(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.2/optimize for better performance and smaller assets.');


var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log_UNUSED = F2(function(tag, value)
{
	return value;
});

var _Debug_log = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString_UNUSED(value)
{
	return '<internals>';
}

function _Debug_toString(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash_UNUSED(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**_UNUSED/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**_UNUSED/
	if (typeof x.$ === 'undefined')
	//*/
	/**/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0_UNUSED = 0;
var _Utils_Tuple0 = { $: '#0' };

function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr_UNUSED(c) { return c; }
function _Utils_chr(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil_UNUSED = { $: 0 };
var _List_Nil = { $: '[]' };

function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap(value) { return { $: 0, a: value }; }
function _Json_unwrap(value) { return value.a; }

function _Json_wrap_UNUSED(value) { return value; }
function _Json_unwrap_UNUSED(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**_UNUSED/
	var node = args['node'];
	//*/
	/**/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		message: func(record.message),
		stopPropagation: record.stopPropagation,
		preventDefault: record.preventDefault
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.message;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.multiline) { flags += 'm'; }
	if (options.caseInsensitive) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var view = impl.view;
			/**_UNUSED/
			var domNode = args['node'];
			//*/
			/**/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.setup && impl.setup(sendToApp)
			var view = impl.view;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.onUrlChange;
	var onUrlRequest = impl.onUrlRequest;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		setup: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.protocol === next.protocol
							&& curr.host === next.host
							&& curr.port_.a === next.port_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		init: function(flags)
		{
			return A3(impl.init, flags, _Browser_getUrl(), key);
		},
		view: impl.view,
		update: impl.update,
		subscriptions: impl.subscriptions
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hidden: 'hidden', change: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hidden: 'msHidden', change: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
		: { hidden: 'hidden', change: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		scene: _Browser_getScene(),
		viewport: {
			x: _Browser_window.pageXOffset,
			y: _Browser_window.pageYOffset,
			width: _Browser_doc.documentElement.clientWidth,
			height: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			scene: {
				width: node.scrollWidth,
				height: node.scrollHeight
			},
			viewport: {
				x: node.scrollLeft,
				y: node.scrollTop,
				width: node.clientWidth,
				height: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: x,
				y: y,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			},
			element: {
				x: x + rect.left,
				y: y + rect.top,
				width: rect.width,
				height: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.expect.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
		$elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);

		try {
			xhr.open(request.method, request.url, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.url));
		}

		_Http_configureRequest(xhr, request);

		request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
		xhr.send(request.body.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.timeout.a || 0;
	xhr.responseType = request.expect.d;
	xhr.withCredentials = request.allowCookiesFromOtherDomains;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		url: xhr.responseURL,
		statusCode: xhr.status,
		statusText: xhr.statusText,
		headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			sent: event.loaded,
			size: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			received: event.loaded,
			size: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Maybe$Just = function (a) {
	return {$: 'Just', a: a};
};
var $elm$core$Maybe$Nothing = {$: 'Nothing'};
var $author$project$Main$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = {$: 'EQ'};
var $elm$core$Basics$GT = {$: 'GT'};
var $elm$core$Basics$LT = {$: 'LT'};
var $elm$core$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 'Index', a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $elm$core$Basics$False = {$: 'False'};
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\u000A    ',
		A2($elm$core$String$split, '\u000A', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\u000A\u000A(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 'Field':
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 'Nothing') {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\u0027' + (f + '\u0027]'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'Index':
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'OneOf':
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\u000A\u000A',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\u000A\u000A';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\u000A\u000A    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\u000A\u000A' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 'SubTree', a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.nodeListSize) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.tail);
		} else {
			var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.tail);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0, tail: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = {$: 'True'};
var $elm$core$Result$isOk = function (result) {
	if (result.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Main$PageMsg = function (a) {
	return {$: 'PageMsg', a: a};
};
var $author$project$HubTran$Effect$AnyCmd = function (a) {
	return {$: 'AnyCmd', a: a};
};
var $author$project$HubTran$Effect$Batch = function (a) {
	return {$: 'Batch', a: a};
};
var $author$project$HubTran$Effect$ForwardEffect = function (a) {
	return {$: 'ForwardEffect', a: a};
};
var $author$project$HubTran$Effect$InspectableEffect = function (a) {
	return {$: 'InspectableEffect', a: a};
};
var $author$project$HubTran$Effect$NoEffect = {$: 'NoEffect'};
var $author$project$Forward$Internal$PureEffectManagerCmd$CacheableRequestCommand = function (a) {
	return {$: 'CacheableRequestCommand', a: a};
};
var $author$project$Forward$Internal$PureEffectManagerCmd$FetchOnce = F2(
	function (a, b) {
		return {$: 'FetchOnce', a: a, b: b};
	});
var $author$project$Forward$Internal$PureEffectManagerCmd$InvalidateAll = {$: 'InvalidateAll'};
var $author$project$Forward$Internal$PureEffectManagerCmd$InvalidateItem = function (a) {
	return {$: 'InvalidateItem', a: a};
};
var $author$project$Forward$Internal$PureEffectManagerCmd$PusherUpdate = function (a) {
	return {$: 'PusherUpdate', a: a};
};
var $author$project$Forward$Internal$PureEffectManagerCmd$RequestItems = function (a) {
	return {$: 'RequestItems', a: a};
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $author$project$Forward$CacheableRequest$CacheableRequest = function (a) {
	return {$: 'CacheableRequest', a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Forward$CacheableRequest$map = F2(
	function (f, _v0) {
		var request_ = _v0.a;
		return $author$project$Forward$CacheableRequest$CacheableRequest(
			{
				body: request_.body,
				headers: request_.headers,
				method: request_.method,
				onResult: A2($elm$core$Basics$composeL, f, request_.onResult),
				timeout: request_.timeout,
				url: request_.url
			});
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (ra.$ === 'Ok') {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Forward$Internal$PureEffectManagerCmd$map = F2(
	function (mapper, myCmd) {
		switch (myCmd.$) {
			case 'RequestItems':
				var graphPaths = myCmd.a;
				return $author$project$Forward$Internal$PureEffectManagerCmd$RequestItems(graphPaths);
			case 'CacheableRequestCommand':
				var cacheableRequest = myCmd.a;
				return $author$project$Forward$Internal$PureEffectManagerCmd$CacheableRequestCommand(
					A2($author$project$Forward$CacheableRequest$map, mapper, cacheableRequest));
			case 'InvalidateAll':
				return $author$project$Forward$Internal$PureEffectManagerCmd$InvalidateAll;
			case 'InvalidateItem':
				var entrypoint = myCmd.a;
				return $author$project$Forward$Internal$PureEffectManagerCmd$InvalidateItem(entrypoint);
			case 'PusherUpdate':
				var value = myCmd.a;
				return $author$project$Forward$Internal$PureEffectManagerCmd$PusherUpdate(value);
			default:
				var debugInfo = myCmd.a;
				var tryResolve = myCmd.b;
				return A2(
					$author$project$Forward$Internal$PureEffectManagerCmd$FetchOnce,
					debugInfo,
					A2(
						$elm$core$Basics$composeR,
						tryResolve,
						$elm$core$Result$map(
							$elm$core$Maybe$map(mapper))));
		}
	});
var $author$project$HubTran$InspectableEffect$Flash = function (a) {
	return {$: 'Flash', a: a};
};
var $author$project$HubTran$InspectableEffect$HttpBytesEffect = function (a) {
	return {$: 'HttpBytesEffect', a: a};
};
var $author$project$HubTran$InspectableEffect$HttpEffect = function (a) {
	return {$: 'HttpEffect', a: a};
};
var $author$project$HubTran$InspectableEffect$Load = function (a) {
	return {$: 'Load', a: a};
};
var $author$project$HubTran$InspectableEffect$Now = function (a) {
	return {$: 'Now', a: a};
};
var $author$project$HubTran$InspectableEffect$PushUrl = function (a) {
	return {$: 'PushUrl', a: a};
};
var $author$project$HubTran$InspectableEffect$Reload = {$: 'Reload'};
var $author$project$HubTran$InspectableEffect$ReplaceUrl = function (a) {
	return {$: 'ReplaceUrl', a: a};
};
var $author$project$HubTran$InspectableEffect$ReportError = function (a) {
	return {$: 'ReportError', a: a};
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $author$project$HubTran$InspectableEffect$map = F2(
	function (f, inspectableEffect) {
		switch (inspectableEffect.$) {
			case 'HttpEffect':
				var request = inspectableEffect.a;
				return $author$project$HubTran$InspectableEffect$HttpEffect(
					{
						body: request.body,
						headers: request.headers,
						method: request.method,
						resolver: function (req) {
							var _v1 = request.resolver(req);
							var httpError = _v1.a;
							var result = _v1.b;
							return _Utils_Tuple2(
								httpError,
								A2(
									$elm$core$Result$mapError,
									f,
									A2($elm$core$Result$map, f, result)));
						},
						timeout: request.timeout,
						url: request.url
					});
			case 'HttpBytesEffect':
				var request = inspectableEffect.a;
				return $author$project$HubTran$InspectableEffect$HttpBytesEffect(
					{
						body: request.body,
						headers: request.headers,
						method: request.method,
						resolver: function (req) {
							var _v2 = request.resolver(req);
							var httpError = _v2.a;
							var result = _v2.b;
							return _Utils_Tuple2(
								httpError,
								A2(
									$elm$core$Result$mapError,
									f,
									A2($elm$core$Result$map, f, result)));
						},
						timeout: request.timeout,
						url: request.url
					});
			case 'PushUrl':
				var url = inspectableEffect.a;
				return $author$project$HubTran$InspectableEffect$PushUrl(url);
			case 'ReplaceUrl':
				var url = inspectableEffect.a;
				return $author$project$HubTran$InspectableEffect$ReplaceUrl(url);
			case 'Load':
				var url = inspectableEffect.a;
				return $author$project$HubTran$InspectableEffect$Load(url);
			case 'Reload':
				return $author$project$HubTran$InspectableEffect$Reload;
			case 'Flash':
				var message = inspectableEffect.a;
				return $author$project$HubTran$InspectableEffect$Flash(message);
			case 'Now':
				var g = inspectableEffect.a;
				return $author$project$HubTran$InspectableEffect$Now(
					A2($elm$core$Basics$composeL, f, g));
			default:
				var report = inspectableEffect.a;
				return $author$project$HubTran$InspectableEffect$ReportError(report);
		}
	});
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$HubTran$Effect$map = F2(
	function (f, effect) {
		switch (effect.$) {
			case 'NoEffect':
				return $author$project$HubTran$Effect$NoEffect;
			case 'ForwardEffect':
				var cmd_ = effect.a;
				return $author$project$HubTran$Effect$ForwardEffect(
					A2($author$project$Forward$Internal$PureEffectManagerCmd$map, f, cmd_));
			case 'InspectableEffect':
				var e = effect.a;
				return $author$project$HubTran$Effect$InspectableEffect(
					A2($author$project$HubTran$InspectableEffect$map, f, e));
			case 'AnyCmd':
				var cmd_ = effect.a;
				return $author$project$HubTran$Effect$AnyCmd(
					A2($elm$core$Platform$Cmd$map, f, cmd_));
			default:
				var effects = effect.a;
				return $author$project$HubTran$Effect$Batch(
					A2(
						$elm$core$List$map,
						$author$project$HubTran$Effect$map(f),
						effects));
		}
	});
var $author$project$Main$DashboardPageMsg = function (a) {
	return {$: 'DashboardPageMsg', a: a};
};
var $author$project$Main$EmailMergePageMsg = function (a) {
	return {$: 'EmailMergePageMsg', a: a};
};
var $author$project$Main$ToBeScrapedLoadsPageMsg = function (a) {
	return {$: 'ToBeScrapedLoadsPageMsg', a: a};
};
var $author$project$Path$addQueries = F2(
	function (newQueries, path) {
		return _Utils_update(
			path,
			{
				queries: _Utils_ap(path.queries, newQueries)
			});
	});
var $author$project$AuditPb$DashboardModeAudit = {$: 'DashboardModeAudit'};
var $author$project$Components$Dashboard$AvailableQueues$supportsFlowMode = F3(
	function (queue, dashboardMode, accountSettings) {
		_v0$7:
		while (true) {
			switch (queue.$) {
				case 'NewQueue':
					return true;
				case 'FactorNeedsIndexingQueue':
					return true;
				case 'ReadyToAuditQueue':
					return true;
				case 'RepliesQueue':
					return true;
				case 'ExceptionQueue':
					return accountSettings.indexAuditSplitEnabled;
				case 'WaitingQueue':
					if (dashboardMode.$ === 'DashboardModeAudit') {
						return true;
					} else {
						return false;
					}
				case 'FinalQueue':
					if ((queue.a.$ === 'ProcessedQueue') && (queue.a.a.$ === 'BrokerAccount')) {
						var _v2 = queue.a.a;
						return accountSettings.indexAuditSplitEnabled && (accountSettings.featureEnableProcessedQueueFlowMode && _Utils_eq(dashboardMode, $author$project$AuditPb$DashboardModeAudit));
					} else {
						break _v0$7;
					}
				default:
					break _v0$7;
			}
		}
		return false;
	});
var $author$project$Components$DashboardPage$flowModeRequested = F2(
	function (accountSettings, model) {
		return model.flowModeState.inFlowMode && A3($author$project$Components$Dashboard$AvailableQueues$supportsFlowMode, model.selectedQueue, model.dashboardMode, accountSettings);
	});
var $author$project$Components$DashboardPage$flowModeEnabled = F2(
	function (accountSettings, model) {
		return A2($author$project$Components$DashboardPage$flowModeRequested, accountSettings, model);
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Maybe$map2($elm$core$List$cons),
	$elm$core$Maybe$Just(_List_Nil));
var $author$project$Pagination$entries = function (_v0) {
	var pageDetails = _v0.a;
	return pageDetails.entries;
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Components$DashboardPage$emailImportCompleted = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.emailMessage;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.importCompletedAt;
				},
				function (d) {
					if (d.$ === 'Just') {
						return true;
					} else {
						return false;
					}
				}))),
	$elm$core$Maybe$withDefault(false));
var $author$project$Domain$EmailMessage$inDocumentReviewState = function (state) {
	switch (state.$) {
		case 'EmailImportStateInDocumentContentReview':
			return true;
		case 'EmailImportStateInDocumentContentReviewDocumentType':
			return true;
		case 'EmailImportStateInDocumentContentReviewNoDependents':
			return true;
		case 'EmailImportStateInDocumentBatchGroupingReview':
			return true;
		default:
			return false;
	}
};
var $author$project$Components$DashboardPage$newQueueEmailWorkableInFlowMode = function (emailRow) {
	var waitingForDocumentReview = function () {
		if (emailRow.$ === 'Just') {
			var row = emailRow.a;
			return $author$project$Domain$EmailMessage$inDocumentReviewState(row.emailMessage.importState);
		} else {
			return false;
		}
	}();
	var importComplete = $author$project$Components$DashboardPage$emailImportCompleted(emailRow);
	return importComplete || waitingForDocumentReview;
};
var $author$project$Components$Dashboard$ExceptionedRow$View$ownerDataRedirectTo = function (_v0) {
	var exceptionedRow = _v0.a;
	return exceptionedRow.ownerData.redirectTo;
};
var $author$project$Path$appendToBase = F2(
	function (strings, path) {
		return _Utils_update(
			path,
			{
				basePath: _Utils_ap(path.basePath, strings)
			});
	});
var $author$project$Path$Path = F2(
	function (basePath, queries) {
		return {basePath: basePath, queries: queries};
	});
var $author$project$Path$base = function (path) {
	return A2($author$project$Path$Path, path, _List_Nil);
};
var $author$project$Domain$LoadStateId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Path$load = function (id) {
	var idString = $elm$core$String$fromInt(
		$author$project$Domain$LoadStateId$toInt(id));
	return $author$project$Path$base(
		_List_fromArray(
			['app', 'loads', idString]));
};
var $author$project$Id$toInt = function (_v0) {
	var id = _v0.a;
	return id;
};
var $author$project$Domain$CarrierInvoiceId$toInt = $author$project$Id$toInt;
var $author$project$Path$carrierInvoiceWithLoad = F3(
	function (loadStateId, carrierInvoiceId, requiresLtlReconciliation) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$CarrierInvoiceId$toInt(carrierInvoiceId));
		var nonLtlPath = A2(
			$author$project$Path$appendToBase,
			_List_fromArray(
				['carrier_invoices', idString]),
			$author$project$Path$load(loadStateId));
		return requiresLtlReconciliation ? A2(
			$author$project$Path$appendToBase,
			_List_fromArray(
				['ltl-reconcile']),
			nonLtlPath) : nonLtlPath;
	});
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$redirectTo = function (row) {
	return A3($author$project$Path$carrierInvoiceWithLoad, row.loadStateId, row.carrierInvoiceId, row.requiresReconciliation);
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Forward$Remote$toMaybe = function (remote) {
	if (remote.$ === 'Loaded') {
		var a = remote.a;
		return $elm$core$Maybe$Just(a);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$DashboardPage$flowModeItems = function (dashboardRows) {
	switch (dashboardRows.$) {
		case 'NewEmailData':
			var newEmailRows = dashboardRows.a;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.redirectTo;
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$filter,
							$author$project$Components$DashboardPage$newQueueEmailWorkableInFlowMode,
							A2(
								$elm$core$List$map,
								$author$project$Forward$Remote$toMaybe,
								$author$project$Pagination$entries(newEmailRows))))));
		case 'FactorNeedsIndexingData':
			var needsIndexingEmailRows = dashboardRows.a;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.redirectTo;
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$Forward$Remote$toMaybe,
							$author$project$Pagination$entries(needsIndexingEmailRows)))));
		case 'ReadyToAuditCarrierInvoiceData':
			var readyToAuditCarrierInvoiceRows = dashboardRows.a;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.redirectTo;
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$Forward$Remote$toMaybe,
							$author$project$Pagination$entries(readyToAuditCarrierInvoiceRows)))));
		case 'ReplyEmailData':
			var replyEmailRows = dashboardRows.a;
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.redirectTo;
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$Forward$Remote$toMaybe,
							$author$project$Pagination$entries(replyEmailRows)))));
		case 'UnsentExceptionedData':
			var unsentExceptionedRows = dashboardRows.a;
			return A2(
				$elm$core$List$map,
				$author$project$Components$Dashboard$ExceptionedRow$View$ownerDataRedirectTo,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							$author$project$Forward$Remote$toMaybe,
							$author$project$Pagination$entries(unsentExceptionedRows)))));
		case 'ProcessedBrokerData':
			var processedBrokerRows = dashboardRows.a;
			return A2(
				$elm$core$List$map,
				$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$redirectTo,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2(
							$elm$core$List$map,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Forward$Remote$toMaybe),
							$author$project$Pagination$entries(processedBrokerRows)))));
		default:
			return _List_Nil;
	}
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$HubTran$InspectableEffect$load = function (url) {
	return $author$project$HubTran$InspectableEffect$Load(url);
};
var $author$project$HubTran$Effect$load = function (url) {
	return $author$project$HubTran$Effect$InspectableEffect(
		$author$project$HubTran$InspectableEffect$load(url));
};
var $author$project$HubTran$Effect$none = $author$project$HubTran$Effect$NoEffect;
var $elm$core$Basics$not = _Basics_not;
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $author$project$Components$Dashboard$Url$QueueArguments$encode = function (queue) {
	switch (queue.$) {
		case 'NewQueue':
			return 'new';
		case 'FactorNeedsIndexingQueue':
			return 'indexing';
		case 'ReadyToAuditQueue':
			return 'ready-to-audit';
		case 'ExceptionQueue':
			return 'exceptions';
		case 'RepliesQueue':
			return 'replies';
		case 'WaitingQueue':
			return 'waiting';
		case 'VerifyQueue':
			return 'verify';
		default:
			switch (queue.a.$) {
				case 'ReviewQueue':
					var _v1 = queue.a;
					return 'review';
				case 'ProcessedQueue':
					return 'processed';
				default:
					var _v2 = queue.a;
					return 'new';
			}
	}
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (_v0.$ === 'Just') {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(_Utils_Tuple0),
			pairs));
};
var $author$project$AuditPb$optionalEncoder = F3(
	function (name, encoder, v) {
		if (v.$ === 'Just') {
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					name,
					encoder(x)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$AuditPb$requiredFieldEncoderWithoutDefault = F3(
	function (name, encoder, v) {
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				name,
				encoder(v)));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$AuditPb$customerEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'name', $elm$json$Json$Encode$string, v.name),
					A3($author$project$AuditPb$optionalEncoder, 'external_id', $elm$json$Json$Encode$string, v.externalId)
				])));
};
var $author$project$Domain$Customer$encode = $author$project$AuditPb$customerEncoder;
var $author$project$Components$Dashboard$Url$FilterArguments$encodeDashboardModeQuery = function (dashboardMode) {
	switch (dashboardMode.$) {
		case 'DashboardModeIndex':
			return $elm$core$Maybe$Just(
				_Utils_Tuple2('dashboardMode', 'index'));
		case 'DashboardModeAudit':
			return $elm$core$Maybe$Just(
				_Utils_Tuple2('dashboardMode', 'audit'));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$time$Time$Jan = {$: 'Jan'};
var $justinmimbs$date$Date$RD = function (a) {
	return {$: 'RD', a: a};
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$Apr = {$: 'Apr'};
var $elm$time$Time$Aug = {$: 'Aug'};
var $elm$time$Time$Dec = {$: 'Dec'};
var $elm$time$Time$Feb = {$: 'Feb'};
var $elm$time$Time$Jul = {$: 'Jul'};
var $elm$time$Time$Jun = {$: 'Jun'};
var $elm$time$Time$Mar = {$: 'Mar'};
var $elm$time$Time$May = {$: 'May'};
var $elm$time$Time$Nov = {$: 'Nov'};
var $elm$time$Time$Oct = {$: 'Oct'};
var $elm$time$Time$Sep = {$: 'Sep'};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Jan;
		case 2:
			return $elm$time$Time$Feb;
		case 3:
			return $elm$time$Time$Mar;
		case 4:
			return $elm$time$Time$Apr;
		case 5:
			return $elm$time$Time$May;
		case 6:
			return $elm$time$Time$Jun;
		case 7:
			return $elm$time$Time$Jul;
		case 8:
			return $elm$time$Time$Aug;
		case 9:
			return $elm$time$Time$Sep;
		case 10:
			return $elm$time$Time$Oct;
		case 11:
			return $elm$time$Time$Nov;
		default:
			return $elm$time$Time$Dec;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {day: d, month: m, year: y};
			}
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0.a;
	var y = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd));
	return {
		ordinalDay: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		year: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0.a;
	var date = $justinmimbs$date$Date$toOrdinalDate(
		$justinmimbs$date$Date$RD(rd));
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.year, $elm$time$Time$Jan, date.ordinalDay);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.day;
	});
var $elm$core$String$slice = _String_slice;
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.month;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.ordinalDay;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$length = _String_length;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(jan4));
};
var $elm$time$Time$Fri = {$: 'Fri'};
var $elm$time$Time$Mon = {$: 'Mon'};
var $elm$time$Time$Sat = {$: 'Sat'};
var $elm$time$Time$Sun = {$: 'Sun'};
var $elm$time$Time$Thu = {$: 'Thu'};
var $elm$time$Time$Tue = {$: 'Tue'};
var $elm$time$Time$Wed = {$: 'Wed'};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Mon;
		case 2:
			return $elm$time$Time$Tue;
		case 3:
			return $elm$time$Time$Wed;
		case 4:
			return $elm$time$Time$Thu;
		case 5:
			return $elm$time$Time$Fri;
		case 6:
			return $elm$time$Time$Sat;
		default:
			return $elm$time$Time$Sun;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0.a;
	var wdn = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(rd));
	var wy = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd + (4 - wdn)));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		weekNumber: 1 + (((rd - week1Day1) / 7) | 0),
		weekYear: wy,
		weekday: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekNumber;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekYear;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char.valueOf()) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.monthNameShort(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.monthName(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.monthNameShort(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.dayWithSuffix(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.weekdayName(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4(
							$justinmimbs$date$Date$formatField,
							language,
							_Utils_chr('E'),
							length,
							date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (token.$ === 'Field') {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 'Bad', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 'Good', a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parseA(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					var _v2 = callback(a);
					var parseB = _v2.a;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
					}
				}
			});
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0.a;
		var parseB = _v1.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v2 = parseA(s0);
				if (_v2.$ === 'Bad') {
					var p = _v2.a;
					var x = _v2.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v2.a;
					var a = _v2.b;
					var s1 = _v2.c;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3(
							$elm$parser$Parser$Advanced$Good,
							p1 || p2,
							A2(func, a, b),
							s2);
					}
				}
			});
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, false, a, s);
		});
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 'Expecting', a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 'Token', a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 'AddRight', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {col: col, contextStack: contextStack, problem: problem, row: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 'Empty'};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.row, s.col, x, s.context));
	});
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
				$elm$parser$Parser$Advanced$Good,
				progress,
				_Utils_Tuple0,
				{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
		});
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\u0027')),
	$elm$parser$Parser$token('\u0027\u0027'));
var $elm$parser$Parser$UnexpectedChar = {$: 'UnexpectedChar'};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
				return _Utils_eq(newOffset, -1) ? A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: 1, context: s.context, indent: s.indent, offset: s.offset + 1, row: s.row + 1, src: s.src}) : A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: s.col + 1, context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src}));
			});
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.offset, offset) < 0,
					_Utils_Tuple0,
					{col: col, context: s0.context, indent: s0.indent, offset: offset, row: row, src: s0.src});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.offset, s.row, s.col, s);
		});
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = $elm$parser$Parser$Advanced$Parser(
	function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, s.offset, s);
	});
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 'Problem', a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						A2(
							func,
							A3($elm$core$String$slice, s0.offset, s1.offset, s0.src),
							a),
						s1);
				}
			});
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 'Literal') && _v0.b.b) && (_v0.b.a.$ === 'Literal')) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v0 = thunk(_Utils_Tuple0);
			var parse = _v0.a;
			return parse(s);
		});
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (!_Utils_eq(
		_char,
		_Utils_chr('\''))) && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						func(a),
						s1);
				} else {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				}
			});
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 'Append', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
		});
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 'ExpectingEnd'};
var $elm$parser$Parser$Advanced$end = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return _Utils_eq(
				$elm$core$String$length(s.src),
				s.offset) ? A3($elm$parser$Parser$Advanced$Good, false, _Utils_Tuple0, s) : A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(_Utils_Tuple0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq(
									_Utils_chr('\'')))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq(
								_Utils_chr('\'')))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\u0027');
				},
				$elm$parser$Parser$token('\u0027\u0027')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq(
				_Utils_chr('\'')))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq(
						_Utils_chr('\''))),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {col: col, problem: problem, row: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.row, p.col, p.problem);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 'Empty':
					return list;
				case 'AddRight':
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0.a;
		var _v1 = parse(
			{col: 1, context: _List_Nil, indent: 1, offset: 0, row: 1, src: src});
		if (_v1.$ === 'Good') {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (_v0.$ === 'Ok') {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (result.$ === 'Ok') {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	dayWithSuffix: $justinmimbs$date$Date$withOrdinalSuffix,
	monthName: $justinmimbs$date$Date$monthToName,
	monthNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	weekdayName: $justinmimbs$date$Date$weekdayToName,
	weekdayNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Components$Dashboard$Url$FilterArguments$encodeDateQuery = function (key) {
	return $elm$core$Maybe$map(
		function (date) {
			return _Utils_Tuple2(
				key,
				$justinmimbs$date$Date$toIsoString(date));
		});
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0.a;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.start, posixMinutes) < 0) {
					return posixMinutes + era.offset;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		month: month,
		year: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).day;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).month;
		switch (_v0) {
			case 1:
				return $elm$time$Time$Jan;
			case 2:
				return $elm$time$Time$Feb;
			case 3:
				return $elm$time$Time$Mar;
			case 4:
				return $elm$time$Time$Apr;
			case 5:
				return $elm$time$Time$May;
			case 6:
				return $elm$time$Time$Jun;
			case 7:
				return $elm$time$Time$Jul;
			case 8:
				return $elm$time$Time$Aug;
			case 9:
				return $elm$time$Time$Sep;
			case 10:
				return $elm$time$Time$Oct;
			case 11:
				return $elm$time$Time$Nov;
			default:
				return $elm$time$Time$Dec;
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			_Utils_chr('0'),
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).year;
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 'Zone', a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$Components$Dashboard$Url$FilterArguments$encodeDateTimeQuery = function (key) {
	return $elm$core$Maybe$map(
		function (date) {
			return _Utils_Tuple2(
				key,
				$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(date));
		});
};
var $author$project$Components$Dashboard$Url$FilterArguments$encodeExceptions = function (exceptions) {
	return $elm$core$List$isEmpty(exceptions) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		_Utils_Tuple2(
			'exceptions',
			A2($elm$core$String$join, ',', exceptions)));
};
var $author$project$Domain$FactorBrokerId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Components$Dashboard$Url$FilterArguments$encodeFactorBrokers = function (factorBrokerIds) {
	return $elm$core$Maybe$Just(
		_Utils_Tuple2(
			$elm$url$Url$percentEncode('filters[factorBrokerId]'),
			A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $author$project$Domain$FactorBrokerId$toInt, $elm$core$String$fromInt),
					factorBrokerIds))));
};
var $author$project$Domain$LabelFilter$Negated = {$: 'Negated'};
var $author$project$Domain$LabelFilter$isState = F2(
	function (desiredState, labelFilter) {
		return _Utils_eq(desiredState, labelFilter.state);
	});
var $author$project$Domain$LabelFilter$isNegated = $author$project$Domain$LabelFilter$isState($author$project$Domain$LabelFilter$Negated);
var $author$project$Domain$LabelFilter$Selected = {$: 'Selected'};
var $author$project$Domain$LabelFilter$isSelected = $author$project$Domain$LabelFilter$isState($author$project$Domain$LabelFilter$Selected);
var $author$project$Components$Dashboard$Url$FilterArguments$encodeLabelFiltersQuery = function (labelFilters) {
	var encodeFilters = function (filtersToKeep) {
		var filtersWithCommas = A2(
			$elm$core$String$join,
			',',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.label;
				},
				A2($elm$core$List$filter, filtersToKeep, labelFilters)));
		return $elm$url$Url$percentEncode('[' + (filtersWithCommas + ']'));
	};
	var negatedLabelFilters = encodeFilters($author$project$Domain$LabelFilter$isNegated);
	var selectedLabelFilters = encodeFilters($author$project$Domain$LabelFilter$isSelected);
	return _List_fromArray(
		[
			$elm$core$Maybe$Just(
			_Utils_Tuple2('selectedLabelFilters', selectedLabelFilters)),
			$elm$core$Maybe$Just(
			_Utils_Tuple2('negatedLabelFilters', negatedLabelFilters))
		]);
};
var $author$project$AuditPb$queueDateToString = function (v) {
	switch (v.$) {
		case 'QueueDateUnsorted':
			return 'unsorted';
		case 'QueueDateDelivered':
			return 'delivered';
		case 'QueueDateReceived':
			return 'received';
		case 'QueueDateLastContact':
			return 'last_contact';
		case 'QueueDateEstimatedDue':
			return 'estimated_due';
		case 'QueueDateReviewOn':
			return 'review_on';
		case 'QueueDateProcessed':
			return 'processed';
		default:
			return 'payment';
	}
};
var $author$project$Domain$QueueDate$toString = $author$project$AuditPb$queueDateToString;
var $author$project$Components$Dashboard$Url$FilterArguments$encodeRangeType = function (rangeType) {
	return $elm$core$Maybe$Just(
		_Utils_Tuple2(
			'rangeType',
			$author$project$Domain$QueueDate$toString(rangeType)));
};
var $author$project$Domain$TmsCarrierId$toInt = $author$project$Id$toInt;
var $author$project$Components$Dashboard$Url$FilterArguments$encodeTmsCarriers = function (tmsCarrierIds) {
	return $elm$core$Maybe$Just(
		_Utils_Tuple2(
			$elm$url$Url$percentEncode('filters[carrierId]'),
			A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $author$project$Domain$TmsCarrierId$toInt, $elm$core$String$fromInt),
					tmsCarrierIds))));
};
var $author$project$Components$Dashboard$Url$FilterArguments$encodeAsQueries = function (dashboardFilters) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Components$Dashboard$Url$FilterArguments$encodeTmsCarriers(dashboardFilters.tmsCarrierIds),
					$author$project$Components$Dashboard$Url$FilterArguments$encodeFactorBrokers(dashboardFilters.factorBrokerIds)
				]),
			_Utils_ap(
				$author$project$Components$Dashboard$Url$FilterArguments$encodeLabelFiltersQuery(dashboardFilters.labelFilters),
				_List_fromArray(
					[
						A2($author$project$Components$Dashboard$Url$FilterArguments$encodeDateQuery, 'startDate', dashboardFilters.startDate),
						A2($author$project$Components$Dashboard$Url$FilterArguments$encodeDateQuery, 'endDate', dashboardFilters.endDate),
						A2($author$project$Components$Dashboard$Url$FilterArguments$encodeDateTimeQuery, 'startDateTime', dashboardFilters.startDateTime),
						A2($author$project$Components$Dashboard$Url$FilterArguments$encodeDateTimeQuery, 'endDateTime', dashboardFilters.endDateTime),
						$author$project$Components$Dashboard$Url$FilterArguments$encodeDashboardModeQuery(dashboardFilters.dashboardMode),
						$author$project$Components$Dashboard$Url$FilterArguments$encodeRangeType(dashboardFilters.rangeType),
						$author$project$Components$Dashboard$Url$FilterArguments$encodeExceptions(dashboardFilters.exceptions)
					]))));
};
var $author$project$Components$Dashboard$Url$FilterArguments$encodeQueryStringArg = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		function (_v0) {
			var key = _v0.a;
			var value = _v0.b;
			return key + ('=' + value);
		}),
	$elm$core$Maybe$withDefault(''));
var $author$project$Components$Dashboard$Url$FilterArguments$encodeAsQueryString = A2(
	$elm$core$Basics$composeR,
	$author$project$Components$Dashboard$Url$FilterArguments$encodeAsQueries,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Components$Dashboard$Url$FilterArguments$encodeQueryStringArg)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$join('&'),
			$elm$core$Basics$append('?'))));
var $author$project$AuditPb$dashboardSortByOrderToString = function (v) {
	if (v.$ === 'DashboardSortByOrderAsc') {
		return 'asc';
	} else {
		return 'desc';
	}
};
var $author$project$Domain$DashboardSortBy$orderToString = function (order) {
	return $author$project$AuditPb$dashboardSortByOrderToString(order);
};
var $author$project$Domain$DashboardSortBy$encodeAsQueryString = function (_v0) {
	var order = _v0.order;
	var name = _v0.name;
	return A2(
		$elm$core$String$join,
		':',
		_List_fromArray(
			[
				name,
				$author$project$Domain$DashboardSortBy$orderToString(order)
			]));
};
var $author$project$Components$Dashboard$Url$getPrefix = '/app/dashboard/';
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $elm$core$Set$Set_elm_builtin = function (a) {
	return {$: 'Set_elm_builtin', a: a};
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Set$Set_elm_builtin($elm$core$Dict$empty);
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === 'RBEmpty_elm_builtin') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Domain$CategoryFilter$effectiveLabels = function (category) {
	return $elm$core$Set$isEmpty(category.excluded) ? category.selected : $elm$core$Set$empty;
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Set$foldl = F3(
	function (func, initialState, _v0) {
		var dict = _v0.a;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $elm$json$Json$Encode$set = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$Set$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $author$project$Domain$CategoryFilter$categorySelectionEncoder = function (categoryJson) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'category',
				$elm$json$Json$Encode$string(categoryJson.category.name)),
				_Utils_Tuple2(
				'label',
				A2(
					$elm$json$Json$Encode$set,
					$elm$json$Json$Encode$string,
					$author$project$Domain$CategoryFilter$effectiveLabels(categoryJson))),
				_Utils_Tuple2(
				'excluded',
				A2($elm$json$Json$Encode$set, $elm$json$Json$Encode$string, categoryJson.excluded))
			]));
};
var $author$project$Domain$CategoryFilter$filterSelected = function (categories) {
	return A2(
		$elm$core$List$filter,
		function (x) {
			return !($elm$core$Set$isEmpty(x.selected) && $elm$core$Set$isEmpty(x.excluded));
		},
		categories);
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Domain$CategoryFilter$filteredCategoryEncoder = function (categories) {
	var sortedCategories = A2(
		$elm$core$List$sortBy,
		function (x) {
			return x.category.name;
		},
		$author$project$Domain$CategoryFilter$filterSelected(categories));
	return A2($elm$json$Json$Encode$list, $author$project$Domain$CategoryFilter$categorySelectionEncoder, sortedCategories);
};
var $author$project$Domain$CategoryFilter$toString = function (categories) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$author$project$Domain$CategoryFilter$filteredCategoryEncoder(categories));
};
var $author$project$Components$Dashboard$Url$urlWithArguments = F5(
	function (queue, dashboardFilters, activePage, inFlowMode, dashboardMode) {
		return $author$project$Components$Dashboard$Url$getPrefix + ($author$project$Components$Dashboard$Url$QueueArguments$encode(queue) + ($author$project$Components$Dashboard$Url$FilterArguments$encodeAsQueryString(dashboardFilters) + ('&customers=' + ($elm$url$Url$percentEncode(
			A2(
				$elm$json$Json$Encode$encode,
				0,
				A2($elm$json$Json$Encode$list, $author$project$Domain$Customer$encode, dashboardFilters.customers))) + ('&page=' + ($elm$core$String$fromInt(activePage) + ((inFlowMode ? '&inFlowMode=true' : '') + (function () {
			switch (dashboardMode.$) {
				case 'DashboardModeIndex':
					return '&dashboardMode=index';
				case 'DashboardModeAudit':
					return '&dashboardMode=audit';
				default:
					return '';
			}
		}() + ('&categories=' + ($elm$url$Url$percentEncode(
			$author$project$Domain$CategoryFilter$toString(dashboardFilters.categories)) + ('&sort=' + $author$project$Domain$DashboardSortBy$encodeAsQueryString(dashboardFilters.dashboardSortBy))))))))))));
	});
var $author$project$Components$Dashboard$Url$onDone = F5(
	function (queue, dashboardFilters, activePage, inFlowMode, dashboardMode) {
		return $elm$url$Url$percentEncode(
			A5($author$project$Components$Dashboard$Url$urlWithArguments, queue, dashboardFilters, activePage, inFlowMode, dashboardMode));
	});
var $author$project$Pagination$pageNumber = function (_v0) {
	var pageDetails = _v0.a;
	return pageDetails.pageNumber;
};
var $author$project$Components$Dashboard$DashboardRows$realActivePage = function (data) {
	switch (data.$) {
		case 'NewEmailData':
			var page = data.a;
			return $author$project$Pagination$pageNumber(page);
		case 'FactorNeedsIndexingData':
			var page = data.a;
			return $author$project$Pagination$pageNumber(page);
		case 'ReadyToAuditCarrierInvoiceData':
			var page = data.a;
			return $author$project$Pagination$pageNumber(page);
		case 'ReplyEmailData':
			var page = data.a;
			return $author$project$Pagination$pageNumber(page);
		case 'UnsentExceptionedData':
			var page = data.a;
			return $author$project$Pagination$pageNumber(page);
		case 'VerifyData':
			var page = data.a;
			return $author$project$Pagination$pageNumber(page);
		case 'ReviewData':
			var page = data.a;
			return $author$project$Pagination$pageNumber(page);
		case 'ProcessedBrokerData':
			var page = data.a;
			return $author$project$Pagination$pageNumber(page);
		default:
			var processedFactorData = data.a;
			return $author$project$Pagination$pageNumber(processedFactorData.currentPageData);
	}
};
var $author$project$AuditPb$dashboardModeToString = function (v) {
	switch (v.$) {
		case 'DashboardModeAll':
			return 'all';
		case 'DashboardModeIndex':
			return 'index';
		default:
			return 'audit';
	}
};
var $author$project$AuditPb$dashboardModeEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$dashboardModeToString);
var $author$project$AuditPb$dashboardSortByOrderEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$dashboardSortByOrderToString);
var $author$project$AuditPb$dashboardSortByEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'name', $elm$json$Json$Encode$string, v.name),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'order', $author$project$AuditPb$dashboardSortByOrderEncoder, v.order)
				])));
};
var $author$project$Domain$DashboardSortBy$encode = function (sortBy) {
	return $author$project$AuditPb$dashboardSortByEncoder(sortBy);
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Id$encode = function (_v0) {
	var value = _v0.a;
	return $elm$json$Json$Encode$int(value);
};
var $author$project$Domain$TmsCarrierId$encode = $author$project$Id$encode;
var $author$project$Encode$FlowModeDashboardArgumentsEncoder$labelFilters = function () {
	var encodeLabelFilter = function (labelFilter) {
		var _v0 = labelFilter.state;
		switch (_v0.$) {
			case 'Unselected':
				return $elm$core$Maybe$Nothing;
			case 'Selected':
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						labelFilter.label,
						$elm$json$Json$Encode$string('+')));
			default:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						labelFilter.label,
						$elm$json$Json$Encode$string('-')));
		}
	};
	return $elm$core$List$filterMap(encodeLabelFilter);
}();
var $author$project$Encode$FlowModeDashboardArgumentsEncoder$filters = function (dashboardFilters) {
	var values = _List_fromArray(
		[
			_Utils_Tuple2(
			'carrierId',
			A2($elm$json$Json$Encode$list, $author$project$Domain$TmsCarrierId$encode, dashboardFilters.tmsCarrierIds))
		]);
	var labels = $author$project$Encode$FlowModeDashboardArgumentsEncoder$labelFilters(dashboardFilters.labelFilters);
	return $elm$json$Json$Encode$object(
		_Utils_ap(values, labels));
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Encode$FlowModeDashboardArgumentsEncoder$mapEncodeMaybe = function (mapper) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(mapper),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Encode$FlowModeDashboardArgumentsEncoder$encode = function (dashboardArguments) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'queue',
				A2($elm$core$Basics$composeR, $author$project$Components$Dashboard$Url$QueueArguments$encode, $elm$json$Json$Encode$string)(dashboardArguments.queue)),
				_Utils_Tuple2(
				'filters',
				$author$project$Encode$FlowModeDashboardArgumentsEncoder$filters(dashboardArguments.dashboardFilters)),
				_Utils_Tuple2(
				'customers',
				A2($elm$json$Json$Encode$list, $author$project$Domain$Customer$encode, dashboardArguments.dashboardFilters.customers)),
				_Utils_Tuple2(
				'categories',
				$author$project$Domain$CategoryFilter$filteredCategoryEncoder(dashboardArguments.dashboardFilters.categories)),
				_Utils_Tuple2(
				'startDate',
				A2(
					$author$project$Encode$FlowModeDashboardArgumentsEncoder$mapEncodeMaybe,
					A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string),
					dashboardArguments.dashboardFilters.startDate)),
				_Utils_Tuple2(
				'endDate',
				A2(
					$author$project$Encode$FlowModeDashboardArgumentsEncoder$mapEncodeMaybe,
					A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string),
					dashboardArguments.dashboardFilters.endDate)),
				_Utils_Tuple2(
				'rangeType',
				A2($elm$core$Basics$composeR, $author$project$Domain$QueueDate$toString, $elm$json$Json$Encode$string)(dashboardArguments.dashboardFilters.rangeType)),
				_Utils_Tuple2(
				'dashboardMode',
				$author$project$AuditPb$dashboardModeEncoder(dashboardArguments.dashboardFilters.dashboardMode)),
				_Utils_Tuple2(
				'timezoneName',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '', dashboardArguments.dashboardFilters.timezoneName))),
				_Utils_Tuple2(
				'sortBy',
				$author$project$Domain$DashboardSortBy$encode(dashboardArguments.dashboardFilters.dashboardSortBy))
			]));
};
var $author$project$Components$Dashboard$Url$flowModeArgs = F2(
	function (queue, dashboardFilters) {
		return _Utils_Tuple2(
			'newFlowMode',
			$elm$url$Url$percentEncode(
				A2(
					$elm$json$Json$Encode$encode,
					0,
					$author$project$Encode$FlowModeDashboardArgumentsEncoder$encode(
						{dashboardFilters: dashboardFilters, queue: queue}))));
	});
var $author$project$Components$Dashboard$Url$startFlowModeUrlWithArguments = F3(
	function (queue, dashboardFilters, activePage) {
		var queueArg = _Utils_Tuple2(
			'queue',
			$author$project$Components$Dashboard$Url$QueueArguments$encode(queue));
		var pageArg = _Utils_Tuple2(
			'page',
			$elm$core$String$fromInt(activePage));
		var filterArgs = $author$project$Components$Dashboard$Url$FilterArguments$encodeAsQueries(dashboardFilters);
		var categoriesArg = _Utils_Tuple2(
			'categories',
			$elm$url$Url$percentEncode(
				$author$project$Domain$CategoryFilter$toString(dashboardFilters.categories)));
		var queries = A2(
			$elm$core$List$cons,
			queueArg,
			_Utils_ap(
				filterArgs,
				_List_fromArray(
					[pageArg, categoriesArg])));
		return A2(
			$author$project$Path$addQueries,
			_Utils_ap(
				queries,
				_List_fromArray(
					[
						A2($author$project$Components$Dashboard$Url$flowModeArgs, queue, dashboardFilters)
					])),
			$author$project$Path$base(
				_List_fromArray(
					['app', 'flow'])));
	});
var $author$project$Path$toString = function (_v0) {
	var queries = _v0.queries;
	var basePath = _v0.basePath;
	var query = F2(
		function (prefix, _v2) {
			var key = _v2.a;
			var val = _v2.b;
			return prefix + (key + ('=' + val));
		});
	var queryString = function () {
		if (!queries.b) {
			return '';
		} else {
			var head = queries.a;
			var tail = queries.b;
			return _Utils_ap(
				A2(query, '?', head),
				A3(
					$elm$core$List$foldr,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$append,
						query('&')),
					'',
					tail));
		}
	}();
	var baseString = A3(
		$elm$core$List$foldr,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$append,
			$elm$core$Basics$append('/')),
		'',
		basePath);
	return _Utils_ap(baseString, queryString);
};
var $author$project$Components$DashboardPage$maybeRedirectStartFlowMode = F2(
	function (data, model) {
		var realActivePage = A2(
			$elm$core$Maybe$withDefault,
			model.requestedActivePage,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Dashboard$DashboardRows$realActivePage,
				$author$project$Forward$Remote$toMaybe(data.dashboardRows)));
		var onDone = A5($author$project$Components$Dashboard$Url$onDone, model.selectedQueue, model.dashboardFilters, realActivePage, false, model.dashboardMode);
		var redirectTo = $author$project$Path$toString(
			A2(
				$author$project$Path$addQueries,
				_List_fromArray(
					[
						_Utils_Tuple2('onDone', onDone)
					]),
				A3($author$project$Components$Dashboard$Url$startFlowModeUrlWithArguments, model.selectedQueue, model.dashboardFilters, realActivePage)));
		var _v0 = $author$project$Forward$Remote$toMaybe(data.dashboardRows);
		if (_v0.$ === 'Nothing') {
			return $author$project$HubTran$Effect$none;
		} else {
			var dashboardRows = _v0.a;
			var someExist = !$elm$core$List$isEmpty(
				$author$project$Components$DashboardPage$flowModeItems(dashboardRows));
			return (A2($author$project$Components$DashboardPage$flowModeEnabled, data.accountSettings, model) && (someExist && model.dashboardPresence.receivedData)) ? $author$project$HubTran$Effect$load(redirectTo) : $author$project$HubTran$Effect$none;
		}
	});
var $author$project$Components$DashboardPage$dataEffects = F2(
	function (data, model) {
		return A2($author$project$Components$DashboardPage$maybeRedirectStartFlowMode, data, model);
	});
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 'Normal':
			return 0;
		case 'MayStopPropagation':
			return 1;
		case 'MayPreventDefault':
			return 2;
		default:
			return 3;
	}
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Forward$LoadingView$defaultErrorView_DEPRECATED = F2(
	function (reason, debug) {
		return (reason === 'DoesNotExist') ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('forward-error')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('ERROR: The data you have requested could not be found on the server.')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('forward-error')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('ERROR: Please click the following link to '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://paymentshelp.triumph.io/support/tickets/new'),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('contact support')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'none')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(reason),
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', debug))
						]))
				]));
	});
var $author$project$Forward$LoadingView$defaultErrorView = function (error) {
	var _v0 = function () {
		if (error.$ === 'Unloadable') {
			var reason_ = error.a;
			return _Utils_Tuple2(reason_, $elm$core$Maybe$Nothing);
		} else {
			var err = error.a;
			return _Utils_Tuple2(
				'Could not parse data from server.\u000A\u000A' + err.decoderMessage,
				$elm$core$Maybe$Just(err.json));
		}
	}();
	var reason = _v0.a;
	var debug = _v0.b;
	return A2($author$project$Forward$LoadingView$defaultErrorView_DEPRECATED, reason, debug);
};
var $author$project$Helpers$Modal$backdrop = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('cg-busy cg-busy-backdrop cg-busy-backdrop-animation')
		]),
	_List_Nil);
var $author$project$Helpers$Modal$blockerView = function (modalView) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cg-busy cg-busy-animation')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cg-busy-default-wrapper'),
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'top', '0px'),
						A2($elm$html$Html$Attributes$style, 'left', '0px'),
						A2($elm$html$Html$Attributes$style, 'right', '0px'),
						A2($elm$html$Html$Attributes$style, 'bottom', '0px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cg-busy-default-container')
							]),
						_List_fromArray(
							[modalView]))
					]))
			]));
};
var $author$project$Helpers$Modal$blocker = F2(
	function (modalView, children) {
		if (modalView.$ === 'Nothing') {
			return A2($elm$html$Html$div, _List_Nil, children);
		} else {
			var view = modalView.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_Utils_ap(
					children,
					_List_fromArray(
						[
							$author$project$Helpers$Modal$backdrop,
							$author$project$Helpers$Modal$blockerView(view)
						])));
		}
	});
var $author$project$Helpers$WaitingSpinner$spinnerBar = function (index) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				'bar' + $elm$core$String$fromInt(index))
			]),
		_List_Nil);
};
var $author$project$Helpers$WaitingSpinner$rawSpinner = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('cg-busy-default-spinner')
		]),
	A2(
		$elm$core$List$map,
		$author$project$Helpers$WaitingSpinner$spinnerBar,
		A2($elm$core$List$range, 1, 12)));
var $author$project$Helpers$WaitingSpinner$waitingSpinnerWithText = F3(
	function (waitingText, when, children) {
		var modalView = when ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cg-busy-default-sign')
					]),
				_List_fromArray(
					[
						$author$project$Helpers$WaitingSpinner$rawSpinner,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cg-busy-default-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(waitingText)
							]))
					]))) : $elm$core$Maybe$Nothing;
		return A2($author$project$Helpers$Modal$blocker, modalView, children);
	});
var $author$project$Helpers$WaitingSpinner$waitingSpinner = $author$project$Helpers$WaitingSpinner$waitingSpinnerWithText('Please Wait…');
var $author$project$Forward$LoadingView$defaultLoadingView = A2(
	$author$project$Helpers$WaitingSpinner$waitingSpinner,
	true,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('forward-loading')
				]),
			_List_Nil)
		]));
var $author$project$Forward$LoadingView$view = F2(
	function (f, remote) {
		switch (remote.$) {
			case 'Loading':
				return $author$project$Forward$LoadingView$defaultLoadingView;
			case 'Loaded':
				var a = remote.a;
				return f(a);
			default:
				var error = remote.a;
				return $author$project$Forward$LoadingView$defaultErrorView(error);
		}
	});
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$Attributes$begin = _VirtualDom_attribute('begin');
var $elm$svg$Svg$Attributes$calcMode = _VirtualDom_attribute('calcMode');
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Attributes$keyTimes = _VirtualDom_attribute('keyTimes');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Forward$LoadingView$v3SpinnerIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('64'),
			$elm$svg$Svg$Attributes$height('64'),
			$elm$svg$Svg$Attributes$viewBox('0 0 64 64'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip0_1273_124830)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M57.6926 23.1432L40.8009 23.1432L40.8009 6.25149L34.5466 0L34.5466 29.3983L63.9448 29.3983L57.6926 23.1432Z'),
							$elm$svg$Svg$Attributes$fill('white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('fill'),
									$elm$svg$Svg$Attributes$values('white;#00A4BF;white;white;white'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('2.67s'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite'),
									$elm$svg$Svg$Attributes$fill('freeze'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$keyTimes('0;0.25;0.5;0.75;1')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M57.6926 40.8041L40.8009 40.8041L40.8009 57.6966L34.5466 63.9481L34.5466 34.5498L63.9448 34.5498L57.6926 40.8041Z'),
							$elm$svg$Svg$Attributes$fill('white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('fill'),
									$elm$svg$Svg$Attributes$values('white;white;#00A4BF;white;white'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('2.67s'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite'),
									$elm$svg$Svg$Attributes$fill('freeze'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$keyTimes('0;0.25;0.5;0.75;1')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M6.25149 23.1432L23.1432 23.1432L23.1432 6.25149L29.3983 0L29.3983 29.3983L0 29.3983L6.25149 23.1432Z'),
							$elm$svg$Svg$Attributes$fill('#00A4BF')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('fill'),
									$elm$svg$Svg$Attributes$values('#00A4BF;white;white;white;#00A4BF'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('2.67s'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite'),
									$elm$svg$Svg$Attributes$fill('freeze'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$keyTimes('0;0.25;0.5;0.75;1')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M6.25149 40.8041L23.1432 40.8041L23.1432 57.6966L29.3983 63.9481L29.3983 34.5498L0 34.5498L6.25149 40.8041Z'),
							$elm$svg$Svg$Attributes$fill('white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('fill'),
									$elm$svg$Svg$Attributes$values('white;white;white;#00A4BF;white'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('2.67s'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite'),
									$elm$svg$Svg$Attributes$fill('freeze'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$keyTimes('0;0.25;0.5;0.75;1')
								]),
							_List_Nil)
						]))
				])),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip0_1273_124830')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('64'),
									$elm$svg$Svg$Attributes$height('64'),
									$elm$svg$Svg$Attributes$fill('white')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Forward$LoadingView$v3LoadingView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'width', '100%'),
			A2($elm$html$Html$Attributes$style, 'height', '100vh'),
			A2($elm$html$Html$Attributes$style, 'display', 'flex'),
			A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
			A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
			A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
			A2($elm$html$Html$Attributes$style, 'top', '0'),
			A2($elm$html$Html$Attributes$style, 'left', '0'),
			A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
		]),
	_List_fromArray(
		[$author$project$Forward$LoadingView$v3SpinnerIcon]));
var $author$project$Forward$LoadingView$viewV3Reskin = F2(
	function (f, remote) {
		switch (remote.$) {
			case 'Loading':
				return $author$project$Forward$LoadingView$v3LoadingView;
			case 'Loaded':
				var a = remote.a;
				return f(a);
			default:
				var error = remote.a;
				return $author$project$Forward$LoadingView$defaultErrorView(error);
		}
	});
var $author$project$Forward$LoadingView$viewV3Reskinnable = F3(
	function (v3ReskinEnabled, f, remote) {
		return v3ReskinEnabled ? A2($author$project$Forward$LoadingView$viewV3Reskin, f, remote) : A2($author$project$Forward$LoadingView$view, f, remote);
	});
var $author$project$Forward$Component$forwardComponent = function (config) {
	return {
		dataEffects: F2(
			function (_v0, _v1) {
				return $author$project$HubTran$Effect$none;
			}),
		init: config.init,
		loadData: config.loadData,
		onUrlChange: $elm$core$Maybe$Nothing,
		update: config.update,
		view: F2(
			function (remoteData, model) {
				return A3(
					$author$project$Forward$LoadingView$viewV3Reskinnable,
					config.v3ReskinEnabled,
					function (data) {
						return A2(config.viewLoaded, data, model);
					},
					remoteData);
			})
	};
};
var $author$project$Components$EmailMergePage$init = {addError: $elm$core$Maybe$Nothing, documentBatchesToMerge: _List_Nil, mergeError: $elm$core$Maybe$Nothing, saving: false, urlToAdd: ''};
var $author$project$Components$EmailMergePage$Data = F2(
	function (account, emails) {
		return {account: account, emails: emails};
	});
var $author$project$Components$EmailMergePage$EmailMessageData = F2(
	function (email, carrier) {
		return {carrier: carrier, email: email};
	});
var $author$project$Forward$Internal$LookupStructure$All = F2(
	function (a, b) {
		return {$: 'All', a: a, b: b};
	});
var $author$project$Forward$Internal$LookupStructure$Apply = function (a) {
	return {$: 'Apply', a: a};
};
var $author$project$Forward$Lookup$Lookup = function (a) {
	return {$: 'Lookup', a: a};
};
var $author$project$Forward$Internal$Loadable$Loadable = function (a) {
	return {$: 'Loadable', a: a};
};
var $author$project$Forward$Remote$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Forward$Remote$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Forward$Remote$Loading = {$: 'Loading'};
var $author$project$Forward$Remote$Unloadable = function (a) {
	return {$: 'Unloadable', a: a};
};
var $author$project$Forward$Remote$Unparseable = function (a) {
	return {$: 'Unparseable', a: a};
};
var $author$project$Forward$Remote$map2 = F3(
	function (f, remoteA, remoteB) {
		var _v0 = _Utils_Tuple2(remoteA, remoteB);
		_v0$1:
		while (true) {
			_v0$2:
			while (true) {
				_v0$3:
				while (true) {
					_v0$4:
					while (true) {
						_v0$5:
						while (true) {
							switch (_v0.a.$) {
								case 'Loaded':
									switch (_v0.b.$) {
										case 'Loaded':
											var a = _v0.a.a;
											var b = _v0.b.a;
											return $author$project$Forward$Remote$Loaded(
												A2(f, a, b));
										case 'Error':
											if (_v0.b.a.$ === 'Unloadable') {
												break _v0$2;
											} else {
												break _v0$4;
											}
										default:
											var _v2 = _v0.b;
											return $author$project$Forward$Remote$Loading;
									}
								case 'Error':
									switch (_v0.b.$) {
										case 'Error':
											if (_v0.a.a.$ === 'Unloadable') {
												break _v0$1;
											} else {
												if (_v0.b.a.$ === 'Unloadable') {
													break _v0$2;
												} else {
													break _v0$3;
												}
											}
										case 'Loading':
											if (_v0.a.a.$ === 'Unloadable') {
												break _v0$1;
											} else {
												break _v0$3;
											}
										default:
											if (_v0.a.a.$ === 'Unloadable') {
												break _v0$1;
											} else {
												break _v0$3;
											}
									}
								default:
									switch (_v0.b.$) {
										case 'Error':
											if (_v0.b.a.$ === 'Unloadable') {
												break _v0$2;
											} else {
												break _v0$4;
											}
										case 'Loading':
											break _v0$5;
										default:
											break _v0$5;
									}
							}
						}
						var _v1 = _v0.a;
						return $author$project$Forward$Remote$Loading;
					}
					var record = _v0.b.a.a;
					return $author$project$Forward$Remote$Error(
						$author$project$Forward$Remote$Unparseable(record));
				}
				var record = _v0.a.a.a;
				return $author$project$Forward$Remote$Error(
					$author$project$Forward$Remote$Unparseable(record));
			}
			var string = _v0.b.a.a;
			return $author$project$Forward$Remote$Error(
				$author$project$Forward$Remote$Unloadable(string));
		}
		var string = _v0.a.a.a;
		return $author$project$Forward$Remote$Error(
			$author$project$Forward$Remote$Unloadable(string));
	});
var $author$project$Forward$Internal$Loadable$map2 = F3(
	function (f, _v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return $author$project$Forward$Internal$Loadable$Loadable(
			{
				effects_: _Utils_ap(a.effects_, b.effects_),
				partiallyLoaded: A3($elm$core$Maybe$map2, f, a.partiallyLoaded, b.partiallyLoaded),
				result: A3($author$project$Forward$Remote$map2, f, a.result, b.result)
			});
	});
var $elm$core$Dict$Black = {$: 'Black'};
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = {$: 'Red'};
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1.$) {
				case 'LT':
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 'EQ':
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $author$project$Forward$Internal$RoseDict$RoseDict = function (a) {
	return {$: 'RoseDict', a: a};
};
var $author$project$Forward$Internal$RoseDict$empty = $author$project$Forward$Internal$RoseDict$RoseDict($elm$core$Dict$empty);
var $author$project$Forward$Internal$GraphTree$noBranches = $author$project$Forward$Internal$RoseDict$empty;
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $author$project$Forward$Internal$RoseDict$union = F2(
	function (_v0, _v1) {
		var da = _v0.a;
		var db = _v1.a;
		return $author$project$Forward$Internal$RoseDict$RoseDict(
			A6(
				$elm$core$Dict$merge,
				$elm$core$Dict$insert,
				F3(
					function (key, a, b) {
						return A2(
							$elm$core$Dict$insert,
							key,
							A2($author$project$Forward$Internal$RoseDict$union, a, b));
					}),
				$elm$core$Dict$insert,
				da,
				db,
				$elm$core$Dict$empty));
	});
var $author$project$Forward$Internal$GraphTree$unionBranches = A2($elm$core$List$foldl, $author$project$Forward$Internal$RoseDict$union, $author$project$Forward$Internal$GraphTree$noBranches);
var $author$project$Forward$Lookup$apply = F2(
	function (_v0, _v1) {
		var arg = _v0.a;
		var fn = _v1.a;
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: A2($elm$core$Dict$union, fn.decoderConfig, arg.decoderConfig),
				invalidate: F2(
					function (k, mode) {
						return A2(
							$elm$core$Basics$composeR,
							A2(fn.invalidate, k, mode),
							A2(arg.invalidate, k, mode));
					}),
				load: F3(
					function (cache, requiredTimestamp, k) {
						return A3(
							$author$project$Forward$Internal$Loadable$map2,
							F2(
								function (f, a) {
									return f(a);
								}),
							A3(fn.load, cache, requiredTimestamp, k),
							A3(arg.load, cache, requiredTimestamp, k));
					}),
				preloadBranches: $author$project$Forward$Internal$GraphTree$unionBranches(
					_List_fromArray(
						[fn.preloadBranches, arg.preloadBranches])),
				structure: function () {
					var _v2 = fn.structure;
					switch (_v2.$) {
						case 'Succeed':
							return $author$project$Forward$Internal$LookupStructure$Apply(
								_List_fromArray(
									[arg.structure]));
						case 'Apply':
							var prevArgs = _v2.a;
							return $author$project$Forward$Internal$LookupStructure$Apply(
								_Utils_ap(
									prevArgs,
									_List_fromArray(
										[arg.structure])));
						default:
							return A2(
								$author$project$Forward$Internal$LookupStructure$All,
								'apply',
								_List_fromArray(
									[fn.structure, arg.structure]));
					}
				}()
			});
	});
var $author$project$Forward$Internal$CacheKey$CacheKey = function (a) {
	return {$: 'CacheKey', a: a};
};
var $author$project$Forward$Internal$CacheKey$cacheKey = F2(
	function (get, set) {
		return $author$project$Forward$Internal$CacheKey$CacheKey(
			{
				getTypedCache: get,
				modifyTypedCache: F2(
					function (modify, cache) {
						return A2(
							set,
							modify(
								get(cache)),
							cache);
					})
			});
	});
var $author$project$Forward$AppSpecific$Cache$account = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.account;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{account: e});
		}));
var $author$project$AuditPb$Account = F9(
	function (name, payablesAccount, factorAccount, receivablesAccount, scraperAccount, tms, createdAt, updatedAt, carrierTerm) {
		return {carrierTerm: carrierTerm, createdAt: createdAt, factorAccount: factorAccount, name: name, payablesAccount: payablesAccount, receivablesAccount: receivablesAccount, scraperAccount: scraperAccount, tms: tms, updatedAt: updatedAt};
	});
var $author$project$AuditPb$decode = $elm$json$Json$Decode$succeed;
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(_Utils_Tuple0));
};
var $author$project$AuditPb$field = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$AuditPb$requiredWithoutDefault = F3(
	function (name, decoder, d) {
		return A2(
			$author$project$AuditPb$field,
			A2($elm$json$Json$Decode$field, name, decoder),
			d);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {index: index, match: match, number: number, submatches: submatches};
	});
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $jweir$elm_iso8601$ISO8601$iso8601Regex = A2(
	$elm$regex$Regex$findAtMost,
	1,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(\u005Cd{4})-?' + ('(\u005Cd{2})?-?' + ('(\u005Cd{2})?' + ('T?' + ('(\u005Cd{2})?:?' + ('(\u005Cd{2})?:?' + ('(\u005Cd{2})?' + ('([.,]\u005Cd{1,})?' + ('(Z|[+-]\u005Cd{2}:?\u005Cd{2})?' + '(.*)?')))))))))));
var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $jweir$elm_iso8601$ISO8601$parseMilliseconds = function (msString) {
	if (msString.$ === 'Nothing') {
		return 0;
	} else {
		var s = msString.a;
		var decimalStr = A4(
			$elm$regex$Regex$replaceAtMost,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[,.]')),
			function (_v1) {
				return '0.';
			},
			s);
		var decimal = A2(
			$elm$core$Maybe$withDefault,
			0.0,
			$elm$core$String$toFloat(decimalStr));
		return $elm$core$Basics$round(1000 * decimal);
	}
};
var $elm$core$String$toInt = _String_toInt;
var $jweir$elm_iso8601$ISO8601$Extras$toInt = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(str));
};
var $jweir$elm_iso8601$ISO8601$parseOffset = function (timeString) {
	var re = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(Z|([+-]\u005Cd{2}:?\u005Cd{2}))?'));
	var match = A3(
		$elm$regex$Regex$findAtMost,
		1,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('([-+])(\u005Cd\u005Cd):?(\u005Cd\u005Cd)')),
		A2($elm$core$Maybe$withDefault, '', timeString));
	var parts = A2(
		$elm$core$List$map,
		function ($) {
			return $.submatches;
		},
		match);
	var calc = F2(
		function (modifier, minutes) {
			switch (modifier) {
				case '+':
					return minutes;
				case '-':
					return (-1) * minutes;
				default:
					return minutes;
			}
		});
	_v0$2:
	while (true) {
		if ((((parts.b && parts.a.b) && (parts.a.a.$ === 'Just')) && parts.a.b.b) && (parts.a.b.a.$ === 'Just')) {
			if (parts.a.b.b.b) {
				if (((parts.a.b.b.a.$ === 'Just') && (!parts.a.b.b.b.b)) && (!parts.b.b)) {
					var _v1 = parts.a;
					var modifier = _v1.a.a;
					var _v2 = _v1.b;
					var hour_ = _v2.a.a;
					var _v3 = _v2.b;
					var minute_ = _v3.a.a;
					return A2(
						calc,
						modifier,
						($jweir$elm_iso8601$ISO8601$Extras$toInt(hour_) * 60) + $jweir$elm_iso8601$ISO8601$Extras$toInt(minute_));
				} else {
					break _v0$2;
				}
			} else {
				if (!parts.b.b) {
					var _v4 = parts.a;
					var modifier = _v4.a.a;
					var _v5 = _v4.b;
					var hour_ = _v5.a.a;
					return A2(
						calc,
						modifier,
						$jweir$elm_iso8601$ISO8601$Extras$toInt(hour_) * 60);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{nodeList: nodeList, nodeListSize: nodeListSize, tail: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $jweir$elm_iso8601$ISO8601$Extras$calendar = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_Utils_Tuple3('January', 31, 31),
			_Utils_Tuple3('February', 28, 29),
			_Utils_Tuple3('March', 31, 31),
			_Utils_Tuple3('April', 30, 30),
			_Utils_Tuple3('May', 31, 31),
			_Utils_Tuple3('June', 30, 30),
			_Utils_Tuple3('July', 31, 31),
			_Utils_Tuple3('August', 31, 31),
			_Utils_Tuple3('September', 30, 30),
			_Utils_Tuple3('October', 31, 31),
			_Utils_Tuple3('November', 30, 30),
			_Utils_Tuple3('December', 31, 31)
		]));
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_v0.$ === 'SubTree') {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $jweir$elm_iso8601$ISO8601$Extras$isLeapYear = function (year) {
	var c = !A2($elm$core$Basics$modBy, 400, year);
	var b = !A2($elm$core$Basics$modBy, 100, year);
	var a = !A2($elm$core$Basics$modBy, 4, year);
	var _v0 = _List_fromArray(
		[a, b, c]);
	_v0$3:
	while (true) {
		if ((_v0.b && _v0.a) && _v0.b.b) {
			if (!_v0.b.a) {
				if (_v0.b.b.b && (!_v0.b.b.b.b)) {
					var _v3 = _v0.b;
					var _v4 = _v3.b;
					return true;
				} else {
					break _v0$3;
				}
			} else {
				if (_v0.b.b.b) {
					if (_v0.b.b.a) {
						if (!_v0.b.b.b.b) {
							var _v1 = _v0.b;
							var _v2 = _v1.b;
							return true;
						} else {
							break _v0$3;
						}
					} else {
						if (!_v0.b.b.b.b) {
							var _v5 = _v0.b;
							var _v6 = _v5.b;
							return false;
						} else {
							break _v0$3;
						}
					}
				} else {
					break _v0$3;
				}
			}
		} else {
			break _v0$3;
		}
	}
	return false;
};
var $jweir$elm_iso8601$ISO8601$Extras$daysInMonth = F2(
	function (year, monthInt) {
		var calMonth = A2($elm$core$Array$get, monthInt - 1, $jweir$elm_iso8601$ISO8601$Extras$calendar);
		if (calMonth.$ === 'Just') {
			var _v1 = calMonth.a;
			var days = _v1.b;
			var leapDays = _v1.c;
			return $jweir$elm_iso8601$ISO8601$Extras$isLeapYear(year) ? leapDays : days;
		} else {
			return 0;
		}
	});
var $jweir$elm_iso8601$ISO8601$validateHour = function (time) {
	var s = time.second;
	var m = time.minute;
	var h = time.hour;
	return ((h === 24) && ((m + s) > 0)) ? $elm$core$Result$Err('hour is out of range') : (((h < 0) || (h > 24)) ? $elm$core$Result$Err('hour is out of range') : (((m < 0) || (m > 59)) ? $elm$core$Result$Err('minute is out of range') : (((s < 0) || (s > 59)) ? $elm$core$Result$Err('second is out of range') : $elm$core$Result$Ok(time))));
};
var $jweir$elm_iso8601$ISO8601$validateTime = function (time) {
	var maxDays = $jweir$elm_iso8601$ISO8601$Extras$daysInMonth;
	return ((time.month < 1) || (time.month > 12)) ? $elm$core$Result$Err('month is out of range') : (((time.day < 1) || (_Utils_cmp(
		time.day,
		A2($jweir$elm_iso8601$ISO8601$Extras$daysInMonth, time.year, time.month)) > 0)) ? $elm$core$Result$Err('day is out of range') : $jweir$elm_iso8601$ISO8601$validateHour(time));
};
var $jweir$elm_iso8601$ISO8601$fromString = function (s) {
	var unwrap = F2(
		function (x, d) {
			return $jweir$elm_iso8601$ISO8601$Extras$toInt(
				A2($elm$core$Maybe$withDefault, d, x));
		});
	var parts = A2(
		$elm$core$List$map,
		function ($) {
			return $.submatches;
		},
		$jweir$elm_iso8601$ISO8601$iso8601Regex(s));
	if (((((((((((parts.b && parts.a.b) && parts.a.b.b) && parts.a.b.b.b) && parts.a.b.b.b.b) && parts.a.b.b.b.b.b) && parts.a.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b.b) && parts.a.b.b.b.b.b.b.b.b.b) && (!parts.a.b.b.b.b.b.b.b.b.b.b)) && (!parts.b.b)) {
		var _v1 = parts.a;
		var y = _v1.a;
		var _v2 = _v1.b;
		var mon = _v2.a;
		var _v3 = _v2.b;
		var d = _v3.a;
		var _v4 = _v3.b;
		var h = _v4.a;
		var _v5 = _v4.b;
		var min = _v5.a;
		var _v6 = _v5.b;
		var sec = _v6.a;
		var _v7 = _v6.b;
		var mil = _v7.a;
		var _v8 = _v7.b;
		var off = _v8.a;
		var _v9 = _v8.b;
		var invalid = _v9.a;
		if (invalid.$ === 'Just') {
			return $elm$core$Result$Err('unexpected text');
		} else {
			return $jweir$elm_iso8601$ISO8601$validateTime(
				{
					day: A2(unwrap, d, '1'),
					hour: A2(unwrap, h, '0'),
					millisecond: $jweir$elm_iso8601$ISO8601$parseMilliseconds(mil),
					minute: A2(unwrap, min, '0'),
					month: A2(unwrap, mon, '1'),
					offset: $jweir$elm_iso8601$ISO8601$parseOffset(off),
					second: A2(unwrap, sec, '0'),
					year: A2(unwrap, y, '0')
				});
		}
	} else {
		return $elm$core$Result$Err('Unable to parse time');
	}
};
var $elm$time$Time$Posix = function (a) {
	return {$: 'Posix', a: a};
};
var $elm$time$Time$millisToPosix = $elm$time$Time$Posix;
var $jweir$elm_iso8601$ISO8601$Extras$daysInYear = function (year) {
	return $jweir$elm_iso8601$ISO8601$Extras$isLeapYear(year) ? 366 : 365;
};
var $jweir$elm_iso8601$ISO8601$ims = 1;
var $jweir$elm_iso8601$ISO8601$isec = $jweir$elm_iso8601$ISO8601$ims * 1000;
var $jweir$elm_iso8601$ISO8601$imin = $jweir$elm_iso8601$ISO8601$isec * 60;
var $jweir$elm_iso8601$ISO8601$ihour = $jweir$elm_iso8601$ISO8601$imin * 60;
var $jweir$elm_iso8601$ISO8601$iday = $jweir$elm_iso8601$ISO8601$ihour * 24;
var $jweir$elm_iso8601$ISO8601$offsetToTime = function (time) {
	return time.offset * $jweir$elm_iso8601$ISO8601$imin;
};
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $jweir$elm_iso8601$ISO8601$toTime = function (time) {
	var _v0 = time.year >= 1970;
	if (!_v0) {
		var years = A2(
			$elm$core$List$map,
			$jweir$elm_iso8601$ISO8601$Extras$daysInYear,
			A2($elm$core$List$range, time.year + 1, 1970 - 1));
		var totalDays = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$jweir$elm_iso8601$ISO8601$Extras$daysInMonth(time.year),
				A2($elm$core$List$range, 1, time.month)));
		var tots = _List_fromArray(
			[
				$jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(years),
				$jweir$elm_iso8601$ISO8601$iday * ($jweir$elm_iso8601$ISO8601$Extras$daysInYear(time.year) - totalDays),
				$jweir$elm_iso8601$ISO8601$iday * (A2($jweir$elm_iso8601$ISO8601$Extras$daysInMonth, time.year, time.month) - time.day),
				($jweir$elm_iso8601$ISO8601$iday - $jweir$elm_iso8601$ISO8601$ihour) - ($jweir$elm_iso8601$ISO8601$ihour * time.hour),
				($jweir$elm_iso8601$ISO8601$ihour - $jweir$elm_iso8601$ISO8601$imin) - ($jweir$elm_iso8601$ISO8601$imin * time.minute),
				$jweir$elm_iso8601$ISO8601$imin - ($jweir$elm_iso8601$ISO8601$isec * time.second),
				$jweir$elm_iso8601$ISO8601$offsetToTime(time)
			]);
		return 0 - ($elm$core$List$sum(tots) - time.millisecond);
	} else {
		var years = A2(
			$elm$core$List$map,
			$jweir$elm_iso8601$ISO8601$Extras$daysInYear,
			A2($elm$core$List$range, 1970, time.year - 1));
		var months = A2(
			$elm$core$List$map,
			$jweir$elm_iso8601$ISO8601$Extras$daysInMonth(time.year),
			A2($elm$core$List$range, 1, time.month - 1));
		var tots = _List_fromArray(
			[
				$jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(years),
				$jweir$elm_iso8601$ISO8601$iday * $elm$core$List$sum(months),
				$jweir$elm_iso8601$ISO8601$iday * (time.day - 1),
				$jweir$elm_iso8601$ISO8601$ihour * time.hour,
				$jweir$elm_iso8601$ISO8601$imin * time.minute,
				$jweir$elm_iso8601$ISO8601$isec * time.second,
				(-1) * $jweir$elm_iso8601$ISO8601$offsetToTime(time)
			]);
		return $elm$core$List$sum(tots) + time.millisecond;
	}
};
var $jweir$elm_iso8601$ISO8601$toPosix = function (time) {
	return $elm$time$Time$millisToPosix(
		$jweir$elm_iso8601$ISO8601$toTime(time));
};
var $author$project$AuditPb$timestampDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (v) {
		if (v.$ === 'Ok') {
			var v1 = v.a;
			return $elm$json$Json$Decode$succeed(
				$jweir$elm_iso8601$ISO8601$toPosix(v1));
		} else {
			var e = v.a;
			return $elm$json$Json$Decode$fail(e);
		}
	},
	A2($elm$json$Json$Decode$map, $jweir$elm_iso8601$ISO8601$fromString, $elm$json$Json$Decode$string));
var $author$project$AuditPb$TMSOptionCustom = {$: 'TMSOptionCustom'};
var $author$project$AuditPb$tmsOptionDefault = $author$project$AuditPb$TMSOptionCustom;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1.$) {
					case 'LT':
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 'EQ':
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $author$project$AuditPb$TMSOptionAljex = {$: 'TMSOptionAljex'};
var $author$project$AuditPb$TMSOptionAmous = {$: 'TMSOptionAmous'};
var $author$project$AuditPb$TMSOptionAscendTMS = {$: 'TMSOptionAscendTMS'};
var $author$project$AuditPb$TMSOptionBrokerPro = {$: 'TMSOptionBrokerPro'};
var $author$project$AuditPb$TMSOptionBusinessManager = {$: 'TMSOptionBusinessManager'};
var $author$project$AuditPb$TMSOptionCadence = {$: 'TMSOptionCadence'};
var $author$project$AuditPb$TMSOptionCargoTel = {$: 'TMSOptionCargoTel'};
var $author$project$AuditPb$TMSOptionDrDispatch = {$: 'TMSOptionDrDispatch'};
var $author$project$AuditPb$TMSOptionEdgeTMS = {$: 'TMSOptionEdgeTMS'};
var $author$project$AuditPb$TMSOptionEzLoader = {$: 'TMSOptionEzLoader'};
var $author$project$AuditPb$TMSOptionFMS = {$: 'TMSOptionFMS'};
var $author$project$AuditPb$TMSOptionFactorFox = {$: 'TMSOptionFactorFox'};
var $author$project$AuditPb$TMSOptionFactorSql = {$: 'TMSOptionFactorSql'};
var $author$project$AuditPb$TMSOptionFactorView = {$: 'TMSOptionFactorView'};
var $author$project$AuditPb$TMSOptionFreightHauler = {$: 'TMSOptionFreightHauler'};
var $author$project$AuditPb$TMSOptionHaulFox = {$: 'TMSOptionHaulFox'};
var $author$project$AuditPb$TMSOptionItsDispatch = {$: 'TMSOptionItsDispatch'};
var $author$project$AuditPb$TMSOptionKeypoint = {$: 'TMSOptionKeypoint'};
var $author$project$AuditPb$TMSOptionKeypointAPI = {$: 'TMSOptionKeypointAPI'};
var $author$project$AuditPb$TMSOptionLogistically = {$: 'TMSOptionLogistically'};
var $author$project$AuditPb$TMSOptionMCLeod = {$: 'TMSOptionMCLeod'};
var $author$project$AuditPb$TMSOptionMasterMind = {$: 'TMSOptionMasterMind'};
var $author$project$AuditPb$TMSOptionMercuryGate = {$: 'TMSOptionMercuryGate'};
var $author$project$AuditPb$TMSOptionOmnis = {$: 'TMSOptionOmnis'};
var $author$project$AuditPb$TMSOptionPortTMS = {$: 'TMSOptionPortTMS'};
var $author$project$AuditPb$TMSOptionPrimeTMS = {$: 'TMSOptionPrimeTMS'};
var $author$project$AuditPb$TMSOptionRevenova = {$: 'TMSOptionRevenova'};
var $author$project$AuditPb$TMSOptionRoseRocket = {$: 'TMSOptionRoseRocket'};
var $author$project$AuditPb$TMSOptionTai = {$: 'TMSOptionTai'};
var $author$project$AuditPb$TMSOptionThreegTMS = {$: 'TMSOptionThreegTMS'};
var $author$project$AuditPb$TMSOptionThreeplSystems = {$: 'TMSOptionThreeplSystems'};
var $author$project$AuditPb$TMSOptionTmw = {$: 'TMSOptionTmw'};
var $author$project$AuditPb$TMSOptionTransportPro = {$: 'TMSOptionTransportPro'};
var $author$project$AuditPb$TMSOptionTruckmate = {$: 'TMSOptionTruckmate'};
var $author$project$AuditPb$TMSOptionTurvo = {$: 'TMSOptionTurvo'};
var $author$project$AuditPb$TMSOptionViaTMS = {$: 'TMSOptionViaTMS'};
var $author$project$AuditPb$TMSOptionWave = {$: 'TMSOptionWave'};
var $author$project$AuditPb$TMSOptionWinFactor = {$: 'TMSOptionWinFactor'};
var $author$project$AuditPb$allTMSOption = _List_fromArray(
	[$author$project$AuditPb$TMSOptionCustom, $author$project$AuditPb$TMSOptionThreegTMS, $author$project$AuditPb$TMSOptionThreeplSystems, $author$project$AuditPb$TMSOptionAljex, $author$project$AuditPb$TMSOptionAmous, $author$project$AuditPb$TMSOptionAscendTMS, $author$project$AuditPb$TMSOptionBrokerPro, $author$project$AuditPb$TMSOptionCargoTel, $author$project$AuditPb$TMSOptionDrDispatch, $author$project$AuditPb$TMSOptionEdgeTMS, $author$project$AuditPb$TMSOptionEzLoader, $author$project$AuditPb$TMSOptionFMS, $author$project$AuditPb$TMSOptionFreightHauler, $author$project$AuditPb$TMSOptionHaulFox, $author$project$AuditPb$TMSOptionItsDispatch, $author$project$AuditPb$TMSOptionKeypoint, $author$project$AuditPb$TMSOptionKeypointAPI, $author$project$AuditPb$TMSOptionLogistically, $author$project$AuditPb$TMSOptionMasterMind, $author$project$AuditPb$TMSOptionMCLeod, $author$project$AuditPb$TMSOptionMercuryGate, $author$project$AuditPb$TMSOptionOmnis, $author$project$AuditPb$TMSOptionPortTMS, $author$project$AuditPb$TMSOptionPrimeTMS, $author$project$AuditPb$TMSOptionRevenova, $author$project$AuditPb$TMSOptionRoseRocket, $author$project$AuditPb$TMSOptionTai, $author$project$AuditPb$TMSOptionTmw, $author$project$AuditPb$TMSOptionTransportPro, $author$project$AuditPb$TMSOptionTruckmate, $author$project$AuditPb$TMSOptionTurvo, $author$project$AuditPb$TMSOptionViaTMS, $author$project$AuditPb$TMSOptionWave, $author$project$AuditPb$TMSOptionWinFactor, $author$project$AuditPb$TMSOptionBusinessManager, $author$project$AuditPb$TMSOptionCadence, $author$project$AuditPb$TMSOptionFactorFox, $author$project$AuditPb$TMSOptionFactorSql, $author$project$AuditPb$TMSOptionFactorView]);
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$AuditPb$tmsOptionToString = function (v) {
	switch (v.$) {
		case 'TMSOptionCustom':
			return 'Custom';
		case 'TMSOptionThreegTMS':
			return '3Gtms';
		case 'TMSOptionThreeplSystems':
			return '3PLSystems';
		case 'TMSOptionAljex':
			return 'aljex';
		case 'TMSOptionAmous':
			return 'Amous';
		case 'TMSOptionAscendTMS':
			return 'AscendTMS';
		case 'TMSOptionBrokerPro':
			return 'BrokerPro';
		case 'TMSOptionCargoTel':
			return 'CargoTel';
		case 'TMSOptionDrDispatch':
			return 'DrDispatch';
		case 'TMSOptionEdgeTMS':
			return 'EdgeTMS';
		case 'TMSOptionEzLoader':
			return 'EZLoader';
		case 'TMSOptionFMS':
			return 'FMS';
		case 'TMSOptionFreightHauler':
			return 'FreightHauler';
		case 'TMSOptionHaulFox':
			return 'HaulFox';
		case 'TMSOptionItsDispatch':
			return 'ITSDispatch';
		case 'TMSOptionKeypoint':
			return 'Keypoint';
		case 'TMSOptionKeypointAPI':
			return 'KeypointApi';
		case 'TMSOptionLogistically':
			return 'Logistically';
		case 'TMSOptionMasterMind':
			return 'MasterMind';
		case 'TMSOptionMCLeod':
			return 'McLeod';
		case 'TMSOptionMercuryGate':
			return 'MercuryGate';
		case 'TMSOptionOmnis':
			return 'Omnis';
		case 'TMSOptionPortTMS':
			return 'PortTMS';
		case 'TMSOptionPrimeTMS':
			return 'PrimeTMS';
		case 'TMSOptionRevenova':
			return 'Revenova';
		case 'TMSOptionRoseRocket':
			return 'RoseRocket';
		case 'TMSOptionTai':
			return 'Tai';
		case 'TMSOptionTmw':
			return 'TMW';
		case 'TMSOptionTransportPro':
			return 'TransportPro';
		case 'TMSOptionTruckmate':
			return 'Truckmate';
		case 'TMSOptionTurvo':
			return 'Turvo';
		case 'TMSOptionViaTMS':
			return 'ViaTMS';
		case 'TMSOptionWave':
			return 'Wave';
		case 'TMSOptionWinFactor':
			return 'WinFactor';
		case 'TMSOptionBusinessManager':
			return 'BusinessManager';
		case 'TMSOptionCadence':
			return 'Cadence';
		case 'TMSOptionFactorFox':
			return 'FactorFox';
		case 'TMSOptionFactorSql':
			return 'FactorSQL';
		default:
			return 'FactorView';
	}
};
var $author$project$AuditPb$tmsOptionDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$tmsOptionToString(v),
				v);
		},
		$author$project$AuditPb$allTMSOption));
var $author$project$AuditPb$tmsOptionFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$tmsOptionDict);
};
var $author$project$AuditPb$tmsOptionDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$tmsOptionDefault),
		$author$project$AuditPb$tmsOptionFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$accountDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'carrier_term',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'updated_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'created_at',
					$author$project$AuditPb$timestampDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'tms',
						$author$project$AuditPb$tmsOptionDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'scraper_account',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'receivables_account',
								$elm$json$Json$Decode$bool,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'factor_account',
									$elm$json$Json$Decode$bool,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'payables_account',
										$elm$json$Json$Decode$bool,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'name',
											$elm$json$Json$Decode$string,
											$author$project$AuditPb$decode($author$project$AuditPb$Account))))))))));
	});
var $author$project$Forward$Internal$LookupStructure$Node = function (a) {
	return {$: 'Node', a: a};
};
var $author$project$Forward$Internal$Loadable$addEffects = F2(
	function (newEffects, _v0) {
		var original = _v0.a;
		return $author$project$Forward$Internal$Loadable$Loadable(
			{
				effects_: _Utils_ap(newEffects, original.effects_),
				partiallyLoaded: original.partiallyLoaded,
				result: original.result
			});
	});
var $author$project$Forward$Internal$Loadable$addEffect = F2(
	function (newEffect, loadable) {
		return A2(
			$author$project$Forward$Internal$Loadable$addEffects,
			_List_fromArray(
				[newEffect]),
			loadable);
	});
var $author$project$Forward$Internal$Priority$RequiredASAP = {$: 'RequiredASAP'};
var $author$project$Forward$Internal$Priority$default = $author$project$Forward$Internal$Priority$RequiredASAP;
var $author$project$Forward$Internal$Loadable$fromTuple = function (_v0) {
	var remote = _v0.a;
	var eff = _v0.b;
	return $author$project$Forward$Internal$Loadable$Loadable(
		{
			effects_: eff,
			partiallyLoaded: $author$project$Forward$Remote$toMaybe(remote),
			result: remote
		});
};
var $author$project$Forward$Internal$Loadable$errored = function (error) {
	return $author$project$Forward$Internal$Loadable$fromTuple(
		_Utils_Tuple2(
			$author$project$Forward$Remote$Error(error),
			_List_Nil));
};
var $author$project$Forward$Internal$GraphTree$fromEntrypoint = function (entrypoint) {
	return _Utils_Tuple3(entrypoint, $elm$core$Maybe$Nothing, $author$project$Forward$Internal$GraphTree$noBranches);
};
var $author$project$Forward$Internal$EntrypointCache$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Forward$Internal$EntrypointCache$NeedsRefresh = function (a) {
	return {$: 'NeedsRefresh', a: a};
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (_v0.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Forward$Internal$GraphEntrypoint$toComparable = function (entrypoint) {
	if (entrypoint.$ === 'BySingleton') {
		var path = entrypoint.a;
		return path;
	} else {
		var path = entrypoint.a;
		var params = entrypoint.b;
		return path + ('-' + A2($elm$json$Json$Encode$encode, 0, params));
	}
};
var $author$project$Forward$Internal$EntrypointCache$get = F3(
	function (key, requiredTimestamp, _v0) {
		var cache = _v0.a;
		var comparableKey = $author$project$Forward$Internal$GraphEntrypoint$toComparable(key);
		var checkFreshness = function (result) {
			if (A2($elm$core$Set$member, comparableKey, cache.needsRefresh)) {
				return $author$project$Forward$Internal$EntrypointCache$NeedsRefresh(result);
			} else {
				if (requiredTimestamp.$ === 'Nothing') {
					return $author$project$Forward$Internal$EntrypointCache$Loaded(result);
				} else {
					var required = requiredTimestamp.a;
					var _v2 = A2($elm$core$Dict$get, comparableKey, cache.timestamps);
					if (_v2.$ === 'Nothing') {
						return $author$project$Forward$Internal$EntrypointCache$NeedsRefresh(result);
					} else {
						var cachedTimestamp = _v2.a;
						return (_Utils_cmp(
							$elm$time$Time$posixToMillis(cachedTimestamp),
							$elm$time$Time$posixToMillis(required)) > -1) ? $author$project$Forward$Internal$EntrypointCache$Loaded(result) : $author$project$Forward$Internal$EntrypointCache$NeedsRefresh(result);
					}
				}
			}
		};
		return A2(
			$elm$core$Maybe$map,
			checkFreshness,
			A2($elm$core$Dict$get, comparableKey, cache.values));
	});
var $author$project$Forward$Internal$CacheKey$getTypedCache = function (_v0) {
	var key = _v0.a;
	return key.getTypedCache;
};
var $author$project$Forward$Internal$EntrypointCache$EntrypointCache = function (a) {
	return {$: 'EntrypointCache', a: a};
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A3($elm$core$Dict$insert, key, _Utils_Tuple0, dict));
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
					if (right.d.$ === 'RBNode_elm_builtin') {
						if (right.d.a.$ === 'Black') {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor.$ === 'Black') {
			if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === 'RBNode_elm_builtin') {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === 'RBNode_elm_builtin') {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBNode_elm_builtin') {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === 'RBNode_elm_builtin') {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$remove, key, dict));
	});
var $author$project$Forward$Internal$EntrypointCache$invalidate = F3(
	function (key, mode, _v0) {
		var cache = _v0.a;
		var comparableKey = $author$project$Forward$Internal$GraphEntrypoint$toComparable(key);
		if (mode.$ === 'RemoveCachedData') {
			return $author$project$Forward$Internal$EntrypointCache$EntrypointCache(
				{
					needsRefresh: A2($elm$core$Set$remove, comparableKey, cache.needsRefresh),
					timestamps: A2($elm$core$Dict$remove, comparableKey, cache.timestamps),
					values: A2($elm$core$Dict$remove, comparableKey, cache.values)
				});
		} else {
			return $author$project$Forward$Internal$EntrypointCache$EntrypointCache(
				{
					needsRefresh: A2($elm$core$Set$insert, comparableKey, cache.needsRefresh),
					timestamps: A2($elm$core$Dict$remove, comparableKey, cache.timestamps),
					values: cache.values
				});
		}
	});
var $author$project$Forward$Internal$Loadable$load = function (effect) {
	return $author$project$Forward$Internal$Loadable$fromTuple(
		_Utils_Tuple2(
			$author$project$Forward$Remote$Loading,
			_List_fromArray(
				[effect])));
};
var $author$project$Forward$Internal$Loadable$loaded = function (a) {
	return $author$project$Forward$Internal$Loadable$fromTuple(
		_Utils_Tuple2(
			$author$project$Forward$Remote$Loaded(a),
			_List_Nil));
};
var $author$project$Forward$Internal$CacheKey$modifyTypedCache = function (_v0) {
	var key = _v0.a;
	return key.modifyTypedCache;
};
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$ParameterResponseDecoder = function (a) {
	return {$: 'ParameterResponseDecoder', a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Forward$Remote$errorFromJsonError = function (jsonError) {
	return $author$project$Forward$Remote$Unparseable(
		{
			decoderMessage: $elm$json$Json$Decode$errorToString(jsonError),
			json: ''
		});
};
var $author$project$Forward$Internal$EntrypointCache$insert = F4(
	function (key, requestedTimestamp, value, _v0) {
		var cache = _v0.a;
		var comparableKey = $author$project$Forward$Internal$GraphEntrypoint$toComparable(key);
		return $author$project$Forward$Internal$EntrypointCache$EntrypointCache(
			{
				needsRefresh: A2($elm$core$Set$remove, comparableKey, cache.needsRefresh),
				timestamps: function () {
					if (requestedTimestamp.$ === 'Nothing') {
						return cache.timestamps;
					} else {
						var timestamp = requestedTimestamp.a;
						return A3($elm$core$Dict$insert, comparableKey, timestamp, cache.timestamps);
					}
				}(),
				values: A3($elm$core$Dict$insert, comparableKey, value, cache.values)
			});
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$unloadableDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (jsonList) {
		if ((jsonList.b && jsonList.b.b) && (!jsonList.b.b.b)) {
			var token = jsonList.a;
			var _v1 = jsonList.b;
			var reason = _v1.a;
			return (token === '~#unloadable') ? $elm$json$Json$Decode$succeed(
				$author$project$Forward$Remote$Unloadable('Unloadable: ' + reason)) : ((token === '~#access_denied') ? $elm$json$Json$Decode$succeed(
				$author$project$Forward$Remote$Unloadable('Access Denied: ' + reason)) : $elm$json$Json$Decode$fail('Not Unloadable'));
		} else {
			return $elm$json$Json$Decode$fail('expecting at least two elements in the array');
		}
	},
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$withError = F2(
	function (error, cacheToCache) {
		return A2(
			$elm$core$Basics$composeR,
			cacheToCache,
			function (cache) {
				return _Utils_Tuple2(
					cache,
					_List_fromArray(
						[error]));
			});
	});
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$noCacheUpdate = function (cache) {
	return _Utils_Tuple2(cache, _List_Nil);
};
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$withNoErrors = function (cacheToCache) {
	return A2($elm$core$Basics$composeR, cacheToCache, $author$project$Forward$RailsBackend$EntrypointDecoderConfig$noCacheUpdate);
};
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$decodeIntoCache = F5(
	function (decodeValue, cacheKey, entrypoint, requestedTimestamp, json) {
		var modifyCache = function (result) {
			return A2(
				$author$project$Forward$Internal$CacheKey$modifyTypedCache,
				cacheKey,
				A3($author$project$Forward$Internal$EntrypointCache$insert, entrypoint, requestedTimestamp, result));
		};
		var updateAndReport = function (result) {
			if (result.$ === 'Ok') {
				return $author$project$Forward$RailsBackend$EntrypointDecoderConfig$withNoErrors(
					modifyCache(result));
			} else {
				var err = result.a;
				return A2(
					$author$project$Forward$RailsBackend$EntrypointDecoderConfig$withError,
					err,
					modifyCache(result));
			}
		};
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Forward$RailsBackend$EntrypointDecoderConfig$unloadableDecoder, json);
		if (_v0.$ === 'Ok') {
			var unloadable = _v0.a;
			return updateAndReport(
				$elm$core$Result$Err(unloadable));
		} else {
			return updateAndReport(
				A2(
					$elm$core$Result$mapError,
					$author$project$Forward$Remote$errorFromJsonError,
					A2($elm$json$Json$Decode$decodeValue, decodeValue, json)));
		}
	});
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$parameterResponseDecoder = F2(
	function (decodeValue, cacheKey) {
		return $author$project$Forward$RailsBackend$EntrypointDecoderConfig$ParameterResponseDecoder(
			A2($author$project$Forward$RailsBackend$EntrypointDecoderConfig$decodeIntoCache, decodeValue, cacheKey));
	});
var $author$project$Forward$Internal$GraphTree$setRequestedTimestamp = F2(
	function (timestamp, _v0) {
		var entrypoint = _v0.a;
		var branches = _v0.c;
		return _Utils_Tuple3(
			entrypoint,
			$elm$core$Maybe$Just(timestamp),
			branches);
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$SingletonDecoder = function (a) {
	return {$: 'SingletonDecoder', a: a};
};
var $author$project$Forward$RailsBackend$EntrypointDecoderConfig$singletonDecoder = F2(
	function (decodeValue, cacheKey) {
		return $author$project$Forward$RailsBackend$EntrypointDecoderConfig$SingletonDecoder(
			A2($author$project$Forward$RailsBackend$EntrypointDecoderConfig$decodeIntoCache, decodeValue, cacheKey));
	});
var $author$project$Forward$Lookup$defineNode = function (config) {
	var toEntrypoint = function () {
		var _v4 = config.parameters;
		if (_v4.$ === 'NoParameters') {
			var f = _v4.a;
			return function (_v5) {
				return f(config.entrypoint);
			};
		} else {
			var f = _v4.a;
			return f(config.entrypoint);
		}
	}();
	return $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: function () {
				var singleConfig = function () {
					var _v0 = config.parameters;
					if (_v0.$ === 'NoParameters') {
						return A2($author$project$Forward$RailsBackend$EntrypointDecoderConfig$singletonDecoder, config.decoder, config.cacheKey);
					} else {
						return A2($author$project$Forward$RailsBackend$EntrypointDecoderConfig$parameterResponseDecoder, config.decoder, config.cacheKey);
					}
				}();
				return A2($elm$core$Dict$singleton, config.entrypoint, singleConfig);
			}(),
			invalidate: F2(
				function (a, mode) {
					var entrypoint = toEntrypoint(a);
					return A2(
						$author$project$Forward$Internal$CacheKey$modifyTypedCache,
						config.cacheKey,
						A2($author$project$Forward$Internal$EntrypointCache$invalidate, entrypoint, mode));
				}),
			load: F3(
				function (cache, requiredTimestamp, a) {
					var resultToLoadable = function (result) {
						if (result.$ === 'Ok') {
							var b = result.a;
							return $author$project$Forward$Internal$Loadable$loaded(b);
						} else {
							var error = result.a;
							return $author$project$Forward$Internal$Loadable$errored(error);
						}
					};
					var entrypoint = toEntrypoint(a);
					var graphTree = function () {
						if (requiredTimestamp.$ === 'Just') {
							var t = requiredTimestamp.a;
							return $author$project$Forward$Internal$GraphTree$setRequestedTimestamp(t);
						} else {
							return $elm$core$Basics$identity;
						}
					}()(
						$author$project$Forward$Internal$GraphTree$fromEntrypoint(entrypoint));
					var _v1 = A3(
						$author$project$Forward$Internal$EntrypointCache$get,
						entrypoint,
						requiredTimestamp,
						A2($author$project$Forward$Internal$CacheKey$getTypedCache, config.cacheKey, cache));
					if (_v1.$ === 'Nothing') {
						return $author$project$Forward$Internal$Loadable$load(
							_Utils_Tuple2(graphTree, $author$project$Forward$Internal$Priority$default));
					} else {
						if (_v1.a.$ === 'Loaded') {
							var result = _v1.a.a;
							return resultToLoadable(result);
						} else {
							var result = _v1.a.a;
							return A2(
								$author$project$Forward$Internal$Loadable$addEffect,
								_Utils_Tuple2(graphTree, $author$project$Forward$Internal$Priority$default),
								resultToLoadable(result));
						}
					}
				}),
			preloadBranches: $author$project$Forward$Internal$GraphTree$noBranches,
			structure: $author$project$Forward$Internal$LookupStructure$Node(config.entrypoint)
		});
};
var $author$project$Forward$Internal$GraphEntrypoint$BySingleton = function (a) {
	return {$: 'BySingleton', a: a};
};
var $author$project$Forward$Lookup$NoParameters = function (a) {
	return {$: 'NoParameters', a: a};
};
var $author$project$Forward$Lookup$noParameters = $author$project$Forward$Lookup$NoParameters(
	function (name) {
		return $author$project$Forward$Internal$GraphEntrypoint$BySingleton(name);
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount = $author$project$Forward$Lookup$defineNode(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$account, decoder: $author$project$AuditPb$accountDecoder, entrypoint: 'elmCurrentAccount', parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Forward$Internal$RoseDict$isEmpty = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Forward$Internal$GraphTree$isNoBranches = function (branches) {
	return $author$project$Forward$Internal$RoseDict$isEmpty(branches);
};
var $author$project$Forward$Internal$Loadable$fromRemote = function (remote) {
	return $author$project$Forward$Internal$Loadable$fromTuple(
		_Utils_Tuple2(remote, _List_Nil));
};
var $author$project$Forward$Remote$map = F2(
	function (f, remote) {
		switch (remote.$) {
			case 'Loading':
				return $author$project$Forward$Remote$Loading;
			case 'Loaded':
				var a = remote.a;
				return $author$project$Forward$Remote$Loaded(
					f(a));
			default:
				var error = remote.a;
				return $author$project$Forward$Remote$Error(error);
		}
	});
var $author$project$Forward$Internal$Loadable$map = F2(
	function (f, _v0) {
		var original = _v0.a;
		return $author$project$Forward$Internal$Loadable$Loadable(
			{
				effects_: original.effects_,
				partiallyLoaded: A2($elm$core$Maybe$map, f, original.partiallyLoaded),
				result: A2($author$project$Forward$Remote$map, f, original.result)
			});
	});
var $author$project$Forward$Internal$Loadable$maybeLoadableToLoadableMaybe = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		$author$project$Forward$Internal$Loadable$map($elm$core$Maybe$Just)),
	$elm$core$Maybe$withDefault(
		$author$project$Forward$Internal$Loadable$fromRemote(
			$author$project$Forward$Remote$Loaded($elm$core$Maybe$Nothing))));
var $author$project$Forward$Internal$RoseDict$singleton = function (a) {
	return $author$project$Forward$Internal$RoseDict$RoseDict(
		A2($elm$core$Dict$singleton, a, $author$project$Forward$Internal$RoseDict$empty));
};
var $author$project$Forward$Internal$GraphTree$singleBranch = function (string) {
	return $author$project$Forward$Internal$RoseDict$singleton(string);
};
var $elm$core$Debug$todo = _Debug_todo;
var $author$project$Forward$Lookup$defineMaybeEdge = function (config) {
	var _v0 = config.entrypoint;
	var nested = _v0.a;
	return $author$project$Forward$Internal$GraphTree$isNoBranches(nested.preloadBranches) ? $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: nested.decoderConfig,
			invalidate: function (from) {
				var _v1 = config.getId(from);
				if (_v1.$ === 'Just') {
					var id = _v1.a;
					return nested.invalidate(id);
				} else {
					return function (_v2) {
						return $elm$core$Basics$identity;
					};
				}
			},
			load: F3(
				function (cache, requiredTimestamp, parent) {
					return $author$project$Forward$Internal$Loadable$maybeLoadableToLoadableMaybe(
						A2(
							$elm$core$Maybe$map,
							A2(nested.load, cache, requiredTimestamp),
							config.getId(parent)));
				}),
			preloadBranches: $author$project$Forward$Internal$GraphTree$singleBranch(config.fieldName),
			structure: nested.structure
		}) : _Debug_todo(
		'Forward.Lookup',
		{
			start: {line: 433, column: 8},
			end: {line: 433, column: 18}
		})('XXX: You should only be passing a top-level graph entrypoint defined with Lookup.defineNode as the entrypoint to defineEdge.  (Advanced note: this could probably be implemented, but would need to be considered carefully to fully handle all edge cases; and it\u0027s probably not something we want to allow anyway.)');
};
var $author$project$AuditPb$EmailMessage = function (id) {
	return function (inReplyToEmailMessageId) {
		return function (messageType) {
			return function (carrierId) {
				return function (subject) {
					return function (textBody) {
						return function (createdAt) {
							return function (updatedAt) {
								return function (senderAddress) {
									return function (recipientAddress) {
										return function (rawTo) {
											return function (rawCc) {
												return function (documentBatchId) {
													return function (attachmentDownloadUrl) {
														return function (completedAt) {
															return function (importCompletedAt) {
																return function (labels) {
																	return function (importFailedAt) {
																		return function (hasFactorClientInvoiceSubmission) {
																			return function (singleCarrier) {
																				return function (automaticallySentAfterIndexing) {
																					return function (importState) {
																						return function (estimatedDueDate) {
																							return {attachmentDownloadUrl: attachmentDownloadUrl, automaticallySentAfterIndexing: automaticallySentAfterIndexing, carrierId: carrierId, completedAt: completedAt, createdAt: createdAt, documentBatchId: documentBatchId, estimatedDueDate: estimatedDueDate, hasFactorClientInvoiceSubmission: hasFactorClientInvoiceSubmission, id: id, importCompletedAt: importCompletedAt, importFailedAt: importFailedAt, importState: importState, inReplyToEmailMessageId: inReplyToEmailMessageId, labels: labels, messageType: messageType, rawCc: rawCc, rawTo: rawTo, recipientAddress: recipientAddress, senderAddress: senderAddress, singleCarrier: singleCarrier, subject: subject, textBody: textBody, updatedAt: updatedAt};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$EmailAddress = F2(
	function (email, name) {
		return {email: email, name: name};
	});
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$AuditPb$optional = F3(
	function (name, decoder, d) {
		return A2(
			$author$project$AuditPb$field,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, name, decoder)),
			d);
	});
var $author$project$AuditPb$emailAddressDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'email',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$EmailAddress)));
	});
var $author$project$AuditPb$EmailImportStateImportInProgress = {$: 'EmailImportStateImportInProgress'};
var $author$project$AuditPb$emailImportStateDefault = $author$project$AuditPb$EmailImportStateImportInProgress;
var $author$project$AuditPb$EmailImportStateImportCompleted = {$: 'EmailImportStateImportCompleted'};
var $author$project$AuditPb$EmailImportStateImportFailed = {$: 'EmailImportStateImportFailed'};
var $author$project$AuditPb$EmailImportStateInDocumentBatchGroupingReview = {$: 'EmailImportStateInDocumentBatchGroupingReview'};
var $author$project$AuditPb$EmailImportStateInDocumentContentReview = {$: 'EmailImportStateInDocumentContentReview'};
var $author$project$AuditPb$EmailImportStateInDocumentContentReviewDocumentType = {$: 'EmailImportStateInDocumentContentReviewDocumentType'};
var $author$project$AuditPb$EmailImportStateInDocumentContentReviewNoDependents = {$: 'EmailImportStateInDocumentContentReviewNoDependents'};
var $author$project$AuditPb$EmailImportStateInDocumentGroupLoadReview = {$: 'EmailImportStateInDocumentGroupLoadReview'};
var $author$project$AuditPb$EmailImportStateInPODDetection = {$: 'EmailImportStateInPODDetection'};
var $author$project$AuditPb$allEmailImportState = _List_fromArray(
	[$author$project$AuditPb$EmailImportStateImportInProgress, $author$project$AuditPb$EmailImportStateImportFailed, $author$project$AuditPb$EmailImportStateInPODDetection, $author$project$AuditPb$EmailImportStateInDocumentContentReview, $author$project$AuditPb$EmailImportStateInDocumentContentReviewDocumentType, $author$project$AuditPb$EmailImportStateInDocumentContentReviewNoDependents, $author$project$AuditPb$EmailImportStateInDocumentBatchGroupingReview, $author$project$AuditPb$EmailImportStateImportCompleted, $author$project$AuditPb$EmailImportStateInDocumentGroupLoadReview]);
var $author$project$AuditPb$emailImportStateToString = function (v) {
	switch (v.$) {
		case 'EmailImportStateImportInProgress':
			return 'importing';
		case 'EmailImportStateImportFailed':
			return 'import_failed';
		case 'EmailImportStateInPODDetection':
			return 'pod_review';
		case 'EmailImportStateInDocumentContentReview':
			return 'document_content_review';
		case 'EmailImportStateInDocumentContentReviewDocumentType':
			return 'document_content_review_document_type';
		case 'EmailImportStateInDocumentContentReviewNoDependents':
			return 'document_content_review_no_dependents';
		case 'EmailImportStateInDocumentBatchGroupingReview':
			return 'document_batch_grouping_review';
		case 'EmailImportStateImportCompleted':
			return 'import_completed';
		default:
			return 'document_group_load_review';
	}
};
var $author$project$AuditPb$emailImportStateDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$emailImportStateToString(v),
				v);
		},
		$author$project$AuditPb$allEmailImportState));
var $author$project$AuditPb$emailImportStateFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$emailImportStateDict);
};
var $author$project$AuditPb$emailImportStateDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$emailImportStateDefault),
		$author$project$AuditPb$emailImportStateFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$EmailMessageTypeSent = {$: 'EmailMessageTypeSent'};
var $author$project$AuditPb$emailMessageTypeDefault = $author$project$AuditPb$EmailMessageTypeSent;
var $author$project$AuditPb$EmailMessageTypeDocuments = {$: 'EmailMessageTypeDocuments'};
var $author$project$AuditPb$EmailMessageTypeImport = {$: 'EmailMessageTypeImport'};
var $author$project$AuditPb$EmailMessageTypeReply = {$: 'EmailMessageTypeReply'};
var $author$project$AuditPb$allEmailMessageType = _List_fromArray(
	[$author$project$AuditPb$EmailMessageTypeSent, $author$project$AuditPb$EmailMessageTypeDocuments, $author$project$AuditPb$EmailMessageTypeReply, $author$project$AuditPb$EmailMessageTypeImport]);
var $author$project$AuditPb$emailMessageTypeToString = function (v) {
	switch (v.$) {
		case 'EmailMessageTypeSent':
			return 'sent';
		case 'EmailMessageTypeDocuments':
			return 'documents';
		case 'EmailMessageTypeReply':
			return 'reply';
		default:
			return 'import';
	}
};
var $author$project$AuditPb$emailMessageTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$emailMessageTypeToString(v),
				v);
		},
		$author$project$AuditPb$allEmailMessageType));
var $author$project$AuditPb$emailMessageTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$emailMessageTypeDict);
};
var $author$project$AuditPb$emailMessageTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$emailMessageTypeDefault),
		$author$project$AuditPb$emailMessageTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$Id$Id = function (a) {
	return {$: 'Id', a: a};
};
var $author$project$Id$fromInt = $author$project$Id$Id;
var $author$project$Domain$DocumentBatchId$fromInt = $author$project$Id$fromInt;
var $author$project$Domain$EmailMessageId$fromInt = $author$project$Id$fromInt;
var $author$project$Domain$TmsCarrierId$fromInt = $author$project$Id$fromInt;
var $author$project$AuditPb$fromMaybe = F2(
	function (error, maybe) {
		if (maybe.$ === 'Just') {
			var v1 = maybe.a;
			return $elm$json$Json$Decode$succeed(v1);
		} else {
			return $elm$json$Json$Decode$fail(error);
		}
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$AuditPb$intDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$int,
			A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toInt,
				$author$project$AuditPb$fromMaybe('could not convert string to integer')),
			$elm$json$Json$Decode$string)
		]));
var $author$project$AuditPb$withDefault = F2(
	function (_default, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					decoder,
					$elm$json$Json$Decode$succeed(_default)
				]));
	});
var $author$project$AuditPb$repeated = F3(
	function (name, decoder, d) {
		return A2(
			$author$project$AuditPb$field,
			A2(
				$author$project$AuditPb$withDefault,
				_List_Nil,
				A2(
					$elm$json$Json$Decode$field,
					name,
					$elm$json$Json$Decode$list(decoder))),
			d);
	});
var $author$project$AuditPb$emailMessageDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'estimated_due_date',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'import_state',
				$author$project$AuditPb$emailImportStateDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'automatically_sent_after_indexing',
					$elm$json$Json$Decode$bool,
					A3(
						$author$project$AuditPb$optional,
						'single_carrier',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'has_factor_client_invoice_submission',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$optional,
								'import_failed_at',
								$author$project$AuditPb$timestampDecoder,
								A3(
									$author$project$AuditPb$repeated,
									'labels',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$optional,
										'import_completed_at',
										$author$project$AuditPb$timestampDecoder,
										A3(
											$author$project$AuditPb$optional,
											'completed_at',
											$author$project$AuditPb$timestampDecoder,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'attachment_download_url',
												$elm$json$Json$Decode$string,
												A3(
													$author$project$AuditPb$optional,
													'document_batch_id',
													A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $author$project$AuditPb$intDecoder),
													A3(
														$author$project$AuditPb$repeated,
														'raw_cc',
														$author$project$AuditPb$emailAddressDecoder,
														A3(
															$author$project$AuditPb$repeated,
															'raw_to',
															$author$project$AuditPb$emailAddressDecoder,
															A3(
																$author$project$AuditPb$optional,
																'recipient_address',
																$elm$json$Json$Decode$string,
																A3(
																	$author$project$AuditPb$requiredWithoutDefault,
																	'sender_address',
																	$elm$json$Json$Decode$string,
																	A3(
																		$author$project$AuditPb$requiredWithoutDefault,
																		'updated_at',
																		$author$project$AuditPb$timestampDecoder,
																		A3(
																			$author$project$AuditPb$requiredWithoutDefault,
																			'created_at',
																			$author$project$AuditPb$timestampDecoder,
																			A3(
																				$author$project$AuditPb$requiredWithoutDefault,
																				'text_body',
																				$elm$json$Json$Decode$string,
																				A3(
																					$author$project$AuditPb$requiredWithoutDefault,
																					'subject',
																					$elm$json$Json$Decode$string,
																					A3(
																						$author$project$AuditPb$optional,
																						'carrier_id',
																						A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
																						A3(
																							$author$project$AuditPb$optional,
																							'message_type',
																							$author$project$AuditPb$emailMessageTypeDecoder,
																							A3(
																								$author$project$AuditPb$optional,
																								'in_reply_to_email_message_id',
																								A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
																								A3(
																									$author$project$AuditPb$requiredWithoutDefault,
																									'id',
																									A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
																									$author$project$AuditPb$decode($author$project$AuditPb$EmailMessage))))))))))))))))))))))));
	});
var $author$project$Domain$EmailMessage$decode = $author$project$AuditPb$emailMessageDecoder;
var $author$project$Forward$AppSpecific$Cache$emailMessage = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.emailMessage;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{emailMessage: e});
		}));
var $author$project$Forward$Internal$GraphEntrypoint$ByQuery = F2(
	function (a, b) {
		return {$: 'ByQuery', a: a, b: b};
	});
var $author$project$Forward$Lookup$SomeParameters = function (a) {
	return {$: 'SomeParameters', a: a};
};
var $author$project$Forward$Lookup$queryParameters = function (encodeParams) {
	return $author$project$Forward$Lookup$SomeParameters(
		F2(
			function (name, query) {
				return A2(
					$author$project$Forward$Internal$GraphEntrypoint$ByQuery,
					name,
					encodeParams(query));
			}));
};
var $author$project$Forward$Lookup$primaryKeyParameter = function (idToInt) {
	return $author$project$Forward$Lookup$queryParameters(
		A2($elm$core$Basics$composeR, idToInt, $elm$json$Json$Encode$int));
};
var $author$project$Domain$EmailMessageId$toInt = $author$project$Id$toInt;
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$emailMessage,
		decoder: $author$project$Domain$EmailMessage$decode,
		entrypoint: 'emailMessageV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
		fieldName: 'emailMessage',
		getId: function ($) {
			return $.emailMessageId;
		}
	});
var $author$project$AuditPb$DocumentBatch = function (id) {
	return function (emailMessageId) {
		return function (singleCarrier) {
			return function (createdAt) {
				return function (updatedAt) {
					return function (pages) {
						return function (groupMismatch) {
							return function (batchLevelUploads) {
								return function (regroupRequired) {
									return function (fullyReviewed) {
										return function (autoProcessingData) {
											return function (mergedDocumentsDownloadUrl) {
												return {autoProcessingData: autoProcessingData, batchLevelUploads: batchLevelUploads, createdAt: createdAt, emailMessageId: emailMessageId, fullyReviewed: fullyReviewed, groupMismatch: groupMismatch, id: id, mergedDocumentsDownloadUrl: mergedDocumentsDownloadUrl, pages: pages, regroupRequired: regroupRequired, singleCarrier: singleCarrier, updatedAt: updatedAt};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$InvoiceAutoProcessingData = F3(
	function (invoiceId, invoiceType, wasAutoProcessed) {
		return {invoiceId: invoiceId, invoiceType: invoiceType, wasAutoProcessed: wasAutoProcessed};
	});
var $author$project$AuditPb$InvoiceAutoProcessingInvoiceTypeFactorInvoice = {$: 'InvoiceAutoProcessingInvoiceTypeFactorInvoice'};
var $author$project$AuditPb$invoiceAutoProcessingInvoiceTypeDefault = $author$project$AuditPb$InvoiceAutoProcessingInvoiceTypeFactorInvoice;
var $author$project$AuditPb$InvoiceAutoProcessingInvoiceTypeCarrierInvoice = {$: 'InvoiceAutoProcessingInvoiceTypeCarrierInvoice'};
var $author$project$AuditPb$allInvoiceAutoProcessingInvoiceType = _List_fromArray(
	[$author$project$AuditPb$InvoiceAutoProcessingInvoiceTypeFactorInvoice, $author$project$AuditPb$InvoiceAutoProcessingInvoiceTypeCarrierInvoice]);
var $author$project$AuditPb$invoiceAutoProcessingInvoiceTypeToString = function (v) {
	if (v.$ === 'InvoiceAutoProcessingInvoiceTypeFactorInvoice') {
		return 'FactorInvoice';
	} else {
		return 'CarrierInvoice';
	}
};
var $author$project$AuditPb$invoiceAutoProcessingInvoiceTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$invoiceAutoProcessingInvoiceTypeToString(v),
				v);
		},
		$author$project$AuditPb$allInvoiceAutoProcessingInvoiceType));
var $author$project$AuditPb$invoiceAutoProcessingInvoiceTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$invoiceAutoProcessingInvoiceTypeDict);
};
var $author$project$AuditPb$invoiceAutoProcessingInvoiceTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$invoiceAutoProcessingInvoiceTypeDefault),
		$author$project$AuditPb$invoiceAutoProcessingInvoiceTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$invoiceAutoProcessingDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'wasAutoProcessed',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'invoiceType',
				$author$project$AuditPb$invoiceAutoProcessingInvoiceTypeDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'invoiceId',
					$author$project$AuditPb$intDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$InvoiceAutoProcessingData))));
	});
var $author$project$AuditPb$documentBatchDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'merged_documents_download_url',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'auto_processing_data',
				$author$project$AuditPb$invoiceAutoProcessingDataDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'fully_reviewed',
					$elm$json$Json$Decode$bool,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'regroup_required',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'batch_level_uploads',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'group_mismatch',
								$elm$json$Json$Decode$bool,
								A3(
									$author$project$AuditPb$optional,
									'pages',
									$author$project$AuditPb$intDecoder,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'updated_at',
										$author$project$AuditPb$timestampDecoder,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'created_at',
											$author$project$AuditPb$timestampDecoder,
											A3(
												$author$project$AuditPb$optional,
												'single_carrier',
												$elm$json$Json$Decode$bool,
												A3(
													$author$project$AuditPb$optional,
													'email_message_id',
													A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'id',
														A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $author$project$AuditPb$intDecoder),
														$author$project$AuditPb$decode($author$project$AuditPb$DocumentBatch)))))))))))));
	});
var $author$project$Forward$AppSpecific$Cache$documentBatchV2 = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentBatchV2;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentBatchV2: e});
		}));
var $author$project$Domain$DocumentBatchId$toInt = $author$project$Id$toInt;
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2 = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$documentBatchV2,
		decoder: $author$project$AuditPb$documentBatchDecoder,
		entrypoint: 'documentBatchV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentBatchId$toInt)
	});
var $author$project$Forward$Internal$LookupStructure$Identity = {$: 'Identity'};
var $author$project$Forward$Lookup$identity = $author$project$Forward$Lookup$Lookup(
	{
		decoderConfig: $elm$core$Dict$empty,
		invalidate: F2(
			function (_v0, _v1) {
				return $elm$core$Basics$identity;
			}),
		load: F3(
			function (_v2, _v3, a) {
				return $author$project$Forward$Internal$Loadable$fromRemote(
					$author$project$Forward$Remote$Loaded(a));
			}),
		preloadBranches: $author$project$Forward$Internal$GraphTree$noBranches,
		structure: $author$project$Forward$Internal$LookupStructure$Identity
	});
var $author$project$Forward$Internal$LookupStructure$AndThen = F3(
	function (a, b, c) {
		return {$: 'AndThen', a: a, b: b, c: c};
	});
var $author$project$Forward$Internal$LookupStructure$OneOf = F2(
	function (a, b) {
		return {$: 'OneOf', a: a, b: b};
	});
var $author$project$Forward$Internal$Loadable$andThen = F2(
	function (f, _v0) {
		var original = _v0.a;
		var make = function (remote) {
			var _v2 = A2($elm$core$Maybe$map, f, original.partiallyLoaded);
			if (_v2.$ === 'Just') {
				var b = _v2.a.a;
				return $author$project$Forward$Internal$Loadable$Loadable(
					{
						effects_: _Utils_ap(original.effects_, b.effects_),
						partiallyLoaded: function () {
							var _v3 = $author$project$Forward$Remote$toMaybe(b.result);
							if (_v3.$ === 'Nothing') {
								return b.partiallyLoaded;
							} else {
								var b_ = _v3.a;
								return $elm$core$Maybe$Just(b_);
							}
						}(),
						result: remote
					});
			} else {
				return $author$project$Forward$Internal$Loadable$Loadable(
					{effects_: original.effects_, partiallyLoaded: $elm$core$Maybe$Nothing, result: remote});
			}
		};
		var _v1 = original.result;
		switch (_v1.$) {
			case 'Loaded':
				var a = _v1.a;
				return A2(
					$author$project$Forward$Internal$Loadable$addEffects,
					original.effects_,
					f(a));
			case 'Loading':
				return make($author$project$Forward$Remote$Loading);
			default:
				var error = _v1.a;
				return make(
					$author$project$Forward$Remote$Error(error));
		}
	});
var $author$project$Forward$Lookup$ifElseVia = F4(
	function (_v0, readSetting, _v1, _v2) {
		var nestedSettings = _v0.a;
		var whenTrue = _v1.a;
		var whenFalse = _v2.a;
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: A2(
					$elm$core$Dict$union,
					nestedSettings.decoderConfig,
					A2($elm$core$Dict$union, whenTrue.decoderConfig, whenFalse.decoderConfig)),
				invalidate: F2(
					function (from, mode) {
						return A2(
							$elm$core$Basics$composeR,
							A2(nestedSettings.invalidate, from, mode),
							A2(
								$elm$core$Basics$composeR,
								A2(whenTrue.invalidate, from, mode),
								A2(whenFalse.invalidate, from, mode)));
					}),
				load: F3(
					function (cache, requiredTimestamp, from) {
						return A2(
							$author$project$Forward$Internal$Loadable$andThen,
							function (settings) {
								return readSetting(settings) ? A3(whenTrue.load, cache, requiredTimestamp, from) : A3(whenFalse.load, cache, requiredTimestamp, from);
							},
							A3(nestedSettings.load, cache, requiredTimestamp, from));
					}),
				preloadBranches: nestedSettings.preloadBranches,
				structure: A3(
					$author$project$Forward$Internal$LookupStructure$AndThen,
					'ifElseVia',
					nestedSettings.structure,
					A2(
						$author$project$Forward$Internal$LookupStructure$OneOf,
						'ifElseVia',
						_List_fromArray(
							[whenTrue.structure, whenFalse.structure])))
			});
	});
var $author$project$Forward$Internal$LookupStructure$Succeed = {$: 'Succeed'};
var $author$project$Forward$Lookup$succeed = function (value) {
	return $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: $elm$core$Dict$empty,
			invalidate: F2(
				function (_v0, _v1) {
					return $elm$core$Basics$identity;
				}),
			load: F3(
				function (_v2, _v3, _v4) {
					return $author$project$Forward$Internal$Loadable$fromRemote(
						$author$project$Forward$Remote$Loaded(value));
				}),
			preloadBranches: $author$project$Forward$Internal$GraphTree$noBranches,
			structure: $author$project$Forward$Internal$LookupStructure$Succeed
		});
};
var $author$project$AuditPb$ScraperAuthRequirementNone = {$: 'ScraperAuthRequirementNone'};
var $author$project$Domain$TmsCarrier$TmsCarrier = function (id) {
	return function (name) {
		return function (acctExec) {
			return function (mcNumber) {
				return function (dotNumber) {
					return function (scac) {
						return function (ein) {
							return function (externalId) {
								return function (externalVendorId) {
									return function (city) {
										return function (state) {
											return function (country) {
												return function (createdAt) {
													return function (updatedAt) {
														return function (address) {
															return function (paymentAddress) {
																return function (effectiveDaysToPay) {
																	return function (effectiveQuickpayDiscount) {
																		return function (paymentStrategy) {
																			return function (attemptToAutoProcessDocumentBatches) {
																				return function (rateConfirmationRequired) {
																					return function (podRequired) {
																						return function (receivablesInvoiceCustomer) {
																							return function (skipAutoStamp) {
																								return function (factorSendCustomerInvoiceToCadence) {
																									return function (transportationClient) {
																										return function (scraperAvailable) {
																											return function (scrapingEnabled) {
																												return function (supportsScrapingInvoice) {
																													return function (supportsCredentialTesting) {
																														return function (scrapingDocumentsAuthRequirement) {
																															return function (scrapingInvoiceAuthRequirement) {
																																return function (documentTypesRetrieved) {
																																	return function (factorClientPortalEnabled) {
																																		return function (portalSubmissionStrategy) {
																																			return function (labels) {
																																				return function (externalLabels) {
																																					return function (contacts) {
																																						return function (externalLogins) {
																																							return function (setupHelpText) {
																																								return function (fundingNotes) {
																																									return function (notes) {
																																										return function (warning) {
																																											return function (excludeFromVerificationsWorkflow) {
																																												return function (verifyPercentile) {
																																													return function (cadenceVerificationInstructions) {
																																														return function (creditRating) {
																																															return function (verificationPercentage) {
																																																return function (inactiveAt) {
																																																	return function (features) {
																																																		return function (warnIfAmountOver) {
																																																			return function (manualReviewPercentage) {
																																																				return function (factorInvoiceNumberStrategy) {
																																																					return function (autoGenerateFactorInvoiceNumbers) {
																																																						return function (overrideDefaultTolerance) {
																																																							return function (invoiceToleranceUnit) {
																																																								return function (invoiceToleranceAmountAbove) {
																																																									return function (invoiceToleranceAmountBelow) {
																																																										return function (programExternalId) {
																																																											return function (implicitInvoice) {
																																																												return {acctExec: acctExec, address: address, attemptToAutoProcessDocumentBatches: attemptToAutoProcessDocumentBatches, autoGenerateFactorInvoiceNumbers: autoGenerateFactorInvoiceNumbers, cadenceVerificationInstructions: cadenceVerificationInstructions, city: city, contacts: contacts, country: country, createdAt: createdAt, creditRating: creditRating, documentTypesRetrieved: documentTypesRetrieved, dotNumber: dotNumber, effectiveDaysToPay: effectiveDaysToPay, effectiveQuickpayDiscount: effectiveQuickpayDiscount, ein: ein, excludeFromVerificationsWorkflow: excludeFromVerificationsWorkflow, externalId: externalId, externalLabels: externalLabels, externalLogins: externalLogins, externalVendorId: externalVendorId, factorClientPortalEnabled: factorClientPortalEnabled, factorInvoiceNumberStrategy: factorInvoiceNumberStrategy, factorSendCustomerInvoiceToCadence: factorSendCustomerInvoiceToCadence, features: features, fundingNotes: fundingNotes, id: id, implicitInvoice: implicitInvoice, inactiveAt: inactiveAt, invoiceToleranceAmountAbove: invoiceToleranceAmountAbove, invoiceToleranceAmountBelow: invoiceToleranceAmountBelow, invoiceToleranceUnit: invoiceToleranceUnit, labels: labels, manualReviewPercentage: manualReviewPercentage, mcNumber: mcNumber, name: name, notes: notes, overrideDefaultTolerance: overrideDefaultTolerance, paymentAddress: paymentAddress, paymentStrategy: paymentStrategy, podRequired: podRequired, portalSubmissionStrategy: portalSubmissionStrategy, programExternalId: programExternalId, rateConfirmationRequired: rateConfirmationRequired, receivablesInvoiceCustomer: receivablesInvoiceCustomer, scac: scac, scraperAvailable: scraperAvailable, scrapingDocumentsAuthRequirement: scrapingDocumentsAuthRequirement, scrapingEnabled: scrapingEnabled, scrapingInvoiceAuthRequirement: scrapingInvoiceAuthRequirement, setupHelpText: setupHelpText, skipAutoStamp: skipAutoStamp, state: state, supportsCredentialTesting: supportsCredentialTesting, supportsScrapingInvoice: supportsScrapingInvoice, transportationClient: transportationClient, updatedAt: updatedAt, verificationPercentage: verificationPercentage, verifyPercentile: verifyPercentile, warnIfAmountOver: warnIfAmountOver, warning: warning};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Helpers$Json$Decode$apply = F2(
	function (aDecoder, f) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (f_) {
				return A2($elm$json$Json$Decode$map, f_, aDecoder);
			},
			f);
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Domain$TmsCarrier$Contact = F7(
	function (id, name, email, admin, factorClientPortalEnabled, portalSubmissionStrategy, urlHash) {
		return {admin: admin, email: email, factorClientPortalEnabled: factorClientPortalEnabled, id: id, name: name, portalSubmissionStrategy: portalSubmissionStrategy, urlHash: urlHash};
	});
var $author$project$Domain$ContactId$ContactId = function (a) {
	return {$: 'ContactId', a: a};
};
var $author$project$Domain$ContactId$fromInt = function (_int) {
	return $author$project$Domain$ContactId$ContactId(_int);
};
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Domain$TmsCarrier$FactorOnly = {$: 'FactorOnly'};
var $author$project$Domain$TmsCarrier$PortalOnly = {$: 'PortalOnly'};
var $author$project$Helpers$Json$Decode$enum = F2(
	function (tag, list) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (raw) {
				var _v0 = A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(raw)),
					list);
				if (_v0.b && (!_v0.b.b)) {
					var _v1 = _v0.a;
					var a = _v1.b;
					return $elm$json$Json$Decode$succeed(a);
				} else {
					return $elm$json$Json$Decode$fail('BAD TAG');
				}
			},
			tag);
	});
var $author$project$Domain$TmsCarrier$portalSubmissionStrategy = A2(
	$author$project$Helpers$Json$Decode$enum,
	$elm$json$Json$Decode$string,
	_List_fromArray(
		[
			_Utils_Tuple2('portal_only', $author$project$Domain$TmsCarrier$PortalOnly),
			_Utils_Tuple2('factor_only', $author$project$Domain$TmsCarrier$FactorOnly)
		]));
var $author$project$Domain$TmsCarrier$contact = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Domain$TmsCarrier$Contact,
	A2(
		$elm$json$Json$Decode$field,
		'id',
		A2($elm$json$Json$Decode$map, $author$project$Domain$ContactId$fromInt, $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'name',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed('')
				]))),
	A2(
		$elm$json$Json$Decode$field,
		'email',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed('')
				]))),
	A2($elm$json$Json$Decode$field, 'admin', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'factor_client_portal_enabled', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'portal_submission_strategy', $author$project$Domain$TmsCarrier$portalSubmissionStrategy),
	A2($elm$json$Json$Decode$field, 'url_hash', $elm$json$Json$Decode$string));
var $author$project$AuditPb$Address = F8(
	function (id, name, addressLine1, addressLine2, city, state, postalCode, country) {
		return {addressLine1: addressLine1, addressLine2: addressLine2, city: city, country: country, id: id, name: name, postalCode: postalCode, state: state};
	});
var $author$project$Domain$AddressId$AddressId = function (a) {
	return {$: 'AddressId', a: a};
};
var $author$project$Domain$AddressId$fromInt = function (_int) {
	return $author$project$Domain$AddressId$AddressId(_int);
};
var $author$project$Domain$AddressId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$AddressId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Helpers$Json$Decode$nonEmptyString = A2(
	$elm$json$Json$Decode$andThen,
	function (decodedString) {
		return $elm$core$String$isEmpty(decodedString) ? $elm$json$Json$Decode$fail('Empty string') : $elm$json$Json$Decode$succeed(decodedString);
	},
	$elm$json$Json$Decode$string);
var $elm_community$json_extra$Json$Decode$Extra$withDefault = F2(
	function (fallback, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(fallback),
			$elm$json$Json$Decode$maybe(decoder));
	});
var $author$project$Domain$Address$decodeWithPrefix = function (prefix) {
	return A2(
		$author$project$Helpers$Json$Decode$apply,
		A2(
			$elm$json$Json$Decode$field,
			prefix + 'country',
			$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString)),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2(
				$elm$json$Json$Decode$field,
				prefix + 'postal_code',
				$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString)),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				A2(
					$elm$json$Json$Decode$field,
					prefix + 'state',
					$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString)),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2(
						$elm$json$Json$Decode$field,
						prefix + 'city',
						$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString)),
					A2(
						$author$project$Helpers$Json$Decode$apply,
						A2(
							$elm$json$Json$Decode$field,
							prefix + 'address_line_2',
							$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString)),
						A2(
							$author$project$Helpers$Json$Decode$apply,
							A2(
								$elm$json$Json$Decode$field,
								prefix + 'address_line_1',
								$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString)),
							A2(
								$author$project$Helpers$Json$Decode$apply,
								A2(
									$elm_community$json_extra$Json$Decode$Extra$withDefault,
									'Unknown Location',
									A2($elm$json$Json$Decode$field, prefix + 'name', $elm$json$Json$Decode$string)),
								A2(
									$author$project$Helpers$Json$Decode$apply,
									$elm$json$Json$Decode$maybe(
										A2($elm$json$Json$Decode$field, prefix + 'id', $author$project$Domain$AddressId$decode)),
									$elm$json$Json$Decode$succeed($author$project$AuditPb$Address)))))))));
};
var $author$project$Domain$Address$decode = $author$project$Domain$Address$decodeWithPrefix('');
var $author$project$Domain$UnresolvedDocumentType$Unknown = {$: 'Unknown'};
var $author$project$Domain$UnresolvedDocumentType$Partial = function (a) {
	return {$: 'Partial', a: a};
};
var $author$project$Domain$UnresolvedDocumentType$Resolved = function (a) {
	return {$: 'Resolved', a: a};
};
var $author$project$AuditPb$DocumentTypeAchSetupForm = {$: 'DocumentTypeAchSetupForm'};
var $author$project$AuditPb$DocumentTypeAdvanceRequest = {$: 'DocumentTypeAdvanceRequest'};
var $author$project$AuditPb$DocumentTypeAgentInvoice = {$: 'DocumentTypeAgentInvoice'};
var $author$project$AuditPb$DocumentTypeArrivalNotice = {$: 'DocumentTypeArrivalNotice'};
var $author$project$AuditPb$DocumentTypeAsbestosDeclaration = {$: 'DocumentTypeAsbestosDeclaration'};
var $author$project$AuditPb$DocumentTypeAuditSheet = {$: 'DocumentTypeAuditSheet'};
var $author$project$AuditPb$DocumentTypeAusfta = {$: 'DocumentTypeAusfta'};
var $author$project$AuditPb$DocumentTypeAuthority = {$: 'DocumentTypeAuthority'};
var $author$project$AuditPb$DocumentTypeAuthorizationRelease = {$: 'DocumentTypeAuthorizationRelease'};
var $author$project$AuditPb$DocumentTypeB3CanadianCustomsEntry = {$: 'DocumentTypeB3CanadianCustomsEntry'};
var $author$project$AuditPb$DocumentTypeBalanceDue = {$: 'DocumentTypeBalanceDue'};
var $author$project$AuditPb$DocumentTypeBillOfLading = {$: 'DocumentTypeBillOfLading'};
var $author$project$AuditPb$DocumentTypeBookingConfirmation = {$: 'DocumentTypeBookingConfirmation'};
var $author$project$AuditPb$DocumentTypeBookingRequest = {$: 'DocumentTypeBookingRequest'};
var $author$project$AuditPb$DocumentTypeCarrierInvoice = {$: 'DocumentTypeCarrierInvoice'};
var $author$project$AuditPb$DocumentTypeCarrierRateConfirmation = {$: 'DocumentTypeCarrierRateConfirmation'};
var $author$project$AuditPb$DocumentTypeCartageAdviceWithReceipt = {$: 'DocumentTypeCartageAdviceWithReceipt'};
var $author$project$AuditPb$DocumentTypeCertificateOfOrigin = {$: 'DocumentTypeCertificateOfOrigin'};
var $author$project$AuditPb$DocumentTypeClaim = {$: 'DocumentTypeClaim'};
var $author$project$AuditPb$DocumentTypeClaimNotice = {$: 'DocumentTypeClaimNotice'};
var $author$project$AuditPb$DocumentTypeCoMCHeck = {$: 'DocumentTypeCoMCHeck'};
var $author$project$AuditPb$DocumentTypeCombinedNoaLor = {$: 'DocumentTypeCombinedNoaLor'};
var $author$project$AuditPb$DocumentTypeCommercialInvoice = {$: 'DocumentTypeCommercialInvoice'};
var $author$project$AuditPb$DocumentTypeConsignmentSecurityDeclaration = {$: 'DocumentTypeConsignmentSecurityDeclaration'};
var $author$project$AuditPb$DocumentTypeContract = {$: 'DocumentTypeContract'};
var $author$project$AuditPb$DocumentTypeCorrectionNotice = {$: 'DocumentTypeCorrectionNotice'};
var $author$project$AuditPb$DocumentTypeCustomerDocumentsOther = {$: 'DocumentTypeCustomerDocumentsOther'};
var $author$project$AuditPb$DocumentTypeCustomerInvoice = {$: 'DocumentTypeCustomerInvoice'};
var $author$project$AuditPb$DocumentTypeCustomerRelease = {$: 'DocumentTypeCustomerRelease'};
var $author$project$AuditPb$DocumentTypeCustomerTender = {$: 'DocumentTypeCustomerTender'};
var $author$project$AuditPb$DocumentTypeCustomsAuthority = {$: 'DocumentTypeCustomsAuthority'};
var $author$project$AuditPb$DocumentTypeCustomsClearanceRequest = {$: 'DocumentTypeCustomsClearanceRequest'};
var $author$project$AuditPb$DocumentTypeCustomsDocument = {$: 'DocumentTypeCustomsDocument'};
var $author$project$AuditPb$DocumentTypeCustomsEntrySummary = {$: 'DocumentTypeCustomsEntrySummary'};
var $author$project$AuditPb$DocumentTypeCustomsPowerOfAttorney = {$: 'DocumentTypeCustomsPowerOfAttorney'};
var $author$project$AuditPb$DocumentTypeDangerousGoodsDeclaration = {$: 'DocumentTypeDangerousGoodsDeclaration'};
var $author$project$AuditPb$DocumentTypeDeclarationCertificate = {$: 'DocumentTypeDeclarationCertificate'};
var $author$project$AuditPb$DocumentTypeDeliveryOrder = {$: 'DocumentTypeDeliveryOrder'};
var $author$project$AuditPb$DocumentTypeDemurrageReceipt = {$: 'DocumentTypeDemurrageReceipt'};
var $author$project$AuditPb$DocumentTypeDetentionApproval = {$: 'DocumentTypeDetentionApproval'};
var $author$project$AuditPb$DocumentTypeDriverForm = {$: 'DocumentTypeDriverForm'};
var $author$project$AuditPb$DocumentTypeDropoffInspectionCertificate = {$: 'DocumentTypeDropoffInspectionCertificate'};
var $author$project$AuditPb$DocumentTypeElectronicInterchangeReceipt = {$: 'DocumentTypeElectronicInterchangeReceipt'};
var $author$project$AuditPb$DocumentTypeEmailApproval = {$: 'DocumentTypeEmailApproval'};
var $author$project$AuditPb$DocumentTypeEscortReceipt = {$: 'DocumentTypeEscortReceipt'};
var $author$project$AuditPb$DocumentTypeExitPass = {$: 'DocumentTypeExitPass'};
var $author$project$AuditPb$DocumentTypeExport = {$: 'DocumentTypeExport'};
var $author$project$AuditPb$DocumentTypeExportAuthority = {$: 'DocumentTypeExportAuthority'};
var $author$project$AuditPb$DocumentTypeExportDeclaration = {$: 'DocumentTypeExportDeclaration'};
var $author$project$AuditPb$DocumentTypeFactorInvoice = {$: 'DocumentTypeFactorInvoice'};
var $author$project$AuditPb$DocumentTypeFerryReceipt = {$: 'DocumentTypeFerryReceipt'};
var $author$project$AuditPb$DocumentTypeFine = {$: 'DocumentTypeFine'};
var $author$project$AuditPb$DocumentTypeForm1113 = {$: 'DocumentTypeForm1113'};
var $author$project$AuditPb$DocumentTypeFreetimeNotification = {$: 'DocumentTypeFreetimeNotification'};
var $author$project$AuditPb$DocumentTypeFreightLabel = {$: 'DocumentTypeFreightLabel'};
var $author$project$AuditPb$DocumentTypeFumigationCertificate = {$: 'DocumentTypeFumigationCertificate'};
var $author$project$AuditPb$DocumentTypeFundingForm = {$: 'DocumentTypeFundingForm'};
var $author$project$AuditPb$DocumentTypeGatePass = {$: 'DocumentTypeGatePass'};
var $author$project$AuditPb$DocumentTypeGovernmentBillOfLading = {$: 'DocumentTypeGovernmentBillOfLading'};
var $author$project$AuditPb$DocumentTypeHiddenBillOfLading = {$: 'DocumentTypeHiddenBillOfLading'};
var $author$project$AuditPb$DocumentTypeHouseAirwayBill = {$: 'DocumentTypeHouseAirwayBill'};
var $author$project$AuditPb$DocumentTypeHouseBillOfLading = {$: 'DocumentTypeHouseBillOfLading'};
var $author$project$AuditPb$DocumentTypeHouseOceanBillOfLading = {$: 'DocumentTypeHouseOceanBillOfLading'};
var $author$project$AuditPb$DocumentTypeInspectionCertificate = {$: 'DocumentTypeInspectionCertificate'};
var $author$project$AuditPb$DocumentTypeInsuranceCertificate = {$: 'DocumentTypeInsuranceCertificate'};
var $author$project$AuditPb$DocumentTypeIntermodalInTransitNotice = {$: 'DocumentTypeIntermodalInTransitNotice'};
var $author$project$AuditPb$DocumentTypeInternalDocumentsOther = {$: 'DocumentTypeInternalDocumentsOther'};
var $author$project$AuditPb$DocumentTypeInternalProofOfDelivery = {$: 'DocumentTypeInternalProofOfDelivery'};
var $author$project$AuditPb$DocumentTypeInternationalBillOfLading = {$: 'DocumentTypeInternationalBillOfLading'};
var $author$project$AuditPb$DocumentTypeInvoice = {$: 'DocumentTypeInvoice'};
var $author$project$AuditPb$DocumentTypeIsfFilingInstruction = {$: 'DocumentTypeIsfFilingInstruction'};
var $author$project$AuditPb$DocumentTypeLaborReceipt = {$: 'DocumentTypeLaborReceipt'};
var $author$project$AuditPb$DocumentTypeLayoverApproval = {$: 'DocumentTypeLayoverApproval'};
var $author$project$AuditPb$DocumentTypeLegacyFactoringAssignment = {$: 'DocumentTypeLegacyFactoringAssignment'};
var $author$project$AuditPb$DocumentTypeLegacyLoadTender = {$: 'DocumentTypeLegacyLoadTender'};
var $author$project$AuditPb$DocumentTypeLetterOfAssignment = {$: 'DocumentTypeLetterOfAssignment'};
var $author$project$AuditPb$DocumentTypeLetterOfCredit = {$: 'DocumentTypeLetterOfCredit'};
var $author$project$AuditPb$DocumentTypeLumperApproval = {$: 'DocumentTypeLumperApproval'};
var $author$project$AuditPb$DocumentTypeManifest = {$: 'DocumentTypeManifest'};
var $author$project$AuditPb$DocumentTypeMasterAirwayBill = {$: 'DocumentTypeMasterAirwayBill'};
var $author$project$AuditPb$DocumentTypeMasterBillOfLading = {$: 'DocumentTypeMasterBillOfLading'};
var $author$project$AuditPb$DocumentTypeMasterOceanBillOfLading = {$: 'DocumentTypeMasterOceanBillOfLading'};
var $author$project$AuditPb$DocumentTypeMotorVehicleCertificate = {$: 'DocumentTypeMotorVehicleCertificate'};
var $author$project$AuditPb$DocumentTypeMsds = {$: 'DocumentTypeMsds'};
var $author$project$AuditPb$DocumentTypeMxBol = {$: 'DocumentTypeMxBol'};
var $author$project$AuditPb$DocumentTypeNaftaCertificate = {$: 'DocumentTypeNaftaCertificate'};
var $author$project$AuditPb$DocumentTypeNmfcCertificate = {$: 'DocumentTypeNmfcCertificate'};
var $author$project$AuditPb$DocumentTypeNoticeOfAssignment = {$: 'DocumentTypeNoticeOfAssignment'};
var $author$project$AuditPb$DocumentTypeNoticeOfRelease = {$: 'DocumentTypeNoticeOfRelease'};
var $author$project$AuditPb$DocumentTypePackingDeclaration = {$: 'DocumentTypePackingDeclaration'};
var $author$project$AuditPb$DocumentTypePackingList = {$: 'DocumentTypePackingList'};
var $author$project$AuditPb$DocumentTypePackingSlip = {$: 'DocumentTypePackingSlip'};
var $author$project$AuditPb$DocumentTypePalletReceipt = {$: 'DocumentTypePalletReceipt'};
var $author$project$AuditPb$DocumentTypePerDiemInvoice = {$: 'DocumentTypePerDiemInvoice'};
var $author$project$AuditPb$DocumentTypePerDiemReceipt = {$: 'DocumentTypePerDiemReceipt'};
var $author$project$AuditPb$DocumentTypePermit = {$: 'DocumentTypePermit'};
var $author$project$AuditPb$DocumentTypePermitToTransfer = {$: 'DocumentTypePermitToTransfer'};
var $author$project$AuditPb$DocumentTypePickupInspectionCertificate = {$: 'DocumentTypePickupInspectionCertificate'};
var $author$project$AuditPb$DocumentTypePickupNumber = {$: 'DocumentTypePickupNumber'};
var $author$project$AuditPb$DocumentTypePostal = {$: 'DocumentTypePostal'};
var $author$project$AuditPb$DocumentTypePreAlert = {$: 'DocumentTypePreAlert'};
var $author$project$AuditPb$DocumentTypeProformaInvoice = {$: 'DocumentTypeProformaInvoice'};
var $author$project$AuditPb$DocumentTypeProofOfDelivery = {$: 'DocumentTypeProofOfDelivery'};
var $author$project$AuditPb$DocumentTypePurchaseOrder = {$: 'DocumentTypePurchaseOrder'};
var $author$project$AuditPb$DocumentTypeQuote = {$: 'DocumentTypeQuote'};
var $author$project$AuditPb$DocumentTypeRateConfirmation = {$: 'DocumentTypeRateConfirmation'};
var $author$project$AuditPb$DocumentTypeRepairItem = {$: 'DocumentTypeRepairItem'};
var $author$project$AuditPb$DocumentTypeRunTicket = {$: 'DocumentTypeRunTicket'};
var $author$project$AuditPb$DocumentTypeSanitaryCertificate = {$: 'DocumentTypeSanitaryCertificate'};
var $author$project$AuditPb$DocumentTypeShippersLetterOfInstruction = {$: 'DocumentTypeShippersLetterOfInstruction'};
var $author$project$AuditPb$DocumentTypeShippersSecurityDeclaration = {$: 'DocumentTypeShippersSecurityDeclaration'};
var $author$project$AuditPb$DocumentTypeSolasForm = {$: 'DocumentTypeSolasForm'};
var $author$project$AuditPb$DocumentTypeSteamingReceipt = {$: 'DocumentTypeSteamingReceipt'};
var $author$project$AuditPb$DocumentTypeTelexRelease = {$: 'DocumentTypeTelexRelease'};
var $author$project$AuditPb$DocumentTypeTir = {$: 'DocumentTypeTir'};
var $author$project$AuditPb$DocumentTypeTollReceipt = {$: 'DocumentTypeTollReceipt'};
var $author$project$AuditPb$DocumentTypeTonuApproval = {$: 'DocumentTypeTonuApproval'};
var $author$project$AuditPb$DocumentTypeTrackingStatus = {$: 'DocumentTypeTrackingStatus'};
var $author$project$AuditPb$DocumentTypeTruckBillOfLading = {$: 'DocumentTypeTruckBillOfLading'};
var $author$project$AuditPb$DocumentTypeUnknown = {$: 'DocumentTypeUnknown'};
var $author$project$AuditPb$DocumentTypeUnknownCadenceImport = {$: 'DocumentTypeUnknownCadenceImport'};
var $author$project$AuditPb$DocumentTypeUsCustomsDocument = {$: 'DocumentTypeUsCustomsDocument'};
var $author$project$AuditPb$DocumentTypeVendorInvoice = {$: 'DocumentTypeVendorInvoice'};
var $author$project$AuditPb$DocumentTypeVeterinaryCertificate = {$: 'DocumentTypeVeterinaryCertificate'};
var $author$project$AuditPb$DocumentTypeVgmContainerInformation = {$: 'DocumentTypeVgmContainerInformation'};
var $author$project$AuditPb$DocumentTypeVoidedCheck = {$: 'DocumentTypeVoidedCheck'};
var $author$project$AuditPb$DocumentTypeW9 = {$: 'DocumentTypeW9'};
var $author$project$AuditPb$DocumentTypeWashReceipt = {$: 'DocumentTypeWashReceipt'};
var $author$project$AuditPb$DocumentTypeWasteManifest = {$: 'DocumentTypeWasteManifest'};
var $author$project$AuditPb$DocumentTypeWaybill = {$: 'DocumentTypeWaybill'};
var $author$project$AuditPb$DocumentTypeWeightMeasurementReport = {$: 'DocumentTypeWeightMeasurementReport'};
var $author$project$AuditPb$DocumentTypeWeightTicket = {$: 'DocumentTypeWeightTicket'};
var $author$project$AuditPb$DocumentTypeWeightTicketUnloaded = {$: 'DocumentTypeWeightTicketUnloaded'};
var $author$project$AuditPb$allDocumentType = _List_fromArray(
	[$author$project$AuditPb$DocumentTypeInvoice, $author$project$AuditPb$DocumentTypeFactorInvoice, $author$project$AuditPb$DocumentTypeCustomerInvoice, $author$project$AuditPb$DocumentTypeCarrierInvoice, $author$project$AuditPb$DocumentTypeCarrierRateConfirmation, $author$project$AuditPb$DocumentTypeCustomerTender, $author$project$AuditPb$DocumentTypeRateConfirmation, $author$project$AuditPb$DocumentTypeProofOfDelivery, $author$project$AuditPb$DocumentTypeBillOfLading, $author$project$AuditPb$DocumentTypeHiddenBillOfLading, $author$project$AuditPb$DocumentTypeWeightTicket, $author$project$AuditPb$DocumentTypeNoticeOfAssignment, $author$project$AuditPb$DocumentTypeLaborReceipt, $author$project$AuditPb$DocumentTypeLegacyFactoringAssignment, $author$project$AuditPb$DocumentTypeLegacyLoadTender, $author$project$AuditPb$DocumentTypeNoticeOfRelease, $author$project$AuditPb$DocumentTypeCombinedNoaLor, $author$project$AuditPb$DocumentTypePackingSlip, $author$project$AuditPb$DocumentTypeNmfcCertificate, $author$project$AuditPb$DocumentTypeCustomerDocumentsOther, $author$project$AuditPb$DocumentTypeInternalDocumentsOther, $author$project$AuditPb$DocumentTypePostal, $author$project$AuditPb$DocumentTypeVoidedCheck, $author$project$AuditPb$DocumentTypeLetterOfAssignment, $author$project$AuditPb$DocumentTypeDeliveryOrder, $author$project$AuditPb$DocumentTypeTir, $author$project$AuditPb$DocumentTypeFundingForm, $author$project$AuditPb$DocumentTypeAuditSheet, $author$project$AuditPb$DocumentTypeAdvanceRequest, $author$project$AuditPb$DocumentTypeDriverForm, $author$project$AuditPb$DocumentTypeEscortReceipt, $author$project$AuditPb$DocumentTypeFerryReceipt, $author$project$AuditPb$DocumentTypeRunTicket, $author$project$AuditPb$DocumentTypeSteamingReceipt, $author$project$AuditPb$DocumentTypeTollReceipt, $author$project$AuditPb$DocumentTypeWashReceipt, $author$project$AuditPb$DocumentTypeExitPass, $author$project$AuditPb$DocumentTypeInsuranceCertificate, $author$project$AuditPb$DocumentTypeContract, $author$project$AuditPb$DocumentTypeDetentionApproval, $author$project$AuditPb$DocumentTypeEmailApproval, $author$project$AuditPb$DocumentTypeLayoverApproval, $author$project$AuditPb$DocumentTypeLumperApproval, $author$project$AuditPb$DocumentTypeTonuApproval, $author$project$AuditPb$DocumentTypeMxBol, $author$project$AuditPb$DocumentTypeVendorInvoice, $author$project$AuditPb$DocumentTypeFine, $author$project$AuditPb$DocumentTypeW9, $author$project$AuditPb$DocumentTypeAuthority, $author$project$AuditPb$DocumentTypeBalanceDue, $author$project$AuditPb$DocumentTypeClaim, $author$project$AuditPb$DocumentTypeCoMCHeck, $author$project$AuditPb$DocumentTypeAchSetupForm, $author$project$AuditPb$DocumentTypeCustomsDocument, $author$project$AuditPb$DocumentTypeQuote, $author$project$AuditPb$DocumentTypeExport, $author$project$AuditPb$DocumentTypeMasterBillOfLading, $author$project$AuditPb$DocumentTypeHouseBillOfLading, $author$project$AuditPb$DocumentTypeWaybill, $author$project$AuditPb$DocumentTypeCommercialInvoice, $author$project$AuditPb$DocumentTypePackingList, $author$project$AuditPb$DocumentTypeCertificateOfOrigin, $author$project$AuditPb$DocumentTypeInspectionCertificate, $author$project$AuditPb$DocumentTypePickupInspectionCertificate, $author$project$AuditPb$DocumentTypeDropoffInspectionCertificate, $author$project$AuditPb$DocumentTypeWeightTicketUnloaded, $author$project$AuditPb$DocumentTypeUnknown, $author$project$AuditPb$DocumentTypeUnknownCadenceImport, $author$project$AuditPb$DocumentTypePalletReceipt, $author$project$AuditPb$DocumentTypeForm1113, $author$project$AuditPb$DocumentTypeGovernmentBillOfLading, $author$project$AuditPb$DocumentTypeInternationalBillOfLading, $author$project$AuditPb$DocumentTypeInternalProofOfDelivery, $author$project$AuditPb$DocumentTypeDemurrageReceipt, $author$project$AuditPb$DocumentTypePerDiemReceipt, $author$project$AuditPb$DocumentTypeElectronicInterchangeReceipt, $author$project$AuditPb$DocumentTypeRepairItem, $author$project$AuditPb$DocumentTypePermit, $author$project$AuditPb$DocumentTypeAgentInvoice, $author$project$AuditPb$DocumentTypeArrivalNotice, $author$project$AuditPb$DocumentTypeAsbestosDeclaration, $author$project$AuditPb$DocumentTypeAusfta, $author$project$AuditPb$DocumentTypeAuthorizationRelease, $author$project$AuditPb$DocumentTypeB3CanadianCustomsEntry, $author$project$AuditPb$DocumentTypeBookingConfirmation, $author$project$AuditPb$DocumentTypeBookingRequest, $author$project$AuditPb$DocumentTypeCartageAdviceWithReceipt, $author$project$AuditPb$DocumentTypeClaimNotice, $author$project$AuditPb$DocumentTypeConsignmentSecurityDeclaration, $author$project$AuditPb$DocumentTypeCorrectionNotice, $author$project$AuditPb$DocumentTypeCustomerRelease, $author$project$AuditPb$DocumentTypeCustomsAuthority, $author$project$AuditPb$DocumentTypeCustomsClearanceRequest, $author$project$AuditPb$DocumentTypeCustomsEntrySummary, $author$project$AuditPb$DocumentTypeCustomsPowerOfAttorney, $author$project$AuditPb$DocumentTypeDangerousGoodsDeclaration, $author$project$AuditPb$DocumentTypeDeclarationCertificate, $author$project$AuditPb$DocumentTypeExportAuthority, $author$project$AuditPb$DocumentTypeExportDeclaration, $author$project$AuditPb$DocumentTypeFreetimeNotification, $author$project$AuditPb$DocumentTypeFreightLabel, $author$project$AuditPb$DocumentTypeFumigationCertificate, $author$project$AuditPb$DocumentTypeGatePass, $author$project$AuditPb$DocumentTypeHouseAirwayBill, $author$project$AuditPb$DocumentTypeHouseOceanBillOfLading, $author$project$AuditPb$DocumentTypeIntermodalInTransitNotice, $author$project$AuditPb$DocumentTypeIsfFilingInstruction, $author$project$AuditPb$DocumentTypeLetterOfCredit, $author$project$AuditPb$DocumentTypeManifest, $author$project$AuditPb$DocumentTypeMasterAirwayBill, $author$project$AuditPb$DocumentTypeMasterOceanBillOfLading, $author$project$AuditPb$DocumentTypeMotorVehicleCertificate, $author$project$AuditPb$DocumentTypeMsds, $author$project$AuditPb$DocumentTypeNaftaCertificate, $author$project$AuditPb$DocumentTypePackingDeclaration, $author$project$AuditPb$DocumentTypePermitToTransfer, $author$project$AuditPb$DocumentTypePickupNumber, $author$project$AuditPb$DocumentTypePreAlert, $author$project$AuditPb$DocumentTypeProformaInvoice, $author$project$AuditPb$DocumentTypePurchaseOrder, $author$project$AuditPb$DocumentTypeSanitaryCertificate, $author$project$AuditPb$DocumentTypeShippersLetterOfInstruction, $author$project$AuditPb$DocumentTypeShippersSecurityDeclaration, $author$project$AuditPb$DocumentTypeSolasForm, $author$project$AuditPb$DocumentTypeTrackingStatus, $author$project$AuditPb$DocumentTypeTelexRelease, $author$project$AuditPb$DocumentTypeTruckBillOfLading, $author$project$AuditPb$DocumentTypeUsCustomsDocument, $author$project$AuditPb$DocumentTypeVeterinaryCertificate, $author$project$AuditPb$DocumentTypeVgmContainerInformation, $author$project$AuditPb$DocumentTypeWeightMeasurementReport, $author$project$AuditPb$DocumentTypePerDiemInvoice, $author$project$AuditPb$DocumentTypeWasteManifest]);
var $author$project$AuditPb$documentTypeToString = function (v) {
	switch (v.$) {
		case 'DocumentTypeInvoice':
			return 'invoice';
		case 'DocumentTypeFactorInvoice':
			return 'factorInvoice';
		case 'DocumentTypeCustomerInvoice':
			return 'customerInvoice';
		case 'DocumentTypeCarrierInvoice':
			return 'carrierInvoice';
		case 'DocumentTypeCarrierRateConfirmation':
			return 'carrierRateConfirmation';
		case 'DocumentTypeCustomerTender':
			return 'customerTender';
		case 'DocumentTypeRateConfirmation':
			return 'rateConfirmation';
		case 'DocumentTypeProofOfDelivery':
			return 'proofOfDelivery';
		case 'DocumentTypeBillOfLading':
			return 'billOfLading';
		case 'DocumentTypeHiddenBillOfLading':
			return 'hiddenBillOfLading';
		case 'DocumentTypeWeightTicket':
			return 'weightTicket';
		case 'DocumentTypeNoticeOfAssignment':
			return 'noticeOfAssignment';
		case 'DocumentTypeLaborReceipt':
			return 'laborReceipt';
		case 'DocumentTypeLegacyFactoringAssignment':
			return 'factoringAssignment';
		case 'DocumentTypeLegacyLoadTender':
			return 'loadTender';
		case 'DocumentTypeNoticeOfRelease':
			return 'noticeOfRelease';
		case 'DocumentTypeCombinedNoaLor':
			return 'noticeOfAssignmentAndRelease';
		case 'DocumentTypePackingSlip':
			return 'packingSlip';
		case 'DocumentTypeNmfcCertificate':
			return 'nmfcCertificate';
		case 'DocumentTypeCustomerDocumentsOther':
			return 'customer_other';
		case 'DocumentTypeInternalDocumentsOther':
			return 'other';
		case 'DocumentTypePostal':
			return 'postal';
		case 'DocumentTypeVoidedCheck':
			return 'voidedCheck';
		case 'DocumentTypeLetterOfAssignment':
			return 'letterOfAssignment';
		case 'DocumentTypeDeliveryOrder':
			return 'deliveryOrder';
		case 'DocumentTypeTir':
			return 'tir';
		case 'DocumentTypeFundingForm':
			return 'fundingForm';
		case 'DocumentTypeAuditSheet':
			return 'auditSheet';
		case 'DocumentTypeAdvanceRequest':
			return 'advanceRequest';
		case 'DocumentTypeDriverForm':
			return 'driverForm';
		case 'DocumentTypeEscortReceipt':
			return 'escortReceipt';
		case 'DocumentTypeFerryReceipt':
			return 'ferryReceipt';
		case 'DocumentTypeRunTicket':
			return 'runTicket';
		case 'DocumentTypeSteamingReceipt':
			return 'steamingReceipt';
		case 'DocumentTypeTollReceipt':
			return 'tollReceipt';
		case 'DocumentTypeWashReceipt':
			return 'washReceipt';
		case 'DocumentTypeExitPass':
			return 'exitPass';
		case 'DocumentTypeInsuranceCertificate':
			return 'insuranceCertificate';
		case 'DocumentTypeContract':
			return 'contract';
		case 'DocumentTypeDetentionApproval':
			return 'detentionApproval';
		case 'DocumentTypeEmailApproval':
			return 'emailApproval';
		case 'DocumentTypeLayoverApproval':
			return 'layoverApproval';
		case 'DocumentTypeLumperApproval':
			return 'lumperApproval';
		case 'DocumentTypeTonuApproval':
			return 'tonuApproval';
		case 'DocumentTypeMxBol':
			return 'mxBOL';
		case 'DocumentTypeVendorInvoice':
			return 'vendorInvoice';
		case 'DocumentTypeFine':
			return 'fine';
		case 'DocumentTypeW9':
			return 'w9';
		case 'DocumentTypeAuthority':
			return 'authority';
		case 'DocumentTypeBalanceDue':
			return 'balanceDue';
		case 'DocumentTypeClaim':
			return 'claim';
		case 'DocumentTypeCoMCHeck':
			return 'comcheck';
		case 'DocumentTypeAchSetupForm':
			return 'achSetupForm';
		case 'DocumentTypeCustomsDocument':
			return 'customsDocument';
		case 'DocumentTypeQuote':
			return 'quoteDoc';
		case 'DocumentTypeExport':
			return 'exportDoc';
		case 'DocumentTypeMasterBillOfLading':
			return 'masterBillOfLading';
		case 'DocumentTypeHouseBillOfLading':
			return 'houseBillOfLading';
		case 'DocumentTypeWaybill':
			return 'waybill';
		case 'DocumentTypeCommercialInvoice':
			return 'commercialInvoice';
		case 'DocumentTypePackingList':
			return 'packingList';
		case 'DocumentTypeCertificateOfOrigin':
			return 'certificateOfOrigin';
		case 'DocumentTypeInspectionCertificate':
			return 'inspectionCertificate';
		case 'DocumentTypePickupInspectionCertificate':
			return 'pickupInspectionCertificate';
		case 'DocumentTypeDropoffInspectionCertificate':
			return 'dropoffInspectionCertificate';
		case 'DocumentTypeWeightTicketUnloaded':
			return 'weightTicketUnloaded';
		case 'DocumentTypeUnknown':
			return 'unknown';
		case 'DocumentTypeUnknownCadenceImport':
			return 'unknownCadenceImport';
		case 'DocumentTypePalletReceipt':
			return 'palletReceipt';
		case 'DocumentTypeForm1113':
			return 'form1113';
		case 'DocumentTypeGovernmentBillOfLading':
			return 'governmentBillOfLading';
		case 'DocumentTypeInternationalBillOfLading':
			return 'internationalBillOfLading';
		case 'DocumentTypeInternalProofOfDelivery':
			return 'internalProofOfDelivery';
		case 'DocumentTypeDemurrageReceipt':
			return 'demurrageReceipt';
		case 'DocumentTypePerDiemReceipt':
			return 'perDiemReceipt';
		case 'DocumentTypeElectronicInterchangeReceipt':
			return 'electronicInterchangeReceipt';
		case 'DocumentTypeRepairItem':
			return 'repairItem';
		case 'DocumentTypePermit':
			return 'permit';
		case 'DocumentTypeAgentInvoice':
			return 'agentInvoice';
		case 'DocumentTypeArrivalNotice':
			return 'arrivalNotice';
		case 'DocumentTypeAsbestosDeclaration':
			return 'asbestosDeclaration';
		case 'DocumentTypeAusfta':
			return 'ausFta';
		case 'DocumentTypeAuthorizationRelease':
			return 'authorizationRelease';
		case 'DocumentTypeB3CanadianCustomsEntry':
			return 'b3CanadianCustomsEntry';
		case 'DocumentTypeBookingConfirmation':
			return 'bookingConfirmation';
		case 'DocumentTypeBookingRequest':
			return 'bookingRequest';
		case 'DocumentTypeCartageAdviceWithReceipt':
			return 'cartageAdviceWithReceipt';
		case 'DocumentTypeClaimNotice':
			return 'claimNotice';
		case 'DocumentTypeConsignmentSecurityDeclaration':
			return 'consignmentSecurityDeclaration';
		case 'DocumentTypeCorrectionNotice':
			return 'correctionNotice';
		case 'DocumentTypeCustomerRelease':
			return 'customerRelease';
		case 'DocumentTypeCustomsAuthority':
			return 'customsAuthority';
		case 'DocumentTypeCustomsClearanceRequest':
			return 'customsClearanceRequest';
		case 'DocumentTypeCustomsEntrySummary':
			return 'customsEntrySummary';
		case 'DocumentTypeCustomsPowerOfAttorney':
			return 'customsPowerOfAttorney';
		case 'DocumentTypeDangerousGoodsDeclaration':
			return 'dangerousGoodsDeclaration';
		case 'DocumentTypeDeclarationCertificate':
			return 'declarationCertificate';
		case 'DocumentTypeExportAuthority':
			return 'exportAuthority';
		case 'DocumentTypeExportDeclaration':
			return 'exportDeclaration';
		case 'DocumentTypeFreetimeNotification':
			return 'freetimeNotification';
		case 'DocumentTypeFreightLabel':
			return 'freightLabel';
		case 'DocumentTypeFumigationCertificate':
			return 'fumigationCertificate';
		case 'DocumentTypeGatePass':
			return 'gatePass';
		case 'DocumentTypeHouseAirwayBill':
			return 'houseAirwayBill';
		case 'DocumentTypeHouseOceanBillOfLading':
			return 'houseOceanBillOfLading';
		case 'DocumentTypeIntermodalInTransitNotice':
			return 'intermodalInTransitNotice';
		case 'DocumentTypeIsfFilingInstruction':
			return 'isfFilingInstruction';
		case 'DocumentTypeLetterOfCredit':
			return 'letterOfCredit';
		case 'DocumentTypeManifest':
			return 'manifest';
		case 'DocumentTypeMasterAirwayBill':
			return 'masterAirwayBill';
		case 'DocumentTypeMasterOceanBillOfLading':
			return 'masterOceanBillOfLading';
		case 'DocumentTypeMotorVehicleCertificate':
			return 'motorVehicleCertificate';
		case 'DocumentTypeMsds':
			return 'MSDS';
		case 'DocumentTypeNaftaCertificate':
			return 'naftaCertificate';
		case 'DocumentTypePackingDeclaration':
			return 'packingDeclaration';
		case 'DocumentTypePermitToTransfer':
			return 'permitToTransfer';
		case 'DocumentTypePickupNumber':
			return 'pickupNumber';
		case 'DocumentTypePreAlert':
			return 'preAlert';
		case 'DocumentTypeProformaInvoice':
			return 'proformaInvoice';
		case 'DocumentTypePurchaseOrder':
			return 'purchaseOrder';
		case 'DocumentTypeSanitaryCertificate':
			return 'sanitaryCertificate';
		case 'DocumentTypeShippersLetterOfInstruction':
			return 'shippersLetterOfInstruction';
		case 'DocumentTypeShippersSecurityDeclaration':
			return 'shippersSecurityDeclaration';
		case 'DocumentTypeSolasForm':
			return 'solasForm';
		case 'DocumentTypeTrackingStatus':
			return 'trackingStatus';
		case 'DocumentTypeTelexRelease':
			return 'telexRelease';
		case 'DocumentTypeTruckBillOfLading':
			return 'truckBillOfLading';
		case 'DocumentTypeUsCustomsDocument':
			return 'usCustomsDocument';
		case 'DocumentTypeVeterinaryCertificate':
			return 'veterinaryCertificate';
		case 'DocumentTypeVgmContainerInformation':
			return 'vgmContainerInformation';
		case 'DocumentTypeWeightMeasurementReport':
			return 'weightMeasurementReport';
		case 'DocumentTypePerDiemInvoice':
			return 'perDiemInvoice';
		default:
			return 'wasteManifest';
	}
};
var $author$project$AuditPb$documentTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$documentTypeToString(v),
				v);
		},
		$author$project$AuditPb$allDocumentType));
var $author$project$AuditPb$documentTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$documentTypeDict);
};
var $author$project$AuditPb$DocumentTypePartialPartiallySpecifiedAirway = {$: 'DocumentTypePartialPartiallySpecifiedAirway'};
var $author$project$AuditPb$DocumentTypePartialPartiallySpecifiedBillOfLading = {$: 'DocumentTypePartialPartiallySpecifiedBillOfLading'};
var $author$project$AuditPb$DocumentTypePartialPartiallySpecifiedOcean = {$: 'DocumentTypePartialPartiallySpecifiedOcean'};
var $author$project$AuditPb$allDocumentTypePartial = _List_fromArray(
	[$author$project$AuditPb$DocumentTypePartialPartiallySpecifiedOcean, $author$project$AuditPb$DocumentTypePartialPartiallySpecifiedAirway, $author$project$AuditPb$DocumentTypePartialPartiallySpecifiedBillOfLading]);
var $author$project$AuditPb$documentTypePartialToString = function (v) {
	switch (v.$) {
		case 'DocumentTypePartialPartiallySpecifiedOcean':
			return '__partial__OceanBillOfLading';
		case 'DocumentTypePartialPartiallySpecifiedAirway':
			return '__partial__AirwayBillOfLading';
		default:
			return '__partial__BillOfLading';
	}
};
var $author$project$AuditPb$documentTypePartialDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$documentTypePartialToString(v),
				v);
		},
		$author$project$AuditPb$allDocumentTypePartial));
var $author$project$AuditPb$documentTypePartialFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$documentTypePartialDict);
};
var $author$project$Domain$UnresolvedDocumentType$deserialize = function (documentTypeString) {
	var _v0 = $author$project$AuditPb$documentTypeFromString(documentTypeString);
	if (_v0.$ === 'Just') {
		var resolvedDocumentType = _v0.a;
		return $author$project$Domain$UnresolvedDocumentType$Resolved(resolvedDocumentType);
	} else {
		var _v1 = $author$project$AuditPb$documentTypePartialFromString(documentTypeString);
		if (_v1.$ === 'Just') {
			var partialDocumentType = _v1.a;
			return $author$project$Domain$UnresolvedDocumentType$Partial(partialDocumentType);
		} else {
			return $author$project$Domain$UnresolvedDocumentType$Unknown;
		}
	}
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Domain$UnresolvedDocumentType$decode = A2(
	$elm$json$Json$Decode$map,
	function (maybeString) {
		if (maybeString.$ === 'Nothing') {
			return $author$project$Domain$UnresolvedDocumentType$Unknown;
		} else {
			var documentTypeString = maybeString.a;
			return $author$project$Domain$UnresolvedDocumentType$deserialize(documentTypeString);
		}
	},
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Domain$Feature$AlwaysOff = {$: 'AlwaysOff'};
var $author$project$Domain$Feature$AlwaysOn = {$: 'AlwaysOn'};
var $author$project$Domain$Feature$Default = {$: 'Default'};
var $author$project$Domain$Feature$FeatureForFactorClient = F5(
	function (id, label, enabledForAccount, canOverrideForClient, overrideForClient) {
		return {canOverrideForClient: canOverrideForClient, enabledForAccount: enabledForAccount, id: id, label: label, overrideForClient: overrideForClient};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Domain$Feature$decodeFeatureForFactorClient = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Domain$Feature$FeatureForFactorClient,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'label', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'enabled', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'can_override_for_client', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$field,
		'client_override',
		A2(
			$elm$json$Json$Decode$map,
			function (maybeBool) {
				if (maybeBool.$ === 'Nothing') {
					return $author$project$Domain$Feature$Default;
				} else {
					if (maybeBool.a) {
						return $author$project$Domain$Feature$AlwaysOn;
					} else {
						return $author$project$Domain$Feature$AlwaysOff;
					}
				}
			},
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))));
var $author$project$Domain$ExternalLogin$ExternalLogin = F3(
	function (id, customerId, scrapingServices) {
		return {customerId: customerId, id: id, scrapingServices: scrapingServices};
	});
var $author$project$Domain$ExternalLoginId$ExternalLoginId = function (a) {
	return {$: 'ExternalLoginId', a: a};
};
var $author$project$Domain$ExternalLoginId$fromInt = $author$project$Domain$ExternalLoginId$ExternalLoginId;
var $author$project$Domain$TmsCustomerId$TmsCustomerId = function (a) {
	return {$: 'TmsCustomerId', a: a};
};
var $author$project$Domain$TmsCustomerId$fromInt = function (_int) {
	return $author$project$Domain$TmsCustomerId$TmsCustomerId(_int);
};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs = {$: 'ScrapingServiceScrAPINgServiceDocs'};
var $author$project$AuditPb$scrapingServiceDefault = $author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs;
var $author$project$AuditPb$ScrapingServiceScrAPINgServiceInvoices = {$: 'ScrapingServiceScrAPINgServiceInvoices'};
var $author$project$AuditPb$allScrapingService = _List_fromArray(
	[$author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs, $author$project$AuditPb$ScrapingServiceScrAPINgServiceInvoices]);
var $author$project$AuditPb$scrapingServiceToString = function (v) {
	if (v.$ === 'ScrapingServiceScrAPINgServiceDocs') {
		return 'service_scraping_docs';
	} else {
		return 'service_scraping_invoice';
	}
};
var $author$project$AuditPb$scrapingServiceDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$scrapingServiceToString(v),
				v);
		},
		$author$project$AuditPb$allScrapingService));
var $author$project$AuditPb$scrapingServiceFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$scrapingServiceDict);
};
var $author$project$AuditPb$scrapingServiceDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$scrapingServiceDefault),
		$author$project$AuditPb$scrapingServiceFromString),
	$elm$json$Json$Decode$string);
var $author$project$Domain$ExternalLogin$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Domain$ExternalLogin$ExternalLogin,
	A2(
		$elm$json$Json$Decode$field,
		'id',
		A2($elm$json$Json$Decode$map, $author$project$Domain$ExternalLoginId$fromInt, $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'tms_customer_id',
		$elm$json$Json$Decode$nullable(
			A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $elm$json$Json$Decode$int))),
	A2(
		$elm$json$Json$Decode$field,
		'scraping_services',
		$elm$json$Json$Decode$list($author$project$AuditPb$scrapingServiceDecoder)));
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (_v0.$ === 'Just') {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \u0022' + (str + '\u0022'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0.a;
			var _v1 = parse(s0);
			if (_v1.$ === 'Good') {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (step.$ === 'Loop') {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
			});
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (step.$ === 'Loop') {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (_v0.$ === 'Just') {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \u0022' + (str + '\u0022'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 'ExpectingSymbol', a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \u0022' + ($elm$core$String$fromInt(month) + '\u0022'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 'Err') {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$AuditPb$ImplicitInvoice = F2(
	function (overrideEnabled, allowImplicitInvoice) {
		return {allowImplicitInvoice: allowImplicitInvoice, overrideEnabled: overrideEnabled};
	});
var $author$project$AuditPb$implicitInvoiceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'allow_implicit_invoice',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'override_enabled',
				$elm$json$Json$Decode$bool,
				$author$project$AuditPb$decode($author$project$AuditPb$ImplicitInvoice)));
	});
var $author$project$AuditPb$scraperAuthRequirementDefault = $author$project$AuditPb$ScraperAuthRequirementNone;
var $author$project$AuditPb$ScraperAuthRequirementToken = {$: 'ScraperAuthRequirementToken'};
var $author$project$AuditPb$ScraperAuthRequirementUsernamePassword = {$: 'ScraperAuthRequirementUsernamePassword'};
var $author$project$AuditPb$ScraperAuthRequirementUsernamePasswordAndToken = {$: 'ScraperAuthRequirementUsernamePasswordAndToken'};
var $author$project$AuditPb$allScraperAuthRequirement = _List_fromArray(
	[$author$project$AuditPb$ScraperAuthRequirementNone, $author$project$AuditPb$ScraperAuthRequirementToken, $author$project$AuditPb$ScraperAuthRequirementUsernamePassword, $author$project$AuditPb$ScraperAuthRequirementUsernamePasswordAndToken]);
var $author$project$AuditPb$scraperAuthRequirementToString = function (v) {
	switch (v.$) {
		case 'ScraperAuthRequirementNone':
			return 'none';
		case 'ScraperAuthRequirementToken':
			return 'auth_requirement_token';
		case 'ScraperAuthRequirementUsernamePassword':
			return 'auth_requirement_username_password';
		default:
			return 'auth_requirement_username_password_and_token';
	}
};
var $author$project$AuditPb$scraperAuthRequirementDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$scraperAuthRequirementToString(v),
				v);
		},
		$author$project$AuditPb$allScraperAuthRequirement));
var $author$project$AuditPb$scraperAuthRequirementFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$scraperAuthRequirementDict);
};
var $author$project$AuditPb$scraperAuthRequirementDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$scraperAuthRequirementDefault),
		$author$project$AuditPb$scraperAuthRequirementFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$ToleranceUnitDollars = {$: 'ToleranceUnitDollars'};
var $author$project$AuditPb$toleranceUnitDefault = $author$project$AuditPb$ToleranceUnitDollars;
var $author$project$AuditPb$ToleranceUnitPercentage = {$: 'ToleranceUnitPercentage'};
var $author$project$AuditPb$allToleranceUnit = _List_fromArray(
	[$author$project$AuditPb$ToleranceUnitDollars, $author$project$AuditPb$ToleranceUnitPercentage]);
var $author$project$AuditPb$toleranceUnitToString = function (v) {
	if (v.$ === 'ToleranceUnitDollars') {
		return 'absolute';
	} else {
		return 'percent';
	}
};
var $author$project$AuditPb$toleranceUnitDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$toleranceUnitToString(v),
				v);
		},
		$author$project$AuditPb$allToleranceUnit));
var $author$project$AuditPb$toleranceUnitFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$toleranceUnitDict);
};
var $author$project$AuditPb$toleranceUnitDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$toleranceUnitDefault),
		$author$project$AuditPb$toleranceUnitFromString),
	$elm$json$Json$Decode$string);
var $author$project$Domain$TmsCarrier$unknownCarrier = {
	acctExec: $elm$core$Maybe$Nothing,
	address: {addressLine1: $elm$core$Maybe$Nothing, addressLine2: $elm$core$Maybe$Nothing, city: $elm$core$Maybe$Nothing, country: $elm$core$Maybe$Nothing, id: $elm$core$Maybe$Nothing, name: 'Unknown Carrier', postalCode: $elm$core$Maybe$Nothing, state: $elm$core$Maybe$Nothing},
	attemptToAutoProcessDocumentBatches: false,
	autoGenerateFactorInvoiceNumbers: $elm$core$Maybe$Nothing,
	cadenceVerificationInstructions: $elm$core$Maybe$Nothing,
	city: $elm$core$Maybe$Nothing,
	contacts: _List_Nil,
	country: $elm$core$Maybe$Nothing,
	createdAt: $elm$time$Time$millisToPosix(0),
	creditRating: $elm$core$Maybe$Nothing,
	documentTypesRetrieved: _List_Nil,
	dotNumber: $elm$core$Maybe$Nothing,
	effectiveDaysToPay: 0,
	effectiveQuickpayDiscount: $elm$core$Maybe$Nothing,
	ein: $elm$core$Maybe$Nothing,
	excludeFromVerificationsWorkflow: false,
	externalId: $elm$core$Maybe$Nothing,
	externalLabels: $elm$core$Set$empty,
	externalLogins: _List_Nil,
	externalVendorId: $elm$core$Maybe$Nothing,
	factorClientPortalEnabled: false,
	factorInvoiceNumberStrategy: $elm$core$Maybe$Nothing,
	factorSendCustomerInvoiceToCadence: $elm$core$Maybe$Nothing,
	features: _List_Nil,
	fundingNotes: $elm$core$Maybe$Nothing,
	id: $author$project$Domain$TmsCarrierId$fromInt(0),
	implicitInvoice: {allowImplicitInvoice: false, overrideEnabled: false},
	inactiveAt: $elm$core$Maybe$Nothing,
	invoiceToleranceAmountAbove: '',
	invoiceToleranceAmountBelow: '',
	invoiceToleranceUnit: $author$project$AuditPb$ToleranceUnitDollars,
	labels: $elm$core$Set$empty,
	manualReviewPercentage: $elm$core$Maybe$Nothing,
	mcNumber: $elm$core$Maybe$Nothing,
	name: 'Unknown Carrier',
	notes: $elm$core$Maybe$Nothing,
	overrideDefaultTolerance: false,
	paymentAddress: $elm$core$Maybe$Nothing,
	paymentStrategy: 'direct',
	podRequired: false,
	portalSubmissionStrategy: $author$project$Domain$TmsCarrier$PortalOnly,
	programExternalId: $elm$core$Maybe$Nothing,
	rateConfirmationRequired: false,
	receivablesInvoiceCustomer: false,
	scac: $elm$core$Maybe$Nothing,
	scraperAvailable: false,
	scrapingDocumentsAuthRequirement: $author$project$AuditPb$ScraperAuthRequirementNone,
	scrapingEnabled: false,
	scrapingInvoiceAuthRequirement: $author$project$AuditPb$ScraperAuthRequirementNone,
	setupHelpText: $elm$core$Maybe$Nothing,
	skipAutoStamp: false,
	state: $elm$core$Maybe$Nothing,
	supportsCredentialTesting: false,
	supportsScrapingInvoice: false,
	transportationClient: false,
	updatedAt: $elm$time$Time$millisToPosix(0),
	verificationPercentage: 0.0,
	verifyPercentile: $elm$core$Maybe$Nothing,
	warnIfAmountOver: $elm$core$Maybe$Nothing,
	warning: $elm$core$Maybe$Nothing
};
var $author$project$Domain$TmsCarrier$decode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$author$project$Helpers$Json$Decode$apply,
			A2($elm$json$Json$Decode$field, 'implicit_invoice_override', $author$project$AuditPb$implicitInvoiceDecoder),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'program_external_id', $elm$json$Json$Decode$string)),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2($elm$json$Json$Decode$field, 'carrier_invoice_amount_tolerance_under', $elm$json$Json$Decode$string),
					A2(
						$author$project$Helpers$Json$Decode$apply,
						A2($elm$json$Json$Decode$field, 'carrier_invoice_amount_tolerance_over', $elm$json$Json$Decode$string),
						A2(
							$author$project$Helpers$Json$Decode$apply,
							A2($elm$json$Json$Decode$field, 'carrier_invoice_amount_tolerance_unit', $author$project$AuditPb$toleranceUnitDecoder),
							A2(
								$author$project$Helpers$Json$Decode$apply,
								A2($elm$json$Json$Decode$field, 'override_default_carrier_invoice_tolerance', $elm$json$Json$Decode$bool),
								A2(
									$author$project$Helpers$Json$Decode$apply,
									A2(
										$elm$json$Json$Decode$field,
										'auto_generate_factor_invoice_numbers',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
									A2(
										$author$project$Helpers$Json$Decode$apply,
										A2(
											$elm$json$Json$Decode$field,
											'factor_invoice_number_strategy',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
										A2(
											$author$project$Helpers$Json$Decode$apply,
											A2(
												$elm$json$Json$Decode$field,
												'manual_review_percentage',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
											A2(
												$author$project$Helpers$Json$Decode$apply,
												A2(
													$elm$json$Json$Decode$field,
													'warn_if_amount_over',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
												A2(
													$author$project$Helpers$Json$Decode$apply,
													A2(
														$elm$json$Json$Decode$field,
														'features',
														$elm$json$Json$Decode$list($author$project$Domain$Feature$decodeFeatureForFactorClient)),
													A2(
														$author$project$Helpers$Json$Decode$apply,
														A2(
															$elm$json$Json$Decode$field,
															'inactive_at',
															$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
														A2(
															$author$project$Helpers$Json$Decode$apply,
															A2($elm$json$Json$Decode$field, 'verification_percentage', $elm$json$Json$Decode$float),
															A2(
																$author$project$Helpers$Json$Decode$apply,
																A2(
																	$elm$json$Json$Decode$field,
																	'credit_rating',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
																A2(
																	$author$project$Helpers$Json$Decode$apply,
																	A2(
																		$elm$json$Json$Decode$field,
																		'verification_instructions',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
																	A2(
																		$author$project$Helpers$Json$Decode$apply,
																		$elm$json$Json$Decode$maybe(
																			A2(
																				$elm$json$Json$Decode$at,
																				_List_fromArray(
																					['settings', 'verify_percentile']),
																				$elm$json$Json$Decode$int)),
																		A2(
																			$author$project$Helpers$Json$Decode$apply,
																			$elm$json$Json$Decode$oneOf(
																				_List_fromArray(
																					[
																						A2($elm$json$Json$Decode$field, 'exclude_from_verifications_workflow?', $elm$json$Json$Decode$bool),
																						$elm$json$Json$Decode$succeed(false)
																					])),
																			A2(
																				$author$project$Helpers$Json$Decode$apply,
																				A2(
																					$elm$json$Json$Decode$field,
																					'warning',
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
																				A2(
																					$author$project$Helpers$Json$Decode$apply,
																					A2(
																						$elm$json$Json$Decode$field,
																						'notes',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
																					A2(
																						$author$project$Helpers$Json$Decode$apply,
																						A2(
																							$elm$json$Json$Decode$field,
																							'funding_notes',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
																						A2(
																							$author$project$Helpers$Json$Decode$apply,
																							A2(
																								$elm$json$Json$Decode$field,
																								'setup_help_text',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
																							A2(
																								$author$project$Helpers$Json$Decode$apply,
																								A2(
																									$elm$json$Json$Decode$field,
																									'external_logins',
																									$elm$json$Json$Decode$list($author$project$Domain$ExternalLogin$decoder)),
																								A2(
																									$author$project$Helpers$Json$Decode$apply,
																									A2(
																										$elm$json$Json$Decode$field,
																										'contacts',
																										$elm$json$Json$Decode$list($author$project$Domain$TmsCarrier$contact)),
																									A2(
																										$author$project$Helpers$Json$Decode$apply,
																										A2(
																											$elm$json$Json$Decode$field,
																											'hashed_labels',
																											$elm$json$Json$Decode$oneOf(
																												_List_fromArray(
																													[
																														A2(
																														$elm$json$Json$Decode$map,
																														$elm$core$Set$fromList,
																														$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
																														$elm$json$Json$Decode$succeed($elm$core$Set$empty)
																													]))),
																										A2(
																											$author$project$Helpers$Json$Decode$apply,
																											A2(
																												$elm$json$Json$Decode$field,
																												'hubtran_labels',
																												$elm$json$Json$Decode$oneOf(
																													_List_fromArray(
																														[
																															A2(
																															$elm$json$Json$Decode$map,
																															$elm$core$Set$fromList,
																															$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
																															$elm$json$Json$Decode$succeed($elm$core$Set$empty)
																														]))),
																											A2(
																												$author$project$Helpers$Json$Decode$apply,
																												A2($elm$json$Json$Decode$field, 'portal_submission_strategy', $author$project$Domain$TmsCarrier$portalSubmissionStrategy),
																												A2(
																													$author$project$Helpers$Json$Decode$apply,
																													A2($elm$json$Json$Decode$field, 'factor_client_portal_enabled?', $elm$json$Json$Decode$bool),
																													A2(
																														$author$project$Helpers$Json$Decode$apply,
																														$elm$json$Json$Decode$oneOf(
																															_List_fromArray(
																																[
																																	A2(
																																	$elm$json$Json$Decode$field,
																																	'document_types_retrieved',
																																	$elm$json$Json$Decode$list($author$project$Domain$UnresolvedDocumentType$decode)),
																																	$elm$json$Json$Decode$succeed(_List_Nil)
																																])),
																														A2(
																															$author$project$Helpers$Json$Decode$apply,
																															$elm$json$Json$Decode$oneOf(
																																_List_fromArray(
																																	[
																																		A2($elm$json$Json$Decode$field, 'scraping_invoice_auth_requirement', $author$project$AuditPb$scraperAuthRequirementDecoder),
																																		$elm$json$Json$Decode$succeed($author$project$AuditPb$ScraperAuthRequirementNone)
																																	])),
																															A2(
																																$author$project$Helpers$Json$Decode$apply,
																																$elm$json$Json$Decode$oneOf(
																																	_List_fromArray(
																																		[
																																			A2($elm$json$Json$Decode$field, 'scraping_documents_auth_requirement', $author$project$AuditPb$scraperAuthRequirementDecoder),
																																			$elm$json$Json$Decode$succeed($author$project$AuditPb$ScraperAuthRequirementNone)
																																		])),
																																A2(
																																	$author$project$Helpers$Json$Decode$apply,
																																	A2($elm$json$Json$Decode$field, 'supports_credential_testing?', $elm$json$Json$Decode$bool),
																																	A2(
																																		$author$project$Helpers$Json$Decode$apply,
																																		A2($elm$json$Json$Decode$field, 'supports_scraping_invoice?', $elm$json$Json$Decode$bool),
																																		A2(
																																			$author$project$Helpers$Json$Decode$apply,
																																			A2($elm$json$Json$Decode$field, 'scraping_enabled', $elm$json$Json$Decode$bool),
																																			A2(
																																				$author$project$Helpers$Json$Decode$apply,
																																				A2($elm$json$Json$Decode$field, 'scraper_available', $elm$json$Json$Decode$bool),
																																				A2(
																																					$author$project$Helpers$Json$Decode$apply,
																																					A2($elm$json$Json$Decode$field, 'transportation_client', $elm$json$Json$Decode$bool),
																																					A2(
																																						$author$project$Helpers$Json$Decode$apply,
																																						A2(
																																							$elm$json$Json$Decode$field,
																																							'factor_send_customer_invoice_to_cadence',
																																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool)),
																																						A2(
																																							$author$project$Helpers$Json$Decode$apply,
																																							A2($elm$json$Json$Decode$field, 'skip_auto_stamp', $elm$json$Json$Decode$bool),
																																							A2(
																																								$author$project$Helpers$Json$Decode$apply,
																																								A2($elm$json$Json$Decode$field, 'receivables_invoice_customer', $elm$json$Json$Decode$bool),
																																								A2(
																																									$author$project$Helpers$Json$Decode$apply,
																																									A2($elm$json$Json$Decode$field, 'pod_required', $elm$json$Json$Decode$bool),
																																									A2(
																																										$author$project$Helpers$Json$Decode$apply,
																																										A2($elm$json$Json$Decode$field, 'rate_confirmation_required', $elm$json$Json$Decode$bool),
																																										A2(
																																											$author$project$Helpers$Json$Decode$apply,
																																											A2($elm$json$Json$Decode$field, 'attempt_to_auto_process_document_batches', $elm$json$Json$Decode$bool),
																																											A2(
																																												$author$project$Helpers$Json$Decode$apply,
																																												A2($elm$json$Json$Decode$field, 'payment_strategy', $elm$json$Json$Decode$string),
																																												A2(
																																													$author$project$Helpers$Json$Decode$apply,
																																													A2(
																																														$elm$json$Json$Decode$field,
																																														'effective_quickpay_discount',
																																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float)),
																																													A2(
																																														$author$project$Helpers$Json$Decode$apply,
																																														A2($elm$json$Json$Decode$field, 'effective_days_to_pay', $elm$json$Json$Decode$int),
																																														A2(
																																															$author$project$Helpers$Json$Decode$apply,
																																															A2(
																																																$elm$json$Json$Decode$field,
																																																'payment_address',
																																																$elm$json$Json$Decode$nullable($author$project$Domain$Address$decode)),
																																															A2(
																																																$author$project$Helpers$Json$Decode$apply,
																																																$author$project$Domain$Address$decode,
																																																A2(
																																																	$author$project$Helpers$Json$Decode$apply,
																																																	A2($elm$json$Json$Decode$field, 'updated_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																																																	A2(
																																																		$author$project$Helpers$Json$Decode$apply,
																																																		A2($elm$json$Json$Decode$field, 'created_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																																																		A2(
																																																			$author$project$Helpers$Json$Decode$apply,
																																																			A2(
																																																				$elm$json$Json$Decode$field,
																																																				'country',
																																																				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																			A2(
																																																				$author$project$Helpers$Json$Decode$apply,
																																																				A2(
																																																					$elm$json$Json$Decode$field,
																																																					'state',
																																																					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																				A2(
																																																					$author$project$Helpers$Json$Decode$apply,
																																																					A2(
																																																						$elm$json$Json$Decode$field,
																																																						'city',
																																																						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																					A2(
																																																						$author$project$Helpers$Json$Decode$apply,
																																																						A2(
																																																							$elm$json$Json$Decode$field,
																																																							'external_vendor_id',
																																																							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																						A2(
																																																							$author$project$Helpers$Json$Decode$apply,
																																																							A2(
																																																								$elm$json$Json$Decode$field,
																																																								'external_id',
																																																								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																							A2(
																																																								$author$project$Helpers$Json$Decode$apply,
																																																								A2(
																																																									$elm$json$Json$Decode$field,
																																																									'ein',
																																																									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																								A2(
																																																									$author$project$Helpers$Json$Decode$apply,
																																																									A2(
																																																										$elm$json$Json$Decode$field,
																																																										'scac',
																																																										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																									A2(
																																																										$author$project$Helpers$Json$Decode$apply,
																																																										A2(
																																																											$elm$json$Json$Decode$field,
																																																											'dot_number',
																																																											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																										A2(
																																																											$author$project$Helpers$Json$Decode$apply,
																																																											A2(
																																																												$elm$json$Json$Decode$field,
																																																												'mc_number',
																																																												$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																											A2(
																																																												$author$project$Helpers$Json$Decode$apply,
																																																												A2(
																																																													$elm$json$Json$Decode$field,
																																																													'account_exec',
																																																													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
																																																												A2(
																																																													$author$project$Helpers$Json$Decode$apply,
																																																													A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
																																																													A2(
																																																														$author$project$Helpers$Json$Decode$apply,
																																																														A2(
																																																															$elm$json$Json$Decode$field,
																																																															'id',
																																																															A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $elm$json$Json$Decode$int)),
																																																														$elm$json$Json$Decode$succeed($author$project$Domain$TmsCarrier$TmsCarrier))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))),
			A2(
			$elm$json$Json$Decode$andThen,
			function (strs) {
				if (strs.b && (strs.a === '~#unloadable')) {
					return $elm$json$Json$Decode$succeed($author$project$Domain$TmsCarrier$unknownCarrier);
				} else {
					return $elm$json$Json$Decode$fail(
						'Bad response:' + A2($elm$core$String$join, ',', strs));
				}
			},
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))
		]));
var $author$project$Forward$AppSpecific$Cache$tmsCarrier = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.tmsCarrier;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{tmsCarrier: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierNode = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$tmsCarrier,
		decoder: $author$project$Domain$TmsCarrier$decode,
		entrypoint: 'tmsCarrier',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsCarrierId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier = A4(
	$author$project$Forward$Lookup$ifElseVia,
	$author$project$Forward$Lookup$identity,
	function (carrierId) {
		return !$author$project$Domain$TmsCarrierId$toInt(carrierId);
	},
	$author$project$Forward$Lookup$succeed($author$project$Domain$TmsCarrier$unknownCarrier),
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierNode);
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.carrierId;
		}
	});
var $author$project$Forward$Internal$Priority$BehindLoadingSpinner = {$: 'BehindLoadingSpinner'};
var $author$project$Forward$Internal$LookupStructure$ExposeLoadingState = function (a) {
	return {$: 'ExposeLoadingState', a: a};
};
var $author$project$Forward$Internal$Loadable$mapEffect = F2(
	function (f, _v0) {
		var original = _v0.a;
		return $author$project$Forward$Internal$Loadable$Loadable(
			{
				effects_: A2($elm$core$List$map, f, original.effects_),
				partiallyLoaded: original.partiallyLoaded,
				result: original.result
			});
	});
var $author$project$Forward$Remote$unliftMaybe = F2(
	function (f, ma) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			return $author$project$Forward$Remote$toMaybe(
				f(
					$author$project$Forward$Remote$Loaded(a)));
		}
	});
var $author$project$Forward$Internal$Loadable$mapRemote = F2(
	function (f, _v0) {
		var original = _v0.a;
		return $author$project$Forward$Internal$Loadable$Loadable(
			{
				effects_: original.effects_,
				partiallyLoaded: A2($author$project$Forward$Remote$unliftMaybe, f, original.partiallyLoaded),
				result: f(original.result)
			});
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Forward$Lookup$exposeLoadingState = function (_v0) {
	var nested = _v0.a;
	return $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: nested.decoderConfig,
			invalidate: nested.invalidate,
			load: F3(
				function (cache, requiredTimestamp, k) {
					return A2(
						$author$project$Forward$Internal$Loadable$mapEffect,
						$elm$core$Tuple$mapSecond(
							function (_v1) {
								return $author$project$Forward$Internal$Priority$BehindLoadingSpinner;
							}),
						A2(
							$author$project$Forward$Internal$Loadable$mapRemote,
							$author$project$Forward$Remote$Loaded,
							A3(nested.load, cache, requiredTimestamp, k)));
				}),
			preloadBranches: nested.preloadBranches,
			structure: $author$project$Forward$Internal$LookupStructure$ExposeLoadingState(nested.structure)
		});
};
var $author$project$Forward$Internal$LookupStructure$MapWithError = function (a) {
	return {$: 'MapWithError', a: a};
};
var $author$project$Forward$Lookup$mapWithError = F2(
	function (f, _v0) {
		var nested = _v0.a;
		var handleRemote = function (remote) {
			var _v1 = A2($author$project$Forward$Remote$map, f, remote);
			switch (_v1.$) {
				case 'Loaded':
					if (_v1.a.$ === 'Ok') {
						var z = _v1.a.a;
						return $author$project$Forward$Remote$Loaded(z);
					} else {
						var message = _v1.a.a;
						return $author$project$Forward$Remote$Error(
							$author$project$Forward$Remote$Unloadable(message));
					}
				case 'Loading':
					return $author$project$Forward$Remote$Loading;
				default:
					var error = _v1.a;
					return $author$project$Forward$Remote$Error(error);
			}
		};
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: nested.decoderConfig,
				invalidate: nested.invalidate,
				load: F3(
					function (cache, requiredTimestamp, k) {
						return A2(
							$author$project$Forward$Internal$Loadable$mapRemote,
							handleRemote,
							A3(nested.load, cache, requiredTimestamp, k));
					}),
				preloadBranches: nested.preloadBranches,
				structure: $author$project$Forward$Internal$LookupStructure$MapWithError(nested.structure)
			});
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Forward$Lookup$startFrom = F2(
	function (a, _v0) {
		var nested = _v0.a;
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: nested.decoderConfig,
				invalidate: function (_v1) {
					return nested.invalidate(a);
				},
				load: F3(
					function (cache, requiredTimestamp, _v2) {
						return A3(nested.load, cache, requiredTimestamp, a);
					}),
				preloadBranches: nested.preloadBranches,
				structure: nested.structure
			});
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$Forward$Internal$Loadable$listOfLoadablesToLoadableList = function () {
	var step = F2(
		function (_v0, acc) {
			var next = _v0.a;
			return {
				effects: A2($elm$core$List$cons, next.effects_, acc.effects),
				partiallyLoaded: A2($elm$core$List$cons, next.partiallyLoaded, acc.partiallyLoaded),
				result: A3($author$project$Forward$Remote$map2, $elm$core$List$cons, next.result, acc.result)
			};
		});
	var init = {
		effects: _List_Nil,
		partiallyLoaded: _List_Nil,
		result: $author$project$Forward$Remote$Loaded(_List_Nil)
	};
	var done = function (acc) {
		return $author$project$Forward$Internal$Loadable$Loadable(
			{
				effects_: $elm$core$List$concat(acc.effects),
				partiallyLoaded: $elm$core$Maybe$Just(
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, acc.partiallyLoaded)),
				result: acc.result
			});
	};
	return A2(
		$elm$core$Basics$composeR,
		A2($elm$core$List$foldr, step, init),
		done);
}();
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Forward$Internal$RoseDict$pasteLeaves = F2(
	function (paste, _v0) {
		var original = _v0.a;
		return $elm$core$Dict$isEmpty(original) ? paste : $author$project$Forward$Internal$RoseDict$RoseDict(
			A2(
				$elm$core$Dict$map,
				function (_v1) {
					return $author$project$Forward$Internal$RoseDict$pasteLeaves(paste);
				},
				original));
	});
var $author$project$Forward$Internal$GraphTree$pasteLeavesToBranches = $author$project$Forward$Internal$RoseDict$pasteLeaves;
var $author$project$Forward$Internal$GraphTree$pasteLeaves = F2(
	function (leaves, _v0) {
		var entrypoint = _v0.a;
		var timestamp = _v0.b;
		var branches = _v0.c;
		return _Utils_Tuple3(
			entrypoint,
			timestamp,
			A2($author$project$Forward$Internal$GraphTree$pasteLeavesToBranches, leaves, branches));
	});
var $author$project$Forward$Lookup$traverseHelper = F4(
	function (debugName, container, _v0, _v1) {
		var second = _v0.a;
		var first = _v1.a;
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: A2($elm$core$Dict$union, first.decoderConfig, second.decoderConfig),
				invalidate: first.invalidate,
				load: F3(
					function (cache, requiredTimestamp, from) {
						return A2(
							$author$project$Forward$Internal$Loadable$andThen,
							A2(
								$elm$core$Basics$composeR,
								container.map(
									A2(second.load, cache, requiredTimestamp)),
								container.containerOfLoadablesToLoadableContainer),
							A2(
								$author$project$Forward$Internal$Loadable$mapEffect,
								$elm$core$Tuple$mapFirst(
									$author$project$Forward$Internal$GraphTree$pasteLeaves(second.preloadBranches)),
								A3(first.load, cache, requiredTimestamp, from)));
					}),
				preloadBranches: A2($author$project$Forward$Internal$GraphTree$pasteLeavesToBranches, second.preloadBranches, first.preloadBranches),
				structure: A3($author$project$Forward$Internal$LookupStructure$AndThen, debugName, first.structure, second.structure)
			});
	});
var $author$project$Forward$Lookup$traverseList = A2(
	$author$project$Forward$Lookup$traverseHelper,
	'traverseList',
	{containerOfLoadablesToLoadableContainer: $author$project$Forward$Internal$Loadable$listOfLoadablesToLoadableList, map: $elm$core$List$map});
var $author$project$Forward$Lookup$startFromList = F2(
	function (list, lookup) {
		return A2(
			$author$project$Forward$Lookup$startFrom,
			list,
			A2($author$project$Forward$Lookup$traverseList, lookup, $author$project$Forward$Lookup$identity));
	});
var $author$project$Forward$Lookup$traverse = F2(
	function (_v0, _v1) {
		var second = _v0.a;
		var first = _v1.a;
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: A2($elm$core$Dict$union, first.decoderConfig, second.decoderConfig),
				invalidate: first.invalidate,
				load: F3(
					function (cache, requiredTimestamp, from) {
						return A2(
							$author$project$Forward$Internal$Loadable$andThen,
							A2(second.load, cache, requiredTimestamp),
							A2(
								$author$project$Forward$Internal$Loadable$mapEffect,
								$elm$core$Tuple$mapFirst(
									$author$project$Forward$Internal$GraphTree$pasteLeaves(second.preloadBranches)),
								A3(first.load, cache, requiredTimestamp, from)));
					}),
				preloadBranches: A2($author$project$Forward$Internal$GraphTree$pasteLeavesToBranches, second.preloadBranches, first.preloadBranches),
				structure: A3($author$project$Forward$Internal$LookupStructure$AndThen, 'traverse', first.structure, second.structure)
			});
	});
var $author$project$Components$EmailMergePage$loadData = function (model) {
	var loadEmailMessageData = A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($author$project$Components$EmailMergePage$EmailMessageData)));
	var convertMissingToError = F2(
		function (errorMessage, maybe) {
			if (maybe.$ === 'Just') {
				var emailMessage = maybe.a;
				return $elm$core$Result$Ok(emailMessage);
			} else {
				return $elm$core$Result$Err(errorMessage);
			}
		});
	var loadEmailForDocumentBatchId = A2(
		$author$project$Forward$Lookup$traverse,
		loadEmailMessageData,
		A2(
			$author$project$Forward$Lookup$mapWithError,
			convertMissingToError('DocumentBatch has no EmailMessage'),
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2)));
	var loadEmailTuple = A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(loadEmailForDocumentBatchId),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
	return A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$startFromList, model.documentBatchesToMerge, loadEmailTuple),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
			$author$project$Forward$Lookup$succeed($author$project$Components$EmailMergePage$Data)));
};
var $author$project$Components$LegacyReact$AlertArea$Alert = {$: 'Alert'};
var $author$project$Components$EmailMergePage$MergeResponse = F2(
	function (a, b) {
		return {$: 'MergeResponse', a: a, b: b};
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $truqu$elm_base64$Base64$Encode$intToBase64 = function (i) {
	switch (i) {
		case 0:
			return 'A';
		case 1:
			return 'B';
		case 2:
			return 'C';
		case 3:
			return 'D';
		case 4:
			return 'E';
		case 5:
			return 'F';
		case 6:
			return 'G';
		case 7:
			return 'H';
		case 8:
			return 'I';
		case 9:
			return 'J';
		case 10:
			return 'K';
		case 11:
			return 'L';
		case 12:
			return 'M';
		case 13:
			return 'N';
		case 14:
			return 'O';
		case 15:
			return 'P';
		case 16:
			return 'Q';
		case 17:
			return 'R';
		case 18:
			return 'S';
		case 19:
			return 'T';
		case 20:
			return 'U';
		case 21:
			return 'V';
		case 22:
			return 'W';
		case 23:
			return 'X';
		case 24:
			return 'Y';
		case 25:
			return 'Z';
		case 26:
			return 'a';
		case 27:
			return 'b';
		case 28:
			return 'c';
		case 29:
			return 'd';
		case 30:
			return 'e';
		case 31:
			return 'f';
		case 32:
			return 'g';
		case 33:
			return 'h';
		case 34:
			return 'i';
		case 35:
			return 'j';
		case 36:
			return 'k';
		case 37:
			return 'l';
		case 38:
			return 'm';
		case 39:
			return 'n';
		case 40:
			return 'o';
		case 41:
			return 'p';
		case 42:
			return 'q';
		case 43:
			return 'r';
		case 44:
			return 's';
		case 45:
			return 't';
		case 46:
			return 'u';
		case 47:
			return 'v';
		case 48:
			return 'w';
		case 49:
			return 'x';
		case 50:
			return 'y';
		case 51:
			return 'z';
		case 52:
			return '0';
		case 53:
			return '1';
		case 54:
			return '2';
		case 55:
			return '3';
		case 56:
			return '4';
		case 57:
			return '5';
		case 58:
			return '6';
		case 59:
			return '7';
		case 60:
			return '8';
		case 61:
			return '9';
		case 62:
			return '+';
		default:
			return '/';
	}
};
var $truqu$elm_base64$Base64$Encode$toBase64 = function (_int) {
	return _Utils_ap(
		$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 18)),
		_Utils_ap(
			$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 12)),
			_Utils_ap(
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 6)),
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 0)))));
};
var $truqu$elm_base64$Base64$Encode$add = F2(
	function (_char, _v0) {
		var res = _v0.a;
		var count = _v0.b;
		var acc = _v0.c;
		var current = (acc << 8) | _char;
		if (count === 2) {
			return _Utils_Tuple3(
				_Utils_ap(
					res,
					$truqu$elm_base64$Base64$Encode$toBase64(current)),
				0,
				0);
		} else {
			return _Utils_Tuple3(res, count + 1, current);
		}
	});
var $truqu$elm_base64$Base64$Encode$chomp = F2(
	function (char_, acc) {
		var _char = $elm$core$Char$toCode(char_);
		return (_char < 128) ? A2($truqu$elm_base64$Base64$Encode$add, _char, acc) : ((_char < 2048) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2($truqu$elm_base64$Base64$Encode$add, 192 | (_char >>> 6), acc)) : (((_char < 55296) || ((_char >= 57344) && (_char <= 65535))) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2($truqu$elm_base64$Base64$Encode$add, 224 | (_char >>> 12), acc))) : A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2(
					$truqu$elm_base64$Base64$Encode$add,
					128 | (63 & (_char >>> 12)),
					A2($truqu$elm_base64$Base64$Encode$add, 240 | (_char >>> 18), acc))))));
	});
var $elm$core$String$foldl = _String_foldl;
var $truqu$elm_base64$Base64$Encode$initial = _Utils_Tuple3('', 0, 0);
var $truqu$elm_base64$Base64$Encode$wrapUp = function (_v0) {
	var res = _v0.a;
	var cnt = _v0.b;
	var acc = _v0.c;
	switch (cnt) {
		case 1:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 2)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 4)) + '=='));
		case 2:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 10)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 4)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 2)) + '=')));
		default:
			return res;
	}
};
var $truqu$elm_base64$Base64$Encode$encode = function (input) {
	return $truqu$elm_base64$Base64$Encode$wrapUp(
		A3($elm$core$String$foldl, $truqu$elm_base64$Base64$Encode$chomp, $truqu$elm_base64$Base64$Encode$initial, input));
};
var $truqu$elm_base64$Base64$encode = $truqu$elm_base64$Base64$Encode$encode;
var $author$project$Domain$EmailMessageId$encode = $author$project$Id$encode;
var $author$project$Components$LegacyReact$AlertArea$init = F3(
	function (alertType, message, errorDetails) {
		return {alertType: alertType, errorDetails: errorDetails, message: message, viewingDetails: false};
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 'Nothing') {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Components$EmailMergePage$mergeErrorSupportDetails = F2(
	function (params, httpMetadata) {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'status',
						$elm$json$Json$Encode$int(httpMetadata.statusCode)),
						_Utils_Tuple2(
						'url',
						$elm$json$Json$Encode$string(httpMetadata.url)),
						_Utils_Tuple2(
						'params',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'ids',
									A2($elm$json$Json$Encode$list, $author$project$Domain$EmailMessageId$encode, params))
								]))),
						_Utils_Tuple2(
						'requestId',
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$json$Json$Encode$null,
							$elm$json$Json$Encode$string,
							A2($elm$core$Dict$get, 'x-request-id', httpMetadata.headers)))
					])));
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $author$project$Components$EmailMergePage$parseEmailUrl = function (url) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('\u005C/index-document-batches\u005C/(\u005Cd+)'));
	var _v0 = A2($elm$regex$Regex$find, regex, url);
	if (_v0.b) {
		var firstMatch = _v0.a;
		var _v1 = firstMatch.submatches;
		if (_v1.b && (_v1.a.$ === 'Just')) {
			var digitsMatch = _v1.a.a;
			var _v2 = $elm$core$String$toInt(digitsMatch);
			if (_v2.$ === 'Just') {
				var id = _v2.a;
				return $elm$core$Maybe$Just(
					$author$project$Domain$DocumentBatchId$fromInt(id));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$HubTran$InspectableEffect$pushUrl = function (url) {
	return $author$project$HubTran$InspectableEffect$PushUrl(url);
};
var $author$project$HubTran$Effect$pushUrl = function (url) {
	return $author$project$HubTran$Effect$InspectableEffect(
		$author$project$HubTran$InspectableEffect$pushUrl(url));
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 'BadBody', a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 'BadStatus', a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $elm$http$Http$NetworkError = {$: 'NetworkError'};
var $elm$http$Http$Timeout = {$: 'Timeout'};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $ianmackenzie$elm_units$Duration$inSeconds = function (_v0) {
	var numSeconds = _v0.a;
	return numSeconds;
};
var $ianmackenzie$elm_units$Duration$inMilliseconds = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) * 1000;
};
var $author$project$Forward$CacheableRequest$cacheableRequestWithErrorDataHelper = F2(
	function (request_, toMessage_) {
		var parseResponse = function (response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return $elm$core$Result$Err($elm$http$Http$Timeout);
				case 'NetworkError_':
					return $elm$core$Result$Err($elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					var body = response.b;
					if (A2(
						$elm$core$List$member,
						metadata.statusCode,
						_List_fromArray(
							[400, 409, 422]))) {
						var _v1 = A2(
							$elm$json$Json$Decode$decodeString,
							request_.errorDecoder(metadata),
							body);
						if (_v1.$ === 'Ok') {
							var errorData = _v1.a;
							return $elm$core$Result$Ok(
								$elm$core$Result$Err(errorData));
						} else {
							var decodeError = _v1.a;
							return $elm$core$Result$Err(
								$elm$http$Http$BadBody(
									$elm$json$Json$Decode$errorToString(decodeError)));
						}
					} else {
						return $elm$core$Result$Err(
							$elm$http$Http$BadStatus(metadata.statusCode));
					}
				default:
					var metadata = response.a;
					var body = response.b;
					var _v2 = request_.decoder(
						_Utils_Tuple2(metadata, body));
					if (_v2.$ === 'Ok') {
						var data = _v2.a;
						return $elm$core$Result$Ok(
							$elm$core$Result$Ok(data));
					} else {
						var decodeError = _v2.a;
						return $elm$core$Result$Err(decodeError);
					}
			}
		};
		return $author$project$Forward$CacheableRequest$CacheableRequest(
			{
				body: request_.body,
				headers: request_.headers,
				method: request_.method,
				onResult: A2($elm$core$Basics$composeR, parseResponse, toMessage_),
				timeout: A2($elm$core$Maybe$map, $ianmackenzie$elm_units$Duration$inMilliseconds, request_.timeout),
				url: request_.url
			});
	});
var $author$project$Forward$CacheableRequest$requestWithIgnoredResponseBody = F2(
	function (request_, toMessage_) {
		return A2(
			$author$project$Forward$CacheableRequest$cacheableRequestWithErrorDataHelper,
			{
				body: request_.body,
				decoder: function (_v0) {
					return $elm$core$Result$Ok(_Utils_Tuple0);
				},
				errorDecoder: request_.errorDecoder,
				headers: request_.headers,
				method: request_.method,
				timeout: request_.timeout,
				url: request_.url
			},
			toMessage_);
	});
var $author$project$HubTran$Effect$sendCacheableRequest = F2(
	function (toMsg, request) {
		return $author$project$HubTran$Effect$ForwardEffect(
			$author$project$Forward$Internal$PureEffectManagerCmd$CacheableRequestCommand(
				A2($author$project$Forward$CacheableRequest$map, toMsg, request)));
	});
var $elm$core$Debug$toString = _Debug_toString;
var $author$project$Components$LegacyReact$AlertArea$update = F2(
	function (msg, model) {
		return _Utils_update(
			model,
			{viewingDetails: true});
	});
var $author$project$Components$EmailMergePage$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'ChangedUrlToAdd':
				var newString = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{urlToAdd: newString}),
					$author$project$HubTran$Effect$none);
			case 'ClickedAddUrl':
				var _v1 = $author$project$Components$EmailMergePage$parseEmailUrl(model.urlToAdd);
				if (_v1.$ === 'Just') {
					var documentBatchId = _v1.a;
					return A2($elm$core$List$member, documentBatchId, model.documentBatchesToMerge) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								addError: $elm$core$Maybe$Just('Message Already Added.')
							}),
						$author$project$HubTran$Effect$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								addError: $elm$core$Maybe$Nothing,
								documentBatchesToMerge: _Utils_ap(
									model.documentBatchesToMerge,
									_List_fromArray(
										[documentBatchId])),
								urlToAdd: ''
							}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								addError: $elm$core$Maybe$Just('Unable to find email in URL. It should look like: \u0027https://www.hubtran.com/app/index-document-batches/123...\u0027')
							}),
						$author$project$HubTran$Effect$none);
				}
			case 'ClickedRemoveEmail':
				var documentBatchId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documentBatchesToMerge: A2(
								$elm$core$List$filter,
								function (id) {
									return !_Utils_eq(id, documentBatchId);
								},
								model.documentBatchesToMerge)
						}),
					$author$project$HubTran$Effect$none);
			case 'ClickedPerformMerge':
				var emailMessageIds = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{saving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequest,
						$author$project$Components$EmailMergePage$MergeResponse(emailMessageIds),
						A2(
							$author$project$Forward$CacheableRequest$requestWithIgnoredResponseBody,
							{
								body: $elm$core$Maybe$Just(
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'ids',
												A2($elm$json$Json$Encode$list, $author$project$Domain$EmailMessageId$encode, emailMessageIds))
											]))),
								errorDecoder: function (metadata) {
									return A2(
										$elm$json$Json$Decode$map,
										$elm$core$Tuple$pair(metadata),
										A2($elm$json$Json$Decode$field, 'error_message', $elm$json$Json$Decode$string));
								},
								headers: _List_Nil,
								method: 'POST',
								timeout: $elm$core$Maybe$Nothing,
								url: '/api/email_messages/merge'
							},
							$elm$core$Basics$identity)));
			case 'MergeResponse':
				var params = msg.a;
				var response = msg.b;
				if (response.$ === 'Ok') {
					if (response.a.$ === 'Ok') {
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$pushUrl('/app/dashboard'));
					} else {
						var _v3 = response.a.a;
						var httpMetadata = _v3.a;
						var errorMessage = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									mergeError: $elm$core$Maybe$Just(
										A3(
											$author$project$Components$LegacyReact$AlertArea$init,
											$author$project$Components$LegacyReact$AlertArea$Alert,
											errorMessage,
											$elm$core$Maybe$Just(
												$truqu$elm_base64$Base64$encode(
													A2($author$project$Components$EmailMergePage$mergeErrorSupportDetails, params, httpMetadata))))),
									saving: false
								}),
							$author$project$HubTran$Effect$none);
					}
				} else {
					var err = response.a;
					var errorMessage = function () {
						switch (err.$) {
							case 'Timeout':
								return 'Unable to connect to TriumphPay Audit. Please check your network connection and try again.';
							case 'NetworkError':
								return 'Unable to connect to TriumphPay Audit. Please check your network connection and try again.';
							default:
								return 'An unexpected error occurred, please try again.';
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mergeError: $elm$core$Maybe$Just(
									A3(
										$author$project$Components$LegacyReact$AlertArea$init,
										$author$project$Components$LegacyReact$AlertArea$Alert,
										errorMessage,
										$elm$core$Maybe$Just(
											$truqu$elm_base64$Base64$encode(
												$elm$core$Debug$toString(
													{error: err, ids: params}))))),
								saving: false
							}),
						$author$project$HubTran$Effect$none);
				}
			case 'ClickedDismissMergeError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mergeError: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			default:
				var alertAreaMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mergeError: A2(
								$elm$core$Maybe$map,
								$author$project$Components$LegacyReact$AlertArea$update(alertAreaMsg),
								model.mergeError)
						}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$EmailMergePage$AlertAreaMsg = function (a) {
	return {$: 'AlertAreaMsg', a: a};
};
var $author$project$Components$EmailMergePage$ClickedDismissMergeError = {$: 'ClickedDismissMergeError'};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Components$LegacyReact$AlertArea$ClickedViewDetails = {$: 'ClickedViewDetails'};
var $author$project$Components$LegacyReact$AlertArea$alertTypeCssClass = function (alertType) {
	return $elm$html$Html$Attributes$class('alert');
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$core$Char$fromCode = _Char_fromCode;
var $author$project$Helpers$String$nbsp = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(160));
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 'Normal', a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Components$LegacyReact$AlertArea$view = F2(
	function (model, config) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert-row row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('alert-box radius'),
							$author$project$Components$LegacyReact$AlertArea$alertTypeCssClass(model.alertType)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(model.message)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Helpers$String$nbsp)
								])),
							function () {
							var _v0 = _Utils_Tuple2(model.errorDetails, model.viewingDetails);
							if (_v0.a.$ === 'Nothing') {
								var _v1 = _v0.a;
								return $elm$html$Html$text('');
							} else {
								if (!_v0.b) {
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('alert-box__support-link'),
												$elm$html$Html$Events$onClick(
												config.onAlertAreaMsg($author$project$Components$LegacyReact$AlertArea$ClickedViewDetails))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View Details.')
											]));
								} else {
									var errorDetails = _v0.a.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('alert-box__error-details')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Error Details')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Copy and paste this information into ')
															])),
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('a support ticket at')
															])),
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(' ')
															])),
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$href('https://paymentshelp.triumph.io/support/tickets/new'),
																$elm$html$Html$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('TriumphPay Support')
															])),
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(':')
															]))
													])),
												A2(
												$elm$html$Html$textarea,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$rows(12)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$String$join,
															'\u000A',
															_List_fromArray(
																['Please describe what you were doing above this line.', '----------------------------------', '', errorDetails])))
													]))
											]));
								}
							}
						}(),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('close'),
									$elm$html$Html$Events$onClick(config.onDismiss)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('x')
								]))
						]))
				]));
	});
var $author$project$Components$LegacyReact$CarrierName$viewCarrierName = function (carrier) {
	return $elm$html$Html$text(carrier.name);
};
var $author$project$Components$LegacyReact$CarrierName$view = F2(
	function (config, data) {
		return config.multiple ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Multiple ' + (config.account.carrierTerm + 's'))
				])) : A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', config.carrierNamePrefix)),
							function () {
							switch (data.$) {
								case 'Loading':
									return $elm$html$Html$text('Loading ' + (config.account.carrierTerm + ' Name...'));
								case 'Loaded':
									var carrier = data.a;
									return $author$project$Components$LegacyReact$CarrierName$viewCarrierName(carrier);
								default:
									var error = data.a;
									return $author$project$Forward$LoadingView$defaultErrorView(error);
							}
						}(),
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', config.carrierNameSuffix))
						]))
				]));
	});
var $author$project$Components$EmailMergePage$viewTableEntry = F2(
	function (label, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-1 columns')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-9 columns')
						]),
					_List_fromArray(
						[value]))
				]));
	});
var $author$project$Components$EmailMergePage$viewEmailTable = F2(
	function (account, emailMessage) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Components$EmailMergePage$viewTableEntry,
					'Subject',
					$elm$html$Html$text(emailMessage.email.subject)),
					A2(
					$author$project$Components$EmailMergePage$viewTableEntry,
					'Sender',
					$elm$html$Html$text(emailMessage.email.senderAddress)),
					A2(
					$author$project$Components$EmailMergePage$viewTableEntry,
					account.carrierTerm,
					A2(
						$author$project$Components$LegacyReact$CarrierName$view,
						{
							account: account,
							carrierNamePrefix: $elm$core$Maybe$Nothing,
							carrierNameSuffix: $elm$core$Maybe$Nothing,
							multiple: !A2($elm$core$Maybe$withDefault, false, emailMessage.email.singleCarrier)
						},
						A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Forward$Remote$Loading, $author$project$Forward$Remote$Loaded, emailMessage.carrier)))
				]));
	});
var $author$project$Components$EmailMergePage$ClickedRemoveEmail = function (a) {
	return {$: 'ClickedRemoveEmail', a: a};
};
var $author$project$Components$EmailMergePage$viewRemoveLink = function (documentBatchId) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Components$EmailMergePage$ClickedRemoveEmail(documentBatchId))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('X')
			]));
};
var $author$project$Components$EmailMergePage$viewEmailDetail = F3(
	function (account, index, _v0) {
		var documentBatchId = _v0.a;
		var data = _v0.b;
		switch (data.$) {
			case 'Loading':
				return A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Loading...')
						]));
			case 'Loaded':
				var emailData = data.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-merger__email-detail')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Message ' + $elm$core$String$fromInt(index + 1)),
									$elm$html$Html$text(' ['),
									$author$project$Components$EmailMergePage$viewRemoveLink(documentBatchId),
									$elm$html$Html$text(']')
								])),
							A2($author$project$Components$EmailMergePage$viewEmailTable, account, emailData)
						]));
			default:
				var error = data.a;
				return $author$project$Forward$LoadingView$defaultErrorView(error);
		}
	});
var $author$project$Components$EmailMergePage$viewEmail = F3(
	function (account, index, email) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 columns')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$EmailMergePage$viewEmailDetail, account, index, email)
						]))
				]));
	});
var $author$project$Components$EmailMergePage$ChangedUrlToAdd = function (a) {
	return {$: 'ChangedUrlToAdd', a: a};
};
var $author$project$Components$EmailMergePage$ClickedAddUrl = {$: 'ClickedAddUrl'};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 'MayStopPropagation', a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Components$EmailMergePage$viewError = function (model) {
	var _v0 = model.addError;
	if (_v0.$ === 'Nothing') {
		return $elm$html$Html$text('');
	} else {
		var errors = _v0.a;
		return A2(
			$elm$html$Html$small,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('error'),
					A2($elm$html$Html$Attributes$style, 'text-transform', 'none')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(errors)
				]));
	}
};
var $author$project$Components$EmailMergePage$viewNewEmailForm = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-10 large-5 columns')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Paste URL to email here'),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('row collapse')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-8 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Attributes$value(model.urlToAdd),
														$elm$html$Html$Events$onInput($author$project$Components$EmailMergePage$ChangedUrlToAdd)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick($author$project$Components$EmailMergePage$ClickedAddUrl),
														$elm$html$Html$Attributes$class('email-merger__go-button button postfix')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add')
													]))
											])),
										$author$project$Components$EmailMergePage$viewError(model)
									]))
							]))
					]))
			]));
};
var $author$project$Components$EmailMergePage$ClickedPerformMerge = function (a) {
	return {$: 'ClickedPerformMerge', a: a};
};
var $author$project$Components$LegacyReact$DisablingButton$ElmMessage = function (a) {
	return {$: 'ElmMessage', a: a};
};
var $author$project$Forward$Remote$traverseList = A2(
	$elm$core$List$foldr,
	$author$project$Forward$Remote$map2($elm$core$List$cons),
	$author$project$Forward$Remote$Loaded(_List_Nil));
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Components$LegacyReact$DisablingButton$defaultDisabledClasses = _List_fromArray(
	['button--disabled']);
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 'MayPreventDefault', a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Components$LegacyReact$DisablingButton$view = function (config) {
	var disabledClasses = A2($elm$core$Maybe$withDefault, $author$project$Components$LegacyReact$DisablingButton$defaultDisabledClasses, config.disabledClasses);
	var clickBehaviorAttribute = function () {
		var _v0 = config.onClick;
		if (_v0.$ === 'ElmMessage') {
			var msg = _v0.a;
			return A2(
				$elm$html$Html$Events$preventDefaultOn,
				'click',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(msg, true)));
		} else {
			return $elm$html$Html$Attributes$type_('submit');
		}
	}();
	var classes = config.disabled ? disabledClasses : config.enabledClasses;
	return A2(
		$elm$html$Html$button,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(config.disabled),
					clickBehaviorAttribute
				]),
			A2($elm$core$List$map, $elm$html$Html$Attributes$class, classes)),
		_List_fromArray(
			[
				$elm$html$Html$text(
				config.disabled ? config.disabledText : config.text)
			]));
};
var $author$project$Components$EmailMergePage$viewPerformButton = F2(
	function (model, data) {
		var emailMessageIds = A2(
			$author$project$Forward$Remote$map,
			$elm$core$List$map(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.email;
					},
					function ($) {
						return $.id;
					})),
			$author$project$Forward$Remote$traverseList(
				A2($elm$core$List$map, $elm$core$Tuple$second, data.emails)));
		switch (emailMessageIds.$) {
			case 'Loading':
				return $elm$html$Html$text('');
			case 'Loaded':
				var ids = emailMessageIds.a;
				return ($elm$core$List$length(ids) > 1) ? $author$project$Components$LegacyReact$DisablingButton$view(
					{
						disabled: model.saving,
						disabledClasses: $elm$core$Maybe$Nothing,
						disabledText: 'Merging...',
						enabledClasses: _List_fromArray(
							['button-confirmation']),
						onClick: $author$project$Components$LegacyReact$DisablingButton$ElmMessage(
							$author$project$Components$EmailMergePage$ClickedPerformMerge(ids)),
						text: 'Merge'
					}) : $elm$html$Html$text('');
			default:
				var error = emailMessageIds.a;
				return $author$project$Forward$LoadingView$defaultErrorView(error);
		}
	});
var $author$project$Components$EmailMergePage$viewLoaded = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row general-container reply-container')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = model.mergeError;
					if (_v0.$ === 'Just') {
						var alertAreaModel = _v0.a;
						return A2(
							$author$project$Components$LegacyReact$AlertArea$view,
							alertAreaModel,
							{onAlertAreaMsg: $author$project$Components$EmailMergePage$AlertAreaMsg, onDismiss: $author$project$Components$EmailMergePage$ClickedDismissMergeError});
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Merge Messages')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-merger__new-container')
								]),
							_List_fromArray(
								[
									$author$project$Components$EmailMergePage$viewNewEmailForm(model),
									A2($author$project$Components$EmailMergePage$viewPerformButton, model, data)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-merger__existing-container')
								]),
							A2(
								$elm$core$List$indexedMap,
								$author$project$Components$EmailMergePage$viewEmail(data.account),
								data.emails))
						]))
				]));
	});
var $author$project$Components$EmailMergePage$page = $author$project$Forward$Component$forwardComponent(
	{
		init: function (_v0) {
			return _Utils_Tuple2($author$project$Components$EmailMergePage$init, $author$project$HubTran$Effect$none);
		},
		loadData: $author$project$Components$EmailMergePage$loadData,
		update: function (_v1) {
			return $author$project$Components$EmailMergePage$update;
		},
		v3ReskinEnabled: false,
		viewLoaded: $author$project$Components$EmailMergePage$viewLoaded
	});
var $author$project$Components$ToBeScrapedLoadsPage$BackendResponseCarriers = function (a) {
	return {$: 'BackendResponseCarriers', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$BackendResponseToBeScrapedLoads = function (a) {
	return {$: 'BackendResponseToBeScrapedLoads', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$HubTran$Effect$batch = $author$project$HubTran$Effect$Batch;
var $author$project$HubTran$Effect$cmd = $author$project$HubTran$Effect$AnyCmd;
var $author$project$Components$ToBeScrapedLoadsPage$documentTypesForDownload = _List_fromArray(
	[$author$project$AuditPb$DocumentTypeBillOfLading, $author$project$AuditPb$DocumentTypeProofOfDelivery, $author$project$AuditPb$DocumentTypeInvoice, $author$project$AuditPb$DocumentTypeLetterOfAssignment, $author$project$AuditPb$DocumentTypeNmfcCertificate]);
var $timo_weike$generic_collections$ManualSet$Set = function (a) {
	return {$: 'Set', a: a};
};
var $timo_weike$generic_collections$ManualSet$empty = $timo_weike$generic_collections$ManualSet$Set($elm$core$Dict$empty);
var $author$project$Components$ToBeScrapedLoadsPage$emptyFilters = {carrier: '', customer: '', deliveredAfter: '', deliveredBefore: '', invoicedAfter: '', invoicedBefore: '', searchTerm: '', withDocuments: false, withInvoice: false};
var $timo_weike$generic_collections$ManualSet$fromList = F2(
	function (f, list) {
		var mappedList = A2(
			$elm$core$List$map,
			function (v) {
				return _Utils_Tuple2(
					f(v),
					v);
			},
			list);
		return $timo_weike$generic_collections$ManualSet$Set(
			$elm$core$Dict$fromList(mappedList));
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (result.$ === 'Ok') {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Forward$CacheableRequest$responseToBodyResult = function (response) {
	switch (response.$) {
		case 'BadUrl_':
			var url = response.a;
			return $elm$core$Result$Err(
				$elm$http$Http$BadUrl(url));
		case 'Timeout_':
			return $elm$core$Result$Err($elm$http$Http$Timeout);
		case 'NetworkError_':
			return $elm$core$Result$Err($elm$http$Http$NetworkError);
		case 'BadStatus_':
			var metadata = response.a;
			return $elm$core$Result$Err(
				$elm$http$Http$BadStatus(metadata.statusCode));
		default:
			var body = response.b;
			return $elm$core$Result$Ok(body);
	}
};
var $author$project$Forward$CacheableRequest$cacheableRequest = F2(
	function (request_, toMessage_) {
		return $author$project$Forward$CacheableRequest$CacheableRequest(
			{
				body: request_.body,
				headers: request_.headers,
				method: request_.method,
				onResult: A2(
					$elm$core$Basics$composeR,
					$author$project$Forward$CacheableRequest$responseToBodyResult,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Result$andThen(
							A2(
								$elm$core$Basics$composeR,
								$elm$json$Json$Decode$decodeString(request_.decoder),
								$elm$core$Result$mapError(
									A2($elm$core$Basics$composeR, $elm$json$Json$Decode$errorToString, $elm$http$Http$BadBody)))),
						toMessage_)),
				timeout: A2($elm$core$Maybe$map, $ianmackenzie$elm_units$Duration$inMilliseconds, request_.timeout),
				url: request_.url
			});
	});
var $author$project$Components$ToBeScrapedLoadsPage$LegacyCarrierData = F2(
	function (name, scac) {
		return {name: name, scac: scac};
	});
var $author$project$Components$ToBeScrapedLoadsPage$decodeLegacyCarrier = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2(
		$elm$json$Json$Decode$field,
		'scac',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Components$ToBeScrapedLoadsPage$LegacyCarrierData)));
var $author$project$Components$ToBeScrapedLoadsPage$loadCarriers = A2(
	$author$project$Forward$CacheableRequest$cacheableRequest,
	{
		body: $elm$core$Maybe$Nothing,
		decoder: A2(
			$elm$json$Json$Decode$field,
			'carriers',
			$elm$json$Json$Decode$list($author$project$Components$ToBeScrapedLoadsPage$decodeLegacyCarrier)),
		headers: _List_Nil,
		method: 'GET',
		timeout: $elm$core$Maybe$Nothing,
		url: '/api/to_be_scraped_loads/carriers/'
	},
	$elm$core$Basics$identity);
var $author$project$Components$ToBeScrapedLoadsPage$ToBeScrapedLoadsResponse = F3(
	function (totalPages, unmatchedReferences, loads) {
		return {loads: loads, totalPages: totalPages, unmatchedReferences: unmatchedReferences};
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 'QueryParameter', a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Helpers$Url$Builder$bool = F2(
	function (key, value) {
		var valueString = value ? 'true' : 'false';
		return A2($elm$url$Url$Builder$string, key, valueString);
	});
var $author$project$Domain$ToBeScrapedLoad$ToBeScrapedLoad = function (id) {
	return function (primaryReference) {
		return function (carrierScac) {
			return function (proNumber) {
				return function (actualDeliveredAt) {
					return function (documentBatchId) {
						return function (lastScrapedAt) {
							return function (invalidProNumberDetectedAt) {
								return function (permissionDeniedAt) {
									return function (loginFailureDetectedAt) {
										return function (lastSuccessfulLoginId) {
											return function (secondaryTrackingNumber) {
												return function (customerInvoiceNumber) {
													return function (totalAmountValue) {
														return function (totalAmountCurrency) {
															return {actualDeliveredAt: actualDeliveredAt, carrierScac: carrierScac, customerInvoiceNumber: customerInvoiceNumber, documentBatchId: documentBatchId, id: id, invalidProNumberDetectedAt: invalidProNumberDetectedAt, lastScrapedAt: lastScrapedAt, lastSuccessfulLoginId: lastSuccessfulLoginId, loginFailureDetectedAt: loginFailureDetectedAt, permissionDeniedAt: permissionDeniedAt, primaryReference: primaryReference, proNumber: proNumber, secondaryTrackingNumber: secondaryTrackingNumber, totalAmountCurrency: totalAmountCurrency, totalAmountValue: totalAmountValue};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Id$decoder = A2($elm$json$Json$Decode$map, $author$project$Id$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$DocumentBatchId$decode = $author$project$Id$decoder;
var $author$project$Domain$ExternalLoginId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$ExternalLoginId$ExternalLoginId, $elm$json$Json$Decode$int);
var $author$project$Domain$ToBeScrapedLoadId$ToBeScrapedLoadId = function (a) {
	return {$: 'ToBeScrapedLoadId', a: a};
};
var $author$project$Domain$ToBeScrapedLoadId$fromInt = function (_int) {
	return $author$project$Domain$ToBeScrapedLoadId$ToBeScrapedLoadId(_int);
};
var $author$project$Domain$ToBeScrapedLoadId$decoder = A2($elm$json$Json$Decode$map, $author$project$Domain$ToBeScrapedLoadId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$ToBeScrapedLoad$decoder = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2(
		$elm$json$Json$Decode$field,
		'total_amount_currency',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		A2(
			$elm$json$Json$Decode$field,
			'total_amount_value',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2(
				$elm$json$Json$Decode$field,
				'customer_invoice_number',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				A2(
					$elm$json$Json$Decode$field,
					'secondary_tracking_number',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2(
						$elm$json$Json$Decode$field,
						'last_successful_login_id',
						$elm$json$Json$Decode$maybe($author$project$Domain$ExternalLoginId$decode)),
					A2(
						$author$project$Helpers$Json$Decode$apply,
						A2(
							$elm$json$Json$Decode$field,
							'login_failure_detected_at',
							$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
						A2(
							$author$project$Helpers$Json$Decode$apply,
							A2(
								$elm$json$Json$Decode$field,
								'permission_denied_at',
								$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
							A2(
								$author$project$Helpers$Json$Decode$apply,
								A2(
									$elm$json$Json$Decode$field,
									'invalid_pro_number_detected_at',
									$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
								A2(
									$author$project$Helpers$Json$Decode$apply,
									A2(
										$elm$json$Json$Decode$field,
										'last_scraped_at',
										$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
									A2(
										$author$project$Helpers$Json$Decode$apply,
										A2(
											$elm$json$Json$Decode$field,
											'document_batch_id',
											$elm$json$Json$Decode$maybe($author$project$Domain$DocumentBatchId$decode)),
										A2(
											$author$project$Helpers$Json$Decode$apply,
											A2(
												$elm$json$Json$Decode$field,
												'actual_delivered_at',
												$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
											A2(
												$author$project$Helpers$Json$Decode$apply,
												A2(
													$elm$json$Json$Decode$field,
													'pro_number',
													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
												A2(
													$author$project$Helpers$Json$Decode$apply,
													A2(
														$elm$json$Json$Decode$field,
														'carrier_scac',
														$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
													A2(
														$author$project$Helpers$Json$Decode$apply,
														A2(
															$elm$json$Json$Decode$field,
															'primary_reference',
															$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
														A2(
															$author$project$Helpers$Json$Decode$apply,
															A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$ToBeScrapedLoadId$decoder),
															$elm$json$Json$Decode$succeed($author$project$Domain$ToBeScrapedLoad$ToBeScrapedLoad))))))))))))))));
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Components$ToBeScrapedLoadsPage$loadToBeScrapedLoads = F2(
	function (filters, page_) {
		return A2(
			$author$project$Forward$CacheableRequest$cacheableRequest,
			{
				body: $elm$core$Maybe$Nothing,
				decoder: A2(
					$author$project$Helpers$Json$Decode$apply,
					A2(
						$elm$json$Json$Decode$field,
						'to_be_scraped_loads',
						$elm$json$Json$Decode$list($author$project$Domain$ToBeScrapedLoad$decoder)),
					A2(
						$author$project$Helpers$Json$Decode$apply,
						A2(
							$elm$json$Json$Decode$field,
							'unmatched_references',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
						A2(
							$author$project$Helpers$Json$Decode$apply,
							A2($elm$json$Json$Decode$field, 'total_pages', $elm$json$Json$Decode$int),
							$elm$json$Json$Decode$succeed($author$project$Components$ToBeScrapedLoadsPage$ToBeScrapedLoadsResponse)))),
				headers: _List_Nil,
				method: 'GET',
				timeout: $elm$core$Maybe$Nothing,
				url: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						['api', 'to_be_scraped_loads']),
					function () {
						var encodeParamIfNotDefaultValue = F3(
							function (paramName, getField, urlBuilder) {
								return (!_Utils_eq(
									getField(filters),
									getField($author$project$Components$ToBeScrapedLoadsPage$emptyFilters))) ? $elm$core$Maybe$Just(
									A2(
										urlBuilder,
										paramName,
										getField(filters))) : $elm$core$Maybe$Nothing;
							});
						return A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A3(
									encodeParamIfNotDefaultValue,
									'search_term',
									function ($) {
										return $.searchTerm;
									},
									$elm$url$Url$Builder$string),
									A3(
									encodeParamIfNotDefaultValue,
									'carrier',
									function ($) {
										return $.carrier;
									},
									$elm$url$Url$Builder$string),
									A3(
									encodeParamIfNotDefaultValue,
									'delivered_after',
									function ($) {
										return $.deliveredAfter;
									},
									$elm$url$Url$Builder$string),
									A3(
									encodeParamIfNotDefaultValue,
									'delivered_before',
									function ($) {
										return $.deliveredBefore;
									},
									$elm$url$Url$Builder$string),
									A3(
									encodeParamIfNotDefaultValue,
									'invoiced_after',
									function ($) {
										return $.invoicedAfter;
									},
									$elm$url$Url$Builder$string),
									A3(
									encodeParamIfNotDefaultValue,
									'invoiced_before',
									function ($) {
										return $.invoicedBefore;
									},
									$elm$url$Url$Builder$string),
									A3(
									encodeParamIfNotDefaultValue,
									'with_invoice',
									function ($) {
										return $.withInvoice;
									},
									$author$project$Helpers$Url$Builder$bool),
									A3(
									encodeParamIfNotDefaultValue,
									'with_documents',
									function ($) {
										return $.withDocuments;
									},
									$author$project$Helpers$Url$Builder$bool),
									$elm$core$Maybe$Just(
									A2($elm$url$Url$Builder$int, 'page', page_))
								]));
					}())
			},
			$elm$core$Basics$identity);
	});
var $justinmimbs$timezone_data$TimeZone$NoDataForZoneName = function (a) {
	return {$: 'NoDataForZoneName', a: a};
};
var $justinmimbs$timezone_data$TimeZone$NoZoneName = {$: 'NoZoneName'};
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {clock: clock, day: day, month: month, time: time, year: year};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
	return {$: 'Rules', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 'Save', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = {$: 'WallClock'};
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {current: current, history: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {standardOffset: standardOffset, zoneRules: zoneRules};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = {$: 'Universal'};
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.start <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.offset, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m.$) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return 59 + leapDays;
			case 'Apr':
				return 90 + leapDays;
			case 'May':
				return 120 + leapDays;
			case 'Jun':
				return 151 + leapDays;
			case 'Jul':
				return 181 + leapDays;
			case 'Aug':
				return 212 + leapDays;
			case 'Sep':
				return 243 + leapDays;
			case 'Oct':
				return 273 + leapDays;
			case 'Nov':
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var save = _v0.save;
		var standard = _v0.standard;
		switch (clock.$) {
			case 'Universal':
				return 0;
			case 'Standard':
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var time = _v0.time;
	var day = _v0.day;
	var month = _v0.month;
	var year = _v0.year;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.clock, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.start;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								clock: rule.clock,
								save: rule.save,
								start: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.day;
										switch (_v2.$) {
											case 'Day':
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, day);
											case 'Next':
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, after));
											case 'Prev':
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.month));
										}
									}()) + rule.time
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.from, year) < 1) && (_Utils_cmp(year, rule.to) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.year - 1, until.year));
		var initialOffset = {save: 0, standard: standardOffset};
		var initialChange = {
			offset: standardOffset,
			start: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {save: transition.save, standard: standardOffset};
					if (_Utils_cmp(
						transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, previousOffset),
						initialChange.start) < 1) {
						var updatedInitialChange = {offset: standardOffset + transition.save, start: initialChange.start};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								offset: standardOffset + transition.save,
								start: transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset)
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var zoneRules = _v0.zoneRules;
		var standardOffset = _v0.standardOffset;
		if (zoneRules.$ === 'Save') {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						offset: standardOffset + save,
						start: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
					}
					]),
				{save: save, standard: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone.history);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.current, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone.history;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.current;
			}
		}();
		var initialOffset = {
			save: function () {
				var _v4 = initialState.zoneRules;
				if (_v4.$ === 'Save') {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			standard: initialState.standardOffset
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.offset;
			},
			initialOffset.standard + initialOffset.save,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Universal),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Universal),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.standard + initialOffset.save, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
	return {$: 'Day', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
	return {$: 'Last', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(
	function (a, b) {
		return {$: 'Next', a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
	function (from, to, month, day, time, clock, save) {
		return {clock: clock, day: day, from: from, month: month, save: save, time: time, to: to};
	});
var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__accra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__addis_ababa = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$Specification$Standard = {$: 'Standard'};
var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__algiers = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__asmara = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__bamako = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__lagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__bangui = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__banjul = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__bissau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__maputo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__blantyre = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__brazzaville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__bujumbura = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1959,
		1981,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1994,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1988,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1994,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2010,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Thu, 1),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__cairo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2018,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Mar, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Mar, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$africa__conakry = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__dakar = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__djibouti = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__douala = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Apr, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$africa__freetown = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__gaborone = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__harare = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__juba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 15, 720, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__kampala = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 15, 720, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__kigali = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__kinshasa = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__libreville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__lome = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__luanda = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__lubumbashi = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__lusaka = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__malabo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__maseru = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
var $justinmimbs$timezone_data$TimeZone$africa__mbabane = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
var $justinmimbs$timezone_data$TimeZone$africa__mogadishu = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-45,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jan, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Mar, 8, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__niamey = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__nouakchott = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__ouagadougou = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__porto_novo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Jan, 1, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jan, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$May, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Oct, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Nov, 10, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Oct, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tunis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2017,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2017,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
};
var $justinmimbs$timezone_data$TimeZone$america__adak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__anchorage = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__port_of_spain = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__anguilla = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__antigua = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2017,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2011,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2014,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2019,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__araguaina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Sep, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1969,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1993,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1992,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$May, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Sep, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$May, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jul, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jul, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jan, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 11, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__curacao = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__aruba = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2001,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2001,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2004,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2003,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2009,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2012,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__asuncion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para))));
};
var $justinmimbs$timezone_data$TimeZone$america__atikokan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__bahia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Apr, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__barbados = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
};
var $justinmimbs$timezone_data$TimeZone$america__belem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__belize = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__blanc_sablon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bogota = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
};
var $justinmimbs$timezone_data$TimeZone$america__boise = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Feb, 3, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Nov, 5, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__cancun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Aug, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Feb, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__caracas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Dec, 9, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-270,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$May, 1, 150, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayenne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__panama = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayman = $justinmimbs$timezone_data$TimeZone$america__panama;
var $justinmimbs$timezone_data$TimeZone$america__chicago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 5, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Jun,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
};
var $justinmimbs$timezone_data$TimeZone$america__creston = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__dawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Oct, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Aug, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__denver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__detroit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Apr, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__dominica = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__edmonton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Nov, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
};
var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Mar, 8, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1951,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1960,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2010,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Mar, 8, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Mar, 11, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__grenada = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__guadeloupe = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guatemala = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$america__guyana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-225,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jul, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__halifax = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1990,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1997,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2003,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2010,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__havana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
};
var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Mar, 11, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__inuvik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Apr, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__jamaica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__juneau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kralendijk = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$america__la_paz = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__lima = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
};
var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__lower_princes = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$america__maceio = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Oct, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Sep, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Jun,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Mon, 23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__managua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Feb, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
};
var $justinmimbs$timezone_data$TimeZone$america__manaus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__marigot = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__martinique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__matamoros = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__menominee = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Apr, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__merida = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Dec, 2, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Nov, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jan, 20, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__miquelon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1972,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1972,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__moncton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__monterrey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		90),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1991,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2015,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2014,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__montevideo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Mar, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Dec, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
};
var $justinmimbs$timezone_data$TimeZone$america__montserrat = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Bahamas = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1964,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1964,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__nassau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bahamas)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__new_york = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nipigon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__nome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__noronha = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Nov, 7, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Oct, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 5, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__pangnirtung = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__phoenix = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1987,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
};
var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1972,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1996,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1997,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2010,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rainy_river = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__recife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__regina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__resolute = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Mar, 11, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Nov, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santarem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santiago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Dec, 3, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__sitka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_barthelemy = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_johns = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_kitts = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_lucia = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_thomas = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_vincent = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__swift_current = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Apr, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Mon, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thule = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1950,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thunder_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__tijuana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__toronto = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__tortola = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__vancouver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2005,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__yakutat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__yellowknife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 5, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Feb, 21, 1020, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Mar, 11, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 7, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Mar, 17, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Oct, 4, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Mar, 8, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Oct, 4, 1, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 10, 1200, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Feb, 21, 1200, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1986,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1999,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo = $justinmimbs$timezone_data$TimeZone$pacific__auckland;
var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Dec, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__syowa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Feb, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__oslo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen = $justinmimbs$timezone_data$TimeZone$europe__oslo;
var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aden = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__almaty = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1988,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1998,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2002,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2012,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__amman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bahrain = $justinmimbs$timezone_data$TimeZone$asia__qatar;
var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		300,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baku = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$May, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__beirut = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		150,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		150,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Aug, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Aug, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__brunei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__chita = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2006,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__choibalsan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__colombo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$May, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						390,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 26, 30, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 15, 30, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1996,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Mon),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2011,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__damascus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dili = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$May, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dubai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 9, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1997,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Sep, 8, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, $elm$time$Time$Oct, 29, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2005,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2003,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2007,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2(
	function (a, b) {
		return {$: 'Prev', a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2012,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Fri, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__gaza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Aug, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 27, 1, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Aug, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hebron = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jun, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hovd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2006,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jun, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Nov, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 30, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Oct, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Nov, 8, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Sep, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__istanbul = $justinmimbs$timezone_data$TimeZone$europe__istanbul;
var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kabul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				270,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__karachi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Mar, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				345,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuching = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuwait = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1973,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1976,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__macau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
};
var $justinmimbs$timezone_data$TimeZone$asia__magadan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Apr, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__makassar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__manila = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
};
var $justinmimbs$timezone_data$TimeZone$asia__muscat = $justinmimbs$timezone_data$TimeZone$asia__dubai;
var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$May, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Jul, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__omsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__oral = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__phnom_penh = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Aug, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$May, 4, 1410, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Dec, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__seoul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
};
var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1991,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1991,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
};
var $justinmimbs$timezone_data$TimeZone$asia__singapore = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__taipei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2023,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2023,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2027,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2027,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2029,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2029,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2031,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2031,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2033,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2033,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2035,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2035,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2037,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2037,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tehran = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
};
var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$May, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$May, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__vientiane = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yangon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1982,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Mar, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Apr, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Sep, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Nov, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__st_helena = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2000,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		2000,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Sep, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Sep, 5, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$australia__darwin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__eucla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				525,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__hobart = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1994,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
};
var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						630,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				630,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1994,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
};
var $justinmimbs$timezone_data$TimeZone$australia__perth = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__sydney = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$europe__amsterdam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__andorra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		540,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__athens = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Nov, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__berlin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__prague = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__bratislava = $justinmimbs$timezone_data$TimeZone$europe__prague;
var $justinmimbs$timezone_data$TimeZone$europe__brussels = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__budapest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zurich = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__busingen = $justinmimbs$timezone_data$TimeZone$europe__zurich;
var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$May, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
};
var $justinmimbs$timezone_data$TimeZone$europe__copenhagen = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__dublin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
};
var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__london = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__guernsey = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__isle_of_man = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$europe__jersey = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kiev = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jul, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kirov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Sep, 26, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Mar, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ljubljana = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__luxembourg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 12),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__madrid = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1969,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1972,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1979,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1979,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1980,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__malta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__mariehamn = $justinmimbs$timezone_data$TimeZone$europe__helsinki;
var $justinmimbs$timezone_data$TimeZone$europe__minsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__monaco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__moscow = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__nicosia = $justinmimbs$timezone_data$TimeZone$asia__nicosia;
var $justinmimbs$timezone_data$TimeZone$europe__paris = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__podgorica = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__riga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Feb, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Jan, 2, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__rome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__samara = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__san_marino = $justinmimbs$timezone_data$TimeZone$europe__rome;
var $justinmimbs$timezone_data$TimeZone$europe__sarajevo = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__saratov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jul, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 27, 180, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__skopje = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1982,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 1),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__sofia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Mar, 31, 1380, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Sep, 26, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__stockholm = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__tirane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__uzhgorod = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jul, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vaduz = $justinmimbs$timezone_data$TimeZone$europe__zurich;
var $justinmimbs$timezone_data$TimeZone$europe__vatican = $justinmimbs$timezone_data$TimeZone$europe__rome;
var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__vienna = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Mar, 29, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, $elm$time$Time$Dec, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zagreb = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__zaporozhye = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$indian__antananarivo = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__chagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__christmas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__cocos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__comoro = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__kerguelen = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__mahe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__maldives = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
};
var $justinmimbs$timezone_data$TimeZone$indian__mayotte = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__reunion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 1),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__apia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Dec, 29, 1440, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Dec, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				765,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__chuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__easter = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Mar, 14, 180, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		720,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		720,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1991,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__efate = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__enderbury = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Dec, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Dec, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2000,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2013,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 21),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 18),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 12),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__funafuti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		121,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__guam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-640,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Dec, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				840,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Aug, 20, 1440, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__majuro = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__midway = $justinmimbs$timezone_data$TimeZone$pacific__pago_pago;
var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Feb, 10, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__niue = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Mar, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Oct, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Dec,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__palau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pohnpei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-630,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Nov, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__saipan = $justinmimbs$timezone_data$TimeZone$pacific__guam;
var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2002,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__wake = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__wallis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Africa/Abidjan', $justinmimbs$timezone_data$TimeZone$africa__abidjan),
			_Utils_Tuple2('Africa/Accra', $justinmimbs$timezone_data$TimeZone$africa__accra),
			_Utils_Tuple2('Africa/Addis_Ababa', $justinmimbs$timezone_data$TimeZone$africa__addis_ababa),
			_Utils_Tuple2('Africa/Algiers', $justinmimbs$timezone_data$TimeZone$africa__algiers),
			_Utils_Tuple2('Africa/Asmara', $justinmimbs$timezone_data$TimeZone$africa__asmara),
			_Utils_Tuple2('Africa/Bamako', $justinmimbs$timezone_data$TimeZone$africa__bamako),
			_Utils_Tuple2('Africa/Bangui', $justinmimbs$timezone_data$TimeZone$africa__bangui),
			_Utils_Tuple2('Africa/Banjul', $justinmimbs$timezone_data$TimeZone$africa__banjul),
			_Utils_Tuple2('Africa/Bissau', $justinmimbs$timezone_data$TimeZone$africa__bissau),
			_Utils_Tuple2('Africa/Blantyre', $justinmimbs$timezone_data$TimeZone$africa__blantyre),
			_Utils_Tuple2('Africa/Brazzaville', $justinmimbs$timezone_data$TimeZone$africa__brazzaville),
			_Utils_Tuple2('Africa/Bujumbura', $justinmimbs$timezone_data$TimeZone$africa__bujumbura),
			_Utils_Tuple2('Africa/Cairo', $justinmimbs$timezone_data$TimeZone$africa__cairo),
			_Utils_Tuple2('Africa/Casablanca', $justinmimbs$timezone_data$TimeZone$africa__casablanca),
			_Utils_Tuple2('Africa/Ceuta', $justinmimbs$timezone_data$TimeZone$africa__ceuta),
			_Utils_Tuple2('Africa/Conakry', $justinmimbs$timezone_data$TimeZone$africa__conakry),
			_Utils_Tuple2('Africa/Dakar', $justinmimbs$timezone_data$TimeZone$africa__dakar),
			_Utils_Tuple2('Africa/Dar_es_Salaam', $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam),
			_Utils_Tuple2('Africa/Djibouti', $justinmimbs$timezone_data$TimeZone$africa__djibouti),
			_Utils_Tuple2('Africa/Douala', $justinmimbs$timezone_data$TimeZone$africa__douala),
			_Utils_Tuple2('Africa/El_Aaiun', $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
			_Utils_Tuple2('Africa/Freetown', $justinmimbs$timezone_data$TimeZone$africa__freetown),
			_Utils_Tuple2('Africa/Gaborone', $justinmimbs$timezone_data$TimeZone$africa__gaborone),
			_Utils_Tuple2('Africa/Harare', $justinmimbs$timezone_data$TimeZone$africa__harare),
			_Utils_Tuple2('Africa/Johannesburg', $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
			_Utils_Tuple2('Africa/Juba', $justinmimbs$timezone_data$TimeZone$africa__juba),
			_Utils_Tuple2('Africa/Kampala', $justinmimbs$timezone_data$TimeZone$africa__kampala),
			_Utils_Tuple2('Africa/Khartoum', $justinmimbs$timezone_data$TimeZone$africa__khartoum),
			_Utils_Tuple2('Africa/Kigali', $justinmimbs$timezone_data$TimeZone$africa__kigali),
			_Utils_Tuple2('Africa/Kinshasa', $justinmimbs$timezone_data$TimeZone$africa__kinshasa),
			_Utils_Tuple2('Africa/Lagos', $justinmimbs$timezone_data$TimeZone$africa__lagos),
			_Utils_Tuple2('Africa/Libreville', $justinmimbs$timezone_data$TimeZone$africa__libreville),
			_Utils_Tuple2('Africa/Lome', $justinmimbs$timezone_data$TimeZone$africa__lome),
			_Utils_Tuple2('Africa/Luanda', $justinmimbs$timezone_data$TimeZone$africa__luanda),
			_Utils_Tuple2('Africa/Lubumbashi', $justinmimbs$timezone_data$TimeZone$africa__lubumbashi),
			_Utils_Tuple2('Africa/Lusaka', $justinmimbs$timezone_data$TimeZone$africa__lusaka),
			_Utils_Tuple2('Africa/Malabo', $justinmimbs$timezone_data$TimeZone$africa__malabo),
			_Utils_Tuple2('Africa/Maputo', $justinmimbs$timezone_data$TimeZone$africa__maputo),
			_Utils_Tuple2('Africa/Maseru', $justinmimbs$timezone_data$TimeZone$africa__maseru),
			_Utils_Tuple2('Africa/Mbabane', $justinmimbs$timezone_data$TimeZone$africa__mbabane),
			_Utils_Tuple2('Africa/Mogadishu', $justinmimbs$timezone_data$TimeZone$africa__mogadishu),
			_Utils_Tuple2('Africa/Monrovia', $justinmimbs$timezone_data$TimeZone$africa__monrovia),
			_Utils_Tuple2('Africa/Nairobi', $justinmimbs$timezone_data$TimeZone$africa__nairobi),
			_Utils_Tuple2('Africa/Ndjamena', $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
			_Utils_Tuple2('Africa/Niamey', $justinmimbs$timezone_data$TimeZone$africa__niamey),
			_Utils_Tuple2('Africa/Nouakchott', $justinmimbs$timezone_data$TimeZone$africa__nouakchott),
			_Utils_Tuple2('Africa/Ouagadougou', $justinmimbs$timezone_data$TimeZone$africa__ouagadougou),
			_Utils_Tuple2('Africa/Porto-Novo', $justinmimbs$timezone_data$TimeZone$africa__porto_novo),
			_Utils_Tuple2('Africa/Sao_Tome', $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
			_Utils_Tuple2('Africa/Tripoli', $justinmimbs$timezone_data$TimeZone$africa__tripoli),
			_Utils_Tuple2('Africa/Tunis', $justinmimbs$timezone_data$TimeZone$africa__tunis),
			_Utils_Tuple2('Africa/Windhoek', $justinmimbs$timezone_data$TimeZone$africa__windhoek),
			_Utils_Tuple2('America/Adak', $justinmimbs$timezone_data$TimeZone$america__adak),
			_Utils_Tuple2('America/Anchorage', $justinmimbs$timezone_data$TimeZone$america__anchorage),
			_Utils_Tuple2('America/Anguilla', $justinmimbs$timezone_data$TimeZone$america__anguilla),
			_Utils_Tuple2('America/Antigua', $justinmimbs$timezone_data$TimeZone$america__antigua),
			_Utils_Tuple2('America/Araguaina', $justinmimbs$timezone_data$TimeZone$america__araguaina),
			_Utils_Tuple2('America/Argentina/Buenos_Aires', $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
			_Utils_Tuple2('America/Argentina/Catamarca', $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
			_Utils_Tuple2('America/Argentina/Cordoba', $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
			_Utils_Tuple2('America/Argentina/Jujuy', $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
			_Utils_Tuple2('America/Argentina/La_Rioja', $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
			_Utils_Tuple2('America/Argentina/Mendoza', $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
			_Utils_Tuple2('America/Argentina/Rio_Gallegos', $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
			_Utils_Tuple2('America/Argentina/Salta', $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
			_Utils_Tuple2('America/Argentina/San_Juan', $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
			_Utils_Tuple2('America/Argentina/San_Luis', $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
			_Utils_Tuple2('America/Argentina/Tucuman', $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
			_Utils_Tuple2('America/Argentina/Ushuaia', $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
			_Utils_Tuple2('America/Aruba', $justinmimbs$timezone_data$TimeZone$america__aruba),
			_Utils_Tuple2('America/Asuncion', $justinmimbs$timezone_data$TimeZone$america__asuncion),
			_Utils_Tuple2('America/Atikokan', $justinmimbs$timezone_data$TimeZone$america__atikokan),
			_Utils_Tuple2('America/Bahia', $justinmimbs$timezone_data$TimeZone$america__bahia),
			_Utils_Tuple2('America/Bahia_Banderas', $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
			_Utils_Tuple2('America/Barbados', $justinmimbs$timezone_data$TimeZone$america__barbados),
			_Utils_Tuple2('America/Belem', $justinmimbs$timezone_data$TimeZone$america__belem),
			_Utils_Tuple2('America/Belize', $justinmimbs$timezone_data$TimeZone$america__belize),
			_Utils_Tuple2('America/Blanc-Sablon', $justinmimbs$timezone_data$TimeZone$america__blanc_sablon),
			_Utils_Tuple2('America/Boa_Vista', $justinmimbs$timezone_data$TimeZone$america__boa_vista),
			_Utils_Tuple2('America/Bogota', $justinmimbs$timezone_data$TimeZone$america__bogota),
			_Utils_Tuple2('America/Boise', $justinmimbs$timezone_data$TimeZone$america__boise),
			_Utils_Tuple2('America/Cambridge_Bay', $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
			_Utils_Tuple2('America/Campo_Grande', $justinmimbs$timezone_data$TimeZone$america__campo_grande),
			_Utils_Tuple2('America/Cancun', $justinmimbs$timezone_data$TimeZone$america__cancun),
			_Utils_Tuple2('America/Caracas', $justinmimbs$timezone_data$TimeZone$america__caracas),
			_Utils_Tuple2('America/Cayenne', $justinmimbs$timezone_data$TimeZone$america__cayenne),
			_Utils_Tuple2('America/Cayman', $justinmimbs$timezone_data$TimeZone$america__cayman),
			_Utils_Tuple2('America/Chicago', $justinmimbs$timezone_data$TimeZone$america__chicago),
			_Utils_Tuple2('America/Chihuahua', $justinmimbs$timezone_data$TimeZone$america__chihuahua),
			_Utils_Tuple2('America/Costa_Rica', $justinmimbs$timezone_data$TimeZone$america__costa_rica),
			_Utils_Tuple2('America/Creston', $justinmimbs$timezone_data$TimeZone$america__creston),
			_Utils_Tuple2('America/Cuiaba', $justinmimbs$timezone_data$TimeZone$america__cuiaba),
			_Utils_Tuple2('America/Curacao', $justinmimbs$timezone_data$TimeZone$america__curacao),
			_Utils_Tuple2('America/Danmarkshavn', $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
			_Utils_Tuple2('America/Dawson', $justinmimbs$timezone_data$TimeZone$america__dawson),
			_Utils_Tuple2('America/Dawson_Creek', $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
			_Utils_Tuple2('America/Denver', $justinmimbs$timezone_data$TimeZone$america__denver),
			_Utils_Tuple2('America/Detroit', $justinmimbs$timezone_data$TimeZone$america__detroit),
			_Utils_Tuple2('America/Dominica', $justinmimbs$timezone_data$TimeZone$america__dominica),
			_Utils_Tuple2('America/Edmonton', $justinmimbs$timezone_data$TimeZone$america__edmonton),
			_Utils_Tuple2('America/Eirunepe', $justinmimbs$timezone_data$TimeZone$america__eirunepe),
			_Utils_Tuple2('America/El_Salvador', $justinmimbs$timezone_data$TimeZone$america__el_salvador),
			_Utils_Tuple2('America/Fort_Nelson', $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
			_Utils_Tuple2('America/Fortaleza', $justinmimbs$timezone_data$TimeZone$america__fortaleza),
			_Utils_Tuple2('America/Glace_Bay', $justinmimbs$timezone_data$TimeZone$america__glace_bay),
			_Utils_Tuple2('America/Goose_Bay', $justinmimbs$timezone_data$TimeZone$america__goose_bay),
			_Utils_Tuple2('America/Grand_Turk', $justinmimbs$timezone_data$TimeZone$america__grand_turk),
			_Utils_Tuple2('America/Grenada', $justinmimbs$timezone_data$TimeZone$america__grenada),
			_Utils_Tuple2('America/Guadeloupe', $justinmimbs$timezone_data$TimeZone$america__guadeloupe),
			_Utils_Tuple2('America/Guatemala', $justinmimbs$timezone_data$TimeZone$america__guatemala),
			_Utils_Tuple2('America/Guayaquil', $justinmimbs$timezone_data$TimeZone$america__guayaquil),
			_Utils_Tuple2('America/Guyana', $justinmimbs$timezone_data$TimeZone$america__guyana),
			_Utils_Tuple2('America/Halifax', $justinmimbs$timezone_data$TimeZone$america__halifax),
			_Utils_Tuple2('America/Havana', $justinmimbs$timezone_data$TimeZone$america__havana),
			_Utils_Tuple2('America/Hermosillo', $justinmimbs$timezone_data$TimeZone$america__hermosillo),
			_Utils_Tuple2('America/Indiana/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
			_Utils_Tuple2('America/Indiana/Knox', $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
			_Utils_Tuple2('America/Indiana/Marengo', $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
			_Utils_Tuple2('America/Indiana/Petersburg', $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
			_Utils_Tuple2('America/Indiana/Tell_City', $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
			_Utils_Tuple2('America/Indiana/Vevay', $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
			_Utils_Tuple2('America/Indiana/Vincennes', $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
			_Utils_Tuple2('America/Indiana/Winamac', $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
			_Utils_Tuple2('America/Inuvik', $justinmimbs$timezone_data$TimeZone$america__inuvik),
			_Utils_Tuple2('America/Iqaluit', $justinmimbs$timezone_data$TimeZone$america__iqaluit),
			_Utils_Tuple2('America/Jamaica', $justinmimbs$timezone_data$TimeZone$america__jamaica),
			_Utils_Tuple2('America/Juneau', $justinmimbs$timezone_data$TimeZone$america__juneau),
			_Utils_Tuple2('America/Kentucky/Louisville', $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
			_Utils_Tuple2('America/Kentucky/Monticello', $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
			_Utils_Tuple2('America/Kralendijk', $justinmimbs$timezone_data$TimeZone$america__kralendijk),
			_Utils_Tuple2('America/La_Paz', $justinmimbs$timezone_data$TimeZone$america__la_paz),
			_Utils_Tuple2('America/Lima', $justinmimbs$timezone_data$TimeZone$america__lima),
			_Utils_Tuple2('America/Los_Angeles', $justinmimbs$timezone_data$TimeZone$america__los_angeles),
			_Utils_Tuple2('America/Lower_Princes', $justinmimbs$timezone_data$TimeZone$america__lower_princes),
			_Utils_Tuple2('America/Maceio', $justinmimbs$timezone_data$TimeZone$america__maceio),
			_Utils_Tuple2('America/Managua', $justinmimbs$timezone_data$TimeZone$america__managua),
			_Utils_Tuple2('America/Manaus', $justinmimbs$timezone_data$TimeZone$america__manaus),
			_Utils_Tuple2('America/Marigot', $justinmimbs$timezone_data$TimeZone$america__marigot),
			_Utils_Tuple2('America/Martinique', $justinmimbs$timezone_data$TimeZone$america__martinique),
			_Utils_Tuple2('America/Matamoros', $justinmimbs$timezone_data$TimeZone$america__matamoros),
			_Utils_Tuple2('America/Mazatlan', $justinmimbs$timezone_data$TimeZone$america__mazatlan),
			_Utils_Tuple2('America/Menominee', $justinmimbs$timezone_data$TimeZone$america__menominee),
			_Utils_Tuple2('America/Merida', $justinmimbs$timezone_data$TimeZone$america__merida),
			_Utils_Tuple2('America/Metlakatla', $justinmimbs$timezone_data$TimeZone$america__metlakatla),
			_Utils_Tuple2('America/Mexico_City', $justinmimbs$timezone_data$TimeZone$america__mexico_city),
			_Utils_Tuple2('America/Miquelon', $justinmimbs$timezone_data$TimeZone$america__miquelon),
			_Utils_Tuple2('America/Moncton', $justinmimbs$timezone_data$TimeZone$america__moncton),
			_Utils_Tuple2('America/Monterrey', $justinmimbs$timezone_data$TimeZone$america__monterrey),
			_Utils_Tuple2('America/Montevideo', $justinmimbs$timezone_data$TimeZone$america__montevideo),
			_Utils_Tuple2('America/Montserrat', $justinmimbs$timezone_data$TimeZone$america__montserrat),
			_Utils_Tuple2('America/Nassau', $justinmimbs$timezone_data$TimeZone$america__nassau),
			_Utils_Tuple2('America/New_York', $justinmimbs$timezone_data$TimeZone$america__new_york),
			_Utils_Tuple2('America/Nipigon', $justinmimbs$timezone_data$TimeZone$america__nipigon),
			_Utils_Tuple2('America/Nome', $justinmimbs$timezone_data$TimeZone$america__nome),
			_Utils_Tuple2('America/Noronha', $justinmimbs$timezone_data$TimeZone$america__noronha),
			_Utils_Tuple2('America/North_Dakota/Beulah', $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
			_Utils_Tuple2('America/North_Dakota/Center', $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
			_Utils_Tuple2('America/North_Dakota/New_Salem', $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
			_Utils_Tuple2('America/Nuuk', $justinmimbs$timezone_data$TimeZone$america__nuuk),
			_Utils_Tuple2('America/Ojinaga', $justinmimbs$timezone_data$TimeZone$america__ojinaga),
			_Utils_Tuple2('America/Panama', $justinmimbs$timezone_data$TimeZone$america__panama),
			_Utils_Tuple2('America/Pangnirtung', $justinmimbs$timezone_data$TimeZone$america__pangnirtung),
			_Utils_Tuple2('America/Paramaribo', $justinmimbs$timezone_data$TimeZone$america__paramaribo),
			_Utils_Tuple2('America/Phoenix', $justinmimbs$timezone_data$TimeZone$america__phoenix),
			_Utils_Tuple2('America/Port-au-Prince', $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
			_Utils_Tuple2('America/Port_of_Spain', $justinmimbs$timezone_data$TimeZone$america__port_of_spain),
			_Utils_Tuple2('America/Porto_Velho', $justinmimbs$timezone_data$TimeZone$america__porto_velho),
			_Utils_Tuple2('America/Puerto_Rico', $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
			_Utils_Tuple2('America/Punta_Arenas', $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
			_Utils_Tuple2('America/Rainy_River', $justinmimbs$timezone_data$TimeZone$america__rainy_river),
			_Utils_Tuple2('America/Rankin_Inlet', $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
			_Utils_Tuple2('America/Recife', $justinmimbs$timezone_data$TimeZone$america__recife),
			_Utils_Tuple2('America/Regina', $justinmimbs$timezone_data$TimeZone$america__regina),
			_Utils_Tuple2('America/Resolute', $justinmimbs$timezone_data$TimeZone$america__resolute),
			_Utils_Tuple2('America/Rio_Branco', $justinmimbs$timezone_data$TimeZone$america__rio_branco),
			_Utils_Tuple2('America/Santarem', $justinmimbs$timezone_data$TimeZone$america__santarem),
			_Utils_Tuple2('America/Santiago', $justinmimbs$timezone_data$TimeZone$america__santiago),
			_Utils_Tuple2('America/Santo_Domingo', $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
			_Utils_Tuple2('America/Sao_Paulo', $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
			_Utils_Tuple2('America/Scoresbysund', $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
			_Utils_Tuple2('America/Sitka', $justinmimbs$timezone_data$TimeZone$america__sitka),
			_Utils_Tuple2('America/St_Barthelemy', $justinmimbs$timezone_data$TimeZone$america__st_barthelemy),
			_Utils_Tuple2('America/St_Johns', $justinmimbs$timezone_data$TimeZone$america__st_johns),
			_Utils_Tuple2('America/St_Kitts', $justinmimbs$timezone_data$TimeZone$america__st_kitts),
			_Utils_Tuple2('America/St_Lucia', $justinmimbs$timezone_data$TimeZone$america__st_lucia),
			_Utils_Tuple2('America/St_Thomas', $justinmimbs$timezone_data$TimeZone$america__st_thomas),
			_Utils_Tuple2('America/St_Vincent', $justinmimbs$timezone_data$TimeZone$america__st_vincent),
			_Utils_Tuple2('America/Swift_Current', $justinmimbs$timezone_data$TimeZone$america__swift_current),
			_Utils_Tuple2('America/Tegucigalpa', $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
			_Utils_Tuple2('America/Thule', $justinmimbs$timezone_data$TimeZone$america__thule),
			_Utils_Tuple2('America/Thunder_Bay', $justinmimbs$timezone_data$TimeZone$america__thunder_bay),
			_Utils_Tuple2('America/Tijuana', $justinmimbs$timezone_data$TimeZone$america__tijuana),
			_Utils_Tuple2('America/Toronto', $justinmimbs$timezone_data$TimeZone$america__toronto),
			_Utils_Tuple2('America/Tortola', $justinmimbs$timezone_data$TimeZone$america__tortola),
			_Utils_Tuple2('America/Vancouver', $justinmimbs$timezone_data$TimeZone$america__vancouver),
			_Utils_Tuple2('America/Whitehorse', $justinmimbs$timezone_data$TimeZone$america__whitehorse),
			_Utils_Tuple2('America/Winnipeg', $justinmimbs$timezone_data$TimeZone$america__winnipeg),
			_Utils_Tuple2('America/Yakutat', $justinmimbs$timezone_data$TimeZone$america__yakutat),
			_Utils_Tuple2('America/Yellowknife', $justinmimbs$timezone_data$TimeZone$america__yellowknife),
			_Utils_Tuple2('Antarctica/Casey', $justinmimbs$timezone_data$TimeZone$antarctica__casey),
			_Utils_Tuple2('Antarctica/Davis', $justinmimbs$timezone_data$TimeZone$antarctica__davis),
			_Utils_Tuple2('Antarctica/DumontDUrville', $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville),
			_Utils_Tuple2('Antarctica/Macquarie', $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
			_Utils_Tuple2('Antarctica/Mawson', $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
			_Utils_Tuple2('Antarctica/McMurdo', $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo),
			_Utils_Tuple2('Antarctica/Palmer', $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
			_Utils_Tuple2('Antarctica/Rothera', $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
			_Utils_Tuple2('Antarctica/Syowa', $justinmimbs$timezone_data$TimeZone$antarctica__syowa),
			_Utils_Tuple2('Antarctica/Troll', $justinmimbs$timezone_data$TimeZone$antarctica__troll),
			_Utils_Tuple2('Antarctica/Vostok', $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
			_Utils_Tuple2('Arctic/Longyearbyen', $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen),
			_Utils_Tuple2('Asia/Aden', $justinmimbs$timezone_data$TimeZone$asia__aden),
			_Utils_Tuple2('Asia/Almaty', $justinmimbs$timezone_data$TimeZone$asia__almaty),
			_Utils_Tuple2('Asia/Amman', $justinmimbs$timezone_data$TimeZone$asia__amman),
			_Utils_Tuple2('Asia/Anadyr', $justinmimbs$timezone_data$TimeZone$asia__anadyr),
			_Utils_Tuple2('Asia/Aqtau', $justinmimbs$timezone_data$TimeZone$asia__aqtau),
			_Utils_Tuple2('Asia/Aqtobe', $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
			_Utils_Tuple2('Asia/Ashgabat', $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
			_Utils_Tuple2('Asia/Atyrau', $justinmimbs$timezone_data$TimeZone$asia__atyrau),
			_Utils_Tuple2('Asia/Baghdad', $justinmimbs$timezone_data$TimeZone$asia__baghdad),
			_Utils_Tuple2('Asia/Bahrain', $justinmimbs$timezone_data$TimeZone$asia__bahrain),
			_Utils_Tuple2('Asia/Baku', $justinmimbs$timezone_data$TimeZone$asia__baku),
			_Utils_Tuple2('Asia/Bangkok', $justinmimbs$timezone_data$TimeZone$asia__bangkok),
			_Utils_Tuple2('Asia/Barnaul', $justinmimbs$timezone_data$TimeZone$asia__barnaul),
			_Utils_Tuple2('Asia/Beirut', $justinmimbs$timezone_data$TimeZone$asia__beirut),
			_Utils_Tuple2('Asia/Bishkek', $justinmimbs$timezone_data$TimeZone$asia__bishkek),
			_Utils_Tuple2('Asia/Brunei', $justinmimbs$timezone_data$TimeZone$asia__brunei),
			_Utils_Tuple2('Asia/Chita', $justinmimbs$timezone_data$TimeZone$asia__chita),
			_Utils_Tuple2('Asia/Choibalsan', $justinmimbs$timezone_data$TimeZone$asia__choibalsan),
			_Utils_Tuple2('Asia/Colombo', $justinmimbs$timezone_data$TimeZone$asia__colombo),
			_Utils_Tuple2('Asia/Damascus', $justinmimbs$timezone_data$TimeZone$asia__damascus),
			_Utils_Tuple2('Asia/Dhaka', $justinmimbs$timezone_data$TimeZone$asia__dhaka),
			_Utils_Tuple2('Asia/Dili', $justinmimbs$timezone_data$TimeZone$asia__dili),
			_Utils_Tuple2('Asia/Dubai', $justinmimbs$timezone_data$TimeZone$asia__dubai),
			_Utils_Tuple2('Asia/Dushanbe', $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
			_Utils_Tuple2('Asia/Famagusta', $justinmimbs$timezone_data$TimeZone$asia__famagusta),
			_Utils_Tuple2('Asia/Gaza', $justinmimbs$timezone_data$TimeZone$asia__gaza),
			_Utils_Tuple2('Asia/Hebron', $justinmimbs$timezone_data$TimeZone$asia__hebron),
			_Utils_Tuple2('Asia/Ho_Chi_Minh', $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
			_Utils_Tuple2('Asia/Hong_Kong', $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
			_Utils_Tuple2('Asia/Hovd', $justinmimbs$timezone_data$TimeZone$asia__hovd),
			_Utils_Tuple2('Asia/Irkutsk', $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
			_Utils_Tuple2('Asia/Istanbul', $justinmimbs$timezone_data$TimeZone$asia__istanbul),
			_Utils_Tuple2('Asia/Jakarta', $justinmimbs$timezone_data$TimeZone$asia__jakarta),
			_Utils_Tuple2('Asia/Jayapura', $justinmimbs$timezone_data$TimeZone$asia__jayapura),
			_Utils_Tuple2('Asia/Jerusalem', $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
			_Utils_Tuple2('Asia/Kabul', $justinmimbs$timezone_data$TimeZone$asia__kabul),
			_Utils_Tuple2('Asia/Kamchatka', $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
			_Utils_Tuple2('Asia/Karachi', $justinmimbs$timezone_data$TimeZone$asia__karachi),
			_Utils_Tuple2('Asia/Kathmandu', $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
			_Utils_Tuple2('Asia/Khandyga', $justinmimbs$timezone_data$TimeZone$asia__khandyga),
			_Utils_Tuple2('Asia/Kolkata', $justinmimbs$timezone_data$TimeZone$asia__kolkata),
			_Utils_Tuple2('Asia/Krasnoyarsk', $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
			_Utils_Tuple2('Asia/Kuala_Lumpur', $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur),
			_Utils_Tuple2('Asia/Kuching', $justinmimbs$timezone_data$TimeZone$asia__kuching),
			_Utils_Tuple2('Asia/Kuwait', $justinmimbs$timezone_data$TimeZone$asia__kuwait),
			_Utils_Tuple2('Asia/Macau', $justinmimbs$timezone_data$TimeZone$asia__macau),
			_Utils_Tuple2('Asia/Magadan', $justinmimbs$timezone_data$TimeZone$asia__magadan),
			_Utils_Tuple2('Asia/Makassar', $justinmimbs$timezone_data$TimeZone$asia__makassar),
			_Utils_Tuple2('Asia/Manila', $justinmimbs$timezone_data$TimeZone$asia__manila),
			_Utils_Tuple2('Asia/Muscat', $justinmimbs$timezone_data$TimeZone$asia__muscat),
			_Utils_Tuple2('Asia/Nicosia', $justinmimbs$timezone_data$TimeZone$asia__nicosia),
			_Utils_Tuple2('Asia/Novokuznetsk', $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
			_Utils_Tuple2('Asia/Novosibirsk', $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
			_Utils_Tuple2('Asia/Omsk', $justinmimbs$timezone_data$TimeZone$asia__omsk),
			_Utils_Tuple2('Asia/Oral', $justinmimbs$timezone_data$TimeZone$asia__oral),
			_Utils_Tuple2('Asia/Phnom_Penh', $justinmimbs$timezone_data$TimeZone$asia__phnom_penh),
			_Utils_Tuple2('Asia/Pontianak', $justinmimbs$timezone_data$TimeZone$asia__pontianak),
			_Utils_Tuple2('Asia/Pyongyang', $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
			_Utils_Tuple2('Asia/Qatar', $justinmimbs$timezone_data$TimeZone$asia__qatar),
			_Utils_Tuple2('Asia/Qostanay', $justinmimbs$timezone_data$TimeZone$asia__qostanay),
			_Utils_Tuple2('Asia/Qyzylorda', $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
			_Utils_Tuple2('Asia/Riyadh', $justinmimbs$timezone_data$TimeZone$asia__riyadh),
			_Utils_Tuple2('Asia/Sakhalin', $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
			_Utils_Tuple2('Asia/Samarkand', $justinmimbs$timezone_data$TimeZone$asia__samarkand),
			_Utils_Tuple2('Asia/Seoul', $justinmimbs$timezone_data$TimeZone$asia__seoul),
			_Utils_Tuple2('Asia/Shanghai', $justinmimbs$timezone_data$TimeZone$asia__shanghai),
			_Utils_Tuple2('Asia/Singapore', $justinmimbs$timezone_data$TimeZone$asia__singapore),
			_Utils_Tuple2('Asia/Srednekolymsk', $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
			_Utils_Tuple2('Asia/Taipei', $justinmimbs$timezone_data$TimeZone$asia__taipei),
			_Utils_Tuple2('Asia/Tashkent', $justinmimbs$timezone_data$TimeZone$asia__tashkent),
			_Utils_Tuple2('Asia/Tbilisi', $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
			_Utils_Tuple2('Asia/Tehran', $justinmimbs$timezone_data$TimeZone$asia__tehran),
			_Utils_Tuple2('Asia/Thimphu', $justinmimbs$timezone_data$TimeZone$asia__thimphu),
			_Utils_Tuple2('Asia/Tokyo', $justinmimbs$timezone_data$TimeZone$asia__tokyo),
			_Utils_Tuple2('Asia/Tomsk', $justinmimbs$timezone_data$TimeZone$asia__tomsk),
			_Utils_Tuple2('Asia/Ulaanbaatar', $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
			_Utils_Tuple2('Asia/Urumqi', $justinmimbs$timezone_data$TimeZone$asia__urumqi),
			_Utils_Tuple2('Asia/Ust-Nera', $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
			_Utils_Tuple2('Asia/Vientiane', $justinmimbs$timezone_data$TimeZone$asia__vientiane),
			_Utils_Tuple2('Asia/Vladivostok', $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
			_Utils_Tuple2('Asia/Yakutsk', $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
			_Utils_Tuple2('Asia/Yangon', $justinmimbs$timezone_data$TimeZone$asia__yangon),
			_Utils_Tuple2('Asia/Yekaterinburg', $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
			_Utils_Tuple2('Asia/Yerevan', $justinmimbs$timezone_data$TimeZone$asia__yerevan),
			_Utils_Tuple2('Atlantic/Azores', $justinmimbs$timezone_data$TimeZone$atlantic__azores),
			_Utils_Tuple2('Atlantic/Bermuda', $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
			_Utils_Tuple2('Atlantic/Canary', $justinmimbs$timezone_data$TimeZone$atlantic__canary),
			_Utils_Tuple2('Atlantic/Cape_Verde', $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
			_Utils_Tuple2('Atlantic/Faroe', $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
			_Utils_Tuple2('Atlantic/Madeira', $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
			_Utils_Tuple2('Atlantic/Reykjavik', $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik),
			_Utils_Tuple2('Atlantic/South_Georgia', $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
			_Utils_Tuple2('Atlantic/St_Helena', $justinmimbs$timezone_data$TimeZone$atlantic__st_helena),
			_Utils_Tuple2('Atlantic/Stanley', $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
			_Utils_Tuple2('Australia/Adelaide', $justinmimbs$timezone_data$TimeZone$australia__adelaide),
			_Utils_Tuple2('Australia/Brisbane', $justinmimbs$timezone_data$TimeZone$australia__brisbane),
			_Utils_Tuple2('Australia/Broken_Hill', $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
			_Utils_Tuple2('Australia/Darwin', $justinmimbs$timezone_data$TimeZone$australia__darwin),
			_Utils_Tuple2('Australia/Eucla', $justinmimbs$timezone_data$TimeZone$australia__eucla),
			_Utils_Tuple2('Australia/Hobart', $justinmimbs$timezone_data$TimeZone$australia__hobart),
			_Utils_Tuple2('Australia/Lindeman', $justinmimbs$timezone_data$TimeZone$australia__lindeman),
			_Utils_Tuple2('Australia/Lord_Howe', $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
			_Utils_Tuple2('Australia/Melbourne', $justinmimbs$timezone_data$TimeZone$australia__melbourne),
			_Utils_Tuple2('Australia/Perth', $justinmimbs$timezone_data$TimeZone$australia__perth),
			_Utils_Tuple2('Australia/Sydney', $justinmimbs$timezone_data$TimeZone$australia__sydney),
			_Utils_Tuple2('Europe/Amsterdam', $justinmimbs$timezone_data$TimeZone$europe__amsterdam),
			_Utils_Tuple2('Europe/Andorra', $justinmimbs$timezone_data$TimeZone$europe__andorra),
			_Utils_Tuple2('Europe/Astrakhan', $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
			_Utils_Tuple2('Europe/Athens', $justinmimbs$timezone_data$TimeZone$europe__athens),
			_Utils_Tuple2('Europe/Belgrade', $justinmimbs$timezone_data$TimeZone$europe__belgrade),
			_Utils_Tuple2('Europe/Berlin', $justinmimbs$timezone_data$TimeZone$europe__berlin),
			_Utils_Tuple2('Europe/Bratislava', $justinmimbs$timezone_data$TimeZone$europe__bratislava),
			_Utils_Tuple2('Europe/Brussels', $justinmimbs$timezone_data$TimeZone$europe__brussels),
			_Utils_Tuple2('Europe/Bucharest', $justinmimbs$timezone_data$TimeZone$europe__bucharest),
			_Utils_Tuple2('Europe/Budapest', $justinmimbs$timezone_data$TimeZone$europe__budapest),
			_Utils_Tuple2('Europe/Busingen', $justinmimbs$timezone_data$TimeZone$europe__busingen),
			_Utils_Tuple2('Europe/Chisinau', $justinmimbs$timezone_data$TimeZone$europe__chisinau),
			_Utils_Tuple2('Europe/Copenhagen', $justinmimbs$timezone_data$TimeZone$europe__copenhagen),
			_Utils_Tuple2('Europe/Dublin', $justinmimbs$timezone_data$TimeZone$europe__dublin),
			_Utils_Tuple2('Europe/Gibraltar', $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
			_Utils_Tuple2('Europe/Guernsey', $justinmimbs$timezone_data$TimeZone$europe__guernsey),
			_Utils_Tuple2('Europe/Helsinki', $justinmimbs$timezone_data$TimeZone$europe__helsinki),
			_Utils_Tuple2('Europe/Isle_of_Man', $justinmimbs$timezone_data$TimeZone$europe__isle_of_man),
			_Utils_Tuple2('Europe/Istanbul', $justinmimbs$timezone_data$TimeZone$europe__istanbul),
			_Utils_Tuple2('Europe/Jersey', $justinmimbs$timezone_data$TimeZone$europe__jersey),
			_Utils_Tuple2('Europe/Kaliningrad', $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
			_Utils_Tuple2('Europe/Kiev', $justinmimbs$timezone_data$TimeZone$europe__kiev),
			_Utils_Tuple2('Europe/Kirov', $justinmimbs$timezone_data$TimeZone$europe__kirov),
			_Utils_Tuple2('Europe/Lisbon', $justinmimbs$timezone_data$TimeZone$europe__lisbon),
			_Utils_Tuple2('Europe/Ljubljana', $justinmimbs$timezone_data$TimeZone$europe__ljubljana),
			_Utils_Tuple2('Europe/London', $justinmimbs$timezone_data$TimeZone$europe__london),
			_Utils_Tuple2('Europe/Luxembourg', $justinmimbs$timezone_data$TimeZone$europe__luxembourg),
			_Utils_Tuple2('Europe/Madrid', $justinmimbs$timezone_data$TimeZone$europe__madrid),
			_Utils_Tuple2('Europe/Malta', $justinmimbs$timezone_data$TimeZone$europe__malta),
			_Utils_Tuple2('Europe/Mariehamn', $justinmimbs$timezone_data$TimeZone$europe__mariehamn),
			_Utils_Tuple2('Europe/Minsk', $justinmimbs$timezone_data$TimeZone$europe__minsk),
			_Utils_Tuple2('Europe/Monaco', $justinmimbs$timezone_data$TimeZone$europe__monaco),
			_Utils_Tuple2('Europe/Moscow', $justinmimbs$timezone_data$TimeZone$europe__moscow),
			_Utils_Tuple2('Europe/Nicosia', $justinmimbs$timezone_data$TimeZone$europe__nicosia),
			_Utils_Tuple2('Europe/Oslo', $justinmimbs$timezone_data$TimeZone$europe__oslo),
			_Utils_Tuple2('Europe/Paris', $justinmimbs$timezone_data$TimeZone$europe__paris),
			_Utils_Tuple2('Europe/Podgorica', $justinmimbs$timezone_data$TimeZone$europe__podgorica),
			_Utils_Tuple2('Europe/Prague', $justinmimbs$timezone_data$TimeZone$europe__prague),
			_Utils_Tuple2('Europe/Riga', $justinmimbs$timezone_data$TimeZone$europe__riga),
			_Utils_Tuple2('Europe/Rome', $justinmimbs$timezone_data$TimeZone$europe__rome),
			_Utils_Tuple2('Europe/Samara', $justinmimbs$timezone_data$TimeZone$europe__samara),
			_Utils_Tuple2('Europe/San_Marino', $justinmimbs$timezone_data$TimeZone$europe__san_marino),
			_Utils_Tuple2('Europe/Sarajevo', $justinmimbs$timezone_data$TimeZone$europe__sarajevo),
			_Utils_Tuple2('Europe/Saratov', $justinmimbs$timezone_data$TimeZone$europe__saratov),
			_Utils_Tuple2('Europe/Simferopol', $justinmimbs$timezone_data$TimeZone$europe__simferopol),
			_Utils_Tuple2('Europe/Skopje', $justinmimbs$timezone_data$TimeZone$europe__skopje),
			_Utils_Tuple2('Europe/Sofia', $justinmimbs$timezone_data$TimeZone$europe__sofia),
			_Utils_Tuple2('Europe/Stockholm', $justinmimbs$timezone_data$TimeZone$europe__stockholm),
			_Utils_Tuple2('Europe/Tallinn', $justinmimbs$timezone_data$TimeZone$europe__tallinn),
			_Utils_Tuple2('Europe/Tirane', $justinmimbs$timezone_data$TimeZone$europe__tirane),
			_Utils_Tuple2('Europe/Ulyanovsk', $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
			_Utils_Tuple2('Europe/Uzhgorod', $justinmimbs$timezone_data$TimeZone$europe__uzhgorod),
			_Utils_Tuple2('Europe/Vaduz', $justinmimbs$timezone_data$TimeZone$europe__vaduz),
			_Utils_Tuple2('Europe/Vatican', $justinmimbs$timezone_data$TimeZone$europe__vatican),
			_Utils_Tuple2('Europe/Vienna', $justinmimbs$timezone_data$TimeZone$europe__vienna),
			_Utils_Tuple2('Europe/Vilnius', $justinmimbs$timezone_data$TimeZone$europe__vilnius),
			_Utils_Tuple2('Europe/Volgograd', $justinmimbs$timezone_data$TimeZone$europe__volgograd),
			_Utils_Tuple2('Europe/Warsaw', $justinmimbs$timezone_data$TimeZone$europe__warsaw),
			_Utils_Tuple2('Europe/Zagreb', $justinmimbs$timezone_data$TimeZone$europe__zagreb),
			_Utils_Tuple2('Europe/Zaporozhye', $justinmimbs$timezone_data$TimeZone$europe__zaporozhye),
			_Utils_Tuple2('Europe/Zurich', $justinmimbs$timezone_data$TimeZone$europe__zurich),
			_Utils_Tuple2('Indian/Antananarivo', $justinmimbs$timezone_data$TimeZone$indian__antananarivo),
			_Utils_Tuple2('Indian/Chagos', $justinmimbs$timezone_data$TimeZone$indian__chagos),
			_Utils_Tuple2('Indian/Christmas', $justinmimbs$timezone_data$TimeZone$indian__christmas),
			_Utils_Tuple2('Indian/Cocos', $justinmimbs$timezone_data$TimeZone$indian__cocos),
			_Utils_Tuple2('Indian/Comoro', $justinmimbs$timezone_data$TimeZone$indian__comoro),
			_Utils_Tuple2('Indian/Kerguelen', $justinmimbs$timezone_data$TimeZone$indian__kerguelen),
			_Utils_Tuple2('Indian/Mahe', $justinmimbs$timezone_data$TimeZone$indian__mahe),
			_Utils_Tuple2('Indian/Maldives', $justinmimbs$timezone_data$TimeZone$indian__maldives),
			_Utils_Tuple2('Indian/Mauritius', $justinmimbs$timezone_data$TimeZone$indian__mauritius),
			_Utils_Tuple2('Indian/Mayotte', $justinmimbs$timezone_data$TimeZone$indian__mayotte),
			_Utils_Tuple2('Indian/Reunion', $justinmimbs$timezone_data$TimeZone$indian__reunion),
			_Utils_Tuple2('Pacific/Apia', $justinmimbs$timezone_data$TimeZone$pacific__apia),
			_Utils_Tuple2('Pacific/Auckland', $justinmimbs$timezone_data$TimeZone$pacific__auckland),
			_Utils_Tuple2('Pacific/Bougainville', $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
			_Utils_Tuple2('Pacific/Chatham', $justinmimbs$timezone_data$TimeZone$pacific__chatham),
			_Utils_Tuple2('Pacific/Chuuk', $justinmimbs$timezone_data$TimeZone$pacific__chuuk),
			_Utils_Tuple2('Pacific/Easter', $justinmimbs$timezone_data$TimeZone$pacific__easter),
			_Utils_Tuple2('Pacific/Efate', $justinmimbs$timezone_data$TimeZone$pacific__efate),
			_Utils_Tuple2('Pacific/Enderbury', $justinmimbs$timezone_data$TimeZone$pacific__enderbury),
			_Utils_Tuple2('Pacific/Fakaofo', $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
			_Utils_Tuple2('Pacific/Fiji', $justinmimbs$timezone_data$TimeZone$pacific__fiji),
			_Utils_Tuple2('Pacific/Funafuti', $justinmimbs$timezone_data$TimeZone$pacific__funafuti),
			_Utils_Tuple2('Pacific/Galapagos', $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
			_Utils_Tuple2('Pacific/Gambier', $justinmimbs$timezone_data$TimeZone$pacific__gambier),
			_Utils_Tuple2('Pacific/Guadalcanal', $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
			_Utils_Tuple2('Pacific/Guam', $justinmimbs$timezone_data$TimeZone$pacific__guam),
			_Utils_Tuple2('Pacific/Honolulu', $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
			_Utils_Tuple2('Pacific/Kiritimati', $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
			_Utils_Tuple2('Pacific/Kosrae', $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
			_Utils_Tuple2('Pacific/Kwajalein', $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
			_Utils_Tuple2('Pacific/Majuro', $justinmimbs$timezone_data$TimeZone$pacific__majuro),
			_Utils_Tuple2('Pacific/Marquesas', $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
			_Utils_Tuple2('Pacific/Midway', $justinmimbs$timezone_data$TimeZone$pacific__midway),
			_Utils_Tuple2('Pacific/Nauru', $justinmimbs$timezone_data$TimeZone$pacific__nauru),
			_Utils_Tuple2('Pacific/Niue', $justinmimbs$timezone_data$TimeZone$pacific__niue),
			_Utils_Tuple2('Pacific/Norfolk', $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
			_Utils_Tuple2('Pacific/Noumea', $justinmimbs$timezone_data$TimeZone$pacific__noumea),
			_Utils_Tuple2('Pacific/Pago_Pago', $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
			_Utils_Tuple2('Pacific/Palau', $justinmimbs$timezone_data$TimeZone$pacific__palau),
			_Utils_Tuple2('Pacific/Pitcairn', $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
			_Utils_Tuple2('Pacific/Pohnpei', $justinmimbs$timezone_data$TimeZone$pacific__pohnpei),
			_Utils_Tuple2('Pacific/Port_Moresby', $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
			_Utils_Tuple2('Pacific/Rarotonga', $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
			_Utils_Tuple2('Pacific/Saipan', $justinmimbs$timezone_data$TimeZone$pacific__saipan),
			_Utils_Tuple2('Pacific/Tahiti', $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
			_Utils_Tuple2('Pacific/Tarawa', $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
			_Utils_Tuple2('Pacific/Tongatapu', $justinmimbs$timezone_data$TimeZone$pacific__tongatapu),
			_Utils_Tuple2('Pacific/Wake', $justinmimbs$timezone_data$TimeZone$pacific__wake),
			_Utils_Tuple2('Pacific/Wallis', $justinmimbs$timezone_data$TimeZone$pacific__wallis)
		]));
var $author$project$Helpers$Date$amendedZones = A3(
	$elm$core$Dict$insert,
	'Asia/Calcutta',
	$justinmimbs$timezone_data$TimeZone$asia__kolkata,
	A3($elm$core$Dict$insert, 'America/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis, $justinmimbs$timezone_data$TimeZone$zones));
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$time$Time$Name = function (a) {
	return {$: 'Name', a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 'Offset', a: a};
};
var $elm$time$Time$getZoneName = _Time_getZoneName(_Utils_Tuple0);
var $elm$core$Task$succeed = _Scheduler_succeed;
var $author$project$Helpers$Date$getZone = A2(
	$elm$core$Task$andThen,
	function (nameOrOffset) {
		if (nameOrOffset.$ === 'Name') {
			var zoneName = nameOrOffset.a;
			var _v1 = A2($elm$core$Dict$get, zoneName, $author$project$Helpers$Date$amendedZones);
			if (_v1.$ === 'Just') {
				var zone = _v1.a;
				return $elm$core$Task$succeed(
					_Utils_Tuple2(
						zoneName,
						zone(_Utils_Tuple0)));
			} else {
				return $elm$core$Task$fail(
					$justinmimbs$timezone_data$TimeZone$NoDataForZoneName(zoneName));
			}
		} else {
			return $elm$core$Task$fail($justinmimbs$timezone_data$TimeZone$NoZoneName);
		}
	},
	$elm$time$Time$getZoneName);
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $author$project$Helpers$Date$localTimezone = A2(
	$elm$core$Task$onError,
	function (_v0) {
		return $elm$core$Task$succeed($elm$time$Time$utc);
	},
	A2($elm$core$Task$map, $elm$core$Tuple$second, $author$project$Helpers$Date$getZone));
var $elm$core$Task$Perform = function (a) {
	return {$: 'Perform', a: a};
};
var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0.a;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(_Utils_Tuple0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0.a;
		return $elm$core$Task$Perform(
			A2($elm$core$Task$map, tagger, task));
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2($elm$core$Task$map, toMessage, task)));
	});
var $author$project$Components$ToBeScrapedLoadsPage$init = function (params) {
	var filters = {
		carrier: A2($elm$core$Maybe$withDefault, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.carrier, params.carrier),
		customer: $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.customer,
		deliveredAfter: A2($elm$core$Maybe$withDefault, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.deliveredAfter, params.deliveredAfter),
		deliveredBefore: A2($elm$core$Maybe$withDefault, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.deliveredBefore, params.deliveredBefore),
		invoicedAfter: A2($elm$core$Maybe$withDefault, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.invoicedAfter, params.invoicedAfter),
		invoicedBefore: A2($elm$core$Maybe$withDefault, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.invoicedBefore, params.invoicedBefore),
		searchTerm: A2($elm$core$Maybe$withDefault, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.searchTerm, params.searchTerm),
		withDocuments: A2($elm$core$Maybe$withDefault, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.withDocuments, params.withDocuments),
		withInvoice: A2($elm$core$Maybe$withDefault, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters.withInvoice, params.withInvoice)
	};
	var currentPage = A2($elm$core$Maybe$withDefault, 1, params.page);
	return _Utils_Tuple2(
		{
			activeFilters: filters,
			currentPage: currentPage,
			filtersUiState: filters,
			legacyDataCarriers: $author$project$Forward$Remote$Loading,
			legacyDataLoads: $author$project$Forward$Remote$Loading,
			selectedDocumentTypes: A2($timo_weike$generic_collections$ManualSet$fromList, $author$project$AuditPb$documentTypeToString, $author$project$Components$ToBeScrapedLoadsPage$documentTypesForDownload),
			selectedLoads: $timo_weike$generic_collections$ManualSet$empty,
			tz: $elm$time$Time$utc
		},
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$cmd(
					A2($elm$core$Task$perform, $author$project$Components$ToBeScrapedLoadsPage$SetTimezone, $author$project$Helpers$Date$localTimezone)),
					A2($author$project$HubTran$Effect$sendCacheableRequest, $author$project$Components$ToBeScrapedLoadsPage$BackendResponseCarriers, $author$project$Components$ToBeScrapedLoadsPage$loadCarriers),
					A2(
					$author$project$HubTran$Effect$sendCacheableRequest,
					$author$project$Components$ToBeScrapedLoadsPage$BackendResponseToBeScrapedLoads,
					A2($author$project$Components$ToBeScrapedLoadsPage$loadToBeScrapedLoads, filters, currentPage))
				])));
};
var $author$project$Components$ToBeScrapedLoadsPage$Data = F3(
	function (account, accountSettings, documentBatchesByLoadId) {
		return {account: account, accountSettings: accountSettings, documentBatchesByLoadId: documentBatchesByLoadId};
	});
var $author$project$Components$ToBeScrapedLoadsPage$DocumentBatchData = F2(
	function (documentBatch, documents) {
		return {documentBatch: documentBatch, documents: documents};
	});
var $author$project$Forward$AppSpecific$Cache$accountSettings = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.accountSettings;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{accountSettings: e});
		}));
var $author$project$AuditPb$AccountSettings = function (invoiceDateStrategy) {
	return function (autoGenerateFactorInvoiceNumberStrategy) {
		return function (autoGenerateFactorInvoiceNumbers) {
			return function (carrierInvoiceAmountToleranceOver) {
				return function (carrierInvoiceAmountToleranceUnder) {
					return function (carrierInvoiceAmountToleranceUnit) {
						return function (carrierInvoiceAmountToleranceLineItemTypeId) {
							return function (tmsLineItemTypes) {
								return function (carrierDaysToPay) {
									return function (quickpayDiscount) {
										return function (quickpayDiscountDisabled) {
											return function (visibleTMSReferenceFieldLabels) {
												return function (annotationAutoStampDocumentType) {
													return function (brokerCustomerPortalEnabled) {
														return function (defaultEmailPerInvoice) {
															return function (verificationsEnabled) {
																return function (customExceptionSubjectTemplate) {
																	return function (customInvoiceExceptionMessages) {
																		return function (payablesTemplateVariables) {
																			return function (limitReportsToAdmin) {
																				return function (labels) {
																					return function (possibleCarrierLabels) {
																						return function (categories) {
																							return function (autoApprovePayables) {
																								return function (selfServeAutoApproveSetting) {
																									return function (useSubmissionWorkflow) {
																										return function (useBothSubmissionAndTraditionalWorkflow) {
																											return function (displayAutomatedVerificationsOnSubmissionWorkflow) {
																												return function (disableOutgoingEmailsInSubmissionWorkflow) {
																													return function (usesOfficePeopleMap) {
																														return function (useLoadCustomerLabels) {
																															return function (checkClientOrDebtorOnBol) {
																																return function (manuallyCheckAmountMatchesRateCon) {
																																	return function (manuallyCheckPickupDropoffMatches) {
																																		return function (manuallyCheckThirdPartyListedOnBol) {
																																			return function (factorUseSourceInvoiceDate) {
																																				return function (showInvoiceDateInputInSubmissionWorkflow) {
																																					return function (showGroupMovementButtonsInSubmissionWorkflow) {
																																						return function (allowManualSubmissionReassignmentInSubmissionWorkflow) {
																																							return function (loadCustomerLabels) {
																																								return function (failedCadenceTransmissionRecipients) {
																																									return function (validSourceDateRange) {
																																										return function (showCadenceDebtorInfo) {
																																											return function (considerNoaDataForVerifications) {
																																												return function (allowEditingCarrierPaymentStrategy) {
																																													return function (carrierDaysToPayIntegration) {
																																														return function (attemptToAutoProcessDocumentBatches) {
																																															return function (ableToGenerateCustomerInvoices) {
																																																return function (carrierDocumentsAccount) {
																																																	return function (factorClientPortalEnabled) {
																																																		return function (factorUseLabelsOnProcessed) {
																																																			return function (useCadenceImageTypes) {
																																																				return function (verificationsWorkflowEnabled) {
																																																					return function (verificationsDebtorConfirmationEnabled) {
																																																						return function (verificationsWorkflowUseCadenceNotes) {
																																																							return function (verificationsWorkflowSendRejectedInvoicesToTMS) {
																																																								return function (verificationsWorkflowEnableCarrierPercentileCheck) {
																																																									return function (verificationsWorkflowDebtorBatchItemCustomStates) {
																																																										return function (verificationsWorkflowEmailCcRecipients) {
																																																											return function (verificationsWorkflowDisplayName) {
																																																												return function (reviewTabEnabled) {
																																																													return function (reviewTabVerifyModeEnabled) {
																																																														return function (rulesBrokerRequiredReferences) {
																																																															return function (controlledByTMS) {
																																																																return function (featureFlags) {
																																																																	return function (podRequirementPolicy) {
																																																																		return function (rulesBrokerCustomExceptionMessages) {
																																																																			return function (displayCadenceFundingNotes) {
																																																																				return function (clientNotesSidebarDisplay) {
																																																																					return function (clientNotesConfiguration) {
																																																																						return function (allowCustomExceptions) {
																																																																							return function (loadReferenceVariables) {
																																																																								return function (shipmentReferenceVariables) {
																																																																									return function (nonInvoiceLoadDocumentTypes) {
																																																																										return function (showCarrierExternalVendorId) {
																																																																											return function (processorSupportEmailAddress) {
																																																																												return function (enablePODInSubmissionWorkflow) {
																																																																													return function (showCadenceVerificationInstructions) {
																																																																														return function (showClientVerificationPercentagesOnReviewTab) {
																																																																															return function (perPageOnDashboard) {
																																																																																return function (lineItemVisibility) {
																																																																																	return function (useTriumphPayCarrierRemitTo) {
																																																																																		return function (paymentsNetworkEnabled) {
																																																																																			return function (indexAuditSplitEnabled) {
																																																																																				return function (featureEnableProcessedQueueFlowMode) {
																																																																																					return function (ignoreMode) {
																																																																																						return function (documentAnnotationEnabled) {
																																																																																							return function (annotationStampUrl) {
																																																																																								return function (annotationStampWidth) {
																																																																																									return function (annotationStampHeight) {
																																																																																										return function (featureEnableNonInvoiceFlow) {
																																																																																											return function (showDateReceivedOnExceptionAndWaiting) {
																																																																																												return function (showDateDeliveredOnQueues) {
																																																																																													return function (auditBillingEnabled) {
																																																																																														return function (customerDisplayRequiresExternalId) {
																																																																																															return function (customDocumentTypeNames) {
																																																																																																return function (factorAutoSendInvoices) {
																																																																																																	return function (showCategorizedLabels) {
																																																																																																		return function (apiRateConfirmationRequired) {
																																																																																																			return function (customerRepresentativeViewEnabled) {
																																																																																																				return function (disableReorderTMSReferenceFields) {
																																																																																																					return function (savedFilterEnhancementsEnabled) {
																																																																																																						return function (documentsViewerDoctypeGroupingEnabled) {
																																																																																																							return function (ltlReconcileEnabled) {
																																																																																																								return function (showDateTimeFilters) {
																																																																																																									return function (ltlInvoiceAvailableTMSQueues) {
																																																																																																										return function (ltlRerateEnabled) {
																																																																																																											return function (ltlReweighChargeExceptionsEnabled) {
																																																																																																												return function (ltlAccessorialUpdateEnabled) {
																																																																																																													return function (ltlLoadsReportEnabled) {
																																																																																																														return function (auditV3ReskinEnabledSettings) {
																																																																																																															return function (auditV3ReskinEnabledTopLevel) {
																																																																																																																return function (auditV3ReskinEnabledQueues) {
																																																																																																																	return function (auditV3ReactStyleOverrides) {
																																																																																																																		return function (factorNextGenAuditEnabled) {
																																																																																																																			return function (useFactorInvoiceWorkflowPage) {
																																																																																																																				return function (warnIfAmountOver) {
																																																																																																																					return function (auditorDocumentUploadEnabled) {
																																																																																																																						return function (manualReviewPercentage) {
																																																																																																																							return function (ltlHoldEdiImportDays) {
																																																																																																																								return function (showAllLoadDocsEnabled) {
																																																																																																																									return function (scraperStatusEnabled) {
																																																																																																																										return function (ltlTolerancesEnabled) {
																																																																																																																											return function (ltlCarrierInvoiceAmountToleranceOver) {
																																																																																																																												return function (ltlCarrierInvoiceAmountToleranceUnder) {
																																																																																																																													return function (ltlCarrierInvoiceAmountToleranceUnit) {
																																																																																																																														return function (multipleCustomExceptionTemplates) {
																																																																																																																															return function (ltlReconcilePageMismatchTableEnabled) {
																																																																																																																																return function (ltlRerateBlockedForHazardousMaterial) {
																																																																																																																																	return function (runNoDocumentsHaveDamagesOrRatesRule) {
																																																																																																																																		return function (runNoDocumentsHaveCarrierRatesRule) {
																																																																																																																																			return function (ltlCustomerMarginToleranceEnabled) {
																																																																																																																																				return function (ltlDefaultMarginToleranceUnit) {
																																																																																																																																					return function (ltlDefaultMarginToleranceMinimum) {
																																																																																																																																						return function (ltlDefaultMarginToleranceMaximum) {
																																																																																																																																							return function (displayCustomerMarginInHeader) {
																																																																																																																																								return function (ngaRules) {
																																																																																																																																									return function (requireLoadStatus) {
																																																																																																																																										return function (displayReferenceInHeader) {
																																																																																																																																											return function (loadDisplayReferenceLabel) {
																																																																																																																																												return function (loadDisplayReferenceKey) {
																																																																																																																																													return function (allowReadonlyFactorUserSelection) {
																																																																																																																																														return function (documentTypeForTruckPhotos) {
																																																																																																																																															return function (carrierToleranceEnabledModes) {
																																																																																																																																																return function (canUnapproveInvoices) {
																																																																																																																																																	return function (noaManagementEnabled) {
																																																																																																																																																		return function (sendMissingDocumentsEmailsEnabled) {
																																																																																																																																																			return function (sendMissingDocumentsEmailDelayInHours) {
																																																																																																																																																				return function (factorVerificationExceptionTypes) {
																																																																																																																																																					return function (enablePerRelationshipAutoprocessingOverrides) {
																																																																																																																																																						return function (factorBrokerLoadIdRegressionRuleMode) {
																																																																																																																																																							return function (laneRateExceptionsMode) {
																																																																																																																																																								return function (invoiceAmountHistoryRuleMode) {
																																																																																																																																																									return function (allowImplicitCarrierInvoice) {
																																																																																																																																																										return function (tempAllowCarrierLevelImplicitInvoice) {
																																																																																																																																																											return function (podRequiresBolValidation) {
																																																																																																																																																												return function (podDefinitionModuleEnabled) {
																																																																																																																																																													return function (podInferenceCheckTypes) {
																																																																																																																																																														return function (useElmDocumentGrouping) {
																																																																																																																																																															return function (podDefinitionReferenceMatchEnabled) {
																																																																																																																																																																return function (podDefinitionExpandedReferenceMatchUiEnabled) {
																																																																																																																																																																	return function (podDefinitionCustomerEditEnabled) {
																																																																																																																																																																		return function (conditionalExceptionRules) {
																																																																																																																																																																			return function (loadIdStrategies) {
																																																																																																																																																																				return function (autoIndexNidfDocumentsToLoad) {
																																																																																																																																																																					return function (sendMissingDocumentsEmailTotalCount) {
																																																																																																																																																																						return function (sendMissingDocumentsEmailIntervalInDays) {
																																																																																																																																																																							return function (sendMissingDocumentsEmailCadenceUiEnabled) {
																																																																																																																																																																								return {ableToGenerateCustomerInvoices: ableToGenerateCustomerInvoices, allowCustomExceptions: allowCustomExceptions, allowEditingCarrierPaymentStrategy: allowEditingCarrierPaymentStrategy, allowImplicitCarrierInvoice: allowImplicitCarrierInvoice, allowManualSubmissionReassignmentInSubmissionWorkflow: allowManualSubmissionReassignmentInSubmissionWorkflow, allowReadonlyFactorUserSelection: allowReadonlyFactorUserSelection, annotationAutoStampDocumentType: annotationAutoStampDocumentType, annotationStampHeight: annotationStampHeight, annotationStampUrl: annotationStampUrl, annotationStampWidth: annotationStampWidth, apiRateConfirmationRequired: apiRateConfirmationRequired, attemptToAutoProcessDocumentBatches: attemptToAutoProcessDocumentBatches, auditBillingEnabled: auditBillingEnabled, auditV3ReactStyleOverrides: auditV3ReactStyleOverrides, auditV3ReskinEnabledQueues: auditV3ReskinEnabledQueues, auditV3ReskinEnabledSettings: auditV3ReskinEnabledSettings, auditV3ReskinEnabledTopLevel: auditV3ReskinEnabledTopLevel, auditorDocumentUploadEnabled: auditorDocumentUploadEnabled, autoApprovePayables: autoApprovePayables, autoGenerateFactorInvoiceNumberStrategy: autoGenerateFactorInvoiceNumberStrategy, autoGenerateFactorInvoiceNumbers: autoGenerateFactorInvoiceNumbers, autoIndexNidfDocumentsToLoad: autoIndexNidfDocumentsToLoad, brokerCustomerPortalEnabled: brokerCustomerPortalEnabled, canUnapproveInvoices: canUnapproveInvoices, carrierDaysToPay: carrierDaysToPay, carrierDaysToPayIntegration: carrierDaysToPayIntegration, carrierDocumentsAccount: carrierDocumentsAccount, carrierInvoiceAmountToleranceLineItemTypeId: carrierInvoiceAmountToleranceLineItemTypeId, carrierInvoiceAmountToleranceOver: carrierInvoiceAmountToleranceOver, carrierInvoiceAmountToleranceUnder: carrierInvoiceAmountToleranceUnder, carrierInvoiceAmountToleranceUnit: carrierInvoiceAmountToleranceUnit, carrierToleranceEnabledModes: carrierToleranceEnabledModes, categories: categories, checkClientOrDebtorOnBol: checkClientOrDebtorOnBol, clientNotesConfiguration: clientNotesConfiguration, clientNotesSidebarDisplay: clientNotesSidebarDisplay, conditionalExceptionRules: conditionalExceptionRules, considerNoaDataForVerifications: considerNoaDataForVerifications, controlledByTMS: controlledByTMS, customDocumentTypeNames: customDocumentTypeNames, customExceptionSubjectTemplate: customExceptionSubjectTemplate, customInvoiceExceptionMessages: customInvoiceExceptionMessages, customerDisplayRequiresExternalId: customerDisplayRequiresExternalId, customerRepresentativeViewEnabled: customerRepresentativeViewEnabled, defaultEmailPerInvoice: defaultEmailPerInvoice, disableOutgoingEmailsInSubmissionWorkflow: disableOutgoingEmailsInSubmissionWorkflow, disableReorderTMSReferenceFields: disableReorderTMSReferenceFields, displayAutomatedVerificationsOnSubmissionWorkflow: displayAutomatedVerificationsOnSubmissionWorkflow, displayCadenceFundingNotes: displayCadenceFundingNotes, displayCustomerMarginInHeader: displayCustomerMarginInHeader, displayReferenceInHeader: displayReferenceInHeader, documentAnnotationEnabled: documentAnnotationEnabled, documentTypeForTruckPhotos: documentTypeForTruckPhotos, documentsViewerDoctypeGroupingEnabled: documentsViewerDoctypeGroupingEnabled, enablePODInSubmissionWorkflow: enablePODInSubmissionWorkflow, enablePerRelationshipAutoprocessingOverrides: enablePerRelationshipAutoprocessingOverrides, factorAutoSendInvoices: factorAutoSendInvoices, factorBrokerLoadIdRegressionRuleMode: factorBrokerLoadIdRegressionRuleMode, factorClientPortalEnabled: factorClientPortalEnabled, factorNextGenAuditEnabled: factorNextGenAuditEnabled, factorUseLabelsOnProcessed: factorUseLabelsOnProcessed, factorUseSourceInvoiceDate: factorUseSourceInvoiceDate, factorVerificationExceptionTypes: factorVerificationExceptionTypes, failedCadenceTransmissionRecipients: failedCadenceTransmissionRecipients, featureEnableNonInvoiceFlow: featureEnableNonInvoiceFlow, featureEnableProcessedQueueFlowMode: featureEnableProcessedQueueFlowMode, featureFlags: featureFlags, ignoreMode: ignoreMode, indexAuditSplitEnabled: indexAuditSplitEnabled, invoiceAmountHistoryRuleMode: invoiceAmountHistoryRuleMode, invoiceDateStrategy: invoiceDateStrategy, labels: labels, laneRateExceptionsMode: laneRateExceptionsMode, limitReportsToAdmin: limitReportsToAdmin, lineItemVisibility: lineItemVisibility, loadCustomerLabels: loadCustomerLabels, loadDisplayReferenceKey: loadDisplayReferenceKey, loadDisplayReferenceLabel: loadDisplayReferenceLabel, loadIdStrategies: loadIdStrategies, loadReferenceVariables: loadReferenceVariables, ltlAccessorialUpdateEnabled: ltlAccessorialUpdateEnabled, ltlCarrierInvoiceAmountToleranceOver: ltlCarrierInvoiceAmountToleranceOver, ltlCarrierInvoiceAmountToleranceUnder: ltlCarrierInvoiceAmountToleranceUnder, ltlCarrierInvoiceAmountToleranceUnit: ltlCarrierInvoiceAmountToleranceUnit, ltlCustomerMarginToleranceEnabled: ltlCustomerMarginToleranceEnabled, ltlDefaultMarginToleranceMaximum: ltlDefaultMarginToleranceMaximum, ltlDefaultMarginToleranceMinimum: ltlDefaultMarginToleranceMinimum, ltlDefaultMarginToleranceUnit: ltlDefaultMarginToleranceUnit, ltlHoldEdiImportDays: ltlHoldEdiImportDays, ltlInvoiceAvailableTMSQueues: ltlInvoiceAvailableTMSQueues, ltlLoadsReportEnabled: ltlLoadsReportEnabled, ltlReconcileEnabled: ltlReconcileEnabled, ltlReconcilePageMismatchTableEnabled: ltlReconcilePageMismatchTableEnabled, ltlRerateBlockedForHazardousMaterial: ltlRerateBlockedForHazardousMaterial, ltlRerateEnabled: ltlRerateEnabled, ltlReweighChargeExceptionsEnabled: ltlReweighChargeExceptionsEnabled, ltlTolerancesEnabled: ltlTolerancesEnabled, manualReviewPercentage: manualReviewPercentage, manuallyCheckAmountMatchesRateCon: manuallyCheckAmountMatchesRateCon, manuallyCheckPickupDropoffMatches: manuallyCheckPickupDropoffMatches, manuallyCheckThirdPartyListedOnBol: manuallyCheckThirdPartyListedOnBol, multipleCustomExceptionTemplates: multipleCustomExceptionTemplates, ngaRules: ngaRules, noaManagementEnabled: noaManagementEnabled, nonInvoiceLoadDocumentTypes: nonInvoiceLoadDocumentTypes, payablesTemplateVariables: payablesTemplateVariables, paymentsNetworkEnabled: paymentsNetworkEnabled, perPageOnDashboard: perPageOnDashboard, podDefinitionCustomerEditEnabled: podDefinitionCustomerEditEnabled, podDefinitionExpandedReferenceMatchUiEnabled: podDefinitionExpandedReferenceMatchUiEnabled, podDefinitionModuleEnabled: podDefinitionModuleEnabled, podDefinitionReferenceMatchEnabled: podDefinitionReferenceMatchEnabled, podInferenceCheckTypes: podInferenceCheckTypes, podRequirementPolicy: podRequirementPolicy, podRequiresBolValidation: podRequiresBolValidation, possibleCarrierLabels: possibleCarrierLabels, processorSupportEmailAddress: processorSupportEmailAddress, quickpayDiscount: quickpayDiscount, quickpayDiscountDisabled: quickpayDiscountDisabled, requireLoadStatus: requireLoadStatus, reviewTabEnabled: reviewTabEnabled, reviewTabVerifyModeEnabled: reviewTabVerifyModeEnabled, rulesBrokerCustomExceptionMessages: rulesBrokerCustomExceptionMessages, rulesBrokerRequiredReferences: rulesBrokerRequiredReferences, runNoDocumentsHaveCarrierRatesRule: runNoDocumentsHaveCarrierRatesRule, runNoDocumentsHaveDamagesOrRatesRule: runNoDocumentsHaveDamagesOrRatesRule, savedFilterEnhancementsEnabled: savedFilterEnhancementsEnabled, scraperStatusEnabled: scraperStatusEnabled, selfServeAutoApproveSetting: selfServeAutoApproveSetting, sendMissingDocumentsEmailCadenceUiEnabled: sendMissingDocumentsEmailCadenceUiEnabled, sendMissingDocumentsEmailDelayInHours: sendMissingDocumentsEmailDelayInHours, sendMissingDocumentsEmailIntervalInDays: sendMissingDocumentsEmailIntervalInDays, sendMissingDocumentsEmailTotalCount: sendMissingDocumentsEmailTotalCount, sendMissingDocumentsEmailsEnabled: sendMissingDocumentsEmailsEnabled, shipmentReferenceVariables: shipmentReferenceVariables, showAllLoadDocsEnabled: showAllLoadDocsEnabled, showCadenceDebtorInfo: showCadenceDebtorInfo, showCadenceVerificationInstructions: showCadenceVerificationInstructions, showCarrierExternalVendorId: showCarrierExternalVendorId, showCategorizedLabels: showCategorizedLabels, showClientVerificationPercentagesOnReviewTab: showClientVerificationPercentagesOnReviewTab, showDateDeliveredOnQueues: showDateDeliveredOnQueues, showDateReceivedOnExceptionAndWaiting: showDateReceivedOnExceptionAndWaiting, showDateTimeFilters: showDateTimeFilters, showGroupMovementButtonsInSubmissionWorkflow: showGroupMovementButtonsInSubmissionWorkflow, showInvoiceDateInputInSubmissionWorkflow: showInvoiceDateInputInSubmissionWorkflow, tempAllowCarrierLevelImplicitInvoice: tempAllowCarrierLevelImplicitInvoice, tmsLineItemTypes: tmsLineItemTypes, useBothSubmissionAndTraditionalWorkflow: useBothSubmissionAndTraditionalWorkflow, useCadenceImageTypes: useCadenceImageTypes, useElmDocumentGrouping: useElmDocumentGrouping, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage, useLoadCustomerLabels: useLoadCustomerLabels, useSubmissionWorkflow: useSubmissionWorkflow, useTriumphPayCarrierRemitTo: useTriumphPayCarrierRemitTo, usesOfficePeopleMap: usesOfficePeopleMap, validSourceDateRange: validSourceDateRange, verificationsDebtorConfirmationEnabled: verificationsDebtorConfirmationEnabled, verificationsEnabled: verificationsEnabled, verificationsWorkflowDebtorBatchItemCustomStates: verificationsWorkflowDebtorBatchItemCustomStates, verificationsWorkflowDisplayName: verificationsWorkflowDisplayName, verificationsWorkflowEmailCcRecipients: verificationsWorkflowEmailCcRecipients, verificationsWorkflowEnableCarrierPercentileCheck: verificationsWorkflowEnableCarrierPercentileCheck, verificationsWorkflowEnabled: verificationsWorkflowEnabled, verificationsWorkflowSendRejectedInvoicesToTMS: verificationsWorkflowSendRejectedInvoicesToTMS, verificationsWorkflowUseCadenceNotes: verificationsWorkflowUseCadenceNotes, visibleTMSReferenceFieldLabels: visibleTMSReferenceFieldLabels, warnIfAmountOver: warnIfAmountOver};
																																																																																																																																																																							};
																																																																																																																																																																						};
																																																																																																																																																																					};
																																																																																																																																																																				};
																																																																																																																																																																			};
																																																																																																																																																																		};
																																																																																																																																																																	};
																																																																																																																																																																};
																																																																																																																																																															};
																																																																																																																																																														};
																																																																																																																																																													};
																																																																																																																																																												};
																																																																																																																																																											};
																																																																																																																																																										};
																																																																																																																																																									};
																																																																																																																																																								};
																																																																																																																																																							};
																																																																																																																																																						};
																																																																																																																																																					};
																																																																																																																																																				};
																																																																																																																																																			};
																																																																																																																																																		};
																																																																																																																																																	};
																																																																																																																																																};
																																																																																																																																															};
																																																																																																																																														};
																																																																																																																																													};
																																																																																																																																												};
																																																																																																																																											};
																																																																																																																																										};
																																																																																																																																									};
																																																																																																																																								};
																																																																																																																																							};
																																																																																																																																						};
																																																																																																																																					};
																																																																																																																																				};
																																																																																																																																			};
																																																																																																																																		};
																																																																																																																																	};
																																																																																																																																};
																																																																																																																															};
																																																																																																																														};
																																																																																																																													};
																																																																																																																												};
																																																																																																																											};
																																																																																																																										};
																																																																																																																									};
																																																																																																																								};
																																																																																																																							};
																																																																																																																						};
																																																																																																																					};
																																																																																																																				};
																																																																																																																			};
																																																																																																																		};
																																																																																																																	};
																																																																																																																};
																																																																																																															};
																																																																																																														};
																																																																																																													};
																																																																																																												};
																																																																																																											};
																																																																																																										};
																																																																																																									};
																																																																																																								};
																																																																																																							};
																																																																																																						};
																																																																																																					};
																																																																																																				};
																																																																																																			};
																																																																																																		};
																																																																																																	};
																																																																																																};
																																																																																															};
																																																																																														};
																																																																																													};
																																																																																												};
																																																																																											};
																																																																																										};
																																																																																									};
																																																																																								};
																																																																																							};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$AccountSettings_Category = F2(
	function (name, labels) {
		return {labels: labels, name: name};
	});
var $author$project$AuditPb$accountSettings_CategoryDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'labels',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'name',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$AccountSettings_Category)));
	});
var $author$project$AuditPb$AccountSettings_ClientNoteSetting = F2(
	function (noteType, display) {
		return {display: display, noteType: noteType};
	});
var $author$project$AuditPb$accountSettings_ClientNoteSettingDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'display',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'note_type',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$AccountSettings_ClientNoteSetting)));
	});
var $author$project$AuditPb$AccountSettings_LoadCustomerLabel = F3(
	function (name, source, customerIds) {
		return {customerIds: customerIds, name: name, source: source};
	});
var $author$project$AuditPb$accountSettings_LoadCustomerLabelDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'customer_ids',
			A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'source',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'name',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$AccountSettings_LoadCustomerLabel))));
	});
var $author$project$AuditPb$AccountSettings_TMSLineItemType = F2(
	function (description, id) {
		return {description: description, id: id};
	});
var $author$project$AuditPb$accountSettings_TMSLineItemTypeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'id',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'description',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$AccountSettings_TMSLineItemType)));
	});
var $author$project$AuditPb$ClientNotesSidebarDisplayDisabled = {$: 'ClientNotesSidebarDisplayDisabled'};
var $author$project$AuditPb$clientNotesSidebarDisplayDefault = $author$project$AuditPb$ClientNotesSidebarDisplayDisabled;
var $author$project$AuditPb$ClientNotesSidebarDisplayCollapsed = {$: 'ClientNotesSidebarDisplayCollapsed'};
var $author$project$AuditPb$ClientNotesSidebarDisplayExpanded = {$: 'ClientNotesSidebarDisplayExpanded'};
var $author$project$AuditPb$allClientNotesSidebarDisplay = _List_fromArray(
	[$author$project$AuditPb$ClientNotesSidebarDisplayDisabled, $author$project$AuditPb$ClientNotesSidebarDisplayCollapsed, $author$project$AuditPb$ClientNotesSidebarDisplayExpanded]);
var $author$project$AuditPb$clientNotesSidebarDisplayToString = function (v) {
	switch (v.$) {
		case 'ClientNotesSidebarDisplayDisabled':
			return 'disabled';
		case 'ClientNotesSidebarDisplayCollapsed':
			return 'collapsed';
		default:
			return 'expanded';
	}
};
var $author$project$AuditPb$clientNotesSidebarDisplayDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$clientNotesSidebarDisplayToString(v),
				v);
		},
		$author$project$AuditPb$allClientNotesSidebarDisplay));
var $author$project$AuditPb$clientNotesSidebarDisplayFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$clientNotesSidebarDisplayDict);
};
var $author$project$AuditPb$clientNotesSidebarDisplayDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$clientNotesSidebarDisplayDefault),
		$author$project$AuditPb$clientNotesSidebarDisplayFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$ConditionalExceptionRule = F3(
	function (id, exceptionMessage, conditions) {
		return {conditions: conditions, exceptionMessage: exceptionMessage, id: id};
	});
var $author$project$AuditPb$ConditionalExceptionRule_ConditionGroup = F2(
	function (operator, children) {
		return {children: children, operator: operator};
	});
var $author$project$AuditPb$ConditionalExceptionRule_RuleNode = F2(
	function (nodeType, node) {
		return {node: node, nodeType: nodeType};
	});
var $author$project$AuditPb$ConditionalExceptionRule_RuleNode_Node_Condition = function (a) {
	return {$: 'ConditionalExceptionRule_RuleNode_Node_Condition', a: a};
};
var $author$project$AuditPb$ConditionalExceptionRule_RuleNode_Node_ConditionGroup = function (a) {
	return {$: 'ConditionalExceptionRule_RuleNode_Node_ConditionGroup', a: a};
};
var $author$project$AuditPb$ConditionalExceptionRule_Condition = F4(
	function (fieldCategory, fieldId, predicate, value) {
		return {fieldCategory: fieldCategory, fieldId: fieldId, predicate: predicate, value: value};
	});
var $author$project$AuditPb$conditionalExceptionRule_ConditionDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'value',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'predicate',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'fieldId',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'fieldCategory',
						$elm$json$Json$Decode$string,
						$author$project$AuditPb$decode($author$project$AuditPb$ConditionalExceptionRule_Condition)))));
	});
function $author$project$AuditPb$cyclic$conditionalExceptionRule_ConditionGroupDecoder() {
	return $elm$json$Json$Decode$lazy(
		function (_v2) {
			return A3(
				$author$project$AuditPb$repeated,
				'children',
				$author$project$AuditPb$cyclic$conditionalExceptionRule_RuleNodeDecoder(),
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'operator',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$ConditionalExceptionRule_ConditionGroup)));
		});
}
function $author$project$AuditPb$cyclic$conditionalExceptionRule_RuleNodeDecoder() {
	return $elm$json$Json$Decode$lazy(
		function (_v1) {
			return A2(
				$author$project$AuditPb$field,
				$author$project$AuditPb$cyclic$conditionalExceptionRule_RuleNode_NodeDecoder(),
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'nodeType',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$ConditionalExceptionRule_RuleNode)));
		});
}
function $author$project$AuditPb$cyclic$conditionalExceptionRule_RuleNode_NodeDecoder() {
	return $elm$json$Json$Decode$lazy(
		function (_v0) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$map,
						$author$project$AuditPb$ConditionalExceptionRule_RuleNode_Node_Condition,
						A2($elm$json$Json$Decode$field, 'condition', $author$project$AuditPb$conditionalExceptionRule_ConditionDecoder)),
						A2(
						$elm$json$Json$Decode$map,
						$author$project$AuditPb$ConditionalExceptionRule_RuleNode_Node_ConditionGroup,
						A2(
							$elm$json$Json$Decode$field,
							'group',
							$author$project$AuditPb$cyclic$conditionalExceptionRule_ConditionGroupDecoder())),
						$elm$json$Json$Decode$fail('ConditionalExceptionRule_RuleNode_Node_Unspecified')
					]));
		});
}
try {
	var $author$project$AuditPb$conditionalExceptionRule_ConditionGroupDecoder = $author$project$AuditPb$cyclic$conditionalExceptionRule_ConditionGroupDecoder();
	$author$project$AuditPb$cyclic$conditionalExceptionRule_ConditionGroupDecoder = function () {
		return $author$project$AuditPb$conditionalExceptionRule_ConditionGroupDecoder;
	};
	var $author$project$AuditPb$conditionalExceptionRule_RuleNodeDecoder = $author$project$AuditPb$cyclic$conditionalExceptionRule_RuleNodeDecoder();
	$author$project$AuditPb$cyclic$conditionalExceptionRule_RuleNodeDecoder = function () {
		return $author$project$AuditPb$conditionalExceptionRule_RuleNodeDecoder;
	};
	var $author$project$AuditPb$conditionalExceptionRule_RuleNode_NodeDecoder = $author$project$AuditPb$cyclic$conditionalExceptionRule_RuleNode_NodeDecoder();
	$author$project$AuditPb$cyclic$conditionalExceptionRule_RuleNode_NodeDecoder = function () {
		return $author$project$AuditPb$conditionalExceptionRule_RuleNode_NodeDecoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `AuditPb` are causing infinite recursion:\n\n  ┌─────┐\n  │    conditionalExceptionRule_ConditionGroupDecoder\n  │     ↓\n  │    conditionalExceptionRule_RuleNodeDecoder\n  │     ↓\n  │    conditionalExceptionRule_RuleNode_NodeDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.2/bad-recursion to learn how to fix it!';}
var $author$project$AuditPb$conditionalExceptionRuleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'conditions',
			$author$project$AuditPb$conditionalExceptionRule_ConditionGroupDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'exceptionMessage',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'id',
					$author$project$AuditPb$intDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$ConditionalExceptionRule))));
	});
var $author$project$AuditPb$ConsiderNoaDataForVerificationsDontConsiderNoa = {$: 'ConsiderNoaDataForVerificationsDontConsiderNoa'};
var $author$project$AuditPb$considerNoaDataForVerificationsDefault = $author$project$AuditPb$ConsiderNoaDataForVerificationsDontConsiderNoa;
var $author$project$AuditPb$ConsiderNoaDataForVerificationsSentAndReceivedDate = {$: 'ConsiderNoaDataForVerificationsSentAndReceivedDate'};
var $author$project$AuditPb$ConsiderNoaDataForVerificationsSentDate = {$: 'ConsiderNoaDataForVerificationsSentDate'};
var $author$project$AuditPb$allConsiderNoaDataForVerifications = _List_fromArray(
	[$author$project$AuditPb$ConsiderNoaDataForVerificationsDontConsiderNoa, $author$project$AuditPb$ConsiderNoaDataForVerificationsSentDate, $author$project$AuditPb$ConsiderNoaDataForVerificationsSentAndReceivedDate]);
var $author$project$AuditPb$considerNoaDataForVerificationsToString = function (v) {
	switch (v.$) {
		case 'ConsiderNoaDataForVerificationsDontConsiderNoa':
			return 'Don\u0027t Consider NOA for Verification Level';
		case 'ConsiderNoaDataForVerificationsSentDate':
			return 'Consider NOA sent at date';
		default:
			return 'Consider NOA sent at and received at dates';
	}
};
var $author$project$AuditPb$considerNoaDataForVerificationsDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$considerNoaDataForVerificationsToString(v),
				v);
		},
		$author$project$AuditPb$allConsiderNoaDataForVerifications));
var $author$project$AuditPb$considerNoaDataForVerificationsFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$considerNoaDataForVerificationsDict);
};
var $author$project$AuditPb$considerNoaDataForVerificationsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$considerNoaDataForVerificationsDefault),
		$author$project$AuditPb$considerNoaDataForVerificationsFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$ControlledByTMS = function (customerVisibleDocs) {
	return function (customerRequiredDocs) {
		return function (deliveryMethod) {
			return function (emailDeliveryRecipientAddress) {
				return function (customerBillingInterval) {
					return function (customerInvoiceTemplates) {
						return function (customExceptionMessages) {
							return function (customerInstructions) {
								return function (debtorBillingEmail) {
									return function (customerLtlRerate) {
										return {customExceptionMessages: customExceptionMessages, customerBillingInterval: customerBillingInterval, customerInstructions: customerInstructions, customerInvoiceTemplates: customerInvoiceTemplates, customerLtlRerate: customerLtlRerate, customerRequiredDocs: customerRequiredDocs, customerVisibleDocs: customerVisibleDocs, debtorBillingEmail: debtorBillingEmail, deliveryMethod: deliveryMethod, emailDeliveryRecipientAddress: emailDeliveryRecipientAddress};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$controlledByTMSDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'customer_ltl_rerate',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'debtor_billing_email',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'customer_instructions',
					$elm$json$Json$Decode$bool,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'custom_exception_messages',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'customer_invoice_templates',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'customer_billing_interval',
								$elm$json$Json$Decode$bool,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'email_delivery_recipient_address',
									$elm$json$Json$Decode$bool,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'delivery_method',
										$elm$json$Json$Decode$bool,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'customer_required_docs',
											$elm$json$Json$Decode$bool,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'customer_visible_docs',
												$elm$json$Json$Decode$bool,
												$author$project$AuditPb$decode($author$project$AuditPb$ControlledByTMS)))))))))));
	});
var $author$project$AuditPb$CustomExceptionMessage = F2(
	function (message, typesSelection) {
		return {message: message, typesSelection: typesSelection};
	});
var $author$project$AuditPb$CustomExceptionMessageTypesSelectionBoth = {$: 'CustomExceptionMessageTypesSelectionBoth'};
var $author$project$AuditPb$customExceptionMessageTypesSelectionDefault = $author$project$AuditPb$CustomExceptionMessageTypesSelectionBoth;
var $author$project$AuditPb$CustomExceptionMessageTypesSelectionBilling = {$: 'CustomExceptionMessageTypesSelectionBilling'};
var $author$project$AuditPb$CustomExceptionMessageTypesSelectionPayment = {$: 'CustomExceptionMessageTypesSelectionPayment'};
var $author$project$AuditPb$CustomExceptionMessageTypesSelectionUnknown = {$: 'CustomExceptionMessageTypesSelectionUnknown'};
var $author$project$AuditPb$allCustomExceptionMessageTypesSelection = _List_fromArray(
	[$author$project$AuditPb$CustomExceptionMessageTypesSelectionBoth, $author$project$AuditPb$CustomExceptionMessageTypesSelectionPayment, $author$project$AuditPb$CustomExceptionMessageTypesSelectionBilling, $author$project$AuditPb$CustomExceptionMessageTypesSelectionUnknown]);
var $author$project$AuditPb$customExceptionMessageTypesSelectionToString = function (v) {
	switch (v.$) {
		case 'CustomExceptionMessageTypesSelectionBoth':
			return 'both';
		case 'CustomExceptionMessageTypesSelectionPayment':
			return 'payment';
		case 'CustomExceptionMessageTypesSelectionBilling':
			return 'billing';
		default:
			return 'unknown';
	}
};
var $author$project$AuditPb$customExceptionMessageTypesSelectionDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$customExceptionMessageTypesSelectionToString(v),
				v);
		},
		$author$project$AuditPb$allCustomExceptionMessageTypesSelection));
var $author$project$AuditPb$customExceptionMessageTypesSelectionFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$customExceptionMessageTypesSelectionDict);
};
var $author$project$AuditPb$customExceptionMessageTypesSelectionDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$customExceptionMessageTypesSelectionDefault),
		$author$project$AuditPb$customExceptionMessageTypesSelectionFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$customExceptionMessageDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'types_selection',
			$author$project$AuditPb$customExceptionMessageTypesSelectionDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'message',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$CustomExceptionMessage)));
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$AuditPb$DocumentPODInferenceCheckTypeCheckSignature = {$: 'DocumentPODInferenceCheckTypeCheckSignature'};
var $author$project$AuditPb$documentPODInferenceCheckTypeDefault = $author$project$AuditPb$DocumentPODInferenceCheckTypeCheckSignature;
var $author$project$AuditPb$DocumentPODInferenceCheckTypeAllPagesPresent = {$: 'DocumentPODInferenceCheckTypeAllPagesPresent'};
var $author$project$AuditPb$DocumentPODInferenceCheckTypeHasReceiverDate = {$: 'DocumentPODInferenceCheckTypeHasReceiverDate'};
var $author$project$AuditPb$DocumentPODInferenceCheckTypeManualReferenceMatch = {$: 'DocumentPODInferenceCheckTypeManualReferenceMatch'};
var $author$project$AuditPb$DocumentPODInferenceCheckTypeNoCarrierRate = {$: 'DocumentPODInferenceCheckTypeNoCarrierRate'};
var $author$project$AuditPb$DocumentPODInferenceCheckTypeNoDamages = {$: 'DocumentPODInferenceCheckTypeNoDamages'};
var $author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch = {$: 'DocumentPODInferenceCheckTypeReferenceMatch'};
var $author$project$AuditPb$allDocumentPODInferenceCheckType = _List_fromArray(
	[$author$project$AuditPb$DocumentPODInferenceCheckTypeCheckSignature, $author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch, $author$project$AuditPb$DocumentPODInferenceCheckTypeNoDamages, $author$project$AuditPb$DocumentPODInferenceCheckTypeAllPagesPresent, $author$project$AuditPb$DocumentPODInferenceCheckTypeHasReceiverDate, $author$project$AuditPb$DocumentPODInferenceCheckTypeNoCarrierRate, $author$project$AuditPb$DocumentPODInferenceCheckTypeManualReferenceMatch]);
var $author$project$AuditPb$documentPODInferenceCheckTypeToString = function (v) {
	switch (v.$) {
		case 'DocumentPODInferenceCheckTypeCheckSignature':
			return 'check_signature';
		case 'DocumentPODInferenceCheckTypeReferenceMatch':
			return 'check_for_reference_match';
		case 'DocumentPODInferenceCheckTypeNoDamages':
			return 'no_damages';
		case 'DocumentPODInferenceCheckTypeAllPagesPresent':
			return 'all_pages_present';
		case 'DocumentPODInferenceCheckTypeHasReceiverDate':
			return 'has_receiver_date';
		case 'DocumentPODInferenceCheckTypeNoCarrierRate':
			return 'no_carrier_rate';
		default:
			return 'manual_reference_match';
	}
};
var $author$project$AuditPb$documentPODInferenceCheckTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$documentPODInferenceCheckTypeToString(v),
				v);
		},
		$author$project$AuditPb$allDocumentPODInferenceCheckType));
var $author$project$AuditPb$documentPODInferenceCheckTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$documentPODInferenceCheckTypeDict);
};
var $author$project$AuditPb$documentPODInferenceCheckTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$documentPODInferenceCheckTypeDefault),
		$author$project$AuditPb$documentPODInferenceCheckTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$documentTypeDefault = $author$project$AuditPb$DocumentTypeInvoice;
var $author$project$AuditPb$documentTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$documentTypeDefault),
		$author$project$AuditPb$documentTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$FeatureFlags = function (allowHidingItemsInQueuesOnPresence) {
	return {allowHidingItemsInQueuesOnPresence: allowHidingItemsInQueuesOnPresence};
};
var $author$project$AuditPb$featureFlagsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'allow_hiding_items_in_queues_on_presence',
			$elm$json$Json$Decode$bool,
			$author$project$AuditPb$decode($author$project$AuditPb$FeatureFlags));
	});
var $author$project$AuditPb$floatValueDecoder = $elm$json$Json$Decode$float;
var $author$project$AuditPb$IgnoreModeBulkIgnore = {$: 'IgnoreModeBulkIgnore'};
var $author$project$AuditPb$ignoreModeDefault = $author$project$AuditPb$IgnoreModeBulkIgnore;
var $author$project$AuditPb$IgnoreModeIgnore = {$: 'IgnoreModeIgnore'};
var $author$project$AuditPb$IgnoreModeSubmissionsWorkflowNoIgnore = {$: 'IgnoreModeSubmissionsWorkflowNoIgnore'};
var $author$project$AuditPb$allIgnoreMode = _List_fromArray(
	[$author$project$AuditPb$IgnoreModeBulkIgnore, $author$project$AuditPb$IgnoreModeIgnore, $author$project$AuditPb$IgnoreModeSubmissionsWorkflowNoIgnore]);
var $author$project$AuditPb$ignoreModeToString = function (v) {
	switch (v.$) {
		case 'IgnoreModeBulkIgnore':
			return 'BulkIgnore';
		case 'IgnoreModeIgnore':
			return 'Ignore';
		default:
			return 'SubmissionsWorkflowNoIgnore';
	}
};
var $author$project$AuditPb$ignoreModeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$ignoreModeToString(v),
				v);
		},
		$author$project$AuditPb$allIgnoreMode));
var $author$project$AuditPb$ignoreModeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$ignoreModeDict);
};
var $author$project$AuditPb$ignoreModeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$ignoreModeDefault),
		$author$project$AuditPb$ignoreModeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$Label = F2(
	function (name, source) {
		return {name: name, source: source};
	});
var $author$project$AuditPb$labelDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'source',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'name',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$Label)));
	});
var $author$project$AuditPb$LoadIdStrategyStripDashedSuffix = {$: 'LoadIdStrategyStripDashedSuffix'};
var $author$project$AuditPb$loadIdStrategyDefault = $author$project$AuditPb$LoadIdStrategyStripDashedSuffix;
var $author$project$AuditPb$LoadIdStrategyAlphanumericOnly = {$: 'LoadIdStrategyAlphanumericOnly'};
var $author$project$AuditPb$LoadIdStrategyNumbersOnly = {$: 'LoadIdStrategyNumbersOnly'};
var $author$project$AuditPb$LoadIdStrategyStripColons = {$: 'LoadIdStrategyStripColons'};
var $author$project$AuditPb$LoadIdStrategyStripLeadingZeros = {$: 'LoadIdStrategyStripLeadingZeros'};
var $author$project$AuditPb$LoadIdStrategyStripPipe = {$: 'LoadIdStrategyStripPipe'};
var $author$project$AuditPb$LoadIdStrategyStripWhitespace = {$: 'LoadIdStrategyStripWhitespace'};
var $author$project$AuditPb$LoadIdStrategyUpcase = {$: 'LoadIdStrategyUpcase'};
var $author$project$AuditPb$allLoadIdStrategy = _List_fromArray(
	[$author$project$AuditPb$LoadIdStrategyStripDashedSuffix, $author$project$AuditPb$LoadIdStrategyStripLeadingZeros, $author$project$AuditPb$LoadIdStrategyStripWhitespace, $author$project$AuditPb$LoadIdStrategyStripColons, $author$project$AuditPb$LoadIdStrategyStripPipe, $author$project$AuditPb$LoadIdStrategyUpcase, $author$project$AuditPb$LoadIdStrategyNumbersOnly, $author$project$AuditPb$LoadIdStrategyAlphanumericOnly]);
var $author$project$AuditPb$loadIdStrategyToString = function (v) {
	switch (v.$) {
		case 'LoadIdStrategyStripDashedSuffix':
			return 'strip_dashed_suffix';
		case 'LoadIdStrategyStripLeadingZeros':
			return 'strip_leading_zeros';
		case 'LoadIdStrategyStripWhitespace':
			return 'strip_whitespace';
		case 'LoadIdStrategyStripColons':
			return 'strip_colons';
		case 'LoadIdStrategyStripPipe':
			return 'strip_pipe';
		case 'LoadIdStrategyUpcase':
			return 'upcase';
		case 'LoadIdStrategyNumbersOnly':
			return 'numbers_only';
		default:
			return 'alphanumeric_only';
	}
};
var $author$project$AuditPb$loadIdStrategyDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$loadIdStrategyToString(v),
				v);
		},
		$author$project$AuditPb$allLoadIdStrategy));
var $author$project$AuditPb$loadIdStrategyFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$loadIdStrategyDict);
};
var $author$project$AuditPb$loadIdStrategyDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$loadIdStrategyDefault),
		$author$project$AuditPb$loadIdStrategyFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$NgaRulesResponse = F2(
	function (reviewPercentageRules, availableCreditRatings) {
		return {availableCreditRatings: availableCreditRatings, reviewPercentageRules: reviewPercentageRules};
	});
var $author$project$AuditPb$NgaRulesResponse_ReviewPercentageRule = F3(
	function (creditRatings, reviewPercentage, ngaRuleId) {
		return {creditRatings: creditRatings, ngaRuleId: ngaRuleId, reviewPercentage: reviewPercentage};
	});
var $author$project$AuditPb$ngaRulesResponse_ReviewPercentageRuleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'ngaRuleId',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'reviewPercentage',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'creditRatings',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$NgaRulesResponse_ReviewPercentageRule))));
	});
var $author$project$AuditPb$ngaRulesResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'availableCreditRatings',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'reviewPercentageRules',
				$author$project$AuditPb$ngaRulesResponse_ReviewPercentageRuleDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$NgaRulesResponse)));
	});
var $author$project$AuditPb$optionalMessage = F2(
	function (name, decoder) {
		return $author$project$AuditPb$field(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						name,
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing)),
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A2($elm$json$Json$Decode$field, name, decoder)),
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
					])));
	});
var $author$project$AuditPb$PODRequirementPolicyUseAccountSetting = {$: 'PODRequirementPolicyUseAccountSetting'};
var $author$project$AuditPb$podRequirementPolicyDefault = $author$project$AuditPb$PODRequirementPolicyUseAccountSetting;
var $author$project$AuditPb$PODRequirementPolicyAlways = {$: 'PODRequirementPolicyAlways'};
var $author$project$AuditPb$PODRequirementPolicyDetermineFromLoad = {$: 'PODRequirementPolicyDetermineFromLoad'};
var $author$project$AuditPb$PODRequirementPolicyFlagAllBolsForMercuryGate = {$: 'PODRequirementPolicyFlagAllBolsForMercuryGate'};
var $author$project$AuditPb$PODRequirementPolicyNever = {$: 'PODRequirementPolicyNever'};
var $author$project$AuditPb$allPODRequirementPolicy = _List_fromArray(
	[$author$project$AuditPb$PODRequirementPolicyUseAccountSetting, $author$project$AuditPb$PODRequirementPolicyAlways, $author$project$AuditPb$PODRequirementPolicyDetermineFromLoad, $author$project$AuditPb$PODRequirementPolicyNever, $author$project$AuditPb$PODRequirementPolicyFlagAllBolsForMercuryGate]);
var $author$project$AuditPb$podRequirementPolicyToString = function (v) {
	switch (v.$) {
		case 'PODRequirementPolicyUseAccountSetting':
			return 'use_account_setting';
		case 'PODRequirementPolicyAlways':
			return 'always';
		case 'PODRequirementPolicyDetermineFromLoad':
			return 'determine from load';
		case 'PODRequirementPolicyNever':
			return 'never';
		default:
			return 'flag_all_bols_for_mercury_gate';
	}
};
var $author$project$AuditPb$podRequirementPolicyDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$podRequirementPolicyToString(v),
				v);
		},
		$author$project$AuditPb$allPODRequirementPolicy));
var $author$project$AuditPb$podRequirementPolicyFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$podRequirementPolicyDict);
};
var $author$project$AuditPb$podRequirementPolicyDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$podRequirementPolicyDefault),
		$author$project$AuditPb$podRequirementPolicyFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$ReferenceRule = F2(
	function (reference, rule) {
		return {reference: reference, rule: rule};
	});
var $author$project$AuditPb$ReferenceRule_Rule_BeginsWith = function (a) {
	return {$: 'ReferenceRule_Rule_BeginsWith', a: a};
};
var $author$project$AuditPb$ReferenceRule_Rule_HasValue = function (a) {
	return {$: 'ReferenceRule_Rule_HasValue', a: a};
};
var $author$project$AuditPb$ReferenceRule_Rule_IsEmpty = function (a) {
	return {$: 'ReferenceRule_Rule_IsEmpty', a: a};
};
var $author$project$AuditPb$ReferenceRule_Rule_IsPresent = function (a) {
	return {$: 'ReferenceRule_Rule_IsPresent', a: a};
};
var $author$project$AuditPb$ReferenceRule_Rule_NotValue = function (a) {
	return {$: 'ReferenceRule_Rule_NotValue', a: a};
};
var $author$project$AuditPb$ReferenceRule_BeginsWith = function (value) {
	return {value: value};
};
var $author$project$AuditPb$referenceRule_BeginsWithDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'value',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$ReferenceRule_BeginsWith));
	});
var $author$project$AuditPb$ReferenceRule_HasValue = function (value) {
	return {value: value};
};
var $author$project$AuditPb$referenceRule_HasValueDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'value',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$ReferenceRule_HasValue));
	});
var $author$project$AuditPb$ReferenceRule_IsEmpty = {};
var $author$project$AuditPb$referenceRule_IsEmptyDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$ReferenceRule_IsEmpty);
	});
var $author$project$AuditPb$ReferenceRule_IsPresent = {};
var $author$project$AuditPb$referenceRule_IsPresentDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$ReferenceRule_IsPresent);
	});
var $author$project$AuditPb$ReferenceRule_NotValue = function (value) {
	return {value: value};
};
var $author$project$AuditPb$referenceRule_NotValueDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'value',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$ReferenceRule_NotValue));
	});
var $author$project$AuditPb$referenceRule_RuleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ReferenceRule_Rule_IsPresent,
					A2($elm$json$Json$Decode$field, 'is_present', $author$project$AuditPb$referenceRule_IsPresentDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ReferenceRule_Rule_IsEmpty,
					A2($elm$json$Json$Decode$field, 'is_empty', $author$project$AuditPb$referenceRule_IsEmptyDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ReferenceRule_Rule_HasValue,
					A2($elm$json$Json$Decode$field, 'has_value', $author$project$AuditPb$referenceRule_HasValueDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ReferenceRule_Rule_BeginsWith,
					A2($elm$json$Json$Decode$field, 'begins_with', $author$project$AuditPb$referenceRule_BeginsWithDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ReferenceRule_Rule_NotValue,
					A2($elm$json$Json$Decode$field, 'not_value', $author$project$AuditPb$referenceRule_NotValueDecoder)),
					$elm$json$Json$Decode$fail('ReferenceRule_Rule_Unspecified')
				]));
	});
var $author$project$AuditPb$referenceRuleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$referenceRule_RuleDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'reference',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$ReferenceRule)));
	});
var $author$project$AuditPb$UnresolvedDocumentType = function (value) {
	return {value: value};
};
var $author$project$AuditPb$UnresolvedDocumentType_Value_DocumentType = function (a) {
	return {$: 'UnresolvedDocumentType_Value_DocumentType', a: a};
};
var $author$project$AuditPb$UnresolvedDocumentType_Value_DocumentTypePartial = function (a) {
	return {$: 'UnresolvedDocumentType_Value_DocumentTypePartial', a: a};
};
var $author$project$AuditPb$UnresolvedDocumentType_Value_Unknown = function (a) {
	return {$: 'UnresolvedDocumentType_Value_Unknown', a: a};
};
var $author$project$AuditPb$documentTypePartialDefault = $author$project$AuditPb$DocumentTypePartialPartiallySpecifiedOcean;
var $author$project$AuditPb$documentTypePartialDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$documentTypePartialDefault),
		$author$project$AuditPb$documentTypePartialFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$UnresolvedDocumentType_Unknown = {};
var $author$project$AuditPb$unresolvedDocumentType_UnknownDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$UnresolvedDocumentType_Unknown);
	});
var $author$project$AuditPb$unresolvedDocumentType_ValueDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$UnresolvedDocumentType_Value_DocumentType,
					A2($elm$json$Json$Decode$field, 'document_type', $author$project$AuditPb$documentTypeDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$UnresolvedDocumentType_Value_DocumentTypePartial,
					A2($elm$json$Json$Decode$field, 'document_type_partial', $author$project$AuditPb$documentTypePartialDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$UnresolvedDocumentType_Value_Unknown,
					A2($elm$json$Json$Decode$field, 'unknown', $author$project$AuditPb$unresolvedDocumentType_UnknownDecoder)),
					$elm$json$Json$Decode$fail('UnresolvedDocumentType_Value_Unspecified')
				]));
	});
var $author$project$AuditPb$unresolvedDocumentTypeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$unresolvedDocumentType_ValueDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$UnresolvedDocumentType));
	});
var $author$project$AuditPb$VerificationsDebtorBatchItemCustomState = F4(
	function (id, name, state, selectable) {
		return {id: id, name: name, selectable: selectable, state: state};
	});
var $author$project$AuditPb$VerificationsDebtorBatchItemStateUnverified = {$: 'VerificationsDebtorBatchItemStateUnverified'};
var $author$project$AuditPb$verificationsDebtorBatchItemStateDefault = $author$project$AuditPb$VerificationsDebtorBatchItemStateUnverified;
var $author$project$AuditPb$VerificationsDebtorBatchItemStateAutoSkipped = {$: 'VerificationsDebtorBatchItemStateAutoSkipped'};
var $author$project$AuditPb$VerificationsDebtorBatchItemStateHeld = {$: 'VerificationsDebtorBatchItemStateHeld'};
var $author$project$AuditPb$VerificationsDebtorBatchItemStateNotReady = {$: 'VerificationsDebtorBatchItemStateNotReady'};
var $author$project$AuditPb$VerificationsDebtorBatchItemStateRejected = {$: 'VerificationsDebtorBatchItemStateRejected'};
var $author$project$AuditPb$VerificationsDebtorBatchItemStateSkipped = {$: 'VerificationsDebtorBatchItemStateSkipped'};
var $author$project$AuditPb$VerificationsDebtorBatchItemStateVerified = {$: 'VerificationsDebtorBatchItemStateVerified'};
var $author$project$AuditPb$VerificationsDebtorBatchItemStateWaiting = {$: 'VerificationsDebtorBatchItemStateWaiting'};
var $author$project$AuditPb$allVerificationsDebtorBatchItemState = _List_fromArray(
	[$author$project$AuditPb$VerificationsDebtorBatchItemStateUnverified, $author$project$AuditPb$VerificationsDebtorBatchItemStateVerified, $author$project$AuditPb$VerificationsDebtorBatchItemStateSkipped, $author$project$AuditPb$VerificationsDebtorBatchItemStateRejected, $author$project$AuditPb$VerificationsDebtorBatchItemStateHeld, $author$project$AuditPb$VerificationsDebtorBatchItemStateAutoSkipped, $author$project$AuditPb$VerificationsDebtorBatchItemStateNotReady, $author$project$AuditPb$VerificationsDebtorBatchItemStateWaiting]);
var $author$project$AuditPb$verificationsDebtorBatchItemStateToString = function (v) {
	switch (v.$) {
		case 'VerificationsDebtorBatchItemStateUnverified':
			return 'unverified';
		case 'VerificationsDebtorBatchItemStateVerified':
			return 'verified';
		case 'VerificationsDebtorBatchItemStateSkipped':
			return 'skipped';
		case 'VerificationsDebtorBatchItemStateRejected':
			return 'rejected';
		case 'VerificationsDebtorBatchItemStateHeld':
			return 'held';
		case 'VerificationsDebtorBatchItemStateAutoSkipped':
			return 'auto_skipped';
		case 'VerificationsDebtorBatchItemStateNotReady':
			return 'not_ready';
		default:
			return 'waiting';
	}
};
var $author$project$AuditPb$verificationsDebtorBatchItemStateDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationsDebtorBatchItemStateToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationsDebtorBatchItemState));
var $author$project$AuditPb$verificationsDebtorBatchItemStateFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationsDebtorBatchItemStateDict);
};
var $author$project$AuditPb$verificationsDebtorBatchItemStateDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationsDebtorBatchItemStateDefault),
		$author$project$AuditPb$verificationsDebtorBatchItemStateFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$verificationsDebtorBatchItemCustomStateDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'selectable',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'state',
				$author$project$AuditPb$verificationsDebtorBatchItemStateDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						$elm$json$Json$Decode$string,
						$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorBatchItemCustomState)))));
	});
var $author$project$AuditPb$accountSettingsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'send_missing_documents_email_cadence_ui_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'send_missing_documents_email_interval_in_days',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'send_missing_documents_email_total_count',
					$author$project$AuditPb$intDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'auto_index_nidf_documents_to_load',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$AuditPb$repeated,
							'load_id_strategies',
							$author$project$AuditPb$loadIdStrategyDecoder,
							A3(
								$author$project$AuditPb$repeated,
								'conditional_exception_rules',
								$author$project$AuditPb$conditionalExceptionRuleDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'pod_definition_customer_edit_enabled',
									$elm$json$Json$Decode$bool,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'pod_definition_expanded_reference_match_ui_enabled',
										$elm$json$Json$Decode$bool,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'pod_definition_reference_match_enabled',
											$elm$json$Json$Decode$bool,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'use_elm_document_grouping',
												$elm$json$Json$Decode$bool,
												A3(
													$author$project$AuditPb$repeated,
													'pod_inference_check_types',
													$author$project$AuditPb$documentPODInferenceCheckTypeDecoder,
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'pod_definition_module_enabled',
														$elm$json$Json$Decode$bool,
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'pod_requires_bol_validation',
															$elm$json$Json$Decode$bool,
															A3(
																$author$project$AuditPb$requiredWithoutDefault,
																'temp_allow_carrier_level_implicit_invoice',
																$elm$json$Json$Decode$bool,
																A3(
																	$author$project$AuditPb$requiredWithoutDefault,
																	'allow_implicit_carrier_invoice',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$author$project$AuditPb$requiredWithoutDefault,
																		'invoice_amount_history_rule_mode',
																		$elm$json$Json$Decode$string,
																		A3(
																			$author$project$AuditPb$requiredWithoutDefault,
																			'lane_rate_exceptions_mode',
																			$elm$json$Json$Decode$string,
																			A3(
																				$author$project$AuditPb$requiredWithoutDefault,
																				'factor_broker_load_id_regression_rule_mode',
																				$elm$json$Json$Decode$string,
																				A3(
																					$author$project$AuditPb$requiredWithoutDefault,
																					'enable_per_relationship_autoprocessing_overrides',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$author$project$AuditPb$repeated,
																						'factor_verification_exception_types',
																						$elm$json$Json$Decode$string,
																						A3(
																							$author$project$AuditPb$requiredWithoutDefault,
																							'send_missing_documents_email_delay_in_hours',
																							$author$project$AuditPb$intDecoder,
																							A3(
																								$author$project$AuditPb$requiredWithoutDefault,
																								'send_missing_documents_emails_enabled',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$author$project$AuditPb$requiredWithoutDefault,
																									'noa_management_enabled',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$author$project$AuditPb$requiredWithoutDefault,
																										'can_unapprove_invoices',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$author$project$AuditPb$repeated,
																											'carrier_tolerance_enabled_modes',
																											$elm$json$Json$Decode$string,
																											A3(
																												$author$project$AuditPb$requiredWithoutDefault,
																												'document_type_for_truck_photos',
																												$author$project$AuditPb$documentTypeDecoder,
																												A3(
																													$author$project$AuditPb$requiredWithoutDefault,
																													'allow_readonly_factor_user_selection',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$author$project$AuditPb$requiredWithoutDefault,
																														'load_display_reference_key',
																														$elm$json$Json$Decode$string,
																														A3(
																															$author$project$AuditPb$requiredWithoutDefault,
																															'load_display_reference_label',
																															$elm$json$Json$Decode$string,
																															A3(
																																$author$project$AuditPb$requiredWithoutDefault,
																																'display_reference_in_header',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$author$project$AuditPb$repeated,
																																	'require_load_status',
																																	$elm$json$Json$Decode$string,
																																	A3(
																																		$author$project$AuditPb$optionalMessage,
																																		'nga_rules',
																																		$author$project$AuditPb$ngaRulesResponseDecoder,
																																		A3(
																																			$author$project$AuditPb$requiredWithoutDefault,
																																			'display_customer_margin_in_header',
																																			$elm$json$Json$Decode$bool,
																																			A3(
																																				$author$project$AuditPb$optional,
																																				'ltl_default_margin_tolerance_maximum',
																																				$elm$json$Json$Decode$string,
																																				A3(
																																					$author$project$AuditPb$optional,
																																					'ltl_default_margin_tolerance_minimum',
																																					$elm$json$Json$Decode$string,
																																					A3(
																																						$author$project$AuditPb$requiredWithoutDefault,
																																						'ltl_default_margin_tolerance_unit',
																																						$author$project$AuditPb$toleranceUnitDecoder,
																																						A3(
																																							$author$project$AuditPb$requiredWithoutDefault,
																																							'ltl_customer_margin_tolerance_enabled',
																																							$elm$json$Json$Decode$bool,
																																							A3(
																																								$author$project$AuditPb$requiredWithoutDefault,
																																								'run_no_documents_have_carrier_rates_rule',
																																								$elm$json$Json$Decode$bool,
																																								A3(
																																									$author$project$AuditPb$requiredWithoutDefault,
																																									'run_no_documents_have_damages_or_rates_rule',
																																									$elm$json$Json$Decode$bool,
																																									A3(
																																										$author$project$AuditPb$requiredWithoutDefault,
																																										'ltl_rerate_blocked_for_hazardous_material',
																																										$elm$json$Json$Decode$bool,
																																										A3(
																																											$author$project$AuditPb$requiredWithoutDefault,
																																											'ltl_reconcile_page_mismatch_table_enabled',
																																											$elm$json$Json$Decode$bool,
																																											A3(
																																												$author$project$AuditPb$requiredWithoutDefault,
																																												'multiple_custom_exception_templates',
																																												$elm$json$Json$Decode$bool,
																																												A3(
																																													$author$project$AuditPb$requiredWithoutDefault,
																																													'ltl_carrier_invoice_amount_tolerance_unit',
																																													$author$project$AuditPb$toleranceUnitDecoder,
																																													A3(
																																														$author$project$AuditPb$requiredWithoutDefault,
																																														'ltl_carrier_invoice_amount_tolerance_under',
																																														$elm$json$Json$Decode$string,
																																														A3(
																																															$author$project$AuditPb$requiredWithoutDefault,
																																															'ltl_carrier_invoice_amount_tolerance_over',
																																															$elm$json$Json$Decode$string,
																																															A3(
																																																$author$project$AuditPb$requiredWithoutDefault,
																																																'ltl_tolerances_enabled',
																																																$elm$json$Json$Decode$bool,
																																																A3(
																																																	$author$project$AuditPb$requiredWithoutDefault,
																																																	'scraper_status_enabled',
																																																	$elm$json$Json$Decode$bool,
																																																	A3(
																																																		$author$project$AuditPb$requiredWithoutDefault,
																																																		'show_all_load_docs_enabled',
																																																		$elm$json$Json$Decode$bool,
																																																		A3(
																																																			$author$project$AuditPb$requiredWithoutDefault,
																																																			'ltl_hold_edi_import_days',
																																																			$author$project$AuditPb$intDecoder,
																																																			A3(
																																																				$author$project$AuditPb$requiredWithoutDefault,
																																																				'manual_review_percentage',
																																																				$author$project$AuditPb$intDecoder,
																																																				A3(
																																																					$author$project$AuditPb$requiredWithoutDefault,
																																																					'auditor_document_upload_enabled',
																																																					$elm$json$Json$Decode$bool,
																																																					A3(
																																																						$author$project$AuditPb$optional,
																																																						'warn_if_amount_over',
																																																						$author$project$AuditPb$intDecoder,
																																																						A3(
																																																							$author$project$AuditPb$requiredWithoutDefault,
																																																							'use_factor_invoice_workflow_page',
																																																							$elm$json$Json$Decode$bool,
																																																							A3(
																																																								$author$project$AuditPb$requiredWithoutDefault,
																																																								'factor_next_gen_audit_enabled',
																																																								$elm$json$Json$Decode$bool,
																																																								A3(
																																																									$author$project$AuditPb$requiredWithoutDefault,
																																																									'audit_v3_react_style_overrides',
																																																									$elm$json$Json$Decode$bool,
																																																									A3(
																																																										$author$project$AuditPb$requiredWithoutDefault,
																																																										'audit_v3_reskin_enabled_queues',
																																																										$elm$json$Json$Decode$bool,
																																																										A3(
																																																											$author$project$AuditPb$requiredWithoutDefault,
																																																											'audit_v3_reskin_enabled_top_level',
																																																											$elm$json$Json$Decode$bool,
																																																											A3(
																																																												$author$project$AuditPb$requiredWithoutDefault,
																																																												'audit_v3_reskin_enabled_settings',
																																																												$elm$json$Json$Decode$bool,
																																																												A3(
																																																													$author$project$AuditPb$requiredWithoutDefault,
																																																													'ltl_loads_report_enabled',
																																																													$elm$json$Json$Decode$bool,
																																																													A3(
																																																														$author$project$AuditPb$requiredWithoutDefault,
																																																														'ltl_accessorial_update_enabled',
																																																														$elm$json$Json$Decode$bool,
																																																														A3(
																																																															$author$project$AuditPb$requiredWithoutDefault,
																																																															'ltl_reweigh_charge_exceptions_enabled',
																																																															$elm$json$Json$Decode$bool,
																																																															A3(
																																																																$author$project$AuditPb$requiredWithoutDefault,
																																																																'ltl_rerate_enabled',
																																																																$elm$json$Json$Decode$bool,
																																																																A3(
																																																																	$author$project$AuditPb$repeated,
																																																																	'ltl_invoice_available_tms_queues',
																																																																	$elm$json$Json$Decode$string,
																																																																	A3(
																																																																		$author$project$AuditPb$requiredWithoutDefault,
																																																																		'show_date_time_filters',
																																																																		$elm$json$Json$Decode$bool,
																																																																		A3(
																																																																			$author$project$AuditPb$requiredWithoutDefault,
																																																																			'ltl_reconcile_enabled',
																																																																			$elm$json$Json$Decode$bool,
																																																																			A3(
																																																																				$author$project$AuditPb$requiredWithoutDefault,
																																																																				'documents_viewer_doctype_grouping_enabled',
																																																																				$elm$json$Json$Decode$bool,
																																																																				A3(
																																																																					$author$project$AuditPb$requiredWithoutDefault,
																																																																					'saved_filter_enhancements_enabled',
																																																																					$elm$json$Json$Decode$bool,
																																																																					A3(
																																																																						$author$project$AuditPb$requiredWithoutDefault,
																																																																						'disable_reorder_tms_reference_fields',
																																																																						$elm$json$Json$Decode$bool,
																																																																						A3(
																																																																							$author$project$AuditPb$requiredWithoutDefault,
																																																																							'customer_representative_view_enabled',
																																																																							$elm$json$Json$Decode$bool,
																																																																							A3(
																																																																								$author$project$AuditPb$requiredWithoutDefault,
																																																																								'api_rate_confirmation_required',
																																																																								$elm$json$Json$Decode$bool,
																																																																								A3(
																																																																									$author$project$AuditPb$requiredWithoutDefault,
																																																																									'show_categorized_labels',
																																																																									$elm$json$Json$Decode$bool,
																																																																									A3(
																																																																										$author$project$AuditPb$requiredWithoutDefault,
																																																																										'factor_auto_send_invoices',
																																																																										$elm$json$Json$Decode$bool,
																																																																										A3(
																																																																											$author$project$AuditPb$requiredWithoutDefault,
																																																																											'custom_document_type_names',
																																																																											$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
																																																																											A3(
																																																																												$author$project$AuditPb$requiredWithoutDefault,
																																																																												'customer_display_requires_external_id',
																																																																												$elm$json$Json$Decode$bool,
																																																																												A3(
																																																																													$author$project$AuditPb$requiredWithoutDefault,
																																																																													'audit_billing_enabled',
																																																																													$elm$json$Json$Decode$bool,
																																																																													A3(
																																																																														$author$project$AuditPb$requiredWithoutDefault,
																																																																														'show_date_delivered_on_queues',
																																																																														$elm$json$Json$Decode$bool,
																																																																														A3(
																																																																															$author$project$AuditPb$requiredWithoutDefault,
																																																																															'show_date_received_on_exception_and_waiting',
																																																																															$elm$json$Json$Decode$bool,
																																																																															A3(
																																																																																$author$project$AuditPb$requiredWithoutDefault,
																																																																																'feature_enable_non_invoice_flow',
																																																																																$elm$json$Json$Decode$bool,
																																																																																A3(
																																																																																	$author$project$AuditPb$optional,
																																																																																	'annotation_stamp_height',
																																																																																	$author$project$AuditPb$floatValueDecoder,
																																																																																	A3(
																																																																																		$author$project$AuditPb$optional,
																																																																																		'annotation_stamp_width',
																																																																																		$author$project$AuditPb$floatValueDecoder,
																																																																																		A3(
																																																																																			$author$project$AuditPb$optional,
																																																																																			'annotation_stamp_url',
																																																																																			$elm$json$Json$Decode$string,
																																																																																			A3(
																																																																																				$author$project$AuditPb$requiredWithoutDefault,
																																																																																				'document_annotation_enabled',
																																																																																				$elm$json$Json$Decode$bool,
																																																																																				A3(
																																																																																					$author$project$AuditPb$requiredWithoutDefault,
																																																																																					'ignore_mode',
																																																																																					$author$project$AuditPb$ignoreModeDecoder,
																																																																																					A3(
																																																																																						$author$project$AuditPb$requiredWithoutDefault,
																																																																																						'feature_enable_processed_queue_flow_mode',
																																																																																						$elm$json$Json$Decode$bool,
																																																																																						A3(
																																																																																							$author$project$AuditPb$requiredWithoutDefault,
																																																																																							'index_audit_split_enabled',
																																																																																							$elm$json$Json$Decode$bool,
																																																																																							A3(
																																																																																								$author$project$AuditPb$requiredWithoutDefault,
																																																																																								'payments_network_enabled',
																																																																																								$elm$json$Json$Decode$bool,
																																																																																								A3(
																																																																																									$author$project$AuditPb$requiredWithoutDefault,
																																																																																									'use_triumph_pay_carrier_remit_to',
																																																																																									$elm$json$Json$Decode$bool,
																																																																																									A3(
																																																																																										$author$project$AuditPb$requiredWithoutDefault,
																																																																																										'line_item_visibility',
																																																																																										$elm$json$Json$Decode$string,
																																																																																										A3(
																																																																																											$author$project$AuditPb$requiredWithoutDefault,
																																																																																											'per_page_on_dashboard',
																																																																																											$author$project$AuditPb$intDecoder,
																																																																																											A3(
																																																																																												$author$project$AuditPb$requiredWithoutDefault,
																																																																																												'show_client_verification_percentages_on_review_tab',
																																																																																												$elm$json$Json$Decode$bool,
																																																																																												A3(
																																																																																													$author$project$AuditPb$requiredWithoutDefault,
																																																																																													'show_cadence_verification_instructions',
																																																																																													$elm$json$Json$Decode$bool,
																																																																																													A3(
																																																																																														$author$project$AuditPb$requiredWithoutDefault,
																																																																																														'enable_pod_in_submission_workflow',
																																																																																														$elm$json$Json$Decode$bool,
																																																																																														A3(
																																																																																															$author$project$AuditPb$optional,
																																																																																															'processor_support_email_address',
																																																																																															$elm$json$Json$Decode$string,
																																																																																															A3(
																																																																																																$author$project$AuditPb$requiredWithoutDefault,
																																																																																																'show_carrier_external_vendor_id',
																																																																																																$elm$json$Json$Decode$bool,
																																																																																																A3(
																																																																																																	$author$project$AuditPb$repeated,
																																																																																																	'non_invoice_load_document_types',
																																																																																																	$author$project$AuditPb$unresolvedDocumentTypeDecoder,
																																																																																																	A3(
																																																																																																		$author$project$AuditPb$repeated,
																																																																																																		'shipment_reference_variables',
																																																																																																		$elm$json$Json$Decode$string,
																																																																																																		A3(
																																																																																																			$author$project$AuditPb$repeated,
																																																																																																			'load_reference_variables',
																																																																																																			$elm$json$Json$Decode$string,
																																																																																																			A3(
																																																																																																				$author$project$AuditPb$requiredWithoutDefault,
																																																																																																				'allow_custom_exceptions',
																																																																																																				$elm$json$Json$Decode$bool,
																																																																																																				A3(
																																																																																																					$author$project$AuditPb$repeated,
																																																																																																					'client_notes_configuration',
																																																																																																					$author$project$AuditPb$accountSettings_ClientNoteSettingDecoder,
																																																																																																					A3(
																																																																																																						$author$project$AuditPb$requiredWithoutDefault,
																																																																																																						'client_notes_sidebar_display',
																																																																																																						$author$project$AuditPb$clientNotesSidebarDisplayDecoder,
																																																																																																						A3(
																																																																																																							$author$project$AuditPb$requiredWithoutDefault,
																																																																																																							'display_cadence_funding_notes',
																																																																																																							$elm$json$Json$Decode$bool,
																																																																																																							A3(
																																																																																																								$author$project$AuditPb$repeated,
																																																																																																								'rules_broker_custom_exception_messages',
																																																																																																								$author$project$AuditPb$customExceptionMessageDecoder,
																																																																																																								A3(
																																																																																																									$author$project$AuditPb$requiredWithoutDefault,
																																																																																																									'pod_requirement_policy',
																																																																																																									$author$project$AuditPb$podRequirementPolicyDecoder,
																																																																																																									A3(
																																																																																																										$author$project$AuditPb$requiredWithoutDefault,
																																																																																																										'feature_flags',
																																																																																																										$author$project$AuditPb$featureFlagsDecoder,
																																																																																																										A3(
																																																																																																											$author$project$AuditPb$requiredWithoutDefault,
																																																																																																											'controlled_by_tms',
																																																																																																											$author$project$AuditPb$controlledByTMSDecoder,
																																																																																																											A3(
																																																																																																												$author$project$AuditPb$repeated,
																																																																																																												'rules_broker_required_references',
																																																																																																												$author$project$AuditPb$referenceRuleDecoder,
																																																																																																												A3(
																																																																																																													$author$project$AuditPb$requiredWithoutDefault,
																																																																																																													'review_tab_verify_mode_enabled',
																																																																																																													$elm$json$Json$Decode$bool,
																																																																																																													A3(
																																																																																																														$author$project$AuditPb$requiredWithoutDefault,
																																																																																																														'review_tab_enabled',
																																																																																																														$elm$json$Json$Decode$bool,
																																																																																																														A3(
																																																																																																															$author$project$AuditPb$optional,
																																																																																																															'verifications_workflow_display_name',
																																																																																																															$elm$json$Json$Decode$string,
																																																																																																															A3(
																																																																																																																$author$project$AuditPb$optional,
																																																																																																																'verifications_workflow_email_cc_recipients',
																																																																																																																$elm$json$Json$Decode$string,
																																																																																																																A3(
																																																																																																																	$author$project$AuditPb$repeated,
																																																																																																																	'verifications_workflow_debtor_batch_item_custom_states',
																																																																																																																	$author$project$AuditPb$verificationsDebtorBatchItemCustomStateDecoder,
																																																																																																																	A3(
																																																																																																																		$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																		'verifications_workflow_enable_carrier_percentile_check',
																																																																																																																		$elm$json$Json$Decode$bool,
																																																																																																																		A3(
																																																																																																																			$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																			'verifications_workflow_send_rejected_invoices_to_tms',
																																																																																																																			$elm$json$Json$Decode$bool,
																																																																																																																			A3(
																																																																																																																				$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																				'verifications_workflow_use_cadence_notes',
																																																																																																																				$elm$json$Json$Decode$bool,
																																																																																																																				A3(
																																																																																																																					$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																					'verifications_debtor_confirmation_enabled',
																																																																																																																					$elm$json$Json$Decode$bool,
																																																																																																																					A3(
																																																																																																																						$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																						'verifications_workflow_enabled',
																																																																																																																						$elm$json$Json$Decode$bool,
																																																																																																																						A3(
																																																																																																																							$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																							'use_cadence_image_types',
																																																																																																																							$elm$json$Json$Decode$bool,
																																																																																																																							A3(
																																																																																																																								$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																								'factor_use_labels_on_processed',
																																																																																																																								$elm$json$Json$Decode$bool,
																																																																																																																								A3(
																																																																																																																									$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																									'factor_client_portal_enabled',
																																																																																																																									$elm$json$Json$Decode$bool,
																																																																																																																									A3(
																																																																																																																										$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																										'carrier_documents_account',
																																																																																																																										$elm$json$Json$Decode$bool,
																																																																																																																										A3(
																																																																																																																											$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																											'able_to_generate_customer_invoices',
																																																																																																																											$elm$json$Json$Decode$bool,
																																																																																																																											A3(
																																																																																																																												$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																												'attempt_to_auto_process_document_batches',
																																																																																																																												$elm$json$Json$Decode$bool,
																																																																																																																												A3(
																																																																																																																													$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																													'carrier_days_to_pay_integration',
																																																																																																																													$elm$json$Json$Decode$bool,
																																																																																																																													A3(
																																																																																																																														$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																														'allow_editing_carrier_payment_strategy',
																																																																																																																														$elm$json$Json$Decode$bool,
																																																																																																																														A3(
																																																																																																																															$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																															'consider_noa_data_for_verifications',
																																																																																																																															$author$project$AuditPb$considerNoaDataForVerificationsDecoder,
																																																																																																																															A3(
																																																																																																																																$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																'show_cadence_debtor_info',
																																																																																																																																$elm$json$Json$Decode$bool,
																																																																																																																																A3(
																																																																																																																																	$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																	'valid_source_date_range',
																																																																																																																																	$elm$json$Json$Decode$string,
																																																																																																																																	A3(
																																																																																																																																		$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																		'failed_cadence_transmission_recipients',
																																																																																																																																		$elm$json$Json$Decode$string,
																																																																																																																																		A3(
																																																																																																																																			$author$project$AuditPb$repeated,
																																																																																																																																			'load_customer_labels',
																																																																																																																																			$author$project$AuditPb$accountSettings_LoadCustomerLabelDecoder,
																																																																																																																																			A3(
																																																																																																																																				$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																				'allow_manual_submission_reassignment_in_submission_workflow',
																																																																																																																																				$elm$json$Json$Decode$bool,
																																																																																																																																				A3(
																																																																																																																																					$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																					'show_group_movement_buttons_in_submission_workflow',
																																																																																																																																					$elm$json$Json$Decode$bool,
																																																																																																																																					A3(
																																																																																																																																						$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																						'show_invoice_date_input_in_submission_workflow',
																																																																																																																																						$elm$json$Json$Decode$bool,
																																																																																																																																						A3(
																																																																																																																																							$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																							'factor_use_source_invoice_date',
																																																																																																																																							$elm$json$Json$Decode$bool,
																																																																																																																																							A3(
																																																																																																																																								$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																								'manually_check_third_party_listed_on_bol',
																																																																																																																																								$elm$json$Json$Decode$bool,
																																																																																																																																								A3(
																																																																																																																																									$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																									'manually_check_pickup_dropoff_matches',
																																																																																																																																									$elm$json$Json$Decode$bool,
																																																																																																																																									A3(
																																																																																																																																										$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																										'manually_check_amount_matches_rate_con',
																																																																																																																																										$elm$json$Json$Decode$bool,
																																																																																																																																										A3(
																																																																																																																																											$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																											'check_client_or_debtor_on_bol',
																																																																																																																																											$elm$json$Json$Decode$bool,
																																																																																																																																											A3(
																																																																																																																																												$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																												'use_load_customer_labels',
																																																																																																																																												$elm$json$Json$Decode$bool,
																																																																																																																																												A3(
																																																																																																																																													$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																													'uses_office_people_map',
																																																																																																																																													$elm$json$Json$Decode$bool,
																																																																																																																																													A3(
																																																																																																																																														$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																														'disable_outgoing_emails_in_submission_workflow',
																																																																																																																																														$elm$json$Json$Decode$bool,
																																																																																																																																														A3(
																																																																																																																																															$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																															'display_automated_verifications_on_submission_workflow',
																																																																																																																																															$elm$json$Json$Decode$bool,
																																																																																																																																															A3(
																																																																																																																																																$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																'use_both_submission_and_traditional_workflow',
																																																																																																																																																$elm$json$Json$Decode$bool,
																																																																																																																																																A3(
																																																																																																																																																	$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																	'use_submission_workflow',
																																																																																																																																																	$elm$json$Json$Decode$bool,
																																																																																																																																																	A3(
																																																																																																																																																		$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																		'self_serve_auto_approve_setting',
																																																																																																																																																		$elm$json$Json$Decode$bool,
																																																																																																																																																		A3(
																																																																																																																																																			$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																			'auto_approve_payables',
																																																																																																																																																			$elm$json$Json$Decode$bool,
																																																																																																																																																			A3(
																																																																																																																																																				$author$project$AuditPb$repeated,
																																																																																																																																																				'categories',
																																																																																																																																																				$author$project$AuditPb$accountSettings_CategoryDecoder,
																																																																																																																																																				A3(
																																																																																																																																																					$author$project$AuditPb$repeated,
																																																																																																																																																					'possible_carrier_labels',
																																																																																																																																																					$author$project$AuditPb$labelDecoder,
																																																																																																																																																					A3(
																																																																																																																																																						$author$project$AuditPb$repeated,
																																																																																																																																																						'labels',
																																																																																																																																																						$author$project$AuditPb$labelDecoder,
																																																																																																																																																						A3(
																																																																																																																																																							$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																							'limit_reports_to_admin',
																																																																																																																																																							$elm$json$Json$Decode$bool,
																																																																																																																																																							A3(
																																																																																																																																																								$author$project$AuditPb$repeated,
																																																																																																																																																								'payables_template_variables',
																																																																																																																																																								$elm$json$Json$Decode$string,
																																																																																																																																																								A3(
																																																																																																																																																									$author$project$AuditPb$repeated,
																																																																																																																																																									'custom_invoice_exception_messages',
																																																																																																																																																									$elm$json$Json$Decode$string,
																																																																																																																																																									A3(
																																																																																																																																																										$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																										'custom_exception_subject_template',
																																																																																																																																																										$elm$json$Json$Decode$string,
																																																																																																																																																										A3(
																																																																																																																																																											$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																											'verifications_enabled',
																																																																																																																																																											$elm$json$Json$Decode$bool,
																																																																																																																																																											A3(
																																																																																																																																																												$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																												'default_email_per_invoice',
																																																																																																																																																												$elm$json$Json$Decode$bool,
																																																																																																																																																												A3(
																																																																																																																																																													$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																													'broker_customer_portal_enabled',
																																																																																																																																																													$elm$json$Json$Decode$bool,
																																																																																																																																																													A3(
																																																																																																																																																														$author$project$AuditPb$optionalMessage,
																																																																																																																																																														'annotation_auto_stamp_document_type',
																																																																																																																																																														$author$project$AuditPb$unresolvedDocumentTypeDecoder,
																																																																																																																																																														A3(
																																																																																																																																																															$author$project$AuditPb$repeated,
																																																																																																																																																															'visible_tms_reference_field_labels',
																																																																																																																																																															$elm$json$Json$Decode$string,
																																																																																																																																																															A3(
																																																																																																																																																																$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																'quickpay_discount_disabled',
																																																																																																																																																																$elm$json$Json$Decode$bool,
																																																																																																																																																																A3(
																																																																																																																																																																	$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																	'quickpay_discount',
																																																																																																																																																																	$author$project$AuditPb$floatValueDecoder,
																																																																																																																																																																	A3(
																																																																																																																																																																		$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																		'carrier_days_to_pay',
																																																																																																																																																																		$author$project$AuditPb$intDecoder,
																																																																																																																																																																		A3(
																																																																																																																																																																			$author$project$AuditPb$repeated,
																																																																																																																																																																			'tms_line_item_types',
																																																																																																																																																																			$author$project$AuditPb$accountSettings_TMSLineItemTypeDecoder,
																																																																																																																																																																			A3(
																																																																																																																																																																				$author$project$AuditPb$optional,
																																																																																																																																																																				'carrier_invoice_amount_tolerance_line_item_type_id',
																																																																																																																																																																				$author$project$AuditPb$intDecoder,
																																																																																																																																																																				A3(
																																																																																																																																																																					$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																					'carrier_invoice_amount_tolerance_unit',
																																																																																																																																																																					$author$project$AuditPb$toleranceUnitDecoder,
																																																																																																																																																																					A3(
																																																																																																																																																																						$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																						'carrier_invoice_amount_tolerance_under',
																																																																																																																																																																						$elm$json$Json$Decode$string,
																																																																																																																																																																						A3(
																																																																																																																																																																							$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																							'carrier_invoice_amount_tolerance_over',
																																																																																																																																																																							$elm$json$Json$Decode$string,
																																																																																																																																																																							A3(
																																																																																																																																																																								$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																								'auto_generate_factor_invoice_numbers',
																																																																																																																																																																								$elm$json$Json$Decode$string,
																																																																																																																																																																								A3(
																																																																																																																																																																									$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																									'auto_generate_factor_invoice_number_strategy',
																																																																																																																																																																									$elm$json$Json$Decode$string,
																																																																																																																																																																									A3(
																																																																																																																																																																										$author$project$AuditPb$requiredWithoutDefault,
																																																																																																																																																																										'invoice_date_strategy',
																																																																																																																																																																										$elm$json$Json$Decode$string,
																																																																																																																																																																										$author$project$AuditPb$decode($author$project$AuditPb$AccountSettings)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings = $author$project$Forward$Lookup$defineNode(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$accountSettings, decoder: $author$project$AuditPb$accountSettingsDecoder, entrypoint: 'accountSettingsV2', parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Domain$DocumentId$fromInt = $author$project$Id$fromInt;
var $author$project$Domain$DocumentId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$Lookup$defineReferenceList = function (config) {
	return A2(
		$author$project$Forward$Lookup$traverseList,
		config.objectEntrypoint,
		$author$project$Forward$Lookup$defineNode(
			{
				cacheKey: config.cacheKey,
				decoder: $elm$json$Json$Decode$list(config.decoder),
				entrypoint: config.entrypoint,
				parameters: config.parameters
			}));
};
var $author$project$AuditPb$Document = function (id) {
	return function (number) {
		return function (carrierInvoiceId) {
			return function (documentGroupId) {
				return function (documentBatchId) {
					return function (factorInvoiceId) {
						return function (createdAt) {
							return function (inlineDownloadUrl) {
								return function (previewable) {
									return function (brokerEmailAddresses) {
										return function (token) {
											return function (hidden) {
												return function (isSigned) {
													return function (hasReferenceNumber) {
														return function (isPOD) {
															return function (includesPOD) {
																return function (hasMissingPages) {
																	return function (hasDamage) {
																		return function (hasCarrierRate) {
																			return function (finished) {
																				return function (documentTypeValue) {
																					return function (guessedDocumentTypeValue) {
																						return {brokerEmailAddresses: brokerEmailAddresses, carrierInvoiceId: carrierInvoiceId, createdAt: createdAt, documentBatchId: documentBatchId, documentGroupId: documentGroupId, documentTypeValue: documentTypeValue, factorInvoiceId: factorInvoiceId, finished: finished, guessedDocumentTypeValue: guessedDocumentTypeValue, hasCarrierRate: hasCarrierRate, hasDamage: hasDamage, hasMissingPages: hasMissingPages, hasReferenceNumber: hasReferenceNumber, hidden: hidden, id: id, includesPOD: includesPOD, inlineDownloadUrl: inlineDownloadUrl, isPOD: isPOD, isSigned: isSigned, number: number, previewable: previewable, token: token};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$Document_DocumentTypeValue_DocumentType = function (a) {
	return {$: 'Document_DocumentTypeValue_DocumentType', a: a};
};
var $author$project$AuditPb$Document_DocumentTypeValue_DocumentTypePartial = function (a) {
	return {$: 'Document_DocumentTypeValue_DocumentTypePartial', a: a};
};
var $author$project$AuditPb$Document_DocumentTypeValue_UnknownDocumentType = function (a) {
	return {$: 'Document_DocumentTypeValue_UnknownDocumentType', a: a};
};
var $author$project$AuditPb$Document_UnknownDocumentType = {};
var $author$project$AuditPb$document_UnknownDocumentTypeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Document_UnknownDocumentType);
	});
var $author$project$AuditPb$document_DocumentTypeValueDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Document_DocumentTypeValue_DocumentType,
					A2($elm$json$Json$Decode$field, 'document_type', $author$project$AuditPb$documentTypeDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Document_DocumentTypeValue_DocumentTypePartial,
					A2($elm$json$Json$Decode$field, 'document_type_partial', $author$project$AuditPb$documentTypePartialDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Document_DocumentTypeValue_UnknownDocumentType,
					A2($elm$json$Json$Decode$field, 'unknown_document_type', $author$project$AuditPb$document_UnknownDocumentTypeDecoder)),
					$elm$json$Json$Decode$fail('Document_DocumentTypeValue_Unspecified')
				]));
	});
var $author$project$AuditPb$Document_GuessedDocumentTypeValue_DocumentType = function (a) {
	return {$: 'Document_GuessedDocumentTypeValue_DocumentType', a: a};
};
var $author$project$AuditPb$Document_GuessedDocumentTypeValue_DocumentTypePartial = function (a) {
	return {$: 'Document_GuessedDocumentTypeValue_DocumentTypePartial', a: a};
};
var $author$project$AuditPb$Document_GuessedDocumentTypeValue_UnknownDocumentType = function (a) {
	return {$: 'Document_GuessedDocumentTypeValue_UnknownDocumentType', a: a};
};
var $author$project$AuditPb$document_GuessedDocumentTypeValueDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Document_GuessedDocumentTypeValue_DocumentType,
					A2($elm$json$Json$Decode$field, 'guessed_document_type', $author$project$AuditPb$documentTypeDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Document_GuessedDocumentTypeValue_DocumentTypePartial,
					A2($elm$json$Json$Decode$field, 'guessed_document_type_partial', $author$project$AuditPb$documentTypePartialDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Document_GuessedDocumentTypeValue_UnknownDocumentType,
					A2($elm$json$Json$Decode$field, 'guessed_unknown_document_type', $author$project$AuditPb$document_UnknownDocumentTypeDecoder)),
					$elm$json$Json$Decode$fail('Document_GuessedDocumentTypeValue_Unspecified')
				]));
	});
var $author$project$Domain$CarrierInvoiceId$fromInt = $author$project$Id$fromInt;
var $author$project$Domain$DocumentGroupId$DocumentGroupId = function (a) {
	return {$: 'DocumentGroupId', a: a};
};
var $author$project$Domain$DocumentGroupId$fromInt = function (_int) {
	return $author$project$Domain$DocumentGroupId$DocumentGroupId(_int);
};
var $author$project$Domain$FactorInvoiceId$fromInt = $author$project$Id$fromInt;
var $author$project$AuditPb$documentDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$document_GuessedDocumentTypeValueDecoder,
			A2(
				$author$project$AuditPb$field,
				$author$project$AuditPb$document_DocumentTypeValueDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'finished',
					$elm$json$Json$Decode$bool,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'has_carrier_rate',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'has_damage',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'has_missing_pages',
								$elm$json$Json$Decode$bool,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'includes_pod',
									$elm$json$Json$Decode$bool,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'is_pod',
										$elm$json$Json$Decode$bool,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'has_reference_number',
											$elm$json$Json$Decode$bool,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'is_signed',
												$elm$json$Json$Decode$bool,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'hidden',
													$elm$json$Json$Decode$bool,
													A3(
														$author$project$AuditPb$optional,
														'token',
														$elm$json$Json$Decode$string,
														A3(
															$author$project$AuditPb$repeated,
															'broker_email_addresses',
															$elm$json$Json$Decode$string,
															A3(
																$author$project$AuditPb$requiredWithoutDefault,
																'previewable',
																$elm$json$Json$Decode$bool,
																A3(
																	$author$project$AuditPb$requiredWithoutDefault,
																	'inline_download_url',
																	$elm$json$Json$Decode$string,
																	A3(
																		$author$project$AuditPb$requiredWithoutDefault,
																		'created_at',
																		$author$project$AuditPb$timestampDecoder,
																		A3(
																			$author$project$AuditPb$optional,
																			'factor_invoice_id',
																			A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
																			A3(
																				$author$project$AuditPb$optional,
																				'document_batch_id',
																				A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $author$project$AuditPb$intDecoder),
																				A3(
																					$author$project$AuditPb$optional,
																					'document_group_id',
																					A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentGroupId$fromInt, $author$project$AuditPb$intDecoder),
																					A3(
																						$author$project$AuditPb$optional,
																						'carrier_invoice_id',
																						A2($elm$json$Json$Decode$map, $author$project$Domain$CarrierInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
																						A3(
																							$author$project$AuditPb$requiredWithoutDefault,
																							'number',
																							$author$project$AuditPb$intDecoder,
																							A3(
																								$author$project$AuditPb$requiredWithoutDefault,
																								'id',
																								A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
																								$author$project$AuditPb$decode($author$project$AuditPb$Document)))))))))))))))))))))));
	});
var $author$project$Forward$AppSpecific$Cache$documentV2 = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentV2;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentV2: e});
		}));
var $author$project$Domain$DocumentId$toInt = $author$project$Id$toInt;
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2 = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$documentV2,
		decoder: $author$project$AuditPb$documentDecoder,
		entrypoint: 'documentV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$list_documentId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_documentId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_documentId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentId,
		decoder: $author$project$Domain$DocumentId$decode,
		entrypoint: 'documentIdsByDocumentBatchId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentBatchId$toInt)
	});
var $timo_weike$generic_collections$ManualDict$Dict = function (a) {
	return {$: 'Dict', a: a};
};
var $timo_weike$generic_collections$ManualDict$fromList = F2(
	function (f, list) {
		return $timo_weike$generic_collections$ManualDict$Dict(
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (t) {
						return _Utils_Tuple2(
							f(t.a),
							t);
					},
					list)));
	});
var $author$project$Forward$Lookup$map = F2(
	function (f, _v0) {
		var nested = _v0.a;
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: nested.decoderConfig,
				invalidate: nested.invalidate,
				load: F3(
					function (cache, requiredTimestamp, k) {
						return A2(
							$author$project$Forward$Internal$Loadable$map,
							f,
							A3(nested.load, cache, requiredTimestamp, k));
					}),
				preloadBranches: nested.preloadBranches,
				structure: nested.structure
			});
	});
var $author$project$Components$ToBeScrapedLoadsPage$loadData = function (model) {
	var loadDocumentBatchData = A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2,
			$author$project$Forward$Lookup$succeed($author$project$Components$ToBeScrapedLoadsPage$DocumentBatchData)));
	var loadDocumentBatches = A2(
		$author$project$Forward$Lookup$map,
		$timo_weike$generic_collections$ManualDict$fromList($author$project$Domain$DocumentBatchId$toInt),
		A2(
			$author$project$Forward$Lookup$startFromList,
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.documentBatchId;
				},
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.loads;
						},
						$author$project$Forward$Remote$toMaybe(model.legacyDataLoads)))),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(loadDocumentBatchData),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$identity,
					$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)))));
	return A2(
		$author$project$Forward$Lookup$apply,
		loadDocumentBatches,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				$author$project$Forward$Lookup$succeed($author$project$Components$ToBeScrapedLoadsPage$Data))));
};
var $author$project$Components$ToBeScrapedLoadsPage$RequeueLoadResponse = function (a) {
	return {$: 'RequeueLoadResponse', a: a};
};
var $author$project$HubTran$Flash$alert = function (msg) {
	return {indefinite: false, level: 'alert', message: msg, position: 'top', time: $elm$core$Maybe$Nothing, title: $elm$core$Maybe$Nothing};
};
var $author$project$HubTran$InspectableEffect$flash = $author$project$HubTran$InspectableEffect$Flash;
var $author$project$HubTran$Effect$flash = A2($elm$core$Basics$composeL, $author$project$HubTran$Effect$InspectableEffect, $author$project$HubTran$InspectableEffect$flash);
var $timo_weike$generic_collections$ManualSet$insert = F3(
	function (f, v, _v0) {
		var dict = _v0.a;
		return $timo_weike$generic_collections$ManualSet$Set(
			A3(
				$elm$core$Dict$insert,
				f(v),
				v,
				dict));
	});
var $elm_community$result_extra$Result$Extra$merge = function (r) {
	if (r.$ === 'Ok') {
		var rr = r.a;
		return rr;
	} else {
		var rr = r.a;
		return rr;
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Components$ToBeScrapedLoadsPage$refreshLoads = F3(
	function (filters, newPage, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{activeFilters: filters, currentPage: newPage, legacyDataLoads: $author$project$Forward$Remote$Loading, selectedLoads: $timo_weike$generic_collections$ManualSet$empty}),
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						$author$project$HubTran$Effect$pushUrl(
						A2(
							$elm$url$Url$Builder$relative,
							_List_Nil,
							function () {
								var encodeParamIfNotDefaultValue = F3(
									function (paramName, getField, urlBuilder) {
										return (!_Utils_eq(
											getField(filters),
											getField($author$project$Components$ToBeScrapedLoadsPage$emptyFilters))) ? $elm$core$Maybe$Just(
											A2(
												urlBuilder,
												paramName,
												getField(filters))) : $elm$core$Maybe$Nothing;
									});
								return A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											A3(
											encodeParamIfNotDefaultValue,
											'search_term',
											function ($) {
												return $.searchTerm;
											},
											$elm$url$Url$Builder$string),
											A3(
											encodeParamIfNotDefaultValue,
											'carrier',
											function ($) {
												return $.carrier;
											},
											$elm$url$Url$Builder$string),
											A3(
											encodeParamIfNotDefaultValue,
											'delivered_after',
											function ($) {
												return $.deliveredAfter;
											},
											$elm$url$Url$Builder$string),
											A3(
											encodeParamIfNotDefaultValue,
											'delivered_before',
											function ($) {
												return $.deliveredBefore;
											},
											$elm$url$Url$Builder$string),
											A3(
											encodeParamIfNotDefaultValue,
											'invoiced_after',
											function ($) {
												return $.invoicedAfter;
											},
											$elm$url$Url$Builder$string),
											A3(
											encodeParamIfNotDefaultValue,
											'invoiced_before',
											function ($) {
												return $.invoicedBefore;
											},
											$elm$url$Url$Builder$string),
											A3(
											encodeParamIfNotDefaultValue,
											'with_invoice',
											function ($) {
												return $.withInvoice;
											},
											$author$project$Helpers$Url$Builder$bool),
											A3(
											encodeParamIfNotDefaultValue,
											'with_documents',
											function ($) {
												return $.withDocuments;
											},
											$author$project$Helpers$Url$Builder$bool),
											$elm$core$Maybe$Just(
											A2($elm$url$Url$Builder$int, 'page', newPage))
										]));
							}())),
						A2(
						$author$project$HubTran$Effect$sendCacheableRequest,
						$author$project$Components$ToBeScrapedLoadsPage$BackendResponseToBeScrapedLoads,
						A2($author$project$Components$ToBeScrapedLoadsPage$loadToBeScrapedLoads, filters, newPage))
					])));
	});
var $timo_weike$generic_collections$ManualSet$remove = F3(
	function (f, v, _v0) {
		var dict = _v0.a;
		return $timo_weike$generic_collections$ManualSet$Set(
			A2(
				$elm$core$Dict$remove,
				f(v),
				dict));
	});
var $author$project$HubTran$Flash$success = function (msg) {
	return {indefinite: false, level: 'success', message: msg, position: 'top', time: $elm$core$Maybe$Nothing, title: $elm$core$Maybe$Nothing};
};
var $author$project$Domain$ToBeScrapedLoadId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Domain$ToBeScrapedLoadId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Components$ToBeScrapedLoadsPage$updateFilters = F2(
	function (filtersUiMsg, filters) {
		switch (filtersUiMsg.$) {
			case 'ChangeSearchTerm':
				var newSearchTerm = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{searchTerm: newSearchTerm});
			case 'ChangeCarrier':
				var newCarrier = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{carrier: newCarrier});
			case 'ChangeCustomer':
				var newCustomer = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{customer: newCustomer});
			case 'ChangeDeliveredAfter':
				var newDeliveredAfter = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{deliveredAfter: newDeliveredAfter});
			case 'ChangeDeliveredBefore':
				var newDelieveredBefore = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{deliveredBefore: newDelieveredBefore});
			case 'ChangeWithDocuments':
				var newWithDocuments = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{withDocuments: newWithDocuments});
			case 'ChangeWithCustomerInvoice':
				var newWithInvoice = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{withInvoice: newWithInvoice});
			case 'ChangeInvoicedAfter':
				var newInvoicedAfter = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{invoicedAfter: newInvoicedAfter});
			default:
				var newInvoicedBefore = filtersUiMsg.a;
				return _Utils_update(
					filters,
					{invoicedBefore: newInvoicedBefore});
		}
	});
var $author$project$Components$ToBeScrapedLoadsPage$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'SetTimezone':
				var tz = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{tz: tz}),
					$author$project$HubTran$Effect$none);
			case 'BackendResponseCarriers':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var carriers = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								legacyDataCarriers: $author$project$Forward$Remote$Loaded(carriers)
							}),
						$author$project$HubTran$Effect$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								legacyDataCarriers: $author$project$Forward$Remote$Error(
									$author$project$Forward$Remote$Unloadable(
										$elm$core$Debug$toString(error)))
							}),
						$author$project$HubTran$Effect$none);
				}
			case 'BackendResponseToBeScrapedLoads':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								legacyDataLoads: $author$project$Forward$Remote$Loaded(response)
							}),
						$author$project$HubTran$Effect$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								legacyDataLoads: $author$project$Forward$Remote$Error(
									$author$project$Forward$Remote$Unloadable(
										$elm$core$Debug$toString(error)))
							}),
						$author$project$HubTran$Effect$none);
				}
			case 'ToggleLoadSelected':
				var toBeScrapedLoadId = msg.a;
				var newSelected = msg.b;
				var updateSet = newSelected ? $timo_weike$generic_collections$ManualSet$insert($author$project$Domain$ToBeScrapedLoadId$toInt) : $timo_weike$generic_collections$ManualSet$remove($author$project$Domain$ToBeScrapedLoadId$toInt);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedLoads: A2(updateSet, toBeScrapedLoadId, model.selectedLoads)
						}),
					$author$project$HubTran$Effect$none);
			case 'SelectAllLoads':
				var newSelected = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedLoads: function () {
								if (newSelected) {
									var _v3 = $author$project$Forward$Remote$toMaybe(model.legacyDataLoads);
									if (_v3.$ === 'Just') {
										var loads = _v3.a.loads;
										return A2(
											$timo_weike$generic_collections$ManualSet$fromList,
											$author$project$Domain$ToBeScrapedLoadId$toInt,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.id;
												},
												loads));
									} else {
										return model.selectedLoads;
									}
								} else {
									return $timo_weike$generic_collections$ManualSet$empty;
								}
							}()
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleDocumentTypeSelected':
				var documentType = msg.a;
				var newSelected = msg.b;
				var updateSet = newSelected ? $timo_weike$generic_collections$ManualSet$insert($author$project$AuditPb$documentTypeToString) : $timo_weike$generic_collections$ManualSet$remove($author$project$AuditPb$documentTypeToString);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedDocumentTypes: A2(updateSet, documentType, model.selectedDocumentTypes)
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangePage':
				var newPage = msg.a;
				return A3($author$project$Components$ToBeScrapedLoadsPage$refreshLoads, model.activeFilters, newPage, model);
			case 'ChangeFilters':
				var filtersUiMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							filtersUiState: A2($author$project$Components$ToBeScrapedLoadsPage$updateFilters, filtersUiMsg, model.filtersUiState)
						}),
					$author$project$HubTran$Effect$none);
			case 'ClearFilters':
				return A3(
					$author$project$Components$ToBeScrapedLoadsPage$refreshLoads,
					$author$project$Components$ToBeScrapedLoadsPage$emptyFilters,
					1,
					_Utils_update(
						model,
						{filtersUiState: $author$project$Components$ToBeScrapedLoadsPage$emptyFilters}));
			case 'SubmitFilters':
				return A3($author$project$Components$ToBeScrapedLoadsPage$refreshLoads, model.filtersUiState, 1, model);
			case 'RequeueLoad':
				var loadId = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequest,
						$author$project$Components$ToBeScrapedLoadsPage$RequeueLoadResponse,
						A2(
							$author$project$Forward$CacheableRequest$requestWithIgnoredResponseBody,
							{
								body: $elm$core$Maybe$Nothing,
								errorDecoder: function (_v4) {
									return $elm$json$Json$Decode$succeed(_Utils_Tuple0);
								},
								headers: _List_Nil,
								method: 'POST',
								timeout: $elm$core$Maybe$Nothing,
								url: '/api/to_be_scraped_loads/' + ($author$project$Domain$ToBeScrapedLoadId$toString(loadId) + '/retry_load')
							},
							$elm$core$Result$map($elm_community$result_extra$Result$Extra$merge))));
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$success('Load successfully queued for document retrieval.')));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$alert('There was a problem queueing that load for document retrieval.')));
				}
		}
	});
var $author$project$Components$LegacyReact$DisablingButton$SubmitForm = {$: 'SubmitForm'};
var $elm$html$Html$Attributes$action = function (uri) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'action',
		_VirtualDom_noJavaScriptUri(uri));
};
var $author$project$Forward$Remote$andThen = F2(
	function (f, remote) {
		switch (remote.$) {
			case 'Loading':
				return $author$project$Forward$Remote$Loading;
			case 'Loaded':
				var a = remote.a;
				return f(a);
			default:
				var error = remote.a;
				return $author$project$Forward$Remote$Error(error);
		}
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $timo_weike$generic_collections$ManualDict$get = F3(
	function (f, key, _v0) {
		var dict = _v0.a;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				f(key),
				dict));
	});
var $timo_weike$generic_collections$ManualSet$isEmpty = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Forward$Remote$isResolved = function (remote) {
	switch (remote.$) {
		case 'Loading':
			return false;
		case 'Loaded':
			return true;
		default:
			return true;
	}
};
var $elm$html$Html$Attributes$method = $elm$html$Html$Attributes$stringProperty('method');
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Components$ToBeScrapedLoadsPage$ToggleDocumentTypeSelected = F2(
	function (a, b) {
		return {$: 'ToggleDocumentTypeSelected', a: a, b: b};
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $author$project$Domain$Environment$BrokerEnvironment = {$: 'BrokerEnvironment'};
var $author$project$Domain$Environment$FactorEnvironment = {$: 'FactorEnvironment'};
var $author$project$Domain$Account$environment = function (account) {
	return account.factorAccount ? $author$project$Domain$Environment$FactorEnvironment : $author$project$Domain$Environment$BrokerEnvironment;
};
var $author$project$Domain$DocumentType$toDefaultString = F2(
	function (environment, knownType) {
		switch (knownType.$) {
			case 'DocumentTypeAdvanceRequest':
				return 'Advance Request';
			case 'DocumentTypeInvoice':
				switch (environment.$) {
					case 'FactorEnvironment':
						return 'Client Invoice / Billing Statement';
					case 'BrokerEnvironment':
						return 'Carrier Invoice / Billing Statement';
					default:
						return 'Vendor Invoice';
				}
			case 'DocumentTypeBillOfLading':
				return 'Bill of Lading / Packing Slip';
			case 'DocumentTypeLaborReceipt':
				return 'Lumper / Other Accessorial Receipt';
			case 'DocumentTypeDeliveryOrder':
				return 'Delivery Order';
			case 'DocumentTypeProofOfDelivery':
				switch (environment.$) {
					case 'FactorEnvironment':
						return 'Delivery Receipt';
					case 'BrokerEnvironment':
						return 'Delivery Receipt';
					default:
						return 'Proof of Delivery';
				}
			case 'DocumentTypeCustomerInvoice':
				switch (environment.$) {
					case 'FactorEnvironment':
						return 'Debtor Invoice';
					case 'BrokerEnvironment':
						return 'Customer Invoice';
					default:
						return 'Customer Invoice';
				}
			case 'DocumentTypeFactorInvoice':
				return 'Factor Invoice / Billing Statement';
			case 'DocumentTypeFundingForm':
				return 'Funding Request Form';
			case 'DocumentTypeLetterOfAssignment':
				return 'Letter Of Assignment';
			case 'DocumentTypeNmfcCertificate':
				return 'NMFC / W & I Certificate';
			case 'DocumentTypeNoticeOfAssignment':
				return 'Notice Of Assignment';
			case 'DocumentTypeNoticeOfRelease':
				return 'Notice Of Release';
			case 'DocumentTypeCustomerDocumentsOther':
				return 'Customer Documents - Other';
			case 'DocumentTypeInternalDocumentsOther':
				if (environment.$ === 'ForwarderEnvironment') {
					return 'Miscellaneous';
				} else {
					return 'Internal Documents - Other';
				}
			case 'DocumentTypePostal':
				return 'Postal';
			case 'DocumentTypePackingSlip':
				return 'Packing Slip';
			case 'DocumentTypeRateConfirmation':
				return 'Rate Confirmation';
			case 'DocumentTypeTir':
				return 'Trailer Interchange Report';
			case 'DocumentTypeVoidedCheck':
				return 'Voided Check';
			case 'DocumentTypeWeightTicket':
				return 'Weight Ticket / Gate Pass';
			case 'DocumentTypeDriverForm':
				return 'Driver Form';
			case 'DocumentTypeEscortReceipt':
				return 'Escort Receipt';
			case 'DocumentTypeExitPass':
				return 'Exit Pass';
			case 'DocumentTypeFerryReceipt':
				return 'Ferry Receipt';
			case 'DocumentTypeRepairItem':
				return 'Repair Item';
			case 'DocumentTypeRunTicket':
				return 'Run Ticket';
			case 'DocumentTypeSteamingReceipt':
				return 'Steaming Receipt';
			case 'DocumentTypeTollReceipt':
				return 'Toll Receipt';
			case 'DocumentTypeWashReceipt':
				return 'Wash Receipt';
			case 'DocumentTypeAuditSheet':
				return 'Audit Sheet';
			case 'DocumentTypeInsuranceCertificate':
				return 'Insurance Certificate';
			case 'DocumentTypeContract':
				return 'Contract';
			case 'DocumentTypeCustomerTender':
				return 'Customer Rate Confirmation';
			case 'DocumentTypeCarrierInvoice':
				return 'Carrier Invoice';
			case 'DocumentTypeCarrierRateConfirmation':
				return 'Carrier Rate Confirmation';
			case 'DocumentTypeDetentionApproval':
				return 'Detention Approval';
			case 'DocumentTypeLayoverApproval':
				return 'Layover Approval';
			case 'DocumentTypeLumperApproval':
				return 'Lumper Approval';
			case 'DocumentTypeTonuApproval':
				return 'TONU Approval';
			case 'DocumentTypeMxBol':
				return 'MX BOL';
			case 'DocumentTypeEmailApproval':
				return 'Email Approval';
			case 'DocumentTypeVendorInvoice':
				return 'Vendor Invoice';
			case 'DocumentTypeBalanceDue':
				return 'Balance Due';
			case 'DocumentTypeClaim':
				return 'Claim';
			case 'DocumentTypeCoMCHeck':
				return 'Comcheck';
			case 'DocumentTypeCustomsDocument':
				return 'Customs Document';
			case 'DocumentTypeAchSetupForm':
				return 'ACH Setup Form';
			case 'DocumentTypeAuthority':
				return 'Authority';
			case 'DocumentTypeW9':
				return 'W9';
			case 'DocumentTypeQuote':
				return 'Quote Doc';
			case 'DocumentTypeExport':
				return 'Export Doc';
			case 'DocumentTypeMasterBillOfLading':
				return 'Master Bill of Lading';
			case 'DocumentTypeHouseBillOfLading':
				return 'House Bill of Lading';
			case 'DocumentTypeWaybill':
				return 'Waybill';
			case 'DocumentTypeCommercialInvoice':
				return 'Commercial Invoice';
			case 'DocumentTypePackingList':
				return 'Packing List';
			case 'DocumentTypeCertificateOfOrigin':
				return 'Certificate of Origin';
			case 'DocumentTypePickupInspectionCertificate':
				return 'Pickup Inspection';
			case 'DocumentTypeDropoffInspectionCertificate':
				return 'Dropoff Inspection';
			case 'DocumentTypeInspectionCertificate':
				return 'Inspection Certificate';
			case 'DocumentTypePalletReceipt':
				return 'Pallet Receipt';
			case 'DocumentTypePurchaseOrder':
				return 'Purchase Order';
			case 'DocumentTypeLetterOfCredit':
				return 'Letter of Credit';
			case 'DocumentTypePreAlert':
				return 'Pre-Alert';
			case 'DocumentTypeShippersLetterOfInstruction':
				return 'Shipper\u0027s Letter of Instruction';
			case 'DocumentTypeManifest':
				return 'Manifest';
			case 'DocumentTypeHouseAirwayBill':
				return 'House Airway Bill of Lading';
			case 'DocumentTypeMasterAirwayBill':
				return 'Master Airway Bill of Lading';
			case 'DocumentTypeHouseOceanBillOfLading':
				return 'House Ocean Bill of Lading';
			case 'DocumentTypeMasterOceanBillOfLading':
				return 'Master Ocean Bill of Lading';
			case 'DocumentTypeTruckBillOfLading':
				return 'Truck Bill of Lading';
			case 'DocumentTypeWeightTicketUnloaded':
				return 'Weight Ticket (Unloaded)';
			case 'DocumentTypeBookingRequest':
				return 'Booking Request';
			case 'DocumentTypeIsfFilingInstruction':
				return 'ISF Filing Instruction';
			case 'DocumentTypeProformaInvoice':
				return 'Proforma Invoice';
			case 'DocumentTypeCustomsClearanceRequest':
				return 'Customs Clearance Request';
			case 'DocumentTypeCustomsEntrySummary':
				return 'Customs Entry Summary';
			case 'DocumentTypeIntermodalInTransitNotice':
				return 'Intermodal In-Transit Notice';
			case 'DocumentTypeFreetimeNotification':
				return 'Freetime Notification';
			case 'DocumentTypeArrivalNotice':
				return 'Arrival Notice';
			case 'DocumentTypeExportDeclaration':
				return 'Export Declaration';
			case 'DocumentTypeAgentInvoice':
				return 'Agent Invoice';
			case 'DocumentTypeCustomerRelease':
				return 'Customer Release';
			case 'DocumentTypeCustomsPowerOfAttorney':
				return 'Customs Power of Attorney';
			case 'DocumentTypeTrackingStatus':
				return 'Tracking Status';
			case 'DocumentTypeDeclarationCertificate':
				return 'Declaration/Certificate';
			case 'DocumentTypeDangerousGoodsDeclaration':
				return 'Dangerous Goods Declaration';
			case 'DocumentTypeFreightLabel':
				return 'Freight Label';
			case 'DocumentTypeBookingConfirmation':
				return 'Booking Confirmation';
			case 'DocumentTypeClaimNotice':
				return 'Claim Notice';
			case 'DocumentTypeCorrectionNotice':
				return 'Correction Notice (CCA)';
			case 'DocumentTypeCustomsAuthority':
				return 'Customs Authority';
			case 'DocumentTypeExportAuthority':
				return 'Export Authority';
			case 'DocumentTypeAuthorizationRelease':
				return 'Authorization Release';
			case 'DocumentTypeVeterinaryCertificate':
				return 'Veterinary Certificate';
			case 'DocumentTypeSanitaryCertificate':
				return 'Sanitary Certificate';
			case 'DocumentTypeMotorVehicleCertificate':
				return 'Motor Vehicle Certificate';
			case 'DocumentTypeFumigationCertificate':
				return 'Fumigation Certificate';
			case 'DocumentTypeShippersSecurityDeclaration':
				return 'Shipper\u0027s Security Declaration';
			case 'DocumentTypeNaftaCertificate':
				return 'NAFTA Certificate';
			case 'DocumentTypeCartageAdviceWithReceipt':
				return 'Cartage Advice with Receipt';
			case 'DocumentTypeUsCustomsDocument':
				return 'US Customs Document';
			case 'DocumentTypeWeightMeasurementReport':
				return 'Weight/Measurement Report';
			case 'DocumentTypePermitToTransfer':
				return 'Permit to Transfer';
			case 'DocumentTypeGatePass':
				return 'Gate Pass';
			case 'DocumentTypeTelexRelease':
				return 'Telex Release';
			case 'DocumentTypePickupNumber':
				return 'Pickup Number';
			case 'DocumentTypeForm1113':
				return 'Form 1113';
			case 'DocumentTypeGovernmentBillOfLading':
				return 'Government Bill Of Lading';
			case 'DocumentTypeInternationalBillOfLading':
				return 'International Bill Of Lading';
			case 'DocumentTypeInternalProofOfDelivery':
				return 'Internal Proof Of Delivery';
			case 'DocumentTypeDemurrageReceipt':
				return 'Demurrage Receipt';
			case 'DocumentTypePerDiemReceipt':
				return 'Per Diem Receipt';
			case 'DocumentTypePermit':
				return 'Permit';
			case 'DocumentTypeElectronicInterchangeReceipt':
				return 'Electronic Interchange Receipt';
			case 'DocumentTypeAsbestosDeclaration':
				return 'Asbestos Declaration';
			case 'DocumentTypeAusfta':
				return 'AUSFTA';
			case 'DocumentTypeMsds':
				return 'MSDS';
			case 'DocumentTypeSolasForm':
				return 'SOLAS Form';
			case 'DocumentTypePackingDeclaration':
				return 'Packing Declaration';
			case 'DocumentTypeConsignmentSecurityDeclaration':
				return 'Consignment Security Declaration';
			case 'DocumentTypeB3CanadianCustomsEntry':
				return 'B3 - Canadian Customs Entry';
			case 'DocumentTypeVgmContainerInformation':
				return 'VGM/Container Information';
			case 'DocumentTypeUnknownCadenceImport':
				return 'Unknown (Imported from Cadence)';
			case 'DocumentTypeUnknown':
				return 'Unknown';
			case 'DocumentTypePerDiemInvoice':
				return 'Per Diem Invoice';
			case 'DocumentTypeWasteManifest':
				return 'Waste Manifest';
			case 'DocumentTypeHiddenBillOfLading':
				return 'Bill of Lading (Hidden)';
			case 'DocumentTypeLegacyFactoringAssignment':
				return 'Factoring Assignment (Legacy)';
			case 'DocumentTypeLegacyLoadTender':
				return 'Load Tender (Legacy)';
			case 'DocumentTypeCombinedNoaLor':
				return 'Combined NOA/LOR';
			default:
				return 'Fine';
		}
	});
var $author$project$Domain$DocumentType$toString = F3(
	function (customDocumentTypeNames, environment, knownType) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Domain$DocumentType$toDefaultString, environment, knownType),
			A2(
				$elm$core$Dict$get,
				$author$project$AuditPb$documentTypeToString(knownType),
				customDocumentTypeNames));
	});
var $author$project$Domain$UnresolvedDocumentType$toString = F3(
	function (customDocumentTypeNames, environment, unresolvedDocumentType) {
		switch (unresolvedDocumentType.$) {
			case 'Resolved':
				var documentType = unresolvedDocumentType.a;
				return A3($author$project$Domain$DocumentType$toString, customDocumentTypeNames, environment, documentType);
			case 'Unknown':
				return 'Unknown';
			default:
				var partialDocumentType = unresolvedDocumentType.a;
				switch (partialDocumentType.$) {
					case 'DocumentTypePartialPartiallySpecifiedOcean':
						return 'Ocean Bill of Lading (House or Master)';
					case 'DocumentTypePartialPartiallySpecifiedAirway':
						return 'Airway Bill of Lading (House or Master)';
					default:
						return 'Bill of Lading (House or Master)';
				}
		}
	});
var $author$project$Domain$Helpers$documentTypeToString = F3(
	function (account, accountSettings, documentType) {
		return A3(
			$author$project$Domain$UnresolvedDocumentType$toString,
			accountSettings.customDocumentTypeNames,
			$author$project$Domain$Account$environment(account),
			documentType);
	});
var $timo_weike$generic_collections$ManualSet$member = F3(
	function (f, v, _v0) {
		var dict = _v0.a;
		return A2(
			$elm$core$Dict$member,
			f(v),
			dict);
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Components$ToBeScrapedLoadsPage$viewDocumentTypeFilter = F3(
	function (data, model, documentType) {
		var isSelected = A3($timo_weike$generic_collections$ManualSet$member, $author$project$AuditPb$documentTypeToString, documentType, model.selectedDocumentTypes);
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$name('document_types[]'),
							$elm$html$Html$Attributes$value(
							$author$project$AuditPb$documentTypeToString(documentType)),
							$elm$html$Html$Attributes$checked(isSelected),
							$elm$html$Html$Events$onCheck(
							$author$project$Components$ToBeScrapedLoadsPage$ToggleDocumentTypeSelected(documentType))
						]),
					_List_Nil),
					$elm$html$Html$text(' '),
					$elm$html$Html$text(
					A3(
						$author$project$Domain$Helpers$documentTypeToString,
						data.account,
						data.accountSettings,
						$author$project$Domain$UnresolvedDocumentType$Resolved(documentType)))
				]));
	});
var $author$project$Components$ToBeScrapedLoadsPage$ChangeCarrier = function (a) {
	return {$: 'ChangeCarrier', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeCustomer = function (a) {
	return {$: 'ChangeCustomer', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeDeliveredAfter = function (a) {
	return {$: 'ChangeDeliveredAfter', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeDeliveredBefore = function (a) {
	return {$: 'ChangeDeliveredBefore', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeFilters = function (a) {
	return {$: 'ChangeFilters', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeInvoicedAfter = function (a) {
	return {$: 'ChangeInvoicedAfter', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeInvoicedBefore = function (a) {
	return {$: 'ChangeInvoicedBefore', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeSearchTerm = function (a) {
	return {$: 'ChangeSearchTerm', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeWithCustomerInvoice = function (a) {
	return {$: 'ChangeWithCustomerInvoice', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$ChangeWithDocuments = function (a) {
	return {$: 'ChangeWithDocuments', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$SubmitFilters = {$: 'SubmitFilters'};
var $author$project$Domain$Account$BrokerAccount = {$: 'BrokerAccount'};
var $author$project$Domain$Account$FactorAccount = {$: 'FactorAccount'};
var $author$project$Domain$Account$accountType = function (account) {
	return account.factorAccount ? $author$project$Domain$Account$FactorAccount : $author$project$Domain$Account$BrokerAccount;
};
var $author$project$Domain$Account$carrierTerm = function (accountType_) {
	if (accountType_.$ === 'FactorAccount') {
		return 'Client';
	} else {
		return 'Carrier';
	}
};
var $author$project$Domain$Account$carrierTermForAccount = function (account) {
	return $author$project$Domain$Account$carrierTerm(
		$author$project$Domain$Account$accountType(account));
};
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$Components$ToBeScrapedLoadsPage$ClearFilters = {$: 'ClearFilters'};
var $author$project$Components$ToBeScrapedLoadsPage$maybeViewClearButton = F2(
	function (isLoaded, filters) {
		return _Utils_eq(filters, $author$project$Components$ToBeScrapedLoadsPage$emptyFilters) ? $elm$html$Html$text('') : $author$project$Components$LegacyReact$DisablingButton$view(
			{
				disabled: !isLoaded,
				disabledClasses: $elm$core$Maybe$Just(
					_List_fromArray(
						['button--cancel'])),
				disabledText: '',
				enabledClasses: _List_fromArray(
					['button--cancel']),
				onClick: $author$project$Components$LegacyReact$DisablingButton$ElmMessage($author$project$Components$ToBeScrapedLoadsPage$ClearFilters),
				text: 'Clear Filters'
			});
	});
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Components$ToBeScrapedLoadsPage$viewFilters = F4(
	function (isLoaded, data, carriers, filters) {
		var makeCarrierOption = function (maybeCarrier) {
			var _v0 = function () {
				if (maybeCarrier.$ === 'Nothing') {
					return _Utils_Tuple2('', '-- any --');
				} else {
					var carrier = maybeCarrier.a;
					return _Utils_Tuple2(
						A2($elm$core$Maybe$withDefault, carrier.name, carrier.scac),
						carrier.name);
				}
			}();
			var value = _v0.a;
			var label = _v0.b;
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(value),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(value, filters.carrier))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		};
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Events$onSubmit($author$project$Components$ToBeScrapedLoadsPage$SubmitFilters)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$legend,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Filter')
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$ToBeScrapedLoadsPage$ChangeFilters,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Reference '),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('text'),
																$elm$html$Html$Attributes$value(filters.searchTerm),
																$elm$html$Html$Events$onInput($author$project$Components$ToBeScrapedLoadsPage$ChangeSearchTerm)
															]),
														_List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$for('carrier-filter')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Domain$Account$carrierTermForAccount(data.account)),
														$elm$html$Html$text(' '),
														A2(
														$elm$html$Html$select,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$id('carrier-filter'),
																A2(
																$elm$html$Html$Attributes$property,
																'value',
																$elm$json$Json$Encode$string(filters.carrier)),
																A2(
																$elm$html$Html$Attributes$map,
																$author$project$Components$ToBeScrapedLoadsPage$ChangeCarrier,
																A2($elm$html$Html$Events$on, 'change', $elm$html$Html$Events$targetValue))
															]),
														A2(
															$elm$core$List$map,
															makeCarrierOption,
															A2(
																$elm$core$List$cons,
																$elm$core$Maybe$Nothing,
																A2($elm$core$List$map, $elm$core$Maybe$Just, carriers))))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Customer '),
														A2(
														$elm$html$Html$select,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$Attributes$property,
																'value',
																$elm$json$Json$Encode$string(filters.customer)),
																$elm$html$Html$Events$onInput($author$project$Components$ToBeScrapedLoadsPage$ChangeCustomer)
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$option,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$value(''),
																		$elm$html$Html$Attributes$selected(true)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('-- any --')
																	]))
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Delivered on or After '),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('date'),
																$elm$html$Html$Attributes$value(filters.deliveredAfter),
																$elm$html$Html$Events$onInput($author$project$Components$ToBeScrapedLoadsPage$ChangeDeliveredAfter)
															]),
														_List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Delivered on or Before '),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('date'),
																$elm$html$Html$Attributes$value(filters.deliveredBefore),
																$elm$html$Html$Events$onInput($author$project$Components$ToBeScrapedLoadsPage$ChangeDeliveredBefore)
															]),
														_List_Nil)
													]))
											]))
									]))),
							A2(
							$elm$html$Html$map,
							$author$project$Components$ToBeScrapedLoadsPage$ChangeFilters,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id('with-documents'),
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$checked(filters.withDocuments),
														$elm$html$Html$Events$onCheck($author$project$Components$ToBeScrapedLoadsPage$ChangeWithDocuments)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$for('with-documents')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('With Documents')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id('with-invoice'),
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$checked(filters.withInvoice),
														$elm$html$Html$Events$onCheck($author$project$Components$ToBeScrapedLoadsPage$ChangeWithCustomerInvoice)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$for('with-invoice')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('With Customer Invoice')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Invoiced After '),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('date'),
																$elm$html$Html$Attributes$value(filters.invoicedAfter),
																$elm$html$Html$Events$onInput($author$project$Components$ToBeScrapedLoadsPage$ChangeInvoicedAfter)
															]),
														_List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Invoiced Before '),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('date'),
																$elm$html$Html$Attributes$value(filters.invoicedBefore),
																$elm$html$Html$Events$onInput($author$project$Components$ToBeScrapedLoadsPage$ChangeInvoicedBefore)
															]),
														_List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('small-2 columns')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text($author$project$Helpers$String$nbsp)
											]))
									]))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-10 columns')
										]),
									_List_fromArray(
										[
											$author$project$Components$LegacyReact$DisablingButton$view(
											{
												disabled: !isLoaded,
												disabledClasses: $elm$core$Maybe$Nothing,
												disabledText: 'Loading...',
												enabledClasses: _List_fromArray(
													['button--confirmation']),
												onClick: $author$project$Components$LegacyReact$DisablingButton$SubmitForm,
												text: 'Filter'
											}),
											$elm$html$Html$text($author$project$Helpers$String$nbsp),
											A2($author$project$Components$ToBeScrapedLoadsPage$maybeViewClearButton, isLoaded, filters)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$ToBeScrapedLoadsPage$ChangePage = function (a) {
	return {$: 'ChangePage', a: a};
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Components$LegacyReact$Paginator$pageWindow = F2(
	function (numberOfPages, currentPage) {
		var windowSize = 15;
		var startPage = currentPage;
		var lastPage = numberOfPages;
		if (_Utils_cmp(lastPage, windowSize) < 1) {
			return A2($elm$core$List$range, 1, lastPage);
		} else {
			var start = A2(
				$elm$core$Basics$max,
				1,
				startPage - $elm$core$Basics$floor(windowSize / 2));
			var stop = start + windowSize;
			return (_Utils_cmp(stop, lastPage) > 0) ? A2(
				$elm$core$List$range,
				A2($elm$core$Basics$max, 1, (lastPage + 1) - windowSize),
				lastPage) : A2($elm$core$List$range, start, stop - 1);
		}
	});
var $author$project$Event$Extra$onClickPreventDefaultForLinkWithHref = function (msg) {
	var succeedIfFalse = F2(
		function (msg_, preventDefault) {
			if (!preventDefault) {
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(msg_, true));
			} else {
				return $elm$json$Json$Decode$fail('succeedIfFalse: condition was True');
			}
		});
	var isSpecialClick = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (isCtrl, isMeta) {
				return isCtrl || isMeta;
			}),
		A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
		A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool));
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'click',
		A2(
			$elm$json$Json$Decode$andThen,
			succeedIfFalse(msg),
			isSpecialClick));
};
var $author$project$Components$LegacyReact$Paginator$spaHrefAttributes = F2(
	function (config, page) {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$href(
				config.buildUrl(
					{page: page})),
				$author$project$Event$Extra$onClickPreventDefaultForLinkWithHref(
				config.onPageChange(page))
			]);
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Components$LegacyReact$Paginator$viewPage = F2(
	function (config, page) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'current',
							_Utils_eq(config.currentPage, page))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					A2($author$project$Components$LegacyReact$Paginator$spaHrefAttributes, config, page),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(page))
						]))
				]));
	});
var $author$project$Components$LegacyReact$Paginator$view = function (config) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pagination')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('arrow', true),
										_Utils_Tuple2('unavailable', config.currentPage <= 1)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								A2($author$project$Components$LegacyReact$Paginator$spaHrefAttributes, config, config.currentPage - 1),
								_List_fromArray(
									[
										$elm$html$Html$text('«')
									]))
							]))
					]),
					A2(
					$elm$core$List$map,
					$author$project$Components$LegacyReact$Paginator$viewPage(config),
					A2($author$project$Components$LegacyReact$Paginator$pageWindow, config.numberOfPages, config.currentPage)),
					_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('arrow', true),
										_Utils_Tuple2(
										'unavailable',
										_Utils_cmp(config.currentPage, config.numberOfPages) > -1)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								A2($author$project$Components$LegacyReact$Paginator$spaHrefAttributes, config, config.currentPage + 1),
								_List_fromArray(
									[
										$elm$html$Html$text('»')
									]))
							]))
					])
				])));
};
var $author$project$Components$ToBeScrapedLoadsPage$viewPagination = function (model) {
	var _v0 = $author$project$Forward$Remote$toMaybe(model.legacyDataLoads);
	if (_v0.$ === 'Just') {
		var totalPages = _v0.a.totalPages;
		return $author$project$Components$LegacyReact$Paginator$view(
			{
				buildUrl: function (q) {
					return A2(
						$elm$url$Url$Builder$relative,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$int, 'page', q.page)
							]));
				},
				currentPage: model.currentPage,
				numberOfPages: totalPages,
				onPageChange: $author$project$Components$ToBeScrapedLoadsPage$ChangePage
			});
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Helpers$String$pluralize = F2(
	function (_v0, count) {
		var many = _v0.many;
		var one = _v0.one;
		if (count === 1) {
			return '1 ' + one;
		} else {
			var n = count;
			return $elm$core$String$fromInt(n) + (' ' + many);
		}
	});
var $author$project$Helpers$String$quote = function (string) {
	return '\u0022' + (string + '\u0022');
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Helpers$String$longSentence = F2(
	function (joinString, list) {
		var nMinusOne = $elm$core$List$length(list) - 1;
		var start = A2($elm$core$List$take, nMinusOne, list);
		var end = A2($elm$core$List$drop, nMinusOne, list);
		return A2($elm$core$String$join, ', ', start) + (', ' + (joinString + (' ' + $elm$core$String$concat(end))));
	});
var $author$project$Helpers$String$toSentence = F3(
	function (emptyString, joinString, list) {
		if (!list.b) {
			return emptyString;
		} else {
			if (!list.b.b) {
				var onlyOne = list.a;
				return onlyOne;
			} else {
				if (!list.b.b.b) {
					var first = list.a;
					var _v1 = list.b;
					var last = _v1.a;
					return first + (' ' + (joinString + (' ' + last)));
				} else {
					return A2($author$project$Helpers$String$longSentence, joinString, list);
				}
			}
		}
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewPossibleUnmatchedReferences = function (_v0) {
	var unmatchedReferences = _v0.unmatchedReferences;
	if (!unmatchedReferences.b) {
		return $elm$html$Html$text('');
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert-box--caution')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unable to find '),
					$elm$html$Html$text(
					A2(
						$author$project$Helpers$String$pluralize,
						{many: 'search terms', one: 'search term'},
						$elm$core$List$length(unmatchedReferences))),
					$elm$html$Html$text(': '),
					$elm$html$Html$text(
					A3(
						$author$project$Helpers$String$toSentence,
						'',
						'and',
						A2($elm$core$List$map, $author$project$Helpers$String$quote, unmatchedReferences)))
				]));
	}
};
var $author$project$Components$ToBeScrapedLoadsPage$SelectAllLoads = function (a) {
	return {$: 'SelectAllLoads', a: a};
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewSelectAll = function (model) {
	var show = function () {
		var _v1 = $author$project$Forward$Remote$toMaybe(model.legacyDataLoads);
		if (_v1.$ === 'Just') {
			var response = _v1.a;
			return $elm$core$List$isEmpty(response.loads) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(response);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	if (show.$ === 'Just') {
		var totalPages = show.a.totalPages;
		var loads = show.a.loads;
		var isChecked = A2(
			$elm$core$List$all,
			function (load) {
				return A3($timo_weike$generic_collections$ManualSet$member, $author$project$Domain$ToBeScrapedLoadId$toInt, load.id, model.selectedLoads);
			},
			loads);
		var anyChecked = A2(
			$elm$core$List$any,
			function (load) {
				return A3($timo_weike$generic_collections$ManualSet$member, $author$project$Domain$ToBeScrapedLoadId$toInt, load.id, model.selectedLoads);
			},
			loads);
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('select-all'),
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(isChecked),
							$elm$html$Html$Events$onCheck($author$project$Components$ToBeScrapedLoadsPage$SelectAllLoads),
							A2(
							$elm$html$Html$Attributes$property,
							'indeterminate',
							$elm$json$Json$Encode$bool((!isChecked) && anyChecked))
						]),
					_List_Nil),
					$elm$html$Html$text(' '),
					(totalPages > 1) ? $elm$html$Html$text('Select Displayed') : $elm$html$Html$text('Select All'),
					$elm$html$Html$text(' ')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Components$ToBeScrapedLoadsPage$ToggleLoadSelected = F2(
	function (a, b) {
		return {$: 'ToggleLoadSelected', a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Domain$Document$documentTypeValueToUnresolved = function (documentTypeValue) {
	switch (documentTypeValue.$) {
		case 'Document_DocumentTypeValue_DocumentType':
			var docType = documentTypeValue.a;
			return $author$project$Domain$UnresolvedDocumentType$Resolved(docType);
		case 'Document_DocumentTypeValue_DocumentTypePartial':
			var partialDocType = documentTypeValue.a;
			return $author$project$Domain$UnresolvedDocumentType$Partial(partialDocType);
		default:
			return $author$project$Domain$UnresolvedDocumentType$Unknown;
	}
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$Components$ToBeScrapedLoadsPage$viewDocumentCell = F2(
	function (data, document) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('to-be-scraped-loads__document')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(document.inlineDownloadUrl),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-page')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Helpers$String$nbsp)
								])),
							$elm$html$Html$text(' '),
							$elm$html$Html$text(
							A3(
								$author$project$Domain$Helpers$documentTypeToString,
								data.account,
								data.accountSettings,
								$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue)))
						]))
				]));
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewDocumentList = F2(
	function (data, documentsData) {
		if (!documentsData.b) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$em,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('No Documents')
						]))
				]);
		} else {
			var documents = documentsData;
			return A2(
				$elm$core$List$map,
				$author$project$Components$ToBeScrapedLoadsPage$viewDocumentCell(data),
				documents);
		}
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewMaybeInvalidProAlert = F2(
	function (load, documentsData) {
		var _v0 = _Utils_Tuple2(load.invalidProNumberDetectedAt, documentsData);
		if ((_v0.a.$ === 'Just') && (!_v0.b.b)) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$em,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Pro Number Not Found')
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewMaybeSignInFailedAlert = function (load) {
	var signInFailed = function () {
		var _v0 = _Utils_Tuple2(load.loginFailureDetectedAt, load.lastSuccessfulLoginId);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Nothing')) {
			var _v1 = _v0.b;
			return true;
		} else {
			return false;
		}
	}();
	return signInFailed ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$em,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('alert')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Sign In Failure')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Components$ToBeScrapedLoadsPage$viewPermissionDeniedAlert = function (load) {
	var _v0 = load.permissionDeniedAt;
	if (_v0.$ === 'Just') {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('to-be-scraped-loads__permissions-alert')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-alert alert to-be-scraped-loads__permissions-alert-icon')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Helpers$String$nbsp)
						])),
					$elm$html$Html$text(' '),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('to-be-scraped-loads__permission-denied-alert-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Permissions problems kept us from retrieving all documents. Contact support for more information.')
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$ToBeScrapedLoadsPage$viewDocumentsCell = F3(
	function (data, load, documentsData) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2($author$project$Components$ToBeScrapedLoadsPage$viewMaybeInvalidProAlert, load, documentsData),
							$author$project$Components$ToBeScrapedLoadsPage$viewMaybeSignInFailedAlert(load),
							$author$project$Components$ToBeScrapedLoadsPage$viewPermissionDeniedAlert(load)
						]),
						A2($author$project$Components$ToBeScrapedLoadsPage$viewDocumentList, data, documentsData)
					])));
	});
var $author$project$Helpers$Date$monthInt = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $author$project$Helpers$Date$dateStringFromDate = function (date) {
	var year = $elm$core$String$fromInt(
		$justinmimbs$date$Date$year(date));
	var month = A3(
		$elm$core$String$padLeft,
		2,
		_Utils_chr('0'),
		$elm$core$String$fromInt(
			$author$project$Helpers$Date$monthInt(
				$justinmimbs$date$Date$month(date))));
	var day = A3(
		$elm$core$String$padLeft,
		2,
		_Utils_chr('0'),
		$elm$core$String$fromInt(
			$justinmimbs$date$Date$day(date)));
	return A2(
		$elm$core$String$join,
		'/',
		_List_fromArray(
			[month, day, year]));
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m.$) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return 59 + leapDays;
			case 'Apr':
				return 90 + leapDays;
			case 'May':
				return 120 + leapDays;
			case 'Jun':
				return 151 + leapDays;
			case 'Jul':
				return 181 + leapDays;
			case 'Aug':
				return 212 + leapDays;
			case 'Sep':
				return 243 + leapDays;
			case 'Oct':
				return 273 + leapDays;
			case 'Nov':
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return $justinmimbs$date$Date$RD(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
				$elm$core$Basics$clamp,
				1,
				A2($justinmimbs$date$Date$daysInMonth, y, m),
				d));
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $author$project$Helpers$Date$dateString = F2(
	function (tz, date) {
		return $author$project$Helpers$Date$dateStringFromDate(
			A2($justinmimbs$date$Date$fromPosix, tz, date));
	});
var $author$project$Helpers$Date$timeString = F2(
	function (tz, date) {
		var minutes = A3(
			$elm$core$String$padLeft,
			2,
			_Utils_chr('0'),
			$elm$core$String$fromInt(
				A2($elm$time$Time$toMinute, tz, date)));
		var hour = (!A2(
			$elm$core$Basics$modBy,
			12,
			A2($elm$time$Time$toHour, tz, date))) ? '12' : A3(
			$elm$core$String$padLeft,
			2,
			_Utils_chr('0'),
			$elm$core$String$fromInt(
				A2(
					$elm$core$Basics$modBy,
					12,
					A2($elm$time$Time$toHour, tz, date))));
		var am_pm = (A2($elm$time$Time$toHour, tz, date) < 12) ? 'AM' : 'PM';
		return hour + (':' + (minutes + (' ' + am_pm)));
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewLastUpdated = F2(
	function (tz, maybePosix) {
		if (maybePosix.$ === 'Just') {
			var posix = maybePosix.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Helpers$Date$timeString, tz, posix))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Helpers$Date$dateString, tz, posix))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('N/A')
					]));
		}
	});
var $author$project$Helpers$Html$empty = $elm$html$Html$text('');
var $author$project$Helpers$Html$showMaybe = F2(
	function (view_, maybe) {
		if (maybe.$ === 'Nothing') {
			return $author$project$Helpers$Html$empty;
		} else {
			var a = maybe.a;
			return view_(a);
		}
	});
var $author$project$Components$ToBeScrapedLoadsPage$isPartialDownload = function (selectedDocumentTypes) {
	var allTypesSelected = A2(
		$elm$core$List$all,
		function (documentType) {
			return A3($timo_weike$generic_collections$ManualSet$member, $author$project$AuditPb$documentTypeToString, documentType, selectedDocumentTypes);
		},
		$author$project$Components$ToBeScrapedLoadsPage$documentTypesForDownload);
	return !allTypesSelected;
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $timo_weike$generic_collections$ManualSet$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$values(dict);
};
var $author$project$Components$ToBeScrapedLoadsPage$addTypesToDownload = F2(
	function (selectedDocumentTypes, baseUrl) {
		return $author$project$Components$ToBeScrapedLoadsPage$isPartialDownload(selectedDocumentTypes) ? (baseUrl + ('?types=' + A2(
			$elm$core$String$join,
			',',
			A2(
				$elm$core$List$map,
				$author$project$AuditPb$documentTypeToString,
				$timo_weike$generic_collections$ManualSet$toList(selectedDocumentTypes))))) : baseUrl;
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Components$ToBeScrapedLoadsPage$viewDownloadAllDocumentsLink = F2(
	function (model, _v0) {
		var documents = _v0.documents;
		var documentBatch = _v0.documentBatch;
		if ($elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				function (doc) {
					var _v1 = $author$project$Domain$Document$documentTypeValueToUnresolved(doc.documentTypeValue);
					if (_v1.$ === 'Resolved') {
						var docType = _v1.a;
						return A3($timo_weike$generic_collections$ManualSet$member, $author$project$AuditPb$documentTypeToString, docType, model.selectedDocumentTypes);
					} else {
						return false;
					}
				},
				documents))) {
			return $elm$html$Html$text('');
		} else {
			var url = A2($author$project$Components$ToBeScrapedLoadsPage$addTypesToDownload, model.selectedDocumentTypes, documentBatch.mergedDocumentsDownloadUrl);
			var tooltipTitle = A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						'Download',
						$author$project$Components$ToBeScrapedLoadsPage$isPartialDownload(model.selectedDocumentTypes) ? 'Selected' : 'All'
					]));
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-header__carrier-label'),
										A2($elm$html$Html$Attributes$attribute, 'data-tooltip', ''),
										A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
										$elm$html$Html$Attributes$title(tooltipTitle)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fi-download to-be-scraped-loads__action-icon')
											]),
										_List_Nil)
									]))
							]))
					]));
		}
	});
var $author$project$Components$ToBeScrapedLoadsPage$RequeueLoad = function (a) {
	return {$: 'RequeueLoad', a: a};
};
var $author$project$Components$ToBeScrapedLoadsPage$viewRequeueRetrievalLink = function (loadId) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Components$ToBeScrapedLoadsPage$RequeueLoad(loadId))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('indexer-header__carrier-label'),
								A2($elm$html$Html$Attributes$attribute, 'data-tooltip', ''),
								A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
								$elm$html$Html$Attributes$title('Retry Document Retrieval')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fi-refresh to-be-scraped-loads__action-icon')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Components$ToBeScrapedLoadsPage$viewLoadActions = F3(
	function (model, load, documentBatchData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('to-be-scraped-loads__actions')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Helpers$Html$showMaybe,
					$author$project$Components$ToBeScrapedLoadsPage$viewDownloadAllDocumentsLink(model),
					documentBatchData),
					$author$project$Components$ToBeScrapedLoadsPage$viewRequeueRetrievalLink(load.id)
				]));
	});
var $author$project$Helpers$Date$shortMonthString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Helpers$Date$dateStringFormat2FromDate = function (date) {
	var year = $elm$core$String$fromInt(
		$justinmimbs$date$Date$year(date));
	var month = $author$project$Helpers$Date$shortMonthString(
		$justinmimbs$date$Date$month(date));
	var day = $elm$core$String$fromInt(
		$justinmimbs$date$Date$day(date));
	return month + (' ' + (day + (', ' + year)));
};
var $author$project$Helpers$Date$dateStringFormat2 = F2(
	function (tz, date) {
		return $author$project$Helpers$Date$dateStringFormat2FromDate(
			A2($justinmimbs$date$Date$fromPosix, tz, date));
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewMaybeDate = F2(
	function (tz, maybePosix) {
		if (maybePosix.$ === 'Just') {
			var posix = maybePosix.a;
			return $elm$html$Html$text(
				A2($author$project$Helpers$Date$dateStringFormat2, tz, posix));
		} else {
			return $elm$html$Html$text('N/A');
		}
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewToBeScrapedLoadsRow = F3(
	function (model, data, _v0) {
		var load = _v0.a;
		var documentBatchData = _v0.b;
		var loadIdString = $author$project$Domain$ToBeScrapedLoadId$toString(load.id);
		var documents = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.documents;
				},
				documentBatchData));
		return _Utils_Tuple2(
			loadIdString,
			A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('load_row_' + loadIdString)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$name('load_ids[]'),
										$elm$html$Html$Attributes$value(loadIdString),
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(
										A3($timo_weike$generic_collections$ManualSet$member, $author$project$Domain$ToBeScrapedLoadId$toInt, load.id, model.selectedLoads)),
										A2(
										$elm$html$Html$Attributes$attribute,
										'aria-label',
										'Select ' + A2($elm$core$Maybe$withDefault, '(missing Load ID)', load.primaryReference)),
										$elm$html$Html$Events$onCheck(
										$author$project$Components$ToBeScrapedLoadsPage$ToggleLoadSelected(load.id))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', load.carrierScac))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', load.primaryReference))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', load.proNumber))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', load.secondaryTrackingNumber))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', load.customerInvoiceNumber))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$ToBeScrapedLoadsPage$viewMaybeDate, model.tz, load.actualDeliveredAt)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$ToBeScrapedLoadsPage$viewLastUpdated, model.tz, load.lastScrapedAt)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', load.totalAmountValue)),
								$elm$html$Html$text(' '),
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', load.totalAmountCurrency))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A3($author$project$Components$ToBeScrapedLoadsPage$viewDocumentsCell, data, load, documents)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('to-be-scraped-loads__actions')
							]),
						_List_fromArray(
							[
								A3($author$project$Components$ToBeScrapedLoadsPage$viewLoadActions, model, load, documentBatchData)
							]))
					])));
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewToBeScrapedLoadsRows = F3(
	function (model, data, loads) {
		return $elm$core$List$isEmpty(loads) ? _List_fromArray(
			[
				_Utils_Tuple2(
				'empty_row',
				A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$colspan(8),
									$elm$html$Html$Attributes$class('to-be-scraped-loads__not-found-row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('alert-box info')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$em,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('No loads found.')
												]))
										]))
								]))
						])))
			]) : A2(
			$elm$core$List$map,
			A2($author$project$Components$ToBeScrapedLoadsPage$viewToBeScrapedLoadsRow, model, data),
			loads);
	});
var $author$project$Components$ToBeScrapedLoadsPage$viewLoaded = F2(
	function (data, model) {
		var pairWithDocumentBatchData = function (load) {
			var _v1 = load.documentBatchId;
			if (_v1.$ === 'Nothing') {
				return $author$project$Forward$Remote$Loaded(
					_Utils_Tuple2(load, $elm$core$Maybe$Nothing));
			} else {
				var documentBatchId = _v1.a;
				var _v2 = A3($timo_weike$generic_collections$ManualDict$get, $author$project$Domain$DocumentBatchId$toInt, documentBatchId, data.documentBatchesByLoadId);
				if (_v2.$ === 'Nothing') {
					return $author$project$Forward$Remote$Loaded(
						_Utils_Tuple2(load, $elm$core$Maybe$Nothing));
				} else {
					var remoteBatch = _v2.a;
					return A2(
						$author$project$Forward$Remote$map,
						function (batch) {
							return _Utils_Tuple2(
								load,
								$elm$core$Maybe$Just(batch));
						},
						remoteBatch);
				}
			}
		};
		var loadsWithDocumentBatchData = A2(
			$author$project$Forward$Remote$andThen,
			$author$project$Forward$Remote$traverseList,
			A2(
				$author$project$Forward$Remote$map,
				function (legacyDataLoads) {
					return A2($elm$core$List$map, pairWithDocumentBatchData, legacyDataLoads.loads);
				},
				model.legacyDataLoads));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('general-container row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('to-be-scraped-loads')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('small-10 column')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Forward$LoadingView$viewV3Reskinnable,
													false,
													function (carriers) {
														return A4(
															$author$project$Components$ToBeScrapedLoadsPage$viewFilters,
															$author$project$Forward$Remote$isResolved(model.legacyDataLoads),
															data,
															carriers,
															model.filtersUiState);
													},
													model.legacyDataCarriers)
												]))
										])),
									function () {
									var _v0 = $author$project$Forward$Remote$toMaybe(model.legacyDataLoads);
									if (_v0.$ === 'Just') {
										var legacyDataLoads = _v0.a;
										return $author$project$Components$ToBeScrapedLoadsPage$viewPossibleUnmatchedReferences(legacyDataLoads);
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$elm$html$Html$form,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$method('get'),
											$elm$html$Html$Attributes$action('/api/to_be_scraped_loads/bulk_download')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small-10 column to-be-scraped-loads__document-type-filter')
														]),
													$elm$core$List$concat(
														_List_fromArray(
															[
																_List_fromArray(
																[
																	$elm$html$Html$text('Download Only: ')
																]),
																A2(
																$elm$core$List$map,
																A2($author$project$Components$ToBeScrapedLoadsPage$viewDocumentTypeFilter, data, model),
																$author$project$Components$ToBeScrapedLoadsPage$documentTypesForDownload),
																_List_fromArray(
																[
																	$author$project$Components$LegacyReact$DisablingButton$view(
																	{
																		disabled: $timo_weike$generic_collections$ManualSet$isEmpty(model.selectedLoads),
																		disabledClasses: $elm$core$Maybe$Nothing,
																		disabledText: 'Select loads to download',
																		enabledClasses: _List_fromArray(
																			['button--confirmation']),
																		onClick: $author$project$Components$LegacyReact$DisablingButton$SubmitForm,
																		text: 'Download Checked'
																	})
																])
															]))),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small-10 column')
														]),
													_List_fromArray(
														[
															$author$project$Components$ToBeScrapedLoadsPage$viewPagination(model)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small-10 column')
														]),
													_List_fromArray(
														[
															$author$project$Components$ToBeScrapedLoadsPage$viewSelectAll(model)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small-10 column')
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Forward$LoadingView$view,
															function (loads) {
																return A2(
																	$elm$html$Html$table,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('to-be-scraped-loads__table')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$thead,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$tr,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text($author$project$Helpers$String$nbsp)
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text(data.account.carrierTerm)
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Load ID')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Pro Number')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Secondary Tracking Number')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Invoice Number')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Delivered on')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Last Updated on')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Invoice Amount')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Available Documents')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Actions')
																								]))
																						]))
																				])),
																			A3(
																			$elm$html$Html$Keyed$node,
																			'tbody',
																			_List_Nil,
																			A3($author$project$Components$ToBeScrapedLoadsPage$viewToBeScrapedLoadsRows, model, data, loads))
																		]));
															},
															loadsWithDocumentBatchData)
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$ToBeScrapedLoadsPage$page = $author$project$Forward$Component$forwardComponent(
	{
		init: $author$project$Components$ToBeScrapedLoadsPage$init,
		loadData: $author$project$Components$ToBeScrapedLoadsPage$loadData,
		update: function (_v0) {
			return $author$project$Components$ToBeScrapedLoadsPage$update;
		},
		v3ReskinEnabled: false,
		viewLoaded: $author$project$Components$ToBeScrapedLoadsPage$viewLoaded
	});
var $author$project$Main$pageDataEffects = F2(
	function (data, _v0) {
		switch (data.$) {
			case 'BlankPageData':
				return $author$project$HubTran$Effect$none;
			case 'LoadingPageData':
				return $author$project$HubTran$Effect$none;
			case 'LoadingFailedPageData':
				return $author$project$HubTran$Effect$none;
			case 'ActivityPageData':
				return $author$project$HubTran$Effect$none;
			case 'BrokerBillingRequirementsPageData':
				return $author$project$HubTran$Effect$none;
			case 'ClientSubmissionInvoicePageData':
				return $author$project$HubTran$Effect$none;
			case 'ClientSubmissionPageData':
				return $author$project$HubTran$Effect$none;
			case 'ClientSubmissionReviewPageData':
				return $author$project$HubTran$Effect$none;
			case 'DashboardPageData':
				var page = data.a;
				var remotePageData = data.b;
				if (remotePageData.$ === 'Loaded') {
					var pageData = remotePageData.a;
					return A2(
						$author$project$HubTran$Effect$map,
						$author$project$Main$DashboardPageMsg,
						A2($author$project$Components$DashboardPage$dataEffects, pageData, page));
				} else {
					return $author$project$HubTran$Effect$none;
				}
			case 'DocumentsViewerPopoutPageData':
				return $author$project$HubTran$Effect$none;
			case 'EmailMessageSearchPageData':
				return $author$project$HubTran$Effect$none;
			case 'HelpPageData':
				return $author$project$HubTran$Effect$none;
			case 'NonInvoiceConfirmPageData':
				return $author$project$HubTran$Effect$none;
			case 'OktaLoginPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsCarrierPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsCarriersPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsCustomerPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsCustomersPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsDebtorPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsReportsPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsReferenceFieldsPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsRulesPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsUserPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsUsersPageData':
				return $author$project$HubTran$Effect$none;
			case 'SettingsVerificationsPageData':
				return $author$project$HubTran$Effect$none;
			case 'TermsPageData':
				return $author$project$HubTran$Effect$none;
			case 'VerificationBatchPageData':
				return $author$project$HubTran$Effect$none;
			case 'LtlReconcileInvoicePageData':
				return $author$project$HubTran$Effect$none;
			case 'CarrierInvoiceAuditPageData':
				return $author$project$HubTran$Effect$none;
			case 'FactorInvoiceAuditPageData':
				return $author$project$HubTran$Effect$none;
			case 'FactorInvoiceAuditBatchGroupingPageData':
				return $author$project$HubTran$Effect$none;
			case 'FactorInvoiceAuditBatchPageData':
				return $author$project$HubTran$Effect$none;
			case 'ForwardingHasMovedPageData':
				return $author$project$HubTran$Effect$none;
			case 'MyClientsOverviewPageData':
				return $author$project$HubTran$Effect$none;
			case 'NoaManagementToSendPageData':
				return $author$project$HubTran$Effect$none;
			case 'DebtorChangesPageData':
				return $author$project$HubTran$Effect$none;
			case 'DebtorChangesTemplatePageData':
				return $author$project$HubTran$Effect$none;
			case 'NoaManagementSentPageData':
				return $author$project$HubTran$Effect$none;
			case 'NoaManagementSkippedPageData':
				return $author$project$HubTran$Effect$none;
			case 'LtlHeldSubmissionsPageData':
				return $author$project$HubTran$Effect$none;
			case 'DocumentReviewPageData':
				return $author$project$HubTran$Effect$none;
			case 'DocumentBatchReviewPageData':
				return $author$project$HubTran$Effect$none;
			case 'DocumentGroupReviewPageData':
				return $author$project$HubTran$Effect$none;
			case 'EmailMergePageData':
				var page = data.a;
				var remotePageData = data.b;
				if (remotePageData.$ === 'Loaded') {
					var pageData = remotePageData.a;
					return A2(
						$author$project$HubTran$Effect$map,
						$author$project$Main$EmailMergePageMsg,
						A2($author$project$Components$EmailMergePage$page.dataEffects, pageData, page));
				} else {
					return $author$project$HubTran$Effect$none;
				}
			case 'ReadonlyFactorInvoicePageData':
				return $author$project$HubTran$Effect$none;
			default:
				var page = data.a;
				var remotePageData = data.b;
				if (remotePageData.$ === 'Loaded') {
					var pageData = remotePageData.a;
					return A2(
						$author$project$HubTran$Effect$map,
						$author$project$Main$ToBeScrapedLoadsPageMsg,
						A2($author$project$Components$ToBeScrapedLoadsPage$page.dataEffects, pageData, page));
				} else {
					return $author$project$HubTran$Effect$none;
				}
		}
	});
var $author$project$Main$dataEffects = F2(
	function (pageData, _v0) {
		return A2(
			$author$project$HubTran$Effect$map,
			$author$project$Main$PageMsg,
			A2($author$project$Main$pageDataEffects, pageData, _Utils_Tuple0));
	});
var $author$project$Main$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$Main$GotHeaderElement = function (a) {
	return {$: 'GotHeaderElement', a: a};
};
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2(
					$elm$core$Task$onError,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Err),
					A2(
						$elm$core$Task$andThen,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
							$elm$core$Result$Ok),
						task))));
	});
var $elm$browser$Browser$External = function (a) {
	return {$: 'External', a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 'Internal', a: a};
};
var $elm$browser$Browser$Dom$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $elm$url$Url$Http = {$: 'Http'};
var $elm$url$Url$Https = {$: 'Https'};
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Http,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Https,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0.a;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Main$headerId = 'header-container';
var $author$project$Main$getHeaderViewport = A2(
	$elm$core$Task$attempt,
	$author$project$Main$GotHeaderElement,
	$elm$browser$Browser$Dom$getElement($author$project$Main$headerId));
var $author$project$Components$Flash$Model = F2(
	function (messages, currentTime) {
		return {currentTime: currentTime, messages: messages};
	});
var $author$project$Components$Flash$init = A2($author$project$Components$Flash$Model, $elm$core$Array$empty, $elm$core$Maybe$Nothing);
var $author$project$Ui$V3$Header$init = {isAccountsOpen: false, isMenuOpen: false, isSettingsOpen: false};
var $author$project$Main$ActivityPageInitDataLoaded = F2(
	function (a, b) {
		return {$: 'ActivityPageInitDataLoaded', a: a, b: b};
	});
var $author$project$Main$BlankPage = {$: 'BlankPage'};
var $author$project$Main$BrokerBillingRequirementsPage = function (a) {
	return {$: 'BrokerBillingRequirementsPage', a: a};
};
var $author$project$Main$BrokerBillingRequirementsPageMsg = function (a) {
	return {$: 'BrokerBillingRequirementsPageMsg', a: a};
};
var $author$project$Main$CarrierInvoiceAuditPage = function (a) {
	return {$: 'CarrierInvoiceAuditPage', a: a};
};
var $author$project$Main$CarrierInvoiceAuditPageMsg = function (a) {
	return {$: 'CarrierInvoiceAuditPageMsg', a: a};
};
var $author$project$Main$ClientSubmissionInvoicePage = function (a) {
	return {$: 'ClientSubmissionInvoicePage', a: a};
};
var $author$project$Main$ClientSubmissionInvoicePageMsg = function (a) {
	return {$: 'ClientSubmissionInvoicePageMsg', a: a};
};
var $author$project$Main$ClientSubmissionPage = function (a) {
	return {$: 'ClientSubmissionPage', a: a};
};
var $author$project$Main$ClientSubmissionPageMsg = function (a) {
	return {$: 'ClientSubmissionPageMsg', a: a};
};
var $author$project$Main$ClientSubmissionReviewPage = function (a) {
	return {$: 'ClientSubmissionReviewPage', a: a};
};
var $author$project$Main$ClientSubmissionReviewPageMsg = function (a) {
	return {$: 'ClientSubmissionReviewPageMsg', a: a};
};
var $author$project$AuditPb$DashboardModeAll = {$: 'DashboardModeAll'};
var $author$project$Main$DashboardPageInitDataLoaded = F2(
	function (a, b) {
		return {$: 'DashboardPageInitDataLoaded', a: a, b: b};
	});
var $author$project$Main$DebtorChangesPage = function (a) {
	return {$: 'DebtorChangesPage', a: a};
};
var $author$project$Main$DebtorChangesPageMsg = function (a) {
	return {$: 'DebtorChangesPageMsg', a: a};
};
var $author$project$Main$DebtorChangesTemplatePage = function (a) {
	return {$: 'DebtorChangesTemplatePage', a: a};
};
var $author$project$Main$DebtorChangesTemplatePageMsg = function (a) {
	return {$: 'DebtorChangesTemplatePageMsg', a: a};
};
var $author$project$Main$DocumentBatchReviewPage = function (a) {
	return {$: 'DocumentBatchReviewPage', a: a};
};
var $author$project$Main$DocumentBatchReviewPageMsg = function (a) {
	return {$: 'DocumentBatchReviewPageMsg', a: a};
};
var $author$project$Main$DocumentGroupReviewPage = function (a) {
	return {$: 'DocumentGroupReviewPage', a: a};
};
var $author$project$Main$DocumentGroupReviewPageMsg = function (a) {
	return {$: 'DocumentGroupReviewPageMsg', a: a};
};
var $author$project$Main$DocumentReviewPage = function (a) {
	return {$: 'DocumentReviewPage', a: a};
};
var $author$project$Main$DocumentReviewPageMsg = function (a) {
	return {$: 'DocumentReviewPageMsg', a: a};
};
var $author$project$Main$DocumentsViewerPopoutPageInitDataLoaded = function (a) {
	return {$: 'DocumentsViewerPopoutPageInitDataLoaded', a: a};
};
var $author$project$Main$EmailMergePage = function (a) {
	return {$: 'EmailMergePage', a: a};
};
var $author$project$Main$EmailMessageSearchPage = function (a) {
	return {$: 'EmailMessageSearchPage', a: a};
};
var $author$project$Main$EmailMessageSearchPageMsg = function (a) {
	return {$: 'EmailMessageSearchPageMsg', a: a};
};
var $author$project$Main$FactorInvoiceAuditBatchGroupingPage = function (a) {
	return {$: 'FactorInvoiceAuditBatchGroupingPage', a: a};
};
var $author$project$Main$FactorInvoiceAuditBatchPageInitDataLoaded = F3(
	function (a, b, c) {
		return {$: 'FactorInvoiceAuditBatchPageInitDataLoaded', a: a, b: b, c: c};
	});
var $author$project$Main$FactorInvoiceAuditPageInitDataLoaded = function (a) {
	return {$: 'FactorInvoiceAuditPageInitDataLoaded', a: a};
};
var $author$project$Main$ForwardingHasMovedPage = function (a) {
	return {$: 'ForwardingHasMovedPage', a: a};
};
var $author$project$Main$HelpPage = {$: 'HelpPage'};
var $author$project$Main$LoadingPage = {$: 'LoadingPage'};
var $author$project$Main$LtlHeldSubmissionsPageInitDataLoaded = function (a) {
	return {$: 'LtlHeldSubmissionsPageInitDataLoaded', a: a};
};
var $author$project$Main$LtlReconcileInvoicePageInitDataLoaded = function (a) {
	return {$: 'LtlReconcileInvoicePageInitDataLoaded', a: a};
};
var $author$project$Main$MyClientsOverviewPage = function (a) {
	return {$: 'MyClientsOverviewPage', a: a};
};
var $author$project$Main$MyClientsOverviewPageMsg = function (a) {
	return {$: 'MyClientsOverviewPageMsg', a: a};
};
var $author$project$Main$NoaManagementSentPageInitDataLoaded = F2(
	function (a, b) {
		return {$: 'NoaManagementSentPageInitDataLoaded', a: a, b: b};
	});
var $author$project$Main$NoaManagementSkippedPage = function (a) {
	return {$: 'NoaManagementSkippedPage', a: a};
};
var $author$project$Main$NoaManagementSkippedPageMsg = function (a) {
	return {$: 'NoaManagementSkippedPageMsg', a: a};
};
var $author$project$Main$NoaManagementToSendPage = function (a) {
	return {$: 'NoaManagementToSendPage', a: a};
};
var $author$project$Main$NoaManagementToSendPageMsg = function (a) {
	return {$: 'NoaManagementToSendPageMsg', a: a};
};
var $author$project$Main$NonInvoiceConfirmPageInitDataLoaded = function (a) {
	return {$: 'NonInvoiceConfirmPageInitDataLoaded', a: a};
};
var $author$project$Main$OktaLoginPage = function (a) {
	return {$: 'OktaLoginPage', a: a};
};
var $author$project$Main$OktaLoginPageMsg = function (a) {
	return {$: 'OktaLoginPageMsg', a: a};
};
var $author$project$Main$ReadonlyFactorInvoicePageInitDataLoaded = function (a) {
	return {$: 'ReadonlyFactorInvoicePageInitDataLoaded', a: a};
};
var $author$project$Main$SettingsCarrierPage = function (a) {
	return {$: 'SettingsCarrierPage', a: a};
};
var $author$project$Main$SettingsCarrierPageMsg = function (a) {
	return {$: 'SettingsCarrierPageMsg', a: a};
};
var $author$project$Main$SettingsCarriersPage = function (a) {
	return {$: 'SettingsCarriersPage', a: a};
};
var $author$project$Main$SettingsCarriersPageMsg = function (a) {
	return {$: 'SettingsCarriersPageMsg', a: a};
};
var $author$project$Main$SettingsCustomerPage = function (a) {
	return {$: 'SettingsCustomerPage', a: a};
};
var $author$project$Main$SettingsCustomersPage = function (a) {
	return {$: 'SettingsCustomersPage', a: a};
};
var $author$project$Main$SettingsDebtorPage = function (a) {
	return {$: 'SettingsDebtorPage', a: a};
};
var $author$project$Main$SettingsDebtorPageMsg = function (a) {
	return {$: 'SettingsDebtorPageMsg', a: a};
};
var $author$project$Main$SettingsPage = function (a) {
	return {$: 'SettingsPage', a: a};
};
var $author$project$Main$SettingsPageMsg = function (a) {
	return {$: 'SettingsPageMsg', a: a};
};
var $author$project$Main$SettingsReferenceFieldsPage = function (a) {
	return {$: 'SettingsReferenceFieldsPage', a: a};
};
var $author$project$Main$SettingsReferenceFieldsPageMsg = function (a) {
	return {$: 'SettingsReferenceFieldsPageMsg', a: a};
};
var $author$project$Main$SettingsReportsPage = function (a) {
	return {$: 'SettingsReportsPage', a: a};
};
var $author$project$Main$SettingsReportsPageMsg = function (a) {
	return {$: 'SettingsReportsPageMsg', a: a};
};
var $author$project$Main$SettingsRulesPage = function (a) {
	return {$: 'SettingsRulesPage', a: a};
};
var $author$project$Main$SettingsRulesPageMsg = function (a) {
	return {$: 'SettingsRulesPageMsg', a: a};
};
var $author$project$Main$SettingsUserPage = function (a) {
	return {$: 'SettingsUserPage', a: a};
};
var $author$project$Main$SettingsUserPageMsg = function (a) {
	return {$: 'SettingsUserPageMsg', a: a};
};
var $author$project$Main$SettingsUsersPage = function (a) {
	return {$: 'SettingsUsersPage', a: a};
};
var $author$project$Main$SettingsUsersPageMsg = function (a) {
	return {$: 'SettingsUsersPageMsg', a: a};
};
var $author$project$Main$SettingsVerificationsPage = function (a) {
	return {$: 'SettingsVerificationsPage', a: a};
};
var $author$project$Main$SettingsVerificationsPageMsg = function (a) {
	return {$: 'SettingsVerificationsPageMsg', a: a};
};
var $author$project$Main$TermsPage = function (a) {
	return {$: 'TermsPage', a: a};
};
var $author$project$Main$TermsPageMsg = function (a) {
	return {$: 'TermsPageMsg', a: a};
};
var $author$project$Main$ToBeScrapedLoadsPage = function (a) {
	return {$: 'ToBeScrapedLoadsPage', a: a};
};
var $author$project$Main$VerificationBatchPage = function (a) {
	return {$: 'VerificationBatchPage', a: a};
};
var $author$project$Main$VerificationBatchPageMsg = function (a) {
	return {$: 'VerificationBatchPageMsg', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$emptyQueryParams = {activityType: $elm$core$Maybe$Nothing, carrierDropdownId: $elm$core$Maybe$Nothing, carrierId: $elm$core$Maybe$Nothing, customerDropdownId: $elm$core$Maybe$Nothing, customerId: $elm$core$Maybe$Nothing, debtorId: $elm$core$Maybe$Nothing, endDate: $elm$core$Maybe$Nothing, invoiceNumOrLoadId: $elm$core$Maybe$Nothing, page: $elm$core$Maybe$Nothing, startDate: $elm$core$Maybe$Nothing, userId: $elm$core$Maybe$Nothing};
var $author$project$Forward$Internal$Priority$max = function (list) {
	return A2(
		$elm$core$List$any,
		function (p) {
			return _Utils_eq(p, $author$project$Forward$Internal$Priority$RequiredASAP);
		},
		list) ? $author$project$Forward$Internal$Priority$RequiredASAP : ($elm$core$List$isEmpty(list) ? $author$project$Forward$Internal$Priority$RequiredASAP : $author$project$Forward$Internal$Priority$BehindLoadingSpinner);
};
var $author$project$Forward$Internal$Loadable$toTuple = function (_v0) {
	var effects_ = _v0.a.effects_;
	var result = _v0.a.result;
	return _Utils_Tuple2(result, effects_);
};
var $author$project$Forward$Lookup$run = F2(
	function (cache, _v0) {
		var lookup = _v0.a;
		var loadable = A3(lookup.load, cache, $elm$core$Maybe$Nothing, _Utils_Tuple0);
		var _v1 = $author$project$Forward$Internal$Loadable$toTuple(loadable);
		var cachedValue = _v1.a;
		var missingData = _v1.b;
		return {cachedValue: cachedValue, missingData: missingData};
	});
var $author$project$Forward$Lookup$viewStructure = function (_v0) {
	var lookup = _v0.a;
	return lookup.structure;
};
var $author$project$HubTran$Effect$fetchFromCache = F2(
	function (onResult, lookup) {
		var debugView = $author$project$Forward$Lookup$viewStructure(lookup);
		var checkResult = function (cache) {
			var lookupResult = A2($author$project$Forward$Lookup$run, cache, lookup);
			var _v0 = lookupResult.cachedValue;
			switch (_v0.$) {
				case 'Loading':
					return $elm$core$Result$Err(
						_Utils_Tuple2(
							$author$project$Forward$Internal$Priority$max(
								A2($elm$core$List$map, $elm$core$Tuple$second, lookupResult.missingData)),
							A2($elm$core$List$map, $elm$core$Tuple$first, lookupResult.missingData)));
				case 'Loaded':
					var a = _v0.a;
					return $elm$core$Result$Ok(
						$elm$core$Result$Ok(a));
				default:
					var error = _v0.a;
					return $elm$core$Result$Ok(
						$elm$core$Result$Err(error));
			}
		};
		return $author$project$HubTran$Effect$ForwardEffect(
			A2(
				$author$project$Forward$Internal$PureEffectManagerCmd$FetchOnce,
				debugView,
				A2(
					$elm$core$Basics$composeR,
					checkResult,
					$elm$core$Result$map(
						A2($elm$core$Basics$composeR, onResult, $elm$core$Maybe$Just)))));
	});
var $author$project$Js$setupCurrentProcessingSelectionUpdates = _Platform_outgoingPort(
	'setupCurrentProcessingSelectionUpdates',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Broker$Page$BillingRequirements$init = _Utils_Tuple2(
	{selectedCarrierInvoiceId: $elm$core$Maybe$Nothing, selectedCustomerId: $elm$core$Maybe$Nothing},
	$author$project$HubTran$Effect$cmd(
		$author$project$Js$setupCurrentProcessingSelectionUpdates(_Utils_Tuple0)));
var $author$project$Components$DocumentsBrowser$DefaultViewModeWidth = {$: 'DefaultViewModeWidth'};
var $author$project$Components$CarrierInvoiceAuditPage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Components$CarrierInvoiceAuditPage$Summary = {$: 'Summary'};
var $author$project$Components$DocumentsBrowser$UpdateDocumentTypeAction = {$: 'UpdateDocumentTypeAction'};
var $author$project$Broker$Shared$CurrentProcessingSelection$CarrierInvoiceSelection = F2(
	function (a, b) {
		return {$: 'CarrierInvoiceSelection', a: a, b: b};
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$carrierInvoice = function (carrierInvoiceId) {
	return A2($author$project$Broker$Shared$CurrentProcessingSelection$CarrierInvoiceSelection, carrierInvoiceId, $elm$core$Maybe$Nothing);
};
var $author$project$Helpers$DocumentViewerPageContextData$empty = {carrierInvoiceHasSubmission: $elm$core$Maybe$Nothing, carrierInvoiceId: $elm$core$Maybe$Nothing, loadStateId: $elm$core$Maybe$Nothing};
var $author$project$Components$AuditSplitPane$AsSaved = {$: 'AsSaved'};
var $author$project$Components$AuditSplitPane$Model = function (a) {
	return {$: 'Model', a: a};
};
var $author$project$Components$AuditSplitPane$init = $author$project$Components$AuditSplitPane$Model(
	{expanded: false, gesture: $elm$core$Maybe$Nothing, poppedOut: false, width: $author$project$Components$AuditSplitPane$AsSaved});
var $author$project$Components$CarrierInvoiceAuditChecks$TopCheckOnly = {$: 'TopCheckOnly'};
var $author$project$Components$AuditDrafts$Drafts = F2(
	function (a, b) {
		return {$: 'Drafts', a: a, b: b};
	});
var $turboMaCk$any_dict$Dict$Any$AnyDict = function (a) {
	return {$: 'AnyDict', a: a};
};
var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
	return $turboMaCk$any_dict$Dict$Any$AnyDict(
		{dict: $elm$core$Dict$empty, toKey: toKey});
};
var $author$project$Components$AuditDrafts$empty = function (_v0) {
	var kindOf = _v0.kindOf;
	var toComparable = _v0.toComparable;
	return A2(
		$author$project$Components$AuditDrafts$Drafts,
		kindOf,
		$turboMaCk$any_dict$Dict$Any$empty(toComparable));
};
var $author$project$Components$AuditDrafts$Amount = {$: 'Amount'};
var $author$project$Components$AuditDrafts$PresentText = {$: 'PresentText'};
var $author$project$Components$AuditDrafts$StrippedText = {$: 'StrippedText'};
var $author$project$Components$CarrierInvoiceAuditDrafts$kindOf = function (key) {
	if (key.$ === 'QuickReview') {
		switch (key.a.$) {
			case 'InvoiceNumber':
				var _v1 = key.a;
				return $author$project$Components$AuditDrafts$PresentText;
			case 'InvoiceAmount':
				var _v2 = key.a;
				return $author$project$Components$AuditDrafts$Amount;
			case 'InvoiceDate':
				var _v3 = key.a;
				return $author$project$Components$AuditDrafts$PresentText;
			default:
				var _v4 = key.a;
				return $author$project$Components$AuditDrafts$Amount;
		}
	} else {
		return $author$project$Components$AuditDrafts$StrippedText;
	}
};
var $author$project$Components$CarrierInvoiceAuditDrafts$toComparable = function (key) {
	if (key.$ === 'QuickReview') {
		switch (key.a.$) {
			case 'InvoiceNumber':
				var _v1 = key.a;
				return _Utils_Tuple2('quick-review', 'invoice-number');
			case 'InvoiceAmount':
				var _v2 = key.a;
				return _Utils_Tuple2('quick-review', 'invoice-amount');
			case 'InvoiceDate':
				var _v3 = key.a;
				return _Utils_Tuple2('quick-review', 'invoice-date');
			default:
				var _v4 = key.a;
				return _Utils_Tuple2('quick-review', 'amount-to-pay');
		}
	} else {
		var name = key.a;
		return _Utils_Tuple2('extracted', name);
	}
};
var $author$project$Components$CarrierInvoiceAuditDrafts$empty = $author$project$Components$AuditDrafts$empty(
	{kindOf: $author$project$Components$CarrierInvoiceAuditDrafts$kindOf, toComparable: $author$project$Components$CarrierInvoiceAuditDrafts$toComparable});
var $author$project$Components$AuditAddExceptionEvent$init = {customMessage: '', selectedMessage: ''};
var $author$project$Components$CarrierInvoiceAuditChecks$init = {addExceptionEvent: $author$project$Components$AuditAddExceptionEvent$init, drafts: $author$project$Components$CarrierInvoiceAuditDrafts$empty, exceptionEventInputs: $elm$core$Dict$empty, expandedCompletedChecks: $elm$core$Set$empty, expansion: $author$project$Components$CarrierInvoiceAuditChecks$TopCheckOnly, ignoreInFlight: $elm$core$Maybe$Nothing, quickReviewCollapsed: true};
var $author$project$Components$DocumentsBrowser$AddDocumentToLoadMsg = function (a) {
	return {$: 'AddDocumentToLoadMsg', a: a};
};
var $author$project$Components$DocumentsBrowser$Documents = {$: 'Documents'};
var $author$project$Components$DocumentBrowser$Full$Height = {$: 'Height'};
var $author$project$Components$DocumentsBrowser$NonHotkeyMsg = function (a) {
	return {$: 'NonHotkeyMsg', a: a};
};
var $author$project$Components$DocumentBrowser$Full$Width = {$: 'Width'};
var $author$project$Domain$DocumentId$toComparable = function (id) {
	return _Utils_Tuple2(
		'documentId',
		$author$project$Domain$DocumentId$toInt(id));
};
var $author$project$Helpers$DocumentIsPodUpdates$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$Domain$DocumentId$toComparable);
var $author$project$Js$setupAddDocumentToLoad = _Platform_outgoingPort(
	'setupAddDocumentToLoad',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$init = function (pageContextData) {
	return _Utils_Tuple2(
		{pageContextData: pageContextData},
		$author$project$HubTran$Effect$cmd(
			$author$project$Js$setupAddDocumentToLoad(_Utils_Tuple0)));
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Idle = {$: 'Idle'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$init = $author$project$Components$DocumentBrowser$AnnotationOverlay$Idle;
var $author$project$Components$DocumentsBrowser$init = function (config) {
	var viewModeFromDefault = function (_default) {
		if (_default.$ === 'DefaultViewModeHeight') {
			return $author$project$Components$DocumentBrowser$Full$Height;
		} else {
			return $author$project$Components$DocumentBrowser$Full$Width;
		}
	};
	var _v0 = $author$project$Components$DocumentBrowser$AddDocumentToLoad$init(config.pageContextData);
	var addDocumentToLoadModel = _v0.a;
	var addDocumentToLoadEffect = _v0.b;
	return _Utils_Tuple2(
		{
			activityTabPage: 0,
			addDocumentToLoad: addDocumentToLoadModel,
			addressMarks: false,
			annotating: false,
			annotations: $author$project$Components$DocumentBrowser$AnnotationOverlay$init,
			currentProcessingSelection: config.currentProcessingSelection,
			displayUnassignedLoadDocuments: config.displayUnassignedLoadDocuments,
			documentIsPodUpdates: $author$project$Helpers$DocumentIsPodUpdates$empty,
			documentTypePickerOpen: false,
			dragScroll: $elm$core$Maybe$Nothing,
			enabledDocumentTypes: config.enabledDocumentTypes,
			enabledToolbarActions: config.enabledToolbarActions,
			highlight: $elm$core$Maybe$Nothing,
			maybeSelectedDocumentPageId: $elm$core$Maybe$Nothing,
			onDone: config.maybeOnDone,
			pendingHidden: $elm$core$Dict$empty,
			popout: config.popout,
			resendingTransmissions: $elm$core$Dict$empty,
			savedMessageAsDocument: false,
			savingMessageAsDocument: false,
			scrollContainerSuffix: config.scrollContainerSuffix,
			selectedLabelIndex: 0,
			selectedPage_INTERNAL: {documentIndex: 0, pageIndex: 0},
			selectedTab: $author$project$Components$DocumentsBrowser$Documents,
			showAllLoadDocsToggled: false,
			updating: false,
			viewMode: A2($elm$core$Maybe$map, viewModeFromDefault, config.maybeDefaultViewMode),
			viewPortHeightPxOffset: config.viewPortHeightPxOffset,
			zoomLevel: 1
		},
		A2(
			$author$project$HubTran$Effect$map,
			A2($elm$core$Basics$composeL, $author$project$Components$DocumentsBrowser$NonHotkeyMsg, $author$project$Components$DocumentsBrowser$AddDocumentToLoadMsg),
			addDocumentToLoadEffect));
};
var $author$project$Components$DragDrop$NotDragging = {$: 'NotDragging'};
var $author$project$Components$DragDrop$init = {dragState: $author$project$Components$DragDrop$NotDragging};
var $author$project$PostRequestState$PostRequestState = function (a) {
	return {$: 'PostRequestState', a: a};
};
var $author$project$PostRequestState$init = $author$project$PostRequestState$PostRequestState(
	{inProgress: 0});
var $author$project$AuditApi$initRequestState = $author$project$PostRequestState$init;
var $author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdEncoder = function (id) {
	return _Utils_Tuple2(
		'documentBatchId',
		$author$project$Id$encode(id));
};
var $author$project$Domain$DocumentPageId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Domain$DocumentPageId$encode = function (id) {
	return $elm$json$Json$Encode$int(
		$author$project$Domain$DocumentPageId$toInt(id));
};
var $author$project$Broker$Shared$CurrentProcessingSelection$documentPageIdEncoder = function (id) {
	return _Utils_Tuple2(
		'documentPageId',
		$author$project$Domain$DocumentPageId$encode(id));
};
var $author$project$Domain$DocumentGroupId$toInt = function (_v0) {
	var i = _v0.a;
	return i;
};
var $author$project$Domain$DocumentGroupId$encode = function (id) {
	return $elm$json$Json$Encode$int(
		$author$project$Domain$DocumentGroupId$toInt(id));
};
var $author$project$Domain$LoadStateId$encode = function (id) {
	return $elm$json$Json$Encode$int(
		$author$project$Domain$LoadStateId$toInt(id));
};
var $author$project$Broker$Shared$CurrentProcessingSelection$encodeToValue = function (selection) {
	var maybeEncodePage = F2(
		function (maybeDocPageId, list) {
			var _v1 = A2($elm$core$Maybe$map, $author$project$Broker$Shared$CurrentProcessingSelection$documentPageIdEncoder, maybeDocPageId);
			if (_v1.$ === 'Just') {
				var pageId = _v1.a;
				return _Utils_ap(
					list,
					_List_fromArray(
						[pageId]));
			} else {
				return list;
			}
		});
	var encodeWithPage = F2(
		function (maybeDocPageId, fields) {
			return $elm$json$Json$Encode$object(
				A2(maybeEncodePage, maybeDocPageId, fields));
		});
	switch (selection.$) {
		case 'CarrierInvoiceSelection':
			var carrierInvoiceId = selection.a;
			var maybeDocPageId = selection.b;
			return A2(
				encodeWithPage,
				maybeDocPageId,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'carrierInvoiceId',
						$author$project$Id$encode(carrierInvoiceId))
					]));
		case 'FactorInvoiceSelection':
			var factorInvoiceId = selection.a;
			var maybeDocPageId = selection.b;
			return A2(
				encodeWithPage,
				maybeDocPageId,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'factorInvoiceId',
						$author$project$Id$encode(factorInvoiceId))
					]));
		case 'GroupedDocumentBatchSelection':
			var documentBatchId = selection.a;
			var documentGroupId = selection.b;
			var maybeDocPageId = selection.c;
			return A2(
				encodeWithPage,
				maybeDocPageId,
				_List_fromArray(
					[
						$author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdEncoder(documentBatchId),
						_Utils_Tuple2(
						'documentGroupId',
						$author$project$Domain$DocumentGroupId$encode(documentGroupId))
					]));
		case 'DocumentBatchSelection':
			var documentBatchId = selection.a;
			var maybeDocPageId = selection.b;
			return A2(
				encodeWithPage,
				maybeDocPageId,
				_List_fromArray(
					[
						$author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdEncoder(documentBatchId)
					]));
		case 'EmailMessageSelection':
			var emailId = selection.a;
			var documentBatchId = selection.b;
			var maybeDocPageId = selection.c;
			return A2(
				encodeWithPage,
				maybeDocPageId,
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							_Utils_Tuple2(
								'emailId',
								$author$project$Id$encode(emailId))),
							A2($elm$core$Maybe$map, $author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdEncoder, documentBatchId)
						])));
		case 'SinglePageSelection':
			var documentPageId = selection.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						$author$project$Broker$Shared$CurrentProcessingSelection$documentPageIdEncoder(documentPageId)
					]));
		case 'DocumentReviewSelection':
			var maybeDocumentPageId = selection.b;
			return A2(encodeWithPage, maybeDocumentPageId, _List_Nil);
		case 'DocumentBatchReviewSelection':
			var maybeDocumentPageId = selection.c;
			return A2(encodeWithPage, maybeDocumentPageId, _List_Nil);
		case 'DocumentGroupReviewSelection':
			var maybeDocumentPageId = selection.c;
			return A2(encodeWithPage, maybeDocumentPageId, _List_Nil);
		case 'NonInvoiceLoadSelection':
			var loadStateId = selection.a;
			var documentBatchId = selection.b;
			var maybeDocPageId = selection.c;
			return A2(
				encodeWithPage,
				maybeDocPageId,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'loadStateId',
						$author$project$Domain$LoadStateId$encode(loadStateId)),
						$author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdEncoder(documentBatchId)
					]));
		default:
			return $elm$json$Json$Encode$null;
	}
};
var $author$project$Js$offerDocumentViewerPopoutSelection = _Platform_outgoingPort('offerDocumentViewerPopoutSelection', $elm$core$Basics$identity);
var $author$project$Components$AuditSplitPane$offerSelection = function (selection) {
	return $author$project$HubTran$Effect$cmd(
		$author$project$Js$offerDocumentViewerPopoutSelection(
			$author$project$Broker$Shared$CurrentProcessingSelection$encodeToValue(selection)));
};
var $author$project$Components$CarrierInvoiceAuditPage$init = F4(
	function (carrierInvoiceId, emailMessageId, replyEmailId, onDone) {
		var selection = $author$project$Broker$Shared$CurrentProcessingSelection$carrierInvoice(carrierInvoiceId);
		var _v0 = $author$project$Components$DocumentsBrowser$init(
			{
				currentProcessingSelection: selection,
				displayUnassignedLoadDocuments: true,
				enabledDocumentTypes: _List_Nil,
				enabledToolbarActions: _List_fromArray(
					[$author$project$Components$DocumentsBrowser$UpdateDocumentTypeAction]),
				maybeDefaultViewMode: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$DefaultViewModeWidth),
				maybeOnDone: onDone,
				pageContextData: $author$project$Helpers$DocumentViewerPageContextData$empty,
				popout: false,
				scrollContainerSuffix: 'primary',
				viewPortHeightPxOffset: 0
			});
		var documentsBrowser = _v0.a;
		var documentsBrowserEffect = _v0.b;
		return _Utils_Tuple2(
			{auditChecks: $author$project$Components$CarrierInvoiceAuditChecks$init, carrierInvoiceId: carrierInvoiceId, documentsBrowser: documentsBrowser, dragDrop: $author$project$Components$DragDrop$init, emailMessageId: emailMessageId, onDone: onDone, queuedUpdates: _List_Nil, replyEmailId: replyEmailId, requestState: $author$project$AuditApi$initRequestState, selectedTab: $author$project$Components$CarrierInvoiceAuditPage$Summary, sendToCarrierOpen: false, splitPane: $author$project$Components$AuditSplitPane$init},
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						A2($author$project$HubTran$Effect$map, $author$project$Components$CarrierInvoiceAuditPage$DocumentsBrowserMsg, documentsBrowserEffect),
						$author$project$Components$AuditSplitPane$offerSelection(selection)
					])));
	});
var $author$project$Components$DocumentBatchReviewPage$DocumentBatchGroupingReviewPage = function (a) {
	return {$: 'DocumentBatchGroupingReviewPage', a: a};
};
var $author$project$Components$DocumentBatchReviewPage$DocumentBatchGroupingReviewPageMsg = function (a) {
	return {$: 'DocumentBatchGroupingReviewPageMsg', a: a};
};
var $author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchReviewSelection = F3(
	function (a, b, c) {
		return {$: 'DocumentBatchReviewSelection', a: a, b: b, c: c};
	});
var $author$project$Components$DocumentBatchReviewPage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$NotPreviewing = {$: 'NotPreviewing'};
var $author$project$Components$DocumentBatchGroupingReviewPage$init = F2(
	function (documentBatchGroupingReviewId, documentBatchReviewId) {
		return _Utils_Tuple2(
			{documentBatchGroupingReviewId: documentBatchGroupingReviewId, documentBatchReviewId: documentBatchReviewId, documentPreview: $author$project$Components$DocumentBatchGroupingReviewPage$NotPreviewing, dragDrop: $author$project$Components$DragDrop$init, groupableDocumentIds: _List_Nil, updating: false},
			$author$project$HubTran$Effect$none);
	});
var $author$project$Components$DocumentBatchReviewPage$init = F2(
	function (documentBatchReviewId, onDoneQuery) {
		var _v0 = $author$project$Components$DocumentsBrowser$init(
			{
				currentProcessingSelection: A3($author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchReviewSelection, documentBatchReviewId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
				displayUnassignedLoadDocuments: true,
				enabledDocumentTypes: _List_Nil,
				enabledToolbarActions: _List_Nil,
				maybeDefaultViewMode: $elm$core$Maybe$Nothing,
				maybeOnDone: $elm$core$Maybe$Nothing,
				pageContextData: {
					carrierInvoiceHasSubmission: $elm$core$Maybe$Just(false),
					carrierInvoiceId: $elm$core$Maybe$Nothing,
					loadStateId: $elm$core$Maybe$Nothing
				},
				popout: false,
				scrollContainerSuffix: 'primary',
				viewPortHeightPxOffset: 0
			});
		var documentsBrowser = _v0.a;
		var documentsBrowserEffect = _v0.b;
		var _v1 = function () {
			var id = documentBatchReviewId.a;
			var _v3 = A2($author$project$Components$DocumentBatchGroupingReviewPage$init, id, documentBatchReviewId);
			var documentBatchGroupingModel = _v3.a;
			var documentBatchGroupingEffect = _v3.b;
			return _Utils_Tuple2(
				$author$project$Components$DocumentBatchReviewPage$DocumentBatchGroupingReviewPage(documentBatchGroupingModel),
				A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentBatchReviewPage$DocumentBatchGroupingReviewPageMsg, documentBatchGroupingEffect));
		}();
		var childModel = _v1.a;
		var childEffect = _v1.b;
		return _Utils_Tuple2(
			{childModel: childModel, documentBatchReviewId: documentBatchReviewId, documentsBrowser: documentsBrowser, onDone: onDoneQuery, requestState: $author$project$AuditApi$initRequestState},
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						childEffect,
						A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentBatchReviewPage$DocumentsBrowserMsg, documentsBrowserEffect)
					])));
	});
var $author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPage = function (a) {
	return {$: 'DocumentGroupLoadReviewPage', a: a};
};
var $author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPageMsg = function (a) {
	return {$: 'DocumentGroupLoadReviewPageMsg', a: a};
};
var $author$project$Domain$DocumentGroupReviewId$DocumentGroupLoadReviewId = function (a) {
	return {$: 'DocumentGroupLoadReviewId', a: a};
};
var $author$project$Broker$Shared$CurrentProcessingSelection$DocumentGroupReviewSelection = F3(
	function (a, b, c) {
		return {$: 'DocumentGroupReviewSelection', a: a, b: b, c: c};
	});
var $author$project$Components$DocumentGroupLoadReviewPage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 'NotAsked'};
var $author$project$Components$LoadPicker$ShowingGuessed = {$: 'ShowingGuessed'};
var $author$project$Components$LoadPicker$init = function (guessedLoads) {
	return {guessedLoads: guessedLoads, hoveredValue: $elm$core$Maybe$Nothing, selectedLoadStateId: $elm$core$Maybe$Nothing, state: $author$project$Components$LoadPicker$ShowingGuessed};
};
var $author$project$Components$DocumentGroupLoadReviewPage$init = function (documentGroupLoadReviewId) {
	var loadPicker = $author$project$Components$LoadPicker$init(_List_Nil);
	var _v0 = $author$project$Components$DocumentsBrowser$init(
		{
			currentProcessingSelection: A3(
				$author$project$Broker$Shared$CurrentProcessingSelection$DocumentGroupReviewSelection,
				$author$project$Domain$DocumentGroupReviewId$DocumentGroupLoadReviewId(documentGroupLoadReviewId),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing),
			displayUnassignedLoadDocuments: true,
			enabledDocumentTypes: _List_Nil,
			enabledToolbarActions: _List_Nil,
			maybeDefaultViewMode: $elm$core$Maybe$Nothing,
			maybeOnDone: $elm$core$Maybe$Nothing,
			pageContextData: {
				carrierInvoiceHasSubmission: $elm$core$Maybe$Just(false),
				carrierInvoiceId: $elm$core$Maybe$Nothing,
				loadStateId: $elm$core$Maybe$Nothing
			},
			popout: false,
			scrollContainerSuffix: 'primary',
			viewPortHeightPxOffset: 0
		});
	var documentsBrowser = _v0.a;
	var documentsBrowserEffect = _v0.b;
	return _Utils_Tuple2(
		{carrierChoice: $elm$core$Maybe$Nothing, carrierSearchResults: $krisajenkins$remotedata$RemoteData$NotAsked, carrierSearchTerm: '', documentGroupLoadReviewId: documentGroupLoadReviewId, documentsBrowser: documentsBrowser, extractedCarrier: $elm$core$Maybe$Nothing, hasLoadedGuessedLoads: false, highlightedValue: $elm$core$Maybe$Nothing, loadPicker: loadPicker, selectedSearchedCarrier: $elm$core$Maybe$Nothing},
		A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupLoadReviewPage$DocumentsBrowserMsg, documentsBrowserEffect));
};
var $author$project$Components$DocumentGroupReviewPage$init = F2(
	function (reviewId, onDone) {
		var loadReviewId = reviewId.a;
		var _v1 = $author$project$Components$DocumentGroupLoadReviewPage$init(loadReviewId);
		var childModel = _v1.a;
		var childEffect = _v1.b;
		return _Utils_Tuple2(
			{
				childModel: $author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPage(childModel),
				onDone: onDone,
				requestState: $author$project$AuditApi$initRequestState,
				reviewId: reviewId
			},
			A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPageMsg, childEffect));
	});
var $author$project$Components$DocumentReviewPage$DocumentLoadReferenceMatchReviewPage = function (a) {
	return {$: 'DocumentLoadReferenceMatchReviewPage', a: a};
};
var $author$project$Components$DocumentReviewPage$DocumentLoadReferenceMatchReviewPageMsg = function (a) {
	return {$: 'DocumentLoadReferenceMatchReviewPageMsg', a: a};
};
var $author$project$Broker$Shared$CurrentProcessingSelection$DocumentReviewSelection = F2(
	function (a, b) {
		return {$: 'DocumentReviewSelection', a: a, b: b};
	});
var $author$project$Components$DocumentReviewPage$DocumentTypeReviewPage = function (a) {
	return {$: 'DocumentTypeReviewPage', a: a};
};
var $author$project$Components$DocumentReviewPage$DocumentTypeReviewPageMsg = function (a) {
	return {$: 'DocumentTypeReviewPageMsg', a: a};
};
var $author$project$Components$DocumentReviewPage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Components$DocumentReviewPage$InvoiceAmountReviewPage = function (a) {
	return {$: 'InvoiceAmountReviewPage', a: a};
};
var $author$project$Components$DocumentReviewPage$InvoiceAmountReviewPageMsg = function (a) {
	return {$: 'InvoiceAmountReviewPageMsg', a: a};
};
var $author$project$Components$DocumentReviewPage$InvoiceNumberReviewPage = function (a) {
	return {$: 'InvoiceNumberReviewPage', a: a};
};
var $author$project$Components$DocumentReviewPage$InvoiceNumberReviewPageMsg = function (a) {
	return {$: 'InvoiceNumberReviewPageMsg', a: a};
};
var $author$project$Components$DocumentReviewPage$MultiPageBolReviewPage = function (a) {
	return {$: 'MultiPageBolReviewPage', a: a};
};
var $author$project$Components$DocumentReviewPage$MultiPageBolReviewPageMsg = function (a) {
	return {$: 'MultiPageBolReviewPageMsg', a: a};
};
var $author$project$Components$DocumentsBrowser$RotateAction = {$: 'RotateAction'};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$init = function (documentLoadReferenceMatchReviewId) {
	return _Utils_Tuple2(
		{checkedValues: $elm$core$Set$empty, documentLoadReferenceMatchReviewId: documentLoadReferenceMatchReviewId, hoveredValue: $elm$core$Maybe$Nothing},
		$author$project$HubTran$Effect$none);
};
var $author$project$Components$DocumentTypeReviewPage$init = function (documentTypeReviewId) {
	return _Utils_Tuple2(
		{documentTypeReviewId: documentTypeReviewId},
		$author$project$HubTran$Effect$none);
};
var $author$project$Components$InvoiceAmountReviewPage$init = function (invoiceAmountReviewId) {
	return _Utils_Tuple2(
		{invoiceAmountInput: $elm$core$Maybe$Nothing, invoiceAmountReviewId: invoiceAmountReviewId},
		$author$project$HubTran$Effect$none);
};
var $author$project$Components$InvoiceNumberReviewPage$init = function (invoiceNumberReviewId) {
	return _Utils_Tuple2(
		{invoiceNumberInput: '', invoiceNumberReviewId: invoiceNumberReviewId},
		$author$project$HubTran$Effect$none);
};
var $author$project$Components$MultiPageBolReviewPage$init = function (multiPageBolReviewId) {
	return _Utils_Tuple2(
		{allPagesAreSameBol: $elm$core$Maybe$Nothing, allPagesOfBolPresent: $elm$core$Maybe$Nothing, multiPageBolReviewId: multiPageBolReviewId},
		$author$project$HubTran$Effect$none);
};
var $author$project$Components$DocumentReviewPage$init = F2(
	function (documentReviewId, onDoneQuery) {
		var _v0 = $author$project$Components$DocumentsBrowser$init(
			{
				currentProcessingSelection: A2($author$project$Broker$Shared$CurrentProcessingSelection$DocumentReviewSelection, documentReviewId, $elm$core$Maybe$Nothing),
				displayUnassignedLoadDocuments: true,
				enabledDocumentTypes: _List_Nil,
				enabledToolbarActions: _List_fromArray(
					[$author$project$Components$DocumentsBrowser$RotateAction]),
				maybeDefaultViewMode: $elm$core$Maybe$Nothing,
				maybeOnDone: $elm$core$Maybe$Nothing,
				pageContextData: {
					carrierInvoiceHasSubmission: $elm$core$Maybe$Just(false),
					carrierInvoiceId: $elm$core$Maybe$Nothing,
					loadStateId: $elm$core$Maybe$Nothing
				},
				popout: false,
				scrollContainerSuffix: 'primary',
				viewPortHeightPxOffset: 0
			});
		var documentsBrowser = _v0.a;
		var documentsBrowserEffect = _v0.b;
		var _v1 = function () {
			switch (documentReviewId.$) {
				case 'InvoiceNumberReviewId':
					var id = documentReviewId.a;
					var _v3 = $author$project$Components$InvoiceNumberReviewPage$init(id);
					var invoiceNumberModel = _v3.a;
					var invoiceNumberEffect = _v3.b;
					return _Utils_Tuple2(
						$author$project$Components$DocumentReviewPage$InvoiceNumberReviewPage(invoiceNumberModel),
						A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$InvoiceNumberReviewPageMsg, invoiceNumberEffect));
				case 'InvoiceAmountReviewId':
					var id = documentReviewId.a;
					var _v4 = $author$project$Components$InvoiceAmountReviewPage$init(id);
					var invoiceAmountModel = _v4.a;
					var invoiceAmountEffect = _v4.b;
					return _Utils_Tuple2(
						$author$project$Components$DocumentReviewPage$InvoiceAmountReviewPage(invoiceAmountModel),
						A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$InvoiceAmountReviewPageMsg, invoiceAmountEffect));
				case 'MultiPageBolReviewId':
					var id = documentReviewId.a;
					var _v5 = $author$project$Components$MultiPageBolReviewPage$init(id);
					var multiPageBolModel = _v5.a;
					var multiPageBolEffect = _v5.b;
					return _Utils_Tuple2(
						$author$project$Components$DocumentReviewPage$MultiPageBolReviewPage(multiPageBolModel),
						A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$MultiPageBolReviewPageMsg, multiPageBolEffect));
				case 'DocumentTypeReviewId':
					var id = documentReviewId.a;
					var _v6 = $author$project$Components$DocumentTypeReviewPage$init(id);
					var documentTypeModel = _v6.a;
					var documentTypeEffect = _v6.b;
					return _Utils_Tuple2(
						$author$project$Components$DocumentReviewPage$DocumentTypeReviewPage(documentTypeModel),
						A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$DocumentTypeReviewPageMsg, documentTypeEffect));
				default:
					var id = documentReviewId.a;
					var _v7 = $author$project$Components$DocumentLoadReferenceMatchReviewPage$init(id);
					var documentLoadReferenceMatchReviewModel = _v7.a;
					var documentLoadReferenceMatchReviewEffect = _v7.b;
					return _Utils_Tuple2(
						$author$project$Components$DocumentReviewPage$DocumentLoadReferenceMatchReviewPage(documentLoadReferenceMatchReviewModel),
						A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$DocumentLoadReferenceMatchReviewPageMsg, documentLoadReferenceMatchReviewEffect));
			}
		}();
		var childModel = _v1.a;
		var childEffect = _v1.b;
		return _Utils_Tuple2(
			{childModel: childModel, documentsBrowser: documentsBrowser, onDone: onDoneQuery, requestState: $author$project$AuditApi$initRequestState},
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						childEffect,
						A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$DocumentsBrowserMsg, documentsBrowserEffect)
					])));
	});
var $author$project$Components$EmailMessageSearchPage$FiltersViewMsg = function (a) {
	return {$: 'FiltersViewMsg', a: a};
};
var $author$project$Components$EmailMessageSearchPage$defaultParameters = {clientId: $elm$core$Maybe$Nothing, endDate: $elm$core$Maybe$Nothing, endDateTime: $elm$core$Maybe$Nothing, includeSent: false, searchText: $elm$core$Maybe$Nothing, startDate: $elm$core$Maybe$Nothing, startDateTime: $elm$core$Maybe$Nothing};
var $author$project$Components$EmailMessageSearchPage$FiltersView$CarrierDropdownMsg = function (a) {
	return {$: 'CarrierDropdownMsg', a: a};
};
var $author$project$Ui$V3$CustomSelect$HideSelectAllAttribute = function (a) {
	return {$: 'HideSelectAllAttribute', a: a};
};
var $author$project$Ui$V3$CustomSelect$hideSelectAll = $author$project$Ui$V3$CustomSelect$HideSelectAllAttribute;
var $author$project$Typeahead$defaultHowManyToShow = 10;
var $author$project$Typeahead$Model = function (a) {
	return {$: 'Model', a: a};
};
var $author$project$Typeahead$NoSelection = function (a) {
	return {$: 'NoSelection', a: a};
};
var $author$project$TypeaheadMenu$empty = {highlightedViaKeyboard: $elm$core$Maybe$Nothing, highlightedViaMouse: $elm$core$Maybe$Nothing};
var $author$project$Typeahead$initHelp = F2(
	function (numberToShow, show) {
		return $author$project$Typeahead$Model(
			{
				focused: false,
				incrementToSetText: 0,
				menu: show ? $elm$core$Maybe$Just($author$project$TypeaheadMenu$empty) : $elm$core$Maybe$Nothing,
				numberToShow: numberToShow,
				selection: $author$project$Typeahead$NoSelection('')
			});
	});
var $author$project$Typeahead$initOpen = A2($author$project$Typeahead$initHelp, $author$project$Typeahead$defaultHowManyToShow, true);
var $author$project$Components$CarrierTypeahead$init = $author$project$Typeahead$initOpen;
var $author$project$Ui$V3$CustomSelect$AutoFilter = function (a) {
	return {$: 'AutoFilter', a: a};
};
var $author$project$Ui$V3$CustomSelect$autoFilter = $author$project$Ui$V3$CustomSelect$AutoFilter;
var $author$project$Components$SettingsPage$CarrierDropdown$carrierToDropdownItem = function (carrier) {
	return {
		id: $elm$core$String$fromInt(
			$author$project$Domain$TmsCarrierId$toInt(carrier.id)),
		label: $elm$html$Html$text(carrier.name),
		text: carrier.name
	};
};
var $author$project$Ui$V3$CustomSelect$FilterableAttribute = function (a) {
	return {$: 'FilterableAttribute', a: a};
};
var $author$project$Ui$V3$CustomSelect$filterable = $author$project$Ui$V3$CustomSelect$FilterableAttribute;
var $author$project$Ui$V3$CustomSelect$Model = function (a) {
	return {$: 'Model', a: a};
};
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $author$project$Ui$V3$CustomSelect$defaultAttributes = {
	autoFill: false,
	autoFilter: true,
	borderless: false,
	clearable: false,
	customId: $elm$core$Maybe$Nothing,
	disabled: false,
	disabledItemIds: _List_Nil,
	error: false,
	excludable: false,
	filterable: false,
	footerItems: _List_Nil,
	footerItemsHeader: $elm$core$Maybe$Nothing,
	hideArrow: false,
	hideEmptyDropdown: false,
	hideSelectAll: false,
	label: $elm$core$Maybe$Nothing,
	labelToHtml: function (lbl) {
		return A2(
			$elm$html$Html$h6,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(lbl)
				]));
	},
	leftIcon: $elm$core$Maybe$Nothing,
	loading: false,
	multiSelectTypeahead: false,
	openUp: false,
	placeLabelOnLeft: false,
	placeholder: $elm$core$Maybe$Nothing,
	placeholderOptionAt: $elm$core$Maybe$Nothing,
	placeholderOptionAtToHtml: function (p) {
		return A2(
			$elm$html$Html$h6,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(p)
				]));
	},
	singleSelectTypeahead: false,
	verticalInputPadding: 12
};
var $author$project$Ui$V3$CustomSelect$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'DisabledAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{disabled: value});
				case 'ExcludableAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{excludable: value});
				case 'FilterableAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{filterable: value});
				case 'HideSelectAllAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{hideSelectAll: value});
				case 'LoadingAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{loading: value});
				case 'TypeaheadStyleAttribute':
					var value = a.a;
					switch (value.$) {
						case 'MultiSelectTypeahead':
							return _Utils_update(
								acc,
								{multiSelectTypeahead: true, singleSelectTypeahead: false});
						case 'SingleSelectTypeahead':
							return _Utils_update(
								acc,
								{multiSelectTypeahead: false, singleSelectTypeahead: true});
						default:
							return _Utils_update(
								acc,
								{multiSelectTypeahead: false, singleSelectTypeahead: false});
					}
				case 'OpenUpAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{openUp: value});
				case 'PlaceLabelOnLeftAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{placeLabelOnLeft: value});
				case 'AutoFilter':
					var value = a.a;
					return _Utils_update(
						acc,
						{autoFilter: value});
				case 'Placeholder':
					var value = a.a;
					return _Utils_update(
						acc,
						{placeholder: value});
				case 'PlaceholderOptionAt':
					var minSearchLength = a.a;
					return _Utils_update(
						acc,
						{
							placeholderOptionAt: $elm$core$Maybe$Just(minSearchLength)
						});
				case 'Clearable':
					var value = a.a;
					return _Utils_update(
						acc,
						{clearable: value});
				case 'CustomId':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							customId: $elm$core$Maybe$Just(value)
						});
				case 'AutoFill':
					var value = a.a;
					return _Utils_update(
						acc,
						{autoFill: value});
				case 'LabelOverride':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							label: $elm$core$Maybe$Just(value)
						});
				case 'LabelToHtml':
					var toHtml = a.a;
					return _Utils_update(
						acc,
						{labelToHtml: toHtml});
				case 'PlaceholderOptionAtToHtml':
					var toHtml = a.a;
					return _Utils_update(
						acc,
						{placeholderOptionAtToHtml: toHtml});
				case 'ErrorAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{error: value});
				case 'DisabledItemIds':
					var ids = a.a;
					return _Utils_update(
						acc,
						{disabledItemIds: ids});
				case 'VerticalInputPadding':
					var padding = a.a;
					return _Utils_update(
						acc,
						{verticalInputPadding: padding});
				case 'LeftIcon':
					var icon = a.a;
					return _Utils_update(
						acc,
						{
							leftIcon: $elm$core$Maybe$Just(icon)
						});
				case 'BorderlessAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{borderless: value});
				case 'HideArrowAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{hideArrow: value});
				case 'HideEmptyDropdownAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{hideEmptyDropdown: value});
				case 'FooterItemsAttribute':
					var items = a.a;
					return _Utils_update(
						acc,
						{footerItems: items});
				default:
					var header = a.a;
					return _Utils_update(
						acc,
						{
							footerItemsHeader: $elm$core$Maybe$Just(header)
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$CustomSelect$defaultAttributes, attributes);
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Ui$V3$CustomSelect$getCleanId = function (_v0) {
	var model = _v0.a;
	return A3(
		$elm$core$String$replace,
		' ',
		'-',
		A2($elm$core$Maybe$withDefault, model.domId, model.customId));
};
var $author$project$Ui$V3$CustomSelect$getListId = function (model) {
	return $author$project$Ui$V3$CustomSelect$getCleanId(model) + '-list';
};
var $author$project$Ui$V3$Ports$v3DisableScrollByContainerId = _Platform_outgoingPort('v3DisableScrollByContainerId', $elm$json$Json$Encode$string);
var $author$project$Ui$V3$CustomSelect$init = F2(
	function (requiredAttributes, attributes) {
		var computedAttributes = $author$project$Ui$V3$CustomSelect$computeAttributes(attributes);
		var initialModel = $author$project$Ui$V3$CustomSelect$Model(
			{autoFill: computedAttributes.autoFill, autoFilter: computedAttributes.autoFilter, autoSelectText: '', canExcludeOptions: computedAttributes.multiSelectTypeahead && computedAttributes.excludable, clearable: computedAttributes.clearable, customId: computedAttributes.customId, debouncedInputValue: '', disabled: computedAttributes.disabled, domId: requiredAttributes.domId, excludedItems: requiredAttributes.excludedItems, focusedOptionId: $elm$core$Maybe$Nothing, hasScrolledToBottom: false, hideSelectAll: computedAttributes.hideSelectAll, inputKeystrokeCount: 0, inputValue: '', isFilterable: computedAttributes.filterable && (computedAttributes.multiSelectTypeahead || computedAttributes.singleSelectTypeahead), isOpen: false, items: requiredAttributes.items, maxItemCountSeen: 0, multiSelectTypeahead: computedAttributes.multiSelectTypeahead, openUp: computedAttributes.openUp, placeLabelOnLeft: computedAttributes.placeLabelOnLeft, placeholder: computedAttributes.placeholder, placeholderOptionAt: computedAttributes.placeholderOptionAt, selectedItems: requiredAttributes.selectedItems, singleSelectTypeahead: computedAttributes.singleSelectTypeahead});
		return _Utils_Tuple2(
			initialModel,
			$author$project$Ui$V3$Ports$v3DisableScrollByContainerId(
				$author$project$Ui$V3$CustomSelect$getListId(initialModel)));
	});
var $author$project$Ui$V3$CustomSelect$MultiSelectTypeahead = {$: 'MultiSelectTypeahead'};
var $author$project$Ui$V3$CustomSelect$multiSelectTypeahead = $author$project$Ui$V3$CustomSelect$MultiSelectTypeahead;
var $author$project$Ui$V3$CustomSelect$PlaceholderOptionAt = function (a) {
	return {$: 'PlaceholderOptionAt', a: a};
};
var $author$project$Ui$V3$CustomSelect$placeholderOptionAt = function (minSearchLength) {
	return $author$project$Ui$V3$CustomSelect$PlaceholderOptionAt(minSearchLength);
};
var $author$project$Ui$V3$CustomSelect$TypeaheadStyleAttribute = function (a) {
	return {$: 'TypeaheadStyleAttribute', a: a};
};
var $author$project$Ui$V3$CustomSelect$typeaheadStyle = $author$project$Ui$V3$CustomSelect$TypeaheadStyleAttribute;
var $author$project$Components$PaginatedDropdown$init = function (_v0) {
	var attrs = _v0.attrs;
	var lastItems = _v0.lastItems;
	var otherItems = _v0.otherItems;
	var selectedItems = _v0.selectedItems;
	var domId = _v0.domId;
	var _v1 = A2(
		$author$project$Ui$V3$CustomSelect$init,
		{domId: domId, excludedItems: _List_Nil, items: _List_Nil, selectedItems: selectedItems},
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$multiSelectTypeahead),
					$author$project$Ui$V3$CustomSelect$filterable(true),
					$author$project$Ui$V3$CustomSelect$placeholderOptionAt(2)
				]),
			attrs));
	var dropdown = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		{cachedPages: $elm$core$Dict$empty, dropdown: dropdown, entriesPerPage: 50, lastItems: lastItems, otherItems: otherItems},
		cmd);
};
var $author$project$Components$SettingsPage$CarrierDropdown$initWithSelected = F2(
	function (selectedCarriers, attrs) {
		var _v0 = $author$project$Components$PaginatedDropdown$init(
			{
				attrs: _Utils_ap(
					_List_fromArray(
						[
							$author$project$Ui$V3$CustomSelect$autoFilter(false),
							$author$project$Ui$V3$CustomSelect$hideSelectAll(true)
						]),
					attrs),
				domId: 'carrier',
				lastItems: _List_Nil,
				otherItems: _List_Nil,
				selectedItems: A2($elm$core$List$map, $author$project$Components$SettingsPage$CarrierDropdown$carrierToDropdownItem, selectedCarriers)
			});
		var dropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{dropdown: dropdown},
			cmd);
	});
var $author$project$Components$SettingsPage$CarrierDropdown$init = function (attrs) {
	return A2($author$project$Components$SettingsPage$CarrierDropdown$initWithSelected, _List_Nil, attrs);
};
var $author$project$Typeahead$initClosed = A2($author$project$Typeahead$initHelp, $author$project$Typeahead$defaultHowManyToShow, false);
var $author$project$Typeahead$Selected = function (a) {
	return {$: 'Selected', a: a};
};
var $author$project$Typeahead$selectItem = F2(
	function (selectedItem, _v0) {
		var model = _v0.a;
		return $author$project$Typeahead$Model(
			function () {
				if (selectedItem.$ === 'Nothing') {
					return _Utils_update(
						model,
						{
							selection: $author$project$Typeahead$NoSelection('')
						});
				} else {
					var newItem = selectedItem.a;
					return _Utils_update(
						model,
						{
							menu: $elm$core$Maybe$Nothing,
							selection: $author$project$Typeahead$Selected(newItem)
						});
				}
			}());
	});
var $author$project$Typeahead$initWithSelectedItem = function (selectedItem) {
	return A2(
		$author$project$Typeahead$selectItem,
		$elm$core$Maybe$Just(selectedItem),
		$author$project$Typeahead$initClosed);
};
var $author$project$Components$CarrierTypeahead$initWithTmsCarrier = $author$project$Typeahead$initWithSelectedItem;
var $author$project$Ui$V3$CustomSelect$SingleSelectTypeahead = {$: 'SingleSelectTypeahead'};
var $author$project$Ui$V3$CustomSelect$singleSelectTypeahead = $author$project$Ui$V3$CustomSelect$SingleSelectTypeahead;
var $author$project$Components$EmailMessageSearchPage$FiltersView$init = function (parameters) {
	var _v0 = $author$project$Components$SettingsPage$CarrierDropdown$init(
		_List_fromArray(
			[
				$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
				$author$project$Ui$V3$CustomSelect$hideSelectAll(false)
			]));
	var carrierDropdown = _v0.a;
	var carrierDropdownCmd = _v0.b;
	return _Utils_Tuple2(
		{
			carrierDropdown: carrierDropdown,
			carrierTypeahead: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$CarrierTypeahead$init,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$CarrierTypeahead$initWithTmsCarrier, $author$project$Domain$TmsCarrierId$fromInt),
					parameters.clientId)),
			endDate: parameters.endDate,
			endDateString: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$justinmimbs$date$Date$format('yyyy-MM-dd'),
					parameters.endDate)),
			endDateTime: parameters.endDateTime,
			includeSentEmails: parameters.includeSent,
			selectedSearchTerm: parameters.searchText,
			startDate: parameters.startDate,
			startDateString: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$justinmimbs$date$Date$format('yyyy-MM-dd'),
					parameters.startDate)),
			startDateTime: parameters.startDateTime
		},
		$author$project$HubTran$Effect$cmd(
			A2($elm$core$Platform$Cmd$map, $author$project$Components$EmailMessageSearchPage$FiltersView$CarrierDropdownMsg, carrierDropdownCmd)));
};
var $author$project$Components$EmailMessageSearchPage$init = function (parameters) {
	var _v0 = $author$project$Components$EmailMessageSearchPage$FiltersView$init(parameters);
	var filterUiState = _v0.a;
	var filterUiEffect = _v0.b;
	var filtersApplied = (!_Utils_eq(parameters, $author$project$Components$EmailMessageSearchPage$defaultParameters)) ? $elm$core$Maybe$Just(filterUiState) : $elm$core$Maybe$Nothing;
	return _Utils_Tuple2(
		{filtersApplied: filtersApplied, filtersUiState: filterUiState, maybeLastData: $elm$core$Maybe$Nothing, page: 0},
		A2($author$project$HubTran$Effect$map, $author$project$Components$EmailMessageSearchPage$FiltersViewMsg, filterUiEffect));
};
var $author$project$Components$FactorInvoiceAuditBatchGroupingPage$init = F2(
	function (documentBatchId, onDone) {
		return _Utils_Tuple2(
			{documentBatchId: documentBatchId, onDone: onDone},
			$author$project$HubTran$Effect$none);
	});
var $author$project$Components$OktaLoginPage$showOktaSignIn = _Platform_outgoingPort(
	'showOktaSignIn',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elementId',
					$elm$json$Json$Encode$string($.elementId)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.email)),
					_Utils_Tuple2(
					'error',
					$elm$json$Json$Encode$string($.error)),
					_Utils_Tuple2(
					'flow',
					$elm$json$Json$Encode$string($.flow)),
					_Utils_Tuple2(
					'state',
					$elm$json$Json$Encode$string($.state))
				]));
	});
var $author$project$Components$OktaLoginPage$signInWidgetId = 'user-auth-okta-signin';
var $author$project$Components$OktaLoginPage$init = function (config) {
	return _Utils_Tuple2(
		{failReason: $elm$core$Maybe$Nothing, redirect: config.maybeRedirect},
		$author$project$HubTran$Effect$cmd(
			$author$project$Components$OktaLoginPage$showOktaSignIn(
				{
					elementId: $author$project$Components$OktaLoginPage$signInWidgetId,
					email: A2($elm$core$Maybe$withDefault, '', config.maybeEmail),
					error: A2($elm$core$Maybe$withDefault, '', config.maybeError),
					flow: 'login',
					state: A2($elm$core$Maybe$withDefault, '', config.maybeState)
				})));
};
var $author$project$Components$SettingsPage$AccountSettings = function (a) {
	return {$: 'AccountSettings', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsViewMsg = function (a) {
	return {$: 'AccountSettingsViewMsg', a: a};
};
var $author$project$Components$SettingsPage$CarrierDocumentsSettings = function (a) {
	return {$: 'CarrierDocumentsSettings', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettings = function (a) {
	return {$: 'ContactsSettings', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettingsViewMsg = function (a) {
	return {$: 'ContactsSettingsViewMsg', a: a};
};
var $author$project$Components$SettingsPage$DebtorsSettings = function (a) {
	return {$: 'DebtorsSettings', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettings = function (a) {
	return {$: 'DocumentTypesSettings', a: a};
};
var $author$project$Components$SettingsPage$ExceptionSettings = function (a) {
	return {$: 'ExceptionSettings', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettings = function (a) {
	return {$: 'FactorClientPortalSettings', a: a};
};
var $author$project$Components$SettingsPage$IntegrationsSettings = {$: 'IntegrationsSettings'};
var $author$project$Components$SettingsPage$NextGenAuditSettings = function (a) {
	return {$: 'NextGenAuditSettings', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsViewMsg = function (a) {
	return {$: 'NextGenAuditSettingsViewMsg', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettings = function (a) {
	return {$: 'PodDefinitionSettings', a: a};
};
var $author$project$Components$SettingsPage$ScraperStatusSettings = {$: 'ScraperStatusSettings'};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$init = function (carrierId) {
	return {carrierId: carrierId, confirmDeleteDocumentId: $elm$core$Maybe$Nothing, deletingDocument: false, previewDocumentId: $elm$core$Maybe$Nothing};
};
var $author$project$Components$CarrierDocumentsView$FiltersView$init = {selectedDocumentType: $elm$core$Maybe$Nothing};
var $author$project$Components$DocumentBrowser$init = function (documentIds) {
	return {
		documentIds: documentIds,
		selection: {documentIndex: 0, pageIndex: 0}
	};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$init = function (carrierId) {
	return {
		carrierId: carrierId,
		documentBrowser: $author$project$Components$DocumentBrowser$init(_List_Nil),
		documentsListView: $author$project$Components$CarrierDocumentsView$DocumentsListView$init(carrierId),
		errorMessage: $elm$core$Maybe$Nothing,
		fileUploaded: false,
		filtersView: $author$project$Components$CarrierDocumentsView$FiltersView$init,
		saving: false,
		selectedDocumentType: ''
	};
};
var $author$project$Components$SettingsPage$AccountSettingsView$CustomerTypeaheadReskinMsg = function (a) {
	return {$: 'CustomerTypeaheadReskinMsg', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$New = function (a) {
	return {$: 'New', a: a};
};
var $author$project$Api$LoadCustomerLabels$ungroupedSource = 'ungrouped_category_labeler';
var $author$project$Api$LoadCustomerLabels$defaultSource = $author$project$Api$LoadCustomerLabels$ungroupedSource;
var $author$project$Components$TmsCustomerDropdown$init = function (attrs) {
	var _v0 = $author$project$Components$PaginatedDropdown$init(
		{attrs: attrs, domId: 'customer-name', lastItems: _List_Nil, otherItems: _List_Nil, selectedItems: _List_Nil});
	var dropdown = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{dropdown: dropdown},
		cmd);
};
var $author$project$Typeahead$initOpenWithSize = function (size) {
	return A2($author$project$Typeahead$initHelp, size, true);
};
var $author$project$Components$CustomerTypeahead$initWithSize = function (numberToShow) {
	return $author$project$Typeahead$initOpenWithSize(numberToShow);
};
var $author$project$Ui$V3$CustomSelect$Placeholder = function (a) {
	return {$: 'Placeholder', a: a};
};
var $author$project$Ui$V3$CustomSelect$placeholder = $author$project$Ui$V3$CustomSelect$Placeholder;
var $author$project$Components$SettingsPage$AccountSettingsView$init = function () {
	var _v0 = $author$project$Components$TmsCustomerDropdown$init(
		_List_fromArray(
			[
				$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
				$author$project$Ui$V3$CustomSelect$hideSelectAll(true),
				$author$project$Ui$V3$CustomSelect$placeholder(
				$elm$core$Maybe$Just(''))
			]));
	var loadCustomerTypeaheadReskin = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{
			changes: $elm$core$Maybe$Nothing,
			isSaving: false,
			loadCustomerTypeahead: $author$project$Components$CustomerTypeahead$initWithSize(50),
			loadCustomerTypeaheadReskin: loadCustomerTypeaheadReskin,
			newAutoReplyFilterBody: '',
			newAutoReplyFilterEmailAddress: '',
			newAutoReplyFilterSubject: '',
			newCustomInvoiceExceptionMessage: '',
			newLoadCustomerLabel: $author$project$Components$SettingsPage$AccountSettingsView$New(
				{name: '', source: $author$project$Api$LoadCustomerLabels$defaultSource}),
			newOfficeMapping: '',
			newPeopleMapping: '',
			showLoadCustomerLabel: $elm$core$Maybe$Nothing
		},
		$author$project$HubTran$Effect$cmd(
			A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$AccountSettingsView$CustomerTypeaheadReskinMsg, cmd)));
}();
var $author$project$Components$SettingsPage$ContactsSettingsView$ContactFilterMsg = function (a) {
	return {$: 'ContactFilterMsg', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg = function (a) {
	return {$: 'ContactFormMsg', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettingsView$ShowList = {$: 'ShowList'};
var $author$project$Components$SettingsPage$ContactForm$CarrierDropdownMsg = function (a) {
	return {$: 'CarrierDropdownMsg', a: a};
};
var $author$project$Components$SettingsPage$ContactForm$General = {$: 'General'};
var $author$project$Components$SettingsPage$ContactForm$init = function () {
	var _v0 = A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$Components$SettingsPage$ContactForm$CarrierDropdownMsg),
		$author$project$Components$SettingsPage$CarrierDropdown$init(
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead)
				])));
	var carrierDropdown = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{carrierDropdown: carrierDropdown, carrierTypeahead: $author$project$Components$CarrierTypeahead$init, emailInput: '', nameInput: '', selectedContactType: $author$project$Components$SettingsPage$ContactForm$General},
		$author$project$HubTran$Effect$cmd(cmd));
}();
var $author$project$Components$SettingsPage$ContactsFilter$CarrierDropdownMsg = function (a) {
	return {$: 'CarrierDropdownMsg', a: a};
};
var $author$project$AuditPb$ContactTypeAll = {$: 'ContactTypeAll'};
var $author$project$Components$SettingsPage$ContactsFilter$init = function () {
	var _v0 = $author$project$Components$SettingsPage$CarrierDropdown$init(
		_List_fromArray(
			[
				$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead)
			]));
	var carrierDropdown = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{carrierDropdown: carrierDropdown, carrierTypeahead: $author$project$Components$CarrierTypeahead$init, emailSearchTerm: '', selectedContactType: $author$project$AuditPb$ContactTypeAll},
		$author$project$HubTran$Effect$cmd(
			A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$ContactsFilter$CarrierDropdownMsg, cmd)));
}();
var $author$project$Components$SettingsPage$ContactsSettingsView$init = function () {
	var _v0 = A2(
		$elm$core$Tuple$mapSecond,
		$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg),
		$author$project$Components$SettingsPage$ContactForm$init);
	var contactForm = _v0.a;
	var contactFormEffect = _v0.b;
	var _v1 = A2(
		$elm$core$Tuple$mapSecond,
		$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$ContactsSettingsView$ContactFilterMsg),
		$author$project$Components$SettingsPage$ContactsFilter$init);
	var contactFilter = _v1.a;
	var contactFilterEffect = _v1.b;
	return _Utils_Tuple2(
		{contactFilterModel: contactFilter, contactFormModel: contactForm, page: 1, viewState: $author$project$Components$SettingsPage$ContactsSettingsView$ShowList},
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[contactFilterEffect, contactFormEffect])));
}();
var $author$project$Components$SettingsPage$DebtorsSettingsView$init = {page: 1, searchTerm: ''};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$init = {changes: $elm$core$Maybe$Nothing, documentTypeForTruckPhotos: $elm$core$Maybe$Nothing, editingHotkeyList: false, editingTmsMap: false, editingTmsPodMap: false, isSaving: false, lastSavedHotkeyList: $elm$core$Maybe$Nothing, lastSavedTmsMap: $elm$core$Maybe$Nothing, lastSavedTmsPodMap: $elm$core$Maybe$Nothing, localHotkeyList: _List_Nil, tmsMapEdits: $elm$core$Dict$empty, tmsPodMapEdit: $elm$core$Maybe$Nothing};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotDeleting = {$: 'NotDeleting'};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotEditing = {$: 'NotEditing'};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$init = {deletingState: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotDeleting, editingState: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotEditing, requestState: $author$project$PostRequestState$init};
var $author$project$Components$SettingsPage$ExceptionSettingsView$init = {customSubjectTemplate: $elm$core$Maybe$Nothing, multipleCustomExceptionTemplates: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$init};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$init = {form: $elm$core$Maybe$Nothing, isSaving: false};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Summary = {$: 'Summary'};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$init = $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Summary;
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$init = _Utils_Tuple2(
	{manualReviewPercentage: $elm$core$Maybe$Nothing, reviewPercentageTable: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$init, verificationExceptions: $elm$core$Maybe$Nothing, warnIfAmountOver: $elm$core$Maybe$Nothing},
	$author$project$HubTran$Effect$none);
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$init = {deleting: $elm$core$Maybe$Nothing, editing: $elm$core$Maybe$Nothing, requestState: $author$project$AuditApi$initRequestState};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$init = {accountChecksDraft: $elm$core$Maybe$Nothing, customerLevel: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$init};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Components$SettingsPage$initialActiveSection = function (section) {
	switch (section.$) {
		case 'Account':
			return A3(
				$elm$core$Tuple$mapBoth,
				$author$project$Components$SettingsPage$AccountSettings,
				$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$AccountSettingsViewMsg),
				$author$project$Components$SettingsPage$AccountSettingsView$init);
		case 'NextGenAudit':
			return A3(
				$elm$core$Tuple$mapBoth,
				$author$project$Components$SettingsPage$NextGenAuditSettings,
				$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$NextGenAuditSettingsViewMsg),
				$author$project$Components$SettingsPage$NextGenAuditSettingsView$init);
		case 'Integrations':
			return _Utils_Tuple2($author$project$Components$SettingsPage$IntegrationsSettings, $author$project$HubTran$Effect$none);
		case 'DocumentTypes':
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$DocumentTypesSettings($author$project$Components$SettingsPage$DocumentTypesSettingsView$init),
				$author$project$HubTran$Effect$none);
		case 'CarrierDocuments':
			var tmsCarrierId = section.a;
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$CarrierDocumentsSettings(
					$author$project$Components$CarrierDocumentsView$CarrierDocumentsView$init(tmsCarrierId)),
				$author$project$HubTran$Effect$none);
		case 'Contacts':
			return A3(
				$elm$core$Tuple$mapBoth,
				$author$project$Components$SettingsPage$ContactsSettings,
				$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$ContactsSettingsViewMsg),
				$author$project$Components$SettingsPage$ContactsSettingsView$init);
		case 'Debtors':
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$DebtorsSettings($author$project$Components$SettingsPage$DebtorsSettingsView$init),
				$author$project$HubTran$Effect$none);
		case 'FactorClientPortal':
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$FactorClientPortalSettings($author$project$Components$SettingsPage$FactorClientPortalSettingsView$init),
				$author$project$HubTran$Effect$none);
		case 'Exceptions':
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$ExceptionSettings($author$project$Components$SettingsPage$ExceptionSettingsView$init),
				$author$project$HubTran$Effect$none);
		case 'ScraperStatus':
			return _Utils_Tuple2($author$project$Components$SettingsPage$ScraperStatusSettings, $author$project$HubTran$Effect$none);
		case 'PodDefinition':
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$PodDefinitionSettings($author$project$Components$SettingsPage$PodDefinitionSettingsView$init),
				$author$project$HubTran$Effect$none);
		default:
			return _Debug_todo(
				'Components.SettingsPage',
				{
					start: {line: 132, column: 12},
					end: {line: 132, column: 22}
				})(
				'Got section type ' + ($elm$core$Debug$toString(section) + ' which is not yet handled'));
	}
};
var $author$project$Components$SettingsPage$init = function (section) {
	var _v0 = $author$project$Components$SettingsPage$initialActiveSection(section);
	var activeSection = _v0.a;
	var effect = _v0.b;
	return _Utils_Tuple2(
		{activeSection: activeSection},
		effect);
};
var $author$project$Components$SettingsPage$CarrierLayout$ClientDebtorConfigManagerMsg = function (a) {
	return {$: 'ClientDebtorConfigManagerMsg', a: a};
};
var $author$project$Api$Carriers$ExternalLogins$NotTested = {$: 'NotTested'};
var $author$project$Components$ClientDebtorConfigurationManager$ConfigurationsLoaded = function (a) {
	return {$: 'ConfigurationsLoaded', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$DebtorSpecific = {$: 'DebtorSpecific'};
var $author$project$Components$ClientDebtorConfigurationManager$Hidden = {$: 'Hidden'};
var $author$project$Domain$AmountMatchRequirement$Inherit = {$: 'Inherit'};
var $author$project$Domain$DeliveryDateCheckSetting$Inherit = {$: 'Inherit'};
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit = {$: 'Inherit'};
var $author$project$Domain$LaneRateCheckSetting$Inherit = {$: 'Inherit'};
var $author$project$Domain$RequirementSetting$Inherit = {$: 'Inherit'};
var $author$project$Domain$TrustClientSubmittedSetting$Inherit = {$: 'Inherit'};
var $author$project$Components$DebtorTypeahead$init = $author$project$Typeahead$initOpen;
var $ianmackenzie$elm_units$Quantity$Quantity = function (a) {
	return {$: 'Quantity', a: a};
};
var $ianmackenzie$elm_units$Duration$seconds = function (numSeconds) {
	return $ianmackenzie$elm_units$Quantity$Quantity(numSeconds);
};
var $ianmackenzie$elm_units$Duration$minutes = function (numMinutes) {
	return $ianmackenzie$elm_units$Duration$seconds(60 * numMinutes);
};
var $author$project$Helpers$Api$standardTimeout = $ianmackenzie$elm_units$Duration$minutes(1);
var $author$project$Helpers$Api$get = F2(
	function (url, decoder) {
		return A2(
			$author$project$Forward$CacheableRequest$cacheableRequest,
			{
				body: $elm$core$Maybe$Nothing,
				decoder: decoder,
				headers: _List_Nil,
				method: 'GET',
				timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
				url: url
			},
			$elm$core$Basics$identity);
	});
var $author$project$Domain$FactorBrokerId$FactorBrokerId = function (a) {
	return {$: 'FactorBrokerId', a: a};
};
var $author$project$Domain$FactorBrokerId$fromInt = function (_int) {
	return $author$project$Domain$FactorBrokerId$FactorBrokerId(_int);
};
var $author$project$Domain$FactorBrokerId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $elm$json$Json$Decode$int);
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Domain$AmountMatchRequirement$MayDiffer = {$: 'MayDiffer'};
var $author$project$Domain$AmountMatchRequirement$MustMatch = {$: 'MustMatch'};
var $author$project$Domain$AmountMatchRequirement$fromString = function (raw) {
	return (raw === 'inherit') ? $elm$core$Maybe$Just($author$project$Domain$AmountMatchRequirement$Inherit) : ((raw === 'must_match') ? $elm$core$Maybe$Just($author$project$Domain$AmountMatchRequirement$MustMatch) : ((raw === 'may_differ') ? $elm$core$Maybe$Just($author$project$Domain$AmountMatchRequirement$MayDiffer) : $elm$core$Maybe$Nothing));
};
var $author$project$Domain$AmountMatchRequirement$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Domain$AmountMatchRequirement$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('looking for an AmountMatchRequirement')))),
	$elm$json$Json$Decode$string);
var $author$project$Domain$ClientDebtorConfiguration$optionalAmountMatchRequirementDefaultInherit = function (name) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, name, $author$project$Domain$AmountMatchRequirement$decode),
				$elm$json$Json$Decode$succeed($author$project$Domain$AmountMatchRequirement$Inherit)
			]));
};
var $author$project$Domain$DeliveryDateCheckSetting$Disabled = {$: 'Disabled'};
var $author$project$Domain$DeliveryDateCheckSetting$NinetyDays = {$: 'NinetyDays'};
var $author$project$Domain$DeliveryDateCheckSetting$SixtyDays = {$: 'SixtyDays'};
var $author$project$Domain$DeliveryDateCheckSetting$ThirtyDays = {$: 'ThirtyDays'};
var $author$project$Domain$DeliveryDateCheckSetting$decode = A2(
	$elm$json$Json$Decode$map,
	function (maybeInt) {
		if (maybeInt.$ === 'Nothing') {
			return $author$project$Domain$DeliveryDateCheckSetting$Inherit;
		} else {
			switch (maybeInt.a) {
				case 0:
					return $author$project$Domain$DeliveryDateCheckSetting$Disabled;
				case 30:
					return $author$project$Domain$DeliveryDateCheckSetting$ThirtyDays;
				case 60:
					return $author$project$Domain$DeliveryDateCheckSetting$SixtyDays;
				case 90:
					return $author$project$Domain$DeliveryDateCheckSetting$NinetyDays;
				default:
					return $author$project$Domain$DeliveryDateCheckSetting$Inherit;
			}
		}
	},
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Domain$ClientDebtorConfiguration$optionalDeliveryDateCheckSettingDefaultInherit = function (name) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, name, $author$project$Domain$DeliveryDateCheckSetting$decode),
				$elm$json$Json$Decode$succeed($author$project$Domain$DeliveryDateCheckSetting$Inherit)
			]));
};
var $author$project$Domain$ClientDebtorConfiguration$optionalFlagDefaultFalse = function (name) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, name, $elm$json$Json$Decode$bool),
				$elm$json$Json$Decode$succeed(false)
			]));
};
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$Disabled = {$: 'Disabled'};
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$Enabled = {$: 'Enabled'};
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$fromString = function (raw) {
	switch (raw) {
		case 'on':
			return $elm$core$Maybe$Just($author$project$Domain$InvoiceAmountHistoryCheckSetting$Enabled);
		case 'off':
			return $elm$core$Maybe$Just($author$project$Domain$InvoiceAmountHistoryCheckSetting$Disabled);
		default:
			return $elm$core$Maybe$Just($author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit);
	}
};
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Domain$InvoiceAmountHistoryCheckSetting$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('looking for an InvoiceAmountHistoryCheckSetting')))),
	$elm$json$Json$Decode$string);
var $author$project$Domain$ClientDebtorConfiguration$optionalInvoiceAmountHistoryCheckSettingDefaultInherit = function (name) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, name, $author$project$Domain$InvoiceAmountHistoryCheckSetting$decode),
				$elm$json$Json$Decode$succeed($author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit)
			]));
};
var $author$project$Domain$LaneRateCheckSetting$Disabled = {$: 'Disabled'};
var $author$project$Domain$LaneRateCheckSetting$Enabled = {$: 'Enabled'};
var $author$project$Domain$LaneRateCheckSetting$decode = A2(
	$elm$json$Json$Decode$map,
	function (raw) {
		switch (raw) {
			case 'on':
				return $author$project$Domain$LaneRateCheckSetting$Enabled;
			case 'off':
				return $author$project$Domain$LaneRateCheckSetting$Disabled;
			default:
				return $author$project$Domain$LaneRateCheckSetting$Inherit;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Domain$ClientDebtorConfiguration$optionalLaneRateCheckSettingDefaultInherit = function (name) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, name, $author$project$Domain$LaneRateCheckSetting$decode),
				$elm$json$Json$Decode$succeed($author$project$Domain$LaneRateCheckSetting$Inherit)
			]));
};
var $author$project$Domain$RequirementSetting$NotRequired = {$: 'NotRequired'};
var $author$project$Domain$RequirementSetting$Required = {$: 'Required'};
var $author$project$Domain$RequirementSetting$fromString = function (raw) {
	return (raw === 'inherit') ? $elm$core$Maybe$Just($author$project$Domain$RequirementSetting$Inherit) : ((raw === 'required') ? $elm$core$Maybe$Just($author$project$Domain$RequirementSetting$Required) : ((raw === 'not_required') ? $elm$core$Maybe$Just($author$project$Domain$RequirementSetting$NotRequired) : $elm$core$Maybe$Nothing));
};
var $author$project$Domain$RequirementSetting$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Domain$RequirementSetting$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('looking for a RequirementSetting')))),
	$elm$json$Json$Decode$string);
var $author$project$Domain$ClientDebtorConfiguration$optionalRequirementSettingDefaultInherit = function (name) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, name, $author$project$Domain$RequirementSetting$decode),
				$elm$json$Json$Decode$succeed($author$project$Domain$RequirementSetting$Inherit)
			]));
};
var $author$project$Domain$ClientDebtorConfiguration$optionalStringDefault = F2(
	function (name, _default) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, name, $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed(_default)
				]));
	});
var $author$project$Domain$TrustClientSubmittedSetting$Disabled = {$: 'Disabled'};
var $author$project$Domain$TrustClientSubmittedSetting$Enabled = {$: 'Enabled'};
var $author$project$Domain$TrustClientSubmittedSetting$fromString = function (raw) {
	return (raw === 'inherit') ? $elm$core$Maybe$Just($author$project$Domain$TrustClientSubmittedSetting$Inherit) : ((raw === 'enabled') ? $elm$core$Maybe$Just($author$project$Domain$TrustClientSubmittedSetting$Enabled) : ((raw === 'disabled') ? $elm$core$Maybe$Just($author$project$Domain$TrustClientSubmittedSetting$Disabled) : $elm$core$Maybe$Nothing));
};
var $author$project$Domain$TrustClientSubmittedSetting$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Domain$TrustClientSubmittedSetting$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('looking for a TrustClientSubmittedSetting')))),
	$elm$json$Json$Decode$string);
var $author$project$Domain$ClientDebtorConfiguration$optionalTrustClientSubmittedSettingDefaultInherit = function (name) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, name, $author$project$Domain$TrustClientSubmittedSetting$decode),
				$elm$json$Json$Decode$succeed($author$project$Domain$TrustClientSubmittedSetting$Inherit)
			]));
};
var $author$project$Domain$ClientDebtorConfiguration$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (fields) {
		return A6(
			$elm$json$Json$Decode$map5,
			F5(
				function (invoiceAmountHistoryRuleMode, trustClientSubmittedInvoiceNumber, trustClientSubmittedLoadId, trustClientSubmittedDebtor, trustClientSubmittedAmount) {
					return _Utils_update(
						fields,
						{invoiceAmountHistoryRuleMode: invoiceAmountHistoryRuleMode, trustClientSubmittedAmount: trustClientSubmittedAmount, trustClientSubmittedDebtor: trustClientSubmittedDebtor, trustClientSubmittedInvoiceNumber: trustClientSubmittedInvoiceNumber, trustClientSubmittedLoadId: trustClientSubmittedLoadId});
				}),
			$author$project$Domain$ClientDebtorConfiguration$optionalInvoiceAmountHistoryCheckSettingDefaultInherit('invoiceAmountHistoryRuleMode'),
			$author$project$Domain$ClientDebtorConfiguration$optionalTrustClientSubmittedSettingDefaultInherit('trustClientSubmittedInvoiceNumber'),
			$author$project$Domain$ClientDebtorConfiguration$optionalTrustClientSubmittedSettingDefaultInherit('trustClientSubmittedLoadId'),
			$author$project$Domain$ClientDebtorConfiguration$optionalTrustClientSubmittedSettingDefaultInherit('trustClientSubmittedDebtor'),
			$author$project$Domain$ClientDebtorConfiguration$optionalTrustClientSubmittedSettingDefaultInherit('trustClientSubmittedAmount'));
	},
	A2(
		$elm$json$Json$Decode$andThen,
		function (firstFields) {
			return A9(
				$elm$json$Json$Decode$map8,
				F8(
					function (rateConRequired, bolRequired, podRequired, amountMatchRequirement, amountSource, alwaysBlock, laneRateExceptionsMode, factorDeliveryDateCheckDays) {
						return _Utils_update(
							firstFields,
							{alwaysBlock: alwaysBlock, amountMatchRequirement: amountMatchRequirement, amountSource: amountSource, bolRequired: bolRequired, factorDeliveryDateCheckDays: factorDeliveryDateCheckDays, laneRateExceptionsMode: laneRateExceptionsMode, podRequired: podRequired, rateConRequired: rateConRequired});
					}),
				$author$project$Domain$ClientDebtorConfiguration$optionalRequirementSettingDefaultInherit('rateConRequired'),
				$author$project$Domain$ClientDebtorConfiguration$optionalRequirementSettingDefaultInherit('bolRequired'),
				$author$project$Domain$ClientDebtorConfiguration$optionalRequirementSettingDefaultInherit('podRequired'),
				$author$project$Domain$ClientDebtorConfiguration$optionalAmountMatchRequirementDefaultInherit('amountMatchRequirement'),
				A2($author$project$Domain$ClientDebtorConfiguration$optionalStringDefault, 'amountSource', 'invoice'),
				$author$project$Domain$ClientDebtorConfiguration$optionalFlagDefaultFalse('alwaysBlock'),
				$author$project$Domain$ClientDebtorConfiguration$optionalLaneRateCheckSettingDefaultInherit('laneRateExceptionsMode'),
				$author$project$Domain$ClientDebtorConfiguration$optionalDeliveryDateCheckSettingDefaultInherit('factorDeliveryDateCheckDays'));
		},
		A6(
			$elm$json$Json$Decode$map5,
			F5(
				function (id, debtorId, debtorName, isClientLevel, notes) {
					return {alwaysBlock: false, amountMatchRequirement: $author$project$Domain$AmountMatchRequirement$Inherit, amountSource: 'invoice', bolRequired: $author$project$Domain$RequirementSetting$Inherit, debtorId: debtorId, debtorName: debtorName, factorDeliveryDateCheckDays: $author$project$Domain$DeliveryDateCheckSetting$Inherit, id: id, invoiceAmountHistoryRuleMode: $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit, isClientLevel: isClientLevel, laneRateExceptionsMode: $author$project$Domain$LaneRateCheckSetting$Inherit, notes: notes, podRequired: $author$project$Domain$RequirementSetting$Inherit, rateConRequired: $author$project$Domain$RequirementSetting$Inherit, trustClientSubmittedAmount: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedDebtor: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedInvoiceNumber: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedLoadId: $author$project$Domain$TrustClientSubmittedSetting$Inherit};
				}),
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'debtorId', $author$project$Domain$FactorBrokerId$decode)),
			A2($elm$json$Json$Decode$field, 'debtorName', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'isClientLevel', $elm$json$Json$Decode$bool),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'notes', $elm$json$Json$Decode$string)))));
var $author$project$Domain$ClientDebtorConfiguration$listDecoder = $elm$json$Json$Decode$list($author$project$Domain$ClientDebtorConfiguration$decoder);
var $author$project$Api$ClientDebtorConfigurations$list = function (carrierId) {
	return A2(
		$author$project$Helpers$Api$get,
		'/api/carriers/' + ($elm$core$String$fromInt(
			$author$project$Domain$TmsCarrierId$toInt(carrierId)) + '/client_debtor_configurations'),
		A2($elm$json$Json$Decode$field, 'clientDebtorConfigurations', $author$project$Domain$ClientDebtorConfiguration$listDecoder));
};
var $author$project$Components$ClientDebtorConfigurationManager$init = function (carrierId) {
	return _Utils_Tuple2(
		{alwaysBlock: false, amountMatchRequirement: $author$project$Domain$AmountMatchRequirement$Inherit, amountSource: 'invoice', bolRequired: $author$project$Domain$RequirementSetting$Inherit, carrierId: carrierId, configMode: $author$project$Components$ClientDebtorConfigurationManager$DebtorSpecific, configurations: _List_Nil, confirmDeleteConfigId: $elm$core$Maybe$Nothing, debtorTypeahead: $author$project$Components$DebtorTypeahead$init, deletingConfiguration: false, factorDeliveryDateCheckDays: $author$project$Domain$DeliveryDateCheckSetting$Inherit, formState: $author$project$Components$ClientDebtorConfigurationManager$Hidden, invoiceAmountHistoryRuleMode: $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit, isLoading: true, laneRateExceptionsMode: $author$project$Domain$LaneRateCheckSetting$Inherit, loadError: $elm$core$Maybe$Nothing, notes: $elm$core$Maybe$Nothing, podRequired: $author$project$Domain$RequirementSetting$Inherit, rateConRequired: $author$project$Domain$RequirementSetting$Inherit, savingConfiguration: false, trustClientSubmittedAmount: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedDebtor: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedInvoiceNumber: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedLoadId: $author$project$Domain$TrustClientSubmittedSetting$Inherit, updatingConfiguration: false},
		A2(
			$author$project$HubTran$Effect$sendCacheableRequest,
			$author$project$Components$ClientDebtorConfigurationManager$ConfigurationsLoaded,
			$author$project$Api$ClientDebtorConfigurations$list(carrierId)));
};
var $author$project$Components$SettingsPage$CarrierLayout$init = function (carrierId) {
	var _v0 = $author$project$Components$ClientDebtorConfigurationManager$init(carrierId);
	var clientDebtorConfigManager = _v0.a;
	var clientDebtorConfigManagerEffect = _v0.b;
	return _Utils_Tuple2(
		{carrierId: carrierId, clientDebtorConfigManager: clientDebtorConfigManager, contactForm: $elm$core$Maybe$Nothing, externalLoginForm: $elm$core$Maybe$Nothing, form: $elm$core$Maybe$Nothing, processingExternalLogin: $elm$core$Maybe$Nothing, showPortalWarning: false, testCredentialsResult: $author$project$Api$Carriers$ExternalLogins$NotTested, testingCredentials: false},
		A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$CarrierLayout$ClientDebtorConfigManagerMsg, clientDebtorConfigManagerEffect));
};
var $author$project$Components$SettingsPage$Carriers$Filters$init = {eligibleForAutoprocessing: false, page: 1, scraperOnly: false, selectedLabels: $elm$core$Set$empty, term: '', withLoginFailures: false};
var $author$project$Components$SettingsPage$CarriersLayout$init = _Utils_Tuple2(
	{filtersModel: $author$project$Components$SettingsPage$Carriers$Filters$init},
	$author$project$HubTran$Effect$none);
var $author$project$Components$SettingsPage$CustomerLayout$init = function (customerId) {
	return {customerId: customerId, formState_INTERNAL: $elm$core$Maybe$Nothing};
};
var $author$project$Components$SettingsPage$CustomersLayout$init = {page: 1, term: ''};
var $author$project$Components$SettingsPage$DebtorLayout$init = function (debtorId) {
	return _Utils_Tuple2(
		{debtorId: debtorId, formState: $elm$core$Maybe$Nothing},
		$author$project$HubTran$Effect$none);
};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$init = _Utils_Tuple2(
	{loadedModel: $elm$core$Maybe$Nothing},
	$author$project$HubTran$Effect$none);
var $author$project$Components$SettingsPage$ReportsLayout$UpdateCurrentDate = function (a) {
	return {$: 'UpdateCurrentDate', a: a};
};
var $elm$time$Time$here = _Time_here(_Utils_Tuple0);
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $author$project$Components$SettingsPage$ReportsLayout$init = _Utils_Tuple2(
	{currentDate: $elm$core$Maybe$Nothing, loadedModel: $elm$core$Maybe$Nothing},
	$author$project$HubTran$Effect$cmd(
		A2($elm$core$Task$perform, $author$project$Components$SettingsPage$ReportsLayout$UpdateCurrentDate, $justinmimbs$date$Date$today)));
var $author$project$Components$SettingsPage$RulesLayout$ConditionalExceptionsMsg = function (a) {
	return {$: 'ConditionalExceptionsMsg', a: a};
};
var $author$project$Components$SettingsPage$RulesLayout$CustomExceptionMessagesMsg = function (a) {
	return {$: 'CustomExceptionMessagesMsg', a: a};
};
var $author$project$Components$SettingsPage$RulesLayout$PodRequirementPolicyMsg = function (a) {
	return {$: 'PodRequirementPolicyMsg', a: a};
};
var $author$project$Components$SettingsPage$RulesLayout$ReferencesMsg = function (a) {
	return {$: 'ReferencesMsg', a: a};
};
var $author$project$Forward$FormWrapper$Initialize = function (a) {
	return {$: 'Initialize', a: a};
};
var $author$project$Forward$FormWrapper$Model = function (a) {
	return {$: 'Model', a: a};
};
var $author$project$Forward$FormWrapper$init = function (lookup) {
	return _Utils_Tuple2(
		$author$project$Forward$FormWrapper$Model(
			{child: $author$project$Forward$Remote$Loading}),
		A2($author$project$HubTran$Effect$fetchFromCache, $author$project$Forward$FormWrapper$Initialize, lookup));
};
var $author$project$Components$SettingsPage$ConditionalExceptions$Closed = {$: 'Closed'};
var $author$project$Components$SettingsPage$ConditionalExceptions$initWithRules = function (rules) {
	return {
		expandedRules: $elm$core$Set$empty,
		formState: $author$project$Components$SettingsPage$ConditionalExceptions$Closed,
		rules: rules,
		typeaheadStates: {open: $elm$core$Maybe$Nothing, queries: _List_Nil}
	};
};
var $author$project$Components$SettingsPage$RulesLayout$initConditionalRules = A2(
	$author$project$Forward$Lookup$map,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.conditionalExceptionRules;
		},
		$author$project$Components$SettingsPage$ConditionalExceptions$initWithRules),
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings);
var $author$project$Components$SettingsPage$RulesLayout$ReferencesInitialData = F2(
	function (rulesBrokerRequiredReferences, allReferenceFieldLabels) {
		return {allReferenceFieldLabels: allReferenceFieldLabels, rulesBrokerRequiredReferences: rulesBrokerRequiredReferences};
	});
var $author$project$Decode$Set$set = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Set$fromList,
		$elm$json$Json$Decode$list(decoder));
};
var $author$project$Forward$AppSpecific$Cache$set_string = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.set_string;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{set_string: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$allReferenceFieldLabels = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$set_string,
		decoder: $author$project$Decode$Set$set($elm$json$Json$Decode$string),
		entrypoint: 'allReferenceFieldLabels',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Domain$ReferenceRule$ReferenceRule = F2(
	function (reference, rule) {
		return {reference: reference, rule: rule};
	});
var $author$project$Domain$ReferenceRule$BeginsWith = function (a) {
	return {$: 'BeginsWith', a: a};
};
var $author$project$Domain$ReferenceRule$HasValue = function (a) {
	return {$: 'HasValue', a: a};
};
var $author$project$Domain$ReferenceRule$IsEmpty = {$: 'IsEmpty'};
var $author$project$Domain$ReferenceRule$IsPresent = {$: 'IsPresent'};
var $author$project$Domain$ReferenceRule$NotValue = function (a) {
	return {$: 'NotValue', a: a};
};
var $author$project$Domain$ReferenceRule$ruleFromPb = function (rule) {
	switch (rule.$) {
		case 'ReferenceRule_Rule_IsPresent':
			return $author$project$Domain$ReferenceRule$IsPresent;
		case 'ReferenceRule_Rule_IsEmpty':
			return $author$project$Domain$ReferenceRule$IsEmpty;
		case 'ReferenceRule_Rule_HasValue':
			var hasValue = rule.a;
			return $author$project$Domain$ReferenceRule$HasValue(hasValue.value);
		case 'ReferenceRule_Rule_BeginsWith':
			var beginsWith = rule.a;
			return $author$project$Domain$ReferenceRule$BeginsWith(beginsWith.value);
		default:
			var notValue = rule.a;
			return $author$project$Domain$ReferenceRule$NotValue(notValue.value);
	}
};
var $author$project$Domain$ReferenceRule$fromPb = function (referenceRule) {
	return A2(
		$author$project$Domain$ReferenceRule$ReferenceRule,
		referenceRule.reference,
		$author$project$Domain$ReferenceRule$ruleFromPb(referenceRule.rule));
};
var $author$project$Components$SettingsPage$RulesLayout$loadReferencesInitialData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$allReferenceFieldLabels,
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.rulesBrokerRequiredReferences;
				},
				$elm$core$List$map($author$project$Domain$ReferenceRule$fromPb)),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
		$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$RulesLayout$ReferencesInitialData)));
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$RulesWithAccountSettings = F2(
	function (customExceptionMessages, accountSettings) {
		return {accountSettings: accountSettings, customExceptionMessages: customExceptionMessages};
	});
var $author$project$Domain$CustomExceptionMessage$Billing = {$: 'Billing'};
var $author$project$Domain$CustomExceptionMessage$Both = {$: 'Both'};
var $author$project$Domain$CustomExceptionMessage$Payment = {$: 'Payment'};
var $author$project$Domain$CustomExceptionMessage$Unknown = {$: 'Unknown'};
var $author$project$Domain$CustomExceptionMessage$typesSelectionFromPb = function (typesSelection) {
	switch (typesSelection.$) {
		case 'CustomExceptionMessageTypesSelectionBoth':
			return $author$project$Domain$CustomExceptionMessage$Both;
		case 'CustomExceptionMessageTypesSelectionPayment':
			return $author$project$Domain$CustomExceptionMessage$Payment;
		case 'CustomExceptionMessageTypesSelectionBilling':
			return $author$project$Domain$CustomExceptionMessage$Billing;
		default:
			return $author$project$Domain$CustomExceptionMessage$Unknown;
	}
};
var $author$project$Domain$CustomExceptionMessage$fromPb = function (customExceptionMessage) {
	return {
		message: customExceptionMessage.message,
		typesSelection: $author$project$Domain$CustomExceptionMessage$typesSelectionFromPb(customExceptionMessage.typesSelection)
	};
};
var $author$project$Components$SettingsPage$RulesLayout$loadRulesWithAccountSettings = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.rulesBrokerCustomExceptionMessages;
				},
				$elm$core$List$map($author$project$Domain$CustomExceptionMessage$fromPb)),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
		$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$RulesWithAccountSettings)));
var $author$project$Components$SettingsPage$RulesLayout$init = function () {
	var _v0 = $author$project$Forward$FormWrapper$init($author$project$Components$SettingsPage$RulesLayout$loadReferencesInitialData);
	var references = _v0.a;
	var referencesEffect = _v0.b;
	var _v1 = $author$project$Forward$FormWrapper$init(
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.podRequirementPolicy;
			},
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings));
	var podRequirementPolicy = _v1.a;
	var podRequirementPolicyEffect = _v1.b;
	var _v2 = $author$project$Forward$FormWrapper$init($author$project$Components$SettingsPage$RulesLayout$loadRulesWithAccountSettings);
	var customExceptionMessages = _v2.a;
	var customExceptionMessagesEffect = _v2.b;
	var _v3 = $author$project$Forward$FormWrapper$init($author$project$Components$SettingsPage$RulesLayout$initConditionalRules);
	var conditionalRules = _v3.a;
	var conditionalRulesEffect = _v3.b;
	return _Utils_Tuple2(
		{conditionalRules: conditionalRules, customExceptionMessages: customExceptionMessages, podRequirementPolicy: podRequirementPolicy, references: references},
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$RulesLayout$ReferencesMsg, referencesEffect),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$RulesLayout$CustomExceptionMessagesMsg, customExceptionMessagesEffect),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$RulesLayout$PodRequirementPolicyMsg, podRequirementPolicyEffect),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$RulesLayout$ConditionalExceptionsMsg, conditionalRulesEffect)
				])));
}();
var $author$project$Components$SettingsPage$UserLayout$init = function (mode) {
	return _Utils_Tuple2(
		{isSaving: false, maybeUserForm: $elm$core$Maybe$Nothing, mode: mode},
		$author$project$HubTran$Effect$none);
};
var $author$project$Components$SettingsPage$UsersLayout$init = _Utils_Tuple2(
	{activePageNum: 0, activePerPage: 10, disabledPageNum: 0, disabledPerPage: 10, isSaving: false},
	$author$project$HubTran$Effect$none);
var $author$project$Components$SettingsPage$VerificationsLayout$Model = function (loginForms) {
	return {loginForms: loginForms};
};
var $author$project$Components$SettingsPage$VerificationsLayout$init = _Utils_Tuple2(
	$author$project$Components$SettingsPage$VerificationsLayout$Model($elm$core$Dict$empty),
	$author$project$HubTran$Effect$none);
var $author$project$Factoring$Page$ClientSubmission$InitialDataLoaded = function (a) {
	return {$: 'InitialDataLoaded', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$OutOfOrderError = function (a) {
	return {$: 'OutOfOrderError', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Processing = function (a) {
	return {$: 'Processing', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Review = {$: 'Review'};
var $author$project$Factoring$Page$ClientSubmission$startOnSubmission = F2(
	function (f, maybeInvoiceId) {
		if (maybeInvoiceId.$ === 'Nothing') {
			return $author$project$Factoring$Page$ClientSubmission$Review;
		} else {
			var invoiceId = maybeInvoiceId.a;
			return f(invoiceId);
		}
	});
var $author$project$Factoring$Page$ClientSubmission$decidePage = F5(
	function (maybeRequestedGroup, maybeRequestedInvoiceId, maybeCalculatedGroup, maybeCalculatedInvoiceId, maybeDocumentBatch) {
		var _v0 = _Utils_Tuple3(maybeRequestedGroup, maybeCalculatedInvoiceId, maybeCalculatedGroup);
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $author$project$Factoring$Page$ClientSubmission$Review;
			} else {
				var _v3 = _v0.a;
				var invoiceId = _v0.b.a;
				return $author$project$Factoring$Page$ClientSubmission$Processing(invoiceId);
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v4 = _v0.b;
				return A2($author$project$Factoring$Page$ClientSubmission$startOnSubmission, $author$project$Factoring$Page$ClientSubmission$Processing, maybeRequestedInvoiceId);
			} else {
				if (_v0.c.$ === 'Just') {
					var requestedGroup = _v0.a.a;
					var nextInvoiceId = _v0.b.a;
					var nextCalculatedGroup = _v0.c.a;
					var mismatchMode = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.groupMismatch;
							},
							maybeDocumentBatch));
					return ((_Utils_cmp(requestedGroup, nextCalculatedGroup) < 1) || mismatchMode) ? A2($author$project$Factoring$Page$ClientSubmission$startOnSubmission, $author$project$Factoring$Page$ClientSubmission$Processing, maybeRequestedInvoiceId) : $author$project$Factoring$Page$ClientSubmission$OutOfOrderError(nextInvoiceId);
				} else {
					var nextInvoiceId = _v0.b.a;
					var _v5 = _v0.c;
					return $author$project$Factoring$Page$ClientSubmission$Processing(nextInvoiceId);
				}
			}
		}
	});
var $author$project$Domain$FactorInvoiceId$decode = $author$project$Id$decoder;
var $author$project$Forward$Lookup$traverseMaybe = A2(
	$author$project$Forward$Lookup$traverseHelper,
	'traverseMaybe',
	{containerOfLoadablesToLoadableContainer: $author$project$Forward$Internal$Loadable$maybeLoadableToLoadableMaybe, map: $elm$core$Maybe$map});
var $author$project$Forward$Lookup$defineReferenceMaybe = function (config) {
	return A2(
		$author$project$Forward$Lookup$traverseMaybe,
		config.objectEntrypoint,
		$author$project$Forward$Lookup$defineNode(
			{
				cacheKey: config.cacheKey,
				decoder: $elm$json$Json$Decode$maybe(config.decoder),
				entrypoint: config.entrypoint,
				parameters: config.parameters
			}));
};
var $author$project$Domain$FactorInvoice$FactorInvoice = function (id) {
	return function (tmsCarrierId) {
		return function (factorBrokerId) {
			return function (factorInvoiceSubmissionId) {
				return function (loadId) {
					return function (invoiceNumber) {
						return function (amount) {
							return function (formattedAmount) {
								return function (receivedAt) {
									return function (createdAt) {
										return function (updatedAt) {
											return function (invoiceDate) {
												return function (processedAt) {
													return function (failureMessages) {
														return function (ignoredRules) {
															return function (clientOrDebtorOnBol) {
																return function (clientOnRateCon) {
																	return function (amountMatchesRateCon) {
																		return function (thirdPartyListedOnBol) {
																			return function (pickupDropoffMatches) {
																				return function (loadIdPatternMismatch) {
																					return function (tonu) {
																						return function (state) {
																							return function (labels) {
																								return function (transmissionId) {
																									return function (transmissionState) {
																										return function (submissionReviewedAt) {
																											return function (activityItems) {
																												return function (documentIds) {
																													return function (paymentsNetworkExternalLoadId) {
																														return function (clientDebtorNoaRelationship) {
																															return function (documentBatchEmailDetails) {
																																return function (mustVerify) {
																																	return function (fuelAdvance) {
																																		return function (origin) {
																																			return function (destination) {
																																				return function (notes) {
																																					return function (carrierAmount) {
																																						return function (status) {
																																							return {activityItems: activityItems, amount: amount, amountMatchesRateCon: amountMatchesRateCon, carrierAmount: carrierAmount, clientDebtorNoaRelationship: clientDebtorNoaRelationship, clientOnRateCon: clientOnRateCon, clientOrDebtorOnBol: clientOrDebtorOnBol, createdAt: createdAt, destination: destination, documentBatchEmailDetails: documentBatchEmailDetails, documentIds: documentIds, factorBrokerId: factorBrokerId, factorInvoiceSubmissionId: factorInvoiceSubmissionId, failureMessages: failureMessages, formattedAmount: formattedAmount, fuelAdvance: fuelAdvance, id: id, ignoredRules: ignoredRules, invoiceDate: invoiceDate, invoiceNumber: invoiceNumber, labels: labels, loadId: loadId, loadIdPatternMismatch: loadIdPatternMismatch, mustVerify: mustVerify, notes: notes, origin: origin, paymentsNetworkExternalLoadId: paymentsNetworkExternalLoadId, pickupDropoffMatches: pickupDropoffMatches, processedAt: processedAt, receivedAt: receivedAt, state: state, status: status, submissionReviewedAt: submissionReviewedAt, thirdPartyListedOnBol: thirdPartyListedOnBol, tmsCarrierId: tmsCarrierId, tonu: tonu, transmissionId: transmissionId, transmissionState: transmissionState, updatedAt: updatedAt};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Domain$FactorInvoice$ClientDebtorNoaRelationship = F3(
	function (status, title, description) {
		return {description: description, status: status, title: title};
	});
var $author$project$Domain$FactorInvoice$Error = {$: 'Error'};
var $author$project$Domain$FactorInvoice$Info = {$: 'Info'};
var $author$project$Domain$FactorInvoice$Success = {$: 'Success'};
var $author$project$Domain$FactorInvoice$Warning = {$: 'Warning'};
var $author$project$Domain$FactorInvoice$clientDebtorNoaRelationshipStatusFromString = function (string) {
	switch (string) {
		case 'success':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Success);
		case 'warning':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Warning);
		case 'info':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Info);
		case 'error':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Error);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Domain$FactorInvoice$clientdebtorNoaRelationship = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Domain$FactorInvoice$ClientDebtorNoaRelationship,
	A2(
		$elm$json$Json$Decode$field,
		'status',
		A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoice$clientDebtorNoaRelationshipStatusFromString, $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string)));
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.problem;
	if (problem.$ === 'Problem') {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 'MonthAndDay', a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 'OrdinalDay', a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 'WeekAndWeekday', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0.a;
	return $elm$parser$Parser$Advanced$Parser(
		function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 'Bad') {
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, false, x);
			} else {
				var a = _v1.b;
				var s1 = _v1.c;
				return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
			}
		});
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, true, a, s);
		});
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(_Utils_Tuple0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeYear(y) + A2(
					$justinmimbs$date$Date$daysBeforeMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + d)) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				$justinmimbs$date$Date$daysBeforeYear(y) + od)) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$RD(
		$justinmimbs$date$Date$daysBeforeYear(y) + 1);
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn)) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 'MonthAndDay':
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 'WeekAndWeekday':
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(_Utils_Tuple0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return _Utils_eq(
											c,
											_Utils_chr('-'));
									}),
									$elm$parser$Parser$succeed(_Utils_Tuple0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (result.$ === 'Ok') {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq(
										_Utils_chr('T')))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$Helpers$Json$Decode$date = A2(
	$elm$json$Json$Decode$andThen,
	function (raw) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(raw);
		if (_v0.$ === 'Ok') {
			var value = _v0.a;
			return $elm$json$Json$Decode$succeed(value);
		} else {
			var reason = _v0.a;
			return $elm$json$Json$Decode$fail(reason);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Domain$ActivityItem$ActivityItem = F8(
	function (id, accountId, userName, ownerId, createdAt, updatedAt, details, automatedDisplayName) {
		return {accountId: accountId, automatedDisplayName: automatedDisplayName, createdAt: createdAt, details: details, id: id, ownerId: ownerId, updatedAt: updatedAt, userName: userName};
	});
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeApproval = {$: 'ActivityItemAccountsPayableActivityTypeApproval'};
var $author$project$AuditPb$activityItemAccountsPayableActivityTypeDefault = $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeApproval;
var $author$project$AuditPb$activityItemAccountsPayableActivityTypeToString = function (v) {
	switch (v.$) {
		case 'ActivityItemAccountsPayableActivityTypeApproval':
			return 'approval';
		case 'ActivityItemAccountsPayableActivityTypeCarrierPayableApproval':
			return 'carrier_payable_approval';
		case 'ActivityItemAccountsPayableActivityTypeStateChange':
			return 'state_change';
		case 'ActivityItemAccountsPayableActivityTypeNote':
			return 'note';
		case 'ActivityItemAccountsPayableActivityTypeDocumentAdded':
			return 'document_added';
		case 'ActivityItemAccountsPayableActivityTypeDocumentRemoved':
			return 'document_removed';
		case 'ActivityItemAccountsPayableActivityTypeDocumentsResendRequested':
			return 'documents_resend_requested';
		case 'ActivityItemAccountsPayableActivityTypeDocumentAssigned':
			return 'document_assigned';
		case 'ActivityItemAccountsPayableActivityTypeExternalCreation':
			return 'external_creation';
		case 'ActivityItemAccountsPayableActivityTypeSentToExternal':
			return 'sent_to_external';
		case 'ActivityItemAccountsPayableActivityTypePause':
			return 'pause';
		case 'ActivityItemAccountsPayableActivityTypeProcessed':
			return 'processed';
		case 'ActivityItemAccountsPayableActivityTypeAutoProcessed':
			return 'auto_processed';
		case 'ActivityItemAccountsPayableActivityTypeException':
			return 'exception';
		case 'ActivityItemAccountsPayableActivityTypeInvoiceAbandoned':
			return 'invoice_abandoned';
		case 'ActivityItemAccountsPayableActivityTypeInvoiceUnapproved':
			return 'invoice_unapproved';
		case 'ActivityItemAccountsPayableActivityTypeInvoiceRevived':
			return 'invoice_revived';
		case 'ActivityItemAccountsPayableActivityTypeRuleDisabled':
			return 'rule_disabled';
		case 'ActivityItemAccountsPayableActivityTypeRuleEnabled':
			return 'rule_enabled';
		case 'ActivityItemAccountsPayableActivityTypeExceptionResolved':
			return 'exception_resolved';
		case 'ActivityItemAccountsPayableActivityTypePaymentAddressChanged':
			return 'payment_address_changed';
		case 'ActivityItemAccountsPayableActivityTypeFactoringAssignment':
			return 'factoring_assignment';
		case 'ActivityItemAccountsPayableActivityTypeIgnore':
			return 'ignore';
		case 'ActivityItemAccountsPayableActivityTypeInvoiceMatched':
			return 'invoice_matched';
		case 'ActivityItemAccountsPayableActivityTypeRemovedFromGroup':
			return 'removed_from_group';
		case 'ActivityItemAccountsPayableActivityTypeTransmissionFailed':
			return 'transmission_failed';
		case 'ActivityItemAccountsPayableActivityTypeInvoiceRejected':
			return 'invoice_rejected';
		case 'ActivityItemAccountsPayableActivityTypeSentToCadence':
			return 'sent_to_cadence';
		case 'ActivityItemAccountsPayableActivityTypeVerifyCompleted':
			return 'verify_completed';
		case 'ActivityItemAccountsPayableActivityTypeVerifiedByCadence':
			return 'verified_by_cadence';
		case 'ActivityItemAccountsPayableActivityTypeForwardedEmail':
			return 'forwarded_email';
		case 'ActivityItemAccountsPayableActivityTypeDocSentToExternal':
			return 'doc_sent_to_external';
		case 'ActivityItemAccountsPayableActivityTypeEmailMergeTarget':
			return 'email_merge_target';
		case 'ActivityItemAccountsPayableActivityTypeEmailMergeSource':
			return 'email_merge_source';
		case 'ActivityItemAccountsPayableActivityTypeEmailIgnored':
			return 'email_ignored';
		case 'ActivityItemAccountsPayableActivityTypeEmailUnignored':
			return 'email_unignored';
		case 'ActivityItemAccountsPayableActivityTypeEmailCompleted':
			return 'email_completed';
		case 'ActivityItemAccountsPayableActivityTypeContactAdded':
			return 'contact_added';
		case 'ActivityItemAccountsPayableActivityTypeExceptionsClearedViaAPI':
			return 'exceptions_cleared_via_api';
		case 'ActivityItemAccountsPayableActivityTypeUpdatedFromExternal':
			return 'updated_from_external';
		case 'ActivityItemAccountsPayableActivityTypeAcertusShipmentApproved':
			return 'acertus_shipment_approved';
		case 'ActivityItemAccountsPayableActivityTypeAcertusShipmentRejected':
			return 'acertus_shipment_rejected';
		case 'ActivityItemAccountsPayableActivityTypeMarkedPurchasedByUser':
			return 'marked_purchased_by_user';
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsApproved':
			return 'load_documents_approved';
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsScraped':
			return 'load_documents_scraped';
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsAssigned':
			return 'load_documents_assigned';
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsSent':
			return 'load_documents_sent';
		case 'ActivityItemAccountsPayableActivityTypeBuiltLoadSentToTMS':
			return 'built_load_sent_to_tms';
		case 'ActivityItemAccountsPayableActivityTypeBuiltLoadConfirmed':
			return 'built_load_confirmed';
		case 'ActivityItemAccountsPayableActivityTypePODRequestSentToTextLocate':
			return 'pod_request_sent_to_text_locate';
		case 'ActivityItemAccountsPayableActivityTypeSentToVerifyQueue':
			return 'sent_to_verify_queue';
		case 'ActivityItemAccountsPayableActivityTypeBypassedVerifyQueue':
			return 'bypassed_verify_queue';
		case 'ActivityItemAccountsPayableActivityTypeVerifierChangedInvoiceAmount':
			return 'verifier_changed_invoice_amount';
		case 'ActivityItemAccountsPayableActivityTypeMarkedNotReadyForVerification':
			return 'marked_not_ready_for_verification';
		case 'ActivityItemAccountsPayableActivityTypeSendNoteToPayeeViaPaymentsNetwork':
			return 'send_note_to_payee_via_payments_network';
		case 'ActivityItemAccountsPayableActivityTypeDocsSentOnException':
			return 'docs_sent_on_exception';
		case 'ActivityItemAccountsPayableActivityTypeInvoiceDocumentsForwardedToTriumph':
			return 'invoice_documents_forwarded_to_triumph';
		case 'ActivityItemAccountsPayableActivityTypeReceivedInvoice':
			return 'received_invoice';
		case 'ActivityItemAccountsPayableActivityTypeTransmissionReceived':
			return 'transmission_received';
		case 'ActivityItemAccountsPayableActivityTypeTransmissionSucceeded':
			return 'transmission_succeeded';
		case 'ActivityItemAccountsPayableActivityTypeLoadShipmentApproval':
			return 'load_shipment_approval';
		case 'ActivityItemAccountsPayableActivityTypeLoadShipmentUnapproval':
			return 'load_shipment_unapproval';
		case 'ActivityItemAccountsPayableActivityTypeClientOrDebtorOnBolChanged':
			return 'client_or_debtor_on_bol_changed';
		case 'ActivityItemAccountsPayableActivityTypeInvoiceExceptionEmailSent':
			return 'invoice_exception_email_sent';
		case 'ActivityItemAccountsPayableActivityTypeLtlDisputeAdded':
			return 'ltl_dispute_added';
		case 'ActivityItemAccountsPayableActivityTypeLtlAcceptAdded':
			return 'ltl_accept_added';
		case 'ActivityItemAccountsPayableActivityTypeLtlMovedToTMSQueue':
			return 'ltl_moved_to_tms_queue';
		case 'ActivityItemAccountsPayableActivityTypeLtlUpdatedEdiReceived':
			return 'ltl_updated_edi_received';
		case 'ActivityItemAccountsPayableActivityTypeHidden':
			return 'hidden';
		case 'ActivityItemAccountsPayableActivityTypeAddDocumentToLoadSuccess':
			return 'add_document_to_load_success';
		case 'ActivityItemAccountsPayableActivityTypeAddDocumentToLoadFailure':
			return 'add_document_to_load_failure';
		case 'ActivityItemAccountsPayableActivityTypeFlaggedForManualReview':
			return 'flagged_for_manual_review';
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateRequested':
			return 'ltl_rerate_requested';
		case 'ActivityItemAccountsPayableActivityTypeCarrierInvoiceRuleChangedViaTMS':
			return 'carrier_invoice_rule_changed_via_tms';
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateFailed':
			return 'ltl_rerate_failed';
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateCompleted':
			return 'ltl_rerate_completed';
		case 'ActivityItemAccountsPayableActivityTypeDocumentsMerged':
			return 'documents_merged';
		case 'ActivityItemAccountsPayableActivityTypeIndexingComplete':
			return 'indexing_complete';
		case 'ActivityItemAccountsPayableActivityTypeEmailZeroPages':
			return 'email_zero_pages';
		case 'ActivityItemAccountsPayableActivityTypeReadyForFMSPickup':
			return 'ready_for_fms_pickup';
		case 'ActivityItemAccountsPayableActivityTypeAcknowledgedByFMS':
			return 'acknowledged_by_fms';
		case 'ActivityItemAccountsPayableActivityTypeNonInvoiceLoadAssignment':
			return 'non_invoice_load_assignment';
		case 'ActivityItemAccountsPayableActivityTypeDuplicateEmailAutoCompleted':
			return 'duplicate_email_auto_completed';
		case 'ActivityItemAccountsPayableActivityTypeAutoCompletedWaitingExceptionsOnNewDocs':
			return 'auto_completed_waiting_exceptions_on_new_docs';
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentBatchAutoCompleted':
			return 'duplicate_document_batch_auto_completed';
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoHidden':
			return 'duplicate_document_auto_hidden';
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoMerged':
			return 'duplicate_document_auto_merged';
		case 'ActivityItemAccountsPayableActivityTypeLineItemsAutoReplaced':
			return 'line_items_auto_replaced';
		case 'ActivityItemAccountsPayableActivityTypeDebtorCorrected':
			return 'debtor_corrected';
		default:
			return 'verification_batch_started';
	}
};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAcertusShipmentApproved = {$: 'ActivityItemAccountsPayableActivityTypeAcertusShipmentApproved'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAcertusShipmentRejected = {$: 'ActivityItemAccountsPayableActivityTypeAcertusShipmentRejected'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAcknowledgedByFMS = {$: 'ActivityItemAccountsPayableActivityTypeAcknowledgedByFMS'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAddDocumentToLoadFailure = {$: 'ActivityItemAccountsPayableActivityTypeAddDocumentToLoadFailure'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAddDocumentToLoadSuccess = {$: 'ActivityItemAccountsPayableActivityTypeAddDocumentToLoadSuccess'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAutoCompletedWaitingExceptionsOnNewDocs = {$: 'ActivityItemAccountsPayableActivityTypeAutoCompletedWaitingExceptionsOnNewDocs'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAutoProcessed = {$: 'ActivityItemAccountsPayableActivityTypeAutoProcessed'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeBuiltLoadConfirmed = {$: 'ActivityItemAccountsPayableActivityTypeBuiltLoadConfirmed'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeBuiltLoadSentToTMS = {$: 'ActivityItemAccountsPayableActivityTypeBuiltLoadSentToTMS'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeBypassedVerifyQueue = {$: 'ActivityItemAccountsPayableActivityTypeBypassedVerifyQueue'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeCarrierInvoiceRuleChangedViaTMS = {$: 'ActivityItemAccountsPayableActivityTypeCarrierInvoiceRuleChangedViaTMS'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeCarrierPayableApproval = {$: 'ActivityItemAccountsPayableActivityTypeCarrierPayableApproval'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeClientOrDebtorOnBolChanged = {$: 'ActivityItemAccountsPayableActivityTypeClientOrDebtorOnBolChanged'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeContactAdded = {$: 'ActivityItemAccountsPayableActivityTypeContactAdded'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDebtorCorrected = {$: 'ActivityItemAccountsPayableActivityTypeDebtorCorrected'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocSentToExternal = {$: 'ActivityItemAccountsPayableActivityTypeDocSentToExternal'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocsSentOnException = {$: 'ActivityItemAccountsPayableActivityTypeDocsSentOnException'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentAdded = {$: 'ActivityItemAccountsPayableActivityTypeDocumentAdded'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentAssigned = {$: 'ActivityItemAccountsPayableActivityTypeDocumentAssigned'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentRemoved = {$: 'ActivityItemAccountsPayableActivityTypeDocumentRemoved'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentsMerged = {$: 'ActivityItemAccountsPayableActivityTypeDocumentsMerged'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentsResendRequested = {$: 'ActivityItemAccountsPayableActivityTypeDocumentsResendRequested'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoHidden = {$: 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoHidden'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoMerged = {$: 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoMerged'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDuplicateDocumentBatchAutoCompleted = {$: 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentBatchAutoCompleted'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDuplicateEmailAutoCompleted = {$: 'ActivityItemAccountsPayableActivityTypeDuplicateEmailAutoCompleted'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailCompleted = {$: 'ActivityItemAccountsPayableActivityTypeEmailCompleted'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailIgnored = {$: 'ActivityItemAccountsPayableActivityTypeEmailIgnored'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailMergeSource = {$: 'ActivityItemAccountsPayableActivityTypeEmailMergeSource'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailMergeTarget = {$: 'ActivityItemAccountsPayableActivityTypeEmailMergeTarget'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailUnignored = {$: 'ActivityItemAccountsPayableActivityTypeEmailUnignored'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailZeroPages = {$: 'ActivityItemAccountsPayableActivityTypeEmailZeroPages'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeException = {$: 'ActivityItemAccountsPayableActivityTypeException'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeExceptionResolved = {$: 'ActivityItemAccountsPayableActivityTypeExceptionResolved'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeExceptionsClearedViaAPI = {$: 'ActivityItemAccountsPayableActivityTypeExceptionsClearedViaAPI'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeExternalCreation = {$: 'ActivityItemAccountsPayableActivityTypeExternalCreation'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeFactoringAssignment = {$: 'ActivityItemAccountsPayableActivityTypeFactoringAssignment'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeFlaggedForManualReview = {$: 'ActivityItemAccountsPayableActivityTypeFlaggedForManualReview'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeForwardedEmail = {$: 'ActivityItemAccountsPayableActivityTypeForwardedEmail'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeHidden = {$: 'ActivityItemAccountsPayableActivityTypeHidden'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeIgnore = {$: 'ActivityItemAccountsPayableActivityTypeIgnore'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeIndexingComplete = {$: 'ActivityItemAccountsPayableActivityTypeIndexingComplete'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceAbandoned = {$: 'ActivityItemAccountsPayableActivityTypeInvoiceAbandoned'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceDocumentsForwardedToTriumph = {$: 'ActivityItemAccountsPayableActivityTypeInvoiceDocumentsForwardedToTriumph'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceExceptionEmailSent = {$: 'ActivityItemAccountsPayableActivityTypeInvoiceExceptionEmailSent'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceMatched = {$: 'ActivityItemAccountsPayableActivityTypeInvoiceMatched'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceRejected = {$: 'ActivityItemAccountsPayableActivityTypeInvoiceRejected'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceRevived = {$: 'ActivityItemAccountsPayableActivityTypeInvoiceRevived'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceUnapproved = {$: 'ActivityItemAccountsPayableActivityTypeInvoiceUnapproved'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLineItemsAutoReplaced = {$: 'ActivityItemAccountsPayableActivityTypeLineItemsAutoReplaced'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsApproved = {$: 'ActivityItemAccountsPayableActivityTypeLoadDocumentsApproved'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsAssigned = {$: 'ActivityItemAccountsPayableActivityTypeLoadDocumentsAssigned'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsScraped = {$: 'ActivityItemAccountsPayableActivityTypeLoadDocumentsScraped'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsSent = {$: 'ActivityItemAccountsPayableActivityTypeLoadDocumentsSent'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadShipmentApproval = {$: 'ActivityItemAccountsPayableActivityTypeLoadShipmentApproval'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadShipmentUnapproval = {$: 'ActivityItemAccountsPayableActivityTypeLoadShipmentUnapproval'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlAcceptAdded = {$: 'ActivityItemAccountsPayableActivityTypeLtlAcceptAdded'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlDisputeAdded = {$: 'ActivityItemAccountsPayableActivityTypeLtlDisputeAdded'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlMovedToTMSQueue = {$: 'ActivityItemAccountsPayableActivityTypeLtlMovedToTMSQueue'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlRerateCompleted = {$: 'ActivityItemAccountsPayableActivityTypeLtlRerateCompleted'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlRerateFailed = {$: 'ActivityItemAccountsPayableActivityTypeLtlRerateFailed'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlRerateRequested = {$: 'ActivityItemAccountsPayableActivityTypeLtlRerateRequested'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlUpdatedEdiReceived = {$: 'ActivityItemAccountsPayableActivityTypeLtlUpdatedEdiReceived'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeMarkedNotReadyForVerification = {$: 'ActivityItemAccountsPayableActivityTypeMarkedNotReadyForVerification'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeMarkedPurchasedByUser = {$: 'ActivityItemAccountsPayableActivityTypeMarkedPurchasedByUser'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeNonInvoiceLoadAssignment = {$: 'ActivityItemAccountsPayableActivityTypeNonInvoiceLoadAssignment'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeNote = {$: 'ActivityItemAccountsPayableActivityTypeNote'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypePODRequestSentToTextLocate = {$: 'ActivityItemAccountsPayableActivityTypePODRequestSentToTextLocate'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypePause = {$: 'ActivityItemAccountsPayableActivityTypePause'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypePaymentAddressChanged = {$: 'ActivityItemAccountsPayableActivityTypePaymentAddressChanged'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeProcessed = {$: 'ActivityItemAccountsPayableActivityTypeProcessed'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeReadyForFMSPickup = {$: 'ActivityItemAccountsPayableActivityTypeReadyForFMSPickup'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeReceivedInvoice = {$: 'ActivityItemAccountsPayableActivityTypeReceivedInvoice'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeRemovedFromGroup = {$: 'ActivityItemAccountsPayableActivityTypeRemovedFromGroup'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeRuleDisabled = {$: 'ActivityItemAccountsPayableActivityTypeRuleDisabled'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeRuleEnabled = {$: 'ActivityItemAccountsPayableActivityTypeRuleEnabled'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeSendNoteToPayeeViaPaymentsNetwork = {$: 'ActivityItemAccountsPayableActivityTypeSendNoteToPayeeViaPaymentsNetwork'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeSentToCadence = {$: 'ActivityItemAccountsPayableActivityTypeSentToCadence'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeSentToExternal = {$: 'ActivityItemAccountsPayableActivityTypeSentToExternal'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeSentToVerifyQueue = {$: 'ActivityItemAccountsPayableActivityTypeSentToVerifyQueue'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeStateChange = {$: 'ActivityItemAccountsPayableActivityTypeStateChange'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeTransmissionFailed = {$: 'ActivityItemAccountsPayableActivityTypeTransmissionFailed'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeTransmissionReceived = {$: 'ActivityItemAccountsPayableActivityTypeTransmissionReceived'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeTransmissionSucceeded = {$: 'ActivityItemAccountsPayableActivityTypeTransmissionSucceeded'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeUpdatedFromExternal = {$: 'ActivityItemAccountsPayableActivityTypeUpdatedFromExternal'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeVerificationBatchStarted = {$: 'ActivityItemAccountsPayableActivityTypeVerificationBatchStarted'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeVerifiedByCadence = {$: 'ActivityItemAccountsPayableActivityTypeVerifiedByCadence'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeVerifierChangedInvoiceAmount = {$: 'ActivityItemAccountsPayableActivityTypeVerifierChangedInvoiceAmount'};
var $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeVerifyCompleted = {$: 'ActivityItemAccountsPayableActivityTypeVerifyCompleted'};
var $author$project$AuditPb$allActivityItemAccountsPayableActivityType = _List_fromArray(
	[$author$project$AuditPb$ActivityItemAccountsPayableActivityTypeApproval, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeCarrierPayableApproval, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeStateChange, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeNote, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentAdded, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentRemoved, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentsResendRequested, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentAssigned, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeExternalCreation, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeSentToExternal, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypePause, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeProcessed, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAutoProcessed, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeException, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceAbandoned, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceUnapproved, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceRevived, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeRuleDisabled, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeRuleEnabled, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeExceptionResolved, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypePaymentAddressChanged, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeFactoringAssignment, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeIgnore, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceMatched, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeRemovedFromGroup, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeTransmissionFailed, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceRejected, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeSentToCadence, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeVerifyCompleted, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeVerifiedByCadence, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeForwardedEmail, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocSentToExternal, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailMergeTarget, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailMergeSource, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailIgnored, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailUnignored, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailCompleted, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeContactAdded, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeExceptionsClearedViaAPI, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeUpdatedFromExternal, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAcertusShipmentApproved, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAcertusShipmentRejected, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeMarkedPurchasedByUser, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsApproved, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsScraped, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsAssigned, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsSent, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeBuiltLoadSentToTMS, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeBuiltLoadConfirmed, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypePODRequestSentToTextLocate, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeSentToVerifyQueue, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeBypassedVerifyQueue, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeVerifierChangedInvoiceAmount, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeMarkedNotReadyForVerification, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeSendNoteToPayeeViaPaymentsNetwork, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocsSentOnException, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceDocumentsForwardedToTriumph, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeReceivedInvoice, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeTransmissionReceived, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeTransmissionSucceeded, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadShipmentApproval, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadShipmentUnapproval, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeClientOrDebtorOnBolChanged, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeInvoiceExceptionEmailSent, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlDisputeAdded, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlAcceptAdded, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlMovedToTMSQueue, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlUpdatedEdiReceived, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeHidden, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAddDocumentToLoadSuccess, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAddDocumentToLoadFailure, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeFlaggedForManualReview, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlRerateRequested, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeCarrierInvoiceRuleChangedViaTMS, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlRerateFailed, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLtlRerateCompleted, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDocumentsMerged, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeIndexingComplete, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeEmailZeroPages, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeReadyForFMSPickup, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAcknowledgedByFMS, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeNonInvoiceLoadAssignment, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDuplicateEmailAutoCompleted, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeAutoCompletedWaitingExceptionsOnNewDocs, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDuplicateDocumentBatchAutoCompleted, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoHidden, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoMerged, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLineItemsAutoReplaced, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeDebtorCorrected, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeVerificationBatchStarted]);
var $author$project$AuditPb$activityItemAccountsPayableActivityTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$activityItemAccountsPayableActivityTypeToString(v),
				v);
		},
		$author$project$AuditPb$allActivityItemAccountsPayableActivityType));
var $author$project$AuditPb$activityItemAccountsPayableActivityTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$activityItemAccountsPayableActivityTypeDict);
};
var $author$project$AuditPb$activityItemAccountsPayableActivityTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$activityItemAccountsPayableActivityTypeDefault),
		$author$project$AuditPb$activityItemAccountsPayableActivityTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$Domain$ActivityItemId$ActivityItemId = function (a) {
	return {$: 'ActivityItemId', a: a};
};
var $author$project$Domain$ActivityItemId$fromInt = function (_int) {
	return $author$project$Domain$ActivityItemId$ActivityItemId(_int);
};
var $author$project$Domain$ActivityItemId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$ActivityItemId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$ActivityItem$defaultTo = F2(
	function (_default, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					decoder,
					$elm$json$Json$Decode$succeed(_default)
				]));
	});
var $author$project$Domain$ActivityItem$AbandonedDetails = function (reason) {
	return {reason: reason};
};
var $author$project$Domain$ActivityItem$AcknowledgedByFms = {$: 'AcknowledgedByFms'};
var $author$project$Domain$ActivityItem$AddDocumentToLoadFailure = function (a) {
	return {$: 'AddDocumentToLoadFailure', a: a};
};
var $author$project$Domain$ActivityItem$AddDocumentToLoadSuccess = function (a) {
	return {$: 'AddDocumentToLoadSuccess', a: a};
};
var $author$project$Domain$ActivityItem$AutoCompletedWaitingExceptionsOnNewDocs = {$: 'AutoCompletedWaitingExceptionsOnNewDocs'};
var $author$project$Domain$ActivityItem$BuiltLoadConfirmed = {$: 'BuiltLoadConfirmed'};
var $author$project$Domain$ActivityItem$BuiltLoadSentToTMS = {$: 'BuiltLoadSentToTMS'};
var $author$project$Domain$ActivityItem$BypassedVerifyQueue = {$: 'BypassedVerifyQueue'};
var $author$project$Domain$ActivityItem$CarrierInvoiceRuleChangedViaTms = {$: 'CarrierInvoiceRuleChangedViaTms'};
var $author$project$Domain$ActivityItem$ClientOrDebtorOnBolChanged = function (a) {
	return {$: 'ClientOrDebtorOnBolChanged', a: a};
};
var $author$project$Domain$ActivityItem$ClientOrDebtorOnBolChangedDetails = function (to) {
	return {to: to};
};
var $author$project$Domain$ActivityItem$ContactAdded = function (a) {
	return {$: 'ContactAdded', a: a};
};
var $author$project$Domain$ActivityItem$ContactAddedDetails = F3(
	function (carrierName, contactName, contactEmail) {
		return {carrierName: carrierName, contactEmail: contactEmail, contactName: contactName};
	});
var $author$project$Domain$ActivityItem$DebtorCorrected = function (a) {
	return {$: 'DebtorCorrected', a: a};
};
var $author$project$Domain$ActivityItem$DebtorCorrectedDetails = F3(
	function (previousDebtorName, correctedDebtorName, notes) {
		return {correctedDebtorName: correctedDebtorName, notes: notes, previousDebtorName: previousDebtorName};
	});
var $author$project$Domain$ActivityItem$DocumentAdded = function (a) {
	return {$: 'DocumentAdded', a: a};
};
var $author$project$Domain$ActivityItem$DocumentAddedDetails = F3(
	function (documentType, documentTypeName, original) {
		return {documentType: documentType, documentTypeName: documentTypeName, original: original};
	});
var $author$project$Domain$ActivityItem$DocumentAssigned = {$: 'DocumentAssigned'};
var $author$project$Domain$ActivityItem$DocumentBatchIgnored = function (a) {
	return {$: 'DocumentBatchIgnored', a: a};
};
var $author$project$Domain$ActivityItem$DocumentBatchIgnoredDetails = function (reason) {
	return {reason: reason};
};
var $author$project$Domain$ActivityItem$DocumentRemoved = function (a) {
	return {$: 'DocumentRemoved', a: a};
};
var $author$project$Domain$ActivityItem$DocumentRemovedDetails = F3(
	function (documentType, documentTypeName, _new) {
		return {documentType: documentType, documentTypeName: documentTypeName, _new: _new};
	});
var $author$project$Domain$ActivityItem$DocumentSentToExternal = function (a) {
	return {$: 'DocumentSentToExternal', a: a};
};
var $author$project$Domain$ActivityItem$DocumentSentToExternalDetails = F2(
	function (documentType, loadId) {
		return {documentType: documentType, loadId: loadId};
	});
var $author$project$Domain$ActivityItem$DocumentsMerged = {$: 'DocumentsMerged'};
var $author$project$Domain$ActivityItem$DuplicateDocumentAutoHidden = {$: 'DuplicateDocumentAutoHidden'};
var $author$project$Domain$ActivityItem$DuplicateDocumentAutoMerged = {$: 'DuplicateDocumentAutoMerged'};
var $author$project$Domain$ActivityItem$DuplicateDocumentBatchAutoCompleted = function (a) {
	return {$: 'DuplicateDocumentBatchAutoCompleted', a: a};
};
var $author$project$Domain$ActivityItem$DuplicateDocumentBatchAutoCompletedDetails = function (duplicateDocumentBatchId) {
	return {duplicateDocumentBatchId: duplicateDocumentBatchId};
};
var $author$project$Domain$ActivityItem$DuplicateEmailAutoCompleted = function (a) {
	return {$: 'DuplicateEmailAutoCompleted', a: a};
};
var $author$project$Domain$ActivityItem$DuplicateEmailAutoCompletedDetails = function (duplicateEmailMessageId) {
	return {duplicateEmailMessageId: duplicateEmailMessageId};
};
var $author$project$Domain$ActivityItem$EmailCompleted = {$: 'EmailCompleted'};
var $author$project$Domain$ActivityItem$EmailIgnored = function (a) {
	return {$: 'EmailIgnored', a: a};
};
var $author$project$Domain$ActivityItem$EmailIgnoredDetails = function (reason) {
	return {reason: reason};
};
var $author$project$Domain$ActivityItem$EmailMergeSource = function (a) {
	return {$: 'EmailMergeSource', a: a};
};
var $author$project$Domain$ActivityItem$EmailMergeSourceDetails = F2(
	function (targetEmailMessageId, targetDocumentBatchId) {
		return {targetDocumentBatchId: targetDocumentBatchId, targetEmailMessageId: targetEmailMessageId};
	});
var $author$project$Domain$ActivityItem$EmailMergeTarget = function (a) {
	return {$: 'EmailMergeTarget', a: a};
};
var $author$project$Domain$ActivityItem$EmailMergeTargetDetails = function (sources) {
	return {sources: sources};
};
var $author$project$Domain$ActivityItem$EmailMergeTargetSource = F4(
	function (subject, sender, emailMessageId, documentBatchId) {
		return {documentBatchId: documentBatchId, emailMessageId: emailMessageId, sender: sender, subject: subject};
	});
var $author$project$Domain$ActivityItem$EmailUnignored = {$: 'EmailUnignored'};
var $author$project$Domain$ActivityItem$EmailZeroPages = {$: 'EmailZeroPages'};
var $author$project$Domain$ActivityItem$ExceptionDocumentsSent = {$: 'ExceptionDocumentsSent'};
var $author$project$Domain$ActivityItem$ExceptionResolved = function (a) {
	return {$: 'ExceptionResolved', a: a};
};
var $author$project$Domain$ActivityItem$ExceptionResolvedDetails = F2(
	function (message, resolution) {
		return {message: message, resolution: resolution};
	});
var $author$project$Domain$ActivityItem$ExceptionsClearedViaAPI = {$: 'ExceptionsClearedViaAPI'};
var $author$project$Domain$ActivityItem$FactoringAssignment = function (a) {
	return {$: 'FactoringAssignment', a: a};
};
var $author$project$Domain$ActivityItem$FactoringAssignmentDetails = F2(
	function (factoringCompanyName, factoringCompanyAddress) {
		return {factoringCompanyAddress: factoringCompanyAddress, factoringCompanyName: factoringCompanyName};
	});
var $author$project$Domain$ActivityItem$FlaggedForManualReview = function (a) {
	return {$: 'FlaggedForManualReview', a: a};
};
var $author$project$Domain$ActivityItem$ForwardedEmail = function (a) {
	return {$: 'ForwardedEmail', a: a};
};
var $author$project$Domain$ActivityItem$ForwardedEmailDetails = F2(
	function (recipients, note) {
		return {note: note, recipients: recipients};
	});
var $author$project$Domain$ActivityItem$Hidden = function (a) {
	return {$: 'Hidden', a: a};
};
var $author$project$Domain$ActivityItem$HiddenDetails = function (message) {
	return {message: message};
};
var $author$project$Domain$ActivityItem$IndexingComplete = {$: 'IndexingComplete'};
var $author$project$Domain$ActivityItem$InvoiceAbandoned = function (a) {
	return {$: 'InvoiceAbandoned', a: a};
};
var $author$project$Domain$ActivityItem$InvoiceApproved = function (a) {
	return {$: 'InvoiceApproved', a: a};
};
var $author$project$Domain$ActivityItem$InvoiceApprovedDetails = function (invoiceCount) {
	return {invoiceCount: invoiceCount};
};
var $author$project$Domain$ActivityItem$InvoiceCreatedByExternal = function (a) {
	return {$: 'InvoiceCreatedByExternal', a: a};
};
var $author$project$Domain$ActivityItem$InvoiceCreatedByExternalDetails = F6(
	function (invoiceNumber, invoiceDate, amountToPay, dateToPay, tmsCarrierId, sourceSystem) {
		return {amountToPay: amountToPay, dateToPay: dateToPay, invoiceDate: invoiceDate, invoiceNumber: invoiceNumber, sourceSystem: sourceSystem, tmsCarrierId: tmsCarrierId};
	});
var $author$project$Domain$ActivityItem$InvoiceDocumentsForwardedToTriumph = {$: 'InvoiceDocumentsForwardedToTriumph'};
var $author$project$Domain$ActivityItem$InvoiceDocumentsResendRequested = {$: 'InvoiceDocumentsResendRequested'};
var $author$project$Domain$ActivityItem$InvoiceExceptionEmailSent = {$: 'InvoiceExceptionEmailSent'};
var $author$project$Domain$ActivityItem$InvoiceMarkedAsPurchased = {$: 'InvoiceMarkedAsPurchased'};
var $author$project$Domain$ActivityItem$InvoiceMatched = {$: 'InvoiceMatched'};
var $author$project$Domain$ActivityItem$InvoiceRejected = {$: 'InvoiceRejected'};
var $author$project$Domain$ActivityItem$InvoiceRemovedFromGroup = {$: 'InvoiceRemovedFromGroup'};
var $author$project$Domain$ActivityItem$InvoiceUnapproved = {$: 'InvoiceUnapproved'};
var $author$project$Domain$ActivityItem$InvoiceUnignored = {$: 'InvoiceUnignored'};
var $author$project$Domain$ActivityItem$LineItemsAutoReplaced = {$: 'LineItemsAutoReplaced'};
var $author$project$Domain$ActivityItem$LoadDocumentsApproved = {$: 'LoadDocumentsApproved'};
var $author$project$Domain$ActivityItem$LoadDocumentsAssigned = {$: 'LoadDocumentsAssigned'};
var $author$project$Domain$ActivityItem$LoadDocumentsScraped = {$: 'LoadDocumentsScraped'};
var $author$project$Domain$ActivityItem$LoadDocumentsSent = {$: 'LoadDocumentsSent'};
var $author$project$Domain$ActivityItem$LoadShipmentApproval = function (a) {
	return {$: 'LoadShipmentApproval', a: a};
};
var $author$project$Domain$ActivityItem$LoadShipmentApprovalDetails = F4(
	function (shipmentId, customerId, amount, customerName) {
		return {amount: amount, customerId: customerId, customerName: customerName, shipmentId: shipmentId};
	});
var $author$project$Domain$ActivityItem$LoadShipmentUnapproval = function (a) {
	return {$: 'LoadShipmentUnapproval', a: a};
};
var $author$project$Domain$ActivityItem$LoadShipmentUnapprovalDetails = F4(
	function (shipmentId, customerId, amount, customerName) {
		return {amount: amount, customerId: customerId, customerName: customerName, shipmentId: shipmentId};
	});
var $author$project$Domain$ActivityItem$LtlAcceptAdded = function (a) {
	return {$: 'LtlAcceptAdded', a: a};
};
var $author$project$Domain$ActivityItem$LtlDisputeAdded = function (a) {
	return {$: 'LtlDisputeAdded', a: a};
};
var $author$project$Domain$ActivityItem$LtlInvoiceMovedToTMSQueue = function (a) {
	return {$: 'LtlInvoiceMovedToTMSQueue', a: a};
};
var $author$project$Domain$ActivityItem$LtlRerateCompleted = {$: 'LtlRerateCompleted'};
var $author$project$Domain$ActivityItem$LtlRerateFailed = function (a) {
	return {$: 'LtlRerateFailed', a: a};
};
var $author$project$Domain$ActivityItem$LtlRerateFailedDetails = function (errorMessage) {
	return {errorMessage: errorMessage};
};
var $author$project$Domain$ActivityItem$LtlRerateRequested = {$: 'LtlRerateRequested'};
var $author$project$Domain$ActivityItem$LtlUpdatedEdiReceived = {$: 'LtlUpdatedEdiReceived'};
var $author$project$Domain$ActivityItem$MarkedNotReadyForVerification = {$: 'MarkedNotReadyForVerification'};
var $author$project$Domain$ActivityItem$NonInvoiceLoadAssignment = {$: 'NonInvoiceLoadAssignment'};
var $author$project$Domain$ActivityItem$NoteAdded = function (a) {
	return {$: 'NoteAdded', a: a};
};
var $author$project$Domain$ActivityItem$NoteSentToPaymentsNetwork = function (a) {
	return {$: 'NoteSentToPaymentsNetwork', a: a};
};
var $author$project$Domain$ActivityItem$Paused = function (a) {
	return {$: 'Paused', a: a};
};
var $author$project$Domain$ActivityItem$PaymentAddressChanged = {$: 'PaymentAddressChanged'};
var $author$project$Domain$ActivityItem$PodRequestSentToTextLocate = {$: 'PodRequestSentToTextLocate'};
var $author$project$Domain$ActivityItem$ReadyForFmsPickup = {$: 'ReadyForFmsPickup'};
var $author$project$Domain$ActivityItem$ReceivedInvoice = {$: 'ReceivedInvoice'};
var $author$project$Domain$ActivityItem$RuleDetails = function (rule) {
	return {rule: rule};
};
var $author$project$Domain$ActivityItem$RuleDisabled = function (a) {
	return {$: 'RuleDisabled', a: a};
};
var $author$project$Domain$ActivityItem$RuleEnabled = function (a) {
	return {$: 'RuleEnabled', a: a};
};
var $author$project$Domain$ActivityItem$SavedAsIncomplete = {$: 'SavedAsIncomplete'};
var $author$project$Domain$ActivityItem$SentToCadence = function (a) {
	return {$: 'SentToCadence', a: a};
};
var $author$project$Domain$ActivityItem$SentToCadenceDetails = F3(
	function (transmissionId, transmissionType, invoiceCount) {
		return {invoiceCount: invoiceCount, transmissionId: transmissionId, transmissionType: transmissionType};
	});
var $author$project$Domain$ActivityItem$SentToExternal = function (a) {
	return {$: 'SentToExternal', a: a};
};
var $author$project$Domain$ActivityItem$SentToExternalDetails = F4(
	function (payload, response, url, filename) {
		return {filename: filename, payload: payload, response: response, url: url};
	});
var $author$project$Domain$ActivityItem$SentToVerifyQueue = {$: 'SentToVerifyQueue'};
var $author$project$Domain$ActivityItem$ShipmentApproved = function (a) {
	return {$: 'ShipmentApproved', a: a};
};
var $author$project$Domain$ActivityItem$ShipmentApprovedDetails = function (vin) {
	return {vin: vin};
};
var $author$project$Domain$ActivityItem$ShipmentRejected = function (a) {
	return {$: 'ShipmentRejected', a: a};
};
var $author$project$Domain$ActivityItem$ShipmentRejectedDetails = F2(
	function (vin, reason) {
		return {reason: reason, vin: vin};
	});
var $author$project$Domain$ActivityItem$StateChanged = function (a) {
	return {$: 'StateChanged', a: a};
};
var $author$project$Domain$ActivityItem$StateChangedDetails = F3(
	function (originalState, newState, reason) {
		return {newState: newState, originalState: originalState, reason: reason};
	});
var $author$project$Domain$ActivityItem$TransmissionFailed = function (a) {
	return {$: 'TransmissionFailed', a: a};
};
var $author$project$Domain$ActivityItem$TransmissionFailedDetails = function (failure_message) {
	return {failure_message: failure_message};
};
var $author$project$Domain$ActivityItem$TransmissionReceived = {$: 'TransmissionReceived'};
var $author$project$Domain$ActivityItem$TransmissionSucceeded = {$: 'TransmissionSucceeded'};
var $author$project$Domain$ActivityItem$UpdatedFromExternal = function (a) {
	return {$: 'UpdatedFromExternal', a: a};
};
var $author$project$Domain$ActivityItem$UpdatedFromExternalDetails = F3(
	function (updatedAttribute, previousValue, newValue) {
		return {newValue: newValue, previousValue: previousValue, updatedAttribute: updatedAttribute};
	});
var $author$project$Domain$ActivityItem$VerificationBatchStarted = {$: 'VerificationBatchStarted'};
var $author$project$Domain$ActivityItem$VerifiedByCadence = {$: 'VerifiedByCadence'};
var $author$project$Domain$ActivityItem$VerifierChangedInvoiceAmount = function (a) {
	return {$: 'VerifierChangedInvoiceAmount', a: a};
};
var $author$project$Domain$ActivityItem$VerifierChangedInvoiceAmountDetails = F2(
	function (oldAmount, newAmount) {
		return {newAmount: newAmount, oldAmount: oldAmount};
	});
var $author$project$Domain$ActivityItem$VerifyCompleted = function (a) {
	return {$: 'VerifyCompleted', a: a};
};
var $author$project$Domain$ActivityItem$VerifyCompletedDetails = F2(
	function (status, note) {
		return {note: note, status: status};
	});
var $author$project$AuditPb$ActivityItemAddDocumentToLoadFailureData = F2(
	function (addDocumentToLoadUploadId, errorMessage) {
		return {addDocumentToLoadUploadId: addDocumentToLoadUploadId, errorMessage: errorMessage};
	});
var $author$project$AuditPb$activityItemAddDocumentToLoadFailureDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'errorMessage',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'addDocumentToLoadUploadId',
				$author$project$AuditPb$intDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemAddDocumentToLoadFailureData)));
	});
var $author$project$AuditPb$ActivityItemAddDocumentToLoadSuccessData = F2(
	function (addDocumentToLoadUploadId, documents) {
		return {addDocumentToLoadUploadId: addDocumentToLoadUploadId, documents: documents};
	});
var $author$project$AuditPb$ActivityItemAddDocumentToLoadSuccessData_Document = F2(
	function (documentId, documentType) {
		return {documentId: documentId, documentType: documentType};
	});
var $author$project$AuditPb$activityItemAddDocumentToLoadSuccessData_DocumentDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'documentType',
			$author$project$AuditPb$documentTypeDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'documentId',
				A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemAddDocumentToLoadSuccessData_Document)));
	});
var $author$project$AuditPb$activityItemAddDocumentToLoadSuccessDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'documents',
			$author$project$AuditPb$activityItemAddDocumentToLoadSuccessData_DocumentDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'addDocumentToLoadUploadId',
				$author$project$AuditPb$intDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemAddDocumentToLoadSuccessData)));
	});
var $author$project$AuditPb$ActivityItemDataLtlAcceptAdded = function (acceptItems) {
	return {acceptItems: acceptItems};
};
var $author$project$AuditPb$ActivityItemDataLtlAcceptAdded_AcceptItem = F4(
	function (description, classChange, weightChange, amountChange) {
		return {amountChange: amountChange, classChange: classChange, description: description, weightChange: weightChange};
	});
var $author$project$AuditPb$ActivityItemDataLtlAcceptAdded_Change = F2(
	function (original, updated) {
		return {original: original, updated: updated};
	});
var $author$project$AuditPb$activityItemDataLtlAcceptAdded_ChangeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'updated',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'original',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemDataLtlAcceptAdded_Change)));
	});
var $author$project$AuditPb$activityItemDataLtlAcceptAdded_AcceptItemDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optionalMessage,
			'amountChange',
			$author$project$AuditPb$activityItemDataLtlAcceptAdded_ChangeDecoder,
			A3(
				$author$project$AuditPb$optionalMessage,
				'weightChange',
				$author$project$AuditPb$activityItemDataLtlAcceptAdded_ChangeDecoder,
				A3(
					$author$project$AuditPb$optionalMessage,
					'classChange',
					$author$project$AuditPb$activityItemDataLtlAcceptAdded_ChangeDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'description',
						$elm$json$Json$Decode$string,
						$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemDataLtlAcceptAdded_AcceptItem)))));
	});
var $author$project$AuditPb$activityItemDataLtlAcceptAddedDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'acceptItems',
			$author$project$AuditPb$activityItemDataLtlAcceptAdded_AcceptItemDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemDataLtlAcceptAdded));
	});
var $author$project$AuditPb$ActivityItemLtlDisputeAddedData = function (disputeItems) {
	return {disputeItems: disputeItems};
};
var $author$project$AuditPb$ActivityItemLtlDisputeAddedData_DisputeItem = F2(
	function (reconcileType, description) {
		return {description: description, reconcileType: reconcileType};
	});
var $author$project$AuditPb$LtlCarrierInvoiceReconcileTypeClass = {$: 'LtlCarrierInvoiceReconcileTypeClass'};
var $author$project$AuditPb$ltlCarrierInvoiceReconcileTypeDefault = $author$project$AuditPb$LtlCarrierInvoiceReconcileTypeClass;
var $author$project$AuditPb$LtlCarrierInvoiceReconcileTypeAmount = {$: 'LtlCarrierInvoiceReconcileTypeAmount'};
var $author$project$AuditPb$LtlCarrierInvoiceReconcileTypeWeight = {$: 'LtlCarrierInvoiceReconcileTypeWeight'};
var $author$project$AuditPb$allLtlCarrierInvoiceReconcileType = _List_fromArray(
	[$author$project$AuditPb$LtlCarrierInvoiceReconcileTypeClass, $author$project$AuditPb$LtlCarrierInvoiceReconcileTypeWeight, $author$project$AuditPb$LtlCarrierInvoiceReconcileTypeAmount]);
var $author$project$AuditPb$ltlCarrierInvoiceReconcileTypeToString = function (v) {
	switch (v.$) {
		case 'LtlCarrierInvoiceReconcileTypeClass':
			return 'class';
		case 'LtlCarrierInvoiceReconcileTypeWeight':
			return 'weight';
		default:
			return 'amount';
	}
};
var $author$project$AuditPb$ltlCarrierInvoiceReconcileTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$ltlCarrierInvoiceReconcileTypeToString(v),
				v);
		},
		$author$project$AuditPb$allLtlCarrierInvoiceReconcileType));
var $author$project$AuditPb$ltlCarrierInvoiceReconcileTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$ltlCarrierInvoiceReconcileTypeDict);
};
var $author$project$AuditPb$ltlCarrierInvoiceReconcileTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$ltlCarrierInvoiceReconcileTypeDefault),
		$author$project$AuditPb$ltlCarrierInvoiceReconcileTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$activityItemLtlDisputeAddedData_DisputeItemDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'reconcileType',
				$author$project$AuditPb$ltlCarrierInvoiceReconcileTypeDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemLtlDisputeAddedData_DisputeItem)));
	});
var $author$project$AuditPb$activityItemLtlDisputeAddedDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'disputeItems',
			$author$project$AuditPb$activityItemLtlDisputeAddedData_DisputeItemDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemLtlDisputeAddedData));
	});
var $author$project$Domain$LoadStateId$LoadStateId = function (a) {
	return {$: 'LoadStateId', a: a};
};
var $author$project$Domain$LoadStateId$fromInt = function (_int) {
	return $author$project$Domain$LoadStateId$LoadStateId(_int);
};
var $author$project$Domain$LoadStateId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$LoadStateId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$Rule$Rule = F2(
	function (ruleType, displayText) {
		return {displayText: displayText, ruleType: ruleType};
	});
var $author$project$Domain$Rule$decode = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Domain$Rule$Rule,
	A2($elm$json$Json$Decode$field, 'rule_type', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'display_text', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('rule description missing')
			])));
var $author$project$Domain$TmsCarrierId$decode = $author$project$Id$decoder;
var $author$project$Domain$ActivityItem$InvoiceAutoProcessed = function (a) {
	return {$: 'InvoiceAutoProcessed', a: a};
};
var $author$project$Domain$ActivityItem$FactorInvoiceProcessedDetails = F7(
	function (invoiceNumber, loadId, amountToPay, invoiceDate, tmsCarrierId, debtorName, fieldSources) {
		return {amountToPay: amountToPay, debtorName: debtorName, fieldSources: fieldSources, invoiceDate: invoiceDate, invoiceNumber: invoiceNumber, loadId: loadId, tmsCarrierId: tmsCarrierId};
	});
var $author$project$AuditPb$ActivityItemFactorInvoiceFieldSources = F4(
	function (invoiceNumberSource, loadIdSource, amountSource, debtorSource) {
		return {amountSource: amountSource, debtorSource: debtorSource, invoiceNumberSource: invoiceNumberSource, loadIdSource: loadIdSource};
	});
var $author$project$AuditPb$ActivityItemFactorInvoiceFieldSources_FieldSource = F3(
	function (kind, systemValue, changedByName) {
		return {changedByName: changedByName, kind: kind, systemValue: systemValue};
	});
var $author$project$AuditPb$FactorInvoiceFieldSourceKindPrefilledBySystem = {$: 'FactorInvoiceFieldSourceKindPrefilledBySystem'};
var $author$project$AuditPb$factorInvoiceFieldSourceKindDefault = $author$project$AuditPb$FactorInvoiceFieldSourceKindPrefilledBySystem;
var $author$project$AuditPb$FactorInvoiceFieldSourceKindChangedBySupport = {$: 'FactorInvoiceFieldSourceKindChangedBySupport'};
var $author$project$AuditPb$FactorInvoiceFieldSourceKindChangedByUser = {$: 'FactorInvoiceFieldSourceKindChangedByUser'};
var $author$project$AuditPb$allFactorInvoiceFieldSourceKind = _List_fromArray(
	[$author$project$AuditPb$FactorInvoiceFieldSourceKindPrefilledBySystem, $author$project$AuditPb$FactorInvoiceFieldSourceKindChangedByUser, $author$project$AuditPb$FactorInvoiceFieldSourceKindChangedBySupport]);
var $author$project$AuditPb$factorInvoiceFieldSourceKindToString = function (v) {
	switch (v.$) {
		case 'FactorInvoiceFieldSourceKindPrefilledBySystem':
			return 'prefilled_by_system';
		case 'FactorInvoiceFieldSourceKindChangedByUser':
			return 'changed_by_user';
		default:
			return 'changed_by_support';
	}
};
var $author$project$AuditPb$factorInvoiceFieldSourceKindDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$factorInvoiceFieldSourceKindToString(v),
				v);
		},
		$author$project$AuditPb$allFactorInvoiceFieldSourceKind));
var $author$project$AuditPb$factorInvoiceFieldSourceKindFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$factorInvoiceFieldSourceKindDict);
};
var $author$project$AuditPb$factorInvoiceFieldSourceKindDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$factorInvoiceFieldSourceKindDefault),
		$author$project$AuditPb$factorInvoiceFieldSourceKindFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$activityItemFactorInvoiceFieldSources_FieldSourceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'changedByName',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'systemValue',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'kind',
					$author$project$AuditPb$factorInvoiceFieldSourceKindDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemFactorInvoiceFieldSources_FieldSource))));
	});
var $author$project$AuditPb$activityItemFactorInvoiceFieldSourcesDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optionalMessage,
			'debtorSource',
			$author$project$AuditPb$activityItemFactorInvoiceFieldSources_FieldSourceDecoder,
			A3(
				$author$project$AuditPb$optionalMessage,
				'amountSource',
				$author$project$AuditPb$activityItemFactorInvoiceFieldSources_FieldSourceDecoder,
				A3(
					$author$project$AuditPb$optionalMessage,
					'loadIdSource',
					$author$project$AuditPb$activityItemFactorInvoiceFieldSources_FieldSourceDecoder,
					A3(
						$author$project$AuditPb$optionalMessage,
						'invoiceNumberSource',
						$author$project$AuditPb$activityItemFactorInvoiceFieldSources_FieldSourceDecoder,
						$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemFactorInvoiceFieldSources)))));
	});
var $author$project$Domain$ActivityItem$decodeFactorInvoiceProcessedDetails = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Domain$ActivityItem$FactorInvoiceProcessedDetails,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['data', 'factor_invoice', 'invoice_number']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'factor_invoice', 'load_id']),
			$elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['data', 'factor_invoice', 'amount']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'factor_invoice', 'invoice_date']),
			$author$project$Helpers$Json$Decode$date)),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['data', 'factor_invoice', 'carrier_id']),
		$author$project$Domain$TmsCarrierId$decode),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['data', 'factor_invoice', 'debtor_name']),
		$elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'field_sources']),
			$author$project$AuditPb$activityItemFactorInvoiceFieldSourcesDecoder)));
var $author$project$Domain$ActivityItem$decodeAutoProcessed = A2($elm$json$Json$Decode$map, $author$project$Domain$ActivityItem$InvoiceAutoProcessed, $author$project$Domain$ActivityItem$decodeFactorInvoiceProcessedDetails);
var $author$project$Domain$ActivityItem$CarrierPayableApproved = function (a) {
	return {$: 'CarrierPayableApproved', a: a};
};
var $author$project$Domain$ActivityItem$CarrierPayableApprovedDetails = F6(
	function (invoiceNumber, invoiceDate, amountToPay, dateToPay, tmsCarrierId, remitToAddress) {
		return {amountToPay: amountToPay, dateToPay: dateToPay, invoiceDate: invoiceDate, invoiceNumber: invoiceNumber, remitToAddress: remitToAddress, tmsCarrierId: tmsCarrierId};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Domain$ActivityItem$decodeCarrierPayableApproved = A2(
	$elm$json$Json$Decode$map,
	$author$project$Domain$ActivityItem$CarrierPayableApproved,
	A7(
		$elm$json$Json$Decode$map6,
		$author$project$Domain$ActivityItem$CarrierPayableApprovedDetails,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'invoice', 'invoice_number']),
			$elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'invoice', 'invoice_date']),
			$author$project$Helpers$Json$Decode$date),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'invoice', 'amount_to_pay']),
			$elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'invoice', 'date_to_pay']),
			$author$project$Helpers$Json$Decode$date),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'invoice', 'carrier_id']),
			$author$project$Domain$TmsCarrierId$decode),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'invoice', 'remit_to_address']),
			$elm$json$Json$Decode$maybe($author$project$Domain$Address$decode))));
var $author$project$Domain$ActivityItem$CarrierInvoiceProcessedDetails = F6(
	function (invoiceNumber, invoiceDate, amountToPay, dateToPay, tmsCarrierId, remitToAddress) {
		return {amountToPay: amountToPay, dateToPay: dateToPay, invoiceDate: invoiceDate, invoiceNumber: invoiceNumber, remitToAddress: remitToAddress, tmsCarrierId: tmsCarrierId};
	});
var $author$project$Domain$ActivityItem$CarrierInvoiceProcessedDetails_ = function (a) {
	return {$: 'CarrierInvoiceProcessedDetails_', a: a};
};
var $author$project$Domain$ActivityItem$FactorInvoiceProcessedDetails_ = function (a) {
	return {$: 'FactorInvoiceProcessedDetails_', a: a};
};
var $author$project$Domain$ActivityItem$InvoiceProcessed = function (a) {
	return {$: 'InvoiceProcessed', a: a};
};
var $author$project$Domain$ActivityItem$decodeProcessed = A2(
	$elm$json$Json$Decode$map,
	$author$project$Domain$ActivityItem$InvoiceProcessed,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$CarrierInvoiceProcessedDetails_,
				A7(
					$elm$json$Json$Decode$map6,
					$author$project$Domain$ActivityItem$CarrierInvoiceProcessedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'invoice_number']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'invoice_date']),
						$author$project$Helpers$Json$Decode$date),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'amount_to_pay']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'date_to_pay']),
						$author$project$Helpers$Json$Decode$date),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'carrier_id']),
						$author$project$Domain$TmsCarrierId$decode),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'remit_to_address']),
						$elm$json$Json$Decode$maybe($author$project$Domain$Address$decode)))),
				A2($elm$json$Json$Decode$map, $author$project$Domain$ActivityItem$FactorInvoiceProcessedDetails_, $author$project$Domain$ActivityItem$decodeFactorInvoiceProcessedDetails)
			])));
var $author$project$AuditPb$FlaggedForManualReviewReasonHitClientThreshold = {$: 'FlaggedForManualReviewReasonHitClientThreshold'};
var $author$project$AuditPb$flaggedForManualReviewReasonDefault = $author$project$AuditPb$FlaggedForManualReviewReasonHitClientThreshold;
var $author$project$AuditPb$FlaggedForManualReviewReasonAutoprocessingDisabledForDebtor = {$: 'FlaggedForManualReviewReasonAutoprocessingDisabledForDebtor'};
var $author$project$AuditPb$FlaggedForManualReviewReasonBrokerDomainMismatch = {$: 'FlaggedForManualReviewReasonBrokerDomainMismatch'};
var $author$project$AuditPb$FlaggedForManualReviewReasonFailedAutoVerification = {$: 'FlaggedForManualReviewReasonFailedAutoVerification'};
var $author$project$AuditPb$FlaggedForManualReviewReasonHitAccountThreshold = {$: 'FlaggedForManualReviewReasonHitAccountThreshold'};
var $author$project$AuditPb$FlaggedForManualReviewReasonHitClientCreditRatingThreshold = {$: 'FlaggedForManualReviewReasonHitClientCreditRatingThreshold'};
var $author$project$AuditPb$FlaggedForManualReviewReasonMarkedAsFuelAdvance = {$: 'FlaggedForManualReviewReasonMarkedAsFuelAdvance'};
var $author$project$AuditPb$allFlaggedForManualReviewReason = _List_fromArray(
	[$author$project$AuditPb$FlaggedForManualReviewReasonHitClientThreshold, $author$project$AuditPb$FlaggedForManualReviewReasonHitAccountThreshold, $author$project$AuditPb$FlaggedForManualReviewReasonFailedAutoVerification, $author$project$AuditPb$FlaggedForManualReviewReasonMarkedAsFuelAdvance, $author$project$AuditPb$FlaggedForManualReviewReasonBrokerDomainMismatch, $author$project$AuditPb$FlaggedForManualReviewReasonHitClientCreditRatingThreshold, $author$project$AuditPb$FlaggedForManualReviewReasonAutoprocessingDisabledForDebtor]);
var $author$project$AuditPb$flaggedForManualReviewReasonToString = function (v) {
	switch (v.$) {
		case 'FlaggedForManualReviewReasonHitClientThreshold':
			return 'hit_client_threshold';
		case 'FlaggedForManualReviewReasonHitAccountThreshold':
			return 'hit_account_threshold';
		case 'FlaggedForManualReviewReasonFailedAutoVerification':
			return 'failed_auto_verification';
		case 'FlaggedForManualReviewReasonMarkedAsFuelAdvance':
			return 'marked_as_fuel_advance';
		case 'FlaggedForManualReviewReasonBrokerDomainMismatch':
			return 'broker_domain_mismatch';
		case 'FlaggedForManualReviewReasonHitClientCreditRatingThreshold':
			return 'hit_client_credit_rating_threshold';
		default:
			return 'autoprocessing_disabled_for_debtor';
	}
};
var $author$project$AuditPb$flaggedForManualReviewReasonDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$flaggedForManualReviewReasonToString(v),
				v);
		},
		$author$project$AuditPb$allFlaggedForManualReviewReason));
var $author$project$AuditPb$flaggedForManualReviewReasonFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$flaggedForManualReviewReasonDict);
};
var $author$project$AuditPb$flaggedForManualReviewReasonDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$flaggedForManualReviewReasonDefault),
		$author$project$AuditPb$flaggedForManualReviewReasonFromString),
	$elm$json$Json$Decode$string);
var $author$project$Domain$TransmissionId$TransmissionId = function (a) {
	return {$: 'TransmissionId', a: a};
};
var $author$project$Domain$TransmissionId$fromInt = function (_int) {
	return $author$project$Domain$TransmissionId$TransmissionId(_int);
};
var $author$project$AuditPb$LtlInvoiceMovedToTMSQueueData = F2(
	function (reason, queueName) {
		return {queueName: queueName, reason: reason};
	});
var $author$project$AuditPb$ltlInvoiceMovedToTMSQueueDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'queueName',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'reason',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$LtlInvoiceMovedToTMSQueueData)));
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Domain$ActivityItem$details = function (activityType) {
	switch (activityType.$) {
		case 'ActivityItemAccountsPayableActivityTypeAcertusShipmentApproved':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$ShipmentApproved,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$ShipmentApprovedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'vin']),
						$author$project$Helpers$Json$Decode$nonEmptyString)));
		case 'ActivityItemAccountsPayableActivityTypeAcertusShipmentRejected':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$ShipmentRejected,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Domain$ActivityItem$ShipmentRejectedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'vin']),
						$author$project$Helpers$Json$Decode$nonEmptyString),
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'reason']),
							$author$project$Helpers$Json$Decode$nonEmptyString))));
		case 'ActivityItemAccountsPayableActivityTypeApproval':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$InvoiceApproved,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$InvoiceApprovedDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'invoice_count']),
							$elm$json$Json$Decode$int))));
		case 'ActivityItemAccountsPayableActivityTypeLtlAcceptAdded':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$LtlAcceptAdded,
				A2($elm$json$Json$Decode$field, 'data', $author$project$AuditPb$activityItemDataLtlAcceptAddedDecoder));
		case 'ActivityItemAccountsPayableActivityTypeCarrierPayableApproval':
			return $author$project$Domain$ActivityItem$decodeCarrierPayableApproved;
		case 'ActivityItemAccountsPayableActivityTypeBypassedVerifyQueue':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$BypassedVerifyQueue);
		case 'ActivityItemAccountsPayableActivityTypeVerificationBatchStarted':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$VerificationBatchStarted);
		case 'ActivityItemAccountsPayableActivityTypeDocumentsResendRequested':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceDocumentsResendRequested);
		case 'ActivityItemAccountsPayableActivityTypeDocumentAdded':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DocumentAdded,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Domain$ActivityItem$DocumentAddedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'document_type']),
						$author$project$Domain$UnresolvedDocumentType$decode),
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'document_type_name', $elm$json$Json$Decode$string))),
					$elm$json$Json$Decode$maybe(
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (x, y) {
									return {load_id: y, load_state_id: x};
								}),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['data', 'original_load_state_id']),
								$author$project$Domain$LoadStateId$decode),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['data', 'original_load_id']),
								$elm$json$Json$Decode$string)))));
		case 'ActivityItemAccountsPayableActivityTypeDocumentAssigned':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$DocumentAssigned);
		case 'ActivityItemAccountsPayableActivityTypeDocumentRemoved':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DocumentRemoved,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Domain$ActivityItem$DocumentRemovedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'document_type']),
						$author$project$Domain$UnresolvedDocumentType$decode),
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'document_type_name', $elm$json$Json$Decode$string))),
					$elm$json$Json$Decode$maybe(
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (x, y) {
									return {load_id: y, load_state_id: x};
								}),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['data', 'new_load_state_id']),
								$author$project$Domain$LoadStateId$decode),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['data', 'new_load_id']),
								$elm$json$Json$Decode$string)))));
		case 'ActivityItemAccountsPayableActivityTypeDocSentToExternal':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DocumentSentToExternal,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Domain$ActivityItem$DocumentSentToExternalDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'document_type']),
						$author$project$Domain$UnresolvedDocumentType$decode),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'load_id']),
						$elm$json$Json$Decode$string)));
		case 'ActivityItemAccountsPayableActivityTypeEmailMergeSource':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$EmailMergeSource,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Domain$ActivityItem$EmailMergeSourceDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'target_email_id']),
						A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $elm$json$Json$Decode$int)),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'target_document_batch_id']),
						A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $elm$json$Json$Decode$int))));
		case 'ActivityItemAccountsPayableActivityTypeEmailMergeTarget':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$EmailMergeTarget,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$EmailMergeTargetDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'sources']),
						$elm$json$Json$Decode$list(
							A5(
								$elm$json$Json$Decode$map4,
								$author$project$Domain$ActivityItem$EmailMergeTargetSource,
								A2($elm$json$Json$Decode$field, 'subject', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'sender', $elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$field,
									'id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $elm$json$Json$Decode$int)),
								A2(
									$elm$json$Json$Decode$field,
									'document_batch_id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $elm$json$Json$Decode$int)))))));
		case 'ActivityItemAccountsPayableActivityTypeEmailIgnored':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$EmailIgnored,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$EmailIgnoredDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'reason']),
							$author$project$Helpers$Json$Decode$nonEmptyString))));
		case 'ActivityItemAccountsPayableActivityTypeEmailUnignored':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$EmailUnignored);
		case 'ActivityItemAccountsPayableActivityTypeEmailCompleted':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$EmailCompleted);
		case 'ActivityItemAccountsPayableActivityTypeDuplicateEmailAutoCompleted':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DuplicateEmailAutoCompleted,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$DuplicateEmailAutoCompletedDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'duplicate_email_message_id']),
							$elm$json$Json$Decode$int))));
		case 'ActivityItemAccountsPayableActivityTypeAutoCompletedWaitingExceptionsOnNewDocs':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$AutoCompletedWaitingExceptionsOnNewDocs);
		case 'ActivityItemAccountsPayableActivityTypeException':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$SavedAsIncomplete);
		case 'ActivityItemAccountsPayableActivityTypeExceptionResolved':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$ExceptionResolved,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Domain$ActivityItem$ExceptionResolvedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'message']),
						$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString)),
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'resolution']),
							$author$project$Helpers$Json$Decode$nonEmptyString))));
		case 'ActivityItemAccountsPayableActivityTypeExceptionsClearedViaAPI':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$ExceptionsClearedViaAPI);
		case 'ActivityItemAccountsPayableActivityTypeDocsSentOnException':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$ExceptionDocumentsSent);
		case 'ActivityItemAccountsPayableActivityTypeExternalCreation':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$InvoiceCreatedByExternal,
				A7(
					$elm$json$Json$Decode$map6,
					$author$project$Domain$ActivityItem$InvoiceCreatedByExternalDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'invoice_number']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'invoice_date']),
						$author$project$Helpers$Json$Decode$date),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'amount_to_pay']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'date_to_pay']),
						$author$project$Helpers$Json$Decode$date),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'carrier_id']),
						$author$project$Domain$TmsCarrierId$decode),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'invoice', 'source_system']),
						$elm$json$Json$Decode$string)));
		case 'ActivityItemAccountsPayableActivityTypeContactAdded':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$ContactAdded,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Domain$ActivityItem$ContactAddedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'carrier_name']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'contact_name']),
						$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString)),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'contact_email']),
						$elm$json$Json$Decode$string)));
		case 'ActivityItemAccountsPayableActivityTypeFactoringAssignment':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$FactoringAssignment,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Domain$ActivityItem$FactoringAssignmentDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'factoring_company_name']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'factoring_company_office_address']),
						$author$project$Domain$Address$decode)));
		case 'ActivityItemAccountsPayableActivityTypeForwardedEmail':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$ForwardedEmail,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Domain$ActivityItem$ForwardedEmailDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'recipients']),
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'note']),
						$elm$json$Json$Decode$maybe($author$project$Helpers$Json$Decode$nonEmptyString))));
		case 'ActivityItemAccountsPayableActivityTypeInvoiceDocumentsForwardedToTriumph':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceDocumentsForwardedToTriumph);
		case 'ActivityItemAccountsPayableActivityTypeIgnore':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DocumentBatchIgnored,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$DocumentBatchIgnoredDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'reason']),
							$author$project$Helpers$Json$Decode$nonEmptyString))));
		case 'ActivityItemAccountsPayableActivityTypeInvoiceAbandoned':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$InvoiceAbandoned,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$AbandonedDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'reason']),
							$elm$json$Json$Decode$string))));
		case 'ActivityItemAccountsPayableActivityTypeInvoiceMatched':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceMatched);
		case 'ActivityItemAccountsPayableActivityTypeMarkedPurchasedByUser':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceMarkedAsPurchased);
		case 'ActivityItemAccountsPayableActivityTypeSentToVerifyQueue':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$SentToVerifyQueue);
		case 'ActivityItemAccountsPayableActivityTypeVerifyCompleted':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$VerifyCompleted,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Domain$ActivityItem$VerifyCompletedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'status']),
						$elm$json$Json$Decode$string),
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'note']),
							$elm$json$Json$Decode$string))));
		case 'ActivityItemAccountsPayableActivityTypeInvoiceRejected':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceRejected);
		case 'ActivityItemAccountsPayableActivityTypeInvoiceRevived':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceUnignored);
		case 'ActivityItemAccountsPayableActivityTypeInvoiceUnapproved':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceUnapproved);
		case 'ActivityItemAccountsPayableActivityTypeNote':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$NoteAdded,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['data', 'message']),
					$elm$json$Json$Decode$string));
		case 'ActivityItemAccountsPayableActivityTypeSendNoteToPayeeViaPaymentsNetwork':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$NoteSentToPaymentsNetwork,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['data', 'message']),
					$elm$json$Json$Decode$string));
		case 'ActivityItemAccountsPayableActivityTypePause':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$Paused,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['data', 'paused_until']),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder));
		case 'ActivityItemAccountsPayableActivityTypePaymentAddressChanged':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$PaymentAddressChanged);
		case 'ActivityItemAccountsPayableActivityTypeProcessed':
			return $author$project$Domain$ActivityItem$decodeProcessed;
		case 'ActivityItemAccountsPayableActivityTypeAutoProcessed':
			return $author$project$Domain$ActivityItem$decodeAutoProcessed;
		case 'ActivityItemAccountsPayableActivityTypeReceivedInvoice':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$ReceivedInvoice);
		case 'ActivityItemAccountsPayableActivityTypeRemovedFromGroup':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceRemovedFromGroup);
		case 'ActivityItemAccountsPayableActivityTypeRuleDisabled':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$RuleDisabled,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$RuleDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'rule']),
						$author$project$Domain$Rule$decode)));
		case 'ActivityItemAccountsPayableActivityTypeClientOrDebtorOnBolChanged':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$ClientOrDebtorOnBolChanged,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$ClientOrDebtorOnBolChangedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'to']),
						$elm$json$Json$Decode$string)));
		case 'ActivityItemAccountsPayableActivityTypeDebtorCorrected':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DebtorCorrected,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Domain$ActivityItem$DebtorCorrectedDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'previous_debtor_name']),
							$elm$json$Json$Decode$string)),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'corrected_debtor_name']),
						$elm$json$Json$Decode$string),
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'notes']),
							$elm$json$Json$Decode$string))));
		case 'ActivityItemAccountsPayableActivityTypeRuleEnabled':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$RuleEnabled,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$RuleDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'rule']),
						$author$project$Domain$Rule$decode)));
		case 'ActivityItemAccountsPayableActivityTypeSentToCadence':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$SentToCadence,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Domain$ActivityItem$SentToCadenceDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'transmission_id']),
							A2($elm$json$Json$Decode$map, $author$project$Domain$TransmissionId$fromInt, $elm$json$Json$Decode$int))),
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'transmission_type']),
							$elm$json$Json$Decode$string)),
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'invoice_count']),
							$elm$json$Json$Decode$int))));
		case 'ActivityItemAccountsPayableActivityTypeVerifiedByCadence':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$VerifiedByCadence);
		case 'ActivityItemAccountsPayableActivityTypeVerifierChangedInvoiceAmount':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$VerifierChangedInvoiceAmount,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Domain$ActivityItem$VerifierChangedInvoiceAmountDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'old_amount']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'new_amount']),
						$elm$json$Json$Decode$string)));
		case 'ActivityItemAccountsPayableActivityTypeMarkedNotReadyForVerification':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$MarkedNotReadyForVerification);
		case 'ActivityItemAccountsPayableActivityTypeUpdatedFromExternal':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$UpdatedFromExternal,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Domain$ActivityItem$UpdatedFromExternalDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'updated_attribute']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'previous_value']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'new_value']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string))));
		case 'ActivityItemAccountsPayableActivityTypeSentToExternal':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$SentToExternal,
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Domain$ActivityItem$SentToExternalDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'payload']),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$string,
									A2(
									$elm$json$Json$Decode$map,
									$elm$json$Json$Encode$encode(2),
									$elm$json$Json$Decode$value)
								]))),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'response']),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$string,
									A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)
								]))),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'url']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'filename']),
							$elm$json$Json$Decode$string))));
		case 'ActivityItemAccountsPayableActivityTypeStateChange':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$StateChanged,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Domain$ActivityItem$StateChangedDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'original_state']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'new_state']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'reason']),
						$elm$json$Json$Decode$string)));
		case 'ActivityItemAccountsPayableActivityTypeTransmissionReceived':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$TransmissionReceived);
		case 'ActivityItemAccountsPayableActivityTypeTransmissionFailed':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$TransmissionFailed,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$TransmissionFailedDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'failure_message']),
							$author$project$Helpers$Json$Decode$nonEmptyString))));
		case 'ActivityItemAccountsPayableActivityTypeTransmissionSucceeded':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$TransmissionSucceeded);
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsApproved':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$LoadDocumentsApproved);
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsScraped':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$LoadDocumentsScraped);
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsAssigned':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$LoadDocumentsAssigned);
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsSent':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$LoadDocumentsSent);
		case 'ActivityItemAccountsPayableActivityTypeBuiltLoadSentToTMS':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$BuiltLoadSentToTMS);
		case 'ActivityItemAccountsPayableActivityTypePODRequestSentToTextLocate':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$PodRequestSentToTextLocate);
		case 'ActivityItemAccountsPayableActivityTypeBuiltLoadConfirmed':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$BuiltLoadConfirmed);
		case 'ActivityItemAccountsPayableActivityTypeLoadShipmentApproval':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$LoadShipmentApproval,
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Domain$ActivityItem$LoadShipmentApprovalDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'shipment_id']),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$string,
									A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)
								]))),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customer_id']),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
									$elm$json$Json$Decode$maybe(
									A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int))
								]))),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'amount']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customer_name']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string))));
		case 'ActivityItemAccountsPayableActivityTypeLoadShipmentUnapproval':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$LoadShipmentUnapproval,
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Domain$ActivityItem$LoadShipmentUnapprovalDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'shipment_id']),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$string,
									A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)
								]))),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customer_id']),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
									$elm$json$Json$Decode$maybe(
									A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int))
								]))),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'amount']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customer_name']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string))));
		case 'ActivityItemAccountsPayableActivityTypeInvoiceExceptionEmailSent':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$InvoiceExceptionEmailSent);
		case 'ActivityItemAccountsPayableActivityTypeLtlDisputeAdded':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$LtlDisputeAdded,
				A2($elm$json$Json$Decode$field, 'data', $author$project$AuditPb$activityItemLtlDisputeAddedDataDecoder));
		case 'ActivityItemAccountsPayableActivityTypeLtlMovedToTMSQueue':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$LtlInvoiceMovedToTMSQueue,
				A2($elm$json$Json$Decode$field, 'data', $author$project$AuditPb$ltlInvoiceMovedToTMSQueueDataDecoder));
		case 'ActivityItemAccountsPayableActivityTypeLtlUpdatedEdiReceived':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$LtlUpdatedEdiReceived);
		case 'ActivityItemAccountsPayableActivityTypeHidden':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$Hidden,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$HiddenDetails,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'message']),
						$elm$json$Json$Decode$string)));
		case 'ActivityItemAccountsPayableActivityTypeAddDocumentToLoadSuccess':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$AddDocumentToLoadSuccess,
				A2($elm$json$Json$Decode$field, 'data', $author$project$AuditPb$activityItemAddDocumentToLoadSuccessDataDecoder));
		case 'ActivityItemAccountsPayableActivityTypeAddDocumentToLoadFailure':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$AddDocumentToLoadFailure,
				A2($elm$json$Json$Decode$field, 'data', $author$project$AuditPb$activityItemAddDocumentToLoadFailureDataDecoder));
		case 'ActivityItemAccountsPayableActivityTypeFlaggedForManualReview':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$FlaggedForManualReview,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['data', 'reason']),
					$author$project$AuditPb$flaggedForManualReviewReasonDecoder));
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateRequested':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$LtlRerateRequested);
		case 'ActivityItemAccountsPayableActivityTypeCarrierInvoiceRuleChangedViaTMS':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$CarrierInvoiceRuleChangedViaTms);
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateCompleted':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$LtlRerateCompleted);
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateFailed':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Domain$ActivityItem$LtlRerateFailed, $author$project$Domain$ActivityItem$LtlRerateFailedDetails),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['data', 'error_message']),
					$elm$json$Json$Decode$string));
		case 'ActivityItemAccountsPayableActivityTypeDocumentsMerged':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$DocumentsMerged);
		case 'ActivityItemAccountsPayableActivityTypeIndexingComplete':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$IndexingComplete);
		case 'ActivityItemAccountsPayableActivityTypeEmailZeroPages':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$EmailZeroPages);
		case 'ActivityItemAccountsPayableActivityTypeReadyForFMSPickup':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$ReadyForFmsPickup);
		case 'ActivityItemAccountsPayableActivityTypeAcknowledgedByFMS':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$AcknowledgedByFms);
		case 'ActivityItemAccountsPayableActivityTypeNonInvoiceLoadAssignment':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$NonInvoiceLoadAssignment);
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentBatchAutoCompleted':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DuplicateDocumentBatchAutoCompleted,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Domain$ActivityItem$DuplicateDocumentBatchAutoCompletedDetails,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'duplicate_document_batch_id']),
							$elm$json$Json$Decode$int))));
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoHidden':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$DuplicateDocumentAutoHidden);
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoMerged':
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$DuplicateDocumentAutoMerged);
		default:
			return $elm$json$Json$Decode$succeed($author$project$Domain$ActivityItem$LineItemsAutoReplaced);
	}
};
var $author$project$Domain$ActivityItem$CarrierInvoiceOwnerId = function (a) {
	return {$: 'CarrierInvoiceOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$DocumentBatchOwnerId = function (a) {
	return {$: 'DocumentBatchOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$DocumentGroupOwnerId = function (a) {
	return {$: 'DocumentGroupOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$DocumentOwnerId = function (a) {
	return {$: 'DocumentOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$DocumentPageOwnerId = function (a) {
	return {$: 'DocumentPageOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$EmailMessageOwnerId = function (a) {
	return {$: 'EmailMessageOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$FactorInvoiceOwnerId = function (a) {
	return {$: 'FactorInvoiceOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$LoadStateOwnerId = function (a) {
	return {$: 'LoadStateOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$TmsCarrierOwnerId = function (a) {
	return {$: 'TmsCarrierOwnerId', a: a};
};
var $author$project$Domain$ActivityItem$TmsLoadShipmentOwnerId = function (a) {
	return {$: 'TmsLoadShipmentOwnerId', a: a};
};
var $author$project$Domain$DocumentPageId$DocumentPageId = function (a) {
	return {$: 'DocumentPageId', a: a};
};
var $author$project$Domain$DocumentPageId$fromInt = function (_int) {
	return $author$project$Domain$DocumentPageId$DocumentPageId(_int);
};
var $author$project$Domain$DocumentPageId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentPageId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$TmsLoadShipmentId$TmsLoadShipmentId = function (a) {
	return {$: 'TmsLoadShipmentId', a: a};
};
var $author$project$Domain$TmsLoadShipmentId$fromInt = function (_int) {
	return $author$project$Domain$TmsLoadShipmentId$TmsLoadShipmentId(_int);
};
var $author$project$Domain$TmsLoadShipmentId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$TmsLoadShipmentId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$ActivityItem$ownerId = function (ownerType) {
	switch (ownerType) {
		case 'CarrierInvoice':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Domain$ActivityItem$CarrierInvoiceOwnerId, $author$project$Domain$CarrierInvoiceId$fromInt),
				A2($elm$json$Json$Decode$field, 'owner_id', $elm$json$Json$Decode$int));
		case 'DocumentBatch':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Domain$ActivityItem$DocumentBatchOwnerId, $author$project$Domain$DocumentBatchId$fromInt),
				A2($elm$json$Json$Decode$field, 'owner_id', $elm$json$Json$Decode$int));
		case 'DocumentGroup':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Domain$ActivityItem$DocumentGroupOwnerId, $author$project$Domain$DocumentGroupId$fromInt),
				A2($elm$json$Json$Decode$field, 'owner_id', $elm$json$Json$Decode$int));
		case 'EmailMessage':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Domain$ActivityItem$EmailMessageOwnerId, $author$project$Domain$EmailMessageId$fromInt),
				A2($elm$json$Json$Decode$field, 'owner_id', $elm$json$Json$Decode$int));
		case 'FactorInvoice':
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Domain$ActivityItem$FactorInvoiceOwnerId, $author$project$Domain$FactorInvoiceId$fromInt),
				A2($elm$json$Json$Decode$field, 'owner_id', $elm$json$Json$Decode$int));
		case 'TMS::Carrier':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$TmsCarrierOwnerId,
				A2($elm$json$Json$Decode$field, 'owner_id', $author$project$Domain$TmsCarrierId$decode));
		case 'LoadState':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$LoadStateOwnerId,
				A2($elm$json$Json$Decode$field, 'owner_id', $author$project$Domain$LoadStateId$decode));
		case 'DocumentPage':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DocumentPageOwnerId,
				A2($elm$json$Json$Decode$field, 'owner_id', $author$project$Domain$DocumentPageId$decode));
		case 'Document':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$DocumentOwnerId,
				A2($elm$json$Json$Decode$field, 'owner_id', $author$project$Domain$DocumentId$decode));
		case 'TMS::LoadShipment':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$ActivityItem$TmsLoadShipmentOwnerId,
				A2($elm$json$Json$Decode$field, 'owner_id', $author$project$Domain$TmsLoadShipmentId$decode));
		default:
			return $elm$json$Json$Decode$fail(ownerType + ' is not a recognized tag for shapes');
	}
};
var $author$project$Domain$ActivityItem$decode = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Domain$ActivityItem$ActivityItem,
	A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$ActivityItemId$decode),
	A2($elm$json$Json$Decode$field, 'account_id', $elm$json$Json$Decode$int),
	A2(
		$author$project$Domain$ActivityItem$defaultTo,
		$elm$core$Maybe$Nothing,
		A2(
			$elm$json$Json$Decode$field,
			'user',
			$elm$json$Json$Decode$nullable(
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed('(Unknown)')
						]))))),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Domain$ActivityItem$ownerId,
		A2($elm$json$Json$Decode$field, 'owner_type', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'created_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A2($elm$json$Json$Decode$field, 'updated_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Domain$ActivityItem$details,
		A2($elm$json$Json$Decode$field, 'activity_type', $author$project$AuditPb$activityItemAccountsPayableActivityTypeDecoder)),
	A2($elm$json$Json$Decode$field, 'automated_activity_display_name', $elm$json$Json$Decode$string));
var $author$project$Domain$FactorInvoice$DocumentBatchEmailDetails = F5(
	function (subject, date, senderAddress, carrierName, carrierAccountExecutive) {
		return {carrierAccountExecutive: carrierAccountExecutive, carrierName: carrierName, date: date, senderAddress: senderAddress, subject: subject};
	});
var $author$project$Domain$FactorInvoice$decodeDocumentBatchEmailDetails = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2(
		$elm$json$Json$Decode$field,
		'carrier_account_executive',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		A2(
			$elm$json$Json$Decode$field,
			'carrier_name',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2(
				$elm$json$Json$Decode$field,
				'sender_address',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				A2(
					$elm$json$Json$Decode$field,
					'date',
					$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2(
						$elm$json$Json$Decode$field,
						'subject',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					$elm$json$Json$Decode$succeed($author$project$Domain$FactorInvoice$DocumentBatchEmailDetails))))));
var $author$project$Domain$FactorInvoice$defaultTo = F2(
	function (_default, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					decoder,
					$elm$json$Json$Decode$succeed(_default)
				]));
	});
var $author$project$Domain$FactorInvoice$FailureMessage = F4(
	function (raw, internal, unskippable, formattedMessage) {
		return {formattedMessage: formattedMessage, internal: internal, raw: raw, unskippable: unskippable};
	});
var $author$project$Domain$FactorInvoice$failureMessage = function (formattedMessage) {
	return A5(
		$elm$json$Json$Decode$map4,
		$author$project$Domain$FactorInvoice$FailureMessage,
		$elm$json$Json$Decode$value,
		A2($elm$json$Json$Decode$field, 'internal_failure', $elm$json$Json$Decode$bool),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['data', 'unskippable']),
					$elm$json$Json$Decode$bool),
					$elm$json$Json$Decode$succeed(false)
				])),
		$elm$json$Json$Decode$succeed(formattedMessage));
};
var $author$project$Domain$FactorInvoice$formattedFailureMessages = $elm$json$Json$Decode$list(
	A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeL,
			$elm$json$Json$Decode$field('raw'),
			$author$project$Domain$FactorInvoice$failureMessage),
		A2($elm$json$Json$Decode$field, 'formatted', $elm$json$Json$Decode$string)));
var $author$project$Domain$FactorInvoiceSubmissionId$FactorInvoiceSubmissionId = function (a) {
	return {$: 'FactorInvoiceSubmissionId', a: a};
};
var $author$project$Domain$FactorInvoiceSubmissionId$fromInt = function (_int) {
	return $author$project$Domain$FactorInvoiceSubmissionId$FactorInvoiceSubmissionId(_int);
};
var $author$project$Domain$FactorInvoice$safeList = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$maybe(decoder)));
};
var $author$project$Domain$FactorInvoice$decodeStateFromMaybe = function (maybeState) {
	if (maybeState.$ === 'Just') {
		var state_ = maybeState.a;
		return $elm$json$Json$Decode$succeed(state_);
	} else {
		return $elm$json$Json$Decode$fail('Could not parse state for FactorInvoice');
	}
};
var $author$project$Domain$FactorInvoice$Abandoned = {$: 'Abandoned'};
var $author$project$Domain$FactorInvoice$Approved = {$: 'Approved'};
var $author$project$Domain$FactorInvoice$Draft = {$: 'Draft'};
var $author$project$Domain$FactorInvoice$Exception = {$: 'Exception'};
var $author$project$Domain$FactorInvoice$Processed = {$: 'Processed'};
var $author$project$Domain$FactorInvoice$Purchased = {$: 'Purchased'};
var $author$project$Domain$FactorInvoice$Verified = {$: 'Verified'};
var $author$project$Domain$FactorInvoice$VerifyCompleted = {$: 'VerifyCompleted'};
var $author$project$Domain$FactorInvoice$Verifying = {$: 'Verifying'};
var $elm$core$String$toLower = _String_toLower;
var $elm$core$String$trim = _String_trim;
var $author$project$Domain$FactorInvoice$stateFromString = function (string) {
	var _v0 = $elm$core$String$toLower(
		$elm$core$String$trim(string));
	switch (_v0) {
		case 'draft':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Draft);
		case 'exception':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Exception);
		case 'abandoned':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Abandoned);
		case 'processed':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Processed);
		case 'verifying':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Verifying);
		case 'verify_completed':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$VerifyCompleted);
		case 'approved':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Approved);
		case 'verified':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Verified);
		case 'purchased':
			return $elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Purchased);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Domain$FactorInvoice$state = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Domain$FactorInvoice$decodeStateFromMaybe,
	A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoice$stateFromString, $elm$json$Json$Decode$string));
var $author$project$Domain$FactorInvoice$decode = A2(
	$author$project$Helpers$Json$Decode$apply,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string)),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'carrier_amount', $elm$json$Json$Decode$string)),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2(
				$elm$json$Json$Decode$field,
				'notes',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				A2(
					$elm$json$Json$Decode$field,
					'destination',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2(
						$elm$json$Json$Decode$field,
						'origin',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$author$project$Helpers$Json$Decode$apply,
						A2(
							$author$project$Domain$FactorInvoice$defaultTo,
							false,
							A2($elm$json$Json$Decode$field, 'fuel_advance', $elm$json$Json$Decode$bool)),
						A2(
							$author$project$Helpers$Json$Decode$apply,
							A2(
								$author$project$Domain$FactorInvoice$defaultTo,
								false,
								A2($elm$json$Json$Decode$field, 'must_verify', $elm$json$Json$Decode$bool)),
							A2(
								$author$project$Helpers$Json$Decode$apply,
								A2($elm$json$Json$Decode$field, 'document_batch_email_details', $author$project$Domain$FactorInvoice$decodeDocumentBatchEmailDetails),
								A2(
									$author$project$Helpers$Json$Decode$apply,
									$elm$json$Json$Decode$maybe(
										A2($elm$json$Json$Decode$field, 'client_debtor_noa_relationship', $author$project$Domain$FactorInvoice$clientdebtorNoaRelationship)),
									A2(
										$author$project$Helpers$Json$Decode$apply,
										$elm$json$Json$Decode$maybe(
											A2($elm$json$Json$Decode$field, 'payments_network_external_load_id', $elm$json$Json$Decode$string)),
										A2(
											$author$project$Helpers$Json$Decode$apply,
											A2(
												$author$project$Domain$FactorInvoice$defaultTo,
												_List_Nil,
												A2(
													$elm$json$Json$Decode$field,
													'document_ids',
													$elm$json$Json$Decode$list($author$project$Domain$DocumentId$decode))),
											A2(
												$author$project$Helpers$Json$Decode$apply,
												A2(
													$author$project$Domain$FactorInvoice$defaultTo,
													_List_Nil,
													A2(
														$elm$json$Json$Decode$field,
														'activity_items',
														$author$project$Domain$FactorInvoice$safeList($author$project$Domain$ActivityItem$decode))),
												A2(
													$author$project$Helpers$Json$Decode$apply,
													$elm$json$Json$Decode$maybe(
														A2($elm$json$Json$Decode$field, 'submission_reviewed_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
													A2(
														$author$project$Helpers$Json$Decode$apply,
														$elm$json$Json$Decode$maybe(
															A2($elm$json$Json$Decode$field, 'transmission_state', $elm$json$Json$Decode$string)),
														A2(
															$author$project$Helpers$Json$Decode$apply,
															$elm$json$Json$Decode$maybe(
																A2(
																	$elm$json$Json$Decode$field,
																	'transmission_id',
																	A2($elm$json$Json$Decode$map, $author$project$Domain$TransmissionId$fromInt, $elm$json$Json$Decode$int))),
															A2(
																$author$project$Helpers$Json$Decode$apply,
																A2(
																	$elm$json$Json$Decode$field,
																	'labels',
																	$elm$json$Json$Decode$list(
																		$elm$json$Json$Decode$oneOf(
																			_List_fromArray(
																				[
																					$elm$json$Json$Decode$string,
																					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)
																				])))),
																A2(
																	$author$project$Helpers$Json$Decode$apply,
																	A2($elm$json$Json$Decode$field, 'state', $author$project$Domain$FactorInvoice$state),
																	A2(
																		$author$project$Helpers$Json$Decode$apply,
																		A2(
																			$author$project$Domain$FactorInvoice$defaultTo,
																			false,
																			A2($elm$json$Json$Decode$field, 'tonu', $elm$json$Json$Decode$bool)),
																		A2(
																			$author$project$Helpers$Json$Decode$apply,
																			A2(
																				$author$project$Domain$FactorInvoice$defaultTo,
																				false,
																				A2($elm$json$Json$Decode$field, 'load_id_pattern_mismatch', $elm$json$Json$Decode$bool)),
																			A2(
																				$author$project$Helpers$Json$Decode$apply,
																				A2(
																					$author$project$Domain$FactorInvoice$defaultTo,
																					false,
																					A2($elm$json$Json$Decode$field, 'pickup_dropoff_matches', $elm$json$Json$Decode$bool)),
																				A2(
																					$author$project$Helpers$Json$Decode$apply,
																					A2(
																						$author$project$Domain$FactorInvoice$defaultTo,
																						false,
																						A2($elm$json$Json$Decode$field, 'third_party_listed_on_bol', $elm$json$Json$Decode$bool)),
																					A2(
																						$author$project$Helpers$Json$Decode$apply,
																						A2(
																							$author$project$Domain$FactorInvoice$defaultTo,
																							false,
																							A2($elm$json$Json$Decode$field, 'amount_matches_rate_con', $elm$json$Json$Decode$bool)),
																						A2(
																							$author$project$Helpers$Json$Decode$apply,
																							A2(
																								$author$project$Domain$FactorInvoice$defaultTo,
																								false,
																								A2($elm$json$Json$Decode$field, 'client_on_rate_con', $elm$json$Json$Decode$bool)),
																							A2(
																								$author$project$Helpers$Json$Decode$apply,
																								A2(
																									$author$project$Domain$FactorInvoice$defaultTo,
																									false,
																									A2($elm$json$Json$Decode$field, 'client_or_debtor_on_bol', $elm$json$Json$Decode$bool)),
																								A2(
																									$author$project$Helpers$Json$Decode$apply,
																									A2(
																										$author$project$Domain$FactorInvoice$defaultTo,
																										_List_Nil,
																										A2(
																											$elm$json$Json$Decode$field,
																											'ignored_rules',
																											$elm$json$Json$Decode$list(
																												$author$project$Domain$FactorInvoice$failureMessage('')))),
																									A2(
																										$author$project$Helpers$Json$Decode$apply,
																										A2(
																											$author$project$Domain$FactorInvoice$defaultTo,
																											_List_Nil,
																											A2($elm$json$Json$Decode$field, 'formatted_failure_messages', $author$project$Domain$FactorInvoice$formattedFailureMessages)),
																										A2(
																											$author$project$Helpers$Json$Decode$apply,
																											$elm$json$Json$Decode$maybe(
																												A2($elm$json$Json$Decode$field, 'processed_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
																											A2(
																												$author$project$Helpers$Json$Decode$apply,
																												$elm$json$Json$Decode$maybe(
																													A2($elm$json$Json$Decode$field, 'source_invoice_date', $author$project$Helpers$Json$Decode$date)),
																												A2(
																													$author$project$Helpers$Json$Decode$apply,
																													A2($elm$json$Json$Decode$field, 'updated_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																													A2(
																														$author$project$Helpers$Json$Decode$apply,
																														A2($elm$json$Json$Decode$field, 'created_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																														A2(
																															$author$project$Helpers$Json$Decode$apply,
																															A2($elm$json$Json$Decode$field, 'received_at', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																															A2(
																																$author$project$Helpers$Json$Decode$apply,
																																$elm$json$Json$Decode$maybe(
																																	A2($elm$json$Json$Decode$field, 'formatted_source_invoice_amount', $elm$json$Json$Decode$string)),
																																A2(
																																	$author$project$Helpers$Json$Decode$apply,
																																	$elm$json$Json$Decode$maybe(
																																		A2($elm$json$Json$Decode$field, 'source_invoice_amount', $elm$json$Json$Decode$string)),
																																	A2(
																																		$author$project$Helpers$Json$Decode$apply,
																																		$elm$json$Json$Decode$maybe(
																																			A2($elm$json$Json$Decode$field, 'source_invoice_number', $elm$json$Json$Decode$string)),
																																		A2(
																																			$author$project$Helpers$Json$Decode$apply,
																																			$elm$json$Json$Decode$maybe(
																																				A2($elm$json$Json$Decode$field, 'load_id', $elm$json$Json$Decode$string)),
																																			A2(
																																				$author$project$Helpers$Json$Decode$apply,
																																				$elm$json$Json$Decode$maybe(
																																					A2(
																																						$elm$json$Json$Decode$field,
																																						'factor_client_invoice_submission_id',
																																						A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceSubmissionId$fromInt, $elm$json$Json$Decode$int))),
																																				A2(
																																					$author$project$Helpers$Json$Decode$apply,
																																					A2(
																																						$elm$json$Json$Decode$field,
																																						'factor_broker_id',
																																						$elm$json$Json$Decode$maybe(
																																							A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $elm$json$Json$Decode$int))),
																																					A2(
																																						$author$project$Helpers$Json$Decode$apply,
																																						A2(
																																							$elm$json$Json$Decode$field,
																																							'carrier_id',
																																							$elm$json$Json$Decode$maybe(
																																								A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $elm$json$Json$Decode$int))),
																																						A2(
																																							$author$project$Helpers$Json$Decode$apply,
																																							A2(
																																								$elm$json$Json$Decode$field,
																																								'id',
																																								A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $elm$json$Json$Decode$int)),
																																							$elm$json$Json$Decode$succeed($author$project$Domain$FactorInvoice$FactorInvoice))))))))))))))))))))))))))))))))))))))));
var $author$project$Forward$AppSpecific$Cache$factorInvoice = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.factorInvoice;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{factorInvoice: e});
		}));
var $author$project$Domain$FactorInvoiceId$toInt = $author$project$Id$toInt;
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$factorInvoice,
		decoder: $author$project$Domain$FactorInvoice$decode,
		entrypoint: 'factorInvoices',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$maybe_factorInvoiceId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_factorInvoiceId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_factorInvoiceId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$firstUnreviewedSubmissionWorkflowFactorInvoice = $author$project$Forward$Lookup$defineReferenceMaybe(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_factorInvoiceId,
		decoder: $author$project$Domain$FactorInvoiceId$decode,
		entrypoint: 'firstUnreviewedSubmissionWorkflowFactorInvoice',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$firstUnreviewedIdOnly = function (emailId) {
	return A2(
		$author$project$Forward$Lookup$map,
		$elm$core$Maybe$map(
			function ($) {
				return $.id;
			}),
		A2($author$project$Forward$Lookup$startFrom, emailId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$firstUnreviewedSubmissionWorkflowFactorInvoice));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2,
		fieldName: 'documentBatch',
		getId: function ($) {
			return $.documentBatchId;
		}
	});
var $author$project$Factoring$Page$ClientSubmission$getDocumentBatch = function (emailId) {
	return A2(
		$author$project$Forward$Lookup$startFrom,
		emailId,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage));
};
var $author$project$Forward$AppSpecific$Cache$list_factorInvoiceId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_factorInvoiceId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_factorInvoiceId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceIdsByEmailMessageId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_factorInvoiceId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$FactorInvoiceId$decode),
		entrypoint: 'factorInvoiceIdsByEmailMessageId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$getInvoiceIndexInList = F2(
	function (invoiceId, invoiceIdList) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var factorInvoiceId = _v0.b;
						return _Utils_eq(invoiceId, factorInvoiceId);
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, invoiceIdList))));
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$maybeGetInvoiceIndexInList = F2(
	function (maybeFirstUnreviewedInvoiceId, factorInvoiceIdList) {
		if (maybeFirstUnreviewedInvoiceId.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var invoiceId = maybeFirstUnreviewedInvoiceId.a;
			return A2($author$project$Factoring$Page$ClientSubmission$CacheData$getInvoiceIndexInList, invoiceId, factorInvoiceIdList);
		}
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$getFirstUnreviewedGroupNumber = function (emailId) {
	return A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$startFrom, emailId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceIdsByEmailMessageId),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Factoring$Page$ClientSubmission$CacheData$firstUnreviewedIdOnly(emailId),
			$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$ClientSubmission$CacheData$maybeGetInvoiceIndexInList)));
};
var $author$project$Factoring$Page$ClientSubmission$CacheData$getInvoiceIdAtIndex = F2(
	function (maybeGroup, factorInvoiceIdList) {
		if (maybeGroup.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var group = maybeGroup.a;
			return (_Utils_cmp(
				group,
				$elm$core$List$length(factorInvoiceIdList)) > -1) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$List$take, group + 1, factorInvoiceIdList)));
		}
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$getInvoiceIdForGroupNumber = F2(
	function (groupNumber, emailId) {
		return A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$startFrom, emailId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceIdsByEmailMessageId),
			$author$project$Forward$Lookup$succeed(
				$author$project$Factoring$Page$ClientSubmission$CacheData$getInvoiceIdAtIndex(groupNumber)));
	});
var $author$project$Factoring$Page$ClientSubmission$loadFirstInvoice = F2(
	function (emailId, group) {
		return A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Factoring$Page$ClientSubmission$getDocumentBatch(emailId),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Factoring$Page$ClientSubmission$CacheData$firstUnreviewedIdOnly(emailId),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Factoring$Page$ClientSubmission$CacheData$getFirstUnreviewedGroupNumber(emailId),
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Factoring$Page$ClientSubmission$CacheData$getInvoiceIdForGroupNumber, group, emailId),
						$author$project$Forward$Lookup$succeed(
							$author$project$Factoring$Page$ClientSubmission$decidePage(group))))));
	});
var $author$project$Factoring$Page$ClientSubmission$init = F4(
	function (emailId, group, dismissFundingNotes, onDoneQuery) {
		return _Utils_Tuple2(
			{dismissFundingNotes: dismissFundingNotes, emailId: emailId, group: group, loadingError: $elm$core$Maybe$Nothing, onDone: onDoneQuery},
			A2(
				$author$project$HubTran$Effect$fetchFromCache,
				$author$project$Factoring$Page$ClientSubmission$InitialDataLoaded,
				A2($author$project$Factoring$Page$ClientSubmission$loadFirstInvoice, emailId, group)));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$CarrierIdentified = function (a) {
	return {$: 'CarrierIdentified', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$DebtorIdentified = function (a) {
	return {$: 'DebtorIdentified', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$OriginalSelectionLoaded = function (a) {
	return {$: 'OriginalSelectionLoaded', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$OriginalSubmissionLoaded = function (a) {
	return {$: 'OriginalSubmissionLoaded', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$Other = function (a) {
	return {$: 'Other', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (maybeValue.$ === 'Just') {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Forward$AppSpecific$Cache$submissionDropdownData = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.submissionDropdownData;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{submissionDropdownData: e});
		}));
var $author$project$AuditPb$SubmissionDropdownData = F3(
	function (submissionId, debtorName, loadId) {
		return {debtorName: debtorName, loadId: loadId, submissionId: submissionId};
	});
var $author$project$AuditPb$submissionDropdownDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'load_id',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'debtor_name',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'submission_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceSubmissionId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$SubmissionDropdownData))));
	});
var $author$project$Domain$FactorInvoiceSubmissionId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionDropdownDataByFactorInvoiceSubmissionId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$submissionDropdownData,
		decoder: $elm$json$Json$Decode$nullable($author$project$AuditPb$submissionDropdownDataDecoder),
		entrypoint: 'submissionDropdownDataByFactorInvoiceSubmissionId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceSubmissionId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToSubmissionDropdownData = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionDropdownDataByFactorInvoiceSubmissionId,
		fieldName: 'submissionDropdownDataByFactorInvoiceSubmissionId',
		getId: function ($) {
			return $.factorInvoiceSubmissionId;
		}
	});
var $author$project$Indexer$Group$getAt = F2(
	function (index, list) {
		return $elm$core$List$head(
			A2($elm$core$List$drop, index, list));
	});
var $author$project$Indexer$Group$getList = function (index) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Indexer$Group$getAt(index),
		$elm$core$Maybe$withDefault(_List_Nil));
};
var $author$project$Indexer$Group$getDocumentsInGroup = F2(
	function (grouped, selection) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.document;
			},
			A2($author$project$Indexer$Group$getList, selection.group, grouped));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$getDocumentsInGroup = F2(
	function (selection, groupedDocuments) {
		return A2($author$project$Indexer$Group$getDocumentsInGroup, groupedDocuments, selection);
	});
var $author$project$Indexer$Group$Selection = F4(
	function (group, document, page, lines) {
		return {document: document, group: group, lines: lines, page: page};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$unknownSelections = F2(
	function (currentGroup, documentTypes) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (documentType, _v0) {
					var currentIndex = _v0.a;
					var unknownSelections_ = _v0.b;
					return _Utils_eq(documentType, $author$project$Domain$UnresolvedDocumentType$Unknown) ? _Utils_Tuple2(
						currentIndex + 1,
						A2(
							$elm$core$List$append,
							unknownSelections_,
							_List_fromArray(
								[
									A4($author$project$Indexer$Group$Selection, currentGroup, currentIndex, 0, _List_Nil)
								]))) : _Utils_Tuple2(currentIndex + 1, unknownSelections_);
				}),
			_Utils_Tuple2(0, _List_Nil),
			documentTypes).b;
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$firstPageOf = F2(
	function (pageData, group) {
		var firstSelection = {document: 0, group: group, lines: _List_Nil, page: 0};
		var document = A2(
			$elm$core$Maybe$withDefault,
			firstSelection,
			$elm$core$List$head(
				A2(
					$author$project$Factoring$Page$ClientSubmissionInvoice$unknownSelections,
					group,
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Domain$Document$documentTypeValueToUnresolved,
							function ($) {
								return $.documentTypeValue;
							}),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.groupedDocuments;
									},
									$author$project$Factoring$Page$ClientSubmissionInvoice$getDocumentsInGroup(firstSelection)),
								$author$project$Forward$Remote$toMaybe(pageData.documentPagesData))))))).document;
		return _Utils_update(
			firstSelection,
			{document: document, group: group});
	});
var $author$project$Indexer$Group$firstSelection = {document: 0, group: 0, lines: _List_Nil, page: 0};
var $jinjor$elm_debounce$Debounce$Debounce = function (a) {
	return {$: 'Debounce', a: a};
};
var $jinjor$elm_debounce$Debounce$init = $jinjor$elm_debounce$Debounce$Debounce(
	{input: _List_Nil, locked: false});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$init = {errorMessage: $elm$core$Maybe$Nothing, isSaving: false};
var $author$project$Indexer$DocumentBrowser$Collapsed = {$: 'Collapsed'};
var $author$project$Indexer$DocumentBrowser$Document = {$: 'Document'};
var $author$project$Indexer$DocumentBrowser$LabelEditor = F2(
	function (selected, saving) {
		return {saving: saving, selected: selected};
	});
var $author$project$Indexer$DocumentBrowser$init = F2(
	function (emailMessageId, idPrefix) {
		return {
			activeTab: $author$project$Indexer$DocumentBrowser$Document,
			emailMessageId: emailMessageId,
			idPrefix: idPrefix,
			isUpdatingGroups: false,
			labelEditor: A2($author$project$Indexer$DocumentBrowser$LabelEditor, 0, $elm$core$Set$empty),
			size: $author$project$Indexer$DocumentBrowser$Collapsed
		};
	});
var $author$project$Components$DebtorWithAddressTypeahead$initClosed = $author$project$Typeahead$initClosed;
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$submissionToItem = function (submission) {
	var debtorName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(' from '),
			submission.debtorName));
	var labelText = _Utils_ap(submission.loadId, debtorName);
	return {
		id: $elm$core$String$fromInt(
			$author$project$Domain$FactorInvoiceSubmissionId$toInt(submission.submissionId)),
		label: $elm$html$Html$text(labelText),
		text: labelText
	};
};
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$init = F3(
	function (emailMessageId, defaultSelectedSubmission, submissions) {
		var items = A2($elm$core$List$map, $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$submissionToItem, submissions);
		var defaultSelectedItem = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2($elm$core$Maybe$map, $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$submissionToItem, defaultSelectedSubmission)));
		var _v0 = $author$project$Components$PaginatedDropdown$init(
			{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$CustomSelect$filterable(true),
						$author$project$Ui$V3$CustomSelect$autoFilter(true),
						$author$project$Ui$V3$CustomSelect$hideSelectAll(true),
						$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
						$author$project$Ui$V3$CustomSelect$placeholderOptionAt(2)
					]),
				domId: 'submission',
				lastItems: _List_Nil,
				otherItems: items,
				selectedItems: defaultSelectedItem
			});
		var dropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{dropdown: dropdown, emailMessageId: emailMessageId},
			cmd);
	});
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$initClosed = function (emailMessageId) {
	return A3($author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$init, emailMessageId, $elm$core$Maybe$Nothing, _List_Nil).a;
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$initMoveDocumentsModal = {isPerforming: false, isShown: false, succeeded: false, text: 'This will move all images in this group to the selected load, are you sure you want to do this?'};
var $author$project$Presence$State = F2(
	function (path, others) {
		return {others: others, path: path};
	});
var $author$project$Presence$on = function (path) {
	return A2($author$project$Presence$State, path, _List_Nil);
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix = '';
var $author$project$Path$submission = function (emailId) {
	var idString = $elm$core$String$fromInt(
		$author$project$Domain$EmailMessageId$toInt(emailId));
	return $author$project$Path$base(
		_List_fromArray(
			['app', 'client_submission', 'email', idString]));
};
var $author$project$Path$submissionInvoice = F2(
	function (emailId, invoiceId) {
		return A2(
			$author$project$Path$appendToBase,
			_List_fromArray(
				[
					'invoice',
					$elm$core$String$fromInt(
					$author$project$Domain$FactorInvoiceId$toInt(invoiceId))
				]),
			$author$project$Path$submission(emailId));
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$MissingInvoice = {$: 'MissingInvoice'};
var $author$project$Factoring$Page$ClientSubmission$CacheData$missingInvoiceError = $elm$core$Result$Err($author$project$Factoring$Page$ClientSubmission$CacheData$MissingInvoice);
var $author$project$Factoring$Page$ClientSubmission$CacheData$assembleSubmissionResult = F2(
	function (maybeSubmission, maybeGroupNumber) {
		var _v0 = _Utils_Tuple2(maybeSubmission, maybeGroupNumber);
		if (_v0.a.$ === 'Nothing') {
			var _v2 = _v0.a;
			return $author$project$Factoring$Page$ClientSubmission$CacheData$missingInvoiceError;
		} else {
			if (_v0.a.a.$ === 'Ok') {
				if (_v0.b.$ === 'Just') {
					var singleSubmission = _v0.a.a.a;
					var groupNumber = _v0.b.a;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(groupNumber, singleSubmission));
				} else {
					var _v1 = _v0.b;
					return $author$project$Factoring$Page$ClientSubmission$CacheData$missingInvoiceError;
				}
			} else {
				var x = _v0.a.a.a;
				return $elm$core$Result$Err(x);
			}
		}
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$getRequestedInvoiceGroupNumber = F2(
	function (invoiceId, emailId) {
		return A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$startFrom, emailId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceIdsByEmailMessageId),
			$author$project$Forward$Lookup$succeed(
				$author$project$Factoring$Page$ClientSubmission$CacheData$getInvoiceIndexInList(invoiceId)));
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$blankSubmission = F2(
	function (carrier, invoice) {
		return {amount: '', auditClientInvoiceDocument: true, carrier: carrier, correspondents: _List_Nil, debtor: $elm$core$Maybe$Nothing, debtorAddress: $elm$core$Maybe$Nothing, invoice: invoice, invoiceDate: $elm$core$Maybe$Nothing, loadId: '', manualDebtorName: '', number: ''};
	});
var $author$project$Forward$Lookup$defineEdge = function (config) {
	var _v0 = config.entrypoint;
	var nested = _v0.a;
	return $author$project$Forward$Internal$GraphTree$isNoBranches(nested.preloadBranches) ? $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: nested.decoderConfig,
			invalidate: function (from) {
				return nested.invalidate(
					config.getId(from));
			},
			load: F3(
				function (cache, requiredTimestamp, parent) {
					return A3(
						nested.load,
						cache,
						requiredTimestamp,
						config.getId(parent));
				}),
			preloadBranches: $author$project$Forward$Internal$GraphTree$singleBranch(config.fieldName),
			structure: nested.structure
		}) : _Debug_todo(
		'Forward.Lookup',
		{
			start: {line: 396, column: 8},
			end: {line: 396, column: 18}
		})('XXX: You should only be passing a top-level graph entrypoint defined with Lookup.defineNode as the entrypoint to defineEdge.  (Advanced note: this could probably be implemented, but would need to be considered carefully to fully handle all edge cases; and it\u0027s probably not something we want to allow anyway.)');
};
var $author$project$Forward$AppSpecific$Cache$maybe_address = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_address;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_address: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerPaymentAddress = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_address,
		decoder: $elm$json$Json$Decode$maybe($author$project$Domain$Address$decode),
		entrypoint: 'factorBrokerPaymentAddress',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorBrokerId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerToPaymentAddress = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerPaymentAddress,
		fieldName: 'paymentAddress',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Forward$AppSpecific$Cache$factorBroker = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.factorBroker;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{factorBroker: e});
		}));
var $author$project$AuditPb$FactorBroker = function (id) {
	return function (name) {
		return function (mcNumber) {
			return function (dotNumber) {
				return function (commonAliases) {
					return function (contactInfo) {
						return function (cadenceDebtorDetails) {
							return function (emailDomainsToValidate) {
								return function (billingContact) {
									return function (warning) {
										return function (notes) {
											return function (noBuy) {
												return function (createdAt) {
													return function (updatedAt) {
														return function (verificationsType) {
															return {billingContact: billingContact, cadenceDebtorDetails: cadenceDebtorDetails, commonAliases: commonAliases, contactInfo: contactInfo, createdAt: createdAt, dotNumber: dotNumber, emailDomainsToValidate: emailDomainsToValidate, id: id, mcNumber: mcNumber, name: name, noBuy: noBuy, notes: notes, updatedAt: updatedAt, verificationsType: verificationsType, warning: warning};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$FactorBrokerVerificationTypeScraper = {$: 'FactorBrokerVerificationTypeScraper'};
var $author$project$AuditPb$factorBrokerVerificationTypeDefault = $author$project$AuditPb$FactorBrokerVerificationTypeScraper;
var $author$project$AuditPb$FactorBrokerVerificationTypeHubtranCustomer = {$: 'FactorBrokerVerificationTypeHubtranCustomer'};
var $author$project$AuditPb$FactorBrokerVerificationTypeHubtranMultiAccountCustomer = {$: 'FactorBrokerVerificationTypeHubtranMultiAccountCustomer'};
var $author$project$AuditPb$FactorBrokerVerificationTypeOnDemandScraper = {$: 'FactorBrokerVerificationTypeOnDemandScraper'};
var $author$project$AuditPb$FactorBrokerVerificationTypePaymentsNetworkCustomer = {$: 'FactorBrokerVerificationTypePaymentsNetworkCustomer'};
var $author$project$AuditPb$allFactorBrokerVerificationType = _List_fromArray(
	[$author$project$AuditPb$FactorBrokerVerificationTypeScraper, $author$project$AuditPb$FactorBrokerVerificationTypeHubtranCustomer, $author$project$AuditPb$FactorBrokerVerificationTypeHubtranMultiAccountCustomer, $author$project$AuditPb$FactorBrokerVerificationTypePaymentsNetworkCustomer, $author$project$AuditPb$FactorBrokerVerificationTypeOnDemandScraper]);
var $author$project$AuditPb$factorBrokerVerificationTypeToString = function (v) {
	switch (v.$) {
		case 'FactorBrokerVerificationTypeScraper':
			return 'Scraper';
		case 'FactorBrokerVerificationTypeHubtranCustomer':
			return 'HubtranCustomer';
		case 'FactorBrokerVerificationTypeHubtranMultiAccountCustomer':
			return 'HubtranMultiAccountCustomer';
		case 'FactorBrokerVerificationTypePaymentsNetworkCustomer':
			return 'PaymentsNetworkCustomer';
		default:
			return 'OnDemandScraper';
	}
};
var $author$project$AuditPb$factorBrokerVerificationTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$factorBrokerVerificationTypeToString(v),
				v);
		},
		$author$project$AuditPb$allFactorBrokerVerificationType));
var $author$project$AuditPb$factorBrokerVerificationTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$factorBrokerVerificationTypeDict);
};
var $author$project$AuditPb$factorBrokerVerificationTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$factorBrokerVerificationTypeDefault),
		$author$project$AuditPb$factorBrokerVerificationTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$FactorBroker_BillingContact = function (email) {
	return {email: email};
};
var $author$project$AuditPb$factorBroker_BillingContactDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'email',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorBroker_BillingContact));
	});
var $author$project$AuditPb$FactorBroker_CadenceDebtorDetails = F5(
	function (email, phone1, phone2, dotNumber, mcNumber) {
		return {dotNumber: dotNumber, email: email, mcNumber: mcNumber, phone1: phone1, phone2: phone2};
	});
var $author$project$AuditPb$factorBroker_CadenceDebtorDetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'mc_number',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'dot_number',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'phone_2',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'phone_1',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'email',
							$elm$json$Json$Decode$string,
							$author$project$AuditPb$decode($author$project$AuditPb$FactorBroker_CadenceDebtorDetails))))));
	});
var $author$project$AuditPb$factorBrokerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'verifications_type',
			$author$project$AuditPb$factorBrokerVerificationTypeDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'updated_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'created_at',
					$author$project$AuditPb$timestampDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'no_buy',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'notes',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'warning',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$optionalMessage,
									'billing_contact',
									$author$project$AuditPb$factorBroker_BillingContactDecoder,
									A3(
										$author$project$AuditPb$repeated,
										'email_domains_to_validate',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'cadence_debtor_details',
											$author$project$AuditPb$factorBroker_CadenceDebtorDetailsDecoder,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'contact_info',
												$elm$json$Json$Decode$string,
												A3(
													$author$project$AuditPb$repeated,
													'common_aliases',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$AuditPb$optional,
														'dot_number',
														$elm$json$Json$Decode$string,
														A3(
															$author$project$AuditPb$optional,
															'mc_number',
															$elm$json$Json$Decode$string,
															A3(
																$author$project$AuditPb$requiredWithoutDefault,
																'name',
																$elm$json$Json$Decode$string,
																A3(
																	$author$project$AuditPb$requiredWithoutDefault,
																	'id',
																	A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $author$project$AuditPb$intDecoder),
																	$author$project$AuditPb$decode($author$project$AuditPb$FactorBroker))))))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$factorBroker,
		decoder: $author$project$AuditPb$factorBrokerDecoder,
		entrypoint: 'factorBrokerV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorBrokerId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmissionToFactorBroker = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker,
		fieldName: 'factorBroker',
		getId: function ($) {
			return $.factorBrokerId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmissionToTmsCarrier = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.tmsCarrierId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$factorInvoiceSubmission = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.factorInvoiceSubmission;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{factorInvoiceSubmission: e});
		}));
var $author$project$AuditPb$FactorInvoiceSubmission = function (id) {
	return function (tmsCarrierId) {
		return function (factorBrokerId) {
			return function (loadId) {
				return function (invoiceNumber) {
					return function (amount) {
						return function (formattedAmount) {
							return function (invoiceDate) {
								return function (manualDebtorName) {
									return function (auditClientInvoiceDocument) {
										return function (factorInvoiceId) {
											return {amount: amount, auditClientInvoiceDocument: auditClientInvoiceDocument, factorBrokerId: factorBrokerId, factorInvoiceId: factorInvoiceId, formattedAmount: formattedAmount, id: id, invoiceDate: invoiceDate, invoiceNumber: invoiceNumber, loadId: loadId, manualDebtorName: manualDebtorName, tmsCarrierId: tmsCarrierId};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$factorInvoiceSubmissionDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'factor_invoice_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'audit_client_invoice_document',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'manual_debtor_name',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'invoice_date',
						$author$project$AuditPb$timestampDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'formatted_amount',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'amount',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'invoice_number',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'load_id',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$optional,
											'factor_broker_id',
											A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $author$project$AuditPb$intDecoder),
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'tms_carrier_id',
												A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'id',
													A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceSubmissionId$fromInt, $author$project$AuditPb$intDecoder),
													$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceSubmission))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmission = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$factorInvoiceSubmission,
		decoder: $author$project$AuditPb$factorInvoiceSubmissionDecoder,
		entrypoint: 'factorInvoiceSubmissionsV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceSubmissionId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToSubmission = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmission,
		fieldName: 'factorInvoiceSubmission',
		getId: function ($) {
			return $.factorInvoiceSubmissionId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.tmsCarrierId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$list_documentPageId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_documentPageId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_documentPageId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$badQualityPagesByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentPageId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$DocumentPageId$decode),
		entrypoint: 'factorInvoiceBadQualityPages',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToBadQualityPages = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$badQualityPagesByFactorInvoiceId,
		fieldName: 'badQualityPages',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Domain$ExceptionEventId$ExceptionEventId = function (a) {
	return {$: 'ExceptionEventId', a: a};
};
var $author$project$Domain$ExceptionEventId$fromInt = function (_int) {
	return $author$project$Domain$ExceptionEventId$ExceptionEventId(_int);
};
var $author$project$Domain$ExceptionEventId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$ExceptionEventId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$exceptionEvent = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.exceptionEvent;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{exceptionEvent: e});
		}));
var $author$project$AuditPb$ExceptionEvent = F4(
	function (message, category, resolution, id) {
		return {category: category, id: id, message: message, resolution: resolution};
	});
var $author$project$AuditPb$ExceptionEventCategoryMissingPages = {$: 'ExceptionEventCategoryMissingPages'};
var $author$project$AuditPb$exceptionEventCategoryDefault = $author$project$AuditPb$ExceptionEventCategoryMissingPages;
var $author$project$AuditPb$ExceptionEventCategoryBadQuality = {$: 'ExceptionEventCategoryBadQuality'};
var $author$project$AuditPb$ExceptionEventCategoryCustomException = {$: 'ExceptionEventCategoryCustomException'};
var $author$project$AuditPb$ExceptionEventCategoryIllegible = {$: 'ExceptionEventCategoryIllegible'};
var $author$project$AuditPb$ExceptionEventCategoryNone = {$: 'ExceptionEventCategoryNone'};
var $author$project$AuditPb$allExceptionEventCategory = _List_fromArray(
	[$author$project$AuditPb$ExceptionEventCategoryMissingPages, $author$project$AuditPb$ExceptionEventCategoryBadQuality, $author$project$AuditPb$ExceptionEventCategoryCustomException, $author$project$AuditPb$ExceptionEventCategoryNone, $author$project$AuditPb$ExceptionEventCategoryIllegible]);
var $author$project$AuditPb$exceptionEventCategoryToString = function (v) {
	switch (v.$) {
		case 'ExceptionEventCategoryMissingPages':
			return 'MISSING_PAGES';
		case 'ExceptionEventCategoryBadQuality':
			return 'BAD_QUALITY';
		case 'ExceptionEventCategoryCustomException':
			return 'CUSTOM_EXCEPTION';
		case 'ExceptionEventCategoryNone':
			return '';
		default:
			return 'ILLEGIBLE';
	}
};
var $author$project$AuditPb$exceptionEventCategoryDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$exceptionEventCategoryToString(v),
				v);
		},
		$author$project$AuditPb$allExceptionEventCategory));
var $author$project$AuditPb$exceptionEventCategoryFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$exceptionEventCategoryDict);
};
var $author$project$AuditPb$exceptionEventCategoryDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$exceptionEventCategoryDefault),
		$author$project$AuditPb$exceptionEventCategoryFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$exceptionEventDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$ExceptionEventId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$optional,
				'resolution',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'category',
					$author$project$AuditPb$exceptionEventCategoryDecoder,
					A3(
						$author$project$AuditPb$optional,
						'message',
						$elm$json$Json$Decode$string,
						$author$project$AuditPb$decode($author$project$AuditPb$ExceptionEvent)))));
	});
var $author$project$Domain$ExceptionEventId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionEvent = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$exceptionEvent,
		decoder: $author$project$AuditPb$exceptionEventDecoder,
		entrypoint: 'exceptionEvent',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$ExceptionEventId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$list_exceptionEventId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_exceptionEventId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_exceptionEventId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceExceptionEvents = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_exceptionEventId,
		decoder: $author$project$Domain$ExceptionEventId$decode,
		entrypoint: 'factorInvoiceExceptionEvents',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionEvent,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToExceptionEvents = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceExceptionEvents,
		fieldName: 'exceptionEvents',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker,
		fieldName: 'factorBroker',
		getId: function ($) {
			return $.factorBrokerId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$list_unresolvedDocumentType = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_unresolvedDocumentType;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_unresolvedDocumentType: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$missingPagesByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_unresolvedDocumentType,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$UnresolvedDocumentType$decode),
		entrypoint: 'factorInvoiceMissingPages',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToMissingPages = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$missingPagesByFactorInvoiceId,
		fieldName: 'missingPages',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Forward$AppSpecific$Cache$maybe_verification = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_verification;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_verification: e});
		}));
var $author$project$AuditPb$Verification = function (state) {
	return {state: state};
};
var $author$project$AuditPb$Verification_State_Fail = function (a) {
	return {$: 'Verification_State_Fail', a: a};
};
var $author$project$AuditPb$Verification_State_NonParticipatingCarrier = function (a) {
	return {$: 'Verification_State_NonParticipatingCarrier', a: a};
};
var $author$project$AuditPb$Verification_State_Pending = function (a) {
	return {$: 'Verification_State_Pending', a: a};
};
var $author$project$AuditPb$Verification_State_Success = function (a) {
	return {$: 'Verification_State_Success', a: a};
};
var $author$project$AuditPb$Verification_State_UnconfirmedDelivery = function (a) {
	return {$: 'Verification_State_UnconfirmedDelivery', a: a};
};
var $author$project$AuditPb$Verification_State_UnverifiableLoad = function (a) {
	return {$: 'Verification_State_UnverifiableLoad', a: a};
};
var $author$project$AuditPb$Verification_Fail = F2(
	function (mode, failures) {
		return {failures: failures, mode: mode};
	});
var $author$project$AuditPb$VerificationFailure = F2(
	function (message, brokerAmount) {
		return {brokerAmount: brokerAmount, message: message};
	});
var $author$project$AuditPb$VerificationFailureMessageLoadIssueFailure = {$: 'VerificationFailureMessageLoadIssueFailure'};
var $author$project$AuditPb$verificationFailureMessageDefault = $author$project$AuditPb$VerificationFailureMessageLoadIssueFailure;
var $author$project$AuditPb$VerificationFailureMessageAmountMismatchFailure = {$: 'VerificationFailureMessageAmountMismatchFailure'};
var $author$project$AuditPb$VerificationFailureMessageCarrierMismatchFailure = {$: 'VerificationFailureMessageCarrierMismatchFailure'};
var $author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure = {$: 'VerificationFailureMessageLoadNotFoundFailure'};
var $author$project$AuditPb$VerificationFailureMessagePossibleFeesFailure = {$: 'VerificationFailureMessagePossibleFeesFailure'};
var $author$project$AuditPb$VerificationFailureMessageRemitToFailure = {$: 'VerificationFailureMessageRemitToFailure'};
var $author$project$AuditPb$VerificationFailureMessageUndeliveredFailure = {$: 'VerificationFailureMessageUndeliveredFailure'};
var $author$project$AuditPb$allVerificationFailureMessage = _List_fromArray(
	[$author$project$AuditPb$VerificationFailureMessageLoadIssueFailure, $author$project$AuditPb$VerificationFailureMessageAmountMismatchFailure, $author$project$AuditPb$VerificationFailureMessageUndeliveredFailure, $author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure, $author$project$AuditPb$VerificationFailureMessageCarrierMismatchFailure, $author$project$AuditPb$VerificationFailureMessagePossibleFeesFailure, $author$project$AuditPb$VerificationFailureMessageRemitToFailure]);
var $author$project$AuditPb$verificationFailureMessageToString = function (v) {
	switch (v.$) {
		case 'VerificationFailureMessageLoadIssueFailure':
			return 'load_issue_failure';
		case 'VerificationFailureMessageAmountMismatchFailure':
			return 'amount_mismatch_failure';
		case 'VerificationFailureMessageUndeliveredFailure':
			return 'undelivered_failue';
		case 'VerificationFailureMessageLoadNotFoundFailure':
			return 'load_not_found_failure';
		case 'VerificationFailureMessageCarrierMismatchFailure':
			return 'carrier_mismatch_failure';
		case 'VerificationFailureMessagePossibleFeesFailure':
			return 'possible_fees_failure';
		default:
			return 'remit_to_failure';
	}
};
var $author$project$AuditPb$verificationFailureMessageDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationFailureMessageToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationFailureMessage));
var $author$project$AuditPb$verificationFailureMessageFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationFailureMessageDict);
};
var $author$project$AuditPb$verificationFailureMessageDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationFailureMessageDefault),
		$author$project$AuditPb$verificationFailureMessageFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$verificationFailureDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'broker_amount',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'message',
				$author$project$AuditPb$verificationFailureMessageDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$VerificationFailure)));
	});
var $author$project$AuditPb$VerificationsModeFull = {$: 'VerificationsModeFull'};
var $author$project$AuditPb$verificationsModeDefault = $author$project$AuditPb$VerificationsModeFull;
var $author$project$AuditPb$VerificationsModeRestricted = {$: 'VerificationsModeRestricted'};
var $author$project$AuditPb$VerificationsModeTest = {$: 'VerificationsModeTest'};
var $author$project$AuditPb$allVerificationsMode = _List_fromArray(
	[$author$project$AuditPb$VerificationsModeFull, $author$project$AuditPb$VerificationsModeTest, $author$project$AuditPb$VerificationsModeRestricted]);
var $author$project$AuditPb$verificationsModeToString = function (v) {
	switch (v.$) {
		case 'VerificationsModeFull':
			return 'full';
		case 'VerificationsModeTest':
			return 'test';
		default:
			return 'restricted';
	}
};
var $author$project$AuditPb$verificationsModeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationsModeToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationsMode));
var $author$project$AuditPb$verificationsModeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationsModeDict);
};
var $author$project$AuditPb$verificationsModeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationsModeDefault),
		$author$project$AuditPb$verificationsModeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$verification_FailDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'failures',
			$author$project$AuditPb$verificationFailureDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'mode',
				$author$project$AuditPb$verificationsModeDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$Verification_Fail)));
	});
var $author$project$AuditPb$Verification_NonParticipatingCarrier = {};
var $author$project$AuditPb$verification_NonParticipatingCarrierDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Verification_NonParticipatingCarrier);
	});
var $author$project$AuditPb$Verification_Pending = {};
var $author$project$AuditPb$verification_PendingDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Verification_Pending);
	});
var $author$project$AuditPb$Verification_Success = {};
var $author$project$AuditPb$verification_SuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Verification_Success);
	});
var $author$project$AuditPb$Verification_UnconfirmedDelivery = {};
var $author$project$AuditPb$verification_UnconfirmedDeliveryDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Verification_UnconfirmedDelivery);
	});
var $author$project$AuditPb$Verification_UnverifiableLoad = {};
var $author$project$AuditPb$verification_UnverifiableLoadDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Verification_UnverifiableLoad);
	});
var $author$project$AuditPb$verification_StateDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Verification_State_Success,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$verification_SuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Verification_State_Pending,
					A2($elm$json$Json$Decode$field, 'pending', $author$project$AuditPb$verification_PendingDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Verification_State_NonParticipatingCarrier,
					A2($elm$json$Json$Decode$field, 'non_participating_carrier', $author$project$AuditPb$verification_NonParticipatingCarrierDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Verification_State_UnverifiableLoad,
					A2($elm$json$Json$Decode$field, 'unverifiable_load', $author$project$AuditPb$verification_UnverifiableLoadDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Verification_State_UnconfirmedDelivery,
					A2($elm$json$Json$Decode$field, 'unconfirmed_delivery', $author$project$AuditPb$verification_UnconfirmedDeliveryDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Verification_State_Fail,
					A2($elm$json$Json$Decode$field, 'fail', $author$project$AuditPb$verification_FailDecoder)),
					$elm$json$Json$Decode$fail('Verification_State_Unspecified')
				]));
	});
var $author$project$AuditPb$verificationDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$verification_StateDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$Verification));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_verification,
		decoder: $elm$json$Json$Decode$nullable($author$project$AuditPb$verificationDecoder),
		entrypoint: 'verificationV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToVerification = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationByFactorInvoiceId,
		fieldName: 'verification',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Domain$FactorInvoice$editable = function (invoiceState) {
	switch (invoiceState.$) {
		case 'Draft':
			return true;
		case 'Exception':
			return true;
		default:
			return false;
	}
};
var $author$project$Domain$FactorInvoice$readOnly = function (invoiceState) {
	return !$author$project$Domain$FactorInvoice$editable(invoiceState);
};
var $author$project$Domain$FactorInvoice$stateToString = function (invoiceState) {
	switch (invoiceState.$) {
		case 'Draft':
			return 'draft';
		case 'Exception':
			return 'exception';
		case 'Abandoned':
			return 'abandoned';
		case 'Processed':
			return 'processed';
		case 'Verifying':
			return 'verifying';
		case 'VerifyCompleted':
			return 'verify_completed';
		case 'Approved':
			return 'approved';
		case 'Verified':
			return 'verified';
		default:
			return 'purchased';
	}
};
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Enabled = {$: 'Enabled'};
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Ignored = {$: 'Ignored'};
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Required = {$: 'Required'};
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Skippable = function (a) {
	return {$: 'Skippable', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$toExceptionData = F2(
	function (ignored, failedRule) {
		return failedRule.unskippable ? $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Required : (A2($elm$core$List$member, failedRule.raw, ignored) ? $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Skippable(
			_Utils_Tuple2($author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Ignored, failedRule.raw)) : $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Skippable(
			_Utils_Tuple2($author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Enabled, failedRule.raw)));
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Resolvable = function (a) {
	return {$: 'Resolvable', a: a};
};
var $author$project$AuditPb$exceptionEventCategoryEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$exceptionEventCategoryToString);
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$toExceptionEventData = function (event) {
	var exceptionEventEncoder = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'message',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, event.message)),
				_Utils_Tuple2(
				'resolution',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, event.resolution)),
				_Utils_Tuple2(
				'category',
				$author$project$AuditPb$exceptionEventCategoryEncoder(event.category))
			]));
	var _v0 = event.category;
	if (_v0.$ === 'ExceptionEventCategoryCustomException') {
		var _v1 = event.resolution;
		if (_v1.$ === 'Nothing') {
			return $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Resolvable(
				_Utils_Tuple2($author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Enabled, exceptionEventEncoder));
		} else {
			return $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Resolvable(
				_Utils_Tuple2($author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Ignored, exceptionEventEncoder));
		}
	} else {
		return $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Required;
	}
};
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$toExceptions = F2(
	function (invoice, events) {
		var ignored = A2(
			$elm$core$List$map,
			function ($) {
				return $.raw;
			},
			invoice.ignoredRules);
		var fromFailedRule = function (fail) {
			return {
				data: A2($author$project$Factoring$Page$ClientSubmission$CacheData$Exception$toExceptionData, ignored, fail),
				formattedMessage: fail.formattedMessage,
				internal: fail.internal,
				possibleId: $elm$core$Maybe$Nothing,
				possibleResolutionMessage: $elm$core$Maybe$Nothing
			};
		};
		var fromEventMessage = function (event) {
			return {
				data: $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$toExceptionEventData(event),
				formattedMessage: A2($elm$core$Maybe$withDefault, 'No exception message provided', event.message),
				internal: false,
				possibleId: $elm$core$Maybe$Just(event.id),
				possibleResolutionMessage: event.resolution
			};
		};
		return _Utils_ap(
			A2($elm$core$List$map, fromEventMessage, events),
			A2($elm$core$List$map, fromFailedRule, invoice.failureMessages));
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$toInvoice = F7(
	function (factorInvoice, debtor, debtorAddress, verification, exceptionEvents, badQualityPages, missingPages) {
		return {
			activityItems: factorInvoice.activityItems,
			amount: A2($elm$core$Maybe$withDefault, '', factorInvoice.formattedAmount),
			amountMatchesRateCon: factorInvoice.amountMatchesRateCon,
			badQualityPages: badQualityPages,
			clientDebtorNoaRelationship: factorInvoice.clientDebtorNoaRelationship,
			clientOnRateCon: factorInvoice.clientOnRateCon,
			clientOrDebtorOnBol: factorInvoice.clientOrDebtorOnBol,
			debtor: debtor,
			debtorAddress: A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, debtorAddress),
			exceptions: A2($author$project$Factoring$Page$ClientSubmission$CacheData$Exception$toExceptions, factorInvoice, exceptionEvents),
			id: factorInvoice.id,
			invoiceDate: factorInvoice.invoiceDate,
			loadId: A2($elm$core$Maybe$withDefault, '', factorInvoice.loadId),
			loadIdPatternMismatch: factorInvoice.loadIdPatternMismatch,
			missingPages: missingPages,
			number: A2($elm$core$Maybe$withDefault, '', factorInvoice.invoiceNumber),
			paymentsNetworkExternalLoadId: factorInvoice.paymentsNetworkExternalLoadId,
			pickupDropoffMatches: factorInvoice.pickupDropoffMatches,
			readonly: $author$project$Domain$FactorInvoice$readOnly(factorInvoice.state),
			reviewedAt: factorInvoice.submissionReviewedAt,
			state: $author$project$Domain$FactorInvoice$stateToString(factorInvoice.state),
			thirdPartyListedOnBol: factorInvoice.thirdPartyListedOnBol,
			tonu: factorInvoice.tonu,
			transmissionId: factorInvoice.transmissionId,
			transmissionState: factorInvoice.transmissionState,
			verification: verification
		};
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$getInvoice = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToMissingPages,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToBadQualityPages,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToExceptionEvents,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToVerification,
				A2(
					$author$project$Forward$Lookup$apply,
					A2($author$project$Forward$Lookup$traverseMaybe, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerToPaymentAddress, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$identity,
							$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$ClientSubmission$CacheData$toInvoice))))))));
var $author$project$Factoring$Page$ClientSubmission$CacheData$MissingSubmissionAndClient = function (a) {
	return {$: 'MissingSubmissionAndClient', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$CacheData$missingSubmissionAndClientError = $elm$core$Result$Err(
	$author$project$Factoring$Page$ClientSubmission$CacheData$MissingSubmissionAndClient(
		{
			clientTerm: $author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount)
		}));
var $author$project$AuditPb$Correspondent = function (email) {
	return {email: email};
};
var $author$project$AuditPb$correspondentDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'email',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$Correspondent));
	});
var $author$project$Forward$AppSpecific$Cache$list_correspondent = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_correspondent;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_correspondent: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$correspondentsByTmsCarrierId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_correspondent,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$correspondentDecoder),
		entrypoint: 'correspondents',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsCarrierId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToCorrespondents = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$correspondentsByTmsCarrierId,
		fieldName: 'correspondents',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$toSubmission = F6(
	function (submission, debtor, debtorAddress, carrier, correspondents, invoice) {
		return {
			amount: submission.formattedAmount,
			auditClientInvoiceDocument: submission.auditClientInvoiceDocument,
			carrier: carrier,
			correspondents: correspondents,
			debtor: debtor,
			debtorAddress: A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, debtorAddress),
			invoice: invoice,
			invoiceDate: A2(
				$elm$core$Maybe$map,
				$justinmimbs$date$Date$fromPosix($elm$time$Time$utc),
				submission.invoiceDate),
			loadId: submission.loadId,
			manualDebtorName: submission.manualDebtorName,
			number: submission.invoiceNumber
		};
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$getSubmission = function () {
	var makeSubmission = F3(
		function (invoice, maybeSubmission, maybeCarrier) {
			var _v0 = _Utils_Tuple2(maybeSubmission, maybeCarrier);
			if (_v0.a.$ === 'Nothing') {
				if (_v0.b.$ === 'Nothing') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return $author$project$Factoring$Page$ClientSubmission$CacheData$missingSubmissionAndClientError;
				} else {
					var _v3 = _v0.a;
					var carrier = _v0.b.a;
					return $elm$core$Result$Ok(
						A2($author$project$Factoring$Page$ClientSubmission$CacheData$blankSubmission, carrier, invoice));
				}
			} else {
				var almostSubmission = _v0.a.a;
				return $elm$core$Result$Ok(
					almostSubmission(invoice));
			}
		});
	var loadSubmissionInfo = A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToCorrespondents, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmissionToTmsCarrier),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmissionToTmsCarrier,
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Forward$Lookup$traverseMaybe, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerToPaymentAddress, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmissionToFactorBroker),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmissionToFactorBroker,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$identity,
						$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$ClientSubmission$CacheData$toSubmission))))));
	var submissionInfo = A2($author$project$Forward$Lookup$traverseMaybe, loadSubmissionInfo, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToSubmission);
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier,
		A2(
			$author$project$Forward$Lookup$apply,
			submissionInfo,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Factoring$Page$ClientSubmission$CacheData$getInvoice,
				$author$project$Forward$Lookup$succeed(makeSubmission))));
}();
var $author$project$Indexer$EmailMessageData$PageData = F3(
	function (coreData, documentBatchData, documentPagesData) {
		return {coreData: coreData, documentBatchData: documentBatchData, documentPagesData: documentPagesData};
	});
var $author$project$Indexer$SharedModel$CoreInfo = F5(
	function (account, settings, emailMessage, documentIds, rejectMessage) {
		return {account: account, documentIds: documentIds, emailMessage: emailMessage, rejectMessage: rejectMessage, settings: settings};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentIdsByEmailMessageId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$DocumentId$decode),
		entrypoint: 'documentIdsByEmailMessageId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Forward$Lookup$fromRoot = function (_v0) {
	var nested = _v0.a;
	return $author$project$Forward$Internal$GraphTree$isNoBranches(nested.preloadBranches) ? $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: nested.decoderConfig,
			invalidate: function (_v1) {
				return nested.invalidate(_Utils_Tuple0);
			},
			load: F3(
				function (cache, requiredTimestamp, _v2) {
					return A3(nested.load, cache, requiredTimestamp, _Utils_Tuple0);
				}),
			preloadBranches: nested.preloadBranches,
			structure: nested.structure
		}) : _Debug_todo(
		'Forward.Lookup',
		{
			start: {line: 977, column: 8},
			end: {line: 977, column: 18}
		})('XXX: You should only be passing a top-level graph entrypoint defined with Lookup.defineNode to fromRoot.');
};
var $author$project$Forward$AppSpecific$Cache$maybe_sentMessage = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_sentMessage;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_sentMessage: e});
		}));
var $author$project$AuditPb$SentMessage = function (id) {
	return function (messageType) {
		return function (subject) {
			return function (textBody) {
				return function (createdAt) {
					return function (updatedAt) {
						return function (senderAddress) {
							return function (recipientAddress) {
								return function (rawTo) {
									return function (rawCc) {
										return {createdAt: createdAt, id: id, messageType: messageType, rawCc: rawCc, rawTo: rawTo, recipientAddress: recipientAddress, senderAddress: senderAddress, subject: subject, textBody: textBody, updatedAt: updatedAt};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$sentMessageDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'raw_cc',
			$author$project$AuditPb$emailAddressDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'raw_to',
				$author$project$AuditPb$emailAddressDecoder,
				A3(
					$author$project$AuditPb$optional,
					'recipient_address',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'sender_address',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'updated_at',
							$author$project$AuditPb$timestampDecoder,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'created_at',
								$author$project$AuditPb$timestampDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'text_body',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'subject',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$optional,
											'message_type',
											$author$project$AuditPb$emailMessageTypeDecoder,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'id',
												A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
												$author$project$AuditPb$decode($author$project$AuditPb$SentMessage)))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$rejectMessage = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_sentMessage,
		decoder: $elm$json$Json$Decode$maybe($author$project$AuditPb$sentMessageDecoder),
		entrypoint: 'rejectMessage',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Indexer$EmailMessageData$loadCore = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$rejectMessage,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentIdsByEmailMessageId,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
					$author$project$Forward$Lookup$succeed($author$project$Indexer$SharedModel$CoreInfo))))));
var $author$project$Indexer$SharedModel$DocumentBatchInfo = F6(
	function (loadedCore, tmsCarrier, documentBatch, documentList, documentPageIds, documentTypeSettings) {
		return {documentBatch: documentBatch, documentList: documentList, documentPageIds: documentPageIds, documentTypeSettings: documentTypeSettings, loadedCore: loadedCore, tmsCarrier: tmsCarrier};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageIdsByDocumentId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentPageId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$DocumentPageId$decode),
		entrypoint: 'documentPageIds',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentId$toInt)
	});
var $author$project$Domain$DocumentTypeSettings$DocumentTypeSettings = F9(
	function (allDocumentTypeNames, enabledDocumentTypeNames, customerVisibleDocumentTypes, requiredReceivablesDocumentTypes, requiredPayablesDocumentTypes, documentTypeHotkeysOrdering, hubtranTmsDocumentTypeMap, cadenceImageTypes, hubtranTmsPodDocumentTypeMap) {
		return {allDocumentTypeNames: allDocumentTypeNames, cadenceImageTypes: cadenceImageTypes, customerVisibleDocumentTypes: customerVisibleDocumentTypes, documentTypeHotkeysOrdering: documentTypeHotkeysOrdering, enabledDocumentTypeNames: enabledDocumentTypeNames, hubtranTmsDocumentTypeMap: hubtranTmsDocumentTypeMap, hubtranTmsPodDocumentTypeMap: hubtranTmsPodDocumentTypeMap, requiredPayablesDocumentTypes: requiredPayablesDocumentTypes, requiredReceivablesDocumentTypes: requiredReceivablesDocumentTypes};
	});
var $author$project$Domain$CadenceImageType$CadenceImageType = F4(
	function (externalId, imageCode, description, hubtranDocumentType) {
		return {description: description, externalId: externalId, hubtranDocumentType: hubtranDocumentType, imageCode: imageCode};
	});
var $author$project$Domain$CadenceImageType$decode = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Domain$CadenceImageType$CadenceImageType,
	A2($elm$json$Json$Decode$field, 'external_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'image_code', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'hubtran_document_type', $author$project$Domain$UnresolvedDocumentType$decode));
var $author$project$Domain$DocumentType$DocumentTypeWithName = F2(
	function (documentType, name) {
		return {documentType: documentType, name: name};
	});
var $author$project$Domain$DocumentType$decode = $author$project$AuditPb$documentTypeDecoder;
var $author$project$Domain$DocumentType$decodeWithName = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Domain$DocumentType$DocumentTypeWithName,
	A2($elm$json$Json$Decode$field, 'value', $author$project$Domain$DocumentType$decode),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
var $author$project$Domain$DocumentTypeSettings$listDocumentType = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$map,
			function (maybeString) {
				return A2($elm$core$Maybe$andThen, $author$project$AuditPb$documentTypeFromString, maybeString);
			},
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Domain$DocumentTypeSettings$requiredDocumentTypes = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$Domain$DocumentTypeSettings$listDocumentType,
			$elm$json$Json$Decode$succeed(_List_Nil)
		]));
var $author$project$Domain$DocumentTypeSettings$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hubtranTmsPodDocumentTypeMap',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cadenceImageTypes',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Domain$CadenceImageType$decode),
					$elm$json$Json$Decode$succeed(_List_Nil)
				])),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hubtranTmsDocumentTypeMap',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
					])),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'documentTypeHotkeysOrdering',
				$author$project$Domain$DocumentTypeSettings$requiredDocumentTypes,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'requiredPayablesDocumentTypes',
					$author$project$Domain$DocumentTypeSettings$requiredDocumentTypes,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'requiredReceivablesDocumentTypes',
						$author$project$Domain$DocumentTypeSettings$requiredDocumentTypes,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'customerVisibleDocumentTypes',
							$author$project$Domain$DocumentTypeSettings$listDocumentType,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'enabledDocumentTypeNames',
								$elm$json$Json$Decode$list($author$project$Domain$DocumentType$decodeWithName),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'allDocumentTypeNames',
									$elm$json$Json$Decode$list($author$project$Domain$DocumentType$decodeWithName),
									$elm$json$Json$Decode$succeed($author$project$Domain$DocumentTypeSettings$DocumentTypeSettings))))))))));
var $author$project$Forward$AppSpecific$Cache$documentTypeSettings = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentTypeSettings;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentTypeSettings: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings = $author$project$Forward$Lookup$defineNode(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$documentTypeSettings, decoder: $author$project$Domain$DocumentTypeSettings$decode, entrypoint: 'documentTypeSettings', parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Indexer$EmailMessageData$loadCoreBatch = function () {
	var maybeTmsCarrier = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage);
	var maybeDocumentBatch = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage);
	var documents = A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentIdsByEmailMessageId);
	var documentPageIds = A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageIdsByDocumentId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentIdsByEmailMessageId);
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings),
		A2(
			$author$project$Forward$Lookup$apply,
			documentPageIds,
			A2(
				$author$project$Forward$Lookup$apply,
				documents,
				A2(
					$author$project$Forward$Lookup$apply,
					maybeDocumentBatch,
					A2(
						$author$project$Forward$Lookup$apply,
						maybeTmsCarrier,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Indexer$EmailMessageData$loadCore,
							$author$project$Forward$Lookup$succeed($author$project$Indexer$SharedModel$DocumentBatchInfo)))))));
}();
var $author$project$Indexer$SharedModel$DocumentPagesInfo = F3(
	function (loadedDocumentBatch, documentGroups, groupedDocuments) {
		return {documentGroups: documentGroups, groupedDocuments: groupedDocuments, loadedDocumentBatch: loadedDocumentBatch};
	});
var $author$project$Forward$AppSpecific$Cache$documentGroup = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentGroup;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentGroup: e});
		}));
var $author$project$AuditPb$DocumentGroup = F9(
	function (id, factorInvoiceId, displayStatus, invoiceInformation, documentBatchId, groupingMethod, documentIds, additionalLabels, position) {
		return {additionalLabels: additionalLabels, displayStatus: displayStatus, documentBatchId: documentBatchId, documentIds: documentIds, factorInvoiceId: factorInvoiceId, groupingMethod: groupingMethod, id: id, invoiceInformation: invoiceInformation, position: position};
	});
var $author$project$AuditPb$DocumentGroup_DisplayStatusApproved = {$: 'DocumentGroup_DisplayStatusApproved'};
var $author$project$AuditPb$documentGroup_DisplayStatusDefault = $author$project$AuditPb$DocumentGroup_DisplayStatusApproved;
var $author$project$AuditPb$DocumentGroup_DisplayStatusRejected = {$: 'DocumentGroup_DisplayStatusRejected'};
var $author$project$AuditPb$allDocumentGroup_DisplayStatus = _List_fromArray(
	[$author$project$AuditPb$DocumentGroup_DisplayStatusApproved, $author$project$AuditPb$DocumentGroup_DisplayStatusRejected]);
var $author$project$AuditPb$documentGroup_DisplayStatusToString = function (v) {
	if (v.$ === 'DocumentGroup_DisplayStatusApproved') {
		return 'approved';
	} else {
		return 'rejected';
	}
};
var $author$project$AuditPb$documentGroup_DisplayStatusDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$documentGroup_DisplayStatusToString(v),
				v);
		},
		$author$project$AuditPb$allDocumentGroup_DisplayStatus));
var $author$project$AuditPb$documentGroup_DisplayStatusFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$documentGroup_DisplayStatusDict);
};
var $author$project$AuditPb$documentGroup_DisplayStatusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$documentGroup_DisplayStatusDefault),
		$author$project$AuditPb$documentGroup_DisplayStatusFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$documentGroupDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'position',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'additional_labels',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$repeated,
					'document_ids',
					A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$optional,
						'grouping_method',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'document_batch_id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $author$project$AuditPb$intDecoder),
							A3(
								$author$project$AuditPb$optional,
								'invoice_information',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$optional,
									'display_status',
									$author$project$AuditPb$documentGroup_DisplayStatusDecoder,
									A3(
										$author$project$AuditPb$optional,
										'factor_invoice_id',
										A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'id',
											A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentGroupId$fromInt, $author$project$AuditPb$intDecoder),
											$author$project$AuditPb$decode($author$project$AuditPb$DocumentGroup))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$documentGroup,
		decoder: $author$project$AuditPb$documentGroupDecoder,
		entrypoint: 'documentGroup',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentGroupId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$documentPage = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentPage;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentPage: e});
		}));
var $author$project$AuditPb$DocumentPage = function (id) {
	return function (documentId) {
		return function (thumbnailUrl) {
			return function (fullUrl) {
				return function (previewUrl) {
					return function (rotation) {
						return function (documentBatchId) {
							return function (documentGroupId) {
								return function (emailMessageSubject) {
									return function (illegible) {
										return function (rawFullUrl) {
											return {documentBatchId: documentBatchId, documentGroupId: documentGroupId, documentId: documentId, emailMessageSubject: emailMessageSubject, fullUrl: fullUrl, id: id, illegible: illegible, previewUrl: previewUrl, rawFullUrl: rawFullUrl, rotation: rotation, thumbnailUrl: thumbnailUrl};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$documentPageDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'raw_full_url',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'illegible',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$optional,
					'email_message_subject',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'document_group_id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentGroupId$fromInt, $author$project$AuditPb$intDecoder),
						A3(
							$author$project$AuditPb$optional,
							'document_batch_id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $author$project$AuditPb$intDecoder),
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'rotation',
								$author$project$AuditPb$intDecoder,
								A3(
									$author$project$AuditPb$optional,
									'preview_url',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$optional,
										'full_url',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$optional,
											'thumbnail_url',
											$elm$json$Json$Decode$string,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'document_id',
												A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'id',
													A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentPageId$fromInt, $author$project$AuditPb$intDecoder),
													$author$project$AuditPb$decode($author$project$AuditPb$DocumentPage))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPage = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$documentPage,
		decoder: $author$project$AuditPb$documentPageDecoder,
		entrypoint: 'documentPage',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentPageId$toInt)
	});
var $author$project$Domain$DocumentPageLine$DocumentPageLine = F5(
	function (top, left, height, width, chars) {
		return {chars: chars, height: height, left: left, top: top, width: width};
	});
var $author$project$Domain$DocumentPageLine$decode = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Domain$DocumentPageLine$DocumentPageLine,
	A2($elm$json$Json$Decode$field, 'top', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'left', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'chars', $elm$json$Json$Decode$string));
var $author$project$Forward$AppSpecific$Cache$list_documentPageLine = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_documentPageLine;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_documentPageLine: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentPageLine,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$DocumentPageLine$decode),
		entrypoint: 'documentPageLines',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentPageId$toInt)
	});
var $author$project$Indexer$Group$Browsable = F2(
	function (document, pages) {
		return {document: document, pages: pages};
	});
var $author$project$Indexer$Group$OcrPage = F2(
	function (page, lines) {
		return {lines: lines, page: page};
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $author$project$Indexer$EmailMessageData$toGroupedDocuments = F3(
	function (documents, pages, lines) {
		return A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				$elm$core$List$sortBy(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.document;
						},
						function ($) {
							return $.number;
						}))),
			$elm$core$Dict$toList(
				A3(
					$elm$core$List$foldl,
					function (x) {
						var _v0 = x.document.documentGroupId;
						if (_v0.$ === 'Just') {
							var documentGroupId = _v0.a;
							return A2(
								$elm$core$Dict$update,
								$author$project$Domain$DocumentGroupId$toInt(documentGroupId),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault(_List_Nil),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$cons(x),
										$elm$core$Maybe$Just)));
						} else {
							return $elm$core$Basics$identity;
						}
					},
					$elm$core$Dict$empty,
					A3(
						$elm$core$List$map2,
						$author$project$Indexer$Group$Browsable,
						documents,
						A3(
							$elm$core$List$map2,
							$elm$core$List$map2($author$project$Indexer$Group$OcrPage),
							pages,
							lines)))));
	});
var $author$project$Indexer$EmailMessageData$uniq_ = function (ids) {
	return A2(
		$elm$core$List$map,
		$author$project$Domain$DocumentGroupId$fromInt,
		$elm$core$Set$toList(
			$elm$core$Set$fromList(
				A2($elm$core$List$map, $author$project$Domain$DocumentGroupId$toInt, ids))));
};
var $author$project$Indexer$EmailMessageData$loadCorePages = function () {
	var documentPages = A2(
		$author$project$Forward$Lookup$traverseList,
		A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPage, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageIdsByDocumentId),
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentIdsByEmailMessageId);
	var documentPageLines = A2(
		$author$project$Forward$Lookup$traverseList,
		A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageIdsByDocumentId),
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentIdsByEmailMessageId);
	var documentGroups = A2(
		$author$project$Forward$Lookup$traverseList,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup,
		A2(
			$author$project$Forward$Lookup$map,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Indexer$EmailMessageData$uniq_,
				$elm$core$List$filterMap(
					function ($) {
						return $.documentGroupId;
					})),
			A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentIdsByEmailMessageId)));
	return A2(
		$author$project$Forward$Lookup$apply,
		documentPageLines,
		A2(
			$author$project$Forward$Lookup$apply,
			documentPages,
			A2(
				$author$project$Forward$Lookup$apply,
				documentGroups,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Indexer$EmailMessageData$loadCoreBatch,
					$author$project$Forward$Lookup$succeed(
						F4(
							function (batch, g, p, l) {
								return A3(
									$author$project$Indexer$SharedModel$DocumentPagesInfo,
									batch,
									g,
									A3($author$project$Indexer$EmailMessageData$toGroupedDocuments, batch.documentList, p, l));
							}))))));
}();
var $author$project$Indexer$EmailMessageData$loadAll = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$exposeLoadingState($author$project$Indexer$EmailMessageData$loadCorePages),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState($author$project$Indexer$EmailMessageData$loadCoreBatch),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Indexer$EmailMessageData$loadCore),
			$author$project$Forward$Lookup$succeed($author$project$Indexer$EmailMessageData$PageData))));
var $author$project$Factoring$Page$ClientSubmission$CacheData$requestedInvoiceOnly = function (invoiceId) {
	return A2(
		$author$project$Forward$Lookup$startFrom,
		invoiceId,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
			$author$project$Forward$Lookup$succeed(
				function (factorInvoice) {
					return $elm$core$Maybe$Just(factorInvoice);
				})));
};
var $author$project$Factoring$Page$ClientSubmission$CacheData$withFirstOnly = F2(
	function (emailId, invoiceId) {
		return A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Factoring$Page$ClientSubmission$CacheData$getRequestedInvoiceGroupNumber, invoiceId, emailId),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverseMaybe,
						$author$project$Factoring$Page$ClientSubmission$CacheData$getSubmission,
						$author$project$Factoring$Page$ClientSubmission$CacheData$requestedInvoiceOnly(invoiceId)),
					$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$ClientSubmission$CacheData$assembleSubmissionResult))),
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Forward$Lookup$startFrom, emailId, $author$project$Indexer$EmailMessageData$loadAll),
				$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$init = F4(
	function (emailId, invoiceId, dismissFundingNotes, onDoneQuery) {
		var presence = $author$project$Presence$on(
			$author$project$Path$toString(
				A2($author$project$Path$submissionInvoice, emailId, invoiceId)));
		var model = {
			changes: _List_Nil,
			customExceptionText: $author$project$Factoring$Page$ClientSubmissionInvoice$Other(''),
			debounce: $jinjor$elm_debounce$Debounce$init,
			debtorWithAddressTypeahead: $author$project$Components$DebtorWithAddressTypeahead$initClosed,
			dirtyInvoiceAmount: $elm$core$Maybe$Nothing,
			dirtyInvoiceDate: $elm$core$Maybe$Nothing,
			dismissFundingNotes: A2($elm$core$Maybe$withDefault, false, dismissFundingNotes),
			documentBrowser: A2($author$project$Indexer$DocumentBrowser$init, emailId, $author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix),
			emailMessageId: emailId,
			exceptionResolutionText: '',
			factorInvoiceId: invoiceId,
			holdingShift: false,
			hoveredLineText: $elm$core$Maybe$Nothing,
			identifyDocuments: $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$init,
			mostRecentHotkeySelections: $elm$core$Dict$empty,
			moveDocumentsModal: $author$project$Factoring$Page$ClientSubmissionInvoice$initMoveDocumentsModal,
			onDoneQuery: onDoneQuery,
			originalSubmissionDropdown: $elm$core$Maybe$Nothing,
			presence: presence,
			regroupInProgress: false,
			resolvingException: $elm$core$Maybe$Nothing,
			secondaryDocumentBrowser: $elm$core$Maybe$Nothing,
			selection: $author$project$Indexer$Group$firstSelection,
			submissionDropdown: $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$initClosed(emailId),
			timezone: $elm$time$Time$utc,
			userRequestsViewFundingNotes: $elm$core$Maybe$Nothing,
			viewCustomExceptionForm: false
		};
		return _Utils_Tuple2(
			model,
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Factoring$Page$ClientSubmissionInvoice$CarrierIdentified,
						A2(
							$author$project$Forward$Lookup$map,
							function ($) {
								return $.carrierId;
							},
							A2($author$project$Forward$Lookup$startFrom, emailId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage))),
						A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Factoring$Page$ClientSubmissionInvoice$DebtorIdentified,
						A2(
							$author$project$Forward$Lookup$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$second,
								$elm$core$Result$map(
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$second,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.invoice;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.debtor;
												},
												$elm$core$Maybe$map(
													function ($) {
														return $.id;
													})))))),
							A2($author$project$Factoring$Page$ClientSubmission$CacheData$withFirstOnly, emailId, invoiceId))),
						A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Factoring$Page$ClientSubmissionInvoice$OriginalSelectionLoaded,
						A2(
							$author$project$Forward$Lookup$map,
							function (_v0) {
								var pageData = _v0.a;
								var groupSubmissionData = _v0.b;
								return A2(
									$elm$core$Result$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$first,
										$author$project$Factoring$Page$ClientSubmissionInvoice$firstPageOf(pageData)),
									groupSubmissionData);
							},
							A2($author$project$Factoring$Page$ClientSubmission$CacheData$withFirstOnly, emailId, invoiceId))),
						A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Factoring$Page$ClientSubmissionInvoice$OriginalSubmissionLoaded,
						A2(
							$author$project$Forward$Lookup$map,
							$elm$core$Maybe$andThen($elm$core$Basics$identity),
							A2(
								$author$project$Forward$Lookup$traverse,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToSubmissionDropdownData,
								A2($author$project$Forward$Lookup$startFrom, invoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)))),
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Task$perform, $author$project$Factoring$Page$ClientSubmissionInvoice$SetTimezone, $author$project$Helpers$Date$localTimezone))
					])));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$Unedited = {$: 'Unedited'};
var $author$project$Js$maybePrefetchNextFlowModeItem = _Platform_outgoingPort(
	'maybePrefetchNextFlowModeItem',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$int(b)
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$primaryBrowserPrefix = '';
var $author$project$Path$submissionReview = function (emailId) {
	return A2(
		$author$project$Path$appendToBase,
		_List_fromArray(
			['review']),
		$author$project$Path$submission(emailId));
};
var $author$project$Factoring$Page$ClientSubmissionReview$init = F2(
	function (emailId, onDoneQuery) {
		var presence = $author$project$Presence$on(
			$author$project$Path$toString(
				$author$project$Path$submissionReview(emailId)));
		return _Utils_Tuple2(
			{
				documentBrowser: A2($author$project$Indexer$DocumentBrowser$init, emailId, $author$project$Factoring$Page$ClientSubmissionReview$primaryBrowserPrefix),
				emailMessageId: emailId,
				extraRecipients: '',
				identifyDocuments: $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$init,
				messageDraft: $author$project$Factoring$Page$ClientSubmissionReview$Unedited,
				onDoneQuery: onDoneQuery,
				presence: presence,
				resent: false,
				selection: $elm$core$Maybe$Nothing,
				sending: false,
				timezone: $elm$time$Time$utc
			},
			$author$project$HubTran$Effect$Batch(
				_List_fromArray(
					[
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Task$perform, $author$project$Factoring$Page$ClientSubmissionReview$SetTimezone, $author$project$Helpers$Date$localTimezone)),
						$author$project$HubTran$Effect$cmd(
						$author$project$Js$maybePrefetchNextFlowModeItem(
							_Utils_Tuple2(
								A2($elm$core$Maybe$withDefault, '/app', onDoneQuery),
								$author$project$Domain$EmailMessageId$toInt(emailId))))
					])));
	});
var $author$project$Factoring$Page$VerificationBatch$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$Domain$VerificationsDebtorBatchId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Path$verificationBatch = function (id) {
	var idString = $elm$core$String$fromInt(
		$author$project$Domain$VerificationsDebtorBatchId$toInt(id));
	return $author$project$Path$base(
		_List_fromArray(
			['app', 'verification_batch', idString]));
};
var $author$project$Factoring$Page$VerificationBatch$init = F2(
	function (debtorBatchId, maybeOnDone) {
		var presence = $author$project$Presence$on(
			$author$project$Path$toString(
				$author$project$Path$verificationBatch(debtorBatchId)));
		return _Utils_Tuple2(
			{
				addedRecipients: _List_Nil,
				contactInfoExpanded: false,
				copiedToClipboard: false,
				dataWhileInvalidating: $elm$core$Maybe$Nothing,
				debtorBatchId: debtorBatchId,
				debtorConfirmationExpandedState: $elm$core$Dict$empty,
				debtorConfirmationModal: $elm$core$Maybe$Nothing,
				debtorContactsExpanded: false,
				debtorNotesExpanded: false,
				debtorVerificationsExpandedState: $elm$core$Dict$empty,
				documentBrowserExpanded: false,
				editingContactInfo: false,
				excludedRecipients: $elm$core$Set$empty,
				formState: $elm$core$Dict$empty,
				isSaving: false,
				leftSideSelectedPage: $elm$core$Maybe$Nothing,
				maybeOnDone: maybeOnDone,
				newContactInfo: $elm$core$Maybe$Nothing,
				nextAddedRecipientKey: 0,
				pendingEditUndos: $elm$core$Set$empty,
				presence: presence,
				recipientEditsInFlight: $elm$core$Set$empty,
				requireItemsNewerThan: $elm$time$Time$millisToPosix(0),
				selectedFactorInvoiceId: $elm$core$Maybe$Nothing,
				selectedPage: {documentIndex: 0, pageIndex: 0},
				tab: $elm$core$Maybe$Nothing,
				timezone: $elm$time$Time$utc,
				verificationInstructionsState: {fundingNotes: false, section: false, verificationNotes: true},
				viewEmailModal: false
			},
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Task$perform, $author$project$Factoring$Page$VerificationBatch$SetTimezone, $author$project$Helpers$Date$localTimezone)));
	});
var $author$project$Broker$Page$DocumentsViewerPopout$InitData = function (accountSettings) {
	return {accountSettings: accountSettings};
};
var $author$project$Broker$Page$DocumentsViewerPopout$loadInitData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
	$author$project$Forward$Lookup$succeed($author$project$Broker$Page$DocumentsViewerPopout$InitData));
var $author$project$Components$ActivityPage$InitData = F3(
	function (accountSettings, carrierDropdown, customerDropdown) {
		return {accountSettings: accountSettings, carrierDropdown: carrierDropdown, customerDropdown: customerDropdown};
	});
var $author$project$Components$SettingsPage$CarrierDropdown$InitData = function (selectedCarriers) {
	return {selectedCarriers: selectedCarriers};
};
var $author$project$Forward$Lookup$waitForAll = function (items) {
	return $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: A3(
				$elm$core$List$foldl,
				$elm$core$Dict$union,
				$elm$core$Dict$empty,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var nested = _v0.a;
						return nested.decoderConfig;
					},
					items)),
			invalidate: F3(
				function (k, mode, cache) {
					return A3(
						$elm$core$List$foldl,
						function (_v1) {
							var nested = _v1.a;
							return A2(nested.invalidate, k, mode);
						},
						cache,
						items);
				}),
			load: F3(
				function (cache, requiredTimestamp, k) {
					return $author$project$Forward$Internal$Loadable$listOfLoadablesToLoadableList(
						A2(
							$elm$core$List$map,
							function (_v2) {
								var nested = _v2.a;
								return A3(nested.load, cache, requiredTimestamp, k);
							},
							items));
				}),
			preloadBranches: $author$project$Forward$Internal$GraphTree$unionBranches(
				A2(
					$elm$core$List$map,
					function (_v3) {
						var nested = _v3.a;
						return nested.preloadBranches;
					},
					items)),
			structure: A2(
				$author$project$Forward$Internal$LookupStructure$All,
				'waitForAll',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var nested = _v4.a;
						return nested.structure;
					},
					items))
		});
};
var $author$project$Components$SettingsPage$CarrierDropdown$loadInitData = function (ids) {
	var selectedItems = $author$project$Forward$Lookup$waitForAll(
		A2(
			$elm$core$List$map,
			function (id) {
				return A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier);
			},
			ids));
	return A2(
		$author$project$Forward$Lookup$apply,
		selectedItems,
		$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$CarrierDropdown$InitData));
};
var $author$project$Components$TmsCustomerDropdown$InitData = function (selectedCustomers) {
	return {selectedCustomers: selectedCustomers};
};
var $author$project$Forward$AppSpecific$Cache$tmsCustomer = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.tmsCustomer;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{tmsCustomer: e});
		}));
var $author$project$AuditPb$TMSCustomer = F5(
	function (id, accountNumber, name, instructionsList, externalId) {
		return {accountNumber: accountNumber, externalId: externalId, id: id, instructionsList: instructionsList, name: name};
	});
var $author$project$AuditPb$tmsCustomerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'external_id',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'instructions_list',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'account_number',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$TMSCustomer))))));
	});
var $author$project$Domain$TmsCustomerId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$tmsCustomer,
		decoder: $author$project$AuditPb$tmsCustomerDecoder,
		entrypoint: 'tmsCustomer',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsCustomerId$toInt)
	});
var $author$project$Components$TmsCustomerDropdown$loadInitData = function (ids) {
	var selectedItems = $author$project$Forward$Lookup$waitForAll(
		A2(
			$elm$core$List$map,
			function (id) {
				return A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer);
			},
			ids));
	return A2(
		$author$project$Forward$Lookup$apply,
		selectedItems,
		$author$project$Forward$Lookup$succeed($author$project$Components$TmsCustomerDropdown$InitData));
};
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Components$ActivityPage$loadInitData = function (queryParams) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$TmsCustomerDropdown$loadInitData(
			$elm_community$maybe_extra$Maybe$Extra$toList(queryParams.customerDropdownId)),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$SettingsPage$CarrierDropdown$loadInitData(
				$elm_community$maybe_extra$Maybe$Extra$toList(queryParams.carrierDropdownId)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				$author$project$Forward$Lookup$succeed($author$project$Components$ActivityPage$InitData))));
};
var $author$project$Components$DashboardPage$InitData = F7(
	function (account, accountSettings, currentUser, availableQueuesAccountData, dashboardFilterStateInitData, carrierDropdown, debtorDropdown) {
		return {account: account, accountSettings: accountSettings, availableQueuesAccountData: availableQueuesAccountData, carrierDropdown: carrierDropdown, currentUser: currentUser, dashboardFilterStateInitData: dashboardFilterStateInitData, debtorDropdown: debtorDropdown};
	});
var $author$project$Domain$UserId$UserId = function (a) {
	return {$: 'UserId', a: a};
};
var $author$project$Domain$UserId$fromInt = function (_int) {
	return $author$project$Domain$UserId$UserId(_int);
};
var $author$project$Domain$UserId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$UserId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$Lookup$defineReference = function (config) {
	return A2(
		$author$project$Forward$Lookup$traverse,
		config.objectEntrypoint,
		$author$project$Forward$Lookup$defineNode(
			{cacheKey: config.cacheKey, decoder: config.decoder, entrypoint: config.entrypoint, parameters: config.parameters}));
};
var $author$project$AuditPb$User = function (id) {
	return function (name) {
		return function (emailAddress) {
			return function (isAdmin) {
				return function (isDisabled) {
					return function (isApprover) {
						return function (isIndexer) {
							return function (isAuditor) {
								return function (isManagedIndexer) {
									return function (isCustomerRepresentative) {
										return function (receivables) {
											return function (hasSettingsRole) {
												return function (preferredFilters) {
													return function (preferredCategories) {
														return function (emailSignature) {
															return function (hideItemsInQueuesOnPresence) {
																return function (createdAt) {
																	return function (updatedAt) {
																		return function (receivesEmailsAt) {
																			return function (groupUserId) {
																				return function (hasInsightsDashboardAccess) {
																					return function (termsAgreedToAt) {
																						return function (labelsCollapsed) {
																							return function (readOnlyFactorInvoices) {
																								return function (canUnapproveInvoices) {
																									return function (useFactorInvoiceWorkflowPage) {
																										return function (auditDocumentsColumnWidth) {
																											return {auditDocumentsColumnWidth: auditDocumentsColumnWidth, canUnapproveInvoices: canUnapproveInvoices, createdAt: createdAt, emailAddress: emailAddress, emailSignature: emailSignature, groupUserId: groupUserId, hasInsightsDashboardAccess: hasInsightsDashboardAccess, hasSettingsRole: hasSettingsRole, hideItemsInQueuesOnPresence: hideItemsInQueuesOnPresence, id: id, isAdmin: isAdmin, isApprover: isApprover, isAuditor: isAuditor, isCustomerRepresentative: isCustomerRepresentative, isDisabled: isDisabled, isIndexer: isIndexer, isManagedIndexer: isManagedIndexer, labelsCollapsed: labelsCollapsed, name: name, preferredCategories: preferredCategories, preferredFilters: preferredFilters, readOnlyFactorInvoices: readOnlyFactorInvoices, receivables: receivables, receivesEmailsAt: receivesEmailsAt, termsAgreedToAt: termsAgreedToAt, updatedAt: updatedAt, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$DashboardCategoryFilter = F3(
	function (category, label, excluded) {
		return {category: category, excluded: excluded, label: label};
	});
var $author$project$AuditPb$dashboardCategoryFilterDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'excluded',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'label',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'category',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$DashboardCategoryFilter))));
	});
var $author$project$AuditPb$DashboardLabelFilter = F2(
	function (label, state) {
		return {label: label, state: state};
	});
var $author$project$AuditPb$LabelFilterStateUnselected = {$: 'LabelFilterStateUnselected'};
var $author$project$AuditPb$labelFilterStateDefault = $author$project$AuditPb$LabelFilterStateUnselected;
var $author$project$AuditPb$LabelFilterStateNegated = {$: 'LabelFilterStateNegated'};
var $author$project$AuditPb$LabelFilterStateSelected = {$: 'LabelFilterStateSelected'};
var $author$project$AuditPb$allLabelFilterState = _List_fromArray(
	[$author$project$AuditPb$LabelFilterStateUnselected, $author$project$AuditPb$LabelFilterStateSelected, $author$project$AuditPb$LabelFilterStateNegated]);
var $author$project$AuditPb$labelFilterStateToString = function (v) {
	switch (v.$) {
		case 'LabelFilterStateUnselected':
			return '';
		case 'LabelFilterStateSelected':
			return '+';
		default:
			return '-';
	}
};
var $author$project$AuditPb$labelFilterStateDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$labelFilterStateToString(v),
				v);
		},
		$author$project$AuditPb$allLabelFilterState));
var $author$project$AuditPb$labelFilterStateFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$labelFilterStateDict);
};
var $author$project$AuditPb$labelFilterStateDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$labelFilterStateDefault),
		$author$project$AuditPb$labelFilterStateFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$dashboardLabelFilterDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'state',
			$author$project$AuditPb$labelFilterStateDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'label',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$DashboardLabelFilter)));
	});
var $author$project$AuditPb$userDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'audit_documents_column_width',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'use_factor_invoice_workflow_page',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'can_unapprove_invoices',
					$elm$json$Json$Decode$bool,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'read_only_factor_invoices',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'labels_collapsed',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$optional,
								'terms_agreed_to_at',
								$author$project$AuditPb$timestampDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'has_insights_dashboard_access',
									$elm$json$Json$Decode$bool,
									A3(
										$author$project$AuditPb$optional,
										'group_user_id',
										$author$project$AuditPb$intDecoder,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'receives_emails_at',
											$elm$json$Json$Decode$string,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'updated_at',
												$author$project$AuditPb$timestampDecoder,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'created_at',
													$author$project$AuditPb$timestampDecoder,
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'hide_items_in_queues_on_presence',
														$elm$json$Json$Decode$bool,
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'email_signature',
															$elm$json$Json$Decode$string,
															A3(
																$author$project$AuditPb$repeated,
																'preferred_categories',
																$author$project$AuditPb$dashboardCategoryFilterDecoder,
																A3(
																	$author$project$AuditPb$repeated,
																	'preferred_filters',
																	$author$project$AuditPb$dashboardLabelFilterDecoder,
																	A3(
																		$author$project$AuditPb$requiredWithoutDefault,
																		'has_settings_role',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$author$project$AuditPb$requiredWithoutDefault,
																			'receivables',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$author$project$AuditPb$requiredWithoutDefault,
																				'is_customer_representative',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$author$project$AuditPb$requiredWithoutDefault,
																					'is_managed_indexer',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$author$project$AuditPb$requiredWithoutDefault,
																						'is_auditor',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$author$project$AuditPb$requiredWithoutDefault,
																							'is_indexer',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$author$project$AuditPb$requiredWithoutDefault,
																								'is_approver',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$author$project$AuditPb$requiredWithoutDefault,
																									'is_disabled',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$author$project$AuditPb$requiredWithoutDefault,
																										'is_admin',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$author$project$AuditPb$requiredWithoutDefault,
																											'email_address',
																											$elm$json$Json$Decode$string,
																											A3(
																												$author$project$AuditPb$requiredWithoutDefault,
																												'name',
																												$elm$json$Json$Decode$string,
																												A3(
																													$author$project$AuditPb$requiredWithoutDefault,
																													'id',
																													A2($elm$json$Json$Decode$map, $author$project$Domain$UserId$fromInt, $author$project$AuditPb$intDecoder),
																													$author$project$AuditPb$decode($author$project$AuditPb$User))))))))))))))))))))))))))));
	});
var $author$project$Domain$User$decode = $author$project$AuditPb$userDecoder;
var $author$project$Domain$UserId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$Cache$user = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.user;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{user: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$user = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$user,
		decoder: $author$project$Domain$User$decode,
		entrypoint: 'userV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$UserId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$userId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.userId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{userId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser = $author$project$Forward$Lookup$defineReference(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$userId, decoder: $author$project$Domain$UserId$decode, entrypoint: 'currentUserId', objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$user, parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Components$Dashboard$AvailableQueues$AccountData = F3(
	function (accountType, accountSettings, currentUser) {
		return {accountSettings: accountSettings, accountType: accountType, currentUser: currentUser};
	});
var $author$project$Components$Dashboard$AvailableQueues$loadAccountType = A2($author$project$Forward$Lookup$map, $author$project$Domain$Account$accountType, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount);
var $author$project$Components$Dashboard$AvailableQueues$loadAccountData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$Dashboard$AvailableQueues$loadAccountType,
			$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$AvailableQueues$AccountData))));
var $author$project$Components$CarrierDropdown$InitData = function (selectedCarriers) {
	return {selectedCarriers: selectedCarriers};
};
var $author$project$Components$CarrierDropdown$loadInitData = function (ids) {
	var lookupCarrier = function (id) {
		return (!$author$project$Domain$TmsCarrierId$toInt(id)) ? $author$project$Forward$Lookup$succeed($author$project$Domain$TmsCarrier$unknownCarrier) : A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier);
	};
	var selectedItems = $author$project$Forward$Lookup$waitForAll(
		A2($elm$core$List$map, lookupCarrier, ids));
	return A2(
		$author$project$Forward$Lookup$apply,
		selectedItems,
		$author$project$Forward$Lookup$succeed($author$project$Components$CarrierDropdown$InitData));
};
var $author$project$Components$Dashboard$DashboardFilterState$InitData = F3(
	function (account, accountSettings, user) {
		return {account: account, accountSettings: accountSettings, user: user};
	});
var $author$project$Components$Dashboard$DashboardFilterState$loadInitData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
			$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$DashboardFilterState$InitData))));
var $author$project$Components$DebtorDropdown$InitData = function (selectedFactorBrokers) {
	return {selectedFactorBrokers: selectedFactorBrokers};
};
var $author$project$Components$DebtorDropdown$loadInitData = function (ids) {
	var selectedItems = $author$project$Forward$Lookup$waitForAll(
		A2(
			$elm$core$List$map,
			function (id) {
				return A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker);
			},
			ids));
	return A2(
		$author$project$Forward$Lookup$apply,
		selectedItems,
		$author$project$Forward$Lookup$succeed($author$project$Components$DebtorDropdown$InitData));
};
var $author$project$Sanitized$sanitize = F2(
	function (sanitizeA, _v0) {
		var a = _v0.a;
		return sanitizeA(a);
	});
var $author$project$Components$DashboardPage$loadInitData = function (filters) {
	var filtersRecord = A2(
		$elm$core$Maybe$map,
		$author$project$Sanitized$sanitize($elm$core$Basics$identity),
		filters);
	var debtorIds = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.factorBrokerIds;
			},
			filtersRecord));
	var carrierIds = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.tmsCarrierIds;
			},
			filtersRecord));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$DebtorDropdown$loadInitData(debtorIds),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$CarrierDropdown$loadInitData(carrierIds),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$Dashboard$DashboardFilterState$loadInitData,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Components$Dashboard$AvailableQueues$loadAccountData,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
								$author$project$Forward$Lookup$succeed($author$project$Components$DashboardPage$InitData))))))));
};
var $author$project$Components$FactorInvoiceAuditBatchPage$InitData = F6(
	function (documentBatchId, emailMessageId, factorInvoiceId, onDone, workingArea, documentTypeSettings) {
		return {documentBatchId: documentBatchId, documentTypeSettings: documentTypeSettings, emailMessageId: emailMessageId, factorInvoiceId: factorInvoiceId, onDone: onDone, workingArea: workingArea};
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$InitData = F6(
	function (account, accountSettings, currentUser, initialCarrier, initialDebtor, documentTypeSettings) {
		return {account: account, accountSettings: accountSettings, currentUser: currentUser, documentTypeSettings: documentTypeSettings, initialCarrier: initialCarrier, initialDebtor: initialDebtor};
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$loadInitData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings),
	A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
						$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditWorkingArea$InitData)))))));
var $author$project$Components$FactorInvoiceAuditBatchResolver$batchReadyToSelect = function (groups) {
	var anyEmptyGroup = A2(
		$elm$core$List$any,
		function (g) {
			return $elm$core$List$isEmpty(g.documents);
		},
		groups);
	var allDocuments = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.documents;
		},
		groups);
	var anyZeroPageDoc = A2(
		$elm$core$List$any,
		function (d) {
			return !d.pageCount;
		},
		allDocuments);
	return !(anyZeroPageDoc || anyEmptyGroup);
};
var $author$project$Components$FactorInvoiceAuditBatchResolver$listFind = F2(
	function (predicate, list) {
		listFind:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var head = list.a;
				var tail = list.b;
				if (predicate(head)) {
					return $elm$core$Maybe$Just(head);
				} else {
					var $temp$predicate = predicate,
						$temp$list = tail;
					predicate = $temp$predicate;
					list = $temp$list;
					continue listFind;
				}
			}
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchResolver$firstIncompleteGroup = function (groups) {
	var allTyped = A2(
		$elm$core$List$all,
		function ($) {
			return $.hasType;
		},
		A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.documents;
			},
			groups));
	var incomplete = function (group) {
		return allTyped ? (!A2(
			$elm$core$List$all,
			function ($) {
				return $.finished;
			},
			group.documents)) : A2(
			$elm$core$List$any,
			function (d) {
				return !d.hasType;
			},
			group.documents);
	};
	return A2(
		$author$project$Components$FactorInvoiceAuditBatchResolver$listFind,
		incomplete,
		A2(
			$elm$core$List$filter,
			function (g) {
				return A2(
					$elm$core$List$any,
					function (d) {
						return d.pageCount > 0;
					},
					g.documents);
			},
			groups));
};
var $author$project$Components$FactorInvoiceAuditBatchResolver$decide = function (groups) {
	if (!$author$project$Components$FactorInvoiceAuditBatchResolver$batchReadyToSelect(groups)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = $author$project$Components$FactorInvoiceAuditBatchResolver$firstIncompleteGroup(groups);
		if (_v0.$ === 'Just') {
			var group = _v0.a;
			return group.factorInvoiceId;
		} else {
			return A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.factorInvoiceId;
				},
				$elm$core$List$head(groups));
		}
	}
};
var $author$project$Domain$DocumentGroupId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentGroupId$DocumentGroupId, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$list_documentGroupId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_documentGroupId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_documentGroupId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupIdsByDocumentBatchId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentGroupId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$DocumentGroupId$decode),
		entrypoint: 'documentGroupIdsByDocumentBatchId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentBatchId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPageIds = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageIdsByDocumentId,
		fieldName: 'pageIds',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchResolver$docWithPageCount = A2(
	$author$project$Forward$Lookup$apply,
	A2($author$project$Forward$Lookup$map, $elm$core$List$length, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPageIds),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
var $author$project$Forward$Internal$Loadable$exposeLoadingStateOfListItems = A2(
	$elm$core$List$foldr,
	function (_v0) {
		var original = _v0.a;
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Forward$Internal$Loadable$map(
				$elm$core$List$cons(original.result)),
			$author$project$Forward$Internal$Loadable$addEffects(original.effects_));
	},
	$author$project$Forward$Internal$Loadable$fromRemote(
		$author$project$Forward$Remote$Loaded(_List_Nil)));
var $author$project$Forward$Lookup$defineListEdge = function (config) {
	var _v0 = config.entrypoint;
	var nested = _v0.a;
	return $author$project$Forward$Internal$GraphTree$isNoBranches(nested.preloadBranches) ? $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: nested.decoderConfig,
			invalidate: F3(
				function (from, mode, cache) {
					return A3(
						$elm$core$List$foldl,
						function (id) {
							return A2(nested.invalidate, id, mode);
						},
						cache,
						config.getIds(from));
				}),
			load: F3(
				function (cache, requiredTimestamp, parent) {
					return $author$project$Forward$Internal$Loadable$exposeLoadingStateOfListItems(
						A2(
							$elm$core$List$map,
							A2(nested.load, cache, requiredTimestamp),
							config.getIds(parent)));
				}),
			preloadBranches: $author$project$Forward$Internal$GraphTree$singleBranch(config.fieldName),
			structure: nested.structure
		}) : _Debug_todo(
		'Forward.Lookup',
		{
			start: {line: 465, column: 8},
			end: {line: 465, column: 18}
		})('XXX: You should only be passing a top-level graph entrypoint defined with Lookup.defineNode as the entrypoint to defineEdge.  (Advanced note: this could probably be implemented, but would need to be considered carefully to fully handle all edge cases; and it\u0027s probably not something we want to allow anyway.)');
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToDocuments = $author$project$Forward$Lookup$defineListEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'documents',
		getIds: function ($) {
			return $.documentIds;
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchResolver$summarizeDocument = F2(
	function (doc, pageCount) {
		var hasType = function () {
			var _v0 = doc.documentTypeValue;
			switch (_v0.$) {
				case 'Document_DocumentTypeValue_DocumentType':
					return true;
				case 'Document_DocumentTypeValue_DocumentTypePartial':
					return true;
				default:
					return false;
			}
		}();
		return {finished: doc.finished, hasType: hasType, pageCount: pageCount};
	});
var $author$project$Components$FactorInvoiceAuditBatchResolver$toGroupSummary = F3(
	function (group, state, docsWithPageCounts) {
		return {
			documents: A2(
				$elm$core$List$map,
				function (_v0) {
					var doc = _v0.a;
					var pageCount = _v0.b;
					return A2($author$project$Components$FactorInvoiceAuditBatchResolver$summarizeDocument, doc, pageCount);
				},
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						function ($) {
							return $.number;
						}),
					docsWithPageCounts)),
			factorInvoiceId: group.factorInvoiceId,
			state: state
		};
	});
var $author$project$Forward$Lookup$waitForAllHelper = F4(
	function (debugName, split, join, _v0) {
		var nested = _v0.a;
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: nested.decoderConfig,
				invalidate: nested.invalidate,
				load: F3(
					function (cache, requiredTimestamp, k) {
						return A2(
							$author$project$Forward$Internal$Loadable$andThen,
							A2(
								$elm$core$Basics$composeR,
								split,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map($author$project$Forward$Internal$Loadable$fromRemote),
									A2(
										$elm$core$Basics$composeR,
										$author$project$Forward$Internal$Loadable$listOfLoadablesToLoadableList,
										$author$project$Forward$Internal$Loadable$map(join)))),
							A3(nested.load, cache, requiredTimestamp, k));
					}),
				preloadBranches: nested.preloadBranches,
				structure: A2(
					$author$project$Forward$Internal$LookupStructure$All,
					debugName,
					_List_fromArray(
						[nested.structure]))
			});
	});
var $author$project$Forward$Lookup$waitForAllList = A3($author$project$Forward$Lookup$waitForAllHelper, 'waitForAllList', $elm$core$Basics$identity, $elm$core$Basics$identity);
var $author$project$Components$FactorInvoiceAuditBatchResolver$groupWithDocuments = A2(
	$author$project$Forward$Lookup$traverse,
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$traverseList,
			$author$project$Components$FactorInvoiceAuditBatchResolver$docWithPageCount,
			$author$project$Forward$Lookup$waitForAllList($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToDocuments)),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$traverseMaybe,
				A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.state;
					},
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
				A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.factorInvoiceId;
					},
					$author$project$Forward$Lookup$identity)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$identity,
				$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditBatchResolver$toGroupSummary)))),
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup);
var $author$project$Components$FactorInvoiceAuditBatchResolver$loadGroupSummaries = function (documentBatchId) {
	return A2(
		$author$project$Forward$Lookup$startFrom,
		documentBatchId,
		A2($author$project$Forward$Lookup$traverseList, $author$project$Components$FactorInvoiceAuditBatchResolver$groupWithDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupIdsByDocumentBatchId));
};
var $author$project$Components$FactorInvoiceAuditBatchResolver$resolveFactorInvoiceIdFromBatch = function (documentBatchId) {
	return A2(
		$author$project$Forward$Lookup$map,
		$author$project$Components$FactorInvoiceAuditBatchResolver$decide,
		$author$project$Components$FactorInvoiceAuditBatchResolver$loadGroupSummaries(documentBatchId));
};
var $author$project$Components$FactorInvoiceAuditBatchPage$loadInitData = F4(
	function (documentBatchId, maybeEmailMessageId, maybeFactorInvoiceId, onDone) {
		var resolvedId = function () {
			if (maybeFactorInvoiceId.$ === 'Just') {
				var id = maybeFactorInvoiceId.a;
				return $author$project$Forward$Lookup$succeed(
					$elm$core$Maybe$Just(id));
			} else {
				return $author$project$Components$FactorInvoiceAuditBatchResolver$resolveFactorInvoiceIdFromBatch(documentBatchId);
			}
		}();
		var resolvedEmailId = function () {
			if (maybeEmailMessageId.$ === 'Just') {
				var id = maybeEmailMessageId.a;
				return $author$project$Forward$Lookup$succeed(
					$elm$core$Maybe$Just(id));
			} else {
				return A2(
					$author$project$Forward$Lookup$startFrom,
					documentBatchId,
					A2(
						$author$project$Forward$Lookup$map,
						function ($) {
							return $.emailMessageId;
						},
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2));
			}
		}();
		return A2(
			$author$project$Forward$Lookup$traverseMaybe,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$identity,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$fromRoot(resolvedEmailId),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Components$FactorInvoiceAuditWorkingArea$loadInitData,
							$author$project$Forward$Lookup$succeed(
								F4(
									function (workingArea, emailMessageId, factorInvoiceId, docTypeSettings) {
										return A6($author$project$Components$FactorInvoiceAuditBatchPage$InitData, documentBatchId, emailMessageId, factorInvoiceId, onDone, workingArea, docTypeSettings);
									})))))),
			resolvedId);
	});
var $author$project$Components$FactorInvoiceAuditPage$InitData = F5(
	function (factorInvoiceId, emailId, onDone, workingArea, documentTypeSettings) {
		return {documentTypeSettings: documentTypeSettings, emailId: emailId, factorInvoiceId: factorInvoiceId, onDone: onDone, workingArea: workingArea};
	});
var $author$project$Components$FactorInvoiceAuditPage$loadInitData = F3(
	function (factorInvoiceId, emailId, onDone) {
		return A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Components$FactorInvoiceAuditWorkingArea$loadInitData),
				$author$project$Forward$Lookup$succeed(
					A3($author$project$Components$FactorInvoiceAuditPage$InitData, factorInvoiceId, emailId, onDone))));
	});
var $author$project$Components$LtlHeldSubmissionsPage$InitData = function (accountSettings) {
	return {accountSettings: accountSettings};
};
var $author$project$Components$LtlHeldSubmissionsPage$loadInitData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
	$author$project$Forward$Lookup$succeed($author$project$Components$LtlHeldSubmissionsPage$InitData));
var $author$project$Components$LtlReconcileInvoicePage$InitData = F3(
	function (params, settings, carrierInvoice) {
		return {carrierInvoice: carrierInvoice, params: params, settings: settings};
	});
var $author$project$Forward$AppSpecific$Cache$carrierInvoice = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.carrierInvoice;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{carrierInvoice: e});
		}));
var $author$project$AuditPb$CarrierInvoice = function (id) {
	return function (carrierId) {
		return function (loadStateId) {
			return function (labels) {
				return function (number) {
					return function (amountToPay) {
						return function (dateToPay) {
							return function (approvedAt) {
								return function (status) {
									return function (ltlData) {
										return function (processedAt) {
											return function (customerMarginData) {
												return function (podRequirementSkipped) {
													return function (sourceInvoiceNumber) {
														return function (invoiceAmount) {
															return function (invoiceDate) {
																return function (isEditable) {
																	return function (finishActions) {
																		return function (maySaveWithErrors) {
																			return {amountToPay: amountToPay, approvedAt: approvedAt, carrierId: carrierId, customerMarginData: customerMarginData, dateToPay: dateToPay, finishActions: finishActions, id: id, invoiceAmount: invoiceAmount, invoiceDate: invoiceDate, isEditable: isEditable, labels: labels, loadStateId: loadStateId, ltlData: ltlData, maySaveWithErrors: maySaveWithErrors, number: number, podRequirementSkipped: podRequirementSkipped, processedAt: processedAt, sourceInvoiceNumber: sourceInvoiceNumber, status: status};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$CarrierInvoiceCustomerMarginData = F4(
	function (dollarDifference, percentDifference, customerCharge, carrierCharge) {
		return {carrierCharge: carrierCharge, customerCharge: customerCharge, dollarDifference: dollarDifference, percentDifference: percentDifference};
	});
var $author$project$AuditPb$carrierInvoiceCustomerMarginDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'carrierCharge',
			$author$project$AuditPb$floatValueDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'customerCharge',
				$author$project$AuditPb$floatValueDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'percentDifference',
					$author$project$AuditPb$floatValueDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'dollarDifference',
						$author$project$AuditPb$floatValueDecoder,
						$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceCustomerMarginData)))));
	});
var $author$project$AuditPb$CarrierInvoiceFinishActionsNone = {$: 'CarrierInvoiceFinishActionsNone'};
var $author$project$AuditPb$carrierInvoiceFinishActionsDefault = $author$project$AuditPb$CarrierInvoiceFinishActionsNone;
var $author$project$AuditPb$CarrierInvoiceFinishActionsProcessAndApprove = {$: 'CarrierInvoiceFinishActionsProcessAndApprove'};
var $author$project$AuditPb$CarrierInvoiceFinishActionsProcessOnly = {$: 'CarrierInvoiceFinishActionsProcessOnly'};
var $author$project$AuditPb$CarrierInvoiceFinishActionsProcessOrApprove = {$: 'CarrierInvoiceFinishActionsProcessOrApprove'};
var $author$project$AuditPb$allCarrierInvoiceFinishActions = _List_fromArray(
	[$author$project$AuditPb$CarrierInvoiceFinishActionsNone, $author$project$AuditPb$CarrierInvoiceFinishActionsProcessOnly, $author$project$AuditPb$CarrierInvoiceFinishActionsProcessAndApprove, $author$project$AuditPb$CarrierInvoiceFinishActionsProcessOrApprove]);
var $author$project$AuditPb$carrierInvoiceFinishActionsToString = function (v) {
	switch (v.$) {
		case 'CarrierInvoiceFinishActionsNone':
			return 'none';
		case 'CarrierInvoiceFinishActionsProcessOnly':
			return 'process_only';
		case 'CarrierInvoiceFinishActionsProcessAndApprove':
			return 'process_and_approve';
		default:
			return 'process_or_approve';
	}
};
var $author$project$AuditPb$carrierInvoiceFinishActionsDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$carrierInvoiceFinishActionsToString(v),
				v);
		},
		$author$project$AuditPb$allCarrierInvoiceFinishActions));
var $author$project$AuditPb$carrierInvoiceFinishActionsFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$carrierInvoiceFinishActionsDict);
};
var $author$project$AuditPb$carrierInvoiceFinishActionsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$carrierInvoiceFinishActionsDefault),
		$author$project$AuditPb$carrierInvoiceFinishActionsFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$CarrierInvoiceLtlData = F6(
	function (hasSubmission, requiresReconciliation, reRatingStatus, ltlShippedItemReconcileItems, ltlLineItemReconcileItems, customerRerateEnabled) {
		return {customerRerateEnabled: customerRerateEnabled, hasSubmission: hasSubmission, ltlLineItemReconcileItems: ltlLineItemReconcileItems, ltlShippedItemReconcileItems: ltlShippedItemReconcileItems, reRatingStatus: reRatingStatus, requiresReconciliation: requiresReconciliation};
	});
var $author$project$AuditPb$CarrierInvoiceReRatingStatusNone = {$: 'CarrierInvoiceReRatingStatusNone'};
var $author$project$AuditPb$carrierInvoiceReRatingStatusDefault = $author$project$AuditPb$CarrierInvoiceReRatingStatusNone;
var $author$project$AuditPb$CarrierInvoiceReRatingStatusCompleted = {$: 'CarrierInvoiceReRatingStatusCompleted'};
var $author$project$AuditPb$CarrierInvoiceReRatingStatusFailed = {$: 'CarrierInvoiceReRatingStatusFailed'};
var $author$project$AuditPb$CarrierInvoiceReRatingStatusInProgress = {$: 'CarrierInvoiceReRatingStatusInProgress'};
var $author$project$AuditPb$CarrierInvoiceReRatingStatusTimeout = {$: 'CarrierInvoiceReRatingStatusTimeout'};
var $author$project$AuditPb$allCarrierInvoiceReRatingStatus = _List_fromArray(
	[$author$project$AuditPb$CarrierInvoiceReRatingStatusNone, $author$project$AuditPb$CarrierInvoiceReRatingStatusInProgress, $author$project$AuditPb$CarrierInvoiceReRatingStatusCompleted, $author$project$AuditPb$CarrierInvoiceReRatingStatusTimeout, $author$project$AuditPb$CarrierInvoiceReRatingStatusFailed]);
var $author$project$AuditPb$carrierInvoiceReRatingStatusToString = function (v) {
	switch (v.$) {
		case 'CarrierInvoiceReRatingStatusNone':
			return 'none';
		case 'CarrierInvoiceReRatingStatusInProgress':
			return 'in_progress';
		case 'CarrierInvoiceReRatingStatusCompleted':
			return 'completed';
		case 'CarrierInvoiceReRatingStatusTimeout':
			return 'timeout';
		default:
			return 'failed';
	}
};
var $author$project$AuditPb$carrierInvoiceReRatingStatusDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$carrierInvoiceReRatingStatusToString(v),
				v);
		},
		$author$project$AuditPb$allCarrierInvoiceReRatingStatus));
var $author$project$AuditPb$carrierInvoiceReRatingStatusFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$carrierInvoiceReRatingStatusDict);
};
var $author$project$AuditPb$carrierInvoiceReRatingStatusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$carrierInvoiceReRatingStatusDefault),
		$author$project$AuditPb$carrierInvoiceReRatingStatusFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$LtlCarrierInvoiceReconcileRequest_LineItemReconcileItem = F5(
	function (loadItemId, carrierItemId, description, oldAmount, newAmount) {
		return {carrierItemId: carrierItemId, description: description, loadItemId: loadItemId, newAmount: newAmount, oldAmount: oldAmount};
	});
var $author$project$AuditPb$ltlCarrierInvoiceReconcileRequest_LineItemReconcileItemDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'newAmount',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'oldAmount',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'carrierItemId',
						$author$project$AuditPb$intDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'loadItemId',
							$author$project$AuditPb$intDecoder,
							$author$project$AuditPb$decode($author$project$AuditPb$LtlCarrierInvoiceReconcileRequest_LineItemReconcileItem))))));
	});
var $author$project$AuditPb$LtlCarrierInvoiceReconcileRequest_ShippedItemReconcileItem = F7(
	function (loadItemId, carrierItemId, description, oldWeight, newWeight, oldClass, newClass) {
		return {carrierItemId: carrierItemId, description: description, loadItemId: loadItemId, newClass: newClass, newWeight: newWeight, oldClass: oldClass, oldWeight: oldWeight};
	});
var $author$project$AuditPb$ltlCarrierInvoiceReconcileRequest_ShippedItemReconcileItemDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'newClass',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'oldClass',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'newWeight',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'oldWeight',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'description',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'carrierItemId',
								$author$project$AuditPb$intDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'loadItemId',
									$author$project$AuditPb$intDecoder,
									$author$project$AuditPb$decode($author$project$AuditPb$LtlCarrierInvoiceReconcileRequest_ShippedItemReconcileItem))))))));
	});
var $author$project$AuditPb$carrierInvoiceLtlDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'customerRerateEnabled',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$repeated,
				'ltlLineItemReconcileItems',
				$author$project$AuditPb$ltlCarrierInvoiceReconcileRequest_LineItemReconcileItemDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'ltlShippedItemReconcileItems',
					$author$project$AuditPb$ltlCarrierInvoiceReconcileRequest_ShippedItemReconcileItemDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'reRatingStatus',
						$author$project$AuditPb$carrierInvoiceReRatingStatusDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'requiresReconciliation',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'hasSubmission',
								$elm$json$Json$Decode$bool,
								$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceLtlData)))))));
	});
var $author$project$AuditPb$carrierInvoiceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'may_save_with_errors',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'finish_actions',
				$author$project$AuditPb$carrierInvoiceFinishActionsDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'is_editable',
					$elm$json$Json$Decode$bool,
					A3(
						$author$project$AuditPb$optional,
						'invoice_date',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'invoice_amount',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'source_invoice_number',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$optional,
									'pod_requirement_skipped',
									$elm$json$Json$Decode$bool,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'customer_margin_data',
										$author$project$AuditPb$carrierInvoiceCustomerMarginDataDecoder,
										A3(
											$author$project$AuditPb$optional,
											'processed_at',
											$author$project$AuditPb$timestampDecoder,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'ltl_data',
												$author$project$AuditPb$carrierInvoiceLtlDataDecoder,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'status',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$AuditPb$optional,
														'approved_at',
														$author$project$AuditPb$timestampDecoder,
														A3(
															$author$project$AuditPb$optional,
															'date_to_pay',
															$author$project$AuditPb$timestampDecoder,
															A3(
																$author$project$AuditPb$optional,
																'amount_to_pay',
																$elm$json$Json$Decode$string,
																A3(
																	$author$project$AuditPb$optional,
																	'number',
																	$elm$json$Json$Decode$string,
																	A3(
																		$author$project$AuditPb$repeated,
																		'labels',
																		$elm$json$Json$Decode$string,
																		A3(
																			$author$project$AuditPb$requiredWithoutDefault,
																			'load_state_id',
																			A2($elm$json$Json$Decode$map, $author$project$Domain$LoadStateId$fromInt, $author$project$AuditPb$intDecoder),
																			A3(
																				$author$project$AuditPb$optional,
																				'carrier_id',
																				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
																				A3(
																					$author$project$AuditPb$requiredWithoutDefault,
																					'id',
																					A2($elm$json$Json$Decode$map, $author$project$Domain$CarrierInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
																					$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoice))))))))))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$carrierInvoice,
		decoder: $author$project$AuditPb$carrierInvoiceDecoder,
		entrypoint: 'carrierInvoices',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Components$LtlReconcileInvoicePage$loadInitData = function (params) {
	return A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$startFrom, params.carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$succeed(params),
				$author$project$Forward$Lookup$succeed($author$project$Components$LtlReconcileInvoicePage$InitData))));
};
var $author$project$Components$NoaManagement$SentPage$InitData = F4(
	function (account, accountSettings, debtorDropdown, carrierDropdown) {
		return {account: account, accountSettings: accountSettings, carrierDropdown: carrierDropdown, debtorDropdown: debtorDropdown};
	});
var $author$project$Components$NoaManagement$SentPage$loadInitData = function (params) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$CarrierDropdown$loadInitData(
			$elm_community$maybe_extra$Maybe$Extra$toList(params.carrierId)),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$DebtorDropdown$loadInitData(
				$elm_community$maybe_extra$Maybe$Extra$toList(params.debtorId)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					$author$project$Forward$Lookup$succeed($author$project$Components$NoaManagement$SentPage$InitData)))));
};
var $author$project$Components$NonInvoiceConfirmPage$InitData = F6(
	function (params, settings, documentBatch, tmsLoadDetails, shipments, documents) {
		return {documentBatch: documentBatch, documents: documents, params: params, settings: settings, shipments: shipments, tmsLoadDetails: tmsLoadDetails};
	});
var $author$project$Forward$AppSpecific$Cache$tmsLoadDetails = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.tmsLoadDetails;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{tmsLoadDetails: e});
		}));
var $author$project$AuditPb$TMSLoadDetails = F6(
	function (load, documentIds, lineItems, referenceFields, shipmentIds, customerVisibleDocumentTypes) {
		return {customerVisibleDocumentTypes: customerVisibleDocumentTypes, documentIds: documentIds, lineItems: lineItems, load: load, referenceFields: referenceFields, shipmentIds: shipmentIds};
	});
var $author$project$Domain$TmsShipmentId$fromInt = $author$project$Id$fromInt;
var $author$project$AuditPb$TMSLoadDetails_LineItem = F7(
	function (id, description, rateQualifier, rate, quantity, total, externalId) {
		return {description: description, externalId: externalId, id: id, quantity: quantity, rate: rate, rateQualifier: rateQualifier, total: total};
	});
var $author$project$Domain$LineItemId$LineItemId = function (a) {
	return {$: 'LineItemId', a: a};
};
var $author$project$Domain$LineItemId$fromInt = function (_int) {
	return $author$project$Domain$LineItemId$LineItemId(_int);
};
var $author$project$AuditPb$tmsLoadDetails_LineItemDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'external_id',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'total',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'quantity',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'rate',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'rate_qualifier',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'description',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$LineItemId$fromInt, $author$project$AuditPb$intDecoder),
									$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadDetails_LineItem))))))));
	});
var $author$project$AuditPb$TMSLoadDetails_Load = function (id) {
	return function (externalId) {
		return function (loadId) {
			return function (origin) {
				return function (destination) {
					return function (actualShippedAt) {
						return function (actualDeliveredAt) {
							return function (customerCharge) {
								return function (proNumber) {
									return function (distance) {
										return function (status) {
											return function (carrierId) {
												return function (customerId) {
													return {actualDeliveredAt: actualDeliveredAt, actualShippedAt: actualShippedAt, carrierId: carrierId, customerCharge: customerCharge, customerId: customerId, destination: destination, distance: distance, externalId: externalId, id: id, loadId: loadId, origin: origin, proNumber: proNumber, status: status};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$addressDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'country',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'postal_code',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'state',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'city',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'address_line_2',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'address_line_1',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$optional,
										'id',
										A2($elm$json$Json$Decode$map, $author$project$Domain$AddressId$fromInt, $author$project$AuditPb$intDecoder),
										$author$project$AuditPb$decode($author$project$AuditPb$Address)))))))));
	});
var $author$project$Domain$TmsLoadId$TmsLoadId = function (a) {
	return {$: 'TmsLoadId', a: a};
};
var $author$project$Domain$TmsLoadId$fromInt = function (_int) {
	return $author$project$Domain$TmsLoadId$TmsLoadId(_int);
};
var $author$project$AuditPb$tmsLoadDetails_LoadDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'customer_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$optional,
				'carrier_id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
				A3(
					$author$project$AuditPb$optional,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'distance',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'pro_number',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'customer_charge',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$optional,
									'actual_delivered_at',
									$author$project$AuditPb$timestampDecoder,
									A3(
										$author$project$AuditPb$optional,
										'actual_shipped_at',
										$author$project$AuditPb$timestampDecoder,
										A3(
											$author$project$AuditPb$optionalMessage,
											'destination',
											$author$project$AuditPb$addressDecoder,
											A3(
												$author$project$AuditPb$optionalMessage,
												'origin',
												$author$project$AuditPb$addressDecoder,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'load_id',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'external_id',
														$elm$json$Json$Decode$string,
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'id',
															A2($elm$json$Json$Decode$map, $author$project$Domain$TmsLoadId$fromInt, $author$project$AuditPb$intDecoder),
															$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadDetails_Load))))))))))))));
	});
var $author$project$AuditPb$TMSLoadDetails_Reference = F2(
	function (key, value) {
		return {key: key, value: value};
	});
var $author$project$AuditPb$tmsLoadDetails_ReferenceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'value',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'key',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadDetails_Reference)));
	});
var $author$project$AuditPb$tmsLoadDetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'customer_visible_document_types',
			$author$project$AuditPb$unresolvedDocumentTypeDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'shipment_ids',
				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsShipmentId$fromInt, $author$project$AuditPb$intDecoder),
				A3(
					$author$project$AuditPb$repeated,
					'reference_fields',
					$author$project$AuditPb$tmsLoadDetails_ReferenceDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'line_items',
						$author$project$AuditPb$tmsLoadDetails_LineItemDecoder,
						A3(
							$author$project$AuditPb$repeated,
							'document_ids',
							A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'load',
								$author$project$AuditPb$tmsLoadDetails_LoadDecoder,
								$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadDetails)))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetails = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$tmsLoadDetails,
		decoder: $author$project$AuditPb$tmsLoadDetailsDecoder,
		entrypoint: 'tmsLoadDetailsV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$LoadStateId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToDocuments = $author$project$Forward$Lookup$waitForAllList(
	$author$project$Forward$Lookup$defineListEdge(
		{
			entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
			fieldName: 'documents',
			getIds: function ($) {
				return $.documentIds;
			}
		}));
var $author$project$Forward$AppSpecific$Cache$tmsShipment = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.tmsShipment;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{tmsShipment: e});
		}));
var $author$project$AuditPb$TMSShipment = F9(
	function (id, shipmentId, weight, shipperName, references, documentIds, customerId, shipmentNotes, stops) {
		return {customerId: customerId, documentIds: documentIds, id: id, references: references, shipmentId: shipmentId, shipmentNotes: shipmentNotes, shipperName: shipperName, stops: stops, weight: weight};
	});
var $author$project$AuditPb$TMSShipment_TMSStopWrapper = function (tmsStop) {
	return {tmsStop: tmsStop};
};
var $author$project$AuditPb$TMSShipment_TMSStopWrapper_TMSStop_Drop = function (a) {
	return {$: 'TMSShipment_TMSStopWrapper_TMSStop_Drop', a: a};
};
var $author$project$AuditPb$TMSShipment_TMSStopWrapper_TMSStop_Pickup = function (a) {
	return {$: 'TMSShipment_TMSStopWrapper_TMSStop_Pickup', a: a};
};
var $author$project$AuditPb$TMSShipment_Drop = F2(
	function (id, address) {
		return {address: address, id: id};
	});
var $author$project$Domain$TmsStopId$TmsStopId = function (a) {
	return {$: 'TmsStopId', a: a};
};
var $author$project$Domain$TmsStopId$fromInt = function (_int) {
	return $author$project$Domain$TmsStopId$TmsStopId(_int);
};
var $author$project$AuditPb$tmsShipment_DropDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'address',
			$author$project$AuditPb$addressDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsStopId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$TMSShipment_Drop)));
	});
var $author$project$AuditPb$TMSShipment_Pickup = F2(
	function (id, address) {
		return {address: address, id: id};
	});
var $author$project$AuditPb$tmsShipment_PickupDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'address',
			$author$project$AuditPb$addressDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsStopId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$TMSShipment_Pickup)));
	});
var $author$project$AuditPb$tmsShipment_TMSStopWrapper_TMSStopDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$TMSShipment_TMSStopWrapper_TMSStop_Pickup,
					A2($elm$json$Json$Decode$field, 'pickup', $author$project$AuditPb$tmsShipment_PickupDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$TMSShipment_TMSStopWrapper_TMSStop_Drop,
					A2($elm$json$Json$Decode$field, 'drop', $author$project$AuditPb$tmsShipment_DropDecoder)),
					$elm$json$Json$Decode$fail('TMSShipment_TMSStopWrapper_TMSStop_Unspecified')
				]));
	});
var $author$project$AuditPb$tmsShipment_TMSStopWrapperDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$tmsShipment_TMSStopWrapper_TMSStopDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$TMSShipment_TMSStopWrapper));
	});
var $author$project$AuditPb$tmsShipmentDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'stops',
			$author$project$AuditPb$tmsShipment_TMSStopWrapperDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'shipment_notes',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'customer_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$repeated,
						'document_ids',
						A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'references',
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
							A3(
								$author$project$AuditPb$optional,
								'shipper_name',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$optional,
									'weight',
									$author$project$AuditPb$intDecoder,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'shipment_id',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'id',
											A2($elm$json$Json$Decode$map, $author$project$Domain$TmsShipmentId$fromInt, $author$project$AuditPb$intDecoder),
											$author$project$AuditPb$decode($author$project$AuditPb$TMSShipment))))))))));
	});
var $author$project$Domain$TmsShipmentId$toInt = $author$project$Id$toInt;
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsShipment = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$tmsShipment,
		decoder: $author$project$AuditPb$tmsShipmentDecoder,
		entrypoint: 'tmsShipmentV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsShipmentId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsShipments = $author$project$Forward$Lookup$waitForAllList(
	$author$project$Forward$Lookup$defineListEdge(
		{
			entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsShipment,
			fieldName: 'tmsShipments',
			getIds: function ($) {
				return $.shipmentIds;
			}
		}));
var $author$project$Components$NonInvoiceConfirmPage$loadInitData = function (params) {
	var tmsLoadDetails = A2($author$project$Forward$Lookup$startFrom, params.loadStateId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetails);
	return A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToDocuments, tmsLoadDetails),
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsShipments, tmsLoadDetails),
			A2(
				$author$project$Forward$Lookup$apply,
				tmsLoadDetails,
				A2(
					$author$project$Forward$Lookup$apply,
					A2($author$project$Forward$Lookup$startFrom, params.documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$succeed(params),
							$author$project$Forward$Lookup$succeed($author$project$Components$NonInvoiceConfirmPage$InitData)))))));
};
var $author$project$Components$ReadonlyFactorInvoicePage$InitData = F2(
	function (accountSettings, documentSource) {
		return {accountSettings: accountSettings, documentSource: documentSource};
	});
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$DocumentBatchSource = F4(
	function (documentBatch, maybeEmail, maybeCarrier, documentGroupIds) {
		return {documentBatch: documentBatch, documentGroupIds: documentGroupIds, maybeCarrier: maybeCarrier, maybeEmail: maybeEmail};
	});
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$EmailMessageSource = F3(
	function (email, maybeCarrier, documentGroupIds) {
		return {documentGroupIds: documentGroupIds, email: email, maybeCarrier: maybeCarrier};
	});
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$FromDocumentBatch = function (a) {
	return {$: 'FromDocumentBatch', a: a};
};
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$FromEmailMessage = function (a) {
	return {$: 'FromEmailMessage', a: a};
};
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$FromFactorInvoice = function (a) {
	return {$: 'FromFactorInvoice', a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (mx.$ === 'Just') {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$RawFactorInvoiceDetails = F4(
	function (factorInvoice, debtor, debtorPaymentAddress, exceptionEvents) {
		return {debtor: debtor, debtorPaymentAddress: debtorPaymentAddress, exceptionEvents: exceptionEvents, factorInvoice: factorInvoice};
	});
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$lookup = function () {
	var lookupFactorBroker = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker;
	var lookupPaymentAddress = A2(
		$author$project$Forward$Lookup$map,
		$elm_community$maybe_extra$Maybe$Extra$join,
		A2($author$project$Forward$Lookup$traverseMaybe, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerToPaymentAddress, lookupFactorBroker));
	var lookupExceptionEvents = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToExceptionEvents;
	var convertExceptions = function (_v0) {
		var debtorPaymentAddress = _v0.debtorPaymentAddress;
		var debtor = _v0.debtor;
		var exceptionEvents = _v0.exceptionEvents;
		var factorInvoice = _v0.factorInvoice;
		return {
			debtor: debtor,
			debtorPaymentAddress: debtorPaymentAddress,
			exceptions: A2($author$project$Factoring$Page$ClientSubmission$CacheData$Exception$toExceptions, factorInvoice, exceptionEvents),
			factorInvoice: factorInvoice
		};
	};
	return A2(
		$author$project$Forward$Lookup$map,
		convertExceptions,
		A2(
			$author$project$Forward$Lookup$apply,
			lookupExceptionEvents,
			A2(
				$author$project$Forward$Lookup$apply,
				lookupPaymentAddress,
				A2(
					$author$project$Forward$Lookup$apply,
					lookupFactorBroker,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$identity,
						$author$project$Forward$Lookup$succeed($author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$RawFactorInvoiceDetails))))));
}();
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$lookup = function (readonlyId) {
	switch (readonlyId.$) {
		case 'EmailMessageIdParam':
			var emailId = readonlyId.a;
			var lookupEmail = A2($author$project$Forward$Lookup$startFrom, emailId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage);
			var lookupDocumentGroupIds = A2(
				$author$project$Forward$Lookup$traverseMaybe,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupIdsByDocumentBatchId,
				A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.documentBatchId;
					},
					lookupEmail));
			var lookupCarrier = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier, lookupEmail);
			var lookupSource = A2(
				$author$project$Forward$Lookup$apply,
				lookupDocumentGroupIds,
				A2(
					$author$project$Forward$Lookup$apply,
					lookupCarrier,
					A2(
						$author$project$Forward$Lookup$apply,
						lookupEmail,
						$author$project$Forward$Lookup$succeed($author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$EmailMessageSource))));
			return A2($author$project$Forward$Lookup$map, $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$FromEmailMessage, lookupSource);
		case 'DocumentBatchIdParam':
			var documentBatchId = readonlyId.a;
			var lookupDocumentBatch = A2($author$project$Forward$Lookup$startFrom, documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2);
			var lookupDocumentGroupIds = A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupIdsByDocumentBatchId,
				A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.id;
					},
					lookupDocumentBatch));
			var lookupEmail = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage, lookupDocumentBatch);
			var lookupCarrier = A2(
				$author$project$Forward$Lookup$map,
				$elm_community$maybe_extra$Maybe$Extra$join,
				A2($author$project$Forward$Lookup$traverseMaybe, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier, lookupEmail));
			var lookupSource = A2(
				$author$project$Forward$Lookup$apply,
				lookupDocumentGroupIds,
				A2(
					$author$project$Forward$Lookup$apply,
					lookupCarrier,
					A2(
						$author$project$Forward$Lookup$apply,
						lookupEmail,
						A2(
							$author$project$Forward$Lookup$apply,
							lookupDocumentBatch,
							$author$project$Forward$Lookup$succeed($author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$DocumentBatchSource)))));
			return A2($author$project$Forward$Lookup$map, $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$FromDocumentBatch, lookupSource);
		default:
			var factorInvoiceId = readonlyId.a;
			var lookupSource = A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$lookup,
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice));
			return A2($author$project$Forward$Lookup$map, $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$FromFactorInvoice, lookupSource);
	}
};
var $author$project$Components$ReadonlyFactorInvoicePage$loadInitData = function (id) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$lookup(id),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			$author$project$Forward$Lookup$succeed($author$project$Components$ReadonlyFactorInvoicePage$InitData)));
};
var $author$project$Components$DebtorChanges$Common$AnyOutcome = {$: 'AnyOutcome'};
var $author$project$Components$DebtorChanges$IndexPage$AnyTemplate = {$: 'AnyTemplate'};
var $author$project$Components$DebtorChanges$IndexPage$GotTimezone = function (a) {
	return {$: 'GotTimezone', a: a};
};
var $author$project$Components$DebtorChanges$IndexPage$init = function (params) {
	return _Utils_Tuple2(
		{
			draft: $elm$core$Maybe$Nothing,
			invoicePage: 1,
			outcome: $author$project$Components$DebtorChanges$Common$AnyOutcome,
			range: {
				endDate: A2($elm$core$Maybe$withDefault, '', params.endDate),
				startDate: A2($elm$core$Maybe$withDefault, '', params.startDate)
			},
			template: $author$project$Components$DebtorChanges$IndexPage$AnyTemplate,
			templatePage: 1,
			timezone: $elm$time$Time$utc
		},
		$author$project$HubTran$Effect$cmd(
			A2($elm$core$Task$perform, $author$project$Components$DebtorChanges$IndexPage$GotTimezone, $author$project$Helpers$Date$localTimezone)));
};
var $author$project$Forward$AppSpecific$Cache$debtorChangeReport = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.debtorChangeReport;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{debtorChangeReport: e});
		}));
var $author$project$AuditPb$DebtorChangeReport = F5(
	function (invoices, templates, error, startDate, endDate) {
		return {endDate: endDate, error: error, invoices: invoices, startDate: startDate, templates: templates};
	});
var $author$project$AuditPb$DebtorChangeInvoice = F7(
	function (factorInvoiceId, createdAt, outcome, guessedDebtor, finalDebtor, processedByUser, rateConfirmations) {
		return {createdAt: createdAt, factorInvoiceId: factorInvoiceId, finalDebtor: finalDebtor, guessedDebtor: guessedDebtor, outcome: outcome, processedByUser: processedByUser, rateConfirmations: rateConfirmations};
	});
var $author$project$AuditPb$DebtorChangeDebtor = F3(
	function (id, name, mcNumber) {
		return {id: id, mcNumber: mcNumber, name: name};
	});
var $author$project$AuditPb$debtorChangeDebtorDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'mc_number',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$DebtorChangeDebtor))));
	});
var $author$project$AuditPb$DebtorChangeOutcomeCorrect = {$: 'DebtorChangeOutcomeCorrect'};
var $author$project$AuditPb$debtorChangeOutcomeDefault = $author$project$AuditPb$DebtorChangeOutcomeCorrect;
var $author$project$AuditPb$DebtorChangeOutcomeNoGuess = {$: 'DebtorChangeOutcomeNoGuess'};
var $author$project$AuditPb$DebtorChangeOutcomeUnlabeled = {$: 'DebtorChangeOutcomeUnlabeled'};
var $author$project$AuditPb$DebtorChangeOutcomeWrongGuess = {$: 'DebtorChangeOutcomeWrongGuess'};
var $author$project$AuditPb$allDebtorChangeOutcome = _List_fromArray(
	[$author$project$AuditPb$DebtorChangeOutcomeCorrect, $author$project$AuditPb$DebtorChangeOutcomeWrongGuess, $author$project$AuditPb$DebtorChangeOutcomeNoGuess, $author$project$AuditPb$DebtorChangeOutcomeUnlabeled]);
var $author$project$AuditPb$debtorChangeOutcomeToString = function (v) {
	switch (v.$) {
		case 'DebtorChangeOutcomeCorrect':
			return 'correct';
		case 'DebtorChangeOutcomeWrongGuess':
			return 'wrong_guess';
		case 'DebtorChangeOutcomeNoGuess':
			return 'no_guess';
		default:
			return 'unlabeled';
	}
};
var $author$project$AuditPb$debtorChangeOutcomeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$debtorChangeOutcomeToString(v),
				v);
		},
		$author$project$AuditPb$allDebtorChangeOutcome));
var $author$project$AuditPb$debtorChangeOutcomeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$debtorChangeOutcomeDict);
};
var $author$project$AuditPb$debtorChangeOutcomeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$debtorChangeOutcomeDefault),
		$author$project$AuditPb$debtorChangeOutcomeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$DebtorChangeRateConfirmation = F3(
	function (documentId, templateId, templateEditorUrl) {
		return {documentId: documentId, templateEditorUrl: templateEditorUrl, templateId: templateId};
	});
var $author$project$AuditPb$debtorChangeRateConfirmationDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'template_editor_url',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'template_id',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'document_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$DebtorChangeRateConfirmation))));
	});
var $author$project$AuditPb$debtorChangeInvoiceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'rate_confirmations',
			$author$project$AuditPb$debtorChangeRateConfirmationDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'processed_by_user',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$optionalMessage,
					'final_debtor',
					$author$project$AuditPb$debtorChangeDebtorDecoder,
					A3(
						$author$project$AuditPb$optionalMessage,
						'guessed_debtor',
						$author$project$AuditPb$debtorChangeDebtorDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'outcome',
							$author$project$AuditPb$debtorChangeOutcomeDecoder,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'created_at',
								$author$project$AuditPb$timestampDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'factor_invoice_id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
									$author$project$AuditPb$decode($author$project$AuditPb$DebtorChangeInvoice))))))));
	});
var $author$project$AuditPb$DebtorChangeReportErrorInvalidRange = {$: 'DebtorChangeReportErrorInvalidRange'};
var $author$project$AuditPb$debtorChangeReportErrorDefault = $author$project$AuditPb$DebtorChangeReportErrorInvalidRange;
var $author$project$AuditPb$DebtorChangeReportErrorTimedOut = {$: 'DebtorChangeReportErrorTimedOut'};
var $author$project$AuditPb$allDebtorChangeReportError = _List_fromArray(
	[$author$project$AuditPb$DebtorChangeReportErrorInvalidRange, $author$project$AuditPb$DebtorChangeReportErrorTimedOut]);
var $author$project$AuditPb$debtorChangeReportErrorToString = function (v) {
	if (v.$ === 'DebtorChangeReportErrorInvalidRange') {
		return 'invalid_range';
	} else {
		return 'timed_out';
	}
};
var $author$project$AuditPb$debtorChangeReportErrorDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$debtorChangeReportErrorToString(v),
				v);
		},
		$author$project$AuditPb$allDebtorChangeReportError));
var $author$project$AuditPb$debtorChangeReportErrorFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$debtorChangeReportErrorDict);
};
var $author$project$AuditPb$debtorChangeReportErrorDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$debtorChangeReportErrorDefault),
		$author$project$AuditPb$debtorChangeReportErrorFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$DebtorChangeTemplateSummary = F4(
	function (template, wrongGuesses, noGuesses, wrongGuessesOfAPin) {
		return {noGuesses: noGuesses, template: template, wrongGuesses: wrongGuesses, wrongGuessesOfAPin: wrongGuessesOfAPin};
	});
var $author$project$AuditPb$DebtorChangeTemplateInfo = F6(
	function (id, label, documentsTemplatesGroupId, networkBrokerId, accountPins, editorUrl) {
		return {accountPins: accountPins, documentsTemplatesGroupId: documentsTemplatesGroupId, editorUrl: editorUrl, id: id, label: label, networkBrokerId: networkBrokerId};
	});
var $author$project$AuditPb$debtorChangeTemplateInfoDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'editor_url',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'account_pins',
				$author$project$AuditPb$debtorChangeDebtorDecoder,
				A3(
					$author$project$AuditPb$optional,
					'network_broker_id',
					$author$project$AuditPb$intDecoder,
					A3(
						$author$project$AuditPb$optional,
						'documents_templates_group_id',
						$author$project$AuditPb$intDecoder,
						A3(
							$author$project$AuditPb$optional,
							'label',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'id',
								$author$project$AuditPb$intDecoder,
								$author$project$AuditPb$decode($author$project$AuditPb$DebtorChangeTemplateInfo)))))));
	});
var $author$project$AuditPb$debtorChangeTemplateSummaryDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'wrong_guesses_of_a_pin',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'no_guesses',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'wrong_guesses',
					$author$project$AuditPb$intDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'template',
						$author$project$AuditPb$debtorChangeTemplateInfoDecoder,
						$author$project$AuditPb$decode($author$project$AuditPb$DebtorChangeTemplateSummary)))));
	});
var $author$project$AuditPb$debtorChangeReportDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'end_date',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'start_date',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'error',
					$author$project$AuditPb$debtorChangeReportErrorDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'templates',
						$author$project$AuditPb$debtorChangeTemplateSummaryDecoder,
						A3(
							$author$project$AuditPb$repeated,
							'invoices',
							$author$project$AuditPb$debtorChangeInvoiceDecoder,
							$author$project$AuditPb$decode($author$project$AuditPb$DebtorChangeReport))))));
	});
var $author$project$AuditPb$debtorChangeReportQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'start_date', $elm$json$Json$Encode$string, v.startDate),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'end_date', $elm$json$Json$Encode$string, v.endDate)
				])));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorChangeReport = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$debtorChangeReport,
		decoder: $author$project$AuditPb$debtorChangeReportDecoder,
		entrypoint: 'debtorChangeReport',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$debtorChangeReportQueryEncoder)
	});
var $author$project$Components$DebtorChanges$IndexPage$loadData = function (model) {
	return A2($author$project$Forward$Lookup$startFrom, model.range, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorChangeReport);
};
var $author$project$Path$debtorChanges = function (_v0) {
	var endDate = _v0.endDate;
	var startDate = _v0.startDate;
	return A2(
		$author$project$Path$addQueries,
		_List_fromArray(
			[
				_Utils_Tuple2('start_date', startDate),
				_Utils_Tuple2('end_date', endDate)
			]),
		$author$project$Path$base(
			_List_fromArray(
				['app', 'debtor_changes'])));
};
var $author$project$Components$DebtorChanges$IndexPage$formRange = F2(
	function (data, model) {
		var _v0 = _Utils_Tuple2(
			model.draft,
			$author$project$Forward$Remote$toMaybe(data));
		if (_v0.a.$ === 'Just') {
			var draft = _v0.a.a;
			return draft;
		} else {
			if (_v0.b.$ === 'Just') {
				var _v1 = _v0.a;
				var report = _v0.b.a;
				return {endDate: report.endDate, startDate: report.startDate};
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return model.range;
			}
		}
	});
var $author$project$HubTran$InspectableEffect$replaceUrl = function (url) {
	return $author$project$HubTran$InspectableEffect$ReplaceUrl(url);
};
var $author$project$HubTran$Effect$replaceUrl = function (url) {
	return $author$project$HubTran$Effect$InspectableEffect(
		$author$project$HubTran$InspectableEffect$replaceUrl(url));
};
var $author$project$Components$DebtorChanges$IndexPage$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'GotTimezone':
				var timezone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: timezone}),
					$author$project$HubTran$Effect$none);
			case 'ChangedStartDate':
				var startDate = msg.a;
				var shown = A2($author$project$Components$DebtorChanges$IndexPage$formRange, data, model);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							draft: $elm$core$Maybe$Just(
								_Utils_update(
									shown,
									{startDate: startDate}))
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangedEndDate':
				var endDate = msg.a;
				var shown = A2($author$project$Components$DebtorChanges$IndexPage$formRange, data, model);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							draft: $elm$core$Maybe$Just(
								_Utils_update(
									shown,
									{endDate: endDate}))
						}),
					$author$project$HubTran$Effect$none);
			case 'Applied':
				var range = A2($author$project$Components$DebtorChanges$IndexPage$formRange, data, model);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{draft: $elm$core$Maybe$Nothing, invoicePage: 1, range: range, template: $author$project$Components$DebtorChanges$IndexPage$AnyTemplate, templatePage: 1}),
					$author$project$HubTran$Effect$replaceUrl(
						$author$project$Path$toString(
							$author$project$Path$debtorChanges(range))));
			case 'SelectedOutcome':
				var outcome = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{invoicePage: 1, outcome: outcome}),
					$author$project$HubTran$Effect$none);
			case 'SelectedTemplate':
				var template = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{invoicePage: 1, template: template}),
					$author$project$HubTran$Effect$none);
			case 'UpdatedTemplatePage':
				var templatePage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{templatePage: templatePage}),
					$author$project$HubTran$Effect$none);
			default:
				var invoicePage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{invoicePage: invoicePage}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$DebtorChanges$IndexPage$Applied = {$: 'Applied'};
var $author$project$Components$DebtorChanges$IndexPage$ChangedEndDate = function (a) {
	return {$: 'ChangedEndDate', a: a};
};
var $author$project$Components$DebtorChanges$IndexPage$ChangedStartDate = function (a) {
	return {$: 'ChangedStartDate', a: a};
};
var $author$project$Ui$V3$Stack$GapAttribute = function (a) {
	return {$: 'GapAttribute', a: a};
};
var $author$project$Ui$V3$Stack$gap = $author$project$Ui$V3$Stack$GapAttribute;
var $author$project$Ui$V3$Stack$Padding = function (a) {
	return {$: 'Padding', a: a};
};
var $author$project$Ui$V3$Stack$PaddingAttribute = function (a) {
	return {$: 'PaddingAttribute', a: a};
};
var $author$project$Ui$V3$Stack$padding = function (v) {
	return $author$project$Ui$V3$Stack$PaddingAttribute(
		$author$project$Ui$V3$Stack$Padding(v));
};
var $author$project$Ui$V3$Stack$SpatialUnit = function (a) {
	return {$: 'SpatialUnit', a: a};
};
var $author$project$Ui$V3$Stack$spaceMedium = $author$project$Ui$V3$Stack$SpatialUnit('m');
var $author$project$Helpers$Html$v3ReskinContainer = function (node) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('enable_shared-ui-v3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__theme audit_v3_reskin')
					]),
				_List_fromArray(
					[node]))
			]));
};
var $author$project$Ui$V3$Stack$CrossAxisAttribute = function (a) {
	return {$: 'CrossAxisAttribute', a: a};
};
var $author$project$Ui$V3$Stack$CrossAxisBottom = {$: 'CrossAxisBottom'};
var $author$project$Ui$V3$Stack$crossAxisBottom = $author$project$Ui$V3$Stack$CrossAxisAttribute($author$project$Ui$V3$Stack$CrossAxisBottom);
var $author$project$Ui$V3$Input$TypeAttribute = function (a) {
	return {$: 'TypeAttribute', a: a};
};
var $author$project$Ui$V3$Input$date = $author$project$Ui$V3$Input$TypeAttribute('date');
var $author$project$Ui$V3$Stack$Basis = function (a) {
	return {$: 'Basis', a: a};
};
var $author$project$Ui$V3$Stack$fit = $author$project$Ui$V3$Stack$Basis('fit');
var $author$project$Ui$V3$Stack$BasisPx = function (a) {
	return {$: 'BasisPx', a: a};
};
var $author$project$Ui$V3$Stack$fitPx = $author$project$Ui$V3$Stack$BasisPx;
var $author$project$Ui$V3$Stack$flex1 = $author$project$Ui$V3$Stack$Basis('flex-1');
var $author$project$Ui$V3$Stack$spaceXXSmall = $author$project$Ui$V3$Stack$SpatialUnit('xxs');
var $author$project$Ui$V3$Stack$StyleAsAttribute = function (a) {
	return {$: 'StyleAsAttribute', a: a};
};
var $author$project$Ui$V3$Stack$StyleAsLabel = {$: 'StyleAsLabel'};
var $author$project$Ui$V3$Stack$styleAsLabel = $author$project$Ui$V3$Stack$StyleAsAttribute($author$project$Ui$V3$Stack$StyleAsLabel);
var $author$project$Ui$V3$Stack$defaultAttributes = {background: $elm$core$Maybe$Nothing, backgroundOnHover: $elm$core$Maybe$Nothing, border: $elm$core$Maybe$Nothing, classes: _List_Nil, crossAxisAlign: $elm$core$Maybe$Nothing, gap: $elm$core$Maybe$Nothing, hideOnPrint: false, htmlAttributes: _List_Nil, linkHref: $elm$core$Maybe$Nothing, mainAxis: $elm$core$Maybe$Nothing, onEvents: _List_Nil, padding: $elm$core$Maybe$Nothing, styleAs: $elm$core$Maybe$Nothing, styles: _List_Nil, tabIndex: $elm$core$Maybe$Nothing, testId: $elm$core$Maybe$Nothing};
var $author$project$Ui$V3$Stack$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'GapAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							gap: $elm$core$Maybe$Just(value)
						});
				case 'ClassAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							classes: _Utils_ap(
								acc.classes,
								_List_fromArray(
									[value]))
						});
				case 'CrossAxisAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							crossAxisAlign: $elm$core$Maybe$Just(value)
						});
				case 'MainAxisAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							mainAxis: $elm$core$Maybe$Just(value)
						});
				case 'StyleAsAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							styleAs: $elm$core$Maybe$Just(value)
						});
				case 'PaddingAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							padding: $elm$core$Maybe$Just(value)
						});
				case 'BackgroundAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							background: $elm$core$Maybe$Just(value)
						});
				case 'BackgroundOnHoverAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							backgroundOnHover: $elm$core$Maybe$Just(value)
						});
				case 'BorderAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							border: $elm$core$Maybe$Just(value)
						});
				case 'OnEventAttribute':
					var name = a.a;
					var decoder = a.b;
					return _Utils_update(
						acc,
						{
							onEvents: A2(
								$elm$core$List$cons,
								_Utils_Tuple2(name, decoder),
								acc.onEvents)
						});
				case 'TabIndexAttribute':
					var index = a.a;
					return _Utils_update(
						acc,
						{tabIndex: index});
				case 'StyleAttribute':
					var v = a.a;
					return _Utils_update(
						acc,
						{
							styles: _Utils_ap(
								acc.styles,
								_List_fromArray(
									[v]))
						});
				case 'HtmlAttribute':
					var v = a.a;
					return _Utils_update(
						acc,
						{
							htmlAttributes: _Utils_ap(
								acc.htmlAttributes,
								_List_fromArray(
									[v]))
						});
				case 'HideOnPrint':
					return _Utils_update(
						acc,
						{hideOnPrint: true});
				case 'TestIdAttribute':
					var id = a.a;
					return _Utils_update(
						acc,
						{
							testId: $elm$core$Maybe$Just(id)
						});
				default:
					var href = a.a;
					var maybeTarget = a.b;
					return _Utils_update(
						acc,
						{
							linkHref: $elm$core$Maybe$Just(
								_Utils_Tuple2(href, maybeTarget))
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Stack$defaultAttributes, attributes);
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Ui$V3$Stack$interactionAttributes = function (eventSettings) {
	var interactionClass = A2(
		$elm$core$List$any,
		function (_v1) {
			var name = _v1.a;
			return (name === 'click') || ((name === 'dblclick') || (name === 'auxclick'));
		},
		eventSettings) ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('v3__stack--clickable')
		]) : _List_Nil;
	return _Utils_ap(
		interactionClass,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var eventName = _v0.a;
				var eventDecoder = _v0.b;
				return A2($elm$html$Html$Events$custom, eventName, eventDecoder);
			},
			eventSettings));
};
var $elm_community$html_extra$Html$Attributes$Extra$empty = $elm$html$Html$Attributes$classList(_List_Nil);
var $author$project$Ui$V3$Stack$maybeAlign = F2(
	function (prefix, alignVal) {
		if (alignVal.$ === 'Nothing') {
			return $elm_community$html_extra$Html$Attributes$Extra$empty;
		} else {
			var v = alignVal.a;
			switch (v.$) {
				case 'CrossAxisStretch':
					return $elm$html$Html$Attributes$class(prefix + 'stretch');
				case 'CrossAxisCenter':
					return $elm$html$Html$Attributes$class(prefix + 'center');
				case 'CrossAxisLeft':
					return $elm$html$Html$Attributes$class(prefix + 'left');
				case 'CrossAxisRight':
					return $elm$html$Html$Attributes$class(prefix + 'right');
				case 'CrossAxisTop':
					return $elm$html$Html$Attributes$class(prefix + 'top');
				case 'CrossAxisBottom':
					return $elm$html$Html$Attributes$class(prefix + 'bottom');
				default:
					return $elm$html$Html$Attributes$class(prefix + 'baseline');
			}
		}
	});
var $author$project$Ui$V3$Colors$colorName = function (c) {
	switch (c.$) {
		case 'Red50':
			return 'red-50';
		case 'Red100':
			return 'red-100';
		case 'Red150':
			return 'red-150';
		case 'Red200':
			return 'red-200';
		case 'Red300':
			return 'red-300';
		case 'Red400':
			return 'red-400';
		case 'Red500':
			return 'red-500';
		case 'Red600':
			return 'red-600';
		case 'Red700':
			return 'red-700';
		case 'Red800':
			return 'red-800';
		case 'Red900':
			return 'red-900';
		case 'Orange50':
			return 'orange-50';
		case 'Orange100':
			return 'orange-100';
		case 'Orange150':
			return 'orange-150';
		case 'Orange200':
			return 'orange-200';
		case 'Orange300':
			return 'orange-300';
		case 'Orange400':
			return 'orange-400';
		case 'Orange500':
			return 'orange-500';
		case 'Orange600':
			return 'orange-600';
		case 'Orange700':
			return 'orange-700';
		case 'Orange800':
			return 'orange-800';
		case 'Orange900':
			return 'orange-900';
		case 'Yellow50':
			return 'yellow-50';
		case 'Yellow100':
			return 'yellow-100';
		case 'Yellow150':
			return 'yellow-150';
		case 'Yellow200':
			return 'yellow-200';
		case 'Yellow300':
			return 'yellow-300';
		case 'Yellow400':
			return 'yellow-400';
		case 'Yellow500':
			return 'yellow-500';
		case 'Yellow600':
			return 'yellow-600';
		case 'Yellow700':
			return 'yellow-700';
		case 'Yellow800':
			return 'yellow-800';
		case 'Yellow900':
			return 'yellow-900';
		case 'Green50':
			return 'green-50';
		case 'Green100':
			return 'green-100';
		case 'Green150':
			return 'green-150';
		case 'Green200':
			return 'green-200';
		case 'Green300':
			return 'green-300';
		case 'Green400':
			return 'green-400';
		case 'Green500':
			return 'green-500';
		case 'Green600':
			return 'green-600';
		case 'Green700':
			return 'green-700';
		case 'Green800':
			return 'green-800';
		case 'Green900':
			return 'green-900';
		case 'Teal50':
			return 'teal-50';
		case 'Teal100':
			return 'teal-100';
		case 'Teal150':
			return 'teal-150';
		case 'Teal200':
			return 'teal-200';
		case 'Teal300':
			return 'teal-300';
		case 'Teal400':
			return 'teal-400';
		case 'Teal500':
			return 'teal-500';
		case 'Teal600':
			return 'teal-600';
		case 'Teal700':
			return 'teal-700';
		case 'Teal800':
			return 'teal-800';
		case 'Teal900':
			return 'teal-900';
		case 'Blue50':
			return 'blue-50';
		case 'Blue100':
			return 'blue-100';
		case 'Blue150':
			return 'blue-150';
		case 'Blue200':
			return 'blue-200';
		case 'Blue300':
			return 'blue-300';
		case 'Blue400':
			return 'blue-400';
		case 'Blue500':
			return 'blue-500';
		case 'Blue600':
			return 'blue-600';
		case 'Blue700':
			return 'blue-700';
		case 'Blue800':
			return 'blue-800';
		case 'Blue900':
			return 'blue-900';
		case 'Navy50':
			return 'navy-50';
		case 'Navy100':
			return 'navy-100';
		case 'Navy150':
			return 'navy-150';
		case 'Navy200':
			return 'navy-200';
		case 'Navy300':
			return 'navy-300';
		case 'Navy400':
			return 'navy-400';
		case 'Navy450':
			return 'navy-450';
		case 'Navy500':
			return 'navy-500';
		case 'Navy600':
			return 'navy-600';
		case 'Navy650':
			return 'navy-650';
		case 'Navy700':
			return 'navy-700';
		case 'Navy750':
			return 'navy-750';
		case 'Navy800':
			return 'navy-800';
		case 'Navy850':
			return 'navy-850';
		case 'Navy900':
			return 'navy-900';
		case 'Purple50':
			return 'purple-50';
		case 'Purple100':
			return 'purple-100';
		case 'Purple150':
			return 'purple-150';
		case 'Purple200':
			return 'purple-200';
		case 'Purple300':
			return 'purple-300';
		case 'Purple400':
			return 'purple-400';
		case 'Purple500':
			return 'purple-500';
		case 'Purple600':
			return 'purple-600';
		case 'Purple700':
			return 'purple-700';
		case 'Purple800':
			return 'purple-800';
		case 'Purple900':
			return 'purple-900';
		case 'Turquoise50':
			return 'turquoise-50';
		case 'Turquoise100':
			return 'turquoise-100';
		case 'Turquoise150':
			return 'turquoise-150';
		case 'Turquoise200':
			return 'turquoise-200';
		case 'Turquoise300':
			return 'turquoise-300';
		case 'Turquoise400':
			return 'turquoise-400';
		case 'Turquoise500':
			return 'turquoise-500';
		case 'Turquoise600':
			return 'turquoise-600';
		case 'Turquoise700':
			return 'turquoise-700';
		case 'Turquoise800':
			return 'turquoise-800';
		case 'Turquoise900':
			return 'turquoise-900';
		case 'Pink50':
			return 'pink-50';
		case 'Pink100':
			return 'pink-100';
		case 'Pink150':
			return 'pink-150';
		case 'Pink200':
			return 'pink-200';
		case 'Pink300':
			return 'pink-300';
		case 'Pink400':
			return 'pink-400';
		case 'Pink500':
			return 'pink-500';
		case 'Pink600':
			return 'pink-600';
		case 'Pink700':
			return 'pink-700';
		case 'Pink800':
			return 'pink-800';
		case 'Pink900':
			return 'pink-900';
		case 'Gray0':
			return 'gray-0';
		case 'Gray50':
			return 'gray-50';
		case 'Gray100':
			return 'gray-100';
		case 'Gray150':
			return 'gray-150';
		case 'Gray200':
			return 'gray-200';
		case 'Gray300':
			return 'gray-300';
		case 'Gray400':
			return 'gray-400';
		case 'Gray450':
			return 'gray-450';
		case 'Gray500':
			return 'gray-500';
		case 'Gray600':
			return 'gray-600';
		case 'Gray650':
			return 'gray-650';
		case 'Gray700':
			return 'gray-700';
		case 'Gray750':
			return 'gray-750';
		case 'Gray800':
			return 'gray-800';
		case 'Gray850':
			return 'gray-850';
		case 'Gray900':
			return 'gray-900';
		case 'NeutralStrong50':
			return 'neutral-strong-50';
		case 'NeutralStrong100':
			return 'neutral-strong-100';
		case 'NeutralStrong150':
			return 'neutral-strong-150';
		case 'NeutralStrong200':
			return 'neutral-strong-200';
		case 'NeutralStrong300':
			return 'neutral-strong-300';
		case 'NeutralStrong400':
			return 'neutral-strong-400';
		case 'NeutralStrong450':
			return 'neutral-strong-450';
		case 'NeutralStrong500':
			return 'neutral-strong-500';
		case 'NeutralStrong600':
			return 'neutral-strong-600';
		case 'NeutralStrong650':
			return 'neutral-strong-650';
		case 'NeutralStrong700':
			return 'neutral-strong-700';
		case 'NeutralStrong750':
			return 'neutral-strong-750';
		case 'NeutralStrong800':
			return 'neutral-strong-800';
		case 'NeutralStrong850':
			return 'neutral-strong-850';
		case 'NeutralStrong900':
			return 'neutral-strong-900';
		case 'SiblingAPrimary50':
			return 'sibling-a-primary-50';
		case 'SiblingAPrimary100':
			return 'sibling-a-primary-100';
		case 'SiblingAPrimary150':
			return 'sibling-a-primary-150';
		case 'SiblingAPrimary200':
			return 'sibling-a-primary-200';
		case 'SiblingAPrimary300':
			return 'sibling-a-primary-300';
		case 'SiblingAPrimary400':
			return 'sibling-a-primary-400';
		case 'SiblingAPrimary500':
			return 'sibling-a-primary-500';
		case 'SiblingAPrimary600':
			return 'sibling-a-primary-600';
		case 'SiblingAPrimary700':
			return 'sibling-a-primary-700';
		case 'SiblingAPrimary800':
			return 'sibling-a-primary-800';
		case 'SiblingAPrimary900':
			return 'sibling-a-primary-900';
		case 'SiblingAAccentA50':
			return 'sibling-a-accent-a-50';
		case 'SiblingAAccentA100':
			return 'sibling-a-accent-a-100';
		case 'SiblingAAccentA150':
			return 'sibling-a-accent-a-150';
		case 'SiblingAAccentA200':
			return 'sibling-a-accent-a-200';
		case 'SiblingAAccentA300':
			return 'sibling-a-accent-a-300';
		case 'SiblingAAccentA400':
			return 'sibling-a-accent-a-400';
		case 'SiblingAAccentA500':
			return 'sibling-a-accent-a-500';
		case 'SiblingAAccentA600':
			return 'sibling-a-accent-a-600';
		case 'SiblingAAccentA700':
			return 'sibling-a-accent-a-700';
		case 'SiblingAAccentA800':
			return 'sibling-a-accent-a-800';
		case 'SiblingAAccentA900':
			return 'sibling-a-accent-a-900';
		case 'SiblingAAccentB50':
			return 'sibling-a-accent-b-50';
		case 'SiblingAAccentB100':
			return 'sibling-a-accent-b-100';
		case 'SiblingAAccentB150':
			return 'sibling-a-accent-b-150';
		case 'SiblingAAccentB200':
			return 'sibling-a-accent-b-200';
		case 'SiblingAAccentB300':
			return 'sibling-a-accent-b-300';
		case 'SiblingAAccentB400':
			return 'sibling-a-accent-b-400';
		case 'SiblingAAccentB500':
			return 'sibling-a-accent-b-500';
		case 'SiblingAAccentB600':
			return 'sibling-a-accent-b-600';
		case 'SiblingAAccentB700':
			return 'sibling-a-accent-b-700';
		case 'SiblingAAccentB800':
			return 'sibling-a-accent-b-800';
		case 'SiblingAAccentB900':
			return 'sibling-a-accent-b-900';
		case 'SiblingBPrimary50':
			return 'sibling-b-primary-50';
		case 'SiblingBPrimary100':
			return 'sibling-b-primary-100';
		case 'SiblingBPrimary150':
			return 'sibling-b-primary-150';
		case 'SiblingBPrimary200':
			return 'sibling-b-primary-200';
		case 'SiblingBPrimary300':
			return 'sibling-b-primary-300';
		case 'SiblingBPrimary400':
			return 'sibling-b-primary-400';
		case 'SiblingBPrimary500':
			return 'sibling-b-primary-500';
		case 'SiblingBPrimary600':
			return 'sibling-b-primary-600';
		case 'SiblingBPrimary700':
			return 'sibling-b-primary-700';
		case 'SiblingBPrimary800':
			return 'sibling-b-primary-800';
		case 'SiblingBPrimary900':
			return 'sibling-b-primary-900';
		case 'SiblingBAccentA50':
			return 'sibling-b-accent-a-50';
		case 'SiblingBAccentA100':
			return 'sibling-b-accent-a-100';
		case 'SiblingBAccentA150':
			return 'sibling-b-accent-a-150';
		case 'SiblingBAccentA200':
			return 'sibling-b-accent-a-200';
		case 'SiblingBAccentA300':
			return 'sibling-b-accent-a-300';
		case 'SiblingBAccentA400':
			return 'sibling-b-accent-a-400';
		case 'SiblingBAccentA500':
			return 'sibling-b-accent-a-500';
		case 'SiblingBAccentA600':
			return 'sibling-b-accent-a-600';
		case 'SiblingBAccentA700':
			return 'sibling-b-accent-a-700';
		case 'SiblingBAccentA800':
			return 'sibling-b-accent-a-800';
		case 'SiblingBAccentA900':
			return 'sibling-b-accent-a-900';
		case 'SiblingBAccentB50':
			return 'sibling-b-accent-b-50';
		case 'SiblingBAccentB100':
			return 'sibling-b-accent-b-100';
		case 'SiblingBAccentB150':
			return 'sibling-b-accent-b-150';
		case 'SiblingBAccentB200':
			return 'sibling-b-accent-b-200';
		case 'SiblingBAccentB300':
			return 'sibling-b-accent-b-300';
		case 'SiblingBAccentB400':
			return 'sibling-b-accent-b-400';
		case 'SiblingBAccentB500':
			return 'sibling-b-accent-b-500';
		case 'SiblingBAccentB600':
			return 'sibling-b-accent-b-600';
		case 'SiblingBAccentB700':
			return 'sibling-b-accent-b-700';
		case 'SiblingBAccentB800':
			return 'sibling-b-accent-b-800';
		case 'SiblingBAccentB900':
			return 'sibling-b-accent-b-900';
		case 'BackgroundNeutralContainer':
			return 'background-neutral-container';
		case 'BackgroundNeutralSubtle':
			return 'background-neutral-subtle';
		case 'BackgroundNeutralStrong':
			return 'background-neutral-strong';
		case 'BackgroundNeutralPage':
			return 'background-neutral-page';
		case 'BackgroundNeutralScrim':
			return 'background-neutral-scrim';
		case 'BackgroundNeutralStateHover':
			return 'background-neutral-state-hover';
		case 'BackgroundNeutralStateFocus':
			return 'background-neutral-state-focus';
		case 'BackgroundNeutralStatePressed':
			return 'background-neutral-state-pressed';
		case 'BackgroundNeutralStateSelected':
			return 'background-neutral-state-selected';
		case 'BackgroundNeutralStateDisabledDefault':
			return 'background-neutral-state-disabled-default';
		case 'BackgroundNeutralStateDisabledStrong':
			return 'background-neutral-state-disabled-strong';
		case 'BackgroundBrandDefaultStrong':
			return 'background-brand-default-strong';
		case 'BackgroundBrandHoverStrong':
			return 'background-brand-hover-strong';
		case 'BackgroundBrandFocusStrong':
			return 'background-brand-focus-strong';
		case 'BackgroundBrandPressedStrong':
			return 'background-brand-pressed-strong';
		case 'BackgroundBrandSelectedStrong':
			return 'background-brand-selected-strong';
		case 'BackgroundBrandDefaultSubtle':
			return 'background-brand-default-subtle';
		case 'BackgroundBrandHoverSubtle':
			return 'background-brand-hover-subtle';
		case 'BackgroundBrandFocusSubtle':
			return 'background-brand-focus-subtle';
		case 'BackgroundBrandPressedSubtle':
			return 'background-brand-pressed-subtle';
		case 'BackgroundBrandSelectedSubtle':
			return 'background-brand-selected-subtle';
		case 'BackgroundBrandAlternativeDefault':
			return 'background-brand-alternative-default';
		case 'BackgroundBrandAlternativeHover':
			return 'background-brand-alternative-hover';
		case 'BackgroundBrandAlternativeFocus':
			return 'background-brand-alternative-focus';
		case 'BackgroundBrandAlternativePressed':
			return 'background-brand-alternative-pressed';
		case 'BackgroundBrandAlternativeSelected':
			return 'background-brand-alternative-selected';
		case 'BackgroundDangerDefaultStrong':
			return 'background-danger-default-strong';
		case 'BackgroundDangerHoverStrong':
			return 'background-danger-hover-strong';
		case 'BackgroundDangerFocusStrong':
			return 'background-danger-focus-strong';
		case 'BackgroundDangerPressedStrong':
			return 'background-danger-pressed-strong';
		case 'BackgroundDangerDefaultSubtle':
			return 'background-danger-default-subtle';
		case 'BackgroundDangerHoverSubtle':
			return 'background-danger-hover-subtle';
		case 'BackgroundDangerFocusSubtle':
			return 'background-danger-focus-subtle';
		case 'BackgroundDangerPressedSubtle':
			return 'background-danger-pressed-subtle';
		case 'BackgroundFeedbackErrorStrong':
			return 'background-feedback-error-strong';
		case 'BackgroundFeedbackErrorSubtle':
			return 'background-feedback-error-subtle';
		case 'BackgroundFeedbackSuccessStrong':
			return 'background-feedback-success-strong';
		case 'BackgroundFeedbackSuccessSubtle':
			return 'background-feedback-success-subtle';
		case 'BackgroundFeedbackWarningStrong':
			return 'background-feedback-warning-strong';
		case 'BackgroundFeedbackWarningSubtle':
			return 'background-feedback-warning-subtle';
		case 'BackgroundFeedbackInfoStrong':
			return 'background-feedback-info-strong';
		case 'BackgroundFeedbackInfoSubtle':
			return 'background-feedback-info-subtle';
		case 'BackgroundFeedbackNeutralStrong':
			return 'background-feedback-neutral-strong';
		case 'BackgroundFeedbackNeutralSubtle':
			return 'background-feedback-neutral-subtle';
		case 'BackgroundChartingSequentialBrand1':
			return 'background-charting-sequential-brand-1';
		case 'BackgroundChartingSequentialBrand2':
			return 'background-charting-sequential-brand-2';
		case 'BackgroundChartingSequentialBrand3':
			return 'background-charting-sequential-brand-3';
		case 'BackgroundChartingSequentialBrand4':
			return 'background-charting-sequential-brand-4';
		case 'BackgroundChartingSequentialBrand5':
			return 'background-charting-sequential-brand-5';
		case 'BackgroundChartingSequentialBrand6':
			return 'background-charting-sequential-brand-6';
		case 'BackgroundChartingSequentialAccent1':
			return 'background-charting-sequential-accent-1';
		case 'BackgroundChartingSequentialAccent2':
			return 'background-charting-sequential-accent-2';
		case 'BackgroundChartingSequentialAccent3':
			return 'background-charting-sequential-accent-3';
		case 'BackgroundChartingSequentialAccent4':
			return 'background-charting-sequential-accent-4';
		case 'BackgroundChartingSequentialAccent5':
			return 'background-charting-sequential-accent-5';
		case 'BackgroundChartingSequentialAccent6':
			return 'background-charting-sequential-accent-6';
		case 'BorderNeutralDefault':
			return 'border-neutral-default';
		case 'BorderNeutralStrong':
			return 'border-neutral-strong';
		case 'BorderNeutralHover':
			return 'border-neutral-hover';
		case 'BorderNeutralFocus':
			return 'border-neutral-focus';
		case 'BorderNeutralPressed':
			return 'border-neutral-pressed';
		case 'BorderNeutralSelected':
			return 'border-neutral-selected';
		case 'BorderNeutralDisabledStrong':
			return 'border-neutral-disabled-strong';
		case 'BorderNeutralDisabledSubtle':
			return 'border-neutral-disabled-subtle';
		case 'BorderBrandDefaultStrong':
			return 'border-brand-default-strong';
		case 'BorderBrandDefaultSubtle':
			return 'border-brand-default-subtle';
		case 'BorderBrandHover':
			return 'border-brand-hover';
		case 'BorderBrandFocus':
			return 'border-brand-focus';
		case 'BorderBrandPressed':
			return 'border-brand-pressed';
		case 'BorderBrandSelected':
			return 'border-brand-selected';
		case 'BorderDangerDefault':
			return 'border-danger-default';
		case 'BorderDangerHover':
			return 'border-danger-hover';
		case 'BorderDangerFocus':
			return 'border-danger-focus';
		case 'BorderDangerPressed':
			return 'border-danger-pressed';
		case 'BorderFeedbackErrorStrong':
			return 'border-feedback-error-strong';
		case 'BorderFeedbackErrorSubtle':
			return 'border-feedback-error-subtle';
		case 'BorderFeedbackSuccess':
			return 'border-feedback-success';
		case 'BorderFeedbackWarning':
			return 'border-feedback-warning';
		case 'BorderFeedbackInfo':
			return 'border-feedback-info';
		case 'BorderFeedbackNeutral':
			return 'border-feedback-neutral';
		case 'TextNeutralDefault':
			return 'text-neutral-default';
		case 'TextNeutralSubtle':
			return 'text-neutral-subtle';
		case 'TextNeutralPlaceholder':
			return 'text-neutral-placeholder';
		case 'TextNeutralInverted':
			return 'text-neutral-inverted';
		case 'TextNeutralOnStrong':
			return 'text-neutral-on-strong';
		case 'TextNeutralOnSubtle':
			return 'text-neutral-on-subtle';
		case 'TextNeutralDisabledDefault':
			return 'text-neutral-disabled-default';
		case 'TextNeutralDisabledStrong':
			return 'text-neutral-disabled-strong';
		case 'TextNeutralNull':
			return 'text-neutral-null';
		case 'TextBrandDefault':
			return 'text-brand-default';
		case 'TextBrandOn':
			return 'text-brand-on';
		case 'TextBrandHover':
			return 'text-brand-hover';
		case 'TextBrandFocus':
			return 'text-brand-focus';
		case 'TextBrandPressed':
			return 'text-brand-pressed';
		case 'TextBrandSelected':
			return 'text-brand-selected';
		case 'TextBrandAlternativeDefault':
			return 'text-brand-alternative-default';
		case 'TextBrandAlternativeHover':
			return 'text-brand-alternative-hover';
		case 'TextBrandAlternativeFocus':
			return 'text-brand-alternative-focus';
		case 'TextBrandAlternativePressed':
			return 'text-brand-alternative-pressed';
		case 'TextBrandAlternativeSelected':
			return 'text-brand-alternative-selected';
		case 'TextEmphasisPositive':
			return 'text-emphasis-positive';
		case 'TextEmphasisNegative':
			return 'text-emphasis-negative';
		case 'TextDangerDefault':
			return 'text-danger-default';
		case 'TextDangerHover':
			return 'text-danger-hover';
		case 'TextDangerFocus':
			return 'text-danger-focus';
		case 'TextDangerPressed':
			return 'text-danger-pressed';
		case 'TextDangerOn':
			return 'text-danger-on';
		case 'TextFeedbackError':
			return 'text-feedback-error';
		case 'TextFeedbackSuccess':
			return 'text-feedback-success';
		case 'TextFeedbackWarning':
			return 'text-feedback-warning';
		case 'TextFeedbackInfo':
			return 'text-feedback-info';
		case 'TextFeedbackNeutral':
			return 'text-feedback-neutral';
		case 'IconNeutralDefault':
			return 'icon-neutral-default';
		case 'IconNeutralSubtle':
			return 'icon-neutral-subtle';
		case 'IconNeutralHover':
			return 'icon-neutral-hover';
		case 'IconNeutralSubtleHover':
			return 'icon-neutral-subtle-hover';
		case 'IconNeutralInverted':
			return 'icon-neutral-inverted';
		case 'IconNeutralFocus':
			return 'icon-neutral-focus';
		case 'IconNeutralPressed':
			return 'icon-neutral-pressed';
		case 'IconNeutralDisabled':
			return 'icon-neutral-disabled';
		case 'IconBrandDefault':
			return 'icon-brand-default';
		case 'IconBrandHover':
			return 'icon-brand-hover';
		case 'IconBrandFocus':
			return 'icon-brand-focus';
		case 'IconBrandPressed':
			return 'icon-brand-pressed';
		case 'IconBrandSelected':
			return 'icon-brand-selected';
		case 'IconBrandOn':
			return 'icon-brand-on';
		case 'IconDangerDefault':
			return 'icon-danger-default';
		case 'IconDangerHover':
			return 'icon-danger-hover';
		case 'IconDangerFocus':
			return 'icon-danger-focus';
		case 'IconDangerPressed':
			return 'icon-danger-pressed';
		case 'IconFeedbackErrorStrong':
			return 'icon-feedback-error-strong';
		case 'IconFeedbackErrorSubtle':
			return 'icon-feedback-error-subtle';
		case 'IconFeedbackSuccessStrong':
			return 'icon-feedback-success-strong';
		case 'IconFeedbackSuccessSubtle':
			return 'icon-feedback-success-subtle';
		case 'IconFeedbackWarningStrong':
			return 'icon-feedback-warning-strong';
		case 'IconFeedbackWarningSubtle':
			return 'icon-feedback-warning-subtle';
		case 'IconFeedbackInfoStrong':
			return 'icon-feedback-info-strong';
		case 'IconFeedbackInfoSubtle':
			return 'icon-feedback-info-subtle';
		case 'IconFeedbackNeutralStrong':
			return 'icon-feedback-neutral-strong';
		case 'GradientPrimaryStrong':
			return 'gradient-primary-strong';
		case 'GradientAccentStrong':
			return 'gradient-accent-strong';
		case 'GradientPrimarySubtle':
			return 'gradient-primary-subtle';
		case 'GradientAccentSubtle':
			return 'gradient-accent-subtle';
		case 'EffectFocus':
			return 'effect-focus';
		case 'EffectHover':
			return 'effect-hover';
		case 'EffectGap':
			return 'effect-gap';
		case 'EffectShadowAmbient':
			return 'effect-shadow-ambient';
		case 'EffectShadowDiffuse':
			return 'effect-shadow-diffuse';
		case 'EffectContainer':
			return 'effect-container';
		case 'ChartingCategoricalStrong1':
			return 'charting-categorical-strong-1';
		case 'ChartingCategoricalStrong2':
			return 'charting-categorical-strong-2';
		case 'ChartingCategoricalStrong3':
			return 'charting-categorical-strong-3';
		case 'ChartingCategoricalStrong4':
			return 'charting-categorical-strong-4';
		case 'ChartingCategoricalStrong5':
			return 'charting-categorical-strong-5';
		case 'ChartingCategoricalStrong6':
			return 'charting-categorical-strong-6';
		case 'ChartingCategoricalStrong7':
			return 'charting-categorical-strong-7';
		case 'ChartingCategoricalStrong8':
			return 'charting-categorical-strong-8';
		case 'ChartingCategoricalStrong9':
			return 'charting-categorical-strong-9';
		case 'ChartingCategoricalStrong10':
			return 'charting-categorical-strong-10';
		case 'ChartingCategoricalStrong11':
			return 'charting-categorical-strong-11';
		case 'ChartingCategoricalStrong12':
			return 'charting-categorical-strong-12';
		case 'ChartingCategoricalSubtle1':
			return 'charting-categorical-subtle-1';
		case 'ChartingCategoricalSubtle2':
			return 'charting-categorical-subtle-2';
		case 'ChartingCategoricalSubtle3':
			return 'charting-categorical-subtle-3';
		case 'ChartingCategoricalSubtle4':
			return 'charting-categorical-subtle-4';
		case 'ChartingCategoricalSubtle5':
			return 'charting-categorical-subtle-5';
		case 'ChartingCategoricalSubtle6':
			return 'charting-categorical-subtle-6';
		case 'ChartingCategoricalSubtle7':
			return 'charting-categorical-subtle-7';
		case 'ChartingCategoricalSubtle8':
			return 'charting-categorical-subtle-8';
		case 'ChartingCategoricalSubtle9':
			return 'charting-categorical-subtle-9';
		case 'ChartingCategoricalSubtle10':
			return 'charting-categorical-subtle-10';
		case 'ChartingCategoricalSubtle11':
			return 'charting-categorical-subtle-11';
		case 'ChartingCategoricalSubtle12':
			return 'charting-categorical-subtle-12';
		case 'BackgroundChartingCategorical1':
			return 'background-charting-categorical-1';
		case 'BackgroundChartingCategorical2':
			return 'background-charting-categorical-2';
		case 'BackgroundChartingCategorical3':
			return 'background-charting-categorical-3';
		case 'BackgroundChartingCategorical4':
			return 'background-charting-categorical-4';
		case 'BackgroundChartingCategorical5':
			return 'background-charting-categorical-5';
		case 'BackgroundChartingCategorical6':
			return 'background-charting-categorical-6';
		case 'BackgroundChartingCategorical7':
			return 'background-charting-categorical-7';
		case 'BackgroundChartingCategorical8':
			return 'background-charting-categorical-8';
		case 'BackgroundChartingCategorical9':
			return 'background-charting-categorical-9';
		case 'BackgroundChartingCategorical10':
			return 'background-charting-categorical-10';
		case 'BackgroundChartingCategorical11':
			return 'background-charting-categorical-11';
		case 'BackgroundChartingCategorical12':
			return 'background-charting-categorical-12';
		case 'BorderChartingCategorical1':
			return 'border-charting-categorical-1';
		case 'BorderChartingCategorical2':
			return 'border-charting-categorical-2';
		case 'BorderChartingCategorical3':
			return 'border-charting-categorical-3';
		case 'BorderChartingCategorical4':
			return 'border-charting-categorical-4';
		case 'BorderChartingCategorical5':
			return 'border-charting-categorical-5';
		case 'BorderChartingCategorical6':
			return 'border-charting-categorical-6';
		case 'TextChartingCategorical1':
			return 'text-charting-categorical-1';
		case 'TextChartingCategorical2':
			return 'text-charting-categorical-2';
		case 'TextChartingCategorical3':
			return 'text-charting-categorical-3';
		case 'TextChartingCategorical4':
			return 'text-charting-categorical-4';
		case 'TextChartingCategorical5':
			return 'text-charting-categorical-5';
		default:
			return 'text-charting-categorical-6';
	}
};
var $author$project$Ui$V3$Colors$cssVariable = function (c) {
	return 'var(--color-' + ($author$project$Ui$V3$Colors$colorName(c) + ')');
};
var $author$project$Ui$V3$Colors$backgroundColorAttribute = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$Attributes$style('background-color'),
	$author$project$Ui$V3$Colors$cssVariable);
var $author$project$Ui$V3$Stack$maybeBackground = function (maybeBackgroundVal) {
	if (maybeBackgroundVal.$ === 'Nothing') {
		return $elm_community$html_extra$Html$Attributes$Extra$empty;
	} else {
		var color = maybeBackgroundVal.a.a;
		return $author$project$Ui$V3$Colors$backgroundColorAttribute(color);
	}
};
var $author$project$Ui$V3$Colors$backgroundColorOnHoverAttribute = function (c) {
	return $elm$html$Html$Attributes$class(
		'bg-hover-color-' + $author$project$Ui$V3$Colors$colorName(c));
};
var $author$project$Ui$V3$Stack$maybeBackgroundOnHover = function (maybeBackgroundVal) {
	if (maybeBackgroundVal.$ === 'Nothing') {
		return $elm_community$html_extra$Html$Attributes$Extra$empty;
	} else {
		var color = maybeBackgroundVal.a.a;
		return $author$project$Ui$V3$Colors$backgroundColorOnHoverAttribute(color);
	}
};
var $author$project$Ui$V3$Helpers$Html$px = function (numPx) {
	return $elm$core$String$fromInt(numPx) + 'px';
};
var $author$project$Ui$V3$Stack$maybeBorder = function (maybeBorderVal) {
	if (maybeBorderVal.$ === 'Nothing') {
		return _List_Nil;
	} else {
		if (maybeBorderVal.a.$ === 'BorderInset') {
			var _v1 = maybeBorderVal.a;
			var width = _v1.a;
			var color = _v1.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'border-color',
					$author$project$Ui$V3$Colors$cssVariable(color)),
					A2(
					$elm$html$Html$Attributes$style,
					'box-shadow',
					'inset 0 0 0 ' + ($elm$core$String$fromInt(width) + ('px ' + $author$project$Ui$V3$Colors$cssVariable(color))))
				]);
		} else {
			var _v2 = maybeBorderVal.a;
			var width = _v2.a;
			var color = _v2.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'border-color',
					$author$project$Ui$V3$Colors$cssVariable(color)),
					A2(
					$elm$html$Html$Attributes$style,
					'border-width',
					$author$project$Ui$V3$Helpers$Html$px(width)),
					A2($elm$html$Html$Attributes$style, 'border-style', 'solid')
				]);
		}
	}
};
var $author$project$Ui$V3$Stack$maybeHideOnPrint = function (hideOnPrintVal) {
	return hideOnPrintVal ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('hide-on-print')
		]) : _List_Nil;
};
var $author$project$Ui$V3$Stack$maybeMainAxis = F2(
	function (prefix, mainAxisVal) {
		if (mainAxisVal.$ === 'Nothing') {
			return $elm_community$html_extra$Html$Attributes$Extra$empty;
		} else {
			var v = mainAxisVal.a;
			switch (v.$) {
				case 'MainAxisStart':
					return $elm$html$Html$Attributes$class(prefix + 'start');
				case 'MainAxisEnd':
					return $elm$html$Html$Attributes$class(prefix + 'end');
				case 'MainAxisCenter':
					return $elm$html$Html$Attributes$class(prefix + 'center');
				case 'MainAxisSpaceBetween':
					return $elm$html$Html$Attributes$class(prefix + 'space-between');
				case 'MainAxisSpaceAround':
					return $elm$html$Html$Attributes$class(prefix + 'space-around');
				default:
					return $elm$html$Html$Attributes$class(prefix + 'space-evenly');
			}
		}
	});
var $author$project$Ui$V3$Stack$maybePadding = F2(
	function (prefix, paddingVal) {
		if (paddingVal.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var v = paddingVal.a;
			var s = function (_v2) {
				var spactialUnit = _v2.a;
				return spactialUnit;
			};
			switch (v.$) {
				case 'Padding':
					var pv = v.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('p-' + s(pv)))
						]);
				case 'PaddingLeftRightTopBottom':
					var l = v.a;
					var r = v.b;
					var t = v.c;
					var b = v.d;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pl-' + s(l))),
							$elm$html$Html$Attributes$class(
							prefix + ('pr-' + s(r))),
							$elm$html$Html$Attributes$class(
							prefix + ('pt-' + s(t))),
							$elm$html$Html$Attributes$class(
							prefix + ('pb-' + s(b)))
						]);
				case 'PaddingLeftRight':
					var l = v.a;
					var r = v.b;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pl-' + s(l))),
							$elm$html$Html$Attributes$class(
							prefix + ('pr-' + s(r)))
						]);
				case 'PaddingTopBottom':
					var t = v.a;
					var b = v.b;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pt-' + s(t))),
							$elm$html$Html$Attributes$class(
							prefix + ('pb-' + s(b)))
						]);
				case 'PaddingTopHorzBottom':
					var t = v.a;
					var h = v.b;
					var b = v.c;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pt-' + s(t))),
							$elm$html$Html$Attributes$class(
							prefix + ('ph-' + s(h))),
							$elm$html$Html$Attributes$class(
							prefix + ('pb-' + s(b)))
						]);
				case 'PaddingTop':
					var t = v.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pt-' + s(t)))
						]);
				case 'PaddingBottom':
					var t = v.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pb-' + s(t)))
						]);
				case 'PaddingLeft':
					var l = v.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pl-' + s(l)))
						]);
				case 'PaddingVert':
					var pv = v.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pv-' + s(pv)))
						]);
				case 'PaddingHorz':
					var h = v.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('ph-' + s(h)))
						]);
				default:
					var pv = v.a;
					var ph = v.b;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							prefix + ('pv-' + s(pv))),
							$elm$html$Html$Attributes$class(
							prefix + ('ph-' + s(ph)))
						]);
			}
		}
	});
var $author$project$Ui$V3$Stack$maybeSpace = F2(
	function (prefix, maybeUnit) {
		if (maybeUnit.$ === 'Nothing') {
			return $elm_community$html_extra$Html$Attributes$Extra$empty;
		} else {
			var name = maybeUnit.a.a;
			return $elm$html$Html$Attributes$class(
				_Utils_ap(prefix, name));
		}
	});
var $author$project$Ui$V3$Stack$maybeStyleAs = F2(
	function (prefix, styleVal) {
		if (styleVal.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var v = styleVal.a;
			switch (v.$) {
				case 'StyleAsCard':
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(prefix + 'card')
						]);
				case 'StyleAsHoverableCard':
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(prefix + 'card'),
							$elm$html$Html$Attributes$class(prefix + 'card--hoverable')
						]);
				case 'StyleAsUl':
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(prefix + 'ul')
						]);
				case 'StyleAsLabel':
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(prefix + 'label')
						]);
				case 'StyleAsCardLabel':
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(prefix + 'card'),
							$elm$html$Html$Attributes$class(prefix + 'label')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class(prefix + 'card'),
							$elm$html$Html$Attributes$class(prefix + 'card-list')
						]);
			}
		}
	});
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$V3$Stack$maybeTabIndex = function (maybeIndex) {
	if (maybeIndex.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var index = maybeIndex.a;
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$tabindex(index)
			]);
	}
};
var $author$project$Ui$V3$Stack$maybeTestId = function (id) {
	if (id.$ === 'Just') {
		var id_ = id.a;
		return A2($elm$html$Html$Attributes$attribute, 'data-testid', id_);
	} else {
		return $elm_community$html_extra$Html$Attributes$Extra$empty;
	}
};
var $author$project$Ui$V3$Stack$viewCell = function (_v0) {
	var width = _v0.a;
	var child = _v0.b;
	var widthAttr = function () {
		if (width.$ === 'Basis') {
			var w = width.a;
			return $elm$html$Html$Attributes$class('v3__stack-cell--size-' + w);
		} else {
			var px_ = width.a;
			return A2(
				$elm$html$Html$Attributes$style,
				'flex-basis',
				$author$project$Ui$V3$Helpers$Html$px(px_));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__stack-cell'),
				widthAttr
			]),
		_List_fromArray(
			[child]));
};
var $author$project$Ui$V3$Stack$viewWithWidths = F3(
	function (vertHorzClass, attributes, childrenWithWidths) {
		var computed = $author$project$Ui$V3$Stack$computeAttributes(attributes);
		var el = function () {
			var _v4 = computed.linkHref;
			if (_v4.$ === 'Just') {
				return $elm$html$Html$a;
			} else {
				var _v5 = computed.styleAs;
				if (_v5.$ === 'Just') {
					switch (_v5.a.$) {
						case 'StyleAsUl':
							var _v6 = _v5.a;
							return $elm$html$Html$ul;
						case 'StyleAsLabel':
							var _v7 = _v5.a;
							return $elm$html$Html$label;
						case 'StyleAsCard':
							var _v8 = _v5.a;
							return $elm$html$Html$div;
						case 'StyleAsHoverableCard':
							var _v9 = _v5.a;
							return $elm$html$Html$div;
						case 'StyleAsCardLabel':
							var _v10 = _v5.a;
							return $elm$html$Html$label;
						default:
							var _v11 = _v5.a;
							return $elm$html$Html$div;
					}
				} else {
					return $elm$html$Html$div;
				}
			}
		}();
		var linkAttributes = function () {
			var _v1 = computed.linkHref;
			if (_v1.$ === 'Just') {
				var _v2 = _v1.a;
				var href = _v2.a;
				var maybeTarget = _v2.b;
				return A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$href(href),
					function () {
						if (maybeTarget.$ === 'Just') {
							var target = maybeTarget.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$target(target)
								]);
						} else {
							return _List_Nil;
						}
					}());
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			el,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(vertHorzClass),
						$elm$html$Html$Attributes$class('v3__stack'),
						$elm$html$Html$Attributes$class(
						A2($elm$core$String$join, ' ', computed.classes)),
						$author$project$Ui$V3$Stack$maybeTestId(computed.testId),
						A2($author$project$Ui$V3$Stack$maybeSpace, 'v3__stack--gap-', computed.gap),
						A2($author$project$Ui$V3$Stack$maybeAlign, 'v3__stack--cross-axis-align-', computed.crossAxisAlign),
						A2($author$project$Ui$V3$Stack$maybeMainAxis, 'v3__stack--main-axis-', computed.mainAxis),
						$author$project$Ui$V3$Stack$maybeBackground(computed.background),
						$author$project$Ui$V3$Stack$maybeBackgroundOnHover(computed.backgroundOnHover)
					]),
				_Utils_ap(
					A2($author$project$Ui$V3$Stack$maybeStyleAs, 'v3__stack--style-as-', computed.styleAs),
					_Utils_ap(
						A2($author$project$Ui$V3$Stack$maybePadding, 'v3__stack--padding-', computed.padding),
						_Utils_ap(
							$author$project$Ui$V3$Stack$maybeHideOnPrint(computed.hideOnPrint),
							_Utils_ap(
								$author$project$Ui$V3$Stack$maybeBorder(computed.border),
								_Utils_ap(
									$author$project$Ui$V3$Stack$interactionAttributes(computed.onEvents),
									_Utils_ap(
										$author$project$Ui$V3$Stack$maybeTabIndex(computed.tabIndex),
										_Utils_ap(
											A2(
												$elm$core$List$map,
												function (_v0) {
													var key = _v0.a;
													var val = _v0.b;
													return A2($elm$html$Html$Attributes$style, key, val);
												},
												computed.styles),
											_Utils_ap(computed.htmlAttributes, linkAttributes))))))))),
			A2($elm$core$List$map, $author$project$Ui$V3$Stack$viewCell, childrenWithWidths));
	});
var $author$project$Ui$V3$Stack$viewVertWithHeights = F2(
	function (attributes, childrenWithWidths) {
		return A3($author$project$Ui$V3$Stack$viewWithWidths, 'v3__stack--vert', attributes, childrenWithWidths);
	});
var $author$project$Ui$V3$Stack$viewVert = F2(
	function (attributes, children) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertWithHeights,
			attributes,
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
				children));
	});
var $author$project$Ui$V3$Typography$spanHelper = F3(
	function (_class, attrs, str) {
		return A2(
			$elm$html$Html$span,
			A2($elm$core$List$cons, _class, attrs),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	});
var $author$project$Ui$V3$Typography$xSmallBodySemiBoldClass = $elm$html$Html$Attributes$class('v3__type__extra-small-body-semi-bold');
var $author$project$Ui$V3$Typography$xSmallBodySemiBold = $author$project$Ui$V3$Typography$spanHelper($author$project$Ui$V3$Typography$xSmallBodySemiBoldClass);
var $author$project$Helpers$Html$labeledInput = F2(
	function (label, content) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsLabel,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, label),
					content
				]));
	});
var $author$project$Ui$V3$Stack$spaceXSmall = $author$project$Ui$V3$Stack$SpatialUnit('xs');
var $author$project$Ui$V3$Button$SubmitForm = {$: 'SubmitForm'};
var $author$project$Ui$V3$Button$submitForm = $author$project$Ui$V3$Button$SubmitForm;
var $author$project$Ui$V3$Badge$AlertStyle = {$: 'AlertStyle'};
var $author$project$Ui$V3$Button$addMarketingIdAttr = F2(
	function (buttonAttributeList, marketingIdArg) {
		if (marketingIdArg.$ === 'Just') {
			var str = marketingIdArg.a;
			return _Utils_ap(
				buttonAttributeList,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-marketing-analytics-id', str)
					]));
		} else {
			return buttonAttributeList;
		}
	});
var $author$project$Ui$V3$Button$addTrackingAttr = F2(
	function (buttonAttributeList, trackingAttrArg) {
		if (trackingAttrArg.$ === 'Just') {
			var str = trackingAttrArg.a;
			return _Utils_ap(
				buttonAttributeList,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-tracking-event', str)
					]));
		} else {
			return buttonAttributeList;
		}
	});
var $author$project$Ui$V3$Badge$BadgeStyle = function (a) {
	return {$: 'BadgeStyle', a: a};
};
var $author$project$Ui$V3$Badge$badgeStyle = $author$project$Ui$V3$Badge$BadgeStyle;
var $author$project$Ui$V3$Button$colorToStr = function (color) {
	switch (color.$) {
		case 'ColorBrand':
			return 'brand';
		case 'ColorAlternative':
			return 'alternative';
		default:
			return 'danger';
	}
};
var $author$project$Ui$V3$Button$ColorBrand = {$: 'ColorBrand'};
var $author$project$Ui$V3$Button$SizeLarge = {$: 'SizeLarge'};
var $author$project$Ui$V3$Button$VariantPrimary = {$: 'VariantPrimary'};
var $author$project$Ui$V3$Button$defaultAttributes = {badge: $elm$core$Maybe$Nothing, buttonColor: $author$project$Ui$V3$Button$ColorBrand, buttonSize: $author$project$Ui$V3$Button$SizeLarge, buttonVariant: $author$project$Ui$V3$Button$VariantPrimary, cssStyles: _List_Nil, disabled: false, disabledWhileLoading: false, leftIconContent: $elm$core$Maybe$Nothing, marketingId: $elm$core$Maybe$Nothing, rightIconContent: $elm$core$Maybe$Nothing, showLabel: true, trackingAttr: $elm$core$Maybe$Nothing};
var $author$project$Ui$V3$Button$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'ButtonColor':
					var value = a.a;
					return _Utils_update(
						acc,
						{buttonColor: value});
				case 'ButtonSize':
					var value = a.a;
					return _Utils_update(
						acc,
						{buttonSize: value});
				case 'ButtonVariant':
					var value = a.a;
					return _Utils_update(
						acc,
						{buttonVariant: value});
				case 'DisabledAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{disabled: value || acc.disabled});
				case 'DisabledWhileLoadingAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{disabledWhileLoading: value || acc.disabledWhileLoading});
				case 'LeftIconWithHiddenLabelAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							leftIconContent: $elm$core$Maybe$Just(value)
						});
				case 'BadgeAlert':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							badge: $elm$core$Maybe$Just(value)
						});
				case 'MarketingIdAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							marketingId: $elm$core$Maybe$Just(value)
						});
				case 'TrackingAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							trackingAttr: $elm$core$Maybe$Just(value)
						});
				case 'RightIconWithHiddenLabelAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							rightIconContent: $elm$core$Maybe$Just(value)
						});
				case 'ShowLabelAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{showLabel: value});
				default:
					var prop = a.a;
					var val = a.b;
					return _Utils_update(
						acc,
						{
							cssStyles: _Utils_ap(
								acc.cssStyles,
								_List_fromArray(
									[
										_Utils_Tuple2(prop, val)
									]))
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Button$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Button$mapLinkAttributes = function (linkAttrs) {
	return A2(
		$elm$core$List$map,
		function (linkAttr) {
			var target = linkAttr.a;
			return $elm$html$Html$Attributes$target(target);
		},
		linkAttrs);
};
var $author$project$Ui$V3$Button$sizeToStr = function (size) {
	switch (size.$) {
		case 'SizeLarge':
			return 'large';
		case 'SizeMedium':
			return 'medium';
		case 'SizeSmall':
			return 'small';
		default:
			return 'xsmall';
	}
};
var $author$project$Ui$V3$Button$showLabelView = function (label) {
	if (label === '') {
		return $elm$html$Html$text('');
	} else {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	}
};
var $author$project$Ui$V3$Button$textLabelView = F2(
	function (label, shouldShowLabel) {
		return shouldShowLabel ? $author$project$Ui$V3$Button$showLabelView(label) : $author$project$Ui$V3$Button$showLabelView('');
	});
var $author$project$Ui$V3$Button$variantToStr = function (variant) {
	switch (variant.$) {
		case 'VariantPrimary':
			return 'primary';
		case 'VariantSecondary':
			return 'secondary';
		default:
			return 'tertiary';
	}
};
var $author$project$Ui$V3$Badge$NoCountStyle = {$: 'NoCountStyle'};
var $author$project$Ui$V3$Badge$badgeSizeClass = function (size) {
	switch (size.$) {
		case 'DefaultSize':
			return 'size-default';
		case 'MediumSize':
			return 'size-medium';
		default:
			return 'size-small';
	}
};
var $author$project$Ui$V3$Badge$badgeStyleClass = function (style) {
	switch (style.$) {
		case 'DefaultStyle':
			return 'default';
		case 'InfoStyle':
			return 'info';
		case 'AlertStyle':
			return 'alert';
		case 'WarningStyle':
			return 'warning';
		case 'SuccessStyle':
			return 'success';
		default:
			return 'no-count';
	}
};
var $author$project$Ui$V3$Badge$DefaultSize = {$: 'DefaultSize'};
var $author$project$Ui$V3$Badge$DefaultStyle = {$: 'DefaultStyle'};
var $author$project$Ui$V3$Badge$defaultAttributes = {size: $author$project$Ui$V3$Badge$DefaultSize, style: $author$project$Ui$V3$Badge$DefaultStyle};
var $author$project$Ui$V3$Badge$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			if (a.$ === 'BadgeSize') {
				var size = a.a;
				return _Utils_update(
					acc,
					{size: size});
			} else {
				var style = a.a;
				return _Utils_update(
					acc,
					{style: style});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Badge$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Badge$view = F3(
	function (attributes, count, text) {
		var countSpan = A2(
			$elm$core$List$member,
			$author$project$Ui$V3$Badge$BadgeStyle($author$project$Ui$V3$Badge$NoCountStyle),
			attributes) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('v3__badge-count', true),
								_Utils_Tuple2('v3__badge-count--single-digit', (0 <= count) && (count <= 9))
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(count))
					])));
		var computedAttributes = $author$project$Ui$V3$Badge$computeAttributes(attributes);
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__badge'),
					$elm$html$Html$Attributes$class(
					'v3__badge--' + $author$project$Ui$V3$Badge$badgeStyleClass(computedAttributes.style)),
					$elm$html$Html$Attributes$class(
					'v3__badge--' + $author$project$Ui$V3$Badge$badgeSizeClass(computedAttributes.size))
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						countSpan,
						$elm$core$String$isEmpty(text) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__badge-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(text)
								])))
					])));
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Ui$V3$Icon$Decorative = {$: 'Decorative'};
var $author$project$Ui$V3$Icon$computeAttributes = A2(
	$elm$core$List$foldl,
	F2(
		function (attribute, computedAttributes) {
			if (attribute.$ === 'DescriptionAttribute') {
				var description = attribute.a;
				return _Utils_update(
					computedAttributes,
					{description: description});
			} else {
				return _Utils_update(
					computedAttributes,
					{spin: true});
			}
		}),
	{description: $author$project$Ui$V3$Icon$Decorative, spin: false});
var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Ui$V3$Icon$viewWithCustomDimensions = F4(
	function (_v0, _v1, attributes_, svg) {
		var srcWidth = _v0.a;
		var srcHeight = _v0.b;
		var width = _v1.a;
		var height = _v1.b;
		var attributes = $author$project$Ui$V3$Icon$computeAttributes(attributes_);
		var _class = attributes.spin ? 'v3__icon v3__icon--spin' : 'v3__icon';
		var ariaAttributes = function () {
			var _v2 = attributes.description;
			if (_v2.$ === 'Decorative') {
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
					]);
			} else {
				var text = _v2.a;
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', text)
					]);
			}
		}();
		return A2(
			$elm$svg$Svg$svg,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$class(_class),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$width(width + 'px'),
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$height(height + 'px'),
						A2(
							$elm$core$List$cons,
							$elm$svg$Svg$Attributes$viewBox('0 0 ' + (srcWidth + (' ' + srcHeight))),
							ariaAttributes)))),
			_List_fromArray(
				[
					A2($elm$svg$Svg$map, $elm$core$Basics$never, svg)
				]));
	});
var $author$project$Ui$V3$Icon$view = F3(
	function (size, attributes, svg) {
		return A4(
			$author$project$Ui$V3$Icon$viewWithCustomDimensions,
			_Utils_Tuple2(size, size),
			_Utils_Tuple2(size, size),
			attributes,
			svg);
	});
var $author$project$Ui$V3$Icon$view16 = F2(
	function (attributes, _v0) {
		var svg = _v0.a;
		return A3($author$project$Ui$V3$Icon$view, '16', attributes, svg);
	});
var $author$project$Ui$V3$Icon$view24 = F2(
	function (attributes, _v0) {
		var svg = _v0.a;
		return A3($author$project$Ui$V3$Icon$view, '24', attributes, svg);
	});
var $author$project$Ui$V3$Button$view = F3(
	function (_v0, attributes, label) {
		var action = _v0.action;
		var viewMaybeIcon = function (maybeIconContent) {
			return A2(
				$elm$core$Maybe$map,
				function (iconContent) {
					if (iconContent.$ === 'Icon16Content') {
						var icon = iconContent.a;
						return A2($author$project$Ui$V3$Icon$view16, _List_Nil, icon);
					} else {
						var icon = iconContent.a;
						return A2($author$project$Ui$V3$Icon$view24, _List_Nil, icon);
					}
				},
				maybeIconContent);
		};
		var computedAttributes = $author$project$Ui$V3$Button$computeAttributes(attributes);
		var hasIcon = (!_Utils_eq(computedAttributes.leftIconContent, $elm$core$Maybe$Nothing)) || (!_Utils_eq(computedAttributes.rightIconContent, $elm$core$Maybe$Nothing));
		var renderSquare = hasIcon && (!computedAttributes.showLabel);
		var initialButtonAttributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__button'),
				$elm$html$Html$Attributes$class(
				'v3__button--color-' + $author$project$Ui$V3$Button$colorToStr(computedAttributes.buttonColor)),
				$elm$html$Html$Attributes$class(
				'v3__button--size-' + $author$project$Ui$V3$Button$sizeToStr(computedAttributes.buttonSize)),
				$elm$html$Html$Attributes$class(
				'v3__button--variant-' + $author$project$Ui$V3$Button$variantToStr(computedAttributes.buttonVariant)),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('v3__button--square', renderSquare),
						_Utils_Tuple2('v3__button--disabled', computedAttributes.disabled || computedAttributes.disabledWhileLoading),
						_Utils_Tuple2('v3__button--disabled-while-loading', computedAttributes.disabledWhileLoading)
					])),
				$elm$html$Html$Attributes$disabled(computedAttributes.disabled || computedAttributes.disabledWhileLoading),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', label)
			]);
		var baseButtonAttributes = A2($author$project$Ui$V3$Button$addMarketingIdAttr, initialButtonAttributes, computedAttributes.marketingId);
		var baseButtonAttributesWithTracking = A2($author$project$Ui$V3$Button$addTrackingAttr, baseButtonAttributes, computedAttributes.trackingAttr);
		var badgeSpan = A2(
			$elm$core$Maybe$map,
			function (c) {
				return A3(
					$author$project$Ui$V3$Badge$view,
					_List_fromArray(
						[
							$author$project$Ui$V3$Badge$badgeStyle($author$project$Ui$V3$Badge$AlertStyle)
						]),
					c,
					'');
			},
			computedAttributes.badge);
		var _v1 = function () {
			switch (action.$) {
				case 'SubmitForm':
					return _Utils_Tuple2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('submit')
							]));
				case 'OnClick':
					var clickHandler = action.a;
					return _Utils_Tuple2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								A2(
								$elm$html$Html$Events$stopPropagationOn,
								'click',
								$elm$json$Json$Decode$succeed(
									function (msg) {
										return _Utils_Tuple2(msg, true);
									}(clickHandler)))
							]));
				default:
					var href = action.a;
					var linkAttrs = action.b;
					return _Utils_Tuple2(
						$elm$html$Html$a,
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(href),
									A2($elm$html$Html$Attributes$attribute, 'role', 'button')
								]),
							$author$project$Ui$V3$Button$mapLinkAttributes(linkAttrs)));
			}
		}();
		var htmlElement = _v1.a;
		var actionAttributes = _v1.b;
		return A2(
			htmlElement,
			$elm$core$List$concat(
				_List_fromArray(
					[
						baseButtonAttributesWithTracking,
						actionAttributes,
						A2(
						$elm$core$List$map,
						function (_v3) {
							var prop = _v3.a;
							var val = _v3.b;
							return A2($elm$html$Html$Attributes$style, prop, val);
						},
						computedAttributes.cssStyles)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__button--label-wrapper')
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								viewMaybeIcon(computedAttributes.leftIconContent),
								badgeSpan,
								$elm$core$Maybe$Just(
								A2($author$project$Ui$V3$Button$textLabelView, label, computedAttributes.showLabel)),
								viewMaybeIcon(computedAttributes.rightIconContent)
							])))
				]));
	});
var $author$project$Ui$V3$Input$defaultAttributes = {
	active: false,
	classes: _List_Nil,
	disabled: false,
	error: false,
	height: $elm$core$Maybe$Nothing,
	label: $elm$core$Maybe$Nothing,
	leadingIcon: $elm$core$Maybe$Nothing,
	leadingText: $elm$core$Maybe$Nothing,
	leadingTextInBox: $elm$core$Maybe$Nothing,
	max: '',
	min: '',
	node: 'input',
	parentClasses: _List_Nil,
	placeholder: '',
	trailingIconButton: $elm$core$Maybe$Nothing,
	trailingTextInBox: $elm$core$Maybe$Nothing,
	type_: $elm$core$Maybe$Nothing,
	validation: $elm$core$Result$Ok(_Utils_Tuple0),
	width: $elm$core$Maybe$Nothing,
	withSelect: $elm$core$Maybe$Nothing,
	withSelectLeading: $elm$core$Maybe$Nothing
};
var $author$project$Ui$V3$Input$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'NodeAttribute':
					var node = a.a;
					return _Utils_update(
						acc,
						{node: node});
				case 'TypeAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							type_: $elm$core$Maybe$Just(value)
						});
				case 'PlaceholderAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{placeholder: value});
				case 'LabelAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							label: $elm$core$Maybe$Just(value)
						});
				case 'ValidationAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{validation: value});
				case 'ErrorAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{error: value});
				case 'ActiveAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{active: value});
				case 'DisabledAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{disabled: value});
				case 'LeadingIconAttribute':
					var description = a.a;
					var icon = a.b;
					return _Utils_update(
						acc,
						{
							leadingIcon: $elm$core$Maybe$Just(
								_Utils_Tuple2(description, icon))
						});
				case 'LeadingTextInBoxAttribute':
					var str = a.a;
					return _Utils_update(
						acc,
						{
							leadingTextInBox: $elm$core$Maybe$Just(str)
						});
				case 'LeadingTextAttribute':
					var str = a.a;
					return _Utils_update(
						acc,
						{
							leadingText: $elm$core$Maybe$Just(str)
						});
				case 'TrailingIconButton':
					var attrs = a.a;
					var iconAttributes = a.b;
					var icon = a.c;
					var onClick = a.d;
					return _Utils_update(
						acc,
						{
							trailingIconButton: $elm$core$Maybe$Just(
								{attrs: attrs, icon: icon, iconAttributes: iconAttributes, onClick: onClick})
						});
				case 'TrailingTextInBoxAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							trailingTextInBox: $elm$core$Maybe$Just(value)
						});
				case 'ClassAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							classes: A2($elm$core$List$cons, value, acc.classes)
						});
				case 'ParentClassAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							parentClasses: A2($elm$core$List$cons, value, acc.parentClasses)
						});
				case 'MinAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{min: value});
				case 'MaxAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{max: value});
				case 'Width':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							width: $elm$core$Maybe$Just(value)
						});
				case 'Height':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							height: $elm$core$Maybe$Just(value)
						});
				case 'WithSelect':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							withSelect: $elm$core$Maybe$Just(value)
						});
				default:
					var value = a.a;
					return _Utils_update(
						acc,
						{
							withSelectLeading: $elm$core$Maybe$Just(value)
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Input$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Input$dateTime = $author$project$Ui$V3$Input$TypeAttribute('datetime-local');
var $author$project$Ui$V3$Icon$Icon16 = function (a) {
	return {$: 'Icon16', a: a};
};
var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $author$project$Ui$V3$Icon$error16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM10.7301 4.4169C10.9564 4.4169 11.1734 4.50678 11.3334 4.66677C11.4136 4.74612 11.4773 4.8406 11.5208 4.94474C11.5642 5.04887 11.5866 5.16059 11.5866 5.27343C11.5866 5.38627 11.5642 5.498 11.5208 5.60213C11.4773 5.70626 11.4136 5.80074 11.3334 5.8801L9.20673 8.0001L11.3334 10.1268C11.4934 10.2868 11.5833 10.5038 11.5833 10.7301C11.5833 10.9564 11.4934 11.1734 11.3334 11.3334C11.1706 11.4907 10.9531 11.5785 10.7267 11.5785C10.5004 11.5785 10.2829 11.4907 10.1201 11.3334L8.00006 9.2001L5.88673 11.3334C5.72495 11.4952 5.50553 11.5861 5.27673 11.5861C5.04794 11.5861 4.82851 11.4952 4.66673 11.3334C4.50495 11.1717 4.41406 10.9522 4.41406 10.7234C4.41406 10.6101 4.43638 10.498 4.47973 10.3933C4.52308 10.2886 4.58663 10.1935 4.66673 10.1134L6.80007 8.0001L4.66673 5.8801C4.50794 5.71809 4.41899 5.50029 4.41899 5.27343C4.41899 5.04658 4.50794 4.82877 4.66673 4.66677C4.7462 4.58553 4.84109 4.52099 4.94584 4.47692C5.05059 4.43286 5.16309 4.41016 5.27673 4.41016C5.39037 4.41016 5.50287 4.43286 5.60762 4.47692C5.71237 4.52099 5.80726 4.58553 5.88673 4.66677L8.00006 6.79343L10.1267 4.66677C10.2868 4.50678 10.5038 4.4169 10.7301 4.4169Z'),
						$elm$svg$Svg$Attributes$fill('#D11F00')
					]),
				_List_Nil)
			])));
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Ui$V3$Input$viewIcon = function (maybeIcon) {
	if (maybeIcon.$ === 'Nothing') {
		return $elm$html$Html$text('');
	} else {
		var _v1 = maybeIcon.a;
		var iconAttributes = _v1.a;
		var icon = _v1.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__input-icon'),
					$elm$html$Html$Attributes$class('v3__input-icon--leading')
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Icon$view16, iconAttributes, icon)
				]));
	}
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Ui$V3$SimpleSelect$Medium = {$: 'Medium'};
var $author$project$Ui$V3$SimpleSelect$defaultAttributes = function (toLabel) {
	return {additionalClasses: _List_Nil, autoWidth: false, autocomplete: $elm$core$Maybe$Nothing, disabled: false, disabledOptions: _List_Nil, error: false, optionValue: toLabel, placeholder: $elm$core$Maybe$Nothing, size: $author$project$Ui$V3$SimpleSelect$Medium, sortByLabel: false};
};
var $author$project$Ui$V3$SimpleSelect$computeAttributes = F2(
	function (toLabel, attributes) {
		var step = F2(
			function (a, acc) {
				switch (a.$) {
					case 'PlaceholderAttribute':
						var val = a.a;
						return _Utils_update(
							acc,
							{placeholder: val});
					case 'DisabledAttribute':
						var val = a.a;
						return _Utils_update(
							acc,
							{disabled: val});
					case 'DisabledOptionsAttribute':
						var val = a.a;
						return _Utils_update(
							acc,
							{disabledOptions: val});
					case 'SortByLabelAttribute':
						var val = a.a;
						return _Utils_update(
							acc,
							{sortByLabel: val});
					case 'AutocompleteAttribute':
						var val = a.a;
						return _Utils_update(
							acc,
							{autocomplete: val});
					case 'ErrorAttribute':
						var val = a.a;
						return _Utils_update(
							acc,
							{error: val});
					case 'ClassAttribute':
						var val = a.a;
						return _Utils_update(
							acc,
							{
								additionalClasses: _Utils_ap(
									acc.additionalClasses,
									_List_fromArray(
										[val]))
							});
					case 'SizeAttribute':
						var val = a.a;
						return _Utils_update(
							acc,
							{size: val});
					case 'AutoWidthAttribute':
						return _Utils_update(
							acc,
							{autoWidth: true});
					default:
						var val = a.a;
						return _Utils_update(
							acc,
							{optionValue: val});
				}
			});
		return A3(
			$elm$core$List$foldl,
			step,
			$author$project$Ui$V3$SimpleSelect$defaultAttributes(toLabel),
			attributes);
	});
var $author$project$Ui$V3$SimpleSelect$onSelect = F2(
	function (config, computedAttributes) {
		var decoder = A2(
			$elm$json$Json$Decode$map,
			config.onInput,
			A2(
				$elm$json$Json$Decode$andThen,
				function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Decode$fail('No mapping provided for ' + (value + '.')),
						A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Decode$succeed,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (choice) {
										return _Utils_eq(
											computedAttributes.optionValue(choice),
											value);
									},
									config.options))));
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					$elm$json$Json$Decode$string)));
		return A2($elm$html$Html$Events$on, 'change', decoder);
	});
var $author$project$Ui$V3$SimpleSelect$selectedAttributeFor = F2(
	function (a, b) {
		return $elm$html$Html$Attributes$selected(
			_Utils_eq(a, b));
	});
var $author$project$Ui$V3$SimpleSelect$viewSelectOption = F3(
	function (config, computedAttributes, value) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					A2($elm$core$List$member, value, computedAttributes.disabledOptions)),
					A2(
					$author$project$Ui$V3$SimpleSelect$selectedAttributeFor,
					config.value,
					$elm$core$Maybe$Just(value)),
					$elm$html$Html$Attributes$value(
					computedAttributes.optionValue(value))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					config.toLabel(value))
				]));
	});
var $author$project$Ui$V3$SimpleSelect$view = F2(
	function (config, attrs) {
		var computedAttributes = A2($author$project$Ui$V3$SimpleSelect$computeAttributes, config.toLabel, attrs);
		var isShowingDisabledOption = function () {
			var _v2 = config.value;
			if (_v2.$ === 'Just') {
				var val = _v2.a;
				return A2($elm$core$List$member, val, computedAttributes.disabledOptions) || (!A2($elm$core$List$member, val, config.options));
			} else {
				var _v3 = computedAttributes.placeholder;
				if (_v3.$ === 'Just') {
					return true;
				} else {
					var _v4 = $elm$core$List$head(config.options);
					if (_v4.$ === 'Just') {
						var firstOption = _v4.a;
						return A2($elm$core$List$member, firstOption, computedAttributes.disabledOptions);
					} else {
						return true;
					}
				}
			}
		}();
		var maybePlaceholderOption = function () {
			var _v1 = computedAttributes.placeholder;
			if (_v1.$ === 'Just') {
				var placeholder_ = _v1.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'disabled', 'true'),
								A2($author$project$Ui$V3$SimpleSelect$selectedAttributeFor, config.value, $elm$core$Maybe$Nothing),
								$elm$html$Html$Attributes$value(placeholder_)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(placeholder_)
							])));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var sizeClass = function () {
			var _v0 = computedAttributes.size;
			if (_v0.$ === 'Small') {
				return 'v3__simple-select--size-small';
			} else {
				return 'v3__simple-select--size-medium';
			}
		}();
		var sortIfNeeded = computedAttributes.sortByLabel ? $elm$core$List$sortBy(config.toLabel) : $elm$core$Basics$identity;
		return A2(
			$elm$html$Html$select,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						$elm$html$Html$Attributes$classList(
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (c) {
										return _Utils_Tuple2(c, true);
									},
									computedAttributes.additionalClasses),
								_List_fromArray(
									[
										_Utils_Tuple2('v3__input', true),
										_Utils_Tuple2('v3__simple-select', true),
										_Utils_Tuple2('v3__simple-select--with-disabled-option', isShowingDisabledOption),
										_Utils_Tuple2('v3__input--errored', computedAttributes.error),
										_Utils_Tuple2(sizeClass, true)
									])))),
						$elm$core$Maybe$Just(
						A2($author$project$Ui$V3$SimpleSelect$onSelect, config, computedAttributes)),
						A2(
						$elm$core$Maybe$map,
						$elm$html$Html$Attributes$attribute('autocomplete'),
						computedAttributes.autocomplete),
						$elm$core$Maybe$Just(
						$elm$html$Html$Attributes$disabled(computedAttributes.disabled)),
						computedAttributes.autoWidth ? $elm$core$Maybe$Just(
						A2($elm$html$Html$Attributes$style, 'width', 'auto')) : $elm$core$Maybe$Nothing
					])),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$cons,
					maybePlaceholderOption,
					A2(
						$elm$core$List$map,
						$elm$core$Maybe$Just,
						A2(
							$elm$core$List$map,
							A2($author$project$Ui$V3$SimpleSelect$viewSelectOption, config, computedAttributes),
							sortIfNeeded(config.options))))));
	});
var $author$project$Ui$V3$Input$viewSelectContainer = F2(
	function (attrs, config) {
		return A2(
			$elm$html$Html$span,
			attrs,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: function ($) {
							return $.onInput;
						},
						options: config.options,
						toLabel: function ($) {
							return $.label;
						},
						value: A2(
							$elm_community$list_extra$List$Extra$find,
							function ($) {
								return $.isSelected;
							},
							config.options)
					},
					_List_Nil)
				]));
	});
var $author$project$Ui$V3$Input$viewLeadingSelect = function (config) {
	return A2(
		$author$project$Ui$V3$Input$viewSelectContainer,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__input__select-container--leading')
			]),
		config);
};
var $author$project$Ui$V3$Input$viewSelect = function (config) {
	return A2(
		$author$project$Ui$V3$Input$viewSelectContainer,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__input__select-container')
			]),
		config);
};
var $author$project$Ui$V3$Input$viewTrailingIconButton = function (computedAttributes) {
	var _v0 = computedAttributes.trailingIconButton;
	if (_v0.$ === 'Nothing') {
		return $elm$html$Html$text('');
	} else {
		var onClick = _v0.a.onClick;
		var iconAttributes = _v0.a.iconAttributes;
		var icon = _v0.a.icon;
		var attrs = _v0.a.attrs;
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__input-icon'),
						$elm$html$Html$Attributes$class('v3__input-icon--trailing'),
						computedAttributes.disabled ? $elm$html$Html$Attributes$class('') : $elm$html$Html$Events$onClick(onClick)
					]),
				attrs),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Icon$view16, iconAttributes, icon)
				]));
	}
};
var $author$project$Ui$V3$Input$view = F4(
	function (_v0, attributes, htmlAttributes, value) {
		var onInput = _v0.onInput;
		var onChooseDate = A2($elm$core$List$member, $author$project$Ui$V3$Input$date, attributes) ? A2(
			$elm$html$Html$Events$on,
			'change',
			A2($elm$json$Json$Decode$map, onInput, $elm$html$Html$Events$targetValue)) : (A2($elm$core$List$member, $author$project$Ui$V3$Input$dateTime, attributes) ? A2(
			$elm$html$Html$Events$on,
			'change',
			A2($elm$json$Json$Decode$map, onInput, $elm$html$Html$Events$targetValue)) : $elm$html$Html$Events$onInput(onInput));
		var htmlInputAttributes = htmlAttributes;
		var computedAttributes = $author$project$Ui$V3$Input$computeAttributes(attributes);
		var hasLeadingText = !_Utils_eq(computedAttributes.leadingText, $elm$core$Maybe$Nothing);
		var hasLeadingTextBox = !_Utils_eq(computedAttributes.leadingTextInBox, $elm$core$Maybe$Nothing);
		var hasTrailingTextBox = !_Utils_eq(computedAttributes.trailingTextInBox, $elm$core$Maybe$Nothing);
		var computedInputAttributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__input'),
				$elm$html$Html$Attributes$class(
				A2($elm$core$String$join, ' ', computedAttributes.classes)),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('v3__input--active', computedAttributes.active),
						_Utils_Tuple2(
						'v3__input--errored',
						(!_Utils_eq(
							computedAttributes.validation,
							$elm$core$Result$Ok(_Utils_Tuple0))) || computedAttributes.error),
						_Utils_Tuple2(
						'v3__input--empty',
						$elm$core$String$isEmpty(value)),
						_Utils_Tuple2('v3__input--has-leading-text-box', hasLeadingTextBox),
						_Utils_Tuple2('v3__input--has-leading-text', hasLeadingText),
						_Utils_Tuple2(
						'v3__input--has-leading-icon',
						!_Utils_eq(computedAttributes.leadingIcon, $elm$core$Maybe$Nothing)),
						_Utils_Tuple2(
						'v3__input--has-trailing-icon',
						!_Utils_eq(computedAttributes.trailingIconButton, $elm$core$Maybe$Nothing)),
						_Utils_Tuple2('v3__input--has-trailing-text-box', hasTrailingTextBox),
						_Utils_Tuple2(
						'v3__input--has-leading-select',
						!_Utils_eq(computedAttributes.withSelectLeading, $elm$core$Maybe$Nothing))
					])),
				function () {
				var _v8 = _Utils_Tuple2(computedAttributes.node, computedAttributes.type_);
				if ((_v8.a === 'input') && (_v8.b.$ === 'Just')) {
					var type_ = _v8.b.a;
					return $elm$html$Html$Attributes$type_(type_);
				} else {
					return $elm$html$Html$Attributes$class('');
				}
			}(),
				function () {
				var _v9 = computedAttributes.trailingTextInBox;
				if (_v9.$ === 'Just') {
					var config = _v9.a;
					return A2(
						$elm$html$Html$Attributes$style,
						'padding-right',
						$author$project$Ui$V3$Helpers$Html$px(config.width));
				} else {
					return $elm$html$Html$Attributes$class('');
				}
			}(),
				function () {
				var _v10 = computedAttributes.width;
				if (_v10.$ === 'Just') {
					var val = _v10.a;
					return A2($elm$html$Html$Attributes$style, 'width', val);
				} else {
					return $elm$html$Html$Attributes$class('');
				}
			}(),
				function () {
				var _v11 = computedAttributes.height;
				if (_v11.$ === 'Just') {
					var val = _v11.a;
					return A2($elm$html$Html$Attributes$style, 'height', val);
				} else {
					return $elm$html$Html$Attributes$class('');
				}
			}(),
				$elm$html$Html$Attributes$disabled(computedAttributes.disabled),
				$elm$html$Html$Attributes$placeholder(computedAttributes.placeholder),
				$elm$html$Html$Attributes$value(value),
				$elm$html$Html$Attributes$max(computedAttributes.max),
				$elm$html$Html$Attributes$min(computedAttributes.min),
				onChooseDate
			]);
		var inputAttributes = A2($elm$core$List$append, htmlInputAttributes, computedInputAttributes);
		var wrapperAttrs = A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('v3__input-wrapper'),
			_Utils_ap(
				function () {
					var _v3 = computedAttributes.leadingTextInBox;
					if (_v3.$ === 'Just') {
						var str = _v3.a;
						return _List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-leading-text', str),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('v3__input-wrapper--has-leading-text-box', true),
										_Utils_Tuple2(
										'v3__input-wrapper--has-leading-text-box--errored',
										!_Utils_eq(
											computedAttributes.validation,
											$elm$core$Result$Ok(_Utils_Tuple0)))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v4 = computedAttributes.leadingText;
						if (_v4.$ === 'Just') {
							var str = _v4.a;
							return _List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'data-leading-text', str),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('v3__input-wrapper--has-leading-text', true),
											_Utils_Tuple2(
											'v3__input-wrapper--has-leading-text--errored',
											!_Utils_eq(
												computedAttributes.validation,
												$elm$core$Result$Ok(_Utils_Tuple0)))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v5 = computedAttributes.trailingTextInBox;
							if (_v5.$ === 'Just') {
								var text = _v5.a.text;
								return _List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-trailing-text', text),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('v3__input-wrapper--has-trailing-text-box', true),
												_Utils_Tuple2(
												'v3__input-wrapper--has-trailing-text-box--errored',
												!_Utils_eq(
													computedAttributes.validation,
													$elm$core$Result$Ok(_Utils_Tuple0)))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_Utils_ap(
							function () {
								var _v6 = computedAttributes.withSelectLeading;
								if (_v6.$ === 'Just') {
									return _List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3__input-wrapper--has-leading-select')
										]);
								} else {
									return _List_Nil;
								}
							}(),
							function () {
								var _v7 = computedAttributes.width;
								if (_v7.$ === 'Just') {
									var val = _v7.a;
									return _List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', val)
										]);
								} else {
									return _List_Nil;
								}
							}())))));
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__input-label'),
					$elm$html$Html$Attributes$class(
					A2($elm$core$String$join, ' ', computedAttributes.parentClasses))
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = computedAttributes.label;
					if (_v1.$ === 'Nothing') {
						return $elm$html$Html$text('');
					} else {
						var text = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__input-label-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(text)
								]));
					}
				}(),
					A2(
					$elm$html$Html$div,
					wrapperAttrs,
					_List_fromArray(
						[
							$author$project$Ui$V3$Input$viewIcon(computedAttributes.leadingIcon),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2($elm$core$Maybe$map, $author$project$Ui$V3$Input$viewLeadingSelect, computedAttributes.withSelectLeading)),
							A3($elm$html$Html$node, computedAttributes.node, inputAttributes, _List_Nil),
							$author$project$Ui$V3$Input$viewTrailingIconButton(computedAttributes),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2($elm$core$Maybe$map, $author$project$Ui$V3$Input$viewSelect, computedAttributes.withSelect))
						])),
					function () {
					var _v2 = computedAttributes.validation;
					if (_v2.$ === 'Ok') {
						return $elm$html$Html$text('');
					} else {
						var text = _v2.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__input-validation')
								]),
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$error16),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(text)
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Ui$V3$Stack$viewHorzWithWidths = F2(
	function (attributes, childrenWithWidths) {
		return A3($author$project$Ui$V3$Stack$viewWithWidths, 'v3__stack--horz', attributes, childrenWithWidths);
	});
var $author$project$Ui$V3$Colors$TextNeutralSubtle = {$: 'TextNeutralSubtle'};
var $author$project$Ui$V3$Colors$colorAttribute = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$Attributes$style('color'),
	$author$project$Ui$V3$Colors$cssVariable);
var $author$project$Ui$V3$Typography$smallBodyClass = $elm$html$Html$Attributes$class('v3__type__small-body');
var $author$project$Ui$V3$Typography$smallBody = $author$project$Ui$V3$Typography$spanHelper($author$project$Ui$V3$Typography$smallBodyClass);
var $author$project$Components$DebtorChanges$Common$viewSubtle = function (text) {
	return A2(
		$author$project$Ui$V3$Typography$smallBody,
		_List_fromArray(
			[
				$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
			]),
		text);
};
var $author$project$Components$DebtorChanges$Common$viewRangeForm = F2(
	function (_v0, dates) {
		var onApply = _v0.onApply;
		var onEndDate = _v0.onEndDate;
		var onStartDate = _v0.onStartDate;
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Events$onSubmit(onApply)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
									$author$project$Ui$V3$Stack$crossAxisBottom
								]),
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fitPx(160),
									A2(
										$author$project$Helpers$Html$labeledInput,
										'Start date',
										A4(
											$author$project$Ui$V3$Input$view,
											{onInput: onStartDate},
											_List_fromArray(
												[$author$project$Ui$V3$Input$date]),
											_List_Nil,
											dates.startDate))),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fitPx(160),
									A2(
										$author$project$Helpers$Html$labeledInput,
										'End date',
										A4(
											$author$project$Ui$V3$Input$view,
											{onInput: onEndDate},
											_List_fromArray(
												[$author$project$Ui$V3$Input$date]),
											_List_Nil,
											dates.endDate))),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									A3(
										$author$project$Ui$V3$Button$view,
										{action: $author$project$Ui$V3$Button$submitForm},
										_List_Nil,
										'Apply')),
									_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Helpers$Html$empty)
								])),
							$author$project$Components$DebtorChanges$Common$viewSubtle('Up to 30 days, both dates included, in the account\u0027s time zone.')
						]))
				]));
	});
var $author$project$Ui$V3$Pagination$None = {$: 'None'};
var $author$project$Components$DebtorChanges$IndexPage$SelectedOutcome = function (a) {
	return {$: 'SelectedOutcome', a: a};
};
var $author$project$Components$DebtorChanges$IndexPage$UpdatedInvoicePage = function (a) {
	return {$: 'UpdatedInvoicePage', a: a};
};
var $author$project$Ui$V3$Typography$bodyClass = $elm$html$Html$Attributes$class('v3__type__body');
var $author$project$Ui$V3$Typography$body = $author$project$Ui$V3$Typography$spanHelper($author$project$Ui$V3$Typography$bodyClass);
var $author$project$Ui$V3$Table$EmptyContent = function (a) {
	return {$: 'EmptyContent', a: a};
};
var $author$project$Ui$V3$Table$emptyContent = $author$project$Ui$V3$Table$EmptyContent;
var $author$project$Components$DebtorChanges$IndexPage$entriesPerPage = 25;
var $author$project$Pagination$Page = function (a) {
	return {$: 'Page', a: a};
};
var $author$project$Pagination$fromList = F3(
	function (activePage, perPage, items) {
		var realActivePage = function () {
			if (activePage < 1) {
				return 1;
			} else {
				var upperBound = $elm$core$Basics$ceiling(
					$elm$core$List$length(items) / perPage);
				return (_Utils_cmp(activePage, upperBound) < 0) ? activePage : upperBound;
			}
		}();
		var page = A2(
			$elm$core$List$take,
			perPage,
			A2($elm$core$List$drop, (realActivePage - 1) * perPage, items));
		return $author$project$Pagination$Page(
			{
				entries: page,
				entriesPerPage: perPage,
				pageNumber: realActivePage,
				totalEntries: $elm$core$List$length(items)
			});
	});
var $author$project$Components$DebtorChanges$Common$matchesOutcome = F2(
	function (filter, outcome) {
		if (filter.$ === 'AnyOutcome') {
			return true;
		} else {
			var only = filter.a;
			return _Utils_eq(outcome, only);
		}
	});
var $author$project$Components$DebtorChanges$IndexPage$matchesTemplate = F2(
	function (filter, invoice) {
		var templateIds = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.templateId;
			},
			invoice.rateConfirmations);
		switch (filter.$) {
			case 'AnyTemplate':
				return true;
			case 'NoTemplate':
				return $elm$core$List$isEmpty(templateIds);
			default:
				var id = filter.a;
				return A2($elm$core$List$member, id, templateIds);
		}
	});
var $author$project$Ui$V3$Table$PaginationAttribute = function (a) {
	return {$: 'PaginationAttribute', a: a};
};
var $author$project$Ui$V3$Table$pagination = $author$project$Ui$V3$Table$PaginationAttribute;
var $author$project$Ui$V3$Table$ToolbarItem = function (a) {
	return {$: 'ToolbarItem', a: a};
};
var $author$project$Ui$V3$Table$toolbarCustomHtml = function (html) {
	return $author$project$Ui$V3$Table$ToolbarItem(html);
};
var $author$project$Ui$V3$Table$toolbarEmpty = $author$project$Ui$V3$Table$ToolbarItem(
	$elm$html$Html$text(''));
var $author$project$Ui$V3$Table$ToolbarItems = function (a) {
	return {$: 'ToolbarItems', a: a};
};
var $author$project$Ui$V3$Table$toolbarItems = function (items) {
	return $author$project$Ui$V3$Table$ToolbarItems(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var basis = _v0.a;
				var html = _v0.b.a;
				return _Utils_Tuple2(basis, html);
			},
			items));
};
var $author$project$Ui$V3$Table$TopAlignedAttribute = {$: 'TopAlignedAttribute'};
var $author$project$Ui$V3$Table$topAligned = $author$project$Ui$V3$Table$TopAlignedAttribute;
var $author$project$Ui$V3$Table$Default = {$: 'Default'};
var $author$project$Ui$V3$Table$defaultAttributes = {
	drawer: $elm$core$Maybe$Nothing,
	emptyContent: $elm$core$Maybe$Nothing,
	fillHeight: false,
	footer: $elm$core$Maybe$Nothing,
	headCellAttrs: _List_Nil,
	linkableRowAttrs: $elm$core$Maybe$Nothing,
	loadMore: $elm$core$Maybe$Nothing,
	loadingRow: $elm$core$Basics$always($elm$core$Maybe$Nothing),
	maxHeight: $elm$core$Maybe$Nothing,
	minHeight: $elm$core$Maybe$Nothing,
	nestedRow: $elm$core$Maybe$Nothing,
	noHeader: false,
	noOverflow: false,
	onClick: $elm$core$Maybe$Nothing,
	pagination: $elm$core$Maybe$Nothing,
	rowAttributes: function (_v0) {
		return _List_Nil;
	},
	style: $author$project$Ui$V3$Table$Default,
	subRow: $elm$core$Maybe$Nothing,
	toolbarItems: _List_Nil
};
var $author$project$Ui$V3$Table$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'FooterAttribute':
					var html = a.a;
					return _Utils_update(
						acc,
						{
							footer: $elm$core$Maybe$Just(html)
						});
				case 'OnClickAttribute':
					var onClick = a.a;
					return _Utils_update(
						acc,
						{
							onClick: $elm$core$Maybe$Just(onClick)
						});
				case 'LinkableRowAttribute':
					var func = a.a;
					return _Utils_update(
						acc,
						{
							linkableRowAttrs: $elm$core$Maybe$Just(func)
						});
				case 'PaginationAttribute':
					var pagination_ = a.a;
					return _Utils_update(
						acc,
						{
							pagination: $elm$core$Maybe$Just(pagination_)
						});
				case 'DrawerAttribute':
					var drawer_ = a.a;
					return _Utils_update(
						acc,
						{
							drawer: $elm$core$Maybe$Just(drawer_)
						});
				case 'MinHeightAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							minHeight: $elm$core$Maybe$Just(value)
						});
				case 'MaxHeightAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							maxHeight: $elm$core$Maybe$Just(value)
						});
				case 'FillHeightAttribute':
					return _Utils_update(
						acc,
						{fillHeight: true});
				case 'NoOverflow':
					return _Utils_update(
						acc,
						{noOverflow: true});
				case 'NoHeader':
					return _Utils_update(
						acc,
						{noHeader: true});
				case 'RowAttributes':
					var f = a.a;
					return _Utils_update(
						acc,
						{rowAttributes: f});
				case 'SubRow':
					var f = a.a;
					return _Utils_update(
						acc,
						{
							subRow: $elm$core$Maybe$Just(f)
						});
				case 'LoadingRow':
					var val = a.a;
					return _Utils_update(
						acc,
						{loadingRow: val});
				case 'EmptyContent':
					var html = a.a;
					return _Utils_update(
						acc,
						{
							emptyContent: $elm$core$Maybe$Just(html)
						});
				case 'StyleAttribute':
					var style = a.a;
					return _Utils_update(
						acc,
						{style: style});
				case 'LoadMoreAttribute':
					var val = a.a;
					return _Utils_update(
						acc,
						{
							loadMore: $elm$core$Maybe$Just(val)
						});
				case 'ToolbarItems':
					var val = a.a;
					return _Utils_update(
						acc,
						{
							toolbarItems: _Utils_ap(acc.toolbarItems, val)
						});
				case 'HeadCellAttrs':
					var vals = a.a;
					return _Utils_update(
						acc,
						{
							headCellAttrs: _Utils_ap(acc.headCellAttrs, vals)
						});
				default:
					var val = a.a;
					return _Utils_update(
						acc,
						{
							nestedRow: $elm$core$Maybe$Just(val)
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Table$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Table$defaultTableAttributes = {loading: false};
var $author$project$Ui$V3$Table$computeTableAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			var value = a.a;
			return _Utils_update(
				acc,
				{loading: value});
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Table$defaultTableAttributes, attributes);
};
var $author$project$Ui$V3$Table$fillHeightStyle = function (enabled) {
	return enabled ? _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'height', '100%'),
			A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start')
		]) : _List_Nil;
};
var $author$project$Ui$V3$Table$maxHeightStyle = function (maybeHeight) {
	if (maybeHeight.$ === 'Just') {
		var height = maybeHeight.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'max-height',
				$elm$core$String$fromInt(height) + 'px'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$V3$Table$minHeightStyle = function (maybeHeight) {
	if (maybeHeight.$ === 'Just') {
		var height = maybeHeight.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'min-height',
				$elm$core$String$fromInt(height) + 'px'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$V3$Table$styleToClassSuffix = function (style) {
	if (style.$ === 'Default') {
		return 'default';
	} else {
		return 'dark';
	}
};
var $author$project$Ui$V3$SimpleSelect$ClassAttribute = function (a) {
	return {$: 'ClassAttribute', a: a};
};
var $author$project$Ui$V3$SimpleSelect$class = $author$project$Ui$V3$SimpleSelect$ClassAttribute;
var $author$project$Pagination$entriesPerPage = function (_v0) {
	var pageDetails = _v0.a;
	return pageDetails.entriesPerPage;
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 'Exact', a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 'Min', a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	decimalSeparator: '.',
	decimals: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	negativePrefix: '−',
	negativeSuffix: '',
	positivePrefix: '',
	positiveSuffix: '',
	thousandSeparator: '',
	zeroPrefix: '',
	zeroSuffix: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		decimals: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		thousandSeparator: ','
	});
var $author$project$Helpers$Format$defaultLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
	{
		decimalSeparator: '.',
		decimals: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		thousandSeparator: ','
	});
var $author$project$Helpers$Format$defaultIntLocale = _Utils_update(
	$author$project$Helpers$Format$defaultLocale,
	{
		decimalSeparator: '',
		decimals: $cuducos$elm_format_number$FormatNumber$Locales$Exact(0)
	});
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {decimals: decimals, integers: integers, original: original, prefix: prefix, suffix: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = {$: 'Negative'};
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = {$: 'Positive'};
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = {$: 'Zero'};
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _Utils_eq(
				_char,
				_Utils_chr('0'));
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.integers,
				$elm$core$List$singleton(formatted.decimals))));
	return onlyZeros ? $cuducos$elm_format_number$FormatNumber$Parser$Zero : ((formatted.original < 0) ? $cuducos$elm_format_number$FormatNumber$Parser$Negative : $cuducos$elm_format_number$FormatNumber$Parser$Positive);
};
var $elm$core$String$filter = _String_filter;
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.decimals;
		switch (_v0.$) {
			case 'Max':
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 'Exact':
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (!_Utils_eq(
					c,
					_Utils_chr('0'))) && (!_Utils_eq(
					c,
					_Utils_chr('.')));
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (_Utils_eq(
		head,
		_Utils_chr('9'))) {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 'Nothing') {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				_Utils_chr('0'),
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3(
				$elm$core$String$padRight,
				e + 1,
				_Utils_chr('0'),
				total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					_Utils_chr('0'),
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3(
					$elm$core$String$padRight,
					s,
					_Utils_chr('0'),
					after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 'Nothing') {
				return false;
			} else {
				if ('5' === _v0.a.a.valueOf()) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.decimals;
			switch (_v1.$) {
				case 'Max':
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 'Min':
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (_v0.$ === 'Just') {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = $cuducos$elm_format_number$FormatNumber$Parser$splitThousands(
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0.$) {
			case 'Negative':
				return _Utils_update(
					partial,
					{prefix: locale.negativePrefix, suffix: locale.negativeSuffix});
			case 'Positive':
				return _Utils_update(
					partial,
					{prefix: locale.positivePrefix, suffix: locale.positiveSuffix});
			default:
				return _Utils_update(
					partial,
					{prefix: locale.zeroPrefix, suffix: locale.zeroSuffix});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.decimalSeparator, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.thousandSeparator, formatted.integers);
		var decimals = stringfyDecimals(formatted.decimals);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.prefix, integers, decimals, formatted.suffix]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $author$project$Helpers$Format$int = function (num) {
	return A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Helpers$Format$defaultIntLocale, num);
};
var $author$project$Pagination$pageFirstEntry = function (page) {
	return 1 + (($author$project$Pagination$pageNumber(page) - 1) * $author$project$Pagination$entriesPerPage(page));
};
var $author$project$Pagination$totalEntries = function (_v0) {
	var pageDetails = _v0.a;
	return pageDetails.totalEntries;
};
var $author$project$Pagination$pageLastEntry = function (page) {
	return A2(
		$elm$core$Basics$min,
		$author$project$Pagination$pageNumber(page) * $author$project$Pagination$entriesPerPage(page),
		$author$project$Pagination$totalEntries(page));
};
var $author$project$Ui$V3$Pagination$resultsText = function (page) {
	var _v0 = $author$project$Helpers$Format$int(
		$author$project$Pagination$totalEntries(page));
	if (_v0 === '0') {
		return '0 results';
	} else {
		var total = _v0;
		return $author$project$Helpers$Format$int(
			$author$project$Pagination$pageFirstEntry(page)) + (' - ' + ($author$project$Helpers$Format$int(
			$author$project$Pagination$pageLastEntry(page)) + (' of ' + (total + ' results'))));
	}
};
var $author$project$Pagination$hasPreviousPage = function (page) {
	return $author$project$Pagination$pageNumber(page) > 1;
};
var $author$project$Ui$V3$Pagination$viewArrow = F5(
	function (label, updatePageMsg, enabled, icon, page) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-label', label),
					$elm$html$Html$Attributes$class('v3-pagination__arrow'),
					$elm$html$Html$Attributes$disabled(
					!enabled(page)),
					$elm$html$Html$Attributes$tabindex(0),
					$elm$html$Html$Events$onClick(
					updatePageMsg(page))
				]),
			_List_fromArray(
				[icon]));
	});
var $author$project$Ui$V3$Pagination$viewFirstPageArrow = function (updatePageMsg) {
	return A4(
		$author$project$Ui$V3$Pagination$viewArrow,
		'Go to first page',
		A2(
			$elm$core$Basics$composeL,
			updatePageMsg,
			$elm$core$Basics$always(1)),
		$author$project$Pagination$hasPreviousPage,
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('14'),
					$elm$svg$Svg$Attributes$height('12'),
					$elm$svg$Svg$Attributes$viewBox('0 0 14 12'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$clipRule('evenodd'),
							$elm$svg$Svg$Attributes$d('M13.7463 0.255281C14.0846 0.595736 14.0846 1.14772 13.7463 1.48818L9.26321 5.99991L13.7463 10.5116C14.0846 10.8521 14.0846 11.4041 13.7463 11.7445C13.408 12.085 12.8595 12.085 12.5212 11.7445L7.42561 6.61636C7.08732 6.27591 7.08732 5.72392 7.42561 5.38346L12.5212 0.255281C12.8595 -0.0851749 13.408 -0.0851749 13.7463 0.255281Z'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$clipRule('evenodd'),
							$elm$svg$Svg$Attributes$d('M6.57465 0.255311C6.91294 0.595767 6.91294 1.14775 6.57465 1.48821L2.09158 5.99994L6.57465 10.5117C6.91294 10.8521 6.91294 11.4041 6.57465 11.7446C6.23636 12.085 5.68788 12.085 5.34958 11.7446L0.253978 6.61639C-0.0843141 6.27594 -0.0843141 5.72395 0.253978 5.38349L5.34958 0.255311C5.68788 -0.0851445 6.23636 -0.0851445 6.57465 0.255311Z'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil)
				])));
};
var $author$project$Pagination$totalPages = function (_v0) {
	var pageDetails = _v0.a;
	var baseTotalPages = pageDetails.totalEntries / pageDetails.entriesPerPage;
	return $elm$core$Basics$ceiling(baseTotalPages);
};
var $author$project$Pagination$hasNextPage = function (page) {
	return _Utils_cmp(
		$author$project$Pagination$pageNumber(page),
		$author$project$Pagination$totalPages(page)) < 0;
};
var $author$project$Ui$V3$Pagination$viewLastPageArrow = function (updatePageMsg) {
	return A4(
		$author$project$Ui$V3$Pagination$viewArrow,
		'Go to last page',
		A2($elm$core$Basics$composeL, updatePageMsg, $author$project$Pagination$totalPages),
		$author$project$Pagination$hasNextPage,
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('14'),
					$elm$svg$Svg$Attributes$height('12'),
					$elm$svg$Svg$Attributes$viewBox('0 0 14 12'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$clipRule('evenodd'),
							$elm$svg$Svg$Attributes$d('M0.25372 11.7447C-0.0845733 11.4042 -0.0845733 10.8522 0.253719 10.5118L4.73679 6.00005L0.253719 1.48832C-0.0845743 1.14787 -0.0845743 0.595877 0.253718 0.255422C0.592011 -0.0850344 1.14049 -0.0850345 1.47878 0.255421L6.57439 5.38361C6.91268 5.72406 6.91268 6.27605 6.57439 6.6165L1.47879 11.7447C1.14049 12.0851 0.592012 12.0851 0.25372 11.7447Z'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$clipRule('evenodd'),
							$elm$svg$Svg$Attributes$d('M7.42535 11.7446C7.08706 11.4042 7.08706 10.8522 7.42535 10.5117L11.9084 5.99999L7.42535 1.48826C7.08706 1.1478 7.08706 0.595816 7.42535 0.255361C7.76364 -0.0850954 8.31212 -0.0850955 8.65042 0.255361L13.746 5.38354C14.0843 5.724 14.0843 6.27599 13.746 6.61644L8.65042 11.7446C8.31212 12.0851 7.76364 12.0851 7.42535 11.7446Z'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil)
				])));
};
var $author$project$Pagination$nextPageNumber = function (page) {
	return A2(
		$elm$core$Basics$min,
		$author$project$Pagination$totalPages(page),
		$author$project$Pagination$pageNumber(page) + 1);
};
var $author$project$Ui$V3$Pagination$viewNextPageArrow = function (updatePageMsg) {
	return A4(
		$author$project$Ui$V3$Pagination$viewArrow,
		'Go to next page',
		A2($elm$core$Basics$composeL, updatePageMsg, $author$project$Pagination$nextPageNumber),
		$author$project$Pagination$hasNextPage,
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('7'),
					$elm$svg$Svg$Attributes$height('12'),
					$elm$svg$Svg$Attributes$viewBox('0 0 7 12'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$clipRule('evenodd'),
							$elm$svg$Svg$Attributes$d('M0.25372 11.7447C-0.0845733 11.4042 -0.0845733 10.8523 0.253719 10.5118L4.73679 6.00007L0.253719 1.48834C-0.0845743 1.14788 -0.0845743 0.595892 0.253718 0.255437C0.592011 -0.0850189 1.14049 -0.085019 1.47878 0.255436L6.57439 5.38362C6.91268 5.72408 6.91268 6.27606 6.57439 6.61652L1.47879 11.7447C1.14049 12.0852 0.592012 12.0852 0.25372 11.7447Z'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil)
				])));
};
var $author$project$Pagination$previousPageNumber = function (page) {
	return A2(
		$elm$core$Basics$max,
		1,
		$author$project$Pagination$pageNumber(page) - 1);
};
var $author$project$Ui$V3$Pagination$viewPreviousPageArrow = function (updatePageMsg) {
	return A4(
		$author$project$Ui$V3$Pagination$viewArrow,
		'Go to previous page',
		A2($elm$core$Basics$composeL, updatePageMsg, $author$project$Pagination$previousPageNumber),
		$author$project$Pagination$hasPreviousPage,
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('7'),
					$elm$svg$Svg$Attributes$height('12'),
					$elm$svg$Svg$Attributes$viewBox('0 0 7 12'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$clipRule('evenodd'),
							$elm$svg$Svg$Attributes$d('M6.74628 0.255342C7.08457 0.595797 7.08457 1.14779 6.74628 1.48824L2.26321 5.99998L6.74628 10.5117C7.08457 10.8522 7.08457 11.4042 6.74628 11.7446C6.40799 12.0851 5.85951 12.0851 5.52121 11.7446L0.42561 6.61643C0.0873172 6.27597 0.0873172 5.72398 0.42561 5.38353L5.52121 0.255342C5.85951 -0.0851138 6.40799 -0.0851139 6.74628 0.255342Z'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil)
				])));
};
var $author$project$Ui$V3$Pagination$view = F3(
	function (updatePageMsg, dropdown, currentPage) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3-pagination')
				]),
			_List_fromArray(
				[
					function () {
					switch (dropdown.$) {
						case 'Default':
							var onSelect = dropdown.a.onSelect;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3-pagination__per-page-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('v3-pagination__element')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('v3-pagination__per-page-label'),
														$elm$html$Html$Attributes$class('v3__type__h6')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Rows per page')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('v3-pagination__element')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$V3$SimpleSelect$view,
												{
													onInput: onSelect,
													options: _List_fromArray(
														[10, 20, 50, 100, 250]),
													toLabel: $elm$core$String$fromInt,
													value: $elm$core$Maybe$Just(
														$author$project$Pagination$entriesPerPage(currentPage))
												},
												_List_fromArray(
													[
														$author$project$Ui$V3$SimpleSelect$class('v3-pagination__per-page-select')
													]))
											]))
									]));
						case 'Custom':
							var el = dropdown.a;
							return el;
						default:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3-pagination__per-page-container')
									]),
								_List_Nil);
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3-pagination__right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3-pagination__element')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3-pagination__results'),
											$elm$html$Html$Attributes$class('v3__type__h6')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Ui$V3$Pagination$resultsText(currentPage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3-pagination__element')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3-pagination__arrow-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('v3-pagination__arrow-group')
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$V3$Pagination$viewFirstPageArrow, updatePageMsg, currentPage),
													A2($author$project$Ui$V3$Pagination$viewPreviousPageArrow, updatePageMsg, currentPage)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('v3-pagination__arrow-group')
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$V3$Pagination$viewNextPageArrow, updatePageMsg, currentPage),
													A2($author$project$Ui$V3$Pagination$viewLastPageArrow, updatePageMsg, currentPage)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Ui$V3$Table$viewPagination = function (_v0) {
	var currentPage = _v0.currentPage;
	var dropdown = _v0.dropdown;
	var updatePageMsg = _v0.updatePageMsg;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__table--pagination')
			]),
		_List_fromArray(
			[
				A3($author$project$Ui$V3$Pagination$view, updatePageMsg, dropdown, currentPage)
			]));
};
var $author$project$Ui$V3$Stack$ClassAttribute = function (a) {
	return {$: 'ClassAttribute', a: a};
};
var $author$project$Ui$V3$Stack$class = $author$project$Ui$V3$Stack$ClassAttribute;
var $author$project$Ui$V3$Stack$CrossAxisCenter = {$: 'CrossAxisCenter'};
var $author$project$Ui$V3$Stack$crossAxisCenter = $author$project$Ui$V3$Stack$CrossAxisAttribute($author$project$Ui$V3$Stack$CrossAxisCenter);
var $author$project$Ui$V3$Table$viewToolbar = function (computedAttributes) {
	var toolbarEls = computedAttributes.toolbarItems;
	return $elm$core$List$isEmpty(toolbarEls) ? _List_Nil : _List_fromArray(
		[
			A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$class('v3__table-toolbar'),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			toolbarEls)
		]);
};
var $author$project$Ui$V3$Table$viewWrappingDiv = F2(
	function (attrs, children) {
		return $elm$core$List$isEmpty(children) ? _List_Nil : _List_fromArray(
			[
				A2($elm$html$Html$div, attrs, children)
			]);
	});
var $author$project$Ui$V3$Table$viewContainer = F2(
	function (computedAttributes, tableHtml) {
		var styleSuffix = $author$project$Ui$V3$Table$styleToClassSuffix(computedAttributes.style);
		var maybeDrawer = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var content = _v0.content;
					var isOpen = _v0.isOpen;
					return isOpen ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v3__drawer-container')
							]),
						_List_fromArray(
							[content])) : $elm$html$Html$text('');
				},
				computedAttributes.drawer));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('v3__table-wrapper', true),
							_Utils_Tuple2('v3__table-wrapper--' + styleSuffix, true),
							_Utils_Tuple2('v3__table-wrapper--no-overflow', computedAttributes.noOverflow),
							_Utils_Tuple2('v3__table-wrapper--fill-height', computedAttributes.fillHeight)
						]))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						$author$project$Ui$V3$Table$viewToolbar(computedAttributes),
						A2(
						$author$project$Ui$V3$Table$viewWrappingDiv,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('v3__table-layout-row-wrap', true),
										_Utils_Tuple2('v3__table-layout-row-wrap--fill-height', computedAttributes.fillHeight)
									]))
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Table$viewWrappingDiv,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('v3__table-layout-column', true),
													_Utils_Tuple2('v3__table-layout-column--no-overflow', computedAttributes.noOverflow)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$class('v3__table-inner-layout-container'),
												_Utils_ap(
													$author$project$Ui$V3$Table$fillHeightStyle(computedAttributes.fillHeight),
													_Utils_ap(
														$author$project$Ui$V3$Table$minHeightStyle(computedAttributes.minHeight),
														$author$project$Ui$V3$Table$maxHeightStyle(computedAttributes.maxHeight)))),
											_List_fromArray(
												[tableHtml])),
											A2(
											$elm$core$Maybe$withDefault,
											$elm$html$Html$text(''),
											A2($elm$core$Maybe$map, $author$project$Ui$V3$Table$viewPagination, computedAttributes.pagination))
										])),
									_List_fromArray(
									[maybeDrawer])
								])))
					])));
	});
var $author$project$Ui$V3$Button$DisabledAttribute = function (a) {
	return {$: 'DisabledAttribute', a: a};
};
var $author$project$Ui$V3$Button$disabled = $author$project$Ui$V3$Button$DisabledAttribute;
var $author$project$Ui$V3$Table$emptyContentContainer = F2(
	function (columns, content) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(columns)),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'padding', 'var(--space-l)'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
							A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle')
						]),
					_List_fromArray(
						[content]))
				]));
	});
var $elm_community$list_extra$List$Extra$findMap = F2(
	function (f, list) {
		findMap:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var a = list.a;
				var tail = list.b;
				var _v1 = f(a);
				if (_v1.$ === 'Just') {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$f = f,
						$temp$list = tail;
					f = $temp$f;
					list = $temp$list;
					continue findMap;
				}
			}
		}
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				helper:
				while (true) {
					if (!scattered.b) {
						return $elm$core$List$reverse(gathered);
					} else {
						var toGather = scattered.a;
						var population = scattered.b;
						var _v1 = A2(
							$elm$core$List$partition,
							testFn(toGather),
							population);
						var gathering = _v1.a;
						var remaining = _v1.b;
						var $temp$scattered = remaining,
							$temp$gathered = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered);
						scattered = $temp$scattered;
						gathered = $temp$gathered;
						continue helper;
					}
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $author$project$Ui$V3$Table$maybeList = F2(
	function (f, maybe) {
		if (maybe.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var a = maybe.a;
			return _List_fromArray(
				[
					f(a)
				]);
		}
	});
var $author$project$Ui$V3$Button$OnClick = function (a) {
	return {$: 'OnClick', a: a};
};
var $author$project$Ui$V3$Button$onClick = function (message) {
	return $author$project$Ui$V3$Button$OnClick(message);
};
var $author$project$Ui$V3$Skeleton$viewCustom = F2(
	function (attrs, _v0) {
		var height = _v0.height;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__skeleton'),
						$elm$html$Html$Attributes$class('v3__skeleton--standalone'),
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2(
						$elm$html$Html$Attributes$style,
						'height',
						A2(
							$elm$core$Maybe$withDefault,
							'100%',
							A2($elm$core$Maybe$map, $author$project$Ui$V3$Helpers$Html$px, height)))
					]),
				attrs),
			_List_Nil);
	});
var $author$project$Ui$V3$Table$skeletonContent = A2(
	$author$project$Ui$V3$Skeleton$viewCustom,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'border-radius', '0'),
			A2($elm$html$Html$Attributes$style, 'height', '100%'),
			A2($elm$html$Html$Attributes$style, 'min-height', '300px')
		]),
	{height: $elm$core$Maybe$Nothing});
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $author$project$Ui$V3$Table$viewFooterCell = F2(
	function (styleSuffix, _v0) {
		var attributes = _v0.a;
		var child = _v0.b;
		return A2(
			$elm$html$Html$td,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('v3__table-cell v3__table-cell--footer v3__table-cell--footer--' + styleSuffix),
				attributes),
			_List_fromArray(
				[child]));
	});
var $author$project$Ui$V3$Table$SortableAttribute = {$: 'SortableAttribute'};
var $author$project$Ui$V3$Table$BottomAlignedAttribute = {$: 'BottomAlignedAttribute'};
var $author$project$Ui$V3$Table$isBottomAligned = function (attrs) {
	return A2($elm$core$List$member, $author$project$Ui$V3$Table$BottomAlignedAttribute, attrs);
};
var $author$project$Ui$V3$Table$RightAlignedAttribute = {$: 'RightAlignedAttribute'};
var $author$project$Ui$V3$Table$isRightAligned = function (attrs) {
	return A2($elm$core$List$member, $author$project$Ui$V3$Table$RightAlignedAttribute, attrs);
};
var $author$project$Ui$V3$Table$isTopAligned = function (attrs) {
	return A2($elm$core$List$member, $author$project$Ui$V3$Table$TopAlignedAttribute, attrs);
};
var $author$project$Ui$V3$Icon$DescriptionAttribute = function (a) {
	return {$: 'DescriptionAttribute', a: a};
};
var $author$project$Ui$V3$Icon$Label = function (a) {
	return {$: 'Label', a: a};
};
var $author$project$Ui$V3$Icon$label = A2($elm$core$Basics$composeL, $author$project$Ui$V3$Icon$DescriptionAttribute, $author$project$Ui$V3$Icon$Label);
var $author$project$Ui$V3$Icon$sort16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.57309 1.67891L7.99999 2.1627L7.99999 2.1627L8.57309 1.67891ZM11.4269 6.22225C11.6941 6.53877 12.1672 6.57875 12.4838 6.31157C12.8003 6.04438 12.8403 5.57119 12.5731 5.25467L11.4269 6.22225ZM3.4269 5.25467C3.15971 5.57119 3.19969 6.04438 3.51621 6.31157C3.83273 6.57875 4.30592 6.53877 4.5731 6.22225L3.4269 5.25467ZM7.42688 1.67891L6.85378 1.19512V1.19512L7.42688 1.67891ZM7.99999 2.1627L11.4269 6.22225L12.5731 5.25467L9.1462 1.19512L7.99999 2.1627ZM4.5731 6.22225L7.99999 2.1627L6.85378 1.19512L3.4269 5.25467L4.5731 6.22225ZM9.1462 1.19512C8.54694 0.485225 7.45304 0.485222 6.85378 1.19512L7.99999 2.1627L7.99999 2.1627L9.1462 1.19512Z'),
						$elm$svg$Svg$Attributes$fill('#C8D8EB')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.42691 14.3211L6.8538 14.8049L6.8538 14.8049L7.42691 14.3211ZM4.57313 9.77775C4.30594 9.46123 3.83275 9.42124 3.51624 9.68843C3.19972 9.95562 3.15973 10.4288 3.42692 10.7453L4.57313 9.77775ZM12.5731 10.7453C12.8403 10.4288 12.8003 9.95562 12.4838 9.68843C12.1673 9.42125 11.6941 9.46123 11.4269 9.77775L12.5731 10.7453ZM8.57312 14.3211L9.14622 14.8049L9.14622 14.8049L8.57312 14.3211ZM8.00001 13.8373L4.57313 9.77775L3.42692 10.7453L6.8538 14.8049L8.00001 13.8373ZM11.4269 9.77775L8.00001 13.8373L9.14622 14.8049L12.5731 10.7453L11.4269 9.77775ZM6.8538 14.8049C7.45307 15.5148 8.54696 15.5148 9.14622 14.8049L8.00001 13.8373L8.00001 13.8373L6.8538 14.8049Z'),
						$elm$svg$Svg$Attributes$fill('#C8D8EB')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Table$viewHeadCell = F2(
	function (computedAttrs, _v0) {
		var attrs = _v0.attrs;
		var heading = _v0.heading;
		var sortIconOrEmpty = A2($elm$core$List$member, $author$project$Ui$V3$Table$SortableAttribute, attrs) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('receivables-invoice-status__sort-icon')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Icon$view16,
					_List_fromArray(
						[
							$author$project$Ui$V3$Icon$label('test')
						]),
					$author$project$Ui$V3$Icon$sort16)
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$th,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('v3__table-cell', true),
							_Utils_Tuple2('v3__table-cell--head', true),
							_Utils_Tuple2(
							'v3__table-cell--head--' + $author$project$Ui$V3$Table$styleToClassSuffix(computedAttrs.style),
							true),
							_Utils_Tuple2(
							'v3__table-cell--head--right-aligned',
							$author$project$Ui$V3$Table$isRightAligned(attrs)),
							_Utils_Tuple2(
							'v3__table-cell--head--top-aligned',
							$author$project$Ui$V3$Table$isTopAligned(attrs)),
							_Utils_Tuple2(
							'v3__table-cell--head--bottom-aligned',
							$author$project$Ui$V3$Table$isBottomAligned(attrs))
						])),
				computedAttrs.headCellAttrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__table-cell--head--text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('receivables-invoice-status__sort')
								]),
							_List_fromArray(
								[heading])),
							sortIconOrEmpty
						]))
				]));
	});
var $author$project$Ui$V3$Table$viewNestedGroupHeader = F2(
	function (columns, rows) {
		var tds = A2(
			$elm$core$List$map,
			function (col) {
				return A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__table-cell')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v1) {
								var forSubgroup = _v1.forSubgroup;
								return _List_fromArray(
									[
										forSubgroup(rows)
									]);
							},
							A2(
								$elm_community$list_extra$List$Extra$findMap,
								function (attr) {
									if (attr.$ === 'NestedColumnAttribute') {
										var v = attr.a;
										return $elm$core$Maybe$Just(v);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								col.attrs))));
			},
			columns);
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('v3__table-body-row', true),
							_Utils_Tuple2('v3__table-body-row-nested-group-header', true)
						]))
				]),
			tds);
	});
var $author$project$Ui$V3$Table$viewBodyCell = F3(
	function (computedAttrs, row, _v0) {
		var attrs = _v0.attrs;
		var content = _v0.content;
		var cellAttrs = A2(
			$elm$core$List$concatMap,
			function (attr) {
				if (attr.$ === 'CellAttributes') {
					var getter = attr.a;
					return getter(row);
				} else {
					return _List_Nil;
				}
			},
			attrs);
		var tdAttrs = A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('v3__table-cell', true),
						_Utils_Tuple2('v3__table-cell--body', true),
						_Utils_Tuple2(
						'v3__table-cell--right-aligned',
						$author$project$Ui$V3$Table$isRightAligned(attrs)),
						_Utils_Tuple2(
						'v3__table-cell--top-aligned',
						$author$project$Ui$V3$Table$isTopAligned(attrs)),
						_Utils_Tuple2(
						'v3__table-cell--bottom-aligned',
						$author$project$Ui$V3$Table$isBottomAligned(attrs))
					])),
			cellAttrs);
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$html$Html$td,
				tdAttrs,
				_List_fromArray(
					[
						content(row)
					])),
			A2(
				$elm$core$Maybe$map,
				function (linkAttrs) {
					return A2(
						$elm$html$Html$td,
						_Utils_ap(
							tdAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__table-cell--linkable')
								])),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('v3__table-cell--link'),
											_Utils_ap(tdAttrs, linkAttrs)),
										_List_fromArray(
											[
												content(row)
											]))
									]))
							]));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (linkableRowAttrs_) {
						return linkableRowAttrs_(row);
					},
					computedAttrs.linkableRowAttrs)));
	});
var $author$project$Ui$V3$Table$zebraRowSuffix = function (index) {
	return (!A2($elm$core$Basics$modBy, 2, index)) ? '--zebra-even' : '--zebra-odd';
};
var $author$project$Ui$V3$Table$viewRow = F4(
	function (columns, computedAttrs, index, row) {
		var zebraSuffix = $author$project$Ui$V3$Table$zebraRowSuffix(index);
		var styleSuffix = $author$project$Ui$V3$Table$styleToClassSuffix(computedAttrs.style);
		var classes = _Utils_ap(
			_List_fromArray(
				['v3__table-body-row', 'v3__table-body-row--' + styleSuffix, 'v3__table-body-row--' + (styleSuffix + zebraSuffix)]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						_List_fromArray(
							['v3__table-body-row--linkable'])),
					A2(
						$elm$core$Maybe$andThen,
						function (linkableRowAttrs_) {
							return linkableRowAttrs_(row);
						},
						computedAttrs.linkableRowAttrs))));
		var _v0 = computedAttrs.loadingRow(row);
		if (_v0.$ === 'Just') {
			var height = _v0.a.height;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($elm$core$String$join, ' ', classes)),
							A2($elm$html$Html$Attributes$style, 'padding', '0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$colspan(
									$elm$core$List$length(columns)),
									A2($elm$html$Html$Attributes$style, 'padding', '0')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Skeleton$viewCustom,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'border-radius', '0')
										]),
									{
										height: $elm$core$Maybe$Just(height)
									})
								]))
						]))
				]);
		} else {
			var rowAttrs = computedAttrs.rowAttributes(row);
			var onClickDecoder = function (onClickHandler) {
				if (onClickHandler.$ === 'RawMessage') {
					var onClick = onClickHandler.a;
					return $elm$json$Json$Decode$succeed(
						{
							message: onClick(row),
							preventDefault: true,
							stopPropagation: true
						});
				} else {
					var decoder = onClickHandler.a;
					return A2(
						$elm$json$Json$Decode$map,
						function (msg) {
							return {message: msg, preventDefault: true, stopPropagation: true};
						},
						decoder(row));
				}
			};
			var tr = function () {
				var _v1 = computedAttrs.onClick;
				if (_v1.$ === 'Just') {
					var onClick = _v1.a;
					return A2(
						$elm$html$Html$tr,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									A2(
										$elm$core$String$join,
										' ',
										A2($elm$core$List$cons, 'v3__table-body-row--clickable', classes))),
									A2(
									$elm$html$Html$Events$custom,
									'click',
									onClickDecoder(onClick))
								]),
							rowAttrs),
						A2(
							$elm$core$List$map,
							A2($author$project$Ui$V3$Table$viewBodyCell, computedAttrs, row),
							columns));
				} else {
					return A2(
						$elm$html$Html$tr,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(
								A2($elm$core$String$join, ' ', classes)),
							rowAttrs),
						A2(
							$elm$core$List$map,
							A2($author$project$Ui$V3$Table$viewBodyCell, computedAttrs, row),
							columns));
				}
			}();
			var maybeSubRow = A2(
				$elm$core$Maybe$map,
				$elm$html$Html$tr(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[
										'v3__table-body-subrow',
										'v3__table-body-subrow--' + (styleSuffix + $author$project$Ui$V3$Table$zebraRowSuffix(index))
									])))
						])),
				A2(
					$elm$core$Maybe$andThen,
					function (func) {
						return func(row);
					},
					computedAttrs.subRow));
			return A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(tr),
						maybeSubRow
					]));
		}
	});
var $author$project$Ui$V3$Table$viewTable = F4(
	function (rows, columns, computedAttributes, tableAttrs) {
		var styleSuffix = $author$project$Ui$V3$Table$styleToClassSuffix(computedAttributes.style);
		var nestedTableHeaderRow = function () {
			var columnContents = A2(
				$elm$core$List$map,
				function (col) {
					return A2(
						$elm_community$list_extra$List$Extra$findMap,
						function (attr) {
							if (attr.$ === 'NestedColumnAttribute') {
								var forTable = attr.a.forTable;
								return $elm$core$Maybe$Just(forTable);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						col.attrs);
				},
				columns);
			return $elm$core$List$isEmpty(
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, columnContents)) ? _List_Nil : _List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__table-body-row')
						]),
					A2(
						$elm$core$List$map,
						function (content) {
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('v3__table-cell', true),
												_Utils_Tuple2('v3__table-cell-top-nested-group-header', true)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										content)
									]));
						},
						columnContents))
				]);
		}();
		var loadMoreBtnRow = F3(
			function (hasMore, onLoadMore, isLoading) {
				return hasMore ? _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(
								$elm$core$List$length(columns)),
								A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
								A2($elm$html$Html$Attributes$style, 'padding', 'var(--space-xs)')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick(onLoadMore)
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Button$disabled(isLoading)
									]),
								'Load more')
							]))
					]) : _List_Nil;
			});
		var _v0 = function () {
			if (tableAttrs.loading) {
				return _Utils_Tuple2(
					true,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$colspan(
											$elm$core$List$length(columns)),
											A2($elm$html$Html$Attributes$style, 'padding', '0'),
											A2($elm$html$Html$Attributes$style, 'height', '100%')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'height', '100%')
												]),
											_List_fromArray(
												[$author$project$Ui$V3$Table$skeletonContent]))
										]))
								]))
						]));
			} else {
				var viewRows = function () {
					var _v5 = computedAttributes.nestedRow;
					if (_v5.$ === 'Just') {
						var toKey = _v5.a;
						return function (rows_) {
							return A2(
								$elm$core$List$concatMap,
								function (_v6) {
									var first = _v6.a;
									var rest = _v6.b;
									return A2(
										$elm$core$List$cons,
										A2(
											$author$project$Ui$V3$Table$viewNestedGroupHeader,
											columns,
											A2($elm$core$List$cons, first, rest)),
										$elm$core$List$concat(
											A2(
												$elm$core$List$indexedMap,
												A2($author$project$Ui$V3$Table$viewRow, columns, computedAttributes),
												A2($elm$core$List$cons, first, rest))));
								},
								A2($elm_community$list_extra$List$Extra$gatherEqualsBy, toKey, rows_));
						};
					} else {
						return A2(
							$elm$core$Basics$composeR,
							$elm$core$List$indexedMap(
								A2($author$project$Ui$V3$Table$viewRow, columns, computedAttributes)),
							$elm$core$List$concat);
					}
				}();
				var _v1 = computedAttributes.loadMore;
				if (_v1.$ === 'Just') {
					var rowsToShowWhileLoading = _v1.a.rowsToShowWhileLoading;
					var onLoadMore = _v1.a.onLoadMore;
					var hasMore = _v1.a.hasMore;
					if (rowsToShowWhileLoading.$ === 'Just') {
						var rows_ = rowsToShowWhileLoading.a;
						return _Utils_Tuple2(
							false,
							_Utils_ap(
								viewRows(rows_),
								A3(loadMoreBtnRow, hasMore, onLoadMore, true)));
					} else {
						var _v3 = _Utils_Tuple2(rows, computedAttributes.emptyContent);
						if ((!_v3.a.b) && (_v3.b.$ === 'Just')) {
							var emptyContent_ = _v3.b.a;
							return _Utils_Tuple2(
								true,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Table$emptyContentContainer, columns, emptyContent_)
									]));
						} else {
							return _Utils_Tuple2(
								false,
								_Utils_ap(
									viewRows(rows),
									A3(loadMoreBtnRow, hasMore, onLoadMore, false)));
						}
					}
				} else {
					var _v4 = _Utils_Tuple2(rows, computedAttributes.emptyContent);
					if ((!_v4.a.b) && (_v4.b.$ === 'Just')) {
						var emptyContent_ = _v4.b.a;
						return _Utils_Tuple2(
							true,
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Table$emptyContentContainer, columns, emptyContent_)
								]));
					} else {
						return _Utils_Tuple2(
							false,
							viewRows(rows));
					}
				}
			}
		}();
		var useFullHeight = _v0.a;
		var tbodyChildren = _v0.b;
		return A2(
			$elm$html$Html$table,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('v3__table', true),
							_Utils_Tuple2('v3__table--' + styleSuffix, true)
						])),
				useFullHeight ? _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'height', '100%')
					]) : _List_Nil),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('v3__table-head', true),
									_Utils_Tuple2('v3__table-head--' + styleSuffix, true)
								]))
						]),
					computedAttributes.noHeader ? _List_Nil : A2(
						$elm$core$List$map,
						$author$project$Ui$V3$Table$viewHeadCell(computedAttributes),
						columns)),
					A2(
					$elm$html$Html$tbody,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('v3__table-body', true),
									_Utils_Tuple2('v3__table-body--' + styleSuffix, true)
								]))
						]),
					_Utils_ap(nestedTableHeaderRow, tbodyChildren)),
					A2(
					$elm$html$Html$tfoot,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__table-foot')
						]),
					A2(
						$author$project$Ui$V3$Table$maybeList,
						A2(
							$elm$core$Basics$composeL,
							$elm$html$Html$tr(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3__table-foot-row'),
										$elm$html$Html$Attributes$class('v3__table-foot-row--' + styleSuffix)
									])),
							$elm$core$List$map(
								$author$project$Ui$V3$Table$viewFooterCell(styleSuffix))),
						computedAttributes.footer))
				]));
	});
var $author$project$Ui$V3$Table$view = F4(
	function (_v0, attributes, tableAttributes, rows) {
		var columns = _v0.columns;
		var computedTableAttributes = $author$project$Ui$V3$Table$computeTableAttributes(tableAttributes);
		var computedAttributes = $author$project$Ui$V3$Table$computeAttributes(attributes);
		return A2(
			$author$project$Ui$V3$Table$viewContainer,
			computedAttributes,
			A4($author$project$Ui$V3$Table$viewTable, rows, columns, computedAttributes, computedTableAttributes));
	});
var $author$project$Path$factorInvoice = F2(
	function (id, pathContext) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$FactorInvoiceId$toInt(id));
		var basePath = pathContext.isReadonly ? _List_fromArray(
			['app', 'readonly_factor_invoices', idString]) : (pathContext.useFactorInvoiceWorkflowPage ? _List_fromArray(
			['app', 'factor_invoices_workflow', idString]) : _List_fromArray(
			['app', 'factor_invoices', idString]));
		return $author$project$Path$base(basePath);
	});
var $author$project$Ui$V3$Link$TargetAttribute = function (a) {
	return {$: 'TargetAttribute', a: a};
};
var $author$project$Ui$V3$Link$targetBlank = $author$project$Ui$V3$Link$TargetAttribute('_blank');
var $author$project$Ui$V3$Link$defaultAttributes = {target: $elm$core$Maybe$Nothing};
var $author$project$Ui$V3$Link$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			var value = a.a;
			return _Utils_update(
				acc,
				{
					target: $elm$core$Maybe$Just(value)
				});
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Link$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Link$view = F2(
	function (_v0, attributes) {
		var text = _v0.text;
		var url = _v0.url;
		var computedAttributes = $author$project$Ui$V3$Link$computeAttributes(attributes);
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__link'),
					$elm$html$Html$Attributes$href(url),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$Attributes$class(''),
					A2($elm$core$Maybe$map, $elm$html$Html$Attributes$target, computedAttributes.target))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text)
				]));
	});
var $author$project$Components$DebtorChanges$Common$viewInvoiceLink = function (id) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[$author$project$Ui$V3$Typography$bodyClass]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Link$view,
				{
					text: '#' + $elm$core$String$fromInt(
						$author$project$Domain$FactorInvoiceId$toInt(id)),
					url: $author$project$Path$toString(
						A2(
							$author$project$Path$factorInvoice,
							id,
							{isReadonly: true, useFactorInvoiceWorkflowPage: false}))
				},
				_List_fromArray(
					[$author$project$Ui$V3$Link$targetBlank]))
			]));
};
var $author$project$Ui$V3$Stack$spaceXXXSmall = $author$project$Ui$V3$Stack$SpatialUnit('xxxs');
var $author$project$Components$DebtorChanges$Common$viewDebtor = function (debtor) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$body, _List_Nil, debtor.name),
				$elm$core$String$isEmpty(debtor.mcNumber) ? $author$project$Components$DebtorChanges$Common$viewSubtle('No MC') : $author$project$Components$DebtorChanges$Common$viewSubtle('MC ' + debtor.mcNumber)
			]));
};
var $author$project$Components$DebtorChanges$Common$viewMaybeDebtor = function (maybeDebtor) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$DebtorChanges$Common$viewSubtle('None'),
		A2($elm$core$Maybe$map, $author$project$Components$DebtorChanges$Common$viewDebtor, maybeDebtor));
};
var $author$project$Ui$V3$DescriptorTag$AlertStyle = {$: 'AlertStyle'};
var $author$project$Ui$V3$DescriptorTag$DefaultStyle = {$: 'DefaultStyle'};
var $author$project$Ui$V3$DescriptorTag$DescriptorTagStyle = function (a) {
	return {$: 'DescriptorTagStyle', a: a};
};
var $author$project$Ui$V3$DescriptorTag$SuccessStyle = {$: 'SuccessStyle'};
var $author$project$Ui$V3$DescriptorTag$WarningStyle = {$: 'WarningStyle'};
var $author$project$Components$DebtorChanges$Common$outcomeLabel = function (outcome) {
	switch (outcome.$) {
		case 'DebtorChangeOutcomeCorrect':
			return 'Correct';
		case 'DebtorChangeOutcomeWrongGuess':
			return 'Wrong guess';
		case 'DebtorChangeOutcomeNoGuess':
			return 'No guess';
		default:
			return 'Not labeled';
	}
};
var $author$project$Ui$V3$Tooltip$AboveDirection = {$: 'AboveDirection'};
var $author$project$Ui$V3$Tooltip$BeginningLocation = {$: 'BeginningLocation'};
var $author$project$Ui$V3$Tooltip$TooltipDirection = function (a) {
	return {$: 'TooltipDirection', a: a};
};
var $author$project$Ui$V3$Tooltip$tooltipDirection = $author$project$Ui$V3$Tooltip$TooltipDirection;
var $author$project$Ui$V3$Tooltip$TooltipLocation = function (a) {
	return {$: 'TooltipLocation', a: a};
};
var $author$project$Ui$V3$Tooltip$tooltipLocation = $author$project$Ui$V3$Tooltip$TooltipLocation;
var $author$project$Ui$V3$Tooltip$AutoWidth = {$: 'AutoWidth'};
var $author$project$Ui$V3$Tooltip$MiddleLocation = {$: 'MiddleLocation'};
var $author$project$Ui$V3$Tooltip$defaultAttributes = {direction: $author$project$Ui$V3$Tooltip$AboveDirection, header: '', location: $author$project$Ui$V3$Tooltip$MiddleLocation, styles: _List_Nil, width: $author$project$Ui$V3$Tooltip$AutoWidth};
var $author$project$Ui$V3$Tooltip$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'TooltipDirection':
					var direction = a.a;
					return _Utils_update(
						acc,
						{direction: direction});
				case 'TooltipLocation':
					var location = a.a;
					return _Utils_update(
						acc,
						{location: location});
				case 'TooltipWidth':
					var width = a.a;
					return _Utils_update(
						acc,
						{width: width});
				case 'TooltipHeader':
					var header = a.a;
					return _Utils_update(
						acc,
						{header: header});
				default:
					var key = a.a;
					var val = a.b;
					return _Utils_update(
						acc,
						{
							styles: _Utils_ap(
								acc.styles,
								_List_fromArray(
									[
										_Utils_Tuple2(key, val)
									]))
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Tooltip$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Tooltip$tooltipContent = F2(
	function (attributes, content) {
		var computedAttributes = $author$project$Ui$V3$Tooltip$computeAttributes(attributes);
		return (computedAttributes.header !== '') ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__tooltip--header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(computedAttributes.header)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(content)
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	});
var $author$project$Ui$V3$Tooltip$tooltipDirectionClass = function (direction) {
	switch (direction.$) {
		case 'AboveDirection':
			return 'v3__tooltip--above';
		case 'LeftDirection':
			return 'v3__tooltip--left';
		case 'RightDirection':
			return 'v3__tooltip--right';
		default:
			return 'v3__tooltip--below';
	}
};
var $author$project$Ui$V3$Tooltip$tooltipLocationStyle = function (location) {
	switch (location.$) {
		case 'BeginningLocation':
			return $elm$html$Html$Attributes$class('v3__tooltip--beginning');
		case 'MiddleLocation':
			return $elm$html$Html$Attributes$class('v3__tooltip--middle');
		case 'EndLocation':
			return $elm$html$Html$Attributes$class('v3__tooltip--end');
		case 'HiddenLocation':
			return $elm$html$Html$Attributes$class('v3__tooltip--hidden');
		default:
			var left = location.a;
			return A2($elm$html$Html$Attributes$style, 'left', left);
	}
};
var $author$project$Ui$V3$Tooltip$tooltipStyles = function (styles) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var key = _v0.a;
			var val = _v0.b;
			return A2($elm$html$Html$Attributes$style, key, val);
		},
		styles);
};
var $author$project$Ui$V3$Tooltip$tooltipWidthStyles = function (width) {
	if (width.$ === 'AutoWidth') {
		return _List_Nil;
	} else {
		var px = width.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromInt(px) + 'px'),
				A2($elm$html$Html$Attributes$style, 'white-space', 'break-spaces'),
				A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box')
			]);
	}
};
var $author$project$Ui$V3$Tooltip$viewHtml = F3(
	function (attributes, tooltipHtml, element) {
		var computedAttributes = $author$project$Ui$V3$Tooltip$computeAttributes(attributes);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__tooltip--wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v3__tooltip'),
								$elm$html$Html$Attributes$class(
								$author$project$Ui$V3$Tooltip$tooltipDirectionClass(computedAttributes.direction)),
								$author$project$Ui$V3$Tooltip$tooltipLocationStyle(computedAttributes.location)
							]),
						_Utils_ap(
							$author$project$Ui$V3$Tooltip$tooltipWidthStyles(computedAttributes.width),
							$author$project$Ui$V3$Tooltip$tooltipStyles(computedAttributes.styles))),
					_List_fromArray(
						[tooltipHtml])),
					element
				]));
	});
var $author$project$Ui$V3$Tooltip$view = F2(
	function (attributes, tooltipStr) {
		return A2(
			$author$project$Ui$V3$Tooltip$viewHtml,
			attributes,
			A2($author$project$Ui$V3$Tooltip$tooltipContent, attributes, tooltipStr));
	});
var $author$project$Ui$V3$DescriptorTag$addToolTip = $author$project$Ui$V3$Tooltip$view(
	_List_fromArray(
		[
			$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$AboveDirection),
			$author$project$Ui$V3$Tooltip$tooltipLocation($author$project$Ui$V3$Tooltip$BeginningLocation)
		]));
var $author$project$Ui$V3$DescriptorTag$defaultAttributes = {style: $author$project$Ui$V3$DescriptorTag$SuccessStyle, truncateText: false};
var $author$project$Ui$V3$DescriptorTag$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			if (a.$ === 'DescriptorTagStyle') {
				var style = a.a;
				return _Utils_update(
					acc,
					{style: style});
			} else {
				return _Utils_update(
					acc,
					{truncateText: true});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$DescriptorTag$defaultAttributes, attributes);
};
var $author$project$Ui$V3$DescriptorTag$descriptorTagStyleClass = function (style) {
	switch (style.$) {
		case 'SuccessStyle':
			return 'success';
		case 'InfoStyle':
			return 'info';
		case 'WarningStyle':
			return 'warning';
		case 'AlertStyle':
			return 'alert';
		default:
			return 'default';
	}
};
var $author$project$Ui$V3$DescriptorTag$descriptorTagView = F2(
	function (computedAttributes, text) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__descriptor-tag'),
					$elm$html$Html$Attributes$class(
					'v3__descriptor-tag--color-' + $author$project$Ui$V3$DescriptorTag$descriptorTagStyleClass(computedAttributes.style))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text)
				]));
	});
var $author$project$Ui$V3$DescriptorTag$view = F2(
	function (attributes, text) {
		var computedAttributes = $author$project$Ui$V3$DescriptorTag$computeAttributes(attributes);
		return computedAttributes.truncateText ? A2(
			$author$project$Ui$V3$DescriptorTag$addToolTip,
			text,
			A2(
				$author$project$Ui$V3$DescriptorTag$descriptorTagView,
				computedAttributes,
				A2($elm$core$String$left, 1, text))) : A2($author$project$Ui$V3$DescriptorTag$descriptorTagView, computedAttributes, text);
	});
var $author$project$Components$DebtorChanges$Common$viewOutcome = function (outcome) {
	var style = function () {
		switch (outcome.$) {
			case 'DebtorChangeOutcomeCorrect':
				return $author$project$Ui$V3$DescriptorTag$SuccessStyle;
			case 'DebtorChangeOutcomeWrongGuess':
				return $author$project$Ui$V3$DescriptorTag$AlertStyle;
			case 'DebtorChangeOutcomeNoGuess':
				return $author$project$Ui$V3$DescriptorTag$WarningStyle;
			default:
				return $author$project$Ui$V3$DescriptorTag$DefaultStyle;
		}
	}();
	return A2(
		$author$project$Ui$V3$DescriptorTag$view,
		_List_fromArray(
			[
				$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle(style)
			]),
		$author$project$Components$DebtorChanges$Common$outcomeLabel(outcome));
};
var $author$project$Components$DebtorChanges$Common$OnlyOutcome = function (a) {
	return {$: 'OnlyOutcome', a: a};
};
var $author$project$Ui$V3$SimpleSelect$AutoWidthAttribute = {$: 'AutoWidthAttribute'};
var $author$project$Ui$V3$SimpleSelect$autoWidth = $author$project$Ui$V3$SimpleSelect$AutoWidthAttribute;
var $author$project$Ui$V3$SimpleSelect$OptionValueAttribute = function (a) {
	return {$: 'OptionValueAttribute', a: a};
};
var $author$project$Ui$V3$SimpleSelect$optionValue = $author$project$Ui$V3$SimpleSelect$OptionValueAttribute;
var $author$project$Ui$V3$SimpleSelect$SizeAttribute = function (a) {
	return {$: 'SizeAttribute', a: a};
};
var $author$project$Ui$V3$SimpleSelect$Small = {$: 'Small'};
var $author$project$Ui$V3$SimpleSelect$sizeSmall = $author$project$Ui$V3$SimpleSelect$SizeAttribute($author$project$Ui$V3$SimpleSelect$Small);
var $author$project$Components$DebtorChanges$Common$viewOutcomeFilter = F2(
	function (_v0, selected) {
		var onSelect = _v0.onSelect;
		var outcomes = _v0.outcomes;
		var allLabel = _v0.allLabel;
		var label = function (filter) {
			if (filter.$ === 'AnyOutcome') {
				return allLabel;
			} else {
				var outcome = filter.a;
				return $author$project$Components$DebtorChanges$Common$outcomeLabel(outcome);
			}
		};
		return A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{
				onInput: onSelect,
				options: A2(
					$elm$core$List$cons,
					$author$project$Components$DebtorChanges$Common$AnyOutcome,
					A2($elm$core$List$map, $author$project$Components$DebtorChanges$Common$OnlyOutcome, outcomes)),
				toLabel: label,
				value: $elm$core$Maybe$Just(selected)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$SimpleSelect$optionValue(label),
					$author$project$Ui$V3$SimpleSelect$sizeSmall,
					$author$project$Ui$V3$SimpleSelect$autoWidth
				]));
	});
var $author$project$Components$DebtorChanges$Common$viewProcessedBy = function (processedByUser) {
	return processedByUser ? A2($author$project$Ui$V3$Typography$body, _List_Nil, 'User') : A2($author$project$Ui$V3$Typography$body, _List_Nil, 'Automatic');
};
var $author$project$Ui$V3$Stack$CrossAxisLeft = {$: 'CrossAxisLeft'};
var $author$project$Ui$V3$Stack$crossAxisLeft = $author$project$Ui$V3$Stack$CrossAxisAttribute($author$project$Ui$V3$Stack$CrossAxisLeft);
var $author$project$Path$debtorChangesTemplate = F2(
	function (templateId, _v0) {
		var endDate = _v0.endDate;
		var startDate = _v0.startDate;
		return A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2('start_date', startDate),
					_Utils_Tuple2('end_date', endDate)
				]),
			$author$project$Path$base(
				_List_fromArray(
					[
						'app',
						'debtor_changes',
						'templates',
						$elm$core$String$fromInt(templateId)
					])));
	});
var $author$project$Components$DebtorChanges$IndexPage$viewRateConfirmation = F2(
	function (dates, rateConfirmation) {
		var _v0 = _Utils_Tuple2(rateConfirmation.templateId, rateConfirmation.templateEditorUrl);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var templateId = _v0.a.a;
			var url = _v0.b.a;
			return A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
						$author$project$Ui$V3$Stack$crossAxisCenter
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[$author$project$Ui$V3$Typography$bodyClass]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Link$view,
									{
										text: '#' + $elm$core$String$fromInt(templateId),
										url: $author$project$Path$toString(
											A2($author$project$Path$debtorChangesTemplate, templateId, dates))
									},
									_List_Nil)
								]))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[$author$project$Ui$V3$Typography$smallBodyClass]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Link$view,
									{text: 'Edit', url: url},
									_List_fromArray(
										[$author$project$Ui$V3$Link$targetBlank]))
								])))
					]));
		} else {
			return $author$project$Components$DebtorChanges$Common$viewSubtle('No match');
		}
	});
var $author$project$Components$DebtorChanges$IndexPage$viewRateConfirmations = F2(
	function (dates, rateConfirmations) {
		if (!rateConfirmations.b) {
			return $author$project$Components$DebtorChanges$Common$viewSubtle('No rate con');
		} else {
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
						$author$project$Ui$V3$Stack$crossAxisLeft
					]),
				A2(
					$elm$core$List$map,
					$author$project$Components$DebtorChanges$IndexPage$viewRateConfirmation(dates),
					rateConfirmations));
		}
	});
var $author$project$Components$DebtorChanges$IndexPage$NoTemplate = {$: 'NoTemplate'};
var $author$project$Components$DebtorChanges$IndexPage$OnlyTemplate = function (a) {
	return {$: 'OnlyTemplate', a: a};
};
var $author$project$Components$DebtorChanges$IndexPage$SelectedTemplate = function (a) {
	return {$: 'SelectedTemplate', a: a};
};
var $author$project$Components$DebtorChanges$IndexPage$templateFilterLabel = function (filter) {
	switch (filter.$) {
		case 'AnyTemplate':
			return 'All templates';
		case 'NoTemplate':
			return 'No template matched';
		default:
			var id = filter.a;
			return 'Template #' + $elm$core$String$fromInt(id);
	}
};
var $author$project$Components$DebtorChanges$IndexPage$viewTemplateFilter = F2(
	function (selected, summaries) {
		var named = A2(
			$elm$core$List$cons,
			$author$project$Components$DebtorChanges$IndexPage$AnyTemplate,
			A2(
				$elm$core$List$cons,
				$author$project$Components$DebtorChanges$IndexPage$NoTemplate,
				A2(
					$elm$core$List$map,
					function (summary) {
						return $author$project$Components$DebtorChanges$IndexPage$OnlyTemplate(summary.template.id);
					},
					summaries)));
		var options = A2($elm$core$List$member, selected, named) ? named : _Utils_ap(
			named,
			_List_fromArray(
				[selected]));
		return A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{
				onInput: $author$project$Components$DebtorChanges$IndexPage$SelectedTemplate,
				options: options,
				toLabel: $author$project$Components$DebtorChanges$IndexPage$templateFilterLabel,
				value: $elm$core$Maybe$Just(selected)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$SimpleSelect$optionValue($author$project$Components$DebtorChanges$IndexPage$templateFilterLabel),
					$author$project$Ui$V3$SimpleSelect$sizeSmall,
					$author$project$Ui$V3$SimpleSelect$autoWidth
				]));
	});
var $author$project$Components$DebtorChanges$IndexPage$viewInvoices = F3(
	function (model, dates, report) {
		var currentPage = A3(
			$author$project$Pagination$fromList,
			model.invoicePage,
			$author$project$Components$DebtorChanges$IndexPage$entriesPerPage,
			A2(
				$elm$core$List$filter,
				$author$project$Components$DebtorChanges$IndexPage$matchesTemplate(model.template),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.outcome;
						},
						$author$project$Components$DebtorChanges$Common$matchesOutcome(model.outcome)),
					report.invoices)));
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.factorInvoiceId;
							},
							$author$project$Components$DebtorChanges$Common$viewInvoiceLink),
						heading: $elm$html$Html$text('Invoice')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (invoice) {
							return A2(
								$author$project$Ui$V3$Typography$body,
								_List_Nil,
								A2($author$project$Helpers$Date$dateString, model.timezone, invoice.createdAt));
						},
						heading: $elm$html$Html$text('Created')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.outcome;
							},
							$author$project$Components$DebtorChanges$Common$viewOutcome),
						heading: $elm$html$Html$text('Change')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.guessedDebtor;
							},
							$author$project$Components$DebtorChanges$Common$viewMaybeDebtor),
						heading: $elm$html$Html$text('We guessed')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.finalDebtor;
							},
							$author$project$Components$DebtorChanges$Common$viewMaybeDebtor),
						heading: $elm$html$Html$text('Final debtor')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.processedByUser;
							},
							$author$project$Components$DebtorChanges$Common$viewProcessedBy),
						heading: $elm$html$Html$text('Processed by')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (invoice) {
							return A2($author$project$Components$DebtorChanges$IndexPage$viewRateConfirmations, dates, invoice.rateConfirmations);
						},
						heading: $elm$html$Html$text('Rate con template')
					}
					])
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$toolbarItems(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Ui$V3$Table$toolbarCustomHtml(
								A2(
									$author$project$Components$DebtorChanges$Common$viewOutcomeFilter,
									{
										allLabel: 'All changes',
										onSelect: $author$project$Components$DebtorChanges$IndexPage$SelectedOutcome,
										outcomes: _List_fromArray(
											[$author$project$AuditPb$DebtorChangeOutcomeWrongGuess, $author$project$AuditPb$DebtorChangeOutcomeNoGuess])
									},
									model.outcome))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Ui$V3$Table$toolbarCustomHtml(
								A2($author$project$Components$DebtorChanges$IndexPage$viewTemplateFilter, model.template, report.templates))),
							_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Ui$V3$Table$toolbarEmpty)
						])),
					$author$project$Ui$V3$Table$pagination(
					{currentPage: currentPage, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$DebtorChanges$IndexPage$UpdatedInvoicePage}),
					$author$project$Ui$V3$Table$emptyContent(
					$author$project$Components$DebtorChanges$Common$viewSubtle('No changed invoices match.'))
				]),
			_List_Nil,
			$author$project$Pagination$entries(currentPage));
	});
var $author$project$Components$DebtorChanges$Common$viewRangeError = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('alert-box warning')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				function () {
					if (error.$ === 'DebtorChangeReportErrorInvalidRange') {
						return 'Pick a start date on or before the end date, and no more than 30 days apart.';
					} else {
						return 'That range took too long to load. Try a shorter one.';
					}
				}())
			]));
};
var $author$project$Components$DebtorChanges$IndexPage$UpdatedTemplatePage = function (a) {
	return {$: 'UpdatedTemplatePage', a: a};
};
var $author$project$Components$DebtorChanges$Common$viewCount = function (count) {
	return A2(
		$author$project$Ui$V3$Typography$body,
		_List_Nil,
		$elm$core$String$fromInt(count));
};
var $author$project$Components$DebtorChanges$Common$viewWarningTag = function (text) {
	return A2(
		$author$project$Ui$V3$DescriptorTag$view,
		_List_fromArray(
			[
				$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$WarningStyle)
			]),
		text);
};
var $author$project$Components$DebtorChanges$Common$viewPinWriters = function (template) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
				$author$project$Ui$V3$Stack$crossAxisLeft
			]),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (id) {
						return $author$project$Components$DebtorChanges$Common$viewWarningTag(
							'Template group ' + $elm$core$String$fromInt(id));
					},
					template.documentsTemplatesGroupId),
					A2(
					$elm$core$Maybe$map,
					function (id) {
						return $author$project$Components$DebtorChanges$Common$viewWarningTag(
							'Network broker ' + $elm$core$String$fromInt(id));
					},
					template.networkBrokerId)
				])));
};
var $author$project$Components$DebtorChanges$Common$viewPins = function (pins) {
	if (!pins.b) {
		return $author$project$Components$DebtorChanges$Common$viewSubtle('None');
	} else {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			A2($elm$core$List$map, $author$project$Components$DebtorChanges$Common$viewDebtor, pins));
	}
};
var $author$project$Ui$V3$Button$SizeSmall = {$: 'SizeSmall'};
var $author$project$Ui$V3$Button$VariantTertiary = {$: 'VariantTertiary'};
var $author$project$Ui$V3$Button$ButtonSize = function (a) {
	return {$: 'ButtonSize', a: a};
};
var $author$project$Ui$V3$Button$buttonSize = $author$project$Ui$V3$Button$ButtonSize;
var $author$project$Ui$V3$Button$ButtonVariant = function (a) {
	return {$: 'ButtonVariant', a: a};
};
var $author$project$Ui$V3$Button$buttonVariant = $author$project$Ui$V3$Button$ButtonVariant;
var $author$project$Components$DebtorChanges$IndexPage$viewShowInvoices = function (summary) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick(
				$author$project$Components$DebtorChanges$IndexPage$SelectedTemplate(
					$author$project$Components$DebtorChanges$IndexPage$OnlyTemplate(summary.template.id)))
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
			]),
		'Show invoices');
};
var $author$project$Components$DebtorChanges$IndexPage$viewTemplateLink = F2(
	function (dates, template) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
					$author$project$Ui$V3$Stack$crossAxisLeft
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[$author$project$Ui$V3$Typography$bodyClass]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Link$view,
							{
								text: '#' + $elm$core$String$fromInt(template.id),
								url: $author$project$Path$toString(
									A2($author$project$Path$debtorChangesTemplate, template.id, dates))
							},
							_List_Nil)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Helpers$Html$empty,
					A2($elm$core$Maybe$map, $author$project$Components$DebtorChanges$Common$viewSubtle, template.label)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[$author$project$Ui$V3$Typography$smallBodyClass]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Link$view,
							{text: 'Edit', url: template.editorUrl},
							_List_fromArray(
								[$author$project$Ui$V3$Link$targetBlank]))
						]))
				]));
	});
var $author$project$Components$DebtorChanges$IndexPage$viewTemplates = F3(
	function (model, dates, summaries) {
		var currentPage = A3($author$project$Pagination$fromList, model.templatePage, $author$project$Components$DebtorChanges$IndexPage$entriesPerPage, summaries);
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (summary) {
							return A2($author$project$Components$DebtorChanges$IndexPage$viewTemplateLink, dates, summary.template);
						},
						heading: $elm$html$Html$text('Template')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (summary) {
							return $author$project$Components$DebtorChanges$Common$viewPins(summary.template.accountPins);
						},
						heading: $elm$html$Html$text('Pinned debtors on this account')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (summary) {
							return $author$project$Components$DebtorChanges$Common$viewCount(summary.wrongGuesses);
						},
						heading: $elm$html$Html$text('Wrong guesses')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (summary) {
							return $author$project$Components$DebtorChanges$Common$viewCount(summary.wrongGuessesOfAPin);
						},
						heading: $elm$html$Html$text('Guessed a pinned debtor')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (summary) {
							return $author$project$Components$DebtorChanges$Common$viewCount(summary.noGuesses);
						},
						heading: $elm$html$Html$text('No guess')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (summary) {
							return $author$project$Components$DebtorChanges$Common$viewPinWriters(summary.template);
						},
						heading: $elm$html$Html$text('Pins rewritten by')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$DebtorChanges$IndexPage$viewShowInvoices,
						heading: $elm$html$Html$text('')
					}
					])
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$pagination(
					{currentPage: currentPage, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$DebtorChanges$IndexPage$UpdatedTemplatePage}),
					$author$project$Ui$V3$Table$emptyContent(
					$author$project$Components$DebtorChanges$Common$viewSubtle('No changed invoice in this range had a template match.'))
				]),
			_List_Nil,
			$author$project$Pagination$entries(currentPage));
	});
var $author$project$Components$DebtorChanges$IndexPage$viewReport = F2(
	function (report, model) {
		var _v0 = report.error;
		if (_v0.$ === 'Just') {
			var error = _v0.a;
			return _List_fromArray(
				[
					$author$project$Components$DebtorChanges$Common$viewRangeError(error)
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('By template')
						])),
					A3(
					$author$project$Components$DebtorChanges$IndexPage$viewTemplates,
					model,
					{endDate: report.endDate, startDate: report.startDate},
					report.templates),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoices')
						])),
					A3(
					$author$project$Components$DebtorChanges$IndexPage$viewInvoices,
					model,
					{endDate: report.endDate, startDate: report.startDate},
					report)
				]);
		}
	});
var $author$project$Components$DebtorChanges$IndexPage$view = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium),
								$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceMedium)
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Debtor Changes by Template')
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Components$DebtorChanges$Common$viewRangeForm,
									{onApply: $author$project$Components$DebtorChanges$IndexPage$Applied, onEndDate: $author$project$Components$DebtorChanges$IndexPage$ChangedEndDate, onStartDate: $author$project$Components$DebtorChanges$IndexPage$ChangedStartDate},
									A2(
										$author$project$Components$DebtorChanges$IndexPage$formRange,
										$author$project$Forward$Remote$Loaded(data),
										model)),
								A2($author$project$Components$DebtorChanges$IndexPage$viewReport, data, model)))))
				]));
	});
var $author$project$Components$DebtorChanges$IndexPage$page = $author$project$Forward$Component$forwardComponent(
	{init: $author$project$Components$DebtorChanges$IndexPage$init, loadData: $author$project$Components$DebtorChanges$IndexPage$loadData, update: $author$project$Components$DebtorChanges$IndexPage$update, v3ReskinEnabled: true, viewLoaded: $author$project$Components$DebtorChanges$IndexPage$view});
var $author$project$Components$DebtorChanges$TemplatePage$AnyDebtor = {$: 'AnyDebtor'};
var $author$project$Components$DebtorChanges$TemplatePage$GotTimezone = function (a) {
	return {$: 'GotTimezone', a: a};
};
var $author$project$Components$DebtorChanges$TemplatePage$init = function (params) {
	return _Utils_Tuple2(
		{
			debtor: $author$project$Components$DebtorChanges$TemplatePage$AnyDebtor,
			draft: $elm$core$Maybe$Nothing,
			matchPage: 1,
			outcome: $author$project$Components$DebtorChanges$Common$AnyOutcome,
			query: {
				endDate: A2($elm$core$Maybe$withDefault, '', params.endDate),
				startDate: A2($elm$core$Maybe$withDefault, '', params.startDate),
				templateId: params.templateId
			},
			timezone: $elm$time$Time$utc
		},
		$author$project$HubTran$Effect$cmd(
			A2($elm$core$Task$perform, $author$project$Components$DebtorChanges$TemplatePage$GotTimezone, $author$project$Helpers$Date$localTimezone)));
};
var $author$project$Forward$AppSpecific$Cache$debtorChangeTemplate = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.debtorChangeTemplate;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{debtorChangeTemplate: e});
		}));
var $author$project$AuditPb$DebtorChangeTemplate = F5(
	function (template, matches, error, startDate, endDate) {
		return {endDate: endDate, error: error, matches: matches, startDate: startDate, template: template};
	});
var $author$project$AuditPb$DebtorChangeTemplateMatch = F9(
	function (documentId, documentType, matchedAt, factorInvoiceId, outcome, guessedDebtor, finalDebtor, processedByUser, templateEditorUrl) {
		return {documentId: documentId, documentType: documentType, factorInvoiceId: factorInvoiceId, finalDebtor: finalDebtor, guessedDebtor: guessedDebtor, matchedAt: matchedAt, outcome: outcome, processedByUser: processedByUser, templateEditorUrl: templateEditorUrl};
	});
var $author$project$AuditPb$debtorChangeTemplateMatchDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'template_editor_url',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'processed_by_user',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$optionalMessage,
					'final_debtor',
					$author$project$AuditPb$debtorChangeDebtorDecoder,
					A3(
						$author$project$AuditPb$optionalMessage,
						'guessed_debtor',
						$author$project$AuditPb$debtorChangeDebtorDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'outcome',
							$author$project$AuditPb$debtorChangeOutcomeDecoder,
							A3(
								$author$project$AuditPb$optional,
								'factor_invoice_id',
								A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'matched_at',
									$author$project$AuditPb$timestampDecoder,
									A3(
										$author$project$AuditPb$optional,
										'document_type',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'document_id',
											A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
											$author$project$AuditPb$decode($author$project$AuditPb$DebtorChangeTemplateMatch))))))))));
	});
var $author$project$AuditPb$debtorChangeTemplateDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'end_date',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'start_date',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'error',
					$author$project$AuditPb$debtorChangeReportErrorDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'matches',
						$author$project$AuditPb$debtorChangeTemplateMatchDecoder,
						A3(
							$author$project$AuditPb$optionalMessage,
							'template',
							$author$project$AuditPb$debtorChangeTemplateInfoDecoder,
							$author$project$AuditPb$decode($author$project$AuditPb$DebtorChangeTemplate))))));
	});
var $author$project$AuditPb$debtorChangeTemplateQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'template_id', $elm$json$Json$Encode$int, v.templateId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'start_date', $elm$json$Json$Encode$string, v.startDate),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'end_date', $elm$json$Json$Encode$string, v.endDate)
				])));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorChangeTemplate = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$debtorChangeTemplate,
		decoder: $author$project$AuditPb$debtorChangeTemplateDecoder,
		entrypoint: 'debtorChangeTemplate',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$debtorChangeTemplateQueryEncoder)
	});
var $author$project$Components$DebtorChanges$TemplatePage$loadData = function (model) {
	return A2($author$project$Forward$Lookup$startFrom, model.query, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorChangeTemplate);
};
var $author$project$Components$DebtorChanges$TemplatePage$formDates = F2(
	function (data, model) {
		var _v0 = _Utils_Tuple2(
			model.draft,
			$author$project$Forward$Remote$toMaybe(data));
		if (_v0.a.$ === 'Just') {
			var draft = _v0.a.a;
			return draft;
		} else {
			if (_v0.b.$ === 'Just') {
				var _v1 = _v0.a;
				var result = _v0.b.a;
				return {endDate: result.endDate, startDate: result.startDate};
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return {endDate: model.query.endDate, startDate: model.query.startDate};
			}
		}
	});
var $author$project$Components$DebtorChanges$TemplatePage$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'GotTimezone':
				var timezone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: timezone}),
					$author$project$HubTran$Effect$none);
			case 'ChangedStartDate':
				var startDate = msg.a;
				var shown = A2($author$project$Components$DebtorChanges$TemplatePage$formDates, data, model);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							draft: $elm$core$Maybe$Just(
								_Utils_update(
									shown,
									{startDate: startDate}))
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangedEndDate':
				var endDate = msg.a;
				var shown = A2($author$project$Components$DebtorChanges$TemplatePage$formDates, data, model);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							draft: $elm$core$Maybe$Just(
								_Utils_update(
									shown,
									{endDate: endDate}))
						}),
					$author$project$HubTran$Effect$none);
			case 'Applied':
				var query = model.query;
				var dates = A2($author$project$Components$DebtorChanges$TemplatePage$formDates, data, model);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							debtor: $author$project$Components$DebtorChanges$TemplatePage$AnyDebtor,
							draft: $elm$core$Maybe$Nothing,
							matchPage: 1,
							query: _Utils_update(
								query,
								{endDate: dates.endDate, startDate: dates.startDate})
						}),
					$author$project$HubTran$Effect$replaceUrl(
						$author$project$Path$toString(
							A2($author$project$Path$debtorChangesTemplate, query.templateId, dates))));
			case 'SelectedOutcome':
				var outcome = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{matchPage: 1, outcome: outcome}),
					$author$project$HubTran$Effect$none);
			case 'SelectedDebtor':
				var debtor = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtor: debtor, matchPage: 1}),
					$author$project$HubTran$Effect$none);
			default:
				var matchPage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{matchPage: matchPage}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$DebtorChanges$TemplatePage$Applied = {$: 'Applied'};
var $author$project$Components$DebtorChanges$TemplatePage$ChangedEndDate = function (a) {
	return {$: 'ChangedEndDate', a: a};
};
var $author$project$Components$DebtorChanges$TemplatePage$ChangedStartDate = function (a) {
	return {$: 'ChangedStartDate', a: a};
};
var $author$project$Components$DebtorChanges$TemplatePage$debtorTotals = F2(
	function (template, matches) {
		var pinIds = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.id;
				},
				$author$project$Domain$FactorBrokerId$toInt),
			template.accountPins);
		var key = function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.id;
						},
						$author$project$Domain$FactorBrokerId$toInt),
					match.finalDebtor));
		};
		var empty = function (match) {
			return {
				correct: 0,
				debtor: match.finalDebtor,
				matched: 0,
				noGuesses: 0,
				pinned: A2(
					$elm$core$List$member,
					key(match),
					pinIds),
				unlabeled: 0,
				wrongGuesses: 0
			};
		};
		var add = F2(
			function (match, totals) {
				var counted = _Utils_update(
					totals,
					{matched: totals.matched + 1});
				var _v0 = match.outcome;
				switch (_v0.$) {
					case 'DebtorChangeOutcomeCorrect':
						return _Utils_update(
							counted,
							{correct: counted.correct + 1});
					case 'DebtorChangeOutcomeWrongGuess':
						return _Utils_update(
							counted,
							{wrongGuesses: counted.wrongGuesses + 1});
					case 'DebtorChangeOutcomeNoGuess':
						return _Utils_update(
							counted,
							{noGuesses: counted.noGuesses + 1});
					default:
						return _Utils_update(
							counted,
							{unlabeled: counted.unlabeled + 1});
				}
			});
		var byDebtor = A3(
			$elm$core$List$foldl,
			F2(
				function (match, acc) {
					return A3(
						$elm$core$Dict$update,
						key(match),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(
								empty(match)),
							A2(
								$elm$core$Basics$composeR,
								add(match),
								$elm$core$Maybe$Just)),
						acc);
				}),
			$elm$core$Dict$empty,
			matches);
		return A2(
			$elm$core$List$sortBy,
			function (totals) {
				return _Utils_Tuple2(
					-totals.matched,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							totals.debtor)));
			},
			$elm$core$Dict$values(byDebtor));
	});
var $author$project$Components$DebtorChanges$TemplatePage$SelectedOutcome = function (a) {
	return {$: 'SelectedOutcome', a: a};
};
var $author$project$Components$DebtorChanges$TemplatePage$UpdatedMatchPage = function (a) {
	return {$: 'UpdatedMatchPage', a: a};
};
var $author$project$Components$DebtorChanges$TemplatePage$NoDebtor = {$: 'NoDebtor'};
var $author$project$Components$DebtorChanges$TemplatePage$OnlyDebtor = function (a) {
	return {$: 'OnlyDebtor', a: a};
};
var $author$project$Components$DebtorChanges$TemplatePage$debtorFilterFor = function (maybeDebtor) {
	if (maybeDebtor.$ === 'Just') {
		var debtor = maybeDebtor.a;
		return $author$project$Components$DebtorChanges$TemplatePage$OnlyDebtor(
			$author$project$Domain$FactorBrokerId$toInt(debtor.id));
	} else {
		return $author$project$Components$DebtorChanges$TemplatePage$NoDebtor;
	}
};
var $author$project$Components$DebtorChanges$TemplatePage$entriesPerPage = 25;
var $author$project$Components$DebtorChanges$TemplatePage$SelectedDebtor = function (a) {
	return {$: 'SelectedDebtor', a: a};
};
var $author$project$Components$DebtorChanges$TemplatePage$viewDebtorFilter = F2(
	function (selected, totals) {
		var value = function (filter) {
			switch (filter.$) {
				case 'AnyDebtor':
					return '';
				case 'NoDebtor':
					return 'none';
				default:
					var id = filter.a;
					return $elm$core$String$fromInt(id);
			}
		};
		var names = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (debtor) {
					return _Utils_Tuple2(
						$author$project$Domain$FactorBrokerId$toInt(debtor.id),
						debtor.name);
				},
				A2(
					$elm$core$List$filterMap,
					function ($) {
						return $.debtor;
					},
					totals)));
		var named = A2(
			$elm$core$List$cons,
			$author$project$Components$DebtorChanges$TemplatePage$AnyDebtor,
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.debtor;
					},
					$author$project$Components$DebtorChanges$TemplatePage$debtorFilterFor),
				totals));
		var options = A2($elm$core$List$member, selected, named) ? named : _Utils_ap(
			named,
			_List_fromArray(
				[selected]));
		var label = function (filter) {
			switch (filter.$) {
				case 'AnyDebtor':
					return 'All debtors';
				case 'NoDebtor':
					return 'No debtor';
				default:
					var id = filter.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'Debtor ' + $elm$core$String$fromInt(id),
						A2($elm$core$Dict$get, id, names));
			}
		};
		return A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{
				onInput: $author$project$Components$DebtorChanges$TemplatePage$SelectedDebtor,
				options: options,
				toLabel: label,
				value: $elm$core$Maybe$Just(selected)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$SimpleSelect$optionValue(value),
					$author$project$Ui$V3$SimpleSelect$sizeSmall,
					$author$project$Ui$V3$SimpleSelect$autoWidth
				]));
	});
var $author$project$Components$DebtorChanges$TemplatePage$viewDocumentLink = function (match) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
				$author$project$Ui$V3$Stack$crossAxisLeft
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[$author$project$Ui$V3$Typography$bodyClass]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Link$view,
						{
							text: '#' + $elm$core$String$fromInt(
								$author$project$Domain$DocumentId$toInt(match.documentId)),
							url: match.templateEditorUrl
						},
						_List_fromArray(
							[$author$project$Ui$V3$Link$targetBlank]))
					])),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Helpers$Html$empty,
				A2($elm$core$Maybe$map, $author$project$Components$DebtorChanges$Common$viewSubtle, match.documentType))
			]));
};
var $author$project$Components$DebtorChanges$TemplatePage$viewMatchInvoice = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$DebtorChanges$Common$viewSubtle('Not on an invoice'),
		A2($elm$core$Maybe$map, $author$project$Components$DebtorChanges$Common$viewInvoiceLink, match.factorInvoiceId));
};
var $author$project$Components$DebtorChanges$TemplatePage$viewMatchProcessedBy = function (match) {
	var _v0 = match.factorInvoiceId;
	if (_v0.$ === 'Just') {
		return $author$project$Components$DebtorChanges$Common$viewProcessedBy(match.processedByUser);
	} else {
		return $author$project$Helpers$Html$empty;
	}
};
var $author$project$Components$DebtorChanges$TemplatePage$viewMatches = F3(
	function (model, totals, matches) {
		var currentPage = A3(
			$author$project$Pagination$fromList,
			model.matchPage,
			$author$project$Components$DebtorChanges$TemplatePage$entriesPerPage,
			A2(
				$elm$core$List$filter,
				function (match) {
					return _Utils_eq(model.debtor, $author$project$Components$DebtorChanges$TemplatePage$AnyDebtor) || _Utils_eq(
						$author$project$Components$DebtorChanges$TemplatePage$debtorFilterFor(match.finalDebtor),
						model.debtor);
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.outcome;
						},
						$author$project$Components$DebtorChanges$Common$matchesOutcome(model.outcome)),
					matches)));
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (match) {
							return A2(
								$author$project$Ui$V3$Typography$body,
								_List_Nil,
								A2($author$project$Helpers$Date$dateString, model.timezone, match.matchedAt));
						},
						heading: $elm$html$Html$text('Matched')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$DebtorChanges$TemplatePage$viewDocumentLink,
						heading: $elm$html$Html$text('Document')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$DebtorChanges$TemplatePage$viewMatchInvoice,
						heading: $elm$html$Html$text('Invoice')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.outcome;
							},
							$author$project$Components$DebtorChanges$Common$viewOutcome),
						heading: $elm$html$Html$text('Change')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.guessedDebtor;
							},
							$author$project$Components$DebtorChanges$Common$viewMaybeDebtor),
						heading: $elm$html$Html$text('We guessed')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.finalDebtor;
							},
							$author$project$Components$DebtorChanges$Common$viewMaybeDebtor),
						heading: $elm$html$Html$text('Final debtor')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$DebtorChanges$TemplatePage$viewMatchProcessedBy,
						heading: $elm$html$Html$text('Processed by')
					}
					])
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$toolbarItems(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Ui$V3$Table$toolbarCustomHtml(
								A2(
									$author$project$Components$DebtorChanges$Common$viewOutcomeFilter,
									{
										allLabel: 'All outcomes',
										onSelect: $author$project$Components$DebtorChanges$TemplatePage$SelectedOutcome,
										outcomes: _List_fromArray(
											[$author$project$AuditPb$DebtorChangeOutcomeCorrect, $author$project$AuditPb$DebtorChangeOutcomeWrongGuess, $author$project$AuditPb$DebtorChangeOutcomeNoGuess, $author$project$AuditPb$DebtorChangeOutcomeUnlabeled])
									},
									model.outcome))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Ui$V3$Table$toolbarCustomHtml(
								A2($author$project$Components$DebtorChanges$TemplatePage$viewDebtorFilter, model.debtor, totals))),
							_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Ui$V3$Table$toolbarEmpty)
						])),
					$author$project$Ui$V3$Table$pagination(
					{currentPage: currentPage, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$DebtorChanges$TemplatePage$UpdatedMatchPage}),
					$author$project$Ui$V3$Table$emptyContent(
					$author$project$Components$DebtorChanges$Common$viewSubtle('No matched documents match.'))
				]),
			_List_Nil,
			$author$project$Pagination$entries(currentPage));
	});
var $author$project$Ui$V3$Typography$bodySemiBoldClass = $elm$html$Html$Attributes$class('v3__type__body-semi-bold');
var $author$project$Ui$V3$Typography$bodySemiBold = $author$project$Ui$V3$Typography$spanHelper($author$project$Ui$V3$Typography$bodySemiBoldClass);
var $author$project$Components$DebtorChanges$TemplatePage$viewMultiplePins = function (pins) {
	return ($elm$core$List$length(pins) >= 2) ? A2(
		$author$project$Ui$V3$DescriptorTag$view,
		_List_fromArray(
			[
				$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$AlertStyle)
			]),
		'Pins ' + ($elm$core$String$fromInt(
			$elm$core$List$length(pins)) + ' debtors on this account, so no match can pass debtor validation')) : $author$project$Helpers$Html$empty;
};
var $author$project$Components$DebtorChanges$TemplatePage$viewTemplate = function (template) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
				$author$project$Ui$V3$Stack$crossAxisLeft
			]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Helpers$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Ui$V3$Typography$body(_List_Nil),
					template.label)),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[$author$project$Ui$V3$Typography$bodyClass]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Link$view,
						{text: 'Edit template', url: template.editorUrl},
						_List_fromArray(
							[$author$project$Ui$V3$Link$targetBlank]))
					])),
				A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Pinned debtors on this account'),
				$author$project$Components$DebtorChanges$Common$viewPins(template.accountPins),
				$author$project$Components$DebtorChanges$TemplatePage$viewMultiplePins(template.accountPins),
				$author$project$Components$DebtorChanges$Common$viewPinWriters(template)
			]));
};
var $author$project$Components$DebtorChanges$TemplatePage$viewShowDocuments = function (row) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick(
				$author$project$Components$DebtorChanges$TemplatePage$SelectedDebtor(
					$author$project$Components$DebtorChanges$TemplatePage$debtorFilterFor(row.debtor)))
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
			]),
		'Show documents');
};
var $author$project$Ui$V3$DescriptorTag$InfoStyle = {$: 'InfoStyle'};
var $author$project$Components$DebtorChanges$TemplatePage$viewTotalsDebtor = function (row) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
				$author$project$Ui$V3$Stack$crossAxisLeft
			]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$DebtorChanges$Common$viewSubtle('No debtor'),
				A2($elm$core$Maybe$map, $author$project$Components$DebtorChanges$Common$viewDebtor, row.debtor)),
				row.pinned ? A2(
				$author$project$Ui$V3$DescriptorTag$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$InfoStyle)
					]),
				'Pinned') : $author$project$Helpers$Html$empty
			]));
};
var $author$project$Components$DebtorChanges$TemplatePage$viewTotals = function (totals) {
	return A4(
		$author$project$Ui$V3$Table$view,
		{
			columns: _List_fromArray(
				[
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned]),
					content: function (row) {
						return $author$project$Components$DebtorChanges$TemplatePage$viewTotalsDebtor(row);
					},
					heading: $elm$html$Html$text('Final debtor')
				},
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned]),
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.matched;
						},
						$author$project$Components$DebtorChanges$Common$viewCount),
					heading: $elm$html$Html$text('Matched')
				},
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned]),
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.correct;
						},
						$author$project$Components$DebtorChanges$Common$viewCount),
					heading: $elm$html$Html$text('Correct')
				},
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned]),
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.wrongGuesses;
						},
						$author$project$Components$DebtorChanges$Common$viewCount),
					heading: $elm$html$Html$text('Wrong guess')
				},
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned]),
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.noGuesses;
						},
						$author$project$Components$DebtorChanges$Common$viewCount),
					heading: $elm$html$Html$text('No guess')
				},
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned]),
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.unlabeled;
						},
						$author$project$Components$DebtorChanges$Common$viewCount),
					heading: $elm$html$Html$text('Not labeled')
				},
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned]),
					content: $author$project$Components$DebtorChanges$TemplatePage$viewShowDocuments,
					heading: $elm$html$Html$text('')
				}
				])
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Table$emptyContent(
				$author$project$Components$DebtorChanges$Common$viewSubtle('The template matched nothing on this account in this range.'))
			]),
		_List_Nil,
		totals);
};
var $author$project$Components$DebtorChanges$TemplatePage$viewResult = F2(
	function (data, model) {
		var _v0 = _Utils_Tuple2(data.error, data.template);
		if (_v0.a.$ === 'Just') {
			var error = _v0.a.a;
			return _List_fromArray(
				[
					$author$project$Components$DebtorChanges$Common$viewRangeError(error)
				]);
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return _List_fromArray(
					[
						$author$project$Components$DebtorChanges$Common$viewSubtle(
						'There is no template #' + ($elm$core$String$fromInt(model.query.templateId) + '.'))
					]);
			} else {
				var _v3 = _v0.a;
				var template = _v0.b.a;
				var totals = A2($author$project$Components$DebtorChanges$TemplatePage$debtorTotals, template, data.matches);
				return _List_fromArray(
					[
						$author$project$Components$DebtorChanges$TemplatePage$viewTemplate(template),
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Who the debtor turned out to be')
							])),
						$author$project$Components$DebtorChanges$TemplatePage$viewTotals(totals),
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Matched documents')
							])),
						A3($author$project$Components$DebtorChanges$TemplatePage$viewMatches, model, totals, data.matches)
					]);
			}
		}
	});
var $author$project$Components$DebtorChanges$TemplatePage$view = F2(
	function (data, model) {
		var covered = {endDate: data.endDate, startDate: data.startDate};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium),
								$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceMedium)
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[$author$project$Ui$V3$Typography$bodyClass]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$V3$Link$view,
										{
											text: 'All templates',
											url: $author$project$Path$toString(
												$author$project$Path$debtorChanges(covered))
										},
										_List_Nil)
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Template #' + $elm$core$String$fromInt(model.query.templateId))
										])),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Components$DebtorChanges$Common$viewRangeForm,
										{onApply: $author$project$Components$DebtorChanges$TemplatePage$Applied, onEndDate: $author$project$Components$DebtorChanges$TemplatePage$ChangedEndDate, onStartDate: $author$project$Components$DebtorChanges$TemplatePage$ChangedStartDate},
										A2(
											$author$project$Components$DebtorChanges$TemplatePage$formDates,
											$author$project$Forward$Remote$Loaded(data),
											model)),
									A2($author$project$Components$DebtorChanges$TemplatePage$viewResult, data, model))))))
				]));
	});
var $author$project$Components$DebtorChanges$TemplatePage$page = $author$project$Forward$Component$forwardComponent(
	{init: $author$project$Components$DebtorChanges$TemplatePage$init, loadData: $author$project$Components$DebtorChanges$TemplatePage$loadData, update: $author$project$Components$DebtorChanges$TemplatePage$update, v3ReskinEnabled: true, viewLoaded: $author$project$Components$DebtorChanges$TemplatePage$view});
var $author$project$Forward$Internal$LookupStructure$Constant = function (a) {
	return {$: 'Constant', a: a};
};
var $author$project$Forward$Lookup$fromRemote_INTERNAL_ONLY = function (constantRemote) {
	return $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: $elm$core$Dict$empty,
			invalidate: F2(
				function (_v0, _v1) {
					return $elm$core$Basics$identity;
				}),
			load: F3(
				function (_v2, _v3, _v4) {
					return $author$project$Forward$Internal$Loadable$fromRemote(constantRemote);
				}),
			preloadBranches: $author$project$Forward$Internal$GraphTree$noBranches,
			structure: $author$project$Forward$Internal$LookupStructure$Constant('fromRemote_INTERNAL_ONLY')
		});
};
var $author$project$Forward$Component$staticComponent = function (config) {
	return {
		dataEffects: F2(
			function (_v0, _v1) {
				return $author$project$HubTran$Effect$none;
			}),
		init: function (_v2) {
			return _Utils_Tuple2(_Utils_Tuple0, $author$project$HubTran$Effect$none);
		},
		loadData: function (_v3) {
			return $author$project$Forward$Lookup$fromRemote_INTERNAL_ONLY(
				$author$project$Forward$Remote$Error(
					$author$project$Forward$Remote$Unloadable('Forward.Component.sandboxComponent: this component does not use loadData, and this message should never be visible anywhere')));
		},
		onUrlChange: $elm$core$Maybe$Nothing,
		update: F3(
			function (_v4, _v5, _v6) {
				return _Utils_Tuple2(_Utils_Tuple0, $author$project$HubTran$Effect$none);
			}),
		view: F2(
			function (_v7, _v8) {
				return config.view;
			})
	};
};
var $author$project$Components$ForwardingHasMovedPage$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('row')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-6'),
					$elm$html$Html$Attributes$class('small-centered'),
					$elm$html$Html$Attributes$class('column'),
					$elm$html$Html$Attributes$class('general-container-style')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Forwarding Has Moved')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Our Forwarding products are now live at '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://bravotran.com')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('bravotran.com')
								])),
							$elm$html$Html$text('!')
						]))
				]))
		]));
var $author$project$Components$ForwardingHasMovedPage$page = $author$project$Forward$Component$staticComponent(
	{view: $author$project$Components$ForwardingHasMovedPage$view});
var $author$project$AuditPb$MyClientsGroupFullyFunded = {$: 'MyClientsGroupFullyFunded'};
var $author$project$AuditPb$MyClientsGroupInFlight = {$: 'MyClientsGroupInFlight'};
var $author$project$AuditPb$MyClientsGroupNeedsAttention = {$: 'MyClientsGroupNeedsAttention'};
var $author$project$AuditPb$allMyClientsGroup = _List_fromArray(
	[$author$project$AuditPb$MyClientsGroupNeedsAttention, $author$project$AuditPb$MyClientsGroupInFlight, $author$project$AuditPb$MyClientsGroupFullyFunded]);
var $author$project$Components$MyClients$OverviewPage$EveryAccountExecutive = {$: 'EveryAccountExecutive'};
var $author$project$Components$MyClients$OverviewPage$NoAccountExecutive = {$: 'NoAccountExecutive'};
var $author$project$Components$MyClients$OverviewPage$OneAccountExecutive = function (a) {
	return {$: 'OneAccountExecutive', a: a};
};
var $author$project$Components$MyClients$OverviewPage$filterFromParam = function (param) {
	var _v0 = A2($elm$core$Maybe$withDefault, '', param);
	switch (_v0) {
		case '':
			return $author$project$Components$MyClients$OverviewPage$EveryAccountExecutive;
		case 'none':
			return $author$project$Components$MyClients$OverviewPage$NoAccountExecutive;
		default:
			var name = _v0;
			return $author$project$Components$MyClients$OverviewPage$OneAccountExecutive(name);
	}
};
var $author$project$Components$MyClients$OverviewPage$Data = F4(
	function (clients, accountExecutives, accountSettings, currentUser) {
		return {accountExecutives: accountExecutives, accountSettings: accountSettings, clients: clients, currentUser: currentUser};
	});
var $author$project$Forward$AppSpecific$Cache$list_myClientsAccountExecutive = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_myClientsAccountExecutive;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_myClientsAccountExecutive: e});
		}));
var $author$project$AuditPb$MyClientsAccountExecutive = function (name) {
	return {name: name};
};
var $author$project$AuditPb$myClientsAccountExecutiveDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'name',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$MyClientsAccountExecutive));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$myClientsAccountExecutives = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_myClientsAccountExecutive,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$myClientsAccountExecutiveDecoder),
		entrypoint: 'myClientsAccountExecutives',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Forward$AppSpecific$Cache$list_myClientsOverviewRow = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_myClientsOverviewRow;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_myClientsOverviewRow: e});
		}));
var $author$project$AuditPb$MyClientsOverviewRow = function (id) {
	return function (name) {
		return function (mcNumber) {
			return function (accountExecutive) {
				return function (counts) {
					return function (total) {
						return function (oldest) {
							return function (group) {
								return function (lines) {
									return function (totalAmount) {
										return function (oldestAt) {
											return {accountExecutive: accountExecutive, counts: counts, group: group, id: id, lines: lines, mcNumber: mcNumber, name: name, oldest: oldest, oldestAt: oldestAt, total: total, totalAmount: totalAmount};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$MyClientsBucketCount = F3(
	function (bucket, count, heat) {
		return {bucket: bucket, count: count, heat: heat};
	});
var $author$project$AuditPb$MyClientsBucketNew = {$: 'MyClientsBucketNew'};
var $author$project$AuditPb$myClientsBucketDefault = $author$project$AuditPb$MyClientsBucketNew;
var $author$project$AuditPb$MyClientsBucketIncomplete = {$: 'MyClientsBucketIncomplete'};
var $author$project$AuditPb$MyClientsBucketProcessed = {$: 'MyClientsBucketProcessed'};
var $author$project$AuditPb$MyClientsBucketPurchased = {$: 'MyClientsBucketPurchased'};
var $author$project$AuditPb$MyClientsBucketReplies = {$: 'MyClientsBucketReplies'};
var $author$project$AuditPb$MyClientsBucketSentToFMS = {$: 'MyClientsBucketSentToFMS'};
var $author$project$AuditPb$MyClientsBucketVerify = {$: 'MyClientsBucketVerify'};
var $author$project$AuditPb$MyClientsBucketWaiting = {$: 'MyClientsBucketWaiting'};
var $author$project$AuditPb$allMyClientsBucket = _List_fromArray(
	[$author$project$AuditPb$MyClientsBucketNew, $author$project$AuditPb$MyClientsBucketIncomplete, $author$project$AuditPb$MyClientsBucketWaiting, $author$project$AuditPb$MyClientsBucketReplies, $author$project$AuditPb$MyClientsBucketVerify, $author$project$AuditPb$MyClientsBucketProcessed, $author$project$AuditPb$MyClientsBucketSentToFMS, $author$project$AuditPb$MyClientsBucketPurchased]);
var $author$project$AuditPb$myClientsBucketToString = function (v) {
	switch (v.$) {
		case 'MyClientsBucketNew':
			return 'new';
		case 'MyClientsBucketIncomplete':
			return 'incomplete';
		case 'MyClientsBucketWaiting':
			return 'waiting';
		case 'MyClientsBucketReplies':
			return 'replies';
		case 'MyClientsBucketVerify':
			return 'verify';
		case 'MyClientsBucketProcessed':
			return 'processed';
		case 'MyClientsBucketSentToFMS':
			return 'sent_to_fms';
		default:
			return 'purchased';
	}
};
var $author$project$AuditPb$myClientsBucketDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$myClientsBucketToString(v),
				v);
		},
		$author$project$AuditPb$allMyClientsBucket));
var $author$project$AuditPb$myClientsBucketFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$myClientsBucketDict);
};
var $author$project$AuditPb$myClientsBucketDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$myClientsBucketDefault),
		$author$project$AuditPb$myClientsBucketFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$MyClientsHeatStopped = {$: 'MyClientsHeatStopped'};
var $author$project$AuditPb$myClientsHeatDefault = $author$project$AuditPb$MyClientsHeatStopped;
var $author$project$AuditPb$MyClientsHeatAuto = {$: 'MyClientsHeatAuto'};
var $author$project$AuditPb$MyClientsHeatDone = {$: 'MyClientsHeatDone'};
var $author$project$AuditPb$MyClientsHeatForYou = {$: 'MyClientsHeatForYou'};
var $author$project$AuditPb$MyClientsHeatWaiting = {$: 'MyClientsHeatWaiting'};
var $author$project$AuditPb$allMyClientsHeat = _List_fromArray(
	[$author$project$AuditPb$MyClientsHeatStopped, $author$project$AuditPb$MyClientsHeatWaiting, $author$project$AuditPb$MyClientsHeatForYou, $author$project$AuditPb$MyClientsHeatAuto, $author$project$AuditPb$MyClientsHeatDone]);
var $author$project$AuditPb$myClientsHeatToString = function (v) {
	switch (v.$) {
		case 'MyClientsHeatStopped':
			return 'stopped';
		case 'MyClientsHeatWaiting':
			return 'waiting';
		case 'MyClientsHeatForYou':
			return 'for_you';
		case 'MyClientsHeatAuto':
			return 'auto';
		default:
			return 'done';
	}
};
var $author$project$AuditPb$myClientsHeatDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$myClientsHeatToString(v),
				v);
		},
		$author$project$AuditPb$allMyClientsHeat));
var $author$project$AuditPb$myClientsHeatFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$myClientsHeatDict);
};
var $author$project$AuditPb$myClientsHeatDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$myClientsHeatDefault),
		$author$project$AuditPb$myClientsHeatFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$myClientsBucketCountDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'heat',
			$author$project$AuditPb$myClientsHeatDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'count',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'bucket',
					$author$project$AuditPb$myClientsBucketDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$MyClientsBucketCount))));
	});
var $author$project$AuditPb$myClientsGroupDefault = $author$project$AuditPb$MyClientsGroupNeedsAttention;
var $author$project$AuditPb$myClientsGroupToString = function (v) {
	switch (v.$) {
		case 'MyClientsGroupNeedsAttention':
			return 'needs_attention';
		case 'MyClientsGroupInFlight':
			return 'in_flight';
		default:
			return 'fully_funded';
	}
};
var $author$project$AuditPb$myClientsGroupDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$myClientsGroupToString(v),
				v);
		},
		$author$project$AuditPb$allMyClientsGroup));
var $author$project$AuditPb$myClientsGroupFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$myClientsGroupDict);
};
var $author$project$AuditPb$myClientsGroupDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$myClientsGroupDefault),
		$author$project$AuditPb$myClientsGroupFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$MyClientsInvoice = function (factorInvoiceId) {
	return function (emailMessageId) {
		return function (invoiceNumber) {
			return function (loadId) {
				return function (debtor) {
					return function (bucket) {
						return function (heat) {
							return function (reason) {
								return function (amount) {
									return function (age) {
										return function (amountValue) {
											return function (ageAt) {
												return function (verificationBatchId) {
													return {age: age, ageAt: ageAt, amount: amount, amountValue: amountValue, bucket: bucket, debtor: debtor, emailMessageId: emailMessageId, factorInvoiceId: factorInvoiceId, heat: heat, invoiceNumber: invoiceNumber, loadId: loadId, reason: reason, verificationBatchId: verificationBatchId};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Domain$VerificationsDebtorBatchId$VerificationsDebtorBatchId = function (a) {
	return {$: 'VerificationsDebtorBatchId', a: a};
};
var $author$project$Domain$VerificationsDebtorBatchId$fromInt = function (_int) {
	return $author$project$Domain$VerificationsDebtorBatchId$VerificationsDebtorBatchId(_int);
};
var $author$project$AuditPb$myClientsInvoiceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'verification_batch_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationsDebtorBatchId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'age_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$optional,
					'amount_value',
					$author$project$AuditPb$floatValueDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'age',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'amount',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'reason',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'heat',
									$author$project$AuditPb$myClientsHeatDecoder,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'bucket',
										$author$project$AuditPb$myClientsBucketDecoder,
										A3(
											$author$project$AuditPb$optional,
											'debtor',
											$elm$json$Json$Decode$string,
											A3(
												$author$project$AuditPb$optional,
												'load_id',
												$elm$json$Json$Decode$string,
												A3(
													$author$project$AuditPb$optional,
													'invoice_number',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$AuditPb$optional,
														'email_message_id',
														A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
														A3(
															$author$project$AuditPb$optional,
															'factor_invoice_id',
															A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
															$author$project$AuditPb$decode($author$project$AuditPb$MyClientsInvoice))))))))))))));
	});
var $author$project$AuditPb$myClientsOverviewRowDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'oldest_at',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$optional,
				'total_amount',
				$author$project$AuditPb$floatValueDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'lines',
					$author$project$AuditPb$myClientsInvoiceDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'group',
						$author$project$AuditPb$myClientsGroupDecoder,
						A3(
							$author$project$AuditPb$optional,
							'oldest',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'total',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$repeated,
									'counts',
									$author$project$AuditPb$myClientsBucketCountDecoder,
									A3(
										$author$project$AuditPb$optional,
										'account_executive',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$optional,
											'mc_number',
											$elm$json$Json$Decode$string,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'name',
												$elm$json$Json$Decode$string,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'id',
													A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
													$author$project$AuditPb$decode($author$project$AuditPb$MyClientsOverviewRow))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$myClientsOverviewRows = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_myClientsOverviewRow,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$myClientsOverviewRowDecoder),
		entrypoint: 'myClientsOverviewRows',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Components$MyClients$OverviewPage$loadData = function (_v0) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$myClientsAccountExecutives,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$myClientsOverviewRows,
					$author$project$Forward$Lookup$succeed($author$project$Components$MyClients$OverviewPage$Data)))));
};
var $author$project$Components$MyClients$OverviewPage$startsCollapsed = function (group) {
	switch (group.$) {
		case 'MyClientsGroupNeedsAttention':
			return false;
		case 'MyClientsGroupInFlight':
			return false;
		default:
			return true;
	}
};
var $author$project$Components$MyClients$OverviewPage$lineStartsDescending = function (column) {
	switch (column.$) {
		case 'ByAmount':
			return true;
		case 'ByAge':
			return true;
		case 'ByInvoice':
			return false;
		case 'ByLoad':
			return false;
		case 'ByDebtor':
			return false;
		case 'ByColumn':
			return false;
		default:
			return false;
	}
};
var $author$project$Components$MyClients$OverviewPage$nextLineSort = F2(
	function (column, current) {
		if (current.$ === 'Just') {
			var sort = current.a;
			return _Utils_eq(sort.column, column) ? _Utils_update(
				sort,
				{descending: !sort.descending}) : {
				column: column,
				descending: $author$project$Components$MyClients$OverviewPage$lineStartsDescending(column)
			};
		} else {
			return {
				column: column,
				descending: $author$project$Components$MyClients$OverviewPage$lineStartsDescending(column)
			};
		}
	});
var $author$project$Components$MyClients$OverviewPage$startsDescending = function (column) {
	switch (column.$) {
		case 'ByClient':
			return false;
		case 'ByBucket':
			return true;
		case 'ByTotal':
			return true;
		default:
			return true;
	}
};
var $author$project$Components$MyClients$OverviewPage$nextSort = F2(
	function (column, current) {
		if (current.$ === 'Just') {
			var sort = current.a;
			return _Utils_eq(sort.column, column) ? _Utils_update(
				sort,
				{descending: !sort.descending}) : {
				column: column,
				descending: $author$project$Components$MyClients$OverviewPage$startsDescending(column)
			};
		} else {
			return {
				column: column,
				descending: $author$project$Components$MyClients$OverviewPage$startsDescending(column)
			};
		}
	});
var $author$project$Components$MyClients$OverviewPage$toggle = F2(
	function (id, expanded) {
		return A2($elm$core$Set$member, id, expanded) ? A2($elm$core$Set$remove, id, expanded) : A2($elm$core$Set$insert, id, expanded);
	});
var $author$project$Components$MyClients$OverviewPage$toggleGroup = F2(
	function (group, collapsed) {
		return A2($elm$core$List$member, group, collapsed) ? A2(
			$elm$core$List$filter,
			function (collapsedGroup) {
				return !_Utils_eq(collapsedGroup, group);
			},
			collapsed) : A2($elm$core$List$cons, group, collapsed);
	});
var $author$project$Components$MyClients$OverviewPage$urlFor = function (filter) {
	return A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			['app', 'my_clients_demo']),
		function () {
			switch (filter.$) {
				case 'EveryAccountExecutive':
					return _List_Nil;
				case 'OneAccountExecutive':
					var name = filter.a;
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'account_executive', name)
						]);
				default:
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'account_executive', 'none')
						]);
			}
		}());
};
var $author$project$Components$MyClients$OverviewPage$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'FilterChanged':
				var filter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filter: filter}),
					$author$project$HubTran$Effect$replaceUrl(
						$author$project$Components$MyClients$OverviewPage$urlFor(filter)));
			case 'SearchChanged':
				var search = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{search: search}),
					$author$project$HubTran$Effect$none);
			case 'ExpansionToggled':
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							expandedClients: A2(
								$author$project$Components$MyClients$OverviewPage$toggle,
								$author$project$Domain$TmsCarrierId$toInt(id),
								model.expandedClients)
						}),
					$author$project$HubTran$Effect$none);
			case 'GroupCollapseToggled':
				var group = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							collapsedGroups: A2($author$project$Components$MyClients$OverviewPage$toggleGroup, group, model.collapsedGroups)
						}),
					$author$project$HubTran$Effect$none);
			case 'SortToggled':
				var column = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sort: $elm$core$Maybe$Just(
								A2($author$project$Components$MyClients$OverviewPage$nextSort, column, model.sort))
						}),
					$author$project$HubTran$Effect$none);
			default:
				var column = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							lineSort: $elm$core$Maybe$Just(
								A2($author$project$Components$MyClients$OverviewPage$nextLineSort, column, model.lineSort))
						}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Domain$User$usesFactorInvoiceWorkflowPage = F2(
	function (accountSettings, user) {
		return accountSettings.useFactorInvoiceWorkflowPage && user.useFactorInvoiceWorkflowPage;
	});
var $author$project$Components$MyClients$OverviewPage$contextFor = F2(
	function (data, model) {
		return {
			collapsedGroups: model.collapsedGroups,
			expandedClients: model.expandedClients,
			lineSort: model.lineSort,
			pathContext: {
				isReadonly: data.currentUser.readOnlyFactorInvoices,
				useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, data.accountSettings, data.currentUser)
			},
			sort: model.sort
		};
	});
var $author$project$Components$MyClients$OverviewPage$noOpenWorkMessage = function (filter) {
	switch (filter.$) {
		case 'EveryAccountExecutive':
			return 'No clients with open invoices.';
		case 'OneAccountExecutive':
			var name = filter.a;
			return 'No open invoices for ' + (name + '.');
		default:
			return 'No open invoices for clients with no account executive.';
	}
};
var $author$project$Components$MyClients$OverviewPage$withinFilter = function (filter) {
	switch (filter.$) {
		case 'EveryAccountExecutive':
			return '';
		case 'OneAccountExecutive':
			var name = filter.a;
			return ' for ' + name;
		default:
			return ' among clients with no account executive';
	}
};
var $author$project$Components$MyClients$OverviewPage$emptyMessage = F2(
	function (filter, search) {
		var _v0 = $elm$core$String$trim(search);
		if (_v0 === '') {
			return $author$project$Components$MyClients$OverviewPage$noOpenWorkMessage(filter);
		} else {
			var term = _v0;
			return 'No clients match \u0022' + (term + ('\u0022' + ($author$project$Components$MyClients$OverviewPage$withinFilter(filter) + '.')));
		}
	});
var $author$project$Components$MyClients$OverviewPage$matchesFilter = F2(
	function (filter, row) {
		switch (filter.$) {
			case 'EveryAccountExecutive':
				return true;
			case 'OneAccountExecutive':
				var name = filter.a;
				return _Utils_eq(
					row.accountExecutive,
					$elm$core$Maybe$Just(name));
			default:
				return _Utils_eq(row.accountExecutive, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$MyClients$OverviewPage$searchTerm = function (search) {
	return $elm$core$String$toLower(
		$elm$core$String$trim(search));
};
var $author$project$Components$MyClients$OverviewPage$matchesSearch = F2(
	function (search, row) {
		var _v0 = $author$project$Components$MyClients$OverviewPage$searchTerm(search);
		if (_v0 === '') {
			return true;
		} else {
			var term = _v0;
			return A2(
				$elm$core$String$contains,
				term,
				$elm$core$String$toLower(row.client)) || A2(
				$elm$core$String$contains,
				term,
				$elm$core$String$toLower(row.mcNumber));
		}
	});
var $author$project$Components$MyClients$OverviewPage$matches = F3(
	function (filter, search, row) {
		return A2($author$project$Components$MyClients$OverviewPage$matchesFilter, filter, row) && A2($author$project$Components$MyClients$OverviewPage$matchesSearch, search, row);
	});
var $author$project$Components$MyClients$OverviewPage$rowFor = function (client) {
	return {
		accountExecutive: client.accountExecutive,
		client: client.name,
		counts: client.counts,
		group: client.group,
		id: client.id,
		lines: client.lines,
		mcNumber: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (number) {
					return 'MC ' + number;
				},
				client.mcNumber)),
		oldest: A2($elm$core$Maybe$withDefault, '', client.oldest),
		oldestAt: client.oldestAt,
		total: A2($elm$core$Maybe$withDefault, '', client.total),
		totalAmount: client.totalAmount
	};
};
var $author$project$Ui$V3$Stack$spaceSmall = $author$project$Ui$V3$Stack$SpatialUnit('s');
var $author$project$Components$MyClients$OverviewPage$FilterChanged = function (a) {
	return {$: 'FilterChanged', a: a};
};
var $author$project$Components$MyClients$OverviewPage$filterLabel = function (filter) {
	switch (filter.$) {
		case 'EveryAccountExecutive':
			return 'All account executives';
		case 'OneAccountExecutive':
			var name = filter.a;
			return name;
		default:
			return 'No account executive';
	}
};
var $author$project$Components$MyClients$OverviewPage$filterOptions = F2(
	function (data, rows) {
		var names = A2(
			$elm$core$List$sortBy,
			$elm$core$String$toLower,
			$elm$core$Set$toList(
				$elm$core$Set$fromList(
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							data.accountExecutives),
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.accountExecutive;
							},
							rows)))));
		return _Utils_ap(
			A2(
				$elm$core$List$cons,
				$author$project$Components$MyClients$OverviewPage$EveryAccountExecutive,
				A2($elm$core$List$map, $author$project$Components$MyClients$OverviewPage$OneAccountExecutive, names)),
			A2(
				$elm$core$List$any,
				function (row) {
					return _Utils_eq(row.accountExecutive, $elm$core$Maybe$Nothing);
				},
				rows) ? _List_fromArray(
				[$author$project$Components$MyClients$OverviewPage$NoAccountExecutive]) : _List_Nil);
	});
var $author$project$Components$MyClients$OverviewPage$filterValue = function (filter) {
	switch (filter.$) {
		case 'EveryAccountExecutive':
			return 'every';
		case 'OneAccountExecutive':
			var name = filter.a;
			return 'accountExecutive:' + name;
		default:
			return 'none';
	}
};
var $author$project$Components$MyClients$OverviewPage$viewSubtle = function (text) {
	return A2(
		$author$project$Ui$V3$Typography$smallBody,
		_List_fromArray(
			[
				$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
			]),
		text);
};
var $author$project$Components$MyClients$OverviewPage$viewAeFilter = F3(
	function (data, rows, filter) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					$author$project$Components$MyClients$OverviewPage$viewSubtle('Account executive'),
					A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: $author$project$Components$MyClients$OverviewPage$FilterChanged,
						options: A2($author$project$Components$MyClients$OverviewPage$filterOptions, data, rows),
						toLabel: $author$project$Components$MyClients$OverviewPage$filterLabel,
						value: $elm$core$Maybe$Just(filter)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$SimpleSelect$autoWidth,
							$author$project$Ui$V3$SimpleSelect$optionValue($author$project$Components$MyClients$OverviewPage$filterValue)
						]))
				]));
	});
var $author$project$Components$MyClients$OverviewPage$SearchChanged = function (a) {
	return {$: 'SearchChanged', a: a};
};
var $author$project$Ui$V3$SearchInput$PlaceholderAttribute = function (a) {
	return {$: 'PlaceholderAttribute', a: a};
};
var $author$project$Ui$V3$SearchInput$placeholder = $author$project$Ui$V3$SearchInput$PlaceholderAttribute;
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Ui$V3$Icon$close16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth('1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M1,15 L15,1 M15,15 L1,1'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Input$LeadingIconAttribute = F2(
	function (a, b) {
		return {$: 'LeadingIconAttribute', a: a, b: b};
	});
var $author$project$Ui$V3$Input$leadingIcon = $author$project$Ui$V3$Input$LeadingIconAttribute;
var $author$project$Ui$V3$Input$ParentClassAttribute = function (a) {
	return {$: 'ParentClassAttribute', a: a};
};
var $author$project$Ui$V3$Input$parentClass = function (value) {
	return $author$project$Ui$V3$Input$ParentClassAttribute(value);
};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Ui$V3$Icon$search16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth('1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('6.5'),
						$elm$svg$Svg$Attributes$cy('6.5'),
						$elm$svg$Svg$Attributes$r('5.5'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$line,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$x1('11'),
						$elm$svg$Svg$Attributes$x2('15'),
						$elm$svg$Svg$Attributes$y1('11'),
						$elm$svg$Svg$Attributes$y2('15')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Input$DisabledAttribute = function (a) {
	return {$: 'DisabledAttribute', a: a};
};
var $author$project$Ui$V3$Input$PlaceholderAttribute = function (a) {
	return {$: 'PlaceholderAttribute', a: a};
};
var $author$project$Ui$V3$SearchInput$toInputAttr = function (attr) {
	if (attr.$ === 'DisabledAttribute') {
		var isDisabled = attr.a;
		return $author$project$Ui$V3$Input$DisabledAttribute(isDisabled);
	} else {
		var str = attr.a;
		return $author$project$Ui$V3$Input$PlaceholderAttribute(str);
	}
};
var $author$project$Ui$V3$Input$TrailingIconButton = F4(
	function (a, b, c, d) {
		return {$: 'TrailingIconButton', a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$V3$Input$trailingIconButtonCustom = $author$project$Ui$V3$Input$TrailingIconButton;
var $author$project$Ui$V3$SearchInput$view = F4(
	function (_v0, attributes, htmlInputAttributes, value) {
		var onClear = _v0.onClear;
		var onInput = _v0.onInput;
		var inputAttrs = A2($elm$core$List$map, $author$project$Ui$V3$SearchInput$toInputAttr, attributes);
		return A4(
			$author$project$Ui$V3$Input$view,
			{onInput: onInput},
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$parentClass('v3__input--dark-icons'),
						$author$project$Ui$V3$Input$parentClass('v3__input--rounded'),
						A2(
						$author$project$Ui$V3$Input$leadingIcon,
						_List_fromArray(
							[
								$author$project$Ui$V3$Icon$label('Search')
							]),
						$author$project$Ui$V3$Icon$search16),
						A4(
						$author$project$Ui$V3$Input$trailingIconButtonCustom,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'scale', '0.75')
							]),
						_List_fromArray(
							[
								$author$project$Ui$V3$Icon$label('Clear')
							]),
						$author$project$Ui$V3$Icon$close16,
						onClear)
					]),
				inputAttrs),
			htmlInputAttributes,
			value);
	});
var $author$project$Components$MyClients$OverviewPage$viewClientFilter = function (search) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
			]),
		_List_fromArray(
			[
				$author$project$Components$MyClients$OverviewPage$viewSubtle('Client'),
				A4(
				$author$project$Ui$V3$SearchInput$view,
				{
					onClear: $author$project$Components$MyClients$OverviewPage$SearchChanged(''),
					onInput: $author$project$Components$MyClients$OverviewPage$SearchChanged
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$SearchInput$placeholder('Name or MC number')
					]),
				_List_Nil,
				search)
			]));
};
var $author$project$Components$MyClients$OverviewPage$viewFilters = F3(
	function (data, rows, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A3($author$project$Components$MyClients$OverviewPage$viewAeFilter, data, rows, model.filter)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fitPx(280),
					$author$project$Components$MyClients$OverviewPage$viewClientFilter(model.search))
				]));
	});
var $author$project$Components$MyClients$OverviewPage$isGroupCollapsed = F2(
	function (context, group) {
		return A2($elm$core$List$member, group, context.collapsedGroups);
	});
var $author$project$Components$MyClients$OverviewPage$countFor = F2(
	function (bucket, row) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (count) {
					return _Utils_eq(count.bucket, bucket);
				},
				row.counts));
	});
var $author$project$Components$MyClients$OverviewPage$bucketCount = F2(
	function (bucket, row) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.count;
				},
				A2($author$project$Components$MyClients$OverviewPage$countFor, bucket, row)));
	});
var $author$project$Components$MyClients$OverviewPage$oldestMillis = function (row) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, row.oldestAt));
};
var $author$project$Components$MyClients$OverviewPage$compareOnColumn = F3(
	function (column, a, b) {
		switch (column.$) {
			case 'ByClient':
				return A2(
					$elm$core$Basics$compare,
					$elm$core$String$toLower(a.client),
					$elm$core$String$toLower(b.client));
			case 'ByBucket':
				var bucket = column.a;
				return A2(
					$elm$core$Basics$compare,
					A2($author$project$Components$MyClients$OverviewPage$bucketCount, bucket, a),
					A2($author$project$Components$MyClients$OverviewPage$bucketCount, bucket, b));
			case 'ByTotal':
				return A2(
					$elm$core$Basics$compare,
					A2($elm$core$Maybe$withDefault, 0, a.totalAmount),
					A2($elm$core$Maybe$withDefault, 0, b.totalAmount));
			default:
				return A2(
					$elm$core$Basics$compare,
					-$author$project$Components$MyClients$OverviewPage$oldestMillis(a),
					-$author$project$Components$MyClients$OverviewPage$oldestMillis(b));
		}
	});
var $author$project$Components$MyClients$OverviewPage$invertOrder = function (order) {
	switch (order.$) {
		case 'LT':
			return $elm$core$Basics$GT;
		case 'GT':
			return $elm$core$Basics$LT;
		default:
			return $elm$core$Basics$EQ;
	}
};
var $author$project$Components$MyClients$OverviewPage$compareRows = F3(
	function (sort, a, b) {
		var primary = A3($author$project$Components$MyClients$OverviewPage$compareOnColumn, sort.column, a, b);
		var directed = sort.descending ? $author$project$Components$MyClients$OverviewPage$invertOrder(primary) : primary;
		if (directed.$ === 'EQ') {
			return A2(
				$elm$core$Basics$compare,
				$elm$core$String$toLower(a.client),
				$elm$core$String$toLower(b.client));
		} else {
			var other = directed;
			return other;
		}
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Components$MyClients$OverviewPage$stoppedCount = function (row) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.count;
			},
			A2(
				$elm$core$List$filter,
				function (count) {
					return _Utils_eq(count.heat, $author$project$AuditPb$MyClientsHeatStopped);
				},
				row.counts)));
};
var $author$project$Components$MyClients$OverviewPage$sortRows = F2(
	function (sort, rows) {
		if (sort.$ === 'Nothing') {
			return A2(
				$elm$core$List$sortBy,
				function (row) {
					return -$author$project$Components$MyClients$OverviewPage$stoppedCount(row);
				},
				rows);
		} else {
			var active = sort.a;
			return A2(
				$elm$core$List$sortWith,
				$author$project$Components$MyClients$OverviewPage$compareRows(active),
				rows);
		}
	});
var $author$project$Components$MyClients$OverviewPage$rowsInGroup = F3(
	function (sort, rows, group) {
		return A2(
			$author$project$Components$MyClients$OverviewPage$sortRows,
			sort,
			A2(
				$elm$core$List$filter,
				function (row) {
					return _Utils_eq(row.group, group);
				},
				rows));
	});
var $author$project$Components$MyClients$OverviewPage$GroupCollapseToggled = function (a) {
	return {$: 'GroupCollapseToggled', a: a};
};
var $author$project$Ui$V3$Icon$chevronDown16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M7.97945 11.4673C7.63023 11.4673 7.3309 11.3176 7.13135 11.0682L2.19243 5.53062C1.8931 5.13152 1.94299 4.53286 2.34209 4.23353C2.74119 3.9342 3.28996 3.9342 3.58929 4.33331L7.87967 9.22234C7.92956 9.27223 7.97945 9.27223 8.07922 9.22234L12.3696 4.33331C12.7188 3.9342 13.2676 3.88432 13.6667 4.23353C14.0658 4.58275 14.1157 5.13152 13.7665 5.53062C13.7665 5.53062 13.7665 5.53062 13.7166 5.58051L8.82754 11.1181C8.62799 11.3176 8.27877 11.4673 7.97945 11.4673Z'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_Nil));
var $author$project$Ui$V3$Icon$chevronRight16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M11.4945 7.98151C11.4945 8.33061 11.3448 8.62984 11.0955 8.82932L5.50994 13.7665C5.11097 14.1156 4.51252 14.0658 4.21329 13.6668C3.91407 13.2678 3.91407 12.7193 4.31303 12.3702L9.20039 8.08125C9.25026 8.03138 9.25026 7.98151 9.20039 7.88177L4.31303 3.59287C3.91407 3.24377 3.91407 2.64532 4.26316 2.29622C4.61226 1.94712 5.16084 1.89725 5.55981 2.19648L11.1454 7.08383C11.3448 7.33319 11.4945 7.63242 11.4945 7.98151Z'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_Nil));
var $author$project$Components$MyClients$OverviewPage$chevronFor = function (isCollapsed) {
	return isCollapsed ? $author$project$Ui$V3$Icon$chevronRight16 : $author$project$Ui$V3$Icon$chevronDown16;
};
var $author$project$Components$MyClients$OverviewPage$groupLabel = function (group) {
	switch (group.$) {
		case 'MyClientsGroupNeedsAttention':
			return 'Needs attention';
		case 'MyClientsGroupInFlight':
			return 'In flight';
		default:
			return 'Fully funded';
	}
};
var $author$project$Components$MyClients$OverviewPage$groupHeading = F2(
	function (group, rows) {
		return $author$project$Components$MyClients$OverviewPage$groupLabel(group) + (' (' + ($elm$core$String$fromInt(
			$elm$core$List$length(rows)) + ')'));
	});
var $author$project$Components$MyClients$OverviewPage$viewGroupHeading = F3(
	function (group, rows, isCollapsed) {
		return A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'gap', '4px'),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
							$elm$html$Html$Events$onClick(
							$author$project$Components$MyClients$OverviewPage$GroupCollapseToggled(group))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Icon$view16,
							_List_Nil,
							$author$project$Components$MyClients$OverviewPage$chevronFor(isCollapsed)),
							$elm$html$Html$text(
							A2($author$project$Components$MyClients$OverviewPage$groupHeading, group, rows))
						]))
				]));
	});
var $author$project$Components$MyClients$OverviewPage$ByClient = {$: 'ByClient'};
var $author$project$Components$MyClients$OverviewPage$ByOldest = {$: 'ByOldest'};
var $author$project$Components$MyClients$OverviewPage$ByTotal = {$: 'ByTotal'};
var $author$project$Components$MyClients$OverviewPage$ExpansionToggled = function (a) {
	return {$: 'ExpansionToggled', a: a};
};
var $author$project$Components$MyClients$OverviewPage$ByBucket = function (a) {
	return {$: 'ByBucket', a: a};
};
var $author$project$Ui$V3$Table$CellAttributes = function (a) {
	return {$: 'CellAttributes', a: a};
};
var $author$project$Ui$V3$Table$cellAttributes = $author$project$Ui$V3$Table$CellAttributes;
var $author$project$Components$MyClients$OverviewPage$columnLabel = function (bucket) {
	switch (bucket.$) {
		case 'MyClientsBucketNew':
			return 'New';
		case 'MyClientsBucketIncomplete':
			return 'Incomplete';
		case 'MyClientsBucketWaiting':
			return 'Waiting';
		case 'MyClientsBucketReplies':
			return 'Replies';
		case 'MyClientsBucketVerify':
			return 'Verify';
		case 'MyClientsBucketProcessed':
			return 'Processed';
		case 'MyClientsBucketSentToFMS':
			return 'Sent to FMS';
		default:
			return 'Purchased';
	}
};
var $author$project$Components$MyClients$OverviewPage$SortToggled = function (a) {
	return {$: 'SortToggled', a: a};
};
var $author$project$Components$MyClients$OverviewPage$ascendingWords = function (column) {
	switch (column.$) {
		case 'ByClient':
			return 'A to Z';
		case 'ByOldest':
			return 'newest first';
		case 'ByBucket':
			return 'low to high';
		default:
			return 'low to high';
	}
};
var $author$project$Components$MyClients$OverviewPage$descendingWords = function (column) {
	switch (column.$) {
		case 'ByClient':
			return 'Z to A';
		case 'ByOldest':
			return 'oldest first';
		case 'ByBucket':
			return 'high to low';
		default:
			return 'high to low';
	}
};
var $author$project$Ui$V3$Icon$sortArrowDefault16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#C8D8EB'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27349 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#C8D8EB'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$sortArrowDown16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#C8D8EB'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27348 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#001929'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$sortArrowUp16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#001929'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27348 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#C8D8EB'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Components$MyClients$OverviewPage$sortableHeading = F3(
	function (context, column, label) {
		var active = function () {
			var _v2 = context.sort;
			if (_v2.$ === 'Just') {
				var sort = _v2.a;
				return _Utils_eq(sort.column, column) ? $elm$core$Maybe$Just(sort.descending) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = function () {
			if (active.$ === 'Just') {
				if (active.a) {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Icon$sortArrowDown16,
						label + (', sorted ' + $author$project$Components$MyClients$OverviewPage$descendingWords(column)));
				} else {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Icon$sortArrowUp16,
						label + (', sorted ' + $author$project$Components$MyClients$OverviewPage$ascendingWords(column)));
				}
			} else {
				return _Utils_Tuple2($author$project$Ui$V3$Icon$sortArrowDefault16, 'Sort by ' + label);
			}
		}();
		var icon = _v0.a;
		var description = _v0.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('my-clients__sort'),
					$elm$html$Html$Attributes$type_('button'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', description),
					$elm$html$Html$Events$onClick(
					$author$project$Components$MyClients$OverviewPage$SortToggled(column))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$author$project$Ui$V3$Icon$view16,
					_List_fromArray(
						[
							$author$project$Ui$V3$Icon$label(description)
						]),
					icon)
				]));
	});
var $author$project$Ui$V3$Colors$BackgroundFeedbackErrorSubtle = {$: 'BackgroundFeedbackErrorSubtle'};
var $author$project$Ui$V3$Colors$BackgroundFeedbackInfoSubtle = {$: 'BackgroundFeedbackInfoSubtle'};
var $author$project$Ui$V3$Colors$BackgroundFeedbackNeutralSubtle = {$: 'BackgroundFeedbackNeutralSubtle'};
var $author$project$Ui$V3$Colors$BackgroundFeedbackSuccessSubtle = {$: 'BackgroundFeedbackSuccessSubtle'};
var $author$project$Ui$V3$Colors$BackgroundFeedbackWarningSubtle = {$: 'BackgroundFeedbackWarningSubtle'};
var $author$project$Ui$V3$Colors$TextFeedbackError = {$: 'TextFeedbackError'};
var $author$project$Ui$V3$Colors$TextFeedbackInfo = {$: 'TextFeedbackInfo'};
var $author$project$Ui$V3$Colors$TextFeedbackSuccess = {$: 'TextFeedbackSuccess'};
var $author$project$Ui$V3$Colors$TextFeedbackWarning = {$: 'TextFeedbackWarning'};
var $author$project$Ui$V3$Colors$TextNeutralDefault = {$: 'TextNeutralDefault'};
var $author$project$Components$MyClients$OverviewPage$tintFor = function (heat) {
	switch (heat.$) {
		case 'MyClientsHeatStopped':
			return {
				background: $author$project$Ui$V3$Colors$BackgroundFeedbackErrorSubtle,
				text: $author$project$Ui$V3$Colors$TextFeedbackError,
				word: $elm$core$Maybe$Just('stopped')
			};
		case 'MyClientsHeatWaiting':
			return {
				background: $author$project$Ui$V3$Colors$BackgroundFeedbackWarningSubtle,
				text: $author$project$Ui$V3$Colors$TextFeedbackWarning,
				word: $elm$core$Maybe$Just('waiting')
			};
		case 'MyClientsHeatForYou':
			return {
				background: $author$project$Ui$V3$Colors$BackgroundFeedbackInfoSubtle,
				text: $author$project$Ui$V3$Colors$TextFeedbackInfo,
				word: $elm$core$Maybe$Just('you')
			};
		case 'MyClientsHeatDone':
			return {background: $author$project$Ui$V3$Colors$BackgroundFeedbackSuccessSubtle, text: $author$project$Ui$V3$Colors$TextFeedbackSuccess, word: $elm$core$Maybe$Nothing};
		default:
			return {background: $author$project$Ui$V3$Colors$BackgroundFeedbackNeutralSubtle, text: $author$project$Ui$V3$Colors$TextNeutralDefault, word: $elm$core$Maybe$Nothing};
	}
};
var $author$project$Components$MyClients$OverviewPage$viewChipWord = F2(
	function (tint, word) {
		return A2(
			$author$project$Ui$V3$Typography$xSmallBodySemiBold,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute(tint.text),
					A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase'),
					A2($elm$html$Html$Attributes$style, 'letter-spacing', '0.03em')
				]),
			word);
	});
var $author$project$Components$MyClients$OverviewPage$viewChip = F2(
	function (tint, label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$backgroundColorAttribute(tint.background),
					A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
					A2($elm$html$Html$Attributes$style, 'padding', '3px 8px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					A2($elm$html$Html$Attributes$style, 'text-align', 'center')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					A2(
						$elm$core$List$cons,
						label,
						function () {
							var _v0 = tint.word;
							if (_v0.$ === 'Just') {
								var word = _v0.a;
								return _List_fromArray(
									[
										A2($author$project$Components$MyClients$OverviewPage$viewChipWord, tint, word)
									]);
							} else {
								return _List_Nil;
							}
						}()))
				]));
	});
var $author$project$Components$MyClients$OverviewPage$viewCountChip = F2(
	function (count, tint) {
		return A2(
			$author$project$Components$MyClients$OverviewPage$viewChip,
			tint,
			A2(
				$author$project$Ui$V3$Typography$bodySemiBold,
				_List_fromArray(
					[
						$author$project$Ui$V3$Colors$colorAttribute(tint.text)
					]),
				$elm$core$String$fromInt(count)));
	});
var $author$project$Ui$V3$Colors$TextNeutralDisabledDefault = {$: 'TextNeutralDisabledDefault'};
var $author$project$Components$MyClients$OverviewPage$viewEmptyCount = A2(
	$author$project$Ui$V3$Typography$bodySemiBold,
	_List_fromArray(
		[
			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralDisabledDefault)
		]),
	'0');
var $author$project$Components$MyClients$OverviewPage$viewCount = F2(
	function (bucket, row) {
		var _v0 = A2($author$project$Components$MyClients$OverviewPage$countFor, bucket, row);
		if (_v0.$ === 'Nothing') {
			return $author$project$Components$MyClients$OverviewPage$viewEmptyCount;
		} else {
			var count = _v0.a;
			return (!count.count) ? $author$project$Components$MyClients$OverviewPage$viewEmptyCount : A2(
				$author$project$Components$MyClients$OverviewPage$viewCountChip,
				count.count,
				$author$project$Components$MyClients$OverviewPage$tintFor(count.heat));
		}
	});
var $author$project$Components$MyClients$OverviewPage$bucketColumn = F2(
	function (context, bucket) {
		return {
			attrs: _List_fromArray(
				[
					$author$project$Ui$V3$Table$topAligned,
					$author$project$Ui$V3$Table$cellAttributes(
					function (_v0) {
						return _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'text-align', 'center')
							]);
					})
				]),
			content: $author$project$Components$MyClients$OverviewPage$viewCount(bucket),
			heading: A3(
				$author$project$Components$MyClients$OverviewPage$sortableHeading,
				context,
				$author$project$Components$MyClients$OverviewPage$ByBucket(bucket),
				$author$project$Components$MyClients$OverviewPage$columnLabel(bucket))
		};
	});
var $author$project$Ui$V3$Table$OnClickAttribute = function (a) {
	return {$: 'OnClickAttribute', a: a};
};
var $author$project$Ui$V3$Table$RawMessage = function (a) {
	return {$: 'RawMessage', a: a};
};
var $author$project$Ui$V3$Table$clickable = function (_v0) {
	var onClick = _v0.onClick;
	return $author$project$Ui$V3$Table$OnClickAttribute(
		$author$project$Ui$V3$Table$RawMessage(onClick));
};
var $author$project$Components$MyClients$OverviewPage$isExpanded = F2(
	function (context, row) {
		return A2(
			$elm$core$Set$member,
			$author$project$Domain$TmsCarrierId$toInt(row.id),
			context.expandedClients);
	});
var $author$project$Components$MyClients$OverviewPage$expansionColumn = function (context) {
	return {
		attrs: _List_fromArray(
			[$author$project$Ui$V3$Table$topAligned]),
		content: function (row) {
			return A2(
				$author$project$Ui$V3$Icon$view16,
				_List_Nil,
				$author$project$Components$MyClients$OverviewPage$chevronFor(
					!A2($author$project$Components$MyClients$OverviewPage$isExpanded, context, row)));
		},
		heading: $elm$html$Html$text('')
	};
};
var $author$project$Ui$V3$Table$HeadCellAttrs = function (a) {
	return {$: 'HeadCellAttrs', a: a};
};
var $author$project$Ui$V3$Table$headCellAttrs = $author$project$Ui$V3$Table$HeadCellAttrs;
var $author$project$Ui$V3$Table$rightAligned = $author$project$Ui$V3$Table$RightAlignedAttribute;
var $author$project$Ui$V3$Table$SubRow = function (a) {
	return {$: 'SubRow', a: a};
};
var $author$project$Ui$V3$Table$subRow = $author$project$Ui$V3$Table$SubRow;
var $author$project$Components$MyClients$OverviewPage$viewClientCell = function (row) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
			]),
		A2(
			$elm$core$List$cons,
			A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, row.client),
			$elm$core$String$isEmpty(row.mcNumber) ? _List_Nil : _List_fromArray(
				[
					$author$project$Components$MyClients$OverviewPage$viewSubtle(row.mcNumber)
				])));
};
var $author$project$Components$MyClients$OverviewPage$ByAge = {$: 'ByAge'};
var $author$project$Components$MyClients$OverviewPage$ByAmount = {$: 'ByAmount'};
var $author$project$Components$MyClients$OverviewPage$ByColumn = {$: 'ByColumn'};
var $author$project$Components$MyClients$OverviewPage$ByDebtor = {$: 'ByDebtor'};
var $author$project$Components$MyClients$OverviewPage$ByInvoice = {$: 'ByInvoice'};
var $author$project$Components$MyClients$OverviewPage$ByLoad = {$: 'ByLoad'};
var $author$project$Components$MyClients$OverviewPage$ByWhy = {$: 'ByWhy'};
var $author$project$Components$MyClients$OverviewPage$LineSortToggled = function (a) {
	return {$: 'LineSortToggled', a: a};
};
var $author$project$Components$MyClients$OverviewPage$lineAscendingWords = function (column) {
	switch (column.$) {
		case 'ByAmount':
			return 'low to high';
		case 'ByAge':
			return 'newest first';
		case 'ByColumn':
			return 'earliest column first';
		default:
			return 'A to Z';
	}
};
var $author$project$Components$MyClients$OverviewPage$lineDescendingWords = function (column) {
	switch (column.$) {
		case 'ByAmount':
			return 'high to low';
		case 'ByAge':
			return 'oldest first';
		case 'ByColumn':
			return 'latest column first';
		default:
			return 'Z to A';
	}
};
var $author$project$Components$MyClients$OverviewPage$lineHeading = F3(
	function (context, column, label) {
		var active = function () {
			var _v2 = context.lineSort;
			if (_v2.$ === 'Just') {
				var sort = _v2.a;
				return _Utils_eq(sort.column, column) ? $elm$core$Maybe$Just(sort.descending) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = function () {
			if (active.$ === 'Just') {
				if (active.a) {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Icon$sortArrowDown16,
						label + (', sorted ' + $author$project$Components$MyClients$OverviewPage$lineDescendingWords(column)));
				} else {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Icon$sortArrowUp16,
						label + (', sorted ' + $author$project$Components$MyClients$OverviewPage$lineAscendingWords(column)));
				}
			} else {
				return _Utils_Tuple2($author$project$Ui$V3$Icon$sortArrowDefault16, 'Sort by ' + label);
			}
		}();
		var icon = _v0.a;
		var description = _v0.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('my-clients__sort'),
					$elm$html$Html$Attributes$type_('button'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', description),
					$elm$html$Html$Events$onClick(
					$author$project$Components$MyClients$OverviewPage$LineSortToggled(column))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$author$project$Ui$V3$Icon$view16,
					_List_fromArray(
						[
							$author$project$Ui$V3$Icon$label(description)
						]),
					icon)
				]));
	});
var $author$project$Ui$V3$Table$NoOverflow = {$: 'NoOverflow'};
var $author$project$Ui$V3$Table$noOverflow = $author$project$Ui$V3$Table$NoOverflow;
var $author$project$Components$MyClients$OverviewPage$bucketPosition = function (bucket) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$List$length($author$project$AuditPb$allMyClientsBucket),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var candidate = _v0.b;
						return _Utils_eq(candidate, bucket);
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, $author$project$AuditPb$allMyClientsBucket)))));
};
var $author$project$Components$MyClients$OverviewPage$compareText = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(
			$elm$core$String$isEmpty(a),
			$elm$core$String$isEmpty(b));
		if (_v0.a) {
			if (_v0.b) {
				return $elm$core$Basics$EQ;
			} else {
				return $elm$core$Basics$GT;
			}
		} else {
			if (_v0.b) {
				return $elm$core$Basics$LT;
			} else {
				return A2(
					$elm$core$Basics$compare,
					$elm$core$String$toLower(a),
					$elm$core$String$toLower(b));
			}
		}
	});
var $author$project$Components$MyClients$OverviewPage$invoiceLabel = function (invoice) {
	var _v0 = _Utils_Tuple2(invoice.factorInvoiceId, invoice.emailMessageId);
	if (_v0.a.$ === 'Just') {
		var id = _v0.a.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'Invoice ' + $elm$core$String$fromInt(
				$author$project$Domain$FactorInvoiceId$toInt(id)),
			invoice.invoiceNumber);
	} else {
		if (_v0.b.$ === 'Just') {
			var _v1 = _v0.a;
			return 'Not indexed yet';
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return '';
		}
	}
};
var $author$project$Components$MyClients$OverviewPage$compareOnLineColumn = F3(
	function (column, a, b) {
		switch (column.$) {
			case 'ByInvoice':
				return A2(
					$author$project$Components$MyClients$OverviewPage$compareText,
					$author$project$Components$MyClients$OverviewPage$invoiceLabel(a),
					$author$project$Components$MyClients$OverviewPage$invoiceLabel(b));
			case 'ByLoad':
				return A2(
					$author$project$Components$MyClients$OverviewPage$compareText,
					A2($elm$core$Maybe$withDefault, '', a.loadId),
					A2($elm$core$Maybe$withDefault, '', b.loadId));
			case 'ByDebtor':
				return A2(
					$author$project$Components$MyClients$OverviewPage$compareText,
					A2($elm$core$Maybe$withDefault, '', a.debtor),
					A2($elm$core$Maybe$withDefault, '', b.debtor));
			case 'ByColumn':
				return A2(
					$elm$core$Basics$compare,
					$author$project$Components$MyClients$OverviewPage$bucketPosition(a.bucket),
					$author$project$Components$MyClients$OverviewPage$bucketPosition(b.bucket));
			case 'ByWhy':
				return A2(
					$author$project$Components$MyClients$OverviewPage$compareText,
					A2($elm$core$Maybe$withDefault, '', a.reason),
					A2($elm$core$Maybe$withDefault, '', b.reason));
			case 'ByAmount':
				return A2(
					$elm$core$Basics$compare,
					A2($elm$core$Maybe$withDefault, 0, a.amountValue),
					A2($elm$core$Maybe$withDefault, 0, b.amountValue));
			default:
				return A2(
					$elm$core$Basics$compare,
					-$elm$time$Time$posixToMillis(a.ageAt),
					-$elm$time$Time$posixToMillis(b.ageAt));
		}
	});
var $author$project$Components$MyClients$OverviewPage$compareLines = F3(
	function (sort, _v0, _v1) {
		var indexA = _v0.a;
		var a = _v0.b;
		var indexB = _v1.a;
		var b = _v1.b;
		var primary = A3($author$project$Components$MyClients$OverviewPage$compareOnLineColumn, sort.column, a, b);
		var directed = sort.descending ? $author$project$Components$MyClients$OverviewPage$invertOrder(primary) : primary;
		if (directed.$ === 'EQ') {
			return A2($elm$core$Basics$compare, indexA, indexB);
		} else {
			var other = directed;
			return other;
		}
	});
var $author$project$Components$MyClients$OverviewPage$sortLines = F2(
	function (sort, lines) {
		if (sort.$ === 'Nothing') {
			return lines;
		} else {
			var active = sort.a;
			return A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$sortWith,
					$author$project$Components$MyClients$OverviewPage$compareLines(active),
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, lines)));
		}
	});
var $author$project$Ui$V3$Typography$smallBodySemiBoldClass = $elm$html$Html$Attributes$class('v3__type__small-body-semi-bold');
var $author$project$Ui$V3$Typography$smallBodySemiBold = $author$project$Ui$V3$Typography$spanHelper($author$project$Ui$V3$Typography$smallBodySemiBoldClass);
var $author$project$Components$MyClients$OverviewPage$viewBucketChip = function (invoice) {
	var tint = $author$project$Components$MyClients$OverviewPage$tintFor(invoice.heat);
	return A2(
		$author$project$Components$MyClients$OverviewPage$viewChip,
		tint,
		A2(
			$author$project$Ui$V3$Typography$smallBodySemiBold,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute(tint.text)
				]),
			$author$project$Components$MyClients$OverviewPage$columnLabel(invoice.bucket)));
};
var $author$project$Path$emailMessage = F2(
	function (id, isReadonly) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$EmailMessageId$toInt(id));
		return isReadonly ? $author$project$Path$base(
			_List_fromArray(
				['app', 'readonly_emails', idString])) : $author$project$Path$base(
			_List_fromArray(
				['app', 'email', idString]));
	});
var $author$project$Components$MyClients$OverviewPage$invoicePath = F3(
	function (pathContext, invoice, id) {
		var _v0 = invoice.verificationBatchId;
		if (_v0.$ === 'Just') {
			var batchId = _v0.a;
			return $author$project$Path$verificationBatch(batchId);
		} else {
			return A2($author$project$Path$factorInvoice, id, pathContext);
		}
	});
var $author$project$Components$MyClients$OverviewPage$viewMissing = A2(
	$author$project$Ui$V3$Typography$body,
	_List_fromArray(
		[
			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralDisabledDefault)
		]),
	'—');
var $author$project$Components$MyClients$OverviewPage$viewInvoiceCell = F2(
	function (pathContext, invoice) {
		var _v0 = _Utils_Tuple2(invoice.factorInvoiceId, invoice.emailMessageId);
		if (_v0.a.$ === 'Just') {
			var id = _v0.a.a;
			return A2(
				$author$project$Ui$V3$Link$view,
				{
					text: $author$project$Components$MyClients$OverviewPage$invoiceLabel(invoice),
					url: $author$project$Path$toString(
						A3($author$project$Components$MyClients$OverviewPage$invoicePath, pathContext, invoice, id))
				},
				_List_Nil);
		} else {
			if (_v0.b.$ === 'Just') {
				var _v1 = _v0.a;
				var emailId = _v0.b.a;
				return A2(
					$author$project$Ui$V3$Link$view,
					{
						text: $author$project$Components$MyClients$OverviewPage$invoiceLabel(invoice),
						url: $author$project$Path$toString(
							A2($author$project$Path$emailMessage, emailId, pathContext.isReadonly))
					},
					_List_Nil);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return $author$project$Components$MyClients$OverviewPage$viewMissing;
			}
		}
	});
var $author$project$Components$MyClients$OverviewPage$viewOptional = function (maybeText) {
	if (maybeText.$ === 'Just') {
		var text = maybeText.a;
		return A2($author$project$Ui$V3$Typography$body, _List_Nil, text);
	} else {
		return $author$project$Components$MyClients$OverviewPage$viewMissing;
	}
};
var $author$project$Components$MyClients$OverviewPage$viewInvoicesTable = F2(
	function (context, invoices) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('my-clients__drill-down-table')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Ui$V3$Table$view,
					{
						columns: _List_fromArray(
							[
								{
								attrs: _List_fromArray(
									[$author$project$Ui$V3$Table$topAligned]),
								content: $author$project$Components$MyClients$OverviewPage$viewInvoiceCell(context.pathContext),
								heading: A3($author$project$Components$MyClients$OverviewPage$lineHeading, context, $author$project$Components$MyClients$OverviewPage$ByInvoice, 'Invoice')
							},
								{
								attrs: _List_fromArray(
									[$author$project$Ui$V3$Table$topAligned]),
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.loadId;
									},
									$author$project$Components$MyClients$OverviewPage$viewOptional),
								heading: A3($author$project$Components$MyClients$OverviewPage$lineHeading, context, $author$project$Components$MyClients$OverviewPage$ByLoad, 'Load')
							},
								{
								attrs: _List_fromArray(
									[$author$project$Ui$V3$Table$topAligned]),
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.debtor;
									},
									$author$project$Components$MyClients$OverviewPage$viewOptional),
								heading: A3($author$project$Components$MyClients$OverviewPage$lineHeading, context, $author$project$Components$MyClients$OverviewPage$ByDebtor, 'Debtor')
							},
								{
								attrs: _List_fromArray(
									[$author$project$Ui$V3$Table$topAligned]),
								content: $author$project$Components$MyClients$OverviewPage$viewBucketChip,
								heading: A3($author$project$Components$MyClients$OverviewPage$lineHeading, context, $author$project$Components$MyClients$OverviewPage$ByColumn, 'Column')
							},
								{
								attrs: _List_fromArray(
									[$author$project$Ui$V3$Table$topAligned]),
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.reason;
									},
									$author$project$Components$MyClients$OverviewPage$viewOptional),
								heading: A3($author$project$Components$MyClients$OverviewPage$lineHeading, context, $author$project$Components$MyClients$OverviewPage$ByWhy, 'Why')
							},
								{
								attrs: _List_fromArray(
									[$author$project$Ui$V3$Table$topAligned, $author$project$Ui$V3$Table$rightAligned]),
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.amount;
									},
									$author$project$Components$MyClients$OverviewPage$viewOptional),
								heading: A3($author$project$Components$MyClients$OverviewPage$lineHeading, context, $author$project$Components$MyClients$OverviewPage$ByAmount, 'Amount')
							},
								{
								attrs: _List_fromArray(
									[$author$project$Ui$V3$Table$topAligned, $author$project$Ui$V3$Table$rightAligned]),
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.age;
									},
									$author$project$Components$MyClients$OverviewPage$viewSubtle),
								heading: A3($author$project$Components$MyClients$OverviewPage$lineHeading, context, $author$project$Components$MyClients$OverviewPage$ByAge, 'Age')
							}
							])
					},
					_List_fromArray(
						[$author$project$Ui$V3$Table$noOverflow]),
					_List_Nil,
					A2($author$project$Components$MyClients$OverviewPage$sortLines, context.lineSort, invoices))
				]));
	});
var $author$project$Components$MyClients$OverviewPage$viewDrillDown = F2(
	function (context, row) {
		var _v0 = row.lines;
		if (!_v0.b) {
			return $author$project$Components$MyClients$OverviewPage$viewSubtle('Nothing open for this client any more.');
		} else {
			var lines = _v0;
			return A2($author$project$Components$MyClients$OverviewPage$viewInvoicesTable, context, lines);
		}
	});
var $author$project$Components$MyClients$OverviewPage$viewDrillDownRow = F3(
	function (context, columnCount, row) {
		return (!A2($author$project$Components$MyClients$OverviewPage$isExpanded, context, row)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(columnCount),
							$elm$html$Html$Attributes$class('my-clients__drill-down')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$MyClients$OverviewPage$viewDrillDown, context, row)
						]))
				]));
	});
var $author$project$Components$MyClients$OverviewPage$viewCountsTable = F2(
	function (context, rows) {
		var columns = _Utils_ap(
			A2(
				$elm$core$List$cons,
				$author$project$Components$MyClients$OverviewPage$expansionColumn(context),
				A2(
					$elm$core$List$cons,
					{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$MyClients$OverviewPage$viewClientCell,
						heading: A3($author$project$Components$MyClients$OverviewPage$sortableHeading, context, $author$project$Components$MyClients$OverviewPage$ByClient, 'Client')
					},
					A2(
						$elm$core$List$map,
						$author$project$Components$MyClients$OverviewPage$bucketColumn(context),
						$author$project$AuditPb$allMyClientsBucket))),
			_List_fromArray(
				[
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned, $author$project$Ui$V3$Table$rightAligned]),
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.total;
						},
						$author$project$Ui$V3$Typography$body(_List_Nil)),
					heading: A3($author$project$Components$MyClients$OverviewPage$sortableHeading, context, $author$project$Components$MyClients$OverviewPage$ByTotal, 'Total')
				},
					{
					attrs: _List_fromArray(
						[$author$project$Ui$V3$Table$topAligned, $author$project$Ui$V3$Table$rightAligned]),
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.oldest;
						},
						$author$project$Components$MyClients$OverviewPage$viewSubtle),
					heading: A3($author$project$Components$MyClients$OverviewPage$sortableHeading, context, $author$project$Components$MyClients$OverviewPage$ByOldest, 'Oldest')
				}
				]));
		return A4(
			$author$project$Ui$V3$Table$view,
			{columns: columns},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$clickable(
					{
						onClick: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.id;
							},
							$author$project$Components$MyClients$OverviewPage$ExpansionToggled)
					}),
					$author$project$Ui$V3$Table$subRow(
					A2(
						$author$project$Components$MyClients$OverviewPage$viewDrillDownRow,
						context,
						$elm$core$List$length(columns))),
					$author$project$Ui$V3$Table$headCellAttrs(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-my-clients-heading', '')
						]))
				]),
			_List_Nil,
			rows);
	});
var $author$project$Components$MyClients$OverviewPage$viewTable = F2(
	function (context, rows) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('my-clients__counts-table')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$MyClients$OverviewPage$viewCountsTable, context, rows)
				]));
	});
var $author$project$Components$MyClients$OverviewPage$viewGroup = F3(
	function (context, allRows, group) {
		var rows = A3($author$project$Components$MyClients$OverviewPage$rowsInGroup, context.sort, allRows, group);
		var isCollapsed = A2($author$project$Components$MyClients$OverviewPage$isGroupCollapsed, context, group);
		return $elm$core$List$isEmpty(rows) ? $elm$html$Html$text('') : A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			A2(
				$elm$core$List$cons,
				A3($author$project$Components$MyClients$OverviewPage$viewGroupHeading, group, rows, isCollapsed),
				isCollapsed ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$MyClients$OverviewPage$viewTable, context, rows)
					])));
	});
var $author$project$Components$MyClients$OverviewPage$view = F2(
	function (data, model) {
		var rows = A2($elm$core$List$map, $author$project$Components$MyClients$OverviewPage$rowFor, data.clients);
		var shown = A2(
			$elm$core$List$filter,
			A2($author$project$Components$MyClients$OverviewPage$matches, model.filter, model.search),
			rows);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium),
								$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceMedium)
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('My Clients')
									])),
							A2(
								$elm$core$List$cons,
								A3($author$project$Components$MyClients$OverviewPage$viewFilters, data, rows, model),
								$elm$core$List$isEmpty(shown) ? _List_fromArray(
									[
										$author$project$Components$MyClients$OverviewPage$viewSubtle(
										A2($author$project$Components$MyClients$OverviewPage$emptyMessage, model.filter, model.search))
									]) : A2(
									$elm$core$List$map,
									A2(
										$author$project$Components$MyClients$OverviewPage$viewGroup,
										A2($author$project$Components$MyClients$OverviewPage$contextFor, data, model),
										shown),
									$author$project$AuditPb$allMyClientsGroup)))))
				]));
	});
var $author$project$Components$MyClients$OverviewPage$page = $author$project$Forward$Component$forwardComponent(
	{
		init: function (params) {
			return _Utils_Tuple2(
				{
					collapsedGroups: A2($elm$core$List$filter, $author$project$Components$MyClients$OverviewPage$startsCollapsed, $author$project$AuditPb$allMyClientsGroup),
					expandedClients: $elm$core$Set$empty,
					filter: $author$project$Components$MyClients$OverviewPage$filterFromParam(params.accountExecutive),
					lineSort: $elm$core$Maybe$Nothing,
					search: '',
					sort: $elm$core$Maybe$Nothing
				},
				$author$project$HubTran$Effect$none);
		},
		loadData: $author$project$Components$MyClients$OverviewPage$loadData,
		update: F3(
			function (_v0, msg, model) {
				return A2($author$project$Components$MyClients$OverviewPage$update, msg, model);
			}),
		v3ReskinEnabled: true,
		viewLoaded: $author$project$Components$MyClients$OverviewPage$view
	});
var $author$project$Components$NoaManagement$SkippedPage$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$Components$NoaManagement$SkippedPage$Data = F3(
	function (skippedNoas, expandedItem, sandboxRecipients) {
		return {expandedItem: expandedItem, sandboxRecipients: sandboxRecipients, skippedNoas: skippedNoas};
	});
var $author$project$Forward$AppSpecific$Cache$noaSandboxRecipients = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.noaSandboxRecipients;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{noaSandboxRecipients: e});
		}));
var $author$project$AuditPb$NoaSandboxRecipients = function (recipients) {
	return {recipients: recipients};
};
var $author$project$AuditPb$noaSandboxRecipientsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'recipients',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$NoaSandboxRecipients));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSandboxRecipients = $author$project$Forward$Lookup$defineNode(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$noaSandboxRecipients, decoder: $author$project$AuditPb$noaSandboxRecipientsDecoder, entrypoint: 'noaSandboxRecipients', parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Forward$AppSpecific$Cache$noaSendQueueItem = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.noaSendQueueItem;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{noaSendQueueItem: e});
		}));
var $author$project$AuditPb$NoaSendQueueItem = function (id) {
	return function (debtorName) {
		return function (clientName) {
			return function (recipients) {
				return function (documentDisplay) {
					return function (documentUploadedAt) {
						return function (warnings) {
							return function (createdAt) {
								return function (documentId) {
									return function (documentPreviewUrl) {
										return function (reopenedFromEmail) {
											return function (tmsCarrierId) {
												return function (reopenedByName) {
													return {clientName: clientName, createdAt: createdAt, debtorName: debtorName, documentDisplay: documentDisplay, documentId: documentId, documentPreviewUrl: documentPreviewUrl, documentUploadedAt: documentUploadedAt, id: id, recipients: recipients, reopenedByName: reopenedByName, reopenedFromEmail: reopenedFromEmail, tmsCarrierId: tmsCarrierId, warnings: warnings};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$NoaSendQueueItem_Recipient = F2(
	function (email, sourceLabel) {
		return {email: email, sourceLabel: sourceLabel};
	});
var $author$project$AuditPb$noaSendQueueItem_RecipientDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'source_label',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'email',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$NoaSendQueueItem_Recipient)));
	});
var $author$project$AuditPb$NoaSendQueueItem_WarningUnknownWarning = {$: 'NoaSendQueueItem_WarningUnknownWarning'};
var $author$project$AuditPb$noaSendQueueItem_WarningDefault = $author$project$AuditPb$NoaSendQueueItem_WarningUnknownWarning;
var $author$project$AuditPb$NoaSendQueueItem_WarningNoAddress = {$: 'NoaSendQueueItem_WarningNoAddress'};
var $author$project$AuditPb$NoaSendQueueItem_WarningNoDocument = {$: 'NoaSendQueueItem_WarningNoDocument'};
var $author$project$AuditPb$allNoaSendQueueItem_Warning = _List_fromArray(
	[$author$project$AuditPb$NoaSendQueueItem_WarningUnknownWarning, $author$project$AuditPb$NoaSendQueueItem_WarningNoAddress, $author$project$AuditPb$NoaSendQueueItem_WarningNoDocument]);
var $author$project$AuditPb$noaSendQueueItem_WarningToString = function (v) {
	switch (v.$) {
		case 'NoaSendQueueItem_WarningUnknownWarning':
			return 'UNKNOWN_WARNING';
		case 'NoaSendQueueItem_WarningNoAddress':
			return 'NO_ADDRESS';
		default:
			return 'NO_DOCUMENT';
	}
};
var $author$project$AuditPb$noaSendQueueItem_WarningDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$noaSendQueueItem_WarningToString(v),
				v);
		},
		$author$project$AuditPb$allNoaSendQueueItem_Warning));
var $author$project$AuditPb$noaSendQueueItem_WarningFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$noaSendQueueItem_WarningDict);
};
var $author$project$AuditPb$noaSendQueueItem_WarningDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$noaSendQueueItem_WarningDefault),
		$author$project$AuditPb$noaSendQueueItem_WarningFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$noaSendQueueItemDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'reopened_by_name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'tms_carrier_id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
				A3(
					$author$project$AuditPb$optional,
					'reopened_from_email',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'document_preview_url',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'document_id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'created_at',
								$author$project$AuditPb$timestampDecoder,
								A3(
									$author$project$AuditPb$repeated,
									'warnings',
									$author$project$AuditPb$noaSendQueueItem_WarningDecoder,
									A3(
										$author$project$AuditPb$optional,
										'document_uploaded_at',
										$author$project$AuditPb$timestampDecoder,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'document_display',
											$elm$json$Json$Decode$string,
											A3(
												$author$project$AuditPb$repeated,
												'recipients',
												$author$project$AuditPb$noaSendQueueItem_RecipientDecoder,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'client_name',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'debtor_name',
														$elm$json$Json$Decode$string,
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'id',
															$author$project$AuditPb$intDecoder,
															$author$project$AuditPb$decode($author$project$AuditPb$NoaSendQueueItem))))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSendQueueItem = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$noaSendQueueItem,
		decoder: $author$project$AuditPb$noaSendQueueItemDecoder,
		entrypoint: 'noaSendQueueItem',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($elm$core$Basics$identity)
	});
var $author$project$Pagination$PageDetails = F4(
	function (entries, pageNumber, entriesPerPage, totalEntries) {
		return {entries: entries, entriesPerPage: entriesPerPage, pageNumber: pageNumber, totalEntries: totalEntries};
	});
var $author$project$AuditPb$ForwardAPIPaginatedResult = F4(
	function (entries, pageNumber, entriesPerPage, totalEntries) {
		return {entries: entries, entriesPerPage: entriesPerPage, pageNumber: pageNumber, totalEntries: totalEntries};
	});
var $author$project$AuditPb$forwardAPIPaginatedResultDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'totalEntries',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'entriesPerPage',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'pageNumber',
					$author$project$AuditPb$intDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'entries',
						$author$project$AuditPb$intDecoder,
						$author$project$AuditPb$decode($author$project$AuditPb$ForwardAPIPaginatedResult)))));
	});
var $author$project$Pagination$fromRecord = function (pageDetails) {
	return $author$project$Pagination$Page(pageDetails);
};
var $author$project$Forward$Lookup$decodeReferencePage = function (entryFromInt) {
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Pagination$fromRecord,
		A2(
			$elm$json$Json$Decode$andThen,
			function (result) {
				return A2(
					$author$project$Helpers$Json$Decode$apply,
					$elm$json$Json$Decode$succeed(result.totalEntries),
					A2(
						$author$project$Helpers$Json$Decode$apply,
						$elm$json$Json$Decode$succeed(result.entriesPerPage),
						A2(
							$author$project$Helpers$Json$Decode$apply,
							$elm$json$Json$Decode$succeed(result.pageNumber),
							A2(
								$author$project$Helpers$Json$Decode$apply,
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$List$map(entryFromInt),
									$elm$json$Json$Decode$succeed(result.entries)),
								$elm$json$Json$Decode$succeed($author$project$Pagination$PageDetails)))));
			},
			$author$project$AuditPb$forwardAPIPaginatedResultDecoder));
};
var $author$project$Pagination$map = F2(
	function (f, _v0) {
		var pageDetails = _v0.a;
		return $author$project$Pagination$Page(
			{
				entries: A2($elm$core$List$map, f, pageDetails.entries),
				entriesPerPage: pageDetails.entriesPerPage,
				pageNumber: pageDetails.pageNumber,
				totalEntries: pageDetails.totalEntries
			});
	});
var $author$project$Pagination$mapEntries = F2(
	function (f, _v0) {
		var pageDetails = _v0.a;
		return $author$project$Pagination$Page(
			{
				entries: f(pageDetails.entries),
				entriesPerPage: pageDetails.entriesPerPage,
				pageNumber: pageDetails.pageNumber,
				totalEntries: pageDetails.totalEntries
			});
	});
var $author$project$Forward$Internal$Loadable$pageOfLoadablesToLoadablePage = function (page) {
	return A2(
		$author$project$Forward$Internal$Loadable$map,
		function (entries) {
			return A2(
				$author$project$Pagination$mapEntries,
				function (_v0) {
					return entries;
				},
				page);
		},
		$author$project$Forward$Internal$Loadable$listOfLoadablesToLoadableList(
			$author$project$Pagination$entries(page)));
};
var $author$project$Forward$Lookup$traversePage = A2(
	$author$project$Forward$Lookup$traverseHelper,
	'traversePage',
	{containerOfLoadablesToLoadableContainer: $author$project$Forward$Internal$Loadable$pageOfLoadablesToLoadablePage, map: $author$project$Pagination$map});
var $author$project$Forward$Lookup$defineReferencePage = function (config) {
	return A2(
		$author$project$Forward$Lookup$traversePage,
		config.objectEntrypoint,
		$author$project$Forward$Lookup$defineNode(
			{
				cacheKey: config.cacheKey,
				decoder: $author$project$Forward$Lookup$decodeReferencePage(config.idFromInt),
				entrypoint: config.entrypoint,
				parameters: config.parameters
			}));
};
var $author$project$Forward$AppSpecific$Cache$page_skippedNoaId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_skippedNoaId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_skippedNoaId: e});
		}));
var $author$project$Forward$AppSpecific$Cache$skippedNoa = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.skippedNoa;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{skippedNoa: e});
		}));
var $author$project$AuditPb$SkippedNoa = F9(
	function (id, skippedAt, factorBrokerId, debtorName, tmsCarrierId, clientName, reason, note, skippedByName) {
		return {clientName: clientName, debtorName: debtorName, factorBrokerId: factorBrokerId, id: id, note: note, reason: reason, skippedAt: skippedAt, skippedByName: skippedByName, tmsCarrierId: tmsCarrierId};
	});
var $author$project$AuditPb$SkippedNoa_ReasonUnknownReason = {$: 'SkippedNoa_ReasonUnknownReason'};
var $author$project$AuditPb$skippedNoa_ReasonDefault = $author$project$AuditPb$SkippedNoa_ReasonUnknownReason;
var $author$project$AuditPb$SkippedNoa_ReasonNoAddressYet = {$: 'SkippedNoa_ReasonNoAddressYet'};
var $author$project$AuditPb$SkippedNoa_ReasonNotRequired = {$: 'SkippedNoa_ReasonNotRequired'};
var $author$project$AuditPb$SkippedNoa_ReasonOther = {$: 'SkippedNoa_ReasonOther'};
var $author$project$AuditPb$allSkippedNoa_Reason = _List_fromArray(
	[$author$project$AuditPb$SkippedNoa_ReasonUnknownReason, $author$project$AuditPb$SkippedNoa_ReasonNoAddressYet, $author$project$AuditPb$SkippedNoa_ReasonNotRequired, $author$project$AuditPb$SkippedNoa_ReasonOther]);
var $author$project$AuditPb$skippedNoa_ReasonToString = function (v) {
	switch (v.$) {
		case 'SkippedNoa_ReasonUnknownReason':
			return 'UNKNOWN_REASON';
		case 'SkippedNoa_ReasonNoAddressYet':
			return 'NO_ADDRESS_YET';
		case 'SkippedNoa_ReasonNotRequired':
			return 'NOT_REQUIRED';
		default:
			return 'OTHER';
	}
};
var $author$project$AuditPb$skippedNoa_ReasonDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$skippedNoa_ReasonToString(v),
				v);
		},
		$author$project$AuditPb$allSkippedNoa_Reason));
var $author$project$AuditPb$skippedNoa_ReasonFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$skippedNoa_ReasonDict);
};
var $author$project$AuditPb$skippedNoa_ReasonDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$skippedNoa_ReasonDefault),
		$author$project$AuditPb$skippedNoa_ReasonFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$skippedNoaDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'skipped_by_name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'note',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'reason',
					$author$project$AuditPb$skippedNoa_ReasonDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'client_name',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'tms_carrier_id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'debtor_name',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'factor_broker_id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $author$project$AuditPb$intDecoder),
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'skipped_at',
										$author$project$AuditPb$timestampDecoder,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'id',
											$author$project$AuditPb$intDecoder,
											$author$project$AuditPb$decode($author$project$AuditPb$SkippedNoa))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$skippedNoa = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$skippedNoa,
		decoder: $author$project$AuditPb$skippedNoaDecoder,
		entrypoint: 'skippedNoa',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($elm$core$Basics$identity)
	});
var $author$project$AuditPb$skippedNoasQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page)
				])));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$skippedNoas = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_skippedNoaId,
		entrypoint: 'skippedNoas',
		idFromInt: $elm$core$Basics$identity,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$skippedNoa,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$skippedNoasQueryEncoder)
	});
var $author$project$Components$NoaManagement$SkippedPage$skippedNoasPage = function (model) {
	return A2(
		$author$project$Forward$Lookup$startFrom,
		{page: model.pageNumber},
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$skippedNoas);
};
var $author$project$Forward$Lookup$startFromMaybe = F2(
	function (maybe, lookup) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$Maybe$Just,
				A2($author$project$Forward$Lookup$startFrom, value, lookup));
		} else {
			return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$NoaManagement$SkippedPage$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSandboxRecipients,
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$startFromMaybe, model.expandedRowId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSendQueueItem),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$NoaManagement$SkippedPage$skippedNoasPage(model),
				$author$project$Forward$Lookup$succeed($author$project$Components$NoaManagement$SkippedPage$Data))));
};
var $author$project$Components$NoaManagement$SkippedPage$SendCompleted = function (a) {
	return {$: 'SendCompleted', a: a};
};
var $author$project$HubTran$Flash$defaultServerErrorAlert = $author$project$HubTran$Flash$alert('An unexpected server error occurred. Please try again.');
var $author$project$Helpers$Api$standardErrorDecoder = function (_v0) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'error_message', $elm$json$Json$Decode$string),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$String$join(', '),
				A2(
					$elm$json$Json$Decode$field,
					'errors',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))
			]));
};
var $author$project$Helpers$Api$postWithNoResponseBody = F2(
	function (url, json) {
		return A2(
			$author$project$Forward$CacheableRequest$requestWithIgnoredResponseBody,
			{
				body: $elm$core$Maybe$Just(json),
				errorDecoder: $author$project$Helpers$Api$standardErrorDecoder,
				headers: _List_Nil,
				method: 'POST',
				timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
				url: url
			},
			$elm$core$Basics$identity);
	});
var $author$project$Api$NoaSendQueueItems$deliver = F4(
	function (id, expectedRecipientEmail, expectedDocumentId, typedEmail) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/accounts_payable/noa_send_queue_items/' + ($elm$core$String$fromInt(id) + '/deliver'),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'expected_recipient_email',
						$elm$json$Json$Encode$string(expectedRecipientEmail)),
						_Utils_Tuple2(
						'expected_document_id',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentId$toInt),
								expectedDocumentId))),
						_Utils_Tuple2(
						'typed_email',
						$elm$json$Json$Encode$string(typedEmail))
					])));
	});
var $author$project$Components$NoaManagement$SkippedPage$humanErrorMessage = function (serverError) {
	switch (serverError) {
		case 'drifted':
			return 'This row has changed since you loaded the page. Reload to see the current version.';
		case 'no_document':
			return 'No NOA document is on file for this carrier. Skip this row or upload one first.';
		case 'already_sent':
			return 'This NOA has already been sent. Reload the page to see the current queue.';
		default:
			return 'The NOA could not be sent. Please reload the page and try again.';
	}
};
var $author$project$Forward$Internal$EntrypointCache$empty = $author$project$Forward$Internal$EntrypointCache$EntrypointCache(
	{needsRefresh: $elm$core$Set$empty, timestamps: $elm$core$Dict$empty, values: $elm$core$Dict$empty});
var $author$project$HubTran$Effect$invalidateAllOfType = function (typeKey) {
	return $author$project$HubTran$Effect$ForwardEffect(
		$author$project$Forward$Internal$PureEffectManagerCmd$InvalidateItem(
			A2(
				$author$project$Forward$Internal$CacheKey$modifyTypedCache,
				typeKey,
				function (_v0) {
					return $author$project$Forward$Internal$EntrypointCache$empty;
				})));
};
var $author$project$Components$NoaManagement$SkippedPage$pageAfterRemovingOneRow = F2(
	function (data, pageNumber) {
		var rowsOnPage = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.skippedNoas;
					},
					A2($elm$core$Basics$composeR, $author$project$Pagination$entries, $elm$core$List$length)),
				$author$project$Forward$Remote$toMaybe(data)));
		return ((pageNumber > 1) && (rowsOnPage === 1)) ? (pageNumber - 1) : pageNumber;
	});
var $author$project$Forward$AppSpecific$Cache$page_sentNoa = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_sentNoa;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_sentNoa: e});
		}));
var $author$project$Path$noaManagement = $author$project$Path$base(
	_List_fromArray(
		['app', 'noa_management']));
var $author$project$Path$noaManagementSent = F2(
	function (maybeDebtorId, maybeCarrierId) {
		var queries = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (id) {
						return _Utils_Tuple2(
							'debtor_id',
							$elm$core$String$fromInt(
								$author$project$Domain$FactorBrokerId$toInt(id)));
					},
					maybeDebtorId),
					A2(
					$elm$core$Maybe$map,
					function (id) {
						return _Utils_Tuple2(
							'carrier_id',
							$elm$core$String$fromInt(
								$author$project$Domain$TmsCarrierId$toInt(id)));
					},
					maybeCarrierId)
				]));
		return A2(
			$author$project$Path$addQueries,
			queries,
			A2(
				$author$project$Path$appendToBase,
				_List_fromArray(
					['sent']),
				$author$project$Path$noaManagement));
	});
var $author$project$Path$noaManagementSkipped = A2(
	$author$project$Path$appendToBase,
	_List_fromArray(
		['skipped']),
	$author$project$Path$noaManagement);
var $author$project$Components$NoaManagement$Layout$path = function (tab) {
	switch (tab.$) {
		case 'ToSend':
			return $author$project$Path$noaManagement;
		case 'Sent':
			return A2($author$project$Path$noaManagementSent, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		default:
			return $author$project$Path$noaManagementSkipped;
	}
};
var $author$project$Forward$Internal$EntrypointCache$ContinueShowingCachedData = {$: 'ContinueShowingCachedData'};
var $author$project$Forward$Lookup$runInvalidation = F3(
	function (mode, a, _v0) {
		var lookup = _v0.a;
		return A2(lookup.invalidate, a, mode);
	});
var $author$project$HubTran$Effect$refresh = function (lookup) {
	return $author$project$HubTran$Effect$ForwardEffect(
		$author$project$Forward$Internal$PureEffectManagerCmd$InvalidateItem(
			A3($author$project$Forward$Lookup$runInvalidation, $author$project$Forward$Internal$EntrypointCache$ContinueShowingCachedData, _Utils_Tuple0, lookup)));
};
var $author$project$Helpers$Api$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $author$project$Helpers$Api$Result$HttpErr = function (a) {
	return {$: 'HttpErr', a: a};
};
var $author$project$Helpers$Api$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $author$project$Helpers$Api$Result$fromNestedResult = function (result) {
	if (result.$ === 'Ok') {
		if (result.a.$ === 'Ok') {
			var a = result.a.a;
			return $author$project$Helpers$Api$Result$Ok(a);
		} else {
			var x = result.a.a;
			return $author$project$Helpers$Api$Result$Err(x);
		}
	} else {
		var httpError = result.a;
		return $author$project$Helpers$Api$Result$HttpErr(httpError);
	}
};
var $author$project$HubTran$Effect$sendCacheableRequestWithError = F2(
	function (toMsg, request) {
		return $author$project$HubTran$Effect$ForwardEffect(
			$author$project$Forward$Internal$PureEffectManagerCmd$CacheableRequestCommand(
				A2(
					$author$project$Forward$CacheableRequest$map,
					A2($elm$core$Basics$composeR, $author$project$Helpers$Api$Result$fromNestedResult, toMsg),
					request)));
	});
var $author$project$Components$NoaManagement$SkippedPage$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'ClickedReview':
				var rowId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							expandedRowId: $elm$core$Maybe$Just(rowId),
							sending: false
						}),
					$author$project$HubTran$Effect$none);
			case 'ClickedCancelReview':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{expandedRowId: $elm$core$Maybe$Nothing, sending: false, typedEmail: ''}),
					$author$project$HubTran$Effect$none);
			case 'TypedEmailChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{typedEmail: value}),
					$author$project$HubTran$Effect$none);
			case 'ClickedSend':
				var itemId = msg.a;
				var expectedRecipientEmail = msg.b;
				var expectedDocumentId = msg.c;
				var typedEmail = msg.d;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sending: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$NoaManagement$SkippedPage$SendCompleted,
						A4($author$project$Api$NoaSendQueueItems$deliver, itemId, expectedRecipientEmail, expectedDocumentId, typedEmail)));
			case 'SendCompleted':
				var result = msg.a;
				switch (result.$) {
					case 'Ok':
						var nextModel = _Utils_update(
							model,
							{
								expandedRowId: $elm$core$Maybe$Nothing,
								pageNumber: A2($author$project$Components$NoaManagement$SkippedPage$pageAfterRemovingOneRow, data, model.pageNumber),
								sending: false,
								typedEmail: ''
							});
						return _Utils_Tuple2(
							nextModel,
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$refresh(
										$author$project$Components$NoaManagement$SkippedPage$skippedNoasPage(nextModel)),
										$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$page_skippedNoaId),
										$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$page_sentNoa)
									])));
					case 'Err':
						var serverError = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sending: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(
									$author$project$Components$NoaManagement$SkippedPage$humanErrorMessage(serverError))));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sending: false}),
							$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
				}
			case 'SelectedTab':
				var tab = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$pushUrl(
						$author$project$Path$toString(
							$author$project$Components$NoaManagement$Layout$path(tab))));
			case 'SetTimezone':
				var timezone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: timezone}),
					$author$project$HubTran$Effect$none);
			default:
				var newPageNumber = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pageNumber: newPageNumber}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$NoaManagement$SkippedPage$SelectedTab = function (a) {
	return {$: 'SelectedTab', a: a};
};
var $author$project$Components$NoaManagement$Layout$Skipped = {$: 'Skipped'};
var $author$project$Components$NoaManagement$Layout$viewSandboxBanner = function (sandboxRecipients) {
	var _v0 = sandboxRecipients.recipients;
	if (_v0.$ === 'Nothing') {
		return $author$project$Helpers$Html$empty;
	} else {
		var recipients = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert-box warning centered')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Sandbox mode: NOA sends from this account will go to ' + (recipients + '.'))
				]));
	}
};
var $author$project$Components$NoaManagement$Layout$Sent = {$: 'Sent'};
var $author$project$Components$NoaManagement$Layout$ToSend = {$: 'ToSend'};
var $author$project$Components$NoaManagement$Layout$label = function (tab) {
	switch (tab.$) {
		case 'ToSend':
			return 'To Send';
		case 'Sent':
			return 'Sent';
		default:
			return 'Skipped';
	}
};
var $author$project$Ui$V3$SecondaryToggle$LeftRightPadding = function (a) {
	return {$: 'LeftRightPadding', a: a};
};
var $author$project$Ui$V3$SecondaryToggle$leftRightPadding = $author$project$Ui$V3$SecondaryToggle$LeftRightPadding;
var $author$project$Ui$V3$SecondaryToggle$TopBottomPadding = function (a) {
	return {$: 'TopBottomPadding', a: a};
};
var $author$project$Ui$V3$SecondaryToggle$topBottomPadding = $author$project$Ui$V3$SecondaryToggle$TopBottomPadding;
var $author$project$Ui$V3$SecondaryToggle$defaultAttributes = {leftRightPadding: '8px', topBottomPadding: '4px'};
var $author$project$Ui$V3$SecondaryToggle$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			if (a.$ === 'TopBottomPadding') {
				var s = a.a;
				return _Utils_update(
					acc,
					{topBottomPadding: s});
			} else {
				var s = a.a;
				return _Utils_update(
					acc,
					{leftRightPadding: s});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$SecondaryToggle$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Stack$noWrap = $author$project$Ui$V3$Stack$ClassAttribute('v3__stack--no-wrap');
var $author$project$Ui$V3$SecondaryToggle$viewToggle = F4(
	function (attrs, isSelected, onToggle, label) {
		var selectedClass = isSelected ? 'v3__secondary-toggle__button--selected' : 'v3__secondary-toggle__button--unselected';
		var clickAttr = A2(
			$elm$html$Html$Events$stopPropagationOn,
			'click',
			$elm$json$Json$Decode$succeed(
				function (msg) {
					return _Utils_Tuple2(msg, true);
				}(onToggle)));
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('v3__secondary-toggle__button'),
					$elm$html$Html$Attributes$class(selectedClass),
					$author$project$Ui$V3$Typography$xSmallBodySemiBoldClass,
					clickAttr,
					A2($elm$html$Html$Attributes$style, 'padding', attrs.topBottomPadding + (' ' + attrs.leftRightPadding))
				]),
			_List_fromArray(
				[label]));
	});
var $author$project$Ui$V3$SecondaryToggle$view = F2(
	function (attributes, config) {
		var computedAttributes = $author$project$Ui$V3$SecondaryToggle$computeAttributes(attributes);
		var buttons = A2(
			$elm$core$List$map,
			function (val) {
				return _Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A4(
						$author$project$Ui$V3$SecondaryToggle$viewToggle,
						computedAttributes,
						_Utils_eq(config.selected, val),
						config.onToggle(val),
						config.toLabel(val)));
			},
			config.segments);
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$class('v3__secondary-toggle'),
					$author$project$Ui$V3$Stack$noWrap,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			buttons);
	});
var $author$project$Components$NoaManagement$Layout$viewTabs = F2(
	function (current, onSelectTab) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$SecondaryToggle$view,
						_List_fromArray(
							[
								$author$project$Ui$V3$SecondaryToggle$topBottomPadding('6px'),
								$author$project$Ui$V3$SecondaryToggle$leftRightPadding('16px')
							]),
						{
							onToggle: onSelectTab,
							segments: _List_fromArray(
								[$author$project$Components$NoaManagement$Layout$ToSend, $author$project$Components$NoaManagement$Layout$Sent, $author$project$Components$NoaManagement$Layout$Skipped]),
							selected: current,
							toLabel: A2($elm$core$Basics$composeR, $author$project$Components$NoaManagement$Layout$label, $elm$html$Html$text)
						})),
					_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Helpers$Html$empty)
				]));
	});
var $author$project$Components$NoaManagement$Layout$view = F2(
	function (_v0, inner) {
		var sandboxRecipients = _v0.sandboxRecipients;
		var onSelectTab = _v0.onSelectTab;
		var current = _v0.current;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$class('noa-management'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium),
								$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceMedium)
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('NOA Management')
									])),
							A2(
								$elm$core$List$cons,
								$author$project$Components$NoaManagement$Layout$viewSandboxBanner(sandboxRecipients),
								A2(
									$elm$core$List$cons,
									A2($author$project$Components$NoaManagement$Layout$viewTabs, current, onSelectTab),
									inner)))))
				]));
	});
var $author$project$Components$NoaManagement$SkippedPage$viewEmptyState = A2(
	$author$project$Ui$V3$Typography$body,
	_List_fromArray(
		[
			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
		]),
	'Nothing skipped yet');
var $author$project$Components$NoaManagement$SkippedPage$ClickedCancelReview = {$: 'ClickedCancelReview'};
var $author$project$Components$NoaManagement$SkippedPage$ClickedSend = F4(
	function (a, b, c, d) {
		return {$: 'ClickedSend', a: a, b: b, c: c, d: d};
	});
var $author$project$Components$NoaManagement$SkippedPage$TypedEmailChanged = function (a) {
	return {$: 'TypedEmailChanged', a: a};
};
var $author$project$Ui$V3$Modal$DisablePrimaryButton = function (a) {
	return {$: 'DisablePrimaryButton', a: a};
};
var $author$project$Ui$V3$Modal$disablePrimaryButton = function (bool) {
	return $author$project$Ui$V3$Modal$DisablePrimaryButton(bool);
};
var $author$project$Components$NoaManagement$SkippedPage$firstRecipientEmail = function (recipients) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.email;
			},
			$elm$core$List$head(recipients)));
};
var $author$project$Components$NoaManagement$SkippedPage$sendDisabled = F2(
	function (model, detail) {
		var hasUnresolvedNoAddress = A2($elm$core$List$member, $author$project$AuditPb$NoaSendQueueItem_WarningNoAddress, detail.warnings) && $elm$core$String$isEmpty(model.typedEmail);
		var hasNoDocument = A2($elm$core$List$member, $author$project$AuditPb$NoaSendQueueItem_WarningNoDocument, detail.warnings);
		return model.sending || (hasNoDocument || hasUnresolvedNoAddress);
	});
var $author$project$Ui$V3$Modal$Small = {$: 'Small'};
var $author$project$Ui$V3$Modal$small = $author$project$Ui$V3$Modal$Small;
var $author$project$Ui$V3$Modal$TextHeader = function (a) {
	return {$: 'TextHeader', a: a};
};
var $author$project$Ui$V3$Modal$textHeader = $author$project$Ui$V3$Modal$TextHeader;
var $author$project$Ui$V3$Button$VariantSecondary = {$: 'VariantSecondary'};
var $author$project$Ui$V3$Modal$defaultAttributes = {disablePrimaryButton: false, headerIcon: $elm$core$Maybe$Nothing, hideCloseIcon: false, hideFooterHr: false, info: $elm$core$Maybe$Nothing};
var $author$project$Ui$V3$Modal$computeAttributes = function (attrs) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'Info':
					var str = a.a;
					return _Utils_update(
						acc,
						{
							info: $elm$core$Maybe$Just(str)
						});
				case 'HideCloseIcon':
					var bool = a.a;
					return _Utils_update(
						acc,
						{hideCloseIcon: bool});
				case 'DisablePrimaryButton':
					var bool = a.a;
					return _Utils_update(
						acc,
						{disablePrimaryButton: bool});
				default:
					var icon = a.a;
					return _Utils_update(
						acc,
						{
							headerIcon: $elm$core$Maybe$Just(icon)
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Modal$defaultAttributes, attrs);
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Ui$V3$Notification$AlertLevelAttribute = function (a) {
	return {$: 'AlertLevelAttribute', a: a};
};
var $author$project$Ui$V3$Notification$InfoLevel = {$: 'InfoLevel'};
var $author$project$Ui$V3$Notification$info = $author$project$Ui$V3$Notification$AlertLevelAttribute($author$project$Ui$V3$Notification$InfoLevel);
var $author$project$Ui$V3$Stack$MainAxisAttribute = function (a) {
	return {$: 'MainAxisAttribute', a: a};
};
var $author$project$Ui$V3$Stack$MainAxisEnd = {$: 'MainAxisEnd'};
var $author$project$Ui$V3$Stack$mainAxisEnd = $author$project$Ui$V3$Stack$MainAxisAttribute($author$project$Ui$V3$Stack$MainAxisEnd);
var $author$project$Ui$V3$Modal$modalContainer = F2(
	function (config, dialogBody) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__modal__outer_container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__modal__bg'),
							$elm$html$Html$Events$onClick(config.dismissMsg)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, dialogBody)
						]))
				]));
	});
var $author$project$Ui$V3$Stack$TestIdAttribute = function (a) {
	return {$: 'TestIdAttribute', a: a};
};
var $author$project$Ui$V3$Stack$testId = function (id) {
	return $author$project$Ui$V3$Stack$TestIdAttribute(id);
};
var $author$project$Ui$V3$Stack$viewHorz = F2(
	function (attributes, children) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			attributes,
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$pair($author$project$Ui$V3$Stack$flex1),
				children));
	});
var $author$project$Ui$V3$Icon$alertTriangle16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.8471 13.9617L9.18279 0.744345C9.06983 0.519844 8.90023 0.331839 8.69233 0.20065C8.48443 0.0694619 8.24614 7.879e-05 8.0032 0C7.76027 7.879e-05 7.52197 0.0694619 7.31407 0.20065C7.10617 0.331839 6.93658 0.519844 6.82361 0.744345L0.15927 13.9617C0.0483055 14.1768 -0.00641988 14.4187 0.000599508 14.6629C0.00761889 14.9072 0.0761354 15.1452 0.199256 15.353C0.320703 15.5532 0.48913 15.7177 0.688569 15.8309C0.888007 15.9442 1.11184 16.0023 1.33886 15.9999H14.6675C14.897 15.9999 15.1225 15.938 15.3223 15.8203C15.5221 15.7026 15.6894 15.533 15.808 15.328C15.9266 15.1231 15.9925 14.8896 15.9994 14.6502C16.0063 14.4109 15.9538 14.1737 15.8471 13.9617ZM7.33677 5.56519C7.33677 5.38069 7.40698 5.20375 7.53196 5.07329C7.65694 4.94284 7.82645 4.86954 8.0032 4.86954C8.17995 4.86954 8.34946 4.94284 8.47444 5.07329C8.59942 5.20375 8.66964 5.38069 8.66964 5.56519V9.73909C8.66964 9.92358 8.59942 10.1005 8.47444 10.231C8.34946 10.3614 8.17995 10.4347 8.0032 10.4347C7.82645 10.4347 7.65694 10.3614 7.53196 10.231C7.40698 10.1005 7.33677 9.92358 7.33677 9.73909V5.56519ZM8.03652 13.5652C7.77404 13.5636 7.52225 13.4564 7.33356 13.2659C7.14488 13.0754 7.03383 12.8163 7.02354 12.5426C7.01909 12.405 7.04108 12.268 7.08823 12.1395C7.13539 12.011 7.20673 11.8937 7.29806 11.7944C7.38939 11.6952 7.49884 11.6161 7.61996 11.5618C7.74107 11.5075 7.87139 11.4791 8.0032 11.4782C8.26569 11.4798 8.51748 11.587 8.70616 11.7775C8.89485 11.9679 9.00589 12.227 9.01618 12.5008C9.02064 12.6383 8.99864 12.7754 8.95149 12.9039C8.90434 13.0324 8.83299 13.1497 8.74166 13.2489C8.65034 13.3481 8.54088 13.4273 8.41977 13.4816C8.29866 13.5359 8.16834 13.5643 8.03652 13.5652Z'),
						$elm$svg$Svg$Attributes$fill('#FFC229')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$info16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0V0ZM8.16667 3.33333C8.36445 3.33333 8.55779 3.39198 8.72224 3.50186C8.88669 3.61174 9.01486 3.76792 9.09055 3.95065C9.16624 4.13338 9.18604 4.33444 9.14746 4.52842C9.10887 4.7224 9.01363 4.90059 8.87378 5.04044C8.73392 5.18029 8.55574 5.27553 8.36176 5.31412C8.16778 5.3527 7.96671 5.3329 7.78399 5.25721C7.60126 5.18153 7.44508 5.05335 7.3352 4.8889C7.22532 4.72445 7.16667 4.53111 7.16667 4.33333C7.16667 4.06812 7.27203 3.81376 7.45956 3.62623C7.6471 3.43869 7.90145 3.33333 8.16667 3.33333ZM9.66667 12.3333H7C6.82319 12.3333 6.65362 12.2631 6.5286 12.1381C6.40358 12.013 6.33334 11.8435 6.33334 11.6667C6.33334 11.4899 6.40358 11.3203 6.5286 11.1953C6.65362 11.0702 6.82319 11 7 11H7.5C7.54421 11 7.5866 10.9824 7.61786 10.9512C7.64911 10.9199 7.66667 10.8775 7.66667 10.8333V7.83333C7.66667 7.78913 7.64911 7.74674 7.61786 7.71548C7.5866 7.68423 7.54421 7.66667 7.5 7.66667H7C6.82319 7.66667 6.65362 7.59643 6.5286 7.4714C6.40358 7.34638 6.33334 7.17681 6.33334 7C6.33334 6.82319 6.40358 6.65362 6.5286 6.5286C6.65362 6.40357 6.82319 6.33333 7 6.33333H7.66667C8.02029 6.33333 8.35943 6.47381 8.60948 6.72386C8.85953 6.97391 9 7.31304 9 7.66667V10.8333C9 10.8775 9.01756 10.9199 9.04882 10.9512C9.08008 10.9824 9.12247 11 9.16667 11H9.66667C9.84348 11 10.0131 11.0702 10.1381 11.1953C10.2631 11.3203 10.3333 11.4899 10.3333 11.6667C10.3333 11.8435 10.2631 12.013 10.1381 12.1381C10.0131 12.2631 9.84348 12.3333 9.66667 12.3333Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$success16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM12.62 5.46667L8.05334 11.66C8.0002 11.7324 7.93297 11.7933 7.8557 11.8391C7.77843 11.8849 7.6927 11.9146 7.60366 11.9265C7.51462 11.9383 7.42411 11.932 7.33756 11.908C7.25101 11.884 7.17021 11.8427 7.1 11.7867L3.84 9.18C3.77152 9.12498 3.71458 9.05698 3.67247 8.97989C3.63035 8.90279 3.60389 8.81814 3.59459 8.73079C3.5853 8.64344 3.59336 8.55511 3.61832 8.47088C3.64327 8.38666 3.68463 8.30819 3.74 8.24C3.85078 8.10557 4.00977 8.01984 4.18296 8.00115C4.35614 7.98247 4.52976 8.0323 4.66667 8.14L7.38667 10.3133L11.5467 4.66667C11.6516 4.5261 11.8078 4.43257 11.9813 4.40636C12.1547 4.38015 12.3315 4.42338 12.4733 4.52667C12.5453 4.57824 12.6064 4.64364 12.6528 4.71906C12.6993 4.79447 12.7302 4.87839 12.7439 4.9659C12.7575 5.05341 12.7536 5.14277 12.7323 5.22875C12.7111 5.31473 12.6729 5.39561 12.62 5.46667Z'),
						$elm$svg$Svg$Attributes$fill('#14994C')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Notification$levelToIcon = function (level) {
	switch (level.$) {
		case 'SuccessLevel':
			return $author$project$Ui$V3$Icon$success16;
		case 'WarningLevel':
			return $author$project$Ui$V3$Icon$alertTriangle16;
		case 'InfoLevel':
			return $author$project$Ui$V3$Icon$info16;
		default:
			return $author$project$Ui$V3$Icon$error16;
	}
};
var $author$project$Ui$V3$Notification$defaultAttributes = function () {
	var defaultLevel = $author$project$Ui$V3$Notification$InfoLevel;
	return {
		alertLevel: defaultLevel,
		column: false,
		icon: _Utils_Tuple2(
			_List_Nil,
			$author$project$Ui$V3$Notification$levelToIcon(defaultLevel))
	};
}();
var $author$project$Ui$V3$Notification$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'AlertLevelAttribute':
					var alertLevel = a.a;
					return _Utils_update(
						acc,
						{
							alertLevel: alertLevel,
							icon: _Utils_Tuple2(
								_List_Nil,
								$author$project$Ui$V3$Notification$levelToIcon(alertLevel))
						});
				case 'Icon':
					var iconAttributes = a.a;
					var icon_ = a.b;
					return _Utils_update(
						acc,
						{
							icon: _Utils_Tuple2(iconAttributes, icon_)
						});
				default:
					return _Utils_update(
						acc,
						{column: true});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Notification$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Notification$levelToModifier = function (level) {
	switch (level.$) {
		case 'SuccessLevel':
			return 'success';
		case 'WarningLevel':
			return 'warning';
		case 'InfoLevel':
			return 'info';
		default:
			return 'error';
	}
};
var $author$project$Ui$V3$Notification$view = function (_v0) {
	var computedAttributes = _v0.computedAttributes;
	var actionButton = _v0.actionButton;
	var onClose = _v0.onClose;
	var message = _v0.message;
	var title = _v0.title;
	var style = _v0.style;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__notification'),
				$elm$html$Html$Attributes$class('v3__notification--' + style),
				$elm$html$Html$Attributes$class(
				'v3__notification--' + $author$project$Ui$V3$Notification$levelToModifier(computedAttributes.alertLevel))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__notification-icon'),
						$elm$html$Html$Attributes$class('v3__notification-icon--' + style)
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, computedAttributes.icon.a, computedAttributes.icon.b)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('v3__notification-text', true),
								_Utils_Tuple2('v3__notification-text--column', computedAttributes.column)
							]))
					]),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (t) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3__notification-text-title'),
											$elm$html$Html$Attributes$class('v3__notification-text-title--' + style)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(t)
										]));
							},
							title),
							$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3__notification-text-message')
									]),
								_List_fromArray(
									[message]))),
							A2(
							$elm$core$Maybe$map,
							function (button) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3__notification-action-button')
										]),
									_List_fromArray(
										[button]));
							},
							actionButton)
						]))),
				A2(
				$elm$core$Maybe$withDefault,
				A2($elm$html$Html$div, _List_Nil, _List_Nil),
				A2(
					$elm$core$Maybe$map,
					function (action) {
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__notification-close'),
									$elm$html$Html$Attributes$class('v3__notification-close--' + style),
									$elm$html$Html$Events$onClick(action)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Icon$view16,
									_List_fromArray(
										[
											$author$project$Ui$V3$Icon$label('Close')
										]),
									$author$project$Ui$V3$Icon$close16)
								]));
					},
					onClose))
			]));
};
var $author$project$Ui$V3$Notification$viewInlineWithAction = F2(
	function (_v0, attributes) {
		var actionButton = _v0.actionButton;
		var onClose = _v0.onClose;
		var message = _v0.message;
		var title = _v0.title;
		var computedAttributes = $author$project$Ui$V3$Notification$computeAttributes(attributes);
		return $author$project$Ui$V3$Notification$view(
			{actionButton: actionButton, computedAttributes: computedAttributes, message: message, onClose: onClose, style: 'inline', title: title});
	});
var $author$project$Ui$V3$Notification$viewInline = F2(
	function (_v0, attributes) {
		var onClose = _v0.onClose;
		var message = _v0.message;
		var title = _v0.title;
		return A2(
			$author$project$Ui$V3$Notification$viewInlineWithAction,
			{actionButton: $elm$core$Maybe$Nothing, message: message, onClose: onClose, title: title},
			attributes);
	});
var $author$project$Ui$V3$Modal$view = F2(
	function (attrs, config) {
		var sizeClass = function () {
			var _v4 = config.size;
			switch (_v4.$) {
				case 'XSmall':
					return 'v3__modal__xsmall-container';
				case 'Small':
					return 'v3__modal__small-container';
				case 'Medium':
					return 'v3__modal__medium-container';
				default:
					return 'v3__modal__large-container';
			}
		}();
		var computedAttributes = $author$project$Ui$V3$Modal$computeAttributes(attrs);
		var header = function () {
			var _v2 = config.header;
			if (_v2.$ === 'TextHeader') {
				var str = _v2.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$testId('modal-header-and-hr'),
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$testId('modal-header'),
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
										$author$project$Ui$V3$Stack$crossAxisCenter
									]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											function () {
											var _v3 = computedAttributes.headerIcon;
											if (_v3.$ === 'Just') {
												var icon = _v3.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														$author$project$Ui$V3$Stack$fit,
														A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$style, 'margin-top', '12px')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$map,
																	$elm$core$Basics$never,
																	A2($author$project$Ui$V3$Icon$view24, _List_Nil, icon))
																])))
													]);
											} else {
												return _List_Nil;
											}
										}(),
											_List_fromArray(
											[
												_Utils_Tuple2(
												$author$project$Ui$V3$Stack$flex1,
												A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('v3__modal__header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(str)
														])))
											]),
											computedAttributes.hideCloseIcon ? _List_Nil : _List_fromArray(
											[
												_Utils_Tuple2(
												$author$project$Ui$V3$Stack$fit,
												A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Events$onClick(config.dismissMsg),
															$elm$html$Html$Attributes$class('v3__button__plain'),
															$elm$html$Html$Attributes$class('v3__modal__close-button')
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$V3$Icon$view16,
															_List_fromArray(
																[
																	$author$project$Ui$V3$Icon$label('Close modal')
																]),
															$author$project$Ui$V3$Icon$close16)
														])))
											])
										]))),
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3__modal__hr')
									]),
								_List_Nil)
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var infoEls = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (info_) {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorz,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$testId('modal-info'),
									$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXXSmall)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Notification$viewInline,
									{
										message: $elm$html$Html$text(info_),
										onClose: $elm$core$Maybe$Nothing,
										title: $elm$core$Maybe$Just('')
									},
									_List_fromArray(
										[$author$project$Ui$V3$Notification$info]))
								]))
						]);
				},
				computedAttributes.info));
		var primaryButton = A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var label = _v1.a;
				var msg = _v1.b;
				return A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(msg)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$disabled(computedAttributes.disablePrimaryButton)
						]),
					label);
			},
			config.primaryButton);
		var cancelButton = A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var label = _v0.a;
				var msg = _v0.b;
				return A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(msg)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
						]),
					label);
			},
			config.cancelButton);
		var allFooterButtons = _Utils_ap(
			config.footerButtons,
			_Utils_ap(
				$elm_community$maybe_extra$Maybe$Extra$toList(cancelButton),
				$elm_community$maybe_extra$Maybe$Extra$toList(primaryButton)));
		var footer = $elm$core$List$isEmpty(allFooterButtons) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$testId('modal-footer-buttons'),
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
						$author$project$Ui$V3$Stack$mainAxisEnd
					]),
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
					allFooterButtons))
			]);
		return A2(
			$author$project$Ui$V3$Modal$modalContainer,
			config,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__modal ' + sizeClass)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Stack$viewVertWithHeights,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$testId('modal'),
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									A2(
									$elm$core$List$map,
									$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
									header),
									A2(
									$elm$core$List$map,
									$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
									infoEls),
									_List_fromArray(
									[
										_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, config.body)
									]),
									A2(
									$elm$core$List$map,
									$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
									footer)
								])))
					])));
	});
var $author$project$Ui$V3$Colors$TextBrandDefault = {$: 'TextBrandDefault'};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Components$NoaManagement$SkippedPage$viewDocumentSection = F2(
	function (documentDisplay, documentPreviewUrl) {
		return $elm$core$String$isEmpty(documentDisplay) ? A2(
			$author$project$Ui$V3$Typography$body,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
				]),
			'None uploaded') : ($elm$core$String$isEmpty(documentPreviewUrl) ? A2($author$project$Ui$V3$Typography$body, _List_Nil, documentDisplay) : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(documentPreviewUrl),
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$rel('noopener noreferrer'),
					A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextBrandDefault)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Typography$body, _List_Nil, documentDisplay)
				])));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Components$NoaManagement$SkippedPage$viewSection = F2(
	function (label, body) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Typography$xSmallBodySemiBold,
					_List_fromArray(
						[
							$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
						]),
					$elm$core$String$toUpper(label)),
					body
				]));
	});
var $author$project$Components$NoaManagement$SkippedPage$viewNoteSection = function (note) {
	return $elm$core$String$isEmpty(note) ? $elm$html$Html$text('') : A2(
		$author$project$Components$NoaManagement$SkippedPage$viewSection,
		'Reviewer note',
		A2($author$project$Ui$V3$Typography$body, _List_Nil, note));
};
var $author$project$Components$NoaManagement$SkippedPage$viewRecipient = function (recipient) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$body, _List_Nil, recipient.email)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Typography$smallBody,
						_List_fromArray(
							[
								$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
							]),
						recipient.sourceLabel)
					]))
			]));
};
var $author$project$Components$NoaManagement$SkippedPage$viewRecipientSection = function (recipients) {
	if (!recipients.b) {
		return A2(
			$author$project$Ui$V3$Typography$body,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
				]),
			'None proposed');
	} else {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			A2($elm$core$List$map, $author$project$Components$NoaManagement$SkippedPage$viewRecipient, recipients));
	}
};
var $author$project$Components$NoaManagement$SkippedPage$viewWarning = function (warning) {
	switch (warning.$) {
		case 'NoaSendQueueItem_WarningNoAddress':
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$body, _List_Nil, 'No address')
					]));
		case 'NoaSendQueueItem_WarningNoDocument':
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$body, _List_Nil, 'No document')
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Components$NoaManagement$SkippedPage$viewWarningsSection = function (warnings) {
	return $elm$core$List$isEmpty(warnings) ? $elm$html$Html$text('') : A2(
		$author$project$Components$NoaManagement$SkippedPage$viewSection,
		'Missing information',
		A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2($elm$core$List$map, $author$project$Components$NoaManagement$SkippedPage$viewWarning, warnings)));
};
var $author$project$Ui$V3$Typography$xSmallBodyClass = $elm$html$Html$Attributes$class('v3__type__extra-small-body');
var $author$project$Ui$V3$Typography$xSmallBody = $author$project$Ui$V3$Typography$spanHelper($author$project$Ui$V3$Typography$xSmallBodyClass);
var $author$project$Components$NoaManagement$SkippedPage$viewReviewModal = F2(
	function (model, data) {
		var _v0 = _Utils_Tuple2(model.expandedRowId, data.expandedItem);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var rowId = _v0.a.a;
			var detail = _v0.b.a;
			var skippedRow = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (r) {
						return _Utils_eq(r.id, rowId);
					},
					$author$project$Pagination$entries(data.skippedNoas)));
			var header = A2(
				$elm$core$Maybe$withDefault,
				'Review NOA',
				A2(
					$elm$core$Maybe$map,
					function (row) {
						return row.debtorName + (' → ' + row.clientName);
					},
					skippedRow));
			return A2(
				$author$project$Ui$V3$Modal$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$Modal$disablePrimaryButton(
						A2($author$project$Components$NoaManagement$SkippedPage$sendDisabled, model, detail))
					]),
				{
					body: A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-testid', 'review-expansion')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$NoaManagement$SkippedPage$viewSection,
										'Recipient',
										$author$project$Components$NoaManagement$SkippedPage$viewRecipientSection(detail.recipients)),
										A2(
										$author$project$Ui$V3$Stack$viewVert,
										_List_fromArray(
											[
												$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$for('typed-address')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Or type an address:')
													])),
												A2(
												$author$project$Ui$V3$Stack$viewVert,
												_List_fromArray(
													[
														$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$id('typed-address'),
																$elm$html$Html$Attributes$class('v3__input'),
																$elm$html$Html$Attributes$type_('email'),
																$elm$html$Html$Attributes$value(model.typedEmail),
																$elm$html$Html$Events$onInput($author$project$Components$NoaManagement$SkippedPage$TypedEmailChanged)
															]),
														_List_Nil),
														A2(
														$author$project$Ui$V3$Typography$xSmallBody,
														_List_fromArray(
															[
																$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
															]),
														'Sent here instead of any proposed recipient.')
													]))
											])),
										A2(
										$author$project$Components$NoaManagement$SkippedPage$viewSection,
										'Document',
										A2($author$project$Components$NoaManagement$SkippedPage$viewDocumentSection, detail.documentDisplay, detail.documentPreviewUrl)),
										$author$project$Components$NoaManagement$SkippedPage$viewWarningsSection(detail.warnings),
										$author$project$Components$NoaManagement$SkippedPage$viewNoteSection(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.note;
												},
												skippedRow)))
									]))
							])),
					cancelButton: $elm$core$Maybe$Just(
						_Utils_Tuple2('Cancel', $author$project$Components$NoaManagement$SkippedPage$ClickedCancelReview)),
					dismissMsg: $author$project$Components$NoaManagement$SkippedPage$ClickedCancelReview,
					footerButtons: _List_Nil,
					header: $author$project$Ui$V3$Modal$textHeader(header),
					primaryButton: $elm$core$Maybe$Just(
						_Utils_Tuple2(
							'Send this NOA',
							A4(
								$author$project$Components$NoaManagement$SkippedPage$ClickedSend,
								detail.id,
								$author$project$Components$NoaManagement$SkippedPage$firstRecipientEmail(detail.recipients),
								detail.documentId,
								model.typedEmail))),
					size: $author$project$Ui$V3$Modal$small
				});
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$NoaManagement$SkippedPage$SetPageNumber = function (a) {
	return {$: 'SetPageNumber', a: a};
};
var $author$project$Components$NoaManagement$SkippedPage$reasonLabel = function (reason) {
	switch (reason.$) {
		case 'SkippedNoa_ReasonNoAddressYet':
			return 'No address yet';
		case 'SkippedNoa_ReasonNotRequired':
			return 'Not required';
		case 'SkippedNoa_ReasonOther':
			return 'Other';
		default:
			return '';
	}
};
var $author$project$Components$NoaManagement$SkippedPage$ClickedReview = function (a) {
	return {$: 'ClickedReview', a: a};
};
var $author$project$Components$NoaManagement$SkippedPage$viewReviewButton = function (row) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick(
				$author$project$Components$NoaManagement$SkippedPage$ClickedReview(row.id))
		},
		_List_Nil,
		'Review');
};
var $author$project$Components$NoaManagement$SkippedPage$viewTable = F2(
	function (model, page_) {
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2(
								$author$project$Ui$V3$Typography$body,
								_List_Nil,
								A2($author$project$Helpers$Date$dateString, model.timezone, row.skippedAt));
						},
						heading: $elm$html$Html$text('Skipped')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, row.debtorName);
						},
						heading: $elm$html$Html$text('Debtor')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, row.clientName);
						},
						heading: $elm$html$Html$text('Client')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2(
								$author$project$Ui$V3$Typography$body,
								_List_Nil,
								$author$project$Components$NoaManagement$SkippedPage$reasonLabel(row.reason));
						},
						heading: $elm$html$Html$text('Reason')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, row.note);
						},
						heading: $elm$html$Html$text('Note')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, row.skippedByName);
						},
						heading: $elm$html$Html$text('Skipped by')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$rightAligned]),
						content: $author$project$Components$NoaManagement$SkippedPage$viewReviewButton,
						heading: $elm$html$Html$text('')
					}
					])
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$pagination(
					{currentPage: page_, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$NoaManagement$SkippedPage$SetPageNumber})
				]),
			_List_Nil,
			$author$project$Pagination$entries(page_));
	});
var $author$project$Components$NoaManagement$SkippedPage$view = F2(
	function (data, model) {
		return A2(
			$author$project$Components$NoaManagement$Layout$view,
			{current: $author$project$Components$NoaManagement$Layout$Skipped, onSelectTab: $author$project$Components$NoaManagement$SkippedPage$SelectedTab, sandboxRecipients: data.sandboxRecipients},
			(!$author$project$Pagination$totalEntries(data.skippedNoas)) ? _List_fromArray(
				[$author$project$Components$NoaManagement$SkippedPage$viewEmptyState]) : _List_fromArray(
				[
					A2($author$project$Components$NoaManagement$SkippedPage$viewTable, model, data.skippedNoas),
					A2($author$project$Components$NoaManagement$SkippedPage$viewReviewModal, model, data)
				]));
	});
var $author$project$Components$NoaManagement$SkippedPage$page = $author$project$Forward$Component$forwardComponent(
	{
		init: function (_v0) {
			return _Utils_Tuple2(
				{expandedRowId: $elm$core$Maybe$Nothing, pageNumber: 1, sending: false, timezone: $elm$time$Time$utc, typedEmail: ''},
				$author$project$HubTran$Effect$cmd(
					A2($elm$core$Task$perform, $author$project$Components$NoaManagement$SkippedPage$SetTimezone, $author$project$Helpers$Date$localTimezone)));
		},
		loadData: $author$project$Components$NoaManagement$SkippedPage$loadData,
		update: $author$project$Components$NoaManagement$SkippedPage$update,
		v3ReskinEnabled: true,
		viewLoaded: $author$project$Components$NoaManagement$SkippedPage$view
	});
var $author$project$Components$NoaManagement$ToSendPage$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$Components$NoaManagement$ToSendPage$Data = F2(
	function (items, sandboxRecipients) {
		return {items: items, sandboxRecipients: sandboxRecipients};
	});
var $author$project$AuditPb$noaSendQueueItemsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page)
				])));
};
var $author$project$Forward$AppSpecific$Cache$page_noaSendQueueItemId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_noaSendQueueItemId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_noaSendQueueItemId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSendQueueItemsToSend = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_noaSendQueueItemId,
		entrypoint: 'noaSendQueueItemsToSend',
		idFromInt: $elm$core$Basics$identity,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSendQueueItem,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$noaSendQueueItemsQueryEncoder)
	});
var $author$project$Components$NoaManagement$ToSendPage$toSendPageLookup = function (pageNumber) {
	return A2(
		$author$project$Forward$Lookup$startFrom,
		{page: pageNumber},
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSendQueueItemsToSend);
};
var $author$project$Components$NoaManagement$ToSendPage$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSandboxRecipients,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$NoaManagement$ToSendPage$toSendPageLookup(model.pageNumber),
			$author$project$Forward$Lookup$succeed($author$project$Components$NoaManagement$ToSendPage$Data)));
};
var $author$project$Components$NoaManagement$ToSendPage$SendCompleted = function (a) {
	return {$: 'SendCompleted', a: a};
};
var $author$project$Components$NoaManagement$ToSendPage$SkipCompleted = function (a) {
	return {$: 'SkipCompleted', a: a};
};
var $author$project$Components$NoaManagement$ToSendPage$closeSkipModal = function (model) {
	return _Utils_update(
		model,
		{skipModalItemId: $elm$core$Maybe$Nothing, skipModalNote: '', skipModalReason: $elm$core$Maybe$Nothing, skipModalSubmitting: false});
};
var $author$project$Components$NoaManagement$ToSendPage$forgetCachedPages = $author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$page_noaSendQueueItemId);
var $author$project$Components$NoaManagement$ToSendPage$humanErrorMessage = function (serverError) {
	switch (serverError) {
		case 'drifted':
			return 'This row has changed since you loaded the page. Reload to see the current version.';
		case 'no_document':
			return 'No NOA document is on file for this carrier. Skip this row or upload one first.';
		case 'already_sent':
			return 'This NOA has already been sent. Reload the page to see the current queue.';
		case 'no_recipients':
			return 'No address is on file for this row. Skip it or add a recipient before sending.';
		case 'delivered_not_recorded':
			return 'This NOA was delivered to the debtor but could not be recorded. Do not send it again. Reload the page and contact support.';
		default:
			return 'The NOA could not be sent. Please reload the page and try again.';
	}
};
var $author$project$Components$NoaManagement$ToSendPage$humanSkipErrorMessage = function (serverError) {
	switch (serverError) {
		case 'already_decided':
			return 'This row has already been decided. Reload the page to see the current queue.';
		case 'invalid_reason':
			return 'That is not a valid skip reason. Please choose one from the list.';
		case 'note_too_long':
			return 'The note is too long. Please shorten it to under 2000 characters and try again.';
		default:
			return 'The NOA could not be skipped. Please reload the page and try again.';
	}
};
var $author$project$Components$NoaManagement$ToSendPage$pageAfterRemovingOneRow = F2(
	function (data, pageNumber) {
		var rowsOnPage = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.items;
					},
					A2($elm$core$Basics$composeR, $author$project$Pagination$entries, $elm$core$List$length)),
				$author$project$Forward$Remote$toMaybe(data)));
		return ((pageNumber > 1) && (rowsOnPage === 1)) ? (pageNumber - 1) : pageNumber;
	});
var $author$project$Api$NoaSendQueueItems$skip = F3(
	function (id, reason, note) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/accounts_payable/noa_send_queue_items/' + ($elm$core$String$fromInt(id) + '/skip'),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'reason',
						$elm$json$Json$Encode$string(reason)),
						_Utils_Tuple2(
						'note',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, note)))
					])));
	});
var $author$project$Components$NoaManagement$ToSendPage$skipReasonToString = function (reason) {
	switch (reason.$) {
		case 'NoAddressYet':
			return 'no_address_yet';
		case 'NotRequired':
			return 'not_required';
		default:
			return 'other';
	}
};
var $author$project$Components$NoaManagement$ToSendPage$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'ClickedSend':
				var itemId = msg.a;
				var expectedRecipientEmail = msg.b;
				var expectedDocumentId = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sendingItemId: $elm$core$Maybe$Just(itemId)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$NoaManagement$ToSendPage$SendCompleted,
						A4($author$project$Api$NoaSendQueueItems$deliver, itemId, expectedRecipientEmail, expectedDocumentId, '')));
			case 'SendCompleted':
				var result = msg.a;
				switch (result.$) {
					case 'Ok':
						var pageNumber = A2($author$project$Components$NoaManagement$ToSendPage$pageAfterRemovingOneRow, data, model.pageNumber);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{pageNumber: pageNumber, sendingItemId: $elm$core$Maybe$Nothing}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$refresh(
										$author$project$Components$NoaManagement$ToSendPage$toSendPageLookup(pageNumber)),
										$author$project$Components$NoaManagement$ToSendPage$forgetCachedPages,
										$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$page_sentNoa)
									])));
					case 'Err':
						var serverError = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sendingItemId: $elm$core$Maybe$Nothing}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(
									$author$project$Components$NoaManagement$ToSendPage$humanErrorMessage(serverError))));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sendingItemId: $elm$core$Maybe$Nothing}),
							$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
				}
			case 'ClickedSkip':
				var itemId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							skipModalItemId: $elm$core$Maybe$Just(itemId),
							skipModalNote: '',
							skipModalReason: $elm$core$Maybe$Nothing,
							skipModalSubmitting: false
						}),
					$author$project$HubTran$Effect$none);
			case 'SkipReasonChosen':
				var reason = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							skipModalReason: $elm$core$Maybe$Just(reason)
						}),
					$author$project$HubTran$Effect$none);
			case 'SkipNoteChanged':
				var note = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{skipModalNote: note}),
					$author$project$HubTran$Effect$none);
			case 'SkipConfirmed':
				var _v2 = _Utils_Tuple2(model.skipModalItemId, model.skipModalReason);
				if ((_v2.a.$ === 'Just') && (_v2.b.$ === 'Just')) {
					var itemId = _v2.a.a;
					var reason = _v2.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{skipModalSubmitting: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$NoaManagement$ToSendPage$SkipCompleted,
							A3(
								$author$project$Api$NoaSendQueueItems$skip,
								itemId,
								$author$project$Components$NoaManagement$ToSendPage$skipReasonToString(reason),
								$elm$core$String$isEmpty(model.skipModalNote) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.skipModalNote))));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'SkipCompleted':
				var result = msg.a;
				switch (result.$) {
					case 'Ok':
						var pageNumber = A2($author$project$Components$NoaManagement$ToSendPage$pageAfterRemovingOneRow, data, model.pageNumber);
						return _Utils_Tuple2(
							$author$project$Components$NoaManagement$ToSendPage$closeSkipModal(
								_Utils_update(
									model,
									{pageNumber: pageNumber})),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$refresh(
										$author$project$Components$NoaManagement$ToSendPage$toSendPageLookup(pageNumber)),
										$author$project$Components$NoaManagement$ToSendPage$forgetCachedPages,
										$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$page_skippedNoaId)
									])));
					case 'Err':
						var serverError = result.a;
						return _Utils_Tuple2(
							$author$project$Components$NoaManagement$ToSendPage$closeSkipModal(model),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(
									$author$project$Components$NoaManagement$ToSendPage$humanSkipErrorMessage(serverError))));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{skipModalSubmitting: false}),
							$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
				}
			case 'SkipCancelled':
				return _Utils_Tuple2(
					$author$project$Components$NoaManagement$ToSendPage$closeSkipModal(model),
					$author$project$HubTran$Effect$none);
			case 'NoOp':
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'SelectedTab':
				var tab = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$pushUrl(
						$author$project$Path$toString(
							$author$project$Components$NoaManagement$Layout$path(tab))));
			case 'SetTimezone':
				var timezone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: timezone}),
					$author$project$HubTran$Effect$none);
			default:
				var newPageNumber = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pageNumber: newPageNumber}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$NoaManagement$ToSendPage$SelectedTab = function (a) {
	return {$: 'SelectedTab', a: a};
};
var $author$project$Components$NoaManagement$ToSendPage$viewEmptyState = A2(
	$author$project$Ui$V3$Typography$body,
	_List_fromArray(
		[
			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
		]),
	'Nothing waiting to send');
var $author$project$Components$NoaManagement$ToSendPage$SkipCancelled = {$: 'SkipCancelled'};
var $author$project$Components$NoaManagement$ToSendPage$SkipConfirmed = {$: 'SkipConfirmed'};
var $author$project$Components$NoaManagement$ToSendPage$SkipNoteChanged = function (a) {
	return {$: 'SkipNoteChanged', a: a};
};
var $author$project$Components$NoaManagement$ToSendPage$NoAddressYet = {$: 'NoAddressYet'};
var $author$project$Components$NoaManagement$ToSendPage$NotRequired = {$: 'NotRequired'};
var $author$project$Components$NoaManagement$ToSendPage$Other = {$: 'Other'};
var $author$project$Components$NoaManagement$ToSendPage$allSkipReasons = _List_fromArray(
	[$author$project$Components$NoaManagement$ToSendPage$NoAddressYet, $author$project$Components$NoaManagement$ToSendPage$NotRequired, $author$project$Components$NoaManagement$ToSendPage$Other]);
var $author$project$Components$NoaManagement$ToSendPage$NoOp = {$: 'NoOp'};
var $author$project$Components$NoaManagement$ToSendPage$SkipReasonChosen = function (a) {
	return {$: 'SkipReasonChosen', a: a};
};
var $author$project$Components$NoaManagement$ToSendPage$onSkipReasonChange = function (value) {
	switch (value) {
		case 'no_address_yet':
			return $author$project$Components$NoaManagement$ToSendPage$SkipReasonChosen($author$project$Components$NoaManagement$ToSendPage$NoAddressYet);
		case 'not_required':
			return $author$project$Components$NoaManagement$ToSendPage$SkipReasonChosen($author$project$Components$NoaManagement$ToSendPage$NotRequired);
		case 'other':
			return $author$project$Components$NoaManagement$ToSendPage$SkipReasonChosen($author$project$Components$NoaManagement$ToSendPage$Other);
		default:
			return $author$project$Components$NoaManagement$ToSendPage$NoOp;
	}
};
var $author$project$Components$NoaManagement$ToSendPage$skipReasonLabel = function (reason) {
	switch (reason.$) {
		case 'NoAddressYet':
			return 'No address yet';
		case 'NotRequired':
			return 'Not required';
		default:
			return 'Other';
	}
};
var $author$project$Components$NoaManagement$ToSendPage$viewSkipReasonOption = F2(
	function (current, reason) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Components$NoaManagement$ToSendPage$skipReasonToString(reason)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						current,
						$elm$core$Maybe$Just(reason)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Components$NoaManagement$ToSendPage$skipReasonLabel(reason))
				]));
	});
var $author$project$Components$NoaManagement$ToSendPage$viewSkipModal = function (model) {
	var _v0 = model.skipModalItemId;
	if (_v0.$ === 'Nothing') {
		return $elm$html$Html$text('');
	} else {
		return A2(
			$author$project$Ui$V3$Modal$view,
			_List_fromArray(
				[
					$author$project$Ui$V3$Modal$disablePrimaryButton(
					_Utils_eq(model.skipModalReason, $elm$core$Maybe$Nothing))
				]),
			{
				body: A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('skip-reason')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Reason')
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('skip-reason'),
									$elm$html$Html$Attributes$class('v3__input v3__simple-select v3__simple-select--size-medium'),
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2($elm$json$Json$Decode$map, $author$project$Components$NoaManagement$ToSendPage$onSkipReasonChange, $elm$html$Html$Events$targetValue))
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(''),
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(model.skipModalReason, $elm$core$Maybe$Nothing))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Choose a reason')
										])),
								A2(
									$elm$core$List$map,
									$author$project$Components$NoaManagement$ToSendPage$viewSkipReasonOption(model.skipModalReason),
									$author$project$Components$NoaManagement$ToSendPage$allSkipReasons))),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('skip-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Note')
								])),
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('skip-note'),
									$elm$html$Html$Attributes$class('v3__input'),
									$elm$html$Html$Attributes$value(model.skipModalNote),
									$elm$html$Html$Events$onInput($author$project$Components$NoaManagement$ToSendPage$SkipNoteChanged)
								]),
							_List_Nil)
						])),
				cancelButton: $elm$core$Maybe$Just(
					_Utils_Tuple2('Cancel', $author$project$Components$NoaManagement$ToSendPage$SkipCancelled)),
				dismissMsg: $author$project$Components$NoaManagement$ToSendPage$SkipCancelled,
				footerButtons: _List_Nil,
				header: $author$project$Ui$V3$Modal$textHeader('Skip this NOA'),
				primaryButton: $elm$core$Maybe$Just(
					_Utils_Tuple2('Skip this NOA', $author$project$Components$NoaManagement$ToSendPage$SkipConfirmed)),
				size: $author$project$Ui$V3$Modal$small
			});
	}
};
var $author$project$Components$NoaManagement$ToSendPage$SetPageNumber = function (a) {
	return {$: 'SetPageNumber', a: a};
};
var $author$project$Components$NoaManagement$ToSendPage$hasWarning = F2(
	function (warning, item) {
		return A2($elm$core$List$member, warning, item.warnings);
	});
var $author$project$Components$NoaManagement$ToSendPage$uploadedLabel = F2(
	function (timezone, uploadedAt) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (at) {
					return 'Uploaded ' + A2($author$project$Helpers$Date$dateString, timezone, at);
				},
				uploadedAt));
	});
var $author$project$Components$NoaManagement$ToSendPage$viewDocumentDisplay = F2(
	function (documentDisplay, documentPreviewUrl) {
		return $elm$core$String$isEmpty(documentPreviewUrl) ? A2($author$project$Ui$V3$Typography$body, _List_Nil, documentDisplay) : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(documentPreviewUrl),
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$rel('noopener noreferrer'),
					A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextBrandDefault)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Typography$body, _List_Nil, documentDisplay)
				]));
	});
var $author$project$Path$settingsEditCarrier = function (tmsCarrierId) {
	return $author$project$Path$base(
		_List_fromArray(
			[
				'app',
				'settings',
				'carriers',
				$elm$core$String$fromInt(
				$author$project$Domain$TmsCarrierId$toInt(tmsCarrierId))
			]));
};
var $author$project$Path$settingsEditCarrierDocuments = function (tmsCarrierId) {
	return A2(
		$author$project$Path$appendToBase,
		_List_fromArray(
			['documents']),
		$author$project$Path$settingsEditCarrier(tmsCarrierId));
};
var $author$project$Components$NoaManagement$ToSendPage$viewUploadDocumentLink = function (tmsCarrierId) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(
				$author$project$Path$toString(
					$author$project$Path$settingsEditCarrierDocuments(tmsCarrierId))),
				A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
				$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextBrandDefault)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'Upload NOA document')
			]));
};
var $author$project$Components$NoaManagement$ToSendPage$viewWarning = function (label) {
	return A2(
		$author$project$Ui$V3$Typography$body,
		_List_fromArray(
			[
				$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
			]),
		label);
};
var $author$project$Components$NoaManagement$ToSendPage$viewDocument = F2(
	function (timezone, item) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			A2($author$project$Components$NoaManagement$ToSendPage$hasWarning, $author$project$AuditPb$NoaSendQueueItem_WarningNoDocument, item) ? _List_fromArray(
				[
					$author$project$Components$NoaManagement$ToSendPage$viewWarning('No document'),
					$author$project$Components$NoaManagement$ToSendPage$viewUploadDocumentLink(item.tmsCarrierId)
				]) : _List_fromArray(
				[
					A2($author$project$Components$NoaManagement$ToSendPage$viewDocumentDisplay, item.documentDisplay, item.documentPreviewUrl),
					A2(
					$author$project$Ui$V3$Typography$smallBody,
					_List_fromArray(
						[
							$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
						]),
					A2($author$project$Components$NoaManagement$ToSendPage$uploadedLabel, timezone, item.documentUploadedAt))
				]));
	});
var $author$project$Components$NoaManagement$ToSendPage$ClickedSend = F3(
	function (a, b, c) {
		return {$: 'ClickedSend', a: a, b: b, c: c};
	});
var $author$project$Components$NoaManagement$ToSendPage$firstRecipientEmail = function (item) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.email;
			},
			$elm$core$List$head(item.recipients)));
};
var $author$project$Components$NoaManagement$ToSendPage$viewSendButton = F2(
	function (model, item) {
		var isDisabled = A2($author$project$Components$NoaManagement$ToSendPage$hasWarning, $author$project$AuditPb$NoaSendQueueItem_WarningNoDocument, item) || (A2($author$project$Components$NoaManagement$ToSendPage$hasWarning, $author$project$AuditPb$NoaSendQueueItem_WarningNoAddress, item) || (_Utils_eq(
			model.sendingItemId,
			$elm$core$Maybe$Just(item.id)) || _Utils_eq(
			model.skipModalItemId,
			$elm$core$Maybe$Just(item.id))));
		var button = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					A3(
						$author$project$Components$NoaManagement$ToSendPage$ClickedSend,
						item.id,
						$author$project$Components$NoaManagement$ToSendPage$firstRecipientEmail(item),
						item.documentId))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$disabled(isDisabled)
				]),
			'Send');
		return A2($author$project$Components$NoaManagement$ToSendPage$hasWarning, $author$project$AuditPb$NoaSendQueueItem_WarningNoAddress, item) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title('Add a recipient before sending this NOA.')
				]),
			_List_fromArray(
				[button])) : button;
	});
var $author$project$Components$NoaManagement$ToSendPage$viewRecipient = function (recipient) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$body, _List_Nil, recipient.email),
				A2(
				$author$project$Ui$V3$Typography$smallBody,
				_List_fromArray(
					[
						$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
					]),
				recipient.sourceLabel)
			]));
};
var $author$project$Ui$V3$Colors$BorderFeedbackWarning = {$: 'BorderFeedbackWarning'};
var $author$project$Ui$V3$Colors$borderColorAttribute = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$Attributes$style('border-color'),
	$author$project$Ui$V3$Colors$cssVariable);
var $author$project$Components$NoaManagement$ToSendPage$viewReopenedFromCallout = F2(
	function (reopenedFromEmail, reopenedByName) {
		if (reopenedFromEmail.$ === 'Just') {
			var email = reopenedFromEmail.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$BackgroundFeedbackWarningSubtle),
							$author$project$Ui$V3$Colors$borderColorAttribute($author$project$Ui$V3$Colors$BorderFeedbackWarning),
							$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextFeedbackWarning),
							A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'padding', '2px 6px'),
							A2($elm$html$Html$Attributes$style, 'font-weight', 'var(--font-weight-bold)'),
							A2($elm$html$Html$Attributes$style, 'font-size', 'var(--font-size-h6)'),
							A2($elm$html$Html$Attributes$style, 'line-height', 'var(--line-height-h6)'),
							A2($elm$html$Html$Attributes$style, 'border-style', 'solid'),
							A2($elm$html$Html$Attributes$style, 'border-width', '1.5px'),
							A2($elm$html$Html$Attributes$style, 'border-radius', 'var(--corner-radius-sm)'),
							A2($elm$html$Html$Attributes$style, 'white-space', 'normal'),
							A2($elm$html$Html$Attributes$style, 'word-break', 'break-all')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								if (reopenedByName.$ === 'Just') {
									var name = reopenedByName.a;
									return 'Reopened by ' + name;
								} else {
									return 'Reopened after bounce to ' + email;
								}
							}())
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$NoaManagement$ToSendPage$viewSendTo = function (item) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
				$author$project$Ui$V3$Stack$crossAxisLeft
			]),
		_Utils_ap(
			A2($author$project$Components$NoaManagement$ToSendPage$viewReopenedFromCallout, item.reopenedFromEmail, item.reopenedByName),
			_Utils_ap(
				A2($elm$core$List$map, $author$project$Components$NoaManagement$ToSendPage$viewRecipient, item.recipients),
				A2($author$project$Components$NoaManagement$ToSendPage$hasWarning, $author$project$AuditPb$NoaSendQueueItem_WarningNoAddress, item) ? _List_fromArray(
					[
						$author$project$Components$NoaManagement$ToSendPage$viewWarning('No address')
					]) : _List_Nil)));
};
var $author$project$Components$NoaManagement$ToSendPage$ClickedSkip = function (a) {
	return {$: 'ClickedSkip', a: a};
};
var $author$project$Components$NoaManagement$ToSendPage$viewSkipButton = F2(
	function (model, item) {
		return A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					$author$project$Components$NoaManagement$ToSendPage$ClickedSkip(item.id))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$disabled(
					_Utils_eq(
						model.skipModalItemId,
						$elm$core$Maybe$Just(item.id)) && model.skipModalSubmitting)
				]),
			'Skip');
	});
var $author$project$Components$NoaManagement$ToSendPage$viewTable = F2(
	function (model, itemsPage) {
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (item) {
							return A2(
								$author$project$Ui$V3$Typography$body,
								_List_Nil,
								A2($author$project$Helpers$Date$dateString, model.timezone, item.createdAt));
						},
						heading: $elm$html$Html$text('Date')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (item) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, item.debtorName);
						},
						heading: $elm$html$Html$text('Debtor')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (item) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, item.clientName);
						},
						heading: $elm$html$Html$text('Client')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$NoaManagement$ToSendPage$viewSendTo,
						heading: $elm$html$Html$text('Send to')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$NoaManagement$ToSendPage$viewDocument(model.timezone),
						heading: $elm$html$Html$text('Document')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$rightAligned]),
						content: function (item) {
							return A2(
								$author$project$Ui$V3$Stack$viewHorz,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
										$author$project$Ui$V3$Stack$noWrap
									]),
								_List_fromArray(
									[
										A2($author$project$Components$NoaManagement$ToSendPage$viewSendButton, model, item),
										A2($author$project$Components$NoaManagement$ToSendPage$viewSkipButton, model, item)
									]));
						},
						heading: $elm$html$Html$text('')
					}
					])
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$pagination(
					{currentPage: itemsPage, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$NoaManagement$ToSendPage$SetPageNumber})
				]),
			_List_Nil,
			$author$project$Pagination$entries(itemsPage));
	});
var $author$project$Components$NoaManagement$ToSendPage$view = F2(
	function (data, model) {
		return A2(
			$author$project$Components$NoaManagement$Layout$view,
			{current: $author$project$Components$NoaManagement$Layout$ToSend, onSelectTab: $author$project$Components$NoaManagement$ToSendPage$SelectedTab, sandboxRecipients: data.sandboxRecipients},
			_List_fromArray(
				[
					(!$author$project$Pagination$totalEntries(data.items)) ? $author$project$Components$NoaManagement$ToSendPage$viewEmptyState : A2($author$project$Components$NoaManagement$ToSendPage$viewTable, model, data.items),
					$author$project$Components$NoaManagement$ToSendPage$viewSkipModal(model)
				]));
	});
var $author$project$Components$NoaManagement$ToSendPage$page = $author$project$Forward$Component$forwardComponent(
	{
		init: function (_v0) {
			return _Utils_Tuple2(
				{pageNumber: 1, sendingItemId: $elm$core$Maybe$Nothing, skipModalItemId: $elm$core$Maybe$Nothing, skipModalNote: '', skipModalReason: $elm$core$Maybe$Nothing, skipModalSubmitting: false, timezone: $elm$time$Time$utc},
				$author$project$HubTran$Effect$cmd(
					A2($elm$core$Task$perform, $author$project$Components$NoaManagement$ToSendPage$SetTimezone, $author$project$Helpers$Date$localTimezone)));
		},
		loadData: $author$project$Components$NoaManagement$ToSendPage$loadData,
		update: $author$project$Components$NoaManagement$ToSendPage$update,
		v3ReskinEnabled: true,
		viewLoaded: $author$project$Components$NoaManagement$ToSendPage$view
	});
var $author$project$Components$TermsPage$TermsOfUse = {$: 'TermsOfUse'};
var $author$project$HubTran$Flash$warning = function (msg) {
	return {indefinite: false, level: 'warning', message: msg, position: 'top', time: $elm$core$Maybe$Nothing, title: $elm$core$Maybe$Nothing};
};
var $author$project$Components$TermsPage$init = function (initData) {
	return _Utils_eq(initData.user.termsAgreedToAt, $elm$core$Maybe$Nothing) ? $elm$core$Result$Ok(
		{agreed: false, document: $author$project$Components$TermsPage$TermsOfUse, saving: false, v3Reskin: initData.accountSettings.auditV3ReskinEnabledTopLevel}) : $elm$core$Result$Err(
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$flash(
					$author$project$HubTran$Flash$warning('Terms already accepted. Forwarding to application.')),
					$author$project$HubTran$Effect$load('/')
				])));
};
var $author$project$Components$TermsPage$InitData = F2(
	function (user, accountSettings) {
		return {accountSettings: accountSettings, user: user};
	});
var $author$project$Components$TermsPage$loadInitData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		$author$project$Forward$Lookup$succeed($author$project$Components$TermsPage$InitData)));
var $author$project$Forward$Component$ChildMsg_ = function (a) {
	return {$: 'ChildMsg_', a: a};
};
var $author$project$Forward$Component$DidNotStart_ = function (a) {
	return {$: 'DidNotStart_', a: a};
};
var $author$project$Forward$Component$InitDataLoaded_ = function (a) {
	return {$: 'InitDataLoaded_', a: a};
};
var $author$project$Forward$Component$LoadingInitData_ = {$: 'LoadingInitData_'};
var $author$project$Forward$Component$Started_ = function (a) {
	return {$: 'Started_', a: a};
};
var $author$project$Forward$Component$startupComponent = function (config) {
	return {
		dataEffects: F2(
			function (_v0, _v1) {
				return $author$project$HubTran$Effect$none;
			}),
		init: function (_v2) {
			return _Utils_Tuple2(
				$author$project$Forward$Component$LoadingInitData_,
				A2($author$project$HubTran$Effect$fetchFromCache, $author$project$Forward$Component$InitDataLoaded_, config.loadInitData));
		},
		loadData: function (_v3) {
			return $author$project$Forward$Lookup$fromRemote_INTERNAL_ONLY(
				$author$project$Forward$Remote$Error(
					$author$project$Forward$Remote$Unloadable('Forward.Component.elmComponent: this component does not use loadData, and this message should never be visible anywhere')));
		},
		onUrlChange: $elm$core$Maybe$Nothing,
		update: F3(
			function (_v4, msg, model) {
				if (msg.$ === 'InitDataLoaded_') {
					if (msg.a.$ === 'Ok') {
						var initData = msg.a.a;
						var _v6 = config.init(initData);
						if (_v6.$ === 'Ok') {
							var childModel = _v6.a;
							return _Utils_Tuple2(
								$author$project$Forward$Component$Started_(childModel),
								$author$project$HubTran$Effect$none);
						} else {
							var effect = _v6.a;
							return _Utils_Tuple2(
								$author$project$Forward$Component$DidNotStart_($elm$core$Maybe$Nothing),
								A2($author$project$HubTran$Effect$map, $elm$core$Basics$never, effect));
						}
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							$author$project$Forward$Component$DidNotStart_(
								$elm$core$Maybe$Just(err)),
							$author$project$HubTran$Effect$none);
					}
				} else {
					var childMsg = msg.a;
					if (model.$ === 'Started_') {
						var childModel = model.a;
						return A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Forward$Component$Started_,
							$author$project$HubTran$Effect$map($author$project$Forward$Component$ChildMsg_),
							A2(config.update, childMsg, childModel));
					} else {
						return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					}
				}
			}),
		view: F2(
			function (_v8, model) {
				if (model.$ === 'Started_') {
					var childModel = model.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Forward$Component$ChildMsg_,
						config.view(childModel));
				} else {
					return $author$project$Forward$LoadingView$defaultLoadingView;
				}
			})
	};
};
var $author$project$Components$TermsPage$AgreeServerResponse = function (a) {
	return {$: 'AgreeServerResponse', a: a};
};
var $author$project$Components$TermsPage$PrivacyPolicy = {$: 'PrivacyPolicy'};
var $author$project$Components$TermsPage$agreeApiUrl = '/api/users/agreed';
var $author$project$HubTran$InspectableEffect$http = function (request) {
	return $author$project$HubTran$InspectableEffect$HttpEffect(
		{
			body: request.body,
			headers: request.headers,
			method: request.method,
			resolver: function (req) {
				var result = request.resolver(req);
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$elm$core$Result$Ok(result));
				} else {
					var e = result.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(e),
						$elm$core$Result$Ok(result));
				}
			},
			timeout: request.timeout,
			url: request.url
		});
};
var $author$project$HubTran$Effect$http = function (request) {
	return $author$project$HubTran$Effect$InspectableEffect(
		$author$project$HubTran$InspectableEffect$http(request));
};
var $author$project$Helpers$Http$jsonResolver = function (decoder) {
	return function (response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.statusCode));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					A2($elm$core$Basics$composeR, $elm$json$Json$Decode$errorToString, $elm$http$Http$BadBody),
					A2($elm$json$Json$Decode$decodeString, decoder, body));
		}
	};
};
var $author$project$Components$LegacyReact$LegacyReactPorts$updateAuthUser = _Platform_outgoingPort('updateAuthUser', $elm$core$Basics$identity);
var $author$project$Components$TermsPage$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnAgreeChanged':
				var newAgreed = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{agreed: newAgreed}),
					$author$project$HubTran$Effect$none);
			case 'ShowTerms':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{document: $author$project$Components$TermsPage$TermsOfUse}),
					$author$project$HubTran$Effect$none);
			case 'ShowPrivacy':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{document: $author$project$Components$TermsPage$PrivacyPolicy}),
					$author$project$HubTran$Effect$none);
			case 'AgreeToTerms':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{saving: true}),
					A2(
						$author$project$HubTran$Effect$map,
						$author$project$Components$TermsPage$AgreeServerResponse,
						$author$project$HubTran$Effect$http(
							{
								body: $elm$core$Maybe$Nothing,
								headers: _List_Nil,
								method: 'POST',
								resolver: $author$project$Helpers$Http$jsonResolver(
									A2($elm$json$Json$Decode$field, 'user', $elm$json$Json$Decode$value)),
								timeout: $elm$core$Maybe$Nothing,
								url: $author$project$Components$TermsPage$agreeApiUrl
							})));
			default:
				if (msg.a.$ === 'Ok') {
					var updatedUserJson = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$cmd(
							$author$project$Components$LegacyReact$LegacyReactPorts$updateAuthUser(updatedUserJson)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{saving: false}),
						$author$project$HubTran$Effect$none);
				}
		}
	});
var $author$project$Components$TermsPage$AgreeToTerms = {$: 'AgreeToTerms'};
var $author$project$Components$TermsPage$OnAgreeChanged = function (a) {
	return {$: 'OnAgreeChanged', a: a};
};
var $author$project$Components$TermsPage$ShowPrivacy = {$: 'ShowPrivacy'};
var $author$project$Components$TermsPage$ShowTerms = {$: 'ShowTerms'};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $author$project$Helpers$Html$onClickPreventDefault = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Components$TermsPage$privacyPolicyUrl = 'https://triumph.io/privacy-policy/';
var $author$project$Components$TermsPage$termsOfUseUrl = 'https://triumph.io/terms-of-service/';
var $author$project$Components$TermsPage$termsDocumentUrl = function (document) {
	if (document.$ === 'TermsOfUse') {
		return $author$project$Components$TermsPage$termsOfUseUrl;
	} else {
		return $author$project$Components$TermsPage$privacyPolicyUrl;
	}
};
var $author$project$Components$TermsPage$legacyView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row'),
				$elm$html$Html$Attributes$class('general-container'),
				$elm$html$Html$Attributes$class('reply-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-2'),
						$elm$html$Html$Attributes$class('column')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Helpers$String$nbsp)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-6'),
						$elm$html$Html$Attributes$class('column'),
						$elm$html$Html$Attributes$class('end'),
						$elm$html$Html$Attributes$class('terms__container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('View and agree to the TriumphPay Audit terms')
							])),
						A2(
						$elm$html$Html$iframe,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('terms__viewer'),
								$elm$html$Html$Attributes$src(
								$author$project$Components$TermsPage$termsDocumentUrl(model.document))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-10'),
										$elm$html$Html$Attributes$class('column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$checked(model.agreed),
														$elm$html$Html$Events$onCheck($author$project$Components$TermsPage$OnAgreeChanged),
														$elm$html$Html$Attributes$disabled(model.saving)
													]),
												_List_Nil),
												$elm$html$Html$text(' I have read and agree to the '),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$author$project$Helpers$Html$onClickPreventDefault($author$project$Components$TermsPage$ShowTerms)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Terms of Use')
													])),
												$elm$html$Html$text(' and '),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$author$project$Helpers$Html$onClickPreventDefault($author$project$Components$TermsPage$ShowPrivacy)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Privacy Policy')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-10'),
										$elm$html$Html$Attributes$class('column')
									]),
								_List_fromArray(
									[
										$author$project$Components$LegacyReact$DisablingButton$view(
										{
											disabled: (!model.agreed) || model.saving,
											disabledClasses: $elm$core$Maybe$Nothing,
											disabledText: model.saving ? 'Please wait...' : 'Agree to the terms to continue',
											enabledClasses: _List_fromArray(
												['button--progress']),
											onClick: $author$project$Components$LegacyReact$DisablingButton$ElmMessage($author$project$Components$TermsPage$AgreeToTerms),
											text: 'Agree and Continue'
										})
									]))
							]))
					]))
			]));
};
var $author$project$Ui$V3$Button$ButtonColor = function (a) {
	return {$: 'ButtonColor', a: a};
};
var $author$project$Ui$V3$Button$buttonColor = $author$project$Ui$V3$Button$ButtonColor;
var $author$project$Ui$V3$Checkbox$DisabledAttribute = function (a) {
	return {$: 'DisabledAttribute', a: a};
};
var $author$project$Ui$V3$Checkbox$disabled = $author$project$Ui$V3$Checkbox$DisabledAttribute;
var $author$project$Ui$V3$Stack$PaddingVertHorz = F2(
	function (a, b) {
		return {$: 'PaddingVertHorz', a: a, b: b};
	});
var $author$project$Ui$V3$Stack$paddingVertHorz = F2(
	function (v, h) {
		return $author$project$Ui$V3$Stack$PaddingAttribute(
			A2($author$project$Ui$V3$Stack$PaddingVertHorz, v, h));
	});
var $author$project$Ui$V3$Stack$spaceXLarge = $author$project$Ui$V3$Stack$SpatialUnit('xl');
var $author$project$Ui$V3$Stack$spaceXXLarge = $author$project$Ui$V3$Stack$SpatialUnit('xxl');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $author$project$Ui$V3$Icon$checkboxChecked16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$width('16'),
						$elm$svg$Svg$Attributes$height('16'),
						$elm$svg$Svg$Attributes$rx('2'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M3.5 8.75L6.6256 11.2505C6.96379 11.521 7.46019 11.4497 7.70855 11.0949L12.5 4.25'),
						$elm$svg$Svg$Attributes$stroke('var(--color-icon-neutral-inverted)'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$class('v3__icon-checkbox-checked-border')
					]),
				_List_Nil)
			])));
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$Ui$V3$Icon$checkboxUnchecked16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('1'),
						$elm$svg$Svg$Attributes$y('1'),
						$elm$svg$Svg$Attributes$width('14'),
						$elm$svg$Svg$Attributes$height('14'),
						$elm$svg$Svg$Attributes$rx('1'),
						$elm$svg$Svg$Attributes$fill('var(--color-background-neutral-container)'),
						$elm$svg$Svg$Attributes$class('v3__icon-checkbox-unchecked-fill')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('1'),
						$elm$svg$Svg$Attributes$y('1'),
						$elm$svg$Svg$Attributes$width('14'),
						$elm$svg$Svg$Attributes$height('14'),
						$elm$svg$Svg$Attributes$rx('1'),
						$elm$svg$Svg$Attributes$stroke('var(--color-border-neutral-default)'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$class('v3__icon-checkbox-unchecked-border')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Checkbox$defaultAttributes = {disabled: false, error: false, extraPadding: 0, stopPropagation: false};
var $author$project$Ui$V3$Checkbox$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'DisabledAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{disabled: value});
				case 'ErrorAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{error: value});
				case 'StopPropagationAttribute':
					return _Utils_update(
						acc,
						{stopPropagation: true});
				default:
					var value = a.a;
					return _Utils_update(
						acc,
						{extraPadding: value});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Checkbox$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Checkbox$viewInternal = F2(
	function (_v0, attributes) {
		var label = _v0.label;
		var onCheck = _v0.onCheck;
		var checked = _v0.checked;
		var computedAttributes = $author$project$Ui$V3$Checkbox$computeAttributes(attributes);
		var checkboxIcon = checked ? $author$project$Ui$V3$Icon$checkboxChecked16 : $author$project$Ui$V3$Icon$checkboxUnchecked16;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(computedAttributes.stopPropagation, onCheck);
			if (_v2.b.$ === 'Just') {
				if (_v2.a) {
					var enabledOnCheck = _v2.b.a;
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Events$custom,
								'click',
								$elm$json$Json$Decode$succeed(
									{
										message: enabledOnCheck(!checked),
										preventDefault: true,
										stopPropagation: true
									}))
							]),
						_List_Nil);
				} else {
					var enabledOnCheck = _v2.b.a;
					return _Utils_Tuple2(
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$Events$onCheck(enabledOnCheck)
							]));
				}
			} else {
				var _v3 = _v2.b;
				return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var labelAttrs = _v1.a;
		var inputAttrs = _v1.b;
		return A2(
			$elm$html$Html$label,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('v3__checkbox', true),
							_Utils_Tuple2('v3__checkbox--disabled', computedAttributes.disabled)
						])),
				labelAttrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v3__checkbox-input'),
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$disabled(computedAttributes.disabled),
								$elm$html$Html$Attributes$checked(checked)
							]),
						inputAttrs),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('v3__checkbox-icon', true),
									_Utils_Tuple2('v3__checkbox-icon--disabled', computedAttributes.disabled),
									_Utils_Tuple2('v3__checkbox-icon--error', computedAttributes.error)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__checkbox__extra-padding'),
									A2(
									$elm$html$Html$Attributes$style,
									'padding',
									$author$project$Ui$V3$Helpers$Html$px(computedAttributes.extraPadding))
								]),
							_List_Nil),
							A2($author$project$Ui$V3$Icon$view16, _List_Nil, checkboxIcon)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__checkbox-label-text')
						]),
					_List_fromArray(
						[label]))
				]));
	});
var $author$project$Ui$V3$Checkbox$view = F2(
	function (_v0, attributes) {
		var label = _v0.label;
		var onCheck = _v0.onCheck;
		var checked = _v0.checked;
		return A2(
			$author$project$Ui$V3$Checkbox$viewInternal,
			{
				checked: checked,
				label: label,
				onCheck: $elm$core$Maybe$Just(onCheck)
			},
			attributes);
	});
var $author$project$Components$TermsPage$v3ReskinView = function (model) {
	var buttonText = model.saving ? 'Please wait…' : 'Agree to terms to continue';
	return $author$project$Helpers$Html$v3ReskinContainer(
		A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Stack$paddingVertHorz, $author$project$Ui$V3$Stack$spaceXLarge, $author$project$Ui$V3$Stack$spaceXXLarge),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
					$author$project$Ui$V3$Stack$crossAxisLeft,
					$author$project$Ui$V3$Stack$class('audit_v3_reskin__activate_container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('View and agree to the terms and conditions')
						])),
					A2(
					$elm$html$Html$iframe,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin', '32px 0 0'),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							A2($elm$html$Html$Attributes$style, 'width', '827px'),
							A2($elm$html$Html$Attributes$style, 'height', '40vh'),
							A2($elm$html$Html$Attributes$style, 'border', '1px solid black'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'scroll'),
							$elm$html$Html$Attributes$src(
							$author$project$Components$TermsPage$termsDocumentUrl(model.document))
						]),
					_List_Nil),
					A2(
					$author$project$Ui$V3$Checkbox$view,
					{
						checked: model.agreed,
						label: A2(
							$elm$html$Html$span,
							_List_fromArray(
								[$author$project$Ui$V3$Typography$xSmallBodyClass]),
							_List_fromArray(
								[
									$elm$html$Html$text(' I have read and agree to the '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Helpers$Html$onClickPreventDefault($author$project$Components$TermsPage$ShowTerms),
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Terms of Use')
										])),
									$elm$html$Html$text(' and '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Helpers$Html$onClickPreventDefault($author$project$Components$TermsPage$ShowPrivacy),
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Privacy Policy')
										]))
								])),
						onCheck: $author$project$Components$TermsPage$OnAgreeChanged
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Checkbox$disabled(model.saving)
						])),
					A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$TermsPage$AgreeToTerms)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$disabled((!model.agreed) || model.saving),
							$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorBrand),
							$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantPrimary)
						]),
					buttonText)
				])));
};
var $author$project$Components$TermsPage$view = function (model) {
	return model.v3Reskin ? $author$project$Components$TermsPage$v3ReskinView(model) : $author$project$Components$TermsPage$legacyView(model);
};
var $author$project$Components$TermsPage$page = $author$project$Forward$Component$startupComponent(
	{init: $author$project$Components$TermsPage$init, loadInitData: $author$project$Components$TermsPage$loadInitData, update: $author$project$Components$TermsPage$update, view: $author$project$Components$TermsPage$view});
var $author$project$Sanitized$Unsanitized = function (a) {
	return {$: 'Unsanitized', a: a};
};
var $author$project$Sanitized$raw = function (a) {
	return $author$project$Sanitized$Unsanitized(a);
};
var $author$project$Components$SettingsPage$Shared$Section$Account = {$: 'Account'};
var $author$project$Main$ActivityPageRequest = {$: 'ActivityPageRequest'};
var $author$project$Main$BrokerBillingRequirementsPageRequest = {$: 'BrokerBillingRequirementsPageRequest'};
var $author$project$Components$SettingsPage$Shared$Section$CarrierDocuments = function (a) {
	return {$: 'CarrierDocuments', a: a};
};
var $author$project$Main$ClientSubmissionInvoicePageRequest = F4(
	function (a, b, c, d) {
		return {$: 'ClientSubmissionInvoicePageRequest', a: a, b: b, c: c, d: d};
	});
var $author$project$Main$ClientSubmissionPageRequest = F4(
	function (a, b, c, d) {
		return {$: 'ClientSubmissionPageRequest', a: a, b: b, c: c, d: d};
	});
var $author$project$Main$ClientSubmissionReviewPageRequest = F2(
	function (a, b) {
		return {$: 'ClientSubmissionReviewPageRequest', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Shared$Section$Contacts = {$: 'Contacts'};
var $author$project$Main$DebtorChangesPageRequest = function (a) {
	return {$: 'DebtorChangesPageRequest', a: a};
};
var $author$project$Main$DebtorChangesTemplatePageRequest = function (a) {
	return {$: 'DebtorChangesTemplatePageRequest', a: a};
};
var $author$project$Components$SettingsPage$Shared$Section$Debtors = {$: 'Debtors'};
var $author$project$Main$DocumentBatchReviewPageRequest = F2(
	function (a, b) {
		return {$: 'DocumentBatchReviewPageRequest', a: a, b: b};
	});
var $author$project$Main$DocumentGroupReviewPageRequest = F2(
	function (a, b) {
		return {$: 'DocumentGroupReviewPageRequest', a: a, b: b};
	});
var $author$project$Main$DocumentReviewPageRequest = F2(
	function (a, b) {
		return {$: 'DocumentReviewPageRequest', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Shared$Section$DocumentTypes = {$: 'DocumentTypes'};
var $author$project$Main$DocumentsViewerPopoutPageRequest = {$: 'DocumentsViewerPopoutPageRequest'};
var $author$project$Components$SettingsPage$UserLayout$EditMode = function (a) {
	return {$: 'EditMode', a: a};
};
var $author$project$Main$EmailMergePageRequest = {$: 'EmailMergePageRequest'};
var $author$project$Main$EmailMessageSearchPageRequest = function (a) {
	return {$: 'EmailMessageSearchPageRequest', a: a};
};
var $author$project$Components$SettingsPage$UserLayout$EnableMode = function (a) {
	return {$: 'EnableMode', a: a};
};
var $author$project$Components$SettingsPage$Shared$Section$Exceptions = {$: 'Exceptions'};
var $author$project$Components$SettingsPage$Shared$Section$FactorClientPortal = {$: 'FactorClientPortal'};
var $author$project$Main$FactorInvoiceAuditBatchGroupingPageRequest = F2(
	function (a, b) {
		return {$: 'FactorInvoiceAuditBatchGroupingPageRequest', a: a, b: b};
	});
var $author$project$Main$FactorInvoiceAuditBatchPageRequest = F4(
	function (a, b, c, d) {
		return {$: 'FactorInvoiceAuditBatchPageRequest', a: a, b: b, c: c, d: d};
	});
var $author$project$Main$FactorInvoiceAuditPageRequest = F3(
	function (a, b, c) {
		return {$: 'FactorInvoiceAuditPageRequest', a: a, b: b, c: c};
	});
var $author$project$Main$ForwardingHasMovedPageRequest = {$: 'ForwardingHasMovedPageRequest'};
var $author$project$Main$HelpPageRequest = {$: 'HelpPageRequest'};
var $author$project$Components$SettingsPage$Shared$Section$Integrations = {$: 'Integrations'};
var $author$project$Main$LtlConfirmRequest = F3(
	function (a, b, c) {
		return {$: 'LtlConfirmRequest', a: a, b: b, c: c};
	});
var $author$project$Main$LtlHeldSubmissionsPageRequest = {$: 'LtlHeldSubmissionsPageRequest'};
var $author$project$Main$MyClientsOverviewPageRequest = function (a) {
	return {$: 'MyClientsOverviewPageRequest', a: a};
};
var $author$project$Main$NewDashboardRequest = {$: 'NewDashboardRequest'};
var $author$project$Components$SettingsPage$UserLayout$NewMode = {$: 'NewMode'};
var $author$project$Components$SettingsPage$Shared$Section$NextGenAudit = {$: 'NextGenAudit'};
var $author$project$Main$NoaManagementSentPageRequest = function (a) {
	return {$: 'NoaManagementSentPageRequest', a: a};
};
var $author$project$Main$NoaManagementSkippedPageRequest = {$: 'NoaManagementSkippedPageRequest'};
var $author$project$Main$NoaManagementToSendPageRequest = {$: 'NoaManagementToSendPageRequest'};
var $author$project$Main$NonInvoiceConfirmRequest = F3(
	function (a, b, c) {
		return {$: 'NonInvoiceConfirmRequest', a: a, b: b, c: c};
	});
var $author$project$Main$OktaLoginPageRequest = F4(
	function (a, b, c, d) {
		return {$: 'OktaLoginPageRequest', a: a, b: b, c: c, d: d};
	});
var $author$project$Components$SettingsPage$Shared$Section$PodDefinition = {$: 'PodDefinition'};
var $author$project$Components$ActivityBrowser$FiltersView$QueryParams = function (activityType) {
	return function (userId) {
		return function (startDate) {
			return function (endDate) {
				return function (debtorId) {
					return function (carrierId) {
						return function (customerId) {
							return function (carrierDropdownId) {
								return function (customerDropdownId) {
									return function (invoiceNumOrLoadId) {
										return function (page) {
											return {activityType: activityType, carrierDropdownId: carrierDropdownId, carrierId: carrierId, customerDropdownId: customerDropdownId, customerId: customerId, debtorId: debtorId, endDate: endDate, invoiceNumOrLoadId: invoiceNumOrLoadId, page: page, startDate: startDate, userId: userId};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$ReadonlyFactorInvoicePageRequest = function (a) {
	return {$: 'ReadonlyFactorInvoicePageRequest', a: a};
};
var $author$project$Components$SettingsPage$Shared$Section$ScraperStatus = {$: 'ScraperStatus'};
var $author$project$Main$SettingsCarrierRequest = function (a) {
	return {$: 'SettingsCarrierRequest', a: a};
};
var $author$project$Main$SettingsCarriersRequest = {$: 'SettingsCarriersRequest'};
var $author$project$Main$SettingsCustomerRequest = function (a) {
	return {$: 'SettingsCustomerRequest', a: a};
};
var $author$project$Main$SettingsCustomersRequest = {$: 'SettingsCustomersRequest'};
var $author$project$Main$SettingsDebtorRequest = function (a) {
	return {$: 'SettingsDebtorRequest', a: a};
};
var $author$project$Main$SettingsPageRequest = function (a) {
	return {$: 'SettingsPageRequest', a: a};
};
var $author$project$Main$SettingsReferenceFieldsRequest = {$: 'SettingsReferenceFieldsRequest'};
var $author$project$Main$SettingsReportsRequest = {$: 'SettingsReportsRequest'};
var $author$project$Main$SettingsRulesRequest = {$: 'SettingsRulesRequest'};
var $author$project$Main$SettingsUserRequest = function (a) {
	return {$: 'SettingsUserRequest', a: a};
};
var $author$project$Main$SettingsUsersRequest = {$: 'SettingsUsersRequest'};
var $author$project$Main$SettingsVerificationsRequest = {$: 'SettingsVerificationsRequest'};
var $author$project$Main$TermsPageRequest = {$: 'TermsPageRequest'};
var $author$project$Main$ToBeScrapedLoadsPageRequest = function (a) {
	return {$: 'ToBeScrapedLoadsPageRequest', a: a};
};
var $author$project$Main$VerificationBatchPageRequest = F2(
	function (a, b) {
		return {$: 'VerificationBatchPageRequest', a: a, b: b};
	});
var $elm$url$Url$Parser$Internal$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return $elm$url$Url$Parser$Internal$Parser(
			function (dict) {
				return func(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Dict$get, key, dict)));
			});
	});
var $author$project$Main$customParam = F2(
	function (field, f) {
		return A2(
			$elm$url$Url$Parser$Query$custom,
			field,
			A2($elm$core$Basics$composeR, $elm$core$List$head, f));
	});
var $elm$core$Result$toMaybe = function (result) {
	if (result.$ === 'Ok') {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$dateParam = function (name) {
	return A2(
		$author$project$Main$customParam,
		name,
		$elm$core$Maybe$andThen(
			A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm$core$Result$toMaybe)));
};
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Main$parseFactorBrokerId = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen($elm$core$String$toInt),
				$elm$core$Maybe$map($author$project$Domain$FactorBrokerId$fromInt))));
};
var $author$project$Main$parseTmsCarrierId = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen($elm$core$String$toInt),
				$elm$core$Maybe$map($author$project$Domain$TmsCarrierId$fromInt))));
};
var $author$project$Main$parseTmsCustomerId = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen($elm$core$String$toInt),
				$elm$core$Maybe$map($author$project$Domain$TmsCustomerId$fromInt))));
};
var $author$project$Main$parseUserId = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		function (values) {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Domain$UserId$fromInt,
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$String$toInt,
					$elm$core$List$head(values)));
		});
};
var $elm$url$Url$Parser$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {frag: frag, params: params, unvisited: unvisited, value: value, visited: visited};
	});
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0.a;
	return $elm$url$Url$Parser$Parser(
		function (_v1) {
			var value = _v1.value;
			var frag = _v1.frag;
			var params = _v1.params;
			var unvisited = _v1.unvisited;
			var visited = _v1.visited;
			return _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					visited,
					unvisited,
					params,
					frag,
					value(
						queryParser(params)))
				]);
		});
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0.a;
		var parseAfter = _v1.a;
		return $elm$url$Url$Parser$Parser(
			function (state) {
				return A2(
					$elm$core$List$concatMap,
					parseAfter,
					parseBefore(state));
			});
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return $elm$url$Url$Parser$Parser(
		function (_v0) {
			var value = _v0.value;
			var frag = _v0.frag;
			var params = _v0.params;
			var unvisited = _v0.unvisited;
			var visited = _v0.visited;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				return _Utils_eq(next, str) ? _List_fromArray(
					[
						A5(
						$elm$url$Url$Parser$State,
						A2($elm$core$List$cons, next, visited),
						rest,
						params,
						frag,
						value)
					]) : _List_Nil;
			}
		});
};
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Main$activityArguments = A2(
	$elm$url$Url$Parser$questionMark,
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											$elm$url$Url$Parser$s('activity'),
											$elm$url$Url$Parser$Query$string('activityType')),
										$author$project$Main$parseUserId('userId')),
									$author$project$Main$dateParam('startDate')),
								$author$project$Main$dateParam('endDate')),
							$author$project$Main$parseFactorBrokerId('debtorId')),
						$author$project$Main$parseTmsCarrierId('carrierId')),
					$author$project$Main$parseTmsCustomerId('customerId')),
				$author$project$Main$parseTmsCarrierId('carrierDropdownId')),
			$author$project$Main$parseTmsCustomerId('customerDropdownId')),
		$elm$url$Url$Parser$Query$string('invoiceNumOrLoadId')),
	$elm$url$Url$Parser$Query$int('page'));
var $author$project$Main$boolParam = function (name) {
	var boolParamHelp = function (values) {
		var _v0 = $elm$core$List$head(values);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var value = _v0.a;
			switch (value) {
				case 'true':
					return $elm$core$Maybe$Just(true);
				case 'false':
					return $elm$core$Maybe$Just(false);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}
	};
	return A2($elm$url$Url$Parser$Query$custom, name, boolParamHelp);
};
var $author$project$Main$ActivityPageRequestWithArguments = function (a) {
	return {$: 'ActivityPageRequestWithArguments', a: a};
};
var $author$project$Main$buildActivityRequest = function (queryParams) {
	return _Utils_eq(queryParams, $author$project$Components$ActivityBrowser$FiltersView$emptyQueryParams) ? $author$project$Main$ActivityPageRequest : $author$project$Main$ActivityPageRequestWithArguments(queryParams);
};
var $author$project$Domain$DashboardFilters$DashboardFilters = function (tmsCarrierIds) {
	return function (factorBrokerIds) {
		return function (customers) {
			return function (labelFilters) {
				return function (categories) {
					return function (startDate) {
						return function (endDate) {
							return function (startDateTime) {
								return function (endDateTime) {
									return function (rangeType) {
										return function (dashboardMode) {
											return function (dashboardSortBy) {
												return function (timezoneName) {
													return function (exceptions) {
														return function (reskinToggle) {
															return {categories: categories, customers: customers, dashboardMode: dashboardMode, dashboardSortBy: dashboardSortBy, endDate: endDate, endDateTime: endDateTime, exceptions: exceptions, factorBrokerIds: factorBrokerIds, labelFilters: labelFilters, rangeType: rangeType, reskinToggle: reskinToggle, startDate: startDate, startDateTime: startDateTime, timezoneName: timezoneName, tmsCarrierIds: tmsCarrierIds};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$DashboardRequestWithArguments = F5(
	function (a, b, c, d, e) {
		return {$: 'DashboardRequestWithArguments', a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Main$buildDashboardRequest = function (queue_) {
	return function (tmsCarrierIds) {
		return function (factorBrokerIds) {
			return function (customers) {
				return function (selectedFilters) {
					return function (negatedFilters) {
						return function (categoryFilters) {
							return function (activePage) {
								return function (inFlowMode) {
									return function (startDate) {
										return function (endDate) {
											return function (startDateTime) {
												return function (endDateTime) {
													return function (rangeType) {
														return function (dashboardMode) {
															return function (sortBy) {
																return function (timezoneName) {
																	return function (exceptions) {
																		var flowModeWithDefault = A2($elm$core$Maybe$withDefault, false, inFlowMode);
																		var cleanList = $elm$core$Maybe$withDefault(_List_Nil);
																		var labelFilters_ = A2(
																			$elm$core$List$append,
																			cleanList(selectedFilters),
																			cleanList(negatedFilters));
																		var dashboardFilterState = function () {
																			var _v0 = _Utils_Tuple2(
																				_Utils_Tuple2(tmsCarrierIds, selectedFilters),
																				_Utils_Tuple2(negatedFilters, dashboardMode));
																			if ((((!_v0.a.a.b) && (_v0.a.b.$ === 'Nothing')) && (_v0.b.a.$ === 'Nothing')) && (_v0.b.b.$ === 'DashboardModeAll')) {
																				var _v1 = _v0.a;
																				var _v2 = _v1.b;
																				var _v3 = _v0.b;
																				var _v4 = _v3.a;
																				var _v5 = _v3.b;
																				return $elm$core$Maybe$Nothing;
																			} else {
																				return $elm$core$Maybe$Just(
																					$author$project$Sanitized$raw(
																						$author$project$Domain$DashboardFilters$DashboardFilters(tmsCarrierIds)(factorBrokerIds)(customers)(labelFilters_)(categoryFilters)(startDate)(endDate)(startDateTime)(endDateTime)(rangeType)(dashboardMode)(sortBy)(timezoneName)(exceptions)($elm$core$Maybe$Nothing)));
																			}
																		}();
																		var actualPage = A2($elm$core$Maybe$withDefault, 1, activePage);
																		return A5(
																			$author$project$Main$DashboardRequestWithArguments,
																			queue_,
																			dashboardFilterState,
																			actualPage,
																			flowModeWithDefault,
																			$author$project$Sanitized$raw(dashboardMode));
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$BlankPageRequest = {$: 'BlankPageRequest'};
var $author$project$Main$CarrierInvoiceAuditPageRequest = F5(
	function (a, b, c, d, e) {
		return {$: 'CarrierInvoiceAuditPageRequest', a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Main$carrierInvoiceAuditPageRequest = F5(
	function (carrierInvoiceId, maybeLoadStateId, maybeEmailMessageId, maybeReplyEmailId, maybeOnDone) {
		if (maybeLoadStateId.$ === 'Just') {
			var loadStateId = maybeLoadStateId.a;
			return A5($author$project$Main$CarrierInvoiceAuditPageRequest, carrierInvoiceId, loadStateId, maybeEmailMessageId, maybeReplyEmailId, maybeOnDone);
		} else {
			return $author$project$Main$BlankPageRequest;
		}
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return $elm$url$Url$Parser$Parser(
			function (_v0) {
				var value = _v0.value;
				var frag = _v0.frag;
				var params = _v0.params;
				var unvisited = _v0.unvisited;
				var visited = _v0.visited;
				if (!unvisited.b) {
					return _List_Nil;
				} else {
					var next = unvisited.a;
					var rest = unvisited.b;
					var _v2 = stringToSomething(next);
					if (_v2.$ === 'Just') {
						var nextValue = _v2.a;
						return _List_fromArray(
							[
								A5(
								$elm$url$Url$Parser$State,
								A2($elm$core$List$cons, next, visited),
								rest,
								params,
								frag,
								value(nextValue))
							]);
					} else {
						return _List_Nil;
					}
				}
			});
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var value = _v0.value;
		var frag = _v0.frag;
		var params = _v0.params;
		var unvisited = _v0.unvisited;
		var visited = _v0.visited;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0.a;
		return $elm$url$Url$Parser$Parser(
			function (_v1) {
				var value = _v1.value;
				var frag = _v1.frag;
				var params = _v1.params;
				var unvisited = _v1.unvisited;
				var visited = _v1.visited;
				return A2(
					$elm$core$List$map,
					$elm$url$Url$Parser$mapState(value),
					parseArg(
						A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
			});
	});
var $author$project$Main$clientSubmissionEmail = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('client_submission'),
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('email'),
		A2($elm$url$Url$Parser$map, $author$project$Domain$EmailMessageId$fromInt, $elm$url$Url$Parser$int)));
var $author$project$Domain$CategoryFilter$SelectableCategoryFilter = F3(
	function (category, selected, excluded) {
		return {category: category, excluded: excluded, selected: selected};
	});
var $author$project$Domain$CategoryFilter$CategoryFilter = F2(
	function (name, labels) {
		return {labels: labels, name: name};
	});
var $author$project$Domain$CategoryFilter$decode = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Domain$CategoryFilter$CategoryFilter,
	A2($elm$json$Json$Decode$field, 'category', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $author$project$Domain$CategoryFilter$categorySelectionDecoder = $elm$json$Json$Decode$list(
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Domain$CategoryFilter$SelectableCategoryFilter,
		$author$project$Domain$CategoryFilter$decode,
		A2(
			$elm$json$Json$Decode$field,
			'label',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Set$fromList,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
		A2(
			$elm$json$Json$Decode$field,
			'excluded',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Set$fromList,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed(_List_Nil)
						]))))));
var $author$project$Domain$CategoryFilter$fromQueryString = function (categoryParam) {
	var categoriesJson = A2($elm$json$Json$Decode$decodeString, $author$project$Domain$CategoryFilter$categorySelectionDecoder, categoryParam);
	if (categoriesJson.$ === 'Ok') {
		var categories = categoriesJson.a;
		return categories;
	} else {
		return _List_Nil;
	}
};
var $author$project$Main$categoryQueryParser = function (name) {
	var maybeStringToCategoryFilter = function (values) {
		var _v0 = $elm$core$List$head(values);
		if (_v0.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var value = _v0.a;
			return $author$project$Domain$CategoryFilter$fromQueryString(value);
		}
	};
	return A2($elm$url$Url$Parser$Query$custom, name, maybeStringToCategoryFilter);
};
var $author$project$AuditPb$DashboardModeIndex = {$: 'DashboardModeIndex'};
var $author$project$AuditPb$allDashboardMode = _List_fromArray(
	[$author$project$AuditPb$DashboardModeAll, $author$project$AuditPb$DashboardModeIndex, $author$project$AuditPb$DashboardModeAudit]);
var $author$project$AuditPb$dashboardModeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$dashboardModeToString(v),
				v);
		},
		$author$project$AuditPb$allDashboardMode));
var $author$project$AuditPb$dashboardModeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$dashboardModeDict);
};
var $author$project$Domain$DashboardMode$fromString = function (string) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$AuditPb$DashboardModeAll,
		$author$project$AuditPb$dashboardModeFromString(string));
};
var $author$project$Main$dashboardModeQueryParser = function (name) {
	var maybeStringToDashboardMode = function (values) {
		var _v0 = $elm$core$List$head(values);
		if (_v0.$ === 'Nothing') {
			return $author$project$AuditPb$DashboardModeAll;
		} else {
			var value = _v0.a;
			return $author$project$Domain$DashboardMode$fromString(value);
		}
	};
	return A2($elm$url$Url$Parser$Query$custom, name, maybeStringToDashboardMode);
};
var $author$project$Main$dateTimeParam = function (name) {
	return A2(
		$author$project$Main$customParam,
		name,
		$elm$core$Maybe$andThen(
			A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, $elm$core$Result$toMaybe)));
};
var $author$project$AuditPb$DashboardSortByOrderAsc = {$: 'DashboardSortByOrderAsc'};
var $author$project$AuditPb$QueueDateDelivered = {$: 'QueueDateDelivered'};
var $author$project$Domain$QueueDate$default = $author$project$AuditPb$QueueDateDelivered;
var $author$project$Domain$DashboardSortBy$default = {
	name: $author$project$Domain$QueueDate$toString($author$project$Domain$QueueDate$default),
	order: $author$project$AuditPb$DashboardSortByOrderAsc
};
var $author$project$Domain$DashboardFilters$empty = {categories: _List_Nil, customers: _List_Nil, dashboardMode: $author$project$AuditPb$DashboardModeAll, dashboardSortBy: $author$project$Domain$DashboardSortBy$default, endDate: $elm$core$Maybe$Nothing, endDateTime: $elm$core$Maybe$Nothing, exceptions: _List_Nil, factorBrokerIds: _List_Nil, labelFilters: _List_Nil, rangeType: $author$project$Domain$QueueDate$default, reskinToggle: $elm$core$Maybe$Nothing, startDate: $elm$core$Maybe$Nothing, startDateTime: $elm$core$Maybe$Nothing, timezoneName: $elm$core$Maybe$Nothing, tmsCarrierIds: _List_Nil};
var $author$project$AuditPb$QueueDateEstimatedDue = {$: 'QueueDateEstimatedDue'};
var $author$project$AuditPb$QueueDateLastContact = {$: 'QueueDateLastContact'};
var $author$project$AuditPb$QueueDateReceived = {$: 'QueueDateReceived'};
var $author$project$AuditPb$QueueDateReviewOn = {$: 'QueueDateReviewOn'};
var $author$project$AuditPb$QueueDatePayment = {$: 'QueueDatePayment'};
var $author$project$AuditPb$QueueDateProcessed = {$: 'QueueDateProcessed'};
var $author$project$AuditPb$QueueDateUnsorted = {$: 'QueueDateUnsorted'};
var $author$project$AuditPb$allQueueDate = _List_fromArray(
	[$author$project$AuditPb$QueueDateUnsorted, $author$project$AuditPb$QueueDateDelivered, $author$project$AuditPb$QueueDateReceived, $author$project$AuditPb$QueueDateLastContact, $author$project$AuditPb$QueueDateEstimatedDue, $author$project$AuditPb$QueueDateReviewOn, $author$project$AuditPb$QueueDateProcessed, $author$project$AuditPb$QueueDatePayment]);
var $author$project$AuditPb$queueDateDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$queueDateToString(v),
				v);
		},
		$author$project$AuditPb$allQueueDate));
var $author$project$AuditPb$queueDateFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$queueDateDict);
};
var $author$project$Domain$QueueDate$fromString = function (name) {
	switch (name) {
		case 'delivered_at':
			return $author$project$AuditPb$QueueDateDelivered;
		case 'received_at':
			return $author$project$AuditPb$QueueDateReceived;
		case 'last_contact_at':
			return $author$project$AuditPb$QueueDateLastContact;
		case 'exceptioned_at':
			return $author$project$AuditPb$QueueDateReceived;
		case 'estimated_due_at':
			return $author$project$AuditPb$QueueDateEstimatedDue;
		case 'createdAt':
			return $author$project$AuditPb$QueueDateReceived;
		case 'reviewOn':
			return $author$project$AuditPb$QueueDateReviewOn;
		case 'deliveredAt':
			return $author$project$AuditPb$QueueDateDelivered;
		case 'exceptioned':
			return $author$project$AuditPb$QueueDateReceived;
		default:
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$AuditPb$QueueDateDelivered,
				$author$project$AuditPb$queueDateFromString(name));
	}
};
var $author$project$Main$maybeRangeTypeString = function (name) {
	var maybeStringToRangeType = function (values) {
		var _v0 = $elm$core$List$head(values);
		if (_v0.$ === 'Nothing') {
			return $author$project$Domain$DashboardFilters$empty.rangeType;
		} else {
			var value = _v0.a;
			return $author$project$Domain$QueueDate$fromString(value);
		}
	};
	return A2($elm$url$Url$Parser$Query$custom, name, maybeStringToRangeType);
};
var $author$project$Main$labelFilters = F2(
	function (toLabelFilter, values) {
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				A2($elm$core$String$slice, 1, -1),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$split(','),
					$elm$core$List$map(toLabelFilter))),
			$elm$core$List$head(values));
	});
var $author$project$Domain$LabelFilter$LabelFilter = F2(
	function (label, state) {
		return {label: label, state: state};
	});
var $author$project$Domain$LabelFilter$negated = function (string) {
	return A2($author$project$Domain$LabelFilter$LabelFilter, string, $author$project$Domain$LabelFilter$Negated);
};
var $author$project$Main$negatedLabelFilters = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		$author$project$Main$labelFilters($author$project$Domain$LabelFilter$negated));
};
var $author$project$AuditPb$Customer = F2(
	function (name, externalId) {
		return {externalId: externalId, name: name};
	});
var $author$project$AuditPb$customerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'external_id',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'name',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$Customer)));
	});
var $author$project$Domain$Customer$decoder = $author$project$AuditPb$customerDecoder;
var $author$project$Main$parseCustomerNames = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		function (values) {
			var decoder = $elm$json$Json$Decode$list($author$project$Domain$Customer$decoder);
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$Result$toMaybe,
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Decode$decodeString(decoder),
						$elm$core$List$head(values))));
		});
};
var $author$project$Main$parseExceptions = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		$elm$core$List$concatMap(
			$elm$core$String$split(',')));
};
var $author$project$Main$parseFactorBrokerIds = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$concatMap(
				$elm$core$String$split(',')),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filterMap($elm$core$String$toInt),
				$elm$core$List$map($author$project$Domain$FactorBrokerId$fromInt))));
};
var $author$project$Main$parseTmsCarrierIds = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$concatMap(
				$elm$core$String$split(',')),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filterMap($elm$core$String$toInt),
				$elm$core$List$map($author$project$Domain$TmsCarrierId$fromInt))));
};
var $author$project$Components$Dashboard$AvailableQueues$ExceptionQueue = {$: 'ExceptionQueue'};
var $author$project$Components$Dashboard$AvailableQueues$FactorNeedsIndexingQueue = {$: 'FactorNeedsIndexingQueue'};
var $author$project$Components$Dashboard$AvailableQueues$FinalQueue = function (a) {
	return {$: 'FinalQueue', a: a};
};
var $author$project$Components$Dashboard$AvailableQueues$NewQueue = {$: 'NewQueue'};
var $author$project$Components$Dashboard$AvailableQueues$ReadyToAuditQueue = {$: 'ReadyToAuditQueue'};
var $author$project$Components$Dashboard$AvailableQueues$RepliesQueue = {$: 'RepliesQueue'};
var $author$project$Components$Dashboard$AvailableQueues$ReviewQueue = {$: 'ReviewQueue'};
var $author$project$Components$Dashboard$AvailableQueues$Unknown = {$: 'Unknown'};
var $author$project$Components$Dashboard$AvailableQueues$VerifyQueue = {$: 'VerifyQueue'};
var $author$project$Components$Dashboard$AvailableQueues$WaitingQueue = {$: 'WaitingQueue'};
var $author$project$Components$Dashboard$Url$QueueArguments$decode = function (string) {
	switch (string) {
		case 'new':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw($author$project$Components$Dashboard$AvailableQueues$NewQueue));
		case 'indexing':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw($author$project$Components$Dashboard$AvailableQueues$FactorNeedsIndexingQueue));
		case 'ready-to-audit':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw($author$project$Components$Dashboard$AvailableQueues$ReadyToAuditQueue));
		case 'exceptions':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw($author$project$Components$Dashboard$AvailableQueues$ExceptionQueue));
		case 'replies':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw($author$project$Components$Dashboard$AvailableQueues$RepliesQueue));
		case 'waiting':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw($author$project$Components$Dashboard$AvailableQueues$WaitingQueue));
		case 'verify':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw($author$project$Components$Dashboard$AvailableQueues$VerifyQueue));
		case 'review':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw(
					$author$project$Components$Dashboard$AvailableQueues$FinalQueue($author$project$Components$Dashboard$AvailableQueues$Unknown)));
		case 'processed':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw(
					$author$project$Components$Dashboard$AvailableQueues$FinalQueue($author$project$Components$Dashboard$AvailableQueues$Unknown)));
		case 'review-test':
			return $elm$core$Maybe$Just(
				$author$project$Sanitized$raw(
					$author$project$Components$Dashboard$AvailableQueues$FinalQueue($author$project$Components$Dashboard$AvailableQueues$ReviewQueue)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Main$queue = A2($elm$url$Url$Parser$map, $author$project$Components$Dashboard$Url$QueueArguments$decode, $elm$url$Url$Parser$string);
var $author$project$Domain$LabelFilter$selected = function (string) {
	return A2($author$project$Domain$LabelFilter$LabelFilter, string, $author$project$Domain$LabelFilter$Selected);
};
var $author$project$Main$selectedLabelFilters = function (name) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		name,
		$author$project$Main$labelFilters($author$project$Domain$LabelFilter$selected));
};
var $author$project$AuditPb$DashboardSortByOrderDesc = {$: 'DashboardSortByOrderDesc'};
var $author$project$AuditPb$allDashboardSortByOrder = _List_fromArray(
	[$author$project$AuditPb$DashboardSortByOrderAsc, $author$project$AuditPb$DashboardSortByOrderDesc]);
var $author$project$AuditPb$dashboardSortByOrderDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$dashboardSortByOrderToString(v),
				v);
		},
		$author$project$AuditPb$allDashboardSortByOrder));
var $author$project$AuditPb$dashboardSortByOrderFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$dashboardSortByOrderDict);
};
var $author$project$Domain$DashboardSortBy$fromOrderString = function (order) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$AuditPb$DashboardSortByOrderAsc,
		$author$project$AuditPb$dashboardSortByOrderFromString(order));
};
var $author$project$Domain$DashboardSortBy$parseQueryString = function (str) {
	var _v0 = A2($elm$core$String$split, ':', str);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var name = _v0.a;
		var _v1 = _v0.b;
		var order = _v1.a;
		return {
			name: $author$project$Domain$QueueDate$toString(
				$author$project$Domain$QueueDate$fromString(name)),
			order: $author$project$Domain$DashboardSortBy$fromOrderString(order)
		};
	} else {
		return $author$project$Domain$DashboardSortBy$default;
	}
};
var $author$project$Main$sortByParser = function (str) {
	var maybeStringToSortBy = function (values) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Domain$DashboardSortBy$default,
			A2(
				$elm$core$Maybe$map,
				$author$project$Domain$DashboardSortBy$parseQueryString,
				$elm$core$List$head(values)));
	};
	return A2($elm$url$Url$Parser$Query$custom, str, maybeStringToSortBy);
};
var $author$project$Main$dashboardArguments = A2(
	$elm$url$Url$Parser$questionMark,
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											A2(
												$elm$url$Url$Parser$questionMark,
												A2(
													$elm$url$Url$Parser$questionMark,
													A2(
														$elm$url$Url$Parser$questionMark,
														A2(
															$elm$url$Url$Parser$questionMark,
															A2(
																$elm$url$Url$Parser$questionMark,
																A2(
																	$elm$url$Url$Parser$questionMark,
																	$author$project$Main$queue,
																	$author$project$Main$parseTmsCarrierIds('filters[carrierId]')),
																$author$project$Main$parseFactorBrokerIds('filters[factorBrokerId]')),
															$author$project$Main$parseCustomerNames('customers')),
														$author$project$Main$selectedLabelFilters('selectedLabelFilters')),
													$author$project$Main$negatedLabelFilters('negatedLabelFilters')),
												$author$project$Main$categoryQueryParser('categories')),
											$elm$url$Url$Parser$Query$int('page')),
										$author$project$Main$boolParam('inFlowMode')),
									$author$project$Main$dateParam('startDate')),
								$author$project$Main$dateParam('endDate')),
							$author$project$Main$dateTimeParam('startDateTime')),
						$author$project$Main$dateTimeParam('endDateTime')),
					$author$project$Main$maybeRangeTypeString('rangeType')),
				$author$project$Main$dashboardModeQueryParser('dashboardMode')),
			$author$project$Main$sortByParser('sort')),
		$elm$url$Url$Parser$Query$string('timezoneName')),
	$author$project$Main$parseExceptions('exceptions'));
var $elm_community$json_extra$Json$Decode$Extra$datetime = A2(
	$elm$json$Json$Decode$andThen,
	function (dateString) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
		if (_v0.$ === 'Ok') {
			var v = _v0.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$DocumentBatchIdParam = function (a) {
	return {$: 'DocumentBatchIdParam', a: a};
};
var $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$parseIntParam = function (fromInt) {
	return A2($elm$url$Url$Parser$map, fromInt, $elm$url$Url$Parser$int);
};
var $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$documentBatchId = $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$parseIntParam(
	A2($elm$core$Basics$composeL, $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$DocumentBatchIdParam, $author$project$Domain$DocumentBatchId$fromInt));
var $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$EmailMessageIdParam = function (a) {
	return {$: 'EmailMessageIdParam', a: a};
};
var $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$emailId = $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$parseIntParam(
	A2($elm$core$Basics$composeL, $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$EmailMessageIdParam, $author$project$Domain$EmailMessageId$fromInt));
var $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$FactorInvoiceIdParam = function (a) {
	return {$: 'FactorInvoiceIdParam', a: a};
};
var $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$factorInvoiceId = $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$parseIntParam(
	A2($elm$core$Basics$composeL, $author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$FactorInvoiceIdParam, $author$project$Domain$FactorInvoiceId$fromInt));
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0.a;
		return $elm$url$Url$Parser$Internal$Parser(
			function (dict) {
				return func(
					a(dict));
			});
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return $elm$url$Url$Parser$Parser(
		function (state) {
			return A2(
				$elm$core$List$concatMap,
				function (_v0) {
					var parser = _v0.a;
					return parser(state);
				},
				parsers);
		});
};
var $author$project$Domain$DocumentBatchReviewId$DocumentBatchGroupingReviewId = function (a) {
	return {$: 'DocumentBatchGroupingReviewId', a: a};
};
var $author$project$Domain$DocumentBatchGroupingReviewId$DocumentBatchGroupingReviewId = function (a) {
	return {$: 'DocumentBatchGroupingReviewId', a: a};
};
var $author$project$Domain$DocumentBatchGroupingReviewId$fromInt = function (_int) {
	return $author$project$Domain$DocumentBatchGroupingReviewId$DocumentBatchGroupingReviewId(_int);
};
var $author$project$Domain$DocumentBatchReviewId$urlParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Domain$DocumentBatchReviewId$DocumentBatchGroupingReviewId, $author$project$Domain$DocumentBatchGroupingReviewId$fromInt),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('document_batch_grouping_reviews'),
				$elm$url$Url$Parser$int))
		]));
var $author$project$Domain$DocumentGroupLoadReviewId$DocumentGroupLoadReviewId = function (a) {
	return {$: 'DocumentGroupLoadReviewId', a: a};
};
var $author$project$Domain$DocumentGroupLoadReviewId$fromInt = function (_int) {
	return $author$project$Domain$DocumentGroupLoadReviewId$DocumentGroupLoadReviewId(_int);
};
var $author$project$Domain$DocumentGroupReviewId$urlParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Domain$DocumentGroupReviewId$DocumentGroupLoadReviewId, $author$project$Domain$DocumentGroupLoadReviewId$fromInt),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('document_group_load_reviews'),
				$elm$url$Url$Parser$int))
		]));
var $author$project$Domain$DocumentReviewId$DocumentLoadReferenceMatchReviewId = function (a) {
	return {$: 'DocumentLoadReferenceMatchReviewId', a: a};
};
var $author$project$Domain$DocumentReviewId$DocumentTypeReviewId = function (a) {
	return {$: 'DocumentTypeReviewId', a: a};
};
var $author$project$Domain$DocumentReviewId$InvoiceAmountReviewId = function (a) {
	return {$: 'InvoiceAmountReviewId', a: a};
};
var $author$project$Domain$DocumentReviewId$InvoiceNumberReviewId = function (a) {
	return {$: 'InvoiceNumberReviewId', a: a};
};
var $author$project$Domain$DocumentReviewId$MultiPageBolReviewId = function (a) {
	return {$: 'MultiPageBolReviewId', a: a};
};
var $author$project$Domain$DocumentLoadReferenceMatchReviewId$DocumentLoadReferenceMatchReviewId = function (a) {
	return {$: 'DocumentLoadReferenceMatchReviewId', a: a};
};
var $author$project$Domain$DocumentLoadReferenceMatchReviewId$fromInt = function (_int) {
	return $author$project$Domain$DocumentLoadReferenceMatchReviewId$DocumentLoadReferenceMatchReviewId(_int);
};
var $author$project$Domain$DocumentTypeReviewId$DocumentTypeReviewId = function (a) {
	return {$: 'DocumentTypeReviewId', a: a};
};
var $author$project$Domain$DocumentTypeReviewId$fromInt = function (_int) {
	return $author$project$Domain$DocumentTypeReviewId$DocumentTypeReviewId(_int);
};
var $author$project$Domain$InvoiceAmountReviewId$InvoiceAmountReviewId = function (a) {
	return {$: 'InvoiceAmountReviewId', a: a};
};
var $author$project$Domain$InvoiceAmountReviewId$fromInt = function (_int) {
	return $author$project$Domain$InvoiceAmountReviewId$InvoiceAmountReviewId(_int);
};
var $author$project$Domain$InvoiceNumberReviewId$InvoiceNumberReviewId = function (a) {
	return {$: 'InvoiceNumberReviewId', a: a};
};
var $author$project$Domain$InvoiceNumberReviewId$fromInt = function (_int) {
	return $author$project$Domain$InvoiceNumberReviewId$InvoiceNumberReviewId(_int);
};
var $author$project$Domain$MultiPageBolReviewId$MultiPageBolReviewId = function (a) {
	return {$: 'MultiPageBolReviewId', a: a};
};
var $author$project$Domain$MultiPageBolReviewId$fromInt = function (_int) {
	return $author$project$Domain$MultiPageBolReviewId$MultiPageBolReviewId(_int);
};
var $author$project$Domain$DocumentReviewId$urlParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Domain$DocumentReviewId$InvoiceNumberReviewId, $author$project$Domain$InvoiceNumberReviewId$fromInt),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('invoice_number_reviews'),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Domain$DocumentReviewId$InvoiceAmountReviewId, $author$project$Domain$InvoiceAmountReviewId$fromInt),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('invoice_amount_reviews'),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Domain$DocumentReviewId$MultiPageBolReviewId, $author$project$Domain$MultiPageBolReviewId$fromInt),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('multi_page_bol_reviews'),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Domain$DocumentReviewId$DocumentTypeReviewId, $author$project$Domain$DocumentTypeReviewId$fromInt),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('document_type_reviews'),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Domain$DocumentReviewId$DocumentLoadReferenceMatchReviewId, $author$project$Domain$DocumentLoadReferenceMatchReviewId$fromInt),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('document_load_reference_match_reviews'),
				$elm$url$Url$Parser$int))
		]));
var $author$project$Main$pageParser = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('app'),
	$elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$buildActivityRequest,
				A2($elm$url$Url$Parser$map, $author$project$Components$ActivityBrowser$FiltersView$QueryParams, $author$project$Main$activityArguments)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$ActivityPageRequest,
				$elm$url$Url$Parser$s('activity')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$OktaLoginPageRequest,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s('okta_login'),
								$elm$url$Url$Parser$Query$string('e')),
							$elm$url$Url$Parser$Query$string('state')),
						$elm$url$Url$Parser$Query$string('error')),
					$elm$url$Url$Parser$Query$string('error_description'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$BrokerBillingRequirementsPageRequest,
				$elm$url$Url$Parser$s('billing_requirements')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$DocumentsViewerPopoutPageRequest,
				$elm$url$Url$Parser$s('documents_viewer')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$HelpPageRequest,
				$elm$url$Url$Parser$s('help')),
				A2(
				$elm$url$Url$Parser$map,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Main$SettingsPageRequest, $author$project$Components$SettingsPage$Shared$Section$CarrierDocuments),
					$author$project$Domain$TmsCarrierId$fromInt),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('carriers'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$int,
							$elm$url$Url$Parser$s('documents'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$DocumentTypes),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('document_types'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$Account),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('account'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$NextGenAudit),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('next_gen_audit'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$Integrations),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('integrations'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$ScraperStatus),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('scraper_status'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$PodDefinition),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('pod_definition'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$Contacts),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('contacts'))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeL, $author$project$Main$SettingsDebtorRequest, $author$project$Domain$FactorBrokerId$fromInt),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('debtors'),
						$elm$url$Url$Parser$int))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$Debtors),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('debtors'))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeL, $author$project$Main$SettingsCustomerRequest, $author$project$Domain$TmsCustomerId$fromInt),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('customers'),
						$elm$url$Url$Parser$int))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsCustomersRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('customers'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsVerificationsRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('verifications'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsReferenceFieldsRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('reference_fields'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsReportsRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('reports'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsRulesRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('rules'))),
				A2(
				$elm$url$Url$Parser$map,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Main$SettingsUserRequest, $author$project$Components$SettingsPage$UserLayout$EnableMode),
					$author$project$Domain$UserId$fromInt),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('users'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$int,
							$elm$url$Url$Parser$s('enable'))))),
				A2(
				$elm$url$Url$Parser$map,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Main$SettingsUserRequest, $author$project$Components$SettingsPage$UserLayout$EditMode),
					$author$project$Domain$UserId$fromInt),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('users'),
						$elm$url$Url$Parser$int))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsUserRequest($author$project$Components$SettingsPage$UserLayout$NewMode),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('users'),
						$elm$url$Url$Parser$s('new')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsUsersRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('users'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$Exceptions),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('exceptions'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsPageRequest($author$project$Components$SettingsPage$Shared$Section$FactorClientPortal),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('client_portal'))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeL, $author$project$Main$SettingsCarrierRequest, $author$project$Domain$TmsCarrierId$fromInt),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('carriers'),
						$elm$url$Url$Parser$int))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$SettingsCarriersRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$s('carriers'))),
				A2(
				$elm$url$Url$Parser$map,
				F7(
					function (searchText, clientId, startDate, startDateTime, endDate, endDateTime, includeSent) {
						return $author$project$Main$EmailMessageSearchPageRequest(
							{
								clientId: clientId,
								endDate: A2(
									$elm$core$Maybe$andThen,
									A2($elm$core$Basics$composeL, $elm$core$Result$toMaybe, $justinmimbs$date$Date$fromIsoString),
									endDate),
								endDateTime: A2(
									$elm$core$Maybe$andThen,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Result$toMaybe,
										$elm$json$Json$Decode$decodeString($elm_community$json_extra$Json$Decode$Extra$datetime)),
									endDateTime),
								includeSent: _Utils_eq(
									includeSent,
									$elm$core$Maybe$Just('true')),
								searchText: searchText,
								startDate: A2(
									$elm$core$Maybe$andThen,
									A2($elm$core$Basics$composeL, $elm$core$Result$toMaybe, $justinmimbs$date$Date$fromIsoString),
									startDate),
								startDateTime: A2(
									$elm$core$Maybe$andThen,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Result$toMaybe,
										$elm$json$Json$Decode$decodeString($elm_community$json_extra$Json$Decode$Extra$datetime)),
									startDateTime)
							});
					}),
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											$elm$url$Url$Parser$s('email_search'),
											$elm$url$Url$Parser$Query$string('search_text')),
										$elm$url$Url$Parser$Query$int('client_id')),
									$elm$url$Url$Parser$Query$string('start_date')),
								$elm$url$Url$Parser$Query$string('start_datetime')),
							$elm$url$Url$Parser$Query$string('end_date')),
						$elm$url$Url$Parser$Query$string('end_datetime')),
					$elm$url$Url$Parser$Query$string('include_sent'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$ClientSubmissionPageRequest,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$author$project$Main$clientSubmissionEmail,
							$elm$url$Url$Parser$Query$int('group')),
						$author$project$Main$boolParam('dismissFundingNotes')),
					$elm$url$Url$Parser$Query$string('onDone'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$ClientSubmissionReviewPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Main$clientSubmissionEmail,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('review'),
						$elm$url$Url$Parser$Query$string('onDone')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$ClientSubmissionInvoicePageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Main$clientSubmissionEmail,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('invoice'),
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2($elm$url$Url$Parser$map, $author$project$Domain$FactorInvoiceId$fromInt, $elm$url$Url$Parser$int),
								$author$project$Main$boolParam('dismissFundingNotes')),
							$elm$url$Url$Parser$Query$string('onDone'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$VerificationBatchPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('verification_batch'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2($elm$url$Url$Parser$map, $author$project$Domain$VerificationsDebtorBatchId$fromInt, $elm$url$Url$Parser$int),
						$elm$url$Url$Parser$Query$string('onDone')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$NewDashboardRequest,
				$elm$url$Url$Parser$oneOf(
					_List_fromArray(
						[
							$elm$url$Url$Parser$s('dashboard'),
							A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('elm'),
							$elm$url$Url$Parser$s('dash'))
						]))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$buildDashboardRequest,
				$elm$url$Url$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('dashboard'),
							$author$project$Main$dashboardArguments),
							A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('elm'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('dash'),
								$author$project$Main$dashboardArguments))
						]))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$NonInvoiceConfirmRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('index-document-batches'),
					A2(
						$elm$url$Url$Parser$slash,
						A2($elm$url$Url$Parser$map, $author$project$Domain$DocumentBatchId$fromInt, $elm$url$Url$Parser$int),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('loads'),
							A2(
								$elm$url$Url$Parser$slash,
								A2($elm$url$Url$Parser$map, $author$project$Domain$LoadStateId$fromInt, $elm$url$Url$Parser$int),
								A2(
									$elm$url$Url$Parser$questionMark,
									$elm$url$Url$Parser$s('confirm'),
									$elm$url$Url$Parser$Query$string('onDone'))))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$LtlConfirmRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('loads'),
					A2(
						$elm$url$Url$Parser$slash,
						A2($elm$url$Url$Parser$map, $author$project$Domain$LoadStateId$fromInt, $elm$url$Url$Parser$int),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('carrier_invoices'),
							A2(
								$elm$url$Url$Parser$slash,
								A2($elm$url$Url$Parser$map, $author$project$Domain$CarrierInvoiceId$fromInt, $elm$url$Url$Parser$int),
								A2(
									$elm$url$Url$Parser$questionMark,
									$elm$url$Url$Parser$s('ltl-reconcile'),
									$elm$url$Url$Parser$Query$string('onDone'))))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$TermsPageRequest,
				$elm$url$Url$Parser$s('terms')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$carrierInvoiceAuditPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('carrier_invoices_workflow'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2($elm$url$Url$Parser$map, $author$project$Domain$CarrierInvoiceId$fromInt, $elm$url$Url$Parser$int),
									A2(
										$elm$url$Url$Parser$Query$map,
										$elm$core$Maybe$map($author$project$Domain$LoadStateId$fromInt),
										$elm$url$Url$Parser$Query$int('loadId'))),
								A2(
									$elm$url$Url$Parser$Query$map,
									$elm$core$Maybe$map($author$project$Domain$EmailMessageId$fromInt),
									$elm$url$Url$Parser$Query$int('emailMessageId'))),
							A2(
								$elm$url$Url$Parser$Query$map,
								$elm$core$Maybe$map($author$project$Domain$EmailMessageId$fromInt),
								$elm$url$Url$Parser$Query$int('replyEmailId'))),
						$elm$url$Url$Parser$Query$string('onDone')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$FactorInvoiceAuditPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('factor_invoices_workflow'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2($elm$url$Url$Parser$map, $author$project$Domain$FactorInvoiceId$fromInt, $elm$url$Url$Parser$int),
							A2(
								$elm$url$Url$Parser$Query$map,
								$elm$core$Maybe$map($author$project$Domain$EmailMessageId$fromInt),
								$elm$url$Url$Parser$Query$int('emailId'))),
						$elm$url$Url$Parser$Query$string('onDone')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$FactorInvoiceAuditBatchGroupingPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('factor_invoices_workflow'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('batch'),
						A2(
							$elm$url$Url$Parser$slash,
							A2($elm$url$Url$Parser$map, $author$project$Domain$DocumentBatchId$fromInt, $elm$url$Url$Parser$int),
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s('grouping'),
								$elm$url$Url$Parser$Query$string('onDone')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$FactorInvoiceAuditBatchPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('factor_invoices_workflow'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('batch'),
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2($elm$url$Url$Parser$map, $author$project$Domain$DocumentBatchId$fromInt, $elm$url$Url$Parser$int),
									A2(
										$elm$url$Url$Parser$Query$map,
										$elm$core$Maybe$map($author$project$Domain$EmailMessageId$fromInt),
										$elm$url$Url$Parser$Query$int('emailId'))),
								A2(
									$elm$url$Url$Parser$Query$map,
									$elm$core$Maybe$map($author$project$Domain$FactorInvoiceId$fromInt),
									$elm$url$Url$Parser$Query$int('invoiceId'))),
							$elm$url$Url$Parser$Query$string('onDone'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$ForwardingHasMovedPageRequest,
				$elm$url$Url$Parser$s('forwarding-has-moved')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$MyClientsOverviewPageRequest,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('my_clients_demo'),
					$elm$url$Url$Parser$Query$string('account_executive'))),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (maybeDebtorId, maybeCarrierId) {
						return $author$project$Main$NoaManagementSentPageRequest(
							{
								carrierId: A2($elm$core$Maybe$map, $author$project$Domain$TmsCarrierId$fromInt, maybeCarrierId),
								debtorId: A2($elm$core$Maybe$map, $author$project$Domain$FactorBrokerId$fromInt, maybeDebtorId)
							});
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('noa_management'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('sent'),
							$elm$url$Url$Parser$Query$int('debtor_id')),
						$elm$url$Url$Parser$Query$int('carrier_id')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$NoaManagementSkippedPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('noa_management'),
					$elm$url$Url$Parser$s('skipped'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$NoaManagementToSendPageRequest,
				$elm$url$Url$Parser$s('noa_management')),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (startDate, endDate) {
						return $author$project$Main$DebtorChangesPageRequest(
							{endDate: endDate, startDate: startDate});
					}),
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('debtor_changes'),
						$elm$url$Url$Parser$Query$string('start_date')),
					$elm$url$Url$Parser$Query$string('end_date'))),
				A2(
				$elm$url$Url$Parser$map,
				F3(
					function (templateId, startDate, endDate) {
						return $author$project$Main$DebtorChangesTemplatePageRequest(
							{endDate: endDate, startDate: startDate, templateId: templateId});
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('debtor_changes'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('templates'),
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$int,
								$elm$url$Url$Parser$Query$string('start_date')),
							$elm$url$Url$Parser$Query$string('end_date'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$LtlHeldSubmissionsPageRequest,
				$elm$url$Url$Parser$s('held_submissions')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$DocumentReviewPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('document_reviews'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$author$project$Domain$DocumentReviewId$urlParser,
						$elm$url$Url$Parser$Query$string('onDone')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$DocumentBatchReviewPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('document_batch_reviews'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$author$project$Domain$DocumentBatchReviewId$urlParser,
						$elm$url$Url$Parser$Query$string('onDone')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$DocumentGroupReviewPageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('document_group_reviews'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$author$project$Domain$DocumentGroupReviewId$urlParser,
						$elm$url$Url$Parser$Query$string('onDone')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$EmailMergePageRequest,
				$elm$url$Url$Parser$s('email_merge')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$ReadonlyFactorInvoicePageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('readonly_factor_invoices'),
					$author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$factorInvoiceId)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$ReadonlyFactorInvoicePageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('readonly_document_batches'),
					$author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$documentBatchId)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Main$ReadonlyFactorInvoicePageRequest,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('readonly_emails'),
					$author$project$Components$ReadonlyFactorInvoicePage$ReadonlyDocumentBrowserId$emailId)),
				A2(
				$elm$url$Url$Parser$map,
				F9(
					function (page, searchTerm, carrier, deliveredAfter, deliveredBefore, invoicedAfter, invoicedBefore, withDocuments, withInvoice) {
						return $author$project$Main$ToBeScrapedLoadsPageRequest(
							{carrier: carrier, deliveredAfter: deliveredAfter, deliveredBefore: deliveredBefore, invoicedAfter: invoicedAfter, invoicedBefore: invoicedBefore, page: page, searchTerm: searchTerm, withDocuments: withDocuments, withInvoice: withInvoice});
					}),
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											A2(
												$elm$url$Url$Parser$questionMark,
												A2(
													$elm$url$Url$Parser$questionMark,
													$elm$url$Url$Parser$s('to_be_scraped_loads'),
													$elm$url$Url$Parser$Query$int('page')),
												$elm$url$Url$Parser$Query$string('search_term')),
											$elm$url$Url$Parser$Query$string('carrier')),
										$elm$url$Url$Parser$Query$string('delivered_after')),
									$elm$url$Url$Parser$Query$string('delivered_before')),
								$elm$url$Url$Parser$Query$string('invoiced_after')),
							$elm$url$Url$Parser$Query$string('invoiced_before')),
						$author$project$Main$boolParam('with_documents')),
					$author$project$Main$boolParam('with_invoice')))
			])));
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.unvisited;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.value);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.value);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 'Nothing') {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 'Nothing') {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 'Nothing') {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0.a;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.path),
					$elm$url$Url$Parser$prepareQuery(url.query),
					url.fragment,
					$elm$core$Basics$identity)));
	});
var $author$project$Main$routesInElm = function (pathString) {
	var _v0 = function () {
		var _v1 = A2($elm$core$String$split, '?', pathString);
		if (_v1.b && _v1.b.b) {
			var p = _v1.a;
			var _v2 = _v1.b;
			var q = _v2.a;
			return _Utils_Tuple2(
				p,
				$elm$core$Maybe$Just(q));
		} else {
			return _Utils_Tuple2(pathString, $elm$core$Maybe$Nothing);
		}
	}();
	var path = _v0.a;
	var query = _v0.b;
	return !_Utils_eq(
		$elm$core$Maybe$Nothing,
		A2(
			$elm$url$Url$Parser$parse,
			$author$project$Main$pageParser,
			{fragment: $elm$core$Maybe$Nothing, host: '', path: path, port_: $elm$core$Maybe$Nothing, protocol: $elm$url$Url$Https, query: query}));
};
var $author$project$Main$initPage = F2(
	function (reskinVals, pageRequest) {
		switch (pageRequest.$) {
			case 'ActivityPageRequest':
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$ActivityPageInitDataLoaded($author$project$Components$ActivityBrowser$FiltersView$emptyQueryParams),
						$author$project$Components$ActivityPage$loadInitData($author$project$Components$ActivityBrowser$FiltersView$emptyQueryParams)));
			case 'ActivityPageRequestWithArguments':
				var requestedFilters = pageRequest.a;
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$ActivityPageInitDataLoaded(requestedFilters),
						$author$project$Components$ActivityPage$loadInitData(requestedFilters)));
			case 'BrokerBillingRequirementsPageRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$BrokerBillingRequirementsPage,
						$author$project$HubTran$Effect$map($author$project$Main$BrokerBillingRequirementsPageMsg),
						$author$project$Broker$Page$BillingRequirements$init));
			case 'DocumentsViewerPopoutPageRequest':
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2($author$project$HubTran$Effect$fetchFromCache, $author$project$Main$DocumentsViewerPopoutPageInitDataLoaded, $author$project$Broker$Page$DocumentsViewerPopout$loadInitData));
			case 'NewDashboardRequest':
				var flags = {
					activePage: 1,
					dashboardMode: $author$project$Sanitized$raw($author$project$AuditPb$DashboardModeAll),
					inFlowMode: false,
					requestedFilters: $elm$core$Maybe$Nothing,
					requestedQueue: $elm$core$Maybe$Nothing,
					routesInElm: $author$project$Main$routesInElm,
					v3ReskinEnabledQueues: reskinVals.queues,
					v3ReskinEnabledTopLevel: reskinVals.topLevel
				};
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$DashboardPageInitDataLoaded(flags),
						$author$project$Components$DashboardPage$loadInitData($elm$core$Maybe$Nothing)));
			case 'DashboardRequestWithArguments':
				var queue_ = pageRequest.a;
				var requestedFilters = pageRequest.b;
				var activePage = pageRequest.c;
				var inFlowMode = pageRequest.d;
				var dashboardMode = pageRequest.e;
				var flags = {activePage: activePage, dashboardMode: dashboardMode, inFlowMode: inFlowMode, requestedFilters: requestedFilters, requestedQueue: queue_, routesInElm: $author$project$Main$routesInElm, v3ReskinEnabledQueues: reskinVals.queues, v3ReskinEnabledTopLevel: reskinVals.topLevel};
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$DashboardPageInitDataLoaded(flags),
						$author$project$Components$DashboardPage$loadInitData(requestedFilters)));
			case 'HelpPageRequest':
				return _Utils_Tuple2($author$project$Main$HelpPage, $author$project$HubTran$Effect$none);
			case 'SettingsCarrierRequest':
				var tmsCarrierId = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsCarrierPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsCarrierPageMsg),
						$author$project$Components$SettingsPage$CarrierLayout$init(tmsCarrierId)));
			case 'SettingsCarriersRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsCarriersPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsCarriersPageMsg),
						$author$project$Components$SettingsPage$CarriersLayout$init));
			case 'SettingsDebtorRequest':
				var debtorId = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsDebtorPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsDebtorPageMsg),
						$author$project$Components$SettingsPage$DebtorLayout$init(debtorId)));
			case 'SettingsCustomerRequest':
				var customerId = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Main$SettingsCustomerPage,
					_Utils_Tuple2(
						$author$project$Components$SettingsPage$CustomerLayout$init(customerId),
						$author$project$HubTran$Effect$none));
			case 'SettingsCustomersRequest':
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Main$SettingsCustomersPage,
					_Utils_Tuple2($author$project$Components$SettingsPage$CustomersLayout$init, $author$project$HubTran$Effect$none));
			case 'SettingsReferenceFieldsRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsReferenceFieldsPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsReferenceFieldsPageMsg),
						$author$project$Components$SettingsPage$ReferenceFieldsLayout$init));
			case 'SettingsReportsRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsReportsPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsReportsPageMsg),
						$author$project$Components$SettingsPage$ReportsLayout$init));
			case 'SettingsRulesRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsRulesPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsRulesPageMsg),
						$author$project$Components$SettingsPage$RulesLayout$init));
			case 'SettingsUserRequest':
				var mode = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsUserPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsUserPageMsg),
						$author$project$Components$SettingsPage$UserLayout$init(mode)));
			case 'SettingsUsersRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsUsersPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsUsersPageMsg),
						$author$project$Components$SettingsPage$UsersLayout$init));
			case 'SettingsVerificationsRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsVerificationsPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsVerificationsPageMsg),
						$author$project$Components$SettingsPage$VerificationsLayout$init));
			case 'SettingsPageRequest':
				var activeSection = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$SettingsPage,
						$author$project$HubTran$Effect$map($author$project$Main$SettingsPageMsg),
						$author$project$Components$SettingsPage$init(activeSection)));
			case 'TermsPageRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$TermsPage,
						$author$project$HubTran$Effect$map($author$project$Main$TermsPageMsg),
						$author$project$Components$TermsPage$page.init(_Utils_Tuple0)));
			case 'BlankPageRequest':
				return _Utils_Tuple2($author$project$Main$BlankPage, $author$project$HubTran$Effect$none);
			case 'EmailMessageSearchPageRequest':
				var parameters = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$EmailMessageSearchPage,
						$author$project$HubTran$Effect$map($author$project$Main$EmailMessageSearchPageMsg),
						$author$project$Components$EmailMessageSearchPage$init(parameters)));
			case 'ClientSubmissionPageRequest':
				var emailMessageId = pageRequest.a;
				var group = pageRequest.b;
				var dismissFundingNotes = pageRequest.c;
				var onDoneQuery = pageRequest.d;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$ClientSubmissionPage,
						$author$project$HubTran$Effect$map($author$project$Main$ClientSubmissionPageMsg),
						A4($author$project$Factoring$Page$ClientSubmission$init, emailMessageId, group, dismissFundingNotes, onDoneQuery)));
			case 'ClientSubmissionReviewPageRequest':
				var emailMessageId = pageRequest.a;
				var onDoneQuery = pageRequest.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$ClientSubmissionReviewPage,
						$author$project$HubTran$Effect$map($author$project$Main$ClientSubmissionReviewPageMsg),
						A2($author$project$Factoring$Page$ClientSubmissionReview$init, emailMessageId, onDoneQuery)));
			case 'ClientSubmissionInvoicePageRequest':
				var emailMessageId = pageRequest.a;
				var invoiceId = pageRequest.b;
				var dismissFundingNotesQuery = pageRequest.c;
				var onDoneQuery = pageRequest.d;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$ClientSubmissionInvoicePage,
						$author$project$HubTran$Effect$map($author$project$Main$ClientSubmissionInvoicePageMsg),
						A4($author$project$Factoring$Page$ClientSubmissionInvoice$init, emailMessageId, invoiceId, dismissFundingNotesQuery, onDoneQuery)));
			case 'VerificationBatchPageRequest':
				var verificationsDebtorBatchId = pageRequest.a;
				var maybeQuery = pageRequest.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$VerificationBatchPage,
						$author$project$HubTran$Effect$map($author$project$Main$VerificationBatchPageMsg),
						A2($author$project$Factoring$Page$VerificationBatch$init, verificationsDebtorBatchId, maybeQuery)));
			case 'NonInvoiceConfirmRequest':
				var documentBatchId = pageRequest.a;
				var loadStateId = pageRequest.b;
				var onDoneQuery = pageRequest.c;
				var flags = {documentBatchId: documentBatchId, loadStateId: loadStateId, onDone: onDoneQuery};
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$NonInvoiceConfirmPageInitDataLoaded,
						$author$project$Components$NonInvoiceConfirmPage$loadInitData(flags)));
			case 'LtlConfirmRequest':
				var loadStateId = pageRequest.a;
				var carrierInvoiceId = pageRequest.b;
				var onDoneQuery = pageRequest.c;
				var flags = {carrierInvoiceId: carrierInvoiceId, loadStateId: loadStateId, onDone: onDoneQuery};
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$LtlReconcileInvoicePageInitDataLoaded,
						$author$project$Components$LtlReconcileInvoicePage$loadInitData(flags)));
			case 'OktaLoginPageRequest':
				var maybeEmail = pageRequest.a;
				var maybeState = pageRequest.b;
				var maybeError = pageRequest.c;
				var maybeErrorDescription = pageRequest.d;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$OktaLoginPage,
						$author$project$HubTran$Effect$map($author$project$Main$OktaLoginPageMsg),
						$author$project$Components$OktaLoginPage$init(
							{maybeEmail: maybeEmail, maybeError: maybeError, maybeErrorDescription: maybeErrorDescription, maybeRedirect: $elm$core$Maybe$Nothing, maybeState: maybeState})));
			case 'CarrierInvoiceAuditPageRequest':
				var carrierInvoiceId = pageRequest.a;
				var maybeEmailMessageId = pageRequest.c;
				var maybeReplyEmailId = pageRequest.d;
				var maybeOnDone = pageRequest.e;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$CarrierInvoiceAuditPage,
						$author$project$HubTran$Effect$map($author$project$Main$CarrierInvoiceAuditPageMsg),
						A4($author$project$Components$CarrierInvoiceAuditPage$init, carrierInvoiceId, maybeEmailMessageId, maybeReplyEmailId, maybeOnDone)));
			case 'FactorInvoiceAuditPageRequest':
				var factorInvoiceId = pageRequest.a;
				var maybeEmailMessageId = pageRequest.b;
				var maybeOnDone = pageRequest.c;
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$FactorInvoiceAuditPageInitDataLoaded,
						A3($author$project$Components$FactorInvoiceAuditPage$loadInitData, factorInvoiceId, maybeEmailMessageId, maybeOnDone)));
			case 'FactorInvoiceAuditBatchGroupingPageRequest':
				var documentBatchId = pageRequest.a;
				var maybeOnDone = pageRequest.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$FactorInvoiceAuditBatchGroupingPage,
						$author$project$HubTran$Effect$map($elm$core$Basics$never),
						A2($author$project$Components$FactorInvoiceAuditBatchGroupingPage$init, documentBatchId, maybeOnDone)));
			case 'FactorInvoiceAuditBatchPageRequest':
				var documentBatchId = pageRequest.a;
				var maybeEmailMessageId = pageRequest.b;
				var maybeFactorInvoiceId = pageRequest.c;
				var maybeOnDone = pageRequest.d;
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						A2($author$project$Main$FactorInvoiceAuditBatchPageInitDataLoaded, documentBatchId, maybeOnDone),
						A4($author$project$Components$FactorInvoiceAuditBatchPage$loadInitData, documentBatchId, maybeEmailMessageId, maybeFactorInvoiceId, maybeOnDone)));
			case 'ForwardingHasMovedPageRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$ForwardingHasMovedPage,
						$author$project$HubTran$Effect$map($elm$core$Basics$never),
						$author$project$Components$ForwardingHasMovedPage$page.init(_Utils_Tuple0)));
			case 'MyClientsOverviewPageRequest':
				var accountExecutive = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$MyClientsOverviewPage,
						$author$project$HubTran$Effect$map($author$project$Main$MyClientsOverviewPageMsg),
						$author$project$Components$MyClients$OverviewPage$page.init(
							{accountExecutive: accountExecutive})));
			case 'NoaManagementToSendPageRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$NoaManagementToSendPage,
						$author$project$HubTran$Effect$map($author$project$Main$NoaManagementToSendPageMsg),
						$author$project$Components$NoaManagement$ToSendPage$page.init(_Utils_Tuple0)));
			case 'DebtorChangesPageRequest':
				var params = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$DebtorChangesPage,
						$author$project$HubTran$Effect$map($author$project$Main$DebtorChangesPageMsg),
						$author$project$Components$DebtorChanges$IndexPage$page.init(params)));
			case 'DebtorChangesTemplatePageRequest':
				var params = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$DebtorChangesTemplatePage,
						$author$project$HubTran$Effect$map($author$project$Main$DebtorChangesTemplatePageMsg),
						$author$project$Components$DebtorChanges$TemplatePage$page.init(params)));
			case 'NoaManagementSentPageRequest':
				var params = pageRequest.a;
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$NoaManagementSentPageInitDataLoaded(params),
						$author$project$Components$NoaManagement$SentPage$loadInitData(params)));
			case 'NoaManagementSkippedPageRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$NoaManagementSkippedPage,
						$author$project$HubTran$Effect$map($author$project$Main$NoaManagementSkippedPageMsg),
						$author$project$Components$NoaManagement$SkippedPage$page.init(_Utils_Tuple0)));
			case 'DocumentReviewPageRequest':
				var documentReviewId = pageRequest.a;
				var onDoneQuery = pageRequest.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$DocumentReviewPage,
						$author$project$HubTran$Effect$map($author$project$Main$DocumentReviewPageMsg),
						A2($author$project$Components$DocumentReviewPage$init, documentReviewId, onDoneQuery)));
			case 'DocumentBatchReviewPageRequest':
				var documentBatchReviewId = pageRequest.a;
				var onDoneQuery = pageRequest.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$DocumentBatchReviewPage,
						$author$project$HubTran$Effect$map($author$project$Main$DocumentBatchReviewPageMsg),
						A2($author$project$Components$DocumentBatchReviewPage$init, documentBatchReviewId, onDoneQuery)));
			case 'DocumentGroupReviewPageRequest':
				var documentGroupReviewId = pageRequest.a;
				var onDoneQuery = pageRequest.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$DocumentGroupReviewPage,
						$author$project$HubTran$Effect$map($author$project$Main$DocumentGroupReviewPageMsg),
						A2($author$project$Components$DocumentGroupReviewPage$init, documentGroupReviewId, onDoneQuery)));
			case 'LtlHeldSubmissionsPageRequest':
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2($author$project$HubTran$Effect$fetchFromCache, $author$project$Main$LtlHeldSubmissionsPageInitDataLoaded, $author$project$Components$LtlHeldSubmissionsPage$loadInitData));
			case 'EmailMergePageRequest':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$EmailMergePage,
						$author$project$HubTran$Effect$map($author$project$Main$EmailMergePageMsg),
						$author$project$Components$EmailMergePage$page.init(_Utils_Tuple0)));
			case 'ReadonlyFactorInvoicePageRequest':
				var id = pageRequest.a;
				return _Utils_Tuple2(
					$author$project$Main$LoadingPage,
					A2(
						$author$project$HubTran$Effect$fetchFromCache,
						$author$project$Main$ReadonlyFactorInvoicePageInitDataLoaded,
						$author$project$Components$ReadonlyFactorInvoicePage$loadInitData(id)));
			default:
				var params = pageRequest.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Main$PageMsg),
					A3(
						$elm$core$Tuple$mapBoth,
						$author$project$Main$ToBeScrapedLoadsPage,
						$author$project$HubTran$Effect$map($author$project$Main$ToBeScrapedLoadsPageMsg),
						$author$project$Components$ToBeScrapedLoadsPage$page.init(params)));
		}
	});
var $author$project$Main$parsePageRequest = function (location) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Main$BlankPageRequest,
		A2(
			$elm$core$Maybe$andThen,
			$elm$url$Url$Parser$parse($author$project$Main$pageParser),
			location));
};
var $author$project$Js$refreshBeamerCount = _Platform_outgoingPort(
	'refreshBeamerCount',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Main$init = F2(
	function (headerFlags, location) {
		var pageRequest = $author$project$Main$parsePageRequest(location);
		var _v0 = A2($author$project$Main$initPage, headerFlags.reskinVals, pageRequest);
		var newPageModel = _v0.a;
		var pageEffect = _v0.b;
		return _Utils_Tuple2(
			{beamerMessageCount: 0, flash: $author$project$Components$Flash$init, header: $author$project$Ui$V3$Header$init, headerElement: $elm$core$Maybe$Nothing, headerFlags: headerFlags, headerSearchRemote: $elm$core$Maybe$Nothing, headerSearchTerm: '', location: location, page: newPageModel, timezone: $elm$time$Time$utc},
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Task$perform, $author$project$Main$SetTimezone, $author$project$Helpers$Date$localTimezone)),
						$author$project$HubTran$Effect$cmd(
						$author$project$Js$refreshBeamerCount(_Utils_Tuple0)),
						pageEffect,
						$author$project$HubTran$Effect$cmd($author$project$Main$getHeaderViewport)
					])));
	});
var $author$project$Main$ActivityPageData = F2(
	function (a, b) {
		return {$: 'ActivityPageData', a: a, b: b};
	});
var $author$project$Main$BlankPageData = {$: 'BlankPageData'};
var $author$project$Main$BrokerBillingRequirementsPageData = F2(
	function (a, b) {
		return {$: 'BrokerBillingRequirementsPageData', a: a, b: b};
	});
var $author$project$Main$CarrierInvoiceAuditPageData = F2(
	function (a, b) {
		return {$: 'CarrierInvoiceAuditPageData', a: a, b: b};
	});
var $author$project$Main$ClientSubmissionInvoicePageData = F2(
	function (a, b) {
		return {$: 'ClientSubmissionInvoicePageData', a: a, b: b};
	});
var $author$project$Main$ClientSubmissionPageData = function (a) {
	return {$: 'ClientSubmissionPageData', a: a};
};
var $author$project$Main$ClientSubmissionReviewPageData = F2(
	function (a, b) {
		return {$: 'ClientSubmissionReviewPageData', a: a, b: b};
	});
var $author$project$Main$DashboardPageData = F2(
	function (a, b) {
		return {$: 'DashboardPageData', a: a, b: b};
	});
var $author$project$Main$DebtorChangesPageData = F2(
	function (a, b) {
		return {$: 'DebtorChangesPageData', a: a, b: b};
	});
var $author$project$Main$DebtorChangesTemplatePageData = F2(
	function (a, b) {
		return {$: 'DebtorChangesTemplatePageData', a: a, b: b};
	});
var $author$project$Main$DocumentBatchReviewPageData = F2(
	function (a, b) {
		return {$: 'DocumentBatchReviewPageData', a: a, b: b};
	});
var $author$project$Main$DocumentGroupReviewPageData = F2(
	function (a, b) {
		return {$: 'DocumentGroupReviewPageData', a: a, b: b};
	});
var $author$project$Main$DocumentReviewPageData = F2(
	function (a, b) {
		return {$: 'DocumentReviewPageData', a: a, b: b};
	});
var $author$project$Main$DocumentsViewerPopoutPageData = F2(
	function (a, b) {
		return {$: 'DocumentsViewerPopoutPageData', a: a, b: b};
	});
var $author$project$Main$EmailMergePageData = F2(
	function (a, b) {
		return {$: 'EmailMergePageData', a: a, b: b};
	});
var $author$project$Main$EmailMessageSearchPageData = F2(
	function (a, b) {
		return {$: 'EmailMessageSearchPageData', a: a, b: b};
	});
var $author$project$Main$FactorInvoiceAuditBatchGroupingPageData = F2(
	function (a, b) {
		return {$: 'FactorInvoiceAuditBatchGroupingPageData', a: a, b: b};
	});
var $author$project$Main$FactorInvoiceAuditBatchPageData = F2(
	function (a, b) {
		return {$: 'FactorInvoiceAuditBatchPageData', a: a, b: b};
	});
var $author$project$Main$FactorInvoiceAuditPageData = F2(
	function (a, b) {
		return {$: 'FactorInvoiceAuditPageData', a: a, b: b};
	});
var $author$project$Main$ForwardingHasMovedPageData = {$: 'ForwardingHasMovedPageData'};
var $author$project$Main$HelpPageData = function (a) {
	return {$: 'HelpPageData', a: a};
};
var $author$project$Main$LoadingFailedPageData = function (a) {
	return {$: 'LoadingFailedPageData', a: a};
};
var $author$project$Main$LoadingPageData = {$: 'LoadingPageData'};
var $author$project$Main$LtlHeldSubmissionsPageData = F2(
	function (a, b) {
		return {$: 'LtlHeldSubmissionsPageData', a: a, b: b};
	});
var $author$project$Main$LtlReconcileInvoicePageData = F2(
	function (a, b) {
		return {$: 'LtlReconcileInvoicePageData', a: a, b: b};
	});
var $author$project$Main$MyClientsOverviewPageData = F2(
	function (a, b) {
		return {$: 'MyClientsOverviewPageData', a: a, b: b};
	});
var $author$project$Main$NoaManagementSentPageData = F2(
	function (a, b) {
		return {$: 'NoaManagementSentPageData', a: a, b: b};
	});
var $author$project$Main$NoaManagementSkippedPageData = F2(
	function (a, b) {
		return {$: 'NoaManagementSkippedPageData', a: a, b: b};
	});
var $author$project$Main$NoaManagementToSendPageData = F2(
	function (a, b) {
		return {$: 'NoaManagementToSendPageData', a: a, b: b};
	});
var $author$project$Main$NonInvoiceConfirmPageData = F2(
	function (a, b) {
		return {$: 'NonInvoiceConfirmPageData', a: a, b: b};
	});
var $author$project$Main$OktaLoginPageData = F2(
	function (a, b) {
		return {$: 'OktaLoginPageData', a: a, b: b};
	});
var $author$project$Main$ReadonlyFactorInvoicePageData = F2(
	function (a, b) {
		return {$: 'ReadonlyFactorInvoicePageData', a: a, b: b};
	});
var $author$project$Main$SettingsCarrierPageData = F2(
	function (a, b) {
		return {$: 'SettingsCarrierPageData', a: a, b: b};
	});
var $author$project$Main$SettingsCarriersPageData = F2(
	function (a, b) {
		return {$: 'SettingsCarriersPageData', a: a, b: b};
	});
var $author$project$Main$SettingsCustomerPageData = F2(
	function (a, b) {
		return {$: 'SettingsCustomerPageData', a: a, b: b};
	});
var $author$project$Main$SettingsCustomersPageData = F2(
	function (a, b) {
		return {$: 'SettingsCustomersPageData', a: a, b: b};
	});
var $author$project$Main$SettingsDebtorPageData = F2(
	function (a, b) {
		return {$: 'SettingsDebtorPageData', a: a, b: b};
	});
var $author$project$Main$SettingsPageData = F2(
	function (a, b) {
		return {$: 'SettingsPageData', a: a, b: b};
	});
var $author$project$Main$SettingsReferenceFieldsPageData = F2(
	function (a, b) {
		return {$: 'SettingsReferenceFieldsPageData', a: a, b: b};
	});
var $author$project$Main$SettingsReportsPageData = F2(
	function (a, b) {
		return {$: 'SettingsReportsPageData', a: a, b: b};
	});
var $author$project$Main$SettingsRulesPageData = F2(
	function (a, b) {
		return {$: 'SettingsRulesPageData', a: a, b: b};
	});
var $author$project$Main$SettingsUserPageData = F2(
	function (a, b) {
		return {$: 'SettingsUserPageData', a: a, b: b};
	});
var $author$project$Main$SettingsUsersPageData = F2(
	function (a, b) {
		return {$: 'SettingsUsersPageData', a: a, b: b};
	});
var $author$project$Main$SettingsVerificationsPageData = F2(
	function (a, b) {
		return {$: 'SettingsVerificationsPageData', a: a, b: b};
	});
var $author$project$Main$TermsPageData = function (a) {
	return {$: 'TermsPageData', a: a};
};
var $author$project$Main$ToBeScrapedLoadsPageData = F2(
	function (a, b) {
		return {$: 'ToBeScrapedLoadsPageData', a: a, b: b};
	});
var $author$project$Main$VerificationBatchPageData = F2(
	function (a, b) {
		return {$: 'VerificationBatchPageData', a: a, b: b};
	});
var $author$project$Broker$Page$BillingRequirements$Data = F5(
	function (currentAccount, accountSettings, currentUser, loadCustomerSettings, shipmentCustomerSettings) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, currentUser: currentUser, loadCustomerSettings: loadCustomerSettings, shipmentCustomerSettings: shipmentCustomerSettings};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadDetails = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetails,
		fieldName: 'tmsLoadDetails',
		getId: function ($) {
			return $.loadStateId;
		}
	});
var $author$project$Helpers$Maybe$join = $elm_community$maybe_extra$Maybe$Extra$join;
var $author$project$AuditPb$TMSCustomerSettings = function (id) {
	return function (name) {
		return function (accountNumber) {
			return function (effectiveDaysToPay) {
				return function (customerInvoiceTemplateId) {
					return function (statementCustomerInvoiceTemplateId) {
						return function (masterCustomerInvoiceTemplateId) {
							return function (instructionsForWrite) {
								return function (instructionsList) {
									return function (billingInterval) {
										return function (podRequirementPolicy) {
											return function (customSubjectTemplate) {
												return function (billingEmail) {
													return function (templateVariables) {
														return function (ignoreCustomerInvoiceDocument) {
															return function (accountRemitToAddressId) {
																return function (overrideDefaultLtlTolerance) {
																	return function (ltlCarrierInvoiceAmountToleranceUnit) {
																		return function (ltlCarrierInvoiceAmountToleranceOver) {
																			return function (ltlCarrierInvoiceAmountToleranceUnder) {
																				return function (overrideDefaultLtlCustomerMarginTolerance) {
																					return function (ltlCustomerMarginToleranceUnit) {
																						return function (ltlCustomerMarginToleranceMinimum) {
																							return function (ltlCustomerMarginToleranceMaximum) {
																								return function (ltlAutoRerateEnabled) {
																									return function (ltlReweighChargeExceptionsEnabled) {
																										return function (ltlRequireManualReweighReview) {
																											return function (billToAddress) {
																												return function (customerVisibleDocumentTypes) {
																													return function (requiredReceivablesTypes) {
																														return function (requiredPayablesTypes) {
																															return function (contacts) {
																																return function (references) {
																																	return function (rulesBrokerRequiredReferences) {
																																		return function (rulesBrokerCustomExceptionMessages) {
																																			return function (deliveryMethod) {
																																				return {accountNumber: accountNumber, accountRemitToAddressId: accountRemitToAddressId, billToAddress: billToAddress, billingEmail: billingEmail, billingInterval: billingInterval, contacts: contacts, customSubjectTemplate: customSubjectTemplate, customerInvoiceTemplateId: customerInvoiceTemplateId, customerVisibleDocumentTypes: customerVisibleDocumentTypes, deliveryMethod: deliveryMethod, effectiveDaysToPay: effectiveDaysToPay, id: id, ignoreCustomerInvoiceDocument: ignoreCustomerInvoiceDocument, instructionsForWrite: instructionsForWrite, instructionsList: instructionsList, ltlAutoRerateEnabled: ltlAutoRerateEnabled, ltlCarrierInvoiceAmountToleranceOver: ltlCarrierInvoiceAmountToleranceOver, ltlCarrierInvoiceAmountToleranceUnder: ltlCarrierInvoiceAmountToleranceUnder, ltlCarrierInvoiceAmountToleranceUnit: ltlCarrierInvoiceAmountToleranceUnit, ltlCustomerMarginToleranceMaximum: ltlCustomerMarginToleranceMaximum, ltlCustomerMarginToleranceMinimum: ltlCustomerMarginToleranceMinimum, ltlCustomerMarginToleranceUnit: ltlCustomerMarginToleranceUnit, ltlRequireManualReweighReview: ltlRequireManualReweighReview, ltlReweighChargeExceptionsEnabled: ltlReweighChargeExceptionsEnabled, masterCustomerInvoiceTemplateId: masterCustomerInvoiceTemplateId, name: name, overrideDefaultLtlCustomerMarginTolerance: overrideDefaultLtlCustomerMarginTolerance, overrideDefaultLtlTolerance: overrideDefaultLtlTolerance, podRequirementPolicy: podRequirementPolicy, references: references, requiredPayablesTypes: requiredPayablesTypes, requiredReceivablesTypes: requiredReceivablesTypes, rulesBrokerCustomExceptionMessages: rulesBrokerCustomExceptionMessages, rulesBrokerRequiredReferences: rulesBrokerRequiredReferences, statementCustomerInvoiceTemplateId: statementCustomerInvoiceTemplateId, templateVariables: templateVariables};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$BillingIntervalDaily = {$: 'BillingIntervalDaily'};
var $author$project$AuditPb$billingIntervalDefault = $author$project$AuditPb$BillingIntervalDaily;
var $author$project$AuditPb$BillingIntervalImmediately = {$: 'BillingIntervalImmediately'};
var $author$project$AuditPb$BillingIntervalMonthly = {$: 'BillingIntervalMonthly'};
var $author$project$AuditPb$BillingIntervalNever = {$: 'BillingIntervalNever'};
var $author$project$AuditPb$BillingIntervalWeekly = {$: 'BillingIntervalWeekly'};
var $author$project$AuditPb$allBillingInterval = _List_fromArray(
	[$author$project$AuditPb$BillingIntervalDaily, $author$project$AuditPb$BillingIntervalWeekly, $author$project$AuditPb$BillingIntervalMonthly, $author$project$AuditPb$BillingIntervalNever, $author$project$AuditPb$BillingIntervalImmediately]);
var $author$project$AuditPb$billingIntervalToString = function (v) {
	switch (v.$) {
		case 'BillingIntervalDaily':
			return 'daily';
		case 'BillingIntervalWeekly':
			return 'weekly';
		case 'BillingIntervalMonthly':
			return 'monthly';
		case 'BillingIntervalNever':
			return 'never';
		default:
			return 'immediately';
	}
};
var $author$project$AuditPb$billingIntervalDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$billingIntervalToString(v),
				v);
		},
		$author$project$AuditPb$allBillingInterval));
var $author$project$AuditPb$billingIntervalFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$billingIntervalDict);
};
var $author$project$AuditPb$billingIntervalDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$billingIntervalDefault),
		$author$project$AuditPb$billingIntervalFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$DeliveryMethod = function (method) {
	return {method: method};
};
var $author$project$AuditPb$DeliveryMethod_Method_BackupOnly = function (a) {
	return {$: 'DeliveryMethod_Method_BackupOnly', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_Email = function (a) {
	return {$: 'DeliveryMethod_Method_Email', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_FtpDelivery = function (a) {
	return {$: 'DeliveryMethod_Method_FtpDelivery', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_Multiple = function (a) {
	return {$: 'DeliveryMethod_Method_Multiple', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_Other = function (a) {
	return {$: 'DeliveryMethod_Method_Other', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_PaymentsNetwork = function (a) {
	return {$: 'DeliveryMethod_Method_PaymentsNetwork', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_PaymentsNetworkMultiple = function (a) {
	return {$: 'DeliveryMethod_Method_PaymentsNetworkMultiple', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_Print = function (a) {
	return {$: 'DeliveryMethod_Method_Print', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_TpayAPI = function (a) {
	return {$: 'DeliveryMethod_Method_TpayAPI', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Method_UploadCass = function (a) {
	return {$: 'DeliveryMethod_Method_UploadCass', a: a};
};
var $author$project$AuditPb$DeliveryMethod_BackupOnly = {};
var $author$project$AuditPb$deliveryMethod_BackupOnlyDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_BackupOnly);
	});
var $author$project$AuditPb$DeliveryMethod_Email = F4(
	function (emailPerInvoice, attachInvoices, billingEmailOverride, customInvoiceAttachmentFilename) {
		return {attachInvoices: attachInvoices, billingEmailOverride: billingEmailOverride, customInvoiceAttachmentFilename: customInvoiceAttachmentFilename, emailPerInvoice: emailPerInvoice};
	});
var $author$project$AuditPb$EmailPerInvoiceEmailAccountDefault = {$: 'EmailPerInvoiceEmailAccountDefault'};
var $author$project$AuditPb$emailPerInvoiceDefault = $author$project$AuditPb$EmailPerInvoiceEmailAccountDefault;
var $author$project$AuditPb$EmailPerInvoiceEmailPerInvoice = {$: 'EmailPerInvoiceEmailPerInvoice'};
var $author$project$AuditPb$EmailPerInvoiceEmailSingle = {$: 'EmailPerInvoiceEmailSingle'};
var $author$project$AuditPb$allEmailPerInvoice = _List_fromArray(
	[$author$project$AuditPb$EmailPerInvoiceEmailAccountDefault, $author$project$AuditPb$EmailPerInvoiceEmailPerInvoice, $author$project$AuditPb$EmailPerInvoiceEmailSingle]);
var $author$project$AuditPb$emailPerInvoiceToString = function (v) {
	switch (v.$) {
		case 'EmailPerInvoiceEmailAccountDefault':
			return 'email_account_default';
		case 'EmailPerInvoiceEmailPerInvoice':
			return 'email_per_invoice';
		default:
			return 'email_single';
	}
};
var $author$project$AuditPb$emailPerInvoiceDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$emailPerInvoiceToString(v),
				v);
		},
		$author$project$AuditPb$allEmailPerInvoice));
var $author$project$AuditPb$emailPerInvoiceFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$emailPerInvoiceDict);
};
var $author$project$AuditPb$emailPerInvoiceDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$emailPerInvoiceDefault),
		$author$project$AuditPb$emailPerInvoiceFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$deliveryMethod_EmailDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'custom_invoice_attachment_filename',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'billing_email_override',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'attach_invoices',
					$elm$json$Json$Decode$bool,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'email_per_invoice',
						$author$project$AuditPb$emailPerInvoiceDecoder,
						$author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_Email)))));
	});
var $author$project$AuditPb$DeliveryMethod_FtpDelivery = F7(
	function (filenameTemplate, host, username, password, rootDirectory, ftpPort, protocolType) {
		return {filenameTemplate: filenameTemplate, ftpPort: ftpPort, host: host, password: password, protocolType: protocolType, rootDirectory: rootDirectory, username: username};
	});
var $author$project$AuditPb$FtpProtocolTypeFtp = {$: 'FtpProtocolTypeFtp'};
var $author$project$AuditPb$ftpProtocolTypeDefault = $author$project$AuditPb$FtpProtocolTypeFtp;
var $author$project$AuditPb$FtpProtocolTypeSftp = {$: 'FtpProtocolTypeSftp'};
var $author$project$AuditPb$allFtpProtocolType = _List_fromArray(
	[$author$project$AuditPb$FtpProtocolTypeFtp, $author$project$AuditPb$FtpProtocolTypeSftp]);
var $author$project$AuditPb$ftpProtocolTypeToString = function (v) {
	if (v.$ === 'FtpProtocolTypeFtp') {
		return 'ftp';
	} else {
		return 'sftp';
	}
};
var $author$project$AuditPb$ftpProtocolTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$ftpProtocolTypeToString(v),
				v);
		},
		$author$project$AuditPb$allFtpProtocolType));
var $author$project$AuditPb$ftpProtocolTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$ftpProtocolTypeDict);
};
var $author$project$AuditPb$ftpProtocolTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$ftpProtocolTypeDefault),
		$author$project$AuditPb$ftpProtocolTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$deliveryMethod_FtpDeliveryDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'protocol_type',
			$author$project$AuditPb$ftpProtocolTypeDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'ftp_port',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'root_directory',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'password',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'username',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'host',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'filename_template',
									$elm$json$Json$Decode$string,
									$author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_FtpDelivery))))))));
	});
var $author$project$AuditPb$DeliveryMethod_Multiple = function (choices) {
	return {choices: choices};
};
var $author$project$AuditPb$DeliveryMethod_Choice = F2(
	function (regexPattern, method) {
		return {method: method, regexPattern: regexPattern};
	});
var $author$project$AuditPb$DeliveryMethod_Choice_Method_BackupOnly = function (a) {
	return {$: 'DeliveryMethod_Choice_Method_BackupOnly', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Choice_Method_Email = function (a) {
	return {$: 'DeliveryMethod_Choice_Method_Email', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Choice_Method_FtpDelivery = function (a) {
	return {$: 'DeliveryMethod_Choice_Method_FtpDelivery', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Choice_Method_Other = function (a) {
	return {$: 'DeliveryMethod_Choice_Method_Other', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Choice_Method_PaymentsNetwork = function (a) {
	return {$: 'DeliveryMethod_Choice_Method_PaymentsNetwork', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Choice_Method_Print = function (a) {
	return {$: 'DeliveryMethod_Choice_Method_Print', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Choice_Method_TpayAPI = function (a) {
	return {$: 'DeliveryMethod_Choice_Method_TpayAPI', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Choice_Method_UploadCass = function (a) {
	return {$: 'DeliveryMethod_Choice_Method_UploadCass', a: a};
};
var $author$project$AuditPb$DeliveryMethod_Other = F2(
	function (externalDeliveryMethod, externalEmailRecipients) {
		return {externalDeliveryMethod: externalDeliveryMethod, externalEmailRecipients: externalEmailRecipients};
	});
var $author$project$AuditPb$deliveryMethod_OtherDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'external_email_recipients',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'external_delivery_method',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_Other)));
	});
var $author$project$AuditPb$DeliveryMethod_PaymentsNetwork = {};
var $author$project$AuditPb$deliveryMethod_PaymentsNetworkDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_PaymentsNetwork);
	});
var $author$project$AuditPb$DeliveryMethod_Print = {};
var $author$project$AuditPb$deliveryMethod_PrintDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_Print);
	});
var $author$project$AuditPb$DeliveryMethod_TpayAPI = {};
var $author$project$AuditPb$deliveryMethod_TpayAPIDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_TpayAPI);
	});
var $author$project$AuditPb$DeliveryMethod_UploadCass = F3(
	function (account, username, password) {
		return {account: account, password: password, username: username};
	});
var $author$project$AuditPb$deliveryMethod_UploadCassDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'password',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'username',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'account',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_UploadCass))));
	});
var $author$project$AuditPb$deliveryMethod_Choice_MethodDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Choice_Method_Email,
					A2($elm$json$Json$Decode$field, 'email', $author$project$AuditPb$deliveryMethod_EmailDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Choice_Method_Print,
					A2($elm$json$Json$Decode$field, 'print', $author$project$AuditPb$deliveryMethod_PrintDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Choice_Method_PaymentsNetwork,
					A2($elm$json$Json$Decode$field, 'payments_network', $author$project$AuditPb$deliveryMethod_PaymentsNetworkDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Choice_Method_FtpDelivery,
					A2($elm$json$Json$Decode$field, 'ftp', $author$project$AuditPb$deliveryMethod_FtpDeliveryDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Choice_Method_UploadCass,
					A2($elm$json$Json$Decode$field, 'upload_cass', $author$project$AuditPb$deliveryMethod_UploadCassDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Choice_Method_TpayAPI,
					A2($elm$json$Json$Decode$field, 'tpay_api', $author$project$AuditPb$deliveryMethod_TpayAPIDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Choice_Method_BackupOnly,
					A2($elm$json$Json$Decode$field, 'backup_only', $author$project$AuditPb$deliveryMethod_BackupOnlyDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Choice_Method_Other,
					A2($elm$json$Json$Decode$field, 'other', $author$project$AuditPb$deliveryMethod_OtherDecoder)),
					$elm$json$Json$Decode$fail('DeliveryMethod_Choice_Method_Unspecified')
				]));
	});
var $author$project$AuditPb$deliveryMethod_ChoiceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$deliveryMethod_Choice_MethodDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'regex_pattern',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_Choice)));
	});
var $author$project$AuditPb$deliveryMethod_MultipleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'choices',
			$author$project$AuditPb$deliveryMethod_ChoiceDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_Multiple));
	});
var $author$project$AuditPb$DeliveryMethod_PaymentsNetworkMultiple = function (choices) {
	return {choices: choices};
};
var $author$project$AuditPb$deliveryMethod_PaymentsNetworkMultipleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'choices',
			$author$project$AuditPb$deliveryMethod_ChoiceDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod_PaymentsNetworkMultiple));
	});
var $author$project$AuditPb$deliveryMethod_MethodDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_Email,
					A2($elm$json$Json$Decode$field, 'email', $author$project$AuditPb$deliveryMethod_EmailDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_Print,
					A2($elm$json$Json$Decode$field, 'print', $author$project$AuditPb$deliveryMethod_PrintDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_PaymentsNetwork,
					A2($elm$json$Json$Decode$field, 'payments_network', $author$project$AuditPb$deliveryMethod_PaymentsNetworkDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_FtpDelivery,
					A2($elm$json$Json$Decode$field, 'ftp', $author$project$AuditPb$deliveryMethod_FtpDeliveryDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_UploadCass,
					A2($elm$json$Json$Decode$field, 'upload_cass', $author$project$AuditPb$deliveryMethod_UploadCassDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_Multiple,
					A2($elm$json$Json$Decode$field, 'multiple', $author$project$AuditPb$deliveryMethod_MultipleDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_PaymentsNetworkMultiple,
					A2($elm$json$Json$Decode$field, 'payments_network_multiple', $author$project$AuditPb$deliveryMethod_PaymentsNetworkMultipleDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_TpayAPI,
					A2($elm$json$Json$Decode$field, 'tpay_api', $author$project$AuditPb$deliveryMethod_TpayAPIDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_BackupOnly,
					A2($elm$json$Json$Decode$field, 'backup_only', $author$project$AuditPb$deliveryMethod_BackupOnlyDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DeliveryMethod_Method_Other,
					A2($elm$json$Json$Decode$field, 'other', $author$project$AuditPb$deliveryMethod_OtherDecoder)),
					$elm$json$Json$Decode$fail('DeliveryMethod_Method_Unspecified')
				]));
	});
var $author$project$AuditPb$deliveryMethodDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$deliveryMethod_MethodDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$DeliveryMethod));
	});
var $author$project$Domain$CustomerInvoiceTemplateId$CustomerInvoiceTemplateId = function (a) {
	return {$: 'CustomerInvoiceTemplateId', a: a};
};
var $author$project$Domain$CustomerInvoiceTemplateId$fromInt = $author$project$Domain$CustomerInvoiceTemplateId$CustomerInvoiceTemplateId;
var $author$project$AuditPb$TMSCustomerSettings_Contact = F5(
	function (id, name, email, urlHash, deleted) {
		return {deleted: deleted, email: email, id: id, name: name, urlHash: urlHash};
	});
var $author$project$AuditPb$tmsCustomerSettings_ContactDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'deleted',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'url_hash',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'email',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$ContactId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$TMSCustomerSettings_Contact))))));
	});
var $author$project$AuditPb$TMSCustomerSettings_Reference = F2(
	function (name, values) {
		return {name: name, values: values};
	});
var $author$project$AuditPb$tmsCustomerSettings_ReferenceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'values',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'name',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$TMSCustomerSettings_Reference)));
	});
var $author$project$AuditPb$tmsCustomerSettingsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'delivery_method',
			$author$project$AuditPb$deliveryMethodDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'rules_broker_custom_exception_messages',
				$author$project$AuditPb$customExceptionMessageDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'rules_broker_required_references',
					$author$project$AuditPb$referenceRuleDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'references',
						$author$project$AuditPb$tmsCustomerSettings_ReferenceDecoder,
						A3(
							$author$project$AuditPb$repeated,
							'contacts',
							$author$project$AuditPb$tmsCustomerSettings_ContactDecoder,
							A3(
								$author$project$AuditPb$repeated,
								'required_payables_types',
								$author$project$AuditPb$unresolvedDocumentTypeDecoder,
								A3(
									$author$project$AuditPb$repeated,
									'required_receivables_types',
									$author$project$AuditPb$unresolvedDocumentTypeDecoder,
									A3(
										$author$project$AuditPb$repeated,
										'customer_visible_document_types',
										$author$project$AuditPb$unresolvedDocumentTypeDecoder,
										A3(
											$author$project$AuditPb$optionalMessage,
											'bill_to_address',
											$author$project$AuditPb$addressDecoder,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'ltl_require_manual_reweigh_review',
												$elm$json$Json$Decode$bool,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'ltl_reweigh_charge_exceptions_enabled',
													$elm$json$Json$Decode$bool,
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'ltl_auto_rerate_enabled',
														$elm$json$Json$Decode$bool,
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'ltl_customer_margin_tolerance_maximum',
															$elm$json$Json$Decode$string,
															A3(
																$author$project$AuditPb$requiredWithoutDefault,
																'ltl_customer_margin_tolerance_minimum',
																$elm$json$Json$Decode$string,
																A3(
																	$author$project$AuditPb$requiredWithoutDefault,
																	'ltl_customer_margin_tolerance_unit',
																	$author$project$AuditPb$toleranceUnitDecoder,
																	A3(
																		$author$project$AuditPb$requiredWithoutDefault,
																		'override_default_ltl_customer_margin_tolerance',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$author$project$AuditPb$requiredWithoutDefault,
																			'ltl_carrier_invoice_amount_tolerance_under',
																			$elm$json$Json$Decode$string,
																			A3(
																				$author$project$AuditPb$requiredWithoutDefault,
																				'ltl_carrier_invoice_amount_tolerance_over',
																				$elm$json$Json$Decode$string,
																				A3(
																					$author$project$AuditPb$requiredWithoutDefault,
																					'ltl_carrier_invoice_amount_tolerance_unit',
																					$author$project$AuditPb$toleranceUnitDecoder,
																					A3(
																						$author$project$AuditPb$requiredWithoutDefault,
																						'override_default_ltl_tolerance',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$author$project$AuditPb$optional,
																							'account_remit_to_address_id',
																							A2($elm$json$Json$Decode$map, $author$project$Domain$AddressId$fromInt, $author$project$AuditPb$intDecoder),
																							A3(
																								$author$project$AuditPb$requiredWithoutDefault,
																								'ignore_customer_invoice_document',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$author$project$AuditPb$repeated,
																									'template_variables',
																									$elm$json$Json$Decode$string,
																									A3(
																										$author$project$AuditPb$requiredWithoutDefault,
																										'billing_email',
																										$elm$json$Json$Decode$string,
																										A3(
																											$author$project$AuditPb$requiredWithoutDefault,
																											'custom_subject_template',
																											$elm$json$Json$Decode$string,
																											A3(
																												$author$project$AuditPb$requiredWithoutDefault,
																												'pod_requirement_policy',
																												$author$project$AuditPb$podRequirementPolicyDecoder,
																												A3(
																													$author$project$AuditPb$requiredWithoutDefault,
																													'billing_interval',
																													$author$project$AuditPb$billingIntervalDecoder,
																													A3(
																														$author$project$AuditPb$repeated,
																														'instructions_list',
																														$elm$json$Json$Decode$string,
																														A3(
																															$author$project$AuditPb$requiredWithoutDefault,
																															'instructions_for_write',
																															$elm$json$Json$Decode$string,
																															A3(
																																$author$project$AuditPb$optional,
																																'master_customer_invoice_template_id',
																																A2($elm$json$Json$Decode$map, $author$project$Domain$CustomerInvoiceTemplateId$fromInt, $author$project$AuditPb$intDecoder),
																																A3(
																																	$author$project$AuditPb$optional,
																																	'statement_customer_invoice_template_id',
																																	A2($elm$json$Json$Decode$map, $author$project$Domain$CustomerInvoiceTemplateId$fromInt, $author$project$AuditPb$intDecoder),
																																	A3(
																																		$author$project$AuditPb$optional,
																																		'customer_invoice_template_id',
																																		A2($elm$json$Json$Decode$map, $author$project$Domain$CustomerInvoiceTemplateId$fromInt, $author$project$AuditPb$intDecoder),
																																		A3(
																																			$author$project$AuditPb$requiredWithoutDefault,
																																			'effective_days_to_pay',
																																			$author$project$AuditPb$intDecoder,
																																			A3(
																																				$author$project$AuditPb$optional,
																																				'account_number',
																																				$elm$json$Json$Decode$string,
																																				A3(
																																					$author$project$AuditPb$requiredWithoutDefault,
																																					'name',
																																					$elm$json$Json$Decode$string,
																																					A3(
																																						$author$project$AuditPb$requiredWithoutDefault,
																																						'id',
																																						A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
																																						$author$project$AuditPb$decode($author$project$AuditPb$TMSCustomerSettings)))))))))))))))))))))))))))))))))))));
	});
var $author$project$Domain$TmsCustomerSettings$decode = $author$project$AuditPb$tmsCustomerSettingsDecoder;
var $author$project$Forward$AppSpecific$Cache$tmsCustomerSettings = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.tmsCustomerSettings;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{tmsCustomerSettings: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerSettings = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$tmsCustomerSettings,
		decoder: $author$project$Domain$TmsCustomerSettings$decode,
		entrypoint: 'tmsCustomerSettingsV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsCustomerId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCustomerSettings = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerSettings,
		fieldName: 'tmsCustomerSettings',
		getId: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.load;
			},
			function ($) {
				return $.customerId;
			})
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsShipmentToTmsCustomerSettings = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerSettings,
		fieldName: 'tmsCustomersSettings',
		getId: function ($) {
			return $.customerId;
		}
	});
var $author$project$Broker$Page$BillingRequirements$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$traverseList,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsShipmentToTmsCustomerSettings,
			A2(
				$author$project$Forward$Lookup$map,
				$elm$core$Maybe$withDefault(_List_Nil),
				A2(
					$author$project$Forward$Lookup$traverseMaybe,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsShipments,
					A2(
						$author$project$Forward$Lookup$traverseMaybe,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadDetails,
						A2($author$project$Forward$Lookup$startFromMaybe, model.selectedCarrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice))))),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$map,
				$author$project$Helpers$Maybe$join,
				A2(
					$author$project$Forward$Lookup$traverseMaybe,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCustomerSettings,
					A2(
						$author$project$Forward$Lookup$traverseMaybe,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadDetails,
						A2($author$project$Forward$Lookup$startFromMaybe, model.selectedCarrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice)))),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
						$author$project$Forward$Lookup$succeed($author$project$Broker$Page$BillingRequirements$Data))))));
};
var $author$project$Broker$Page$DocumentsViewerPopout$Data = F2(
	function (documentsBrowserData, accountSettings) {
		return {accountSettings: accountSettings, documentsBrowserData: documentsBrowserData};
	});
var $author$project$Components$DocumentsBrowser$Data = function (currentAccount) {
	return function (accountSettings) {
		return function (currentUser) {
			return function (documentData) {
				return function (groupedDocumentData) {
					return function (activities) {
						return function (activityCarrierNames) {
							return function (emailMessageDataList) {
								return function (carrierInvoice) {
									return function (addDocumentToLoadData) {
										return function (invoiceStateByGroupId) {
											return function (factorInvoiceState) {
												return function (addressAnswers) {
													return {accountSettings: accountSettings, activities: activities, activityCarrierNames: activityCarrierNames, addDocumentToLoadData: addDocumentToLoadData, addressAnswers: addressAnswers, carrierInvoice: carrierInvoice, currentAccount: currentAccount, currentUser: currentUser, documentData: documentData, emailMessageDataList: emailMessageDataList, factorInvoiceState: factorInvoiceState, groupedDocumentData: groupedDocumentData, invoiceStateByGroupId: invoiceStateByGroupId};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Forward$AppSpecific$Cache$activityItem = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.activityItem;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{activityItem: e});
		}));
var $author$project$Domain$ActivityItemId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItem = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$activityItem,
		decoder: $author$project$Domain$ActivityItem$decode,
		entrypoint: 'activityItems',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$ActivityItemId$toInt)
	});
var $author$project$Stream$Stream = F2(
	function (a, b) {
		return {$: 'Stream', a: a, b: b};
	});
var $author$project$AuditPb$Stream = F2(
	function (ids, hasMore) {
		return {hasMore: hasMore, ids: ids};
	});
var $author$project$AuditPb$streamDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'has_more',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$repeated,
				'ids',
				$author$project$AuditPb$intDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$Stream)));
	});
var $author$project$Stream$decoder = function (intToId) {
	var streamDecoder = function (result) {
		return A2(
			$author$project$Helpers$Json$Decode$apply,
			$elm$json$Json$Decode$succeed(result.hasMore),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$List$map(intToId),
					$elm$json$Json$Decode$succeed(result.ids)),
				$elm$json$Json$Decode$succeed($author$project$Stream$Stream)));
	};
	return A2($elm$json$Json$Decode$andThen, streamDecoder, $author$project$AuditPb$streamDecoder);
};
var $author$project$Stream$map = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(
			$author$project$Stream$Stream,
			A2($elm$core$List$map, f, a),
			b);
	});
var $author$project$Stream$hasMore = function (_v0) {
	var hasMore_ = _v0.b;
	return hasMore_;
};
var $author$project$Stream$init = F2(
	function (value_, hasMore_) {
		return A2($author$project$Stream$Stream, value_, hasMore_);
	});
var $author$project$Stream$value = function (_v0) {
	var value_ = _v0.a;
	return value_;
};
var $author$project$Forward$Internal$Loadable$streamOfLoadablesToLoadableStream = function (stream) {
	return A2(
		$author$project$Forward$Internal$Loadable$map,
		function (a) {
			return A2(
				$author$project$Stream$init,
				a,
				$author$project$Stream$hasMore(stream));
		},
		$author$project$Forward$Internal$Loadable$listOfLoadablesToLoadableList(
			$author$project$Stream$value(stream)));
};
var $author$project$Forward$Lookup$traverseStream = A2(
	$author$project$Forward$Lookup$traverseHelper,
	'traverseStream',
	{containerOfLoadablesToLoadableContainer: $author$project$Forward$Internal$Loadable$streamOfLoadablesToLoadableStream, map: $author$project$Stream$map});
var $author$project$Forward$Lookup$defineReferenceStream = function (config) {
	return A2(
		$author$project$Forward$Lookup$traverseStream,
		config.objectEntrypoint,
		$author$project$Forward$Lookup$defineNode(
			{
				cacheKey: config.cacheKey,
				decoder: $author$project$Stream$decoder(config.idFromInt),
				entrypoint: config.entrypoint,
				parameters: config.parameters
			}));
};
var $author$project$AuditPb$activityItemIdsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page),
					A3($author$project$AuditPb$optionalEncoder, 'activity_type', $elm$json$Json$Encode$string, v.activityType),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'user_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$UserId$toInt),
					v.userId),
					A3($author$project$AuditPb$optionalEncoder, 'start_date', $elm$json$Json$Encode$string, v.startDate),
					A3($author$project$AuditPb$optionalEncoder, 'end_date', $elm$json$Json$Encode$string, v.endDate),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'factor_broker_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorBrokerId$toInt),
					v.factorBrokerId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'tms_carrier_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCarrierId$toInt),
					v.tmsCarrierId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'tms_customer_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCustomerId$toInt),
					v.tmsCustomerId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'carrier_invoice_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'document_batch_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentBatchId$toInt),
					v.documentBatchId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'load_state_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$LoadStateId$toInt),
					v.loadStateId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'document_group_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentGroupId$toInt),
					v.documentGroupId),
					A3($author$project$AuditPb$optionalEncoder, 'invoice_num_or_load_id', $elm$json$Json$Encode$string, v.invoiceNumOrLoadId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'factor_invoice_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId)
				])));
};
var $author$project$Domain$ActivityItemIdsQuery$encode = function (activityItemIdsQuery) {
	return $author$project$AuditPb$activityItemIdsQueryEncoder(activityItemIdsQuery);
};
var $author$project$Forward$AppSpecific$Cache$stream_activityItemId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.stream_activityItemId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{stream_activityItemId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemsByQuery = $author$project$Forward$Lookup$defineReferenceStream(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$stream_activityItemId,
		entrypoint: 'activityItemIdsStreamByQuery',
		idFromInt: $author$project$Domain$ActivityItemId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItem,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$ActivityItemIdsQuery$encode)
	});
var $author$project$Forward$AppSpecific$Cache$loadState = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.loadState;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{loadState: e});
		}));
var $author$project$AuditPb$LoadState = F4(
	function (id, loadId, createdAt, updatedAt) {
		return {createdAt: createdAt, id: id, loadId: loadId, updatedAt: updatedAt};
	});
var $author$project$AuditPb$loadStateDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'updated_at',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'created_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'load_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$TmsLoadId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$LoadStateId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$LoadState)))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadState = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$loadState,
		decoder: $author$project$AuditPb$loadStateDecoder,
		entrypoint: 'loadStates',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$LoadStateId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToLoadState = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadState,
		fieldName: 'loadState',
		getId: function ($) {
			return $.loadStateId;
		}
	});
var $author$project$Domain$ActivityItemIdsQuery$forPage = function (page) {
	return {activityType: $elm$core$Maybe$Nothing, carrierInvoiceId: $elm$core$Maybe$Nothing, documentBatchId: $elm$core$Maybe$Nothing, documentGroupId: $elm$core$Maybe$Nothing, endDate: $elm$core$Maybe$Nothing, factorBrokerId: $elm$core$Maybe$Nothing, factorInvoiceId: $elm$core$Maybe$Nothing, invoiceNumOrLoadId: $elm$core$Maybe$Nothing, loadStateId: $elm$core$Maybe$Nothing, page: page, startDate: $elm$core$Maybe$Nothing, tmsCarrierId: $elm$core$Maybe$Nothing, tmsCustomerId: $elm$core$Maybe$Nothing, userId: $elm$core$Maybe$Nothing};
};
var $author$project$Components$DocumentsBrowser$buildActivities = function (_v0) {
	var currentProcessingSelection = _v0.currentProcessingSelection;
	var activityTabPage = _v0.activityTabPage;
	var pageQuery = $author$project$Domain$ActivityItemIdsQuery$forPage(activityTabPage);
	var lookupActivityItems = function (query) {
		return A2($author$project$Forward$Lookup$startFrom, query, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemsByQuery);
	};
	switch (currentProcessingSelection.$) {
		case 'CarrierInvoiceSelection':
			var carrierInvoiceId = currentProcessingSelection.a;
			var lookupLoadState = A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToLoadState,
				A2($author$project$Forward$Lookup$startFrom, carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice));
			var loadStateToQuery = function (loadState) {
				return _Utils_update(
					pageQuery,
					{
						loadStateId: $elm$core$Maybe$Just(loadState.id)
					});
			};
			return A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemsByQuery,
				A2($author$project$Forward$Lookup$map, loadStateToQuery, lookupLoadState));
		case 'FactorInvoiceSelection':
			var factorInvoiceId = currentProcessingSelection.a;
			return lookupActivityItems(
				_Utils_update(
					pageQuery,
					{
						factorInvoiceId: $elm$core$Maybe$Just(factorInvoiceId)
					}));
		case 'GroupedDocumentBatchSelection':
			var documentGroupId = currentProcessingSelection.b;
			return lookupActivityItems(
				_Utils_update(
					pageQuery,
					{
						documentGroupId: $elm$core$Maybe$Just(documentGroupId)
					}));
		case 'DocumentBatchSelection':
			var documentBatchId = currentProcessingSelection.a;
			return lookupActivityItems(
				_Utils_update(
					pageQuery,
					{
						documentBatchId: $elm$core$Maybe$Just(documentBatchId)
					}));
		case 'EmailMessageSelection':
			return $author$project$Forward$Lookup$succeed(
				A2($author$project$Stream$init, _List_Nil, false));
		case 'SinglePageSelection':
			return $author$project$Forward$Lookup$succeed(
				A2($author$project$Stream$init, _List_Nil, false));
		case 'NonInvoiceLoadSelection':
			var loadStateId = currentProcessingSelection.a;
			return lookupActivityItems(
				_Utils_update(
					pageQuery,
					{
						loadStateId: $elm$core$Maybe$Just(loadStateId)
					}));
		case 'DocumentReviewSelection':
			return $author$project$Forward$Lookup$succeed(
				A2($author$project$Stream$init, _List_Nil, false));
		case 'DocumentBatchReviewSelection':
			return $author$project$Forward$Lookup$succeed(
				A2($author$project$Stream$init, _List_Nil, false));
		case 'DocumentGroupReviewSelection':
			return $author$project$Forward$Lookup$succeed(
				A2($author$project$Stream$init, _List_Nil, false));
		default:
			return $author$project$Forward$Lookup$succeed(
				A2($author$project$Stream$init, _List_Nil, false));
	}
};
var $author$project$Components$DocumentsBrowser$factorInvoiceProcessedCarrierId = function (activityItem) {
	var _v0 = activityItem.details;
	_v0$2:
	while (true) {
		switch (_v0.$) {
			case 'InvoiceProcessed':
				if (_v0.a.$ === 'FactorInvoiceProcessedDetails_') {
					var details = _v0.a.a;
					return $elm$core$Maybe$Just(details.tmsCarrierId);
				} else {
					break _v0$2;
				}
			case 'InvoiceAutoProcessed':
				var details = _v0.a;
				return $elm$core$Maybe$Just(details.tmsCarrierId);
			default:
				break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Domain$TmsCarrierId$toComparable = function (id) {
	return _Utils_Tuple2(
		'tmsCarrierId',
		$author$project$Domain$TmsCarrierId$toInt(id));
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Components$DocumentsBrowser$buildActivityCarrierNames = function (model) {
	return A2(
		$author$project$Forward$Lookup$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function (carrier) {
					return _Utils_Tuple2(
						$author$project$Domain$TmsCarrierId$toComparable(carrier.id),
						carrier.name);
				}),
			$elm$core$Dict$fromList),
		A2(
			$author$project$Forward$Lookup$traverseList,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
			A2(
				$author$project$Forward$Lookup$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Stream$value,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filterMap($author$project$Components$DocumentsBrowser$factorInvoiceProcessedCarrierId),
						$elm_community$list_extra$List$Extra$uniqueBy($author$project$Domain$TmsCarrierId$toComparable))),
				$author$project$Components$DocumentsBrowser$buildActivities(model))));
};
var $elm_community$dict_extra$Dict$Extra$groupBy = F2(
	function (keyfn, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$update,
						keyfn(x),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$elm$core$List$cons(x)),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(
									_List_fromArray(
										[x])),
								$elm$core$Maybe$Just)),
						acc);
				}),
			$elm$core$Dict$empty,
			list);
	});
var $author$project$Domain$DocumentPageId$toComparable = function (id) {
	return _Utils_Tuple2(
		'documentPageId',
		$author$project$Domain$DocumentPageId$toInt(id));
};
var $author$project$Components$DocumentsBrowser$answersByPage = function (answers) {
	return A2(
		$elm_community$dict_extra$Dict$Extra$groupBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.documentPageId;
			},
			$author$project$Domain$DocumentPageId$toComparable),
		answers);
};
var $author$project$Components$DocumentBrowser$Full$DocumentData = F2(
	function (documents, documentPages) {
		return {documentPages: documentPages, documents: documents};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPagesByDocumentId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentPageId,
		decoder: $author$project$Domain$DocumentPageId$decode,
		entrypoint: 'documentPageIds',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPage,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPagesByDocumentId,
		fieldName: 'pages',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Components$DocumentsBrowser$FullDocumentData = F3(
	function (browserDocumentData, lines, hasHiddenLoadDocuments) {
		return {browserDocumentData: browserDocumentData, hasHiddenLoadDocuments: hasHiddenLoadDocuments, lines: lines};
	});
var $author$project$Components$DocumentsBrowser$emptyDocumentData = A2($author$project$Components$DocumentBrowser$Full$DocumentData, _List_Nil, _List_Nil);
var $author$project$Components$DocumentsBrowser$emptyFullDocumentData = A3($author$project$Components$DocumentsBrowser$FullDocumentData, $author$project$Components$DocumentsBrowser$emptyDocumentData, $elm$core$Dict$empty, false);
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments = $author$project$Forward$Lookup$defineListEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'documents',
		getIds: function ($) {
			return $.documentIds;
		}
	});
var $author$project$Domain$DocumentBatchGroupingReview$DocumentBatchGroupingReview = F2(
	function (id, documentBatchId) {
		return {documentBatchId: documentBatchId, id: id};
	});
var $author$project$Domain$DocumentBatchGroupingReviewId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchGroupingReviewId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$DocumentBatchGroupingReview$decode = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2($elm$json$Json$Decode$field, 'document_batch_id', $author$project$Domain$DocumentBatchId$decode),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$DocumentBatchGroupingReviewId$decode),
		$elm$json$Json$Decode$succeed($author$project$Domain$DocumentBatchGroupingReview$DocumentBatchGroupingReview)));
var $author$project$Forward$AppSpecific$Cache$documentBatchGroupingReview = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentBatchGroupingReview;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentBatchGroupingReview: e});
		}));
var $author$project$Domain$DocumentBatchGroupingReviewId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchGroupingReview = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$documentBatchGroupingReview,
		decoder: $author$project$Domain$DocumentBatchGroupingReview$decode,
		entrypoint: 'documentBatchGroupingReview',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentBatchGroupingReviewId$toInt)
	});
var $author$project$Broker$Shared$DocumentBatchReviewHelper$loadDocuments = function (documentBatchReviewId) {
	var id = documentBatchReviewId.a;
	return A2(
		$author$project$Forward$Lookup$traverse,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.documentBatchId;
			},
			A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchGroupingReview)));
};
var $author$project$Domain$DocumentGroupLoadReview$DocumentGroupLoadReview = F5(
	function (id, documentGroupId, documentBatchId, guessedLoads, extractedCarrier) {
		return {documentBatchId: documentBatchId, documentGroupId: documentGroupId, extractedCarrier: extractedCarrier, guessedLoads: guessedLoads, id: id};
	});
var $author$project$Domain$LoadSearch$CarrierSummary = F6(
	function (id, name, mcNumber, scac, city, state) {
		return {city: city, id: id, mcNumber: mcNumber, name: name, scac: scac, state: state};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (_v0.$ === 'Ok') {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (_v1.$ === 'Ok') {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Domain$LoadSearch$carrierSummaryDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'state',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'city',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'scac',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'mc_number',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'name',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'id',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						$elm$core$Maybe$Nothing,
						$elm$json$Json$Decode$succeed($author$project$Domain$LoadSearch$CarrierSummary)))))));
var $author$project$Domain$DocumentGroupLoadReviewId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentGroupLoadReviewId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$LoadSearch$LoadState = F6(
	function (id, load, emailIds, factorInvoiceIds, invoiceNumber, isGuessed) {
		return {emailIds: emailIds, factorInvoiceIds: factorInvoiceIds, id: id, invoiceNumber: invoiceNumber, isGuessed: isGuessed, load: load};
	});
var $author$project$Domain$EmailMessageId$decode = $author$project$Id$decoder;
var $author$project$Domain$TmsLoadId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$TmsLoadId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$LoadSearch$Load = function (loadId) {
	return function (carrier) {
		return function (tmsShipmentIds) {
			return function (originCity) {
				return function (originState) {
					return function (originPostalCode) {
						return function (originName) {
							return function (destinationCity) {
								return function (destinationState) {
									return function (destinationPostalCode) {
										return function (destinationName) {
											return function (visibleReferences) {
												return function (customer) {
													return function (office) {
														return {carrier: carrier, customer: customer, destinationCity: destinationCity, destinationName: destinationName, destinationPostalCode: destinationPostalCode, destinationState: destinationState, loadId: loadId, office: office, originCity: originCity, originName: originName, originPostalCode: originPostalCode, originState: originState, tmsShipmentIds: tmsShipmentIds, visibleReferences: visibleReferences};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Domain$TmsShipmentId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$TmsShipmentId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$LoadSearch$loadDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'office',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'customer',
		$elm$json$Json$Decode$nullable($author$project$AuditPb$tmsCustomerDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'visible_references',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$toList,
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'destination_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'destination_postal_code',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'destination_state',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'destination_city',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'origin_name',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'origin_postal_code',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'origin_state',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'origin_city',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'tms_shipment_ids',
												$elm$json$Json$Decode$list($author$project$Domain$TmsShipmentId$decode),
												_List_Nil,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'carrier',
													$elm$json$Json$Decode$nullable($author$project$Domain$LoadSearch$carrierSummaryDecoder),
													$elm$core$Maybe$Nothing,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'load_id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Domain$LoadSearch$Load)))))))))))))));
var $author$project$Domain$LoadSearch$loadStateDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'is_guessed',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'invoice_number',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'factor_invoice_ids',
			$elm$json$Json$Decode$list($author$project$Domain$FactorInvoiceId$decode),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'email_ids',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$List$filterMap($elm$core$Basics$identity),
					$elm$json$Json$Decode$list(
						$elm$json$Json$Decode$nullable($author$project$Domain$EmailMessageId$decode))),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'load',
					$author$project$Domain$LoadSearch$loadDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Domain$TmsLoadId$decode,
						$elm$json$Json$Decode$succeed($author$project$Domain$LoadSearch$LoadState)))))));
var $author$project$Domain$DocumentGroupLoadReview$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'extracted_carrier',
	$elm$json$Json$Decode$nullable($author$project$Domain$LoadSearch$carrierSummaryDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'guessed_loads',
		$elm$json$Json$Decode$list($author$project$Domain$LoadSearch$loadStateDecoder),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2($elm$json$Json$Decode$field, 'document_batch_id', $author$project$Domain$DocumentBatchId$decode),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				A2($elm$json$Json$Decode$field, 'document_group_id', $author$project$Domain$DocumentGroupId$decode),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$DocumentGroupLoadReviewId$decode),
					$elm$json$Json$Decode$succeed($author$project$Domain$DocumentGroupLoadReview$DocumentGroupLoadReview))))));
var $author$project$Forward$AppSpecific$Cache$documentGroupLoadReview = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentGroupLoadReview;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentGroupLoadReview: e});
		}));
var $author$project$Domain$DocumentGroupLoadReviewId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReview = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$documentGroupLoadReview,
		decoder: $author$project$Domain$DocumentGroupLoadReview$decode,
		entrypoint: 'documentGroupLoadReview',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentGroupLoadReviewId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReviewToDocumentGroup = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup,
		fieldName: 'documentGroup',
		getId: function ($) {
			return $.documentGroupId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentGroupId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentId,
		decoder: $author$project$Domain$DocumentId$decode,
		entrypoint: 'documentIdsByDocumentGroupId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentGroupId$toInt)
	});
var $author$project$Broker$Shared$DocumentGroupReviewHelper$loadDocuments = function (documentGroupReviewId) {
	var id = documentGroupReviewId.a;
	return A2(
		$author$project$Forward$Lookup$traverse,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentGroupId,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.id;
			},
			A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReviewToDocumentGroup,
				A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReview))));
};
var $author$project$Domain$DocumentLoadReferenceMatchReview$DocumentLoadReferenceMatchReview = F4(
	function (id, documentId, tmsLoadId, documentReferencesMatchLoad) {
		return {documentId: documentId, documentReferencesMatchLoad: documentReferencesMatchLoad, id: id, tmsLoadId: tmsLoadId};
	});
var $author$project$Domain$DocumentLoadReferenceMatchReviewId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentLoadReferenceMatchReviewId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$DocumentLoadReferenceMatchReview$decode = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2(
		$elm$json$Json$Decode$field,
		'document_references_match_load',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool)),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		A2($elm$json$Json$Decode$field, 'tms_load_id', $author$project$Domain$TmsLoadId$decode),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2($elm$json$Json$Decode$field, 'document_id', $author$project$Domain$DocumentId$decode),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$DocumentLoadReferenceMatchReviewId$decode),
				$elm$json$Json$Decode$succeed($author$project$Domain$DocumentLoadReferenceMatchReview$DocumentLoadReferenceMatchReview)))));
var $author$project$Forward$AppSpecific$Cache$documentLoadReferenceMatchReview = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentLoadReferenceMatchReview;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentLoadReferenceMatchReview: e});
		}));
var $author$project$Domain$DocumentLoadReferenceMatchReviewId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReview = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$documentLoadReferenceMatchReview,
		decoder: $author$project$Domain$DocumentLoadReferenceMatchReview$decode,
		entrypoint: 'documentLoadReferenceMatchReview',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentLoadReferenceMatchReviewId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReviewToDocument = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'document',
		getId: function ($) {
			return $.documentId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$documentTypeReview = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.documentTypeReview;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{documentTypeReview: e});
		}));
var $author$project$AuditPb$DocumentTypeReview = F2(
	function (id, documentId) {
		return {documentId: documentId, id: id};
	});
var $author$project$AuditPb$documentTypeReviewDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'document_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentTypeReviewId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$DocumentTypeReview)));
	});
var $author$project$Domain$DocumentTypeReviewId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReview = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$documentTypeReview,
		decoder: $author$project$AuditPb$documentTypeReviewDecoder,
		entrypoint: 'documentTypeReview',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentTypeReviewId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReviewToDocument = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'document',
		getId: function ($) {
			return $.documentId;
		}
	});
var $author$project$Domain$InvoiceAmountReview$InvoiceAmountReview = F2(
	function (id, documentId) {
		return {documentId: documentId, id: id};
	});
var $author$project$Domain$InvoiceAmountReviewId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$InvoiceAmountReviewId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$InvoiceAmountReview$decode = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2($elm$json$Json$Decode$field, 'document_id', $author$project$Domain$DocumentId$decode),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$InvoiceAmountReviewId$decode),
		$elm$json$Json$Decode$succeed($author$project$Domain$InvoiceAmountReview$InvoiceAmountReview)));
var $author$project$Forward$AppSpecific$Cache$invoiceAmountReview = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.invoiceAmountReview;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{invoiceAmountReview: e});
		}));
var $author$project$Domain$InvoiceAmountReviewId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceAmountReview = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$invoiceAmountReview,
		decoder: $author$project$Domain$InvoiceAmountReview$decode,
		entrypoint: 'invoiceAmountReview',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$InvoiceAmountReviewId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceAmountReviewToDocument = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'document',
		getId: function ($) {
			return $.documentId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$invoiceNumberReview = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.invoiceNumberReview;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{invoiceNumberReview: e});
		}));
var $author$project$AuditPb$InvoiceNumberReview = F2(
	function (id, documentId) {
		return {documentId: documentId, id: id};
	});
var $author$project$AuditPb$invoiceNumberReviewDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'document_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$InvoiceNumberReviewId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$InvoiceNumberReview)));
	});
var $author$project$Domain$InvoiceNumberReviewId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceNumberReview = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$invoiceNumberReview,
		decoder: $author$project$AuditPb$invoiceNumberReviewDecoder,
		entrypoint: 'invoiceNumberReview',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$InvoiceNumberReviewId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceNumberReviewToDocument = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'document',
		getId: function ($) {
			return $.documentId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$multiPageBolReview = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.multiPageBolReview;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{multiPageBolReview: e});
		}));
var $author$project$AuditPb$MultiPageBolReview = F4(
	function (id, documentId, allPagesAreSameBol, allPagesOfBolPresent) {
		return {allPagesAreSameBol: allPagesAreSameBol, allPagesOfBolPresent: allPagesOfBolPresent, documentId: documentId, id: id};
	});
var $author$project$AuditPb$MultiPageBolReviewAnswerNo = {$: 'MultiPageBolReviewAnswerNo'};
var $author$project$AuditPb$multiPageBolReviewAnswerDefault = $author$project$AuditPb$MultiPageBolReviewAnswerNo;
var $author$project$AuditPb$MultiPageBolReviewAnswerUnsure = {$: 'MultiPageBolReviewAnswerUnsure'};
var $author$project$AuditPb$MultiPageBolReviewAnswerYes = {$: 'MultiPageBolReviewAnswerYes'};
var $author$project$AuditPb$allMultiPageBolReviewAnswer = _List_fromArray(
	[$author$project$AuditPb$MultiPageBolReviewAnswerNo, $author$project$AuditPb$MultiPageBolReviewAnswerUnsure, $author$project$AuditPb$MultiPageBolReviewAnswerYes]);
var $author$project$AuditPb$multiPageBolReviewAnswerToString = function (v) {
	switch (v.$) {
		case 'MultiPageBolReviewAnswerNo':
			return 'no';
		case 'MultiPageBolReviewAnswerUnsure':
			return 'unsure';
		default:
			return 'yes';
	}
};
var $author$project$AuditPb$multiPageBolReviewAnswerDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$multiPageBolReviewAnswerToString(v),
				v);
		},
		$author$project$AuditPb$allMultiPageBolReviewAnswer));
var $author$project$AuditPb$multiPageBolReviewAnswerFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$multiPageBolReviewAnswerDict);
};
var $author$project$AuditPb$multiPageBolReviewAnswerDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$multiPageBolReviewAnswerDefault),
		$author$project$AuditPb$multiPageBolReviewAnswerFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$multiPageBolReviewDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'all_pages_of_bol_present',
			$author$project$AuditPb$multiPageBolReviewAnswerDecoder,
			A3(
				$author$project$AuditPb$optional,
				'all_pages_are_same_bol',
				$author$project$AuditPb$multiPageBolReviewAnswerDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'document_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$MultiPageBolReviewId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$MultiPageBolReview)))));
	});
var $author$project$Domain$MultiPageBolReviewId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReview = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$multiPageBolReview,
		decoder: $author$project$AuditPb$multiPageBolReviewDecoder,
		entrypoint: 'multiPageBolReview',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$MultiPageBolReviewId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReviewToDocument = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'document',
		getId: function ($) {
			return $.documentId;
		}
	});
var $author$project$Broker$Shared$DocumentReviewHelper$loadDocuments = function (documentReviewId) {
	switch (documentReviewId.$) {
		case 'InvoiceNumberReviewId':
			var id = documentReviewId.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$List$singleton,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceNumberReviewToDocument,
					A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceNumberReview)));
		case 'InvoiceAmountReviewId':
			var id = documentReviewId.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$List$singleton,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceAmountReviewToDocument,
					A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceAmountReview)));
		case 'MultiPageBolReviewId':
			var id = documentReviewId.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$List$singleton,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReviewToDocument,
					A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReview)));
		case 'DocumentTypeReviewId':
			var id = documentReviewId.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$List$singleton,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReviewToDocument,
					A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReview)));
		default:
			var id = documentReviewId.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$List$singleton,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReviewToDocument,
					A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReview)));
	}
};
var $author$project$Components$DocumentsBrowser$comparableDocumentByBatchAndNumber = function (doc) {
	return _Utils_Tuple2(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $author$project$Domain$DocumentBatchId$toInt, doc.documentBatchId)),
		doc.number);
};
var $author$project$Components$DocumentsBrowser$sortByBatchAndNumber = F2(
	function (documents, documentPages) {
		return A2(
			$elm$core$List$sortBy,
			function (_v0) {
				var doc = _v0.a;
				return $author$project$Components$DocumentsBrowser$comparableDocumentByBatchAndNumber(doc);
			},
			A3($elm$core$List$map2, $elm$core$Tuple$pair, documents, documentPages));
	});
var $author$project$Domain$UnresolvedDocumentType$serialize = function (unresolvedDocumentType) {
	switch (unresolvedDocumentType.$) {
		case 'Resolved':
			var documentType = unresolvedDocumentType.a;
			return $author$project$AuditPb$documentTypeToString(documentType);
		case 'Unknown':
			return 'Unknown';
		default:
			var partialDocumentType = unresolvedDocumentType.a;
			return $author$project$AuditPb$documentTypePartialToString(partialDocumentType);
	}
};
var $author$project$Components$DocumentBrowser$Full$doctypesAtTheEnd = _List_fromArray(
	['other']);
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $author$project$Components$DocumentBrowser$Full$doctypesAtTheEndIndex = function (doctype) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$List$length($author$project$Components$DocumentBrowser$Full$doctypesAtTheEnd),
		A2(
			$elm_community$list_extra$List$Extra$findIndex,
			$elm$core$Basics$eq(doctype),
			$author$project$Components$DocumentBrowser$Full$doctypesAtTheEnd));
};
var $author$project$Components$DocumentBrowser$Full$doctypesAtTheEndOrder = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(
			A2($elm$core$List$member, a, $author$project$Components$DocumentBrowser$Full$doctypesAtTheEnd),
			A2($elm$core$List$member, b, $author$project$Components$DocumentBrowser$Full$doctypesAtTheEnd));
		if (_v0.a) {
			if (_v0.b) {
				return A2(
					$elm$core$Basics$compare,
					$author$project$Components$DocumentBrowser$Full$doctypesAtTheEndIndex(a),
					$author$project$Components$DocumentBrowser$Full$doctypesAtTheEndIndex(b));
			} else {
				return $elm$core$Basics$GT;
			}
		} else {
			if (_v0.b) {
				return $elm$core$Basics$LT;
			} else {
				return A2($elm$core$Basics$compare, a, b);
			}
		}
	});
var $author$project$Components$DocumentBrowser$Full$doctypesAtTheStart = _List_fromArray(
	['invoice', 'rateConfirmation', 'billOfLading', 'deliveryReceipt', 'customerRateCon']);
var $author$project$Components$DocumentBrowser$Full$doctypesAtTheStartIndex = function (doctype) {
	return A2(
		$elm$core$Maybe$withDefault,
		-1,
		A2(
			$elm_community$list_extra$List$Extra$findIndex,
			$elm$core$Basics$eq(doctype),
			$author$project$Components$DocumentBrowser$Full$doctypesAtTheStart));
};
var $author$project$Components$DocumentBrowser$Full$sortedDoctypeGrouping = $elm$core$List$sortWith(
	F2(
		function (_v0, _v1) {
			var a = _v0.a;
			var b = _v1.a;
			var _v2 = _Utils_Tuple2(
				A2($elm$core$List$member, a, $author$project$Components$DocumentBrowser$Full$doctypesAtTheStart),
				A2($elm$core$List$member, b, $author$project$Components$DocumentBrowser$Full$doctypesAtTheStart));
			if (_v2.a) {
				if (_v2.b) {
					return A2(
						$elm$core$Basics$compare,
						$author$project$Components$DocumentBrowser$Full$doctypesAtTheStartIndex(a),
						$author$project$Components$DocumentBrowser$Full$doctypesAtTheStartIndex(b));
				} else {
					return $elm$core$Basics$LT;
				}
			} else {
				if (_v2.b) {
					return $elm$core$Basics$GT;
				} else {
					return A2($author$project$Components$DocumentBrowser$Full$doctypesAtTheEndOrder, a, b);
				}
			}
		}));
var $author$project$Components$DocumentsBrowser$sortByDoctype = F2(
	function (documents, documentPages) {
		var pairs = A3($elm$core$List$map2, $elm$core$Tuple$pair, documents, documentPages);
		var getDoctypeString = function (_v0) {
			var doc = _v0.a;
			return $author$project$Domain$UnresolvedDocumentType$serialize(
				$author$project$Domain$Document$documentTypeValueToUnresolved(doc.documentTypeValue));
		};
		var doctypeGroups = A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			$author$project$Components$DocumentBrowser$Full$sortedDoctypeGrouping(
				$elm$core$Dict$toList(
					A2($elm_community$dict_extra$Dict$Extra$groupBy, getDoctypeString, pairs))));
		return $elm$core$List$concat(doctypeGroups);
	});
var $author$project$Components$DocumentsBrowser$sortDocumentsByAccountSettings = F3(
	function (accountSettings, documents, documentPages) {
		return accountSettings.documentsViewerDoctypeGroupingEnabled ? A2($author$project$Components$DocumentsBrowser$sortByDoctype, documents, documentPages) : A2($author$project$Components$DocumentsBrowser$sortByBatchAndNumber, documents, documentPages);
	});
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$Components$DocumentsBrowser$buildDocumentData = function (model) {
	var buildLineDict = F2(
		function (documentPages, lines) {
			return $elm$core$Dict$fromList(
				function (ids) {
					return A2($elm_community$list_extra$List$Extra$zip, ids, lines);
				}(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.id;
							},
							$author$project$Domain$DocumentPageId$toComparable),
						$elm$core$List$concat(documentPages))));
		});
	var fullDocumentDataConstructor = F5(
		function (accountSettings, documents, documentPages, lines, hasHiddenLoadDocuments) {
			var sortedPairs = A3($author$project$Components$DocumentsBrowser$sortDocumentsByAccountSettings, accountSettings, documents, documentPages);
			var sortedDocuments = A2($elm$core$List$map, $elm$core$Tuple$first, sortedPairs);
			var sortedDocumentPages = A2($elm$core$List$map, $elm$core$Tuple$second, sortedPairs);
			return {
				browserDocumentData: A2($author$project$Components$DocumentBrowser$Full$DocumentData, sortedDocuments, sortedDocumentPages),
				hasHiddenLoadDocuments: hasHiddenLoadDocuments,
				lines: A2(buildLineDict, documentPages, lines)
			};
		});
	var lookupDocDataFromDocumentBatchId = function (documentBatchId) {
		return A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$succeed(false),
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$traverseList,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
					A2(
						$author$project$Forward$Lookup$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$concat,
							$elm$core$List$map(
								function ($) {
									return $.id;
								})),
						A2(
							$author$project$Forward$Lookup$traverseList,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages,
							A2($author$project$Forward$Lookup$startFrom, documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId)))),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages,
						A2($author$project$Forward$Lookup$startFrom, documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId)),
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Forward$Lookup$startFrom, documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
							$author$project$Forward$Lookup$succeed(fullDocumentDataConstructor))))));
	};
	var _v0 = model.currentProcessingSelection;
	switch (_v0.$) {
		case 'FactorInvoiceSelection':
			var factorInvoiceId = _v0.a;
			var lookupFactorInvoiceDocuments = A2(
				$author$project$Forward$Lookup$startFrom,
				factorInvoiceId,
				$author$project$Forward$Lookup$waitForAllList(
					A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)));
			var lookupFactorInvoiceDocumentPages = A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, lookupFactorInvoiceDocuments);
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$succeed(false),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
						A2(
							$author$project$Forward$Lookup$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$concat,
								$elm$core$List$map(
									function ($) {
										return $.id;
									})),
							lookupFactorInvoiceDocumentPages)),
					A2(
						$author$project$Forward$Lookup$apply,
						lookupFactorInvoiceDocumentPages,
						A2(
							$author$project$Forward$Lookup$apply,
							lookupFactorInvoiceDocuments,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
								$author$project$Forward$Lookup$succeed(fullDocumentDataConstructor))))));
		case 'CarrierInvoiceSelection':
			var carrierInvoiceId = _v0.a;
			var loadDocumentsCurrentlyShown = model.displayUnassignedLoadDocuments || model.showAllLoadDocsToggled;
			var documentShouldDisplay = F2(
				function (doc, displayUnassignedLoadDocuments) {
					var _v1 = doc.carrierInvoiceId;
					if (_v1.$ === 'Just') {
						var documentInvoiceId = _v1.a;
						return _Utils_eq(documentInvoiceId, carrierInvoiceId);
					} else {
						return displayUnassignedLoadDocuments;
					}
				});
			var carrierInvoiceToTmsLoadDetailsDocuments = A2(
				$author$project$Forward$Lookup$startFrom,
				carrierInvoiceId,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToDocuments,
					A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadDetails, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice)));
			var hasHiddenLoadDocuments = A2(
				$author$project$Forward$Lookup$map,
				$elm$core$List$any(
					function (doc) {
						return (!model.displayUnassignedLoadDocuments) && _Utils_eq(doc.carrierInvoiceId, $elm$core$Maybe$Nothing);
					}),
				carrierInvoiceToTmsLoadDetailsDocuments);
			var loadTmsLoadDetailsDocuments = A2(
				$author$project$Forward$Lookup$map,
				$elm$core$List$filter(
					function (doc) {
						return A2(documentShouldDisplay, doc, loadDocumentsCurrentlyShown);
					}),
				carrierInvoiceToTmsLoadDetailsDocuments);
			return A2(
				$author$project$Forward$Lookup$apply,
				hasHiddenLoadDocuments,
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
						A2(
							$author$project$Forward$Lookup$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$concat,
								$elm$core$List$map(
									function ($) {
										return $.id;
									})),
							A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, loadTmsLoadDetailsDocuments))),
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, loadTmsLoadDetailsDocuments),
						A2(
							$author$project$Forward$Lookup$apply,
							loadTmsLoadDetailsDocuments,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
								$author$project$Forward$Lookup$succeed(fullDocumentDataConstructor))))));
		case 'GroupedDocumentBatchSelection':
			return $author$project$Forward$Lookup$succeed($author$project$Components$DocumentsBrowser$emptyFullDocumentData);
		case 'DocumentBatchSelection':
			var documentBatchId = _v0.a;
			return lookupDocDataFromDocumentBatchId(documentBatchId);
		case 'EmailMessageSelection':
			if (_v0.b.$ === 'Just') {
				var documentBatchId = _v0.b.a;
				return lookupDocDataFromDocumentBatchId(documentBatchId);
			} else {
				var _v2 = _v0.b;
				return $author$project$Forward$Lookup$succeed($author$project$Components$DocumentsBrowser$emptyFullDocumentData);
			}
		case 'DocumentReviewSelection':
			var documentReviewId = _v0.a;
			var documentsLookup = $author$project$Broker$Shared$DocumentReviewHelper$loadDocuments(documentReviewId);
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$succeed(false),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
						A2(
							$author$project$Forward$Lookup$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$concat,
								$elm$core$List$map(
									function ($) {
										return $.id;
									})),
							A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, documentsLookup))),
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, documentsLookup),
						A2(
							$author$project$Forward$Lookup$apply,
							documentsLookup,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
								$author$project$Forward$Lookup$succeed(fullDocumentDataConstructor))))));
		case 'DocumentBatchReviewSelection':
			var documentBatchReviewId = _v0.a;
			var documentsLookup = $author$project$Broker$Shared$DocumentBatchReviewHelper$loadDocuments(documentBatchReviewId);
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$succeed(false),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
						A2(
							$author$project$Forward$Lookup$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$concat,
								$elm$core$List$map(
									function ($) {
										return $.id;
									})),
							A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, documentsLookup))),
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, documentsLookup),
						A2(
							$author$project$Forward$Lookup$apply,
							documentsLookup,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
								$author$project$Forward$Lookup$succeed(fullDocumentDataConstructor))))));
		case 'DocumentGroupReviewSelection':
			var documentGroupReviewId = _v0.a;
			var documentsLookup = $author$project$Broker$Shared$DocumentGroupReviewHelper$loadDocuments(documentGroupReviewId);
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$succeed(false),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
						A2(
							$author$project$Forward$Lookup$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$concat,
								$elm$core$List$map(
									function ($) {
										return $.id;
									})),
							A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, documentsLookup))),
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, documentsLookup),
						A2(
							$author$project$Forward$Lookup$apply,
							documentsLookup,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
								$author$project$Forward$Lookup$succeed(fullDocumentDataConstructor))))));
		case 'SinglePageSelection':
			var documentPageId = _v0.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$succeed(false),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$map,
						$elm$core$List$singleton,
						A2($author$project$Forward$Lookup$startFrom, documentPageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId)),
					A2(
						$author$project$Forward$Lookup$apply,
						A2(
							$author$project$Forward$Lookup$map,
							function (documentPage) {
								return _List_fromArray(
									[
										_List_fromArray(
										[documentPage])
									]);
							},
							A2($author$project$Forward$Lookup$startFrom, documentPageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPage)),
						A2(
							$author$project$Forward$Lookup$apply,
							A2(
								$author$project$Forward$Lookup$map,
								$elm$core$List$singleton,
								A2(
									$author$project$Forward$Lookup$traverse,
									$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
									A2(
										$author$project$Forward$Lookup$map,
										function ($) {
											return $.documentId;
										},
										A2($author$project$Forward$Lookup$startFrom, documentPageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPage)))),
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
								$author$project$Forward$Lookup$succeed(fullDocumentDataConstructor))))));
		case 'NonInvoiceLoadSelection':
			var loadStateId = _v0.a;
			var loadTmsLoadDetailsDocuments = A2(
				$author$project$Forward$Lookup$startFrom,
				loadStateId,
				A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetails));
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$succeed(false),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
						A2(
							$author$project$Forward$Lookup$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$concat,
								$elm$core$List$map(
									function ($) {
										return $.id;
									})),
							A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, loadTmsLoadDetailsDocuments))),
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, loadTmsLoadDetailsDocuments),
						A2(
							$author$project$Forward$Lookup$apply,
							loadTmsLoadDetailsDocuments,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
								$author$project$Forward$Lookup$succeed(fullDocumentDataConstructor))))));
		default:
			return $author$project$Forward$Lookup$succeed($author$project$Components$DocumentsBrowser$emptyFullDocumentData);
	}
};
var $author$project$Components$DocumentsBrowser$GroupedDocumentData = F3(
	function (browserDocumentDataByGroupId, lines, relatedDocumentsStartIndex) {
		return {browserDocumentDataByGroupId: browserDocumentDataByGroupId, lines: lines, relatedDocumentsStartIndex: relatedDocumentsStartIndex};
	});
var $elm_community$dict_extra$Dict$Extra$insertDedupe = F4(
	function (combine, key, value, dict) {
		var _with = function (mbValue) {
			if (mbValue.$ === 'Just') {
				var oldValue = mbValue.a;
				return $elm$core$Maybe$Just(
					A2(combine, oldValue, value));
			} else {
				return $elm$core$Maybe$Just(value);
			}
		};
		return A3($elm$core$Dict$update, key, _with, dict);
	});
var $author$project$Domain$DocumentGroupId$toComparable = function (id) {
	return _Utils_Tuple2(
		'documentGroupId',
		$author$project$Domain$DocumentGroupId$toInt(id));
};
var $author$project$Components$DocumentsBrowser$addDocDataToDict = F2(
	function (_v0, dict) {
		var doc = _v0.a;
		var docPages = _v0.b;
		var key = $author$project$Domain$DocumentGroupId$toComparable(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Domain$DocumentGroupId$fromInt(0),
				doc.documentGroupId));
		var documentData = {
			documentPages: _List_fromArray(
				[docPages]),
			documents: _List_fromArray(
				[doc])
		};
		var combine = F2(
			function (old, _new) {
				return {
					documentPages: _Utils_ap(old.documentPages, _new.documentPages),
					documents: _Utils_ap(old.documents, _new.documents)
				};
			});
		return A4($elm_community$dict_extra$Dict$Extra$insertDedupe, combine, key, documentData, dict);
	});
var $author$project$Components$DocumentBrowser$RelatedDocuments$appendToGroup = F3(
	function (selectedGroupId, related, dict) {
		var _v0 = _Utils_Tuple2(
			$elm$core$List$isEmpty(related.documents),
			A2($elm$core$Dict$get, selectedGroupId, dict));
		if ((!_v0.a) && (_v0.b.$ === 'Just')) {
			var group = _v0.b.a;
			return _Utils_Tuple2(
				A3(
					$elm$core$Dict$insert,
					selectedGroupId,
					{
						documentPages: _Utils_ap(group.documentPages, related.documentPages),
						documents: _Utils_ap(group.documents, related.documents)
					},
					dict),
				$elm$core$Maybe$Just(
					$elm$core$List$length(group.documents)));
		} else {
			return _Utils_Tuple2(dict, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$DocumentsBrowser$sortDocumentData = F2(
	function (accountSettings, documentData) {
		var sortedPairs = A3($author$project$Components$DocumentsBrowser$sortDocumentsByAccountSettings, accountSettings, documentData.documents, documentData.documentPages);
		var sortedDocuments = A2($elm$core$List$map, $elm$core$Tuple$first, sortedPairs);
		var sortedDocumentPages = A2($elm$core$List$map, $elm$core$Tuple$second, sortedPairs);
		return {documentPages: sortedDocumentPages, documents: sortedDocuments};
	});
var $author$project$Components$DocumentsBrowser$buildDocumentDataDict = F7(
	function (accountSettings, selectedGroupId, documents, documentPages, relatedDocuments, relatedDocumentPages, documentPageLines) {
		var relatedDocumentData = A2(
			$author$project$Components$DocumentsBrowser$sortDocumentData,
			accountSettings,
			{documentPages: relatedDocumentPages, documents: relatedDocuments});
		var linesByPageDict = $elm$core$Dict$fromList(
			function (ids) {
				return A2($elm_community$list_extra$List$Extra$zip, ids, documentPageLines);
			}(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.id;
						},
						$author$project$Domain$DocumentPageId$toComparable),
					$elm$core$List$concat(
						_Utils_ap(documentPages, relatedDocumentPages)))));
		var dataByGroupDict = A2(
			$elm$core$Dict$map,
			function (_v1) {
				return $author$project$Components$DocumentsBrowser$sortDocumentData(accountSettings);
			},
			A3(
				$elm$core$List$foldl,
				$author$project$Components$DocumentsBrowser$addDocDataToDict,
				$elm$core$Dict$empty,
				A2($elm_community$list_extra$List$Extra$zip, documents, documentPages)));
		var _v0 = A3($author$project$Components$DocumentBrowser$RelatedDocuments$appendToGroup, selectedGroupId, relatedDocumentData, dataByGroupDict);
		var dataByGroupDictWithRelated = _v0.a;
		var relatedDocumentsStartIndex = _v0.b;
		return A3($author$project$Components$DocumentsBrowser$GroupedDocumentData, dataByGroupDictWithRelated, linesByPageDict, relatedDocumentsStartIndex);
	});
var $author$project$Components$DocumentsBrowser$emptyGroupedDocumentData = A3($author$project$Components$DocumentsBrowser$GroupedDocumentData, $elm$core$Dict$empty, $elm$core$Dict$empty, $elm$core$Maybe$Nothing);
var $author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$documentGroupKey = function (doc) {
	return $author$project$Domain$DocumentGroupId$toComparable(
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$Domain$DocumentGroupId$fromInt(0),
			doc.documentGroupId));
};
var $elm_community$dict_extra$Dict$Extra$filterMap = F2(
	function (f, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					var _v0 = A2(f, k, v);
					if (_v0.$ === 'Just') {
						var newVal = _v0.a;
						return A3($elm$core$Dict$insert, k, newVal, acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$groupFactorInvoiceIdPairs = function (documents) {
	return $elm$core$Dict$toList(
		A2(
			$elm_community$dict_extra$Dict$Extra$filterMap,
			F2(
				function (_v0, docs) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.factorInvoiceId;
							},
							docs));
				}),
			A2($elm_community$dict_extra$Dict$Extra$groupBy, $author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$documentGroupKey, documents)));
};
var $author$project$Forward$Lookup$map2 = F3(
	function (f, _v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: A2($elm$core$Dict$union, a.decoderConfig, b.decoderConfig),
				invalidate: F2(
					function (k, mode) {
						return A2(
							$elm$core$Basics$composeR,
							A2(a.invalidate, k, mode),
							A2(b.invalidate, k, mode));
					}),
				load: F3(
					function (cache, requiredTimestamp, k) {
						return A3(
							$author$project$Forward$Internal$Loadable$map2,
							f,
							A3(a.load, cache, requiredTimestamp, k),
							A3(b.load, cache, requiredTimestamp, k));
					}),
				preloadBranches: $author$project$Forward$Internal$GraphTree$unionBranches(
					_List_fromArray(
						[a.preloadBranches, b.preloadBranches])),
				structure: A2(
					$author$project$Forward$Internal$LookupStructure$All,
					'map2',
					_List_fromArray(
						[a.structure, b.structure]))
			});
	});
var $author$project$Components$DocumentBrowser$RelatedDocuments$select = function (_v0) {
	var batchDocuments = _v0.batchDocuments;
	var invoiceDocuments = _v0.invoiceDocuments;
	var batchIds = $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.id;
				},
				$author$project$Domain$DocumentId$toComparable),
			batchDocuments));
	return A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.id;
			},
			$author$project$Domain$DocumentId$toComparable),
		A2(
			$elm$core$List$filter,
			function (doc) {
				return !A2(
					$elm$core$Set$member,
					$author$project$Domain$DocumentId$toComparable(doc.id),
					batchIds);
			},
			invoiceDocuments));
};
var $author$project$Components$DocumentsBrowser$lookupRelatedDocuments = F2(
	function (documentGroupId, batchDocuments) {
		var selectedGroupInvoiceId = A2(
			$author$project$Forward$Lookup$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$groupFactorInvoiceIdPairs,
				A2(
					$elm$core$Basics$composeR,
					$elm_community$list_extra$List$Extra$find(
						function (_v0) {
							var groupId = _v0.a;
							return _Utils_eq(
								groupId,
								$author$project$Domain$DocumentGroupId$toComparable(documentGroupId));
						}),
					$elm$core$Maybe$map($elm$core$Tuple$second))),
			batchDocuments);
		var invoiceDocuments = A2(
			$author$project$Forward$Lookup$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			A2(
				$author$project$Forward$Lookup$traverseMaybe,
				$author$project$Forward$Lookup$waitForAllList(
					A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
				selectedGroupInvoiceId));
		return A3(
			$author$project$Forward$Lookup$map2,
			F2(
				function (invoiceDocs, batchDocs) {
					return $author$project$Components$DocumentBrowser$RelatedDocuments$select(
						{batchDocuments: batchDocs, invoiceDocuments: invoiceDocs});
				}),
			invoiceDocuments,
			batchDocuments);
	});
var $author$project$Components$DocumentsBrowser$buildDocumentDataByDocumentGroupId = function (_v0) {
	var currentProcessingSelection = _v0.currentProcessingSelection;
	var lookupGroupedDocumentData = F2(
		function (documentBatchId, documentGroupId) {
			var batchDocuments = A2($author$project$Forward$Lookup$startFrom, documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId);
			var relatedDocuments = A2($author$project$Components$DocumentsBrowser$lookupRelatedDocuments, documentGroupId, batchDocuments);
			var relatedDocumentPages = A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, relatedDocuments);
			var batchDocumentPages = A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, batchDocuments);
			return A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$traverseList,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
					A2(
						$author$project$Forward$Lookup$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$concat,
							$elm$core$List$map(
								function ($) {
									return $.id;
								})),
						A3($author$project$Forward$Lookup$map2, $elm$core$Basics$append, batchDocumentPages, relatedDocumentPages))),
				A2(
					$author$project$Forward$Lookup$apply,
					relatedDocumentPages,
					A2(
						$author$project$Forward$Lookup$apply,
						relatedDocuments,
						A2(
							$author$project$Forward$Lookup$apply,
							batchDocumentPages,
							A2(
								$author$project$Forward$Lookup$apply,
								batchDocuments,
								A2(
									$author$project$Forward$Lookup$apply,
									$author$project$Forward$Lookup$succeed(
										$author$project$Domain$DocumentGroupId$toComparable(documentGroupId)),
									A2(
										$author$project$Forward$Lookup$apply,
										$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
										$author$project$Forward$Lookup$succeed($author$project$Components$DocumentsBrowser$buildDocumentDataDict))))))));
		});
	if (currentProcessingSelection.$ === 'GroupedDocumentBatchSelection') {
		var documentBatchId = currentProcessingSelection.a;
		var documentGroupId = currentProcessingSelection.b;
		return A2(lookupGroupedDocumentData, documentBatchId, documentGroupId);
	} else {
		return $author$project$Forward$Lookup$succeed($author$project$Components$DocumentsBrowser$emptyGroupedDocumentData);
	}
};
var $author$project$AuditPb$DocumentAddressAnswer = F5(
	function (documentPageId, place, tier, value, location) {
		return {documentPageId: documentPageId, location: location, place: place, tier: tier, value: value};
	});
var $author$project$AuditPb$AddressPlaceOrigin = {$: 'AddressPlaceOrigin'};
var $author$project$AuditPb$addressPlaceDefault = $author$project$AuditPb$AddressPlaceOrigin;
var $author$project$AuditPb$addressPlaceToString = function (v) {
	if (v.$ === 'AddressPlaceOrigin') {
		return 'origin';
	} else {
		return 'destination';
	}
};
var $author$project$AuditPb$AddressPlaceDestination = {$: 'AddressPlaceDestination'};
var $author$project$AuditPb$allAddressPlace = _List_fromArray(
	[$author$project$AuditPb$AddressPlaceOrigin, $author$project$AuditPb$AddressPlaceDestination]);
var $author$project$AuditPb$addressPlaceDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$addressPlaceToString(v),
				v);
		},
		$author$project$AuditPb$allAddressPlace));
var $author$project$AuditPb$addressPlaceFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$addressPlaceDict);
};
var $author$project$AuditPb$addressPlaceDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$addressPlaceDefault),
		$author$project$AuditPb$addressPlaceFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$DocumentLocation = F5(
	function (documentPageId, top, left, height, width) {
		return {documentPageId: documentPageId, height: height, left: left, top: top, width: width};
	});
var $author$project$AuditPb$documentLocationDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'width',
			$author$project$AuditPb$floatValueDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'height',
				$author$project$AuditPb$floatValueDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'left',
					$author$project$AuditPb$floatValueDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'top',
						$author$project$AuditPb$floatValueDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'documentPageId',
							$author$project$AuditPb$intDecoder,
							$author$project$AuditPb$decode($author$project$AuditPb$DocumentLocation))))));
	});
var $author$project$AuditPb$documentAddressAnswerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optionalMessage,
			'location',
			$author$project$AuditPb$documentLocationDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'value',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'tier',
					$author$project$AuditPb$intDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'place',
						$author$project$AuditPb$addressPlaceDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'documentPageId',
							A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentPageId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$DocumentAddressAnswer))))));
	});
var $author$project$Forward$AppSpecific$Cache$list_documentAddressAnswer = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_documentAddressAnswer;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_documentAddressAnswer: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentAddressAnswersByDocumentId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentAddressAnswer,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$documentAddressAnswerDecoder),
		entrypoint: 'documentAddressAnswersByDocumentId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentId$toInt)
	});
var $author$project$Components$DocumentsBrowser$shownDocumentIds = F2(
	function (documentData, groupedDocumentData) {
		return A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			$author$project$Domain$DocumentId$toInt,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				_Utils_ap(
					documentData.browserDocumentData.documents,
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.documents;
						},
						$elm$core$Dict$values(groupedDocumentData.browserDocumentDataByGroupId)))));
	});
var $author$project$Components$DocumentsBrowser$buildAddressAnswers = function (model) {
	return (!model.addressMarks) ? $author$project$Forward$Lookup$succeed($elm$core$Dict$empty) : A2(
		$author$project$Forward$Lookup$map,
		A2($elm$core$Basics$composeR, $elm$core$List$concat, $author$project$Components$DocumentsBrowser$answersByPage),
		A2(
			$author$project$Forward$Lookup$traverseList,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentAddressAnswersByDocumentId,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$DocumentsBrowser$buildDocumentDataByDocumentGroupId(model),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Components$DocumentsBrowser$buildDocumentData(model),
					$author$project$Forward$Lookup$succeed($author$project$Components$DocumentsBrowser$shownDocumentIds)))));
};
var $author$project$Components$DocumentsBrowser$buildCarrierInvoiceData = function (model) {
	var _v0 = model.currentProcessingSelection;
	if (_v0.$ === 'CarrierInvoiceSelection') {
		var carrierInvoiceId = _v0.a;
		return A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$startFrom, carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice),
			$author$project$Forward$Lookup$succeed($elm$core$Maybe$Just));
	} else {
		return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
	}
};
var $author$project$Components$DocumentBrowser$MessagesView$EmailMessageData = F2(
	function (emailMessage, rejectMessage) {
		return {emailMessage: emailMessage, rejectMessage: rejectMessage};
	});
var $author$project$Forward$AppSpecific$Cache$list_emailMessageId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_emailMessageId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_emailMessageId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByCarrierInvoiceId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_emailMessageId,
		decoder: $author$project$Domain$EmailMessageId$decode,
		entrypoint: 'emailAndReplyMessageIdsByCarrierInvoiceId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByDocumentGroupId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_emailMessageId,
		decoder: $author$project$Domain$EmailMessageId$decode,
		entrypoint: 'emailAndReplyMessageIdsByDocumentGroupId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentGroupId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByFactorInvoiceId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_emailMessageId,
		decoder: $author$project$Domain$EmailMessageId$decode,
		entrypoint: 'emailAndReplyMessageIdsByFactorInvoiceId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToRejectMessage = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$rejectMessage,
		fieldName: 'rejectMessage',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Components$DocumentsBrowser$buildEmailMessageDataList = function (_v0) {
	var currentProcessingSelection = _v0.currentProcessingSelection;
	var withRejections = function (idToEmails) {
		return A3(
			$author$project$Forward$Lookup$map2,
			$elm$core$List$map2($author$project$Components$DocumentBrowser$MessagesView$EmailMessageData),
			idToEmails,
			A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToRejectMessage, idToEmails));
	};
	var documentBatchIdToEmailMessageLookup = function (documentBatchId) {
		return A2(
			$author$project$Forward$Lookup$traverse,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage,
			A2($author$project$Forward$Lookup$startFrom, documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2));
	};
	var documentBatchToEmailMessageData = function (documentBatchId) {
		return A2(
			$author$project$Forward$Lookup$map,
			function (_v6) {
				var maybeEmailMessage = _v6.a;
				var maybeRejectMessage = _v6.b;
				if (maybeEmailMessage.$ === 'Just') {
					var emailMessage = maybeEmailMessage.a;
					return _List_fromArray(
						[
							A2($author$project$Components$DocumentBrowser$MessagesView$EmailMessageData, emailMessage, maybeRejectMessage)
						]);
				} else {
					return _List_Nil;
				}
			},
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$map,
					$author$project$Helpers$Maybe$join,
					A2(
						$author$project$Forward$Lookup$traverseMaybe,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToRejectMessage,
						documentBatchIdToEmailMessageLookup(documentBatchId))),
				A2(
					$author$project$Forward$Lookup$apply,
					documentBatchIdToEmailMessageLookup(documentBatchId),
					$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair))));
	};
	switch (currentProcessingSelection.$) {
		case 'EmailMessageSelection':
			var emailId = currentProcessingSelection.a;
			return withRejections(
				A2(
					$author$project$Forward$Lookup$map,
					$elm$core$List$singleton,
					A2($author$project$Forward$Lookup$startFrom, emailId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage)));
		case 'FactorInvoiceSelection':
			var factorInvoiceId = currentProcessingSelection.a;
			return withRejections(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByFactorInvoiceId));
		case 'CarrierInvoiceSelection':
			var carrierInvoiceId = currentProcessingSelection.a;
			return withRejections(
				A2($author$project$Forward$Lookup$startFrom, carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByCarrierInvoiceId));
		case 'GroupedDocumentBatchSelection':
			var documentBatchId = currentProcessingSelection.a;
			var documentGroupId = currentProcessingSelection.b;
			return A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$traverseList,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToRejectMessage,
					A2($author$project$Forward$Lookup$startFrom, documentGroupId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByDocumentGroupId)),
				A2(
					$author$project$Forward$Lookup$apply,
					A2($author$project$Forward$Lookup$startFrom, documentGroupId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByDocumentGroupId),
					A2(
						$author$project$Forward$Lookup$apply,
						A2(
							$author$project$Forward$Lookup$map,
							$author$project$Helpers$Maybe$join,
							A2(
								$author$project$Forward$Lookup$traverseMaybe,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToRejectMessage,
								documentBatchIdToEmailMessageLookup(documentBatchId))),
						A2(
							$author$project$Forward$Lookup$apply,
							documentBatchIdToEmailMessageLookup(documentBatchId),
							$author$project$Forward$Lookup$succeed(
								F4(
									function (maybeDocumentBatchEmailMessage, maybeDocumentBatchRejectMessage, documentGroupEmailMessages, documentGroupMaybeRejectMessages) {
										var documentGroupEmailMessageDataList = A3($elm$core$List$map2, $author$project$Components$DocumentBrowser$MessagesView$EmailMessageData, documentGroupEmailMessages, documentGroupMaybeRejectMessages);
										var documentBatchEmailMessageDataList = function () {
											if (maybeDocumentBatchEmailMessage.$ === 'Just') {
												var emailMessage = maybeDocumentBatchEmailMessage.a;
												return _List_fromArray(
													[
														A2($author$project$Components$DocumentBrowser$MessagesView$EmailMessageData, emailMessage, maybeDocumentBatchRejectMessage)
													]);
											} else {
												return _List_Nil;
											}
										}();
										return _Utils_ap(documentBatchEmailMessageDataList, documentGroupEmailMessageDataList);
									}))))));
		case 'DocumentBatchSelection':
			var documentBatchId = currentProcessingSelection.a;
			return documentBatchToEmailMessageData(documentBatchId);
		case 'NonInvoiceLoadSelection':
			var documentBatchId = currentProcessingSelection.b;
			return documentBatchToEmailMessageData(documentBatchId);
		case 'SinglePageSelection':
			return $author$project$Forward$Lookup$succeed(_List_Nil);
		case 'DocumentReviewSelection':
			return $author$project$Forward$Lookup$succeed(_List_Nil);
		case 'DocumentBatchReviewSelection':
			return $author$project$Forward$Lookup$succeed(_List_Nil);
		case 'DocumentGroupReviewSelection':
			var documentGroupReviewId = currentProcessingSelection.a;
			var reviewId = documentGroupReviewId.a;
			var emailMessageLookup = A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2,
					A2(
						$author$project$Forward$Lookup$map,
						function ($) {
							return $.documentBatchId;
						},
						A2($author$project$Forward$Lookup$startFrom, reviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReview))));
			return A2(
				$author$project$Forward$Lookup$map,
				function (_v4) {
					var maybeEmailMessage = _v4.a;
					var maybeRejectMessage = _v4.b;
					if (maybeEmailMessage.$ === 'Just') {
						var emailMessage = maybeEmailMessage.a;
						return _List_fromArray(
							[
								A2($author$project$Components$DocumentBrowser$MessagesView$EmailMessageData, emailMessage, maybeRejectMessage)
							]);
					} else {
						return _List_Nil;
					}
				},
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$map,
						$author$project$Helpers$Maybe$join,
						A2($author$project$Forward$Lookup$traverseMaybe, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToRejectMessage, emailMessageLookup)),
					A2(
						$author$project$Forward$Lookup$apply,
						emailMessageLookup,
						$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair))));
		default:
			return $author$project$Forward$Lookup$succeed(_List_Nil);
	}
};
var $author$project$Components$DocumentsBrowser$buildFactorInvoiceState = function (model) {
	var _v0 = model.currentProcessingSelection;
	if (_v0.$ === 'FactorInvoiceSelection') {
		var factorInvoiceId = _v0.a;
		return A2(
			$author$project$Forward$Lookup$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.state;
				},
				$elm$core$Maybe$Just),
			A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice));
	} else {
		return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
	}
};
var $author$project$Components$DocumentsBrowser$groupIdToInvoiceState = function () {
	var invoiceState = A2(
		$author$project$Forward$Lookup$map,
		function ($) {
			return $.state;
		},
		A2(
			$author$project$Forward$Lookup$traverse,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
			A2($author$project$Forward$Lookup$map, $elm$core$Tuple$second, $author$project$Forward$Lookup$identity)));
	return A3(
		$author$project$Forward$Lookup$map2,
		F2(
			function (_v0, state) {
				var groupId = _v0.a;
				return _Utils_Tuple2(groupId, state);
			}),
		$author$project$Forward$Lookup$identity,
		invoiceState);
}();
var $author$project$Components$DocumentsBrowser$buildInvoiceStateByGroupId = function (model) {
	var _v0 = model.currentProcessingSelection;
	if (_v0.$ === 'GroupedDocumentBatchSelection') {
		var documentBatchId = _v0.a;
		return A2(
			$author$project$Forward$Lookup$map,
			$elm$core$Dict$fromList,
			A2(
				$author$project$Forward$Lookup$traverseList,
				$author$project$Components$DocumentsBrowser$groupIdToInvoiceState,
				A2(
					$author$project$Forward$Lookup$map,
					$author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$groupFactorInvoiceIdPairs,
					A2($author$project$Forward$Lookup$startFrom, documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId))));
	} else {
		return $author$project$Forward$Lookup$succeed($elm$core$Dict$empty);
	}
};
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$Data = F3(
	function (maybeTmsLoad, accountSettings, currentUser) {
		return {accountSettings: accountSettings, currentUser: currentUser, maybeTmsLoad: maybeTmsLoad};
	});
var $author$project$Forward$AppSpecific$Cache$tmsLoad = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.tmsLoad;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{tmsLoad: e});
		}));
var $author$project$AuditPb$TMSLoad = F7(
	function (id, loadId, displayIdentifier, tmsCustomerId, createdAt, updatedAt, deliveredAt) {
		return {createdAt: createdAt, deliveredAt: deliveredAt, displayIdentifier: displayIdentifier, id: id, loadId: loadId, tmsCustomerId: tmsCustomerId, updatedAt: updatedAt};
	});
var $author$project$AuditPb$TMSLoad_DisplayIdentifier = F2(
	function (label, identifier) {
		return {identifier: identifier, label: label};
	});
var $author$project$AuditPb$tmsLoad_DisplayIdentifierDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'identifier',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'label',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$TMSLoad_DisplayIdentifier)));
	});
var $author$project$AuditPb$tmsLoadDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'delivered_at',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'updated_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'created_at',
					$author$project$AuditPb$timestampDecoder,
					A3(
						$author$project$AuditPb$optional,
						'tms_customer_id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
						A3(
							$author$project$AuditPb$optionalMessage,
							'display_identifier',
							$author$project$AuditPb$tmsLoad_DisplayIdentifierDecoder,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'load_id',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$TmsLoadId$fromInt, $author$project$AuditPb$intDecoder),
									$author$project$AuditPb$decode($author$project$AuditPb$TMSLoad))))))));
	});
var $author$project$Domain$TmsLoadId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoad = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$tmsLoad,
		decoder: $author$project$AuditPb$tmsLoadDecoder,
		entrypoint: 'tmsLoadsV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsLoadId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadStateToTmsLoad = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoad,
		fieldName: 'tmsLoad',
		getId: function ($) {
			return $.loadId;
		}
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$maybeBuildTmsLoad = function (pageContextData) {
	var _v0 = pageContextData.loadStateId;
	if (_v0.$ === 'Just') {
		var loadStateId = _v0.a;
		return A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadStateToTmsLoad,
				A2($author$project$Forward$Lookup$startFrom, loadStateId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadState)),
			$author$project$Forward$Lookup$succeed($elm$core$Maybe$Just));
	} else {
		return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
	}
};
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$DocumentBrowser$AddDocumentToLoad$maybeBuildTmsLoad(model.pageContextData),
				$author$project$Forward$Lookup$succeed($author$project$Components$DocumentBrowser$AddDocumentToLoad$Data))));
};
var $author$project$Components$DocumentsBrowser$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(
			$author$project$Components$DocumentsBrowser$buildAddressAnswers(model)),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$DocumentsBrowser$buildFactorInvoiceState(model),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$DocumentsBrowser$buildInvoiceStateByGroupId(model)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Components$DocumentBrowser$AddDocumentToLoad$loadData(model.addDocumentToLoad),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Components$DocumentsBrowser$buildCarrierInvoiceData(model),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Components$DocumentsBrowser$buildEmailMessageDataList(model),
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$Lookup$exposeLoadingState(
									$author$project$Components$DocumentsBrowser$buildActivityCarrierNames(model)),
								A2(
									$author$project$Forward$Lookup$apply,
									$author$project$Forward$Lookup$exposeLoadingState(
										$author$project$Components$DocumentsBrowser$buildActivities(model)),
									A2(
										$author$project$Forward$Lookup$apply,
										$author$project$Components$DocumentsBrowser$buildDocumentDataByDocumentGroupId(model),
										A2(
											$author$project$Forward$Lookup$apply,
											$author$project$Components$DocumentsBrowser$buildDocumentData(model),
											A2(
												$author$project$Forward$Lookup$apply,
												$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
												A2(
													$author$project$Forward$Lookup$apply,
													$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
													A2(
														$author$project$Forward$Lookup$apply,
														$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
														$author$project$Forward$Lookup$succeed($author$project$Components$DocumentsBrowser$Data))))))))))))));
};
var $author$project$Broker$Page$DocumentsViewerPopout$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState(
				$author$project$Components$DocumentsBrowser$loadData(model.documentsViewer)),
			$author$project$Forward$Lookup$succeed($author$project$Broker$Page$DocumentsViewerPopout$Data)));
};
var $author$project$Components$ActivityPage$Data = F5(
	function (users, currentAccount, accountSettings, filtersView, activityItemListView) {
		return {accountSettings: accountSettings, activityItemListView: activityItemListView, currentAccount: currentAccount, filtersView: filtersView, users: users};
	});
var $author$project$Components$ActivityBrowser$ActivityItemListView$Data = function (activityItems) {
	return {activityItems: activityItems};
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemIdsByQuery = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$stream_activityItemId,
		decoder: $author$project$Stream$decoder($author$project$Domain$ActivityItemId$fromInt),
		entrypoint: 'activityItemIdsStreamByQuery',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$ActivityItemIdsQuery$encode)
	});
var $author$project$Stream$concat = function (streams) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, _v1) {
				var items = _v0.a;
				var hasMore_ = _v0.b;
				var restItems = _v1.a;
				var restHasMore = _v1.b;
				return A2(
					$author$project$Stream$Stream,
					_Utils_ap(restItems, items),
					restHasMore || hasMore_);
			}),
		A2($author$project$Stream$Stream, _List_Nil, false),
		streams);
};
var $author$project$Components$ActivityBrowser$ActivityItemView$Data = F5(
	function (currentAccount, accountSettings, activityItem, contextView, detailsView) {
		return {accountSettings: accountSettings, activityItem: activityItem, contextView: contextView, currentAccount: currentAccount, detailsView: detailsView};
	});
var $author$project$Components$ActivityBrowser$ContextView$Data = F5(
	function (account, activityItem, ownerData, accountSettings, currentUser) {
		return {account: account, accountSettings: accountSettings, activityItem: activityItem, currentUser: currentUser, ownerData: ownerData};
	});
var $author$project$Components$ActivityBrowser$ContextView$CarrierInvoiceData = function (a) {
	return {$: 'CarrierInvoiceData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$DocumentBatchData = function (a) {
	return {$: 'DocumentBatchData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$DocumentData = function (a) {
	return {$: 'DocumentData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$DocumentGroupData = function (a) {
	return {$: 'DocumentGroupData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$DocumentPageData = function (a) {
	return {$: 'DocumentPageData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$EmailMessageData = function (a) {
	return {$: 'EmailMessageData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$FactorInvoiceData = function (a) {
	return {$: 'FactorInvoiceData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$LoadStateData = function (a) {
	return {$: 'LoadStateData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$TmsCarrierData = function (a) {
	return {$: 'TmsCarrierData', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$TmsLoadShipmentData = function (a) {
	return {$: 'TmsLoadShipmentData', a: a};
};
var $author$project$Forward$Internal$RoseDict$fromList = function (items) {
	return $author$project$Forward$Internal$RoseDict$RoseDict(
		$elm$core$Dict$fromList(items));
};
var $author$project$Forward$Internal$GraphTree$branchesFromList = function (strings) {
	return $author$project$Forward$Internal$RoseDict$fromList(strings);
};
var $author$project$Forward$Lookup$defineUnionTypeEdge = F3(
	function (variantsList, dispatch, variantsRecord) {
		return $author$project$Forward$Lookup$Lookup(
			{
				decoderConfig: A3(
					$elm$core$List$foldl,
					$elm$core$Dict$union,
					$elm$core$Dict$empty,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var v = _v0.a;
							return v.getDecoderConfig(variantsRecord);
						},
						variantsList)),
				invalidate: function (a) {
					var _v1 = dispatch(a);
					var getChildLookup = _v1.a;
					var _v2 = getChildLookup(variantsRecord);
					var child = _v2.a;
					return child.invalidate(_Utils_Tuple0);
				},
				load: F3(
					function (cache, requiredTimestamp, start) {
						var _v3 = dispatch(start);
						var getChildLookup = _v3.a;
						var _v4 = getChildLookup(variantsRecord);
						var child = _v4.a;
						return A3(child.load, cache, requiredTimestamp, _Utils_Tuple0);
					}),
				preloadBranches: $author$project$Forward$Internal$GraphTree$branchesFromList(
					A2(
						$elm$core$List$map,
						function (_v5) {
							var v = _v5.a;
							return _Utils_Tuple2(
								v.backendName,
								v.getPreloadBranches(variantsRecord));
						},
						variantsList)),
				structure: A2(
					$author$project$Forward$Internal$LookupStructure$OneOf,
					'(defineUnionTypeEdge)',
					A2(
						$elm$core$List$map,
						function (_v6) {
							var v = _v6.a;
							return v.getStructure(variantsRecord);
						},
						variantsList))
			});
	});
var $author$project$Forward$Lookup$Dispatch = function (a) {
	return {$: 'Dispatch', a: a};
};
var $author$project$Forward$Lookup$unionTypeDispatch = F2(
	function (id, getLookup) {
		return $author$project$Forward$Lookup$Dispatch(
			A2(
				$elm$core$Basics$composeR,
				getLookup,
				$author$project$Forward$Lookup$startFrom(id)));
	});
var $author$project$Forward$Lookup$Variant = function (a) {
	return {$: 'Variant', a: a};
};
var $author$project$Forward$Lookup$unionTypeVariant = F3(
	function (backendName, getLookup, _v0) {
		var getNestedChild = function (_v1) {
			var nested = _v1.a;
			return nested;
		};
		return $author$project$Forward$Lookup$Variant(
			{
				backendName: backendName,
				getDecoderConfig: A2(
					$elm$core$Basics$composeR,
					getLookup,
					A2(
						$elm$core$Basics$composeR,
						getNestedChild,
						function ($) {
							return $.decoderConfig;
						})),
				getPreloadBranches: A2(
					$elm$core$Basics$composeR,
					getLookup,
					A2(
						$elm$core$Basics$composeR,
						getNestedChild,
						function ($) {
							return $.preloadBranches;
						})),
				getStructure: A2(
					$elm$core$Basics$composeR,
					getLookup,
					A2(
						$elm$core$Basics$composeR,
						getNestedChild,
						function ($) {
							return $.structure;
						}))
			});
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemOwnerIdEdge = A2(
	$author$project$Forward$Lookup$defineUnionTypeEdge,
	_List_fromArray(
		[
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'CarrierInvoiceOwnerId',
			function ($) {
				return $.carrierInvoiceOwnerId;
			},
			$author$project$Domain$ActivityItem$CarrierInvoiceOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentBatchOwnerId',
			function ($) {
				return $.documentBatchOwnerId;
			},
			$author$project$Domain$ActivityItem$DocumentBatchOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentGroupOwnerId',
			function ($) {
				return $.documentGroupOwnerId;
			},
			$author$project$Domain$ActivityItem$DocumentGroupOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentOwnerId',
			function ($) {
				return $.documentOwnerId;
			},
			$author$project$Domain$ActivityItem$DocumentOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'EmailMessageOwnerId',
			function ($) {
				return $.emailMessageOwnerId;
			},
			$author$project$Domain$ActivityItem$EmailMessageOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'FactorInvoiceOwnerId',
			function ($) {
				return $.factorInvoiceOwnerId;
			},
			$author$project$Domain$ActivityItem$FactorInvoiceOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'TmsCarrierOwnerId',
			function ($) {
				return $.tmsCarrierOwnerId;
			},
			$author$project$Domain$ActivityItem$TmsCarrierOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LoadStateOwnerId',
			function ($) {
				return $.loadStateOwnerId;
			},
			$author$project$Domain$ActivityItem$LoadStateOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentPageOwnerId',
			function ($) {
				return $.documentPageOwnerId;
			},
			$author$project$Domain$ActivityItem$DocumentPageOwnerId),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'TmsLoadShipmentOwnerId',
			function ($) {
				return $.tmsLoadShipmentOwnerId;
			},
			$author$project$Domain$ActivityItem$TmsLoadShipmentOwnerId)
		]),
	function (ownerId) {
		switch (ownerId.$) {
			case 'CarrierInvoiceOwnerId':
				var carrierInvoiceId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					carrierInvoiceId,
					function ($) {
						return $.carrierInvoiceOwnerId;
					});
			case 'DocumentBatchOwnerId':
				var documentBatchId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					documentBatchId,
					function ($) {
						return $.documentBatchOwnerId;
					});
			case 'DocumentGroupOwnerId':
				var documentGroupId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					documentGroupId,
					function ($) {
						return $.documentGroupOwnerId;
					});
			case 'DocumentOwnerId':
				var documentId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					documentId,
					function ($) {
						return $.documentOwnerId;
					});
			case 'EmailMessageOwnerId':
				var emailMessageId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					emailMessageId,
					function ($) {
						return $.emailMessageOwnerId;
					});
			case 'FactorInvoiceOwnerId':
				var factorInvoiceId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					factorInvoiceId,
					function ($) {
						return $.factorInvoiceOwnerId;
					});
			case 'TmsCarrierOwnerId':
				var tmsCarrierId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					tmsCarrierId,
					function ($) {
						return $.tmsCarrierOwnerId;
					});
			case 'LoadStateOwnerId':
				var loadStateId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					loadStateId,
					function ($) {
						return $.loadStateOwnerId;
					});
			case 'DocumentPageOwnerId':
				var documentPageId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					documentPageId,
					function ($) {
						return $.documentPageOwnerId;
					});
			default:
				var tmsLoadShipmentId = ownerId.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					tmsLoadShipmentId,
					function ($) {
						return $.tmsLoadShipmentOwnerId;
					});
		}
	});
var $author$project$Components$ActivityBrowser$Context$CarrierInvoiceContextView$Data = function (contextData) {
	return {contextData: contextData};
};
var $author$project$Forward$AppSpecific$Cache$activityItemContextDataByCarrierInvoiceId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.activityItemContextDataByCarrierInvoiceId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{activityItemContextDataByCarrierInvoiceId: e});
		}));
var $author$project$AuditPb$ActivityItemContextDataByCarrierInvoiceId = F3(
	function (loadId, carrierName, loadStateId) {
		return {carrierName: carrierName, loadId: loadId, loadStateId: loadStateId};
	});
var $author$project$AuditPb$activityItemContextDataByCarrierInvoiceIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'load_state_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$LoadStateId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$optional,
				'carrier_name',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'load_id',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemContextDataByCarrierInvoiceId))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByCarrierInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$activityItemContextDataByCarrierInvoiceId,
		decoder: $author$project$AuditPb$activityItemContextDataByCarrierInvoiceIdDecoder,
		entrypoint: 'activityItemContextDataByCarrierInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Components$ActivityBrowser$Context$CarrierInvoiceContextView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByCarrierInvoiceId,
	$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$CarrierInvoiceContextView$Data));
var $author$project$Components$ActivityBrowser$Context$DocumentBatchContextView$Data = F4(
	function (contextData, accountSettings, currentAccount, currentUser) {
		return {accountSettings: accountSettings, contextData: contextData, currentAccount: currentAccount, currentUser: currentUser};
	});
var $author$project$Forward$AppSpecific$Cache$activityItemContextDataByDocumentBatchId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.activityItemContextDataByDocumentBatchId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{activityItemContextDataByDocumentBatchId: e});
		}));
var $author$project$AuditPb$ActivityItemContextDataByDocumentBatchId = F3(
	function (documentBatchId, email, carrierName) {
		return {carrierName: carrierName, documentBatchId: documentBatchId, email: email};
	});
var $author$project$AuditPb$ActivityItemContextDataByDocumentBatchId_EmailContext = F4(
	function (id, subject, documentBatchId, hasFactorClientInvoiceSubmission) {
		return {documentBatchId: documentBatchId, hasFactorClientInvoiceSubmission: hasFactorClientInvoiceSubmission, id: id, subject: subject};
	});
var $author$project$AuditPb$activityItemContextDataByDocumentBatchId_EmailContextDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'has_factor_client_invoice_submission',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$optional,
				'document_batch_id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $author$project$AuditPb$intDecoder),
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'subject',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemContextDataByDocumentBatchId_EmailContext)))));
	});
var $author$project$AuditPb$activityItemContextDataByDocumentBatchIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'carrier_name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optionalMessage,
				'email',
				$author$project$AuditPb$activityItemContextDataByDocumentBatchId_EmailContextDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'document_batch_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$ActivityItemContextDataByDocumentBatchId))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByDocumentBatchId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$activityItemContextDataByDocumentBatchId,
		decoder: $author$project$AuditPb$activityItemContextDataByDocumentBatchIdDecoder,
		entrypoint: 'activityItemContextDataByDocumentBatchId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentBatchId$toInt)
	});
var $author$project$Components$ActivityBrowser$Context$DocumentBatchContextView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByDocumentBatchId,
				$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$DocumentBatchContextView$Data)))));
var $author$project$Components$ActivityBrowser$Context$DocumentContextView$loadData = A2(
	$author$project$Forward$Lookup$traverseMaybe,
	$author$project$Components$ActivityBrowser$Context$DocumentBatchContextView$loadData,
	A2(
		$author$project$Forward$Lookup$map,
		function ($) {
			return $.documentBatchId;
		},
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2));
var $author$project$Components$ActivityBrowser$Context$DocumentGroupContextView$loadData = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup;
var $author$project$Components$ActivityBrowser$Context$DocumentPageContextView$Data = F3(
	function (documentPage, currentUser, accountSettings) {
		return {accountSettings: accountSettings, currentUser: currentUser, documentPage: documentPage};
	});
var $author$project$Components$ActivityBrowser$Context$DocumentPageContextView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPage,
			$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$DocumentPageContextView$Data))));
var $author$project$Components$ActivityBrowser$Context$EmailMessageContextView$Data = F5(
	function (accountSettings, currentAccount, emailMessage, tmsCarrier, currentUser) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, currentUser: currentUser, emailMessage: emailMessage, tmsCarrier: tmsCarrier};
	});
var $author$project$Components$ActivityBrowser$Context$EmailMessageContextView$loadData = function () {
	var maybeTmsCarrier = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage);
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
		A2(
			$author$project$Forward$Lookup$apply,
			maybeTmsCarrier,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
						$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$EmailMessageContextView$Data))))));
}();
var $author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$Data = F4(
	function (emailMessageId, factorInvoiceDetails, accountSettings, currentUser) {
		return {accountSettings: accountSettings, currentUser: currentUser, emailMessageId: emailMessageId, factorInvoiceDetails: factorInvoiceDetails};
	});
var $author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$FactorInvoiceDetails = F3(
	function (factorInvoice, tmsCarrier, factorBroker) {
		return {factorBroker: factorBroker, factorInvoice: factorInvoice, tmsCarrier: tmsCarrier};
	});
var $author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$factorInvoiceToDetails = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$FactorInvoiceDetails))));
var $author$project$Forward$AppSpecific$Cache$maybe_emailMessageId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_emailMessageId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_emailMessageId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionEmailMessageIdByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_emailMessageId,
		decoder: $elm$json$Json$Decode$nullable($author$project$Domain$EmailMessageId$decode),
		entrypoint: 'submissionEmailMessageIdByFactorInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$loadData = function () {
	var factorInvoiceDetails = A2($author$project$Forward$Lookup$traverse, $author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$factorInvoiceToDetails, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice);
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
			A2(
				$author$project$Forward$Lookup$apply,
				factorInvoiceDetails,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionEmailMessageIdByFactorInvoiceId,
					$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$Data)))));
}();
var $author$project$Components$ActivityBrowser$Context$LoadStateContextView$Data = F2(
	function (loadStateId, loadId) {
		return {loadId: loadId, loadStateId: loadStateId};
	});
var $author$project$Forward$AppSpecific$Cache$activityItemContextDataByLoadStateId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.activityItemContextDataByLoadStateId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{activityItemContextDataByLoadStateId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByLoadStateId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$activityItemContextDataByLoadStateId,
		decoder: $elm$json$Json$Decode$string,
		entrypoint: 'activityItemContextDataByLoadStateId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$LoadStateId$toInt)
	});
var $author$project$Components$ActivityBrowser$Context$LoadStateContextView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByLoadStateId,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$LoadStateContextView$Data)));
var $author$project$Components$ActivityBrowser$Context$TmsCarrierContextView$Data = function (tmsCarrier) {
	return {tmsCarrier: tmsCarrier};
};
var $author$project$Components$ActivityBrowser$Context$TmsCarrierContextView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
	$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$TmsCarrierContextView$Data));
var $author$project$Components$ActivityBrowser$Context$TmsLoadShipmentContextView$Data = F3(
	function (tmsLoadShipment, loadState, tmsLoad) {
		return {loadState: loadState, tmsLoad: tmsLoad, tmsLoadShipment: tmsLoadShipment};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadStateByTmsLoadId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$loadState,
		decoder: $author$project$AuditPb$loadStateDecoder,
		entrypoint: 'loadStateByTmsLoadId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsLoadId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$tmsLoadShipment = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.tmsLoadShipment;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{tmsLoadShipment: e});
		}));
var $author$project$AuditPb$TMSLoadShipment = F3(
	function (id, tmsLoadId, customerName) {
		return {customerName: customerName, id: id, tmsLoadId: tmsLoadId};
	});
var $author$project$AuditPb$tmsLoadShipmentDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'customer_name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'tms_load_id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsLoadId$fromInt, $author$project$AuditPb$intDecoder),
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$TmsLoadShipmentId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadShipment))));
	});
var $author$project$Domain$TmsLoadShipmentId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadShipment = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$tmsLoadShipment,
		decoder: $author$project$AuditPb$tmsLoadShipmentDecoder,
		entrypoint: 'tmsLoadShipment',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsLoadShipmentId$toInt)
	});
var $author$project$Components$ActivityBrowser$Context$TmsLoadShipmentContextView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	A2(
		$author$project$Forward$Lookup$traverse,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoad,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.tmsLoadId;
			},
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadShipment)),
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$traverse,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadStateByTmsLoadId,
			A2(
				$author$project$Forward$Lookup$map,
				function ($) {
					return $.tmsLoadId;
				},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadShipment)),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadShipment,
			$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$Context$TmsLoadShipmentContextView$Data))));
var $author$project$Components$ActivityBrowser$ContextView$loadOwnerData = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemOwnerIdEdge(
	{
		carrierInvoiceOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$CarrierInvoiceData, $author$project$Components$ActivityBrowser$Context$CarrierInvoiceContextView$loadData),
		documentBatchOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$DocumentBatchData, $author$project$Components$ActivityBrowser$Context$DocumentBatchContextView$loadData),
		documentGroupOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$DocumentGroupData, $author$project$Components$ActivityBrowser$Context$DocumentGroupContextView$loadData),
		documentOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$DocumentData, $author$project$Components$ActivityBrowser$Context$DocumentContextView$loadData),
		documentPageOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$DocumentPageData, $author$project$Components$ActivityBrowser$Context$DocumentPageContextView$loadData),
		emailMessageOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$EmailMessageData, $author$project$Components$ActivityBrowser$Context$EmailMessageContextView$loadData),
		factorInvoiceOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$FactorInvoiceData, $author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$loadData),
		loadStateOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$LoadStateData, $author$project$Components$ActivityBrowser$Context$LoadStateContextView$loadData),
		tmsCarrierOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$TmsCarrierData, $author$project$Components$ActivityBrowser$Context$TmsCarrierContextView$loadData),
		tmsLoadShipmentOwnerId: A2($author$project$Forward$Lookup$map, $author$project$Components$ActivityBrowser$ContextView$TmsLoadShipmentData, $author$project$Components$ActivityBrowser$Context$TmsLoadShipmentContextView$loadData)
	});
var $author$project$Components$ActivityBrowser$ContextView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Components$ActivityBrowser$ContextView$loadOwnerData,
				A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.ownerId;
					},
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItem)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItem,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
					$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$ContextView$Data))))));
var $author$project$Components$ActivityBrowser$DetailsView$Data = F5(
	function (account, accountSettings, activityItem, nestedDetails, currentUser) {
		return {account: account, accountSettings: accountSettings, activityItem: activityItem, currentUser: currentUser, nestedDetails: nestedDetails};
	});
var $author$project$Components$ActivityBrowser$DetailsView$CarrierInvoiceProcessedData = F2(
	function (a, b) {
		return {$: 'CarrierInvoiceProcessedData', a: a, b: b};
	});
var $author$project$Components$ActivityBrowser$DetailsView$CarrierPayableApprovedData = F2(
	function (a, b) {
		return {$: 'CarrierPayableApprovedData', a: a, b: b};
	});
var $author$project$Components$ActivityBrowser$DetailsView$FactorInvoiceProcessedData = F2(
	function (a, b) {
		return {$: 'FactorInvoiceProcessedData', a: a, b: b};
	});
var $author$project$Components$ActivityBrowser$DetailsView$InvoiceCreatedByExternalData = F2(
	function (a, b) {
		return {$: 'InvoiceCreatedByExternalData', a: a, b: b};
	});
var $author$project$Components$ActivityBrowser$DetailsView$LoadShipmentApprovalData = function (a) {
	return {$: 'LoadShipmentApprovalData', a: a};
};
var $author$project$Components$ActivityBrowser$DetailsView$LoadShipmentUnapprovalData = function (a) {
	return {$: 'LoadShipmentUnapprovalData', a: a};
};
var $author$project$Components$ActivityBrowser$DetailsView$NoNestedDetails = {$: 'NoNestedDetails'};
var $author$project$Components$ActivityBrowser$DetailsView$TransmissionDetailsData = function (a) {
	return {$: 'TransmissionDetailsData', a: a};
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemCarrierInvoiceProcessedDetailsToTmsCarrier = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.tmsCarrierId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemCarrierPayableApprovedDetailsToTmsCarrier = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.tmsCarrierId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemDetailsEdge = A2(
	$author$project$Forward$Lookup$defineUnionTypeEdge,
	_List_fromArray(
		[
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'BypassedVerifyQueue',
			function ($) {
				return $.bypassedVerifyQueue;
			},
			function (_v0) {
				return $author$project$Domain$ActivityItem$BypassedVerifyQueue;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentAdded',
			function ($) {
				return $.documentAdded;
			},
			$author$project$Domain$ActivityItem$DocumentAdded),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentAssigned',
			function ($) {
				return $.documentAssigned;
			},
			function (_v1) {
				return $author$project$Domain$ActivityItem$DocumentAssigned;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentBatchIgnored',
			function ($) {
				return $.documentBatchIgnored;
			},
			$author$project$Domain$ActivityItem$DocumentBatchIgnored),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentRemoved',
			function ($) {
				return $.documentRemoved;
			},
			$author$project$Domain$ActivityItem$DocumentRemoved),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentSentToExternal',
			function ($) {
				return $.documentSentToExternal;
			},
			$author$project$Domain$ActivityItem$DocumentSentToExternal),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'EmailMergeSource',
			function ($) {
				return $.emailMergeSource;
			},
			$author$project$Domain$ActivityItem$EmailMergeSource),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'EmailMergeTarget',
			function ($) {
				return $.emailMergeTarget;
			},
			$author$project$Domain$ActivityItem$EmailMergeTarget),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'EmailIgnored',
			function ($) {
				return $.emailIgnored;
			},
			$author$project$Domain$ActivityItem$EmailIgnored),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'EmailUnignored',
			function ($) {
				return $.emailUnignored;
			},
			function (_v2) {
				return $author$project$Domain$ActivityItem$EmailUnignored;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'EmailZeroPages',
			function ($) {
				return $.emailZeroPages;
			},
			function (_v3) {
				return $author$project$Domain$ActivityItem$EmailZeroPages;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'EmailCompleted',
			function ($) {
				return $.emailCompleted;
			},
			function (_v4) {
				return $author$project$Domain$ActivityItem$EmailCompleted;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DuplicateEmailAutoCompleted',
			function ($) {
				return $.duplicateEmailAutoCompleted;
			},
			$author$project$Domain$ActivityItem$DuplicateEmailAutoCompleted),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'AutoCompletedWaitingExceptionsOnNewDocs',
			function ($) {
				return $.autoCompletedWaitingExceptionsOnNewDocs;
			},
			function (_v5) {
				return $author$project$Domain$ActivityItem$AutoCompletedWaitingExceptionsOnNewDocs;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DuplicateDocumentBatchAutoCompleted',
			function ($) {
				return $.duplicateDocumentBatchAutoCompleted;
			},
			$author$project$Domain$ActivityItem$DuplicateDocumentBatchAutoCompleted),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DuplicateDocumentAutoHidden',
			function ($) {
				return $.duplicateDocumentAutoHidden;
			},
			function (_v6) {
				return $author$project$Domain$ActivityItem$DuplicateDocumentAutoHidden;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DuplicateDocumentAutoMerged',
			function ($) {
				return $.duplicateDocumentAutoMerged;
			},
			function (_v7) {
				return $author$project$Domain$ActivityItem$DuplicateDocumentAutoMerged;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ExceptionDocumentsSent',
			function ($) {
				return $.exceptionDocumentsSent;
			},
			function (_v8) {
				return $author$project$Domain$ActivityItem$ExceptionDocumentsSent;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ExceptionResolved',
			function ($) {
				return $.exceptionResolved;
			},
			$author$project$Domain$ActivityItem$ExceptionResolved),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ExceptionsClearedViaAPI',
			function ($) {
				return $.exceptionsClearedViaAPI;
			},
			function (_v9) {
				return $author$project$Domain$ActivityItem$ExceptionsClearedViaAPI;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'FactoringAssignment',
			function ($) {
				return $.factoringAssignment;
			},
			$author$project$Domain$ActivityItem$FactoringAssignment),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ForwardedEmail',
			function ($) {
				return $.forwardedEmail;
			},
			$author$project$Domain$ActivityItem$ForwardedEmail),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceDocumentsForwardedToTriumph',
			function ($) {
				return $.invoiceDocumentsForwardedToTriumph;
			},
			function (_v10) {
				return $author$project$Domain$ActivityItem$InvoiceDocumentsForwardedToTriumph;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceApproved',
			function ($) {
				return $.invoiceApproved;
			},
			$author$project$Domain$ActivityItem$InvoiceApproved),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'CarrierPayableApproved',
			function ($) {
				return $.carrierPayableApproved;
			},
			$author$project$Domain$ActivityItem$CarrierPayableApproved),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceDocumentsResendRequested',
			function ($) {
				return $.invoiceDocumentsResendRequested;
			},
			function (_v11) {
				return $author$project$Domain$ActivityItem$InvoiceDocumentsResendRequested;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceAbandoned',
			function ($) {
				return $.invoiceAbandoned;
			},
			$author$project$Domain$ActivityItem$InvoiceAbandoned),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceCreatedByExternal',
			function ($) {
				return $.invoiceCreatedByExternal;
			},
			$author$project$Domain$ActivityItem$InvoiceCreatedByExternal),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceMatched',
			function ($) {
				return $.invoiceMatched;
			},
			function (_v12) {
				return $author$project$Domain$ActivityItem$InvoiceMatched;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceMarkedAsPurchased',
			function ($) {
				return $.invoiceMarkedAsPurchased;
			},
			function (_v13) {
				return $author$project$Domain$ActivityItem$InvoiceMarkedAsPurchased;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceProcessed',
			function ($) {
				return $.invoiceProcessed;
			},
			$author$project$Domain$ActivityItem$InvoiceProcessed),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceAutoProcessed',
			function ($) {
				return $.invoiceAutoProcessed;
			},
			$author$project$Domain$ActivityItem$InvoiceAutoProcessed),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceRejected',
			function ($) {
				return $.invoiceRejected;
			},
			function (_v14) {
				return $author$project$Domain$ActivityItem$InvoiceRejected;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceRemovedFromGroup',
			function ($) {
				return $.invoiceRemovedFromGroup;
			},
			function (_v15) {
				return $author$project$Domain$ActivityItem$InvoiceRemovedFromGroup;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceUnapproved',
			function ($) {
				return $.invoiceUnapproved;
			},
			function (_v16) {
				return $author$project$Domain$ActivityItem$InvoiceUnapproved;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceUnignored',
			function ($) {
				return $.invoiceUnignored;
			},
			function (_v17) {
				return $author$project$Domain$ActivityItem$InvoiceUnignored;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'SentToVerifyQueue',
			function ($) {
				return $.sentToVerifyQueue;
			},
			function (_v18) {
				return $author$project$Domain$ActivityItem$SentToVerifyQueue;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'VerifyCompleted',
			function ($) {
				return $.verifyCompleted;
			},
			$author$project$Domain$ActivityItem$VerifyCompleted),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'NoteAdded',
			function ($) {
				return $.noteAdded;
			},
			$author$project$Domain$ActivityItem$NoteAdded),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'NoteSentToPaymentsNetwork',
			function ($) {
				return $.noteSentToPaymentsNetwork;
			},
			$author$project$Domain$ActivityItem$NoteSentToPaymentsNetwork),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'Paused',
			function ($) {
				return $.paused;
			},
			$author$project$Domain$ActivityItem$Paused),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'PaymentAddressChanged',
			function ($) {
				return $.paymentAddressChanged;
			},
			function (_v19) {
				return $author$project$Domain$ActivityItem$PaymentAddressChanged;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ReceivedInvoice',
			function ($) {
				return $.receivedInvoice;
			},
			function (_v20) {
				return $author$project$Domain$ActivityItem$ReceivedInvoice;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'RuleDisabled',
			function ($) {
				return $.ruleDisabled;
			},
			$author$project$Domain$ActivityItem$RuleDisabled),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'RuleEnabled',
			function ($) {
				return $.ruleEnabled;
			},
			$author$project$Domain$ActivityItem$RuleEnabled),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'SavedAsIncomplete',
			function ($) {
				return $.savedAsIncomplete;
			},
			function (_v21) {
				return $author$project$Domain$ActivityItem$SavedAsIncomplete;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'SentToCadence',
			function ($) {
				return $.sentToCadence;
			},
			$author$project$Domain$ActivityItem$SentToCadence),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'SentToExternal',
			function ($) {
				return $.sentToExternal;
			},
			$author$project$Domain$ActivityItem$SentToExternal),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ReadyForFmsPickup',
			function ($) {
				return $.readyForFmsPickup;
			},
			function (_v22) {
				return $author$project$Domain$ActivityItem$ReadyForFmsPickup;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'StateChanged',
			function ($) {
				return $.stateChanged;
			},
			$author$project$Domain$ActivityItem$StateChanged),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'TransmissionReceived',
			function ($) {
				return $.transmissionReceived;
			},
			function (_v23) {
				return $author$project$Domain$ActivityItem$TransmissionReceived;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'TransmissionFailed',
			function ($) {
				return $.transmissionFailed;
			},
			$author$project$Domain$ActivityItem$TransmissionFailed),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'TransmissionSucceeded',
			function ($) {
				return $.transmissionSucceeded;
			},
			function (_v24) {
				return $author$project$Domain$ActivityItem$TransmissionSucceeded;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ContactAdded',
			function ($) {
				return $.contactAdded;
			},
			$author$project$Domain$ActivityItem$ContactAdded),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'UpdatedFromExternal',
			function ($) {
				return $.updatedFromExternal;
			},
			$author$project$Domain$ActivityItem$UpdatedFromExternal),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'VerifiedByCadence',
			function ($) {
				return $.verifiedByCadence;
			},
			function (_v25) {
				return $author$project$Domain$ActivityItem$VerifiedByCadence;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'AcknowledgedByFms',
			function ($) {
				return $.acknowledgedByFms;
			},
			function (_v26) {
				return $author$project$Domain$ActivityItem$AcknowledgedByFms;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'NonInvoiceLoadAssignment',
			function ($) {
				return $.nonInvoiceLoadAssignment;
			},
			function (_v27) {
				return $author$project$Domain$ActivityItem$NonInvoiceLoadAssignment;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'VerifierChangedInvoiceAmount',
			function ($) {
				return $.verifierChangedInvoiceAmount;
			},
			$author$project$Domain$ActivityItem$VerifierChangedInvoiceAmount),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'MarkedNotReadyForVerification',
			function ($) {
				return $.markedNotReadyForVerification;
			},
			function (_v28) {
				return $author$project$Domain$ActivityItem$MarkedNotReadyForVerification;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ShipmentApproved',
			function ($) {
				return $.shipmentApproved;
			},
			$author$project$Domain$ActivityItem$ShipmentApproved),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ShipmentRejected',
			function ($) {
				return $.shipmentRejected;
			},
			$author$project$Domain$ActivityItem$ShipmentRejected),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LoadDocumentsApproved',
			function ($) {
				return $.loadDocumentsApproved;
			},
			function (_v29) {
				return $author$project$Domain$ActivityItem$LoadDocumentsApproved;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LoadDocumentsScraped',
			function ($) {
				return $.loadDocumentsScraped;
			},
			function (_v30) {
				return $author$project$Domain$ActivityItem$LoadDocumentsScraped;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LoadDocumentsAssigned',
			function ($) {
				return $.loadDocumentsAssigned;
			},
			function (_v31) {
				return $author$project$Domain$ActivityItem$LoadDocumentsAssigned;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LoadDocumentsSent',
			function ($) {
				return $.loadDocumentsSent;
			},
			function (_v32) {
				return $author$project$Domain$ActivityItem$LoadDocumentsSent;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'BuiltLoadSentToTMS',
			function ($) {
				return $.builtLoadSentToTMS;
			},
			function (_v33) {
				return $author$project$Domain$ActivityItem$BuiltLoadSentToTMS;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'PodRequestSentToTextLocate',
			function ($) {
				return $.podRequestSentToTextLocate;
			},
			function (_v34) {
				return $author$project$Domain$ActivityItem$PodRequestSentToTextLocate;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'BuiltLoadConfirmed',
			function ($) {
				return $.builtLoadConfirmed;
			},
			function (_v35) {
				return $author$project$Domain$ActivityItem$BuiltLoadConfirmed;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LoadShipmentApproval',
			function ($) {
				return $.loadShipmentApproval;
			},
			$author$project$Domain$ActivityItem$LoadShipmentApproval),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LoadShipmentUnapproval',
			function ($) {
				return $.loadShipmentUnapproval;
			},
			$author$project$Domain$ActivityItem$LoadShipmentUnapproval),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'ClientOrDebtorOnBolChanged',
			function ($) {
				return $.clientOrDebtorOnBolChanged;
			},
			$author$project$Domain$ActivityItem$ClientOrDebtorOnBolChanged),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DebtorCorrected',
			function ($) {
				return $.debtorCorrected;
			},
			$author$project$Domain$ActivityItem$DebtorCorrected),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'InvoiceExceptionEmailSent',
			function ($) {
				return $.invoiceExceptionEmailSent;
			},
			function (_v36) {
				return $author$project$Domain$ActivityItem$InvoiceExceptionEmailSent;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LtlDisputeAdded',
			function ($) {
				return $.ltlDisputeAdded;
			},
			$author$project$Domain$ActivityItem$LtlDisputeAdded),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'Hidden',
			function ($) {
				return $.hidden;
			},
			$author$project$Domain$ActivityItem$Hidden),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LtlAcceptAdded',
			function ($) {
				return $.ltlAcceptAdded;
			},
			$author$project$Domain$ActivityItem$LtlAcceptAdded),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LtlUpdatedEdiReceived',
			function ($) {
				return $.ltlUpdatedEdiReceived;
			},
			function (_v37) {
				return $author$project$Domain$ActivityItem$LtlUpdatedEdiReceived;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LtlInvoiceMovedToTMSQueue',
			function ($) {
				return $.ltlInvoiceMovedToTMSQueue;
			},
			$author$project$Domain$ActivityItem$LtlInvoiceMovedToTMSQueue),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LtlRerateRequested',
			function ($) {
				return $.ltlRerateRequested;
			},
			function (_v38) {
				return $author$project$Domain$ActivityItem$LtlRerateRequested;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'AddDocumentToLoadSuccess',
			function ($) {
				return $.addDocumentToLoadSuccess;
			},
			$author$project$Domain$ActivityItem$AddDocumentToLoadSuccess),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'AddDocumentToLoadFailure',
			function ($) {
				return $.addDocumentToLoadFailure;
			},
			$author$project$Domain$ActivityItem$AddDocumentToLoadFailure),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'FlaggedForManualReview',
			function ($) {
				return $.flaggedForManualReview;
			},
			$author$project$Domain$ActivityItem$FlaggedForManualReview),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'CarrierInvoiceRuleChangedViaTms',
			function ($) {
				return $.carrierInvoiceRuleChangedViaTms;
			},
			function (_v39) {
				return $author$project$Domain$ActivityItem$CarrierInvoiceRuleChangedViaTms;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LtlRerateCompleted',
			function ($) {
				return $.ltlRerateCompleted;
			},
			function (_v40) {
				return $author$project$Domain$ActivityItem$LtlRerateCompleted;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LtlRerateFailed',
			function ($) {
				return $.ltlRerateFailed;
			},
			$author$project$Domain$ActivityItem$LtlRerateFailed),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentsMerged',
			function ($) {
				return $.documentsMerged;
			},
			function (_v41) {
				return $author$project$Domain$ActivityItem$DocumentsMerged;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'LineItemsAutoReplaced',
			function ($) {
				return $.lineItemsAutoReplaced;
			},
			function (_v42) {
				return $author$project$Domain$ActivityItem$LineItemsAutoReplaced;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'IndexingComplete',
			function ($) {
				return $.indexingComplete;
			},
			function (_v43) {
				return $author$project$Domain$ActivityItem$IndexingComplete;
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'VerificationBatchStarted',
			function ($) {
				return $.verificationBatchStarted;
			},
			function (_v44) {
				return $author$project$Domain$ActivityItem$VerificationBatchStarted;
			})
		]),
	function (details_) {
		switch (details_.$) {
			case 'BypassedVerifyQueue':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.bypassedVerifyQueue;
					});
			case 'DocumentAdded':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.documentAdded;
					});
			case 'DocumentAssigned':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.documentAssigned;
					});
			case 'DocumentBatchIgnored':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.documentBatchIgnored;
					});
			case 'DocumentRemoved':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.documentRemoved;
					});
			case 'DocumentSentToExternal':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.documentSentToExternal;
					});
			case 'EmailMergeSource':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.emailMergeSource;
					});
			case 'EmailMergeTarget':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.emailMergeTarget;
					});
			case 'EmailIgnored':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.emailIgnored;
					});
			case 'EmailUnignored':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.emailUnignored;
					});
			case 'EmailZeroPages':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.emailZeroPages;
					});
			case 'EmailCompleted':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.emailCompleted;
					});
			case 'DuplicateEmailAutoCompleted':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.duplicateEmailAutoCompleted;
					});
			case 'AutoCompletedWaitingExceptionsOnNewDocs':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.autoCompletedWaitingExceptionsOnNewDocs;
					});
			case 'DuplicateDocumentBatchAutoCompleted':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.duplicateDocumentBatchAutoCompleted;
					});
			case 'DuplicateDocumentAutoHidden':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.duplicateDocumentAutoHidden;
					});
			case 'DuplicateDocumentAutoMerged':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.duplicateDocumentAutoMerged;
					});
			case 'ExceptionDocumentsSent':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.exceptionDocumentsSent;
					});
			case 'ExceptionResolved':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.exceptionResolved;
					});
			case 'ExceptionsClearedViaAPI':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.exceptionsClearedViaAPI;
					});
			case 'FactoringAssignment':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.factoringAssignment;
					});
			case 'ForwardedEmail':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.forwardedEmail;
					});
			case 'InvoiceDocumentsForwardedToTriumph':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceDocumentsForwardedToTriumph;
					});
			case 'InvoiceApproved':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.invoiceApproved;
					});
			case 'CarrierPayableApproved':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.carrierPayableApproved;
					});
			case 'InvoiceDocumentsResendRequested':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceDocumentsResendRequested;
					});
			case 'InvoiceAbandoned':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.invoiceAbandoned;
					});
			case 'InvoiceCreatedByExternal':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.invoiceCreatedByExternal;
					});
			case 'InvoiceMatched':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceMatched;
					});
			case 'InvoiceMarkedAsPurchased':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceMarkedAsPurchased;
					});
			case 'InvoiceProcessed':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.invoiceProcessed;
					});
			case 'InvoiceAutoProcessed':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.invoiceAutoProcessed;
					});
			case 'InvoiceRejected':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceRejected;
					});
			case 'InvoiceRemovedFromGroup':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceRemovedFromGroup;
					});
			case 'InvoiceUnapproved':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceUnapproved;
					});
			case 'InvoiceUnignored':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceUnignored;
					});
			case 'SentToVerifyQueue':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.sentToVerifyQueue;
					});
			case 'VerifyCompleted':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.verifyCompleted;
					});
			case 'NoteAdded':
				var message = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					message,
					function ($) {
						return $.noteAdded;
					});
			case 'NoteSentToPaymentsNetwork':
				var message = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					message,
					function ($) {
						return $.noteSentToPaymentsNetwork;
					});
			case 'Paused':
				var until = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					until,
					function ($) {
						return $.paused;
					});
			case 'PaymentAddressChanged':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.paymentAddressChanged;
					});
			case 'ReceivedInvoice':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.receivedInvoice;
					});
			case 'RuleDisabled':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.ruleDisabled;
					});
			case 'RuleEnabled':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.ruleEnabled;
					});
			case 'SavedAsIncomplete':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.savedAsIncomplete;
					});
			case 'SentToCadence':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.sentToCadence;
					});
			case 'SentToExternal':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.sentToExternal;
					});
			case 'ReadyForFmsPickup':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.readyForFmsPickup;
					});
			case 'StateChanged':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.stateChanged;
					});
			case 'TransmissionReceived':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.transmissionReceived;
					});
			case 'TransmissionFailed':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.transmissionFailed;
					});
			case 'TransmissionSucceeded':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.transmissionSucceeded;
					});
			case 'ContactAdded':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.contactAdded;
					});
			case 'UpdatedFromExternal':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.updatedFromExternal;
					});
			case 'VerifiedByCadence':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.verifiedByCadence;
					});
			case 'AcknowledgedByFms':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.acknowledgedByFms;
					});
			case 'NonInvoiceLoadAssignment':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.nonInvoiceLoadAssignment;
					});
			case 'VerifierChangedInvoiceAmount':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.verifierChangedInvoiceAmount;
					});
			case 'MarkedNotReadyForVerification':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.markedNotReadyForVerification;
					});
			case 'ShipmentApproved':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.shipmentApproved;
					});
			case 'ShipmentRejected':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.shipmentRejected;
					});
			case 'LoadDocumentsApproved':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.loadDocumentsApproved;
					});
			case 'LoadDocumentsScraped':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.loadDocumentsScraped;
					});
			case 'LoadDocumentsAssigned':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.loadDocumentsAssigned;
					});
			case 'LoadDocumentsSent':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.loadDocumentsSent;
					});
			case 'BuiltLoadSentToTMS':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.builtLoadSentToTMS;
					});
			case 'PodRequestSentToTextLocate':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.podRequestSentToTextLocate;
					});
			case 'BuiltLoadConfirmed':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.builtLoadConfirmed;
					});
			case 'LoadShipmentApproval':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.loadShipmentApproval;
					});
			case 'LoadShipmentUnapproval':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.loadShipmentUnapproval;
					});
			case 'ClientOrDebtorOnBolChanged':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.clientOrDebtorOnBolChanged;
					});
			case 'DebtorCorrected':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.debtorCorrected;
					});
			case 'InvoiceExceptionEmailSent':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.invoiceExceptionEmailSent;
					});
			case 'LtlDisputeAdded':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.ltlDisputeAdded;
					});
			case 'Hidden':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.hidden;
					});
			case 'LtlAcceptAdded':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.ltlAcceptAdded;
					});
			case 'LtlUpdatedEdiReceived':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.ltlUpdatedEdiReceived;
					});
			case 'LtlInvoiceMovedToTMSQueue':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.ltlInvoiceMovedToTMSQueue;
					});
			case 'LtlRerateRequested':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.ltlRerateRequested;
					});
			case 'AddDocumentToLoadSuccess':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.addDocumentToLoadSuccess;
					});
			case 'AddDocumentToLoadFailure':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.addDocumentToLoadFailure;
					});
			case 'FlaggedForManualReview':
				var reason = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					reason,
					function ($) {
						return $.flaggedForManualReview;
					});
			case 'CarrierInvoiceRuleChangedViaTms':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.carrierInvoiceRuleChangedViaTms;
					});
			case 'LtlRerateCompleted':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.ltlRerateCompleted;
					});
			case 'LtlRerateFailed':
				var details = details_.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					details,
					function ($) {
						return $.ltlRerateFailed;
					});
			case 'DocumentsMerged':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.documentsMerged;
					});
			case 'LineItemsAutoReplaced':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.lineItemsAutoReplaced;
					});
			case 'IndexingComplete':
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.indexingComplete;
					});
			default:
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					_Utils_Tuple0,
					function ($) {
						return $.verificationBatchStarted;
					});
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemFactorInvoiceProcessedDetailsToTmsCarrier = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.tmsCarrierId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemInvoiceCreatedByExternalDetailsToTmsCarrier = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.tmsCarrierId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemProcessedDetailsEdge = A2(
	$author$project$Forward$Lookup$defineUnionTypeEdge,
	_List_fromArray(
		[
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'FactorInvoiceProcessedDetails_',
			function ($) {
				return $.factorInvoiceProcessedDetails_;
			},
			$author$project$Domain$ActivityItem$FactorInvoiceProcessedDetails_),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'CarrierInvoiceProcessedDetails_',
			function ($) {
				return $.carrierInvoiceProcessedDetails_;
			},
			$author$project$Domain$ActivityItem$CarrierInvoiceProcessedDetails_)
		]),
	function (details_) {
		if (details_.$ === 'FactorInvoiceProcessedDetails_') {
			var details = details_.a;
			return A2(
				$author$project$Forward$Lookup$unionTypeDispatch,
				details,
				function ($) {
					return $.factorInvoiceProcessedDetails_;
				});
		} else {
			var details = details_.a;
			return A2(
				$author$project$Forward$Lookup$unionTypeDispatch,
				details,
				function ($) {
					return $.carrierInvoiceProcessedDetails_;
				});
		}
	});
var $author$project$Components$ActivityBrowser$DetailsView$tmsCarrierForActivityItem = function () {
	var noDetails = $author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$NoNestedDetails);
	return $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemDetailsEdge(
		{
			acknowledgedByFms: noDetails,
			addDocumentToLoadFailure: noDetails,
			addDocumentToLoadSuccess: noDetails,
			autoCompletedWaitingExceptionsOnNewDocs: noDetails,
			builtLoadConfirmed: noDetails,
			builtLoadSentToTMS: noDetails,
			bypassedVerifyQueue: noDetails,
			carrierInvoiceRuleChangedViaTms: noDetails,
			carrierPayableApproved: A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemCarrierPayableApprovedDetailsToTmsCarrier,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$identity,
					$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$CarrierPayableApprovedData))),
			clientOrDebtorOnBolChanged: noDetails,
			contactAdded: noDetails,
			debtorCorrected: noDetails,
			documentAdded: noDetails,
			documentAssigned: noDetails,
			documentBatchIgnored: noDetails,
			documentRemoved: noDetails,
			documentSentToExternal: noDetails,
			documentsMerged: noDetails,
			duplicateDocumentAutoHidden: noDetails,
			duplicateDocumentAutoMerged: noDetails,
			duplicateDocumentBatchAutoCompleted: noDetails,
			duplicateEmailAutoCompleted: noDetails,
			emailCompleted: noDetails,
			emailIgnored: noDetails,
			emailMergeSource: noDetails,
			emailMergeTarget: noDetails,
			emailUnignored: noDetails,
			emailZeroPages: noDetails,
			exceptionDocumentsSent: noDetails,
			exceptionResolved: noDetails,
			exceptionsClearedViaAPI: noDetails,
			factoringAssignment: noDetails,
			flaggedForManualReview: noDetails,
			forwardedEmail: noDetails,
			hidden: noDetails,
			indexingComplete: noDetails,
			invoiceAbandoned: noDetails,
			invoiceApproved: noDetails,
			invoiceAutoProcessed: A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemFactorInvoiceProcessedDetailsToTmsCarrier,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$identity,
					$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$FactorInvoiceProcessedData))),
			invoiceCreatedByExternal: A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemInvoiceCreatedByExternalDetailsToTmsCarrier,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$identity,
					$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$InvoiceCreatedByExternalData))),
			invoiceDocumentsForwardedToTriumph: noDetails,
			invoiceDocumentsResendRequested: noDetails,
			invoiceExceptionEmailSent: noDetails,
			invoiceMarkedAsPurchased: noDetails,
			invoiceMatched: noDetails,
			invoiceProcessed: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemProcessedDetailsEdge(
				{
					carrierInvoiceProcessedDetails_: A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemCarrierInvoiceProcessedDetailsToTmsCarrier,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$identity,
							$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$CarrierInvoiceProcessedData))),
					factorInvoiceProcessedDetails_: A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemFactorInvoiceProcessedDetailsToTmsCarrier,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$identity,
							$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$FactorInvoiceProcessedData)))
				}),
			invoiceRejected: noDetails,
			invoiceRemovedFromGroup: noDetails,
			invoiceUnapproved: noDetails,
			invoiceUnignored: noDetails,
			lineItemsAutoReplaced: noDetails,
			loadDocumentsApproved: noDetails,
			loadDocumentsAssigned: noDetails,
			loadDocumentsScraped: noDetails,
			loadDocumentsSent: noDetails,
			loadShipmentApproval: A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$identity,
				$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$LoadShipmentApprovalData)),
			loadShipmentUnapproval: A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$identity,
				$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$LoadShipmentUnapprovalData)),
			ltlAcceptAdded: noDetails,
			ltlDisputeAdded: noDetails,
			ltlInvoiceMovedToTMSQueue: noDetails,
			ltlRerateCompleted: noDetails,
			ltlRerateFailed: noDetails,
			ltlRerateRequested: noDetails,
			ltlUpdatedEdiReceived: noDetails,
			markedNotReadyForVerification: noDetails,
			nonInvoiceLoadAssignment: noDetails,
			noteAdded: noDetails,
			noteSentToPaymentsNetwork: noDetails,
			paused: noDetails,
			paymentAddressChanged: noDetails,
			podRequestSentToTextLocate: noDetails,
			readyForFmsPickup: noDetails,
			receivedInvoice: noDetails,
			ruleDisabled: noDetails,
			ruleEnabled: noDetails,
			savedAsIncomplete: noDetails,
			sentToCadence: noDetails,
			sentToExternal: A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$identity,
				$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$TransmissionDetailsData)),
			sentToVerifyQueue: noDetails,
			shipmentApproved: noDetails,
			shipmentRejected: noDetails,
			stateChanged: noDetails,
			transmissionFailed: noDetails,
			transmissionReceived: noDetails,
			transmissionSucceeded: noDetails,
			updatedFromExternal: noDetails,
			verificationBatchStarted: noDetails,
			verifiedByCadence: noDetails,
			verifierChangedInvoiceAmount: noDetails,
			verifyCompleted: noDetails
		});
}();
var $author$project$Components$ActivityBrowser$DetailsView$loadData = function () {
	var nestedDetails = A2(
		$author$project$Forward$Lookup$traverse,
		$author$project$Components$ActivityBrowser$DetailsView$tmsCarrierForActivityItem,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.details;
			},
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItem));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
		A2(
			$author$project$Forward$Lookup$apply,
			nestedDetails,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItem,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
						$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$DetailsView$Data))))));
}();
var $author$project$Components$ActivityBrowser$ActivityItemView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Components$ActivityBrowser$DetailsView$loadData,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$ActivityBrowser$ContextView$loadData,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItem,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
					$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$ActivityItemView$Data))))));
var $author$project$Components$ActivityBrowser$FiltersView$maybeInvoiceNumOrLoadId = function (model) {
	var _v0 = model.invoiceNumOrLoadIdString;
	if (_v0 === '') {
		return $elm$core$Maybe$Nothing;
	} else {
		var s = _v0;
		return $elm$core$Maybe$Just(s);
	}
};
var $author$project$Typeahead$selectedId = function (_v0) {
	var model = _v0.a;
	var _v1 = model.selection;
	if (_v1.$ === 'NoSelection') {
		return $elm$core$Maybe$Nothing;
	} else {
		var itemId = _v1.a;
		return $elm$core$Maybe$Just(itemId);
	}
};
var $author$project$Components$ActivityBrowser$FiltersView$selectedFactorBrokerId = function (model) {
	return $author$project$Typeahead$selectedId(model.debtorTypeahead);
};
var $author$project$Ui$V3$CustomSelect$selectedItems = function (_v0) {
	var model = _v0.a;
	return model.selectedItems;
};
var $author$project$Components$PaginatedDropdown$selectedIds = function (model) {
	return $author$project$Ui$V3$CustomSelect$selectedItems(model.dropdown);
};
var $author$project$Components$SettingsPage$CarrierDropdown$selectedIds = function (model) {
	return A2(
		$elm$core$List$map,
		$author$project$Domain$TmsCarrierId$fromInt,
		A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown))));
};
var $author$project$Components$ActivityBrowser$FiltersView$selectedTmsCarrierId = F2(
	function (v3Reskin, model) {
		return v3Reskin ? $elm$core$List$head(
			$author$project$Components$SettingsPage$CarrierDropdown$selectedIds(model.carrierDropdown)) : $author$project$Typeahead$selectedId(model.carrierTypeahead);
	});
var $author$project$Components$TmsCustomerDropdown$selectedIds = function (model) {
	return A2(
		$elm$core$List$map,
		$author$project$Domain$TmsCustomerId$fromInt,
		A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown))));
};
var $author$project$Components$ActivityBrowser$FiltersView$selectedTmsCustomerId = F2(
	function (v3Reskin, model) {
		return v3Reskin ? $elm$core$List$head(
			$author$project$Components$TmsCustomerDropdown$selectedIds(model.customerDropdown)) : $author$project$Typeahead$selectedId(model.customerTypeahead);
	});
var $author$project$Helpers$Date$toRfc3339 = function (date) {
	return A2(
		$elm$core$String$join,
		'-',
		A2(
			$elm$core$List$map,
			$elm$core$Basics$apR(date),
			_List_fromArray(
				[
					A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $justinmimbs$date$Date$year),
					A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$String$padLeft,
								2,
								_Utils_chr('0')),
							$elm$core$String$fromInt),
						$author$project$Helpers$Date$monthInt),
					$justinmimbs$date$Date$month),
					A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0')),
						$elm$core$String$fromInt),
					$justinmimbs$date$Date$day)
				])));
};
var $author$project$Components$ActivityBrowser$ActivityItemListView$loadData = F2(
	function (v3Reskin, _v0) {
		var filters = _v0.filters;
		var page = _v0.page;
		var pageQuery = $author$project$Domain$ActivityItemIdsQuery$forPage(page);
		var query = _Utils_update(
			pageQuery,
			{
				activityType: filters.selectedActivityType,
				endDate: A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, filters.endDate),
				factorBrokerId: $author$project$Components$ActivityBrowser$FiltersView$selectedFactorBrokerId(filters),
				invoiceNumOrLoadId: $author$project$Components$ActivityBrowser$FiltersView$maybeInvoiceNumOrLoadId(filters),
				startDate: A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, filters.startDate),
				tmsCarrierId: A2($author$project$Components$ActivityBrowser$FiltersView$selectedTmsCarrierId, v3Reskin, filters),
				tmsCustomerId: A2($author$project$Components$ActivityBrowser$FiltersView$selectedTmsCustomerId, v3Reskin, filters),
				userId: filters.selectedUserId
			});
		var queries = v3Reskin ? A2(
			$elm$core$List$map,
			function (p) {
				return _Utils_update(
					query,
					{page: p});
			},
			A2($elm$core$List$range, 0, page)) : _List_fromArray(
			[query]);
		var activityItems = A2(
			$author$project$Forward$Lookup$traverseStream,
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$ActivityBrowser$ActivityItemView$loadData),
			A2(
				$author$project$Forward$Lookup$map,
				$author$project$Stream$concat,
				A2($author$project$Forward$Lookup$startFromList, queries, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemIdsByQuery)));
		return A2(
			$author$project$Forward$Lookup$apply,
			activityItems,
			$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$ActivityItemListView$Data));
	});
var $author$project$Components$ActivityBrowser$FiltersView$Data = F5(
	function (debtorTypeaheadData, carrierTypeaheadData, carrierDropdownData, customerTypeaheadData, customerDropdownData) {
		return {carrierDropdownData: carrierDropdownData, carrierTypeaheadData: carrierTypeaheadData, customerDropdownData: customerDropdownData, customerTypeaheadData: customerTypeaheadData, debtorTypeaheadData: debtorTypeaheadData};
	});
var $author$project$Typeahead$Data = F2(
	function (selectedItem, menuItems) {
		return {menuItems: menuItems, selectedItem: selectedItem};
	});
var $author$project$Typeahead$loadData = F3(
	function (loadItem, loadItems, _v0) {
		var model = _v0.a;
		var selectedItem = function () {
			var _v2 = $author$project$Typeahead$selectedId(
				$author$project$Typeahead$Model(model));
			if (_v2.$ === 'Just') {
				var itemId = _v2.a;
				return A2(
					$author$project$Forward$Lookup$map,
					$elm$core$Maybe$Just,
					A2($author$project$Forward$Lookup$startFrom, itemId, loadItem));
			} else {
				return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
			}
		}();
		var itemsForMenu = function () {
			var _v1 = model.selection;
			if (_v1.$ === 'NoSelection') {
				var term = _v1.a;
				return loadItems(term);
			} else {
				return $author$project$Forward$Lookup$succeed(_List_Nil);
			}
		}();
		return $author$project$Forward$Lookup$exposeLoadingState(
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(itemsForMenu),
				A2(
					$author$project$Forward$Lookup$apply,
					selectedItem,
					$author$project$Forward$Lookup$succeed($author$project$Typeahead$Data))));
	});
var $author$project$Domain$TmsCustomerId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$list_tmsCustomerId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_tmsCustomerId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_tmsCustomerId: e});
		}));
var $author$project$AuditPb$tmsCustomerIdsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'query', $elm$json$Json$Encode$string, v.query)
				])));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomersByQuery = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_tmsCustomerId,
		decoder: $author$project$Domain$TmsCustomerId$decode,
		entrypoint: 'tmsCustomerIdsByQuery',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$tmsCustomerIdsQueryEncoder)
	});
var $author$project$Components$CustomerTypeahead$loadData = function () {
	var search = function (searchTerm) {
		return A2(
			$author$project$Forward$Lookup$startFrom,
			{query: searchTerm},
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomersByQuery);
	};
	return A2($author$project$Typeahead$loadData, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer, search);
}();
var $author$project$AuditPb$factorBrokerIdsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'term', $elm$json$Json$Encode$string, v.term),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'carrier_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCarrierId$toInt),
					v.carrierId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'use_simple_search', $elm$json$Json$Encode$bool, v.useSimpleSearch)
				])));
};
var $author$project$Domain$FactorBrokerIdsQuery$encode = function (query) {
	return $author$project$AuditPb$factorBrokerIdsQueryEncoder(query);
};
var $author$project$Forward$AppSpecific$Cache$list_factorBrokerId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_factorBrokerId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_factorBrokerId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokersByQuery = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_factorBrokerId,
		decoder: $author$project$Domain$FactorBrokerId$decode,
		entrypoint: 'factorBrokerIdsByQuery',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$FactorBrokerIdsQuery$encode)
	});
var $author$project$Components$DebtorTypeahead$loadDataWithOptions = function (options) {
	var search = function (searchTerm) {
		return A2(
			$author$project$Forward$Lookup$startFrom,
			{carrierId: options.carrierId, term: searchTerm, useSimpleSearch: options.useSimpleSearch},
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokersByQuery);
	};
	return A2($author$project$Typeahead$loadData, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker, search);
};
var $author$project$Components$DebtorTypeahead$loadData = function (carrierId) {
	return $author$project$Components$DebtorTypeahead$loadDataWithOptions(
		{carrierId: carrierId, useSimpleSearch: false});
};
var $author$project$Ui$V3$CustomSelect$hasScrolledToBottom = function (_v0) {
	var model = _v0.a;
	return model.hasScrolledToBottom;
};
var $author$project$Ui$V3$CustomSelect$inputValue = function (_v0) {
	var model = _v0.a;
	return model.inputValue;
};
var $author$project$Components$PaginatedDropdown$minSearchLength = 2;
var $author$project$Components$PaginatedDropdown$loadData = F2(
	function (lookup, paginatedDropdown) {
		var dropdown = paginatedDropdown.dropdown;
		var searchTerm = $elm$core$String$trim(
			$author$project$Ui$V3$CustomSelect$inputValue(dropdown));
		var numItemsPerPage = paginatedDropdown.entriesPerPage;
		var numCachedItems = $elm$core$List$length(
			$elm$core$List$concat(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.pages;
						},
						A2($elm$core$Dict$get, searchTerm, paginatedDropdown.cachedPages)))));
		var currentPageNum = (A2($elm$core$Basics$max, 0, numCachedItems - 1) / numItemsPerPage) | 0;
		var canSearchMore = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.isExhausted;
					}),
				A2($elm$core$Dict$get, searchTerm, paginatedDropdown.cachedPages)));
		var shouldSearchNextPage = canSearchMore && $author$project$Ui$V3$CustomSelect$hasScrolledToBottom(paginatedDropdown.dropdown);
		var pageNumToSearch = shouldSearchNextPage ? (currentPageNum + 1) : currentPageNum;
		var paginatedItems = (_Utils_cmp(
			$elm$core$String$length(searchTerm),
			$author$project$Components$PaginatedDropdown$minSearchLength) < 0) ? $author$project$Forward$Lookup$succeed(
			A3($author$project$Pagination$fromList, 1, numItemsPerPage, _List_Nil)) : lookup(
			{page: pageNumToSearch + 1, term: searchTerm});
		return $author$project$Forward$Lookup$exposeLoadingState(paginatedItems);
	});
var $author$project$AuditPb$repeatedFieldEncoder = F3(
	function (name, encoder, v) {
		if (!v.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					name,
					A2($elm$json$Json$Encode$list, encoder, v)));
		}
	});
var $author$project$AuditPb$tmsCarrierIdsSettingsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'term', $elm$json$Json$Encode$string, v.term),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'labels', $elm$json$Json$Encode$string, v.labels),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'scraperOnly', $elm$json$Json$Encode$bool, v.scraperOnly),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'withLoginFailures', $elm$json$Json$Encode$bool, v.withLoginFailures),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'eligibleForAutoprocessing', $elm$json$Json$Encode$bool, v.eligibleForAutoprocessing)
				])));
};
var $author$project$Domain$TmsCarrierIdsSettingsQuery$encode = function (query) {
	return $author$project$AuditPb$tmsCarrierIdsSettingsQueryEncoder(query);
};
var $author$project$Forward$AppSpecific$Cache$page_tmsCarrierId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_tmsCarrierId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_tmsCarrierId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarriersBySettingsQuery = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_tmsCarrierId,
		entrypoint: 'tmsCarrierIdsBySettingsQuery',
		idFromInt: $author$project$Domain$TmsCarrierId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$TmsCarrierIdsSettingsQuery$encode)
	});
var $author$project$Components$SettingsPage$CarrierDropdown$loadData = function (_v0) {
	var dropdown = _v0.dropdown;
	return A2(
		$author$project$Components$PaginatedDropdown$loadData,
		function (_v1) {
			var term = _v1.term;
			var page = _v1.page;
			return A2(
				$author$project$Forward$Lookup$startFrom,
				{eligibleForAutoprocessing: false, labels: _List_Nil, page: page, scraperOnly: false, term: term, withLoginFailures: false},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarriersBySettingsQuery);
		},
		dropdown);
};
var $author$project$Forward$AppSpecific$Cache$page_tmsCustomer = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_tmsCustomer;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_tmsCustomer: e});
		}));
var $author$project$AuditPb$tmsCustomerInfoQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'term', $elm$json$Json$Encode$string, v.term)
				])));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerNamesByQuery = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_tmsCustomer,
		entrypoint: 'tmsCustomerNamesByQuery',
		idFromInt: $author$project$Domain$TmsCustomerId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$tmsCustomerInfoQueryEncoder)
	});
var $author$project$Components$TmsCustomerDropdown$loadData = function (_v0) {
	var dropdown = _v0.dropdown;
	return A2(
		$author$project$Components$PaginatedDropdown$loadData,
		function (_v1) {
			var term = _v1.term;
			var page = _v1.page;
			return A2(
				$author$project$Forward$Lookup$startFrom,
				{page: page, term: term},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerNamesByQuery);
		},
		dropdown);
};
var $author$project$Forward$AppSpecific$Cache$list_tmsCarrierId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_tmsCarrierId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_tmsCarrierId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarriersByQuery = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_tmsCarrierId,
		decoder: $author$project$Domain$TmsCarrierId$decode,
		entrypoint: 'tmsCarrierIdsByQuery',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		parameters: $author$project$Forward$Lookup$queryParameters($elm$json$Json$Encode$string)
	});
var $author$project$Components$CarrierTypeahead$loadDataAllCarriers = function () {
	var searchIfNotEmpty = function (searchTerm) {
		if (searchTerm === '') {
			return $author$project$Forward$Lookup$succeed(_List_Nil);
		} else {
			return A2($author$project$Forward$Lookup$startFrom, searchTerm, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarriersByQuery);
		}
	};
	return A2($author$project$Typeahead$loadData, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier, searchIfNotEmpty);
}();
var $author$project$Components$ActivityBrowser$FiltersView$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$TmsCustomerDropdown$loadData(model.customerDropdown),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$CustomerTypeahead$loadData(model.customerTypeahead),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$SettingsPage$CarrierDropdown$loadData(model.carrierDropdown),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Components$CarrierTypeahead$loadDataAllCarriers(model.carrierTypeahead),
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Components$DebtorTypeahead$loadData, model.debtorTypeaheadCarrierId, model.debtorTypeahead),
						$author$project$Forward$Lookup$succeed($author$project$Components$ActivityBrowser$FiltersView$Data))))));
};
var $author$project$Forward$AppSpecific$Cache$list_userId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_userId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_userId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$users = $author$project$Forward$Lookup$defineReferenceList(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$list_userId, decoder: $author$project$Domain$UserId$decode, entrypoint: 'userIds', objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$user, parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Components$ActivityPage$loadData = F2(
	function (v3Reskin, model) {
		return A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState(
				A2(
					$author$project$Components$ActivityBrowser$ActivityItemListView$loadData,
					v3Reskin,
					{filters: model.appliedFilters, page: model.page})),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$ActivityBrowser$FiltersView$loadData(model.filters)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$users,
							$author$project$Forward$Lookup$succeed($author$project$Components$ActivityPage$Data))))));
	});
var $author$project$Components$CarrierInvoiceAuditPage$Data = F9(
	function (auditChecks, documentsBrowserData, carrierInvoice, tmsLoadDetails, tmsCarrier, tmsLoadInformation, documentTypeSettings, accountSettings, currentUser) {
		return {accountSettings: accountSettings, auditChecks: auditChecks, carrierInvoice: carrierInvoice, currentUser: currentUser, documentTypeSettings: documentTypeSettings, documentsBrowserData: documentsBrowserData, tmsCarrier: tmsCarrier, tmsLoadDetails: tmsLoadDetails, tmsLoadInformation: tmsLoadInformation};
	});
var $author$project$AuditPb$CarrierInvoiceAuditCheck = F2(
	function (result, details) {
		return {details: details, result: result};
	});
var $author$project$AuditPb$CarrierInvoiceAuditCheckResultSkipped = {$: 'CarrierInvoiceAuditCheckResultSkipped'};
var $author$project$AuditPb$carrierInvoiceAuditCheckResultDefault = $author$project$AuditPb$CarrierInvoiceAuditCheckResultSkipped;
var $author$project$AuditPb$CarrierInvoiceAuditCheckResultFailed = {$: 'CarrierInvoiceAuditCheckResultFailed'};
var $author$project$AuditPb$CarrierInvoiceAuditCheckResultIgnored = {$: 'CarrierInvoiceAuditCheckResultIgnored'};
var $author$project$AuditPb$CarrierInvoiceAuditCheckResultPassed = {$: 'CarrierInvoiceAuditCheckResultPassed'};
var $author$project$AuditPb$CarrierInvoiceAuditCheckResultResolved = {$: 'CarrierInvoiceAuditCheckResultResolved'};
var $author$project$AuditPb$allCarrierInvoiceAuditCheckResult = _List_fromArray(
	[$author$project$AuditPb$CarrierInvoiceAuditCheckResultSkipped, $author$project$AuditPb$CarrierInvoiceAuditCheckResultPassed, $author$project$AuditPb$CarrierInvoiceAuditCheckResultFailed, $author$project$AuditPb$CarrierInvoiceAuditCheckResultIgnored, $author$project$AuditPb$CarrierInvoiceAuditCheckResultResolved]);
var $author$project$AuditPb$carrierInvoiceAuditCheckResultToString = function (v) {
	switch (v.$) {
		case 'CarrierInvoiceAuditCheckResultSkipped':
			return 'skipped';
		case 'CarrierInvoiceAuditCheckResultPassed':
			return 'passed';
		case 'CarrierInvoiceAuditCheckResultFailed':
			return 'failed';
		case 'CarrierInvoiceAuditCheckResultIgnored':
			return 'ignored';
		default:
			return 'resolved';
	}
};
var $author$project$AuditPb$carrierInvoiceAuditCheckResultDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$carrierInvoiceAuditCheckResultToString(v),
				v);
		},
		$author$project$AuditPb$allCarrierInvoiceAuditCheckResult));
var $author$project$AuditPb$carrierInvoiceAuditCheckResultFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$carrierInvoiceAuditCheckResultDict);
};
var $author$project$AuditPb$carrierInvoiceAuditCheckResultDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$carrierInvoiceAuditCheckResultDefault),
		$author$project$AuditPb$carrierInvoiceAuditCheckResultFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheck_Details_ExceptionEvent = function (a) {
	return {$: 'CarrierInvoiceAuditCheck_Details_ExceptionEvent', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditRuleCheck = F3(
	function (checkType, failures, ignoredFailures) {
		return {checkType: checkType, failures: failures, ignoredFailures: ignoredFailures};
	});
var $author$project$AuditPb$CarrierInvoiceAuditCheckFailure = F3(
	function (id, message, ignorable) {
		return {id: id, ignorable: ignorable, message: message};
	});
var $author$project$AuditPb$carrierInvoiceAuditCheckFailureDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'ignorable',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'message',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'id',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceAuditCheckFailure))));
	});
var $author$project$AuditPb$CarrierInvoiceAuditCheckType = function (check) {
	return {check: check};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierInvoiceDuplicateInvoiceCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceDuplicateInvoiceCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceAmountCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceAmountCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceDateCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceDateCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierMatchCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_CarrierMatchCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierRateCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_CarrierRateCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CustomExceptionMessageCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_CustomExceptionMessageCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CustomerInstructionsCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_CustomerInstructionsCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_DocumentReviewCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_DocumentReviewCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_DocumentsRequiredCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_DocumentsRequiredCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_LoadMatchCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_LoadMatchCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_OsdCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_OsdCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_OtherCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_OtherCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck = function (a) {
	return {$: 'CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck', a: a};
};
var $author$project$AuditPb$CarrierInvoiceDuplicateInvoiceCheck = {};
var $author$project$AuditPb$carrierInvoiceDuplicateInvoiceCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceDuplicateInvoiceCheck);
	});
var $author$project$AuditPb$CarrierInvoiceInvoiceAmountCheck = {};
var $author$project$AuditPb$carrierInvoiceInvoiceAmountCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceInvoiceAmountCheck);
	});
var $author$project$AuditPb$CarrierInvoiceInvoiceDateCheck = {};
var $author$project$AuditPb$carrierInvoiceInvoiceDateCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceInvoiceDateCheck);
	});
var $author$project$AuditPb$CarrierMatchCheck = {};
var $author$project$AuditPb$carrierMatchCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$CarrierMatchCheck);
	});
var $author$project$AuditPb$CarrierRateCheck = function (documentIds) {
	return {documentIds: documentIds};
};
var $author$project$AuditPb$carrierRateCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'documentIds',
			A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$CarrierRateCheck));
	});
var $author$project$AuditPb$CustomExceptionMessageCheck = function (message) {
	return {message: message};
};
var $author$project$AuditPb$customExceptionMessageCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'message',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$CustomExceptionMessageCheck));
	});
var $author$project$AuditPb$CustomerInstructionsCheck = function (customers) {
	return {customers: customers};
};
var $author$project$AuditPb$CustomerInstructions = F2(
	function (customerName, instructions) {
		return {customerName: customerName, instructions: instructions};
	});
var $author$project$AuditPb$customerInstructionsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'instructions',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'customerName',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$CustomerInstructions)));
	});
var $author$project$AuditPb$customerInstructionsCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'customers',
			$author$project$AuditPb$customerInstructionsDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$CustomerInstructionsCheck));
	});
var $author$project$AuditPb$DocumentReviewCheck = {};
var $author$project$AuditPb$documentReviewCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DocumentReviewCheck);
	});
var $author$project$AuditPb$DocumentsRequiredCheck = F3(
	function (requiredDocumentTypes, title, passedDescription) {
		return {passedDescription: passedDescription, requiredDocumentTypes: requiredDocumentTypes, title: title};
	});
var $author$project$AuditPb$documentsRequiredCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'passedDescription',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$repeated,
					'requiredDocumentTypes',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$DocumentsRequiredCheck))));
	});
var $author$project$AuditPb$ExtractedFieldsCheck = function (fields) {
	return {fields: fields};
};
var $author$project$AuditPb$CarrierInvoiceExtractedField = F4(
	function (name, label, value, required) {
		return {label: label, name: name, required: required, value: value};
	});
var $author$project$AuditPb$carrierInvoiceExtractedFieldDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'required',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'value',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'label',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'name',
						$elm$json$Json$Decode$string,
						$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceExtractedField)))));
	});
var $author$project$AuditPb$extractedFieldsCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'fields',
			$author$project$AuditPb$carrierInvoiceExtractedFieldDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$ExtractedFieldsCheck));
	});
var $author$project$AuditPb$LabelRuleFailureCheck = F2(
	function (title, labelingRules) {
		return {labelingRules: labelingRules, title: title};
	});
var $author$project$AuditPb$LabelingRule = F4(
	function (label, kind, category, record) {
		return {category: category, kind: kind, label: label, record: record};
	});
var $author$project$AuditPb$LabelingRecord = function (record) {
	return {record: record};
};
var $author$project$AuditPb$LabelingRecord_Record_LabelingCarrier = function (a) {
	return {$: 'LabelingRecord_Record_LabelingCarrier', a: a};
};
var $author$project$AuditPb$LabelingRecord_Record_LabelingNoRecord = function (a) {
	return {$: 'LabelingRecord_Record_LabelingNoRecord', a: a};
};
var $author$project$AuditPb$LabelingRecord_Record_LabelingReferences = function (a) {
	return {$: 'LabelingRecord_Record_LabelingReferences', a: a};
};
var $author$project$AuditPb$LabelingCarrier = F2(
	function (id, name) {
		return {id: id, name: name};
	});
var $author$project$AuditPb$labelingCarrierDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$LabelingCarrier)));
	});
var $author$project$AuditPb$LabelingNoRecord = {};
var $author$project$AuditPb$labelingNoRecordDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$LabelingNoRecord);
	});
var $author$project$AuditPb$LabelingReferences = function (references) {
	return {references: references};
};
var $author$project$AuditPb$LabelingReference = F3(
	function (key, value, owner) {
		return {key: key, owner: owner, value: value};
	});
var $author$project$AuditPb$LabelingReferenceOwnerLoad = {$: 'LabelingReferenceOwnerLoad'};
var $author$project$AuditPb$labelingReferenceOwnerDefault = $author$project$AuditPb$LabelingReferenceOwnerLoad;
var $author$project$AuditPb$LabelingReferenceOwnerCustomer = {$: 'LabelingReferenceOwnerCustomer'};
var $author$project$AuditPb$LabelingReferenceOwnerShipment = {$: 'LabelingReferenceOwnerShipment'};
var $author$project$AuditPb$allLabelingReferenceOwner = _List_fromArray(
	[$author$project$AuditPb$LabelingReferenceOwnerLoad, $author$project$AuditPb$LabelingReferenceOwnerShipment, $author$project$AuditPb$LabelingReferenceOwnerCustomer]);
var $author$project$AuditPb$labelingReferenceOwnerToString = function (v) {
	switch (v.$) {
		case 'LabelingReferenceOwnerLoad':
			return 'load';
		case 'LabelingReferenceOwnerShipment':
			return 'shipment';
		default:
			return 'customer';
	}
};
var $author$project$AuditPb$labelingReferenceOwnerDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$labelingReferenceOwnerToString(v),
				v);
		},
		$author$project$AuditPb$allLabelingReferenceOwner));
var $author$project$AuditPb$labelingReferenceOwnerFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$labelingReferenceOwnerDict);
};
var $author$project$AuditPb$labelingReferenceOwnerDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$labelingReferenceOwnerDefault),
		$author$project$AuditPb$labelingReferenceOwnerFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$labelingReferenceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'owner',
			$author$project$AuditPb$labelingReferenceOwnerDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'value',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'key',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$LabelingReference))));
	});
var $author$project$AuditPb$labelingReferencesDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'references',
			$author$project$AuditPb$labelingReferenceDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$LabelingReferences));
	});
var $author$project$AuditPb$labelingRecord_RecordDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$LabelingRecord_Record_LabelingNoRecord,
					A2($elm$json$Json$Decode$field, 'none', $author$project$AuditPb$labelingNoRecordDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$LabelingRecord_Record_LabelingReferences,
					A2($elm$json$Json$Decode$field, 'references', $author$project$AuditPb$labelingReferencesDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$LabelingRecord_Record_LabelingCarrier,
					A2($elm$json$Json$Decode$field, 'carrier', $author$project$AuditPb$labelingCarrierDecoder)),
					$elm$json$Json$Decode$fail('LabelingRecord_Record_Unspecified')
				]));
	});
var $author$project$AuditPb$labelingRecordDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$labelingRecord_RecordDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$LabelingRecord));
	});
var $author$project$AuditPb$LabelingRuleKindUnrecorded = {$: 'LabelingRuleKindUnrecorded'};
var $author$project$AuditPb$labelingRuleKindDefault = $author$project$AuditPb$LabelingRuleKindUnrecorded;
var $author$project$AuditPb$LabelingRuleKindAdHoc = {$: 'LabelingRuleKindAdHoc'};
var $author$project$AuditPb$LabelingRuleKindAuditBilling = {$: 'LabelingRuleKindAuditBilling'};
var $author$project$AuditPb$LabelingRuleKindCarrier = {$: 'LabelingRuleKindCarrier'};
var $author$project$AuditPb$LabelingRuleKindCustomerReference = {$: 'LabelingRuleKindCustomerReference'};
var $author$project$AuditPb$LabelingRuleKindDocumentTemplate = {$: 'LabelingRuleKindDocumentTemplate'};
var $author$project$AuditPb$LabelingRuleKindEmail = {$: 'LabelingRuleKindEmail'};
var $author$project$AuditPb$LabelingRuleKindInvoiceException = {$: 'LabelingRuleKindInvoiceException'};
var $author$project$AuditPb$LabelingRuleKindLargeBatch = {$: 'LabelingRuleKindLargeBatch'};
var $author$project$AuditPb$LabelingRuleKindLoadBusinessUnit = {$: 'LabelingRuleKindLoadBusinessUnit'};
var $author$project$AuditPb$LabelingRuleKindLoadCustomerList = {$: 'LabelingRuleKindLoadCustomerList'};
var $author$project$AuditPb$LabelingRuleKindLoadDaysToPay = {$: 'LabelingRuleKindLoadDaysToPay'};
var $author$project$AuditPb$LabelingRuleKindLoadIdPrefix = {$: 'LabelingRuleKindLoadIdPrefix'};
var $author$project$AuditPb$LabelingRuleKindLoadMode = {$: 'LabelingRuleKindLoadMode'};
var $author$project$AuditPb$LabelingRuleKindLoadMultiDrop = {$: 'LabelingRuleKindLoadMultiDrop'};
var $author$project$AuditPb$LabelingRuleKindLoadMultiLeg = {$: 'LabelingRuleKindLoadMultiLeg'};
var $author$project$AuditPb$LabelingRuleKindLoadOffice = {$: 'LabelingRuleKindLoadOffice'};
var $author$project$AuditPb$LabelingRuleKindLoadPeople = {$: 'LabelingRuleKindLoadPeople'};
var $author$project$AuditPb$LabelingRuleKindLoadPriority = {$: 'LabelingRuleKindLoadPriority'};
var $author$project$AuditPb$LabelingRuleKindLoadQuickpay = {$: 'LabelingRuleKindLoadQuickpay'};
var $author$project$AuditPb$LabelingRuleKindLoadReference = {$: 'LabelingRuleKindLoadReference'};
var $author$project$AuditPb$LabelingRuleKindLtlPayables = {$: 'LabelingRuleKindLtlPayables'};
var $author$project$AuditPb$LabelingRuleKindManual = {$: 'LabelingRuleKindManual'};
var $author$project$AuditPb$LabelingRuleKindNoDocuments = {$: 'LabelingRuleKindNoDocuments'};
var $author$project$AuditPb$LabelingRuleKindReferenceCategory = {$: 'LabelingRuleKindReferenceCategory'};
var $author$project$AuditPb$LabelingRuleKindReplyParent = {$: 'LabelingRuleKindReplyParent'};
var $author$project$AuditPb$LabelingRuleKindShipmentReference = {$: 'LabelingRuleKindShipmentReference'};
var $author$project$AuditPb$LabelingRuleKindSubmission = {$: 'LabelingRuleKindSubmission'};
var $author$project$AuditPb$LabelingRuleKindTonu = {$: 'LabelingRuleKindTonu'};
var $author$project$AuditPb$allLabelingRuleKind = _List_fromArray(
	[$author$project$AuditPb$LabelingRuleKindUnrecorded, $author$project$AuditPb$LabelingRuleKindLoadReference, $author$project$AuditPb$LabelingRuleKindShipmentReference, $author$project$AuditPb$LabelingRuleKindCustomerReference, $author$project$AuditPb$LabelingRuleKindReferenceCategory, $author$project$AuditPb$LabelingRuleKindLoadCustomerList, $author$project$AuditPb$LabelingRuleKindLoadPeople, $author$project$AuditPb$LabelingRuleKindLoadOffice, $author$project$AuditPb$LabelingRuleKindLoadBusinessUnit, $author$project$AuditPb$LabelingRuleKindLoadPriority, $author$project$AuditPb$LabelingRuleKindLoadMode, $author$project$AuditPb$LabelingRuleKindLoadDaysToPay, $author$project$AuditPb$LabelingRuleKindLoadQuickpay, $author$project$AuditPb$LabelingRuleKindLoadMultiDrop, $author$project$AuditPb$LabelingRuleKindLoadMultiLeg, $author$project$AuditPb$LabelingRuleKindLoadIdPrefix, $author$project$AuditPb$LabelingRuleKindAuditBilling, $author$project$AuditPb$LabelingRuleKindTonu, $author$project$AuditPb$LabelingRuleKindLtlPayables, $author$project$AuditPb$LabelingRuleKindInvoiceException, $author$project$AuditPb$LabelingRuleKindEmail, $author$project$AuditPb$LabelingRuleKindReplyParent, $author$project$AuditPb$LabelingRuleKindDocumentTemplate, $author$project$AuditPb$LabelingRuleKindLargeBatch, $author$project$AuditPb$LabelingRuleKindNoDocuments, $author$project$AuditPb$LabelingRuleKindSubmission, $author$project$AuditPb$LabelingRuleKindManual, $author$project$AuditPb$LabelingRuleKindCarrier, $author$project$AuditPb$LabelingRuleKindAdHoc]);
var $author$project$AuditPb$labelingRuleKindToString = function (v) {
	switch (v.$) {
		case 'LabelingRuleKindUnrecorded':
			return 'unrecorded';
		case 'LabelingRuleKindLoadReference':
			return 'load_reference';
		case 'LabelingRuleKindShipmentReference':
			return 'shipment_reference';
		case 'LabelingRuleKindCustomerReference':
			return 'customer_reference';
		case 'LabelingRuleKindReferenceCategory':
			return 'reference_category';
		case 'LabelingRuleKindLoadCustomerList':
			return 'load_customer_list';
		case 'LabelingRuleKindLoadPeople':
			return 'load_people';
		case 'LabelingRuleKindLoadOffice':
			return 'load_office';
		case 'LabelingRuleKindLoadBusinessUnit':
			return 'load_business_unit';
		case 'LabelingRuleKindLoadPriority':
			return 'load_priority';
		case 'LabelingRuleKindLoadMode':
			return 'load_mode';
		case 'LabelingRuleKindLoadDaysToPay':
			return 'load_days_to_pay';
		case 'LabelingRuleKindLoadQuickpay':
			return 'load_quickpay';
		case 'LabelingRuleKindLoadMultiDrop':
			return 'load_multi_drop';
		case 'LabelingRuleKindLoadMultiLeg':
			return 'load_multi_leg';
		case 'LabelingRuleKindLoadIdPrefix':
			return 'load_id_prefix';
		case 'LabelingRuleKindAuditBilling':
			return 'audit_billing';
		case 'LabelingRuleKindTonu':
			return 'tonu';
		case 'LabelingRuleKindLtlPayables':
			return 'ltl_payables';
		case 'LabelingRuleKindInvoiceException':
			return 'invoice_exception';
		case 'LabelingRuleKindEmail':
			return 'email';
		case 'LabelingRuleKindReplyParent':
			return 'reply_parent';
		case 'LabelingRuleKindDocumentTemplate':
			return 'document_template';
		case 'LabelingRuleKindLargeBatch':
			return 'large_batch';
		case 'LabelingRuleKindNoDocuments':
			return 'no_documents';
		case 'LabelingRuleKindSubmission':
			return 'submission';
		case 'LabelingRuleKindManual':
			return 'manual';
		case 'LabelingRuleKindCarrier':
			return 'carrier';
		default:
			return 'ad_hoc';
	}
};
var $author$project$AuditPb$labelingRuleKindDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$labelingRuleKindToString(v),
				v);
		},
		$author$project$AuditPb$allLabelingRuleKind));
var $author$project$AuditPb$labelingRuleKindFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$labelingRuleKindDict);
};
var $author$project$AuditPb$labelingRuleKindDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$labelingRuleKindDefault),
		$author$project$AuditPb$labelingRuleKindFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$labelingRuleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'record',
			$author$project$AuditPb$labelingRecordDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'category',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'kind',
					$author$project$AuditPb$labelingRuleKindDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'label',
						$elm$json$Json$Decode$string,
						$author$project$AuditPb$decode($author$project$AuditPb$LabelingRule)))));
	});
var $author$project$AuditPb$labelRuleFailureCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'labelingRules',
			$author$project$AuditPb$labelingRuleDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'title',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$LabelRuleFailureCheck)));
	});
var $author$project$AuditPb$LoadMatchCheck = {};
var $author$project$AuditPb$loadMatchCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$LoadMatchCheck);
	});
var $author$project$AuditPb$OsdCheck = {};
var $author$project$AuditPb$osdCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$OsdCheck);
	});
var $author$project$AuditPb$OtherCheck = {};
var $author$project$AuditPb$otherCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$OtherCheck);
	});
var $author$project$AuditPb$ReferenceRequirementsCheck = F5(
	function (message, reference, loadValue, requirements, source) {
		return {loadValue: loadValue, message: message, reference: reference, requirements: requirements, source: source};
	});
var $author$project$AuditPb$ReferenceRequirementsCheck_Source_AccountSource = function (a) {
	return {$: 'ReferenceRequirementsCheck_Source_AccountSource', a: a};
};
var $author$project$AuditPb$ReferenceRequirementsCheck_Source_CustomerSource = function (a) {
	return {$: 'ReferenceRequirementsCheck_Source_CustomerSource', a: a};
};
var $author$project$AuditPb$ReferenceRequirementsCheck_AccountSource = {};
var $author$project$AuditPb$referenceRequirementsCheck_AccountSourceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$ReferenceRequirementsCheck_AccountSource);
	});
var $author$project$AuditPb$ReferenceRequirementsCheck_CustomerSource = function (name) {
	return {name: name};
};
var $author$project$AuditPb$referenceRequirementsCheck_CustomerSourceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'name',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$ReferenceRequirementsCheck_CustomerSource));
	});
var $author$project$AuditPb$referenceRequirementsCheck_SourceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ReferenceRequirementsCheck_Source_AccountSource,
					A2($elm$json$Json$Decode$field, 'accountSource', $author$project$AuditPb$referenceRequirementsCheck_AccountSourceDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ReferenceRequirementsCheck_Source_CustomerSource,
					A2($elm$json$Json$Decode$field, 'customerSource', $author$project$AuditPb$referenceRequirementsCheck_CustomerSourceDecoder)),
					$elm$json$Json$Decode$fail('ReferenceRequirementsCheck_Source_Unspecified')
				]));
	});
var $author$project$AuditPb$referenceRequirementsCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$referenceRequirementsCheck_SourceDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'requirements',
				$author$project$AuditPb$referenceRuleDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'loadValue',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'reference',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'message',
							$elm$json$Json$Decode$string,
							$author$project$AuditPb$decode($author$project$AuditPb$ReferenceRequirementsCheck))))));
	});
var $author$project$AuditPb$carrierInvoiceAuditCheckType_CheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_OtherCheck,
					A2($elm$json$Json$Decode$field, 'other', $author$project$AuditPb$otherCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_DocumentsRequiredCheck,
					A2($elm$json$Json$Decode$field, 'documentsRequired', $author$project$AuditPb$documentsRequiredCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_LoadMatchCheck,
					A2($elm$json$Json$Decode$field, 'loadMatch', $author$project$AuditPb$loadMatchCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceAmountCheck,
					A2($elm$json$Json$Decode$field, 'invoiceAmount', $author$project$AuditPb$carrierInvoiceInvoiceAmountCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierMatchCheck,
					A2($elm$json$Json$Decode$field, 'carrierMatch', $author$project$AuditPb$carrierMatchCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierInvoiceDuplicateInvoiceCheck,
					A2($elm$json$Json$Decode$field, 'duplicateInvoice', $author$project$AuditPb$carrierInvoiceDuplicateInvoiceCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceDateCheck,
					A2($elm$json$Json$Decode$field, 'invoiceDate', $author$project$AuditPb$carrierInvoiceInvoiceDateCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_DocumentReviewCheck,
					A2($elm$json$Json$Decode$field, 'documentReview', $author$project$AuditPb$documentReviewCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck,
					A2($elm$json$Json$Decode$field, 'extractedFields', $author$project$AuditPb$extractedFieldsCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_OsdCheck,
					A2($elm$json$Json$Decode$field, 'osd', $author$project$AuditPb$osdCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CustomExceptionMessageCheck,
					A2($elm$json$Json$Decode$field, 'customExceptionMessage', $author$project$AuditPb$customExceptionMessageCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck,
					A2($elm$json$Json$Decode$field, 'referenceRequirements', $author$project$AuditPb$referenceRequirementsCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck,
					A2($elm$json$Json$Decode$field, 'labelRuleFailure', $author$project$AuditPb$labelRuleFailureCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CarrierRateCheck,
					A2($elm$json$Json$Decode$field, 'carrierRate', $author$project$AuditPb$carrierRateCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheckType_Check_CustomerInstructionsCheck,
					A2($elm$json$Json$Decode$field, 'customerInstructions', $author$project$AuditPb$customerInstructionsCheckDecoder)),
					$elm$json$Json$Decode$fail('CarrierInvoiceAuditCheckType_Check_Unspecified')
				]));
	});
var $author$project$AuditPb$carrierInvoiceAuditCheckTypeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$carrierInvoiceAuditCheckType_CheckDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceAuditCheckType));
	});
var $author$project$AuditPb$carrierInvoiceAuditRuleCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'ignoredFailures',
			$author$project$AuditPb$carrierInvoiceAuditCheckFailureDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'failures',
				$author$project$AuditPb$carrierInvoiceAuditCheckFailureDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'checkType',
					$author$project$AuditPb$carrierInvoiceAuditCheckTypeDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceAuditRuleCheck))));
	});
var $author$project$AuditPb$carrierInvoiceAuditCheck_DetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck,
					A2($elm$json$Json$Decode$field, 'ruleCheck', $author$project$AuditPb$carrierInvoiceAuditRuleCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceAuditCheck_Details_ExceptionEvent,
					A2($elm$json$Json$Decode$field, 'exceptionEvent', $author$project$AuditPb$exceptionEventDecoder)),
					$elm$json$Json$Decode$fail('CarrierInvoiceAuditCheck_Details_Unspecified')
				]));
	});
var $author$project$AuditPb$carrierInvoiceAuditCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$carrierInvoiceAuditCheck_DetailsDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'result',
				$author$project$AuditPb$carrierInvoiceAuditCheckResultDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceAuditCheck)));
	});
var $author$project$Forward$AppSpecific$Cache$list_carrierInvoiceAuditCheck = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_carrierInvoiceAuditCheck;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_carrierInvoiceAuditCheck: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceAuditChecks = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_carrierInvoiceAuditCheck,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$carrierInvoiceAuditCheckDecoder),
		entrypoint: 'carrierInvoiceAuditChecks',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$tmsLoadInformation = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.tmsLoadInformation;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{tmsLoadInformation: e});
		}));
var $author$project$AuditPb$TMSLoadInformation = F3(
	function (shipments, unshippedStops, references) {
		return {references: references, shipments: shipments, unshippedStops: unshippedStops};
	});
var $author$project$AuditPb$TMSLoadInformation_Reference = F2(
	function (key, value) {
		return {key: key, value: value};
	});
var $author$project$AuditPb$tmsLoadInformation_ReferenceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'value',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'key',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadInformation_Reference)));
	});
var $author$project$AuditPb$TMSLoadInformation_Shipment = function (id) {
	return function (shipmentId) {
		return function (actualShippedAt) {
			return function (actualDeliveredAt) {
				return function (weight) {
					return function (po) {
						return function (pickupReference) {
							return function (shipRef) {
								return function (shipperName) {
									return function (customerName) {
										return function (references) {
											return function (notes) {
												return function (stops) {
													return {actualDeliveredAt: actualDeliveredAt, actualShippedAt: actualShippedAt, customerName: customerName, id: id, notes: notes, pickupReference: pickupReference, po: po, references: references, shipRef: shipRef, shipmentId: shipmentId, shipperName: shipperName, stops: stops, weight: weight};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$TMSLoadInformation_Stop = F7(
	function (id, kind, address, actualArrivedAt, actualDepartedAt, weight, references) {
		return {actualArrivedAt: actualArrivedAt, actualDepartedAt: actualDepartedAt, address: address, id: id, kind: kind, references: references, weight: weight};
	});
var $author$project$AuditPb$TMSLoadInformation_KindPickup = {$: 'TMSLoadInformation_KindPickup'};
var $author$project$AuditPb$tmsLoadInformation_KindDefault = $author$project$AuditPb$TMSLoadInformation_KindPickup;
var $author$project$AuditPb$TMSLoadInformation_KindDrop = {$: 'TMSLoadInformation_KindDrop'};
var $author$project$AuditPb$allTMSLoadInformation_Kind = _List_fromArray(
	[$author$project$AuditPb$TMSLoadInformation_KindPickup, $author$project$AuditPb$TMSLoadInformation_KindDrop]);
var $author$project$AuditPb$tmsLoadInformation_KindToString = function (v) {
	if (v.$ === 'TMSLoadInformation_KindPickup') {
		return 'PICKUP';
	} else {
		return 'DROP';
	}
};
var $author$project$AuditPb$tmsLoadInformation_KindDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$tmsLoadInformation_KindToString(v),
				v);
		},
		$author$project$AuditPb$allTMSLoadInformation_Kind));
var $author$project$AuditPb$tmsLoadInformation_KindFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$tmsLoadInformation_KindDict);
};
var $author$project$AuditPb$tmsLoadInformation_KindDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$tmsLoadInformation_KindDefault),
		$author$project$AuditPb$tmsLoadInformation_KindFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$tmsLoadInformation_StopDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'references',
			$author$project$AuditPb$tmsLoadInformation_ReferenceDecoder,
			A3(
				$author$project$AuditPb$optional,
				'weight',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$optional,
					'actual_departed_at',
					$author$project$AuditPb$timestampDecoder,
					A3(
						$author$project$AuditPb$optional,
						'actual_arrived_at',
						$author$project$AuditPb$timestampDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'address',
							$author$project$AuditPb$addressDecoder,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'kind',
								$author$project$AuditPb$tmsLoadInformation_KindDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$TmsStopId$fromInt, $author$project$AuditPb$intDecoder),
									$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadInformation_Stop))))))));
	});
var $author$project$AuditPb$tmsLoadInformation_ShipmentDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'stops',
			$author$project$AuditPb$tmsLoadInformation_StopDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'notes',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$repeated,
					'references',
					$author$project$AuditPb$tmsLoadInformation_ReferenceDecoder,
					A3(
						$author$project$AuditPb$optional,
						'customer_name',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'shipper_name',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'ship_ref',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$optional,
									'pickup_reference',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$optional,
										'po',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$optional,
											'weight',
											$author$project$AuditPb$intDecoder,
											A3(
												$author$project$AuditPb$optional,
												'actual_delivered_at',
												$author$project$AuditPb$timestampDecoder,
												A3(
													$author$project$AuditPb$optional,
													'actual_shipped_at',
													$author$project$AuditPb$timestampDecoder,
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'shipment_id',
														$elm$json$Json$Decode$string,
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'id',
															A2($elm$json$Json$Decode$map, $author$project$Domain$TmsShipmentId$fromInt, $author$project$AuditPb$intDecoder),
															$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadInformation_Shipment))))))))))))));
	});
var $author$project$AuditPb$tmsLoadInformationDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'references',
			$author$project$AuditPb$tmsLoadInformation_ReferenceDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'unshipped_stops',
				$author$project$AuditPb$tmsLoadInformation_StopDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'shipments',
					$author$project$AuditPb$tmsLoadInformation_ShipmentDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$TMSLoadInformation))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadInformation = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$tmsLoadInformation,
		decoder: $author$project$AuditPb$tmsLoadInformationDecoder,
		entrypoint: 'tmsLoadInformation',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$LoadStateId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadInformation = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadInformation,
		fieldName: 'tmsLoadInformation',
		getId: function ($) {
			return $.loadStateId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCarrier = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.load;
			},
			function ($) {
				return $.carrierId;
			})
	});
var $author$project$Components$CarrierInvoiceAuditPage$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$exposeLoadingState(
						A2(
							$author$project$Forward$Lookup$startFrom,
							model.carrierInvoiceId,
							A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadInformation, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice))),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$exposeLoadingState(
							A2(
								$author$project$Forward$Lookup$startFrom,
								model.carrierInvoiceId,
								A2(
									$author$project$Forward$Lookup$traverse,
									$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCarrier,
									A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadDetails, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice)))),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$exposeLoadingState(
								A2(
									$author$project$Forward$Lookup$startFrom,
									model.carrierInvoiceId,
									A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadDetails, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice))),
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$Lookup$exposeLoadingState(
									A2($author$project$Forward$Lookup$startFrom, model.carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice)),
								A2(
									$author$project$Forward$Lookup$apply,
									$author$project$Forward$Lookup$exposeLoadingState(
										$author$project$Components$DocumentsBrowser$loadData(model.documentsBrowser)),
									A2(
										$author$project$Forward$Lookup$apply,
										$author$project$Forward$Lookup$exposeLoadingState(
											A2($author$project$Forward$Lookup$startFrom, model.carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceAuditChecks)),
										$author$project$Forward$Lookup$succeed($author$project$Components$CarrierInvoiceAuditPage$Data))))))))));
};
var $author$project$Components$DashboardPage$Data = function (account) {
	return function (accountSettings) {
		return function (currentUser) {
			return function (dashboardSavedFilters) {
				return function (customerDropdown) {
					return function (carrierDropdown) {
						return function (debtorDropdown) {
							return function (dashboardRows) {
								return function (menuData) {
									return function (exceptionStats) {
										return {account: account, accountSettings: accountSettings, carrierDropdown: carrierDropdown, currentUser: currentUser, customerDropdown: customerDropdown, dashboardRows: dashboardRows, dashboardSavedFilters: dashboardSavedFilters, debtorDropdown: debtorDropdown, exceptionStats: exceptionStats, menuData: menuData};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$DashboardExceptionStat = F2(
	function (id, name) {
		return {id: id, name: name};
	});
var $author$project$AuditPb$dashboardExceptionStatDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$DashboardExceptionStat)));
	});
var $author$project$Forward$AppSpecific$Cache$exceptionsByHighestCount = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.exceptionsByHighestCount;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{exceptionsByHighestCount: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionsByHighestCount = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$exceptionsByHighestCount,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$dashboardExceptionStatDecoder),
		entrypoint: 'exceptionsByHighestCount',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Forward$AppSpecific$Cache$dashboardSavedFilter = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.dashboardSavedFilter;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{dashboardSavedFilter: e});
		}));
var $author$project$AuditPb$DashboardSavedFilter = F5(
	function (id, name, dashboardMode, filter, isDefault) {
		return {dashboardMode: dashboardMode, filter: filter, id: id, isDefault: isDefault, name: name};
	});
var $author$project$AuditPb$DashboardFiltersQuery = function (carrierId) {
	return function (factorBrokerId) {
		return function (customers) {
			return function (labelFilters) {
				return function (categories) {
					return function (startDate) {
						return function (endDate) {
							return function (startDateTime) {
								return function (endDateTime) {
									return function (rangeType) {
										return function (dashboardMode) {
											return function (sortBy) {
												return function (timezoneName) {
													return function (exceptions) {
														return function (reskinToggle) {
															return {carrierId: carrierId, categories: categories, customers: customers, dashboardMode: dashboardMode, endDate: endDate, endDateTime: endDateTime, exceptions: exceptions, factorBrokerId: factorBrokerId, labelFilters: labelFilters, rangeType: rangeType, reskinToggle: reskinToggle, sortBy: sortBy, startDate: startDate, startDateTime: startDateTime, timezoneName: timezoneName};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$dashboardModeDefault = $author$project$AuditPb$DashboardModeAll;
var $author$project$AuditPb$dashboardModeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$dashboardModeDefault),
		$author$project$AuditPb$dashboardModeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$DashboardSortBy = F2(
	function (name, order) {
		return {name: name, order: order};
	});
var $author$project$AuditPb$dashboardSortByOrderDefault = $author$project$AuditPb$DashboardSortByOrderAsc;
var $author$project$AuditPb$dashboardSortByOrderDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$dashboardSortByOrderDefault),
		$author$project$AuditPb$dashboardSortByOrderFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$dashboardSortByDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'order',
			$author$project$AuditPb$dashboardSortByOrderDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'name',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$DashboardSortBy)));
	});
var $author$project$AuditPb$queueDateDefault = $author$project$AuditPb$QueueDateUnsorted;
var $author$project$AuditPb$queueDateDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$queueDateDefault),
		$author$project$AuditPb$queueDateFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$dashboardFiltersQueryDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'reskin_toggle',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$repeated,
				'exceptions',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'timezone_name',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'sort_by',
						$author$project$AuditPb$dashboardSortByDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'dashboard_mode',
							$author$project$AuditPb$dashboardModeDecoder,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'range_type',
								$author$project$AuditPb$queueDateDecoder,
								A3(
									$author$project$AuditPb$optional,
									'end_date_time',
									$author$project$AuditPb$timestampDecoder,
									A3(
										$author$project$AuditPb$optional,
										'start_date_time',
										$author$project$AuditPb$timestampDecoder,
										A3(
											$author$project$AuditPb$optional,
											'end_date',
											$elm$json$Json$Decode$string,
											A3(
												$author$project$AuditPb$optional,
												'start_date',
												$elm$json$Json$Decode$string,
												A3(
													$author$project$AuditPb$repeated,
													'categories',
													$author$project$AuditPb$dashboardCategoryFilterDecoder,
													A3(
														$author$project$AuditPb$repeated,
														'label_filters',
														$author$project$AuditPb$dashboardLabelFilterDecoder,
														A3(
															$author$project$AuditPb$repeated,
															'customers',
															$author$project$AuditPb$customerDecoder,
															A3(
																$author$project$AuditPb$repeated,
																'factor_broker_id',
																A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $author$project$AuditPb$intDecoder),
																A3(
																	$author$project$AuditPb$repeated,
																	'carrier_id',
																	A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
																	$author$project$AuditPb$decode($author$project$AuditPb$DashboardFiltersQuery))))))))))))))));
	});
var $author$project$Domain$DashboardSavedFilterId$DashboardSavedFilterId = function (a) {
	return {$: 'DashboardSavedFilterId', a: a};
};
var $author$project$Domain$DashboardSavedFilterId$fromInt = function (_int) {
	return $author$project$Domain$DashboardSavedFilterId$DashboardSavedFilterId(_int);
};
var $author$project$AuditPb$dashboardSavedFilterDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'is_default',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'filter',
				$author$project$AuditPb$dashboardFiltersQueryDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'dashboard_mode',
					$author$project$AuditPb$dashboardModeDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$DashboardSavedFilterId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$DashboardSavedFilter))))));
	});
var $author$project$Domain$DashboardSavedFilterId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilter = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$dashboardSavedFilter,
		decoder: $author$project$AuditPb$dashboardSavedFilterDecoder,
		entrypoint: 'dashboardSavedFiltersV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DashboardSavedFilterId$toInt)
	});
var $author$project$AuditPb$dashboardSavedFilterQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$optionalEncoder, 'dashboard_mode', $author$project$AuditPb$dashboardModeEncoder, v.dashboardMode)
				])));
};
var $author$project$Domain$DashboardSavedFilterId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$DashboardSavedFilterId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$list_dashboardSavedFilterId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_dashboardSavedFilterId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_dashboardSavedFilterId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilters = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_dashboardSavedFilterId,
		decoder: $author$project$Domain$DashboardSavedFilterId$decode,
		entrypoint: 'dashboardSavedFilterIds',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilter,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$dashboardSavedFilterQueryEncoder)
	});
var $author$project$Components$DashboardPage$DashboardSavedFilterData = F3(
	function (dashboardSavedFilter, factorBrokers, tmsCarriers) {
		return {dashboardSavedFilter: dashboardSavedFilter, factorBrokers: factorBrokers, tmsCarriers: tmsCarriers};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilterToFactorBrokers = $author$project$Forward$Lookup$waitForAllList(
	$author$project$Forward$Lookup$defineListEdge(
		{
			entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker,
			fieldName: 'factorBrokers',
			getIds: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.filter;
				},
				function ($) {
					return $.factorBrokerId;
				})
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilterToTmsCarriers = $author$project$Forward$Lookup$waitForAllList(
	$author$project$Forward$Lookup$defineListEdge(
		{
			entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
			fieldName: 'tmsCarriers',
			getIds: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.filter;
				},
				function ($) {
					return $.carrierId;
				})
		}));
var $author$project$Components$DashboardPage$loadDashboardSavedFilterData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilterToTmsCarriers,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilterToFactorBrokers,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($author$project$Components$DashboardPage$DashboardSavedFilterData))));
var $author$project$Components$DashboardPage$loadDashboardSavedFilters = function (_v0) {
	return A2(
		$author$project$Forward$Lookup$startFrom,
		{dashboardMode: $elm$core$Maybe$Nothing},
		A2($author$project$Forward$Lookup$traverseList, $author$project$Components$DashboardPage$loadDashboardSavedFilterData, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilters));
};
var $author$project$Components$CarrierDropdown$loadData = function (_v0) {
	var dropdown = _v0.dropdown;
	return A2(
		$author$project$Components$PaginatedDropdown$loadData,
		function (_v1) {
			var term = _v1.term;
			var page = _v1.page;
			return A2(
				$author$project$Forward$Lookup$startFrom,
				{eligibleForAutoprocessing: false, labels: _List_Nil, page: page, scraperOnly: false, term: term, withLoginFailures: false},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarriersBySettingsQuery);
		},
		dropdown);
};
var $author$project$Components$CustomerDropdown$loadData = function (_v0) {
	var dropdown = _v0.dropdown;
	return A2(
		$author$project$Components$PaginatedDropdown$loadData,
		function (_v1) {
			var term = _v1.term;
			var page = _v1.page;
			return A2(
				$author$project$Forward$Lookup$startFrom,
				{page: page, term: term},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerNamesByQuery);
		},
		dropdown);
};
var $author$project$Components$Dashboard$DashboardRows$FactorNeedsIndexingData = function (a) {
	return {$: 'FactorNeedsIndexingData', a: a};
};
var $author$project$Components$Dashboard$DashboardRows$NewEmailData = function (a) {
	return {$: 'NewEmailData', a: a};
};
var $author$project$Components$Dashboard$DashboardRows$ProcessedBrokerData = function (a) {
	return {$: 'ProcessedBrokerData', a: a};
};
var $author$project$Components$Dashboard$DashboardRows$ProcessedFactorData = function (a) {
	return {$: 'ProcessedFactorData', a: a};
};
var $author$project$Components$Dashboard$DashboardRows$ReadyToAuditCarrierInvoiceData = function (a) {
	return {$: 'ReadyToAuditCarrierInvoiceData', a: a};
};
var $author$project$Components$Dashboard$DashboardRows$ReplyEmailData = function (a) {
	return {$: 'ReplyEmailData', a: a};
};
var $author$project$Components$Dashboard$DashboardRows$ReviewData = function (a) {
	return {$: 'ReviewData', a: a};
};
var $author$project$Components$Dashboard$Load$ExceptionedRows$Unsent = {$: 'Unsent'};
var $author$project$Components$Dashboard$DashboardRows$UnsentExceptionedData = function (a) {
	return {$: 'UnsentExceptionedData', a: a};
};
var $author$project$Components$Dashboard$DashboardRows$VerifyData = function (a) {
	return {$: 'VerifyData', a: a};
};
var $author$project$Components$Dashboard$Load$ExceptionedRows$Waiting = {$: 'Waiting'};
var $author$project$Forward$AppSpecific$Cache$carrierInvoiceDashboardRow = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.carrierInvoiceDashboardRow;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{carrierInvoiceDashboardRow: e});
		}));
var $author$project$AuditPb$CarrierInvoiceDashboardRow = function (id) {
	return function (loadStateId) {
		return function (labels) {
			return function (requiresReconciliation) {
				return function (loadId) {
					return function (loadLabel) {
						return function (deliveredAt) {
							return function (tmsCarrierId) {
								return function (tmsCarrierName) {
									return function (loadCustomer) {
										return function (shipmentCustomers) {
											return {deliveredAt: deliveredAt, id: id, labels: labels, loadCustomer: loadCustomer, loadId: loadId, loadLabel: loadLabel, loadStateId: loadStateId, requiresReconciliation: requiresReconciliation, shipmentCustomers: shipmentCustomers, tmsCarrierId: tmsCarrierId, tmsCarrierName: tmsCarrierName};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$CarrierInvoiceDashboardRow_DashboardLoadLabels = F2(
	function (label, identifier) {
		return {identifier: identifier, label: label};
	});
var $author$project$AuditPb$carrierInvoiceDashboardRow_DashboardLoadLabelsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'identifier',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'label',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceDashboardRow_DashboardLoadLabels)));
	});
var $author$project$AuditPb$DashboardCustomer = F3(
	function (id, name, externalId) {
		return {externalId: externalId, id: id, name: name};
	});
var $author$project$AuditPb$dashboardCustomerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'external_id',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$DashboardCustomer))));
	});
var $author$project$AuditPb$carrierInvoiceDashboardRowDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'shipment_customers',
			$author$project$AuditPb$dashboardCustomerDecoder,
			A3(
				$author$project$AuditPb$optionalMessage,
				'load_customer',
				$author$project$AuditPb$dashboardCustomerDecoder,
				A3(
					$author$project$AuditPb$optional,
					'tms_carrier_name',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'tms_carrier_id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
						A3(
							$author$project$AuditPb$optional,
							'delivered_at',
							$author$project$AuditPb$timestampDecoder,
							A3(
								$author$project$AuditPb$optionalMessage,
								'load_label',
								$author$project$AuditPb$carrierInvoiceDashboardRow_DashboardLoadLabelsDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'load_id',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'requires_reconciliation',
										$elm$json$Json$Decode$bool,
										A3(
											$author$project$AuditPb$repeated,
											'labels',
											$elm$json$Json$Decode$string,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'load_state_id',
												A2($elm$json$Json$Decode$map, $author$project$Domain$LoadStateId$fromInt, $author$project$AuditPb$intDecoder),
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'id',
													A2($elm$json$Json$Decode$map, $author$project$Domain$CarrierInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
													$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceDashboardRow))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceDashboardRow = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$carrierInvoiceDashboardRow,
		decoder: $author$project$AuditPb$carrierInvoiceDashboardRowDecoder,
		entrypoint: 'carrierInvoiceDashboardRows',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$exceptionSummary = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.exceptionSummary;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{exceptionSummary: e});
		}));
var $author$project$AuditPb$ExceptionSummary = F2(
	function (paymentExceptions, billingExceptions) {
		return {billingExceptions: billingExceptions, paymentExceptions: paymentExceptions};
	});
var $author$project$AuditPb$exceptionSummaryDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'billing_exceptions',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'payment_exceptions',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$ExceptionSummary)));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByCarrierInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$exceptionSummary,
		decoder: $author$project$AuditPb$exceptionSummaryDecoder,
		entrypoint: 'exceptionSummaryByCarrierInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Components$Dashboard$RowHelper$DashboardTmsCarrier = F2(
	function (id, name) {
		return {id: id, name: name};
	});
var $author$project$Components$Dashboard$Load$CarrierInvoiceRows$makeCarrierInvoiceRow = F3(
	function (row, emailAndReplyMessages, exceptionSummary) {
		var redirectTo = A3($author$project$Path$carrierInvoiceWithLoad, row.loadStateId, row.id, row.requiresReconciliation);
		var maybeTmsCarrier = A3($elm$core$Maybe$map2, $author$project$Components$Dashboard$RowHelper$DashboardTmsCarrier, row.tmsCarrierId, row.tmsCarrierName);
		return {carrierInvoiceId: row.id, deliveredAt: row.deliveredAt, emailAndReplyMessages: emailAndReplyMessages, exceptionSummary: exceptionSummary, labels: row.labels, loadCustomer: row.loadCustomer, loadId: row.loadId, redirectTo: redirectTo, shipmentCustomers: row.shipmentCustomers, tmsCarrier: maybeTmsCarrier};
	});
var $author$project$Components$Dashboard$Load$CarrierInvoiceRows$loadCarrierInvoiceRow = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByCarrierInvoiceId,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByCarrierInvoiceId,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceDashboardRow,
			$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Load$CarrierInvoiceRows$makeCarrierInvoiceRow))));
var $author$project$AuditPb$dashboardCategoryFilterEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'category', $elm$json$Json$Encode$string, v.category),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'label', $elm$json$Json$Encode$string, v.label),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'excluded', $elm$json$Json$Encode$string, v.excluded)
				])));
};
var $author$project$AuditPb$labelFilterStateEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$labelFilterStateToString);
var $author$project$AuditPb$dashboardLabelFilterEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'label', $elm$json$Json$Encode$string, v.label),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'state', $author$project$AuditPb$labelFilterStateEncoder, v.state)
				])));
};
var $author$project$AuditPb$queueDateEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$queueDateToString);
var $jweir$elm_iso8601$ISO8601$Extras$After = {$: 'After'};
var $jweir$elm_iso8601$ISO8601$Extras$Before = {$: 'Before'};
var $jweir$elm_iso8601$ISO8601$Extras$daysToMonths = F3(
	function (year, startMonth, remainingDays) {
		daysToMonths:
		while (true) {
			var remainingDays_ = remainingDays - A2($jweir$elm_iso8601$ISO8601$Extras$daysInMonth, year, startMonth);
			if (remainingDays_ > 0) {
				var $temp$year = year,
					$temp$startMonth = startMonth + 1,
					$temp$remainingDays = remainingDays_;
				year = $temp$year;
				startMonth = $temp$startMonth;
				remainingDays = $temp$remainingDays;
				continue daysToMonths;
			} else {
				return _Utils_Tuple2(startMonth, remainingDays);
			}
		}
	});
var $jweir$elm_iso8601$ISO8601$Extras$daysToYears = F3(
	function (rel, startYear, remainingDays) {
		daysToYears:
		while (true) {
			if (rel.$ === 'After') {
				var remainingDays_ = remainingDays - $jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear);
				if (remainingDays_ > 0) {
					var $temp$rel = $jweir$elm_iso8601$ISO8601$Extras$After,
						$temp$startYear = startYear + 1,
						$temp$remainingDays = remainingDays_;
					rel = $temp$rel;
					startYear = $temp$startYear;
					remainingDays = $temp$remainingDays;
					continue daysToYears;
				} else {
					if (!remainingDays_) {
						return _Utils_Tuple2(startYear + 1, 0);
					} else {
						return _Utils_Tuple2(startYear, remainingDays);
					}
				}
			} else {
				var remainingDays_ = remainingDays + $jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear);
				if (remainingDays_ < 0) {
					var $temp$rel = $jweir$elm_iso8601$ISO8601$Extras$Before,
						$temp$startYear = startYear - 1,
						$temp$remainingDays = remainingDays_;
					rel = $temp$rel;
					startYear = $temp$startYear;
					remainingDays = $temp$remainingDays;
					continue daysToYears;
				} else {
					return _Utils_Tuple2(
						startYear,
						$jweir$elm_iso8601$ISO8601$Extras$daysInYear(startYear) + remainingDays);
				}
			}
		}
	});
var $jweir$elm_iso8601$ISO8601$defaultTime = {day: 1, hour: 0, millisecond: 0, minute: 0, month: 1, offset: 0, second: 0, year: 0};
var $jweir$elm_iso8601$ISO8601$fromTime = function (msFloat) {
	var ms = msFloat;
	var v = (ms >= 0) ? $jweir$elm_iso8601$ISO8601$Extras$After : $jweir$elm_iso8601$ISO8601$Extras$Before;
	var milliseconds = A2($elm$core$Basics$modBy, $jweir$elm_iso8601$ISO8601$isec, ms);
	if (v.$ === 'After') {
		var seconds = A2(
			$elm$core$Basics$modBy,
			60,
			$elm$core$Basics$floor(ms / $jweir$elm_iso8601$ISO8601$isec));
		var minutes = A2($elm$core$Basics$modBy, 60, (ms / $jweir$elm_iso8601$ISO8601$imin) | 0);
		var hours = A2($elm$core$Basics$modBy, 24, (ms / $jweir$elm_iso8601$ISO8601$ihour) | 0);
		var days = (ms / $jweir$elm_iso8601$ISO8601$iday) | 0;
		var _v1 = A3($jweir$elm_iso8601$ISO8601$Extras$daysToYears, $jweir$elm_iso8601$ISO8601$Extras$After, 1970, days);
		var years = _v1.a;
		var remainingDays = _v1.b;
		var _v2 = A3($jweir$elm_iso8601$ISO8601$Extras$daysToMonths, years, 1, remainingDays + 1);
		var months = _v2.a;
		var daysInMonth = _v2.b;
		return _Utils_update(
			$jweir$elm_iso8601$ISO8601$defaultTime,
			{day: daysInMonth, hour: hours, millisecond: milliseconds, minute: minutes, month: months, second: seconds, year: years});
	} else {
		var totalDays = (ms / $jweir$elm_iso8601$ISO8601$iday) | 0;
		var rem = A2($elm$core$Basics$modBy, $jweir$elm_iso8601$ISO8601$iday, ms);
		var seconds = A2($elm$core$Basics$modBy, 60, (rem / $jweir$elm_iso8601$ISO8601$isec) | 0);
		var minutes = A2($elm$core$Basics$modBy, 60, (rem / $jweir$elm_iso8601$ISO8601$imin) | 0);
		var hours = A2($elm$core$Basics$modBy, 24, (rem / $jweir$elm_iso8601$ISO8601$ihour) | 0);
		var days = (rem / $jweir$elm_iso8601$ISO8601$iday) | 0;
		var _v3 = (!rem) ? A3($jweir$elm_iso8601$ISO8601$Extras$daysToYears, $jweir$elm_iso8601$ISO8601$Extras$Before, 1969, totalDays + 1) : A3($jweir$elm_iso8601$ISO8601$Extras$daysToYears, $jweir$elm_iso8601$ISO8601$Extras$Before, 1969, totalDays);
		var years = _v3.a;
		var remainingDays = _v3.b;
		var _v4 = A3($jweir$elm_iso8601$ISO8601$Extras$daysToMonths, years, 1, remainingDays);
		var months = _v4.a;
		var daysInMonth = _v4.b;
		return _Utils_update(
			$jweir$elm_iso8601$ISO8601$defaultTime,
			{day: daysInMonth, hour: hours, millisecond: milliseconds, minute: minutes, month: months, second: seconds, year: years});
	}
};
var $jweir$elm_iso8601$ISO8601$fromPosix = function (posix) {
	return $jweir$elm_iso8601$ISO8601$fromTime(
		$elm$time$Time$posixToMillis(posix));
};
var $jweir$elm_iso8601$ISO8601$fmt = function (n) {
	return (n < 10) ? ('0' + $elm$core$String$fromInt(n)) : $elm$core$String$fromInt(n);
};
var $jweir$elm_iso8601$ISO8601$fmtMs = function (n) {
	return (!n) ? '' : ((n < 10) ? ('.00' + $elm$core$String$fromInt(n)) : ((n < 100) ? ('.0' + $elm$core$String$fromInt(n)) : ('.' + $elm$core$String$fromInt(n))));
};
var $jweir$elm_iso8601$ISO8601$fmtOffset = function (minutes) {
	if (!minutes) {
		return 'Z';
	} else {
		var symbol = (minutes >= 0) ? '+' : '-';
		var m = A2($elm$core$Basics$modBy, 60, minutes);
		var h = (minutes / 60) | 0;
		return _Utils_ap(
			symbol,
			_Utils_ap(
				$jweir$elm_iso8601$ISO8601$fmt(
					$elm$core$Basics$abs(h)),
				$jweir$elm_iso8601$ISO8601$fmt(m)));
	}
};
var $jweir$elm_iso8601$ISO8601$fmtYear = function (n) {
	var s = $elm$core$String$fromInt(n);
	return (n < 10) ? ('000' + s) : ((n < 100) ? ('00' + s) : ((n < 1000) ? ('0' + s) : s));
};
var $jweir$elm_iso8601$ISO8601$toString = function (time) {
	return A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				$jweir$elm_iso8601$ISO8601$fmtYear(time.year),
				'-',
				$jweir$elm_iso8601$ISO8601$fmt(time.month),
				'-',
				$jweir$elm_iso8601$ISO8601$fmt(time.day),
				'T',
				$jweir$elm_iso8601$ISO8601$fmt(time.hour),
				':',
				$jweir$elm_iso8601$ISO8601$fmt(time.minute),
				':',
				$jweir$elm_iso8601$ISO8601$fmt(time.second),
				$jweir$elm_iso8601$ISO8601$fmtMs(time.millisecond),
				$jweir$elm_iso8601$ISO8601$fmtOffset(time.offset)
			]));
};
var $author$project$AuditPb$timestampEncoder = function (v) {
	return $elm$json$Json$Encode$string(
		$jweir$elm_iso8601$ISO8601$toString(
			$jweir$elm_iso8601$ISO8601$fromPosix(v)));
};
var $author$project$AuditPb$dashboardFiltersQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$repeatedFieldEncoder,
					'carrier_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCarrierId$toInt),
					v.carrierId),
					A3(
					$author$project$AuditPb$repeatedFieldEncoder,
					'factor_broker_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorBrokerId$toInt),
					v.factorBrokerId),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'customers', $author$project$AuditPb$customerEncoder, v.customers),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'label_filters', $author$project$AuditPb$dashboardLabelFilterEncoder, v.labelFilters),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'categories', $author$project$AuditPb$dashboardCategoryFilterEncoder, v.categories),
					A3($author$project$AuditPb$optionalEncoder, 'start_date', $elm$json$Json$Encode$string, v.startDate),
					A3($author$project$AuditPb$optionalEncoder, 'end_date', $elm$json$Json$Encode$string, v.endDate),
					A3($author$project$AuditPb$optionalEncoder, 'start_date_time', $author$project$AuditPb$timestampEncoder, v.startDateTime),
					A3($author$project$AuditPb$optionalEncoder, 'end_date_time', $author$project$AuditPb$timestampEncoder, v.endDateTime),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'range_type', $author$project$AuditPb$queueDateEncoder, v.rangeType),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'dashboard_mode', $author$project$AuditPb$dashboardModeEncoder, v.dashboardMode),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'sort_by', $author$project$AuditPb$dashboardSortByEncoder, v.sortBy),
					A3($author$project$AuditPb$optionalEncoder, 'timezone_name', $elm$json$Json$Encode$string, v.timezoneName),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'exceptions', $elm$json$Json$Encode$string, v.exceptions),
					A3($author$project$AuditPb$optionalEncoder, 'reskin_toggle', $elm$json$Json$Encode$bool, v.reskinToggle)
				])));
};
var $author$project$Domain$CarrierInvoiceId$decode = $author$project$Id$decoder;
var $author$project$Forward$AppSpecific$Cache$list_carrierInvoiceId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_carrierInvoiceId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_carrierInvoiceId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$readyToAuditCarrierInvoiceIds = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_carrierInvoiceId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$CarrierInvoiceId$decode),
		entrypoint: 'readyToAuditCarrierInvoiceIdsV2',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$dashboardFiltersQueryEncoder)
	});
var $author$project$Components$Dashboard$Load$CarrierInvoiceRows$loadIds = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$readyToAuditCarrierInvoiceIds;
var $author$project$Components$Dashboard$Load$CarrierInvoiceRows$loadData = F2(
	function (page, perPage) {
		return A2(
			$author$project$Forward$Lookup$traversePage,
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$Dashboard$Load$CarrierInvoiceRows$loadCarrierInvoiceRow),
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, page, perPage),
				$author$project$Components$Dashboard$Load$CarrierInvoiceRows$loadIds));
	});
var $author$project$AuditPb$ImportStatus = F4(
	function (id, pages, step, pageInStep) {
		return {id: id, pageInStep: pageInStep, pages: pages, step: step};
	});
var $author$project$AuditPb$ImportStepUnknown = {$: 'ImportStepUnknown'};
var $author$project$AuditPb$importStepDefault = $author$project$AuditPb$ImportStepUnknown;
var $author$project$AuditPb$ImportStepExtractData = {$: 'ImportStepExtractData'};
var $author$project$AuditPb$ImportStepOcr = {$: 'ImportStepOcr'};
var $author$project$AuditPb$ImportStepSplitPages = {$: 'ImportStepSplitPages'};
var $author$project$AuditPb$allImportStep = _List_fromArray(
	[$author$project$AuditPb$ImportStepUnknown, $author$project$AuditPb$ImportStepSplitPages, $author$project$AuditPb$ImportStepOcr, $author$project$AuditPb$ImportStepExtractData]);
var $author$project$AuditPb$importStepToString = function (v) {
	switch (v.$) {
		case 'ImportStepUnknown':
			return 'unknown';
		case 'ImportStepSplitPages':
			return 'split_pages';
		case 'ImportStepOcr':
			return 'ocr';
		default:
			return 'extract_data';
	}
};
var $author$project$AuditPb$importStepDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$importStepToString(v),
				v);
		},
		$author$project$AuditPb$allImportStep));
var $author$project$AuditPb$importStepFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$importStepDict);
};
var $author$project$AuditPb$importStepDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$importStepDefault),
		$author$project$AuditPb$importStepFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$importStatusDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'page_in_step',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'step',
				$author$project$AuditPb$importStepDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'pages',
					$author$project$AuditPb$intDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						$author$project$AuditPb$intDecoder,
						$author$project$AuditPb$decode($author$project$AuditPb$ImportStatus)))));
	});
var $author$project$Forward$AppSpecific$Cache$maybe_importStatus = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_importStatus;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_importStatus: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentImportStatusByEmailMessageId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_importStatus,
		decoder: $elm$json$Json$Decode$maybe($author$project$AuditPb$importStatusDecoder),
		entrypoint: 'currentImportStatusByEmailMessageIdV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToCurrentImportStatus = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentImportStatusByEmailMessageId,
		fieldName: 'currentImportStatusByEmailMessageId',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Components$Dashboard$EmailRow$EmailRow = F8(
	function (emailMessage, maybeTmsCarrier, customers, maybeDocumentBatch, redirectTo, exceptionSummary, exceptionedItems, maybeImportStatus) {
		return {customers: customers, emailMessage: emailMessage, exceptionSummary: exceptionSummary, exceptionedItems: exceptionedItems, maybeDocumentBatch: maybeDocumentBatch, maybeImportStatus: maybeImportStatus, maybeTmsCarrier: maybeTmsCarrier, redirectTo: redirectTo};
	});
var $author$project$Components$Dashboard$DashboardRow$NoCustomers = {$: 'NoCustomers'};
var $author$project$Domain$ExceptionSummary$empty = {billingExceptions: _List_Nil, paymentExceptions: _List_Nil};
var $author$project$Path$carrierInvoiceFromReply = F4(
	function (loadStateId, carrierInvoiceId, replyId, requiresLtlReconciliation) {
		var replyIdString = $elm$core$String$fromInt(
			$author$project$Domain$EmailMessageId$toInt(replyId));
		var carrierInvoicePath = A3($author$project$Path$carrierInvoiceWithLoad, loadStateId, carrierInvoiceId, requiresLtlReconciliation);
		return A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2('activeDocumentTab', 'Messages'),
					_Utils_Tuple2('emailId', replyIdString)
				]),
			carrierInvoicePath);
	});
var $author$project$Path$factorInvoiceFromReply = F3(
	function (factorInvoiceId, replyId, pathContext) {
		var replyIdString = $elm$core$String$fromInt(
			$author$project$Domain$EmailMessageId$toInt(replyId));
		return A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2('activeDocumentTab', 'Messages'),
					_Utils_Tuple2('emailId', replyIdString)
				]),
			A2($author$project$Path$factorInvoice, factorInvoiceId, pathContext));
	});
var $author$project$Components$Dashboard$Url$PathToEmail$invoiceOwnerPath = F3(
	function (accountPathParams, emailPathParams, invoiceOwnerParams) {
		if (invoiceOwnerParams.$ === 'CarrierOwner') {
			var carrierParams = invoiceOwnerParams.a;
			return A4($author$project$Path$carrierInvoiceFromReply, carrierParams.loadStateId, carrierParams.carrierInvoiceId, emailPathParams.emailMessageId, carrierParams.requiresLtlReconciliation);
		} else {
			var factorInvoiceParams = invoiceOwnerParams.a;
			return A3(
				$author$project$Path$factorInvoiceFromReply,
				factorInvoiceParams.factorInvoiceId,
				emailPathParams.emailMessageId,
				{isReadonly: accountPathParams.readOnlyFactorInvoices, useFactorInvoiceWorkflowPage: accountPathParams.useFactorInvoiceWorkflowPage});
		}
	});
var $author$project$Components$Dashboard$Url$PathToEmail$isReply = function (maybeEmailType) {
	if ((maybeEmailType.$ === 'Just') && (maybeEmailType.a.$ === 'EmailMessageTypeReply')) {
		var _v1 = maybeEmailType.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Path$documentBatch = F2(
	function (id, pathContext) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$DocumentBatchId$toInt(id));
		return pathContext.isReadonly ? $author$project$Path$base(
			_List_fromArray(
				['app', 'readonly_document_batches', idString])) : (pathContext.useFactorInvoiceWorkflowPage ? $author$project$Path$base(
			_List_fromArray(
				['app', 'factor_invoices_workflow', 'batch', idString])) : $author$project$Path$base(
			_List_fromArray(
				['app', 'index-document-batches', idString])));
	});
var $author$project$Path$documentBatchWithEmail = F3(
	function (documentBatchId, emailId, pathContext) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$EmailMessageId$toInt(emailId));
		return A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2('emailId', idString)
				]),
			A2($author$project$Path$documentBatch, documentBatchId, pathContext));
	});
var $author$project$Components$Dashboard$Url$PathToEmail$pathToDocumentBatch = F4(
	function (documentBatchId, maybeEmailType, emailMessageId, pathContext) {
		var maybeReply = $author$project$Components$Dashboard$Url$PathToEmail$isReply(maybeEmailType) ? _List_fromArray(
			[
				_Utils_Tuple2('fromReply', 'true')
			]) : _List_Nil;
		return A2(
			$author$project$Path$addQueries,
			maybeReply,
			A3($author$project$Path$documentBatchWithEmail, documentBatchId, emailMessageId, pathContext));
	});
var $author$project$Path$replyMessage = function (id) {
	var idString = $elm$core$String$fromInt(
		$author$project$Domain$EmailMessageId$toInt(id));
	return $author$project$Path$base(
		_List_fromArray(
			['app', 'reply', idString]));
};
var $author$project$Components$Dashboard$Url$PathToEmail$pathToMaybeDocumentBatch = F2(
	function (_v0, _v1) {
		var useFactorInvoiceWorkflowPage = _v0.useFactorInvoiceWorkflowPage;
		var readOnly = _v1.readOnly;
		var emailMessageId = _v1.emailMessageId;
		var maybeEmailType = _v1.maybeEmailType;
		var maybeDocumentBatch = _v1.maybeDocumentBatch;
		var pathContext = {isReadonly: readOnly, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage};
		if (maybeDocumentBatch.$ === 'Just') {
			var documentBatch = maybeDocumentBatch.a;
			return A4($author$project$Components$Dashboard$Url$PathToEmail$pathToDocumentBatch, documentBatch.id, maybeEmailType, emailMessageId, pathContext);
		} else {
			return $author$project$Components$Dashboard$Url$PathToEmail$isReply(maybeEmailType) ? $author$project$Path$replyMessage(emailMessageId) : A2($author$project$Path$emailMessage, emailMessageId, pathContext.isReadonly);
		}
	});
var $author$project$Components$Dashboard$Url$PathToEmail$invoiceIndexPath = F2(
	function (accountPathParams, emailPathParams) {
		var _v0 = _Utils_Tuple2(emailPathParams.maybeInvoiceOwnerParams, emailPathParams.maybeDocumentBatch);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var invoiceOwnerParams = _v0.a.a;
			return A3($author$project$Components$Dashboard$Url$PathToEmail$invoiceOwnerPath, accountPathParams, emailPathParams, invoiceOwnerParams);
		} else {
			return A2($author$project$Components$Dashboard$Url$PathToEmail$pathToMaybeDocumentBatch, accountPathParams, emailPathParams);
		}
	});
var $author$project$Components$Dashboard$Url$PathToEmail$submissionOrInvoicePath = F2(
	function (accountPathParams, emailPathParams) {
		return (accountPathParams.useSubmissionWorkflow && (!accountPathParams.useBothWorkflows)) ? $author$project$Path$submission(emailPathParams.emailMessageId) : ((accountPathParams.useBothWorkflows && emailPathParams.hasSubmission) ? $author$project$Path$submission(emailPathParams.emailMessageId) : A2($author$project$Components$Dashboard$Url$PathToEmail$invoiceIndexPath, accountPathParams, emailPathParams));
	});
var $author$project$Components$Dashboard$Url$PathToEmail$pathToEmail = F3(
	function (accountType, accountPathParams, emailPathParams) {
		if (accountType.$ === 'BrokerAccount') {
			return A2($author$project$Components$Dashboard$Url$PathToEmail$invoiceIndexPath, accountPathParams, emailPathParams);
		} else {
			return A2($author$project$Components$Dashboard$Url$PathToEmail$submissionOrInvoicePath, accountPathParams, emailPathParams);
		}
	});
var $author$project$Components$Dashboard$Load$EmailRows$makeEmailRow = F3(
	function (account, accountSettings, user) {
		return F4(
			function (emailMessage, tmsCarrier, documentBatch, maybeImportStatus) {
				var url = A3(
					$author$project$Components$Dashboard$Url$PathToEmail$pathToEmail,
					$author$project$Domain$Account$accountType(account),
					{
						readOnlyFactorInvoices: user.readOnlyFactorInvoices,
						useBothWorkflows: accountSettings.useBothSubmissionAndTraditionalWorkflow,
						useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, accountSettings, user),
						useSubmissionWorkflow: accountSettings.useSubmissionWorkflow
					},
					{emailMessageId: emailMessage.id, hasSubmission: emailMessage.hasFactorClientInvoiceSubmission, maybeDocumentBatch: documentBatch, maybeEmailType: emailMessage.messageType, maybeInvoiceOwnerParams: $elm$core$Maybe$Nothing, readOnly: user.readOnlyFactorInvoices});
				return A8($author$project$Components$Dashboard$EmailRow$EmailRow, emailMessage, tmsCarrier, $author$project$Components$Dashboard$DashboardRow$NoCustomers, documentBatch, url, $author$project$Domain$ExceptionSummary$empty, _List_Nil, maybeImportStatus);
			});
	});
var $author$project$Components$Dashboard$Load$EmailRows$loadEmailRow = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToCurrentImportStatus,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$identity,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
							$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Load$EmailRows$makeEmailRow))))))));
var $author$project$Id$Dict$get = F2(
	function (id, _v0) {
		var dict = _v0.a;
		return A2(
			$elm$core$Dict$get,
			$author$project$Id$toInt(id),
			dict);
	});
var $author$project$DashboardPresence$emailIdInPresence = F2(
	function (presence, id) {
		var pathsAtId = A2($author$project$Id$Dict$get, id, presence.pathsByEmailMessageId);
		if (pathsAtId.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var $author$project$DashboardPresence$filterEmailMessageIds = F2(
	function (presence, ids) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				$author$project$DashboardPresence$emailIdInPresence(presence)),
			ids);
	});
var $author$project$DashboardPresence$shouldHideIfOthersPresent = F3(
	function (accountSettings, currentUser, flowModeRequested) {
		var fromHideOthers = accountSettings.featureFlags.allowHidingItemsInQueuesOnPresence && currentUser.hideItemsInQueuesOnPresence;
		var fromFlowMode = flowModeRequested;
		return fromFlowMode || fromHideOthers;
	});
var $author$project$Components$Dashboard$Load$EmailRows$loadIdsHelper = F2(
	function (baseQuery, filter) {
		return A4(
			$author$project$Forward$Lookup$ifElseVia,
			$author$project$Forward$Lookup$fromRoot(
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
						$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)))),
			function (_v0) {
				var accountSettings = _v0.a;
				var currentUser = _v0.b;
				return A3($author$project$DashboardPresence$shouldHideIfOthersPresent, accountSettings, currentUser, filter.flowModeRequested);
			},
			A2(
				$author$project$Forward$Lookup$map,
				$author$project$DashboardPresence$filterEmailMessageIds(filter.dashboardPresence),
				baseQuery),
			baseQuery);
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$newEmailIds = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_emailMessageId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$EmailMessageId$decode),
		entrypoint: 'newEmailIdsV2',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$dashboardFiltersQueryEncoder)
	});
var $author$project$Components$Dashboard$Load$EmailRows$loadIds = $author$project$Components$Dashboard$Load$EmailRows$loadIdsHelper($author$project$Forward$AppSpecific$NeedsControllerEndpoints$newEmailIds);
var $author$project$Components$Dashboard$Load$EmailRows$loadData = F3(
	function (filter, page, perPage) {
		return A2(
			$author$project$Forward$Lookup$traversePage,
			$author$project$Forward$Lookup$exposeLoadingState(
				A2($author$project$Forward$Lookup$traverse, $author$project$Components$Dashboard$Load$EmailRows$loadEmailRow, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage)),
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, page, perPage),
				$author$project$Components$Dashboard$Load$EmailRows$loadIds(filter)));
	});
var $author$project$Forward$AppSpecific$Cache$exceptionedItem = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.exceptionedItem;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{exceptionedItem: e});
		}));
var $author$project$AuditPb$ExceptionedItem = function (id) {
	return function (createdAt) {
		return function (documentGroupId) {
			return function (emailMessageId) {
				return function (labels) {
					return function (note) {
						return function (lastSentAt) {
							return function (nextReviewOn) {
								return function (tmsCarrierId) {
									return function (completedAt) {
										return function (firstReceivedAt) {
											return function (owner) {
												return {completedAt: completedAt, createdAt: createdAt, documentGroupId: documentGroupId, emailMessageId: emailMessageId, firstReceivedAt: firstReceivedAt, id: id, labels: labels, lastSentAt: lastSentAt, nextReviewOn: nextReviewOn, note: note, owner: owner, tmsCarrierId: tmsCarrierId};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$ExceptionedItem_Owner_CarrierInvoiceOwner = function (a) {
	return {$: 'ExceptionedItem_Owner_CarrierInvoiceOwner', a: a};
};
var $author$project$AuditPb$ExceptionedItem_Owner_DocumentGroupOwner = function (a) {
	return {$: 'ExceptionedItem_Owner_DocumentGroupOwner', a: a};
};
var $author$project$AuditPb$ExceptionedItem_Owner_EmailMessageOwner = function (a) {
	return {$: 'ExceptionedItem_Owner_EmailMessageOwner', a: a};
};
var $author$project$AuditPb$ExceptionedItem_Owner_FactorInvoiceOwner = function (a) {
	return {$: 'ExceptionedItem_Owner_FactorInvoiceOwner', a: a};
};
var $author$project$AuditPb$ExceptionedItem_CarrierInvoiceOwner = function (ownerId) {
	return {ownerId: ownerId};
};
var $author$project$AuditPb$exceptionedItem_CarrierInvoiceOwnerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'owner_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$CarrierInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$ExceptionedItem_CarrierInvoiceOwner));
	});
var $author$project$AuditPb$ExceptionedItem_DocumentGroupOwner = function (ownerId) {
	return {ownerId: ownerId};
};
var $author$project$AuditPb$exceptionedItem_DocumentGroupOwnerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'owner_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentGroupId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$ExceptionedItem_DocumentGroupOwner));
	});
var $author$project$AuditPb$ExceptionedItem_EmailMessageOwner = function (ownerId) {
	return {ownerId: ownerId};
};
var $author$project$AuditPb$exceptionedItem_EmailMessageOwnerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'owner_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$ExceptionedItem_EmailMessageOwner));
	});
var $author$project$AuditPb$ExceptionedItem_FactorInvoiceOwner = function (ownerId) {
	return {ownerId: ownerId};
};
var $author$project$AuditPb$exceptionedItem_FactorInvoiceOwnerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'owner_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$ExceptionedItem_FactorInvoiceOwner));
	});
var $author$project$AuditPb$exceptionedItem_OwnerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ExceptionedItem_Owner_CarrierInvoiceOwner,
					A2($elm$json$Json$Decode$field, 'carrier_invoice_owner', $author$project$AuditPb$exceptionedItem_CarrierInvoiceOwnerDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ExceptionedItem_Owner_FactorInvoiceOwner,
					A2($elm$json$Json$Decode$field, 'factor_invoice_owner', $author$project$AuditPb$exceptionedItem_FactorInvoiceOwnerDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ExceptionedItem_Owner_DocumentGroupOwner,
					A2($elm$json$Json$Decode$field, 'document_group_owner', $author$project$AuditPb$exceptionedItem_DocumentGroupOwnerDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$ExceptionedItem_Owner_EmailMessageOwner,
					A2($elm$json$Json$Decode$field, 'email_message_owner', $author$project$AuditPb$exceptionedItem_EmailMessageOwnerDecoder)),
					$elm$json$Json$Decode$fail('ExceptionedItem_Owner_Unspecified')
				]));
	});
var $author$project$Domain$ExceptionedItemId$ExceptionedItemId = function (a) {
	return {$: 'ExceptionedItemId', a: a};
};
var $author$project$Domain$ExceptionedItemId$fromInt = function (_int) {
	return $author$project$Domain$ExceptionedItemId$ExceptionedItemId(_int);
};
var $author$project$AuditPb$exceptionedItemDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$exceptionedItem_OwnerDecoder,
			A3(
				$author$project$AuditPb$optional,
				'first_received_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$optional,
					'completed_at',
					$author$project$AuditPb$timestampDecoder,
					A3(
						$author$project$AuditPb$optional,
						'tms_carrier_id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
						A3(
							$author$project$AuditPb$optional,
							'next_review_on',
							$author$project$AuditPb$timestampDecoder,
							A3(
								$author$project$AuditPb$optional,
								'last_sent_at',
								$author$project$AuditPb$timestampDecoder,
								A3(
									$author$project$AuditPb$optional,
									'note',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$repeated,
										'labels',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$optional,
											'email_message_id',
											A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
											A3(
												$author$project$AuditPb$optional,
												'document_group_id',
												A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentGroupId$fromInt, $author$project$AuditPb$intDecoder),
												A3(
													$author$project$AuditPb$optional,
													'created_at',
													$author$project$AuditPb$timestampDecoder,
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'id',
														A2($elm$json$Json$Decode$map, $author$project$Domain$ExceptionedItemId$fromInt, $author$project$AuditPb$intDecoder),
														$author$project$AuditPb$decode($author$project$AuditPb$ExceptionedItem)))))))))))));
	});
var $author$project$Domain$ExceptionedItemId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItem = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$exceptionedItem,
		decoder: $author$project$AuditPb$exceptionedItemDecoder,
		entrypoint: 'exceptionedItemV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$ExceptionedItemId$toInt)
	});
var $author$project$Components$Dashboard$ExceptionedRow$ExceptionedRow = function (a) {
	return {$: 'ExceptionedRow', a: a};
};
var $author$project$Components$Dashboard$ExceptionedRow$View$init = F2(
	function (exceptionedItem, maybeOwnerData) {
		return $author$project$Components$Dashboard$ExceptionedRow$ExceptionedRow(
			{exceptionedItem: exceptionedItem, ownerData: maybeOwnerData});
	});
var $author$project$Components$Dashboard$DashboardRow$Customers = function (a) {
	return {$: 'Customers', a: a};
};
var $author$project$Components$Dashboard$DashboardRow$customersToCustomerType = F2(
	function (shipmentCustomers, loadCustomer) {
		var customers = A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.id;
			},
			_Utils_ap(
				$elm_community$maybe_extra$Maybe$Extra$toList(loadCustomer),
				shipmentCustomers));
		return $elm$core$List$isEmpty(customers) ? $author$project$Components$Dashboard$DashboardRow$NoCustomers : $author$project$Components$Dashboard$DashboardRow$Customers(customers);
	});
var $author$project$Components$Dashboard$Load$Owners$CarrierInvoice$makeOwnerData = F2(
	function (row, exceptionSummary) {
		var subject = function () {
			var _v0 = row.loadLabel;
			if (_v0.$ === 'Nothing') {
				return 'Load: ' + row.loadId;
			} else {
				var label = _v0.a;
				return 'Load: ' + (row.loadId + (' - ' + (label.label + (': ' + label.identifier))));
			}
		}();
		var redirectTo = A3($author$project$Path$carrierInvoiceWithLoad, row.loadStateId, row.id, row.requiresReconciliation);
		var maybeTmsCarrier = A3(
			$elm$core$Maybe$map2,
			F2(
				function (carrierId, carrierName) {
					var base = $author$project$Domain$TmsCarrier$unknownCarrier;
					return _Utils_update(
						base,
						{id: carrierId, name: carrierName});
				}),
			row.tmsCarrierId,
			row.tmsCarrierName);
		var customers = A2($author$project$Components$Dashboard$DashboardRow$customersToCustomerType, row.shipmentCustomers, row.loadCustomer);
		return {
			customers: customers,
			deliveredAt: row.deliveredAt,
			exceptionSummary: exceptionSummary,
			labels: row.labels,
			loadDisplayId: A2(
				$elm$core$Maybe$map,
				function (label) {
					return {identifier: label.identifier, label: label.label};
				},
				row.loadLabel),
			loadId: $elm$core$Maybe$Just(row.loadId),
			redirectTo: redirectTo,
			subject: subject,
			tmsCarrierData: {
				singleCarrier: $elm$core$Maybe$Just(true),
				tmsCarrier: maybeTmsCarrier
			}
		};
	});
var $author$project$Components$Dashboard$Load$Owners$CarrierInvoice$carrierInvoiceExceptionedRow = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByCarrierInvoiceId,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceDashboardRow,
		$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Load$Owners$CarrierInvoice$makeOwnerData)));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToDocumentBatch = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2,
		fieldName: 'documentBatch',
		getId: function ($) {
			return $.documentBatchId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByDocumentGroupId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$exceptionSummary,
		decoder: $author$project$AuditPb$exceptionSummaryDecoder,
		entrypoint: 'exceptionSummaryByDocumentGroupId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentGroupId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToExceptionSummary = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByDocumentGroupId,
		fieldName: 'exceptionSummary',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Path$documentGroup = F3(
	function (documentBatchId, documentGroupId, pathContext) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$DocumentGroupId$toInt(documentGroupId));
		return A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2('group_id', idString)
				]),
			A2($author$project$Path$documentBatch, documentBatchId, pathContext));
	});
var $author$project$Components$Dashboard$Load$Owners$DocumentGroup$makeOwnerData = F7(
	function (account, user, accountSettings, documentGroup, maybeEmailMessage, maybeTmsCarrier, exceptionSummary) {
		var isReadonly = function () {
			var _v0 = $author$project$Domain$Account$accountType(account);
			if (_v0.$ === 'BrokerAccount') {
				return false;
			} else {
				return user.readOnlyFactorInvoices;
			}
		}();
		var pathContext = {
			isReadonly: isReadonly,
			useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, accountSettings, user)
		};
		var redirectToDocumentGroup = A3($author$project$Path$documentGroup, documentGroup.documentBatchId, documentGroup.id, pathContext);
		var toOwnerData = function (validEmailMessage) {
			return {
				customers: $author$project$Components$Dashboard$DashboardRow$NoCustomers,
				deliveredAt: $elm$core$Maybe$Nothing,
				exceptionSummary: exceptionSummary,
				labels: _Utils_ap(validEmailMessage.labels, documentGroup.additionalLabels),
				loadDisplayId: $elm$core$Maybe$Nothing,
				loadId: $elm$core$Maybe$Nothing,
				redirectTo: redirectToDocumentGroup,
				subject: validEmailMessage.subject,
				tmsCarrierData: {singleCarrier: validEmailMessage.singleCarrier, tmsCarrier: maybeTmsCarrier}
			};
		};
		return A2($elm$core$Maybe$map, toOwnerData, maybeEmailMessage);
	});
var $author$project$Components$Dashboard$Load$Owners$DocumentGroup$documentGroupExceptionedRow = A2(
	$author$project$Forward$Lookup$mapWithError,
	function (maybeOwnerData) {
		if (maybeOwnerData.$ === 'Just') {
			var ownerData = maybeOwnerData.a;
			return $elm$core$Result$Ok(ownerData);
		} else {
			return $elm$core$Result$Err('The exception is missing an owner');
		}
	},
	A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToExceptionSummary, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$map,
				$elm_community$maybe_extra$Maybe$Extra$join,
				A2(
					$author$project$Forward$Lookup$traverseMaybe,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier,
					A2(
						$author$project$Forward$Lookup$traverse,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage,
						A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToDocumentBatch, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup)))),
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage,
					A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToDocumentBatch, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
								$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Load$Owners$DocumentGroup$makeOwnerData)))))))));
var $author$project$Components$Dashboard$Load$Owners$EmailMessage$buildOwnerData = F4(
	function (emailMessage, tmsCarrier, exceptionSummary, currentUser) {
		var redirectTo = A2($author$project$Path$emailMessage, emailMessage.id, currentUser.readOnlyFactorInvoices);
		return {
			customers: $author$project$Components$Dashboard$DashboardRow$NoCustomers,
			deliveredAt: $elm$core$Maybe$Nothing,
			exceptionSummary: exceptionSummary,
			labels: emailMessage.labels,
			loadDisplayId: $elm$core$Maybe$Nothing,
			loadId: $elm$core$Maybe$Nothing,
			redirectTo: redirectTo,
			subject: emailMessage.subject,
			tmsCarrierData: {singleCarrier: emailMessage.singleCarrier, tmsCarrier: tmsCarrier}
		};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByEmailMessageId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$exceptionSummary,
		decoder: $author$project$AuditPb$exceptionSummaryDecoder,
		entrypoint: 'exceptionSummaryByEmailMessageId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToExceptionSummary = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByEmailMessageId,
		fieldName: 'exceptionSummary',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Components$Dashboard$Load$Owners$EmailMessage$emailMessageExceptionedRow = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
	A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToExceptionSummary, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage),
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
				$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Load$Owners$EmailMessage$buildOwnerData)))));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItemOwnerIdEdge = A2(
	$author$project$Forward$Lookup$defineUnionTypeEdge,
	_List_fromArray(
		[
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'CarrierInvoice',
			function ($) {
				return $.carrierInvoiceOwner;
			},
			function (id) {
				return $author$project$AuditPb$ExceptionedItem_Owner_CarrierInvoiceOwner(
					{ownerId: id});
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'FactorInvoice',
			function ($) {
				return $.factorInvoiceOwner;
			},
			function (id) {
				return $author$project$AuditPb$ExceptionedItem_Owner_FactorInvoiceOwner(
					{ownerId: id});
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'DocumentGroup',
			function ($) {
				return $.documentGroupOwner;
			},
			function (id) {
				return $author$project$AuditPb$ExceptionedItem_Owner_DocumentGroupOwner(
					{ownerId: id});
			}),
			A3(
			$author$project$Forward$Lookup$unionTypeVariant,
			'EmailMessage',
			function ($) {
				return $.emailMessageOwner;
			},
			function (id) {
				return $author$project$AuditPb$ExceptionedItem_Owner_EmailMessageOwner(
					{ownerId: id});
			})
		]),
	function (owner) {
		switch (owner.$) {
			case 'ExceptionedItem_Owner_CarrierInvoiceOwner':
				var carrierInvoiceOwner = owner.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					carrierInvoiceOwner.ownerId,
					function ($) {
						return $.carrierInvoiceOwner;
					});
			case 'ExceptionedItem_Owner_FactorInvoiceOwner':
				var factorInvoiceOwner = owner.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					factorInvoiceOwner.ownerId,
					function ($) {
						return $.factorInvoiceOwner;
					});
			case 'ExceptionedItem_Owner_DocumentGroupOwner':
				var documentGroupOwner = owner.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					documentGroupOwner.ownerId,
					function ($) {
						return $.documentGroupOwner;
					});
			default:
				var emailMessageOwner = owner.a;
				return A2(
					$author$project$Forward$Lookup$unionTypeDispatch,
					emailMessageOwner.ownerId,
					function ($) {
						return $.emailMessageOwner;
					});
		}
	});
var $author$project$Components$Dashboard$DashboardRow$Debtor = function (a) {
	return {$: 'Debtor', a: a};
};
var $author$project$Components$Dashboard$Load$Owners$FactorInvoice$factorInvoiceSubject = function (_v0) {
	var maybeDebtor = _v0.maybeDebtor;
	var maybeLoadId = _v0.maybeLoadId;
	var _v1 = _Utils_Tuple2(maybeLoadId, maybeDebtor);
	if (_v1.a.$ === 'Just') {
		if (_v1.b.$ === 'Nothing') {
			var loadId = _v1.a.a;
			var _v2 = _v1.b;
			return 'Load ' + loadId;
		} else {
			var loadId = _v1.a.a;
			var debtor = _v1.b.a;
			return 'Debtor: ' + (debtor + (' Load ' + loadId));
		}
	} else {
		if (_v1.b.$ === 'Nothing') {
			var _v3 = _v1.a;
			var _v4 = _v1.b;
			return 'unknown debtor/load';
		} else {
			var _v5 = _v1.a;
			var debtor = _v1.b.a;
			return 'Debtor: ' + debtor;
		}
	}
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$exceptionSummary,
		decoder: $author$project$AuditPb$exceptionSummaryDecoder,
		entrypoint: 'exceptionSummaryByFactorInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToExceptionSummary = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByFactorInvoiceId,
		fieldName: 'exceptionSummary',
		getId: function ($) {
			return $.id;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		var _v0 = A2($elm$core$Maybe$map, f, m);
		if ((_v0.$ === 'Just') && _v0.a) {
			return m;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Dashboard$Load$Owners$FactorInvoice$factorInvoiceExceptionedRow = A2(
	$author$project$Forward$Lookup$apply,
	A3(
		$author$project$Forward$Lookup$map2,
		$author$project$Domain$User$usesFactorInvoiceWorkflowPage,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser)),
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.readOnlyFactorInvoices;
			},
			$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser)),
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToExceptionSummary, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
				A2(
					$author$project$Forward$Lookup$apply,
					A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
						$author$project$Forward$Lookup$succeed(
							F6(
								function (factorInvoice, tmsCarrier, factorBroker, exceptionSummary, readOnlyFactorUser, useFactorInvoiceWorkflowPage) {
									var redirectTo = A2(
										$author$project$Path$factorInvoice,
										factorInvoice.id,
										{isReadonly: readOnlyFactorUser, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage});
									var loadId = factorInvoice.loadId;
									var clientOrDebtorOnBool = factorInvoice.clientOrDebtorOnBol;
									var debtor = A2(
										$elm_community$maybe_extra$Maybe$Extra$filter,
										$elm$core$Basics$always(!clientOrDebtorOnBool),
										factorBroker);
									var subject = $author$project$Components$Dashboard$Load$Owners$FactorInvoice$factorInvoiceSubject(
										{
											maybeDebtor: A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.name;
												},
												debtor),
											maybeLoadId: loadId
										});
									return {
										customers: A2(
											$elm$core$Maybe$withDefault,
											$author$project$Components$Dashboard$DashboardRow$NoCustomers,
											A2($elm$core$Maybe$map, $author$project$Components$Dashboard$DashboardRow$Debtor, debtor)),
										deliveredAt: $elm$core$Maybe$Nothing,
										exceptionSummary: exceptionSummary,
										labels: factorInvoice.labels,
										loadDisplayId: $elm$core$Maybe$Nothing,
										loadId: loadId,
										redirectTo: redirectTo,
										subject: subject,
										tmsCarrierData: {
											singleCarrier: $elm$core$Maybe$Just(true),
											tmsCarrier: tmsCarrier
										}
									};
								}))))))));
var $author$project$Components$Dashboard$Load$ExceptionedRows$loadOwnerData = A2(
	$author$project$Forward$Lookup$traverse,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItemOwnerIdEdge(
		{carrierInvoiceOwner: $author$project$Components$Dashboard$Load$Owners$CarrierInvoice$carrierInvoiceExceptionedRow, documentGroupOwner: $author$project$Components$Dashboard$Load$Owners$DocumentGroup$documentGroupExceptionedRow, emailMessageOwner: $author$project$Components$Dashboard$Load$Owners$EmailMessage$emailMessageExceptionedRow, factorInvoiceOwner: $author$project$Components$Dashboard$Load$Owners$FactorInvoice$factorInvoiceExceptionedRow}),
	A2(
		$author$project$Forward$Lookup$map,
		function ($) {
			return $.owner;
		},
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItem));
var $author$project$Components$Dashboard$Load$ExceptionedRows$loadExceptionedRow = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Components$Dashboard$Load$ExceptionedRows$loadOwnerData,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItem,
		$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$ExceptionedRow$View$init)));
var $author$project$Domain$ExceptionedItemId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$ExceptionedItemId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$list_exceptionedItemId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_exceptionedItemId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_exceptionedItemId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$unsentExceptionIds = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_exceptionedItemId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$ExceptionedItemId$decode),
		entrypoint: 'unsentExceptionIdsV2',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$dashboardFiltersQueryEncoder)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$waitingExceptionIds = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_exceptionedItemId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$ExceptionedItemId$decode),
		entrypoint: 'waitingExceptionIdsV2',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$dashboardFiltersQueryEncoder)
	});
var $author$project$Components$Dashboard$Load$ExceptionedRows$loadIds = function (exceptionType) {
	if (exceptionType.$ === 'Unsent') {
		return $author$project$Forward$AppSpecific$NeedsControllerEndpoints$unsentExceptionIds;
	} else {
		return $author$project$Forward$AppSpecific$NeedsControllerEndpoints$waitingExceptionIds;
	}
};
var $author$project$Components$Dashboard$Load$ExceptionedRows$loadData = F3(
	function (exceptionType, page, perPage) {
		return A2(
			$author$project$Forward$Lookup$traversePage,
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$Dashboard$Load$ExceptionedRows$loadExceptionedRow),
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, page, perPage),
				$author$project$Components$Dashboard$Load$ExceptionedRows$loadIds(exceptionType)));
	});
var $author$project$Components$Dashboard$Load$NeedsIndexingRows$loadIdsHelper = F2(
	function (baseQuery, filter) {
		return A4(
			$author$project$Forward$Lookup$ifElseVia,
			$author$project$Forward$Lookup$fromRoot(
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
						$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)))),
			function (_v0) {
				var accountSettings = _v0.a;
				var currentUser = _v0.b;
				return A3($author$project$DashboardPresence$shouldHideIfOthersPresent, accountSettings, currentUser, filter.flowModeRequested);
			},
			A2(
				$author$project$Forward$Lookup$map,
				$author$project$DashboardPresence$filterEmailMessageIds(filter.dashboardPresence),
				baseQuery),
			baseQuery);
	});
var $author$project$Components$Dashboard$Load$NeedsIndexingRows$loadIds = $author$project$Components$Dashboard$Load$NeedsIndexingRows$loadIdsHelper($author$project$Forward$AppSpecific$NeedsControllerEndpoints$newEmailIds);
var $author$project$Components$Dashboard$Load$NeedsIndexingRows$RowData = F7(
	function (emailMessage, submissionBatch, maybeTmsCarrier, maybeDocumentBatch, maybeImportStatus, currentUser, accountSettings) {
		return {accountSettings: accountSettings, currentUser: currentUser, emailMessage: emailMessage, maybeDocumentBatch: maybeDocumentBatch, maybeImportStatus: maybeImportStatus, maybeTmsCarrier: maybeTmsCarrier, submissionBatch: submissionBatch};
	});
var $author$project$AuditPb$FactorSubmissionBatch = F4(
	function (id, externalId, createdAt, updatedAt) {
		return {createdAt: createdAt, externalId: externalId, id: id, updatedAt: updatedAt};
	});
var $author$project$Domain$FactorSubmissionBatchId$FactorSubmissionBatchId = function (a) {
	return {$: 'FactorSubmissionBatchId', a: a};
};
var $author$project$Domain$FactorSubmissionBatchId$fromInt = function (_int) {
	return $author$project$Domain$FactorSubmissionBatchId$FactorSubmissionBatchId(_int);
};
var $author$project$AuditPb$factorSubmissionBatchDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'updated_at',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'created_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$optional,
					'external_id',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$FactorSubmissionBatchId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$FactorSubmissionBatch)))));
	});
var $author$project$Forward$AppSpecific$Cache$maybe_factorSubmissionBatch = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_factorSubmissionBatch;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_factorSubmissionBatch: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionBatchByEmailMessageId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_factorSubmissionBatch,
		decoder: $elm$json$Json$Decode$maybe($author$project$AuditPb$factorSubmissionBatchDecoder),
		entrypoint: 'submissionBatchByEmailMessageId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToSubmissionBatch = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionBatchByEmailMessageId,
		fieldName: 'submissionBatchByEmailMessageId',
		getId: function ($) {
			return $.id;
		}
	});
var $author$project$Components$Dashboard$Load$NeedsIndexingRows$loadRowData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToCurrentImportStatus,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToSubmissionBatch,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$identity,
							$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Load$NeedsIndexingRows$RowData))))))));
var $author$project$Components$Dashboard$Load$NeedsIndexingRows$needsIndexingRowFromRowData = function (_v0) {
	var accountSettings = _v0.accountSettings;
	var currentUser = _v0.currentUser;
	var maybeImportStatus = _v0.maybeImportStatus;
	var maybeDocumentBatch = _v0.maybeDocumentBatch;
	var maybeTmsCarrier = _v0.maybeTmsCarrier;
	var submissionBatch = _v0.submissionBatch;
	var emailMessage = _v0.emailMessage;
	var useFactorInvoiceWorkflowPage = A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, accountSettings, currentUser);
	var readOnly = currentUser.readOnlyFactorInvoices;
	var pathContext = {isReadonly: readOnly, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage};
	var url = function () {
		if (maybeDocumentBatch.$ === 'Just') {
			var batch = maybeDocumentBatch.a;
			return A4($author$project$Components$Dashboard$Url$PathToEmail$pathToDocumentBatch, batch.id, emailMessage.messageType, emailMessage.id, pathContext);
		} else {
			return A2($author$project$Path$emailMessage, emailMessage.id, pathContext.isReadonly);
		}
	}();
	return {emailMessage: emailMessage, maybeDocumentBatch: maybeDocumentBatch, maybeImportStatus: maybeImportStatus, maybeTmsCarrier: maybeTmsCarrier, redirectTo: url, submissionBatch: submissionBatch};
};
var $author$project$Components$Dashboard$Load$NeedsIndexingRows$loadNeedsIndexingRow = A2($author$project$Forward$Lookup$map, $author$project$Components$Dashboard$Load$NeedsIndexingRows$needsIndexingRowFromRowData, $author$project$Components$Dashboard$Load$NeedsIndexingRows$loadRowData);
var $author$project$Components$Dashboard$Load$NeedsIndexingRows$loadData = F3(
	function (filter, page, perPage) {
		return A2(
			$author$project$Forward$Lookup$traversePage,
			$author$project$Forward$Lookup$exposeLoadingState(
				A2($author$project$Forward$Lookup$traverse, $author$project$Components$Dashboard$Load$NeedsIndexingRows$loadNeedsIndexingRow, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage)),
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, page, perPage),
				$author$project$Components$Dashboard$Load$NeedsIndexingRows$loadIds(filter)));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$replyEmailIds = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_emailMessageId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$EmailMessageId$decode),
		entrypoint: 'replyEmailIdsV2',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$dashboardFiltersQueryEncoder)
	});
var $author$project$Components$Dashboard$Load$ReplyRows$loadIds = $author$project$Components$Dashboard$Load$EmailRows$loadIdsHelper($author$project$Forward$AppSpecific$NeedsControllerEndpoints$replyEmailIds);
var $author$project$Components$Dashboard$Load$ReplyRows$RowData = F4(
	function (emailData, exceptionedItems, maybeInvoiceOwnerParams, currentUser) {
		return {currentUser: currentUser, emailData: emailData, exceptionedItems: exceptionedItems, maybeInvoiceOwnerParams: maybeInvoiceOwnerParams};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItemsByEmailMessageId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_exceptionedItemId,
		decoder: $author$project$Domain$ExceptionedItemId$decode,
		entrypoint: 'exceptionedItemIdsByEmailMessageId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItem,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToInReplyToExceptionedItems = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItemsByEmailMessageId,
		fieldName: 'inReplyTo.exceptionedItems',
		getId: function ($) {
			return $.inReplyToEmailMessageId;
		}
	});
var $author$project$Components$Dashboard$Url$PathToEmail$CarrierOwner = function (a) {
	return {$: 'CarrierOwner', a: a};
};
var $author$project$Components$Dashboard$Url$PathToEmail$FactorOwner = function (a) {
	return {$: 'FactorOwner', a: a};
};
var $author$project$Components$Dashboard$Load$ReplyRows$loadCarrierInvoiceOwner = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByCarrierInvoiceId,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceDashboardRow,
		$author$project$Forward$Lookup$succeed(
			F2(
				function (row, exceptionSummary) {
					return {carrierInvoiceId: row.id, exceptionSummary: exceptionSummary, loadStateId: row.loadStateId, maybeLoadCustomer: row.loadCustomer, requiresLtlReconciliation: row.requiresReconciliation, shipmentCustomers: row.shipmentCustomers};
				}))));
var $author$project$Components$Dashboard$Load$ReplyRows$loadFactorInvoiceOwner = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByFactorInvoiceId,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed(
			F2(
				function (factorInvoiceId, exceptionSummary) {
					return {exceptionSummary: exceptionSummary, factorInvoiceId: factorInvoiceId};
				}))));
var $author$project$Components$Dashboard$Load$ReplyRows$exceptionedItemToInvoiceOwnerParams = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItemOwnerIdEdge(
	{
		carrierInvoiceOwner: A2(
			$author$project$Forward$Lookup$map,
			A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Components$Dashboard$Url$PathToEmail$CarrierOwner),
			$author$project$Components$Dashboard$Load$ReplyRows$loadCarrierInvoiceOwner),
		documentGroupOwner: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
		emailMessageOwner: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
		factorInvoiceOwner: A2(
			$author$project$Forward$Lookup$map,
			A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Components$Dashboard$Url$PathToEmail$FactorOwner),
			$author$project$Components$Dashboard$Load$ReplyRows$loadFactorInvoiceOwner)
	});
var $author$project$Components$Dashboard$Load$ReplyRows$emailMessageToInvoiceOwnerParams = A2(
	$author$project$Forward$Lookup$map,
	$elm_community$maybe_extra$Maybe$Extra$join,
	A2(
		$author$project$Forward$Lookup$traverseMaybe,
		$author$project$Components$Dashboard$Load$ReplyRows$exceptionedItemToInvoiceOwnerParams,
		A2(
			$author$project$Forward$Lookup$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen($elm$core$List$head),
				$elm$core$Maybe$map(
					function ($) {
						return $.owner;
					})),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToInReplyToExceptionedItems)));
var $author$project$Components$Dashboard$Load$ReplyRows$EmailData = F8(
	function (accountType, useSubmissionWorkflow, useBothWorkflows, readOnlyFactorInvoices, useFactorInvoiceWorkflowPage, emailMessage, maybeTmsCarrier, maybeDocumentBatch) {
		return {accountType: accountType, emailMessage: emailMessage, maybeDocumentBatch: maybeDocumentBatch, maybeTmsCarrier: maybeTmsCarrier, readOnlyFactorInvoices: readOnlyFactorInvoices, useBothWorkflows: useBothWorkflows, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage, useSubmissionWorkflow: useSubmissionWorkflow};
	});
var $author$project$Components$Dashboard$Load$ReplyRows$loadEmailData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			A2(
				$author$project$Forward$Lookup$apply,
				A3(
					$author$project$Forward$Lookup$map2,
					$author$project$Domain$User$usesFactorInvoiceWorkflowPage,
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
					$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser)),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$map,
						function ($) {
							return $.readOnlyFactorInvoices;
						},
						$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser)),
					A2(
						$author$project$Forward$Lookup$apply,
						A2(
							$author$project$Forward$Lookup$map,
							function ($) {
								return $.useBothSubmissionAndTraditionalWorkflow;
							},
							$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings)),
						A2(
							$author$project$Forward$Lookup$apply,
							A2(
								$author$project$Forward$Lookup$map,
								function ($) {
									return $.useSubmissionWorkflow;
								},
								$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings)),
							A2(
								$author$project$Forward$Lookup$apply,
								A2(
									$author$project$Forward$Lookup$map,
									$author$project$Domain$Account$accountType,
									$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount)),
								$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Load$ReplyRows$EmailData)))))))));
var $author$project$Components$Dashboard$Load$ReplyRows$loadRowData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$Dashboard$Load$ReplyRows$emailMessageToInvoiceOwnerParams,
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$map,
				$elm$core$Maybe$withDefault(_List_Nil),
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToInReplyToExceptionedItems),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$Dashboard$Load$ReplyRows$loadEmailData,
				$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Load$ReplyRows$RowData)))));
var $author$project$Components$Dashboard$Load$ReplyRows$replyRowFromRowData = function (_v0) {
	var currentUser = _v0.currentUser;
	var maybeInvoiceOwnerParams = _v0.maybeInvoiceOwnerParams;
	var exceptionedItems = _v0.exceptionedItems;
	var emailData = _v0.emailData;
	var redirectTo = A3(
		$author$project$Components$Dashboard$Url$PathToEmail$pathToEmail,
		emailData.accountType,
		{readOnlyFactorInvoices: emailData.readOnlyFactorInvoices, useBothWorkflows: emailData.useBothWorkflows, useFactorInvoiceWorkflowPage: emailData.useFactorInvoiceWorkflowPage, useSubmissionWorkflow: emailData.useSubmissionWorkflow},
		{emailMessageId: emailData.emailMessage.id, hasSubmission: emailData.emailMessage.hasFactorClientInvoiceSubmission, maybeDocumentBatch: emailData.maybeDocumentBatch, maybeEmailType: emailData.emailMessage.messageType, maybeInvoiceOwnerParams: maybeInvoiceOwnerParams, readOnly: currentUser.readOnlyFactorInvoices});
	var exceptionSummary = function () {
		if (maybeInvoiceOwnerParams.$ === 'Just') {
			var invoiceOwnerParams = maybeInvoiceOwnerParams.a;
			if (invoiceOwnerParams.$ === 'FactorOwner') {
				var factorInvoiceParams = invoiceOwnerParams.a;
				return factorInvoiceParams.exceptionSummary;
			} else {
				var carrierParams = invoiceOwnerParams.a;
				return carrierParams.exceptionSummary;
			}
		} else {
			return $author$project$Domain$ExceptionSummary$empty;
		}
	}();
	var customers = function () {
		if (maybeInvoiceOwnerParams.$ === 'Just') {
			var invoiceOwnerParams = maybeInvoiceOwnerParams.a;
			if (invoiceOwnerParams.$ === 'FactorOwner') {
				return $author$project$Components$Dashboard$DashboardRow$NoCustomers;
			} else {
				var shipmentCustomers = invoiceOwnerParams.a.shipmentCustomers;
				var maybeLoadCustomer = invoiceOwnerParams.a.maybeLoadCustomer;
				return A2($author$project$Components$Dashboard$DashboardRow$customersToCustomerType, shipmentCustomers, maybeLoadCustomer);
			}
		} else {
			return $author$project$Components$Dashboard$DashboardRow$NoCustomers;
		}
	}();
	return {customers: customers, emailMessage: emailData.emailMessage, exceptionSummary: exceptionSummary, exceptionedItems: exceptionedItems, maybeDocumentBatch: emailData.maybeDocumentBatch, maybeImportStatus: $elm$core$Maybe$Nothing, maybeTmsCarrier: emailData.maybeTmsCarrier, redirectTo: redirectTo};
};
var $author$project$Components$Dashboard$Load$ReplyRows$loadReplyRow = A2($author$project$Forward$Lookup$map, $author$project$Components$Dashboard$Load$ReplyRows$replyRowFromRowData, $author$project$Components$Dashboard$Load$ReplyRows$loadRowData);
var $author$project$Components$Dashboard$Load$ReplyRows$loadData = F3(
	function (filter, page, perPage) {
		return A2(
			$author$project$Forward$Lookup$traversePage,
			$author$project$Forward$Lookup$exposeLoadingState(
				A2($author$project$Forward$Lookup$traverse, $author$project$Components$Dashboard$Load$ReplyRows$loadReplyRow, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage)),
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, page, perPage),
				$author$project$Components$Dashboard$Load$ReplyRows$loadIds(filter)));
	});
var $author$project$Domain$VerificationsDebtorBatchIdGroup$VerificationsDebtorBatchIdGroup = F2(
	function (debtorBatchId, itemIds) {
		return {debtorBatchId: debtorBatchId, itemIds: itemIds};
	});
var $author$project$Domain$VerificationsDebtorBatchId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationsDebtorBatchId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$VerificationsDebtorBatchItemId$VerificationsDebtorBatchItemId = function (a) {
	return {$: 'VerificationsDebtorBatchItemId', a: a};
};
var $author$project$Domain$VerificationsDebtorBatchItemId$fromInt = function (_int) {
	return $author$project$Domain$VerificationsDebtorBatchItemId$VerificationsDebtorBatchItemId(_int);
};
var $author$project$Domain$VerificationsDebtorBatchItemId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationsDebtorBatchItemId$fromInt, $elm$json$Json$Decode$int);
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Domain$VerificationsDebtorBatchIdGroup$decode = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Domain$VerificationsDebtorBatchIdGroup$VerificationsDebtorBatchIdGroup,
	A2($elm$json$Json$Decode$index, 0, $author$project$Domain$VerificationsDebtorBatchId$decode),
	A2(
		$elm$json$Json$Decode$index,
		1,
		$elm$json$Json$Decode$list($author$project$Domain$VerificationsDebtorBatchItemId$decode)));
var $author$project$Domain$LabelFilter$stateAsMaybeString = function (labelFilter) {
	var _v0 = labelFilter.state;
	switch (_v0.$) {
		case 'Unselected':
			return $elm$core$Maybe$Nothing;
		case 'Selected':
			return $elm$core$Maybe$Just('+');
		default:
			return $elm$core$Maybe$Just('-');
	}
};
var $author$project$Domain$DashboardFilters$toLabelFilterTuple = function (labelFilter) {
	return A2(
		$elm$core$Maybe$map,
		function (stateString) {
			return _Utils_Tuple2(
				labelFilter.label,
				$elm$json$Json$Encode$string(stateString));
		},
		$author$project$Domain$LabelFilter$stateAsMaybeString(labelFilter));
};
var $author$project$Domain$DashboardFilters$encodedTuples = function (filters) {
	var labelFilterTuples = A2($elm$core$List$filterMap, $author$project$Domain$DashboardFilters$toLabelFilterTuple, filters.labelFilters);
	var debtorIdTuples = _List_fromArray(
		[
			_Utils_Tuple2(
			'factorBrokerId',
			A2(
				$elm$json$Json$Encode$list,
				$elm$json$Json$Encode$int,
				A2($elm$core$List$map, $author$project$Domain$FactorBrokerId$toInt, filters.factorBrokerIds)))
		]);
	var categories = A2(
		$elm$core$List$filter,
		function (x) {
			return !($elm$core$Set$isEmpty(x.selected) && $elm$core$Set$isEmpty(x.excluded));
		},
		filters.categories);
	var carrierIdTuple = $elm$core$List$isEmpty(filters.tmsCarrierIds) ? _Utils_Tuple2('carrierId', $elm$json$Json$Encode$null) : _Utils_Tuple2(
		'carrierId',
		A2(
			$elm$json$Json$Encode$list,
			$elm$json$Json$Encode$int,
			A2($elm$core$List$map, $author$project$Domain$TmsCarrierId$toInt, filters.tmsCarrierIds)));
	return _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'filters',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						carrierIdTuple,
						_Utils_ap(labelFilterTuples, debtorIdTuples)))),
				_Utils_Tuple2(
				'dashboardMode',
				$author$project$AuditPb$dashboardModeEncoder(filters.dashboardMode)),
				_Utils_Tuple2(
				'categories',
				A2($elm$json$Json$Encode$list, $author$project$Domain$CategoryFilter$categorySelectionEncoder, categories)),
				_Utils_Tuple2(
				'startDate',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, filters.startDate)))),
				_Utils_Tuple2(
				'endDate',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, filters.endDate)))),
				_Utils_Tuple2(
				'startDateTime',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, filters.startDateTime)))),
				_Utils_Tuple2(
				'endDateTime',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, filters.endDateTime)))),
				_Utils_Tuple2(
				'rangeType',
				$elm$json$Json$Encode$string(
					$author$project$Domain$QueueDate$toString(filters.rangeType))),
				_Utils_Tuple2(
				'sortBy',
				$author$project$Domain$DashboardSortBy$encode(filters.dashboardSortBy)),
				_Utils_Tuple2(
				'timezoneName',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '', filters.timezoneName))),
				_Utils_Tuple2(
				'customers',
				A2($elm$json$Json$Encode$list, $author$project$Domain$Customer$encode, filters.customers)),
				_Utils_Tuple2(
				'exceptions',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, filters.exceptions))
			]),
		function () {
			var _v0 = filters.reskinToggle;
			if (_v0.$ === 'Just') {
				var reskinToggle = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'reskin_toggle',
						$elm$json$Json$Encode$bool(reskinToggle))
					]);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Domain$DashboardFilters$encode = function (filters) {
	return $elm$json$Json$Encode$object(
		$author$project$Domain$DashboardFilters$encodedTuples(filters));
};
var $author$project$Forward$AppSpecific$Cache$list_verificationsDebtorBatchIdGroup = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_verificationsDebtorBatchIdGroup;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_verificationsDebtorBatchIdGroup: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroups = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_verificationsDebtorBatchIdGroup,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$VerificationsDebtorBatchIdGroup$decode),
		entrypoint: 'verifyDebtorBatchIdGroups',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$DashboardFilters$encode)
	});
var $author$project$Components$Dashboard$Load$VerifyRows$loadIds = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroups;
var $author$project$Components$Dashboard$VerifyRow$VerifyRow = F4(
	function (debtorBatch, debtor, items, invoices) {
		return {debtor: debtor, debtorBatch: debtorBatch, invoices: invoices, items: items};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorInvoice = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
		fieldName: 'factorInvoice',
		getId: function ($) {
			return $.factorInvoiceId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToFactorBroker = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker,
		fieldName: 'factorBroker',
		getId: function ($) {
			return $.factorBrokerId;
		}
	});
var $author$project$AuditPb$VerificationsDebtorBatch = function (id) {
	return function (factorBrokerId) {
		return function (state) {
			return function (sortScore) {
				return function (labels) {
					return function (optOuts) {
						return function (bouncingAddresses) {
							return function (recipientEdits) {
								return function (confirmationResetAvailable) {
									return function (confirmationEmailMessageIds) {
										return {bouncingAddresses: bouncingAddresses, confirmationEmailMessageIds: confirmationEmailMessageIds, confirmationResetAvailable: confirmationResetAvailable, factorBrokerId: factorBrokerId, id: id, labels: labels, optOuts: optOuts, recipientEdits: recipientEdits, sortScore: sortScore, state: state};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$VerificationsDebtorBatchStateAvailable = {$: 'VerificationsDebtorBatchStateAvailable'};
var $author$project$AuditPb$verificationsDebtorBatchStateDefault = $author$project$AuditPb$VerificationsDebtorBatchStateAvailable;
var $author$project$AuditPb$VerificationsDebtorBatchStateFinished = {$: 'VerificationsDebtorBatchStateFinished'};
var $author$project$AuditPb$VerificationsDebtorBatchStateReply = {$: 'VerificationsDebtorBatchStateReply'};
var $author$project$AuditPb$VerificationsDebtorBatchStateStarted = {$: 'VerificationsDebtorBatchStateStarted'};
var $author$project$AuditPb$VerificationsDebtorBatchStateWaiting = {$: 'VerificationsDebtorBatchStateWaiting'};
var $author$project$AuditPb$allVerificationsDebtorBatchState = _List_fromArray(
	[$author$project$AuditPb$VerificationsDebtorBatchStateAvailable, $author$project$AuditPb$VerificationsDebtorBatchStateStarted, $author$project$AuditPb$VerificationsDebtorBatchStateWaiting, $author$project$AuditPb$VerificationsDebtorBatchStateFinished, $author$project$AuditPb$VerificationsDebtorBatchStateReply]);
var $author$project$AuditPb$verificationsDebtorBatchStateToString = function (v) {
	switch (v.$) {
		case 'VerificationsDebtorBatchStateAvailable':
			return 'available';
		case 'VerificationsDebtorBatchStateStarted':
			return 'started';
		case 'VerificationsDebtorBatchStateWaiting':
			return 'waiting';
		case 'VerificationsDebtorBatchStateFinished':
			return 'finished';
		default:
			return 'reply';
	}
};
var $author$project$AuditPb$verificationsDebtorBatchStateDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationsDebtorBatchStateToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationsDebtorBatchState));
var $author$project$AuditPb$verificationsDebtorBatchStateFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationsDebtorBatchStateDict);
};
var $author$project$AuditPb$verificationsDebtorBatchStateDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationsDebtorBatchStateDefault),
		$author$project$AuditPb$verificationsDebtorBatchStateFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$VerificationsDebtorConfirmationOptOut = F3(
	function (emailAddress, optedOutAt, freeText) {
		return {emailAddress: emailAddress, freeText: freeText, optedOutAt: optedOutAt};
	});
var $author$project$AuditPb$verificationsDebtorConfirmationOptOutDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'free_text',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'opted_out_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'email_address',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorConfirmationOptOut))));
	});
var $author$project$AuditPb$VerificationsDebtorConfirmationRecipientEdit = F3(
	function (emailAddress, name, kind) {
		return {emailAddress: emailAddress, kind: kind, name: name};
	});
var $author$project$AuditPb$VerificationsDebtorConfirmationRecipientEditKindAdded = {$: 'VerificationsDebtorConfirmationRecipientEditKindAdded'};
var $author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindDefault = $author$project$AuditPb$VerificationsDebtorConfirmationRecipientEditKindAdded;
var $author$project$AuditPb$VerificationsDebtorConfirmationRecipientEditKindExcluded = {$: 'VerificationsDebtorConfirmationRecipientEditKindExcluded'};
var $author$project$AuditPb$allVerificationsDebtorConfirmationRecipientEditKind = _List_fromArray(
	[$author$project$AuditPb$VerificationsDebtorConfirmationRecipientEditKindAdded, $author$project$AuditPb$VerificationsDebtorConfirmationRecipientEditKindExcluded]);
var $author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindToString = function (v) {
	if (v.$ === 'VerificationsDebtorConfirmationRecipientEditKindAdded') {
		return 'added';
	} else {
		return 'excluded';
	}
};
var $author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationsDebtorConfirmationRecipientEditKind));
var $author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindDict);
};
var $author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindDefault),
		$author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$verificationsDebtorConfirmationRecipientEditDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'kind',
			$author$project$AuditPb$verificationsDebtorConfirmationRecipientEditKindDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'email_address',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorConfirmationRecipientEdit))));
	});
var $author$project$AuditPb$verificationsDebtorBatchDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'confirmation_email_message_ids',
			A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'confirmation_reset_available',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$repeated,
					'recipient_edits',
					$author$project$AuditPb$verificationsDebtorConfirmationRecipientEditDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'bouncing_addresses',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$repeated,
							'opt_outs',
							$author$project$AuditPb$verificationsDebtorConfirmationOptOutDecoder,
							A3(
								$author$project$AuditPb$repeated,
								'labels',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'sort_score',
									$author$project$AuditPb$intDecoder,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'state',
										$author$project$AuditPb$verificationsDebtorBatchStateDecoder,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'factor_broker_id',
											A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $author$project$AuditPb$intDecoder),
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'id',
												A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationsDebtorBatchId$fromInt, $author$project$AuditPb$intDecoder),
												$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorBatch)))))))))));
	});
var $author$project$Domain$VerificationsDebtorBatch$decode = $author$project$AuditPb$verificationsDebtorBatchDecoder;
var $author$project$Forward$AppSpecific$Cache$verificationsDebtorBatch = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.verificationsDebtorBatch;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{verificationsDebtorBatch: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$verificationsDebtorBatch,
		decoder: $author$project$Domain$VerificationsDebtorBatch$decode,
		entrypoint: 'verificationsDebtorBatch',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$VerificationsDebtorBatchId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroupToVerificationsDebtorBatch = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch,
		fieldName: 'verificationsDebtorBatch',
		getId: function ($) {
			return $.debtorBatchId;
		}
	});
var $author$project$AuditPb$VerificationsDebtorBatchItem = function (id) {
	return function (verificationsDebtorBatchId) {
		return function (previousVerificationsDebtorBatchId) {
			return function (factorInvoiceId) {
				return function (state) {
					return function (priority) {
						return function (note) {
							return function (cadenceDebtorContactId) {
								return function (cadenceVerificationMethodId) {
									return function (verifyLevel) {
										return function (verifyLevelReason) {
											return function (failedVerifyRules) {
												return function (effectiveCustomState) {
													return function (debtorConfirmation) {
														return {cadenceDebtorContactId: cadenceDebtorContactId, cadenceVerificationMethodId: cadenceVerificationMethodId, debtorConfirmation: debtorConfirmation, effectiveCustomState: effectiveCustomState, factorInvoiceId: factorInvoiceId, failedVerifyRules: failedVerifyRules, id: id, note: note, previousVerificationsDebtorBatchId: previousVerificationsDebtorBatchId, priority: priority, state: state, verificationsDebtorBatchId: verificationsDebtorBatchId, verifyLevel: verifyLevel, verifyLevelReason: verifyLevelReason};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Domain$CadenceDebtorContactId$CadenceDebtorContactId = function (a) {
	return {$: 'CadenceDebtorContactId', a: a};
};
var $author$project$Domain$CadenceDebtorContactId$fromInt = function (_int) {
	return $author$project$Domain$CadenceDebtorContactId$CadenceDebtorContactId(_int);
};
var $author$project$Domain$CadenceVerificationMethodId$CadenceVerificationMethodId = function (a) {
	return {$: 'CadenceVerificationMethodId', a: a};
};
var $author$project$Domain$CadenceVerificationMethodId$fromInt = function (_int) {
	return $author$project$Domain$CadenceVerificationMethodId$CadenceVerificationMethodId(_int);
};
var $author$project$AuditPb$VerificationsDebtorBatchItemFailedVerifyRule = F3(
	function (level, message, reason) {
		return {level: level, message: message, reason: reason};
	});
var $author$project$AuditPb$VerifyLevelUndefined = {$: 'VerifyLevelUndefined'};
var $author$project$AuditPb$verifyLevelDefault = $author$project$AuditPb$VerifyLevelUndefined;
var $author$project$AuditPb$VerifyLevelHigh = {$: 'VerifyLevelHigh'};
var $author$project$AuditPb$VerifyLevelLow = {$: 'VerifyLevelLow'};
var $author$project$AuditPb$VerifyLevelMedium = {$: 'VerifyLevelMedium'};
var $author$project$AuditPb$allVerifyLevel = _List_fromArray(
	[$author$project$AuditPb$VerifyLevelUndefined, $author$project$AuditPb$VerifyLevelLow, $author$project$AuditPb$VerifyLevelMedium, $author$project$AuditPb$VerifyLevelHigh]);
var $author$project$AuditPb$verifyLevelToString = function (v) {
	switch (v.$) {
		case 'VerifyLevelUndefined':
			return 'undefined';
		case 'VerifyLevelLow':
			return 'low';
		case 'VerifyLevelMedium':
			return 'medium';
		default:
			return 'high';
	}
};
var $author$project$AuditPb$verifyLevelDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verifyLevelToString(v),
				v);
		},
		$author$project$AuditPb$allVerifyLevel));
var $author$project$AuditPb$verifyLevelFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verifyLevelDict);
};
var $author$project$AuditPb$verifyLevelDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verifyLevelDefault),
		$author$project$AuditPb$verifyLevelFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$VerifyLevelReasonUnknown = {$: 'VerifyLevelReasonUnknown'};
var $author$project$AuditPb$verifyLevelReasonDefault = $author$project$AuditPb$VerifyLevelReasonUnknown;
var $author$project$AuditPb$VerifyLevelReasonAbnormalLaneRate = {$: 'VerifyLevelReasonAbnormalLaneRate'};
var $author$project$AuditPb$VerifyLevelReasonCarrierVerificationRequired = {$: 'VerifyLevelReasonCarrierVerificationRequired'};
var $author$project$AuditPb$VerifyLevelReasonClientThresholdExceeded = {$: 'VerifyLevelReasonClientThresholdExceeded'};
var $author$project$AuditPb$VerifyLevelReasonDefault = {$: 'VerifyLevelReasonDefault'};
var $author$project$AuditPb$VerifyLevelReasonFailedVerification = {$: 'VerifyLevelReasonFailedVerification'};
var $author$project$AuditPb$VerifyLevelReasonIgnoredNoClientDebtorOnBol = {$: 'VerifyLevelReasonIgnoredNoClientDebtorOnBol'};
var $author$project$AuditPb$VerifyLevelReasonNewCarrier = {$: 'VerifyLevelReasonNewCarrier'};
var $author$project$AuditPb$VerifyLevelReasonNoticeOfAssignment = {$: 'VerifyLevelReasonNoticeOfAssignment'};
var $author$project$AuditPb$VerifyLevelReasonStaleDeliveryDate = {$: 'VerifyLevelReasonStaleDeliveryDate'};
var $author$project$AuditPb$VerifyLevelReasonTopInvoiceAmountPercentile = {$: 'VerifyLevelReasonTopInvoiceAmountPercentile'};
var $author$project$AuditPb$VerifyLevelReasonWarnAmountExceeded = {$: 'VerifyLevelReasonWarnAmountExceeded'};
var $author$project$AuditPb$allVerifyLevelReason = _List_fromArray(
	[$author$project$AuditPb$VerifyLevelReasonUnknown, $author$project$AuditPb$VerifyLevelReasonDefault, $author$project$AuditPb$VerifyLevelReasonCarrierVerificationRequired, $author$project$AuditPb$VerifyLevelReasonClientThresholdExceeded, $author$project$AuditPb$VerifyLevelReasonFailedVerification, $author$project$AuditPb$VerifyLevelReasonNewCarrier, $author$project$AuditPb$VerifyLevelReasonNoticeOfAssignment, $author$project$AuditPb$VerifyLevelReasonTopInvoiceAmountPercentile, $author$project$AuditPb$VerifyLevelReasonWarnAmountExceeded, $author$project$AuditPb$VerifyLevelReasonAbnormalLaneRate, $author$project$AuditPb$VerifyLevelReasonIgnoredNoClientDebtorOnBol, $author$project$AuditPb$VerifyLevelReasonStaleDeliveryDate]);
var $author$project$AuditPb$verifyLevelReasonToString = function (v) {
	switch (v.$) {
		case 'VerifyLevelReasonUnknown':
			return 'unknown';
		case 'VerifyLevelReasonDefault':
			return 'default';
		case 'VerifyLevelReasonCarrierVerificationRequired':
			return 'carrier_verification_required';
		case 'VerifyLevelReasonClientThresholdExceeded':
			return 'client_threshold_exceeded';
		case 'VerifyLevelReasonFailedVerification':
			return 'failed_verification';
		case 'VerifyLevelReasonNewCarrier':
			return 'new_carrier';
		case 'VerifyLevelReasonNoticeOfAssignment':
			return 'notice_of_assignment';
		case 'VerifyLevelReasonTopInvoiceAmountPercentile':
			return 'top_invoice_amount_percentile';
		case 'VerifyLevelReasonWarnAmountExceeded':
			return 'warn_amount_exceeded';
		case 'VerifyLevelReasonAbnormalLaneRate':
			return 'abnormal_lane_rate';
		case 'VerifyLevelReasonIgnoredNoClientDebtorOnBol':
			return 'ignored_no_client_debtor_on_bol';
		default:
			return 'stale_delivery_date';
	}
};
var $author$project$AuditPb$verifyLevelReasonDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verifyLevelReasonToString(v),
				v);
		},
		$author$project$AuditPb$allVerifyLevelReason));
var $author$project$AuditPb$verifyLevelReasonFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verifyLevelReasonDict);
};
var $author$project$AuditPb$verifyLevelReasonDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verifyLevelReasonDefault),
		$author$project$AuditPb$verifyLevelReasonFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$verificationsDebtorBatchItemFailedVerifyRuleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'reason',
			$author$project$AuditPb$verifyLevelReasonDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'message',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'level',
					$author$project$AuditPb$verifyLevelDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorBatchItemFailedVerifyRule))));
	});
var $author$project$AuditPb$VerificationsDebtorConfirmation = function (state) {
	return function (askedAt) {
		return function (respondedAt) {
			return function (verdict) {
				return function (driftedFields) {
					return function (askedAmount) {
						return function (freeText) {
							return function (answers) {
								return function (requestReply) {
									return function (askedLoadId) {
										return function (askedInvoiceDate) {
											return function (askedCarrierName) {
												return function (channel) {
													return function (answeredQuestions) {
														return function (recipients) {
															return function (answeredBy) {
																return function (answeredAt) {
																	return {answeredAt: answeredAt, answeredBy: answeredBy, answeredQuestions: answeredQuestions, answers: answers, askedAmount: askedAmount, askedAt: askedAt, askedCarrierName: askedCarrierName, askedInvoiceDate: askedInvoiceDate, askedLoadId: askedLoadId, channel: channel, driftedFields: driftedFields, freeText: freeText, recipients: recipients, requestReply: requestReply, respondedAt: respondedAt, state: state, verdict: verdict};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$VerificationsDebtorConfirmationAnswer = F2(
	function (question, answer) {
		return {answer: answer, question: question};
	});
var $author$project$AuditPb$verificationsDebtorConfirmationAnswerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'answer',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'question',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorConfirmationAnswer)));
	});
var $author$project$AuditPb$VerificationsDebtorConfirmationAnswers = F7(
	function (amountToPay, delivery, carrierDisputed, actualCarrier, advances, deductions, accessorials) {
		return {accessorials: accessorials, actualCarrier: actualCarrier, advances: advances, amountToPay: amountToPay, carrierDisputed: carrierDisputed, deductions: deductions, delivery: delivery};
	});
var $author$project$AuditPb$VerificationsDebtorConfirmationDeliveryUnknown = {$: 'VerificationsDebtorConfirmationDeliveryUnknown'};
var $author$project$AuditPb$verificationsDebtorConfirmationDeliveryDefault = $author$project$AuditPb$VerificationsDebtorConfirmationDeliveryUnknown;
var $author$project$AuditPb$VerificationsDebtorConfirmationDeliveryDelivered = {$: 'VerificationsDebtorConfirmationDeliveryDelivered'};
var $author$project$AuditPb$VerificationsDebtorConfirmationDeliveryNever = {$: 'VerificationsDebtorConfirmationDeliveryNever'};
var $author$project$AuditPb$VerificationsDebtorConfirmationDeliveryNotYet = {$: 'VerificationsDebtorConfirmationDeliveryNotYet'};
var $author$project$AuditPb$allVerificationsDebtorConfirmationDelivery = _List_fromArray(
	[$author$project$AuditPb$VerificationsDebtorConfirmationDeliveryUnknown, $author$project$AuditPb$VerificationsDebtorConfirmationDeliveryDelivered, $author$project$AuditPb$VerificationsDebtorConfirmationDeliveryNotYet, $author$project$AuditPb$VerificationsDebtorConfirmationDeliveryNever]);
var $author$project$AuditPb$verificationsDebtorConfirmationDeliveryToString = function (v) {
	switch (v.$) {
		case 'VerificationsDebtorConfirmationDeliveryUnknown':
			return 'unknown';
		case 'VerificationsDebtorConfirmationDeliveryDelivered':
			return 'delivered';
		case 'VerificationsDebtorConfirmationDeliveryNotYet':
			return 'not_yet';
		default:
			return 'never';
	}
};
var $author$project$AuditPb$verificationsDebtorConfirmationDeliveryDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationsDebtorConfirmationDeliveryToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationsDebtorConfirmationDelivery));
var $author$project$AuditPb$verificationsDebtorConfirmationDeliveryFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationsDebtorConfirmationDeliveryDict);
};
var $author$project$AuditPb$verificationsDebtorConfirmationDeliveryDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationsDebtorConfirmationDeliveryDefault),
		$author$project$AuditPb$verificationsDebtorConfirmationDeliveryFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$verificationsDebtorConfirmationAnswersDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'accessorials',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'deductions',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'advances',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'actual_carrier',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'carrier_disputed',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$optional,
								'delivery',
								$author$project$AuditPb$verificationsDebtorConfirmationDeliveryDecoder,
								A3(
									$author$project$AuditPb$optional,
									'amount_to_pay',
									$elm$json$Json$Decode$string,
									$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorConfirmationAnswers))))))));
	});
var $author$project$AuditPb$VerificationsDebtorConfirmationChannelOneClick = {$: 'VerificationsDebtorConfirmationChannelOneClick'};
var $author$project$AuditPb$verificationsDebtorConfirmationChannelDefault = $author$project$AuditPb$VerificationsDebtorConfirmationChannelOneClick;
var $author$project$AuditPb$VerificationsDebtorConfirmationChannelCorrectionForm = {$: 'VerificationsDebtorConfirmationChannelCorrectionForm'};
var $author$project$AuditPb$VerificationsDebtorConfirmationChannelEmailReply = {$: 'VerificationsDebtorConfirmationChannelEmailReply'};
var $author$project$AuditPb$VerificationsDebtorConfirmationChannelWebPage = {$: 'VerificationsDebtorConfirmationChannelWebPage'};
var $author$project$AuditPb$allVerificationsDebtorConfirmationChannel = _List_fromArray(
	[$author$project$AuditPb$VerificationsDebtorConfirmationChannelOneClick, $author$project$AuditPb$VerificationsDebtorConfirmationChannelWebPage, $author$project$AuditPb$VerificationsDebtorConfirmationChannelCorrectionForm, $author$project$AuditPb$VerificationsDebtorConfirmationChannelEmailReply]);
var $author$project$AuditPb$verificationsDebtorConfirmationChannelToString = function (v) {
	switch (v.$) {
		case 'VerificationsDebtorConfirmationChannelOneClick':
			return 'one_click';
		case 'VerificationsDebtorConfirmationChannelWebPage':
			return 'web_page';
		case 'VerificationsDebtorConfirmationChannelCorrectionForm':
			return 'correction_form';
		default:
			return 'email_reply';
	}
};
var $author$project$AuditPb$verificationsDebtorConfirmationChannelDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationsDebtorConfirmationChannelToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationsDebtorConfirmationChannel));
var $author$project$AuditPb$verificationsDebtorConfirmationChannelFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationsDebtorConfirmationChannelDict);
};
var $author$project$AuditPb$verificationsDebtorConfirmationChannelDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationsDebtorConfirmationChannelDefault),
		$author$project$AuditPb$verificationsDebtorConfirmationChannelFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$VerificationsDebtorConfirmationRecipient = F8(
	function (emailAddress, name, acceptedAt, deliveredAt, openedAt, bouncedAt, bounceReason, deliveryError) {
		return {acceptedAt: acceptedAt, bounceReason: bounceReason, bouncedAt: bouncedAt, deliveredAt: deliveredAt, deliveryError: deliveryError, emailAddress: emailAddress, name: name, openedAt: openedAt};
	});
var $author$project$AuditPb$verificationsDebtorConfirmationRecipientDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'delivery_error',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'bounce_reason',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'bounced_at',
					$author$project$AuditPb$timestampDecoder,
					A3(
						$author$project$AuditPb$optional,
						'opened_at',
						$author$project$AuditPb$timestampDecoder,
						A3(
							$author$project$AuditPb$optional,
							'delivered_at',
							$author$project$AuditPb$timestampDecoder,
							A3(
								$author$project$AuditPb$optional,
								'accepted_at',
								$author$project$AuditPb$timestampDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'email_address',
										$elm$json$Json$Decode$string,
										$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorConfirmationRecipient)))))))));
	});
var $author$project$AuditPb$VerificationsDebtorConfirmationRequestReply = F3(
	function (verdict, respondedAt, freeText) {
		return {freeText: freeText, respondedAt: respondedAt, verdict: verdict};
	});
var $author$project$AuditPb$VerificationsDebtorConfirmationVerdictConfirmed = {$: 'VerificationsDebtorConfirmationVerdictConfirmed'};
var $author$project$AuditPb$verificationsDebtorConfirmationVerdictDefault = $author$project$AuditPb$VerificationsDebtorConfirmationVerdictConfirmed;
var $author$project$AuditPb$VerificationsDebtorConfirmationVerdictCorrection = {$: 'VerificationsDebtorConfirmationVerdictCorrection'};
var $author$project$AuditPb$VerificationsDebtorConfirmationVerdictUnparsed = {$: 'VerificationsDebtorConfirmationVerdictUnparsed'};
var $author$project$AuditPb$allVerificationsDebtorConfirmationVerdict = _List_fromArray(
	[$author$project$AuditPb$VerificationsDebtorConfirmationVerdictConfirmed, $author$project$AuditPb$VerificationsDebtorConfirmationVerdictCorrection, $author$project$AuditPb$VerificationsDebtorConfirmationVerdictUnparsed]);
var $author$project$AuditPb$verificationsDebtorConfirmationVerdictToString = function (v) {
	switch (v.$) {
		case 'VerificationsDebtorConfirmationVerdictConfirmed':
			return 'confirmed';
		case 'VerificationsDebtorConfirmationVerdictCorrection':
			return 'correction';
		default:
			return 'unparsed';
	}
};
var $author$project$AuditPb$verificationsDebtorConfirmationVerdictDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationsDebtorConfirmationVerdictToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationsDebtorConfirmationVerdict));
var $author$project$AuditPb$verificationsDebtorConfirmationVerdictFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationsDebtorConfirmationVerdictDict);
};
var $author$project$AuditPb$verificationsDebtorConfirmationVerdictDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationsDebtorConfirmationVerdictDefault),
		$author$project$AuditPb$verificationsDebtorConfirmationVerdictFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$verificationsDebtorConfirmationRequestReplyDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'free_text',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'responded_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$optional,
					'verdict',
					$author$project$AuditPb$verificationsDebtorConfirmationVerdictDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorConfirmationRequestReply))));
	});
var $author$project$AuditPb$VerificationsDebtorConfirmationStateNotAsked = {$: 'VerificationsDebtorConfirmationStateNotAsked'};
var $author$project$AuditPb$verificationsDebtorConfirmationStateDefault = $author$project$AuditPb$VerificationsDebtorConfirmationStateNotAsked;
var $author$project$AuditPb$VerificationsDebtorConfirmationStateAnswered = {$: 'VerificationsDebtorConfirmationStateAnswered'};
var $author$project$AuditPb$VerificationsDebtorConfirmationStateAsked = {$: 'VerificationsDebtorConfirmationStateAsked'};
var $author$project$AuditPb$VerificationsDebtorConfirmationStateSendFailed = {$: 'VerificationsDebtorConfirmationStateSendFailed'};
var $author$project$AuditPb$allVerificationsDebtorConfirmationState = _List_fromArray(
	[$author$project$AuditPb$VerificationsDebtorConfirmationStateNotAsked, $author$project$AuditPb$VerificationsDebtorConfirmationStateAsked, $author$project$AuditPb$VerificationsDebtorConfirmationStateAnswered, $author$project$AuditPb$VerificationsDebtorConfirmationStateSendFailed]);
var $author$project$AuditPb$verificationsDebtorConfirmationStateToString = function (v) {
	switch (v.$) {
		case 'VerificationsDebtorConfirmationStateNotAsked':
			return 'not_asked';
		case 'VerificationsDebtorConfirmationStateAsked':
			return 'asked';
		case 'VerificationsDebtorConfirmationStateAnswered':
			return 'answered';
		default:
			return 'send_failed';
	}
};
var $author$project$AuditPb$verificationsDebtorConfirmationStateDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$verificationsDebtorConfirmationStateToString(v),
				v);
		},
		$author$project$AuditPb$allVerificationsDebtorConfirmationState));
var $author$project$AuditPb$verificationsDebtorConfirmationStateFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$verificationsDebtorConfirmationStateDict);
};
var $author$project$AuditPb$verificationsDebtorConfirmationStateDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$verificationsDebtorConfirmationStateDefault),
		$author$project$AuditPb$verificationsDebtorConfirmationStateFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$verificationsDebtorConfirmationDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'answered_at',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$optionalMessage,
				'answered_by',
				$author$project$AuditPb$verificationsDebtorConfirmationRecipientDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'recipients',
					$author$project$AuditPb$verificationsDebtorConfirmationRecipientDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'answered_questions',
						$author$project$AuditPb$verificationsDebtorConfirmationAnswerDecoder,
						A3(
							$author$project$AuditPb$optional,
							'channel',
							$author$project$AuditPb$verificationsDebtorConfirmationChannelDecoder,
							A3(
								$author$project$AuditPb$optional,
								'asked_carrier_name',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$optional,
									'asked_invoice_date',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$optional,
										'asked_load_id',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$optionalMessage,
											'request_reply',
											$author$project$AuditPb$verificationsDebtorConfirmationRequestReplyDecoder,
											A3(
												$author$project$AuditPb$optionalMessage,
												'answers',
												$author$project$AuditPb$verificationsDebtorConfirmationAnswersDecoder,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'free_text',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$AuditPb$optional,
														'asked_amount',
														$elm$json$Json$Decode$string,
														A3(
															$author$project$AuditPb$repeated,
															'drifted_fields',
															$elm$json$Json$Decode$string,
															A3(
																$author$project$AuditPb$optional,
																'verdict',
																$author$project$AuditPb$verificationsDebtorConfirmationVerdictDecoder,
																A3(
																	$author$project$AuditPb$optional,
																	'responded_at',
																	$author$project$AuditPb$timestampDecoder,
																	A3(
																		$author$project$AuditPb$optional,
																		'asked_at',
																		$author$project$AuditPb$timestampDecoder,
																		A3(
																			$author$project$AuditPb$requiredWithoutDefault,
																			'state',
																			$author$project$AuditPb$verificationsDebtorConfirmationStateDecoder,
																			$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorConfirmation))))))))))))))))));
	});
var $author$project$AuditPb$verificationsDebtorBatchItemDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optionalMessage,
			'debtor_confirmation',
			$author$project$AuditPb$verificationsDebtorConfirmationDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'effective_custom_state',
				$author$project$AuditPb$verificationsDebtorBatchItemCustomStateDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'failed_verify_rules',
					$author$project$AuditPb$verificationsDebtorBatchItemFailedVerifyRuleDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'verify_level_reason',
						$author$project$AuditPb$verifyLevelReasonDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'verify_level',
							$author$project$AuditPb$verifyLevelDecoder,
							A3(
								$author$project$AuditPb$optional,
								'cadence_verification_method_id',
								A2($elm$json$Json$Decode$map, $author$project$Domain$CadenceVerificationMethodId$fromInt, $author$project$AuditPb$intDecoder),
								A3(
									$author$project$AuditPb$optional,
									'cadence_debtor_contact_id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$CadenceDebtorContactId$fromInt, $author$project$AuditPb$intDecoder),
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'note',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'priority',
											$author$project$AuditPb$intDecoder,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'state',
												$author$project$AuditPb$verificationsDebtorBatchItemStateDecoder,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'factor_invoice_id',
													A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
													A3(
														$author$project$AuditPb$optional,
														'previous_verifications_debtor_batch_id',
														A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationsDebtorBatchId$fromInt, $author$project$AuditPb$intDecoder),
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'verifications_debtor_batch_id',
															A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationsDebtorBatchId$fromInt, $author$project$AuditPb$intDecoder),
															A3(
																$author$project$AuditPb$requiredWithoutDefault,
																'id',
																A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationsDebtorBatchItemId$fromInt, $author$project$AuditPb$intDecoder),
																$author$project$AuditPb$decode($author$project$AuditPb$VerificationsDebtorBatchItem)))))))))))))));
	});
var $author$project$Domain$VerificationsDebtorBatchItem$decode = $author$project$AuditPb$verificationsDebtorBatchItemDecoder;
var $author$project$Domain$VerificationsDebtorBatchItemId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$Cache$verificationsDebtorBatchItem = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.verificationsDebtorBatchItem;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{verificationsDebtorBatchItem: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItem = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$verificationsDebtorBatchItem,
		decoder: $author$project$Domain$VerificationsDebtorBatchItem$decode,
		entrypoint: 'verificationsDebtorBatchItemV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$VerificationsDebtorBatchItemId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroupToVerificationsDebtorBatchItems = $author$project$Forward$Lookup$waitForAllList(
	$author$project$Forward$Lookup$defineListEdge(
		{
			entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItem,
			fieldName: 'verificationsDebtorBatchItmes',
			getIds: function ($) {
				return $.itemIds;
			}
		}));
var $author$project$Components$Dashboard$Load$VerifyRows$loadVerificationRow = A2(
	$author$project$Forward$Lookup$apply,
	A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorInvoice, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroupToVerificationsDebtorBatchItems),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroupToVerificationsDebtorBatchItems,
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToFactorBroker, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroupToVerificationsDebtorBatch),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroupToVerificationsDebtorBatch,
				$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$VerifyRow$VerifyRow)))));
var $author$project$Components$Dashboard$Load$VerifyRows$loadData = F2(
	function (page, perPage) {
		return A2(
			$author$project$Forward$Lookup$traversePage,
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$Dashboard$Load$VerifyRows$loadVerificationRow),
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, page, perPage),
				$author$project$Components$Dashboard$Load$VerifyRows$loadIds));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedInvoiceIds = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_carrierInvoiceId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$CarrierInvoiceId$decode),
		entrypoint: 'processedInvoiceIdsV2',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$dashboardFiltersQueryEncoder)
	});
var $author$project$Components$Dashboard$Processed$BrokerModel$loadIds = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedInvoiceIds;
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$makeData = F2(
	function (row, processedData) {
		return {
			amountToPay: processedData.amountToPay,
			carrierInvoiceId: row.id,
			customers: A2($author$project$Components$Dashboard$DashboardRow$customersToCustomerType, row.shipmentCustomers, row.loadCustomer),
			dateToPay: A2(
				$elm$core$Maybe$andThen,
				A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm$core$Result$toMaybe),
				processedData.dateToPay),
			deliveredAt: row.deliveredAt,
			invoiceNumber: processedData.invoiceNumber,
			labels: row.labels,
			loadId: row.loadId,
			loadStateId: row.loadStateId,
			payViaTriumphPay: processedData.payViaTriumphPay,
			paymentAddress: processedData.paymentAddress,
			processedAt: processedData.processedAt,
			requiresReconciliation: row.requiresReconciliation,
			tmsCarrier: A3($elm$core$Maybe$map2, $author$project$Components$Dashboard$RowHelper$DashboardTmsCarrier, row.tmsCarrierId, row.tmsCarrierName)
		};
	});
var $author$project$Forward$AppSpecific$Cache$processedCarrierInvoiceRowData = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.processedCarrierInvoiceRowData;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{processedCarrierInvoiceRowData: e});
		}));
var $author$project$AuditPb$ProcessedCarrierInvoiceRowData = F6(
	function (invoiceNumber, amountToPay, dateToPay, processedAt, paymentAddress, payViaTriumphPay) {
		return {amountToPay: amountToPay, dateToPay: dateToPay, invoiceNumber: invoiceNumber, payViaTriumphPay: payViaTriumphPay, paymentAddress: paymentAddress, processedAt: processedAt};
	});
var $author$project$AuditPb$processedCarrierInvoiceRowDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'pay_via_triumph_pay',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$optionalMessage,
				'payment_address',
				$author$project$AuditPb$addressDecoder,
				A3(
					$author$project$AuditPb$optional,
					'processed_at',
					$author$project$AuditPb$timestampDecoder,
					A3(
						$author$project$AuditPb$optional,
						'date_to_pay',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'amount_to_pay',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'invoice_number',
								$elm$json$Json$Decode$string,
								$author$project$AuditPb$decode($author$project$AuditPb$ProcessedCarrierInvoiceRowData)))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedCarrierInvoiceRowData = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$processedCarrierInvoiceRowData,
		decoder: $author$project$AuditPb$processedCarrierInvoiceRowDataDecoder,
		entrypoint: 'processedCarrierInvoiceRowData',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedCarrierInvoiceRowData,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceDashboardRow,
		$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Processed$ProcessedBrokerRow$makeData)));
var $author$project$Components$Dashboard$Processed$BrokerModel$loadInvoiceData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$Dashboard$Processed$ProcessedBrokerRow$loadData),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
var $author$project$Components$Dashboard$Processed$BrokerModel$loadData = F2(
	function (page, perPage) {
		return A2(
			$author$project$Forward$Lookup$traversePage,
			$author$project$Components$Dashboard$Processed$BrokerModel$loadInvoiceData,
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, page, perPage),
				$author$project$Components$Dashboard$Processed$BrokerModel$loadIds));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$Data = F2(
	function (unsortedAllIds, currentPageData) {
		return {currentPageData: currentPageData, unsortedAllIds: unsortedAllIds};
	});
var $author$project$Helpers$Maybe$orList = function (maybes) {
	orList:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (maybes.a.$ === 'Nothing') {
				var _v1 = maybes.a;
				var rest = maybes.b;
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue orList;
			} else {
				var answer = maybes.a.a;
				return $elm$core$Maybe$Just(answer);
			}
		}
	}
};
var $author$project$Helpers$Maybe$compareWithNothingLast = F2(
	function (a, b) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$EQ,
			$author$project$Helpers$Maybe$orList(
				_List_fromArray(
					[
						A3($elm$core$Maybe$map2, $elm$core$Basics$compare, a, b),
						A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always($elm$core$Basics$LT),
						a),
						A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always($elm$core$Basics$GT),
						b)
					])));
	});
var $author$project$Helpers$List$customSortWith = function (_v0) {
	var by = _v0.by;
	var _with = _v0._with;
	return F2(
		function (a, b) {
			return A2(
				_with,
				by(a),
				by(b));
		});
};
var $author$project$Helpers$List$foldl1 = F2(
	function (f, list) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var head = list.a;
			var tail = list.b;
			return $elm$core$Maybe$Just(
				A3($elm$core$List$foldl, f, head, tail));
		}
	});
var $author$project$Helpers$Date$max = F2(
	function (date1, date2) {
		return (_Utils_cmp(
			$elm$time$Time$posixToMillis(date1),
			$elm$time$Time$posixToMillis(date2)) > 0) ? date1 : date2;
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$newestProcessedDate = function (factorInvoices) {
	return $elm_community$maybe_extra$Maybe$Extra$join(
		A2(
			$author$project$Helpers$List$foldl1,
			$elm$core$Maybe$map2($author$project$Helpers$Date$max),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Forward$Remote$toMaybe,
					$elm$core$Maybe$andThen(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.factorInvoice;
							},
							function ($) {
								return $.processedAt;
							}))),
				factorInvoices)));
};
var $author$project$Helpers$Date$min = F2(
	function (date1, date2) {
		return (_Utils_cmp(
			$elm$time$Time$posixToMillis(date1),
			$elm$time$Time$posixToMillis(date2)) < 0) ? date1 : date2;
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$oldestProcessedDate = function (factorInvoices) {
	return $elm_community$maybe_extra$Maybe$Extra$join(
		A2(
			$author$project$Helpers$List$foldl1,
			$elm$core$Maybe$map2($author$project$Helpers$Date$min),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Forward$Remote$toMaybe,
					$elm$core$Maybe$andThen(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.factorInvoice;
							},
							function ($) {
								return $.processedAt;
							}))),
				factorInvoices)));
};
var $author$project$Components$Dashboard$Processed$FactorModel$dataSortOrder = function (sortBy_) {
	switch (sortBy_.$) {
		case 'SortByAlpha':
			return $author$project$Helpers$List$customSortWith(
				{
					by: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.tmsCarrierData;
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Forward$Remote$map(
								$elm$core$Maybe$map(
									function ($) {
										return $.name;
									})),
							A2($elm$core$Basics$composeR, $author$project$Forward$Remote$toMaybe, $author$project$Helpers$Maybe$join))),
					_with: $author$project$Helpers$Maybe$compareWithNothingLast
				});
		case 'SortByNewest':
			return $author$project$Helpers$List$customSortWith(
				{
					by: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.factorInvoiceData;
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$newestProcessedDate,
							$elm$core$Maybe$map($elm$time$Time$posixToMillis))),
					_with: F2(
						function (b, a) {
							return A2($author$project$Helpers$Maybe$compareWithNothingLast, a, b);
						})
				});
		default:
			return $author$project$Helpers$List$customSortWith(
				{
					by: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.factorInvoiceData;
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$oldestProcessedDate,
							$elm$core$Maybe$map($elm$time$Time$posixToMillis))),
					_with: $author$project$Helpers$Maybe$compareWithNothingLast
				});
	}
};
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$Data = F5(
	function (tmsCarrierId, tmsCarrierData, factorInvoiceIds, factorInvoiceData, useFactorInvoiceWorkflowPage) {
		return {factorInvoiceData: factorInvoiceData, factorInvoiceIds: factorInvoiceIds, tmsCarrierData: tmsCarrierData, tmsCarrierId: tmsCarrierId, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage};
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$FactorInvoiceData = F2(
	function (factorInvoice, maybeFactorBroker) {
		return {factorInvoice: factorInvoice, maybeFactorBroker: maybeFactorBroker};
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$loadFactorInvoiceData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Processed$ProcessedFactorGroup$FactorInvoiceData)));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroupToFactorInvoices = $author$project$Forward$Lookup$defineListEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
		fieldName: 'factorInvoices',
		getIds: function ($) {
			return $.factorInvoiceIds;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroupToTmsCarrier = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.tmsCarrierId;
		}
	});
var $author$project$Forward$Internal$Loadable$remoteLoadableToLoadableRemote = function (remote) {
	switch (remote.$) {
		case 'Loading':
			return $author$project$Forward$Internal$Loadable$fromRemote($author$project$Forward$Remote$Loading);
		case 'Loaded':
			var a = remote.a;
			return A2($author$project$Forward$Internal$Loadable$map, $author$project$Forward$Remote$Loaded, a);
		default:
			var error = remote.a;
			return $author$project$Forward$Internal$Loadable$fromRemote(
				$author$project$Forward$Remote$Error(error));
	}
};
var $author$project$Forward$Lookup$traverseListRemote = A2(
	$author$project$Forward$Lookup$traverseHelper,
	'traverseListRemote',
	{
		containerOfLoadablesToLoadableContainer: A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($author$project$Forward$Internal$Loadable$remoteLoadableToLoadableRemote),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Forward$Internal$Loadable$exposeLoadingStateOfListItems,
				$author$project$Forward$Internal$Loadable$map(
					$elm$core$List$map(
						$author$project$Forward$Remote$andThen($elm$core$Basics$identity))))),
		map: function (f) {
			return $elm$core$List$map(
				$author$project$Forward$Remote$map(f));
		}
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$loadData = A2(
	$author$project$Forward$Lookup$apply,
	A3(
		$author$project$Forward$Lookup$map2,
		$author$project$Domain$User$usesFactorInvoiceWorkflowPage,
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
		$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser)),
	A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$traverseListRemote, $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$loadFactorInvoiceData, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroupToFactorInvoices),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$map,
				function ($) {
					return $.factorInvoiceIds;
				},
				$author$project$Forward$Lookup$identity),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroupToTmsCarrier),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$map,
						function ($) {
							return $.tmsCarrierId;
						},
						$author$project$Forward$Lookup$identity),
					$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Processed$ProcessedFactorGroup$Data))))));
var $author$project$Domain$ProcessedFactorInvoiceIdGroup$ProcessedFactorInvoiceIdGroup = F2(
	function (tmsCarrierId, factorInvoiceIds) {
		return {factorInvoiceIds: factorInvoiceIds, tmsCarrierId: tmsCarrierId};
	});
var $author$project$Domain$ProcessedFactorInvoiceIdGroup$decode = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Domain$ProcessedFactorInvoiceIdGroup$ProcessedFactorInvoiceIdGroup,
	A2(
		$elm$json$Json$Decode$index,
		0,
		$elm$json$Json$Decode$maybe($author$project$Domain$TmsCarrierId$decode)),
	A2(
		$elm$json$Json$Decode$index,
		1,
		$elm$json$Json$Decode$list($author$project$Domain$FactorInvoiceId$decode)));
var $author$project$Forward$AppSpecific$Cache$list_processedFactorInvoiceIdGroup = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_processedFactorInvoiceIdGroup;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_processedFactorInvoiceIdGroup: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroups = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_processedFactorInvoiceIdGroup,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$ProcessedFactorInvoiceIdGroup$decode),
		entrypoint: 'processedFactorInvoiceIdGroups',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$DashboardFilters$encode)
	});
var $author$project$Components$Dashboard$Processed$FactorModel$loadIds = $author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroups;
var $author$project$Components$Dashboard$Processed$FactorModel$loadData = F3(
	function (_v0, requestedActivePage, perPage) {
		var factorModel = _v0.a;
		return A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, requestedActivePage, perPage),
				A2(
					$author$project$Forward$Lookup$map,
					$elm$core$List$sortWith(
						$author$project$Components$Dashboard$Processed$FactorModel$dataSortOrder(factorModel.sortBy)),
					A2($author$project$Forward$Lookup$traverseList, $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$loadData, $author$project$Components$Dashboard$Processed$FactorModel$loadIds))),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$Dashboard$Processed$FactorModel$loadIds,
				$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Processed$FactorModel$Data)));
	});
var $author$project$Domain$ReviewIdGroup$hasApprovableOrVerifying = function (_v0) {
	var verifyingFactorInvoices = _v0.verifyingFactorInvoices;
	var approvableFactorInvoices = _v0.approvableFactorInvoices;
	var _v1 = _Utils_Tuple2(approvableFactorInvoices, verifyingFactorInvoices);
	if ((!_v1.a.b) && (!_v1.b.b)) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Forward$AppSpecific$Cache$list_reviewIdGroup = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_reviewIdGroup;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_reviewIdGroup: e});
		}));
var $author$project$AuditPb$ReviewIdGroups = function (groups) {
	return {groups: groups};
};
var $author$project$AuditPb$ReviewIdGroup = function (carrierId) {
	return function (approvableFactorInvoices) {
		return function (draftFactorInvoices) {
			return function (replyFactorInvoices) {
				return function (verifyingFactorInvoices) {
					return function (unsentExceptionFactorInvoices) {
						return function (waitingExceptionFactorInvoices) {
							return function (newEmailMessageIds) {
								return function (replyEmailMessageIds) {
									return function (exceptionInvoicesCreatedAt) {
										return function (labels) {
											return {approvableFactorInvoices: approvableFactorInvoices, carrierId: carrierId, draftFactorInvoices: draftFactorInvoices, exceptionInvoicesCreatedAt: exceptionInvoicesCreatedAt, labels: labels, newEmailMessageIds: newEmailMessageIds, replyEmailMessageIds: replyEmailMessageIds, replyFactorInvoices: replyFactorInvoices, unsentExceptionFactorInvoices: unsentExceptionFactorInvoices, verifyingFactorInvoices: verifyingFactorInvoices, waitingExceptionFactorInvoices: waitingExceptionFactorInvoices};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$ReviewIdGroupInvoice = F2(
	function (id, updatedAt) {
		return {id: id, updatedAt: updatedAt};
	});
var $author$project$AuditPb$reviewIdGroupInvoiceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'updated_at',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$ReviewIdGroupInvoice)));
	});
var $author$project$AuditPb$reviewIdGroupDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'labels',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'exception_invoices_created_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'reply_email_message_ids',
					A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$repeated,
						'new_email_message_ids',
						A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
						A3(
							$author$project$AuditPb$repeated,
							'waiting_exception_factor_invoices',
							$author$project$AuditPb$reviewIdGroupInvoiceDecoder,
							A3(
								$author$project$AuditPb$repeated,
								'unsent_exception_factor_invoices',
								$author$project$AuditPb$reviewIdGroupInvoiceDecoder,
								A3(
									$author$project$AuditPb$repeated,
									'verifying_factor_invoices',
									$author$project$AuditPb$reviewIdGroupInvoiceDecoder,
									A3(
										$author$project$AuditPb$repeated,
										'reply_factor_invoices',
										$author$project$AuditPb$reviewIdGroupInvoiceDecoder,
										A3(
											$author$project$AuditPb$repeated,
											'draft_factor_invoices',
											$author$project$AuditPb$reviewIdGroupInvoiceDecoder,
											A3(
												$author$project$AuditPb$repeated,
												'approvable_factor_invoices',
												$author$project$AuditPb$reviewIdGroupInvoiceDecoder,
												A3(
													$author$project$AuditPb$optional,
													'carrier_id',
													A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
													$author$project$AuditPb$decode($author$project$AuditPb$ReviewIdGroup))))))))))));
	});
var $author$project$AuditPb$reviewIdGroupsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'groups',
			$author$project$AuditPb$reviewIdGroupDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$ReviewIdGroups));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroups = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_reviewIdGroup,
		decoder: A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.groups;
			},
			$author$project$AuditPb$reviewIdGroupsDecoder),
		entrypoint: 'reviewIdGroupsV2',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$dashboardFiltersQueryEncoder)
	});
var $author$project$Domain$DashboardFilters$categoryToPb = function (category) {
	return {
		category: category.category.name,
		excluded: $elm$core$Set$toList(category.excluded),
		label: $elm$core$Set$toList(
			$author$project$Domain$CategoryFilter$effectiveLabels(category))
	};
};
var $author$project$Domain$DashboardFilters$labelFilterToPb = function (labelFilter) {
	return {
		label: labelFilter.label,
		state: function () {
			var _v0 = labelFilter.state;
			switch (_v0.$) {
				case 'Unselected':
					return $author$project$AuditPb$LabelFilterStateUnselected;
				case 'Selected':
					return $author$project$AuditPb$LabelFilterStateSelected;
				default:
					return $author$project$AuditPb$LabelFilterStateNegated;
			}
		}()
	};
};
var $author$project$Domain$DashboardFilters$toPb = function (filters) {
	return {
		carrierId: filters.tmsCarrierIds,
		categories: A2($elm$core$List$map, $author$project$Domain$DashboardFilters$categoryToPb, filters.categories),
		customers: filters.customers,
		dashboardMode: filters.dashboardMode,
		endDate: A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, filters.endDate),
		endDateTime: filters.endDateTime,
		exceptions: filters.exceptions,
		factorBrokerId: filters.factorBrokerIds,
		labelFilters: A2($elm$core$List$map, $author$project$Domain$DashboardFilters$labelFilterToPb, filters.labelFilters),
		rangeType: filters.rangeType,
		reskinToggle: filters.reskinToggle,
		sortBy: filters.dashboardSortBy,
		startDate: A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, filters.startDate),
		startDateTime: filters.startDateTime,
		timezoneName: filters.timezoneName
	};
};
var $author$project$Components$Dashboard$Review$Model$loadIds = function (dashboardFilters) {
	var reviewIdsFilter = $elm$core$List$isEmpty(dashboardFilters.tmsCarrierIds) ? $elm$core$List$filter($author$project$Domain$ReviewIdGroup$hasApprovableOrVerifying) : $elm$core$Basics$identity;
	return A2(
		$author$project$Forward$Lookup$map,
		reviewIdsFilter,
		A2(
			$author$project$Forward$Lookup$startFrom,
			$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroups));
};
var $author$project$Components$Dashboard$Review$Model$ReviewGroupData = F3(
	function (tmsCarrier, clientGroup, labels) {
		return {clientGroup: clientGroup, labels: labels, tmsCarrier: tmsCarrier};
	});
var $author$project$Components$Dashboard$Review$Model$ClientGroup = function (approvableInvoices) {
	return function (draftInvoices) {
		return function (verifyingInvoices) {
			return function (newEmailMessages) {
				return function (exceptionedCount) {
					return function (unsentExceptionedInvoices) {
						return function (waitingExceptionedInvoices) {
							return function (replyEmailMessages) {
								return function (replyInvoices) {
									return function (exceptionInvoicesCreatedAt) {
										return {approvableInvoices: approvableInvoices, draftInvoices: draftInvoices, exceptionInvoicesCreatedAt: exceptionInvoicesCreatedAt, exceptionedCount: exceptionedCount, newEmailMessages: newEmailMessages, replyEmailMessages: replyEmailMessages, replyInvoices: replyInvoices, unsentExceptionedInvoices: unsentExceptionedInvoices, verifyingInvoices: verifyingInvoices, waitingExceptionedInvoices: waitingExceptionedInvoices};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Forward$Lookup$ifVia = F3(
	function (settingsLookup, readSetting, whenTrue) {
		return A4(
			$author$project$Forward$Lookup$ifElseVia,
			settingsLookup,
			readSetting,
			A2($author$project$Forward$Lookup$map, $elm$core$Maybe$Just, whenTrue),
			$author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing));
	});
var $author$project$Components$Dashboard$Review$Model$InvoiceInformation = F3(
	function (updatedAt, expandedData, factorInvoice) {
		return {expandedData: expandedData, factorInvoice: factorInvoice, updatedAt: updatedAt};
	});
var $author$project$Forward$Internal$LookupStructure$TimestampInvalidation = function (a) {
	return {$: 'TimestampInvalidation', a: a};
};
var $author$project$Forward$Lookup$applyTimestampInvalidation = function (_v0) {
	var nested = _v0.a;
	return $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: nested.decoderConfig,
			invalidate: function (_v1) {
				var a = _v1.a;
				return nested.invalidate(a);
			},
			load: F3(
				function (cache, parentRequestedTimestamp, _v2) {
					var a = _v2.a;
					var requiredTimestamp = _v2.b;
					var maxTimestamp = function () {
						if (parentRequestedTimestamp.$ === 'Nothing') {
							return requiredTimestamp;
						} else {
							var parent = parentRequestedTimestamp.a;
							return A2($author$project$Helpers$Date$max, parent, requiredTimestamp);
						}
					}();
					return A3(
						nested.load,
						cache,
						$elm$core$Maybe$Just(maxTimestamp),
						a);
				}),
			preloadBranches: nested.preloadBranches,
			structure: $author$project$Forward$Internal$LookupStructure$TimestampInvalidation(nested.structure)
		});
};
var $author$project$Components$Dashboard$Review$Model$ExpandedData = F7(
	function (factorBroker, activeBatchId, canonicalVerificationId, verificationPercentage, clientSubmissionReviewData, autoVerification, verificationsDebtorBatchItem) {
		return {activeBatchId: activeBatchId, autoVerification: autoVerification, canonicalVerificationId: canonicalVerificationId, clientSubmissionReviewData: clientSubmissionReviewData, factorBroker: factorBroker, verificationPercentage: verificationPercentage, verificationsDebtorBatchItem: verificationsDebtorBatchItem};
	});
var $author$project$Forward$AppSpecific$Cache$maybe_verificationsDebtorBatchId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_verificationsDebtorBatchId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_verificationsDebtorBatchId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activeVerificationsDebtorBatchIdByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_verificationsDebtorBatchId,
		decoder: $elm$json$Json$Decode$nullable($author$project$Domain$VerificationsDebtorBatchId$decode),
		entrypoint: 'activeVerificationsDebtorBatchIdByFactorInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$autoVerificationByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_verification,
		decoder: $elm$json$Json$Decode$nullable($author$project$AuditPb$verificationDecoder),
		entrypoint: 'autoVerificationV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$canonicalVerificationId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.canonicalVerificationId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{canonicalVerificationId: e});
		}));
var $author$project$Domain$CanonicalVerificationId$AutoVerificationId = {$: 'AutoVerificationId'};
var $author$project$Domain$CanonicalVerificationId$BatchItemId = {$: 'BatchItemId'};
var $author$project$Domain$CanonicalVerificationId$NoId = {$: 'NoId'};
var $author$project$Domain$VerificationId$VerificationId = function (a) {
	return {$: 'VerificationId', a: a};
};
var $author$project$Domain$VerificationId$fromInt = function (_int) {
	return $author$project$Domain$VerificationId$VerificationId(_int);
};
var $author$project$Domain$VerificationId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$CanonicalVerificationId$decode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			function (_v0) {
				return $author$project$Domain$CanonicalVerificationId$BatchItemId;
			},
			A2($elm$json$Json$Decode$field, 'verifications_debtor_batch_item_id', $author$project$Domain$VerificationsDebtorBatchItemId$decode)),
			A2(
			$elm$json$Json$Decode$map,
			function (_v1) {
				return $author$project$Domain$CanonicalVerificationId$AutoVerificationId;
			},
			A2($elm$json$Json$Decode$field, 'automatic_verification_id', $author$project$Domain$VerificationId$decode)),
			$elm$json$Json$Decode$succeed($author$project$Domain$CanonicalVerificationId$NoId)
		]));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$canonicalVerificationIdByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$canonicalVerificationId,
		decoder: $author$project$Domain$CanonicalVerificationId$decode,
		entrypoint: 'canonicalVerificationIdByFactorInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$AuditPb$ClientSubmissionReviewData = F2(
	function (batchEmailId, fundingMethods) {
		return {batchEmailId: batchEmailId, fundingMethods: fundingMethods};
	});
var $author$project$AuditPb$clientSubmissionReviewDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'funding_methods',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'batch_email_id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$EmailMessageId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$ClientSubmissionReviewData)));
	});
var $author$project$Forward$AppSpecific$Cache$maybe_clientSubmissionReviewData = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_clientSubmissionReviewData;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_clientSubmissionReviewData: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$clientSubmissionReviewDataByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_clientSubmissionReviewData,
		decoder: $elm$json$Json$Decode$maybe($author$project$AuditPb$clientSubmissionReviewDataDecoder),
		entrypoint: 'clientSubmissionReviewDataByFactorInvoiceIds',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$maybe_string = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_string;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_string: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationPercentageByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_string,
		decoder: $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		entrypoint: 'verificationPercentageByInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$maybe_verificationsDebtorBatchItem = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_verificationsDebtorBatchItem;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_verificationsDebtorBatchItem: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_verificationsDebtorBatchItem,
		decoder: $elm$json$Json$Decode$nullable($author$project$Domain$VerificationsDebtorBatchItem$decode),
		entrypoint: 'verificationsDebtorBatchItemByFactorInvoiceIdV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Components$Dashboard$Review$Model$loadExpandedData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemByFactorInvoiceId,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$autoVerificationByFactorInvoiceId,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$clientSubmissionReviewDataByFactorInvoiceId,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationPercentageByFactorInvoiceId,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$canonicalVerificationIdByFactorInvoiceId,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$activeVerificationsDebtorBatchIdByFactorInvoiceId,
						A2(
							$author$project$Forward$Lookup$apply,
							A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
							$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Review$Model$ExpandedData))))))));
var $author$project$Components$Dashboard$Review$Model$loadInvoiceInformation = function () {
	var maybeLoadExpandedData = A2(
		$author$project$Forward$Lookup$map,
		$elm$core$Maybe$Just,
		$author$project$Forward$Lookup$applyTimestampInvalidation(
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$Dashboard$Review$Model$loadExpandedData)));
	var loadFactorInvoice = $author$project$Forward$Lookup$applyTimestampInvalidation($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice);
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(loadFactorInvoice),
		A2(
			$author$project$Forward$Lookup$apply,
			maybeLoadExpandedData,
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Forward$Lookup$map, $elm$core$Tuple$second, $author$project$Forward$Lookup$identity),
				$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Review$Model$InvoiceInformation))));
}();
var $author$project$Id$MaybeSet$makeKey = function (maybeId) {
	if (maybeId.$ === 'Nothing') {
		return _Utils_Tuple2(0, 0);
	} else {
		var id = maybeId.a;
		return _Utils_Tuple2(
			1,
			$author$project$Id$toInt(id));
	}
};
var $author$project$Id$MaybeSet$member = F2(
	function (id, _v0) {
		var set = _v0.a;
		return A2(
			$elm$core$Set$member,
			$author$project$Id$MaybeSet$makeKey(id),
			set);
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToNewEmailMessages = $author$project$Forward$Lookup$defineListEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
		fieldName: 'newEmailMessages',
		getIds: function ($) {
			return $.newEmailMessageIds;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToReplyEmailMessages = $author$project$Forward$Lookup$defineListEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
		fieldName: 'replyEmailMessages',
		getIds: function ($) {
			return $.replyEmailMessageIds;
		}
	});
var $author$project$Components$Dashboard$Review$Model$loadClientGroup = function (exceptionsExpanded) {
	var loadInvoices = function (getIds) {
		return A2(
			$author$project$Forward$Lookup$traverseList,
			$author$project$Components$Dashboard$Review$Model$loadInvoiceInformation,
			A2(
				$author$project$Forward$Lookup$map,
				A2(
					$elm$core$Basics$composeR,
					getIds,
					$elm$core$List$map(
						function (invoice) {
							return _Utils_Tuple2(invoice.id, invoice.updatedAt);
						})),
				$author$project$Forward$Lookup$identity));
	};
	var loadExceptionedInvoices = function (getIds) {
		return A3(
			$author$project$Forward$Lookup$ifVia,
			A2(
				$author$project$Forward$Lookup$map,
				function ($) {
					return $.carrierId;
				},
				$author$project$Forward$Lookup$identity),
			function (carrierId) {
				return A2($author$project$Id$MaybeSet$member, carrierId, exceptionsExpanded);
			},
			loadInvoices(getIds));
	};
	var loadExceptionedCount = A2(
		$author$project$Forward$Lookup$map,
		function (reviewIdGroup) {
			return $elm$core$List$length(reviewIdGroup.unsentExceptionFactorInvoices) + $elm$core$List$length(reviewIdGroup.waitingExceptionFactorInvoices);
		},
		$author$project$Forward$Lookup$identity);
	return A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.exceptionInvoicesCreatedAt;
			},
			$author$project$Forward$Lookup$identity),
		A2(
			$author$project$Forward$Lookup$apply,
			loadInvoices(
				function ($) {
					return $.replyFactorInvoices;
				}),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToReplyEmailMessages,
				A2(
					$author$project$Forward$Lookup$apply,
					loadExceptionedInvoices(
						function ($) {
							return $.waitingExceptionFactorInvoices;
						}),
					A2(
						$author$project$Forward$Lookup$apply,
						loadExceptionedInvoices(
							function ($) {
								return $.unsentExceptionFactorInvoices;
							}),
						A2(
							$author$project$Forward$Lookup$apply,
							loadExceptionedCount,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToNewEmailMessages,
								A2(
									$author$project$Forward$Lookup$apply,
									loadInvoices(
										function ($) {
											return $.verifyingFactorInvoices;
										}),
									A2(
										$author$project$Forward$Lookup$apply,
										loadInvoices(
											function ($) {
												return $.draftFactorInvoices;
											}),
										A2(
											$author$project$Forward$Lookup$apply,
											loadInvoices(
												function ($) {
													return $.approvableFactorInvoices;
												}),
											$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Review$Model$ClientGroup)))))))))));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToTmsCarrier = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.carrierId;
		}
	});
var $author$project$Components$Dashboard$Review$Model$loadReviewGroupData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.labels;
			},
			$author$project$Forward$Lookup$identity),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$Dashboard$Review$Model$loadClientGroup(model.clientGroupExceptionsExpanded),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToTmsCarrier,
				$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Review$Model$ReviewGroupData))));
};
var $author$project$Components$Dashboard$Review$Model$loadData = F4(
	function (dashboardFilters, model, page, perPage) {
		return A2(
			$author$project$Forward$Lookup$traversePage,
			$author$project$Forward$Lookup$exposeLoadingState(
				$author$project$Components$Dashboard$Review$Model$loadReviewGroupData(model)),
			A2(
				$author$project$Forward$Lookup$map,
				A2($author$project$Pagination$fromList, page, perPage),
				$author$project$Components$Dashboard$Review$Model$loadIds(dashboardFilters)));
	});
var $author$project$Helpers$Date$dateStringTruncatedFromDate = function (date) {
	var year = $elm$core$String$fromInt(
		$justinmimbs$date$Date$year(date) - 2000);
	var month = $elm$core$String$fromInt(
		$author$project$Helpers$Date$monthInt(
			$justinmimbs$date$Date$month(date)));
	var day = $elm$core$String$fromInt(
		$justinmimbs$date$Date$day(date));
	return A2(
		$elm$core$String$join,
		'/',
		_List_fromArray(
			[month, day, year]));
};
var $author$project$Helpers$Date$dateStringTruncated = F2(
	function (tz, date) {
		return $author$project$Helpers$Date$dateStringTruncatedFromDate(
			A2($justinmimbs$date$Date$fromPosix, tz, date));
	});
var $justinmimbs$time_extra$Time$Extra$Day = {$: 'Day'};
var $justinmimbs$time_extra$Time$Extra$Hour = {$: 'Hour'};
var $justinmimbs$time_extra$Time$Extra$Minute = {$: 'Minute'};
var $justinmimbs$time_extra$Time$Extra$Millisecond = {$: 'Millisecond'};
var $justinmimbs$time_extra$Time$Extra$Month = {$: 'Month'};
var $justinmimbs$time_extra$Time$Extra$Week = {$: 'Week'};
var $justinmimbs$date$Date$Day = {$: 'Day'};
var $justinmimbs$date$Date$Friday = {$: 'Friday'};
var $justinmimbs$date$Date$Monday = {$: 'Monday'};
var $justinmimbs$date$Date$Month = {$: 'Month'};
var $justinmimbs$date$Date$Quarter = {$: 'Quarter'};
var $justinmimbs$date$Date$Saturday = {$: 'Saturday'};
var $justinmimbs$date$Date$Sunday = {$: 'Sunday'};
var $justinmimbs$date$Date$Thursday = {$: 'Thursday'};
var $justinmimbs$date$Date$Tuesday = {$: 'Tuesday'};
var $justinmimbs$date$Date$Wednesday = {$: 'Wednesday'};
var $justinmimbs$date$Date$Week = {$: 'Week'};
var $justinmimbs$date$Date$Year = {$: 'Year'};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return $justinmimbs$date$Date$RD(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1);
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date.a;
		switch (interval.$) {
			case 'Year':
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 'Quarter':
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 'Month':
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 'Week':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Mon, date));
			case 'Monday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Mon, date));
			case 'Tuesday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Tue, date));
			case 'Wednesday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Wed, date));
			case 'Thursday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Thu, date));
			case 'Friday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Fri, date));
			case 'Saturday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Sat, date));
			case 'Sunday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Sun, date));
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0.a;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval.$) {
			case 'Millisecond':
				return posix;
			case 'Second':
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 'Minute':
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 'Hour':
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 'Day':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Day, zone, posix);
			case 'Month':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Month, zone, posix);
			case 'Year':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Year, zone, posix);
			case 'Quarter':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Quarter, zone, posix);
			case 'Week':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Week, zone, posix);
			case 'Monday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Monday, zone, posix);
			case 'Tuesday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Tuesday, zone, posix);
			case 'Wednesday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Wednesday, zone, posix);
			case 'Thursday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Thursday, zone, posix);
			case 'Friday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Friday, zone, posix);
			case 'Saturday':
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Saturday, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, $justinmimbs$date$Date$Sunday, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(
	function (zone, posix) {
		return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
	});
var $justinmimbs$time_extra$Time$Extra$toMonths = F2(
	function (zone, posix) {
		var wholeMonths = (12 * (A2($elm$time$Time$toYear, zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber(
			A2($elm$time$Time$toMonth, zone, posix)) - 1);
		var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
		return wholeMonths + fractionalMonth;
	});
var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$time_extra$Time$Extra$diff = F4(
	function (interval, zone, posix1, posix2) {
		diff:
		while (true) {
			switch (interval.$) {
				case 'Millisecond':
					return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
				case 'Second':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Millisecond, zone, posix1, posix2) / 1000) | 0;
				case 'Minute':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Millisecond, zone, posix1, posix2) / 60000) | 0;
				case 'Hour':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Millisecond, zone, posix1, posix2) / 3600000) | 0;
				case 'Day':
					return (A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1)) | 0;
				case 'Month':
					return (A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1)) | 0;
				case 'Year':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Month, zone, posix1, posix2) / 12) | 0;
				case 'Quarter':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Month, zone, posix1, posix2) / 3) | 0;
				case 'Week':
					return (A4($justinmimbs$time_extra$Time$Extra$diff, $justinmimbs$time_extra$Time$Extra$Day, zone, posix1, posix2) / 7) | 0;
				default:
					var weekday = interval;
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Week,
						$temp$zone = zone,
						$temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
						$temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
					interval = $temp$interval;
					zone = $temp$zone;
					posix1 = $temp$posix1;
					posix2 = $temp$posix2;
					continue diff;
			}
		}
	});
var $author$project$Components$Dashboard$ExceptionedRow$View$getAge = F3(
	function (tz, currentDate, createdAt) {
		var getDiff = function (interval) {
			return A4($justinmimbs$time_extra$Time$Extra$diff, interval, tz, createdAt, currentDate);
		};
		var ageString = F2(
			function (interval, units) {
				if (getDiff(interval) === 1) {
					if (interval.$ === 'Hour') {
						return 'an' + units;
					} else {
						return 'a' + units;
					}
				} else {
					return $elm$core$String$fromInt(
						getDiff(interval)) + (units + 's');
				}
			});
		return (getDiff($justinmimbs$time_extra$Time$Extra$Day) >= 1) ? A2(ageString, $justinmimbs$time_extra$Time$Extra$Day, ' day') : ((getDiff($justinmimbs$time_extra$Time$Extra$Hour) >= 1) ? A2(ageString, $justinmimbs$time_extra$Time$Extra$Hour, ' hour') : ((getDiff($justinmimbs$time_extra$Time$Extra$Minute) >= 1) ? A2(ageString, $justinmimbs$time_extra$Time$Extra$Minute, ' minute') : 'a few seconds'));
	});
var $author$project$Components$Dashboard$RowHelper$getRelativeDeliveredAt = F3(
	function (tz, currentDate, deliveredAt) {
		var getDiff = function (interval) {
			return A4($justinmimbs$time_extra$Time$Extra$diff, interval, tz, deliveredAt, currentDate);
		};
		var ageString = F2(
			function (interval, units) {
				return (getDiff(interval) === 1) ? ('a' + units) : ($elm$core$String$fromInt(
					getDiff(interval)) + (units + 's'));
			});
		return (getDiff($justinmimbs$time_extra$Time$Extra$Day) >= 1) ? A2(ageString, $justinmimbs$time_extra$Time$Extra$Day, ' day') : '';
	});
var $author$project$Ui$V3$Colors$Gray600 = {$: 'Gray600'};
var $author$project$Ui$V3$Stack$StyleAttribute = function (a) {
	return {$: 'StyleAttribute', a: a};
};
var $author$project$Ui$V3$Stack$style = F2(
	function (key, value) {
		return $author$project$Ui$V3$Stack$StyleAttribute(
			_Utils_Tuple2(key, value));
	});
var $author$project$Components$Dashboard$DashboardRow$View$nextReviewTextV3Reskin = function (maybeNextReviewOn) {
	return A2(
		$elm$core$Maybe$map,
		function (nextReviewOn) {
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Stack$style, 'white-space', 'nowrap'),
						A2(
						$author$project$Ui$V3$Stack$style,
						'color',
						$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray600))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Review on:'),
						$elm$html$Html$text(
						$author$project$Helpers$Date$dateStringFromDate(nextReviewOn))
					]));
		},
		maybeNextReviewOn);
};
var $author$project$Ui$V3$Colors$Gray400 = {$: 'Gray400'};
var $author$project$Helpers$Date$timeStringNoPadding = F2(
	function (tz, date) {
		var minutes = A3(
			$elm$core$String$padLeft,
			2,
			_Utils_chr('0'),
			$elm$core$String$fromInt(
				A2($elm$time$Time$toMinute, tz, date)));
		var hour = (!A2(
			$elm$core$Basics$modBy,
			12,
			A2($elm$time$Time$toHour, tz, date))) ? '12' : $elm$core$String$fromInt(
			A2(
				$elm$core$Basics$modBy,
				12,
				A2($elm$time$Time$toHour, tz, date)));
		var am_pm = (A2($elm$time$Time$toHour, tz, date) < 12) ? 'AM' : 'PM';
		return hour + (':' + (minutes + (' ' + am_pm)));
	});
var $author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin = F2(
	function (tz, maybeDate) {
		if (maybeDate.$ === 'Just') {
			var date = maybeDate.a;
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Stack$style, 'white-space', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Helpers$Date$dateStringTruncated, tz, date)),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray400)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Helpers$Date$timeStringNoPadding, tz, date))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Ui$V3$Stack$viewVertMaybes = F2(
	function (attributes, maybeChildren) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			attributes,
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeChildren));
	});
var $author$project$Components$Dashboard$ExceptionedRow$View$getLazyQueueDateInfosAndColumns = F2(
	function (dashboardMode, queue) {
		var showDateDelivered = _Utils_eq(dashboardMode, $author$project$AuditPb$DashboardModeAudit);
		var applyQueueDateAndDefault = function (_v11) {
			var queueDateAndDefault = _v11.a;
			var toInfosAndColumns = _v11.b;
			return _Utils_Tuple2(
				queueDateAndDefault,
				function (accountSettings) {
					return A2(
						$elm$core$Tuple$mapFirst,
						function (_v10) {
							var tooltip = _v10.tooltip;
							var name = _v10.name;
							return {_default: queueDateAndDefault.b, name: name, queueDate: queueDateAndDefault.a, tooltip: tooltip};
						},
						toInfosAndColumns(accountSettings));
				});
		};
		var dateDelivered = showDateDelivered ? $elm$core$Maybe$Just(
			applyQueueDateAndDefault(
				_Utils_Tuple2(
					_Utils_Tuple2($author$project$AuditPb$QueueDateDelivered, true),
					function (_v8) {
						return _Utils_Tuple2(
							{name: 'Date delivered', tooltip: $elm$core$Maybe$Nothing},
							F2(
								function (config, _v9) {
									var row = _v9.a;
									return A2(
										$author$project$Ui$V3$Stack$viewVertMaybes,
										_List_Nil,
										_List_fromArray(
											[
												$elm$core$Maybe$Just(
												A2($author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin, config.tz, row.ownerData.deliveredAt)),
												A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A3(
													$elm$core$Maybe$map2,
													$author$project$Components$Dashboard$RowHelper$getRelativeDeliveredAt(config.tz),
													config.currentDate,
													row.ownerData.deliveredAt))
											]));
								}));
					}))) : $elm$core$Maybe$Nothing;
		var exceptionAgeReviewOn = applyQueueDateAndDefault(
			_Utils_Tuple2(
				_Utils_Tuple2($author$project$AuditPb$QueueDateReceived, !showDateDelivered),
				function (accountSettings) {
					var nextReviewOn = F2(
						function (_v7, row) {
							return $author$project$Components$Dashboard$DashboardRow$View$nextReviewTextV3Reskin(
								A2(
									$elm$core$Maybe$map,
									$justinmimbs$date$Date$fromPosix($elm$time$Time$utc),
									row.exceptionedItem.nextReviewOn));
						});
					var firstMessageReceivedAt = F2(
						function (config, row) {
							return $elm$core$Maybe$Just(
								A2($author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin, config.tz, row.exceptionedItem.firstReceivedAt));
						});
					var createdAt = F2(
						function (config, row) {
							return A2(
								$elm$core$Maybe$map,
								$elm$html$Html$text,
								A3(
									$elm$core$Maybe$map2,
									$author$project$Components$Dashboard$ExceptionedRow$View$getAge(config.tz),
									config.currentDate,
									row.exceptionedItem.createdAt));
						});
					var _v2 = function () {
						var _v3 = _Utils_Tuple2(accountSettings.showDateReceivedOnExceptionAndWaiting, queue);
						if (_v3.a) {
							if (_v3.b.$ === 'WaitingQueue') {
								var _v4 = _v3.b;
								return _Utils_Tuple3(
									'Date received',
									'Time that these messages were received and the date when this item should be reviewed.',
									_List_fromArray(
										[firstMessageReceivedAt, nextReviewOn]));
							} else {
								return _Utils_Tuple3(
									'Date received',
									'Time that these messages were received.',
									_List_fromArray(
										[firstMessageReceivedAt]));
							}
						} else {
							if (_v3.b.$ === 'WaitingQueue') {
								var _v5 = _v3.b;
								return _Utils_Tuple3(
									'Exception age',
									'Time since these exceptions were saved. If provided, the date when this item should be reviewed.',
									_List_fromArray(
										[createdAt, nextReviewOn]));
							} else {
								return _Utils_Tuple3(
									'Exception age',
									'Time since these exceptions were saved.',
									_List_fromArray(
										[createdAt]));
							}
						}
					}();
					var name = _v2.a;
					var tooltip = _v2.b;
					var content = _v2.c;
					return _Utils_Tuple2(
						{
							name: name,
							tooltip: $elm$core$Maybe$Just(tooltip)
						},
						F2(
							function (config, _v6) {
								var row = _v6.a;
								return A2(
									$author$project$Ui$V3$Stack$viewVertMaybes,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (c) {
											return A2(c, config, row);
										},
										content));
							}));
				}));
		var lastContact = applyQueueDateAndDefault(
			_Utils_Tuple2(
				_Utils_Tuple2($author$project$AuditPb$QueueDateLastContact, false),
				function (_v0) {
					return _Utils_Tuple2(
						{
							name: 'Last contact',
							tooltip: $elm$core$Maybe$Just('Last message sent or received about this item')
						},
						F2(
							function (config, _v1) {
								var row = _v1.a;
								return $elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Helpers$Date$dateStringTruncated(config.tz),
											row.exceptionedItem.lastSentAt)));
							}));
				}));
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(lastContact),
					dateDelivered,
					$elm$core$Maybe$Just(exceptionAgeReviewOn)
				]));
	});
var $author$project$Components$Dashboard$CarrierInvoiceRow$View$getQueueDateInfosAndColumns = function () {
	var estimatedDueDate = _Utils_Tuple2(
		{_default: false, name: 'Estimated due date', queueDate: $author$project$AuditPb$QueueDateEstimatedDue, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (config, row) {
				return A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin,
					config.tz,
					A2(
						$author$project$Helpers$List$foldl1,
						$author$project$Helpers$Date$min,
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.estimatedDueDate;
							},
							row.emailAndReplyMessages)));
			}));
	var dateReceived = _Utils_Tuple2(
		{_default: false, name: 'Date received', queueDate: $author$project$AuditPb$QueueDateReceived, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (config, row) {
				return A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin,
					config.tz,
					A2(
						$author$project$Helpers$List$foldl1,
						$author$project$Helpers$Date$min,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.createdAt;
							},
							row.emailAndReplyMessages)));
			}));
	var dateDelivered = _Utils_Tuple2(
		{_default: true, name: 'Date delivered', queueDate: $author$project$AuditPb$QueueDateDelivered, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (config, row) {
				return A2(
					$author$project$Ui$V3$Stack$viewVertMaybes,
					_List_Nil,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2($author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin, config.tz, row.deliveredAt)),
							A2(
							$elm$core$Maybe$map,
							$elm$html$Html$text,
							A3(
								$elm$core$Maybe$map2,
								$author$project$Components$Dashboard$RowHelper$getRelativeDeliveredAt(config.tz),
								config.currentDate,
								row.deliveredAt))
						]));
			}));
	return _List_fromArray(
		[dateReceived, dateDelivered, estimatedDueDate]);
}();
var $author$project$Components$Dashboard$EmailRow$View$getQueueDateInfosAndColumns = function () {
	var estimatedDueDate = _Utils_Tuple2(
		{_default: false, name: 'Estimated due date', queueDate: $author$project$AuditPb$QueueDateEstimatedDue, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (config, row) {
				return A2($author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin, config.tz, row.emailMessage.estimatedDueDate);
			}));
	var dateReceived = _Utils_Tuple2(
		{_default: true, name: 'Date received', queueDate: $author$project$AuditPb$QueueDateReceived, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (config, row) {
				return A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin,
					config.tz,
					$elm$core$Maybe$Just(row.emailMessage.createdAt));
			}));
	return _List_fromArray(
		[dateReceived, estimatedDueDate]);
}();
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$displayDateV3Reskin = function (maybeDate) {
	if (maybeDate.$ === 'Just') {
		var date = maybeDate.a;
		return $elm$html$Html$text(
			$author$project$Helpers$Date$dateStringTruncatedFromDate(date));
	} else {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Invalid Date')
				]));
	}
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$getQueueDateInfosAndColumns = function () {
	var paymentDate = _Utils_Tuple2(
		{_default: false, name: 'Payment date', queueDate: $author$project$AuditPb$QueueDatePayment, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (_v0, row) {
				return $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$displayDateV3Reskin(row.dateToPay);
			}));
	var dateProcessed = _Utils_Tuple2(
		{_default: false, name: 'Date processed', queueDate: $author$project$AuditPb$QueueDateProcessed, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (config, row) {
				return A2($author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin, config.tz, row.processedAt);
			}));
	var dateDelivered = _Utils_Tuple2(
		{_default: true, name: 'Date delivered', queueDate: $author$project$AuditPb$QueueDateDelivered, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (config, row) {
				return A2(
					$author$project$Ui$V3$Stack$viewVertMaybes,
					_List_Nil,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2($author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin, config.tz, row.deliveredAt)),
							A2(
							$elm$core$Maybe$map,
							$elm$html$Html$text,
							A3(
								$elm$core$Maybe$map2,
								$author$project$Components$Dashboard$RowHelper$getRelativeDeliveredAt(config.tz),
								config.currentDate,
								row.deliveredAt))
						]));
			}));
	return _List_fromArray(
		[dateDelivered, paymentDate, dateProcessed]);
}();
var $author$project$Components$Dashboard$ReplyRow$getQueueDateInfosAndColumns = function () {
	var received = _Utils_Tuple2(
		{_default: true, name: 'Received', queueDate: $author$project$AuditPb$QueueDateReceived, tooltip: $elm$core$Maybe$Nothing},
		F2(
			function (config, row) {
				return A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateAreaV3Reskin,
					config.tz,
					$elm$core$Maybe$Just(row.emailMessage.createdAt));
			}));
	return _List_fromArray(
		[received]);
}();
var $author$project$Components$Dashboard$QueueDateInfoHelper$availableForQueueLazy = F2(
	function (dashboardMode, queue) {
		var toLazy = function (queueDateInfosAndColumns) {
			return A2(
				$elm$core$List$map,
				function (queueDateInfo) {
					return _Utils_Tuple2(
						_Utils_Tuple2(queueDateInfo.queueDate, queueDateInfo._default),
						function (_v6) {
							return queueDateInfo;
						});
				},
				A2($elm$core$List$map, $elm$core$Tuple$first, queueDateInfosAndColumns));
		};
		var lazyExceptionRows = A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond(
				F2(
					function (toQueueDateInfoAndColumns, accountSettings) {
						return toQueueDateInfoAndColumns(accountSettings).a;
					})),
			A2($author$project$Components$Dashboard$ExceptionedRow$View$getLazyQueueDateInfosAndColumns, dashboardMode, queue));
		switch (queue.$) {
			case 'NewQueue':
				return toLazy($author$project$Components$Dashboard$EmailRow$View$getQueueDateInfosAndColumns);
			case 'ReadyToAuditQueue':
				return toLazy($author$project$Components$Dashboard$CarrierInvoiceRow$View$getQueueDateInfosAndColumns);
			case 'ExceptionQueue':
				return lazyExceptionRows;
			case 'WaitingQueue':
				return _Utils_ap(
					lazyExceptionRows,
					_List_fromArray(
						[
							_Utils_Tuple2(
							_Utils_Tuple2($author$project$AuditPb$QueueDateReviewOn, false),
							function (_v1) {
								return {_default: false, name: 'Review on', queueDate: $author$project$AuditPb$QueueDateReviewOn, tooltip: $elm$core$Maybe$Nothing};
							})
						]));
			case 'RepliesQueue':
				return toLazy($author$project$Components$Dashboard$ReplyRow$getQueueDateInfosAndColumns);
			case 'FactorNeedsIndexingQueue':
				return _List_Nil;
			case 'VerifyQueue':
				return _List_Nil;
			default:
				switch (queue.a.$) {
					case 'ReviewQueue':
						var _v3 = queue.a;
						return _List_Nil;
					case 'ProcessedQueue':
						if (queue.a.a.$ === 'BrokerAccount') {
							var _v2 = queue.a.a;
							return toLazy($author$project$Components$Dashboard$Processed$ProcessedBrokerRow$getQueueDateInfosAndColumns);
						} else {
							var _v4 = queue.a.a;
							return _List_Nil;
						}
					default:
						var _v5 = queue.a;
						return _List_Nil;
				}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$orList = function (maybes) {
	orList:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (maybes.a.$ === 'Nothing') {
				var _v1 = maybes.a;
				var rest = maybes.b;
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue orList;
			} else {
				var answer = maybes.a.a;
				return $elm$core$Maybe$Just(answer);
			}
		}
	}
};
var $author$project$Components$Dashboard$QueueDateInfoHelper$applyFallbackQueueDatesForDashboardFilters = F3(
	function (dashboardMode, queue, dashboardFilters) {
		var rangeType = dashboardFilters.rangeType;
		var dashboardSortBy = dashboardFilters.dashboardSortBy;
		var queueDatesAndDefaults = A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2($author$project$Components$Dashboard$QueueDateInfoHelper$availableForQueueLazy, dashboardMode, queue));
		var fallbackQueueDate = function (currentQueueDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Domain$QueueDate$default,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$elm_community$maybe_extra$Maybe$Extra$orList(
						_List_fromArray(
							[
								A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v0) {
									var queueDate = _v0.a;
									return _Utils_eq(queueDate, currentQueueDate);
								},
								queueDatesAndDefaults),
								A2($elm_community$list_extra$List$Extra$find, $elm$core$Tuple$second, queueDatesAndDefaults)
							]))));
		};
		return _Utils_update(
			dashboardFilters,
			{
				dashboardSortBy: _Utils_update(
					dashboardSortBy,
					{
						name: $author$project$Domain$QueueDate$toString(
							fallbackQueueDate(
								$author$project$Domain$QueueDate$fromString(dashboardSortBy.name)))
					}),
				rangeType: fallbackQueueDate(rangeType),
				reskinToggle: $elm$core$Maybe$Just(true)
			});
	});
var $author$project$Components$Dashboard$QueueDateInfoHelper$maybeApplyFallbackQueueDatesForDashboardFilters = F4(
	function (dashboardMode, queue, dashboardFilters, v3ReskinEnabled) {
		return v3ReskinEnabled ? A3($author$project$Components$Dashboard$QueueDateInfoHelper$applyFallbackQueueDatesForDashboardFilters, dashboardMode, queue, dashboardFilters) : dashboardFilters;
	});
var $author$project$Components$Dashboard$DashboardRows$loadData = F2(
	function (v3ReskinEnabled, loaderArgs) {
		var dashboardFilters = A4($author$project$Components$Dashboard$QueueDateInfoHelper$maybeApplyFallbackQueueDatesForDashboardFilters, loaderArgs.dashboardMode, loaderArgs.queue, loaderArgs.dashboardFilters, v3ReskinEnabled);
		var _v0 = loaderArgs.queue;
		switch (_v0.$) {
			case 'NewQueue':
				return $author$project$Forward$Lookup$exposeLoadingState(
					A2(
						$author$project$Forward$Lookup$map,
						$author$project$Components$Dashboard$DashboardRows$NewEmailData,
						A2(
							$author$project$Forward$Lookup$startFrom,
							$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
							A3($author$project$Components$Dashboard$Load$EmailRows$loadData, loaderArgs.filterByPresence, loaderArgs.requestedActivePage, loaderArgs.perPage))));
			case 'FactorNeedsIndexingQueue':
				return $author$project$Forward$Lookup$exposeLoadingState(
					A2(
						$author$project$Forward$Lookup$map,
						$author$project$Components$Dashboard$DashboardRows$FactorNeedsIndexingData,
						A2(
							$author$project$Forward$Lookup$startFrom,
							$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
							A3($author$project$Components$Dashboard$Load$NeedsIndexingRows$loadData, loaderArgs.filterByPresence, loaderArgs.requestedActivePage, loaderArgs.perPage))));
			case 'ReadyToAuditQueue':
				return $author$project$Forward$Lookup$exposeLoadingState(
					A2(
						$author$project$Forward$Lookup$map,
						$author$project$Components$Dashboard$DashboardRows$ReadyToAuditCarrierInvoiceData,
						A2(
							$author$project$Forward$Lookup$startFrom,
							$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
							A2($author$project$Components$Dashboard$Load$CarrierInvoiceRows$loadData, loaderArgs.requestedActivePage, loaderArgs.perPage))));
			case 'ExceptionQueue':
				return $author$project$Forward$Lookup$exposeLoadingState(
					A2(
						$author$project$Forward$Lookup$map,
						$author$project$Components$Dashboard$DashboardRows$UnsentExceptionedData,
						A2(
							$author$project$Forward$Lookup$startFrom,
							$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
							A3($author$project$Components$Dashboard$Load$ExceptionedRows$loadData, $author$project$Components$Dashboard$Load$ExceptionedRows$Unsent, loaderArgs.requestedActivePage, loaderArgs.perPage))));
			case 'RepliesQueue':
				return $author$project$Forward$Lookup$exposeLoadingState(
					A2(
						$author$project$Forward$Lookup$map,
						$author$project$Components$Dashboard$DashboardRows$ReplyEmailData,
						A2(
							$author$project$Forward$Lookup$startFrom,
							$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
							A3($author$project$Components$Dashboard$Load$ReplyRows$loadData, loaderArgs.filterByPresence, loaderArgs.requestedActivePage, loaderArgs.perPage))));
			case 'WaitingQueue':
				return $author$project$Forward$Lookup$exposeLoadingState(
					A2(
						$author$project$Forward$Lookup$map,
						$author$project$Components$Dashboard$DashboardRows$UnsentExceptionedData,
						A2(
							$author$project$Forward$Lookup$startFrom,
							$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
							A3($author$project$Components$Dashboard$Load$ExceptionedRows$loadData, $author$project$Components$Dashboard$Load$ExceptionedRows$Waiting, loaderArgs.requestedActivePage, loaderArgs.perPage))));
			case 'VerifyQueue':
				return $author$project$Forward$Lookup$exposeLoadingState(
					A2(
						$author$project$Forward$Lookup$map,
						$author$project$Components$Dashboard$DashboardRows$VerifyData,
						A2(
							$author$project$Forward$Lookup$startFrom,
							dashboardFilters,
							A2($author$project$Components$Dashboard$Load$VerifyRows$loadData, loaderArgs.requestedActivePage, loaderArgs.perPage))));
			default:
				switch (_v0.a.$) {
					case 'ReviewQueue':
						var _v1 = _v0.a;
						return $author$project$Forward$Lookup$exposeLoadingState(
							A2(
								$author$project$Forward$Lookup$map,
								$author$project$Components$Dashboard$DashboardRows$ReviewData,
								A4($author$project$Components$Dashboard$Review$Model$loadData, dashboardFilters, loaderArgs.reviewModel, loaderArgs.requestedActivePage, loaderArgs.perPage)));
					case 'ProcessedQueue':
						if (_v0.a.a.$ === 'BrokerAccount') {
							var _v2 = _v0.a.a;
							return $author$project$Forward$Lookup$exposeLoadingState(
								A2(
									$author$project$Forward$Lookup$map,
									$author$project$Components$Dashboard$DashboardRows$ProcessedBrokerData,
									A2(
										$author$project$Forward$Lookup$startFrom,
										$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
										A2($author$project$Components$Dashboard$Processed$BrokerModel$loadData, loaderArgs.requestedActivePage, loaderArgs.perPage))));
						} else {
							var _v3 = _v0.a.a;
							return $author$project$Forward$Lookup$exposeLoadingState(
								A2(
									$author$project$Forward$Lookup$map,
									$author$project$Components$Dashboard$DashboardRows$ProcessedFactorData,
									A2(
										$author$project$Forward$Lookup$startFrom,
										dashboardFilters,
										A3($author$project$Components$Dashboard$Processed$FactorModel$loadData, loaderArgs.factorModel, loaderArgs.requestedActivePage, loaderArgs.perPage))));
						}
					default:
						var _v4 = _v0.a;
						return $author$project$Forward$Lookup$succeed($author$project$Forward$Remote$Loading);
				}
		}
	});
var $author$project$Components$Dashboard$Menu$Data = F2(
	function (accountType, queueCounts) {
		return {accountType: accountType, queueCounts: queueCounts};
	});
var $author$project$Components$Dashboard$Menu$loadAccountType = A2($author$project$Forward$Lookup$map, $author$project$Domain$Account$accountType, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount);
var $author$project$Domain$ReviewIdGroup$getFlat = F2(
	function (field, groups) {
		return A2($elm$core$List$concatMap, field, groups);
	});
var $author$project$Domain$ReviewIdGroup$approvableInvoiceCount = function (reviewIdGroups) {
	return $elm$core$List$length(
		A2(
			$author$project$Domain$ReviewIdGroup$getFlat,
			function ($) {
				return $.approvableFactorInvoices;
			},
			reviewIdGroups));
};
var $author$project$Components$Dashboard$Menu$loadQueueCount = F5(
	function (v3ReskinEnabled, filterByPresence, origDashboardFilters, dashboardMode, queue) {
		var dashboardFilters = A4($author$project$Components$Dashboard$QueueDateInfoHelper$maybeApplyFallbackQueueDatesForDashboardFilters, dashboardMode, queue, origDashboardFilters, v3ReskinEnabled);
		switch (queue.$) {
			case 'NewQueue':
				return A2(
					$author$project$Forward$Lookup$startFrom,
					$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
					A2(
						$author$project$Forward$Lookup$map,
						$elm$core$List$length,
						$author$project$Components$Dashboard$Load$EmailRows$loadIds(filterByPresence)));
			case 'FactorNeedsIndexingQueue':
				return A2(
					$author$project$Forward$Lookup$startFrom,
					$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
					A2(
						$author$project$Forward$Lookup$map,
						$elm$core$List$length,
						$author$project$Components$Dashboard$Load$NeedsIndexingRows$loadIds(filterByPresence)));
			case 'ReadyToAuditQueue':
				return A2(
					$author$project$Forward$Lookup$startFrom,
					$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
					A2($author$project$Forward$Lookup$map, $elm$core$List$length, $author$project$Components$Dashboard$Load$CarrierInvoiceRows$loadIds));
			case 'ExceptionQueue':
				return A2(
					$author$project$Forward$Lookup$startFrom,
					$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
					A2(
						$author$project$Forward$Lookup$map,
						$elm$core$List$length,
						$author$project$Components$Dashboard$Load$ExceptionedRows$loadIds($author$project$Components$Dashboard$Load$ExceptionedRows$Unsent)));
			case 'RepliesQueue':
				return A2(
					$author$project$Forward$Lookup$startFrom,
					$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
					A2(
						$author$project$Forward$Lookup$map,
						$elm$core$List$length,
						$author$project$Components$Dashboard$Load$ReplyRows$loadIds(filterByPresence)));
			case 'WaitingQueue':
				return A2(
					$author$project$Forward$Lookup$startFrom,
					$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
					A2(
						$author$project$Forward$Lookup$map,
						$elm$core$List$length,
						$author$project$Components$Dashboard$Load$ExceptionedRows$loadIds($author$project$Components$Dashboard$Load$ExceptionedRows$Waiting)));
			case 'VerifyQueue':
				return A2(
					$author$project$Forward$Lookup$startFrom,
					dashboardFilters,
					A2(
						$author$project$Forward$Lookup$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$concatMap(
								function ($) {
									return $.itemIds;
								}),
							$elm$core$List$length),
						$author$project$Components$Dashboard$Load$VerifyRows$loadIds));
			default:
				switch (queue.a.$) {
					case 'ProcessedQueue':
						if (queue.a.a.$ === 'BrokerAccount') {
							var _v1 = queue.a.a;
							return A2(
								$author$project$Forward$Lookup$startFrom,
								$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
								A2($author$project$Forward$Lookup$map, $elm$core$List$length, $author$project$Components$Dashboard$Processed$BrokerModel$loadIds));
						} else {
							var _v2 = queue.a.a;
							return A2(
								$author$project$Forward$Lookup$startFrom,
								dashboardFilters,
								A2(
									$author$project$Forward$Lookup$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$concatMap(
											function ($) {
												return $.factorInvoiceIds;
											}),
										$elm$core$List$length),
									$author$project$Components$Dashboard$Processed$FactorModel$loadIds));
						}
					case 'ReviewQueue':
						var _v3 = queue.a;
						return A2(
							$author$project$Forward$Lookup$map,
							$author$project$Domain$ReviewIdGroup$approvableInvoiceCount,
							$author$project$Components$Dashboard$Review$Model$loadIds(dashboardFilters));
					default:
						var _v4 = queue.a;
						return $author$project$Forward$Lookup$fromRemote_INTERNAL_ONLY($author$project$Forward$Remote$Loading);
				}
		}
	});
var $author$project$Components$Dashboard$Menu$loadData = F5(
	function (v3ReskinEnabled, filterByPresence, dashboardFilters, dashboardMode, queues) {
		var loadQueueCountData = function (queue) {
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					A5($author$project$Components$Dashboard$Menu$loadQueueCount, v3ReskinEnabled, filterByPresence, dashboardFilters, dashboardMode, queue)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(queue),
					$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
		};
		return A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$waitForAll(
				A2($elm$core$List$map, loadQueueCountData, queues)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$Dashboard$Menu$loadAccountType,
				$author$project$Forward$Lookup$succeed($author$project$Components$Dashboard$Menu$Data)));
	});
var $author$project$Domain$FactorBrokerSettingsIdsQuery$encode = function (query) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'page',
				$elm$json$Json$Encode$int(query.page)),
				_Utils_Tuple2(
				'term',
				$elm$json$Json$Encode$string(query.term))
			]));
};
var $author$project$Forward$AppSpecific$Cache$page_factorBrokerId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_factorBrokerId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_factorBrokerId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokersBySettingsQuery = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_factorBrokerId,
		entrypoint: 'factorBrokerSettingsIdsByQuery',
		idFromInt: $author$project$Domain$FactorBrokerId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$FactorBrokerSettingsIdsQuery$encode)
	});
var $author$project$Components$DebtorDropdown$DebtorWithAddress = F2(
	function (factorBroker, paymentAddress) {
		return {factorBroker: factorBroker, paymentAddress: paymentAddress};
	});
var $author$project$Components$DebtorDropdown$withAddress = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerToPaymentAddress,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($author$project$Components$DebtorDropdown$DebtorWithAddress)));
var $author$project$Components$DebtorDropdown$loadData = function (_v0) {
	var dropdown = _v0.dropdown;
	return A2(
		$author$project$Components$PaginatedDropdown$loadData,
		function (_v1) {
			var term = _v1.term;
			var page = _v1.page;
			return A2(
				$author$project$Forward$Lookup$traversePage,
				$author$project$Components$DebtorDropdown$withAddress,
				A2(
					$author$project$Forward$Lookup$startFrom,
					{page: page, term: term},
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokersBySettingsQuery));
		},
		dropdown);
};
var $author$project$Components$DashboardPage$loadData = F2(
	function (reskinVals, model) {
		var filterByPresence = {
			dashboardPresence: model.dashboardPresence,
			flowModeRequested: A2($author$project$Components$DashboardPage$flowModeRequested, model.accountSettings, model)
		};
		var exceptionStats = $author$project$Forward$Lookup$exposeLoadingState(
			A4(
				$author$project$Forward$Lookup$ifElseVia,
				$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
				function ($) {
					return $.payablesAccount;
				},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionsByHighestCount,
				$author$project$Forward$Lookup$succeed(_List_Nil)));
		var _v0 = function () {
			var _v1 = model.dashboardFilters.timezoneName;
			if (_v1.$ === 'Nothing') {
				return _Utils_Tuple2(
					$author$project$Forward$Lookup$succeed($author$project$Forward$Remote$Loading),
					$author$project$Forward$Lookup$succeed($author$project$Forward$Remote$Loading));
			} else {
				return _Utils_Tuple2(
					A2(
						$author$project$Components$Dashboard$DashboardRows$loadData,
						reskinVals.queues,
						{dashboardFilters: model.dashboardFilters, dashboardMode: model.dashboardMode, factorModel: model.processedFactorModel, filterByPresence: filterByPresence, perPage: model.perPage, queue: model.selectedQueue, requestedActivePage: model.requestedActivePage, reviewModel: model.reviewModel}),
					$author$project$Forward$Lookup$exposeLoadingState(
						A5($author$project$Components$Dashboard$Menu$loadData, reskinVals.queues, filterByPresence, model.dashboardFilters, model.dashboardMode, model.availableQueues)));
			}
		}();
		var loadDashboardRows = _v0.a;
		var loadMenuData = _v0.b;
		return A2(
			$author$project$Forward$Lookup$apply,
			exceptionStats,
			A2(
				$author$project$Forward$Lookup$apply,
				loadMenuData,
				A2(
					$author$project$Forward$Lookup$apply,
					loadDashboardRows,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Components$DebtorDropdown$loadData(model.debtorDropdown),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Components$CarrierDropdown$loadData(model.carrierDropdown),
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Components$CustomerDropdown$loadData(model.customerDropdown),
								A2(
									$author$project$Forward$Lookup$apply,
									$author$project$Forward$Lookup$exposeLoadingState(
										$author$project$Components$DashboardPage$loadDashboardSavedFilters(model.dashboardMode)),
									A2(
										$author$project$Forward$Lookup$apply,
										$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
										A2(
											$author$project$Forward$Lookup$apply,
											$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
											A2(
												$author$project$Forward$Lookup$apply,
												$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
												$author$project$Forward$Lookup$succeed($author$project$Components$DashboardPage$Data)))))))))));
	});
var $author$project$Components$DocumentBatchReview$Data$Data = F6(
	function (account, accountSettings, documentBatchId, documents, documentPagesByDocument, documentsBrowserData) {
		return {account: account, accountSettings: accountSettings, documentBatchId: documentBatchId, documentPagesByDocument: documentPagesByDocument, documents: documents, documentsBrowserData: documentsBrowserData};
	});
var $author$project$Components$DocumentBatchReviewPage$documentLookups = function (model) {
	var documentsBrowserLookup = $author$project$Forward$Lookup$exposeLoadingState(
		$author$project$Components$DocumentsBrowser$loadData(model.documentsBrowser));
	var documentBatchIdLookup = function (_v1) {
		var documentBatchGroupingReviewId = _v1.documentBatchGroupingReviewId;
		return A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.documentBatchId;
			},
			A2($author$project$Forward$Lookup$startFrom, documentBatchGroupingReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchGroupingReview));
	};
	var pageLookups = function () {
		var _v0 = model.childModel;
		var childModel = _v0.a;
		return {
			documentBatchIdLookup: documentBatchIdLookup(childModel),
			documentLookup: A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId,
				documentBatchIdLookup(childModel))
		};
	}();
	var documentPagesLookup = A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, pageLookups.documentLookup);
	return {documentBatchIdLookup: pageLookups.documentBatchIdLookup, documentLookup: pageLookups.documentLookup, documentPagesLookup: documentPagesLookup, documentsBrowserLookup: documentsBrowserLookup};
};
var $author$project$Components$DocumentBatchReviewPage$loadData = function (model) {
	var lookups = $author$project$Components$DocumentBatchReviewPage$documentLookups(model);
	return A2(
		$author$project$Forward$Lookup$apply,
		lookups.documentsBrowserLookup,
		A2(
			$author$project$Forward$Lookup$apply,
			lookups.documentPagesLookup,
			A2(
				$author$project$Forward$Lookup$apply,
				lookups.documentLookup,
				A2(
					$author$project$Forward$Lookup$apply,
					lookups.documentBatchIdLookup,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
							$author$project$Forward$Lookup$succeed($author$project$Components$DocumentBatchReview$Data$Data)))))));
};
var $author$project$Components$DocumentGroupReview$Data$Data = F3(
	function (documentGroup, documentsBrowserData, reviewData) {
		return {documentGroup: documentGroup, documentsBrowserData: documentsBrowserData, reviewData: reviewData};
	});
var $author$project$Components$DocumentGroupReview$Data$LoadReviewData = function (a) {
	return {$: 'LoadReviewData', a: a};
};
var $author$project$Components$DocumentGroupReviewPage$loadData = function (model) {
	var _v0 = model.childModel;
	var childModel = _v0.a;
	var documentsBrowserLookup = $author$project$Forward$Lookup$exposeLoadingState(
		$author$project$Components$DocumentsBrowser$loadData(childModel.documentsBrowser));
	var documentGroupLoadReviewLookup = A2($author$project$Forward$Lookup$startFrom, childModel.documentGroupLoadReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReview);
	var documentGroupLookup = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReviewToDocumentGroup, documentGroupLoadReviewLookup);
	var reviewDataLookup = A2(
		$author$project$Forward$Lookup$map,
		function (dgLR) {
			return $author$project$Components$DocumentGroupReview$Data$LoadReviewData(
				{documentGroupLoadReview: dgLR});
		},
		documentGroupLoadReviewLookup);
	return A2(
		$author$project$Forward$Lookup$apply,
		reviewDataLookup,
		A2(
			$author$project$Forward$Lookup$apply,
			documentsBrowserLookup,
			A2(
				$author$project$Forward$Lookup$apply,
				documentGroupLookup,
				$author$project$Forward$Lookup$succeed($author$project$Components$DocumentGroupReview$Data$Data))));
};
var $author$project$Components$DocumentReviewPage$Data = F6(
	function (document, documentPages, documentsBrowserData, multiPageBolReviewData, documentTypeReviewData, documentLoadReferenceMatchReviewData) {
		return {document: document, documentLoadReferenceMatchReviewData: documentLoadReferenceMatchReviewData, documentPages: documentPages, documentTypeReviewData: documentTypeReviewData, documentsBrowserData: documentsBrowserData, multiPageBolReviewData: multiPageBolReviewData};
	});
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$Data = F2(
	function (documentLoadReferenceMatchReview, tmsLoadDetails) {
		return {documentLoadReferenceMatchReview: documentLoadReferenceMatchReview, tmsLoadDetails: tmsLoadDetails};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReviewToTmsLoad = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoad,
		fieldName: 'tmsLoad',
		getId: function ($) {
			return $.tmsLoadId;
		}
	});
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$loadData = function (model) {
	var documentLoadReferenceMatchReviewLookup = A2($author$project$Forward$Lookup$startFrom, model.documentLoadReferenceMatchReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReview);
	var tmsLoadLookup = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReviewToTmsLoad, documentLoadReferenceMatchReviewLookup);
	var tmsLoadDetailsLookup = A2(
		$author$project$Forward$Lookup$traverse,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetails,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.id;
			},
			A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadStateByTmsLoadId,
				A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.id;
					},
					tmsLoadLookup))));
	return A2(
		$author$project$Forward$Lookup$apply,
		tmsLoadDetailsLookup,
		A2(
			$author$project$Forward$Lookup$apply,
			documentLoadReferenceMatchReviewLookup,
			$author$project$Forward$Lookup$succeed($author$project$Components$DocumentLoadReferenceMatchReviewPage$Data)));
};
var $author$project$Components$DocumentTypeReviewPage$Data = F2(
	function (documentTypeReview, documentTypeSettings) {
		return {documentTypeReview: documentTypeReview, documentTypeSettings: documentTypeSettings};
	});
var $author$project$Components$DocumentTypeReviewPage$loadData = function (model) {
	var documentTypeReviewLookup = A2($author$project$Forward$Lookup$startFrom, model.documentTypeReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReview);
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			documentTypeReviewLookup,
			$author$project$Forward$Lookup$succeed($author$project$Components$DocumentTypeReviewPage$Data)));
};
var $author$project$Components$MultiPageBolReviewPage$Data = F3(
	function (multiPageBolReview, document, documentPages) {
		return {document: document, documentPages: documentPages, multiPageBolReview: multiPageBolReview};
	});
var $author$project$Components$MultiPageBolReviewPage$loadData = function (model) {
	var multiPageBolReviewLookup = A2($author$project$Forward$Lookup$startFrom, model.multiPageBolReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReview);
	var documentLookup = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReviewToDocument, multiPageBolReviewLookup);
	var documentPagesLookup = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, documentLookup);
	return A2(
		$author$project$Forward$Lookup$apply,
		documentPagesLookup,
		A2(
			$author$project$Forward$Lookup$apply,
			documentLookup,
			A2(
				$author$project$Forward$Lookup$apply,
				multiPageBolReviewLookup,
				$author$project$Forward$Lookup$succeed($author$project$Components$MultiPageBolReviewPage$Data))));
};
var $author$project$Components$DocumentReviewPage$loadData = function (model) {
	var lookups = function () {
		var _v0 = model.childModel;
		switch (_v0.$) {
			case 'InvoiceNumberReviewPage':
				var childModel = _v0.a;
				return {
					documentLoadReferenceMatchReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
					documentLookup: A2(
						$author$project$Forward$Lookup$traverse,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceNumberReviewToDocument,
						A2($author$project$Forward$Lookup$startFrom, childModel.invoiceNumberReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceNumberReview)),
					documentTypeReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
					multiPageBolReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing)
				};
			case 'InvoiceAmountReviewPage':
				var childModel = _v0.a;
				return {
					documentLoadReferenceMatchReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
					documentLookup: A2(
						$author$project$Forward$Lookup$traverse,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceAmountReviewToDocument,
						A2($author$project$Forward$Lookup$startFrom, childModel.invoiceAmountReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceAmountReview)),
					documentTypeReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
					multiPageBolReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing)
				};
			case 'MultiPageBolReviewPage':
				var childModel = _v0.a;
				return {
					documentLoadReferenceMatchReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
					documentLookup: A2(
						$author$project$Forward$Lookup$traverse,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReviewToDocument,
						A2($author$project$Forward$Lookup$startFrom, childModel.multiPageBolReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReview)),
					documentTypeReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
					multiPageBolReviewDataLookup: A2(
						$author$project$Forward$Lookup$map,
						$elm$core$Maybe$Just,
						$author$project$Components$MultiPageBolReviewPage$loadData(childModel))
				};
			case 'DocumentTypeReviewPage':
				var childModel = _v0.a;
				return {
					documentLoadReferenceMatchReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
					documentLookup: A2(
						$author$project$Forward$Lookup$traverse,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReviewToDocument,
						A2($author$project$Forward$Lookup$startFrom, childModel.documentTypeReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReview)),
					documentTypeReviewDataLookup: A2(
						$author$project$Forward$Lookup$map,
						$elm$core$Maybe$Just,
						$author$project$Components$DocumentTypeReviewPage$loadData(childModel)),
					multiPageBolReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing)
				};
			default:
				var childModel = _v0.a;
				return {
					documentLoadReferenceMatchReviewDataLookup: A2(
						$author$project$Forward$Lookup$map,
						$elm$core$Maybe$Just,
						$author$project$Components$DocumentLoadReferenceMatchReviewPage$loadData(childModel)),
					documentLookup: A2(
						$author$project$Forward$Lookup$traverse,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReviewToDocument,
						A2($author$project$Forward$Lookup$startFrom, childModel.documentLoadReferenceMatchReviewId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReview)),
					documentTypeReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing),
					multiPageBolReviewDataLookup: $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing)
				};
		}
	}();
	var documentPagesLookup = A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, lookups.documentLookup);
	return A2(
		$author$project$Forward$Lookup$apply,
		lookups.documentLoadReferenceMatchReviewDataLookup,
		A2(
			$author$project$Forward$Lookup$apply,
			lookups.documentTypeReviewDataLookup,
			A2(
				$author$project$Forward$Lookup$apply,
				lookups.multiPageBolReviewDataLookup,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$exposeLoadingState(
						$author$project$Components$DocumentsBrowser$loadData(model.documentsBrowser)),
					A2(
						$author$project$Forward$Lookup$apply,
						documentPagesLookup,
						A2(
							$author$project$Forward$Lookup$apply,
							lookups.documentLookup,
							$author$project$Forward$Lookup$succeed($author$project$Components$DocumentReviewPage$Data)))))));
};
var $author$project$Components$EmailMessageSearchPage$Data = F2(
	function (filtersUiState, emailMessageListView) {
		return {emailMessageListView: emailMessageListView, filtersUiState: filtersUiState};
	});
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$Data = F4(
	function (account, accountSettings, emailMessagesStream, currentUser) {
		return {account: account, accountSettings: accountSettings, currentUser: currentUser, emailMessagesStream: emailMessagesStream};
	});
var $author$project$AuditPb$emailMessageIdsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page),
					A3($author$project$AuditPb$optionalEncoder, 'term', $elm$json$Json$Encode$string, v.term),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'tms_carrier_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCarrierId$toInt),
					v.tmsCarrierId),
					A3($author$project$AuditPb$optionalEncoder, 'start_date', $elm$json$Json$Encode$string, v.startDate),
					A3($author$project$AuditPb$optionalEncoder, 'end_date', $elm$json$Json$Encode$string, v.endDate),
					A3($author$project$AuditPb$optionalEncoder, 'start_date_time', $elm$json$Json$Encode$string, v.startDateTime),
					A3($author$project$AuditPb$optionalEncoder, 'end_date_time', $elm$json$Json$Encode$string, v.endDateTime),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'include_sent_emails', $elm$json$Json$Encode$bool, v.includeSentEmails)
				])));
};
var $author$project$Domain$EmailMessageIdsQuery$encode = function (query) {
	return $author$project$AuditPb$emailMessageIdsQueryEncoder(query);
};
var $author$project$Forward$AppSpecific$Cache$stream_emailMessageId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.stream_emailMessageId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{stream_emailMessageId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageIdsStreamByQuery = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$stream_emailMessageId,
		decoder: $author$project$Stream$decoder($author$project$Domain$EmailMessageId$fromInt),
		entrypoint: 'emailMessageIdsStreamByQuery',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$EmailMessageIdsQuery$encode)
	});
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$Data = F4(
	function (emailMessage, documentBatch, tmsCarrier, currentUser) {
		return {currentUser: currentUser, documentBatch: documentBatch, emailMessage: emailMessage, tmsCarrier: tmsCarrier};
	});
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$emailMessageToData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$identity,
				$author$project$Forward$Lookup$succeed($author$project$Components$EmailMessageSearchPage$EmailMessageView$Data)))));
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$loadData = A2($author$project$Forward$Lookup$traverse, $author$project$Components$EmailMessageSearchPage$EmailMessageView$emailMessageToData, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage);
var $author$project$Components$CarrierTypeahead$selectedId = $author$project$Typeahead$selectedId;
var $author$project$Components$EmailMessageSearchPage$FiltersView$selectedCarrierId = F2(
	function (v3Reskin, model) {
		return v3Reskin ? $elm$core$List$head(
			$author$project$Components$SettingsPage$CarrierDropdown$selectedIds(model.carrierDropdown)) : $author$project$Components$CarrierTypeahead$selectedId(model.carrierTypeahead);
	});
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$loadData = function (config) {
	var filters = config.filters;
	var emailMessagesQuery = {
		endDate: A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, filters.endDate),
		endDateTime: A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, filters.endDateTime),
		includeSentEmails: filters.includeSentEmails,
		page: config.page,
		startDate: A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, filters.startDate),
		startDateTime: A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, filters.startDateTime),
		term: filters.selectedSearchTerm,
		tmsCarrierId: A2($author$project$Components$EmailMessageSearchPage$FiltersView$selectedCarrierId, config.v3Reskin, filters)
	};
	var emailMessagesQueries = config.v3Reskin ? A2(
		$elm$core$List$map,
		function (p) {
			return _Utils_update(
				emailMessagesQuery,
				{page: p});
		},
		A2($elm$core$List$range, 0, config.page)) : _List_fromArray(
		[emailMessagesQuery]);
	var emailMessageDetails = $author$project$Forward$Lookup$exposeLoadingState($author$project$Components$EmailMessageSearchPage$EmailMessageView$loadData);
	var emailMessages = A2(
		$author$project$Forward$Lookup$traverseStream,
		emailMessageDetails,
		A2(
			$author$project$Forward$Lookup$map,
			$author$project$Stream$concat,
			A2($author$project$Forward$Lookup$startFromList, emailMessagesQueries, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageIdsStreamByQuery)));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			emailMessages,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					$author$project$Forward$Lookup$succeed($author$project$Components$EmailMessageSearchPage$EmailMessageListView$Data)))));
};
var $author$project$Components$EmailMessageSearchPage$FiltersView$Data = F3(
	function (account, carrierTypeaheadData, carrierDropdownData) {
		return {account: account, carrierDropdownData: carrierDropdownData, carrierTypeaheadData: carrierTypeaheadData};
	});
var $author$project$Components$EmailMessageSearchPage$FiltersView$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$SettingsPage$CarrierDropdown$loadData(model.carrierDropdown),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$CarrierTypeahead$loadDataAllCarriers(model.carrierTypeahead),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				$author$project$Forward$Lookup$succeed($author$project$Components$EmailMessageSearchPage$FiltersView$Data))));
};
var $author$project$Components$EmailMessageSearchPage$loadData = F2(
	function (v3Reskin, model) {
		var emailMessageListViewLookup = function () {
			var _v0 = model.filtersApplied;
			if (_v0.$ === 'Nothing') {
				return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
			} else {
				var filters = _v0.a;
				return A2(
					$author$project$Forward$Lookup$map,
					$elm$core$Maybe$Just,
					$author$project$Components$EmailMessageSearchPage$EmailMessageListView$loadData(
						{filters: filters, page: model.page, v3Reskin: v3Reskin}));
			}
		}();
		return A2(
			$author$project$Forward$Lookup$apply,
			emailMessageListViewLookup,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$EmailMessageSearchPage$FiltersView$loadData(model.filtersUiState),
				$author$project$Forward$Lookup$succeed($author$project$Components$EmailMessageSearchPage$Data)));
	});
var $author$project$Components$FactorInvoiceAuditBatchGroupingPage$loadData = function (_v0) {
	return $author$project$Forward$Lookup$succeed(_Utils_Tuple0);
};
var $author$project$Components$FactorInvoiceAuditBatchPage$Data = F4(
	function (workingArea, documentsBrowserData, verificationTab, packetComparison) {
		return {documentsBrowserData: documentsBrowserData, packetComparison: packetComparison, verificationTab: verificationTab, workingArea: workingArea};
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$Data = F5(
	function (comparison, mine, duplicates, pairings, pathContext) {
		return {comparison: comparison, duplicates: duplicates, mine: mine, pairings: pairings, pathContext: pathContext};
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$Closed = {$: 'Closed'};
var $author$project$Components$FactorInvoiceAuditPacketComparison$Open = F2(
	function (a, b) {
		return {$: 'Open', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$packetDocument = F3(
	function (account, accountSettings, resolved) {
		var documentType = $author$project$Domain$Document$documentTypeValueToUnresolved(resolved.document.documentTypeValue);
		return {
			documentType: $author$project$Domain$UnresolvedDocumentType$serialize(documentType),
			pages: A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var page = _v0.a;
					var lines = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (url) {
							return {id: page.id, lines: lines, url: url};
						},
						page.previewUrl);
				},
				A2($elm_community$list_extra$List$Extra$zip, resolved.pages, resolved.lines)),
			title: A3($author$project$Domain$Helpers$documentTypeToString, account, accountSettings, documentType)
		};
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$row = F3(
	function (account, accountSettings, resolved) {
		return {
			mine: A2(
				$elm$core$Maybe$map,
				A2($author$project$Components$FactorInvoiceAuditPacketComparison$packetDocument, account, accountSettings),
				resolved.mine),
			pagesScored: resolved.pagesScored,
			similarities: resolved.similarities,
			theirs: A2(
				$elm$core$Maybe$map,
				A2($author$project$Components$FactorInvoiceAuditPacketComparison$packetDocument, account, accountSettings),
				resolved.theirs)
		};
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$labelled = F3(
	function (account, accountSettings, resolved) {
		return {
			overlapFloor: resolved.overlapFloor,
			rows: A2(
				$elm$core$List$map,
				A2($author$project$Components$FactorInvoiceAuditPacketComparison$row, account, accountSettings),
				resolved.rows)
		};
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$query = F2(
	function (factorInvoiceId, model) {
		if (model.$ === 'NotComparing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var selection = model.a;
			return $elm$core$Maybe$Just(
				{factorInvoiceId: factorInvoiceId, otherInvoiceId: selection.otherInvoiceId});
		}
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$ResolvedPairing = F2(
	function (rows, overlapFloor) {
		return {overlapFloor: overlapFloor, rows: rows};
	});
var $author$project$Forward$AppSpecific$Cache$factorInvoiceDocumentPacketComparison = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.factorInvoiceDocumentPacketComparison;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{factorInvoiceDocumentPacketComparison: e});
		}));
var $author$project$AuditPb$FactorInvoiceDocumentPacketComparison = F2(
	function (rows, reportedOverlapFloor) {
		return {reportedOverlapFloor: reportedOverlapFloor, rows: rows};
	});
var $author$project$AuditPb$DocumentPacketComparisonRow = F4(
	function (documentId, otherDocumentId, pageSimilarities, pagesScored) {
		return {documentId: documentId, otherDocumentId: otherDocumentId, pageSimilarities: pageSimilarities, pagesScored: pagesScored};
	});
var $author$project$AuditPb$DocumentPacketPageSimilarity = F4(
	function (documentPageId, otherDocumentPageId, identical, wordOverlap) {
		return {documentPageId: documentPageId, identical: identical, otherDocumentPageId: otherDocumentPageId, wordOverlap: wordOverlap};
	});
var $author$project$AuditPb$documentPacketPageSimilarityDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'word_overlap',
			$author$project$AuditPb$floatValueDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'identical',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'other_document_page_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentPageId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'document_page_id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentPageId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$DocumentPacketPageSimilarity)))));
	});
var $author$project$AuditPb$documentPacketComparisonRowDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'pages_scored',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$repeated,
				'page_similarities',
				$author$project$AuditPb$documentPacketPageSimilarityDecoder,
				A3(
					$author$project$AuditPb$optional,
					'other_document_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$optional,
						'document_id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$DocumentPacketComparisonRow)))));
	});
var $author$project$AuditPb$factorInvoiceDocumentPacketComparisonDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'reported_overlap_floor',
			$author$project$AuditPb$floatValueDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'rows',
				$author$project$AuditPb$documentPacketComparisonRowDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceDocumentPacketComparison)));
	});
var $author$project$AuditPb$factorInvoiceDocumentPacketComparisonQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factor_invoice_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'other_invoice_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.otherInvoiceId)
				])));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceDocumentPacketComparison = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$factorInvoiceDocumentPacketComparison,
		decoder: $author$project$AuditPb$factorInvoiceDocumentPacketComparisonDecoder,
		entrypoint: 'factorInvoiceDocumentPacketComparison',
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$factorInvoiceDocumentPacketComparisonQueryEncoder)
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$ResolvedRow = F4(
	function (mine, theirs, similarities, pagesScored) {
		return {mine: mine, pagesScored: pagesScored, similarities: similarities, theirs: theirs};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPacketComparisonRowToMaybeDocument = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'document',
		getId: function ($) {
			return $.documentId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPacketComparisonRowToMaybeOtherDocument = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'otherDocument',
		getId: function ($) {
			return $.otherDocumentId;
		}
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$ResolvedDocument = F3(
	function (document, pages, lines) {
		return {document: document, lines: lines, pages: pages};
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$resolvedDocument = A2(
	$author$project$Forward$Lookup$apply,
	A2(
		$author$project$Forward$Lookup$traverseList,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId,
		A2(
			$author$project$Forward$Lookup$map,
			$elm$core$List$map(
				function ($) {
					return $.id;
				}),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages)),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditPacketComparison$ResolvedDocument))));
var $author$project$Components$FactorInvoiceAuditPacketComparison$resolvedRow = A2(
	$author$project$Forward$Lookup$apply,
	A2(
		$author$project$Forward$Lookup$map,
		function ($) {
			return $.pagesScored;
		},
		$author$project$Forward$Lookup$identity),
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.pageSimilarities;
			},
			$author$project$Forward$Lookup$identity),
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$traverseMaybe, $author$project$Components$FactorInvoiceAuditPacketComparison$resolvedDocument, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPacketComparisonRowToMaybeOtherDocument),
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Forward$Lookup$traverseMaybe, $author$project$Components$FactorInvoiceAuditPacketComparison$resolvedDocument, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPacketComparisonRowToMaybeDocument),
				$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditPacketComparison$ResolvedRow)))));
var $author$project$Components$FactorInvoiceAuditPacketComparison$resolvedPairing = A2(
	$author$project$Forward$Lookup$traverse,
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.reportedOverlapFloor;
			},
			$author$project$Forward$Lookup$identity),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$traverseList,
				$author$project$Components$FactorInvoiceAuditPacketComparison$resolvedRow,
				A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.rows;
					},
					$author$project$Forward$Lookup$identity)),
			$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditPacketComparison$ResolvedPairing))),
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceDocumentPacketComparison);
var $author$project$Components$FactorInvoiceAuditPacketComparison$comparisonLookup = F2(
	function (factorInvoiceId, model) {
		return A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$startFromMaybe,
				A2($author$project$Components$FactorInvoiceAuditPacketComparison$query, factorInvoiceId, model),
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$FactorInvoiceAuditPacketComparison$resolvedPairing)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					$author$project$Forward$Lookup$succeed(
						F3(
							function (account, accountSettings, remotePairing) {
								var _v0 = _Utils_Tuple2(model, remotePairing);
								if ((_v0.a.$ === 'Comparing') && (_v0.b.$ === 'Just')) {
									var selection = _v0.a.a;
									var pairing = _v0.b.a;
									return A2(
										$author$project$Components$FactorInvoiceAuditPacketComparison$Open,
										selection,
										A2(
											$author$project$Forward$Remote$map,
											A2($author$project$Components$FactorInvoiceAuditPacketComparison$labelled, account, accountSettings),
											pairing));
								} else {
									return $author$project$Components$FactorInvoiceAuditPacketComparison$Closed;
								}
							})))));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$detailsFor = function (invoiceRow) {
	return {
		amount: A2(
			$elm$core$Maybe$map,
			function (amount) {
				return '$' + amount;
			},
			invoiceRow.invoice.formattedAmount),
		debtorName: invoiceRow.debtorName,
		invoiceDate: A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$format('MM/dd/yyyy'),
			invoiceRow.invoice.invoiceDate),
		invoiceNumber: invoiceRow.invoice.invoiceNumber,
		loadId: invoiceRow.invoice.loadId
	};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$choiceFor = function (invoiceRow) {
	return {
		details: $author$project$Components$FactorInvoiceDuplicatePacketComparison$detailsFor(invoiceRow),
		id: invoiceRow.invoice.id
	};
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$duplicateFactorInvoicesByFactorInvoiceId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_factorInvoiceId,
		decoder: $author$project$Domain$FactorInvoiceId$decode,
		entrypoint: 'duplicateFactorInvoiceIdsByFactorInvoiceId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$DuplicateInvoiceRow = F3(
	function (invoice, debtorName, carrierName) {
		return {carrierName: carrierName, debtorName: debtorName, invoice: invoice};
	});
var $author$project$Components$FactorInvoiceAudit$DuplicateInvoices$row = A2(
	$author$project$Forward$Lookup$apply,
	A2(
		$author$project$Forward$Lookup$map,
		$elm$core$Maybe$map(
			function ($) {
				return $.name;
			}),
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier),
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			$elm$core$Maybe$map(
				function ($) {
					return $.name;
				}),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$DuplicateInvoiceRow))));
var $author$project$Components$FactorInvoiceAudit$DuplicateInvoices$lookup = function (factorInvoiceId) {
	return A2(
		$author$project$Forward$Lookup$startFrom,
		factorInvoiceId,
		A2($author$project$Forward$Lookup$traverseList, $author$project$Components$FactorInvoiceAudit$DuplicateInvoices$row, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$duplicateFactorInvoicesByFactorInvoiceId));
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$duplicateChoicesLookup = function (factorInvoiceId) {
	return A2(
		$author$project$Forward$Lookup$map,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Forward$Remote$toMaybe,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault(_List_Nil),
				$elm$core$List$map($author$project$Components$FactorInvoiceDuplicatePacketComparison$choiceFor))),
		$author$project$Forward$Lookup$exposeLoadingState(
			$author$project$Components$FactorInvoiceAudit$DuplicateInvoices$lookup(factorInvoiceId)));
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$myDetailsLookup = function (factorInvoiceId) {
	return A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$startFrom,
			factorInvoiceId,
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
			$author$project$Forward$Lookup$succeed(
				F2(
					function (invoice, debtor) {
						return $author$project$Components$FactorInvoiceDuplicatePacketComparison$detailsFor(
							{
								debtorName: A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.name;
									},
									debtor),
								invoice: invoice
							});
					}))));
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$pairingsLookup = F2(
	function (factorInvoiceId, model) {
		if (model.$ === 'NotComparing') {
			return $author$project$Forward$Lookup$succeed($elm$core$Dict$empty);
		} else {
			return A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$startFrom,
					factorInvoiceId,
					A2(
						$author$project$Forward$Lookup$traverseList,
						A3(
							$author$project$Forward$Lookup$map2,
							$elm$core$Tuple$pair,
							A2(
								$author$project$Forward$Lookup$map,
								function ($) {
									return $.otherInvoiceId;
								},
								$author$project$Forward$Lookup$identity),
							$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$FactorInvoiceAuditPacketComparison$resolvedPairing)),
						A2(
							$author$project$Forward$Lookup$map,
							$elm$core$List$map(
								function (duplicate) {
									return {factorInvoiceId: factorInvoiceId, otherInvoiceId: duplicate.id};
								}),
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$duplicateFactorInvoicesByFactorInvoiceId))),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
						$author$project$Forward$Lookup$succeed(
							F3(
								function (account, accountSettings, pairings) {
									return $elm$core$Dict$fromList(
										A2(
											$elm$core$List$map,
											function (_v1) {
												var otherInvoiceId = _v1.a;
												var pairing = _v1.b;
												return _Utils_Tuple2(
													$author$project$Domain$FactorInvoiceId$toInt(otherInvoiceId),
													A2(
														$author$project$Forward$Remote$map,
														A2($author$project$Components$FactorInvoiceAuditPacketComparison$labelled, account, accountSettings),
														pairing));
											},
											pairings));
								})))));
		}
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$pathContextLookup = function (factorInvoiceId) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
			$author$project$Forward$Lookup$succeed(
				F2(
					function (invoice, settings) {
						return {
							isReadonly: $author$project$Domain$FactorInvoice$readOnly(invoice.state),
							useFactorInvoiceWorkflowPage: settings.useFactorInvoiceWorkflowPage
						};
					}))));
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$loadData = F2(
	function (factorInvoiceId, model) {
		return A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$FactorInvoiceAuditPacketComparison$pathContextLookup(factorInvoiceId),
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Components$FactorInvoiceAuditPacketComparison$pairingsLookup, factorInvoiceId, model),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Components$FactorInvoiceAuditPacketComparison$duplicateChoicesLookup(factorInvoiceId),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Components$FactorInvoiceAuditPacketComparison$myDetailsLookup(factorInvoiceId),
						A2(
							$author$project$Forward$Lookup$apply,
							A2($author$project$Components$FactorInvoiceAuditPacketComparison$comparisonLookup, factorInvoiceId, model),
							$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditPacketComparison$Data))))));
	});
var $author$project$Components$FactorInvoiceAuditVerificationTab$Data = F3(
	function (verification, assignedDebtor, loadId) {
		return {assignedDebtor: assignedDebtor, loadId: loadId, verification: verification};
	});
var $author$project$Components$FactorInvoiceAuditVerificationTab$loadData = function (factorInvoiceId) {
	return A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$startFrom,
			factorInvoiceId,
			A2(
				$author$project$Forward$Lookup$map,
				function ($) {
					return $.loadId;
				},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$startFrom,
				factorInvoiceId,
				A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$startFrom,
					factorInvoiceId,
					A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToVerification, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
				$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditVerificationTab$Data))));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$Data = function (factorInvoice) {
	return function (auditChecks) {
		return function (assignedCarrier) {
			return function (assignedDebtor) {
				return function (carrierDropdownData) {
					return function (selectedCarrier) {
						return function (debtorDropdownData) {
							return function (selectedDebtor) {
								return function (brokeredCarrierDropdownData) {
									return function (brokeredCarrierTermDropdownData) {
										return function (duplicateInvoices) {
											return function (podDocuments) {
												return function (unidentifiedDocuments) {
													return function (possibleMatches) {
														return {assignedCarrier: assignedCarrier, assignedDebtor: assignedDebtor, auditChecks: auditChecks, brokeredCarrierDropdownData: brokeredCarrierDropdownData, brokeredCarrierTermDropdownData: brokeredCarrierTermDropdownData, carrierDropdownData: carrierDropdownData, debtorDropdownData: debtorDropdownData, duplicateInvoices: duplicateInvoices, factorInvoice: factorInvoice, podDocuments: podDocuments, possibleMatches: possibleMatches, selectedCarrier: selectedCarrier, selectedDebtor: selectedDebtor, unidentifiedDocuments: unidentifiedDocuments};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$FactorInvoiceAuditCheck = F2(
	function (result, details) {
		return {details: details, result: result};
	});
var $author$project$AuditPb$FactorInvoiceAuditCheckResultSkipped = {$: 'FactorInvoiceAuditCheckResultSkipped'};
var $author$project$AuditPb$factorInvoiceAuditCheckResultDefault = $author$project$AuditPb$FactorInvoiceAuditCheckResultSkipped;
var $author$project$AuditPb$FactorInvoiceAuditCheckResultFailed = {$: 'FactorInvoiceAuditCheckResultFailed'};
var $author$project$AuditPb$FactorInvoiceAuditCheckResultIgnored = {$: 'FactorInvoiceAuditCheckResultIgnored'};
var $author$project$AuditPb$FactorInvoiceAuditCheckResultPassed = {$: 'FactorInvoiceAuditCheckResultPassed'};
var $author$project$AuditPb$FactorInvoiceAuditCheckResultPending = {$: 'FactorInvoiceAuditCheckResultPending'};
var $author$project$AuditPb$FactorInvoiceAuditCheckResultResolved = {$: 'FactorInvoiceAuditCheckResultResolved'};
var $author$project$AuditPb$allFactorInvoiceAuditCheckResult = _List_fromArray(
	[$author$project$AuditPb$FactorInvoiceAuditCheckResultSkipped, $author$project$AuditPb$FactorInvoiceAuditCheckResultPassed, $author$project$AuditPb$FactorInvoiceAuditCheckResultFailed, $author$project$AuditPb$FactorInvoiceAuditCheckResultIgnored, $author$project$AuditPb$FactorInvoiceAuditCheckResultResolved, $author$project$AuditPb$FactorInvoiceAuditCheckResultPending]);
var $author$project$AuditPb$factorInvoiceAuditCheckResultToString = function (v) {
	switch (v.$) {
		case 'FactorInvoiceAuditCheckResultSkipped':
			return 'skipped';
		case 'FactorInvoiceAuditCheckResultPassed':
			return 'passed';
		case 'FactorInvoiceAuditCheckResultFailed':
			return 'failed';
		case 'FactorInvoiceAuditCheckResultIgnored':
			return 'ignored';
		case 'FactorInvoiceAuditCheckResultResolved':
			return 'resolved';
		default:
			return 'pending';
	}
};
var $author$project$AuditPb$factorInvoiceAuditCheckResultDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$factorInvoiceAuditCheckResultToString(v),
				v);
		},
		$author$project$AuditPb$allFactorInvoiceAuditCheckResult));
var $author$project$AuditPb$factorInvoiceAuditCheckResultFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$factorInvoiceAuditCheckResultDict);
};
var $author$project$AuditPb$factorInvoiceAuditCheckResultDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$factorInvoiceAuditCheckResultDefault),
		$author$project$AuditPb$factorInvoiceAuditCheckResultFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$FactorInvoiceAuditCheck_Details_ExceptionEvent = function (a) {
	return {$: 'FactorInvoiceAuditCheck_Details_ExceptionEvent', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditRuleCheck = F4(
	function (checkType, failedRules, resolvedRules, ignoredRules) {
		return {checkType: checkType, failedRules: failedRules, ignoredRules: ignoredRules, resolvedRules: resolvedRules};
	});
var $author$project$AuditPb$FactorInvoiceAuditCheckRule = F7(
	function (ruleType, failureType, unskippable, message, ruleEvaluationId, status, confirmable) {
		return {confirmable: confirmable, failureType: failureType, message: message, ruleEvaluationId: ruleEvaluationId, ruleType: ruleType, status: status, unskippable: unskippable};
	});
var $author$project$Domain$RuleEvaluationId$fromInt = $author$project$Id$fromInt;
var $author$project$AuditPb$RuleEvaluationStatusSkipped = {$: 'RuleEvaluationStatusSkipped'};
var $author$project$AuditPb$ruleEvaluationStatusDefault = $author$project$AuditPb$RuleEvaluationStatusSkipped;
var $author$project$AuditPb$RuleEvaluationStatusFailed = {$: 'RuleEvaluationStatusFailed'};
var $author$project$AuditPb$RuleEvaluationStatusIgnored = {$: 'RuleEvaluationStatusIgnored'};
var $author$project$AuditPb$RuleEvaluationStatusPassed = {$: 'RuleEvaluationStatusPassed'};
var $author$project$AuditPb$RuleEvaluationStatusResolved = {$: 'RuleEvaluationStatusResolved'};
var $author$project$AuditPb$allRuleEvaluationStatus = _List_fromArray(
	[$author$project$AuditPb$RuleEvaluationStatusSkipped, $author$project$AuditPb$RuleEvaluationStatusPassed, $author$project$AuditPb$RuleEvaluationStatusFailed, $author$project$AuditPb$RuleEvaluationStatusIgnored, $author$project$AuditPb$RuleEvaluationStatusResolved]);
var $author$project$AuditPb$ruleEvaluationStatusToString = function (v) {
	switch (v.$) {
		case 'RuleEvaluationStatusSkipped':
			return 'skipped';
		case 'RuleEvaluationStatusPassed':
			return 'passed';
		case 'RuleEvaluationStatusFailed':
			return 'failed';
		case 'RuleEvaluationStatusIgnored':
			return 'ignored';
		default:
			return 'resolved';
	}
};
var $author$project$AuditPb$ruleEvaluationStatusDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$ruleEvaluationStatusToString(v),
				v);
		},
		$author$project$AuditPb$allRuleEvaluationStatus));
var $author$project$AuditPb$ruleEvaluationStatusFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$ruleEvaluationStatusDict);
};
var $author$project$AuditPb$ruleEvaluationStatusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$ruleEvaluationStatusDefault),
		$author$project$AuditPb$ruleEvaluationStatusFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$factorInvoiceAuditCheckRuleDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'confirmable',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'status',
				$author$project$AuditPb$ruleEvaluationStatusDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'ruleEvaluationId',
					A2($elm$json$Json$Decode$map, $author$project$Domain$RuleEvaluationId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$optional,
						'message',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'unskippable',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$optional,
								'failureType',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'ruleType',
									$elm$json$Json$Decode$string,
									$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceAuditCheckRule))))))));
	});
var $author$project$AuditPb$FactorInvoiceAuditCheckType = function (check) {
	return {check: check};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierTermsCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierTermsCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_BrokerClientRequirementsCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_BrokerClientRequirementsCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_CarrierRequiredCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_CarrierRequiredCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_ClientDebtorRelationshipCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_ClientDebtorRelationshipCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_DocumentPresenceCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_DocumentPresenceCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_FactorLaneRateCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_FactorLaneRateCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_FundingInstructionsDetectedCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_FundingInstructionsDetectedCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_InvoiceDateCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_InvoiceDateCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_InvoiceDeliveryDateCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_InvoiceDeliveryDateCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_MaxAmountReviewCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_MaxAmountReviewCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_PODRequiredCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_PODRequiredCheck', a: a};
};
var $author$project$AuditPb$FactorInvoiceAuditCheckType_Check_RateConBolConsistencyCheck = function (a) {
	return {$: 'FactorInvoiceAuditCheckType_Check_RateConBolConsistencyCheck', a: a};
};
var $author$project$AuditPb$BrokerClientBrokeredCarrierCheck = {};
var $author$project$AuditPb$brokerClientBrokeredCarrierCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$BrokerClientBrokeredCarrierCheck);
	});
var $author$project$AuditPb$BrokerClientBrokeredCarrierTermsCheck = {};
var $author$project$AuditPb$brokerClientBrokeredCarrierTermsCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$BrokerClientBrokeredCarrierTermsCheck);
	});
var $author$project$AuditPb$BrokerClientRequirementsCheck = {};
var $author$project$AuditPb$brokerClientRequirementsCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$BrokerClientRequirementsCheck);
	});
var $author$project$AuditPb$CarrierRequiredCheck = {};
var $author$project$AuditPb$carrierRequiredCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$CarrierRequiredCheck);
	});
var $author$project$AuditPb$ClientDebtorRelationshipCheck = {};
var $author$project$AuditPb$clientDebtorRelationshipCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$ClientDebtorRelationshipCheck);
	});
var $author$project$AuditPb$DebtorRequiredCheck = F2(
	function (suggestions, noaStatus) {
		return {noaStatus: noaStatus, suggestions: suggestions};
	});
var $author$project$AuditPb$DebtorNoaStatusVerified = {$: 'DebtorNoaStatusVerified'};
var $author$project$AuditPb$debtorNoaStatusDefault = $author$project$AuditPb$DebtorNoaStatusVerified;
var $author$project$AuditPb$DebtorNoaStatusCarrierNotFactored = {$: 'DebtorNoaStatusCarrierNotFactored'};
var $author$project$AuditPb$DebtorNoaStatusNotFactorOfRecord = {$: 'DebtorNoaStatusNotFactorOfRecord'};
var $author$project$AuditPb$DebtorNoaStatusRelationshipMissing = {$: 'DebtorNoaStatusRelationshipMissing'};
var $author$project$AuditPb$allDebtorNoaStatus = _List_fromArray(
	[$author$project$AuditPb$DebtorNoaStatusVerified, $author$project$AuditPb$DebtorNoaStatusNotFactorOfRecord, $author$project$AuditPb$DebtorNoaStatusCarrierNotFactored, $author$project$AuditPb$DebtorNoaStatusRelationshipMissing]);
var $author$project$AuditPb$debtorNoaStatusToString = function (v) {
	switch (v.$) {
		case 'DebtorNoaStatusVerified':
			return 'verified';
		case 'DebtorNoaStatusNotFactorOfRecord':
			return 'not_factor_of_record';
		case 'DebtorNoaStatusCarrierNotFactored':
			return 'carrier_not_factored';
		default:
			return 'relationship_missing';
	}
};
var $author$project$AuditPb$debtorNoaStatusDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$debtorNoaStatusToString(v),
				v);
		},
		$author$project$AuditPb$allDebtorNoaStatus));
var $author$project$AuditPb$debtorNoaStatusFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$debtorNoaStatusDict);
};
var $author$project$AuditPb$debtorNoaStatusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$debtorNoaStatusDefault),
		$author$project$AuditPb$debtorNoaStatusFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$FactorInvoiceAuditCheckSuggestion = F6(
	function (source, value, location, entityId, recommended, reasoning) {
		return {entityId: entityId, location: location, reasoning: reasoning, recommended: recommended, source: source, value: value};
	});
var $author$project$AuditPb$SuggestionSourceClientSubmission = {$: 'SuggestionSourceClientSubmission'};
var $author$project$AuditPb$suggestionSourceDefault = $author$project$AuditPb$SuggestionSourceClientSubmission;
var $author$project$AuditPb$SuggestionSourceAiRecommendation = {$: 'SuggestionSourceAiRecommendation'};
var $author$project$AuditPb$SuggestionSourceBillOfLading = {$: 'SuggestionSourceBillOfLading'};
var $author$project$AuditPb$SuggestionSourceClientInvoice = {$: 'SuggestionSourceClientInvoice'};
var $author$project$AuditPb$SuggestionSourceRateConfirmation = {$: 'SuggestionSourceRateConfirmation'};
var $author$project$AuditPb$allSuggestionSource = _List_fromArray(
	[$author$project$AuditPb$SuggestionSourceClientSubmission, $author$project$AuditPb$SuggestionSourceClientInvoice, $author$project$AuditPb$SuggestionSourceRateConfirmation, $author$project$AuditPb$SuggestionSourceBillOfLading, $author$project$AuditPb$SuggestionSourceAiRecommendation]);
var $author$project$AuditPb$suggestionSourceToString = function (v) {
	switch (v.$) {
		case 'SuggestionSourceClientSubmission':
			return 'clientSubmission';
		case 'SuggestionSourceClientInvoice':
			return 'clientInvoice';
		case 'SuggestionSourceRateConfirmation':
			return 'rateConfirmation';
		case 'SuggestionSourceBillOfLading':
			return 'billOfLading';
		default:
			return 'aiRecommendation';
	}
};
var $author$project$AuditPb$suggestionSourceDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$suggestionSourceToString(v),
				v);
		},
		$author$project$AuditPb$allSuggestionSource));
var $author$project$AuditPb$suggestionSourceFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$suggestionSourceDict);
};
var $author$project$AuditPb$suggestionSourceDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$suggestionSourceDefault),
		$author$project$AuditPb$suggestionSourceFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$factorInvoiceAuditCheckSuggestionDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'reasoning',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'recommended',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$optional,
					'entityId',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optionalMessage,
						'location',
						$author$project$AuditPb$documentLocationDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'value',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'source',
								$author$project$AuditPb$suggestionSourceDecoder,
								$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceAuditCheckSuggestion)))))));
	});
var $author$project$AuditPb$debtorRequiredCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'noaStatus',
			$author$project$AuditPb$debtorNoaStatusDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'suggestions',
				$author$project$AuditPb$factorInvoiceAuditCheckSuggestionDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$DebtorRequiredCheck)));
	});
var $author$project$AuditPb$DocumentPresenceCheck = F2(
	function (requirement, requiredDocumentTypes) {
		return {requiredDocumentTypes: requiredDocumentTypes, requirement: requirement};
	});
var $author$project$AuditPb$DocumentPresenceRequirementRateConfirmationRequired = {$: 'DocumentPresenceRequirementRateConfirmationRequired'};
var $author$project$AuditPb$documentPresenceRequirementDefault = $author$project$AuditPb$DocumentPresenceRequirementRateConfirmationRequired;
var $author$project$AuditPb$DocumentPresenceRequirementBillOfLadingRequired = {$: 'DocumentPresenceRequirementBillOfLadingRequired'};
var $author$project$AuditPb$DocumentPresenceRequirementBrokerRequiredDocuments = {$: 'DocumentPresenceRequirementBrokerRequiredDocuments'};
var $author$project$AuditPb$DocumentPresenceRequirementCarrierInvoiceRequired = {$: 'DocumentPresenceRequirementCarrierInvoiceRequired'};
var $author$project$AuditPb$DocumentPresenceRequirementCarrierRateConfirmationRequired = {$: 'DocumentPresenceRequirementCarrierRateConfirmationRequired'};
var $author$project$AuditPb$DocumentPresenceRequirementClientInvoiceRequired = {$: 'DocumentPresenceRequirementClientInvoiceRequired'};
var $author$project$AuditPb$DocumentPresenceRequirementDebtorVisibleDocumentRequired = {$: 'DocumentPresenceRequirementDebtorVisibleDocumentRequired'};
var $author$project$AuditPb$DocumentPresenceRequirementDocumentsRequired = {$: 'DocumentPresenceRequirementDocumentsRequired'};
var $author$project$AuditPb$DocumentPresenceRequirementPODRequired = {$: 'DocumentPresenceRequirementPODRequired'};
var $author$project$AuditPb$DocumentPresenceRequirementRequireDoctypes = {$: 'DocumentPresenceRequirementRequireDoctypes'};
var $author$project$AuditPb$allDocumentPresenceRequirement = _List_fromArray(
	[$author$project$AuditPb$DocumentPresenceRequirementRateConfirmationRequired, $author$project$AuditPb$DocumentPresenceRequirementBillOfLadingRequired, $author$project$AuditPb$DocumentPresenceRequirementPODRequired, $author$project$AuditPb$DocumentPresenceRequirementDebtorVisibleDocumentRequired, $author$project$AuditPb$DocumentPresenceRequirementClientInvoiceRequired, $author$project$AuditPb$DocumentPresenceRequirementRequireDoctypes, $author$project$AuditPb$DocumentPresenceRequirementDocumentsRequired, $author$project$AuditPb$DocumentPresenceRequirementBrokerRequiredDocuments, $author$project$AuditPb$DocumentPresenceRequirementCarrierInvoiceRequired, $author$project$AuditPb$DocumentPresenceRequirementCarrierRateConfirmationRequired]);
var $author$project$AuditPb$documentPresenceRequirementToString = function (v) {
	switch (v.$) {
		case 'DocumentPresenceRequirementRateConfirmationRequired':
			return 'rate_confirmation_required';
		case 'DocumentPresenceRequirementBillOfLadingRequired':
			return 'bill_of_lading_required';
		case 'DocumentPresenceRequirementPODRequired':
			return 'pod_required';
		case 'DocumentPresenceRequirementDebtorVisibleDocumentRequired':
			return 'debtor_visible_document_required';
		case 'DocumentPresenceRequirementClientInvoiceRequired':
			return 'client_invoice_required';
		case 'DocumentPresenceRequirementRequireDoctypes':
			return 'require_doctypes';
		case 'DocumentPresenceRequirementDocumentsRequired':
			return 'documents_required';
		case 'DocumentPresenceRequirementBrokerRequiredDocuments':
			return 'broker_required_documents';
		case 'DocumentPresenceRequirementCarrierInvoiceRequired':
			return 'carrier_invoice_required';
		default:
			return 'carrier_rate_confirmation_required';
	}
};
var $author$project$AuditPb$documentPresenceRequirementDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$documentPresenceRequirementToString(v),
				v);
		},
		$author$project$AuditPb$allDocumentPresenceRequirement));
var $author$project$AuditPb$documentPresenceRequirementFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$documentPresenceRequirementDict);
};
var $author$project$AuditPb$documentPresenceRequirementDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$documentPresenceRequirementDefault),
		$author$project$AuditPb$documentPresenceRequirementFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$documentPresenceCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'requiredDocumentTypes',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'requirement',
				$author$project$AuditPb$documentPresenceRequirementDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$DocumentPresenceCheck)));
	});
var $author$project$AuditPb$DuplicateInvoiceCheck = F7(
	function (duplicatedInvoiceId, matchedInvoiceNumber, matchedDebtorName, matchedAmount, matchedDate, matchedLoadId, matchedCarrierName) {
		return {duplicatedInvoiceId: duplicatedInvoiceId, matchedAmount: matchedAmount, matchedCarrierName: matchedCarrierName, matchedDate: matchedDate, matchedDebtorName: matchedDebtorName, matchedInvoiceNumber: matchedInvoiceNumber, matchedLoadId: matchedLoadId};
	});
var $author$project$AuditPb$duplicateInvoiceCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'matchedCarrierName',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'matchedLoadId',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'matchedDate',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'matchedAmount',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'matchedDebtorName',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'matchedInvoiceNumber',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$optional,
									'duplicatedInvoiceId',
									A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
									$author$project$AuditPb$decode($author$project$AuditPb$DuplicateInvoiceCheck))))))));
	});
var $author$project$AuditPb$FactorLaneRateCheck = {};
var $author$project$AuditPb$factorLaneRateCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$FactorLaneRateCheck);
	});
var $author$project$AuditPb$FundingInstructionsDetectedCheck = function (text) {
	return {text: text};
};
var $author$project$AuditPb$fundingInstructionsDetectedCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'text',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$FundingInstructionsDetectedCheck));
	});
var $author$project$AuditPb$InvoiceAmountCheck = function (suggestions) {
	return {suggestions: suggestions};
};
var $author$project$AuditPb$invoiceAmountCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'suggestions',
			$author$project$AuditPb$factorInvoiceAuditCheckSuggestionDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$InvoiceAmountCheck));
	});
var $author$project$AuditPb$InvoiceDateCheck = {};
var $author$project$AuditPb$invoiceDateCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$InvoiceDateCheck);
	});
var $author$project$AuditPb$InvoiceDeliveryDateCheck = F5(
	function (deliveryDate, checkDays, invoiceDate, daysSince, deliveryDateSource) {
		return {checkDays: checkDays, daysSince: daysSince, deliveryDate: deliveryDate, deliveryDateSource: deliveryDateSource, invoiceDate: invoiceDate};
	});
var $author$project$AuditPb$invoiceDeliveryDateCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'deliveryDateSource',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'daysSince',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$optional,
					'invoiceDate',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'checkDays',
						$author$project$AuditPb$intDecoder,
						A3(
							$author$project$AuditPb$optional,
							'deliveryDate',
							$elm$json$Json$Decode$string,
							$author$project$AuditPb$decode($author$project$AuditPb$InvoiceDeliveryDateCheck))))));
	});
var $author$project$AuditPb$InvoiceNumberCheck = function (suggestions) {
	return {suggestions: suggestions};
};
var $author$project$AuditPb$invoiceNumberCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'suggestions',
			$author$project$AuditPb$factorInvoiceAuditCheckSuggestionDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$InvoiceNumberCheck));
	});
var $author$project$AuditPb$LoadIdExtractionAndConfirmationCheck = F2(
	function (suggestions, debtorAutofillOffer) {
		return {debtorAutofillOffer: debtorAutofillOffer, suggestions: suggestions};
	});
var $author$project$AuditPb$LoadIdExtractionAndConfirmationCheck_DebtorAutofillOffer = F4(
	function (debtorName, keptPercentage, priorCount, enabled) {
		return {debtorName: debtorName, enabled: enabled, keptPercentage: keptPercentage, priorCount: priorCount};
	});
var $author$project$AuditPb$loadIdExtractionAndConfirmationCheck_DebtorAutofillOfferDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'priorCount',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'keptPercentage',
					$author$project$AuditPb$floatValueDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'debtorName',
						$elm$json$Json$Decode$string,
						$author$project$AuditPb$decode($author$project$AuditPb$LoadIdExtractionAndConfirmationCheck_DebtorAutofillOffer)))));
	});
var $author$project$AuditPb$loadIdExtractionAndConfirmationCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optionalMessage,
			'debtorAutofillOffer',
			$author$project$AuditPb$loadIdExtractionAndConfirmationCheck_DebtorAutofillOfferDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'suggestions',
				$author$project$AuditPb$factorInvoiceAuditCheckSuggestionDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$LoadIdExtractionAndConfirmationCheck)));
	});
var $author$project$AuditPb$MaxAmountReviewCheck = F2(
	function (amount, maxAmount) {
		return {amount: amount, maxAmount: maxAmount};
	});
var $author$project$AuditPb$maxAmountReviewCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'maxAmount',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'amount',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$MaxAmountReviewCheck)));
	});
var $author$project$AuditPb$PODRequiredCheck = {};
var $author$project$AuditPb$podRequiredCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$PODRequiredCheck);
	});
var $author$project$AuditPb$RateConBolConsistencyCheck = {};
var $author$project$AuditPb$rateConBolConsistencyCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$RateConBolConsistencyCheck);
	});
var $author$project$AuditPb$factorInvoiceAuditCheckType_CheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck,
					A2($elm$json$Json$Decode$field, 'invoiceAmount', $author$project$AuditPb$invoiceAmountCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_DocumentPresenceCheck,
					A2($elm$json$Json$Decode$field, 'documentPresence', $author$project$AuditPb$documentPresenceCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_InvoiceDateCheck,
					A2($elm$json$Json$Decode$field, 'invoiceDate', $author$project$AuditPb$invoiceDateCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_CarrierRequiredCheck,
					A2($elm$json$Json$Decode$field, 'carrierRequired', $author$project$AuditPb$carrierRequiredCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck,
					A2($elm$json$Json$Decode$field, 'debtorRequired', $author$project$AuditPb$debtorRequiredCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck,
					A2($elm$json$Json$Decode$field, 'loadIdExtractionAndConfirmation', $author$project$AuditPb$loadIdExtractionAndConfirmationCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck,
					A2($elm$json$Json$Decode$field, 'invoiceNumber', $author$project$AuditPb$invoiceNumberCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck,
					A2($elm$json$Json$Decode$field, 'duplicateInvoiceCheck', $author$project$AuditPb$duplicateInvoiceCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_RateConBolConsistencyCheck,
					A2($elm$json$Json$Decode$field, 'rateConBolConsistency', $author$project$AuditPb$rateConBolConsistencyCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_BrokerClientRequirementsCheck,
					A2($elm$json$Json$Decode$field, 'brokerClientRequirements', $author$project$AuditPb$brokerClientRequirementsCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_FactorLaneRateCheck,
					A2($elm$json$Json$Decode$field, 'factorLaneRate', $author$project$AuditPb$factorLaneRateCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_FundingInstructionsDetectedCheck,
					A2($elm$json$Json$Decode$field, 'fundingInstructionsDetected', $author$project$AuditPb$fundingInstructionsDetectedCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_ClientDebtorRelationshipCheck,
					A2($elm$json$Json$Decode$field, 'clientDebtorRelationship', $author$project$AuditPb$clientDebtorRelationshipCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_InvoiceDeliveryDateCheck,
					A2($elm$json$Json$Decode$field, 'invoiceDeliveryDate', $author$project$AuditPb$invoiceDeliveryDateCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierCheck,
					A2($elm$json$Json$Decode$field, 'brokerClientBrokeredCarrier', $author$project$AuditPb$brokerClientBrokeredCarrierCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierTermsCheck,
					A2($elm$json$Json$Decode$field, 'brokerClientBrokeredCarrierTerms', $author$project$AuditPb$brokerClientBrokeredCarrierTermsCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_PODRequiredCheck,
					A2($elm$json$Json$Decode$field, 'podRequired', $author$project$AuditPb$podRequiredCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheckType_Check_MaxAmountReviewCheck,
					A2($elm$json$Json$Decode$field, 'maxAmountReview', $author$project$AuditPb$maxAmountReviewCheckDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceAuditCheckType_Check_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceAuditCheckTypeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceAuditCheckType_CheckDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceAuditCheckType));
	});
var $author$project$AuditPb$factorInvoiceAuditRuleCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'ignoredRules',
			$author$project$AuditPb$factorInvoiceAuditCheckRuleDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'resolvedRules',
				$author$project$AuditPb$factorInvoiceAuditCheckRuleDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'failedRules',
					$author$project$AuditPb$factorInvoiceAuditCheckRuleDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'checkType',
						$author$project$AuditPb$factorInvoiceAuditCheckTypeDecoder,
						$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceAuditRuleCheck)))));
	});
var $author$project$AuditPb$factorInvoiceAuditCheck_DetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck,
					A2($elm$json$Json$Decode$field, 'ruleCheck', $author$project$AuditPb$factorInvoiceAuditRuleCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceAuditCheck_Details_ExceptionEvent,
					A2($elm$json$Json$Decode$field, 'exceptionEvent', $author$project$AuditPb$exceptionEventDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceAuditCheck_Details_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceAuditCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceAuditCheck_DetailsDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'result',
				$author$project$AuditPb$factorInvoiceAuditCheckResultDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceAuditCheck)));
	});
var $author$project$Forward$AppSpecific$Cache$list_factorInvoiceAuditCheck = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_factorInvoiceAuditCheck;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_factorInvoiceAuditCheck: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceAuditChecks = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_factorInvoiceAuditCheck,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$factorInvoiceAuditCheckDecoder),
		entrypoint: 'factorInvoiceAuditChecks',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$isExpanded = function (_v0) {
	var model = _v0.a;
	return !model.isCollapsed;
};
var $author$project$Forward$AppSpecific$Cache$brokeredCarrier = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.brokeredCarrier;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{brokeredCarrier: e});
		}));
var $author$project$AuditPb$BrokeredCarrier = F4(
	function (id, name, mcNumber, dotNumber) {
		return {dotNumber: dotNumber, id: id, mcNumber: mcNumber, name: name};
	});
var $author$project$Domain$BrokeredCarrierId$BrokeredCarrierId = function (a) {
	return {$: 'BrokeredCarrierId', a: a};
};
var $author$project$Domain$BrokeredCarrierId$fromInt = function (_int) {
	return $author$project$Domain$BrokeredCarrierId$BrokeredCarrierId(_int);
};
var $author$project$AuditPb$brokeredCarrierDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'dot_number',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'mc_number',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$BrokeredCarrierId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$BrokeredCarrier)))));
	});
var $author$project$Domain$BrokeredCarrierId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrier = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$brokeredCarrier,
		decoder: $author$project$AuditPb$brokeredCarrierDecoder,
		entrypoint: 'brokeredCarrier',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$BrokeredCarrierId$toInt)
	});
var $author$project$Domain$BrokeredCarrierSettingsIdsQuery$encode = function (query) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'page',
				$elm$json$Json$Encode$int(query.page)),
				_Utils_Tuple2(
				'term',
				$elm$json$Json$Encode$string(query.term))
			]));
};
var $author$project$Forward$AppSpecific$Cache$page_brokeredCarrierId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_brokeredCarrierId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_brokeredCarrierId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarriersBySettingsQuery = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_brokeredCarrierId,
		entrypoint: 'brokeredCarrierSettingsIdsByQuery',
		idFromInt: $author$project$Domain$BrokeredCarrierId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrier,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$BrokeredCarrierSettingsIdsQuery$encode)
	});
var $author$project$Components$BrokeredCarrierDropdown$loadData = function (_v0) {
	var dropdown = _v0.dropdown;
	return A2(
		$author$project$Components$PaginatedDropdown$loadData,
		function (_v1) {
			var term = _v1.term;
			var page = _v1.page;
			return A2(
				$author$project$Forward$Lookup$startFrom,
				{page: page, term: term},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarriersBySettingsQuery);
		},
		dropdown);
};
var $author$project$Forward$AppSpecific$Cache$brokeredCarrierTerm = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.brokeredCarrierTerm;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{brokeredCarrierTerm: e});
		}));
var $author$project$AuditPb$BrokeredCarrierTerm = F5(
	function (id, name, days, rate, flatRate) {
		return {days: days, flatRate: flatRate, id: id, name: name, rate: rate};
	});
var $author$project$Domain$BrokeredCarrierTermId$BrokeredCarrierTermId = function (a) {
	return {$: 'BrokeredCarrierTermId', a: a};
};
var $author$project$Domain$BrokeredCarrierTermId$fromInt = function (_int) {
	return $author$project$Domain$BrokeredCarrierTermId$BrokeredCarrierTermId(_int);
};
var $author$project$AuditPb$brokeredCarrierTermDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'flat_rate',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'rate',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'days',
					$author$project$AuditPb$intDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$BrokeredCarrierTermId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$BrokeredCarrierTerm))))));
	});
var $author$project$Domain$BrokeredCarrierTermId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrierTerm = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$brokeredCarrierTerm,
		decoder: $author$project$AuditPb$brokeredCarrierTermDecoder,
		entrypoint: 'brokeredCarrierTerm',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$BrokeredCarrierTermId$toInt)
	});
var $author$project$Domain$BrokeredCarrierTermSettingsIdsQuery$encode = function (query) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'page',
				$elm$json$Json$Encode$int(query.page)),
				_Utils_Tuple2(
				'term',
				$elm$json$Json$Encode$string(query.term)),
				_Utils_Tuple2(
				'program_external_id',
				$elm$json$Json$Encode$string(query.programExternalId))
			]));
};
var $author$project$Forward$AppSpecific$Cache$page_brokeredCarrierTermId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_brokeredCarrierTermId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_brokeredCarrierTermId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrierTermsBySettingsQuery = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_brokeredCarrierTermId,
		entrypoint: 'brokeredCarrierTermSettingsIdsByQuery',
		idFromInt: $author$project$Domain$BrokeredCarrierTermId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrierTerm,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$BrokeredCarrierTermSettingsIdsQuery$encode)
	});
var $author$project$Components$BrokeredCarrierTermDropdown$loadData = function (_v0) {
	var programExternalId = _v0.programExternalId;
	var dropdown = _v0.dropdown;
	return A2(
		$author$project$Components$PaginatedDropdown$loadData,
		function (_v1) {
			var term = _v1.term;
			var page = _v1.page;
			return A2(
				$author$project$Forward$Lookup$startFrom,
				{page: page, programExternalId: programExternalId, term: term},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrierTermsBySettingsQuery);
		},
		dropdown);
};
var $author$project$Components$CarrierDropdown$selectedIds = function (model) {
	return A2(
		$elm$core$List$map,
		$author$project$Domain$TmsCarrierId$fromInt,
		A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown))));
};
var $author$project$Components$CarrierDropdown$loadSelectedDetails = function (model) {
	var _v0 = $elm$core$List$head(
		$author$project$Components$CarrierDropdown$selectedIds(model));
	if (_v0.$ === 'Just') {
		var tmsCarrierId = _v0.a;
		return $author$project$Forward$Lookup$exposeLoadingState(
			A2(
				$author$project$Forward$Lookup$map,
				$elm$core$Maybe$Just,
				A2($author$project$Forward$Lookup$startFrom, tmsCarrierId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier)));
	} else {
		return $author$project$Forward$Lookup$succeed(
			$author$project$Forward$Remote$Loaded($elm$core$Maybe$Nothing));
	}
};
var $author$project$Components$DebtorDropdown$selectedIds = function (model) {
	return A2(
		$elm$core$List$map,
		$author$project$Domain$FactorBrokerId$fromInt,
		A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown))));
};
var $author$project$Components$DebtorDropdown$loadSelectedDetails = function (model) {
	var _v0 = $elm$core$List$head(
		$author$project$Components$DebtorDropdown$selectedIds(model));
	if (_v0.$ === 'Just') {
		var factorBrokerId = _v0.a;
		return $author$project$Forward$Lookup$exposeLoadingState(
			A2(
				$author$project$Forward$Lookup$map,
				$elm$core$Maybe$Just,
				A2(
					$author$project$Forward$Lookup$startFrom,
					factorBrokerId,
					A2($author$project$Forward$Lookup$traverse, $author$project$Components$DebtorDropdown$withAddress, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker))));
	} else {
		return $author$project$Forward$Lookup$succeed(
			$author$project$Forward$Remote$Loaded($elm$core$Maybe$Nothing));
	}
};
var $author$project$Forward$Lookup$if_ = F2(
	function (shouldLoad, lookup) {
		return shouldLoad ? A2($author$project$Forward$Lookup$map, $elm$core$Maybe$Just, lookup) : $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
	});
var $author$project$Domain$UnresolvedDocumentType$fromPb = function (unresolvedDocumentType) {
	var _v0 = unresolvedDocumentType.value;
	switch (_v0.$) {
		case 'UnresolvedDocumentType_Value_DocumentType':
			var docType = _v0.a;
			return $author$project$Domain$UnresolvedDocumentType$Resolved(docType);
		case 'UnresolvedDocumentType_Value_DocumentTypePartial':
			var partialDocType = _v0.a;
			return $author$project$Domain$UnresolvedDocumentType$Partial(partialDocType);
		default:
			return $author$project$Domain$UnresolvedDocumentType$Unknown;
	}
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$documentTypeLabel = F3(
	function (account, accountSettings, docType) {
		return A3(
			$author$project$Domain$Helpers$documentTypeToString,
			account,
			accountSettings,
			$author$project$Domain$UnresolvedDocumentType$fromPb(docType.documentType)) + (' (' + ($elm$core$String$fromInt(docType.count) + ')'));
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$matchRow = F3(
	function (account, accountSettings, match) {
		return {
			documentTypeLabels: A2(
				$elm$core$List$map,
				A2($author$project$Components$FactorInvoiceAudit$PossibleMatches$documentTypeLabel, account, accountSettings),
				match.documentTypes),
			match: match
		};
	});
var $author$project$AuditPb$FactorInvoicePossibleMatch = function (id) {
	return function (invoiceNumber) {
		return function (formattedAmount) {
			return function (loadId) {
				return function (debtorName) {
					return function (emailSubject) {
						return function (documentTypes) {
							return function (originMatches) {
								return function (destinationMatches) {
									return function (matchedReferences) {
										return function (emailDate) {
											return function (origin) {
												return function (destination) {
													return {debtorName: debtorName, destination: destination, destinationMatches: destinationMatches, documentTypes: documentTypes, emailDate: emailDate, emailSubject: emailSubject, formattedAmount: formattedAmount, id: id, invoiceNumber: invoiceNumber, loadId: loadId, matchedReferences: matchedReferences, origin: origin, originMatches: originMatches};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$FactorInvoicePossibleMatchDocType = F2(
	function (documentType, count) {
		return {count: count, documentType: documentType};
	});
var $author$project$AuditPb$factorInvoicePossibleMatchDocTypeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'count',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'document_type',
				$author$project$AuditPb$unresolvedDocumentTypeDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoicePossibleMatchDocType)));
	});
var $author$project$AuditPb$factorInvoicePossibleMatchDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'destination',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'origin',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'email_date',
					$author$project$AuditPb$timestampDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'matched_references',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'destination_matches',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'origin_matches',
								$elm$json$Json$Decode$bool,
								A3(
									$author$project$AuditPb$repeated,
									'document_types',
									$author$project$AuditPb$factorInvoicePossibleMatchDocTypeDecoder,
									A3(
										$author$project$AuditPb$optional,
										'email_subject',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$optional,
											'debtor_name',
											$elm$json$Json$Decode$string,
											A3(
												$author$project$AuditPb$optional,
												'load_id',
												$elm$json$Json$Decode$string,
												A3(
													$author$project$AuditPb$optional,
													'formatted_amount',
													$elm$json$Json$Decode$string,
													A3(
														$author$project$AuditPb$optional,
														'invoice_number',
														$elm$json$Json$Decode$string,
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'id',
															A2($elm$json$Json$Decode$map, $author$project$Domain$FactorInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
															$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoicePossibleMatch))))))))))))));
	});
var $author$project$Forward$AppSpecific$Cache$list_factorInvoicePossibleMatch = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_factorInvoicePossibleMatch;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_factorInvoicePossibleMatch: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$possibleMatchesByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_factorInvoicePossibleMatch,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$factorInvoicePossibleMatchDecoder),
		entrypoint: 'possibleMatchesByFactorInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$lookup = F2(
	function (sectionIsExpanded, factorInvoiceId) {
		return $author$project$Forward$Lookup$exposeLoadingState(
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$if_,
					sectionIsExpanded,
					A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$possibleMatchesByFactorInvoiceId)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
						$author$project$Forward$Lookup$succeed(
							F3(
								function (account, accountSettings, matches) {
									return A2(
										$elm$core$List$map,
										A2($author$project$Components$FactorInvoiceAudit$PossibleMatches$matchRow, account, accountSettings),
										A2($elm$core$Maybe$withDefault, _List_Nil, matches));
								}))))));
	});
var $author$project$AuditPb$DocumentPODDefinition = F6(
	function (disposition, isDisplayed, podInferenceChecks, documentId, attemptedReferences, podOverrideCheck) {
		return {attemptedReferences: attemptedReferences, disposition: disposition, documentId: documentId, isDisplayed: isDisplayed, podInferenceChecks: podInferenceChecks, podOverrideCheck: podOverrideCheck};
	});
var $author$project$AuditPb$DocumentPODAttemptedReference = F3(
	function (label, matchedValue, loadValue) {
		return {label: label, loadValue: loadValue, matchedValue: matchedValue};
	});
var $author$project$AuditPb$documentPODAttemptedReferenceDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'load_value',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'matched_value',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'label',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$DocumentPODAttemptedReference))));
	});
var $author$project$AuditPb$DocumentPODDefinitionInferenceCheck = F3(
	function (checkType, passed, applied) {
		return {applied: applied, checkType: checkType, passed: passed};
	});
var $author$project$AuditPb$documentPODDefinitionInferenceCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'applied',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'passed',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'check_type',
					$author$project$AuditPb$documentPODInferenceCheckTypeDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$DocumentPODDefinitionInferenceCheck))));
	});
var $author$project$AuditPb$DocumentPODDefinition_PODOverrideCheck_AutomatedOverrideCheck = function (a) {
	return {$: 'DocumentPODDefinition_PODOverrideCheck_AutomatedOverrideCheck', a: a};
};
var $author$project$AuditPb$DocumentPODDefinition_PODOverrideCheck_ManualOverrideCheck = function (a) {
	return {$: 'DocumentPODDefinition_PODOverrideCheck_ManualOverrideCheck', a: a};
};
var $author$project$AuditPb$DocumentPODDefinition_PODOverrideCheck_NoOverrideCheck = function (a) {
	return {$: 'DocumentPODDefinition_PODOverrideCheck_NoOverrideCheck', a: a};
};
var $author$project$AuditPb$DocumentPODDefinition_AutomatedOverrideCheck = {};
var $author$project$AuditPb$documentPODDefinition_AutomatedOverrideCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DocumentPODDefinition_AutomatedOverrideCheck);
	});
var $author$project$AuditPb$DocumentPODDefinition_ManualOverrideCheck = {};
var $author$project$AuditPb$documentPODDefinition_ManualOverrideCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DocumentPODDefinition_ManualOverrideCheck);
	});
var $author$project$AuditPb$DocumentPODDefinition_NoOverrideCheck = {};
var $author$project$AuditPb$documentPODDefinition_NoOverrideCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DocumentPODDefinition_NoOverrideCheck);
	});
var $author$project$AuditPb$documentPODDefinition_PODOverrideCheckDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentPODDefinition_PODOverrideCheck_NoOverrideCheck,
					A2($elm$json$Json$Decode$field, 'no_override', $author$project$AuditPb$documentPODDefinition_NoOverrideCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentPODDefinition_PODOverrideCheck_ManualOverrideCheck,
					A2($elm$json$Json$Decode$field, 'manual_override', $author$project$AuditPb$documentPODDefinition_ManualOverrideCheckDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentPODDefinition_PODOverrideCheck_AutomatedOverrideCheck,
					A2($elm$json$Json$Decode$field, 'automated_override', $author$project$AuditPb$documentPODDefinition_AutomatedOverrideCheckDecoder)),
					$elm$json$Json$Decode$fail('DocumentPODDefinition_PODOverrideCheck_Unspecified')
				]));
	});
var $author$project$AuditPb$DocumentPODDispositionUnknown = {$: 'DocumentPODDispositionUnknown'};
var $author$project$AuditPb$documentPODDispositionDefault = $author$project$AuditPb$DocumentPODDispositionUnknown;
var $author$project$AuditPb$DocumentPODDispositionKnownNotPOD = {$: 'DocumentPODDispositionKnownNotPOD'};
var $author$project$AuditPb$DocumentPODDispositionKnownPOD = {$: 'DocumentPODDispositionKnownPOD'};
var $author$project$AuditPb$allDocumentPODDisposition = _List_fromArray(
	[$author$project$AuditPb$DocumentPODDispositionUnknown, $author$project$AuditPb$DocumentPODDispositionKnownPOD, $author$project$AuditPb$DocumentPODDispositionKnownNotPOD]);
var $author$project$AuditPb$documentPODDispositionToString = function (v) {
	switch (v.$) {
		case 'DocumentPODDispositionUnknown':
			return 'unknown';
		case 'DocumentPODDispositionKnownPOD':
			return 'known_pod';
		default:
			return 'known_not_pod';
	}
};
var $author$project$AuditPb$documentPODDispositionDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$documentPODDispositionToString(v),
				v);
		},
		$author$project$AuditPb$allDocumentPODDisposition));
var $author$project$AuditPb$documentPODDispositionFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$documentPODDispositionDict);
};
var $author$project$AuditPb$documentPODDispositionDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$documentPODDispositionDefault),
		$author$project$AuditPb$documentPODDispositionFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$documentPODDefinitionDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$documentPODDefinition_PODOverrideCheckDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'attempted_references',
				$author$project$AuditPb$documentPODAttemptedReferenceDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'document_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$repeated,
						'pod_inference_checks',
						$author$project$AuditPb$documentPODDefinitionInferenceCheckDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'is_displayed',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'disposition',
								$author$project$AuditPb$documentPODDispositionDecoder,
								$author$project$AuditPb$decode($author$project$AuditPb$DocumentPODDefinition)))))));
	});
var $author$project$Forward$AppSpecific$Cache$list_documentPODDefinitionByFactorInvoice = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_documentPODDefinitionByFactorInvoice;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_documentPODDefinitionByFactorInvoice: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionsByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentPODDefinitionByFactorInvoice,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$documentPODDefinitionDecoder),
		entrypoint: 'documentPODDefinitionsByFactorInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionToDocument = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		fieldName: 'document',
		getId: function ($) {
			return $.documentId;
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$podDefinitionWithThumbnail = A2(
	$author$project$Forward$Lookup$apply,
	A2(
		$author$project$Forward$Lookup$map,
		$elm$core$List$head,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionToDocument)),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionToDocument,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed(
				F3(
					function (definition, document, maybePage) {
						return _Utils_Tuple3(definition, document, maybePage);
					})))));
var $author$project$Components$FactorInvoiceAuditWorkingArea$podDocument = F5(
	function (account, accountSettings, definition, document, maybePage) {
		return {
			firstPageId: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.id;
				},
				maybePage),
			podDefinition: definition,
			thumbnailUrl: A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.thumbnailUrl;
				},
				maybePage),
			title: A3(
				$author$project$Domain$Helpers$documentTypeToString,
				account,
				accountSettings,
				$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue))
		};
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$podDocumentsLookup = function (model) {
	return $author$project$Forward$Lookup$exposeLoadingState(
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$startFrom,
				model.factorInvoiceId,
				A2($author$project$Forward$Lookup$traverseList, $author$project$Components$FactorInvoiceAuditWorkingArea$podDefinitionWithThumbnail, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionsByFactorInvoiceId)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					$author$project$Forward$Lookup$succeed(
						F3(
							function (account, accountSettings, triples) {
								return A2(
									$elm$core$List$map,
									function (_v0) {
										var definition = _v0.a;
										var document = _v0.b;
										var maybePage = _v0.c;
										return A5($author$project$Components$FactorInvoiceAuditWorkingArea$podDocument, account, accountSettings, definition, document, maybePage);
									},
									triples);
							}))))));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$documentWithFirstPage = A2(
	$author$project$Forward$Lookup$apply,
	A2($author$project$Forward$Lookup$map, $elm$core$List$head, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
var $author$project$Components$FactorInvoiceAuditWorkingArea$isUntyped = function (document) {
	return _Utils_eq(
		$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue),
		$author$project$Domain$UnresolvedDocumentType$Unknown);
};
var $author$project$Domain$Document$guessedDocumentTypeValueToUnresolved = function (documentTypeValue) {
	switch (documentTypeValue.$) {
		case 'Document_GuessedDocumentTypeValue_DocumentType':
			var docType = documentTypeValue.a;
			return $author$project$Domain$UnresolvedDocumentType$Resolved(docType);
		case 'Document_GuessedDocumentTypeValue_DocumentTypePartial':
			var partialDocType = documentTypeValue.a;
			return $author$project$Domain$UnresolvedDocumentType$Partial(partialDocType);
		default:
			return $author$project$Domain$UnresolvedDocumentType$Unknown;
	}
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$guessedDocumentType = function (document) {
	var _v0 = $author$project$Domain$Document$guessedDocumentTypeValueToUnresolved(document.guessedDocumentTypeValue);
	if (_v0.$ === 'Resolved') {
		var documentType = _v0.a;
		return $elm$core$Maybe$Just(documentType);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$unidentifiedDocument = function (_v0) {
	var document = _v0.a;
	var maybePage = _v0.b;
	return A2(
		$elm$core$Maybe$map,
		function (page) {
			return {
				documentId: document.id,
				guessedType: $author$project$Components$FactorInvoiceAuditWorkingArea$guessedDocumentType(document),
				pageId: page.id,
				thumbnailUrl: page.thumbnailUrl
			};
		},
		maybePage);
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$unidentifiedDocumentsLookup = function (model) {
	return $author$project$Forward$Lookup$exposeLoadingState(
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$startFrom,
				model.factorInvoiceId,
				A2(
					$author$project$Forward$Lookup$traverseList,
					$author$project$Components$FactorInvoiceAuditWorkingArea$documentWithFirstPage,
					A2(
						$author$project$Forward$Lookup$map,
						$elm$core$List$filter($author$project$Components$FactorInvoiceAuditWorkingArea$isUntyped),
						$author$project$Forward$Lookup$waitForAllList(
							A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice))))),
			$author$project$Forward$Lookup$succeed(
				$elm$core$List$filterMap($author$project$Components$FactorInvoiceAuditWorkingArea$unidentifiedDocument))));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Components$FactorInvoiceAudit$PossibleMatches$lookup,
			$author$project$Components$FactorInvoiceAudit$PossibleMatches$isExpanded(model.possibleMatchesSection),
			model.factorInvoiceId),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$FactorInvoiceAuditWorkingArea$unidentifiedDocumentsLookup(model),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$FactorInvoiceAuditWorkingArea$podDocumentsLookup(model),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$exposeLoadingState(
						$author$project$Components$FactorInvoiceAudit$DuplicateInvoices$lookup(model.factorInvoiceId)),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Components$BrokeredCarrierTermDropdown$loadData(model.brokeredCarrierTermDropdown),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Components$BrokeredCarrierDropdown$loadData(model.brokeredCarrierDropdown),
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Components$DebtorDropdown$loadSelectedDetails(model.debtorDropdown),
								A2(
									$author$project$Forward$Lookup$apply,
									$author$project$Components$DebtorDropdown$loadData(model.debtorDropdown),
									A2(
										$author$project$Forward$Lookup$apply,
										$author$project$Components$CarrierDropdown$loadSelectedDetails(model.carrierDropdown),
										A2(
											$author$project$Forward$Lookup$apply,
											$author$project$Components$CarrierDropdown$loadData(model.carrierDropdown),
											A2(
												$author$project$Forward$Lookup$apply,
												A2(
													$author$project$Forward$Lookup$startFrom,
													model.factorInvoiceId,
													A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
												A2(
													$author$project$Forward$Lookup$apply,
													A2(
														$author$project$Forward$Lookup$startFrom,
														model.factorInvoiceId,
														A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
													A2(
														$author$project$Forward$Lookup$apply,
														A2(
															$author$project$Forward$Lookup$startFrom,
															_Utils_Tuple2(model.factorInvoiceId, model.auditChecksRequiredAt),
															$author$project$Forward$Lookup$applyTimestampInvalidation($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceAuditChecks)),
														A2(
															$author$project$Forward$Lookup$apply,
															A2($author$project$Forward$Lookup$startFrom, model.factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
															$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditWorkingArea$Data)))))))))))))));
};
var $author$project$Components$FactorInvoiceAuditBatchPage$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(
			A2($author$project$Components$FactorInvoiceAuditPacketComparison$loadData, model.workingArea.factorInvoiceId, model.packetComparison)),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState(
				$author$project$Components$FactorInvoiceAuditVerificationTab$loadData(model.workingArea.factorInvoiceId)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$DocumentsBrowser$loadData(model.documentsBrowser)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$exposeLoadingState(
						$author$project$Components$FactorInvoiceAuditWorkingArea$loadData(model.workingArea)),
					$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditBatchPage$Data)))));
};
var $author$project$Components$FactorInvoiceAuditPage$Data = F4(
	function (workingArea, documentsBrowserData, verificationTab, packetComparison) {
		return {documentsBrowserData: documentsBrowserData, packetComparison: packetComparison, verificationTab: verificationTab, workingArea: workingArea};
	});
var $author$project$Components$FactorInvoiceAuditPage$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(
			A2($author$project$Components$FactorInvoiceAuditPacketComparison$loadData, model.factorInvoiceId, model.packetComparison)),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState(
				$author$project$Components$FactorInvoiceAuditVerificationTab$loadData(model.workingArea.factorInvoiceId)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$DocumentsBrowser$loadData(model.documentsBrowser)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$exposeLoadingState(
						$author$project$Components$FactorInvoiceAuditWorkingArea$loadData(model.workingArea)),
					$author$project$Forward$Lookup$succeed($author$project$Components$FactorInvoiceAuditPage$Data)))));
};
var $author$project$Components$HelpPage$Data = F2(
	function (account, settings) {
		return {account: account, settings: settings};
	});
var $author$project$Components$HelpPage$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
		$author$project$Forward$Lookup$succeed($author$project$Components$HelpPage$Data)));
var $author$project$Components$LtlHeldSubmissionsPage$Data = F3(
	function (ltlPayablesCarrierInvoiceSubmissions, accountSettings, account) {
		return {account: account, accountSettings: accountSettings, ltlPayablesCarrierInvoiceSubmissions: ltlPayablesCarrierInvoiceSubmissions};
	});
var $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmissionImportStatePendingImport = {$: 'LtlPayablesCarrierInvoiceSubmissionImportStatePendingImport'};
var $author$project$Components$LtlHeldSubmissionsPage$LtlPayablesCarrierInvoiceSubmissionData = F3(
	function (submission, maybeTmsLoad, maybeTmsCarrier) {
		return {maybeTmsCarrier: maybeTmsCarrier, maybeTmsLoad: maybeTmsLoad, submission: submission};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissionToMaybeLoadState = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadState,
		fieldName: 'loadStateId',
		getId: function ($) {
			return $.loadStateId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissionToMaybeTmsCarrier = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier,
		fieldName: 'tmsCarrier',
		getId: function ($) {
			return $.tmsCarrierId;
		}
	});
var $author$project$Components$LtlHeldSubmissionsPage$loadLtlPayablesCarrierInvoiceSubmissionData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissionToMaybeTmsCarrier,
	A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$traverseMaybe, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadStateToTmsLoad, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissionToMaybeLoadState),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($author$project$Components$LtlHeldSubmissionsPage$LtlPayablesCarrierInvoiceSubmissionData))));
var $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$LtlPayablesCarrierInvoiceSubmissionId = function (a) {
	return {$: 'LtlPayablesCarrierInvoiceSubmissionId', a: a};
};
var $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$fromInt = function (_int) {
	return $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$LtlPayablesCarrierInvoiceSubmissionId(_int);
};
var $author$project$Forward$AppSpecific$Cache$ltlPayablesCarrierInvoiceSubmission = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.ltlPayablesCarrierInvoiceSubmission;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{ltlPayablesCarrierInvoiceSubmission: e});
		}));
var $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmission = F8(
	function (id, receivedDate, importState, loadStateId, proNumber, scac, tmsCarrierId, documents) {
		return {documents: documents, id: id, importState: importState, loadStateId: loadStateId, proNumber: proNumber, receivedDate: receivedDate, scac: scac, tmsCarrierId: tmsCarrierId};
	});
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateDefault = $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmissionImportStatePendingImport;
var $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmissionImportStateNotSentToImport = {$: 'LtlPayablesCarrierInvoiceSubmissionImportStateNotSentToImport'};
var $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmissionImportStateSentToImport = {$: 'LtlPayablesCarrierInvoiceSubmissionImportStateSentToImport'};
var $author$project$AuditPb$allLtlPayablesCarrierInvoiceSubmissionImportState = _List_fromArray(
	[$author$project$AuditPb$LtlPayablesCarrierInvoiceSubmissionImportStatePendingImport, $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmissionImportStateSentToImport, $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmissionImportStateNotSentToImport]);
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateToString = function (v) {
	switch (v.$) {
		case 'LtlPayablesCarrierInvoiceSubmissionImportStatePendingImport':
			return 'pending_import';
		case 'LtlPayablesCarrierInvoiceSubmissionImportStateSentToImport':
			return 'sent_to_import';
		default:
			return 'not_sent_to_import';
	}
};
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateToString(v),
				v);
		},
		$author$project$AuditPb$allLtlPayablesCarrierInvoiceSubmissionImportState));
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateDict);
};
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateDefault),
		$author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmission_Document = function (documentType) {
	return {documentType: documentType};
};
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmission_DocumentDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'documentType',
			$author$project$AuditPb$documentTypeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$LtlPayablesCarrierInvoiceSubmission_Document));
	});
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'documents',
			$author$project$AuditPb$ltlPayablesCarrierInvoiceSubmission_DocumentDecoder,
			A3(
				$author$project$AuditPb$optional,
				'tmsCarrierId',
				A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
				A3(
					$author$project$AuditPb$optional,
					'scac',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'proNumber',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$optional,
							'loadStateId',
							A2($elm$json$Json$Decode$map, $author$project$Domain$LoadStateId$fromInt, $author$project$AuditPb$intDecoder),
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'importState',
								$author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'receivedDate',
									$author$project$AuditPb$timestampDecoder,
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'id',
										A2($elm$json$Json$Decode$map, $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$fromInt, $author$project$AuditPb$intDecoder),
										$author$project$AuditPb$decode($author$project$AuditPb$LtlPayablesCarrierInvoiceSubmission)))))))));
	});
var $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmission = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$ltlPayablesCarrierInvoiceSubmission,
		decoder: $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionDecoder,
		entrypoint: 'ltlPayablesCarrierInvoiceSubmission',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$toInt)
	});
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateToString);
var $author$project$AuditPb$sortOrderToString = function (v) {
	if (v.$ === 'SortOrderAsc') {
		return 'asc';
	} else {
		return 'desc';
	}
};
var $author$project$AuditPb$sortOrderEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$sortOrderToString);
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionIdsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'importState', $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateEncoder, v.importState),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'pageNumber', $elm$json$Json$Encode$int, v.pageNumber),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'entriesPerPage', $elm$json$Json$Encode$int, v.entriesPerPage),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'sortOrder', $author$project$AuditPb$sortOrderEncoder, v.sortOrder),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'searchTerm', $elm$json$Json$Encode$string, v.searchTerm)
				])));
};
var $author$project$Forward$AppSpecific$Cache$page_ltlPayablesCarrierInvoiceSubmissionId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_ltlPayablesCarrierInvoiceSubmissionId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_ltlPayablesCarrierInvoiceSubmissionId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissions = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_ltlPayablesCarrierInvoiceSubmissionId,
		entrypoint: 'ltlPayablesCarrierInvoiceSubmissionIds',
		idFromInt: $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmission,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionIdsQueryEncoder)
	});
var $author$project$Components$LtlHeldSubmissionsPage$loadData = function (_v0) {
	var searchTerm = _v0.searchTerm;
	var sortOrder = _v0.sortOrder;
	var entriesPerPage = _v0.entriesPerPage;
	var pageNumber = _v0.pageNumber;
	var loadLtlPayablesCarrierInvoiceSubmissions = A2(
		$author$project$Forward$Lookup$traversePage,
		$author$project$Components$LtlHeldSubmissionsPage$loadLtlPayablesCarrierInvoiceSubmissionData,
		A2(
			$author$project$Forward$Lookup$startFrom,
			{entriesPerPage: entriesPerPage, importState: $author$project$AuditPb$LtlPayablesCarrierInvoiceSubmissionImportStatePendingImport, pageNumber: pageNumber, searchTerm: searchTerm, sortOrder: sortOrder},
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissions));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				loadLtlPayablesCarrierInvoiceSubmissions,
				$author$project$Forward$Lookup$succeed($author$project$Components$LtlHeldSubmissionsPage$Data))));
};
var $author$project$Components$LtlReconcileInvoicePage$Data = F7(
	function (tmsLoadDetailsData, carrierInvoice, documentsBrowserData, equalityData, accountSettings, mismatchTableData, currentUser) {
		return {accountSettings: accountSettings, carrierInvoice: carrierInvoice, currentUser: currentUser, documentsBrowserData: documentsBrowserData, equalityData: equalityData, mismatchTableData: mismatchTableData, tmsLoadDetailsData: tmsLoadDetailsData};
	});
var $author$project$Components$LtlReconcileInvoicePage$TmsLoadDetailsData = F3(
	function (tmsLoadDetails, carrier, customer) {
		return {carrier: carrier, customer: customer, tmsLoadDetails: tmsLoadDetails};
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$Data = F3(
	function (equalityData, accountSettings, carrierInvoice) {
		return {accountSettings: accountSettings, carrierInvoice: carrierInvoice, equalityData: equalityData};
	});
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$ItemPair = F2(
	function (state, metadata) {
		return {metadata: metadata, state: state};
	});
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$LtlPayablesCarrierAndLoadItemEqualityData = F2(
	function (lineItemPairs, shippedItemPairs) {
		return {lineItemPairs: lineItemPairs, shippedItemPairs: shippedItemPairs};
	});
var $author$project$Domain$LineItem$LineItem = F7(
	function (description, rateQualifier, rate, quantity, total, externalId, id) {
		return {description: description, externalId: externalId, id: id, quantity: quantity, rate: rate, rateQualifier: rateQualifier, total: total};
	});
var $author$project$Money$Money = function (a) {
	return {$: 'Money', a: a};
};
var $author$project$Money$fromCents = function (cents) {
	return $author$project$Money$Money(cents);
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 'Err') {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 'Err') {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (maybe.$ === 'Just') {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Helpers$String$toIntResult = function (string) {
	return A2(
		$elm$core$Result$fromMaybe,
		'Couldn\u0027t convert ' + (string + ' to an integer.'),
		$elm$core$String$toInt(string));
};
var $author$project$Money$fromString = function (string) {
	var provideSign = function (cents) {
		return A2($elm$core$String$startsWith, '-', string) ? (-cents) : cents;
	};
	var isNotSymbol = function (_char) {
		return (!_Utils_eq(
			_char,
			_Utils_chr(','))) && ((!_Utils_eq(
			_char,
			_Utils_chr('$'))) && (!_Utils_eq(
			_char,
			_Utils_chr('-'))));
	};
	var filterSymbols = $elm$core$String$filter(isNotSymbol);
	var _v0 = A2(
		$elm$core$List$map,
		filterSymbols,
		A2($elm$core$String$split, '.', string));
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.b.b) {
				if (!_v0.b.b.b) {
					var ds = _v0.a;
					var _v1 = _v0.b;
					var cs = _v1.a;
					return ($elm$core$String$length(cs) > 2) ? $elm$core$Result$Err('Invalid format ' + string) : A3(
						$elm$core$Result$map2,
						F2(
							function (dollars, cents) {
								return $author$project$Money$fromCents(
									provideSign((dollars * 100) + cents));
							}),
						$author$project$Helpers$String$toIntResult(ds),
						$author$project$Helpers$String$toIntResult(
							A3(
								$elm$core$String$padRight,
								2,
								_Utils_chr('0'),
								cs)));
				} else {
					break _v0$2;
				}
			} else {
				var ds = _v0.a;
				return A2(
					$elm$core$Result$map,
					function (dollars) {
						return $author$project$Money$fromCents(
							provideSign(dollars * 100));
					},
					$author$project$Helpers$String$toIntResult(ds));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err('Could not convert ' + string);
};
var $author$project$Money$zero = $author$project$Money$Money(0);
var $author$project$Money$castFromString = A2(
	$elm$core$Basics$composeR,
	$author$project$Money$fromString,
	$elm$core$Result$withDefault($author$project$Money$zero));
var $author$project$Domain$LineItemId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$LineItemId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Domain$LineItem$withDefault = F2(
	function (fallbackValue, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(fallbackValue),
			$elm$json$Json$Decode$maybe(decoder));
	});
var $author$project$Domain$LineItem$decode = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$LineItemId$decode),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		A2(
			$author$project$Domain$LineItem$withDefault,
			'',
			A2($elm$json$Json$Decode$field, 'external_id', $elm$json$Json$Decode$string)),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2(
				$elm$json$Json$Decode$field,
				'total',
				A2($elm$json$Json$Decode$map, $author$project$Money$castFromString, $elm$json$Json$Decode$string)),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'quantity', $elm$json$Json$Decode$string)),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Money$castFromString,
						A2(
							$author$project$Domain$LineItem$withDefault,
							'',
							A2($elm$json$Json$Decode$field, 'rate', $elm$json$Json$Decode$string))),
					A2(
						$author$project$Helpers$Json$Decode$apply,
						A2(
							$author$project$Domain$LineItem$withDefault,
							'',
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['tms_data', 'rate_qualifier']),
								$elm$json$Json$Decode$string)),
						A2(
							$author$project$Helpers$Json$Decode$apply,
							A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Domain$LineItem$LineItem))))))));
var $author$project$Domain$TmsShippedItem$TmsShippedItem = F8(
	function (id, className, description, weight, weightUnit, externalId, maybeTotal, isHazardousMaterial) {
		return {className: className, description: description, externalId: externalId, id: id, isHazardousMaterial: isHazardousMaterial, maybeTotal: maybeTotal, weight: weight, weightUnit: weightUnit};
	});
var $author$project$Domain$TmsShippedItemId$TmsShippedItemId = function (a) {
	return {$: 'TmsShippedItemId', a: a};
};
var $author$project$Domain$TmsShippedItemId$fromInt = function (_int) {
	return $author$project$Domain$TmsShippedItemId$TmsShippedItemId(_int);
};
var $author$project$Domain$TmsShippedItemId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$TmsShippedItemId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Helpers$Json$Decode$default = F2(
	function (value, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					decoder,
					$elm$json$Json$Decode$succeed(value)
				]));
	});
var $author$project$Domain$TmsShippedItem$decode = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2(
		$author$project$Helpers$Json$Decode$default,
		false,
		A2($elm$json$Json$Decode$field, 'is_hazardous_material', $elm$json$Json$Decode$bool)),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'total',
				A2($elm$json$Json$Decode$map, $author$project$Money$castFromString, $elm$json$Json$Decode$string))),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2($elm$json$Json$Decode$field, 'external_id', $elm$json$Json$Decode$string),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				A2(
					$elm$json$Json$Decode$field,
					'weight_unit',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2(
						$elm$json$Json$Decode$field,
						'weight',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$author$project$Helpers$Json$Decode$apply,
						A2(
							$elm$json$Json$Decode$field,
							'description',
							A2($author$project$Helpers$Json$Decode$default, '', $elm$json$Json$Decode$string)),
						A2(
							$author$project$Helpers$Json$Decode$apply,
							A2(
								$elm$json$Json$Decode$field,
								'class_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$author$project$Helpers$Json$Decode$apply,
								A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$TmsShippedItemId$decode),
								$elm$json$Json$Decode$succeed($author$project$Domain$TmsShippedItem$TmsShippedItem)))))))));
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$CarrierItemOnly = function (a) {
	return {$: 'CarrierItemOnly', a: a};
};
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$LoadItemAndCarrierItem = F2(
	function (a, b) {
		return {$: 'LoadItemAndCarrierItem', a: a, b: b};
	});
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$LoadItemOnly = function (a) {
	return {$: 'LoadItemOnly', a: a};
};
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$decodeItemState = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$author$project$Helpers$Json$Decode$apply,
				A2($elm$json$Json$Decode$field, 'carrier_item', decoder),
				A2(
					$author$project$Helpers$Json$Decode$apply,
					A2($elm$json$Json$Decode$field, 'load_item', decoder),
					$elm$json$Json$Decode$succeed($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$LoadItemAndCarrierItem))),
				A2(
				$author$project$Helpers$Json$Decode$apply,
				A2($elm$json$Json$Decode$field, 'load_item', decoder),
				$elm$json$Json$Decode$succeed($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$LoadItemOnly)),
				A2(
				$author$project$Helpers$Json$Decode$apply,
				A2($elm$json$Json$Decode$field, 'carrier_item', decoder),
				$elm$json$Json$Decode$succeed($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$CarrierItemOnly))
			]));
};
var $author$project$AuditPb$LtlItemPairMetadata = F7(
	function (amountMismatch, weightMismatch, classMismatch, displayMismatches, itemType, description, sortScore) {
		return {amountMismatch: amountMismatch, classMismatch: classMismatch, description: description, displayMismatches: displayMismatches, itemType: itemType, sortScore: sortScore, weightMismatch: weightMismatch};
	});
var $author$project$AuditPb$LtlItemTypeLineHaul = {$: 'LtlItemTypeLineHaul'};
var $author$project$AuditPb$ltlItemTypeDefault = $author$project$AuditPb$LtlItemTypeLineHaul;
var $author$project$AuditPb$LtlItemTypeAdditionalAccessorial = {$: 'LtlItemTypeAdditionalAccessorial'};
var $author$project$AuditPb$LtlItemTypeDiscount = {$: 'LtlItemTypeDiscount'};
var $author$project$AuditPb$LtlItemTypeFuelSurcharge = {$: 'LtlItemTypeFuelSurcharge'};
var $author$project$AuditPb$LtlItemTypeMinimum = {$: 'LtlItemTypeMinimum'};
var $author$project$AuditPb$allLtlItemType = _List_fromArray(
	[$author$project$AuditPb$LtlItemTypeLineHaul, $author$project$AuditPb$LtlItemTypeMinimum, $author$project$AuditPb$LtlItemTypeDiscount, $author$project$AuditPb$LtlItemTypeFuelSurcharge, $author$project$AuditPb$LtlItemTypeAdditionalAccessorial]);
var $author$project$AuditPb$ltlItemTypeToString = function (v) {
	switch (v.$) {
		case 'LtlItemTypeLineHaul':
			return 'line_haul';
		case 'LtlItemTypeMinimum':
			return 'minimum';
		case 'LtlItemTypeDiscount':
			return 'discount';
		case 'LtlItemTypeFuelSurcharge':
			return 'fuel_surcharge';
		default:
			return 'additional_accessorial';
	}
};
var $author$project$AuditPb$ltlItemTypeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$ltlItemTypeToString(v),
				v);
		},
		$author$project$AuditPb$allLtlItemType));
var $author$project$AuditPb$ltlItemTypeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$ltlItemTypeDict);
};
var $author$project$AuditPb$ltlItemTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$ltlItemTypeDefault),
		$author$project$AuditPb$ltlItemTypeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$ltlItemPairMetadataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'sortScore',
			$author$project$AuditPb$intDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'itemType',
					$author$project$AuditPb$ltlItemTypeDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'displayMismatches',
						$elm$json$Json$Decode$bool,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'classMismatch',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'weightMismatch',
								$elm$json$Json$Decode$bool,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'amountMismatch',
									$elm$json$Json$Decode$bool,
									$author$project$AuditPb$decode($author$project$AuditPb$LtlItemPairMetadata))))))));
	});
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$decode = function () {
	var itemDecoder = function (decoder) {
		return A2(
			$author$project$Helpers$Json$Decode$apply,
			A2($elm$json$Json$Decode$field, 'metadata', $author$project$AuditPb$ltlItemPairMetadataDecoder),
			A2(
				$author$project$Helpers$Json$Decode$apply,
				$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$decodeItemState(decoder),
				$elm$json$Json$Decode$succeed($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$ItemPair)));
	};
	return A2(
		$author$project$Helpers$Json$Decode$apply,
		A2(
			$elm$json$Json$Decode$field,
			'shipped_items',
			$elm$json$Json$Decode$list(
				itemDecoder($author$project$Domain$TmsShippedItem$decode))),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2(
				$elm$json$Json$Decode$field,
				'line_items',
				$elm$json$Json$Decode$list(
					itemDecoder($author$project$Domain$LineItem$decode))),
			$elm$json$Json$Decode$succeed($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$LtlPayablesCarrierAndLoadItemEqualityData)));
}();
var $author$project$Forward$AppSpecific$Cache$ltlPayablesCarrierAndLoadItemEqualityData = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.ltlPayablesCarrierAndLoadItemEqualityData;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{ltlPayablesCarrierAndLoadItemEqualityData: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierAndLoadItemEqualityData = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$ltlPayablesCarrierAndLoadItemEqualityData,
		decoder: $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$decode,
		entrypoint: 'ltlPayablesCarrierAndLoadItemEqualityData',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		A2($author$project$Forward$Lookup$startFrom, model.carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				A2($author$project$Forward$Lookup$startFrom, model.carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierAndLoadItemEqualityData),
				$author$project$Forward$Lookup$succeed($author$project$Components$LtlReconcileInvoicePage$MismatchTable$Data))));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCustomer = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer,
		fieldName: 'tmsCustomer',
		getId: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.load;
			},
			function ($) {
				return $.customerId;
			})
	});
var $author$project$Components$LtlReconcileInvoicePage$loadData = function (model) {
	var loadTmsLoadDetailsData = A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCustomer,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCarrier,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$identity,
				$author$project$Forward$Lookup$succeed($author$project$Components$LtlReconcileInvoicePage$TmsLoadDetailsData))));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$LtlReconcileInvoicePage$MismatchTable$loadData(model.mismatchTable),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					A2($author$project$Forward$Lookup$startFrom, model.carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierAndLoadItemEqualityData),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$exposeLoadingState(
							$author$project$Components$DocumentsBrowser$loadData(model.documentsBrowser)),
						A2(
							$author$project$Forward$Lookup$apply,
							A2($author$project$Forward$Lookup$startFrom, model.carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice),
							A2(
								$author$project$Forward$Lookup$apply,
								A2(
									$author$project$Forward$Lookup$traverse,
									loadTmsLoadDetailsData,
									A2($author$project$Forward$Lookup$startFrom, model.loadStateId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetails)),
								$author$project$Forward$Lookup$succeed($author$project$Components$LtlReconcileInvoicePage$Data))))))));
};
var $author$project$Components$NonInvoiceConfirmPage$Data = F6(
	function (account, settings, currentUser, documentBatch, tmsLoadDetails, documentsBrowserData) {
		return {account: account, currentUser: currentUser, documentBatch: documentBatch, documentsBrowserData: documentsBrowserData, settings: settings, tmsLoadDetails: tmsLoadDetails};
	});
var $author$project$Components$NonInvoiceConfirmPage$DocumentBatchData = F2(
	function (documentBatch, message) {
		return {documentBatch: documentBatch, message: message};
	});
var $author$project$Components$NonInvoiceConfirmPage$loadDocumentBatchData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($author$project$Components$NonInvoiceConfirmPage$DocumentBatchData)));
var $author$project$Components$NonInvoiceConfirmPage$TmsLoadDetailsData = F5(
	function (tmsLoadDetails, carrier, customer, shipments, documents) {
		return {carrier: carrier, customer: customer, documents: documents, shipments: shipments, tmsLoadDetails: tmsLoadDetails};
	});
var $author$project$Components$NonInvoiceConfirmPage$loadDocumentsData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
var $author$project$Components$NonInvoiceConfirmPage$loadTmsLoadDetailsData = A2(
	$author$project$Forward$Lookup$apply,
	A2($author$project$Forward$Lookup$traverseList, $author$project$Components$NonInvoiceConfirmPage$loadDocumentsData, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToDocuments),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsShipments,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCustomer,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCarrier,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$identity,
					$author$project$Forward$Lookup$succeed($author$project$Components$NonInvoiceConfirmPage$TmsLoadDetailsData))))));
var $author$project$Components$NonInvoiceConfirmPage$loadData = function (params) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(
			$author$project$Components$DocumentsBrowser$loadData(params.documentsBrowser)),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$traverse,
				$author$project$Components$NonInvoiceConfirmPage$loadTmsLoadDetailsData,
				A2($author$project$Forward$Lookup$startFrom, params.loadStateId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetails)),
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Components$NonInvoiceConfirmPage$loadDocumentBatchData,
					A2($author$project$Forward$Lookup$startFrom, params.documentBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
							$author$project$Forward$Lookup$succeed($author$project$Components$NonInvoiceConfirmPage$Data)))))));
};
var $author$project$Components$OktaLoginPage$loadData = function (_v0) {
	return $author$project$Forward$Lookup$succeed(
		{});
};
var $author$project$Components$ReadonlyFactorInvoicePage$Data = F2(
	function (documentsBrowserData, factorInvoicesByGroupId) {
		return {documentsBrowserData: documentsBrowserData, factorInvoicesByGroupId: factorInvoicesByGroupId};
	});
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$documentGroupIds = function (documentSource) {
	switch (documentSource.$) {
		case 'FromDocumentBatch':
			var source = documentSource.a;
			return $elm$core$Maybe$Just(source.documentGroupIds);
		case 'FromEmailMessage':
			var source = documentSource.a;
			return source.documentGroupIds;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Forward$Lookup$loadEach = function (items) {
	return $author$project$Forward$Lookup$Lookup(
		{
			decoderConfig: A3(
				$elm$core$List$foldl,
				$elm$core$Dict$union,
				$elm$core$Dict$empty,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var nested = _v0.a;
						return nested.decoderConfig;
					},
					items)),
			invalidate: F3(
				function (k, mode, cache) {
					return A3(
						$elm$core$List$foldl,
						function (_v1) {
							var nested = _v1.a;
							return A2(nested.invalidate, k, mode);
						},
						cache,
						items);
				}),
			load: F3(
				function (cache, requiredTimestamp, k) {
					return $author$project$Forward$Internal$Loadable$exposeLoadingStateOfListItems(
						A2(
							$elm$core$List$map,
							function (_v2) {
								var nested = _v2.a;
								return A3(nested.load, cache, requiredTimestamp, k);
							},
							items));
				}),
			preloadBranches: $author$project$Forward$Internal$GraphTree$unionBranches(
				A2(
					$elm$core$List$map,
					function (_v3) {
						var nested = _v3.a;
						return nested.preloadBranches;
					},
					items)),
			structure: A2(
				$author$project$Forward$Internal$LookupStructure$All,
				'loadEach',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var nested = _v4.a;
						return nested.structure;
					},
					items))
		});
};
var $author$project$Components$ReadonlyFactorInvoicePage$lazyLoadDict = function (_v0) {
	var toLookup = _v0.toLookup;
	var toKey = _v0.toKey;
	var ids = _v0.ids;
	var zipToDict = function (values) {
		return $elm$core$Dict$fromList(
			A2(
				$elm_community$list_extra$List$Extra$zip,
				A2($elm$core$List$map, toKey, ids),
				values));
	};
	return A2(
		$author$project$Forward$Lookup$map,
		zipToDict,
		$author$project$Forward$Lookup$loadEach(
			A2($elm$core$List$map, toLookup, ids)));
};
var $author$project$Components$ReadonlyFactorInvoicePage$loadData = function (model) {
	var lookupFactorInvoiceByGroupId = function (groupId) {
		return A2(
			$author$project$Forward$Lookup$traverseMaybe,
			$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$lookup,
			A2(
				$author$project$Forward$Lookup$traverseMaybe,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
				A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.factorInvoiceId;
					},
					A2($author$project$Forward$Lookup$startFrom, groupId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup))));
	};
	var groupIdsToLoad = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$documentGroupIds(model.documentSource));
	var lazyFactorInvoicesByGroupId = $author$project$Components$ReadonlyFactorInvoicePage$lazyLoadDict(
		{ids: groupIdsToLoad, toKey: $author$project$Domain$DocumentGroupId$toInt, toLookup: lookupFactorInvoiceByGroupId});
	return A2(
		$author$project$Forward$Lookup$apply,
		lazyFactorInvoicesByGroupId,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$DocumentsBrowser$loadData(model.documentsBrowser),
			$author$project$Forward$Lookup$succeed($author$project$Components$ReadonlyFactorInvoicePage$Data)));
};
var $author$project$Components$SettingsPage$Data = F4(
	function (currentAccount, accountSettings, currentUser, sectionData) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, currentUser: currentUser, sectionData: sectionData};
	});
var $author$project$Components$SettingsPage$AccountSettingsData = F2(
	function (a, b) {
		return {$: 'AccountSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$CarrierDocumentsSettingsData = F2(
	function (a, b) {
		return {$: 'CarrierDocumentsSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$ContactsSettingsData = F2(
	function (a, b) {
		return {$: 'ContactsSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DebtorsSettingsData = F2(
	function (a, b) {
		return {$: 'DebtorsSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsData = F2(
	function (a, b) {
		return {$: 'DocumentTypesSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$ExceptionSettingsData = F2(
	function (a, b) {
		return {$: 'ExceptionSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsData = F2(
	function (a, b) {
		return {$: 'FactorClientPortalSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$IntegrationsSettingsData = function (a) {
	return {$: 'IntegrationsSettingsData', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsData = F2(
	function (a, b) {
		return {$: 'NextGenAuditSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsData = F2(
	function (a, b) {
		return {$: 'PodDefinitionSettingsData', a: a, b: b};
	});
var $author$project$Components$SettingsPage$ScraperStatusSettingsData = function (a) {
	return {$: 'ScraperStatusSettingsData', a: a};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$Data = F6(
	function (carrierDocumentTypes, currentAccount, accountSettings, documentsListView, documentBrowser, currentUser) {
		return {accountSettings: accountSettings, carrierDocumentTypes: carrierDocumentTypes, currentAccount: currentAccount, currentUser: currentUser, documentBrowser: documentBrowser, documentsListView: documentsListView};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierDocumentTypes = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_unresolvedDocumentType,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$UnresolvedDocumentType$decode),
		entrypoint: 'carrierDocumentTypes',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$Data = F3(
	function (documents, currentAccount, accountSettings) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, documents: documents};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByCarrierId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentId,
		decoder: $author$project$Domain$DocumentId$decode,
		entrypoint: 'documentIds',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$TmsCarrierId$toInt)
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$loadDocuments = function (carrierId) {
	return A2($author$project$Forward$Lookup$startFrom, carrierId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByCarrierId);
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$CarrierDocumentsView$DocumentsListView$loadDocuments(model.carrierId),
				$author$project$Forward$Lookup$succeed($author$project$Components$CarrierDocumentsView$DocumentsListView$Data))));
};
var $author$project$Components$DocumentBrowser$Data = F3(
	function (documents, currentAccount, accountSettings) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, documents: documents};
	});
var $author$project$Components$DocumentBrowser$loadData = function (model) {
	var documentAndPages = A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$traverseList,
					documentAndPages,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
						$author$project$Forward$Lookup$succeed(model.documentIds))),
				$author$project$Forward$Lookup$succeed($author$project$Components$DocumentBrowser$Data))));
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState(
				$author$project$Components$DocumentBrowser$loadData(model.documentBrowser)),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$CarrierDocumentsView$DocumentsListView$loadData(model.documentsListView)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierDocumentTypes,
							$author$project$Forward$Lookup$succeed($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$Data)))))));
};
var $author$project$Components$SettingsPage$AccountSettingsView$Data = F9(
	function (accountSettings, account, allReferenceFieldLabels, autoReplyFilters, labeledCustomers, officePeopleMappings, user, customerTypeahead, customerTypeaheadReskin) {
		return {account: account, accountSettings: accountSettings, allReferenceFieldLabels: allReferenceFieldLabels, autoReplyFilters: autoReplyFilters, customerTypeahead: customerTypeahead, customerTypeaheadReskin: customerTypeaheadReskin, labeledCustomers: labeledCustomers, officePeopleMappings: officePeopleMappings, user: user};
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettingsToLoadCustomerLabels = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$Lookup$identity,
		fieldName: 'loadCustomerLabels',
		getId: function ($) {
			return $.loadCustomerLabels;
		}
	});
var $author$project$AuditPb$AutoReplyFilter = F4(
	function (id, email, subject, body) {
		return {body: body, email: email, id: id, subject: subject};
	});
var $author$project$Domain$AutoReplyFilterId$AutoReplyFilterId = function (a) {
	return {$: 'AutoReplyFilterId', a: a};
};
var $author$project$Domain$AutoReplyFilterId$fromInt = function (_int) {
	return $author$project$Domain$AutoReplyFilterId$AutoReplyFilterId(_int);
};
var $author$project$AuditPb$autoReplyFilterDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'body',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'subject',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'email',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$AutoReplyFilterId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$AutoReplyFilter)))));
	});
var $author$project$Forward$AppSpecific$Cache$list_autoReplyFilter = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_autoReplyFilter;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_autoReplyFilter: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$autoReplyFilters = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_autoReplyFilter,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$autoReplyFilterDecoder),
		entrypoint: 'autoReplyFilters',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadCustomerLabelToCustomers = $author$project$Forward$Lookup$waitForAllList(
	$author$project$Forward$Lookup$defineListEdge(
		{
			entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer,
			fieldName: 'customers',
			getIds: function ($) {
				return $.customerIds;
			}
		}));
var $author$project$Forward$AppSpecific$Cache$list_officePeopleMapping = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_officePeopleMapping;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_officePeopleMapping: e});
		}));
var $author$project$AuditPb$OfficePeopleMapping = F3(
	function (id, office, person) {
		return {id: id, office: office, person: person};
	});
var $author$project$Domain$OfficePeopleMappingId$OfficePeopleMappingId = function (a) {
	return {$: 'OfficePeopleMappingId', a: a};
};
var $author$project$Domain$OfficePeopleMappingId$fromInt = function (_int) {
	return $author$project$Domain$OfficePeopleMappingId$OfficePeopleMappingId(_int);
};
var $author$project$AuditPb$officePeopleMappingDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'person',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'office',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$OfficePeopleMappingId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$OfficePeopleMapping))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$officePeopleMappings = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_officePeopleMapping,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$officePeopleMappingDecoder),
		entrypoint: 'officePeopleMappings',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Components$SettingsPage$AccountSettingsView$loadData = function (model) {
	var labeledCustomers = A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadCustomerLabelToCustomers,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$TmsCustomerDropdown$loadData(model.loadCustomerTypeaheadReskin),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$CustomerTypeahead$loadData(model.loadCustomerTypeahead),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$officePeopleMappings,
					A2(
						$author$project$Forward$Lookup$apply,
						A2(
							$author$project$Forward$Lookup$traverseList,
							labeledCustomers,
							A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettingsToLoadCustomerLabels, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings)),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$autoReplyFilters,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$allReferenceFieldLabels,
								A2(
									$author$project$Forward$Lookup$apply,
									$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
									A2(
										$author$project$Forward$Lookup$apply,
										$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
										$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$AccountSettingsView$Data))))))))));
};
var $author$project$Components$SettingsPage$ContactsSettingsView$Data = F5(
	function (currentAccount, contactFilterData, contactFormData, contactData, user) {
		return {contactData: contactData, contactFilterData: contactFilterData, contactFormData: contactFormData, currentAccount: currentAccount, user: user};
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$ContactInfo = F2(
	function (contact, carrier) {
		return {carrier: carrier, contact: contact};
	});
var $author$project$Domain$Contact$tmsCarrierId = function (contact) {
	var _v0 = contact.contactType;
	if (_v0.$ === 'Contact_ContactType_MultiCarrierContact') {
		return $elm$core$Maybe$Nothing;
	} else {
		var carrierContact = _v0.a;
		return carrierContact.tmsCarrierId;
	}
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$contactToMaybeTmsCarrier = $author$project$Forward$Lookup$defineMaybeEdge(
	{entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier, fieldName: 'tmsCarrier', getId: $author$project$Domain$Contact$tmsCarrierId});
var $author$project$Components$SettingsPage$ContactsSettingsView$contactToContactDetails = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$contactToMaybeTmsCarrier,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ContactsSettingsView$ContactInfo)));
var $author$project$Forward$AppSpecific$Cache$contact = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.contact;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{contact: e});
		}));
var $author$project$AuditPb$Contact = function (contactType) {
	return {contactType: contactType};
};
var $author$project$AuditPb$Contact_ContactType_CarrierContact = function (a) {
	return {$: 'Contact_ContactType_CarrierContact', a: a};
};
var $author$project$AuditPb$Contact_ContactType_MultiCarrierContact = function (a) {
	return {$: 'Contact_ContactType_MultiCarrierContact', a: a};
};
var $author$project$AuditPb$Contact_CarrierContact = F4(
	function (id, email, name, tmsCarrierId) {
		return {email: email, id: id, name: name, tmsCarrierId: tmsCarrierId};
	});
var $author$project$AuditPb$contact_CarrierContactDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'tms_carrier_id',
			A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
			A3(
				$author$project$AuditPb$optional,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'email',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$ContactId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$Contact_CarrierContact)))));
	});
var $author$project$AuditPb$Contact_MultiCarrierContact = F3(
	function (id, email, name) {
		return {email: email, id: id, name: name};
	});
var $author$project$AuditPb$contact_MultiCarrierContactDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'email',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$ContactId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$Contact_MultiCarrierContact))));
	});
var $author$project$AuditPb$contact_ContactTypeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Contact_ContactType_CarrierContact,
					A2($elm$json$Json$Decode$field, 'carrier_contact', $author$project$AuditPb$contact_CarrierContactDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Contact_ContactType_MultiCarrierContact,
					A2($elm$json$Json$Decode$field, 'multi_carrier_contact', $author$project$AuditPb$contact_MultiCarrierContactDecoder)),
					$elm$json$Json$Decode$fail('Contact_ContactType_Unspecified')
				]));
	});
var $author$project$AuditPb$contactDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$contact_ContactTypeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$Contact));
	});
var $author$project$Domain$Contact$decode = $author$project$AuditPb$contactDecoder;
var $author$project$Domain$ContactId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$contact = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$contact,
		decoder: $author$project$Domain$Contact$decode,
		entrypoint: 'contactV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$ContactId$toInt)
	});
var $author$project$AuditPb$contactTypeToString = function (v) {
	switch (v.$) {
		case 'ContactTypeAll':
			return 'all';
		case 'ContactTypeCarrier':
			return 'carrier';
		default:
			return 'general';
	}
};
var $author$project$AuditPb$contactTypeEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$contactTypeToString);
var $author$project$AuditPb$contactIdsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'term', $elm$json$Json$Encode$string, v.term),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'contact_type', $author$project$AuditPb$contactTypeEncoder, v.contactType),
					A3($author$project$AuditPb$optionalEncoder, 'carrier_name', $elm$json$Json$Encode$string, v.carrierName)
				])));
};
var $author$project$Domain$ContactIdsQuery$encode = function (query) {
	return $author$project$AuditPb$contactIdsQueryEncoder(query);
};
var $author$project$Forward$AppSpecific$Cache$page_contactId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_contactId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_contactId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$contactsByQuery = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_contactId,
		entrypoint: 'contactIdsByQuery',
		idFromInt: $author$project$Domain$ContactId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$contact,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$ContactIdsQuery$encode)
	});
var $author$project$Typeahead$selection = function (_v0) {
	var model = _v0.a;
	return model.selection;
};
var $author$project$Components$SettingsPage$ContactsFilter$selection = function (model) {
	return $author$project$Typeahead$selection(model.carrierTypeahead);
};
var $author$project$Components$PaginatedDropdown$inputValue = function (model) {
	return $author$project$Ui$V3$CustomSelect$inputValue(model.dropdown);
};
var $author$project$Components$SettingsPage$CarrierDropdown$inputValue = function (model) {
	return $author$project$Components$PaginatedDropdown$inputValue(model.dropdown);
};
var $author$project$Components$SettingsPage$ContactsFilter$selectionV3Reskin = function (model) {
	var _v0 = $elm$core$List$head(
		$author$project$Components$SettingsPage$CarrierDropdown$selectedIds(model.carrierDropdown));
	if (_v0.$ === 'Just') {
		var id = _v0.a;
		return $elm$core$Result$Ok(id);
	} else {
		return $elm$core$Result$Err(
			$author$project$Components$SettingsPage$CarrierDropdown$inputValue(model.carrierDropdown));
	}
};
var $author$project$Components$SettingsPage$ContactsSettingsView$contactData = function (model) {
	var v3ReskinEnabled = function () {
		var _v2 = $author$project$Components$SettingsPage$ContactsFilter$selectionV3Reskin(model.contactFilterModel);
		if (_v2.$ === 'Ok') {
			return true;
		} else {
			var str = _v2.a;
			return str !== '';
		}
	}();
	var carrierName = function () {
		if (v3ReskinEnabled) {
			var _v0 = $author$project$Components$SettingsPage$ContactsFilter$selectionV3Reskin(model.contactFilterModel);
			if (_v0.$ === 'Ok') {
				var id = _v0.a;
				return A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.name;
					},
					A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier));
			} else {
				var searchTerm = _v0.a;
				return $author$project$Forward$Lookup$succeed(searchTerm);
			}
		} else {
			var _v1 = $author$project$Components$SettingsPage$ContactsFilter$selection(model.contactFilterModel);
			if (_v1.$ === 'Selected') {
				var carrierId = _v1.a;
				return A2(
					$author$project$Forward$Lookup$map,
					function ($) {
						return $.name;
					},
					A2($author$project$Forward$Lookup$startFrom, carrierId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier));
			} else {
				var searchTerm = _v1.a;
				return $author$project$Forward$Lookup$succeed(searchTerm);
			}
		}
	}();
	var query = A2(
		$author$project$Forward$Lookup$map,
		function (searchTerm) {
			return {
				carrierName: $elm$core$Maybe$Just(searchTerm),
				contactType: model.contactFilterModel.selectedContactType,
				page: model.page,
				term: model.contactFilterModel.emailSearchTerm
			};
		},
		carrierName);
	return A2(
		$author$project$Forward$Lookup$traversePage,
		$author$project$Components$SettingsPage$ContactsSettingsView$contactToContactDetails,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$contactsByQuery, query));
};
var $author$project$Components$SettingsPage$ContactForm$Data = F3(
	function (account, carrierTypeaheadData, carrierDropdownData) {
		return {account: account, carrierDropdownData: carrierDropdownData, carrierTypeaheadData: carrierTypeaheadData};
	});
var $author$project$Components$SettingsPage$ContactForm$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$SettingsPage$CarrierDropdown$loadData(model.carrierDropdown),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$CarrierTypeahead$loadDataAllCarriers(model.carrierTypeahead),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ContactForm$Data))));
};
var $author$project$Components$SettingsPage$ContactsFilter$Data = F3(
	function (account, carrierTypeaheadData, carrierDropdownData) {
		return {account: account, carrierDropdownData: carrierDropdownData, carrierTypeaheadData: carrierTypeaheadData};
	});
var $author$project$Components$SettingsPage$ContactsFilter$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$SettingsPage$CarrierDropdown$loadData(model.carrierDropdown),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$CarrierTypeahead$loadDataAllCarriers(model.carrierTypeahead),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ContactsFilter$Data))));
};
var $author$project$Components$SettingsPage$ContactsSettingsView$loadData = function (model) {
	var contactFormLookup = $author$project$Components$SettingsPage$ContactForm$loadData(model.contactFormModel);
	var contactFilterLookup = $author$project$Components$SettingsPage$ContactsFilter$loadData(model.contactFilterModel);
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState(
				$author$project$Components$SettingsPage$ContactsSettingsView$contactData(model)),
			A2(
				$author$project$Forward$Lookup$apply,
				contactFormLookup,
				A2(
					$author$project$Forward$Lookup$apply,
					contactFilterLookup,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
						$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ContactsSettingsView$Data))))));
};
var $author$project$Components$SettingsPage$DebtorsSettingsView$BrokerInfo = F2(
	function (broker, paymentAddress) {
		return {broker: broker, paymentAddress: paymentAddress};
	});
var $author$project$Components$SettingsPage$DebtorsSettingsView$Data = F2(
	function (currentPage, currentUser) {
		return {currentPage: currentPage, currentUser: currentUser};
	});
var $author$project$Components$SettingsPage$DebtorsSettingsView$loadData = function (model) {
	var brokerInfo = A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerToPaymentAddress,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$DebtorsSettingsView$BrokerInfo)));
	var currentPage = A2(
		$author$project$Forward$Lookup$traversePage,
		brokerInfo,
		A2(
			$author$project$Forward$Lookup$startFrom,
			{page: model.page, term: model.searchTerm},
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokersBySettingsQuery));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState(currentPage),
			$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$DebtorsSettingsView$Data)));
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$Data = F4(
	function (currentAccount, documentTypeSettings, accountSettings, currentUser) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, currentUser: currentUser, documentTypeSettings: documentTypeSettings};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$DocumentTypesSettingsView$Data)))));
var $author$project$Components$SettingsPage$ExceptionSettingsView$Data = F4(
	function (currentAccount, accountSettings, currentUser, multipleCustomExceptionTemplatesData) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, currentUser: currentUser, multipleCustomExceptionTemplatesData: multipleCustomExceptionTemplatesData};
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Data = function (customExceptionEmailTemplates) {
	return {customExceptionEmailTemplates: customExceptionEmailTemplates};
};
var $author$project$Forward$AppSpecific$Cache$customExceptionEmailTemplate = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.customExceptionEmailTemplate;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{customExceptionEmailTemplate: e});
		}));
var $author$project$AuditPb$CustomExceptionEmailTemplate = F5(
	function (id, body, name, subject, isDefault) {
		return {body: body, id: id, isDefault: isDefault, name: name, subject: subject};
	});
var $author$project$Domain$CustomExceptionEmailTemplateId$CustomExceptionEmailTemplateId = function (a) {
	return {$: 'CustomExceptionEmailTemplateId', a: a};
};
var $author$project$Domain$CustomExceptionEmailTemplateId$fromInt = function (_int) {
	return $author$project$Domain$CustomExceptionEmailTemplateId$CustomExceptionEmailTemplateId(_int);
};
var $author$project$AuditPb$customExceptionEmailTemplateDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'is_default',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'subject',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'body',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$CustomExceptionEmailTemplateId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$CustomExceptionEmailTemplate))))));
	});
var $author$project$Domain$CustomExceptionEmailTemplateId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$customExceptionEmailTemplate = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$customExceptionEmailTemplate,
		decoder: $author$project$AuditPb$customExceptionEmailTemplateDecoder,
		entrypoint: 'customExceptionEmailTemplate',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CustomExceptionEmailTemplateId$toInt)
	});
var $author$project$Domain$CustomExceptionEmailTemplateId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$CustomExceptionEmailTemplateId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$list_customExceptionEmailTemplateId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_customExceptionEmailTemplateId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_customExceptionEmailTemplateId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$customExceptionEmailTemplates = $author$project$Forward$Lookup$defineReferenceList(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$list_customExceptionEmailTemplateId, decoder: $author$project$Domain$CustomExceptionEmailTemplateId$decode, entrypoint: 'customExceptionEmailTemplateIds', objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$customExceptionEmailTemplate, parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$customExceptionEmailTemplates,
	$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Data));
var $author$project$Components$SettingsPage$ExceptionSettingsView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$loadData,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ExceptionSettingsView$Data)))));
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$Data = F3(
	function (currentAccount, portalDisplaySettings, currentUser) {
		return {currentAccount: currentAccount, currentUser: currentUser, portalDisplaySettings: portalDisplaySettings};
	});
var $author$project$Forward$AppSpecific$Cache$portalDisplaySettings = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.portalDisplaySettings;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{portalDisplaySettings: e});
		}));
var $author$project$AuditPb$PortalDisplaySettings = function (invoiceListColumns) {
	return function (showInvoiceNumber) {
		return function (showRushFee) {
			return function (rushFeeLabelOverride) {
				return function (factorClientPortalEnabled) {
					return function (requiredFields) {
						return function (fundingMethods) {
							return function (features) {
								return function (publicDebtorCreditCheckPathSegment) {
									return function (customMessage) {
										return function (fundingDisclosure) {
											return {customMessage: customMessage, factorClientPortalEnabled: factorClientPortalEnabled, features: features, fundingDisclosure: fundingDisclosure, fundingMethods: fundingMethods, invoiceListColumns: invoiceListColumns, publicDebtorCreditCheckPathSegment: publicDebtorCreditCheckPathSegment, requiredFields: requiredFields, rushFeeLabelOverride: rushFeeLabelOverride, showInvoiceNumber: showInvoiceNumber, showRushFee: showRushFee};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$PortalDisplaySettingsColumnReceivedAt = {$: 'PortalDisplaySettingsColumnReceivedAt'};
var $author$project$AuditPb$portalDisplaySettingsColumnDefault = $author$project$AuditPb$PortalDisplaySettingsColumnReceivedAt;
var $author$project$AuditPb$PortalDisplaySettingsColumnAmount = {$: 'PortalDisplaySettingsColumnAmount'};
var $author$project$AuditPb$PortalDisplaySettingsColumnInvoiceNumber = {$: 'PortalDisplaySettingsColumnInvoiceNumber'};
var $author$project$AuditPb$PortalDisplaySettingsColumnIsFuelAdvance = {$: 'PortalDisplaySettingsColumnIsFuelAdvance'};
var $author$project$AuditPb$PortalDisplaySettingsColumnLoadNumber = {$: 'PortalDisplaySettingsColumnLoadNumber'};
var $author$project$AuditPb$PortalDisplaySettingsColumnStatus = {$: 'PortalDisplaySettingsColumnStatus'};
var $author$project$AuditPb$allPortalDisplaySettingsColumn = _List_fromArray(
	[$author$project$AuditPb$PortalDisplaySettingsColumnReceivedAt, $author$project$AuditPb$PortalDisplaySettingsColumnInvoiceNumber, $author$project$AuditPb$PortalDisplaySettingsColumnIsFuelAdvance, $author$project$AuditPb$PortalDisplaySettingsColumnAmount, $author$project$AuditPb$PortalDisplaySettingsColumnStatus, $author$project$AuditPb$PortalDisplaySettingsColumnLoadNumber]);
var $author$project$AuditPb$portalDisplaySettingsColumnToString = function (v) {
	switch (v.$) {
		case 'PortalDisplaySettingsColumnReceivedAt':
			return 'received_at';
		case 'PortalDisplaySettingsColumnInvoiceNumber':
			return 'invoice_number';
		case 'PortalDisplaySettingsColumnIsFuelAdvance':
			return 'is_fuel_advance';
		case 'PortalDisplaySettingsColumnAmount':
			return 'amount';
		case 'PortalDisplaySettingsColumnStatus':
			return 'status';
		default:
			return 'load_number';
	}
};
var $author$project$AuditPb$portalDisplaySettingsColumnDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$portalDisplaySettingsColumnToString(v),
				v);
		},
		$author$project$AuditPb$allPortalDisplaySettingsColumn));
var $author$project$AuditPb$portalDisplaySettingsColumnFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$portalDisplaySettingsColumnDict);
};
var $author$project$AuditPb$portalDisplaySettingsColumnDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$portalDisplaySettingsColumnDefault),
		$author$project$AuditPb$portalDisplaySettingsColumnFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$PortalDisplaySettingsInputFieldDebtor = {$: 'PortalDisplaySettingsInputFieldDebtor'};
var $author$project$AuditPb$portalDisplaySettingsInputFieldDefault = $author$project$AuditPb$PortalDisplaySettingsInputFieldDebtor;
var $author$project$AuditPb$PortalDisplaySettingsInputFieldAmountField = {$: 'PortalDisplaySettingsInputFieldAmountField'};
var $author$project$AuditPb$PortalDisplaySettingsInputFieldComments = {$: 'PortalDisplaySettingsInputFieldComments'};
var $author$project$AuditPb$PortalDisplaySettingsInputFieldInvoiceNumberField = {$: 'PortalDisplaySettingsInputFieldInvoiceNumberField'};
var $author$project$AuditPb$PortalDisplaySettingsInputFieldLoadId = {$: 'PortalDisplaySettingsInputFieldLoadId'};
var $author$project$AuditPb$allPortalDisplaySettingsInputField = _List_fromArray(
	[$author$project$AuditPb$PortalDisplaySettingsInputFieldDebtor, $author$project$AuditPb$PortalDisplaySettingsInputFieldInvoiceNumberField, $author$project$AuditPb$PortalDisplaySettingsInputFieldLoadId, $author$project$AuditPb$PortalDisplaySettingsInputFieldAmountField, $author$project$AuditPb$PortalDisplaySettingsInputFieldComments]);
var $author$project$AuditPb$portalDisplaySettingsInputFieldToString = function (v) {
	switch (v.$) {
		case 'PortalDisplaySettingsInputFieldDebtor':
			return 'debtor';
		case 'PortalDisplaySettingsInputFieldInvoiceNumberField':
			return 'invoice_number';
		case 'PortalDisplaySettingsInputFieldLoadId':
			return 'load_id';
		case 'PortalDisplaySettingsInputFieldAmountField':
			return 'amount';
		default:
			return 'comments';
	}
};
var $author$project$AuditPb$portalDisplaySettingsInputFieldDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$portalDisplaySettingsInputFieldToString(v),
				v);
		},
		$author$project$AuditPb$allPortalDisplaySettingsInputField));
var $author$project$AuditPb$portalDisplaySettingsInputFieldFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$portalDisplaySettingsInputFieldDict);
};
var $author$project$AuditPb$portalDisplaySettingsInputFieldDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$portalDisplaySettingsInputFieldDefault),
		$author$project$AuditPb$portalDisplaySettingsInputFieldFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$PortalDisplaySettings_Feature = F4(
	function (id, label, enabled, canOverrideForClient) {
		return {canOverrideForClient: canOverrideForClient, enabled: enabled, id: id, label: label};
	});
var $author$project$AuditPb$portalDisplaySettings_FeatureDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'can_override_for_client',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'enabled',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'label',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'id',
						$elm$json$Json$Decode$string,
						$author$project$AuditPb$decode($author$project$AuditPb$PortalDisplaySettings_Feature)))));
	});
var $author$project$AuditPb$PortalDisplaySettings_FundingMethod = F3(
	function (portalFieldName, spanishTranslation, payablesLabel) {
		return {payablesLabel: payablesLabel, portalFieldName: portalFieldName, spanishTranslation: spanishTranslation};
	});
var $author$project$AuditPb$portalDisplaySettings_FundingMethodDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'payables_label',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'spanish_translation',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'portal_field_name',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$PortalDisplaySettings_FundingMethod))));
	});
var $author$project$AuditPb$portalDisplaySettingsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'funding_disclosure',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$optional,
				'custom_message',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$optional,
					'public_debtor_credit_check_path_segment',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$repeated,
						'features',
						$author$project$AuditPb$portalDisplaySettings_FeatureDecoder,
						A3(
							$author$project$AuditPb$repeated,
							'funding_methods',
							$author$project$AuditPb$portalDisplaySettings_FundingMethodDecoder,
							A3(
								$author$project$AuditPb$repeated,
								'required_fields',
								$author$project$AuditPb$portalDisplaySettingsInputFieldDecoder,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'factor_client_portal_enabled',
									$elm$json$Json$Decode$bool,
									A3(
										$author$project$AuditPb$optional,
										'rush_fee_label_override',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'show_rush_fee',
											$elm$json$Json$Decode$bool,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'show_invoice_number',
												$elm$json$Json$Decode$bool,
												A3(
													$author$project$AuditPb$repeated,
													'invoice_list_columns',
													$author$project$AuditPb$portalDisplaySettingsColumnDecoder,
													$author$project$AuditPb$decode($author$project$AuditPb$PortalDisplaySettings))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$portalDisplaySettings = $author$project$Forward$Lookup$defineNode(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$portalDisplaySettings, decoder: $author$project$AuditPb$portalDisplaySettingsDecoder, entrypoint: 'portalDisplaySettingsV2', parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$portalDisplaySettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
			$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$FactorClientPortalSettingsView$Data))));
var $author$project$Components$SettingsPage$IntegrationsSettingsView$Data = F2(
	function (integrations, currentUser) {
		return {currentUser: currentUser, integrations: integrations};
	});
var $author$project$Domain$IntegrationId$IntegrationId = function (a) {
	return {$: 'IntegrationId', a: a};
};
var $author$project$Domain$IntegrationId$fromInt = function (_int) {
	return $author$project$Domain$IntegrationId$IntegrationId(_int);
};
var $author$project$Domain$IntegrationId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$IntegrationId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$integration = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.integration;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{integration: e});
		}));
var $author$project$AuditPb$Integration = F2(
	function (id, integrationDetails) {
		return {id: id, integrationDetails: integrationDetails};
	});
var $author$project$AuditPb$Integration_IntegrationDetails_CadenceDetails = function (a) {
	return {$: 'Integration_IntegrationDetails_CadenceDetails', a: a};
};
var $author$project$AuditPb$Integration_IntegrationDetails_FactorSqlDetails = function (a) {
	return {$: 'Integration_IntegrationDetails_FactorSqlDetails', a: a};
};
var $author$project$AuditPb$Integration_IntegrationDetails_MercuryGateDetails = function (a) {
	return {$: 'Integration_IntegrationDetails_MercuryGateDetails', a: a};
};
var $author$project$AuditPb$Integration_IntegrationDetails_UnknownIntegrationDetails = function (a) {
	return {$: 'Integration_IntegrationDetails_UnknownIntegrationDetails', a: a};
};
var $author$project$AuditPb$Integration_CadenceDetails = F2(
	function (fileStatusData, transmissionData) {
		return {fileStatusData: fileStatusData, transmissionData: transmissionData};
	});
var $author$project$AuditPb$Integration_FileStatusData = F4(
	function (invoices, debtors, carriers, agings) {
		return {agings: agings, carriers: carriers, debtors: debtors, invoices: invoices};
	});
var $author$project$AuditPb$Integration_FileDetails = F2(
	function (status, time) {
		return {status: status, time: time};
	});
var $author$project$AuditPb$FileStatusImporting = {$: 'FileStatusImporting'};
var $author$project$AuditPb$fileStatusDefault = $author$project$AuditPb$FileStatusImporting;
var $author$project$AuditPb$FileStatusImportFailed = {$: 'FileStatusImportFailed'};
var $author$project$AuditPb$FileStatusImported = {$: 'FileStatusImported'};
var $author$project$AuditPb$FileStatusSkipped = {$: 'FileStatusSkipped'};
var $author$project$AuditPb$allFileStatus = _List_fromArray(
	[$author$project$AuditPb$FileStatusImporting, $author$project$AuditPb$FileStatusImported, $author$project$AuditPb$FileStatusImportFailed, $author$project$AuditPb$FileStatusSkipped]);
var $author$project$AuditPb$fileStatusToString = function (v) {
	switch (v.$) {
		case 'FileStatusImporting':
			return 'importing';
		case 'FileStatusImported':
			return 'imported';
		case 'FileStatusImportFailed':
			return 'import_failed';
		default:
			return 'skipped';
	}
};
var $author$project$AuditPb$fileStatusDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$fileStatusToString(v),
				v);
		},
		$author$project$AuditPb$allFileStatus));
var $author$project$AuditPb$fileStatusFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$fileStatusDict);
};
var $author$project$AuditPb$fileStatusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$fileStatusDefault),
		$author$project$AuditPb$fileStatusFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$integration_FileDetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'time',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$optional,
				'status',
				$author$project$AuditPb$fileStatusDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$Integration_FileDetails)));
	});
var $author$project$AuditPb$integration_FileStatusDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'agings',
			$author$project$AuditPb$integration_FileDetailsDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'carriers',
				$author$project$AuditPb$integration_FileDetailsDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'debtors',
					$author$project$AuditPb$integration_FileDetailsDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'invoices',
						$author$project$AuditPb$integration_FileDetailsDecoder,
						$author$project$AuditPb$decode($author$project$AuditPb$Integration_FileStatusData)))));
	});
var $author$project$AuditPb$Integration_TransmissionStatusData = F2(
	function (transmissionDetails, time) {
		return {time: time, transmissionDetails: transmissionDetails};
	});
var $author$project$AuditPb$integration_TransmissionStatusDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'time',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'transmissionDetails',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$Integration_TransmissionStatusData)));
	});
var $author$project$AuditPb$integration_CadenceDetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'transmissionData',
			$author$project$AuditPb$integration_TransmissionStatusDataDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'fileStatusData',
				$author$project$AuditPb$integration_FileStatusDataDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$Integration_CadenceDetails)));
	});
var $author$project$AuditPb$Integration_FactorSqlDetails = {};
var $author$project$AuditPb$integration_FactorSqlDetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Integration_FactorSqlDetails);
	});
var $author$project$AuditPb$Integration_MercuryGateDetails = F3(
	function (remitToAddressTypes, importEnterpriseBillTo, billToCustomerBillingAdapter) {
		return {billToCustomerBillingAdapter: billToCustomerBillingAdapter, importEnterpriseBillTo: importEnterpriseBillTo, remitToAddressTypes: remitToAddressTypes};
	});
var $author$project$AuditPb$integration_MercuryGateDetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'billToCustomerBillingAdapter',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'importEnterpriseBillTo',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$repeated,
					'remitToAddressTypes',
					$elm$json$Json$Decode$string,
					$author$project$AuditPb$decode($author$project$AuditPb$Integration_MercuryGateDetails))));
	});
var $author$project$AuditPb$Integration_UnknownIntegrationDetails = {};
var $author$project$AuditPb$integration_UnknownIntegrationDetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Integration_UnknownIntegrationDetails);
	});
var $author$project$AuditPb$integration_IntegrationDetailsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Integration_IntegrationDetails_MercuryGateDetails,
					A2($elm$json$Json$Decode$field, 'mercuryGateDetails', $author$project$AuditPb$integration_MercuryGateDetailsDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Integration_IntegrationDetails_CadenceDetails,
					A2($elm$json$Json$Decode$field, 'cadenceDetails', $author$project$AuditPb$integration_CadenceDetailsDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Integration_IntegrationDetails_FactorSqlDetails,
					A2($elm$json$Json$Decode$field, 'factorSqlDetails', $author$project$AuditPb$integration_FactorSqlDetailsDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$Integration_IntegrationDetails_UnknownIntegrationDetails,
					A2($elm$json$Json$Decode$field, 'unknownDetails', $author$project$AuditPb$integration_UnknownIntegrationDetailsDecoder)),
					$elm$json$Json$Decode$fail('Integration_IntegrationDetails_Unspecified')
				]));
	});
var $author$project$AuditPb$integrationDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$integration_IntegrationDetailsDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$IntegrationId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$Integration)));
	});
var $author$project$Domain$IntegrationId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$integration = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$integration,
		decoder: $author$project$AuditPb$integrationDecoder,
		entrypoint: 'integrationV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$IntegrationId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$list_integrationId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_integrationId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_integrationId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$integrations = $author$project$Forward$Lookup$defineReferenceList(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$list_integrationId, decoder: $author$project$Domain$IntegrationId$decode, entrypoint: 'integrationIds', objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$integration, parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Components$SettingsPage$IntegrationsSettingsView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$integrations,
		$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$IntegrationsSettingsView$Data)));
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$Data = F2(
	function (currentUser, accountSettings) {
		return {accountSettings: accountSettings, currentUser: currentUser};
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$NextGenAuditSettingsView$Data)));
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$Data = F3(
	function (accountSettings, user, customerLevel) {
		return {accountSettings: accountSettings, customerLevel: customerLevel, user: user};
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Data = F5(
	function (accountSettings, account, definitions, customers, customerSelectData) {
		return {account: account, accountSettings: accountSettings, customerSelectData: customerSelectData, customers: customers, definitions: definitions};
	});
var $author$project$Forward$AppSpecific$Cache$customerPODDefinitions = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.customerPODDefinitions;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{customerPODDefinitions: e});
		}));
var $author$project$AuditPb$CustomerPODDefinitions = F3(
	function (groups, availableChecks, availableDocumentTypes) {
		return {availableChecks: availableChecks, availableDocumentTypes: availableDocumentTypes, groups: groups};
	});
var $author$project$AuditPb$CustomerPODDefinitionGroup = F5(
	function (tmsCustomerIds, allowedAsPODOverrideDocumentTypes, podDefinitionChecksEnabled, inheritsAllowedAsPODOverrideDocumentTypes, inheritsPODDefinitionChecksEnabled) {
		return {allowedAsPODOverrideDocumentTypes: allowedAsPODOverrideDocumentTypes, inheritsAllowedAsPODOverrideDocumentTypes: inheritsAllowedAsPODOverrideDocumentTypes, inheritsPODDefinitionChecksEnabled: inheritsPODDefinitionChecksEnabled, podDefinitionChecksEnabled: podDefinitionChecksEnabled, tmsCustomerIds: tmsCustomerIds};
	});
var $author$project$AuditPb$customerPODDefinitionGroupDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'inherits_pod_definition_checks_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'inherits_allowed_as_pod_override_document_types',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$repeated,
					'pod_definition_checks_enabled',
					$author$project$AuditPb$documentPODInferenceCheckTypeDecoder,
					A3(
						$author$project$AuditPb$repeated,
						'allowed_as_pod_override_document_types',
						$author$project$AuditPb$documentTypeDecoder,
						A3(
							$author$project$AuditPb$repeated,
							'tms_customer_ids',
							A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$CustomerPODDefinitionGroup))))));
	});
var $author$project$AuditPb$customerPODDefinitionsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'available_document_types',
			$author$project$AuditPb$documentTypeDecoder,
			A3(
				$author$project$AuditPb$repeated,
				'available_checks',
				$author$project$AuditPb$documentPODInferenceCheckTypeDecoder,
				A3(
					$author$project$AuditPb$repeated,
					'groups',
					$author$project$AuditPb$customerPODDefinitionGroupDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$CustomerPODDefinitions))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerPODDefinitions = $author$project$Forward$Lookup$defineNode(
	{cacheKey: $author$project$Forward$AppSpecific$Cache$customerPODDefinitions, decoder: $author$project$AuditPb$customerPODDefinitionsDecoder, entrypoint: 'customerPODDefinitions', parameters: $author$project$Forward$Lookup$noParameters});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$customerSelectData = function (model) {
	var _v0 = model.editing;
	if (_v0.$ === 'Nothing') {
		return $author$project$Forward$Lookup$succeed(
			$author$project$Forward$Remote$Loaded(
				A3($author$project$Pagination$fromList, 1, 1, _List_Nil)));
	} else {
		var customerSelect = _v0.a.customerSelect;
		return $author$project$Components$TmsCustomerDropdown$loadData(customerSelect);
	}
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$relevantCustomers = function (model) {
	var draftIds = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_List_Nil,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.draft;
			},
			function ($) {
				return $.tmsCustomerIds;
			}),
		model.editing);
	return A2(
		$author$project$Forward$Lookup$traverseList,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer,
		A2(
			$author$project$Forward$Lookup$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.groups;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$concatMap(
						function ($) {
							return $.tmsCustomerIds;
						}),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$append(draftIds),
						$elm_community$list_extra$List$Extra$uniqueBy($author$project$Domain$TmsCustomerId$toInt)))),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerPODDefinitions));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$customerSelectData(model),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$relevantCustomers(model),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerPODDefinitions,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
						$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Data))))));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(
			$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$loadData(model.customerLevel)),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$PodDefinitionSettingsView$Data))));
};
var $author$project$Components$SettingsPage$ScraperStatusView$Data = F2(
	function (account, accountSettings) {
		return {account: account, accountSettings: accountSettings};
	});
var $author$project$Components$SettingsPage$ScraperStatusView$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
		$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ScraperStatusView$Data)));
var $author$project$Components$SettingsPage$loadSectionData = function (activeSection) {
	switch (activeSection.$) {
		case 'AccountSettings':
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$SettingsPage$AccountSettingsView$loadData(childModel),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$AccountSettingsData)));
		case 'IntegrationsSettings':
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$SettingsPage$IntegrationsSettingsView$loadData,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$IntegrationsSettingsData));
		case 'NextGenAuditSettings':
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$SettingsPage$NextGenAuditSettingsView$loadData,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$NextGenAuditSettingsData)));
		case 'DocumentTypesSettings':
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$SettingsPage$DocumentTypesSettingsView$loadData),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$DocumentTypesSettingsData)));
		case 'CarrierDocumentsSettings':
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$CarrierDocumentsView$CarrierDocumentsView$loadData(childModel)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$CarrierDocumentsSettingsData)));
		case 'ContactsSettings':
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$SettingsPage$ContactsSettingsView$loadData(childModel)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ContactsSettingsData)));
		case 'DebtorsSettings':
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$SettingsPage$DebtorsSettingsView$loadData(childModel),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$DebtorsSettingsData)));
		case 'FactorClientPortalSettings':
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$SettingsPage$FactorClientPortalSettingsView$loadData),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$FactorClientPortalSettingsData)));
		case 'ExceptionSettings':
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$SettingsPage$ExceptionSettingsView$loadData,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ExceptionSettingsData)));
		case 'ScraperStatusSettings':
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$SettingsPage$ScraperStatusView$loadData,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ScraperStatusSettingsData));
		default:
			var childModel = activeSection.a;
			return A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$loadData(childModel),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$succeed(childModel),
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$PodDefinitionSettingsData)));
	}
};
var $author$project$Components$SettingsPage$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$SettingsPage$loadSectionData(model.activeSection),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$Data)))));
};
var $author$project$Components$SettingsPage$CarrierLayout$Data = F8(
	function (account, accountSettings, currentUser, carrierData, externalLogins, typeaheadData, typeaheadDataV3Reskin, clientDebtorConfigManagerData) {
		return {account: account, accountSettings: accountSettings, carrierData: carrierData, clientDebtorConfigManagerData: clientDebtorConfigManagerData, currentUser: currentUser, externalLogins: externalLogins, typeaheadData: typeaheadData, typeaheadDataV3Reskin: typeaheadDataV3Reskin};
	});
var $author$project$Components$SettingsPage$CarrierLayout$CarrierData = F2(
	function (carrier, externalLoginCustomers) {
		return {carrier: carrier, externalLoginCustomers: externalLoginCustomers};
	});
var $elm_community$dict_extra$Dict$Extra$fromListBy = F2(
	function (keyfn, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$insert,
						keyfn(x),
						x,
						acc);
				}),
			$elm$core$Dict$empty,
			xs);
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToExternalLoginCustomers = $author$project$Forward$Lookup$waitForAllList(
	$author$project$Forward$Lookup$defineListEdge(
		{
			entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer,
			fieldName: 'externalLoginCustomers',
			getIds: function (carrier) {
				return A2(
					$elm$core$List$filterMap,
					function ($) {
						return $.customerId;
					},
					carrier.externalLogins);
			}
		}));
var $author$project$Components$SettingsPage$CarrierLayout$customerIdsLookup = A2(
	$author$project$Forward$Lookup$map,
	$elm_community$dict_extra$Dict$Extra$fromListBy(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.id;
			},
			$author$project$Domain$TmsCustomerId$toInt)),
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToExternalLoginCustomers);
var $author$project$Components$SettingsPage$CarrierLayout$carrierToCarrierData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Components$SettingsPage$CarrierLayout$customerIdsLookup,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$identity,
		$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$CarrierLayout$CarrierData)));
var $author$project$Components$ClientDebtorConfigurationManager$Data = F3(
	function (debtorTypeaheadData, hideLaneRateExceptionCheck, hideInvoiceAmountHistoryCheck) {
		return {debtorTypeaheadData: debtorTypeaheadData, hideInvoiceAmountHistoryCheck: hideInvoiceAmountHistoryCheck, hideLaneRateExceptionCheck: hideLaneRateExceptionCheck};
	});
var $author$project$Components$DebtorTypeahead$loadDataWithSimpleSearch = function (carrierId) {
	return $author$project$Components$DebtorTypeahead$loadDataWithOptions(
		{carrierId: carrierId, useSimpleSearch: true});
};
var $author$project$Components$ClientDebtorConfigurationManager$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$succeed(true),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$succeed(false),
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Components$DebtorTypeahead$loadDataWithSimpleSearch,
					$elm$core$Maybe$Just(model.carrierId),
					model.debtorTypeahead),
				$author$project$Forward$Lookup$succeed($author$project$Components$ClientDebtorConfigurationManager$Data))));
};
var $author$project$Forward$AppSpecific$Cache$externalLogin = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.externalLogin;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{externalLogin: e});
		}));
var $author$project$AuditPb$ExternalLogin = F7(
	function (id, user, passwordPresent, token, tmsCustomerId, scrapingServices, loginFailureDetectedAt) {
		return {id: id, loginFailureDetectedAt: loginFailureDetectedAt, passwordPresent: passwordPresent, scrapingServices: scrapingServices, tmsCustomerId: tmsCustomerId, token: token, user: user};
	});
var $author$project$AuditPb$externalLoginDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'loginFailureDetectedAt',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'scrapingServices',
				$author$project$AuditPb$scrapingServiceDecoder,
				A3(
					$author$project$AuditPb$optional,
					'tmsCustomerId',
					A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCustomerId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$optional,
						'token',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'passwordPresent',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$optional,
								'user',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$ExternalLoginId$fromInt, $author$project$AuditPb$intDecoder),
									$author$project$AuditPb$decode($author$project$AuditPb$ExternalLogin))))))));
	});
var $author$project$Domain$ExternalLoginId$toInt = function (_v0) {
	var i = _v0.a;
	return i;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$externalLogins = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$externalLogin,
		decoder: $author$project$AuditPb$externalLoginDecoder,
		entrypoint: 'externalLogin',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$ExternalLoginId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToExternalLogins = $author$project$Forward$Lookup$waitForAllList(
	$author$project$Forward$Lookup$defineListEdge(
		{
			entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$externalLogins,
			fieldName: 'externalLogins',
			getIds: function (carrier) {
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.id;
					},
					carrier.externalLogins);
			}
		}));
var $author$project$Components$SettingsPage$CarrierLayout$loadData = function (model) {
	var typeaheadLookupV3Reskin = function () {
		var _v1 = model.externalLoginForm;
		if (_v1.$ === 'Nothing') {
			return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
		} else {
			var typeaheadV3Reskin = _v1.a.typeaheadV3Reskin;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$Maybe$Just,
				$author$project$Components$TmsCustomerDropdown$loadData(typeaheadV3Reskin));
		}
	}();
	var typeaheadLookup = function () {
		var _v0 = model.externalLoginForm;
		if (_v0.$ === 'Nothing') {
			return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
		} else {
			var typeahead = _v0.a.typeahead;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$Maybe$Just,
				$author$project$Components$CustomerTypeahead$loadData(typeahead));
		}
	}();
	return A2(
		$author$project$Forward$Lookup$apply,
		A3(
			$author$project$Forward$Lookup$map2,
			F2(
				function (settings, configData) {
					return _Utils_update(
						configData,
						{hideInvoiceAmountHistoryCheck: settings.invoiceAmountHistoryRuleMode !== 'on', hideLaneRateExceptionCheck: settings.laneRateExceptionsMode === 'secret'});
				}),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			$author$project$Components$ClientDebtorConfigurationManager$loadData(model.clientDebtorConfigManager)),
		A2(
			$author$project$Forward$Lookup$apply,
			typeaheadLookupV3Reskin,
			A2(
				$author$project$Forward$Lookup$apply,
				typeaheadLookup,
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$traverse,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToExternalLogins,
						A2($author$project$Forward$Lookup$startFrom, model.carrierId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier)),
					A2(
						$author$project$Forward$Lookup$apply,
						A2(
							$author$project$Forward$Lookup$traverse,
							$author$project$Components$SettingsPage$CarrierLayout$carrierToCarrierData,
							A2($author$project$Forward$Lookup$startFrom, model.carrierId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier)),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
								A2(
									$author$project$Forward$Lookup$apply,
									$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
									$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$CarrierLayout$Data)))))))));
};
var $author$project$Components$SettingsPage$CarriersLayout$Data = F4(
	function (account, accountSettings, user, carrierData) {
		return {account: account, accountSettings: accountSettings, carrierData: carrierData, user: user};
	});
var $author$project$Components$SettingsPage$Carriers$Filters$toQuery = function (model) {
	return {
		eligibleForAutoprocessing: model.eligibleForAutoprocessing,
		labels: $elm$core$Set$toList(model.selectedLabels),
		page: model.page,
		scraperOnly: model.scraperOnly,
		term: model.term,
		withLoginFailures: model.withLoginFailures
	};
};
var $author$project$Components$SettingsPage$CarriersLayout$loadCarrierData = function (filtersModel) {
	return A2(
		$author$project$Forward$Lookup$startFrom,
		$author$project$Components$SettingsPage$Carriers$Filters$toQuery(filtersModel),
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarriersBySettingsQuery);
};
var $author$project$Components$SettingsPage$CarriersLayout$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(
			$author$project$Components$SettingsPage$CarriersLayout$loadCarrierData(model.filtersModel)),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$CarriersLayout$Data)))));
};
var $author$project$Components$SettingsPage$CustomerLayout$Data = F8(
	function (customerSettings, documentTypeSettings, invoiceTemplates, accountSettings, currentAccount, allReferenceFieldLabels, currentUser, remitToAddresses) {
		return {accountSettings: accountSettings, allReferenceFieldLabels: allReferenceFieldLabels, currentAccount: currentAccount, currentUser: currentUser, customerSettings: customerSettings, documentTypeSettings: documentTypeSettings, invoiceTemplates: invoiceTemplates, remitToAddresses: remitToAddresses};
	});
var $author$project$AuditPb$CustomerInvoiceTemplate = F2(
	function (id, name) {
		return {id: id, name: name};
	});
var $author$project$AuditPb$customerInvoiceTemplateDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$CustomerInvoiceTemplateId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$CustomerInvoiceTemplate)));
	});
var $author$project$Forward$AppSpecific$Cache$list_customerInvoiceTemplate = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_customerInvoiceTemplate;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_customerInvoiceTemplate: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerInvoiceTemplates = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_customerInvoiceTemplate,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$customerInvoiceTemplateDecoder),
		entrypoint: 'customerInvoiceTemplates',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Forward$AppSpecific$Cache$list_address = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_address;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_address: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$remitToAddresses = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_address,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$Address$decode),
		entrypoint: 'remitToAddresses',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Components$SettingsPage$CustomerLayout$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$remitToAddresses,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$allReferenceFieldLabels,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerInvoiceTemplates,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings,
								A2(
									$author$project$Forward$Lookup$apply,
									A2($author$project$Forward$Lookup$startFrom, model.customerId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerSettings),
									$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$CustomerLayout$Data)))))))));
};
var $author$project$Components$SettingsPage$CustomersLayout$Data = F4(
	function (currentAccount, accountSettings, currentUser, customers) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, currentUser: currentUser, customers: customers};
	});
var $author$project$AuditPb$tmsCustomerSettingsIdsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'term', $elm$json$Json$Encode$string, v.term)
				])));
};
var $author$project$Domain$TmsCustomerSettingsIdsQuery$encode = function (tmsCustomerSettingsIdsQuery) {
	return $author$project$AuditPb$tmsCustomerSettingsIdsQueryEncoder(tmsCustomerSettingsIdsQuery);
};
var $author$project$Forward$AppSpecific$Cache$page_tmsCustomerId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_tmsCustomerId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_tmsCustomerId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomersBySettingsQuery = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_tmsCustomerId,
		entrypoint: 'tmsCustomerSettingsIdsByQuery',
		idFromInt: $author$project$Domain$TmsCustomerId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$Domain$TmsCustomerSettingsIdsQuery$encode)
	});
var $author$project$Components$SettingsPage$CustomersLayout$loadData = function (model) {
	var customers = A2(
		$author$project$Forward$Lookup$startFrom,
		{page: model.page, term: model.term},
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomersBySettingsQuery);
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState(customers),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$CustomersLayout$Data)))));
};
var $author$project$Components$SettingsPage$DebtorLayout$Data = F6(
	function (debtorSettings, documentTypeSettings, accountSettings, currentAccount, invoiceTemplates, currentUser) {
		return {accountSettings: accountSettings, currentAccount: currentAccount, currentUser: currentUser, debtorSettings: debtorSettings, documentTypeSettings: documentTypeSettings, invoiceTemplates: invoiceTemplates};
	});
var $author$project$AuditPb$FactorBrokerSettings = function (id) {
	return function (name) {
		return function (billingEmail) {
			return function (contactInfo) {
				return function (deliveryMethod) {
					return function (customerVisibleDocumentTypes) {
						return function (requiredReceivablesTypes) {
							return function (billingInterval) {
								return function (customerInvoiceTemplateId) {
									return function (skipAutoStamp) {
										return function (rateConfirmationRequired) {
											return function (podRequired) {
												return function (excludeFromVerificationsWorkflow) {
													return function (requireVerificationsWorkflow) {
														return function (factorInvoiceExtractedFields) {
															return function (warnIfAmountOver) {
																return function (addAccessorialsToInvoiceTotal) {
																	return function (deductAdvancesFromInvoiceTotal) {
																		return function (allowAutoprocessing) {
																			return function (factorBrokerLoadIdRegressionRuleMode) {
																				return function (loadIdAutoRelease) {
																					return function (templateVariables) {
																						return function (loadIdStrategies) {
																							return {addAccessorialsToInvoiceTotal: addAccessorialsToInvoiceTotal, allowAutoprocessing: allowAutoprocessing, billingEmail: billingEmail, billingInterval: billingInterval, contactInfo: contactInfo, customerInvoiceTemplateId: customerInvoiceTemplateId, customerVisibleDocumentTypes: customerVisibleDocumentTypes, deductAdvancesFromInvoiceTotal: deductAdvancesFromInvoiceTotal, deliveryMethod: deliveryMethod, excludeFromVerificationsWorkflow: excludeFromVerificationsWorkflow, factorBrokerLoadIdRegressionRuleMode: factorBrokerLoadIdRegressionRuleMode, factorInvoiceExtractedFields: factorInvoiceExtractedFields, id: id, loadIdAutoRelease: loadIdAutoRelease, loadIdStrategies: loadIdStrategies, name: name, podRequired: podRequired, rateConfirmationRequired: rateConfirmationRequired, requireVerificationsWorkflow: requireVerificationsWorkflow, requiredReceivablesTypes: requiredReceivablesTypes, skipAutoStamp: skipAutoStamp, templateVariables: templateVariables, warnIfAmountOver: warnIfAmountOver};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$FactorBrokerSettings_InvoiceExtractedField = F5(
	function (label, name, lineItem, cleanAmount, advance) {
		return {advance: advance, cleanAmount: cleanAmount, label: label, lineItem: lineItem, name: name};
	});
var $author$project$AuditPb$factorBrokerSettings_InvoiceExtractedFieldDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'advance',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'clean_amount',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'line_item',
					$elm$json$Json$Decode$bool,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'label',
							$elm$json$Json$Decode$string,
							$author$project$AuditPb$decode($author$project$AuditPb$FactorBrokerSettings_InvoiceExtractedField))))));
	});
var $author$project$AuditPb$FactorBrokerSettings_LoadIdAutoRelease = F9(
	function (enabled, enabledAt, enabledByName, disabledAt, disabledByName, keptPercentage, priorCount, statsUpdatedAt, eligible) {
		return {disabledAt: disabledAt, disabledByName: disabledByName, eligible: eligible, enabled: enabled, enabledAt: enabledAt, enabledByName: enabledByName, keptPercentage: keptPercentage, priorCount: priorCount, statsUpdatedAt: statsUpdatedAt};
	});
var $author$project$AuditPb$factorBrokerSettings_LoadIdAutoReleaseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'eligible',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$optional,
				'stats_updated_at',
				$author$project$AuditPb$timestampDecoder,
				A3(
					$author$project$AuditPb$optional,
					'prior_count',
					$author$project$AuditPb$intDecoder,
					A3(
						$author$project$AuditPb$optional,
						'kept_percentage',
						$author$project$AuditPb$floatValueDecoder,
						A3(
							$author$project$AuditPb$optional,
							'disabled_by_name',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$optional,
								'disabled_at',
								$author$project$AuditPb$timestampDecoder,
								A3(
									$author$project$AuditPb$optional,
									'enabled_by_name',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$AuditPb$optional,
										'enabled_at',
										$author$project$AuditPb$timestampDecoder,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'enabled',
											$elm$json$Json$Decode$bool,
											$author$project$AuditPb$decode($author$project$AuditPb$FactorBrokerSettings_LoadIdAutoRelease))))))))));
	});
var $author$project$AuditPb$RulesModeUnset = {$: 'RulesModeUnset'};
var $author$project$AuditPb$rulesModeDefault = $author$project$AuditPb$RulesModeUnset;
var $author$project$AuditPb$RulesModeOff = {$: 'RulesModeOff'};
var $author$project$AuditPb$RulesModeOn = {$: 'RulesModeOn'};
var $author$project$AuditPb$RulesModeSecret = {$: 'RulesModeSecret'};
var $author$project$AuditPb$allRulesMode = _List_fromArray(
	[$author$project$AuditPb$RulesModeUnset, $author$project$AuditPb$RulesModeSecret, $author$project$AuditPb$RulesModeOn, $author$project$AuditPb$RulesModeOff]);
var $author$project$AuditPb$rulesModeToString = function (v) {
	switch (v.$) {
		case 'RulesModeUnset':
			return 'unset';
		case 'RulesModeSecret':
			return 'secret';
		case 'RulesModeOn':
			return 'on';
		default:
			return 'off';
	}
};
var $author$project$AuditPb$rulesModeDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$rulesModeToString(v),
				v);
		},
		$author$project$AuditPb$allRulesMode));
var $author$project$AuditPb$rulesModeFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$rulesModeDict);
};
var $author$project$AuditPb$rulesModeDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$rulesModeDefault),
		$author$project$AuditPb$rulesModeFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$factorBrokerSettingsDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'load_id_strategies',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$repeated,
				'template_variables',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'load_id_auto_release',
					$author$project$AuditPb$factorBrokerSettings_LoadIdAutoReleaseDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'factor_broker_load_id_regression_rule_mode',
						$author$project$AuditPb$rulesModeDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'allow_autoprocessing',
							$elm$json$Json$Decode$bool,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'deduct_advances_from_invoice_total',
								$elm$json$Json$Decode$bool,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'add_accessorials_to_invoice_total',
									$elm$json$Json$Decode$bool,
									A3(
										$author$project$AuditPb$optional,
										'warn_if_amount_over',
										$author$project$AuditPb$intDecoder,
										A3(
											$author$project$AuditPb$repeated,
											'factor_invoice_extracted_fields',
											$author$project$AuditPb$factorBrokerSettings_InvoiceExtractedFieldDecoder,
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'require_verifications_workflow',
												$elm$json$Json$Decode$bool,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'exclude_from_verifications_workflow',
													$elm$json$Json$Decode$bool,
													A3(
														$author$project$AuditPb$requiredWithoutDefault,
														'pod_required',
														$elm$json$Json$Decode$bool,
														A3(
															$author$project$AuditPb$requiredWithoutDefault,
															'rate_confirmation_required',
															$elm$json$Json$Decode$bool,
															A3(
																$author$project$AuditPb$requiredWithoutDefault,
																'skip_auto_stamp',
																$elm$json$Json$Decode$bool,
																A3(
																	$author$project$AuditPb$optional,
																	'customer_invoice_template_id',
																	A2($elm$json$Json$Decode$map, $author$project$Domain$CustomerInvoiceTemplateId$fromInt, $author$project$AuditPb$intDecoder),
																	A3(
																		$author$project$AuditPb$requiredWithoutDefault,
																		'billing_interval',
																		$author$project$AuditPb$billingIntervalDecoder,
																		A3(
																			$author$project$AuditPb$repeated,
																			'required_receivables_types',
																			$author$project$AuditPb$unresolvedDocumentTypeDecoder,
																			A3(
																				$author$project$AuditPb$repeated,
																				'customer_visible_document_types',
																				$author$project$AuditPb$unresolvedDocumentTypeDecoder,
																				A3(
																					$author$project$AuditPb$requiredWithoutDefault,
																					'delivery_method',
																					$author$project$AuditPb$deliveryMethodDecoder,
																					A3(
																						$author$project$AuditPb$requiredWithoutDefault,
																						'contact_info',
																						$elm$json$Json$Decode$string,
																						A3(
																							$author$project$AuditPb$requiredWithoutDefault,
																							'billing_email',
																							$elm$json$Json$Decode$string,
																							A3(
																								$author$project$AuditPb$requiredWithoutDefault,
																								'name',
																								$elm$json$Json$Decode$string,
																								A3(
																									$author$project$AuditPb$requiredWithoutDefault,
																									'id',
																									A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $author$project$AuditPb$intDecoder),
																									$author$project$AuditPb$decode($author$project$AuditPb$FactorBrokerSettings))))))))))))))))))))))));
	});
var $author$project$Domain$FactorBrokerSettings$decode = $author$project$AuditPb$factorBrokerSettingsDecoder;
var $author$project$Forward$AppSpecific$Cache$factorBrokerSettings = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.factorBrokerSettings;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{factorBrokerSettings: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerSettings = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$factorBrokerSettings,
		decoder: $author$project$Domain$FactorBrokerSettings$decode,
		entrypoint: 'factorBrokerSettingsV2',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorBrokerId$toInt)
	});
var $author$project$Components$SettingsPage$DebtorLayout$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerInvoiceTemplates,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings,
						A2(
							$author$project$Forward$Lookup$apply,
							A2($author$project$Forward$Lookup$startFrom, model.debtorId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerSettings),
							$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$DebtorLayout$Data)))))));
};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$Data = F4(
	function (account, accountSettings, currentUser, allReferenceFieldLabels) {
		return {account: account, accountSettings: accountSettings, allReferenceFieldLabels: allReferenceFieldLabels, currentUser: currentUser};
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$allReferenceFieldLabels,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ReferenceFieldsLayout$Data)))));
var $author$project$Components$SettingsPage$ReportsLayout$Data = F3(
	function (account, accountSettings, currentUser) {
		return {account: account, accountSettings: accountSettings, currentUser: currentUser};
	});
var $author$project$Components$SettingsPage$ReportsLayout$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
			$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$ReportsLayout$Data))));
var $author$project$Components$SettingsPage$RulesLayout$Data = F3(
	function (account, settings, user) {
		return {account: account, settings: settings, user: user};
	});
var $author$project$Components$SettingsPage$RulesLayout$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
			$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$RulesLayout$Data))));
var $author$project$Components$SettingsPage$UserLayout$Data = F4(
	function (account, accountSettings, currentUser, maybeUser) {
		return {account: account, accountSettings: accountSettings, currentUser: currentUser, maybeUser: maybeUser};
	});
var $author$project$Components$SettingsPage$UserLayout$maybeUserId = function (mode) {
	switch (mode.$) {
		case 'NewMode':
			return $elm$core$Maybe$Nothing;
		case 'EditMode':
			var userId = mode.a;
			return $elm$core$Maybe$Just(userId);
		default:
			var userId = mode.a;
			return $elm$core$Maybe$Just(userId);
	}
};
var $author$project$Components$SettingsPage$UserLayout$loadData = function (model) {
	var maybeUser = function () {
		var _v0 = $author$project$Components$SettingsPage$UserLayout$maybeUserId(model.mode);
		if (_v0.$ === 'Just') {
			var userId = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$elm$core$Maybe$Just,
				A2($author$project$Forward$Lookup$startFrom, userId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$user));
		} else {
			return $author$project$Forward$Lookup$succeed($elm$core$Maybe$Nothing);
		}
	}();
	return A2(
		$author$project$Forward$Lookup$apply,
		maybeUser,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
					$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$UserLayout$Data)))));
};
var $author$project$Components$SettingsPage$UsersLayout$Data = F4(
	function (account, accountSettings, users, user) {
		return {account: account, accountSettings: accountSettings, user: user, users: users};
	});
var $author$project$Components$SettingsPage$UsersLayout$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$users,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
				$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$UsersLayout$Data)))));
var $author$project$Components$SettingsPage$VerificationsLayout$Data = F6(
	function (logins, matchedDebtors, unMatchedDebtors, account, accountSettings, user) {
		return {account: account, accountSettings: accountSettings, logins: logins, matchedDebtors: matchedDebtors, unMatchedDebtors: unMatchedDebtors, user: user};
	});
var $author$project$Forward$AppSpecific$Cache$list_verificationsLogin = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_verificationsLogin;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_verificationsLogin: e});
		}));
var $author$project$AuditPb$VerificationsLogin = F4(
	function (loginId, loginUser, debtorId, debtorName) {
		return {debtorId: debtorId, debtorName: debtorName, loginId: loginId, loginUser: loginUser};
	});
var $author$project$Domain$NetworkBrokerId$NetworkBrokerId = function (a) {
	return {$: 'NetworkBrokerId', a: a};
};
var $author$project$Domain$NetworkBrokerId$fromInt = function (_int) {
	return $author$project$Domain$NetworkBrokerId$NetworkBrokerId(_int);
};
var $author$project$Domain$VerificationsLoginId$VerificationsLoginId = function (a) {
	return {$: 'VerificationsLoginId', a: a};
};
var $author$project$Domain$VerificationsLoginId$fromInt = function (_int) {
	return $author$project$Domain$VerificationsLoginId$VerificationsLoginId(_int);
};
var $author$project$AuditPb$verificationsLoginDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'debtor_name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'debtor_id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$NetworkBrokerId$fromInt, $author$project$AuditPb$intDecoder),
				A3(
					$author$project$AuditPb$optional,
					'login_user',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$optional,
						'login_id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$VerificationsLoginId$fromInt, $author$project$AuditPb$intDecoder),
						$author$project$AuditPb$decode($author$project$AuditPb$VerificationsLogin)))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsLogins = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_verificationsLogin,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$verificationsLoginDecoder),
		entrypoint: 'verificationsLogins',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Forward$AppSpecific$Cache$list_networkBroker = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_networkBroker;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_networkBroker: e});
		}));
var $author$project$AuditPb$NetworkBroker = F5(
	function (id, name, mcNumber, verificationsMode, isMatched) {
		return {id: id, isMatched: isMatched, mcNumber: mcNumber, name: name, verificationsMode: verificationsMode};
	});
var $author$project$AuditPb$networkBrokerDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'is_matched',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'verifications_mode',
				$author$project$AuditPb$verificationsModeDecoder,
				A3(
					$author$project$AuditPb$optional,
					'mc_number',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$NetworkBrokerId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$NetworkBroker))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsMatchedDebtors = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_networkBroker,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$networkBrokerDecoder),
		entrypoint: 'verificationsMatchedDebtors',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsUnmatchedDebtors = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_networkBroker,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$networkBrokerDecoder),
		entrypoint: 'verificationsUnmatchedDebtors',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Components$SettingsPage$VerificationsLayout$loadData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsUnmatchedDebtors,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsMatchedDebtors,
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsLogins,
						$author$project$Forward$Lookup$succeed($author$project$Components$SettingsPage$VerificationsLayout$Data)))))));
var $author$project$Factoring$Page$ClientSubmissionInvoice$Data = function (pageData) {
	return function (originalSelection) {
		return function (submission) {
			return function (invoiceDocuments) {
				return function (documentBatch) {
					return function (documentTypeSettings) {
						return function (accountSettings) {
							return function (hasUnreviewedGroups) {
								return function (allGroupsUnreviewed) {
									return function (debtorWithAddressTypeahead) {
										return function (submissionDropdown) {
											return {accountSettings: accountSettings, allGroupsUnreviewed: allGroupsUnreviewed, debtorWithAddressTypeahead: debtorWithAddressTypeahead, documentBatch: documentBatch, documentTypeSettings: documentTypeSettings, hasUnreviewedGroups: hasUnreviewedGroups, invoiceDocuments: invoiceDocuments, originalSelection: originalSelection, pageData: pageData, submission: submission, submissionDropdown: submissionDropdown};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$isFirstGroup = function (maybeGroup) {
	if (maybeGroup.$ === 'Nothing') {
		return false;
	} else {
		if (!maybeGroup.a) {
			return true;
		} else {
			return false;
		}
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$areAllGroupsUnreviewed = function (emailId) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Factoring$Page$ClientSubmission$CacheData$getFirstUnreviewedGroupNumber(emailId),
		$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$ClientSubmissionInvoice$isFirstGroup));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$unreviewedGroupsExist = function (maybeGroup) {
	if (maybeGroup.$ === 'Nothing') {
		return false;
	} else {
		return true;
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$hasUnreviewedGroups = function (emailId) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Factoring$Page$ClientSubmission$CacheData$getFirstUnreviewedGroupNumber(emailId),
		$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$ClientSubmissionInvoice$unreviewedGroupsExist));
};
var $author$project$Components$DebtorWithAddressTypeahead$DebtorWithAddress = F2(
	function (factorBroker, address) {
		return {address: address, factorBroker: factorBroker};
	});
var $author$project$Components$DebtorWithAddressTypeahead$loadData = function (carrierId) {
	var debtorWithAddress = A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerToPaymentAddress,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$identity,
			$author$project$Forward$Lookup$succeed($author$project$Components$DebtorWithAddressTypeahead$DebtorWithAddress)));
	var findById = A2($author$project$Forward$Lookup$traverse, debtorWithAddress, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker);
	var search = function (searchTerm) {
		return A2(
			$author$project$Forward$Lookup$traverseList,
			debtorWithAddress,
			A2(
				$author$project$Forward$Lookup$startFrom,
				{carrierId: carrierId, term: searchTerm, useSimpleSearch: false},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokersByQuery));
	};
	return A2($author$project$Typeahead$loadData, findById, search);
};
var $author$project$AuditPb$clientSubmissionIdsQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page),
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'email_message_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$EmailMessageId$toInt),
					v.emailMessageId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'term', $elm$json$Json$Encode$string, v.term)
				])));
};
var $author$project$Forward$AppSpecific$Cache$page_factorInvoiceSubmissionId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.page_factorInvoiceSubmissionId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{page_factorInvoiceSubmissionId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$availableClientSubmissionDropdownDataByQuery = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_factorInvoiceSubmissionId,
		entrypoint: 'availableClientSubmissionIdsByQuery',
		idFromInt: $author$project$Domain$FactorInvoiceSubmissionId$fromInt,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionDropdownDataByFactorInvoiceSubmissionId,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$clientSubmissionIdsQueryEncoder)
	});
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$loadData = function (model) {
	var dropdown = model.dropdown;
	return A2(
		$author$project$Components$PaginatedDropdown$loadData,
		function (_v0) {
			var term = _v0.term;
			var page = _v0.page;
			return A2(
				$author$project$Forward$Lookup$startFrom,
				{emailMessageId: model.emailMessageId, page: page, term: term},
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$availableClientSubmissionDropdownDataByQuery);
		},
		dropdown);
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$loadData = function (model) {
	var invoiceId = model.factorInvoiceId;
	var loadDocumentsForInvoice = $author$project$Forward$Lookup$waitForAllList(
		A2(
			$author$project$Forward$Lookup$startFrom,
			invoiceId,
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)));
	var emailId = model.emailMessageId;
	var loadMaybeDocumentBatch = A2(
		$author$project$Forward$Lookup$startFrom,
		emailId,
		A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage));
	var loadOriginalSelection = A2(
		$author$project$Forward$Lookup$map,
		function (_v0) {
			var pageData = _v0.a;
			var groupSubmissionData = _v0.b;
			return A2(
				$elm$core$Result$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$author$project$Factoring$Page$ClientSubmissionInvoice$firstPageOf(pageData)),
				groupSubmissionData);
		},
		A2($author$project$Factoring$Page$ClientSubmission$CacheData$withFirstOnly, emailId, invoiceId));
	var loadPageData = A2(
		$author$project$Forward$Lookup$map,
		$elm$core$Tuple$first,
		A2($author$project$Factoring$Page$ClientSubmission$CacheData$withFirstOnly, emailId, invoiceId));
	var loadSubmission = A2(
		$author$project$Forward$Lookup$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			$elm$core$Result$map($elm$core$Tuple$second)),
		A2($author$project$Factoring$Page$ClientSubmission$CacheData$withFirstOnly, emailId, invoiceId));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$loadData(model.submissionDropdown),
		A2(
			$author$project$Forward$Lookup$apply,
			A2($author$project$Components$DebtorWithAddressTypeahead$loadData, $elm$core$Maybe$Nothing, model.debtorWithAddressTypeahead),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Factoring$Page$ClientSubmissionInvoice$areAllGroupsUnreviewed(emailId)),
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$Lookup$exposeLoadingState(
						$author$project$Factoring$Page$ClientSubmissionInvoice$hasUnreviewedGroups(emailId)),
					A2(
						$author$project$Forward$Lookup$apply,
						$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings),
							A2(
								$author$project$Forward$Lookup$apply,
								loadMaybeDocumentBatch,
								A2(
									$author$project$Forward$Lookup$apply,
									loadDocumentsForInvoice,
									A2(
										$author$project$Forward$Lookup$apply,
										loadSubmission,
										A2(
											$author$project$Forward$Lookup$apply,
											loadOriginalSelection,
											A2(
												$author$project$Forward$Lookup$apply,
												loadPageData,
												$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$ClientSubmissionInvoice$Data))))))))))));
};
var $author$project$Factoring$Page$ClientSubmissionReview$Data = F4(
	function (pageData, sections, user, documentTypeSettings) {
		return {documentTypeSettings: documentTypeSettings, pageData: pageData, sections: sections, user: user};
	});
var $author$project$Factoring$Page$ClientSubmissionReview$Sections = F2(
	function (approved, rejected) {
		return {approved: approved, rejected: rejected};
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$passing = function (_v0) {
	var data = _v0.data;
	switch (data.$) {
		case 'Required':
			return false;
		case 'Skippable':
			if (data.a.a.$ === 'Enabled') {
				var _v2 = data.a;
				var _v3 = _v2.a;
				return false;
			} else {
				var _v4 = data.a;
				var _v5 = _v4.a;
				return true;
			}
		default:
			if (data.a.a.$ === 'Enabled') {
				var _v6 = data.a;
				var _v7 = _v6.a;
				return false;
			} else {
				var _v8 = data.a;
				var _v9 = _v8.a;
				return true;
			}
	}
};
var $author$project$Factoring$Page$ClientSubmissionReview$toSections = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$partition(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.invoice;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.exceptions;
				},
				$elm$core$List$all($author$project$Factoring$Page$ClientSubmission$CacheData$Exception$passing)))),
	function (_v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2($author$project$Factoring$Page$ClientSubmissionReview$Sections, a, b);
	});
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoicesByEmailMessageId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_factorInvoiceId,
		decoder: $author$project$Domain$FactorInvoiceId$decode,
		entrypoint: 'factorInvoiceIdsByEmailMessageId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$EmailMessageId$toInt)
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$withAll = function (emailId) {
	var submissions = A2(
		$author$project$Forward$Lookup$map,
		$elm_community$result_extra$Result$Extra$combine,
		A2($author$project$Forward$Lookup$traverseList, $author$project$Factoring$Page$ClientSubmission$CacheData$getSubmission, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoicesByEmailMessageId));
	return A2(
		$author$project$Forward$Lookup$startFrom,
		emailId,
		A2(
			$author$project$Forward$Lookup$apply,
			submissions,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Indexer$EmailMessageData$loadAll,
				$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair))));
};
var $author$project$Factoring$Page$ClientSubmissionReview$loadData = function (_v0) {
	var emailMessageId = _v0.emailMessageId;
	var loadSections = A2(
		$author$project$Forward$Lookup$map,
		$elm$core$Result$map($author$project$Factoring$Page$ClientSubmissionReview$toSections),
		A2(
			$author$project$Forward$Lookup$map,
			$elm$core$Tuple$second,
			$author$project$Factoring$Page$ClientSubmission$CacheData$withAll(emailMessageId)));
	var loadPageData = A2(
		$author$project$Forward$Lookup$map,
		$elm$core$Tuple$first,
		$author$project$Factoring$Page$ClientSubmission$CacheData$withAll(emailMessageId));
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
			A2(
				$author$project$Forward$Lookup$apply,
				loadSections,
				A2(
					$author$project$Forward$Lookup$apply,
					loadPageData,
					$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$ClientSubmissionReview$Data)))));
};
var $author$project$Factoring$Page$VerificationBatch$Data = function (account) {
	return function (accountSettings) {
		return function (verificationMethodIds) {
			return function (debtorBatch) {
				return function (debtor) {
					return function (debtorContactIds) {
						return function (itemIds) {
							return function (verificationMethods) {
								return function (debtorContacts) {
									return function (items) {
										return function (documentsData) {
											return function (confirmationMessages) {
												return {account: account, accountSettings: accountSettings, confirmationMessages: confirmationMessages, debtor: debtor, debtorBatch: debtorBatch, debtorContactIds: debtorContactIds, debtorContacts: debtorContacts, documentsData: documentsData, itemIds: itemIds, items: items, verificationMethodIds: verificationMethodIds, verificationMethods: verificationMethods};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Forward$AppSpecific$Cache$cadenceDebtorContact = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.cadenceDebtorContact;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{cadenceDebtorContact: e});
		}));
var $author$project$AuditPb$CadenceDebtorContact = F5(
	function (id, firstName, lastName, email, phone) {
		return {email: email, firstName: firstName, id: id, lastName: lastName, phone: phone};
	});
var $author$project$AuditPb$cadenceDebtorContactDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'phone',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'email',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'last_name',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'first_name',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'id',
							A2($elm$json$Json$Decode$map, $author$project$Domain$CadenceDebtorContactId$fromInt, $author$project$AuditPb$intDecoder),
							$author$project$AuditPb$decode($author$project$AuditPb$CadenceDebtorContact))))));
	});
var $author$project$Domain$CadenceDebtorContact$decode = $author$project$AuditPb$cadenceDebtorContactDecoder;
var $author$project$Domain$CadenceDebtorContactId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceDebtorContact = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$cadenceDebtorContact,
		decoder: $author$project$Domain$CadenceDebtorContact$decode,
		entrypoint: 'cadenceDebtorContact',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CadenceDebtorContactId$toInt)
	});
var $author$project$Forward$AppSpecific$Cache$cadenceVerificationMethod = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.cadenceVerificationMethod;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{cadenceVerificationMethod: e});
		}));
var $author$project$AuditPb$CadenceVerificationMethod = F2(
	function (id, description) {
		return {description: description, id: id};
	});
var $author$project$AuditPb$cadenceVerificationMethodDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$Domain$CadenceVerificationMethodId$fromInt, $author$project$AuditPb$intDecoder),
				$author$project$AuditPb$decode($author$project$AuditPb$CadenceVerificationMethod)));
	});
var $author$project$Domain$CadenceVerificationMethodId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceVerificationMethod = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$cadenceVerificationMethod,
		decoder: $author$project$AuditPb$cadenceVerificationMethodDecoder,
		entrypoint: 'cadenceVerificationMethod',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CadenceVerificationMethodId$toInt)
	});
var $author$project$Domain$CadenceVerificationMethodId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$CadenceVerificationMethodId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$list_cadenceVerificationMethodId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_cadenceVerificationMethodId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_cadenceVerificationMethodId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceVerificationMethodIds = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_cadenceVerificationMethodId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$CadenceVerificationMethodId$decode),
		entrypoint: 'cadenceVerificationMethodIds',
		parameters: $author$project$Forward$Lookup$noParameters
	});
var $author$project$Factoring$Page$VerificationBatch$Load$loadDocumentData = A2(
	$author$project$Forward$Lookup$apply,
	A2(
		$author$project$Forward$Lookup$traverseList,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages,
		$author$project$Forward$Lookup$waitForAllList(
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorInvoice))),
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$Lookup$waitForAllList(
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorInvoice)),
		$author$project$Forward$Lookup$succeed($author$project$Components$DocumentBrowser$Full$DocumentData)));
var $author$project$Factoring$Page$VerificationBatch$Load$maybeLoadDocument = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$Lookup$exposeLoadingState($author$project$Factoring$Page$VerificationBatch$Load$loadDocumentData),
	A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$map,
			function ($) {
				return $.factorInvoiceId;
			},
			$author$project$Forward$Lookup$identity),
		$author$project$Forward$Lookup$succeed($elm$core$Tuple$pair)));
var $author$project$Domain$FactorInvoiceId$toComparable = function (id) {
	return _Utils_Tuple2(
		'factorInvoiceId',
		$author$project$Domain$FactorInvoiceId$toInt(id));
};
var $author$project$Factoring$Page$VerificationBatch$Load$documentsData = function () {
	var documentDataDictFromList = function (dataList) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var id = _v0.a;
					var data = _v0.b;
					return _Utils_Tuple2(
						$author$project$Domain$FactorInvoiceId$toComparable(id),
						data);
				},
				A2($elm$core$List$filterMap, $author$project$Forward$Remote$toMaybe, dataList)));
	};
	return A2(
		$author$project$Forward$Lookup$map,
		documentDataDictFromList,
		A2(
			$author$project$Forward$Lookup$traverseList,
			$author$project$Forward$Lookup$exposeLoadingState($author$project$Factoring$Page$VerificationBatch$Load$maybeLoadDocument),
			$author$project$Forward$Lookup$identity));
}();
var $author$project$Factoring$Page$VerificationBatch$Load$ItemData = F8(
	function (item, invoice, tmsCarrier, maybeAutoVerification, maybeAgingAndPaymentData, debtorContact, verificationMethod, debtorVisibleDocumentUrl) {
		return {debtorContact: debtorContact, debtorVisibleDocumentUrl: debtorVisibleDocumentUrl, invoice: invoice, item: item, maybeAgingAndPaymentData: maybeAgingAndPaymentData, maybeAutoVerification: maybeAutoVerification, tmsCarrier: tmsCarrier, verificationMethod: verificationMethod};
	});
var $author$project$Factoring$Page$VerificationBatch$Load$AgingAndPaymentData = F2(
	function (aging, paymentCount) {
		return {aging: aging, paymentCount: paymentCount};
	});
var $author$project$Forward$AppSpecific$Cache$factorAging = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.factorAging;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{factorAging: e});
		}));
var $author$project$AuditPb$FactorAging = F2(
	function (noaSentAt, noaReceivedAt) {
		return {noaReceivedAt: noaReceivedAt, noaSentAt: noaSentAt};
	});
var $author$project$AuditPb$factorAgingDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'noa_received_at',
			$author$project$AuditPb$timestampDecoder,
			A3(
				$author$project$AuditPb$optional,
				'noa_sent_at',
				$author$project$AuditPb$timestampDecoder,
				$author$project$AuditPb$decode($author$project$AuditPb$FactorAging)));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorAgingByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$factorAging,
		decoder: $author$project$AuditPb$factorAgingDecoder,
		entrypoint: 'factorAgingByInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorAging = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorAgingByFactorInvoiceId,
		fieldName: 'factorAging',
		getId: function ($) {
			return $.factorInvoiceId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$int = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $._int;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{_int: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$paymentCountByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$int,
		decoder: $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed(0)
				])),
		entrypoint: 'paymentCountByInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToPaymentCount = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$paymentCountByFactorInvoiceId,
		fieldName: 'paymentCount',
		getId: function ($) {
			return $.factorInvoiceId;
		}
	});
var $author$project$Factoring$Page$VerificationBatch$Load$loadAgingAndPaymentData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToPaymentCount,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorAging,
		$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$VerificationBatch$Load$AgingAndPaymentData)));
var $author$project$Factoring$Page$VerificationBatch$Load$maybeAgingAndPaymentData = A3(
	$author$project$Forward$Lookup$ifVia,
	$author$project$Forward$Lookup$fromRoot($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
	function (accountSettings) {
		return !_Utils_eq(accountSettings.considerNoaDataForVerifications, $author$project$AuditPb$ConsiderNoaDataForVerificationsDontConsiderNoa);
	},
	$author$project$Factoring$Page$VerificationBatch$Load$loadAgingAndPaymentData);
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToAutoVerification = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$autoVerificationByFactorInvoiceId,
		fieldName: 'autoVerification',
		getId: function ($) {
			return $.factorInvoiceId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToCadenceDebtorContact = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceDebtorContact,
		fieldName: 'cadenceDebtorContact',
		getId: function ($) {
			return $.cadenceDebtorContactId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToCadenceVerificationMethod = $author$project$Forward$Lookup$defineMaybeEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceVerificationMethod,
		fieldName: 'cadenceVerificationMethod',
		getId: function ($) {
			return $.cadenceVerificationMethodId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$string = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.string;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{string: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorVisibleFactorInvoiceDocumentURLByFactorInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$string,
		decoder: $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed('')
				])),
		entrypoint: 'debtorVisibleFactorInvoiceDocumentURL',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToDebtorVisibleFactorInvoiceDocumentURL = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorVisibleFactorInvoiceDocumentURLByFactorInvoiceId,
		fieldName: 'debtorVisibleFactorInvoiceDocumentURL',
		getId: function ($) {
			return $.factorInvoiceId;
		}
	});
var $author$project$Factoring$Page$VerificationBatch$Load$loadItemData = A2(
	$author$project$Forward$Lookup$apply,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToDebtorVisibleFactorInvoiceDocumentURL,
	A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToCadenceVerificationMethod,
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToCadenceDebtorContact,
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Factoring$Page$VerificationBatch$Load$maybeAgingAndPaymentData,
				A2(
					$author$project$Forward$Lookup$apply,
					$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToAutoVerification,
					A2(
						$author$project$Forward$Lookup$apply,
						A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorInvoice),
						A2(
							$author$project$Forward$Lookup$apply,
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorInvoice,
							A2(
								$author$project$Forward$Lookup$apply,
								$author$project$Forward$Lookup$identity,
								$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$VerificationBatch$Load$ItemData)))))))));
var $author$project$Factoring$Page$VerificationBatch$Load$items = $author$project$Forward$Lookup$exposeLoadingState(
	A2(
		$author$project$Forward$Lookup$traverse,
		$author$project$Factoring$Page$VerificationBatch$Load$loadItemData,
		$author$project$Forward$Lookup$applyTimestampInvalidation($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItem)));
var $author$project$Forward$AppSpecific$Cache$list_verificationsDebtorBatchItemId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_verificationsDebtorBatchItemId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_verificationsDebtorBatchItemId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemIdsByDebtorBatchId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_verificationsDebtorBatchItemId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$VerificationsDebtorBatchItemId$decode),
		entrypoint: 'verificationsDebtorBatchItemIdsByDebtorBatchId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$VerificationsDebtorBatchId$toInt)
	});
var $author$project$Domain$CadenceDebtorContactId$decode = A2($elm$json$Json$Decode$map, $author$project$Domain$CadenceDebtorContactId$fromInt, $elm$json$Json$Decode$int);
var $author$project$Forward$AppSpecific$Cache$list_cadenceDebtorContactId = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_cadenceDebtorContactId;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_cadenceDebtorContactId: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceDebtorContactIdsByFactorBrokerId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_cadenceDebtorContactId,
		decoder: $elm$json$Json$Decode$list($author$project$Domain$CadenceDebtorContactId$decode),
		entrypoint: 'cadenceDebtorContactIdsByFactorBrokerId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$FactorBrokerId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToCadenceDebtorContactIds = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceDebtorContactIdsByFactorBrokerId,
		fieldName: 'cadenceDebtorContactIds',
		getId: function ($) {
			return $.factorBrokerId;
		}
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToConfirmationEmailMessages = $author$project$Forward$Lookup$defineListEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage,
		fieldName: 'confirmationEmailMessages',
		getIds: function ($) {
			return $.confirmationEmailMessageIds;
		}
	});
var $author$project$Factoring$Page$VerificationBatch$loadData = function (model) {
	var debtorBatchId = model.debtorBatchId;
	return A2(
		$author$project$Forward$Lookup$apply,
		A2(
			$author$project$Forward$Lookup$startFrom,
			debtorBatchId,
			A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToConfirmationEmailMessages, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch)),
		A2(
			$author$project$Forward$Lookup$apply,
			A2(
				$author$project$Forward$Lookup$startFrom,
				debtorBatchId,
				A2(
					$author$project$Forward$Lookup$traverse,
					$author$project$Factoring$Page$VerificationBatch$Load$documentsData,
					A2($author$project$Forward$Lookup$traverseList, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItem, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemIdsByDebtorBatchId))),
			A2(
				$author$project$Forward$Lookup$apply,
				A2(
					$author$project$Forward$Lookup$startFrom,
					debtorBatchId,
					A2(
						$author$project$Forward$Lookup$traverseList,
						$author$project$Factoring$Page$VerificationBatch$Load$items,
						A2(
							$author$project$Forward$Lookup$map,
							$elm$core$List$map(
								function (itemId) {
									return _Utils_Tuple2(itemId, model.requireItemsNewerThan);
								}),
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemIdsByDebtorBatchId))),
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$startFrom,
						debtorBatchId,
						A2(
							$author$project$Forward$Lookup$traverseList,
							$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceDebtorContact),
							A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToCadenceDebtorContactIds, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch))),
					A2(
						$author$project$Forward$Lookup$apply,
						A2(
							$author$project$Forward$Lookup$traverseList,
							$author$project$Forward$Lookup$exposeLoadingState($author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceVerificationMethod),
							$author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceVerificationMethodIds),
						A2(
							$author$project$Forward$Lookup$apply,
							A2($author$project$Forward$Lookup$startFrom, debtorBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemIdsByDebtorBatchId),
							A2(
								$author$project$Forward$Lookup$apply,
								A2(
									$author$project$Forward$Lookup$startFrom,
									debtorBatchId,
									A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToCadenceDebtorContactIds, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch)),
								A2(
									$author$project$Forward$Lookup$apply,
									A2(
										$author$project$Forward$Lookup$startFrom,
										debtorBatchId,
										A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToFactorBroker, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch)),
									A2(
										$author$project$Forward$Lookup$apply,
										A2($author$project$Forward$Lookup$startFrom, debtorBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch),
										A2(
											$author$project$Forward$Lookup$apply,
											$author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceVerificationMethodIds,
											A2(
												$author$project$Forward$Lookup$apply,
												$author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings,
												A2(
													$author$project$Forward$Lookup$apply,
													$author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount,
													$author$project$Forward$Lookup$succeed($author$project$Factoring$Page$VerificationBatch$Data)))))))))))));
};
var $author$project$Components$NoaManagement$SentPage$CarrierDropdownMsg = function (a) {
	return {$: 'CarrierDropdownMsg', a: a};
};
var $author$project$Components$NoaManagement$SentPage$DebtorDropdownMsg = function (a) {
	return {$: 'DebtorDropdownMsg', a: a};
};
var $author$project$Components$NoaManagement$SentPage$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (item.$ === 'Just') {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Components$DebtorDropdown$nameAndMcNumber = function (factorBroker) {
	return A2(
		$elm$core$String$join,
		' - ',
		$elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					$elm$core$Maybe$Just(factorBroker.name),
					factorBroker.mcNumber
				])));
};
var $author$project$Components$DebtorDropdown$debtorToSelectedItem = function (factorBroker) {
	return {
		id: $elm$core$String$fromInt(
			$author$project$Domain$FactorBrokerId$toInt(factorBroker.id)),
		label: $elm$html$Html$text(
			$author$project$Components$DebtorDropdown$nameAndMcNumber(factorBroker)),
		text: $author$project$Components$DebtorDropdown$nameAndMcNumber(factorBroker)
	};
};
var $author$project$Components$DebtorDropdown$init = function (_v0) {
	var attrs = _v0.attrs;
	var selected = _v0.selected;
	var _v1 = $author$project$Components$PaginatedDropdown$init(
		{
			attrs: A2(
				$elm$core$List$cons,
				$author$project$Ui$V3$CustomSelect$autoFilter(false),
				attrs),
			domId: 'debtor',
			lastItems: _List_Nil,
			otherItems: _List_Nil,
			selectedItems: A2($elm$core$List$map, $author$project$Components$DebtorDropdown$debtorToSelectedItem, selected)
		});
	var dropdown = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		{dropdown: dropdown},
		cmd);
};
var $author$project$Components$CarrierDropdown$maybeAddressString = function (_v0) {
	var state = _v0.state;
	var city = _v0.city;
	var addressLine1 = _v0.addressLine1;
	var _v1 = _Utils_Tuple3(addressLine1, city, state);
	_v1$2:
	while (true) {
		if (_v1.a.$ === 'Just') {
			if ((_v1.b.$ === 'Just') && (_v1.c.$ === 'Just')) {
				var addressLine1_ = _v1.a.a;
				var city_ = _v1.b.a;
				var state_ = _v1.c.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[addressLine1_, city_, state_])));
			} else {
				break _v1$2;
			}
		} else {
			if ((_v1.b.$ === 'Just') && (_v1.c.$ === 'Just')) {
				var _v2 = _v1.a;
				var city_ = _v1.b.a;
				var state_ = _v1.c.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[city_, state_])));
			} else {
				break _v1$2;
			}
		}
	}
	return addressLine1;
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Components$CarrierDropdown$maybeAppendWithBr = F2(
	function (maybeString, originalString) {
		if (maybeString.$ === 'Just') {
			var str = maybeString.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(originalString),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text(str)
					]));
		} else {
			return $elm$html$Html$text(originalString);
		}
	});
var $author$project$Components$CarrierDropdown$maybeAppendWith = F3(
	function (prefix, maybeString, originalString) {
		return _Utils_ap(
			originalString,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$append(prefix),
					maybeString)));
	});
var $author$project$Components$CarrierDropdown$maybeExternalId = F4(
	function (isFactor, showVendorId, externalId, originalString) {
		return (isFactor || showVendorId) ? A3($author$project$Components$CarrierDropdown$maybeAppendWith, ' - ', externalId, originalString) : originalString;
	});
var $author$project$Components$CarrierDropdown$nameText = F2(
	function (_v0, carrier) {
		var showVendorId = _v0.showVendorId;
		var isFactor = _v0.isFactor;
		return A4(
			$author$project$Components$CarrierDropdown$maybeExternalId,
			isFactor,
			showVendorId,
			carrier.externalVendorId,
			A3(
				$author$project$Components$CarrierDropdown$maybeAppendWith,
				' - SCAC ',
				carrier.scac,
				A3(
					$author$project$Components$CarrierDropdown$maybeAppendWith,
					' - EIN ',
					carrier.ein,
					A3($author$project$Components$CarrierDropdown$maybeAppendWith, ' - MC# ', carrier.mcNumber, carrier.name))));
	});
var $author$project$Components$CarrierDropdown$itemLabel = F2(
	function (accountInfo, carrier) {
		return A2(
			$author$project$Components$CarrierDropdown$maybeAppendWithBr,
			$author$project$Components$CarrierDropdown$maybeAddressString(carrier.address),
			A2($author$project$Components$CarrierDropdown$nameText, accountInfo, carrier));
	});
var $author$project$Components$CarrierDropdown$itemText = F2(
	function (accountInfo, carrier) {
		return A3(
			$author$project$Components$CarrierDropdown$maybeAppendWith,
			' - ',
			$author$project$Components$CarrierDropdown$maybeAddressString(carrier.address),
			A2($author$project$Components$CarrierDropdown$nameText, accountInfo, carrier));
	});
var $author$project$Components$CarrierDropdown$carrierToDropdownItem = F2(
	function (accountInfo, carrier) {
		return {
			id: $elm$core$String$fromInt(
				$author$project$Domain$TmsCarrierId$toInt(carrier.id)),
			label: A2($author$project$Components$CarrierDropdown$itemLabel, accountInfo, carrier),
			text: A2($author$project$Components$CarrierDropdown$itemText, accountInfo, carrier)
		};
	});
var $author$project$Components$CarrierDropdown$initWithLastCarriers = F2(
	function (lastCarriers, _v0) {
		var attrs = _v0.attrs;
		var showVendorId = _v0.showVendorId;
		var isFactor = _v0.isFactor;
		var selectedCarriers = _v0.selectedCarriers;
		var accountType = _v0.accountType;
		var accountInfo = {accountType: accountType, isFactor: isFactor, showVendorId: showVendorId};
		var _v1 = $author$project$Components$PaginatedDropdown$init(
			{
				attrs: A2(
					$elm$core$List$cons,
					$author$project$Ui$V3$CustomSelect$autoFilter(false),
					attrs),
				domId: $author$project$Domain$Account$carrierTerm(accountType),
				lastItems: A2(
					$elm$core$List$map,
					$author$project$Components$CarrierDropdown$carrierToDropdownItem(accountInfo),
					lastCarriers),
				otherItems: _List_Nil,
				selectedItems: A2(
					$elm$core$List$map,
					$author$project$Components$CarrierDropdown$carrierToDropdownItem(accountInfo),
					selectedCarriers)
			});
		var dropdown = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{accountInfo: accountInfo, dropdown: dropdown},
			cmd);
	});
var $author$project$Components$CarrierDropdown$initForAssignment = function (_v0) {
	var showVendorId = _v0.showVendorId;
	var isFactor = _v0.isFactor;
	var selectedCarriers = _v0.selectedCarriers;
	var accountType = _v0.accountType;
	return A2(
		$author$project$Components$CarrierDropdown$initWithLastCarriers,
		_List_Nil,
		{
			accountType: accountType,
			attrs: _List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
					$author$project$Ui$V3$CustomSelect$hideSelectAll(true)
				]),
			isFactor: isFactor,
			selectedCarriers: selectedCarriers,
			showVendorId: showVendorId
		});
};
var $author$project$Components$NoaManagement$SentPage$Data = F4(
	function (page, sandboxRecipients, debtorDropdown, carrierDropdown) {
		return {carrierDropdown: carrierDropdown, debtorDropdown: debtorDropdown, page: page, sandboxRecipients: sandboxRecipients};
	});
var $author$project$Forward$AppSpecific$Cache$sentNoa = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.sentNoa;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{sentNoa: e});
		}));
var $author$project$AuditPb$SentNoa = function (id) {
	return function (sentAt) {
		return function (factorBrokerId) {
			return function (debtorName) {
				return function (tmsCarrierId) {
					return function (clientName) {
						return function (sentToEmailAddress) {
							return function (addressSource) {
								return function (documentDisplay) {
									return function (sentByName) {
										return function (factoringSystemStatus) {
											return {addressSource: addressSource, clientName: clientName, debtorName: debtorName, documentDisplay: documentDisplay, factorBrokerId: factorBrokerId, factoringSystemStatus: factoringSystemStatus, id: id, sentAt: sentAt, sentByName: sentByName, sentToEmailAddress: sentToEmailAddress, tmsCarrierId: tmsCarrierId};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$AuditPb$SentNoa_AddressSourceUnknownAddressSource = {$: 'SentNoa_AddressSourceUnknownAddressSource'};
var $author$project$AuditPb$sentNoa_AddressSourceDefault = $author$project$AuditPb$SentNoa_AddressSourceUnknownAddressSource;
var $author$project$AuditPb$SentNoa_AddressSourceProposed = {$: 'SentNoa_AddressSourceProposed'};
var $author$project$AuditPb$SentNoa_AddressSourceTyped = {$: 'SentNoa_AddressSourceTyped'};
var $author$project$AuditPb$allSentNoa_AddressSource = _List_fromArray(
	[$author$project$AuditPb$SentNoa_AddressSourceUnknownAddressSource, $author$project$AuditPb$SentNoa_AddressSourceProposed, $author$project$AuditPb$SentNoa_AddressSourceTyped]);
var $author$project$AuditPb$sentNoa_AddressSourceToString = function (v) {
	switch (v.$) {
		case 'SentNoa_AddressSourceUnknownAddressSource':
			return 'UNKNOWN_ADDRESS_SOURCE';
		case 'SentNoa_AddressSourceProposed':
			return 'PROPOSED';
		default:
			return 'TYPED';
	}
};
var $author$project$AuditPb$sentNoa_AddressSourceDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$sentNoa_AddressSourceToString(v),
				v);
		},
		$author$project$AuditPb$allSentNoa_AddressSource));
var $author$project$AuditPb$sentNoa_AddressSourceFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$sentNoa_AddressSourceDict);
};
var $author$project$AuditPb$sentNoa_AddressSourceDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$sentNoa_AddressSourceDefault),
		$author$project$AuditPb$sentNoa_AddressSourceFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$SentNoa_FactoringSystemStatusUnknownFactoringSystemStatus = {$: 'SentNoa_FactoringSystemStatusUnknownFactoringSystemStatus'};
var $author$project$AuditPb$sentNoa_FactoringSystemStatusDefault = $author$project$AuditPb$SentNoa_FactoringSystemStatusUnknownFactoringSystemStatus;
var $author$project$AuditPb$SentNoa_FactoringSystemStatusAwaitingRelationship = {$: 'SentNoa_FactoringSystemStatusAwaitingRelationship'};
var $author$project$AuditPb$SentNoa_FactoringSystemStatusFailed = {$: 'SentNoa_FactoringSystemStatusFailed'};
var $author$project$AuditPb$SentNoa_FactoringSystemStatusNotApplicable = {$: 'SentNoa_FactoringSystemStatusNotApplicable'};
var $author$project$AuditPb$SentNoa_FactoringSystemStatusPending = {$: 'SentNoa_FactoringSystemStatusPending'};
var $author$project$AuditPb$SentNoa_FactoringSystemStatusSucceeded = {$: 'SentNoa_FactoringSystemStatusSucceeded'};
var $author$project$AuditPb$allSentNoa_FactoringSystemStatus = _List_fromArray(
	[$author$project$AuditPb$SentNoa_FactoringSystemStatusUnknownFactoringSystemStatus, $author$project$AuditPb$SentNoa_FactoringSystemStatusPending, $author$project$AuditPb$SentNoa_FactoringSystemStatusSucceeded, $author$project$AuditPb$SentNoa_FactoringSystemStatusFailed, $author$project$AuditPb$SentNoa_FactoringSystemStatusNotApplicable, $author$project$AuditPb$SentNoa_FactoringSystemStatusAwaitingRelationship]);
var $author$project$AuditPb$sentNoa_FactoringSystemStatusToString = function (v) {
	switch (v.$) {
		case 'SentNoa_FactoringSystemStatusUnknownFactoringSystemStatus':
			return 'UNKNOWN_FACTORING_SYSTEM_STATUS';
		case 'SentNoa_FactoringSystemStatusPending':
			return 'PENDING';
		case 'SentNoa_FactoringSystemStatusSucceeded':
			return 'SUCCEEDED';
		case 'SentNoa_FactoringSystemStatusFailed':
			return 'FAILED';
		case 'SentNoa_FactoringSystemStatusNotApplicable':
			return 'NOT_APPLICABLE';
		default:
			return 'AWAITING_RELATIONSHIP';
	}
};
var $author$project$AuditPb$sentNoa_FactoringSystemStatusDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$sentNoa_FactoringSystemStatusToString(v),
				v);
		},
		$author$project$AuditPb$allSentNoa_FactoringSystemStatus));
var $author$project$AuditPb$sentNoa_FactoringSystemStatusFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$sentNoa_FactoringSystemStatusDict);
};
var $author$project$AuditPb$sentNoa_FactoringSystemStatusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$sentNoa_FactoringSystemStatusDefault),
		$author$project$AuditPb$sentNoa_FactoringSystemStatusFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$sentNoaDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'factoring_system_status',
			$author$project$AuditPb$sentNoa_FactoringSystemStatusDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'sent_by_name',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'document_display',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'address_source',
						$author$project$AuditPb$sentNoa_AddressSourceDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'sent_to_email_address',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'client_name',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$AuditPb$requiredWithoutDefault,
									'tms_carrier_id',
									A2($elm$json$Json$Decode$map, $author$project$Domain$TmsCarrierId$fromInt, $author$project$AuditPb$intDecoder),
									A3(
										$author$project$AuditPb$requiredWithoutDefault,
										'debtor_name',
										$elm$json$Json$Decode$string,
										A3(
											$author$project$AuditPb$requiredWithoutDefault,
											'factor_broker_id',
											A2($elm$json$Json$Decode$map, $author$project$Domain$FactorBrokerId$fromInt, $author$project$AuditPb$intDecoder),
											A3(
												$author$project$AuditPb$requiredWithoutDefault,
												'sent_at',
												$author$project$AuditPb$timestampDecoder,
												A3(
													$author$project$AuditPb$requiredWithoutDefault,
													'id',
													$author$project$AuditPb$intDecoder,
													$author$project$AuditPb$decode($author$project$AuditPb$SentNoa))))))))))));
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$sentNoa = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$sentNoa,
		decoder: $author$project$AuditPb$sentNoaDecoder,
		entrypoint: 'sentNoa',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($elm$core$Basics$identity)
	});
var $author$project$AuditPb$sentNoasQueryEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'page', $elm$json$Json$Encode$int, v.page),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'factor_broker_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorBrokerId$toInt),
					v.factorBrokerId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'tms_carrier_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCarrierId$toInt),
					v.tmsCarrierId)
				])));
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$sentNoas = $author$project$Forward$Lookup$defineReferencePage(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$page_sentNoa,
		entrypoint: 'sentNoas',
		idFromInt: $elm$core$Basics$identity,
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$sentNoa,
		parameters: $author$project$Forward$Lookup$queryParameters($author$project$AuditPb$sentNoasQueryEncoder)
	});
var $author$project$Components$NoaManagement$SentPage$toQuery = function (model) {
	return {factorBrokerId: model.debtorId, page: model.pageNumber, tmsCarrierId: model.carrierId};
};
var $author$project$Components$NoaManagement$SentPage$loadData = function (model) {
	return A2(
		$author$project$Forward$Lookup$apply,
		$author$project$Components$CarrierDropdown$loadData(model.carrierDropdown),
		A2(
			$author$project$Forward$Lookup$apply,
			$author$project$Components$DebtorDropdown$loadData(model.debtorDropdown),
			A2(
				$author$project$Forward$Lookup$apply,
				$author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSandboxRecipients,
				A2(
					$author$project$Forward$Lookup$apply,
					A2(
						$author$project$Forward$Lookup$startFrom,
						$author$project$Components$NoaManagement$SentPage$toQuery(model),
						$author$project$Forward$AppSpecific$NeedsControllerEndpoints$sentNoas),
					$author$project$Forward$Lookup$succeed($author$project$Components$NoaManagement$SentPage$Data)))));
};
var $author$project$Components$NoaManagement$SentPage$singleSelect = _List_fromArray(
	[
		$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
		$author$project$Ui$V3$CustomSelect$hideSelectAll(true)
	]);
var $author$project$Components$NoaManagement$SentPage$ResendCompleted = function (a) {
	return {$: 'ResendCompleted', a: a};
};
var $author$project$Components$NoaManagement$SentPage$RetryCompleted = function (a) {
	return {$: 'RetryCompleted', a: a};
};
var $author$project$Ui$V3$CustomSelect$clearSelections = function (_v0) {
	var model = _v0.a;
	return $author$project$Ui$V3$CustomSelect$Model(
		_Utils_update(
			model,
			{excludedItems: _List_Nil, isOpen: false, selectedItems: _List_Nil}));
};
var $author$project$Components$PaginatedDropdown$clear = function (paginatedDropdown) {
	return _Utils_update(
		paginatedDropdown,
		{
			dropdown: $author$project$Ui$V3$CustomSelect$clearSelections(paginatedDropdown.dropdown)
		});
};
var $author$project$Components$CarrierDropdown$clear = function (model) {
	return _Utils_update(
		model,
		{
			dropdown: $author$project$Components$PaginatedDropdown$clear(model.dropdown)
		});
};
var $author$project$Components$DebtorDropdown$clear = function (model) {
	return _Utils_update(
		model,
		{
			dropdown: $author$project$Components$PaginatedDropdown$clear(model.dropdown)
		});
};
var $author$project$Components$NoaManagement$SentPage$filterByCarrier = F2(
	function (carrierId, model) {
		return _Utils_eq(carrierId, model.carrierId) ? model : _Utils_update(
			model,
			{carrierId: carrierId, pageNumber: 1});
	});
var $author$project$Components$NoaManagement$SentPage$filterByDebtor = F2(
	function (debtorId, model) {
		return _Utils_eq(debtorId, model.debtorId) ? model : _Utils_update(
			model,
			{debtorId: debtorId, pageNumber: 1});
	});
var $author$project$Components$NoaManagement$SentPage$humanResendErrorMessage = function (serverError) {
	switch (serverError) {
		case 'already_waiting':
			return 'This client and debtor already have an NOA waiting on the To Send tab.';
		case 'not_sent':
			return 'This NOA has not been sent, so there is nothing to send again. Reload the page.';
		default:
			return 'This NOA could not be queued again. Please reload the page and try again.';
	}
};
var $author$project$Components$NoaManagement$SentPage$humanRetryErrorMessage = function (serverError) {
	if (serverError === 'not_failed') {
		return 'This write-back is no longer failed. Reload the page to see its current status.';
	} else {
		return 'The write-back could not be retried. Please reload the page and try again.';
	}
};
var $author$project$Api$NoaSendQueueItems$resend = function (id) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts_payable/noa_send_queue_items/' + ($elm$core$String$fromInt(id) + '/resend'),
		$elm$json$Json$Encode$object(_List_Nil));
};
var $author$project$Api$NoaSendQueueItems$retryWriteBack = function (id) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts_payable/noa_send_queue_items/' + ($elm$core$String$fromInt(id) + '/retry_write_back'),
		$elm$json$Json$Encode$object(_List_Nil));
};
var $author$project$Ui$V3$CustomSelect$ChangeDebouncedInputValue = function (a) {
	return {$: 'ChangeDebouncedInputValue', a: a};
};
var $author$project$Ui$V3$CustomSelect$NoOp = {$: 'NoOp'};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Ui$V3$CustomSelect$defaultToFirstItem = F2(
	function (filteredItems, _v0) {
		var model = _v0.a;
		var selectedItemIsDisplayed = function () {
			var _v2 = $elm$core$List$head(model.selectedItems);
			if (_v2.$ === 'Just') {
				var item = _v2.a;
				return A2($elm$core$List$member, item, filteredItems);
			} else {
				return false;
			}
		}();
		var focusedOptionIdIsBlank = function () {
			var _v1 = model.focusedOptionId;
			if (_v1.$ === 'Just') {
				return false;
			} else {
				return true;
			}
		}();
		return model.isOpen && (model.singleSelectTypeahead && ((!model.isFilterable) && ((!selectedItemIsDisplayed) && focusedOptionIdIsBlank)));
	});
var $author$project$Ui$V3$CustomSelect$addExcludedItem = F2(
	function (existingItem, _v0) {
		var model = _v0.a;
		if (existingItem.$ === 'Nothing') {
			return model.excludedItems;
		} else {
			var value = existingItem.a;
			return model.multiSelectTypeahead ? A2(
				$elm$core$List$append,
				model.excludedItems,
				_List_fromArray(
					[value])) : _List_fromArray(
				[value]);
		}
	});
var $author$project$Ui$V3$CustomSelect$getExistingExcludedItemIndex = F2(
	function (_v0, id) {
		var model = _v0.a;
		return A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (item) {
				return _Utils_eq(item.id, id);
			},
			model.excludedItems);
	});
var $author$project$Ui$V3$CustomSelect$getExistingItem = F2(
	function (_v0, id) {
		var model = _v0.a;
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (item) {
				return _Utils_eq(item.id, id);
			},
			model.items);
	});
var $author$project$Ui$V3$CustomSelect$getExistingSelectedItemIndex = F2(
	function (_v0, id) {
		var model = _v0.a;
		return A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (item) {
				return _Utils_eq(item.id, id);
			},
			model.selectedItems);
	});
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $author$project$Ui$V3$CustomSelect$excludeItem = F2(
	function (id, _v0) {
		var model = _v0.a;
		var stayOpen = model.multiSelectTypeahead;
		var existingItem = A2(
			$author$project$Ui$V3$CustomSelect$getExistingItem,
			$author$project$Ui$V3$CustomSelect$Model(model),
			id);
		var _v1 = A2(
			$author$project$Ui$V3$CustomSelect$getExistingSelectedItemIndex,
			$author$project$Ui$V3$CustomSelect$Model(model),
			id);
		if (_v1.$ === 'Just') {
			var selectedIndex = _v1.a;
			return $author$project$Ui$V3$CustomSelect$Model(
				_Utils_update(
					model,
					{
						excludedItems: A2(
							$author$project$Ui$V3$CustomSelect$addExcludedItem,
							existingItem,
							$author$project$Ui$V3$CustomSelect$Model(model)),
						isOpen: stayOpen,
						selectedItems: A2($elm_community$list_extra$List$Extra$removeAt, selectedIndex, model.selectedItems)
					}));
		} else {
			var _v2 = A2(
				$author$project$Ui$V3$CustomSelect$getExistingExcludedItemIndex,
				$author$project$Ui$V3$CustomSelect$Model(model),
				id);
			if (_v2.$ === 'Just') {
				var excludedIndex = _v2.a;
				return $author$project$Ui$V3$CustomSelect$Model(
					_Utils_update(
						model,
						{
							excludedItems: A2($elm_community$list_extra$List$Extra$removeAt, excludedIndex, model.excludedItems),
							isOpen: stayOpen
						}));
			} else {
				return $author$project$Ui$V3$CustomSelect$Model(
					_Utils_update(
						model,
						{
							excludedItems: A2(
								$author$project$Ui$V3$CustomSelect$addExcludedItem,
								existingItem,
								$author$project$Ui$V3$CustomSelect$Model(model)),
							isOpen: stayOpen
						}));
			}
		}
	});
var $author$project$Ui$V3$CustomSelect$Unselected = {$: 'Unselected'};
var $author$project$Ui$V3$CustomSelect$getNextValueIndex = F2(
	function (matchingItems, existingValueIndex) {
		return _Utils_eq(
			existingValueIndex,
			$elm$core$List$length(matchingItems) - 1) ? 0 : (existingValueIndex + 1);
	});
var $author$project$Ui$V3$CustomSelect$getOptionWithSplitIndex = F3(
	function (options, indexToSplit, inputVal) {
		var startOfList = A2($elm$core$List$take, indexToSplit, options);
		var findItem = function (item) {
			return A2(
				$elm$core$String$startsWith,
				$elm$core$String$toLower(inputVal),
				$elm$core$String$toLower(item.text));
		};
		var endOfList = A2($elm$core$List$drop, indexToSplit, options);
		var resortedOptions = A2($elm$core$List$append, endOfList, startOfList);
		return A2($elm_community$list_extra$List$Extra$find, findItem, resortedOptions);
	});
var $author$project$Ui$V3$CustomSelect$Excluded = {$: 'Excluded'};
var $author$project$Ui$V3$CustomSelect$Selected = {$: 'Selected'};
var $author$project$Ui$V3$CustomSelect$getSelectedStatusFromItem = F2(
	function (id, model) {
		var existingSelectedItemIndex = A2($author$project$Ui$V3$CustomSelect$getExistingSelectedItemIndex, model, id);
		var existingExcludedItemIndex = A2($author$project$Ui$V3$CustomSelect$getExistingExcludedItemIndex, model, id);
		return ((!_Utils_eq(existingSelectedItemIndex, $elm$core$Maybe$Nothing)) && _Utils_eq(existingExcludedItemIndex, $elm$core$Maybe$Nothing)) ? $author$project$Ui$V3$CustomSelect$Selected : ((!_Utils_eq(existingExcludedItemIndex, $elm$core$Maybe$Nothing)) ? $author$project$Ui$V3$CustomSelect$Excluded : $author$project$Ui$V3$CustomSelect$Unselected);
	});
var $author$project$Ui$V3$CustomSelect$findBestMatch = F2(
	function (autoSelectText, _v0) {
		var model = _v0.a;
		var lowerText = $elm$core$String$trim(
			$elm$core$String$toLower(autoSelectText));
		var findExistingSelection = function (item) {
			return !_Utils_eq(
				A2(
					$author$project$Ui$V3$CustomSelect$getSelectedStatusFromItem,
					item.id,
					$author$project$Ui$V3$CustomSelect$Model(model)),
				$author$project$Ui$V3$CustomSelect$Unselected);
		};
		var filterMatchingItems = function (item) {
			return A2(
				$elm$core$String$startsWith,
				lowerText,
				$elm$core$String$toLower(item.text));
		};
		var matchingItems = A2($elm$core$List$filter, filterMatchingItems, model.items);
		var existingValueIndex = A2(
			$elm$core$Maybe$withDefault,
			-1,
			A2($elm_community$list_extra$List$Extra$findIndex, findExistingSelection, matchingItems));
		var indexToSplit = ($elm$core$String$length(lowerText) === 1) ? A2($author$project$Ui$V3$CustomSelect$getNextValueIndex, matchingItems, existingValueIndex) : existingValueIndex;
		return A3($author$project$Ui$V3$CustomSelect$getOptionWithSplitIndex, matchingItems, indexToSplit, lowerText);
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Ui$V3$CustomSelect$focusList = function (id) {
	return A2(
		$elm$core$Task$attempt,
		function (_v0) {
			return $author$project$Ui$V3$CustomSelect$NoOp;
		},
		$elm$browser$Browser$Dom$focus(id));
};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Ui$V3$CustomSelect$alphabet = 'abcdefghijklmnopqrstuvwxyz1234567890';
var $author$project$Ui$V3$CustomSelect$getFilteredItems = function (_v0) {
	var model = _v0.a;
	if (model.isFilterable && model.autoFilter) {
		var toLowercaseAlphanumeric = function (str) {
			return $elm$core$String$concat(
				A2(
					$elm$core$List$filter,
					function (_char) {
						return A2($elm$core$String$contains, _char, $author$project$Ui$V3$CustomSelect$alphabet);
					},
					A2(
						$elm$core$List$map,
						$elm$core$String$fromChar,
						$elm$core$String$toList(
							$elm$core$String$toLower(str)))));
		};
		var lowercasedAlphanumericInput = toLowercaseAlphanumeric(model.inputValue);
		var filterItems = function (item) {
			return A2(
				$elm$core$String$contains,
				lowercasedAlphanumericInput,
				toLowercaseAlphanumeric(item.text));
		};
		return A2($elm$core$List$filter, filterItems, model.items);
	} else {
		return model.items;
	}
};
var $author$project$Ui$V3$CustomSelect$getInputId = function (model) {
	return $author$project$Ui$V3$CustomSelect$getCleanId(model) + '-input';
};
var $author$project$Ui$V3$CustomSelect$getScrollableListContainerId = function (model) {
	return $author$project$Ui$V3$CustomSelect$getCleanId(model) + '-scrollable-list-container';
};
var $author$project$Ui$V3$CustomSelect$isAlphaCharacter = function (character) {
	return ($elm$core$String$length(character) === 1) && A2(
		$elm$core$String$contains,
		$elm$core$String$toLower(character),
		$author$project$Ui$V3$CustomSelect$alphabet);
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Ui$V3$CustomSelect$removeItem = F2(
	function (id, _v0) {
		var model = _v0.a;
		var newSelectedItems = function () {
			var _v2 = A2(
				$author$project$Ui$V3$CustomSelect$getExistingSelectedItemIndex,
				$author$project$Ui$V3$CustomSelect$Model(model),
				id);
			if (_v2.$ === 'Nothing') {
				return model.selectedItems;
			} else {
				var value = _v2.a;
				return A2($elm_community$list_extra$List$Extra$removeAt, value, model.selectedItems);
			}
		}();
		var newExcludedItems = function () {
			var _v1 = A2(
				$author$project$Ui$V3$CustomSelect$getExistingExcludedItemIndex,
				$author$project$Ui$V3$CustomSelect$Model(model),
				id);
			if (_v1.$ === 'Nothing') {
				return model.excludedItems;
			} else {
				var value = _v1.a;
				return A2($elm_community$list_extra$List$Extra$removeAt, value, model.excludedItems);
			}
		}();
		return $author$project$Ui$V3$CustomSelect$Model(
			_Utils_update(
				model,
				{excludedItems: newExcludedItems, selectedItems: newSelectedItems}));
	});
var $author$project$Ui$V3$CustomSelect$resetScroll = function (_v0) {
	var model = _v0.a;
	return $author$project$Ui$V3$CustomSelect$Model(
		_Utils_update(
			model,
			{hasScrolledToBottom: false}));
};
var $author$project$Ui$V3$CustomSelect$addSelectedItem = F2(
	function (existingItem, _v0) {
		var model = _v0.a;
		if (existingItem.$ === 'Nothing') {
			return model.selectedItems;
		} else {
			var value = existingItem.a;
			return model.multiSelectTypeahead ? A2(
				$elm$core$List$append,
				model.selectedItems,
				_List_fromArray(
					[value])) : _List_fromArray(
				[value]);
		}
	});
var $author$project$Ui$V3$CustomSelect$selectItem = F2(
	function (id, _v0) {
		var model = _v0.a;
		var stayOpen = model.multiSelectTypeahead;
		var _v1 = model.singleSelectTypeahead ? _Utils_Tuple2('', 0) : _Utils_Tuple2(model.inputValue, model.inputKeystrokeCount);
		var newInputValue = _v1.a;
		var newInputKeystrokeCount = _v1.b;
		var _v2 = A2(
			$author$project$Ui$V3$CustomSelect$getExistingSelectedItemIndex,
			$author$project$Ui$V3$CustomSelect$Model(model),
			id);
		if (_v2.$ === 'Just') {
			var selectedIndex = _v2.a;
			return $author$project$Ui$V3$CustomSelect$Model(
				_Utils_update(
					model,
					{
						focusedOptionId: $elm$core$Maybe$Nothing,
						inputKeystrokeCount: newInputKeystrokeCount,
						inputValue: newInputValue,
						isOpen: stayOpen,
						selectedItems: model.multiSelectTypeahead ? A2($elm_community$list_extra$List$Extra$removeAt, selectedIndex, model.selectedItems) : model.selectedItems
					}));
		} else {
			return $author$project$Ui$V3$CustomSelect$Model(
				_Utils_update(
					model,
					{
						excludedItems: function () {
							var _v3 = A2(
								$author$project$Ui$V3$CustomSelect$getExistingExcludedItemIndex,
								$author$project$Ui$V3$CustomSelect$Model(model),
								id);
							if (_v3.$ === 'Just') {
								var excludedIndex = _v3.a;
								return A2($elm_community$list_extra$List$Extra$removeAt, excludedIndex, model.excludedItems);
							} else {
								return model.excludedItems;
							}
						}(),
						focusedOptionId: $elm$core$Maybe$Nothing,
						inputKeystrokeCount: newInputKeystrokeCount,
						inputValue: newInputValue,
						isOpen: stayOpen,
						selectedItems: A2(
							$author$project$Ui$V3$CustomSelect$addSelectedItem,
							A2(
								$author$project$Ui$V3$CustomSelect$getExistingItem,
								$author$project$Ui$V3$CustomSelect$Model(model),
								id),
							$author$project$Ui$V3$CustomSelect$Model(model))
					}));
		}
	});
var $author$project$Ui$V3$CustomSelect$setClickIn = F2(
	function (_v0, _v1) {
		var isCaret = _v0.isCaret;
		var model = _v1.a;
		return $author$project$Ui$V3$CustomSelect$Model(
			_Utils_update(
				model,
				{
					isOpen: isCaret ? (!model.isOpen) : ((model.isFilterable || model.multiSelectTypeahead) ? true : (!model.isOpen))
				}));
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Ui$V3$CustomSelect$updateAutoText = F2(
	function (_v0, character) {
		var model = _v0.a;
		var newCharacter = $elm$core$String$toLower(character);
		var appendedString = _Utils_ap(model.autoSelectText, newCharacter);
		var currentBestMatch = A2(
			$author$project$Ui$V3$CustomSelect$findBestMatch,
			appendedString,
			$author$project$Ui$V3$CustomSelect$Model(model));
		var bestMatch = function () {
			if (currentBestMatch.$ === 'Just') {
				var value = currentBestMatch.a;
				return $elm$core$Maybe$Just(value);
			} else {
				return A2(
					$author$project$Ui$V3$CustomSelect$findBestMatch,
					newCharacter,
					$author$project$Ui$V3$CustomSelect$Model(model));
			}
		}();
		var bestMatchId = function () {
			if (bestMatch.$ === 'Just') {
				var value = bestMatch.a;
				return value.id;
			} else {
				return '';
			}
		}();
		var newAutoSelectString = function () {
			if (currentBestMatch.$ === 'Just') {
				return appendedString;
			} else {
				return newCharacter;
			}
		}();
		var _v1 = A2(
			$author$project$Ui$V3$CustomSelect$selectItem,
			bestMatchId,
			$author$project$Ui$V3$CustomSelect$Model(model));
		var updatedModel = _v1.a;
		return $author$project$Ui$V3$CustomSelect$Model(
			_Utils_update(
				updatedModel,
				{autoSelectText: newAutoSelectString}));
	});
var $author$project$Ui$V3$Ports$v3ScrollToId = _Platform_outgoingPort(
	'v3ScrollToId',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'listId',
					$elm$json$Json$Encode$string($.listId)),
					_Utils_Tuple2(
					'optionId',
					$elm$json$Json$Encode$string($.optionId))
				]));
	});
var $author$project$Ui$V3$CustomSelect$update = F2(
	function (msg, parentModel) {
		var model = parentModel.a;
		var _v0 = function () {
			switch (msg.$) {
				case 'ClickIn':
					var params = msg.a;
					var _v2 = A2($author$project$Ui$V3$CustomSelect$setClickIn, params, parentModel);
					var clickedModel = _v2.a;
					return _Utils_Tuple2(
						clickedModel,
						clickedModel.isOpen ? A2(
							$elm$core$Task$attempt,
							function (_v3) {
								return $author$project$Ui$V3$CustomSelect$NoOp;
							},
							$elm$browser$Browser$Dom$focus(
								$author$project$Ui$V3$CustomSelect$getInputId(parentModel))) : $elm$core$Platform$Cmd$none);
				case 'ClickChip':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isOpen: model.multiSelectTypeahead}),
						$elm$core$Platform$Cmd$none);
				case 'Close':
					var autoFilledModel = function () {
						if (model.autoFill && (model.inputValue !== '')) {
							var _v4 = A2(
								$author$project$Ui$V3$CustomSelect$findBestMatch,
								model.inputValue,
								$author$project$Ui$V3$CustomSelect$Model(model));
							if (_v4.$ === 'Just') {
								var item = _v4.a;
								var _v5 = A2(
									$author$project$Ui$V3$CustomSelect$selectItem,
									item.id,
									$author$project$Ui$V3$CustomSelect$Model(model));
								var m = _v5.a;
								return m;
							} else {
								return model;
							}
						} else {
							return model;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							autoFilledModel,
							{autoSelectText: '', inputValue: '', isOpen: false}),
						$elm$core$Platform$Cmd$none);
				case 'ChangeDebouncedInputValue':
					var value = msg.a;
					var debouncedInputValue_ = _Utils_eq(value, model.inputKeystrokeCount) ? model.inputValue : model.debouncedInputValue;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{debouncedInputValue: debouncedInputValue_}),
						$elm$core$Platform$Cmd$none);
				case 'ChangeInputValue':
					var value = msg.a;
					var inputKeystrokeCount = model.inputKeystrokeCount + 1;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{inputKeystrokeCount: inputKeystrokeCount, inputValue: value}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$perform,
									function (_v6) {
										return $author$project$Ui$V3$CustomSelect$ChangeDebouncedInputValue(inputKeystrokeCount);
									},
									$elm$core$Process$sleep(500)),
									A2(
									$elm$core$Task$attempt,
									function (_v7) {
										return $author$project$Ui$V3$CustomSelect$NoOp;
									},
									A3(
										$elm$browser$Browser$Dom$setViewportOf,
										$author$project$Ui$V3$CustomSelect$getScrollableListContainerId(parentModel),
										0,
										0))
								])));
				case 'HandleFocus':
					var _v8 = model.isFilterable ? A2(
						$author$project$Ui$V3$CustomSelect$setClickIn,
						{isCaret: false},
						parentModel) : parentModel;
					var updatedModel = _v8.a;
					return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
				case 'HandleKeyboardEvent':
					var keyboardEvent = msg.a;
					var isFocused = function (item) {
						return _Utils_eq(
							item.id,
							A2($elm$core$Maybe$withDefault, '', model.focusedOptionId));
					};
					var filteredItems = $author$project$Ui$V3$CustomSelect$getFilteredItems(parentModel);
					var _v9 = A2($author$project$Ui$V3$CustomSelect$defaultToFirstItem, filteredItems, parentModel) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(0),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.id;
							},
							$elm$core$List$head(filteredItems))) : _Utils_Tuple2(
						A2($elm_community$list_extra$List$Extra$findIndex, isFocused, filteredItems),
						model.focusedOptionId);
					var currentlyFocusedItemIndex = _v9.a;
					var focusedOptionId = _v9.b;
					var _v10 = keyboardEvent.key;
					if (_v10.$ === 'Nothing') {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						switch (_v10.a) {
							case 'Escape':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{inputValue: '', isOpen: false}),
									$elm$core$Platform$Cmd$none);
							case 'ArrowDown':
								var nextIndex = function () {
									if (currentlyFocusedItemIndex.$ === 'Nothing') {
										return 0;
									} else {
										var value = currentlyFocusedItemIndex.a;
										return _Utils_eq(
											value,
											$elm$core$List$length(filteredItems) - 1) ? 0 : (value + 1);
									}
								}();
								var nextItem = A2($elm_community$list_extra$List$Extra$getAt, nextIndex, filteredItems);
								var nextItemId = function () {
									if (nextItem.$ === 'Nothing') {
										return $elm$core$Maybe$Nothing;
									} else {
										var item = nextItem.a;
										return $elm$core$Maybe$Just(item.id);
									}
								}();
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{focusedOptionId: nextItemId, isOpen: true}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												$author$project$Ui$V3$CustomSelect$focusList(
												$author$project$Ui$V3$CustomSelect$getListId(parentModel)),
												$author$project$Ui$V3$Ports$v3ScrollToId(
												{
													listId: $author$project$Ui$V3$CustomSelect$getListId(parentModel),
													optionId: A2($elm$core$Maybe$withDefault, '', nextItemId)
												})
											])));
							case 'ArrowUp':
								var previousIndex = function () {
									if (currentlyFocusedItemIndex.$ === 'Nothing') {
										return $elm$core$List$length(filteredItems) - 1;
									} else {
										var value = currentlyFocusedItemIndex.a;
										return (!value) ? ($elm$core$List$length(filteredItems) - 1) : (value - 1);
									}
								}();
								var previousItem = A2($elm_community$list_extra$List$Extra$getAt, previousIndex, filteredItems);
								var previousItemId = function () {
									if (previousItem.$ === 'Nothing') {
										return $elm$core$Maybe$Nothing;
									} else {
										var item = previousItem.a;
										return $elm$core$Maybe$Just(item.id);
									}
								}();
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{focusedOptionId: previousItemId, isOpen: true}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												$author$project$Ui$V3$CustomSelect$focusList(
												$author$project$Ui$V3$CustomSelect$getListId(parentModel)),
												$author$project$Ui$V3$Ports$v3ScrollToId(
												{
													listId: $author$project$Ui$V3$CustomSelect$getListId(parentModel),
													optionId: A2($elm$core$Maybe$withDefault, '', previousItemId)
												})
											])));
							case ' ':
								if (focusedOptionId.$ === 'Just') {
									var value = focusedOptionId.a;
									var _v16 = A2($author$project$Ui$V3$CustomSelect$selectItem, value, parentModel);
									var newModel = _v16.a;
									return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
								} else {
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{isOpen: true}),
										$elm$core$Platform$Cmd$none);
								}
							case 'Enter':
								if (focusedOptionId.$ === 'Just') {
									var value = focusedOptionId.a;
									var _v18 = A2($author$project$Ui$V3$CustomSelect$selectItem, value, parentModel);
									var newModel = _v18.a;
									return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							default:
								var value = _v10.a;
								if ($author$project$Ui$V3$CustomSelect$isAlphaCharacter(value)) {
									if (model.multiSelectTypeahead || model.isFilterable) {
										return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
									} else {
										var _v19 = A2($author$project$Ui$V3$CustomSelect$updateAutoText, parentModel, value);
										var newModel = _v19.a;
										return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
									}
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
						}
					}
				case 'NoOp':
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 'SelectItem':
					var id = msg.a;
					var _v20 = (id === '') ? $author$project$Ui$V3$CustomSelect$clearSelections(parentModel) : A2($author$project$Ui$V3$CustomSelect$selectItem, id, parentModel);
					var newModel = _v20.a;
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				case 'ExcludeItem':
					var id = msg.a;
					var _v21 = A2($author$project$Ui$V3$CustomSelect$excludeItem, id, parentModel);
					var newModel = _v21.a;
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				case 'RemoveItem':
					var id = msg.a;
					var _v22 = A2($author$project$Ui$V3$CustomSelect$removeItem, id, parentModel);
					var updatedModel = _v22.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{excludedItems: updatedModel.excludedItems, inputValue: updatedModel.inputValue, isOpen: true, selectedItems: updatedModel.selectedItems}),
						$elm$core$Platform$Cmd$none);
				case 'ClearSelections':
					var _v23 = $author$project$Ui$V3$CustomSelect$resetScroll(
						$author$project$Ui$V3$CustomSelect$clearSelections(parentModel));
					var newModel = _v23.a;
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				default:
					var isAtBottom = msg.a.isAtBottom;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hasScrolledToBottom: isAtBottom}),
						$elm$core$Platform$Cmd$none);
			}
		}();
		var newInnerModel = _v0.a;
		var command = _v0.b;
		return _Utils_Tuple2(
			$author$project$Ui$V3$CustomSelect$Model(
				_Utils_update(
					newInnerModel,
					{
						maxItemCountSeen: A2(
							$elm$core$Basics$max,
							$elm$core$List$length(newInnerModel.items),
							newInnerModel.maxItemCountSeen)
					})),
			command);
	});
var $author$project$Helpers$Bool$doIf = F3(
	function (check, f, val) {
		return check ? f(val) : val;
	});
var $author$project$Ui$V3$CustomSelect$setItems = F2(
	function (items, _v0) {
		var model = _v0.a;
		return $author$project$Ui$V3$CustomSelect$Model(
			_Utils_update(
				model,
				{
					hasScrolledToBottom: model.hasScrolledToBottom && _Utils_eq(items, model.items),
					items: items
				}));
	});
var $author$project$Components$PaginatedDropdown$withData = F3(
	function (dataToItem, data, paginatedDropdown) {
		var dropdown = paginatedDropdown.dropdown;
		var _v0 = $author$project$Forward$Remote$toMaybe(data);
		if (_v0.$ === 'Just') {
			var loadedData = _v0.a;
			var pageNumber = $author$project$Pagination$pageNumber(loadedData);
			var inputValue_ = $author$project$Ui$V3$CustomSelect$inputValue(dropdown);
			var entriesPerPage = $author$project$Pagination$entriesPerPage(loadedData);
			var entries = $author$project$Pagination$entries(loadedData);
			var remoteItems = A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.text;
				},
				A2($elm$core$List$map, dataToItem, entries));
			var isExhausted = _Utils_cmp(
				$elm$core$List$length(remoteItems),
				entriesPerPage) < 0;
			var cachedPagesItems = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.pages;
				},
				A2($elm$core$Dict$get, inputValue_, paginatedDropdown.cachedPages));
			var newCachedPagesItems = function () {
				if (cachedPagesItems.$ === 'Nothing') {
					return _List_fromArray(
						[remoteItems]);
				} else {
					var cpis = cachedPagesItems.a;
					return (_Utils_cmp(
						$elm$core$List$length(cpis),
						pageNumber) > -1) ? cpis : _Utils_ap(
						cpis,
						_List_fromArray(
							[remoteItems]));
				}
			}();
			var newCachedPages = A3(
				$elm$core$Dict$insert,
				inputValue_,
				{isExhausted: isExhausted, pages: newCachedPagesItems},
				paginatedDropdown.cachedPages);
			var _v1 = (_Utils_cmp(
				$elm$core$String$length(inputValue_),
				$author$project$Components$PaginatedDropdown$minSearchLength) < 0) ? _Utils_Tuple2(_List_Nil, _List_Nil) : _Utils_Tuple2(paginatedDropdown.otherItems, paginatedDropdown.lastItems);
			var extraItems = _v1.a;
			var lastItems = _v1.b;
			return _Utils_update(
				paginatedDropdown,
				{
					cachedPages: newCachedPages,
					dropdown: A3(
						$author$project$Helpers$Bool$doIf,
						!_Utils_eq(
							cachedPagesItems,
							$elm$core$Maybe$Just(newCachedPagesItems)),
						$author$project$Ui$V3$CustomSelect$resetScroll,
						A2(
							$author$project$Ui$V3$CustomSelect$setItems,
							function (items) {
								return _Utils_ap(items, lastItems);
							}(
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.text;
									},
									_Utils_ap(
										extraItems,
										$elm$core$List$concat(newCachedPagesItems)))),
							dropdown)),
					entriesPerPage: entriesPerPage
				});
		} else {
			return paginatedDropdown;
		}
	});
var $author$project$Components$PaginatedDropdown$update = F4(
	function (dataToItem, data, msg, origPaginatedDropdown) {
		var paginatedDropdown = A3($author$project$Components$PaginatedDropdown$withData, dataToItem, data, origPaginatedDropdown);
		var _v0 = A2($author$project$Ui$V3$CustomSelect$update, msg, paginatedDropdown.dropdown);
		var newDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				paginatedDropdown,
				{dropdown: newDropdown}),
			cmd);
	});
var $author$project$Components$CarrierDropdown$update = F3(
	function (data, msg, model) {
		var _v0 = A4(
			$author$project$Components$PaginatedDropdown$update,
			$author$project$Components$CarrierDropdown$carrierToDropdownItem(model.accountInfo),
			data,
			msg,
			model.dropdown);
		var newDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: newDropdown}),
			cmd);
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$isBlank = function (string) {
	return A2(
		$elm$regex$Regex$contains,
		$elm_community$string_extra$String$Extra$regexFromString('^\u005Cs*$'),
		string);
};
var $elm_community$string_extra$String$Extra$nonBlank = function (string) {
	return $elm_community$string_extra$String$Extra$isBlank(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Components$DebtorDropdown$joinNonBlank = F2(
	function (separator, parts) {
		return $elm_community$string_extra$String$Extra$nonBlank(
			A2(
				$elm$core$String$join,
				separator,
				A2(
					$elm$core$List$filterMap,
					$elm$core$Maybe$andThen($elm_community$string_extra$String$Extra$nonBlank),
					parts)));
	});
var $author$project$Components$DebtorDropdown$addressLine = function (address) {
	return A2(
		$author$project$Components$DebtorDropdown$joinNonBlank,
		' ',
		_List_fromArray(
			[address.addressLine1, address.city, address.state]));
};
var $author$project$Components$DebtorDropdown$identifiers = function (factorBroker) {
	return A2(
		$author$project$Components$DebtorDropdown$joinNonBlank,
		' ',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$append('DOT: '),
				factorBroker.dotNumber),
				A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$append('MC: '),
				factorBroker.mcNumber)
			]));
};
var $author$project$Ui$V3$StatusTag$AlertStyle = {$: 'AlertStyle'};
var $author$project$Ui$V3$StatusTag$Style = function (a) {
	return {$: 'Style', a: a};
};
var $author$project$Ui$V3$StatusTag$alertStyle = $author$project$Ui$V3$StatusTag$Style($author$project$Ui$V3$StatusTag$AlertStyle);
var $author$project$Ui$V3$StatusTag$Size = function (a) {
	return {$: 'Size', a: a};
};
var $author$project$Ui$V3$StatusTag$Small = {$: 'Small'};
var $author$project$Ui$V3$StatusTag$smallSize = $author$project$Ui$V3$StatusTag$Size($author$project$Ui$V3$StatusTag$Small);
var $author$project$Ui$V3$StatusTag$Default = {$: 'Default'};
var $author$project$Ui$V3$StatusTag$NeutralStyle = {$: 'NeutralStyle'};
var $author$project$Ui$V3$StatusTag$Strong = {$: 'Strong'};
var $author$project$Ui$V3$StatusTag$defaultAttributes = {emphasis: $author$project$Ui$V3$StatusTag$Strong, size: $author$project$Ui$V3$StatusTag$Default, style: $author$project$Ui$V3$StatusTag$NeutralStyle};
var $author$project$Ui$V3$StatusTag$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'Emphasis':
					var emphasis = a.a;
					return _Utils_update(
						acc,
						{emphasis: emphasis});
				case 'Style':
					var style = a.a;
					return _Utils_update(
						acc,
						{style: style});
				default:
					var size_ = a.a;
					return _Utils_update(
						acc,
						{size: size_});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$StatusTag$defaultAttributes, attributes);
};
var $author$project$Ui$V3$StatusTag$emphasisClass = function (emphasis) {
	if (emphasis.$ === 'Strong') {
		return 'strong';
	} else {
		return 'subtle';
	}
};
var $author$project$Ui$V3$StatusTag$sizeClass = function (style) {
	if (style.$ === 'Default') {
		return 'default';
	} else {
		return 'small';
	}
};
var $author$project$Ui$V3$StatusTag$styleClass = function (style) {
	switch (style.$) {
		case 'SuccessStyle':
			return 'success';
		case 'ActiveStyle':
			return 'active';
		case 'WarningStyle':
			return 'warning';
		case 'AlertStyle':
			return 'alert';
		default:
			return 'neutral';
	}
};
var $author$project$Ui$V3$StatusTag$view = F2(
	function (attributes, text) {
		var computedAttributes = $author$project$Ui$V3$StatusTag$computeAttributes(attributes);
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__status-tag'),
					$elm$html$Html$Attributes$class(
					'v3__status-tag--color-' + $author$project$Ui$V3$StatusTag$styleClass(computedAttributes.style)),
					$elm$html$Html$Attributes$class(
					'v3__status-tag--size-' + $author$project$Ui$V3$StatusTag$sizeClass(computedAttributes.size)),
					$elm$html$Html$Attributes$class(
					'v3__status-tag--emphasis-' + $author$project$Ui$V3$StatusTag$emphasisClass(computedAttributes.emphasis))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text)
				]));
	});
var $author$project$Components$DebtorDetails$noBuyTag = A2(
	$author$project$Ui$V3$StatusTag$view,
	_List_fromArray(
		[$author$project$Ui$V3$StatusTag$smallSize, $author$project$Ui$V3$StatusTag$alertStyle]),
	'No Buy');
var $author$project$Components$DebtorDropdown$nameLine = function (factorBroker) {
	return factorBroker.noBuy ? A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
				$author$project$Ui$V3$Stack$crossAxisCenter
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				$elm$html$Html$text(factorBroker.name)),
				_Utils_Tuple2($author$project$Ui$V3$Stack$fit, $author$project$Components$DebtorDetails$noBuyTag)
			])) : $elm$html$Html$text(factorBroker.name);
};
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 'Nothing') {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$Components$DebtorDropdown$phone = function (_v0) {
	var cadenceDebtorDetails = _v0.cadenceDebtorDetails;
	return A2(
		$elm_community$maybe_extra$Maybe$Extra$or,
		A2($elm$core$Maybe$andThen, $elm_community$string_extra$String$Extra$nonBlank, cadenceDebtorDetails.phone1),
		A2($elm$core$Maybe$andThen, $elm_community$string_extra$String$Extra$nonBlank, cadenceDebtorDetails.phone2));
};
var $author$project$Components$DebtorDropdown$debtorDetails = function (_v0) {
	var paymentAddress = _v0.paymentAddress;
	var factorBroker = _v0.factorBroker;
	return A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_Nil,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				$author$project$Components$DebtorDropdown$nameLine(factorBroker)),
				A2(
				$elm$core$Maybe$map,
				$elm$html$Html$text,
				$author$project$Components$DebtorDropdown$identifiers(factorBroker)),
				A2(
				$elm$core$Maybe$map,
				$elm$html$Html$text,
				$author$project$Components$DebtorDropdown$phone(factorBroker)),
				A2(
				$elm$core$Maybe$map,
				$elm$html$Html$text,
				A2($elm$core$Maybe$andThen, $author$project$Components$DebtorDropdown$addressLine, paymentAddress))
			]));
};
var $author$project$Components$DebtorDropdown$debtorToDropdownItem = function (debtorWithAddress) {
	return {
		id: $elm$core$String$fromInt(
			$author$project$Domain$FactorBrokerId$toInt(debtorWithAddress.factorBroker.id)),
		label: $author$project$Components$DebtorDropdown$debtorDetails(debtorWithAddress),
		text: $author$project$Components$DebtorDropdown$nameAndMcNumber(debtorWithAddress.factorBroker)
	};
};
var $author$project$Components$DebtorDropdown$update = F3(
	function (data, msg, model) {
		var _v0 = A4($author$project$Components$PaginatedDropdown$update, $author$project$Components$DebtorDropdown$debtorToDropdownItem, data, msg, model.dropdown);
		var newDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: newDropdown}),
			cmd);
	});
var $author$project$Components$NoaManagement$SentPage$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'SelectedTab':
				var tab = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$pushUrl(
						$author$project$Path$toString(
							$author$project$Components$NoaManagement$Layout$path(tab))));
			case 'DebtorDropdownMsg':
				var dropdownMsg = msg.a;
				var _v1 = A3(
					$author$project$Components$DebtorDropdown$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.debtorDropdown;
						},
						data),
					dropdownMsg,
					model.debtorDropdown);
				var debtorDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$NoaManagement$SentPage$filterByDebtor,
						$elm$core$List$head(
							$author$project$Components$DebtorDropdown$selectedIds(debtorDropdown)),
						_Utils_update(
							model,
							{debtorDropdown: debtorDropdown})),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$NoaManagement$SentPage$DebtorDropdownMsg, cmd)));
			case 'CarrierDropdownMsg':
				var dropdownMsg = msg.a;
				var _v2 = A3(
					$author$project$Components$CarrierDropdown$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.carrierDropdown;
						},
						data),
					dropdownMsg,
					model.carrierDropdown);
				var carrierDropdown = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$NoaManagement$SentPage$filterByCarrier,
						$elm$core$List$head(
							$author$project$Components$CarrierDropdown$selectedIds(carrierDropdown)),
						_Utils_update(
							model,
							{carrierDropdown: carrierDropdown})),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$NoaManagement$SentPage$CarrierDropdownMsg, cmd)));
			case 'ClickedClearFilters':
				return _Utils_Tuple2(
					A2(
						$author$project$Components$NoaManagement$SentPage$filterByCarrier,
						$elm$core$Maybe$Nothing,
						A2(
							$author$project$Components$NoaManagement$SentPage$filterByDebtor,
							$elm$core$Maybe$Nothing,
							_Utils_update(
								model,
								{
									carrierDropdown: $author$project$Components$CarrierDropdown$clear(model.carrierDropdown),
									debtorDropdown: $author$project$Components$DebtorDropdown$clear(model.debtorDropdown)
								}))),
					$author$project$HubTran$Effect$none);
			case 'UpdatedPage':
				var pageNumber = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pageNumber: pageNumber}),
					$author$project$HubTran$Effect$none);
			case 'SetTimezone':
				var timezone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: timezone}),
					$author$project$HubTran$Effect$none);
			case 'ClickedRetry':
				var itemId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							retryingItemId: $elm$core$Maybe$Just(itemId)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$NoaManagement$SentPage$RetryCompleted,
						$author$project$Api$NoaSendQueueItems$retryWriteBack(itemId)));
			case 'RetryCompleted':
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{retryingItemId: $elm$core$Maybe$Nothing}),
					function () {
						switch (result.$) {
							case 'Ok':
								var _v4 = model.retryingItemId;
								if (_v4.$ === 'Just') {
									var itemId = _v4.a;
									return $author$project$HubTran$Effect$refresh(
										A2($author$project$Forward$Lookup$startFrom, itemId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$sentNoa));
								} else {
									return $author$project$HubTran$Effect$none;
								}
							case 'Err':
								var serverError = result.a;
								return $author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(
										$author$project$Components$NoaManagement$SentPage$humanRetryErrorMessage(serverError)));
							default:
								return $author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert);
						}
					}());
			case 'ClickedResend':
				var itemId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							resendingItemId: $elm$core$Maybe$Just(itemId)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$NoaManagement$SentPage$ResendCompleted,
						$author$project$Api$NoaSendQueueItems$resend(itemId)));
			default:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{resendingItemId: $elm$core$Maybe$Nothing}),
					function () {
						switch (result.$) {
							case 'Ok':
								return $author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$success('Queued on the To Send tab for another send.'));
							case 'Err':
								var serverError = result.a;
								return $author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(
										$author$project$Components$NoaManagement$SentPage$humanResendErrorMessage(serverError)));
							default:
								return $author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert);
						}
					}());
		}
	});
var $author$project$Components$NoaManagement$SentPage$SelectedTab = function (a) {
	return {$: 'SelectedTab', a: a};
};
var $author$project$Components$NoaManagement$SentPage$ClickedClearFilters = {$: 'ClickedClearFilters'};
var $author$project$Components$NoaManagement$SentPage$UpdatedPage = function (a) {
	return {$: 'UpdatedPage', a: a};
};
var $author$project$Ui$V3$CustomSelect$LabelOverride = function (a) {
	return {$: 'LabelOverride', a: a};
};
var $author$project$Ui$V3$CustomSelect$label = $author$project$Ui$V3$CustomSelect$LabelOverride;
var $author$project$Ui$V3$CustomSelect$LoadingAttribute = function (a) {
	return {$: 'LoadingAttribute', a: a};
};
var $author$project$Ui$V3$CustomSelect$loading = $author$project$Ui$V3$CustomSelect$LoadingAttribute;
var $author$project$Ui$V3$CustomSelect$ChangeInputValue = function (a) {
	return {$: 'ChangeInputValue', a: a};
};
var $author$project$Ui$V3$CustomSelect$ClickIn = function (a) {
	return {$: 'ClickIn', a: a};
};
var $author$project$Ui$V3$CustomSelect$HandleFocus = {$: 'HandleFocus'};
var $author$project$Ui$V3$CustomSelect$HandleKeyboardEvent = function (a) {
	return {$: 'HandleKeyboardEvent', a: a};
};
var $author$project$Ui$V3$Icon$arrowDown16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.97945 11.4673C7.63023 11.4673 7.3309 11.3176 7.13135 11.0682L2.19243 5.53062C1.8931 5.13152 1.94299 4.53286 2.34209 4.23353C2.74119 3.9342 3.28996 3.9342 3.58929 4.33331L7.87967 9.22234C7.92956 9.27223 7.97945 9.27223 8.07922 9.22234L12.3696 4.33331C12.7188 3.9342 13.2676 3.88432 13.6667 4.23353C14.0658 4.58275 14.1157 5.13152 13.7665 5.53062C13.7665 5.53062 13.7665 5.53062 13.7166 5.58051L8.82754 11.1181C8.62799 11.3176 8.27877 11.4673 7.97945 11.4673Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1')
					]),
				_List_Nil)
			])));
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent = F7(
	function (altKey, ctrlKey, key, keyCode, metaKey, repeat, shiftKey) {
		return {altKey: altKey, ctrlKey: ctrlKey, key: key, keyCode: keyCode, metaKey: metaKey, repeat: repeat, shiftKey: shiftKey};
	});
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKey = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return $elm$core$String$isEmpty(key) ? $elm$json$Json$Decode$fail('empty key') : $elm$json$Json$Decode$succeed(key);
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		return (!code) ? $elm$json$Json$Decode$fail('code was zero') : $elm$json$Json$Decode$succeed(code);
	},
	$elm$json$Json$Decode$int);
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'keyCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'which', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'charCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			$elm$json$Json$Decode$succeed(0)
		]));
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$A = {$: 'A'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add = {$: 'Add'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt = {$: 'Alt'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous = function (a) {
	return {$: 'Ambiguous', a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$B = {$: 'B'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace = {$: 'Backspace'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$C = {$: 'C'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock = {$: 'CapsLock'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch = {$: 'ChromeSearch'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command = {$: 'Command'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl = function (a) {
	return {$: 'Ctrl', a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$D = {$: 'D'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal = {$: 'Decimal'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete = {$: 'Delete'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide = {$: 'Divide'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down = {$: 'Down'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$E = {$: 'E'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight = {$: 'Eight'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$End = {$: 'End'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter = {$: 'Enter'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape = {$: 'Escape'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F = {$: 'F'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1 = {$: 'F1'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10 = {$: 'F10'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11 = {$: 'F11'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12 = {$: 'F12'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2 = {$: 'F2'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3 = {$: 'F3'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4 = {$: 'F4'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5 = {$: 'F5'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6 = {$: 'F6'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7 = {$: 'F7'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8 = {$: 'F8'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9 = {$: 'F9'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five = {$: 'Five'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four = {$: 'Four'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$G = {$: 'G'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$H = {$: 'H'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home = {$: 'Home'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$I = {$: 'I'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert = {$: 'Insert'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$J = {$: 'J'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$K = {$: 'K'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$L = {$: 'L'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left = {$: 'Left'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$M = {$: 'M'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply = {$: 'Multiply'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$N = {$: 'N'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine = {$: 'Nine'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock = {$: 'NumLock'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight = {$: 'NumpadEight'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive = {$: 'NumpadFive'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour = {$: 'NumpadFour'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine = {$: 'NumpadNine'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne = {$: 'NumpadOne'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven = {$: 'NumpadSeven'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix = {$: 'NumpadSix'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree = {$: 'NumpadThree'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo = {$: 'NumpadTwo'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero = {$: 'NumpadZero'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$O = {$: 'O'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$One = {$: 'One'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$P = {$: 'P'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown = {$: 'PageDown'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp = {$: 'PageUp'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak = {$: 'PauseBreak'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen = {$: 'PrintScreen'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q = {$: 'Q'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$R = {$: 'R'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right = {$: 'Right'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$S = {$: 'S'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock = {$: 'ScrollLock'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven = {$: 'Seven'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift = function (a) {
	return {$: 'Shift', a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six = {$: 'Six'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar = {$: 'Spacebar'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract = {$: 'Subtract'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$T = {$: 'T'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab = {$: 'Tab'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three = {$: 'Three'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two = {$: 'Two'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$U = {$: 'U'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown = function (a) {
	return {$: 'Unknown', a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up = {$: 'Up'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$V = {$: 'V'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$W = {$: 'W'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows = {$: 'Windows'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$X = {$: 'X'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y = {$: 'Y'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z = {$: 'Z'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero = {$: 'Zero'};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode = function (keyCode) {
	switch (keyCode) {
		case 8:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace;
		case 9:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab;
		case 13:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter;
		case 16:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift($elm$core$Maybe$Nothing);
		case 17:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl($elm$core$Maybe$Nothing);
		case 18:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt;
		case 19:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak;
		case 20:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock;
		case 27:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape;
		case 32:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar;
		case 33:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp;
		case 34:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown;
		case 35:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$End;
		case 36:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home;
		case 37:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left;
		case 38:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up;
		case 39:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right;
		case 40:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down;
		case 44:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen;
		case 45:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert;
		case 46:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete;
		case 48:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero;
		case 49:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$One;
		case 50:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two;
		case 51:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three;
		case 52:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four;
		case 53:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five;
		case 54:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six;
		case 55:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven;
		case 56:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight;
		case 57:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine;
		case 65:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$A;
		case 66:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$B;
		case 67:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$C;
		case 68:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$D;
		case 69:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$E;
		case 70:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F;
		case 71:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$G;
		case 72:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$H;
		case 73:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$I;
		case 74:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$J;
		case 75:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$K;
		case 76:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$L;
		case 77:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$M;
		case 78:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$N;
		case 79:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$O;
		case 80:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$P;
		case 81:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q;
		case 82:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$R;
		case 83:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$S;
		case 84:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$T;
		case 85:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$U;
		case 86:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$V;
		case 87:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$W;
		case 88:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$X;
		case 89:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y;
		case 90:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z;
		case 91:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous(
				_List_fromArray(
					[$SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows, $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command, $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch]));
		case 96:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero;
		case 97:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne;
		case 98:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo;
		case 99:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree;
		case 100:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour;
		case 101:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive;
		case 102:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix;
		case 103:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven;
		case 104:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight;
		case 105:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine;
		case 106:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply;
		case 107:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add;
		case 109:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract;
		case 110:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal;
		case 111:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide;
		case 112:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1;
		case 113:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2;
		case 114:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3;
		case 115:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4;
		case 116:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5;
		case 117:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6;
		case 118:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7;
		case 119:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8;
		case 120:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9;
		case 121:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10;
		case 122:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11;
		case 123:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12;
		case 144:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock;
		case 145:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock;
		default:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown(keyCode);
	}
};
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent = A8(
	$elm$json$Json$Decode$map7,
	$Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	$Gizra$elm_keyboard_event$Keyboard$Event$decodeKey,
	A2($elm$json$Json$Decode$map, $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode, $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode),
	A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $author$project$Ui$V3$Helpers$Html$empty = $elm$html$Html$text('');
var $author$project$Ui$V3$CustomSelect$getCustomSelectId = function (model) {
	return $author$project$Ui$V3$CustomSelect$getCleanId(model) + '-customSelect';
};
var $elm$core$String$words = _String_words;
var $author$project$Helpers$String$toLowerKeepMixedCaps = function (words) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (word) {
				var numUppercaseLetters = $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						$elm$core$Char$isUpper,
						$elm$core$String$toList(word)));
				var isFirstLetterLowercase = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Char$isLower,
						$elm$core$List$head(
							$elm$core$String$toList(word))));
				return (isFirstLetterLowercase && (numUppercaseLetters >= 1)) ? word : ((numUppercaseLetters >= 2) ? word : $elm$core$String$toLower(word));
			},
			$elm$core$String$words(words)));
};
var $author$project$Ui$V3$CustomSelect$getDerivedPlaceholder = F2(
	function (maybeLabel, _v0) {
		var model = _v0.a;
		var _v1 = model.excludedItems;
		if (!_v1.b) {
			var _v2 = model.selectedItems;
			if (!_v2.b) {
				if (maybeLabel.$ === 'Just') {
					var label_ = maybeLabel.a;
					return 'Any ' + $author$project$Helpers$String$toLowerKeepMixedCaps(label_);
				} else {
					return 'Any';
				}
			} else {
				if (!_v2.b.b) {
					var value = _v2.a;
					return value.text;
				} else {
					return 'Multiple selected';
				}
			}
		} else {
			if (!_v1.b.b) {
				var value = _v1.a;
				return 'Not ' + value.text;
			} else {
				return 'Multiple excluded';
			}
		}
	});
var $author$project$Ui$V3$CustomSelect$getItemsNotUnselected = function (_v0) {
	var model = _v0.a;
	return A2($elm$core$List$append, model.selectedItems, model.excludedItems);
};
var $author$project$Ui$V3$CustomSelect$getFirstSelectedItem = function (model) {
	return $elm$core$List$head(
		$author$project$Ui$V3$CustomSelect$getItemsNotUnselected(model));
};
var $author$project$Ui$V3$CustomSelect$getFirstValueText = function (model) {
	var firstValue = $author$project$Ui$V3$CustomSelect$getFirstSelectedItem(model);
	if (firstValue.$ === 'Just') {
		var value = firstValue.a;
		return value.text;
	} else {
		return '';
	}
};
var $author$project$Ui$V3$Badge$SmallSize = {$: 'SmallSize'};
var $author$project$Ui$V3$Badge$BadgeSize = function (a) {
	return {$: 'BadgeSize', a: a};
};
var $author$project$Ui$V3$Badge$badgeSize = $author$project$Ui$V3$Badge$BadgeSize;
var $author$project$Ui$V3$CustomSelect$getMultiSelectValue = function (selectedCount) {
	if (!selectedCount) {
		return $elm$html$Html$text('');
	} else {
		return A3(
			$author$project$Ui$V3$Badge$view,
			_List_fromArray(
				[
					$author$project$Ui$V3$Badge$badgeSize($author$project$Ui$V3$Badge$SmallSize)
				]),
			selectedCount,
			'');
	}
};
var $author$project$Ui$V3$CustomSelect$getSelectedCount = function (model) {
	return $elm$core$List$length(
		$author$project$Ui$V3$CustomSelect$getItemsNotUnselected(model));
};
var $author$project$Ui$V3$Icon$loading1 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8 4.33325C8.26522 4.33325 8.51957 4.2279 8.70711 4.04036C8.89464 3.85282 9 3.59847 9 3.33325V1.33325C9 1.06804 8.89464 0.813682 8.70711 0.626145C8.51957 0.438609 8.26522 0.333252 8 0.333252C7.73478 0.333252 7.48043 0.438609 7.29289 0.626145C7.10536 0.813682 7 1.06804 7 1.33325V3.33325C7 3.59847 7.10536 3.85282 7.29289 4.04036C7.48043 4.2279 7.73478 4.33325 8 4.33325Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M5.5133 4.07342L4.09997 2.66676C3.90907 2.47826 3.65158 2.37256 3.3833 2.37256C3.11502 2.37256 2.85754 2.47826 2.66664 2.66676C2.57315 2.75908 2.49905 2.86915 2.44868 2.9905C2.39831 3.11185 2.37268 3.24204 2.3733 3.37342C2.37671 3.63595 2.48187 3.8869 2.66664 4.07342L4.09997 5.48676C4.28733 5.67435 4.54151 5.77986 4.80664 5.78009C5.00429 5.77992 5.19746 5.72117 5.36175 5.61128C5.52603 5.50139 5.65407 5.34527 5.72968 5.16265C5.8053 4.98004 5.8251 4.77911 5.78659 4.58524C5.74808 4.39138 5.65298 4.21327 5.5133 4.07342Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M0.333252 8C0.333252 8.26522 0.438609 8.51957 0.626145 8.70711C0.813682 8.89464 1.06804 9 1.33325 9H3.33325C3.59847 9 3.85282 8.89464 4.04036 8.70711C4.2279 8.51957 4.33325 8.26522 4.33325 8C4.33325 7.73478 4.2279 7.48043 4.04036 7.29289C3.85282 7.10536 3.59847 7 3.33325 7H1.33325C1.06804 7 0.813682 7.10536 0.626145 7.29289C0.438609 7.48043 0.333252 7.73478 0.333252 8Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.66669 10.3467C4.52889 10.3459 4.39244 10.3739 4.26614 10.429C4.13983 10.4841 4.02647 10.5651 3.93336 10.6667L2.51336 12.0534C2.32771 12.2417 2.22363 12.4956 2.22363 12.76C2.22363 13.0245 2.32771 13.2783 2.51336 13.4667C2.702 13.6544 2.95727 13.7597 3.22336 13.7597C3.48946 13.7597 3.74472 13.6544 3.93336 13.4667L5.33336 12.0534C5.4709 11.916 5.56541 11.7415 5.60532 11.5512C5.64523 11.3609 5.62881 11.1631 5.55808 10.982C5.48734 10.801 5.36535 10.6444 5.20704 10.5316C5.04872 10.4187 4.86095 10.3545 4.66669 10.3467Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7 14.6667C7 14.932 7.10536 15.1863 7.29289 15.3739C7.48043 15.5614 7.73478 15.6667 8 15.6667C8.26522 15.6667 8.51957 15.5614 8.70711 15.3739C8.89464 15.1863 9 14.932 9 14.6667V12.6667C9 12.4015 8.89464 12.1472 8.70711 11.9596C8.51957 11.7721 8.26522 11.6667 8 11.6667C7.73478 11.6667 7.48043 11.7721 7.29289 11.9596C7.10536 12.1472 7 12.4015 7 12.6667V14.6667Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10.6999 10.6667C10.5127 10.8542 10.4075 11.1084 10.4075 11.3734C10.4075 11.6384 10.5127 11.8926 10.6999 12.0801L12.1133 13.4934C12.3014 13.6798 12.5551 13.785 12.8199 13.7867C13.0868 13.7854 13.3426 13.6802 13.5333 13.4934C13.7178 13.3045 13.8207 13.0508 13.8199 12.7867C13.8214 12.6542 13.7962 12.5228 13.7458 12.4002C13.6955 12.2776 13.6209 12.1665 13.5266 12.0734L12.1133 10.6667C11.9258 10.4795 11.6716 10.3743 11.4066 10.3743C11.1416 10.3743 10.8874 10.4795 10.6999 10.6667Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.6667 8C15.6667 7.73478 15.5614 7.48043 15.3739 7.29289C15.1863 7.10536 14.932 7 14.6667 7H12.6667C12.4015 7 12.1472 7.10536 11.9596 7.29289C11.7721 7.48043 11.6667 7.73478 11.6667 8C11.6667 8.26522 11.7721 8.51957 11.9596 8.70711C12.1472 8.89464 12.4015 9 12.6667 9H14.6667C14.932 9 15.1863 8.89464 15.3739 8.70711C15.5614 8.51957 15.6667 8.26522 15.6667 8Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.6665 2.27322C12.4157 2.285 12.1781 2.38953 11.9999 2.56655L10.5732 3.99989C10.3859 4.18739 10.2808 4.44155 10.2808 4.70655C10.2808 4.97155 10.3859 5.22572 10.5732 5.41322C10.7619 5.6009 11.0171 5.70625 11.2832 5.70625C11.5493 5.70625 11.8046 5.6009 11.9932 5.41322L13.4065 3.99989C13.5558 3.85937 13.6583 3.67636 13.7001 3.47566C13.7419 3.27495 13.721 3.06625 13.6403 2.87781C13.5595 2.68937 13.4228 2.53031 13.2486 2.42217C13.0745 2.31403 12.8713 2.26203 12.6665 2.27322Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $author$project$Ui$V3$CustomSelect$ClearSelections = {$: 'ClearSelections'};
var $author$project$Ui$V3$CustomSelect$ExcludeItem = function (a) {
	return {$: 'ExcludeItem', a: a};
};
var $author$project$Ui$V3$CustomSelect$Scrolled = function (a) {
	return {$: 'Scrolled', a: a};
};
var $author$project$Ui$V3$CustomSelect$SelectItem = function (a) {
	return {$: 'SelectItem', a: a};
};
var $author$project$Ui$V3$CustomSelect$selectedStatusToString = function (selectedStatus) {
	switch (selectedStatus.$) {
		case 'Unselected':
			return 'unselected';
		case 'Selected':
			return 'selected';
		default:
			return 'excluded';
	}
};
var $author$project$Ui$V3$CustomSelect$getCheckboxClassName = function (selectedStatus) {
	return 'v3__custom-select__selection-icon-' + $author$project$Ui$V3$CustomSelect$selectedStatusToString(selectedStatus);
};
var $author$project$Helpers$Scroll$onScroll = function (msg) {
	var decoder = A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (offsetHeight, scrollTop, scrollHeight) {
				return msg(
					{
						isAtBottom: _Utils_cmp(scrollTop + offsetHeight, scrollHeight) > -1
					});
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'offsetHeight']),
			$elm$json$Json$Decode$int),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'scrollTop']),
			$elm$json$Json$Decode$int),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'scrollHeight']),
			$elm$json$Json$Decode$int));
	return A2($elm$html$Html$Events$on, 'scroll', decoder);
};
var $author$project$Ui$V3$CustomSelect$simpleItem = function (data) {
	return {
		id: data.id,
		label: $elm$html$Html$text(data.label),
		text: data.label
	};
};
var $author$project$Ui$V3$Icon$exclude16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$width('16'),
						$elm$svg$Svg$Attributes$height('16'),
						$elm$svg$Svg$Attributes$rx('1'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('4'),
						$elm$svg$Svg$Attributes$y('7.25'),
						$elm$svg$Svg$Attributes$width('8'),
						$elm$svg$Svg$Attributes$height('1.5'),
						$elm$svg$Svg$Attributes$rx('0.75'),
						$elm$svg$Svg$Attributes$fill('var(--color-icon-neutral-inverted)')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$CustomSelect$viewCheckboxIcon = function (selectedStatus) {
	switch (selectedStatus.$) {
		case 'Selected':
			return A2(
				$author$project$Ui$V3$Icon$view16,
				_List_fromArray(
					[
						$author$project$Ui$V3$Icon$label('Checked')
					]),
				$author$project$Ui$V3$Icon$checkboxChecked16);
		case 'Unselected':
			return A2(
				$author$project$Ui$V3$Icon$view16,
				_List_fromArray(
					[
						$author$project$Ui$V3$Icon$label('Checked')
					]),
				$author$project$Ui$V3$Icon$checkboxUnchecked16);
		default:
			return A2(
				$author$project$Ui$V3$Icon$view16,
				_List_fromArray(
					[
						$author$project$Ui$V3$Icon$label('Checked')
					]),
				$author$project$Ui$V3$Icon$exclude16);
	}
};
var $author$project$Ui$V3$CustomSelect$ClickChip = {$: 'ClickChip'};
var $author$project$Ui$V3$Chip$Excluded = function (a) {
	return {$: 'Excluded', a: a};
};
var $author$project$Ui$V3$CustomSelect$RemoveItem = function (a) {
	return {$: 'RemoveItem', a: a};
};
var $author$project$Ui$V3$CustomSelect$getChipsId = function (model) {
	return $author$project$Ui$V3$CustomSelect$getCleanId(model) + '-chips';
};
var $author$project$Ui$V3$Chip$OnRemoveAttribute = function (a) {
	return {$: 'OnRemoveAttribute', a: a};
};
var $author$project$Ui$V3$Chip$removable = function (_v0) {
	var onRemove = _v0.onRemove;
	return $author$project$Ui$V3$Chip$OnRemoveAttribute(onRemove);
};
var $author$project$Ui$V3$Chip$defaultAttributes = {excluded: false, filled: false, onRemove: $elm$core$Maybe$Nothing, styles: _List_Nil};
var $author$project$Ui$V3$Chip$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'OnRemoveAttribute':
					var msg = a.a;
					return _Utils_update(
						acc,
						{
							onRemove: $elm$core$Maybe$Just(msg)
						});
				case 'Excluded':
					var value = a.a;
					return _Utils_update(
						acc,
						{excluded: value});
				case 'Filled':
					var value = a.a;
					return _Utils_update(
						acc,
						{filled: value});
				default:
					var key = a.a;
					var val = a.b;
					return _Utils_update(
						acc,
						{
							styles: _Utils_ap(
								acc.styles,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, key, val)
									]))
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Chip$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Chip$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Ui$V3$Chip$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'click',
		$elm$json$Json$Decode$succeed(
			$author$project$Ui$V3$Chip$alwaysPreventDefault(msg)));
};
var $author$project$Ui$V3$Icon$removeCircle16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0V0ZM8 14.3333C6.74739 14.3333 5.5229 13.9619 4.48139 13.266C3.43988 12.5701 2.62812 11.5809 2.14877 10.4237C1.66941 9.2664 1.54399 7.99297 1.78836 6.76443C2.03274 5.53588 2.63593 4.40739 3.52166 3.52166C4.40739 2.63592 5.53589 2.03273 6.76443 1.78836C7.99298 1.54399 9.2664 1.66941 10.4237 2.14876C11.5809 2.62812 12.5701 3.43988 13.266 4.48139C13.9619 5.5229 14.3333 6.74738 14.3333 8C14.3316 9.67916 13.6637 11.289 12.4764 12.4764C11.289 13.6637 9.67917 14.3316 8 14.3333Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.18001 7.16675C3.959 7.16675 3.74704 7.25455 3.59076 7.41083C3.43448 7.56711 3.34668 7.77907 3.34668 8.00008C3.34668 8.2211 3.43448 8.43306 3.59076 8.58934C3.74704 8.74562 3.959 8.83341 4.18001 8.83341H11.82C12.041 8.83341 12.253 8.74562 12.4093 8.58934C12.5655 8.43306 12.6533 8.2211 12.6533 8.00008C12.6533 7.77907 12.5655 7.56711 12.4093 7.41083C12.253 7.25455 12.041 7.16675 11.82 7.16675H4.18001Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Chip$viewHtml = F2(
	function (attributes, html) {
		var computedAttributes = $author$project$Ui$V3$Chip$computeAttributes(attributes);
		var className = computedAttributes.filled ? 'v3__chip__filled' : 'v3__chip__default';
		return A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('v3__chip', true),
							_Utils_Tuple2(className, true)
						])),
				computedAttributes.styles),
			_List_fromArray(
				[
					computedAttributes.excluded ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__chip-exclude-icon')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Icon$view16,
							_List_fromArray(
								[
									$author$project$Ui$V3$Icon$label('Exclude')
								]),
							$author$project$Ui$V3$Icon$removeCircle16)
						])) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__chip-text')
						]),
					_List_fromArray(
						[html])),
					function () {
					var _v0 = computedAttributes.onRemove;
					if (_v0.$ === 'Nothing') {
						return $elm$html$Html$text('');
					} else {
						var msg = _v0.a;
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__chip-remove-button'),
									$author$project$Ui$V3$Chip$onClick(msg)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Icon$view16,
									_List_fromArray(
										[
											$author$project$Ui$V3$Icon$label('Remove')
										]),
									$author$project$Ui$V3$Icon$close16)
								]));
					}
				}()
				]));
	});
var $author$project$Ui$V3$CustomSelect$viewChips = function (_v0) {
	var model = _v0.a;
	var viewChip = function (item) {
		return A2(
			$author$project$Ui$V3$Chip$viewHtml,
			_List_fromArray(
				[
					$author$project$Ui$V3$Chip$Excluded(
					_Utils_eq(
						A2(
							$author$project$Ui$V3$CustomSelect$getSelectedStatusFromItem,
							item.id,
							$author$project$Ui$V3$CustomSelect$Model(model)),
						$author$project$Ui$V3$CustomSelect$Excluded)),
					$author$project$Ui$V3$Chip$removable(
					{
						onRemove: $author$project$Ui$V3$CustomSelect$RemoveItem(item.id)
					})
				]),
			item.label);
	};
	var selectedCount = $author$project$Ui$V3$CustomSelect$getSelectedCount(
		$author$project$Ui$V3$CustomSelect$Model(model));
	var shouldShowChips = model.multiSelectTypeahead && (selectedCount > 0);
	return shouldShowChips ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__custom-select__chips'),
				$elm$html$Html$Attributes$id(
				$author$project$Ui$V3$CustomSelect$getChipsId(
					$author$project$Ui$V3$CustomSelect$Model(model))),
				$elm$html$Html$Events$onClick($author$project$Ui$V3$CustomSelect$ClickChip)
			]),
		A2(
			$elm$core$List$map,
			viewChip,
			A2($elm$core$List$append, model.selectedItems, model.excludedItems))) : $elm$html$Html$text('');
};
var $author$project$Ui$V3$CustomSelect$viewSelections = F2(
	function (_v0, computedAttributes) {
		var model = _v0.a;
		var prefixedItem = (model.multiSelectTypeahead || model.hideSelectAll) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Ui$V3$CustomSelect$simpleItem(
				{id: '', label: 'Select All'}));
		var placeholderOptionHtml = function () {
			var _v4 = model.placeholderOptionAt;
			if (_v4.$ === 'Just') {
				var minSearchLength = _v4.a;
				return (_Utils_cmp(
					$elm$core$String$length(model.inputValue),
					minSearchLength) < 0) ? A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__custom-select__selection')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__custom-select__selection-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									computedAttributes.placeholderOptionAtToHtml('Type to search'))
								]))
						])) : $elm$html$Html$text('');
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var hasPlaceholderOption = function () {
			var _v3 = model.placeholderOptionAt;
			if (_v3.$ === 'Just') {
				var minSearchLength = _v3.a;
				return _Utils_cmp(
					$elm$core$String$length(model.inputValue),
					minSearchLength) < 0;
			} else {
				return false;
			}
		}();
		var hasFooterItems = !$elm$core$List$isEmpty(computedAttributes.footerItems);
		var hasClearAllOption = model.clearable && (($elm$core$List$length(model.selectedItems) > 0) || ($elm$core$List$length(model.excludedItems) > 0));
		var footerHeaderHtml = function () {
			var _v2 = computedAttributes.footerItemsHeader;
			if (_v2.$ === 'Just') {
				var headerText = _v2.a;
				return $elm$core$List$isEmpty(computedAttributes.footerItems) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__custom-select__footer-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(headerText)
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var focusedOptionId = model.focusedOptionId;
		var footerItemsHtml = A2(
			$elm$core$List$map,
			function (item) {
				var status = A2(
					$author$project$Ui$V3$CustomSelect$getSelectedStatusFromItem,
					item.id,
					$author$project$Ui$V3$CustomSelect$Model(model));
				var onClick = computedAttributes.disabled ? $author$project$Ui$V3$CustomSelect$NoOp : $author$project$Ui$V3$CustomSelect$SelectItem(item.id);
				var itemFocused = _Utils_eq(
					focusedOptionId,
					$elm$core$Maybe$Just(item.id));
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('v3__custom-select__selection', true),
									_Utils_Tuple2(
									'v3__custom-select__selection__' + $author$project$Ui$V3$CustomSelect$selectedStatusToString(status),
									true),
									_Utils_Tuple2('v3__custom-select__selection__focused', itemFocused)
								])),
							$elm$html$Html$Events$onClick(onClick),
							A2($elm$html$Html$Attributes$attribute, 'data-option', item.id)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__custom-select__selection-text v3__type__h6')
								]),
							_List_fromArray(
								[item.label]))
						]));
			},
			computedAttributes.footerItems);
		var filteredItems = $author$project$Ui$V3$CustomSelect$getFilteredItems(
			$author$project$Ui$V3$CustomSelect$Model(model));
		var maybePrefixedFilteredItems = function () {
			if (prefixedItem.$ === 'Nothing') {
				return filteredItems;
			} else {
				var value = prefixedItem.a;
				return _Utils_eq(
					_List_fromArray(
						[value]),
					filteredItems) ? _List_fromArray(
					[value]) : A2(
					$elm$core$List$append,
					_List_fromArray(
						[value]),
					filteredItems);
			}
		}();
		var itemsHtml = A2(
			$elm$core$List$map,
			function (item) {
				var status = A2(
					$author$project$Ui$V3$CustomSelect$getSelectedStatusFromItem,
					item.id,
					$author$project$Ui$V3$CustomSelect$Model(model));
				var itemFocused = _Utils_eq(
					focusedOptionId,
					$elm$core$Maybe$Just(item.id));
				var itemDisabled = A2($elm$core$List$member, item.id, computedAttributes.disabledItemIds);
				var onClick = (computedAttributes.disabled || itemDisabled) ? $author$project$Ui$V3$CustomSelect$NoOp : $author$project$Ui$V3$CustomSelect$SelectItem(item.id);
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('v3__custom-select__selection', true),
									_Utils_Tuple2(
									'v3__custom-select__selection__' + $author$project$Ui$V3$CustomSelect$selectedStatusToString(status),
									true),
									_Utils_Tuple2('v3__custom-select__selection__focused', itemFocused),
									_Utils_Tuple2('v3__custom-select__selection__disabled', itemDisabled)
								])),
							$elm$html$Html$Events$onClick(onClick),
							A2($elm$html$Html$Attributes$attribute, 'data-option', item.id)
						]),
					_List_fromArray(
						[
							model.multiSelectTypeahead ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('v3__custom-select__selection-icon', true),
											_Utils_Tuple2(
											$author$project$Ui$V3$CustomSelect$getCheckboxClassName(
												A2(
													$author$project$Ui$V3$CustomSelect$getSelectedStatusFromItem,
													item.id,
													$author$project$Ui$V3$CustomSelect$Model(model))),
											true)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Ui$V3$CustomSelect$viewCheckboxIcon(
									A2(
										$author$project$Ui$V3$CustomSelect$getSelectedStatusFromItem,
										item.id,
										$author$project$Ui$V3$CustomSelect$Model(model)))
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__custom-select__selection-text v3__type__h6')
								]),
							_List_fromArray(
								[item.label])),
							model.canExcludeOptions ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__custom-select__selection-exclude_btn')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick(
											$author$project$Ui$V3$CustomSelect$ExcludeItem(item.id))
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
											$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorBrand)
										]),
									_Utils_eq(status, $author$project$Ui$V3$CustomSelect$Excluded) ? 'Reset' : 'Exclude')
								])) : $elm$html$Html$text('')
						]));
			},
			maybePrefixedFilteredItems);
		var shouldHideEmpty = computedAttributes.hideEmptyDropdown && ($elm$core$List$isEmpty(filteredItems) && ((!hasPlaceholderOption) && ((!hasClearAllOption) && (!hasFooterItems))));
		var effectivelyOpen = model.isOpen && (!shouldHideEmpty);
		var clearAllOptionHtml = (model.clearable && (($elm$core$List$length(model.selectedItems) > 0) || ($elm$core$List$length(model.excludedItems) > 0))) ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__custom-select__selection'),
					$elm$html$Html$Events$onClick($author$project$Ui$V3$CustomSelect$ClearSelections)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__custom-select__clear v3__type__h6')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Clear All')
						]))
				])) : $elm$html$Html$text('');
		var allOptions = A2(
			$elm$core$List$cons,
			placeholderOptionHtml,
			A2(
				$elm$core$List$cons,
				clearAllOptionHtml,
				_Utils_ap(
					itemsHtml,
					_Utils_ap(
						_List_fromArray(
							[footerHeaderHtml]),
						footerItemsHtml))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__custom-select__selections-bounding-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__custom-select__selections-container'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('v3__custom-select__open', effectivelyOpen),
									_Utils_Tuple2('v3__custom-select__closed', !effectivelyOpen),
									_Utils_Tuple2('v3__custom-select__direction-up', model.openUp),
									_Utils_Tuple2('v3__custom-select__direction-down', !model.openUp)
								])),
							$elm$html$Html$Attributes$id(
							$author$project$Ui$V3$CustomSelect$getScrollableListContainerId(
								$author$project$Ui$V3$CustomSelect$Model(model))),
							$author$project$Helpers$Scroll$onScroll($author$project$Ui$V3$CustomSelect$Scrolled)
						]),
					_List_fromArray(
						[
							$author$project$Ui$V3$CustomSelect$viewChips(
							$author$project$Ui$V3$CustomSelect$Model(model)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__custom-select__selections-container-list'),
									$elm$html$Html$Attributes$id(
									$author$project$Ui$V3$CustomSelect$getListId(
										$author$project$Ui$V3$CustomSelect$Model(model))),
									$elm$html$Html$Attributes$tabindex(
									model.isOpen ? 0 : (-1))
								]),
							allOptions)
						]))
				]));
	});
var $author$project$Ui$V3$CustomSelect$view = F2(
	function (_v0, attributes) {
		var model = _v0.a;
		var selectedCount = $author$project$Ui$V3$CustomSelect$getSelectedCount(
			$author$project$Ui$V3$CustomSelect$Model(model));
		var isEditable = model.isFilterable;
		var displayValue = (model.multiSelectTypeahead || (model.singleSelectTypeahead && model.isOpen)) ? model.inputValue : $author$project$Ui$V3$CustomSelect$getFirstValueText(
			$author$project$Ui$V3$CustomSelect$Model(model));
		var computedAttributes = $author$project$Ui$V3$CustomSelect$computeAttributes(attributes);
		var labelEl = function () {
			var _v2 = computedAttributes.label;
			if (_v2.$ === 'Just') {
				var l = _v2.a;
				return A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__custom-select__label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							computedAttributes.labelToHtml(l))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var leftIconElement = A2(
			$elm$core$Maybe$map,
			$author$project$Ui$V3$Icon$view16(_List_Nil),
			computedAttributes.leftIcon);
		var placeholderStr = A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$Ui$V3$CustomSelect$getDerivedPlaceholder,
				computedAttributes.label,
				$author$project$Ui$V3$CustomSelect$Model(model)),
			model.placeholder);
		return A2(
			$elm$html$Html$map,
			function (msg) {
				return computedAttributes.disabled ? $author$project$Ui$V3$CustomSelect$NoOp : msg;
			},
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__custom-select'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('v3__custom-select-flex', model.placeLabelOnLeft),
								_Utils_Tuple2('v3__custom-select__disabled', computedAttributes.disabled)
							]))
					]),
				_List_fromArray(
					[
						labelEl,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v3__custom-select__container'),
								$elm$html$Html$Attributes$id(
								$author$project$Ui$V3$CustomSelect$getCustomSelectId(
									$author$project$Ui$V3$CustomSelect$Model(model))),
								A2(
								$elm$html$Html$Events$on,
								'keydown',
								A2($elm$json$Json$Decode$map, $author$project$Ui$V3$CustomSelect$HandleKeyboardEvent, $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3__custom-select__input-container'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('v3__custom-select__input-container--errored', computedAttributes.error),
												_Utils_Tuple2('v3__custom-select__input-container--borderless', computedAttributes.borderless)
											]))
									]),
								_List_fromArray(
									[
										function () {
										if (leftIconElement.$ === 'Just') {
											var leftIconValue = leftIconElement.a;
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('v3__custom-select__left-icon')
													]),
												_List_fromArray(
													[leftIconValue]));
										} else {
											return $author$project$Ui$V3$Helpers$Html$empty;
										}
									}(),
										model.multiSelectTypeahead ? $author$project$Ui$V3$CustomSelect$getMultiSelectValue(selectedCount) : $elm$html$Html$text(''),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('v3__custom-select__input'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('v3__custom-select__input--editable', isEditable),
														_Utils_Tuple2('v3__custom-select__input--is-open', model.isOpen && (!computedAttributes.error)),
														_Utils_Tuple2('v3__custom-select__input--has-badge', model.multiSelectTypeahead && (selectedCount > 0)),
														_Utils_Tuple2(
														'v3__custom-select__input--has-left-icon',
														!_Utils_eq(computedAttributes.leftIcon, $elm$core$Maybe$Nothing)),
														_Utils_Tuple2('v3__custom-select__input--borderless', computedAttributes.borderless)
													])),
												A2(
												$elm$html$Html$Attributes$style,
												'padding-top',
												$elm$core$String$fromInt(computedAttributes.verticalInputPadding) + 'px'),
												A2(
												$elm$html$Html$Attributes$style,
												'padding-bottom',
												$elm$core$String$fromInt(computedAttributes.verticalInputPadding) + 'px'),
												$elm$html$Html$Attributes$id(
												$author$project$Ui$V3$CustomSelect$getInputId(
													$author$project$Ui$V3$CustomSelect$Model(model))),
												$elm$html$Html$Attributes$readonly(!isEditable),
												$elm$html$Html$Attributes$value(displayValue),
												$elm$html$Html$Attributes$placeholder(placeholderStr),
												$elm$html$Html$Attributes$disabled(computedAttributes.disabled),
												$elm$html$Html$Events$onInput($author$project$Ui$V3$CustomSelect$ChangeInputValue),
												$elm$html$Html$Events$onFocus($author$project$Ui$V3$CustomSelect$HandleFocus),
												$elm$html$Html$Events$onClick(
												$author$project$Ui$V3$CustomSelect$ClickIn(
													{isCaret: false})),
												$elm$html$Html$Attributes$autocomplete(false)
											]),
										_List_Nil),
										function () {
										if (computedAttributes.hideArrow) {
											return $author$project$Ui$V3$Helpers$Html$empty;
										} else {
											var rightIcon = computedAttributes.loading ? A2(
												$author$project$Ui$V3$Icon$view16,
												_List_fromArray(
													[
														$author$project$Ui$V3$Icon$label('Open')
													]),
												$author$project$Ui$V3$Icon$loading1) : A2(
												$author$project$Ui$V3$Icon$view16,
												_List_fromArray(
													[
														$author$project$Ui$V3$Icon$label('Open')
													]),
												$author$project$Ui$V3$Icon$arrowDown16);
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('v3__custom-select__arrow'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('v3__custom-select__arrow-flipped', model.isOpen && (!computedAttributes.loading)),
																_Utils_Tuple2('v3__spin', computedAttributes.loading)
															])),
														$elm$html$Html$Events$onClick(
														$author$project$Ui$V3$CustomSelect$ClickIn(
															{isCaret: true}))
													]),
												_List_fromArray(
													[rightIcon]));
										}
									}()
									])),
								A2(
								$author$project$Ui$V3$CustomSelect$viewSelections,
								$author$project$Ui$V3$CustomSelect$Model(model),
								computedAttributes)
							]))
					])));
	});
var $author$project$Components$PaginatedDropdown$view = F4(
	function (dataToItem, data, attrs, origPaginatedDropdown) {
		var paginatedDropdown = A3($author$project$Components$PaginatedDropdown$withData, dataToItem, data, origPaginatedDropdown);
		var isLoading = !$author$project$Forward$Remote$isResolved(data);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$CustomSelect$view,
							paginatedDropdown.dropdown,
							A2(
								$elm$core$List$cons,
								$author$project$Ui$V3$CustomSelect$loading(isLoading),
								attrs))
						]))
				]));
	});
var $author$project$Components$CarrierDropdown$view = F3(
	function (attrs, data, model) {
		return A4(
			$author$project$Components$PaginatedDropdown$view,
			$author$project$Components$CarrierDropdown$carrierToDropdownItem(model.accountInfo),
			data,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$V3$CustomSelect$label(
					$author$project$Domain$Account$carrierTerm(model.accountInfo.accountType)),
				attrs),
			model.dropdown);
	});
var $author$project$Components$DebtorDropdown$view = F3(
	function (attrs, data, model) {
		return A4(
			$author$project$Components$PaginatedDropdown$view,
			$author$project$Components$DebtorDropdown$debtorToDropdownItem,
			data,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$V3$CustomSelect$label('Debtor'),
				attrs),
			model.dropdown);
	});
var $author$project$Components$NoaManagement$SentPage$viewClientLink = function (row) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[$author$project$Ui$V3$Typography$bodyClass]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Link$view,
				{
					text: row.clientName,
					url: $author$project$Path$toString(
						$author$project$Path$settingsEditCarrier(row.tmsCarrierId))
				},
				_List_Nil)
			]));
};
var $author$project$Components$NoaManagement$SentPage$viewFactoringSystemStatus = function (status) {
	switch (status.$) {
		case 'SentNoa_FactoringSystemStatusSucceeded':
			return A2(
				$author$project$Ui$V3$DescriptorTag$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$SuccessStyle)
					]),
				'Recorded');
		case 'SentNoa_FactoringSystemStatusFailed':
			return A2(
				$author$project$Ui$V3$DescriptorTag$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$AlertStyle)
					]),
				'Not recorded');
		case 'SentNoa_FactoringSystemStatusPending':
			return A2(
				$author$project$Ui$V3$DescriptorTag$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$DefaultStyle)
					]),
				'Pending');
		case 'SentNoa_FactoringSystemStatusNotApplicable':
			return A2(
				$author$project$Ui$V3$DescriptorTag$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$DefaultStyle)
					]),
				'N/A');
		case 'SentNoa_FactoringSystemStatusAwaitingRelationship':
			return A2(
				$author$project$Ui$V3$DescriptorTag$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$DefaultStyle)
					]),
				'Waiting for relationship');
		default:
			return $author$project$Helpers$Html$empty;
	}
};
var $author$project$Components$NoaManagement$SentPage$ClickedRetry = function (a) {
	return {$: 'ClickedRetry', a: a};
};
var $author$project$Components$NoaManagement$SentPage$viewRetryButton = F2(
	function (model, itemId) {
		return A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					$author$project$Components$NoaManagement$SentPage$ClickedRetry(itemId))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$disabled(
					_Utils_eq(
						model.retryingItemId,
						$elm$core$Maybe$Just(itemId)))
				]),
			'Retry');
	});
var $author$project$Components$NoaManagement$SentPage$viewFactoringSystemCell = F2(
	function (model, row) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$crossAxisLeft
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Components$NoaManagement$SentPage$viewFactoringSystemStatus(row.factoringSystemStatus),
				function () {
					var _v0 = row.factoringSystemStatus;
					if (_v0.$ === 'SentNoa_FactoringSystemStatusFailed') {
						return _List_fromArray(
							[
								A2($author$project$Components$NoaManagement$SentPage$viewRetryButton, model, row.id)
							]);
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$Components$NoaManagement$SentPage$ClickedResend = function (a) {
	return {$: 'ClickedResend', a: a};
};
var $author$project$Components$NoaManagement$SentPage$viewResendButton = F2(
	function (model, row) {
		return A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					$author$project$Components$NoaManagement$SentPage$ClickedResend(row.id))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$disabled(
					_Utils_eq(
						model.resendingItemId,
						$elm$core$Maybe$Just(row.id)))
				]),
			'Resend');
	});
var $author$project$Components$NoaManagement$SentPage$viewSentAt = F2(
	function (timezone, row) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Typography$body,
					_List_Nil,
					A2($author$project$Helpers$Date$dateString, timezone, row.sentAt)),
					A2(
					$author$project$Ui$V3$Typography$smallBody,
					_List_fromArray(
						[
							$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
						]),
					A2($author$project$Helpers$Date$timeStringNoPadding, timezone, row.sentAt))
				]));
	});
var $author$project$Components$NoaManagement$SentPage$viewAddressSource = function (source) {
	switch (source.$) {
		case 'SentNoa_AddressSourceProposed':
			return A2(
				$author$project$Ui$V3$DescriptorTag$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$SuccessStyle)
					]),
				'Proposed address');
		case 'SentNoa_AddressSourceTyped':
			return A2(
				$author$project$Ui$V3$DescriptorTag$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$InfoStyle)
					]),
				'Typed by reviewer');
		default:
			return $author$project$Helpers$Html$empty;
	}
};
var $author$project$Components$NoaManagement$SentPage$viewSentTo = function (row) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
				$author$project$Ui$V3$Stack$crossAxisLeft
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$body, _List_Nil, row.sentToEmailAddress),
				$author$project$Components$NoaManagement$SentPage$viewAddressSource(row.addressSource)
			]));
};
var $author$project$Components$NoaManagement$SentPage$viewTable = F2(
	function (data, model) {
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$NoaManagement$SentPage$viewSentAt(model.timezone),
						heading: $elm$html$Html$text('Sent')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, row.debtorName);
						},
						heading: $elm$html$Html$text('Debtor')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$NoaManagement$SentPage$viewClientLink,
						heading: $elm$html$Html$text('Client')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$NoaManagement$SentPage$viewSentTo,
						heading: $elm$html$Html$text('Sent to')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, row.documentDisplay);
						},
						heading: $elm$html$Html$text('Document')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: function (row) {
							return A2($author$project$Ui$V3$Typography$body, _List_Nil, row.sentByName);
						},
						heading: $elm$html$Html$text('Sent by')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$NoaManagement$SentPage$viewFactoringSystemCell(model),
						heading: $elm$html$Html$text('Factoring system')
					},
						{
						attrs: _List_fromArray(
							[$author$project$Ui$V3$Table$topAligned]),
						content: $author$project$Components$NoaManagement$SentPage$viewResendButton(model),
						heading: $author$project$Helpers$Html$empty
					}
					])
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$toolbarItems(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Ui$V3$Table$toolbarCustomHtml(
								A2(
									$elm$html$Html$map,
									$author$project$Components$NoaManagement$SentPage$DebtorDropdownMsg,
									A3($author$project$Components$DebtorDropdown$view, _List_Nil, data.debtorDropdown, model.debtorDropdown)))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Ui$V3$Table$toolbarCustomHtml(
								A2(
									$elm$html$Html$map,
									$author$project$Components$NoaManagement$SentPage$CarrierDropdownMsg,
									A3($author$project$Components$CarrierDropdown$view, _List_Nil, data.carrierDropdown, model.carrierDropdown)))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Ui$V3$Table$toolbarCustomHtml(
								A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick($author$project$Components$NoaManagement$SentPage$ClickedClearFilters)
									},
									_List_Nil,
									'Clear'))),
							_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Ui$V3$Table$toolbarEmpty)
						])),
					$author$project$Ui$V3$Table$pagination(
					{currentPage: data.page, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$NoaManagement$SentPage$UpdatedPage}),
					$author$project$Ui$V3$Table$emptyContent(
					A2(
						$author$project$Ui$V3$Typography$body,
						_List_fromArray(
							[
								$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextNeutralSubtle)
							]),
						'No NOAs sent yet'))
				]),
			_List_Nil,
			$author$project$Pagination$entries(data.page));
	});
var $author$project$Components$NoaManagement$SentPage$view = F2(
	function (data, model) {
		return A2(
			$author$project$Components$NoaManagement$Layout$view,
			{current: $author$project$Components$NoaManagement$Layout$Sent, onSelectTab: $author$project$Components$NoaManagement$SentPage$SelectedTab, sandboxRecipients: data.sandboxRecipients},
			_List_fromArray(
				[
					A2($author$project$Components$NoaManagement$SentPage$viewTable, data, model)
				]));
	});
var $author$project$Components$NoaManagement$SentPage$page = $author$project$Forward$Component$forwardComponent(
	{
		init: function (_v0) {
			var params = _v0.a;
			var initData = _v0.b;
			var _v1 = $author$project$Components$DebtorDropdown$init(
				{attrs: $author$project$Components$NoaManagement$SentPage$singleSelect, selected: initData.debtorDropdown.selectedFactorBrokers});
			var debtorDropdown = _v1.a;
			var debtorCmd = _v1.b;
			var _v2 = $author$project$Components$CarrierDropdown$initForAssignment(
				{
					accountType: $author$project$Domain$Account$accountType(initData.account),
					isFactor: initData.account.factorAccount,
					selectedCarriers: initData.carrierDropdown.selectedCarriers,
					showVendorId: initData.accountSettings.showCarrierExternalVendorId
				});
			var carrierDropdown = _v2.a;
			var carrierCmd = _v2.b;
			return _Utils_Tuple2(
				{carrierDropdown: carrierDropdown, carrierId: params.carrierId, debtorDropdown: debtorDropdown, debtorId: params.debtorId, pageNumber: 1, resendingItemId: $elm$core$Maybe$Nothing, retryingItemId: $elm$core$Maybe$Nothing, timezone: $elm$time$Time$utc},
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[
							$author$project$HubTran$Effect$cmd(
							A2($elm$core$Task$perform, $author$project$Components$NoaManagement$SentPage$SetTimezone, $author$project$Helpers$Date$localTimezone)),
							$author$project$HubTran$Effect$cmd(
							A2($elm$core$Platform$Cmd$map, $author$project$Components$NoaManagement$SentPage$DebtorDropdownMsg, debtorCmd)),
							$author$project$HubTran$Effect$cmd(
							A2($elm$core$Platform$Cmd$map, $author$project$Components$NoaManagement$SentPage$CarrierDropdownMsg, carrierCmd))
						])));
		},
		loadData: $author$project$Components$NoaManagement$SentPage$loadData,
		update: $author$project$Components$NoaManagement$SentPage$update,
		v3ReskinEnabled: true,
		viewLoaded: $author$project$Components$NoaManagement$SentPage$view
	});
var $author$project$Main$loadData = function (model) {
	var _v0 = model.page;
	switch (_v0.$) {
		case 'BlankPage':
			return $author$project$Forward$Lookup$succeed($author$project$Main$BlankPageData);
		case 'LoadingPage':
			return $author$project$Forward$Lookup$succeed($author$project$Main$LoadingPageData);
		case 'LoadingFailedPage':
			var error = _v0.a;
			return $author$project$Forward$Lookup$succeed(
				$author$project$Main$LoadingFailedPageData(error));
		case 'ActivityPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$ActivityPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					A2($author$project$Components$ActivityPage$loadData, model.headerFlags.reskinVals.topLevel, page)));
		case 'BrokerBillingRequirementsPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$BrokerBillingRequirementsPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Broker$Page$BillingRequirements$loadData(page)));
		case 'CarrierInvoiceAuditPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$CarrierInvoiceAuditPageData(page),
				$author$project$Components$CarrierInvoiceAuditPage$loadData(page));
		case 'ClientSubmissionInvoicePage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$ClientSubmissionInvoicePageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Factoring$Page$ClientSubmissionInvoice$loadData(page)));
		case 'ClientSubmissionPage':
			var page = _v0.a;
			return $author$project$Forward$Lookup$succeed(
				$author$project$Main$ClientSubmissionPageData(page));
		case 'ClientSubmissionReviewPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$ClientSubmissionReviewPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Factoring$Page$ClientSubmissionReview$loadData(page)));
		case 'DashboardPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$DashboardPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					A2($author$project$Components$DashboardPage$loadData, model.headerFlags.reskinVals, page)));
		case 'DocumentsViewerPopoutPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$DocumentsViewerPopoutPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Broker$Page$DocumentsViewerPopout$loadData(page)));
		case 'EmailMessageSearchPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$EmailMessageSearchPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					A2($author$project$Components$EmailMessageSearchPage$loadData, model.headerFlags.reskinVals.topLevel, page)));
		case 'HelpPage':
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$HelpPageData,
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$HelpPage$loadData));
		case 'NonInvoiceConfirmPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$NonInvoiceConfirmPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$NonInvoiceConfirmPage$loadData(page)));
		case 'SettingsCarrierPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsCarrierPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$SettingsPage$CarrierLayout$loadData(page)));
		case 'SettingsCarriersPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsCarriersPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$SettingsPage$CarriersLayout$loadData(page)));
		case 'SettingsCustomerPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsCustomerPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$SettingsPage$CustomerLayout$loadData(page)));
		case 'SettingsCustomersPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsCustomersPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$SettingsPage$CustomersLayout$loadData(page)));
		case 'SettingsDebtorPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsDebtorPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$SettingsPage$DebtorLayout$loadData(page)));
		case 'SettingsPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$SettingsPage$loadData(page)));
		case 'SettingsReferenceFieldsPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsReferenceFieldsPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$SettingsPage$ReferenceFieldsLayout$loadData));
		case 'SettingsReportsPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsReportsPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$SettingsPage$ReportsLayout$loadData));
		case 'SettingsRulesPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsRulesPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$SettingsPage$RulesLayout$loadData));
		case 'SettingsUserPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsUserPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$SettingsPage$UserLayout$loadData(page)));
		case 'SettingsUsersPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsUsersPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$SettingsPage$UsersLayout$loadData));
		case 'SettingsVerificationsPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$SettingsVerificationsPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState($author$project$Components$SettingsPage$VerificationsLayout$loadData));
		case 'TermsPage':
			var page = _v0.a;
			return $author$project$Forward$Lookup$succeed(
				$author$project$Main$TermsPageData(page));
		case 'VerificationBatchPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$VerificationBatchPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Factoring$Page$VerificationBatch$loadData(page)));
		case 'LtlReconcileInvoicePage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$LtlReconcileInvoicePageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$LtlReconcileInvoicePage$loadData(page)));
		case 'OktaLoginPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$OktaLoginPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$OktaLoginPage$loadData(page)));
		case 'FactorInvoiceAuditPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$FactorInvoiceAuditPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$FactorInvoiceAuditPage$loadData(page)));
		case 'FactorInvoiceAuditBatchGroupingPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$FactorInvoiceAuditBatchGroupingPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$FactorInvoiceAuditBatchGroupingPage$loadData(page)));
		case 'FactorInvoiceAuditBatchPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$FactorInvoiceAuditBatchPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$FactorInvoiceAuditBatchPage$loadData(page)));
		case 'ForwardingHasMovedPage':
			return $author$project$Forward$Lookup$succeed($author$project$Main$ForwardingHasMovedPageData);
		case 'MyClientsOverviewPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$MyClientsOverviewPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$MyClients$OverviewPage$page.loadData(page)));
		case 'NoaManagementToSendPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$NoaManagementToSendPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$NoaManagement$ToSendPage$page.loadData(page)));
		case 'DebtorChangesPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$DebtorChangesPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$DebtorChanges$IndexPage$page.loadData(page)));
		case 'DebtorChangesTemplatePage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$DebtorChangesTemplatePageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$DebtorChanges$TemplatePage$page.loadData(page)));
		case 'NoaManagementSentPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$NoaManagementSentPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$NoaManagement$SentPage$page.loadData(page)));
		case 'NoaManagementSkippedPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$NoaManagementSkippedPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$NoaManagement$SkippedPage$page.loadData(page)));
		case 'DocumentReviewPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$DocumentReviewPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$DocumentReviewPage$loadData(page)));
		case 'DocumentBatchReviewPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$DocumentBatchReviewPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$DocumentBatchReviewPage$loadData(page)));
		case 'DocumentGroupReviewPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$DocumentGroupReviewPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$DocumentGroupReviewPage$loadData(page)));
		case 'LtlHeldSubmissionsPage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$LtlHeldSubmissionsPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$LtlHeldSubmissionsPage$loadData(page)));
		case 'EmailMergePage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$EmailMergePageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$EmailMergePage$page.loadData(page)));
		case 'ReadonlyFactorInvoicePage':
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$ReadonlyFactorInvoicePageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$ReadonlyFactorInvoicePage$loadData(page)));
		default:
			var page = _v0.a;
			return A2(
				$author$project$Forward$Lookup$map,
				$author$project$Main$ToBeScrapedLoadsPageData(page),
				$author$project$Forward$Lookup$exposeLoadingState(
					$author$project$Components$ToBeScrapedLoadsPage$page.loadData(page)));
	}
};
var $author$project$Forward$Component$ChildMsg = function (a) {
	return {$: 'ChildMsg', a: a};
};
var $author$project$Forward$Component$Model = function (a) {
	return {$: 'Model', a: a};
};
var $author$project$Forward$AppSpecific$Cache$empty = {account: $author$project$Forward$Internal$EntrypointCache$empty, accountSettings: $author$project$Forward$Internal$EntrypointCache$empty, activityItem: $author$project$Forward$Internal$EntrypointCache$empty, activityItemContextDataByCarrierInvoiceId: $author$project$Forward$Internal$EntrypointCache$empty, activityItemContextDataByDocumentBatchId: $author$project$Forward$Internal$EntrypointCache$empty, activityItemContextDataByLoadStateId: $author$project$Forward$Internal$EntrypointCache$empty, brokeredCarrier: $author$project$Forward$Internal$EntrypointCache$empty, brokeredCarrierTerm: $author$project$Forward$Internal$EntrypointCache$empty, cadenceDebtorContact: $author$project$Forward$Internal$EntrypointCache$empty, cadenceVerificationMethod: $author$project$Forward$Internal$EntrypointCache$empty, canonicalVerificationId: $author$project$Forward$Internal$EntrypointCache$empty, carrierInvoice: $author$project$Forward$Internal$EntrypointCache$empty, carrierInvoiceDashboardRow: $author$project$Forward$Internal$EntrypointCache$empty, contact: $author$project$Forward$Internal$EntrypointCache$empty, customExceptionEmailTemplate: $author$project$Forward$Internal$EntrypointCache$empty, customerPODDefinitions: $author$project$Forward$Internal$EntrypointCache$empty, dashboardSavedFilter: $author$project$Forward$Internal$EntrypointCache$empty, debtorChangeReport: $author$project$Forward$Internal$EntrypointCache$empty, debtorChangeTemplate: $author$project$Forward$Internal$EntrypointCache$empty, documentBatchGroupingReview: $author$project$Forward$Internal$EntrypointCache$empty, documentBatchV2: $author$project$Forward$Internal$EntrypointCache$empty, documentGroup: $author$project$Forward$Internal$EntrypointCache$empty, documentGroupLoadReview: $author$project$Forward$Internal$EntrypointCache$empty, documentLoadReferenceMatchReview: $author$project$Forward$Internal$EntrypointCache$empty, documentPage: $author$project$Forward$Internal$EntrypointCache$empty, documentTypeReview: $author$project$Forward$Internal$EntrypointCache$empty, documentTypeSettings: $author$project$Forward$Internal$EntrypointCache$empty, documentV2: $author$project$Forward$Internal$EntrypointCache$empty, emailMessage: $author$project$Forward$Internal$EntrypointCache$empty, exceptionEvent: $author$project$Forward$Internal$EntrypointCache$empty, exceptionSummary: $author$project$Forward$Internal$EntrypointCache$empty, exceptionedItem: $author$project$Forward$Internal$EntrypointCache$empty, exceptionsByHighestCount: $author$project$Forward$Internal$EntrypointCache$empty, externalLogin: $author$project$Forward$Internal$EntrypointCache$empty, factorAging: $author$project$Forward$Internal$EntrypointCache$empty, factorBroker: $author$project$Forward$Internal$EntrypointCache$empty, factorBrokerSettings: $author$project$Forward$Internal$EntrypointCache$empty, factorInvoice: $author$project$Forward$Internal$EntrypointCache$empty, factorInvoiceDocumentPacketComparison: $author$project$Forward$Internal$EntrypointCache$empty, factorInvoiceSubmission: $author$project$Forward$Internal$EntrypointCache$empty, _int: $author$project$Forward$Internal$EntrypointCache$empty, integration: $author$project$Forward$Internal$EntrypointCache$empty, invoiceAmountReview: $author$project$Forward$Internal$EntrypointCache$empty, invoiceNumberReview: $author$project$Forward$Internal$EntrypointCache$empty, list_address: $author$project$Forward$Internal$EntrypointCache$empty, list_autoReplyFilter: $author$project$Forward$Internal$EntrypointCache$empty, list_cadenceDebtorContactId: $author$project$Forward$Internal$EntrypointCache$empty, list_cadenceVerificationMethodId: $author$project$Forward$Internal$EntrypointCache$empty, list_carrierInvoiceAuditCheck: $author$project$Forward$Internal$EntrypointCache$empty, list_carrierInvoiceId: $author$project$Forward$Internal$EntrypointCache$empty, list_correspondent: $author$project$Forward$Internal$EntrypointCache$empty, list_customExceptionEmailTemplateId: $author$project$Forward$Internal$EntrypointCache$empty, list_customerInvoiceTemplate: $author$project$Forward$Internal$EntrypointCache$empty, list_dashboardSavedFilterId: $author$project$Forward$Internal$EntrypointCache$empty, list_documentAddressAnswer: $author$project$Forward$Internal$EntrypointCache$empty, list_documentGroupId: $author$project$Forward$Internal$EntrypointCache$empty, list_documentId: $author$project$Forward$Internal$EntrypointCache$empty, list_documentPODDefinition: $author$project$Forward$Internal$EntrypointCache$empty, list_documentPODDefinitionByFactorInvoice: $author$project$Forward$Internal$EntrypointCache$empty, list_documentPageId: $author$project$Forward$Internal$EntrypointCache$empty, list_documentPageLine: $author$project$Forward$Internal$EntrypointCache$empty, list_emailMessageId: $author$project$Forward$Internal$EntrypointCache$empty, list_exceptionEventId: $author$project$Forward$Internal$EntrypointCache$empty, list_exceptionedItemId: $author$project$Forward$Internal$EntrypointCache$empty, list_externalLoginId: $author$project$Forward$Internal$EntrypointCache$empty, list_factorBrokerId: $author$project$Forward$Internal$EntrypointCache$empty, list_factorInvoiceAuditCheck: $author$project$Forward$Internal$EntrypointCache$empty, list_factorInvoiceId: $author$project$Forward$Internal$EntrypointCache$empty, list_factorInvoicePossibleMatch: $author$project$Forward$Internal$EntrypointCache$empty, list_integrationId: $author$project$Forward$Internal$EntrypointCache$empty, list_myClientsAccountExecutive: $author$project$Forward$Internal$EntrypointCache$empty, list_myClientsOverviewRow: $author$project$Forward$Internal$EntrypointCache$empty, list_networkBroker: $author$project$Forward$Internal$EntrypointCache$empty, list_officePeopleMapping: $author$project$Forward$Internal$EntrypointCache$empty, list_processedFactorInvoiceIdGroup: $author$project$Forward$Internal$EntrypointCache$empty, list_reviewIdGroup: $author$project$Forward$Internal$EntrypointCache$empty, list_tmsCarrierId: $author$project$Forward$Internal$EntrypointCache$empty, list_tmsCustomerId: $author$project$Forward$Internal$EntrypointCache$empty, list_unresolvedDocumentType: $author$project$Forward$Internal$EntrypointCache$empty, list_userId: $author$project$Forward$Internal$EntrypointCache$empty, list_verificationsDebtorBatchIdGroup: $author$project$Forward$Internal$EntrypointCache$empty, list_verificationsDebtorBatchItemId: $author$project$Forward$Internal$EntrypointCache$empty, list_verificationsLogin: $author$project$Forward$Internal$EntrypointCache$empty, loadState: $author$project$Forward$Internal$EntrypointCache$empty, ltlPayablesCarrierAndLoadItemEqualityData: $author$project$Forward$Internal$EntrypointCache$empty, ltlPayablesCarrierInvoiceSubmission: $author$project$Forward$Internal$EntrypointCache$empty, maybe_address: $author$project$Forward$Internal$EntrypointCache$empty, maybe_clientSubmissionReviewData: $author$project$Forward$Internal$EntrypointCache$empty, maybe_documentPODDefinitionOverrideInteraction: $author$project$Forward$Internal$EntrypointCache$empty, maybe_emailMessageId: $author$project$Forward$Internal$EntrypointCache$empty, maybe_factorInvoiceId: $author$project$Forward$Internal$EntrypointCache$empty, maybe_factorSubmissionBatch: $author$project$Forward$Internal$EntrypointCache$empty, maybe_importStatus: $author$project$Forward$Internal$EntrypointCache$empty, maybe_sentMessage: $author$project$Forward$Internal$EntrypointCache$empty, maybe_string: $author$project$Forward$Internal$EntrypointCache$empty, maybe_verification: $author$project$Forward$Internal$EntrypointCache$empty, maybe_verificationsDebtorBatchId: $author$project$Forward$Internal$EntrypointCache$empty, maybe_verificationsDebtorBatchItem: $author$project$Forward$Internal$EntrypointCache$empty, multiPageBolReview: $author$project$Forward$Internal$EntrypointCache$empty, noaSandboxRecipients: $author$project$Forward$Internal$EntrypointCache$empty, noaSendQueueItem: $author$project$Forward$Internal$EntrypointCache$empty, page_brokeredCarrierId: $author$project$Forward$Internal$EntrypointCache$empty, page_brokeredCarrierTermId: $author$project$Forward$Internal$EntrypointCache$empty, page_contactId: $author$project$Forward$Internal$EntrypointCache$empty, page_factorBrokerId: $author$project$Forward$Internal$EntrypointCache$empty, page_factorInvoiceSubmissionId: $author$project$Forward$Internal$EntrypointCache$empty, page_ltlPayablesCarrierInvoiceSubmissionId: $author$project$Forward$Internal$EntrypointCache$empty, page_noaSendQueueItemId: $author$project$Forward$Internal$EntrypointCache$empty, page_sentNoa: $author$project$Forward$Internal$EntrypointCache$empty, page_skippedNoaId: $author$project$Forward$Internal$EntrypointCache$empty, page_tmsCarrierId: $author$project$Forward$Internal$EntrypointCache$empty, page_tmsCustomer: $author$project$Forward$Internal$EntrypointCache$empty, page_tmsCustomerId: $author$project$Forward$Internal$EntrypointCache$empty, portalDisplaySettings: $author$project$Forward$Internal$EntrypointCache$empty, processedCarrierInvoiceRowData: $author$project$Forward$Internal$EntrypointCache$empty, sentNoa: $author$project$Forward$Internal$EntrypointCache$empty, set_string: $author$project$Forward$Internal$EntrypointCache$empty, skippedNoa: $author$project$Forward$Internal$EntrypointCache$empty, stream_activityItemId: $author$project$Forward$Internal$EntrypointCache$empty, stream_emailMessageId: $author$project$Forward$Internal$EntrypointCache$empty, string: $author$project$Forward$Internal$EntrypointCache$empty, submissionDropdownData: $author$project$Forward$Internal$EntrypointCache$empty, tmsCarrier: $author$project$Forward$Internal$EntrypointCache$empty, tmsCustomer: $author$project$Forward$Internal$EntrypointCache$empty, tmsCustomerSettings: $author$project$Forward$Internal$EntrypointCache$empty, tmsLoad: $author$project$Forward$Internal$EntrypointCache$empty, tmsLoadDetails: $author$project$Forward$Internal$EntrypointCache$empty, tmsLoadInformation: $author$project$Forward$Internal$EntrypointCache$empty, tmsLoadShipment: $author$project$Forward$Internal$EntrypointCache$empty, tmsShipment: $author$project$Forward$Internal$EntrypointCache$empty, unit: $author$project$Forward$Internal$EntrypointCache$empty, user: $author$project$Forward$Internal$EntrypointCache$empty, userId: $author$project$Forward$Internal$EntrypointCache$empty, verificationsDebtorBatch: $author$project$Forward$Internal$EntrypointCache$empty, verificationsDebtorBatchItem: $author$project$Forward$Internal$EntrypointCache$empty};
var $author$project$Forward$Internal$OutstandingRequests$OutstandingRequests = function (a) {
	return {$: 'OutstandingRequests', a: a};
};
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$union, dict1, dict2));
	});
var $author$project$Forward$Internal$OutstandingRequests$build = function (newDict) {
	return $author$project$Forward$Internal$OutstandingRequests$OutstandingRequests(
		{
			byRequestId: newDict,
			precomputedUnion: A3(
				$elm$core$List$foldl,
				$elm$core$Set$union,
				$elm$core$Set$empty,
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $elm$core$Dict$keys, $elm$core$Set$fromList),
					$elm$core$Dict$values(newDict)))
		});
};
var $author$project$Forward$Internal$OutstandingRequests$empty = $author$project$Forward$Internal$OutstandingRequests$build($elm$core$Dict$empty);
var $author$project$Forward$Internal$PureEffectManager$init = {nextRequestId: 1, outstandingRequestsByEntrypoint: $elm$core$Dict$empty, pendingSingleFetches: _List_Nil, requestsOnLastEffectManagerTick: $elm$core$Dict$empty, z__internal__outstandingRequests: $author$project$Forward$Internal$OutstandingRequests$empty, z__internal__typedCache: $author$project$Forward$AppSpecific$Cache$empty};
var $author$project$Forward$Component$initModel = function (childModel) {
	return $author$project$Forward$Component$Model(
		{
			childModel: childModel,
			data: $author$project$Forward$Remote$Loading,
			forwardAPI: $author$project$Forward$Internal$PureEffectManager$init,
			mostRecentLookup: $author$project$Forward$Internal$LookupStructure$Constant('(none)')
		});
};
var $author$project$HubTran$Effect$internal_forwardRequestItems = function (dataToLoad) {
	return $elm$core$List$isEmpty(dataToLoad) ? $author$project$HubTran$Effect$none : $author$project$HubTran$Effect$ForwardEffect(
		$author$project$Forward$Internal$PureEffectManagerCmd$RequestItems(dataToLoad));
};
var $author$project$Forward$Component$refreshData = F3(
	function (childLoadData, childDataEffects, _v0) {
		var model = _v0.a.a;
		var childEffects = _v0.b;
		var childLookup = childLoadData(model.childModel);
		var cache = model.forwardAPI.z__internal__typedCache;
		var lookupResult = A2($author$project$Forward$Lookup$run, cache, childLookup);
		var newData = lookupResult.cachedValue;
		var dataEffects = function () {
			if (newData.$ === 'Loaded') {
				var data = newData.a;
				return A2(childDataEffects, data, model.childModel);
			} else {
				return $author$project$HubTran$Effect$none;
			}
		}();
		return _Utils_Tuple2(
			$author$project$Forward$Component$Model(
				_Utils_update(
					model,
					{
						data: newData,
						mostRecentLookup: $author$project$Forward$Lookup$viewStructure(childLookup)
					})),
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						childEffects,
						$author$project$HubTran$Effect$internal_forwardRequestItems(lookupResult.missingData),
						dataEffects
					])));
	});
var $author$project$Forward$Component$init = F3(
	function (childLoadData, childDataEffects, childInit) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$author$project$HubTran$Effect$map($author$project$Forward$Component$ChildMsg),
			A3(
				$author$project$Forward$Component$refreshData,
				childLoadData,
				childDataEffects,
				A2($elm$core$Tuple$mapFirst, $author$project$Forward$Component$initModel, childInit)));
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$browser$Browser$element = _Browser_element;
var $author$project$HubTran$Navigation$onUrlChange = _Platform_incomingPort('onUrlChange', $elm$json$Json$Decode$string);
var $author$project$HubTran$Navigation$programWithFlags = F2(
	function (onUrlChangeMsg, config) {
		return $elm$browser$Browser$element(
			{
				init: function (flags) {
					return A2(
						config.init,
						flags,
						$elm$url$Url$fromString(flags.initialLocation));
				},
				subscriptions: function (model) {
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								config.subscriptions(model),
								$author$project$HubTran$Navigation$onUrlChange(
								A2($elm$core$Basics$composeR, $elm$url$Url$fromString, onUrlChangeMsg))
							]));
				},
				update: config.update,
				view: config.view
			});
	});
var $author$project$Forward$Component$EffectManagerEffects = function (a) {
	return {$: 'EffectManagerEffects', a: a};
};
var $author$project$HubTran$Effect$flatten = function (effect) {
	switch (effect.$) {
		case 'NoEffect':
			return {cmd: $elm$core$Platform$Cmd$none, effectManagerEffects: _List_Nil, inspectableEffects: _List_Nil};
		case 'ForwardEffect':
			var effectManagerEffect = effect.a;
			return {
				cmd: $elm$core$Platform$Cmd$none,
				effectManagerEffects: _List_fromArray(
					[effectManagerEffect]),
				inspectableEffects: _List_Nil
			};
		case 'InspectableEffect':
			var e = effect.a;
			return {
				cmd: $elm$core$Platform$Cmd$none,
				effectManagerEffects: _List_Nil,
				inspectableEffects: _List_fromArray(
					[e])
			};
		case 'AnyCmd':
			var c = effect.a;
			return {cmd: c, effectManagerEffects: _List_Nil, inspectableEffects: _List_Nil};
		default:
			var effects = effect.a;
			var all = A2($elm$core$List$map, $author$project$HubTran$Effect$flatten, effects);
			return {
				cmd: $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.cmd;
						},
						all)),
				effectManagerEffects: A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.effectManagerEffects;
					},
					all),
				inspectableEffects: A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.inspectableEffects;
					},
					all)
			};
	}
};
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (maybe.$ === 'Just') {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Forward$Component$flashToJavascript = _Platform_outgoingPort(
	'flashToJavascript',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'indefinite',
					$elm$json$Json$Encode$bool($.indefinite)),
					_Utils_Tuple2(
					'level',
					$elm$json$Json$Encode$string($.level)),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.message)),
					_Utils_Tuple2(
					'position',
					$elm$json$Json$Encode$string($.position)),
					_Utils_Tuple2(
					'time',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$float, $);
					}($.time)),
					_Utils_Tuple2(
					'title',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.title))
				]));
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$HubTran$Navigation$load = $elm$browser$Browser$Navigation$load;
var $author$project$HubTran$Navigation$pushUrl = _Platform_outgoingPort('pushUrl', $elm$json$Json$Encode$string);
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$HubTran$Navigation$reload = $elm$browser$Browser$Navigation$reload;
var $author$project$HubTran$Navigation$replaceUrl = _Platform_outgoingPort('replaceUrl', $elm$json$Json$Encode$string);
var $author$project$ErrorReporting$reportError = _Platform_outgoingPort(
	'reportError',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'fingerprint',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.fingerprint)),
					_Utils_Tuple2(
					'json',
					$elm$json$Json$Encode$string($.json)),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.message)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.name))
				]));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 'BadStatus_', a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 'BadUrl_', a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 'GoodStatus_', a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
var $elm$http$Http$Receiving = function (a) {
	return {$: 'Receiving', a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 'Sending', a: a};
};
var $elm$http$Http$Timeout_ = {$: 'Timeout_'};
var $elm$core$Maybe$isJust = function (maybe) {
	if (maybe.$ === 'Just') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 'Header', a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$http$Http$resultToTask = function (result) {
	if (result.$ === 'Ok') {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		_Utils_Tuple0,
		$elm$http$Http$resultToTask,
		{allowCookiesFromOtherDomains: false, body: r.body, expect: r.resolver, headers: r.headers, method: r.method, timeout: r.timeout, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $author$project$HubTran$HttpCmd$run = function (request) {
	return A2(
		$elm$core$Task$attempt,
		$elm_community$result_extra$Result$Extra$merge,
		$elm$http$Http$task(
			{
				body: function () {
					var _v0 = request.body;
					if (_v0.$ === 'Nothing') {
						return $elm$http$Http$emptyBody;
					} else {
						var json = _v0.a;
						return $elm$http$Http$jsonBody(json);
					}
				}(),
				headers: A2(
					$elm$core$List$map,
					function (_v1) {
						var name = _v1.a;
						var value = _v1.b;
						return A2($elm$http$Http$header, name, value);
					},
					request.headers),
				method: request.method,
				resolver: $elm$http$Http$stringResolver(
					function (response) {
						var _v2 = request.resolver(response);
						var innerResult = _v2.b;
						return innerResult;
					}),
				timeout: request.timeout,
				url: request.url
			}));
};
var $author$project$Forward$Component$runInspectableEffect = function (effect) {
	switch (effect.$) {
		case 'HttpEffect':
			var request = effect.a;
			return $author$project$HubTran$HttpCmd$run(request);
		case 'PushUrl':
			var url = effect.a;
			return $author$project$HubTran$Navigation$pushUrl(url);
		case 'ReplaceUrl':
			var url = effect.a;
			return $author$project$HubTran$Navigation$replaceUrl(url);
		case 'Load':
			var url = effect.a;
			return $author$project$HubTran$Navigation$load(url);
		case 'Reload':
			return $author$project$HubTran$Navigation$reload;
		case 'Flash':
			var message = effect.a;
			return $author$project$Forward$Component$flashToJavascript(message);
		case 'Now':
			var f = effect.a;
			return A2($elm$core$Task$perform, f, $elm$time$Time$now);
		case 'ReportError':
			var report = effect.a;
			return $author$project$ErrorReporting$reportError(report);
		default:
			return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Forward$Component$runEffect = function (effect) {
	var all = $author$project$HubTran$Effect$flatten(effect);
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				all.cmd,
				function () {
				var _v0 = all.effectManagerEffects;
				if (!_v0.b) {
					return $elm$core$Platform$Cmd$none;
				} else {
					return A2(
						$elm$core$Task$perform,
						$author$project$Forward$Component$EffectManagerEffects,
						$elm$core$Task$succeed(all.effectManagerEffects));
				}
			}(),
				$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$map, $author$project$Forward$Component$runInspectableEffect, all.inspectableEffects))
			]));
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Forward$Ports$onPusherDataUpdate = _Platform_incomingPort('onPusherDataUpdate', $elm$json$Json$Decode$value);
var $author$project$Forward$Component$subscriptions = F2(
	function (childSubscriptions, _v0) {
		var model = _v0.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Forward$Component$ChildMsg,
					A2(childSubscriptions, model.data, model.childModel)),
					$author$project$Forward$Ports$onPusherDataUpdate(
					function (value) {
						return $author$project$Forward$Component$EffectManagerEffects(
							_List_fromArray(
								[
									$author$project$Forward$Internal$PureEffectManagerCmd$PusherUpdate(value)
								]));
					})
				]));
	});
var $author$project$Forward$Component$CacheUpdate = {$: 'CacheUpdate'};
var $author$project$Forward$Component$EffectManagerMsg = function (a) {
	return {$: 'EffectManagerMsg', a: a};
};
var $turboMaCk$queue$Queue$Queue = F2(
	function (a, b) {
		return {$: 'Queue', a: a, b: b};
	});
var $turboMaCk$queue$Queue$empty = A2($turboMaCk$queue$Queue$Queue, _List_Nil, _List_Nil);
var $author$project$Forward$Internal$PureEffectManager$emptyCollectedEffects = {cacheableRequests: _List_Nil, invalidateAll: false, newInvalidations: _List_Nil, newRequests: _List_Nil, newSingleFetches: _List_Nil, pusherUpdates: _List_Nil};
var $turboMaCk$queue$Queue$queue = F2(
	function (fl, rl) {
		if (!fl.b) {
			return A2(
				$turboMaCk$queue$Queue$Queue,
				$elm$core$List$reverse(rl),
				_List_Nil);
		} else {
			return A2($turboMaCk$queue$Queue$Queue, fl, rl);
		}
	});
var $turboMaCk$queue$Queue$enqueue = F2(
	function (a, _v0) {
		var fl = _v0.a;
		var rl = _v0.b;
		return A2(
			$turboMaCk$queue$Queue$queue,
			fl,
			A2($elm$core$List$cons, a, rl));
	});
var $author$project$Forward$Internal$PureEffectManager$ReceivedCacheableResponse = F2(
	function (a, b) {
		return {$: 'ReceivedCacheableResponse', a: a, b: b};
	});
var $elm_community$result_extra$Result$Extra$error = function (result) {
	if (result.$ === 'Ok') {
		return $elm$core$Maybe$Nothing;
	} else {
		var err = result.a;
		return $elm$core$Maybe$Just(err);
	}
};
var $elm_community$result_extra$Result$Extra$extract = F2(
	function (f, x) {
		if (x.$ === 'Ok') {
			var a = x.a;
			return a;
		} else {
			var e = x.a;
			return f(e);
		}
	});
var $author$project$Forward$CacheableRequest$toEffect = function (_v0) {
	var request_ = _v0.a;
	return A2(
		$author$project$HubTran$InspectableEffect$map,
		$elm_community$result_extra$Result$Extra$extract($elm$core$Basics$never),
		$author$project$HubTran$InspectableEffect$HttpEffect(
			{
				body: request_.body,
				headers: request_.headers,
				method: request_.method,
				resolver: function (response) {
					return _Utils_Tuple2(
						$elm_community$result_extra$Result$Extra$error(
							$author$project$Forward$CacheableRequest$responseToBodyResult(response)),
						$elm$core$Result$Ok(
							$elm$core$Result$Ok(response)));
				},
				timeout: request_.timeout,
				url: request_.url
			}));
};
var $author$project$Forward$CacheableRequest$toMessage = F2(
	function (_v0, response) {
		var request_ = _v0.a;
		return request_.onResult(response);
	});
var $author$project$Forward$Internal$PureEffectManager$sendCacheableRequest = function (cacheableRequest) {
	var toMessage = $author$project$Forward$CacheableRequest$toMessage(cacheableRequest);
	return A2(
		$author$project$HubTran$InspectableEffect$map,
		$author$project$Forward$Internal$PureEffectManager$ReceivedCacheableResponse(toMessage),
		$author$project$Forward$CacheableRequest$toEffect(cacheableRequest));
};
var $author$project$Forward$Internal$PureEffectManager$processCacheableRequests = F2(
	function (cacheableRequests, previousResult) {
		var newTasks = A2($elm$core$List$map, $author$project$Forward$Internal$PureEffectManager$sendCacheableRequest, cacheableRequests);
		return _Utils_update(
			previousResult,
			{
				tasksToSpawn: A3($elm$core$List$foldl, $turboMaCk$queue$Queue$enqueue, previousResult.tasksToSpawn, newTasks)
			});
	});
var $author$project$Forward$Internal$PureEffectManager$processInvalidations = F2(
	function (invalidations, cache) {
		return _Utils_Tuple2(
			A3(
				$elm$core$List$foldl,
				F2(
					function (inv, c) {
						return inv(c);
					}),
				cache,
				invalidations),
			$elm$core$List$length(invalidations) > 0);
	});
var $author$project$Forward$Internal$PureEffectManager$processPendingSingleFetches = F2(
	function (cache, pendingFetches) {
		var step = F2(
			function (fetch, _v3) {
				var stillPending_ = _v3.a;
				var requests_ = _v3.b;
				var appMsgs_ = _v3.c;
				var _v1 = fetch(cache);
				if (_v1.$ === 'Err') {
					var _v2 = _v1.a;
					var priority = _v2.a;
					var graphPaths = _v2.b;
					return _Utils_Tuple3(
						A2($elm$core$List$cons, fetch, stillPending_),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$core$List$map,
								function (graphPath) {
									return _Utils_Tuple2(graphPath, priority);
								},
								graphPaths),
							requests_),
						appMsgs_);
				} else {
					var appMsg = _v1.a;
					return _Utils_Tuple3(
						stillPending_,
						requests_,
						A2($elm$core$List$cons, appMsg, appMsgs_));
				}
			});
		var done = function (_v0) {
			var pending = _v0.a;
			var reqs = _v0.b;
			var appMsgs = _v0.c;
			return {
				appMsgs: A2($elm$core$List$filterMap, $elm$core$Basics$identity, appMsgs),
				requestsToMake: $elm$core$List$concat(reqs),
				stillPending: pending
			};
		};
		return done(
			A3(
				$elm$core$List$foldl,
				step,
				_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
				pendingFetches));
	});
var $author$project$AuditPb$DocumentPODDefinitionOverrideInteraction = F6(
	function (podDisposition, overrides, documentId, userId, otherReason, referenceOverrides) {
		return {documentId: documentId, otherReason: otherReason, overrides: overrides, podDisposition: podDisposition, referenceOverrides: referenceOverrides, userId: userId};
	});
var $author$project$AuditPb$documentPODDefinitionOverrideInteractionDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'reference_overrides',
			$author$project$AuditPb$documentPODAttemptedReferenceDecoder,
			A3(
				$author$project$AuditPb$optional,
				'other_reason',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'user_id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$UserId$fromInt, $author$project$AuditPb$intDecoder),
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'document_id',
						A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentId$fromInt, $author$project$AuditPb$intDecoder),
						A3(
							$author$project$AuditPb$repeated,
							'overrides',
							$author$project$AuditPb$documentPODDefinitionInferenceCheckDecoder,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'pod_disposition',
								$author$project$AuditPb$documentPODDispositionDecoder,
								$author$project$AuditPb$decode($author$project$AuditPb$DocumentPODDefinitionOverrideInteraction)))))));
	});
var $author$project$Forward$AppSpecific$Cache$maybe_documentPODDefinitionOverrideInteraction = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.maybe_documentPODDefinitionOverrideInteraction;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{maybe_documentPODDefinitionOverrideInteraction: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$latestPODDefinitionOverrideByDocumentId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$maybe_documentPODDefinitionOverrideInteraction,
		decoder: $elm$json$Json$Decode$maybe($author$project$AuditPb$documentPODDefinitionOverrideInteractionDecoder),
		entrypoint: 'latestPODDefinitionOverrideByDocumentId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$DocumentId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionToMaybeOverride = $author$project$Forward$Lookup$defineEdge(
	{
		entrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$latestPODDefinitionOverrideByDocumentId,
		fieldName: 'latestPODDefinitionOverride',
		getId: function ($) {
			return $.documentId;
		}
	});
var $author$project$Forward$AppSpecific$Cache$list_documentPODDefinition = A2(
	$author$project$Forward$Internal$CacheKey$cacheKey,
	function ($) {
		return $.list_documentPODDefinition;
	},
	F2(
		function (e, c) {
			return _Utils_update(
				c,
				{list_documentPODDefinition: e});
		}));
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionsByCarrierInvoiceId = $author$project$Forward$Lookup$defineNode(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentPODDefinition,
		decoder: $elm$json$Json$Decode$list($author$project$AuditPb$documentPODDefinitionDecoder),
		entrypoint: 'documentPODDefinitionsByCarrierInvoiceId',
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByCarrierInvoiceId = $author$project$Forward$Lookup$defineReferenceList(
	{
		cacheKey: $author$project$Forward$AppSpecific$Cache$list_documentId,
		decoder: $author$project$Domain$DocumentId$decode,
		entrypoint: 'documentIdsByCarrierInvoiceId',
		objectEntrypoint: $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2,
		parameters: $author$project$Forward$Lookup$primaryKeyParameter($author$project$Domain$CarrierInvoiceId$toInt)
	});
var $author$project$Forward$Lookup$toDecoderConfig = function (_v0) {
	var lookup = _v0.a;
	return lookup.decoderConfig;
};
var $author$project$Forward$AppSpecific$NeedsControllerEndpoints$allDecoders = _List_fromArray(
	[
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettings),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$accountSettingsToLoadCustomerLabels),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activeVerificationsDebtorBatchIdByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItem),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemCarrierInvoiceProcessedDetailsToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemCarrierPayableApprovedDetailsToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemFactorInvoiceProcessedDetailsToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemIdsByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemInvoiceCreatedByExternalDetailsToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemsByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$allReferenceFieldLabels),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$autoReplyFilters),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$autoVerificationByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$availableClientSubmissionDropdownDataByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$badQualityPagesByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceDebtorContact),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceDebtorContactIdsByFactorBrokerId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceVerificationMethod),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$cadenceVerificationMethodIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$canonicalVerificationIdByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierDocumentTypes),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceAuditChecks),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceDashboardRow),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByCarrierInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByDocumentBatchId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$activityItemContextDataByLoadStateId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToLoadState),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadDetails),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceToTmsLoadInformation),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$clientSubmissionReviewDataByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$contact),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$contactToMaybeTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$contactsByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$correspondentsByTmsCarrierId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentAccount),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentImportStatusByEmailMessageId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$currentUser),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$customExceptionEmailTemplate),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$customExceptionEmailTemplates),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerInvoiceTemplates),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerPODDefinitions),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilters),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilter),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilterToFactorBrokers),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$dashboardSavedFilterToTmsCarriers),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorChangeReport),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorChangeTemplate),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$debtorVisibleFactorInvoiceDocumentURLByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentAddressAnswersByDocumentId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchV2),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchGroupingReview),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReview),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupLoadReviewToDocumentGroup),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentBatchToEmailMessage),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToDocumentBatch),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToDocuments),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupToExceptionSummary),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentIdsByEmailMessageId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPage),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageIdsByDocumentId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPageLinesByDocumentPageId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPagesByDocumentId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionsByCarrierInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionsByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionToDocument),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionToMaybeOverride),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPacketComparisonRowToMaybeDocument),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPacketComparisonRowToMaybeOtherDocument),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPageIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentToPages),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReview),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeReviewToDocument),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentTypeSettings),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentV2),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$duplicateFactorInvoicesByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceNumberReview),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceNumberReviewToDocument),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceAmountReview),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$invoiceAmountReviewToDocument),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByCarrierId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByCarrierInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentBatchId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentsByDocumentGroupId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByCarrierInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByDocumentGroupId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageIdsStreamByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToCurrentImportStatus),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToDocumentBatch),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToExceptionSummary),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToInReplyToExceptionedItems),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToRejectMessage),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionEvent),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByCarrierInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByDocumentGroupId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByEmailMessageId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionSummaryByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionsByHighestCount),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItem),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$exceptionedItemsByEmailMessageId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarriersBySettingsQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrierTerm),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$brokeredCarrierTermsBySettingsQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$externalLogins),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorAgingByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerPaymentAddress),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerSettings),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokerToPaymentAddress),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokersByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBrokersBySettingsQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceAuditChecks),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceDocumentPacketComparison),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmission),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmissionToFactorBroker),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceSubmissionToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToBadQualityPages),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceExceptionEvents),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToExceptionEvents),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToExceptionSummary),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToFactorBroker),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToMissingPages),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToSubmission),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToSubmissionDropdownData),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToVerification),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoicesByEmailMessageId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceIdsByEmailMessageId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$firstUnreviewedSubmissionWorkflowFactorInvoice),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessageToSubmissionBatch),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$integration),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$integrations),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$latestPODDefinitionOverrideByDocumentId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadCustomerLabelToCustomers),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadState),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadStateByTmsLoadId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$loadStateToTmsLoad),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierAndLoadItemEqualityData),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissions),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmission),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissionToMaybeLoadState),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$ltlPayablesCarrierInvoiceSubmissionToMaybeTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$missingPagesByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReview),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$multiPageBolReviewToDocument),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReview),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReviewToDocument),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentLoadReferenceMatchReviewToTmsLoad),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$myClientsAccountExecutives),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$myClientsOverviewRows),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$newEmailIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSandboxRecipients),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSendQueueItem),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$noaSendQueueItemsToSend),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$officePeopleMappings),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$paymentCountByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$portalDisplaySettings),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedCarrierInvoiceRowData),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$possibleMatchesByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroupToFactorInvoices),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroupToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedFactorInvoiceIdGroups),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$processedInvoiceIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$readyToAuditCarrierInvoiceIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$rejectMessage),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$remitToAddresses),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$replyEmailIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToNewEmailMessages),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToReplyEmailMessages),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroupToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$reviewIdGroups),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$sentNoa),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$sentNoas),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$skippedNoa),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$skippedNoas),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionBatchByEmailMessageId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionEmailMessageIdByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$submissionDropdownDataByFactorInvoiceSubmissionId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierNode),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToCorrespondents),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToExternalLoginCustomers),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarrierToExternalLogins),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarriersByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCarriersBySettingsQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomer),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerSettings),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomersByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerNamesByQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomersBySettingsQuery),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoad),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetails),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToDocuments),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCarrier),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCustomer),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsCustomerSettings),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadDetailsToTmsShipments),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadInformation),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsLoadShipment),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsShipment),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsShipmentToTmsCustomerSettings),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$unsentExceptionIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$user),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$users),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationPercentageByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItem),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemByFactorInvoiceId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemIdsByDebtorBatchId),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToAutoVerification),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToCadenceDebtorContact),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToCadenceVerificationMethod),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToDebtorVisibleFactorInvoiceDocumentURL),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorAging),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToFactorInvoice),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemToPaymentCount),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToCadenceDebtorContactIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToConfirmationEmailMessages),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchToFactorBroker),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsLogins),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsMatchedDebtors),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsUnmatchedDebtors),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroupToVerificationsDebtorBatch),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroupToVerificationsDebtorBatchItems),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$verifyDebtorBatchIdGroups),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$waitingExceptionIds),
		$author$project$Forward$Lookup$toDecoderConfig($author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroupIdsByDocumentBatchId)
	]);
var $author$project$Forward$RailsBackend$NeedsController$allDecodersConfig = A3(
	$elm$core$List$foldl,
	function (d) {
		return $elm$core$Dict$union(d);
	},
	$elm$core$Dict$empty,
	$author$project$Forward$AppSpecific$NeedsControllerEndpoints$allDecoders);
var $elm_community$json_extra$Json$Decode$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$json$Json$Decode$map2($elm$core$List$cons),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $author$project$Forward$RailsBackend$NeedsController$decoderFold = function () {
	var composeCacheUpdates = F2(
		function (f, g) {
			return function (cache) {
				var _v0 = f(cache);
				var firstUpdatedCache = _v0.a;
				var firstErrors = _v0.b;
				var _v1 = g(firstUpdatedCache);
				var secondUpdatedCache = _v1.a;
				var secondErrors = _v1.b;
				return _Utils_Tuple2(
					secondUpdatedCache,
					_Utils_ap(firstErrors, secondErrors));
			};
		});
	return $elm$json$Json$Decode$map(
		A2($elm$core$List$foldl, composeCacheUpdates, $author$project$Forward$RailsBackend$EntrypointDecoderConfig$noCacheUpdate));
}();
var $author$project$Forward$Internal$GraphEntrypoint$dictGet = $timo_weike$generic_collections$ManualDict$get($author$project$Forward$Internal$GraphEntrypoint$toComparable);
var $elm$core$Debug$log = _Debug_log;
var $author$project$Forward$RailsBackend$NeedsController$decodeNeedValue = F2(
	function (warnOnMissingFields, requestedTimestamps) {
		var makeEntrypointDecoder = function (entrypointName) {
			var _v0 = A2($elm$core$Dict$get, entrypointName, $author$project$Forward$RailsBackend$NeedsController$allDecodersConfig);
			if (_v0.$ === 'Just') {
				if (_v0.a.$ === 'SingletonDecoder') {
					var decoderConfig = _v0.a.a;
					var entrypoint = $author$project$Forward$Internal$GraphEntrypoint$BySingleton(entrypointName);
					var requestedTimestamp = A2($author$project$Forward$Internal$GraphEntrypoint$dictGet, entrypoint, requestedTimestamps);
					return A2(
						$elm$json$Json$Decode$map,
						A2(decoderConfig, entrypoint, requestedTimestamp),
						A2($elm$json$Json$Decode$field, entrypointName, $elm$json$Json$Decode$value));
				} else {
					var decoderConfig = _v0.a.a;
					return $author$project$Forward$RailsBackend$NeedsController$decoderFold(
						A2(
							$elm$json$Json$Decode$field,
							entrypointName,
							$elm$json$Json$Decode$list(
								A2(
									$elm$json$Json$Decode$andThen,
									function (param) {
										var entrypoint = A2($author$project$Forward$Internal$GraphEntrypoint$ByQuery, entrypointName, param);
										var requestedTimestamp = A2($author$project$Forward$Internal$GraphEntrypoint$dictGet, entrypoint, requestedTimestamps);
										return A2(
											$elm$json$Json$Decode$map,
											A2(decoderConfig, entrypoint, requestedTimestamp),
											A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$value));
									},
									A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$value)))));
				}
			} else {
				if (warnOnMissingFields) {
					var message = 'INTERNAL ERROR: Forward.AppSpecific.Cache.decoderConfig does not define a decoder for: ' + entrypointName;
					var _v1 = A2($elm$core$Debug$log, 'INTERNAL ERROR: Forward.AppSpecific.Cache.decoderConfig does not define a decoder for', entrypointName);
					return $elm$json$Json$Decode$succeed(
						A2(
							$author$project$Forward$RailsBackend$EntrypointDecoderConfig$withError,
							$author$project$Forward$Remote$Unloadable(message),
							$elm$core$Basics$identity));
				} else {
					return $elm$json$Json$Decode$succeed($author$project$Forward$RailsBackend$EntrypointDecoderConfig$noCacheUpdate);
				}
			}
		};
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm_community$json_extra$Json$Decode$Extra$combine,
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$map(
					A2($elm$core$Basics$composeR, $elm$core$Tuple$first, makeEntrypointDecoder)),
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value)));
	});
var $author$project$Forward$RailsBackend$NeedsController$decodeResponseAsUpdateFunction = F2(
	function (warnOnMissingFields, requestedTimestamps) {
		return $author$project$Forward$RailsBackend$NeedsController$decoderFold(
			A2($author$project$Forward$RailsBackend$NeedsController$decodeNeedValue, warnOnMissingFields, requestedTimestamps));
	});
var $timo_weike$generic_collections$ManualDict$empty = $timo_weike$generic_collections$ManualDict$Dict($elm$core$Dict$empty);
var $turboMaCk$queue$Queue$fromList = function (list) {
	return A2($turboMaCk$queue$Queue$Queue, list, _List_Nil);
};
var $author$project$Forward$Internal$PureEffectManager$modifyCache = F2(
	function (state, updateFunction) {
		var _v0 = updateFunction(state.z__internal__typedCache);
		var newCache = _v0.a;
		var errors = _v0.b;
		var newState = _Utils_update(
			state,
			{z__internal__typedCache: newCache});
		return _Utils_Tuple2(newState, errors);
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $elm$core$String$lines = _String_lines;
var $author$project$Errors$HoneybadgerReport$ranIntoProblemsError = 'I ran into the following problems:';
var $author$project$Errors$HoneybadgerReport$toFingerprint = function (string) {
	if (A2($elm$core$String$startsWith, 'Problem with the given value:', string)) {
		return $elm$core$String$trim(
			A2(
				$elm$core$Maybe$withDefault,
				'Problem with the given value:',
				$elm_community$list_extra$List$Extra$last(
					A2($elm$core$String$split, '\u000A\u000A', string))));
	} else {
		if (A2($elm$core$String$startsWith, 'Problem with the value at', string)) {
			var parts = A2($elm$core$String$split, '\u000A\u000A', string);
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$List$head(parts),
							$elm_community$list_extra$List$Extra$last(parts)
						])));
		} else {
			if (A2($elm$core$String$startsWith, 'Given an invalid JSON', string)) {
				return 'Given an invalid JSON';
			} else {
				if (A2($elm$core$String$startsWith, $author$project$Errors$HoneybadgerReport$ranIntoProblemsError, string)) {
					return A2(
						$elm$core$String$join,
						'\u000A',
						A2(
							$elm$core$List$map,
							$author$project$Errors$HoneybadgerReport$toFingerprint,
							$elm$core$String$lines(
								A2(
									$elm$core$String$dropLeft,
									$elm$core$String$length($author$project$Errors$HoneybadgerReport$ranIntoProblemsError),
									string))));
				} else {
					var _v0 = A2($elm$core$String$split, ' but instead got:', string);
					if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
						var fingerprint = _v0.a;
						var _v1 = _v0.b;
						return fingerprint;
					} else {
						return string;
					}
				}
			}
		}
	}
};
var $author$project$Errors$HoneybadgerReport$fromUnparseable = function (_v0) {
	var decoderMessage = _v0.decoderMessage;
	var json = _v0.json;
	var fingerprint = $author$project$Errors$HoneybadgerReport$toFingerprint(decoderMessage);
	return {
		fingerprint: $elm$core$Maybe$Just(fingerprint),
		json: json,
		message: decoderMessage,
		name: fingerprint
	};
};
var $author$project$Errors$HoneybadgerReport$fromRemoteError = function (remoteError) {
	if (remoteError.$ === 'Unloadable') {
		return $elm$core$Maybe$Nothing;
	} else {
		var unparseable = remoteError.a;
		return $elm$core$Maybe$Just(
			$author$project$Errors$HoneybadgerReport$fromUnparseable(unparseable));
	}
};
var $author$project$HubTran$InspectableEffect$reportError = function (report) {
	return $author$project$HubTran$InspectableEffect$ReportError(report);
};
var $author$project$Forward$Internal$PureEffectManager$reportErrors = function (errors) {
	var reportRemoteError = function (remoteError) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$HubTran$InspectableEffect$reportError,
			$author$project$Errors$HoneybadgerReport$fromRemoteError(remoteError));
	};
	return A2($elm$core$List$filterMap, reportRemoteError, errors);
};
var $turboMaCk$queue$Queue$toList = function (_v0) {
	var fl = _v0.a;
	var rl = _v0.b;
	return _Utils_ap(
		fl,
		$elm$core$List$reverse(rl));
};
var $author$project$Forward$Internal$PureEffectManager$processPusherUpdates = F2(
	function (pusherUpdates, previousResult) {
		var sendCacheUpdate = ($elm$core$List$length(pusherUpdates) > 0) || previousResult.sendCacheUpdate;
		var decodeAndUpdateState = F2(
			function (value, _v1) {
				var state = _v1.a;
				var existingErrors = _v1.b;
				return A2(
					$elm_community$result_extra$Result$Extra$extract,
					function (err) {
						return _Utils_Tuple2(
							state,
							A2($elm$core$List$cons, err, existingErrors));
					},
					A2(
						$elm$core$Result$map,
						function (update) {
							return A2($author$project$Forward$Internal$PureEffectManager$modifyCache, state, update);
						},
						A2(
							$elm$core$Result$mapError,
							$author$project$Forward$Remote$errorFromJsonError,
							A2(
								$elm$json$Json$Decode$decodeValue,
								A2(
									$elm$json$Json$Decode$field,
									'graph',
									A2($author$project$Forward$RailsBackend$NeedsController$decodeResponseAsUpdateFunction, false, $timo_weike$generic_collections$ManualDict$empty)),
								value))));
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			decodeAndUpdateState,
			_Utils_Tuple2(previousResult.newState, _List_Nil),
			pusherUpdates);
		var newState = _v0.a;
		var errors = _v0.b;
		var tasksToSpawn = $turboMaCk$queue$Queue$fromList(
			A2(
				$elm$core$List$append,
				$author$project$Forward$Internal$PureEffectManager$reportErrors(errors),
				$turboMaCk$queue$Queue$toList(previousResult.tasksToSpawn)));
		return _Utils_update(
			previousResult,
			{newState: newState, sendCacheUpdate: sendCacheUpdate, tasksToSpawn: tasksToSpawn});
	});
var $timo_weike$generic_collections$ManualDict$insert = F4(
	function (f, key, value, _v0) {
		var dict = _v0.a;
		return $timo_weike$generic_collections$ManualDict$Dict(
			A3(
				$elm$core$Dict$insert,
				f(key),
				_Utils_Tuple2(key, value),
				dict));
	});
var $author$project$Forward$Internal$GraphEntrypoint$dictInsert = $timo_weike$generic_collections$ManualDict$insert($author$project$Forward$Internal$GraphEntrypoint$toComparable);
var $timo_weike$generic_collections$ManualDict$update = F4(
	function (f, key, updateFunc, _v0) {
		var dict = _v0.a;
		var updater = function (tuple) {
			return A2(
				$elm$core$Maybe$map,
				function (value) {
					return _Utils_Tuple2(key, value);
				},
				updateFunc(
					A2($elm$core$Maybe$map, $elm$core$Tuple$second, tuple)));
		};
		return $timo_weike$generic_collections$ManualDict$Dict(
			A3(
				$elm$core$Dict$update,
				f(key),
				updater,
				dict));
	});
var $author$project$Forward$Internal$GraphEntrypoint$dictUpdate = $timo_weike$generic_collections$ManualDict$update($author$project$Forward$Internal$GraphEntrypoint$toComparable);
var $author$project$Forward$Internal$Priority$toComparable = function (priority) {
	if (priority.$ === 'RequiredASAP') {
		return 1;
	} else {
		return 2;
	}
};
var $author$project$Forward$Internal$Priority$dictUpdate = $timo_weike$generic_collections$ManualDict$update($author$project$Forward$Internal$Priority$toComparable);
var $timo_weike$generic_collections$ManualDict$foldl = F3(
	function (f, start, _v0) {
		var dict = _v0.a;
		var combine = F3(
			function (_v1, _v2, prev) {
				var key = _v2.a;
				var value = _v2.b;
				return A3(f, key, value, prev);
			});
		return A3($elm$core$Dict$foldl, combine, start, dict);
	});
var $author$project$Forward$Internal$Priority$max2 = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		if (_v0.a.$ === 'RequiredASAP') {
			var _v1 = _v0.a;
			return $author$project$Forward$Internal$Priority$RequiredASAP;
		} else {
			if (_v0.b.$ === 'RequiredASAP') {
				var _v2 = _v0.b;
				return $author$project$Forward$Internal$Priority$RequiredASAP;
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return $author$project$Forward$Internal$Priority$BehindLoadingSpinner;
			}
		}
	});
var $author$project$Forward$Internal$GraphTree$maxRequiredTimestamp = F2(
	function (maybeA, maybeB) {
		var _v0 = _Utils_Tuple2(maybeA, maybeB);
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$core$Maybe$Nothing;
			} else {
				var _v4 = _v0.a;
				var b = _v0.b.a;
				return $elm$core$Maybe$Just(b);
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var a = _v0.a.a;
				var _v3 = _v0.b;
				return $elm$core$Maybe$Just(a);
			} else {
				var a = _v0.a.a;
				var b = _v0.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Helpers$Date$max, a, b));
			}
		}
	});
var $author$project$Forward$Internal$PureEffectManager$ReceivedNeedsResponse = F2(
	function (a, b) {
		return {$: 'ReceivedNeedsResponse', a: a, b: b};
	});
var $author$project$Forward$Internal$GraphEntrypoint$destructure__INTERNAL_ONLY = function (entrypoint) {
	if (entrypoint.$ === 'BySingleton') {
		var path = entrypoint.a;
		return _Utils_Tuple2(path, $elm$core$Maybe$Nothing);
	} else {
		var path = entrypoint.a;
		var params = entrypoint.b;
		return _Utils_Tuple2(
			path,
			$elm$core$Maybe$Just(params));
	}
};
var $author$project$LocalExtra$Dict$groupByMap3 = F3(
	function (fa, fb, fc) {
		return A2(
			$elm$core$List$foldl,
			function (x) {
				return A2(
					$elm$core$Dict$update,
					fa(x),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault($elm$core$Dict$empty),
						A2(
							$elm$core$Basics$composeR,
							A2(
								$elm$core$Dict$update,
								fb(x),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault($elm$core$Set$empty),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Set$insert(
											fc(x)),
										$elm$core$Maybe$Just))),
							$elm$core$Maybe$Just)));
			},
			$elm$core$Dict$empty);
	});
var $author$project$Forward$Internal$GraphEntrypoint$paramToString = function (param) {
	return A2(
		$elm$core$Maybe$withDefault,
		'[singleton entrypoint]',
		A2(
			$elm$core$Maybe$map,
			$elm$json$Json$Encode$encode(0),
			param));
};
var $author$project$Forward$Internal$OutstandingRequests$debugView = function (_v0) {
	var byRequestId = _v0.a.byRequestId;
	var flat = A3(
		$elm$core$Dict$foldr,
		F3(
			function (requestId, d, acc) {
				return A3(
					$elm$core$List$foldl,
					F2(
						function (entrypoint, acc1) {
							var _v4 = $author$project$Forward$Internal$GraphEntrypoint$destructure__INTERNAL_ONLY(entrypoint);
							var entrypointName = _v4.a;
							var param = _v4.b;
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple3(
									entrypointName,
									$author$project$Forward$Internal$GraphEntrypoint$paramToString(param),
									requestId),
								acc1);
						}),
					acc,
					$elm$core$Dict$values(d));
			}),
		_List_Nil,
		byRequestId);
	return A4(
		$author$project$LocalExtra$Dict$groupByMap3,
		function (_v1) {
			var e = _v1.a;
			return e;
		},
		function (_v2) {
			var e = _v2.c;
			return 'requestId: ' + $elm$core$String$fromInt(e);
		},
		function (_v3) {
			var e = _v3.b;
			return e;
		},
		flat);
};
var $author$project$Forward$RailsBackend$NeedsController$encodeEntrypoint = function (entrypoint) {
	if (entrypoint.$ === 'BySingleton') {
		var path = entrypoint.a;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(path)
				]));
	} else {
		var path = entrypoint.a;
		var params = entrypoint.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(path),
					params
				]));
	}
};
var $author$project$Forward$RailsBackend$NeedsController$encode = F2(
	function (requestId, needs) {
		var uniqueNeeds = $elm$core$Dict$values(
			A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$Forward$Internal$GraphEntrypoint$toComparable, needs));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requestId',
					$elm$json$Json$Encode$int(requestId)),
					_Utils_Tuple2(
					'needs',
					A2($elm$json$Json$Encode$list, $author$project$Forward$RailsBackend$NeedsController$encodeEntrypoint, uniqueNeeds))
				]));
	});
var $author$project$LocalExtra$ManualDict$filterMap = F3(
	function (compareFunc, updateFunc, dict) {
		var foldHelp = F3(
			function (k, a, acc) {
				var _v0 = A2(updateFunc, k, a);
				if (_v0.$ === 'Nothing') {
					return acc;
				} else {
					var b = _v0.a;
					return A4($timo_weike$generic_collections$ManualDict$insert, compareFunc, k, b, acc);
				}
			});
		return A3($timo_weike$generic_collections$ManualDict$foldl, foldHelp, $timo_weike$generic_collections$ManualDict$empty, dict);
	});
var $author$project$LocalExtra$Dict$groupByMap2 = F2(
	function (fa, fb) {
		return A2(
			$elm$core$List$foldl,
			function (x) {
				return A2(
					$elm$core$Dict$update,
					fa(x),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault($elm$core$Set$empty),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Set$insert(
								fb(x)),
							$elm$core$Maybe$Just)));
			},
			$elm$core$Dict$empty);
	});
var $author$project$Forward$Internal$OutstandingRequests$insert = F3(
	function (requestId, items, _v0) {
		var old = _v0.a;
		var indexedItems = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (e) {
					return _Utils_Tuple2(
						$author$project$Forward$Internal$GraphEntrypoint$toComparable(e),
						e);
				},
				items));
		return $author$project$Forward$Internal$OutstandingRequests$build(
			A3($elm$core$Dict$insert, requestId, indexedItems, old.byRequestId));
	});
var $author$project$Forward$Internal$OutstandingRequests$member = F2(
	function (_v0, item) {
		var old = _v0.a;
		return A2(
			$elm$core$Set$member,
			$author$project$Forward$Internal$GraphEntrypoint$toComparable(item),
			old.precomputedUnion);
	});
var $author$project$Forward$Internal$OutstandingRequests$isNew = F2(
	function (outstandingRequests, graphEntrypoint) {
		return !A2($author$project$Forward$Internal$OutstandingRequests$member, outstandingRequests, graphEntrypoint);
	});
var $timo_weike$generic_collections$ManualDict$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$values(dict);
};
var $timo_weike$generic_collections$ManualDict$keys = function (dict) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		$timo_weike$generic_collections$ManualDict$toList(dict));
};
var $author$project$Forward$Internal$Requests$prepareRequest = F4(
	function (needsUrl, requestId, oldOutstanding, requested) {
		var requestedTimestamps = A3(
			$author$project$LocalExtra$ManualDict$filterMap,
			$author$project$Forward$Internal$GraphEntrypoint$toComparable,
			F2(
				function (_v3, mt) {
					return mt;
				}),
			requested);
		var entrypoints = $timo_weike$generic_collections$ManualDict$keys(requested);
		var _v0 = A2(
			$elm$core$List$filter,
			$author$project$Forward$Internal$OutstandingRequests$isNew(oldOutstanding),
			entrypoints);
		if (!_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var newEntrypoints = _v0;
			return $elm$core$Maybe$Just(
				{
					debugView: A3(
						$author$project$LocalExtra$Dict$groupByMap2,
						function (_v1) {
							var name = _v1.a;
							return name;
						},
						function (_v2) {
							var param = _v2.b;
							return $author$project$Forward$Internal$GraphEntrypoint$paramToString(param);
						},
						A2($elm$core$List$map, $author$project$Forward$Internal$GraphEntrypoint$destructure__INTERNAL_ONLY, newEntrypoints)),
					httpRequest: $author$project$HubTran$InspectableEffect$http(
						{
							body: $elm$core$Maybe$Just(
								A2($author$project$Forward$RailsBackend$NeedsController$encode, requestId, newEntrypoints)),
							headers: _List_fromArray(
								[
									_Utils_Tuple2('Accept', 'application/json')
								]),
							method: 'POST',
							resolver: $author$project$Helpers$Http$jsonResolver(
								A2($author$project$Forward$RailsBackend$NeedsController$decodeResponseAsUpdateFunction, true, requestedTimestamps)),
							timeout: $elm$core$Maybe$Nothing,
							url: needsUrl
						}),
					newState: A3($author$project$Forward$Internal$OutstandingRequests$insert, requestId, newEntrypoints, oldOutstanding)
				});
		}
	});
var $author$project$Forward$Internal$PureEffectManager$processRequestsBatch = F3(
	function (needsUrl, graphPaths, previousResult) {
		var requestId = previousResult.newState.nextRequestId;
		var _v0 = A4($author$project$Forward$Internal$Requests$prepareRequest, needsUrl, requestId, previousResult.newState.z__internal__outstandingRequests, graphPaths);
		if (_v0.$ === 'Just') {
			var preparedBatch = _v0.a;
			var requestDetails = {
				requestId: requestId,
				requested: A2(
					$elm$core$List$map,
					A2(
						$elm$core$Tuple$mapBoth,
						$elm$core$Debug$toString,
						function (t) {
							return 'requiredTimestamp: ' + $elm$core$Debug$toString(t);
						}),
					$timo_weike$generic_collections$ManualDict$toList(graphPaths))
			};
			var previousState = previousResult.newState;
			var newTask = A2(
				$author$project$HubTran$InspectableEffect$map,
				$author$project$Forward$Internal$PureEffectManager$ReceivedNeedsResponse(requestDetails),
				preparedBatch.httpRequest);
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					_Utils_update(
						previousResult,
						{
							newState: _Utils_update(
								previousState,
								{
									nextRequestId: requestId + 1,
									outstandingRequestsByEntrypoint: $author$project$Forward$Internal$OutstandingRequests$debugView(preparedBatch.newState),
									z__internal__outstandingRequests: preparedBatch.newState
								}),
							tasksToSpawn: A2($turboMaCk$queue$Queue$enqueue, newTask, previousResult.tasksToSpawn)
						}),
					preparedBatch.debugView));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Forward$Internal$PureEffectManager$processRequests = F3(
	function (needsUrl, graphPaths, previousResult) {
		var storeDebugInfo = function (_v9) {
			var finalResult = _v9.a;
			var debugInfo = _v9.b;
			var oldState = finalResult.newState;
			return _Utils_update(
				finalResult,
				{
					newState: _Utils_update(
						oldState,
						{requestsOnLastEffectManagerTick: debugInfo})
				});
		};
		var processBatch = F2(
			function (_v7, _v8) {
				var priority = _v7.a;
				var graphTrees = _v7.b;
				var prevResult = _v8.a;
				var debugInfo = _v8.b;
				var _v5 = A3($author$project$Forward$Internal$PureEffectManager$processRequestsBatch, needsUrl, graphTrees, prevResult);
				if (_v5.$ === 'Nothing') {
					return _Utils_Tuple2(previousResult, debugInfo);
				} else {
					var _v6 = _v5.a;
					var nextResult = _v6.a;
					var nextDebugView = _v6.b;
					return _Utils_Tuple2(
						nextResult,
						A3(
							$elm$core$Dict$insert,
							$elm$core$Debug$toString(priority),
							nextDebugView,
							debugInfo));
				}
			});
		var groupStep = F2(
			function (_v3, acc) {
				var _v4 = _v3.a;
				var entrypoint = _v4.a;
				var requiredTimestamp = _v4.b;
				var priority = _v3.b;
				return A3(
					$author$project$Forward$Internal$GraphEntrypoint$dictUpdate,
					entrypoint,
					function (prev) {
						if (prev.$ === 'Nothing') {
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(priority, requiredTimestamp));
						} else {
							var _v2 = prev.a;
							var prevPriority = _v2.a;
							var prevTimestamp = _v2.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									A2($author$project$Forward$Internal$Priority$max2, prevPriority, priority),
									A2($author$project$Forward$Internal$GraphTree$maxRequiredTimestamp, prevTimestamp, requiredTimestamp)));
						}
					},
					acc);
			});
		var byEntrypoint = A3($elm$core$List$foldl, groupStep, $timo_weike$generic_collections$ManualDict$empty, graphPaths);
		var batchedByPriority = function () {
			var regroupStep = F3(
				function (entrypoint, _v0, acc) {
					var priority = _v0.a;
					var requiredTimestamp = _v0.b;
					return A3(
						$author$project$Forward$Internal$Priority$dictUpdate,
						priority,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault($timo_weike$generic_collections$ManualDict$empty),
							A2(
								$elm$core$Basics$composeR,
								A2($author$project$Forward$Internal$GraphEntrypoint$dictInsert, entrypoint, requiredTimestamp),
								$elm$core$Maybe$Just)),
						acc);
				});
			return A3($timo_weike$generic_collections$ManualDict$foldl, regroupStep, $timo_weike$generic_collections$ManualDict$empty, byEntrypoint);
		}();
		return storeDebugInfo(
			A3(
				$elm$core$List$foldl,
				processBatch,
				_Utils_Tuple2(previousResult, $elm$core$Dict$empty),
				$timo_weike$generic_collections$ManualDict$toList(batchedByPriority)));
	});
var $author$project$Forward$Internal$PureEffectManager$pushEffect = F2(
	function (cmd, collected) {
		switch (cmd.$) {
			case 'RequestItems':
				var graphPaths = cmd.a;
				return _Utils_update(
					collected,
					{
						newRequests: _Utils_ap(graphPaths, collected.newRequests)
					});
			case 'InvalidateAll':
				return _Utils_update(
					collected,
					{invalidateAll: true});
			case 'InvalidateItem':
				var invalidation = cmd.a;
				return _Utils_update(
					collected,
					{
						newInvalidations: A2($elm$core$List$cons, invalidation, collected.newInvalidations)
					});
			case 'CacheableRequestCommand':
				var cacheableRequest = cmd.a;
				return _Utils_update(
					collected,
					{
						cacheableRequests: A2($elm$core$List$cons, cacheableRequest, collected.cacheableRequests)
					});
			case 'PusherUpdate':
				var value = cmd.a;
				return _Utils_update(
					collected,
					{
						pusherUpdates: A2($elm$core$List$cons, value, collected.pusherUpdates)
					});
			default:
				var tryResolve = cmd.b;
				return _Utils_update(
					collected,
					{
						newSingleFetches: A2($elm$core$List$cons, tryResolve, collected.newSingleFetches)
					});
		}
	});
var $author$project$Forward$Internal$PureEffectManager$onEffects = F3(
	function (needsUrl, cmds, state0) {
		var collected = A3($elm$core$List$foldr, $author$project$Forward$Internal$PureEffectManager$pushEffect, $author$project$Forward$Internal$PureEffectManager$emptyCollectedEffects, cmds);
		var pendingFetches = _Utils_ap(collected.newSingleFetches, state0.pendingSingleFetches);
		var _v0 = A2($author$project$Forward$Internal$PureEffectManager$processInvalidations, collected.newInvalidations, state0.z__internal__typedCache);
		var newCache1 = _v0.a;
		var cacheUpdate1 = _v0.b;
		var _v1 = collected.invalidateAll ? _Utils_Tuple2($author$project$Forward$AppSpecific$Cache$empty, true) : _Utils_Tuple2(newCache1, false);
		var newCache2 = _v1.a;
		var cacheUpdate2 = _v1.b;
		var pendingFetchesResult = A2($author$project$Forward$Internal$PureEffectManager$processPendingSingleFetches, newCache1, pendingFetches);
		var newRequests = $elm$core$List$concat(
			_List_fromArray(
				[collected.newRequests, pendingFetchesResult.requestsToMake]));
		return A2(
			$author$project$Forward$Internal$PureEffectManager$processCacheableRequests,
			collected.cacheableRequests,
			A3(
				$author$project$Forward$Internal$PureEffectManager$processRequests,
				needsUrl,
				newRequests,
				A2(
					$author$project$Forward$Internal$PureEffectManager$processPusherUpdates,
					collected.pusherUpdates,
					{
						appMsg: pendingFetchesResult.appMsgs,
						newState: _Utils_update(
							state0,
							{pendingSingleFetches: pendingFetchesResult.stillPending, z__internal__typedCache: newCache2}),
						sendCacheUpdate: cacheUpdate1 || cacheUpdate2,
						tasksToSpawn: $turboMaCk$queue$Queue$empty
					})));
	});
var $author$project$Forward$Internal$OutstandingRequests$removeRequest = F2(
	function (requestId, _v0) {
		var old = _v0.a;
		return $author$project$Forward$Internal$OutstandingRequests$build(
			A2($elm$core$Dict$remove, requestId, old.byRequestId));
	});
var $author$project$Forward$Internal$Requests$requestCompleted = F2(
	function (requestId, oldOutstanding) {
		return A2($author$project$Forward$Internal$OutstandingRequests$removeRequest, requestId, oldOutstanding);
	});
var $author$project$Forward$Internal$PureEffectManager$onSelfMsg = F3(
	function (needsUrl, selfMsg, state) {
		if (selfMsg.$ === 'ReceivedNeedsResponse') {
			if (selfMsg.b.$ === 'Ok') {
				var requestDetails = selfMsg.a;
				var insertNewItems = selfMsg.b.a;
				var newRequestsState = A2($author$project$Forward$Internal$Requests$requestCompleted, requestDetails.requestId, state.z__internal__outstandingRequests);
				var _v1 = insertNewItems(state.z__internal__typedCache);
				var newCache = _v1.a;
				var errors = _v1.b;
				var tasksToSpawn = $turboMaCk$queue$Queue$fromList(
					$author$project$Forward$Internal$PureEffectManager$reportErrors(errors));
				var state1 = _Utils_update(
					state,
					{
						outstandingRequestsByEntrypoint: $author$project$Forward$Internal$OutstandingRequests$debugView(newRequestsState),
						z__internal__outstandingRequests: newRequestsState,
						z__internal__typedCache: newCache
					});
				var pendingFetchesResult = A2($author$project$Forward$Internal$PureEffectManager$processPendingSingleFetches, state1.z__internal__typedCache, state1.pendingSingleFetches);
				var state2 = _Utils_update(
					state1,
					{pendingSingleFetches: pendingFetchesResult.stillPending});
				return A3(
					$author$project$Forward$Internal$PureEffectManager$processRequests,
					needsUrl,
					pendingFetchesResult.requestsToMake,
					{appMsg: pendingFetchesResult.appMsgs, newState: state2, sendCacheUpdate: true, tasksToSpawn: tasksToSpawn});
			} else {
				var err = selfMsg.b.a;
				return {appMsg: _List_Nil, newState: state, sendCacheUpdate: false, tasksToSpawn: $turboMaCk$queue$Queue$empty};
			}
		} else {
			var responseToMessage = selfMsg.a;
			var result = selfMsg.b;
			if (result.$ === 'GoodStatus_') {
				var body = result.b;
				var maybeApplyCacheUpdate = function (maybeUpdate) {
					if (maybeUpdate.$ === 'Just') {
						var update = maybeUpdate.a;
						return A2($author$project$Forward$Internal$PureEffectManager$modifyCache, state, update);
					} else {
						return _Utils_Tuple2(state, _List_Nil);
					}
				};
				var cacheableFieldDecoder = A2($author$project$Forward$RailsBackend$NeedsController$decodeResponseAsUpdateFunction, true, $timo_weike$generic_collections$ManualDict$empty);
				var _v3 = A2(
					$elm_community$result_extra$Result$Extra$extract,
					function (err) {
						return _Utils_Tuple2(
							state,
							_List_fromArray(
								[
									$author$project$Forward$Remote$errorFromJsonError(err)
								]));
					},
					A2(
						$elm$core$Result$map,
						maybeApplyCacheUpdate,
						A2(
							$elm$json$Json$Decode$decodeString,
							$elm$json$Json$Decode$maybe(
								A2($elm$json$Json$Decode$field, 'cacheable', cacheableFieldDecoder)),
							body)));
				var newState = _v3.a;
				var errors = _v3.b;
				return {
					appMsg: _List_fromArray(
						[
							responseToMessage(result)
						]),
					newState: newState,
					sendCacheUpdate: true,
					tasksToSpawn: $turboMaCk$queue$Queue$fromList(
						$author$project$Forward$Internal$PureEffectManager$reportErrors(errors))
				};
			} else {
				return {
					appMsg: _List_fromArray(
						[
							responseToMessage(result)
						]),
					newState: state,
					sendCacheUpdate: false,
					tasksToSpawn: $turboMaCk$queue$Queue$empty
				};
			}
		}
	});
var $author$project$Forward$Component$spawnTasksInOrder = function (tasksToSpawn) {
	return $author$project$HubTran$Effect$batch(
		A2(
			$elm$core$List$map,
			$author$project$HubTran$Effect$InspectableEffect,
			$elm$core$List$reverse(
				$turboMaCk$queue$Queue$toList(tasksToSpawn))));
};
var $author$project$Forward$Ports$needsUnauthorized = _Platform_outgoingPort(
	'needsUnauthorized',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Forward$Component$unauthorizedEffect = function (msg) {
	if ((((msg.$ === 'ReceivedNeedsResponse') && (msg.b.$ === 'Err')) && (msg.b.a.$ === 'BadStatus')) && (msg.b.a.a === 401)) {
		return $author$project$HubTran$Effect$cmd(
			$author$project$Forward$Ports$needsUnauthorized(_Utils_Tuple0));
	} else {
		return $author$project$HubTran$Effect$none;
	}
};
var $author$project$Forward$Component$handleEffectManagerUpdateResult = F6(
	function (needsUrl, childLoadData, childDataEffects, childUpdate, updateResult, _v3) {
		var model = _v3.a;
		var model1 = $author$project$Forward$Component$Model(
			_Utils_update(
				model,
				{forwardAPI: updateResult.newState}));
		var handleAppMsgs = F2(
			function (_v4, appMsgs) {
				handleAppMsgs:
				while (true) {
					var model_ = _v4.a;
					var cmd_ = _v4.b;
					if (appMsgs.b) {
						var next = appMsgs.a;
						var rest = appMsgs.b;
						var _v6 = A6($author$project$Forward$Component$update, needsUrl, childLoadData, childDataEffects, childUpdate, next, model_);
						var m = _v6.a;
						var c = _v6.b;
						var $temp$_v4 = _Utils_Tuple2(
							m,
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[c, cmd_]))),
							$temp$appMsgs = rest;
						_v4 = $temp$_v4;
						appMsgs = $temp$appMsgs;
						continue handleAppMsgs;
					} else {
						return _Utils_Tuple2(model_, cmd_);
					}
				}
			});
		var asyncTasks = $author$project$Forward$Component$spawnTasksInOrder(updateResult.tasksToSpawn);
		var _v7 = updateResult.sendCacheUpdate ? A6($author$project$Forward$Component$update, needsUrl, childLoadData, childDataEffects, childUpdate, $author$project$Forward$Component$CacheUpdate, model1) : _Utils_Tuple2(model1, $author$project$HubTran$Effect$none);
		var model2 = _v7.a;
		var cmd2 = _v7.b;
		var _v8 = A2(
			handleAppMsgs,
			_Utils_Tuple2(model2, $author$project$HubTran$Effect$none),
			updateResult.appMsg);
		var model3 = _v8.a;
		var cmd3 = _v8.b;
		return _Utils_Tuple2(
			model3,
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						cmd2,
						cmd3,
						A2($author$project$HubTran$Effect$map, $author$project$Forward$Component$EffectManagerMsg, asyncTasks)
					])));
	});
var $author$project$Forward$Component$update = F6(
	function (needsUrl, childLoadData, childDataEffects, childUpdate, action, _v0) {
		var model = _v0.a;
		switch (action.$) {
			case 'CacheUpdate':
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Forward$Component$ChildMsg),
					A3(
						$author$project$Forward$Component$refreshData,
						childLoadData,
						childDataEffects,
						_Utils_Tuple2(
							$author$project$Forward$Component$Model(model),
							$author$project$HubTran$Effect$none)));
			case 'EffectManagerEffects':
				var cmds = action.a;
				var updateResult = A3($author$project$Forward$Internal$PureEffectManager$onEffects, needsUrl, cmds, model.forwardAPI);
				return A6(
					$author$project$Forward$Component$handleEffectManagerUpdateResult,
					needsUrl,
					childLoadData,
					childDataEffects,
					childUpdate,
					updateResult,
					$author$project$Forward$Component$Model(model));
			case 'EffectManagerMsg':
				var msg = action.a;
				var updateResult = A3($author$project$Forward$Internal$PureEffectManager$onSelfMsg, needsUrl, msg, model.forwardAPI);
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effect) {
						return $author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									effect,
									$author$project$Forward$Component$unauthorizedEffect(msg)
								]));
					},
					A6(
						$author$project$Forward$Component$handleEffectManagerUpdateResult,
						needsUrl,
						childLoadData,
						childDataEffects,
						childUpdate,
						updateResult,
						$author$project$Forward$Component$Model(model)));
			case 'ChildMsg':
				var childMsg = action.a;
				var _v2 = A3(childUpdate, model.data, childMsg, model.childModel);
				var newChildModel = _v2.a;
				var childEffects = _v2.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$author$project$HubTran$Effect$map($author$project$Forward$Component$ChildMsg),
					A3(
						$author$project$Forward$Component$refreshData,
						childLoadData,
						childDataEffects,
						_Utils_Tuple2(
							$author$project$Forward$Component$Model(
								_Utils_update(
									model,
									{childModel: newChildModel})),
							childEffects)));
			default:
				return _Utils_Tuple2(
					$author$project$Forward$Component$Model(model),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Forward$Component$view = F2(
	function (childView, _v0) {
		var model = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Forward$Component$ChildMsg,
			A2(childView, model.data, model.childModel));
	});
var $author$project$Forward$Component$programWithFlags = function (config) {
	return A2(
		$author$project$HubTran$Navigation$programWithFlags,
		A2($elm$core$Basics$composeL, $author$project$Forward$Component$ChildMsg, config.onUrlChange),
		{
			init: F2(
				function (flags, initialUrl) {
					return A2(
						$elm$core$Tuple$mapSecond,
						$author$project$Forward$Component$runEffect,
						A3(
							$author$project$Forward$Component$init,
							config.loadData,
							config.dataEffects,
							A2(config.init, flags.mainFlags, initialUrl)));
				}),
			subscriptions: $author$project$Forward$Component$subscriptions(config.subscriptions),
			update: F2(
				function (msg, model) {
					return A2(
						$elm$core$Tuple$mapSecond,
						$author$project$Forward$Component$runEffect,
						A6($author$project$Forward$Component$update, config.needsUrl, config.loadData, config.dataEffects, config.update, msg, model));
				}),
			view: $author$project$Forward$Component$view(config.view)
		});
};
var $author$project$Main$BeamerMessageCount = function (a) {
	return {$: 'BeamerMessageCount', a: a};
};
var $author$project$Main$FlashComponentMsg = function (a) {
	return {$: 'FlashComponentMsg', a: a};
};
var $author$project$Main$FlashFromJavascriptMaybeV3Reskin = function (a) {
	return {$: 'FlashFromJavascriptMaybeV3Reskin', a: a};
};
var $author$project$Main$UpdateHeaderFlags = function (a) {
	return {$: 'UpdateHeaderFlags', a: a};
};
var $author$project$Main$ViewportChanged = {$: 'ViewportChanged'};
var $author$project$Js$beamerMessageCount = _Platform_incomingPort('beamerMessageCount', $elm$json$Json$Decode$int);
var $author$project$Js$flashFromJavascriptMaybeV3Reskin = _Platform_incomingPort(
	'flashFromJavascriptMaybeV3Reskin',
	A2(
		$elm$json$Json$Decode$andThen,
		function (title) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (time) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (position) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (message) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (level) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (indefinite) {
													return $elm$json$Json$Decode$succeed(
														{indefinite: indefinite, level: level, message: message, position: position, time: time, title: title});
												},
												A2($elm$json$Json$Decode$field, 'indefinite', $elm$json$Json$Decode$bool));
										},
										A2($elm$json$Json$Decode$field, 'level', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'position', $elm$json$Json$Decode$string));
				},
				A2(
					$elm$json$Json$Decode$field,
					'time',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$float)
							]))));
		},
		A2(
			$elm$json$Json$Decode$field,
			'title',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
					])))));
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Window = {$: 'Window'};
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 'MySub', a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {pids: pids, subs: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (node.$ === 'Document') {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {event: event, key: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (node.$ === 'Document') {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.pids,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var event = _v0.event;
		var key = _v0.key;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.subs);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		$elm$browser$Browser$Events$Window,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $elm$browser$Browser$Events$Document = {$: 'Document'};
var $elm$browser$Browser$Events$Hidden = {$: 'Hidden'};
var $elm$browser$Browser$Events$Visible = {$: 'Visible'};
var $elm$browser$Browser$Events$withHidden = F2(
	function (func, isHidden) {
		return func(
			isHidden ? $elm$browser$Browser$Events$Hidden : $elm$browser$Browser$Events$Visible);
	});
var $elm$browser$Browser$Events$onVisibilityChange = function (func) {
	var info = _Browser_visibilityInfo(_Utils_Tuple0);
	return A3(
		$elm$browser$Browser$Events$on,
		$elm$browser$Browser$Events$Document,
		info.change,
		A2(
			$elm$json$Json$Decode$map,
			$elm$browser$Browser$Events$withHidden(func),
			A2(
				$elm$json$Json$Decode$field,
				'target',
				A2($elm$json$Json$Decode$field, info.hidden, $elm$json$Json$Decode$bool))));
};
var $author$project$Main$ActivityPageMsg = function (a) {
	return {$: 'ActivityPageMsg', a: a};
};
var $author$project$Main$DocumentsViewerPopoutPageMsg = function (a) {
	return {$: 'DocumentsViewerPopoutPageMsg', a: a};
};
var $author$project$Main$FactorInvoiceAuditBatchPageMsg = function (a) {
	return {$: 'FactorInvoiceAuditBatchPageMsg', a: a};
};
var $author$project$Main$FactorInvoiceAuditPageMsg = function (a) {
	return {$: 'FactorInvoiceAuditPageMsg', a: a};
};
var $author$project$Main$LtlHeldSubmissionsPageMsg = function (a) {
	return {$: 'LtlHeldSubmissionsPageMsg', a: a};
};
var $author$project$Main$LtlReconcileInvoicePageMsg = function (a) {
	return {$: 'LtlReconcileInvoicePageMsg', a: a};
};
var $author$project$Main$NoaManagementSentPageMsg = function (a) {
	return {$: 'NoaManagementSentPageMsg', a: a};
};
var $author$project$Main$NonInvoiceConfirmPageMsg = function (a) {
	return {$: 'NonInvoiceConfirmPageMsg', a: a};
};
var $author$project$Broker$Page$BillingRequirements$CurrentProcessingSelectionUpdated = function (a) {
	return {$: 'CurrentProcessingSelectionUpdated', a: a};
};
var $author$project$Js$onCurrentProcessingSelectionUpdate = _Platform_incomingPort(
	'onCurrentProcessingSelectionUpdate',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value)
			])));
var $author$project$Broker$Page$BillingRequirements$subscriptions = function (_v0) {
	return $author$project$Js$onCurrentProcessingSelectionUpdate($author$project$Broker$Page$BillingRequirements$CurrentProcessingSelectionUpdated);
};
var $author$project$Broker$Page$DocumentsViewerPopout$CurrentProcessingSelectionRefreshed = {$: 'CurrentProcessingSelectionRefreshed'};
var $author$project$Broker$Page$DocumentsViewerPopout$CurrentProcessingSelectionUpdated = function (a) {
	return {$: 'CurrentProcessingSelectionUpdated', a: a};
};
var $author$project$Broker$Page$DocumentsViewerPopout$DocumentViewerPageContextDataUpdated = function (a) {
	return {$: 'DocumentViewerPageContextDataUpdated', a: a};
};
var $author$project$Broker$Page$DocumentsViewerPopout$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Broker$Page$DocumentsViewerPopout$HoveredTextFromMainPageUpdated = function (a) {
	return {$: 'HoveredTextFromMainPageUpdated', a: a};
};
var $author$project$Js$onCurrentProcessingSelectionRefresh = _Platform_incomingPort(
	'onCurrentProcessingSelectionRefresh',
	$elm$json$Json$Decode$null(_Utils_Tuple0));
var $author$project$Js$onDocumentViewerPageContextDataUpdate = _Platform_incomingPort(
	'onDocumentViewerPageContextDataUpdate',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value)
			])));
var $author$project$Js$onHoveredTextFromMainPageUpdate = _Platform_incomingPort(
	'onHoveredTextFromMainPageUpdate',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
			])));
var $author$project$Components$DocumentsBrowser$AnnotationMsg = function (a) {
	return {$: 'AnnotationMsg', a: a};
};
var $author$project$Components$DocumentsBrowser$DragScrollEnd = {$: 'DragScrollEnd'};
var $author$project$Components$DocumentsBrowser$DragScrollMove = F2(
	function (a, b) {
		return {$: 'DragScrollMove', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$HotkeyMsg = function (a) {
	return {$: 'HotkeyMsg', a: a};
};
var $author$project$Components$DocumentsBrowser$KeyPressed = function (a) {
	return {$: 'KeyPressed', a: a};
};
var $author$project$Helpers$Hotkey$MarkIllegible = {$: 'MarkIllegible'};
var $author$project$Helpers$Hotkey$NextGroup = {$: 'NextGroup'};
var $author$project$Helpers$Hotkey$NextPage = {$: 'NextPage'};
var $author$project$Helpers$Hotkey$NoOp = {$: 'NoOp'};
var $author$project$Helpers$Hotkey$PrevGroup = {$: 'PrevGroup'};
var $author$project$Helpers$Hotkey$PrevPage = {$: 'PrevPage'};
var $author$project$Helpers$Hotkey$RotateLeft = {$: 'RotateLeft'};
var $author$project$Helpers$Hotkey$RotateRight = {$: 'RotateRight'};
var $author$project$Helpers$Hotkey$ToggleHidden = {$: 'ToggleHidden'};
var $author$project$Helpers$Hotkey$TogglePOD = {$: 'TogglePOD'};
var $author$project$Helpers$Hotkey$ZoomIn = {$: 'ZoomIn'};
var $author$project$Helpers$Hotkey$ZoomOut = {$: 'ZoomOut'};
var $author$project$Helpers$Hotkey$fromString = function (str) {
	switch (str) {
		case 'markIllegible':
			return $author$project$Helpers$Hotkey$MarkIllegible;
		case 'nextGroup':
			return $author$project$Helpers$Hotkey$NextGroup;
		case 'nextPage':
			return $author$project$Helpers$Hotkey$NextPage;
		case 'prevGroup':
			return $author$project$Helpers$Hotkey$PrevGroup;
		case 'prevPage':
			return $author$project$Helpers$Hotkey$PrevPage;
		case 'toggleHidden':
			return $author$project$Helpers$Hotkey$ToggleHidden;
		case 'togglePOD':
			return $author$project$Helpers$Hotkey$TogglePOD;
		case 'rotateLeft':
			return $author$project$Helpers$Hotkey$RotateLeft;
		case 'rotateRight':
			return $author$project$Helpers$Hotkey$RotateRight;
		case 'zoomIn':
			return $author$project$Helpers$Hotkey$ZoomIn;
		case 'zoomOut':
			return $author$project$Helpers$Hotkey$ZoomOut;
		default:
			return $author$project$Helpers$Hotkey$NoOp;
	}
};
var $author$project$Js$onHotkeyInput = _Platform_incomingPort('onHotkeyInput', $elm$json$Json$Decode$string);
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'keydown');
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mousemove');
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mouseup');
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadUploadFinished = function (a) {
	return {$: 'AddDocumentToLoadUploadFinished', a: a};
};
var $author$project$Js$onAddDocumentToLoadUploadFinished = _Platform_incomingPort('onAddDocumentToLoadUploadFinished', $elm$json$Json$Decode$value);
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$subscriptions = $author$project$Js$onAddDocumentToLoadUploadFinished($author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadUploadFinished);
var $author$project$Components$DocumentBrowser$AnnotationOverlay$DragEnded = {$: 'DragEnded'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$DragMoved = F2(
	function (a, b) {
		return {$: 'DragMoved', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$sessionOf = function (model) {
	switch (model.$) {
		case 'Annotating':
			var session = model.a;
			return $elm$core$Maybe$Just(session);
		case 'Idle':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$DocumentBrowser$Annotation$Drag$subscriptions = F2(
	function (drag, handlers) {
		if (drag.$ === 'Dragging') {
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$elm$browser$Browser$Events$onMouseMove(
						A3(
							$elm$json$Json$Decode$map2,
							handlers.moved,
							A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))),
						$elm$browser$Browser$Events$onMouseUp(
						$elm$json$Json$Decode$succeed(handlers.ended))
					]));
		} else {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$subscriptions = function (model) {
	var _v0 = $author$project$Components$DocumentBrowser$AnnotationOverlay$sessionOf(model);
	if (_v0.$ === 'Just') {
		var session = _v0.a;
		return A2(
			$author$project$Components$DocumentBrowser$Annotation$Drag$subscriptions,
			session.drag,
			{ended: $author$project$Components$DocumentBrowser$AnnotationOverlay$DragEnded, moved: $author$project$Components$DocumentBrowser$AnnotationOverlay$DragMoved});
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$DocumentsBrowser$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Js$onHotkeyInput(
				A2($elm$core$Basics$composeL, $author$project$Components$DocumentsBrowser$HotkeyMsg, $author$project$Helpers$Hotkey$fromString)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$DocumentsBrowser$NonHotkeyMsg, $author$project$Components$DocumentsBrowser$AddDocumentToLoadMsg),
				$author$project$Components$DocumentBrowser$AddDocumentToLoad$subscriptions),
				$elm$browser$Browser$Events$onKeyDown(
				A5(
					$elm$json$Json$Decode$map4,
					F4(
						function (key, ctrl, meta, alt) {
							return (ctrl || (meta || alt)) ? $author$project$Components$DocumentsBrowser$NonHotkeyMsg(
								$author$project$Components$DocumentsBrowser$KeyPressed('')) : $author$project$Components$DocumentsBrowser$NonHotkeyMsg(
								$author$project$Components$DocumentsBrowser$KeyPressed(key));
						}),
					A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool))),
				function () {
				var _v0 = model.dragScroll;
				if (_v0.$ === 'Just') {
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								$elm$browser$Browser$Events$onMouseMove(
								A3(
									$elm$json$Json$Decode$map2,
									F2(
										function (x, y) {
											return $author$project$Components$DocumentsBrowser$NonHotkeyMsg(
												A2($author$project$Components$DocumentsBrowser$DragScrollMove, x, y));
										}),
									A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
									A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))),
								$elm$browser$Browser$Events$onMouseUp(
								$elm$json$Json$Decode$succeed(
									$author$project$Components$DocumentsBrowser$NonHotkeyMsg($author$project$Components$DocumentsBrowser$DragScrollEnd)))
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$DocumentsBrowser$NonHotkeyMsg, $author$project$Components$DocumentsBrowser$AnnotationMsg),
				$author$project$Components$DocumentBrowser$AnnotationOverlay$subscriptions(model.annotations))
			]));
};
var $author$project$Broker$Page$DocumentsViewerPopout$subscriptions = function (model) {
	var documentViewerSubs = A2(
		$elm$core$Platform$Sub$map,
		$author$project$Broker$Page$DocumentsViewerPopout$DocumentsBrowserMsg,
		$author$project$Components$DocumentsBrowser$subscriptions(model.documentsViewer));
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				documentViewerSubs,
				$author$project$Js$onCurrentProcessingSelectionRefresh(
				function (_v0) {
					return $author$project$Broker$Page$DocumentsViewerPopout$CurrentProcessingSelectionRefreshed;
				}),
				$author$project$Js$onCurrentProcessingSelectionUpdate($author$project$Broker$Page$DocumentsViewerPopout$CurrentProcessingSelectionUpdated),
				$author$project$Js$onHoveredTextFromMainPageUpdate($author$project$Broker$Page$DocumentsViewerPopout$HoveredTextFromMainPageUpdated),
				$author$project$Js$onDocumentViewerPageContextDataUpdate($author$project$Broker$Page$DocumentsViewerPopout$DocumentViewerPageContextDataUpdated)
			]));
};
var $author$project$Components$ActivityPage$FiltersViewMsg = function (a) {
	return {$: 'FiltersViewMsg', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$CarrierDropdownMsg = function (a) {
	return {$: 'CarrierDropdownMsg', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$CarrierTypeaheadMsg = function (a) {
	return {$: 'CarrierTypeaheadMsg', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$CustomerDropdownMsg = function (a) {
	return {$: 'CustomerDropdownMsg', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$CustomerTypeaheadMsg = function (a) {
	return {$: 'CustomerTypeaheadMsg', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$DebtorTypeaheadMsg = function (a) {
	return {$: 'DebtorTypeaheadMsg', a: a};
};
var $author$project$Typeahead$TypeaheadMenuMsg = function (a) {
	return {$: 'TypeaheadMenuMsg', a: a};
};
var $author$project$TypeaheadMenu$KeyDown = function (a) {
	return {$: 'KeyDown', a: a};
};
var $ohanhi$keyboard$Keyboard$Backspace = {$: 'Backspace'};
var $ohanhi$keyboard$Keyboard$Clear = {$: 'Clear'};
var $ohanhi$keyboard$Keyboard$Copy = {$: 'Copy'};
var $ohanhi$keyboard$Keyboard$CrSel = {$: 'CrSel'};
var $ohanhi$keyboard$Keyboard$Cut = {$: 'Cut'};
var $ohanhi$keyboard$Keyboard$Delete = {$: 'Delete'};
var $ohanhi$keyboard$Keyboard$EraseEof = {$: 'EraseEof'};
var $ohanhi$keyboard$Keyboard$ExSel = {$: 'ExSel'};
var $ohanhi$keyboard$Keyboard$Insert = {$: 'Insert'};
var $ohanhi$keyboard$Keyboard$Paste = {$: 'Paste'};
var $ohanhi$keyboard$Keyboard$Redo = {$: 'Redo'};
var $ohanhi$keyboard$Keyboard$Undo = {$: 'Undo'};
var $ohanhi$keyboard$Keyboard$editingKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'Backspace':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Backspace);
		case 'Clear':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Clear);
		case 'Copy':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Copy);
		case 'CrSel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CrSel);
		case 'Cut':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Cut);
		case 'Delete':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Delete);
		case 'EraseEof':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$EraseEof);
		case 'ExSel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ExSel);
		case 'Insert':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Insert);
		case 'Paste':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Paste);
		case 'Redo':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Redo);
		case 'Undo':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Undo);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$F1 = {$: 'F1'};
var $ohanhi$keyboard$Keyboard$F10 = {$: 'F10'};
var $ohanhi$keyboard$Keyboard$F11 = {$: 'F11'};
var $ohanhi$keyboard$Keyboard$F12 = {$: 'F12'};
var $ohanhi$keyboard$Keyboard$F13 = {$: 'F13'};
var $ohanhi$keyboard$Keyboard$F14 = {$: 'F14'};
var $ohanhi$keyboard$Keyboard$F15 = {$: 'F15'};
var $ohanhi$keyboard$Keyboard$F16 = {$: 'F16'};
var $ohanhi$keyboard$Keyboard$F17 = {$: 'F17'};
var $ohanhi$keyboard$Keyboard$F18 = {$: 'F18'};
var $ohanhi$keyboard$Keyboard$F19 = {$: 'F19'};
var $ohanhi$keyboard$Keyboard$F2 = {$: 'F2'};
var $ohanhi$keyboard$Keyboard$F20 = {$: 'F20'};
var $ohanhi$keyboard$Keyboard$F3 = {$: 'F3'};
var $ohanhi$keyboard$Keyboard$F4 = {$: 'F4'};
var $ohanhi$keyboard$Keyboard$F5 = {$: 'F5'};
var $ohanhi$keyboard$Keyboard$F6 = {$: 'F6'};
var $ohanhi$keyboard$Keyboard$F7 = {$: 'F7'};
var $ohanhi$keyboard$Keyboard$F8 = {$: 'F8'};
var $ohanhi$keyboard$Keyboard$F9 = {$: 'F9'};
var $ohanhi$keyboard$Keyboard$functionKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'F1':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F1);
		case 'F2':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F2);
		case 'F3':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F3);
		case 'F4':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F4);
		case 'F5':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F5);
		case 'F6':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F6);
		case 'F7':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F7);
		case 'F8':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F8);
		case 'F9':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F9);
		case 'F10':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F10);
		case 'F11':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F11);
		case 'F12':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F12);
		case 'F13':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F13);
		case 'F14':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F14);
		case 'F15':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F15);
		case 'F16':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F16);
		case 'F17':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F17);
		case 'F18':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F18);
		case 'F19':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F19);
		case 'F20':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F20);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$ChannelDown = {$: 'ChannelDown'};
var $ohanhi$keyboard$Keyboard$ChannelUp = {$: 'ChannelUp'};
var $ohanhi$keyboard$Keyboard$MediaFastForward = {$: 'MediaFastForward'};
var $ohanhi$keyboard$Keyboard$MediaPause = {$: 'MediaPause'};
var $ohanhi$keyboard$Keyboard$MediaPlay = {$: 'MediaPlay'};
var $ohanhi$keyboard$Keyboard$MediaPlayPause = {$: 'MediaPlayPause'};
var $ohanhi$keyboard$Keyboard$MediaRecord = {$: 'MediaRecord'};
var $ohanhi$keyboard$Keyboard$MediaRewind = {$: 'MediaRewind'};
var $ohanhi$keyboard$Keyboard$MediaStop = {$: 'MediaStop'};
var $ohanhi$keyboard$Keyboard$MediaTrackNext = {$: 'MediaTrackNext'};
var $ohanhi$keyboard$Keyboard$MediaTrackPrevious = {$: 'MediaTrackPrevious'};
var $ohanhi$keyboard$Keyboard$mediaKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'ChannelDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ChannelDown);
		case 'ChannelUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ChannelUp);
		case 'MediaFastForward':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaFastForward);
		case 'MediaPause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPause);
		case 'MediaPlay':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPlay);
		case 'MediaPlayPause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPlayPause);
		case 'MediaRecord':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaRecord);
		case 'MediaRewind':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaRewind);
		case 'MediaStop':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaStop);
		case 'MediaTrackNext':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaTrackNext);
		case 'MediaTrackPrevious':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaTrackPrevious);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Alt = {$: 'Alt'};
var $ohanhi$keyboard$Keyboard$AltGraph = {$: 'AltGraph'};
var $ohanhi$keyboard$Keyboard$CapsLock = {$: 'CapsLock'};
var $ohanhi$keyboard$Keyboard$Control = {$: 'Control'};
var $ohanhi$keyboard$Keyboard$Fn = {$: 'Fn'};
var $ohanhi$keyboard$Keyboard$FnLock = {$: 'FnLock'};
var $ohanhi$keyboard$Keyboard$Hyper = {$: 'Hyper'};
var $ohanhi$keyboard$Keyboard$Meta = {$: 'Meta'};
var $ohanhi$keyboard$Keyboard$NumLock = {$: 'NumLock'};
var $ohanhi$keyboard$Keyboard$ScrollLock = {$: 'ScrollLock'};
var $ohanhi$keyboard$Keyboard$Shift = {$: 'Shift'};
var $ohanhi$keyboard$Keyboard$Super = {$: 'Super'};
var $ohanhi$keyboard$Keyboard$Symbol = {$: 'Symbol'};
var $ohanhi$keyboard$Keyboard$SymbolLock = {$: 'SymbolLock'};
var $ohanhi$keyboard$Keyboard$modifierKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'Alt':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Alt);
		case 'AltGraph':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$AltGraph);
		case 'CapsLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CapsLock);
		case 'Control':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Control);
		case 'Fn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Fn);
		case 'FnLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$FnLock);
		case 'Hyper':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Hyper);
		case 'Meta':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Meta);
		case 'NumLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$NumLock);
		case 'ScrollLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ScrollLock);
		case 'Shift':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Shift);
		case 'Super':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Super);
		case 'OS':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Super);
		case 'Symbol':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Symbol);
		case 'SymbolLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$SymbolLock);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$ArrowDown = {$: 'ArrowDown'};
var $ohanhi$keyboard$Keyboard$ArrowLeft = {$: 'ArrowLeft'};
var $ohanhi$keyboard$Keyboard$ArrowRight = {$: 'ArrowRight'};
var $ohanhi$keyboard$Keyboard$ArrowUp = {$: 'ArrowUp'};
var $ohanhi$keyboard$Keyboard$End = {$: 'End'};
var $ohanhi$keyboard$Keyboard$Home = {$: 'Home'};
var $ohanhi$keyboard$Keyboard$PageDown = {$: 'PageDown'};
var $ohanhi$keyboard$Keyboard$PageUp = {$: 'PageUp'};
var $ohanhi$keyboard$Keyboard$navigationKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'ArrowDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowDown);
		case 'ArrowLeft':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft);
		case 'ArrowRight':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight);
		case 'ArrowUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowUp);
		case 'Down':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowDown);
		case 'Left':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft);
		case 'Right':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight);
		case 'Up':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowUp);
		case 'End':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$End);
		case 'Home':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Home);
		case 'PageDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$PageDown);
		case 'PageUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$PageUp);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$oneOf = F2(
	function (fns, key) {
		oneOf:
		while (true) {
			if (!fns.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var fn = fns.a;
				var rest = fns.b;
				var _v1 = fn(key);
				if (_v1.$ === 'Just') {
					var a = _v1.a;
					return $elm$core$Maybe$Just(a);
				} else {
					var $temp$fns = rest,
						$temp$key = key;
					fns = $temp$fns;
					key = $temp$key;
					continue oneOf;
				}
			}
		}
	});
var $ohanhi$keyboard$Keyboard$AppSwitch = {$: 'AppSwitch'};
var $ohanhi$keyboard$Keyboard$Call = {$: 'Call'};
var $ohanhi$keyboard$Keyboard$Camera = {$: 'Camera'};
var $ohanhi$keyboard$Keyboard$CameraFocus = {$: 'CameraFocus'};
var $ohanhi$keyboard$Keyboard$EndCall = {$: 'EndCall'};
var $ohanhi$keyboard$Keyboard$GoBack = {$: 'GoBack'};
var $ohanhi$keyboard$Keyboard$GoHome = {$: 'GoHome'};
var $ohanhi$keyboard$Keyboard$HeadsetHook = {$: 'HeadsetHook'};
var $ohanhi$keyboard$Keyboard$LastNumberRedial = {$: 'LastNumberRedial'};
var $ohanhi$keyboard$Keyboard$MannerMode = {$: 'MannerMode'};
var $ohanhi$keyboard$Keyboard$Notification = {$: 'Notification'};
var $ohanhi$keyboard$Keyboard$VoiceDial = {$: 'VoiceDial'};
var $ohanhi$keyboard$Keyboard$phoneKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'AppSwitch':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$AppSwitch);
		case 'Call':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Call);
		case 'Camera':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Camera);
		case 'CameraFocus':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CameraFocus);
		case 'EndCall':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$EndCall);
		case 'GoBack':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$GoBack);
		case 'GoHome':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$GoHome);
		case 'HeadsetHook':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$HeadsetHook);
		case 'LastNumberRedial':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$LastNumberRedial);
		case 'Notification':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Notification);
		case 'MannerMode':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MannerMode);
		case 'VoiceDial':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$VoiceDial);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Again = {$: 'Again'};
var $ohanhi$keyboard$Keyboard$Attn = {$: 'Attn'};
var $ohanhi$keyboard$Keyboard$Cancel = {$: 'Cancel'};
var $ohanhi$keyboard$Keyboard$ContextMenu = {$: 'ContextMenu'};
var $ohanhi$keyboard$Keyboard$Escape = {$: 'Escape'};
var $ohanhi$keyboard$Keyboard$Execute = {$: 'Execute'};
var $ohanhi$keyboard$Keyboard$Find = {$: 'Find'};
var $ohanhi$keyboard$Keyboard$Finish = {$: 'Finish'};
var $ohanhi$keyboard$Keyboard$Help = {$: 'Help'};
var $ohanhi$keyboard$Keyboard$Pause = {$: 'Pause'};
var $ohanhi$keyboard$Keyboard$Play = {$: 'Play'};
var $ohanhi$keyboard$Keyboard$Props = {$: 'Props'};
var $ohanhi$keyboard$Keyboard$Select = {$: 'Select'};
var $ohanhi$keyboard$Keyboard$ZoomIn = {$: 'ZoomIn'};
var $ohanhi$keyboard$Keyboard$ZoomOut = {$: 'ZoomOut'};
var $ohanhi$keyboard$Keyboard$uiKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'Again':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Again);
		case 'Attn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Attn);
		case 'Cancel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Cancel);
		case 'ContextMenu':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ContextMenu);
		case 'Escape':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Escape);
		case 'Execute':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Execute);
		case 'Find':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Find);
		case 'Finish':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Finish);
		case 'Help':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Help);
		case 'Pause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Pause);
		case 'Play':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Play);
		case 'Props':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Props);
		case 'Select':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Select);
		case 'ZoomIn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ZoomIn);
		case 'ZoomOut':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ZoomOut);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Enter = {$: 'Enter'};
var $ohanhi$keyboard$Keyboard$Spacebar = {$: 'Spacebar'};
var $ohanhi$keyboard$Keyboard$Tab = {$: 'Tab'};
var $ohanhi$keyboard$Keyboard$whitespaceKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'Enter':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Enter);
		case 'Tab':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Tab);
		case 'Spacebar':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Spacebar);
		case ' ':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Spacebar);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$anyKeyWith = function (charParser) {
	return $ohanhi$keyboard$Keyboard$oneOf(
		_List_fromArray(
			[$ohanhi$keyboard$Keyboard$whitespaceKey, charParser, $ohanhi$keyboard$Keyboard$modifierKey, $ohanhi$keyboard$Keyboard$navigationKey, $ohanhi$keyboard$Keyboard$editingKey, $ohanhi$keyboard$Keyboard$functionKey, $ohanhi$keyboard$Keyboard$uiKey, $ohanhi$keyboard$Keyboard$phoneKey, $ohanhi$keyboard$Keyboard$mediaKey]));
};
var $ohanhi$keyboard$Keyboard$Character = function (a) {
	return {$: 'Character', a: a};
};
var $ohanhi$keyboard$Keyboard$characterKeyUpper = function (_v0) {
	var value = _v0.a;
	return ($elm$core$String$length(value) === 1) ? $elm$core$Maybe$Just(
		$ohanhi$keyboard$Keyboard$Character(
			$elm$core$String$toUpper(value))) : $elm$core$Maybe$Nothing;
};
var $ohanhi$keyboard$Keyboard$anyKeyUpper = $ohanhi$keyboard$Keyboard$anyKeyWith($ohanhi$keyboard$Keyboard$characterKeyUpper);
var $ohanhi$keyboard$Keyboard$RawKey = function (a) {
	return {$: 'RawKey', a: a};
};
var $ohanhi$keyboard$Keyboard$eventKeyDecoder = A2(
	$elm$json$Json$Decode$field,
	'key',
	A2($elm$json$Json$Decode$map, $ohanhi$keyboard$Keyboard$RawKey, $elm$json$Json$Decode$string));
var $ohanhi$keyboard$Keyboard$downs = function (toMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
};
var $author$project$TypeaheadMenu$subscription = $ohanhi$keyboard$Keyboard$downs(
	A2($elm$core$Basics$composeR, $ohanhi$keyboard$Keyboard$anyKeyUpper, $author$project$TypeaheadMenu$KeyDown));
var $author$project$Typeahead$subscriptions = function (_v0) {
	var model = _v0.a;
	return model.focused ? A2($elm$core$Platform$Sub$map, $author$project$Typeahead$TypeaheadMenuMsg, $author$project$TypeaheadMenu$subscription) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$CarrierTypeahead$subscriptions = $author$project$Typeahead$subscriptions;
var $author$project$Components$CustomerTypeahead$subscriptions = $author$project$Typeahead$subscriptions;
var $author$project$Components$DebtorTypeahead$subscriptions = $author$project$Typeahead$subscriptions;
var $author$project$Ui$V3$CustomSelect$Close = {$: 'Close'};
var $author$project$Ui$V3$CustomSelect$isOutsideCustomSelect = function (customSelectId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return _Utils_eq(customSelectId, id) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('check parent node');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Ui$V3$CustomSelect$isOutsideCustomSelect(customSelectId));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Ui$V3$CustomSelect$outsideTarget = F2(
	function (targetName, customSelectId) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed($author$project$Ui$V3$CustomSelect$Close) : $elm$json$Json$Decode$fail('inside customSelect');
			},
			A2(
				$elm$json$Json$Decode$field,
				targetName,
				$author$project$Ui$V3$CustomSelect$isOutsideCustomSelect(customSelectId)));
	});
var $author$project$Ui$V3$CustomSelect$eventIsOutsideTargetDecoder = function (model) {
	return A2(
		$author$project$Ui$V3$CustomSelect$outsideTarget,
		'target',
		$author$project$Ui$V3$CustomSelect$getCustomSelectId(model));
};
var $author$project$Ui$V3$CustomSelect$isOpen = function (_v0) {
	var model = _v0.a;
	return model.isOpen;
};
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mousedown');
var $author$project$Components$PaginatedDropdown$subscriptions = function (_v0) {
	var dropdown = _v0.dropdown;
	return $author$project$Ui$V3$CustomSelect$isOpen(dropdown) ? $elm$browser$Browser$Events$onMouseDown(
		$author$project$Ui$V3$CustomSelect$eventIsOutsideTargetDecoder(dropdown)) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$SettingsPage$CarrierDropdown$subscriptions = function (model) {
	return $author$project$Components$PaginatedDropdown$subscriptions(model.dropdown);
};
var $author$project$Components$TmsCustomerDropdown$subscriptions = function (model) {
	return $author$project$Components$PaginatedDropdown$subscriptions(model.dropdown);
};
var $author$project$Components$ActivityBrowser$FiltersView$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$ActivityBrowser$FiltersView$DebtorTypeaheadMsg,
				$author$project$Components$DebtorTypeahead$subscriptions(model.debtorTypeahead)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$ActivityBrowser$FiltersView$CustomerTypeaheadMsg,
				$author$project$Components$CustomerTypeahead$subscriptions(model.customerTypeahead)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$ActivityBrowser$FiltersView$CarrierTypeaheadMsg,
				$author$project$Components$CarrierTypeahead$subscriptions(model.carrierTypeahead)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$ActivityBrowser$FiltersView$CarrierDropdownMsg,
				$author$project$Components$SettingsPage$CarrierDropdown$subscriptions(model.carrierDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$ActivityBrowser$FiltersView$CustomerDropdownMsg,
				$author$project$Components$TmsCustomerDropdown$subscriptions(model.customerDropdown))
			]));
};
var $author$project$Components$ActivityPage$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$ActivityPage$FiltersViewMsg,
		$author$project$Components$ActivityBrowser$FiltersView$subscriptions(model.filters));
};
var $author$project$Components$CarrierInvoiceAuditPage$SplitPaneMsg = function (a) {
	return {$: 'SplitPaneMsg', a: a};
};
var $author$project$Components$AuditSplitPane$Moved = function (a) {
	return {$: 'Moved', a: a};
};
var $author$project$Components$AuditSplitPane$PopoutAlreadyOpen = {$: 'PopoutAlreadyOpen'};
var $author$project$Components$AuditSplitPane$PopoutClosed = {$: 'PopoutClosed'};
var $author$project$Components$AuditSplitPane$Released = {$: 'Released'};
var $author$project$Js$onDocumentViewerPopoutClosed = _Platform_incomingPort(
	'onDocumentViewerPopoutClosed',
	$elm$json$Json$Decode$null(_Utils_Tuple0));
var $author$project$Js$onDocumentViewerPopoutOpen = _Platform_incomingPort(
	'onDocumentViewerPopoutOpen',
	$elm$json$Json$Decode$null(_Utils_Tuple0));
var $author$project$Components$AuditSplitPane$subscriptions = function (_v0) {
	var model = _v0.a;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Js$onDocumentViewerPopoutOpen(
				function (_v1) {
					return $author$project$Components$AuditSplitPane$PopoutAlreadyOpen;
				}),
				$author$project$Js$onDocumentViewerPopoutClosed(
				function (_v2) {
					return $author$project$Components$AuditSplitPane$PopoutClosed;
				}),
				function () {
				var _v3 = model.gesture;
				if (_v3.$ === 'Just') {
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								$elm$browser$Browser$Events$onMouseMove(
								A2(
									$elm$json$Json$Decode$map,
									$author$project$Components$AuditSplitPane$Moved,
									A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float))),
								$elm$browser$Browser$Events$onMouseUp(
								$elm$json$Json$Decode$succeed($author$project$Components$AuditSplitPane$Released))
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Components$CarrierInvoiceAuditPage$subscriptions = F2(
	function (_v0, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$CarrierInvoiceAuditPage$DocumentsBrowserMsg,
					$author$project$Components$DocumentsBrowser$subscriptions(model.documentsBrowser)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$CarrierInvoiceAuditPage$SplitPaneMsg,
					$author$project$Components$AuditSplitPane$subscriptions(model.splitPane))
				]));
	});
var $author$project$Components$DashboardPage$CarrierDropdownMsg = function (a) {
	return {$: 'CarrierDropdownMsg', a: a};
};
var $author$project$Components$DashboardPage$CategoryDropdownMsg = F2(
	function (a, b) {
		return {$: 'CategoryDropdownMsg', a: a, b: b};
	});
var $author$project$Components$DashboardPage$CustomerDropdownMsg = function (a) {
	return {$: 'CustomerDropdownMsg', a: a};
};
var $author$project$Components$DashboardPage$DashboardPresenceMsg = function (a) {
	return {$: 'DashboardPresenceMsg', a: a};
};
var $author$project$Components$DashboardPage$DateRangeDropdownMsg = function (a) {
	return {$: 'DateRangeDropdownMsg', a: a};
};
var $author$project$Components$DashboardPage$DebtorDropdownMsg = function (a) {
	return {$: 'DebtorDropdownMsg', a: a};
};
var $author$project$Components$DashboardPage$ExceptionsDropdownMsg = function (a) {
	return {$: 'ExceptionsDropdownMsg', a: a};
};
var $author$project$Components$DashboardPage$RefreshIds = {$: 'RefreshIds'};
var $author$project$Components$DashboardPage$SetShouldRefreshIds = {$: 'SetShouldRefreshIds'};
var $author$project$Components$DashboardPage$ViewportChanged = {$: 'ViewportChanged'};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 'Every', a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {processes: processes, taggers: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 'Nothing') {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.processes;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(_Utils_Tuple0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.taggers);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 'Time', a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {oldTime: oldTime, request: request, subs: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(_Utils_Tuple0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(_Utils_Tuple0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var oldTime = _v0.oldTime;
		var request = _v0.request;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 'Nothing') {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var oldTime = _v0.oldTime;
		var subs = _v0.subs;
		var send = function (sub) {
			if (sub.$ === 'Time') {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 'Delta', a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (sub.$ === 'Time') {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $author$project$Components$CarrierDropdown$subscriptions = function (model) {
	return $author$project$Components$PaginatedDropdown$subscriptions(model.dropdown);
};
var $author$project$Components$CustomerDropdown$subscriptions = function (model) {
	return $author$project$Components$PaginatedDropdown$subscriptions(model.dropdown);
};
var $author$project$Components$DebtorDropdown$subscriptions = function (model) {
	return $author$project$Components$PaginatedDropdown$subscriptions(model.dropdown);
};
var $author$project$DashboardPresence$GotAllOthers = function (a) {
	return {$: 'GotAllOthers', a: a};
};
var $author$project$Js$onPresenceUpdate = _Platform_incomingPort(
	'onPresenceUpdate',
	$elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$andThen,
			function (path) {
				return A2(
					$elm$json$Json$Decode$andThen,
					function (others) {
						return A2(
							$elm$json$Json$Decode$andThen,
							function (carrier) {
								return $elm$json$Json$Decode$succeed(
									{carrier: carrier, others: others, path: path});
							},
							A2(
								$elm$json$Json$Decode$field,
								'carrier',
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int)
										]))));
					},
					A2(
						$elm$json$Json$Decode$field,
						'others',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
			},
			A2($elm$json$Json$Decode$field, 'path', $elm$json$Json$Decode$string))));
var $author$project$DashboardPresence$subscriptions = $author$project$Js$onPresenceUpdate($author$project$DashboardPresence$GotAllOthers);
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'click');
var $author$project$Ui$V3$CustomSelect$subscriptions = function (_v0) {
	var model = _v0.a;
	return model.isOpen ? $elm$browser$Browser$Events$onClick(
		A2(
			$author$project$Ui$V3$CustomSelect$outsideTarget,
			'target',
			$author$project$Ui$V3$CustomSelect$getCustomSelectId(
				$author$project$Ui$V3$CustomSelect$Model(model)))) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$DashboardPage$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$core$Platform$Sub$map, $author$project$Components$DashboardPage$DashboardPresenceMsg, $author$project$DashboardPresence$subscriptions),
				A2(
				$elm$time$Time$every,
				60000,
				function (_v0) {
					return $author$project$Components$DashboardPage$SetShouldRefreshIds;
				}),
				model.shouldRefreshIds ? $elm$browser$Browser$Events$onAnimationFrame(
				function (_v1) {
					return $author$project$Components$DashboardPage$RefreshIds;
				}) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$DashboardPage$CustomerDropdownMsg,
				$author$project$Components$CustomerDropdown$subscriptions(model.customerDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$DashboardPage$CarrierDropdownMsg,
				$author$project$Components$CarrierDropdown$subscriptions(model.carrierDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$DashboardPage$DebtorDropdownMsg,
				$author$project$Components$DebtorDropdown$subscriptions(model.debtorDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$DashboardPage$DateRangeDropdownMsg,
				$author$project$Ui$V3$CustomSelect$subscriptions(model.dateRangeDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$DashboardPage$ExceptionsDropdownMsg,
				$author$project$Ui$V3$CustomSelect$subscriptions(model.exceptionsDropdown)),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (_v2) {
						var categoryName = _v2.a;
						var dropdown = _v2.b;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$DashboardPage$CategoryDropdownMsg(categoryName),
							$author$project$Ui$V3$CustomSelect$subscriptions(dropdown));
					},
					$elm$core$Dict$toList(model.categoryDropdowns))),
				$elm$browser$Browser$Events$onResize(
				F2(
					function (_v3, _v4) {
						return $author$project$Components$DashboardPage$ViewportChanged;
					})),
				$elm$browser$Browser$Events$onVisibilityChange(
				function (_v5) {
					return $author$project$Components$DashboardPage$ViewportChanged;
				})
			]));
};
var $author$project$Components$DocumentBatchGroupingReviewPage$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$DocumentBatchReviewPage$subscriptions = F2(
	function (_v0, model) {
		var _v1 = model.childModel;
		var childModel = _v1.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$DocumentBatchReviewPage$DocumentBatchGroupingReviewPageMsg,
			$author$project$Components$DocumentBatchGroupingReviewPage$subscriptions(childModel));
	});
var $author$project$Components$DocumentGroupLoadReviewPage$LoadGuessedLoads = {$: 'LoadGuessedLoads'};
var $author$project$Components$DocumentGroupLoadReviewPage$subscriptions = F2(
	function (remoteData, model) {
		var guessedLoadsCheckSub = function () {
			if (remoteData.$ === 'Loaded') {
				return (!model.hasLoadedGuessedLoads) ? A2(
					$elm$time$Time$every,
					100,
					$elm$core$Basics$always($author$project$Components$DocumentGroupLoadReviewPage$LoadGuessedLoads)) : $elm$core$Platform$Sub$none;
			} else {
				return $elm$core$Platform$Sub$none;
			}
		}();
		var documentsBrowserSub = A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$DocumentGroupLoadReviewPage$DocumentsBrowserMsg,
			$author$project$Components$DocumentsBrowser$subscriptions(model.documentsBrowser));
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[documentsBrowserSub, guessedLoadsCheckSub]));
	});
var $author$project$Components$DocumentGroupReviewPage$subscriptions = F2(
	function (remoteData, model) {
		var _v0 = model.childModel;
		var childModel = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPageMsg,
			A2($author$project$Components$DocumentGroupLoadReviewPage$subscriptions, remoteData, childModel));
	});
var $author$project$Components$DocumentReviewPage$subscriptions = F2(
	function (_v0, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$DocumentReviewPage$DocumentsBrowserMsg,
			$author$project$Components$DocumentsBrowser$subscriptions(model.documentsBrowser));
	});
var $author$project$Components$EmailMessageSearchPage$FiltersView$CarrierTypeaheadMsg = function (a) {
	return {$: 'CarrierTypeaheadMsg', a: a};
};
var $author$project$Components$EmailMessageSearchPage$FiltersView$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$EmailMessageSearchPage$FiltersView$CarrierTypeaheadMsg,
				$author$project$Components$CarrierTypeahead$subscriptions(model.carrierTypeahead)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$EmailMessageSearchPage$FiltersView$CarrierDropdownMsg,
				$author$project$Components$SettingsPage$CarrierDropdown$subscriptions(model.carrierDropdown))
			]));
};
var $author$project$Components$EmailMessageSearchPage$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$EmailMessageSearchPage$FiltersViewMsg,
		$author$project$Components$EmailMessageSearchPage$FiltersView$subscriptions(model.filtersUiState));
};
var $author$project$Components$FactorInvoiceAuditBatchGroupingPage$subscriptions = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Sub$none;
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$FactorInvoiceCreated = {$: 'FactorInvoiceCreated'};
var $author$project$Components$FactorInvoiceAuditBatchPage$PresenceMsg = function (a) {
	return {$: 'PresenceMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$SecondaryDocumentsBrowserMsg = function (a) {
	return {$: 'SecondaryDocumentsBrowserMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$SplitPaneMsg = function (a) {
	return {$: 'SplitPaneMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg = function (a) {
	return {$: 'WorkingAreaMsg', a: a};
};
var $author$project$Js$onFactorInvoiceCreated = _Platform_incomingPort('onFactorInvoiceCreated', $elm$json$Json$Decode$int);
var $author$project$Components$FactorInvoiceAuditWorkingArea$BrokeredCarrierDropdownMsg = function (a) {
	return {$: 'BrokeredCarrierDropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$BrokeredCarrierTermDropdownMsg = function (a) {
	return {$: 'BrokeredCarrierTermDropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$CarrierDropdownMsg = function (a) {
	return {$: 'CarrierDropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$DebtorDropdownMsg = function (a) {
	return {$: 'DebtorDropdownMsg', a: a};
};
var $author$project$Components$BrokeredCarrierDropdown$subscriptions = function (model) {
	return $author$project$Components$PaginatedDropdown$subscriptions(model.dropdown);
};
var $author$project$Components$BrokeredCarrierTermDropdown$subscriptions = function (model) {
	return $author$project$Components$PaginatedDropdown$subscriptions(model.dropdown);
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$FactorInvoiceAuditWorkingArea$CarrierDropdownMsg,
				$author$project$Components$CarrierDropdown$subscriptions(model.carrierDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$FactorInvoiceAuditWorkingArea$DebtorDropdownMsg,
				$author$project$Components$DebtorDropdown$subscriptions(model.debtorDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$FactorInvoiceAuditWorkingArea$BrokeredCarrierDropdownMsg,
				$author$project$Components$BrokeredCarrierDropdown$subscriptions(model.brokeredCarrierDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$FactorInvoiceAuditWorkingArea$BrokeredCarrierTermDropdownMsg,
				$author$project$Components$BrokeredCarrierTermDropdown$subscriptions(model.brokeredCarrierTermDropdown))
			]));
};
var $author$project$Presence$GotOthers = function (a) {
	return {$: 'GotOthers', a: a};
};
var $author$project$Js$onOthersPresence = _Platform_incomingPort(
	'onOthersPresence',
	A2(
		$elm$json$Json$Decode$andThen,
		function (path) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (others) {
					return $elm$json$Json$Decode$succeed(
						{others: others, path: path});
				},
				A2(
					$elm$json$Json$Decode$field,
					'others',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
		},
		A2($elm$json$Json$Decode$field, 'path', $elm$json$Json$Decode$string)));
var $author$project$Presence$subscriptions = F2(
	function (toMsg, _v0) {
		return $author$project$Js$onOthersPresence(
			A2($elm$core$Basics$composeR, $author$project$Presence$GotOthers, toMsg));
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$subscriptions = F2(
	function (_v0, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$FactorInvoiceAuditBatchPage$DocumentsBrowserMsg,
					$author$project$Components$DocumentsBrowser$subscriptions(model.documentsBrowser)),
					function () {
					var _v1 = model.secondaryDocumentsBrowser;
					if (_v1.$ === 'Just') {
						var secondary = _v1.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$FactorInvoiceAuditBatchPage$SecondaryDocumentsBrowserMsg,
							$author$project$Components$DocumentsBrowser$subscriptions(secondary));
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}(),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
					$author$project$Components$FactorInvoiceAuditWorkingArea$subscriptions(model.workingArea)),
					A2($author$project$Presence$subscriptions, $author$project$Components$FactorInvoiceAuditBatchPage$PresenceMsg, model.presence),
					$author$project$Js$onFactorInvoiceCreated(
					function (_v2) {
						return $author$project$Components$FactorInvoiceAuditBatchPage$FactorInvoiceCreated;
					}),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$FactorInvoiceAuditBatchPage$SplitPaneMsg,
					$author$project$Components$AuditSplitPane$subscriptions(model.splitPane))
				]));
	});
var $author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$PresenceMsg = function (a) {
	return {$: 'PresenceMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$SecondaryDocumentsBrowserMsg = function (a) {
	return {$: 'SecondaryDocumentsBrowserMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$SplitPaneMsg = function (a) {
	return {$: 'SplitPaneMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg = function (a) {
	return {$: 'WorkingAreaMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$subscriptions = F2(
	function (_v0, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg,
					$author$project$Components$DocumentsBrowser$subscriptions(model.documentsBrowser)),
					function () {
					var _v1 = model.secondaryDocumentsBrowser;
					if (_v1.$ === 'Just') {
						var secondary = _v1.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$FactorInvoiceAuditPage$SecondaryDocumentsBrowserMsg,
							$author$project$Components$DocumentsBrowser$subscriptions(secondary));
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}(),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg,
					$author$project$Components$FactorInvoiceAuditWorkingArea$subscriptions(model.workingArea)),
					A2($author$project$Presence$subscriptions, $author$project$Components$FactorInvoiceAuditPage$PresenceMsg, model.presence),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$FactorInvoiceAuditPage$SplitPaneMsg,
					$author$project$Components$AuditSplitPane$subscriptions(model.splitPane))
				]));
	});
var $author$project$Components$LtlHeldSubmissionsPage$ImportFinished = function (a) {
	return {$: 'ImportFinished', a: a};
};
var $author$project$Js$ltlPayablesCarrierInvoiceSubmissionImportFinished = _Platform_incomingPort('ltlPayablesCarrierInvoiceSubmissionImportFinished', $elm$json$Json$Decode$value);
var $author$project$Components$LtlHeldSubmissionsPage$subscriptions = $author$project$Js$ltlPayablesCarrierInvoiceSubmissionImportFinished($author$project$Components$LtlHeldSubmissionsPage$ImportFinished);
var $author$project$Components$LtlReconcileInvoicePage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$LtlReconcileInvoicePage$DocumentsBrowserMsg,
		$author$project$Components$DocumentsBrowser$subscriptions(model.documentsBrowser));
};
var $author$project$Components$NoaManagement$SentPage$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$NoaManagement$SentPage$DebtorDropdownMsg,
				$author$project$Components$DebtorDropdown$subscriptions(model.debtorDropdown)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$NoaManagement$SentPage$CarrierDropdownMsg,
				$author$project$Components$CarrierDropdown$subscriptions(model.carrierDropdown))
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$PresenceMsg = function (a) {
	return {$: 'PresenceMsg', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$subscriptions = F2(
	function (_v0, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$NonInvoiceConfirmPage$DocumentsBrowserMsg,
					$author$project$Components$DocumentsBrowser$subscriptions(model.documentsBrowser)),
					A2($author$project$Presence$subscriptions, $author$project$Components$NonInvoiceConfirmPage$PresenceMsg, model.presence)
				]));
	});
var $author$project$Components$OktaLoginPage$FailedOktaAuth = function (a) {
	return {$: 'FailedOktaAuth', a: a};
};
var $author$project$Components$OktaLoginPage$failedOktaAuth = _Platform_incomingPort('failedOktaAuth', $elm$json$Json$Decode$string);
var $author$project$Components$OktaLoginPage$subscriptions = $author$project$Components$OktaLoginPage$failedOktaAuth($author$project$Components$OktaLoginPage$FailedOktaAuth);
var $author$project$Components$SettingsPage$CarrierDocumentsSettingsViewMsg = function (a) {
	return {$: 'CarrierDocumentsSettingsViewMsg', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsViewMsg = function (a) {
	return {$: 'FactorClientPortalSettingsViewMsg', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsViewMsg = function (a) {
	return {$: 'PodDefinitionSettingsViewMsg', a: a};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$FileUploaded = function (a) {
	return {$: 'FileUploaded', a: a};
};
var $author$project$Uppy$uppyFileUploaded = _Platform_incomingPort('uppyFileUploaded', $elm$json$Json$Decode$value);
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$subscriptions = $author$project$Uppy$uppyFileUploaded($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$FileUploaded);
var $author$project$Components$SettingsPage$AccountSettingsView$CustomerTypeaheadMsg = function (a) {
	return {$: 'CustomerTypeaheadMsg', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$AccountSettingsView$CustomerTypeaheadMsg,
				$author$project$Components$CustomerTypeahead$subscriptions(model.loadCustomerTypeahead)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$AccountSettingsView$CustomerTypeaheadReskinMsg,
				$author$project$Components$TmsCustomerDropdown$subscriptions(model.loadCustomerTypeaheadReskin))
			]));
};
var $author$project$Components$SettingsPage$ContactForm$CarrierTypeaheadMsg = function (a) {
	return {$: 'CarrierTypeaheadMsg', a: a};
};
var $author$project$Components$SettingsPage$ContactForm$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$ContactForm$CarrierTypeaheadMsg,
				$author$project$Components$CarrierTypeahead$subscriptions(model.carrierTypeahead)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$ContactForm$CarrierDropdownMsg,
				$author$project$Components$SettingsPage$CarrierDropdown$subscriptions(model.carrierDropdown))
			]));
};
var $author$project$Components$SettingsPage$ContactsSettingsView$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg,
		$author$project$Components$SettingsPage$ContactForm$subscriptions(model.contactFormModel));
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm = function (a) {
	return {$: 'EditForm', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$FeatureDropdownMsg = F2(
	function (a, b) {
		return {$: 'FeatureDropdownMsg', a: a, b: b};
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$subscriptions = function (model) {
	var _v0 = model.form;
	if (_v0.$ === 'Just') {
		var form = _v0.a;
		return $elm$core$Platform$Sub$batch(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var dropdown = _v1.dropdown;
					var feature = _v1.feature;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm,
						A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FeatureDropdownMsg(feature.label),
							$author$project$Ui$V3$CustomSelect$subscriptions(dropdown)));
				},
				form.features));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevelMsg = function (a) {
	return {$: 'CustomerLevelMsg', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CustomerSelectMsg = function (a) {
	return {$: 'CustomerSelectMsg', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$subscriptions = function (model) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.customerSelect;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$TmsCustomerDropdown$subscriptions,
				$elm$core$Platform$Sub$map($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CustomerSelectMsg))),
		model.editing);
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevelMsg,
		$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$subscriptions(model.customerLevel));
};
var $author$project$Components$SettingsPage$subscriptions = function (model) {
	var _v0 = model.activeSection;
	switch (_v0.$) {
		case 'CarrierDocumentsSettings':
			return A2($elm$core$Platform$Sub$map, $author$project$Components$SettingsPage$CarrierDocumentsSettingsViewMsg, $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$subscriptions);
		case 'ContactsSettings':
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$ContactsSettingsViewMsg,
				$author$project$Components$SettingsPage$ContactsSettingsView$subscriptions(model_));
		case 'AccountSettings':
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$AccountSettingsViewMsg,
				$author$project$Components$SettingsPage$AccountSettingsView$subscriptions(model_));
		case 'FactorClientPortalSettings':
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$FactorClientPortalSettingsViewMsg,
				$author$project$Components$SettingsPage$FactorClientPortalSettingsView$subscriptions(model_));
		case 'PodDefinitionSettings':
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$PodDefinitionSettingsViewMsg,
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$subscriptions(model_));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$SettingsPage$CarrierLayout$CustomerTypeaheadMsgV3Reskin = function (a) {
	return {$: 'CustomerTypeaheadMsgV3Reskin', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateFeature = F2(
	function (a, b) {
		return {$: 'UpdateFeature', a: a, b: b};
	});
var $author$project$Components$ClientDebtorConfigurationManager$DebtorTypeaheadMsg = function (a) {
	return {$: 'DebtorTypeaheadMsg', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$HideDeleteConfirmation = {$: 'HideDeleteConfirmation'};
var $author$project$Components$ClientDebtorConfigurationManager$subscriptions = function (model) {
	var keyboardSub = function () {
		var _v0 = model.confirmDeleteConfigId;
		if (_v0.$ === 'Just') {
			return $elm$browser$Browser$Events$onKeyDown(
				A2(
					$elm$json$Json$Decode$andThen,
					function (key) {
						return (key === 'Escape') ? $elm$json$Json$Decode$succeed($author$project$Components$ClientDebtorConfigurationManager$HideDeleteConfirmation) : $elm$json$Json$Decode$fail('Not Escape');
					},
					A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
		} else {
			return $elm$core$Platform$Sub$none;
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$ClientDebtorConfigurationManager$DebtorTypeaheadMsg,
				$author$project$Components$DebtorTypeahead$subscriptions(model.debtorTypeahead)),
				keyboardSub
			]));
};
var $author$project$Components$SettingsPage$CarrierLayout$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (form) {
						return $elm$core$Platform$Sub$batch(
							A2(
								$elm$core$List$map,
								function (_v0) {
									var dropdown = _v0.dropdown;
									var feature = _v0.feature;
									return A2(
										$elm$core$Platform$Sub$map,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$SettingsPage$CarrierLayout$FormMsg,
											$author$project$Components$SettingsPage$CarrierLayout$UpdateFeature(feature.id)),
										$author$project$Ui$V3$CustomSelect$subscriptions(dropdown));
								},
								form.featureOverrides));
					},
					model.form)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$SettingsPage$CarrierLayout$CustomerTypeaheadMsgV3Reskin),
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$TmsCustomerDropdown$subscriptions,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.typeaheadV3Reskin;
							},
							model.externalLoginForm)))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$SettingsPage$CarrierLayout$ClientDebtorConfigManagerMsg,
				$author$project$Components$ClientDebtorConfigurationManager$subscriptions(model.clientDebtorConfigManager))
			]));
};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$TmsReferenceFieldsMsg = function (a) {
	return {$: 'TmsReferenceFieldsMsg', a: a};
};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$Resized = {$: 'Resized'};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$elm$browser$Browser$Events$onResize(
			F2(
				function (_v0, _v1) {
					return $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$Resized;
				})),
			$elm$browser$Browser$Events$onVisibilityChange(
			function (_v2) {
				return $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$Resized;
			})
		]));
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$subscriptions = A2($elm$core$Platform$Sub$map, $author$project$Components$SettingsPage$ReferenceFieldsLayout$TmsReferenceFieldsMsg, $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$subscriptions);
var $author$project$Factoring$Page$ClientSubmissionInvoice$AddNewFactorInvoice = function (a) {
	return {$: 'AddNewFactorInvoice', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$DebtorWithAddressTypeaheadMsg = function (a) {
	return {$: 'DebtorWithAddressTypeaheadMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$GetNewVerification = function (a) {
	return {$: 'GetNewVerification', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$NoOp = {$: 'NoOp'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$PresenceMsg = function (a) {
	return {$: 'PresenceMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$SetShift = function (a) {
	return {$: 'SetShift', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$SubmissionDropdownMsg = function (a) {
	return {$: 'SubmissionDropdownMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$ifShiftKey = F3(
	function (whenTrue, whenFalse, key) {
		return _Utils_eq(
			key,
			$elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Shift)) ? whenTrue : whenFalse;
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$DocumentKeyDown = function (a) {
	return {$: 'DocumentKeyDown', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$onDocumentKeyDown = function (json) {
	var result = A2($elm$json$Json$Decode$decodeValue, $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent, json);
	if (result.$ === 'Ok') {
		var keyboardEvent = result.a;
		return $author$project$Factoring$Page$ClientSubmissionInvoice$DocumentKeyDown(keyboardEvent);
	} else {
		return $author$project$Factoring$Page$ClientSubmissionInvoice$NoOp;
	}
};
var $author$project$Js$onDocumentKeyDown = _Platform_incomingPort('onDocumentKeyDown', $elm$json$Json$Decode$value);
var $author$project$Components$DebtorWithAddressTypeahead$subscriptions = $author$project$Typeahead$subscriptions;
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$subscriptions = function (model) {
	return $author$project$Components$PaginatedDropdown$subscriptions(model.dropdown);
};
var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'keyup');
var $ohanhi$keyboard$Keyboard$ups = function (toMsg) {
	return $elm$browser$Browser$Events$onKeyUp(
		A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$subscriptions = F2(
	function (data_, model) {
		if (data_.$ === 'Loaded') {
			var data = data_.a;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($author$project$Presence$subscriptions, $author$project$Factoring$Page$ClientSubmissionInvoice$PresenceMsg, model.presence),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$Factoring$Page$ClientSubmissionInvoice$SubmissionDropdownMsg,
						$author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$subscriptions(model.submissionDropdown)),
						model.holdingShift ? $ohanhi$keyboard$Keyboard$ups(
						A2(
							$elm$core$Basics$composeR,
							$ohanhi$keyboard$Keyboard$modifierKey,
							A2(
								$author$project$Factoring$Page$ClientSubmissionInvoice$ifShiftKey,
								$author$project$Factoring$Page$ClientSubmissionInvoice$SetShift(false),
								$author$project$Factoring$Page$ClientSubmissionInvoice$NoOp))) : $ohanhi$keyboard$Keyboard$downs(
						A2(
							$elm$core$Basics$composeR,
							$ohanhi$keyboard$Keyboard$modifierKey,
							A2(
								$author$project$Factoring$Page$ClientSubmissionInvoice$ifShiftKey,
								$author$project$Factoring$Page$ClientSubmissionInvoice$SetShift(true),
								$author$project$Factoring$Page$ClientSubmissionInvoice$NoOp))),
						$author$project$Js$onDocumentKeyDown($author$project$Factoring$Page$ClientSubmissionInvoice$onDocumentKeyDown),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$Factoring$Page$ClientSubmissionInvoice$DebtorWithAddressTypeaheadMsg,
						$author$project$Components$DebtorWithAddressTypeahead$subscriptions(model.debtorWithAddressTypeahead)),
						function () {
						var _v1 = $elm$core$Result$toMaybe(data.submission);
						if (_v1.$ === 'Nothing') {
							return $elm$core$Platform$Sub$none;
						} else {
							var invoice = _v1.a.invoice;
							return (invoice.readonly || (!_Utils_eq(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.state;
									},
									invoice.verification),
								$elm$core$Maybe$Just(
									$author$project$AuditPb$Verification_State_Pending(
										{}))))) ? $elm$core$Platform$Sub$none : A2(
								$elm$time$Time$every,
								2000,
								function (_v2) {
									return $author$project$Factoring$Page$ClientSubmissionInvoice$GetNewVerification(invoice.id);
								});
						}
					}(),
						$author$project$Js$onFactorInvoiceCreated(
						A2($elm$core$Basics$composeL, $author$project$Factoring$Page$ClientSubmissionInvoice$AddNewFactorInvoice, $author$project$Domain$FactorInvoiceId$fromInt))
					]));
		} else {
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Factoring$Page$ClientSubmissionInvoice$SubmissionDropdownMsg,
				$author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$subscriptions(model.submissionDropdown));
		}
	});
var $author$project$Factoring$Page$ClientSubmissionReview$PresenceMsg = function (a) {
	return {$: 'PresenceMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$subscriptions = F2(
	function (_v0, model) {
		return A2($author$project$Presence$subscriptions, $author$project$Factoring$Page$ClientSubmissionReview$PresenceMsg, model.presence);
	});
var $author$project$Factoring$Page$VerificationBatch$CopiedToClipboard = {$: 'CopiedToClipboard'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmationDelivered = function (a) {
	return {$: 'DebtorConfirmationDelivered', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$PresenceMsg = function (a) {
	return {$: 'PresenceMsg', a: a};
};
var $author$project$Js$copiedToClipboard = _Platform_incomingPort('copiedToClipboard', $elm$json$Json$Decode$string);
var $author$project$Js$onDebtorConfirmationDelivered = _Platform_incomingPort('onDebtorConfirmationDelivered', $elm$json$Json$Decode$int);
var $author$project$Factoring$Page$VerificationBatch$subscriptions = F2(
	function (_v0, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2($author$project$Presence$subscriptions, $author$project$Factoring$Page$VerificationBatch$PresenceMsg, model.presence),
					$author$project$Js$copiedToClipboard(
					function (_v1) {
						return $author$project$Factoring$Page$VerificationBatch$CopiedToClipboard;
					}),
					$author$project$Js$onDebtorConfirmationDelivered($author$project$Factoring$Page$VerificationBatch$DebtorConfirmationDelivered)
				]));
	});
var $author$project$Main$pageSubscriptions = function (remoteData) {
	switch (remoteData.$) {
		case 'BlankPageData':
			return $elm$core$Platform$Sub$none;
		case 'LoadingPageData':
			return $elm$core$Platform$Sub$none;
		case 'LoadingFailedPageData':
			return $elm$core$Platform$Sub$none;
		case 'ActivityPageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$ActivityPageMsg,
				$author$project$Components$ActivityPage$subscriptions(page));
		case 'BrokerBillingRequirementsPageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$BrokerBillingRequirementsPageMsg,
				$author$project$Broker$Page$BillingRequirements$subscriptions(page));
		case 'ClientSubmissionInvoicePageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$ClientSubmissionInvoicePageMsg,
				A2($author$project$Factoring$Page$ClientSubmissionInvoice$subscriptions, pageData, page));
		case 'ClientSubmissionPageData':
			return $elm$core$Platform$Sub$none;
		case 'ClientSubmissionReviewPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$ClientSubmissionReviewPageMsg,
				A2($author$project$Factoring$Page$ClientSubmissionReview$subscriptions, pageData, page));
		case 'DashboardPageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$DashboardPageMsg,
				$author$project$Components$DashboardPage$subscriptions(page));
		case 'DocumentsViewerPopoutPageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$DocumentsViewerPopoutPageMsg,
				$author$project$Broker$Page$DocumentsViewerPopout$subscriptions(page));
		case 'EmailMessageSearchPageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$EmailMessageSearchPageMsg,
				$author$project$Components$EmailMessageSearchPage$subscriptions(page));
		case 'HelpPageData':
			return $elm$core$Platform$Sub$none;
		case 'NonInvoiceConfirmPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$NonInvoiceConfirmPageMsg,
				A2($author$project$Components$NonInvoiceConfirmPage$subscriptions, pageData, page));
		case 'OktaLoginPageData':
			return A2($elm$core$Platform$Sub$map, $author$project$Main$OktaLoginPageMsg, $author$project$Components$OktaLoginPage$subscriptions);
		case 'SettingsCarrierPageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$SettingsCarrierPageMsg,
				$author$project$Components$SettingsPage$CarrierLayout$subscriptions(page));
		case 'SettingsCarriersPageData':
			return $elm$core$Platform$Sub$none;
		case 'SettingsCustomerPageData':
			return $elm$core$Platform$Sub$none;
		case 'SettingsCustomersPageData':
			return $elm$core$Platform$Sub$none;
		case 'SettingsDebtorPageData':
			return $elm$core$Platform$Sub$none;
		case 'SettingsPageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$SettingsPageMsg,
				$author$project$Components$SettingsPage$subscriptions(page));
		case 'SettingsReferenceFieldsPageData':
			return A2($elm$core$Platform$Sub$map, $author$project$Main$SettingsReferenceFieldsPageMsg, $author$project$Components$SettingsPage$ReferenceFieldsLayout$subscriptions);
		case 'SettingsReportsPageData':
			return $elm$core$Platform$Sub$none;
		case 'SettingsRulesPageData':
			return $elm$core$Platform$Sub$none;
		case 'SettingsUserPageData':
			return $elm$core$Platform$Sub$none;
		case 'SettingsUsersPageData':
			return $elm$core$Platform$Sub$none;
		case 'SettingsVerificationsPageData':
			return $elm$core$Platform$Sub$none;
		case 'TermsPageData':
			return $elm$core$Platform$Sub$none;
		case 'VerificationBatchPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$VerificationBatchPageMsg,
				A2($author$project$Factoring$Page$VerificationBatch$subscriptions, pageData, page));
		case 'LtlReconcileInvoicePageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$LtlReconcileInvoicePageMsg,
				$author$project$Components$LtlReconcileInvoicePage$subscriptions(page));
		case 'CarrierInvoiceAuditPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$CarrierInvoiceAuditPageMsg,
				A2($author$project$Components$CarrierInvoiceAuditPage$subscriptions, pageData, page));
		case 'FactorInvoiceAuditPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$FactorInvoiceAuditPageMsg,
				A2($author$project$Components$FactorInvoiceAuditPage$subscriptions, pageData, page));
		case 'FactorInvoiceAuditBatchGroupingPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$elm$core$Basics$never,
				A2($author$project$Components$FactorInvoiceAuditBatchGroupingPage$subscriptions, pageData, page));
		case 'FactorInvoiceAuditBatchPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$FactorInvoiceAuditBatchPageMsg,
				A2($author$project$Components$FactorInvoiceAuditBatchPage$subscriptions, pageData, page));
		case 'ForwardingHasMovedPageData':
			return $elm$core$Platform$Sub$none;
		case 'MyClientsOverviewPageData':
			return $elm$core$Platform$Sub$none;
		case 'NoaManagementToSendPageData':
			return $elm$core$Platform$Sub$none;
		case 'DebtorChangesPageData':
			return $elm$core$Platform$Sub$none;
		case 'DebtorChangesTemplatePageData':
			return $elm$core$Platform$Sub$none;
		case 'NoaManagementSentPageData':
			var page = remoteData.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$NoaManagementSentPageMsg,
				$author$project$Components$NoaManagement$SentPage$subscriptions(page));
		case 'NoaManagementSkippedPageData':
			return $elm$core$Platform$Sub$none;
		case 'LtlHeldSubmissionsPageData':
			return A2($elm$core$Platform$Sub$map, $author$project$Main$LtlHeldSubmissionsPageMsg, $author$project$Components$LtlHeldSubmissionsPage$subscriptions);
		case 'DocumentReviewPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$DocumentReviewPageMsg,
				A2($author$project$Components$DocumentReviewPage$subscriptions, pageData, page));
		case 'DocumentBatchReviewPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$DocumentBatchReviewPageMsg,
				A2($author$project$Components$DocumentBatchReviewPage$subscriptions, pageData, page));
		case 'DocumentGroupReviewPageData':
			var page = remoteData.a;
			var pageData = remoteData.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$DocumentGroupReviewPageMsg,
				A2($author$project$Components$DocumentGroupReviewPage$subscriptions, pageData, page));
		case 'EmailMergePageData':
			return $elm$core$Platform$Sub$none;
		case 'ReadonlyFactorInvoicePageData':
			return $elm$core$Platform$Sub$none;
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Flash$MessageReceived = function (a) {
	return {$: 'MessageReceived', a: a};
};
var $author$project$Components$Flash$flashFromJavascript = _Platform_incomingPort(
	'flashFromJavascript',
	A2(
		$elm$json$Json$Decode$andThen,
		function (title) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (time) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (position) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (message) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (level) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (indefinite) {
													return $elm$json$Json$Decode$succeed(
														{indefinite: indefinite, level: level, message: message, position: position, time: time, title: title});
												},
												A2($elm$json$Json$Decode$field, 'indefinite', $elm$json$Json$Decode$bool));
										},
										A2($elm$json$Json$Decode$field, 'level', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'position', $elm$json$Json$Decode$string));
				},
				A2(
					$elm$json$Json$Decode$field,
					'time',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$float)
							]))));
		},
		A2(
			$elm$json$Json$Decode$field,
			'title',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
					])))));
var $author$project$Components$Flash$HideOld = function (a) {
	return {$: 'HideOld', a: a};
};
var $elm$core$Array$filter = F2(
	function (isGood, array) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$Array$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				array));
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Components$Flash$hideOldItems = function (model) {
	var timedMessages = A2(
		$elm$core$Array$filter,
		function (m) {
			return (!m.indefinite) || (($elm$time$Time$posixToMillis(
				A2(
					$elm$core$Maybe$withDefault,
					$elm$time$Time$millisToPosix(0),
					model.currentTime)) - A2($elm$core$Maybe$withDefault, 0, m.time)) < 1000);
		},
		model.messages);
	return ($elm$core$Array$length(timedMessages) > 0) ? A2($elm$time$Time$every, 100, $author$project$Components$Flash$HideOld) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Flash$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Components$Flash$flashFromJavascript($author$project$Components$Flash$MessageReceived),
				$author$project$Components$Flash$hideOldItems(model)
			]));
};
var $author$project$Js$updateHeaderFlags = _Platform_incomingPort(
	'updateHeaderFlags',
	A2(
		$elm$json$Json$Decode$andThen,
		function (useSubmissionWorkflow) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (showNavBar) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (reskinVals) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (reskinUserToggle) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (isFactor) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (headerRightPages) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (headerDropdownPages) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (hasSettingsRole) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (dashboardLinkLocation) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (accounts) {
																					return $elm$json$Json$Decode$succeed(
																						{accounts: accounts, dashboardLinkLocation: dashboardLinkLocation, hasSettingsRole: hasSettingsRole, headerDropdownPages: headerDropdownPages, headerRightPages: headerRightPages, isFactor: isFactor, reskinUserToggle: reskinUserToggle, reskinVals: reskinVals, showNavBar: showNavBar, useSubmissionWorkflow: useSubmissionWorkflow});
																				},
																				A2(
																					$elm$json$Json$Decode$field,
																					'accounts',
																					$elm$json$Json$Decode$list(
																						A2(
																							$elm$json$Json$Decode$andThen,
																							function (name) {
																								return A2(
																									$elm$json$Json$Decode$andThen,
																									function (isCurrent) {
																										return A2(
																											$elm$json$Json$Decode$andThen,
																											function (id) {
																												return $elm$json$Json$Decode$succeed(
																													{id: id, isCurrent: isCurrent, name: name});
																											},
																											A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int));
																									},
																									A2($elm$json$Json$Decode$field, 'isCurrent', $elm$json$Json$Decode$bool));
																							},
																							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)))));
																		},
																		A2($elm$json$Json$Decode$field, 'dashboardLinkLocation', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'hasSettingsRole', $elm$json$Json$Decode$bool));
														},
														A2(
															$elm$json$Json$Decode$field,
															'headerDropdownPages',
															A2(
																$elm$json$Json$Decode$andThen,
																function (receivables) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (payables) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (noaManagement) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (ltlDocRetrieval) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (insights) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (customerRep) {
																											return $elm$json$Json$Decode$succeed(
																												{customerRep: customerRep, insights: insights, ltlDocRetrieval: ltlDocRetrieval, noaManagement: noaManagement, payables: payables, receivables: receivables});
																										},
																										A2($elm$json$Json$Decode$field, 'customerRep', $elm$json$Json$Decode$bool));
																								},
																								A2($elm$json$Json$Decode$field, 'insights', $elm$json$Json$Decode$bool));
																						},
																						A2($elm$json$Json$Decode$field, 'ltlDocRetrieval', $elm$json$Json$Decode$bool));
																				},
																				A2($elm$json$Json$Decode$field, 'noaManagement', $elm$json$Json$Decode$bool));
																		},
																		A2($elm$json$Json$Decode$field, 'payables', $elm$json$Json$Decode$bool));
																},
																A2($elm$json$Json$Decode$field, 'receivables', $elm$json$Json$Decode$bool))));
												},
												A2(
													$elm$json$Json$Decode$field,
													'headerRightPages',
													$elm$json$Json$Decode$list(
														A2(
															$elm$json$Json$Decode$andThen,
															function (url) {
																return A2(
																	$elm$json$Json$Decode$andThen,
																	function (title) {
																		return A2(
																			$elm$json$Json$Decode$andThen,
																			function (possibleLocationRegexes) {
																				return $elm$json$Json$Decode$succeed(
																					{possibleLocationRegexes: possibleLocationRegexes, title: title, url: url});
																			},
																			A2(
																				$elm$json$Json$Decode$field,
																				'possibleLocationRegexes',
																				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
																	},
																	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string));
															},
															A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string)))));
										},
										A2($elm$json$Json$Decode$field, 'isFactor', $elm$json$Json$Decode$bool));
								},
								A2(
									$elm$json$Json$Decode$field,
									'reskinUserToggle',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)
											]))));
						},
						A2(
							$elm$json$Json$Decode$field,
							'reskinVals',
							A2(
								$elm$json$Json$Decode$andThen,
								function (topLevel) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (settings) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (queues) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (indexAudit) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (everything) {
																	return $elm$json$Json$Decode$succeed(
																		{everything: everything, indexAudit: indexAudit, queues: queues, settings: settings, topLevel: topLevel});
																},
																A2($elm$json$Json$Decode$field, 'everything', $elm$json$Json$Decode$bool));
														},
														A2($elm$json$Json$Decode$field, 'indexAudit', $elm$json$Json$Decode$bool));
												},
												A2($elm$json$Json$Decode$field, 'queues', $elm$json$Json$Decode$bool));
										},
										A2($elm$json$Json$Decode$field, 'settings', $elm$json$Json$Decode$bool));
								},
								A2($elm$json$Json$Decode$field, 'topLevel', $elm$json$Json$Decode$bool))));
				},
				A2($elm$json$Json$Decode$field, 'showNavBar', $elm$json$Json$Decode$bool));
		},
		A2($elm$json$Json$Decode$field, 'useSubmissionWorkflow', $elm$json$Json$Decode$bool)));
var $author$project$Main$subscriptions = F2(
	function (remoteData, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$FlashComponentMsg,
					$author$project$Components$Flash$subscriptions(model.flash)),
					$author$project$Js$flashFromJavascriptMaybeV3Reskin($author$project$Main$FlashFromJavascriptMaybeV3Reskin),
					$author$project$Js$beamerMessageCount($author$project$Main$BeamerMessageCount),
					$author$project$Js$updateHeaderFlags($author$project$Main$UpdateHeaderFlags),
					function () {
					switch (remoteData.$) {
						case 'Loaded':
							var pageData = remoteData.a;
							return A2(
								$elm$core$Platform$Sub$map,
								$author$project$Main$PageMsg,
								$author$project$Main$pageSubscriptions(pageData));
						case 'Loading':
							return $elm$core$Platform$Sub$none;
						default:
							return $elm$core$Platform$Sub$none;
					}
				}(),
					model.headerFlags.reskinVals.topLevel ? $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$elm$browser$Browser$Events$onResize(
							F2(
								function (_v1, _v2) {
									return $author$project$Main$ViewportChanged;
								})),
							$elm$browser$Browser$Events$onVisibilityChange(
							function (_v3) {
								return $author$project$Main$ViewportChanged;
							})
						])) : $elm$core$Platform$Sub$none
				]));
	});
var $author$project$Main$ActivityPage = function (a) {
	return {$: 'ActivityPage', a: a};
};
var $author$project$Main$DashboardPage = function (a) {
	return {$: 'DashboardPage', a: a};
};
var $author$project$Main$DocumentsViewerPopoutPage = function (a) {
	return {$: 'DocumentsViewerPopoutPage', a: a};
};
var $author$project$Main$FactorInvoiceAuditBatchPage = function (a) {
	return {$: 'FactorInvoiceAuditBatchPage', a: a};
};
var $author$project$Main$FactorInvoiceAuditPage = function (a) {
	return {$: 'FactorInvoiceAuditPage', a: a};
};
var $author$project$Main$GotSearchItems = function (a) {
	return {$: 'GotSearchItems', a: a};
};
var $author$project$Main$HeaderMsg = function (a) {
	return {$: 'HeaderMsg', a: a};
};
var $author$project$Main$LoadingFailedPage = function (a) {
	return {$: 'LoadingFailedPage', a: a};
};
var $author$project$Main$LtlHeldSubmissionsPage = function (a) {
	return {$: 'LtlHeldSubmissionsPage', a: a};
};
var $author$project$Main$LtlReconcileInvoicePage = function (a) {
	return {$: 'LtlReconcileInvoicePage', a: a};
};
var $author$project$Main$NoaManagementSentPage = function (a) {
	return {$: 'NoaManagementSentPage', a: a};
};
var $author$project$Main$NonInvoiceConfirmPage = function (a) {
	return {$: 'NonInvoiceConfirmPage', a: a};
};
var $author$project$Main$ReadonlyFactorInvoicePage = function (a) {
	return {$: 'ReadonlyFactorInvoicePage', a: a};
};
var $author$project$Main$ReadonlyFactorInvoicePageMsg = function (a) {
	return {$: 'ReadonlyFactorInvoicePageMsg', a: a};
};
var $author$project$Domain$LoadSearch$LoadSearch = F2(
	function (loads, tmsShipments) {
		return {loads: loads, tmsShipments: tmsShipments};
	});
var $author$project$Domain$LoadSearch$TmsShipment = F2(
	function (id, externalId) {
		return {externalId: externalId, id: id};
	});
var $author$project$Domain$LoadSearch$tmsShipmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$author$project$Domain$TmsShipmentId$decode,
		$elm$json$Json$Decode$succeed($author$project$Domain$LoadSearch$TmsShipment)));
var $author$project$Domain$LoadSearch$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tms_shipments',
	$elm$json$Json$Decode$list($author$project$Domain$LoadSearch$tmsShipmentDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'loads',
		$elm$json$Json$Decode$list($author$project$Domain$LoadSearch$loadStateDecoder),
		$elm$json$Json$Decode$succeed($author$project$Domain$LoadSearch$LoadSearch)));
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.statusCode));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $author$project$Js$flashToJavascriptLegacy = _Platform_outgoingPort(
	'flashToJavascriptLegacy',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'indefinite',
					$elm$json$Json$Encode$bool($.indefinite)),
					_Utils_Tuple2(
					'level',
					$elm$json$Json$Encode$string($.level)),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.message)),
					_Utils_Tuple2(
					'position',
					$elm$json$Json$Encode$string($.position)),
					_Utils_Tuple2(
					'time',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$float, $);
					}($.time)),
					_Utils_Tuple2(
					'title',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.title))
				]));
	});
var $author$project$Js$flashToJavascriptV3Reskin = _Platform_outgoingPort(
	'flashToJavascriptV3Reskin',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'indefinite',
					$elm$json$Json$Encode$bool($.indefinite)),
					_Utils_Tuple2(
					'level',
					$elm$json$Json$Encode$string($.level)),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.message)),
					_Utils_Tuple2(
					'position',
					$elm$json$Json$Encode$string($.position)),
					_Utils_Tuple2(
					'time',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$float, $);
					}($.time)),
					_Utils_Tuple2(
					'title',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.title))
				]));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 'Request', a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {reqs: reqs, subs: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (cmd.$ === 'Cancel') {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 'Nothing') {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.tracker;
							if (_v4.$ === 'Nothing') {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.reqs));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.subs)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 'Cancel', a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (cmd.$ === 'Cancel') {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
					body: r.body,
					expect: A2(_Http_mapExpect, func, r.expect),
					headers: r.headers,
					method: r.method,
					timeout: r.timeout,
					tracker: r.tracker,
					url: r.url
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 'MySub', a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{allowCookiesFromOtherDomains: false, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{body: $elm$http$Http$emptyBody, expect: r.expect, headers: _List_Nil, method: 'GET', timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $author$project$Path$onDoneQuery = function (maybeOnDone) {
	if (maybeOnDone.$ === 'Just') {
		var onDone = maybeOnDone.a;
		return $elm$core$String$isEmpty(onDone) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				'onDone',
				$elm$url$Url$percentEncode(onDone))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Main$indexerFallbackUrl = F2(
	function (documentBatchId, maybeOnDone) {
		return $author$project$Path$toString(
			A2(
				$author$project$Path$addQueries,
				$author$project$Path$onDoneQuery(maybeOnDone),
				A2(
					$author$project$Path$documentBatch,
					documentBatchId,
					{isReadonly: false, useFactorInvoiceWorkflowPage: false})));
	});
var $author$project$Components$DocumentsBrowser$DefaultViewModeHeight = {$: 'DefaultViewModeHeight'};
var $author$project$Components$DocumentsBrowser$AnnotateDocumentAction = {$: 'AnnotateDocumentAction'};
var $author$project$Components$DocumentsBrowser$DuplicateAction = {$: 'DuplicateAction'};
var $author$project$Components$DocumentsBrowser$EditMessageAction = {$: 'EditMessageAction'};
var $author$project$Components$DocumentsBrowser$MergeToPreviousAction = {$: 'MergeToPreviousAction'};
var $author$project$Components$DocumentsBrowser$SplitFromDocumentAction = {$: 'SplitFromDocumentAction'};
var $author$project$Components$DocumentsBrowser$UpdatePodAction = {$: 'UpdatePodAction'};
var $author$project$Components$DocumentsBrowser$allNonDocumentTypeToolbarActionsEnabled = _List_fromArray(
	[$author$project$Components$DocumentsBrowser$RotateAction, $author$project$Components$DocumentsBrowser$DuplicateAction, $author$project$Components$DocumentsBrowser$SplitFromDocumentAction, $author$project$Components$DocumentsBrowser$MergeToPreviousAction, $author$project$Components$DocumentsBrowser$UpdatePodAction, $author$project$Components$DocumentsBrowser$AnnotateDocumentAction, $author$project$Components$DocumentsBrowser$EditMessageAction]);
var $author$project$Broker$Shared$CurrentProcessingSelection$NoSelection = {$: 'NoSelection'};
var $author$project$Broker$Shared$CurrentProcessingSelection$noSelection = $author$project$Broker$Shared$CurrentProcessingSelection$NoSelection;
var $author$project$Js$setupHoveredTextFromMainPageUpdates = _Platform_outgoingPort(
	'setupHoveredTextFromMainPageUpdates',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Broker$Page$DocumentsViewerPopout$init = function (initData) {
	var _v0 = $author$project$Components$DocumentsBrowser$init(
		{
			currentProcessingSelection: $author$project$Broker$Shared$CurrentProcessingSelection$noSelection,
			displayUnassignedLoadDocuments: initData.accountSettings.showAllLoadDocsEnabled,
			enabledDocumentTypes: _List_Nil,
			enabledToolbarActions: $author$project$Components$DocumentsBrowser$allNonDocumentTypeToolbarActionsEnabled,
			maybeDefaultViewMode: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$DefaultViewModeHeight),
			maybeOnDone: $elm$core$Maybe$Nothing,
			pageContextData: $author$project$Helpers$DocumentViewerPageContextData$empty,
			popout: true,
			scrollContainerSuffix: 'primary',
			viewPortHeightPxOffset: 0
		});
	var documentsViewer = _v0.a;
	var documentsViewerEffect = _v0.b;
	return _Utils_Tuple2(
		{documentsViewer: documentsViewer},
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$cmd(
					$author$project$Js$setupCurrentProcessingSelectionUpdates(_Utils_Tuple0)),
					$author$project$HubTran$Effect$cmd(
					$author$project$Js$setupHoveredTextFromMainPageUpdates(_Utils_Tuple0)),
					A2($author$project$HubTran$Effect$map, $author$project$Broker$Page$DocumentsViewerPopout$DocumentsBrowserMsg, documentsViewerEffect)
				])));
};
var $author$project$Components$ActivityBrowser$ActivityItemListView$init = {activityItemViews: $elm$core$Dict$empty};
var $author$project$Components$CustomerTypeahead$init = $author$project$Typeahead$initOpen;
var $author$project$Components$TmsCustomerDropdown$initWithSelected = F2(
	function (items, attrs) {
		var _v0 = $author$project$Components$PaginatedDropdown$init(
			{attrs: attrs, domId: 'customer-name', lastItems: _List_Nil, otherItems: _List_Nil, selectedItems: items});
		var dropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{dropdown: dropdown},
			cmd);
	});
var $author$project$Components$DebtorTypeahead$initWithSelectedFactorBroker = $author$project$Typeahead$initWithSelectedItem;
var $author$project$Components$CustomerTypeahead$initWithTmsCustomer = $author$project$Typeahead$initWithSelectedItem;
var $author$project$Domain$TmsCustomer$customerNameForDisplay = F2(
	function (accountSettings, customer) {
		var maybeExternalId = accountSettings.customerDisplayRequiresExternalId ? (' (' + (customer.externalId + ')')) : '';
		return _Utils_ap(customer.name, maybeExternalId);
	});
var $author$project$Components$TmsCustomerDropdown$tmsCustomerToDropdownItem = F2(
	function (accountSettings, tmsCustomer) {
		var text = A2($author$project$Domain$TmsCustomer$customerNameForDisplay, accountSettings, tmsCustomer);
		return {
			id: $elm$core$String$fromInt(
				$author$project$Domain$TmsCustomerId$toInt(tmsCustomer.id)),
			label: $elm$html$Html$text(text),
			text: text
		};
	});
var $author$project$Components$ActivityBrowser$FiltersView$init = F4(
	function (accountSettings, carrierDropdownInitData, customerDropdownInitData, queryParams) {
		var startDateString = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, queryParams.startDate));
		var endDateString = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, queryParams.endDate));
		var debtorTypeaheadInit = function () {
			var _v4 = queryParams.debtorId;
			if (_v4.$ === 'Nothing') {
				return $author$project$Components$DebtorTypeahead$init;
			} else {
				var debtorId = _v4.a;
				return $author$project$Components$DebtorTypeahead$initWithSelectedFactorBroker(debtorId);
			}
		}();
		var customerTypeaheadInit = function () {
			var _v3 = queryParams.customerId;
			if (_v3.$ === 'Nothing') {
				return $author$project$Components$CustomerTypeahead$init;
			} else {
				var customerId = _v3.a;
				return $author$project$Components$CustomerTypeahead$initWithTmsCustomer(customerId);
			}
		}();
		var carrierTypeaheadInit = function () {
			var _v2 = queryParams.carrierId;
			if (_v2.$ === 'Nothing') {
				return $author$project$Components$CarrierTypeahead$init;
			} else {
				var carrierId = _v2.a;
				return $author$project$Components$CarrierTypeahead$initWithTmsCarrier(carrierId);
			}
		}();
		var _v0 = A2(
			$author$project$Components$TmsCustomerDropdown$initWithSelected,
			A2(
				$elm$core$List$map,
				$author$project$Components$TmsCustomerDropdown$tmsCustomerToDropdownItem(accountSettings),
				customerDropdownInitData.selectedCustomers),
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead)
				]));
		var customerDropdown = _v0.a;
		var customerDropdownCmd = _v0.b;
		var _v1 = A2(
			$author$project$Components$SettingsPage$CarrierDropdown$initWithSelected,
			carrierDropdownInitData.selectedCarriers,
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
					$author$project$Ui$V3$CustomSelect$hideSelectAll(false)
				]));
		var carrierDropdown = _v1.a;
		var carrierDropdownCmd = _v1.b;
		return _Utils_Tuple3(
			{
				carrierDropdown: carrierDropdown,
				carrierTypeahead: carrierTypeaheadInit,
				customerDropdown: customerDropdown,
				customerTypeahead: customerTypeaheadInit,
				debtorTypeahead: debtorTypeaheadInit,
				debtorTypeaheadCarrierId: queryParams.carrierId,
				endDate: queryParams.endDate,
				endDateString: endDateString,
				invoiceNumOrLoadIdString: A2($elm$core$Maybe$withDefault, '', queryParams.invoiceNumOrLoadId),
				selectedActivityType: queryParams.activityType,
				selectedUserId: queryParams.userId,
				startDate: queryParams.startDate,
				startDateString: startDateString
			},
			A2($elm$core$Maybe$withDefault, 0, queryParams.page),
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						A2(
						$author$project$HubTran$Effect$map,
						$author$project$Components$ActivityBrowser$FiltersView$CarrierDropdownMsg,
						$author$project$HubTran$Effect$cmd(carrierDropdownCmd)),
						A2(
						$author$project$HubTran$Effect$map,
						$author$project$Components$ActivityBrowser$FiltersView$CustomerDropdownMsg,
						$author$project$HubTran$Effect$cmd(customerDropdownCmd))
					])));
	});
var $author$project$Components$ActivityPage$init = F2(
	function (initData, queryParams) {
		var _v0 = A4($author$project$Components$ActivityBrowser$FiltersView$init, initData.accountSettings, initData.carrierDropdown, initData.customerDropdown, queryParams);
		var filters = _v0.a;
		var page = _v0.b;
		var filtersCmd = _v0.c;
		return _Utils_Tuple2(
			{activityItemListView: $author$project$Components$ActivityBrowser$ActivityItemListView$init, appliedFilters: filters, filters: filters, maybeLastActivityItemListViewData: $elm$core$Maybe$Nothing, page: page},
			A2($author$project$HubTran$Effect$map, $author$project$Components$ActivityPage$FiltersViewMsg, filtersCmd));
	});
var $author$project$Components$DashboardPage$FlowModeState = F2(
	function (inFlowMode, nextItemIndex) {
		return {inFlowMode: inFlowMode, nextItemIndex: nextItemIndex};
	});
var $author$project$Components$DashboardPage$SetDate = function (a) {
	return {$: 'SetDate', a: a};
};
var $author$project$Components$DashboardPage$SetTimezoneName = function (a) {
	return {$: 'SetTimezoneName', a: a};
};
var $author$project$Components$Dashboard$AvailableQueues$ProcessedQueue = function (a) {
	return {$: 'ProcessedQueue', a: a};
};
var $author$project$Components$Dashboard$AvailableQueues$availableQueues = F2(
	function (dashboardMode, data) {
		var user = data.currentUser;
		var factorIndexingQueues = _List_fromArray(
			[$author$project$Components$Dashboard$AvailableQueues$FactorNeedsIndexingQueue]);
		var exceptionQueues = _List_fromArray(
			[$author$project$Components$Dashboard$AvailableQueues$ExceptionQueue, $author$project$Components$Dashboard$AvailableQueues$RepliesQueue, $author$project$Components$Dashboard$AvailableQueues$WaitingQueue]);
		var defaultQueues = A2($elm$core$List$cons, $author$project$Components$Dashboard$AvailableQueues$NewQueue, exceptionQueues);
		var appendIf = F3(
			function (doAppend, toAppend, queues) {
				return doAppend ? _Utils_ap(
					queues,
					_List_fromArray(
						[toAppend])) : queues;
			});
		var accountSettings = data.accountSettings;
		var bothWorkflowsEnabled = accountSettings.useBothSubmissionAndTraditionalWorkflow && accountSettings.useSubmissionWorkflow;
		var indexAuditSplitEnabled = accountSettings.indexAuditSplitEnabled;
		var verificationAndSubmissionWorkflowEnabled = accountSettings.verificationsWorkflowEnabled && accountSettings.useSubmissionWorkflow;
		var viewFinalTab = function () {
			var accountHasFinalTab = (!accountSettings.useSubmissionWorkflow) || (bothWorkflowsEnabled || verificationAndSubmissionWorkflowEnabled);
			return accountHasFinalTab && (user.isApprover || user.readOnlyFactorInvoices);
		}();
		var _v0 = data.accountType;
		if (_v0.$ === 'BrokerAccount') {
			var appendProcessedQueueIfApproverAndNotAutoApprovePayables = A2(
				appendIf,
				user.isApprover && (!accountSettings.autoApprovePayables),
				$author$project$Components$Dashboard$AvailableQueues$FinalQueue(
					$author$project$Components$Dashboard$AvailableQueues$ProcessedQueue(data.accountType)));
			if (indexAuditSplitEnabled) {
				switch (dashboardMode.$) {
					case 'DashboardModeIndex':
						return defaultQueues;
					case 'DashboardModeAudit':
						return appendProcessedQueueIfApproverAndNotAutoApprovePayables(
							A2($elm$core$List$cons, $author$project$Components$Dashboard$AvailableQueues$ReadyToAuditQueue, exceptionQueues));
					default:
						return appendProcessedQueueIfApproverAndNotAutoApprovePayables(defaultQueues);
				}
			} else {
				return appendProcessedQueueIfApproverAndNotAutoApprovePayables(defaultQueues);
			}
		} else {
			var whichFinalQueue = accountSettings.reviewTabEnabled ? $author$project$Components$Dashboard$AvailableQueues$FinalQueue($author$project$Components$Dashboard$AvailableQueues$ReviewQueue) : $author$project$Components$Dashboard$AvailableQueues$FinalQueue(
				$author$project$Components$Dashboard$AvailableQueues$ProcessedQueue(data.accountType));
			var isVerifier = accountSettings.verificationsWorkflowEnabled && (!user.readOnlyFactorInvoices);
			if (indexAuditSplitEnabled) {
				switch (dashboardMode.$) {
					case 'DashboardModeIndex':
						return factorIndexingQueues;
					case 'DashboardModeAudit':
						return A3(
							appendIf,
							viewFinalTab,
							whichFinalQueue,
							A3(appendIf, isVerifier, $author$project$Components$Dashboard$AvailableQueues$VerifyQueue, defaultQueues));
					default:
						return A3(
							appendIf,
							viewFinalTab,
							whichFinalQueue,
							A3(appendIf, isVerifier, $author$project$Components$Dashboard$AvailableQueues$VerifyQueue, defaultQueues));
				}
			} else {
				return A3(
					appendIf,
					viewFinalTab,
					whichFinalQueue,
					A3(appendIf, isVerifier, $author$project$Components$Dashboard$AvailableQueues$VerifyQueue, defaultQueues));
			}
		}
	});
var $author$project$Components$CarrierDropdown$unknownCarrier = function (carrierTerm) {
	var base = $author$project$Domain$TmsCarrier$unknownCarrier;
	return _Utils_update(
		base,
		{name: 'Unknown ' + carrierTerm});
};
var $author$project$Components$CarrierDropdown$init = function (config) {
	return A2(
		$author$project$Components$CarrierDropdown$initWithLastCarriers,
		_List_fromArray(
			[
				$author$project$Components$CarrierDropdown$unknownCarrier(
				$author$project$Domain$Account$carrierTerm(config.accountType))
			]),
		config);
};
var $author$project$Components$DashboardPage$carrierDropdownAndCmd = F3(
	function (account, accountSettings, carriers) {
		return $author$project$Components$CarrierDropdown$init(
			{
				accountType: $author$project$Domain$Account$accountType(account),
				attrs: _List_Nil,
				isFactor: account.factorAccount,
				selectedCarriers: carriers,
				showVendorId: accountSettings.showCarrierExternalVendorId
			});
	});
var $author$project$Ui$V3$CustomSelect$Clearable = function (a) {
	return {$: 'Clearable', a: a};
};
var $author$project$Ui$V3$CustomSelect$clearable = $author$project$Ui$V3$CustomSelect$Clearable;
var $author$project$Ui$V3$CustomSelect$ExcludableAttribute = function (a) {
	return {$: 'ExcludableAttribute', a: a};
};
var $author$project$Ui$V3$CustomSelect$excludable = $author$project$Ui$V3$CustomSelect$ExcludableAttribute;
var $author$project$Components$DashboardPage$shouldShowCustomerDropdown = F2(
	function (dashboardMode, account) {
		return _Utils_eq(dashboardMode, $author$project$AuditPb$DashboardModeAudit) && _Utils_eq(
			$author$project$Domain$Account$accountType(account),
			$author$project$Domain$Account$BrokerAccount);
	});
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $author$project$Components$DashboardPage$categoryDropdownsAndEffects = F3(
	function (categories, account, dashboardMode) {
		return A3(
			$elm$core$Tuple$mapBoth,
			$elm$core$Dict$fromList,
			$author$project$HubTran$Effect$batch,
			$elm$core$List$unzip(
				A2(
					$elm$core$List$filterMap,
					function (selectableCategoryFilter) {
						var labelToItem = function (str) {
							return $author$project$Ui$V3$CustomSelect$simpleItem(
								{id: str, label: str});
						};
						var extraLabels = _List_fromArray(
							['<None>']);
						var _v0 = _Utils_Tuple2(
							_Utils_Tuple2(selectableCategoryFilter.category.name, selectableCategoryFilter.category.labels),
							_Utils_Tuple2(
								$elm$core$Set$toList(selectableCategoryFilter.selected),
								$elm$core$Set$toList(selectableCategoryFilter.excluded)));
						var _v1 = _v0.a;
						var categoryName = _v1.a;
						var all = _v1.b;
						var _v2 = _v0.b;
						var selected = _v2.a;
						var excluded = _v2.b;
						var shouldHide = $elm$core$List$isEmpty(all) || ((categoryName === 'Customers') && A2($author$project$Components$DashboardPage$shouldShowCustomerDropdown, dashboardMode, account));
						var _v3 = A2(
							$author$project$Ui$V3$CustomSelect$init,
							{
								domId: categoryName,
								excludedItems: A2($elm$core$List$map, labelToItem, excluded),
								items: A2(
									$elm$core$List$map,
									labelToItem,
									_Utils_ap(all, extraLabels)),
								selectedItems: A2($elm$core$List$map, labelToItem, selected)
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$multiSelectTypeahead),
									$author$project$Ui$V3$CustomSelect$filterable(true),
									$author$project$Ui$V3$CustomSelect$clearable(true),
									$author$project$Ui$V3$CustomSelect$excludable(true)
								]));
						var dropdown = _v3.a;
						var cmd = _v3.b;
						return shouldHide ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							_Utils_Tuple2(
								_Utils_Tuple2(selectableCategoryFilter.category.name, dropdown),
								$author$project$HubTran$Effect$cmd(
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Components$DashboardPage$CategoryDropdownMsg(categoryName),
										cmd))));
					},
					categories)));
	});
var $author$project$Components$DashboardSavedFilterEditModal$closed = {dashboardSavedFilters: _List_Nil, editingFilter: $elm$core$Maybe$Nothing, isOpen: false, isSaving: false, onSaveErrorMessage: ''};
var $author$project$Components$DashboardSavedFilterSaveModal$closed = {errorMessage: '', filter: $elm$core$Maybe$Nothing, isOpen: false, isSaving: false, name: ''};
var $author$project$Domain$Customer$toStringKey = function (customer) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$author$project$Domain$Customer$encode(customer));
};
var $author$project$Components$CustomerDropdown$customerToDropdownItem = function (customer) {
	var text = function () {
		var _v0 = customer.externalId;
		if (_v0.$ === 'Just') {
			var externalId = _v0.a;
			return customer.name + (' (' + (externalId + ')'));
		} else {
			return customer.name;
		}
	}();
	return {
		id: $author$project$Domain$Customer$toStringKey(customer),
		label: $elm$html$Html$text(text),
		text: text
	};
};
var $author$project$Domain$Customer$fromCustomerLabel = function (name) {
	return {externalId: $elm$core$Maybe$Nothing, name: name};
};
var $author$project$Components$CustomerDropdown$init = function (_v0) {
	var selected = _v0.selected;
	var customerLabels = _v0.customerLabels;
	var _v1 = $author$project$Components$PaginatedDropdown$init(
		{
			attrs: _List_Nil,
			domId: 'customer',
			lastItems: _List_Nil,
			otherItems: A2(
				$elm$core$List$map,
				$author$project$Components$CustomerDropdown$customerToDropdownItem,
				A2($elm$core$List$map, $author$project$Domain$Customer$fromCustomerLabel, customerLabels)),
			selectedItems: A2($elm$core$List$map, $author$project$Components$CustomerDropdown$customerToDropdownItem, selected)
		});
	var dropdown = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		{dropdown: dropdown},
		cmd);
};
var $author$project$Components$DashboardPage$customerDropdownAndCmd = F2(
	function (accountSettings, validatedFilters) {
		return $author$project$Components$CustomerDropdown$init(
			{
				customerLabels: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.labels;
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (category) {
								return category.name === 'Customers';
							},
							accountSettings.categories))),
				selected: validatedFilters.customers
			});
	});
var $author$project$Components$DashboardPage$debtorDropdownAndCmd = function (factorBrokers) {
	return $author$project$Components$DebtorDropdown$init(
		{attrs: _List_Nil, selected: factorBrokers});
};
var $author$project$Components$Dashboard$AvailableQueues$defaultQueue = F2(
	function (dashboardMode, accountType) {
		switch (dashboardMode.$) {
			case 'DashboardModeAll':
				return $author$project$Components$Dashboard$AvailableQueues$NewQueue;
			case 'DashboardModeIndex':
				return _Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) ? $author$project$Components$Dashboard$AvailableQueues$NewQueue : $author$project$Components$Dashboard$AvailableQueues$FactorNeedsIndexingQueue;
			default:
				return _Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) ? $author$project$Components$Dashboard$AvailableQueues$ReadyToAuditQueue : $author$project$Components$Dashboard$AvailableQueues$NewQueue;
		}
	});
var $author$project$Id$Dict$Dict = function (a) {
	return {$: 'Dict', a: a};
};
var $author$project$Id$Dict$empty = $author$project$Id$Dict$Dict($elm$core$Dict$empty);
var $author$project$DashboardPresence$empty = {carriersPresent: _List_Nil, pathsByDocumentBatchId: $author$project$Id$Dict$empty, pathsByEmailMessageId: $author$project$Id$Dict$empty, presenceByPath: $elm$core$Dict$empty, receivedData: false};
var $author$project$Components$Dashboard$Review$Model$Approve = {$: 'Approve'};
var $author$project$Components$Dashboard$Review$Model$SendingState = F3(
	function (isSending, isRejecting, isVerifying) {
		return {isRejecting: isRejecting, isSending: isSending, isVerifying: isVerifying};
	});
var $author$project$Domain$VerificationsDebtorBatchItem$customStateSkipped = {id: 'skipped', name: 'Skipped', selectable: false, state: $author$project$AuditPb$VerificationsDebtorBatchItemStateSkipped};
var $author$project$Id$MaybeSet$MaybeSet = function (a) {
	return {$: 'MaybeSet', a: a};
};
var $author$project$Id$MaybeSet$empty = $author$project$Id$MaybeSet$MaybeSet($elm$core$Set$empty);
var $author$project$Id$Set$Set = function (a) {
	return {$: 'Set', a: a};
};
var $author$project$Id$Set$empty = $author$project$Id$Set$Set($elm$core$Set$empty);
var $author$project$Components$Dashboard$Review$Model$emptyModel = {
	clientGroupExceptionsExpanded: $author$project$Id$MaybeSet$empty,
	expandedTmsCarrierIds: $author$project$Id$MaybeSet$empty,
	selectedCustomState: $author$project$Domain$VerificationsDebtorBatchItem$customStateSkipped,
	selectedFactorInvoiceIds: $author$project$Sanitized$raw($author$project$Id$Set$empty),
	sendingState: A3($author$project$Components$Dashboard$Review$Model$SendingState, false, false, false),
	verifyMode: $author$project$Components$Dashboard$Review$Model$Approve
};
var $author$project$Components$DashboardPage$GotTableElement = function (a) {
	return {$: 'GotTableElement', a: a};
};
var $author$project$Components$Dashboard$Pager$View$tableId = 'queues-table';
var $author$project$Components$DashboardPage$getTableElementEffect = $author$project$HubTran$Effect$cmd(
	A2(
		$elm$core$Task$attempt,
		$author$project$Components$DashboardPage$GotTableElement,
		$elm$browser$Browser$Dom$getElement($author$project$Components$Dashboard$Pager$View$tableId)));
var $author$project$Domain$DashboardMode$dashboardModeOverride = F2(
	function (accountSettings, user) {
		return $author$project$Sanitized$sanitize(
			function (dashboardMode) {
				if (accountSettings.indexAuditSplitEnabled) {
					if ((user.isIndexer && user.isAuditor) || user.isAdmin) {
						switch (dashboardMode.$) {
							case 'DashboardModeAll':
								return $author$project$AuditPb$DashboardModeIndex;
							case 'DashboardModeIndex':
								return dashboardMode;
							default:
								return dashboardMode;
						}
					} else {
						if (user.isIndexer) {
							return $author$project$AuditPb$DashboardModeIndex;
						} else {
							if (user.isAuditor) {
								return $author$project$AuditPb$DashboardModeAudit;
							} else {
								return dashboardMode;
							}
						}
					}
				} else {
					return $author$project$AuditPb$DashboardModeAll;
				}
			});
	});
var $author$project$Domain$CategoryFilter$fromPb = function (categoryFilter) {
	return {
		category: {labels: _List_Nil, name: categoryFilter.category},
		excluded: $elm$core$Set$fromList(categoryFilter.excluded),
		selected: $elm$core$Set$fromList(categoryFilter.label)
	};
};
var $author$project$Domain$LabelFilter$Unselected = {$: 'Unselected'};
var $author$project$Domain$LabelFilter$fromPb = function (labelFilter) {
	return {
		label: labelFilter.label,
		state: function () {
			var _v0 = labelFilter.state;
			switch (_v0.$) {
				case 'LabelFilterStateUnselected':
					return $author$project$Domain$LabelFilter$Unselected;
				case 'LabelFilterStateSelected':
					return $author$project$Domain$LabelFilter$Selected;
				default:
					return $author$project$Domain$LabelFilter$Negated;
			}
		}()
	};
};
var $author$project$Domain$CategoryFilter$maybeGetSelection = F2(
	function (selectedCategories, category) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.category.name, category.name);
				},
				selectedCategories));
	});
var $author$project$Domain$CategoryFilter$getSelection = F2(
	function (selectedCategories, category) {
		var _v0 = A2($author$project$Domain$CategoryFilter$maybeGetSelection, selectedCategories, category);
		if (_v0.$ === 'Just') {
			var selection = _v0.a;
			return A3($author$project$Domain$CategoryFilter$SelectableCategoryFilter, category, selection.selected, selection.excluded);
		} else {
			return A3($author$project$Domain$CategoryFilter$SelectableCategoryFilter, category, $elm$core$Set$empty, $elm$core$Set$empty);
		}
	});
var $author$project$Domain$CategoryFilter$labelComparator = F3(
	function (category, label1, label2) {
		var isSelected2 = A2($elm$core$Set$member, label2, category.selected);
		var isSelected1 = A2($elm$core$Set$member, label1, category.selected);
		return _Utils_eq(isSelected1, isSelected2) ? A2($elm$core$Basics$compare, label1, label2) : (isSelected1 ? $elm$core$Basics$LT : $elm$core$Basics$GT);
	});
var $author$project$Domain$CategoryFilter$selectableCategoryFilterWithSortedLabels = function (selectableCategoryFilter) {
	return _Utils_update(
		selectableCategoryFilter,
		{
			category: {
				labels: A2(
					$elm$core$List$sortWith,
					$author$project$Domain$CategoryFilter$labelComparator(selectableCategoryFilter),
					selectableCategoryFilter.category.labels),
				name: selectableCategoryFilter.category.name
			}
		});
};
var $author$project$Domain$CategoryFilter$mergeSelectedCategories = F2(
	function (categories, selectedCategories) {
		return A2(
			$elm$core$List$map,
			$author$project$Domain$CategoryFilter$selectableCategoryFilterWithSortedLabels,
			A2(
				$elm$core$List$map,
				$author$project$Domain$CategoryFilter$getSelection(selectedCategories),
				categories));
	});
var $author$project$Components$Dashboard$FilterBar$LabelFilters$checkLabels = F2(
	function (filterA, filterB) {
		return _Utils_eq(filterA.label, filterB.label);
	});
var $author$project$Helpers$List$updateMemberWhere = F3(
	function (isValueToReplace, newValue, list) {
		return A2(
			$elm$core$List$map,
			function (value) {
				return isValueToReplace(value) ? newValue : value;
			},
			list);
	});
var $author$project$Components$Dashboard$FilterBar$LabelFilters$setFilterState = F2(
	function (preferredFilters, initialFilters) {
		if (!preferredFilters.b) {
			return initialFilters;
		} else {
			var currentFilter = preferredFilters.a;
			var remainingFilters = preferredFilters.b;
			return A2(
				$author$project$Components$Dashboard$FilterBar$LabelFilters$setFilterState,
				remainingFilters,
				A3(
					$author$project$Helpers$List$updateMemberWhere,
					$author$project$Components$Dashboard$FilterBar$LabelFilters$checkLabels(currentFilter),
					currentFilter,
					initialFilters));
		}
	});
var $author$project$Components$Dashboard$FilterBar$LabelFilters$init = F3(
	function (accountType, labels, overrideFilterStates) {
		var baseLabels = function () {
			if (accountType.$ === 'BrokerAccount') {
				return A2($elm$core$List$cons, 'Resolved Exceptions', labels);
			} else {
				return labels;
			}
		}();
		return A2(
			$author$project$Components$Dashboard$FilterBar$LabelFilters$setFilterState,
			overrideFilterStates,
			A2(
				$elm$core$List$map,
				function (label) {
					return A2($author$project$Domain$LabelFilter$LabelFilter, label, $author$project$Domain$LabelFilter$Unselected);
				},
				baseLabels));
	});
var $author$project$Domain$AccountSettings$uniqLabelNames = function (labels) {
	return $elm$core$Set$toList(
		$elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.name;
				},
				labels)));
};
var $author$project$Domain$AccountSettings$labelNames = function (labels) {
	var _v0 = A2(
		$elm$core$List$partition,
		function (x) {
			return x.source !== 'invoice_exception';
		},
		labels);
	var nonExceptionLabels = _v0.a;
	var exceptionLabels = _v0.b;
	return _Utils_ap(
		$author$project$Domain$AccountSettings$uniqLabelNames(nonExceptionLabels),
		$author$project$Domain$AccountSettings$uniqLabelNames(exceptionLabels));
};
var $author$project$Components$Dashboard$DashboardFilterState$withAccountLabels = F3(
	function (account, accountSettings, labelsToSet) {
		var accountType = $author$project$Domain$Account$accountType(account);
		var accountLabels = $author$project$Domain$AccountSettings$labelNames(accountSettings.labels);
		return A3($author$project$Components$Dashboard$FilterBar$LabelFilters$init, accountType, accountLabels, labelsToSet);
	});
var $author$project$Components$Dashboard$DashboardFilterState$init = F2(
	function (_v0, maybeRequestedFilters) {
		var user = _v0.user;
		var accountSettings = _v0.accountSettings;
		var account = _v0.account;
		var usePreferredFilters = !accountSettings.savedFilterEnhancementsEnabled;
		var preferredFilters = usePreferredFilters ? A2($elm$core$List$map, $author$project$Domain$LabelFilter$fromPb, user.preferredFilters) : _List_Nil;
		var preferredCategories = usePreferredFilters ? A2($elm$core$List$map, $author$project$Domain$CategoryFilter$fromPb, user.preferredCategories) : _List_Nil;
		var labelsToSet = A2($author$project$Components$Dashboard$DashboardFilterState$withAccountLabels, account, accountSettings);
		var sanitize = $author$project$Sanitized$sanitize(
			function (dashboardFilters) {
				return _Utils_update(
					dashboardFilters,
					{
						categories: A2($author$project$Domain$CategoryFilter$mergeSelectedCategories, accountSettings.categories, dashboardFilters.categories),
						dashboardMode: A3(
							$author$project$Domain$DashboardMode$dashboardModeOverride,
							accountSettings,
							user,
							$author$project$Sanitized$raw(dashboardFilters.dashboardMode)),
						labelFilters: labelsToSet(dashboardFilters.labelFilters)
					});
			});
		var defaultFilters = {
			categories: A2($author$project$Domain$CategoryFilter$mergeSelectedCategories, accountSettings.categories, preferredCategories),
			customers: _List_Nil,
			dashboardMode: A3(
				$author$project$Domain$DashboardMode$dashboardModeOverride,
				accountSettings,
				user,
				$author$project$Sanitized$raw($author$project$AuditPb$DashboardModeAll)),
			dashboardSortBy: $author$project$Domain$DashboardSortBy$default,
			endDate: $elm$core$Maybe$Nothing,
			endDateTime: $elm$core$Maybe$Nothing,
			exceptions: _List_Nil,
			factorBrokerIds: _List_Nil,
			labelFilters: labelsToSet(preferredFilters),
			rangeType: $author$project$Domain$QueueDate$default,
			reskinToggle: $elm$core$Maybe$Just(accountSettings.auditV3ReskinEnabledQueues),
			startDate: $elm$core$Maybe$Nothing,
			startDateTime: $elm$core$Maybe$Nothing,
			timezoneName: $elm$core$Maybe$Nothing,
			tmsCarrierIds: _List_Nil
		};
		var shouldUseDefaultFilters = function (requestedFilters) {
			return _Utils_eq(requestedFilters.tmsCarrierIds, defaultFilters.tmsCarrierIds) && (_Utils_eq(requestedFilters.factorBrokerIds, defaultFilters.factorBrokerIds) && (_Utils_eq(requestedFilters.startDate, defaultFilters.startDate) && (_Utils_eq(requestedFilters.startDateTime, defaultFilters.startDateTime) && (_Utils_eq(requestedFilters.endDate, defaultFilters.endDate) && (_Utils_eq(requestedFilters.endDateTime, defaultFilters.endDateTime) && (_Utils_eq(requestedFilters.rangeType, defaultFilters.rangeType) && ($elm$core$List$isEmpty(requestedFilters.labelFilters) && ($elm$core$List$isEmpty(requestedFilters.categories) && $elm$core$List$isEmpty(requestedFilters.exceptions)))))))));
		};
		if (maybeRequestedFilters.$ === 'Nothing') {
			return defaultFilters;
		} else {
			var requestedFilters = maybeRequestedFilters.a;
			return A2(
				$author$project$Sanitized$sanitize,
				function (dashboardFilters) {
					return shouldUseDefaultFilters(dashboardFilters) ? _Utils_update(
						defaultFilters,
						{
							dashboardMode: A3(
								$author$project$Domain$DashboardMode$dashboardModeOverride,
								accountSettings,
								user,
								$author$project$Sanitized$raw(dashboardFilters.dashboardMode))
						}) : sanitize(requestedFilters);
				},
				requestedFilters);
		}
	});
var $author$project$Components$Dashboard$Processed$BrokerModel$BrokerModel = function (a) {
	return {$: 'BrokerModel', a: a};
};
var $author$project$Components$Dashboard$Processed$BrokerModel$init = $author$project$Components$Dashboard$Processed$BrokerModel$BrokerModel(
	{selected: $author$project$Id$Set$empty});
var $author$project$Components$Dashboard$Processed$FactorModel$FactorModel = function (a) {
	return {$: 'FactorModel', a: a};
};
var $author$project$Components$Dashboard$Processed$FactorModel$SortByAlpha = {$: 'SortByAlpha'};
var $author$project$Components$Dashboard$Processed$FactorModel$init = $author$project$Components$Dashboard$Processed$FactorModel$FactorModel(
	{
		expandedTmsCarrierIds: $author$project$Id$Set$empty,
		selectedFactorInvoiceIds: $author$project$Sanitized$raw($author$project$Id$Set$empty),
		sortBy: $author$project$Components$Dashboard$Processed$FactorModel$SortByAlpha
	});
var $author$project$Components$DashboardPage$initBulkLabelModal = {isPerforming: false, isShown: false, selectedLabel: 0, succeeded: false};
var $author$project$Components$DashboardPage$initDashboardMode = F3(
	function (accountSettings, currentUser, dashboardMode) {
		return A3($author$project$Domain$DashboardMode$dashboardModeOverride, accountSettings, currentUser, dashboardMode);
	});
var $author$project$Components$DashboardPage$initIgnoreModal = {isPerforming: false, isShown: false, succeeded: false, text: 'Ignoring these items will remove them from your dashboard.'};
var $author$project$Components$DashboardPage$initMergeModal = {isPerforming: false, isShown: false, succeeded: false, text: 'Documents from all selected emails will be combined into a single email.'};
var $author$project$Components$Dashboard$Processed$ProcessedModel$initSendingState = {isErrored: false, isProcessingApproval: false, isRejecting: false, isSendingToCadence: false};
var $author$project$Helpers$Date$localTimezoneName = A2(
	$elm$core$Task$onError,
	function (_v0) {
		return $elm$core$Task$succeed('UTC');
	},
	A2($elm$core$Task$map, $elm$core$Tuple$first, $author$project$Helpers$Date$getZone));
var $author$project$Js$listenToPresenceUpdate = _Platform_outgoingPort(
	'listenToPresenceUpdate',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$DashboardPresence$on = $author$project$HubTran$Effect$cmd(
	$author$project$Js$listenToPresenceUpdate(_Utils_Tuple0));
var $author$project$Components$DashboardPage$validateQueue = F2(
	function (accountType, accountSettings) {
		return $author$project$Sanitized$sanitize(
			function (queue) {
				if ((queue.$ === 'FinalQueue') && (queue.a.$ === 'Unknown')) {
					var _v1 = queue.a;
					return accountSettings.reviewTabEnabled ? $author$project$Components$Dashboard$AvailableQueues$FinalQueue($author$project$Components$Dashboard$AvailableQueues$ReviewQueue) : $author$project$Components$Dashboard$AvailableQueues$FinalQueue(
						$author$project$Components$Dashboard$AvailableQueues$ProcessedQueue(accountType));
				} else {
					return queue;
				}
			});
	});
var $author$project$Components$DashboardPage$init = F2(
	function (flags, initData) {
		var dashboardMode = flags.dashboardMode;
		var inFlowMode = flags.inFlowMode;
		var requestedFilters = flags.requestedFilters;
		var requestedQueue = flags.requestedQueue;
		var validatedFilters = A2($author$project$Components$Dashboard$DashboardFilterState$init, initData.dashboardFilterStateInitData, requestedFilters);
		var validatedDashboardMode = A3($author$project$Components$DashboardPage$initDashboardMode, initData.accountSettings, initData.currentUser, dashboardMode);
		var accountType = $author$project$Domain$Account$accountType(initData.account);
		var validatedQueue = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$Dashboard$AvailableQueues$defaultQueue, validatedDashboardMode, accountType),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Components$DashboardPage$validateQueue, accountType, initData.accountSettings),
				requestedQueue));
		var _v0 = A2(
			$author$project$Ui$V3$CustomSelect$init,
			{domId: 'exceptions', excludedItems: _List_Nil, items: _List_Nil, selectedItems: _List_Nil},
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$multiSelectTypeahead)
				]));
		var exceptionsDropdown = _v0.a;
		var exceptionsDropdownCmd = _v0.b;
		var _v1 = $author$project$Components$DashboardPage$debtorDropdownAndCmd(initData.debtorDropdown.selectedFactorBrokers);
		var debtorDropdown = _v1.a;
		var _v2 = A2(
			$author$project$Ui$V3$CustomSelect$init,
			{domId: 'date-range', excludedItems: _List_Nil, items: _List_Nil, selectedItems: _List_Nil},
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$hideSelectAll(true)
				]));
		var dateRangeDropdown = _v2.a;
		var dateRangeDropdownCmd = _v2.b;
		var _v3 = A2($author$project$Components$DashboardPage$customerDropdownAndCmd, initData.accountSettings, validatedFilters);
		var customerDropdown = _v3.a;
		var customerDropdownCmd = _v3.b;
		var _v4 = A3($author$project$Components$DashboardPage$categoryDropdownsAndEffects, validatedFilters.categories, initData.account, validatedDashboardMode);
		var categoryDropdowns = _v4.a;
		var categoryDropdownsEffects = _v4.b;
		var _v5 = A3($author$project$Components$DashboardPage$carrierDropdownAndCmd, initData.account, initData.accountSettings, initData.carrierDropdown.selectedCarriers);
		var carrierDropdown = _v5.a;
		var carrierDropdownCmd = _v5.b;
		return _Utils_Tuple2(
			{
				accountSettings: initData.accountSettings,
				availableQueues: A2($author$project$Components$Dashboard$AvailableQueues$availableQueues, validatedDashboardMode, initData.availableQueuesAccountData),
				bulkLabelModal: $author$project$Components$DashboardPage$initBulkLabelModal,
				carrierDropdown: carrierDropdown,
				categoryDropdowns: categoryDropdowns,
				currentDate: $elm$core$Maybe$Nothing,
				customerDropdown: customerDropdown,
				dashboardFilters: validatedFilters,
				dashboardMode: validatedDashboardMode,
				dashboardPresence: $author$project$DashboardPresence$empty,
				dashboardSavedFilterEditModal: $author$project$Components$DashboardSavedFilterEditModal$closed,
				dashboardSavedFilterRefreshing: false,
				dashboardSavedFilterSaveModal: $author$project$Components$DashboardSavedFilterSaveModal$closed,
				dateRangeDropdown: dateRangeDropdown,
				debtorDropdown: debtorDropdown,
				endDate: validatedFilters.endDate,
				endDateTime: validatedFilters.endDateTime,
				exceptionsDropdown: exceptionsDropdown,
				flowModeState: A2($author$project$Components$DashboardPage$FlowModeState, inFlowMode, $elm$core$Maybe$Nothing),
				hasAppliedDefaultFilter: !_Utils_eq(requestedFilters, $elm$core$Maybe$Nothing),
				hoveredCategory: $elm$core$Maybe$Nothing,
				ignoreModal: $author$project$Components$DashboardPage$initIgnoreModal,
				labelsCollapsed: initData.currentUser.labelsCollapsed,
				mergeModal: $author$project$Components$DashboardPage$initMergeModal,
				perPage: initData.accountSettings.perPageOnDashboard,
				processedBrokerModel: $author$project$Components$Dashboard$Processed$BrokerModel$init,
				processedFactorModel: $author$project$Components$Dashboard$Processed$FactorModel$init,
				requestedActivePage: flags.activePage,
				reviewModel: $author$project$Components$Dashboard$Review$Model$emptyModel,
				routesInElm: flags.routesInElm,
				selectAllVisible: false,
				selectedQueue: validatedQueue,
				selectedSelectables: $timo_weike$generic_collections$ManualSet$empty,
				sendingState: $author$project$Components$Dashboard$Processed$ProcessedModel$initSendingState,
				shouldRefreshIds: false,
				showFilters: true,
				startDate: validatedFilters.startDate,
				startDateTime: validatedFilters.startDateTime,
				tableElement: $elm$core$Maybe$Nothing,
				timezoneName: $elm$core$Maybe$Nothing
			},
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Task$perform, $author$project$Components$DashboardPage$SetDate, $elm$time$Time$now)),
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Task$perform, $author$project$Components$DashboardPage$SetTimezoneName, $author$project$Helpers$Date$localTimezoneName)),
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$CustomerDropdownMsg, customerDropdownCmd)),
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$CarrierDropdownMsg, carrierDropdownCmd)),
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$DateRangeDropdownMsg, dateRangeDropdownCmd)),
						categoryDropdownsEffects,
						$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$ExceptionsDropdownMsg, exceptionsDropdownCmd)),
						$author$project$DashboardPresence$on,
						$author$project$Components$DashboardPage$getTableElementEffect
					])));
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$CanMergeResolved = function (a) {
	return {$: 'CanMergeResolved', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$HasMoreGroupsResolved = function (a) {
	return {$: 'HasMoreGroupsResolved', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$InitialGroupResolved = function (a) {
	return {$: 'InitialGroupResolved', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$PageLoadedResponse = function (a) {
	return {$: 'PageLoadedResponse', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$ProcessedCountResolved = function (a) {
	return {$: 'ProcessedCountResolved', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$Summary = {$: 'Summary'};
var $author$project$Components$DocumentsBrowser$MarkIllegibleAction = {$: 'MarkIllegibleAction'};
var $author$project$Components$FactorInvoiceAudit$ToolbarActions$enabled = _List_fromArray(
	[$author$project$Components$DocumentsBrowser$RotateAction, $author$project$Components$DocumentsBrowser$DuplicateAction, $author$project$Components$DocumentsBrowser$SplitFromDocumentAction, $author$project$Components$DocumentsBrowser$MergeToPreviousAction, $author$project$Components$DocumentsBrowser$UpdatePodAction, $author$project$Components$DocumentsBrowser$EditMessageAction, $author$project$Components$DocumentsBrowser$UpdateDocumentTypeAction, $author$project$Components$DocumentsBrowser$AnnotateDocumentAction, $author$project$Components$DocumentsBrowser$MarkIllegibleAction]);
var $author$project$Path$factorInvoiceAuditBatchBase = function (documentBatchId) {
	return $author$project$Path$base(
		_List_fromArray(
			[
				'app',
				'factor_invoices_workflow',
				'batch',
				$elm$core$String$fromInt(
				$author$project$Domain$DocumentBatchId$toInt(documentBatchId))
			]));
};
var $author$project$AuditPb$factorInvoiceServicePageLoadedRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId)
				])));
};
var $author$project$AuditPb$FactorInvoiceServicePageLoadedResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServicePageLoadedResponse_Outcome_FactorInvoiceServicePageLoadedSuccess = function (a) {
	return {$: 'FactorInvoiceServicePageLoadedResponse_Outcome_FactorInvoiceServicePageLoadedSuccess', a: a};
};
var $author$project$AuditPb$FactorInvoiceServicePageLoadedResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServicePageLoadedResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServicePageLoadedSuccess = {};
var $author$project$AuditPb$factorInvoiceServicePageLoadedSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServicePageLoadedSuccess);
	});
var $author$project$AuditPb$FactorInvoiceServiceUpdateError = function (message) {
	return {message: message};
};
var $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'message',
			$elm$json$Json$Decode$string,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceUpdateError));
	});
var $author$project$AuditPb$factorInvoiceServicePageLoadedResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServicePageLoadedResponse_Outcome_FactorInvoiceServicePageLoadedSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServicePageLoadedSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServicePageLoadedResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServicePageLoadedResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServicePageLoadedResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServicePageLoadedResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServicePageLoadedResponse));
	});
var $krisajenkins$remotedata$RemoteData$Loading = {$: 'Loading'};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 'Failure', a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 'Success', a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 'Err') {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$AuditApi$toInspectableEffect = function (_v0) {
	var body = _v0.body;
	var decoder = _v0.decoder;
	var path = _v0.path;
	return $author$project$HubTran$Effect$InspectableEffect(
		$author$project$HubTran$InspectableEffect$http(
			{
				body: $elm$core$Maybe$Just(body),
				headers: _List_fromArray(
					[
						_Utils_Tuple2('Content-Type', 'application/json')
					]),
				method: 'POST',
				resolver: $author$project$Helpers$Http$jsonResolver(decoder),
				timeout: $elm$core$Maybe$Just(60 * 1000),
				url: path
			}));
};
var $author$project$AuditApi$toRemote = F5(
	function (path, encoder, decoder, toMsg, value) {
		var effect = A2(
			$author$project$HubTran$Effect$map,
			$krisajenkins$remotedata$RemoteData$fromResult,
			$author$project$AuditApi$toInspectableEffect(
				{
					body: encoder(value),
					decoder: decoder,
					path: path
				}));
		return A2(
			$author$project$HubTran$Effect$map,
			toMsg,
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						$author$project$HubTran$Effect$AnyCmd(
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$identity,
							$elm$core$Task$succeed($krisajenkins$remotedata$RemoteData$Loading))),
						effect
					])));
	});
var $author$project$AuditApi$factorInvoiceServicePageLoadedRemote = A3($author$project$AuditApi$toRemote, '/factor_invoice_service/page_loaded', $author$project$AuditPb$factorInvoiceServicePageLoadedRequestEncoder, $author$project$AuditPb$factorInvoiceServicePageLoadedResponseDecoder);
var $author$project$Components$FactorInvoiceAuditPacketComparison$NotComparing = {$: 'NotComparing'};
var $author$project$Components$FactorInvoiceAuditPacketComparison$init = $author$project$Components$FactorInvoiceAuditPacketComparison$NotComparing;
var $author$project$Components$BrokeredCarrierDropdown$init = function (_v0) {
	var attrs = _v0.attrs;
	var _v1 = $author$project$Components$PaginatedDropdown$init(
		{
			attrs: A2(
				$elm$core$List$cons,
				$author$project$Ui$V3$CustomSelect$autoFilter(false),
				attrs),
			domId: 'brokered-carrier-select',
			lastItems: _List_Nil,
			otherItems: _List_Nil,
			selectedItems: _List_Nil
		});
	var dropdown = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		{dropdown: dropdown},
		cmd);
};
var $author$project$Components$BrokeredCarrierTermDropdown$init = function (_v0) {
	var programExternalId = _v0.programExternalId;
	var attrs = _v0.attrs;
	var _v1 = $author$project$Components$PaginatedDropdown$init(
		{
			attrs: A2(
				$elm$core$List$cons,
				$author$project$Ui$V3$CustomSelect$autoFilter(false),
				attrs),
			domId: 'brokered-carrier-term-select',
			lastItems: _List_Nil,
			otherItems: _List_Nil,
			selectedItems: _List_Nil
		});
	var dropdown = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		{dropdown: dropdown, programExternalId: programExternalId},
		cmd);
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$Model = function (a) {
	return {$: 'Model', a: a};
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$init = $author$project$Components$FactorInvoiceAudit$PossibleMatches$Model(
	{isCollapsed: true, selectedMatch: $elm$core$Maybe$Nothing});
var $author$project$Components$AuditDrafts$Text = {$: 'Text'};
var $author$project$Components$FactorInvoiceAuditDrafts$kindOf = function (field) {
	switch (field.$) {
		case 'LoadId':
			return $author$project$Components$AuditDrafts$StrippedText;
		case 'InvoiceNumber':
			return $author$project$Components$AuditDrafts$Text;
		default:
			return $author$project$Components$AuditDrafts$Amount;
	}
};
var $author$project$Components$FactorInvoiceAuditDrafts$toComparable = function (field) {
	switch (field.$) {
		case 'LoadId':
			return 'load-id';
		case 'InvoiceNumber':
			return 'invoice-number';
		default:
			return 'invoice-amount';
	}
};
var $author$project$Components$FactorInvoiceAuditDrafts$empty = $author$project$Components$AuditDrafts$empty(
	{kindOf: $author$project$Components$FactorInvoiceAuditDrafts$kindOf, toComparable: $author$project$Components$FactorInvoiceAuditDrafts$toComparable});
var $author$project$Components$FactorInvoiceAuditChecks$init = {addExceptionEvent: $author$project$Components$AuditAddExceptionEvent$init, brokerClientCarrierAmountInput: $elm$core$Maybe$Nothing, debtorAutofillInput: $elm$core$Maybe$Nothing, drafts: $author$project$Components$FactorInvoiceAuditDrafts$empty, exceptionEventInputs: $elm$core$Dict$empty, expandedFailedChecks: _List_Nil, invoiceDateInput: $elm$core$Maybe$Nothing, quickReviewCollapsed: true, quickReviewDebtorDetailsExpanded: false, unidentifiedDocumentCursor: 0};
var $author$project$Components$FactorInvoiceAuditWorkingArea$init = F5(
	function (factorInvoiceId, emailId, onDone, documentBatchId, initData) {
		var _v0 = $author$project$Components$DebtorDropdown$init(
			{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
						$author$project$Ui$V3$CustomSelect$hideSelectAll(true)
					]),
				selected: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, initData.initialDebtor))
			});
		var debtorDropdown = _v0.a;
		var debtorDropdownCmd = _v0.b;
		var _v1 = $author$project$Components$CarrierDropdown$initForAssignment(
			{
				accountType: $author$project$Domain$Account$accountType(initData.account),
				isFactor: initData.account.factorAccount,
				selectedCarriers: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, initData.initialCarrier)),
				showVendorId: initData.accountSettings.showCarrierExternalVendorId
			});
		var carrierDropdown = _v1.a;
		var carrierDropdownCmd = _v1.b;
		var _v2 = $author$project$Components$BrokeredCarrierTermDropdown$init(
			{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
						$author$project$Ui$V3$CustomSelect$hideSelectAll(true),
						$author$project$Ui$V3$CustomSelect$placeholder(
						$elm$core$Maybe$Just('Select brokered carrier term'))
					]),
				programExternalId: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.programExternalId;
						},
						initData.initialCarrier))
			});
		var brokeredCarrierTermDropdown = _v2.a;
		var brokeredCarrierTermDropdownCmd = _v2.b;
		var _v3 = $author$project$Components$BrokeredCarrierDropdown$init(
			{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
						$author$project$Ui$V3$CustomSelect$hideSelectAll(true),
						$author$project$Ui$V3$CustomSelect$placeholder(
						$elm$core$Maybe$Just('Select brokered carrier'))
					])
			});
		var brokeredCarrierDropdown = _v3.a;
		var brokeredCarrierDropdownCmd = _v3.b;
		return _Utils_Tuple2(
			{
				auditChecks: $author$project$Components$FactorInvoiceAuditChecks$init,
				auditChecksRequiredAt: $elm$time$Time$millisToPosix(0),
				brokeredCarrierDropdown: brokeredCarrierDropdown,
				brokeredCarrierTermDropdown: brokeredCarrierTermDropdown,
				carrierDropdown: carrierDropdown,
				carrierTerm: $author$project$Domain$Account$carrierTermForAccount(initData.account),
				customInvoiceExceptionMessages: initData.accountSettings.customInvoiceExceptionMessages,
				debtorDropdown: debtorDropdown,
				documentBatchId: documentBatchId,
				emailId: emailId,
				enabledDocumentTypes: initData.documentTypeSettings.enabledDocumentTypeNames,
				factorInvoiceId: factorInvoiceId,
				ignoreModalOpen: false,
				ignoreReason: '',
				isApprover: initData.currentUser.isApprover,
				isFactor: initData.account.factorAccount,
				isUnapprover: initData.currentUser.isAdmin,
				mustVerifyDraft: $elm$core$Maybe$Nothing,
				notesDebounce: $jinjor$elm_debounce$Debounce$init,
				notesDraft: $elm$core$Maybe$Nothing,
				onDone: onDone,
				paymentsNetworkEnabled: initData.accountSettings.paymentsNetworkEnabled,
				possibleMatchesSection: $author$project$Components$FactorInvoiceAudit$PossibleMatches$init,
				queuedUpdates: _List_Nil,
				requestState: $author$project$AuditApi$initRequestState,
				sendToCarrierModalRequested: false,
				showVendorId: initData.accountSettings.showCarrierExternalVendorId,
				useFactorInvoiceWorkflowPage: initData.accountSettings.useFactorInvoiceWorkflowPage,
				verificationsWorkflowEnabled: initData.accountSettings.verificationsWorkflowEnabled
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$CarrierDropdownMsg, carrierDropdownCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$DebtorDropdownMsg, debtorDropdownCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$BrokeredCarrierDropdownMsg, brokeredCarrierDropdownCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$BrokeredCarrierTermDropdownMsg, brokeredCarrierTermDropdownCmd)
					])));
	});
var $author$project$Domain$ClientNotesSidebarDisplay$isInitiallyOpen = function (display) {
	return _Utils_eq(display, $author$project$AuditPb$ClientNotesSidebarDisplayExpanded);
};
var $author$project$Components$FactorInvoiceClientNotesPanel$init = function (accountSettings) {
	return {
		open: $author$project$Domain$ClientNotesSidebarDisplay$isInitiallyOpen(accountSettings.clientNotesSidebarDisplay)
	};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$initialGroupWithinBatch = F2(
	function (documentBatchId, documents) {
		var withinBatch = A2(
			$elm$core$List$filter,
			function (doc) {
				return _Utils_eq(
					doc.documentBatchId,
					$elm$core$Maybe$Just(documentBatchId));
			},
			documents);
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.documentGroupId;
				},
				_Utils_ap(withinBatch, documents)));
	});
var $author$project$Components$FactorInvoiceAuditBatchResolver$canMerge = function (groups) {
	var invoiceStates = A2(
		$elm$core$List$filterMap,
		function ($) {
			return $.state;
		},
		groups);
	return $elm$core$List$isEmpty(invoiceStates) || A2(
		$elm$core$List$all,
		$elm$core$Basics$eq($author$project$Domain$FactorInvoice$Draft),
		invoiceStates);
};
var $author$project$Components$FactorInvoiceAuditBatchResolver$resolveCanMerge = function (documentBatchId) {
	return A2(
		$author$project$Forward$Lookup$map,
		$author$project$Components$FactorInvoiceAuditBatchResolver$canMerge,
		$author$project$Components$FactorInvoiceAuditBatchResolver$loadGroupSummaries(documentBatchId));
};
var $author$project$Components$FactorInvoiceAuditBatchResolver$groupIncomplete = function (group) {
	return (!A2(
		$elm$core$List$all,
		function ($) {
			return $.finished;
		},
		group.documents)) && (!_Utils_eq(group.factorInvoiceId, $elm$core$Maybe$Nothing));
};
var $author$project$Components$FactorInvoiceAuditBatchResolver$hasIncompleteGroupOtherThanCurrent = F2(
	function (currentFactorInvoiceId, groups) {
		return A2(
			$elm$core$List$any,
			function (g) {
				return !_Utils_eq(
					g.factorInvoiceId,
					$elm$core$Maybe$Just(currentFactorInvoiceId));
			},
			A2($elm$core$List$filter, $author$project$Components$FactorInvoiceAuditBatchResolver$groupIncomplete, groups));
	});
var $author$project$Components$FactorInvoiceAuditBatchResolver$resolveHasMoreGroups = F2(
	function (currentFactorInvoiceId, documentBatchId) {
		return A2(
			$author$project$Forward$Lookup$map,
			$author$project$Components$FactorInvoiceAuditBatchResolver$hasIncompleteGroupOtherThanCurrent(currentFactorInvoiceId),
			$author$project$Components$FactorInvoiceAuditBatchResolver$loadGroupSummaries(documentBatchId));
	});
var $author$project$Components$FactorInvoiceAuditBatchResolver$countProcessed = F2(
	function (currentFactorInvoiceId, groups) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (g) {
					return _Utils_eq(
						g.state,
						$elm$core$Maybe$Just($author$project$Domain$FactorInvoice$Processed));
				},
				A2(
					$elm$core$List$filter,
					function (g) {
						return !_Utils_eq(
							g.factorInvoiceId,
							$elm$core$Maybe$Just(currentFactorInvoiceId));
					},
					groups)));
	});
var $author$project$Components$FactorInvoiceAuditBatchResolver$resolveProcessedCount = F2(
	function (currentFactorInvoiceId, documentBatchId) {
		return A2(
			$author$project$Forward$Lookup$map,
			$author$project$Components$FactorInvoiceAuditBatchResolver$countProcessed(currentFactorInvoiceId),
			$author$project$Components$FactorInvoiceAuditBatchResolver$loadGroupSummaries(documentBatchId));
	});
var $author$project$Js$setUserPresence = _Platform_outgoingPort('setUserPresence', $elm$json$Json$Encode$string);
var $author$project$Js$setupNewFactorInvoiceCreated = _Platform_outgoingPort('setupNewFactorInvoiceCreated', $elm$json$Json$Encode$string);
var $author$project$Components$FactorInvoiceAuditBatchPage$init = function (initData) {
	var resolveInitialGroup = A2(
		$author$project$Forward$Lookup$startFrom,
		initData.factorInvoiceId,
		A2(
			$author$project$Forward$Lookup$map,
			$author$project$Components$FactorInvoiceAuditBatchPage$initialGroupWithinBatch(initData.documentBatchId),
			$author$project$Forward$Lookup$waitForAllList(
				A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice))));
	var presencePath = $author$project$Path$toString(
		$author$project$Path$factorInvoiceAuditBatchBase(initData.documentBatchId));
	var presence = $author$project$Presence$on(presencePath);
	var _v0 = A5(
		$author$project$Components$FactorInvoiceAuditWorkingArea$init,
		initData.factorInvoiceId,
		initData.emailMessageId,
		initData.onDone,
		$elm$core$Maybe$Just(initData.documentBatchId),
		initData.workingArea);
	var workingArea = _v0.a;
	var workingAreaCmd = _v0.b;
	var _v1 = $author$project$Components$DocumentsBrowser$init(
		{
			currentProcessingSelection: $author$project$Broker$Shared$CurrentProcessingSelection$noSelection,
			displayUnassignedLoadDocuments: false,
			enabledDocumentTypes: initData.documentTypeSettings.enabledDocumentTypeNames,
			enabledToolbarActions: $author$project$Components$FactorInvoiceAudit$ToolbarActions$enabled,
			maybeDefaultViewMode: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$DefaultViewModeWidth),
			maybeOnDone: initData.onDone,
			pageContextData: $author$project$Helpers$DocumentViewerPageContextData$empty,
			popout: false,
			scrollContainerSuffix: 'primary',
			viewPortHeightPxOffset: 0
		});
	var documentsBrowser = _v1.a;
	var documentsBrowserEffect = _v1.b;
	return _Utils_Tuple2(
		{
			accountSettings: initData.workingArea.accountSettings,
			activeHeaderModal: $elm$core$Maybe$Nothing,
			canMerge: $elm$core$Maybe$Nothing,
			clientNotesPanel: $author$project$Components$FactorInvoiceClientNotesPanel$init(initData.workingArea.accountSettings),
			documentBatchId: initData.documentBatchId,
			documentsBrowser: documentsBrowser,
			dragDrop: $author$project$Components$DragDrop$init,
			emailMessageId: initData.emailMessageId,
			hasMoreGroups: $elm$core$Maybe$Nothing,
			onDone: initData.onDone,
			packetComparison: $author$project$Components$FactorInvoiceAuditPacketComparison$init,
			pendingInvoiceGroupId: $elm$core$Maybe$Nothing,
			presence: presence,
			processedCount: $elm$core$Maybe$Nothing,
			savedDocumentsColumnWidth: initData.workingArea.currentUser.auditDocumentsColumnWidth,
			secondaryDocumentsBrowser: $elm$core$Maybe$Nothing,
			selectedTab: $author$project$Components$FactorInvoiceAuditBatchPage$Summary,
			sendToCarrierModalOpen: false,
			splitPane: $author$project$Components$AuditSplitPane$init,
			usesVectorWorkflow: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, initData.workingArea.accountSettings, initData.workingArea.currentUser),
			workingArea: workingArea
		},
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditBatchPage$DocumentsBrowserMsg, documentsBrowserEffect),
					$author$project$HubTran$Effect$cmd(
					A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg, workingAreaCmd)),
					A2($author$project$HubTran$Effect$fetchFromCache, $author$project$Components$FactorInvoiceAuditBatchPage$InitialGroupResolved, resolveInitialGroup),
					A2(
					$author$project$HubTran$Effect$fetchFromCache,
					$author$project$Components$FactorInvoiceAuditBatchPage$HasMoreGroupsResolved,
					A2($author$project$Components$FactorInvoiceAuditBatchResolver$resolveHasMoreGroups, initData.factorInvoiceId, initData.documentBatchId)),
					A2(
					$author$project$HubTran$Effect$fetchFromCache,
					$author$project$Components$FactorInvoiceAuditBatchPage$ProcessedCountResolved,
					A2($author$project$Components$FactorInvoiceAuditBatchResolver$resolveProcessedCount, initData.factorInvoiceId, initData.documentBatchId)),
					A2(
					$author$project$HubTran$Effect$fetchFromCache,
					$author$project$Components$FactorInvoiceAuditBatchPage$CanMergeResolved,
					$author$project$Components$FactorInvoiceAuditBatchResolver$resolveCanMerge(initData.documentBatchId)),
					$author$project$HubTran$Effect$cmd(
					$author$project$Js$setUserPresence(presencePath)),
					$author$project$HubTran$Effect$cmd(
					$author$project$Js$setupNewFactorInvoiceCreated('')),
					A2(
					$author$project$AuditApi$factorInvoiceServicePageLoadedRemote,
					$author$project$Components$FactorInvoiceAuditBatchPage$PageLoadedResponse,
					{factorInvoiceId: initData.factorInvoiceId})
				])));
};
var $author$project$Components$FactorInvoiceAuditPage$PageLoadedResponse = function (a) {
	return {$: 'PageLoadedResponse', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$Summary = {$: 'Summary'};
var $author$project$Broker$Shared$CurrentProcessingSelection$FactorInvoiceSelection = F2(
	function (a, b) {
		return {$: 'FactorInvoiceSelection', a: a, b: b};
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$factorInvoice = function (factorInvoiceId) {
	return A2($author$project$Broker$Shared$CurrentProcessingSelection$FactorInvoiceSelection, factorInvoiceId, $elm$core$Maybe$Nothing);
};
var $author$project$Path$factorInvoiceAuditWorkflowBase = function (factorInvoiceId) {
	return $author$project$Path$base(
		_List_fromArray(
			[
				'app',
				'factor_invoices_workflow',
				$elm$core$String$fromInt(
				$author$project$Domain$FactorInvoiceId$toInt(factorInvoiceId))
			]));
};
var $author$project$Components$FactorInvoiceAuditPage$init = function (initData) {
	var selection = $author$project$Broker$Shared$CurrentProcessingSelection$factorInvoice(initData.factorInvoiceId);
	var presencePath = $author$project$Path$toString(
		$author$project$Path$factorInvoiceAuditWorkflowBase(initData.factorInvoiceId));
	var presence = $author$project$Presence$on(presencePath);
	var _v0 = A5($author$project$Components$FactorInvoiceAuditWorkingArea$init, initData.factorInvoiceId, initData.emailId, initData.onDone, $elm$core$Maybe$Nothing, initData.workingArea);
	var workingArea = _v0.a;
	var workingAreaCmd = _v0.b;
	var _v1 = $author$project$Components$DocumentsBrowser$init(
		{
			currentProcessingSelection: selection,
			displayUnassignedLoadDocuments: false,
			enabledDocumentTypes: initData.documentTypeSettings.enabledDocumentTypeNames,
			enabledToolbarActions: $author$project$Components$FactorInvoiceAudit$ToolbarActions$enabled,
			maybeDefaultViewMode: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$DefaultViewModeWidth),
			maybeOnDone: initData.onDone,
			pageContextData: $author$project$Helpers$DocumentViewerPageContextData$empty,
			popout: false,
			scrollContainerSuffix: 'primary',
			viewPortHeightPxOffset: 0
		});
	var documentsBrowser = _v1.a;
	var documentsBrowserEffect = _v1.b;
	return _Utils_Tuple2(
		{
			accountSettings: initData.workingArea.accountSettings,
			clientNotesPanel: $author$project$Components$FactorInvoiceClientNotesPanel$init(initData.workingArea.accountSettings),
			documentsBrowser: documentsBrowser,
			dragDrop: $author$project$Components$DragDrop$init,
			factorInvoiceId: initData.factorInvoiceId,
			onDone: initData.onDone,
			packetComparison: $author$project$Components$FactorInvoiceAuditPacketComparison$init,
			presence: presence,
			savedDocumentsColumnWidth: initData.workingArea.currentUser.auditDocumentsColumnWidth,
			secondaryDocumentsBrowser: $elm$core$Maybe$Nothing,
			selectedTab: $author$project$Components$FactorInvoiceAuditPage$Summary,
			sendToCarrierModalOpen: false,
			splitPane: $author$project$Components$AuditSplitPane$init,
			usesVectorWorkflow: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, initData.workingArea.accountSettings, initData.workingArea.currentUser),
			workingArea: workingArea
		},
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg, documentsBrowserEffect),
					$author$project$HubTran$Effect$cmd(
					A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg, workingAreaCmd)),
					$author$project$HubTran$Effect$cmd(
					$author$project$Js$setUserPresence(presencePath)),
					$author$project$Components$AuditSplitPane$offerSelection(selection),
					A2(
					$author$project$AuditApi$factorInvoiceServicePageLoadedRemote,
					$author$project$Components$FactorInvoiceAuditPage$PageLoadedResponse,
					{factorInvoiceId: initData.factorInvoiceId})
				])));
};
var $author$project$Components$LtlHeldSubmissionsPage$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$AuditPb$SortOrderAsc = {$: 'SortOrderAsc'};
var $author$project$Js$setupLtlPayablesCarrierInvoiceSubmissionImport = _Platform_outgoingPort(
	'setupLtlPayablesCarrierInvoiceSubmissionImport',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Components$LtlHeldSubmissionsPage$init = function (initData) {
	return _Utils_Tuple2(
		{entriesPerPage: 10, importsInProgress: $elm$core$Set$empty, pageNumber: 1, requestState: $author$project$PostRequestState$init, searchInput: '', searchTerm: '', sortOrder: $author$project$AuditPb$SortOrderAsc, tz: $elm$time$Time$utc},
		(!initData.accountSettings.ltlHoldEdiImportDays) ? $author$project$HubTran$Effect$load('/app') : $author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$cmd(
					A2($elm$core$Task$perform, $author$project$Components$LtlHeldSubmissionsPage$SetTimezone, $author$project$Helpers$Date$localTimezone)),
					$author$project$HubTran$Effect$cmd(
					$author$project$Js$setupLtlPayablesCarrierInvoiceSubmissionImport(_Utils_Tuple0))
				])));
};
var $author$project$Components$LtlReconcileInvoicePage$Amount = {$: 'Amount'};
var $author$project$Components$LtlReconcileInvoicePage$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$carrierInvoiceWithLoadPath = F3(
	function (loadStateId, carrierInvoiceId, maybeOnDone) {
		return A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'onDone',
					$elm$url$Url$percentEncode(
						A2($elm$core$Maybe$withDefault, '/app', maybeOnDone)))
				]),
			A3($author$project$Path$carrierInvoiceWithLoad, loadStateId, carrierInvoiceId, false));
	});
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem = function (_v0) {
	var state = _v0.state;
	switch (state.$) {
		case 'LoadItemAndCarrierItem':
			var carrierItem_ = state.b;
			return $elm$core$Maybe$Just(carrierItem_);
		case 'CarrierItemOnly':
			var carrierItem_ = state.a;
			return $elm$core$Maybe$Just(carrierItem_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem = function (_v0) {
	var state = _v0.state;
	switch (state.$) {
		case 'LoadItemAndCarrierItem':
			var loadItem_ = state.a;
			return $elm$core$Maybe$Just(loadItem_);
		case 'LoadItemOnly':
			var loadItem_ = state.a;
			return $elm$core$Maybe$Just(loadItem_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Domain$LineItemId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$lineItemPairToComparable = function (itemPair) {
	var maybeLineItemIdAsInt = function (maybeLineItem) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			-1,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.id;
				},
				$author$project$Domain$LineItemId$toInt),
			maybeLineItem);
	};
	return _Utils_Tuple2(
		maybeLineItemIdAsInt(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair)),
		maybeLineItemIdAsInt(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair)));
};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$init = {
	selectedDiscountToggleOptions: $turboMaCk$any_dict$Dict$Any$empty($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$lineItemPairToComparable)
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$lineItemPairToComparable = function (itemPair) {
	var maybeLineItemIdToInt = A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		-1,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.id;
			},
			$author$project$Domain$LineItemId$toInt));
	return _Utils_Tuple2(
		maybeLineItemIdToInt(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair)),
		maybeLineItemIdToInt(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair)));
};
var $author$project$Domain$TmsShippedItemId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$shippedItemPairToComparable = function (itemPair) {
	var maybeShippedItemIdToInt = function (maybeShippedItem) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			-1,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.id;
				},
				$author$project$Domain$TmsShippedItemId$toInt),
			maybeShippedItem);
	};
	return _Utils_Tuple2(
		maybeShippedItemIdToInt(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair)),
		maybeShippedItemIdToInt(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair)));
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$init = function (carrierInvoiceId) {
	return {
		carrierInvoiceId: carrierInvoiceId,
		tmsUpdateValuesAccessorial: $turboMaCk$any_dict$Dict$Any$empty($author$project$Components$LtlReconcileInvoicePage$MismatchTable$lineItemPairToComparable),
		tmsUpdateValuesShippedItem: $turboMaCk$any_dict$Dict$Any$empty($author$project$Components$LtlReconcileInvoicePage$MismatchTable$shippedItemPairToComparable)
	};
};
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$init = F3(
	function (ltlInvoiceAvailableTmsQueues, carrierInvoiceId, confirmAndSubmitPath) {
		var selectedTmsQueue = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(ltlInvoiceAvailableTmsQueues));
		return {carrierInvoiceId: carrierInvoiceId, confirmAndSubmitPath: confirmAndSubmitPath, isOpen: false, isSubmitting: false, ltlInvoiceAvailableTmsQueues: ltlInvoiceAvailableTmsQueues, reason: '', requestState: $author$project$PostRequestState$init, selectedTmsQueue: selectedTmsQueue};
	});
var $author$project$Helpers$LtlReconcile$isLtlReconcileEnabled = F2(
	function (accountSettings, carrierInvoiceHasSubmission) {
		return accountSettings.indexAuditSplitEnabled && (accountSettings.ltlReconcileEnabled && carrierInvoiceHasSubmission);
	});
var $author$project$Components$LtlReconcileInvoicePage$init = function (data) {
	var params = data.params;
	var confirmAndSubmitPath = A3($author$project$Components$LtlReconcileInvoicePage$carrierInvoiceWithLoadPath, params.loadStateId, params.carrierInvoiceId, params.onDone);
	var moveToTmsModal = A3($author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$init, data.settings.ltlInvoiceAvailableTMSQueues, params.carrierInvoiceId, confirmAndSubmitPath);
	var pageEffect = (!A2($author$project$Helpers$LtlReconcile$isLtlReconcileEnabled, data.settings, data.carrierInvoice.ltlData.hasSubmission)) ? $author$project$HubTran$Effect$load(
		$author$project$Path$toString(confirmAndSubmitPath)) : $author$project$HubTran$Effect$cmd(
		A2($elm$core$Task$perform, $author$project$Components$LtlReconcileInvoicePage$SetTimezone, $author$project$Helpers$Date$localTimezone));
	var _v0 = $author$project$Components$DocumentsBrowser$init(
		{
			currentProcessingSelection: $author$project$Broker$Shared$CurrentProcessingSelection$carrierInvoice(params.carrierInvoiceId),
			displayUnassignedLoadDocuments: true,
			enabledDocumentTypes: _List_Nil,
			enabledToolbarActions: $author$project$Components$DocumentsBrowser$allNonDocumentTypeToolbarActionsEnabled,
			maybeDefaultViewMode: $elm$core$Maybe$Nothing,
			maybeOnDone: params.onDone,
			pageContextData: {
				carrierInvoiceHasSubmission: $elm$core$Maybe$Just(true),
				carrierInvoiceId: $elm$core$Maybe$Just(params.carrierInvoiceId),
				loadStateId: $elm$core$Maybe$Just(params.loadStateId)
			},
			popout: false,
			scrollContainerSuffix: 'primary',
			viewPortHeightPxOffset: -200
		});
	var documentsBrowser = _v0.a;
	var documentsBrowserEffect = _v0.b;
	return _Utils_Tuple2(
		{
			carrierInvoiceId: params.carrierInvoiceId,
			documentsBrowser: documentsBrowser,
			ignoreModal: {isPerforming: false, isShown: false, text: ''},
			invoiceDetailsTable: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$init,
			isFinished: false,
			isFinishing: false,
			loadStateId: params.loadStateId,
			mismatchTable: $author$project$Components$LtlReconcileInvoicePage$MismatchTable$init(params.carrierInvoiceId),
			moveToTmsModal: moveToTmsModal,
			onDone: params.onDone,
			requestState: $author$project$PostRequestState$init,
			timezone: $elm$time$Time$utc,
			totalsHeaderSelectedToggleOption: $author$project$Components$LtlReconcileInvoicePage$Amount
		},
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					pageEffect,
					A2($author$project$HubTran$Effect$map, $author$project$Components$LtlReconcileInvoicePage$DocumentsBrowserMsg, documentsBrowserEffect)
				])));
};
var $author$project$Components$NonInvoiceConfirmPage$AnotherLoad = F2(
	function (a, b) {
		return {$: 'AnotherLoad', a: a, b: b};
	});
var $author$project$Components$NonInvoiceConfirmPage$Dashboard = function (a) {
	return {$: 'Dashboard', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$Ready = {$: 'Ready'};
var $author$project$Components$NonInvoiceConfirmPage$SetTimezone = function (a) {
	return {$: 'SetTimezone', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$documentsRequiringShipmentAssignment = F4(
	function (shipments, documents, nonInvoiceLoadDocumentTypes, customerVisibleDocumentTypes) {
		var shipmentType = function (doc) {
			return A2(
				$elm$core$List$member,
				$author$project$Domain$Document$documentTypeValueToUnresolved(doc.documentTypeValue),
				nonInvoiceLoadDocumentTypes) && A2(
				$elm$core$List$member,
				$author$project$Domain$Document$documentTypeValueToUnresolved(doc.documentTypeValue),
				customerVisibleDocumentTypes);
		};
		return $elm$core$List$isEmpty(shipments) ? _List_Nil : A2($elm$core$List$filter, shipmentType, documents);
	});
var $author$project$Id$Set$fromList = function (list) {
	return $author$project$Id$Set$Set(
		$elm$core$Set$fromList(
			A2($elm$core$List$map, $author$project$Id$toInt, list)));
};
var $author$project$Id$Dict$fromList = function (list) {
	return $author$project$Id$Dict$Dict(
		$elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst($author$project$Id$toInt),
				list)));
};
var $author$project$Components$NonInvoiceConfirmPage$initShipmentDocuments = function (shipments) {
	return $author$project$Id$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (shipment) {
				return _Utils_Tuple2(
					shipment.id,
					$author$project$Id$Set$fromList(shipment.documentIds));
			},
			shipments));
};
var $author$project$Path$documentBatchWithLoad = F3(
	function (documentBatchId, loadStateId, pathContext) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$LoadStateId$toInt(loadStateId));
		return A2(
			$author$project$Path$appendToBase,
			_List_fromArray(
				['loads', idString]),
			A2($author$project$Path$documentBatch, documentBatchId, pathContext));
	});
var $author$project$Path$nonInvoiceConfirm = F2(
	function (documentBatchId, loadStateId) {
		return A2(
			$author$project$Path$appendToBase,
			_List_fromArray(
				['confirm']),
			A3(
				$author$project$Path$documentBatchWithLoad,
				documentBatchId,
				loadStateId,
				{isReadonly: false, useFactorInvoiceWorkflowPage: false}));
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$NonInvoiceLoadSelection = F3(
	function (a, b, c) {
		return {$: 'NonInvoiceLoadSelection', a: a, b: b, c: c};
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$nonInvoiceLoadSelection = F3(
	function (loadStateId, documentBatchId, maybeDocPageId) {
		return A3($author$project$Broker$Shared$CurrentProcessingSelection$NonInvoiceLoadSelection, loadStateId, documentBatchId, maybeDocPageId);
	});
var $author$project$Components$NonInvoiceConfirmPage$init = function (data) {
	var params = data.params;
	var presence = $author$project$Presence$on(
		$author$project$Path$toString(
			A2($author$project$Path$nonInvoiceConfirm, params.documentBatchId, params.loadStateId)));
	var _v0 = $author$project$Components$DocumentsBrowser$init(
		{
			currentProcessingSelection: A3($author$project$Broker$Shared$CurrentProcessingSelection$nonInvoiceLoadSelection, params.loadStateId, params.documentBatchId, $elm$core$Maybe$Nothing),
			displayUnassignedLoadDocuments: true,
			enabledDocumentTypes: _List_Nil,
			enabledToolbarActions: $author$project$Components$DocumentsBrowser$allNonDocumentTypeToolbarActionsEnabled,
			maybeDefaultViewMode: $elm$core$Maybe$Nothing,
			maybeOnDone: params.onDone,
			pageContextData: {
				carrierInvoiceHasSubmission: $elm$core$Maybe$Nothing,
				carrierInvoiceId: $elm$core$Maybe$Nothing,
				loadStateId: $elm$core$Maybe$Just(params.loadStateId)
			},
			popout: false,
			scrollContainerSuffix: 'primary',
			viewPortHeightPxOffset: -200
		});
	var documentsBrowser = _v0.a;
	var documentsBrowserEffect = _v0.b;
	return _Utils_Tuple2(
		{
			documentBatchId: params.documentBatchId,
			documentIdsRequiringShipments: $author$project$Id$Set$fromList(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.id;
					},
					A4(
						$author$project$Components$NonInvoiceConfirmPage$documentsRequiringShipmentAssignment,
						data.shipments,
						data.documents,
						A2($elm$core$List$map, $author$project$Domain$UnresolvedDocumentType$fromPb, data.settings.nonInvoiceLoadDocumentTypes),
						A2($elm$core$List$map, $author$project$Domain$UnresolvedDocumentType$fromPb, data.tmsLoadDetails.customerVisibleDocumentTypes)))),
			documentsBrowser: documentsBrowser,
			expandedShipmentReferences: $author$project$Id$Set$empty,
			formState: $author$project$Components$NonInvoiceConfirmPage$Ready,
			loadStateId: params.loadStateId,
			nextUp: (!_Utils_eq(params.onDone, $elm$core$Maybe$Nothing)) ? $author$project$Components$NonInvoiceConfirmPage$Dashboard(params.onDone) : A2($author$project$Components$NonInvoiceConfirmPage$AnotherLoad, params.documentBatchId, data.documentBatch.emailMessageId),
			onDoneParam: params.onDone,
			presence: presence,
			selectedDocumentId: $elm$core$Maybe$Nothing,
			shipmentDocuments: $author$project$Components$NonInvoiceConfirmPage$initShipmentDocuments(data.shipments),
			timezone: $elm$time$Time$utc
		},
		$author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$cmd(
					A2($elm$core$Task$perform, $author$project$Components$NonInvoiceConfirmPage$SetTimezone, $author$project$Helpers$Date$localTimezone)),
					A2($author$project$HubTran$Effect$map, $author$project$Components$NonInvoiceConfirmPage$DocumentsBrowserMsg, documentsBrowserEffect)
				])));
};
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchSelection = F2(
	function (a, b) {
		return {$: 'DocumentBatchSelection', a: a, b: b};
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$documentBatch = function (documentBatchId) {
	return A2($author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchSelection, documentBatchId, $elm$core$Maybe$Nothing);
};
var $author$project$Broker$Shared$CurrentProcessingSelection$EmailMessageSelection = F3(
	function (a, b, c) {
		return {$: 'EmailMessageSelection', a: a, b: b, c: c};
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$email = F2(
	function (emailId, documentBatchId) {
		return A3($author$project$Broker$Shared$CurrentProcessingSelection$EmailMessageSelection, emailId, documentBatchId, $elm$core$Maybe$Nothing);
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$GroupedDocumentBatchSelection = F3(
	function (a, b, c) {
		return {$: 'GroupedDocumentBatchSelection', a: a, b: b, c: c};
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$groupedDocumentBatch = F2(
	function (batchId, groupId) {
		return A3($author$project$Broker$Shared$CurrentProcessingSelection$GroupedDocumentBatchSelection, batchId, groupId, $elm$core$Maybe$Nothing);
	});
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$processingSelection = function (documentSource) {
	var lowestDocGroupId = function (ids) {
		return $elm$core$List$head(
			A2($elm$core$List$sortBy, $author$project$Domain$DocumentGroupId$toComparable, ids));
	};
	switch (documentSource.$) {
		case 'FromFactorInvoice':
			var factorInvoice = documentSource.a.factorInvoice;
			return $author$project$Broker$Shared$CurrentProcessingSelection$factorInvoice(factorInvoice.id);
		case 'FromDocumentBatch':
			var source = documentSource.a;
			var documentBatch = source.documentBatch;
			var firstDocGroupId = lowestDocGroupId(source.documentGroupIds);
			if (firstDocGroupId.$ === 'Just') {
				var groupId = firstDocGroupId.a;
				return A2($author$project$Broker$Shared$CurrentProcessingSelection$groupedDocumentBatch, documentBatch.id, groupId);
			} else {
				return $author$project$Broker$Shared$CurrentProcessingSelection$documentBatch(documentBatch.id);
			}
		default:
			var source = documentSource.a;
			var email = source.email;
			var firstDocGroupId = A2($elm$core$Maybe$andThen, lowestDocGroupId, source.documentGroupIds);
			var _v2 = _Utils_Tuple2(email.documentBatchId, firstDocGroupId);
			if ((_v2.a.$ === 'Just') && (_v2.b.$ === 'Just')) {
				var documentBatchId = _v2.a.a;
				var groupId = _v2.b.a;
				return A2($author$project$Broker$Shared$CurrentProcessingSelection$groupedDocumentBatch, documentBatchId, groupId);
			} else {
				return A2($author$project$Broker$Shared$CurrentProcessingSelection$email, email.id, email.documentBatchId);
			}
	}
};
var $author$project$Components$ReadonlyFactorInvoicePage$init = function (initData) {
	var _v0 = $author$project$Components$DocumentsBrowser$init(
		{
			currentProcessingSelection: $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$processingSelection(initData.documentSource),
			displayUnassignedLoadDocuments: initData.accountSettings.showAllLoadDocsEnabled,
			enabledDocumentTypes: _List_Nil,
			enabledToolbarActions: _List_Nil,
			maybeDefaultViewMode: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$DefaultViewModeHeight),
			maybeOnDone: $elm$core$Maybe$Nothing,
			pageContextData: $author$project$Helpers$DocumentViewerPageContextData$empty,
			popout: true,
			scrollContainerSuffix: 'primary',
			viewPortHeightPxOffset: 0
		});
	var documentsBrowser = _v0.a;
	var documentsBrowserEffect = _v0.b;
	var model = {accountSettings: initData.accountSettings, documentSource: initData.documentSource, documentsBrowser: documentsBrowser};
	var effect = A2($author$project$HubTran$Effect$map, $author$project$Components$ReadonlyFactorInvoicePage$DocumentsBrowserMsg, documentsBrowserEffect);
	return _Utils_Tuple2(model, effect);
};
var $author$project$Main$initDataLoaded = function (_v0) {
	var initDataResult = _v0.initDataResult;
	var pageMsg = _v0.pageMsg;
	var page = _v0.page;
	var pageInit = _v0.pageInit;
	var model = _v0.model;
	if (initDataResult.$ === 'Ok') {
		var initData = initDataResult.a;
		var _v2 = A2(
			$elm$core$Tuple$mapSecond,
			$author$project$HubTran$Effect$map(pageMsg),
			A2(
				$elm$core$Tuple$mapFirst,
				page,
				pageInit(initData)));
		var newPage = _v2.a;
		var pageEffect = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{page: newPage}),
			A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
	} else {
		var error = initDataResult.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					page: $author$project$Main$LoadingFailedPage(error)
				}),
			$author$project$HubTran$Effect$none);
	}
};
var $author$project$Js$navigateToReactPath = _Platform_outgoingPort('navigateToReactPath', $elm$json$Json$Encode$string);
var $author$project$Js$openBeamer = _Platform_outgoingPort(
	'openBeamer',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Js$openUrlInNewTab = _Platform_outgoingPort('openUrlInNewTab', $elm$json$Json$Encode$string);
var $author$project$Main$overrideRemoteDataForReskin = F2(
	function (model, data) {
		var reskinVals = model.headerFlags.reskinVals;
		var overrideAccountSettings = function (accountSettings) {
			return _Utils_update(
				accountSettings,
				{auditV3ReactStyleOverrides: reskinVals.indexAudit, auditV3ReskinEnabledQueues: reskinVals.queues, auditV3ReskinEnabledSettings: reskinVals.settings, auditV3ReskinEnabledTopLevel: reskinVals.topLevel});
		};
		var overrideDataAccountSettings = $author$project$Forward$Remote$map(
			function (dataWithAccountSettings) {
				var accountSettings = dataWithAccountSettings.accountSettings;
				return _Utils_update(
					dataWithAccountSettings,
					{
						accountSettings: overrideAccountSettings(accountSettings)
					});
			});
		var overrideDataSettings = $author$project$Forward$Remote$map(
			function (dataWithAccountSettings) {
				var settings = dataWithAccountSettings.settings;
				return _Utils_update(
					dataWithAccountSettings,
					{
						settings: overrideAccountSettings(settings)
					});
			});
		var overrideDocumentsBrowserData = function (rd) {
			return A2(
				$author$project$Forward$Remote$map,
				function (d) {
					return _Utils_update(
						d,
						{
							documentsBrowserData: A2(
								$author$project$Forward$Remote$map,
								function (dvd) {
									return _Utils_update(
										dvd,
										{
											accountSettings: overrideAccountSettings(dvd.accountSettings)
										});
								},
								d.documentsBrowserData)
						});
				},
				rd);
		};
		return A2(
			$author$project$Forward$Remote$map,
			function (pageData) {
				switch (pageData.$) {
					case 'BlankPageData':
						return pageData;
					case 'LoadingPageData':
						return pageData;
					case 'LoadingFailedPageData':
						return pageData;
					case 'ActivityPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$ActivityPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'BrokerBillingRequirementsPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$BrokerBillingRequirementsPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'ClientSubmissionInvoicePageData':
						return pageData;
					case 'ClientSubmissionPageData':
						return pageData;
					case 'ClientSubmissionReviewPageData':
						return pageData;
					case 'DashboardPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$DashboardPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'DocumentsViewerPopoutPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$DocumentsViewerPopoutPageData,
							p,
							overrideDocumentsBrowserData(
								overrideDataAccountSettings(rd)));
					case 'EmailMessageSearchPageData':
						return pageData;
					case 'HelpPageData':
						return pageData;
					case 'NonInvoiceConfirmPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$NonInvoiceConfirmPageData,
							p,
							overrideDocumentsBrowserData(
								overrideDataSettings(rd)));
					case 'OktaLoginPageData':
						return pageData;
					case 'SettingsPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsCarriersPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsCarriersPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsCarrierPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsCarrierPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsCustomersPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsCustomersPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsCustomerPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsCustomerPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsReferenceFieldsPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsReferenceFieldsPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsReportsPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsReportsPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsRulesPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsRulesPageData,
							p,
							overrideDataSettings(rd));
					case 'SettingsUsersPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsUsersPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsUserPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsUserPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsDebtorPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsDebtorPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'SettingsVerificationsPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$SettingsVerificationsPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'TermsPageData':
						return pageData;
					case 'VerificationBatchPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$VerificationBatchPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'LtlReconcileInvoicePageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$LtlReconcileInvoicePageData,
							p,
							overrideDocumentsBrowserData(
								overrideDataAccountSettings(rd)));
					case 'CarrierInvoiceAuditPageData':
						return pageData;
					case 'FactorInvoiceAuditPageData':
						return pageData;
					case 'FactorInvoiceAuditBatchGroupingPageData':
						return pageData;
					case 'FactorInvoiceAuditBatchPageData':
						return pageData;
					case 'ForwardingHasMovedPageData':
						return pageData;
					case 'MyClientsOverviewPageData':
						return pageData;
					case 'NoaManagementToSendPageData':
						return pageData;
					case 'DebtorChangesPageData':
						return pageData;
					case 'DebtorChangesTemplatePageData':
						return pageData;
					case 'NoaManagementSentPageData':
						return pageData;
					case 'NoaManagementSkippedPageData':
						return pageData;
					case 'DocumentReviewPageData':
						return pageData;
					case 'DocumentBatchReviewPageData':
						return pageData;
					case 'DocumentGroupReviewPageData':
						return pageData;
					case 'LtlHeldSubmissionsPageData':
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$LtlHeldSubmissionsPageData,
							p,
							overrideDataAccountSettings(rd));
					case 'EmailMergePageData':
						return pageData;
					case 'ReadonlyFactorInvoicePageData':
						return pageData;
					default:
						var p = pageData.a;
						var rd = pageData.b;
						return A2(
							$author$project$Main$ToBeScrapedLoadsPageData,
							p,
							overrideDataAccountSettings(rd));
				}
			},
			data);
	});
var $author$project$Main$presencePath = F2(
	function (pathname, pageRequest) {
		if (pageRequest.$ === 'CarrierInvoiceAuditPageRequest') {
			var loadStateId = pageRequest.b;
			return pathname + ('?loadId=' + $elm$core$String$fromInt(
				$author$project$Domain$LoadStateId$toInt(loadStateId)));
		} else {
			return pathname;
		}
	});
var $author$project$Main$resetHeaderSearch = function (model) {
	return _Utils_update(
		model,
		{headerSearchRemote: $elm$core$Maybe$Nothing, headerSearchTerm: ''});
};
var $author$project$Main$searchEndpoint = function (model) {
	return model.headerFlags.isFactor ? '/api/load_searches/factor_quick_search' : '/api/load_searches/by_location';
};
var $author$project$Main$pageUsesPresence = function (page) {
	switch (page.$) {
		case 'ClientSubmissionInvoicePage':
			return true;
		case 'ClientSubmissionReviewPage':
			return true;
		case 'VerificationBatchPage':
			return true;
		case 'NonInvoiceConfirmPage':
			return true;
		case 'DocumentReviewPage':
			return true;
		case 'DocumentBatchReviewPage':
			return true;
		case 'FactorInvoiceAuditBatchPage':
			return true;
		case 'FactorInvoiceAuditPage':
			return true;
		case 'CarrierInvoiceAuditPage':
			return true;
		default:
			return false;
	}
};
var $author$project$Main$setUserPresenceIfInterested = F3(
	function (pathname, previousPage, newPage) {
		return ($author$project$Main$pageUsesPresence(newPage) || $author$project$Main$pageUsesPresence(previousPage)) ? $author$project$HubTran$Effect$cmd(
			$author$project$Js$setUserPresence(pathname)) : $author$project$HubTran$Effect$none;
	});
var $author$project$Main$shouldRetainState = F2(
	function (oldPageData, pageRequest) {
		var _v0 = _Utils_Tuple2(oldPageData, pageRequest);
		_v0$7:
		while (true) {
			if (_v0.a.$ === 'Loaded') {
				switch (_v0.a.a.$) {
					case 'DashboardPageData':
						switch (_v0.b.$) {
							case 'NewDashboardRequest':
								var _v1 = _v0.a.a;
								var _v2 = _v0.b;
								return false;
							case 'DashboardRequestWithArguments':
								var _v3 = _v0.a.a;
								var oldDashboard = _v3.a;
								var oldDashboardData = _v3.b;
								var _v4 = _v0.b;
								var requestedDashboardMode = _v4.e;
								var oldMode = $elm$core$Maybe$Just(oldDashboard.dashboardMode);
								var newMode = A2(
									$elm$core$Maybe$map,
									function (data) {
										return A3($author$project$Components$DashboardPage$initDashboardMode, data.accountSettings, data.currentUser, requestedDashboardMode);
									},
									$author$project$Forward$Remote$toMaybe(oldDashboardData));
								return _Utils_eq(oldMode, newMode);
							default:
								break _v0$7;
						}
					case 'EmailMessageSearchPageData':
						if (_v0.b.$ === 'EmailMessageSearchPageRequest') {
							var _v5 = _v0.a.a;
							return true;
						} else {
							break _v0$7;
						}
					case 'MyClientsOverviewPageData':
						if (_v0.b.$ === 'MyClientsOverviewPageRequest') {
							var _v6 = _v0.a.a;
							return true;
						} else {
							break _v0$7;
						}
					case 'DebtorChangesPageData':
						if (_v0.b.$ === 'DebtorChangesPageRequest') {
							var _v7 = _v0.a.a;
							return true;
						} else {
							break _v0$7;
						}
					case 'DebtorChangesTemplatePageData':
						if (_v0.b.$ === 'DebtorChangesTemplatePageRequest') {
							var _v8 = _v0.a.a;
							return true;
						} else {
							break _v0$7;
						}
					case 'ToBeScrapedLoadsPageData':
						if (_v0.b.$ === 'ToBeScrapedLoadsPageRequest') {
							var _v9 = _v0.a.a;
							return true;
						} else {
							break _v0$7;
						}
					default:
						break _v0$7;
				}
			} else {
				break _v0$7;
			}
		}
		return false;
	});
var $author$project$Js$switchGroupUserAccount = _Platform_outgoingPort('switchGroupUserAccount', $elm$json$Json$Encode$int);
var $author$project$Js$toggleReskinUser = _Platform_outgoingPort('toggleReskinUser', $elm$json$Json$Encode$bool);
var $author$project$Components$Flash$FadeOut = F2(
	function (a, b) {
		return {$: 'FadeOut', a: a, b: b};
	});
var $ianmackenzie$elm_units$Duration$milliseconds = function (numMilliseconds) {
	return $ianmackenzie$elm_units$Duration$seconds(0.001 * numMilliseconds);
};
var $author$project$Components$Flash$fadeOutTime = $ianmackenzie$elm_units$Duration$milliseconds(9700.0);
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			nodeList: _List_Nil,
			nodeListSize: 0,
			tail: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.nodeListSize * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						nodeList: A2($elm$core$List$cons, mappedLeaf, builder.nodeList),
						nodeListSize: builder.nodeListSize + 1,
						tail: builder.tail
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $ianmackenzie$elm_units$Duration$subtractFrom = F2(
	function (time, duration) {
		return $elm$time$Time$millisToPosix(
			$elm$time$Time$posixToMillis(time) - $elm$core$Basics$round(
				$ianmackenzie$elm_units$Duration$inMilliseconds(duration)));
	});
var $author$project$Components$Flash$markForHide = F3(
	function (index, currentTime, arr) {
		return A2(
			$elm$core$Array$indexedMap,
			F2(
				function (idx, item) {
					return _Utils_eq(idx, index) ? _Utils_update(
						item,
						{
							indefinite: false,
							time: $elm$core$Maybe$Just(
								$elm$time$Time$posixToMillis(
									A2($ianmackenzie$elm_units$Duration$subtractFrom, currentTime, $author$project$Components$Flash$fadeOutTime)))
						}) : item;
				}),
			arr);
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (value.$ === 'SubTree') {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $author$project$Components$Flash$removeTime = $ianmackenzie$elm_units$Duration$milliseconds(10000.0);
var $author$project$Components$Flash$update = F2(
	function (action, model) {
		switch (action.$) {
			case 'FadeOut':
				var index = action.a;
				var currentTime = action.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							messages: A3($author$project$Components$Flash$markForHide, index, currentTime, model.messages)
						}),
					$author$project$HubTran$Effect$none);
			case 'MarkForRemoval':
				var index = action.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						A2(
							$elm$core$Task$perform,
							$author$project$Components$Flash$FadeOut(index),
							$elm$time$Time$now)));
			case 'MessageReceived':
				var message = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							messages: A2($elm$core$Array$push, message, model.messages)
						}),
					$author$project$HubTran$Effect$none);
			default:
				var time = action.a;
				var filteredMessages = A2(
					$elm$core$Array$filter,
					function (m) {
						return (_Utils_cmp(
							$elm$time$Time$posixToMillis(time) - A2($elm$core$Maybe$withDefault, 0, m.time),
							$ianmackenzie$elm_units$Duration$inMilliseconds($author$project$Components$Flash$removeTime)) < 0) || m.indefinite;
					},
					model.messages);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							currentTime: $elm$core$Maybe$Just(time),
							messages: filteredMessages
						}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Ui$V3$Header$NoOp = {$: 'NoOp'};
var $author$project$Ui$V3$Header$accountListDomId = 'header-menu--account-list';
var $author$project$Ui$V3$Header$currentAccountDomId = 'header-menu--current-account';
var $author$project$Ui$V3$Header$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'ToggleMenu':
				var shouldOpen = msg.a.shouldOpen;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isMenuOpen: shouldOpen}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleSettings':
				var shouldOpen = msg.a.shouldOpen;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSettingsOpen: shouldOpen}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleAccounts':
				var shouldOpen = msg.a.shouldOpen;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isAccountsOpen: shouldOpen}),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Ui$V3$Header$NoOp),
						A2(
							$elm$core$Task$andThen,
							function (_v1) {
								var viewport = _v1.viewport;
								var element = _v1.element;
								var y = element.y - (viewport.height / 2);
								return A3($elm$browser$Browser$Dom$setViewportOf, $author$project$Ui$V3$Header$accountListDomId, 0, y);
							},
							$elm$browser$Browser$Dom$getElement($author$project$Ui$V3$Header$currentAccountDomId))));
			case 'CollapseSettings':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSettingsOpen: false}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$SettingsCustomerPageMsg = function (a) {
	return {$: 'SettingsCustomerPageMsg', a: a};
};
var $author$project$Main$SettingsCustomersPageMsg = function (a) {
	return {$: 'SettingsCustomersPageMsg', a: a};
};
var $author$project$Broker$Shared$CurrentProcessingSelection$carrierInvoiceIdDecoder = A2($elm$json$Json$Decode$field, 'carrierInvoiceId', $author$project$Domain$CarrierInvoiceId$decode);
var $author$project$Broker$Shared$CurrentProcessingSelection$maybeCarrierInvoiceIdFromValue = function (maybeValue) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$decodeValue($author$project$Broker$Shared$CurrentProcessingSelection$carrierInvoiceIdDecoder),
			$elm$core$Result$toMaybe),
		maybeValue);
};
var $author$project$Broker$Shared$CurrentProcessingSelection$customerIdDecoder = A2($elm$json$Json$Decode$field, 'customerId', $elm$json$Json$Decode$int);
var $author$project$Broker$Shared$CurrentProcessingSelection$maybeCustomerIdFromValue = function (maybeValue) {
	return A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$decodeValue($author$project$Broker$Shared$CurrentProcessingSelection$customerIdDecoder),
			$elm$core$Result$toMaybe),
		maybeValue);
};
var $author$project$Broker$Page$BillingRequirements$update = F2(
	function (msg, model) {
		if (msg.$ === 'CurrentProcessingSelectionUpdated') {
			var value = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						selectedCarrierInvoiceId: $author$project$Broker$Shared$CurrentProcessingSelection$maybeCarrierInvoiceIdFromValue(value),
						selectedCustomerId: $author$project$Broker$Shared$CurrentProcessingSelection$maybeCustomerIdFromValue(value)
					}),
				$author$project$HubTran$Effect$none);
		} else {
			var value = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						selectedCustomerId: $elm$core$String$toInt(value)
					}),
				$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Js$closeDocumentViewer = _Platform_outgoingPort('closeDocumentViewer', $elm$core$Basics$identity);
var $author$project$Broker$Page$DocumentsViewerPopout$closeDocumentViewerEffect = function (document) {
	var _v0 = document.documentBatchId;
	if (_v0.$ === 'Just') {
		var documentBatchId = _v0.a;
		var encodedUrl = $elm$json$Json$Encode$string(
			A2(
				$elm$core$String$append,
				'/index-document-batches/',
				$elm$core$String$fromInt(
					$author$project$Domain$DocumentBatchId$toInt(documentBatchId))));
		var encodedInvoiceId = A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Encode$int,
				$elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2($elm$core$Maybe$map, $author$project$Domain$CarrierInvoiceId$toInt, document.carrierInvoiceId),
								A2($elm$core$Maybe$map, $author$project$Domain$FactorInvoiceId$toInt, document.factorInvoiceId)
							])))));
		return $author$project$HubTran$Effect$cmd(
			$author$project$Js$closeDocumentViewer(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2('forwardUrl', encodedUrl),
							_Utils_Tuple2('invoiceId', encodedInvoiceId)
						]))));
	} else {
		return $author$project$HubTran$Effect$none;
	}
};
var $author$project$Broker$Shared$CurrentProcessingSelection$documentPageIdDecoder = A2($elm$json$Json$Decode$field, 'documentPageId', $author$project$Domain$DocumentPageId$decode);
var $author$project$Broker$Shared$CurrentProcessingSelection$maybeDocumentPageIdDecoder = $elm$json$Json$Decode$maybe($author$project$Broker$Shared$CurrentProcessingSelection$documentPageIdDecoder);
var $author$project$Broker$Shared$CurrentProcessingSelection$carrierInvoiceSelectionDecoder = A3($elm$json$Json$Decode$map2, $author$project$Broker$Shared$CurrentProcessingSelection$CarrierInvoiceSelection, $author$project$Broker$Shared$CurrentProcessingSelection$carrierInvoiceIdDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$maybeDocumentPageIdDecoder);
var $author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdDecoder = A2($elm$json$Json$Decode$field, 'documentBatchId', $author$project$Domain$DocumentBatchId$decode);
var $author$project$Broker$Shared$CurrentProcessingSelection$documentBatchSelectionDecoder = A3($elm$json$Json$Decode$map2, $author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchSelection, $author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$maybeDocumentPageIdDecoder);
var $author$project$Broker$Shared$CurrentProcessingSelection$emailIdDecoder = A2($elm$json$Json$Decode$field, 'emailId', $author$project$Domain$EmailMessageId$decode);
var $author$project$Broker$Shared$CurrentProcessingSelection$emailSelectionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Broker$Shared$CurrentProcessingSelection$EmailMessageSelection,
	$author$project$Broker$Shared$CurrentProcessingSelection$emailIdDecoder,
	$elm$json$Json$Decode$maybe($author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdDecoder),
	$author$project$Broker$Shared$CurrentProcessingSelection$maybeDocumentPageIdDecoder);
var $author$project$Broker$Shared$CurrentProcessingSelection$factorInvoiceIdDecoder = A2($elm$json$Json$Decode$field, 'factorInvoiceId', $author$project$Domain$FactorInvoiceId$decode);
var $author$project$Broker$Shared$CurrentProcessingSelection$factorInvoiceSelectionDecoder = A3($elm$json$Json$Decode$map2, $author$project$Broker$Shared$CurrentProcessingSelection$FactorInvoiceSelection, $author$project$Broker$Shared$CurrentProcessingSelection$factorInvoiceIdDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$maybeDocumentPageIdDecoder);
var $author$project$Broker$Shared$CurrentProcessingSelection$groupedDocumentBatchSelectionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Broker$Shared$CurrentProcessingSelection$GroupedDocumentBatchSelection,
	$author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdDecoder,
	A2($elm$json$Json$Decode$field, 'documentGroupId', $author$project$Domain$DocumentGroupId$decode),
	$author$project$Broker$Shared$CurrentProcessingSelection$maybeDocumentPageIdDecoder);
var $author$project$Broker$Shared$CurrentProcessingSelection$nonInvoiceLoadSelectionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Broker$Shared$CurrentProcessingSelection$NonInvoiceLoadSelection,
	A2($elm$json$Json$Decode$field, 'loadStateId', $author$project$Domain$LoadStateId$decode),
	$author$project$Broker$Shared$CurrentProcessingSelection$documentBatchIdDecoder,
	$author$project$Broker$Shared$CurrentProcessingSelection$maybeDocumentPageIdDecoder);
var $author$project$Broker$Shared$CurrentProcessingSelection$SinglePageSelection = function (a) {
	return {$: 'SinglePageSelection', a: a};
};
var $author$project$Broker$Shared$CurrentProcessingSelection$singlePageSelectionDecoder = A2($elm$json$Json$Decode$map, $author$project$Broker$Shared$CurrentProcessingSelection$SinglePageSelection, $author$project$Broker$Shared$CurrentProcessingSelection$documentPageIdDecoder);
var $author$project$Broker$Shared$CurrentProcessingSelection$decodeToSelection = function (value) {
	return A2(
		$elm$core$Result$withDefault,
		$author$project$Broker$Shared$CurrentProcessingSelection$NoSelection,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[$author$project$Broker$Shared$CurrentProcessingSelection$carrierInvoiceSelectionDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$groupedDocumentBatchSelectionDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$emailSelectionDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$documentBatchSelectionDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$singlePageSelectionDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$factorInvoiceSelectionDecoder, $author$project$Broker$Shared$CurrentProcessingSelection$nonInvoiceLoadSelectionDecoder])),
			value));
};
var $author$project$Broker$Shared$CurrentProcessingSelection$decodeFromValue = function (maybeValue) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Broker$Shared$CurrentProcessingSelection$NoSelection,
		A2($elm$core$Maybe$map, $author$project$Broker$Shared$CurrentProcessingSelection$decodeToSelection, maybeValue));
};
var $author$project$AuditPb$DocumentViewerPageContextData = F3(
	function (carrierInvoiceId, loadStateId, carrierInvoiceHasSubmission) {
		return {carrierInvoiceHasSubmission: carrierInvoiceHasSubmission, carrierInvoiceId: carrierInvoiceId, loadStateId: loadStateId};
	});
var $author$project$AuditPb$documentViewerPageContextDataDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'carrierInvoiceHasSubmission',
			$elm$json$Json$Decode$bool,
			A3(
				$author$project$AuditPb$optional,
				'loadStateId',
				A2($elm$json$Json$Decode$map, $author$project$Domain$LoadStateId$fromInt, $author$project$AuditPb$intDecoder),
				A3(
					$author$project$AuditPb$optional,
					'carrierInvoiceId',
					A2($elm$json$Json$Decode$map, $author$project$Domain$CarrierInvoiceId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$DocumentViewerPageContextData))));
	});
var $author$project$Helpers$DocumentViewerPageContextData$decode = function (value) {
	return A2(
		$elm$core$Result$withDefault,
		$author$project$Helpers$DocumentViewerPageContextData$empty,
		A2($elm$json$Json$Decode$decodeValue, $author$project$AuditPb$documentViewerPageContextDataDecoder, value));
};
var $author$project$Helpers$DocumentViewerPageContextData$decodeMaybe = function (maybeEncodedData) {
	return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Helpers$DocumentViewerPageContextData$empty, $author$project$Helpers$DocumentViewerPageContextData$decode, maybeEncodedData);
};
var $author$project$AuditPb$documentPODUpdateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'documentId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentId$toInt),
					v.documentId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'isPOD', $elm$json$Json$Encode$bool, v.isPOD)
				])));
};
var $author$project$Js$documentPageLineFromPopout = _Platform_outgoingPort('documentPageLineFromPopout', $elm$json$Json$Encode$string);
var $author$project$HubTran$Effect$invalidateAll = $author$project$HubTran$Effect$ForwardEffect($author$project$Forward$Internal$PureEffectManagerCmd$InvalidateAll);
var $author$project$Components$DocumentsBrowser$setCurrentProcessingSelection = F2(
	function (currentProcessingSelection_, model) {
		return _Utils_update(
			model,
			{currentProcessingSelection: currentProcessingSelection_});
	});
var $author$project$Js$setDocumentPodUpdate = _Platform_outgoingPort('setDocumentPodUpdate', $elm$core$Basics$identity);
var $author$project$Components$DocumentsBrowser$setHighlight = F2(
	function (highlight, model) {
		return _Utils_update(
			model,
			{highlight: highlight});
	});
var $author$project$Components$DocumentsBrowser$maybeSelectedDocumentPageId = function (selectedEntityId) {
	switch (selectedEntityId.$) {
		case 'GroupedDocumentBatchSelection':
			var maybeDocumentPageId = selectedEntityId.c;
			return maybeDocumentPageId;
		case 'DocumentBatchSelection':
			var maybeDocumentPageId = selectedEntityId.b;
			return maybeDocumentPageId;
		case 'EmailMessageSelection':
			var maybeDocumentPageId = selectedEntityId.c;
			return maybeDocumentPageId;
		case 'CarrierInvoiceSelection':
			var maybeDocumentPageId = selectedEntityId.b;
			return maybeDocumentPageId;
		case 'FactorInvoiceSelection':
			var maybeDocumentPageId = selectedEntityId.b;
			return maybeDocumentPageId;
		case 'SinglePageSelection':
			var documentPageId = selectedEntityId.a;
			return $elm$core$Maybe$Just(documentPageId);
		case 'NonInvoiceLoadSelection':
			var maybeDocumentPageId = selectedEntityId.c;
			return maybeDocumentPageId;
		case 'DocumentReviewSelection':
			var maybeDocumentPageId = selectedEntityId.b;
			return maybeDocumentPageId;
		case 'DocumentBatchReviewSelection':
			var maybeDocumentPageId = selectedEntityId.c;
			return maybeDocumentPageId;
		case 'DocumentGroupReviewSelection':
			var maybeDocumentPageId = selectedEntityId.c;
			return maybeDocumentPageId;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$DocumentsBrowser$setMaybeSelectedDocumentPageId = F2(
	function (currentProcessingSelection, model) {
		return _Utils_update(
			model,
			{
				maybeSelectedDocumentPageId: $author$project$Components$DocumentsBrowser$maybeSelectedDocumentPageId(currentProcessingSelection)
			});
	});
var $author$project$Components$DocumentsBrowser$NoOp = {$: 'NoOp'};
var $author$project$Components$DocumentsBrowser$ZoomIn = {$: 'ZoomIn'};
var $author$project$Components$DocumentsBrowser$ZoomOut = {$: 'ZoomOut'};
var $author$project$Components$DocumentsBrowser$SelectDocument = F2(
	function (a, b) {
		return {$: 'SelectDocument', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$Full$GroupedDocuments = F2(
	function (a, b) {
		return {$: 'GroupedDocuments', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$Full$UngroupedDocuments = function (a) {
	return {$: 'UngroupedDocuments', a: a};
};
var $author$project$Components$DocumentsBrowser$withPendingHidden = F2(
	function (model, documentData) {
		var withHidden = function (document) {
			return _Utils_update(
				document,
				{
					hidden: A2(
						$elm$core$Maybe$withDefault,
						document.hidden,
						A2(
							$elm$core$Dict$get,
							$author$project$Domain$DocumentId$toComparable(document.id),
							model.pendingHidden))
				});
		};
		return _Utils_update(
			documentData,
			{
				documents: A2($elm$core$List$map, withHidden, documentData.documents)
			});
	});
var $author$project$Components$DocumentsBrowser$getDocumentData = F2(
	function (data, model) {
		var _v0 = model.currentProcessingSelection;
		switch (_v0.$) {
			case 'GroupedDocumentBatchSelection':
				var documentGroupId_ = _v0.b;
				return A2(
					$author$project$Components$DocumentsBrowser$withPendingHidden,
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$DocumentsBrowser$emptyDocumentData,
						A2(
							$elm$core$Dict$get,
							$author$project$Domain$DocumentGroupId$toComparable(documentGroupId_),
							data.groupedDocumentData.browserDocumentDataByGroupId)));
			case 'NoSelection':
				return $author$project$Components$DocumentsBrowser$emptyDocumentData;
			default:
				return A2($author$project$Components$DocumentsBrowser$withPendingHidden, model, data.documentData.browserDocumentData);
		}
	});
var $author$project$Components$DocumentsBrowser$getPossiblyGroupedDocuments = F2(
	function (data, model) {
		var _v0 = model.currentProcessingSelection;
		if (_v0.$ === 'GroupedDocumentBatchSelection') {
			var documentGroupId = _v0.b;
			return A2(
				$author$project$Components$DocumentBrowser$Full$GroupedDocuments,
				$author$project$Domain$DocumentGroupId$toComparable(documentGroupId),
				A2(
					$elm$core$Dict$map,
					function (_v1) {
						return $author$project$Components$DocumentsBrowser$withPendingHidden(model);
					},
					data.groupedDocumentData.browserDocumentDataByGroupId));
		} else {
			return $author$project$Components$DocumentBrowser$Full$UngroupedDocuments(
				A2($author$project$Components$DocumentsBrowser$getDocumentData, data, model));
		}
	});
var $author$project$Components$DocumentBrowser$Full$getSelectedDocumentData = function (possiblyGroupedDocs) {
	if (possiblyGroupedDocs.$ === 'UngroupedDocuments') {
		var docs = possiblyGroupedDocs.a;
		return docs;
	} else {
		var key = possiblyGroupedDocs.a;
		var dict = possiblyGroupedDocs.b;
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$DocumentBrowser$Full$DocumentData, _List_Nil, _List_Nil),
			A2($elm$core$Dict$get, key, dict));
	}
};
var $author$project$Components$DocumentBrowser$Full$selectedDocumentPage = F2(
	function (documents, selection) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm_community$list_extra$List$Extra$getAt(selection.pageIndex),
			A2(
				$elm_community$list_extra$List$Extra$getAt,
				selection.documentIndex,
				$author$project$Components$DocumentBrowser$Full$getSelectedDocumentData(documents).documentPages));
	});
var $author$project$Components$DocumentsBrowser$buildSelectDocumentMsg = F3(
	function (data, model, selection) {
		var possiblyGroupedDocuments = A2($author$project$Components$DocumentsBrowser$getPossiblyGroupedDocuments, data, model);
		var documentPage = A2($author$project$Components$DocumentBrowser$Full$selectedDocumentPage, possiblyGroupedDocuments, selection);
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Components$DocumentsBrowser$NoOp,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.id;
				},
				$author$project$Components$DocumentsBrowser$SelectDocument(selection)),
			documentPage);
	});
var $author$project$Components$DocumentsBrowser$canZoomIn = function (zoomLevel) {
	return zoomLevel < 3;
};
var $author$project$Components$DocumentsBrowser$canZoomOut = function (zoomLevel) {
	return zoomLevel > 1;
};
var $author$project$Domain$FactorInvoice$isAtLeastApproved = function (invoiceState) {
	switch (invoiceState.$) {
		case 'Approved':
			return true;
		case 'Verified':
			return true;
		case 'Purchased':
			return true;
		case 'Draft':
			return false;
		case 'Exception':
			return false;
		case 'Abandoned':
			return false;
		case 'Processed':
			return false;
		case 'Verifying':
			return false;
		default:
			return false;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 'Nothing') {
		return true;
	} else {
		return false;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 'Nothing') {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Components$DocumentsBrowser$selectedDocumentGroupId = function (model) {
	var _v0 = model.currentProcessingSelection;
	if (_v0.$ === 'GroupedDocumentBatchSelection') {
		var documentGroupId = _v0.b;
		return $elm$core$Maybe$Just(documentGroupId);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$DocumentsBrowser$hideEnabled = F2(
	function (_v0, model) {
		var invoiceStateByGroupId = _v0.invoiceStateByGroupId;
		var factorInvoiceState = _v0.factorInvoiceState;
		var carrierInvoice = _v0.carrierInvoice;
		var groupInvoiceNotApproved = A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Domain$FactorInvoice$isAtLeastApproved, $elm$core$Basics$not),
			$elm_community$maybe_extra$Maybe$Extra$join(
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (groupId, states) {
							return A2(
								$elm$core$Dict$get,
								$author$project$Domain$DocumentGroupId$toComparable(groupId),
								states);
						}),
					$author$project$Components$DocumentsBrowser$selectedDocumentGroupId(model),
					$author$project$Forward$Remote$toMaybe(invoiceStateByGroupId))));
		var factorInvoiceNotApproved = A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Domain$FactorInvoice$isAtLeastApproved, $elm$core$Basics$not),
			factorInvoiceState);
		var carrierInvoiceNotApproved = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.approvedAt;
				},
				$elm_community$maybe_extra$Maybe$Extra$isNothing),
			carrierInvoice);
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				groupInvoiceNotApproved,
				A2($elm_community$maybe_extra$Maybe$Extra$orElse, factorInvoiceNotApproved, carrierInvoiceNotApproved)));
	});
var $author$project$Components$DocumentsBrowser$Hide = F3(
	function (a, b, c) {
		return {$: 'Hide', a: a, b: b, c: c};
	});
var $author$project$Components$DocumentsBrowser$hideMsg = F3(
	function (data, model, selection) {
		var documentData = A2($author$project$Components$DocumentsBrowser$getDocumentData, data, model);
		var maybeDoc = A2($elm_community$list_extra$List$Extra$getAt, selection.documentIndex, documentData.documents);
		var maybeDocPage = A2(
			$elm$core$Maybe$andThen,
			$elm_community$list_extra$List$Extra$getAt(selection.pageIndex),
			A2($elm_community$list_extra$List$Extra$getAt, selection.documentIndex, documentData.documentPages));
		var _v0 = _Utils_Tuple2(maybeDocPage, maybeDoc);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var docPage = _v0.a.a;
			var doc = _v0.b.a;
			return A3($author$project$Components$DocumentsBrowser$Hide, doc.id, docPage.id, !doc.hidden);
		} else {
			return $author$project$Components$DocumentsBrowser$NoOp;
		}
	});
var $author$project$Components$DocumentsBrowser$Rotate = F2(
	function (a, b) {
		return {$: 'Rotate', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$Full$Selection = F2(
	function (documentIndex, pageIndex) {
		return {documentIndex: documentIndex, pageIndex: pageIndex};
	});
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Components$DocumentsBrowser$findPageIndexForDocument = F3(
	function (documentPageIdToFind, documentIndex, documentPages) {
		return A2(
			$elm$core$Maybe$map,
			function (pageIndex) {
				return A2($author$project$Components$DocumentBrowser$Full$Selection, documentIndex, pageIndex);
			},
			A2(
				$elm_community$list_extra$List$Extra$elemIndex,
				documentPageIdToFind,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.id;
					},
					documentPages)));
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 'Nothing') {
		return false;
	} else {
		return true;
	}
};
var $author$project$Components$DocumentsBrowser$findSelection = F2(
	function (documentPagesList, documentPageIdToFind) {
		return $author$project$Helpers$Maybe$join(
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					$elm_community$maybe_extra$Maybe$Extra$isJust,
					A2(
						$elm$core$List$indexedMap,
						$author$project$Components$DocumentsBrowser$findPageIndexForDocument(documentPageIdToFind),
						documentPagesList))));
	});
var $author$project$Components$DocumentsBrowser$findSelectionFromDocumentData = F2(
	function (documentData, documentPageIdToFind) {
		return A2($author$project$Components$DocumentsBrowser$findSelection, documentData.documentPages, documentPageIdToFind);
	});
var $author$project$Components$DocumentsBrowser$selectedPage = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model.selectedPage_INTERNAL,
			$author$project$Helpers$Maybe$join(
				A2(
					$elm$core$Maybe$map,
					function (selectedDocumentPageId) {
						return A2(
							$author$project$Components$DocumentsBrowser$findSelectionFromDocumentData,
							A2($author$project$Components$DocumentsBrowser$getDocumentData, data, model),
							selectedDocumentPageId);
					},
					model.maybeSelectedDocumentPageId)));
	});
var $author$project$Components$DocumentsBrowser$selectedPageFromRemote = F2(
	function (remoteData, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model.selectedPage_INTERNAL,
			A2(
				$elm$core$Maybe$map,
				function (data) {
					return A2($author$project$Components$DocumentsBrowser$selectedPage, data, model);
				},
				$author$project$Forward$Remote$toMaybe(remoteData)));
	});
var $author$project$Components$DocumentsBrowser$selectedDocPage = F2(
	function (data, model) {
		if (data.$ === 'Loaded') {
			var data_ = data.a;
			var selectedPage_ = A2($author$project$Components$DocumentsBrowser$selectedPageFromRemote, data, model);
			var possiblyGroupedDocuments = A2($author$project$Components$DocumentsBrowser$getPossiblyGroupedDocuments, data_, model);
			return A2($author$project$Components$DocumentBrowser$Full$selectedDocumentPage, possiblyGroupedDocuments, selectedPage_);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$DocumentsBrowser$hotkeyRotateMsgFromRemote = F3(
	function (data, model, rotation) {
		var _v0 = A2($author$project$Components$DocumentsBrowser$selectedDocPage, data, model);
		if (_v0.$ === 'Just') {
			var docPage = _v0.a;
			return A2($author$project$Components$DocumentsBrowser$Rotate, docPage, rotation);
		} else {
			return $author$project$Components$DocumentsBrowser$NoOp;
		}
	});
var $author$project$Components$DocumentsBrowser$illegibleEnabled = F2(
	function (_v0, model) {
		var invoiceStateByGroupId = _v0.invoiceStateByGroupId;
		var factorInvoiceState = _v0.factorInvoiceState;
		var groupInvoiceEditable = A2(
			$elm$core$Maybe$map,
			$author$project$Domain$FactorInvoice$editable,
			$elm_community$maybe_extra$Maybe$Extra$join(
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (groupId, states) {
							return A2(
								$elm$core$Dict$get,
								$author$project$Domain$DocumentGroupId$toComparable(groupId),
								states);
						}),
					$author$project$Components$DocumentsBrowser$selectedDocumentGroupId(model),
					$author$project$Forward$Remote$toMaybe(invoiceStateByGroupId))));
		var factorInvoiceEditable = A2($elm$core$Maybe$map, $author$project$Domain$FactorInvoice$editable, factorInvoiceState);
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm_community$maybe_extra$Maybe$Extra$orElse, groupInvoiceEditable, factorInvoiceEditable));
	});
var $author$project$Components$DocumentsBrowser$MarkIllegible = function (a) {
	return {$: 'MarkIllegible', a: a};
};
var $author$project$Components$DocumentsBrowser$illegibleMsg = F3(
	function (data, model, selection) {
		var maybeDocPage = A2(
			$elm$core$Maybe$andThen,
			$elm_community$list_extra$List$Extra$getAt(selection.pageIndex),
			A2(
				$elm_community$list_extra$List$Extra$getAt,
				selection.documentIndex,
				A2($author$project$Components$DocumentsBrowser$getDocumentData, data, model).documentPages));
		if (maybeDocPage.$ === 'Just') {
			var docPage = maybeDocPage.a;
			return $author$project$Components$DocumentsBrowser$MarkIllegible(docPage.id);
		} else {
			return $author$project$Components$DocumentsBrowser$NoOp;
		}
	});
var $author$project$Components$DocumentsBrowser$isActionEnabled = F2(
	function (action, model) {
		return A2($elm$core$List$member, action, model.enabledToolbarActions);
	});
var $author$project$Components$DocumentsBrowser$nextSelection = F2(
	function (docPages, currentPage) {
		var docPageCount = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$length,
				A2($elm_community$list_extra$List$Extra$getAt, currentPage.documentIndex, docPages)));
		return (_Utils_cmp(docPageCount, currentPage.pageIndex + 1) > 0) ? A2($author$project$Components$DocumentBrowser$Full$Selection, currentPage.documentIndex, currentPage.pageIndex + 1) : ((_Utils_cmp(
			$elm$core$List$length(docPages),
			currentPage.documentIndex + 1) > 0) ? A2($author$project$Components$DocumentBrowser$Full$Selection, currentPage.documentIndex + 1, 0) : currentPage);
	});
var $author$project$Components$DocumentsBrowser$prevSelection = F2(
	function (docPages, currentPage) {
		if (!currentPage.pageIndex) {
			if (!currentPage.documentIndex) {
				return currentPage;
			} else {
				var prevDocPageCount = A2(
					$elm$core$Maybe$withDefault,
					1,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$length,
						A2($elm_community$list_extra$List$Extra$getAt, currentPage.documentIndex - 1, docPages)));
				return A2($author$project$Components$DocumentBrowser$Full$Selection, currentPage.documentIndex - 1, prevDocPageCount - 1);
			}
		} else {
			return A2($author$project$Components$DocumentBrowser$Full$Selection, currentPage.documentIndex, currentPage.pageIndex - 1);
		}
	});
var $author$project$Components$DocumentsBrowser$SelectGroup = F2(
	function (a, b) {
		return {$: 'SelectGroup', a: a, b: b};
	});
var $author$project$Domain$DocumentGroupId$fromComparable = function (_v0) {
	var string = _v0.a;
	var id = _v0.b;
	return $author$project$Domain$DocumentGroupId$fromInt(id);
};
var $author$project$Components$DocumentsBrowser$selectGroupByOffSetMsg = F3(
	function (data, model, offset) {
		var _v0 = model.currentProcessingSelection;
		if (_v0.$ === 'GroupedDocumentBatchSelection') {
			var documentBatchId_ = _v0.a;
			var documentGroupId_ = _v0.b;
			var documentGroupIds = A2(
				$elm$core$List$map,
				$author$project$Domain$DocumentGroupId$fromComparable,
				$elm$core$Dict$keys(data.groupedDocumentData.browserDocumentDataByGroupId));
			var nextDocumentGroupId = A2(
				$elm$core$Maybe$withDefault,
				documentGroupId_,
				A2(
					$elm$core$Maybe$andThen,
					function (i) {
						return A2($elm_community$list_extra$List$Extra$getAt, i + offset, documentGroupIds);
					},
					A2($elm_community$list_extra$List$Extra$elemIndex, documentGroupId_, documentGroupIds)));
			return A2($author$project$Components$DocumentsBrowser$SelectGroup, documentBatchId_, nextDocumentGroupId);
		} else {
			return $author$project$Components$DocumentsBrowser$NoOp;
		}
	});
var $author$project$Components$DocumentsBrowser$UpdatePod = F2(
	function (a, b) {
		return {$: 'UpdatePod', a: a, b: b};
	});
var $author$project$Helpers$DocumentType$allowedAsPod = F2(
	function (accountSettings, unresolvedDocumentType) {
		var invalidTypes = _List_fromArray(
			[$author$project$AuditPb$DocumentTypeInvoice, $author$project$AuditPb$DocumentTypeCarrierInvoice, $author$project$AuditPb$DocumentTypeFactorInvoice, $author$project$AuditPb$DocumentTypeRateConfirmation, $author$project$AuditPb$DocumentTypeContract, $author$project$AuditPb$DocumentTypeNoticeOfRelease, $author$project$AuditPb$DocumentTypeNoticeOfAssignment, $author$project$AuditPb$DocumentTypeInsuranceCertificate, $author$project$AuditPb$DocumentTypeFundingForm, $author$project$AuditPb$DocumentTypeInternalDocumentsOther]);
		if (unresolvedDocumentType.$ === 'Resolved') {
			var documentType = unresolvedDocumentType.a;
			return $elm$core$List$isEmpty(
				A2(
					$elm$core$List$filter,
					function (docType) {
						return _Utils_eq(docType, documentType);
					},
					invalidTypes));
		} else {
			return false;
		}
	});
var $turboMaCk$any_dict$Dict$Any$get = F2(
	function (k, _v0) {
		var toKey = _v0.a.toKey;
		var dict = _v0.a.dict;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				toKey(k),
				dict));
	});
var $author$project$Helpers$DocumentIsPodUpdates$get = F2(
	function (documentId, pendingUpdatePodRequests) {
		return A2($turboMaCk$any_dict$Dict$Any$get, documentId, pendingUpdatePodRequests);
	});
var $author$project$Helpers$DocumentIsPodUpdates$getWithDefault = F3(
	function (defaultValue, documentId, pendingUpdatePodRequests) {
		return A2(
			$elm$core$Maybe$withDefault,
			defaultValue,
			A2($author$project$Helpers$DocumentIsPodUpdates$get, documentId, pendingUpdatePodRequests));
	});
var $author$project$Components$DocumentsBrowser$togglePodHotkeyUpdateMsg = F3(
	function (data, model, selection) {
		var selectedMaybeDocument = A2(
			$elm_community$list_extra$List$Extra$getAt,
			selection.documentIndex,
			A2($author$project$Components$DocumentsBrowser$getDocumentData, data, model).documents);
		if (selectedMaybeDocument.$ === 'Just') {
			var document = selectedMaybeDocument.a;
			return A2(
				$author$project$Helpers$DocumentType$allowedAsPod,
				data.accountSettings,
				$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue)) ? A2(
				$author$project$Components$DocumentsBrowser$UpdatePod,
				document.id,
				!A3($author$project$Helpers$DocumentIsPodUpdates$getWithDefault, document.includesPOD, document.id, model.documentIsPodUpdates)) : $author$project$Components$DocumentsBrowser$NoOp;
		} else {
			return $author$project$Components$DocumentsBrowser$NoOp;
		}
	});
var $author$project$Components$DocumentsBrowser$hotkeyToMsg = F3(
	function (hotkey, data, model) {
		switch (hotkey.$) {
			case 'ZoomIn':
				return $author$project$Components$DocumentsBrowser$canZoomIn(model.zoomLevel) ? $author$project$Components$DocumentsBrowser$ZoomIn : $author$project$Components$DocumentsBrowser$NoOp;
			case 'ZoomOut':
				return $author$project$Components$DocumentsBrowser$canZoomOut(model.zoomLevel) ? $author$project$Components$DocumentsBrowser$ZoomOut : $author$project$Components$DocumentsBrowser$NoOp;
			case 'NextPage':
				if (data.$ === 'Loaded') {
					var data_ = data.a;
					var docPages = A2($author$project$Components$DocumentsBrowser$getDocumentData, data_, model).documentPages;
					return A3(
						$author$project$Components$DocumentsBrowser$buildSelectDocumentMsg,
						data_,
						model,
						A2(
							$author$project$Components$DocumentsBrowser$nextSelection,
							docPages,
							A2($author$project$Components$DocumentsBrowser$selectedPage, data_, model)));
				} else {
					return $author$project$Components$DocumentsBrowser$NoOp;
				}
			case 'PrevPage':
				if (data.$ === 'Loaded') {
					var data_ = data.a;
					var docPages = A2($author$project$Components$DocumentsBrowser$getDocumentData, data_, model).documentPages;
					return A3(
						$author$project$Components$DocumentsBrowser$buildSelectDocumentMsg,
						data_,
						model,
						A2(
							$author$project$Components$DocumentsBrowser$prevSelection,
							docPages,
							A2($author$project$Components$DocumentsBrowser$selectedPage, data_, model)));
				} else {
					return $author$project$Components$DocumentsBrowser$NoOp;
				}
			case 'ToggleHidden':
				if (data.$ === 'Loaded') {
					var data_ = data.a;
					return A2($author$project$Components$DocumentsBrowser$hideEnabled, data_, model) ? A3(
						$author$project$Components$DocumentsBrowser$hideMsg,
						data_,
						model,
						A2($author$project$Components$DocumentsBrowser$selectedPage, data_, model)) : $author$project$Components$DocumentsBrowser$NoOp;
				} else {
					return $author$project$Components$DocumentsBrowser$NoOp;
				}
			case 'MarkIllegible':
				if (data.$ === 'Loaded') {
					var data_ = data.a;
					return (A2($author$project$Components$DocumentsBrowser$isActionEnabled, $author$project$Components$DocumentsBrowser$MarkIllegibleAction, model) && A2($author$project$Components$DocumentsBrowser$illegibleEnabled, data_, model)) ? A3(
						$author$project$Components$DocumentsBrowser$illegibleMsg,
						data_,
						model,
						A2($author$project$Components$DocumentsBrowser$selectedPage, data_, model)) : $author$project$Components$DocumentsBrowser$NoOp;
				} else {
					return $author$project$Components$DocumentsBrowser$NoOp;
				}
			case 'TogglePOD':
				if (data.$ === 'Loaded') {
					var data_ = data.a;
					return A3(
						$author$project$Components$DocumentsBrowser$togglePodHotkeyUpdateMsg,
						data_,
						model,
						A2($author$project$Components$DocumentsBrowser$selectedPage, data_, model));
				} else {
					return $author$project$Components$DocumentsBrowser$NoOp;
				}
			case 'NextGroup':
				if (data.$ === 'Loaded') {
					var data_ = data.a;
					return A3($author$project$Components$DocumentsBrowser$selectGroupByOffSetMsg, data_, model, 1);
				} else {
					return $author$project$Components$DocumentsBrowser$NoOp;
				}
			case 'PrevGroup':
				if (data.$ === 'Loaded') {
					var data_ = data.a;
					return A3($author$project$Components$DocumentsBrowser$selectGroupByOffSetMsg, data_, model, -1);
				} else {
					return $author$project$Components$DocumentsBrowser$NoOp;
				}
			case 'RotateLeft':
				return A3($author$project$Components$DocumentsBrowser$hotkeyRotateMsgFromRemote, data, model, -90);
			case 'RotateRight':
				return A3($author$project$Components$DocumentsBrowser$hotkeyRotateMsgFromRemote, data, model, 90);
			default:
				return $author$project$Components$DocumentsBrowser$NoOp;
		}
	});
var $author$project$Components$DocumentsBrowser$AnnotationsReplaced = F2(
	function (a, b) {
		return {$: 'AnnotationsReplaced', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$ApiCallComplete = F2(
	function (a, b) {
		return {$: 'ApiCallComplete', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$DragScrollStartWithViewport = F4(
	function (a, b, c, d) {
		return {$: 'DragScrollStartWithViewport', a: a, b: b, c: c, d: d};
	});
var $author$project$Components$DocumentsBrowser$HideFinished = F3(
	function (a, b, c) {
		return {$: 'HideFinished', a: a, b: b, c: c};
	});
var $author$project$Components$DocumentsBrowser$MarkIllegibleFinished = F2(
	function (a, b) {
		return {$: 'MarkIllegibleFinished', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$ResendSending = {$: 'ResendSending'};
var $author$project$Components$DocumentsBrowser$ResendSent = {$: 'ResendSent'};
var $author$project$Components$DocumentsBrowser$ResendToCadenceResult = F2(
	function (a, b) {
		return {$: 'ResendToCadenceResult', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$SaveMessageAsDocumentComplete = function (a) {
	return {$: 'SaveMessageAsDocumentComplete', a: a};
};
var $author$project$Components$DocumentsBrowser$UpdateDocumentType = F2(
	function (a, b) {
		return {$: 'UpdateDocumentType', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$UpdateDocumentTypeFinished = F3(
	function (a, b, c) {
		return {$: 'UpdateDocumentTypeFinished', a: a, b: b, c: c};
	});
var $author$project$Components$DocumentsBrowser$UpdatePodFinished = F2(
	function (a, b) {
		return {$: 'UpdatePodFinished', a: a, b: b};
	});
var $author$project$Api$EmailMessages$baseUrl = function (id) {
	return '/api/email_messages/' + $elm$core$String$fromInt(
		$author$project$Domain$EmailMessageId$toInt(id));
};
var $author$project$Api$EmailMessages$updateLabel = F3(
	function (method, id, label) {
		return A2(
			method,
			$author$project$Api$EmailMessages$baseUrl(id) + '/labels?format=forward',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'label_name',
						$elm$json$Json$Encode$string(label))
					])));
	});
var $author$project$Api$EmailMessages$addLabel = $author$project$Api$EmailMessages$updateLabel($author$project$Helpers$Api$postWithNoResponseBody);
var $author$project$Api$EmailMessages$createDocument = function (emailMessageId) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		$author$project$Api$EmailMessages$baseUrl(emailMessageId) + '/create_document',
		$elm$json$Json$Encode$object(_List_Nil));
};
var $author$project$Helpers$Api$deleteWithParams = F2(
	function (url, json) {
		return A2(
			$author$project$Forward$CacheableRequest$requestWithIgnoredResponseBody,
			{
				body: $elm$core$Maybe$Just(json),
				errorDecoder: $author$project$Helpers$Api$standardErrorDecoder,
				headers: _List_Nil,
				method: 'DELETE',
				timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
				url: url
			},
			$elm$core$Basics$identity);
	});
var $author$project$Api$EmailMessages$deleteLabel = $author$project$Api$EmailMessages$updateLabel($author$project$Helpers$Api$deleteWithParams);
var $author$project$Api$Documents$duplicate = function (id) {
	var url = '/api/documents/' + ($elm$core$String$fromInt(
		$author$project$Domain$DocumentId$toInt(id)) + '/duplicate?format=forward');
	var body = $elm$json$Json$Encode$object(_List_Nil);
	return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
};
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$Components$DocumentBrowser$Full$groupRailId = function (suffix) {
	return 'document-browser-group-rail-' + suffix;
};
var $turboMaCk$any_dict$Dict$Any$insert = F3(
	function (k, v, _v0) {
		var inner = _v0.a;
		return $turboMaCk$any_dict$Dict$Any$AnyDict(
			_Utils_update(
				inner,
				{
					dict: A3(
						$elm$core$Dict$insert,
						inner.toKey(k),
						_Utils_Tuple2(k, v),
						inner.dict)
				}));
	});
var $author$project$Helpers$DocumentIsPodUpdates$insert = F3(
	function (documentId, isPod, pendingUpdatePodRequests) {
		return A3($turboMaCk$any_dict$Dict$Any$insert, documentId, isPod, pendingUpdatePodRequests);
	});
var $author$project$Forward$Internal$EntrypointCache$RemoveCachedData = {$: 'RemoveCachedData'};
var $author$project$HubTran$Effect$invalidate = function (lookup) {
	return $author$project$HubTran$Effect$ForwardEffect(
		$author$project$Forward$Internal$PureEffectManagerCmd$InvalidateItem(
			A3($author$project$Forward$Lookup$runInvalidation, $author$project$Forward$Internal$EntrypointCache$RemoveCachedData, _Utils_Tuple0, lookup)));
};
var $author$project$Components$DocumentsBrowser$invalidateDocumentData = function (model) {
	return $author$project$HubTran$Effect$batch(
		_List_fromArray(
			[
				$author$project$HubTran$Effect$invalidate(
				$author$project$Components$DocumentsBrowser$buildDocumentData(model)),
				$author$project$HubTran$Effect$invalidate(
				$author$project$Components$DocumentsBrowser$buildDocumentDataByDocumentGroupId(model)),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_documentAddressAnswer)
			]));
};
var $author$project$Components$DocumentsBrowser$keyToIndex = function (key) {
	if (key === '0') {
		return $elm$core$Maybe$Just(9);
	} else {
		return A2(
			$elm$core$Maybe$andThen,
			function (n) {
				return ((n >= 1) && (n <= 9)) ? $elm$core$Maybe$Just(n - 1) : $elm$core$Maybe$Nothing;
			},
			$elm$core$String$toInt(key));
	}
};
var $author$project$Api$Documents$markHidden = F2(
	function (pageId, hidden) {
		var url = '/api/document_pages/' + ($elm$core$String$fromInt(
			$author$project$Domain$DocumentPageId$toInt(pageId)) + '/hidden?format=forward');
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'hidden',
					$elm$json$Json$Encode$bool(hidden))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Api$Documents$markIllegible = function (pageId) {
	var url = '/api/document_pages/' + ($elm$core$String$fromInt(
		$author$project$Domain$DocumentPageId$toInt(pageId)) + '/illegible?format=forward');
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		url,
		$elm$json$Json$Encode$object(_List_Nil));
};
var $author$project$Api$Documents$mergeDocuments = function (_v0) {
	var intoDocumentId = _v0.intoDocumentId;
	var currentDocumentId = _v0.currentDocumentId;
	var url = '/api/documents/' + ($elm$core$String$fromInt(
		$author$project$Domain$DocumentId$toInt(currentDocumentId)) + '/merge?format=forward');
	var body = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'into_document_id',
				$elm$json$Json$Encode$int(
					$author$project$Domain$DocumentId$toInt(intoDocumentId)))
			]));
	return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
};
var $author$project$AuditPb$Empty = {};
var $author$project$AuditPb$emptyDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$Empty);
	});
var $author$project$AuditPb$pageAnnotationKindToString = function (v) {
	switch (v.$) {
		case 'PageAnnotationKindUnknown':
			return 'unknown';
		case 'PageAnnotationKindStamp':
			return 'stamp';
		case 'PageAnnotationKindRedaction':
			return 'redaction';
		case 'PageAnnotationKindText':
			return 'text';
		default:
			return 'crop';
	}
};
var $author$project$AuditPb$pageAnnotationKindEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$pageAnnotationKindToString);
var $author$project$AuditPb$pageAnnotationEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'kind', $author$project$AuditPb$pageAnnotationKindEncoder, v.kind),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'top', $elm$json$Json$Encode$float, v.top),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'left', $elm$json$Json$Encode$float, v.left),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'width', $elm$json$Json$Encode$float, v.width),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'height', $elm$json$Json$Encode$float, v.height),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'text', $elm$json$Json$Encode$string, v.text)
				])));
};
var $author$project$AuditPb$pageAnnotationServiceReplaceRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'document_page_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentPageId$toInt),
					v.documentPageId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'kind', $author$project$AuditPb$pageAnnotationKindEncoder, v.kind),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'annotations', $author$project$AuditPb$pageAnnotationEncoder, v.annotations)
				])));
};
var $author$project$AuditApi$pageAnnotationServiceReplaceRemote = A3($author$project$AuditApi$toRemote, '/page_annotation_service/replace', $author$project$AuditPb$pageAnnotationServiceReplaceRequestEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$Domain$TransmissionId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Api$Transmissions$resend = function (id) {
	var baseUrl = '/api/transmissions/' + $elm$core$String$fromInt(
		$author$project$Domain$TransmissionId$toInt(id));
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		baseUrl + '/resend',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Api$Documents$rotatePage = F2(
	function (id, degrees) {
		var url = '/api/document_pages/' + ($elm$core$String$fromInt(
			$author$project$Domain$DocumentPageId$toInt(id)) + '/rotate?format=forward');
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'degrees',
					$elm$json$Json$Encode$int(degrees))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Api$EmailMessages$saveAsDocument = F2(
	function (emailMessageId, documentGroupId) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/documents/create_from_email',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'email_message_id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId))),
						_Utils_Tuple2(
						'document_group_id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$DocumentGroupId$toInt(documentGroupId)))
					])));
	});
var $author$project$Components$DocumentBrowser$Full$scrollContainerId = function (suffix) {
	return 'document-browser-scroll-container-' + suffix;
};
var $author$project$Js$scrollToIdAtTopOfContainer = _Platform_outgoingPort(
	'scrollToIdAtTopOfContainer',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'containerId',
					$elm$json$Json$Encode$string($.containerId)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.id))
				]));
	});
var $author$project$Components$DocumentBrowser$Full$selectedDocument = F2(
	function (documents, selection) {
		return A2(
			$elm_community$list_extra$List$Extra$getAt,
			selection.documentIndex,
			$author$project$Components$DocumentBrowser$Full$getSelectedDocumentData(documents).documents);
	});
var $author$project$Components$DocumentBrowser$Full$selectedGroupHeadingId = function (suffix) {
	return 'document-browser-selected-group-' + suffix;
};
var $author$project$TempJsInterop$sendToDataStoreService = _Platform_outgoingPort('sendToDataStoreService', $elm$core$Basics$identity);
var $author$project$Encode$DocumentTypeEncoder$documentTypeString = function (unresolvedDocumentType) {
	switch (unresolvedDocumentType.$) {
		case 'Resolved':
			var documentType = unresolvedDocumentType.a;
			return $author$project$AuditPb$documentTypeToString(documentType);
		case 'Partial':
			var partial = unresolvedDocumentType.a;
			return $author$project$AuditPb$documentTypePartialToString(partial);
		default:
			return 'unknown';
	}
};
var $author$project$Encode$DocumentTypeEncoder$encodeDocumentType = function (documentType) {
	return $elm$json$Json$Encode$string(
		$author$project$Encode$DocumentTypeEncoder$documentTypeString(documentType));
};
var $author$project$Helpers$Api$putWithNoResponseBody = F2(
	function (url, json) {
		return A2(
			$author$project$Forward$CacheableRequest$requestWithIgnoredResponseBody,
			{
				body: $elm$core$Maybe$Just(json),
				errorDecoder: $author$project$Helpers$Api$standardErrorDecoder,
				headers: _List_Nil,
				method: 'PUT',
				timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
				url: url
			},
			$elm$core$Basics$identity);
	});
var $author$project$Api$Documents$setDocumentType = F2(
	function (id, type_) {
		var url = '/api/documents/' + ($elm$core$String$fromInt(
			$author$project$Domain$DocumentId$toInt(id)) + '?format=forward');
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$author$project$Encode$DocumentTypeEncoder$encodeDocumentType(type_))
							])))
				]));
		return A2($author$project$Helpers$Api$putWithNoResponseBody, url, body);
	});
var $author$project$Forward$CacheableRequest$cacheableRequestWithErrorData = F2(
	function (request_, toMessage_) {
		return A2(
			$author$project$Forward$CacheableRequest$cacheableRequestWithErrorDataHelper,
			{
				body: request_.body,
				decoder: A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Decode$decodeString(request_.decoder),
						$elm$core$Result$mapError(
							A2($elm$core$Basics$composeR, $elm$json$Json$Decode$errorToString, $elm$http$Http$BadBody)))),
				errorDecoder: request_.errorDecoder,
				headers: request_.headers,
				method: request_.method,
				timeout: request_.timeout,
				url: request_.url
			},
			toMessage_);
	});
var $author$project$Helpers$Api$put = F3(
	function (url, json, decoder) {
		return A2(
			$author$project$Forward$CacheableRequest$cacheableRequestWithErrorData,
			{
				body: $elm$core$Maybe$Just(json),
				decoder: decoder,
				errorDecoder: $author$project$Helpers$Api$standardErrorDecoder,
				headers: _List_Nil,
				method: 'PUT',
				timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
				url: url
			},
			$elm$core$Basics$identity);
	});
var $author$project$Api$Documents$setPodStatus = F2(
	function (id, status) {
		var url = '/api/documents/' + ($elm$core$String$fromInt(
			$author$project$Domain$DocumentId$toInt(id)) + '?format=forward');
		var podData = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'includesPOD',
					$elm$json$Json$Encode$bool(status)),
					_Utils_Tuple2(
					'podFlagSetByUser',
					$elm$json$Json$Encode$bool(true))
				]));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('data', podData)
							])))
				]));
		return A3($author$project$Helpers$Api$put, url, body, $elm$json$Json$Decode$value);
	});
var $author$project$Components$DocumentTypePicker$sortedTypes = function (enabledDocumentTypes) {
	return A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.name;
		},
		enabledDocumentTypes);
};
var $author$project$Api$Documents$splitPageFromDocument = F2(
	function (docId, pageId) {
		var url = '/api/documents/' + ($elm$core$String$fromInt(
			$author$project$Domain$DocumentId$toInt(docId)) + '/split?format=forward');
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'page_id',
					$elm$json$Json$Encode$int(
						$author$project$Domain$DocumentPageId$toInt(pageId)))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadFilesLoaded = F2(
	function (a, b) {
		return {$: 'AddDocumentToLoadFilesLoaded', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadFilesSelected = F2(
	function (a, b) {
		return {$: 'AddDocumentToLoadFilesSelected', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadRequest = function (a) {
	return {$: 'AddDocumentToLoadRequest', a: a};
};
var $author$project$AuditPb$addDocumentToLoadRequest_DocumentEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'fileName', $elm$json$Json$Encode$string, v.fileName),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'mimeType', $elm$json$Json$Encode$string, v.mimeType),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'base64EncodedFile', $elm$json$Json$Encode$string, v.base64EncodedFile)
				])));
};
var $author$project$AuditPb$addDocumentToLoadRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'loadId', $elm$json$Json$Encode$int, v.loadId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'carrierInvoiceId', $elm$json$Json$Encode$int, v.carrierInvoiceId),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'documents', $author$project$AuditPb$addDocumentToLoadRequest_DocumentEncoder, v.documents)
				])));
};
var $author$project$AuditPb$AddDocumentToLoadResponse = function (uploadStatus) {
	return {uploadStatus: uploadStatus};
};
var $author$project$AuditPb$AddDocumentToLoadUploadStatusInProgress = {$: 'AddDocumentToLoadUploadStatusInProgress'};
var $author$project$AuditPb$addDocumentToLoadUploadStatusDefault = $author$project$AuditPb$AddDocumentToLoadUploadStatusInProgress;
var $author$project$AuditPb$addDocumentToLoadUploadStatusToString = function (v) {
	switch (v.$) {
		case 'AddDocumentToLoadUploadStatusInProgress':
			return 'in_progress';
		case 'AddDocumentToLoadUploadStatusFailed':
			return 'failure';
		default:
			return 'success';
	}
};
var $author$project$AuditPb$AddDocumentToLoadUploadStatusFailed = {$: 'AddDocumentToLoadUploadStatusFailed'};
var $author$project$AuditPb$AddDocumentToLoadUploadStatusSuccess = {$: 'AddDocumentToLoadUploadStatusSuccess'};
var $author$project$AuditPb$allAddDocumentToLoadUploadStatus = _List_fromArray(
	[$author$project$AuditPb$AddDocumentToLoadUploadStatusInProgress, $author$project$AuditPb$AddDocumentToLoadUploadStatusFailed, $author$project$AuditPb$AddDocumentToLoadUploadStatusSuccess]);
var $author$project$AuditPb$addDocumentToLoadUploadStatusDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$addDocumentToLoadUploadStatusToString(v),
				v);
		},
		$author$project$AuditPb$allAddDocumentToLoadUploadStatus));
var $author$project$AuditPb$addDocumentToLoadUploadStatusFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$addDocumentToLoadUploadStatusDict);
};
var $author$project$AuditPb$addDocumentToLoadUploadStatusDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$addDocumentToLoadUploadStatusDefault),
		$author$project$AuditPb$addDocumentToLoadUploadStatusFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$addDocumentToLoadResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'uploadStatus',
			$author$project$AuditPb$addDocumentToLoadUploadStatusDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$AddDocumentToLoadResponse));
	});
var $author$project$AuditApi$addDocumentToLoadServiceUploadRemote = A3($author$project$AuditApi$toRemote, '/add_document_to_load_service/upload', $author$project$AuditPb$addDocumentToLoadRequestEncoder, $author$project$AuditPb$addDocumentToLoadResponseDecoder);
var $author$project$AuditPb$DashboardUpdateEvent_AddDocumentToLoad = F3(
	function (loadStateId, fileCount, uploadStatus) {
		return {fileCount: fileCount, loadStateId: loadStateId, uploadStatus: uploadStatus};
	});
var $author$project$AuditPb$dashboardUpdateEvent_AddDocumentToLoadDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'uploadStatus',
			$author$project$AuditPb$addDocumentToLoadUploadStatusDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'fileCount',
				$author$project$AuditPb$intDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'loadStateId',
					$author$project$AuditPb$intDecoder,
					$author$project$AuditPb$decode($author$project$AuditPb$DashboardUpdateEvent_AddDocumentToLoad))));
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$errorMessage = {indefinite: false, level: 'alert', message: 'Document failed to upload, please try again.', position: 'bottom', time: $elm$core$Maybe$Nothing, title: $elm$core$Maybe$Nothing};
var $elm$file$File$mime = _File_mime;
var $elm$file$File$name = _File_name;
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$fileDataToMaybeDocument = F2(
	function (file, fileAsUrl) {
		return A2(
			$elm$core$Maybe$map,
			function (base64EncodedFile) {
				return {
					base64EncodedFile: base64EncodedFile,
					fileName: $elm$file$File$name(file),
					mimeType: $elm$file$File$mime(file)
				};
			},
			A2(
				$elm$core$Array$get,
				1,
				$elm$core$Array$fromList(
					A2($elm$core$String$split, ',', fileAsUrl))));
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$fileDataToDocuments = F2(
	function (files, filesAsUrls) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A3($elm$core$List$map2, $author$project$Components$DocumentBrowser$AddDocumentToLoad$fileDataToMaybeDocument, files, filesAsUrls));
	});
var $elm$file$File$Select$files = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				var f = _v0.a;
				var fs = _v0.b;
				return A2(toMsg, f, fs);
			},
			_File_uploadOneOrMore(mimes));
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$notificationMessage = {
	indefinite: false,
	level: 'notification',
	message: 'This may take a few minutes.',
	position: 'bottom',
	time: $elm$core$Maybe$Nothing,
	title: $elm$core$Maybe$Just('Document uploading')
};
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$successMessage = function (fileCount) {
	var maybePlural = (fileCount > 1) ? 's' : '';
	return {
		indefinite: false,
		level: 'success',
		message: $elm$core$String$fromInt(fileCount) + (' Document' + (maybePlural + ' uploaded.')),
		position: 'bottom',
		time: $elm$core$Maybe$Nothing,
		title: $elm$core$Maybe$Just('Success')
	};
};
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$processableUpdateEffect = function (decodedUpdate) {
	var _v0 = decodedUpdate.uploadStatus;
	switch (_v0.$) {
		case 'AddDocumentToLoadUploadStatusSuccess':
			return $author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						$author$project$HubTran$Effect$cmd(
						$author$project$Js$flashToJavascriptV3Reskin(
							$author$project$Components$DocumentBrowser$AddDocumentToLoad$successMessage(decodedUpdate.fileCount))),
						$author$project$HubTran$Effect$invalidateAll
					]));
		case 'AddDocumentToLoadUploadStatusFailed':
			return $author$project$HubTran$Effect$cmd(
				$author$project$Js$flashToJavascriptV3Reskin($author$project$Components$DocumentBrowser$AddDocumentToLoad$errorMessage));
		default:
			return $author$project$HubTran$Effect$none;
	}
};
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'AddDocumentToLoadFilesRequested':
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						A2(
							$elm$file$File$Select$files,
							_List_fromArray(
								['*']),
							$author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadFilesSelected)));
			case 'AddDocumentToLoadFilesSelected':
				var file = msg.a;
				var files = msg.b;
				var files_ = A2($elm$core$List$cons, file, files);
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						A2(
							$elm$core$Task$perform,
							$author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadFilesLoaded(files_),
							$elm$core$Task$sequence(
								A2($elm$core$List$map, $elm$file$File$toUrl, files_)))));
			case 'AddDocumentToLoadFilesLoaded':
				var files = msg.a;
				var filesAsUrls = msg.b;
				var _v1 = _Utils_Tuple2(data.maybeTmsLoad, model.pageContextData.carrierInvoiceId);
				if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
					var tmsLoad = _v1.a.a;
					var carrierInvoiceId = _v1.b.a;
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$cmd(
									$author$project$Js$flashToJavascriptV3Reskin($author$project$Components$DocumentBrowser$AddDocumentToLoad$notificationMessage)),
									A2(
									$author$project$AuditApi$addDocumentToLoadServiceUploadRemote,
									$author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadRequest,
									{
										carrierInvoiceId: $author$project$Domain$CarrierInvoiceId$toInt(carrierInvoiceId),
										documents: A2($author$project$Components$DocumentBrowser$AddDocumentToLoad$fileDataToDocuments, files, filesAsUrls),
										loadId: $author$project$Domain$TmsLoadId$toInt(tmsLoad.id)
									})
								])));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'AddDocumentToLoadRequest':
				var remoteData = msg.a;
				if (remoteData.$ === 'Failure') {
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$flashToJavascriptV3Reskin($author$project$Components$DocumentBrowser$AddDocumentToLoad$errorMessage)));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			default:
				var json = msg.a;
				var _v3 = A2($elm$json$Json$Decode$decodeValue, $author$project$AuditPb$dashboardUpdateEvent_AddDocumentToLoadDecoder, json);
				if (_v3.$ === 'Ok') {
					var decodedUpdate = _v3.a;
					var isUpdateForThisPage = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						false,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Domain$LoadStateId$toInt,
							$elm$core$Basics$eq(decodedUpdate.loadStateId)),
						model.pageContextData.loadStateId);
					return isUpdateForThisPage ? _Utils_Tuple2(
						model,
						$author$project$Components$DocumentBrowser$AddDocumentToLoad$processableUpdateEffect(decodedUpdate)) : _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
		}
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Annotating = function (a) {
	return {$: 'Annotating', a: a};
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Checking = F2(
	function (a, b) {
		return {$: 'Checking', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$DragStartedWithRect = function (a) {
	return {$: 'DragStartedWithRect', a: a};
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOp = {$: 'NoOp'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$NothingSelected = {$: 'NothingSelected'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Selected = function (a) {
	return {$: 'Selected', a: a};
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$TextGrown = F2(
	function (a, b) {
		return {$: 'TextGrown', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$UpdateRequested = function (a) {
	return {$: 'UpdateRequested', a: a};
};
var $author$project$Components$DocumentBrowser$Annotation$Drag$begin = F2(
	function (_v0, handlers) {
		var containerId = _v0.containerId;
		var grip = _v0.grip;
		var boxId = _v0.boxId;
		return $author$project$HubTran$Effect$cmd(
			A2(
				$elm$core$Task$attempt,
				function (result) {
					if (result.$ === 'Ok') {
						var element = result.a.element;
						return handlers.onMeasured(
							{boxId: boxId, containerId: containerId, grip: grip, page: element});
					} else {
						return handlers.onFailed;
					}
				},
				$elm$browser$Browser$Dom$getElement(containerId)));
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Checked = F4(
	function (a, b, c, d) {
		return {$: 'Checked', a: a, b: b, c: c, d: d};
	});
var $author$project$AuditPb$pageAnnotationServiceShowRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'document_page_id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentPageId$toInt),
					v.documentPageId)
				])));
};
var $author$project$AuditPb$PageAnnotationServiceShowResponse = F2(
	function (stampUrl, annotations) {
		return {annotations: annotations, stampUrl: stampUrl};
	});
var $author$project$AuditPb$PageAnnotation = F6(
	function (kind, top, left, width, height, text) {
		return {height: height, kind: kind, left: left, text: text, top: top, width: width};
	});
var $author$project$AuditPb$PageAnnotationKindUnknown = {$: 'PageAnnotationKindUnknown'};
var $author$project$AuditPb$pageAnnotationKindDefault = $author$project$AuditPb$PageAnnotationKindUnknown;
var $author$project$AuditPb$PageAnnotationKindCrop = {$: 'PageAnnotationKindCrop'};
var $author$project$AuditPb$PageAnnotationKindRedaction = {$: 'PageAnnotationKindRedaction'};
var $author$project$AuditPb$PageAnnotationKindStamp = {$: 'PageAnnotationKindStamp'};
var $author$project$AuditPb$PageAnnotationKindText = {$: 'PageAnnotationKindText'};
var $author$project$AuditPb$allPageAnnotationKind = _List_fromArray(
	[$author$project$AuditPb$PageAnnotationKindUnknown, $author$project$AuditPb$PageAnnotationKindStamp, $author$project$AuditPb$PageAnnotationKindRedaction, $author$project$AuditPb$PageAnnotationKindText, $author$project$AuditPb$PageAnnotationKindCrop]);
var $author$project$AuditPb$pageAnnotationKindDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$pageAnnotationKindToString(v),
				v);
		},
		$author$project$AuditPb$allPageAnnotationKind));
var $author$project$AuditPb$pageAnnotationKindFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$pageAnnotationKindDict);
};
var $author$project$AuditPb$pageAnnotationKindDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$pageAnnotationKindDefault),
		$author$project$AuditPb$pageAnnotationKindFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$pageAnnotationDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'text',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'height',
				$author$project$AuditPb$floatValueDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'width',
					$author$project$AuditPb$floatValueDecoder,
					A3(
						$author$project$AuditPb$requiredWithoutDefault,
						'left',
						$author$project$AuditPb$floatValueDecoder,
						A3(
							$author$project$AuditPb$requiredWithoutDefault,
							'top',
							$author$project$AuditPb$floatValueDecoder,
							A3(
								$author$project$AuditPb$requiredWithoutDefault,
								'kind',
								$author$project$AuditPb$pageAnnotationKindDecoder,
								$author$project$AuditPb$decode($author$project$AuditPb$PageAnnotation)))))));
	});
var $author$project$AuditPb$pageAnnotationServiceShowResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$repeated,
			'annotations',
			$author$project$AuditPb$pageAnnotationDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'stamp_url',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$PageAnnotationServiceShowResponse)));
	});
var $author$project$AuditApi$pageAnnotationServiceShowRemote = A3($author$project$AuditApi$toRemote, '/page_annotation_service/show', $author$project$AuditPb$pageAnnotationServiceShowRequestEncoder, $author$project$AuditPb$pageAnnotationServiceShowResponseDecoder);
var $author$project$Components$DocumentBrowser$AnnotationOverlay$check = F3(
	function (kind, docPageId, box) {
		return A2(
			$author$project$AuditApi$pageAnnotationServiceShowRemote,
			A3($author$project$Components$DocumentBrowser$AnnotationOverlay$Checked, kind, docPageId, box),
			{documentPageId: docPageId});
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Stamp = {$: 'Stamp'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$addBox = F2(
	function (_v0, session) {
		var text = _v0.text;
		var box = _v0.box;
		return _Utils_update(
			session,
			{
				boxes: _Utils_ap(
					session.boxes,
					_List_fromArray(
						[
							{box: box, id: session.nextBoxId, text: text}
						])),
				nextBoxId: session.nextBoxId + 1,
				selection: $author$project$Components$DocumentBrowser$AnnotationOverlay$Selected(session.nextBoxId)
			});
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$fresh = function (box) {
	return {box: box, text: ''};
};
var $author$project$Components$DocumentBrowser$Annotation$Drag$NotDragging = {$: 'NotDragging'};
var $author$project$Components$DocumentBrowser$Annotation$Drag$notDragging = $author$project$Components$DocumentBrowser$Annotation$Drag$NotDragging;
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Redaction = {$: 'Redaction'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Text = {$: 'Text'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$partitionKind = F2(
	function (kind, saved) {
		var _v0 = _Utils_Tuple2(kind, saved);
		_v0$5:
		while (true) {
			if (!_v0.b.b) {
				return _Utils_Tuple2(_List_Nil, _List_Nil);
			} else {
				switch (_v0.a.$) {
					case 'Stamp':
						if (_v0.b.a.$ === 'SavedStamp') {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							var _v3 = _v2.a;
							var box = _v3.a;
							var rest = _v2.b;
							return _Utils_Tuple2(
								_List_fromArray(
									[
										$author$project$Components$DocumentBrowser$AnnotationOverlay$fresh(box)
									]),
								rest);
						} else {
							break _v0$5;
						}
					case 'Crop':
						if (_v0.b.a.$ === 'SavedCrop') {
							var _v4 = _v0.a;
							var _v5 = _v0.b;
							var box = _v5.a.a;
							var rest = _v5.b;
							return _Utils_Tuple2(
								_List_fromArray(
									[
										$author$project$Components$DocumentBrowser$AnnotationOverlay$fresh(box)
									]),
								rest);
						} else {
							break _v0$5;
						}
					case 'Redaction':
						if (_v0.b.a.$ === 'SavedRedaction') {
							var _v6 = _v0.a;
							var _v7 = _v0.b;
							var box = _v7.a.a;
							var rest = _v7.b;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$List$cons(
									$author$project$Components$DocumentBrowser$AnnotationOverlay$fresh(box)),
								A2($author$project$Components$DocumentBrowser$AnnotationOverlay$partitionKind, $author$project$Components$DocumentBrowser$AnnotationOverlay$Redaction, rest));
						} else {
							break _v0$5;
						}
					default:
						if (_v0.b.a.$ === 'SavedText') {
							var _v8 = _v0.a;
							var _v9 = _v0.b;
							var _v10 = _v9.a;
							var box = _v10.a;
							var text = _v10.b;
							var rest = _v9.b;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$List$cons(
									{box: box, text: text}),
								A2($author$project$Components$DocumentBrowser$AnnotationOverlay$partitionKind, $author$project$Components$DocumentBrowser$AnnotationOverlay$Text, rest));
						} else {
							break _v0$5;
						}
				}
			}
		}
		var _v11 = _v0.b;
		var first = _v11.a;
		var rest = _v11.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$cons(first),
			A2($author$project$Components$DocumentBrowser$AnnotationOverlay$partitionKind, kind, rest));
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$selectFirst = function (session) {
	return _Utils_update(
		session,
		{
			selection: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$DocumentBrowser$AnnotationOverlay$NothingSelected,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.id;
						},
						$author$project$Components$DocumentBrowser$AnnotationOverlay$Selected),
					$elm$core$List$head(session.boxes)))
		});
};
var $author$project$Components$DocumentBrowser$Annotation$SavedCrop = function (a) {
	return {$: 'SavedCrop', a: a};
};
var $author$project$Components$DocumentBrowser$Annotation$SavedRedaction = function (a) {
	return {$: 'SavedRedaction', a: a};
};
var $author$project$Components$DocumentBrowser$Annotation$SavedStamp = F2(
	function (a, b) {
		return {$: 'SavedStamp', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$Annotation$SavedText = F2(
	function (a, b) {
		return {$: 'SavedText', a: a, b: b};
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$toSaved = F2(
	function (stampUrl, annotation) {
		var box = {height: annotation.height, left: annotation.left, top: annotation.top, width: annotation.width};
		var _v0 = annotation.kind;
		switch (_v0.$) {
			case 'PageAnnotationKindStamp':
				return $elm$core$Maybe$Just(
					A2($author$project$Components$DocumentBrowser$Annotation$SavedStamp, box, stampUrl));
			case 'PageAnnotationKindRedaction':
				return $elm$core$Maybe$Just(
					$author$project$Components$DocumentBrowser$Annotation$SavedRedaction(box));
			case 'PageAnnotationKindText':
				return $elm$core$Maybe$Just(
					A2($author$project$Components$DocumentBrowser$Annotation$SavedText, box, annotation.text));
			case 'PageAnnotationKindCrop':
				return $elm$core$Maybe$Just(
					$author$project$Components$DocumentBrowser$Annotation$SavedCrop(box));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$newSession = F4(
	function (kind, docPageId, response, box) {
		var _v0 = A2(
			$author$project$Components$DocumentBrowser$AnnotationOverlay$partitionKind,
			kind,
			A2(
				$elm$core$List$filterMap,
				$author$project$Components$DocumentBrowser$AnnotationOverlay$toSaved(response.stampUrl),
				response.annotations));
		var saved = _v0.a;
		var others = _v0.b;
		var empty = {boxes: _List_Nil, docPageId: docPageId, drag: $author$project$Components$DocumentBrowser$Annotation$Drag$notDragging, kind: kind, nextBoxId: 0, others: others, selection: $author$project$Components$DocumentBrowser$AnnotationOverlay$NothingSelected, stampUrl: response.stampUrl};
		if (!saved.b) {
			return A2(
				$author$project$Components$DocumentBrowser$AnnotationOverlay$addBox,
				$author$project$Components$DocumentBrowser$AnnotationOverlay$fresh(box),
				empty);
		} else {
			return $author$project$Components$DocumentBrowser$AnnotationOverlay$selectFirst(
				A3($elm$core$List$foldl, $author$project$Components$DocumentBrowser$AnnotationOverlay$addBox, empty, saved));
		}
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$checked = F4(
	function (kind, docPageId, box, result) {
		switch (result.$) {
			case 'Success':
				var response = result.a;
				return (_Utils_eq(kind, $author$project$Components$DocumentBrowser$AnnotationOverlay$Stamp) && $elm$core$String$isEmpty(response.stampUrl)) ? _Utils_Tuple2(
					$author$project$Components$DocumentBrowser$AnnotationOverlay$Idle,
					$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert)) : _Utils_Tuple2(
					$author$project$Components$DocumentBrowser$AnnotationOverlay$Annotating(
						A4($author$project$Components$DocumentBrowser$AnnotationOverlay$newSession, kind, docPageId, response, box)),
					$author$project$HubTran$Effect$none);
			case 'Failure':
				return _Utils_Tuple2(
					$author$project$Components$DocumentBrowser$AnnotationOverlay$Idle,
					$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
			case 'Loading':
				return _Utils_Tuple2(
					A2($author$project$Components$DocumentBrowser$AnnotationOverlay$Checking, kind, docPageId),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					A2($author$project$Components$DocumentBrowser$AnnotationOverlay$Checking, kind, docPageId),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$DocumentBrowser$Annotation$moveTo = F3(
	function (rect, cursor, box) {
		return _Utils_update(
			box,
			{
				left: A3($elm$core$Basics$clamp, 0, 100 - box.width, (((cursor.x - rect.x) / rect.width) * 100) - (box.width / 2)),
				top: A3($elm$core$Basics$clamp, 0, 100 - box.height, (((cursor.y - rect.y) / rect.height) * 100) - (box.height / 2))
			});
	});
var $author$project$Components$DocumentBrowser$Annotation$fromEdges = function (_v0) {
	var bottom = _v0.bottom;
	var right = _v0.right;
	var left = _v0.left;
	var top = _v0.top;
	return {height: bottom - top, left: left, top: top, width: right - left};
};
var $author$project$Components$DocumentBrowser$Annotation$minSize = 2;
var $author$project$Components$DocumentBrowser$Annotation$resizeTo = F4(
	function (corner, rect, cursor, box) {
		var y = A3($elm$core$Basics$clamp, 0, 100, ((cursor.y - rect.y) / rect.height) * 100);
		var x = A3($elm$core$Basics$clamp, 0, 100, ((cursor.x - rect.x) / rect.width) * 100);
		var right = box.left + box.width;
		var bottom = box.top + box.height;
		switch (corner.$) {
			case 'TopLeft':
				return $author$project$Components$DocumentBrowser$Annotation$fromEdges(
					{
						bottom: bottom,
						left: A2($elm$core$Basics$min, x, right - $author$project$Components$DocumentBrowser$Annotation$minSize),
						right: right,
						top: A2($elm$core$Basics$min, y, bottom - $author$project$Components$DocumentBrowser$Annotation$minSize)
					});
			case 'TopRight':
				return $author$project$Components$DocumentBrowser$Annotation$fromEdges(
					{
						bottom: bottom,
						left: box.left,
						right: A2($elm$core$Basics$max, x, box.left + $author$project$Components$DocumentBrowser$Annotation$minSize),
						top: A2($elm$core$Basics$min, y, bottom - $author$project$Components$DocumentBrowser$Annotation$minSize)
					});
			case 'BottomRight':
				return $author$project$Components$DocumentBrowser$Annotation$fromEdges(
					{
						bottom: A2($elm$core$Basics$max, y, box.top + $author$project$Components$DocumentBrowser$Annotation$minSize),
						left: box.left,
						right: A2($elm$core$Basics$max, x, box.left + $author$project$Components$DocumentBrowser$Annotation$minSize),
						top: box.top
					});
			default:
				return $author$project$Components$DocumentBrowser$Annotation$fromEdges(
					{
						bottom: A2($elm$core$Basics$max, y, box.top + $author$project$Components$DocumentBrowser$Annotation$minSize),
						left: A2($elm$core$Basics$min, x, right - $author$project$Components$DocumentBrowser$Annotation$minSize),
						right: right,
						top: box.top
					});
		}
	});
var $author$project$Components$DocumentBrowser$Annotation$Drag$apply = F4(
	function (cursor, boxId, drag, box) {
		if (drag.$ === 'Dragging') {
			var grabbed = drag.a;
			if (!_Utils_eq(grabbed.boxId, boxId)) {
				return box;
			} else {
				var _v1 = grabbed.grip;
				if (_v1.$ === 'ByBody') {
					return A3($author$project$Components$DocumentBrowser$Annotation$moveTo, grabbed.page, cursor, box);
				} else {
					var corner = _v1.a;
					return A4($author$project$Components$DocumentBrowser$Annotation$resizeTo, corner, grabbed.page, cursor, box);
				}
			}
		} else {
			return box;
		}
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$dragBox = F3(
	function (x, y, session) {
		var moved = function (editable) {
			return _Utils_update(
				editable,
				{
					box: A4(
						$author$project$Components$DocumentBrowser$Annotation$Drag$apply,
						{x: x, y: y},
						editable.id,
						session.drag,
						editable.box)
				});
		};
		return _Utils_update(
			session,
			{
				boxes: A2($elm$core$List$map, moved, session.boxes)
			});
	});
var $author$project$Components$DocumentBrowser$Annotation$TextBox$inputId = F2(
	function (containerId, boxId) {
		return containerId + ('-annotation-text-' + $elm$core$String$fromInt(boxId));
	});
var $author$project$Components$DocumentBrowser$Annotation$TextBox$focus = F2(
	function (_v0, noOp) {
		var boxId = _v0.boxId;
		var containerId = _v0.containerId;
		return $author$project$HubTran$Effect$cmd(
			A2(
				$elm$core$Task$attempt,
				$elm$core$Basics$always(noOp),
				$elm$browser$Browser$Dom$focus(
					A2($author$project$Components$DocumentBrowser$Annotation$TextBox$inputId, containerId, boxId))));
	});
var $author$project$Components$DocumentBrowser$Annotation$Drag$gesture = function (drag) {
	if (drag.$ === 'Dragging') {
		var grabbed = drag.a;
		return $elm$core$Maybe$Just(grabbed);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$focusText = function (session) {
	var _v0 = _Utils_Tuple2(
		session.kind,
		$author$project$Components$DocumentBrowser$Annotation$Drag$gesture(session.drag));
	if ((_v0.a.$ === 'Text') && (_v0.b.$ === 'Just')) {
		var _v1 = _v0.a;
		var containerId = _v0.b.a.containerId;
		var grip = _v0.b.a.grip;
		var boxId = _v0.b.a.boxId;
		if (grip.$ === 'ByBody') {
			return A2(
				$author$project$Components$DocumentBrowser$Annotation$TextBox$focus,
				{boxId: boxId, containerId: containerId},
				$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOp);
		} else {
			return $author$project$HubTran$Effect$none;
		}
	} else {
		return $author$project$HubTran$Effect$none;
	}
};
var $author$project$Components$DocumentBrowser$Annotation$TextBox$grow = F2(
	function (overflow, box) {
		return _Utils_update(
			box,
			{
				height: A2(
					$elm$core$Basics$min,
					100 - box.top,
					box.height + A2($elm$core$Basics$max, 0, overflow))
			});
	});
var $author$project$Components$DocumentBrowser$Annotation$Drag$Dragging = function (a) {
	return {$: 'Dragging', a: a};
};
var $author$project$Components$DocumentBrowser$Annotation$Drag$held = $author$project$Components$DocumentBrowser$Annotation$Drag$Dragging;
var $author$project$Components$DocumentBrowser$AnnotationOverlay$mapBox = F3(
	function (boxId, f, session) {
		return _Utils_update(
			session,
			{
				boxes: A2(
					$elm$core$List$map,
					function (editable) {
						return _Utils_eq(editable.id, boxId) ? f(editable) : editable;
					},
					session.boxes)
			});
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$mapSession = F2(
	function (f, model) {
		if (model.$ === 'Annotating') {
			var session = model.a;
			return $author$project$Components$DocumentBrowser$AnnotationOverlay$Annotating(
				f(session));
		} else {
			return model;
		}
	});
var $author$project$Components$DocumentBrowser$Annotation$TextBox$measure = F2(
	function (_v0, handlers) {
		var boxId = _v0.boxId;
		var containerId = _v0.containerId;
		return $author$project$HubTran$Effect$cmd(
			A2(
				$elm$core$Task$attempt,
				$elm$core$Result$withDefault(handlers.onFailed),
				A3(
					$elm$core$Task$map2,
					F2(
						function (input, page) {
							return handlers.onMeasured(((input.scene.height - input.viewport.height) / page.element.height) * 100);
						}),
					$elm$browser$Browser$Dom$getViewportOf(
						A2($author$project$Components$DocumentBrowser$Annotation$TextBox$inputId, containerId, boxId)),
					$elm$browser$Browser$Dom$getElement(containerId))));
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$reopened = F2(
	function (box, session) {
		var _v0 = session.kind;
		switch (_v0.$) {
			case 'Stamp':
				return session;
			case 'Crop':
				return session;
			case 'Redaction':
				return A2(
					$author$project$Components$DocumentBrowser$AnnotationOverlay$addBox,
					$author$project$Components$DocumentBrowser$AnnotationOverlay$fresh(box),
					session);
			default:
				return A2(
					$author$project$Components$DocumentBrowser$AnnotationOverlay$addBox,
					$author$project$Components$DocumentBrowser$AnnotationOverlay$fresh(box),
					session);
		}
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$kindOf = function (kind) {
	switch (kind.$) {
		case 'Stamp':
			return $author$project$AuditPb$PageAnnotationKindStamp;
		case 'Redaction':
			return $author$project$AuditPb$PageAnnotationKindRedaction;
		case 'Text':
			return $author$project$AuditPb$PageAnnotationKindText;
		default:
			return $author$project$AuditPb$PageAnnotationKindCrop;
	}
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$replacement = function (session) {
	return {
		annotations: A2(
			$elm$core$List$map,
			function (_v0) {
				var text = _v0.text;
				var box = _v0.box;
				return {
					height: box.height,
					kind: $author$project$Components$DocumentBrowser$AnnotationOverlay$kindOf(session.kind),
					left: box.left,
					text: text,
					top: box.top,
					width: box.width
				};
			},
			session.boxes),
		documentPageId: session.docPageId,
		kind: $author$project$Components$DocumentBrowser$AnnotationOverlay$kindOf(session.kind)
	};
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'Started':
				var kind = msg.a;
				var docPageId = msg.b;
				var box = msg.c;
				var _v1 = $author$project$Components$DocumentBrowser$AnnotationOverlay$sessionOf(model);
				if (_v1.$ === 'Just') {
					var session = _v1.a;
					return (_Utils_eq(session.docPageId, docPageId) && _Utils_eq(session.kind, kind)) ? _Utils_Tuple3(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$Annotating(
							A2($author$project$Components$DocumentBrowser$AnnotationOverlay$reopened, box, session)),
						$author$project$HubTran$Effect$none,
						$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg) : _Utils_Tuple3(
						A2($author$project$Components$DocumentBrowser$AnnotationOverlay$Checking, kind, docPageId),
						A3($author$project$Components$DocumentBrowser$AnnotationOverlay$check, kind, docPageId, box),
						$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
				} else {
					return _Utils_Tuple3(
						A2($author$project$Components$DocumentBrowser$AnnotationOverlay$Checking, kind, docPageId),
						A3($author$project$Components$DocumentBrowser$AnnotationOverlay$check, kind, docPageId, box),
						$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
				}
			case 'Checked':
				var kind = msg.a;
				var docPageId = msg.b;
				var box = msg.c;
				var result = msg.d;
				if (model.$ === 'Checking') {
					var pendingKind = model.a;
					var pendingDocPageId = model.b;
					if (_Utils_eq(pendingKind, kind) && _Utils_eq(pendingDocPageId, docPageId)) {
						var _v3 = A4($author$project$Components$DocumentBrowser$AnnotationOverlay$checked, kind, docPageId, box, result);
						var checkedModel = _v3.a;
						var effect = _v3.b;
						return _Utils_Tuple3(checkedModel, effect, $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
					} else {
						return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
					}
				} else {
					return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
				}
			case 'DragStarted':
				var boxId = msg.a;
				var grip = msg.b;
				var containerId = msg.c;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$mapSession,
						function (session) {
							return _Utils_update(
								session,
								{
									selection: $author$project$Components$DocumentBrowser$AnnotationOverlay$Selected(boxId)
								});
						},
						model),
					A2(
						$author$project$Components$DocumentBrowser$Annotation$Drag$begin,
						{boxId: boxId, containerId: containerId, grip: grip},
						{onFailed: $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOp, onMeasured: $author$project$Components$DocumentBrowser$AnnotationOverlay$DragStartedWithRect}),
					$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
			case 'DragStartedWithRect':
				var gesture = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$mapSession,
						function (session) {
							return _Utils_update(
								session,
								{
									drag: $author$project$Components$DocumentBrowser$Annotation$Drag$held(gesture)
								});
						},
						model),
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
			case 'DragMoved':
				var x = msg.a;
				var y = msg.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$mapSession,
						A2($author$project$Components$DocumentBrowser$AnnotationOverlay$dragBox, x, y),
						model),
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
			case 'DragEnded':
				return _Utils_Tuple3(
					A2(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$mapSession,
						function (session) {
							return _Utils_update(
								session,
								{drag: $author$project$Components$DocumentBrowser$Annotation$Drag$notDragging});
						},
						model),
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$HubTran$Effect$none,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$DocumentBrowser$AnnotationOverlay$focusText,
							$author$project$Components$DocumentBrowser$AnnotationOverlay$sessionOf(model))),
					$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
			case 'TextChanged':
				var boxId = msg.a;
				var containerId = msg.b;
				var text = msg.c;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$mapSession,
						A2(
							$author$project$Components$DocumentBrowser$AnnotationOverlay$mapBox,
							boxId,
							function (editable) {
								return _Utils_update(
									editable,
									{text: text});
							}),
						model),
					A2(
						$author$project$Components$DocumentBrowser$Annotation$TextBox$measure,
						{boxId: boxId, containerId: containerId},
						{
							onFailed: $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOp,
							onMeasured: $author$project$Components$DocumentBrowser$AnnotationOverlay$TextGrown(boxId)
						}),
					$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
			case 'TextGrown':
				var boxId = msg.a;
				var overflow = msg.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$mapSession,
						A2(
							$author$project$Components$DocumentBrowser$AnnotationOverlay$mapBox,
							boxId,
							function (editable) {
								return _Utils_update(
									editable,
									{
										box: A2($author$project$Components$DocumentBrowser$Annotation$TextBox$grow, overflow, editable.box)
									});
							}),
						model),
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
			case 'SaveClicked':
				var _v4 = $author$project$Components$DocumentBrowser$AnnotationOverlay$sessionOf(model);
				if (_v4.$ === 'Just') {
					var session = _v4.a;
					return _Utils_Tuple3(
						model,
						$author$project$HubTran$Effect$none,
						$author$project$Components$DocumentBrowser$AnnotationOverlay$UpdateRequested(
							$author$project$Components$DocumentBrowser$AnnotationOverlay$replacement(session)));
				} else {
					return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
				}
			case 'RemoveClicked':
				var boxId = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$mapSession,
						function (session) {
							return _Utils_update(
								session,
								{
									boxes: A2(
										$elm$core$List$filter,
										function (editable) {
											return !_Utils_eq(editable.id, boxId);
										},
										session.boxes),
									selection: $author$project$Components$DocumentBrowser$AnnotationOverlay$NothingSelected
								});
						},
						model),
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
			case 'CancelClicked':
				return _Utils_Tuple3($author$project$Components$DocumentBrowser$AnnotationOverlay$init, $author$project$HubTran$Effect$none, $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
			default:
				return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$DocumentBrowser$AnnotationOverlay$NoOutMsg);
		}
	});
var $author$project$Broker$Shared$CurrentProcessingSelection$updateWithDocPage = F2(
	function (docPageId, currentSelection) {
		switch (currentSelection.$) {
			case 'GroupedDocumentBatchSelection':
				var docBatchId = currentSelection.a;
				var docGroupId = currentSelection.b;
				return A3(
					$author$project$Broker$Shared$CurrentProcessingSelection$GroupedDocumentBatchSelection,
					docBatchId,
					docGroupId,
					$elm$core$Maybe$Just(docPageId));
			case 'DocumentBatchSelection':
				var docBatchId = currentSelection.a;
				return A2(
					$author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchSelection,
					docBatchId,
					$elm$core$Maybe$Just(docPageId));
			case 'EmailMessageSelection':
				var emailId = currentSelection.a;
				var docBatchId = currentSelection.b;
				return A3(
					$author$project$Broker$Shared$CurrentProcessingSelection$EmailMessageSelection,
					emailId,
					docBatchId,
					$elm$core$Maybe$Just(docPageId));
			case 'SinglePageSelection':
				return $author$project$Broker$Shared$CurrentProcessingSelection$SinglePageSelection(docPageId);
			case 'DocumentReviewSelection':
				var documentsLookup = currentSelection.a;
				return A2(
					$author$project$Broker$Shared$CurrentProcessingSelection$DocumentReviewSelection,
					documentsLookup,
					$elm$core$Maybe$Just(docPageId));
			case 'DocumentBatchReviewSelection':
				var documentBatchReviewId = currentSelection.a;
				var documentId = currentSelection.b;
				return A3(
					$author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchReviewSelection,
					documentBatchReviewId,
					documentId,
					$elm$core$Maybe$Just(docPageId));
			case 'DocumentGroupReviewSelection':
				var documentGroupReviewId = currentSelection.a;
				var documentId = currentSelection.b;
				return A3(
					$author$project$Broker$Shared$CurrentProcessingSelection$DocumentGroupReviewSelection,
					documentGroupReviewId,
					documentId,
					$elm$core$Maybe$Just(docPageId));
			case 'CarrierInvoiceSelection':
				var carrierInvoiceId = currentSelection.a;
				return A2(
					$author$project$Broker$Shared$CurrentProcessingSelection$CarrierInvoiceSelection,
					carrierInvoiceId,
					$elm$core$Maybe$Just(docPageId));
			case 'FactorInvoiceSelection':
				var factorInvoiceId = currentSelection.a;
				return A2(
					$author$project$Broker$Shared$CurrentProcessingSelection$FactorInvoiceSelection,
					factorInvoiceId,
					$elm$core$Maybe$Just(docPageId));
			case 'NonInvoiceLoadSelection':
				var loadStateId = currentSelection.a;
				var documentBatchId = currentSelection.b;
				return A3(
					$author$project$Broker$Shared$CurrentProcessingSelection$NonInvoiceLoadSelection,
					loadStateId,
					documentBatchId,
					$elm$core$Maybe$Just(docPageId));
			default:
				return currentSelection;
		}
	});
var $author$project$Components$DocumentsBrowser$viewEmailEffect = F3(
	function (maybeDocument, maybeOnDone, pathContext) {
		var _v0 = _Utils_Tuple2(
			maybeDocument,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.documentBatchId;
				},
				maybeDocument));
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var document = _v0.a.a;
			var documentBatchId = _v0.b.a;
			var maybeInvoiceId = A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				$elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2($elm$core$Maybe$map, $author$project$Domain$CarrierInvoiceId$toInt, document.carrierInvoiceId),
								A2($elm$core$Maybe$map, $author$project$Domain$FactorInvoiceId$toInt, document.factorInvoiceId)
							]))));
			return $author$project$HubTran$Effect$load(
				$author$project$Path$toString(
					A2(
						$author$project$Path$addQueries,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'invoiceId',
								A2($elm$core$Maybe$withDefault, '', maybeInvoiceId)),
								_Utils_Tuple2(
								'onDone',
								$elm$url$Url$percentEncode(
									A2($elm$core$Maybe$withDefault, '/dashboard', maybeOnDone)))
							]),
						A2($author$project$Path$documentBatch, documentBatchId, pathContext))));
		} else {
			return $author$project$HubTran$Effect$none;
		}
	});
var $author$project$Components$DocumentsBrowser$nonHotkeyUpdate = F4(
	function (data, msg, model, hooks) {
		nonHotkeyUpdate:
		while (true) {
			var useFactorInvoiceWorkflowPage = function () {
				var _v15 = $author$project$Forward$Remote$toMaybe(data);
				if (_v15.$ === 'Just') {
					var data_ = _v15.a;
					return A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, data_.accountSettings, data_.currentUser);
				} else {
					return false;
				}
			}();
			switch (msg.$) {
				case 'SelectDocument':
					var selection = msg.a;
					var docPageId = msg.b;
					var currentProcessingSelection = A2($author$project$Broker$Shared$CurrentProcessingSelection$updateWithDocPage, docPageId, model.currentProcessingSelection);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{currentProcessingSelection: currentProcessingSelection, maybeSelectedDocumentPageId: $elm$core$Maybe$Nothing, selectedPage_INTERNAL: selection}),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$HubTran$Effect$none,
							function (hook) {
								return A2(hook, selection, docPageId);
							},
							hooks.onSelectDocument));
				case 'SelectGroup':
					var batchId = msg.a;
					var docGroupId = msg.b;
					var currentProcessingSelection = A3($author$project$Broker$Shared$CurrentProcessingSelection$GroupedDocumentBatchSelection, batchId, docGroupId, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								currentProcessingSelection: currentProcessingSelection,
								maybeSelectedDocumentPageId: $elm$core$Maybe$Nothing,
								selectedPage_INTERNAL: {documentIndex: 0, pageIndex: 0}
							}),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$HubTran$Effect$none,
							function (hook) {
								return A2(hook, batchId, docGroupId);
							},
							hooks.onSelectGroup));
				case 'SelectedGroupRendered':
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$scrollToIdAtTopOfContainer(
								{
									containerId: $author$project$Components$DocumentBrowser$Full$groupRailId(model.scrollContainerSuffix),
									id: $author$project$Components$DocumentBrowser$Full$selectedGroupHeadingId(model.scrollContainerSuffix)
								})));
				case 'SetLineSelection':
					var line = msg.a;
					return _Utils_Tuple2(
						model,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$HubTran$Effect$none,
							function (hook) {
								return hook(line);
							},
							hooks.onSetLineSelection));
				case 'SelectTab':
					var tab = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedTab: tab}),
						$author$project$HubTran$Effect$none);
				case 'ChangeActivityTabPage':
					var page = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{activityTabPage: page}),
						$author$project$HubTran$Effect$none);
				case 'Rotate':
					var docPage = msg.a;
					var rotation = msg.b;
					var newRotation = docPage.rotation + rotation;
					var cleanedRotation = (newRotation < 0) ? 270 : ((newRotation === 360) ? 0 : ((newRotation > 360) ? 90 : newRotation));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{updating: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$ApiCallComplete(model),
							A2($author$project$Api$Documents$rotatePage, docPage.id, cleanedRotation)));
				case 'ZoomIn':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{zoomLevel: model.zoomLevel + 0.3}),
						$author$project$HubTran$Effect$none);
				case 'ZoomOut':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{zoomLevel: model.zoomLevel - 0.3}),
						$author$project$HubTran$Effect$none);
				case 'Duplicate':
					var docId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{updating: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$ApiCallComplete(model),
							$author$project$Api$Documents$duplicate(docId)));
				case 'SplitFromDocument':
					var selectedDocumentId = msg.a;
					var selectedDocumentPageId = msg.b;
					var selectedPage_ = A2($author$project$Components$DocumentsBrowser$selectedPageFromRemote, data, model);
					var updatedSelection = A2($author$project$Components$DocumentBrowser$Full$Selection, selectedPage_.documentIndex + 1, 0);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{updating: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$ApiCallComplete(
								_Utils_update(
									model,
									{maybeSelectedDocumentPageId: $elm$core$Maybe$Nothing, selectedPage_INTERNAL: updatedSelection})),
							A2($author$project$Api$Documents$splitPageFromDocument, selectedDocumentId, selectedDocumentPageId)));
				case 'MergeToPrevious':
					var mergeDocumentsData = msg.a;
					var selectedPage_ = A2($author$project$Components$DocumentsBrowser$selectedPageFromRemote, data, model);
					var previousDocIndex = selectedPage_.documentIndex - 1;
					var dataToDocumentData = function (data_) {
						return A2($author$project$Components$DocumentsBrowser$getDocumentData, data_, model);
					};
					var nextPageIndex = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$length,
								$elm$core$Basics$add(selectedPage_.pageIndex)),
							A2(
								$elm$core$Maybe$andThen,
								$elm_community$list_extra$List$Extra$getAt(previousDocIndex),
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										dataToDocumentData,
										function ($) {
											return $.documentPages;
										}),
									$author$project$Forward$Remote$toMaybe(data)))));
					var updatedSelection = A2($author$project$Components$DocumentBrowser$Full$Selection, previousDocIndex, nextPageIndex);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{updating: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$ApiCallComplete(
								_Utils_update(
									model,
									{maybeSelectedDocumentPageId: $elm$core$Maybe$Nothing, selectedPage_INTERNAL: updatedSelection})),
							$author$project$Api$Documents$mergeDocuments(mergeDocumentsData)));
				case 'UpdatePod':
					var documentId = msg.a;
					var isPOD = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								documentIsPodUpdates: A3($author$project$Helpers$DocumentIsPodUpdates$insert, documentId, isPOD, model.documentIsPodUpdates)
							}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$UpdatePodFinished(
								{documentId: documentId, isPOD: isPOD}),
							A2($author$project$Api$Documents$setPodStatus, documentId, isPOD)));
				case 'UpdatePodFinished':
					var documentPODUpdate = msg.a;
					var apiResult = msg.b;
					switch (apiResult.$) {
						case 'Ok':
							var response = apiResult.a;
							return _Utils_Tuple2(
								model,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$cmd(
											$author$project$TempJsInterop$sendToDataStoreService(response)),
											A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$HubTran$Effect$none,
											function (hook) {
												return hook(documentPODUpdate);
											},
											hooks.onUpdatePodFinished)
										])));
						case 'Err':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{documentIsPodUpdates: $author$project$Helpers$DocumentIsPodUpdates$empty}),
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{documentIsPodUpdates: $author$project$Helpers$DocumentIsPodUpdates$empty}),
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
					}
				case 'ToggleDocumentTypePicker':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{documentTypePickerOpen: !model.documentTypePickerOpen}),
						$author$project$HubTran$Effect$none);
				case 'KeyPressed':
					var key = msg.a;
					var _v2 = _Utils_Tuple3(
						model.documentTypePickerOpen,
						data,
						$author$project$Components$DocumentsBrowser$keyToIndex(key));
					if ((_v2.a && (_v2.b.$ === 'Loaded')) && (_v2.c.$ === 'Just')) {
						var data_ = _v2.b.a;
						var index = _v2.c.a;
						var sorted = $author$project$Components$DocumentTypePicker$sortedTypes(model.enabledDocumentTypes);
						var maybeDocumentId = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.id;
							},
							A2(
								$author$project$Components$DocumentBrowser$Full$selectedDocument,
								A2($author$project$Components$DocumentsBrowser$getPossiblyGroupedDocuments, data_, model),
								A2($author$project$Components$DocumentsBrowser$selectedPage, data_, model)));
						var _v3 = _Utils_Tuple2(
							A2($elm_community$list_extra$List$Extra$getAt, index, sorted),
							maybeDocumentId);
						if ((_v3.a.$ === 'Just') && (_v3.b.$ === 'Just')) {
							var dt = _v3.a.a;
							var docId = _v3.b.a;
							var $temp$data = data,
								$temp$msg = A2($author$project$Components$DocumentsBrowser$UpdateDocumentType, docId, dt.documentType),
								$temp$model = model,
								$temp$hooks = hooks;
							data = $temp$data;
							msg = $temp$msg;
							model = $temp$model;
							hooks = $temp$hooks;
							continue nonHotkeyUpdate;
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					} else {
						return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					}
				case 'UpdateDocumentType':
					var documentId = msg.a;
					var documentType = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{documentTypePickerOpen: false}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							A2($author$project$Components$DocumentsBrowser$UpdateDocumentTypeFinished, documentId, documentType),
							A2(
								$author$project$Api$Documents$setDocumentType,
								documentId,
								$author$project$Domain$UnresolvedDocumentType$Resolved(documentType))));
				case 'UpdateDocumentTypeFinished':
					var documentId = msg.a;
					var documentType = msg.b;
					var apiResult = msg.c;
					switch (apiResult.$) {
						case 'Ok':
							return _Utils_Tuple2(
								model,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_documentAddressAnswer),
											A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$HubTran$Effect$none,
											function (hook) {
												return A2(hook, documentId, documentType);
											},
											hooks.onUpdateDocumentTypeFinished)
										])));
						case 'Err':
							return _Utils_Tuple2(
								model,
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
						default:
							return _Utils_Tuple2(
								model,
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
					}
				case 'UpdateViewMode':
					var viewMode = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								viewMode: $elm$core$Maybe$Just(viewMode),
								zoomLevel: 1
							}),
						$author$project$HubTran$Effect$none);
				case 'SelectLabelForMessage':
					var index = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedLabelIndex: index}),
						$author$project$HubTran$Effect$none);
				case 'AddLabelToMessage':
					var emailMessageId = msg.a;
					var label = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{updating: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$ApiCallComplete(
								_Utils_update(
									model,
									{selectedLabelIndex: 0})),
							A2($author$project$Api$EmailMessages$addLabel, emailMessageId, label)));
				case 'DeleteLabelFromMessage':
					var emailMessageId = msg.a;
					var label = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{updating: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$ApiCallComplete(model),
							A2($author$project$Api$EmailMessages$deleteLabel, emailMessageId, label)));
				case 'SaveMessageAsDocument':
					var documentGroupId = msg.a;
					var emailMessageId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{savingMessageAsDocument: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$SaveMessageAsDocumentComplete,
							A2($author$project$Api$EmailMessages$saveAsDocument, emailMessageId, documentGroupId)));
				case 'CreateDocumentFromMessage':
					var emailMessageId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{savingMessageAsDocument: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$SaveMessageAsDocumentComplete,
							$author$project$Api$EmailMessages$createDocument(emailMessageId)));
				case 'SaveMessageAsDocumentComplete':
					switch (msg.a.$) {
						case 'Ok':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{savedMessageAsDocument: true, savingMessageAsDocument: false, selectedTab: $author$project$Components$DocumentsBrowser$Documents}),
								$author$project$Components$DocumentsBrowser$invalidateDocumentData(model));
						case 'Err':
							var message = msg.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{savingMessageAsDocument: false}),
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(message)));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{savingMessageAsDocument: false}),
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
					}
				case 'ApiCallComplete':
					switch (msg.b.$) {
						case 'Ok':
							var updatedModel = msg.a;
							return _Utils_Tuple2(
								_Utils_update(
									updatedModel,
									{updating: false}),
								$author$project$Components$DocumentsBrowser$invalidateDocumentData(model));
						case 'Err':
							var message = msg.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{updating: false}),
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(message)));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{updating: false}),
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
					}
				case 'Hide':
					var documentId = msg.a;
					var documentPageId = msg.b;
					var hidden = msg.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pendingHidden: A3(
									$elm$core$Dict$insert,
									$author$project$Domain$DocumentId$toComparable(documentId),
									hidden,
									model.pendingHidden)
							}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							A2($author$project$Components$DocumentsBrowser$HideFinished, documentId, documentPageId),
							A2($author$project$Api$Documents$markHidden, documentPageId, hidden)));
				case 'HideFinished':
					switch (msg.c.$) {
						case 'Ok':
							var documentId = msg.a;
							var documentPageId = msg.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										pendingHidden: A2(
											$elm$core$Dict$remove,
											$author$project$Domain$DocumentId$toComparable(documentId),
											model.pendingHidden)
									}),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$HubTran$Effect$none,
									function (hook) {
										return hook(documentPageId);
									},
									hooks.onHideFinished));
						case 'Err':
							var documentId = msg.a;
							var message = msg.c.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										pendingHidden: A2(
											$elm$core$Dict$remove,
											$author$project$Domain$DocumentId$toComparable(documentId),
											model.pendingHidden)
									}),
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(message)));
						default:
							var documentId = msg.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										pendingHidden: A2(
											$elm$core$Dict$remove,
											$author$project$Domain$DocumentId$toComparable(documentId),
											model.pendingHidden)
									}),
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
					}
				case 'MarkIllegible':
					var documentPageId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{updating: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DocumentsBrowser$MarkIllegibleFinished(documentPageId),
							$author$project$Api$Documents$markIllegible(documentPageId)));
				case 'MarkIllegibleFinished':
					switch (msg.b.$) {
						case 'Ok':
							var documentPageId = msg.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{updating: false}),
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$Components$DocumentsBrowser$invalidateDocumentData(model),
											A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$HubTran$Effect$none,
											function (hook) {
												return hook(documentPageId);
											},
											hooks.onMarkIllegibleFinished)
										])));
						case 'Err':
							var message = msg.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{updating: false}),
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(message)));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{updating: false}),
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
					}
				case 'ViewEmailToolbarClick':
					var maybeDocument = msg.a;
					var pathContext = {
						isReadonly: !A2($author$project$Components$DocumentsBrowser$isActionEnabled, $author$project$Components$DocumentsBrowser$EditMessageAction, model),
						useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage
					};
					return _Utils_Tuple2(
						model,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							A3($author$project$Components$DocumentsBrowser$viewEmailEffect, maybeDocument, model.onDone, pathContext),
							function (hook) {
								return hook(maybeDocument);
							},
							hooks.onViewEmailToolbarClick));
				case 'ViewEmailBrowserClick':
					var document = msg.a;
					var pathContext = {
						isReadonly: !A2($author$project$Components$DocumentsBrowser$isActionEnabled, $author$project$Components$DocumentsBrowser$EditMessageAction, model),
						useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage
					};
					return _Utils_Tuple2(
						model,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							A3(
								$author$project$Components$DocumentsBrowser$viewEmailEffect,
								$elm$core$Maybe$Just(document),
								model.onDone,
								pathContext),
							function (hook) {
								return hook(document);
							},
							hooks.onViewEmailBrowserClick));
				case 'AddDocumentToLoadMsg':
					var msg_ = msg.a;
					if (data.$ === 'Loaded') {
						var data_ = data.a;
						var _v6 = A3($author$project$Components$DocumentBrowser$AddDocumentToLoad$update, data_.addDocumentToLoadData, msg_, model.addDocumentToLoad);
						var childModel = _v6.a;
						var childEffect = _v6.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{addDocumentToLoad: childModel}),
							A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentsBrowser$AddDocumentToLoadMsg, childEffect));
					} else {
						return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					}
				case 'ToggleShowAllLoadDocs':
					var showAllLoadDocs = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{showAllLoadDocsToggled: showAllLoadDocs}),
						$author$project$HubTran$Effect$none);
				case 'RightClickedThumbnail':
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				case 'CompareBolAndRateConClicked':
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				case 'CloseClicked':
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				case 'ExpandClicked':
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				case 'PopoutClicked':
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				case 'LineDragStarted':
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				case 'DragScrollStart':
					var x = msg.a;
					var y = msg.b;
					var containerId = $author$project$Components$DocumentBrowser$Full$scrollContainerId(model.scrollContainerSuffix);
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$cmd(
							A2(
								$elm$core$Task$attempt,
								function (result) {
									if (result.$ === 'Ok') {
										var viewport = result.a;
										return A4($author$project$Components$DocumentsBrowser$DragScrollStartWithViewport, x, y, viewport.viewport.x, viewport.viewport.y);
									} else {
										return $author$project$Components$DocumentsBrowser$NoOp;
									}
								},
								$elm$browser$Browser$Dom$getViewportOf(containerId))));
				case 'DragScrollStartWithViewport':
					var x = msg.a;
					var y = msg.b;
					var scrollX = msg.c;
					var scrollY = msg.d;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dragScroll: $elm$core$Maybe$Just(
									{startScrollX: scrollX, startScrollY: scrollY, startX: x, startY: y})
							}),
						$author$project$HubTran$Effect$none);
				case 'DragScrollMove':
					var x = msg.a;
					var y = msg.b;
					var _v8 = model.dragScroll;
					if (_v8.$ === 'Nothing') {
						return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					} else {
						var state = _v8.a;
						var containerId = $author$project$Components$DocumentBrowser$Full$scrollContainerId(model.scrollContainerSuffix);
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$cmd(
								A2(
									$elm$core$Task$attempt,
									function (_v9) {
										return $author$project$Components$DocumentsBrowser$NoOp;
									},
									A3($elm$browser$Browser$Dom$setViewportOf, containerId, state.startScrollX - (x - state.startX), state.startScrollY - (y - state.startY)))));
					}
				case 'DragScrollEnd':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dragScroll: $elm$core$Maybe$Nothing}),
						$author$project$HubTran$Effect$none);
				case 'ToggleAnnotating':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{annotating: !model.annotating, annotations: $author$project$Components$DocumentBrowser$AnnotationOverlay$init}),
						$author$project$HubTran$Effect$none);
				case 'AnnotationMsg':
					var msg_ = msg.a;
					var _v10 = A2($author$project$Components$DocumentBrowser$AnnotationOverlay$update, msg_, model.annotations);
					var annotationsModel = _v10.a;
					var annotationsEffect = _v10.b;
					var outMsg = _v10.c;
					var updatedModel = _Utils_update(
						model,
						{annotations: annotationsModel});
					if (outMsg.$ === 'NoOutMsg') {
						return _Utils_Tuple2(
							updatedModel,
							A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentsBrowser$AnnotationMsg, annotationsEffect));
					} else {
						var request = outMsg.a;
						return _Utils_Tuple2(
							_Utils_update(
								updatedModel,
								{updating: true}),
							A2(
								$author$project$AuditApi$pageAnnotationServiceReplaceRemote,
								$author$project$Components$DocumentsBrowser$AnnotationsReplaced(
									_Utils_update(
										updatedModel,
										{annotations: $author$project$Components$DocumentBrowser$AnnotationOverlay$init})),
								request));
					}
				case 'AnnotationsReplaced':
					switch (msg.b.$) {
						case 'Success':
							var updatedModel = msg.a;
							return _Utils_Tuple2(
								_Utils_update(
									updatedModel,
									{updating: false}),
								$author$project$Components$DocumentsBrowser$invalidateDocumentData(model));
						case 'Failure':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{updating: false}),
								$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
						default:
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					}
				case 'ResendToCadence':
					var transmissionId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								resendingTransmissions: A3(
									$elm$core$Dict$insert,
									$author$project$Domain$TransmissionId$toInt(transmissionId),
									$author$project$Components$DocumentsBrowser$ResendSending,
									model.resendingTransmissions)
							}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequest,
							function (result) {
								if (result.$ === 'Err') {
									return A2(
										$author$project$Components$DocumentsBrowser$ResendToCadenceResult,
										transmissionId,
										$elm$core$Result$Err('HTTP error'));
								} else {
									if (result.a.$ === 'Err') {
										var serverError = result.a.a;
										return A2(
											$author$project$Components$DocumentsBrowser$ResendToCadenceResult,
											transmissionId,
											$elm$core$Result$Err(serverError));
									} else {
										return A2(
											$author$project$Components$DocumentsBrowser$ResendToCadenceResult,
											transmissionId,
											$elm$core$Result$Ok(_Utils_Tuple0));
									}
								}
							},
							$author$project$Api$Transmissions$resend(transmissionId)));
				case 'ResendToCadenceResult':
					var transmissionId = msg.a;
					var result = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								resendingTransmissions: function () {
									if (result.$ === 'Ok') {
										return A3(
											$elm$core$Dict$insert,
											$author$project$Domain$TransmissionId$toInt(transmissionId),
											$author$project$Components$DocumentsBrowser$ResendSent,
											model.resendingTransmissions);
									} else {
										return A2(
											$elm$core$Dict$remove,
											$author$project$Domain$TransmissionId$toInt(transmissionId),
											model.resendingTransmissions);
									}
								}()
							}),
						function () {
							if (result.$ === 'Ok') {
								return $author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$success('Invoice Resent to FactorSoft!'));
							} else {
								return $author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert('Failed to resend invoice'));
							}
						}());
				case 'UnapproveFromActivity':
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				default:
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			}
		}
	});
var $author$project$Components$DocumentsBrowser$update = F4(
	function (data, topLevelMsg, model, hooks) {
		var msg = function () {
			if (topLevelMsg.$ === 'HotkeyMsg') {
				var hotkey = topLevelMsg.a;
				return A3($author$project$Components$DocumentsBrowser$hotkeyToMsg, hotkey, data, model);
			} else {
				var nonHotkeyMsg = topLevelMsg.a;
				return nonHotkeyMsg;
			}
		}();
		return A2(
			$elm$core$Tuple$mapSecond,
			$author$project$HubTran$Effect$map($author$project$Components$DocumentsBrowser$NonHotkeyMsg),
			A4($author$project$Components$DocumentsBrowser$nonHotkeyUpdate, data, msg, model, hooks));
	});
var $author$project$Js$updateCurrentProcessingSelection = _Platform_outgoingPort('updateCurrentProcessingSelection', $elm$core$Basics$identity);
var $author$project$Components$DocumentBrowser$Full$HighlightString = function (a) {
	return {$: 'HighlightString', a: a};
};
var $author$project$Components$DocumentsBrowser$valueHighlight = function (value) {
	return {
		target: $author$project$Components$DocumentBrowser$Full$HighlightString(value)
	};
};
var $author$project$Broker$Page$DocumentsViewerPopout$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'DocumentsBrowserMsg':
				var documentsViewerMsg = msg.a;
				var viewEmailEffect = function (maybeDocument) {
					return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$HubTran$Effect$none, $author$project$Broker$Page$DocumentsViewerPopout$closeDocumentViewerEffect, maybeDocument);
				};
				var updatePodFinishedEffect = function (documentPODUpdate) {
					return $author$project$HubTran$Effect$cmd(
						$author$project$Js$setDocumentPodUpdate(
							$author$project$AuditPb$documentPODUpdateEncoder(documentPODUpdate)));
				};
				var setLineEffect = function (line) {
					return $author$project$HubTran$Effect$cmd(
						$author$project$Js$documentPageLineFromPopout(line));
				};
				var selectGroupEffect = F2(
					function (batchId, docGroupId) {
						var currentGroupSelection = A2($author$project$Broker$Shared$CurrentProcessingSelection$groupedDocumentBatch, batchId, docGroupId);
						return $author$project$HubTran$Effect$cmd(
							$author$project$Js$updateCurrentProcessingSelection(
								$author$project$Broker$Shared$CurrentProcessingSelection$encodeToValue(currentGroupSelection)));
					});
				var selectDocumentEffect = F2(
					function (_v2, docPageId) {
						var currentProcessingSelection = A2($author$project$Broker$Shared$CurrentProcessingSelection$updateWithDocPage, docPageId, model.documentsViewer.currentProcessingSelection);
						return $author$project$HubTran$Effect$cmd(
							$author$project$Js$updateCurrentProcessingSelection(
								$author$project$Broker$Shared$CurrentProcessingSelection$encodeToValue(currentProcessingSelection)));
					});
				var hooks = {
					onHideFinished: $elm$core$Maybe$Nothing,
					onMarkIllegibleFinished: $elm$core$Maybe$Nothing,
					onSelectDocument: $elm$core$Maybe$Just(selectDocumentEffect),
					onSelectGroup: $elm$core$Maybe$Just(selectGroupEffect),
					onSetLineSelection: $elm$core$Maybe$Just(setLineEffect),
					onUpdateDocumentTypeFinished: $elm$core$Maybe$Nothing,
					onUpdatePodFinished: $elm$core$Maybe$Just(updatePodFinishedEffect),
					onViewEmailBrowserClick: $elm$core$Maybe$Just($author$project$Broker$Page$DocumentsViewerPopout$closeDocumentViewerEffect),
					onViewEmailToolbarClick: $elm$core$Maybe$Just(viewEmailEffect)
				};
				var _v1 = A4(
					$author$project$Components$DocumentsBrowser$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.documentsBrowserData;
						},
						data),
					documentsViewerMsg,
					model.documentsViewer,
					hooks);
				var documentsViewer = _v1.a;
				var documentsViewerEffect = _v1.b;
				var newModel = _Utils_update(
					model,
					{documentsViewer: documentsViewer});
				var newEffect = A2($author$project$HubTran$Effect$map, $author$project$Broker$Page$DocumentsViewerPopout$DocumentsBrowserMsg, documentsViewerEffect);
				return _Utils_Tuple2(newModel, newEffect);
			case 'CurrentProcessingSelectionRefreshed':
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$invalidateAll);
			case 'CurrentProcessingSelectionUpdated':
				var selectionData = msg.a;
				var currentProcessingSelection = $author$project$Broker$Shared$CurrentProcessingSelection$decodeFromValue(selectionData);
				var documentsViewer = A2(
					$author$project$Components$DocumentsBrowser$setMaybeSelectedDocumentPageId,
					currentProcessingSelection,
					A2($author$project$Components$DocumentsBrowser$setCurrentProcessingSelection, currentProcessingSelection, model.documentsViewer));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{documentsViewer: documentsViewer}),
					$author$project$HubTran$Effect$none);
			case 'DocumentViewerPageContextDataUpdated':
				var encodedPageData = msg.a;
				var pageContextData = $author$project$Helpers$DocumentViewerPageContextData$decodeMaybe(encodedPageData);
				var documentsViewer = model.documentsViewer;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documentsViewer: _Utils_update(
								documentsViewer,
								{
									addDocumentToLoad: $author$project$Components$DocumentBrowser$AddDocumentToLoad$init(pageContextData).a
								})
						}),
					$author$project$HubTran$Effect$none);
			default:
				var hoveredText = msg.a;
				var documentsViewer = A2(
					$author$project$Components$DocumentsBrowser$setHighlight,
					A2($elm$core$Maybe$map, $author$project$Components$DocumentsBrowser$valueHighlight, hoveredText),
					model.documentsViewer);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{documentsViewer: documentsViewer}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeActivityType = function (maybeActivityType) {
	return A2(
		$elm$core$Maybe$map,
		function (activityType) {
			return _Utils_Tuple2('activityType', activityType);
		},
		maybeActivityType);
};
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeCarrier = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (carrierId) {
			return _Utils_Tuple2(
				'carrierId',
				$elm$core$String$fromInt(
					$author$project$Domain$TmsCarrierId$toInt(carrierId)));
		},
		$author$project$Components$CarrierTypeahead$selectedId(model));
};
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeCarrierDropdown = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (carrierId) {
			return _Utils_Tuple2(
				'carrierDropdownId',
				$elm$core$String$fromInt(
					$author$project$Domain$TmsCarrierId$toInt(carrierId)));
		},
		$elm$core$List$head(
			$author$project$Components$SettingsPage$CarrierDropdown$selectedIds(model)));
};
var $author$project$Components$CustomerTypeahead$selectedId = $author$project$Typeahead$selectedId;
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeCustomer = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (customerId) {
			return _Utils_Tuple2(
				'customerId',
				$elm$core$String$fromInt(
					$author$project$Domain$TmsCustomerId$toInt(customerId)));
		},
		$author$project$Components$CustomerTypeahead$selectedId(model));
};
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeCustomerDropdown = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (customerId) {
			return _Utils_Tuple2(
				'customerDropdownId',
				$elm$core$String$fromInt(
					$author$project$Domain$TmsCustomerId$toInt(customerId)));
		},
		$elm$core$List$head(
			$author$project$Components$TmsCustomerDropdown$selectedIds(model)));
};
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeDateQuery = function (key) {
	return $elm$core$Maybe$map(
		function (date) {
			return _Utils_Tuple2(
				key,
				$justinmimbs$date$Date$toIsoString(date));
		});
};
var $author$project$Components$DebtorTypeahead$selectedId = $author$project$Typeahead$selectedId;
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeDebtor = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (debtorId) {
			return _Utils_Tuple2(
				'debtorId',
				$elm$core$String$fromInt(
					$author$project$Domain$FactorBrokerId$toInt(debtorId)));
		},
		$author$project$Components$DebtorTypeahead$selectedId(model));
};
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeInvoiceLoadId = function (key) {
	return $elm$core$Maybe$Just(
		_Utils_Tuple2('invoiceNumOrLoadId', key));
};
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeUserId = function (maybeUserId) {
	return A2(
		$elm$core$Maybe$map,
		function (userId) {
			return _Utils_Tuple2(
				'userId',
				$elm$core$String$fromInt(
					$author$project$Domain$UserId$toInt(userId)));
		},
		maybeUserId);
};
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeAsQueries = function (activityFilters) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeActivityType(activityFilters.selectedActivityType),
				$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeUserId(activityFilters.selectedUserId),
				A2($author$project$Components$ActivityBrowser$Url$FilterArguments$encodeDateQuery, 'startDate', activityFilters.startDate),
				A2($author$project$Components$ActivityBrowser$Url$FilterArguments$encodeDateQuery, 'endDate', activityFilters.endDate),
				$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeDebtor(activityFilters.debtorTypeahead),
				$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeCarrier(activityFilters.carrierTypeahead),
				$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeCustomer(activityFilters.customerTypeahead),
				$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeCarrierDropdown(activityFilters.carrierDropdown),
				$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeCustomerDropdown(activityFilters.customerDropdown),
				$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeInvoiceLoadId(activityFilters.invoiceNumOrLoadIdString)
			]));
};
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeQueryStringArg = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		function (_v0) {
			var key = _v0.a;
			var value = _v0.b;
			return key + ('=' + value);
		}),
	$elm$core$Maybe$withDefault(''));
var $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeAsQueryString = A2(
	$elm$core$Basics$composeR,
	$author$project$Components$ActivityBrowser$Url$FilterArguments$encodeAsQueries,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Components$ActivityBrowser$Url$FilterArguments$encodeQueryStringArg)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$join('&'),
			$elm$core$Basics$append('?'))));
var $author$project$Components$ActivityBrowser$Url$getPrefix = '/app/activity/';
var $author$project$Components$ActivityBrowser$Url$urlWithArguments = F2(
	function (filters, activePage) {
		return $author$project$Components$ActivityBrowser$Url$getPrefix + ($author$project$Components$ActivityBrowser$Url$FilterArguments$encodeAsQueryString(filters) + ('&page=' + $elm$core$String$fromInt(activePage)));
	});
var $author$project$Components$ActivityPage$browserUrl = function (model) {
	return A2($author$project$Components$ActivityBrowser$Url$urlWithArguments, model.appliedFilters, model.page);
};
var $author$project$Components$ActivityPage$maybeUpdateBrowserUrl = F2(
	function (previousModel, currentModel) {
		return (!_Utils_eq(
			$author$project$Components$ActivityPage$browserUrl(previousModel),
			$author$project$Components$ActivityPage$browserUrl(currentModel))) ? $author$project$HubTran$Effect$replaceUrl(
			$author$project$Components$ActivityPage$browserUrl(currentModel)) : $author$project$HubTran$Effect$none;
	});
var $author$project$Components$SettingsPage$CarrierDropdown$clear = function (model) {
	return _Utils_update(
		model,
		{
			dropdown: $author$project$Components$PaginatedDropdown$clear(model.dropdown)
		});
};
var $author$project$Components$TmsCustomerDropdown$clear = function (model) {
	return _Utils_update(
		model,
		{
			dropdown: $author$project$Components$PaginatedDropdown$clear(model.dropdown)
		});
};
var $author$project$Components$ActivityBrowser$FiltersView$clear = function (model) {
	return _Utils_update(
		model,
		{
			carrierDropdown: $author$project$Components$SettingsPage$CarrierDropdown$clear(model.carrierDropdown),
			customerDropdown: $author$project$Components$TmsCustomerDropdown$clear(model.customerDropdown),
			endDate: $elm$core$Maybe$Nothing,
			endDateString: '',
			selectedActivityType: $elm$core$Maybe$Nothing,
			selectedUserId: $elm$core$Maybe$Nothing,
			startDate: $elm$core$Maybe$Nothing,
			startDateString: ''
		});
};
var $author$project$Components$ActivityPage$saveLastActivityItemListViewData = F2(
	function (remoteData, model) {
		return _Utils_update(
			model,
			{
				maybeLastActivityItemListViewData: function () {
					if (remoteData.$ === 'Loaded') {
						var loadedData = remoteData.a;
						var _v1 = loadedData.activityItemListView;
						if (_v1.$ === 'Loaded') {
							var d = _v1.a;
							return $elm$core$Maybe$Just(d);
						} else {
							return model.maybeLastActivityItemListViewData;
						}
					} else {
						return model.maybeLastActivityItemListViewData;
					}
				}()
			});
	});
var $author$project$Components$ActivityBrowser$Details$TransmissionDetailsView$init = {isDataVisible: false};
var $author$project$Components$ActivityBrowser$DetailsView$init = {transmissionDetailsState: $author$project$Components$ActivityBrowser$Details$TransmissionDetailsView$init};
var $author$project$Components$ActivityBrowser$ActivityItemView$init = {detailsView: $author$project$Components$ActivityBrowser$DetailsView$init, isExpanded: false};
var $author$project$Components$ActivityBrowser$ActivityItemListView$activityItemViewModel = F2(
	function (activityItemId, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$ActivityBrowser$ActivityItemView$init,
			A2(
				$elm$core$Dict$get,
				$author$project$Domain$ActivityItemId$toInt(activityItemId),
				model.activityItemViews));
	});
var $author$project$Components$ActivityBrowser$Details$TransmissionDetailsView$update = F2(
	function (action, model) {
		return _Utils_update(
			model,
			{isDataVisible: !model.isDataVisible});
	});
var $author$project$Components$ActivityBrowser$DetailsView$update = F2(
	function (msg, model) {
		var childMsg = msg.a;
		return _Utils_update(
			model,
			{
				transmissionDetailsState: A2($author$project$Components$ActivityBrowser$Details$TransmissionDetailsView$update, childMsg, model.transmissionDetailsState)
			});
	});
var $author$project$Components$ActivityBrowser$ActivityItemView$update = F2(
	function (msg, model) {
		if (msg.$ === 'DetailsViewMsg') {
			var childMsg = msg.a;
			return _Utils_update(
				model,
				{
					detailsView: A2($author$project$Components$ActivityBrowser$DetailsView$update, childMsg, model.detailsView)
				});
		} else {
			return _Utils_update(
				model,
				{isExpanded: !model.isExpanded});
		}
	});
var $author$project$Components$ActivityBrowser$ActivityItemListView$update = F2(
	function (msg, model) {
		var activityItemId = msg.a;
		var childMsg = msg.b;
		var oldChildModel = A2($author$project$Components$ActivityBrowser$ActivityItemListView$activityItemViewModel, activityItemId, model);
		var newChildModel = A2($author$project$Components$ActivityBrowser$ActivityItemView$update, childMsg, oldChildModel);
		return _Utils_update(
			model,
			{
				activityItemViews: A3(
					$elm$core$Dict$insert,
					$author$project$Domain$ActivityItemId$toInt(activityItemId),
					newChildModel,
					model.activityItemViews)
			});
	});
var $author$project$Components$CarrierTypeahead$unknownCarrier = function (carrierTerm) {
	var base = $author$project$Domain$TmsCarrier$unknownCarrier;
	return _Utils_update(
		base,
		{
			name: 'Unknown ' + A2($elm$core$Maybe$withDefault, $author$project$Helpers$String$nbsp, carrierTerm)
		});
};
var $author$project$Components$CarrierTypeahead$config = function (accountType) {
	var carrierTerm = A2($elm$core$Maybe$map, $author$project$Domain$Account$carrierTerm, accountType);
	var placeholder = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Helpers$String$nbsp,
		A2(
			$elm$core$Maybe$map,
			function (term) {
				return term + ' Name';
			},
			carrierTerm));
	return {
		additionalInputAttributes: _List_Nil,
		additionalMenuAttributes: _List_Nil,
		idToString: A2($elm$core$Basics$composeR, $author$project$Domain$TmsCarrierId$toInt, $elm$core$String$fromInt),
		inputClassOverride: $elm$core$Maybe$Nothing,
		itemDisplay: A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.name;
			},
			$elm$html$Html$text),
		itemName: function ($) {
			return $.name;
		},
		liClassOverride: $elm$core$Maybe$Nothing,
		noItemDisplay: $elm$core$Maybe$Nothing,
		placeholder: placeholder,
		prependItems: _List_fromArray(
			[
				$author$project$Components$CarrierTypeahead$unknownCarrier(carrierTerm)
			]),
		sort: $elm$core$List$sortBy(
			function ($) {
				return $.name;
			}),
		toId: function ($) {
			return $.id;
		}
	};
};
var $author$project$Components$ActivityBrowser$FiltersView$carrierTypeaheadConfig = function (account) {
	return $author$project$Components$CarrierTypeahead$config(
		$elm$core$Maybe$Just(
			$author$project$Domain$Account$accountType(account)));
};
var $author$project$Components$ActivityBrowser$FiltersView$isSiloingDebtors = function (account) {
	return _Utils_eq(account.tms, $author$project$AuditPb$TMSOptionBusinessManager);
};
var $author$project$Helpers$String$begins = F2(
	function (first, second) {
		return A2($elm$core$String$startsWith, second, first);
	});
var $author$project$Typeahead$menuItems = F3(
	function (config, _v0, items) {
		var model = _v0.a;
		var searchTerm = function () {
			var _v1 = model.selection;
			if (_v1.$ === 'NoSelection') {
				var term = _v1.a;
				return term;
			} else {
				var itemId = _v1.a;
				return '';
			}
		}();
		var clean = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$String$join(''),
				$elm$core$String$words),
			$elm$core$String$toLower);
		var matchesSearchTerm = function (prependItem) {
			return A2(
				$author$project$Helpers$String$begins,
				clean(
					config.itemName(prependItem)),
				clean(searchTerm));
		};
		return _Utils_ap(
			A2($elm$core$List$filter, matchesSearchTerm, config.prependItems),
			config.sort(items));
	});
var $author$project$TypeaheadMenu$resetToFirst = function (selectedType) {
	var setFirstItem = F2(
		function (datum, newState) {
			return _Utils_update(
				newState,
				{
					highlightedViaKeyboard: $elm$core$Maybe$Just(datum)
				});
		});
	var _v0 = $elm$core$List$head(selectedType);
	if (_v0.$ === 'Nothing') {
		return $author$project$TypeaheadMenu$empty;
	} else {
		var datum = _v0.a;
		return A2(setFirstItem, datum, $author$project$TypeaheadMenu$empty);
	}
};
var $author$project$TypeaheadMenu$resetToFirstItem = F2(
	function (selectedType, howManyToShow) {
		return $author$project$TypeaheadMenu$resetToFirst(
			A2($elm$core$List$take, howManyToShow, selectedType));
	});
var $author$project$TypeaheadMenu$resetToLastItem = F2(
	function (selectedType, howManyToShow) {
		var reversedData = $elm$core$List$reverse(
			A2($elm$core$List$take, howManyToShow, selectedType));
		return $author$project$TypeaheadMenu$resetToFirst(reversedData);
	});
var $author$project$Typeahead$handleTypeaheadMenuResult = F4(
	function (config, items, updateResult, _v0) {
		var model = _v0.a;
		return $author$project$Typeahead$Model(
			function () {
				switch (updateResult.$) {
					case 'CloseMenu':
						return _Utils_update(
							model,
							{menu: $elm$core$Maybe$Nothing});
					case 'SelectItem':
						var id = updateResult.a;
						return _Utils_update(
							model,
							{
								incrementToSetText: model.incrementToSetText + 1,
								menu: $elm$core$Maybe$Nothing,
								selection: $author$project$Typeahead$Selected(id)
							});
					case 'Wrap':
						var direction = updateResult.a;
						var allItems = A2(
							$elm$core$List$map,
							config.toId,
							A3(
								$author$project$Typeahead$menuItems,
								config,
								$author$project$Typeahead$Model(model),
								items));
						var wrap = function () {
							if (direction.$ === 'TopToBottom') {
								return A2($author$project$TypeaheadMenu$resetToLastItem, allItems, model.numberToShow);
							} else {
								return A2($author$project$TypeaheadMenu$resetToFirstItem, allItems, model.numberToShow);
							}
						}();
						return _Utils_update(
							model,
							{
								menu: A2(
									$elm$core$Maybe$map,
									function (_v2) {
										return wrap;
									},
									model.menu)
							});
					default:
						var focused = updateResult.a;
						return _Utils_update(
							model,
							{focused: focused});
				}
			}());
	});
var $author$project$TypeaheadMenu$BottomToTop = {$: 'BottomToTop'};
var $author$project$TypeaheadMenu$CloseMenu = {$: 'CloseMenu'};
var $author$project$TypeaheadMenu$SelectItem = function (a) {
	return {$: 'SelectItem', a: a};
};
var $author$project$TypeaheadMenu$SetFocus = function (a) {
	return {$: 'SetFocus', a: a};
};
var $author$project$TypeaheadMenu$TopToBottom = {$: 'TopToBottom'};
var $author$project$TypeaheadMenu$Wrap = function (a) {
	return {$: 'Wrap', a: a};
};
var $author$project$TypeaheadMenu$getPrevious = F3(
	function (id, selectedId, resultId) {
		return _Utils_eq(selectedId, id) ? $elm$core$Maybe$Just(id) : (_Utils_eq(
			resultId,
			$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Just(selectedId) : resultId);
	});
var $author$project$TypeaheadMenu$getNextItemId = F2(
	function (ids, selectedId) {
		return A2(
			$elm$core$Maybe$withDefault,
			selectedId,
			A3(
				$elm$core$List$foldl,
				$author$project$TypeaheadMenu$getPrevious(selectedId),
				$elm$core$Maybe$Nothing,
				ids));
	});
var $author$project$TypeaheadMenu$getPreviousItemId = F2(
	function (ids, selectedId) {
		return A2(
			$elm$core$Maybe$withDefault,
			selectedId,
			A3(
				$elm$core$List$foldr,
				$author$project$TypeaheadMenu$getPrevious(selectedId),
				$elm$core$Maybe$Nothing,
				ids));
	});
var $author$project$TypeaheadMenu$navigateWithKey = F3(
	function (key, ids, maybeId) {
		switch (key.$) {
			case 'ArrowUp':
				return A2(
					$elm$core$Maybe$map,
					$author$project$TypeaheadMenu$getPreviousItemId(ids),
					maybeId);
			case 'ArrowDown':
				return A2(
					$elm$core$Maybe$map,
					$author$project$TypeaheadMenu$getNextItemId(ids),
					maybeId);
			default:
				return maybeId;
		}
	});
var $author$project$TypeaheadMenu$resetStateWithId = function (id) {
	return {
		highlightedViaKeyboard: $elm$core$Maybe$Just(id),
		highlightedViaMouse: $elm$core$Maybe$Just(id)
	};
};
var $author$project$TypeaheadMenu$update = F4(
	function (msg, howManyToShow, state, ids) {
		switch (msg.$) {
			case 'KeyDown':
				if (msg.a.$ === 'Nothing') {
					var _v1 = msg.a;
					return _Utils_Tuple2(state, $elm$core$Maybe$Nothing);
				} else {
					var key = msg.a.a;
					var boundedList = A2($elm$core$List$take, howManyToShow, ids);
					var newKey = A3($author$project$TypeaheadMenu$navigateWithKey, key, boundedList, state.highlightedViaKeyboard);
					return (_Utils_eq(newKey, state.highlightedViaKeyboard) && _Utils_eq(key, $ohanhi$keyboard$Keyboard$ArrowUp)) ? _Utils_Tuple2(
						state,
						$elm$core$Maybe$Just(
							$author$project$TypeaheadMenu$Wrap($author$project$TypeaheadMenu$TopToBottom))) : ((_Utils_eq(newKey, state.highlightedViaKeyboard) && _Utils_eq(key, $ohanhi$keyboard$Keyboard$ArrowDown)) ? _Utils_Tuple2(
						state,
						$elm$core$Maybe$Just(
							$author$project$TypeaheadMenu$Wrap($author$project$TypeaheadMenu$BottomToTop))) : _Utils_Tuple2(
						{highlightedViaKeyboard: newKey, highlightedViaMouse: newKey},
						function () {
							var _v2 = _Utils_Tuple2(key, newKey);
							_v2$3:
							while (true) {
								if (_v2.b.$ === 'Just') {
									switch (_v2.a.$) {
										case 'Enter':
											var _v3 = _v2.a;
											var id_ = _v2.b.a;
											return $elm$core$Maybe$Just(
												$author$project$TypeaheadMenu$SelectItem(id_));
										case 'Escape':
											var _v4 = _v2.a;
											return $elm$core$Maybe$Just($author$project$TypeaheadMenu$CloseMenu);
										default:
											break _v2$3;
									}
								} else {
									if (_v2.a.$ === 'Tab') {
										var _v5 = _v2.a;
										var _v6 = _v2.b;
										return $elm$core$Maybe$Just(
											$author$project$TypeaheadMenu$SetFocus(false));
									} else {
										break _v2$3;
									}
								}
							}
							return $elm$core$Maybe$Nothing;
						}()));
				}
			case 'MouseEnter':
				var id = msg.a;
				return _Utils_Tuple2(
					$author$project$TypeaheadMenu$resetStateWithId(id),
					$elm$core$Maybe$Just(
						$author$project$TypeaheadMenu$SetFocus(false)));
			case 'MouseLeave':
				return _Utils_Tuple2(
					$author$project$TypeaheadMenu$empty,
					$elm$core$Maybe$Just(
						$author$project$TypeaheadMenu$SetFocus(true)));
			default:
				var id = msg.a;
				return _Utils_Tuple2(
					$author$project$TypeaheadMenu$resetStateWithId(id),
					$elm$core$Maybe$Just(
						$author$project$TypeaheadMenu$SelectItem(id)));
		}
	});
var $author$project$Typeahead$modelCommands = F4(
	function (autoMsg, _v0, items, config) {
		var model = _v0.a;
		var _v1 = model.menu;
		if (_v1.$ === 'Nothing') {
			return $author$project$Typeahead$Model(model);
		} else {
			var menu = _v1.a;
			var allItems = A3(
				$author$project$Typeahead$menuItems,
				config,
				$author$project$Typeahead$Model(model),
				items);
			var _v2 = A4(
				$author$project$TypeaheadMenu$update,
				autoMsg,
				model.numberToShow,
				menu,
				A2($elm$core$List$map, config.toId, allItems));
			var newState = _v2.a;
			var updatResult = _v2.b;
			var newModel = $author$project$Typeahead$Model(
				_Utils_update(
					model,
					{
						menu: $elm$core$Maybe$Just(newState)
					}));
			if (updatResult.$ === 'Nothing') {
				return newModel;
			} else {
				var result = updatResult.a;
				return A4($author$project$Typeahead$handleTypeaheadMenuResult, config, allItems, result, newModel);
			}
		}
	});
var $author$project$Typeahead$update = F4(
	function (config, data_, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'GetNewItems':
				if (msg.a === '') {
					return $author$project$Typeahead$Model(
						_Utils_update(
							model,
							{
								focused: true,
								menu: $elm$core$Maybe$Nothing,
								selection: $author$project$Typeahead$NoSelection('')
							}));
				} else {
					var newSearchTerm = msg.a;
					return $author$project$Typeahead$Model(
						_Utils_update(
							model,
							{
								focused: true,
								menu: $elm$core$Maybe$Just(
									A2($elm$core$Maybe$withDefault, $author$project$TypeaheadMenu$empty, model.menu)),
								selection: $author$project$Typeahead$NoSelection(newSearchTerm)
							}));
				}
			case 'Clear':
				return $author$project$Typeahead$Model(
					_Utils_update(
						model,
						{
							focused: false,
							incrementToSetText: model.incrementToSetText + 1,
							menu: $elm$core$Maybe$Nothing,
							selection: $author$project$Typeahead$NoSelection('')
						}));
			case 'PossibleReset':
				var _v2 = _Utils_Tuple3(model.focused, model.selection, model.menu);
				if (_v2.a) {
					if (_v2.b.$ === 'NoSelection') {
						return $author$project$Typeahead$Model(
							_Utils_update(
								model,
								{
									focused: false,
									incrementToSetText: model.incrementToSetText + 1,
									menu: $elm$core$Maybe$Nothing,
									selection: $author$project$Typeahead$NoSelection('')
								}));
					} else {
						if (_v2.c.$ === 'Just') {
							return $author$project$Typeahead$Model(
								_Utils_update(
									model,
									{
										focused: false,
										incrementToSetText: model.incrementToSetText + 1,
										menu: $elm$core$Maybe$Nothing,
										selection: $author$project$Typeahead$NoSelection('')
									}));
						} else {
							var _v3 = _v2.c;
							return $author$project$Typeahead$Model(
								_Utils_update(
									model,
									{focused: false, menu: $elm$core$Maybe$Nothing}));
						}
					}
				} else {
					return $author$project$Typeahead$Model(model);
				}
			case 'TypeaheadMenuMsg':
				var autoMsg = msg.a;
				var _v4 = $author$project$Forward$Remote$toMaybe(data_);
				if (_v4.$ === 'Nothing') {
					return $author$project$Typeahead$Model(model);
				} else {
					var data__ = _v4.a;
					var _v5 = $author$project$Forward$Remote$toMaybe(data__.menuItems);
					if (_v5.$ === 'Just') {
						var menuItems_ = _v5.a;
						return A4(
							$author$project$Typeahead$modelCommands,
							autoMsg,
							$author$project$Typeahead$Model(model),
							menuItems_,
							config);
					} else {
						return A4(
							$author$project$Typeahead$modelCommands,
							autoMsg,
							$author$project$Typeahead$Model(model),
							_List_Nil,
							config);
					}
				}
			default:
				var focus = msg.a;
				return $author$project$Typeahead$Model(
					_Utils_update(
						model,
						{focused: focus}));
		}
	});
var $author$project$Components$CarrierTypeahead$update = $author$project$Typeahead$update;
var $author$project$Components$CustomerTypeahead$config = function () {
	var accountNumber = function (c) {
		var _v0 = function ($) {
			return $.accountNumber;
		}(c);
		if (_v0.$ === 'Just') {
			var num = _v0.a;
			return ' ' + num;
		} else {
			return '';
		}
	};
	var display = function (c) {
		return _Utils_ap(
			function ($) {
				return $.name;
			}(c),
			accountNumber(c));
	};
	return {
		additionalInputAttributes: _List_Nil,
		additionalMenuAttributes: _List_fromArray(
			[
				$elm$html$Html$Attributes$class('typeahead-menu-fixed')
			]),
		idToString: A2($elm$core$Basics$composeR, $author$project$Domain$TmsCustomerId$toInt, $elm$core$String$fromInt),
		inputClassOverride: $elm$core$Maybe$Nothing,
		itemDisplay: A2($elm$core$Basics$composeR, display, $elm$html$Html$text),
		itemName: function ($) {
			return $.name;
		},
		liClassOverride: $elm$core$Maybe$Nothing,
		noItemDisplay: $elm$core$Maybe$Nothing,
		placeholder: 'Customer Name',
		prependItems: _List_Nil,
		sort: $elm$core$List$sortBy(
			function ($) {
				return $.name;
			}),
		toId: function ($) {
			return $.id;
		}
	};
}();
var $author$project$Components$CustomerTypeahead$update = $author$project$Typeahead$update($author$project$Components$CustomerTypeahead$config);
var $author$project$Components$DebtorTypeahead$defaultConfig = {
	additionalInputAttributes: _List_Nil,
	additionalMenuAttributes: _List_Nil,
	idToString: A2($elm$core$Basics$composeR, $author$project$Domain$FactorBrokerId$toInt, $elm$core$String$fromInt),
	inputClassOverride: $elm$core$Maybe$Nothing,
	itemDisplay: A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.name;
		},
		$elm$html$Html$text),
	itemName: function ($) {
		return $.name;
	},
	liClassOverride: $elm$core$Maybe$Nothing,
	noItemDisplay: $elm$core$Maybe$Nothing,
	placeholder: 'Debtor Name',
	prependItems: _List_Nil,
	sort: $elm$core$List$sortBy(
		function ($) {
			return $.name;
		}),
	toId: function ($) {
		return $.id;
	}
};
var $author$project$Components$DebtorTypeahead$update = $author$project$Typeahead$update($author$project$Components$DebtorTypeahead$defaultConfig);
var $author$project$Components$SettingsPage$CarrierDropdown$update = F3(
	function (data, msg, model) {
		var _v0 = A4($author$project$Components$PaginatedDropdown$update, $author$project$Components$SettingsPage$CarrierDropdown$carrierToDropdownItem, data, msg, model.dropdown);
		var newDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: newDropdown}),
			cmd);
	});
var $author$project$Components$TmsCustomerDropdown$update = F4(
	function (accountSettings, data, msg, model) {
		var _v0 = A4(
			$author$project$Components$PaginatedDropdown$update,
			$author$project$Components$TmsCustomerDropdown$tmsCustomerToDropdownItem(accountSettings),
			data,
			msg,
			model.dropdown);
		var newDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: newDropdown}),
			cmd);
	});
var $author$project$Components$ActivityBrowser$FiltersView$update = F5(
	function (account, accountSettings, data, msg, model) {
		switch (msg.$) {
			case 'SelectActivityType':
				var selectedType = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedActivityType: selectedType}),
					$author$project$HubTran$Effect$none);
			case 'SelectUserId':
				var selectedUserId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedUserId: selectedUserId}),
					$author$project$HubTran$Effect$none);
			case 'SelectDate':
				var string = msg.a;
				var newDate = $elm$core$Result$toMaybe(
					$justinmimbs$date$Date$fromIsoString(string));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{startDate: newDate, startDateString: string}),
					$author$project$HubTran$Effect$none);
			case 'SelectEndDate':
				var string = msg.a;
				var newDate = $elm$core$Result$toMaybe(
					$justinmimbs$date$Date$fromIsoString(string));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{endDate: newDate, endDateString: string}),
					$author$project$HubTran$Effect$none);
			case 'CarrierTypeaheadMsg':
				var msg_ = msg.a;
				var carrierTypeaheadData = A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.carrierTypeaheadData;
					},
					data);
				var carrierTypeaheadConfig_ = $author$project$Components$ActivityBrowser$FiltersView$carrierTypeaheadConfig(account);
				var newCarrierTypeahead = A4($author$project$Components$CarrierTypeahead$update, carrierTypeaheadConfig_, carrierTypeaheadData, msg_, model.carrierTypeahead);
				var newCarrierId = $author$project$Components$ActivityBrowser$FiltersView$isSiloingDebtors(account) ? $author$project$Typeahead$selectedId(newCarrierTypeahead) : $elm$core$Maybe$Nothing;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{carrierTypeahead: newCarrierTypeahead, debtorTypeaheadCarrierId: newCarrierId}),
					$author$project$HubTran$Effect$none);
			case 'CarrierDropdownMsg':
				var msg_ = msg.a;
				var _v1 = A3(
					$author$project$Components$SettingsPage$CarrierDropdown$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.carrierDropdownData;
						},
						data),
					msg_,
					model.carrierDropdown);
				var carrierDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{carrierDropdown: carrierDropdown}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$ActivityBrowser$FiltersView$CarrierDropdownMsg, cmd)));
			case 'DebtorTypeaheadMsg':
				var msg_ = msg.a;
				var debtorTypeaheadData = A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.debtorTypeaheadData;
					},
					data);
				var newDebtorTypeahead = A3($author$project$Components$DebtorTypeahead$update, debtorTypeaheadData, msg_, model.debtorTypeahead);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtorTypeahead: newDebtorTypeahead}),
					$author$project$HubTran$Effect$none);
			case 'CustomerTypeaheadMsg':
				var msg_ = msg.a;
				var customerTypeaheadData = A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.customerTypeaheadData;
					},
					data);
				var newCustomerTypeahead = A3($author$project$Components$CustomerTypeahead$update, customerTypeaheadData, msg_, model.customerTypeahead);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{customerTypeahead: newCustomerTypeahead}),
					$author$project$HubTran$Effect$none);
			case 'CustomerDropdownMsg':
				var msg_ = msg.a;
				var _v2 = A4(
					$author$project$Components$TmsCustomerDropdown$update,
					accountSettings,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.customerDropdownData;
						},
						data),
					msg_,
					model.customerDropdown);
				var customerDropdown = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{customerDropdown: customerDropdown}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$ActivityBrowser$FiltersView$CustomerDropdownMsg, cmd)));
			default:
				var newId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{invoiceNumOrLoadIdString: newId}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$ActivityBrowser$ActivityItemListView$clearItemUiStates = function (model) {
	return _Utils_update(
		model,
		{activityItemViews: $elm$core$Dict$empty});
};
var $author$project$Components$ActivityPage$updateListView = F2(
	function (newPage, model) {
		return _Utils_update(
			model,
			{
				activityItemListView: $author$project$Components$ActivityBrowser$ActivityItemListView$clearItemUiStates(model.activityItemListView),
				page: newPage
			});
	});
var $author$project$Components$ActivityPage$updateLogic = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'ActivityItemListViewMsg':
				var childMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							activityItemListView: A2($author$project$Components$ActivityBrowser$ActivityItemListView$update, childMsg, model.activityItemListView)
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangePage':
				var page = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$ActivityPage$updateListView,
						page,
						A2($author$project$Components$ActivityPage$saveLastActivityItemListViewData, data, model)),
					$author$project$HubTran$Effect$none);
			case 'ApplyFilters':
				return _Utils_Tuple2(
					A2(
						$author$project$Components$ActivityPage$updateListView,
						0,
						_Utils_update(
							model,
							{appliedFilters: model.filters, maybeLastActivityItemListViewData: $elm$core$Maybe$Nothing})),
					$author$project$HubTran$Effect$none);
			case 'FiltersViewMsg':
				var childMsg = msg.a;
				var _v1 = $author$project$Forward$Remote$toMaybe(data);
				if (_v1.$ === 'Just') {
					var loadedData = _v1.a;
					var _v2 = A5(
						$author$project$Components$ActivityBrowser$FiltersView$update,
						loadedData.currentAccount,
						loadedData.accountSettings,
						A2(
							$author$project$Forward$Remote$andThen,
							function ($) {
								return $.filtersView;
							},
							data),
						childMsg,
						model.filters);
					var newFilters = _v2.a;
					var filtersEffect = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{filters: newFilters}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$ActivityPage$FiltersViewMsg, filtersEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			default:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$ActivityPage$updateListView,
						0,
						_Utils_update(
							model,
							{
								appliedFilters: $author$project$Components$ActivityBrowser$FiltersView$clear(model.appliedFilters),
								filters: $author$project$Components$ActivityBrowser$FiltersView$clear(model.filters),
								maybeLastActivityItemListViewData: $elm$core$Maybe$Nothing
							})),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$ActivityPage$update = F3(
	function (data, msg, model) {
		var _v0 = A3($author$project$Components$ActivityPage$updateLogic, data, msg, model);
		var newModel = _v0.a;
		var effect = _v0.b;
		var urlEffect = A2($author$project$Components$ActivityPage$maybeUpdateBrowserUrl, model, newModel);
		return _Utils_Tuple2(
			newModel,
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[effect, urlEffect])));
	});
var $author$project$Components$CarrierInvoiceAuditPage$DragDropMsg = function (a) {
	return {$: 'DragDropMsg', a: a};
};
var $author$project$Components$DragDrop$DragSideMsg = function (a) {
	return {$: 'DragSideMsg', a: a};
};
var $author$project$Components$DragDrop$DropSideMsg = function (a) {
	return {$: 'DropSideMsg', a: a};
};
var $author$project$Components$CarrierInvoiceAuditPage$LeaveWithFlash = function (a) {
	return {$: 'LeaveWithFlash', a: a};
};
var $author$project$Components$CarrierInvoiceAuditPage$OpenSendToCarrier = {$: 'OpenSendToCarrier'};
var $author$project$Components$DocumentBrowser$Full$highlightBoxId = function (suffix) {
	return 'document-browser-highlight-' + suffix;
};
var $author$project$Js$scrollToIdIfNeeded = _Platform_outgoingPort('scrollToIdIfNeeded', $elm$json$Json$Encode$string);
var $author$project$Components$DocumentsBrowser$scrollToHighlight = function (scrollContainerSuffix) {
	return $author$project$HubTran$Effect$cmd(
		$author$project$Js$scrollToIdIfNeeded(
			$author$project$Components$DocumentBrowser$Full$highlightBoxId(scrollContainerSuffix)));
};
var $author$project$Components$DocumentsBrowser$getDocumentLines = F2(
	function (data, model) {
		var _v0 = model.currentProcessingSelection;
		switch (_v0.$) {
			case 'GroupedDocumentBatchSelection':
				return data.groupedDocumentData.lines;
			case 'NoSelection':
				return $elm$core$Dict$empty;
			default:
				return data.documentData.lines;
		}
	});
var $author$project$Components$DocumentsBrowser$selectNextPageMatchingRule = F3(
	function (pagePredicate, remoteData, model) {
		if (remoteData.$ === 'Loaded') {
			var data = remoteData.a;
			var resolvedPage = A2($author$project$Components$DocumentsBrowser$selectedPage, data, model);
			var pageMatches = function (p) {
				return A2(pagePredicate, p.pageId, p.lines);
			};
			var linesDict = A2($author$project$Components$DocumentsBrowser$getDocumentLines, data, model);
			var documentData = A2($author$project$Components$DocumentsBrowser$getDocumentData, data, model);
			var allPages = $elm$core$List$concat(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (docIdx, pages) {
							return A2(
								$elm$core$List$indexedMap,
								F2(
									function (pageIdx, page) {
										return {
											docIndex: docIdx,
											lines: A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Dict$get,
													$author$project$Domain$DocumentPageId$toComparable(page.id),
													linesDict)),
											pageId: page.id,
											pageIndex: pageIdx
										};
									}),
								pages);
						}),
					documentData.documentPages));
			var currentPos = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm_community$list_extra$List$Extra$findIndex,
					function (p) {
						return _Utils_eq(p.docIndex, resolvedPage.documentIndex) && _Utils_eq(p.pageIndex, resolvedPage.pageIndex);
					},
					allPages));
			var pagesAfter = A2($elm$core$List$drop, currentPos + 1, allPages);
			var pagesBefore = A2($elm$core$List$take, currentPos, allPages);
			var maybeMatch = A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2($elm_community$list_extra$List$Extra$find, pageMatches, pagesBefore),
				A2($elm_community$list_extra$List$Extra$find, pageMatches, pagesAfter));
			if (maybeMatch.$ === 'Just') {
				var match = maybeMatch.a;
				return _Utils_update(
					model,
					{
						maybeSelectedDocumentPageId: $elm$core$Maybe$Nothing,
						selectedPage_INTERNAL: {documentIndex: match.docIndex, pageIndex: match.pageIndex}
					});
			} else {
				return model;
			}
		} else {
			return model;
		}
	});
var $author$project$Components$DocumentsBrowser$applyValueHighlight = F4(
	function (value, pagePredicate, remoteData, model) {
		return _Utils_Tuple2(
			A2(
				$author$project$Components$DocumentsBrowser$setHighlight,
				$elm$core$Maybe$Just(
					$author$project$Components$DocumentsBrowser$valueHighlight(value)),
				A3($author$project$Components$DocumentsBrowser$selectNextPageMatchingRule, pagePredicate, remoteData, model)),
			$author$project$Components$DocumentsBrowser$scrollToHighlight(model.scrollContainerSuffix));
	});
var $author$project$Components$DocumentsBrowser$setEnabledDocumentTypes = F2(
	function (enabledDocumentTypes, model) {
		return _Utils_update(
			model,
			{enabledDocumentTypes: enabledDocumentTypes});
	});
var $author$project$Components$CarrierInvoiceAuditPage$browserWithDocumentTypes = F2(
	function (data, model) {
		return A2(
			$author$project$Components$DocumentsBrowser$setEnabledDocumentTypes,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.enabledDocumentTypeNames;
					},
					$author$project$Forward$Remote$toMaybe(data.documentTypeSettings))),
			model.documentsBrowser);
	});
var $author$project$AuditPb$carrierInvoiceServiceSubmitRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId)
				])));
};
var $author$project$AuditPb$CarrierInvoiceServiceUpdateResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateError = function (a) {
	return {$: 'CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateSuccess = function (a) {
	return {$: 'CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateSuccess', a: a};
};
var $author$project$AuditPb$CarrierInvoiceServiceUpdateError = F2(
	function (message, reason) {
		return {message: message, reason: reason};
	});
var $author$project$AuditPb$CarrierInvoiceServiceUpdateErrorReasonReadOnly = {$: 'CarrierInvoiceServiceUpdateErrorReasonReadOnly'};
var $author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonDefault = $author$project$AuditPb$CarrierInvoiceServiceUpdateErrorReasonReadOnly;
var $author$project$AuditPb$CarrierInvoiceServiceUpdateErrorReasonInvalid = {$: 'CarrierInvoiceServiceUpdateErrorReasonInvalid'};
var $author$project$AuditPb$allCarrierInvoiceServiceUpdateErrorReason = _List_fromArray(
	[$author$project$AuditPb$CarrierInvoiceServiceUpdateErrorReasonReadOnly, $author$project$AuditPb$CarrierInvoiceServiceUpdateErrorReasonInvalid]);
var $author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonToString = function (v) {
	if (v.$ === 'CarrierInvoiceServiceUpdateErrorReasonReadOnly') {
		return 'read_only';
	} else {
		return 'invalid';
	}
};
var $author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonToString(v),
				v);
		},
		$author$project$AuditPb$allCarrierInvoiceServiceUpdateErrorReason));
var $author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonDict);
};
var $author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonDefault),
		$author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$carrierInvoiceServiceUpdateErrorDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'reason',
			$author$project$AuditPb$carrierInvoiceServiceUpdateErrorReasonDecoder,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'message',
				$elm$json$Json$Decode$string,
				$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceServiceUpdateError)));
	});
var $author$project$AuditPb$CarrierInvoiceServiceUpdateSuccess = {};
var $author$project$AuditPb$carrierInvoiceServiceUpdateSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceServiceUpdateSuccess);
	});
var $author$project$AuditPb$carrierInvoiceServiceUpdateResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$carrierInvoiceServiceUpdateSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$carrierInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('CarrierInvoiceServiceUpdateResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$carrierInvoiceServiceUpdateResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$CarrierInvoiceServiceUpdateResponse));
	});
var $author$project$PostRequestState$PostRequest = function (a) {
	return {$: 'PostRequest', a: a};
};
var $author$project$PostRequestState$fromEffect = $author$project$PostRequestState$PostRequest;
var $author$project$PostRequestState$PostResponse = function (a) {
	return {$: 'PostResponse', a: a};
};
var $author$project$PostRequestState$isInProgress = function (_v0) {
	var state = _v0.a;
	return state.inProgress > 0;
};
var $author$project$PostRequestState$makeEffect = F2(
	function (_v0, effect) {
		var state = _v0.a;
		return $author$project$PostRequestState$isInProgress(
			$author$project$PostRequestState$PostRequestState(state)) ? _Utils_Tuple2(
			$author$project$PostRequestState$PostRequestState(state),
			$author$project$HubTran$Effect$none) : _Utils_Tuple2(
			$author$project$PostRequestState$PostRequestState(
				{inProgress: state.inProgress + 1}),
			effect);
	});
var $author$project$PostRequestState$makeRequest = F2(
	function (p, _v0) {
		var request = _v0.a;
		return A2(
			$author$project$PostRequestState$makeEffect,
			p,
			A2($author$project$HubTran$Effect$map, $author$project$PostRequestState$PostResponse, request));
	});
var $author$project$AuditApi$toRequestState = F6(
	function (path, encoder, decoder, model, toMsg, value) {
		var _v0 = A2(
			$author$project$PostRequestState$makeRequest,
			model.requestState,
			$author$project$PostRequestState$fromEffect(
				$author$project$AuditApi$toInspectableEffect(
					{
						body: encoder(value),
						decoder: decoder,
						path: path
					})));
		var newState = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{requestState: newState}),
			A2($author$project$HubTran$Effect$map, toMsg, effect));
	});
var $author$project$AuditApi$carrierInvoiceServiceSaveAndApproveWithState = A3($author$project$AuditApi$toRequestState, '/carrier_invoice_service/save_and_approve', $author$project$AuditPb$carrierInvoiceServiceSubmitRequestEncoder, $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder);
var $author$project$AuditApi$carrierInvoiceServiceSubmitWithState = A3($author$project$AuditApi$toRequestState, '/carrier_invoice_service/submit', $author$project$AuditPb$carrierInvoiceServiceSubmitRequestEncoder, $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$CarrierInvoiceAuditChecks$clearIgnoreInFlight = function (model) {
	return _Utils_update(
		model,
		{ignoreInFlight: $elm$core$Maybe$Nothing});
};
var $author$project$Components$AuditSplitPane$collapse = function (_v0) {
	var model = _v0.a;
	return $author$project$Components$AuditSplitPane$Model(
		_Utils_update(
			model,
			{expanded: false}));
};
var $author$project$Helpers$HttpError$defaultHttpErrorHandler = function (err) {
	return $author$project$HubTran$Effect$batch(
		_List_fromArray(
			[
				$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert),
				function () {
				if (err.$ === 'NetworkError') {
					return $author$project$HubTran$Effect$none;
				} else {
					return $author$project$HubTran$Effect$none;
				}
			}()
			]));
};
var $author$project$Components$DocumentsBrowser$noHooks = {onHideFinished: $elm$core$Maybe$Nothing, onMarkIllegibleFinished: $elm$core$Maybe$Nothing, onSelectDocument: $elm$core$Maybe$Nothing, onSelectGroup: $elm$core$Maybe$Nothing, onSetLineSelection: $elm$core$Maybe$Nothing, onUpdateDocumentTypeFinished: $elm$core$Maybe$Nothing, onUpdatePodFinished: $elm$core$Maybe$Nothing, onViewEmailBrowserClick: $elm$core$Maybe$Nothing, onViewEmailToolbarClick: $elm$core$Maybe$Nothing};
var $author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect = function (carrierInvoiceId) {
	return $author$project$HubTran$Effect$batch(
		_List_fromArray(
			[
				$author$project$HubTran$Effect$refresh(
				A2($author$project$Forward$Lookup$startFrom, carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice)),
				$author$project$HubTran$Effect$refresh(
				A2($author$project$Forward$Lookup$startFrom, carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoiceAuditChecks)),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$stream_activityItemId),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$activityItem)
			]));
};
var $author$project$Components$CarrierInvoiceAuditPage$documentRefreshHooks = function (carrierInvoiceId) {
	var hooks = $author$project$Components$DocumentsBrowser$noHooks;
	return _Utils_update(
		hooks,
		{
			onHideFinished: $elm$core$Maybe$Just(
				function (_v0) {
					return $author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(carrierInvoiceId);
				}),
			onUpdateDocumentTypeFinished: $elm$core$Maybe$Just(
				F2(
					function (_v1, _v2) {
						return $author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(carrierInvoiceId);
					})),
			onUpdatePodFinished: $elm$core$Maybe$Just(
				function (_v3) {
					return $author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(carrierInvoiceId);
				})
		});
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$AmountToPay = {$: 'AmountToPay'};
var $author$project$Components$CarrierInvoiceAuditDrafts$Extracted = function (a) {
	return {$: 'Extracted', a: a};
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount = {$: 'InvoiceAmount'};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceDate = {$: 'InvoiceDate'};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceNumber = {$: 'InvoiceNumber'};
var $author$project$Components$CarrierInvoiceAuditDrafts$QuickReview = function (a) {
	return {$: 'QuickReview', a: a};
};
var $author$project$Components$AuditDrafts$Edited = function (a) {
	return {$: 'Edited', a: a};
};
var $author$project$Components$AuditDrafts$FromInvoice = {$: 'FromInvoice'};
var $author$project$Components$AuditDrafts$draftOf = F2(
	function (key, _v0) {
		var drafts = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$AuditDrafts$FromInvoice,
			A2($turboMaCk$any_dict$Dict$Any$get, key, drafts));
	});
var $turboMaCk$any_dict$Dict$Any$remove = F2(
	function (k, _v0) {
		var inner = _v0.a;
		return $turboMaCk$any_dict$Dict$Any$AnyDict(
			_Utils_update(
				inner,
				{
					dict: A2(
						$elm$core$Dict$remove,
						inner.toKey(k),
						inner.dict)
				}));
	});
var $author$project$Components$AuditDrafts$set = F3(
	function (key, draft, _v0) {
		var kindOf = _v0.a;
		var drafts = _v0.b;
		return A2(
			$author$project$Components$AuditDrafts$Drafts,
			kindOf,
			A3($turboMaCk$any_dict$Dict$Any$insert, key, draft, drafts));
	});
var $author$project$Components$AuditDrafts$dropRefused = F3(
	function (key, refused, unchanged) {
		var kindOf = unchanged.a;
		var drafts = unchanged.b;
		var _v0 = A2($author$project$Components$AuditDrafts$draftOf, key, unchanged);
		if (_v0.$ === 'Edited') {
			var sent = _v0.a.sent;
			var typed = _v0.a.typed;
			return (!_Utils_eq(
				sent,
				$elm$core$Maybe$Just(refused))) ? unchanged : (_Utils_eq(typed, refused) ? A2(
				$author$project$Components$AuditDrafts$Drafts,
				kindOf,
				A2($turboMaCk$any_dict$Dict$Any$remove, key, drafts)) : A3(
				$author$project$Components$AuditDrafts$set,
				key,
				$author$project$Components$AuditDrafts$Edited(
					{sent: $elm$core$Maybe$Nothing, typed: typed}),
				unchanged));
		} else {
			return unchanged;
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$dropRefusedValue = F2(
	function (refused, model) {
		var dropQuickReview = F2(
			function (field, value) {
				return A3(
					$author$project$Components$AuditDrafts$dropRefused,
					$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview(field),
					value,
					model.drafts);
			});
		return _Utils_update(
			model,
			{
				drafts: function () {
					var _v0 = refused.update;
					switch (_v0.$) {
						case 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceNumber':
							var invoiceNumber = _v0.a.invoiceNumber;
							return A2(dropQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceNumber, invoiceNumber);
						case 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceAmount':
							var invoiceAmount = _v0.a.invoiceAmount;
							return A2(dropQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount, invoiceAmount);
						case 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceDate':
							var invoiceDate = _v0.a.invoiceDate;
							return A2(dropQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceDate, invoiceDate);
						case 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateAmountToPay':
							var amountToPay = _v0.a.amountToPay;
							return A2(dropQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$AmountToPay, amountToPay);
						default:
							var fields = _v0.a.fields;
							return A3(
								$elm$core$List$foldl,
								function (field) {
									return A2(
										$author$project$Components$AuditDrafts$dropRefused,
										$author$project$Components$CarrierInvoiceAuditDrafts$Extracted(field.name),
										field.value);
								},
								model.drafts,
								fields);
					}
				}()
			});
	});
var $author$project$Components$CarrierInvoiceAuditPage$dropRefusedValues = F2(
	function (sentUpdates, auditChecks) {
		return A3($elm$core$List$foldl, $author$project$Components$CarrierInvoiceAuditChecks$dropRefusedValue, auditChecks, sentUpdates);
	});
var $author$project$Components$DocumentsBrowser$getCurrentProcessingSelection = function (model) {
	return model.currentProcessingSelection;
};
var $author$project$Components$CarrierInvoiceAuditPage$handleAuditWriteResponse = F2(
	function (model, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateSuccess') {
			return _Utils_Tuple2(
				model,
				$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId));
		} else {
			var message = _v0.a.message;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						auditChecks: $author$project$Components$CarrierInvoiceAuditChecks$clearIgnoreInFlight(model.auditChecks)
					}),
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[
							$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$alert(message)),
							$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId)
						])));
		}
	});
var $author$project$PostRequestState$handleResponseCustom = F2(
	function (_v0, _v1) {
		var state = _v0.a;
		var apiResult = _v1.a;
		return _Utils_Tuple2(
			$author$project$PostRequestState$PostRequestState(
				_Utils_update(
					state,
					{inProgress: state.inProgress - 1})),
			function () {
				if (apiResult.$ === 'Ok') {
					var a = apiResult.a;
					return $elm$core$Result$Ok(
						$elm$core$Result$Ok(a));
				} else {
					var error = apiResult.a;
					return $elm$core$Result$Err(error);
				}
			}());
	});
var $author$project$Components$CarrierInvoiceAuditPage$nonEmpty = $elm$core$Maybe$andThen(
	function (value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value);
	});
var $author$project$Components$CarrierInvoiceAuditPage$leavePage = function (model) {
	return $author$project$HubTran$Effect$load(
		A2(
			$elm$core$Maybe$withDefault,
			'/app/',
			$author$project$Components$CarrierInvoiceAuditPage$nonEmpty(model.onDone)));
};
var $author$project$Components$CarrierInvoiceAuditPage$handleSubmitResponse = F3(
	function (afterSubmit, model, submitResponse) {
		var _v0 = submitResponse.outcome;
		if (_v0.$ === 'CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateSuccess') {
			if (afterSubmit.$ === 'LeaveWithFlash') {
				var message = afterSubmit.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success(message)),
								$author$project$Components$CarrierInvoiceAuditPage$leavePage(model)
							])));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sendToCarrierOpen: true}),
					$author$project$HubTran$Effect$none);
			}
		} else {
			var message = _v0.a.message;
			return _Utils_Tuple2(
				model,
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[
							$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$alert(message)),
							$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId)
						])));
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$handleUpdateResponse = F3(
	function (sentUpdates, model, updateResponse) {
		var _v0 = updateResponse.outcome;
		if (_v0.$ === 'CarrierInvoiceServiceUpdateResponse_Outcome_CarrierInvoiceServiceUpdateSuccess') {
			return _Utils_Tuple2(
				model,
				$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId));
		} else {
			var reason = _v0.a.reason;
			var message = _v0.a.message;
			if (reason.$ === 'CarrierInvoiceServiceUpdateErrorReasonReadOnly') {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							auditChecks: A2($author$project$Components$CarrierInvoiceAuditPage$dropRefusedValues, sentUpdates, model.auditChecks)
						}),
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)),
								$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId)
							])));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							auditChecks: A2($author$project$Components$CarrierInvoiceAuditPage$dropRefusedValues, sentUpdates, model.auditChecks)
						}),
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert(message)));
			}
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$ProcessAuditWriteResponse = function (a) {
	return {$: 'ProcessAuditWriteResponse', a: a};
};
var $author$project$AuditPb$carrierInvoiceServiceIgnoreFailureRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'failureId', $elm$json$Json$Encode$string, v.failureId)
				])));
};
var $author$project$AuditApi$carrierInvoiceServiceIgnoreFailureWithState = A3($author$project$AuditApi$toRequestState, '/carrier_invoice_service/ignore_failure', $author$project$AuditPb$carrierInvoiceServiceIgnoreFailureRequestEncoder, $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$CarrierInvoiceAuditChecks$Ignoring = function (a) {
	return {$: 'Ignoring', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$setIgnoreInFlight = F2(
	function (failureId, model) {
		return _Utils_update(
			model,
			{
				ignoreInFlight: $elm$core$Maybe$Just(
					$author$project$Components$CarrierInvoiceAuditChecks$Ignoring(failureId))
			});
	});
var $author$project$Components$CarrierInvoiceAuditPage$ignoreFailure = F2(
	function (failureId, model) {
		return $author$project$PostRequestState$isInProgress(model.requestState) ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : A3(
			$author$project$AuditApi$carrierInvoiceServiceIgnoreFailureWithState,
			_Utils_update(
				model,
				{
					auditChecks: A2($author$project$Components$CarrierInvoiceAuditChecks$setIgnoreInFlight, failureId, model.auditChecks)
				}),
			$author$project$Components$CarrierInvoiceAuditPage$ProcessAuditWriteResponse,
			{carrierInvoiceId: model.carrierInvoiceId, failureId: failureId});
	});
var $elm$core$String$any = _String_any;
var $author$project$Domain$DocumentPageLine$digitAt = F2(
	function (index, chars) {
		return (index >= 0) && A2(
			$elm$core$String$any,
			$elm$core$Char$isDigit,
			A3($elm$core$String$slice, index, index + 1, chars));
	});
var $author$project$Domain$DocumentPageLine$containsWhole = F2(
	function (printed, chars) {
		return A2(
			$elm$core$List$any,
			function (index) {
				return !(A2($author$project$Domain$DocumentPageLine$digitAt, index - 1, chars) || A2(
					$author$project$Domain$DocumentPageLine$digitAt,
					index + $elm$core$String$length(printed),
					chars));
			},
			A2($elm$core$String$indexes, printed, chars));
	});
var $author$project$Domain$DocumentPageLine$normalize = function (value) {
	return A3(
		$elm$core$String$replace,
		'$',
		'',
		A3(
			$elm$core$String$replace,
			',',
			'',
			$elm$core$String$toLower(value)));
};
var $author$project$Domain$DocumentPageLine$printedDates = function (key) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(key);
	if (_v0.$ === 'Ok') {
		var date = _v0.a;
		return _Utils_eq(
			$justinmimbs$date$Date$toIsoString(date),
			key) ? A2(
			$elm$core$List$map,
			function (pattern) {
				return $author$project$Domain$DocumentPageLine$normalize(
					A2($justinmimbs$date$Date$format, pattern, date));
			},
			_List_fromArray(
				['MM/dd/yyyy', 'M/d/yyyy', 'MM/dd/yy', 'M/d/yy', 'MMM d, yyyy'])) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Domain$DocumentPageLine$matchOnChars = F2(
	function (maybeKey, line) {
		if (maybeKey.$ === 'Just') {
			var key = maybeKey.a;
			var chars = $author$project$Domain$DocumentPageLine$normalize(line.chars);
			return A2(
				$elm$core$String$contains,
				$author$project$Domain$DocumentPageLine$normalize(key),
				chars) || A2(
				$elm$core$List$any,
				function (printed) {
					return A2($author$project$Domain$DocumentPageLine$containsWhole, printed, chars);
				},
				$author$project$Domain$DocumentPageLine$printedDates(key));
		} else {
			return false;
		}
	});
var $author$project$AuditPb$carrierInvoiceServicePlaceExceptionEventRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'message', $elm$json$Json$Encode$string, v.message)
				])));
};
var $author$project$AuditApi$carrierInvoiceServicePlaceExceptionEventWithState = A3($author$project$AuditApi$toRequestState, '/carrier_invoice_service/place_exception_event', $author$project$AuditPb$carrierInvoiceServicePlaceExceptionEventRequestEncoder, $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$CarrierInvoiceAuditPage$placeExceptionEvent = F2(
	function (message, model) {
		return $author$project$PostRequestState$isInProgress(model.requestState) ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : A3(
			$author$project$AuditApi$carrierInvoiceServicePlaceExceptionEventWithState,
			model,
			$author$project$Components$CarrierInvoiceAuditPage$ProcessAuditWriteResponse,
			{carrierInvoiceId: model.carrierInvoiceId, message: message});
	});
var $author$project$Js$openDocumentViewerPopout = _Platform_outgoingPort('openDocumentViewerPopout', $elm$core$Basics$identity);
var $author$project$Components$AuditSplitPane$popOut = F2(
	function (selection, _v0) {
		var model = _v0.a;
		return _Utils_Tuple2(
			$author$project$Components$AuditSplitPane$Model(
				_Utils_update(
					model,
					{expanded: false, poppedOut: true})),
			$author$project$HubTran$Effect$cmd(
				$author$project$Js$openDocumentViewerPopout(
					$author$project$Broker$Shared$CurrentProcessingSelection$encodeToValue(selection))));
	});
var $author$project$Components$CarrierInvoiceAuditPage$processSuccessMessage = function (data) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.finishActions;
		},
		$author$project$Forward$Remote$toMaybe(data.carrierInvoice));
	if ((_v0.$ === 'Just') && (_v0.a.$ === 'CarrierInvoiceFinishActionsProcessAndApprove')) {
		var _v1 = _v0.a;
		return 'Invoice approved';
	} else {
		return 'Invoice processed';
	}
};
var $author$project$Components$CarrierInvoiceAuditPage$quickReviewValues = function (data) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (carrierInvoice, tmsLoadDetails) {
				return {
					amountToPay: A2($elm$core$Maybe$withDefault, '', carrierInvoice.amountToPay),
					invoiceAmount: A2($elm$core$Maybe$withDefault, '', carrierInvoice.invoiceAmount),
					invoiceDate: A2($elm$core$Maybe$withDefault, '', carrierInvoice.invoiceDate),
					invoiceNumber: A2($elm$core$Maybe$withDefault, '', carrierInvoice.sourceInvoiceNumber),
					loadId: tmsLoadDetails.load.loadId
				};
			}),
		$author$project$Forward$Remote$toMaybe(data.carrierInvoice),
		$author$project$Forward$Remote$toMaybe(data.tmsLoadDetails));
};
var $author$project$AuditPb$carrierInvoiceServiceResolveExceptionEventRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId),
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'exceptionEventId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$ExceptionEventId$toInt),
					v.exceptionEventId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'resolutionMessage', $elm$json$Json$Encode$string, v.resolutionMessage)
				])));
};
var $author$project$AuditApi$carrierInvoiceServiceResolveExceptionEventWithState = A3($author$project$AuditApi$toRequestState, '/carrier_invoice_service/resolve_exception_event', $author$project$AuditPb$carrierInvoiceServiceResolveExceptionEventRequestEncoder, $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$CarrierInvoiceAuditPage$resolveExceptionEvent = F3(
	function (exceptionEventId, resolutionMessage, model) {
		return $author$project$PostRequestState$isInProgress(model.requestState) ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : A3(
			$author$project$AuditApi$carrierInvoiceServiceResolveExceptionEventWithState,
			model,
			$author$project$Components$CarrierInvoiceAuditPage$ProcessAuditWriteResponse,
			{carrierInvoiceId: model.carrierInvoiceId, exceptionEventId: exceptionEventId, resolutionMessage: resolutionMessage});
	});
var $author$project$Components$CarrierInvoiceAuditChecks$checkElementId = function (checkId) {
	return 'ci-audit-check-' + checkId;
};
var $author$project$Components$CarrierInvoiceAuditChecks$quickReviewElementId = 'ci-audit-quick-review';
var $author$project$Components$AuditUnsavedEdits$CompletedChecksTab = {$: 'CompletedChecksTab'};
var $author$project$Components$CarrierInvoiceAuditChecks$Expanded = function (a) {
	return {$: 'Expanded', a: a};
};
var $author$project$Components$AuditUnsavedEdits$SummaryTab = {$: 'SummaryTab'};
var $author$project$Components$CarrierInvoiceAuditChecks$withResult = function (result) {
	return $elm$core$List$filter(
		function (check) {
			return _Utils_eq(check.result, result);
		});
};
var $author$project$Components$CarrierInvoiceAuditChecks$completed = function (checks) {
	return _Utils_ap(
		A2($author$project$Components$CarrierInvoiceAuditChecks$withResult, $author$project$AuditPb$CarrierInvoiceAuditCheckResultPassed, checks),
		_Utils_ap(
			A2($author$project$Components$CarrierInvoiceAuditChecks$withResult, $author$project$AuditPb$CarrierInvoiceAuditCheckResultIgnored, checks),
			A2($author$project$Components$CarrierInvoiceAuditChecks$withResult, $author$project$AuditPb$CarrierInvoiceAuditCheckResultResolved, checks)));
};
var $elm$core$Set$singleton = function (key) {
	return $elm$core$Set$Set_elm_builtin(
		A2($elm$core$Dict$singleton, key, _Utils_Tuple0));
};
var $author$project$Components$CarrierInvoiceAuditChecks$expandedKeys = F2(
	function (expansion, topCheckKey) {
		if (expansion.$ === 'TopCheckOnly') {
			return $elm$core$Set$singleton(topCheckKey);
		} else {
			var keys = expansion.a;
			return keys;
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$failing = $author$project$Components$CarrierInvoiceAuditChecks$withResult($author$project$AuditPb$CarrierInvoiceAuditCheckResultFailed);
var $author$project$Components$CarrierInvoiceAuditChecks$checkTypeToString = function (checkType) {
	var _v0 = checkType.check;
	switch (_v0.$) {
		case 'CarrierInvoiceAuditCheckType_Check_OtherCheck':
			return 'other';
		case 'CarrierInvoiceAuditCheckType_Check_DocumentsRequiredCheck':
			return 'documents_required';
		case 'CarrierInvoiceAuditCheckType_Check_OsdCheck':
			return 'osd';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierRateCheck':
			return 'carrier_rate';
		case 'CarrierInvoiceAuditCheckType_Check_DocumentReviewCheck':
			return 'document_review';
		case 'CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck':
			return 'extracted_fields';
		case 'CarrierInvoiceAuditCheckType_Check_LoadMatchCheck':
			return 'load_match';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceAmountCheck':
			return 'invoice_amount';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierMatchCheck':
			return 'carrier_match';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceDuplicateInvoiceCheck':
			return 'duplicate_invoice';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceDateCheck':
			return 'invoice_date';
		case 'CarrierInvoiceAuditCheckType_Check_CustomExceptionMessageCheck':
			return 'custom_exception_message';
		case 'CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck':
			return 'label_rule_failure';
		case 'CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck':
			return 'reference_requirements';
		default:
			return 'customer_instructions';
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$identifier = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		var _v1 = ruleCheck.checkType.check;
		switch (_v1.$) {
			case 'CarrierInvoiceAuditCheckType_Check_DocumentsRequiredCheck':
				var documentsRequired = _v1.a;
				return $author$project$Components$CarrierInvoiceAuditChecks$checkTypeToString(ruleCheck.checkType) + (':' + documentsRequired.title);
			case 'CarrierInvoiceAuditCheckType_Check_CustomExceptionMessageCheck':
				var message = _v1.a.message;
				return $author$project$Components$CarrierInvoiceAuditChecks$checkTypeToString(ruleCheck.checkType) + (':' + message);
			case 'CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck':
				var labelRuleFailure = _v1.a;
				return $author$project$Components$CarrierInvoiceAuditChecks$checkTypeToString(ruleCheck.checkType) + (':' + labelRuleFailure.title);
			case 'CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck':
				var reference = _v1.a.reference;
				return $author$project$Components$CarrierInvoiceAuditChecks$checkTypeToString(ruleCheck.checkType) + (':' + reference);
			default:
				return $author$project$Components$CarrierInvoiceAuditChecks$checkTypeToString(ruleCheck.checkType);
		}
	} else {
		var event = _v0.a;
		return 'exception-event-' + $elm$core$String$fromInt(
			$author$project$Domain$ExceptionEventId$toInt(event.id));
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$revealCheck = F3(
	function (checks, checkId, model) {
		var isIn = $elm$core$List$any(
			function (check) {
				return _Utils_eq(
					$author$project$Components$CarrierInvoiceAuditChecks$identifier(check),
					checkId);
			});
		var failingChecks = $author$project$Components$CarrierInvoiceAuditChecks$failing(checks);
		var topCheckKey = A2(
			$elm$core$Maybe$withDefault,
			checkId,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$CarrierInvoiceAuditChecks$identifier,
				$elm$core$List$head(failingChecks)));
		return isIn(failingChecks) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						expansion: $author$project$Components$CarrierInvoiceAuditChecks$Expanded(
							A2(
								$elm$core$Set$insert,
								checkId,
								A2($author$project$Components$CarrierInvoiceAuditChecks$expandedKeys, model.expansion, topCheckKey)))
					}),
				$author$project$Components$AuditUnsavedEdits$SummaryTab)) : (isIn(
			$author$project$Components$CarrierInvoiceAuditChecks$completed(checks)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						expandedCompletedChecks: A2($elm$core$Set$insert, checkId, model.expandedCompletedChecks)
					}),
				$author$project$Components$AuditUnsavedEdits$CompletedChecksTab)) : $elm$core$Maybe$Nothing);
	});
var $author$project$Components$CarrierInvoiceAuditChecks$revealQuickReview = function (model) {
	return _Utils_update(
		model,
		{quickReviewCollapsed: false});
};
var $author$project$Js$scrollToId = _Platform_outgoingPort('scrollToId', $elm$json$Json$Encode$string);
var $author$project$Components$CarrierInvoiceAuditPage$CompletedChecks = {$: 'CompletedChecks'};
var $author$project$Components$CarrierInvoiceAuditPage$tabOf = function (checkTab) {
	if (checkTab.$ === 'SummaryTab') {
		return $author$project$Components$CarrierInvoiceAuditPage$Summary;
	} else {
		return $author$project$Components$CarrierInvoiceAuditPage$CompletedChecks;
	}
};
var $author$project$Domain$Amount$cleaned = function (typed) {
	return A2(
		$elm$core$String$filter,
		function (_char) {
			return !A2(
				$elm$core$List$member,
				_char,
				_List_fromArray(
					[
						_Utils_chr('$'),
						_Utils_chr(','),
						_Utils_chr(' ')
					]));
		},
		$elm$core$String$trim(typed));
};
var $author$project$Components$AuditUnsavedEdits$showAmount = function (value) {
	return $elm$core$String$isEmpty(
		$author$project$Domain$Amount$cleaned(value)) ? 'none' : ('$' + $author$project$Domain$Amount$cleaned(value));
};
var $author$project$Components$AuditUnsavedEdits$showText = function (value) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(value)) ? 'none' : $elm$core$String$trim(value);
};
var $author$project$Components$AuditUnsavedEdits$showDate = function (value) {
	return A2(
		$elm$core$Result$withDefault,
		$author$project$Components$AuditUnsavedEdits$showText(value),
		A2(
			$elm$core$Result$map,
			$justinmimbs$date$Date$format('MM/dd/yyyy'),
			$justinmimbs$date$Date$fromIsoString(value)));
};
var $author$project$Components$CarrierInvoiceAuditChecks$storedValue = F2(
	function (field, values) {
		switch (field.$) {
			case 'InvoiceNumber':
				return values.invoiceNumber;
			case 'InvoiceAmount':
				return values.invoiceAmount;
			case 'InvoiceDate':
				return values.invoiceDate;
			default:
				return values.amountToPay;
		}
	});
var $author$project$Components$AuditDrafts$cleaned = F2(
	function (kind, typed) {
		if (kind.$ === 'Amount') {
			return $author$project$Domain$Amount$cleaned(typed);
		} else {
			return typed;
		}
	});
var $author$project$Components$AuditDrafts$present = function (value) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(value)) ? '' : value;
};
var $author$project$Components$AuditDrafts$asStored = F2(
	function (kind, value) {
		switch (kind.$) {
			case 'Text':
				return value;
			case 'PresentText':
				return $author$project$Components$AuditDrafts$present(value);
			case 'StrippedText':
				return $elm$core$String$trim(value);
			default:
				return $author$project$Components$AuditDrafts$present(value);
		}
	});
var $author$project$Components$AuditDrafts$sameAmount = F2(
	function (typed, stored) {
		var _v0 = _Utils_Tuple2(
			$elm$core$String$toFloat(
				$elm$core$String$trim(typed)),
			$elm$core$String$toFloat(
				$elm$core$String$trim(stored)));
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var typedAmount = _v0.a.a;
			var storedAmount = _v0.b.a;
			return _Utils_eq(typedAmount, storedAmount);
		} else {
			return _Utils_eq(typed, stored);
		}
	});
var $author$project$Components$AuditDrafts$sameValue = F3(
	function (kind, typed, stored) {
		if (kind.$ === 'Amount') {
			return A2($author$project$Components$AuditDrafts$sameAmount, typed, stored);
		} else {
			return _Utils_eq(typed, stored);
		}
	});
var $author$project$Components$AuditDrafts$sentOf = F2(
	function (key, drafts) {
		var _v0 = A2($author$project$Components$AuditDrafts$draftOf, key, drafts);
		if (_v0.$ === 'Edited') {
			var sent = _v0.a.sent;
			return sent;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$AuditDrafts$worthSending = F3(
	function (key, _v0, drafts) {
		var stored = _v0.stored;
		var typed = _v0.typed;
		var kindOf = drafts.a;
		var kind = kindOf(key);
		var settled = A2($author$project$Components$AuditDrafts$asStored, kind, typed);
		var alreadySent = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$AuditDrafts$asStored(kind),
					A2($author$project$Components$AuditDrafts$sameValue, kind, settled)),
				A2($author$project$Components$AuditDrafts$sentOf, key, drafts)));
		return (A3($author$project$Components$AuditDrafts$sameValue, kind, settled, stored) || alreadySent) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(settled);
	});
var $author$project$Components$AuditDrafts$unsaved = F3(
	function (key, stored, drafts) {
		var kindOf = drafts.a;
		var _v0 = A2($author$project$Components$AuditDrafts$draftOf, key, drafts);
		if (_v0.$ === 'Edited') {
			var typed = _v0.a.typed;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(typed),
				A3(
					$author$project$Components$AuditDrafts$worthSending,
					key,
					{
						stored: stored,
						typed: A2(
							$author$project$Components$AuditDrafts$cleaned,
							kindOf(key),
							typed)
					},
					drafts));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$unsavedEdit = F4(
	function (checkId, label, saved, edited) {
		return {checkId: checkId, edited: edited, label: label, saved: saved};
	});
var $author$project$Components$CarrierInvoiceAuditChecks$extractedFields = function (checkType) {
	var _v0 = checkType.check;
	if (_v0.$ === 'CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck') {
		var extractedFieldsCheck = _v0.a;
		return extractedFieldsCheck.fields;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$checkExtractedFields = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		return $author$project$Components$CarrierInvoiceAuditChecks$extractedFields(ruleCheck.checkType);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$editable = function (checks) {
	return _Utils_ap(
		$author$project$Components$CarrierInvoiceAuditChecks$failing(checks),
		A2($author$project$Components$CarrierInvoiceAuditChecks$withResult, $author$project$AuditPb$CarrierInvoiceAuditCheckResultPassed, checks));
};
var $author$project$Components$CarrierInvoiceAuditChecks$unsavedExtracted = F2(
	function (model, field) {
		return A3(
			$author$project$Components$AuditDrafts$unsaved,
			$author$project$Components$CarrierInvoiceAuditDrafts$Extracted(field.name),
			field.value,
			model.drafts);
	});
var $author$project$Components$CarrierInvoiceAuditChecks$unsavedExtractedEdits = F2(
	function (checks, model) {
		var extractedEdit = F2(
			function (check, field) {
				return A2(
					$elm$core$Maybe$map,
					function (edited) {
						return A4(
							$author$project$Components$CarrierInvoiceAuditChecks$unsavedEdit,
							$author$project$Components$CarrierInvoiceAuditChecks$identifier(check),
							field.label,
							$author$project$Components$AuditUnsavedEdits$showText(field.value),
							$author$project$Components$AuditUnsavedEdits$showText(edited));
					},
					A2($author$project$Components$CarrierInvoiceAuditChecks$unsavedExtracted, model, field));
			});
		return A2(
			$elm$core$List$concatMap,
			function (check) {
				return A2(
					$elm$core$List$filterMap,
					extractedEdit(check),
					$author$project$Components$CarrierInvoiceAuditChecks$checkExtractedFields(check));
			},
			$author$project$Components$CarrierInvoiceAuditChecks$editable(checks));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$unsavedEdits = F2(
	function (config, model) {
		var quickReviewEdit = F4(
			function (checkId, label, display, field) {
				return A2(
					$elm$core$Maybe$andThen,
					function (values) {
						var saved = A2($author$project$Components$CarrierInvoiceAuditChecks$storedValue, field, values);
						return A2(
							$elm$core$Maybe$map,
							function (edited) {
								return A4(
									$author$project$Components$CarrierInvoiceAuditChecks$unsavedEdit,
									checkId,
									label,
									display(saved),
									display(edited));
							},
							A3(
								$author$project$Components$AuditDrafts$unsaved,
								$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview(field),
								saved,
								model.drafts));
					},
					config.quickReview);
			});
		var amountCardIsFailing = A2(
			$elm$core$List$any,
			function (check) {
				return $author$project$Components$CarrierInvoiceAuditChecks$identifier(check) === 'invoice_amount';
			},
			$author$project$Components$CarrierInvoiceAuditChecks$failing(config.auditChecks));
		var amountCheckId = amountCardIsFailing ? 'invoice_amount' : 'quick_review';
		return _Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A4(quickReviewEdit, 'quick_review', 'Invoice Number', $author$project$Components$AuditUnsavedEdits$showText, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceNumber),
						A4(quickReviewEdit, amountCheckId, 'Invoice Amount', $author$project$Components$AuditUnsavedEdits$showAmount, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount),
						A4(quickReviewEdit, 'quick_review', 'Invoice Date', $author$project$Components$AuditUnsavedEdits$showDate, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceDate),
						amountCardIsFailing ? A4(quickReviewEdit, 'invoice_amount', 'Amount to Pay', $author$project$Components$AuditUnsavedEdits$showAmount, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$AmountToPay) : $elm$core$Maybe$Nothing
					])),
			A2($author$project$Components$CarrierInvoiceAuditChecks$unsavedExtractedEdits, config.auditChecks, model));
	});
var $author$project$Components$CarrierInvoiceAuditPage$unsavedEdits = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (checks) {
					return A2(
						$author$project$Components$CarrierInvoiceAuditChecks$unsavedEdits,
						{
							auditChecks: checks,
							quickReview: $author$project$Components$CarrierInvoiceAuditPage$quickReviewValues(data)
						},
						model.auditChecks);
				},
				$author$project$Forward$Remote$toMaybe(data.auditChecks)));
	});
var $author$project$Components$CarrierInvoiceAuditPage$reviewUnsavedEdit = F2(
	function (data, model) {
		var revealed = A2(
			$elm$core$Maybe$andThen,
			function (_v2) {
				var checks = _v2.a;
				var edit = _v2.b;
				return A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var auditChecks = _v3.a;
						var checkTab = _v3.b;
						return _Utils_Tuple3(
							auditChecks,
							checkTab,
							$author$project$Components$CarrierInvoiceAuditChecks$checkElementId(edit.checkId));
					},
					A3($author$project$Components$CarrierInvoiceAuditChecks$revealCheck, checks, edit.checkId, model.auditChecks));
			},
			A3(
				$elm$core$Maybe$map2,
				$elm$core$Tuple$pair,
				$author$project$Forward$Remote$toMaybe(data.auditChecks),
				$elm$core$List$head(
					A2($author$project$Components$CarrierInvoiceAuditPage$unsavedEdits, data, model))));
		if (revealed.$ === 'Just') {
			var _v1 = revealed.a;
			var auditChecks = _v1.a;
			var checkTab = _v1.b;
			var elementId = _v1.c;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						auditChecks: auditChecks,
						selectedTab: $author$project$Components$CarrierInvoiceAuditPage$tabOf(checkTab)
					}),
				$author$project$HubTran$Effect$cmd(
					$author$project$Js$scrollToId(elementId)));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						auditChecks: $author$project$Components$CarrierInvoiceAuditChecks$revealQuickReview(model.auditChecks),
						selectedTab: $author$project$Components$CarrierInvoiceAuditPage$Summary
					}),
				$author$project$HubTran$Effect$cmd(
					$author$project$Js$scrollToId($author$project$Components$CarrierInvoiceAuditChecks$quickReviewElementId)));
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$ProcessUpdateResponse = F2(
	function (a, b) {
		return {$: 'ProcessUpdateResponse', a: a, b: b};
	});
var $author$project$AuditPb$carrierInvoiceFieldUpdateAmountToPayEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'amountToPay', $elm$json$Json$Encode$string, v.amountToPay)
				])));
};
var $author$project$AuditPb$carrierInvoiceExtractedFieldUpdateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'name', $elm$json$Json$Encode$string, v.name),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'value', $elm$json$Json$Encode$string, v.value)
				])));
};
var $author$project$AuditPb$carrierInvoiceFieldUpdateExtractedFieldsEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$repeatedFieldEncoder, 'fields', $author$project$AuditPb$carrierInvoiceExtractedFieldUpdateEncoder, v.fields)
				])));
};
var $author$project$AuditPb$carrierInvoiceFieldUpdateInvoiceAmountEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'invoiceAmount', $elm$json$Json$Encode$string, v.invoiceAmount)
				])));
};
var $author$project$AuditPb$carrierInvoiceFieldUpdateInvoiceDateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'invoiceDate', $elm$json$Json$Encode$string, v.invoiceDate)
				])));
};
var $author$project$AuditPb$carrierInvoiceFieldUpdateInvoiceNumberEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'invoiceNumber', $elm$json$Json$Encode$string, v.invoiceNumber)
				])));
};
var $author$project$AuditPb$carrierInvoiceFieldUpdate_UpdateEncoder = function (v) {
	switch (v.$) {
		case 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceNumber':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'invoice_number_update',
					$author$project$AuditPb$carrierInvoiceFieldUpdateInvoiceNumberEncoder(x)));
		case 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceAmount':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'invoice_amount_update',
					$author$project$AuditPb$carrierInvoiceFieldUpdateInvoiceAmountEncoder(x)));
		case 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceDate':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'invoice_date_update',
					$author$project$AuditPb$carrierInvoiceFieldUpdateInvoiceDateEncoder(x)));
		case 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateAmountToPay':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'amount_to_pay_update',
					$author$project$AuditPb$carrierInvoiceFieldUpdateAmountToPayEncoder(x)));
		default:
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'extracted_fields_update',
					$author$project$AuditPb$carrierInvoiceFieldUpdateExtractedFieldsEncoder(x)));
	}
};
var $author$project$AuditPb$carrierInvoiceFieldUpdateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$AuditPb$carrierInvoiceFieldUpdate_UpdateEncoder(v.update)
				])));
};
var $author$project$AuditPb$carrierInvoiceUpdateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$repeatedFieldEncoder, 'updates', $author$project$AuditPb$carrierInvoiceFieldUpdateEncoder, v.updates)
				])));
};
var $author$project$AuditPb$carrierInvoiceServiceUpdateRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'carrierInvoiceUpdate', $author$project$AuditPb$carrierInvoiceUpdateEncoder, v.carrierInvoiceUpdate)
				])));
};
var $author$project$AuditApi$carrierInvoiceServiceUpdateWithState = A3($author$project$AuditApi$toRequestState, '/carrier_invoice_service/update', $author$project$AuditPb$carrierInvoiceServiceUpdateRequestEncoder, $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$CarrierInvoiceAuditPage$saveFieldUpdates = F2(
	function (fieldUpdates, model) {
		return $author$project$PostRequestState$isInProgress(model.requestState) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{queuedUpdates: fieldUpdates}),
			$author$project$HubTran$Effect$none) : A3(
			$author$project$AuditApi$carrierInvoiceServiceUpdateWithState,
			_Utils_update(
				model,
				{queuedUpdates: _List_Nil}),
			$author$project$Components$CarrierInvoiceAuditPage$ProcessUpdateResponse(fieldUpdates),
			{
				carrierInvoiceId: model.carrierInvoiceId,
				carrierInvoiceUpdate: {updates: fieldUpdates}
			});
	});
var $author$project$AuditPb$carrierInvoiceServiceSaveWithErrorsRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'replyEmailId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$EmailMessageId$toInt),
					v.replyEmailId)
				])));
};
var $author$project$AuditApi$carrierInvoiceServiceSaveWithErrorsWithState = A3($author$project$AuditApi$toRequestState, '/carrier_invoice_service/save_with_errors', $author$project$AuditPb$carrierInvoiceServiceSaveWithErrorsRequestEncoder, $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$CarrierInvoiceAuditPage$ProcessSubmitResponse = F2(
	function (a, b) {
		return {$: 'ProcessSubmitResponse', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditPage$submit = F4(
	function (send, request, afterSubmit, model) {
		return $author$project$PostRequestState$isInProgress(model.requestState) ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : A3(
			send,
			model,
			$author$project$Components$CarrierInvoiceAuditPage$ProcessSubmitResponse(afterSubmit),
			request);
	});
var $author$project$Components$CarrierInvoiceAuditPage$saveWithErrors = F2(
	function (afterSubmit, model) {
		return A4(
			$author$project$Components$CarrierInvoiceAuditPage$submit,
			$author$project$AuditApi$carrierInvoiceServiceSaveWithErrorsWithState,
			{carrierInvoiceId: model.carrierInvoiceId, replyEmailId: model.replyEmailId},
			afterSubmit,
			model);
	});
var $author$project$Components$CarrierInvoiceAuditPage$sendQueuedUpdates = function (_v0) {
	var model = _v0.a;
	var effect = _v0.b;
	if ($elm$core$List$isEmpty(model.queuedUpdates)) {
		return _Utils_Tuple2(model, effect);
	} else {
		var _v1 = A2($author$project$Components$CarrierInvoiceAuditPage$saveFieldUpdates, model.queuedUpdates, model);
		var sentModel = _v1.a;
		var sendEffect = _v1.b;
		return _Utils_Tuple2(
			sentModel,
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[effect, sendEffect])));
	}
};
var $author$project$Components$AuditDrafts$stage = F3(
	function (key, value, drafts) {
		return A3(
			$author$project$Components$AuditDrafts$set,
			key,
			$author$project$Components$AuditDrafts$Edited(
				{
					sent: A2($author$project$Components$AuditDrafts$sentOf, key, drafts),
					typed: value
				}),
			drafts);
	});
var $author$project$Components$CarrierInvoiceAuditChecks$stageDraft = F3(
	function (key, value, model) {
		return _Utils_update(
			model,
			{
				drafts: A3($author$project$Components$AuditDrafts$stage, key, value, model.drafts)
			});
	});
var $author$project$Components$AuditSplitPane$toggleExpanded = function (_v0) {
	var model = _v0.a;
	return $author$project$Components$AuditSplitPane$Model(
		_Utils_update(
			model,
			{expanded: !model.expanded}));
};
var $author$project$AuditPb$carrierInvoiceServiceUnignoreFailureRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'failureId', $elm$json$Json$Encode$string, v.failureId)
				])));
};
var $author$project$AuditApi$carrierInvoiceServiceUnignoreFailureWithState = A3($author$project$AuditApi$toRequestState, '/carrier_invoice_service/unignore_failure', $author$project$AuditPb$carrierInvoiceServiceUnignoreFailureRequestEncoder, $author$project$AuditPb$carrierInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$CarrierInvoiceAuditChecks$Unignoring = function (a) {
	return {$: 'Unignoring', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$setUnignoreInFlight = F2(
	function (failureId, model) {
		return _Utils_update(
			model,
			{
				ignoreInFlight: $elm$core$Maybe$Just(
					$author$project$Components$CarrierInvoiceAuditChecks$Unignoring(failureId))
			});
	});
var $author$project$Components$CarrierInvoiceAuditPage$unignoreFailure = F2(
	function (failureId, model) {
		return $author$project$PostRequestState$isInProgress(model.requestState) ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : A3(
			$author$project$AuditApi$carrierInvoiceServiceUnignoreFailureWithState,
			_Utils_update(
				model,
				{
					auditChecks: A2($author$project$Components$CarrierInvoiceAuditChecks$setUnignoreInFlight, failureId, model.auditChecks)
				}),
			$author$project$Components$CarrierInvoiceAuditPage$ProcessAuditWriteResponse,
			{carrierInvoiceId: model.carrierInvoiceId, failureId: failureId});
	});
var $author$project$Components$AuditSplitPane$Dragged = function (a) {
	return {$: 'Dragged', a: a};
};
var $author$project$Components$AuditSplitPane$Even = {$: 'Even'};
var $author$project$Components$AuditSplitPane$Measured = function (a) {
	return {$: 'Measured', a: a};
};
var $author$project$Components$AuditSplitPane$NoOp = {$: 'NoOp'};
var $author$project$Api$Users$Encode$auditDocumentsColumnWidth = function (widthPx) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'audit_documents_column_width',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, widthPx)))
						])))
			]));
};
var $author$project$Api$Users$filtersBaseUrl = '/api/user';
var $author$project$Api$Users$clearAuditDocumentsColumnWidth = A2(
	$author$project$Helpers$Api$putWithNoResponseBody,
	$author$project$Api$Users$filtersBaseUrl,
	$author$project$Api$Users$Encode$auditDocumentsColumnWidth($elm$core$Maybe$Nothing));
var $author$project$Components$AuditSplitPane$containerId = 'invoice-audit-split-pane';
var $author$project$Js$documentViewerPoppedIn = _Platform_outgoingPort(
	'documentViewerPoppedIn',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Api$Users$setAuditDocumentsColumnWidth = function (widthPx) {
	return A2(
		$author$project$Helpers$Api$putWithNoResponseBody,
		$author$project$Api$Users$filtersBaseUrl,
		$author$project$Api$Users$Encode$auditDocumentsColumnWidth(
			$elm$core$Maybe$Just(widthPx)));
};
var $author$project$Components$AuditSplitPane$handleWidthPx = 8;
var $author$project$Components$AuditSplitPane$minDocumentsWidthPx = 320;
var $author$project$Components$AuditSplitPane$minWorkingAreaWidthPx = 400;
var $author$project$Components$AuditSplitPane$widthFor = F2(
	function (row, clientX) {
		return A3(
			$elm$core$Basics$clamp,
			$author$project$Components$AuditSplitPane$minDocumentsWidthPx,
			($elm$core$Basics$round(row.width) - $author$project$Components$AuditSplitPane$minWorkingAreaWidthPx) - $author$project$Components$AuditSplitPane$handleWidthPx,
			$elm$core$Basics$round((row.x + row.width) - clientX));
	});
var $author$project$Components$AuditSplitPane$update = F2(
	function (msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'HandlePressed':
				return _Utils_Tuple2(
					$author$project$Components$AuditSplitPane$Model(model),
					$author$project$HubTran$Effect$cmd(
						A2(
							$elm$core$Task$attempt,
							function (result) {
								if (result.$ === 'Ok') {
									var element = result.a.element;
									return $author$project$Components$AuditSplitPane$Measured(
										{width: element.width, x: element.x});
								} else {
									return $author$project$Components$AuditSplitPane$NoOp;
								}
							},
							$elm$browser$Browser$Dom$getElement($author$project$Components$AuditSplitPane$containerId))));
			case 'Measured':
				var row = msg.a;
				return _Utils_Tuple2(
					$author$project$Components$AuditSplitPane$Model(
						_Utils_update(
							model,
							{
								gesture: $elm$core$Maybe$Just(
									{movedTo: $elm$core$Maybe$Nothing, row: row})
							})),
					$author$project$HubTran$Effect$none);
			case 'NoOp':
				return _Utils_Tuple2(
					$author$project$Components$AuditSplitPane$Model(model),
					$author$project$HubTran$Effect$none);
			case 'Moved':
				var clientX = msg.a;
				var _v3 = model.gesture;
				if (_v3.$ === 'Just') {
					var gesture = _v3.a;
					var widthPx = A2($author$project$Components$AuditSplitPane$widthFor, gesture.row, clientX);
					return _Utils_Tuple2(
						$author$project$Components$AuditSplitPane$Model(
							_Utils_update(
								model,
								{
									gesture: $elm$core$Maybe$Just(
										_Utils_update(
											gesture,
											{
												movedTo: $elm$core$Maybe$Just(widthPx)
											})),
									width: $author$project$Components$AuditSplitPane$Dragged(widthPx)
								})),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(
						$author$project$Components$AuditSplitPane$Model(model),
						$author$project$HubTran$Effect$none);
				}
			case 'Released':
				return _Utils_Tuple2(
					$author$project$Components$AuditSplitPane$Model(
						_Utils_update(
							model,
							{gesture: $elm$core$Maybe$Nothing})),
					function () {
						var _v4 = A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.movedTo;
							},
							model.gesture);
						if (_v4.$ === 'Just') {
							var widthPx = _v4.a;
							return A2(
								$author$project$HubTran$Effect$sendCacheableRequest,
								$elm$core$Basics$always($author$project$Components$AuditSplitPane$NoOp),
								$author$project$Api$Users$setAuditDocumentsColumnWidth(widthPx));
						} else {
							return $author$project$HubTran$Effect$none;
						}
					}());
			case 'HandleDoubleClicked':
				return _Utils_Tuple2(
					$author$project$Components$AuditSplitPane$Model(
						_Utils_update(
							model,
							{gesture: $elm$core$Maybe$Nothing, width: $author$project$Components$AuditSplitPane$Even})),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequest,
						$elm$core$Basics$always($author$project$Components$AuditSplitPane$NoOp),
						$author$project$Api$Users$clearAuditDocumentsColumnWidth));
			case 'ShowDocumentsHereClicked':
				return _Utils_Tuple2(
					$author$project$Components$AuditSplitPane$Model(
						_Utils_update(
							model,
							{poppedOut: false})),
					$author$project$HubTran$Effect$cmd(
						$author$project$Js$documentViewerPoppedIn(_Utils_Tuple0)));
			case 'PopoutAlreadyOpen':
				return _Utils_Tuple2(
					$author$project$Components$AuditSplitPane$Model(
						_Utils_update(
							model,
							{expanded: false, poppedOut: true})),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					$author$project$Components$AuditSplitPane$Model(
						_Utils_update(
							model,
							{poppedOut: false})),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$FindValueInDocuments = function (a) {
	return {$: 'FindValueInDocuments', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$IgnoreFailure = function (a) {
	return {$: 'IgnoreFailure', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$InputDrop = function (a) {
	return {$: 'InputDrop', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$NoOp = {$: 'NoOp'};
var $author$project$Components$CarrierInvoiceAuditChecks$PlaceExceptionEvent = function (a) {
	return {$: 'PlaceExceptionEvent', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$ResolveExceptionEvent = F2(
	function (a, b) {
		return {$: 'ResolveExceptionEvent', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditChecks$SelectDocumentPage = function (a) {
	return {$: 'SelectDocumentPage', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$UnignoreFailure = function (a) {
	return {$: 'UnignoreFailure', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$resolutionInput = F2(
	function (exceptionEventId, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Dict$get,
				$author$project$Domain$ExceptionEventId$toInt(exceptionEventId),
				model.exceptionEventInputs));
	});
var $author$project$Components$AuditDrafts$revert = F2(
	function (key, _v0) {
		var kindOf = _v0.a;
		var drafts = _v0.b;
		return A2(
			$author$project$Components$AuditDrafts$Drafts,
			kindOf,
			A2($turboMaCk$any_dict$Dict$Any$remove, key, drafts));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$SaveFieldUpdates = function (a) {
	return {$: 'SaveFieldUpdates', a: a};
};
var $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateExtractedFields = function (a) {
	return {$: 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateExtractedFields', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$extractedFieldsUpdate = function (values) {
	return {
		update: $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateExtractedFields(
			{
				fields: A2(
					$elm$core$List$map,
					function (_v0) {
						var name = _v0.a;
						var value = _v0.b;
						return {name: name, value: value};
					},
					values)
			})
	};
};
var $author$project$Components$AuditDrafts$markSent = F2(
	function (key, value) {
		return A2(
			$author$project$Components$AuditDrafts$set,
			key,
			$author$project$Components$AuditDrafts$Edited(
				{
					sent: $elm$core$Maybe$Just(value),
					typed: value
				}));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$saveSettledExtractedFields = F2(
	function (fields, model) {
		var worthSaving = A2(
			$elm$core$List$filterMap,
			function (field) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(field.name),
					A3(
						$author$project$Components$AuditDrafts$worthSending,
						$author$project$Components$CarrierInvoiceAuditDrafts$Extracted(field.name),
						{stored: field.stored, typed: field.typed},
						model.drafts));
			},
			fields);
		return $elm$core$List$isEmpty(worthSaving) ? _Utils_Tuple2(model, $author$project$Components$CarrierInvoiceAuditChecks$NoOp) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					drafts: A3(
						$elm$core$List$foldl,
						function (_v0) {
							var name = _v0.a;
							var value = _v0.b;
							return A2(
								$author$project$Components$AuditDrafts$markSent,
								$author$project$Components$CarrierInvoiceAuditDrafts$Extracted(name),
								value);
						},
						model.drafts,
						worthSaving)
				}),
			$author$project$Components$CarrierInvoiceAuditChecks$SaveFieldUpdates(
				_List_fromArray(
					[
						$author$project$Components$CarrierInvoiceAuditChecks$extractedFieldsUpdate(worthSaving)
					])));
	});
var $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateAmountToPay = function (a) {
	return {$: 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateAmountToPay', a: a};
};
var $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceAmount = function (a) {
	return {$: 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceAmount', a: a};
};
var $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceDate = function (a) {
	return {$: 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceDate', a: a};
};
var $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceNumber = function (a) {
	return {$: 'CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceNumber', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$fieldUpdate = F2(
	function (field, value) {
		switch (field.$) {
			case 'InvoiceNumber':
				return {
					update: $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceNumber(
						{invoiceNumber: value})
				};
			case 'InvoiceAmount':
				return {
					update: $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceAmount(
						{invoiceAmount: value})
				};
			case 'InvoiceDate':
				return {
					update: $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateInvoiceDate(
						{invoiceDate: value})
				};
			default:
				return {
					update: $author$project$AuditPb$CarrierInvoiceFieldUpdate_Update_CarrierInvoiceFieldUpdateAmountToPay(
						{amountToPay: value})
				};
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$valueToSave = F4(
	function (quickReviewValues, model, field, value) {
		return A2(
			$elm$core$Maybe$andThen,
			function (values) {
				return A3(
					$author$project$Components$AuditDrafts$worthSending,
					$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview(field),
					{
						stored: A2($author$project$Components$CarrierInvoiceAuditChecks$storedValue, field, values),
						typed: value
					},
					model.drafts);
			},
			quickReviewValues);
	});
var $author$project$Components$CarrierInvoiceAuditChecks$saveSettledValues = F3(
	function (quickReviewValues, fields, model) {
		var worthSaving = A2(
			$elm$core$List$filterMap,
			function (_v2) {
				var field = _v2.a;
				var value = _v2.b;
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(field),
					A4($author$project$Components$CarrierInvoiceAuditChecks$valueToSave, quickReviewValues, model, field, value));
			},
			fields);
		return $elm$core$List$isEmpty(worthSaving) ? _Utils_Tuple2(model, $author$project$Components$CarrierInvoiceAuditChecks$NoOp) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					drafts: A3(
						$elm$core$List$foldl,
						function (_v0) {
							var field = _v0.a;
							var value = _v0.b;
							return A2(
								$author$project$Components$AuditDrafts$markSent,
								$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview(field),
								value);
						},
						model.drafts,
						worthSaving)
				}),
			$author$project$Components$CarrierInvoiceAuditChecks$SaveFieldUpdates(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var field = _v1.a;
						var value = _v1.b;
						return A2($author$project$Components$CarrierInvoiceAuditChecks$fieldUpdate, field, value);
					},
					worthSaving)));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$toggleMember = F2(
	function (key, keys) {
		return A2($elm$core$Set$member, key, keys) ? A2($elm$core$Set$remove, key, keys) : A2($elm$core$Set$insert, key, keys);
	});
var $author$project$Components$AuditAddExceptionEvent$NoOp = {$: 'NoOp'};
var $author$project$Components$AuditAddExceptionEvent$PlaceException = function (a) {
	return {$: 'PlaceException', a: a};
};
var $author$project$Components$AuditAddExceptionEvent$otherMessage = 'Other';
var $author$project$Components$AuditAddExceptionEvent$finalMessage = function (model) {
	return ((model.selectedMessage === '') || _Utils_eq(model.selectedMessage, $author$project$Components$AuditAddExceptionEvent$otherMessage)) ? model.customMessage : model.selectedMessage;
};
var $author$project$Components$AuditAddExceptionEvent$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'MessageSelected':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedMessage: value}),
					$author$project$Components$AuditAddExceptionEvent$NoOp);
			case 'CustomMessageChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{customMessage: value}),
					$author$project$Components$AuditAddExceptionEvent$NoOp);
			default:
				return _Utils_Tuple2(
					$author$project$Components$AuditAddExceptionEvent$init,
					$author$project$Components$AuditAddExceptionEvent$PlaceException(
						$author$project$Components$AuditAddExceptionEvent$finalMessage(model)));
		}
	});
var $author$project$Components$AuditFailedCheckExceptionEvent$NoOp = {$: 'NoOp'};
var $author$project$Components$AuditFailedCheckExceptionEvent$ResolveExceptionEvent = F2(
	function (a, b) {
		return {$: 'ResolveExceptionEvent', a: a, b: b};
	});
var $author$project$Components$AuditFailedCheckExceptionEvent$update = F2(
	function (msg, resolutionInput) {
		if (msg.$ === 'ResolutionInputChanged') {
			var value = msg.a;
			return _Utils_Tuple2(value, $author$project$Components$AuditFailedCheckExceptionEvent$NoOp);
		} else {
			var exceptionEventId = msg.a;
			return _Utils_Tuple2(
				resolutionInput,
				A2($author$project$Components$AuditFailedCheckExceptionEvent$ResolveExceptionEvent, exceptionEventId, resolutionInput));
		}
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$CollapseToggled = {$: 'CollapseToggled'};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$FieldEdited = F2(
	function (a, b) {
		return {$: 'FieldEdited', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$FieldSaved = F2(
	function (a, b) {
		return {$: 'FieldSaved', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$FindValue = function (a) {
	return {$: 'FindValue', a: a};
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$NothingToReport = {$: 'NothingToReport'};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$update = function (msg) {
	switch (msg.$) {
		case 'InputChanged':
			var field = msg.a;
			var value = msg.b;
			return A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$FieldEdited, field, value);
		case 'InputSettled':
			var field = msg.a;
			var value = msg.b;
			return A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$FieldSaved, field, value);
		case 'InputDisregarded':
			return $author$project$Components$CarrierInvoiceAuditQuickReviewFields$NothingToReport;
		case 'FindClicked':
			var value = msg.a;
			return $author$project$Components$CarrierInvoiceAuditQuickReviewFields$FindValue(value);
		default:
			return $author$project$Components$CarrierInvoiceAuditQuickReviewFields$CollapseToggled;
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$update = F3(
	function (quickReviewValues, msg, model) {
		switch (msg.$) {
			case 'ToggleCheck':
				var topCheckKey = msg.a.topCheckKey;
				var key = msg.a.key;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							expansion: $author$project$Components$CarrierInvoiceAuditChecks$Expanded(
								A2(
									$author$project$Components$CarrierInvoiceAuditChecks$toggleMember,
									key,
									A2($author$project$Components$CarrierInvoiceAuditChecks$expandedKeys, model.expansion, topCheckKey)))
						}),
					$author$project$Components$CarrierInvoiceAuditChecks$NoOp);
			case 'ToggleCompletedCheck':
				var key = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							expandedCompletedChecks: A2($author$project$Components$CarrierInvoiceAuditChecks$toggleMember, key, model.expandedCompletedChecks)
						}),
					$author$project$Components$CarrierInvoiceAuditChecks$NoOp);
			case 'IgnoreFailureClicked':
				var failureId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$CarrierInvoiceAuditChecks$IgnoreFailure(failureId));
			case 'UnignoreFailureClicked':
				var failureId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$CarrierInvoiceAuditChecks$UnignoreFailure(failureId));
			case 'DocumentThumbnailClicked':
				var pageId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$CarrierInvoiceAuditChecks$SelectDocumentPage(pageId));
			case 'FindClicked':
				var value = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$CarrierInvoiceAuditChecks$FindValueInDocuments(value));
			case 'AmountFieldChanged':
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Components$CarrierInvoiceAuditChecks$stageDraft,
						$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview(field),
						value,
						model),
					$author$project$Components$CarrierInvoiceAuditChecks$NoOp);
			case 'AmountFieldsSettled':
				var fields = msg.a;
				return A3($author$project$Components$CarrierInvoiceAuditChecks$saveSettledValues, quickReviewValues, fields, model);
			case 'ExtractedFieldChanged':
				var name = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Components$CarrierInvoiceAuditChecks$stageDraft,
						$author$project$Components$CarrierInvoiceAuditDrafts$Extracted(name),
						value,
						model),
					$author$project$Components$CarrierInvoiceAuditChecks$NoOp);
			case 'ExtractedFieldsSettled':
				var fields = msg.a;
				return A2($author$project$Components$CarrierInvoiceAuditChecks$saveSettledExtractedFields, fields, model);
			case 'RevertClicked':
				var key = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							drafts: A2($author$project$Components$AuditDrafts$revert, key, model.drafts)
						}),
					$author$project$Components$CarrierInvoiceAuditChecks$NoOp);
			case 'InputDropMsg':
				var dropSide = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$CarrierInvoiceAuditChecks$InputDrop(dropSide));
			case 'QuickReviewMsg':
				var quickReviewMsg = msg.a;
				var _v1 = $author$project$Components$CarrierInvoiceAuditQuickReviewFields$update(quickReviewMsg);
				switch (_v1.$) {
					case 'FieldEdited':
						var field = _v1.a;
						var value = _v1.b;
						return _Utils_Tuple2(
							A3(
								$author$project$Components$CarrierInvoiceAuditChecks$stageDraft,
								$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview(field),
								value,
								model),
							$author$project$Components$CarrierInvoiceAuditChecks$NoOp);
					case 'FieldSaved':
						var field = _v1.a;
						var value = _v1.b;
						return A3(
							$author$project$Components$CarrierInvoiceAuditChecks$saveSettledValues,
							quickReviewValues,
							_List_fromArray(
								[
									_Utils_Tuple2(field, value)
								]),
							model);
					case 'FindValue':
						var value = _v1.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$CarrierInvoiceAuditChecks$FindValueInDocuments(value));
					case 'CollapseToggled':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{quickReviewCollapsed: !model.quickReviewCollapsed}),
							$author$project$Components$CarrierInvoiceAuditChecks$NoOp);
					default:
						return _Utils_Tuple2(model, $author$project$Components$CarrierInvoiceAuditChecks$NoOp);
				}
			case 'ExceptionEventMsg':
				var exceptionEventId = msg.a;
				var leafMsg = msg.b;
				var _v2 = A2(
					$author$project$Components$AuditFailedCheckExceptionEvent$update,
					leafMsg,
					A2($author$project$Components$CarrierInvoiceAuditChecks$resolutionInput, exceptionEventId, model));
				var input = _v2.a;
				var leafOut = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							exceptionEventInputs: A3(
								$elm$core$Dict$insert,
								$author$project$Domain$ExceptionEventId$toInt(exceptionEventId),
								input,
								model.exceptionEventInputs)
						}),
					function () {
						if (leafOut.$ === 'NoOp') {
							return $author$project$Components$CarrierInvoiceAuditChecks$NoOp;
						} else {
							var eventId = leafOut.a;
							var resolutionMessage = leafOut.b;
							return A2($author$project$Components$CarrierInvoiceAuditChecks$ResolveExceptionEvent, eventId, resolutionMessage);
						}
					}());
			default:
				var leafMsg = msg.a;
				var _v4 = A2($author$project$Components$AuditAddExceptionEvent$update, leafMsg, model.addExceptionEvent);
				var addExceptionEvent = _v4.a;
				var leafOut = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{addExceptionEvent: addExceptionEvent}),
					function () {
						if (leafOut.$ === 'NoOp') {
							return $author$project$Components$CarrierInvoiceAuditChecks$NoOp;
						} else {
							var message = leafOut.a;
							return $author$project$Components$CarrierInvoiceAuditChecks$PlaceExceptionEvent(message);
						}
					}());
		}
	});
var $author$project$Components$DragDrop$Dropped = F2(
	function (a, b) {
		return {$: 'Dropped', a: a, b: b};
	});
var $author$project$Components$DragDrop$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Components$DragDrop$Dragging = F2(
	function (a, b) {
		return {$: 'Dragging', a: a, b: b};
	});
var $author$project$Components$DragDrop$startDragging = F2(
	function (dragId, model) {
		return _Utils_update(
			model,
			{
				dragState: A2($author$project$Components$DragDrop$Dragging, dragId, $elm$core$Maybe$Nothing)
			});
	});
var $author$project$Components$DragDrop$stopDragging = function (model) {
	return _Utils_update(
		model,
		{dragState: $author$project$Components$DragDrop$NotDragging});
};
var $author$project$Components$DragDrop$updateDragOver = F2(
	function (dropId, model) {
		var updatedDragState = function () {
			var _v0 = model.dragState;
			if (_v0.$ === 'NotDragging') {
				return $author$project$Components$DragDrop$NotDragging;
			} else {
				var dragId = _v0.a;
				return A2($author$project$Components$DragDrop$Dragging, dragId, dropId);
			}
		}();
		return _Utils_update(
			model,
			{dragState: updatedDragState});
	});
var $author$project$Components$DragDrop$update = F2(
	function (msg, model) {
		if (msg.$ === 'DragSideMsg') {
			if (msg.a.$ === 'DragStart') {
				var dragId = msg.a.a;
				return _Utils_Tuple2(
					A2($author$project$Components$DragDrop$startDragging, dragId, model),
					$author$project$Components$DragDrop$NoOutMsg);
			} else {
				var _v1 = msg.a;
				return _Utils_Tuple2(
					$author$project$Components$DragDrop$stopDragging(model),
					$author$project$Components$DragDrop$NoOutMsg);
			}
		} else {
			if (msg.a.$ === 'Drop') {
				var dropId = msg.a.a;
				var _v2 = model.dragState;
				if (_v2.$ === 'NotDragging') {
					return _Utils_Tuple2(model, $author$project$Components$DragDrop$NoOutMsg);
				} else {
					var dragId = _v2.a;
					return _Utils_Tuple2(
						$author$project$Components$DragDrop$stopDragging(model),
						A2($author$project$Components$DragDrop$Dropped, dragId, dropId));
				}
			} else {
				var dropId = msg.a.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$DragDrop$updateDragOver,
						$elm$core$Maybe$Just(dropId),
						model),
					$author$project$Components$DragDrop$NoOutMsg);
			}
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$applyAuditChecksOutMsg = F3(
	function (data, outMsg, model) {
		switch (outMsg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'SaveFieldUpdates':
				var updates = outMsg.a;
				return A2($author$project$Components$CarrierInvoiceAuditPage$saveFieldUpdates, updates, model);
			case 'IgnoreFailure':
				var failureId = outMsg.a;
				return A2($author$project$Components$CarrierInvoiceAuditPage$ignoreFailure, failureId, model);
			case 'UnignoreFailure':
				var failureId = outMsg.a;
				return A2($author$project$Components$CarrierInvoiceAuditPage$unignoreFailure, failureId, model);
			case 'ResolveExceptionEvent':
				var exceptionEventId = outMsg.a;
				var resolutionMessage = outMsg.b;
				return A3($author$project$Components$CarrierInvoiceAuditPage$resolveExceptionEvent, exceptionEventId, resolutionMessage, model);
			case 'PlaceExceptionEvent':
				var message = outMsg.a;
				return A2($author$project$Components$CarrierInvoiceAuditPage$placeExceptionEvent, message, model);
			case 'FindValueInDocuments':
				var value = outMsg.a;
				var pagePredicate = F2(
					function (_v17, lines) {
						return A2(
							$elm$core$List$any,
							$author$project$Domain$DocumentPageLine$matchOnChars(
								$elm$core$Maybe$Just(value)),
							lines);
					});
				var _v16 = A4($author$project$Components$DocumentsBrowser$applyValueHighlight, value, pagePredicate, data.documentsBrowserData, model.documentsBrowser);
				var documentsBrowser = _v16.a;
				var documentsBrowserEffect = _v16.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{documentsBrowser: documentsBrowser}),
					documentsBrowserEffect);
			case 'SelectDocumentPage':
				var pageId = outMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documentsBrowser: A3(
								$author$project$Components$DocumentsBrowser$selectNextPageMatchingRule,
								F2(
									function (candidatePageId, _v18) {
										return _Utils_eq(candidatePageId, pageId);
									}),
								data.documentsBrowserData,
								model.documentsBrowser)
						}),
					$author$project$HubTran$Effect$none);
			default:
				var dropSide = outMsg.a;
				return A3(
					$author$project$Components$CarrierInvoiceAuditPage$update,
					data,
					$author$project$Components$CarrierInvoiceAuditPage$DragDropMsg(
						$author$project$Components$DragDrop$DropSideMsg(dropSide)),
					model);
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$update = F3(
	function (data, msg, model) {
		update:
		while (true) {
			_v0$3:
			while (true) {
				switch (msg.$) {
					case 'DocumentsBrowserMsg':
						if (msg.a.$ === 'NonHotkeyMsg') {
							switch (msg.a.a.$) {
								case 'LineDragStarted':
									var dragSide = msg.a.a.a;
									var $temp$data = data,
										$temp$msg = $author$project$Components$CarrierInvoiceAuditPage$DragDropMsg(
										$author$project$Components$DragDrop$DragSideMsg(dragSide)),
										$temp$model = model;
									data = $temp$data;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								case 'ExpandClicked':
									var _v1 = msg.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												splitPane: $author$project$Components$AuditSplitPane$toggleExpanded(model.splitPane)
											}),
										$author$project$HubTran$Effect$none);
								case 'PopoutClicked':
									var _v2 = msg.a.a;
									var _v3 = A2(
										$author$project$Components$AuditSplitPane$popOut,
										$author$project$Components$DocumentsBrowser$getCurrentProcessingSelection(model.documentsBrowser),
										model.splitPane);
									var splitPane = _v3.a;
									var effect = _v3.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{splitPane: splitPane}),
										effect);
								default:
									break _v0$3;
							}
						} else {
							break _v0$3;
						}
					case 'AuditChecksMsg':
						var auditChecksMsg = msg.a;
						var _v5 = A3(
							$author$project$Components$CarrierInvoiceAuditChecks$update,
							$author$project$Components$CarrierInvoiceAuditPage$quickReviewValues(data),
							auditChecksMsg,
							model.auditChecks);
						var auditChecks = _v5.a;
						var outMsg = _v5.b;
						return A3(
							$author$project$Components$CarrierInvoiceAuditPage$applyAuditChecksOutMsg,
							data,
							outMsg,
							_Utils_update(
								model,
								{auditChecks: auditChecks}));
					case 'DragDropMsg':
						var dragDropMsg = msg.a;
						var _v6 = A2($author$project$Components$DragDrop$update, dragDropMsg, model.dragDrop);
						var dragDrop = _v6.a;
						var outMsg = _v6.b;
						if (outMsg.$ === 'Dropped') {
							var droppedLine = outMsg.a.a;
							var key = outMsg.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										auditChecks: A3($author$project$Components$CarrierInvoiceAuditChecks$stageDraft, key, droppedLine.chars, model.auditChecks),
										dragDrop: dragDrop
									}),
								$author$project$HubTran$Effect$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{dragDrop: dragDrop}),
								$author$project$HubTran$Effect$none);
						}
					case 'ProcessUpdateResponse':
						var sentUpdates = msg.a;
						var response = msg.b;
						var _v8 = A2($author$project$PostRequestState$handleResponseCustom, model.requestState, response);
						var requestState = _v8.a;
						var result = _v8.b;
						return $author$project$Components$CarrierInvoiceAuditPage$sendQueuedUpdates(
							function () {
								var _v9 = A2($elm$core$Result$andThen, $elm$core$Basics$identity, result);
								if (_v9.$ === 'Ok') {
									var updateResponse = _v9.a;
									return A3(
										$author$project$Components$CarrierInvoiceAuditPage$handleUpdateResponse,
										sentUpdates,
										_Utils_update(
											model,
											{requestState: requestState}),
										updateResponse);
								} else {
									var httpError = _v9.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												auditChecks: A2($author$project$Components$CarrierInvoiceAuditPage$dropRefusedValues, sentUpdates, model.auditChecks),
												requestState: requestState
											}),
										$author$project$HubTran$Effect$batch(
											_List_fromArray(
												[
													$author$project$Helpers$HttpError$defaultHttpErrorHandler(httpError),
													$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId)
												])));
								}
							}());
					case 'SplitPaneMsg':
						var splitPaneMsg = msg.a;
						var _v10 = A2($author$project$Components$AuditSplitPane$update, splitPaneMsg, model.splitPane);
						var splitPane = _v10.a;
						var effect = _v10.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{splitPane: splitPane}),
							A2($author$project$HubTran$Effect$map, $author$project$Components$CarrierInvoiceAuditPage$SplitPaneMsg, effect));
					case 'SelectTab':
						var tab = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{selectedTab: tab}),
							$author$project$HubTran$Effect$none);
					case 'ReviewUnsavedEditClicked':
						return A2($author$project$Components$CarrierInvoiceAuditPage$reviewUnsavedEdit, data, model);
					case 'SaveClicked':
						return A4(
							$author$project$Components$CarrierInvoiceAuditPage$submit,
							$author$project$AuditApi$carrierInvoiceServiceSubmitWithState,
							{carrierInvoiceId: model.carrierInvoiceId},
							$author$project$Components$CarrierInvoiceAuditPage$LeaveWithFlash(
								$author$project$Components$CarrierInvoiceAuditPage$processSuccessMessage(data)),
							model);
					case 'SaveAndApproveClicked':
						return A4(
							$author$project$Components$CarrierInvoiceAuditPage$submit,
							$author$project$AuditApi$carrierInvoiceServiceSaveAndApproveWithState,
							{carrierInvoiceId: model.carrierInvoiceId},
							$author$project$Components$CarrierInvoiceAuditPage$LeaveWithFlash('Invoice approved'),
							model);
					case 'SaveWithErrorsClicked':
						return A2(
							$author$project$Components$CarrierInvoiceAuditPage$saveWithErrors,
							$author$project$Components$CarrierInvoiceAuditPage$LeaveWithFlash('Invoice saved to resolve later'),
							model);
					case 'SaveAndSendEmailClicked':
						return A2($author$project$Components$CarrierInvoiceAuditPage$saveWithErrors, $author$project$Components$CarrierInvoiceAuditPage$OpenSendToCarrier, model);
					case 'ProcessSubmitResponse':
						var afterSubmit = msg.a;
						var response = msg.b;
						var _v11 = A2($author$project$PostRequestState$handleResponseCustom, model.requestState, response);
						var requestState = _v11.a;
						var result = _v11.b;
						var _v12 = A2($elm$core$Result$andThen, $elm$core$Basics$identity, result);
						if (_v12.$ === 'Ok') {
							var submitResponse = _v12.a;
							return A3(
								$author$project$Components$CarrierInvoiceAuditPage$handleSubmitResponse,
								afterSubmit,
								_Utils_update(
									model,
									{requestState: requestState}),
								submitResponse);
						} else {
							var httpError = _v12.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{requestState: requestState}),
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$Helpers$HttpError$defaultHttpErrorHandler(httpError),
											$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId)
										])));
						}
					case 'ExceptionSent':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sendToCarrierOpen: false}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Email sent')),
										$author$project$Components$CarrierInvoiceAuditPage$leavePage(model)
									])));
					case 'SendToCarrierClosed':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sendToCarrierOpen: false}),
							$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId));
					default:
						var response = msg.a;
						var _v13 = A2($author$project$PostRequestState$handleResponseCustom, model.requestState, response);
						var requestState = _v13.a;
						var result = _v13.b;
						return $author$project$Components$CarrierInvoiceAuditPage$sendQueuedUpdates(
							function () {
								var _v14 = A2($elm$core$Result$andThen, $elm$core$Basics$identity, result);
								if (_v14.$ === 'Ok') {
									var clearedResponse = _v14.a;
									return A2(
										$author$project$Components$CarrierInvoiceAuditPage$handleAuditWriteResponse,
										_Utils_update(
											model,
											{requestState: requestState}),
										clearedResponse);
								} else {
									var httpError = _v14.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												auditChecks: $author$project$Components$CarrierInvoiceAuditChecks$clearIgnoreInFlight(model.auditChecks),
												requestState: requestState
											}),
										$author$project$HubTran$Effect$batch(
											_List_fromArray(
												[
													$author$project$Helpers$HttpError$defaultHttpErrorHandler(httpError),
													$author$project$Components$CarrierInvoiceAuditPage$refreshAuditDataEffect(model.carrierInvoiceId)
												])));
								}
							}());
				}
			}
			var documentsBrowserMsg = msg.a;
			var _v4 = A4(
				$author$project$Components$DocumentsBrowser$update,
				data.documentsBrowserData,
				documentsBrowserMsg,
				A2($author$project$Components$CarrierInvoiceAuditPage$browserWithDocumentTypes, data, model),
				$author$project$Components$CarrierInvoiceAuditPage$documentRefreshHooks(model.carrierInvoiceId));
			var documentsBrowser = _v4.a;
			var documentsBrowserEffect = _v4.b;
			var splitPane = (documentsBrowser.documentTypePickerOpen && (!model.documentsBrowser.documentTypePickerOpen)) ? $author$project$Components$AuditSplitPane$collapse(model.splitPane) : model.splitPane;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{documentsBrowser: documentsBrowser, splitPane: splitPane}),
				A2($author$project$HubTran$Effect$map, $author$project$Components$CarrierInvoiceAuditPage$DocumentsBrowserMsg, documentsBrowserEffect));
		}
	});
var $author$project$Domain$DashboardFilters$fromPb = function (filters) {
	return {
		categories: A2(
			$elm$core$List$map,
			function (category) {
				return {
					category: {labels: _List_Nil, name: category.category},
					excluded: $elm$core$Set$fromList(category.excluded),
					selected: $elm$core$Set$fromList(category.label)
				};
			},
			filters.categories),
		customers: filters.customers,
		dashboardMode: filters.dashboardMode,
		dashboardSortBy: filters.sortBy,
		endDate: A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm$core$Result$toMaybe),
			filters.endDate),
		endDateTime: filters.endDateTime,
		exceptions: filters.exceptions,
		factorBrokerIds: filters.factorBrokerId,
		labelFilters: A2($elm$core$List$map, $author$project$Domain$LabelFilter$fromPb, filters.labelFilters),
		rangeType: filters.rangeType,
		reskinToggle: filters.reskinToggle,
		startDate: A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm$core$Result$toMaybe),
			filters.startDate),
		startDateTime: filters.startDateTime,
		timezoneName: filters.timezoneName,
		tmsCarrierIds: filters.carrierId
	};
};
var $author$project$Domain$DashboardSavedFilter$applySavedFilter = F2(
	function (currentFilter, savedFilter) {
		var newDashboardFilters = $author$project$Domain$DashboardFilters$fromPb(savedFilter.filter);
		var newTimezoneName = function () {
			var _v0 = newDashboardFilters.timezoneName;
			if (_v0.$ === 'Just') {
				var timezoneName = _v0.a;
				return $elm$core$Maybe$Just(timezoneName);
			} else {
				return currentFilter.timezoneName;
			}
		}();
		var updatedLabelState = function (labelFilter) {
			var state = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Domain$LabelFilter$Unselected,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.state;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (lf) {
								return _Utils_eq(lf.label, labelFilter.label);
							},
							newDashboardFilters.labelFilters))));
			return _Utils_update(
				labelFilter,
				{state: state});
		};
		var newLabelFilters = A2($elm$core$List$map, updatedLabelState, currentFilter.labelFilters);
		var updatedSelection = function (category) {
			var updatedCategories = A2(
				$elm$core$List$filter,
				function (cat) {
					return _Utils_eq(cat.category.name, category.category.name);
				},
				newDashboardFilters.categories);
			var selected = $elm$core$Set$fromList(
				A2(
					$elm$core$List$concatMap,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Set$toList,
						function ($) {
							return $.selected;
						}),
					updatedCategories));
			var excluded = $elm$core$Set$fromList(
				A2(
					$elm$core$List$concatMap,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Set$toList,
						function ($) {
							return $.excluded;
						}),
					updatedCategories));
			return _Utils_update(
				category,
				{excluded: excluded, selected: selected});
		};
		var newCategories = A2($elm$core$List$map, updatedSelection, currentFilter.categories);
		return _Utils_update(
			newDashboardFilters,
			{categories: newCategories, labelFilters: newLabelFilters, timezoneName: newTimezoneName});
	});
var $author$project$Components$DashboardPage$applyDashboardSavedFilterToModel = F3(
	function (data, dashboardSavedFilterData, model) {
		var newDashboardFilters = A2($author$project$Domain$DashboardSavedFilter$applySavedFilter, model.dashboardFilters, dashboardSavedFilterData.dashboardSavedFilter);
		var _v0 = A3($author$project$Components$DashboardPage$categoryDropdownsAndEffects, newDashboardFilters.categories, data.account, model.dashboardMode);
		var newDropdowns = _v0.a;
		var _v1 = $author$project$Components$DashboardPage$debtorDropdownAndCmd(dashboardSavedFilterData.factorBrokers);
		var debtorDropdown = _v1.a;
		var _v2 = A2($author$project$Components$DashboardPage$customerDropdownAndCmd, data.accountSettings, newDashboardFilters);
		var customerDropdown = _v2.a;
		var _v3 = A3($author$project$Components$DashboardPage$carrierDropdownAndCmd, data.account, data.accountSettings, dashboardSavedFilterData.tmsCarriers);
		var carrierDropdown = _v3.a;
		return _Utils_update(
			model,
			{carrierDropdown: carrierDropdown, categoryDropdowns: newDropdowns, customerDropdown: customerDropdown, dashboardFilters: newDashboardFilters, debtorDropdown: debtorDropdown, endDate: newDashboardFilters.endDate, endDateTime: newDashboardFilters.endDateTime, startDate: newDashboardFilters.startDate, startDateTime: newDashboardFilters.startDateTime});
	});
var $author$project$Components$DashboardPage$maybeApplyDefaultFilter = F2(
	function (data, model) {
		if (model.hasAppliedDefaultFilter) {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		} else {
			if (!data.accountSettings.savedFilterEnhancementsEnabled) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hasAppliedDefaultFilter: true}),
					$author$project$HubTran$Effect$none);
			} else {
				var _v0 = $author$project$Forward$Remote$toMaybe(data.dashboardSavedFilters);
				if (_v0.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var savedFilterDataList = _v0.a;
					var defaultFilter = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (sfd) {
								return sfd.dashboardSavedFilter.isDefault && _Utils_eq(sfd.dashboardSavedFilter.dashboardMode, model.dashboardMode);
							},
							savedFilterDataList));
					if (defaultFilter.$ === 'Just') {
						var sfd = defaultFilter.a;
						return _Utils_Tuple2(
							function (m) {
								return _Utils_update(
									m,
									{hasAppliedDefaultFilter: true});
							}(
								A3($author$project$Components$DashboardPage$applyDashboardSavedFilterToModel, data, sfd, model)),
							$author$project$HubTran$Effect$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{hasAppliedDefaultFilter: true}),
							$author$project$HubTran$Effect$none);
					}
				}
			}
		}
	});
var $author$project$Components$DashboardPage$browserUrl = F2(
	function (accountSettings, model) {
		return A5(
			$author$project$Components$Dashboard$Url$urlWithArguments,
			model.selectedQueue,
			model.dashboardFilters,
			model.requestedActivePage,
			A2($author$project$Components$DashboardPage$flowModeEnabled, accountSettings, model),
			model.dashboardMode);
	});
var $author$project$Components$DashboardPage$maybeUpdateBrowserUrl = F3(
	function (accountSettings, previousModel, currentModel) {
		return (!_Utils_eq(
			A2($author$project$Components$DashboardPage$browserUrl, accountSettings, previousModel),
			A2($author$project$Components$DashboardPage$browserUrl, accountSettings, currentModel))) ? $author$project$HubTran$Effect$replaceUrl(
			A2($author$project$Components$DashboardPage$browserUrl, accountSettings, currentModel)) : $author$project$HubTran$Effect$none;
	});
var $author$project$Components$Dashboard$Pager$Selectable$CarrierInvoice = function (a) {
	return {$: 'CarrierInvoice', a: a};
};
var $author$project$Components$DashboardPage$DashboardSavedFilterEditModalMsg = function (a) {
	return {$: 'DashboardSavedFilterEditModalMsg', a: a};
};
var $author$project$Components$DashboardPage$DashboardSavedFilterSaveModalMsg = function (a) {
	return {$: 'DashboardSavedFilterSaveModalMsg', a: a};
};
var $author$project$Components$Dashboard$Pager$Selectable$EmailMessage = function (a) {
	return {$: 'EmailMessage', a: a};
};
var $author$project$Components$DashboardPage$NoOp = {$: 'NoOp'};
var $author$project$Components$DashboardPage$PreferredFiltersUpdated = function (a) {
	return {$: 'PreferredFiltersUpdated', a: a};
};
var $author$project$Components$DashboardPage$ProcessedBrokerMsg = function (a) {
	return {$: 'ProcessedBrokerMsg', a: a};
};
var $author$project$Components$DashboardPage$ProcessedFactorMsg = function (a) {
	return {$: 'ProcessedFactorMsg', a: a};
};
var $author$project$Components$DashboardPage$FinishedBulkLabel = function (a) {
	return {$: 'FinishedBulkLabel', a: a};
};
var $timo_weike$generic_collections$ManualSet$foldl = F3(
	function (f, start, _v0) {
		var dict = _v0.a;
		return A3(
			$elm$core$Dict$foldl,
			function (_v1) {
				return f;
			},
			start,
			dict);
	});
var $author$project$Components$DashboardPage$ignorableLists = function (ignorables) {
	return A3(
		$timo_weike$generic_collections$ManualSet$foldl,
		F2(
			function (ignorable, lists_) {
				switch (ignorable.$) {
					case 'EmailMessage':
						var emailMessage = ignorable.a;
						return _Utils_update(
							lists_,
							{
								emailMessageIds: A2($elm$core$List$cons, emailMessage, lists_.emailMessageIds)
							});
					case 'ExceptionedItem':
						var exceptionedItem = ignorable.a;
						return _Utils_update(
							lists_,
							{
								exceptionedItemIds: A2($elm$core$List$cons, exceptionedItem, lists_.exceptionedItemIds)
							});
					case 'CarrierInvoice':
						var carrierInvoice = ignorable.a;
						return _Utils_update(
							lists_,
							{
								carrierInvoiceIds: A2($elm$core$List$cons, carrierInvoice, lists_.carrierInvoiceIds)
							});
					default:
						var factorInvoice = ignorable.a;
						return _Utils_update(
							lists_,
							{
								factorInvoiceIds: A2($elm$core$List$cons, factorInvoice, lists_.factorInvoiceIds)
							});
				}
			}),
		{carrierInvoiceIds: _List_Nil, emailMessageIds: _List_Nil, exceptionedItemIds: _List_Nil, factorInvoiceIds: _List_Nil},
		ignorables);
};
var $author$project$Api$CarrierInvoice$bulkLabel = F3(
	function (carrierInvoiceIds, label, remove) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/carrier_invoices/label_many',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ids',
						A2(
							$elm$json$Json$Encode$list,
							A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
							carrierInvoiceIds)),
						_Utils_Tuple2(
						'label',
						$elm$json$Json$Encode$string(label)),
						_Utils_Tuple2(
						'remove',
						$elm$json$Json$Encode$bool(remove))
					])));
	});
var $author$project$Api$CarrierInvoice$sendBulkLabel = F4(
	function (finishedMsg, carrierInvoiceIds, label, remove) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			A3($author$project$Api$CarrierInvoice$bulkLabel, carrierInvoiceIds, label, remove));
	});
var $author$project$Api$EmailMessages$bulkLabel = F3(
	function (emailMessageIds, label, remove) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/email_messages/label_many',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ids',
						A2(
							$elm$json$Json$Encode$list,
							A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$EmailMessageId$toInt),
							emailMessageIds)),
						_Utils_Tuple2(
						'label',
						$elm$json$Json$Encode$string(label)),
						_Utils_Tuple2(
						'remove',
						$elm$json$Json$Encode$bool(remove))
					])));
	});
var $author$project$Api$EmailMessages$sendBulkLabel = F4(
	function (finishedMsg, emailMessageIds, label, remove) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			A3($author$project$Api$EmailMessages$bulkLabel, emailMessageIds, label, remove));
	});
var $author$project$Api$ExceptionedItems$bulkLabel = F3(
	function (exceptionedItemIds, label, remove) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/exceptioned_items/label_many',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ids',
						A2(
							$elm$json$Json$Encode$list,
							A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$ExceptionedItemId$toInt),
							exceptionedItemIds)),
						_Utils_Tuple2(
						'label',
						$elm$json$Json$Encode$string(label)),
						_Utils_Tuple2(
						'remove',
						$elm$json$Json$Encode$bool(remove))
					])));
	});
var $author$project$Api$ExceptionedItems$sendBulkLabel = F4(
	function (finishedMsg, exceptionedItemIds, label, remove) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			A3($author$project$Api$ExceptionedItems$bulkLabel, exceptionedItemIds, label, remove));
	});
var $author$project$Api$FactorInvoice$bulkLabel = F3(
	function (exceptionedItemIds, label, remove) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/factor_invoices/label_many',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ids',
						A2(
							$elm$json$Json$Encode$list,
							A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
							exceptionedItemIds)),
						_Utils_Tuple2(
						'label',
						$elm$json$Json$Encode$string(label)),
						_Utils_Tuple2(
						'remove',
						$elm$json$Json$Encode$bool(remove))
					])));
	});
var $author$project$Api$FactorInvoice$sendBulkLabel = F4(
	function (finishedMsg, exceptionedItemIds, label, remove) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			A3($author$project$Api$FactorInvoice$bulkLabel, exceptionedItemIds, label, remove));
	});
var $author$project$Components$DashboardPage$bulkLabel = F3(
	function (selectables, label, remove) {
		var toEffect = F2(
			function (apiFunc, list) {
				return $elm$core$List$isEmpty(list) ? $author$project$HubTran$Effect$none : A4(apiFunc, $author$project$Components$DashboardPage$FinishedBulkLabel, list, label, remove);
			});
		var lists = $author$project$Components$DashboardPage$ignorableLists(selectables);
		return $author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					A2(toEffect, $author$project$Api$EmailMessages$sendBulkLabel, lists.emailMessageIds),
					A2(toEffect, $author$project$Api$ExceptionedItems$sendBulkLabel, lists.exceptionedItemIds),
					A2(toEffect, $author$project$Api$FactorInvoice$sendBulkLabel, lists.factorInvoiceIds),
					A2(toEffect, $author$project$Api$CarrierInvoice$sendBulkLabel, lists.carrierInvoiceIds),
					$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$emailMessage),
					$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$exceptionedItem),
					$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$factorInvoice),
					$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$carrierInvoice)
				]));
	});
var $author$project$Components$DashboardPage$canPerformQueueActions = function (user) {
	return !user.readOnlyFactorInvoices;
};
var $author$project$Components$CustomerDropdown$clear = function (model) {
	return _Utils_update(
		model,
		{
			dropdown: $author$project$Components$PaginatedDropdown$clear(model.dropdown)
		});
};
var $author$project$Domain$LabelFilter$unselect = function (labelFilter) {
	return _Utils_update(
		labelFilter,
		{state: $author$project$Domain$LabelFilter$Unselected});
};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$clearAll = $elm$core$List$map($author$project$Domain$LabelFilter$unselect);
var $author$project$Components$Dashboard$Processed$BrokerModel$clearSelection = function (_v0) {
	var brokerModel = _v0.a;
	return $author$project$Components$Dashboard$Processed$BrokerModel$BrokerModel(
		_Utils_update(
			brokerModel,
			{selected: $author$project$Id$Set$empty}));
};
var $author$project$Components$Dashboard$Processed$FactorModel$clearSelection = function (_v0) {
	var model = _v0.a;
	return $author$project$Components$Dashboard$Processed$FactorModel$FactorModel(
		_Utils_update(
			model,
			{
				expandedTmsCarrierIds: $author$project$Id$Set$empty,
				selectedFactorInvoiceIds: $author$project$Sanitized$raw($author$project$Id$Set$empty)
			}));
};
var $author$project$Domain$CategoryFilter$clearSelection = function (categories) {
	return A2(
		$elm$core$List$map,
		function (x) {
			return A3($author$project$Domain$CategoryFilter$SelectableCategoryFilter, x.category, $elm$core$Set$empty, $elm$core$Set$empty);
		},
		categories);
};
var $author$project$Components$Dashboard$Review$Model$clearSelection = function (reviewModel) {
	return _Utils_update(
		reviewModel,
		{
			selectedFactorInvoiceIds: $author$project$Sanitized$raw($author$project$Id$Set$empty)
		});
};
var $author$project$Components$DashboardPage$clearSelections = function (model) {
	return _Utils_update(
		model,
		{
			processedBrokerModel: $author$project$Components$Dashboard$Processed$BrokerModel$clearSelection(model.processedBrokerModel),
			processedFactorModel: $author$project$Components$Dashboard$Processed$FactorModel$clearSelection(model.processedFactorModel),
			reviewModel: $author$project$Components$Dashboard$Review$Model$clearSelection(model.reviewModel),
			selectAllVisible: false,
			selectedSelectables: $timo_weike$generic_collections$ManualSet$empty
		});
};
var $author$project$Components$DashboardPage$dateTimeWithFourDigitYear = F3(
	function (tz, currentDateTime, dateTime) {
		return (A2($elm$time$Time$toYear, tz, dateTime) > 1000) ? $elm$core$Maybe$Just(dateTime) : currentDateTime;
	});
var $author$project$Components$DashboardPage$dateWithFourDigitYear = F2(
	function (currentDate, date) {
		return ($justinmimbs$date$Date$year(date) > 1000) ? $elm$core$Maybe$Just(date) : currentDate;
	});
var $author$project$Components$Dashboard$Pager$Selectable$ExceptionedItem = function (a) {
	return {$: 'ExceptionedItem', a: a};
};
var $author$project$Components$DashboardPage$getExceptionedItemId = function (_v0) {
	var exceptionedRow = _v0.a;
	return exceptionedRow.exceptionedItem.id;
};
var $author$project$Components$DashboardPage$getExceptionedItemSelectables = function (remoteExceptionedItemRows) {
	var buildSelectable = function (row) {
		return A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$getExceptionedItemId, $author$project$Components$Dashboard$Pager$Selectable$ExceptionedItem),
			$author$project$Forward$Remote$toMaybe(row));
	};
	return A2($elm$core$List$filterMap, buildSelectable, remoteExceptionedItemRows);
};
var $author$project$Components$Dashboard$Pager$Selectable$toComparable = function (ignorable) {
	switch (ignorable.$) {
		case 'EmailMessage':
			var emailMessageId = ignorable.a;
			return _Utils_Tuple2(
				'EmailMessage',
				$author$project$Domain$EmailMessageId$toInt(emailMessageId));
		case 'ExceptionedItem':
			var exceptionedItemId = ignorable.a;
			return _Utils_Tuple2(
				'ExceptionedItem',
				$author$project$Domain$ExceptionedItemId$toInt(exceptionedItemId));
		case 'CarrierInvoice':
			var carrierInvoiceId = ignorable.a;
			return _Utils_Tuple2(
				'CarrierInvoice',
				$author$project$Domain$CarrierInvoiceId$toInt(carrierInvoiceId));
		default:
			var factorInvoiceId = ignorable.a;
			return _Utils_Tuple2(
				'FactorInvoice',
				$author$project$Domain$FactorInvoiceId$toInt(factorInvoiceId));
	}
};
var $author$project$Components$DashboardPage$exceptionSelectAllVisible = F2(
	function (model, currentPage) {
		return (!model.selectAllVisible) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					selectAllVisible: true,
					selectedSelectables: A2(
						$timo_weike$generic_collections$ManualSet$fromList,
						$author$project$Components$Dashboard$Pager$Selectable$toComparable,
						$author$project$Components$DashboardPage$getExceptionedItemSelectables(
							$author$project$Pagination$entries(currentPage)))
				}),
			$author$project$HubTran$Effect$none) : _Utils_Tuple2(
			_Utils_update(
				model,
				{selectAllVisible: false, selectedSelectables: $timo_weike$generic_collections$ManualSet$empty}),
			$author$project$HubTran$Effect$none);
	});
var $author$project$Ui$V3$CustomSelect$excludedItems = function (_v0) {
	var model = _v0.a;
	return model.excludedItems;
};
var $author$project$Id$Set$toList = function (_v0) {
	var set = _v0.a;
	return A2(
		$elm$core$List$map,
		$author$project$Id$fromInt,
		$elm$core$Set$toList(set));
};
var $author$project$Domain$CarrierInvoice$toSelectable = function (id) {
	return $author$project$Components$Dashboard$Pager$Selectable$CarrierInvoice(id);
};
var $author$project$Components$Dashboard$Processed$BrokerModel$selectedSelectables = function (_v0) {
	var model = _v0.a;
	return A2(
		$elm$core$List$map,
		$author$project$Domain$CarrierInvoice$toSelectable,
		$author$project$Id$Set$toList(model.selected));
};
var $author$project$Components$DashboardPage$getProcessedBrokerSelectedAsSelectables = function (brokerModel) {
	return A2(
		$timo_weike$generic_collections$ManualSet$fromList,
		$author$project$Components$Dashboard$Pager$Selectable$toComparable,
		$author$project$Components$Dashboard$Processed$BrokerModel$selectedSelectables(brokerModel));
};
var $author$project$Id$Set$member = F2(
	function (id, _v0) {
		var set = _v0.a;
		return A2(
			$elm$core$Set$member,
			$author$project$Id$toInt(id),
			set);
	});
var $author$project$Components$Dashboard$Processed$FactorModel$isFactorInvoiceIdSelected = F2(
	function (selectedFactorInvoiceIds_, factorInvoiceId) {
		return A2($author$project$Id$Set$member, factorInvoiceId, selectedFactorInvoiceIds_);
	});
var $author$project$Components$Dashboard$Processed$FactorModel$selectedFactorInvoiceIds = F2(
	function (data, _v0) {
		var model = _v0.a;
		return A2(
			$author$project$Sanitized$sanitize,
			function (selectedFactorInvoiceIds_) {
				return $author$project$Id$Set$fromList(
					A2(
						$elm$core$List$concatMap,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.factorInvoiceIds;
							},
							$elm$core$List$filter(
								$author$project$Components$Dashboard$Processed$FactorModel$isFactorInvoiceIdSelected(selectedFactorInvoiceIds_))),
						$author$project$Pagination$entries(data.currentPageData)));
			},
			model.selectedFactorInvoiceIds);
	});
var $author$project$Components$Dashboard$Pager$Selectable$FactorInvoice = function (a) {
	return {$: 'FactorInvoice', a: a};
};
var $author$project$Domain$FactorInvoice$toSelectable = function (id) {
	return $author$project$Components$Dashboard$Pager$Selectable$FactorInvoice(id);
};
var $author$project$Components$Dashboard$Processed$FactorModel$selectedSelectables = F2(
	function (data, model) {
		return A2(
			$elm$core$List$map,
			$author$project$Domain$FactorInvoice$toSelectable,
			$author$project$Id$Set$toList(
				A2($author$project$Components$Dashboard$Processed$FactorModel$selectedFactorInvoiceIds, data, model)));
	});
var $author$project$Components$DashboardPage$getProcessedFactorSelectedAsSelectables = F2(
	function (factorData, factorModel) {
		return A2(
			$timo_weike$generic_collections$ManualSet$fromList,
			$author$project$Components$Dashboard$Pager$Selectable$toComparable,
			A2($author$project$Components$Dashboard$Processed$FactorModel$selectedSelectables, factorData, factorModel));
	});
var $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentBatchReviewId = function (a) {
	return {$: 'ManualDocumentBatchReviewId', a: a};
};
var $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentGroupReviewId = function (a) {
	return {$: 'ManualDocumentGroupReviewId', a: a};
};
var $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentReviewId = function (a) {
	return {$: 'ManualDocumentReviewId', a: a};
};
var $author$project$Components$DocumentReview$DocumentReviewFlow$startNextResponseToManualReviewId = function (startNextResponse) {
	var _v0 = startNextResponse.nextReview;
	switch (_v0.$) {
		case 'DocumentReviewStartNextResponse_NextReview_MultiPageBolReviewId':
			var wrapper = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Domain$DocumentReviewId$MultiPageBolReviewId, $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentReviewId),
				wrapper.multiPageBolReviewId);
		case 'DocumentReviewStartNextResponse_NextReview_DocumentTypeReviewId':
			var wrapper = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Domain$DocumentReviewId$DocumentTypeReviewId, $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentReviewId),
				wrapper.documentTypeReviewId);
		case 'DocumentReviewStartNextResponse_NextReview_InvoiceNumberReviewId':
			var wrapper = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Domain$DocumentReviewId$InvoiceNumberReviewId, $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentReviewId),
				wrapper.invoiceNumberReviewId);
		case 'DocumentReviewStartNextResponse_NextReview_InvoiceAmountReviewId':
			var wrapper = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Domain$DocumentReviewId$InvoiceAmountReviewId, $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentReviewId),
				wrapper.invoiceAmountReviewId);
		case 'DocumentReviewStartNextResponse_NextReview_DocumentLoadReferenceMatchReviewId':
			var wrapper = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Domain$DocumentReviewId$DocumentLoadReferenceMatchReviewId, $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentReviewId),
				wrapper.documentLoadReferenceMatchReviewId);
		case 'DocumentReviewStartNextResponse_NextReview_DocumentGroupLoadReviewId':
			var wrapper = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Domain$DocumentGroupReviewId$DocumentGroupLoadReviewId, $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentGroupReviewId),
				wrapper.documentGroupLoadReviewId);
		case 'DocumentReviewStartNextResponse_NextReview_DocumentBatchGroupingReviewId':
			var wrapper = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Domain$DocumentBatchReviewId$DocumentBatchGroupingReviewId, $author$project$Components$DocumentReview$DocumentReviewFlow$ManualDocumentBatchReviewId),
				wrapper.documentBatchGroupingReviewId);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Domain$DocumentBatchGroupingReviewId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Domain$DocumentBatchReviewId$toUrlPathSegments = function (documentBatchReviewId) {
	var id = documentBatchReviewId.a;
	return _List_fromArray(
		[
			'document_batch_grouping_reviews',
			$author$project$Domain$DocumentBatchGroupingReviewId$toString(id)
		]);
};
var $author$project$Domain$DocumentGroupLoadReviewId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Domain$DocumentGroupReviewId$toUrlPathSegments = function (documentGroupReviewId) {
	var id = documentGroupReviewId.a;
	return _List_fromArray(
		[
			'document_group_load_reviews',
			$author$project$Domain$DocumentGroupLoadReviewId$toString(id)
		]);
};
var $author$project$Domain$DocumentLoadReferenceMatchReviewId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Domain$DocumentTypeReviewId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Domain$InvoiceAmountReviewId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Domain$InvoiceNumberReviewId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Domain$MultiPageBolReviewId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Domain$DocumentReviewId$toUrlPathSegments = function (documentReviewId) {
	switch (documentReviewId.$) {
		case 'InvoiceNumberReviewId':
			var id = documentReviewId.a;
			return _List_fromArray(
				[
					'invoice_number_reviews',
					$author$project$Domain$InvoiceNumberReviewId$toString(id)
				]);
		case 'InvoiceAmountReviewId':
			var id = documentReviewId.a;
			return _List_fromArray(
				[
					'invoice_amount_reviews',
					$author$project$Domain$InvoiceAmountReviewId$toString(id)
				]);
		case 'MultiPageBolReviewId':
			var id = documentReviewId.a;
			return _List_fromArray(
				[
					'multi_page_bol_reviews',
					$author$project$Domain$MultiPageBolReviewId$toString(id)
				]);
		case 'DocumentTypeReviewId':
			var id = documentReviewId.a;
			return _List_fromArray(
				[
					'document_type_reviews',
					$author$project$Domain$DocumentTypeReviewId$toString(id)
				]);
		default:
			var id = documentReviewId.a;
			return _List_fromArray(
				[
					'document_load_reference_match_reviews',
					$author$project$Domain$DocumentLoadReferenceMatchReviewId$toString(id)
				]);
	}
};
var $author$project$Components$DocumentReview$DocumentReviewFlow$nextUrlPath = function (startNextResponse) {
	var toPath = function (manualReviewId) {
		switch (manualReviewId.$) {
			case 'ManualDocumentReviewId':
				var id = manualReviewId.a;
				return A2(
					$elm$core$List$cons,
					'app',
					A2(
						$elm$core$List$cons,
						'document_reviews',
						$author$project$Domain$DocumentReviewId$toUrlPathSegments(id)));
			case 'ManualDocumentBatchReviewId':
				var id = manualReviewId.a;
				return A2(
					$elm$core$List$cons,
					'app',
					A2(
						$elm$core$List$cons,
						'document_batch_reviews',
						$author$project$Domain$DocumentBatchReviewId$toUrlPathSegments(id)));
			default:
				var id = manualReviewId.a;
				return A2(
					$elm$core$List$cons,
					'app',
					A2(
						$elm$core$List$cons,
						'document_group_reviews',
						$author$project$Domain$DocumentGroupReviewId$toUrlPathSegments(id)));
		}
	};
	var maybeManualReviewId = $author$project$Components$DocumentReview$DocumentReviewFlow$startNextResponseToManualReviewId(startNextResponse);
	return A2($elm$core$Maybe$map, toPath, maybeManualReviewId);
};
var $author$project$Components$DocumentReview$DocumentReviewFlow$goToNextReviewIfPresentEffect = F2(
	function (startNextResponse, _v0) {
		var noReviewFlashMessage = _v0.noReviewFlashMessage;
		var onDoneUrlFragment = _v0.onDoneUrlFragment;
		var nextPath = $author$project$Components$DocumentReview$DocumentReviewFlow$nextUrlPath(startNextResponse);
		if (nextPath.$ === 'Just') {
			var path = nextPath.a;
			return $author$project$HubTran$Effect$pushUrl(
				A2(
					$elm$url$Url$Builder$absolute,
					path,
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'onDone',
							A2($elm$core$Maybe$withDefault, '', onDoneUrlFragment))
						])));
		} else {
			return $author$project$HubTran$Effect$flash(
				$author$project$HubTran$Flash$warning(noReviewFlashMessage));
		}
	});
var $author$project$Components$DashboardPage$NextReviewRetrieved = function (a) {
	return {$: 'NextReviewRetrieved', a: a};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse = function (nextReview) {
	return {nextReview: nextReview};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentBatchGroupingReviewId = function (a) {
	return {$: 'DocumentReviewStartNextResponse_NextReview_DocumentBatchGroupingReviewId', a: a};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentGroupLoadReviewId = function (a) {
	return {$: 'DocumentReviewStartNextResponse_NextReview_DocumentGroupLoadReviewId', a: a};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentLoadReferenceMatchReviewId = function (a) {
	return {$: 'DocumentReviewStartNextResponse_NextReview_DocumentLoadReferenceMatchReviewId', a: a};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentReviewNone = function (a) {
	return {$: 'DocumentReviewStartNextResponse_NextReview_DocumentReviewNone', a: a};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentTypeReviewId = function (a) {
	return {$: 'DocumentReviewStartNextResponse_NextReview_DocumentTypeReviewId', a: a};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_InvoiceAmountReviewId = function (a) {
	return {$: 'DocumentReviewStartNextResponse_NextReview_InvoiceAmountReviewId', a: a};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_InvoiceNumberReviewId = function (a) {
	return {$: 'DocumentReviewStartNextResponse_NextReview_InvoiceNumberReviewId', a: a};
};
var $author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_MultiPageBolReviewId = function (a) {
	return {$: 'DocumentReviewStartNextResponse_NextReview_MultiPageBolReviewId', a: a};
};
var $author$project$AuditPb$DocumentBatchGroupingReviewId = function (documentBatchGroupingReviewId) {
	return {documentBatchGroupingReviewId: documentBatchGroupingReviewId};
};
var $author$project$AuditPb$documentBatchGroupingReviewIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'documentBatchGroupingReviewId',
			A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentBatchGroupingReviewId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$DocumentBatchGroupingReviewId));
	});
var $author$project$AuditPb$DocumentGroupLoadReviewId = function (documentGroupLoadReviewId) {
	return {documentGroupLoadReviewId: documentGroupLoadReviewId};
};
var $author$project$AuditPb$documentGroupLoadReviewIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'documentGroupLoadReviewId',
			A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentGroupLoadReviewId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$DocumentGroupLoadReviewId));
	});
var $author$project$AuditPb$DocumentLoadReferenceMatchReviewId = function (documentLoadReferenceMatchReviewId) {
	return {documentLoadReferenceMatchReviewId: documentLoadReferenceMatchReviewId};
};
var $author$project$AuditPb$documentLoadReferenceMatchReviewIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'documentLoadReferenceMatchReviewId',
			A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentLoadReferenceMatchReviewId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$DocumentLoadReferenceMatchReviewId));
	});
var $author$project$AuditPb$DocumentReviewNone = {};
var $author$project$AuditPb$documentReviewNoneDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$DocumentReviewNone);
	});
var $author$project$AuditPb$DocumentTypeReviewId = function (documentTypeReviewId) {
	return {documentTypeReviewId: documentTypeReviewId};
};
var $author$project$AuditPb$documentTypeReviewIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'documentTypeReviewId',
			A2($elm$json$Json$Decode$map, $author$project$Domain$DocumentTypeReviewId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$DocumentTypeReviewId));
	});
var $author$project$AuditPb$InvoiceAmountReviewId = function (invoiceAmountReviewId) {
	return {invoiceAmountReviewId: invoiceAmountReviewId};
};
var $author$project$AuditPb$invoiceAmountReviewIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'invoiceAmountReviewId',
			A2($elm$json$Json$Decode$map, $author$project$Domain$InvoiceAmountReviewId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$InvoiceAmountReviewId));
	});
var $author$project$AuditPb$InvoiceNumberReviewId = function (invoiceNumberReviewId) {
	return {invoiceNumberReviewId: invoiceNumberReviewId};
};
var $author$project$AuditPb$invoiceNumberReviewIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'invoiceNumberReviewId',
			A2($elm$json$Json$Decode$map, $author$project$Domain$InvoiceNumberReviewId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$InvoiceNumberReviewId));
	});
var $author$project$AuditPb$MultiPageBolReviewId = function (multiPageBolReviewId) {
	return {multiPageBolReviewId: multiPageBolReviewId};
};
var $author$project$AuditPb$multiPageBolReviewIdDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'multiPageBolReviewId',
			A2($elm$json$Json$Decode$map, $author$project$Domain$MultiPageBolReviewId$fromInt, $author$project$AuditPb$intDecoder),
			$author$project$AuditPb$decode($author$project$AuditPb$MultiPageBolReviewId));
	});
var $author$project$AuditPb$documentReviewStartNextResponse_NextReviewDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentTypeReviewId,
					A2($elm$json$Json$Decode$field, 'documentTypeReview', $author$project$AuditPb$documentTypeReviewIdDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_InvoiceNumberReviewId,
					A2($elm$json$Json$Decode$field, 'invoiceNumberReview', $author$project$AuditPb$invoiceNumberReviewIdDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_InvoiceAmountReviewId,
					A2($elm$json$Json$Decode$field, 'invoiceAmountReview', $author$project$AuditPb$invoiceAmountReviewIdDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_MultiPageBolReviewId,
					A2($elm$json$Json$Decode$field, 'multiPageBolReview', $author$project$AuditPb$multiPageBolReviewIdDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentReviewNone,
					A2($elm$json$Json$Decode$field, 'noReview', $author$project$AuditPb$documentReviewNoneDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentLoadReferenceMatchReviewId,
					A2($elm$json$Json$Decode$field, 'documentLoadReferenceMatchReview', $author$project$AuditPb$documentLoadReferenceMatchReviewIdDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentBatchGroupingReviewId,
					A2($elm$json$Json$Decode$field, 'documentBatchGroupingReview', $author$project$AuditPb$documentBatchGroupingReviewIdDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$DocumentReviewStartNextResponse_NextReview_DocumentGroupLoadReviewId,
					A2($elm$json$Json$Decode$field, 'documentGroupLoadReview', $author$project$AuditPb$documentGroupLoadReviewIdDecoder)),
					$elm$json$Json$Decode$fail('DocumentReviewStartNextResponse_NextReview_Unspecified')
				]));
	});
var $author$project$AuditPb$documentReviewStartNextResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$documentReviewStartNextResponse_NextReviewDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$DocumentReviewStartNextResponse));
	});
var $author$project$Api$EmailMessages$findAndStartNextReview = F2(
	function (finishedMsg, emailMessageId) {
		var apiCall = A3(
			$author$project$Helpers$Api$put,
			$author$project$Api$EmailMessages$baseUrl(emailMessageId) + '/find_and_start_next_review',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
					])),
			$author$project$AuditPb$documentReviewStartNextResponseDecoder);
		return A2($author$project$HubTran$Effect$sendCacheableRequestWithError, finishedMsg, apiCall);
	});
var $author$project$Components$DashboardPage$goToReview = function (emailMessageId) {
	return A2($author$project$Api$EmailMessages$findAndStartNextReview, $author$project$Components$DashboardPage$NextReviewRetrieved, emailMessageId);
};
var $author$project$Components$Dashboard$Load$EmailRows$refresh = function (dashboardFilters) {
	return $author$project$HubTran$Effect$refresh(
		A2(
			$author$project$Forward$Lookup$startFrom,
			$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$newEmailIds));
};
var $author$project$Components$Dashboard$Load$ReplyRows$refresh = function (dashboardFilters) {
	return $author$project$HubTran$Effect$refresh(
		A2(
			$author$project$Forward$Lookup$startFrom,
			$author$project$Domain$DashboardFilters$toPb(dashboardFilters),
			$author$project$Forward$AppSpecific$NeedsControllerEndpoints$replyEmailIds));
};
var $author$project$Components$DashboardPage$refreshIds = F3(
	function (v3ReskinEnabled, dashboardMode, dashboardFilters) {
		var filtersFor = function (queue) {
			return A4($author$project$Components$Dashboard$QueueDateInfoHelper$maybeApplyFallbackQueueDatesForDashboardFilters, dashboardMode, queue, dashboardFilters, v3ReskinEnabled);
		};
		var pbFiltersFor = function (queue) {
			return $author$project$Domain$DashboardFilters$toPb(
				filtersFor(queue));
		};
		return $author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$refresh(
					A2(
						$author$project$Forward$Lookup$startFrom,
						pbFiltersFor($author$project$Components$Dashboard$AvailableQueues$ExceptionQueue),
						$author$project$Components$Dashboard$Load$ExceptionedRows$loadIds($author$project$Components$Dashboard$Load$ExceptionedRows$Unsent))),
					$author$project$HubTran$Effect$refresh(
					A2(
						$author$project$Forward$Lookup$startFrom,
						pbFiltersFor($author$project$Components$Dashboard$AvailableQueues$WaitingQueue),
						$author$project$Components$Dashboard$Load$ExceptionedRows$loadIds($author$project$Components$Dashboard$Load$ExceptionedRows$Waiting))),
					$author$project$HubTran$Effect$refresh(
					A2(
						$author$project$Forward$Lookup$startFrom,
						pbFiltersFor($author$project$Components$Dashboard$AvailableQueues$ReadyToAuditQueue),
						$author$project$Components$Dashboard$Load$CarrierInvoiceRows$loadIds)),
					$author$project$HubTran$Effect$refresh(
					$author$project$Components$Dashboard$Review$Model$loadIds(
						filtersFor(
							$author$project$Components$Dashboard$AvailableQueues$FinalQueue($author$project$Components$Dashboard$AvailableQueues$ReviewQueue)))),
					$author$project$HubTran$Effect$refresh(
					A2(
						$author$project$Forward$Lookup$startFrom,
						pbFiltersFor(
							$author$project$Components$Dashboard$AvailableQueues$FinalQueue(
								$author$project$Components$Dashboard$AvailableQueues$ProcessedQueue($author$project$Domain$Account$BrokerAccount))),
						$author$project$Components$Dashboard$Processed$BrokerModel$loadIds)),
					$author$project$HubTran$Effect$refresh(
					A2(
						$author$project$Forward$Lookup$startFrom,
						filtersFor(
							$author$project$Components$Dashboard$AvailableQueues$FinalQueue(
								$author$project$Components$Dashboard$AvailableQueues$ProcessedQueue($author$project$Domain$Account$FactorAccount))),
						$author$project$Components$Dashboard$Processed$FactorModel$loadIds)),
					$author$project$Components$Dashboard$Load$EmailRows$refresh(
					filtersFor($author$project$Components$Dashboard$AvailableQueues$NewQueue)),
					$author$project$Components$Dashboard$Load$EmailRows$refresh(
					filtersFor($author$project$Components$Dashboard$AvailableQueues$FactorNeedsIndexingQueue)),
					$author$project$Components$Dashboard$Load$ReplyRows$refresh(
					filtersFor($author$project$Components$Dashboard$AvailableQueues$RepliesQueue))
				]));
	});
var $author$project$Components$DashboardPage$handleProcessedEffect = F4(
	function (v3ReskinEnabled, dashboardMode, dashboardFilters, processedEffect) {
		if (processedEffect.$ === 'ProcessedEffectNone') {
			return $author$project$HubTran$Effect$none;
		} else {
			return A3($author$project$Components$DashboardPage$refreshIds, v3ReskinEnabled, dashboardMode, dashboardFilters);
		}
	});
var $author$project$Components$DashboardPage$FinishedIgnore = function (a) {
	return {$: 'FinishedIgnore', a: a};
};
var $author$project$Api$CarrierInvoice$ignore = function (factorInvoiceIds) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/carrier_invoices/ignore_many',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
						factorInvoiceIds)),
					_Utils_Tuple2(
					'ignored',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Api$CarrierInvoice$sendIgnoreWithMessage = F2(
	function (finishedMsg, factorInvoiceIds) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			$author$project$Api$CarrierInvoice$ignore(factorInvoiceIds));
	});
var $author$project$Api$EmailMessages$ignore = function (emailMessageIds) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/email_messages/complete_many',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$EmailMessageId$toInt),
						emailMessageIds)),
					_Utils_Tuple2(
					'ignored',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Api$EmailMessages$sendIgnoreWithMessage = F2(
	function (finishedMsg, emailMessageIds) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			$author$project$Api$EmailMessages$ignore(emailMessageIds));
	});
var $author$project$Api$ExceptionedItems$ignore = function (exceptionedItemIds) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/exceptioned_items/complete_many',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$ExceptionedItemId$toInt),
						exceptionedItemIds)),
					_Utils_Tuple2(
					'ignored',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Api$ExceptionedItems$sendIgnoreWithMessage = F2(
	function (finishedMsg, exceptionedItemIds) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			$author$project$Api$ExceptionedItems$ignore(exceptionedItemIds));
	});
var $author$project$Api$FactorInvoice$ignore = function (factorInvoiceIds) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/factor_invoices/ignore_many',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
						factorInvoiceIds)),
					_Utils_Tuple2(
					'ignored',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Api$FactorInvoice$sendIgnoreWithMessage = F2(
	function (finishedMsg, factorInvoiceIds) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			$author$project$Api$FactorInvoice$ignore(factorInvoiceIds));
	});
var $author$project$Components$DashboardPage$ignore = function (ignorables) {
	var toEffect = F2(
		function (apiFunc, list) {
			return $elm$core$List$isEmpty(list) ? $author$project$HubTran$Effect$none : A2(apiFunc, $author$project$Components$DashboardPage$FinishedIgnore, list);
		});
	var lists = $author$project$Components$DashboardPage$ignorableLists(ignorables);
	return $author$project$HubTran$Effect$batch(
		_List_fromArray(
			[
				A2(toEffect, $author$project$Api$EmailMessages$sendIgnoreWithMessage, lists.emailMessageIds),
				A2(toEffect, $author$project$Api$ExceptionedItems$sendIgnoreWithMessage, lists.exceptionedItemIds),
				A2(toEffect, $author$project$Api$CarrierInvoice$sendIgnoreWithMessage, lists.carrierInvoiceIds),
				A2(toEffect, $author$project$Api$FactorInvoice$sendIgnoreWithMessage, lists.factorInvoiceIds)
			]));
};
var $author$project$Components$DashboardSavedFilterEditModal$open = function (filters) {
	return _Utils_update(
		$author$project$Components$DashboardSavedFilterEditModal$closed,
		{dashboardSavedFilters: filters, isOpen: true});
};
var $author$project$Components$DashboardPage$initDashboardSavedFilterEditModal = function (data) {
	var filters = A2(
		$elm$core$List$map,
		function ($) {
			return $.dashboardSavedFilter;
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Forward$Remote$toMaybe(data.dashboardSavedFilters)));
	return $author$project$Components$DashboardSavedFilterEditModal$open(filters);
};
var $author$project$Domain$QueueDate$toLegacyRangeTypeLabel = function (name) {
	switch (name.$) {
		case 'QueueDateDelivered':
			return 'Delivered At';
		case 'QueueDateReceived':
			return 'Created At';
		case 'QueueDateReviewOn':
			return 'Review On';
		case 'QueueDateUnsorted':
			return '';
		case 'QueueDateLastContact':
			return 'Last Contacted At';
		case 'QueueDateEstimatedDue':
			return 'Estimated Due Date';
		case 'QueueDateProcessed':
			return 'Date Processed';
		default:
			return 'Payment date';
	}
};
var $author$project$Components$DashboardPage$legacyDateRangeToItem = function (dateRange) {
	return $author$project$Ui$V3$CustomSelect$simpleItem(
		{
			id: $author$project$Domain$QueueDate$toString(dateRange),
			label: $author$project$Domain$QueueDate$toLegacyRangeTypeLabel(dateRange)
		});
};
var $author$project$Domain$LabelFilter$toMaybeComparable = function (labelFilter) {
	return A2(
		$elm$core$Maybe$map,
		function (stateString) {
			return labelFilter.label + (': ' + stateString);
		},
		$author$project$Domain$LabelFilter$stateAsMaybeString(labelFilter));
};
var $author$project$Domain$LabelFilter$listToComparable = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$sortBy(
		function ($) {
			return $.label;
		}),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filterMap($author$project$Domain$LabelFilter$toMaybeComparable),
		A2($author$project$Helpers$String$toSentence, 'none', ',')));
var $justinmimbs$time_extra$Time$Extra$Parts = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return {day: day, hour: hour, millisecond: millisecond, minute: minute, month: month, second: second, year: year};
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var millisecond = _v0.millisecond;
		var second = _v0.second;
		var minute = _v0.minute;
		var hour = _v0.hour;
		var day = _v0.day;
		var month = _v0.month;
		var year = _v0.year;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Components$DashboardPage$localDateTimeToPosix = F2(
	function (tz, localDateTime) {
		var time = $elm$core$List$tail(
			A2($elm$core$String$split, 'T', localDateTime));
		var timeParts = A2(
			$elm$core$List$map,
			$elm$core$Maybe$withDefault(0),
			A2(
				$elm$core$List$map,
				$elm$core$String$toInt,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$split(':'),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2($elm$core$Maybe$map, $elm$core$List$head, time))))));
		var maybeDate = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Result$toMaybe,
				A2(
					$elm$core$Maybe$map,
					$justinmimbs$date$Date$fromIsoString,
					$elm$core$List$head(
						A2($elm$core$String$split, 'T', localDateTime)))));
		if (maybeDate.$ === 'Just') {
			var date = maybeDate.a;
			if ((timeParts.b && timeParts.b.b) && (!timeParts.b.b.b)) {
				var hour = timeParts.a;
				var _v2 = timeParts.b;
				var minute = _v2.a;
				return $elm$core$Maybe$Just(
					A2(
						$justinmimbs$time_extra$Time$Extra$partsToPosix,
						tz,
						A7(
							$justinmimbs$time_extra$Time$Extra$Parts,
							$justinmimbs$date$Date$year(date),
							$justinmimbs$date$Date$month(date),
							$justinmimbs$date$Date$day(date),
							hour,
							minute,
							0,
							0)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$DashboardPage$FinishedMerge = function (a) {
	return {$: 'FinishedMerge', a: a};
};
var $author$project$Api$EmailMessages$merge = function (emailMessageIds) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/email_messages/merge',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$EmailMessageId$toInt),
						emailMessageIds))
				])));
};
var $author$project$Api$EmailMessages$sendMergeWithMessage = F2(
	function (finishedMsg, emailMessageIds) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			$author$project$Api$EmailMessages$merge(emailMessageIds));
	});
var $author$project$Components$DashboardPage$mergeSelectedEmails = function (selectables) {
	var emailMessageIds = A3(
		$timo_weike$generic_collections$ManualSet$foldl,
		F2(
			function (selectable, acc) {
				if (selectable.$ === 'EmailMessage') {
					var id = selectable.a;
					return A2($elm$core$List$cons, id, acc);
				} else {
					return acc;
				}
			}),
		_List_Nil,
		selectables);
	return A2($author$project$Api$EmailMessages$sendMergeWithMessage, $author$project$Components$DashboardPage$FinishedMerge, emailMessageIds);
};
var $author$project$Components$DashboardSavedFilterSaveModal$open = function (filter) {
	return _Utils_update(
		$author$project$Components$DashboardSavedFilterSaveModal$closed,
		{
			filter: $elm$core$Maybe$Just(filter),
			isOpen: true
		});
};
var $author$project$Components$DashboardPage$DashboardSavedFiltersRefreshed = {$: 'DashboardSavedFiltersRefreshed'};
var $author$project$Components$DashboardPage$refreshDashboardSavedFilters = F3(
	function (apiResult, model, childEffect) {
		if (apiResult.$ === 'Ok') {
			var loadFilters = $author$project$Components$DashboardPage$loadDashboardSavedFilters(model.dashboardMode);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{dashboardSavedFilterRefreshing: true}),
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[
							childEffect,
							$author$project$HubTran$Effect$invalidate(loadFilters),
							A2(
							$author$project$HubTran$Effect$fetchFromCache,
							function (_v1) {
								return $author$project$Components$DashboardPage$DashboardSavedFiltersRefreshed;
							},
							loadFilters)
						])));
		} else {
			return _Utils_Tuple2(model, childEffect);
		}
	});
var $author$project$Domain$Customer$fromStringKey = function (key) {
	var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$Domain$Customer$decoder, key);
	if (_v0.$ === 'Ok') {
		var customer = _v0.a;
		return $elm$core$Maybe$Just(customer);
	} else {
		var err = _v0.a;
		var _v1 = A2(
			$elm$core$Debug$log,
			'Error decoding customer',
			$elm$json$Json$Decode$errorToString(err));
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$CustomerDropdown$selectedIds = function (model) {
	return A2(
		$elm$core$List$filterMap,
		$author$project$Domain$Customer$fromStringKey,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.id;
			},
			$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown)));
};
var $author$project$Components$Dashboard$Review$Model$getMaybeLoadedInvoices = function (_v0) {
	var factorInvoice = _v0.factorInvoice;
	return $author$project$Forward$Remote$toMaybe(factorInvoice);
};
var $author$project$Components$Dashboard$Review$Model$getAllSelectableForGroup = F2(
	function (verifyMode, clientGroup) {
		var selectable = function () {
			if (verifyMode.$ === 'Verify') {
				return clientGroup.verifyingInvoices;
			} else {
				return clientGroup.approvableInvoices;
			}
		}();
		return $author$project$Id$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				A2($elm$core$List$filterMap, $author$project$Components$Dashboard$Review$Model$getMaybeLoadedInvoices, selectable)));
	});
var $author$project$Id$Set$union = F2(
	function (_v0, _v1) {
		var first = _v0.a;
		var second = _v1.a;
		return $author$project$Id$Set$Set(
			A2($elm$core$Set$union, first, second));
	});
var $author$project$Components$Dashboard$Review$Model$getAllSelectable = F2(
	function (verifyMode, clientGroupDict) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Id$Set$union,
			$author$project$Id$Set$empty,
			A2(
				$elm$core$List$map,
				$author$project$Components$Dashboard$Review$Model$getAllSelectableForGroup(verifyMode),
				clientGroupDict));
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$intersect, dict1, dict2));
	});
var $author$project$Id$Set$intersect = F2(
	function (_v0, _v1) {
		var first = _v0.a;
		var second = _v1.a;
		return $author$project$Id$Set$Set(
			A2($elm$core$Set$intersect, first, second));
	});
var $author$project$Components$Dashboard$Review$Model$selectedFactorInvoiceIds = F2(
	function (model, data) {
		var clientGroups = A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$map(
					function ($) {
						return $.clientGroup;
					}),
				$author$project$Forward$Remote$toMaybe),
			$author$project$Pagination$entries(data));
		var allSelectable = A2($author$project$Components$Dashboard$Review$Model$getAllSelectable, model.verifyMode, clientGroups);
		return A2(
			$author$project$Sanitized$sanitize,
			$author$project$Id$Set$intersect(allSelectable),
			model.selectedFactorInvoiceIds);
	});
var $author$project$Components$Dashboard$Review$Model$selectedSelectables = F2(
	function (model, data) {
		return A2(
			$elm$core$List$map,
			$author$project$Domain$FactorInvoice$toSelectable,
			$author$project$Id$Set$toList(
				A2($author$project$Components$Dashboard$Review$Model$selectedFactorInvoiceIds, model, data)));
	});
var $author$project$Api$Users$Encode$setLabelsCollapse = function (shouldCollapse) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'labels_collapsed',
							$elm$json$Json$Encode$bool(shouldCollapse))
						])))
			]));
};
var $author$project$Api$Users$setLabelsCollapse = function (shouldCollapse) {
	return A2(
		$author$project$Helpers$Api$putWithNoResponseBody,
		$author$project$Api$Users$filtersBaseUrl,
		$author$project$Api$Users$Encode$setLabelsCollapse(shouldCollapse));
};
var $author$project$Components$SettingsPage$UserFormData$FeedbackData = F3(
	function (name, emailAddress, emailSignature) {
		return {emailAddress: emailAddress, emailSignature: emailSignature, name: name};
	});
var $author$project$Api$Users$Decode$feedbackDecoderHelper = function (fieldName) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Result$Err,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$string),
					A2(
					$elm$json$Json$Decode$field,
					fieldName,
					A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string))
				])));
};
var $author$project$Api$Users$Decode$feedbackDecoder = function (fieldName) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(
			$elm$core$Result$Ok(_Utils_Tuple0)),
		$elm$json$Json$Decode$maybe(
			$author$project$Api$Users$Decode$feedbackDecoderHelper(fieldName)));
};
var $author$project$Api$Users$Decode$errors = A2(
	$elm$json$Json$Decode$field,
	'errors',
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Components$SettingsPage$UserFormData$FeedbackData,
		$author$project$Api$Users$Decode$feedbackDecoder('name'),
		$author$project$Api$Users$Decode$feedbackDecoder('email'),
		$elm$json$Json$Decode$succeed(
			$elm$core$Result$Ok(_Utils_Tuple0))));
var $author$project$Domain$LabelFilter$stateAsMaybeBoolString = function (labelFilter) {
	var _v0 = labelFilter.state;
	switch (_v0.$) {
		case 'Unselected':
			return $elm$core$Maybe$Nothing;
		case 'Selected':
			return $elm$core$Maybe$Just('true');
		default:
			return $elm$core$Maybe$Just('false');
	}
};
var $author$project$Api$Users$Encode$toLabelFilterTuple = function (labelFilter) {
	return A2(
		$elm$core$Maybe$map,
		function (stateBoolString) {
			return _Utils_Tuple2(
				labelFilter.label,
				$elm$json$Json$Encode$string(stateBoolString));
		},
		$author$project$Domain$LabelFilter$stateAsMaybeBoolString(labelFilter));
};
var $author$project$Api$Users$Encode$preferredFilters = F2(
	function (labelFilters_, categories) {
		var labelFilterTuples = A2($elm$core$List$filterMap, $author$project$Api$Users$Encode$toLabelFilterTuple, labelFilters_);
		var labelFiltersObject = function () {
			if (!labelFilterTuples.b) {
				return $elm$json$Json$Encode$null;
			} else {
				return $elm$json$Json$Encode$object(labelFilterTuples);
			}
		}();
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('preferred_filter', labelFiltersObject),
								_Utils_Tuple2(
								'preferred_category_filters',
								$author$project$Domain$CategoryFilter$filteredCategoryEncoder(categories))
							])))
				]));
	});
var $author$project$Helpers$Api$putWithCustomErrors = F4(
	function (url, json, decoder, decodeErrors) {
		return A2(
			$author$project$Forward$CacheableRequest$cacheableRequestWithErrorData,
			{
				body: $elm$core$Maybe$Just(json),
				decoder: decoder,
				errorDecoder: function (_v0) {
					return decodeErrors;
				},
				headers: _List_Nil,
				method: 'PUT',
				timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
				url: url
			},
			$elm$core$Basics$identity);
	});
var $author$project$Api$Users$Decode$userForm = A2($elm$json$Json$Decode$field, 'userV2', $author$project$Domain$User$decode);
var $author$project$Api$Users$setPreferredFilters = F2(
	function (labelFilters, categories) {
		return A4(
			$author$project$Helpers$Api$putWithCustomErrors,
			$author$project$Api$Users$filtersBaseUrl,
			A2($author$project$Api$Users$Encode$preferredFilters, labelFilters, categories),
			$author$project$Api$Users$Decode$userForm,
			$author$project$Api$Users$Decode$errors);
	});
var $author$project$Ui$V3$CustomSelect$setSelectedItems = F2(
	function (items, _v0) {
		var model = _v0.a;
		return $author$project$Ui$V3$CustomSelect$Model(
			_Utils_update(
				model,
				{selectedItems: items}));
	});
var $author$project$Id$Set$insert = F2(
	function (id, _v0) {
		var set = _v0.a;
		return $author$project$Id$Set$Set(
			A2(
				$elm$core$Set$insert,
				$author$project$Id$toInt(id),
				set));
	});
var $author$project$Id$Set$remove = F2(
	function (id, _v0) {
		var set = _v0.a;
		return $author$project$Id$Set$Set(
			A2(
				$elm$core$Set$remove,
				$author$project$Id$toInt(id),
				set));
	});
var $author$project$Components$Dashboard$Processed$BrokerModel$setSelected = F3(
	function (carrierInvoiceId, selected, _v0) {
		var model = _v0.a;
		return $author$project$Components$Dashboard$Processed$BrokerModel$BrokerModel(
			_Utils_update(
				model,
				{
					selected: selected ? A2($author$project$Id$Set$insert, carrierInvoiceId, model.selected) : A2($author$project$Id$Set$remove, carrierInvoiceId, model.selected)
				}));
	});
var $author$project$Components$Dashboard$Processed$BrokerModel$setSelection = F3(
	function (bool, ids, model) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (id, newModel) {
					return A3($author$project$Components$Dashboard$Processed$BrokerModel$setSelected, id, bool, newModel);
				}),
			model,
			ids);
	});
var $author$project$Domain$DashboardFilters$setSortBy = F2(
	function (dashboardSortBy, dashboardFilters) {
		return _Utils_update(
			dashboardFilters,
			{dashboardSortBy: dashboardSortBy});
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $timo_weike$generic_collections$ManualSet$size = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$size(dict);
};
var $author$project$Components$DashboardPage$FinishSkipAsynchronousEmailReview = F4(
	function (a, b, c, d) {
		return {$: 'FinishSkipAsynchronousEmailReview', a: a, b: b, c: c, d: d};
	});
var $author$project$Api$EmailMessages$skipDocumentBatchGroupingReview = F2(
	function (finishedMsg, emailMessageId) {
		var apiCall = A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$EmailMessages$baseUrl(emailMessageId) + '/skip_document_batch_grouping_review',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
					])));
		return A2($author$project$HubTran$Effect$sendCacheableRequestWithError, finishedMsg, apiCall);
	});
var $author$project$Api$EmailMessages$skipDocumentContentReview = F2(
	function (finishedMsg, emailMessageId) {
		var apiCall = A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$EmailMessages$baseUrl(emailMessageId) + '/skip_document_content_review',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
					])));
		return A2($author$project$HubTran$Effect$sendCacheableRequestWithError, finishedMsg, apiCall);
	});
var $author$project$Api$EmailMessages$skipDocumentContentReviewDocumentType = F2(
	function (finishedMsg, emailMessageId) {
		var apiCall = A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$EmailMessages$baseUrl(emailMessageId) + '/skip_document_content_review_document_type',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
					])));
		return A2($author$project$HubTran$Effect$sendCacheableRequestWithError, finishedMsg, apiCall);
	});
var $author$project$Api$EmailMessages$skipDocumentContentReviewNoDependents = F2(
	function (finishedMsg, emailMessageId) {
		var apiCall = A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$EmailMessages$baseUrl(emailMessageId) + '/skip_document_content_review_no_dependents',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
					])));
		return A2($author$project$HubTran$Effect$sendCacheableRequestWithError, finishedMsg, apiCall);
	});
var $author$project$Api$EmailMessages$skipDocumentGroupLoadReviews = F2(
	function (finishedMsg, emailMessageId) {
		var apiCall = A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$EmailMessages$baseUrl(emailMessageId) + '/skip_document_group_load_reviews',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
					])));
		return A2($author$project$HubTran$Effect$sendCacheableRequestWithError, finishedMsg, apiCall);
	});
var $author$project$Api$EmailMessages$skipPodReview = F2(
	function (finishedMsg, emailMessageId) {
		var apiCall = A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$EmailMessages$baseUrl(emailMessageId) + '/skip_pod_review',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
					])));
		return A2($author$project$HubTran$Effect$sendCacheableRequestWithError, finishedMsg, apiCall);
	});
var $author$project$Components$DashboardPage$skipAsynchronousEmailReview = F3(
	function (emailMessageId, documentBatchId, reviewType) {
		var skipFunction = function () {
			switch (reviewType.$) {
				case 'PodReview':
					return $author$project$Api$EmailMessages$skipPodReview;
				case 'DocumentContentReview':
					return $author$project$Api$EmailMessages$skipDocumentContentReview;
				case 'DocumentContentReviewDocumentType':
					return $author$project$Api$EmailMessages$skipDocumentContentReviewDocumentType;
				case 'DocumentContentReviewNoDependents':
					return $author$project$Api$EmailMessages$skipDocumentContentReviewNoDependents;
				case 'DocumentBatchGroupingReview':
					return $author$project$Api$EmailMessages$skipDocumentBatchGroupingReview;
				default:
					return $author$project$Api$EmailMessages$skipDocumentGroupLoadReviews;
			}
		}();
		return $author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					A2(
					skipFunction,
					A3($author$project$Components$DashboardPage$FinishSkipAsynchronousEmailReview, emailMessageId, documentBatchId, reviewType),
					emailMessageId)
				]));
	});
var $author$project$Components$DashboardPage$toggleSelection = F2(
	function (selections, newSelection) {
		var isSelected = A3($timo_weike$generic_collections$ManualSet$member, $author$project$Components$Dashboard$Pager$Selectable$toComparable, newSelection, selections);
		return isSelected ? A3($timo_weike$generic_collections$ManualSet$remove, $author$project$Components$Dashboard$Pager$Selectable$toComparable, newSelection, selections) : A3($timo_weike$generic_collections$ManualSet$insert, $author$project$Components$Dashboard$Pager$Selectable$toComparable, newSelection, selections);
	});
var $author$project$Domain$Customer$fromTmsCustomer = function (tmsCustomer) {
	return {
		externalId: $elm$core$Maybe$Just(tmsCustomer.externalId),
		name: tmsCustomer.name
	};
};
var $author$project$Components$CustomerDropdown$tmsCustomerToDropdownItem = function (tmsCustomer) {
	return $author$project$Components$CustomerDropdown$customerToDropdownItem(
		$author$project$Domain$Customer$fromTmsCustomer(tmsCustomer));
};
var $author$project$Components$CustomerDropdown$update = F3(
	function (data, msg, model) {
		var _v0 = A4($author$project$Components$PaginatedDropdown$update, $author$project$Components$CustomerDropdown$tmsCustomerToDropdownItem, data, msg, model.dropdown);
		var newDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: newDropdown}),
			cmd);
	});
var $author$project$Components$Dashboard$FilterBar$LabelFilters$NoOp = {$: 'NoOp'};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$ToggledCollapse = {$: 'ToggledCollapse'};
var $author$project$Domain$LabelFilter$toggleState = function (state) {
	switch (state.$) {
		case 'Unselected':
			return $author$project$Domain$LabelFilter$Selected;
		case 'Selected':
			return $author$project$Domain$LabelFilter$Negated;
		default:
			return $author$project$Domain$LabelFilter$Unselected;
	}
};
var $author$project$Domain$LabelFilter$toggle = function (labelFilter) {
	return _Utils_update(
		labelFilter,
		{
			state: $author$project$Domain$LabelFilter$toggleState(labelFilter.state)
		});
};
var $author$project$Helpers$List$updateMember = F3(
	function (existingValue, newValue, list) {
		return A2(
			$elm$core$List$map,
			function (value) {
				return _Utils_eq(value, existingValue) ? newValue : value;
			},
			list);
	});
var $author$project$Components$Dashboard$FilterBar$LabelFilters$update = F2(
	function (msg, labelFilters) {
		switch (msg.$) {
			case 'ToggleLabelFilter':
				var labelFilter = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Helpers$List$updateMember,
						labelFilter,
						$author$project$Domain$LabelFilter$toggle(labelFilter),
						labelFilters),
					$author$project$Components$Dashboard$FilterBar$LabelFilters$NoOp);
			case 'ClickedAll':
				return _Utils_Tuple2(
					A2($elm$core$List$map, $author$project$Domain$LabelFilter$unselect, labelFilters),
					$author$project$Components$Dashboard$FilterBar$LabelFilters$NoOp);
			default:
				return _Utils_Tuple2(labelFilters, $author$project$Components$Dashboard$FilterBar$LabelFilters$ToggledCollapse);
		}
	});
var $author$project$Components$DashboardSavedFilterEditModal$DeleteClickFinished = function (a) {
	return {$: 'DeleteClickFinished', a: a};
};
var $author$project$Components$DashboardSavedFilterEditModal$SaveFinished = function (a) {
	return {$: 'SaveFinished', a: a};
};
var $author$project$Components$DashboardSavedFilterEditModal$SetDefaultFinished = function (a) {
	return {$: 'SetDefaultFinished', a: a};
};
var $author$project$Helpers$Api$delete = function (url) {
	return A2(
		$author$project$Forward$CacheableRequest$requestWithIgnoredResponseBody,
		{
			body: $elm$core$Maybe$Nothing,
			errorDecoder: $author$project$Helpers$Api$standardErrorDecoder,
			headers: _List_Nil,
			method: 'DELETE',
			timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
			url: url
		},
		$elm$core$Basics$identity);
};
var $author$project$Api$DashboardSavedFilters$collectionUrl = '/api/dashboard_saved_filters';
var $author$project$Domain$DashboardSavedFilterId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Api$DashboardSavedFilters$resourceUrl = function (id) {
	return $author$project$Api$DashboardSavedFilters$collectionUrl + ('/' + $author$project$Domain$DashboardSavedFilterId$toString(id));
};
var $author$project$Api$DashboardSavedFilters$delete = function (id) {
	return $author$project$Helpers$Api$delete(
		$author$project$Api$DashboardSavedFilters$resourceUrl(id));
};
var $author$project$Domain$DashboardSavedFilterId$toComparable = function (id) {
	return _Utils_Tuple2(
		'dashboardSavedFilterId',
		$author$project$Domain$DashboardSavedFilterId$toInt(id));
};
var $author$project$Components$DashboardSavedFilterEditModal$idsMatch = F2(
	function (filter1, filter2) {
		return _Utils_eq(
			$author$project$Domain$DashboardSavedFilterId$toComparable(filter1.id),
			$author$project$Domain$DashboardSavedFilterId$toComparable(filter2.id));
	});
var $author$project$Api$DashboardSavedFilters$encode = function (savedFilter) {
	var sanitizeTupleKeys = function (key) {
		switch (key) {
			case 'dashboardMode':
				return 'dashboard_mode';
			case 'startDate':
				return 'start_date';
			case 'startDateTime':
				return 'start_datetime';
			case 'endDate':
				return 'end_date';
			case 'endDateTime':
				return 'end_datetime';
			case 'rangeType':
				return 'range_type';
			case 'sortBy':
				return 'sort_by';
			case 'timezoneName':
				return 'timezone_name';
			case 'categories':
				return 'category_filters';
			default:
				return key;
		}
	};
	var sanitizedFilterTuples = A2(
		$elm$core$List$map,
		function (_v0) {
			var k = _v0.a;
			var v = _v0.b;
			return _Utils_Tuple2(
				sanitizeTupleKeys(k),
				v);
		},
		$author$project$Domain$DashboardFilters$encodedTuples(
			$author$project$Domain$DashboardFilters$fromPb(savedFilter.filter)));
	var encodedAttributes = $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$append,
			sanitizedFilterTuples,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(savedFilter.name)),
					_Utils_Tuple2(
					'is_default',
					$elm$json$Json$Encode$bool(savedFilter.isDefault))
				])));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('dashboard_saved_filter', encodedAttributes)
			]));
};
var $author$project$Api$DashboardSavedFilters$update = function (filter) {
	return A2(
		$author$project$Helpers$Api$putWithNoResponseBody,
		$author$project$Api$DashboardSavedFilters$resourceUrl(filter.id),
		$author$project$Api$DashboardSavedFilters$encode(filter));
};
var $author$project$Components$DashboardSavedFilterEditModal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'Close':
				return _Utils_Tuple2($author$project$Components$DashboardSavedFilterEditModal$closed, $author$project$HubTran$Effect$none);
			case 'StartEditing':
				var filter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editingFilter: $elm$core$Maybe$Just(filter),
							onSaveErrorMessage: ''
						}),
					$author$project$HubTran$Effect$none);
			case 'CancelEditing':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editingFilter: $elm$core$Maybe$Nothing, onSaveErrorMessage: ''}),
					$author$project$HubTran$Effect$none);
			case 'DeleteClicked':
				var filter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$DashboardSavedFilterEditModal$DeleteClickFinished,
						$author$project$Api$DashboardSavedFilters$delete(filter.id)));
			case 'DeleteClickFinished':
				var apiResult = msg.a;
				if (apiResult.$ === 'Ok') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isSaving: false}),
						$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
				}
			case 'SetName':
				var newName = msg.a;
				var _v2 = model.editingFilter;
				if (_v2.$ === 'Just') {
					var filter = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								editingFilter: $elm$core$Maybe$Just(
									_Utils_update(
										filter,
										{name: newName}))
							}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'SetDefaultClicked':
				var filter = msg.a;
				var newIsDefault = !filter.isDefault;
				var updatedFilter = _Utils_update(
					filter,
					{isDefault: newIsDefault});
				var updatedFilters = A2(
					$elm$core$List$map,
					function (f) {
						return A2($author$project$Components$DashboardSavedFilterEditModal$idsMatch, f, filter) ? updatedFilter : ((newIsDefault && _Utils_eq(f.dashboardMode, filter.dashboardMode)) ? _Utils_update(
							f,
							{isDefault: false}) : f);
					},
					model.dashboardSavedFilters);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dashboardSavedFilters: updatedFilters, isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$DashboardSavedFilterEditModal$SetDefaultFinished,
						$author$project$Api$DashboardSavedFilters$update(updatedFilter)));
			case 'SetDefaultFinished':
				var apiResult = msg.a;
				if (apiResult.$ === 'Ok') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isSaving: false}),
						$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
				}
			case 'Saving':
				var _v4 = model.editingFilter;
				if (_v4.$ === 'Just') {
					var filter = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isSaving: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DashboardSavedFilterEditModal$SaveFinished,
							$author$project$Api$DashboardSavedFilters$update(filter)));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			default:
				var apiResult = msg.a;
				switch (apiResult.$) {
					case 'Ok':
						return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					case 'Err':
						var message = apiResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false, onSaveErrorMessage: message}),
							$author$project$HubTran$Effect$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false, onSaveErrorMessage: 'Save failed. Please try again later.'}),
							$author$project$HubTran$Effect$none);
				}
		}
	});
var $author$project$Components$DashboardSavedFilterSaveModal$SaveFinished = function (a) {
	return {$: 'SaveFinished', a: a};
};
var $author$project$Api$DashboardSavedFilters$create = function (filter) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		$author$project$Api$DashboardSavedFilters$collectionUrl,
		$author$project$Api$DashboardSavedFilters$encode(filter));
};
var $author$project$Components$DashboardSavedFilterSaveModal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'Close':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filter: $elm$core$Maybe$Nothing, isOpen: false}),
					$author$project$HubTran$Effect$none);
			case 'SaveStarted':
				var _v1 = model.filter;
				if (_v1.$ === 'Just') {
					var filter = _v1.a;
					var newFilter = _Utils_update(
						filter,
						{name: model.name});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								filter: $elm$core$Maybe$Just(newFilter),
								isSaving: true
							}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$DashboardSavedFilterSaveModal$SaveFinished,
							$author$project$Api$DashboardSavedFilters$create(newFilter)));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'SaveFinished':
				var apiResult = msg.a;
				switch (apiResult.$) {
					case 'Ok':
						return _Utils_Tuple2($author$project$Components$DashboardSavedFilterSaveModal$closed, $author$project$HubTran$Effect$none);
					case 'Err':
						var message = apiResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{errorMessage: message, isSaving: false}),
							$author$project$HubTran$Effect$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{errorMessage: 'Save failed. Please try again later.', isSaving: false}),
							$author$project$HubTran$Effect$none);
				}
			default:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{name: str}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$DashboardPresence$IdPath = F2(
	function (id, pathname) {
		return {id: id, pathname: pathname};
	});
var $author$project$DashboardPresence$getDocumentBatchIdPath = function (p) {
	var id_ = function () {
		var _v0 = p.path;
		switch (_v0.$) {
			case 'DocumentBatchPath':
				var id = _v0.a;
				return $elm$core$Maybe$Just(id);
			case 'DocumentBatchWithLoadAndInvoicePath':
				var id = _v0.a;
				return $elm$core$Maybe$Just(id);
			case 'NonInvoiceConfirmPath':
				var id = _v0.a;
				return $elm$core$Maybe$Just(id);
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	return A2(
		$elm$core$Maybe$map,
		function (id) {
			return A2($author$project$DashboardPresence$IdPath, id, p.pathname);
		},
		id_);
};
var $author$project$DashboardPresence$getEmailMessageIdPath = function (p) {
	var emailMessageId_ = function () {
		var _v0 = p.path;
		switch (_v0.$) {
			case 'ClientSubmissionPath':
				var emailMessageId = _v0.a;
				return $elm$core$Maybe$Just(emailMessageId);
			case 'ClientSubmissionInvoicePath':
				var emailMessageId = _v0.a;
				return $elm$core$Maybe$Just(emailMessageId);
			case 'DocumentBatchPath':
				var emailMessageId = _v0.b;
				return emailMessageId;
			case 'EmailPath':
				var emailMessageId = _v0.a;
				return $elm$core$Maybe$Just(emailMessageId);
			case 'DocumentBatchWithLoadAndInvoicePath':
				var emailMessageId = _v0.b;
				return emailMessageId;
			case 'NonInvoiceConfirmPath':
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	return A2(
		$elm$core$Maybe$map,
		function (id) {
			return A2($author$project$DashboardPresence$IdPath, id, p.pathname);
		},
		emailMessageId_);
};
var $author$project$Id$Dict$update = F3(
	function (id, fn, _v0) {
		var dict = _v0.a;
		return $author$project$Id$Dict$Dict(
			A3(
				$elm$core$Dict$update,
				$author$project$Id$toInt(id),
				fn,
				dict));
	});
var $author$project$DashboardPresence$addPathById = F2(
	function (idPath, acc) {
		var id = idPath.id;
		var ogPaths = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($author$project$Id$Dict$get, id, acc));
		var paths = A2($elm$core$List$member, idPath.pathname, ogPaths) ? ogPaths : A2($elm$core$List$cons, idPath.pathname, ogPaths);
		return A3(
			$author$project$Id$Dict$update,
			id,
			function (_v0) {
				return $elm$core$Maybe$Just(paths);
			},
			acc);
	});
var $author$project$DashboardPresence$groupById = function (idPaths) {
	return A3($elm$core$List$foldl, $author$project$DashboardPresence$addPathById, $author$project$Id$Dict$empty, idPaths);
};
var $author$project$DashboardPresence$maybeAddApp = function (string) {
	return A2($elm$core$String$startsWith, '/app', string) ? string : ('/app' + string);
};
var $author$project$DashboardPresence$ParsedPath = F2(
	function (path, pathname) {
		return {path: path, pathname: pathname};
	});
var $author$project$DashboardPresence$ClientSubmissionInvoicePath = function (a) {
	return {$: 'ClientSubmissionInvoicePath', a: a};
};
var $author$project$DashboardPresence$ClientSubmissionPath = function (a) {
	return {$: 'ClientSubmissionPath', a: a};
};
var $author$project$DashboardPresence$EmailPath = function (a) {
	return {$: 'EmailPath', a: a};
};
var $author$project$DashboardPresence$VerificationBatchPath = {$: 'VerificationBatchPath'};
var $author$project$DashboardPresence$email = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('email'),
	A2($elm$url$Url$Parser$map, $author$project$Domain$EmailMessageId$fromInt, $elm$url$Url$Parser$int));
var $author$project$DashboardPresence$clientSubmissionEmail = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('client_submission'),
	$author$project$DashboardPresence$email);
var $author$project$DashboardPresence$DocumentBatchPath = F2(
	function (a, b) {
		return {$: 'DocumentBatchPath', a: a, b: b};
	});
var $author$project$DashboardPresence$toDocumentBatchPath = F2(
	function (batchId, emailId) {
		var maybeEmailId = function () {
			if (emailId.$ === 'Just') {
				var x = emailId.a;
				return $elm$core$Maybe$Just(
					$author$project$Domain$EmailMessageId$fromInt(x));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$author$project$DashboardPresence$DocumentBatchPath,
			$author$project$Domain$DocumentBatchId$fromInt(batchId),
			maybeEmailId);
	});
var $author$project$DashboardPresence$documentBatchEmail = A2(
	$elm$url$Url$Parser$map,
	$author$project$DashboardPresence$toDocumentBatchPath,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('index-document-batches'),
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$int,
			$elm$url$Url$Parser$Query$int('emailId'))));
var $author$project$DashboardPresence$documentBatch = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('index-document-batches'),
	$elm$url$Url$Parser$int);
var $author$project$DashboardPresence$documentBatchWithLoad = A2(
	$elm$url$Url$Parser$slash,
	$author$project$DashboardPresence$documentBatch,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('loads'),
		$elm$url$Url$Parser$int));
var $author$project$DashboardPresence$DocumentBatchWithLoadAndInvoicePath = F2(
	function (a, b) {
		return {$: 'DocumentBatchWithLoadAndInvoicePath', a: a, b: b};
	});
var $author$project$DashboardPresence$toDocumentBatchWithLoadAndInvoicePath = F4(
	function (batchId, _v0, _v1, emailId) {
		var maybeEmailId = function () {
			if (emailId.$ === 'Just') {
				var x = emailId.a;
				return $elm$core$Maybe$Just(
					$author$project$Domain$EmailMessageId$fromInt(x));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$author$project$DashboardPresence$DocumentBatchWithLoadAndInvoicePath,
			$author$project$Domain$DocumentBatchId$fromInt(batchId),
			maybeEmailId);
	});
var $author$project$DashboardPresence$documentBatchWithLoadAndInvoice = A2(
	$elm$url$Url$Parser$map,
	$author$project$DashboardPresence$toDocumentBatchWithLoadAndInvoicePath,
	A2(
		$elm$url$Url$Parser$slash,
		$author$project$DashboardPresence$documentBatchWithLoad,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('carrier_invoices'),
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$int,
				$elm$url$Url$Parser$Query$int('emailId')))));
var $author$project$DashboardPresence$factorInvoiceAuditBatch = A2(
	$elm$url$Url$Parser$map,
	$author$project$DashboardPresence$toDocumentBatchPath,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('factor_invoices_workflow'),
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('batch'),
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$int,
				$elm$url$Url$Parser$Query$int('emailId')))));
var $author$project$DashboardPresence$NonInvoiceConfirmPath = function (a) {
	return {$: 'NonInvoiceConfirmPath', a: a};
};
var $author$project$DashboardPresence$toNonInvoiceConfirmPath = F2(
	function (batchId, _v0) {
		return $author$project$DashboardPresence$NonInvoiceConfirmPath(
			$author$project$Domain$DocumentBatchId$fromInt(batchId));
	});
var $author$project$DashboardPresence$nonInvoiceConfirm = A2(
	$elm$url$Url$Parser$map,
	$author$project$DashboardPresence$toNonInvoiceConfirmPath,
	A2(
		$elm$url$Url$Parser$slash,
		$author$project$DashboardPresence$documentBatchWithLoad,
		$elm$url$Url$Parser$s('confirm')));
var $author$project$DashboardPresence$verificationBatch = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('verification_batch'),
	A2($elm$url$Url$Parser$map, $author$project$Domain$VerificationsDebtorBatchId$fromInt, $elm$url$Url$Parser$int));
var $author$project$DashboardPresence$pathParser = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('app'),
	$elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$DashboardPresence$documentBatchEmail,
				$author$project$DashboardPresence$documentBatchWithLoadAndInvoice,
				$author$project$DashboardPresence$nonInvoiceConfirm,
				$author$project$DashboardPresence$factorInvoiceAuditBatch,
				A2($elm$url$Url$Parser$map, $author$project$DashboardPresence$ClientSubmissionPath, $author$project$DashboardPresence$clientSubmissionEmail),
				A2($elm$url$Url$Parser$map, $author$project$DashboardPresence$EmailPath, $author$project$DashboardPresence$email),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$DashboardPresence$ClientSubmissionPath,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$DashboardPresence$clientSubmissionEmail,
					$elm$url$Url$Parser$s('review'))),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (emailId, _v0) {
						return $author$project$DashboardPresence$ClientSubmissionInvoicePath(emailId);
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$DashboardPresence$clientSubmissionEmail,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('invoice'),
						$elm$url$Url$Parser$int))),
				A2(
				$elm$url$Url$Parser$map,
				function (_v1) {
					return $author$project$DashboardPresence$VerificationBatchPath;
				},
				$author$project$DashboardPresence$verificationBatch)
			])));
var $author$project$DashboardPresence$stringWithoutQuery = function (string) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, '?', string)));
};
var $author$project$DashboardPresence$parsePossiblePath = function (pathnameWithSearch) {
	var splits = A2($elm$core$String$split, '?', pathnameWithSearch);
	var listHelper = function (maybeList) {
		if (maybeList.$ === 'Just') {
			var x = maybeList.a;
			return x;
		} else {
			return _List_Nil;
		}
	};
	var search = $elm$core$List$head(
		listHelper(
			$elm$core$List$tail(splits)));
	var loc = {
		fragment: $elm$core$Maybe$Nothing,
		host: '',
		path: A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(splits)),
		port_: $elm$core$Maybe$Nothing,
		protocol: $elm$url$Url$Https,
		query: search
	};
	var parsedPath = A2($elm$url$Url$Parser$parse, $author$project$DashboardPresence$pathParser, loc);
	if (parsedPath.$ === 'Just') {
		var path = parsedPath.a;
		return $elm$core$Maybe$Just(
			A2(
				$author$project$DashboardPresence$ParsedPath,
				path,
				$author$project$DashboardPresence$stringWithoutQuery(pathnameWithSearch)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DashboardPresence$update = function (msg) {
	var incomingPresenceData = msg.a;
	var presenceByPath = $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (data) {
				return _Utils_Tuple2(
					$author$project$DashboardPresence$maybeAddApp(
						$author$project$DashboardPresence$stringWithoutQuery(data.path)),
					data.others);
			},
			incomingPresenceData));
	var parsedPaths = A2(
		$elm$core$List$filterMap,
		function (data) {
			return $author$project$DashboardPresence$parsePossiblePath(
				$author$project$DashboardPresence$maybeAddApp(data.path));
		},
		incomingPresenceData);
	var pathsByDocumentBatchId = $author$project$DashboardPresence$groupById(
		A2($elm$core$List$filterMap, $author$project$DashboardPresence$getDocumentBatchIdPath, parsedPaths));
	var pathsByEmailMessageId = $author$project$DashboardPresence$groupById(
		A2($elm$core$List$filterMap, $author$project$DashboardPresence$getEmailMessageIdPath, parsedPaths));
	var carriersPresent = A2(
		$elm$core$List$filterMap,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$map($author$project$Domain$TmsCarrierId$fromInt),
			function ($) {
				return $.carrier;
			}),
		incomingPresenceData);
	return {carriersPresent: carriersPresent, pathsByDocumentBatchId: pathsByDocumentBatchId, pathsByEmailMessageId: pathsByEmailMessageId, presenceByPath: presenceByPath, receivedData: true};
};
var $author$project$Components$DashboardPage$updateBulkLabelModal = F2(
	function (fn, model) {
		return _Utils_update(
			model,
			{
				bulkLabelModal: fn(model.bulkLabelModal)
			});
	});
var $author$project$Components$DashboardPage$updateIgnoreModal = F2(
	function (fn, model) {
		return _Utils_update(
			model,
			{
				ignoreModal: fn(model.ignoreModal)
			});
	});
var $author$project$Components$DashboardPage$updateMergeModal = F2(
	function (fn, model) {
		return _Utils_update(
			model,
			{
				mergeModal: fn(model.mergeModal)
			});
	});
var $author$project$Components$DashboardPage$ProcessedCarrierInvoicesUpdated = function (a) {
	return {$: 'ProcessedCarrierInvoicesUpdated', a: a};
};
var $author$project$Components$DashboardPage$ProcessedEffectNone = {$: 'ProcessedEffectNone'};
var $author$project$Components$DashboardPage$ProcessedEffectRefreshIds = {$: 'ProcessedEffectRefreshIds'};
var $author$project$Api$CarrierInvoices$Decode$carrierInvoiceIds = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Result$Ok,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['cacheable', 'carrierInvoices']),
				$elm$json$Json$Decode$list(
					A2($elm$json$Json$Decode$index, 0, $author$project$Domain$CarrierInvoiceId$decode)))),
			$elm$json$Json$Decode$succeed(
			$elm$core$Result$Err(_Utils_Tuple0))
		]));
var $author$project$Api$CarrierInvoices$Encode$carrierInvoiceIds = function (invoiceIds) {
	var idToJsonString = A2(
		$elm$core$Basics$composeR,
		$author$project$Domain$CarrierInvoiceId$toInt,
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$json$Json$Encode$string));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'carrier_invoices',
				A2($elm$json$Json$Encode$list, idToJsonString, invoiceIds))
			]));
};
var $author$project$Helpers$Api$post = F3(
	function (url, json, decoder) {
		return A2(
			$author$project$Forward$CacheableRequest$cacheableRequestWithErrorData,
			{
				body: $elm$core$Maybe$Just(json),
				decoder: decoder,
				errorDecoder: $author$project$Helpers$Api$standardErrorDecoder,
				headers: _List_Nil,
				method: 'POST',
				timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
				url: url
			},
			$elm$core$Basics$identity);
	});
var $author$project$Api$CarrierInvoice$batchApprove = function (invoiceIds) {
	return A3(
		$author$project$Helpers$Api$post,
		'/api/accounts_payable/carrier_invoices/approve',
		$author$project$Api$CarrierInvoices$Encode$carrierInvoiceIds(invoiceIds),
		$author$project$Api$CarrierInvoices$Decode$carrierInvoiceIds);
};
var $author$project$Components$Dashboard$Processed$ProcessedModel$initErroredSendingState = _Utils_update(
	$author$project$Components$Dashboard$Processed$ProcessedModel$initSendingState,
	{isErrored: true});
var $author$project$Components$Dashboard$Processed$BrokerModel$selectedBrokerInvoiceIds = function (_v0) {
	var model = _v0.a;
	return $author$project$Id$Set$toList(model.selected);
};
var $author$project$Components$Dashboard$Processed$BrokerModel$toggleSelected = F2(
	function (carrierInvoiceId, _v0) {
		var model = _v0.a;
		var wasSelected = A2($author$project$Id$Set$member, carrierInvoiceId, model.selected);
		return A3(
			$author$project$Components$Dashboard$Processed$BrokerModel$setSelected,
			carrierInvoiceId,
			!wasSelected,
			$author$project$Components$Dashboard$Processed$BrokerModel$BrokerModel(model));
	});
var $author$project$Components$DashboardPage$updateProcessedBroker = F3(
	function (sendingState, brokerModel, msg) {
		switch (msg.$) {
			case 'ProcessedBrokerActionAreaMsg':
				switch (msg.a.$) {
					case 'BrokerApprove':
						var _v1 = msg.a;
						var apiRequest = $author$project$Api$CarrierInvoice$batchApprove(
							$author$project$Components$Dashboard$Processed$BrokerModel$selectedBrokerInvoiceIds(brokerModel));
						return {
							effect: A2($author$project$HubTran$Effect$sendCacheableRequestWithError, $author$project$Components$DashboardPage$ProcessedCarrierInvoicesUpdated, apiRequest),
							newBrokerModel: $author$project$Components$Dashboard$Processed$BrokerModel$clearSelection(brokerModel),
							newSendingState: _Utils_update(
								sendingState,
								{isProcessingApproval: true}),
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
					case 'BrokerSelectAll':
						var carrierInvoiceIds = msg.a.a;
						return {
							effect: $author$project$HubTran$Effect$none,
							newBrokerModel: A3($author$project$Components$Dashboard$Processed$BrokerModel$setSelection, true, carrierInvoiceIds, brokerModel),
							newSendingState: sendingState,
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
					default:
						var _v2 = msg.a;
						return {
							effect: $author$project$HubTran$Effect$none,
							newBrokerModel: $author$project$Components$Dashboard$Processed$BrokerModel$clearSelection(brokerModel),
							newSendingState: sendingState,
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
				}
			case 'ProcessedBrokerRowMsg':
				var carrierInvoiceId = msg.a.a;
				return {
					effect: $author$project$HubTran$Effect$none,
					newBrokerModel: A2($author$project$Components$Dashboard$Processed$BrokerModel$toggleSelected, carrierInvoiceId, brokerModel),
					newSendingState: sendingState,
					parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
				};
			default:
				if ((msg.a.$ === 'Ok') && (msg.a.a.$ === 'Ok')) {
					return {
						effect: $author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_processedFactorInvoiceIdGroup),
									$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_carrierInvoiceId)
								])),
						newBrokerModel: brokerModel,
						newSendingState: $author$project$Components$Dashboard$Processed$ProcessedModel$initSendingState,
						parentEffect: $author$project$Components$DashboardPage$ProcessedEffectRefreshIds
					};
				} else {
					return {
						effect: $author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert),
						newBrokerModel: brokerModel,
						newSendingState: $author$project$Components$Dashboard$Processed$ProcessedModel$initErroredSendingState,
						parentEffect: $author$project$Components$DashboardPage$ProcessedEffectRefreshIds
					};
				}
		}
	});
var $author$project$Components$DashboardPage$ProcessedFactorInvoicesUpdated = function (a) {
	return {$: 'ProcessedFactorInvoicesUpdated', a: a};
};
var $author$project$Components$Dashboard$Processed$FactorModel$allFactorInvoiceIdsOnCurrentPage = function (data) {
	return A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.factorInvoiceIds;
		},
		$author$project$Pagination$entries(data.currentPageData));
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$size(dict);
};
var $author$project$Id$Set$size = function (_v0) {
	var set = _v0.a;
	return $elm$core$Set$size(set);
};
var $author$project$Components$Dashboard$Processed$FactorModel$countSelected = F2(
	function (data, model) {
		return $author$project$Id$Set$size(
			A2($author$project$Components$Dashboard$Processed$FactorModel$selectedFactorInvoiceIds, data, model));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$allSelected = F2(
	function (data, factorModel) {
		return _Utils_eq(
			$elm$core$List$length(
				$author$project$Components$Dashboard$Processed$FactorModel$allFactorInvoiceIdsOnCurrentPage(data)),
			A2($author$project$Components$Dashboard$Processed$FactorModel$countSelected, data, factorModel));
	});
var $author$project$Api$FactorInvoices$Decode$successfulIds = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['cacheable', 'factorInvoices']),
			$elm$json$Json$Decode$list(
				A2($elm$json$Json$Decode$index, 0, $author$project$Domain$FactorInvoiceId$decode))),
			A2(
			$elm$json$Json$Decode$field,
			'factor_invocies',
			$elm$json$Json$Decode$list(
				A2($elm$json$Json$Decode$field, 'id', $author$project$Domain$FactorInvoiceId$decode)))
		]));
var $author$project$Api$FactorInvoices$Decode$factorInvoiceIds = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, $author$project$Api$FactorInvoices$Decode$successfulIds),
			$elm$json$Json$Decode$succeed(
			$elm$core$Result$Err(_Utils_Tuple0))
		]));
var $author$project$Api$FactorInvoices$Encode$factorInvoiceIdsTuple = function (invoiceIds) {
	var idToJsonString = A2(
		$elm$core$Basics$composeR,
		$author$project$Domain$FactorInvoiceId$toInt,
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$json$Json$Encode$string));
	return _Utils_Tuple2(
		'factor_invoices',
		A2($elm$json$Json$Encode$list, idToJsonString, invoiceIds));
};
var $author$project$Api$FactorInvoices$Encode$factorInvoiceIds = function (invoiceIds) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				$author$project$Api$FactorInvoices$Encode$factorInvoiceIdsTuple(invoiceIds)
			]));
};
var $author$project$Api$FactorInvoice$batchReject = function (invoiceIds) {
	return A3(
		$author$project$Helpers$Api$post,
		'/api/accounts_payable/factor_invoices/reject',
		$author$project$Api$FactorInvoices$Encode$factorInvoiceIds(invoiceIds),
		$author$project$Api$FactorInvoices$Decode$factorInvoiceIds);
};
var $author$project$Api$FactorInvoice$batchSend = function (invoiceIds) {
	return A3(
		$author$project$Helpers$Api$post,
		'/api/accounts_payable/factor_invoices/send_to_cadence',
		$author$project$Api$FactorInvoices$Encode$factorInvoiceIds(invoiceIds),
		$author$project$Api$FactorInvoices$Decode$factorInvoiceIds);
};
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$diff, dict1, dict2));
	});
var $author$project$Id$Set$diff = F2(
	function (_v0, _v1) {
		var first = _v0.a;
		var second = _v1.a;
		return $author$project$Id$Set$Set(
			A2($elm$core$Set$diff, first, second));
	});
var $author$project$Sanitized$mapUnsanitizedValue = F2(
	function (f, _v0) {
		var value = _v0.a;
		return $author$project$Sanitized$Unsanitized(
			f(value));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$setGroupSelection = F3(
	function (bool, _v0, _v1) {
		var factorInvoiceIds = _v0.factorInvoiceIds;
		var model = _v1.a;
		var unionOrDiff = bool ? $author$project$Id$Set$union : $author$project$Id$Set$diff;
		return $author$project$Components$Dashboard$Processed$FactorModel$FactorModel(
			_Utils_update(
				model,
				{
					selectedFactorInvoiceIds: A2(
						$author$project$Sanitized$mapUnsanitizedValue,
						function (oldSelected) {
							return A2(
								unionOrDiff,
								oldSelected,
								$author$project$Id$Set$fromList(factorInvoiceIds));
						},
						model.selectedFactorInvoiceIds)
				}));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$setSelection = F3(
	function (bool, data, model) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Components$Dashboard$Processed$FactorModel$setGroupSelection(bool),
			model,
			data.unsortedAllIds);
	});
var $author$project$Components$Dashboard$Processed$FactorModel$setSortBy = F2(
	function (newSortBy, _v0) {
		var factorModel = _v0.a;
		return $author$project$Components$Dashboard$Processed$FactorModel$FactorModel(
			_Utils_update(
				factorModel,
				{sortBy: newSortBy}));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$expandAllCarrierIds = F2(
	function (data, expandedTmsCarrierIds) {
		var allCarrierIds = $author$project$Id$Set$fromList(
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.tmsCarrierId;
				},
				data.unsortedAllIds));
		return _Utils_eq(allCarrierIds, expandedTmsCarrierIds) ? $author$project$Id$Set$empty : allCarrierIds;
	});
var $author$project$Components$Dashboard$Processed$FactorModel$toggleExpandedGroups = F2(
	function (data, _v0) {
		var model = _v0.a;
		return $author$project$Components$Dashboard$Processed$FactorModel$FactorModel(
			_Utils_update(
				model,
				{
					expandedTmsCarrierIds: A2($author$project$Components$Dashboard$Processed$FactorModel$expandAllCarrierIds, data, model.expandedTmsCarrierIds)
				}));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$toggleExpansion = F2(
	function (tmsCarrierId, _v0) {
		var model = _v0.a;
		return $author$project$Components$Dashboard$Processed$FactorModel$FactorModel(
			_Utils_update(
				model,
				{
					expandedTmsCarrierIds: A2($author$project$Id$Set$member, tmsCarrierId, model.expandedTmsCarrierIds) ? A2($author$project$Id$Set$remove, tmsCarrierId, model.expandedTmsCarrierIds) : A2($author$project$Id$Set$insert, tmsCarrierId, model.expandedTmsCarrierIds)
				}));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$toggleFactorInvoiceSelection = F2(
	function (factorInvoiceId, _v0) {
		var model = _v0.a;
		return $author$project$Components$Dashboard$Processed$FactorModel$FactorModel(
			_Utils_update(
				model,
				{
					selectedFactorInvoiceIds: A2(
						$author$project$Sanitized$mapUnsanitizedValue,
						function (oldSelected) {
							return A2($author$project$Id$Set$member, factorInvoiceId, oldSelected) ? A2($author$project$Id$Set$remove, factorInvoiceId, oldSelected) : A2($author$project$Id$Set$insert, factorInvoiceId, oldSelected);
						},
						model.selectedFactorInvoiceIds)
				}));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$toggleGroupSelection = F2(
	function (factorInvoiceIds, _v0) {
		var model = _v0.a;
		var newSelectedFactorInvoiceIds = function (oldSelected) {
			return A2(
				$elm$core$List$all,
				$author$project$Components$Dashboard$Processed$FactorModel$isFactorInvoiceIdSelected(oldSelected),
				factorInvoiceIds) ? A2(
				$author$project$Id$Set$diff,
				oldSelected,
				$author$project$Id$Set$fromList(factorInvoiceIds)) : A2(
				$author$project$Id$Set$union,
				oldSelected,
				$author$project$Id$Set$fromList(factorInvoiceIds));
		};
		return $author$project$Components$Dashboard$Processed$FactorModel$FactorModel(
			_Utils_update(
				model,
				{
					selectedFactorInvoiceIds: A2($author$project$Sanitized$mapUnsanitizedValue, newSelectedFactorInvoiceIds, model.selectedFactorInvoiceIds)
				}));
	});
var $author$project$Components$DashboardPage$updateProcessedFactor = F4(
	function (factorData, sendingState, factorModel, msg) {
		switch (msg.$) {
			case 'ProcessedFactorActionAreaMsg':
				switch (msg.a.$) {
					case 'FactorSend':
						var _v1 = msg.a;
						var apiRequest = $author$project$Api$FactorInvoice$batchSend(
							$author$project$Id$Set$toList(
								A2($author$project$Components$Dashboard$Processed$FactorModel$selectedFactorInvoiceIds, factorData, factorModel)));
						return {
							effect: A2($author$project$HubTran$Effect$sendCacheableRequestWithError, $author$project$Components$DashboardPage$ProcessedFactorInvoicesUpdated, apiRequest),
							newFactorModel: $author$project$Components$Dashboard$Processed$FactorModel$clearSelection(factorModel),
							newSendingState: _Utils_update(
								sendingState,
								{isSendingToCadence: true}),
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
					case 'FactorReject':
						var _v2 = msg.a;
						var apiRequest = $author$project$Api$FactorInvoice$batchReject(
							$author$project$Id$Set$toList(
								A2($author$project$Components$Dashboard$Processed$FactorModel$selectedFactorInvoiceIds, factorData, factorModel)));
						return {
							effect: A2($author$project$HubTran$Effect$sendCacheableRequestWithError, $author$project$Components$DashboardPage$ProcessedFactorInvoicesUpdated, apiRequest),
							newFactorModel: $author$project$Components$Dashboard$Processed$FactorModel$clearSelection(factorModel),
							newSendingState: _Utils_update(
								sendingState,
								{isRejecting: true}),
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
					default:
						var _v3 = msg.a;
						return {
							effect: $author$project$HubTran$Effect$none,
							newFactorModel: A2($author$project$Components$Dashboard$Processed$FactorModel$toggleExpandedGroups, factorData, factorModel),
							newSendingState: sendingState,
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
				}
			case 'ProcessedFactorHeaderMsg':
				if (msg.a.$ === 'ProcessedFactorToggleAll') {
					var _v4 = msg.a;
					var bool = !A2($author$project$Components$Dashboard$Processed$FactorModel$allSelected, factorData, factorModel);
					return {
						effect: $author$project$HubTran$Effect$none,
						newFactorModel: A3($author$project$Components$Dashboard$Processed$FactorModel$setSelection, bool, factorData, factorModel),
						newSendingState: sendingState,
						parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
					};
				} else {
					var newSort = msg.a.a;
					return {
						effect: $author$project$HubTran$Effect$none,
						newFactorModel: A2($author$project$Components$Dashboard$Processed$FactorModel$setSortBy, newSort, factorModel),
						newSendingState: sendingState,
						parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
					};
				}
			case 'ProcessedFactorGroupMsg':
				switch (msg.a.$) {
					case 'ToggleSelections':
						var factorInvoiceIds = msg.a.a;
						return {
							effect: $author$project$HubTran$Effect$none,
							newFactorModel: A2($author$project$Components$Dashboard$Processed$FactorModel$toggleGroupSelection, factorInvoiceIds, factorModel),
							newSendingState: sendingState,
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
					case 'ToggleFactorInvoiceSelection':
						var factorInvoiceId = msg.a.a;
						return {
							effect: $author$project$HubTran$Effect$none,
							newFactorModel: A2($author$project$Components$Dashboard$Processed$FactorModel$toggleFactorInvoiceSelection, factorInvoiceId, factorModel),
							newSendingState: sendingState,
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
					default:
						var tmsCarrierId = msg.a.a;
						return {
							effect: $author$project$HubTran$Effect$none,
							newFactorModel: A2($author$project$Components$Dashboard$Processed$FactorModel$toggleExpansion, tmsCarrierId, factorModel),
							newSendingState: sendingState,
							parentEffect: $author$project$Components$DashboardPage$ProcessedEffectNone
						};
				}
			default:
				if ((msg.a.$ === 'Ok') && (msg.a.a.$ === 'Ok')) {
					return {
						effect: $author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_processedFactorInvoiceIdGroup),
									$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_carrierInvoiceId)
								])),
						newFactorModel: $author$project$Components$Dashboard$Processed$FactorModel$clearSelection(factorModel),
						newSendingState: $author$project$Components$Dashboard$Processed$ProcessedModel$initSendingState,
						parentEffect: $author$project$Components$DashboardPage$ProcessedEffectRefreshIds
					};
				} else {
					return {
						effect: $author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert),
						newFactorModel: $author$project$Components$Dashboard$Processed$FactorModel$clearSelection(factorModel),
						newSendingState: $author$project$Components$Dashboard$Processed$ProcessedModel$initErroredSendingState,
						parentEffect: $author$project$Components$DashboardPage$ProcessedEffectRefreshIds
					};
				}
		}
	});
var $author$project$Components$DashboardPage$ReviewEffectNone = {$: 'ReviewEffectNone'};
var $author$project$Components$DashboardPage$ReviewEffectRefreshIds = {$: 'ReviewEffectRefreshIds'};
var $author$project$Components$DashboardPage$ReviewEffectViewItem = function (a) {
	return {$: 'ReviewEffectViewItem', a: a};
};
var $author$project$Components$DashboardPage$ReviewInvoicesUpdated = function (a) {
	return {$: 'ReviewInvoicesUpdated', a: a};
};
var $author$project$Components$DashboardPage$ReviewMsg = function (a) {
	return {$: 'ReviewMsg', a: a};
};
var $author$project$Api$FactorInvoice$bulkVerify = F2(
	function (customState, invoiceIds) {
		var args = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'state',
					$elm$json$Json$Encode$string(customState.id)),
					$author$project$Api$FactorInvoices$Encode$factorInvoiceIdsTuple(invoiceIds)
				]));
		return A3(
			$author$project$Helpers$Api$post,
			'/api/accounts_payable/factor_invoices/finish_verification',
			args,
			$elm$json$Json$Decode$succeed(
				$elm$core$Result$Ok(invoiceIds)));
	});
var $author$project$Components$Dashboard$Review$Model$clearSendingState = function (model) {
	return _Utils_update(
		model,
		{
			sendingState: A3($author$project$Components$Dashboard$Review$Model$SendingState, false, false, false)
		});
};
var $author$project$Components$Dashboard$Review$Model$updateSendingState = F2(
	function (modifier, model) {
		return _Utils_update(
			model,
			{
				sendingState: modifier(model.sendingState)
			});
	});
var $author$project$Components$Dashboard$Review$Model$rejecting = function (model) {
	return A2(
		$author$project$Components$Dashboard$Review$Model$updateSendingState,
		function (s) {
			return _Utils_update(
				s,
				{isRejecting: true});
		},
		model);
};
var $author$project$Components$DashboardPage$reviewInvoicesUpdated = function (apiResult) {
	switch (apiResult.$) {
		case 'Ok':
			if (apiResult.a.$ === 'Ok') {
				return $author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_reviewIdGroup);
			} else {
				return $author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert);
			}
		case 'Err':
			var message = apiResult.a;
			return $author$project$HubTran$Effect$flash(
				$author$project$HubTran$Flash$alert(message));
		default:
			return $author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert);
	}
};
var $author$project$Components$Dashboard$Review$Model$sending = function (model) {
	return A2(
		$author$project$Components$Dashboard$Review$Model$updateSendingState,
		function (s) {
			return _Utils_update(
				s,
				{isSending: true});
		},
		model);
};
var $author$project$Components$Dashboard$Review$Model$setCustomStateSelection = F3(
	function (customStates, stateId, reviewModel) {
		var stateToSelect = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Domain$VerificationsDebtorBatchItem$customStateSkipped,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (state) {
						return _Utils_eq(state.id, stateId);
					},
					customStates)));
		return _Utils_update(
			reviewModel,
			{selectedCustomState: stateToSelect});
	});
var $author$project$Id$MaybeSet$insert = F2(
	function (id, _v0) {
		var set = _v0.a;
		return $author$project$Id$MaybeSet$MaybeSet(
			A2(
				$elm$core$Set$insert,
				$author$project$Id$MaybeSet$makeKey(id),
				set));
	});
var $author$project$Id$MaybeSet$remove = F2(
	function (id, _v0) {
		var set = _v0.a;
		return $author$project$Id$MaybeSet$MaybeSet(
			A2(
				$elm$core$Set$remove,
				$author$project$Id$MaybeSet$makeKey(id),
				set));
	});
var $author$project$Id$MaybeSet$setMember = F2(
	function (id, isPresent) {
		return isPresent ? $author$project$Id$MaybeSet$insert(id) : $author$project$Id$MaybeSet$remove(id);
	});
var $author$project$Components$Dashboard$Review$Model$toggleExpansion = F2(
	function (carrierId, reviewModel) {
		return _Utils_update(
			reviewModel,
			{
				expandedTmsCarrierIds: A3(
					$author$project$Id$MaybeSet$setMember,
					carrierId,
					!A2($author$project$Id$MaybeSet$member, carrierId, reviewModel.expandedTmsCarrierIds),
					reviewModel.expandedTmsCarrierIds)
			});
	});
var $author$project$Components$Dashboard$Review$Model$toggleRejectionExpansion = F2(
	function (tmsCarrierId, reviewModel) {
		var wasExpanded = A2($author$project$Id$MaybeSet$member, tmsCarrierId, reviewModel.clientGroupExceptionsExpanded);
		return _Utils_update(
			reviewModel,
			{
				clientGroupExceptionsExpanded: A3($author$project$Id$MaybeSet$setMember, tmsCarrierId, !wasExpanded, reviewModel.clientGroupExceptionsExpanded)
			});
	});
var $author$project$Id$Set$setAll = F3(
	function (keys, isPresent, original) {
		return isPresent ? A2($author$project$Id$Set$union, keys, original) : A2($author$project$Id$Set$diff, original, keys);
	});
var $author$project$Components$Dashboard$Review$Model$toggleSelection = F3(
	function (factorInvoiceIds, newSelected, reviewModel) {
		return _Utils_update(
			reviewModel,
			{
				selectedFactorInvoiceIds: A2(
					$author$project$Sanitized$mapUnsanitizedValue,
					A2($author$project$Id$Set$setAll, factorInvoiceIds, newSelected),
					reviewModel.selectedFactorInvoiceIds)
			});
	});
var $author$project$Components$Dashboard$Review$Model$Verify = {$: 'Verify'};
var $author$project$Components$Dashboard$Review$Model$toggleVerifyMode = function (reviewModel) {
	var newVerifyMode = function () {
		var _v0 = reviewModel.verifyMode;
		if (_v0.$ === 'Verify') {
			return $author$project$Components$Dashboard$Review$Model$Approve;
		} else {
			return $author$project$Components$Dashboard$Review$Model$Verify;
		}
	}();
	return _Utils_update(
		reviewModel,
		{
			selectedFactorInvoiceIds: $author$project$Sanitized$raw($author$project$Id$Set$empty),
			verifyMode: newVerifyMode
		});
};
var $author$project$Components$Dashboard$Review$Model$verifying = function (model) {
	return A2(
		$author$project$Components$Dashboard$Review$Model$updateSendingState,
		function (s) {
			return _Utils_update(
				s,
				{isVerifying: true});
		},
		model);
};
var $author$project$Components$DashboardPage$updateReview = F4(
	function (accountSettings, reviewMsg, reviewModel, maybeData) {
		if (reviewMsg.$ === 'ReviewInvoicesUpdated') {
			var result = reviewMsg.a;
			return _Utils_Tuple3(
				$author$project$Components$Dashboard$Review$Model$clearSendingState(reviewModel),
				$author$project$Components$DashboardPage$reviewInvoicesUpdated(result),
				$author$project$Components$DashboardPage$ReviewEffectRefreshIds);
		} else {
			switch (reviewMsg.a.$) {
				case 'ToggleVerifyMode':
					var _v1 = reviewMsg.a;
					return _Utils_Tuple3(
						$author$project$Components$Dashboard$Review$Model$toggleVerifyMode(reviewModel),
						$author$project$HubTran$Effect$none,
						$author$project$Components$DashboardPage$ReviewEffectNone);
				case 'ToggleExpansion':
					var tmsCarrierId = reviewMsg.a.a;
					return _Utils_Tuple3(
						A2($author$project$Components$Dashboard$Review$Model$toggleExpansion, tmsCarrierId, reviewModel),
						$author$project$HubTran$Effect$none,
						$author$project$Components$DashboardPage$ReviewEffectNone);
				case 'ToggleInvoiceSelection':
					var _v2 = reviewMsg.a;
					var factorInvoiceIds = _v2.a;
					var newSelected = _v2.b;
					return _Utils_Tuple3(
						A3($author$project$Components$Dashboard$Review$Model$toggleSelection, factorInvoiceIds, newSelected, reviewModel),
						$author$project$HubTran$Effect$none,
						$author$project$Components$DashboardPage$ReviewEffectNone);
				case 'SetCustomState':
					var stateId = reviewMsg.a.a;
					var customStates = accountSettings.verificationsWorkflowDebtorBatchItemCustomStates;
					return _Utils_Tuple3(
						A3($author$project$Components$Dashboard$Review$Model$setCustomStateSelection, customStates, stateId, reviewModel),
						$author$project$HubTran$Effect$none,
						$author$project$Components$DashboardPage$ReviewEffectNone);
				case 'ToggleRejectionExpansion':
					var tmsCarrierId = reviewMsg.a.a;
					return _Utils_Tuple3(
						A2($author$project$Components$Dashboard$Review$Model$toggleRejectionExpansion, tmsCarrierId, reviewModel),
						$author$project$HubTran$Effect$none,
						$author$project$Components$DashboardPage$ReviewEffectNone);
				case 'BulkVerifyInvoices':
					var _v3 = reviewMsg.a;
					if (maybeData.$ === 'Just') {
						var data = maybeData.a;
						var apiRequest = A2(
							$author$project$Api$FactorInvoice$bulkVerify,
							reviewModel.selectedCustomState,
							$author$project$Id$Set$toList(
								A2($author$project$Components$Dashboard$Review$Model$selectedFactorInvoiceIds, reviewModel, data)));
						return _Utils_Tuple3(
							$author$project$Components$Dashboard$Review$Model$verifying(reviewModel),
							A2(
								$author$project$HubTran$Effect$sendCacheableRequestWithError,
								A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ReviewInvoicesUpdated, $author$project$Components$DashboardPage$ReviewMsg),
								apiRequest),
							$author$project$Components$DashboardPage$ReviewEffectNone);
					} else {
						return _Utils_Tuple3(reviewModel, $author$project$HubTran$Effect$none, $author$project$Components$DashboardPage$ReviewEffectNone);
					}
				case 'SendInvoices':
					var _v5 = reviewMsg.a;
					if (maybeData.$ === 'Just') {
						var data = maybeData.a;
						var apiRequest = $author$project$Api$FactorInvoice$batchSend(
							$author$project$Id$Set$toList(
								A2($author$project$Components$Dashboard$Review$Model$selectedFactorInvoiceIds, reviewModel, data)));
						return _Utils_Tuple3(
							$author$project$Components$Dashboard$Review$Model$sending(reviewModel),
							A2(
								$author$project$HubTran$Effect$sendCacheableRequestWithError,
								A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ReviewInvoicesUpdated, $author$project$Components$DashboardPage$ReviewMsg),
								apiRequest),
							$author$project$Components$DashboardPage$ReviewEffectNone);
					} else {
						return _Utils_Tuple3(reviewModel, $author$project$HubTran$Effect$none, $author$project$Components$DashboardPage$ReviewEffectNone);
					}
				case 'RejectInvoices':
					var _v7 = reviewMsg.a;
					if (maybeData.$ === 'Just') {
						var data = maybeData.a;
						var apiRequest = $author$project$Api$FactorInvoice$batchReject(
							$author$project$Id$Set$toList(
								A2($author$project$Components$Dashboard$Review$Model$selectedFactorInvoiceIds, reviewModel, data)));
						return _Utils_Tuple3(
							$author$project$Components$Dashboard$Review$Model$rejecting(reviewModel),
							A2(
								$author$project$HubTran$Effect$sendCacheableRequestWithError,
								A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ReviewInvoicesUpdated, $author$project$Components$DashboardPage$ReviewMsg),
								apiRequest),
							$author$project$Components$DashboardPage$ReviewEffectNone);
					} else {
						return _Utils_Tuple3(reviewModel, $author$project$HubTran$Effect$none, $author$project$Components$DashboardPage$ReviewEffectNone);
					}
				case 'NoOp':
					var _v9 = reviewMsg.a;
					return _Utils_Tuple3(reviewModel, $author$project$HubTran$Effect$none, $author$project$Components$DashboardPage$ReviewEffectNone);
				default:
					var path = reviewMsg.a.a;
					return _Utils_Tuple3(
						reviewModel,
						$author$project$HubTran$Effect$none,
						$author$project$Components$DashboardPage$ReviewEffectViewItem(path));
			}
		}
	});
var $author$project$Components$Dashboard$AvailableQueues$hasDeliveredAt = F2(
	function (dashboardMode, queue) {
		return _Utils_eq(dashboardMode, $author$project$AuditPb$DashboardModeAudit) && A2(
			$elm$core$List$member,
			queue,
			_List_fromArray(
				[
					$author$project$Components$Dashboard$AvailableQueues$ExceptionQueue,
					$author$project$Components$Dashboard$AvailableQueues$WaitingQueue,
					$author$project$Components$Dashboard$AvailableQueues$ReadyToAuditQueue,
					$author$project$Components$Dashboard$AvailableQueues$FinalQueue(
					$author$project$Components$Dashboard$AvailableQueues$ProcessedQueue($author$project$Domain$Account$BrokerAccount))
				]));
	});
var $author$project$Components$Dashboard$DashboardRow$shouldShowDeliveredAt = F4(
	function (accountType, accountSettings, dashboardMode, queue) {
		return _Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) && (A2($author$project$Components$Dashboard$AvailableQueues$hasDeliveredAt, dashboardMode, queue) && (accountSettings.showDateDeliveredOnQueues || accountSettings.auditV3ReskinEnabledQueues));
	});
var $author$project$Components$DashboardPage$updatedDateRangeFilter = F3(
	function (data, model, _v0) {
		var dateRangeDropdown = model.dateRangeDropdown;
		var dashboardFilters = model.dashboardFilters;
		var shouldShowDeliveredAt = A4(
			$author$project$Components$Dashboard$DashboardRow$shouldShowDeliveredAt,
			$author$project$Domain$Account$accountType(data.account),
			data.accountSettings,
			model.dashboardMode,
			model.selectedQueue);
		var deliveredAtFilters = shouldShowDeliveredAt ? _List_fromArray(
			[$author$project$AuditPb$QueueDateDelivered, $author$project$AuditPb$QueueDateReceived]) : _List_Nil;
		var possibleItems = function () {
			var _v1 = model.selectedQueue;
			_v1$4:
			while (true) {
				switch (_v1.$) {
					case 'WaitingQueue':
						return A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									shouldShowDeliveredAt ? $elm$core$Maybe$Just($author$project$AuditPb$QueueDateDelivered) : $elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just($author$project$AuditPb$QueueDateReceived),
									$elm$core$Maybe$Just($author$project$AuditPb$QueueDateReviewOn)
								]));
					case 'ExceptionQueue':
						return deliveredAtFilters;
					case 'ReadyToAuditQueue':
						return deliveredAtFilters;
					case 'FinalQueue':
						if ((_v1.a.$ === 'ProcessedQueue') && (_v1.a.a.$ === 'BrokerAccount')) {
							var _v2 = _v1.a.a;
							return deliveredAtFilters;
						} else {
							break _v1$4;
						}
					default:
						break _v1$4;
				}
			}
			return _List_Nil;
		}();
		var selectedItem = A2($elm$core$List$member, dashboardFilters.rangeType, possibleItems) ? dashboardFilters.rangeType : $author$project$AuditPb$QueueDateDelivered;
		var newDateRangeDropdown = A2(
			$author$project$Ui$V3$CustomSelect$setSelectedItems,
			_List_fromArray(
				[
					$author$project$Components$DashboardPage$legacyDateRangeToItem(selectedItem)
				]),
			A2(
				$author$project$Ui$V3$CustomSelect$setItems,
				A2($elm$core$List$map, $author$project$Components$DashboardPage$legacyDateRangeToItem, possibleItems),
				dateRangeDropdown));
		return newDateRangeDropdown;
	});
var $author$project$Components$DashboardPage$updatedExceptionsDropdown = F3(
	function (data, _v0, _v1) {
		var exceptionsDropdown = _v0.exceptionsDropdown;
		var dashboardFilters = _v0.dashboardFilters;
		var toItem = function (stat) {
			return $author$project$Ui$V3$CustomSelect$simpleItem(
				{id: stat.id, label: stat.name});
		};
		var possibleItems = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name;
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Forward$Remote$toMaybe(data.exceptionStats)));
		var selectedItems = A2(
			$elm$core$List$filterMap,
			function (exception) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					function (item) {
						return _Utils_eq(item.id, exception);
					},
					possibleItems);
			},
			dashboardFilters.exceptions);
		return A2(
			$author$project$Ui$V3$CustomSelect$setSelectedItems,
			A2($elm$core$List$map, toItem, selectedItems),
			A2(
				$author$project$Ui$V3$CustomSelect$setItems,
				A2($elm$core$List$map, toItem, possibleItems),
				exceptionsDropdown));
	});
var $author$project$Components$Dashboard$Url$onDoneForNewFlowModeFromDashboard = F3(
	function (queue, dashboardFilters, activePage) {
		var queueArg = _Utils_Tuple2(
			'queue',
			$author$project$Components$Dashboard$Url$QueueArguments$encode(queue));
		var pageArg = _Utils_Tuple2(
			'page',
			$elm$core$String$fromInt(activePage));
		var filterArgs = $author$project$Components$Dashboard$Url$FilterArguments$encodeAsQueries(dashboardFilters);
		var categoriesArg = _Utils_Tuple2(
			'categories',
			$elm$url$Url$percentEncode(
				$author$project$Domain$CategoryFilter$toString(dashboardFilters.categories)));
		var queries = A2(
			$elm$core$List$cons,
			queueArg,
			_Utils_ap(
				filterArgs,
				_List_fromArray(
					[pageArg, categoriesArg])));
		return $elm$url$Url$percentEncode(
			$author$project$Path$toString(
				A2(
					$author$project$Path$addQueries,
					_Utils_ap(
						queries,
						_List_fromArray(
							[
								A2($author$project$Components$Dashboard$Url$flowModeArgs, queue, dashboardFilters)
							])),
					$author$project$Path$base(
						_List_fromArray(
							['flow'])))));
	});
var $author$project$Components$Dashboard$AvailableQueues$startsFlowModeImplicitly = F2(
	function (queue, dashboardMode) {
		var _v0 = _Utils_Tuple2(dashboardMode, queue);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'DashboardModeIndex') {
				switch (_v0.b.$) {
					case 'NewQueue':
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					case 'FactorNeedsIndexingQueue':
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return true;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return false;
	});
var $author$project$Components$DashboardPage$viewItem = F2(
	function (path, model) {
		var enableFlowMode = A2($author$project$Components$Dashboard$AvailableQueues$startsFlowModeImplicitly, model.selectedQueue, model.dashboardMode);
		var onDone = function () {
			var _v0 = _Utils_Tuple2(model.dashboardMode, model.selectedQueue);
			if ((_v0.a.$ === 'DashboardModeIndex') && (_v0.b.$ === 'NewQueue')) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return A3($author$project$Components$Dashboard$Url$onDoneForNewFlowModeFromDashboard, model.selectedQueue, model.dashboardFilters, model.requestedActivePage);
			} else {
				return A5($author$project$Components$Dashboard$Url$onDone, model.selectedQueue, model.dashboardFilters, model.requestedActivePage, enableFlowMode, model.dashboardMode);
			}
		}();
		var url = $author$project$Path$toString(
			A2(
				$author$project$Path$addQueries,
				_Utils_eq(model.selectedQueue, $author$project$Components$Dashboard$AvailableQueues$NewQueue) ? _List_fromArray(
					[
						_Utils_Tuple2('fromQueue', 'new')
					]) : _List_Nil,
				A2(
					$author$project$Path$addQueries,
					_List_fromArray(
						[
							_Utils_Tuple2('onDone', onDone)
						]),
					path)));
		return model.routesInElm(url) ? $author$project$HubTran$Effect$pushUrl(url) : $author$project$HubTran$Effect$load(url);
	});
var $author$project$Components$DashboardPage$viewItemNewTab = F2(
	function (path, _v0) {
		return $author$project$HubTran$Effect$cmd(
			$author$project$Js$openUrlInNewTab(
				$author$project$Path$toString(path)));
	});
var $author$project$Components$DashboardPage$updateLogic = F4(
	function (v3ReskinEnabled, data_, action, model) {
		var dashboardFilters = model.dashboardFilters;
		var currentUser = data_.currentUser;
		var accountSettings = data_.accountSettings;
		switch (action.$) {
			case 'SelectedQueue':
				var queue = action.a;
				var accountType = $author$project$Domain$Account$accountType(data_.account);
				var newQueue = A3($author$project$Components$DashboardPage$validateQueue, accountType, data_.accountSettings, queue);
				var queueModel = _Utils_update(
					model,
					{requestedActivePage: 1, selectedQueue: newQueue});
				return _Utils_eq(newQueue, model.selectedQueue) ? _Utils_Tuple2(queueModel, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
					$author$project$Components$DashboardPage$clearSelections(queueModel),
					$author$project$HubTran$Effect$none);
			case 'SelectStartDate':
				var tz = action.a;
				var newDateString = action.b;
				var newDateTime = A2($author$project$Components$DashboardPage$localDateTimeToPosix, tz, newDateString);
				var newDate = $elm$core$Result$toMaybe(
					$justinmimbs$date$Date$fromIsoString(newDateString));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{
									startDate: A2(
										$elm$core$Maybe$andThen,
										$author$project$Components$DashboardPage$dateWithFourDigitYear(model.dashboardFilters.startDate),
										newDate),
									startDateTime: A2(
										$elm$core$Maybe$andThen,
										A2($author$project$Components$DashboardPage$dateTimeWithFourDigitYear, tz, model.dashboardFilters.startDateTime),
										newDateTime)
								}),
							startDate: newDate,
							startDateTime: newDateTime
						}),
					$author$project$HubTran$Effect$none);
			case 'SelectEndDate':
				var tz = action.a;
				var newDateString = action.b;
				var newDateTime = A2($author$project$Components$DashboardPage$localDateTimeToPosix, tz, newDateString);
				var newDate = $elm$core$Result$toMaybe(
					$justinmimbs$date$Date$fromIsoString(newDateString));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{
									endDate: A2(
										$elm$core$Maybe$andThen,
										$author$project$Components$DashboardPage$dateWithFourDigitYear(model.dashboardFilters.endDate),
										newDate),
									endDateTime: A2(
										$elm$core$Maybe$andThen,
										A2($author$project$Components$DashboardPage$dateTimeWithFourDigitYear, tz, model.dashboardFilters.endDateTime),
										newDateTime)
								}),
							endDate: newDate,
							endDateTime: newDateTime
						}),
					$author$project$HubTran$Effect$none);
			case 'LabelFiltersMsg':
				var childMsg = action.a;
				var _v1 = A2($author$project$Components$Dashboard$FilterBar$LabelFilters$update, childMsg, dashboardFilters.labelFilters);
				var newLabelFilters = _v1.a;
				var outMsg = _v1.b;
				var newRequestedPage = _Utils_eq(dashboardFilters.labelFilters, newLabelFilters) ? model.requestedActivePage : 1;
				var _v2 = function () {
					if (outMsg.$ === 'NoOp') {
						return _Utils_Tuple2(model.labelsCollapsed, $author$project$HubTran$Effect$none);
					} else {
						var shouldCollapse = !model.labelsCollapsed;
						return _Utils_Tuple2(
							shouldCollapse,
							A2(
								$author$project$HubTran$Effect$sendCacheableRequest,
								$elm$core$Basics$always($author$project$Components$DashboardPage$NoOp),
								$author$project$Api$Users$setLabelsCollapse(shouldCollapse)));
					}
				}();
				var newCollapse = _v2.a;
				var effect = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{labelFilters: newLabelFilters}),
							labelsCollapsed: newCollapse,
							requestedActivePage: newRequestedPage
						}),
					effect);
			case 'UpdatePreferredFilters':
				var preferredFilters = A2($elm$core$List$map, $author$project$Domain$LabelFilter$fromPb, currentUser.preferredFilters);
				var preferrencesMatchSelectedLabels = _Utils_eq(
					$author$project$Domain$LabelFilter$listToComparable(dashboardFilters.labelFilters),
					$author$project$Domain$LabelFilter$listToComparable(preferredFilters));
				var preferredCategories = A2($elm$core$List$map, $author$project$Domain$CategoryFilter$fromPb, currentUser.preferredCategories);
				var preferrencesMatchSelectedCategories = _Utils_eq(
					$author$project$Domain$CategoryFilter$toString(dashboardFilters.categories),
					$author$project$Domain$CategoryFilter$toString(preferredCategories));
				var preferrencesMatchSelectedFilters = preferrencesMatchSelectedCategories && preferrencesMatchSelectedLabels;
				var newLabelFilters = preferrencesMatchSelectedFilters ? _List_Nil : dashboardFilters.labelFilters;
				var newCategoryFilters = preferrencesMatchSelectedFilters ? _List_Nil : dashboardFilters.categories;
				var apiRequest = A2($author$project$Api$Users$setPreferredFilters, newLabelFilters, newCategoryFilters);
				return _Utils_Tuple2(
					model,
					A2($author$project$HubTran$Effect$sendCacheableRequestWithError, $author$project$Components$DashboardPage$PreferredFiltersUpdated, apiRequest));
			case 'CustomerDropdownMsg':
				var msg = action.a;
				var _v4 = A3($author$project$Components$CustomerDropdown$update, data_.customerDropdown, msg, model.customerDropdown);
				var newCustomerDropdown = _v4.a;
				var cmd = _v4.b;
				var selectedCustomers = $author$project$Components$CustomerDropdown$selectedIds(newCustomerDropdown);
				var isNewSelection = !_Utils_eq(
					selectedCustomers,
					$author$project$Components$CustomerDropdown$selectedIds(model.customerDropdown));
				var newRequestedPage = isNewSelection ? 1 : model.requestedActivePage;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							customerDropdown: newCustomerDropdown,
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{customers: selectedCustomers}),
							requestedActivePage: newRequestedPage
						}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$CustomerDropdownMsg, cmd)));
			case 'CarrierDropdownMsg':
				var msg = action.a;
				var _v5 = A3($author$project$Components$CarrierDropdown$update, data_.carrierDropdown, msg, model.carrierDropdown);
				var newCarrierDropdown = _v5.a;
				var carrierDropdownCmd = _v5.b;
				var newTmsCarrierIds = $author$project$Components$CarrierDropdown$selectedIds(newCarrierDropdown);
				var isNewSelection = !_Utils_eq(
					newTmsCarrierIds,
					$author$project$Components$CarrierDropdown$selectedIds(model.carrierDropdown));
				var newRequestedPage = isNewSelection ? 1 : model.requestedActivePage;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							carrierDropdown: newCarrierDropdown,
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{tmsCarrierIds: newTmsCarrierIds}),
							requestedActivePage: newRequestedPage
						}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$CarrierDropdownMsg, carrierDropdownCmd)));
			case 'DebtorDropdownMsg':
				var msg = action.a;
				var _v6 = A3($author$project$Components$DebtorDropdown$update, data_.debtorDropdown, msg, model.debtorDropdown);
				var newDebtorDropdown = _v6.a;
				var cmd = _v6.b;
				var selectedDebtors = $author$project$Components$DebtorDropdown$selectedIds(newDebtorDropdown);
				var isNewSelection = !_Utils_eq(
					selectedDebtors,
					$author$project$Components$DebtorDropdown$selectedIds(model.debtorDropdown));
				var newRequestedPage = isNewSelection ? 1 : model.requestedActivePage;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{factorBrokerIds: selectedDebtors}),
							debtorDropdown: newDebtorDropdown,
							requestedActivePage: newRequestedPage
						}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$CustomerDropdownMsg, cmd)));
			case 'DateRangeDropdownMsg':
				var dropdownMsg = action.a;
				var dateRangeDropdown = A3($author$project$Components$DashboardPage$updatedDateRangeFilter, data_, model, model.dateRangeDropdown);
				var _v7 = A2($author$project$Ui$V3$CustomSelect$update, dropdownMsg, dateRangeDropdown);
				var newDropdown = _v7.a;
				var cmd = _v7.b;
				var newRangeType = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Domain$QueueDate$default,
					A2(
						$elm$core$Maybe$map,
						$author$project$Domain$QueueDate$fromString,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.id;
							},
							$author$project$Ui$V3$CustomSelect$getFirstSelectedItem(newDropdown))));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{rangeType: newRangeType}),
							dateRangeDropdown: newDropdown
						}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$DateRangeDropdownMsg, cmd)));
			case 'CategoryDropdownMsg':
				var categoryName = action.a;
				var dropdownMsg = action.b;
				var _v8 = A2($elm$core$Dict$get, categoryName, model.categoryDropdowns);
				if (_v8.$ === 'Just') {
					var dropdown = _v8.a;
					var _v9 = A2($author$project$Ui$V3$CustomSelect$update, dropdownMsg, dropdown);
					var newDropdown = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								categoryDropdowns: A3($elm$core$Dict$insert, categoryName, newDropdown, model.categoryDropdowns),
								dashboardFilters: _Utils_update(
									dashboardFilters,
									{
										categories: A2(
											$elm$core$List$map,
											function (category) {
												return _Utils_eq(category.category.name, categoryName) ? _Utils_update(
													category,
													{
														excluded: $elm$core$Set$fromList(
															A2(
																$elm$core$List$map,
																function ($) {
																	return $.id;
																},
																$author$project$Ui$V3$CustomSelect$excludedItems(newDropdown))),
														selected: $elm$core$Set$fromList(
															A2(
																$elm$core$List$map,
																function ($) {
																	return $.id;
																},
																$author$project$Ui$V3$CustomSelect$selectedItems(newDropdown)))
													}) : category;
											},
											dashboardFilters.categories)
									})
							}),
						$author$project$HubTran$Effect$cmd(
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$DashboardPage$CategoryDropdownMsg(categoryName),
								cmd)));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'ExceptionsDropdownMsg':
				var dropdownMsg = action.a;
				var exceptionsDropdown = A3($author$project$Components$DashboardPage$updatedExceptionsDropdown, data_, model, model.exceptionsDropdown);
				var _v10 = A2($author$project$Ui$V3$CustomSelect$update, dropdownMsg, exceptionsDropdown);
				var newDropdown = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{
									exceptions: A2(
										$elm$core$List$map,
										function ($) {
											return $.id;
										},
										$author$project$Ui$V3$CustomSelect$selectedItems(newDropdown))
								}),
							exceptionsDropdown: newDropdown
						}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DashboardPage$ExceptionsDropdownMsg, cmd)));
			case 'SelectedEventDateRange':
				var queueDate = action.a;
				var newDropdown = A2(
					$author$project$Ui$V3$CustomSelect$setSelectedItems,
					_List_fromArray(
						[
							$author$project$Components$DashboardPage$legacyDateRangeToItem(queueDate)
						]),
					A3($author$project$Components$DashboardPage$updatedDateRangeFilter, data_, model, model.dateRangeDropdown));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{rangeType: queueDate}),
							dateRangeDropdown: newDropdown
						}),
					$author$project$HubTran$Effect$none);
			case 'PagerTo':
				var index = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{requestedActivePage: index}),
					$author$project$HubTran$Effect$none);
			case 'EnableFlowMode':
				var currentState = model.flowModeState;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							flowModeState: _Utils_update(
								currentState,
								{inFlowMode: true}),
							requestedActivePage: 1
						}),
					$author$project$HubTran$Effect$none);
			case 'ViewItemNewTab':
				var path = action.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$Components$DashboardPage$viewItemNewTab, path, model));
			case 'ViewItem':
				var path = action.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$Components$DashboardPage$viewItem, path, model));
			case 'SelectSelectable':
				var ignorable = action.a;
				return $author$project$Components$DashboardPage$canPerformQueueActions(data_.currentUser) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedSelectables: A2($author$project$Components$DashboardPage$toggleSelection, model.selectedSelectables, ignorable)
						}),
					$author$project$HubTran$Effect$none) : _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'PerformIgnore':
				return _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateIgnoreModal,
						function (m) {
							return _Utils_update(
								m,
								{isPerforming: true});
						},
						model),
					$author$project$Components$DashboardPage$ignore(model.selectedSelectables));
			case 'PerformBulkLabel':
				var maybeLabel = A2($elm_community$list_extra$List$Extra$getAt, model.bulkLabelModal.selectedLabel, accountSettings.labels);
				if (maybeLabel.$ === 'Just') {
					var label = maybeLabel.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$DashboardPage$updateBulkLabelModal,
							function (m) {
								return _Utils_update(
									m,
									{isPerforming: true});
							},
							model),
						A3($author$project$Components$DashboardPage$bulkLabel, model.selectedSelectables, label.name, false));
				} else {
					return _Utils_Tuple2(
						A2(
							$author$project$Components$DashboardPage$updateBulkLabelModal,
							function (m) {
								return _Utils_update(
									m,
									{succeeded: false});
							},
							model),
						$author$project$HubTran$Effect$none);
				}
			case 'RemoveBulkLabel':
				var label = action.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateBulkLabelModal,
						function (m) {
							return _Utils_update(
								m,
								{isPerforming: true});
						},
						model),
					A3($author$project$Components$DashboardPage$bulkLabel, model.selectedSelectables, label, true));
			case 'SelectBulkLabel':
				var label = action.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateBulkLabelModal,
						function (m) {
							return _Utils_update(
								m,
								{selectedLabel: label});
						},
						model),
					$author$project$HubTran$Effect$none);
			case 'DismissBulkLabelModal':
				return _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateBulkLabelModal,
						function (m) {
							return _Utils_update(
								m,
								{isShown: false});
						},
						model),
					$author$project$HubTran$Effect$none);
			case 'SkipAsynchronousEmailReview':
				var emailMessageId = action.a;
				var documentBatchId = action.b;
				var reviewType = action.c;
				return _Utils_Tuple2(
					model,
					A3($author$project$Components$DashboardPage$skipAsynchronousEmailReview, emailMessageId, documentBatchId, reviewType));
			case 'GoToReview':
				var emailMessageId = action.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$DashboardPage$goToReview(emailMessageId));
			case 'NextReviewRetrieved':
				switch (action.a.$) {
					case 'Ok':
						var nextReview = action.a.a;
						return _Utils_Tuple2(
							model,
							A2(
								$author$project$Components$DocumentReview$DocumentReviewFlow$goToNextReviewIfPresentEffect,
								nextReview,
								{
									noReviewFlashMessage: 'This review is either locked by another user or has already been completed.',
									onDoneUrlFragment: $elm$core$Maybe$Just(
										A2($author$project$Components$DashboardPage$browserUrl, accountSettings, model))
								}));
					case 'Err':
						var errorMsg = action.a.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(errorMsg)));
					default:
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Error load next review')));
				}
			case 'FinishSkipAsynchronousEmailReview':
				if ((action.c.$ === 'PodReview') && (action.d.$ === 'Ok')) {
					var emailMessageId = action.a;
					var documentBatchId = action.b;
					var _v12 = action.c;
					var path = A3(
						$author$project$Path$documentBatchWithEmail,
						documentBatchId,
						emailMessageId,
						{
							isReadonly: currentUser.readOnlyFactorInvoices,
							useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, accountSettings, currentUser)
						});
					return _Utils_Tuple2(
						model,
						A2($author$project$Components$DashboardPage$viewItem, path, model));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'ToggleSelectAllVisible':
				var _v13 = _Utils_Tuple2(model.selectedQueue, data_.dashboardRows);
				_v13$6:
				while (true) {
					if (_v13.b.$ === 'Loaded') {
						switch (_v13.b.a.$) {
							case 'NewEmailData':
								if (_v13.a.$ === 'NewQueue') {
									var _v14 = _v13.a;
									var currentPage = _v13.b.a.a;
									return (!model.selectAllVisible) ? _Utils_Tuple2(
										_Utils_update(
											model,
											{
												selectAllVisible: true,
												selectedSelectables: A2(
													$timo_weike$generic_collections$ManualSet$fromList,
													$author$project$Components$Dashboard$Pager$Selectable$toComparable,
													A2(
														$elm$core$List$filterMap,
														A2(
															$elm$core$Basics$composeL,
															$elm$core$Maybe$map(
																A2(
																	$elm$core$Basics$composeL,
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Dashboard$Pager$Selectable$EmailMessage,
																		function ($) {
																			return $.id;
																		}),
																	function ($) {
																		return $.emailMessage;
																	})),
															$author$project$Forward$Remote$toMaybe),
														$author$project$Pagination$entries(currentPage)))
											}),
										$author$project$HubTran$Effect$none) : _Utils_Tuple2(
										_Utils_update(
											model,
											{selectAllVisible: false, selectedSelectables: $timo_weike$generic_collections$ManualSet$empty}),
										$author$project$HubTran$Effect$none);
								} else {
									break _v13$6;
								}
							case 'ReplyEmailData':
								if (_v13.a.$ === 'RepliesQueue') {
									var _v15 = _v13.a;
									var currentPage = _v13.b.a.a;
									return (!model.selectAllVisible) ? _Utils_Tuple2(
										_Utils_update(
											model,
											{
												selectAllVisible: true,
												selectedSelectables: A2(
													$timo_weike$generic_collections$ManualSet$fromList,
													$author$project$Components$Dashboard$Pager$Selectable$toComparable,
													A2(
														$elm$core$List$filterMap,
														A2(
															$elm$core$Basics$composeL,
															$elm$core$Maybe$map(
																A2(
																	$elm$core$Basics$composeL,
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Dashboard$Pager$Selectable$EmailMessage,
																		function ($) {
																			return $.id;
																		}),
																	function ($) {
																		return $.emailMessage;
																	})),
															$author$project$Forward$Remote$toMaybe),
														$author$project$Pagination$entries(currentPage)))
											}),
										$author$project$HubTran$Effect$none) : _Utils_Tuple2(
										_Utils_update(
											model,
											{selectAllVisible: false, selectedSelectables: $timo_weike$generic_collections$ManualSet$empty}),
										$author$project$HubTran$Effect$none);
								} else {
									break _v13$6;
								}
							case 'ReadyToAuditCarrierInvoiceData':
								if (_v13.a.$ === 'ReadyToAuditQueue') {
									var _v16 = _v13.a;
									var currentPage = _v13.b.a.a;
									return (!model.selectAllVisible) ? _Utils_Tuple2(
										_Utils_update(
											model,
											{
												selectAllVisible: true,
												selectedSelectables: A2(
													$timo_weike$generic_collections$ManualSet$fromList,
													$author$project$Components$Dashboard$Pager$Selectable$toComparable,
													A2(
														$elm$core$List$filterMap,
														A2(
															$elm$core$Basics$composeL,
															$elm$core$Maybe$map(
																A2(
																	$elm$core$Basics$composeL,
																	$author$project$Components$Dashboard$Pager$Selectable$CarrierInvoice,
																	function ($) {
																		return $.carrierInvoiceId;
																	})),
															$author$project$Forward$Remote$toMaybe),
														$author$project$Pagination$entries(currentPage)))
											}),
										$author$project$HubTran$Effect$none) : _Utils_Tuple2(
										_Utils_update(
											model,
											{selectAllVisible: false, selectedSelectables: $timo_weike$generic_collections$ManualSet$empty}),
										$author$project$HubTran$Effect$none);
								} else {
									break _v13$6;
								}
							case 'UnsentExceptionedData':
								switch (_v13.a.$) {
									case 'ExceptionQueue':
										var _v17 = _v13.a;
										var currentPage = _v13.b.a.a;
										return A2($author$project$Components$DashboardPage$exceptionSelectAllVisible, model, currentPage);
									case 'WaitingQueue':
										var _v18 = _v13.a;
										var currentPage = _v13.b.a.a;
										return A2($author$project$Components$DashboardPage$exceptionSelectAllVisible, model, currentPage);
									default:
										break _v13$6;
								}
							case 'ProcessedBrokerData':
								if (((_v13.a.$ === 'FinalQueue') && (_v13.a.a.$ === 'ProcessedQueue')) && (_v13.a.a.a.$ === 'BrokerAccount')) {
									var _v19 = _v13.a.a.a;
									var brokerData = _v13.b.a.a;
									return _Utils_Tuple2(
										model.selectAllVisible ? _Utils_update(
											model,
											{
												processedBrokerModel: $author$project$Components$Dashboard$Processed$BrokerModel$clearSelection(model.processedBrokerModel),
												selectAllVisible: false
											}) : _Utils_update(
											model,
											{
												processedBrokerModel: A3(
													$author$project$Components$Dashboard$Processed$BrokerModel$setSelection,
													true,
													$author$project$Pagination$entries(
														A2($author$project$Pagination$map, $elm$core$Tuple$first, brokerData)),
													model.processedBrokerModel),
												selectAllVisible: true
											}),
										$author$project$HubTran$Effect$none);
								} else {
									break _v13$6;
								}
							default:
								break _v13$6;
						}
					} else {
						break _v13$6;
					}
				}
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'FinishedBulkLabel':
				if (action.a.$ === 'Ok') {
					return _Utils_Tuple2(
						A2(
							$author$project$Components$DashboardPage$updateBulkLabelModal,
							function (m) {
								return _Utils_update(
									m,
									{isPerforming: false});
							},
							model),
						function () {
							var _v20 = model.selectedQueue;
							if ((_v20.$ === 'FinalQueue') && (_v20.a.$ === 'ReviewQueue')) {
								var _v21 = _v20.a;
								return $author$project$HubTran$Effect$refresh(
									$author$project$Components$Dashboard$Review$Model$loadIds(
										A4($author$project$Components$Dashboard$QueueDateInfoHelper$maybeApplyFallbackQueueDatesForDashboardFilters, model.dashboardMode, model.selectedQueue, model.dashboardFilters, v3ReskinEnabled)));
							} else {
								return $author$project$HubTran$Effect$none;
							}
						}());
				} else {
					return _Utils_Tuple2(
						A2(
							$author$project$Components$DashboardPage$updateBulkLabelModal,
							function (m) {
								return _Utils_update(
									m,
									{isPerforming: false, succeeded: false});
							},
							model),
						$author$project$HubTran$Effect$none);
				}
			case 'FinishedIgnore':
				if (action.a.$ === 'Ok') {
					var toastEffect = v3ReskinEnabled ? $author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$success(
							A2(
								$author$project$Helpers$String$pluralize,
								{many: 'items were', one: 'item was'},
								$timo_weike$generic_collections$ManualSet$size(model.selectedSelectables)) + ' ignored')) : $author$project$HubTran$Effect$none;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$DashboardPage$updateIgnoreModal,
							function (m) {
								return _Utils_update(
									m,
									{isPerforming: false, isShown: false, succeeded: true});
							},
							_Utils_update(
								model,
								{
									processedBrokerModel: $author$project$Components$Dashboard$Processed$BrokerModel$clearSelection(model.processedBrokerModel),
									processedFactorModel: $author$project$Components$Dashboard$Processed$FactorModel$clearSelection(model.processedFactorModel),
									selectedSelectables: $timo_weike$generic_collections$ManualSet$empty
								})),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									A3($author$project$Components$DashboardPage$refreshIds, v3ReskinEnabled, model.dashboardMode, model.dashboardFilters),
									toastEffect
								])));
				} else {
					return _Utils_Tuple2(
						A2(
							$author$project$Components$DashboardPage$updateIgnoreModal,
							function (m) {
								return _Utils_update(
									m,
									{succeeded: false, text: 'An error occurred while attempting to ignore these entries. Please contact support.'});
							},
							model),
						$author$project$HubTran$Effect$none);
				}
			case 'ShowIgnoreModal':
				return model.ignoreModal.isPerforming ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateIgnoreModal,
						function (m) {
							return _Utils_update(
								m,
								{isShown: true});
						},
						A2(
							$author$project$Components$DashboardPage$updateIgnoreModal,
							$elm$core$Basics$always($author$project$Components$DashboardPage$initIgnoreModal),
							model)),
					$author$project$HubTran$Effect$none);
			case 'ShowBulkLabelModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bulkLabelModal: {isPerforming: false, isShown: true, selectedLabel: 0, succeeded: false}
						}),
					$author$project$HubTran$Effect$none);
			case 'DismissIgnoreModal':
				return _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateIgnoreModal,
						function (m) {
							return _Utils_update(
								m,
								{isShown: false});
						},
						model),
					$author$project$HubTran$Effect$none);
			case 'ShowMergeModal':
				return model.mergeModal.isPerforming ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateMergeModal,
						function (m) {
							return _Utils_update(
								m,
								{isShown: true});
						},
						A2(
							$author$project$Components$DashboardPage$updateMergeModal,
							$elm$core$Basics$always($author$project$Components$DashboardPage$initMergeModal),
							model)),
					$author$project$HubTran$Effect$none);
			case 'DismissMergeModal':
				return _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateMergeModal,
						function (m) {
							return _Utils_update(
								m,
								{isShown: false});
						},
						model),
					$author$project$HubTran$Effect$none);
			case 'PerformMerge':
				return _Utils_Tuple2(
					A2(
						$author$project$Components$DashboardPage$updateMergeModal,
						function (m) {
							return _Utils_update(
								m,
								{isPerforming: true});
						},
						model),
					$author$project$Components$DashboardPage$mergeSelectedEmails(model.selectedSelectables));
			case 'FinishedMerge':
				if (action.a.$ === 'Ok') {
					var toastEffect = v3ReskinEnabled ? $author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$success(
							A2(
								$author$project$Helpers$String$pluralize,
								{many: 'emails were', one: 'email was'},
								$timo_weike$generic_collections$ManualSet$size(model.selectedSelectables)) + ' merged')) : $author$project$HubTran$Effect$none;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$DashboardPage$updateMergeModal,
							function (m) {
								return _Utils_update(
									m,
									{isPerforming: false, isShown: false, succeeded: true});
							},
							_Utils_update(
								model,
								{selectedSelectables: $timo_weike$generic_collections$ManualSet$empty})),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									A3($author$project$Components$DashboardPage$refreshIds, v3ReskinEnabled, model.dashboardMode, model.dashboardFilters),
									toastEffect
								])));
				} else {
					return _Utils_Tuple2(
						A2(
							$author$project$Components$DashboardPage$updateMergeModal,
							function (m) {
								return _Utils_update(
									m,
									{isPerforming: false, succeeded: false, text: 'An error occurred while attempting to merge these emails. Please contact support.'});
							},
							model),
						$author$project$HubTran$Effect$none);
				}
			case 'SetDate':
				var date = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							currentDate: $elm$core$Maybe$Just(date)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetSortBy':
				var sortBy = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: A2($author$project$Domain$DashboardFilters$setSortBy, sortBy, model.dashboardFilters)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetTimezoneName':
				var name = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{
									timezoneName: $elm$core$Maybe$Just(name)
								}),
							timezoneName: $elm$core$Maybe$Just(name)
						}),
					$author$project$HubTran$Effect$none);
			case 'PreferredFiltersUpdated':
				var apiResult = action.a;
				return _Utils_Tuple2(
					model,
					function () {
						if (apiResult.$ === 'Ok') {
							return accountSettings.auditV3ReskinEnabledQueues ? $author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('Default labels have been updated')) : $author$project$HubTran$Effect$none;
						} else {
							return $author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert);
						}
					}());
			case 'DashboardPresenceMsg':
				var presenceMsg = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardPresence: $author$project$DashboardPresence$update(presenceMsg)
						}),
					$author$project$HubTran$Effect$none);
			case 'RefreshIds':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{shouldRefreshIds: false}),
					A3($author$project$Components$DashboardPage$refreshIds, v3ReskinEnabled, model.dashboardMode, model.dashboardFilters));
			case 'SetShouldRefreshIds':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{shouldRefreshIds: true}),
					$author$project$HubTran$Effect$none);
			case 'ProcessedFactorMsg':
				var factorMsg = action.a;
				var _v23 = data_.dashboardRows;
				if ((_v23.$ === 'Loaded') && (_v23.a.$ === 'ProcessedFactorData')) {
					var factorData = _v23.a.a;
					var _v24 = A4($author$project$Components$DashboardPage$updateProcessedFactor, factorData, model.sendingState, model.processedFactorModel, factorMsg);
					var parentEffect = _v24.parentEffect;
					var effect = _v24.effect;
					var newSendingState = _v24.newSendingState;
					var newFactorModel = _v24.newFactorModel;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								processedFactorModel: newFactorModel,
								selectedSelectables: A2($author$project$Components$DashboardPage$getProcessedFactorSelectedAsSelectables, factorData, newFactorModel),
								sendingState: newSendingState
							}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									A2($author$project$HubTran$Effect$map, $author$project$Components$DashboardPage$ProcessedFactorMsg, effect),
									A4($author$project$Components$DashboardPage$handleProcessedEffect, v3ReskinEnabled, model.dashboardMode, model.dashboardFilters, parentEffect)
								])));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'ProcessedBrokerMsg':
				var brokerMsg = action.a;
				var _v25 = model.selectedQueue;
				if ((_v25.$ === 'FinalQueue') && (_v25.a.$ === 'ProcessedQueue')) {
					var _v26 = A3($author$project$Components$DashboardPage$updateProcessedBroker, model.sendingState, model.processedBrokerModel, brokerMsg);
					var parentEffect = _v26.parentEffect;
					var effect = _v26.effect;
					var newSendingState = _v26.newSendingState;
					var newBrokerModel = _v26.newBrokerModel;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								processedBrokerModel: newBrokerModel,
								selectedSelectables: $author$project$Components$DashboardPage$getProcessedBrokerSelectedAsSelectables(newBrokerModel),
								sendingState: newSendingState
							}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									A2($author$project$HubTran$Effect$map, $author$project$Components$DashboardPage$ProcessedBrokerMsg, effect),
									A4($author$project$Components$DashboardPage$handleProcessedEffect, v3ReskinEnabled, model.dashboardMode, model.dashboardFilters, parentEffect)
								])));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'ReviewMsg':
				var reviewMsg = action.a;
				var reviewData = function () {
					var _v29 = data_.dashboardRows;
					if ((_v29.$ === 'Loaded') && (_v29.a.$ === 'ReviewData')) {
						var d = _v29.a.a;
						return $elm$core$Maybe$Just(d);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var _v27 = A4($author$project$Components$DashboardPage$updateReview, accountSettings, reviewMsg, model.reviewModel, reviewData);
				var newReviewModel = _v27.a;
				var effect = _v27.b;
				var reviewEffect = _v27.c;
				var reviewEffectEffect = function () {
					switch (reviewEffect.$) {
						case 'ReviewEffectNone':
							return $author$project$HubTran$Effect$none;
						case 'ReviewEffectRefreshIds':
							return A3($author$project$Components$DashboardPage$refreshIds, v3ReskinEnabled, model.dashboardMode, model.dashboardFilters);
						default:
							var path = reviewEffect.a;
							return A2($author$project$Components$DashboardPage$viewItem, path, model);
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							reviewModel: newReviewModel,
							selectedSelectables: A2(
								$timo_weike$generic_collections$ManualSet$fromList,
								$author$project$Components$Dashboard$Pager$Selectable$toComparable,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Dashboard$Review$Model$selectedSelectables(newReviewModel),
										reviewData)))
						}),
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[effect, reviewEffectEffect])));
			case 'ClearAllFilters':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							carrierDropdown: $author$project$Components$CarrierDropdown$clear(model.carrierDropdown),
							categoryDropdowns: A2(
								$elm$core$Dict$map,
								F2(
									function (_v30, dropdown) {
										return $author$project$Ui$V3$CustomSelect$clearSelections(dropdown);
									}),
								model.categoryDropdowns),
							customerDropdown: $author$project$Components$CustomerDropdown$clear(model.customerDropdown),
							dashboardFilters: _Utils_update(
								dashboardFilters,
								{
									categories: $author$project$Domain$CategoryFilter$clearSelection(model.dashboardFilters.categories),
									customers: _List_Nil,
									endDate: $elm$core$Maybe$Nothing,
									endDateTime: $elm$core$Maybe$Nothing,
									exceptions: _List_Nil,
									factorBrokerIds: _List_Nil,
									labelFilters: $author$project$Components$Dashboard$FilterBar$LabelFilters$clearAll(model.dashboardFilters.labelFilters),
									startDate: $elm$core$Maybe$Nothing,
									startDateTime: $elm$core$Maybe$Nothing,
									tmsCarrierIds: _List_Nil
								}),
							debtorDropdown: $author$project$Components$DebtorDropdown$clear(model.debtorDropdown),
							endDate: $elm$core$Maybe$Nothing,
							endDateTime: $elm$core$Maybe$Nothing,
							startDate: $elm$core$Maybe$Nothing,
							startDateTime: $elm$core$Maybe$Nothing
						}),
					A3($author$project$Components$DashboardPage$refreshIds, v3ReskinEnabled, model.dashboardMode, model.dashboardFilters));
			case 'DashboardSavedFilterSelected':
				var dashboardSavedFilterData = action.a;
				return _Utils_Tuple2(
					A3($author$project$Components$DashboardPage$applyDashboardSavedFilterToModel, data_, dashboardSavedFilterData, model),
					$author$project$HubTran$Effect$none);
			case 'DashboardSavedFilterSaving':
				var newDashboardSavedFilter = {
					dashboardMode: model.dashboardMode,
					filter: $author$project$Domain$DashboardFilters$toPb(model.dashboardFilters),
					id: $author$project$Domain$DashboardSavedFilterId$fromInt(0),
					isDefault: false,
					name: ''
				};
				var filterModal = $author$project$Components$DashboardSavedFilterSaveModal$open(newDashboardSavedFilter);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dashboardSavedFilterSaveModal: filterModal}),
					$author$project$HubTran$Effect$none);
			case 'DashboardSavedFilterSaveModalMsg':
				var msg = action.a;
				var _v31 = A2($author$project$Components$DashboardSavedFilterSaveModal$update, msg, model.dashboardSavedFilterSaveModal);
				var modal = _v31.a;
				var effect = _v31.b;
				var childEffect = A2($author$project$HubTran$Effect$map, $author$project$Components$DashboardPage$DashboardSavedFilterSaveModalMsg, effect);
				var newModel = _Utils_update(
					model,
					{dashboardSavedFilterSaveModal: modal});
				if (msg.$ === 'SaveFinished') {
					var apiResult = msg.a;
					return A3($author$project$Components$DashboardPage$refreshDashboardSavedFilters, apiResult, newModel, childEffect);
				} else {
					return _Utils_Tuple2(newModel, childEffect);
				}
			case 'DashboardSavedFiltersRefreshed':
				var newModal = model.dashboardSavedFilterEditModal.isOpen ? $author$project$Components$DashboardPage$initDashboardSavedFilterEditModal(data_) : model.dashboardSavedFilterEditModal;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dashboardSavedFilterEditModal: newModal, dashboardSavedFilterRefreshing: false}),
					$author$project$HubTran$Effect$none);
			case 'DashboardSavedFilterOpenEditModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dashboardSavedFilterEditModal: $author$project$Components$DashboardPage$initDashboardSavedFilterEditModal(data_)
						}),
					$author$project$HubTran$Effect$none);
			case 'DashboardSavedFilterEditModalMsg':
				var msg = action.a;
				var _v33 = A2($author$project$Components$DashboardSavedFilterEditModal$update, msg, model.dashboardSavedFilterEditModal);
				var modal = _v33.a;
				var effect = _v33.b;
				var childEffect = A2($author$project$HubTran$Effect$map, $author$project$Components$DashboardPage$DashboardSavedFilterEditModalMsg, effect);
				var newModel = _Utils_update(
					model,
					{dashboardSavedFilterEditModal: modal});
				switch (msg.$) {
					case 'SaveFinished':
						var apiResult = msg.a;
						return A3($author$project$Components$DashboardPage$refreshDashboardSavedFilters, apiResult, newModel, childEffect);
					case 'DeleteClickFinished':
						var apiResult = msg.a;
						return A3($author$project$Components$DashboardPage$refreshDashboardSavedFilters, apiResult, newModel, childEffect);
					case 'SetDefaultFinished':
						var apiResult = msg.a;
						return A3($author$project$Components$DashboardPage$refreshDashboardSavedFilters, apiResult, newModel, childEffect);
					default:
						return _Utils_Tuple2(newModel, childEffect);
				}
			case 'ToggleFilters':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showFilters: !model.showFilters}),
					$author$project$HubTran$Effect$none);
			case 'ViewportChanged':
				return _Utils_Tuple2(model, $author$project$Components$DashboardPage$getTableElementEffect);
			case 'GotTableElement':
				var result = action.a;
				return _Utils_Tuple2(
					function () {
						if (result.$ === 'Ok') {
							var element = result.a;
							return _Utils_update(
								model,
								{
									tableElement: $elm$core$Maybe$Just(element)
								});
						} else {
							return model;
						}
					}(),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$DashboardPage$update = F4(
	function (v3ReskinEnabled, remoteData, msg, oldModel) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Just') {
			var data = _v0.a;
			var _v1 = A4($author$project$Components$DashboardPage$updateLogic, v3ReskinEnabled, data, msg, oldModel);
			var updatedModel = _v1.a;
			var effects = _v1.b;
			var _v2 = A2($author$project$Components$DashboardPage$maybeApplyDefaultFilter, data, updatedModel);
			var newModel = _v2.a;
			var defaultFilterEffects = _v2.b;
			return _Utils_Tuple2(
				newModel,
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[
							effects,
							defaultFilterEffects,
							A3($author$project$Components$DashboardPage$maybeUpdateBrowserUrl, data.accountSettings, oldModel, newModel)
						])));
		} else {
			var _v3 = A2($elm$core$Debug$log, 'DashboardPage.update: WARNING, skipping update because data is not loaded', remoteData);
			return _Utils_Tuple2(oldModel, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$AuditApi$applyRequestWithRequestStateAccessors = F5(
	function (model, postRequestStateGetter, postRequestStateSetter, responseState, onSuccess) {
		var requestState = postRequestStateGetter(model);
		var _v0 = A2($author$project$PostRequestState$handleResponseCustom, requestState, responseState);
		var newRequestState = _v0.a;
		var result = _v0.b;
		var newModel = A2(postRequestStateSetter, model, newRequestState);
		if (result.$ === 'Ok') {
			var outerSuccess = result.a;
			if (outerSuccess.$ === 'Ok') {
				var successVal = outerSuccess.a;
				return A2(onSuccess, newModel, successVal);
			} else {
				var err = outerSuccess.a;
				return _Utils_Tuple2(
					newModel,
					$author$project$Helpers$HttpError$defaultHttpErrorHandler(err));
			}
		} else {
			var err = result.a;
			return _Utils_Tuple2(
				newModel,
				$author$project$Helpers$HttpError$defaultHttpErrorHandler(err));
		}
	});
var $author$project$AuditApi$applyRequest = F3(
	function (model, responseState, onSuccess) {
		return A5(
			$author$project$AuditApi$applyRequestWithRequestStateAccessors,
			model,
			function ($) {
				return $.requestState;
			},
			F2(
				function (m, requestState) {
					return _Utils_update(
						m,
						{requestState: requestState});
				}),
			responseState,
			onSuccess);
	});
var $author$project$Components$DocumentBatchReviewPage$handleCardSelectionChanged = F3(
	function (selectedDocumentIds, data, model) {
		if (selectedDocumentIds.b && (!selectedDocumentIds.b.b)) {
			var documentId = selectedDocumentIds.a;
			var firstDocumentPageId = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.id;
				},
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (documentPages) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								false,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.documentId;
									},
									$elm$core$Basics$eq(documentId)),
								$elm$core$List$head(documentPages));
						},
						data.documentPagesByDocument)));
			var newCurrentProcessingSelection = A3(
				$author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchReviewSelection,
				model.documentBatchReviewId,
				$elm$core$Maybe$Just(documentId),
				firstDocumentPageId);
			return _Utils_update(
				model,
				{
					documentsBrowser: A2(
						$author$project$Components$DocumentsBrowser$setMaybeSelectedDocumentPageId,
						newCurrentProcessingSelection,
						A2($author$project$Components$DocumentsBrowser$setCurrentProcessingSelection, newCurrentProcessingSelection, model.documentsBrowser))
				});
		} else {
			return model;
		}
	});
var $author$project$Components$DocumentBatchReviewPage$ReviewCompleteResponse = function (a) {
	return {$: 'ReviewCompleteResponse', a: a};
};
var $author$project$AuditPb$documentBatchGroupingReviewDocumentGroupEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'position', $elm$json$Json$Encode$int, v.position),
					A3(
					$author$project$AuditPb$repeatedFieldEncoder,
					'document_ids',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentId$toInt),
					v.documentIds)
				])));
};
var $author$project$AuditPb$documentBatchGroupingReviewCompletionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'documentBatchGroupingReviewId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentBatchGroupingReviewId$toInt),
					v.documentBatchGroupingReviewId),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'groupings', $author$project$AuditPb$documentBatchGroupingReviewDocumentGroupEncoder, v.groupings)
				])));
};
var $author$project$AuditPb$documentGroupLoadReviewCompletionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'documentGroupLoadReviewId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentGroupLoadReviewId$toInt),
					v.documentGroupLoadReviewId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'assignedLoadStateId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$LoadStateId$toInt),
					v.assignedLoadStateId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'assignedCarrierId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCarrierId$toInt),
					v.assignedCarrierId)
				])));
};
var $author$project$AuditPb$documentLoadReferenceMatchReviewCompletionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'documentLoadReferenceMatchReviewId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentLoadReferenceMatchReviewId$toInt),
					v.documentLoadReferenceMatchReviewId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'documentReferencesMatchLoad', $elm$json$Json$Encode$bool, v.documentReferencesMatchLoad),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'matchedValues', $elm$json$Json$Encode$string, v.matchedValues)
				])));
};
var $author$project$AuditPb$documentTypeEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$documentTypeToString);
var $author$project$AuditPb$documentTypeReviewCompletionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'documentTypeReviewId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentTypeReviewId$toInt),
					v.documentTypeReviewId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'assignedDocumentType', $author$project$AuditPb$documentTypeEncoder, v.assignedDocumentType)
				])));
};
var $author$project$AuditPb$invoiceAmountReviewNoResultFoundToString = function (v) {
	return 'NO_INVOICE_AMOUNT';
};
var $author$project$AuditPb$invoiceAmountReviewNoResultFoundEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$invoiceAmountReviewNoResultFoundToString);
var $author$project$AuditPb$invoiceAmountReviewResultFoundEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'assigned_amount', $elm$json$Json$Encode$string, v.assignedAmount)
				])));
};
var $author$project$AuditPb$invoiceAmountReviewCompletionRequest_ResultEncoder = function (v) {
	if (v.$ === 'InvoiceAmountReviewCompletionRequest_Result_InvoiceAmountReviewResultFound') {
		var x = v.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				'resultFound',
				$author$project$AuditPb$invoiceAmountReviewResultFoundEncoder(x)));
	} else {
		var x = v.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				'noResultFound',
				$author$project$AuditPb$invoiceAmountReviewNoResultFoundEncoder(x)));
	}
};
var $author$project$AuditPb$invoiceAmountReviewCompletionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'invoiceAmountReviewId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$InvoiceAmountReviewId$toInt),
					v.invoiceAmountReviewId),
					$author$project$AuditPb$invoiceAmountReviewCompletionRequest_ResultEncoder(v.result)
				])));
};
var $author$project$AuditPb$invoiceNumberReviewCompletionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'invoiceNumberReviewId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$InvoiceNumberReviewId$toInt),
					v.invoiceNumberReviewId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'assignedInvoiceNumber', $elm$json$Json$Encode$string, v.assignedInvoiceNumber)
				])));
};
var $author$project$AuditPb$multiPageBolReviewCompletionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'multiPageBolReviewId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$MultiPageBolReviewId$toInt),
					v.multiPageBolReviewId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'allPagesAreSameBol', $elm$json$Json$Encode$string, v.allPagesAreSameBol),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'allPagesOfBolPresent', $elm$json$Json$Encode$string, v.allPagesOfBolPresent)
				])));
};
var $author$project$AuditPb$documentReviewCompletionRequest_CompletedReviewEncoder = function (v) {
	switch (v.$) {
		case 'DocumentReviewCompletionRequest_CompletedReview_DocumentTypeReviewCompletionRequest':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'documentTypeReview',
					$author$project$AuditPb$documentTypeReviewCompletionRequestEncoder(x)));
		case 'DocumentReviewCompletionRequest_CompletedReview_InvoiceNumberReviewCompletionRequest':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'invoiceNumberReview',
					$author$project$AuditPb$invoiceNumberReviewCompletionRequestEncoder(x)));
		case 'DocumentReviewCompletionRequest_CompletedReview_InvoiceAmountReviewCompletionRequest':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'invoiceAmountReview',
					$author$project$AuditPb$invoiceAmountReviewCompletionRequestEncoder(x)));
		case 'DocumentReviewCompletionRequest_CompletedReview_MultiPageBolReviewCompletionRequest':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'multiPageBolReview',
					$author$project$AuditPb$multiPageBolReviewCompletionRequestEncoder(x)));
		case 'DocumentReviewCompletionRequest_CompletedReview_DocumentLoadReferenceMatchReviewCompletionRequest':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'documentLoadReferenceMatchReview',
					$author$project$AuditPb$documentLoadReferenceMatchReviewCompletionRequestEncoder(x)));
		case 'DocumentReviewCompletionRequest_CompletedReview_DocumentBatchGroupingReviewCompletionRequest':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'documentBatchGroupingReview',
					$author$project$AuditPb$documentBatchGroupingReviewCompletionRequestEncoder(x)));
		default:
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'documentGroupLoadReview',
					$author$project$AuditPb$documentGroupLoadReviewCompletionRequestEncoder(x)));
	}
};
var $author$project$AuditPb$documentReviewCompletionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$AuditPb$documentReviewCompletionRequest_CompletedReviewEncoder(v.completedReview)
				])));
};
var $author$project$AuditApi$documentReviewServiceCompleteWithState = A3($author$project$AuditApi$toRequestState, '/document_review_service/complete', $author$project$AuditPb$documentReviewCompletionRequestEncoder, $author$project$AuditPb$documentReviewStartNextResponseDecoder);
var $author$project$Components$DocumentBatchReviewPage$handleMaybeSubmit = F2(
	function (maybeSubmit, model_) {
		if (maybeSubmit.$ === 'Nothing') {
			return _Utils_Tuple2(model_, $author$project$HubTran$Effect$none);
		} else {
			var documentReviewCompletionRequest = maybeSubmit.a;
			return A3($author$project$AuditApi$documentReviewServiceCompleteWithState, model_, $author$project$Components$DocumentBatchReviewPage$ReviewCompleteResponse, documentReviewCompletionRequest);
		}
	});
var $author$project$Components$DocumentReview$DocumentReviewFlow$afterFlowModeRedirectEffect = F2(
	function (onDone, flashMessage) {
		var targetUrl = function () {
			if (onDone.$ === 'Just') {
				var onDonePath = onDone.a;
				return $elm$core$String$isEmpty(onDonePath) ? '/app' : onDonePath;
			} else {
				return '/app';
			}
		}();
		return $author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$flash(
					$author$project$HubTran$Flash$success(flashMessage)),
					$author$project$HubTran$Effect$load(targetUrl)
				]));
	});
var $author$project$Components$DocumentReview$DocumentReviewFlow$goToNextReviewOrFlowModeEffect = F2(
	function (startNextResponse, _v0) {
		var noResultFlashMessage = _v0.noResultFlashMessage;
		var resultFlashMessage = _v0.resultFlashMessage;
		var onDoneUrlFragment = _v0.onDoneUrlFragment;
		var nextPath = $author$project$Components$DocumentReview$DocumentReviewFlow$nextUrlPath(startNextResponse);
		if (nextPath.$ === 'Just') {
			var path = nextPath.a;
			return $author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$HubTran$Effect$none,
						A2($elm$core$Basics$composeL, $author$project$HubTran$Effect$flash, $author$project$HubTran$Flash$success),
						resultFlashMessage),
						$author$project$HubTran$Effect$pushUrl(
						A2(
							$elm$url$Url$Builder$absolute,
							path,
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'onDone',
									A2($elm$core$Maybe$withDefault, '', onDoneUrlFragment))
								])))
					]));
		} else {
			return A2($author$project$Components$DocumentReview$DocumentReviewFlow$afterFlowModeRedirectEffect, onDoneUrlFragment, noResultFlashMessage);
		}
	});
var $author$project$Components$DocumentBatchReviewPage$handleReviewCompleteSuccess = F3(
	function (onDone, model, response) {
		return _Utils_Tuple2(
			model,
			A2(
				$author$project$Components$DocumentReview$DocumentReviewFlow$goToNextReviewOrFlowModeEffect,
				response,
				{
					noResultFlashMessage: 'Document review saved successfully!',
					onDoneUrlFragment: onDone,
					resultFlashMessage: $elm$core$Maybe$Just('Success, here\u0027s the next review!')
				}));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$ApiCallComplete = {$: 'ApiCallComplete'};
var $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentBatchGroupingReviewCompletionRequest = function (a) {
	return {$: 'DocumentReviewCompletionRequest_CompletedReview_DocumentBatchGroupingReviewCompletionRequest', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DocumentsBrowserMsg = function (a) {
	return {$: 'DocumentsBrowserMsg', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Components$DocumentBatchGroupingReviewPage$PreviewingDocument = F2(
	function (a, b) {
		return {$: 'PreviewingDocument', a: a, b: b};
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$ReloadData = {$: 'ReloadData'};
var $author$project$Components$DocumentBatchGroupingReviewPage$Submit = function (a) {
	return {$: 'Submit', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NotHovering = {$: 'NotHovering'};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$init = {isMenuOpen: false};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$init = {cardManagementMenu: $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$init, hoveringOver: $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NotHovering, isSelected: false};
var $author$project$Components$DocumentBatchGroupingReviewPage$GroupableDocumentId$forDocumentId = function (documentId) {
	return {cardModel: $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$init, documentId: documentId, groupIndex: $elm$core$Maybe$Nothing, isGroupCollapsed: false};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$allGroupableDocumentIds = F3(
	function (documents, documentsPagesByDocument, groupableDocumentIds) {
		var idsAlreadyGrouped = A2(
			$elm$core$List$map,
			function ($) {
				return $.documentId;
			},
			groupableDocumentIds);
		var idsNotInAnyGroup = A2(
			$elm$core$List$map,
			function ($) {
				return $.id;
			},
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var id = _v1.id;
					return !A2($elm$core$List$member, id, idsAlreadyGrouped);
				},
				documents));
		var ungroupableDocumentIds = A2($elm$core$List$map, $author$project$Components$DocumentBatchGroupingReviewPage$GroupableDocumentId$forDocumentId, idsNotInAnyGroup);
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var documentId = _v0.documentId;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						A2(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							false,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.documentId;
								},
								$elm$core$Basics$eq(documentId)))),
					documentsPagesByDocument);
			},
			_Utils_ap(ungroupableDocumentIds, groupableDocumentIds));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$deselect = function (model) {
	return _Utils_update(
		model,
		{isSelected: false});
};
var $author$project$Components$DocumentBatchGroupingReviewPage$groupingsForSubmit = function (groupableDocumentIds) {
	var groupToApiData = F2(
		function (index, _v0) {
			var groupableDocumentId = _v0.a;
			var rest = _v0.b;
			return {
				documentIds: A2(
					$elm$core$List$cons,
					groupableDocumentId.documentId,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.documentId;
						},
						rest)),
				position: index + 1
			};
		});
	return A2(
		$elm$core$List$indexedMap,
		groupToApiData,
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.groupIndex;
					},
					$elm$core$Maybe$withDefault(-1))),
			A2(
				$elm_community$list_extra$List$Extra$gatherEqualsBy,
				function ($) {
					return $.groupIndex;
				},
				groupableDocumentIds)));
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isSelected = function (model) {
	return model.isSelected;
};
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$toggleCollapse = F3(
	function (groupIndex, isCollapsed, groupableDocumentIds) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.groupIndex;
				},
				$elm$core$Basics$eq(groupIndex)),
			function (groupableDocumentId) {
				return _Utils_update(
					groupableDocumentId,
					{
						cardModel: isCollapsed ? $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$deselect(groupableDocumentId.cardModel) : groupableDocumentId.cardModel,
						isGroupCollapsed: isCollapsed
					});
			},
			groupableDocumentIds);
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$handleCardManagementOutMsg = F3(
	function (cardManagementOutMsg, groupableDocumentId, groupableDocumentIds) {
		var updatedGroupableDocumentId = function () {
			if (cardManagementOutMsg.$ === 'ChangeGroup') {
				var groupOption = cardManagementOutMsg.a;
				return _Utils_update(
					groupableDocumentId,
					{
						cardModel: $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$deselect(groupableDocumentId.cardModel),
						groupIndex: function () {
							switch (groupOption.$) {
								case 'Ungrouped':
									return $elm$core$Maybe$Nothing;
								case 'Grouped':
									var index = groupOption.a;
									return $elm$core$Maybe$Just(index);
								default:
									return $elm$core$Maybe$Just(
										1 + A2(
											$elm$core$Maybe$withDefault,
											-1,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.groupIndex;
												},
												A2(
													$elm_community$list_extra$List$Extra$maximumBy,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.groupIndex;
														},
														$elm$core$Maybe$withDefault(-1)),
													groupableDocumentIds))));
							}
						}()
					});
			} else {
				return groupableDocumentId;
			}
		}();
		var withAllSelectedCardsUpdated = _Utils_eq(updatedGroupableDocumentId.groupIndex, groupableDocumentId.groupIndex) ? groupableDocumentIds : A3(
			$elm_community$list_extra$List$Extra$updateIf,
			function (thisGroupableDocumentId) {
				return $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isSelected(thisGroupableDocumentId.cardModel) && (!_Utils_eq(thisGroupableDocumentId.documentId, updatedGroupableDocumentId.documentId));
			},
			function (thisGroupableDocumentId) {
				return _Utils_update(
					thisGroupableDocumentId,
					{
						cardModel: $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$deselect(thisGroupableDocumentId.cardModel),
						groupIndex: updatedGroupableDocumentId.groupIndex
					});
			},
			groupableDocumentIds);
		return A3(
			$author$project$Components$DocumentBatchGroupingReviewPage$toggleCollapse,
			updatedGroupableDocumentId.groupIndex,
			false,
			A3(
				$elm_community$list_extra$List$Extra$updateIf,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.documentId;
					},
					$elm$core$Basics$eq(groupableDocumentId.documentId)),
				$elm$core$Basics$always(updatedGroupableDocumentId),
				withAllSelectedCardsUpdated));
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $elm_community$list_extra$List$Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3($elm$core$List$foldl, $elm$core$List$cons, list2, list1);
	});
var $elm_community$list_extra$List$Extra$removeHelp = F4(
	function (list, x, xs, previousElements) {
		removeHelp:
		while (true) {
			if (!xs.b) {
				return list;
			} else {
				var y = xs.a;
				var ys = xs.b;
				if (_Utils_eq(x, y)) {
					return A2($elm_community$list_extra$List$Extra$reverseAppend, previousElements, ys);
				} else {
					var $temp$list = list,
						$temp$x = x,
						$temp$xs = ys,
						$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
					list = $temp$list;
					x = $temp$x;
					xs = $temp$xs;
					previousElements = $temp$previousElements;
					continue removeHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		return A4($elm_community$list_extra$List$Extra$removeHelp, xs, x, xs, _List_Nil);
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$withoutDraggedItems = function (_v0) {
	var draggedItems = _v0.draggedItems;
	var fullList = _v0.fullList;
	return A3(
		$elm$core$List$foldl,
		F2(
			function (id, list) {
				return A2($elm_community$list_extra$List$Extra$remove, id, list);
			}),
		fullList,
		draggedItems);
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$handleInsertBefore = function (_v0) {
	var draggedGroupDocumentIds = _v0.draggedGroupDocumentIds;
	var groupableDocumentIds = _v0.groupableDocumentIds;
	var droppedOntoDocumentId = _v0.droppedOntoDocumentId;
	var droppedOntoGroupedDocumentIndex = A2(
		$elm_community$list_extra$List$Extra$findIndex,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.documentId;
			},
			$elm$core$Basics$eq(droppedOntoDocumentId)),
		groupableDocumentIds);
	var droppedOntoGroupableDocumentId = A2(
		$elm$core$Maybe$andThen,
		function (index) {
			return A2($elm_community$list_extra$List$Extra$getAt, index, groupableDocumentIds);
		},
		droppedOntoGroupedDocumentIndex);
	var droppedElementIndex = A2(
		$elm_community$list_extra$List$Extra$findIndex,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.documentId;
			},
			$elm$core$Basics$eq(droppedOntoDocumentId)),
		groupableDocumentIds);
	var draggedElementIndexes = A2(
		$elm$core$List$filterMap,
		function (item) {
			return A2(
				$elm_community$list_extra$List$Extra$findIndex,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.documentId;
					},
					$elm$core$Basics$eq(item.documentId)),
				groupableDocumentIds);
		},
		draggedGroupDocumentIds);
	var anyDraggedElementsAfterDropped = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		false,
		function (droppedIndex) {
			return A2(
				$elm$core$List$any,
				$elm$core$Basics$gt(droppedIndex),
				draggedElementIndexes);
		},
		droppedElementIndex);
	var updateGroupableDocumentIds = F2(
		function (droppedIndex, dropped) {
			var updatedDroppedItems = A2(
				$elm$core$List$map,
				function (item) {
					return _Utils_update(
						item,
						{groupIndex: dropped.groupIndex});
				},
				draggedGroupDocumentIds);
			var indexToSplitAt = anyDraggedElementsAfterDropped ? (droppedIndex - 1) : droppedIndex;
			return function (_v1) {
				var beforeDropSite = _v1.a;
				var dropSiteAndAfter = _v1.b;
				return _Utils_ap(
					beforeDropSite,
					_Utils_ap(updatedDroppedItems, dropSiteAndAfter));
			}(
				A2(
					$elm_community$list_extra$List$Extra$splitAt,
					indexToSplitAt,
					$author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$withoutDraggedItems(
						{draggedItems: draggedGroupDocumentIds, fullList: groupableDocumentIds})));
		});
	return A2(
		$elm$core$Maybe$withDefault,
		groupableDocumentIds,
		A3($elm$core$Maybe$map2, updateGroupableDocumentIds, droppedOntoGroupedDocumentIndex, droppedOntoGroupableDocumentId));
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$handleDrop = F3(
	function (draggedDocumentId, dropSite, groupableDocumentIds) {
		var draggedGroupDocumentIds = A2(
			$elm$core$List$filter,
			function (item) {
				return $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isSelected(item.cardModel) || _Utils_eq(item.documentId, draggedDocumentId);
			},
			groupableDocumentIds);
		if (dropSite.$ === 'InsertBefore') {
			var droppedOntoDocumentId = dropSite.a;
			return $elm_community$maybe_extra$Maybe$Extra$isJust(
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.documentId;
						},
						$elm$core$Basics$eq(droppedOntoDocumentId)),
					draggedGroupDocumentIds)) ? groupableDocumentIds : $author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$handleInsertBefore(
				{draggedGroupDocumentIds: draggedGroupDocumentIds, droppedOntoDocumentId: droppedOntoDocumentId, groupableDocumentIds: groupableDocumentIds});
		} else {
			var groupIndex = dropSite.a;
			return function (list) {
				return _Utils_ap(
					list,
					A2(
						$elm$core$List$map,
						function (dragged) {
							return _Utils_update(
								dragged,
								{groupIndex: groupIndex});
						},
						draggedGroupDocumentIds));
			}(
				$author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$withoutDraggedItems(
					{draggedItems: draggedGroupDocumentIds, fullList: groupableDocumentIds}));
		}
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$handleDragDropOutMsg = F3(
	function (data, outMsg, model) {
		var groupableDocumentIds = A3($author$project$Components$DocumentBatchGroupingReviewPage$allGroupableDocumentIds, data.documents, data.documentPagesByDocument, model.groupableDocumentIds);
		if (outMsg.$ === 'Dropped') {
			var draggedDocumentId = outMsg.a.a;
			var dropSite = outMsg.b;
			return _Utils_update(
				model,
				{
					groupableDocumentIds: A3($author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$handleDrop, draggedDocumentId, dropSite, groupableDocumentIds)
				});
		} else {
			return model;
		}
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$CardSelectionChanged = function (a) {
	return {$: 'CardSelectionChanged', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$selectedDocuments = function (model) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.cardModel;
			},
			$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isSelected),
		model.groupableDocumentIds);
};
var $author$project$Components$DocumentBatchGroupingReviewPage$firstCurrentlySelectedCard = function (model) {
	return $elm$core$List$head(
		$author$project$Components$DocumentBatchGroupingReviewPage$selectedDocuments(model));
};
var $author$project$Components$DocumentBatchGroupingReviewPage$numberOfCardsSelected = function (model) {
	return $elm$core$List$length(
		$author$project$Components$DocumentBatchGroupingReviewPage$selectedDocuments(model));
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardSelectionChanged = {$: 'CardSelectionChanged'};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$SplitDocumentPage = F2(
	function (a, b) {
		return {$: 'SplitDocumentPage', a: a, b: b};
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$closeMenu = function (model) {
	return _Utils_update(
		model,
		{isMenuOpen: false});
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$closeMenu = function (model) {
	return _Utils_update(
		model,
		{
			cardManagementMenu: $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$closeMenu(model.cardManagementMenu)
		});
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardManagementOutMsg = function (a) {
	return {$: 'CardManagementOutMsg', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$handleCardManagementOutMsg = F3(
	function (updatedCardManagementMenu, cardManagementOutMsg, model) {
		if (cardManagementOutMsg.$ === 'ChangeGroup') {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{cardManagementMenu: updatedCardManagementMenu, hoveringOver: $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NotHovering, isSelected: false}),
				$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardManagementOutMsg(cardManagementOutMsg));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{cardManagementMenu: updatedCardManagementMenu}),
				$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NoOutMsg);
		}
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$ChangeGroup = function (a) {
	return {$: 'ChangeGroup', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'MoveToGroup':
				var groupOption = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isMenuOpen: false}),
					$author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$ChangeGroup(groupOption));
			case 'MenuClick':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isMenuOpen: !model.isMenuOpen}),
					$author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$NoOutMsg);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isMenuOpen: false}),
					$author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$NoOutMsg);
		}
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$update = F3(
	function (_v0, model, msg) {
		var numberOfCardsSelected = _v0.numberOfCardsSelected;
		var groupIndex = _v0.groupIndex;
		var currentlySelectedGroupIndex = _v0.currentlySelectedGroupIndex;
		var documentId = _v0.documentId;
		switch (msg.$) {
			case 'CardHoverChange':
				var newHoverOver = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hoveringOver: newHoverOver}),
					$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NoOutMsg);
			case 'CardClick':
				var isShift = msg.a.isShift;
				var selectsCard = (isShift || (!numberOfCardsSelected)) && ($elm_community$maybe_extra$Maybe$Extra$isNothing(currentlySelectedGroupIndex) || _Utils_eq(
					currentlySelectedGroupIndex,
					$elm$core$Maybe$Just(groupIndex)));
				return selectsCard ? _Utils_Tuple2(
					$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$closeMenu(
						_Utils_update(
							model,
							{isSelected: !model.isSelected})),
					$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardSelectionChanged) : _Utils_Tuple2(model, $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NoOutMsg);
			case 'CardManagementMenuMsg':
				var cardManagementMenuMsg = msg.a;
				var _v2 = A2($author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$update, cardManagementMenuMsg, model.cardManagementMenu);
				var updatedCardManagementMenu = _v2.a;
				var cardManagementOutMsg = _v2.b;
				return A3($author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$handleCardManagementOutMsg, updatedCardManagementMenu, cardManagementOutMsg, model);
			default:
				var documentPageId = msg.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$SplitDocumentPage, documentId, documentPageId));
		}
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$handleDraggableDocumentCardOutMsg = F4(
	function (draggableDocumentCardMsg, groupableDocumentId, groupableDocumentIds, model) {
		var _v0 = A3(
			$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$update,
			{
				currentlySelectedGroupIndex: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.groupIndex;
					},
					$author$project$Components$DocumentBatchGroupingReviewPage$firstCurrentlySelectedCard(model)),
				documentId: groupableDocumentId.documentId,
				groupIndex: groupableDocumentId.groupIndex,
				numberOfCardsSelected: $author$project$Components$DocumentBatchGroupingReviewPage$numberOfCardsSelected(model)
			},
			groupableDocumentId.cardModel,
			draggableDocumentCardMsg);
		var updatedCardModel = _v0.a;
		var draggableDocumentCardOutMsg = _v0.b;
		var effect = function () {
			switch (draggableDocumentCardOutMsg.$) {
				case 'CardSelectionChanged':
					return $author$project$HubTran$Effect$none;
				case 'CardManagementOutMsg':
					return $author$project$HubTran$Effect$none;
				case 'SplitDocumentPage':
					var documentId = draggableDocumentCardOutMsg.a;
					var documentPageId = draggableDocumentCardOutMsg.b;
					return A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						function (_v4) {
							return $author$project$Components$DocumentBatchGroupingReviewPage$ApiCallComplete;
						},
						A2($author$project$Api$Documents$splitPageFromDocument, documentId, documentPageId));
				default:
					return $author$project$HubTran$Effect$none;
			}
		}();
		var updatedGroupableDocumentId = _Utils_update(
			groupableDocumentId,
			{cardModel: updatedCardModel});
		var initiallyUpdatedGroupableDocumentIds = A3(
			$elm_community$list_extra$List$Extra$updateIf,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.documentId;
				},
				$elm$core$Basics$eq(updatedGroupableDocumentId.documentId)),
			$elm$core$Basics$always(updatedGroupableDocumentId),
			groupableDocumentIds);
		var updatedModel = function () {
			switch (draggableDocumentCardOutMsg.$) {
				case 'CardManagementOutMsg':
					var cardManagementOutMsg = draggableDocumentCardOutMsg.a;
					return _Utils_update(
						model,
						{
							groupableDocumentIds: A3($author$project$Components$DocumentBatchGroupingReviewPage$handleCardManagementOutMsg, cardManagementOutMsg, updatedGroupableDocumentId, initiallyUpdatedGroupableDocumentIds)
						});
				case 'CardSelectionChanged':
					return _Utils_update(
						model,
						{groupableDocumentIds: initiallyUpdatedGroupableDocumentIds});
				case 'SplitDocumentPage':
					return _Utils_update(
						model,
						{groupableDocumentIds: initiallyUpdatedGroupableDocumentIds, updating: true});
				default:
					return _Utils_update(
						model,
						{groupableDocumentIds: initiallyUpdatedGroupableDocumentIds});
			}
		}();
		var outMsg = function () {
			switch (draggableDocumentCardOutMsg.$) {
				case 'CardSelectionChanged':
					return $author$project$Components$DocumentBatchGroupingReviewPage$CardSelectionChanged(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.documentId;
							},
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.cardModel;
									},
									$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isSelected),
								updatedModel.groupableDocumentIds)));
				case 'CardManagementOutMsg':
					return $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg;
				case 'SplitDocumentPage':
					return $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg;
				default:
					return $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg;
			}
		}();
		return _Utils_Tuple3(updatedModel, effect, outMsg);
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$updateCardManagementMenu = F2(
	function (cardManagementMenu, model) {
		return _Utils_update(
			model,
			{cardManagementMenu: cardManagementMenu});
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$GroupableDocumentId$updateCardManagementMenu = F2(
	function (cardManagementMenu, groupableDocumentId) {
		return _Utils_update(
			groupableDocumentId,
			{
				cardModel: A2($author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$updateCardManagementMenu, cardManagementMenu, groupableDocumentId.cardModel)
			});
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$update = F3(
	function (remoteData, msg, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Nothing') {
			return {childEffect: $author$project$HubTran$Effect$none, newChildModel: model, outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg};
		} else {
			var data = _v0.a;
			var groupableDocumentIds = A3($author$project$Components$DocumentBatchGroupingReviewPage$allGroupableDocumentIds, data.documents, data.documentPagesByDocument, model.groupableDocumentIds);
			var documentPageIdForDocument = function (documentId) {
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.id;
					},
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$List$head,
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (pages) {
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									false,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.documentId;
										},
										$elm$core$Basics$eq(documentId)),
									$elm$core$List$head(pages));
							},
							data.documentPagesByDocument)));
			};
			switch (msg.$) {
				case 'DragDropMsg':
					var dragDropMsg = msg.a;
					var _v2 = A2($author$project$Components$DragDrop$update, dragDropMsg, model.dragDrop);
					var dragDrop = _v2.a;
					var outMsg = _v2.b;
					var newModel = A3(
						$author$project$Components$DocumentBatchGroupingReviewPage$handleDragDropOutMsg,
						data,
						outMsg,
						_Utils_update(
							model,
							{dragDrop: dragDrop}));
					return {childEffect: $author$project$HubTran$Effect$none, newChildModel: newModel, outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg};
				case 'BackgroundClick':
					return {
						childEffect: $author$project$HubTran$Effect$none,
						newChildModel: _Utils_update(
							model,
							{
								groupableDocumentIds: A2(
									$elm$core$List$map,
									function (groupableDocumentId) {
										return _Utils_update(
											groupableDocumentId,
											{
												cardModel: $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$deselect(groupableDocumentId.cardModel)
											});
									},
									groupableDocumentIds)
							}),
						outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg
					};
				case 'DraggableDocumentCardMsg':
					var documentId = msg.a;
					var draggableDocumentCardMsg = msg.b;
					var _v3 = A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.documentId;
							},
							$elm$core$Basics$eq(documentId)),
						groupableDocumentIds);
					if (_v3.$ === 'Nothing') {
						return {childEffect: $author$project$HubTran$Effect$none, newChildModel: model, outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg};
					} else {
						var groupableDocumentId = _v3.a;
						var _v4 = A4($author$project$Components$DocumentBatchGroupingReviewPage$handleDraggableDocumentCardOutMsg, draggableDocumentCardMsg, groupableDocumentId, groupableDocumentIds, model);
						var updatedModel = _v4.a;
						var effect = _v4.b;
						var outMsg = _v4.c;
						return {childEffect: effect, newChildModel: updatedModel, outMsg: outMsg};
					}
				case 'ToggleGroupCollapse':
					var groupIndex = msg.a;
					var isCollapsed = msg.b;
					return {
						childEffect: $author$project$HubTran$Effect$none,
						newChildModel: _Utils_update(
							model,
							{
								groupableDocumentIds: A3($author$project$Components$DocumentBatchGroupingReviewPage$toggleCollapse, groupIndex, isCollapsed, groupableDocumentIds)
							}),
						outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg
					};
				case 'PreviewDocument':
					var documentId = msg.a;
					var newSelection = A3(
						$author$project$Broker$Shared$CurrentProcessingSelection$DocumentBatchReviewSelection,
						model.documentBatchReviewId,
						$elm$core$Maybe$Just(documentId),
						documentPageIdForDocument(documentId));
					var _v5 = $author$project$Components$DocumentsBrowser$init(
						{
							currentProcessingSelection: newSelection,
							displayUnassignedLoadDocuments: true,
							enabledDocumentTypes: _List_Nil,
							enabledToolbarActions: _List_Nil,
							maybeDefaultViewMode: $elm$core$Maybe$Nothing,
							maybeOnDone: $elm$core$Maybe$Nothing,
							pageContextData: {
								carrierInvoiceHasSubmission: $elm$core$Maybe$Just(false),
								carrierInvoiceId: $elm$core$Maybe$Nothing,
								loadStateId: $elm$core$Maybe$Nothing
							},
							popout: false,
							scrollContainerSuffix: 'primary',
							viewPortHeightPxOffset: 0
						});
					var documentsBrowser = _v5.a;
					var documentsBrowserEffect = _v5.b;
					var documentsBrowserWithCorrectPage = A2(
						$author$project$Components$DocumentsBrowser$setMaybeSelectedDocumentPageId,
						newSelection,
						A2($author$project$Components$DocumentsBrowser$setCurrentProcessingSelection, newSelection, documentsBrowser));
					return {
						childEffect: A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentBatchGroupingReviewPage$DocumentsBrowserMsg, documentsBrowserEffect),
						newChildModel: _Utils_update(
							model,
							{
								documentPreview: A2($author$project$Components$DocumentBatchGroupingReviewPage$PreviewingDocument, documentId, documentsBrowserWithCorrectPage)
							}),
						outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg
					};
				case 'StopPreviewingDocument':
					return {
						childEffect: $author$project$HubTran$Effect$none,
						newChildModel: _Utils_update(
							model,
							{documentPreview: $author$project$Components$DocumentBatchGroupingReviewPage$NotPreviewing}),
						outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg
					};
				case 'DocumentsBrowserMsg':
					var documentsBrowserMsg = msg.a;
					var _v6 = model.documentPreview;
					if (_v6.$ === 'PreviewingDocument') {
						var documentId = _v6.a;
						var documentsBrowser = _v6.b;
						var _v7 = A4(
							$author$project$Components$DocumentsBrowser$update,
							A2(
								$author$project$Forward$Remote$andThen,
								function ($) {
									return $.documentsBrowserData;
								},
								remoteData),
							documentsBrowserMsg,
							documentsBrowser,
							$author$project$Components$DocumentsBrowser$noHooks);
						var updatedDocumentsBrowser = _v7.a;
						var documentsBrowserEffect = _v7.b;
						return {
							childEffect: A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentBatchGroupingReviewPage$DocumentsBrowserMsg, documentsBrowserEffect),
							newChildModel: _Utils_update(
								model,
								{
									documentPreview: A2($author$project$Components$DocumentBatchGroupingReviewPage$PreviewingDocument, documentId, updatedDocumentsBrowser)
								}),
							outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg
						};
					} else {
						return {childEffect: $author$project$HubTran$Effect$none, newChildModel: model, outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg};
					}
				case 'SubmitGroups':
					var completionRequest = {
						completedReview: $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentBatchGroupingReviewCompletionRequest(
							{
								documentBatchGroupingReviewId: model.documentBatchGroupingReviewId,
								groupings: $author$project$Components$DocumentBatchGroupingReviewPage$groupingsForSubmit(groupableDocumentIds)
							})
					};
					return {
						childEffect: $author$project$HubTran$Effect$none,
						newChildModel: model,
						outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$Submit(completionRequest)
					};
				case 'CardManagementMenuMsg':
					var documentId = msg.a;
					var cardManagementMenuMsg = msg.b;
					var _v8 = A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.documentId;
							},
							$elm$core$Basics$eq(documentId)),
						groupableDocumentIds);
					if (_v8.$ === 'Just') {
						var groupableDocumentId = _v8.a;
						var _v9 = A2($author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$update, cardManagementMenuMsg, groupableDocumentId.cardModel.cardManagementMenu);
						var updatedCardManagementMenu = _v9.a;
						var cardManagementOutMsg = _v9.b;
						var updatedGroupableDocumentIds = A3(
							$author$project$Components$DocumentBatchGroupingReviewPage$handleCardManagementOutMsg,
							cardManagementOutMsg,
							A2($author$project$Components$DocumentBatchGroupingReviewPage$GroupableDocumentId$updateCardManagementMenu, updatedCardManagementMenu, groupableDocumentId),
							model.groupableDocumentIds);
						return {
							childEffect: $author$project$HubTran$Effect$none,
							newChildModel: _Utils_update(
								model,
								{groupableDocumentIds: updatedGroupableDocumentIds}),
							outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg
						};
					} else {
						return {childEffect: $author$project$HubTran$Effect$none, newChildModel: model, outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg};
					}
				case 'MergeSelectedDocuments':
					var _v10 = $author$project$Components$DocumentBatchGroupingReviewPage$selectedDocuments(model);
					if ((_v10.b && _v10.b.b) && (!_v10.b.b.b)) {
						var mergeInto = _v10.a;
						var _v11 = _v10.b;
						var documentToMerge = _v11.a;
						return {
							childEffect: A2(
								$author$project$HubTran$Effect$sendCacheableRequestWithError,
								function (_v12) {
									return $author$project$Components$DocumentBatchGroupingReviewPage$ApiCallComplete;
								},
								$author$project$Api$Documents$mergeDocuments(
									{currentDocumentId: documentToMerge.documentId, intoDocumentId: mergeInto.documentId})),
							newChildModel: _Utils_update(
								model,
								{updating: true}),
							outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg
						};
					} else {
						return {childEffect: $author$project$HubTran$Effect$none, newChildModel: model, outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$NoOutMsg};
					}
				default:
					return {
						childEffect: $author$project$HubTran$Effect$none,
						newChildModel: _Utils_update(
							model,
							{updating: false}),
						outMsg: $author$project$Components$DocumentBatchGroupingReviewPage$ReloadData
					};
			}
		}
	});
var $author$project$Components$DocumentBatchReviewPage$update = F3(
	function (remoteData, msg, model) {
		switch (msg.$) {
			case 'DocumentsBrowserMsg':
				var documentsBrowserMsg = msg.a;
				var _v1 = A4(
					$author$project$Components$DocumentsBrowser$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.documentsBrowserData;
						},
						remoteData),
					documentsBrowserMsg,
					model.documentsBrowser,
					$author$project$Components$DocumentsBrowser$noHooks);
				var documentsBrowser = _v1.a;
				var documentsBrowserEffect = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{documentsBrowser: documentsBrowser}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentBatchReviewPage$DocumentsBrowserMsg, documentsBrowserEffect));
			case 'ReviewCompleteResponse':
				var response = msg.a;
				return A3(
					$author$project$AuditApi$applyRequest,
					model,
					response,
					$author$project$Components$DocumentBatchReviewPage$handleReviewCompleteSuccess(model.onDone));
			default:
				var childMsg = msg.a;
				var _v2 = model.childModel;
				var childModel = _v2.a;
				var _v3 = A3($author$project$Components$DocumentBatchGroupingReviewPage$update, remoteData, childMsg, childModel);
				var outMsg = _v3.outMsg;
				var childEffect = _v3.childEffect;
				var newChildModel = _v3.newChildModel;
				var modelWithPageUpdates = _Utils_update(
					model,
					{
						childModel: $author$project$Components$DocumentBatchReviewPage$DocumentBatchGroupingReviewPage(newChildModel)
					});
				var _v4 = function () {
					switch (outMsg.$) {
						case 'NoOutMsg':
							return _Utils_Tuple3(modelWithPageUpdates, $elm$core$Maybe$Nothing, $author$project$HubTran$Effect$none);
						case 'CardSelectionChanged':
							var selectedDocumentIds = outMsg.a;
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								_Utils_Tuple3(modelWithPageUpdates, $elm$core$Maybe$Nothing, $author$project$HubTran$Effect$none),
								function (data) {
									return _Utils_Tuple3(
										A3($author$project$Components$DocumentBatchReviewPage$handleCardSelectionChanged, selectedDocumentIds, data, modelWithPageUpdates),
										$elm$core$Maybe$Nothing,
										$author$project$HubTran$Effect$none);
								},
								$author$project$Forward$Remote$toMaybe(remoteData));
						case 'Submit':
							var completionRequest = outMsg.a;
							return _Utils_Tuple3(
								modelWithPageUpdates,
								$elm$core$Maybe$Just(completionRequest),
								$author$project$HubTran$Effect$none);
						default:
							return _Utils_Tuple3(
								modelWithPageUpdates,
								$elm$core$Maybe$Nothing,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_documentId),
											$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$documentPage),
											$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$documentBatchV2)
										])));
					}
				}();
				var updatedModel = _v4.a;
				var maybeSubmit = _v4.b;
				var parentEffect = _v4.c;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (submitEffect) {
						return $author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									submitEffect,
									A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentBatchReviewPage$DocumentBatchGroupingReviewPageMsg, childEffect),
									parentEffect
								]));
					},
					A2($author$project$Components$DocumentBatchReviewPage$handleMaybeSubmit, maybeSubmit, updatedModel));
		}
	});
var $author$project$Components$DocumentGroupReviewPage$ReviewCompleteResponse = function (a) {
	return {$: 'ReviewCompleteResponse', a: a};
};
var $author$project$Components$DocumentGroupReviewPage$handleReviewCompleteSuccess = F3(
	function (onDone, model, response) {
		return _Utils_Tuple2(
			model,
			A2(
				$author$project$Components$DocumentReview$DocumentReviewFlow$goToNextReviewOrFlowModeEffect,
				response,
				{
					noResultFlashMessage: 'Document review saved successfully!',
					onDoneUrlFragment: onDone,
					resultFlashMessage: $elm$core$Maybe$Just('Success, here\u0027s the next review!')
				}));
	});
var $author$project$Components$LoadPicker$GuessedLoadsReceived = function (a) {
	return {$: 'GuessedLoadsReceived', a: a};
};
var $author$project$Components$DocumentGroupLoadReviewPage$LoadPickerMsg = function (a) {
	return {$: 'LoadPickerMsg', a: a};
};
var $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Components$DocumentGroupLoadReviewPage$SearchedCarrier = {$: 'SearchedCarrier'};
var $author$project$Components$LoadPicker$SetSearchTerm = function (a) {
	return {$: 'SetSearchTerm', a: a};
};
var $author$project$Components$DocumentGroupLoadReviewPage$CarrierSearchCompleted = function (a) {
	return {$: 'CarrierSearchCompleted', a: a};
};
var $author$project$Components$DocumentGroupLoadReviewPage$decodeCarrierSearchResponse = A2(
	$elm$json$Json$Decode$field,
	'carriers',
	$elm$json$Json$Decode$list($author$project$Domain$TmsCarrier$decode));
var $author$project$Helpers$Http$errorToString = function (error) {
	switch (error.$) {
		case 'BadUrl':
			var message = error.a;
			return 'BadUrl: ' + message;
		case 'Timeout':
			return 'Timeout';
		case 'NetworkError':
			return 'NetworkError';
		case 'BadStatus':
			var statusCode = error.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'BadStatus ',
						'Code: ',
						$elm$core$String$fromInt(statusCode)
					]));
		default:
			var errorMessage = error.a;
			return 'BadBody: ' + errorMessage;
	}
};
var $author$project$Components$DocumentGroupLoadReviewPage$fetchCarriers = function (term) {
	var url = A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			['api', 'carriers']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$int, 'page', 1),
				A2($elm$url$Url$Builder$string, 'term', term)
			]));
	return A2(
		$author$project$HubTran$Effect$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$mapError($author$project$Helpers$Http$errorToString),
			$author$project$Components$DocumentGroupLoadReviewPage$CarrierSearchCompleted),
		$author$project$HubTran$Effect$http(
			{
				body: $elm$core$Maybe$Nothing,
				headers: _List_Nil,
				method: 'GET',
				resolver: $author$project$Helpers$Http$jsonResolver($author$project$Components$DocumentGroupLoadReviewPage$decodeCarrierSearchResponse),
				timeout: $elm$core$Maybe$Nothing,
				url: url
			}));
};
var $author$project$Components$DocumentGroupLoadReviewPage$handleLoadPickerOutMsg = F4(
	function (remoteData, loadPicker, outMsg, model) {
		switch (outMsg.$) {
			case 'SetValueToHighlight':
				var highlightedValue = outMsg.a;
				return _Utils_update(
					model,
					{
						documentsBrowser: A2(
							$author$project$Components$DocumentsBrowser$setHighlight,
							A2($elm$core$Maybe$map, $author$project$Components$DocumentsBrowser$valueHighlight, highlightedValue),
							model.documentsBrowser),
						highlightedValue: highlightedValue,
						loadPicker: loadPicker
					});
			case 'ReferenceValueClicked':
				var value = outMsg.a;
				var pagePredicate = F2(
					function (_v1, lines) {
						return A2(
							$elm$core$List$any,
							$author$project$Domain$DocumentPageLine$matchOnChars(
								$elm$core$Maybe$Just(value)),
							lines);
					});
				var updatedBrowser = A3(
					$author$project$Components$DocumentsBrowser$selectNextPageMatchingRule,
					pagePredicate,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.documentsBrowserData;
						},
						remoteData),
					model.documentsBrowser);
				return _Utils_update(
					model,
					{documentsBrowser: updatedBrowser, loadPicker: loadPicker});
			default:
				return _Utils_update(
					model,
					{loadPicker: loadPicker});
		}
	});
var $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentGroupLoadReviewCompletionRequest = function (a) {
	return {$: 'DocumentReviewCompletionRequest_CompletedReview_DocumentGroupLoadReviewCompletionRequest', a: a};
};
var $author$project$Components$DocumentGroupLoadReviewPage$Submit = function (a) {
	return {$: 'Submit', a: a};
};
var $author$project$Components$LoadPicker$visibleLoads = function (model) {
	var _v0 = model.state;
	if (_v0.$ === 'ShowingGuessed') {
		return model.guessedLoads;
	} else {
		var searchResults = _v0.a.searchResults;
		if (searchResults.$ === 'Success') {
			var loads = searchResults.a;
			return loads;
		} else {
			return _List_Nil;
		}
	}
};
var $author$project$Components$DocumentGroupLoadReviewPage$getSelectedLoadAndExtractedCarrier = function (model) {
	var _v0 = model.loadPicker.selectedLoadStateId;
	if (_v0.$ === 'Nothing') {
		return $elm$core$Maybe$Nothing;
	} else {
		var selectedLoadStateId = _v0.a;
		var maybeSelectedLoadState = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.id;
					},
					$elm$core$Basics$eq(selectedLoadStateId)),
				$author$project$Components$LoadPicker$visibleLoads(model.loadPicker)));
		if (maybeSelectedLoadState.$ === 'Just') {
			var selectedLoadState = maybeSelectedLoadState.a;
			return $elm$core$Maybe$Just(
				{extractedCarrier: model.extractedCarrier, loadCarrier: selectedLoadState.load.carrier, selectedLoadState: selectedLoadState});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Components$DocumentGroupLoadReviewPage$handleSubmitLoadAssignment = function (model) {
	var selectedLoadState = A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.id;
						},
						$elm$core$Basics$eq(id)),
					$author$project$Components$LoadPicker$visibleLoads(model.loadPicker)));
		},
		model.loadPicker.selectedLoadStateId);
	var carriersMatch = function () {
		var _v4 = $author$project$Components$DocumentGroupLoadReviewPage$getSelectedLoadAndExtractedCarrier(model);
		if (_v4.$ === 'Just') {
			var extractedCarrier = _v4.a.extractedCarrier;
			var loadCarrier = _v4.a.loadCarrier;
			var _v5 = _Utils_Tuple2(
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.id;
					},
					loadCarrier),
				extractedCarrier);
			if ((_v5.a.$ === 'Just') && (_v5.b.$ === 'Just')) {
				var loadCarrierId = _v5.a.a;
				var ec = _v5.b.a;
				return _Utils_eq(
					$elm$core$Maybe$Just(loadCarrierId),
					ec.id);
			} else {
				return false;
			}
		} else {
			return false;
		}
	}();
	var resolveCarrierId = function (load) {
		if (carriersMatch) {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Domain$TmsCarrierId$fromInt,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.id;
					},
					load.load.carrier));
		} else {
			var _v0 = model.carrierChoice;
			_v0$3:
			while (true) {
				if (_v0.$ === 'Just') {
					switch (_v0.a.$) {
						case 'ExtractedCarrier':
							var _v1 = _v0.a;
							return A2(
								$elm$core$Maybe$map,
								$author$project$Domain$TmsCarrierId$fromInt,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.id;
									},
									model.extractedCarrier));
						case 'UnknownCarrier':
							var _v2 = _v0.a;
							return $elm$core$Maybe$Nothing;
						case 'SearchedCarrier':
							var _v3 = _v0.a;
							return A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.id;
								},
								model.selectedSearchedCarrier);
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			}
			return A2(
				$elm$core$Maybe$map,
				$author$project$Domain$TmsCarrierId$fromInt,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.id;
					},
					load.load.carrier));
		}
	};
	var effectiveCarrierId = A2($elm$core$Maybe$andThen, resolveCarrierId, selectedLoadState);
	var completionRequest = {
		completedReview: $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentGroupLoadReviewCompletionRequest(
			{
				assignedCarrierId: effectiveCarrierId,
				assignedLoadStateId: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.id;
						},
						A2($elm$core$Basics$composeR, $author$project$Domain$TmsLoadId$toInt, $author$project$Domain$LoadStateId$fromInt)),
					selectedLoadState),
				documentGroupLoadReviewId: model.documentGroupLoadReviewId
			})
	};
	return {
		childEffect: $author$project$HubTran$Effect$none,
		newChildModel: model,
		outMsg: $author$project$Components$DocumentGroupLoadReviewPage$Submit(completionRequest)
	};
};
var $author$project$Components$DocumentGroupLoadReviewPage$isMismatchPanelVisible = function (model) {
	var _v0 = $author$project$Components$DocumentGroupLoadReviewPage$getSelectedLoadAndExtractedCarrier(model);
	if (_v0.$ === 'Just') {
		var extractedCarrier = _v0.a.extractedCarrier;
		var loadCarrier = _v0.a.loadCarrier;
		if (extractedCarrier.$ === 'Nothing') {
			return true;
		} else {
			var ec = extractedCarrier.a;
			var carriersMatch = function () {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.id;
					},
					loadCarrier);
				if (_v2.$ === 'Just') {
					var loadCarrierId = _v2.a;
					return _Utils_eq(
						$elm$core$Maybe$Just(loadCarrierId),
						ec.id);
				} else {
					return false;
				}
			}();
			return (!$elm$core$String$isEmpty(ec.name)) && (!carriersMatch);
		}
	} else {
		return false;
	}
};
var $author$project$Components$LoadPicker$SearchCompleted = function (a) {
	return {$: 'SearchCompleted', a: a};
};
var $author$project$Components$DocumentGroupLoadReviewPage$decodeLoadSearchResponse = A2(
	$elm$json$Json$Decode$field,
	'loads',
	$elm$json$Json$Decode$list($author$project$Domain$LoadSearch$loadStateDecoder));
var $author$project$Components$DocumentGroupLoadReviewPage$performLoadSearch = function (searchTerm) {
	var url = A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			['api', 'load_searches', 'by_location']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'reference', searchTerm)
			]));
	return A2(
		$author$project$HubTran$Effect$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$mapError($author$project$Helpers$Http$errorToString),
			$author$project$Components$LoadPicker$SearchCompleted),
		$author$project$HubTran$Effect$http(
			{
				body: $elm$core$Maybe$Nothing,
				headers: _List_Nil,
				method: 'GET',
				resolver: $author$project$Helpers$Http$jsonResolver($author$project$Components$DocumentGroupLoadReviewPage$decodeLoadSearchResponse),
				timeout: $elm$core$Maybe$Nothing,
				url: url
			}));
};
var $author$project$Components$DocumentGroupLoadReviewPage$resetCarrier = function (model) {
	return _Utils_update(
		model,
		{carrierChoice: $elm$core$Maybe$Nothing, carrierSearchResults: $krisajenkins$remotedata$RemoteData$NotAsked, carrierSearchTerm: '', selectedSearchedCarrier: $elm$core$Maybe$Nothing});
};
var $author$project$Components$LoadPicker$NoOp = {$: 'NoOp'};
var $author$project$Components$LoadPicker$ReferenceValueClicked = function (a) {
	return {$: 'ReferenceValueClicked', a: a};
};
var $author$project$Components$LoadPicker$SetValueToHighlight = function (a) {
	return {$: 'SetValueToHighlight', a: a};
};
var $author$project$Components$LoadPicker$ShowingSearch = function (a) {
	return {$: 'ShowingSearch', a: a};
};
var $author$project$Components$LoadPicker$update = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 'ShowSearch':
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							selectedLoadStateId: $elm$core$Maybe$Nothing,
							state: $author$project$Components$LoadPicker$ShowingSearch(
								{searchResults: $krisajenkins$remotedata$RemoteData$NotAsked, searchTerm: ''})
						}),
					$author$project$HubTran$Effect$none,
					$author$project$Components$LoadPicker$NoOp);
			case 'CancelSearch':
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{selectedLoadStateId: $elm$core$Maybe$Nothing, state: $author$project$Components$LoadPicker$ShowingGuessed}),
					$author$project$HubTran$Effect$none,
					$author$project$Components$LoadPicker$NoOp);
			case 'UpdateSearchTerm':
				var term = msg.a;
				var _v1 = model.state;
				if (_v1.$ === 'ShowingSearch') {
					var search = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								state: $author$project$Components$LoadPicker$ShowingSearch(
									_Utils_update(
										search,
										{searchTerm: term}))
							}),
						$author$project$HubTran$Effect$none,
						$author$project$Components$LoadPicker$NoOp);
				} else {
					return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$LoadPicker$NoOp);
				}
			case 'SetSearchTerm':
				var term = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							selectedLoadStateId: $elm$core$Maybe$Nothing,
							state: $author$project$Components$LoadPicker$ShowingSearch(
								{searchResults: $krisajenkins$remotedata$RemoteData$NotAsked, searchTerm: term})
						}),
					$author$project$HubTran$Effect$none,
					$author$project$Components$LoadPicker$NoOp);
			case 'PerformSearch':
				var _v2 = model.state;
				if (_v2.$ === 'ShowingSearch') {
					var search = _v2.a;
					return $elm$core$String$isEmpty(
						$elm$core$String$trim(search.searchTerm)) ? _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$LoadPicker$NoOp) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								state: $author$project$Components$LoadPicker$ShowingSearch(
									_Utils_update(
										search,
										{searchResults: $krisajenkins$remotedata$RemoteData$Loading}))
							}),
						config.searchEndpoint(search.searchTerm),
						$author$project$Components$LoadPicker$NoOp);
				} else {
					return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$LoadPicker$NoOp);
				}
			case 'SearchCompleted':
				if (msg.a.$ === 'Ok') {
					var loads = msg.a.a;
					var _v3 = model.state;
					if (_v3.$ === 'ShowingSearch') {
						var search = _v3.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									state: $author$project$Components$LoadPicker$ShowingSearch(
										_Utils_update(
											search,
											{
												searchResults: $krisajenkins$remotedata$RemoteData$Success(loads)
											}))
								}),
							$author$project$HubTran$Effect$none,
							$author$project$Components$LoadPicker$NoOp);
					} else {
						return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$LoadPicker$NoOp);
					}
				} else {
					var error = msg.a.a;
					var _v4 = model.state;
					if (_v4.$ === 'ShowingSearch') {
						var search = _v4.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									state: $author$project$Components$LoadPicker$ShowingSearch(
										_Utils_update(
											search,
											{
												searchResults: $krisajenkins$remotedata$RemoteData$Failure(error)
											}))
								}),
							$author$project$HubTran$Effect$none,
							$author$project$Components$LoadPicker$NoOp);
					} else {
						return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$LoadPicker$NoOp);
					}
				}
			case 'GuessedLoadsReceived':
				if (msg.a.$ === 'Ok') {
					var loads = msg.a.a;
					var guessedLoadStateId = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						model.selectedLoadStateId,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.id;
							},
							$elm$core$Maybe$Just),
						A2(
							$elm_community$list_extra$List$Extra$find,
							function ($) {
								return $.isGuessed;
							},
							loads));
					return $elm$core$List$isEmpty(loads) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								guessedLoads: loads,
								state: $author$project$Components$LoadPicker$ShowingSearch(
									{searchResults: $krisajenkins$remotedata$RemoteData$NotAsked, searchTerm: ''})
							}),
						$author$project$HubTran$Effect$none,
						$author$project$Components$LoadPicker$NoOp) : _Utils_Tuple3(
						_Utils_update(
							model,
							{guessedLoads: loads, selectedLoadStateId: guessedLoadStateId}),
						$author$project$HubTran$Effect$none,
						$author$project$Components$LoadPicker$NoOp);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								guessedLoads: _List_Nil,
								state: $author$project$Components$LoadPicker$ShowingSearch(
									{searchResults: $krisajenkins$remotedata$RemoteData$NotAsked, searchTerm: ''})
							}),
						$author$project$HubTran$Effect$none,
						$author$project$Components$LoadPicker$NoOp);
				}
			case 'SelectLoad':
				var loadStateId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{selectedLoadStateId: loadStateId}),
					$author$project$HubTran$Effect$none,
					$author$project$Components$LoadPicker$NoOp);
			case 'HoverReferenceValue':
				var maybeValue = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hoveredValue: maybeValue}),
					$author$project$HubTran$Effect$none,
					$author$project$Components$LoadPicker$SetValueToHighlight(maybeValue));
			default:
				var value = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$HubTran$Effect$none,
					$author$project$Components$LoadPicker$ReferenceValueClicked(value));
		}
	});
var $author$project$Components$DocumentGroupLoadReviewPage$update = F3(
	function (remoteData, msg, model) {
		switch (msg.$) {
			case 'DocumentsBrowserMsg':
				var documentsBrowserMsg = msg.a;
				var _v1 = A4(
					$author$project$Components$DocumentsBrowser$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.documentsBrowserData;
						},
						remoteData),
					documentsBrowserMsg,
					model.documentsBrowser,
					$author$project$Components$DocumentsBrowser$noHooks);
				var documentsBrowser = _v1.a;
				var documentsBrowserEffect = _v1.b;
				var _v2 = function () {
					if ((documentsBrowserMsg.$ === 'NonHotkeyMsg') && (documentsBrowserMsg.a.$ === 'SetLineSelection')) {
						var text = documentsBrowserMsg.a.a;
						if (_Utils_eq(
							model.carrierChoice,
							$elm$core$Maybe$Just($author$project$Components$DocumentGroupLoadReviewPage$SearchedCarrier)) && $author$project$Components$DocumentGroupLoadReviewPage$isMismatchPanelVisible(model)) {
							return _Utils_Tuple3(
								model.loadPicker,
								$author$project$HubTran$Effect$none,
								_Utils_update(
									model,
									{carrierSearchResults: $krisajenkins$remotedata$RemoteData$NotAsked, carrierSearchTerm: text, documentsBrowser: documentsBrowser, selectedSearchedCarrier: $elm$core$Maybe$Nothing}));
						} else {
							var _v4 = A3(
								$author$project$Components$LoadPicker$update,
								{searchEndpoint: $author$project$Components$DocumentGroupLoadReviewPage$performLoadSearch},
								$author$project$Components$LoadPicker$SetSearchTerm(text),
								model.loadPicker);
							var lp = _v4.a;
							var lpEffect = _v4.b;
							return _Utils_Tuple3(
								lp,
								lpEffect,
								$author$project$Components$DocumentGroupLoadReviewPage$resetCarrier(
									_Utils_update(
										model,
										{documentsBrowser: documentsBrowser})));
						}
					} else {
						return _Utils_Tuple3(
							model.loadPicker,
							$author$project$HubTran$Effect$none,
							_Utils_update(
								model,
								{documentsBrowser: documentsBrowser}));
					}
				}();
				var newLoadPicker = _v2.a;
				var loadPickerEffect = _v2.b;
				var newModel = _v2.c;
				return {
					childEffect: $author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupLoadReviewPage$DocumentsBrowserMsg, documentsBrowserEffect),
								A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupLoadReviewPage$LoadPickerMsg, loadPickerEffect)
							])),
					newChildModel: _Utils_update(
						newModel,
						{loadPicker: newLoadPicker}),
					outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
				};
			case 'LoadPickerMsg':
				var loadPickerMsg = msg.a;
				var loadPickerConfig = {searchEndpoint: $author$project$Components$DocumentGroupLoadReviewPage$performLoadSearch};
				var _v5 = A3($author$project$Components$LoadPicker$update, loadPickerConfig, loadPickerMsg, model.loadPicker);
				var loadPicker = _v5.a;
				var loadPickerEffect = _v5.b;
				var loadPickerOutMsg = _v5.c;
				var updatedModel = A4($author$project$Components$DocumentGroupLoadReviewPage$handleLoadPickerOutMsg, remoteData, loadPicker, loadPickerOutMsg, model);
				switch (loadPickerMsg.$) {
					case 'SelectLoad':
						return {
							childEffect: A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupLoadReviewPage$LoadPickerMsg, loadPickerEffect),
							newChildModel: $author$project$Components$DocumentGroupLoadReviewPage$resetCarrier(updatedModel),
							outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
						};
					case 'CancelSearch':
						return {
							childEffect: A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupLoadReviewPage$LoadPickerMsg, loadPickerEffect),
							newChildModel: $author$project$Components$DocumentGroupLoadReviewPage$resetCarrier(updatedModel),
							outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
						};
					case 'ShowSearch':
						return {
							childEffect: A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupLoadReviewPage$LoadPickerMsg, loadPickerEffect),
							newChildModel: $author$project$Components$DocumentGroupLoadReviewPage$resetCarrier(updatedModel),
							outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
						};
					default:
						return {
							childEffect: A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupLoadReviewPage$LoadPickerMsg, loadPickerEffect),
							newChildModel: updatedModel,
							outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
						};
				}
			case 'SubmitLoadAssignment':
				return $author$project$Components$DocumentGroupLoadReviewPage$handleSubmitLoadAssignment(model);
			case 'LoadGuessedLoads':
				if (remoteData.$ === 'Loaded') {
					var data = remoteData.a;
					var _v8 = data.reviewData;
					var documentGroupLoadReview = _v8.a.documentGroupLoadReview;
					var loadPickerMsg = $author$project$Components$LoadPicker$GuessedLoadsReceived(
						$elm$core$Result$Ok(documentGroupLoadReview.guessedLoads));
					var loadPickerConfig = {searchEndpoint: $author$project$Components$DocumentGroupLoadReviewPage$performLoadSearch};
					var _v9 = A3($author$project$Components$LoadPicker$update, loadPickerConfig, loadPickerMsg, model.loadPicker);
					var newLoadPicker = _v9.a;
					var loadPickerEffect = _v9.b;
					return {
						childEffect: A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupLoadReviewPage$LoadPickerMsg, loadPickerEffect),
						newChildModel: $author$project$Components$DocumentGroupLoadReviewPage$resetCarrier(
							_Utils_update(
								model,
								{extractedCarrier: documentGroupLoadReview.extractedCarrier, hasLoadedGuessedLoads: true, loadPicker: newLoadPicker})),
						outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
					};
				} else {
					return {childEffect: $author$project$HubTran$Effect$none, newChildModel: model, outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg};
				}
			case 'SetCarrierChoice':
				var choice = msg.a;
				return {
					childEffect: $author$project$HubTran$Effect$none,
					newChildModel: _Utils_update(
						model,
						{
							carrierChoice: $elm$core$Maybe$Just(choice),
							carrierSearchResults: $krisajenkins$remotedata$RemoteData$NotAsked,
							carrierSearchTerm: '',
							selectedSearchedCarrier: $elm$core$Maybe$Nothing
						}),
					outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
				};
			case 'UpdateCarrierSearchTerm':
				var term = msg.a;
				return {
					childEffect: $author$project$HubTran$Effect$none,
					newChildModel: _Utils_update(
						model,
						{carrierSearchTerm: term}),
					outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
				};
			case 'PerformCarrierSearch':
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(model.carrierSearchTerm)) ? {childEffect: $author$project$HubTran$Effect$none, newChildModel: model, outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg} : {
					childEffect: $author$project$Components$DocumentGroupLoadReviewPage$fetchCarriers(model.carrierSearchTerm),
					newChildModel: _Utils_update(
						model,
						{carrierSearchResults: $krisajenkins$remotedata$RemoteData$Loading}),
					outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
				};
			case 'CarrierSearchCompleted':
				var result = msg.a;
				return {
					childEffect: $author$project$HubTran$Effect$none,
					newChildModel: _Utils_update(
						model,
						{
							carrierSearchResults: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
				};
			default:
				var carrier = msg.a;
				return {
					childEffect: $author$project$HubTran$Effect$none,
					newChildModel: _Utils_update(
						model,
						{
							selectedSearchedCarrier: $elm$core$Maybe$Just(carrier)
						}),
					outMsg: $author$project$Components$DocumentGroupLoadReviewPage$NoOutMsg
				};
		}
	});
var $author$project$Components$DocumentGroupReviewPage$update = F3(
	function (remoteData, msg, model) {
		if (msg.$ === 'ReviewCompleteResponse') {
			var response = msg.a;
			return A3(
				$author$project$AuditApi$applyRequest,
				model,
				response,
				$author$project$Components$DocumentGroupReviewPage$handleReviewCompleteSuccess(model.onDone));
		} else {
			var childMsg = msg.a;
			var _v1 = model.childModel;
			var childModel = _v1.a;
			var _v2 = A3($author$project$Components$DocumentGroupLoadReviewPage$update, remoteData, childMsg, childModel);
			var outMsg = _v2.outMsg;
			var childEffect = _v2.childEffect;
			var newChildModel = _v2.newChildModel;
			var updatedModel = _Utils_update(
				model,
				{
					childModel: $author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPage(newChildModel)
				});
			if (outMsg.$ === 'NoOutMsg') {
				return _Utils_Tuple2(
					updatedModel,
					A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPageMsg, childEffect));
			} else {
				var completionRequest = outMsg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (effect) {
						return $author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									effect,
									A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPageMsg, childEffect)
								]));
					},
					A3($author$project$AuditApi$documentReviewServiceCompleteWithState, updatedModel, $author$project$Components$DocumentGroupReviewPage$ReviewCompleteResponse, completionRequest));
			}
		}
	});
var $author$project$Components$DocumentReviewPage$ReviewCompleteResponse = function (a) {
	return {$: 'ReviewCompleteResponse', a: a};
};
var $author$project$Components$DocumentReviewPage$handleMaybeSubmit = F2(
	function (maybeSubmit, model_) {
		if (maybeSubmit.$ === 'Nothing') {
			return _Utils_Tuple2(model_, $author$project$HubTran$Effect$none);
		} else {
			var documentReviewCompletionRequest = maybeSubmit.a;
			return A3($author$project$AuditApi$documentReviewServiceCompleteWithState, model_, $author$project$Components$DocumentReviewPage$ReviewCompleteResponse, documentReviewCompletionRequest);
		}
	});
var $author$project$Components$DocumentReviewPage$handleReviewCompleteSuccess = F3(
	function (onDone, model, response) {
		return _Utils_Tuple2(
			model,
			A2(
				$author$project$Components$DocumentReview$DocumentReviewFlow$goToNextReviewOrFlowModeEffect,
				response,
				{
					noResultFlashMessage: 'Document review saved successfully!',
					onDoneUrlFragment: onDone,
					resultFlashMessage: $elm$core$Maybe$Just('Success, here\u0027s the next review!')
				}));
	});
var $author$project$Components$InvoiceAmountReviewPage$setInvoiceAmountFromLineSelection = F2(
	function (value, model) {
		return _Utils_update(
			model,
			{
				invoiceAmountInput: $elm$core$Maybe$Just(value)
			});
	});
var $author$project$Components$InvoiceNumberReviewPage$setInvoiceNumber = F2(
	function (value, model) {
		return _Utils_update(
			model,
			{invoiceNumberInput: value});
	});
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$AdvanceToNextPageWithText = function (a) {
	return {$: 'AdvanceToNextPageWithText', a: a};
};
var $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentLoadReferenceMatchReviewCompletionRequest = function (a) {
	return {$: 'DocumentReviewCompletionRequest_CompletedReview_DocumentLoadReferenceMatchReviewCompletionRequest', a: a};
};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$NoOp = {$: 'NoOp'};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$SetValueToHighlight = function (a) {
	return {$: 'SetValueToHighlight', a: a};
};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$SubmitReview = function (a) {
	return {$: 'SubmitReview', a: a};
};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'ToggleReferenceValue':
				var value = msg.a;
				var isChecked = msg.b;
				var newCheckedValues = isChecked ? A2($elm$core$Set$insert, value, model.checkedValues) : A2($elm$core$Set$remove, value, model.checkedValues);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{checkedValues: newCheckedValues}),
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentLoadReferenceMatchReviewPage$NoOp);
			case 'ConfirmMatches':
				var completionRequest = $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentLoadReferenceMatchReviewCompletionRequest(
					{
						documentLoadReferenceMatchReviewId: model.documentLoadReferenceMatchReviewId,
						documentReferencesMatchLoad: true,
						matchedValues: $elm$core$Set$toList(model.checkedValues)
					});
				return _Utils_Tuple3(
					model,
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentLoadReferenceMatchReviewPage$SubmitReview(completionRequest));
			case 'ConfirmNoMatch':
				var completionRequest = $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentLoadReferenceMatchReviewCompletionRequest(
					{documentLoadReferenceMatchReviewId: model.documentLoadReferenceMatchReviewId, documentReferencesMatchLoad: false, matchedValues: _List_Nil});
				return _Utils_Tuple3(
					model,
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentLoadReferenceMatchReviewPage$SubmitReview(completionRequest));
			case 'HoverReferenceValue':
				var maybeValue = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hoveredValue: maybeValue}),
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentLoadReferenceMatchReviewPage$SetValueToHighlight(maybeValue));
			default:
				var value = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$HubTran$Effect$none,
					$author$project$Components$DocumentLoadReferenceMatchReviewPage$AdvanceToNextPageWithText(value));
		}
	});
var $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentTypeReviewCompletionRequest = function (a) {
	return {$: 'DocumentReviewCompletionRequest_CompletedReview_DocumentTypeReviewCompletionRequest', a: a};
};
var $author$project$Components$DocumentTypeReviewPage$update = F2(
	function (msg, model) {
		var docType = msg.a;
		return {
			childEffect: $author$project$HubTran$Effect$none,
			maybeSubmit: $elm$core$Maybe$Just(
				{
					completedReview: $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_DocumentTypeReviewCompletionRequest(
						{assignedDocumentType: docType.documentType, documentTypeReviewId: model.documentTypeReviewId})
				}),
			newChildModel: model
		};
	});
var $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_InvoiceAmountReviewCompletionRequest = function (a) {
	return {$: 'DocumentReviewCompletionRequest_CompletedReview_InvoiceAmountReviewCompletionRequest', a: a};
};
var $author$project$AuditPb$InvoiceAmountReviewCompletionRequest_Result_InvoiceAmountReviewNoResultFound = function (a) {
	return {$: 'InvoiceAmountReviewCompletionRequest_Result_InvoiceAmountReviewNoResultFound', a: a};
};
var $author$project$AuditPb$InvoiceAmountReviewCompletionRequest_Result_InvoiceAmountReviewResultFound = function (a) {
	return {$: 'InvoiceAmountReviewCompletionRequest_Result_InvoiceAmountReviewResultFound', a: a};
};
var $author$project$AuditPb$InvoiceAmountReviewNoResultFoundNoInvoiceAmount = {$: 'InvoiceAmountReviewNoResultFoundNoInvoiceAmount'};
var $author$project$Components$InvoiceAmountReviewPage$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'InvoiceAmountChanged':
				var value = msg.a;
				return {
					childEffect: $author$project$HubTran$Effect$none,
					maybeSubmit: $elm$core$Maybe$Nothing,
					newChildModel: _Utils_update(
						model,
						{
							invoiceAmountInput: $elm$core$Maybe$Just(value)
						})
				};
			case 'Submit':
				return {
					childEffect: $author$project$HubTran$Effect$none,
					maybeSubmit: $elm$core$Maybe$Just(
						{
							completedReview: $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_InvoiceAmountReviewCompletionRequest(
								{
									invoiceAmountReviewId: model.invoiceAmountReviewId,
									result: A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$author$project$AuditPb$InvoiceAmountReviewCompletionRequest_Result_InvoiceAmountReviewNoResultFound($author$project$AuditPb$InvoiceAmountReviewNoResultFoundNoInvoiceAmount),
										function (amount) {
											return $author$project$AuditPb$InvoiceAmountReviewCompletionRequest_Result_InvoiceAmountReviewResultFound(
												{assignedAmount: amount});
										},
										model.invoiceAmountInput)
								})
						}),
					newChildModel: model
				};
			default:
				return {
					childEffect: $author$project$HubTran$Effect$none,
					maybeSubmit: $elm$core$Maybe$Just(
						{
							completedReview: $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_InvoiceAmountReviewCompletionRequest(
								{
									invoiceAmountReviewId: model.invoiceAmountReviewId,
									result: $author$project$AuditPb$InvoiceAmountReviewCompletionRequest_Result_InvoiceAmountReviewNoResultFound($author$project$AuditPb$InvoiceAmountReviewNoResultFoundNoInvoiceAmount)
								})
						}),
					newChildModel: model
				};
		}
	});
var $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_InvoiceNumberReviewCompletionRequest = function (a) {
	return {$: 'DocumentReviewCompletionRequest_CompletedReview_InvoiceNumberReviewCompletionRequest', a: a};
};
var $author$project$Components$InvoiceNumberReviewPage$update = F2(
	function (msg, model) {
		if (msg.$ === 'InvoiceNumberChanged') {
			var value = msg.a;
			return {
				childEffect: $author$project$HubTran$Effect$none,
				maybeSubmit: $elm$core$Maybe$Nothing,
				newChildModel: _Utils_update(
					model,
					{invoiceNumberInput: value})
			};
		} else {
			return {
				childEffect: $author$project$HubTran$Effect$none,
				maybeSubmit: $elm$core$Maybe$Just(
					{
						completedReview: $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_InvoiceNumberReviewCompletionRequest(
							{assignedInvoiceNumber: model.invoiceNumberInput, invoiceNumberReviewId: model.invoiceNumberReviewId})
					}),
				newChildModel: model
			};
		}
	});
var $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_MultiPageBolReviewCompletionRequest = function (a) {
	return {$: 'DocumentReviewCompletionRequest_CompletedReview_MultiPageBolReviewCompletionRequest', a: a};
};
var $author$project$Components$MultiPageBolReviewPage$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'AnswerAllPagesAreSameBol':
				var answer = msg.a;
				return {
					childEffect: $author$project$HubTran$Effect$none,
					maybeSubmit: $elm$core$Maybe$Nothing,
					newChildModel: _Utils_update(
						model,
						{
							allPagesAreSameBol: $elm$core$Maybe$Just(answer),
							allPagesOfBolPresent: $elm$core$Maybe$Nothing
						})
				};
			case 'AnswerAllPagesOfBolPresent':
				var answer = msg.a;
				return {
					childEffect: $author$project$HubTran$Effect$none,
					maybeSubmit: $elm$core$Maybe$Nothing,
					newChildModel: _Utils_update(
						model,
						{
							allPagesOfBolPresent: $elm$core$Maybe$Just(answer)
						})
				};
			default:
				var formState = msg.a;
				return {
					childEffect: $author$project$HubTran$Effect$none,
					maybeSubmit: $elm$core$Maybe$Just(
						{
							completedReview: $author$project$AuditPb$DocumentReviewCompletionRequest_CompletedReview_MultiPageBolReviewCompletionRequest(
								{
									allPagesAreSameBol: function () {
										var _v1 = formState.allPagesAreSameBol;
										if (_v1.$ === 'Just') {
											switch (_v1.a.$) {
												case 'MultiPageBolReviewAnswerYes':
													var _v2 = _v1.a;
													return 'yes';
												case 'MultiPageBolReviewAnswerNo':
													var _v3 = _v1.a;
													return 'no';
												default:
													var _v4 = _v1.a;
													return 'unsure';
											}
										} else {
											return '';
										}
									}(),
									allPagesOfBolPresent: function () {
										var _v5 = formState.allPagesOfBolPresent;
										if (_v5.$ === 'Just') {
											switch (_v5.a.$) {
												case 'MultiPageBolReviewAnswerYes':
													var _v6 = _v5.a;
													return 'yes';
												case 'MultiPageBolReviewAnswerNo':
													var _v7 = _v5.a;
													return 'no';
												default:
													var _v8 = _v5.a;
													return 'unsure';
											}
										} else {
											return '';
										}
									}(),
									multiPageBolReviewId: model.multiPageBolReviewId
								})
						}),
					newChildModel: model
				};
		}
	});
var $author$project$Components$DocumentReviewPage$update = F3(
	function (remoteData, msg, model) {
		switch (msg.$) {
			case 'DocumentsBrowserMsg':
				var documentsBrowserMsg = msg.a;
				var newChildModel = function () {
					if ((documentsBrowserMsg.$ === 'NonHotkeyMsg') && (documentsBrowserMsg.a.$ === 'SetLineSelection')) {
						var value = documentsBrowserMsg.a.a;
						var _v3 = model.childModel;
						switch (_v3.$) {
							case 'InvoiceNumberReviewPage':
								var childModel = _v3.a;
								return $author$project$Components$DocumentReviewPage$InvoiceNumberReviewPage(
									A2($author$project$Components$InvoiceNumberReviewPage$setInvoiceNumber, value, childModel));
							case 'InvoiceAmountReviewPage':
								var childModel = _v3.a;
								return $author$project$Components$DocumentReviewPage$InvoiceAmountReviewPage(
									A2($author$project$Components$InvoiceAmountReviewPage$setInvoiceAmountFromLineSelection, value, childModel));
							case 'MultiPageBolReviewPage':
								return model.childModel;
							case 'DocumentTypeReviewPage':
								return model.childModel;
							default:
								return model.childModel;
						}
					} else {
						return model.childModel;
					}
				}();
				var _v1 = A4(
					$author$project$Components$DocumentsBrowser$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.documentsBrowserData;
						},
						remoteData),
					documentsBrowserMsg,
					model.documentsBrowser,
					$author$project$Components$DocumentsBrowser$noHooks);
				var documentsBrowser = _v1.a;
				var documentsBrowserEffect = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{childModel: newChildModel, documentsBrowser: documentsBrowser}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$DocumentsBrowserMsg, documentsBrowserEffect));
			case 'ReviewCompleteResponse':
				var response = msg.a;
				return A3(
					$author$project$AuditApi$applyRequest,
					model,
					response,
					$author$project$Components$DocumentReviewPage$handleReviewCompleteSuccess(model.onDone));
			case 'InvoiceNumberReviewPageMsg':
				var childMsg = msg.a;
				var _v4 = model.childModel;
				if (_v4.$ === 'InvoiceNumberReviewPage') {
					var childModel = _v4.a;
					var _v5 = A2($author$project$Components$InvoiceNumberReviewPage$update, childMsg, childModel);
					var maybeSubmit = _v5.maybeSubmit;
					var childEffect = _v5.childEffect;
					var newChildModel = _v5.newChildModel;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effect) {
							return $author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										effect,
										A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$InvoiceNumberReviewPageMsg, childEffect)
									]));
						},
						A2(
							$author$project$Components$DocumentReviewPage$handleMaybeSubmit,
							maybeSubmit,
							_Utils_update(
								model,
								{
									childModel: $author$project$Components$DocumentReviewPage$InvoiceNumberReviewPage(newChildModel)
								})));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'InvoiceAmountReviewPageMsg':
				var childMsg = msg.a;
				var _v6 = model.childModel;
				if (_v6.$ === 'InvoiceAmountReviewPage') {
					var childModel = _v6.a;
					var _v7 = A2($author$project$Components$InvoiceAmountReviewPage$update, childMsg, childModel);
					var maybeSubmit = _v7.maybeSubmit;
					var childEffect = _v7.childEffect;
					var newChildModel = _v7.newChildModel;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effect) {
							return $author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										effect,
										A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$InvoiceAmountReviewPageMsg, childEffect)
									]));
						},
						A2(
							$author$project$Components$DocumentReviewPage$handleMaybeSubmit,
							maybeSubmit,
							_Utils_update(
								model,
								{
									childModel: $author$project$Components$DocumentReviewPage$InvoiceAmountReviewPage(newChildModel)
								})));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'MultiPageBolReviewPageMsg':
				var childMsg = msg.a;
				var _v8 = model.childModel;
				if (_v8.$ === 'MultiPageBolReviewPage') {
					var childModel = _v8.a;
					var _v9 = A2($author$project$Components$MultiPageBolReviewPage$update, childMsg, childModel);
					var maybeSubmit = _v9.maybeSubmit;
					var childEffect = _v9.childEffect;
					var newChildModel = _v9.newChildModel;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effect) {
							return $author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										effect,
										A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$MultiPageBolReviewPageMsg, childEffect)
									]));
						},
						A2(
							$author$project$Components$DocumentReviewPage$handleMaybeSubmit,
							maybeSubmit,
							_Utils_update(
								model,
								{
									childModel: $author$project$Components$DocumentReviewPage$MultiPageBolReviewPage(newChildModel)
								})));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'DocumentLoadReferenceMatchReviewPageMsg':
				var childMsg = msg.a;
				var _v10 = model.childModel;
				if (_v10.$ === 'DocumentLoadReferenceMatchReviewPage') {
					var childModel = _v10.a;
					var _v11 = A2($author$project$Components$DocumentLoadReferenceMatchReviewPage$update, childMsg, childModel);
					var newChildModel = _v11.a;
					var childEffect = _v11.b;
					var outMsg = _v11.c;
					var handleOutMsg = function (model_) {
						switch (outMsg.$) {
							case 'NoOp':
								return _Utils_Tuple2(model_, $author$project$HubTran$Effect$none);
							case 'SubmitReview':
								var documentReviewCompletionRequest_CompletedReview = outMsg.a;
								return A3(
									$author$project$AuditApi$documentReviewServiceCompleteWithState,
									model_,
									$author$project$Components$DocumentReviewPage$ReviewCompleteResponse,
									{completedReview: documentReviewCompletionRequest_CompletedReview});
							case 'SetValueToHighlight':
								var maybeValue = outMsg.a;
								return _Utils_Tuple2(
									_Utils_update(
										model_,
										{
											documentsBrowser: A2(
												$author$project$Components$DocumentsBrowser$setHighlight,
												A2($elm$core$Maybe$map, $author$project$Components$DocumentsBrowser$valueHighlight, maybeValue),
												model_.documentsBrowser)
										}),
									$author$project$HubTran$Effect$none);
							default:
								var value = outMsg.a;
								var pagePredicate = F2(
									function (_v13, lines) {
										return A2(
											$elm$core$List$any,
											$author$project$Domain$DocumentPageLine$matchOnChars(
												$elm$core$Maybe$Just(value)),
											lines);
									});
								var updatedBrowser = A3(
									$author$project$Components$DocumentsBrowser$selectNextPageMatchingRule,
									pagePredicate,
									A2(
										$author$project$Forward$Remote$andThen,
										function ($) {
											return $.documentsBrowserData;
										},
										remoteData),
									model_.documentsBrowser);
								return _Utils_Tuple2(
									_Utils_update(
										model_,
										{documentsBrowser: updatedBrowser}),
									$author$project$HubTran$Effect$none);
						}
					};
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effect) {
							return $author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										effect,
										A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$DocumentLoadReferenceMatchReviewPageMsg, childEffect)
									]));
						},
						handleOutMsg(
							_Utils_update(
								model,
								{
									childModel: $author$project$Components$DocumentReviewPage$DocumentLoadReferenceMatchReviewPage(newChildModel)
								})));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			default:
				var childMsg = msg.a;
				var _v14 = model.childModel;
				if (_v14.$ === 'DocumentTypeReviewPage') {
					var childModel = _v14.a;
					var _v15 = A2($author$project$Components$DocumentTypeReviewPage$update, childMsg, childModel);
					var maybeSubmit = _v15.maybeSubmit;
					var childEffect = _v15.childEffect;
					var newChildModel = _v15.newChildModel;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (effect) {
							return $author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										effect,
										A2($author$project$HubTran$Effect$map, $author$project$Components$DocumentReviewPage$DocumentTypeReviewPageMsg, childEffect)
									]));
						},
						A2(
							$author$project$Components$DocumentReviewPage$handleMaybeSubmit,
							maybeSubmit,
							_Utils_update(
								model,
								{
									childModel: $author$project$Components$DocumentReviewPage$DocumentTypeReviewPage(newChildModel)
								})));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
		}
	});
var $author$project$Components$EmailMessageSearchPage$FiltersView$clear = function (model) {
	return _Utils_update(
		model,
		{
			carrierDropdown: $author$project$Components$SettingsPage$CarrierDropdown$clear(model.carrierDropdown),
			endDate: $elm$core$Maybe$Nothing,
			endDateString: '',
			endDateTime: $elm$core$Maybe$Nothing,
			includeSentEmails: false,
			selectedSearchTerm: $elm$core$Maybe$Nothing,
			startDate: $elm$core$Maybe$Nothing,
			startDateString: '',
			startDateTime: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$hasMoreItems = function (data) {
	return $author$project$Stream$hasMore(data.emailMessagesStream);
};
var $author$project$Components$EmailMessageSearchPage$saveLastEmailMessageListViewData = F2(
	function (remoteData, model) {
		return _Utils_update(
			model,
			{
				maybeLastData: A2(
					$elm$core$Maybe$withDefault,
					model.maybeLastData,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Maybe$Just,
						$author$project$Forward$Remote$toMaybe(remoteData)))
			});
	});
var $author$project$Components$EmailMessageSearchPage$queryFromMaybe = F2(
	function (name, value) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, name, v)
						]);
				},
				value));
	});
var $author$project$Components$EmailMessageSearchPage$queryList = F2(
	function (v3Reskin, model) {
		return _Utils_ap(
			A2($author$project$Components$EmailMessageSearchPage$queryFromMaybe, 'search_text', model.selectedSearchTerm),
			_Utils_ap(
				A2(
					$author$project$Components$EmailMessageSearchPage$queryFromMaybe,
					'client_id',
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$fromInt,
						A2(
							$elm$core$Maybe$map,
							$author$project$Domain$TmsCarrierId$toInt,
							A2($author$project$Components$EmailMessageSearchPage$FiltersView$selectedCarrierId, v3Reskin, model)))),
				_Utils_ap(
					A2(
						$author$project$Components$EmailMessageSearchPage$queryFromMaybe,
						'start_date',
						A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, model.startDate)),
					_Utils_ap(
						A2(
							$author$project$Components$EmailMessageSearchPage$queryFromMaybe,
							'start_datetime',
							A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, model.startDateTime)),
						_Utils_ap(
							A2(
								$author$project$Components$EmailMessageSearchPage$queryFromMaybe,
								'end_date',
								A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, model.endDate)),
							_Utils_ap(
								A2(
									$author$project$Components$EmailMessageSearchPage$queryFromMaybe,
									'end_datetime',
									A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, model.endDateTime)),
								model.includeSentEmails ? _List_fromArray(
									[
										A2($elm$url$Url$Builder$string, 'include_sent', 'true')
									]) : _List_Nil))))));
	});
var $author$project$Components$EmailMessageSearchPage$searchUrl = F2(
	function (v3Reskin, model) {
		return A2(
			$elm$url$Url$Builder$absolute,
			_List_fromArray(
				['app', 'email_search']),
			A2($author$project$Components$EmailMessageSearchPage$queryList, v3Reskin, model));
	});
var $author$project$Components$EmailMessageSearchPage$FiltersView$carrierTypeaheadConfig = function (data) {
	return $author$project$Components$CarrierTypeahead$config(
		A2(
			$elm$core$Maybe$map,
			$author$project$Domain$Account$accountType,
			$author$project$Forward$Remote$toMaybe(data)));
};
var $author$project$Helpers$Maybe$validate = F2(
	function (f, a) {
		return f(a) ? $elm$core$Maybe$Just(a) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$EmailMessageSearchPage$FiltersView$update = F3(
	function (data, action, model) {
		switch (action.$) {
			case 'CarrierTypeaheadMsg':
				var msg = action.a;
				var carrierTypeaheadData = A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.carrierTypeaheadData;
					},
					data);
				var carrierTypeaheadConfig_ = $author$project$Components$EmailMessageSearchPage$FiltersView$carrierTypeaheadConfig(
					A2(
						$author$project$Forward$Remote$map,
						function ($) {
							return $.account;
						},
						data));
				var newCarrierTypeahead = A4($author$project$Components$CarrierTypeahead$update, carrierTypeaheadConfig_, carrierTypeaheadData, msg, model.carrierTypeahead);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{carrierTypeahead: newCarrierTypeahead}),
					$author$project$HubTran$Effect$none);
			case 'CarrierDropdownMsg':
				var msg = action.a;
				var _v1 = A3(
					$author$project$Components$SettingsPage$CarrierDropdown$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.carrierDropdownData;
						},
						data),
					msg,
					model.carrierDropdown);
				var carrierDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{carrierDropdown: carrierDropdown}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$EmailMessageSearchPage$FiltersView$CarrierDropdownMsg, cmd)));
			case 'SelectStartDate':
				var newDateString = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							startDate: $elm$core$Result$toMaybe(
								$justinmimbs$date$Date$fromIsoString(newDateString)),
							startDateString: newDateString
						}),
					$author$project$HubTran$Effect$none);
			case 'SelectEndDate':
				var newDateString = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							endDate: $elm$core$Result$toMaybe(
								$justinmimbs$date$Date$fromIsoString(newDateString)),
							endDateString: newDateString
						}),
					$author$project$HubTran$Effect$none);
			case 'SelectSearchTerm':
				var selectedTerm = action.a;
				var validatedTerm = A2(
					$author$project$Helpers$Maybe$validate,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					selectedTerm);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedSearchTerm: validatedTerm}),
					$author$project$HubTran$Effect$none);
			default:
				var newValue = action.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{includeSentEmails: newValue}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$EmailMessageSearchPage$update = F4(
	function (v3Reskin, data, msg, model) {
		switch (msg.$) {
			case 'ApplyFilters':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							filtersApplied: $elm$core$Maybe$Just(model.filtersUiState),
							maybeLastData: $elm$core$Maybe$Nothing,
							page: 0
						}),
					$author$project$HubTran$Effect$replaceUrl(
						A2($author$project$Components$EmailMessageSearchPage$searchUrl, v3Reskin, model.filtersUiState)));
			case 'Clear':
				var clearedFiltersUiState = $author$project$Components$EmailMessageSearchPage$FiltersView$clear(model.filtersUiState);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filtersApplied: $elm$core$Maybe$Nothing, filtersUiState: clearedFiltersUiState, maybeLastData: $elm$core$Maybe$Nothing, page: 0}),
					$author$project$HubTran$Effect$replaceUrl(
						A2($author$project$Components$EmailMessageSearchPage$searchUrl, v3Reskin, clearedFiltersUiState)));
			case 'FiltersViewMsg':
				var childMsg = msg.a;
				var _v1 = A3(
					$author$project$Components$EmailMessageSearchPage$FiltersView$update,
					A2(
						$author$project$Forward$Remote$map,
						function ($) {
							return $.filtersUiState;
						},
						data),
					childMsg,
					model.filtersUiState);
				var filterViewModel = _v1.a;
				var filterViewEffect = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filtersUiState: filterViewModel}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$EmailMessageSearchPage$FiltersViewMsg, filterViewEffect));
			case 'ChangePage':
				var newPage = msg.a;
				var emailMessageListViewData = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.emailMessageListView;
					},
					data);
				var hasMore = function () {
					if ((emailMessageListViewData.$ === 'Loaded') && (emailMessageListViewData.a.$ === 'Just')) {
						var listData = emailMessageListViewData.a.a;
						return $author$project$Components$EmailMessageSearchPage$EmailMessageListView$hasMoreItems(listData);
					} else {
						return false;
					}
				}();
				var canChangePage = ((_Utils_cmp(newPage, model.page) < 0) && (newPage >= 0)) ? true : ((_Utils_cmp(newPage, model.page) > 0) && hasMore);
				return _Utils_Tuple2(
					canChangePage ? _Utils_update(
						model,
						{page: newPage}) : model,
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					A2(
						$author$project$Components$EmailMessageSearchPage$saveLastEmailMessageListViewData,
						data,
						_Utils_update(
							model,
							{page: model.page + 1})),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$CompletedChecks = {$: 'CompletedChecks'};
var $author$project$Components$FactorInvoiceAuditBatchPage$DocumentGroupLoaded = function (a) {
	return {$: 'DocumentGroupLoaded', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$DragDropMsg = function (a) {
	return {$: 'DragDropMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$ForwardEmail = {$: 'ForwardEmail'};
var $author$project$Components$FactorInvoiceAuditBatchPage$IgnoreAllGroups = {$: 'IgnoreAllGroups'};
var $author$project$Components$FactorInvoiceAuditBatchPage$MergeEmail = {$: 'MergeEmail'};
var $author$project$Components$FactorInvoiceAuditBatchPage$PacketComparisonMsg = function (a) {
	return {$: 'PacketComparisonMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$ProcessUnapproveFromActivityResponse = function (a) {
	return {$: 'ProcessUnapproveFromActivityResponse', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$SelectTab = function (a) {
	return {$: 'SelectTab', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaReinitialized = F2(
	function (a, b) {
		return {$: 'WorkingAreaReinitialized', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$BatchGroupResolved = function (a) {
	return {$: 'BatchGroupResolved', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchResolver$decideNextIncomplete = function (groups) {
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.factorInvoiceId;
		},
		A2($author$project$Components$FactorInvoiceAuditBatchResolver$listFind, $author$project$Components$FactorInvoiceAuditBatchResolver$groupIncomplete, groups));
};
var $author$project$Components$FactorInvoiceAuditBatchResolver$resolveNextIncompleteFactorInvoiceIdFromBatchExcluding = F2(
	function (excludeId, documentBatchId) {
		return A2(
			$author$project$Forward$Lookup$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filter(
					function (g) {
						return !_Utils_eq(
							g.factorInvoiceId,
							$elm$core$Maybe$Just(excludeId));
					}),
				$author$project$Components$FactorInvoiceAuditBatchResolver$decideNextIncomplete),
			$author$project$Components$FactorInvoiceAuditBatchResolver$loadGroupSummaries(documentBatchId));
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$advanceToNextIncomplete = function (model) {
	return $author$project$HubTran$Effect$batch(
		_List_fromArray(
			[
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$documentV2),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$documentGroup),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_documentGroupId),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$list_documentPageId),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$factorInvoice),
				A2(
				$author$project$HubTran$Effect$fetchFromCache,
				$author$project$Components$FactorInvoiceAuditBatchPage$BatchGroupResolved,
				A2($author$project$Components$FactorInvoiceAuditBatchResolver$resolveNextIncompleteFactorInvoiceIdFromBatchExcluding, model.workingArea.factorInvoiceId, model.documentBatchId))
			]));
};
var $author$project$Components$DocumentBrowser$Full$HighlightBox = function (a) {
	return {$: 'HighlightBox', a: a};
};
var $author$project$Components$DocumentsBrowser$pinpointHighlight = function (box) {
	return {
		target: $author$project$Components$DocumentBrowser$Full$HighlightBox(box)
	};
};
var $author$project$Components$DocumentsBrowser$setSelectedDocumentPageId = F2(
	function (pageId, model) {
		return _Utils_update(
			model,
			{maybeSelectedDocumentPageId: pageId});
	});
var $author$project$Components$DocumentsBrowser$applyHighlightLocation = F2(
	function (maybeLocation, model) {
		if (maybeLocation.$ === 'Nothing') {
			return _Utils_Tuple2(
				A2($author$project$Components$DocumentsBrowser$setHighlight, $elm$core$Maybe$Nothing, model),
				$author$project$HubTran$Effect$none);
		} else {
			var location = maybeLocation.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Components$DocumentsBrowser$setSelectedDocumentPageId,
					$elm$core$Maybe$Just(
						$author$project$Domain$DocumentPageId$fromInt(location.documentPageId)),
					A2(
						$author$project$Components$DocumentsBrowser$setHighlight,
						$elm$core$Maybe$Just(
							$author$project$Components$DocumentsBrowser$pinpointHighlight(
								{
									documentPageId: $author$project$Domain$DocumentPageId$fromInt(location.documentPageId),
									height: location.height,
									left: location.left,
									top: location.top,
									width: location.width
								})),
						model)),
				$author$project$Components$DocumentsBrowser$scrollToHighlight(model.scrollContainerSuffix));
		}
	});
var $author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$newDocumentsBrowser = F3(
	function (documentsBrowserData, outMsg, documentsBrowser) {
		switch (outMsg.$) {
			case 'HighlightSuggestionLocation':
				var maybeLocation = outMsg.a;
				return A2($author$project$Components$DocumentsBrowser$applyHighlightLocation, maybeLocation, documentsBrowser);
			case 'FindValueInDocuments':
				var value = outMsg.a;
				var pagePredicate = F2(
					function (_v1, lines) {
						return A2(
							$elm$core$List$any,
							$author$project$Domain$DocumentPageLine$matchOnChars(
								$elm$core$Maybe$Just(value)),
							lines);
					});
				return A4($author$project$Components$DocumentsBrowser$applyValueHighlight, value, pagePredicate, documentsBrowserData, documentsBrowser);
			case 'SelectDocumentPageOutMsg':
				var pageId = outMsg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Components$DocumentsBrowser$selectNextPageMatchingRule,
						F2(
							function (candidatePageId, _v2) {
								return _Utils_eq(candidatePageId, pageId);
							}),
						documentsBrowserData,
						documentsBrowser),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(documentsBrowser, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$Comparing = function (a) {
	return {$: 'Comparing', a: a};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$NoSearch = {$: 'NoSearch'};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$noSearch = $author$project$Components$FactorInvoiceDuplicatePacketComparison$NoSearch;
var $author$project$Components$FactorInvoiceAuditPacketComparison$startComparing = function (otherInvoiceId) {
	return $author$project$Components$FactorInvoiceAuditPacketComparison$Comparing(
		{atTop: $elm$core$Dict$empty, otherInvoiceId: otherInvoiceId, search: $author$project$Components$FactorInvoiceDuplicatePacketComparison$noSearch, selectedGroup: $elm$core$Maybe$Nothing});
};
var $author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$newPacketComparison = F2(
	function (outMsg, packetComparison) {
		if (outMsg.$ === 'CompareDuplicateOutMsg') {
			var invoiceId = outMsg.a;
			return $author$project$Components$FactorInvoiceAuditPacketComparison$startComparing(invoiceId);
		} else {
			return packetComparison;
		}
	});
var $author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$newSendToCarrierModalOpen = F2(
	function (outMsg, sendToCarrierModalOpen) {
		if (outMsg.$ === 'OpenSendToCarrierModalOutMsg') {
			return true;
		} else {
			return sendToCarrierModalOpen;
		}
	});
var $author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$applyOutMsg = F3(
	function (documentsBrowserData, outMsg, viewState) {
		var _v0 = A3($author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$newDocumentsBrowser, documentsBrowserData, outMsg, viewState.documentsBrowser);
		var documentsBrowser = _v0.a;
		var documentsBrowserEffect = _v0.b;
		return _Utils_Tuple2(
			{
				documentsBrowser: documentsBrowser,
				packetComparison: A2($author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$newPacketComparison, outMsg, viewState.packetComparison),
				sendToCarrierModalOpen: A2($author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$newSendToCarrierModalOpen, outMsg, viewState.sendToCarrierModalOpen)
			},
			documentsBrowserEffect);
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$closeHeaderModal = function (model) {
	return _Utils_update(
		model,
		{activeHeaderModal: $elm$core$Maybe$Nothing});
};
var $author$project$Components$DocumentsBrowser$setAddressMarks = F2(
	function (addressMarks, model) {
		return _Utils_update(
			model,
			{addressMarks: addressMarks});
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$closeSecondary = function (model) {
	return _Utils_update(
		model,
		{
			documentsBrowser: A2($author$project$Components$DocumentsBrowser$setAddressMarks, false, model.documentsBrowser),
			secondaryDocumentsBrowser: $elm$core$Maybe$Nothing
		});
};
var $author$project$Path$factorInvoiceAuditBatch = F4(
	function (documentBatchId, maybeEmailMessageId, factorInvoiceId, maybeOnDone) {
		var emailIdQuery = function () {
			if (maybeEmailMessageId.$ === 'Just') {
				var emailMessageId = maybeEmailMessageId.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'emailId',
						$elm$core$String$fromInt(
							$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Path$addQueries,
			_Utils_ap(
				emailIdQuery,
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'invoiceId',
							$elm$core$String$fromInt(
								$author$project$Domain$FactorInvoiceId$toInt(factorInvoiceId)))
						]),
					$author$project$Path$onDoneQuery(maybeOnDone))),
			$author$project$Path$factorInvoiceAuditBatchBase(documentBatchId));
	});
var $author$project$Path$factorInvoiceAuditBatchGrouping = F2(
	function (documentBatchId, maybeOnDone) {
		return A2(
			$author$project$Path$addQueries,
			$author$project$Path$onDoneQuery(maybeOnDone),
			A2(
				$author$project$Path$appendToBase,
				_List_fromArray(
					['grouping']),
				$author$project$Path$factorInvoiceAuditBatchBase(documentBatchId)));
	});
var $author$project$AuditPb$factorInvoiceServiceUnapproveRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId)
				])));
};
var $author$project$AuditPb$FactorInvoiceServiceUnapproveResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUnapproveSuccess = function (a) {
	return {$: 'FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUnapproveSuccess', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceUnapproveSuccess = {};
var $author$project$AuditPb$factorInvoiceServiceUnapproveSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceUnapproveSuccess);
	});
var $author$project$AuditPb$factorInvoiceServiceUnapproveResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUnapproveSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServiceUnapproveSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServiceUnapproveResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServiceUnapproveResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServiceUnapproveResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceUnapproveResponse));
	});
var $author$project$AuditApi$factorInvoiceServiceUnapproveRemote = A3($author$project$AuditApi$toRemote, '/factor_invoice_service/unapprove', $author$project$AuditPb$factorInvoiceServiceUnapproveRequestEncoder, $author$project$AuditPb$factorInvoiceServiceUnapproveResponseDecoder);
var $author$project$Components$FactorInvoiceAuditBatchPage$onDoneUrl = function (model) {
	var path = A2(
		$elm$core$Maybe$withDefault,
		'/app/',
		A2(
			$elm$core$Maybe$andThen,
			function (p) {
				return $elm$core$String$isEmpty(p) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(p);
			},
			model.workingArea.onDone));
	return A2($elm$core$String$startsWith, '/flow', path) ? ('/app' + path) : path;
};
var $author$project$Components$DocumentsBrowser$setSelection = F2(
	function (selection, model) {
		return _Utils_update(
			model,
			{selectedPage_INTERNAL: selection});
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$openSecondary = F2(
	function (selection, model) {
		var _v0 = $author$project$Components$DocumentsBrowser$init(
			{
				currentProcessingSelection: $author$project$Components$DocumentsBrowser$getCurrentProcessingSelection(model.documentsBrowser),
				displayUnassignedLoadDocuments: false,
				enabledDocumentTypes: _List_Nil,
				enabledToolbarActions: _List_Nil,
				maybeDefaultViewMode: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$DefaultViewModeWidth),
				maybeOnDone: model.onDone,
				pageContextData: $author$project$Helpers$DocumentViewerPageContextData$empty,
				popout: false,
				scrollContainerSuffix: 'secondary',
				viewPortHeightPxOffset: 0
			});
		var secondary = _v0.a;
		var secondaryEffect = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					documentsBrowser: A2($author$project$Components$DocumentsBrowser$setAddressMarks, model.usesVectorWorkflow, model.documentsBrowser),
					secondaryDocumentsBrowser: $elm$core$Maybe$Just(
						A2(
							$author$project$Components$DocumentsBrowser$setAddressMarks,
							model.usesVectorWorkflow,
							A2($author$project$Components$DocumentsBrowser$setSelection, selection, secondary))),
					splitPane: $author$project$Components$AuditSplitPane$collapse(model.splitPane)
				}),
			A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditBatchPage$SecondaryDocumentsBrowserMsg, secondaryEffect));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect = function (factorInvoiceId) {
	return $author$project$HubTran$Effect$batch(
		_List_fromArray(
			[
				$author$project$HubTran$Effect$refresh(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
				$author$project$HubTran$Effect$refresh(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceAuditChecks)),
				$author$project$HubTran$Effect$refresh(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentPODDefinitionsByFactorInvoiceId)),
				$author$project$HubTran$Effect$refresh(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$duplicateFactorInvoicesByFactorInvoiceId)),
				$author$project$HubTran$Effect$refresh(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$possibleMatchesByFactorInvoiceId)),
				$author$project$HubTran$Effect$refresh(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailAndReplyMessagesByFactorInvoiceId)),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$stream_activityItemId),
				$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$activityItem)
			]));
};
var $author$project$Components$FactorInvoiceAuditBatchPage$podRefreshHooks = function (factorInvoiceId) {
	var hooks = $author$project$Components$DocumentsBrowser$noHooks;
	return _Utils_update(
		hooks,
		{
			onMarkIllegibleFinished: $elm$core$Maybe$Just(
				function (_v0) {
					return $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(factorInvoiceId);
				}),
			onUpdateDocumentTypeFinished: $elm$core$Maybe$Just(
				F2(
					function (_v1, _v2) {
						return $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(factorInvoiceId);
					})),
			onUpdatePodFinished: $elm$core$Maybe$Just(
				function (_v3) {
					return $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(factorInvoiceId);
				})
		});
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				auditChecksRequiredAt: $elm$time$Time$millisToPosix(
					$elm$time$Time$posixToMillis(model.auditChecksRequiredAt) + 1)
			}),
		$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.factorInvoiceId));
};
var $author$project$Components$DocumentsBrowser$selectDocumentMsg = F3(
	function (data, model, selection) {
		return $author$project$Components$DocumentsBrowser$NonHotkeyMsg(
			A3($author$project$Components$DocumentsBrowser$buildSelectDocumentMsg, data, model, selection));
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$Landed = function (a) {
	return {$: 'Landed', a: a};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$Found = function (a) {
	return {$: 'Found', a: a};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$advance = F2(
	function (find, search) {
		var _v0 = find.anchors;
		if (!_v0.b) {
			return _Utils_Tuple2(
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$NotFound(
					{value: find.value}),
				$elm$core$Maybe$Nothing);
		} else {
			var match = function () {
				if (search.$ === 'Found') {
					var current = search.a;
					return _Utils_eq(current.value, find.value) ? A2(
						$elm$core$Basics$modBy,
						$elm$core$List$length(find.anchors),
						current.match + 1) : 0;
				} else {
					return 0;
				}
			}();
			return _Utils_Tuple2(
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$Found(
					{match: match, value: find.value}),
				$elm$core$List$head(
					A2($elm$core$List$drop, match, find.anchors)));
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$byPane = function (anchors) {
	return A2(
		$elm$core$List$filter,
		function (_v0) {
			var elementIds = _v0.b;
			return !$elm$core$List$isEmpty(elementIds);
		},
		A2(
			$elm$core$List$map,
			function (sideIndex) {
				return _Utils_Tuple2(
					sideIndex,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.elementId;
						},
						A2(
							$elm$core$List$filter,
							function (anchor) {
								return _Utils_eq(anchor.sideIndex, sideIndex);
							},
							anchors)));
			},
			_List_fromArray(
				[0, 1])));
};
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $elm$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return $elm$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$contentPositions = F2(
	function (scrollerId, elementIds) {
		return A4(
			$elm$core$Task$map3,
			F3(
				function (viewport, scroller, elements) {
					return _Utils_Tuple2(
						viewport,
						A2(
							$elm$core$List$map,
							function (element) {
								return (element.element.y - scroller.element.y) + viewport.viewport.y;
							},
							elements));
				}),
			$elm$browser$Browser$Dom$getViewportOf(scrollerId),
			$elm$browser$Browser$Dom$getElement(scrollerId),
			$elm$core$Task$sequence(
				A2($elm$core$List$map, $elm$browser$Browser$Dom$getElement, elementIds)));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$paneId = function (sideIndex) {
	return 'fi-audit-packet-compare-pane-' + $elm$core$String$fromInt(sideIndex);
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$measurePane = F2(
	function (choose, _v0) {
		var sideIndex = _v0.a;
		var elementIds = _v0.b;
		return A2(
			$elm$core$Task$map,
			function (_v1) {
				var viewport = _v1.a;
				var positions = _v1.b;
				var pane = {
					maxScroll: A2($elm$core$Basics$max, 0, viewport.scene.height - viewport.viewport.height),
					pageTops: positions,
					scrollTop: viewport.viewport.y
				};
				return A2(
					$elm$core$Maybe$map,
					function (scrollTop) {
						return {
							distance: $elm$core$Basics$abs(scrollTop - pane.scrollTop),
							scrollTop: scrollTop,
							sideIndex: sideIndex,
							viewportX: viewport.viewport.x
						};
					},
					choose(pane));
			},
			A2(
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$contentPositions,
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$paneId(sideIndex),
				elementIds));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$nearest = function (candidates) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.distance;
			},
			candidates));
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$scroll = F2(
	function (choose, anchors) {
		var measure = A2(
			$elm$core$Task$andThen,
			function (_v3) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$measurePane(choose),
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$byPane(anchors)));
			},
			A2(
				$elm$core$Task$mapError,
				$elm$core$Basics$never,
				$elm$core$Process$sleep(0)));
		return A2(
			$elm$core$Task$andThen,
			function (candidates) {
				var _v1 = $author$project$Components$FactorInvoiceDuplicatePacketComparison$nearest(
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, candidates));
				if (_v1.$ === 'Just') {
					var candidate = _v1.a;
					return A2(
						$elm$core$Task$map,
						function (_v2) {
							return $elm$core$Maybe$Just(candidate);
						},
						A3(
							$elm$browser$Browser$Dom$setViewportOf,
							$author$project$Components$FactorInvoiceDuplicatePacketComparison$paneId(candidate.sideIndex),
							candidate.viewportX,
							candidate.scrollTop));
				} else {
					return $elm$core$Task$succeed($elm$core$Maybe$Nothing);
				}
			},
			A2(
				$elm$core$Task$onError,
				function (_v0) {
					return measure;
				},
				measure));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$stickyOffset = 32;
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$topOf = function (pane) {
	return A2(
		$elm$core$Maybe$map,
		function (y) {
			return A3($elm$core$Basics$clamp, 0, pane.maxScroll, y - $author$project$Components$FactorInvoiceDuplicatePacketComparison$stickyOffset);
		},
		$elm$core$List$head(pane.pageTops));
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$jump = F2(
	function (landed, target) {
		if (target.$ === 'ToGroup') {
			return $elm$core$Platform$Cmd$none;
		} else {
			var anchor = target.a;
			return A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$toMaybe,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$andThen($elm$core$Basics$identity),
						landed)),
				A2(
					$elm$core$Task$map,
					$elm$core$Maybe$map(
						function (candidate) {
							return {
								group: anchor.group,
								reading: {page: anchor.pageIndex, scrollTop: candidate.scrollTop},
								sideIndex: anchor.sideIndex
							};
						}),
					A2(
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$scroll,
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$topOf,
						_List_fromArray(
							[anchor]))));
		}
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$readPane = F4(
	function (group, sideIndex, read, model) {
		if (model.$ === 'Comparing') {
			var selection = model.a;
			return (_Utils_eq(selection.selectedGroup, $elm$core$Maybe$Nothing) || _Utils_eq(
				selection.selectedGroup,
				$elm$core$Maybe$Just(group))) ? $author$project$Components$FactorInvoiceAuditPacketComparison$Comparing(
				_Utils_update(
					selection,
					{
						atTop: A3($elm$core$Dict$update, sideIndex, read, selection.atTop),
						selectedGroup: $elm$core$Maybe$Just(group)
					})) : model;
		} else {
			return model;
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$readTolerance = 24;
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageAtTop = function (pane) {
	return $elm$core$List$head(
		$elm$core$List$reverse(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var position = _v0.b;
						return _Utils_cmp(position, pane.scrollTop + $author$project$Components$FactorInvoiceDuplicatePacketComparison$readTolerance) < 1;
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (pageIndex, y) {
								return _Utils_Tuple2(
									pageIndex,
									A3($elm$core$Basics$clamp, 0, pane.maxScroll, y - $author$project$Components$FactorInvoiceDuplicatePacketComparison$stickyOffset));
							}),
						pane.pageTops)))));
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$reading = F2(
	function (pinned, pane) {
		var read = A2(
			$elm$core$Maybe$map,
			function (page) {
				return {page: page, scrollTop: pane.scrollTop};
			},
			$author$project$Components$FactorInvoiceDuplicatePacketComparison$pageAtTop(pane));
		if (pinned.$ === 'Just') {
			var pin = pinned.a;
			return ($elm$core$Basics$abs(pane.scrollTop - pin.scrollTop) < 1) ? $elm$core$Maybe$Just(pin) : read;
		} else {
			return read;
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$jumpedGroup = function (target) {
	if (target.$ === 'ToGroup') {
		var group = target.a;
		return $elm$core$Maybe$Just(group);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$selectingGroup = F2(
	function (group, selection) {
		if (group.$ === 'Just') {
			var key = group.a;
			return _Utils_eq(
				$elm$core$Maybe$Just(key),
				selection.selectedGroup) ? selection : _Utils_update(
				selection,
				{
					atTop: $elm$core$Dict$empty,
					selectedGroup: $elm$core$Maybe$Just(key)
				});
		} else {
			return selection;
		}
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$selectGroup = F2(
	function (target, model) {
		if (model.$ === 'Comparing') {
			var selection = model.a;
			return $author$project$Components$FactorInvoiceAuditPacketComparison$Comparing(
				A2(
					$author$project$Components$FactorInvoiceAuditPacketComparison$selectingGroup,
					$author$project$Components$FactorInvoiceDuplicatePacketComparison$jumpedGroup(target),
					selection));
		} else {
			return model;
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$ToPage = function (a) {
	return {$: 'ToPage', a: a};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$toPage = $author$project$Components$FactorInvoiceDuplicatePacketComparison$ToPage;
var $author$project$Components$FactorInvoiceAuditPacketComparison$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'CloseClicked':
				return _Utils_Tuple2($author$project$Components$FactorInvoiceAuditPacketComparison$NotComparing, $elm$core$Platform$Cmd$none);
			case 'DuplicateChosen':
				var invoiceId = msg.a;
				return _Utils_Tuple2(
					$author$project$Components$FactorInvoiceAuditPacketComparison$startComparing(invoiceId),
					$elm$core$Platform$Cmd$none);
			case 'FindValueRequested':
				var find = msg.a;
				if (model.$ === 'NotComparing') {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var selection = model.a;
					var _v2 = A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$advance, find, selection.search);
					var search = _v2.a;
					var target = _v2.b;
					return _Utils_Tuple2(
						$author$project$Components$FactorInvoiceAuditPacketComparison$Comparing(
							A2(
								$author$project$Components$FactorInvoiceAuditPacketComparison$selectingGroup,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.group;
									},
									target),
								_Utils_update(
									selection,
									{search: search}))),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$FactorInvoiceDuplicatePacketComparison$toPage,
									$author$project$Components$FactorInvoiceDuplicatePacketComparison$jump($author$project$Components$FactorInvoiceAuditPacketComparison$Landed)),
								target)));
				}
			case 'JumpRequested':
				var target = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$FactorInvoiceAuditPacketComparison$selectGroup, target, model),
					A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$jump, $author$project$Components$FactorInvoiceAuditPacketComparison$Landed, target));
			case 'PaneScrolled':
				var pane = msg.a.pane;
				var sideIndex = msg.a.sideIndex;
				var group = msg.a.group;
				return _Utils_Tuple2(
					A4(
						$author$project$Components$FactorInvoiceAuditPacketComparison$readPane,
						group,
						sideIndex,
						function (pinned) {
							return A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$reading, pinned, pane);
						},
						model),
					$elm$core$Platform$Cmd$none);
			default:
				if (msg.a.$ === 'Just') {
					var reading = msg.a.a.reading;
					var sideIndex = msg.a.a.sideIndex;
					var group = msg.a.a.group;
					return _Utils_Tuple2(
						A4(
							$author$project$Components$FactorInvoiceAuditPacketComparison$readPane,
							group,
							sideIndex,
							function (_v3) {
								return $elm$core$Maybe$Just(reading);
							},
							model),
						$elm$core$Platform$Cmd$none);
				} else {
					var _v4 = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$AuditChecksMsg = function (a) {
	return {$: 'AuditChecksMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$CompareDuplicateOutMsg = function (a) {
	return {$: 'CompareDuplicateOutMsg', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceManuallyAddressRuleFailureActionIgnore = {$: 'FactorInvoiceServiceManuallyAddressRuleFailureActionIgnore'};
var $author$project$AuditPb$FactorInvoiceServiceManuallyAddressRuleFailureActionUnignore = {$: 'FactorInvoiceServiceManuallyAddressRuleFailureActionUnignore'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$FindValueInDocuments = function (a) {
	return {$: 'FindValueInDocuments', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$HighlightSuggestionLocation = function (a) {
	return {$: 'HighlightSuggestionLocation', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$InputDroppedOutMsg = function (a) {
	return {$: 'InputDroppedOutMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$OpenSendToCarrierModalOutMsg = {$: 'OpenSendToCarrierModalOutMsg'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$SelectDocumentPageOutMsg = function (a) {
	return {$: 'SelectDocumentPageOutMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$SetDocumentTypeOutMsg = F2(
	function (a, b) {
		return {$: 'SetDocumentTypeOutMsg', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessAbandonResponse = function (a) {
	return {$: 'ProcessAbandonResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceAbandonRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'reason', $elm$json$Json$Encode$string, v.reason)
				])));
};
var $author$project$AuditPb$FactorInvoiceServiceAbandonResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServiceAbandonResponse_Outcome_FactorInvoiceServiceAbandonSuccess = function (a) {
	return {$: 'FactorInvoiceServiceAbandonResponse_Outcome_FactorInvoiceServiceAbandonSuccess', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceAbandonResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServiceAbandonResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceAbandonSuccess = {};
var $author$project$AuditPb$factorInvoiceServiceAbandonSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceAbandonSuccess);
	});
var $author$project$AuditPb$factorInvoiceServiceAbandonResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceAbandonResponse_Outcome_FactorInvoiceServiceAbandonSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServiceAbandonSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceAbandonResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServiceAbandonResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServiceAbandonResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServiceAbandonResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceAbandonResponse));
	});
var $author$project$AuditApi$factorInvoiceServiceAbandonWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/abandon', $author$project$AuditPb$factorInvoiceServiceAbandonRequestEncoder, $author$project$AuditPb$factorInvoiceServiceAbandonResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$abandon = function (model) {
	return A3(
		$author$project$AuditApi$factorInvoiceServiceAbandonWithState,
		model,
		$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessAbandonResponse,
		{factorInvoiceId: model.factorInvoiceId, reason: model.ignoreReason});
};
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateAmount = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateAmount', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$amountUpdates = function (amount) {
	return _List_fromArray(
		[
			{
			update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateAmount(
				{amount: amount})
		}
		]);
};
var $author$project$Components$BrokeredCarrierDropdown$brokeredCarrierToDropdownItem = function (carrier) {
	return {
		id: $elm$core$String$fromInt(
			$author$project$Domain$BrokeredCarrierId$toInt(carrier.id)),
		label: $elm$html$Html$text(carrier.name),
		text: carrier.name
	};
};
var $author$project$Components$BrokeredCarrierDropdown$update = F3(
	function (data, msg, model) {
		var _v0 = A4($author$project$Components$PaginatedDropdown$update, $author$project$Components$BrokeredCarrierDropdown$brokeredCarrierToDropdownItem, data, msg, model.dropdown);
		var newDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: newDropdown}),
			cmd);
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$applyBrokeredCarrierDropdownMsg = F3(
	function (remoteData, dropdownMsg, model) {
		var dropdownData = A2(
			$author$project$Forward$Remote$andThen,
			function ($) {
				return $.brokeredCarrierDropdownData;
			},
			remoteData);
		var _v0 = A3($author$project$Components$BrokeredCarrierDropdown$update, dropdownData, dropdownMsg, model.brokeredCarrierDropdown);
		var newDropdown = _v0.a;
		var dropdownCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{brokeredCarrierDropdown: newDropdown}),
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$BrokeredCarrierDropdownMsg, dropdownCmd)));
	});
var $author$project$Components$BrokeredCarrierTermDropdown$brokeredCarrierTermToDropdownItem = function (term) {
	return {
		id: $elm$core$String$fromInt(
			$author$project$Domain$BrokeredCarrierTermId$toInt(term.id)),
		label: $elm$html$Html$text(term.name),
		text: term.name
	};
};
var $author$project$Components$BrokeredCarrierTermDropdown$update = F3(
	function (data, msg, model) {
		var _v0 = A4($author$project$Components$PaginatedDropdown$update, $author$project$Components$BrokeredCarrierTermDropdown$brokeredCarrierTermToDropdownItem, data, msg, model.dropdown);
		var newDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: newDropdown}),
			cmd);
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$applyBrokeredCarrierTermDropdownMsg = F3(
	function (remoteData, dropdownMsg, model) {
		var dropdownData = A2(
			$author$project$Forward$Remote$andThen,
			function ($) {
				return $.brokeredCarrierTermDropdownData;
			},
			remoteData);
		var _v0 = A3($author$project$Components$BrokeredCarrierTermDropdown$update, dropdownData, dropdownMsg, model.brokeredCarrierTermDropdown);
		var newDropdown = _v0.a;
		var dropdownCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{brokeredCarrierTermDropdown: newDropdown}),
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$BrokeredCarrierTermDropdownMsg, dropdownCmd)));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$applyCarrierDropdownMsg = F3(
	function (remoteData, dropdownMsg, model) {
		var dropdownData = A2(
			$author$project$Forward$Remote$andThen,
			function ($) {
				return $.carrierDropdownData;
			},
			remoteData);
		var _v0 = A3($author$project$Components$CarrierDropdown$update, dropdownData, dropdownMsg, model.carrierDropdown);
		var newDropdown = _v0.a;
		var dropdownCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{carrierDropdown: newDropdown}),
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$CarrierDropdownMsg, dropdownCmd)));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$applyDebtorDropdownMsg = F3(
	function (remoteData, dropdownMsg, model) {
		var dropdownData = A2(
			$author$project$Forward$Remote$andThen,
			function ($) {
				return $.debtorDropdownData;
			},
			remoteData);
		var _v0 = A3($author$project$Components$DebtorDropdown$update, dropdownData, dropdownMsg, model.debtorDropdown);
		var newDropdown = _v0.a;
		var dropdownCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{debtorDropdown: newDropdown}),
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$DebtorDropdownMsg, dropdownCmd)));
	});
var $author$project$AuditApi$applyRequestWithRequestStateAccessorsAndOut = F6(
	function (model, postRequestStateGetter, postRequestStateSetter, noOutMsg, responseState, onSuccess) {
		var requestState = postRequestStateGetter(model);
		var _v0 = A2($author$project$PostRequestState$handleResponseCustom, requestState, responseState);
		var newRequestState = _v0.a;
		var result = _v0.b;
		var newModel = A2(postRequestStateSetter, model, newRequestState);
		if (result.$ === 'Ok') {
			var outerSuccess = result.a;
			if (outerSuccess.$ === 'Ok') {
				var successVal = outerSuccess.a;
				return A2(onSuccess, newModel, successVal);
			} else {
				var err = outerSuccess.a;
				return _Utils_Tuple3(
					newModel,
					$author$project$Helpers$HttpError$defaultHttpErrorHandler(err),
					noOutMsg);
			}
		} else {
			var err = result.a;
			return _Utils_Tuple3(
				newModel,
				$author$project$Helpers$HttpError$defaultHttpErrorHandler(err),
				noOutMsg);
		}
	});
var $author$project$AuditApi$applyRequestWithOut = F4(
	function (model, noOutMsg, responseState, onSuccess) {
		return A6(
			$author$project$AuditApi$applyRequestWithRequestStateAccessorsAndOut,
			model,
			function ($) {
				return $.requestState;
			},
			F2(
				function (m, requestState) {
					return _Utils_update(
						m,
						{requestState: requestState});
				}),
			noOutMsg,
			responseState,
			onSuccess);
	});
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateBrokeredCarrierTerm = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateBrokeredCarrierTerm', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$brokeredCarrierTermUpdates = function (brokeredCarrierTermId) {
	return _List_fromArray(
		[
			{
			update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateBrokeredCarrierTerm(
				{brokeredCarrierTermId: brokeredCarrierTermId})
		}
		]);
};
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateBrokeredCarrier = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateBrokeredCarrier', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$brokeredCarrierUpdates = function (brokeredCarrierId) {
	return _List_fromArray(
		[
			{
			update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateBrokeredCarrier(
				{brokeredCarrierId: brokeredCarrierId})
		}
		]);
};
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateCarrierAmount = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateCarrierAmount', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$carrierAmountUpdates = function (amount) {
	return _List_fromArray(
		[
			{
			update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateCarrierAmount(
				{amount: amount})
		}
		]);
};
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateCarrier = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateCarrier', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$carrierUpdates = function (tmsCarrierId) {
	return _List_fromArray(
		[
			{
			update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateCarrier(
				{
					carrierId: $author$project$Domain$TmsCarrierId$toInt(tmsCarrierId)
				})
		}
		]);
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessCreateExceptionResponse = function (a) {
	return {$: 'ProcessCreateExceptionResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceCreateExceptionRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'message', $elm$json$Json$Encode$string, v.message)
				])));
};
var $author$project$AuditPb$FactorInvoiceServiceCreateExceptionResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServiceCreateExceptionResponse_Outcome_FactorInvoiceServiceCreateExceptionSuccess = function (a) {
	return {$: 'FactorInvoiceServiceCreateExceptionResponse_Outcome_FactorInvoiceServiceCreateExceptionSuccess', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceCreateExceptionResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServiceCreateExceptionResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceCreateExceptionSuccess = {};
var $author$project$AuditPb$factorInvoiceServiceCreateExceptionSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceCreateExceptionSuccess);
	});
var $author$project$AuditPb$factorInvoiceServiceCreateExceptionResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceCreateExceptionResponse_Outcome_FactorInvoiceServiceCreateExceptionSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServiceCreateExceptionSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceCreateExceptionResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServiceCreateExceptionResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServiceCreateExceptionResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServiceCreateExceptionResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceCreateExceptionResponse));
	});
var $author$project$AuditApi$factorInvoiceServiceCreateExceptionWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/create_exception', $author$project$AuditPb$factorInvoiceServiceCreateExceptionRequestEncoder, $author$project$AuditPb$factorInvoiceServiceCreateExceptionResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$createException = F2(
	function (model, message) {
		return A3(
			$author$project$AuditApi$factorInvoiceServiceCreateExceptionWithState,
			model,
			$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessCreateExceptionResponse,
			{factorInvoiceId: model.factorInvoiceId, message: message});
	});
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateInvoiceDate = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateInvoiceDate', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$dateUpdates = F2(
	function (remoteData, dateInput) {
		var invoiceDate = $elm$core$String$isEmpty(dateInput) ? A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$justinmimbs$date$Date$toIsoString,
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.factorInvoice;
						},
						function ($) {
							return $.invoiceDate;
						}),
					$author$project$Forward$Remote$toMaybe(remoteData)))) : dateInput;
		return _List_fromArray(
			[
				{
				update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateInvoiceDate(
					{invoiceDate: invoiceDate})
			}
			]);
	});
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateDebtor = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateDebtor', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$debtorUpdates = function (factorBrokerId) {
	return _List_fromArray(
		[
			{
			update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateDebtor(
				{
					factorBrokerId: $author$project$Domain$FactorBrokerId$toInt(factorBrokerId)
				})
		}
		]);
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$dropTargetField = function (target) {
	if (target.$ === 'QuickReviewInput') {
		var field = target.a;
		return field;
	} else {
		var field = target.a;
		return field;
	}
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoredInvoiceOutMsg = {$: 'IgnoredInvoiceOutMsg'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh = F2(
	function (model, message) {
		var _v0 = $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(model);
		var refreshedModel = _v0.a;
		var refreshEffect = _v0.b;
		return _Utils_Tuple2(
			refreshedModel,
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert(message)),
						refreshEffect
					])));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	return _Utils_Tuple3(m, e, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleAbandonResponse = F2(
	function (m, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'FactorInvoiceServiceAbandonResponse_Outcome_FactorInvoiceServiceAbandonSuccess') {
			return _Utils_Tuple3(
				_Utils_update(
					m,
					{ignoreModalOpen: false}),
				$author$project$HubTran$Effect$none,
				$author$project$Components$FactorInvoiceAuditWorkingArea$IgnoredInvoiceOutMsg);
		} else {
			var message = _v0.a.message;
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				A2(
					$author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh,
					_Utils_update(
						m,
						{ignoreModalOpen: false}),
					message));
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleCreateExceptionResponse = F2(
	function (m, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'FactorInvoiceServiceCreateExceptionResponse_Outcome_FactorInvoiceServiceCreateExceptionSuccess') {
			return $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(m);
		} else {
			var message = _v0.a.message;
			return A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message);
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessedOutMsg = {$: 'ProcessedOutMsg'};
var $author$project$Components$FactorInvoiceAuditChecks$resetFailedCheckToggles = function (model) {
	return _Utils_update(
		model,
		{expandedFailedChecks: _List_Nil});
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$resetFailedCheckToggles = function (model) {
	return _Utils_update(
		model,
		{
			auditChecks: $author$project$Components$FactorInvoiceAuditChecks$resetFailedCheckToggles(model.auditChecks)
		});
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleMarkAsProcessedResponse = F2(
	function (m, updateResponse) {
		var _v0 = updateResponse.outcome;
		if (_v0.$ === 'FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateSuccess') {
			var result = _v0.a.result;
			if (result.$ === 'FactorInvoiceServiceUpdateResultProcessed') {
				return _Utils_Tuple3(m, $author$project$HubTran$Effect$none, $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessedOutMsg);
			} else {
				return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
					$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(
						$author$project$Components$FactorInvoiceAuditWorkingArea$resetFailedCheckToggles(m)));
			}
		} else {
			var message = _v0.a.message;
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				A2(
					$author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh,
					$author$project$Components$FactorInvoiceAuditWorkingArea$resetFailedCheckToggles(m),
					message));
		}
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$clearSelection = function (_v0) {
	var model = _v0.a;
	return $author$project$Components$FactorInvoiceAudit$PossibleMatches$Model(
		_Utils_update(
			model,
			{selectedMatch: $elm$core$Maybe$Nothing}));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleMergeFromResponse = F2(
	function (m, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'FactorInvoiceServiceMergeFromResponse_Outcome_FactorInvoiceServiceMergeFromSuccess') {
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(
					_Utils_update(
						m,
						{
							possibleMatchesSection: $author$project$Components$FactorInvoiceAudit$PossibleMatches$clearSelection(m.possibleMatchesSection)
						})));
		} else {
			var message = _v0.a.message;
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message));
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleMustVerifySaveResponse = F2(
	function (m, updateResponse) {
		var _v0 = updateResponse.outcome;
		if (_v0.$ === 'FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateSuccess') {
			return _Utils_Tuple2(m, $author$project$HubTran$Effect$none);
		} else {
			var message = _v0.a.message;
			return A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message);
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleNotesSaveResponse = F2(
	function (m, updateResponse) {
		var _v0 = updateResponse.outcome;
		if (_v0.$ === 'FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateSuccess') {
			return _Utils_Tuple2(m, $author$project$HubTran$Effect$none);
		} else {
			var message = _v0.a.message;
			return A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message);
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$RejectOutMsg = {$: 'RejectOutMsg'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$withOutMsg = F2(
	function (outMsg, _v0) {
		var m = _v0.a;
		var e = _v0.b;
		return _Utils_Tuple3(m, e, outMsg);
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleRejectResponse = F2(
	function (m, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'FactorInvoiceServiceRejectResponse_Outcome_FactorInvoiceServiceRejectSuccess') {
			return A2(
				$author$project$Components$FactorInvoiceAuditWorkingArea$withOutMsg,
				$author$project$Components$FactorInvoiceAuditWorkingArea$RejectOutMsg,
				$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(m));
		} else {
			var message = _v0.a.message;
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message));
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$RevivedInvoiceOutMsg = {$: 'RevivedInvoiceOutMsg'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleReviveResponse = F2(
	function (m, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'FactorInvoiceServiceReviveResponse_Outcome_FactorInvoiceServiceReviveSuccess') {
			return A2(
				$author$project$Components$FactorInvoiceAuditWorkingArea$withOutMsg,
				$author$project$Components$FactorInvoiceAuditWorkingArea$RevivedInvoiceOutMsg,
				$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(m));
		} else {
			var message = _v0.a.message;
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message));
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$SavedAndApprovedOutMsg = {$: 'SavedAndApprovedOutMsg'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$navigateWithFlash = F2(
	function (message, onDone) {
		var targetUrl = function () {
			if (onDone.$ === 'Just') {
				var path = onDone.a;
				return $elm$core$String$isEmpty(path) ? '/app/' : path;
			} else {
				return '/app/';
			}
		}();
		return $author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$flash(
					$author$project$HubTran$Flash$success(message)),
					$author$project$HubTran$Effect$load(targetUrl)
				]));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleSaveAndApproveResponse = F2(
	function (m, updateResponse) {
		var _v0 = updateResponse.outcome;
		if (_v0.$ === 'FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateSuccess') {
			return _Utils_Tuple3(
				m,
				A2($author$project$Components$FactorInvoiceAuditWorkingArea$navigateWithFlash, 'Invoice approved', m.onDone),
				$author$project$Components$FactorInvoiceAuditWorkingArea$SavedAndApprovedOutMsg);
		} else {
			var message = _v0.a.message;
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				A2(
					$author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh,
					$author$project$Components$FactorInvoiceAuditWorkingArea$resetFailedCheckToggles(m),
					message));
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$SavedAsIncompleteOutMsg = {$: 'SavedAsIncompleteOutMsg'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleSaveAsIncompleteResponse = F2(
	function (m, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'FactorInvoiceServiceSaveWithErrorsResponse_Outcome_FactorInvoiceServiceUpdateSuccess') {
			return _Utils_Tuple3(m, $author$project$HubTran$Effect$none, $author$project$Components$FactorInvoiceAuditWorkingArea$SavedAsIncompleteOutMsg);
		} else {
			var message = _v0.a.message;
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message));
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleSaveWithErrorsResponse = F2(
	function (m, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'FactorInvoiceServiceSaveWithErrorsResponse_Outcome_FactorInvoiceServiceUpdateSuccess') {
			return _Utils_Tuple2(
				_Utils_update(
					m,
					{sendToCarrierModalRequested: true}),
				$author$project$HubTran$Effect$none);
		} else {
			var message = _v0.a.message;
			return A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message);
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$UnapprovedInvoiceOutMsg = {$: 'UnapprovedInvoiceOutMsg'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleUnapproveResponse = F2(
	function (m, response) {
		var _v0 = response.outcome;
		if (_v0.$ === 'FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUnapproveSuccess') {
			return A2(
				$author$project$Components$FactorInvoiceAuditWorkingArea$withOutMsg,
				$author$project$Components$FactorInvoiceAuditWorkingArea$UnapprovedInvoiceOutMsg,
				$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(m));
		} else {
			var message = _v0.a.message;
			return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
				A2($author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh, m, message));
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$handleUpdateResponse = F2(
	function (m, updateResponse) {
		var _v0 = updateResponse.outcome;
		if (_v0.$ === 'FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateSuccess') {
			var result = _v0.a.result;
			if (result.$ === 'FactorInvoiceServiceUpdateResultProcessed') {
				return _Utils_Tuple2(
					m,
					A2($author$project$Components$FactorInvoiceAuditWorkingArea$navigateWithFlash, 'Invoice processed', m.onDone));
			} else {
				return $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(
					$author$project$Components$FactorInvoiceAuditWorkingArea$resetFailedCheckToggles(m));
			}
		} else {
			var message = _v0.a.message;
			return A2(
				$author$project$Components$FactorInvoiceAuditWorkingArea$alertAndRefresh,
				$author$project$Components$FactorInvoiceAuditWorkingArea$resetFailedCheckToggles(m),
				message);
		}
	});
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateInvoiceNumber = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateInvoiceNumber', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$invoiceNumberUpdates = function (invoiceNumber) {
	return _List_fromArray(
		[
			{
			update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateInvoiceNumber(
				{invoiceNumber: invoiceNumber})
		}
		]);
};
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateIsTonu = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateIsTonu', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$isTonuUpdates = function (isTonu) {
	return _List_fromArray(
		[
			{
			update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateIsTonu(
				{isTonu: isTonu})
		}
		]);
};
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateDebtorLoadIdAutofill = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateDebtorLoadIdAutofill', a: a};
};
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateLoadId = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateLoadId', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$loadIdUpdates = F2(
	function (loadId, debtorAutofill) {
		var debtorAutofillUpdates = function () {
			if (debtorAutofill.$ === 'Nothing') {
				return _List_Nil;
			} else {
				var enabled = debtorAutofill.a;
				return _List_fromArray(
					[
						{
						update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateDebtorLoadIdAutofill(
							{enabled: enabled})
					}
					]);
			}
		}();
		return A2(
			$elm$core$List$cons,
			{
				update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateLoadId(
					{loadId: loadId})
			},
			debtorAutofillUpdates);
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessUpdateResponse = function (a) {
	return {$: 'ProcessUpdateResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceManuallyAddressRuleFailureActionToString = function (v) {
	if (v.$ === 'FactorInvoiceServiceManuallyAddressRuleFailureActionIgnore') {
		return 'IGNORE';
	} else {
		return 'UNIGNORE';
	}
};
var $author$project$AuditPb$factorInvoiceServiceManuallyAddressRuleFailureActionEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$factorInvoiceServiceManuallyAddressRuleFailureActionToString);
var $author$project$Domain$RuleEvaluationId$toInt = $author$project$Id$toInt;
var $author$project$AuditPb$factorInvoiceServiceManuallyAddressRuleFailureRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'ruleEvaluationId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$RuleEvaluationId$toInt),
					v.ruleEvaluationId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'action', $author$project$AuditPb$factorInvoiceServiceManuallyAddressRuleFailureActionEncoder, v.action)
				])));
};
var $author$project$AuditPb$FactorInvoiceServiceUpdateResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateSuccess = function (a) {
	return {$: 'FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateSuccess', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceUpdateSuccess = function (result) {
	return {result: result};
};
var $author$project$AuditPb$FactorInvoiceServiceUpdateResultException = {$: 'FactorInvoiceServiceUpdateResultException'};
var $author$project$AuditPb$factorInvoiceServiceUpdateResultDefault = $author$project$AuditPb$FactorInvoiceServiceUpdateResultException;
var $author$project$AuditPb$FactorInvoiceServiceUpdateResultProcessed = {$: 'FactorInvoiceServiceUpdateResultProcessed'};
var $author$project$AuditPb$allFactorInvoiceServiceUpdateResult = _List_fromArray(
	[$author$project$AuditPb$FactorInvoiceServiceUpdateResultException, $author$project$AuditPb$FactorInvoiceServiceUpdateResultProcessed]);
var $author$project$AuditPb$factorInvoiceServiceUpdateResultToString = function (v) {
	if (v.$ === 'FactorInvoiceServiceUpdateResultException') {
		return 'EXCEPTION';
	} else {
		return 'PROCESSED';
	}
};
var $author$project$AuditPb$factorInvoiceServiceUpdateResultDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(
				$author$project$AuditPb$factorInvoiceServiceUpdateResultToString(v),
				v);
		},
		$author$project$AuditPb$allFactorInvoiceServiceUpdateResult));
var $author$project$AuditPb$factorInvoiceServiceUpdateResultFromString = function (s) {
	return A2($elm$core$Dict$get, s, $author$project$AuditPb$factorInvoiceServiceUpdateResultDict);
};
var $author$project$AuditPb$factorInvoiceServiceUpdateResultDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault($author$project$AuditPb$factorInvoiceServiceUpdateResultDefault),
		$author$project$AuditPb$factorInvoiceServiceUpdateResultFromString),
	$elm$json$Json$Decode$string);
var $author$project$AuditPb$factorInvoiceServiceUpdateSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$requiredWithoutDefault,
			'result',
			$author$project$AuditPb$factorInvoiceServiceUpdateResultDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceUpdateSuccess));
	});
var $author$project$AuditPb$factorInvoiceServiceUpdateResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServiceUpdateSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceUpdateResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServiceUpdateResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServiceUpdateResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServiceUpdateResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceUpdateResponse));
	});
var $author$project$AuditApi$factorInvoiceServiceManuallyAddressRuleFailureWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/manually_address_rule_failure', $author$project$AuditPb$factorInvoiceServiceManuallyAddressRuleFailureRequestEncoder, $author$project$AuditPb$factorInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$manuallyAddressRuleFailure = F3(
	function (model, ruleResultId, action) {
		return A3(
			$author$project$AuditApi$factorInvoiceServiceManuallyAddressRuleFailureWithState,
			model,
			$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessUpdateResponse,
			{action: action, factorInvoiceId: model.factorInvoiceId, ruleEvaluationId: ruleResultId});
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessMergeFromResponse = function (a) {
	return {$: 'ProcessMergeFromResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceMergeFromRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'otherInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.otherInvoiceId)
				])));
};
var $author$project$AuditPb$FactorInvoiceServiceMergeFromResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServiceMergeFromResponse_Outcome_FactorInvoiceServiceMergeFromSuccess = function (a) {
	return {$: 'FactorInvoiceServiceMergeFromResponse_Outcome_FactorInvoiceServiceMergeFromSuccess', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceMergeFromResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServiceMergeFromResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceMergeFromSuccess = {};
var $author$project$AuditPb$factorInvoiceServiceMergeFromSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceMergeFromSuccess);
	});
var $author$project$AuditPb$factorInvoiceServiceMergeFromResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceMergeFromResponse_Outcome_FactorInvoiceServiceMergeFromSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServiceMergeFromSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceMergeFromResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServiceMergeFromResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServiceMergeFromResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServiceMergeFromResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceMergeFromResponse));
	});
var $author$project$AuditApi$factorInvoiceServiceMergeFromWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/merge_from', $author$project$AuditPb$factorInvoiceServiceMergeFromRequestEncoder, $author$project$AuditPb$factorInvoiceServiceMergeFromResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$mergeFrom = F2(
	function (model, otherInvoiceId) {
		return A3(
			$author$project$AuditApi$factorInvoiceServiceMergeFromWithState,
			model,
			$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessMergeFromResponse,
			{factorInvoiceId: model.factorInvoiceId, otherInvoiceId: otherInvoiceId});
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$NotesDebounceMsg = function (a) {
	return {$: 'NotesDebounceMsg', a: a};
};
var $jinjor$elm_debounce$Debounce$Later = function (a) {
	return {$: 'Later', a: a};
};
var $jinjor$elm_debounce$Debounce$later = $jinjor$elm_debounce$Debounce$Later;
var $author$project$Components$FactorInvoiceAuditWorkingArea$notesDebounceConfig = {
	strategy: $jinjor$elm_debounce$Debounce$later(500),
	transform: $author$project$Components$FactorInvoiceAuditWorkingArea$NotesDebounceMsg
};
var $jinjor$elm_debounce$Debounce$Flush = function (a) {
	return {$: 'Flush', a: a};
};
var $jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom = function (a) {
	return {$: 'SendIfLengthNotChangedFrom', a: a};
};
var $jinjor$elm_debounce$Debounce$delayCmd = F2(
	function (delay, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(delay));
	});
var $jinjor$elm_debounce$Debounce$length = function (_v0) {
	var input = _v0.a.input;
	return $elm$core$List$length(input);
};
var $jinjor$elm_debounce$Debounce$push = F3(
	function (config, a, _v0) {
		var d = _v0.a;
		var newDebounce = $jinjor$elm_debounce$Debounce$Debounce(
			_Utils_update(
				d,
				{
					input: A2($elm$core$List$cons, a, d.input)
				}));
		var selfCmd = function () {
			var _v1 = config.strategy;
			switch (_v1.$) {
				case 'Manual':
					var offset = _v1.a;
					return d.locked ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Nothing));
				case 'Soon':
					var offset = _v1.a;
					var delay = _v1.b;
					return d.locked ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush(
							$elm$core$Maybe$Just(delay)));
				default:
					var delay = _v1.a;
					return A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						delay,
						$jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom(
							$jinjor$elm_debounce$Debounce$length(newDebounce)));
			}
		}();
		return _Utils_Tuple2(
			newDebounce,
			A2($elm$core$Platform$Cmd$map, config.transform, selfCmd));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessRejectResponse = function (a) {
	return {$: 'ProcessRejectResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceRejectRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId)
				])));
};
var $author$project$AuditPb$FactorInvoiceServiceRejectResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServiceRejectResponse_Outcome_FactorInvoiceServiceRejectSuccess = function (a) {
	return {$: 'FactorInvoiceServiceRejectResponse_Outcome_FactorInvoiceServiceRejectSuccess', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceRejectResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServiceRejectResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceRejectSuccess = {};
var $author$project$AuditPb$factorInvoiceServiceRejectSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceRejectSuccess);
	});
var $author$project$AuditPb$factorInvoiceServiceRejectResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceRejectResponse_Outcome_FactorInvoiceServiceRejectSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServiceRejectSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceRejectResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServiceRejectResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServiceRejectResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServiceRejectResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceRejectResponse));
	});
var $author$project$AuditApi$factorInvoiceServiceRejectWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/reject', $author$project$AuditPb$factorInvoiceServiceRejectRequestEncoder, $author$project$AuditPb$factorInvoiceServiceRejectResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$reject = function (model) {
	return A3(
		$author$project$AuditApi$factorInvoiceServiceRejectWithState,
		model,
		$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessRejectResponse,
		{factorInvoiceId: model.factorInvoiceId});
};
var $author$project$AuditPb$factorInvoiceServiceResolveExceptionEventRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'exceptionEventId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$ExceptionEventId$toInt),
					v.exceptionEventId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'resolutionMessage', $elm$json$Json$Encode$string, v.resolutionMessage)
				])));
};
var $author$project$AuditApi$factorInvoiceServiceResolveExceptionEventWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/resolve_exception_event', $author$project$AuditPb$factorInvoiceServiceResolveExceptionEventRequestEncoder, $author$project$AuditPb$factorInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$resolveExceptionEvent = F3(
	function (model, exceptionEventId, resolutionMessage) {
		return A3(
			$author$project$AuditApi$factorInvoiceServiceResolveExceptionEventWithState,
			model,
			$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessUpdateResponse,
			{exceptionEventId: exceptionEventId, factorInvoiceId: model.factorInvoiceId, resolutionMessage: resolutionMessage});
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$RevealCheckOutMsg = F2(
	function (a, b) {
		return {$: 'RevealCheckOutMsg', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$checkElementId = function (checkId) {
	return 'fi-audit-check-' + checkId;
};
var $author$project$Components$FactorInvoiceAuditChecks$quickReviewElementId = 'fi-audit-quick-review';
var $author$project$Components$FactorInvoiceAuditChecks$checkTypeToString = function (checkType) {
	var _v0 = checkType.check;
	switch (_v0.$) {
		case 'FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck':
			return 'invoice_amount';
		case 'FactorInvoiceAuditCheckType_Check_DocumentPresenceCheck':
			var doc = _v0.a;
			return $author$project$AuditPb$documentPresenceRequirementToString(doc.requirement);
		case 'FactorInvoiceAuditCheckType_Check_PODRequiredCheck':
			return 'pod_required';
		case 'FactorInvoiceAuditCheckType_Check_InvoiceDateCheck':
			return 'invoice_date';
		case 'FactorInvoiceAuditCheckType_Check_CarrierRequiredCheck':
			return 'carrier_required';
		case 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck':
			return 'debtor_required';
		case 'FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck':
			return 'load_id_extraction_and_confirmation';
		case 'FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck':
			return 'invoice_number';
		case 'FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck':
			return 'duplicate_invoice_check';
		case 'FactorInvoiceAuditCheckType_Check_RateConBolConsistencyCheck':
			return 'rate_con_bol_consistency';
		case 'FactorInvoiceAuditCheckType_Check_BrokerClientRequirementsCheck':
			return 'broker_client_carrier_amount';
		case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierCheck':
			return 'broker_client_brokered_carrier';
		case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierTermsCheck':
			return 'broker_client_brokered_carrier_terms';
		case 'FactorInvoiceAuditCheckType_Check_FactorLaneRateCheck':
			return 'factor_lane_rate';
		case 'FactorInvoiceAuditCheckType_Check_FundingInstructionsDetectedCheck':
			return 'funding_instructions_detected';
		case 'FactorInvoiceAuditCheckType_Check_ClientDebtorRelationshipCheck':
			return 'client_debtor_relationship';
		case 'FactorInvoiceAuditCheckType_Check_InvoiceDeliveryDateCheck':
			return 'invoice_delivery_date';
		default:
			return 'max_amount_review';
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$identifier = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		return $author$project$Components$FactorInvoiceAuditChecks$checkTypeToString(ruleCheck.checkType);
	} else {
		var event = _v0.a;
		return 'exception-event-' + $elm$core$String$fromInt(
			$author$project$Domain$ExceptionEventId$toInt(event.id));
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$firstActivelyFailing = function (failedChecks) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Components$FactorInvoiceAuditChecks$identifier,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultFailed) || _Utils_eq(c.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultPending);
				},
				failedChecks)));
};
var $author$project$Components$FactorInvoiceAuditChecks$groupByResult = function (checks) {
	var grouped = A3(
		$elm$core$List$foldl,
		F2(
			function (check, acc) {
				var _v0 = check.result;
				switch (_v0.$) {
					case 'FactorInvoiceAuditCheckResultPassed':
						return _Utils_update(
							acc,
							{
								passed: A2($elm$core$List$cons, check, acc.passed)
							});
					case 'FactorInvoiceAuditCheckResultSkipped':
						return _Utils_update(
							acc,
							{
								skipped: A2($elm$core$List$cons, check, acc.skipped)
							});
					case 'FactorInvoiceAuditCheckResultResolved':
						return _Utils_update(
							acc,
							{
								resolved: A2($elm$core$List$cons, check, acc.resolved)
							});
					case 'FactorInvoiceAuditCheckResultIgnored':
						return _Utils_update(
							acc,
							{
								ignored: A2($elm$core$List$cons, check, acc.ignored)
							});
					default:
						return _Utils_update(
							acc,
							{
								failed: A2($elm$core$List$cons, check, acc.failed)
							});
				}
			}),
		{failed: _List_Nil, ignored: _List_Nil, passed: _List_Nil, resolved: _List_Nil, skipped: _List_Nil},
		checks);
	return {
		failed: $elm$core$List$reverse(grouped.failed),
		ignored: $elm$core$List$reverse(grouped.ignored),
		passed: $elm$core$List$reverse(grouped.passed),
		resolved: $elm$core$List$reverse(grouped.resolved),
		skipped: $elm$core$List$reverse(grouped.skipped)
	};
};
var $author$project$Components$FactorInvoiceAuditChecks$revealCheck = F3(
	function (checks, checkId, model) {
		var openFrom = function (defaultExpanded) {
			var others = A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(checkId),
				model.expandedFailedChecks);
			return defaultExpanded ? _Utils_update(
				model,
				{expandedFailedChecks: others}) : _Utils_update(
				model,
				{
					expandedFailedChecks: A2($elm$core$List$cons, checkId, others)
				});
		};
		var isIn = $elm$core$List$any(
			function (check) {
				return _Utils_eq(
					$author$project$Components$FactorInvoiceAuditChecks$identifier(check),
					checkId);
			});
		var _v0 = $author$project$Components$FactorInvoiceAuditChecks$groupByResult(checks);
		var ignored = _v0.ignored;
		var resolved = _v0.resolved;
		var passed = _v0.passed;
		var failed = _v0.failed;
		return isIn(failed) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				openFrom(
					_Utils_eq(
						$author$project$Components$FactorInvoiceAuditChecks$firstActivelyFailing(failed),
						$elm$core$Maybe$Just(checkId))),
				$author$project$Components$AuditUnsavedEdits$SummaryTab)) : (isIn(
			_Utils_ap(
				passed,
				_Utils_ap(resolved, ignored))) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				openFrom(false),
				$author$project$Components$AuditUnsavedEdits$CompletedChecksTab)) : $elm$core$Maybe$Nothing);
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount = {$: 'InvoiceAmount'};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber = {$: 'InvoiceNumber'};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId = {$: 'LoadId'};
var $author$project$Components$FactorInvoiceAuditChecks$sameAmount = F2(
	function (saved, edited) {
		return $elm$core$String$isEmpty(
			$author$project$Domain$Amount$cleaned(edited)) || _Utils_eq(
			$elm$core$String$toFloat(
				$author$project$Domain$Amount$cleaned(saved)),
			$elm$core$String$toFloat(
				$author$project$Domain$Amount$cleaned(edited)));
	});
var $author$project$Components$FactorInvoiceAuditChecks$amountField = {display: $author$project$Components$AuditUnsavedEdits$showAmount, same: $author$project$Components$FactorInvoiceAuditChecks$sameAmount};
var $author$project$Components$FactorInvoiceAuditChecks$sameDate = F2(
	function (saved, edited) {
		return $elm$core$String$isEmpty(edited) || _Utils_eq(saved, edited);
	});
var $author$project$Components$FactorInvoiceAuditChecks$dateField = {display: $author$project$Components$AuditUnsavedEdits$showDate, same: $author$project$Components$FactorInvoiceAuditChecks$sameDate};
var $author$project$Components$AuditDrafts$edited = F2(
	function (key, drafts) {
		var _v0 = A2($author$project$Components$AuditDrafts$draftOf, key, drafts);
		if (_v0.$ === 'Edited') {
			var typed = _v0.a.typed;
			return $elm$core$Maybe$Just(typed);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$sameText = F2(
	function (a, b) {
		return _Utils_eq(
			$elm$core$String$trim(a),
			$elm$core$String$trim(b));
	});
var $author$project$Components$FactorInvoiceAuditChecks$textField = {display: $author$project$Components$AuditUnsavedEdits$showText, same: $author$project$Components$FactorInvoiceAuditChecks$sameText};
var $author$project$Components$FactorInvoiceAuditChecks$unsavedEdit = F5(
	function (kind, checkId, label, savedValue, editedValue) {
		var saved = A2($elm$core$Maybe$withDefault, '', savedValue);
		return A2(
			$elm$core$Maybe$andThen,
			function (edited) {
				return A2(kind.same, saved, edited) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{
						checkId: checkId,
						edited: kind.display(edited),
						label: label,
						saved: kind.display(saved)
					});
			},
			editedValue);
	});
var $author$project$Components$FactorInvoiceAuditChecks$unsavedEdits = F2(
	function (config, model) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A5(
					$author$project$Components$FactorInvoiceAuditChecks$unsavedEdit,
					$author$project$Components$FactorInvoiceAuditChecks$amountField,
					'invoice_amount',
					'Invoice Amount',
					config.formattedAmount,
					A2($author$project$Components$AuditDrafts$edited, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount, model.drafts)),
					A5(
					$author$project$Components$FactorInvoiceAuditChecks$unsavedEdit,
					$author$project$Components$FactorInvoiceAuditChecks$textField,
					'load_id_extraction_and_confirmation',
					'Load ID',
					config.loadId,
					A2($author$project$Components$AuditDrafts$edited, $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, model.drafts)),
					A5(
					$author$project$Components$FactorInvoiceAuditChecks$unsavedEdit,
					$author$project$Components$FactorInvoiceAuditChecks$textField,
					'invoice_number',
					'Invoice Number',
					config.invoiceNumber,
					A2($author$project$Components$AuditDrafts$edited, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, model.drafts)),
					A5(
					$author$project$Components$FactorInvoiceAuditChecks$unsavedEdit,
					$author$project$Components$FactorInvoiceAuditChecks$dateField,
					'invoice_date',
					'Invoice Date',
					A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, config.invoiceDate),
					model.invoiceDateInput),
					A5($author$project$Components$FactorInvoiceAuditChecks$unsavedEdit, $author$project$Components$FactorInvoiceAuditChecks$amountField, 'broker_client_carrier_amount', 'Brokered Carrier Amount', config.carrierAmount, model.brokerClientCarrierAmountInput)
				]));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$unsavedEdits = F2(
	function (remoteData, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Just') {
			var data = _v0.a;
			return A2($author$project$Components$FactorInvoiceAuditChecks$unsavedEdits, data.factorInvoice, model.auditChecks);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$reviewUnsavedEdit = F2(
	function (remoteData, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Forward$Remote$toMaybe(remoteData),
			$elm$core$List$head(
				A2($author$project$Components$FactorInvoiceAuditWorkingArea$unsavedEdits, remoteData, model)));
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var data = _v0.a.a;
			var edit = _v0.b.a;
			var _v1 = A3($author$project$Components$FactorInvoiceAuditChecks$revealCheck, data.auditChecks, edit.checkId, model.auditChecks);
			if (_v1.$ === 'Just') {
				var _v2 = _v1.a;
				var auditChecks = _v2.a;
				var tab = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{auditChecks: auditChecks}),
					$author$project$HubTran$Effect$none,
					A2(
						$author$project$Components$FactorInvoiceAuditWorkingArea$RevealCheckOutMsg,
						tab,
						$author$project$Components$FactorInvoiceAuditChecks$checkElementId(edit.checkId)));
			} else {
				return _Utils_Tuple3(
					model,
					$author$project$HubTran$Effect$none,
					A2($author$project$Components$FactorInvoiceAuditWorkingArea$RevealCheckOutMsg, $author$project$Components$AuditUnsavedEdits$SummaryTab, $author$project$Components$FactorInvoiceAuditChecks$quickReviewElementId));
			}
		} else {
			return _Utils_Tuple3(model, $author$project$HubTran$Effect$none, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessReviveResponse = function (a) {
	return {$: 'ProcessReviveResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceReviveRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId)
				])));
};
var $author$project$AuditPb$FactorInvoiceServiceReviveResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServiceReviveResponse_Outcome_FactorInvoiceServiceReviveSuccess = function (a) {
	return {$: 'FactorInvoiceServiceReviveResponse_Outcome_FactorInvoiceServiceReviveSuccess', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceReviveResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServiceReviveResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceReviveSuccess = {};
var $author$project$AuditPb$factorInvoiceServiceReviveSuccessDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceReviveSuccess);
	});
var $author$project$AuditPb$factorInvoiceServiceReviveResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceReviveResponse_Outcome_FactorInvoiceServiceReviveSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServiceReviveSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceReviveResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServiceReviveResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServiceReviveResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServiceReviveResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceReviveResponse));
	});
var $author$project$AuditApi$factorInvoiceServiceReviveWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/revive', $author$project$AuditPb$factorInvoiceServiceReviveRequestEncoder, $author$project$AuditPb$factorInvoiceServiceReviveResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$revive = function (model) {
	return A3(
		$author$project$AuditApi$factorInvoiceServiceReviveWithState,
		model,
		$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessReviveResponse,
		{factorInvoiceId: model.factorInvoiceId});
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessMarkAsProcessedResponse = function (a) {
	return {$: 'ProcessMarkAsProcessedResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceMarkAsProcessedRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3($author$project$AuditPb$optionalEncoder, 'debtorLoadIdAutofill', $elm$json$Json$Encode$bool, v.debtorLoadIdAutofill)
				])));
};
var $author$project$AuditApi$factorInvoiceServiceMarkAsProcessedWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/mark_as_processed', $author$project$AuditPb$factorInvoiceServiceMarkAsProcessedRequestEncoder, $author$project$AuditPb$factorInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$FactorInvoiceAuditChecks$pendingDebtorLoadIdAutofill = function (model) {
	return model.debtorAutofillInput;
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$save = function (model) {
	return A3(
		$author$project$AuditApi$factorInvoiceServiceMarkAsProcessedWithState,
		model,
		$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessMarkAsProcessedResponse,
		{
			debtorLoadIdAutofill: $author$project$Components$FactorInvoiceAuditChecks$pendingDebtorLoadIdAutofill(model.auditChecks),
			factorInvoiceId: model.factorInvoiceId
		});
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessSaveAndApproveResponse = function (a) {
	return {$: 'ProcessSaveAndApproveResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceSaveAndApproveRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'documentBatchId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentBatchId$toInt),
					v.documentBatchId),
					A3($author$project$AuditPb$optionalEncoder, 'debtorLoadIdAutofill', $elm$json$Json$Encode$bool, v.debtorLoadIdAutofill)
				])));
};
var $author$project$AuditApi$factorInvoiceServiceSaveAndApproveWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/save_and_approve', $author$project$AuditPb$factorInvoiceServiceSaveAndApproveRequestEncoder, $author$project$AuditPb$factorInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$saveAndApprove = function (model) {
	return A3(
		$author$project$AuditApi$factorInvoiceServiceSaveAndApproveWithState,
		model,
		$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessSaveAndApproveResponse,
		{
			debtorLoadIdAutofill: $author$project$Components$FactorInvoiceAuditChecks$pendingDebtorLoadIdAutofill(model.auditChecks),
			documentBatchId: model.documentBatchId,
			factorInvoiceId: model.factorInvoiceId
		});
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessSaveAsIncompleteResponse = function (a) {
	return {$: 'ProcessSaveAsIncompleteResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceSaveWithErrorsRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'emailId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$EmailMessageId$toInt),
					v.emailId),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'pendingCheckIds', $elm$json$Json$Encode$string, v.pendingCheckIds)
				])));
};
var $author$project$AuditPb$FactorInvoiceServiceSaveWithErrorsResponse = function (outcome) {
	return {outcome: outcome};
};
var $author$project$AuditPb$FactorInvoiceServiceSaveWithErrorsResponse_Outcome_FactorInvoiceServiceUpdateError = function (a) {
	return {$: 'FactorInvoiceServiceSaveWithErrorsResponse_Outcome_FactorInvoiceServiceUpdateError', a: a};
};
var $author$project$AuditPb$FactorInvoiceServiceSaveWithErrorsResponse_Outcome_FactorInvoiceServiceUpdateSuccess = function (a) {
	return {$: 'FactorInvoiceServiceSaveWithErrorsResponse_Outcome_FactorInvoiceServiceUpdateSuccess', a: a};
};
var $author$project$AuditPb$factorInvoiceServiceSaveWithErrorsResponse_OutcomeDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceSaveWithErrorsResponse_Outcome_FactorInvoiceServiceUpdateSuccess,
					A2($elm$json$Json$Decode$field, 'success', $author$project$AuditPb$factorInvoiceServiceUpdateSuccessDecoder)),
					A2(
					$elm$json$Json$Decode$map,
					$author$project$AuditPb$FactorInvoiceServiceSaveWithErrorsResponse_Outcome_FactorInvoiceServiceUpdateError,
					A2($elm$json$Json$Decode$field, 'error', $author$project$AuditPb$factorInvoiceServiceUpdateErrorDecoder)),
					$elm$json$Json$Decode$fail('FactorInvoiceServiceSaveWithErrorsResponse_Outcome_Unspecified')
				]));
	});
var $author$project$AuditPb$factorInvoiceServiceSaveWithErrorsResponseDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A2(
			$author$project$AuditPb$field,
			$author$project$AuditPb$factorInvoiceServiceSaveWithErrorsResponse_OutcomeDecoder,
			$author$project$AuditPb$decode($author$project$AuditPb$FactorInvoiceServiceSaveWithErrorsResponse));
	});
var $author$project$AuditApi$factorInvoiceServiceSaveWithErrorsWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/save_with_errors', $author$project$AuditPb$factorInvoiceServiceSaveWithErrorsRequestEncoder, $author$project$AuditPb$factorInvoiceServiceSaveWithErrorsResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$saveAsIncomplete = function (model) {
	return A3(
		$author$project$AuditApi$factorInvoiceServiceSaveWithErrorsWithState,
		model,
		$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessSaveAsIncompleteResponse,
		{emailId: model.emailId, factorInvoiceId: model.factorInvoiceId, pendingCheckIds: _List_Nil});
};
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateMustVerify = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateMustVerify', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessMustVerifySaveResponse = function (a) {
	return {$: 'ProcessMustVerifySaveResponse', a: a};
};
var $author$project$AuditPb$factorInvoiceFieldUpdateAmountEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'amount', $elm$json$Json$Encode$string, v.amount)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateBrokeredCarrierEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'brokeredCarrierId', $elm$json$Json$Encode$int, v.brokeredCarrierId)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateBrokeredCarrierTermEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'brokeredCarrierTermId', $elm$json$Json$Encode$int, v.brokeredCarrierTermId)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateCarrierAmountEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'amount', $elm$json$Json$Encode$string, v.amount)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateCarrierEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'carrierId', $elm$json$Json$Encode$int, v.carrierId)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateDebtorEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'factorBrokerId', $elm$json$Json$Encode$int, v.factorBrokerId)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateDebtorLoadIdAutofillEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'enabled', $elm$json$Json$Encode$bool, v.enabled)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateDocumentTypeEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'documentId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentId$toInt),
					v.documentId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'documentType', $author$project$AuditPb$documentTypeEncoder, v.documentType)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateInvoiceDateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'invoiceDate', $elm$json$Json$Encode$string, v.invoiceDate)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateInvoiceNumberEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'invoiceNumber', $elm$json$Json$Encode$string, v.invoiceNumber)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateIsTonuEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'isTonu', $elm$json$Json$Encode$bool, v.isTonu)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateLoadIdEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'loadId', $elm$json$Json$Encode$string, v.loadId)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateMustVerifyEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'mustVerify', $elm$json$Json$Encode$bool, v.mustVerify)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdateNotesEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'notes', $elm$json$Json$Encode$string, v.notes)
				])));
};
var $author$project$AuditPb$factorInvoiceFieldUpdate_UpdateEncoder = function (v) {
	switch (v.$) {
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateAmount':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'amount_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateAmountEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateInvoiceDate':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'invoice_date_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateInvoiceDateEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateCarrier':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'carrier_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateCarrierEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateDebtor':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'debtor_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateDebtorEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateLoadId':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'load_id_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateLoadIdEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateInvoiceNumber':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'invoice_number_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateInvoiceNumberEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateCarrierAmount':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'carrier_amount_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateCarrierAmountEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateBrokeredCarrier':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'brokered_carrier_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateBrokeredCarrierEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateBrokeredCarrierTerm':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'brokered_carrier_term_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateBrokeredCarrierTermEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateNotes':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'notes_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateNotesEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateMustVerify':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'must_verify_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateMustVerifyEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateIsTonu':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'is_tonu',
					$author$project$AuditPb$factorInvoiceFieldUpdateIsTonuEncoder(x)));
		case 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateDocumentType':
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'document_type_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateDocumentTypeEncoder(x)));
		default:
			var x = v.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'debtor_load_id_autofill_update',
					$author$project$AuditPb$factorInvoiceFieldUpdateDebtorLoadIdAutofillEncoder(x)));
	}
};
var $author$project$AuditPb$factorInvoiceFieldUpdateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$AuditPb$factorInvoiceFieldUpdate_UpdateEncoder(v.update)
				])));
};
var $author$project$AuditPb$factorInvoiceUpdateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$repeatedFieldEncoder, 'updates', $author$project$AuditPb$factorInvoiceFieldUpdateEncoder, v.updates),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'ignoreRuleEvaluationId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$RuleEvaluationId$toInt),
					v.ignoreRuleEvaluationId)
				])));
};
var $author$project$AuditPb$factorInvoiceServiceUpdateRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'factorInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$FactorInvoiceId$toInt),
					v.factorInvoiceId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'factorInvoiceUpdate', $author$project$AuditPb$factorInvoiceUpdateEncoder, v.factorInvoiceUpdate)
				])));
};
var $author$project$AuditApi$factorInvoiceServiceUpdateWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/update', $author$project$AuditPb$factorInvoiceServiceUpdateRequestEncoder, $author$project$AuditPb$factorInvoiceServiceUpdateResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdateTo = F4(
	function (toMsg, model, ignoreRuleEvaluationId, updates) {
		return A3(
			$author$project$AuditApi$factorInvoiceServiceUpdateWithState,
			model,
			toMsg,
			{
				factorInvoiceId: model.factorInvoiceId,
				factorInvoiceUpdate: {ignoreRuleEvaluationId: ignoreRuleEvaluationId, updates: updates}
			});
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$saveMustVerify = F2(
	function (model, checked) {
		return A4(
			$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdateTo,
			$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessMustVerifySaveResponse,
			model,
			$elm$core$Maybe$Nothing,
			_List_fromArray(
				[
					{
					update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateMustVerify(
						{mustVerify: checked})
				}
				]));
	});
var $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateNotes = function (a) {
	return {$: 'FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateNotes', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessNotesSaveResponse = function (a) {
	return {$: 'ProcessNotesSaveResponse', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$saveNotes = F2(
	function (model, notes) {
		return A4(
			$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdateTo,
			$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessNotesSaveResponse,
			model,
			$elm$core$Maybe$Nothing,
			_List_fromArray(
				[
					{
					update: $author$project$AuditPb$FactorInvoiceFieldUpdate_Update_FactorInvoiceFieldUpdateNotes(
						{notes: notes})
				}
				]));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$SaveNotes = function (a) {
	return {$: 'SaveNotes', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$saveNotesCmd = function (notes) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$FactorInvoiceAuditWorkingArea$SaveNotes,
		$elm$core$Task$succeed(notes));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$updateField = function (fieldUpdate) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$first,
		$author$project$AuditPb$factorInvoiceFieldUpdate_UpdateEncoder(fieldUpdate.update));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$queueUpdates = F2(
	function (settled, waiting) {
		var settledFields = A2($elm$core$List$map, $author$project$Components$FactorInvoiceAuditWorkingArea$updateField, settled);
		return _Utils_ap(
			A2(
				$elm$core$List$filter,
				function (waitingUpdate) {
					return !A2(
						$elm$core$List$member,
						$author$project$Components$FactorInvoiceAuditWorkingArea$updateField(waitingUpdate),
						settledFields);
				},
				waiting),
			settled);
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate = $author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdateTo($author$project$Components$FactorInvoiceAuditWorkingArea$ProcessUpdateResponse);
var $author$project$Components$FactorInvoiceAuditWorkingArea$saveSettledFields = F2(
	function (model, updates) {
		return $author$project$PostRequestState$isInProgress(model.requestState) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					queuedUpdates: A2($author$project$Components$FactorInvoiceAuditWorkingArea$queueUpdates, updates, model.queuedUpdates)
				}),
			$author$project$HubTran$Effect$none) : A3(
			$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
			_Utils_update(
				model,
				{queuedUpdates: _List_Nil}),
			$elm$core$Maybe$Nothing,
			updates);
	});
var $author$project$Components$PaginatedDropdown$search = F2(
	function (term, paginatedDropdown) {
		var _v0 = A2(
			$author$project$Ui$V3$CustomSelect$update,
			$author$project$Ui$V3$CustomSelect$ChangeInputValue(term),
			paginatedDropdown.dropdown);
		var filled = _v0.a;
		var fillCmd = _v0.b;
		var _v1 = A2(
			$author$project$Ui$V3$CustomSelect$update,
			$author$project$Ui$V3$CustomSelect$ClickIn(
				{isCaret: false}),
			filled);
		var opened = _v1.a;
		var openCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				paginatedDropdown,
				{dropdown: opened}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[fillCmd, openCmd])));
	});
var $author$project$Components$DebtorDropdown$search = F2(
	function (term, model) {
		var _v0 = A2($author$project$Components$PaginatedDropdown$search, term, model.dropdown);
		var dropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: dropdown}),
			cmd);
	});
var $author$project$Components$PaginatedDropdown$select = F2(
	function (items, paginatedDropdown) {
		return _Utils_update(
			paginatedDropdown,
			{
				dropdown: A2($author$project$Ui$V3$CustomSelect$setSelectedItems, items, paginatedDropdown.dropdown)
			});
	});
var $author$project$Components$DebtorDropdown$selectById = F2(
	function (_v0, model) {
		var name = _v0.name;
		var id = _v0.id;
		return _Utils_update(
			model,
			{
				dropdown: A2(
					$author$project$Components$PaginatedDropdown$select,
					_List_fromArray(
						[
							{
							id: id,
							label: $elm$html$Html$text(name),
							text: name
						}
						]),
					model.dropdown)
			});
	});
var $author$project$Components$BrokeredCarrierDropdown$selectedIds = function (model) {
	return A2(
		$elm$core$List$map,
		$author$project$Domain$BrokeredCarrierId$fromInt,
		A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown))));
};
var $author$project$Components$BrokeredCarrierTermDropdown$selectedIds = function (model) {
	return A2(
		$elm$core$List$map,
		$author$project$Domain$BrokeredCarrierTermId$fromInt,
		A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown))));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessSaveWithErrorsResponse = function (a) {
	return {$: 'ProcessSaveWithErrorsResponse', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$sendBackToCarrier = F2(
	function (remoteData, model) {
		var pendingCheckIds = function () {
			var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
			if (_v0.$ === 'Just') {
				var data = _v0.a;
				return A2(
					$elm$core$List$map,
					$author$project$Components$FactorInvoiceAuditChecks$identifier,
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(c.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultFailed) || _Utils_eq(c.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultPending);
						},
						data.auditChecks));
			} else {
				return _List_Nil;
			}
		}();
		return A3(
			$author$project$AuditApi$factorInvoiceServiceSaveWithErrorsWithState,
			model,
			$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessSaveWithErrorsResponse,
			{emailId: model.emailId, factorInvoiceId: model.factorInvoiceId, pendingCheckIds: pendingCheckIds});
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$sendQueuedUpdates = function (_v0) {
	var model = _v0.a;
	var effect = _v0.b;
	if ($elm$core$List$isEmpty(model.queuedUpdates)) {
		return _Utils_Tuple2(model, effect);
	} else {
		var _v1 = A2($author$project$Components$FactorInvoiceAuditWorkingArea$saveSettledFields, model, model.queuedUpdates);
		var sentModel = _v1.a;
		var sendEffect = _v1.b;
		return _Utils_Tuple2(
			sentModel,
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[effect, sendEffect])));
	}
};
var $jinjor$elm_debounce$Debounce$takeLast = F3(
	function (send, head, tail) {
		return _Utils_Tuple2(
			_List_Nil,
			send(head));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$ProcessUnapproveResponse = function (a) {
	return {$: 'ProcessUnapproveResponse', a: a};
};
var $author$project$AuditApi$factorInvoiceServiceUnapproveWithState = A3($author$project$AuditApi$toRequestState, '/factor_invoice_service/unapprove', $author$project$AuditPb$factorInvoiceServiceUnapproveRequestEncoder, $author$project$AuditPb$factorInvoiceServiceUnapproveResponseDecoder);
var $author$project$Components$FactorInvoiceAuditWorkingArea$unapprove = function (model) {
	return A3(
		$author$project$AuditApi$factorInvoiceServiceUnapproveWithState,
		model,
		$author$project$Components$FactorInvoiceAuditWorkingArea$ProcessUnapproveResponse,
		{factorInvoiceId: model.factorInvoiceId});
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$MergeRequested = function (a) {
	return {$: 'MergeRequested', a: a};
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$update = F2(
	function (msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'CollapseToggled':
				return _Utils_Tuple2(
					$author$project$Components$FactorInvoiceAudit$PossibleMatches$Model(
						_Utils_update(
							model,
							{isCollapsed: !model.isCollapsed})),
					$author$project$Components$FactorInvoiceAudit$PossibleMatches$NoOutMsg);
			case 'MatchSelected':
				var invoiceId = msg.a;
				return _Utils_Tuple2(
					$author$project$Components$FactorInvoiceAudit$PossibleMatches$Model(
						_Utils_update(
							model,
							{
								selectedMatch: $elm$core$Maybe$Just(invoiceId)
							})),
					$author$project$Components$FactorInvoiceAudit$PossibleMatches$NoOutMsg);
			default:
				var _v2 = model.selectedMatch;
				if (_v2.$ === 'Just') {
					var invoiceId = _v2.a;
					return _Utils_Tuple2(
						$author$project$Components$FactorInvoiceAudit$PossibleMatches$Model(model),
						$author$project$Components$FactorInvoiceAudit$PossibleMatches$MergeRequested(invoiceId));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$FactorInvoiceAudit$PossibleMatches$Model(model),
						$author$project$Components$FactorInvoiceAudit$PossibleMatches$NoOutMsg);
				}
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$BrokeredCarrierDropdownMsg = function (a) {
	return {$: 'BrokeredCarrierDropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$BrokeredCarrierTermDropdownMsg = function (a) {
	return {$: 'BrokeredCarrierTermDropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$CarrierDropdownMsg = function (a) {
	return {$: 'CarrierDropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$CompareDuplicate = function (a) {
	return {$: 'CompareDuplicate', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$CreateException = function (a) {
	return {$: 'CreateException', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$DebtorDropdownMsg = function (a) {
	return {$: 'DebtorDropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$DebtorDropdownMsgWithAutoSave = function (a) {
	return {$: 'DebtorDropdownMsgWithAutoSave', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FindValueInDocuments = function (a) {
	return {$: 'FindValueInDocuments', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$HighlightLocation = function (a) {
	return {$: 'HighlightLocation', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$InputDrop = function (a) {
	return {$: 'InputDrop', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$NoOp = {$: 'NoOp'};
var $author$project$Components$FactorInvoiceAuditChecks$ResolveExceptionEvent = F2(
	function (a, b) {
		return {$: 'ResolveExceptionEvent', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$SaveAmount = function (a) {
	return {$: 'SaveAmount', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$SaveAmountAndConfirm = F2(
	function (a, b) {
		return {$: 'SaveAmountAndConfirm', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$SaveBrokeredCarrierClicked = {$: 'SaveBrokeredCarrierClicked'};
var $author$project$Components$FactorInvoiceAuditChecks$SaveBrokeredCarrierTermClicked = {$: 'SaveBrokeredCarrierTermClicked'};
var $author$project$Components$FactorInvoiceAuditChecks$SaveCarrierAmount = function (a) {
	return {$: 'SaveCarrierAmount', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$SaveCarrierClicked = {$: 'SaveCarrierClicked'};
var $author$project$Components$FactorInvoiceAuditChecks$SaveDate = function (a) {
	return {$: 'SaveDate', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$SaveDateAndConfirm = F2(
	function (a, b) {
		return {$: 'SaveDateAndConfirm', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$SaveDebtorAndConfirm = function (a) {
	return {$: 'SaveDebtorAndConfirm', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$SaveDebtorClicked = {$: 'SaveDebtorClicked'};
var $author$project$Components$FactorInvoiceAuditChecks$SaveInvoiceNumber = function (a) {
	return {$: 'SaveInvoiceNumber', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$SaveInvoiceNumberAndConfirm = F2(
	function (a, b) {
		return {$: 'SaveInvoiceNumberAndConfirm', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$SaveLoadId = F2(
	function (a, b) {
		return {$: 'SaveLoadId', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$SaveLoadIdAndConfirm = F3(
	function (a, b, c) {
		return {$: 'SaveLoadIdAndConfirm', a: a, b: b, c: c};
	});
var $author$project$Components$FactorInvoiceAuditChecks$SelectDebtorSuggestion = function (a) {
	return {$: 'SelectDebtorSuggestion', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$UnignoreRule = function (a) {
	return {$: 'UnignoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$cleanForSave = F2(
	function (field, value) {
		switch (field.$) {
			case 'LoadId':
				return value;
			case 'InvoiceNumber':
				return value;
			default:
				return $author$project$Domain$Amount$cleaned(value);
		}
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$fromDropField = function (dropField) {
	switch (dropField.$) {
		case 'LoadIdField':
			return $elm$core$Maybe$Just($author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId);
		case 'InvoiceNumberField':
			return $elm$core$Maybe$Just($author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber);
		case 'InvoiceAmountField':
			return $elm$core$Maybe$Just($author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount);
		case 'InvoiceDateField':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$SelectDocumentPage = function (a) {
	return {$: 'SelectDocumentPage', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$SetDocumentType = F2(
	function (a, b) {
		return {$: 'SetDocumentType', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$SetIsTonu = function (a) {
	return {$: 'SetIsTonu', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$mapCommonAction = function (action) {
	switch (action.$) {
		case 'IgnoreRule':
			var ruleResultId = action.a;
			return $author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId);
		case 'SelectDocumentPage':
			var pageId = action.a;
			return $author$project$Components$FactorInvoiceAuditChecks$SelectDocumentPage(pageId);
		case 'SetIsTonu':
			var isTonu = action.a;
			return $author$project$Components$FactorInvoiceAuditChecks$SetIsTonu(isTonu);
		default:
			var documentId = action.a;
			var documentType = action.b;
			return A2($author$project$Components$FactorInvoiceAuditChecks$SetDocumentType, documentId, documentType);
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$markSent = F3(
	function (field, value, model) {
		return _Utils_update(
			model,
			{
				drafts: A3($author$project$Components$AuditDrafts$markSent, field, value, model.drafts)
			});
	});
var $author$project$Components$FactorInvoiceAuditChecks$resolutionInputFor = F2(
	function (exceptionEventId, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Dict$get,
				$author$project$Domain$ExceptionEventId$toInt(exceptionEventId),
				model.exceptionEventInputs));
	});
var $author$project$Components$FactorInvoiceAuditChecks$revertDraft = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				drafts: A2($author$project$Components$AuditDrafts$revert, field, model.drafts)
			});
	});
var $author$project$Components$FactorInvoiceAuditChecks$saveQuickReviewField = F2(
	function (field, value) {
		switch (field.$) {
			case 'LoadId':
				return A2($author$project$Components$FactorInvoiceAuditChecks$SaveLoadId, value, $elm$core$Maybe$Nothing);
			case 'InvoiceNumber':
				return $author$project$Components$FactorInvoiceAuditChecks$SaveInvoiceNumber(value);
			default:
				return $author$project$Components$FactorInvoiceAuditChecks$SaveAmount(value);
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$storedValue = F2(
	function (field, invoice) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			function () {
				switch (field.$) {
					case 'LoadId':
						return invoice.loadId;
					case 'InvoiceNumber':
						return invoice.invoiceNumber;
					default:
						return invoice.amount;
				}
			}());
	});
var $author$project$Components$FactorInvoiceAuditChecks$saveSettledQuickReviewField = F4(
	function (factorInvoice, field, value, model) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (invoice) {
				return A3(
					$author$project$Components$AuditDrafts$worthSending,
					field,
					{
						stored: A2($author$project$Components$FactorInvoiceAuditChecks$storedValue, field, invoice),
						typed: value
					},
					model.drafts);
			},
			factorInvoice);
		if (_v0.$ === 'Just') {
			var settled = _v0.a;
			return _Utils_Tuple2(
				A3($author$project$Components$FactorInvoiceAuditChecks$markSent, field, settled, model),
				A2($author$project$Components$FactorInvoiceAuditChecks$saveQuickReviewField, field, settled));
		} else {
			return _Utils_Tuple2(model, $author$project$Components$FactorInvoiceAuditChecks$NoOp);
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$stageDraft = F3(
	function (field, value, model) {
		return _Utils_update(
			model,
			{
				drafts: A3($author$project$Components$AuditDrafts$stage, field, value, model.drafts)
			});
	});
var $author$project$Components$FactorInvoiceAuditChecks$setInputValue = F3(
	function (field, value, model) {
		switch (field.$) {
			case 'InvoiceAmountField':
				return A3(
					$author$project$Components$FactorInvoiceAuditChecks$stageDraft,
					$author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount,
					$author$project$Domain$Amount$cleaned(value),
					model);
			case 'InvoiceDateField':
				return _Utils_update(
					model,
					{
						invoiceDateInput: $elm$core$Maybe$Just(value)
					});
			case 'LoadIdField':
				return A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, value, model);
			case 'InvoiceNumberField':
				return A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, value, model);
			default:
				return model;
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$toggleFailedCheck = F2(
	function (name, model) {
		return A2($elm$core$List$member, name, model.expandedFailedChecks) ? _Utils_update(
			model,
			{
				expandedFailedChecks: A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(name),
					model.expandedFailedChecks)
			}) : _Utils_update(
			model,
			{
				expandedFailedChecks: A2($elm$core$List$cons, name, model.expandedFailedChecks)
			});
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$DropdownChanged = function (a) {
	return {$: 'DropdownChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$SaveClickedOut = {$: 'SaveClickedOut'};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$update = function (msg) {
	switch (msg.$) {
		case 'DropdownMsg':
			var dropdownMsg = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$DropdownChanged(dropdownMsg);
		case 'SaveClicked':
			return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$SaveClickedOut;
		default:
			var ruleResultId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$IgnoreRule(ruleResultId);
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$DropdownChanged = function (a) {
	return {$: 'DropdownChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$SaveClickedOut = {$: 'SaveClickedOut'};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$update = function (msg) {
	switch (msg.$) {
		case 'DropdownMsg':
			var dropdownMsg = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$DropdownChanged(dropdownMsg);
		case 'SaveClicked':
			return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$SaveClickedOut;
		default:
			var ruleResultId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$IgnoreRule(ruleResultId);
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$FindValue = function (a) {
	return {$: 'FindValue', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$NoOp = {$: 'NoOp'};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$SaveAmount = function (a) {
	return {$: 'SaveAmount', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'AmountInputChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							amountInput: $elm$core$Maybe$Just(value)
						}),
					$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$NoOp);
			case 'SaveClicked':
				var value = msg.a;
				var cleaned = $author$project$Domain$Amount$cleaned(value);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							amountInput: $elm$core$Maybe$Just(cleaned)
						}),
					$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$SaveAmount(cleaned));
			case 'FindValueClicked':
				var value = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$FindValue(value));
			case 'IgnoreClicked':
				var ruleResultId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$IgnoreRule(ruleResultId));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{amountInput: $elm$core$Maybe$Nothing}),
					$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$NoOp);
		}
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$DropdownChanged = function (a) {
	return {$: 'DropdownChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$SaveClickedOut = {$: 'SaveClickedOut'};
var $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$update = function (msg) {
	if (msg.$ === 'DropdownMsg') {
		var dropdownMsg = msg.a;
		return $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$DropdownChanged(dropdownMsg);
	} else {
		return $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$SaveClickedOut;
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$DropdownChanged = function (a) {
	return {$: 'DropdownChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$FindValue = function (a) {
	return {$: 'FindValue', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$HighlightLocation = function (a) {
	return {$: 'HighlightLocation', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SaveAndConfirmDebtor = function (a) {
	return {$: 'SaveAndConfirmDebtor', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SaveClickedOut = {$: 'SaveClickedOut'};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SuggestionSelected = function (a) {
	return {$: 'SuggestionSelected', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$update = function (msg) {
	switch (msg.$) {
		case 'DropdownMsg':
			var dropdownMsg = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$DropdownChanged(dropdownMsg);
		case 'SaveClicked':
			return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SaveClickedOut;
		case 'SaveAndConfirmClicked':
			var ruleEvaluationId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SaveAndConfirmDebtor(ruleEvaluationId);
		case 'IgnoreClicked':
			var ruleResultId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$IgnoreRule(ruleResultId);
		case 'SuggestionClicked':
			var suggestion = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SuggestionSelected(suggestion);
		default:
			var value = msg.a.value;
			var location = msg.a.location;
			if (location.$ === 'Just') {
				return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$HighlightLocation(location);
			} else {
				return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$FindValue(value);
			}
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$Common = function (a) {
	return {$: 'Common', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$CompareDocuments = function (a) {
	return {$: 'CompareDocuments', a: a};
};
var $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$update = function (msg) {
	if (msg.$ === 'IgnoreClicked') {
		var ruleResultId = msg.a;
		return $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$Common(
			$author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId));
	} else {
		var invoiceId = msg.a;
		return $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$CompareDocuments(invoiceId);
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$FindValue = function (a) {
	return {$: 'FindValue', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$HighlightLocation = function (a) {
	return {$: 'HighlightLocation', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$InputChanged = function (a) {
	return {$: 'InputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$Reverted = {$: 'Reverted'};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SaveAmount = function (a) {
	return {$: 'SaveAmount', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SaveAndConfirmRule = F2(
	function (a, b) {
		return {$: 'SaveAndConfirmRule', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SuggestionConfirmed = function (a) {
	return {$: 'SuggestionConfirmed', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$update = function (msg) {
	switch (msg.$) {
		case 'AmountInputChanged':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$InputChanged(value);
		case 'SaveClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SaveAmount(
				$author$project$Domain$Amount$cleaned(value));
		case 'SaveAndConfirmClicked':
			var value = msg.a;
			var ruleEvaluationId = msg.b;
			return A2(
				$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SaveAndConfirmRule,
				$author$project$Domain$Amount$cleaned(value),
				ruleEvaluationId);
		case 'IgnoreClicked':
			var ruleResultId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$IgnoreRule(ruleResultId);
		case 'SuggestionClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SuggestionConfirmed(value);
		case 'SuggestionFindClicked':
			var value = msg.a.value;
			var location = msg.a.location;
			if (location.$ === 'Just') {
				return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$HighlightLocation(location);
			} else {
				return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$FindValue(value);
			}
		case 'FindValueClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$FindValue(value);
		default:
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$Reverted;
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$InputChanged = function (a) {
	return {$: 'InputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$Reverted = {$: 'Reverted'};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$SaveAndConfirmRule = F2(
	function (a, b) {
		return {$: 'SaveAndConfirmRule', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$SaveDate = function (a) {
	return {$: 'SaveDate', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$update = function (msg) {
	switch (msg.$) {
		case 'DateInputChanged':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$InputChanged(value);
		case 'SaveClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$SaveDate(value);
		case 'SaveAndConfirmClicked':
			var value = msg.a;
			var ruleEvaluationId = msg.b;
			return A2($author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$SaveAndConfirmRule, value, ruleEvaluationId);
		case 'IgnoreClicked':
			var ruleResultId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$IgnoreRule(ruleResultId);
		default:
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$Reverted;
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$FindValue = function (a) {
	return {$: 'FindValue', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$HighlightLocation = function (a) {
	return {$: 'HighlightLocation', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$InputChanged = function (a) {
	return {$: 'InputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$Reverted = {$: 'Reverted'};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SaveAndConfirmRule = F2(
	function (a, b) {
		return {$: 'SaveAndConfirmRule', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SaveInvoiceNumber = function (a) {
	return {$: 'SaveInvoiceNumber', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SuggestionConfirmed = function (a) {
	return {$: 'SuggestionConfirmed', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$update = function (msg) {
	switch (msg.$) {
		case 'InvoiceNumberInputChanged':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$InputChanged(value);
		case 'SaveClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SaveInvoiceNumber(value);
		case 'SaveAndConfirmClicked':
			var value = msg.a;
			var ruleEvaluationId = msg.b;
			return A2($author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SaveAndConfirmRule, value, ruleEvaluationId);
		case 'IgnoreClicked':
			var ruleResultId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$IgnoreRule(ruleResultId);
		case 'SuggestionClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SuggestionConfirmed(value);
		case 'SuggestionFindClicked':
			var value = msg.a.value;
			var location = msg.a.location;
			if (location.$ === 'Just') {
				return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$HighlightLocation(location);
			} else {
				return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$FindValue(value);
			}
		case 'FindValueClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$FindValue(value);
		default:
			return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$Reverted;
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$DebtorAutofillChanged = function (a) {
	return {$: 'DebtorAutofillChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$FindValue = function (a) {
	return {$: 'FindValue', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$HighlightLocation = function (a) {
	return {$: 'HighlightLocation', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$IgnoreRule = function (a) {
	return {$: 'IgnoreRule', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$InputChanged = function (a) {
	return {$: 'InputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$Reverted = {$: 'Reverted'};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SaveAndConfirmRule = F2(
	function (a, b) {
		return {$: 'SaveAndConfirmRule', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SaveLoadId = function (a) {
	return {$: 'SaveLoadId', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SuggestionConfirmed = function (a) {
	return {$: 'SuggestionConfirmed', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$update = function (msg) {
	switch (msg.$) {
		case 'LoadIdInputChanged':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$InputChanged(value);
		case 'SaveClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SaveLoadId(value);
		case 'SaveAndConfirmClicked':
			var value = msg.a;
			var ruleEvaluationId = msg.b;
			return A2($author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SaveAndConfirmRule, value, ruleEvaluationId);
		case 'IgnoreClicked':
			var ruleResultId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$IgnoreRule(ruleResultId);
		case 'SuggestionClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SuggestionConfirmed(value);
		case 'SuggestionFindClicked':
			var value = msg.a.value;
			var location = msg.a.location;
			if (location.$ === 'Just') {
				return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$HighlightLocation(location);
			} else {
				return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$FindValue(value);
			}
		case 'FindValueClicked':
			var value = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$FindValue(value);
		case 'RevertClicked':
			return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$Reverted;
		default:
			var enabled = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$DebtorAutofillChanged(enabled);
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$AdvanceCursor = {$: 'AdvanceCursor'};
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$Common = function (a) {
	return {$: 'Common', a: a};
};
var $author$project$Components$FactorInvoiceAuditCheckActions$SelectDocumentPage = function (a) {
	return {$: 'SelectDocumentPage', a: a};
};
var $author$project$Components$FactorInvoiceAuditCheckActions$SetDocumentType = F2(
	function (a, b) {
		return {$: 'SetDocumentType', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$update = function (msg) {
	switch (msg.$) {
		case 'TypeClicked':
			var documentId = msg.a;
			var documentType = msg.b;
			return $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$Common(
				A2($author$project$Components$FactorInvoiceAuditCheckActions$SetDocumentType, documentId, documentType));
		case 'ThumbnailClicked':
			var pageId = msg.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$Common(
				$author$project$Components$FactorInvoiceAuditCheckActions$SelectDocumentPage(pageId));
		default:
			return $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$AdvanceCursor;
	}
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorDropdownChanged = function (a) {
	return {$: 'DebtorDropdownChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorSuggestionSelected = function (a) {
	return {$: 'DebtorSuggestionSelected', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$FieldEdited = F2(
	function (a, b) {
		return {$: 'FieldEdited', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$FieldSaved = F2(
	function (a, b) {
		return {$: 'FieldSaved', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$FindValue = function (a) {
	return {$: 'FindValue', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$HighlightLocation = function (a) {
	return {$: 'HighlightLocation', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$InputDropped = function (a) {
	return {$: 'InputDropped', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$ToggleCollapsed = {$: 'ToggleCollapsed'};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$ToggleDebtorDetails = {$: 'ToggleDebtorDetails'};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$update = function (msg) {
	switch (msg.$) {
		case 'InputChanged':
			var field = msg.a;
			var value = msg.b;
			return A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$FieldEdited, field, value);
		case 'Blurred':
			var field = msg.a;
			var value = msg.b;
			return A2(
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$FieldSaved,
				field,
				A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$cleanForSave, field, value));
		case 'SuggestionClicked':
			var field = msg.a;
			var value = msg.b;
			return A2(
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$FieldSaved,
				field,
				A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$cleanForSave, field, value));
		case 'DebtorDropdownMsg':
			var dropdownMsg = msg.a;
			return $author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorDropdownChanged(dropdownMsg);
		case 'DebtorSuggestionClicked':
			var selection = msg.a;
			return $author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorSuggestionSelected(selection);
		case 'FindClicked':
			var value = msg.a.value;
			var location = msg.a.location;
			if (location.$ === 'Just') {
				return $author$project$Components$FactorInvoiceAuditQuickReviewFields$HighlightLocation(location);
			} else {
				return $author$project$Components$FactorInvoiceAuditQuickReviewFields$FindValue(value);
			}
		case 'DebtorDetailsToggled':
			return $author$project$Components$FactorInvoiceAuditQuickReviewFields$ToggleDebtorDetails;
		case 'CollapseToggled':
			return $author$project$Components$FactorInvoiceAuditQuickReviewFields$ToggleCollapsed;
		default:
			var dropSide = msg.a;
			return $author$project$Components$FactorInvoiceAuditQuickReviewFields$InputDropped(dropSide);
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$update = F3(
	function (factorInvoice, msg, model) {
		switch (msg.$) {
			case 'ToggleFailedCheck':
				var name = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$FactorInvoiceAuditChecks$toggleFailedCheck, name, model),
					$author$project$Components$FactorInvoiceAuditChecks$HighlightLocation($elm$core$Maybe$Nothing));
			case 'InvoiceAmountMsg':
				var leafMsg = msg.a;
				var _v1 = $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$update(leafMsg);
				switch (_v1.$) {
					case 'InputChanged':
						var inputValue = _v1.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount, inputValue, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'SuggestionConfirmed':
						var inputValue = _v1.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount, inputValue, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'SaveAmount':
						var amount = _v1.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$markSent, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount, amount, model),
							$author$project$Components$FactorInvoiceAuditChecks$SaveAmount(amount));
					case 'SaveAndConfirmRule':
						var amount = _v1.a;
						var ruleEvaluationId = _v1.b;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount, amount, model),
							A2($author$project$Components$FactorInvoiceAuditChecks$SaveAmountAndConfirm, amount, ruleEvaluationId));
					case 'IgnoreRule':
						var ruleResultId = _v1.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId));
					case 'HighlightLocation':
						var location = _v1.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$HighlightLocation(location));
					case 'FindValue':
						var value = _v1.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$FindValueInDocuments(value));
					default:
						return _Utils_Tuple2(
							A2($author$project$Components$FactorInvoiceAuditChecks$revertDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
				}
			case 'InvoiceDateMsg':
				var leafMsg = msg.a;
				var _v2 = $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$update(leafMsg);
				switch (_v2.$) {
					case 'InputChanged':
						var inputValue = _v2.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									invoiceDateInput: $elm$core$Maybe$Just(inputValue)
								}),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'SaveDate':
						var date = _v2.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$SaveDate(date));
					case 'SaveAndConfirmRule':
						var date = _v2.a;
						var ruleEvaluationId = _v2.b;
						return _Utils_Tuple2(
							model,
							A2($author$project$Components$FactorInvoiceAuditChecks$SaveDateAndConfirm, date, ruleEvaluationId));
					case 'IgnoreRule':
						var ruleResultId = _v2.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{invoiceDateInput: $elm$core$Maybe$Nothing}),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
				}
			case 'LoadIdMsg':
				var leafMsg = msg.a;
				var leafOut = $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$update(leafMsg);
				switch (leafOut.$) {
					case 'InputChanged':
						var inputValue = leafOut.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, inputValue, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'SuggestionConfirmed':
						var inputValue = leafOut.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, inputValue, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'SaveLoadId':
						var loadId = leafOut.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$markSent, $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, loadId, model),
							A2($author$project$Components$FactorInvoiceAuditChecks$SaveLoadId, loadId, model.debtorAutofillInput));
					case 'SaveAndConfirmRule':
						var loadId = leafOut.a;
						var ruleEvaluationId = leafOut.b;
						return _Utils_Tuple2(
							model,
							A3($author$project$Components$FactorInvoiceAuditChecks$SaveLoadIdAndConfirm, loadId, model.debtorAutofillInput, ruleEvaluationId));
					case 'IgnoreRule':
						var ruleResultId = leafOut.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId));
					case 'HighlightLocation':
						var location = leafOut.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$HighlightLocation(location));
					case 'FindValue':
						var value = leafOut.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$FindValueInDocuments(value));
					case 'DebtorAutofillChanged':
						var enabled = leafOut.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									debtorAutofillInput: $elm$core$Maybe$Just(enabled)
								}),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					default:
						return _Utils_Tuple2(
							A2($author$project$Components$FactorInvoiceAuditChecks$revertDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
				}
			case 'InvoiceNumberMsg':
				var leafMsg = msg.a;
				var _v4 = $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$update(leafMsg);
				switch (_v4.$) {
					case 'InputChanged':
						var inputValue = _v4.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, inputValue, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'SuggestionConfirmed':
						var inputValue = _v4.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, inputValue, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'SaveInvoiceNumber':
						var invoiceNumber = _v4.a;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$markSent, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, invoiceNumber, model),
							$author$project$Components$FactorInvoiceAuditChecks$SaveInvoiceNumber(invoiceNumber));
					case 'SaveAndConfirmRule':
						var invoiceNumber = _v4.a;
						var ruleEvaluationId = _v4.b;
						return _Utils_Tuple2(
							model,
							A2($author$project$Components$FactorInvoiceAuditChecks$SaveInvoiceNumberAndConfirm, invoiceNumber, ruleEvaluationId));
					case 'IgnoreRule':
						var ruleResultId = _v4.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId));
					case 'HighlightLocation':
						var location = _v4.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$HighlightLocation(location));
					case 'FindValue':
						var value = _v4.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$FindValueInDocuments(value));
					default:
						return _Utils_Tuple2(
							A2($author$project$Components$FactorInvoiceAuditChecks$revertDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
				}
			case 'BrokerClientCarrierAmountMsg':
				var leafMsg = msg.a;
				var _v5 = A2(
					$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$update,
					leafMsg,
					{amountInput: model.brokerClientCarrierAmountInput});
				var newLeaf = _v5.a;
				var leafOut = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{brokerClientCarrierAmountInput: newLeaf.amountInput}),
					function () {
						switch (leafOut.$) {
							case 'NoOp':
								return $author$project$Components$FactorInvoiceAuditChecks$NoOp;
							case 'SaveAmount':
								var amount = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$SaveCarrierAmount(amount);
							case 'FindValue':
								var value = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$FindValueInDocuments(value);
							default:
								var ruleResultId = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId);
						}
					}());
			case 'BrokerClientBrokeredCarrierMsg':
				var leafMsg = msg.a;
				var leafOut = $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$update(leafMsg);
				return _Utils_Tuple2(
					model,
					function () {
						switch (leafOut.$) {
							case 'DropdownChanged':
								var dropdownMsg = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$BrokeredCarrierDropdownMsg(dropdownMsg);
							case 'SaveClickedOut':
								return $author$project$Components$FactorInvoiceAuditChecks$SaveBrokeredCarrierClicked;
							default:
								var ruleResultId = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId);
						}
					}());
			case 'BrokerClientBrokeredCarrierTermsMsg':
				var leafMsg = msg.a;
				var leafOut = $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$update(leafMsg);
				return _Utils_Tuple2(
					model,
					function () {
						switch (leafOut.$) {
							case 'DropdownChanged':
								var dropdownMsg = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$BrokeredCarrierTermDropdownMsg(dropdownMsg);
							case 'SaveClickedOut':
								return $author$project$Components$FactorInvoiceAuditChecks$SaveBrokeredCarrierTermClicked;
							default:
								var ruleResultId = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId);
						}
					}());
			case 'CommonActionMsg':
				var action = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$FactorInvoiceAuditChecks$mapCommonAction(action));
			case 'UnidentifiedDocumentsMsg':
				var leafMsg = msg.a;
				var _v9 = $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$update(leafMsg);
				if (_v9.$ === 'Common') {
					var action = _v9.a;
					return _Utils_Tuple2(
						model,
						$author$project$Components$FactorInvoiceAuditChecks$mapCommonAction(action));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{unidentifiedDocumentCursor: model.unidentifiedDocumentCursor + 1}),
						$author$project$Components$FactorInvoiceAuditChecks$NoOp);
				}
			case 'DuplicateInvoiceMsg':
				var leafMsg = msg.a;
				var _v10 = $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$update(leafMsg);
				if (_v10.$ === 'Common') {
					var action = _v10.a;
					return _Utils_Tuple2(
						model,
						$author$project$Components$FactorInvoiceAuditChecks$mapCommonAction(action));
				} else {
					var invoiceId = _v10.a;
					return _Utils_Tuple2(
						model,
						$author$project$Components$FactorInvoiceAuditChecks$CompareDuplicate(invoiceId));
				}
			case 'QuickReviewFieldsMsg':
				var leafMsg = msg.a;
				var _v11 = $author$project$Components$FactorInvoiceAuditQuickReviewFields$update(leafMsg);
				switch (_v11.$) {
					case 'FieldEdited':
						var field = _v11.a;
						var value = _v11.b;
						return _Utils_Tuple2(
							A3($author$project$Components$FactorInvoiceAuditChecks$stageDraft, field, value, model),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'FieldSaved':
						var field = _v11.a;
						var value = _v11.b;
						return A4($author$project$Components$FactorInvoiceAuditChecks$saveSettledQuickReviewField, factorInvoice, field, value, model);
					case 'DebtorDropdownChanged':
						var dropdownMsg = _v11.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$DebtorDropdownMsgWithAutoSave(dropdownMsg));
					case 'DebtorSuggestionSelected':
						var entityId = _v11.a.entityId;
						var value = _v11.a.value;
						if (entityId.$ === 'Just') {
							var id = entityId.a;
							return _Utils_Tuple2(
								model,
								$author$project$Components$FactorInvoiceAuditChecks$SelectDebtorSuggestion(
									{entityId: id, name: value}));
						} else {
							return _Utils_Tuple2(model, $author$project$Components$FactorInvoiceAuditChecks$NoOp);
						}
					case 'HighlightLocation':
						var location = _v11.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$HighlightLocation(location));
					case 'FindValue':
						var value = _v11.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$FindValueInDocuments(value));
					case 'ToggleDebtorDetails':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{quickReviewDebtorDetailsExpanded: !model.quickReviewDebtorDetailsExpanded}),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					case 'ToggleCollapsed':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{quickReviewCollapsed: !model.quickReviewCollapsed}),
							$author$project$Components$FactorInvoiceAuditChecks$NoOp);
					default:
						var dropSide = _v11.a;
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditChecks$InputDrop(dropSide));
				}
			case 'CarrierRequiredMsg':
				var leafMsg = msg.a;
				var leafOut = $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$update(leafMsg);
				return _Utils_Tuple2(
					model,
					function () {
						if (leafOut.$ === 'DropdownChanged') {
							var dropdownMsg = leafOut.a;
							return $author$project$Components$FactorInvoiceAuditChecks$CarrierDropdownMsg(dropdownMsg);
						} else {
							return $author$project$Components$FactorInvoiceAuditChecks$SaveCarrierClicked;
						}
					}());
			case 'DebtorRequiredMsg':
				var leafMsg = msg.a;
				var leafOut = $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$update(leafMsg);
				return _Utils_Tuple2(
					model,
					function () {
						switch (leafOut.$) {
							case 'DropdownChanged':
								var dropdownMsg = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$DebtorDropdownMsg(dropdownMsg);
							case 'SaveClickedOut':
								return $author$project$Components$FactorInvoiceAuditChecks$SaveDebtorClicked;
							case 'SaveAndConfirmDebtor':
								var ruleEvaluationId = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$SaveDebtorAndConfirm(ruleEvaluationId);
							case 'IgnoreRule':
								var ruleResultId = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$IgnoreRule(ruleResultId);
							case 'SuggestionSelected':
								var entityId = leafOut.a.entityId;
								var value = leafOut.a.value;
								if (entityId.$ === 'Just') {
									var id = entityId.a;
									return $author$project$Components$FactorInvoiceAuditChecks$SelectDebtorSuggestion(
										{entityId: id, name: value});
								} else {
									return $author$project$Components$FactorInvoiceAuditChecks$NoOp;
								}
							case 'HighlightLocation':
								var location = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$HighlightLocation(location);
							default:
								var value = leafOut.a;
								return $author$project$Components$FactorInvoiceAuditChecks$FindValueInDocuments(value);
						}
					}());
			case 'ExceptionEventMsg':
				var exceptionEventId = msg.a;
				var leafMsg = msg.b;
				var key = $author$project$Domain$ExceptionEventId$toInt(exceptionEventId);
				var _v16 = A2(
					$author$project$Components$AuditFailedCheckExceptionEvent$update,
					leafMsg,
					A2($author$project$Components$FactorInvoiceAuditChecks$resolutionInputFor, exceptionEventId, model));
				var newInput = _v16.a;
				var leafOut = _v16.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							exceptionEventInputs: A3($elm$core$Dict$insert, key, newInput, model.exceptionEventInputs)
						}),
					function () {
						if (leafOut.$ === 'NoOp') {
							return $author$project$Components$FactorInvoiceAuditChecks$NoOp;
						} else {
							var eventId = leafOut.a;
							var resolutionMessage = leafOut.b;
							return A2($author$project$Components$FactorInvoiceAuditChecks$ResolveExceptionEvent, eventId, resolutionMessage);
						}
					}());
			case 'AddExceptionEventMsg':
				var leafMsg = msg.a;
				var _v18 = A2($author$project$Components$AuditAddExceptionEvent$update, leafMsg, model.addExceptionEvent);
				var newLeaf = _v18.a;
				var leafOut = _v18.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{addExceptionEvent: newLeaf}),
					function () {
						if (leafOut.$ === 'NoOp') {
							return $author$project$Components$FactorInvoiceAuditChecks$NoOp;
						} else {
							var message = leafOut.a;
							return $author$project$Components$FactorInvoiceAuditChecks$CreateException(message);
						}
					}());
			case 'UnignoreClicked':
				var ruleResultId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$FactorInvoiceAuditChecks$UnignoreRule(ruleResultId));
			case 'InputDropMsg':
				var dropSide = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Components$FactorInvoiceAuditChecks$InputDrop(dropSide));
			default:
				var target = msg.a;
				var value = msg.b;
				var staged = A3(
					$author$project$Components$FactorInvoiceAuditChecks$setInputValue,
					$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$dropTargetField(target),
					value,
					model);
				if (target.$ === 'QuickReviewInput') {
					var dropField = target.a;
					var _v21 = $author$project$Components$FactorInvoiceAuditQuickReviewFields$fromDropField(dropField);
					if (_v21.$ === 'Just') {
						var field = _v21.a;
						return A4(
							$author$project$Components$FactorInvoiceAuditChecks$saveSettledQuickReviewField,
							factorInvoice,
							field,
							A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$cleanForSave, field, value),
							staged);
					} else {
						return _Utils_Tuple2(staged, $author$project$Components$FactorInvoiceAuditChecks$NoOp);
					}
				} else {
					return _Utils_Tuple2(staged, $author$project$Components$FactorInvoiceAuditChecks$NoOp);
				}
		}
	});
var $jinjor$elm_debounce$Debounce$update = F4(
	function (config, send, msg, _v0) {
		var d = _v0.a;
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(
					$jinjor$elm_debounce$Debounce$Debounce(d),
					$elm$core$Platform$Cmd$none);
			case 'Flush':
				var tryAgainAfter = msg.a;
				var _v2 = d.input;
				if (_v2.b) {
					var head = _v2.a;
					var tail = _v2.b;
					var selfCmd = function () {
						if (tryAgainAfter.$ === 'Just') {
							var delay = tryAgainAfter.a;
							return A2(
								$jinjor$elm_debounce$Debounce$delayCmd,
								delay,
								$jinjor$elm_debounce$Debounce$Flush(
									$elm$core$Maybe$Just(delay)));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v3 = A2(send, head, tail);
					var input = _v3.a;
					var sendCmd = _v3.b;
					return _Utils_Tuple2(
						$jinjor$elm_debounce$Debounce$Debounce(
							_Utils_update(
								d,
								{input: input, locked: true})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									sendCmd,
									A2($elm$core$Platform$Cmd$map, config.transform, selfCmd)
								])));
				} else {
					return _Utils_Tuple2(
						$jinjor$elm_debounce$Debounce$Debounce(
							_Utils_update(
								d,
								{locked: false})),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var lastInputLength = msg.a;
				var _v5 = _Utils_Tuple2(
					_Utils_cmp(
						$elm$core$List$length(d.input),
						lastInputLength) < 1,
					d.input);
				if (_v5.a && _v5.b.b) {
					var _v6 = _v5.b;
					var head = _v6.a;
					var tail = _v6.b;
					var _v7 = A2(send, head, tail);
					var input = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple2(
						$jinjor$elm_debounce$Debounce$Debounce(
							_Utils_update(
								d,
								{input: input})),
						cmd);
				} else {
					return _Utils_Tuple2(
						$jinjor$elm_debounce$Debounce$Debounce(d),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$ValueDropped = F2(
	function (a, b) {
		return {$: 'ValueDropped', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$valueDropped = $author$project$Components$FactorInvoiceAuditChecks$ValueDropped;
var $author$project$Components$FactorInvoiceAuditWorkingArea$update = F3(
	function (remoteData, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 'CarrierDropdownMsg':
					var dropdownMsg = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyCarrierDropdownMsg, remoteData, dropdownMsg, model));
				case 'DebtorDropdownMsg':
					var dropdownMsg = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyDebtorDropdownMsg, remoteData, dropdownMsg, model));
				case 'BrokeredCarrierDropdownMsg':
					var dropdownMsg = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyBrokeredCarrierDropdownMsg, remoteData, dropdownMsg, model));
				case 'BrokeredCarrierTermDropdownMsg':
					var dropdownMsg = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyBrokeredCarrierTermDropdownMsg, remoteData, dropdownMsg, model));
				case 'PossibleMatchesMsg':
					var sectionMsg = msg.a;
					var _v1 = A2($author$project$Components$FactorInvoiceAudit$PossibleMatches$update, sectionMsg, model.possibleMatchesSection);
					var newSection = _v1.a;
					var outMsg = _v1.b;
					var modelWithSection = _Utils_update(
						model,
						{possibleMatchesSection: newSection});
					if (outMsg.$ === 'NoOutMsg') {
						return _Utils_Tuple3(modelWithSection, $author$project$HubTran$Effect$none, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
					} else {
						var otherInvoiceId = outMsg.a;
						return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
							A2($author$project$Components$FactorInvoiceAuditWorkingArea$mergeFrom, modelWithSection, otherInvoiceId));
					}
				case 'ProcessMergeFromResponse':
					var response = msg.a;
					return A4($author$project$AuditApi$applyRequestWithOut, model, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleMergeFromResponse);
				case 'ValueDropped':
					var target = msg.a;
					var value = msg.b;
					var _v3 = $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$dropTargetField(target);
					switch (_v3.$) {
						case 'DebtorField':
							var _v4 = A2($author$project$Components$DebtorDropdown$search, value, model.debtorDropdown);
							var debtorDropdown = _v4.a;
							var cmd = _v4.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{debtorDropdown: debtorDropdown}),
								$author$project$HubTran$Effect$cmd(
									A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditWorkingArea$DebtorDropdownMsg, cmd)),
								$author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
						case 'InvoiceAmountField':
							var $temp$remoteData = remoteData,
								$temp$msg = $author$project$Components$FactorInvoiceAuditWorkingArea$AuditChecksMsg(
								A2($author$project$Components$FactorInvoiceAuditChecks$valueDropped, target, value)),
								$temp$model = model;
							remoteData = $temp$remoteData;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						case 'InvoiceDateField':
							var $temp$remoteData = remoteData,
								$temp$msg = $author$project$Components$FactorInvoiceAuditWorkingArea$AuditChecksMsg(
								A2($author$project$Components$FactorInvoiceAuditChecks$valueDropped, target, value)),
								$temp$model = model;
							remoteData = $temp$remoteData;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						case 'LoadIdField':
							var $temp$remoteData = remoteData,
								$temp$msg = $author$project$Components$FactorInvoiceAuditWorkingArea$AuditChecksMsg(
								A2($author$project$Components$FactorInvoiceAuditChecks$valueDropped, target, value)),
								$temp$model = model;
							remoteData = $temp$remoteData;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						default:
							var $temp$remoteData = remoteData,
								$temp$msg = $author$project$Components$FactorInvoiceAuditWorkingArea$AuditChecksMsg(
								A2($author$project$Components$FactorInvoiceAuditChecks$valueDropped, target, value)),
								$temp$model = model;
							remoteData = $temp$remoteData;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
					}
				case 'AuditChecksMsg':
					var auditChecksMsg = msg.a;
					var _v5 = A3(
						$author$project$Components$FactorInvoiceAuditChecks$update,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.factorInvoice;
							},
							$author$project$Forward$Remote$toMaybe(remoteData)),
						auditChecksMsg,
						model.auditChecks);
					var newAuditChecks = _v5.a;
					var outMsg = _v5.b;
					var modelWithChecks = _Utils_update(
						model,
						{auditChecks: newAuditChecks});
					switch (outMsg.$) {
						case 'NoOp':
							return _Utils_Tuple3(modelWithChecks, $author$project$HubTran$Effect$none, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
						case 'CompareDuplicate':
							var invoiceId = outMsg.a;
							return _Utils_Tuple3(
								modelWithChecks,
								$author$project$HubTran$Effect$none,
								$author$project$Components$FactorInvoiceAuditWorkingArea$CompareDuplicateOutMsg(invoiceId));
						case 'SaveAmount':
							var amount = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A2(
									$author$project$Components$FactorInvoiceAuditWorkingArea$saveSettledFields,
									modelWithChecks,
									$author$project$Components$FactorInvoiceAuditWorkingArea$amountUpdates(amount)));
						case 'SaveCarrierAmount':
							var amount = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3(
									$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
									modelWithChecks,
									$elm$core$Maybe$Nothing,
									$author$project$Components$FactorInvoiceAuditWorkingArea$carrierAmountUpdates(amount)));
						case 'SaveDate':
							var date = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3(
									$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
									modelWithChecks,
									$elm$core$Maybe$Nothing,
									A2($author$project$Components$FactorInvoiceAuditWorkingArea$dateUpdates, remoteData, date)));
						case 'SaveLoadId':
							var loadId = outMsg.a;
							var debtorAutofill = outMsg.b;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A2(
									$author$project$Components$FactorInvoiceAuditWorkingArea$saveSettledFields,
									modelWithChecks,
									A2($author$project$Components$FactorInvoiceAuditWorkingArea$loadIdUpdates, loadId, debtorAutofill)));
						case 'SaveInvoiceNumber':
							var invoiceNumber = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A2(
									$author$project$Components$FactorInvoiceAuditWorkingArea$saveSettledFields,
									modelWithChecks,
									$author$project$Components$FactorInvoiceAuditWorkingArea$invoiceNumberUpdates(invoiceNumber)));
						case 'SaveAmountAndConfirm':
							var amount = outMsg.a;
							var ruleEvaluationId = outMsg.b;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3(
									$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
									modelWithChecks,
									$elm$core$Maybe$Just(ruleEvaluationId),
									$author$project$Components$FactorInvoiceAuditWorkingArea$amountUpdates(amount)));
						case 'SaveDateAndConfirm':
							var date = outMsg.a;
							var ruleEvaluationId = outMsg.b;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3(
									$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
									modelWithChecks,
									$elm$core$Maybe$Just(ruleEvaluationId),
									A2($author$project$Components$FactorInvoiceAuditWorkingArea$dateUpdates, remoteData, date)));
						case 'SaveLoadIdAndConfirm':
							var loadId = outMsg.a;
							var debtorAutofill = outMsg.b;
							var ruleEvaluationId = outMsg.c;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3(
									$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
									modelWithChecks,
									$elm$core$Maybe$Just(ruleEvaluationId),
									A2($author$project$Components$FactorInvoiceAuditWorkingArea$loadIdUpdates, loadId, debtorAutofill)));
						case 'SaveInvoiceNumberAndConfirm':
							var invoiceNumber = outMsg.a;
							var ruleEvaluationId = outMsg.b;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3(
									$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
									modelWithChecks,
									$elm$core$Maybe$Just(ruleEvaluationId),
									$author$project$Components$FactorInvoiceAuditWorkingArea$invoiceNumberUpdates(invoiceNumber)));
						case 'SaveDebtorAndConfirm':
							var ruleEvaluationId = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								function () {
									var _v7 = $elm$core$List$head(
										$author$project$Components$DebtorDropdown$selectedIds(modelWithChecks.debtorDropdown));
									if (_v7.$ === 'Just') {
										var factorBrokerId = _v7.a;
										return A3(
											$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
											modelWithChecks,
											$elm$core$Maybe$Just(ruleEvaluationId),
											$author$project$Components$FactorInvoiceAuditWorkingArea$debtorUpdates(factorBrokerId));
									} else {
										return _Utils_Tuple2(modelWithChecks, $author$project$HubTran$Effect$none);
									}
								}());
						case 'CarrierDropdownMsg':
							var dropdownMsg = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyCarrierDropdownMsg, remoteData, dropdownMsg, modelWithChecks));
						case 'SaveCarrierClicked':
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								function () {
									var _v8 = $elm$core$List$head(
										$author$project$Components$CarrierDropdown$selectedIds(modelWithChecks.carrierDropdown));
									if (_v8.$ === 'Just') {
										var tmsCarrierId = _v8.a;
										return A3(
											$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
											modelWithChecks,
											$elm$core$Maybe$Nothing,
											$author$project$Components$FactorInvoiceAuditWorkingArea$carrierUpdates(tmsCarrierId));
									} else {
										return _Utils_Tuple2(modelWithChecks, $author$project$HubTran$Effect$none);
									}
								}());
						case 'DebtorDropdownMsg':
							var dropdownMsg = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyDebtorDropdownMsg, remoteData, dropdownMsg, modelWithChecks));
						case 'DebtorDropdownMsgWithAutoSave':
							var dropdownMsg = outMsg.a;
							var _v9 = A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyDebtorDropdownMsg, remoteData, dropdownMsg, modelWithChecks);
							var updatedModel = _v9.a;
							var dropdownEffect = _v9.b;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								function () {
									var _v10 = $elm$core$List$head(
										$author$project$Components$DebtorDropdown$selectedIds(updatedModel.debtorDropdown));
									if (_v10.$ === 'Just') {
										var factorBrokerId = _v10.a;
										return A2(
											$elm$core$Tuple$mapSecond,
											function (saveEffect) {
												return $author$project$HubTran$Effect$batch(
													_List_fromArray(
														[dropdownEffect, saveEffect]));
											},
											A3(
												$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
												updatedModel,
												$elm$core$Maybe$Nothing,
												$author$project$Components$FactorInvoiceAuditWorkingArea$debtorUpdates(factorBrokerId)));
									} else {
										return _Utils_Tuple2(updatedModel, dropdownEffect);
									}
								}());
						case 'SaveDebtorClicked':
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								function () {
									var _v11 = $elm$core$List$head(
										$author$project$Components$DebtorDropdown$selectedIds(modelWithChecks.debtorDropdown));
									if (_v11.$ === 'Just') {
										var factorBrokerId = _v11.a;
										return A3(
											$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
											modelWithChecks,
											$elm$core$Maybe$Nothing,
											$author$project$Components$FactorInvoiceAuditWorkingArea$debtorUpdates(factorBrokerId));
									} else {
										return _Utils_Tuple2(modelWithChecks, $author$project$HubTran$Effect$none);
									}
								}());
						case 'BrokeredCarrierDropdownMsg':
							var dropdownMsg = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyBrokeredCarrierDropdownMsg, remoteData, dropdownMsg, modelWithChecks));
						case 'SaveBrokeredCarrierClicked':
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								function () {
									var _v12 = $elm$core$List$head(
										$author$project$Components$BrokeredCarrierDropdown$selectedIds(modelWithChecks.brokeredCarrierDropdown));
									if (_v12.$ === 'Just') {
										var brokeredCarrierId = _v12.a;
										return A3(
											$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
											modelWithChecks,
											$elm$core$Maybe$Nothing,
											$author$project$Components$FactorInvoiceAuditWorkingArea$brokeredCarrierUpdates(
												$author$project$Domain$BrokeredCarrierId$toInt(brokeredCarrierId)));
									} else {
										return _Utils_Tuple2(modelWithChecks, $author$project$HubTran$Effect$none);
									}
								}());
						case 'BrokeredCarrierTermDropdownMsg':
							var dropdownMsg = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3($author$project$Components$FactorInvoiceAuditWorkingArea$applyBrokeredCarrierTermDropdownMsg, remoteData, dropdownMsg, modelWithChecks));
						case 'SaveBrokeredCarrierTermClicked':
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								function () {
									var _v13 = $elm$core$List$head(
										$author$project$Components$BrokeredCarrierTermDropdown$selectedIds(modelWithChecks.brokeredCarrierTermDropdown));
									if (_v13.$ === 'Just') {
										var brokeredCarrierTermId = _v13.a;
										return A3(
											$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
											modelWithChecks,
											$elm$core$Maybe$Nothing,
											$author$project$Components$FactorInvoiceAuditWorkingArea$brokeredCarrierTermUpdates(
												$author$project$Domain$BrokeredCarrierTermId$toInt(brokeredCarrierTermId)));
									} else {
										return _Utils_Tuple2(modelWithChecks, $author$project$HubTran$Effect$none);
									}
								}());
						case 'IgnoreRule':
							var ruleResultId = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3($author$project$Components$FactorInvoiceAuditWorkingArea$manuallyAddressRuleFailure, modelWithChecks, ruleResultId, $author$project$AuditPb$FactorInvoiceServiceManuallyAddressRuleFailureActionIgnore));
						case 'UnignoreRule':
							var ruleResultId = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3($author$project$Components$FactorInvoiceAuditWorkingArea$manuallyAddressRuleFailure, modelWithChecks, ruleResultId, $author$project$AuditPb$FactorInvoiceServiceManuallyAddressRuleFailureActionUnignore));
						case 'ResolveExceptionEvent':
							var exceptionEventId = outMsg.a;
							var resolutionMessage = outMsg.b;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3($author$project$Components$FactorInvoiceAuditWorkingArea$resolveExceptionEvent, modelWithChecks, exceptionEventId, resolutionMessage));
						case 'CreateException':
							var message = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A2($author$project$Components$FactorInvoiceAuditWorkingArea$createException, modelWithChecks, message));
						case 'HighlightLocation':
							var location = outMsg.a;
							return _Utils_Tuple3(
								modelWithChecks,
								$author$project$HubTran$Effect$none,
								$author$project$Components$FactorInvoiceAuditWorkingArea$HighlightSuggestionLocation(location));
						case 'FindValueInDocuments':
							var value = outMsg.a;
							return _Utils_Tuple3(
								modelWithChecks,
								$author$project$HubTran$Effect$none,
								$author$project$Components$FactorInvoiceAuditWorkingArea$FindValueInDocuments(value));
						case 'SelectDocumentPage':
							var pageId = outMsg.a;
							return _Utils_Tuple3(
								modelWithChecks,
								$author$project$HubTran$Effect$none,
								$author$project$Components$FactorInvoiceAuditWorkingArea$SelectDocumentPageOutMsg(pageId));
						case 'SelectDebtorSuggestion':
							var name = outMsg.a.name;
							var entityId = outMsg.a.entityId;
							return _Utils_Tuple3(
								_Utils_update(
									modelWithChecks,
									{
										debtorDropdown: A2(
											$author$project$Components$DebtorDropdown$selectById,
											{id: entityId, name: name},
											modelWithChecks.debtorDropdown)
									}),
								$author$project$HubTran$Effect$none,
								$author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
						case 'InputDrop':
							var dropSide = outMsg.a;
							return _Utils_Tuple3(
								modelWithChecks,
								$author$project$HubTran$Effect$none,
								$author$project$Components$FactorInvoiceAuditWorkingArea$InputDroppedOutMsg(dropSide));
						case 'SetIsTonu':
							var isTonu = outMsg.a;
							return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
								A3(
									$author$project$Components$FactorInvoiceAuditWorkingArea$sendUpdate,
									modelWithChecks,
									$elm$core$Maybe$Nothing,
									$author$project$Components$FactorInvoiceAuditWorkingArea$isTonuUpdates(isTonu)));
						default:
							var documentId = outMsg.a;
							var documentType = outMsg.b;
							return _Utils_Tuple3(
								modelWithChecks,
								$author$project$HubTran$Effect$none,
								A2($author$project$Components$FactorInvoiceAuditWorkingArea$SetDocumentTypeOutMsg, documentId, documentType));
					}
				case 'ProcessUpdateResponse':
					var response = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$sendQueuedUpdates(
							A3($author$project$AuditApi$applyRequest, model, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleUpdateResponse)));
				case 'ProcessSaveWithErrorsResponse':
					var response = msg.a;
					var _v14 = A3($author$project$AuditApi$applyRequest, model, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleSaveWithErrorsResponse);
					var newModel = _v14.a;
					var effect = _v14.b;
					var outMsg = newModel.sendToCarrierModalRequested ? $author$project$Components$FactorInvoiceAuditWorkingArea$OpenSendToCarrierModalOutMsg : $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{sendToCarrierModalRequested: false}),
						effect,
						outMsg);
				case 'ProcessSaveAsIncompleteResponse':
					var response = msg.a;
					return A4($author$project$AuditApi$applyRequestWithOut, model, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleSaveAsIncompleteResponse);
				case 'ProcessCreateExceptionResponse':
					var response = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$sendQueuedUpdates(
							A3($author$project$AuditApi$applyRequest, model, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleCreateExceptionResponse)));
				case 'ProcessMarkAsProcessedResponse':
					var response = msg.a;
					return A4($author$project$AuditApi$applyRequestWithOut, model, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleMarkAsProcessedResponse);
				case 'ProcessSaveAndApproveResponse':
					var response = msg.a;
					return A4($author$project$AuditApi$applyRequestWithOut, model, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleSaveAndApproveResponse);
				case 'SaveAndSendClicked':
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						A2($author$project$Components$FactorInvoiceAuditWorkingArea$sendBackToCarrier, remoteData, model));
				case 'SaveClicked':
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$save(model));
				case 'SaveAndApproveClicked':
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$saveAndApprove(model));
				case 'SaveAsIncompleteClicked':
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$saveAsIncomplete(model));
				case 'RejectClicked':
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$reject(model));
				case 'IgnoreClicked':
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ignoreModalOpen: true, ignoreReason: ''}),
						$author$project$HubTran$Effect$none,
						$author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
				case 'IgnoreReasonChanged':
					var reason = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ignoreReason: reason}),
						$author$project$HubTran$Effect$none,
						$author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
				case 'IgnoreConfirmed':
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$abandon(model));
				case 'IgnoreCancelled':
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ignoreModalOpen: false}),
						$author$project$HubTran$Effect$none,
						$author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
				case 'ProcessAbandonResponse':
					var response = msg.a;
					return A4($author$project$AuditApi$applyRequestWithOut, model, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleAbandonResponse);
				case 'UnIgnoreClicked':
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$revive(model));
				case 'UnapproveClicked':
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$unapprove(model));
				case 'ProcessUnapproveResponse':
					var response = msg.a;
					return A4($author$project$AuditApi$applyRequestWithOut, model, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleUnapproveResponse);
				case 'ProcessReviveResponse':
					var response = msg.a;
					return A4($author$project$AuditApi$applyRequestWithOut, model, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleReviveResponse);
				case 'ProcessRejectResponse':
					var response = msg.a;
					return A4($author$project$AuditApi$applyRequestWithOut, model, $author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleRejectResponse);
				case 'NotesChanged':
					var notes = msg.a;
					var _v15 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$FactorInvoiceAuditWorkingArea$notesDebounceConfig, notes, model.notesDebounce);
					var debounce = _v15.a;
					var cmd = _v15.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								notesDebounce: debounce,
								notesDraft: $elm$core$Maybe$Just(notes)
							}),
						$author$project$HubTran$Effect$cmd(cmd),
						$author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
				case 'NotesDebounceMsg':
					var debounceMsg = msg.a;
					var _v16 = A4(
						$jinjor$elm_debounce$Debounce$update,
						$author$project$Components$FactorInvoiceAuditWorkingArea$notesDebounceConfig,
						$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$FactorInvoiceAuditWorkingArea$saveNotesCmd),
						debounceMsg,
						model.notesDebounce);
					var debounce = _v16.a;
					var cmd = _v16.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{notesDebounce: debounce}),
						$author$project$HubTran$Effect$cmd(cmd),
						$author$project$Components$FactorInvoiceAuditWorkingArea$NoOutMsg);
				case 'SaveNotes':
					var notes = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						A2($author$project$Components$FactorInvoiceAuditWorkingArea$saveNotes, model, notes));
				case 'ProcessNotesSaveResponse':
					var response = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$sendQueuedUpdates(
							A3($author$project$AuditApi$applyRequest, model, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleNotesSaveResponse)));
				case 'MustVerifyChanged':
					var checked = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						A2(
							$author$project$Components$FactorInvoiceAuditWorkingArea$saveMustVerify,
							_Utils_update(
								model,
								{
									mustVerifyDraft: $elm$core$Maybe$Just(checked)
								}),
							checked));
				case 'ProcessMustVerifySaveResponse':
					var response = msg.a;
					return $author$project$Components$FactorInvoiceAuditWorkingArea$withNoOutMsg(
						$author$project$Components$FactorInvoiceAuditWorkingArea$sendQueuedUpdates(
							A3($author$project$AuditApi$applyRequest, model, response, $author$project$Components$FactorInvoiceAuditWorkingArea$handleMustVerifySaveResponse)));
				default:
					return A2($author$project$Components$FactorInvoiceAuditWorkingArea$reviewUnsavedEdit, remoteData, model);
			}
		}
	});
var $author$project$Components$FactorInvoiceClientNotesPanel$update = F2(
	function (msg, model) {
		return _Utils_update(
			model,
			{open: !model.open});
	});
var $author$project$Presence$update = F2(
	function (msg, old) {
		var _new = msg.a;
		return _Utils_eq(_new.path, old.path) ? _new : old;
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$ValueDropped = F2(
	function (a, b) {
		return {$: 'ValueDropped', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$valueDropped = $author$project$Components$FactorInvoiceAuditWorkingArea$ValueDropped;
var $author$project$Components$FactorInvoiceAuditBatchPage$compareBolAndRateCon = F3(
	function (remoteData, _v26, model) {
		var rateCon = _v26.rateCon;
		var bol = _v26.bol;
		var _v27 = $author$project$Forward$Remote$toMaybe(
			A2(
				$author$project$Forward$Remote$andThen,
				function ($) {
					return $.documentsBrowserData;
				},
				remoteData));
		if (_v27.$ === 'Just') {
			var documentsBrowserData = _v27.a;
			var _v28 = A3(
				$author$project$Components$FactorInvoiceAuditBatchPage$update,
				remoteData,
				$author$project$Components$FactorInvoiceAuditBatchPage$DocumentsBrowserMsg(
					A3($author$project$Components$DocumentsBrowser$selectDocumentMsg, documentsBrowserData, model.documentsBrowser, rateCon)),
				model);
			var selectedModel = _v28.a;
			var selectEffect = _v28.b;
			var _v29 = A2($author$project$Components$FactorInvoiceAuditBatchPage$openSecondary, bol, selectedModel);
			var openedModel = _v29.a;
			var openEffect = _v29.b;
			return _Utils_Tuple2(
				openedModel,
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[selectEffect, openEffect])));
		} else {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$update = F3(
	function (remoteData, msg, model) {
		update:
		while (true) {
			_v0$7:
			while (true) {
				switch (msg.$) {
					case 'WorkingAreaMsg':
						var workingAreaMsg = msg.a;
						var workingAreaData = A2(
							$author$project$Forward$Remote$andThen,
							function ($) {
								return $.workingArea;
							},
							remoteData);
						var documentsBrowserData = A2(
							$author$project$Forward$Remote$andThen,
							function ($) {
								return $.documentsBrowserData;
							},
							remoteData);
						var advanceWithFlash = function (flashMessage) {
							return $author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success(flashMessage)),
										$author$project$Components$FactorInvoiceAuditBatchPage$advanceToNextIncomplete(model)
									]));
						};
						var _v1 = A3($author$project$Components$FactorInvoiceAuditWorkingArea$update, workingAreaData, workingAreaMsg, model.workingArea);
						var newWorkingArea = _v1.a;
						var workingAreaEffect = _v1.b;
						var outMsg = _v1.c;
						var _v2 = A3(
							$author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$applyOutMsg,
							documentsBrowserData,
							outMsg,
							{documentsBrowser: model.documentsBrowser, packetComparison: model.packetComparison, sendToCarrierModalOpen: model.sendToCarrierModalOpen});
						var response = _v2.a;
						var responseEffect = _v2.b;
						var updatedModel = _Utils_update(
							model,
							{documentsBrowser: response.documentsBrowser, packetComparison: response.packetComparison, sendToCarrierModalOpen: response.sendToCarrierModalOpen, workingArea: newWorkingArea});
						var additionalEffect = function () {
							switch (outMsg.$) {
								case 'ProcessedOutMsg':
									return advanceWithFlash('Invoice processed');
								case 'SavedAsIncompleteOutMsg':
									return advanceWithFlash('Saved as incomplete');
								case 'IgnoredInvoiceOutMsg':
									return advanceWithFlash('Invoice ignored');
								case 'RevivedInvoiceOutMsg':
									return $author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												$author$project$HubTran$Effect$flash(
												$author$project$HubTran$Flash$success('Invoice un-ignored')),
												A2(
												$author$project$HubTran$Effect$map,
												$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
												$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.workingArea.factorInvoiceId))
											]));
								case 'UnapprovedInvoiceOutMsg':
									return $author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												$author$project$HubTran$Effect$flash(
												$author$project$HubTran$Flash$success('Invoice unapproved successfully.')),
												A2(
												$author$project$HubTran$Effect$map,
												$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
												$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.workingArea.factorInvoiceId))
											]));
								default:
									return $author$project$HubTran$Effect$none;
							}
						}();
						var baseEffect = $author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg, workingAreaEffect),
									additionalEffect,
									responseEffect
								]));
						switch (outMsg.$) {
							case 'InputDroppedOutMsg':
								var dropSide = outMsg.a;
								var $temp$remoteData = remoteData,
									$temp$msg = $author$project$Components$FactorInvoiceAuditBatchPage$DragDropMsg(
									$author$project$Components$DragDrop$DropSideMsg(dropSide)),
									$temp$model = updatedModel;
								remoteData = $temp$remoteData;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							case 'RevealCheckOutMsg':
								var checkTab = outMsg.a;
								var elementId = outMsg.b;
								var tab = function () {
									if (checkTab.$ === 'SummaryTab') {
										return $author$project$Components$FactorInvoiceAuditBatchPage$Summary;
									} else {
										return $author$project$Components$FactorInvoiceAuditBatchPage$CompletedChecks;
									}
								}();
								var _v4 = _Utils_eq(updatedModel.selectedTab, tab) ? _Utils_Tuple2(updatedModel, $author$project$HubTran$Effect$none) : A3(
									$author$project$Components$FactorInvoiceAuditBatchPage$update,
									remoteData,
									$author$project$Components$FactorInvoiceAuditBatchPage$SelectTab(tab),
									updatedModel);
								var tabbedModel = _v4.a;
								var tabEffect = _v4.b;
								return _Utils_Tuple2(
									tabbedModel,
									$author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												baseEffect,
												tabEffect,
												$author$project$HubTran$Effect$cmd(
												$author$project$Js$scrollToId(elementId))
											])));
							default:
								return _Utils_Tuple2(updatedModel, baseEffect);
						}
					case 'DocumentsBrowserMsg':
						if (msg.a.$ === 'NonHotkeyMsg') {
							switch (msg.a.a.$) {
								case 'UnapproveFromActivity':
									var _v7 = msg.a.a;
									return _Utils_Tuple2(
										model,
										A2(
											$author$project$AuditApi$factorInvoiceServiceUnapproveRemote,
											$author$project$Components$FactorInvoiceAuditBatchPage$ProcessUnapproveFromActivityResponse,
											{factorInvoiceId: model.workingArea.factorInvoiceId}));
								case 'RightClickedThumbnail':
									var selection = msg.a.a.a;
									return A2($author$project$Components$FactorInvoiceAuditBatchPage$openSecondary, selection, model);
								case 'CompareBolAndRateConClicked':
									var pair = msg.a.a.a;
									return A3($author$project$Components$FactorInvoiceAuditBatchPage$compareBolAndRateCon, remoteData, pair, model);
								case 'ExpandClicked':
									var _v8 = msg.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												splitPane: $author$project$Components$AuditSplitPane$toggleExpanded(model.splitPane)
											}),
										$author$project$HubTran$Effect$none);
								case 'PopoutClicked':
									var _v9 = msg.a.a;
									var _v10 = A2(
										$author$project$Components$AuditSplitPane$popOut,
										$author$project$Components$DocumentsBrowser$getCurrentProcessingSelection(model.documentsBrowser),
										model.splitPane);
									var splitPane = _v10.a;
									var effect = _v10.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{splitPane: splitPane}),
										effect);
								case 'LineDragStarted':
									var dragSide = msg.a.a.a;
									var $temp$remoteData = remoteData,
										$temp$msg = $author$project$Components$FactorInvoiceAuditBatchPage$DragDropMsg(
										$author$project$Components$DragDrop$DragSideMsg(dragSide)),
										$temp$model = model;
									remoteData = $temp$remoteData;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								default:
									break _v0$7;
							}
						} else {
							break _v0$7;
						}
					case 'SecondaryDocumentsBrowserMsg':
						if ((msg.a.$ === 'NonHotkeyMsg') && (msg.a.a.$ === 'CloseClicked')) {
							var _v12 = msg.a.a;
							return _Utils_Tuple2(
								$author$project$Components$FactorInvoiceAuditBatchPage$closeSecondary(model),
								$author$project$HubTran$Effect$none);
						} else {
							var secondaryMsg = msg.a;
							var _v13 = model.secondaryDocumentsBrowser;
							if (_v13.$ === 'Just') {
								var secondary = _v13.a;
								var docBrowserData = A2(
									$author$project$Forward$Remote$andThen,
									function ($) {
										return $.documentsBrowserData;
									},
									remoteData);
								var _v14 = A4($author$project$Components$DocumentsBrowser$update, docBrowserData, secondaryMsg, secondary, $author$project$Components$DocumentsBrowser$noHooks);
								var updatedSecondary = _v14.a;
								var secondaryEffect = _v14.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											secondaryDocumentsBrowser: $elm$core$Maybe$Just(updatedSecondary)
										}),
									A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditBatchPage$SecondaryDocumentsBrowserMsg, secondaryEffect));
							} else {
								return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
							}
						}
					case 'DocumentGroupLoaded':
						if (msg.a.$ === 'Ok') {
							var group = msg.a.a;
							var _v15 = group.factorInvoiceId;
							if (_v15.$ === 'Just') {
								var factorInvoiceId = _v15.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{pendingInvoiceGroupId: $elm$core$Maybe$Nothing, selectedTab: $author$project$Components$FactorInvoiceAuditBatchPage$Summary}),
									$author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												A2(
												$author$project$HubTran$Effect$fetchFromCache,
												$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaReinitialized(factorInvoiceId),
												A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Components$FactorInvoiceAuditWorkingArea$loadInitData)),
												$author$project$HubTran$Effect$replaceUrl(
												$author$project$Path$toString(
													A4($author$project$Path$factorInvoiceAuditBatch, model.documentBatchId, model.emailMessageId, factorInvoiceId, model.onDone)))
											])));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											pendingInvoiceGroupId: $author$project$Components$DocumentsBrowser$selectedDocumentGroupId(model.documentsBrowser),
											selectedTab: $author$project$Components$FactorInvoiceAuditBatchPage$Summary
										}),
									$author$project$HubTran$Effect$none);
							}
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'FactorInvoiceCreated':
						var _v16 = model.pendingInvoiceGroupId;
						if (_v16.$ === 'Just') {
							var groupId = _v16.a;
							return _Utils_Tuple2(
								model,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$documentGroup),
											$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$documentV2),
											A2(
											$author$project$HubTran$Effect$fetchFromCache,
											$author$project$Components$FactorInvoiceAuditBatchPage$DocumentGroupLoaded,
											A2($author$project$Forward$Lookup$startFrom, groupId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup))
										])));
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'SplitPaneMsg':
						var splitPaneMsg = msg.a;
						var _v17 = A2($author$project$Components$AuditSplitPane$update, splitPaneMsg, model.splitPane);
						var splitPane = _v17.a;
						var effect = _v17.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{splitPane: splitPane}),
							A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditBatchPage$SplitPaneMsg, effect));
					case 'DragDropMsg':
						var dragDropMsg = msg.a;
						var _v18 = A2($author$project$Components$DragDrop$update, dragDropMsg, model.dragDrop);
						var dragDrop = _v18.a;
						var outMsg = _v18.b;
						if (outMsg.$ === 'Dropped') {
							var droppedLine = outMsg.a.a;
							var target = outMsg.b;
							var $temp$remoteData = remoteData,
								$temp$msg = $author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg(
								A2($author$project$Components$FactorInvoiceAuditWorkingArea$valueDropped, target, droppedLine.chars)),
								$temp$model = _Utils_update(
								model,
								{dragDrop: dragDrop});
							remoteData = $temp$remoteData;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{dragDrop: dragDrop}),
								$author$project$HubTran$Effect$none);
						}
					case 'WorkingAreaReinitialized':
						if (msg.b.$ === 'Ok') {
							var factorInvoiceId = msg.a;
							var workingAreaInitData = msg.b.a;
							var _v20 = A5(
								$author$project$Components$FactorInvoiceAuditWorkingArea$init,
								factorInvoiceId,
								model.emailMessageId,
								model.workingArea.onDone,
								$elm$core$Maybe$Just(model.documentBatchId),
								workingAreaInitData);
							var workingArea = _v20.a;
							var workingAreaCmd = _v20.b;
							return _Utils_Tuple2(
								$author$project$Components$FactorInvoiceAuditBatchPage$closeSecondary(
									_Utils_update(
										model,
										{workingArea: workingArea})),
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$cmd(
											A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg, workingAreaCmd)),
											A2(
											$author$project$AuditApi$factorInvoiceServicePageLoadedRemote,
											$author$project$Components$FactorInvoiceAuditBatchPage$PageLoadedResponse,
											{factorInvoiceId: factorInvoiceId})
										])));
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'PageLoadedResponse':
						if (msg.a.$ === 'Success') {
							return _Utils_Tuple2(
								model,
								$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.workingArea.factorInvoiceId));
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'InitialGroupResolved':
						if ((msg.a.$ === 'Ok') && (msg.a.a.$ === 'Just')) {
							var groupId = msg.a.a.a;
							var selection = A2($author$project$Broker$Shared$CurrentProcessingSelection$groupedDocumentBatch, model.documentBatchId, groupId);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										documentsBrowser: A2($author$project$Components$DocumentsBrowser$setCurrentProcessingSelection, selection, model.documentsBrowser)
									}),
								$author$project$Components$AuditSplitPane$offerSelection(selection));
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'BatchGroupResolved':
						if (msg.a.$ === 'Ok') {
							if (msg.a.a.$ === 'Just') {
								var factorInvoiceId = msg.a.a.a;
								return _Utils_eq(factorInvoiceId, model.workingArea.factorInvoiceId) ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
									model,
									$author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												A2(
												$author$project$HubTran$Effect$fetchFromCache,
												$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaReinitialized(factorInvoiceId),
												A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Components$FactorInvoiceAuditWorkingArea$loadInitData)),
												A2(
												$author$project$HubTran$Effect$fetchFromCache,
												$author$project$Components$FactorInvoiceAuditBatchPage$InitialGroupResolved,
												A2(
													$author$project$Forward$Lookup$startFrom,
													factorInvoiceId,
													A2(
														$author$project$Forward$Lookup$map,
														$author$project$Components$FactorInvoiceAuditBatchPage$initialGroupWithinBatch(model.documentBatchId),
														$author$project$Forward$Lookup$waitForAllList(
															A2($author$project$Forward$Lookup$traverse, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceToDocuments, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice))))),
												A2(
												$author$project$HubTran$Effect$fetchFromCache,
												$author$project$Components$FactorInvoiceAuditBatchPage$HasMoreGroupsResolved,
												A2($author$project$Components$FactorInvoiceAuditBatchResolver$resolveHasMoreGroups, factorInvoiceId, model.documentBatchId)),
												A2(
												$author$project$HubTran$Effect$fetchFromCache,
												$author$project$Components$FactorInvoiceAuditBatchPage$ProcessedCountResolved,
												A2($author$project$Components$FactorInvoiceAuditBatchResolver$resolveProcessedCount, factorInvoiceId, model.documentBatchId)),
												$author$project$HubTran$Effect$replaceUrl(
												$author$project$Path$toString(
													A4($author$project$Path$factorInvoiceAuditBatch, model.documentBatchId, model.emailMessageId, factorInvoiceId, model.onDone)))
											])));
							} else {
								var _v21 = msg.a.a;
								return _Utils_Tuple2(
									model,
									$author$project$HubTran$Effect$load(
										$author$project$Components$FactorInvoiceAuditBatchPage$onDoneUrl(model)));
							}
						} else {
							return _Utils_Tuple2(
								model,
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert('Couldn\u0027t load the rest of this batch. Reload the page to continue.')));
						}
					case 'GroupCompleted':
						return _Utils_Tuple2(
							model,
							$author$project$Components$FactorInvoiceAuditBatchPage$advanceToNextIncomplete(model));
					case 'HasMoreGroupsResolved':
						if (msg.a.$ === 'Ok') {
							var hasMoreGroups = msg.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										hasMoreGroups: $elm$core$Maybe$Just(hasMoreGroups)
									}),
								$author$project$HubTran$Effect$none);
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'ProcessedCountResolved':
						if (msg.a.$ === 'Ok') {
							var count = msg.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										processedCount: $elm$core$Maybe$Just(count)
									}),
								$author$project$HubTran$Effect$none);
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'SelectTab':
						var tab = msg.a;
						var reloadEffect = function () {
							switch (tab.$) {
								case 'Summary':
									return A2(
										$author$project$HubTran$Effect$map,
										$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
										$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.workingArea.factorInvoiceId));
								case 'CompletedChecks':
									return A2(
										$author$project$HubTran$Effect$map,
										$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
										$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.workingArea.factorInvoiceId));
								case 'Details':
									return $author$project$HubTran$Effect$none;
								default:
									return $author$project$HubTran$Effect$none;
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{selectedTab: tab}),
							reloadEffect);
					case 'PresenceMsg':
						var subMsg = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									presence: A2($author$project$Presence$update, subMsg, model.presence)
								}),
							$author$project$HubTran$Effect$none);
					case 'ClientNotesPanelMsg':
						var subMsg = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									clientNotesPanel: A2($author$project$Components$FactorInvoiceClientNotesPanel$update, subMsg, model.clientNotesPanel)
								}),
							$author$project$HubTran$Effect$none);
					case 'PacketComparisonMsg':
						var subMsg = msg.a;
						var _v23 = A2($author$project$Components$FactorInvoiceAuditPacketComparison$update, subMsg, model.packetComparison);
						var packetComparison = _v23.a;
						var cmd = _v23.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{packetComparison: packetComparison}),
							$author$project$HubTran$Effect$cmd(
								A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditBatchPage$PacketComparisonMsg, cmd)));
					case 'CloseSendToCarrierModal':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sendToCarrierModalOpen: false}),
							$author$project$HubTran$Effect$none);
					case 'ExceptionSent':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sendToCarrierModalOpen: false}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Email sent')),
										$author$project$Components$FactorInvoiceAuditBatchPage$advanceToNextIncomplete(model)
									])));
					case 'CanMergeResolved':
						if (msg.a.$ === 'Ok') {
							var canMerge = msg.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										canMerge: $elm$core$Maybe$Just(canMerge)
									}),
								$author$project$HubTran$Effect$none);
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'OpenMergeEmailModal':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									activeHeaderModal: $elm$core$Maybe$Just($author$project$Components$FactorInvoiceAuditBatchPage$MergeEmail)
								}),
							$author$project$HubTran$Effect$none);
					case 'CloseMergeEmailModal':
						return _Utils_Tuple2(
							$author$project$Components$FactorInvoiceAuditBatchPage$closeHeaderModal(model),
							$author$project$HubTran$Effect$none);
					case 'MergeEmailComplete':
						return _Utils_Tuple2(
							$author$project$Components$FactorInvoiceAuditBatchPage$closeHeaderModal(model),
							$author$project$HubTran$Effect$load(
								$author$project$Components$FactorInvoiceAuditBatchPage$onDoneUrl(model)));
					case 'OpenIgnoreAllGroupsModal':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									activeHeaderModal: $elm$core$Maybe$Just($author$project$Components$FactorInvoiceAuditBatchPage$IgnoreAllGroups)
								}),
							$author$project$HubTran$Effect$none);
					case 'CloseIgnoreAllGroupsModal':
						return _Utils_Tuple2(
							$author$project$Components$FactorInvoiceAuditBatchPage$closeHeaderModal(model),
							$author$project$HubTran$Effect$none);
					case 'IgnoreAllGroupsComplete':
						return _Utils_Tuple2(
							$author$project$Components$FactorInvoiceAuditBatchPage$closeHeaderModal(model),
							$author$project$HubTran$Effect$load(
								$author$project$Components$FactorInvoiceAuditBatchPage$onDoneUrl(model)));
					case 'OpenForwardEmailModal':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									activeHeaderModal: $elm$core$Maybe$Just($author$project$Components$FactorInvoiceAuditBatchPage$ForwardEmail)
								}),
							$author$project$HubTran$Effect$none);
					case 'CloseForwardEmailModal':
						return _Utils_Tuple2(
							$author$project$Components$FactorInvoiceAuditBatchPage$closeHeaderModal(model),
							$author$project$HubTran$Effect$none);
					case 'ForwardEmailDone':
						var completed = msg.a;
						return completed ? _Utils_Tuple2(
							$author$project$Components$FactorInvoiceAuditBatchPage$closeHeaderModal(model),
							$author$project$HubTran$Effect$load(
								$author$project$Components$FactorInvoiceAuditBatchPage$onDoneUrl(model))) : _Utils_Tuple2(
							$author$project$Components$FactorInvoiceAuditBatchPage$closeHeaderModal(model),
							$author$project$HubTran$Effect$none);
					case 'NavigateToGrouping':
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$pushUrl(
								$author$project$Path$toString(
									A2($author$project$Path$factorInvoiceAuditBatchGrouping, model.documentBatchId, model.workingArea.onDone))));
					default:
						switch (msg.a.$) {
							case 'Success':
								var unapproveResponse = msg.a.a;
								var _v24 = unapproveResponse.outcome;
								if (_v24.$ === 'FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUnapproveSuccess') {
									var _v25 = $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(model.workingArea);
									var workingArea = _v25.a;
									var refreshEffect = _v25.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{workingArea: workingArea}),
										$author$project$HubTran$Effect$batch(
											_List_fromArray(
												[
													$author$project$HubTran$Effect$flash(
													$author$project$HubTran$Flash$success('Invoice unapproved successfully.')),
													A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg, refreshEffect)
												])));
								} else {
									var err = _v24.a;
									return _Utils_Tuple2(
										model,
										$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$alert(err.message)));
								}
							case 'Failure':
								return _Utils_Tuple2(
									model,
									$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$alert('Failed to unapprove invoice. Please try again.')));
							default:
								return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
				}
			}
			var documentsBrowserMsg = msg.a;
			var previousGroupId = $author$project$Components$DocumentsBrowser$selectedDocumentGroupId(model.documentsBrowser);
			var docBrowserData = A2(
				$author$project$Forward$Remote$andThen,
				function ($) {
					return $.documentsBrowserData;
				},
				remoteData);
			var _v11 = A4(
				$author$project$Components$DocumentsBrowser$update,
				docBrowserData,
				documentsBrowserMsg,
				model.documentsBrowser,
				$author$project$Components$FactorInvoiceAuditBatchPage$podRefreshHooks(model.workingArea.factorInvoiceId));
			var documentsBrowser = _v11.a;
			var documentsBrowserEffect = _v11.b;
			var newGroupId = $author$project$Components$DocumentsBrowser$selectedDocumentGroupId(documentsBrowser);
			var groupChangedEffect = (!_Utils_eq(newGroupId, previousGroupId)) ? A2(
				$elm$core$Maybe$withDefault,
				$author$project$HubTran$Effect$none,
				A2(
					$elm$core$Maybe$map,
					function (id) {
						return A2(
							$author$project$HubTran$Effect$fetchFromCache,
							$author$project$Components$FactorInvoiceAuditBatchPage$DocumentGroupLoaded,
							A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$documentGroup));
					},
					newGroupId)) : $author$project$HubTran$Effect$none;
			var splitPane = (documentsBrowser.documentTypePickerOpen && (!model.documentsBrowser.documentTypePickerOpen)) ? $author$project$Components$AuditSplitPane$collapse(model.splitPane) : model.splitPane;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{documentsBrowser: documentsBrowser, splitPane: splitPane}),
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[
							A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditBatchPage$DocumentsBrowserMsg, documentsBrowserEffect),
							groupChangedEffect
						])));
		}
	});
var $author$project$Components$FactorInvoiceAuditPage$CompletedChecks = {$: 'CompletedChecks'};
var $author$project$Components$FactorInvoiceAuditPage$DragDropMsg = function (a) {
	return {$: 'DragDropMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$PacketComparisonMsg = function (a) {
	return {$: 'PacketComparisonMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$ProcessUnapproveFromActivityResponse = function (a) {
	return {$: 'ProcessUnapproveFromActivityResponse', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$SelectTab = function (a) {
	return {$: 'SelectTab', a: a};
};
var $author$project$Components$FactorInvoiceAuditPage$closeSecondary = function (model) {
	return _Utils_update(
		model,
		{
			documentsBrowser: A2($author$project$Components$DocumentsBrowser$setAddressMarks, false, model.documentsBrowser),
			secondaryDocumentsBrowser: $elm$core$Maybe$Nothing
		});
};
var $author$project$Components$FactorInvoiceAuditPage$navigateWithFlash = F2(
	function (message, onDone) {
		var path = function () {
			if (onDone.$ === 'Just') {
				var p = onDone.a;
				return $elm$core$String$isEmpty(p) ? '/app/' : p;
			} else {
				return '/app/';
			}
		}();
		var targetUrl = A2($elm$core$String$startsWith, '/flow', path) ? ('/app' + path) : path;
		return $author$project$HubTran$Effect$batch(
			_List_fromArray(
				[
					$author$project$HubTran$Effect$flash(
					$author$project$HubTran$Flash$success(message)),
					$author$project$HubTran$Effect$load(targetUrl)
				]));
	});
var $author$project$Components$FactorInvoiceAuditPage$openSecondary = F2(
	function (selection, model) {
		var _v0 = $author$project$Components$DocumentsBrowser$init(
			{
				currentProcessingSelection: $author$project$Broker$Shared$CurrentProcessingSelection$factorInvoice(model.factorInvoiceId),
				displayUnassignedLoadDocuments: false,
				enabledDocumentTypes: _List_Nil,
				enabledToolbarActions: _List_Nil,
				maybeDefaultViewMode: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$DefaultViewModeWidth),
				maybeOnDone: model.onDone,
				pageContextData: $author$project$Helpers$DocumentViewerPageContextData$empty,
				popout: false,
				scrollContainerSuffix: 'secondary',
				viewPortHeightPxOffset: 0
			});
		var secondary = _v0.a;
		var secondaryEffect = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					documentsBrowser: A2($author$project$Components$DocumentsBrowser$setAddressMarks, model.usesVectorWorkflow, model.documentsBrowser),
					secondaryDocumentsBrowser: $elm$core$Maybe$Just(
						A2(
							$author$project$Components$DocumentsBrowser$setAddressMarks,
							model.usesVectorWorkflow,
							A2($author$project$Components$DocumentsBrowser$setSelection, selection, secondary))),
					splitPane: $author$project$Components$AuditSplitPane$collapse(model.splitPane)
				}),
			A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditPage$SecondaryDocumentsBrowserMsg, secondaryEffect));
	});
var $author$project$Components$FactorInvoiceAuditPage$podRefreshHooks = function (factorInvoiceId) {
	var hooks = $author$project$Components$DocumentsBrowser$noHooks;
	return _Utils_update(
		hooks,
		{
			onMarkIllegibleFinished: $elm$core$Maybe$Just(
				function (_v0) {
					return $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(factorInvoiceId);
				}),
			onUpdateDocumentTypeFinished: $elm$core$Maybe$Just(
				F2(
					function (_v1, _v2) {
						return $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(factorInvoiceId);
					})),
			onUpdatePodFinished: $elm$core$Maybe$Just(
				function (_v3) {
					return $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(factorInvoiceId);
				})
		});
};
var $author$project$Components$FactorInvoiceAuditPage$compareBolAndRateCon = F3(
	function (remoteData, _v23, model) {
		var rateCon = _v23.rateCon;
		var bol = _v23.bol;
		var _v24 = $author$project$Forward$Remote$toMaybe(
			A2(
				$author$project$Forward$Remote$andThen,
				function ($) {
					return $.documentsBrowserData;
				},
				remoteData));
		if (_v24.$ === 'Just') {
			var documentsBrowserData = _v24.a;
			var _v25 = A3(
				$author$project$Components$FactorInvoiceAuditPage$update,
				remoteData,
				$author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg(
					A3($author$project$Components$DocumentsBrowser$selectDocumentMsg, documentsBrowserData, model.documentsBrowser, rateCon)),
				model);
			var selectedModel = _v25.a;
			var selectEffect = _v25.b;
			var _v26 = A2($author$project$Components$FactorInvoiceAuditPage$openSecondary, bol, selectedModel);
			var openedModel = _v26.a;
			var openEffect = _v26.b;
			return _Utils_Tuple2(
				openedModel,
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[selectEffect, openEffect])));
		} else {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$FactorInvoiceAuditPage$update = F3(
	function (remoteData, msg, model) {
		update:
		while (true) {
			_v0$8:
			while (true) {
				switch (msg.$) {
					case 'WorkingAreaMsg':
						var workingAreaMsg = msg.a;
						var workingAreaData = A2(
							$author$project$Forward$Remote$andThen,
							function ($) {
								return $.workingArea;
							},
							remoteData);
						var documentsBrowserData = A2(
							$author$project$Forward$Remote$andThen,
							function ($) {
								return $.documentsBrowserData;
							},
							remoteData);
						var _v1 = A3($author$project$Components$FactorInvoiceAuditWorkingArea$update, workingAreaData, workingAreaMsg, model.workingArea);
						var newWorkingArea = _v1.a;
						var workingAreaEffect = _v1.b;
						var outMsg = _v1.c;
						var _v2 = A3(
							$author$project$Components$FactorInvoiceAudit$WorkingAreaEffectHandler$applyOutMsg,
							documentsBrowserData,
							outMsg,
							{documentsBrowser: model.documentsBrowser, packetComparison: model.packetComparison, sendToCarrierModalOpen: model.sendToCarrierModalOpen});
						var response = _v2.a;
						var responseEffect = _v2.b;
						var updatedModel = _Utils_update(
							model,
							{documentsBrowser: response.documentsBrowser, packetComparison: response.packetComparison, sendToCarrierModalOpen: response.sendToCarrierModalOpen, workingArea: newWorkingArea});
						var additionalEffect = function () {
							switch (outMsg.$) {
								case 'ProcessedOutMsg':
									return A2($author$project$Components$FactorInvoiceAuditPage$navigateWithFlash, 'Invoice processed', model.workingArea.onDone);
								case 'SavedAsIncompleteOutMsg':
									return A2($author$project$Components$FactorInvoiceAuditPage$navigateWithFlash, 'Saved as incomplete', model.workingArea.onDone);
								case 'IgnoredInvoiceOutMsg':
									return A2($author$project$Components$FactorInvoiceAuditPage$navigateWithFlash, 'Invoice ignored', model.workingArea.onDone);
								case 'RejectOutMsg':
									return $author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Invoice rejected'));
								case 'RevivedInvoiceOutMsg':
									return $author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Invoice un-ignored'));
								case 'UnapprovedInvoiceOutMsg':
									return $author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												$author$project$HubTran$Effect$flash(
												$author$project$HubTran$Flash$success('Invoice unapproved successfully.')),
												A2(
												$author$project$HubTran$Effect$map,
												$author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg,
												$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.workingArea.factorInvoiceId))
											]));
								default:
									return $author$project$HubTran$Effect$none;
							}
						}();
						var baseEffect = $author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg, workingAreaEffect),
									additionalEffect,
									responseEffect
								]));
						switch (outMsg.$) {
							case 'InputDroppedOutMsg':
								var dropSide = outMsg.a;
								var $temp$remoteData = remoteData,
									$temp$msg = $author$project$Components$FactorInvoiceAuditPage$DragDropMsg(
									$author$project$Components$DragDrop$DropSideMsg(dropSide)),
									$temp$model = updatedModel;
								remoteData = $temp$remoteData;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							case 'SetDocumentTypeOutMsg':
								var documentId = outMsg.a;
								var documentType = outMsg.b;
								var _v4 = A3(
									$author$project$Components$FactorInvoiceAuditPage$update,
									remoteData,
									$author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg(
										$author$project$Components$DocumentsBrowser$NonHotkeyMsg(
											A2($author$project$Components$DocumentsBrowser$UpdateDocumentType, documentId, documentType))),
									updatedModel);
								var typedModel = _v4.a;
								var typeEffect = _v4.b;
								return _Utils_Tuple2(
									typedModel,
									$author$project$HubTran$Effect$batch(
										_List_fromArray(
											[baseEffect, typeEffect])));
							case 'RevealCheckOutMsg':
								var checkTab = outMsg.a;
								var elementId = outMsg.b;
								var tab = function () {
									if (checkTab.$ === 'SummaryTab') {
										return $author$project$Components$FactorInvoiceAuditPage$Summary;
									} else {
										return $author$project$Components$FactorInvoiceAuditPage$CompletedChecks;
									}
								}();
								var _v5 = _Utils_eq(updatedModel.selectedTab, tab) ? _Utils_Tuple2(updatedModel, $author$project$HubTran$Effect$none) : A3(
									$author$project$Components$FactorInvoiceAuditPage$update,
									remoteData,
									$author$project$Components$FactorInvoiceAuditPage$SelectTab(tab),
									updatedModel);
								var tabbedModel = _v5.a;
								var tabEffect = _v5.b;
								return _Utils_Tuple2(
									tabbedModel,
									$author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												baseEffect,
												tabEffect,
												$author$project$HubTran$Effect$cmd(
												$author$project$Js$scrollToId(elementId))
											])));
							default:
								return _Utils_Tuple2(updatedModel, baseEffect);
						}
					case 'SelectTab':
						var tab = msg.a;
						var reloadEffect = function () {
							switch (tab.$) {
								case 'Summary':
									return A2(
										$author$project$HubTran$Effect$map,
										$author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg,
										$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.workingArea.factorInvoiceId));
								case 'CompletedChecks':
									return A2(
										$author$project$HubTran$Effect$map,
										$author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg,
										$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.workingArea.factorInvoiceId));
								case 'Details':
									return $author$project$HubTran$Effect$none;
								default:
									return $author$project$HubTran$Effect$none;
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{selectedTab: tab}),
							reloadEffect);
					case 'DocumentsBrowserMsg':
						if (msg.a.$ === 'NonHotkeyMsg') {
							switch (msg.a.a.$) {
								case 'UnapproveFromActivity':
									var _v9 = msg.a.a;
									return _Utils_Tuple2(
										model,
										A2(
											$author$project$AuditApi$factorInvoiceServiceUnapproveRemote,
											$author$project$Components$FactorInvoiceAuditPage$ProcessUnapproveFromActivityResponse,
											{factorInvoiceId: model.workingArea.factorInvoiceId}));
								case 'RightClickedThumbnail':
									var selection = msg.a.a.a;
									return A2($author$project$Components$FactorInvoiceAuditPage$openSecondary, selection, model);
								case 'CompareBolAndRateConClicked':
									var pair = msg.a.a.a;
									return A3($author$project$Components$FactorInvoiceAuditPage$compareBolAndRateCon, remoteData, pair, model);
								case 'ExpandClicked':
									var _v10 = msg.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												splitPane: $author$project$Components$AuditSplitPane$toggleExpanded(model.splitPane)
											}),
										$author$project$HubTran$Effect$none);
								case 'PopoutClicked':
									var _v11 = msg.a.a;
									var _v12 = A2(
										$author$project$Components$AuditSplitPane$popOut,
										$author$project$Components$DocumentsBrowser$getCurrentProcessingSelection(model.documentsBrowser),
										model.splitPane);
									var splitPane = _v12.a;
									var effect = _v12.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{splitPane: splitPane}),
										effect);
								case 'LineDragStarted':
									var dragSide = msg.a.a.a;
									var $temp$remoteData = remoteData,
										$temp$msg = $author$project$Components$FactorInvoiceAuditPage$DragDropMsg(
										$author$project$Components$DragDrop$DragSideMsg(dragSide)),
										$temp$model = model;
									remoteData = $temp$remoteData;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								default:
									break _v0$8;
							}
						} else {
							break _v0$8;
						}
					case 'SecondaryDocumentsBrowserMsg':
						if ((msg.a.$ === 'NonHotkeyMsg') && (msg.a.a.$ === 'CloseClicked')) {
							var _v14 = msg.a.a;
							return _Utils_Tuple2(
								$author$project$Components$FactorInvoiceAuditPage$closeSecondary(model),
								$author$project$HubTran$Effect$none);
						} else {
							var secondaryMsg = msg.a;
							var _v15 = model.secondaryDocumentsBrowser;
							if (_v15.$ === 'Just') {
								var secondary = _v15.a;
								var docBrowserData = A2(
									$author$project$Forward$Remote$andThen,
									function ($) {
										return $.documentsBrowserData;
									},
									remoteData);
								var _v16 = A4($author$project$Components$DocumentsBrowser$update, docBrowserData, secondaryMsg, secondary, $author$project$Components$DocumentsBrowser$noHooks);
								var updatedSecondary = _v16.a;
								var secondaryEffect = _v16.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											secondaryDocumentsBrowser: $elm$core$Maybe$Just(updatedSecondary)
										}),
									A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditPage$SecondaryDocumentsBrowserMsg, secondaryEffect));
							} else {
								return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
							}
						}
					case 'PacketComparisonMsg':
						var subMsg = msg.a;
						var _v17 = A2($author$project$Components$FactorInvoiceAuditPacketComparison$update, subMsg, model.packetComparison);
						var packetComparison = _v17.a;
						var cmd = _v17.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{packetComparison: packetComparison}),
							$author$project$HubTran$Effect$cmd(
								A2($elm$core$Platform$Cmd$map, $author$project$Components$FactorInvoiceAuditPage$PacketComparisonMsg, cmd)));
					case 'CloseSendToCarrierModal':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sendToCarrierModalOpen: false}),
							$author$project$HubTran$Effect$none);
					case 'ExceptionSent':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sendToCarrierModalOpen: false}),
							A2($author$project$Components$FactorInvoiceAuditPage$navigateWithFlash, 'Email sent', model.workingArea.onDone));
					case 'PresenceMsg':
						var subMsg = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									presence: A2($author$project$Presence$update, subMsg, model.presence)
								}),
							$author$project$HubTran$Effect$none);
					case 'PageLoadedResponse':
						if (msg.a.$ === 'Success') {
							return _Utils_Tuple2(
								model,
								$author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditDataEffect(model.factorInvoiceId));
						} else {
							return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
					case 'ClientNotesPanelMsg':
						var subMsg = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									clientNotesPanel: A2($author$project$Components$FactorInvoiceClientNotesPanel$update, subMsg, model.clientNotesPanel)
								}),
							$author$project$HubTran$Effect$none);
					case 'SplitPaneMsg':
						var splitPaneMsg = msg.a;
						var _v18 = A2($author$project$Components$AuditSplitPane$update, splitPaneMsg, model.splitPane);
						var splitPane = _v18.a;
						var effect = _v18.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{splitPane: splitPane}),
							A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditPage$SplitPaneMsg, effect));
					case 'DragDropMsg':
						var dragDropMsg = msg.a;
						var _v19 = A2($author$project$Components$DragDrop$update, dragDropMsg, model.dragDrop);
						var dragDrop = _v19.a;
						var outMsg = _v19.b;
						if (outMsg.$ === 'Dropped') {
							var droppedLine = outMsg.a.a;
							var target = outMsg.b;
							var $temp$remoteData = remoteData,
								$temp$msg = $author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg(
								A2($author$project$Components$FactorInvoiceAuditWorkingArea$valueDropped, target, droppedLine.chars)),
								$temp$model = _Utils_update(
								model,
								{dragDrop: dragDrop});
							remoteData = $temp$remoteData;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{dragDrop: dragDrop}),
								$author$project$HubTran$Effect$none);
						}
					default:
						switch (msg.a.$) {
							case 'Success':
								var unapproveResponse = msg.a.a;
								var _v21 = unapproveResponse.outcome;
								if (_v21.$ === 'FactorInvoiceServiceUnapproveResponse_Outcome_FactorInvoiceServiceUnapproveSuccess') {
									var _v22 = $author$project$Components$FactorInvoiceAuditWorkingArea$refreshAuditData(model.workingArea);
									var workingArea = _v22.a;
									var refreshEffect = _v22.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{workingArea: workingArea}),
										$author$project$HubTran$Effect$batch(
											_List_fromArray(
												[
													$author$project$HubTran$Effect$flash(
													$author$project$HubTran$Flash$success('Invoice unapproved successfully.')),
													A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg, refreshEffect)
												])));
								} else {
									var err = _v21.a;
									return _Utils_Tuple2(
										model,
										$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$alert(err.message)));
								}
							case 'Failure':
								return _Utils_Tuple2(
									model,
									$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$alert('Failed to unapprove invoice. Please try again.')));
							default:
								return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
						}
				}
			}
			var documentsBrowserMsg = msg.a;
			var docBrowserData = A2(
				$author$project$Forward$Remote$andThen,
				function ($) {
					return $.documentsBrowserData;
				},
				remoteData);
			var _v13 = A4(
				$author$project$Components$DocumentsBrowser$update,
				docBrowserData,
				documentsBrowserMsg,
				model.documentsBrowser,
				$author$project$Components$FactorInvoiceAuditPage$podRefreshHooks(model.workingArea.factorInvoiceId));
			var documentsBrowser = _v13.a;
			var documentsBrowserEffect = _v13.b;
			var splitPane = (documentsBrowser.documentTypePickerOpen && (!model.documentsBrowser.documentTypePickerOpen)) ? $author$project$Components$AuditSplitPane$collapse(model.splitPane) : model.splitPane;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{documentsBrowser: documentsBrowser, splitPane: splitPane}),
				A2($author$project$HubTran$Effect$map, $author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg, documentsBrowserEffect));
		}
	});
var $author$project$Components$LtlHeldSubmissionsPage$ProcessImportToQueueButtonClickResponse = function (a) {
	return {$: 'ProcessImportToQueueButtonClickResponse', a: a};
};
var $author$project$AuditPb$DashboardUpdateEvent_LtlPayablesCarrierInvoiceSubmissionImport = F3(
	function (id, importState, proNumber) {
		return {id: id, importState: importState, proNumber: proNumber};
	});
var $author$project$AuditPb$dashboardUpdateEvent_LtlPayablesCarrierInvoiceSubmissionImportDecoder = $elm$json$Json$Decode$lazy(
	function (_v0) {
		return A3(
			$author$project$AuditPb$optional,
			'proNumber',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$AuditPb$requiredWithoutDefault,
				'importState',
				$author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateDecoder,
				A3(
					$author$project$AuditPb$requiredWithoutDefault,
					'id',
					A2($elm$json$Json$Decode$map, $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$fromInt, $author$project$AuditPb$intDecoder),
					$author$project$AuditPb$decode($author$project$AuditPb$DashboardUpdateEvent_LtlPayablesCarrierInvoiceSubmissionImport))));
	});
var $author$project$Components$LtlHeldSubmissionsPage$errorMessage = function (maybeProNumber) {
	var message = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'EDI could not be imported, try again.',
		function (pro) {
			return 'EDI for Pro ' + (pro + ' could not be imported, try again.');
		},
		maybeProNumber);
	return {
		indefinite: false,
		level: 'alert',
		message: message,
		position: 'bottom',
		time: $elm$core$Maybe$Nothing,
		title: $elm$core$Maybe$Just('Failed to import')
	};
};
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmission_DocumentEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'documentType', $author$project$AuditPb$documentTypeEncoder, v.documentType)
				])));
};
var $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$toInt),
					v.id),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'receivedDate', $author$project$AuditPb$timestampEncoder, v.receivedDate),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'importState', $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionImportStateEncoder, v.importState),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'loadStateId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$LoadStateId$toInt),
					v.loadStateId),
					A3($author$project$AuditPb$optionalEncoder, 'proNumber', $elm$json$Json$Encode$string, v.proNumber),
					A3($author$project$AuditPb$optionalEncoder, 'scac', $elm$json$Json$Encode$string, v.scac),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'tmsCarrierId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCarrierId$toInt),
					v.tmsCarrierId),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'documents', $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmission_DocumentEncoder, v.documents)
				])));
};
var $author$project$AuditApi$ltlPayablesCarrierInvoiceSubmissionServiceImportToQueueWithState = A3($author$project$AuditApi$toRequestState, '/ltl_payables_carrier_invoice_submission_service/import_to_queue', $author$project$AuditPb$ltlPayablesCarrierInvoiceSubmissionEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$Components$LtlHeldSubmissionsPage$notificationMessage = {
	indefinite: false,
	level: 'notification',
	message: 'This may take a few minutes, check the activities page to review import outcome.',
	position: 'bottom',
	time: $elm$core$Maybe$Nothing,
	title: $elm$core$Maybe$Just('Import in progress')
};
var $author$project$Components$LtlHeldSubmissionsPage$successMessage = function (maybeProNumber) {
	var message = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'EDI has been successfully imported.',
		function (pro) {
			return 'EDI for Pro ' + (pro + ' has been successfully imported.');
		},
		maybeProNumber);
	return {
		indefinite: false,
		level: 'success',
		message: message,
		position: 'bottom',
		time: $elm$core$Maybe$Nothing,
		title: $elm$core$Maybe$Just('Import complete')
	};
};
var $author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$toComparable = function (id) {
	return _Utils_Tuple2(
		'ltlPayablesCarrierInvoiceSubmissionId',
		$author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$toInt(id));
};
var $author$project$Components$LtlHeldSubmissionsPage$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'ImportToQueueButtonClick':
				var submission = msg.a;
				return A3(
					$author$project$AuditApi$ltlPayablesCarrierInvoiceSubmissionServiceImportToQueueWithState,
					_Utils_update(
						model,
						{
							importsInProgress: A2(
								$elm$core$Set$insert,
								$author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$toComparable(submission.id),
								model.importsInProgress)
						}),
					$author$project$Components$LtlHeldSubmissionsPage$ProcessImportToQueueButtonClickResponse,
					submission);
			case 'ImportFinished':
				var json = msg.a;
				var _v1 = _Utils_Tuple2(
					$author$project$Forward$Remote$toMaybe(data),
					A2($elm$json$Json$Decode$decodeValue, $author$project$AuditPb$dashboardUpdateEvent_LtlPayablesCarrierInvoiceSubmissionImportDecoder, json));
				if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Ok')) {
					var data_ = _v1.a.a;
					var decodedUpdate = _v1.b.a;
					var isUpdateForThisPage = A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.submission;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.id;
								},
								$elm$core$Basics$eq(decodedUpdate.id))),
						$author$project$Pagination$entries(data_.ltlPayablesCarrierInvoiceSubmissions));
					var flashSuccessAndRefreshThePage = _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$invalidateAll,
									$author$project$HubTran$Effect$cmd(
									$author$project$Js$flashToJavascriptV3Reskin(
										$author$project$Components$LtlHeldSubmissionsPage$successMessage(decodedUpdate.proNumber)))
								])));
					var flashFailureAndReenableImportButton = _Utils_Tuple2(
						_Utils_update(
							model,
							{
								importsInProgress: A2(
									$elm$core$Set$remove,
									$author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$toComparable(decodedUpdate.id),
									model.importsInProgress)
							}),
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$flashToJavascriptV3Reskin(
								$author$project$Components$LtlHeldSubmissionsPage$errorMessage(decodedUpdate.proNumber))));
					if (isUpdateForThisPage) {
						var _v2 = decodedUpdate.importState;
						if (_v2.$ === 'LtlPayablesCarrierInvoiceSubmissionImportStateSentToImport') {
							return flashSuccessAndRefreshThePage;
						} else {
							return flashFailureAndReenableImportButton;
						}
					} else {
						return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					}
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'ProcessImportToQueueButtonClickResponse':
				var response = msg.a;
				return A3(
					$author$project$AuditApi$applyRequest,
					model,
					response,
					F2(
						function (model_, _v3) {
							return _Utils_Tuple2(
								model_,
								$author$project$HubTran$Effect$cmd(
									$author$project$Js$flashToJavascriptV3Reskin($author$project$Components$LtlHeldSubmissionsPage$notificationMessage)));
						}));
			case 'SetEntriesPerPage':
				var newEntriesPerPage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{entriesPerPage: newEntriesPerPage}),
					$author$project$HubTran$Effect$none);
			case 'SetPageNumber':
				var newPageNumber = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pageNumber: newPageNumber}),
					$author$project$HubTran$Effect$none);
			case 'SetSearchInput':
				var newSearchInput = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{searchInput: newSearchInput}),
					$author$project$HubTran$Effect$none);
			case 'SetSortOrder':
				var newSortOrder = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sortOrder: newSortOrder}),
					$author$project$HubTran$Effect$none);
			case 'SetTimezone':
				var timezone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{tz: timezone}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{searchTerm: model.searchInput}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$AuditPb$CarrierInvoiceSaveRequestSourceLtlReconcile = {$: 'CarrierInvoiceSaveRequestSourceLtlReconcile'};
var $author$project$Components$LtlReconcileInvoicePage$FinishReconcileInvoice = function (a) {
	return {$: 'FinishReconcileInvoice', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$FinishResolveLater = function (a) {
	return {$: 'FinishResolveLater', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$FinishedIgnore = function (a) {
	return {$: 'FinishedIgnore', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTableMsg = function (a) {
	return {$: 'InvoiceDetailsTableMsg', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTableMsg = function (a) {
	return {$: 'MismatchTableMsg', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModalMsg = function (a) {
	return {$: 'MoveToTmsModalMsg', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$dashboardOrFlowModeRedirectEffect = function (maybeOnDone) {
	var path = A2($elm$core$Maybe$withDefault, '/app/dashboard', maybeOnDone);
	return $author$project$HubTran$Effect$load(
		A2($elm$core$String$startsWith, '/flow', path) ? ('/app' + path) : path);
};
var $author$project$Money$Negative = {$: 'Negative'};
var $author$project$Money$NonNegative = {$: 'NonNegative'};
var $author$project$Money$toDollarsAndCents = function (_v0) {
	var rawCents = _v0.a;
	var positiveCents = $elm$core$Basics$abs(rawCents);
	return _Utils_Tuple3(
		(rawCents < 0) ? $author$project$Money$Negative : $author$project$Money$NonNegative,
		(positiveCents / 100) | 0,
		A2($elm$core$Basics$modBy, 100, positiveCents));
};
var $author$project$Money$dollarStringWithCommas = function (dollars) {
	var step = F2(
		function (c, _v0) {
			var count = _v0.a;
			var string = _v0.b;
			return ((count > 0) && (!A2($elm$core$Basics$modBy, 3, count))) ? _Utils_Tuple2(
				count + 1,
				A2(
					$elm$core$String$cons,
					c,
					A2(
						$elm$core$String$cons,
						_Utils_chr(','),
						string))) : _Utils_Tuple2(
				count + 1,
				A2($elm$core$String$cons, c, string));
		});
	return A3(
		$elm$core$String$foldr,
		step,
		_Utils_Tuple2(0, ''),
		$elm$core$String$fromInt(
			$elm$core$Basics$abs(dollars))).b;
};
var $author$project$Money$toStringWithoutPrefix = function (money) {
	var _v0 = $author$project$Money$toDollarsAndCents(money);
	var dollars = _v0.b;
	var cents = _v0.c;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$author$project$Money$dollarStringWithCommas(dollars),
				'.',
				A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				$elm$core$String$fromInt(cents))
			]));
};
var $author$project$Money$toString = function (money) {
	var prefix = function () {
		var _v0 = $author$project$Money$toDollarsAndCents(money);
		if (_v0.a.$ === 'NonNegative') {
			var _v1 = _v0.a;
			return '$';
		} else {
			var _v2 = _v0.a;
			return '-$';
		}
	}();
	return _Utils_ap(
		prefix,
		$author$project$Money$toStringWithoutPrefix(money));
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$itemPairToMaybeLineItemReconcileItem = F2(
	function (tmsUpdateValues, itemPair) {
		var moneyAsString = $author$project$Money$toString;
		var currentValue = A2($turboMaCk$any_dict$Dict$Any$get, itemPair, tmsUpdateValues);
		return A2(
			$elm$core$Maybe$map,
			function (loadItem) {
				return {
					carrierItemId: A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.id;
							},
							$author$project$Domain$LineItemId$toInt),
						$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair)),
					description: loadItem.description,
					loadItemId: $author$project$Domain$LineItemId$toInt(loadItem.id),
					newAmount: function () {
						if (currentValue.$ === 'Just') {
							if (currentValue.a.$ === 'UpdatingAccessorial') {
								var amount = currentValue.a.a.amount;
								return amount;
							} else {
								var _v1 = currentValue.a;
								return moneyAsString(loadItem.total);
							}
						} else {
							return moneyAsString(loadItem.total);
						}
					}(),
					oldAmount: moneyAsString(loadItem.total)
				};
			},
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair));
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$lineItemReconcileItems = F2(
	function (_v0, _v1) {
		var equalityData = _v0.equalityData;
		var tmsUpdateValuesAccessorial = _v1.tmsUpdateValuesAccessorial;
		return A2(
			$elm$core$List$filterMap,
			$author$project$Components$LtlReconcileInvoicePage$MismatchTable$itemPairToMaybeLineItemReconcileItem(tmsUpdateValuesAccessorial),
			equalityData.lineItemPairs);
	});
var $author$project$AuditPb$carrierInvoiceRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId)
				])));
};
var $author$project$AuditApi$ltlCarrierInvoiceServiceReconcileAllWithState = A3($author$project$AuditApi$toRequestState, '/ltl_carrier_invoice_service/reconcile_all', $author$project$AuditPb$carrierInvoiceRequestEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$AuditPb$ltlCarrierInvoiceReconcileRequest_LineItemReconcileItemEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'loadItemId', $elm$json$Json$Encode$int, v.loadItemId),
					A3($author$project$AuditPb$optionalEncoder, 'carrierItemId', $elm$json$Json$Encode$int, v.carrierItemId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'description', $elm$json$Json$Encode$string, v.description),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'oldAmount', $elm$json$Json$Encode$string, v.oldAmount),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'newAmount', $elm$json$Json$Encode$string, v.newAmount)
				])));
};
var $author$project$AuditPb$ltlCarrierInvoiceReconcileRequest_ShippedItemReconcileItemEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'loadItemId', $elm$json$Json$Encode$int, v.loadItemId),
					A3($author$project$AuditPb$optionalEncoder, 'carrierItemId', $elm$json$Json$Encode$int, v.carrierItemId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'description', $elm$json$Json$Encode$string, v.description),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'oldWeight', $elm$json$Json$Encode$string, v.oldWeight),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'newWeight', $elm$json$Json$Encode$string, v.newWeight),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'oldClass', $elm$json$Json$Encode$string, v.oldClass),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'newClass', $elm$json$Json$Encode$string, v.newClass)
				])));
};
var $author$project$AuditPb$ltlCarrierInvoiceReconcileRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'carrierInvoiceId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CarrierInvoiceId$toInt),
					v.carrierInvoiceId),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'shippedItemReconcileItems', $author$project$AuditPb$ltlCarrierInvoiceReconcileRequest_ShippedItemReconcileItemEncoder, v.shippedItemReconcileItems),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'lineItemReconcileItems', $author$project$AuditPb$ltlCarrierInvoiceReconcileRequest_LineItemReconcileItemEncoder, v.lineItemReconcileItems)
				])));
};
var $author$project$AuditApi$ltlCarrierInvoiceServiceReconcileWithState = A3($author$project$AuditApi$toRequestState, '/ltl_carrier_invoice_service/reconcile', $author$project$AuditPb$ltlCarrierInvoiceReconcileRequestEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$open = function (model) {
	return _Utils_update(
		model,
		{isOpen: true});
};
var $author$project$AuditPb$carrierInvoiceSaveRequestSourceToString = function (v) {
	if (v.$ === 'CarrierInvoiceSaveRequestSourceNone') {
		return 'none';
	} else {
		return 'ltl_reconcile';
	}
};
var $author$project$AuditPb$carrierInvoiceSaveRequestSourceEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$carrierInvoiceSaveRequestSourceToString);
var $author$project$AuditPb$carrierInvoiceSaveWithErrorsParamsEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$optionalEncoder, 'note', $elm$json$Json$Encode$string, v.note),
					A3(
					$author$project$AuditPb$optionalEncoder,
					'emailId',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$EmailMessageId$toInt),
					v.emailId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'source', $author$project$AuditPb$carrierInvoiceSaveRequestSourceEncoder, v.source)
				])));
};
var $author$project$Api$CarrierInvoice$saveWithErrors = F2(
	function (params, carrierInvoiceId) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$CarrierInvoiceId$toInt(carrierInvoiceId));
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/carrier_invoices/' + (idString + '/save_with_errors'),
			$author$project$AuditPb$carrierInvoiceSaveWithErrorsParamsEncoder(params));
	});
var $author$project$Api$CarrierInvoice$abandon = F2(
	function (carrierInvoiceId, reason) {
		var idString = $elm$core$String$fromInt(
			$author$project$Domain$CarrierInvoiceId$toInt(carrierInvoiceId));
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			'/api/carrier_invoices/' + (idString + '/abandon'),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'reason',
						$elm$json$Json$Encode$string(reason))
					])));
	});
var $author$project$Api$CarrierInvoice$sendAbandonWithMessage = F3(
	function (finishedMsg, carrierInvoiceId, reason) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			finishedMsg,
			A2($author$project$Api$CarrierInvoice$abandon, carrierInvoiceId, reason));
	});
var $author$project$Forward$CacheableRequest$unwrapUselessResult = function (result) {
	if (result.$ === 'Ok') {
		var a = result.a;
		return a;
	} else {
		var a = result.a;
		return a;
	}
};
var $author$project$Forward$CacheableRequest$sendWithoutCaching = F2(
	function (toMsg, request) {
		var _v0 = A2($author$project$Forward$CacheableRequest$map, toMsg, request);
		var request_ = _v0.a;
		return A2(
			$author$project$HubTran$InspectableEffect$map,
			$author$project$Forward$CacheableRequest$unwrapUselessResult,
			$author$project$HubTran$InspectableEffect$HttpEffect(
				{
					body: request_.body,
					headers: request_.headers,
					method: request_.method,
					resolver: function (response) {
						return _Utils_Tuple2(
							$elm_community$result_extra$Result$Extra$error(
								$author$project$Forward$CacheableRequest$responseToBodyResult(response)),
							$elm$core$Result$Ok(
								$elm$core$Result$Ok(
									request_.onResult(response))));
					},
					timeout: request_.timeout,
					url: request_.url
				}));
	});
var $author$project$HubTran$Effect$sendCacheableRequestWithoutCaching = F2(
	function (toMsg, cacheableRequest) {
		return $author$project$HubTran$Effect$InspectableEffect(
			A2($author$project$Forward$CacheableRequest$sendWithoutCaching, toMsg, cacheableRequest));
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyNumberAsString = '0';
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$maybeSavedInputValue = F2(
	function (reconcileItems, itemPair) {
		var itemPairShippedItemId = function (getter) {
			return A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.id;
					},
					$author$project$Domain$TmsShippedItemId$toInt),
				getter(itemPair));
		};
		var isMatch = function (reconcileItem) {
			return _Utils_eq(
				$elm$core$Maybe$Just(reconcileItem.loadItemId),
				itemPairShippedItemId($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem)) && _Utils_eq(
				reconcileItem.carrierItemId,
				itemPairShippedItemId($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem));
		};
		return A2(
			$elm$core$Maybe$map,
			function (reconcileItem) {
				return {_class: reconcileItem.newClass, weight: reconcileItem.newWeight};
			},
			A2($elm_community$list_extra$List$Extra$find, isMatch, reconcileItems));
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$classDefault = F3(
	function (maybeCurrentValue, savedItems, itemPair) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyNumberAsString,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.className;
					},
					$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair)),
				A2(
					$elm_community$maybe_extra$Maybe$Extra$orElse,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $._class;
						},
						A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$maybeSavedInputValue, savedItems, itemPair)),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $._class;
						},
						maybeCurrentValue))));
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$weightDefault = F3(
	function (maybeCurrentValue, savedItems, itemPair) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyNumberAsString,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.weight;
					},
					$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair)),
				A2(
					$elm_community$maybe_extra$Maybe$Extra$orElse,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.weight;
						},
						A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$maybeSavedInputValue, savedItems, itemPair)),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.weight;
						},
						maybeCurrentValue))));
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$itemPairToMaybeShippedItemReconcileItem = F3(
	function (tmsUpdateValues, _v0, itemPair) {
		var ltlData = _v0.ltlData;
		var savedItems = ltlData.ltlShippedItemReconcileItems;
		var currentValue = A2($turboMaCk$any_dict$Dict$Any$get, itemPair, tmsUpdateValues);
		return A2(
			$elm$core$Maybe$map,
			function (loadItem) {
				return {
					carrierItemId: A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.id;
							},
							$author$project$Domain$TmsShippedItemId$toInt),
						$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair)),
					description: loadItem.description,
					loadItemId: $author$project$Domain$TmsShippedItemId$toInt(loadItem.id),
					newClass: A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$classDefault, currentValue, savedItems, itemPair),
					newWeight: A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$weightDefault, currentValue, savedItems, itemPair),
					oldClass: A2($elm$core$Maybe$withDefault, $author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyNumberAsString, loadItem.className),
					oldWeight: A2($elm$core$Maybe$withDefault, $author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyNumberAsString, loadItem.weight)
				};
			},
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair));
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$shippedItemReconcileItems = F2(
	function (_v0, _v1) {
		var carrierInvoice = _v0.carrierInvoice;
		var equalityData = _v0.equalityData;
		var tmsUpdateValuesShippedItem = _v1.tmsUpdateValuesShippedItem;
		return A2(
			$elm$core$List$filterMap,
			A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$itemPairToMaybeShippedItemReconcileItem, tmsUpdateValuesShippedItem, carrierInvoice),
			equalityData.shippedItemPairs);
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$update = F2(
	function (msg, model) {
		var itemPair = msg.a;
		var amountPercentToggleOption = msg.b;
		var updatedSelectedDiscountToggleOptions = A3($turboMaCk$any_dict$Dict$Any$insert, itemPair, amountPercentToggleOption, model.selectedDiscountToggleOptions);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{selectedDiscountToggleOptions: updatedSelectedDiscountToggleOptions}),
			$author$project$HubTran$Effect$none);
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$NotUpdatingAccessorial = {$: 'NotUpdatingAccessorial'};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$UpdatingAccessorial = function (a) {
	return {$: 'UpdatingAccessorial', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyMoneyAsString = $author$project$Money$toString(
	$author$project$Money$fromCents(0));
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$update = F3(
	function (msg, data, model) {
		switch (msg.$) {
			case 'SetTmsUpdateValueLineItem':
				var itemPair = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							tmsUpdateValuesAccessorial: A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								itemPair,
								$author$project$Components$LtlReconcileInvoicePage$MismatchTable$UpdatingAccessorial(
									{amount: value}),
								model.tmsUpdateValuesAccessorial)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetTmsUpdateValueShippedItem':
				var itemPair = msg.a;
				var reconcileType = msg.b;
				var value = msg.c;
				var savedItems = data.carrierInvoice.ltlData.ltlShippedItemReconcileItems;
				var maybeCurrentValue = A2($turboMaCk$any_dict$Dict$Any$get, itemPair, model.tmsUpdateValuesShippedItem);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							tmsUpdateValuesShippedItem: A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								itemPair,
								{
									_class: _Utils_eq(reconcileType, $author$project$AuditPb$LtlCarrierInvoiceReconcileTypeClass) ? value : A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$classDefault, maybeCurrentValue, savedItems, itemPair),
									weight: _Utils_eq(reconcileType, $author$project$AuditPb$LtlCarrierInvoiceReconcileTypeWeight) ? value : A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$weightDefault, maybeCurrentValue, savedItems, itemPair)
								},
								model.tmsUpdateValuesShippedItem)
						}),
					$author$project$HubTran$Effect$none);
			case 'ApplyInvoicedValuesShippedItem':
				var itemPair = msg.a;
				var carrierItem = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							tmsUpdateValuesShippedItem: A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								itemPair,
								{
									_class: A2($elm$core$Maybe$withDefault, $author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyNumberAsString, carrierItem.className),
									weight: A2($elm$core$Maybe$withDefault, $author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyNumberAsString, carrierItem.weight)
								},
								model.tmsUpdateValuesShippedItem)
						}),
					$author$project$HubTran$Effect$none);
			case 'ApplyInvoicedValuesLineItem':
				var itemPair = msg.a;
				var carrierItem = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							tmsUpdateValuesAccessorial: A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								itemPair,
								$author$project$Components$LtlReconcileInvoicePage$MismatchTable$UpdatingAccessorial(
									{
										amount: $author$project$Money$toString(carrierItem.total)
									}),
								model.tmsUpdateValuesAccessorial)
						}),
					$author$project$HubTran$Effect$none);
			case 'AcceptDisputeAccessorial':
				var itemPair = msg.a;
				var acceptDispute = msg.b;
				if (acceptDispute.$ === 'AcceptAccessorial') {
					var startingAmount = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyMoneyAsString,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.total;
							},
							$author$project$Money$toString),
						$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tmsUpdateValuesAccessorial: A3(
									$turboMaCk$any_dict$Dict$Any$insert,
									itemPair,
									$author$project$Components$LtlReconcileInvoicePage$MismatchTable$UpdatingAccessorial(
										{amount: startingAmount}),
									model.tmsUpdateValuesAccessorial)
							}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								tmsUpdateValuesAccessorial: A3($turboMaCk$any_dict$Dict$Any$insert, itemPair, $author$project$Components$LtlReconcileInvoicePage$MismatchTable$NotUpdatingAccessorial, model.tmsUpdateValuesAccessorial)
							}),
						$author$project$HubTran$Effect$none);
				}
			default:
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$FinishSubmitForm = function (a) {
	return {$: 'FinishSubmitForm', a: a};
};
var $author$project$AuditPb$ltlInvoiceMovedToTMSQueueDataEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'reason', $elm$json$Json$Encode$string, v.reason),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'queueName', $elm$json$Json$Encode$string, v.queueName)
				])));
};
var $author$project$AuditPb$ltlCarrierInvoiceMoveToTMSQueueRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'carrierInvoiceId', $elm$json$Json$Encode$int, v.carrierInvoiceId),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'data', $author$project$AuditPb$ltlInvoiceMovedToTMSQueueDataEncoder, v.data)
				])));
};
var $author$project$AuditApi$ltlCarrierInvoiceServiceMoveToTMSQueueWithState = A3($author$project$AuditApi$toRequestState, '/ltl_carrier_invoice_service/move_to_tms_queue', $author$project$AuditPb$ltlCarrierInvoiceMoveToTMSQueueRequestEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'Cancel':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isOpen: false}),
					$author$project$HubTran$Effect$none);
			case 'SetReason':
				var reason = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{reason: reason}),
					$author$project$HubTran$Effect$none);
			case 'UpdateSelectedTmsQueue':
				var selectedTmsQueue = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedTmsQueue: selectedTmsQueue}),
					$author$project$HubTran$Effect$none);
			case 'StartSubmitForm':
				return A3(
					$author$project$AuditApi$ltlCarrierInvoiceServiceMoveToTMSQueueWithState,
					_Utils_update(
						model,
						{isSubmitting: true}),
					$author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$FinishSubmitForm,
					{
						carrierInvoiceId: $author$project$Domain$CarrierInvoiceId$toInt(model.carrierInvoiceId),
						data: {queueName: model.selectedTmsQueue, reason: model.reason}
					});
			default:
				var response = msg.a;
				return A3(
					$author$project$AuditApi$applyRequest,
					model,
					response,
					F2(
						function (m, _v1) {
							return _Utils_Tuple2(
								m,
								$author$project$HubTran$Effect$load(
									$author$project$Path$toString(m.confirmAndSubmitPath)));
						}));
		}
	});
var $author$project$Components$LtlReconcileInvoicePage$update = F3(
	function (data, msg, model) {
		var invoiceConfirmPath = $author$project$Path$toString(
			A3($author$project$Components$LtlReconcileInvoicePage$carrierInvoiceWithLoadPath, model.loadStateId, model.carrierInvoiceId, model.onDone));
		var ignoreModal = model.ignoreModal;
		switch (msg.$) {
			case 'SetTimezone':
				var tz = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: tz}),
					$author$project$HubTran$Effect$none);
			case 'OpenIgnoreModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ignoreModal: _Utils_update(
								ignoreModal,
								{isShown: true, text: ''})
						}),
					$author$project$HubTran$Effect$none);
			case 'CloseIgnoreModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ignoreModal: _Utils_update(
								ignoreModal,
								{isShown: false})
						}),
					$author$project$HubTran$Effect$none);
			case 'SetIgnoreReason':
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ignoreModal: _Utils_update(
								ignoreModal,
								{text: input})
						}),
					$author$project$HubTran$Effect$none);
			case 'PerformIgnore':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ignoreModal: _Utils_update(
								ignoreModal,
								{isPerforming: true})
						}),
					A3($author$project$Api$CarrierInvoice$sendAbandonWithMessage, $author$project$Components$LtlReconcileInvoicePage$FinishedIgnore, model.carrierInvoiceId, ignoreModal.text));
			case 'FinishedIgnore':
				var apiResult = msg.a;
				if (apiResult.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ignoreModal: _Utils_update(
									ignoreModal,
									{isPerforming: false, isShown: false})
							}),
						$author$project$HubTran$Effect$refresh(
							A2($author$project$Forward$Lookup$startFrom, model.carrierInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$carrierInvoice)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ignoreModal: _Utils_update(
									ignoreModal,
									{isPerforming: false, isShown: false})
							}),
						$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
				}
			case 'DocumentsBrowserMsg':
				var documentsBrowserMsg = msg.a;
				var _v2 = A4(
					$author$project$Components$DocumentsBrowser$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.documentsBrowserData;
						},
						data),
					documentsBrowserMsg,
					model.documentsBrowser,
					$author$project$Components$DocumentsBrowser$noHooks);
				var documentsBrowser = _v2.a;
				var documentsBrowserEffect = _v2.b;
				var newEffect = A2($author$project$HubTran$Effect$map, $author$project$Components$LtlReconcileInvoicePage$DocumentsBrowserMsg, documentsBrowserEffect);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{documentsBrowser: documentsBrowser}),
					newEffect);
			case 'FinishReconcileInvoice':
				var response = msg.a;
				return A3(
					$author$project$AuditApi$applyRequest,
					model,
					response,
					F2(
						function (m, _v3) {
							return _Utils_Tuple2(
								_Utils_update(
									m,
									{isFinished: true, isFinishing: false}),
								$author$project$HubTran$Effect$load(invoiceConfirmPath));
						}));
			case 'StartReconcileMismatchTableSelectionsForInvoice':
				return A3(
					$author$project$AuditApi$ltlCarrierInvoiceServiceReconcileWithState,
					_Utils_update(
						model,
						{isFinishing: true}),
					$author$project$Components$LtlReconcileInvoicePage$FinishReconcileInvoice,
					{
						carrierInvoiceId: model.carrierInvoiceId,
						lineItemReconcileItems: function () {
							var _v4 = $author$project$Forward$Remote$toMaybe(data);
							if (_v4.$ === 'Just') {
								var data_ = _v4.a;
								return A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$lineItemReconcileItems, data_.mismatchTableData, model.mismatchTable);
							} else {
								return _List_Nil;
							}
						}(),
						shippedItemReconcileItems: function () {
							var _v5 = $author$project$Forward$Remote$toMaybe(data);
							if (_v5.$ === 'Just') {
								var data_ = _v5.a;
								return A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$shippedItemReconcileItems, data_.mismatchTableData, model.mismatchTable);
							} else {
								return _List_Nil;
							}
						}()
					});
			case 'StartReconcileAllForInvoice':
				return A3(
					$author$project$AuditApi$ltlCarrierInvoiceServiceReconcileAllWithState,
					_Utils_update(
						model,
						{isFinishing: true}),
					$author$project$Components$LtlReconcileInvoicePage$FinishReconcileInvoice,
					{carrierInvoiceId: model.carrierInvoiceId});
			case 'SkipReconcileInvoice':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isFinished: true}),
					$author$project$HubTran$Effect$load(invoiceConfirmPath));
			case 'MoveToTmsModalMsg':
				var childMsg = msg.a;
				var _v6 = A2($author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$update, childMsg, model.moveToTmsModal);
				var modal = _v6.a;
				var effect = _v6.b;
				var newEffect = A2($author$project$HubTran$Effect$map, $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModalMsg, effect);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{moveToTmsModal: modal}),
					newEffect);
			case 'OpenMoveToTmsModal':
				var newModal = $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$open(model.moveToTmsModal);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{moveToTmsModal: newModal}),
					$author$project$HubTran$Effect$none);
			case 'StartResolveLater':
				var params = {emailId: $elm$core$Maybe$Nothing, note: $elm$core$Maybe$Nothing, source: $author$project$AuditPb$CarrierInvoiceSaveRequestSourceLtlReconcile};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isFinishing: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						A2($elm$core$Basics$composeR, $author$project$Helpers$Api$Result$fromNestedResult, $author$project$Components$LtlReconcileInvoicePage$FinishResolveLater),
						A2($author$project$Api$CarrierInvoice$saveWithErrors, params, model.carrierInvoiceId)));
			case 'FinishResolveLater':
				var apiResult = msg.a;
				if (apiResult.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isFinished: true, isFinishing: false}),
						$author$project$Components$LtlReconcileInvoicePage$dashboardOrFlowModeRedirectEffect(model.onDone));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isFinishing: false}),
						$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert));
				}
			case 'ImDoneButtonClicked':
				return _Utils_Tuple2(
					model,
					$author$project$Components$LtlReconcileInvoicePage$dashboardOrFlowModeRedirectEffect(model.onDone));
			case 'SelectTotalsHeaderToggle':
				var option = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{totalsHeaderSelectedToggleOption: option}),
					$author$project$HubTran$Effect$none);
			case 'InvoiceDetailsTableMsg':
				var childMsg = msg.a;
				var _v8 = A2($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$update, childMsg, model.invoiceDetailsTable);
				var childModel = _v8.a;
				var childEffect = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{invoiceDetailsTable: childModel}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTableMsg, childEffect));
			default:
				var childMsg = msg.a;
				if (data.$ === 'Loaded') {
					var data_ = data.a;
					var _v10 = A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$update, childMsg, data_.mismatchTableData, model.mismatchTable);
					var childModel = _v10.a;
					var childEffect = _v10.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{mismatchTable: childModel}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$LtlReconcileInvoicePage$MismatchTableMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
		}
	});
var $author$project$Components$NonInvoiceConfirmPage$Error = {$: 'Error'};
var $author$project$Components$NonInvoiceConfirmPage$GotApproveResponse = function (a) {
	return {$: 'GotApproveResponse', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$GotContinueResponse = function (a) {
	return {$: 'GotContinueResponse', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$Loading = {$: 'Loading'};
var $author$project$Components$NonInvoiceConfirmPage$Success = function (a) {
	return {$: 'Success', a: a};
};
var $author$project$Api$LoadState$docIdSetToJsonList = A2(
	$elm$core$Basics$composeR,
	$author$project$Id$Set$toList,
	$elm$json$Json$Encode$list(
		A2($elm$core$Basics$composeR, $author$project$Domain$DocumentId$toInt, $elm$json$Json$Encode$int)));
var $author$project$Id$Dict$toList = function (_v0) {
	var dict = _v0.a;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst($author$project$Id$fromInt),
		$elm$core$Dict$toList(dict));
};
var $author$project$Api$LoadState$toPostRequest = F2(
	function (body, url) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			url,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'shipment_documents',
						A2(
							$elm$json$Json$Encode$list,
							function (_v0) {
								var id = _v0.a;
								var documents = _v0.b;
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'shipment_id',
											$elm$json$Json$Encode$int(
												$author$project$Domain$TmsShipmentId$toInt(id))),
											_Utils_Tuple2(
											'document_ids',
											$author$project$Api$LoadState$docIdSetToJsonList(documents))
										]));
							},
							$author$project$Id$Dict$toList(body.shipmentDocuments)))
					])));
	});
var $author$project$Api$LoadState$approveDocuments = function (options) {
	return A2(
		$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
		options.onComplete,
		A2(
			$author$project$Forward$CacheableRequest$map,
			$author$project$Helpers$Api$Result$fromNestedResult,
			A2(
				$author$project$Api$LoadState$toPostRequest,
				options,
				'/api/load_states/' + ($elm$core$String$fromInt(
					$author$project$Domain$LoadStateId$toInt(options.id)) + '/approve_documents'))));
};
var $author$project$Helpers$Api$Result$dropErrorData = F2(
	function (dataToErrorMessage, result) {
		switch (result.$) {
			case 'Ok':
				var a = result.a;
				return $elm$core$Result$Ok(a);
			case 'Err':
				var x = result.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadBody(
						dataToErrorMessage(x)));
			default:
				var error = result.a;
				return $elm$core$Result$Err(error);
		}
	});
var $author$project$Helpers$Api$Result$collapseError = $author$project$Helpers$Api$Result$dropErrorData(
	function (message) {
		return 'ERROR: ' + message;
	});
var $author$project$Api$LoadState$finishDocuments = function (options) {
	return A2(
		$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
		options.onComplete,
		A2(
			$author$project$Forward$CacheableRequest$map,
			$author$project$Helpers$Api$Result$fromNestedResult,
			A2(
				$author$project$Api$LoadState$toPostRequest,
				options,
				'/api/load_states/' + ($elm$core$String$fromInt(
					$author$project$Domain$LoadStateId$toInt(options.id)) + '/finish_documents'))));
};
var $author$project$Components$NonInvoiceConfirmPage$getDocumentWith = F2(
	function (documents, id) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var doc = _v0.a;
					return _Utils_eq(doc.id, id);
				},
				documents));
	});
var $author$project$Components$NonInvoiceConfirmPage$getPathContext = function (data) {
	return {
		isReadonly: false,
		useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, data.settings, data.currentUser)
	};
};
var $author$project$Components$NonInvoiceConfirmPage$assignLoadUrl = F4(
	function (documentBatchId, emailMessageId, onDone, pathContext) {
		var defaultedEmailId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Domain$EmailMessageId$toInt, $elm$core$String$fromInt),
				emailMessageId));
		return $author$project$Path$toString(
			A2(
				$author$project$Path$addQueries,
				_List_fromArray(
					[
						_Utils_Tuple2('emailId', defaultedEmailId),
						_Utils_Tuple2(
						'onDone',
						$elm$url$Url$percentEncode(
							A2($elm$core$Maybe$withDefault, '/app', onDone)))
					]),
				A2($author$project$Path$documentBatch, documentBatchId, pathContext)));
	});
var $author$project$Components$NonInvoiceConfirmPage$defaultAndPrependOnDone = function (onDoneQuery) {
	var defaultedOnDone = A2($elm$core$Maybe$withDefault, '/app', onDoneQuery);
	var prependedOnDone = (!A2($elm$core$String$startsWith, '/app', defaultedOnDone)) ? ('/app' + defaultedOnDone) : defaultedOnDone;
	return prependedOnDone;
};
var $author$project$Components$NonInvoiceConfirmPage$nextUrl = F2(
	function (nextUp, pathContext) {
		if (nextUp.$ === 'Dashboard') {
			var onDone = nextUp.a;
			return $author$project$Components$NonInvoiceConfirmPage$defaultAndPrependOnDone(onDone);
		} else {
			var documentBatchId = nextUp.a;
			var messageId = nextUp.b;
			return A4($author$project$Components$NonInvoiceConfirmPage$assignLoadUrl, documentBatchId, messageId, $elm$core$Maybe$Nothing, pathContext);
		}
	});
var $author$project$Id$Set$singleton = function (key) {
	return $author$project$Id$Set$Set(
		$elm$core$Set$singleton(
			$author$project$Id$toInt(key)));
};
var $author$project$Components$NonInvoiceConfirmPage$update = F3(
	function (data, msg, model) {
		var pathContext = function () {
			var _v6 = $author$project$Forward$Remote$toMaybe(data);
			if (_v6.$ === 'Just') {
				var data_ = _v6.a;
				return $author$project$Components$NonInvoiceConfirmPage$getPathContext(data_);
			} else {
				return {isReadonly: false, useFactorInvoiceWorkflowPage: false};
			}
		}();
		switch (msg.$) {
			case 'ClickedApprove':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{formState: $author$project$Components$NonInvoiceConfirmPage$Loading}),
					$author$project$Api$LoadState$approveDocuments(
						{id: model.loadStateId, onComplete: $author$project$Components$NonInvoiceConfirmPage$GotApproveResponse, shipmentDocuments: model.shipmentDocuments}));
			case 'GotApproveResponse':
				var result = msg.a;
				var _v1 = $author$project$Helpers$Api$Result$collapseError(result);
				if (_v1.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								formState: $author$project$Components$NonInvoiceConfirmPage$Success('Documents approved!')
							}),
						$author$project$HubTran$Effect$cmd(
							$author$project$HubTran$Navigation$load(
								A2($author$project$Components$NonInvoiceConfirmPage$nextUrl, model.nextUp, pathContext))));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{formState: $author$project$Components$NonInvoiceConfirmPage$Error}),
						$author$project$HubTran$Effect$none);
				}
			case 'ClickedContinue':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{formState: $author$project$Components$NonInvoiceConfirmPage$Loading}),
					$author$project$Api$LoadState$finishDocuments(
						{id: model.loadStateId, onComplete: $author$project$Components$NonInvoiceConfirmPage$GotContinueResponse, shipmentDocuments: model.shipmentDocuments}));
			case 'GotContinueResponse':
				var result = msg.a;
				var _v2 = $author$project$Helpers$Api$Result$collapseError(result);
				if (_v2.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								formState: $author$project$Components$NonInvoiceConfirmPage$Success('')
							}),
						$author$project$HubTran$Effect$cmd(
							$author$project$HubTran$Navigation$load(
								A2($author$project$Components$NonInvoiceConfirmPage$nextUrl, model.nextUp, pathContext))));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{formState: $author$project$Components$NonInvoiceConfirmPage$Error}),
						$author$project$HubTran$Effect$none);
				}
			case 'AddedShipmentDocFor':
				var shipmentId = msg.a;
				var documentId = msg.b;
				var insertOrCreate = A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						$author$project$Id$Set$insert(documentId)),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault(
							$author$project$Id$Set$singleton(documentId)),
						$elm$core$Maybe$Just));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							shipmentDocuments: A3($author$project$Id$Dict$update, shipmentId, insertOrCreate, model.shipmentDocuments)
						}),
					$author$project$HubTran$Effect$none);
			case 'RemovedShipmentDocFor':
				var shipmentId = msg.a;
				var documentId = msg.b;
				var remove = $elm$core$Maybe$map(
					$author$project$Id$Set$remove(documentId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							shipmentDocuments: A3($author$project$Id$Dict$update, shipmentId, remove, model.shipmentDocuments)
						}),
					$author$project$HubTran$Effect$none);
			case 'ExpandReferencesFor':
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							expandedShipmentReferences: A2($author$project$Id$Set$insert, id, model.expandedShipmentReferences)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetTimezone':
				var tz = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: tz}),
					$author$project$HubTran$Effect$none);
			case 'PresenceMsg':
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							presence: A2($author$project$Presence$update, subMsg, model.presence)
						}),
					$author$project$HubTran$Effect$none);
			case 'SelectDocument':
				var documentId = msg.a;
				var maybeDocumentPage = function (remoteData) {
					return A2(
						$elm$core$Maybe$andThen,
						$elm$core$List$head,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Maybe$andThen,
								function (data_) {
									return A2($author$project$Components$NonInvoiceConfirmPage$getDocumentWith, data_.tmsLoadDetails.documents, documentId);
								},
								$author$project$Forward$Remote$toMaybe(remoteData))));
				};
				var _v3 = maybeDocumentPage(data);
				if (_v3.$ === 'Just') {
					var page = _v3.a;
					var updatedCurrentProcessingSelection = A2($author$project$Broker$Shared$CurrentProcessingSelection$updateWithDocPage, page.id, model.documentsBrowser.currentProcessingSelection);
					var updatedDocumentsBrowser = A2($author$project$Components$DocumentsBrowser$setMaybeSelectedDocumentPageId, updatedCurrentProcessingSelection, model.documentsBrowser);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								documentsBrowser: updatedDocumentsBrowser,
								selectedDocumentId: $elm$core$Maybe$Just(documentId)
							}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'DocumentsBrowserMsg':
				var documentsBrowserMsg = msg.a;
				var maybeDocumentIdFromData = F2(
					function (documentPageId, data_) {
						return A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								function ($) {
									return $.id;
								}),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v5) {
									var pages = _v5.b;
									return A2(
										$elm$core$List$member,
										documentPageId,
										A2(
											$elm$core$List$map,
											function ($) {
												return $.id;
											},
											pages));
								},
								data_.tmsLoadDetails.documents));
					});
				var _v4 = A4(
					$author$project$Components$DocumentsBrowser$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.documentsBrowserData;
						},
						data),
					documentsBrowserMsg,
					model.documentsBrowser,
					$author$project$Components$DocumentsBrowser$noHooks);
				var documentsBrowser = _v4.a;
				var documentsBrowserEffect = _v4.b;
				var maybeSelectedDocumentPageId = $author$project$Components$DocumentsBrowser$maybeSelectedDocumentPageId(documentsBrowser.currentProcessingSelection);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documentsBrowser: documentsBrowser,
							selectedDocumentId: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Basics$identity,
								A3(
									$elm$core$Maybe$map2,
									maybeDocumentIdFromData,
									maybeSelectedDocumentPageId,
									$author$project$Forward$Remote$toMaybe(data)))
						}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$NonInvoiceConfirmPage$DocumentsBrowserMsg, documentsBrowserEffect));
			default:
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$HubTran$InspectableEffect$reload = $author$project$HubTran$InspectableEffect$Reload;
var $author$project$HubTran$Effect$reload = $author$project$HubTran$Effect$InspectableEffect($author$project$HubTran$InspectableEffect$reload);
var $author$project$Components$OktaLoginPage$update = F2(
	function (msg, model) {
		if (msg.$ === 'FailedOktaAuth') {
			var reason = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						failReason: $elm$core$Maybe$Just(reason)
					}),
				$author$project$HubTran$Effect$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{failReason: $elm$core$Maybe$Nothing}),
				$author$project$HubTran$Effect$reload);
		}
	});
var $author$project$Components$ReadonlyFactorInvoicePage$update = F3(
	function (data, msg, model) {
		var documentsBrowserMsg = msg.a;
		var docBrowserData = A2(
			$author$project$Forward$Remote$map,
			function ($) {
				return $.documentsBrowserData;
			},
			data);
		var _v1 = A4($author$project$Components$DocumentsBrowser$update, docBrowserData, documentsBrowserMsg, model.documentsBrowser, $author$project$Components$DocumentsBrowser$noHooks);
		var documentsBrowser = _v1.a;
		var documentsBrowserEffect = _v1.b;
		var updatedModel = _Utils_update(
			model,
			{documentsBrowser: documentsBrowser});
		var effect = A2($author$project$HubTran$Effect$map, $author$project$Components$ReadonlyFactorInvoicePage$DocumentsBrowserMsg, documentsBrowserEffect);
		return _Utils_Tuple2(updatedModel, effect);
	});
var $author$project$Components$SettingsPage$DebtorsSettingsViewMsg = function (a) {
	return {$: 'DebtorsSettingsViewMsg', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsViewMsg = function (a) {
	return {$: 'DocumentTypesSettingsViewMsg', a: a};
};
var $author$project$Components$SettingsPage$ExceptionSettingsViewMsg = function (a) {
	return {$: 'ExceptionSettingsViewMsg', a: a};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$DocumentsListViewMsg = function (a) {
	return {$: 'DocumentsListViewMsg', a: a};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$SaveFinished = function (a) {
	return {$: 'SaveFinished', a: a};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$encode = F2(
	function (url, model) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'urls',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						_List_fromArray(
							[url]))),
					_Utils_Tuple2(
					'carrier_id',
					$elm$json$Json$Encode$int(
						$author$project$Domain$TmsCarrierId$toInt(model.carrierId))),
					_Utils_Tuple2(
					'document_type',
					$elm$json$Json$Encode$string(model.selectedDocumentType))
				]));
	});
var $author$project$Uppy$initUppy = _Platform_outgoingPort(
	'initUppy',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'allowedFileTypes',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string)($.allowedFileTypes)),
					_Utils_Tuple2(
					'dragDropTarget',
					$elm$json$Json$Encode$string($.dragDropTarget)),
					_Utils_Tuple2(
					'endpoint',
					$elm$json$Json$Encode$string($.endpoint)),
					_Utils_Tuple2(
					'singleFile',
					$elm$json$Json$Encode$bool($.singleFile)),
					_Utils_Tuple2(
					'statusBarTarget',
					$elm$json$Json$Encode$string($.statusBarTarget))
				]));
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$initUppy = $author$project$Uppy$initUppy(
	{
		allowedFileTypes: _List_fromArray(
			['application/pdf']),
		dragDropTarget: '#hubtran-file-drop',
		endpoint: '/api/uppy_files',
		singleFile: true,
		statusBarTarget: '#hubtran-upload-progress-bar'
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$FinishDeletingDocument = F2(
	function (a, b) {
		return {$: 'FinishDeletingDocument', a: a, b: b};
	});
var $author$project$Api$AccountsPayable$CarrierDocuments$baseUrl = '/api/accounts_payable/carrier_documents';
var $author$project$Domain$DocumentId$toString = function (documentId) {
	return $elm$core$String$fromInt(
		$author$project$Id$toInt(documentId));
};
var $author$project$Api$AccountsPayable$CarrierDocuments$baseMemberUrl = function (documentId) {
	return $author$project$Api$AccountsPayable$CarrierDocuments$baseUrl + ('/' + $author$project$Domain$DocumentId$toString(documentId));
};
var $author$project$Api$AccountsPayable$CarrierDocuments$deleteDocument = function (documentId) {
	return $author$project$Helpers$Api$delete(
		$author$project$Api$AccountsPayable$CarrierDocuments$baseMemberUrl(documentId));
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'PreviewDocumentSelected':
				var documentId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							previewDocumentId: $elm$core$Maybe$Just(documentId)
						}),
					$author$project$HubTran$Effect$none);
			case 'ShowDeleteConfirmation':
				var documentId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							confirmDeleteDocumentId: $elm$core$Maybe$Just(documentId)
						}),
					$author$project$HubTran$Effect$none);
			case 'HideDeleteConfirmation':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmDeleteDocumentId: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'DeleteDocument':
				var documentId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{deletingDocument: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$CarrierDocumentsView$DocumentsListView$FinishDeletingDocument(model.carrierId),
						$author$project$Api$AccountsPayable$CarrierDocuments$deleteDocument(documentId)));
			default:
				switch (msg.b.$) {
					case 'Ok':
						var carrierId = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{confirmDeleteDocumentId: $elm$core$Maybe$Nothing, deletingDocument: false}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$invalidate(
										$author$project$Components$CarrierDocumentsView$DocumentsListView$loadDocuments(carrierId)),
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Deleted document.'))
									])));
					case 'Err':
						var message = msg.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{confirmDeleteDocumentId: $elm$core$Maybe$Nothing, deletingDocument: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{confirmDeleteDocumentId: $elm$core$Maybe$Nothing, deletingDocument: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Failed to delete document.')));
				}
		}
	});
var $author$project$Components$CarrierDocumentsView$FiltersView$update = F3(
	function (config, msg, model) {
		var string = msg.a;
		var documentType = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (docType) {
					return _Utils_eq(
						$author$project$Encode$DocumentTypeEncoder$documentTypeString(docType),
						string);
				},
				config.carrierDocumentTypes));
		return _Utils_update(
			model,
			{selectedDocumentType: documentType});
	});
var $author$project$Components$DocumentBrowser$update = F2(
	function (msg, model) {
		if (msg.$ === 'SelectDocumentPage') {
			var selection = msg.a;
			return _Utils_update(
				model,
				{selection: selection});
		} else {
			return model;
		}
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'FileUploaded':
				var fileData = msg.a;
				var decoded = A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
					fileData);
				if (decoded.$ === 'Ok') {
					var url = decoded.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{saving: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$CarrierDocumentsView$CarrierDocumentsView$SaveFinished,
							A2(
								$author$project$Helpers$Api$postWithNoResponseBody,
								'/api/accounts_payable/carrier_documents',
								A2($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$encode, url, model))));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'SaveFinished':
				var result = msg.a;
				switch (result.$) {
					case 'Ok':
						return _Utils_Tuple2(
							{
								carrierId: model.carrierId,
								documentBrowser: model.documentBrowser,
								documentsListView: $author$project$Components$CarrierDocumentsView$DocumentsListView$init(model.carrierId),
								errorMessage: $elm$core$Maybe$Nothing,
								fileUploaded: false,
								filtersView: model.filtersView,
								saving: false,
								selectedDocumentType: ''
							},
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success(' File Saved!')));
					case 'Err':
						var message = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('An error occurred. Please try to save again.')));
				}
			case 'DocumentBrowserMsg':
				var childMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documentBrowser: A2($author$project$Components$DocumentBrowser$update, childMsg, model.documentBrowser)
						}),
					$author$project$HubTran$Effect$none);
			case 'DocumentsListViewMsg':
				var childMsg = msg.a;
				if (childMsg.$ === 'PreviewDocumentSelected') {
					var documentId = childMsg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								documentBrowser: $author$project$Components$DocumentBrowser$init(
									_List_fromArray(
										[documentId]))
							}),
						$author$project$HubTran$Effect$none);
				} else {
					var _v4 = A2($author$project$Components$CarrierDocumentsView$DocumentsListView$update, childMsg, model.documentsListView);
					var newDocumentsListView = _v4.a;
					var documentsListViewEffect = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{documentsListView: newDocumentsListView}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$DocumentsListViewMsg, documentsListViewEffect));
				}
			case 'SelectDocumentType':
				var string = msg.a;
				var effect = $elm$core$String$isEmpty(model.selectedDocumentType) ? $author$project$HubTran$Effect$cmd($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$initUppy) : $author$project$HubTran$Effect$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedDocumentType: string}),
					effect);
			case 'FiltersViewMsg':
				var childMsg = msg.a;
				var _v5 = $author$project$Forward$Remote$toMaybe(data);
				if (_v5.$ === 'Just') {
					var data_ = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								filtersView: A3(
									$author$project$Components$CarrierDocumentsView$FiltersView$update,
									{accountSettings: data_.accountSettings, carrierDocumentTypes: data_.carrierDocumentTypes, currentAccount: data_.currentAccount},
									childMsg,
									model.filtersView)
							}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{errorMessage: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$AccountSettingsView$Update = function (a) {
	return {$: 'Update', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$UpdateAutoReplyFilters = {$: 'UpdateAutoReplyFilters'};
var $author$project$Components$SettingsPage$AccountSettingsView$UpdateLoadCustomerLabels = {$: 'UpdateLoadCustomerLabels'};
var $author$project$Components$SettingsPage$AccountSettingsView$UpdateOfficePeopleMappings = {$: 'UpdateOfficePeopleMappings'};
var $author$project$Api$LoadCustomerLabels$encodeCustomerId = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCustomerId$toInt);
var $author$project$Api$LoadCustomerLabels$post = F2(
	function (segment, data) {
		var url = '/api/load_customer_labels' + (segment + '?format=forward');
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, data);
	});
var $author$project$Api$LoadCustomerLabels$addCustomer = F2(
	function (name, customerId) {
		return A2(
			$author$project$Api$LoadCustomerLabels$post,
			'/update',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'customer_id',
						$author$project$Api$LoadCustomerLabels$encodeCustomerId(customerId))
					])));
	});
var $author$project$Api$AutoReplyFilters$baseUrl = '/api/auto_reply_filters/';
var $author$project$Api$AutoReplyFilters$format = '?format=forward';
var $author$project$Api$AutoReplyFilters$create = function (_v0) {
	var body = _v0.body;
	var subject = _v0.subject;
	var email = _v0.email;
	var json = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email)),
				_Utils_Tuple2(
				'subject',
				$elm$json$Json$Encode$string(subject)),
				_Utils_Tuple2(
				'body',
				$elm$json$Json$Encode$string(body))
			]));
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		_Utils_ap($author$project$Api$AutoReplyFilters$baseUrl, $author$project$Api$AutoReplyFilters$format),
		json);
};
var $author$project$Api$LoadCustomerLabels$create = function (form) {
	return A2(
		$author$project$Api$LoadCustomerLabels$post,
		'',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(form.name)),
					_Utils_Tuple2(
					'source',
					$elm$json$Json$Encode$string(form.source))
				])));
};
var $author$project$Api$OfficePeopleMappings$baseUrl = '/api/office_people_mappings/';
var $author$project$Api$OfficePeopleMappings$format = '?format=forward';
var $author$project$Api$OfficePeopleMappings$create = function (_v0) {
	var person = _v0.person;
	var office = _v0.office;
	var body = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'office',
				$elm$json$Json$Encode$string(office)),
				_Utils_Tuple2(
				'person',
				$elm$json$Json$Encode$string(person))
			]));
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		_Utils_ap($author$project$Api$OfficePeopleMappings$baseUrl, $author$project$Api$OfficePeopleMappings$format),
		body);
};
var $author$project$Domain$AutoReplyFilterId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Api$AutoReplyFilters$delete = function (id) {
	var url = _Utils_ap(
		$author$project$Api$AutoReplyFilters$baseUrl,
		_Utils_ap(
			$elm$core$String$fromInt(
				$author$project$Domain$AutoReplyFilterId$toInt(id)),
			$author$project$Api$AutoReplyFilters$format));
	return $author$project$Helpers$Api$delete(url);
};
var $author$project$Api$LoadCustomerLabels$delete = function (name) {
	return A2(
		$author$project$Api$LoadCustomerLabels$post,
		'/delete',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name))
				])));
};
var $author$project$Domain$OfficePeopleMappingId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Api$OfficePeopleMappings$delete = function (id) {
	var url = _Utils_ap(
		$author$project$Api$OfficePeopleMappings$baseUrl,
		_Utils_ap(
			$elm$core$String$fromInt(
				$author$project$Domain$OfficePeopleMappingId$toInt(id)),
			$author$project$Api$OfficePeopleMappings$format));
	return $author$project$Helpers$Api$delete(url);
};
var $author$project$Experimental$FormField$FormField = function (a) {
	return {$: 'FormField', a: a};
};
var $author$project$Experimental$FormField$init = function (value_) {
	return $author$project$Experimental$FormField$FormField(
		{feedback: $elm$core$Maybe$Nothing, value: value_});
};
var $author$project$Components$SettingsPage$Account$CarrierPayments$init = function (formData) {
	return {
		carrierDaysToPay: $author$project$Experimental$FormField$init(formData.carrierDaysToPay),
		quickpayDiscount: $author$project$Experimental$FormField$init(formData.quickpayDiscount),
		quickpayDiscountDisabled: $author$project$Experimental$FormField$init(formData.quickpayDiscountDisabled)
	};
};
var $author$project$Components$SettingsPage$AccountSettingsView$carrierPaymentsFromData = function (data) {
	return $author$project$Components$SettingsPage$Account$CarrierPayments$init(
		{
			carrierDaysToPay: $elm$core$String$fromInt(data.accountSettings.carrierDaysToPay),
			quickpayDiscount: $elm$core$String$fromFloat(data.accountSettings.quickpayDiscount),
			quickpayDiscountDisabled: data.accountSettings.quickpayDiscountDisabled
		});
};
var $author$project$Domain$AccountSettings$defaultClientNotesConfiguration = _List_fromArray(
	[
		{display: 'expanded', noteType: 'warning'},
		{display: 'closed', noteType: 'verification_notes'},
		{display: 'expanded', noteType: 'funding_notes'},
		{display: 'expanded', noteType: 'notes'}
	]);
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$init = function (settings) {
	return {
		dragOverIndex: $elm$core$Maybe$Nothing,
		draggingIndex: $elm$core$Maybe$Nothing,
		settings: $elm$core$List$isEmpty(settings) ? $author$project$Domain$AccountSettings$defaultClientNotesConfiguration : settings
	};
};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$init = {fieldsContainer: $elm$core$Maybe$Nothing, subject: $elm$core$Maybe$Nothing};
var $author$project$Components$SettingsPage$EditableSection$EditableSection = function (a) {
	return {$: 'EditableSection', a: a};
};
var $author$project$Components$SettingsPage$EditableSection$fromParts = $author$project$Components$SettingsPage$EditableSection$EditableSection;
var $author$project$Components$SettingsPage$EditableSection$init = function (val) {
	return $author$project$Components$SettingsPage$EditableSection$fromParts(
		{editing: $elm$core$Maybe$Nothing, original: val});
};
var $author$project$Components$SettingsPage$Account$InvoiceSettings$init = function (formData) {
	return {
		autoApprove: $author$project$Experimental$FormField$init(formData.autoApprove),
		autoApproveEditEnabled: formData.autoApproveEditEnabled,
		invoiceDateStrategy: $author$project$Experimental$FormField$init(formData.invoiceDateStrategy)
	};
};
var $author$project$Components$SettingsPage$AccountSettingsView$invoiceSettingsFromData = function (data) {
	return $author$project$Components$SettingsPage$Account$InvoiceSettings$init(
		{autoApprove: data.accountSettings.autoApprovePayables, autoApproveEditEnabled: data.accountSettings.selfServeAutoApproveSetting, invoiceDateStrategy: data.accountSettings.invoiceDateStrategy});
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$init = function (formData) {
	return {
		carrierInvoiceAmountToleranceLineItemTypeId: $author$project$Experimental$FormField$init(formData.carrierInvoiceAmountToleranceLineItemTypeId),
		carrierInvoiceAmountToleranceOver: $author$project$Experimental$FormField$init(formData.carrierInvoiceAmountToToleranceOver),
		carrierInvoiceAmountToleranceUnder: $author$project$Experimental$FormField$init(formData.carrierInvoiceAmountToToleranceUnder),
		carrierInvoiceAmountToleranceUnit: $author$project$Experimental$FormField$init(formData.carrierInvoiceAmountToToleranceUnit),
		ltlCarrierInvoiceAmountToleranceOver: $author$project$Experimental$FormField$init(formData.ltlCarrierInvoiceAmountToToleranceOver),
		ltlCarrierInvoiceAmountToleranceUnder: $author$project$Experimental$FormField$init(formData.ltlCarrierInvoiceAmountToToleranceUnder),
		ltlCarrierInvoiceAmountToleranceUnit: $author$project$Experimental$FormField$init(formData.ltlCarrierInvoiceAmountToToleranceUnit),
		ltlMarginToleranceEnabled: $author$project$Experimental$FormField$init(
			(!$elm$core$String$isEmpty(formData.ltlMarginToleranceMinimum)) || (!$elm$core$String$isEmpty(formData.ltlMarginToleranceMaximum))),
		ltlMarginToleranceMaximum: $author$project$Experimental$FormField$init(formData.ltlMarginToleranceMaximum),
		ltlMarginToleranceMinimum: $author$project$Experimental$FormField$init(formData.ltlMarginToleranceMinimum),
		ltlMarginToleranceUnit: $author$project$Experimental$FormField$init(formData.ltlMarginToleranceUnit)
	};
};
var $author$project$Money$dollarString = function (dollars) {
	var step = F2(
		function (c, _v0) {
			var count = _v0.a;
			var string = _v0.b;
			return _Utils_Tuple2(
				count + 1,
				A2($elm$core$String$cons, c, string));
		});
	return A3(
		$elm$core$String$foldr,
		step,
		_Utils_Tuple2(0, ''),
		$elm$core$String$fromInt(
			$elm$core$Basics$abs(dollars))).b;
};
var $author$project$Money$toStringWithoutPrefixOrCommas = function (money) {
	var _v0 = $author$project$Money$toDollarsAndCents(money);
	var dollars = _v0.b;
	var cents = _v0.c;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$author$project$Money$dollarString(dollars),
				'.',
				A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				$elm$core$String$fromInt(cents))
			]));
};
var $author$project$Components$SettingsPage$AccountSettingsView$invoiceToleranceSettingsFromData = function (data) {
	return $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$init(
		{
			carrierInvoiceAmountToToleranceOver: $author$project$Money$toStringWithoutPrefixOrCommas(
				$author$project$Money$castFromString(data.accountSettings.carrierInvoiceAmountToleranceOver)),
			carrierInvoiceAmountToToleranceUnder: $author$project$Money$toStringWithoutPrefixOrCommas(
				$author$project$Money$castFromString(data.accountSettings.carrierInvoiceAmountToleranceUnder)),
			carrierInvoiceAmountToToleranceUnit: data.accountSettings.carrierInvoiceAmountToleranceUnit,
			carrierInvoiceAmountToleranceLineItemTypeId: data.accountSettings.carrierInvoiceAmountToleranceLineItemTypeId,
			ltlCarrierInvoiceAmountToToleranceOver: $author$project$Money$toStringWithoutPrefixOrCommas(
				$author$project$Money$castFromString(data.accountSettings.ltlCarrierInvoiceAmountToleranceOver)),
			ltlCarrierInvoiceAmountToToleranceUnder: $author$project$Money$toStringWithoutPrefixOrCommas(
				$author$project$Money$castFromString(data.accountSettings.ltlCarrierInvoiceAmountToleranceUnder)),
			ltlCarrierInvoiceAmountToToleranceUnit: data.accountSettings.ltlCarrierInvoiceAmountToleranceUnit,
			ltlMarginToleranceMaximum: A2($elm$core$Maybe$withDefault, '', data.accountSettings.ltlDefaultMarginToleranceMaximum),
			ltlMarginToleranceMinimum: A2($elm$core$Maybe$withDefault, '', data.accountSettings.ltlDefaultMarginToleranceMinimum),
			ltlMarginToleranceUnit: data.accountSettings.ltlDefaultMarginToleranceUnit
		});
};
var $author$project$Components$SettingsPage$AccountSettingsView$loadedModelFromData = F2(
	function (data, model) {
		var _v0 = model.changes;
		if (_v0.$ === 'Nothing') {
			return {
				allowImplicitCarrierInvoiceEditableSection: $author$project$Components$SettingsPage$EditableSection$init(data.accountSettings.allowImplicitCarrierInvoice),
				autoReplyFilters: data.autoReplyFilters,
				carrierPaymentsEditableSection: $author$project$Components$SettingsPage$EditableSection$init(
					$author$project$Components$SettingsPage$AccountSettingsView$carrierPaymentsFromData(data)),
				clientNotesConfigurationModel: $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$init(data.accountSettings.clientNotesConfiguration),
				customInvoiceExceptionMessages: data.accountSettings.customInvoiceExceptionMessages,
				failedCadenceTransmissionRecipientsEditableSection: $author$project$Components$SettingsPage$EditableSection$init(
					{content: data.accountSettings.failedCadenceTransmissionRecipients, valid: true}),
				invoiceSettingsEditableSection: $author$project$Components$SettingsPage$EditableSection$init(
					$author$project$Components$SettingsPage$AccountSettingsView$invoiceSettingsFromData(data)),
				invoiceToleranceSettingsEditableSection: $author$project$Components$SettingsPage$EditableSection$init(
					$author$project$Components$SettingsPage$AccountSettingsView$invoiceToleranceSettingsFromData(data)),
				loadCustomerLabels: data.accountSettings.loadCustomerLabels,
				officePeopleMappings: data.officePeopleMappings,
				sendMissingDocumentsEmailDelayInHours: data.accountSettings.sendMissingDocumentsEmailDelayInHours,
				sendMissingDocumentsEmailIntervalInDays: data.accountSettings.sendMissingDocumentsEmailIntervalInDays,
				sendMissingDocumentsEmailTotalCount: data.accountSettings.sendMissingDocumentsEmailTotalCount,
				sendMissingDocumentsEmailsEnabled: data.accountSettings.sendMissingDocumentsEmailsEnabled,
				tmsReferenceFieldsState: $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$init,
				validSourceDateRangeEditableSection: $author$project$Components$SettingsPage$EditableSection$init(data.accountSettings.validSourceDateRange),
				visibleTmsReferenceFieldLabels: data.accountSettings.visibleTMSReferenceFieldLabels
			};
		} else {
			var changes = _v0.a;
			return changes;
		}
	});
var $author$project$Api$LoadCustomerLabels$removeCustomer = F2(
	function (name, customerId) {
		return A2(
			$author$project$Api$LoadCustomerLabels$post,
			'/update',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'delete_customer_id',
						$author$project$Api$LoadCustomerLabels$encodeCustomerId(customerId))
					])));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$FinishSaving = function (a) {
	return {$: 'FinishSaving', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$sendSave = function (subject) {
	return $author$project$HubTran$Effect$sendCacheableRequestWithError(
		function (result) {
			return $author$project$Components$SettingsPage$AccountSettingsView$FinishSaving(
				function () {
					switch (result.$) {
						case 'Ok':
							return $elm$core$Result$Ok(subject);
						case 'Err':
							return $elm$core$Result$Err(subject);
						default:
							return $elm$core$Result$Err(subject);
					}
				}());
		});
};
var $author$project$Api$LoadCustomerLabels$update = function (form) {
	return A2(
		$author$project$Api$LoadCustomerLabels$post,
		'/update',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(form.old)),
					_Utils_Tuple2(
					'new_name',
					$elm$json$Json$Encode$string(form._new)),
					_Utils_Tuple2(
					'new_source',
					$elm$json$Json$Encode$string(form.newSource))
				])));
};
var $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg = function (a) {
	return {$: 'LoadedMsg', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$TmsReferenceFieldsMsg = function (a) {
	return {$: 'TmsReferenceFieldsMsg', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$UpdateClientNotesConfiguration = {$: 'UpdateClientNotesConfiguration'};
var $author$project$Components$SettingsPage$AccountSettingsView$UpdateImplicitCarrierInvoice = {$: 'UpdateImplicitCarrierInvoice'};
var $author$project$Components$SettingsPage$EditableSection$current = function (_v0) {
	var section = _v0.a;
	return A2($elm$core$Maybe$withDefault, section.original, section.editing);
};
var $author$project$Components$SettingsPage$AccountSettingsView$insertAt = F3(
	function (index, x, list) {
		if (!index) {
			return A2($elm$core$List$cons, x, list);
		} else {
			if (!list.b) {
				return _List_fromArray(
					[x]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A3($author$project$Components$SettingsPage$AccountSettingsView$insertAt, index - 1, x, rest));
			}
		}
	});
var $author$project$Domain$EmailAddress$validRegex = $elm$regex$Regex$fromString('^(([^<>()\u005C[\u005C]\u005C\u005C.,;:\u005Cs@\u0022]+(\u005C.[^<>()\u005C[\u005C]\u005C\u005C.,;:\u005Cs@\u0022]+)*)|(\u0022.+\u0022))@((\u005C[[0-9]{1,3}\u005C.[0-9]{1,3}\u005C.[0-9]{1,3}\u005C.[0-9]{1,3}])|(([a-zA-Z\u005C-0-9]+\u005C.)+[a-zA-Z]{2,}))$');
var $author$project$Domain$EmailAddress$isValid = function (raw) {
	var _v0 = $author$project$Domain$EmailAddress$validRegex;
	if (_v0.$ === 'Nothing') {
		return false;
	} else {
		var re = _v0.a;
		return A2($elm$regex$Regex$contains, re, raw);
	}
};
var $author$project$Domain$EmailAddress$isValidList = function (raw) {
	return $elm$core$String$isEmpty(raw) || A2(
		$elm$core$List$all,
		$author$project$Domain$EmailAddress$isValid,
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2($elm$core$String$split, ',', raw))));
};
var $author$project$Components$SettingsPage$EditableSection$map = F2(
	function (mapper, _v0) {
		var section = _v0.a;
		return $author$project$Components$SettingsPage$EditableSection$EditableSection(
			_Utils_update(
				section,
				{
					editing: $elm$core$Maybe$Just(
						mapper(
							A2($elm$core$Maybe$withDefault, section.original, section.editing)))
				}));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$remove = function (x) {
	return $elm$core$List$filter(
		function (el) {
			return !_Utils_eq(el, x);
		});
};
var $author$project$Api$Accounts$saveAllowImplicitCarrierInvoice = function (enabled) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'allow_implicit_carrier_invoice',
					$elm$json$Json$Encode$bool(enabled))
				])));
};
var $author$project$Api$Accounts$saveClientNotesConfiguration = function (noteSettings) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'client_notes_configuration',
					A2(
						$elm$json$Json$Encode$list,
						function (s) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string(s.noteType)),
										_Utils_Tuple2(
										'display',
										$elm$json$Json$Encode$string(s.display))
									]));
						},
						noteSettings))
				])));
};
var $author$project$Components$SettingsPage$AccountSettingsView$UpdateMain = {$: 'UpdateMain'};
var $author$project$Api$Accounts$encodeTmsReferenceFields = function (visibleTmsReferenceFieldLabels) {
	return $elm$core$List$isEmpty(visibleTmsReferenceFieldLabels) ? $elm$json$Json$Encode$string('empty_array') : A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, visibleTmsReferenceFieldLabels);
};
var $author$project$Api$Accounts$settings = function (form) {
	var quickpayDiscount = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toFloat(form.quickpayDiscount));
	var encodedTmsReferenceFields = $author$project$Api$Accounts$encodeTmsReferenceFields(form.visibleTmsReferenceFieldLabels);
	var encodedCustomInvoiceExceptionMessages = $elm$core$List$isEmpty(form.customInvoiceExceptionMessages) ? $elm$json$Json$Encode$string('empty_array') : A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, form.customInvoiceExceptionMessages);
	var carrierDaysToPay = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(form.carrierDaysToPay));
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'invoice_date_strategy',
					$elm$json$Json$Encode$string(form.invoiceDateStrategy)),
					_Utils_Tuple2(
					'autoApprove',
					$elm$json$Json$Encode$bool(form.autoApprove)),
					_Utils_Tuple2(
					'carrier_invoice_amount_tolerance_over',
					$elm$json$Json$Encode$string(form.carrierInvoiceAmountToleranceOver)),
					_Utils_Tuple2(
					'carrier_invoice_amount_tolerance_under',
					$elm$json$Json$Encode$string(form.carrierInvoiceAmountToleranceUnder)),
					_Utils_Tuple2(
					'carrier_invoice_amount_tolerance_unit',
					$elm$json$Json$Encode$string(form.carrierInvoiceAmountToleranceUnit)),
					_Utils_Tuple2(
					'carrier_invoice_amount_tolerance_line_item_type_id',
					A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, form.carrierInvoiceAmountToleranceLineItemTypeId)),
					_Utils_Tuple2(
					'carrier_days_to_pay',
					$elm$json$Json$Encode$int(carrierDaysToPay)),
					_Utils_Tuple2(
					'quickpay_discount',
					$elm$json$Json$Encode$float(quickpayDiscount)),
					_Utils_Tuple2(
					'quickpay_discount_disabled',
					$elm$json$Json$Encode$bool(form.quickpayDiscountDisabled)),
					_Utils_Tuple2('tms_reference_fields', encodedTmsReferenceFields),
					_Utils_Tuple2(
					'failed_cadence_transmission_recipients',
					$elm$json$Json$Encode$string(form.failedCadenceTransmissionRecipients)),
					_Utils_Tuple2('custom_invoice_exception_messages', encodedCustomInvoiceExceptionMessages),
					_Utils_Tuple2(
					'valid_source_date_range',
					$elm$json$Json$Encode$string(form.validSourceDateRange)),
					_Utils_Tuple2(
					'ltl_carrier_invoice_amount_tolerance_over',
					$elm$json$Json$Encode$string(form.ltlCarrierInvoiceAmountToleranceOver)),
					_Utils_Tuple2(
					'ltl_carrier_invoice_amount_tolerance_under',
					$elm$json$Json$Encode$string(form.ltlCarrierInvoiceAmountToleranceUnder)),
					_Utils_Tuple2(
					'ltl_carrier_invoice_amount_tolerance_unit',
					$elm$json$Json$Encode$string(form.ltlCarrierInvoiceAmountToleranceUnit)),
					_Utils_Tuple2(
					'ltl_default_margin_tolerance_unit',
					$elm$json$Json$Encode$string(form.ltlMarginToleranceUnit)),
					_Utils_Tuple2(
					'ltl_default_margin_tolerance_minimum',
					$elm$json$Json$Encode$string(form.ltlMarginToleranceMinimum)),
					_Utils_Tuple2(
					'ltl_default_margin_tolerance_maximum',
					$elm$json$Json$Encode$string(form.ltlMarginToleranceMaximum)),
					_Utils_Tuple2(
					'send_missing_documents_emails_enabled',
					$elm$json$Json$Encode$bool(form.sendMissingDocumentsEmailsEnabled)),
					_Utils_Tuple2(
					'send_missing_documents_email_delay_in_hours',
					$elm$json$Json$Encode$string(form.sendMissingDocumentsEmailDelayInHours)),
					_Utils_Tuple2(
					'send_missing_documents_email_total_count',
					$elm$json$Json$Encode$string(form.sendMissingDocumentsEmailTotalCount)),
					_Utils_Tuple2(
					'send_missing_documents_email_interval_in_days',
					$elm$json$Json$Encode$string(form.sendMissingDocumentsEmailIntervalInDays)),
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Experimental$FormField$value = function (_v0) {
	var formField = _v0.a;
	return formField.value;
};
var $author$project$Components$SettingsPage$Account$CarrierPayments$toForm = function (model) {
	return {
		carrierDaysToPay: $author$project$Experimental$FormField$value(model.carrierDaysToPay),
		quickpayDiscount: $author$project$Experimental$FormField$value(model.quickpayDiscount),
		quickpayDiscountDisabled: $author$project$Experimental$FormField$value(model.quickpayDiscountDisabled)
	};
};
var $author$project$Components$SettingsPage$Account$InvoiceSettings$toForm = function (model) {
	return {
		autoApprove: $author$project$Experimental$FormField$value(model.autoApprove),
		autoApproveEditEnabled: model.autoApproveEditEnabled,
		invoiceDateStrategy: $author$project$Experimental$FormField$value(model.invoiceDateStrategy)
	};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toForm = function (model) {
	return {
		carrierInvoiceAmountToToleranceOver: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceOver),
		carrierInvoiceAmountToToleranceUnder: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceUnder),
		carrierInvoiceAmountToToleranceUnit: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceUnit),
		carrierInvoiceAmountToleranceLineItemTypeId: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceLineItemTypeId),
		ltlCarrierInvoiceAmountToToleranceOver: $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceOver),
		ltlCarrierInvoiceAmountToToleranceUnder: $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceUnder),
		ltlCarrierInvoiceAmountToToleranceUnit: $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceUnit),
		ltlMarginToleranceMaximum: $author$project$Experimental$FormField$value(model.ltlMarginToleranceEnabled) ? $author$project$Experimental$FormField$value(model.ltlMarginToleranceMaximum) : '',
		ltlMarginToleranceMinimum: $author$project$Experimental$FormField$value(model.ltlMarginToleranceEnabled) ? $author$project$Experimental$FormField$value(model.ltlMarginToleranceMinimum) : '',
		ltlMarginToleranceUnit: $author$project$Experimental$FormField$value(model.ltlMarginToleranceUnit)
	};
};
var $author$project$Components$SettingsPage$AccountSettingsView$saveMain = function (loadedModel) {
	var form = {
		invoice: $author$project$Components$SettingsPage$Account$InvoiceSettings$toForm(
			$author$project$Components$SettingsPage$EditableSection$current(loadedModel.invoiceSettingsEditableSection)),
		payment: $author$project$Components$SettingsPage$Account$CarrierPayments$toForm(
			$author$project$Components$SettingsPage$EditableSection$current(loadedModel.carrierPaymentsEditableSection)),
		tolerance: $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toForm(
			$author$project$Components$SettingsPage$EditableSection$current(loadedModel.invoiceToleranceSettingsEditableSection))
	};
	var post = {
		autoApprove: form.invoice.autoApprove,
		carrierDaysToPay: form.payment.carrierDaysToPay,
		carrierInvoiceAmountToleranceLineItemTypeId: form.tolerance.carrierInvoiceAmountToleranceLineItemTypeId,
		carrierInvoiceAmountToleranceOver: form.tolerance.carrierInvoiceAmountToToleranceOver,
		carrierInvoiceAmountToleranceUnder: form.tolerance.carrierInvoiceAmountToToleranceUnder,
		carrierInvoiceAmountToleranceUnit: $author$project$AuditPb$toleranceUnitToString(form.tolerance.carrierInvoiceAmountToToleranceUnit),
		customInvoiceExceptionMessages: loadedModel.customInvoiceExceptionMessages,
		failedCadenceTransmissionRecipients: $author$project$Components$SettingsPage$EditableSection$current(loadedModel.failedCadenceTransmissionRecipientsEditableSection).content,
		invoiceDateStrategy: form.invoice.invoiceDateStrategy,
		ltlCarrierInvoiceAmountToleranceOver: form.tolerance.ltlCarrierInvoiceAmountToToleranceOver,
		ltlCarrierInvoiceAmountToleranceUnder: form.tolerance.ltlCarrierInvoiceAmountToToleranceUnder,
		ltlCarrierInvoiceAmountToleranceUnit: $author$project$AuditPb$toleranceUnitToString(form.tolerance.ltlCarrierInvoiceAmountToToleranceUnit),
		ltlMarginToleranceMaximum: form.tolerance.ltlMarginToleranceMaximum,
		ltlMarginToleranceMinimum: form.tolerance.ltlMarginToleranceMinimum,
		ltlMarginToleranceUnit: $author$project$AuditPb$toleranceUnitToString(form.tolerance.ltlMarginToleranceUnit),
		quickpayDiscount: form.payment.quickpayDiscount,
		quickpayDiscountDisabled: form.payment.quickpayDiscountDisabled,
		sendMissingDocumentsEmailDelayInHours: $elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailDelayInHours),
		sendMissingDocumentsEmailIntervalInDays: $elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailIntervalInDays),
		sendMissingDocumentsEmailTotalCount: $elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailTotalCount),
		sendMissingDocumentsEmailsEnabled: loadedModel.sendMissingDocumentsEmailsEnabled,
		validSourceDateRange: $author$project$Components$SettingsPage$EditableSection$current(loadedModel.validSourceDateRangeEditableSection),
		visibleTmsReferenceFieldLabels: loadedModel.visibleTmsReferenceFieldLabels
	};
	return _Utils_Tuple2(
		loadedModel,
		A2(
			$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
			$author$project$Components$SettingsPage$AccountSettingsView$UpdateMain,
			$author$project$Api$Accounts$settings(post)));
};
var $author$project$Components$SettingsPage$AccountSettingsView$setCarrierPayments = F2(
	function (carrierPaymentsEditableSection, loadedModel) {
		return _Utils_update(
			loadedModel,
			{carrierPaymentsEditableSection: carrierPaymentsEditableSection});
	});
var $author$project$Components$SettingsPage$AccountSettingsView$setInvoiceSettingsModel = F2(
	function (invoiceSettingsEditableSection, loadedModel) {
		return _Utils_update(
			loadedModel,
			{invoiceSettingsEditableSection: invoiceSettingsEditableSection});
	});
var $author$project$Components$SettingsPage$AccountSettingsView$setInvoiceToleranceSettingsModel = F2(
	function (invoiceToleranceSettingsEditableSection, loadedModel) {
		return _Utils_update(
			loadedModel,
			{invoiceToleranceSettingsEditableSection: invoiceToleranceSettingsEditableSection});
	});
var $author$project$Setter$toUpdater = F3(
	function (setter, f, model) {
		return A2(
			setter,
			f(model),
			model);
	});
var $author$project$Components$SettingsPage$EditableSection$toggle = F2(
	function (open, _v0) {
		var section = _v0.a;
		return open ? $author$project$Components$SettingsPage$EditableSection$EditableSection(
			_Utils_update(
				section,
				{
					editing: $elm$core$Maybe$Just(section.original)
				})) : $author$project$Components$SettingsPage$EditableSection$EditableSection(
			_Utils_update(
				section,
				{editing: $elm$core$Maybe$Nothing}));
	});
var $author$project$Experimental$FormField$alwaysValid = $elm$core$Basics$always(
	$elm$core$Result$Ok(_Utils_Tuple0));
var $author$project$Components$SettingsPage$Account$CarrierPayments$numberBetween = F2(
	function (lower, upper) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toInt,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$fromMaybe('Input must be an integer.'),
				$elm$core$Result$andThen(
					function (value) {
						return ((_Utils_cmp(value, lower) > -1) && (_Utils_cmp(value, upper) < 1)) ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err(
							'Must be between ' + ($elm$core$String$fromInt(lower) + (' — ' + $elm$core$String$fromInt(upper))));
					})));
	});
var $author$project$Experimental$FormField$update = F3(
	function (_v0, value_, validate_) {
		var formField = _v0.a;
		return $author$project$Experimental$FormField$FormField(
			_Utils_update(
				formField,
				{
					feedback: A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(
							validate_(value_)),
						formField.feedback),
					value: value_
				}));
	});
var $author$project$Components$SettingsPage$Account$CarrierPayments$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateCarrierDaysToPay':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						carrierDaysToPay: A3(
							$author$project$Experimental$FormField$update,
							model.carrierDaysToPay,
							string,
							A2($author$project$Components$SettingsPage$Account$CarrierPayments$numberBetween, 0, 9999))
					});
			case 'UpdateQuickpayDiscount':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						quickpayDiscount: A3(
							$author$project$Experimental$FormField$update,
							model.quickpayDiscount,
							string,
							A2($author$project$Components$SettingsPage$Account$CarrierPayments$numberBetween, 0, 100))
					});
			default:
				var bool = msg.a;
				return _Utils_update(
					model,
					{
						quickpayDiscountDisabled: A3($author$project$Experimental$FormField$update, model.quickpayDiscountDisabled, bool, $author$project$Experimental$FormField$alwaysValid)
					});
		}
	});
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$moveItem = F3(
	function (from, to, list) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var i = _v1.a;
					return _Utils_eq(i, from);
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, list)));
		if (_v0.$ === 'Nothing') {
			return list;
		} else {
			var _v2 = _v0.a;
			var item = _v2.b;
			var without = A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					function (_v3) {
						var i = _v3.a;
						return !_Utils_eq(i, from);
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, list)));
			return _Utils_ap(
				A2($elm$core$List$take, to, without),
				_Utils_ap(
					_List_fromArray(
						[item]),
					A2($elm$core$List$drop, to, without)));
		}
	});
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'SetDisplay':
				var index = msg.a;
				var display = msg.b;
				return _Utils_update(
					model,
					{
						settings: A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, setting) {
									return _Utils_eq(i, index) ? _Utils_update(
										setting,
										{display: display}) : setting;
								}),
							model.settings)
					});
			case 'DragStart':
				var index = msg.a;
				return _Utils_update(
					model,
					{
						dragOverIndex: $elm$core$Maybe$Nothing,
						draggingIndex: $elm$core$Maybe$Just(index)
					});
			case 'DragOver':
				var index = msg.a;
				return _Utils_update(
					model,
					{
						dragOverIndex: $elm$core$Maybe$Just(index)
					});
			case 'Drop':
				var toIndex = msg.a;
				var _v1 = model.draggingIndex;
				if (_v1.$ === 'Nothing') {
					return model;
				} else {
					var fromIndex = _v1.a;
					return _Utils_update(
						model,
						{
							dragOverIndex: $elm$core$Maybe$Nothing,
							draggingIndex: $elm$core$Maybe$Nothing,
							settings: A3($author$project$Components$SettingsPage$Account$ClientNotesConfiguration$moveItem, fromIndex, toIndex, model.settings)
						});
				}
			default:
				return _Utils_update(
					model,
					{dragOverIndex: $elm$core$Maybe$Nothing, draggingIndex: $elm$core$Maybe$Nothing});
		}
	});
var $author$project$Components$SettingsPage$Account$InvoiceSettings$update = F2(
	function (msg, model) {
		if (msg.$ === 'UpdateDateStrategy') {
			var string = msg.a;
			return _Utils_update(
				model,
				{
					invoiceDateStrategy: A3($author$project$Experimental$FormField$update, model.invoiceDateStrategy, string, $author$project$Experimental$FormField$alwaysValid)
				});
		} else {
			var bool = msg.a;
			return _Utils_update(
				model,
				{
					autoApprove: A3($author$project$Experimental$FormField$update, model.autoApprove, bool, $author$project$Experimental$FormField$alwaysValid)
				});
		}
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateAmountToleranceOver':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						carrierInvoiceAmountToleranceOver: A3($author$project$Experimental$FormField$update, model.carrierInvoiceAmountToleranceOver, string, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateAmountToleranceUnder':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						carrierInvoiceAmountToleranceUnder: A3($author$project$Experimental$FormField$update, model.carrierInvoiceAmountToleranceUnder, string, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateAmountToleranceUnit':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						carrierInvoiceAmountToleranceUnit: A3(
							$author$project$Experimental$FormField$update,
							model.carrierInvoiceAmountToleranceUnit,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$AuditPb$toleranceUnitDefault,
								$author$project$AuditPb$toleranceUnitFromString(string)),
							$author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateAmountToleranceUnitV3Reskin':
				var toleranceUnit = msg.a;
				return _Utils_update(
					model,
					{
						carrierInvoiceAmountToleranceUnit: A3($author$project$Experimental$FormField$update, model.carrierInvoiceAmountToleranceUnit, toleranceUnit, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateAmountToleranceLineItemType':
				var maybeId = msg.a;
				return _Utils_update(
					model,
					{
						carrierInvoiceAmountToleranceLineItemTypeId: A3($author$project$Experimental$FormField$update, model.carrierInvoiceAmountToleranceLineItemTypeId, maybeId, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlAmountToleranceOver':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						ltlCarrierInvoiceAmountToleranceOver: A3($author$project$Experimental$FormField$update, model.ltlCarrierInvoiceAmountToleranceOver, string, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlAmountToleranceUnder':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						ltlCarrierInvoiceAmountToleranceUnder: A3($author$project$Experimental$FormField$update, model.ltlCarrierInvoiceAmountToleranceUnder, string, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlAmountToleranceUnit':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						ltlCarrierInvoiceAmountToleranceUnit: A3(
							$author$project$Experimental$FormField$update,
							model.ltlCarrierInvoiceAmountToleranceUnit,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$AuditPb$toleranceUnitDefault,
								$author$project$AuditPb$toleranceUnitFromString(string)),
							$author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlAmountToleranceUnitV3Reskin':
				var toleranceUnit = msg.a;
				return _Utils_update(
					model,
					{
						ltlCarrierInvoiceAmountToleranceUnit: A3($author$project$Experimental$FormField$update, model.ltlCarrierInvoiceAmountToleranceUnit, toleranceUnit, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlMarginToleranceEnabled':
				var enabled = msg.a;
				return _Utils_update(
					model,
					{
						ltlMarginToleranceEnabled: A3($author$project$Experimental$FormField$update, model.ltlMarginToleranceEnabled, enabled, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlMarginToleranceUnit':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						ltlMarginToleranceUnit: A3(
							$author$project$Experimental$FormField$update,
							model.ltlMarginToleranceUnit,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$AuditPb$toleranceUnitDefault,
								$author$project$AuditPb$toleranceUnitFromString(string)),
							$author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlMarginToleranceUnitV3Reskin':
				var toleranceUnit = msg.a;
				return _Utils_update(
					model,
					{
						ltlMarginToleranceUnit: A3($author$project$Experimental$FormField$update, model.ltlMarginToleranceUnit, toleranceUnit, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlMarginToleranceMinimum':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						ltlMarginToleranceMinimum: A3($author$project$Experimental$FormField$update, model.ltlMarginToleranceMinimum, string, $author$project$Experimental$FormField$alwaysValid)
					});
			case 'UpdateLtlMarginToleranceMaximum':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						ltlMarginToleranceMaximum: A3($author$project$Experimental$FormField$update, model.ltlMarginToleranceMaximum, string, $author$project$Experimental$FormField$alwaysValid)
					});
			default:
				return model;
		}
	});
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$dragContext = 'tms-reference-fields';
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$GotFieldsContainerElement = function (a) {
	return {$: 'GotFieldsContainerElement', a: a};
};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$fieldsContainerId = 'fields-container';
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$getFieldsContainerElement = $author$project$HubTran$Effect$cmd(
	A2(
		$elm$core$Task$attempt,
		$author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$GotFieldsContainerElement,
		$elm$browser$Browser$Dom$getElement($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$fieldsContainerId)));
var $author$project$Js$setupDragHandlers = _Platform_outgoingPort('setupDragHandlers', $elm$json$Json$Encode$string);
var $author$project$Js$setupDropHandlers = _Platform_outgoingPort('setupDropHandlers', $elm$json$Json$Encode$string);
var $author$project$Drag$setupHandlers = function (key) {
	return $author$project$HubTran$Effect$cmd(
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Js$setupDragHandlers(key),
					$author$project$Js$setupDropHandlers(key)
				])));
};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$update = F2(
	function (msg, state) {
		switch (msg.$) {
			case 'LoadedAvailableFields':
				return _Utils_Tuple2(state, $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$getFieldsContainerElement);
			case 'LoadedSelectedFields':
				return _Utils_Tuple2(
					state,
					$author$project$Drag$setupHandlers($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$dragContext));
			case 'DragStart':
				var field = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							subject: $elm$core$Maybe$Just(field)
						}),
					$author$project$HubTran$Effect$none);
			case 'DragStop':
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{subject: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'GotFieldsContainerElement':
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							fieldsContainer: $elm$core$Result$toMaybe(result)
						}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(state, $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$getFieldsContainerElement);
		}
	});
var $author$project$Components$SettingsPage$AccountSettingsView$updateLoaded = F3(
	function (model, loadedMsg, loadedModel) {
		switch (loadedMsg.$) {
			case 'SaveMainForm':
				return $author$project$Components$SettingsPage$AccountSettingsView$saveMain(loadedModel);
			case 'ToggleInvoiceSettings':
				var open = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							invoiceSettingsEditableSection: A2($author$project$Components$SettingsPage$EditableSection$toggle, open, loadedModel.invoiceSettingsEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleInvoiceToleranceSettings':
				var open = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							invoiceToleranceSettingsEditableSection: A2($author$project$Components$SettingsPage$EditableSection$toggle, open, loadedModel.invoiceToleranceSettingsEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleCarrierPayments':
				var open = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							carrierPaymentsEditableSection: A2($author$project$Components$SettingsPage$EditableSection$toggle, open, loadedModel.carrierPaymentsEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleExceptionSettings':
				var open = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							validSourceDateRangeEditableSection: A2($author$project$Components$SettingsPage$EditableSection$toggle, open, loadedModel.validSourceDateRangeEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleCadenceSettings':
				var open = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							failedCadenceTransmissionRecipientsEditableSection: A2($author$project$Components$SettingsPage$EditableSection$toggle, open, loadedModel.failedCadenceTransmissionRecipientsEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			case 'InvoiceSettingsMsg':
				var invoiceSettingsMsg = loadedMsg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Setter$toUpdater,
						$author$project$Components$SettingsPage$AccountSettingsView$setInvoiceSettingsModel,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$SettingsPage$EditableSection$map(
								$author$project$Components$SettingsPage$Account$InvoiceSettings$update(invoiceSettingsMsg)),
							function ($) {
								return $.invoiceSettingsEditableSection;
							}),
						loadedModel),
					$author$project$HubTran$Effect$none);
			case 'InvoiceToleranceSettingsMsg':
				var invoiceToleranceSettingsMsg = loadedMsg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Setter$toUpdater,
						$author$project$Components$SettingsPage$AccountSettingsView$setInvoiceToleranceSettingsModel,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$SettingsPage$EditableSection$map(
								$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$update(invoiceToleranceSettingsMsg)),
							function ($) {
								return $.invoiceToleranceSettingsEditableSection;
							}),
						loadedModel),
					$author$project$HubTran$Effect$none);
			case 'CarrierPaymentsMsg':
				var carrierPaymentsMsg = loadedMsg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Setter$toUpdater,
						$author$project$Components$SettingsPage$AccountSettingsView$setCarrierPayments,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$SettingsPage$EditableSection$map(
								$author$project$Components$SettingsPage$Account$CarrierPayments$update(carrierPaymentsMsg)),
							function ($) {
								return $.carrierPaymentsEditableSection;
							}),
						loadedModel),
					$author$project$HubTran$Effect$none);
			case 'ClientNotesConfigurationMsg':
				var clientNotesMsg = loadedMsg.a;
				var newModel = A2($author$project$Components$SettingsPage$Account$ClientNotesConfiguration$update, clientNotesMsg, loadedModel.clientNotesConfigurationModel);
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{clientNotesConfigurationModel: newModel}),
					(!_Utils_eq(newModel.settings, loadedModel.clientNotesConfigurationModel.settings)) ? A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateClientNotesConfiguration,
						$author$project$Api$Accounts$saveClientNotesConfiguration(newModel.settings)) : $author$project$HubTran$Effect$none);
			case 'FailedCadenceTransmissionChange':
				var value = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							failedCadenceTransmissionRecipientsEditableSection: A2(
								$author$project$Components$SettingsPage$EditableSection$map,
								$elm$core$Basics$always(
									{
										content: value,
										valid: $author$project$Domain$EmailAddress$isValidList(value)
									}),
								loadedModel.failedCadenceTransmissionRecipientsEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			case 'ExceptionOldInvoicesAfterChange':
				var value = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							validSourceDateRangeEditableSection: A2(
								$author$project$Components$SettingsPage$EditableSection$map,
								$elm$core$Basics$always(value),
								loadedModel.validSourceDateRangeEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			case 'SelectTmsReferenceFieldLabel':
				var string = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							visibleTmsReferenceFieldLabels: A2($elm$core$List$cons, string, loadedModel.visibleTmsReferenceFieldLabels)
						}),
					$author$project$HubTran$Effect$none);
			case 'UnselectTmsReferenceFieldLabel':
				var string = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							visibleTmsReferenceFieldLabels: A2($author$project$Components$SettingsPage$AccountSettingsView$remove, string, loadedModel.visibleTmsReferenceFieldLabels)
						}),
					$author$project$HubTran$Effect$none);
			case 'ReorderTmsReferenceFieldLabel':
				var to = loadedMsg.a;
				var string = loadedMsg.b;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							visibleTmsReferenceFieldLabels: A3(
								$author$project$Components$SettingsPage$AccountSettingsView$insertAt,
								to,
								string,
								A2($author$project$Components$SettingsPage$AccountSettingsView$remove, string, loadedModel.visibleTmsReferenceFieldLabels))
						}),
					$author$project$HubTran$Effect$none);
			case 'TmsReferenceFieldsMsg':
				var msg = loadedMsg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (x) {
						return _Utils_update(
							loadedModel,
							{tmsReferenceFieldsState: x});
					},
					$author$project$HubTran$Effect$map(
						A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$AccountSettingsView$TmsReferenceFieldsMsg, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg)),
					A2($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$update, msg, loadedModel.tmsReferenceFieldsState));
			case 'CreateCustomInvoiceExceptionMessage':
				return $author$project$Components$SettingsPage$AccountSettingsView$saveMain(
					_Utils_update(
						loadedModel,
						{
							customInvoiceExceptionMessages: _Utils_ap(
								loadedModel.customInvoiceExceptionMessages,
								_List_fromArray(
									[model.newCustomInvoiceExceptionMessage]))
						}));
			case 'DeleteCustomInvoiceExceptionMessage':
				var message = loadedMsg.a;
				return $author$project$Components$SettingsPage$AccountSettingsView$saveMain(
					_Utils_update(
						loadedModel,
						{
							customInvoiceExceptionMessages: A2($author$project$Components$SettingsPage$AccountSettingsView$remove, message, loadedModel.customInvoiceExceptionMessages)
						}));
			case 'ToggleMissingDocumentsEmails':
				var enabled = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{sendMissingDocumentsEmailsEnabled: enabled}),
					$author$project$HubTran$Effect$none);
			case 'ChangeMissingDocumentsEmailDelay':
				var value = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							sendMissingDocumentsEmailDelayInHours: A2(
								$elm$core$Maybe$withDefault,
								24,
								$elm$core$String$toInt(value))
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangeMissingDocumentsEmailTotalCount':
				var value = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							sendMissingDocumentsEmailTotalCount: A2(
								$elm$core$Maybe$withDefault,
								1,
								$elm$core$String$toInt(value))
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangeMissingDocumentsEmailInterval':
				var value = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							sendMissingDocumentsEmailIntervalInDays: A2(
								$elm$core$Maybe$withDefault,
								3,
								$elm$core$String$toInt(value))
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleImplicitCarrierInvoiceSection':
				var open = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							allowImplicitCarrierInvoiceEditableSection: A2($author$project$Components$SettingsPage$EditableSection$toggle, open, loadedModel.allowImplicitCarrierInvoiceEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleImplicitCarrierInvoiceValue':
				var value = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							allowImplicitCarrierInvoiceEditableSection: A2(
								$author$project$Components$SettingsPage$EditableSection$map,
								$elm$core$Basics$always(value),
								loadedModel.allowImplicitCarrierInvoiceEditableSection)
						}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					loadedModel,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateImplicitCarrierInvoice,
						$author$project$Api$Accounts$saveAllowImplicitCarrierInvoice(
							$author$project$Components$SettingsPage$EditableSection$current(loadedModel.allowImplicitCarrierInvoiceEditableSection))));
		}
	});
var $author$project$Components$SettingsPage$AccountSettingsView$updateable = function (subject) {
	switch (subject.$) {
		case 'UpdateMain':
			return {
				clear: function (x) {
					return _Utils_update(
						x,
						{newCustomInvoiceExceptionMessage: ''});
				},
				name: 'account settings'
			};
		case 'UpdateOfficePeopleMappings':
			return {
				clear: function (x) {
					return _Utils_update(
						x,
						{newOfficeMapping: '', newPeopleMapping: ''});
				},
				name: 'office-people mappings'
			};
		case 'UpdateAutoReplyFilters':
			return {
				clear: function (x) {
					return _Utils_update(
						x,
						{newAutoReplyFilterBody: '', newAutoReplyFilterEmailAddress: '', newAutoReplyFilterSubject: ''});
				},
				name: 'auto-reply filters'
			};
		case 'UpdateLoadCustomerLabels':
			return {
				clear: function (x) {
					return _Utils_update(
						x,
						{
							loadCustomerTypeahead: $author$project$Components$CustomerTypeahead$initWithSize(50),
							newLoadCustomerLabel: $author$project$Components$SettingsPage$AccountSettingsView$New(
								{name: '', source: $author$project$Api$LoadCustomerLabels$defaultSource})
						});
				},
				name: 'load customer labels'
			};
		case 'UpdateClientNotesConfiguration':
			return {clear: $elm$core$Basics$identity, name: 'client notes configuration'};
		default:
			return {clear: $elm$core$Basics$identity, name: 'implicit carrier invoice setting'};
	}
};
var $author$project$Components$SettingsPage$AccountSettingsView$update = F4(
	function (_v0, data, msg, model) {
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'FinishSaving':
				if (msg.a.$ === 'Ok') {
					var subject = msg.a.a;
					return _Utils_Tuple2(
						A2(
							function ($) {
								return $.clear;
							},
							$author$project$Components$SettingsPage$AccountSettingsView$updateable(subject),
							_Utils_update(
								model,
								{changes: $elm$core$Maybe$Nothing})),
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$success(
								'Successfully saved ' + function ($) {
									return $.name;
								}(
									$author$project$Components$SettingsPage$AccountSettingsView$updateable(subject)))));
				} else {
					var subject = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$alert(
								'Failed to save ' + function ($) {
									return $.name;
								}(
									$author$project$Components$SettingsPage$AccountSettingsView$updateable(subject)))));
				}
			case 'NewOfficeMappingChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{newOfficeMapping: value}),
					$author$project$HubTran$Effect$none);
			case 'NewPeopleMappingChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{newPeopleMapping: value}),
					$author$project$HubTran$Effect$none);
			case 'CreateOfficePeopleMapping':
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateOfficePeopleMappings,
						$author$project$Api$OfficePeopleMappings$create(
							{office: model.newOfficeMapping, person: model.newPeopleMapping})));
			case 'DeleteOfficePeopleMapping':
				var message = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateOfficePeopleMappings,
						$author$project$Api$OfficePeopleMappings$delete(message.id)));
			case 'NewCustomInvoiceExceptionMessageChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{newCustomInvoiceExceptionMessage: value}),
					$author$project$HubTran$Effect$none);
			case 'NewAutoReplyFilterEmailAddressChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{newAutoReplyFilterEmailAddress: value}),
					$author$project$HubTran$Effect$none);
			case 'NewAutoReplyFilterSubjectChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{newAutoReplyFilterSubject: value}),
					$author$project$HubTran$Effect$none);
			case 'NewAutoReplyFilterBodyChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{newAutoReplyFilterBody: value}),
					$author$project$HubTran$Effect$none);
			case 'CreateAutoReplyFilter':
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateAutoReplyFilters,
						$author$project$Api$AutoReplyFilters$create(
							{body: model.newAutoReplyFilterBody, email: model.newAutoReplyFilterEmailAddress, subject: model.newAutoReplyFilterSubject})));
			case 'DeleteAutoReplyFilter':
				var filter = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateAutoReplyFilters,
						$author$project$Api$AutoReplyFilters$delete(filter.id)));
			case 'LoadCustomerLabelNameChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newLoadCustomerLabel: function () {
								var _v2 = model.newLoadCustomerLabel;
								if (_v2.$ === 'New') {
									var x = _v2.a;
									return $author$project$Components$SettingsPage$AccountSettingsView$New(
										{name: value, source: x.source});
								} else {
									var newSource = _v2.a.newSource;
									var old = _v2.a.old;
									return $author$project$Components$SettingsPage$AccountSettingsView$Update(
										{_new: value, newSource: newSource, old: old});
								}
							}()
						}),
					$author$project$HubTran$Effect$none);
			case 'LoadCustomerLabelSourceChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newLoadCustomerLabel: function () {
								var _v3 = model.newLoadCustomerLabel;
								if (_v3.$ === 'New') {
									var x = _v3.a;
									return $author$project$Components$SettingsPage$AccountSettingsView$New(
										{name: x.name, source: value});
								} else {
									var _new = _v3.a._new;
									var old = _v3.a.old;
									return $author$project$Components$SettingsPage$AccountSettingsView$Update(
										{_new: _new, newSource: value, old: old});
								}
							}()
						}),
					$author$project$HubTran$Effect$none);
			case 'ExpandLoadCustomerLabel':
				var label = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							showLoadCustomerLabel: $elm$core$Maybe$Just(label)
						}),
					$author$project$HubTran$Effect$none);
			case 'CollapseLoadCustomerLabel':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showLoadCustomerLabel: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'EditLoadCustomerLabel':
				var label = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newLoadCustomerLabel: $author$project$Components$SettingsPage$AccountSettingsView$Update(
								{_new: label.name, newSource: label.source, old: label.name})
						}),
					$author$project$HubTran$Effect$none);
			case 'SaveLoadCustomerLabel':
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateLoadCustomerLabels,
						function () {
							var _v4 = model.newLoadCustomerLabel;
							if (_v4.$ === 'New') {
								var x = _v4.a;
								return $author$project$Api$LoadCustomerLabels$create(x);
							} else {
								var x = _v4.a;
								return $author$project$Api$LoadCustomerLabels$update(x);
							}
						}()));
			case 'AddCustomerToLoadCustomerLabel':
				var label = msg.a;
				var customerId = msg.b;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateLoadCustomerLabels,
						A2($author$project$Api$LoadCustomerLabels$addCustomer, label.name, customerId)));
			case 'DeleteLoadCustomerLabel':
				var label = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateLoadCustomerLabels,
						$author$project$Api$LoadCustomerLabels$delete(label.name)));
			case 'DeleteLoadCustomerLabelCustomer':
				var label = msg.a;
				var customer = msg.b;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Components$SettingsPage$AccountSettingsView$sendSave,
						$author$project$Components$SettingsPage$AccountSettingsView$UpdateLoadCustomerLabels,
						A2($author$project$Api$LoadCustomerLabels$removeCustomer, label.name, customer.id)));
			case 'LoadedMsg':
				var loadedMsg = msg.a;
				var loadedModel = A2($author$project$Components$SettingsPage$AccountSettingsView$loadedModelFromData, data, model);
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{
								changes: $elm$core$Maybe$Just(x)
							});
					},
					A3($author$project$Components$SettingsPage$AccountSettingsView$updateLoaded, model, loadedMsg, loadedModel));
			case 'CustomerTypeaheadMsg':
				var childMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loadCustomerTypeahead: A3($author$project$Components$CustomerTypeahead$update, data.customerTypeahead, childMsg, model.loadCustomerTypeahead)
						}),
					$author$project$HubTran$Effect$none);
			default:
				var childMsg = msg.a;
				var _v5 = A4($author$project$Components$TmsCustomerDropdown$update, data.accountSettings, data.customerTypeaheadReskin, childMsg, model.loadCustomerTypeaheadReskin);
				var newDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{loadCustomerTypeaheadReskin: newDropdown}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$AccountSettingsView$CustomerTypeaheadReskinMsg, cmd)));
		}
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$FinishDeleteContact = function (a) {
	return {$: 'FinishDeleteContact', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettingsView$FinishUpdateOrCreateContact = function (a) {
	return {$: 'FinishUpdateOrCreateContact', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettingsView$ShowCreateContact = {$: 'ShowCreateContact'};
var $author$project$Components$SettingsPage$ContactsSettingsView$ShowEditContact = function (a) {
	return {$: 'ShowEditContact', a: a};
};
var $author$project$Components$SettingsPage$ContactForm$typeToString = function (contactType) {
	if (contactType.$ === 'General') {
		return 'general';
	} else {
		return 'carrier';
	}
};
var $author$project$Components$SettingsPage$ContactForm$contactFormFromModel = F2(
	function (v3ReskinEnabled, model) {
		return {
			carrier_id: A2(
				$elm$core$Maybe$map,
				$author$project$Domain$TmsCarrierId$toInt,
				v3ReskinEnabled ? $elm$core$List$head(
					$author$project$Components$SettingsPage$CarrierDropdown$selectedIds(model.carrierDropdown)) : $author$project$Typeahead$selectedId(model.carrierTypeahead)),
			contact_type: $author$project$Components$SettingsPage$ContactForm$typeToString(model.selectedContactType),
			email: model.emailInput,
			name: model.nameInput
		};
	});
var $author$project$Api$Contacts$baseUrl = '/api/contacts/';
var $author$project$Encode$ContactEncoder$encodeContact = function (contactForm) {
	var _v0 = contactForm.carrier_id;
	if (_v0.$ === 'Just') {
		var carrier_id = _v0.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(contactForm.email)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(contactForm.name)),
					_Utils_Tuple2(
					'contact_type',
					$elm$json$Json$Encode$string(contactForm.contact_type)),
					_Utils_Tuple2(
					'carrier_id',
					$elm$json$Json$Encode$int(carrier_id))
				]));
	} else {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(contactForm.email)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(contactForm.name)),
					_Utils_Tuple2(
					'contact_type',
					$elm$json$Json$Encode$string(contactForm.contact_type))
				]));
	}
};
var $author$project$Api$Contacts$createContact = function (contactForm) {
	var url = $author$project$Api$Contacts$baseUrl;
	var encodedContact = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'contact',
				$author$project$Encode$ContactEncoder$encodeContact(contactForm))
			]));
	return A2($author$project$Helpers$Api$postWithNoResponseBody, url, encodedContact);
};
var $author$project$Components$SettingsPage$ContactsSettingsView$createContact = function (createContactForm) {
	return $author$project$Api$Contacts$createContact(createContactForm);
};
var $author$project$Api$Contacts$baseUrlForAContact = function (contactId) {
	var contactIdToString = $elm$core$String$fromInt(
		$author$project$Domain$ContactId$toInt(contactId));
	return _Utils_ap($author$project$Api$Contacts$baseUrl, contactIdToString);
};
var $author$project$Api$Contacts$deleteContacts = function (contactId) {
	var url = $author$project$Api$Contacts$baseUrlForAContact(contactId);
	return $author$project$Helpers$Api$delete(url);
};
var $author$project$Components$SettingsPage$ContactsSettingsView$deleteContact = function (contactId) {
	return $author$project$Api$Contacts$deleteContacts(contactId);
};
var $author$project$Components$SettingsPage$CarrierDropdown$select = F2(
	function (items, model) {
		return _Utils_update(
			model,
			{
				dropdown: A2($author$project$Components$PaginatedDropdown$select, items, model.dropdown)
			});
	});
var $author$project$Components$SettingsPage$ContactForm$Carrier = {$: 'Carrier'};
var $author$project$Components$SettingsPage$ContactForm$typeFromString = function (string) {
	switch (string) {
		case 'general':
			return $elm$core$Maybe$Just($author$project$Components$SettingsPage$ContactForm$General);
		case 'carrier':
			return $elm$core$Maybe$Just($author$project$Components$SettingsPage$ContactForm$Carrier);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$SettingsPage$ContactForm$initWithContactForm = F2(
	function (maybeTmsCarrier, contactForm) {
		var carrierTypeahead = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$CarrierTypeahead$init,
			A2(
				$elm$core$Maybe$map,
				function (tmsCarrier) {
					return $author$project$Components$CarrierTypeahead$initWithTmsCarrier(tmsCarrier.id);
				},
				maybeTmsCarrier));
		var _v0 = $author$project$Components$SettingsPage$CarrierDropdown$init(
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead)
				]));
		var carrierDropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{
				carrierDropdown: function () {
					if (maybeTmsCarrier.$ === 'Just') {
						var tmsCarrier = maybeTmsCarrier.a;
						return A2(
							$author$project$Components$SettingsPage$CarrierDropdown$select,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$CarrierDropdown$carrierToDropdownItem(tmsCarrier)
								]),
							carrierDropdown);
					} else {
						return carrierDropdown;
					}
				}(),
				carrierTypeahead: carrierTypeahead,
				emailInput: contactForm.email,
				nameInput: contactForm.name,
				selectedContactType: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$SettingsPage$ContactForm$General,
					$author$project$Components$SettingsPage$ContactForm$typeFromString(contactForm.contact_type))
			},
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$ContactForm$CarrierDropdownMsg, cmd)));
	});
var $author$project$Components$SettingsPage$ContactForm$isValid = function (contactForm) {
	var _v0 = contactForm.contact_type;
	if (_v0 === 'carrier') {
		var _v1 = contactForm.carrier_id;
		if (_v1.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	} else {
		return true;
	}
};
var $author$project$Components$SettingsPage$ContactForm$carrierTypeaheadConfig = function (data) {
	var accountType = A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.account;
			},
			$author$project$Domain$Account$accountType),
		$author$project$Forward$Remote$toMaybe(data));
	var config = $author$project$Components$CarrierTypeahead$config(accountType);
	var updatedItemDisplay = function (tmsCarrier) {
		var _v0 = _Utils_Tuple2(tmsCarrier.inactiveAt, accountType);
		if (((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) && (_v0.b.a.$ === 'FactorAccount')) {
			var _v1 = _v0.b.a;
			return tmsCarrier.name + ' (inactive)';
		} else {
			return tmsCarrier.name;
		}
	};
	return _Utils_update(
		config,
		{
			itemDisplay: A2($elm$core$Basics$composeR, updatedItemDisplay, $elm$html$Html$text)
		});
};
var $author$project$Components$SettingsPage$ContactForm$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'CarrierTypeaheadMsg':
				var msg_ = msg.a;
				var typeaheadData = A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.carrierTypeaheadData;
					},
					data);
				var carrierTypeaheadConfig_ = $author$project$Components$SettingsPage$ContactForm$carrierTypeaheadConfig(data);
				var newCarrierTypeahead = A4($author$project$Components$CarrierTypeahead$update, carrierTypeaheadConfig_, typeaheadData, msg_, model.carrierTypeahead);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{carrierTypeahead: newCarrierTypeahead}),
					$author$project$HubTran$Effect$none);
			case 'CarrierDropdownMsg':
				var msg_ = msg.a;
				var dropdownData = A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.carrierDropdownData;
					},
					data);
				var _v1 = function () {
					var _v2 = $author$project$Forward$Remote$toMaybe(data);
					if (_v2.$ === 'Just') {
						return A3($author$project$Components$SettingsPage$CarrierDropdown$update, dropdownData, msg_, model.carrierDropdown);
					} else {
						return _Utils_Tuple2(model.carrierDropdown, $elm$core$Platform$Cmd$none);
					}
				}();
				var newCarrierDropdown = _v1.a;
				var carrierDropdownCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{carrierDropdown: newCarrierDropdown}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$ContactForm$CarrierDropdownMsg, carrierDropdownCmd)));
			case 'SetNameInput':
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nameInput: name}),
					$author$project$HubTran$Effect$none);
			case 'SetEmailInput':
				var email = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{emailInput: email}),
					$author$project$HubTran$Effect$none);
			default:
				var contactType = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedContactType: A2(
								$elm$core$Maybe$withDefault,
								model.selectedContactType,
								$author$project$Components$SettingsPage$ContactForm$typeFromString(contactType))
						}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$ContactsFilter$carrierTypeaheadConfigFromRemote = function (data) {
	return $author$project$Components$CarrierTypeahead$config(
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.account;
				},
				$author$project$Domain$Account$accountType),
			$author$project$Forward$Remote$toMaybe(data)));
};
var $author$project$AuditPb$ContactTypeCarrier = {$: 'ContactTypeCarrier'};
var $author$project$AuditPb$ContactTypeGeneral = {$: 'ContactTypeGeneral'};
var $author$project$Domain$ContactIdsQuery$fromString = function (contactTypeString) {
	switch (contactTypeString) {
		case 'general':
			return $author$project$AuditPb$ContactTypeGeneral;
		case 'carrier':
			return $author$project$AuditPb$ContactTypeCarrier;
		case 'organization':
			return $author$project$AuditPb$ContactTypeCarrier;
		case 'client':
			return $author$project$AuditPb$ContactTypeCarrier;
		default:
			return $author$project$AuditPb$ContactTypeAll;
	}
};
var $author$project$Components$SettingsPage$ContactsFilter$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'CarrierTypeaheadMsg':
				var msg_ = msg.a;
				var typeaheadData = A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.carrierTypeaheadData;
					},
					data);
				var carrierTypeaheadConfig_ = $author$project$Components$SettingsPage$ContactsFilter$carrierTypeaheadConfigFromRemote(data);
				var newCarrierTypeahead = A4($author$project$Components$CarrierTypeahead$update, carrierTypeaheadConfig_, typeaheadData, msg_, model.carrierTypeahead);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{carrierTypeahead: newCarrierTypeahead}),
					$author$project$HubTran$Effect$none);
			case 'CarrierDropdownMsg':
				var msg_ = msg.a;
				var dropdownData = A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.carrierDropdownData;
					},
					data);
				var _v1 = function () {
					var _v2 = $author$project$Forward$Remote$toMaybe(data);
					if (_v2.$ === 'Just') {
						return A3($author$project$Components$SettingsPage$CarrierDropdown$update, dropdownData, msg_, model.carrierDropdown);
					} else {
						return _Utils_Tuple2(model.carrierDropdown, $elm$core$Platform$Cmd$none);
					}
				}();
				var newCarrierDropdown = _v1.a;
				var carrierDropdownCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{carrierDropdown: newCarrierDropdown}),
					$author$project$HubTran$Effect$cmd(
						A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$ContactsFilter$CarrierDropdownMsg, carrierDropdownCmd)));
			case 'SelectContactType':
				var contactType = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedContactType: $author$project$Domain$ContactIdsQuery$fromString(contactType)
						}),
					$author$project$HubTran$Effect$none);
			case 'UpdateTerm':
				var term = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{emailSearchTerm: term}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{emailSearchTerm: ''}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Api$Contacts$updateContact = F2(
	function (contactId, updateContactForm) {
		var url = $author$project$Api$Contacts$baseUrlForAContact(contactId);
		var encodedContact = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'contact',
					$author$project$Encode$ContactEncoder$encodeContact(updateContactForm)),
					_Utils_Tuple2(
					'elm',
					$elm$json$Json$Encode$bool(true))
				]));
		return A2($author$project$Helpers$Api$putWithNoResponseBody, url, encodedContact);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$updateContact = F2(
	function (contactId, updateContactForm) {
		return A2($author$project$Api$Contacts$updateContact, contactId, updateContactForm);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$update = F4(
	function (v3ReskinEnabled, data, msg, model) {
		var carrierTerm = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Helpers$String$nbsp,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.currentAccount;
					},
					A2($elm$core$Basics$composeR, $author$project$Domain$Account$accountType, $author$project$Domain$Account$carrierTerm)),
				$author$project$Forward$Remote$toMaybe(data)));
		switch (msg.$) {
			case 'ViewEditContact':
				var contactId = msg.a;
				var form = msg.b;
				var maybeTmsCarrier = msg.c;
				var _v1 = A2($author$project$Components$SettingsPage$ContactForm$initWithContactForm, maybeTmsCarrier, form);
				var contactFormModel = _v1.a;
				var effect = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							contactFormModel: contactFormModel,
							viewState: $author$project$Components$SettingsPage$ContactsSettingsView$ShowEditContact(contactId)
						}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg, effect));
			case 'ViewList':
				var _v2 = $author$project$Components$SettingsPage$ContactsFilter$init;
				var contactFilter = _v2.a;
				var effect = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{contactFilterModel: contactFilter, viewState: $author$project$Components$SettingsPage$ContactsSettingsView$ShowList}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ContactsSettingsView$ContactFilterMsg, effect));
			case 'ViewCreateContact':
				var _v3 = $author$project$Components$SettingsPage$ContactForm$init;
				var contactForm = _v3.a;
				var effect = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{contactFormModel: contactForm, viewState: $author$project$Components$SettingsPage$ContactsSettingsView$ShowCreateContact}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg, effect));
			case 'DeleteContact':
				var contactId = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$ContactsSettingsView$FinishDeleteContact,
						$author$project$Components$SettingsPage$ContactsSettingsView$deleteContact(contactId)));
			case 'FinishDeleteContact':
				var result = msg.a;
				var invalidateCmd = $author$project$HubTran$Effect$invalidate(
					$author$project$Components$SettingsPage$ContactsSettingsView$loadData(model));
				switch (result.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{viewState: $author$project$Components$SettingsPage$ContactsSettingsView$ShowList}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										invalidateCmd,
										v3ReskinEnabled ? $author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Contact Deleted')) : $author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$alert('Contact Deleted'))
									])));
					case 'Err':
						var message = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('It didn\u0027t delete ' + message)));
					default:
						var error = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(
									'It didn\u0027t delete ' + $elm$core$Debug$toString(error))));
				}
			case 'UpdateContact':
				var contactId = msg.a;
				var updateForm = A2($author$project$Components$SettingsPage$ContactForm$contactFormFromModel, v3ReskinEnabled, model.contactFormModel);
				return $author$project$Components$SettingsPage$ContactForm$isValid(updateForm) ? _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$ContactsSettingsView$FinishUpdateOrCreateContact,
						A2($author$project$Components$SettingsPage$ContactsSettingsView$updateContact, contactId, updateForm))) : _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert('You must select a ' + (carrierTerm + '.'))));
			case 'FinishUpdateOrCreateContact':
				var response = msg.a;
				switch (response.$) {
					case 'Ok':
						var _v6 = $author$project$Components$SettingsPage$ContactsFilter$init;
						var contactFilter = _v6.a;
						var effect = _v6.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{contactFilterModel: contactFilter, viewState: $author$project$Components$SettingsPage$ContactsSettingsView$ShowList}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Contact Saved!')),
										A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ContactsSettingsView$ContactFilterMsg, effect)
									])));
					case 'Err':
						var message = response.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Couldn\u0027t save')));
				}
			case 'CreateContact':
				var createContactForm = A2($author$project$Components$SettingsPage$ContactForm$contactFormFromModel, v3ReskinEnabled, model.contactFormModel);
				return $author$project$Components$SettingsPage$ContactForm$isValid(createContactForm) ? _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$ContactsSettingsView$FinishUpdateOrCreateContact,
						$author$project$Components$SettingsPage$ContactsSettingsView$createContact(createContactForm))) : _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert('You must select a ' + (carrierTerm + '.'))));
			case 'UpdatePage':
				var newPageNumber = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{page: newPageNumber}),
					$author$project$HubTran$Effect$none);
			case 'ContactFormMsg':
				var childMsg = msg.a;
				var _v7 = A3(
					$author$project$Components$SettingsPage$ContactForm$update,
					A2(
						$author$project$Forward$Remote$map,
						function ($) {
							return $.contactFormData;
						},
						data),
					childMsg,
					model.contactFormModel);
				var newFormModel = _v7.a;
				var childEffects = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{contactFormModel: newFormModel}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg, childEffects));
			default:
				var childMsg = msg.a;
				var _v8 = A3(
					$author$project$Components$SettingsPage$ContactsFilter$update,
					A2(
						$author$project$Forward$Remote$map,
						function ($) {
							return $.contactFilterData;
						},
						data),
					childMsg,
					model.contactFilterModel);
				var newFilterModel = _v8.a;
				var childEffects = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{contactFilterModel: newFilterModel}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ContactsSettingsView$ContactFilterMsg, childEffects));
		}
	});
var $author$project$Components$SettingsPage$DebtorsSettingsView$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateTerm':
				var newTerm = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{searchTerm: newTerm}),
					$author$project$HubTran$Effect$none);
			case 'UpdatePage':
				var newPageNumber = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{page: newPageNumber}),
					$author$project$HubTran$Effect$none);
			default:
				var destination = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$pushUrl(destination));
		}
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$DocumentTypeForTruckPhotosSaveFinished = function (a) {
	return {$: 'DocumentTypeForTruckPhotosSaveFinished', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$DocumentTypes = function (a) {
	return {$: 'DocumentTypes', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$HotkeySaveFinished = function (a) {
	return {$: 'HotkeySaveFinished', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveComplete = F2(
	function (a, b) {
		return {$: 'SaveComplete', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$TmsMapSaveFinished = function (a) {
	return {$: 'TmsMapSaveFinished', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$TmsPodMapSaveFinished = function (a) {
	return {$: 'TmsPodMapSaveFinished', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$getOriginalTmsMap = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			function () {
				var _v0 = $author$project$Forward$Remote$toMaybe(data);
				if (_v0.$ === 'Nothing') {
					return $elm$core$Dict$empty;
				} else {
					var x = _v0.a;
					return x.documentTypeSettings.hubtranTmsDocumentTypeMap;
				}
			}(),
			model.lastSavedTmsMap);
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsMap = F2(
	function (data, model) {
		return A2(
			$elm$core$Dict$union,
			model.tmsMapEdits,
			A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$getOriginalTmsMap, data, model));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$getOriginalTmsPodMap = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			function () {
				var _v0 = $author$project$Forward$Remote$toMaybe(data);
				if (_v0.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var x = _v0.a;
					return x.documentTypeSettings.hubtranTmsPodDocumentTypeMap;
				}
			}(),
			model.lastSavedTmsPodMap);
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsPodMap = F2(
	function (data, model) {
		var _v0 = model.tmsPodMapEdit;
		if (_v0.$ === 'Nothing') {
			return A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$getOriginalTmsPodMap, data, model);
		} else {
			var x = _v0.a;
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(x)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(x);
		}
	});
var $author$project$Api$Settings$documentTypesJson = F2(
	function (payablesFieldName, items) {
		var predicate = function (pred) {
			return A2(
				$elm$core$List$map,
				function ($) {
					return $.documentType;
				},
				A2($elm$core$List$filter, pred, items));
		};
		var cadenceTypeToMap = A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			A3(
				$elm$core$List$foldl,
				F2(
					function (item, pairs) {
						var _v0 = item.cadenceTypeId;
						if (_v0.$ === 'Just') {
							var id = _v0.a;
							var encodedMap = A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$author$project$Encode$DocumentTypeEncoder$encodeDocumentType(item.documentType),
										$elm$json$Json$Encode$int(id)
									]));
							return _Utils_ap(
								pairs,
								_List_fromArray(
									[encodedMap]));
						} else {
							return pairs;
						}
					}),
				_List_Nil,
				items));
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2('cadence_image_type_map', cadenceTypeToMap)
					]),
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(
						A2(
							$elm$core$Basics$composeR,
							predicate,
							$elm$json$Json$Encode$list($author$project$Encode$DocumentTypeEncoder$encodeDocumentType))),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'types',
							$elm$core$Basics$always(true)),
							_Utils_Tuple2(
							'customer_visible_document_types',
							function ($) {
								return $.isIncludedForCustomer;
							}),
							_Utils_Tuple2(
							'required_receivables_types',
							function ($) {
								return $.isRequiredForCustomer;
							}),
							_Utils_Tuple2(
							payablesFieldName,
							function ($) {
								return $.isRequiredForPayables;
							})
						]))));
	});
var $author$project$Api$Settings$documentTypes = function (items) {
	return A3(
		$author$project$Helpers$Api$post,
		'/api/settings/document_types',
		A2($author$project$Api$Settings$documentTypesJson, 'required_payables_types_for_customer_billing', items),
		$elm$json$Json$Decode$value);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$setIsSaving = F2(
	function (bool, model) {
		return _Utils_update(
			model,
			{isSaving: bool});
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$handleSaveFinished = F2(
	function (model, result) {
		switch (result.$) {
			case 'Ok':
				var jsonValue = result.a;
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$setIsSaving, false, model),
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('Document Settings Saved!')),
								$author$project$HubTran$Effect$cmd(
								$author$project$TempJsInterop$sendToDataStoreService(jsonValue))
							])));
			case 'Err':
				var message = result.a;
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$setIsSaving, false, model),
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert(message)));
			default:
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$setIsSaving, false, model),
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert('An error occurred. Please try to save again.')));
		}
	});
var $author$project$Components$SettingsPage$Shared$DocumentTypeTable$MandatoryRow = {$: 'MandatoryRow'};
var $author$project$Components$SettingsPage$Shared$DocumentTypeTable$OptionalRow = {$: 'OptionalRow'};
var $author$project$Components$SettingsPage$Shared$Checkbox$Checked = {$: 'Checked'};
var $author$project$Components$SettingsPage$Shared$Checkbox$Unchecked = {$: 'Unchecked'};
var $author$project$Components$SettingsPage$Shared$Checkbox$fromBool = function (value) {
	return value ? $author$project$Components$SettingsPage$Shared$Checkbox$Checked : $author$project$Components$SettingsPage$Shared$Checkbox$Unchecked;
};
var $author$project$Components$SettingsPage$Shared$PayablesValue$Required = {$: 'Required'};
var $author$project$Components$SettingsPage$Shared$PayablesValue$UseHubtranDefaults = {$: 'UseHubtranDefaults'};
var $author$project$Components$SettingsPage$Shared$PayablesValue$fromBool = function (value) {
	return value ? $author$project$Components$SettingsPage$Shared$PayablesValue$Required : $author$project$Components$SettingsPage$Shared$PayablesValue$UseHubtranDefaults;
};
var $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$NoValue = {$: 'NoValue'};
var $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$TypeValue = function (a) {
	return {$: 'TypeValue', a: a};
};
var $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$fromHubtranType = F2(
	function (imageTypes, docType) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (cadenceType, maybeType) {
					return _Utils_eq(
						cadenceType.hubtranDocumentType,
						$author$project$Domain$UnresolvedDocumentType$Resolved(docType)) ? $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$TypeValue(cadenceType) : maybeType;
				}),
			$author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$NoValue,
			imageTypes);
	});
var $author$project$Domain$DocumentType$Deprecated = {$: 'Deprecated'};
var $author$project$Domain$DocumentType$Optional = {$: 'Optional'};
var $author$project$Domain$DocumentType$Required = {$: 'Required'};
var $author$project$Domain$DocumentType$state = function (documentType) {
	switch (documentType.$) {
		case 'DocumentTypeInvoice':
			return $author$project$Domain$DocumentType$Required;
		case 'DocumentTypeInternalDocumentsOther':
			return $author$project$Domain$DocumentType$Required;
		case 'DocumentTypePackingSlip':
			return $author$project$Domain$DocumentType$Deprecated;
		case 'DocumentTypeCarrierInvoice':
			return $author$project$Domain$DocumentType$Deprecated;
		case 'DocumentTypeCarrierRateConfirmation':
			return $author$project$Domain$DocumentType$Deprecated;
		default:
			return $author$project$Domain$DocumentType$Optional;
	}
};
var $author$project$Domain$DocumentType$isRequired = function (documentType) {
	var _v0 = $author$project$Domain$DocumentType$state(documentType);
	if (_v0.$ === 'Required') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$SettingsPage$Shared$DocumentTypeTable$fromSettings = function (settings) {
	var within = F2(
		function (items, item) {
			return A2($elm$core$List$member, item, items);
		});
	var mappedCadenceType = $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$fromHubtranType(settings.cadenceImageTypes);
	var isVisibleToCustomer = A2(
		$elm$core$Basics$composeR,
		within(settings.customerVisibleDocumentTypes),
		$author$project$Components$SettingsPage$Shared$Checkbox$fromBool);
	var isRequiredForPayables = A2(
		$elm$core$Basics$composeR,
		within(settings.requiredPayablesDocumentTypes),
		$author$project$Components$SettingsPage$Shared$PayablesValue$fromBool);
	var isRequiredForCustomer = A2(
		$elm$core$Basics$composeR,
		within(settings.requiredReceivablesDocumentTypes),
		$author$project$Components$SettingsPage$Shared$Checkbox$fromBool);
	return A2(
		$elm$core$List$map,
		function (docTypeWithName) {
			return {
				documentType: $author$project$Domain$UnresolvedDocumentType$Resolved(docTypeWithName.documentType),
				isRequiredForCustomer: isRequiredForCustomer(docTypeWithName.documentType),
				isRequiredForPayables: isRequiredForPayables(docTypeWithName.documentType),
				isVisibleToCustomer: isVisibleToCustomer(docTypeWithName.documentType),
				maybeCadenceImageType: mappedCadenceType(docTypeWithName.documentType),
				name: docTypeWithName.name,
				rowType: $author$project$Domain$DocumentType$isRequired(docTypeWithName.documentType) ? $author$project$Components$SettingsPage$Shared$DocumentTypeTable$MandatoryRow : $author$project$Components$SettingsPage$Shared$DocumentTypeTable$OptionalRow
			};
		},
		settings.enabledDocumentTypeNames);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$initDocumentTypesSection = F2(
	function (model, data) {
		var _v0 = model.changes;
		if (_v0.$ === 'Just') {
			var changes = _v0.a;
			return changes;
		} else {
			return {
				documentTypeRemovalWarning: $elm$core$Maybe$Nothing,
				rows: $author$project$Components$SettingsPage$Shared$DocumentTypeTable$fromSettings(data.documentTypeSettings),
				rowsSinceLastSave: $elm$core$Maybe$Just(
					$author$project$Components$SettingsPage$Shared$DocumentTypeTable$fromSettings(data.documentTypeSettings)),
				selectedOption: $elm$core$Maybe$Nothing
			};
		}
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$getHotkeyList = F2(
	function (data, model) {
		var enabledDocumentTypeNames = data.documentTypeSettings.enabledDocumentTypeNames;
		var sortedEnabledDocumentTypes = A2(
			$elm$core$List$map,
			function ($) {
				return $.documentType;
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.name;
				},
				enabledDocumentTypeNames));
		var documentTypeHotkeysOrdering = data.documentTypeSettings.documentTypeHotkeysOrdering;
		var filteredEnabledListForPadding = A2(
			$elm$core$List$filter,
			function (a) {
				return !A2($elm$core$List$member, a, documentTypeHotkeysOrdering);
			},
			sortedEnabledDocumentTypes);
		var paddedDocumentTypeHotkeysOrdering = A2(
			$elm$core$List$take,
			9,
			A2($elm$core$List$append, documentTypeHotkeysOrdering, filteredEnabledListForPadding));
		var defaultHotkeyList = A2($elm$core$List$take, 9, sortedEnabledDocumentTypes);
		return $elm$core$List$isEmpty(model.localHotkeyList) ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$List$isEmpty(documentTypeHotkeysOrdering) ? defaultHotkeyList : paddedDocumentTypeHotkeysOrdering,
			model.lastSavedHotkeyList) : model.localHotkeyList;
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$populateEmptyHotkeyListToEdit = F2(
	function (remoteData, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var x = _v0.a;
			return A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$getHotkeyList, x, model);
		}
	});
var $author$project$Helpers$List$atIndex = function (index) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$List$head,
		$elm$core$List$drop(index));
};
var $author$project$Helpers$List$replaceAtIndex = F3(
	function (index, newElement, list) {
		var _v0 = A2($author$project$Helpers$List$atIndex, index, list);
		if (_v0.$ === 'Just') {
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (thisIndex, element) {
						return _Utils_eq(index, thisIndex) ? newElement : element;
					}),
				list);
		} else {
			return list;
		}
	});
var $author$project$Api$Settings$documentTypeForTruckPhotos = function (documentType) {
	var json = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'document_type_for_truck_photos',
				$elm$json$Json$Encode$string(
					$author$project$AuditPb$documentTypeToString(documentType)))
			]));
	return A3($author$project$Helpers$Api$post, '/api/settings/document_type_for_truck_photos', json, $elm$json$Json$Decode$value);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$saveDocumentTypeForTruckPhotos = function (documentType) {
	return $author$project$Api$Settings$documentTypeForTruckPhotos(documentType.documentType);
};
var $author$project$Api$Settings$documentTypesHotkeysList = function (list) {
	var json = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'document_type_hotkeys_ordering',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2($elm$core$List$map, $author$project$AuditPb$documentTypeToString, list)))
			]));
	return A3($author$project$Helpers$Api$post, '/api/settings/document_type_hotkeys_ordering', json, $elm$json$Json$Decode$value);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$saveHotkeyList = function (model) {
	return $author$project$Api$Settings$documentTypesHotkeysList(model.localHotkeyList);
};
var $author$project$Api$Settings$tmsMap = function (map) {
	var json = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'map',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapSecond($elm$json$Json$Encode$string),
						map)))
			]));
	return A3($author$project$Helpers$Api$post, '/api/settings/hubtran_tms_document_type_map', json, $elm$json$Json$Decode$value);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$saveTmsMap = F2(
	function (data, model) {
		return $author$project$Api$Settings$tmsMap(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
				$elm$core$Dict$toList(
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsMap, data, model))));
	});
var $author$project$Api$Settings$tmsPodDocumentTypeMap = function (map) {
	var json = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'map',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, map))
			]));
	return A3($author$project$Helpers$Api$post, '/api/settings/hubtran_tms_pod_document_type_map', json, $elm$json$Json$Decode$value);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$saveTmsPodMap = function (model) {
	return $author$project$Api$Settings$tmsPodDocumentTypeMap(model.tmsPodMapEdit);
};
var $author$project$Components$SettingsPage$Shared$Checkbox$isChecked = function (checkbox) {
	if (checkbox.$ === 'Checked') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$SettingsPage$Shared$PayablesValue$toBool = function (value) {
	if (value.$ === 'Required') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$toTypeId = function (maybeCadenceImageType) {
	if (maybeCadenceImageType.$ === 'TypeValue') {
		var imageType = maybeCadenceImageType.a;
		return $elm$core$Maybe$Just(imageType.externalId);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$toSaveData = function (rows) {
	return A2(
		$elm$core$List$map,
		function (row) {
			return {
				cadenceTypeId: $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$toTypeId(row.maybeCadenceImageType),
				documentType: row.documentType,
				isIncludedForCustomer: $author$project$Components$SettingsPage$Shared$Checkbox$isChecked(row.isVisibleToCustomer),
				isRequiredForCustomer: $author$project$Components$SettingsPage$Shared$Checkbox$isChecked(row.isRequiredForCustomer),
				isRequiredForPayables: $author$project$Components$SettingsPage$Shared$PayablesValue$toBool(row.isRequiredForPayables)
			};
		},
		rows);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$None = {$: 'None'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeData = function (a) {
	return {$: 'SaveDocumentTypeData', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$ShowFlashAlert = function (a) {
	return {$: 'ShowFlashAlert', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$ShowFlashSuccess = function (a) {
	return {$: 'ShowFlashSuccess', a: a};
};
var $author$project$Components$SettingsPage$Shared$Checkbox$checked = $author$project$Components$SettingsPage$Shared$Checkbox$Checked;
var $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$noValue = $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$NoValue;
var $author$project$Components$SettingsPage$Shared$Checkbox$unchecked = $author$project$Components$SettingsPage$Shared$Checkbox$Unchecked;
var $author$project$Components$SettingsPage$Shared$PayablesValue$useHubtranDefaults = $author$project$Components$SettingsPage$Shared$PayablesValue$UseHubtranDefaults;
var $author$project$Components$SettingsPage$Shared$DocumentTypeTable$initOptionalRow = function (docTypeWithName) {
	return {
		documentType: $author$project$Domain$UnresolvedDocumentType$Resolved(docTypeWithName.documentType),
		isRequiredForCustomer: $author$project$Components$SettingsPage$Shared$Checkbox$unchecked,
		isRequiredForPayables: $author$project$Components$SettingsPage$Shared$PayablesValue$useHubtranDefaults,
		isVisibleToCustomer: $author$project$Components$SettingsPage$Shared$Checkbox$unchecked,
		maybeCadenceImageType: $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$noValue,
		name: docTypeWithName.name,
		rowType: $author$project$Components$SettingsPage$Shared$DocumentTypeTable$OptionalRow
	};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$updateRow = F3(
	function (value, column, row) {
		if (column.$ === 'VisibleToCustomer') {
			return _Utils_update(
				row,
				{isVisibleToCustomer: value});
		} else {
			return _Utils_update(
				row,
				{isRequiredForCustomer: value});
		}
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$setRowCheckbox = F4(
	function (column, documentType, value, row) {
		return _Utils_eq(row.documentType, documentType) ? A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$updateRow, value, column, row) : row;
	});
var $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$updateHubtranType = F2(
	function (docType, cadenceTypeValue) {
		if (cadenceTypeValue.$ === 'NoValue') {
			return $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$NoValue;
		} else {
			var cadenceType = cadenceTypeValue.a;
			var updatedType = _Utils_update(
				cadenceType,
				{hubtranDocumentType: docType});
			return $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$TypeValue(updatedType);
		}
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$updateDocumentTypesSection = F2(
	function (msg, model) {
		var appendToRows = F2(
			function (value, rows) {
				return _Utils_ap(
					rows,
					$elm$core$List$singleton(
						$author$project$Components$SettingsPage$Shared$DocumentTypeTable$initOptionalRow(value)));
			});
		switch (msg.$) {
			case 'OnSelectChange':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedOption: $elm$core$Maybe$Just(value)
						}),
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
			case 'OnSelectAddClick':
				var v3ReskinEnabled = msg.a.v3ReskinEnabled;
				var value = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A2(appendToRows, value, model.rows),
							selectedOption: $elm$core$Maybe$Nothing
						}),
					v3ReskinEnabled ? $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeData(
						{v3ReskinEnabled: v3ReskinEnabled}) : $author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
			case 'OnRowCheck':
				var v3ReskinEnabled = msg.a.v3ReskinEnabled;
				var _v1 = msg.b;
				var documentType = _v1.a;
				var column = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A2(
								$elm$core$List$map,
								A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$setRowCheckbox, column, documentType, $author$project$Components$SettingsPage$Shared$Checkbox$checked),
								model.rows)
						}),
					v3ReskinEnabled ? $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeData(
						{v3ReskinEnabled: v3ReskinEnabled}) : $author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
			case 'OnRowUncheck':
				var v3ReskinEnabled = msg.a.v3ReskinEnabled;
				var _v2 = msg.b;
				var documentType = _v2.a;
				var column = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A2(
								$elm$core$List$map,
								A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$setRowCheckbox, column, documentType, $author$project$Components$SettingsPage$Shared$Checkbox$unchecked),
								model.rows)
						}),
					v3ReskinEnabled ? $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeData(
						{v3ReskinEnabled: v3ReskinEnabled}) : $author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
			case 'OnRowRemove':
				var v3ReskinEnabled = msg.a.v3ReskinEnabled;
				var documentType = msg.b;
				return (_Utils_eq(model.documentTypeRemovalWarning, $elm$core$Maybe$Nothing) && _Utils_eq(
					documentType,
					$author$project$Domain$UnresolvedDocumentType$Resolved($author$project$AuditPb$DocumentTypeBillOfLading))) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documentTypeRemovalWarning: $elm$core$Maybe$Just(documentType)
						}),
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$None) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documentTypeRemovalWarning: $elm$core$Maybe$Nothing,
							rows: A2(
								$elm$core$List$filter,
								function (row) {
									return !_Utils_eq(row.documentType, documentType);
								},
								model.rows)
						}),
					v3ReskinEnabled ? $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeData(
						{v3ReskinEnabled: v3ReskinEnabled}) : $author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
			case 'SetPayablesValue':
				var v3ReskinEnabled = msg.a.v3ReskinEnabled;
				var documentType = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A2(
								$elm$core$List$map,
								function (row) {
									return _Utils_eq(row.documentType, documentType) ? _Utils_update(
										row,
										{isRequiredForPayables: value}) : row;
								},
								model.rows)
						}),
					v3ReskinEnabled ? $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeData(
						{v3ReskinEnabled: v3ReskinEnabled}) : $author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
			case 'SetCadenceImageType':
				var v3ReskinEnabled = msg.a.v3ReskinEnabled;
				var documentType = msg.b;
				var imageTypeValue = msg.c;
				var updatedValue = A2($author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$updateHubtranType, documentType, imageTypeValue);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A2(
								$elm$core$List$map,
								function (row) {
									return _Utils_eq(row.documentType, documentType) ? _Utils_update(
										row,
										{maybeCadenceImageType: updatedValue}) : row;
								},
								model.rows)
						}),
					v3ReskinEnabled ? $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeData(
						{v3ReskinEnabled: v3ReskinEnabled}) : $author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
			case 'OnSave':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rowsSinceLastSave: $elm$core$Maybe$Nothing}),
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeData(
						{v3ReskinEnabled: false}));
			case 'SaveComplete':
				switch (msg.b.$) {
					case 'Ok':
						var v3ReskinEnabled = msg.a.v3ReskinEnabled;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									rowsSinceLastSave: $elm$core$Maybe$Just(model.rows)
								}),
							v3ReskinEnabled ? $author$project$Components$SettingsPage$DocumentTypesSettingsView$ShowFlashSuccess('Changes saved successfully') : $author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
					case 'Err':
						var message = msg.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									rowsSinceLastSave: $elm$core$Maybe$Just(model.rows)
								}),
							$author$project$Components$SettingsPage$DocumentTypesSettingsView$ShowFlashAlert(message));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{rowsSinceLastSave: $elm$core$Maybe$Nothing}),
							$author$project$Components$SettingsPage$DocumentTypesSettingsView$ShowFlashAlert('An error occurred. Please try to save again.'));
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{documentTypeRemovalWarning: $elm$core$Maybe$Nothing}),
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$None);
		}
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'InputTmsMap':
				var key = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							tmsMapEdits: A3($elm$core$Dict$insert, key, value, model.tmsMapEdits)
						}),
					$author$project$HubTran$Effect$none);
			case 'InputTmsPodMap':
				var newValue = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							tmsPodMapEdit: $elm$core$Maybe$Just(newValue)
						}),
					$author$project$HubTran$Effect$none);
			case 'SaveTmsMap':
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$setIsSaving, true, model),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$TmsMapSaveFinished,
						A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$saveTmsMap, data, model)));
			case 'SaveTmsPodMap':
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$setIsSaving, true, model),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$TmsPodMapSaveFinished,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$saveTmsPodMap(model)));
			case 'TmsMapSaveFinished':
				var result = msg.a;
				return A2(
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$handleSaveFinished,
					_Utils_update(
						model,
						{
							editingTmsMap: function () {
								if (result.$ === 'Ok') {
									return false;
								} else {
									return model.editingTmsMap;
								}
							}(),
							lastSavedTmsMap: function () {
								if (result.$ === 'Ok') {
									return $elm$core$Maybe$Just(
										A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsMap, data, model));
								} else {
									return model.lastSavedTmsMap;
								}
							}(),
							tmsMapEdits: _Utils_eq(
								A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsMap, data, model),
								A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$getOriginalTmsMap, data, model)) ? $elm$core$Dict$empty : model.tmsMapEdits
						}),
					result);
			case 'TmsPodMapSaveFinished':
				var result = msg.a;
				return A2(
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$handleSaveFinished,
					_Utils_update(
						model,
						{
							editingTmsPodMap: function () {
								if (result.$ === 'Ok') {
									return false;
								} else {
									return model.editingTmsPodMap;
								}
							}(),
							lastSavedTmsPodMap: function () {
								if (result.$ === 'Ok') {
									return $elm$core$Maybe$Just(model.tmsPodMapEdit);
								} else {
									return model.lastSavedTmsPodMap;
								}
							}(),
							tmsPodMapEdit: _Utils_eq(
								A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsPodMap, data, model),
								A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$getOriginalTmsPodMap, data, model)) ? $elm$core$Maybe$Nothing : model.tmsPodMapEdit
						}),
					result);
			case 'EditHotkeyList':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editingHotkeyList: true,
							localHotkeyList: A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$populateEmptyHotkeyListToEdit, data, model)
						}),
					$author$project$HubTran$Effect$none);
			case 'UpdateHotkeySelection':
				var index = msg.a;
				var doc = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							localHotkeyList: A3($author$project$Helpers$List$replaceAtIndex, index, doc, model.localHotkeyList)
						}),
					$author$project$HubTran$Effect$none);
			case 'SaveHotkeyList':
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$setIsSaving, true, model),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$HotkeySaveFinished,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$saveHotkeyList(model)));
			case 'HotkeySaveFinished':
				var result = msg.a;
				return A2(
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$handleSaveFinished,
					_Utils_update(
						model,
						{
							editingHotkeyList: false,
							lastSavedHotkeyList: function () {
								if (result.$ === 'Ok') {
									return $elm$core$Maybe$Just(model.localHotkeyList);
								} else {
									return model.lastSavedHotkeyList;
								}
							}()
						}),
					result);
			case 'SaveDocumentTypeForTruckPhotos':
				var documentType = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$setIsSaving, true, model),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$DocumentTypeForTruckPhotosSaveFinished,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$saveDocumentTypeForTruckPhotos(documentType)));
			case 'DocumentTypeForTruckPhotosSaveFinished':
				var result = msg.a;
				return A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$handleSaveFinished, model, result);
			case 'DocumentTypes':
				var msg_ = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$HubTran$Effect$none),
					A2(
						$elm$core$Maybe$map,
						function (_v6) {
							var documentTypes = _v6.a;
							var request = _v6.b;
							var effect = function () {
								switch (request.$) {
									case 'SaveDocumentTypeData':
										var v3ReskinEnabled = request.a;
										return A2(
											$author$project$HubTran$Effect$sendCacheableRequestWithError,
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$SettingsPage$DocumentTypesSettingsView$DocumentTypes,
												$author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveComplete(v3ReskinEnabled)),
											$author$project$Api$Settings$documentTypes(
												$author$project$Components$SettingsPage$DocumentTypesSettingsView$toSaveData(documentTypes.rows)));
									case 'ShowFlashAlert':
										var message = request.a;
										return $author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$alert(message));
									case 'ShowFlashSuccess':
										var message = request.a;
										return $author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$success(message));
									default:
										return $author$project$HubTran$Effect$none;
								}
							}();
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										changes: $elm$core$Maybe$Just(documentTypes)
									}),
								effect);
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$SettingsPage$DocumentTypesSettingsView$updateDocumentTypesSection(msg_),
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$SettingsPage$DocumentTypesSettingsView$initDocumentTypesSection(model),
								$author$project$Forward$Remote$toMaybe(data)))));
			case 'CancelEditHotkeyList':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editingHotkeyList: false, localHotkeyList: _List_Nil}),
					$author$project$HubTran$Effect$none);
			case 'EditTmsMap':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editingTmsMap: true}),
					$author$project$HubTran$Effect$none);
			case 'CancelEditTmsMap':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editingTmsMap: false, tmsMapEdits: $elm$core$Dict$empty}),
					$author$project$HubTran$Effect$none);
			case 'EditTmsPodMap':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editingTmsPodMap: true}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editingTmsPodMap: false, tmsPodMapEdit: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$MultipleCustomExceptionTemplatesMsg = function (a) {
	return {$: 'MultipleCustomExceptionTemplatesMsg', a: a};
};
var $author$project$Components$SettingsPage$ExceptionSettingsView$CustomSubjectUpdate = function (a) {
	return {$: 'CustomSubjectUpdate', a: a};
};
var $author$project$Api$Accounts$customExceptionSubjectTemplate = function (template) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/custom_exception_email_subject_template',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'custom_exception_email_subject_template',
					$elm$json$Json$Encode$string(template))
				])));
};
var $author$project$Components$Shared$Grid$column = F2(
	function (_int, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'small-' + ($elm$core$String$fromInt(_int) + ' column'))
				]),
			children);
	});
var $author$project$Components$Shared$Grid$autoRow = F2(
	function (columnLength, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Shared$Grid$column(columnLength),
					$elm$core$List$singleton),
				children));
	});
var $author$project$Components$Shared$Button$enabled = F3(
	function (buttonText, message, attributes) {
		var clickConfig = $elm$json$Json$Decode$succeed(
			{message: message, preventDefault: true, stopPropagation: false});
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Events$custom, 'click', clickConfig),
				attributes),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				]));
	});
var $author$project$Components$Shared$Button$confirm = F3(
	function (buttonText, message, attrs) {
		return A3(
			$author$project$Components$Shared$Button$enabled,
			buttonText,
			message,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('button--confirmation'),
				attrs));
	});
var $author$project$Components$Shared$Button$disabled = F2(
	function (buttonText, attributes) {
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(true),
						$elm$html$Html$Attributes$class('button--disabled')
					]),
				attributes),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				]));
	});
var $author$project$Helpers$Result$either = F3(
	function (fromErr, fromOk, result) {
		if (result.$ === 'Err') {
			var x = result.a;
			return fromErr(x);
		} else {
			var a = result.a;
			return fromOk(a);
		}
	});
var $author$project$Components$SettingsPage$Shared$TemplateVariables$isValid = F4(
	function (variables, loadReferenceVariables, shipmentReferenceVariables, templateString) {
		var variable_pattern = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('\u005C{[^\u005C}]*\u005C}'));
		var shipment_ref_pattern = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('\u005C[[^\u005C]]*\u005C]'));
		var matchesAVariable = function (m) {
			return A2(
				$elm$core$List$member,
				m.match,
				_Utils_ap(
					variables,
					_Utils_ap(loadReferenceVariables, shipmentReferenceVariables)));
		};
		var load_ref_pattern = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('<[^>]*>'));
		var findAllMatches = function (pattern) {
			return A2($elm$regex$Regex$find, pattern, templateString);
		};
		var conditionals = A2(
			$elm$core$List$map,
			function (variable) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('\u005C{(#if ' + (variable + ')|(#endif)\u005C}')));
			},
			variables);
		var isConditional = function (m) {
			return A2(
				$elm$core$List$any,
				function (conditional) {
					return A2($elm$regex$Regex$contains, conditional, m.match);
				},
				conditionals);
		};
		var matchesVariableOrConditional = function (match) {
			return matchesAVariable(match) || isConditional(match);
		};
		return A2(
			$elm$core$List$all,
			matchesVariableOrConditional,
			A2(
				$elm$core$List$concatMap,
				findAllMatches,
				_List_fromArray(
					[variable_pattern, load_ref_pattern, shipment_ref_pattern])));
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$ensureValidTemplate = F2(
	function (accountSettings, value) {
		return A4($author$project$Components$SettingsPage$Shared$TemplateVariables$isValid, accountSettings.payablesTemplateVariables, accountSettings.loadReferenceVariables, accountSettings.shipmentReferenceVariables, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(value);
	});
var $author$project$Helpers$Result$isOk = function (result) {
	if (result.$ === 'Err') {
		return false;
	} else {
		return true;
	}
};
var $author$project$Helpers$Result$isError = A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Helpers$Result$isOk);
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$Components$SettingsPage$Shared$TemplateVariables$listView = F4(
	function (example, templateVariables, loadReferenceVariables, shipmentReferenceVariables) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Available variables')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('delivery-method__variables-list')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('delivery-method__columns')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (s) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$pre,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(s)
															]))
													]));
										},
										_Utils_ap(
											templateVariables,
											_Utils_ap(loadReferenceVariables, shipmentReferenceVariables))))
								]))
						])),
					example
				]));
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$defaultTemplate = function (account) {
	return account.factorAccount ? '{account_name} Questions{#if {invoice_number}} for Invoice {invoice_number}{#endif}{#if {load_id}} on Load {load_id}{#endif}: {exception_summary}' : '{account_name} Questions{#if {invoice_number}} for Invoice {invoice_number}{#endif} on Load {load_id}: {exception_summary}';
};
var $author$project$Components$SettingsPage$ExceptionSettingsView$defaultTemplateRendered = function (account) {
	return account.name + ' Questions on Load 123: No Load ID Provided';
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Components$SettingsPage$Shared$TemplateVariables$referenceInstructions = F2(
	function (supportLoadReferences, supportShipmentReferences) {
		var shipmentInstructions = supportShipmentReferences ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Shipment Reference example (if your shipments have a reference named `Shipping Order`): ')
								])),
							A2(
							$elm$html$Html$i,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice for Order [Shipping Order]')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Resulting Subject: ')
								])),
							A2(
							$elm$html$Html$i,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice for Order 456')
								]))
						]))
				])) : $elm$html$Html$text('');
		var loadInstructions = supportLoadReferences ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Load Reference example (if your loads have a reference named \u0027Customer Load ID\u0027): ')
								])),
							A2(
							$elm$html$Html$i,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice for Load <Customer Load ID>')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Resulting Subject: ')
								])),
							A2(
							$elm$html$Html$i,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice for Load 123')
								]))
						]))
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('delivery-method__template-variable-references-text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Available references')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You can use load and shipment references as variables as well. Use angle brackets <> for load references, and square brackets [] for shipment references. Make sure you match the case and spacing exactly as found in your TMS, otherwise it won\u0027t match.')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('delivery-method__template-variable-references-examples')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Examples')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[loadInstructions])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[shipmentInstructions]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$templateVariablesExample = function (currentAccount) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('delivery-method__template-variable-example-text')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Example')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Custom Subject: ')
							])),
						A2(
						$elm$html$Html$i,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Components$SettingsPage$ExceptionSettingsView$defaultTemplate(currentAccount))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Resulting Subject: ')
							])),
						A2(
						$elm$html$Html$i,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Components$SettingsPage$ExceptionSettingsView$defaultTemplateRendered(currentAccount))
							]))
					])),
				A2($author$project$Components$SettingsPage$Shared$TemplateVariables$referenceInstructions, true, false)
			]));
};
var $author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectFormView = F6(
	function (currentAccount, accountSettings, set, save, _v0, result) {
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			10,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('customsubjecttemplate'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'error',
									$author$project$Helpers$Result$isError(result))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Custom Exception Email Subject (optional)')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('customsubjecttemplate'),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$value(
							A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result)),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								set,
								$author$project$Components$SettingsPage$ExceptionSettingsView$ensureValidTemplate(accountSettings)))
						]),
					_List_Nil),
					A4(
					$author$project$Components$SettingsPage$Shared$TemplateVariables$listView,
					$author$project$Components$SettingsPage$ExceptionSettingsView$templateVariablesExample(currentAccount),
					accountSettings.payablesTemplateVariables,
					accountSettings.loadReferenceVariables,
					_List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A3(
					$author$project$Helpers$Result$either,
					$elm$core$Basics$always(
						A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil)),
					$elm$core$Basics$always(
						A3($author$project$Components$Shared$Button$confirm, 'Save Custom Subject Template', save, _List_Nil)),
					result)
				]));
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectSummaryView = function (result) {
	var _v0 = A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result);
	if (_v0 === '') {
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Add a custom subject line to exceptions.')
				]));
	} else {
		var template = _v0;
		return A2(
			$elm$html$Html$pre,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('delivery-method__rendered-template-variable-example')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(template)
				]));
	}
};
var $author$project$Components$SettingsPage$ExceptionSettingsView$validatingSend = function (apiRequest) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map(
			A2(
				$elm$core$Basics$composeR,
				apiRequest,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity))),
		$elm$core$Result$withDefault($author$project$HubTran$Effect$none));
};
var $author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectConfig = F2(
	function (currentAccount, accountSettings) {
		return {
			apiRequest: $author$project$Components$SettingsPage$ExceptionSettingsView$validatingSend($author$project$Api$Accounts$customExceptionSubjectTemplate),
			formView: A2($author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectFormView, currentAccount, accountSettings),
			summaryView: $author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectSummaryView,
			title: 'Custom Exception Subject',
			toMsg: $author$project$Components$SettingsPage$ExceptionSettingsView$CustomSubjectUpdate
		};
	});
var $author$project$Components$SettingsPage$Shared$EditSection$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Components$SettingsPage$Shared$EditSection$editingValue = function (_v0) {
	var state = _v0.a;
	return state.editing ? $elm$core$Maybe$Just(state.current) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$SettingsPage$Shared$EditSection$isEditing = function (_v0) {
	var state = _v0.a;
	return state.editing;
};
var $author$project$Components$SettingsPage$Shared$EditSection$init = F2(
	function (value, previous) {
		return $author$project$Components$SettingsPage$Shared$EditSection$State(
			{
				current: A2(
					$elm$core$Maybe$withDefault,
					value,
					A2($elm$core$Maybe$andThen, $author$project$Components$SettingsPage$Shared$EditSection$editingValue, previous)),
				editing: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Components$SettingsPage$Shared$EditSection$isEditing, previous)),
				errors: A2(
					$elm$core$Maybe$andThen,
					function (_v0) {
						var s = _v0.a;
						return s.errors;
					},
					previous),
				initial: value,
				saving: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var s = _v1.a;
							return s.saving;
						},
						previous))
			});
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectTemplate = F2(
	function (_v0, model) {
		var accountSettings = _v0.accountSettings;
		return A2(
			$author$project$Components$SettingsPage$Shared$EditSection$init,
			$elm$core$Result$Ok(accountSettings.customExceptionSubjectTemplate),
			model.customSubjectTemplate);
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Creating = function (a) {
	return {$: 'Creating', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Deleting = function (a) {
	return {$: 'Deleting', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Editing = F2(
	function (a, b) {
		return {$: 'Editing', a: a, b: b};
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$ProcessDeleteResponse = function (a) {
	return {$: 'ProcessDeleteResponse', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$ProcessSetAsDefaultResponse = function (a) {
	return {$: 'ProcessSetAsDefaultResponse', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$ProcessUpdateResponse = function (a) {
	return {$: 'ProcessUpdateResponse', a: a};
};
var $author$project$AuditPb$customExceptionEmailTemplateEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CustomExceptionEmailTemplateId$toInt),
					v.id),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'body', $elm$json$Json$Encode$string, v.body),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'name', $elm$json$Json$Encode$string, v.name),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'subject', $elm$json$Json$Encode$string, v.subject),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'is_default', $elm$json$Json$Encode$bool, v.isDefault)
				])));
};
var $author$project$AuditApi$customExceptionEmailTemplateServiceCreateWithState = A3($author$project$AuditApi$toRequestState, '/custom_exception_email_template_service/create', $author$project$AuditPb$customExceptionEmailTemplateEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$AuditPb$customExceptionEmailTemplateDeleteRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CustomExceptionEmailTemplateId$toInt),
					v.id)
				])));
};
var $author$project$AuditApi$customExceptionEmailTemplateServiceDeleteWithState = A3($author$project$AuditApi$toRequestState, '/custom_exception_email_template_service/delete', $author$project$AuditPb$customExceptionEmailTemplateDeleteRequestEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$AuditPb$customExceptionEmailTemplateSetAsDefaultRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$requiredFieldEncoderWithoutDefault,
					'id',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CustomExceptionEmailTemplateId$toInt),
					v.id)
				])));
};
var $author$project$AuditApi$customExceptionEmailTemplateServiceSetAsDefaultWithState = A3($author$project$AuditApi$toRequestState, '/custom_exception_email_template_service/set_as_default', $author$project$AuditPb$customExceptionEmailTemplateSetAsDefaultRequestEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$AuditApi$customExceptionEmailTemplateServiceUpdateWithState = A3($author$project$AuditApi$toRequestState, '/custom_exception_email_template_service/update', $author$project$AuditPb$customExceptionEmailTemplateEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$emptyForm = {body: '', isSaving: false, name: '', subject: ''};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$getForm = function (editingState) {
	switch (editingState.$) {
		case 'NotEditing':
			return $elm$core$Maybe$Nothing;
		case 'Editing':
			var form = editingState.a;
			return $elm$core$Maybe$Just(form);
		default:
			var form = editingState.a;
			return $elm$core$Maybe$Just(form);
	}
};
var $author$project$PostRequestState$handleResponseWithFlash = F2(
	function (_v0, _v1) {
		var state = _v0.a;
		var apiResult = _v1.a;
		var newState = $author$project$PostRequestState$PostRequestState(
			_Utils_update(
				state,
				{inProgress: state.inProgress - 1}));
		if (apiResult.$ === 'Ok') {
			var a = apiResult.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(a, newState));
		} else {
			return $elm$core$Result$Err(
				_Utils_Tuple2(
					newState,
					$author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert)));
		}
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setBody = F2(
	function (body, editingState) {
		switch (editingState.$) {
			case 'NotEditing':
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotEditing;
			case 'Editing':
				var form = editingState.a;
				var template = editingState.b;
				return A2(
					$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Editing,
					_Utils_update(
						form,
						{body: body}),
					template);
			default:
				var form = editingState.a;
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Creating(
					_Utils_update(
						form,
						{body: body}));
		}
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setIsSaving = function (model) {
	var _v0 = model.editingState;
	switch (_v0.$) {
		case 'NotEditing':
			return model;
		case 'Editing':
			var form = _v0.a;
			var template = _v0.b;
			return _Utils_update(
				model,
				{
					editingState: A2(
						$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Editing,
						_Utils_update(
							form,
							{isSaving: true}),
						template)
				});
		default:
			var form = _v0.a;
			return _Utils_update(
				model,
				{
					editingState: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Creating(
						_Utils_update(
							form,
							{isSaving: true}))
				});
	}
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setName = F2(
	function (name, editingState) {
		switch (editingState.$) {
			case 'NotEditing':
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotEditing;
			case 'Editing':
				var form = editingState.a;
				var template = editingState.b;
				return A2(
					$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Editing,
					_Utils_update(
						form,
						{name: name}),
					template);
			default:
				var form = editingState.a;
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Creating(
					_Utils_update(
						form,
						{name: name}));
		}
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setNotDeleting = function (model) {
	return _Utils_update(
		model,
		{deletingState: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotDeleting});
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setNotEditing = function (model) {
	return _Utils_update(
		model,
		{editingState: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotEditing});
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setSubject = F2(
	function (subject, editingState) {
		switch (editingState.$) {
			case 'NotEditing':
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NotEditing;
			case 'Editing':
				var form = editingState.a;
				var template = editingState.b;
				return A2(
					$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Editing,
					_Utils_update(
						form,
						{subject: subject}),
					template);
			default:
				var form = editingState.a;
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Creating(
					_Utils_update(
						form,
						{subject: subject}));
		}
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$validateForm = function (form) {
	var errors = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$String$isEmpty(form.name) ? $elm$core$Maybe$Just('Name is required.') : $elm$core$Maybe$Nothing,
				$elm$core$String$isEmpty(form.subject) ? $elm$core$Maybe$Just('Subject is required.') : $elm$core$Maybe$Nothing,
				$elm$core$String$isEmpty(form.body) ? $elm$core$Maybe$Just('Body is required.') : $elm$core$Maybe$Nothing,
				A2($elm$core$String$contains, '{signature}', form.subject) ? $elm$core$Maybe$Just('Subject cannot contain the {signature} variable.') : $elm$core$Maybe$Nothing
			]));
	return $elm$core$List$isEmpty(errors) ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err(errors);
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'StartEditing':
				var template = msg.a;
				var _v1 = $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$getForm(model.editingState);
				if (_v1.$ === 'Nothing') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								editingState: A2(
									$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Editing,
									{body: template.body, isSaving: false, name: template.name, subject: template.subject},
									template)
							}),
						$author$project$HubTran$Effect$none);
				} else {
					var formValue = _v1.a;
					return formValue.isSaving ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								editingState: A2(
									$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Editing,
									{body: template.body, isSaving: false, name: template.name, subject: template.subject},
									template)
							}),
						$author$project$HubTran$Effect$none);
				}
			case 'StartDeleting':
				var template = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							deletingState: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Deleting(template)
						}),
					$author$project$HubTran$Effect$none);
			case 'DeleteTemplate':
				var template = msg.a;
				return A3(
					$author$project$AuditApi$customExceptionEmailTemplateServiceDeleteWithState,
					model,
					$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$ProcessDeleteResponse,
					{id: template.id});
			case 'SetAsDefault':
				var template = msg.a;
				return A3(
					$author$project$AuditApi$customExceptionEmailTemplateServiceSetAsDefaultWithState,
					model,
					$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$ProcessSetAsDefaultResponse,
					{id: template.id});
			case 'CancelDelete':
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setNotDeleting(model),
					$author$project$HubTran$Effect$none);
			case 'SetName':
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editingState: A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setName, name, model.editingState)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetSubject':
				var subject = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editingState: A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setSubject, subject, model.editingState)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetBody':
				var body = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editingState: A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setBody, body, model.editingState)
						}),
					$author$project$HubTran$Effect$none);
			case 'CancelEdit':
				var _v2 = $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$getForm(model.editingState);
				if (_v2.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var formValue = _v2.a;
					return formValue.isSaving ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
						$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setNotEditing(model),
						$author$project$HubTran$Effect$none);
				}
			case 'ProcessDeleteResponse':
				var response = msg.a;
				var _v3 = A2($author$project$PostRequestState$handleResponseWithFlash, model.requestState, response);
				if (_v3.$ === 'Err') {
					var _v4 = _v3.a;
					var newState = _v4.a;
					return _Utils_Tuple2(
						$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setNotDeleting(
							_Utils_update(
								model,
								{requestState: newState})),
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$warning('There was an error deleting the email template. Please try again.')));
				} else {
					var _v5 = _v3.a;
					var newState = _v5.b;
					return _Utils_Tuple2(
						$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setNotDeleting(
							_Utils_update(
								model,
								{requestState: newState})),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$invalidate($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$loadData),
									$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$success('Email template has been deleted.'))
								])));
				}
			case 'SaveButtonClick':
				var template = msg.a;
				var _v6 = $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$getForm(model.editingState);
				if (_v6.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var formValue = _v6.a;
					var _v7 = $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$validateForm(formValue);
					if (_v7.$ === 'Ok') {
						return A3(
							$author$project$AuditApi$customExceptionEmailTemplateServiceUpdateWithState,
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setIsSaving(model),
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$ProcessUpdateResponse,
							{body: formValue.body, id: template.id, isDefault: false, name: formValue.name, subject: formValue.subject});
					} else {
						var errors = _v7.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$warning(
									A2(
										$elm$core$String$join,
										' ',
										A2($elm$core$List$cons, 'Cannot save template:', errors)))));
					}
				}
			case 'ProcessUpdateResponse':
				var response = msg.a;
				var _v8 = model.editingState;
				if (_v8.$ === 'NotEditing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var _v9 = A2($author$project$PostRequestState$handleResponseWithFlash, model.requestState, response);
					if (_v9.$ === 'Err') {
						var _v10 = _v9.a;
						var newState = _v10.a;
						return _Utils_Tuple2(
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setNotEditing(
								_Utils_update(
									model,
									{requestState: newState})),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$warning('There was an error saving the email template. Please try again.')));
					} else {
						var _v11 = _v9.a;
						var newState = _v11.b;
						return _Utils_Tuple2(
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setNotEditing(
								_Utils_update(
									model,
									{requestState: newState})),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$customExceptionEmailTemplate),
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Email template has been saved.'))
									])));
					}
				}
			case 'StartCreatingTemplate':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editingState: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$Creating($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$emptyForm)
						}),
					$author$project$HubTran$Effect$none);
			case 'CreateButtonClick':
				var _v12 = $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$getForm(model.editingState);
				if (_v12.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var formValue = _v12.a;
					var _v13 = $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$validateForm(formValue);
					if (_v13.$ === 'Ok') {
						return A3(
							$author$project$AuditApi$customExceptionEmailTemplateServiceCreateWithState,
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$setIsSaving(model),
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$ProcessUpdateResponse,
							{
								body: formValue.body,
								id: $author$project$Domain$CustomExceptionEmailTemplateId$fromInt(0),
								isDefault: false,
								name: formValue.name,
								subject: formValue.subject
							});
					} else {
						var errors = _v13.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$warning(
									A2(
										$elm$core$String$join,
										' ',
										A2($elm$core$List$cons, 'Cannot create template:', errors)))));
					}
				}
			case 'ProcessSetAsDefaultResponse':
				var response = msg.a;
				var _v14 = A2($author$project$PostRequestState$handleResponseWithFlash, model.requestState, response);
				if (_v14.$ === 'Err') {
					var _v15 = _v14.a;
					var newState = _v15.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{requestState: newState}),
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$warning('There was an error setting the default template. Please try again.')));
				} else {
					var _v16 = _v14.a;
					var newState = _v16.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{requestState: newState}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$customExceptionEmailTemplate),
									$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$success('Default template has been set.'))
								])));
				}
			default:
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$Shared$EditSection$Finish = function (a) {
	return {$: 'Finish', a: a};
};
var $author$project$Components$SettingsPage$Shared$EditSection$update = F3(
	function (_v0, msg, _v1) {
		var apiRequest = _v0.apiRequest;
		var toMsg = _v0.toMsg;
		var title = _v0.title;
		var section = _v1.a;
		switch (msg.$) {
			case 'StartEditing':
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$Shared$EditSection$State(
						_Utils_update(
							section,
							{editing: true})),
					$author$project$HubTran$Effect$none);
			case 'CancelEditing':
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$Shared$EditSection$State(
						_Utils_update(
							section,
							{current: section.initial, editing: false})),
					$author$project$HubTran$Effect$none);
			case 'ChangeValue':
				var a = msg.a;
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$Shared$EditSection$State(
						_Utils_update(
							section,
							{current: a})),
					$author$project$HubTran$Effect$none);
			case 'Save':
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$Shared$EditSection$State(
						_Utils_update(
							section,
							{saving: true})),
					A2(
						$author$project$HubTran$Effect$map,
						A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Shared$EditSection$Finish, toMsg),
						apiRequest(section.current)));
			default:
				switch (msg.a.$) {
					case 'Ok':
						return _Utils_Tuple2(
							$author$project$Components$SettingsPage$Shared$EditSection$State(
								_Utils_update(
									section,
									{editing: false, saving: false})),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success(title + ' successfully updated!')));
					case 'Err':
						var errorMessage = msg.a.a;
						return _Utils_Tuple2(
							$author$project$Components$SettingsPage$Shared$EditSection$State(
								_Utils_update(
									section,
									{
										errors: $elm$core$Maybe$Just(errorMessage),
										saving: false
									})),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Failed to update ' + (title + '!'))));
					default:
						return _Utils_Tuple2(
							$author$project$Components$SettingsPage$Shared$EditSection$State(
								_Utils_update(
									section,
									{errors: $elm$core$Maybe$Nothing, saving: false})),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Failed to update ' + (title + '!'))));
				}
		}
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$update = F3(
	function (data, msg, model) {
		if (msg.$ === 'CustomSubjectUpdate') {
			var msg_ = msg.a;
			var formState = A2($author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectTemplate, data, model);
			var _v1 = A3(
				$author$project$Components$SettingsPage$Shared$EditSection$update,
				A2($author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectConfig, data.currentAccount, data.accountSettings),
				msg_,
				formState);
			var newFormState = _v1.a;
			var formEffect = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						customSubjectTemplate: $elm$core$Maybe$Just(newFormState)
					}),
				formEffect);
		} else {
			var msg_ = msg.a;
			var _v2 = A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$update, msg_, model.multipleCustomExceptionTemplates);
			var newModel = _v2.a;
			var effect = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{multipleCustomExceptionTemplates: newModel}),
				A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ExceptionSettingsView$MultipleCustomExceptionTemplatesMsg, effect));
		}
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$FinishSaveSettings = function (a) {
	return {$: 'FinishSaveSettings', a: a};
};
var $author$project$Api$FactorClientPortalSettings$PortalDisplayForm = F9(
	function (currentHeaders, showInvoiceField, showRushFee, rushFeeLabelOverride, requiredFields, fundingMethods, features, customMessage, fundingDisclosure) {
		return {currentHeaders: currentHeaders, customMessage: customMessage, features: features, fundingDisclosure: fundingDisclosure, fundingMethods: fundingMethods, requiredFields: requiredFields, rushFeeLabelOverride: rushFeeLabelOverride, showInvoiceField: showInvoiceField, showRushFee: showRushFee};
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$NotEditing = F3(
	function (a, b, c) {
		return {$: 'NotEditing', a: a, b: b, c: c};
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$fundingMethods = function (methodsFromSettings) {
	return A2(
		$elm$core$List$map,
		function (method) {
			return A3(
				$author$project$Components$SettingsPage$FactorClientPortalSettingsView$NotEditing,
				method.portalFieldName,
				A2($elm$core$Maybe$withDefault, '', method.spanishTranslation),
				A2($elm$core$Maybe$withDefault, '', method.payablesLabel));
		},
		methodsFromSettings);
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$offLabel = 'Off';
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$onLabel = 'On';
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$initForm = function (data) {
	var _v0 = $elm$core$List$unzip(
		A2(
			$elm$core$List$map,
			function (feature) {
				var _v1 = A2(
					$author$project$Ui$V3$CustomSelect$init,
					{
						domId: 'portal-feature-' + feature.id,
						excludedItems: _List_Nil,
						items: A2(
							$elm$core$List$map,
							$author$project$Ui$V3$CustomSelect$simpleItem,
							_List_fromArray(
								[
									{id: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$onLabel, label: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$onLabel},
									{id: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$offLabel, label: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$offLabel}
								])),
						selectedItems: _List_fromArray(
							[
								$author$project$Ui$V3$CustomSelect$simpleItem(
								feature.enabled ? {id: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$onLabel, label: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$onLabel} : {id: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$offLabel, label: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$offLabel})
							])
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$CustomSelect$hideSelectAll(true)
						]));
				var dropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					{dropdown: dropdown, feature: feature},
					$author$project$HubTran$Effect$AnyCmd(
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FeatureDropdownMsg(feature.label),
								cmd))));
			},
			data.portalDisplaySettings.features));
	var featureDropdowns = _v0.a;
	var featureEffects = _v0.b;
	return _Utils_Tuple2(
		{
			currentHeaders: data.portalDisplaySettings.invoiceListColumns,
			currentRequiredFields: data.portalDisplaySettings.requiredFields,
			customMessage: data.portalDisplaySettings.customMessage,
			features: featureDropdowns,
			fundingDisclosure: data.portalDisplaySettings.fundingDisclosure,
			fundingMethods: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$fundingMethods(data.portalDisplaySettings.fundingMethods),
			publicDebtorCreditCheckPathSegment: data.portalDisplaySettings.publicDebtorCreditCheckPathSegment,
			rushFeeLabelOverride: data.portalDisplaySettings.rushFeeLabelOverride,
			showInvoiceField: data.portalDisplaySettings.showInvoiceNumber,
			showRushFee: data.portalDisplaySettings.showRushFee
		},
		$author$project$HubTran$Effect$Batch(featureEffects));
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$formData = F2(
	function (data, model) {
		var _v0 = model.form;
		if (_v0.$ === 'Just') {
			var form = _v0.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(form, $author$project$HubTran$Effect$none));
		} else {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$SettingsPage$FactorClientPortalSettingsView$initForm,
				$author$project$Forward$Remote$toMaybe(data));
		}
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$fundingMethodPayablesLabel = function (fundingMethodFormValue) {
	if (fundingMethodFormValue.$ === 'Editing') {
		var l = fundingMethodFormValue.c;
		return l;
	} else {
		var l = fundingMethodFormValue.c;
		return l;
	}
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$fundingMethodSpanishTranslation = function (fundingMethodFormValue) {
	if (fundingMethodFormValue.$ === 'Editing') {
		var t = fundingMethodFormValue.b;
		return t;
	} else {
		var t = fundingMethodFormValue.b;
		return t;
	}
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$portalFieldNameLabel = function (fundingMethodFormValue) {
	if (fundingMethodFormValue.$ === 'Editing') {
		var l = fundingMethodFormValue.a;
		return l;
	} else {
		var l = fundingMethodFormValue.a;
		return l;
	}
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$stringToMaybe = function (string) {
	var trimmed = $elm$core$String$trim(string);
	return $elm$core$String$isEmpty(trimmed) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(trimmed);
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$Editing = F4(
	function (a, b, c, d) {
		return {$: 'Editing', a: a, b: b, c: c, d: d};
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$addOrRemoveColumn = F2(
	function (column, headers) {
		return A2($elm$core$List$member, column, headers) ? A3(
			$elm$core$List$foldr,
			F2(
				function (c, newList) {
					return (!_Utils_eq(c, column)) ? A2($elm$core$List$cons, c, newList) : newList;
				}),
			_List_Nil,
			headers) : A3(
			$elm$core$List$foldl,
			F2(
				function (c, indexList) {
					return (indexList.a === 1) ? _Utils_Tuple2(
						indexList.a + 1,
						_Utils_ap(
							indexList.b,
							_List_fromArray(
								[column, c]))) : _Utils_Tuple2(
						indexList.a + 1,
						_Utils_ap(
							indexList.b,
							_List_fromArray(
								[c])));
				}),
			_Utils_Tuple2(0, _List_Nil),
			headers).b;
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$indexedFoldlImpl = F4(
	function (index, f, initial, xs) {
		indexedFoldlImpl:
		while (true) {
			if (xs.b) {
				var x = xs.a;
				var xs_ = xs.b;
				var $temp$index = index + 1,
					$temp$f = f,
					$temp$initial = A3(f, index, x, initial),
					$temp$xs = xs_;
				index = $temp$index;
				f = $temp$f;
				initial = $temp$initial;
				xs = $temp$xs;
				continue indexedFoldlImpl;
			} else {
				return initial;
			}
		}
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$indexedFoldl = F3(
	function (f, initial, xs) {
		return A4($author$project$Components$SettingsPage$FactorClientPortalSettingsView$indexedFoldlImpl, 0, f, initial, xs);
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$indexedFilterMap = F2(
	function (transformingPredicate, xs) {
		return A3(
			$author$project$Components$SettingsPage$FactorClientPortalSettingsView$indexedFoldl,
			F3(
				function (i, x, toKeep) {
					var _v0 = A2(transformingPredicate, i, x);
					if (_v0.$ === 'Just') {
						var result = _v0.a;
						return _Utils_ap(
							toKeep,
							_List_fromArray(
								[result]));
					} else {
						return toKeep;
					}
				}),
			_List_Nil,
			xs);
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$updateForm = F2(
	function (formMsg, form) {
		switch (formMsg.$) {
			case 'ToggleLoadNumber':
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							currentHeaders: A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$addOrRemoveColumn, $author$project$AuditPb$PortalDisplaySettingsColumnLoadNumber, form.currentHeaders)
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleInvoiceNumber':
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							currentHeaders: A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$addOrRemoveColumn, $author$project$AuditPb$PortalDisplaySettingsColumnInvoiceNumber, form.currentHeaders)
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleInvoiceInput':
				var requiredFields = form.showInvoiceField ? A2(
					$elm$core$List$filter,
					function (field) {
						return !_Utils_eq(field, $author$project$AuditPb$PortalDisplaySettingsInputFieldInvoiceNumberField);
					},
					form.currentRequiredFields) : form.currentRequiredFields;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{currentRequiredFields: requiredFields, showInvoiceField: !form.showInvoiceField}),
					$author$project$HubTran$Effect$none);
			case 'ToggleRequiredField':
				var inputField = formMsg.a;
				var requiredFields = A2($elm$core$List$member, inputField, form.currentRequiredFields) ? A2(
					$elm$core$List$filter,
					function (field) {
						return !_Utils_eq(field, inputField);
					},
					form.currentRequiredFields) : A2(
					$elm$core$List$append,
					form.currentRequiredFields,
					_List_fromArray(
						[inputField]));
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{currentRequiredFields: requiredFields}),
					$author$project$HubTran$Effect$none);
			case 'ToggleRushFee':
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{showRushFee: !form.showRushFee}),
					$author$project$HubTran$Effect$none);
			case 'RushFeeLabelChanged':
				var newLabel = formMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							rushFeeLabelOverride: $elm$core$Maybe$Just(newLabel)
						}),
					$author$project$HubTran$Effect$none);
			case 'CustomMessageChanged':
				var newMessage = formMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							customMessage: $elm$core$Maybe$Just(newMessage)
						}),
					$author$project$HubTran$Effect$none);
			case 'FundingDisclosureChanged':
				var newDisclosure = formMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fundingDisclosure: $elm$core$Maybe$Just(newDisclosure)
						}),
					$author$project$HubTran$Effect$none);
			case 'ToggleEditingState':
				var index = formMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fundingMethods: A2(
								$author$project$Components$SettingsPage$FactorClientPortalSettingsView$indexedFilterMap,
								F2(
									function (i, m) {
										if (_Utils_eq(i, index)) {
											if (m.$ === 'Editing') {
												var n = m.a;
												var t = m.b;
												var l = m.c;
												return A2(
													$elm$core$Maybe$map,
													$elm$core$Basics$always(
														A3($author$project$Components$SettingsPage$FactorClientPortalSettingsView$NotEditing, n, t, l)),
													$author$project$Components$SettingsPage$FactorClientPortalSettingsView$stringToMaybe(
														$author$project$Components$SettingsPage$FactorClientPortalSettingsView$portalFieldNameLabel(m)));
											} else {
												var n = m.a;
												var t = m.b;
												var l = m.c;
												return $elm$core$Maybe$Just(
													A4(
														$author$project$Components$SettingsPage$FactorClientPortalSettingsView$Editing,
														n,
														t,
														l,
														$elm$core$Maybe$Just(m)));
											}
										} else {
											return $elm$core$Maybe$Just(m);
										}
									}),
								form.fundingMethods)
						}),
					$author$project$HubTran$Effect$none);
			case 'CancelEditing':
				var index = formMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fundingMethods: A2(
								$author$project$Components$SettingsPage$FactorClientPortalSettingsView$indexedFilterMap,
								F2(
									function (i, m) {
										if (_Utils_eq(i, index)) {
											if (m.$ === 'Editing') {
												var maybeOriginal = m.d;
												return maybeOriginal;
											} else {
												return $elm$core$Maybe$Just(m);
											}
										} else {
											return $elm$core$Maybe$Just(m);
										}
									}),
								form.fundingMethods)
						}),
					$author$project$HubTran$Effect$none);
			case 'RemoveFundingMethod':
				var index = formMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fundingMethods: function (methods) {
								return _Utils_ap(
									A2($elm$core$List$take, index, methods),
									A2($elm$core$List$drop, index + 1, methods));
							}(form.fundingMethods)
						}),
					$author$project$HubTran$Effect$none);
			case 'FundingMethodChanged':
				var index = formMsg.a;
				var newValue = formMsg.b;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fundingMethods: A2(
								$elm$core$List$indexedMap,
								F2(
									function (i, m) {
										if (_Utils_eq(i, index)) {
											if (m.$ === 'Editing') {
												var fieldName = m.a;
												var translation = m.b;
												var payablesLabel = m.c;
												var original = m.d;
												switch (newValue.$) {
													case 'PortalFieldNameValue':
														var fieldName_ = newValue.a;
														return A4($author$project$Components$SettingsPage$FactorClientPortalSettingsView$Editing, fieldName_, translation, payablesLabel, original);
													case 'SpanishTranslationValue':
														var t = newValue.a;
														return A4($author$project$Components$SettingsPage$FactorClientPortalSettingsView$Editing, fieldName, t, payablesLabel, original);
													default:
														var l = newValue.a;
														return A4($author$project$Components$SettingsPage$FactorClientPortalSettingsView$Editing, fieldName, translation, l, original);
												}
											} else {
												return m;
											}
										} else {
											return m;
										}
									}),
								form.fundingMethods)
						}),
					$author$project$HubTran$Effect$none);
			case 'AddNewFundingMethod':
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fundingMethods: _Utils_ap(
								form.fundingMethods,
								_List_fromArray(
									[
										A4($author$project$Components$SettingsPage$FactorClientPortalSettingsView$Editing, '', '', '', $elm$core$Maybe$Nothing)
									]))
						}),
					$author$project$HubTran$Effect$none);
			default:
				var label = formMsg.a;
				var dropdownMsg = formMsg.b;
				var _v5 = $elm$core$List$unzip(
					A2(
						$elm$core$List$map,
						function (featureField) {
							var dropdown = featureField.dropdown;
							var feature = featureField.feature;
							if (_Utils_eq(feature.label, label)) {
								var _v6 = A2($author$project$Ui$V3$CustomSelect$update, dropdownMsg, dropdown);
								var newDropdown = _v6.a;
								var dropdownCmd = _v6.b;
								return _Utils_Tuple2(
									_Utils_update(
										featureField,
										{dropdown: newDropdown}),
									$author$project$HubTran$Effect$AnyCmd(
										A2(
											$elm$core$Platform$Cmd$map,
											$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm,
											A2(
												$elm$core$Platform$Cmd$map,
												$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FeatureDropdownMsg(feature.label),
												dropdownCmd))));
							} else {
								return _Utils_Tuple2(featureField, $author$project$HubTran$Effect$none);
							}
						},
						form.features));
				var newFeatures = _v5.a;
				var featureEffects = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{features: newFeatures}),
					$author$project$HubTran$Effect$batch(featureEffects));
		}
	});
var $author$project$AuditPb$portalDisplaySettingsColumnEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$portalDisplaySettingsColumnToString);
var $author$project$Encode$ColumnEncoder$encodeColumn = $author$project$AuditPb$portalDisplaySettingsColumnEncoder;
var $author$project$Encode$FundingMethodEncoder$encodeFundingMethod = function (fundingMethod) {
	var encodedSpanishTranslation = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A3(
			$elm$core$Basics$apL,
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Encode$string,
					function (b) {
						return _Utils_Tuple2('es-MX', b);
					}),
				$elm$core$List$singleton),
			fundingMethod.spanishTranslation));
	var encodedPayablesLabel = A2(
		$elm$core$Maybe$withDefault,
		$elm$json$Json$Encode$null,
		A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, fundingMethod.payablesLabel));
	var encodedKey = $elm$json$Json$Encode$string(
		A2(
			$elm$core$String$join,
			'_',
			A2(
				$elm$core$String$split,
				' ',
				$elm$core$String$toLower(fundingMethod.portalFieldName))));
	var encodedEnglishLabel = $elm$json$Json$Encode$string(fundingMethod.portalFieldName);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('key', encodedKey),
				_Utils_Tuple2('payables_label', encodedPayablesLabel),
				_Utils_Tuple2(
				'translations',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2('en-US', encodedEnglishLabel),
						encodedSpanishTranslation)))
			]));
};
var $author$project$AuditPb$portalDisplaySettingsInputFieldEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$portalDisplaySettingsInputFieldToString);
var $author$project$AuditPb$portalDisplaySettings_FeatureEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'id', $elm$json$Json$Encode$string, v.id),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'label', $elm$json$Json$Encode$string, v.label),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'enabled', $elm$json$Json$Encode$bool, v.enabled),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'can_override_for_client', $elm$json$Json$Encode$bool, v.canOverrideForClient)
				])));
};
var $author$project$Api$FactorClientPortalSettings$displaySettings = function (form) {
	var rushFeeLabelOverride = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (label) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'rush_fee_label_override',
						$elm$json$Json$Encode$string(label))
					]);
			},
			form.rushFeeLabelOverride));
	var fundingDisclosure = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (disclosure) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'funding_disclosure',
						$elm$json$Json$Encode$string(disclosure))
					]);
			},
			form.fundingDisclosure));
	var customMessage = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (message) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'custom_message',
						$elm$json$Json$Encode$string(message))
					]);
			},
			form.customMessage));
	var json = $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$append,
			fundingDisclosure,
			A2(
				$elm$core$List$append,
				customMessage,
				A2(
					$elm$core$List$append,
					rushFeeLabelOverride,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'invoice_list_columns',
							A2($elm$json$Json$Encode$list, $author$project$Encode$ColumnEncoder$encodeColumn, form.currentHeaders)),
							_Utils_Tuple2(
							'show_invoice_field',
							$elm$json$Json$Encode$bool(form.showInvoiceField)),
							_Utils_Tuple2(
							'show_rush_fee',
							$elm$json$Json$Encode$bool(form.showRushFee)),
							_Utils_Tuple2(
							'required_fields',
							A2($elm$json$Json$Encode$list, $author$project$AuditPb$portalDisplaySettingsInputFieldEncoder, form.requiredFields)),
							_Utils_Tuple2(
							'funding_options',
							A2($elm$json$Json$Encode$list, $author$project$Encode$FundingMethodEncoder$encodeFundingMethod, form.fundingMethods)),
							_Utils_Tuple2(
							'features',
							A2($elm$json$Json$Encode$list, $author$project$AuditPb$portalDisplaySettings_FeatureEncoder, form.features))
						])))));
	return A2($author$project$Helpers$Api$postWithNoResponseBody, '/api/accounts/factor_client_portal_settings', json);
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$updateSettings = function (updateSettingsForm) {
	return $author$project$Api$FactorClientPortalSettings$displaySettings(updateSettingsForm);
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'EditForm':
				var formMsg = msg.a;
				var _v1 = A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$formData, data, model);
				if (_v1.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var _v2 = _v1.a;
					var newFormData = _v2.a;
					var initEffect = _v2.b;
					var _v3 = A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$updateForm, formMsg, newFormData);
					var newForm = _v3.a;
					var newEffect = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: $elm$core$Maybe$Just(newForm)
							}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[initEffect, newEffect])));
				}
			case 'SaveSettings':
				var _v4 = A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$formData, data, model);
				if (_v4.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var _v5 = _v4.a;
					var form = _v5.a;
					var initEffect = _v5.b;
					var fundingMethods_ = A2(
						$elm$core$List$map,
						function (method) {
							return {
								payablesLabel: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$stringToMaybe(
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$fundingMethodPayablesLabel(method)),
								portalFieldName: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$portalFieldNameLabel(method),
								spanishTranslation: $author$project$Components$SettingsPage$FactorClientPortalSettingsView$stringToMaybe(
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$fundingMethodSpanishTranslation(method))
							};
						},
						form.fundingMethods);
					var features = A2(
						$elm$core$List$filterMap,
						function (_v6) {
							var dropdown = _v6.dropdown;
							var feature = _v6.feature;
							var newEnabled = A2(
								$elm$core$List$any,
								function (item) {
									return _Utils_eq(item.id, $author$project$Components$SettingsPage$FactorClientPortalSettingsView$onLabel);
								},
								$author$project$Ui$V3$CustomSelect$selectedItems(dropdown));
							return (!_Utils_eq(newEnabled, feature.enabled)) ? $elm$core$Maybe$Just(
								_Utils_update(
									feature,
									{enabled: newEnabled})) : $elm$core$Maybe$Nothing;
						},
						form.features);
					var settingForm = A9($author$project$Api$FactorClientPortalSettings$PortalDisplayForm, form.currentHeaders, form.showInvoiceField, form.showRushFee, form.rushFeeLabelOverride, form.currentRequiredFields, fundingMethods_, features, form.customMessage, form.fundingDisclosure);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isSaving: true}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									initEffect,
									A2(
									$author$project$HubTran$Effect$sendCacheableRequestWithError,
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FinishSaveSettings,
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$updateSettings(settingForm))
								])));
				}
			default:
				var response = msg.a;
				switch (response.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{form: $elm$core$Maybe$Nothing, isSaving: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('You have successfully saved the portal settings.')));
					case 'Err':
						var message = response.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('An error occurred. Please try to save again.')));
				}
		}
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateReviewPercentageRules = function (a) {
	return {$: 'UpdateReviewPercentageRules', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$getTableData = function (_v0) {
	var accountSettings = _v0.accountSettings;
	return A2(
		$elm$core$Maybe$map,
		function (rulesResponse) {
			return {accountDefault: accountSettings.manualReviewPercentage, rulesResponse: rulesResponse};
		},
		accountSettings.ngaRules);
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentage = F2(
	function (_v0, model) {
		var accountSettings = _v0.accountSettings;
		return A2(
			$author$project$Components$SettingsPage$Shared$EditSection$init,
			$elm$core$Result$Ok(accountSettings.manualReviewPercentage),
			model.manualReviewPercentage);
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$parseNumeric = function (str) {
	var _v0 = $elm$core$String$toInt(str);
	if (_v0.$ === 'Just') {
		var _int = _v0.a;
		return $elm$core$Result$Ok(_int);
	} else {
		return $elm$core$Result$Err('Must be a number');
	}
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageFormViewV2 = F4(
	function (set, save, _v0, result) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select percentage of invoices that need to go through manual review.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row collapse')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column begin')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-4 column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('number'),
													$elm$html$Html$Attributes$value(
													A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$String$fromInt, result)),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$NextGenAuditSettingsView$parseNumeric)),
													$elm$html$Html$Attributes$min('0'),
													$elm$html$Html$Attributes$max('100')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column end')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('postfix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('%')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Helpers$Result$either,
							$elm$core$Basics$always(
								A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil)),
							$elm$core$Basics$always(
								A3($author$project$Components$Shared$Button$confirm, 'Save Amount', save, _List_Nil)),
							result)
						]))
				]));
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateManualReviewPercentage = function (a) {
	return {$: 'UpdateManualReviewPercentage', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageSummary = function (result) {
	manualReviewPercentageSummary:
	while (true) {
		if (result.$ === 'Err') {
			var $temp$result = $elm$core$Result$Ok(100);
			result = $temp$result;
			continue manualReviewPercentageSummary;
		} else {
			var reviewPercentage = result.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(reviewPercentage)),
								$elm$html$Html$text('% of all invoices will be sent for manual review. '),
								$elm$html$Html$text('This setting can be overwritten for every client.')
							]))
					]));
		}
	}
};
var $author$project$Api$Accounts$saveManualReviewPercentage = function (reviewPercentage) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'manual_review_percentage',
					$elm$json$Json$Encode$int(reviewPercentage))
				])));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$validatingSend = function (apiRequest) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map(
			A2(
				$elm$core$Basics$composeR,
				apiRequest,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity))),
		$elm$core$Result$withDefault($author$project$HubTran$Effect$none));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedManualReviewConfig = {
	apiRequest: $author$project$Components$SettingsPage$NextGenAuditSettingsView$validatingSend($author$project$Api$Accounts$saveManualReviewPercentage),
	summaryView: $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageSummary,
	title: 'Manual Review Percentage',
	toMsg: $author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateManualReviewPercentage
};
var $author$project$Components$SettingsPage$Shared$EditSection$withV2FormView = F2(
	function (formView, sharedConfig) {
		return {apiRequest: sharedConfig.apiRequest, formView: formView, summaryView: sharedConfig.summaryView, title: sharedConfig.title, toMsg: sharedConfig.toMsg};
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageConfigV2 = A2($author$project$Components$SettingsPage$Shared$EditSection$withV2FormView, $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageFormViewV2, $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedManualReviewConfig);
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$CustomSelectMsg = F2(
	function (a, b) {
		return {$: 'CustomSelectMsg', a: a, b: b};
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditId = function (a) {
	return {$: 'EditId', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg = function (a) {
	return {$: 'EditMsg', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Editing = function (a) {
	return {$: 'Editing', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Saving = {$: 'Saving'};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$customSelectDomId = function (editId) {
	return 'review-percentage-' + $elm$core$String$fromInt(editId);
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$getAllSelectedRatingIds = function (creditRatingRules) {
	var selectedRatingIds = function (creditRatingRule) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.id;
			},
			$author$project$Ui$V3$CustomSelect$selectedItems(creditRatingRule.select));
	};
	return $elm$core$Set$fromList(
		A2($elm$core$List$concatMap, selectedRatingIds, creditRatingRules));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$initCustomSelect = function (_v0) {
	var allItems = _v0.allItems;
	var selectedItems = _v0.selectedItems;
	var domId = _v0.domId;
	return A2(
		$author$project$Ui$V3$CustomSelect$init,
		{domId: domId, excludedItems: _List_Nil, items: allItems, selectedItems: selectedItems},
		_List_fromArray(
			[
				$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$multiSelectTypeahead),
				$author$project$Ui$V3$CustomSelect$filterable(true)
			]));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$mappedCustomSelectCmd = F2(
	function (editId, cmd) {
		return $author$project$HubTran$Effect$cmd(
			A2(
				$elm$core$Platform$Cmd$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg,
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$CustomSelectMsg(editId)),
				cmd));
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$ratingNameToItem = function (ratingName) {
	return {
		id: ratingName,
		label: $elm$html$Html$text(ratingName),
		text: ratingName
	};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SaveRulesUpdateResponse = function (a) {
	return {$: 'SaveRulesUpdateResponse', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SavingMsg = function (a) {
	return {$: 'SavingMsg', a: a};
};
var $author$project$AuditPb$ngaRulesUpdateRequest_ReviewPercentageRuleEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$repeatedFieldEncoder, 'creditRatings', $elm$json$Json$Encode$string, v.creditRatings),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'reviewPercentage', $elm$json$Json$Encode$int, v.reviewPercentage),
					A3($author$project$AuditPb$optionalEncoder, 'ngaRuleId', $elm$json$Json$Encode$int, v.ngaRuleId)
				])));
};
var $author$project$AuditPb$ngaRulesUpdateRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$repeatedFieldEncoder, 'reviewPercentageRules', $author$project$AuditPb$ngaRulesUpdateRequest_ReviewPercentageRuleEncoder, v.reviewPercentageRules),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'accountDefaultReviewPercentage', $elm$json$Json$Encode$int, v.accountDefaultReviewPercentage)
				])));
};
var $author$project$Api$Accounts$saveNgaRulesUpdate = function (updateRequest) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'nga_rules',
					$author$project$AuditPb$ngaRulesUpdateRequestEncoder(updateRequest))
				])));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$sendMutation = function (toMsg) {
	return $author$project$HubTran$Effect$sendCacheableRequestWithError(
		A2(
			$elm$core$Basics$composeL,
			toMsg,
			$author$project$Helpers$Api$Result$dropErrorData($elm$core$Basics$identity)));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$saveRulesUpdate = function (updateRequest) {
	return A2(
		$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$sendMutation,
		A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SavingMsg, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SaveRulesUpdateResponse),
		$author$project$Api$Accounts$saveNgaRulesUpdate(updateRequest));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validatePercentage = function (input) {
	var checkRange = function (p) {
		return ((p <= 100) && (p >= 0)) ? $elm$core$Maybe$Just(p) : $elm$core$Maybe$Nothing;
	};
	return A2(
		$elm$core$Maybe$andThen,
		checkRange,
		$elm$core$String$toInt(input));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validateRuleSelect = function (select) {
	var selectedIds = A2(
		$elm$core$List$map,
		function ($) {
			return $.id;
		},
		$author$project$Ui$V3$CustomSelect$selectedItems(select));
	return $elm$core$List$isEmpty(selectedIds) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(selectedIds);
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validateCreditRatingRule = function (_v0) {
	var ngaRuleId = _v0.ngaRuleId;
	var percentage = _v0.percentage;
	var select = _v0.select;
	var _v1 = _Utils_Tuple2(
		$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validateRuleSelect(select),
		$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validatePercentage(percentage));
	if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
		var cr = _v1.a.a;
		var p = _v1.b.a;
		return $elm$core$Maybe$Just(
			{creditRatings: cr, ngaRuleId: ngaRuleId, reviewPercentage: p});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validateCreditRatingRules = function (inputRules) {
	return $elm_community$maybe_extra$Maybe$Extra$combine(
		A2($elm$core$List$map, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validateCreditRatingRule, inputRules));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validate = function (editing) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validatePercentage(editing.accountDefault),
		$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validateCreditRatingRules(editing.creditRatingRules));
	if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
		var newAccountDefault = _v0.a.a;
		var newCreditRatingRules = _v0.b.a;
		return $elm$core$Maybe$Just(
			{accountDefaultReviewPercentage: newAccountDefault, reviewPercentageRules: newCreditRatingRules});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$editUpdate = F3(
	function (_v0, msg, editModel) {
		var data = _v0.data;
		var toMsg = _v0.toMsg;
		var editIdEquals = F2(
			function (_v6, _v7) {
				var a = _v6.a;
				var b = _v7.a;
				return _Utils_eq(a, b);
			});
		switch (msg.$) {
			case 'CancelEditing':
				return _Utils_Tuple2($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$init, $author$project$HubTran$Effect$none);
			case 'CustomSelectMsg':
				var editId = msg.a;
				var customSelectMsg = msg.b;
				var updateRuleSelect = function (rule) {
					if (A2(editIdEquals, editId, rule.editId)) {
						var _v3 = A2($author$project$Ui$V3$CustomSelect$update, customSelectMsg, rule.select);
						var updatedCustomSelect = _v3.a;
						var updatedCustomSelectCmd = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								rule,
								{select: updatedCustomSelect}),
							A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$mappedCustomSelectCmd, editId, updatedCustomSelectCmd));
					} else {
						return _Utils_Tuple2(rule, $author$project$HubTran$Effect$none);
					}
				};
				var _v2 = $elm$core$List$unzip(
					A2($elm$core$List$map, updateRuleSelect, editModel.creditRatingRules));
				var updatedCreditRatingRules = _v2.a;
				var effects = _v2.b;
				var focusAndScroll = A2(
					$author$project$HubTran$Effect$map,
					toMsg,
					$author$project$HubTran$Effect$batch(effects));
				var updatedEditModel = _Utils_update(
					editModel,
					{
						allSelectedRatingIds: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$getAllSelectedRatingIds(updatedCreditRatingRules),
						creditRatingRules: updatedCreditRatingRules
					});
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Editing(updatedEditModel),
					focusAndScroll);
			case 'EditDefaultReviewPercentage':
				var input = msg.a;
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Editing(
						_Utils_update(
							editModel,
							{accountDefault: input})),
					$author$project$HubTran$Effect$none);
			case 'EditRuleReviewPercentage':
				var editId = msg.a;
				var input = msg.b;
				var updateCreditRatingRule = function (rule) {
					return A2(editIdEquals, editId, rule.editId) ? _Utils_update(
						rule,
						{percentage: input}) : rule;
				};
				var updatedCreditRatingRules = A2($elm$core$List$map, updateCreditRatingRule, editModel.creditRatingRules);
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Editing(
						_Utils_update(
							editModel,
							{creditRatingRules: updatedCreditRatingRules})),
					$author$project$HubTran$Effect$none);
			case 'SaveEdits':
				var _v4 = $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validate(editModel);
				if (_v4.$ === 'Just') {
					var updateRequest = _v4.a;
					return _Utils_Tuple2(
						$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Saving,
						A2(
							$author$project$HubTran$Effect$map,
							toMsg,
							$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$saveRulesUpdate(updateRequest)));
				} else {
					return _Utils_Tuple2(
						$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Editing(editModel),
						$author$project$HubTran$Effect$none);
				}
			case 'RemoveRule':
				var editId = msg.a;
				var filteredRules = A2(
					$elm$core$List$filter,
					function (rule) {
						return !A2(editIdEquals, editId, rule.editId);
					},
					editModel.creditRatingRules);
				var updatedEditModel = _Utils_update(
					editModel,
					{
						allSelectedRatingIds: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$getAllSelectedRatingIds(filteredRules),
						creditRatingRules: filteredRules
					});
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Editing(updatedEditModel),
					$author$project$HubTran$Effect$none);
			default:
				var editId = $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditId(editModel.nextEditId);
				var _v5 = $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$initCustomSelect(
					{
						allItems: A2($elm$core$List$map, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$ratingNameToItem, data.rulesResponse.availableCreditRatings),
						domId: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$customSelectDomId(editModel.nextEditId),
						selectedItems: _List_Nil
					});
				var select = _v5.a;
				var cmd = _v5.b;
				var disableScroll = $author$project$HubTran$Effect$cmd(
					A2(
						$elm$core$Platform$Cmd$map,
						toMsg,
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg,
								$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$CustomSelectMsg(editId)),
							cmd)));
				var newRule = {editId: editId, ngaRuleId: $elm$core$Maybe$Nothing, percentage: '100', select: select};
				var updatedEditModel = _Utils_update(
					editModel,
					{
						creditRatingRules: _Utils_ap(
							editModel.creditRatingRules,
							_List_fromArray(
								[newRule])),
						nextEditId: editModel.nextEditId + 1
					});
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Editing(updatedEditModel),
					disableScroll);
		}
	});
var $author$project$HubTran$Flash$withNoTimeout = function (msg) {
	return _Utils_update(
		msg,
		{indefinite: true});
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$savingUpdate = function (response) {
	if (response.a.$ === 'Ok') {
		return _Utils_Tuple2($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Summary, $author$project$HubTran$Effect$none);
	} else {
		var error = response.a.a;
		if (error.$ === 'BadBody') {
			var message = error.a;
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Summary,
				$author$project$HubTran$Effect$flash(
					$author$project$HubTran$Flash$withNoTimeout(
						$author$project$HubTran$Flash$alert(message))));
		} else {
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Summary,
				$author$project$HubTran$Effect$flash(
					$author$project$HubTran$Flash$withNoTimeout(
						$author$project$HubTran$Flash$alert('An unexpected error has occurred.'))));
		}
	}
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$summaryUpdate = F2(
	function (_v0, msg) {
		var data = _v0.data;
		var toMsg = _v0.toMsg;
		var initForIndex = F2(
			function (i, _v4) {
				var ngaRuleId = _v4.ngaRuleId;
				var reviewPercentage = _v4.reviewPercentage;
				var creditRatings = _v4.creditRatings;
				var editId = $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditId(i);
				var _v3 = $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$initCustomSelect(
					{
						allItems: A2($elm$core$List$map, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$ratingNameToItem, data.rulesResponse.availableCreditRatings),
						domId: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$customSelectDomId(i),
						selectedItems: A2($elm$core$List$map, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$ratingNameToItem, creditRatings)
					});
				var select = _v3.a;
				var cmd = _v3.b;
				var rule = {
					editId: editId,
					ngaRuleId: ngaRuleId,
					percentage: $elm$core$String$fromInt(reviewPercentage),
					select: select
				};
				return _Utils_Tuple2(
					rule,
					A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$mappedCustomSelectCmd, editId, cmd));
			});
		var _v2 = $elm$core$List$unzip(
			A2($elm$core$List$indexedMap, initForIndex, data.rulesResponse.reviewPercentageRules));
		var creditRatingRules = _v2.a;
		var effects = _v2.b;
		var editModel = {
			accountDefault: $elm$core$String$fromInt(data.accountDefault),
			allSelectedRatingIds: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$getAllSelectedRatingIds(creditRatingRules),
			creditRatingRules: creditRatingRules,
			nextEditId: $elm$core$List$length(creditRatingRules)
		};
		var disableScrollForDropdowns = A2(
			$author$project$HubTran$Effect$map,
			toMsg,
			$author$project$HubTran$Effect$batch(effects));
		return _Utils_Tuple2(
			$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$Editing(editModel),
			disableScrollForDropdowns);
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$update = F3(
	function (updateConfig, msg, table) {
		var _v0 = _Utils_Tuple2(msg, table);
		_v0$3:
		while (true) {
			switch (_v0.a.$) {
				case 'SummaryMsg':
					if (_v0.b.$ === 'Summary') {
						var summaryMsg = _v0.a.a;
						var _v1 = _v0.b;
						return A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$summaryUpdate, updateConfig, summaryMsg);
					} else {
						break _v0$3;
					}
				case 'EditMsg':
					if (_v0.b.$ === 'Editing') {
						var editMsg = _v0.a.a;
						var editModel = _v0.b.a;
						return A3($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$editUpdate, updateConfig, editMsg, editModel);
					} else {
						break _v0$3;
					}
				default:
					if (_v0.b.$ === 'Saving') {
						var response = _v0.a.a;
						var _v2 = _v0.b;
						return $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$savingUpdate(response);
					} else {
						break _v0$3;
					}
			}
		}
		return _Utils_Tuple2(table, $author$project$HubTran$Effect$none);
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateVerificationExceptions = function (a) {
	return {$: 'UpdateVerificationExceptions', a: a};
};
var $author$project$Api$Accounts$saveVerificationExceptionTypes = function (types) {
	var encodedTypes = $elm$core$List$isEmpty(types) ? $elm$json$Json$Encode$string('empty_array') : A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, types);
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2('factor_verification_exception_types', encodedTypes)
				])));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$allVerificationExceptionOptions = _List_fromArray(
	[
		_Utils_Tuple2('amount_mismatch_failure', 'Amount Match'),
		_Utils_Tuple2('carrier_mismatch_failure', 'Carrier Match'),
		_Utils_Tuple2('load_not_found_failure', 'Load Not Found'),
		_Utils_Tuple2('remit_to_failure', 'Remit To Match'),
		_Utils_Tuple2('undelivered_failue', 'Delivery Status'),
		_Utils_Tuple2('load_issue_failure', 'Load Issue'),
		_Utils_Tuple2('possible_fees_failure', 'Possible Fees')
	]);
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsSummary = function (enabledTypes) {
	var enabledSet = $elm$core$Set$fromList(enabledTypes);
	var enabledLabels = A2(
		$elm$core$List$filterMap,
		function (_v1) {
			var key = _v1.a;
			var label = _v1.b;
			return A2($elm$core$Set$member, key, enabledSet) ? $elm$core$Maybe$Just(label) : $elm$core$Maybe$Nothing;
		},
		$author$project$Components$SettingsPage$NextGenAuditSettingsView$allVerificationExceptionOptions);
	if (!enabledLabels.b) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No verification exceptions configured.')
				]));
	} else {
		var labels = enabledLabels;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Stop autoprocessing if a verification fails for:')
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (l) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(l)
									]));
						},
						labels))
				]));
	}
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedVerificationExceptionsConfig = {
	apiRequest: A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Accounts$saveVerificationExceptionTypes,
		$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
	summaryView: $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsSummary,
	title: 'Verification Exceptions',
	toMsg: $author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateVerificationExceptions
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$allTypeKeys = A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Components$SettingsPage$NextGenAuditSettingsView$allVerificationExceptionOptions);
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$toggleType = F2(
	function (typeKey, current) {
		return A2($elm$core$List$member, typeKey, current) ? A2(
			$elm$core$List$filter,
			function (t) {
				return !_Utils_eq(t, typeKey);
			},
			current) : _Utils_ap(
			current,
			_List_fromArray(
				[typeKey]));
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsFormV2 = F4(
	function (set, save, isSaving, enabledTypes) {
		var enabledSet = $elm$core$Set$fromList(enabledTypes);
		var checkboxRow = function (_v1) {
			var key = _v1.a;
			var label = _v1.b;
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px'),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(
								A2($elm$core$Set$member, key, enabledSet)),
								$elm$html$Html$Events$onCheck(
								function (_v0) {
									return set(
										A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$toggleType, key, enabledTypes));
								}),
								A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
							]),
						_List_Nil),
						$elm$html$Html$text(label)
					]));
		};
		var allChecked = _Utils_eq(
			$elm$core$List$length(enabledTypes),
			$elm$core$List$length($author$project$Components$SettingsPage$NextGenAuditSettingsView$allTypeKeys));
		var selectAllRow = A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(allChecked),
							$elm$html$Html$Events$onCheck(
							function (v) {
								return set(
									v ? $author$project$Components$SettingsPage$NextGenAuditSettingsView$allTypeKeys : _List_Nil);
							}),
							A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
						]),
					_List_Nil),
					$elm$html$Html$text('Select All')
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Stop autoprocessing if a verification fails for:')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '15px')
						]),
					_Utils_ap(
						A2($elm$core$List$map, checkboxRow, $author$project$Components$SettingsPage$NextGenAuditSettingsView$allVerificationExceptionOptions),
						_List_fromArray(
							[
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								selectAllRow
							]))),
					isSaving ? A2($author$project$Components$Shared$Button$disabled, 'Saving...', _List_Nil) : A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsConfigV2 = A2($author$project$Components$SettingsPage$Shared$EditSection$withV2FormView, $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsFormV2, $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedVerificationExceptionsConfig);
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsState = F2(
	function (_v0, model) {
		var accountSettings = _v0.accountSettings;
		return A2($author$project$Components$SettingsPage$Shared$EditSection$init, accountSettings.factorVerificationExceptionTypes, model.verificationExceptions);
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOver = F2(
	function (_v0, model) {
		var accountSettings = _v0.accountSettings;
		var stringValue = function () {
			var _v1 = accountSettings.warnIfAmountOver;
			if (_v1.$ === 'Just') {
				var value = _v1.a;
				return $elm$core$String$fromInt(value);
			} else {
				return '';
			}
		}();
		return A2(
			$author$project$Components$SettingsPage$Shared$EditSection$init,
			$elm$core$Result$Ok(stringValue),
			model.warnIfAmountOver);
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateWarnOverAmount = function (a) {
	return {$: 'UpdateWarnOverAmount', a: a};
};
var $author$project$Api$Accounts$saveWarnIfAmountOver = function (warnIfAmountOver) {
	var updatedValue = function () {
		var _v0 = $elm$core$String$toInt(warnIfAmountOver);
		if (_v0.$ === 'Just') {
			var amount = _v0.a;
			return $elm$json$Json$Encode$int(amount);
		} else {
			return $elm$json$Json$Encode$null;
		}
	}();
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2('warn_if_amount_over', updatedValue)
				])));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnOverAmountSummary = function (result) {
	var _v0 = A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result);
	if (_v0 === '') {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No invoice amount is set to require verification.')
				]));
	} else {
		var warnOverString = _v0;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoices over $'),
							$elm$html$Html$text(warnOverString),
							$elm$html$Html$text(' will create an exception of:')
						])),
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice amount of $XXXX exceeds $'),
							$elm$html$Html$text(warnOverString),
							$elm$html$Html$text(' and requires verification.')
						]))
				]));
	}
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedWarnIfAmountOverConfig = {
	apiRequest: $author$project$Components$SettingsPage$NextGenAuditSettingsView$validatingSend($author$project$Api$Accounts$saveWarnIfAmountOver),
	summaryView: $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnOverAmountSummary,
	title: 'Warn Over Invoice Amount',
	toMsg: $author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateWarnOverAmount
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ensureNumeric = function (value) {
	if ($elm$core$String$isEmpty(value)) {
		return $elm$core$Result$Ok('');
	} else {
		var _v0 = $elm$core$String$toInt(value);
		if (_v0.$ === 'Just') {
			return $elm$core$Result$Ok(value);
		} else {
			return $elm$core$Result$Err('Must be a number.');
		}
	}
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnOverFormViewV2 = F4(
	function (set, save, _v0, result) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Require verification for invoice amounts over this value. Please leave blank to be disabled.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row collapse')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column begin')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('prefix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('$')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-4 column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('number'),
													$elm$html$Html$Attributes$value(
													A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result)),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ensureNumeric)),
													$elm$html$Html$Attributes$min('0')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column end')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('postfix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('.00')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Helpers$Result$either,
							$elm$core$Basics$always(
								A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil)),
							$elm$core$Basics$always(
								A3($author$project$Components$Shared$Button$confirm, 'Save Amount', save, _List_Nil)),
							result)
						]))
				]));
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOverConfigV2 = A2($author$project$Components$SettingsPage$Shared$EditSection$withV2FormView, $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnOverFormViewV2, $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedWarnIfAmountOverConfig);
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'UpdateWarnOverAmount':
				var msg_ = msg.a;
				var formState = A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOver, data, model);
				var _v1 = A3($author$project$Components$SettingsPage$Shared$EditSection$update, $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOverConfigV2, msg_, formState);
				var newFormState = _v1.a;
				var formEffect = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							warnIfAmountOver: $elm$core$Maybe$Just(newFormState)
						}),
					formEffect);
			case 'UpdateManualReviewPercentage':
				var msg_ = msg.a;
				var formState = A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentage, data, model);
				var _v2 = A3($author$project$Components$SettingsPage$Shared$EditSection$update, $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageConfigV2, msg_, formState);
				var newFormState = _v2.a;
				var formEffect = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							manualReviewPercentage: $elm$core$Maybe$Just(newFormState)
						}),
					formEffect);
			case 'UpdateReviewPercentageRules':
				var tableMsg = msg.a;
				var _v3 = $author$project$Components$SettingsPage$NextGenAuditSettingsView$getTableData(data);
				if (_v3.$ === 'Just') {
					var tableData = _v3.a;
					var _v4 = A3(
						$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$update,
						{data: tableData, toMsg: $author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateReviewPercentageRules},
						tableMsg,
						model.reviewPercentageTable);
					var updatedTable = _v4.a;
					var tableEffect = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{reviewPercentageTable: updatedTable}),
						tableEffect);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			default:
				var msg_ = msg.a;
				var formState = A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsState, data, model);
				var _v5 = A3($author$project$Components$SettingsPage$Shared$EditSection$update, $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsConfigV2, msg_, formState);
				var newFormState = _v5.a;
				var formEffect = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							verificationExceptions: $elm$core$Maybe$Just(newFormState)
						}),
					formEffect);
		}
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$AccountLevel = function (a) {
	return {$: 'AccountLevel', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CardSaved = function (a) {
	return {$: 'CardSaved', a: a};
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$Disabled = {$: 'Disabled'};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$ExceptionOnly = {$: 'ExceptionOnly'};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$PodDetectionAndException = {$: 'PodDetectionAndException'};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$PodDetectionOnly = {$: 'PodDetectionOnly'};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$deriveCheckType = F3(
	function (checkType, checks, runExceptionRule) {
		var detectionEnabled = A2($elm$core$List$member, checkType, checks);
		var _v0 = _Utils_Tuple2(detectionEnabled, runExceptionRule);
		if (_v0.a) {
			if (_v0.b) {
				return $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$PodDetectionAndException;
			} else {
				return $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$PodDetectionOnly;
			}
		} else {
			if (_v0.b) {
				return $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$ExceptionOnly;
			} else {
				return $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$Disabled;
			}
		}
	});
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$init = function (accountSettings) {
	return {
		carrierRateType: A3($author$project$Components$SettingsPage$Shared$PodDefinitionChecks$deriveCheckType, $author$project$AuditPb$DocumentPODInferenceCheckTypeNoCarrierRate, accountSettings.podInferenceCheckTypes, accountSettings.runNoDocumentsHaveCarrierRatesRule),
		checks: accountSettings.podInferenceCheckTypes,
		damagesType: A3($author$project$Components$SettingsPage$Shared$PodDefinitionChecks$deriveCheckType, $author$project$AuditPb$DocumentPODInferenceCheckTypeNoDamages, accountSettings.podInferenceCheckTypes, accountSettings.runNoDocumentsHaveDamagesOrRatesRule),
		podRequiresBolValidation: accountSettings.podRequiresBolValidation,
		referenceMatchEnabled: accountSettings.podDefinitionReferenceMatchEnabled
	};
};
var $author$project$Api$Accounts$savePodDefinitionChecks = function (podModel) {
	var exceptionEnabled = function (exposureType) {
		switch (exposureType.$) {
			case 'PodDetectionAndException':
				return true;
			case 'ExceptionOnly':
				return true;
			default:
				return false;
		}
	};
	var encodedPodDefinitionChecks = $elm$core$List$isEmpty(podModel.checks) ? $elm$json$Json$Encode$string('empty_array') : A2(
		$elm$json$Json$Encode$list,
		A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$documentPODInferenceCheckTypeToString),
		podModel.checks);
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2('pod_definition_checks_enabled', encodedPodDefinitionChecks),
					_Utils_Tuple2(
					'run_no_documents_have_damages_rule',
					$elm$json$Json$Encode$bool(
						exceptionEnabled(podModel.damagesType))),
					_Utils_Tuple2(
					'run_no_documents_have_carrier_rates_rule',
					$elm$json$Json$Encode$bool(
						exceptionEnabled(podModel.carrierRateType)))
				])));
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$podDetectionEnabled = function (exposureType) {
	switch (exposureType.$) {
		case 'PodDetectionAndException':
			return true;
		case 'PodDetectionOnly':
			return true;
		default:
			return false;
	}
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$setCheckEnabled = F3(
	function (checkType, enabled, checks) {
		var withoutCheck = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(checkType),
			checks);
		return enabled ? A2($elm$core$List$cons, checkType, withoutCheck) : withoutCheck;
	});
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'ToggleCheck':
				var checkType = msg.a;
				var enabled = msg.b;
				var newChecks = enabled ? A2($elm$core$List$cons, checkType, model.checks) : A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(checkType),
					model.checks);
				return _Utils_update(
					model,
					{checks: newChecks});
			case 'SetDamagesType':
				var damagesType = msg.a;
				return _Utils_update(
					model,
					{
						checks: A3(
							$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$setCheckEnabled,
							$author$project$AuditPb$DocumentPODInferenceCheckTypeNoDamages,
							$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$podDetectionEnabled(damagesType),
							model.checks),
						damagesType: damagesType
					});
			default:
				var carrierRateType = msg.a;
				return _Utils_update(
					model,
					{
						carrierRateType: carrierRateType,
						checks: A3(
							$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$setCheckEnabled,
							$author$project$AuditPb$DocumentPODInferenceCheckTypeNoCarrierRate,
							$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$podDetectionEnabled(carrierRateType),
							model.checks)
					});
		}
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$updateAccountLevel = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'SetCardEditing':
				if (msg.a) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								accountChecksDraft: $elm$core$Maybe$Just(
									$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$init(data.accountSettings))
							}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{accountChecksDraft: $elm$core$Maybe$Nothing}),
						$author$project$HubTran$Effect$none);
				}
			case 'CardMsg':
				var checksMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							accountChecksDraft: A2(
								$elm$core$Maybe$map,
								$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$update(checksMsg),
								model.accountChecksDraft)
						}),
					$author$project$HubTran$Effect$none);
			case 'SaveCard':
				return _Utils_Tuple2(
					model,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$HubTran$Effect$none,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$Accounts$savePodDefinitionChecks,
							$author$project$HubTran$Effect$sendCacheableRequestWithError(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$PodDefinitionSettingsView$AccountLevel, $author$project$Components$SettingsPage$PodDefinitionSettingsView$CardSaved),
									$elm$core$Basics$eq(
										$author$project$Helpers$Api$Result$Ok(_Utils_Tuple0))))),
						model.accountChecksDraft));
			default:
				if (msg.a) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{accountChecksDraft: $elm$core$Maybe$Nothing}),
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$success('Successfully saved POD definition checks')));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$alert('Failed to save POD definition checks')));
				}
		}
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$DocumentTypeSelectMsg = function (a) {
	return {$: 'DocumentTypeSelectMsg', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$GroupSaved = F2(
	function (a, b) {
		return {$: 'GroupSaved', a: a, b: b};
	});
var $author$project$AuditPb$documentPODInferenceCheckTypeEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$documentPODInferenceCheckTypeToString);
var $author$project$AuditPb$customerPODDefinitionGroupEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$repeatedFieldEncoder,
					'tms_customer_ids',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCustomerId$toInt),
					v.tmsCustomerIds),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'allowed_as_pod_override_document_types', $author$project$AuditPb$documentTypeEncoder, v.allowedAsPODOverrideDocumentTypes),
					A3($author$project$AuditPb$repeatedFieldEncoder, 'pod_definition_checks_enabled', $author$project$AuditPb$documentPODInferenceCheckTypeEncoder, v.podDefinitionChecksEnabled),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'inherits_allowed_as_pod_override_document_types', $elm$json$Json$Encode$bool, v.inheritsAllowedAsPODOverrideDocumentTypes),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'inherits_pod_definition_checks_enabled', $elm$json$Json$Encode$bool, v.inheritsPODDefinitionChecksEnabled)
				])));
};
var $author$project$AuditPb$customerPODDefinitionServiceUpdateRequestEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$author$project$AuditPb$repeatedFieldEncoder,
					'original_tms_customer_ids',
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCustomerId$toInt),
					v.originalTMSCustomerIds),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'group', $author$project$AuditPb$customerPODDefinitionGroupEncoder, v.group)
				])));
};
var $author$project$AuditApi$customerPODDefinitionServiceUpdateWithState = A3($author$project$AuditApi$toRequestState, '/customer_pod_definition_service/update', $author$project$AuditPb$customerPODDefinitionServiceUpdateRequestEncoder, $author$project$AuditPb$emptyDecoder);
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeLabel = function (data) {
	return A2(
		$author$project$Domain$DocumentType$toString,
		data.accountSettings.customDocumentTypeNames,
		$author$project$Domain$Account$environment(data.account));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeItems = F2(
	function (data, group) {
		return A2(
			$elm$core$List$map,
			function (documentType) {
				return {
					id: $author$project$AuditPb$documentTypeToString(documentType),
					label: $elm$html$Html$text(
						A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeLabel, data, documentType)),
					text: A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeLabel, data, documentType)
				};
			},
			A2(
				$elm$core$List$sortBy,
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeLabel(data),
				A2(
					$elm$core$List$filter,
					function (documentType) {
						return !A2($elm$core$List$member, documentType, group.allowedAsPODOverrideDocumentTypes);
					},
					data.definitions.availableDocumentTypes)));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeSelectDomId = 'customer-pod-definition-document-types';
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$toExistingOrNewGroup = function (target) {
	if (target.$ === 'ExistingGroup') {
		var existing = target.a;
		return existing;
	} else {
		return {allowedAsPODOverrideDocumentTypes: _List_Nil, inheritsAllowedAsPODOverrideDocumentTypes: true, inheritsPODDefinitionChecksEnabled: true, podDefinitionChecksEnabled: _List_Nil, tmsCustomerIds: _List_Nil};
	}
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$updateCustomerSelect = F4(
	function (selectMsg, model, data, editing) {
		var current = editing.draft;
		var _v0 = A4($author$project$Components$TmsCustomerDropdown$update, data.accountSettings, data.customerSelectData, selectMsg, editing.customerSelect);
		var customerSelect = _v0.a;
		var cmd = _v0.b;
		var selected = $author$project$Components$TmsCustomerDropdown$selectedIds(customerSelect);
		var newEditing = $elm$core$List$isEmpty(selected) ? _Utils_update(
			editing,
			{customerSelect: customerSelect}) : _Utils_update(
			editing,
			{
				customerSelect: $author$project$Components$TmsCustomerDropdown$clear(customerSelect),
				draft: _Utils_update(
					current,
					{
						tmsCustomerIds: A2(
							$elm_community$list_extra$List$Extra$uniqueBy,
							$author$project$Domain$TmsCustomerId$toInt,
							_Utils_ap(current.tmsCustomerIds, selected))
					})
			});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					editing: $elm$core$Maybe$Just(newEditing)
				}),
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CustomerSelectMsg, cmd)));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$updateDocumentTypeSelect = F4(
	function (selectMsg, model, data, editing) {
		var current = editing.draft;
		var _v0 = A2($author$project$Ui$V3$CustomSelect$update, selectMsg, editing.documentTypeSelect);
		var documentTypeSelect = _v0.a;
		var cmd = _v0.b;
		var selected = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.id;
				},
				$author$project$AuditPb$documentTypeFromString),
			$author$project$Ui$V3$CustomSelect$getFirstSelectedItem(documentTypeSelect));
		var draft = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			current,
			function (documentType) {
				return _Utils_update(
					current,
					{
						allowedAsPODOverrideDocumentTypes: A2($elm$core$List$cons, documentType, current.allowedAsPODOverrideDocumentTypes)
					});
			},
			selected);
		var newEditing = $elm_community$maybe_extra$Maybe$Extra$isJust(selected) ? _Utils_update(
			editing,
			{
				documentTypeSelect: A2(
					$author$project$Ui$V3$CustomSelect$setItems,
					A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeItems, data, draft),
					$author$project$Ui$V3$CustomSelect$clearSelections(documentTypeSelect)),
				draft: draft
			}) : _Utils_update(
			editing,
			{documentTypeSelect: documentTypeSelect});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					editing: $elm$core$Maybe$Just(newEditing)
				}),
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$DocumentTypeSelectMsg, cmd)));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$update = F3(
	function (data, msg, model) {
		var noOpIfNotEditing = F2(
			function (maybeEditing, fn) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $author$project$HubTran$Effect$none),
					fn,
					maybeEditing);
			});
		switch (msg.$) {
			case 'StartEditing':
				var target = msg.a;
				var group = $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$toExistingOrNewGroup(target);
				var _v1 = A2(
					$author$project$Ui$V3$CustomSelect$init,
					{
						domId: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeSelectDomId,
						excludedItems: _List_Nil,
						items: A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeItems, data, group),
						selectedItems: _List_Nil
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
							$author$project$Ui$V3$CustomSelect$filterable(true),
							$author$project$Ui$V3$CustomSelect$hideSelectAll(true),
							$author$project$Ui$V3$CustomSelect$placeholder(
							$elm$core$Maybe$Just('Search document types'))
						]));
				var documentTypeSelect = _v1.a;
				var docTypeCmd = _v1.b;
				var _v2 = $author$project$Components$TmsCustomerDropdown$init(
					_List_fromArray(
						[
							$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
							$author$project$Ui$V3$CustomSelect$hideSelectAll(true),
							$author$project$Ui$V3$CustomSelect$placeholder(
							$elm$core$Maybe$Just('Search customers'))
						]));
				var customerSelect = _v2.a;
				var customerCmd = _v2.b;
				var editing = {customerSelect: customerSelect, documentTypeSelect: documentTypeSelect, draft: group, target: target};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editing: $elm$core$Maybe$Just(editing)
						}),
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$HubTran$Effect$cmd(
								A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$DocumentTypeSelectMsg, docTypeCmd)),
								$author$project$HubTran$Effect$cmd(
								A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CustomerSelectMsg, customerCmd))
							])));
			case 'UpdateDraft':
				var draft = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editing: A2(
								$elm$core$Maybe$map,
								function (editing) {
									return _Utils_update(
										editing,
										{
											documentTypeSelect: A2(
												$author$project$Ui$V3$CustomSelect$setItems,
												A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeItems, data, draft),
												editing.documentTypeSelect),
											draft: draft
										});
								},
								model.editing)
						}),
					$author$project$HubTran$Effect$none);
			case 'DocumentTypeSelectMsg':
				var selectMsg = msg.a;
				return A2(
					noOpIfNotEditing,
					model.editing,
					A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$updateDocumentTypeSelect, selectMsg, model, data));
			case 'CustomerSelectMsg':
				var selectMsg = msg.a;
				return A2(
					noOpIfNotEditing,
					model.editing,
					A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$updateCustomerSelect, selectMsg, model, data));
			case 'CancelEditing':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editing: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'SaveEditing':
				return A2(
					noOpIfNotEditing,
					model.editing,
					function (editing) {
						return A3(
							$author$project$AuditApi$customerPODDefinitionServiceUpdateWithState,
							model,
							$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$GroupSaved('Successfully saved customer POD definition'),
							{
								group: editing.draft,
								originalTMSCustomerIds: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$toExistingOrNewGroup(editing.target).tmsCustomerIds
							});
					});
			case 'StartDeleting':
				var group = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							deleting: $elm$core$Maybe$Just(group)
						}),
					$author$project$HubTran$Effect$none);
			case 'CancelDeleting':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{deleting: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'ConfirmDeleting':
				var group = msg.a;
				return A3(
					$author$project$AuditApi$customerPODDefinitionServiceUpdateWithState,
					model,
					$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$GroupSaved('Successfully deleted customer POD definition'),
					{
						group: _Utils_update(
							group,
							{tmsCustomerIds: _List_Nil}),
						originalTMSCustomerIds: group.tmsCustomerIds
					});
			default:
				var message = msg.a;
				var response = msg.b;
				return A3(
					$author$project$AuditApi$applyRequest,
					model,
					response,
					F2(
						function (savedModel, _v3) {
							return _Utils_Tuple2(
								_Utils_update(
									savedModel,
									{deleting: $elm$core$Maybe$Nothing, editing: $elm$core$Maybe$Nothing}),
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$invalidate($author$project$Forward$AppSpecific$NeedsControllerEndpoints$customerPODDefinitions),
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$success(message))
										])));
						}));
		}
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$updateCustomerLevel = F3(
	function (msg, model, data) {
		var _v0 = A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$update, data, msg, model.customerLevel);
		var customerLevel = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{customerLevel: customerLevel}),
			A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevelMsg, effect));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$update = F3(
	function (data, msg, model) {
		if (msg.$ === 'AccountLevel') {
			var accountLevelMsg = msg.a;
			return A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$updateAccountLevel, data, accountLevelMsg, model);
		} else {
			var customerLevelMsg = msg.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_Utils_Tuple2(model, $author$project$HubTran$Effect$none),
				A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$updateCustomerLevel, customerLevelMsg, model),
				$author$project$Forward$Remote$toMaybe(data.customerLevel));
		}
	});
var $author$project$Components$SettingsPage$update = F4(
	function (v3ReskinEnabled, data, msg, model) {
		switch (msg.$) {
			case 'NextGenAuditSettingsViewMsg':
				var childMsg = msg.a;
				var _v1 = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.sectionData;
					},
					data);
				if ((_v1.$ === 'Loaded') && (_v1.a.$ === 'NextGenAuditSettingsData')) {
					var _v2 = _v1.a;
					var childModel = _v2.a;
					var childData = _v2.b;
					var _v3 = A3($author$project$Components$SettingsPage$NextGenAuditSettingsView$update, childData, childMsg, childModel);
					var newChildModel = _v3.a;
					var childEffect = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$NextGenAuditSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$NextGenAuditSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'AccountSettingsViewMsg':
				var childMsg = msg.a;
				var _v4 = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.sectionData;
					},
					data);
				if ((_v4.$ === 'Loaded') && (_v4.a.$ === 'AccountSettingsData')) {
					var _v5 = _v4.a;
					var childModel = _v5.a;
					var childData = _v5.b;
					var _v6 = A4($author$project$Components$SettingsPage$AccountSettingsView$update, v3ReskinEnabled, childData, childMsg, childModel);
					var newChildModel = _v6.a;
					var childEffect = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$AccountSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$AccountSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'DocumentTypesSettingsViewMsg':
				var childMsg = msg.a;
				var _v7 = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.sectionData;
					},
					data);
				if ((_v7.$ === 'Loaded') && (_v7.a.$ === 'DocumentTypesSettingsData')) {
					var _v8 = _v7.a;
					var childModel = _v8.a;
					var childData = _v8.b;
					var _v9 = A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$update, childData, childMsg, childModel);
					var newChildModel = _v9.a;
					var childEffect = _v9.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$DocumentTypesSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$DocumentTypesSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'CarrierDocumentsSettingsViewMsg':
				var childMsg = msg.a;
				var _v10 = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.sectionData;
					},
					data);
				if ((_v10.$ === 'Loaded') && (_v10.a.$ === 'CarrierDocumentsSettingsData')) {
					var _v11 = _v10.a;
					var childModel = _v11.a;
					var childData = _v11.b;
					var _v12 = A3($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$update, childData, childMsg, childModel);
					var newChildModel = _v12.a;
					var childEffect = _v12.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$CarrierDocumentsSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$CarrierDocumentsSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'ContactsSettingsViewMsg':
				var childMsg = msg.a;
				var _v13 = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.sectionData;
					},
					data);
				if ((_v13.$ === 'Loaded') && (_v13.a.$ === 'ContactsSettingsData')) {
					var _v14 = _v13.a;
					var childModel = _v14.a;
					var childData = _v14.b;
					var _v15 = A4($author$project$Components$SettingsPage$ContactsSettingsView$update, v3ReskinEnabled, childData, childMsg, childModel);
					var newChildModel = _v15.a;
					var childEffect = _v15.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$ContactsSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ContactsSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'DebtorsSettingsViewMsg':
				var childMsg = msg.a;
				var _v16 = model.activeSection;
				if (_v16.$ === 'DebtorsSettings') {
					var childModel = _v16.a;
					var _v17 = A2($author$project$Components$SettingsPage$DebtorsSettingsView$update, childMsg, childModel);
					var newChildModel = _v17.a;
					var childEffect = _v17.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$DebtorsSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$DebtorsSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'FactorClientPortalSettingsViewMsg':
				var childMsg = msg.a;
				var _v18 = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.sectionData;
					},
					data);
				if ((_v18.$ === 'Loaded') && (_v18.a.$ === 'FactorClientPortalSettingsData')) {
					var _v19 = _v18.a;
					var childModel = _v19.a;
					var childData = _v19.b;
					var _v20 = A3($author$project$Components$SettingsPage$FactorClientPortalSettingsView$update, childData, childMsg, childModel);
					var newChildModel = _v20.a;
					var childEffect = _v20.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$FactorClientPortalSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$FactorClientPortalSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'PodDefinitionSettingsViewMsg':
				var childMsg = msg.a;
				var _v21 = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.sectionData;
					},
					data);
				if ((_v21.$ === 'Loaded') && (_v21.a.$ === 'PodDefinitionSettingsData')) {
					var _v22 = _v21.a;
					var childModel = _v22.a;
					var childData = _v22.b;
					var _v23 = A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$update, childData, childMsg, childModel);
					var newChildModel = _v23.a;
					var childEffect = _v23.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$PodDefinitionSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$PodDefinitionSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			default:
				var childMsg = msg.a;
				var _v24 = A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.sectionData;
					},
					data);
				if ((_v24.$ === 'Loaded') && (_v24.a.$ === 'ExceptionSettingsData')) {
					var _v25 = _v24.a;
					var childModel = _v25.a;
					var childData = _v25.b;
					var _v26 = A3($author$project$Components$SettingsPage$ExceptionSettingsView$update, childData, childMsg, childModel);
					var newChildModel = _v26.a;
					var childEffect = _v26.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								activeSection: $author$project$Components$SettingsPage$ExceptionSettings(newChildModel)
							}),
						A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$ExceptionSettingsViewMsg, childEffect));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$FinishSaving = F2(
	function (a, b) {
		return {$: 'FinishSaving', a: a, b: b};
	});
var $author$project$Components$SettingsPage$CarrierLayout$FinishSavingContact = function (a) {
	return {$: 'FinishSavingContact', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$FinishSavingExternalLogin = function (a) {
	return {$: 'FinishSavingExternalLogin', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$FinishSending = function (a) {
	return {$: 'FinishSending', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$FinishTestingCredentials = function (a) {
	return {$: 'FinishTestingCredentials', a: a};
};
var $author$project$Api$Carriers$ExternalLogins$TestFailure = function (a) {
	return {$: 'TestFailure', a: a};
};
var $author$project$HubTran$Navigation$back = _Platform_outgoingPort('back', $elm$json$Json$Encode$int);
var $author$project$Api$Carriers$Contacts$collectionUrl = function (id) {
	return '/api/carriers/' + ($elm$core$String$fromInt(
		$author$project$Domain$TmsCarrierId$toInt(id)) + '/contacts');
};
var $author$project$Api$Carriers$Contacts$nullIfEmptyString = function (value) {
	return $elm$core$String$isEmpty(value) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(value);
};
var $author$project$Api$Carriers$Contacts$encode = function (contact) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'contact',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$author$project$Api$Carriers$Contacts$nullIfEmptyString(contact.name)),
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(contact.email)),
							_Utils_Tuple2(
							'admin',
							$elm$json$Json$Encode$bool(contact.admin)),
							_Utils_Tuple2(
							'factor_client_portal_enabled',
							$elm$json$Json$Encode$bool(contact.factorClientPortalEnabled)),
							_Utils_Tuple2(
							'portal_submission_strategy',
							function () {
								var _v0 = contact.portalSubmissionStrategy;
								if (_v0.$ === 'PortalOnly') {
									return $elm$json$Json$Encode$string('portal_only');
								} else {
									return $elm$json$Json$Encode$string('factor_only');
								}
							}())
						])))
			]));
};
var $author$project$Api$Carriers$Contacts$create = F2(
	function (carrierId, contact) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$Carriers$Contacts$collectionUrl(carrierId),
			$author$project$Api$Carriers$Contacts$encode(contact));
	});
var $author$project$Api$Carriers$ExternalLogins$collectionUrl = function (carrierId) {
	return '/api/carriers/' + ($elm$core$String$fromInt(
		$author$project$Domain$TmsCarrierId$toInt(carrierId)) + '/external_logins');
};
var $author$project$Api$Carriers$ExternalLogins$maybePair = F2(
	function (name, encode_) {
		return $elm$core$Maybe$map(
			A2(
				$elm$core$Basics$composeL,
				function (b) {
					return _Utils_Tuple2(name, b);
				},
				encode_));
	});
var $author$project$Api$Carriers$ExternalLogins$passwordToMaybe = function (password) {
	switch (password.$) {
		case 'Absent':
			return $elm$core$Maybe$Nothing;
		case 'Present':
			return $elm$core$Maybe$Nothing;
		default:
			var x = password.a;
			return $elm$core$Maybe$Just(x);
	}
};
var $author$project$Api$Carriers$ExternalLogins$encode = function (login) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'external_login',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A3($author$project$Api$Carriers$ExternalLogins$maybePair, 'user', $elm$json$Json$Encode$string, login.user),
								A3(
								$author$project$Api$Carriers$ExternalLogins$maybePair,
								'password',
								$elm$json$Json$Encode$string,
								$author$project$Api$Carriers$ExternalLogins$passwordToMaybe(login.password)),
								A3($author$project$Api$Carriers$ExternalLogins$maybePair, 'token', $elm$json$Json$Encode$string, login.token),
								A3(
								$author$project$Api$Carriers$ExternalLogins$maybePair,
								'tms_customer_id',
								A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$TmsCustomerId$toInt),
								login.customerId),
								A3(
								$author$project$Api$Carriers$ExternalLogins$maybePair,
								'scraping_services',
								$elm$json$Json$Encode$list($elm$json$Json$Encode$string),
								$elm$core$Maybe$Just(
									A2($elm$core$List$map, $author$project$AuditPb$scrapingServiceToString, login.scrapingServices))),
								$elm$core$Maybe$Just(
								_Utils_Tuple2(
									'mark_login_failed',
									$elm$json$Json$Encode$bool(login.markLoginFailed)))
							]))))
			]));
};
var $author$project$Api$Carriers$ExternalLogins$create = F2(
	function (carrierId, login) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$Carriers$ExternalLogins$collectionUrl(carrierId),
			$author$project$Api$Carriers$ExternalLogins$encode(login));
	});
var $author$project$Api$Carriers$Contacts$memberUrl = F2(
	function (carrierId, contactId) {
		return $author$project$Api$Carriers$Contacts$collectionUrl(carrierId) + ('/' + $elm$core$String$fromInt(
			$author$project$Domain$ContactId$toInt(contactId)));
	});
var $author$project$Api$Carriers$Contacts$delete = F2(
	function (carrierId, contactId) {
		return $author$project$Helpers$Api$delete(
			A2($author$project$Api$Carriers$Contacts$memberUrl, carrierId, contactId));
	});
var $author$project$Api$Carriers$ExternalLogins$memberUrl = F2(
	function (carrierId, id) {
		return $author$project$Api$Carriers$ExternalLogins$collectionUrl(carrierId) + ('/' + $elm$core$String$fromInt(
			$author$project$Domain$ExternalLoginId$toInt(id)));
	});
var $author$project$Api$Carriers$ExternalLogins$delete = F2(
	function (carrierId, id) {
		return $author$project$Helpers$Api$delete(
			A2($author$project$Api$Carriers$ExternalLogins$memberUrl, carrierId, id));
	});
var $author$project$Domain$ExternalLoginId$dummyId = $author$project$Domain$ExternalLoginId$ExternalLoginId(-1);
var $author$project$Api$Carriers$memberUrl = function (id) {
	return '/api/carriers/' + $elm$core$String$fromInt(
		$author$project$Domain$TmsCarrierId$toInt(id));
};
var $author$project$Api$Carriers$updateField = F3(
	function (id, name, value) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'carrier',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(name, value)
							])))
				]));
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			$author$project$Api$Carriers$memberUrl(id),
			body);
	});
var $author$project$Api$Carriers$factorClientPortalEnabled = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'enable_factor_client_portal',
			$elm$json$Json$Encode$bool(data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$blankAddress = {addressLine1: $elm$core$Maybe$Nothing, addressLine2: $elm$core$Maybe$Nothing, city: $elm$core$Maybe$Nothing, country: $elm$core$Maybe$Nothing, id: $elm$core$Maybe$Nothing, name: '', postalCode: $elm$core$Maybe$Nothing, state: $elm$core$Maybe$Nothing};
var $author$project$Domain$Feature$overrideToId = function (override) {
	switch (override.$) {
		case 'Default':
			return 'Default';
		case 'AlwaysOn':
			return 'AlwaysOn';
		default:
			return 'AlwaysOff';
	}
};
var $author$project$Domain$Feature$overrideToLabel = function (override) {
	switch (override.$) {
		case 'Default':
			return '(Default)';
		case 'AlwaysOn':
			return 'Always On';
		default:
			return 'Always Off';
	}
};
var $author$project$Components$SettingsPage$CarrierLayout$carrierToFeatureOverrides = function (carrier) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$HubTran$Effect$batch,
		$elm$core$List$unzip(
			A2(
				$elm$core$List$map,
				function (feature) {
					var onItem = $author$project$Ui$V3$CustomSelect$simpleItem(
						{
							id: $author$project$Domain$Feature$overrideToId($author$project$Domain$Feature$AlwaysOn),
							label: $author$project$Domain$Feature$overrideToLabel($author$project$Domain$Feature$AlwaysOn)
						});
					var offItem = $author$project$Ui$V3$CustomSelect$simpleItem(
						{
							id: $author$project$Domain$Feature$overrideToId($author$project$Domain$Feature$AlwaysOff),
							label: $author$project$Domain$Feature$overrideToLabel($author$project$Domain$Feature$AlwaysOff)
						});
					var defaultItem = $author$project$Ui$V3$CustomSelect$simpleItem(
						{
							id: $author$project$Domain$Feature$overrideToId($author$project$Domain$Feature$Default),
							label: $author$project$Domain$Feature$overrideToLabel($author$project$Domain$Feature$Default)
						});
					var _v0 = A2(
						$author$project$Ui$V3$CustomSelect$init,
						{
							domId: 'carrier-feature-' + feature.id,
							excludedItems: _List_Nil,
							items: _List_fromArray(
								[defaultItem, onItem, offItem]),
							selectedItems: function () {
								var _v1 = feature.overrideForClient;
								switch (_v1.$) {
									case 'Default':
										return _List_fromArray(
											[defaultItem]);
									case 'AlwaysOn':
										return _List_fromArray(
											[onItem]);
									default:
										return _List_fromArray(
											[offItem]);
								}
							}()
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$CustomSelect$hideSelectAll(true)
							]));
					var dropdown = _v0.a;
					var cmd = _v0.b;
					return _Utils_Tuple2(
						{dropdown: dropdown, feature: feature},
						$author$project$HubTran$Effect$AnyCmd(
							A2(
								$elm$core$Platform$Cmd$map,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$SettingsPage$CarrierLayout$FormMsg,
									$author$project$Components$SettingsPage$CarrierLayout$UpdateFeature(feature.id)),
								cmd)));
				},
				A2(
					$elm$core$List$filter,
					function (feature) {
						return feature.canOverrideForClient;
					},
					carrier.features))));
};
var $author$project$Domain$Override$AccountDefault = {$: 'AccountDefault'};
var $author$project$Domain$Override$Disabled = {$: 'Disabled'};
var $author$project$Domain$Override$Enabled = {$: 'Enabled'};
var $author$project$Domain$Override$determineImplicitInvoiceOverrideType = function (implicitInvoice) {
	return implicitInvoice.overrideEnabled ? (implicitInvoice.allowImplicitInvoice ? $author$project$Domain$Override$Enabled : $author$project$Domain$Override$Disabled) : $author$project$Domain$Override$AccountDefault;
};
var $author$project$Components$SettingsPage$Shared$Tolerance$init = F6(
	function (overrideEnabled, amountAbove, amountBelow, unit, overrideTypeLabel, enabledModeList) {
		return {amountAbove: amountAbove, amountBelow: amountBelow, enabledModeList: enabledModeList, overrideEnabled: overrideEnabled, overrideTypeLabel: overrideTypeLabel, unit: unit};
	});
var $author$project$Components$SettingsPage$CarrierLayout$mergeFormData = F2(
	function (data, previousForm) {
		var form = function (getter) {
			return A2($elm$core$Maybe$map, getter, previousForm);
		};
		var carrier = data.carrierData.carrier;
		var implicitInvoiceOverrideType = $author$project$Domain$Override$determineImplicitInvoiceOverrideType(carrier.implicitInvoice);
		var _v0 = function () {
			if (previousForm.$ === 'Just') {
				var prevForm = previousForm.a;
				return _Utils_Tuple2(prevForm.featureOverrides, $author$project$HubTran$Effect$none);
			} else {
				return $author$project$Components$SettingsPage$CarrierLayout$carrierToFeatureOverrides(carrier);
			}
		}();
		var featureOverrides = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			{
				autoGenerateInvoiceNumbers: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					carrier.autoGenerateFactorInvoiceNumbers,
					form(
						function ($) {
							return $.autoGenerateInvoiceNumbers;
						})),
				featureOverrides: featureOverrides,
				implicitInvoiceOverride: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					implicitInvoiceOverrideType,
					form(
						function ($) {
							return $.implicitInvoiceOverride;
						})),
				invoiceNumberStrategy: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					carrier.factorInvoiceNumberStrategy,
					form(
						function ($) {
							return $.invoiceNumberStrategy;
						})),
				invoiceTolerance: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					A6($author$project$Components$SettingsPage$Shared$Tolerance$init, carrier.overrideDefaultTolerance, carrier.invoiceToleranceAmountAbove, carrier.invoiceToleranceAmountBelow, carrier.invoiceToleranceUnit, 'Carrier specific', data.accountSettings.carrierToleranceEnabledModes),
					form(
						function ($) {
							return $.invoiceTolerance;
						})),
				labels: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					carrier.labels,
					form(
						function ($) {
							return $.labels;
						})),
				manualReviewPercentage: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					$elm$core$Result$Ok(carrier.manualReviewPercentage),
					form(
						function ($) {
							return $.manualReviewPercentage;
						})),
				paymentAddress: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					A2($elm$core$Maybe$withDefault, $author$project$Components$SettingsPage$CarrierLayout$blankAddress, carrier.paymentAddress),
					form(
						function ($) {
							return $.paymentAddress;
						})),
				paymentTerms: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					$elm$core$Result$Ok(carrier.effectiveDaysToPay),
					form(
						function ($) {
							return $.paymentTerms;
						})),
				quickpayDiscount: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					A2($elm$core$Result$fromMaybe, '', carrier.effectiveQuickpayDiscount),
					form(
						function ($) {
							return $.quickpayDiscount;
						})),
				submissionStrategy: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					carrier.portalSubmissionStrategy,
					form(
						function ($) {
							return $.submissionStrategy;
						})),
				verifyPercentile: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					A2($elm$core$Result$fromMaybe, '', carrier.verifyPercentile),
					form(
						function ($) {
							return $.verifyPercentile;
						})),
				warnIfAmountOver: A2(
					$author$project$Components$SettingsPage$Shared$EditSection$init,
					$elm$core$Result$Ok(carrier.warnIfAmountOver),
					form(
						function ($) {
							return $.warnIfAmountOver;
						}))
			},
			effect);
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$newId = $author$project$Domain$ContactId$fromInt(-1);
var $author$project$Api$Invites$inviteRequestUrl = '/hubtran/invites/request_portal_invite';
var $author$project$Api$Invites$request = F2(
	function (carrierId, email) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email_address',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'carrier_id',
					$elm$json$Json$Encode$int(
						$author$project$Domain$TmsCarrierId$toInt(carrierId)))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, $author$project$Api$Invites$inviteRequestUrl, body);
	});
var $author$project$Api$Carriers$ExternalLogins$TestSuccess = {$: 'TestSuccess'};
var $author$project$Api$Carriers$ExternalLogins$decodeTestCredentialsResult = A2(
	$elm$json$Json$Decode$andThen,
	function (success) {
		return success ? $elm$json$Json$Decode$succeed($author$project$Api$Carriers$ExternalLogins$TestSuccess) : A2(
			$elm$json$Json$Decode$map,
			$author$project$Api$Carriers$ExternalLogins$TestFailure,
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault('Credential test failed'),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string))));
	},
	A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool));
var $author$project$Api$Carriers$ExternalLogins$testCredentials = F2(
	function (carrierId, login) {
		return A3(
			$author$project$Helpers$Api$post,
			$author$project$Api$Carriers$ExternalLogins$collectionUrl(carrierId) + '/test_credentials',
			$author$project$Api$Carriers$ExternalLogins$encode(login),
			$author$project$Api$Carriers$ExternalLogins$decodeTestCredentialsResult);
	});
var $author$project$Api$Carriers$Contacts$update = F2(
	function (carrierId, contact) {
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			A2($author$project$Api$Carriers$Contacts$memberUrl, carrierId, contact.id),
			$author$project$Api$Carriers$Contacts$encode(contact));
	});
var $author$project$Api$Carriers$ExternalLogins$update = F2(
	function (carrierId, login) {
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			A2($author$project$Api$Carriers$ExternalLogins$memberUrl, carrierId, login.id),
			$author$project$Api$Carriers$ExternalLogins$encode(login));
	});
var $author$project$Components$ClientDebtorConfigurationManager$ClientLevel = {$: 'ClientLevel'};
var $author$project$Components$ClientDebtorConfigurationManager$ConfigurationDeleted = F2(
	function (a, b) {
		return {$: 'ConfigurationDeleted', a: a, b: b};
	});
var $author$project$Components$ClientDebtorConfigurationManager$ConfigurationSaved = function (a) {
	return {$: 'ConfigurationSaved', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$ConfigurationUpdated = function (a) {
	return {$: 'ConfigurationUpdated', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$CreatingClientLevelConfig = {$: 'CreatingClientLevelConfig'};
var $author$project$Components$ClientDebtorConfigurationManager$CreatingDebtorConfig = {$: 'CreatingDebtorConfig'};
var $author$project$Components$ClientDebtorConfigurationManager$EditingClientLevelConfig = function (a) {
	return {$: 'EditingClientLevelConfig', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$EditingDebtorConfig = function (a) {
	return {$: 'EditingDebtorConfig', a: a};
};
var $author$project$Domain$AmountMatchRequirement$encode = function (setting) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (setting.$) {
				case 'Inherit':
					return 'inherit';
				case 'MustMatch':
					return 'must_match';
				default:
					return 'may_differ';
			}
		}());
};
var $author$project$Domain$DeliveryDateCheckSetting$encode = function (setting) {
	switch (setting.$) {
		case 'Inherit':
			return $elm$json$Json$Encode$null;
		case 'Disabled':
			return $elm$json$Json$Encode$int(0);
		case 'ThirtyDays':
			return $elm$json$Json$Encode$int(30);
		case 'SixtyDays':
			return $elm$json$Json$Encode$int(60);
		default:
			return $elm$json$Json$Encode$int(90);
	}
};
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$encode = function (setting) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (setting.$) {
				case 'Inherit':
					return 'unset';
				case 'Enabled':
					return 'on';
				default:
					return 'off';
			}
		}());
};
var $author$project$Domain$LaneRateCheckSetting$encode = function (setting) {
	switch (setting.$) {
		case 'Inherit':
			return $elm$json$Json$Encode$string('unset');
		case 'Enabled':
			return $elm$json$Json$Encode$string('on');
		default:
			return $elm$json$Json$Encode$string('off');
	}
};
var $author$project$Domain$RequirementSetting$encode = function (setting) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (setting.$) {
				case 'Inherit':
					return 'inherit';
				case 'Required':
					return 'required';
				default:
					return 'not_required';
			}
		}());
};
var $author$project$Domain$TrustClientSubmittedSetting$encode = function (setting) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (setting.$) {
				case 'Inherit':
					return 'inherit';
				case 'Enabled':
					return 'enabled';
				default:
					return 'disabled';
			}
		}());
};
var $author$project$Api$ClientDebtorConfigurations$maybeEncodeString = function (maybeStr) {
	if (maybeStr.$ === 'Just') {
		var str = maybeStr.a;
		return $elm$json$Json$Encode$string(str);
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Api$ClientDebtorConfigurations$create = function (carrierId) {
	return function (maybeDebtorId) {
		return function (notes) {
			return function (rateConRequired) {
				return function (bolRequired) {
					return function (podRequired) {
						return function (amountMatchRequirement) {
							return function (amountSource) {
								return function (alwaysBlock) {
									return function (laneRateCheckSetting) {
										return function (factorDeliveryDateCheckDays) {
											return function (invoiceAmountHistoryRuleMode) {
												return function (trustClientSubmittedInvoiceNumber) {
													return function (trustClientSubmittedLoadId) {
														return function (trustClientSubmittedDebtor) {
															return function (trustClientSubmittedAmount) {
																var debtorIdField = function () {
																	if (maybeDebtorId.$ === 'Just') {
																		var debtorId = maybeDebtorId.a;
																		return _List_fromArray(
																			[
																				_Utils_Tuple2(
																				'debtor_id',
																				$elm$json$Json$Encode$int(
																					$author$project$Domain$FactorBrokerId$toInt(debtorId)))
																			]);
																	} else {
																		return _List_Nil;
																	}
																}();
																var configFields = _Utils_ap(
																	debtorIdField,
																	_List_fromArray(
																		[
																			_Utils_Tuple2(
																			'notes',
																			$author$project$Api$ClientDebtorConfigurations$maybeEncodeString(notes)),
																			_Utils_Tuple2(
																			'rate_con_required',
																			$author$project$Domain$RequirementSetting$encode(rateConRequired)),
																			_Utils_Tuple2(
																			'bol_required',
																			$author$project$Domain$RequirementSetting$encode(bolRequired)),
																			_Utils_Tuple2(
																			'pod_required',
																			$author$project$Domain$RequirementSetting$encode(podRequired)),
																			_Utils_Tuple2(
																			'amount_match_requirement',
																			$author$project$Domain$AmountMatchRequirement$encode(amountMatchRequirement)),
																			_Utils_Tuple2(
																			'amount_source',
																			$elm$json$Json$Encode$string(amountSource)),
																			_Utils_Tuple2(
																			'always_block',
																			$elm$json$Json$Encode$bool(alwaysBlock)),
																			_Utils_Tuple2(
																			'lane_rate_exceptions_mode',
																			$author$project$Domain$LaneRateCheckSetting$encode(laneRateCheckSetting)),
																			_Utils_Tuple2(
																			'factor_delivery_date_check_days',
																			$author$project$Domain$DeliveryDateCheckSetting$encode(factorDeliveryDateCheckDays)),
																			_Utils_Tuple2(
																			'invoice_amount_history_rule_mode',
																			$author$project$Domain$InvoiceAmountHistoryCheckSetting$encode(invoiceAmountHistoryRuleMode)),
																			_Utils_Tuple2(
																			'trust_client_submitted_invoice_number',
																			$author$project$Domain$TrustClientSubmittedSetting$encode(trustClientSubmittedInvoiceNumber)),
																			_Utils_Tuple2(
																			'trust_client_submitted_load_id',
																			$author$project$Domain$TrustClientSubmittedSetting$encode(trustClientSubmittedLoadId)),
																			_Utils_Tuple2(
																			'trust_client_submitted_debtor',
																			$author$project$Domain$TrustClientSubmittedSetting$encode(trustClientSubmittedDebtor)),
																			_Utils_Tuple2(
																			'trust_client_submitted_amount',
																			$author$project$Domain$TrustClientSubmittedSetting$encode(trustClientSubmittedAmount))
																		]));
																return A3(
																	$author$project$Helpers$Api$post,
																	'/api/carriers/' + ($elm$core$String$fromInt(
																		$author$project$Domain$TmsCarrierId$toInt(carrierId)) + '/client_debtor_configurations'),
																	$elm$json$Json$Encode$object(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'configuration',
																				$elm$json$Json$Encode$object(configFields))
																			])),
																	A2($elm$json$Json$Decode$field, 'clientDebtorConfiguration', $author$project$Domain$ClientDebtorConfiguration$decoder));
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$ClientDebtorConfigurations$delete = F2(
	function (carrierId, configId) {
		return $author$project$Helpers$Api$delete(
			'/api/carriers/' + ($elm$core$String$fromInt(
				$author$project$Domain$TmsCarrierId$toInt(carrierId)) + ('/client_debtor_configurations/' + $elm$core$String$fromInt(configId))));
	});
var $author$project$Components$ClientDebtorConfigurationManager$resetFormFields = function (model) {
	return _Utils_update(
		model,
		{alwaysBlock: false, amountMatchRequirement: $author$project$Domain$AmountMatchRequirement$Inherit, amountSource: 'invoice', bolRequired: $author$project$Domain$RequirementSetting$Inherit, configMode: $author$project$Components$ClientDebtorConfigurationManager$DebtorSpecific, debtorTypeahead: $author$project$Components$DebtorTypeahead$init, factorDeliveryDateCheckDays: $author$project$Domain$DeliveryDateCheckSetting$Inherit, formState: $author$project$Components$ClientDebtorConfigurationManager$Hidden, invoiceAmountHistoryRuleMode: $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit, laneRateExceptionsMode: $author$project$Domain$LaneRateCheckSetting$Inherit, notes: $elm$core$Maybe$Nothing, podRequired: $author$project$Domain$RequirementSetting$Inherit, rateConRequired: $author$project$Domain$RequirementSetting$Inherit, trustClientSubmittedAmount: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedDebtor: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedInvoiceNumber: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedLoadId: $author$project$Domain$TrustClientSubmittedSetting$Inherit});
};
var $author$project$Api$ClientDebtorConfigurations$update = function (carrierId) {
	return function (configId) {
		return function (notes) {
			return function (rateConRequired) {
				return function (bolRequired) {
					return function (podRequired) {
						return function (amountMatchRequirement) {
							return function (amountSource) {
								return function (alwaysBlock) {
									return function (laneRateCheckSetting) {
										return function (factorDeliveryDateCheckDays) {
											return function (invoiceAmountHistoryRuleMode) {
												return function (trustClientSubmittedInvoiceNumber) {
													return function (trustClientSubmittedLoadId) {
														return function (trustClientSubmittedDebtor) {
															return function (trustClientSubmittedAmount) {
																return A3(
																	$author$project$Helpers$Api$put,
																	'/api/carriers/' + ($elm$core$String$fromInt(
																		$author$project$Domain$TmsCarrierId$toInt(carrierId)) + ('/client_debtor_configurations/' + $elm$core$String$fromInt(configId))),
																	$elm$json$Json$Encode$object(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'configuration',
																				$elm$json$Json$Encode$object(
																					_List_fromArray(
																						[
																							_Utils_Tuple2(
																							'notes',
																							$author$project$Api$ClientDebtorConfigurations$maybeEncodeString(notes)),
																							_Utils_Tuple2(
																							'rate_con_required',
																							$author$project$Domain$RequirementSetting$encode(rateConRequired)),
																							_Utils_Tuple2(
																							'bol_required',
																							$author$project$Domain$RequirementSetting$encode(bolRequired)),
																							_Utils_Tuple2(
																							'pod_required',
																							$author$project$Domain$RequirementSetting$encode(podRequired)),
																							_Utils_Tuple2(
																							'amount_match_requirement',
																							$author$project$Domain$AmountMatchRequirement$encode(amountMatchRequirement)),
																							_Utils_Tuple2(
																							'amount_source',
																							$elm$json$Json$Encode$string(amountSource)),
																							_Utils_Tuple2(
																							'always_block',
																							$elm$json$Json$Encode$bool(alwaysBlock)),
																							_Utils_Tuple2(
																							'lane_rate_exceptions_mode',
																							$author$project$Domain$LaneRateCheckSetting$encode(laneRateCheckSetting)),
																							_Utils_Tuple2(
																							'factor_delivery_date_check_days',
																							$author$project$Domain$DeliveryDateCheckSetting$encode(factorDeliveryDateCheckDays)),
																							_Utils_Tuple2(
																							'invoice_amount_history_rule_mode',
																							$author$project$Domain$InvoiceAmountHistoryCheckSetting$encode(invoiceAmountHistoryRuleMode)),
																							_Utils_Tuple2(
																							'trust_client_submitted_invoice_number',
																							$author$project$Domain$TrustClientSubmittedSetting$encode(trustClientSubmittedInvoiceNumber)),
																							_Utils_Tuple2(
																							'trust_client_submitted_load_id',
																							$author$project$Domain$TrustClientSubmittedSetting$encode(trustClientSubmittedLoadId)),
																							_Utils_Tuple2(
																							'trust_client_submitted_debtor',
																							$author$project$Domain$TrustClientSubmittedSetting$encode(trustClientSubmittedDebtor)),
																							_Utils_Tuple2(
																							'trust_client_submitted_amount',
																							$author$project$Domain$TrustClientSubmittedSetting$encode(trustClientSubmittedAmount))
																						])))
																			])),
																	A2($elm$json$Json$Decode$field, 'clientDebtorConfiguration', $author$project$Domain$ClientDebtorConfiguration$decoder));
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$ClientDebtorConfigurationManager$update = F3(
	function (maybeData, msg, model) {
		switch (msg.$) {
			case 'ConfigurationsLoaded':
				if (msg.a.$ === 'Ok') {
					var configurations = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{configurations: configurations, isLoading: false, loadError: $elm$core$Maybe$Nothing}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								isLoading: false,
								loadError: $elm$core$Maybe$Just('Failed to load configurations. Please refresh the page.')
							}),
						$author$project$HubTran$Effect$none);
				}
			case 'DebtorTypeaheadMsg':
				var subMsg = msg.a;
				var debtorTypeaheadData = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Forward$Remote$Loading,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.debtorTypeaheadData;
						},
						maybeData));
				var newDebtorTypeahead = A3($author$project$Components$DebtorTypeahead$update, debtorTypeaheadData, subMsg, model.debtorTypeahead);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtorTypeahead: newDebtorTypeahead}),
					$author$project$HubTran$Effect$none);
			case 'NotesChanged':
				var newNotes = msg.a;
				var normalizedNotes = $elm$core$String$isEmpty(newNotes) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(newNotes);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{notes: normalizedNotes}),
					$author$project$HubTran$Effect$none);
			case 'RateConRequiredChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rateConRequired: value}),
					$author$project$HubTran$Effect$none);
			case 'BolRequiredChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bolRequired: value}),
					$author$project$HubTran$Effect$none);
			case 'PodRequiredChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{podRequired: value}),
					$author$project$HubTran$Effect$none);
			case 'AmountMatchRequirementChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{amountMatchRequirement: value}),
					$author$project$HubTran$Effect$none);
			case 'AmountSourceChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{amountSource: value}),
					$author$project$HubTran$Effect$none);
			case 'AlwaysBlockChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{alwaysBlock: value}),
					$author$project$HubTran$Effect$none);
			case 'LaneRateCheckSettingChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{laneRateExceptionsMode: value}),
					$author$project$HubTran$Effect$none);
			case 'InvoiceAmountHistoryCheckSettingChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{invoiceAmountHistoryRuleMode: value}),
					$author$project$HubTran$Effect$none);
			case 'TrustClientSubmittedInvoiceNumberChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{trustClientSubmittedInvoiceNumber: value}),
					$author$project$HubTran$Effect$none);
			case 'TrustClientSubmittedLoadIdChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{trustClientSubmittedLoadId: value}),
					$author$project$HubTran$Effect$none);
			case 'TrustClientSubmittedDebtorChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{trustClientSubmittedDebtor: value}),
					$author$project$HubTran$Effect$none);
			case 'TrustClientSubmittedAmountChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{trustClientSubmittedAmount: value}),
					$author$project$HubTran$Effect$none);
			case 'DeliveryDateCheckSettingChanged':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{factorDeliveryDateCheckDays: value}),
					$author$project$HubTran$Effect$none);
			case 'SaveConfiguration':
				var _v1 = model.formState;
				switch (_v1.$) {
					case 'CreatingClientLevelConfig':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{savingConfiguration: true}),
							A2(
								$author$project$HubTran$Effect$sendCacheableRequestWithError,
								$author$project$Components$ClientDebtorConfigurationManager$ConfigurationSaved,
								$author$project$Api$ClientDebtorConfigurations$create(model.carrierId)($elm$core$Maybe$Nothing)(model.notes)(model.rateConRequired)(model.bolRequired)(model.podRequired)(model.amountMatchRequirement)(model.amountSource)(model.alwaysBlock)(model.laneRateExceptionsMode)(model.factorDeliveryDateCheckDays)(model.invoiceAmountHistoryRuleMode)(model.trustClientSubmittedInvoiceNumber)(model.trustClientSubmittedLoadId)(model.trustClientSubmittedDebtor)(model.trustClientSubmittedAmount)));
					case 'CreatingDebtorConfig':
						var _v2 = $author$project$Typeahead$selectedId(model.debtorTypeahead);
						if (_v2.$ === 'Nothing') {
							return _Utils_Tuple2(
								model,
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert('Please select a debtor before saving.')));
						} else {
							var debtorId = _v2.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{savingConfiguration: true}),
								A2(
									$author$project$HubTran$Effect$sendCacheableRequestWithError,
									$author$project$Components$ClientDebtorConfigurationManager$ConfigurationSaved,
									$author$project$Api$ClientDebtorConfigurations$create(model.carrierId)(
										$elm$core$Maybe$Just(debtorId))(model.notes)(model.rateConRequired)(model.bolRequired)(model.podRequired)(model.amountMatchRequirement)(model.amountSource)(model.alwaysBlock)(model.laneRateExceptionsMode)(model.factorDeliveryDateCheckDays)(model.invoiceAmountHistoryRuleMode)(model.trustClientSubmittedInvoiceNumber)(model.trustClientSubmittedLoadId)(model.trustClientSubmittedDebtor)(model.trustClientSubmittedAmount)));
						}
					default:
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('No configuration selected. Please try again.')));
				}
			case 'EditConfiguration':
				var config = msg.a;
				var newFormState = config.isClientLevel ? $author$project$Components$ClientDebtorConfigurationManager$EditingClientLevelConfig(config.id) : $author$project$Components$ClientDebtorConfigurationManager$EditingDebtorConfig(config.id);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{alwaysBlock: config.alwaysBlock, amountMatchRequirement: config.amountMatchRequirement, amountSource: config.amountSource, bolRequired: config.bolRequired, factorDeliveryDateCheckDays: config.factorDeliveryDateCheckDays, formState: newFormState, invoiceAmountHistoryRuleMode: config.invoiceAmountHistoryRuleMode, laneRateExceptionsMode: config.laneRateExceptionsMode, notes: config.notes, podRequired: config.podRequired, rateConRequired: config.rateConRequired, trustClientSubmittedAmount: config.trustClientSubmittedAmount, trustClientSubmittedDebtor: config.trustClientSubmittedDebtor, trustClientSubmittedInvoiceNumber: config.trustClientSubmittedInvoiceNumber, trustClientSubmittedLoadId: config.trustClientSubmittedLoadId}),
					$author$project$HubTran$Effect$none);
			case 'StartCreatingClientLevelConfig':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{alwaysBlock: false, amountMatchRequirement: $author$project$Domain$AmountMatchRequirement$Inherit, amountSource: 'invoice', bolRequired: $author$project$Domain$RequirementSetting$Inherit, configMode: $author$project$Components$ClientDebtorConfigurationManager$ClientLevel, debtorTypeahead: $author$project$Components$DebtorTypeahead$init, factorDeliveryDateCheckDays: $author$project$Domain$DeliveryDateCheckSetting$Inherit, formState: $author$project$Components$ClientDebtorConfigurationManager$CreatingClientLevelConfig, invoiceAmountHistoryRuleMode: $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit, laneRateExceptionsMode: $author$project$Domain$LaneRateCheckSetting$Inherit, notes: $elm$core$Maybe$Nothing, podRequired: $author$project$Domain$RequirementSetting$Inherit, rateConRequired: $author$project$Domain$RequirementSetting$Inherit, trustClientSubmittedAmount: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedDebtor: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedInvoiceNumber: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedLoadId: $author$project$Domain$TrustClientSubmittedSetting$Inherit}),
					$author$project$HubTran$Effect$none);
			case 'StartCreatingDebtorConfig':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{alwaysBlock: false, amountMatchRequirement: $author$project$Domain$AmountMatchRequirement$Inherit, amountSource: 'invoice', bolRequired: $author$project$Domain$RequirementSetting$Inherit, configMode: $author$project$Components$ClientDebtorConfigurationManager$DebtorSpecific, debtorTypeahead: $author$project$Components$DebtorTypeahead$init, factorDeliveryDateCheckDays: $author$project$Domain$DeliveryDateCheckSetting$Inherit, formState: $author$project$Components$ClientDebtorConfigurationManager$CreatingDebtorConfig, invoiceAmountHistoryRuleMode: $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit, laneRateExceptionsMode: $author$project$Domain$LaneRateCheckSetting$Inherit, notes: $elm$core$Maybe$Nothing, podRequired: $author$project$Domain$RequirementSetting$Inherit, rateConRequired: $author$project$Domain$RequirementSetting$Inherit, trustClientSubmittedAmount: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedDebtor: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedInvoiceNumber: $author$project$Domain$TrustClientSubmittedSetting$Inherit, trustClientSubmittedLoadId: $author$project$Domain$TrustClientSubmittedSetting$Inherit}),
					$author$project$HubTran$Effect$none);
			case 'CancelEdit':
				return _Utils_Tuple2(
					$author$project$Components$ClientDebtorConfigurationManager$resetFormFields(model),
					$author$project$HubTran$Effect$none);
			case 'UpdateConfiguration':
				var _v3 = model.formState;
				switch (_v3.$) {
					case 'EditingClientLevelConfig':
						var configId = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{updatingConfiguration: true}),
							A2(
								$author$project$HubTran$Effect$sendCacheableRequestWithError,
								$author$project$Components$ClientDebtorConfigurationManager$ConfigurationUpdated,
								$author$project$Api$ClientDebtorConfigurations$update(model.carrierId)(configId)(model.notes)(model.rateConRequired)(model.bolRequired)(model.podRequired)(model.amountMatchRequirement)(model.amountSource)(model.alwaysBlock)(model.laneRateExceptionsMode)(model.factorDeliveryDateCheckDays)(model.invoiceAmountHistoryRuleMode)(model.trustClientSubmittedInvoiceNumber)(model.trustClientSubmittedLoadId)(model.trustClientSubmittedDebtor)(model.trustClientSubmittedAmount)));
					case 'EditingDebtorConfig':
						var configId = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{updatingConfiguration: true}),
							A2(
								$author$project$HubTran$Effect$sendCacheableRequestWithError,
								$author$project$Components$ClientDebtorConfigurationManager$ConfigurationUpdated,
								$author$project$Api$ClientDebtorConfigurations$update(model.carrierId)(configId)(model.notes)(model.rateConRequired)(model.bolRequired)(model.podRequired)(model.amountMatchRequirement)(model.amountSource)(model.alwaysBlock)(model.laneRateExceptionsMode)(model.factorDeliveryDateCheckDays)(model.invoiceAmountHistoryRuleMode)(model.trustClientSubmittedInvoiceNumber)(model.trustClientSubmittedLoadId)(model.trustClientSubmittedDebtor)(model.trustClientSubmittedAmount)));
					default:
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('No configuration selected for update. Please try again.')));
				}
			case 'ConfigurationSaved':
				switch (msg.a.$) {
					case 'Ok':
						var config = msg.a.a;
						var updatedModel = $author$project$Components$ClientDebtorConfigurationManager$resetFormFields(
							_Utils_update(
								model,
								{
									configurations: _Utils_ap(
										model.configurations,
										_List_fromArray(
											[config])),
									savingConfiguration: false
								}));
						return _Utils_Tuple2(updatedModel, $author$project$HubTran$Effect$none);
					case 'Err':
						var errorMsg = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{savingConfiguration: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(errorMsg)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{savingConfiguration: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Failed to save configuration. Please try again.')));
				}
			case 'ConfigurationUpdated':
				switch (msg.a.$) {
					case 'Ok':
						var updatedConfig = msg.a.a;
						return _Utils_Tuple2(
							$author$project$Components$ClientDebtorConfigurationManager$resetFormFields(
								_Utils_update(
									model,
									{
										configurations: A2(
											$elm$core$List$map,
											function (c) {
												return _Utils_eq(c.id, updatedConfig.id) ? updatedConfig : c;
											},
											model.configurations),
										updatingConfiguration: false
									})),
							$author$project$HubTran$Effect$none);
					case 'Err':
						var errorMsg = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{updatingConfiguration: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(errorMsg)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{updatingConfiguration: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Failed to update configuration. Please try again.')));
				}
			case 'ShowDeleteConfirmation':
				var configId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							confirmDeleteConfigId: $elm$core$Maybe$Just(configId)
						}),
					$author$project$HubTran$Effect$none);
			case 'HideDeleteConfirmation':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmDeleteConfigId: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'DeleteConfiguration':
				var configId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmDeleteConfigId: $elm$core$Maybe$Nothing, deletingConfiguration: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$ClientDebtorConfigurationManager$ConfigurationDeleted(configId),
						A2($author$project$Api$ClientDebtorConfigurations$delete, model.carrierId, configId)));
			default:
				switch (msg.b.$) {
					case 'Ok':
						var configId = msg.a;
						return _Utils_Tuple2(
							$author$project$Components$ClientDebtorConfigurationManager$resetFormFields(
								_Utils_update(
									model,
									{
										configurations: A2(
											$elm$core$List$filter,
											function (c) {
												return !_Utils_eq(c.id, configId);
											},
											model.configurations),
										deletingConfiguration: false
									})),
							$author$project$HubTran$Effect$none);
					case 'Err':
						var errorMsg = msg.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{deletingConfiguration: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(errorMsg)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{deletingConfiguration: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Failed to delete configuration. Please try again.')));
				}
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdateImplicitInvoiceOverride = function (a) {
	return {$: 'UpdateImplicitInvoiceOverride', a: a};
};
var $author$project$AuditPb$implicitInvoiceEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'override_enabled', $elm$json$Json$Encode$bool, v.overrideEnabled),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'allow_implicit_invoice', $elm$json$Json$Encode$bool, v.allowImplicitInvoice)
				])));
};
var $author$project$Api$Carriers$implicitInvoiceOverride = F2(
	function (id, overrideType) {
		var overrideEnabled = !_Utils_eq(overrideType, $author$project$Domain$Override$AccountDefault);
		var allowImplicitInvoice = _Utils_eq(overrideType, $author$project$Domain$Override$Enabled);
		var implicitInvoice = A2($author$project$AuditPb$ImplicitInvoice, overrideEnabled, allowImplicitInvoice);
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'implicit_invoice_override',
			$author$project$AuditPb$implicitInvoiceEncoder(implicitInvoice));
	});
var $author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$implicitInvoiceHelpText = function (typeDisplay) {
	var message = 'Don\u0027t require a Carrier Invoice document to approve carrier invoices for this ' + (typeDisplay + '. Expected invoice amount from TMS will be used to determine amount to pay.');
	return A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$body, _List_Nil, message)
			]));
};
var $author$project$Domain$Override$overrideTypeDisplay = function (value) {
	switch (value.$) {
		case 'Enabled':
			return 'Enable';
		case 'Disabled':
			return 'Disable';
		default:
			return 'Account default';
	}
};
var $author$project$Ui$V3$Radio$LayoutDirectionVertical = {$: 'LayoutDirectionVertical'};
var $author$project$Ui$V3$Radio$defaultAttributes = {disabled: false, error: false, layoutDirection: $author$project$Ui$V3$Radio$LayoutDirectionVertical};
var $author$project$Ui$V3$Radio$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'DisabledAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{disabled: value});
				case 'ErrorAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{error: value});
				default:
					var value = a.a;
					return _Utils_update(
						acc,
						{layoutDirection: value});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Radio$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Icon$radio16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$circle,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('v3__icon-radio-outer'),
				$elm$svg$Svg$Attributes$cx('8'),
				$elm$svg$Svg$Attributes$cy('8'),
				$elm$svg$Svg$Attributes$r('7'),
				$elm$svg$Svg$Attributes$strokeWidth('2'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_Nil));
var $author$project$Ui$V3$Icon$radioChecked16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('v3__icon-radio-outer v3__icon-radio-outer--checked'),
						$elm$svg$Svg$Attributes$cx('8'),
						$elm$svg$Svg$Attributes$cy('8'),
						$elm$svg$Svg$Attributes$r('7'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('v3__icon-radio-inner'),
						$elm$svg$Svg$Attributes$cx('8'),
						$elm$svg$Svg$Attributes$cy('8'),
						$elm$svg$Svg$Attributes$r('4')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Radio$viewOption = F4(
	function (_v0, computedAttributes, index, option) {
		var onSelect = _v0.onSelect;
		var selected = _v0.selected;
		var label = _v0.label;
		var name = _v0.name;
		var text = label(option);
		var isSelected = _Utils_eq(
			$elm$core$Maybe$Just(option),
			selected);
		var id = name + ('-' + $elm$core$String$fromInt(index));
		var icon = isSelected ? $author$project$Ui$V3$Icon$radioChecked16 : $author$project$Ui$V3$Icon$radio16;
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$for(id)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
							$author$project$Ui$V3$Stack$crossAxisCenter
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('v3__radio-icon', true),
												_Utils_Tuple2('v3__radio-icon--error', computedAttributes.error),
												_Utils_Tuple2('v3__radio-icon--disabled', computedAttributes.disabled)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('v3__radio-input'),
												$elm$html$Html$Attributes$type_('radio'),
												$elm$html$Html$Attributes$disabled(computedAttributes.disabled),
												$elm$html$Html$Attributes$value(text),
												$elm$html$Html$Attributes$name(name),
												$elm$html$Html$Attributes$selected(isSelected),
												$elm$html$Html$Attributes$id(id),
												A2(
												$elm$html$Html$Events$on,
												'change',
												$elm$json$Json$Decode$succeed(
													onSelect(option)))
											]),
										_List_Nil),
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, icon)
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3__radio-label-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										label(option))
									])))
						]))
				]));
	});
var $author$project$Ui$V3$Radio$view = F2(
	function (requiredAttributes, attributes) {
		var computedAttributes = $author$project$Ui$V3$Radio$computeAttributes(attributes);
		var stackBuilder = function () {
			var _v0 = computedAttributes.layoutDirection;
			if (_v0.$ === 'LayoutDirectionHorizontal') {
				return $author$project$Ui$V3$Stack$viewHorz;
			} else {
				return $author$project$Ui$V3$Stack$viewVert;
			}
		}();
		return A2(
			stackBuilder,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			A2(
				$elm$core$List$indexedMap,
				A2($author$project$Ui$V3$Radio$viewOption, requiredAttributes, computedAttributes),
				requiredAttributes.options));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewAllowImplicitCarrierInvoiceForm = F2(
	function (edit, overrideType) {
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$implicitInvoiceHelpText('carrier'),
						A2(
						$author$project$Ui$V3$Radio$view,
						{
							label: function (option) {
								return $author$project$Domain$Override$overrideTypeDisplay(option);
							},
							name: 'implicit_invoice_override',
							onSelect: function (selected) {
								return edit(selected);
							},
							options: _List_fromArray(
								[$author$project$Domain$Override$AccountDefault, $author$project$Domain$Override$Enabled, $author$project$Domain$Override$Disabled]),
							selected: $elm$core$Maybe$Just(overrideType)
						},
						_List_Nil)
					])),
			true);
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewAllowImplicitCarrierInvoiceSummary = function (overrideType) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$implicitInvoiceHelpText('carrier'),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Current Setting: '),
						A2(
						$author$project$Ui$V3$Typography$smallBody,
						_List_Nil,
						$author$project$Domain$Override$overrideTypeDisplay(overrideType))
					]))
			]));
};
var $author$project$Components$SettingsPage$CarrierLayout$allowImplicitCarrierInvoiceConfigV3Reskin = function (carrierId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeL,
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
			$author$project$Api$Carriers$implicitInvoiceOverride(carrierId)),
		formView: $author$project$Components$SettingsPage$CarrierLayout$viewAllowImplicitCarrierInvoiceForm,
		summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewAllowImplicitCarrierInvoiceSummary,
		title: 'Implicit invoice',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateImplicitInvoiceOverride)
	};
};
var $author$project$Api$Carriers$attemptToAutoProcessDocumentBatches = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'attempt_to_auto_process_document_batches',
			$elm$json$Json$Encode$bool(data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdateAutoGenerateInvoiceNumbers = function (a) {
	return {$: 'UpdateAutoGenerateInvoiceNumbers', a: a};
};
var $author$project$Api$Carriers$autoGenerateFactorInvoiceNumbers = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'auto_generate_factor_invoice_numbers',
			A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewAutoGenerateInvoiceNumbersForm = F4(
	function (set, save, _v0, maybeValue) {
		var isDefault = _Utils_eq(maybeValue, $elm$core$Maybe$Nothing) || _Utils_eq(
			maybeValue,
			$elm$core$Maybe$Just('account_level_setting'));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select when to auto-generate invoice numbers for this carrier. Leave as \u0027Use Account Default\u0027 to inherit the account-level setting.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, set, $elm$core$Maybe$Just))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('account_level_setting'),
											$elm$html$Html$Attributes$selected(isDefault)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Use Account Default')
										])),
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('always'),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												maybeValue,
												$elm$core$Maybe$Just('always')))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Always')
										])),
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('never'),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												maybeValue,
												$elm$core$Maybe$Just('never')))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Never')
										])),
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('when not extracted'),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												maybeValue,
												$elm$core$Maybe$Just('when not extracted')))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('When Not Extracted')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
						]))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewAutoGenerateInvoiceNumbersSummary = F2(
	function (accountSettings, maybeValue) {
		var valueLabel = function (value) {
			switch (value) {
				case 'account_level_setting':
					return 'Use Account Default';
				case 'always':
					return 'Always';
				case 'never':
					return 'Never';
				case 'when not extracted':
					return 'When Not Extracted';
				default:
					return value;
			}
		};
		var accountDefault = valueLabel(accountSettings.autoGenerateFactorInvoiceNumbers);
		if (maybeValue.$ === 'Just') {
			if (maybeValue.a === 'account_level_setting') {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Using account default: ' + accountDefault)
						]));
			} else {
				var value = maybeValue.a;
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							valueLabel(value))
						]));
			}
		} else {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Using account default: ' + accountDefault)
					]));
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$autoGenerateInvoiceNumbersConfig = F2(
	function (accountSettings, carrierId) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeL,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
				$author$project$Api$Carriers$autoGenerateFactorInvoiceNumbers(carrierId)),
			formView: $author$project$Components$SettingsPage$CarrierLayout$viewAutoGenerateInvoiceNumbersForm,
			summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewAutoGenerateInvoiceNumbersSummary(accountSettings),
			title: 'Auto-Generate Invoice Numbers',
			toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateAutoGenerateInvoiceNumbers)
		};
	});
var $author$project$Api$Carriers$factorSendCustomerInvoiceToCadence = F2(
	function (id, data) {
		var json = function () {
			if (data.$ === 'Nothing') {
				return $elm$json$Json$Encode$null;
			} else {
				var x = data.a;
				return $elm$json$Json$Encode$bool(x);
			}
		}();
		return A3($author$project$Api$Carriers$updateField, id, 'factor_send_customer_invoice_to_cadence', json);
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdateInvoiceNumberStrategy = function (a) {
	return {$: 'UpdateInvoiceNumberStrategy', a: a};
};
var $author$project$Api$Carriers$factorInvoiceNumberStrategy = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'factor_invoice_number_strategy',
			A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewInvoiceNumberStrategyForm = F4(
	function (set, save, _v0, maybeStrategy) {
		var isDefault = _Utils_eq(maybeStrategy, $elm$core$Maybe$Nothing) || _Utils_eq(
			maybeStrategy,
			$elm$core$Maybe$Just('account_level_strategy'));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select the invoice number strategy for this carrier. Leave as \u0027Use Account Default\u0027 to inherit the account-level setting.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									function (val) {
										return (val === '') ? set($elm$core$Maybe$Nothing) : set(
											$elm$core$Maybe$Just(val));
									})
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(''),
											$elm$html$Html$Attributes$selected(isDefault)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Use Account Default')
										])),
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('leave_blank'),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												maybeStrategy,
												$elm$core$Maybe$Just('leave_blank')))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Leave Blank')
										])),
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('load_id'),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												maybeStrategy,
												$elm$core$Maybe$Just('load_id')))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Load ID')
										])),
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('single_sequence'),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												maybeStrategy,
												$elm$core$Maybe$Just('single_sequence')))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Single Sequence')
										])),
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('sequence_per_client'),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												maybeStrategy,
												$elm$core$Maybe$Just('sequence_per_client')))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sequence Per Client')
										])),
									A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value('sequence_per_client_with_id'),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												maybeStrategy,
												$elm$core$Maybe$Just('sequence_per_client_with_id')))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sequence Per Client with ID')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
						]))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewInvoiceNumberStrategySummary = F2(
	function (accountSettings, maybeStrategy) {
		var strategyLabel = function (strategy) {
			switch (strategy) {
				case 'account_level_strategy':
					return 'Use Account Default';
				case 'load_id':
					return 'Load ID';
				case 'single_sequence':
					return 'Single Sequence';
				case 'sequence_per_client':
					return 'Sequence Per Client';
				case 'sequence_per_client_with_id':
					return 'Sequence Per Client with ID';
				case 'leave_blank':
					return 'Leave Blank';
				default:
					return strategy;
			}
		};
		var accountDefault = strategyLabel(accountSettings.autoGenerateFactorInvoiceNumberStrategy);
		if (maybeStrategy.$ === 'Just') {
			if (maybeStrategy.a === 'account_level_strategy') {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Using account default: ' + accountDefault)
						]));
			} else {
				var strategy = maybeStrategy.a;
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							strategyLabel(strategy))
						]));
			}
		} else {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Using account default: ' + accountDefault)
					]));
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$invoiceNumberStrategyConfig = F2(
	function (accountSettings, carrierId) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeL,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
				$author$project$Api$Carriers$factorInvoiceNumberStrategy(carrierId)),
			formView: $author$project$Components$SettingsPage$CarrierLayout$viewInvoiceNumberStrategyForm,
			summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewInvoiceNumberStrategySummary(accountSettings),
			title: 'Invoice Number Strategy',
			toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateInvoiceNumberStrategy)
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdateToleranceOverride = function (a) {
	return {$: 'UpdateToleranceOverride', a: a};
};
var $author$project$Components$SettingsPage$Shared$Tolerance$toggleEnableOverride = F3(
	function (model, set, overrideEnabled) {
		return set(
			_Utils_update(
				model,
				{overrideEnabled: overrideEnabled}));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$enableOverride = F2(
	function (set, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id('accountdefault'),
							$elm$html$Html$Attributes$checked(!model.overrideEnabled),
							$elm$html$Html$Events$onClick(
							A3($author$project$Components$SettingsPage$Shared$Tolerance$toggleEnableOverride, model, set, false))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('accountdefault')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Account default')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id('overrideenabled'),
							$elm$html$Html$Attributes$checked(model.overrideEnabled),
							$elm$html$Html$Events$onClick(
							A3($author$project$Components$SettingsPage$Shared$Tolerance$toggleEnableOverride, model, set, true))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('overrideenabled')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(model.overrideTypeLabel)
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$ensureValid = function (model) {
	return A2(
		$elm$core$List$all,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		_List_fromArray(
			[model.amountAbove, model.amountBelow]));
};
var $author$project$Components$SettingsPage$Shared$Tolerance$numberError = function (isInvalid) {
	return isInvalid ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hubtran-feedback__feedback')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Must be a number')
			])) : $elm$html$Html$text('');
};
var $author$project$Components$SettingsPage$Shared$Tolerance$setAmountAbove = F3(
	function (model, set, amountAbove) {
		return set(
			_Utils_update(
				model,
				{amountAbove: amountAbove}));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$ltlToleranceAbove = F3(
	function (set, model, labelPrefix) {
		var isInvalid = $elm$core$String$isEmpty(model.amountAbove);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('ltltoleranceabove')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Less-than-truckload invoice amount tolerance above')
						])),
					$author$project$Components$SettingsPage$Shared$Tolerance$numberError(isInvalid),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hubtran-box__inline')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hubtran-input__prefix')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labelPrefix)
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('ltltoleranceabove'),
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$value(model.amountAbove),
									$elm$html$Html$Events$onInput(
									A2($author$project$Components$SettingsPage$Shared$Tolerance$setAmountAbove, model, set)),
									$elm$html$Html$Attributes$disabled(!model.overrideEnabled)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$setAmountBelow = F3(
	function (value, set, amountBelow) {
		return set(
			_Utils_update(
				value,
				{amountBelow: amountBelow}));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$ltlToleranceBelow = F3(
	function (set, model, labelPrefix) {
		var isInvalid = $elm$core$String$isEmpty(model.amountBelow);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('ltltolerancebelow')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Less-than-truckload invoice amount tolerance below')
						])),
					$author$project$Components$SettingsPage$Shared$Tolerance$numberError(isInvalid),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hubtran-box__inline')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hubtran-input__prefix')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labelPrefix)
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('ltltoleranceabove'),
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$value(model.amountBelow),
									$elm$html$Html$Events$onInput(
									A2($author$project$Components$SettingsPage$Shared$Tolerance$setAmountBelow, model, set)),
									$elm$html$Html$Attributes$disabled(!model.overrideEnabled)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$toleranceUnitDisplay = function (unit) {
	if (unit.$ === 'ToleranceUnitDollars') {
		return 'Dollars';
	} else {
		return 'Percentage';
	}
};
var $author$project$Components$SettingsPage$Shared$Tolerance$ltlToleranceUnitOption = F2(
	function (currentlySelected, unit) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$AuditPb$toleranceUnitToString(unit)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(currentlySelected, unit))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Components$SettingsPage$Shared$Tolerance$toleranceUnitDisplay(unit))
				]));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$setUnit = F3(
	function (value, set, unit) {
		return set(
			_Utils_update(
				value,
				{
					unit: A2(
						$elm$core$Maybe$withDefault,
						$author$project$AuditPb$toleranceUnitDefault,
						$author$project$AuditPb$toleranceUnitFromString(unit))
				}));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$ltlToleranceUnit = F2(
	function (set, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('ltltoleranceunit')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Less-than-truckload invoice amount tolerance unit')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('ltltoleranceunit'),
							$elm$html$Html$Events$onInput(
							A2($author$project$Components$SettingsPage$Shared$Tolerance$setUnit, model, set)),
							$elm$html$Html$Attributes$disabled(!model.overrideEnabled)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$SettingsPage$Shared$Tolerance$ltlToleranceUnitOption(model.unit),
						$author$project$AuditPb$allToleranceUnit))
				]));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$saveButton = F2(
	function (saveAction, isValid) {
		return isValid ? A3($author$project$Components$Shared$Button$confirm, 'Save LTL invoice amount tolerance', saveAction, _List_Nil) : A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil);
	});
var $author$project$Domain$Tolerance$toleranceUnitToSymbol = function (unit) {
	if (unit.$ === 'ToleranceUnitDollars') {
		return '$';
	} else {
		return '%';
	}
};
var $author$project$Components$SettingsPage$Shared$Tolerance$formView = F4(
	function (set, save, _v0, model) {
		var labelPrefix = $author$project$Domain$Tolerance$toleranceUnitToSymbol(model.unit);
		var isValid = $author$project$Components$SettingsPage$Shared$Tolerance$ensureValid(model);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Shared$Tolerance$enableOverride, set, model),
					A2($author$project$Components$SettingsPage$Shared$Tolerance$ltlToleranceUnit, set, model),
					A3($author$project$Components$SettingsPage$Shared$Tolerance$ltlToleranceAbove, set, model, labelPrefix),
					A3($author$project$Components$SettingsPage$Shared$Tolerance$ltlToleranceBelow, set, model, labelPrefix),
					A2($author$project$Components$SettingsPage$Shared$Tolerance$saveButton, save, isValid)
				]));
	});
var $author$project$AuditPb$Tolerance = F4(
	function (overrideEnabled, amountAbove, amountBelow, unit) {
		return {amountAbove: amountAbove, amountBelow: amountBelow, overrideEnabled: overrideEnabled, unit: unit};
	});
var $author$project$AuditPb$toleranceUnitEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$toleranceUnitToString);
var $author$project$AuditPb$toleranceEncoder = function (v) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'override_enabled', $elm$json$Json$Encode$bool, v.overrideEnabled),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'amount_above', $elm$json$Json$Encode$string, v.amountAbove),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'amount_below', $elm$json$Json$Encode$string, v.amountBelow),
					A3($author$project$AuditPb$requiredFieldEncoderWithoutDefault, 'unit', $author$project$AuditPb$toleranceUnitEncoder, v.unit)
				])));
};
var $author$project$Api$Carriers$invoiceTolerance = F2(
	function (id, data) {
		var tolerance = A4($author$project$AuditPb$Tolerance, data.overrideEnabled, data.amountAbove, data.amountBelow, data.unit);
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'carrier_tolerance_override',
			$author$project$AuditPb$toleranceEncoder(tolerance));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$summaryView = function (value) {
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[$author$project$Ui$V3$Typography$smallBodyClass]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create exception if invoice amount outside indicated tolerance')
					])),
				$elm$html$Html$text(
				value.overrideEnabled ? value.overrideTypeLabel : 'Account default')
			]));
};
var $author$project$Components$SettingsPage$CarrierLayout$invoiceToleranceConfig = function (carrierId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Carriers$invoiceTolerance(carrierId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$Tolerance$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$Tolerance$summaryView,
		title: 'Invoice Tolerance',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateToleranceOverride)
	};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateLabels = function (a) {
	return {$: 'UpdateLabels', a: a};
};
var $author$project$Api$Carriers$labels = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'labels',
			A2(
				$elm$json$Json$Encode$list,
				$elm$json$Json$Encode$string,
				$elm$core$Set$toList(data)));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewCheckbox = F3(
	function (labelText, onCheck_, checked_) {
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(checked_),
							$elm$html$Html$Events$onCheck(onCheck_)
						]),
					_List_Nil),
					$elm$html$Html$text($author$project$Helpers$String$nbsp),
					$elm$html$Html$text(labelText)
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewLabelToggle = F3(
	function (edit, labels, candidate) {
		return A3(
			$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
			candidate,
			function (checked) {
				return checked ? edit(
					A2($elm$core$Set$insert, candidate, labels)) : edit(
					A2($elm$core$Set$remove, candidate, labels));
			},
			A2($elm$core$Set$member, candidate, labels));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewLabelsForm = F5(
	function (settings, edit, save, _v0, labels) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Components$SettingsPage$CarrierLayout$viewLabelToggle, edit, labels),
						$author$project$Domain$AccountSettings$labelNames(settings.possibleCarrierLabels))),
					A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewLabelsSummary = function (labels) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carrier-labels')
			]),
		$elm$core$Set$isEmpty(labels) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$em,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('None selected')
					]))
			]) : A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('carrier-labels__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(x)
						]));
			},
			$elm$core$Set$toList(labels)));
};
var $author$project$Components$SettingsPage$CarrierLayout$labelsConfig = F2(
	function (carrierId, settings) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeL,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
				$author$project$Api$Carriers$labels(carrierId)),
			formView: $author$project$Components$SettingsPage$CarrierLayout$viewLabelsForm(settings),
			summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewLabelsSummary,
			title: 'TriumphPay Audit Labels',
			toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateLabels)
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdateManualReviewPercentage = function (a) {
	return {$: 'UpdateManualReviewPercentage', a: a};
};
var $author$project$Api$Carriers$manualReviewPercentage = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'manual_review_percentage',
			A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$validatingSend = F2(
	function (apiRequest, result) {
		if (result.$ === 'Err') {
			return $author$project$HubTran$Effect$none;
		} else {
			var value = result.a;
			return A2(
				$author$project$HubTran$Effect$sendCacheableRequestWithError,
				$elm$core$Basics$identity,
				apiRequest(value));
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$ensureNumeric = F2(
	function (greaterThan, value) {
		if ($elm$core$String$isEmpty(value)) {
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		} else {
			var _v0 = $elm$core$String$toInt(value);
			if (_v0.$ === 'Just') {
				var result = _v0.a;
				return (_Utils_cmp(result, greaterThan) < 1) ? $elm$core$Result$Err(
					'Must be greater than ' + ($elm$core$String$fromInt(greaterThan) + '.')) : $elm$core$Result$Ok(
					$elm$core$Maybe$Just(result));
			} else {
				return $elm$core$Result$Err('Must be a number.');
			}
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewManualReviewPercentageForm = F4(
	function (set, save, _v0, result) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select percentage of invoices that need to go through manual review.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row collapse')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column begin')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-4 column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('number'),
													$elm$html$Html$Attributes$value(
													function () {
														if ((result.$ === 'Ok') && (result.a.$ === 'Just')) {
															var i = result.a.a;
															return $elm$core$String$fromInt(i);
														} else {
															return '';
														}
													}()),
													$elm$html$Html$Events$onInput(
													A2(
														$elm$core$Basics$composeL,
														set,
														$author$project$Components$SettingsPage$CarrierLayout$ensureNumeric(-1))),
													$elm$html$Html$Attributes$min('0'),
													$elm$html$Html$Attributes$max('100')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column end')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('postfix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('%')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Helpers$Result$either,
							$elm$core$Basics$always(
								A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil)),
							$elm$core$Basics$always(
								A3($author$project$Components$Shared$Button$confirm, 'Save Amount', save, _List_Nil)),
							result)
						]))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewManualReviewPercentageSummary = F2(
	function (_v0, maybeManualReviewPercentage) {
		var ngaRules = _v0.ngaRules;
		var manualReviewPercentage = _v0.manualReviewPercentage;
		var fallbackMessage = function () {
			if (ngaRules.$ === 'Just') {
				return 'Using carrier credit rating rules.';
			} else {
				return 'Using account default of ' + ($elm$core$String$fromInt(manualReviewPercentage) + '%.');
			}
		}();
		var noPercentageSet = A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No manual review percentage set. ' + fallbackMessage)
				]));
		if (maybeManualReviewPercentage.$ === 'Ok') {
			if (maybeManualReviewPercentage.a.$ === 'Just') {
				var manualReviewPercentageInt = maybeManualReviewPercentage.a.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(manualReviewPercentageInt)),
									$elm$html$Html$text('% of all invoices will be sent for manual review. '),
									$elm$html$Html$text('This setting can be overwritten for every client.')
								]))
						]));
			} else {
				var _v2 = maybeManualReviewPercentage.a;
				return noPercentageSet;
			}
		} else {
			return noPercentageSet;
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$manualReviewPercentageConfig = F2(
	function (accountSettings, carrierId) {
		return {
			apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
				$author$project$Api$Carriers$manualReviewPercentage(carrierId)),
			formView: $author$project$Components$SettingsPage$CarrierLayout$viewManualReviewPercentageForm,
			summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewManualReviewPercentageSummary(accountSettings),
			title: 'Manual Review Percentage',
			toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateManualReviewPercentage)
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdatePaymentAddress = function (a) {
	return {$: 'UpdatePaymentAddress', a: a};
};
var $author$project$Api$Carriers$maybeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$json$Json$Encode$string),
	$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
var $author$project$Api$Carriers$paymentAddress = F2(
	function (id, data) {
		var url = $author$project$Api$Carriers$memberUrl(id) + '/payment_addresses';
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_strategy',
					$elm$json$Json$Encode$string('direct')),
					_Utils_Tuple2(
					'payment_address',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(data.name)),
								_Utils_Tuple2(
								'address_line_1',
								$author$project$Api$Carriers$maybeString(data.addressLine1)),
								_Utils_Tuple2(
								'address_line_2',
								$author$project$Api$Carriers$maybeString(data.addressLine2)),
								_Utils_Tuple2(
								'city',
								$author$project$Api$Carriers$maybeString(data.city)),
								_Utils_Tuple2(
								'state',
								$author$project$Api$Carriers$maybeString(data.state)),
								_Utils_Tuple2(
								'postal_code',
								$author$project$Api$Carriers$maybeString(data.postalCode)),
								_Utils_Tuple2(
								'country',
								$author$project$Api$Carriers$maybeString(data.country))
							])))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Components$SettingsPage$CarrierLayout$maybeString = $elm$core$Maybe$withDefault('');
var $author$project$Components$SettingsPage$CarrierLayout$isBlank = A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$maybeString, $elm$core$String$isEmpty);
var $author$project$Domain$Address$maybeJoin = F3(
	function (separator, first, second) {
		var _v0 = _Utils_Tuple2(first, second);
		if (_v0.a.$ === 'Just') {
			if (_v0.b.$ === 'Just') {
				var x = _v0.a.a;
				var y = _v0.b.a;
				return $elm$core$Maybe$Just(
					_Utils_ap(
						x,
						_Utils_ap(separator, y)));
			} else {
				var _v1 = _v0.b;
				return first;
			}
		} else {
			if (_v0.b.$ === 'Just') {
				var _v2 = _v0.a;
				return second;
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Domain$Address$lastLine = function (address) {
	return A3(
		$author$project$Domain$Address$maybeJoin,
		', ',
		address.city,
		A3($author$project$Domain$Address$maybeJoin, ' ', address.state, address.postalCode));
};
var $author$project$Components$SettingsPage$Carriers$AddressView$view = function (address) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(x)
						]));
			},
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(address.name),
						address.addressLine1,
						address.addressLine2,
						$author$project$Domain$Address$lastLine(address),
						address.country
					]))));
};
var $author$project$Components$SettingsPage$CarrierLayout$viewAddress = function (address) {
	return A2(
		$elm$core$List$all,
		$author$project$Components$SettingsPage$CarrierLayout$isBlank,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(address.name),
				address.addressLine1,
				address.city,
				address.state
			])) ? $elm$html$Html$text('No address specified') : $author$project$Components$SettingsPage$Carriers$AddressView$view(address);
};
var $author$project$Components$SettingsPage$CarrierLayout$viewAddressInput = F4(
	function (columnWidth, labelText, onInput_, content) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'column small-' + $elm$core$String$fromInt(columnWidth))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(labelText),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Events$onInput(onInput_),
							$elm$html$Html$Attributes$value(
							A2($elm$core$Maybe$withDefault, '', content))
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewPaymentAddressForm = F4(
	function (edit, save, _v0, address) {
		var name = $elm$core$Maybe$Just(address.name);
		var missingRequired = A2(
			$elm$core$List$any,
			$author$project$Components$SettingsPage$CarrierLayout$isBlank,
			_List_fromArray(
				[name, address.addressLine1, address.city, address.state, address.postalCode]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Components$SettingsPage$CarrierLayout$viewAddressInput,
					10,
					'Name',
					function (x) {
						return edit(
							_Utils_update(
								address,
								{name: x}));
					},
					name),
					A4(
					$author$project$Components$SettingsPage$CarrierLayout$viewAddressInput,
					5,
					'Line 1',
					function (x) {
						return edit(
							_Utils_update(
								address,
								{
									addressLine1: $elm$core$Maybe$Just(x)
								}));
					},
					address.addressLine1),
					A4(
					$author$project$Components$SettingsPage$CarrierLayout$viewAddressInput,
					5,
					'Line 2 (optional)',
					function (x) {
						return edit(
							_Utils_update(
								address,
								{
									addressLine2: $elm$core$Maybe$Just(x)
								}));
					},
					address.addressLine2),
					A4(
					$author$project$Components$SettingsPage$CarrierLayout$viewAddressInput,
					5,
					'City',
					function (x) {
						return edit(
							_Utils_update(
								address,
								{
									city: $elm$core$Maybe$Just(x)
								}));
					},
					address.city),
					A4(
					$author$project$Components$SettingsPage$CarrierLayout$viewAddressInput,
					2,
					'State',
					function (x) {
						return edit(
							_Utils_update(
								address,
								{
									state: $elm$core$Maybe$Just(x)
								}));
					},
					address.state),
					A4(
					$author$project$Components$SettingsPage$CarrierLayout$viewAddressInput,
					3,
					'Postal Code',
					function (x) {
						return edit(
							_Utils_update(
								address,
								{
									postalCode: $elm$core$Maybe$Just(x)
								}));
					},
					address.postalCode),
					A4(
					$author$project$Components$SettingsPage$CarrierLayout$viewAddressInput,
					10,
					'Country (optional)',
					function (x) {
						return edit(
							_Utils_update(
								address,
								{
									country: $elm$core$Maybe$Just(x)
								}));
					},
					address.country),
					missingRequired ? A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil) : A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$paymentAddressConfig = function (carrierId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeL,
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
			$author$project$Api$Carriers$paymentAddress(carrierId)),
		formView: $author$project$Components$SettingsPage$CarrierLayout$viewPaymentAddressForm,
		summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewAddress,
		title: 'Payment Address',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdatePaymentAddress)
	};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdatePaymentTerms = function (a) {
	return {$: 'UpdatePaymentTerms', a: a};
};
var $author$project$Api$Carriers$daysToPay = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'days_to_pay',
			$elm$json$Json$Encode$int(data));
	});
var $author$project$Components$Shared$Grid$endColumn = F2(
	function (_int, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'small-' + ($elm$core$String$fromInt(_int) + ' column end'))
				]),
			children);
	});
var $author$project$Components$SettingsPage$Shared$PaymentTerms$ensurePositiveInteger = function (str) {
	var _v0 = $elm$core$String$toInt(str);
	if (_v0.$ === 'Nothing') {
		return $elm$core$Result$Err(str);
	} else {
		var i = _v0.a;
		return $elm$core$Result$Ok(
			$elm$core$Basics$abs(i));
	}
};
var $author$project$Components$SettingsPage$Shared$PaymentTerms$getString = function (model) {
	if (model.$ === 'Err') {
		var x = model.a;
		return x;
	} else {
		var i = model.a;
		return $elm$core$String$fromInt(i);
	}
};
var $author$project$Components$SettingsPage$Shared$PaymentTerms$formView = F4(
	function (set, save, _v0, model) {
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			10,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('payment-terms'),
							function () {
							if (model.$ === 'Ok') {
								return $elm$html$Html$Attributes$class('');
							} else {
								return $elm$html$Html$Attributes$class('error');
							}
						}()
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment Terms')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row collapse')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Grid$column,
							2,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('payment-terms'),
											$elm$html$Html$Attributes$type_('number'),
											$elm$html$Html$Attributes$value(
											$author$project$Components$SettingsPage$Shared$PaymentTerms$getString(model)),
											$elm$html$Html$Events$onInput(
											A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$Shared$PaymentTerms$ensurePositiveInteger))
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Components$Shared$Grid$endColumn,
							1,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('postfix')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('days')
										]))
								]))
						])),
					function () {
					if (model.$ === 'Err') {
						return A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil);
					} else {
						return A3($author$project$Components$Shared$Button$confirm, 'Save Payment Terms', save, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Components$SettingsPage$Shared$PaymentTerms$summaryView = function (model) {
	return $elm$html$Html$text(
		'Net ' + $author$project$Components$SettingsPage$Shared$PaymentTerms$getString(model));
};
var $author$project$Components$SettingsPage$CarrierLayout$paymentTermsConfig = function (carrierId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
			$author$project$Api$Carriers$daysToPay(carrierId)),
		formView: $author$project$Components$SettingsPage$Shared$PaymentTerms$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$PaymentTerms$summaryView,
		title: 'Payment Terms',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdatePaymentTerms)
	};
};
var $author$project$Api$Carriers$podRequired = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'pod_required',
			$elm$json$Json$Encode$bool(data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdateQuickpayDiscount = function (a) {
	return {$: 'UpdateQuickpayDiscount', a: a};
};
var $author$project$Api$Carriers$quickpayDiscount = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'quickpayDiscount',
			$elm$json$Json$Encode$float(data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$checkBounds = F4(
	function (toString, min, max, value) {
		return ((_Utils_cmp(value, min) > -1) && (_Utils_cmp(value, max) < 1)) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			toString(value));
	});
var $author$project$Components$SettingsPage$CarrierLayout$percentInput = function (inputAttrs) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row collapse')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-2 column')
					]),
				_List_fromArray(
					[
						A2($elm$html$Html$input, inputAttrs, _List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-1 column end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('postfix')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('%')
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$CarrierLayout$viewQuickpayDiscountForm = F4(
	function (edit, save, _v0, quickpayDiscount) {
		var newToFloat = function (string) {
			return A2(
				$elm$core$Result$fromMaybe,
				'Could not convert to float.',
				$elm$core$String$toFloat(string));
		};
		var attrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('number'),
				$elm$html$Html$Events$onInput(
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						edit,
						$elm$core$Result$andThen(
							A3($author$project$Components$SettingsPage$CarrierLayout$checkBounds, $elm$core$String$fromFloat, 0, 100))),
					newToFloat))
			]);
		if (quickpayDiscount.$ === 'Ok') {
			var clean = quickpayDiscount.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$CarrierLayout$percentInput(
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$value(
								$elm$core$String$fromFloat(clean)),
							attrs)),
						A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
					]));
		} else {
			var raw = quickpayDiscount.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$CarrierLayout$percentInput(
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('error'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(raw),
								attrs))),
						A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil)
					]));
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewQuickpayDiscountSummary = function (quickpayDiscount) {
	return $elm$html$Html$text(
		function () {
			if (quickpayDiscount.$ === 'Ok') {
				var i = quickpayDiscount.a;
				return $elm$core$String$fromFloat(i) + '%';
			} else {
				return 'No quickpay discount provided';
			}
		}());
};
var $author$project$Components$SettingsPage$CarrierLayout$quickpayDiscountConfig = function (carrierId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
			$author$project$Api$Carriers$quickpayDiscount(carrierId)),
		formView: $author$project$Components$SettingsPage$CarrierLayout$viewQuickpayDiscountForm,
		summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewQuickpayDiscountSummary,
		title: 'QuickPay Discount',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateQuickpayDiscount)
	};
};
var $author$project$Api$Carriers$rateConfirmationRequired = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'rate_confirmation_required',
			$elm$json$Json$Encode$bool(data));
	});
var $author$project$Api$Carriers$receivablesInvoiceCustomer = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'receivables_invoice_customer',
			$elm$json$Json$Encode$bool(data));
	});
var $author$project$Api$Carriers$scrapingEnabled = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'scraping_enabled',
			$elm$json$Json$Encode$bool(data));
	});
var $author$project$Api$Carriers$skipAutoStamp = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'skip_auto_stamp',
			$elm$json$Json$Encode$bool(data));
	});
var $author$project$Api$Carriers$transportationClient = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'transportation_client',
			$elm$json$Json$Encode$bool(data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$tupleToFeature = function (_v0) {
	var dropdown = _v0.dropdown;
	var feature = _v0.feature;
	return _Utils_update(
		feature,
		{
			overrideForClient: function () {
				var _v1 = $author$project$Ui$V3$CustomSelect$getFirstSelectedItem(dropdown);
				if (_v1.$ === 'Just') {
					var item = _v1.a;
					return _Utils_eq(
						item.id,
						$author$project$Domain$Feature$overrideToId($author$project$Domain$Feature$AlwaysOn)) ? $author$project$Domain$Feature$AlwaysOn : (_Utils_eq(
						item.id,
						$author$project$Domain$Feature$overrideToId($author$project$Domain$Feature$AlwaysOff)) ? $author$project$Domain$Feature$AlwaysOff : $author$project$Domain$Feature$Default);
				} else {
					return $author$project$Domain$Feature$Default;
				}
			}()
		});
};
var $author$project$Domain$Feature$encodeFeatureForFactorClient = function (feature) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(feature.id)),
				_Utils_Tuple2(
				'override',
				function () {
					var _v0 = feature.overrideForClient;
					switch (_v0.$) {
						case 'Default':
							return $elm$json$Json$Encode$null;
						case 'AlwaysOn':
							return $elm$json$Json$Encode$bool(true);
						default:
							return $elm$json$Json$Encode$bool(false);
					}
				}())
			]));
};
var $author$project$Api$Carriers$updateFeatures = F2(
	function (id, features) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'features',
			A2($elm$json$Json$Encode$list, $author$project$Domain$Feature$encodeFeatureForFactorClient, features));
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdateVerifyPercentile = function (a) {
	return {$: 'UpdateVerifyPercentile', a: a};
};
var $author$project$Api$Carriers$verifyPercentile = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'verify_percentile',
			$elm$json$Json$Encode$int(data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$verifyPercentileInput = F3(
	function (save, _v0, attrs) {
		var valid = _v0.valid;
		var inputValue = _v0.inputValue;
		var button = valid ? A3($author$project$Components$Shared$Button$confirm, 'Save Verifications Percentile', save, _List_Nil) : A2($author$project$Components$Shared$Button$disabled, 'Value must be between 0 and 99', _List_Nil);
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			10,
			_List_fromArray(
				[
					A2(
					$author$project$Components$Shared$Grid$autoRow,
					10,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row collapse')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Grid$column,
									2,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$id('verify-percentile'),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$value(inputValue),
													attrs)),
											_List_Nil)
										])),
									A2(
									$author$project$Components$Shared$Grid$endColumn,
									1,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('postfix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('%')
												]))
										]))
								]))
						])),
					button
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewVerifyPercentileForm = F4(
	function (edit, save, _v0, verifyPercentile) {
		var newInputToIntResult = function (string) {
			return A2(
				$elm$core$Result$fromMaybe,
				'Could not convert to int.',
				$elm$core$String$toInt(string));
		};
		var attrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('number'),
				$elm$html$Html$Events$onInput(
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						edit,
						$elm$core$Result$andThen(
							A3($author$project$Components$SettingsPage$CarrierLayout$checkBounds, $elm$core$String$fromInt, 0, 99))),
					newInputToIntResult))
			]);
		if (verifyPercentile.$ === 'Ok') {
			var cleanInt = verifyPercentile.a;
			return A3(
				$author$project$Components$SettingsPage$CarrierLayout$verifyPercentileInput,
				save,
				{
					inputValue: $elm$core$String$fromInt(cleanInt),
					valid: true
				},
				attrs);
		} else {
			var rawString = verifyPercentile.a;
			return A3(
				$author$project$Components$SettingsPage$CarrierLayout$verifyPercentileInput,
				save,
				{inputValue: rawString, valid: false},
				attrs);
		}
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewVerifyPercentileSummary = function (verifyPercentile) {
	if (verifyPercentile.$ === 'Ok') {
		var percentile = verifyPercentile.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(percentile) + '%')
				]));
	} else {
		return $elm$html$Html$text('Error retrieving verifications percentile. Please contact support.');
	}
};
var $author$project$Components$SettingsPage$CarrierLayout$verifyPercentileConfig = function (carrierId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
			$author$project$Api$Carriers$verifyPercentile(carrierId)),
		formView: $author$project$Components$SettingsPage$CarrierLayout$viewVerifyPercentileForm,
		summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewVerifyPercentileSummary,
		title: 'Verifications Percentile',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateVerifyPercentile)
	};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateWarnIfAmountOver = function (a) {
	return {$: 'UpdateWarnIfAmountOver', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$viewWarnIfAmountOverForm = F4(
	function (set, save, _v0, result) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Require verification for invoice amounts over this value. Please leave blank to be disabled.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row collapse')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column begin')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('prefix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('$')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-4 column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('number'),
													$elm$html$Html$Attributes$value(
													function () {
														if ((result.$ === 'Ok') && (result.a.$ === 'Just')) {
															var i = result.a.a;
															return $elm$core$String$fromInt(i);
														} else {
															return '';
														}
													}()),
													$elm$html$Html$Events$onInput(
													A2(
														$elm$core$Basics$composeL,
														set,
														$author$project$Components$SettingsPage$CarrierLayout$ensureNumeric(0))),
													$elm$html$Html$Attributes$min('0')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column end')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('postfix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('.00')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Helpers$Result$either,
							$elm$core$Basics$always(
								A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil)),
							$elm$core$Basics$always(
								A3($author$project$Components$Shared$Button$confirm, 'Save Amount', save, _List_Nil)),
							result)
						]))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewWarnIfAmountOverSummary = function (maybeWarnIfAmountOver) {
	var noAmountSet = A2(
		$elm$html$Html$pre,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('No invoice amount is set to require verification.')
			]));
	if ((maybeWarnIfAmountOver.$ === 'Ok') && (maybeWarnIfAmountOver.a.$ === 'Just')) {
		var warnOverAmount = maybeWarnIfAmountOver.a.a;
		var warnOverString = $elm$core$String$fromInt(warnOverAmount);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoices over $'),
							$elm$html$Html$text(warnOverString),
							$elm$html$Html$text(' will create an exception of:')
						])),
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice amount of $XXXX exceeds $'),
							$elm$html$Html$text(warnOverString),
							$elm$html$Html$text(' and requires verification.')
						]))
				]));
	} else {
		return noAmountSet;
	}
};
var $author$project$Api$Carriers$warnIfAmountOver = F2(
	function (id, data) {
		return A3(
			$author$project$Api$Carriers$updateField,
			id,
			'warn_if_amount_over',
			A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$warnIfAmountOverConfig = function (carrierId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
			$author$project$Api$Carriers$warnIfAmountOver(carrierId)),
		formView: $author$project$Components$SettingsPage$CarrierLayout$viewWarnIfAmountOverForm,
		summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewWarnIfAmountOverSummary,
		title: 'Warn Over Invoice Amount',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateWarnIfAmountOver)
	};
};
var $author$project$Components$SettingsPage$CarrierLayout$updateForm = F4(
	function (carrierId, data, msg, form) {
		switch (msg.$) {
			case 'UpdatePaymentTerms':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{paymentTerms: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CarrierLayout$paymentTermsConfig(carrierId),
						msg_,
						form.paymentTerms));
			case 'UpdateWarnIfAmountOver':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{warnIfAmountOver: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CarrierLayout$warnIfAmountOverConfig(carrierId),
						msg_,
						form.warnIfAmountOver));
			case 'UpdateQuickpayDiscount':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{quickpayDiscount: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CarrierLayout$quickpayDiscountConfig(carrierId),
						msg_,
						form.quickpayDiscount));
			case 'UpdateVerifyPercentile':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{verifyPercentile: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CarrierLayout$verifyPercentileConfig(carrierId),
						msg_,
						form.verifyPercentile));
			case 'UpdateManualReviewPercentage':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{manualReviewPercentage: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$CarrierLayout$manualReviewPercentageConfig, data.accountSettings, carrierId),
						msg_,
						form.manualReviewPercentage));
			case 'UpdateAttemptToAutoProcess':
				var value = msg.a;
				return _Utils_Tuple2(
					form,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('auto-processing'),
						A2($author$project$Api$Carriers$attemptToAutoProcessDocumentBatches, carrierId, value)));
			case 'UpdateRateConfirmationRequired':
				var value = msg.a;
				return _Utils_Tuple2(
					form,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('rules'),
						A2($author$project$Api$Carriers$rateConfirmationRequired, carrierId, value)));
			case 'UpdatepodRequired':
				var value = msg.a;
				return _Utils_Tuple2(
					form,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('rules'),
						A2($author$project$Api$Carriers$podRequired, carrierId, value)));
			case 'UpdateReceivablesInvoiceCustomer':
				var value = msg.a;
				return _Utils_Tuple2(
					form,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('invoicing'),
						A2($author$project$Api$Carriers$receivablesInvoiceCustomer, carrierId, value)));
			case 'UpdateSkipAutoStamp':
				var value = msg.a;
				return _Utils_Tuple2(
					form,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('auto-stamping'),
						A2($author$project$Api$Carriers$skipAutoStamp, carrierId, value)));
			case 'UpdateFactorSendCustomerInvoiceToCadence':
				var value = msg.a;
				return _Utils_Tuple2(
					form,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('debtor invoice'),
						A2($author$project$Api$Carriers$factorSendCustomerInvoiceToCadence, carrierId, value)));
			case 'UpdateTransportationClient':
				var value = msg.a;
				return _Utils_Tuple2(
					form,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('client type'),
						A2($author$project$Api$Carriers$transportationClient, carrierId, value)));
			case 'UpdateLabels':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{labels: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$CarrierLayout$labelsConfig, carrierId, data.accountSettings),
						msg_,
						form.labels));
			case 'UpdatePaymentAddress':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{paymentAddress: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CarrierLayout$paymentAddressConfig(carrierId),
						msg_,
						form.paymentAddress));
			case 'UpdateToleranceOverride':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{invoiceTolerance: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CarrierLayout$invoiceToleranceConfig(carrierId),
						msg_,
						form.invoiceTolerance));
			case 'UpdateScrapingEnabled':
				var value = msg.a;
				return _Utils_Tuple2(
					form,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('automatic retrieval'),
						A2($author$project$Api$Carriers$scrapingEnabled, carrierId, value)));
			case 'UpdateFeature':
				var featureId = msg.a;
				var dropdownMsg = msg.b;
				var _v1 = $elm$core$List$unzip(
					A2(
						$elm$core$List$map,
						function (override) {
							if (_Utils_eq(override.feature.id, featureId)) {
								var _v2 = A2($author$project$Ui$V3$CustomSelect$update, dropdownMsg, override.dropdown);
								var newDropdown = _v2.a;
								var dropdownCmd = _v2.b;
								var newOverride = _Utils_update(
									override,
									{dropdown: newDropdown});
								var shouldSave = !_Utils_eq(
									$author$project$Ui$V3$CustomSelect$selectedItems(newDropdown),
									$author$project$Ui$V3$CustomSelect$selectedItems(override.dropdown));
								var saveEffect = shouldSave ? A2(
									$author$project$HubTran$Effect$sendCacheableRequestWithError,
									$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('feature'),
									A2(
										$author$project$Api$Carriers$updateFeatures,
										carrierId,
										_List_fromArray(
											[
												$author$project$Components$SettingsPage$CarrierLayout$tupleToFeature(newOverride)
											]))) : $author$project$HubTran$Effect$none;
								return _Utils_Tuple2(
									newOverride,
									$author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												$author$project$HubTran$Effect$AnyCmd(
												A2(
													$elm$core$Platform$Cmd$map,
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$SettingsPage$CarrierLayout$FormMsg,
														$author$project$Components$SettingsPage$CarrierLayout$UpdateFeature(featureId)),
													dropdownCmd)),
												saveEffect
											])));
							} else {
								return _Utils_Tuple2(override, $author$project$HubTran$Effect$none);
							}
						},
						form.featureOverrides));
				var newFeatures = _v1.a;
				var featureEffects = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{featureOverrides: newFeatures}),
					$author$project$HubTran$Effect$batch(featureEffects));
			case 'UpdateInvoiceNumberStrategy':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{invoiceNumberStrategy: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$CarrierLayout$invoiceNumberStrategyConfig, data.accountSettings, carrierId),
						msg_,
						form.invoiceNumberStrategy));
			case 'UpdateAutoGenerateInvoiceNumbers':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{autoGenerateInvoiceNumbers: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$CarrierLayout$autoGenerateInvoiceNumbersConfig, data.accountSettings, carrierId),
						msg_,
						form.autoGenerateInvoiceNumbers));
			default:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							form,
							{implicitInvoiceOverride: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CarrierLayout$allowImplicitCarrierInvoiceConfigV3Reskin(carrierId),
						msg_,
						form.implicitInvoiceOverride));
		}
	});
var $author$project$Components$CustomerTypeahead$set = $author$project$Typeahead$selectItem;
var $author$project$Components$SettingsPage$CarrierLayout$withNewCustomerTypeahead = F3(
	function (data, form, model) {
		var typeahead = A2($author$project$Components$CustomerTypeahead$set, form.login.customerId, $author$project$Components$CustomerTypeahead$init);
		var externalLoginCustomers = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.carrierData;
					},
					function ($) {
						return $.externalLoginCustomers;
					}),
				$author$project$Forward$Remote$toMaybe(data)));
		var _v0 = A2(
			$author$project$Components$TmsCustomerDropdown$initWithSelected,
			A2(
				$elm$core$List$filterMap,
				function (id) {
					return A2(
						$elm$core$Maybe$map,
						function (customer) {
							return {
								id: $elm$core$String$fromInt(
									$author$project$Domain$TmsCustomerId$toInt(customer.id)),
								label: $elm$html$Html$text(customer.name),
								text: customer.name
							};
						},
						function (x) {
							return A2($elm$core$Dict$get, x, externalLoginCustomers);
						}(
							$author$project$Domain$TmsCustomerId$toInt(id)));
				},
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[form.login.customerId]))),
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$typeaheadStyle($author$project$Ui$V3$CustomSelect$singleSelectTypeahead),
					$author$project$Ui$V3$CustomSelect$hideSelectAll(true),
					$author$project$Ui$V3$CustomSelect$placeholder(
					$elm$core$Maybe$Just(''))
				]));
		var typeaheadV3Reskin = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					externalLoginForm: $elm$core$Maybe$Just(
						{form: form, typeahead: typeahead, typeaheadV3Reskin: typeaheadV3Reskin}),
					testCredentialsResult: $author$project$Api$Carriers$ExternalLogins$NotTested
				}),
			$author$project$HubTran$Effect$cmd(
				A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$CarrierLayout$CustomerTypeaheadMsgV3Reskin, cmd)));
	});
var $author$project$Components$SettingsPage$CarrierLayout$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'GoBack':
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						$author$project$HubTran$Navigation$back(1)));
			case 'GoTo':
				var url = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						$author$project$HubTran$Navigation$load(url)));
			case 'ShowPortalWarning':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showPortalWarning: true}),
					$author$project$HubTran$Effect$none);
			case 'TogglePortalAccess':
				var accessSwitch = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('client portal access'),
						A2($author$project$Api$Carriers$factorClientPortalEnabled, model.carrierId, accessSwitch)));
			case 'ClosePortalWarning':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showPortalWarning: false}),
					$author$project$HubTran$Effect$none);
			case 'FormMsg':
				var formMsg = msg.a;
				var _v1 = $author$project$Forward$Remote$toMaybe(data);
				if (_v1.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var data_ = _v1.a;
					var _v2 = A2($author$project$Components$SettingsPage$CarrierLayout$mergeFormData, data_, model.form);
					var form = _v2.a;
					var initEffect = _v2.b;
					var _v3 = A4($author$project$Components$SettingsPage$CarrierLayout$updateForm, model.carrierId, data_, formMsg, form);
					var newForm = _v3.a;
					var updateEffect = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: $elm$core$Maybe$Just(newForm)
							}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[initEffect, updateEffect])));
				}
			case 'DeleteContact':
				var id = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('contact'),
						A2($author$project$Api$Carriers$Contacts$delete, model.carrierId, id)));
			case 'SetContactForm':
				var contact = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{contactForm: contact}),
					$author$project$HubTran$Effect$none);
			case 'SaveContactForm':
				return _Utils_Tuple2(
					model,
					function () {
						var _v4 = model.contactForm;
						if (_v4.$ === 'Nothing') {
							return $author$project$HubTran$Effect$none;
						} else {
							var contact = _v4.a;
							return A2(
								$author$project$HubTran$Effect$sendCacheableRequestWithError,
								$author$project$Components$SettingsPage$CarrierLayout$FinishSavingContact,
								_Utils_eq(contact.id, $author$project$Components$SettingsPage$Carriers$Contacts$newId) ? A2($author$project$Api$Carriers$Contacts$create, model.carrierId, contact) : A2($author$project$Api$Carriers$Contacts$update, model.carrierId, contact));
						}
					}());
			case 'InviteContact':
				var contact = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSending,
						A2($author$project$Api$Invites$request, model.carrierId, contact.email)));
			case 'FinishSavingContact':
				switch (msg.a.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{contactForm: $elm$core$Maybe$Nothing}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('Updated contacts')));
					case 'Err':
						var message = msg.a.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Failed to update contact')));
				}
			case 'DeleteExternalLogin':
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							processingExternalLogin: $elm$core$Maybe$Just(id)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CarrierLayout$FinishSaving('credentials'),
						A2($author$project$Api$Carriers$ExternalLogins$delete, model.carrierId, id)));
			case 'SetExternalLoginForm':
				var maybeForm = msg.a;
				var _v5 = _Utils_Tuple2(model.externalLoginForm, maybeForm);
				if (_v5.b.$ === 'Nothing') {
					var _v6 = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{externalLoginForm: $elm$core$Maybe$Nothing, testCredentialsResult: $author$project$Api$Carriers$ExternalLogins$NotTested}),
						$author$project$HubTran$Effect$none);
				} else {
					if (_v5.a.$ === 'Nothing') {
						var _v7 = _v5.a;
						var newForm = _v5.b.a;
						return A3($author$project$Components$SettingsPage$CarrierLayout$withNewCustomerTypeahead, data, newForm, model);
					} else {
						var oldForm = _v5.a.a;
						var newForm = _v5.b.a;
						return (!_Utils_eq(oldForm.form.login.id, newForm.login.id)) ? A3($author$project$Components$SettingsPage$CarrierLayout$withNewCustomerTypeahead, data, newForm, model) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									externalLoginForm: $elm$core$Maybe$Just(
										_Utils_update(
											oldForm,
											{form: newForm})),
									testCredentialsResult: (oldForm.form.login.markLoginFailed && (!newForm.login.markLoginFailed)) ? $author$project$Api$Carriers$ExternalLogins$NotTested : model.testCredentialsResult
								}),
							$author$project$HubTran$Effect$none);
					}
				}
			case 'CustomerTypeaheadMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					function () {
						var _v8 = model.externalLoginForm;
						if (_v8.$ === 'Nothing') {
							return model;
						} else {
							var oldForm = _v8.a;
							var typeahead = oldForm.typeahead;
							var form = oldForm.form;
							var typeaheadData = A2(
								$author$project$Forward$Remote$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.typeaheadData;
									},
									$elm$core$Maybe$withDefault($author$project$Forward$Remote$Loading)),
								data);
							var newTypeahead = A3($author$project$Components$CustomerTypeahead$update, typeaheadData, msg_, typeahead);
							var newCustomerId = $author$project$Typeahead$selectedId(newTypeahead);
							var login = form.login;
							var newScrapingForm = _Utils_update(
								form,
								{
									login: _Utils_update(
										login,
										{customerId: newCustomerId})
								});
							return _Utils_update(
								model,
								{
									externalLoginForm: $elm$core$Maybe$Just(
										_Utils_update(
											oldForm,
											{form: newScrapingForm, typeahead: newTypeahead}))
								});
						}
					}(),
					$author$project$HubTran$Effect$none);
			case 'CustomerTypeaheadMsgV3Reskin':
				var msg_ = msg.a;
				var _v9 = model.externalLoginForm;
				if (_v9.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var oldForm = _v9.a;
					var typeaheadV3Reskin = oldForm.typeaheadV3Reskin;
					var form = oldForm.form;
					var typeaheadData = A2(
						$author$project$Forward$Remote$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.typeaheadDataV3Reskin;
							},
							$elm$core$Maybe$withDefault($author$project$Forward$Remote$Loading)),
						data);
					var login = form.login;
					var _v10 = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(typeaheadV3Reskin, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (accountSettings) {
								return A4($author$project$Components$TmsCustomerDropdown$update, accountSettings, typeaheadData, msg_, typeaheadV3Reskin);
							},
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.accountSettings;
								},
								$author$project$Forward$Remote$toMaybe(data))));
					var newTypeahead = _v10.a;
					var cmd = _v10.b;
					var newCustomerId = $elm$core$List$head(
						$author$project$Components$TmsCustomerDropdown$selectedIds(newTypeahead));
					var newScrapingForm = _Utils_update(
						form,
						{
							login: _Utils_update(
								login,
								{customerId: newCustomerId})
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								externalLoginForm: $elm$core$Maybe$Just(
									_Utils_update(
										oldForm,
										{form: newScrapingForm, typeaheadV3Reskin: newTypeahead}))
							}),
						$author$project$HubTran$Effect$cmd(
							A2($elm$core$Platform$Cmd$map, $author$project$Components$SettingsPage$CarrierLayout$CustomerTypeaheadMsgV3Reskin, cmd)));
				}
			case 'SaveExternalLoginForm':
				var _v11 = model.externalLoginForm;
				if (_v11.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var form = _v11.a.form;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								processingExternalLogin: $elm$core$Maybe$Just(form.login.id)
							}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$SettingsPage$CarrierLayout$FinishSavingExternalLogin,
							_Utils_eq(form.login.id, $author$project$Domain$ExternalLoginId$dummyId) ? A2($author$project$Api$Carriers$ExternalLogins$create, model.carrierId, form.login) : A2($author$project$Api$Carriers$ExternalLogins$update, model.carrierId, form.login)));
				}
			case 'TestExternalLoginCredentials':
				var _v12 = model.externalLoginForm;
				if (_v12.$ === 'Nothing') {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				} else {
					var form = _v12.a.form;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{testCredentialsResult: $author$project$Api$Carriers$ExternalLogins$NotTested, testingCredentials: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Components$SettingsPage$CarrierLayout$FinishTestingCredentials,
							A2($author$project$Api$Carriers$ExternalLogins$testCredentials, model.carrierId, form.login)));
				}
			case 'FinishTestingCredentials':
				switch (msg.a.$) {
					case 'Ok':
						var response = msg.a.a;
						var testResult = function () {
							var _v14 = model.externalLoginForm;
							if (_v14.$ === 'Nothing') {
								return $author$project$Api$Carriers$ExternalLogins$NotTested;
							} else {
								return response;
							}
						}();
						var isSuccess = function () {
							if (response.$ === 'TestSuccess') {
								return true;
							} else {
								return false;
							}
						}();
						var updatedForm = A2(
							$elm$core$Maybe$map,
							function (loginForm) {
								return _Utils_update(
									loginForm,
									{
										form: {
											login: function (login) {
												return _Utils_update(
													login,
													{markLoginFailed: !isSuccess});
											}(loginForm.form.login),
											useCustomer: loginForm.form.useCustomer
										}
									});
							},
							model.externalLoginForm);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{externalLoginForm: updatedForm, testCredentialsResult: testResult, testingCredentials: false}),
							$author$project$HubTran$Effect$none);
					case 'Err':
						var message = msg.a.a;
						var updatedForm = A2(
							$elm$core$Maybe$map,
							function (loginForm) {
								return _Utils_update(
									loginForm,
									{
										form: {
											login: function (login) {
												return _Utils_update(
													login,
													{markLoginFailed: true});
											}(loginForm.form.login),
											useCustomer: loginForm.form.useCustomer
										}
									});
							},
							model.externalLoginForm);
						var testResult = function () {
							var _v15 = model.externalLoginForm;
							if (_v15.$ === 'Nothing') {
								return $author$project$Api$Carriers$ExternalLogins$NotTested;
							} else {
								return $author$project$Api$Carriers$ExternalLogins$TestFailure(message);
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{externalLoginForm: updatedForm, testCredentialsResult: testResult, testingCredentials: false}),
							$author$project$HubTran$Effect$none);
					default:
						var updatedForm = A2(
							$elm$core$Maybe$map,
							function (loginForm) {
								return _Utils_update(
									loginForm,
									{
										form: {
											login: function (login) {
												return _Utils_update(
													login,
													{markLoginFailed: true});
											}(loginForm.form.login),
											useCustomer: loginForm.form.useCustomer
										}
									});
							},
							model.externalLoginForm);
						var testResult = function () {
							var _v16 = model.externalLoginForm;
							if (_v16.$ === 'Nothing') {
								return $author$project$Api$Carriers$ExternalLogins$NotTested;
							} else {
								return $author$project$Api$Carriers$ExternalLogins$TestFailure('Failed to test credentials');
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{externalLoginForm: updatedForm, testCredentialsResult: testResult, testingCredentials: false}),
							$author$project$HubTran$Effect$none);
				}
			case 'FinishSavingExternalLogin':
				switch (msg.a.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{externalLoginForm: $elm$core$Maybe$Nothing, processingExternalLogin: $elm$core$Maybe$Nothing, testCredentialsResult: $author$project$Api$Carriers$ExternalLogins$NotTested}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Updated external logins')),
										$author$project$HubTran$Effect$invalidateAllOfType($author$project$Forward$AppSpecific$Cache$externalLogin)
									])));
					case 'Err':
						var message = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{processingExternalLogin: $elm$core$Maybe$Nothing}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{processingExternalLogin: $elm$core$Maybe$Nothing}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Failed to update external logins')));
				}
			case 'FinishSaving':
				var title = msg.a;
				var response = msg.b;
				var flash = function () {
					switch (response.$) {
						case 'Ok':
							return $author$project$HubTran$Flash$success('Updated ' + (title + ' settings'));
						case 'Err':
							var message = response.a;
							return $author$project$HubTran$Flash$alert(message);
						default:
							return $author$project$HubTran$Flash$alert('Failed to update ' + (title + ' settings'));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{processingExternalLogin: $elm$core$Maybe$Nothing, showPortalWarning: false}),
					$author$project$HubTran$Effect$flash(flash));
			case 'FinishSending':
				var response = msg.a;
				var flash = function () {
					switch (response.$) {
						case 'Ok':
							return $author$project$HubTran$Flash$success('Successfully Sent Portal Invite Email');
						case 'Err':
							var message = response.a;
							return $author$project$HubTran$Flash$alert(message);
						default:
							return $author$project$HubTran$Flash$alert('Failed To Send Portal Invite Email');
					}
				}();
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$flash(flash));
			default:
				var subMsg = msg.a;
				var maybeData = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.clientDebtorConfigManagerData;
					},
					$author$project$Forward$Remote$toMaybe(data));
				var _v19 = A3($author$project$Components$ClientDebtorConfigurationManager$update, maybeData, subMsg, model.clientDebtorConfigManager);
				var newClientDebtorConfigManager = _v19.a;
				var effect = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{clientDebtorConfigManager: newClientDebtorConfigManager}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$CarrierLayout$ClientDebtorConfigManagerMsg, effect));
		}
	});
var $author$project$Components$SettingsPage$Carriers$Filters$setPage = F2(
	function (_int, model) {
		return _Utils_update(
			model,
			{page: _int});
	});
var $author$project$Components$SettingsPage$Carriers$Filters$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateTerm':
				var string = msg.a;
				return A2(
					$author$project$Components$SettingsPage$Carriers$Filters$setPage,
					1,
					_Utils_update(
						model,
						{term: string}));
			case 'ClearTerm':
				return A2(
					$author$project$Components$SettingsPage$Carriers$Filters$setPage,
					1,
					_Utils_update(
						model,
						{term: ''}));
			case 'ToggleLabel':
				var labelName = msg.a;
				return A2(
					$author$project$Components$SettingsPage$Carriers$Filters$setPage,
					1,
					_Utils_update(
						model,
						{
							selectedLabels: A2($elm$core$Set$member, labelName, model.selectedLabels) ? A2($elm$core$Set$remove, labelName, model.selectedLabels) : A2($elm$core$Set$insert, labelName, model.selectedLabels)
						}));
			case 'UpdateScraperOnly':
				var bool = msg.a;
				return A2(
					$author$project$Components$SettingsPage$Carriers$Filters$setPage,
					1,
					_Utils_update(
						model,
						{scraperOnly: bool}));
			case 'UpdateWithLoginFailures':
				var bool = msg.a;
				return A2(
					$author$project$Components$SettingsPage$Carriers$Filters$setPage,
					1,
					_Utils_update(
						model,
						{withLoginFailures: bool}));
			case 'UpdateEligibleForAutoprocessing':
				var bool = msg.a;
				return A2(
					$author$project$Components$SettingsPage$Carriers$Filters$setPage,
					1,
					_Utils_update(
						model,
						{eligibleForAutoprocessing: bool}));
			default:
				return model;
		}
	});
var $author$project$Components$SettingsPage$CarriersLayout$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'NavigateTo':
				var url = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$load(url));
			case 'UpdatePage':
				var _int = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							filtersModel: A2($author$project$Components$SettingsPage$Carriers$Filters$setPage, _int, model.filtersModel)
						}),
					$author$project$HubTran$Effect$none);
			default:
				var filtersModelMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							filtersModel: A2($author$project$Components$SettingsPage$Carriers$Filters$update, filtersModelMsg, model.filtersModel)
						}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$CustomerLayout$LoadedMsg = function (a) {
	return {$: 'LoadedMsg', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Customer = function (a) {
	return {$: 'Customer', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$customerId = $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Customer;
var $author$project$Components$SettingsPage$CustomerLayout$documentTypes = function (settings) {
	return {
		customerVisibleTypes: A2($elm$core$List$map, $author$project$Domain$UnresolvedDocumentType$fromPb, settings.customerVisibleDocumentTypes),
		requiredPayablesTypes: A2($elm$core$List$map, $author$project$Domain$UnresolvedDocumentType$fromPb, settings.requiredPayablesTypes),
		requiredReceivablesTypes: A2($elm$core$List$map, $author$project$Domain$UnresolvedDocumentType$fromPb, settings.requiredReceivablesTypes)
	};
};
var $author$project$Components$SettingsPage$Shared$PayablesValue$required = $author$project$Components$SettingsPage$Shared$PayablesValue$Required;
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$RequiredForCustomer = {$: 'RequiredForCustomer'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$requiredForCustomer = $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$RequiredForCustomer;
var $author$project$Components$SettingsPage$Shared$PayablesValue$toString = function (value) {
	if (value.$ === 'Required') {
		return 'Required';
	} else {
		return 'Use TriumphPay Audit defaults';
	}
};
var $author$project$Components$SettingsPage$Shared$Checkbox$checkedAttr = $elm$html$Html$Attributes$checked(true);
var $author$project$Components$SettingsPage$Shared$Checkbox$attributes = function (_v0) {
	var messages = _v0.messages;
	var id = _v0.id;
	var value = _v0.value;
	var onToggle = A2(
		$elm$html$Html$Events$on,
		'change',
		A2(
			$elm$json$Json$Decode$map,
			function (checked_) {
				return checked_ ? messages.onCheck(id) : messages.onUncheck(id);
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'checked']),
				$elm$json$Json$Decode$bool)));
	if (value.$ === 'Checked') {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				$author$project$Components$SettingsPage$Shared$Checkbox$checkedAttr,
				onToggle
			]);
	} else {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				onToggle
			]);
	}
};
var $author$project$Components$SettingsPage$Shared$Checkbox$view = function (options) {
	return A2(
		$elm$html$Html$input,
		$author$project$Components$SettingsPage$Shared$Checkbox$attributes(options),
		_List_Nil);
};
var $author$project$Components$Shared$Select$onSelect = F2(
	function (toMessage, toMsg) {
		var decoder = A2(
			$elm$json$Json$Decode$map,
			toMsg,
			A2(
				$elm$json$Json$Decode$andThen,
				function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Decode$fail('No mapping provided for ' + (value + '.')),
						A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Decode$succeed,
							toMessage(value)));
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					$elm$json$Json$Decode$string)));
		return A2($elm$html$Html$Events$on, 'change', decoder);
	});
var $author$project$Components$Shared$Select$selectedAttributeFor = F2(
	function (a, b) {
		return _Utils_eq(a, b) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'selected', 'true')
			]) : _List_Nil;
	});
var $author$project$Components$Shared$Select$view = function (options) {
	var viewSelectOption = function (value) {
		var label = options.toString(value);
		var attrs = A2($elm$core$List$member, value, options.disabledChoices) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'disabled', 'true')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$option,
			_Utils_ap(
				attrs,
				A2(
					$author$project$Components$Shared$Select$selectedAttributeFor,
					options.value,
					$elm$core$Maybe$Just(value))),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	};
	var sortIfNeeded = options.sortAlphabetically ? $elm$core$List$sortBy(options.toString) : function (list) {
		return list;
	};
	var fromString = F2(
		function (_v0, label) {
			var choices = _v0.choices;
			var toString = _v0.toString;
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (choice) {
						return _Utils_eq(
							toString(choice),
							label);
					},
					choices));
		});
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Select$onSelect,
				fromString(
					{choices: options.choices, toString: options.toString}),
				options.onChange),
				A2($elm$html$Html$Attributes$style, 'margin', '0')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$option,
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'disabled', 'true'),
					A2($author$project$Components$Shared$Select$selectedAttributeFor, options.value, $elm$core$Maybe$Nothing)),
				_List_fromArray(
					[
						$elm$html$Html$text(options.placeholder)
					])),
			A2(
				$elm$core$List$map,
				viewSelectOption,
				sortIfNeeded(options.choices))));
};
var $author$project$Components$SettingsPage$Shared$Checkbox$disabledAttr = $elm$html$Html$Attributes$disabled(true);
var $author$project$Components$SettingsPage$Shared$Checkbox$disabledAttributes = function (value) {
	if (value.$ === 'Checked') {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				$author$project$Components$SettingsPage$Shared$Checkbox$checkedAttr,
				$author$project$Components$SettingsPage$Shared$Checkbox$disabledAttr
			]);
	} else {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				$author$project$Components$SettingsPage$Shared$Checkbox$disabledAttr
			]);
	}
};
var $author$project$Components$SettingsPage$Shared$Checkbox$viewDisabled = function (value) {
	return A2(
		$elm$html$Html$input,
		$author$project$Components$SettingsPage$Shared$Checkbox$disabledAttributes(value),
		_List_Nil);
};
var $author$project$Components$Shared$Select$viewDisabled = function (options) {
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'disabled', 'true')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$option,
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'disabled', 'true'),
					A2($author$project$Components$Shared$Select$selectedAttributeFor, options.value, $elm$core$Maybe$Nothing)),
				_List_fromArray(
					[
						$elm$html$Html$text(options.placeholder)
					])),
			A2(
				$elm$core$List$map,
				function (value) {
					return A2(
						$elm$html$Html$option,
						A2(
							$author$project$Components$Shared$Select$selectedAttributeFor,
							options.value,
							$elm$core$Maybe$Just(value)),
						_List_fromArray(
							[
								$elm$html$Html$text(
								options.toString(value))
							]));
				},
				options.choices)));
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$VisibleToCustomer = {$: 'VisibleToCustomer'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$visibleToCustomer = $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$VisibleToCustomer;
var $author$project$Components$SettingsPage$CustomerLayout$documentTypesSettingsFromData = F2(
	function (id, data) {
		return {
			columns: _List_fromArray(
				[
					{
					header: 'Document Type',
					isDisabled: false,
					view: F2(
						function (_v0, row) {
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'min-width', '200px')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(row.name)
									]));
						}),
					viewDisabled: function (row) {
						return A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'min-width', '200px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(row.name)
								]));
					}
				},
					{
					header: 'Visible to Customer',
					isDisabled: data.accountSettings.controlledByTMS.customerVisibleDocs,
					view: F2(
						function (messages, row) {
							return A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$SettingsPage$Shared$Checkbox$view(
										{
											id: _Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$visibleToCustomer),
											messages: {onCheck: messages.onCheck, onUncheck: messages.onUncheck},
											value: row.isVisibleToCustomer
										})
									]));
						}),
					viewDisabled: function (row) {
						return A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$Shared$Checkbox$viewDisabled(row.isVisibleToCustomer)
								]));
					}
				},
					{
					header: 'Required for Customer Billing',
					isDisabled: data.accountSettings.controlledByTMS.customerRequiredDocs,
					view: F2(
						function (messages, row) {
							return A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$SettingsPage$Shared$Checkbox$view(
										{
											id: _Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$requiredForCustomer),
											messages: {onCheck: messages.onCheck, onUncheck: messages.onUncheck},
											value: row.isRequiredForCustomer
										})
									]));
						}),
					viewDisabled: function (row) {
						return A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$Shared$Checkbox$viewDisabled(row.isRequiredForCustomer)
								]));
					}
				},
					{
					header: 'Required for Payables',
					isDisabled: false,
					view: F2(
						function (messages, row) {
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'min-width', '250px')
									]),
								_List_fromArray(
									[
										$author$project$Components$Shared$Select$view(
										{
											choices: _List_fromArray(
												[$author$project$Components$SettingsPage$Shared$PayablesValue$required, $author$project$Components$SettingsPage$Shared$PayablesValue$useHubtranDefaults]),
											disabledChoices: _List_Nil,
											onChange: messages.setPayablesValue(row.documentType),
											placeholder: '',
											sortAlphabetically: false,
											toString: $author$project$Components$SettingsPage$Shared$PayablesValue$toString,
											value: $elm$core$Maybe$Just(row.isRequiredForPayables)
										})
									]));
						}),
					viewDisabled: function (row) {
						return A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'min-width', '250px')
								]),
							_List_fromArray(
								[
									$author$project$Components$Shared$Select$viewDisabled(
									{
										choices: _List_fromArray(
											[$author$project$Components$SettingsPage$Shared$PayablesValue$required, $author$project$Components$SettingsPage$Shared$PayablesValue$useHubtranDefaults]),
										placeholder: '',
										toString: $author$project$Components$SettingsPage$Shared$PayablesValue$toString,
										value: $elm$core$Maybe$Just(row.isRequiredForPayables)
									})
								]));
					}
				}
				]),
			descriptions: {
				hasDifferences: _List_fromArray(
					[
						$elm$html$Html$text('Make changes to document types for this customer. You can also choose to use the settings for this account by clicking \u0022Use account settings\u0022.')
					]),
				sameAsGlobal: _List_fromArray(
					[
						$elm$html$Html$text('Make changes to document types for this customer. Right now, this customer is using the account settings. '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/app/settings/document_types')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('You can update account settings here. ')
							])),
						$elm$html$Html$text('To change settings for just this customer click the \u0022Edit Document Types\u0022 button below.')
					])
			},
			id: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$customerId(id),
			isAdmin: data.currentUser.isAdmin,
			settings: {
				global: data.documentTypeSettings,
				local: $author$project$Components$SettingsPage$CustomerLayout$documentTypes(data.customerSettings)
			}
		};
	});
var $author$project$Domain$DeliveryMethod$BackupOnly = {$: 'BackupOnly'};
var $author$project$Domain$DeliveryMethod$Email = function (a) {
	return {$: 'Email', a: a};
};
var $author$project$Domain$DeliveryMethod$Multiple = function (a) {
	return {$: 'Multiple', a: a};
};
var $author$project$Domain$DeliveryMethod$Other = function (a) {
	return {$: 'Other', a: a};
};
var $author$project$Domain$DeliveryMethod$PaymentsNetwork = {$: 'PaymentsNetwork'};
var $author$project$Domain$DeliveryMethod$PaymentsNetworkMultiple = function (a) {
	return {$: 'PaymentsNetworkMultiple', a: a};
};
var $author$project$Domain$DeliveryMethod$Print = {$: 'Print'};
var $author$project$Domain$DeliveryMethod$TpayApi = {$: 'TpayApi'};
var $author$project$Domain$DeliveryMethod$UploadCass = function (a) {
	return {$: 'UploadCass', a: a};
};
var $author$project$Domain$DeliveryMethodFromPb$cassCredentials = function (credentials) {
	return {account: credentials.account, password: credentials.password, username: credentials.username};
};
var $author$project$Domain$DeliveryMethod$DeliveryOptionDetails = function (choices) {
	return {choices: choices};
};
var $author$project$Domain$DeliveryMethod$DeliveryOptionChoice = F2(
	function (regexPattern, deliveryMethod) {
		return {deliveryMethod: deliveryMethod, regexPattern: regexPattern};
	});
var $author$project$Domain$DeliveryMethod$Default = {$: 'Default'};
var $author$project$Domain$DeliveryMethod$Overridden = function (a) {
	return {$: 'Overridden', a: a};
};
var $author$project$Domain$DeliveryMethodFromPb$emailPerInvoice = function (value) {
	switch (value.$) {
		case 'EmailPerInvoiceEmailAccountDefault':
			return $author$project$Domain$DeliveryMethod$Default;
		case 'EmailPerInvoiceEmailPerInvoice':
			return $author$project$Domain$DeliveryMethod$Overridden(true);
		default:
			return $author$project$Domain$DeliveryMethod$Overridden(false);
	}
};
var $author$project$Domain$DeliveryMethodFromPb$emailPreferences = function (preferences) {
	return {
		attachInvoices: preferences.attachInvoices,
		billingEmailOverride: preferences.billingEmailOverride,
		customInvoiceAttachmentFilename: preferences.customInvoiceAttachmentFilename,
		emailPerInvoice: $author$project$Domain$DeliveryMethodFromPb$emailPerInvoice(preferences.emailPerInvoice)
	};
};
var $author$project$Domain$DeliveryMethod$Ftp = F3(
	function (a, b, c) {
		return {$: 'Ftp', a: a, b: b, c: c};
	});
var $author$project$Domain$DeliveryMethod$FtpFilename = function (a) {
	return {$: 'FtpFilename', a: a};
};
var $author$project$Domain$DeliveryMethod$BasicFtp = {$: 'BasicFtp'};
var $author$project$Domain$DeliveryMethod$SecureSftp = {$: 'SecureSftp'};
var $author$project$Domain$DeliveryMethodFromPb$ftpProtocolType = function (value) {
	if (value.$ === 'FtpProtocolTypeFtp') {
		return $author$project$Domain$DeliveryMethod$BasicFtp;
	} else {
		return $author$project$Domain$DeliveryMethod$SecureSftp;
	}
};
var $author$project$Domain$DeliveryMethodFromPb$ftp = function (delivery) {
	return A3(
		$author$project$Domain$DeliveryMethod$Ftp,
		$author$project$Domain$DeliveryMethod$FtpFilename(delivery.filenameTemplate),
		{ftpPort: delivery.ftpPort, host: delivery.host, password: delivery.password, rootDirectory: delivery.rootDirectory, username: delivery.username},
		$author$project$Domain$DeliveryMethodFromPb$ftpProtocolType(delivery.protocolType));
};
var $author$project$Domain$DeliveryMethodFromPb$otherSettings = function (settings) {
	return {externalDeliveryMethod: settings.externalDeliveryMethod, externalEmailRecipients: settings.externalEmailRecipients};
};
var $author$project$Domain$DeliveryMethodFromPb$choiceMethod = function (method) {
	switch (method.$) {
		case 'DeliveryMethod_Choice_Method_Email':
			var preferences = method.a;
			return $author$project$Domain$DeliveryMethod$Email(
				$author$project$Domain$DeliveryMethodFromPb$emailPreferences(preferences));
		case 'DeliveryMethod_Choice_Method_Print':
			return $author$project$Domain$DeliveryMethod$Print;
		case 'DeliveryMethod_Choice_Method_PaymentsNetwork':
			return $author$project$Domain$DeliveryMethod$PaymentsNetwork;
		case 'DeliveryMethod_Choice_Method_FtpDelivery':
			var delivery = method.a;
			return $author$project$Domain$DeliveryMethodFromPb$ftp(delivery);
		case 'DeliveryMethod_Choice_Method_UploadCass':
			var credentials = method.a;
			return $author$project$Domain$DeliveryMethod$UploadCass(
				$author$project$Domain$DeliveryMethodFromPb$cassCredentials(credentials));
		case 'DeliveryMethod_Choice_Method_TpayAPI':
			return $author$project$Domain$DeliveryMethod$TpayApi;
		case 'DeliveryMethod_Choice_Method_BackupOnly':
			return $author$project$Domain$DeliveryMethod$BackupOnly;
		default:
			var settings = method.a;
			return $author$project$Domain$DeliveryMethod$Other(
				$author$project$Domain$DeliveryMethodFromPb$otherSettings(settings));
	}
};
var $author$project$Domain$DeliveryMethodFromPb$deliveryOptionChoice = function (choice) {
	return A2(
		$author$project$Domain$DeliveryMethod$DeliveryOptionChoice,
		choice.regexPattern,
		$author$project$Domain$DeliveryMethodFromPb$choiceMethod(choice.method));
};
var $author$project$Domain$DeliveryMethodFromPb$deliveryOptionDetails = function (choices) {
	return $author$project$Domain$DeliveryMethod$DeliveryOptionDetails(
		A2($elm$core$List$map, $author$project$Domain$DeliveryMethodFromPb$deliveryOptionChoice, choices));
};
var $author$project$Domain$DeliveryMethodFromPb$fromPb = function (method) {
	switch (method.$) {
		case 'DeliveryMethod_Method_Email':
			var preferences = method.a;
			return $author$project$Domain$DeliveryMethod$Email(
				$author$project$Domain$DeliveryMethodFromPb$emailPreferences(preferences));
		case 'DeliveryMethod_Method_Print':
			return $author$project$Domain$DeliveryMethod$Print;
		case 'DeliveryMethod_Method_PaymentsNetwork':
			return $author$project$Domain$DeliveryMethod$PaymentsNetwork;
		case 'DeliveryMethod_Method_FtpDelivery':
			var delivery = method.a;
			return $author$project$Domain$DeliveryMethodFromPb$ftp(delivery);
		case 'DeliveryMethod_Method_UploadCass':
			var credentials = method.a;
			return $author$project$Domain$DeliveryMethod$UploadCass(
				$author$project$Domain$DeliveryMethodFromPb$cassCredentials(credentials));
		case 'DeliveryMethod_Method_Multiple':
			var details = method.a;
			return $author$project$Domain$DeliveryMethod$Multiple(
				$author$project$Domain$DeliveryMethodFromPb$deliveryOptionDetails(details.choices));
		case 'DeliveryMethod_Method_PaymentsNetworkMultiple':
			var details = method.a;
			return $author$project$Domain$DeliveryMethod$PaymentsNetworkMultiple(
				$author$project$Domain$DeliveryMethodFromPb$deliveryOptionDetails(details.choices));
		case 'DeliveryMethod_Method_TpayAPI':
			return $author$project$Domain$DeliveryMethod$TpayApi;
		case 'DeliveryMethod_Method_BackupOnly':
			return $author$project$Domain$DeliveryMethod$BackupOnly;
		default:
			var settings = method.a;
			return $author$project$Domain$DeliveryMethod$Other(
				$author$project$Domain$DeliveryMethodFromPb$otherSettings(settings));
	}
};
var $author$project$Domain$EmailAddress$EmailAddress = function (a) {
	return {$: 'EmailAddress', a: a};
};
var $author$project$Domain$EmailAddress$fromString = function (str) {
	return $author$project$Domain$EmailAddress$EmailAddress(str);
};
var $author$project$Helpers$Savable$Savable = function (a) {
	return {$: 'Savable', a: a};
};
var $author$project$Helpers$Savable$create = function (value_) {
	return $author$project$Helpers$Savable$Savable(
		{original: value_, value: value_});
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$defaultNewTypesSelection = function (accountSettings) {
	return accountSettings.auditBillingEnabled ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Domain$CustomExceptionMessage$Payment);
};
var $author$project$Helpers$Savable$hasChanged = function (_v0) {
	var s = _v0.a;
	return !_Utils_eq(s.value, s.original);
};
var $author$project$Helpers$Savable$originalChangedTo = F2(
	function (newOriginal, savable) {
		var s = savable.a;
		return $author$project$Helpers$Savable$hasChanged(savable) ? $author$project$Helpers$Savable$Savable(
			_Utils_update(
				s,
				{original: newOriginal})) : $author$project$Helpers$Savable$create(newOriginal);
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$init = F2(
	function (maybePrevious, _v0) {
		var accountSettings = _v0.accountSettings;
		var customExceptionMessages = _v0.customExceptionMessages;
		return {
			accountSettings: accountSettings,
			isSaving: false,
			items: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Helpers$Savable$create(customExceptionMessages),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.items;
						},
						$author$project$Helpers$Savable$originalChangedTo(customExceptionMessages)),
					maybePrevious)),
			newRuleInput: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.newRuleInput;
					},
					maybePrevious)),
			newTypesSelection: A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$defaultNewTypesSelection(accountSettings),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.newTypesSelection;
					},
					maybePrevious))
		};
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Ready = {$: 'Ready'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$applyCustomerSettings = function (settings) {
	var within = F2(
		function (items, item) {
			return A2($elm$core$List$member, item, items);
		});
	var isVisibleToCustomer = A2(
		$elm$core$Basics$composeR,
		within(settings.customerVisibleTypes),
		$author$project$Components$SettingsPage$Shared$Checkbox$fromBool);
	var isRequiredForPayables = A2(
		$elm$core$Basics$composeR,
		within(settings.requiredPayablesTypes),
		$author$project$Components$SettingsPage$Shared$PayablesValue$fromBool);
	var isRequiredForCustomer = A2(
		$elm$core$Basics$composeR,
		within(settings.requiredReceivablesTypes),
		$author$project$Components$SettingsPage$Shared$Checkbox$fromBool);
	return $elm$core$List$map(
		function (row) {
			return _Utils_update(
				row,
				{
					isRequiredForCustomer: isRequiredForCustomer(row.documentType),
					isRequiredForPayables: isRequiredForPayables(row.documentType),
					isVisibleToCustomer: isVisibleToCustomer(row.documentType)
				});
		});
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$init = F2(
	function (_v0, maybePreviousModel) {
		var settings = _v0.settings;
		var globalRows = $author$project$Components$SettingsPage$Shared$DocumentTypeTable$fromSettings(settings.global);
		var rows = A2($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$applyCustomerSettings, settings.local, globalRows);
		return {
			globalRows: globalRows,
			isEditing: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.isEditing;
					},
					maybePreviousModel)),
			keepGlobalSettings: A2(
				$elm$core$Maybe$withDefault,
				_Utils_eq(rows, globalRows),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.keepGlobalSettings;
					},
					maybePreviousModel)),
			rows: A2(
				$elm$core$Maybe$withDefault,
				rows,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.rows;
					},
					maybePreviousModel)),
			rowsSinceLastSave: A2(
				$elm$core$Maybe$withDefault,
				rows,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.rowsSinceLastSave;
					},
					maybePreviousModel)),
			status: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Ready,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.status;
					},
					maybePreviousModel)),
			useAccountSettings: A2(
				$elm$core$Maybe$withDefault,
				_Utils_eq(rows, globalRows),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.useAccountSettings;
					},
					maybePreviousModel))
		};
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$init = F4(
	function (overrideEnabled, minimum, maximum, unit) {
		var marginType = overrideEnabled ? (($elm$core$String$isEmpty(minimum) || $elm$core$String$isEmpty(maximum)) ? $author$project$Domain$Override$Disabled : $author$project$Domain$Override$Enabled) : $author$project$Domain$Override$AccountDefault;
		return {marginType: marginType, maximumTolerance: maximum, minimumTolerance: minimum, unit: unit};
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$BeginsWithOption = {$: 'BeginsWithOption'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$HasValueOption = {$: 'HasValueOption'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$IsEmptyOption = {$: 'IsEmptyOption'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$IsPresentOption = {$: 'IsPresentOption'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$NotValueOption = {$: 'NotValueOption'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$fromReferenceRule = function (_v0) {
	var rule = _v0.rule;
	var reference = _v0.reference;
	switch (rule.$) {
		case 'IsPresent':
			return {label: reference, option: $author$project$Components$SettingsPage$Shared$ReferenceTable$IsPresentOption, value: ''};
		case 'HasValue':
			var value = rule.a;
			return {label: reference, option: $author$project$Components$SettingsPage$Shared$ReferenceTable$HasValueOption, value: value};
		case 'NotValue':
			var value = rule.a;
			return {label: reference, option: $author$project$Components$SettingsPage$Shared$ReferenceTable$NotValueOption, value: value};
		case 'BeginsWith':
			var value = rule.a;
			return {label: reference, option: $author$project$Components$SettingsPage$Shared$ReferenceTable$BeginsWithOption, value: value};
		default:
			return {label: reference, option: $author$project$Components$SettingsPage$Shared$ReferenceTable$IsEmptyOption, value: ''};
	}
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$init = F3(
	function (items, references, maybePreviousModel) {
		var newItems = A2($elm$core$List$map, $author$project$Components$SettingsPage$Shared$ReferenceTable$fromReferenceRule, items);
		return {
			isEditing: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.isEditing;
					},
					maybePreviousModel)),
			isSaving: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.isSaving;
					},
					maybePreviousModel)),
			items: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Helpers$Savable$create(newItems),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.items;
						},
						$author$project$Helpers$Savable$originalChangedTo(newItems)),
					maybePreviousModel)),
			message: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.message;
					},
					maybePreviousModel)),
			references: $elm$core$List$sort(references),
			selectedReference: A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.selectedReference;
				},
				maybePreviousModel)
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$maybe = F2(
	function (_default, f) {
		return A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(_default),
			$elm$core$Maybe$map(f));
	});
var $author$project$Components$SettingsPage$CustomerLayout$mergeFormState = F2(
	function (data, model) {
		var form = function (getter) {
			return A2($elm$core$Maybe$map, getter, model.formState_INTERNAL);
		};
		return {
			billingEmail: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$elm$core$Result$Ok(
					$author$project$Domain$EmailAddress$fromString(data.customerSettings.billingEmail)),
				form(
					function ($) {
						return $.billingEmail;
					})),
			billingInterval: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.billingInterval,
				form(
					function ($) {
						return $.billingInterval;
					})),
			contactForm: A3(
				$author$project$Components$SettingsPage$CustomerLayout$maybe,
				$elm$core$Maybe$Nothing,
				function ($) {
					return $.contactForm;
				},
				model.formState_INTERNAL),
			customExceptionMessages: function () {
				var _v0 = form(
					function ($) {
						return $.customExceptionMessages;
					});
				if (_v0.$ === 'Nothing') {
					return A2(
						$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$init,
						form(
							function ($) {
								return $.customExceptionMessages;
							}),
						{
							accountSettings: data.accountSettings,
							customExceptionMessages: A2($elm$core$List$map, $author$project$Domain$CustomExceptionMessage$fromPb, data.customerSettings.rulesBrokerCustomExceptionMessages)
						});
				} else {
					var customExceptionMessages = _v0.a;
					return customExceptionMessages;
				}
			}(),
			customSubject: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$elm$core$Result$Ok(data.customerSettings.customSubjectTemplate),
				form(
					function ($) {
						return $.customSubject;
					})),
			deliveryMethod: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$author$project$Domain$DeliveryMethodFromPb$fromPb(data.customerSettings.deliveryMethod.method),
				form(
					function ($) {
						return $.deliveryMethod;
					})),
			documentTypes: A2(
				$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$init,
				A2($author$project$Components$SettingsPage$CustomerLayout$documentTypesSettingsFromData, model.customerId, data),
				form(
					function ($) {
						return $.documentTypes;
					})),
			ignoreInvoiceDocument: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.ignoreCustomerInvoiceDocument,
				form(
					function ($) {
						return $.ignoreInvoiceDocument;
					})),
			instructions: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.instructionsForWrite,
				form(
					function ($) {
						return $.instructions;
					})),
			invoiceTemplate: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.customerInvoiceTemplateId,
				form(
					function ($) {
						return $.invoiceTemplate;
					})),
			ltlCustomerAutoRate: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.ltlAutoRerateEnabled,
				form(
					function ($) {
						return $.ltlCustomerAutoRate;
					})),
			ltlCustomerMarginTolerance: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				A4($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$init, data.customerSettings.overrideDefaultLtlCustomerMarginTolerance, data.customerSettings.ltlCustomerMarginToleranceMinimum, data.customerSettings.ltlCustomerMarginToleranceMaximum, data.customerSettings.ltlCustomerMarginToleranceUnit),
				form(
					function ($) {
						return $.ltlCustomerMarginTolerance;
					})),
			ltlRequireManualReweighReview: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.ltlRequireManualReweighReview,
				form(
					function ($) {
						return $.ltlRequireManualReweighReview;
					})),
			ltlReweighChargeExceptions: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.ltlReweighChargeExceptionsEnabled,
				form(
					function ($) {
						return $.ltlReweighChargeExceptions;
					})),
			ltlTolerance: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				A6($author$project$Components$SettingsPage$Shared$Tolerance$init, data.customerSettings.overrideDefaultLtlTolerance, data.customerSettings.ltlCarrierInvoiceAmountToleranceOver, data.customerSettings.ltlCarrierInvoiceAmountToleranceUnder, data.customerSettings.ltlCarrierInvoiceAmountToleranceUnit, 'Customer specific', _List_Nil),
				form(
					function ($) {
						return $.ltlTolerance;
					})),
			masterInvoiceTemplate: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.masterCustomerInvoiceTemplateId,
				form(
					function ($) {
						return $.masterInvoiceTemplate;
					})),
			paymentTerms: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$elm$core$Result$Ok(data.customerSettings.effectiveDaysToPay),
				form(
					function ($) {
						return $.paymentTerms;
					})),
			podRequirementPolicy: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.podRequirementPolicy,
				form(
					function ($) {
						return $.podRequirementPolicy;
					})),
			remitToAddress: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.accountRemitToAddressId,
				form(
					function ($) {
						return $.remitToAddress;
					})),
			requiredReferences: function () {
				var _v1 = form(
					function ($) {
						return $.requiredReferences;
					});
				if (_v1.$ === 'Nothing') {
					return A3(
						$author$project$Components$SettingsPage$Shared$ReferenceTable$init,
						A2($elm$core$List$map, $author$project$Domain$ReferenceRule$fromPb, data.customerSettings.rulesBrokerRequiredReferences),
						$elm$core$Set$toList(data.allReferenceFieldLabels),
						form(
							function ($) {
								return $.requiredReferences;
							}));
				} else {
					var requiredReferences = _v1.a;
					return requiredReferences;
				}
			}(),
			statementInvoiceTemplate: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.customerSettings.statementCustomerInvoiceTemplateId,
				form(
					function ($) {
						return $.statementInvoiceTemplate;
					}))
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$currentFormState = F2(
	function (data, model) {
		return A2($author$project$Components$SettingsPage$CustomerLayout$mergeFormState, data, model);
	});
var $author$project$Components$SettingsPage$CustomerLayout$Contact_Response = F2(
	function (a, b) {
		return {$: 'Contact_Response', a: a, b: b};
	});
var $author$project$Components$SettingsPage$CustomerLayout$CustomExceptionMessagesUpdate = function (a) {
	return {$: 'CustomExceptionMessagesUpdate', a: a};
};
var $author$project$Components$SettingsPage$CustomerLayout$Delete = function (a) {
	return {$: 'Delete', a: a};
};
var $author$project$Components$SettingsPage$CustomerLayout$DocumentTypesUpdate = function (a) {
	return {$: 'DocumentTypesUpdate', a: a};
};
var $author$project$Components$SettingsPage$CustomerLayout$InvoiceTemplate = {$: 'InvoiceTemplate'};
var $author$project$Components$SettingsPage$CustomerLayout$MasterInvoiceTemplate = {$: 'MasterInvoiceTemplate'};
var $author$project$Components$SettingsPage$CustomerLayout$ReferencesUpdate = function (a) {
	return {$: 'ReferencesUpdate', a: a};
};
var $author$project$Components$SettingsPage$CustomerLayout$StatementInvoiceTemplate = {$: 'StatementInvoiceTemplate'};
var $author$project$Components$SettingsPage$CustomerLayout$BillingEmailUpdate = function (a) {
	return {$: 'BillingEmailUpdate', a: a};
};
var $author$project$Api$Customers$defaultUrl = function (id) {
	return '/api/customers/' + $elm$core$String$fromInt(
		$author$project$Domain$TmsCustomerId$toInt(id));
};
var $author$project$Api$Customers$defaultSend = F2(
	function (id, encodedSettings) {
		var encodedPayload = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('customer', encodedSettings)
				]));
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			$author$project$Api$Customers$defaultUrl(id),
			encodedPayload);
	});
var $author$project$Domain$EmailAddress$toString = function (_v0) {
	var str = _v0.a;
	return str;
};
var $author$project$Api$Customers$billingEmail = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'billing_email',
						$elm$json$Json$Encode$string(
							$author$project$Domain$EmailAddress$toString(data)))
					])));
	});
var $author$project$Components$SettingsPage$Shared$BillingEmail$ensureValid = function (str) {
	return $author$project$Domain$EmailAddress$isValidList(str) ? $elm$core$Result$Ok(
		$author$project$Domain$EmailAddress$fromString(str)) : $elm$core$Result$Err(str);
};
var $author$project$Components$SettingsPage$Shared$BillingEmail$formView = F5(
	function (tmsControlled, set, save, _v0, result) {
		if (result.$ === 'Ok') {
			var emailAddress = result.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('billingemail')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								tmsControlled ? 'Billing email address(es) controlled from TMS' : 'Billing email address(es), separated by comma')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('billingemail'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(
								$author$project$Domain$EmailAddress$toString(emailAddress)),
								$elm$html$Html$Attributes$disabled(tmsControlled),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$Shared$BillingEmail$ensureValid))
							]),
						_List_Nil),
						tmsControlled ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A3($author$project$Components$Shared$Button$confirm, 'Save Billing Email Address(es)', save, _List_Nil)
					]));
		} else {
			var invalid = result.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('billingemail')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Billing email address(es), separated by comma')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('billingemail'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(invalid),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$Shared$BillingEmail$ensureValid)),
								$elm$html$Html$Attributes$class('error')
							]),
						_List_Nil),
						A3(
						$elm$html$Html$node,
						'small',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('error')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Doesn\u0027t look like a list of valid email addresses')
							])),
						A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil)
					]));
		}
	});
var $author$project$Components$SettingsPage$Shared$BillingEmail$summaryView = function (result) {
	return $elm$html$Html$text(
		function () {
			if (result.$ === 'Ok') {
				var emailAddress = result.a;
				return $author$project$Domain$EmailAddress$toString(emailAddress);
			} else {
				var string = result.a;
				return string;
			}
		}());
};
var $author$project$Components$SettingsPage$CustomerLayout$validatingSend = function (apiRequest) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map(
			A2(
				$elm$core$Basics$composeR,
				apiRequest,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity))),
		$elm$core$Result$withDefault($author$project$HubTran$Effect$none));
};
var $author$project$Components$SettingsPage$CustomerLayout$billingEmailConfig = function (customerId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CustomerLayout$validatingSend(
			$author$project$Api$Customers$billingEmail(customerId)),
		formView: $author$project$Components$SettingsPage$Shared$BillingEmail$formView(false),
		summaryView: $author$project$Components$SettingsPage$Shared$BillingEmail$summaryView,
		title: 'Billing Email',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$BillingEmailUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$BillingIntervalUpdate = function (a) {
	return {$: 'BillingIntervalUpdate', a: a};
};
var $author$project$Domain$BillingInterval$encoded = function (interval) {
	return $author$project$AuditPb$billingIntervalToString(interval);
};
var $author$project$Api$Customers$billingInterval = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'billing_interval',
						$elm$json$Json$Encode$string(
							$author$project$Domain$BillingInterval$encoded(data)))
					])));
	});
var $author$project$Domain$BillingInterval$display = function (interval) {
	switch (interval.$) {
		case 'BillingIntervalDaily':
			return 'Daily';
		case 'BillingIntervalWeekly':
			return 'Weekly';
		case 'BillingIntervalMonthly':
			return 'Monthly';
		case 'BillingIntervalNever':
			return 'Never';
		default:
			return 'Immediately';
	}
};
var $author$project$Components$SettingsPage$Shared$BillingInterval$billingOption = F2(
	function (currentlySelected, interval) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Domain$BillingInterval$encoded(interval)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(currentlySelected, interval))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Domain$BillingInterval$display(interval))
				]));
	});
var $author$project$Domain$BillingInterval$decode = $author$project$AuditPb$billingIntervalDecoder;
var $author$project$Components$SettingsPage$Shared$BillingInterval$formView = F4(
	function (set, save, _v0, interval) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('billinginterval')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Billing Interval')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('billinginterval'),
							A2(
							$elm$html$Html$Events$on,
							'input',
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['target', 'value']),
								A2($elm$json$Json$Decode$map, set, $author$project$Domain$BillingInterval$decode)))
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$SettingsPage$Shared$BillingInterval$billingOption(interval),
						_List_fromArray(
							[$author$project$AuditPb$BillingIntervalDaily, $author$project$AuditPb$BillingIntervalWeekly, $author$project$AuditPb$BillingIntervalMonthly, $author$project$AuditPb$BillingIntervalNever]))),
					A3($author$project$Components$Shared$Button$confirm, 'Save Billing Interval', save, _List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$Shared$BillingInterval$summaryView = function (interval) {
	return $elm$html$Html$text(
		$author$project$Domain$BillingInterval$display(interval));
};
var $author$project$Components$SettingsPage$CustomerLayout$billingIntervalConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$billingInterval(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$BillingInterval$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$BillingInterval$summaryView,
		title: 'Billing Interval',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$BillingIntervalUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$contactMessage = F2(
	function (manner, context) {
		switch (context.$) {
			case 'Create':
				var name = context.a;
				return 'Contact “' + (name + ('” ' + (manner + ' created.')));
			case 'Update':
				var name = context.a;
				return 'Contact “' + (name + ('” ' + (manner + ' updated.')));
			default:
				var email = context.a;
				return email + (' ' + (manner + ' deleted.'));
		}
	});
var $author$project$AuditPb$CustomExceptionMessageTypeBilling = {$: 'CustomExceptionMessageTypeBilling'};
var $author$project$AuditPb$customExceptionMessageTypeToString = function (v) {
	if (v.$ === 'CustomExceptionMessageTypePayment') {
		return 'payment';
	} else {
		return 'billing';
	}
};
var $author$project$Domain$CustomExceptionMessage$billingType = $author$project$AuditPb$customExceptionMessageTypeToString($author$project$AuditPb$CustomExceptionMessageTypeBilling);
var $author$project$AuditPb$CustomExceptionMessageTypePayment = {$: 'CustomExceptionMessageTypePayment'};
var $author$project$Domain$CustomExceptionMessage$paymentType = $author$project$AuditPb$customExceptionMessageTypeToString($author$project$AuditPb$CustomExceptionMessageTypePayment);
var $author$project$Domain$CustomExceptionMessage$encode = function (_v0) {
	var typesSelection = _v0.typesSelection;
	var message = _v0.message;
	var typesAsList = function () {
		switch (typesSelection.$) {
			case 'Both':
				return _List_fromArray(
					[$author$project$Domain$CustomExceptionMessage$paymentType, $author$project$Domain$CustomExceptionMessage$billingType]);
			case 'Payment':
				return _List_fromArray(
					[$author$project$Domain$CustomExceptionMessage$paymentType]);
			case 'Billing':
				return _List_fromArray(
					[$author$project$Domain$CustomExceptionMessage$billingType]);
			default:
				return _List_Nil;
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'message',
				$elm$json$Json$Encode$string(message)),
				_Utils_Tuple2(
				'types',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, typesAsList))
			]));
};
var $author$project$Api$Customers$customExceptionMessages = F2(
	function (id, rules) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'rules_broker_custom_exception_messages',
						A2($elm$json$Json$Encode$list, $author$project$Domain$CustomExceptionMessage$encode, rules))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$CustomSubjectUpdate = function (a) {
	return {$: 'CustomSubjectUpdate', a: a};
};
var $author$project$Api$Customers$customSubject = F2(
	function (id, data) {
		var encodedPayload = $elm$core$String$isEmpty(data) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(data);
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('custom_subject_template', encodedPayload)
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$ensureValidTemplate = F3(
	function (customerSettings, accountSettings, str) {
		return A4($author$project$Components$SettingsPage$Shared$TemplateVariables$isValid, customerSettings.templateVariables, accountSettings.loadReferenceVariables, accountSettings.shipmentReferenceVariables, str) ? $elm$core$Result$Ok(str) : $elm$core$Result$Err(str);
	});
var $author$project$Components$SettingsPage$CustomerLayout$errorClass = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$Attributes$class,
	A2(
		$author$project$Helpers$Result$either,
		function (_v0) {
			return 'error';
		},
		function (_v1) {
			return '';
		}));
var $author$project$Components$SettingsPage$CustomerLayout$templateVariablesExample = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('delivery-method__template-variable-example-text')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Example')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Custom Subject: ')
								])),
							A2(
							$elm$html$Html$i,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice_for_Load_{load_id}')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Resulting Subject: ')
								])),
							A2(
							$elm$html$Html$i,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice_for_Load_123')
								]))
						]))
				])),
			A2($author$project$Components$SettingsPage$Shared$TemplateVariables$referenceInstructions, true, true)
		]));
var $author$project$Components$SettingsPage$CustomerLayout$customSubjectFormView = F6(
	function (customerSettings, accountSettings, set, save, _v0, result) {
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			10,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('customsubjecttemplate'),
							$author$project$Components$SettingsPage$CustomerLayout$errorClass(result)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Custom Subject Template (optional)')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('customsubjecttemplate'),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$value(
							A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result)),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								set,
								A2($author$project$Components$SettingsPage$CustomerLayout$ensureValidTemplate, customerSettings, accountSettings)))
						]),
					_List_Nil),
					A4($author$project$Components$SettingsPage$Shared$TemplateVariables$listView, $author$project$Components$SettingsPage$CustomerLayout$templateVariablesExample, customerSettings.templateVariables, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A3(
					$author$project$Helpers$Result$either,
					function (_v1) {
						return A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil);
					},
					function (_v2) {
						return A3($author$project$Components$Shared$Button$confirm, 'Save Custom Subject Template', save, _List_Nil);
					},
					result)
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$customSubjectSummaryView = function (result) {
	var _v0 = A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result);
	if (_v0 === '') {
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Add a custom subject line to email invoices for this customer.')
				]));
	} else {
		var template = _v0;
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(template)
				]));
	}
};
var $author$project$Components$SettingsPage$CustomerLayout$customSubjectConfig = F3(
	function (customerId, customerSettings, accountSettings) {
		return {
			apiRequest: $author$project$Components$SettingsPage$CustomerLayout$validatingSend(
				$author$project$Api$Customers$customSubject(customerId)),
			formView: A2($author$project$Components$SettingsPage$CustomerLayout$customSubjectFormView, customerSettings, accountSettings),
			summaryView: $author$project$Components$SettingsPage$CustomerLayout$customSubjectSummaryView,
			title: 'Custom Invoice Subject',
			toMsg: $author$project$Components$SettingsPage$CustomerLayout$CustomSubjectUpdate
		};
	});
var $author$project$Api$Customers$Contacts$baseUrl = function (id) {
	return '/api/customers/' + ($elm$core$String$fromInt(
		$author$project$Domain$TmsCustomerId$toInt(id)) + '/contacts');
};
var $author$project$Api$Customers$Contacts$contactUrl = F2(
	function (customerId, contactId) {
		return $author$project$Api$Customers$Contacts$baseUrl(customerId) + ('/' + $elm$core$String$fromInt(
			$author$project$Domain$ContactId$toInt(contactId)));
	});
var $author$project$Api$Customers$Contacts$delete = F2(
	function (customerId, contactId) {
		return $author$project$Helpers$Api$delete(
			A2($author$project$Api$Customers$Contacts$contactUrl, customerId, contactId));
	});
var $author$project$Components$SettingsPage$CustomerLayout$DeliveryMethodUpdate = function (a) {
	return {$: 'DeliveryMethodUpdate', a: a};
};
var $author$project$Encode$DeliveryMethodEncoder$deliveryMethod = F2(
	function (nestedFields, topLevelFields) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'delivery_method',
					$elm$json$Json$Encode$object(nestedFields)),
				topLevelFields));
	});
var $author$project$Encode$DeliveryMethodEncoder$emailType = function (emailPerInvoice) {
	if (emailPerInvoice.$ === 'Default') {
		return $elm$json$Json$Encode$string('email_account_default');
	} else {
		if (emailPerInvoice.a) {
			return $elm$json$Json$Encode$string('email_per_invoice');
		} else {
			return $elm$json$Json$Encode$string('email_single');
		}
	}
};
var $author$project$Encode$DeliveryMethodEncoder$linkOrAttachment = function (attachInvoices) {
	return attachInvoices ? $elm$json$Json$Encode$string('attachment') : $elm$json$Json$Encode$string('link');
};
var $author$project$Encode$DeliveryMethodEncoder$nullIfEmpty = function (value) {
	return $elm$core$String$isEmpty(value) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(value);
};
var $author$project$Encode$DeliveryMethodEncoder$choice = function (deliveryOptionChoice) {
	var _v0 = deliveryOptionChoice.deliveryMethod;
	if (_v0.$ === 'Email') {
		var billingEmailOverride = _v0.a.billingEmailOverride;
		var customInvoiceAttachmentFilename = _v0.a.customInvoiceAttachmentFilename;
		var attachInvoices = _v0.a.attachInvoices;
		var emailPerInvoice = _v0.a.emailPerInvoice;
		return A2(
			$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$author$project$Encode$DeliveryMethodEncoder$emailType(emailPerInvoice)),
					_Utils_Tuple2(
					'link_or_attachment',
					$author$project$Encode$DeliveryMethodEncoder$linkOrAttachment(attachInvoices)),
					_Utils_Tuple2(
					'billing_email_override',
					$author$project$Encode$DeliveryMethodEncoder$nullIfEmpty(billingEmailOverride))
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'field_regexp',
					$elm$json$Json$Encode$string(deliveryOptionChoice.regexPattern)),
					_Utils_Tuple2(
					'custom_invoice_attachment_filename',
					$author$project$Encode$DeliveryMethodEncoder$nullIfEmpty(customInvoiceAttachmentFilename))
				]));
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Domain$DeliveryMethod$ftpProtocolTypeToString = function (protocolType) {
	if (protocolType.$ === 'BasicFtp') {
		return 'ftp';
	} else {
		return 'sftp';
	}
};
var $author$project$Encode$DeliveryMethodEncoder$encodeDeliveryMethod = function (data) {
	switch (data.$) {
		case 'Email':
			var billingEmailOverride = data.a.billingEmailOverride;
			var customInvoiceAttachmentFilename = data.a.customInvoiceAttachmentFilename;
			var attachInvoices = data.a.attachInvoices;
			var emailPerInvoice = data.a.emailPerInvoice;
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$author$project$Encode$DeliveryMethodEncoder$emailType(emailPerInvoice)),
						_Utils_Tuple2(
						'link_or_attachment',
						$author$project$Encode$DeliveryMethodEncoder$linkOrAttachment(attachInvoices)),
						_Utils_Tuple2(
						'billing_email_override',
						$author$project$Encode$DeliveryMethodEncoder$nullIfEmpty(billingEmailOverride))
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'custom_invoice_attachment_filename',
						$author$project$Encode$DeliveryMethodEncoder$nullIfEmpty(customInvoiceAttachmentFilename))
					]));
		case 'Print':
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('print'))
					]),
				_List_Nil);
		case 'BackupOnly':
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('backup_only'))
					]),
				_List_Nil);
		case 'PaymentsNetwork':
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('payments_network'))
					]),
				_List_Nil);
		case 'TpayApi':
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('tpay_api'))
					]),
				_List_Nil);
		case 'Multiple':
			var multipleDetails = data.a;
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('multiple')),
						_Utils_Tuple2(
						'choices',
						A2($elm$json$Json$Encode$list, $author$project$Encode$DeliveryMethodEncoder$choice, multipleDetails.choices)),
						_Utils_Tuple2(
						'field',
						$elm$json$Json$Encode$string('load_id'))
					]),
				_List_Nil);
		case 'PaymentsNetworkMultiple':
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('multiple'))
					]),
				_List_Nil);
		case 'Ftp':
			var template = data.a.a;
			var rootDirectory = data.b.rootDirectory;
			var ftpPort = data.b.ftpPort;
			var host = data.b.host;
			var password = data.b.password;
			var username = data.b.username;
			var protocolType = data.c;
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('ftp')),
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(username)),
						_Utils_Tuple2(
						'password',
						$elm$json$Json$Encode$string(password)),
						_Utils_Tuple2(
						'host',
						$elm$json$Json$Encode$string(host)),
						_Utils_Tuple2(
						'port',
						$elm$json$Json$Encode$string(ftpPort)),
						_Utils_Tuple2(
						'root_directory',
						$author$project$Encode$DeliveryMethodEncoder$nullIfEmpty(rootDirectory)),
						_Utils_Tuple2(
						'protocol_type',
						$elm$json$Json$Encode$string(
							$author$project$Domain$DeliveryMethod$ftpProtocolTypeToString(protocolType)))
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'customer_invoicing_ftp_name_template',
						$author$project$Encode$DeliveryMethodEncoder$nullIfEmpty(template))
					]));
		case 'UploadCass':
			var account = data.a.account;
			var password = data.a.password;
			var username = data.a.username;
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('fpa_upload_cass')),
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(username)),
						_Utils_Tuple2(
						'password',
						$elm$json$Json$Encode$string(password)),
						_Utils_Tuple2(
						'account',
						$elm$json$Json$Encode$string(account))
					]),
				_List_Nil);
		default:
			var externalEmailRecipients = data.a.externalEmailRecipients;
			var externalDeliveryMethod = data.a.externalDeliveryMethod;
			return A2(
				$author$project$Encode$DeliveryMethodEncoder$deliveryMethod,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('other')),
						_Utils_Tuple2(
						'external_delivery_method',
						$elm$json$Json$Encode$string(externalDeliveryMethod)),
						_Utils_Tuple2(
						'external_email_recipients',
						$elm$json$Json$Encode$string(externalEmailRecipients))
					]),
				_List_Nil);
	}
};
var $author$project$Api$Customers$deliveryMethod = function (id) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Api$Customers$defaultSend(id),
		$author$project$Encode$DeliveryMethodEncoder$encodeDeliveryMethod);
};
var $author$project$Ui$V2$Badge$AlertStyle = {$: 'AlertStyle'};
var $author$project$Ui$V2$Badge$StyleAttribute = function (a) {
	return {$: 'StyleAttribute', a: a};
};
var $author$project$Ui$V2$Badge$alert = $author$project$Ui$V2$Badge$StyleAttribute($author$project$Ui$V2$Badge$AlertStyle);
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$canAutoSend = F2(
	function (accountSettings, value) {
		switch (value.$) {
			case 'Email':
				var pref = value.a;
				var _v1 = pref.emailPerInvoice;
				if (_v1.$ === 'Overridden') {
					var overridden = _v1.a;
					return overridden;
				} else {
					return accountSettings.defaultEmailPerInvoice;
				}
			case 'Print':
				return false;
			default:
				return true;
		}
	});
var $author$project$Helpers$Html$showIf = F2(
	function (flag, view_) {
		return flag ? view_ : $author$project$Helpers$Html$empty;
	});
var $author$project$Ui$V2$Badge$badgeStyleClass = function (badgeStyle) {
	switch (badgeStyle.$) {
		case 'DefaultStyle':
			return 'default';
		case 'ErrorStyle':
			return 'error';
		case 'InfoStyle':
			return 'info';
		case 'AlertStyle':
			return 'alert';
		case 'SuccessStyle':
			return 'success';
		default:
			return 'disabled';
	}
};
var $author$project$Ui$V2$Badge$DefaultStyle = {$: 'DefaultStyle'};
var $author$project$Ui$V2$Badge$defaultAttributes = {style: $author$project$Ui$V2$Badge$DefaultStyle};
var $author$project$Ui$V2$Badge$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			var style = a.a;
			return _Utils_update(
				acc,
				{style: style});
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V2$Badge$defaultAttributes, attributes);
};
var $author$project$Ui$V2$Badge$view = F2(
	function (attributes, text) {
		var computedAttributes = $author$project$Ui$V2$Badge$computeAttributes(attributes);
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v2__badge'),
					$elm$html$Html$Attributes$class(
					'v2__badge--' + $author$project$Ui$V2$Badge$badgeStyleClass(computedAttributes.style))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text)
				]));
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$autoSendBadge = F3(
	function (isFactor, accountSettings, value) {
		var shouldShow = isFactor && accountSettings.factorAutoSendInvoices;
		var _v0 = A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$canAutoSend, accountSettings, value) ? _Utils_Tuple2(_List_Nil, 'enabled') : _Utils_Tuple2(
			_List_fromArray(
				[$author$project$Ui$V2$Badge$alert]),
			'disabled');
		var attrs = _v0.a;
		var verb = _v0.b;
		var content = 'Auto-sending ' + (verb + ' based off current delivery method');
		return A2(
			$author$project$Helpers$Html$showIf,
			shouldShow,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('delivery-method__auto-send-badge')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V2$Badge$view, attrs, content)
					])));
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldNoHint = F4(
	function (unique, description, setter, attributes) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(unique)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					])),
				A2(
				$elm$html$Html$input,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onInput(setter),
					attributes),
				_List_Nil)
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldView = F4(
	function (unique, description, setter, attributes) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(unique)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					])),
				A2(
				$elm$html$Html$small,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('case-sensitive')
					])),
				A2(
				$elm$html$Html$input,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onInput(setter),
					attributes),
				_List_Nil)
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$newEmail = $author$project$Domain$DeliveryMethod$Email(
	{attachInvoices: false, billingEmailOverride: '', customInvoiceAttachmentFilename: '', emailPerInvoice: $author$project$Domain$DeliveryMethod$Default});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$newFtp = A3(
	$author$project$Domain$DeliveryMethod$Ftp,
	$author$project$Domain$DeliveryMethod$FtpFilename(''),
	{ftpPort: '', host: '', password: '', rootDirectory: '', username: ''},
	$author$project$Domain$DeliveryMethod$BasicFtp);
var $author$project$Domain$DeliveryMethod$schneiderChoices = _List_fromArray(
	[
		{
		deliveryMethod: $author$project$Domain$DeliveryMethod$Email(
			{
				attachInvoices: true,
				billingEmailOverride: 'submit@invoice.schneider.com',
				customInvoiceAttachmentFilename: '',
				emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(true)
			}),
		regexPattern: '^0*40'
	},
		{
		deliveryMethod: $author$project$Domain$DeliveryMethod$Email(
			{
				attachInvoices: true,
				billingEmailOverride: 'carrierpayables@schneider.com',
				customInvoiceAttachmentFilename: '',
				emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(true)
			}),
		regexPattern: '^0*[Ss][Ii]'
	},
		{
		deliveryMethod: $author$project$Domain$DeliveryMethod$Email(
			{
				attachInvoices: true,
				billingEmailOverride: 'schneiderpay@e-transflo.com',
				customInvoiceAttachmentFilename: '',
				emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(true)
			}),
		regexPattern: '^0*[Ss][Ll]'
	},
		{
		deliveryMethod: $author$project$Domain$DeliveryMethod$Email(
			{
				attachInvoices: true,
				billingEmailOverride: 'submit@invoice.schneider.com',
				customInvoiceAttachmentFilename: '',
				emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(true)
			}),
		regexPattern: '^0*[Ss][Tt]'
	},
		{
		deliveryMethod: $author$project$Domain$DeliveryMethod$Email(
			{
				attachInvoices: true,
				billingEmailOverride: 'carrierpayables@schneider.com',
				customInvoiceAttachmentFilename: '',
				emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(true)
			}),
		regexPattern: '.*'
	}
	]);
var $author$project$Domain$DeliveryMethod$schneiderDefaultMultiple = $author$project$Domain$DeliveryMethod$Multiple(
	{choices: $author$project$Domain$DeliveryMethod$schneiderChoices});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$newMultiple = $author$project$Domain$DeliveryMethod$schneiderDefaultMultiple;
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$newUploadCass = $author$project$Domain$DeliveryMethod$UploadCass(
	{account: '', password: '', username: ''});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$option = F5(
	function (enabled, unique, description, selected, onClickMsg) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$name('delivery_method'),
							$elm$html$Html$Attributes$id(unique),
							$elm$html$Html$Attributes$disabled(!enabled),
							selected ? $elm$html$Html$Attributes$checked(true) : $elm$html$Html$Events$onClick(onClickMsg)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(unique)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(description)
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$showPaymentsNetworkOption = F2(
	function (config, model) {
		var isPaymentsNetworkMultiple = function () {
			if (model.$ === 'PaymentsNetworkMultiple') {
				return true;
			} else {
				return false;
			}
		}();
		var view = function () {
			var _v0 = config.currentDeliveryMethod;
			if (_v0.$ === 'PaymentsNetworkMultiple') {
				var details = _v0.a;
				return A5(
					$author$project$Components$SettingsPage$Shared$DeliveryMethod$option,
					config.enableChangingType,
					'payments_network_multiple',
					'Payments Network (Multiple)',
					isPaymentsNetworkMultiple,
					$author$project$Domain$DeliveryMethod$PaymentsNetworkMultiple(details));
			} else {
				return A5(
					$author$project$Components$SettingsPage$Shared$DeliveryMethod$option,
					config.enableChangingType,
					'payments_network',
					'Payments Network',
					_Utils_eq(model, $author$project$Domain$DeliveryMethod$PaymentsNetwork),
					$author$project$Domain$DeliveryMethod$PaymentsNetwork);
			}
		}();
		return A2($author$project$Helpers$Html$showIf, config.isFactor, view);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView = F2(
	function (config, model) {
		var isMultiple = function () {
			if (model.$ === 'Multiple') {
				return true;
			} else {
				return false;
			}
		}();
		var isFtp = function () {
			if (model.$ === 'Ftp') {
				return true;
			} else {
				return false;
			}
		}();
		var isEmail = function () {
			if (model.$ === 'Email') {
				return true;
			} else {
				return false;
			}
		}();
		var isCass = function () {
			if (model.$ === 'UploadCass') {
				return true;
			} else {
				return false;
			}
		}();
		var existingMultiple = function () {
			var _v0 = config.currentDeliveryMethod;
			if (_v0.$ === 'Multiple') {
				var details = _v0.a;
				return $author$project$Domain$DeliveryMethod$Multiple(details);
			} else {
				return $author$project$Components$SettingsPage$Shared$DeliveryMethod$newMultiple;
			}
		}();
		return _List_fromArray(
			[
				A5($author$project$Components$SettingsPage$Shared$DeliveryMethod$option, config.enableChangingType, 'email', 'Email', isEmail, $author$project$Components$SettingsPage$Shared$DeliveryMethod$newEmail),
				A5(
				$author$project$Components$SettingsPage$Shared$DeliveryMethod$option,
				config.enableChangingType,
				'print',
				'Print',
				_Utils_eq(model, $author$project$Domain$DeliveryMethod$Print),
				$author$project$Domain$DeliveryMethod$Print),
				A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$showPaymentsNetworkOption, config, model),
				A2(
				$author$project$Helpers$Html$showIf,
				config.isFactor,
				A5($author$project$Components$SettingsPage$Shared$DeliveryMethod$option, config.enableChangingType, 'multiple', 'Multiple', isMultiple, existingMultiple)),
				A5($author$project$Components$SettingsPage$Shared$DeliveryMethod$option, config.enableChangingType, 'ftp', 'FTP/SFTP', isFtp, $author$project$Components$SettingsPage$Shared$DeliveryMethod$newFtp),
				A5($author$project$Components$SettingsPage$Shared$DeliveryMethod$option, config.enableChangingType, 'uploadcass', 'FPA Upload (Cass)', isCass, $author$project$Components$SettingsPage$Shared$DeliveryMethod$newUploadCass)
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$accountDefaultGrouping = function (accountSettings) {
	return accountSettings.defaultEmailPerInvoice ? 'one invoice per email' : 'single email for all sent invoices';
};
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$displayDeliveryOptionChoice = F2(
	function (settings, choice) {
		var _v0 = choice.deliveryMethod;
		switch (_v0.$) {
			case 'PaymentsNetwork':
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(choice.regexPattern)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Payments Network')
								]))
						]));
			case 'Email':
				var preferences = _v0.a;
				var grouping = function () {
					var _v1 = preferences.emailPerInvoice;
					if (_v1.$ === 'Default') {
						return 'account default (' + ($author$project$Components$SettingsPage$Shared$DeliveryMethod$accountDefaultGrouping(settings) + ')');
					} else {
						if (_v1.a) {
							return 'one invoice per email';
						} else {
							return 'single email for all sent invoices';
						}
					}
				}();
				var format = preferences.attachInvoices ? 'Attachment' : 'Download Link';
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(choice.regexPattern)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Email')
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(grouping)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(format)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(preferences.billingEmailOverride)
								]))
						]));
			default:
				return $author$project$Helpers$Html$empty;
		}
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$multipleDeliveryHeaders = A2(
	$elm$html$Html$thead,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Matching Pattern')
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Delivery Type')
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice Grouping')
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Link or Attachment')
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Billing Override Email Address')
						]))
				]))
		]));
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$displayMultipleDetails = F2(
	function (settings, deliveryOptionDetails) {
		return $elm$core$List$isEmpty(deliveryOptionDetails.choices) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__info-table')
					]),
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$Shared$DeliveryMethod$multipleDeliveryHeaders,
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Components$SettingsPage$Shared$DeliveryMethod$displayDeliveryOptionChoice(settings),
							deliveryOptionDetails.choices))
					]))
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$emailAttachInvoicesRow = function (preferences) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('radio'),
					$elm$html$Html$Attributes$name('email_media'),
					$elm$html$Html$Attributes$id('downloadlink'),
					$elm$html$Html$Attributes$checked(!preferences.attachInvoices),
					$elm$html$Html$Events$onClick(
					$author$project$Domain$DeliveryMethod$Email(
						_Utils_update(
							preferences,
							{attachInvoices: false})))
				]),
			_List_Nil),
			A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$for('downloadlink')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Download Link')
				])),
			A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('radio'),
					$elm$html$Html$Attributes$name('email_media'),
					$elm$html$Html$Attributes$id('attachment'),
					$elm$html$Html$Attributes$checked(preferences.attachInvoices),
					$elm$html$Html$Events$onClick(
					$author$project$Domain$DeliveryMethod$Email(
						_Utils_update(
							preferences,
							{attachInvoices: true})))
				]),
			_List_Nil),
			A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$for('attachment')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Attachment')
				]))
		]);
};
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$errorClass = function (isError) {
	return isError ? $elm$html$Html$Attributes$class('error') : $elm$html$Html$Attributes$class('');
};
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$rowCollapse = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('row collapse')
		]));
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$templateVariablesExample = function (isFactor) {
	var referenceText = isFactor ? $elm$html$Html$text('') : A2($author$project$Components$SettingsPage$Shared$TemplateVariables$referenceInstructions, true, true);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('delivery-method__template-variable-example-text')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Example')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Template: ')
									])),
								A2(
								$elm$html$Html$i,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Invoice_for_Load_{load_id}')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Resulting File Name: ')
									])),
								A2(
								$elm$html$Html$i,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Invoice_for_Load_123.pdf')
									]))
							]))
					])),
				referenceText
			]));
};
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$templateFilenameInputRow = function (config) {
	return _List_fromArray(
		[
			$author$project$Components$SettingsPage$Shared$DeliveryMethod$rowCollapse(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(config.id),
							$author$project$Components$SettingsPage$Shared$DeliveryMethod$errorClass(
							!A4($author$project$Components$SettingsPage$Shared$TemplateVariables$isValid, config.variables, config.settings.loadReferenceVariables, config.settings.shipmentReferenceVariables, config.value))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(config.name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-8 medium-9 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$id(config.id),
									$elm$html$Html$Attributes$value(config.value),
									$elm$html$Html$Events$onInput(config.onInput)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-2 medium-1 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('postfix')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('.pdf')
								]))
						]))
				])),
			$author$project$Components$SettingsPage$Shared$DeliveryMethod$rowCollapse(
			_List_fromArray(
				[
					A4(
					$author$project$Components$SettingsPage$Shared$TemplateVariables$listView,
					$author$project$Components$SettingsPage$Shared$DeliveryMethod$templateVariablesExample(config.isFactor),
					config.variables,
					_List_Nil,
					_List_Nil)
				]))
		]);
};
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$emailFilenameRow = F3(
	function (isFactor, config, preferences) {
		return ((!preferences.attachInvoices) || isFactor) ? _List_Nil : $author$project$Components$SettingsPage$Shared$DeliveryMethod$templateFilenameInputRow(
			{
				id: 'attachmentname',
				isFactor: config.isFactor,
				name: 'Custom filename for attachment (optional)',
				onInput: function (s) {
					return $author$project$Domain$DeliveryMethod$Email(
						_Utils_update(
							preferences,
							{customInvoiceAttachmentFilename: s}));
				},
				settings: config.accountSettings,
				value: preferences.customInvoiceAttachmentFilename,
				variables: config.templateVariables
			});
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$emailPerInvoiceRow = F2(
	function (accountSettings, preferences) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-12 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$name('email_amount'),
										$elm$html$Html$Attributes$id('oneperemail'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(
											preferences.emailPerInvoice,
											$author$project$Domain$DeliveryMethod$Overridden(true))),
										$elm$html$Html$Events$onClick(
										$author$project$Domain$DeliveryMethod$Email(
											_Utils_update(
												preferences,
												{
													emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(true)
												})))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('oneperemail')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('One invoice per email')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-12 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$name('email_amount'),
										$elm$html$Html$Attributes$id('allinoneemail'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(
											preferences.emailPerInvoice,
											$author$project$Domain$DeliveryMethod$Overridden(false))),
										$elm$html$Html$Events$onClick(
										$author$project$Domain$DeliveryMethod$Email(
											_Utils_update(
												preferences,
												{
													emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(false)
												})))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('allinoneemail')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('All invoices in single email')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-12 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$name('email_amount'),
										$elm$html$Html$Attributes$id('useaccountdefault'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(preferences.emailPerInvoice, $author$project$Domain$DeliveryMethod$Default)),
										$elm$html$Html$Events$onClick(
										$author$project$Domain$DeliveryMethod$Email(
											_Utils_update(
												preferences,
												{emailPerInvoice: $author$project$Domain$DeliveryMethod$Default})))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('useaccountdefault')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Use Account Default (' + ($author$project$Components$SettingsPage$Shared$DeliveryMethod$accountDefaultGrouping(accountSettings) + ')'))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$ftpProtocolTypeView = F2(
	function (value, setter) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('radio'),
						$elm$html$Html$Attributes$name('ftp_protocol'),
						$elm$html$Html$Attributes$id('ftp'),
						$elm$html$Html$Attributes$checked(
						_Utils_eq(value, $author$project$Domain$DeliveryMethod$BasicFtp)),
						$elm$html$Html$Events$onClick(
						setter($author$project$Domain$DeliveryMethod$BasicFtp))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('ftp')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('FTP')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('radio'),
						$elm$html$Html$Attributes$name('ftp_protocol'),
						$elm$html$Html$Attributes$id('sftp'),
						$elm$html$Html$Attributes$checked(
						_Utils_eq(value, $author$project$Domain$DeliveryMethod$SecureSftp)),
						$elm$html$Html$Events$onClick(
						setter($author$project$Domain$DeliveryMethod$SecureSftp))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('sftp')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('SFTP')
					]))
			]);
	});
var $author$project$Domain$DeliveryMethod$Custom = {$: 'Custom'};
var $author$project$Domain$DeliveryMethod$Schneider = {$: 'Schneider'};
var $author$project$Domain$DeliveryMethod$fromString = function (raw) {
	return (raw === 'Schneider') ? $elm$core$Maybe$Just($author$project$Domain$DeliveryMethod$Schneider) : ((raw === 'Custom') ? $elm$core$Maybe$Just($author$project$Domain$DeliveryMethod$Custom) : $elm$core$Maybe$Nothing);
};
var $author$project$Domain$DeliveryMethod$decodeMultipleType = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Domain$DeliveryMethod$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('looking for a type')))),
	$elm$json$Json$Decode$string);
var $author$project$Domain$DeliveryMethod$isSchneider = function (details) {
	return _Utils_eq(details.choices, $author$project$Domain$DeliveryMethod$schneiderChoices);
};
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$setMultiple = F2(
	function (currentDetails, multipleType) {
		if (multipleType.$ === 'Schneider') {
			return $author$project$Components$SettingsPage$Shared$DeliveryMethod$newMultiple;
		} else {
			return $author$project$Domain$DeliveryMethod$Multiple(currentDetails);
		}
	});
var $author$project$Domain$DeliveryMethod$multipleTypeToString = function (multipleType) {
	if (multipleType.$ === 'Schneider') {
		return 'Schneider';
	} else {
		return 'Custom';
	}
};
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$viewMultipleOption = F3(
	function (multipleType, details, isDisabled) {
		var mapSelected = function () {
			if (multipleType.$ === 'Schneider') {
				return $author$project$Domain$DeliveryMethod$isSchneider(details);
			} else {
				return !$author$project$Domain$DeliveryMethod$isSchneider(details);
			}
		}();
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Domain$DeliveryMethod$multipleTypeToString(multipleType)),
					$elm$html$Html$Attributes$selected(mapSelected),
					$elm$html$Html$Attributes$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Domain$DeliveryMethod$multipleTypeToString(multipleType))
				]));
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$setMultipleType = F2(
	function (deliveryOptionDetails, currentDeliveryMethod) {
		var disableCustom = function () {
			if (currentDeliveryMethod.$ === 'Multiple') {
				var details = currentDeliveryMethod.a;
				return $author$project$Domain$DeliveryMethod$isSchneider(details);
			} else {
				return true;
			}
		}();
		var currentDetails = function () {
			if (currentDeliveryMethod.$ === 'Multiple') {
				var details = currentDeliveryMethod.a;
				return details;
			} else {
				return {choices: _List_Nil};
			}
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Multiple Type'),
								A2(
								$elm$html$Html$select,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$Events$on,
										'change',
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['target', 'value']),
											A2(
												$elm$json$Json$Decode$map,
												$author$project$Components$SettingsPage$Shared$DeliveryMethod$setMultiple(currentDetails),
												$author$project$Domain$DeliveryMethod$decodeMultipleType)))
									]),
								_List_fromArray(
									[
										A3($author$project$Components$SettingsPage$Shared$DeliveryMethod$viewMultipleOption, $author$project$Domain$DeliveryMethod$Schneider, deliveryOptionDetails, false),
										A3($author$project$Components$SettingsPage$Shared$DeliveryMethod$viewMultipleOption, $author$project$Domain$DeliveryMethod$Custom, deliveryOptionDetails, disableCustom)
									]))
							]))
					]))
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$radioOptionsView = F2(
	function (config, currentValue) {
		var manageInTmsLabel = function (message) {
			return (!config.enableChangingType) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('managedintms')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]) : _List_Nil;
		};
		var delivery = {
			account: A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldView, 'account', 'Account name'),
			ftpPort: A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldNoHint, 'port', 'Port (optional)'),
			host: A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldView, 'hostname', 'Host'),
			password: A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldView, 'password', 'Password'),
			rootDirectory: A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldView, 'rootdirectory', 'Root directory (optional)'),
			username: A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldView, 'username', 'Username')
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Components$Shared$Grid$column(10),
				function () {
					switch (currentValue.$) {
						case 'Email':
							var preferences = currentValue.a;
							return _List_fromArray(
								[
									manageInTmsLabel('All settings except link vs attachment are managed directly in the TMS.'),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue),
									$author$project$Components$SettingsPage$Shared$DeliveryMethod$emailAttachInvoicesRow(preferences),
									A3($author$project$Components$SettingsPage$Shared$DeliveryMethod$emailFilenameRow, config.isFactor, config, preferences),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$emailPerInvoiceRow, config.accountSettings, preferences)
								]);
						case 'Print':
							return _List_fromArray(
								[
									manageInTmsLabel('Settings are managed directly in the TMS.'),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue)
								]);
						case 'BackupOnly':
							return _List_fromArray(
								[
									manageInTmsLabel('Settings are managed directly in the TMS.'),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue)
								]);
						case 'TpayApi':
							return _List_fromArray(
								[
									manageInTmsLabel('Settings are managed directly in the TMS.'),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue)
								]);
						case 'PaymentsNetwork':
							return _List_fromArray(
								[
									manageInTmsLabel('Settings are managed directly in the TMS.'),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue)
								]);
						case 'Multiple':
							var multipleDetails = currentValue.a;
							return _List_fromArray(
								[
									manageInTmsLabel('Settings are managed directly in the TMS.'),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$setMultipleType, multipleDetails, config.currentDeliveryMethod),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$displayMultipleDetails, config.accountSettings, multipleDetails)
								]);
						case 'PaymentsNetworkMultiple':
							var multipleDetails = currentValue.a;
							return _List_fromArray(
								[
									manageInTmsLabel('Settings are managed directly in the TMS.'),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue),
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$displayMultipleDetails, config.accountSettings, multipleDetails)
								]);
						case 'Ftp':
							var filename = currentValue.a;
							var template = filename.a;
							var credentials = currentValue.b;
							var protocolType = currentValue.c;
							return _List_fromArray(
								[
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue),
									A2(
									delivery.username,
									function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{username: s}),
											protocolType);
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(credentials.username)
										])),
									A2(
									delivery.password,
									function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{password: s}),
											protocolType);
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('password'),
											$elm$html$Html$Attributes$value(credentials.password)
										])),
									A2(
									delivery.host,
									function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{host: s}),
											protocolType);
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(credentials.host)
										])),
									A2(
									delivery.ftpPort,
									function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{ftpPort: s}),
											protocolType);
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(credentials.ftpPort)
										])),
									A2(
									$author$project$Components$SettingsPage$Shared$DeliveryMethod$ftpProtocolTypeView,
									protocolType,
									function (s) {
										return A3($author$project$Domain$DeliveryMethod$Ftp, filename, credentials, s);
									}),
									A2(
									delivery.rootDirectory,
									function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{rootDirectory: s}),
											protocolType);
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(credentials.rootDirectory)
										])),
									A2(
									$elm$core$List$cons,
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									$author$project$Components$SettingsPage$Shared$DeliveryMethod$templateFilenameInputRow(
										{
											id: 'ftpcustomname',
											isFactor: config.isFactor,
											name: 'Custom filename (optional)',
											onInput: function (s) {
												return A3(
													$author$project$Domain$DeliveryMethod$Ftp,
													$author$project$Domain$DeliveryMethod$FtpFilename(s),
													credentials,
													protocolType);
											},
											settings: config.accountSettings,
											value: template,
											variables: config.templateVariables
										}))
								]);
						case 'UploadCass':
							var credentials = currentValue.a;
							return _List_fromArray(
								[
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue),
									A2(
									delivery.username,
									function (s) {
										return $author$project$Domain$DeliveryMethod$UploadCass(
											_Utils_update(
												credentials,
												{username: s}));
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(credentials.username)
										])),
									A2(
									delivery.password,
									function (s) {
										return $author$project$Domain$DeliveryMethod$UploadCass(
											_Utils_update(
												credentials,
												{password: s}));
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('password'),
											$elm$html$Html$Attributes$value(credentials.password)
										])),
									A2(
									delivery.account,
									function (s) {
										return $author$project$Domain$DeliveryMethod$UploadCass(
											_Utils_update(
												credentials,
												{account: s}));
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(credentials.account)
										]))
								]);
						default:
							var otherSettings = currentValue.a;
							return _List_fromArray(
								[
									A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsView, config, currentValue),
									A4(
									$author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldView,
									'externalDeliveryMethod',
									'External Delivery Method',
									function (s) {
										return $author$project$Domain$DeliveryMethod$Other(
											_Utils_update(
												otherSettings,
												{externalDeliveryMethod: s}));
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(otherSettings.externalDeliveryMethod)
										])),
									A4(
									$author$project$Components$SettingsPage$Shared$DeliveryMethod$credentialFieldView,
									'externalEmailRecipients',
									'External Email Recipients',
									function (s) {
										return $author$project$Domain$DeliveryMethod$Other(
											_Utils_update(
												otherSettings,
												{externalEmailRecipients: s}));
									},
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(otherSettings.externalEmailRecipients)
										]))
								]);
					}
				}()));
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$saveButton = F4(
	function (_v0, model, config, saveAction) {
		var isMissing = A2($elm$core$Basics$composeL, $elm$core$String$isEmpty, $elm$core$String$trim);
		var _v1 = function () {
			switch (model.$) {
				case 'Email':
					var preferences = model.a;
					return _Utils_Tuple2(
						(!preferences.attachInvoices) || A4($author$project$Components$SettingsPage$Shared$TemplateVariables$isValid, config.templateVariables, config.accountSettings.loadReferenceVariables, config.accountSettings.shipmentReferenceVariables, preferences.customInvoiceAttachmentFilename),
						'Fix Errors To Save');
				case 'Print':
					return _Utils_Tuple2(true, '');
				case 'PaymentsNetwork':
					return _Utils_Tuple2(false, 'Must be changed by support');
				case 'Multiple':
					return _Utils_Tuple2(true, '');
				case 'PaymentsNetworkMultiple':
					return _Utils_Tuple2(false, 'Must be changed by support');
				case 'Ftp':
					var credentials = model.b;
					return _Utils_Tuple2(
						_Utils_eq(
							A2(
								$elm$core$List$filter,
								isMissing,
								_List_fromArray(
									[credentials.username, credentials.password, credentials.host])),
							_List_Nil),
						'Enter Missing Fields To Save');
				case 'UploadCass':
					var credentials = model.a;
					return _Utils_Tuple2(
						_Utils_eq(
							A2(
								$elm$core$List$filter,
								isMissing,
								_List_fromArray(
									[credentials.username, credentials.password, credentials.account])),
							_List_Nil),
						'Enter Missing Field To Save');
				case 'BackupOnly':
					return _Utils_Tuple2(false, 'Must be changed by support');
				case 'TpayApi':
					return _Utils_Tuple2(false, 'Must be changed by support');
				default:
					return _Utils_Tuple2(true, '');
			}
		}();
		var allowSave = _v1.a;
		var disabledText = _v1.b;
		return allowSave ? A3($author$project$Components$Shared$Button$confirm, 'Save Invoice Delivery Method', saveAction, _List_Nil) : A2($author$project$Components$Shared$Button$disabled, disabledText, _List_Nil);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$formView = F5(
	function (config, set, save, saving, value) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Components$SettingsPage$Shared$DeliveryMethod$autoSendBadge, config.isFactor, config.accountSettings, value),
					A2(
					$elm$html$Html$map,
					set,
					A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$radioOptionsView, config, value)),
					A4($author$project$Components$SettingsPage$Shared$DeliveryMethod$saveButton, saving, value, config, save)
				]));
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$summaryView = F3(
	function (_v0, accountSettings, value) {
		var isFactor = _v0.isFactor;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Components$SettingsPage$Shared$DeliveryMethod$autoSendBadge, isFactor, accountSettings, value),
					$elm$html$Html$text(
					function () {
						switch (value.$) {
							case 'Email':
								var preferences = value.a;
								var grouping = function () {
									var _v2 = preferences.emailPerInvoice;
									if (_v2.$ === 'Default') {
										return 'account default (' + ($author$project$Components$SettingsPage$Shared$DeliveryMethod$accountDefaultGrouping(accountSettings) + ')');
									} else {
										if (_v2.a) {
											return 'one invoice per email';
										} else {
											return 'single email for all sent invoices';
										}
									}
								}();
								var format = preferences.attachInvoices ? 'Attachment' : 'Download Link';
								return 'Email + ' + (format + (', ' + grouping));
							case 'Print':
								return 'Print';
							case 'PaymentsNetwork':
								return 'Payments Network';
							case 'Multiple':
								return 'Multiple';
							case 'PaymentsNetworkMultiple':
								return 'Payments Network (Multiple)';
							case 'Ftp':
								var protocolType = value.c;
								return $elm$core$String$toUpper(
									$author$project$Domain$DeliveryMethod$ftpProtocolTypeToString(protocolType));
							case 'UploadCass':
								return 'FPA Upload (Cass)';
							case 'BackupOnly':
								return 'Backup Only';
							case 'TpayApi':
								return 'TriumphPay API';
							default:
								return 'Other';
						}
					}())
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$deliveryMethodConfig = F2(
	function (customerId, data) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Customers$deliveryMethod(customerId),
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
			formView: $author$project$Components$SettingsPage$Shared$DeliveryMethod$formView(
				{
					accountSettings: data.accountSettings,
					currentDeliveryMethod: $author$project$Domain$DeliveryMethodFromPb$fromPb(data.customerSettings.deliveryMethod.method),
					enableChangingType: !data.accountSettings.controlledByTMS.deliveryMethod,
					isFactor: false,
					templateVariables: data.customerSettings.templateVariables
				}),
			summaryView: A2(
				$author$project$Components$SettingsPage$Shared$DeliveryMethod$summaryView,
				{isFactor: false},
				data.accountSettings),
			title: 'Send invoices via',
			toMsg: $author$project$Components$SettingsPage$CustomerLayout$DeliveryMethodUpdate
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$IgnoreInvoiceDocumentUpdate = function (a) {
	return {$: 'IgnoreInvoiceDocumentUpdate', a: a};
};
var $author$project$Api$Customers$ignoreInvoiceDocument = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ignore_customer_invoice_document',
						$elm$json$Json$Encode$bool(data))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentFormView = F4(
	function (set, save, _v0, value) {
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			10,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('ignore-invoice-document')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('ignore-invoice-document'),
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(value),
									$elm$html$Html$Events$onCheck(set)
								]),
							_List_Nil),
							$elm$html$Html$text(' Ignore TriumphPay Audit\u0027s invoice document')
						])),
					A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentSummaryView = function (value) {
	return value ? $elm$html$Html$text('IGNORING invoice documents generated in TriumphPay Audit') : $elm$html$Html$text('Including invoice documents generated in TriumphPay Audit');
};
var $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ignoreInvoiceDocument(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentFormView,
		summaryView: $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentSummaryView,
		title: 'Ignore TriumphPay Audit\u0027s Customer Invoice in receivables',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$IgnoreInvoiceDocumentUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$InstructionsUpdate = function (a) {
	return {$: 'InstructionsUpdate', a: a};
};
var $author$project$Api$Customers$instructions = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'instructions',
						$elm$json$Json$Encode$string(data))
					])));
	});
var $author$project$Helpers$Attributes$blockGrammarly = $elm$core$List$append(
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'data-gramm', 'false'),
			A2($elm$html$Html$Attributes$attribute, 'data-gramm_editor', 'false'),
			A2($elm$html$Html$Attributes$attribute, 'data-enable-grammarly', 'false')
		]));
var $author$project$Components$SettingsPage$CustomerLayout$instructionsFormView = F4(
	function (set, save, _v0, instructions) {
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			10,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('instructions')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Special Instructions')
						])),
					A2(
					$elm$html$Html$textarea,
					$author$project$Helpers$Attributes$blockGrammarly(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('instructions'),
								$elm$html$Html$Attributes$value(instructions),
								$elm$html$Html$Events$onInput(set)
							])),
					_List_Nil),
					A3($author$project$Components$Shared$Button$confirm, 'Save Instructions', save, _List_Nil)
				]));
	});
var $author$project$Ui$V3$Helpers$Html$textToDivs = function (str) {
	return A2(
		$elm$core$List$map,
		function (line) {
			var content = $elm$core$String$isEmpty(line) ? $author$project$Helpers$String$nbsp : line;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(content)
					]));
		},
		$elm$core$String$lines(str));
};
var $author$project$Components$SettingsPage$CustomerLayout$instructionsSummaryView = function (value) {
	return A2(
		$elm$html$Html$p,
		_List_Nil,
		$elm$core$String$isEmpty(value) ? _List_fromArray(
			[
				$elm$html$Html$text('Add special instructions for whoever is processing\u000A                           invoices for this customer.')
			]) : $author$project$Ui$V3$Helpers$Html$textToDivs(value));
};
var $author$project$Components$SettingsPage$CustomerLayout$instructionsConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$instructions(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$CustomerLayout$instructionsFormView,
		summaryView: $author$project$Components$SettingsPage$CustomerLayout$instructionsSummaryView,
		title: 'Instructions',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$InstructionsUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$InvoiceTemplateUpdate = F2(
	function (a, b) {
		return {$: 'InvoiceTemplateUpdate', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Shared$InvoiceTemplate$defaultName = 'Account Default';
var $author$project$Components$SettingsPage$Shared$InvoiceTemplate$isSelected = F2(
	function (maybeId, _v0) {
		var id = _v0.id;
		return _Utils_eq(
			$elm$core$Maybe$Just(id),
			maybeId);
	});
var $author$project$Domain$CustomerInvoiceTemplateId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Components$SettingsPage$Shared$InvoiceTemplate$validate = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	$elm$core$Maybe$map($author$project$Domain$CustomerInvoiceTemplateId$fromInt));
var $author$project$Components$SettingsPage$Shared$InvoiceTemplate$formView = F5(
	function (allOptions, set, save, _v0, maybeId) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('invoicetemplate')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice Template')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('invoicetemplate'),
							A2(
							$elm$html$Html$Events$on,
							'input',
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['target', 'value']),
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Shared$InvoiceTemplate$validate, set),
									$elm$json$Json$Decode$string)))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$option,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Components$SettingsPage$Shared$InvoiceTemplate$defaultName)
								])),
						A2(
							$elm$core$List$map,
							function (template) {
								return A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											$elm$core$String$fromInt(
												$author$project$Domain$CustomerInvoiceTemplateId$toInt(template.id))),
											$elm$html$Html$Attributes$selected(
											A2($author$project$Components$SettingsPage$Shared$InvoiceTemplate$isSelected, maybeId, template))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(template.name)
										]));
							},
							allOptions))),
					A3($author$project$Components$Shared$Button$confirm, 'Save Invoice Template', save, _List_Nil)
				]));
	});
var $author$project$Api$Customers$invoiceTemplate = F3(
	function (idKey, id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						idKey,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CustomerInvoiceTemplateId$toInt),
								data)))
					])));
	});
var $author$project$Components$SettingsPage$Shared$InvoiceTemplate$summaryView = F2(
	function (allOptions, maybeId) {
		var _v0 = A2(
			$elm$core$List$filter,
			$author$project$Components$SettingsPage$Shared$InvoiceTemplate$isSelected(maybeId),
			allOptions);
		if (_v0.b && (!_v0.b.b)) {
			var name = _v0.a.name;
			return $elm$html$Html$text(name);
		} else {
			return $elm$html$Html$text($author$project$Components$SettingsPage$Shared$InvoiceTemplate$defaultName);
		}
	});
var $author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfig = F3(
	function (section, customerId, templates) {
		var _v0 = function () {
			switch (section.$) {
				case 'InvoiceTemplate':
					return {templateIdField: 'customer_invoice_template_id', title: 'Invoice Template'};
				case 'StatementInvoiceTemplate':
					return {templateIdField: 'statement_customer_invoice_template_id', title: 'Statement Invoice Template'};
				default:
					return {templateIdField: 'master_customer_invoice_template_id', title: 'Master Invoice Template (used for Master/Child invoices)'};
			}
		}();
		var templateIdField = _v0.templateIdField;
		var title = _v0.title;
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				A2($author$project$Api$Customers$invoiceTemplate, templateIdField, customerId),
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
			formView: $author$project$Components$SettingsPage$Shared$InvoiceTemplate$formView(templates),
			summaryView: $author$project$Components$SettingsPage$Shared$InvoiceTemplate$summaryView(templates),
			title: title,
			toMsg: $author$project$Components$SettingsPage$CustomerLayout$InvoiceTemplateUpdate(section)
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$LtlCustomerAutoRateUpdate = function (a) {
	return {$: 'LtlCustomerAutoRateUpdate', a: a};
};
var $author$project$Api$Customers$ltlAutoRerateEnabled = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ltl_auto_rerate_enabled',
						$elm$json$Json$Encode$bool(data))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlAutoRerateEnabled(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: F4(
			function (set, save, _v0, value) {
				return A2(
					$author$project$Components$Shared$Grid$autoRow,
					10,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('ltl-auto-rerate-enabled')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('ltl-auto-rerate-enabled'),
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(value),
											$elm$html$Html$Events$onCheck(set)
										]),
									_List_Nil),
									$elm$html$Html$text(' Enable auto re-rating')
								])),
							A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
						]));
			}),
		summaryView: function (value) {
			return value ? $elm$html$Html$text('Enabled') : $elm$html$Html$text('Not enabled');
		},
		title: 'Auto Re-Rate Less-than-truckload Invoices',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlCustomerAutoRateUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$LtlCustomerMarginToleranceUpdate = function (a) {
	return {$: 'LtlCustomerMarginToleranceUpdate', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$updateMarginType = F3(
	function (model, set, marginType) {
		return set(
			_Utils_update(
				model,
				{marginType: marginType}));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$enableOverride = F2(
	function (set, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id('accountdefault'),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(model.marginType, $author$project$Domain$Override$AccountDefault)),
							$elm$html$Html$Events$onClick(
							A3($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$updateMarginType, model, set, $author$project$Domain$Override$AccountDefault))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('accountdefault')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Account default')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id('customerspecific'),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled)),
							$elm$html$Html$Events$onClick(
							A3($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$updateMarginType, model, set, $author$project$Domain$Override$Enabled))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('customerspecific')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Customer specific')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id('disabled'),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(model.marginType, $author$project$Domain$Override$Disabled)),
							$elm$html$Html$Events$onClick(
							A3($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$updateMarginType, model, set, $author$project$Domain$Override$Disabled))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('disabled')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Disabled')
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ensureMinimumLessThanMaximum = function (model) {
	return _Utils_cmp(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toFloat(model.minimumTolerance)),
		A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toFloat(model.maximumTolerance))) < 1;
};
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ensureRequiredFields = function (model) {
	return A2(
		$elm$core$List$all,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		_List_fromArray(
			[model.minimumTolerance, model.maximumTolerance]));
};
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ensureValid = function (model) {
	return _Utils_eq(model.marginType, $author$project$Domain$Override$Enabled) ? ($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ensureRequiredFields(model) && $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ensureMinimumLessThanMaximum(model)) : true;
};
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$numberError = F4(
	function (value, minimumValue, minimumString, isEnabled) {
		return (isEnabled && $elm$core$String$isEmpty(value)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-feedback__feedback')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Must be a number')
				])) : ((isEnabled && (_Utils_cmp(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toFloat(value)),
			minimumValue) < 0)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-feedback__feedback')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Must be greater than or equal to ' + minimumString)
				])) : $elm$html$Html$text(''));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$setMaximumTolerance = F3(
	function (value, set, maximum) {
		return set(
			_Utils_update(
				value,
				{maximumTolerance: maximum}));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ltlMarginToleranceMaximum = F3(
	function (set, model, labelPrefix) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('ltlmargintolerancemaximum')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Less-than-truckload customer margin tolerance maximum')
						])),
					A4(
					$author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$numberError,
					model.maximumTolerance,
					function (minVal) {
						return A2($elm$core$Basics$max, 0, minVal);
					}(
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toFloat(model.minimumTolerance))),
					'minimum and not negative',
					_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hubtran-box__inline')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hubtran-input__prefix')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labelPrefix)
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('ltlmargintolerancemaximum'),
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$value(model.maximumTolerance),
									$elm$html$Html$Events$onInput(
									A2($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$setMaximumTolerance, model, set)),
									$elm$html$Html$Attributes$disabled(
									!_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$numberPresenceError = F2(
	function (value, isEnabled) {
		return (isEnabled && $elm$core$String$isEmpty(value)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-feedback__feedback')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Must be a number')
				])) : $elm$html$Html$text('');
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$setMinimumTolerance = F3(
	function (model, set, minimum) {
		return set(
			_Utils_update(
				model,
				{minimumTolerance: minimum}));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ltlMarginToleranceMinimum = F3(
	function (set, model, labelPrefix) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('ltlmargintoleranceminimum')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Less-than-truckload customer margin tolerance minimum')
						])),
					A2(
					$author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$numberPresenceError,
					model.minimumTolerance,
					_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hubtran-box__inline')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hubtran-input__prefix')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labelPrefix)
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('ltlmargintoleranceminimum'),
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$value(model.minimumTolerance),
									$elm$html$Html$Events$onInput(
									A2($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$setMinimumTolerance, model, set)),
									$elm$html$Html$Attributes$disabled(
									!_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$toleranceUnitDisplay = function (unit) {
	if (unit.$ === 'ToleranceUnitDollars') {
		return 'Dollars';
	} else {
		return 'Percentage';
	}
};
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ltlToleranceUnitOption = F2(
	function (currentlySelected, unit) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$AuditPb$toleranceUnitToString(unit)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(currentlySelected, unit))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$toleranceUnitDisplay(unit))
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$setUnit = F3(
	function (value, set, unit) {
		return set(
			_Utils_update(
				value,
				{
					unit: A2(
						$elm$core$Maybe$withDefault,
						$author$project$AuditPb$toleranceUnitDefault,
						$author$project$AuditPb$toleranceUnitFromString(unit))
				}));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ltlToleranceUnit = F2(
	function (set, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('ltltoleranceunit')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Less-than-truckload customer margin tolerance unit')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('ltltoleranceunit'),
							$elm$html$Html$Events$onInput(
							A2($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$setUnit, model, set)),
							$elm$html$Html$Attributes$disabled(
							!_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled))
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ltlToleranceUnitOption(model.unit),
						$author$project$AuditPb$allToleranceUnit))
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$saveButton = F2(
	function (saveAction, isValid) {
		return isValid ? A3($author$project$Components$Shared$Button$confirm, 'Save LTL customer margin tolerance', saveAction, _List_Nil) : A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil);
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$formView = F4(
	function (set, save, _v0, model) {
		var labelPrefix = function () {
			var _v1 = model.unit;
			if (_v1.$ === 'ToleranceUnitDollars') {
				return '$';
			} else {
				return '%';
			}
		}();
		var isValid = $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ensureValid(model);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$enableOverride, set, model),
					A2($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ltlToleranceUnit, set, model),
					A3($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ltlMarginToleranceMinimum, set, model, labelPrefix),
					A3($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$ltlMarginToleranceMaximum, set, model, labelPrefix),
					A2($author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$saveButton, save, isValid)
				]));
	});
var $author$project$Api$Customers$ltlCustomerMarginTolerance = F2(
	function (id, data) {
		var overrideEnabled = !_Utils_eq(data.marginType, $author$project$Domain$Override$AccountDefault);
		var minimumTolerance = _Utils_eq(data.marginType, $author$project$Domain$Override$Disabled) ? '' : data.minimumTolerance;
		var maximumTolerance = _Utils_eq(data.marginType, $author$project$Domain$Override$Disabled) ? '' : data.maximumTolerance;
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'override_default_ltl_customer_margin_tolerance',
						$elm$json$Json$Encode$bool(overrideEnabled)),
						_Utils_Tuple2(
						'ltl_customer_margin_tolerance_minimum',
						$elm$json$Json$Encode$string(minimumTolerance)),
						_Utils_Tuple2(
						'ltl_customer_margin_tolerance_maximum',
						$elm$json$Json$Encode$string(maximumTolerance)),
						_Utils_Tuple2(
						'ltl_customer_margin_tolerance_unit',
						$elm$json$Json$Encode$string(
							$author$project$AuditPb$toleranceUnitToString(data.unit)))
					])));
	});
var $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$summaryView = function (value) {
	return $elm$html$Html$text(
		function () {
			var _v0 = value.marginType;
			switch (_v0.$) {
				case 'Disabled':
					return 'Disabled';
				case 'Enabled':
					return 'Customer Specific';
				default:
					return 'Account Default';
			}
		}());
};
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginToleranceConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlCustomerMarginTolerance(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$summaryView,
		title: 'Less-than-truckload Customer Margin Tolerance',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlCustomerMarginToleranceUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$LtlRequireManualReweighReviewUpdate = function (a) {
	return {$: 'LtlRequireManualReweighReviewUpdate', a: a};
};
var $author$project$Api$Customers$ltlRequireManualReweighReview = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ltl_require_manual_reweigh_review',
						$elm$json$Json$Encode$bool(data))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlRequireManualReweighReviewConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlRequireManualReweighReview(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: F4(
			function (set, save, _v0, value) {
				return A2(
					$author$project$Components$Shared$Grid$autoRow,
					10,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('ltl-require-manual-reweigh-review')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('ltl-require-manual-reweigh-review'),
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(value),
											$elm$html$Html$Events$onCheck(set)
										]),
									_List_Nil),
									$elm$html$Html$text(' Always require manual review for reweigh charges, even when W&I certificate is present')
								])),
							A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
						]));
			}),
		summaryView: function (value) {
			return value ? $elm$html$Html$text('Manual review required for all reweigh charges') : $elm$html$Html$text('Auto-resolve when W&I certificate is present');
		},
		title: 'Manual review requirements for reweigh charges',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlRequireManualReweighReviewUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$LtlReweighChargeExceptionsUpdate = function (a) {
	return {$: 'LtlReweighChargeExceptionsUpdate', a: a};
};
var $author$project$Api$Customers$ltlReweighChargeExceptionsEnabled = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ltl_reweigh_charge_exceptions_enabled',
						$elm$json$Json$Encode$bool(data))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlReweighChargeExceptionsConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlReweighChargeExceptionsEnabled(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: F4(
			function (set, save, _v0, value) {
				return A2(
					$author$project$Components$Shared$Grid$autoRow,
					10,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('ltl-reweigh-charge-exceptions-enabled')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('ltl-reweigh-charge-exceptions-enabled'),
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(value),
											$elm$html$Html$Events$onCheck(set)
										]),
									_List_Nil),
									$elm$html$Html$text(' Re-weigh charge exception checking')
								])),
							A3($author$project$Components$Shared$Button$confirm, 'Save', save, _List_Nil)
						]));
			}),
		summaryView: function (value) {
			return value ? $elm$html$Html$text('Enabled') : $elm$html$Html$text('Disabled');
		},
		title: 'Re-weigh charge exceptions for less-than-truckload invoices',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlReweighChargeExceptionsUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$LtlToleranceUpdate = function (a) {
	return {$: 'LtlToleranceUpdate', a: a};
};
var $author$project$Api$Customers$ltlTolerance = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'override_default_ltl_tolerance',
						$elm$json$Json$Encode$bool(data.overrideEnabled)),
						_Utils_Tuple2(
						'ltl_carrier_invoice_amount_tolerance_over',
						$elm$json$Json$Encode$string(data.amountAbove)),
						_Utils_Tuple2(
						'ltl_carrier_invoice_amount_tolerance_under',
						$elm$json$Json$Encode$string(data.amountBelow)),
						_Utils_Tuple2(
						'ltl_carrier_invoice_amount_tolerance_unit',
						$elm$json$Json$Encode$string(
							$author$project$AuditPb$toleranceUnitToString(data.unit)))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlToleranceConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlTolerance(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$Tolerance$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$Tolerance$summaryView,
		title: 'Less-than-truckload Invoice Tolerance',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlToleranceUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$PaymentTermsUpdate = function (a) {
	return {$: 'PaymentTermsUpdate', a: a};
};
var $author$project$Api$Customers$daysToPay = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'days_to_pay',
						$elm$json$Json$Encode$int(data))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$paymentTermsConfig = function (customerId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CustomerLayout$validatingSend(
			$author$project$Api$Customers$daysToPay(customerId)),
		formView: $author$project$Components$SettingsPage$Shared$PaymentTerms$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$PaymentTerms$summaryView,
		title: 'Payment Terms',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$PaymentTermsUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$PodRequirementPolicyUpdate = function (a) {
	return {$: 'PodRequirementPolicyUpdate', a: a};
};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$description = A2(
	$elm$html$Html$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('This setting determines whether POD documents are required to approve a carrier invoice.')
		]));
var $author$project$Domain$PodRequirementPolicy$display = function (policy) {
	switch (policy.$) {
		case 'PODRequirementPolicyUseAccountSetting':
			return 'Use account setting';
		case 'PODRequirementPolicyAlways':
			return 'Always require for all loads';
		case 'PODRequirementPolicyDetermineFromLoad':
			return 'Determine from load';
		case 'PODRequirementPolicyNever':
			return 'Never require for any loads';
		default:
			return 'Never require and send all BOLs to MercuryGate as PODs';
	}
};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$advancedView = function (options) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'aria-label', 'POD Requirement Policy')
					]),
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$Shared$PodRequirementPolicy$description,
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'max-width', '240px')
							]),
						_List_fromArray(
							[
								$author$project$Components$Shared$Select$view(
								{
									choices: options.choices,
									disabledChoices: _List_Nil,
									onChange: options.onChange,
									placeholder: 'Select a POD Requirement Policy',
									sortAlphabetically: false,
									toString: $author$project$Domain$PodRequirementPolicy$display,
									value: $elm$core$Maybe$Just(options.policy)
								})
							])),
						A3($author$project$Components$Shared$Button$confirm, 'Save', options.onSave, _List_Nil)
					]))
			]));
};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$formView = F4(
	function (set, save, _v0, policy) {
		return $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$advancedView(
			{
				choices: _List_fromArray(
					[$author$project$AuditPb$PODRequirementPolicyUseAccountSetting, $author$project$AuditPb$PODRequirementPolicyAlways, $author$project$AuditPb$PODRequirementPolicyDetermineFromLoad, $author$project$AuditPb$PODRequirementPolicyNever]),
				onChange: set,
				onSave: save,
				policy: policy
			});
	});
var $author$project$AuditPb$podRequirementPolicyEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$podRequirementPolicyToString);
var $author$project$Domain$PodRequirementPolicy$encode = $author$project$AuditPb$podRequirementPolicyEncoder;
var $author$project$Api$Customers$podRequirementPolicy = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pod_requirement_policy',
						$author$project$Domain$PodRequirementPolicy$encode(data))
					])));
	});
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$summaryView = function (policy) {
	return $elm$html$Html$text(
		$author$project$Domain$PodRequirementPolicy$display(policy));
};
var $author$project$Components$SettingsPage$CustomerLayout$podRequirementPolicyConfig = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$podRequirementPolicy(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$summaryView,
		title: 'POD Requirement Policy',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$PodRequirementPolicyUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$RemitToAddressUpdate = function (a) {
	return {$: 'RemitToAddressUpdate', a: a};
};
var $author$project$Components$SettingsPage$Shared$RemitToAddress$defaultName = '[Account Default]';
var $author$project$Components$SettingsPage$Shared$RemitToAddress$isSelected = F2(
	function (maybeId, _v0) {
		var id = _v0.id;
		return _Utils_eq(id, maybeId);
	});
var $author$project$Domain$AddressId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Components$SettingsPage$Shared$RemitToAddress$validate = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	$elm$core$Maybe$map($author$project$Domain$AddressId$fromInt));
var $author$project$Components$SettingsPage$Shared$RemitToAddress$formView = F5(
	function (allOptions, set, save, _v0, maybeId) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('address')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Account Remit To Address')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('remittoaddress'),
							A2(
							$elm$html$Html$Events$on,
							'input',
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['target', 'value']),
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Shared$RemitToAddress$validate, set),
									$elm$json$Json$Decode$string)))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$option,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Components$SettingsPage$Shared$RemitToAddress$defaultName)
								])),
						A2(
							$elm$core$List$map,
							function (address) {
								return A2(
									$elm$html$Html$option,
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$map,
												$elm$html$Html$Attributes$value,
												A2(
													$elm$core$Maybe$map,
													$elm$core$String$fromInt,
													A2($elm$core$Maybe$map, $author$project$Domain$AddressId$toInt, address.id))),
												$elm$core$Maybe$Just(
												$elm$html$Html$Attributes$selected(
													A2($author$project$Components$SettingsPage$Shared$RemitToAddress$isSelected, maybeId, address)))
											])),
									_List_fromArray(
										[
											$elm$html$Html$text(address.name)
										]));
							},
							allOptions))),
					A3($author$project$Components$Shared$Button$confirm, 'Save Account Remit To Address', save, _List_Nil)
				]));
	});
var $author$project$Api$Customers$remitToAddress = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'account_remit_to_address_id',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$AddressId$toInt),
								data)))
					])));
	});
var $author$project$Components$SettingsPage$Shared$RemitToAddress$summaryView = F2(
	function (allOptions, maybeId) {
		var _v0 = A2(
			$elm$core$List$filter,
			$author$project$Components$SettingsPage$Shared$RemitToAddress$isSelected(maybeId),
			allOptions);
		if (_v0.b && (!_v0.b.b)) {
			var name = _v0.a.name;
			return $elm$html$Html$text(name);
		} else {
			return $elm$html$Html$text($author$project$Components$SettingsPage$Shared$RemitToAddress$defaultName);
		}
	});
var $author$project$Components$SettingsPage$CustomerLayout$remitToAddressConfig = F2(
	function (customerId, addresses) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Customers$remitToAddress(customerId),
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
			formView: $author$project$Components$SettingsPage$Shared$RemitToAddress$formView(addresses),
			summaryView: $author$project$Components$SettingsPage$Shared$RemitToAddress$summaryView(addresses),
			title: 'Remit To Address (to show as account\u0027s \u0027Remit-To\u0027 on invoices)',
			toMsg: $author$project$Components$SettingsPage$CustomerLayout$RemitToAddressUpdate
		};
	});
var $author$project$Domain$ReferenceRule$encode = function (_v0) {
	var rule = _v0.rule;
	var reference = _v0.reference;
	var encodeRule = function (rule_) {
		return $elm$json$Json$Encode$object(
			function () {
				switch (rule_.$) {
					case 'IsPresent':
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('is_present'))
							]);
					case 'IsEmpty':
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('is_empty'))
							]);
					case 'HasValue':
						var value = rule_.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('has_value')),
								_Utils_Tuple2(
								'value',
								$elm$json$Json$Encode$string(value))
							]);
					case 'NotValue':
						var value = rule_.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('not_value')),
								_Utils_Tuple2(
								'value',
								$elm$json$Json$Encode$string(value))
							]);
					default:
						var value = rule_.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('begins_with')),
								_Utils_Tuple2(
								'value',
								$elm$json$Json$Encode$string(value))
							]);
				}
			}());
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'reference',
				$elm$json$Json$Encode$string(reference)),
				_Utils_Tuple2(
				'rule',
				encodeRule(rule))
			]));
};
var $author$project$Api$Customers$requiredReferences = F2(
	function (id, rules) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'rules_broker_required_references',
						A2($elm$json$Json$Encode$list, $author$project$Domain$ReferenceRule$encode, rules))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$Create = function (a) {
	return {$: 'Create', a: a};
};
var $author$project$Components$SettingsPage$CustomerLayout$Update = function (a) {
	return {$: 'Update', a: a};
};
var $author$project$Api$Customers$Contacts$encode = function (_v0) {
	var email = _v0.email;
	var name = _v0.name;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'contact',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name)),
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(
								$author$project$Domain$EmailAddress$toString(email)))
						])))
			]));
};
var $author$project$Api$Customers$Contacts$create = F2(
	function (customerId, data) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$Customers$Contacts$baseUrl(customerId),
			$author$project$Api$Customers$Contacts$encode(data));
	});
var $author$project$Api$Customers$Contacts$update = F3(
	function (customerId, contactId, data) {
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			A2($author$project$Api$Customers$Contacts$contactUrl, customerId, contactId),
			$author$project$Api$Customers$Contacts$encode(data));
	});
var $author$project$Components$SettingsPage$CustomerLayout$saveContact = F2(
	function (customerId, form) {
		var _v0 = form.id;
		if (_v0.$ === 'Nothing') {
			return A2(
				$author$project$HubTran$Effect$sendCacheableRequestWithError,
				$author$project$Components$SettingsPage$CustomerLayout$Contact_Response(
					$author$project$Components$SettingsPage$CustomerLayout$Create(form.name)),
				A2($author$project$Api$Customers$Contacts$create, customerId, form));
		} else {
			var contactId = _v0.a;
			return A2(
				$author$project$HubTran$Effect$sendCacheableRequestWithError,
				$author$project$Components$SettingsPage$CustomerLayout$Contact_Response(
					$author$project$Components$SettingsPage$CustomerLayout$Update(form.name)),
				A3($author$project$Api$Customers$Contacts$update, customerId, contactId, form));
		}
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$AfterSave = function (a) {
	return {$: 'AfterSave', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$AfterSaveV3Reskin = F2(
	function (a, b) {
		return {$: 'AfterSaveV3Reskin', a: a, b: b};
	});
var $author$project$Helpers$Savable$map = F2(
	function (fn, _v0) {
		var s = _v0.a;
		return $author$project$Helpers$Savable$Savable(
			_Utils_update(
				s,
				{
					value: fn(s.value)
				}));
	});
var $author$project$Helpers$Savable$revert = function (_v0) {
	var s = _v0.a;
	return $author$project$Helpers$Savable$Savable(
		_Utils_update(
			s,
			{value: s.original}));
};
var $author$project$Helpers$Savable$sync = function (_v0) {
	var s = _v0.a;
	return $author$project$Helpers$Savable$Savable(
		_Utils_update(
			s,
			{original: s.value}));
};
var $author$project$Helpers$Savable$value = function (_v0) {
	var s = _v0.a;
	return s.value;
};
var $author$project$Domain$CustomExceptionMessage$displayed = F2(
	function (auditBillingEnabled, typesSelection) {
		var _v0 = _Utils_Tuple2(typesSelection, auditBillingEnabled);
		_v0$2:
		while (true) {
			if (!_v0.b) {
				switch (_v0.a.$) {
					case 'Both':
						var _v1 = _v0.a;
						return $elm$core$Maybe$Just($author$project$Domain$CustomExceptionMessage$Payment);
					case 'Billing':
						var _v2 = _v0.a;
						return $elm$core$Maybe$Nothing;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Just(typesSelection);
	});
var $author$project$Domain$CustomExceptionMessage$afterRemoving = F2(
	function (auditBillingEnabled, customExceptionMessage) {
		var remaining = function () {
			var _v0 = _Utils_Tuple2(
				A2($author$project$Domain$CustomExceptionMessage$displayed, auditBillingEnabled, customExceptionMessage.typesSelection),
				customExceptionMessage.typesSelection);
			if (((_v0.a.$ === 'Just') && (_v0.a.a.$ === 'Payment')) && (_v0.b.$ === 'Both')) {
				var _v1 = _v0.a.a;
				var _v2 = _v0.b;
				return $elm$core$Maybe$Just($author$project$Domain$CustomExceptionMessage$Billing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (typesSelection) {
				return _Utils_update(
					customExceptionMessage,
					{typesSelection: typesSelection});
			},
			remaining);
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$withoutDisplayedTypesOf = F3(
	function (accountSettings, item, items) {
		return A2(
			$author$project$Helpers$Savable$map,
			$elm$core$List$filterMap(
				function (candidate) {
					return _Utils_eq(candidate, item) ? A2($author$project$Domain$CustomExceptionMessage$afterRemoving, accountSettings.auditBillingEnabled, candidate) : $elm$core$Maybe$Just(candidate);
				}),
			items);
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$update = F3(
	function (toSaveRequest, msg, model) {
		switch (msg.$) {
			case 'DoNothing':
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'UpdateInput':
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{newRuleInput: string}),
					$author$project$HubTran$Effect$none);
			case 'Add':
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							items: A2(
								$author$project$Helpers$Savable$map,
								function (items) {
									return _Utils_ap(
										items,
										_List_fromArray(
											[item]));
								},
								model.items),
							newRuleInput: ''
						}),
					$author$project$HubTran$Effect$none);
			case 'Remove':
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							items: A3($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$withoutDisplayedTypesOf, model.accountSettings, item, model.items)
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangeTypes':
				var item = msg.a;
				var typesSelection = msg.b;
				var newItem = {message: item.message, typesSelection: typesSelection};
				var itemsWithUpdateTypes = A2(
					$author$project$Helpers$Savable$map,
					function (items) {
						return _Utils_ap(
							A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(item),
								items),
							_List_fromArray(
								[newItem]));
					},
					model.items);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{items: itemsWithUpdateTypes}),
					$author$project$HubTran$Effect$none);
			case 'ClickedUndo':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							items: $author$project$Helpers$Savable$revert(model.items)
						}),
					$author$project$HubTran$Effect$none);
			case 'ClickedSave':
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$AfterSave,
						A2(
							$author$project$Forward$CacheableRequest$map,
							$author$project$Helpers$Api$Result$fromNestedResult,
							toSaveRequest(
								$author$project$Helpers$Savable$value(model.items)))));
			case 'AfterSave':
				switch (msg.a.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									items: $author$project$Helpers$Savable$sync(model.items)
								}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('Changes saved!')));
					case 'Err':
						var message = msg.a.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Something went wrong...')));
				}
			case 'ChangeTypesV3Reskin':
				var item = msg.a;
				var typesSelection = msg.b;
				var newItem = {message: item.message, typesSelection: typesSelection};
				var itemsWithUpdateTypes = A2(
					$author$project$Helpers$Savable$map,
					function (items) {
						return _Utils_ap(
							A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(item),
								items),
							_List_fromArray(
								[newItem]));
					},
					model.items);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$AfterSaveV3Reskin(itemsWithUpdateTypes),
						A2(
							$author$project$Forward$CacheableRequest$map,
							$author$project$Helpers$Api$Result$fromNestedResult,
							toSaveRequest(
								$author$project$Helpers$Savable$value(itemsWithUpdateTypes)))));
			case 'RemoveV3Reskin':
				var item = msg.a;
				var newItems = A3($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$withoutDisplayedTypesOf, model.accountSettings, item, model.items);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$AfterSaveV3Reskin(newItems),
						A2(
							$author$project$Forward$CacheableRequest$map,
							$author$project$Helpers$Api$Result$fromNestedResult,
							toSaveRequest(
								$author$project$Helpers$Savable$value(newItems)))));
			case 'AfterSaveV3Reskin':
				switch (msg.b.$) {
					case 'Ok':
						var newItems = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									isSaving: false,
									items: $author$project$Helpers$Savable$sync(newItems),
									newRuleInput: '',
									newTypesSelection: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$defaultNewTypesSelection(model.accountSettings)
								}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('Changes saved!')));
					case 'Err':
						var message = msg.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Something went wrong...')));
				}
			case 'ChangeNewTypes':
				var typesSelection = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newTypesSelection: $elm$core$Maybe$Just(typesSelection)
						}),
					$author$project$HubTran$Effect$none);
			default:
				var item = msg.a;
				var newItems = A2(
					$author$project$Helpers$Savable$map,
					function (items) {
						return _Utils_ap(
							items,
							_List_fromArray(
								[item]));
					},
					model.items);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$AfterSaveV3Reskin(newItems),
						A2(
							$author$project$Forward$CacheableRequest$map,
							$author$project$Helpers$Api$Result$fromNestedResult,
							toSaveRequest(
								$author$project$Helpers$Savable$value(newItems)))));
		}
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$AfterRevert = function (a) {
	return {$: 'AfterRevert', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$AfterSave = function (a) {
	return {$: 'AfterSave', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Reverting = {$: 'Reverting'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Saving = {$: 'Saving'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Success = function (a) {
	return {$: 'Success', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$checkAccountOrCustomSettings = function (model) {
	return _Utils_eq(model.globalRows, model.rows) ? _Utils_update(
		model,
		{useAccountSettings: true}) : _Utils_update(
		model,
		{useAccountSettings: false});
};
var $author$project$Api$Customers$documentTypes = F2(
	function (id, items) {
		return A2(
			$author$project$Api$Customers$defaultSend,
			id,
			A2($author$project$Api$Settings$documentTypesJson, 'required_payables_types', items));
	});
var $author$project$Api$Debtors$defaultSend = F2(
	function (id, encodedSettings) {
		var url = '/api/debtors/' + $elm$core$String$fromInt(
			$author$project$Domain$FactorBrokerId$toInt(id));
		var encodedPayload = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('debtor', encodedSettings)
				]));
		return A2($author$project$Helpers$Api$putWithNoResponseBody, url, encodedPayload);
	});
var $author$project$Api$Debtors$documentTypes = F2(
	function (id, items) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			A2($author$project$Api$Settings$documentTypesJson, 'required_payables_types', items));
	});
var $author$project$Api$Customers$revertDocumentTypes = function (id) {
	return A2(
		$author$project$Api$Customers$defaultSend,
		id,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'customer_visible_document_types',
					$elm$json$Json$Encode$string('reset')),
					_Utils_Tuple2(
					'required_receivables_types',
					$elm$json$Json$Encode$string('reset')),
					_Utils_Tuple2(
					'required_payables_types',
					$elm$json$Json$Encode$string('reset'))
				])));
};
var $author$project$Api$Debtors$revertDocumentTypes = function (id) {
	return A2(
		$author$project$Api$Debtors$defaultSend,
		id,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'customer_visible_document_types',
					$elm$json$Json$Encode$string('reset')),
					_Utils_Tuple2(
					'required_receivables_types',
					$elm$json$Json$Encode$string('reset'))
				])));
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$updateRow = F2(
	function (_v0, row) {
		var column = _v0.column;
		var value = _v0.value;
		var docType = _v0.docType;
		if (!_Utils_eq(row.documentType, docType)) {
			return row;
		} else {
			if (column.$ === 'VisibleToCustomer') {
				return _Utils_update(
					row,
					{isVisibleToCustomer: value});
			} else {
				return _Utils_update(
					row,
					{isRequiredForCustomer: value});
			}
		}
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$rowToggle = F4(
	function (docType, column, value, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					rows: A2(
						$elm$core$List$map,
						$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$updateRow(
							{column: column, docType: docType, value: value}),
						model.rows)
				}),
			$author$project$HubTran$Effect$none);
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$toSaveData = $elm$core$List$map(
	function (row) {
		return {
			cadenceTypeId: $elm$core$Maybe$Nothing,
			documentType: row.documentType,
			isIncludedForCustomer: $author$project$Components$SettingsPage$Shared$Checkbox$isChecked(row.isVisibleToCustomer),
			isRequiredForCustomer: $author$project$Components$SettingsPage$Shared$Checkbox$isChecked(row.isRequiredForCustomer),
			isRequiredForPayables: $author$project$Components$SettingsPage$Shared$PayablesValue$toBool(row.isRequiredForPayables)
		};
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$update = F3(
	function (_v0, msg, model) {
		var id = _v0.id;
		switch (msg.$) {
			case 'OnRowCheck':
				var _v2 = msg.a;
				var docType = _v2.a;
				var column = _v2.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$checkAccountOrCustomSettings,
					A4($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$rowToggle, docType, column, $author$project$Components$SettingsPage$Shared$Checkbox$checked, model));
			case 'OnRowUncheck':
				var _v3 = msg.a;
				var docType = _v3.a;
				var column = _v3.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$checkAccountOrCustomSettings,
					A4($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$rowToggle, docType, column, $author$project$Components$SettingsPage$Shared$Checkbox$unchecked, model));
			case 'SetPayablesValue':
				var docType = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$checkAccountOrCustomSettings(
						_Utils_update(
							model,
							{
								rows: A2(
									$elm$core$List$map,
									function (row) {
										return _Utils_eq(row.documentType, docType) ? _Utils_update(
											row,
											{isRequiredForPayables: value}) : row;
									},
									model.rows)
							})),
					$author$project$HubTran$Effect$none);
			case 'OnMakeChangesClick':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isEditing: true, keepGlobalSettings: false}),
					$author$project$HubTran$Effect$none);
			case 'OnSaveClick':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{status: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Saving}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						A2($elm$core$Basics$composeR, $author$project$Helpers$Api$Result$fromNestedResult, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$AfterSave),
						function () {
							if (model.useAccountSettings) {
								if (id.$ === 'Customer') {
									var id_ = id.a;
									return $author$project$Api$Customers$revertDocumentTypes(id_);
								} else {
									var id_ = id.a;
									return $author$project$Api$Debtors$revertDocumentTypes(id_);
								}
							} else {
								if (id.$ === 'Customer') {
									var id_ = id.a;
									return A2(
										$author$project$Api$Customers$documentTypes,
										id_,
										$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$toSaveData(model.rows));
								} else {
									var id_ = id.a;
									return A2(
										$author$project$Api$Debtors$documentTypes,
										id_,
										$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$toSaveData(model.rows));
								}
							}
						}()));
			case 'AfterSave':
				switch (msg.a.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									isEditing: false,
									rowsSinceLastSave: model.rows,
									status: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Success('Save successful!')
								}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('Document types saved!')));
					case 'Err':
						var message = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{status: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Ready}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{status: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Ready}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Could not save document types')));
				}
			case 'OnRevertClick':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{status: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Reverting}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						A2($elm$core$Basics$composeR, $author$project$Helpers$Api$Result$fromNestedResult, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$AfterRevert),
						function () {
							if (id.$ === 'Customer') {
								var id_ = id.a;
								return $author$project$Api$Customers$revertDocumentTypes(id_);
							} else {
								var id_ = id.a;
								return $author$project$Api$Debtors$revertDocumentTypes(id_);
							}
						}()));
			case 'AfterRevert':
				switch (msg.a.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									isEditing: false,
									keepGlobalSettings: true,
									rows: model.globalRows,
									rowsSinceLastSave: model.globalRows,
									status: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Success('Using account settings.')
								}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('Document types saved!')));
					case 'Err':
						var message = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{status: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Ready}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{status: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Ready}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Could not save document types')));
				}
			case 'ClickedUseAccountSettings':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{keepGlobalSettings: true, rows: model.globalRows, useAccountSettings: true}),
					$author$project$HubTran$Effect$none);
			case 'ClickedCustom':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{keepGlobalSettings: false, useAccountSettings: false}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							isEditing: false,
							rows: model.rowsSinceLastSave,
							useAccountSettings: _Utils_eq(model.rowsSinceLastSave, model.globalRows)
						}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$AfterSave = F2(
	function (a, b) {
		return {$: 'AfterSave', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$replace = F2(
	function (old, _new) {
		return $elm$core$List$map(
			function (item) {
				return _Utils_eq(item, old) ? _new : item;
			});
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$ruleFor = F2(
	function (option, value) {
		switch (option.$) {
			case 'IsPresentOption':
				return $author$project$Domain$ReferenceRule$IsPresent;
			case 'HasValueOption':
				return $author$project$Domain$ReferenceRule$HasValue(value);
			case 'NotValueOption':
				return $author$project$Domain$ReferenceRule$NotValue(value);
			case 'BeginsWithOption':
				return $author$project$Domain$ReferenceRule$BeginsWith(value);
			default:
				return $author$project$Domain$ReferenceRule$IsEmpty;
		}
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$toReferenceRule = function (item) {
	return {
		reference: item.label,
		rule: A2($author$project$Components$SettingsPage$Shared$ReferenceTable$ruleFor, item.option, item.value)
	};
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$update = F3(
	function (saveReferences, msg, model) {
		switch (msg.$) {
			case 'RevertChanges':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							items: $author$project$Helpers$Savable$revert(model.items)
						}),
					$author$project$HubTran$Effect$none);
			case 'ClickedSave':
				var v3ReskinEnabled = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$SettingsPage$Shared$ReferenceTable$AfterSave(v3ReskinEnabled),
							$author$project$Helpers$Api$Result$fromNestedResult),
						saveReferences(
							A2(
								$elm$core$List$map,
								$author$project$Components$SettingsPage$Shared$ReferenceTable$toReferenceRule,
								$author$project$Helpers$Savable$value(model.items)))));
			case 'AfterSave':
				switch (msg.b.$) {
					case 'Ok':
						var v3ReskinEnabled = msg.a.v3ReskinEnabled;
						var message = 'Changes saved!';
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									isEditing: false,
									isSaving: false,
									items: $author$project$Helpers$Savable$sync(model.items),
									message: message
								}),
							v3ReskinEnabled ? $author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success(message)) : $author$project$HubTran$Effect$none);
					case 'Err':
						var v3ReskinEnabled = msg.a.v3ReskinEnabled;
						var message = msg.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false, message: message}),
							v3ReskinEnabled ? $author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)) : $author$project$HubTran$Effect$none);
					default:
						var v3ReskinEnabled = msg.a.v3ReskinEnabled;
						var message = 'Something went wrong...';
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false, message: message}),
							v3ReskinEnabled ? $author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)) : $author$project$HubTran$Effect$none);
				}
			case 'UpdateItem':
				var item = msg.a;
				var action = msg.b;
				var effect = function () {
					switch (action.$) {
						case 'Remove':
							return $elm$core$List$filter(
								$elm$core$Basics$neq(item));
						case 'SetOption':
							var option = action.a;
							return A2(
								$author$project$Components$SettingsPage$Shared$ReferenceTable$replace,
								item,
								_Utils_update(
									item,
									{option: option}));
						default:
							var value = action.a;
							return A2(
								$author$project$Components$SettingsPage$Shared$ReferenceTable$replace,
								item,
								_Utils_update(
									item,
									{value: value}));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							items: A2($author$project$Helpers$Savable$map, effect, model.items),
							message: ''
						}),
					$author$project$HubTran$Effect$none);
			case 'SelectReference':
				var ref = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedReference: $elm$core$Maybe$Just(ref)
						}),
					$author$project$HubTran$Effect$none);
			case 'AddReference':
				var ref = msg.a;
				var newRule = {label: ref, option: $author$project$Components$SettingsPage$Shared$ReferenceTable$IsPresentOption, value: ''};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							items: A2(
								$author$project$Helpers$Savable$map,
								function (items) {
									return _Utils_ap(
										items,
										_List_fromArray(
											[newRule]));
								},
								model.items),
							selectedReference: $elm$core$Maybe$Nothing
						}),
					$author$project$HubTran$Effect$none);
			case 'StartEditing':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isEditing: true, selectedReference: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							isEditing: false,
							items: $author$project$Helpers$Savable$revert(model.items)
						}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$CustomerLayout$updateForm = F4(
	function (loadedMsg, customerId, data, formState) {
		switch (loadedMsg.$) {
			case 'DeliveryMethodUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{deliveryMethod: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$CustomerLayout$deliveryMethodConfig, customerId, data),
						msg,
						formState.deliveryMethod));
			case 'CustomSubjectUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{customSubject: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A3($author$project$Components$SettingsPage$CustomerLayout$customSubjectConfig, customerId, data.customerSettings, data.accountSettings),
						msg,
						formState.customSubject));
			case 'PaymentTermsUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{paymentTerms: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$paymentTermsConfig(customerId),
						msg,
						formState.paymentTerms));
			case 'IgnoreInvoiceDocumentUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{ignoreInvoiceDocument: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentConfig(customerId),
						msg,
						formState.ignoreInvoiceDocument));
			case 'BillingIntervalUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{billingInterval: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$billingIntervalConfig(customerId),
						msg,
						formState.billingInterval));
			case 'PodRequirementPolicyUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{podRequirementPolicy: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$podRequirementPolicyConfig(customerId),
						msg,
						formState.podRequirementPolicy));
			case 'InvoiceTemplateUpdate':
				switch (loadedMsg.a.$) {
					case 'InvoiceTemplate':
						var _v1 = loadedMsg.a;
						var msg = loadedMsg.b;
						return A2(
							$elm$core$Tuple$mapFirst,
							function (x) {
								return _Utils_update(
									formState,
									{invoiceTemplate: x});
							},
							A3(
								$author$project$Components$SettingsPage$Shared$EditSection$update,
								A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfig, $author$project$Components$SettingsPage$CustomerLayout$InvoiceTemplate, customerId, data.invoiceTemplates),
								msg,
								formState.invoiceTemplate));
					case 'StatementInvoiceTemplate':
						var _v2 = loadedMsg.a;
						var msg = loadedMsg.b;
						return A2(
							$elm$core$Tuple$mapFirst,
							function (x) {
								return _Utils_update(
									formState,
									{statementInvoiceTemplate: x});
							},
							A3(
								$author$project$Components$SettingsPage$Shared$EditSection$update,
								A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfig, $author$project$Components$SettingsPage$CustomerLayout$StatementInvoiceTemplate, customerId, data.invoiceTemplates),
								msg,
								formState.statementInvoiceTemplate));
					default:
						var _v3 = loadedMsg.a;
						var msg = loadedMsg.b;
						return A2(
							$elm$core$Tuple$mapFirst,
							function (x) {
								return _Utils_update(
									formState,
									{masterInvoiceTemplate: x});
							},
							A3(
								$author$project$Components$SettingsPage$Shared$EditSection$update,
								A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfig, $author$project$Components$SettingsPage$CustomerLayout$MasterInvoiceTemplate, customerId, data.invoiceTemplates),
								msg,
								formState.masterInvoiceTemplate));
				}
			case 'RemitToAddressUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{remitToAddress: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$CustomerLayout$remitToAddressConfig, customerId, data.remitToAddresses),
						msg,
						formState.remitToAddress));
			case 'InstructionsUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{instructions: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$instructionsConfig(customerId),
						msg,
						formState.instructions));
			case 'BillingEmailUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{billingEmail: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$billingEmailConfig(customerId),
						msg,
						formState.billingEmail));
			case 'Contact_Set':
				var maybeForm = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{contactForm: maybeForm}),
					$author$project$HubTran$Effect$none);
			case 'Contact_Save':
				var _v4 = formState.contactForm;
				if (_v4.$ === 'Nothing') {
					return _Utils_Tuple2(formState, $author$project$HubTran$Effect$none);
				} else {
					var form = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							formState,
							{
								contactForm: $elm$core$Maybe$Just(
									_Utils_update(
										form,
										{saving: true}))
							}),
						A2($author$project$Components$SettingsPage$CustomerLayout$saveContact, customerId, form));
				}
			case 'Contact_Delete':
				var contact = loadedMsg.a;
				return _Utils_Tuple2(
					formState,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$CustomerLayout$Contact_Response(
							$author$project$Components$SettingsPage$CustomerLayout$Delete(contact.email)),
						A2($author$project$Api$Customers$Contacts$delete, customerId, contact.id)));
			case 'Contact_Response':
				if (loadedMsg.b.$ === 'Ok') {
					var context = loadedMsg.a;
					return _Utils_Tuple2(
						_Utils_update(
							formState,
							{contactForm: $elm$core$Maybe$Nothing}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$invalidate(
									A2($author$project$Forward$Lookup$startFrom, customerId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$tmsCustomerSettings)),
									$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$success(
										A2($author$project$Components$SettingsPage$CustomerLayout$contactMessage, 'successfully', context)))
								])));
				} else {
					var context = loadedMsg.a;
					return _Utils_Tuple2(
						function () {
							var _v5 = formState.contactForm;
							if (_v5.$ === 'Nothing') {
								return formState;
							} else {
								var form = _v5.a;
								return _Utils_update(
									formState,
									{
										contactForm: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{saving: false}))
									});
							}
						}(),
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$alert(
								A2($author$project$Components$SettingsPage$CustomerLayout$contactMessage, 'could not be', context))));
				}
			case 'DocumentTypesUpdate':
				var msg = loadedMsg.a;
				var _v6 = A3(
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$update,
					A2($author$project$Components$SettingsPage$CustomerLayout$documentTypesSettingsFromData, customerId, data),
					msg,
					formState.documentTypes);
				var model = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{documentTypes: model}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$CustomerLayout$DocumentTypesUpdate, cmd));
			case 'ReferencesUpdate':
				var msg = loadedMsg.a;
				var _v7 = A3(
					$author$project$Components$SettingsPage$Shared$ReferenceTable$update,
					$author$project$Api$Customers$requiredReferences(customerId),
					msg,
					formState.requiredReferences);
				var model = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{requiredReferences: model}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$CustomerLayout$ReferencesUpdate, cmd));
			case 'CustomExceptionMessagesUpdate':
				var msg = loadedMsg.a;
				var _v8 = A3(
					$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$update,
					$author$project$Api$Customers$customExceptionMessages(customerId),
					msg,
					formState.customExceptionMessages);
				var model = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{customExceptionMessages: model}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$CustomerLayout$CustomExceptionMessagesUpdate, cmd));
			case 'LtlToleranceUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{ltlTolerance: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$ltlToleranceConfig(customerId),
						msg,
						formState.ltlTolerance));
			case 'LtlCustomerMarginToleranceUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{ltlCustomerMarginTolerance: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginToleranceConfig(customerId),
						msg,
						formState.ltlCustomerMarginTolerance));
			case 'LtlCustomerAutoRateUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{ltlCustomerAutoRate: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateConfig(customerId),
						msg,
						formState.ltlCustomerAutoRate));
			case 'LtlReweighChargeExceptionsUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{ltlReweighChargeExceptions: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$ltlReweighChargeExceptionsConfig(customerId),
						msg,
						formState.ltlReweighChargeExceptions));
			default:
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{ltlRequireManualReweighReview: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$CustomerLayout$ltlRequireManualReweighReviewConfig(customerId),
						msg,
						formState.ltlRequireManualReweighReview));
		}
	});
var $author$project$Components$SettingsPage$CustomerLayout$update = F3(
	function (data, msg, model) {
		if (msg.$ === 'GoBack') {
			return _Utils_Tuple2(
				model,
				$author$project$HubTran$Effect$cmd(
					$author$project$HubTran$Navigation$back(1)));
		} else {
			var loadedMsg = msg.a;
			var _v1 = $author$project$Forward$Remote$toMaybe(data);
			if (_v1.$ === 'Just') {
				var data_ = _v1.a;
				var oldForm = A2($author$project$Components$SettingsPage$CustomerLayout$currentFormState, data_, model);
				var _v2 = A4($author$project$Components$SettingsPage$CustomerLayout$updateForm, loadedMsg, model.customerId, data_, oldForm);
				var newForm = _v2.a;
				var formEffect = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							formState_INTERNAL: $elm$core$Maybe$Just(newForm)
						}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$CustomerLayout$LoadedMsg, formEffect));
			} else {
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			}
		}
	});
var $author$project$Components$SettingsPage$CustomersLayout$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'ChangePage':
				var newPage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{page: newPage}),
					$author$project$HubTran$Effect$none);
			case 'ChangeSearchTerm':
				var newTerm = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{page: 1, term: newTerm}),
					$author$project$HubTran$Effect$none);
			default:
				var destination = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						$author$project$HubTran$Navigation$pushUrl(destination)));
		}
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Debtor = function (a) {
	return {$: 'Debtor', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$debtorId = $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Debtor;
var $author$project$Components$SettingsPage$DebtorLayout$documentTypesSettingsFromData = F2(
	function (id, data) {
		return {
			columns: _List_fromArray(
				[
					{
					header: 'Document Type',
					isDisabled: false,
					view: F2(
						function (_v0, row_) {
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'min-width', '200px')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(row_.name)
									]));
						}),
					viewDisabled: function (row_) {
						return A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'min-width', '200px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(row_.name)
								]));
					}
				},
					{
					header: 'Visible to Debtor',
					isDisabled: data.accountSettings.controlledByTMS.customerVisibleDocs,
					view: F2(
						function (messages, row_) {
							return A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$SettingsPage$Shared$Checkbox$view(
										{
											id: _Utils_Tuple2(row_.documentType, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$visibleToCustomer),
											messages: {onCheck: messages.onCheck, onUncheck: messages.onUncheck},
											value: row_.isVisibleToCustomer
										})
									]));
						}),
					viewDisabled: function (row_) {
						return A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$Shared$Checkbox$viewDisabled(row_.isVisibleToCustomer)
								]));
					}
				},
					{
					header: 'Required for Debtor Billing',
					isDisabled: data.accountSettings.controlledByTMS.customerRequiredDocs,
					view: F2(
						function (messages, row_) {
							return A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$SettingsPage$Shared$Checkbox$view(
										{
											id: _Utils_Tuple2(row_.documentType, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$requiredForCustomer),
											messages: {onCheck: messages.onCheck, onUncheck: messages.onUncheck},
											value: row_.isRequiredForCustomer
										})
									]));
						}),
					viewDisabled: function (row_) {
						return A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$Shared$Checkbox$viewDisabled(row_.isRequiredForCustomer)
								]));
					}
				}
				]),
			descriptions: {
				hasDifferences: _List_fromArray(
					[
						$elm$html$Html$text('Make changes to document types for this debtor. You can also choose to use the settings for this account by clicking \u0022Use account settings\u0022.')
					]),
				sameAsGlobal: _List_fromArray(
					[
						$elm$html$Html$text('Make changes to document types for this debtor. Right now, this debtor is using the account settings. '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/app/settings/document_types')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('You can update account settings here.')
							])),
						$elm$html$Html$text('To change settings for just this customer click the \u0022Edit Document Types\u0022 button below.')
					])
			},
			id: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$debtorId(id),
			isAdmin: data.currentUser.isAdmin,
			settings: {
				global: data.documentTypeSettings,
				local: {
					customerVisibleTypes: A2($elm$core$List$map, $author$project$Domain$UnresolvedDocumentType$fromPb, data.debtorSettings.customerVisibleDocumentTypes),
					requiredPayablesTypes: _List_Nil,
					requiredReceivablesTypes: A2($elm$core$List$map, $author$project$Domain$UnresolvedDocumentType$fromPb, data.debtorSettings.requiredReceivablesTypes)
				}
			}
		};
	});
var $author$project$Domain$LoadIdStrategy$fromKeys = function (keys) {
	return A2($elm$core$List$filterMap, $author$project$AuditPb$loadIdStrategyFromString, keys);
};
var $author$project$Components$SettingsPage$DebtorLayout$maybe = F2(
	function (_default, f) {
		return A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(_default),
			$elm$core$Maybe$map(f));
	});
var $author$project$Components$SettingsPage$DebtorLayout$onlyAccessorials = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.factorInvoiceExtractedFields;
	},
	$elm$core$List$filter(
		function ($) {
			return $.lineItem;
		}));
var $author$project$Components$SettingsPage$DebtorLayout$onlyFields = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.factorInvoiceExtractedFields;
	},
	$elm$core$List$filter(
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$not,
			function ($) {
				return $.lineItem;
			})));
var $author$project$Components$SettingsPage$DebtorLayout$mergeFormData = F2(
	function (data, model) {
		var form = function (getter) {
			return A2($elm$core$Maybe$map, getter, model.formState);
		};
		var keepSaving = function (getter) {
			return A3(
				$author$project$Components$SettingsPage$DebtorLayout$maybe,
				false,
				function ($) {
					return $.saving;
				},
				form(getter));
		};
		return {
			addAccessorials: {
				saving: keepSaving(
					function ($) {
						return $.addAccessorials;
					})
			},
			allowAutoprocessing: {
				saving: keepSaving(
					function ($) {
						return $.allowAutoprocessing;
					}),
				value: data.debtorSettings.allowAutoprocessing
			},
			billingEmail: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$elm$core$Result$Ok(
					$author$project$Domain$EmailAddress$fromString(data.debtorSettings.billingEmail)),
				form(
					function ($) {
						return $.billingEmail;
					})),
			billingInterval: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.debtorSettings.billingInterval,
				form(
					function ($) {
						return $.billingInterval;
					})),
			contactInfo: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$elm$core$Result$Ok(data.debtorSettings.contactInfo),
				form(
					function ($) {
						return $.contactInfo;
					})),
			deductAdvances: {
				saving: keepSaving(
					function ($) {
						return $.deductAdvances;
					})
			},
			deliveryMethod: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$author$project$Domain$DeliveryMethodFromPb$fromPb(data.debtorSettings.deliveryMethod.method),
				form(
					function ($) {
						return $.deliveryMethod;
					})),
			documentTypes: A2(
				$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$init,
				A2($author$project$Components$SettingsPage$DebtorLayout$documentTypesSettingsFromData, model.debtorId, data),
				form(
					function ($) {
						return $.documentTypes;
					})),
			excludeFromVerificationsWorkflow: {
				saving: keepSaving(
					function ($) {
						return $.excludeFromVerificationsWorkflow;
					}),
				value: data.debtorSettings.excludeFromVerificationsWorkflow
			},
			factorBrokerLoadIdRegressionRuleMode: {
				saving: keepSaving(
					function ($) {
						return $.factorBrokerLoadIdRegressionRuleMode;
					}),
				value: data.debtorSettings.factorBrokerLoadIdRegressionRuleMode
			},
			invoiceTemplate: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.debtorSettings.customerInvoiceTemplateId,
				form(
					function ($) {
						return $.invoiceTemplate;
					})),
			loadIdAutoRelease: {
				saving: keepSaving(
					function ($) {
						return $.loadIdAutoRelease;
					}),
				value: data.debtorSettings.loadIdAutoRelease.enabled
			},
			loadIdStrategies: {
				saving: keepSaving(
					function ($) {
						return $.loadIdStrategies;
					}),
				value: $author$project$Domain$LoadIdStrategy$fromKeys(data.debtorSettings.loadIdStrategies)
			},
			podRequired: {
				saving: keepSaving(
					function ($) {
						return $.podRequired;
					}),
				value: data.debtorSettings.podRequired
			},
			rateConfirmationRequired: {
				saving: keepSaving(
					function ($) {
						return $.rateConfirmationRequired;
					}),
				value: data.debtorSettings.rateConfirmationRequired
			},
			requireVerificationsWorkflow: {
				saving: keepSaving(
					function ($) {
						return $.requireVerificationsWorkflow;
					}),
				value: data.debtorSettings.requireVerificationsWorkflow
			},
			skipAutoStamp: {
				saving: keepSaving(
					function ($) {
						return $.skipAutoStamp;
					}),
				value: data.debtorSettings.skipAutoStamp
			},
			specialAccessorials: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$author$project$Components$SettingsPage$DebtorLayout$onlyAccessorials(data.debtorSettings),
				form(
					function ($) {
						return $.specialAccessorials;
					})),
			specialFields: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				$author$project$Components$SettingsPage$DebtorLayout$onlyFields(data.debtorSettings),
				form(
					function ($) {
						return $.specialFields;
					})),
			warnIfAmountOver: A2(
				$author$project$Components$SettingsPage$Shared$EditSection$init,
				data.debtorSettings.warnIfAmountOver,
				form(
					function ($) {
						return $.warnIfAmountOver;
					}))
		};
	});
var $author$project$Components$SettingsPage$DebtorLayout$AllowAutoprocessing_Finish = {$: 'AllowAutoprocessing_Finish'};
var $author$project$Components$SettingsPage$DebtorLayout$DocumentTypesUpdate = function (a) {
	return {$: 'DocumentTypesUpdate', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$LoadIdAutoRelease_Finish = {$: 'LoadIdAutoRelease_Finish'};
var $author$project$Components$SettingsPage$DebtorLayout$LoadIdStrategies_Finish = {$: 'LoadIdStrategies_Finish'};
var $author$project$Components$SettingsPage$DebtorLayout$RateConfirmationRequired_Finish = {$: 'RateConfirmationRequired_Finish'};
var $author$project$Components$SettingsPage$DebtorLayout$SetFactorBrokerLoadIdRegressionRuleMode_Finish = {$: 'SetFactorBrokerLoadIdRegressionRuleMode_Finish'};
var $author$project$Components$SettingsPage$DebtorLayout$SetVerificationWorkflow_Finish = {$: 'SetVerificationWorkflow_Finish'};
var $author$project$Components$SettingsPage$DebtorLayout$SkipAutoStamp_Finish = {$: 'SkipAutoStamp_Finish'};
var $author$project$Api$Debtors$allowAutoprocessing = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'allow_autoprocessing',
						$elm$json$Json$Encode$bool(data))
					])));
	});
var $author$project$Components$SettingsPage$DebtorLayout$BillingEmailUpdate = function (a) {
	return {$: 'BillingEmailUpdate', a: a};
};
var $author$project$Api$Debtors$billingEmail = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'billing_email',
						$elm$json$Json$Encode$string(
							$author$project$Domain$EmailAddress$toString(data)))
					])));
	});
var $author$project$Components$SettingsPage$DebtorLayout$billingEmailConfig = F2(
	function (tmsControlled, debtorId) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Debtors$billingEmail(debtorId),
						$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity))),
				$elm$core$Result$withDefault($author$project$HubTran$Effect$none)),
			formView: $author$project$Components$SettingsPage$Shared$BillingEmail$formView(tmsControlled),
			summaryView: $author$project$Components$SettingsPage$Shared$BillingEmail$summaryView,
			title: 'Billing Email',
			toMsg: $author$project$Components$SettingsPage$DebtorLayout$BillingEmailUpdate
		};
	});
var $author$project$Components$SettingsPage$DebtorLayout$BillingIntervalUpdate = function (a) {
	return {$: 'BillingIntervalUpdate', a: a};
};
var $author$project$Api$Debtors$billingInterval = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'billing_interval',
						$elm$json$Json$Encode$string(
							$author$project$Domain$BillingInterval$encoded(data)))
					])));
	});
var $author$project$Components$SettingsPage$DebtorLayout$billingIntervalConfig = function (debtorId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Debtors$billingInterval(debtorId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$BillingInterval$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$BillingInterval$summaryView,
		title: 'Billing Interval',
		toMsg: $author$project$Components$SettingsPage$DebtorLayout$BillingIntervalUpdate
	};
};
var $author$project$Components$SettingsPage$DebtorLayout$DebtorContactInfoUpdate = function (a) {
	return {$: 'DebtorContactInfoUpdate', a: a};
};
var $author$project$Api$Debtors$contactInfo = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'contact_info',
						$elm$json$Json$Encode$string(data))
					])));
	});
var $author$project$Components$SettingsPage$Shared$DebtorContactInfo$formView = F4(
	function (set, save, _v0, result) {
		if (result.$ === 'Ok') {
			var contactInfo = result.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						$author$project$Helpers$Attributes$blockGrammarly(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('contactinfo'),
									$elm$html$Html$Attributes$value(contactInfo),
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, set, $elm$core$Result$Ok))
								])),
						_List_Nil),
						A3($author$project$Components$Shared$Button$confirm, 'Save Contact Info', save, _List_Nil)
					]));
		} else {
			var invalid = result.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						$author$project$Helpers$Attributes$blockGrammarly(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('contactinfo'),
									$elm$html$Html$Attributes$value(invalid),
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, set, $elm$core$Result$Ok)),
									$elm$html$Html$Attributes$class('error')
								])),
						_List_Nil),
						A3(
						$elm$html$Html$node,
						'small',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('error')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Something went wrong')
							])),
						A2($author$project$Components$Shared$Button$disabled, 'Fix errors to save', _List_Nil)
					]));
		}
	});
var $author$project$Domain$EmailBody$carriageReturn = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\u000D\u000A|\u000D'));
var $author$project$Domain$EmailBody$dropFirstBlank = function (input) {
	return _Utils_eq(
		$elm$core$List$head(input),
		$elm$core$Maybe$Just('')) ? A2($elm$core$List$drop, 1, input) : input;
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Domain$EmailBody$paragraph = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$lines,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Domain$EmailBody$dropFirstBlank,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($elm$html$Html$text),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$intersperse(
					A2($elm$html$Html$br, _List_Nil, _List_Nil)),
				$elm$html$Html$p(_List_Nil)))));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$Domain$EmailBody$textToHtml = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm$regex$Regex$replace,
		$author$project$Domain$EmailBody$carriageReturn,
		$elm$core$Basics$always('\u000A')),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$split('\u000A\u000A'),
		$elm$core$List$map($author$project$Domain$EmailBody$paragraph)));
var $author$project$Components$SettingsPage$Shared$DebtorContactInfo$summaryView = function (result) {
	var info = function () {
		if (result.$ === 'Ok') {
			var contactInfo = result.a;
			return contactInfo;
		} else {
			var string = result.a;
			return string;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Domain$EmailBody$textToHtml(info));
};
var $author$project$Components$SettingsPage$DebtorLayout$contactInfoConfig = function (debtorId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$map(
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Debtors$contactInfo(debtorId),
					$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity))),
			$elm$core$Result$withDefault($author$project$HubTran$Effect$none)),
		formView: $author$project$Components$SettingsPage$Shared$DebtorContactInfo$formView,
		summaryView: $author$project$Components$SettingsPage$Shared$DebtorContactInfo$summaryView,
		title: 'Contact Information',
		toMsg: $author$project$Components$SettingsPage$DebtorLayout$DebtorContactInfoUpdate
	};
};
var $author$project$Components$SettingsPage$DebtorLayout$DeliveryMethodUpdate = function (a) {
	return {$: 'DeliveryMethodUpdate', a: a};
};
var $author$project$Api$Debtors$deliveryMethod = function (id) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Api$Debtors$defaultSend(id),
		$author$project$Encode$DeliveryMethodEncoder$encodeDeliveryMethod);
};
var $author$project$Components$SettingsPage$DebtorLayout$deliveryMethodConfig = F2(
	function (debtorId, data) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Debtors$deliveryMethod(debtorId),
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
			formView: $author$project$Components$SettingsPage$Shared$DeliveryMethod$formView(
				{
					accountSettings: data.accountSettings,
					currentDeliveryMethod: $author$project$Domain$DeliveryMethodFromPb$fromPb(data.debtorSettings.deliveryMethod.method),
					enableChangingType: true,
					isFactor: true,
					templateVariables: data.debtorSettings.templateVariables
				}),
			summaryView: A2(
				$author$project$Components$SettingsPage$Shared$DeliveryMethod$summaryView,
				{isFactor: true},
				data.accountSettings),
			title: 'Send invoices via',
			toMsg: $author$project$Components$SettingsPage$DebtorLayout$DeliveryMethodUpdate
		};
	});
var $author$project$Api$Debtors$factorBrokerLoadIdRegressionRuleMode = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'factor_broker_load_id_regression_rule_mode',
						$elm$json$Json$Encode$string(
							$author$project$AuditPb$rulesModeToString(data)))
					])));
	});
var $author$project$Components$SettingsPage$DebtorLayout$finishedSaving = function (record) {
	return _Utils_update(
		record,
		{saving: false});
};
var $author$project$Components$SettingsPage$DebtorLayout$InvoiceTemplateUpdate = function (a) {
	return {$: 'InvoiceTemplateUpdate', a: a};
};
var $author$project$Api$Debtors$invoiceTemplate = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'customer_invoice_template_id',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$CustomerInvoiceTemplateId$toInt),
								data)))
					])));
	});
var $author$project$Components$SettingsPage$DebtorLayout$invoiceTemplateConfig = F2(
	function (debtorId, templates) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Debtors$invoiceTemplate(debtorId),
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
			formView: $author$project$Components$SettingsPage$Shared$InvoiceTemplate$formView(templates),
			summaryView: $author$project$Components$SettingsPage$Shared$InvoiceTemplate$summaryView(templates),
			title: 'Invoice Template',
			toMsg: $author$project$Components$SettingsPage$DebtorLayout$InvoiceTemplateUpdate
		};
	});
var $author$project$AuditPb$loadIdStrategyEncoder = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$AuditPb$loadIdStrategyToString);
var $author$project$Domain$LoadIdStrategy$encodeList = function (strategies) {
	return A2($elm$json$Json$Encode$list, $author$project$AuditPb$loadIdStrategyEncoder, strategies);
};
var $author$project$Api$Debtors$loadIdStrategies = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'load_id_strategies',
						$author$project$Domain$LoadIdStrategy$encodeList(data))
					])));
	});
var $author$project$Api$Debtors$rateConfirmationRequired = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'rate_confirmation_required',
						$elm$json$Json$Encode$bool(data))
					])));
	});
var $author$project$Api$Debtors$setLoadIdAutoRelease = F2(
	function (id, enabled) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'load_id_prefill_autofill_enabled',
						$elm$json$Json$Encode$bool(enabled))
					])));
	});
var $author$project$Api$Debtors$skipAutoStamp = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'skip_auto_stamp',
						$elm$json$Json$Encode$bool(data))
					])));
	});
var $author$project$Components$SettingsPage$DebtorLayout$SpecialAccessorialsUpdate = function (a) {
	return {$: 'SpecialAccessorialsUpdate', a: a};
};
var $author$project$Api$Debtors$flag = F2(
	function (name, condition) {
		return condition ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				name,
				$elm$json$Json$Encode$bool(true))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Api$Debtors$invoiceExtractedFields = F2(
	function (id, data) {
		var field = function (_v0) {
			var advance = _v0.advance;
			var cleanAmount = _v0.cleanAmount;
			var lineItem = _v0.lineItem;
			var label = _v0.label;
			var name = _v0.name;
			return $elm$json$Json$Encode$object(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name))),
							$elm$core$Maybe$Just(
							_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(label))),
							A2($author$project$Api$Debtors$flag, 'line_item', lineItem),
							A2($author$project$Api$Debtors$flag, 'clean_amount', cleanAmount),
							A2($author$project$Api$Debtors$flag, 'advance', advance)
						])));
		};
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'factor_invoice_extracted_fields',
						A2($elm$json$Json$Encode$list, field, data))
					])));
	});
var $elm$core$String$map = _String_map;
var $elm$core$Char$toLower = _Char_toLower;
var $author$project$Components$SettingsPage$DebtorLayout$nameFromLabel = $elm$core$String$map(
	function (c) {
		return _Utils_eq(
			c,
			_Utils_chr(' ')) ? _Utils_chr('_') : $elm$core$Char$toLower(c);
	});
var $author$project$Components$SettingsPage$DebtorLayout$newAccessorial = {advance: false, cleanAmount: true, label: '', lineItem: true, name: ''};
var $author$project$Components$SettingsPage$DebtorLayout$row = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('row')
		]));
var $author$project$Components$SettingsPage$DebtorLayout$row1 = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			])),
	$elm$core$List$singleton);
var $author$project$Components$SettingsPage$DebtorLayout$setAt = F2(
	function (target, replacement) {
		return $elm$core$List$indexedMap(
			F2(
				function (index, current) {
					return _Utils_eq(index, target) ? replacement : current;
				}));
	});
var $author$project$Components$SettingsPage$DebtorLayout$specialAccessorialsFormView = F4(
	function (set, save, _v0, fields) {
		var fieldRow = F2(
			function (index, field) {
				return $author$project$Components$SettingsPage$DebtorLayout$row(
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Grid$column,
							5,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for(
											'specialaccessorials' + $elm$core$String$fromInt(index))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Label:')
										])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id(
											'specialaccessorials' + $elm$core$String$fromInt(index)),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(field.label),
											$elm$html$Html$Events$onInput(
											function (str) {
												return set(
													A3(
														$author$project$Components$SettingsPage$DebtorLayout$setAt,
														index,
														_Utils_update(
															field,
															{
																label: str,
																name: $author$project$Components$SettingsPage$DebtorLayout$nameFromLabel(str)
															}),
														fields));
											})
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('special-invoicing__advance-checkbox')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Grid$column,
									5,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('checkbox'),
													$elm$html$Html$Attributes$id(
													'specialaccessorialsadvance' + $elm$core$String$fromInt(index)),
													$elm$html$Html$Attributes$checked(field.advance),
													$elm$html$Html$Events$onCheck(
													function (bool) {
														return set(
															A3(
																$author$project$Components$SettingsPage$DebtorLayout$setAt,
																index,
																_Utils_update(
																	field,
																	{advance: bool}),
																fields));
													})
												]),
											_List_Nil),
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for(
													'specialaccessorialsadvance' + $elm$core$String$fromInt(index))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Advance?')
												]))
										]))
								]))
						]));
			});
		var buttonRows = _List_fromArray(
			[
				$author$project$Components$SettingsPage$DebtorLayout$row1(
				A2(
					$author$project$Components$Shared$Grid$column,
					10,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									set(
										_Utils_ap(
											fields,
											_List_fromArray(
												[$author$project$Components$SettingsPage$DebtorLayout$newAccessorial]))))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-plus')
										]),
									_List_Nil),
									$elm$html$Html$text('Add Accessorials')
								]))
						]))),
				$author$project$Components$SettingsPage$DebtorLayout$row1(
				A2(
					$author$project$Components$Shared$Grid$column,
					10,
					_List_fromArray(
						[
							A3($author$project$Components$Shared$Button$confirm, 'Save Accessorials', save, _List_Nil)
						])))
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				A2($elm$core$List$indexedMap, fieldRow, fields),
				buttonRows));
	});
var $author$project$Components$SettingsPage$DebtorLayout$space = A2(
	$elm$html$Html$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text($author$project$Helpers$String$nbsp)
		]));
var $author$project$Components$SettingsPage$DebtorLayout$when = F3(
	function (condition, func, value) {
		return condition ? func(value) : $elm$html$Html$text('');
	});
var $author$project$Components$SettingsPage$DebtorLayout$specialAccessorialsSummaryView = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$div(_List_Nil),
	$elm$core$List$map(
		function (_v0) {
			var advance = _v0.advance;
			var label = _v0.label;
			return $author$project$Components$SettingsPage$DebtorLayout$row1(
				A2(
					$author$project$Components$Shared$Grid$column,
					10,
					_List_fromArray(
						[
							$elm$html$Html$text(label),
							$author$project$Components$SettingsPage$DebtorLayout$space,
							A3(
							$author$project$Components$SettingsPage$DebtorLayout$when,
							advance,
							$elm$html$Html$div(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('special-invoicing__advance-label')
									])),
							_List_fromArray(
								[
									$elm$html$Html$text('Advance')
								]))
						])));
		}));
var $author$project$Components$SettingsPage$DebtorLayout$specialAccessorialsConfig = F2(
	function (debtorId, debtorSettings) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$elm$core$List$append(
					$author$project$Components$SettingsPage$DebtorLayout$onlyFields(debtorSettings)),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Debtors$invoiceExtractedFields(debtorId),
					$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity))),
			formView: $author$project$Components$SettingsPage$DebtorLayout$specialAccessorialsFormView,
			summaryView: $author$project$Components$SettingsPage$DebtorLayout$specialAccessorialsSummaryView,
			title: 'Special Invoicing Accessorials',
			toMsg: $author$project$Components$SettingsPage$DebtorLayout$SpecialAccessorialsUpdate
		};
	});
var $author$project$Components$SettingsPage$DebtorLayout$SpecialFieldsUpdate = function (a) {
	return {$: 'SpecialFieldsUpdate', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$newField = {advance: false, cleanAmount: false, label: '', lineItem: false, name: ''};
var $author$project$Components$SettingsPage$DebtorLayout$specialFieldsFormView = F4(
	function (set, save, _v0, fields) {
		var fieldRow = F2(
			function (index, field) {
				return $author$project$Components$SettingsPage$DebtorLayout$row1(
					A2(
						$author$project$Components$Shared$Grid$column,
						10,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for(
										'specialfields' + $elm$core$String$fromInt(index))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Label:')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id(
										'specialfields' + $elm$core$String$fromInt(index)),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$value(field.label),
										$elm$html$Html$Events$onInput(
										function (s) {
											return set(
												A3(
													$author$project$Components$SettingsPage$DebtorLayout$setAt,
													index,
													_Utils_update(
														field,
														{
															label: s,
															name: $author$project$Components$SettingsPage$DebtorLayout$nameFromLabel(s)
														}),
													fields));
										})
									]),
								_List_Nil)
							])));
			});
		var buttonRows = _List_fromArray(
			[
				$author$project$Components$SettingsPage$DebtorLayout$row1(
				A2(
					$author$project$Components$Shared$Grid$column,
					10,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									set(
										_Utils_ap(
											fields,
											_List_fromArray(
												[$author$project$Components$SettingsPage$DebtorLayout$newField]))))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-plus')
										]),
									_List_Nil),
									$elm$html$Html$text('Add Field')
								]))
						]))),
				$author$project$Components$SettingsPage$DebtorLayout$row1(
				A2(
					$author$project$Components$Shared$Grid$column,
					10,
					_List_fromArray(
						[
							A3($author$project$Components$Shared$Button$confirm, 'Save Fields', save, _List_Nil)
						])))
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				A2($elm$core$List$indexedMap, fieldRow, fields),
				buttonRows));
	});
var $author$project$Components$SettingsPage$DebtorLayout$specialFieldsSummaryView = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$div(_List_Nil),
	$elm$core$List$map(
		function (_v0) {
			var label = _v0.label;
			return $author$project$Components$SettingsPage$DebtorLayout$row1(
				A2(
					$author$project$Components$Shared$Grid$column,
					10,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])));
		}));
var $author$project$Components$SettingsPage$DebtorLayout$specialFieldsConfig = F2(
	function (debtorId, debtorSettings) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$elm$core$List$append(
					$author$project$Components$SettingsPage$DebtorLayout$onlyAccessorials(debtorSettings)),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Debtors$invoiceExtractedFields(debtorId),
					$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity))),
			formView: $author$project$Components$SettingsPage$DebtorLayout$specialFieldsFormView,
			summaryView: $author$project$Components$SettingsPage$DebtorLayout$specialFieldsSummaryView,
			title: 'Special Invoicing Fields',
			toMsg: $author$project$Components$SettingsPage$DebtorLayout$SpecialFieldsUpdate
		};
	});
var $author$project$Components$SettingsPage$DebtorLayout$startSaving = function (record) {
	return _Utils_update(
		record,
		{saving: true});
};
var $author$project$Api$Debtors$updateVerificationWorkflow = F2(
	function (id, params) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'exclude_from_verifications_workflow',
						$elm$json$Json$Encode$bool(params.excludeFromVerificationsWorkflow)),
						_Utils_Tuple2(
						'require_verifications_workflow',
						$elm$json$Json$Encode$bool(params.requireVerificationsWorkflow))
					])));
	});
var $author$project$Components$SettingsPage$DebtorLayout$WarnIfAmountOverUpdate = function (a) {
	return {$: 'WarnIfAmountOverUpdate', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$viewWarnIfAmountOverForm = F4(
	function (set, save, _v0, result) {
		var submitButton = A3($author$project$Components$Shared$Button$confirm, 'Save Amount', save, _List_Nil);
		var handleInput = function (input) {
			return $elm$core$String$isEmpty(input) ? set($elm$core$Maybe$Nothing) : set(
				$elm$core$String$toInt(input));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Require manual review for invoice amounts over this value. Please leave blank to be disabled.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row collapse')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-1 column begin')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('prefix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('$')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-6 column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('number'),
													$elm$html$Html$Attributes$value(
													function () {
														if (result.$ === 'Just') {
															var i = result.a;
															return $elm$core$String$fromInt(i);
														} else {
															return '';
														}
													}()),
													$elm$html$Html$Events$onInput(handleInput),
													$elm$html$Html$Attributes$min('0')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-2 column end')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('postfix')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('.00')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-4')
						]),
					_List_fromArray(
						[submitButton]))
				]));
	});
var $author$project$Components$SettingsPage$DebtorLayout$viewWarnIfAmountOverSummary = function (maybeWarnIfAmountOver) {
	var noAmountSet = A2(
		$elm$html$Html$pre,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('No invoice amount is set to require manual review.')
			]));
	if (maybeWarnIfAmountOver.$ === 'Just') {
		var warnOverAmount = maybeWarnIfAmountOver.a;
		var warnOverString = $elm$core$String$fromInt(warnOverAmount);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoices over $'),
							$elm$html$Html$text(warnOverString),
							$elm$html$Html$text(' will create an exception of:')
						])),
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice amount of $XXXX exceeds $'),
							$elm$html$Html$text(warnOverString),
							$elm$html$Html$text(' and requires manual review.')
						]))
				]));
	} else {
		return noAmountSet;
	}
};
var $author$project$Api$Debtors$maybeInt = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$json$Json$Encode$int),
	$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
var $author$project$Api$Debtors$warnIfAmountOver = F2(
	function (id, data) {
		return A2(
			$author$project$Api$Debtors$defaultSend,
			id,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'warn_if_amount_over',
						$author$project$Api$Debtors$maybeInt(data))
					])));
	});
var $author$project$Components$SettingsPage$DebtorLayout$warnIfAmountOverConfig = function (debtorId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Debtors$warnIfAmountOver(debtorId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$DebtorLayout$viewWarnIfAmountOverForm,
		summaryView: $author$project$Components$SettingsPage$DebtorLayout$viewWarnIfAmountOverSummary,
		title: 'Warn Over Invoice Amount',
		toMsg: $author$project$Components$SettingsPage$DebtorLayout$WarnIfAmountOverUpdate
	};
};
var $author$project$Components$SettingsPage$DebtorLayout$updateForm = F4(
	function (loadedMsg, debtorId, data, formState) {
		switch (loadedMsg.$) {
			case 'GoBack':
				return _Utils_Tuple2(
					formState,
					$author$project$HubTran$Effect$cmd(
						$author$project$HubTran$Navigation$back(1)));
			case 'DeliveryMethodUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{deliveryMethod: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$DebtorLayout$deliveryMethodConfig, debtorId, data),
						msg,
						formState.deliveryMethod));
			case 'DocumentTypesUpdate':
				var msg = loadedMsg.a;
				var _v1 = A3(
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$update,
					A2($author$project$Components$SettingsPage$DebtorLayout$documentTypesSettingsFromData, debtorId, data),
					msg,
					formState.documentTypes);
				var model = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{documentTypes: model}),
					A2($author$project$HubTran$Effect$map, $author$project$Components$SettingsPage$DebtorLayout$DocumentTypesUpdate, cmd));
			case 'BillingEmailUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{billingEmail: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$DebtorLayout$billingEmailConfig, data.accountSettings.controlledByTMS.debtorBillingEmail, debtorId),
						msg,
						formState.billingEmail));
			case 'BillingIntervalUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{billingInterval: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$DebtorLayout$billingIntervalConfig(debtorId),
						msg,
						formState.billingInterval));
			case 'DebtorContactInfoUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{contactInfo: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$DebtorLayout$contactInfoConfig(debtorId),
						msg,
						formState.contactInfo));
			case 'InvoiceTemplateUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{invoiceTemplate: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$DebtorLayout$invoiceTemplateConfig, debtorId, data.invoiceTemplates),
						msg,
						formState.invoiceTemplate));
			case 'WarnIfAmountOverUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{warnIfAmountOver: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						$author$project$Components$SettingsPage$DebtorLayout$warnIfAmountOverConfig(debtorId),
						msg,
						formState.warnIfAmountOver));
			case 'RateConfirmationRequired_Set':
				var required = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							rateConfirmationRequired: $author$project$Components$SettingsPage$DebtorLayout$startSaving(formState.rateConfirmationRequired)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						function (_v2) {
							return $author$project$Components$SettingsPage$DebtorLayout$RateConfirmationRequired_Finish;
						},
						A2($author$project$Api$Debtors$rateConfirmationRequired, debtorId, required)));
			case 'RateConfirmationRequired_Finish':
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							rateConfirmationRequired: $author$project$Components$SettingsPage$DebtorLayout$finishedSaving(formState.rateConfirmationRequired)
						}),
					$author$project$HubTran$Effect$none);
			case 'SkipAutoStamp_Set':
				var skip = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							skipAutoStamp: $author$project$Components$SettingsPage$DebtorLayout$startSaving(formState.skipAutoStamp)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						function (_v3) {
							return $author$project$Components$SettingsPage$DebtorLayout$SkipAutoStamp_Finish;
						},
						A2($author$project$Api$Debtors$skipAutoStamp, debtorId, skip)));
			case 'SkipAutoStamp_Finish':
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							skipAutoStamp: $author$project$Components$SettingsPage$DebtorLayout$finishedSaving(formState.skipAutoStamp)
						}),
					$author$project$HubTran$Effect$none);
			case 'AllowAutoprocessing_Set':
				var allow = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							allowAutoprocessing: $author$project$Components$SettingsPage$DebtorLayout$startSaving(formState.allowAutoprocessing)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						function (_v4) {
							return $author$project$Components$SettingsPage$DebtorLayout$AllowAutoprocessing_Finish;
						},
						A2($author$project$Api$Debtors$allowAutoprocessing, debtorId, allow)));
			case 'AllowAutoprocessing_Finish':
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							allowAutoprocessing: $author$project$Components$SettingsPage$DebtorLayout$finishedSaving(formState.allowAutoprocessing)
						}),
					$author$project$HubTran$Effect$none);
			case 'LoadIdStrategies_Toggle':
				var strategy = loadedMsg.a;
				var enabled = loadedMsg.b;
				var current = formState.loadIdStrategies;
				var selected = A2(
					$elm$core$List$filter,
					function (candidate) {
						return _Utils_eq(candidate, strategy) ? enabled : A2($elm$core$List$member, candidate, current.value);
					},
					$author$project$AuditPb$allLoadIdStrategy);
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							loadIdStrategies: $author$project$Components$SettingsPage$DebtorLayout$startSaving(
								_Utils_update(
									current,
									{value: selected}))
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						function (_v5) {
							return $author$project$Components$SettingsPage$DebtorLayout$LoadIdStrategies_Finish;
						},
						A2($author$project$Api$Debtors$loadIdStrategies, debtorId, selected)));
			case 'LoadIdStrategies_Finish':
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							loadIdStrategies: $author$project$Components$SettingsPage$DebtorLayout$finishedSaving(formState.loadIdStrategies)
						}),
					$author$project$HubTran$Effect$none);
			case 'SpecialAccessorialsUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{specialAccessorials: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$DebtorLayout$specialAccessorialsConfig, debtorId, data.debtorSettings),
						msg,
						formState.specialAccessorials));
			case 'SpecialFieldsUpdate':
				var msg = loadedMsg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							formState,
							{specialFields: x});
					},
					A3(
						$author$project$Components$SettingsPage$Shared$EditSection$update,
						A2($author$project$Components$SettingsPage$DebtorLayout$specialFieldsConfig, debtorId, data.debtorSettings),
						msg,
						formState.specialFields));
			case 'SetVerificationWorkflow':
				var state = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							excludeFromVerificationsWorkflow: $author$project$Components$SettingsPage$DebtorLayout$startSaving(formState.excludeFromVerificationsWorkflow),
							requireVerificationsWorkflow: $author$project$Components$SettingsPage$DebtorLayout$startSaving(formState.requireVerificationsWorkflow)
						}),
					function () {
						switch (state.$) {
							case 'Default':
								return A2(
									$author$project$HubTran$Effect$sendCacheableRequestWithError,
									function (_v7) {
										return $author$project$Components$SettingsPage$DebtorLayout$SetVerificationWorkflow_Finish;
									},
									A2(
										$author$project$Api$Debtors$updateVerificationWorkflow,
										debtorId,
										{excludeFromVerificationsWorkflow: false, requireVerificationsWorkflow: false}));
							case 'NotRequired':
								return A2(
									$author$project$HubTran$Effect$sendCacheableRequestWithError,
									function (_v8) {
										return $author$project$Components$SettingsPage$DebtorLayout$SetVerificationWorkflow_Finish;
									},
									A2(
										$author$project$Api$Debtors$updateVerificationWorkflow,
										debtorId,
										{excludeFromVerificationsWorkflow: true, requireVerificationsWorkflow: false}));
							default:
								return A2(
									$author$project$HubTran$Effect$sendCacheableRequestWithError,
									function (_v9) {
										return $author$project$Components$SettingsPage$DebtorLayout$SetVerificationWorkflow_Finish;
									},
									A2(
										$author$project$Api$Debtors$updateVerificationWorkflow,
										debtorId,
										{excludeFromVerificationsWorkflow: false, requireVerificationsWorkflow: true}));
						}
					}());
			case 'SetVerificationWorkflow_Finish':
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							excludeFromVerificationsWorkflow: $author$project$Components$SettingsPage$DebtorLayout$finishedSaving(formState.excludeFromVerificationsWorkflow),
							requireVerificationsWorkflow: $author$project$Components$SettingsPage$DebtorLayout$finishedSaving(formState.requireVerificationsWorkflow)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetFactorBrokerLoadIdRegressionRuleMode':
				var mode = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							factorBrokerLoadIdRegressionRuleMode: $author$project$Components$SettingsPage$DebtorLayout$startSaving(formState.factorBrokerLoadIdRegressionRuleMode)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						function (_v10) {
							return $author$project$Components$SettingsPage$DebtorLayout$SetFactorBrokerLoadIdRegressionRuleMode_Finish;
						},
						A2($author$project$Api$Debtors$factorBrokerLoadIdRegressionRuleMode, debtorId, mode)));
			case 'SetFactorBrokerLoadIdRegressionRuleMode_Finish':
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							factorBrokerLoadIdRegressionRuleMode: $author$project$Components$SettingsPage$DebtorLayout$finishedSaving(formState.factorBrokerLoadIdRegressionRuleMode)
						}),
					$author$project$HubTran$Effect$none);
			case 'LoadIdAutoRelease_Set':
				var enabled = loadedMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							loadIdAutoRelease: $author$project$Components$SettingsPage$DebtorLayout$startSaving(formState.loadIdAutoRelease)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						function (_v11) {
							return $author$project$Components$SettingsPage$DebtorLayout$LoadIdAutoRelease_Finish;
						},
						A2($author$project$Api$Debtors$setLoadIdAutoRelease, debtorId, enabled)));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						formState,
						{
							loadIdAutoRelease: $author$project$Components$SettingsPage$DebtorLayout$finishedSaving(formState.loadIdAutoRelease)
						}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$DebtorLayout$update = F3(
	function (data, msg, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(data);
		if (_v0.$ === 'Just') {
			var data_ = _v0.a;
			var formState = A2($author$project$Components$SettingsPage$DebtorLayout$mergeFormData, data_, model);
			var _v1 = A4($author$project$Components$SettingsPage$DebtorLayout$updateForm, msg, model.debtorId, data_, formState);
			var newFormState = _v1.a;
			var effect = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						formState: $elm$core$Maybe$Just(newFormState)
					}),
				effect);
		} else {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$loadedModelFromData = F2(
	function (data, model) {
		var _v0 = model.loadedModel;
		if (_v0.$ === 'Nothing') {
			return {isSaving: false, origVisibleTmsReferenceFieldLabels: data.accountSettings.visibleTMSReferenceFieldLabels, tmsReferenceFieldsState: $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$init, visibleTmsReferenceFieldLabels: data.accountSettings.visibleTMSReferenceFieldLabels};
		} else {
			var loadedModel = _v0.a;
			return loadedModel;
		}
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$insertAt = F3(
	function (index, x, list) {
		if (!index) {
			return A2($elm$core$List$cons, x, list);
		} else {
			if (!list.b) {
				return _List_fromArray(
					[x]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A3($author$project$Components$SettingsPage$ReferenceFieldsLayout$insertAt, index - 1, x, rest));
			}
		}
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$remove = function (x) {
	return $elm$core$List$filter(
		function (el) {
			return !_Utils_eq(el, x);
		});
};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$FinishSaving = function (a) {
	return {$: 'FinishSaving', a: a};
};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$sendSave = $author$project$HubTran$Effect$sendCacheableRequestWithError(
	function (result) {
		return $author$project$Components$SettingsPage$ReferenceFieldsLayout$FinishSaving(
			function () {
				switch (result.$) {
					case 'Ok':
						return $elm$core$Result$Ok(_Utils_Tuple0);
					case 'Err':
						var message = result.a;
						return $elm$core$Result$Err(message);
					default:
						return $elm$core$Result$Err('HTTP Error');
				}
			}());
	});
var $author$project$Api$Accounts$tmsReferenceFields = function (visibleTmsReferenceFieldLabels) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tms_reference_fields',
					$author$project$Api$Accounts$encodeTmsReferenceFields(visibleTmsReferenceFieldLabels)),
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$updateLoaded = F2(
	function (msg, loadedModel) {
		switch (msg.$) {
			case 'SelectTmsReferenceFieldLabel':
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							visibleTmsReferenceFieldLabels: A2($elm$core$List$cons, string, loadedModel.visibleTmsReferenceFieldLabels)
						}),
					$author$project$HubTran$Effect$none);
			case 'UnselectTmsReferenceFieldLabel':
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							visibleTmsReferenceFieldLabels: A2($author$project$Components$SettingsPage$ReferenceFieldsLayout$remove, string, loadedModel.visibleTmsReferenceFieldLabels)
						}),
					$author$project$HubTran$Effect$none);
			case 'ReorderTmsReferenceFieldLabel':
				var to = msg.a;
				var string = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{
							visibleTmsReferenceFieldLabels: A3(
								$author$project$Components$SettingsPage$ReferenceFieldsLayout$insertAt,
								to,
								string,
								A2($author$project$Components$SettingsPage$ReferenceFieldsLayout$remove, string, loadedModel.visibleTmsReferenceFieldLabels))
						}),
					$author$project$HubTran$Effect$none);
			case 'TmsReferenceFieldsMsg':
				var tmsReferenceFieldsMsg = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (x) {
						return _Utils_update(
							loadedModel,
							{tmsReferenceFieldsState: x});
					},
					$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$ReferenceFieldsLayout$TmsReferenceFieldsMsg),
					A2($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$update, tmsReferenceFieldsMsg, loadedModel.tmsReferenceFieldsState));
			case 'Save':
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{isSaving: true}),
					$author$project$Components$SettingsPage$ReferenceFieldsLayout$sendSave(
						$author$project$Api$Accounts$tmsReferenceFields(loadedModel.visibleTmsReferenceFieldLabels)));
			case 'Cancel':
				return _Utils_Tuple2(
					_Utils_update(
						loadedModel,
						{visibleTmsReferenceFieldLabels: loadedModel.origVisibleTmsReferenceFieldLabels}),
					$author$project$HubTran$Effect$none);
			default:
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							loadedModel,
							{isSaving: false, origVisibleTmsReferenceFieldLabels: loadedModel.visibleTmsReferenceFieldLabels}),
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$success('Successfully saved reference fields')));
				} else {
					var str = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							loadedModel,
							{isSaving: false}),
						$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$alert('Failed to save reference fields: ' + str)));
				}
		}
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$update = F3(
	function (remoteData, msg, model) {
		if (remoteData.$ === 'Loaded') {
			var data = remoteData.a;
			return A2(
				$elm$core$Tuple$mapFirst,
				function (x) {
					return _Utils_update(
						model,
						{
							loadedModel: $elm$core$Maybe$Just(x)
						});
				},
				A2(
					$author$project$Components$SettingsPage$ReferenceFieldsLayout$updateLoaded,
					msg,
					A2($author$project$Components$SettingsPage$ReferenceFieldsLayout$loadedModelFromData, data, model)));
		} else {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$ReportsLayout$FinishedScrolling = {$: 'FinishedScrolling'};
var $author$project$Components$SettingsPage$ReportsLayout$SendReportFinished = function (a) {
	return {$: 'SendReportFinished', a: a};
};
var $author$project$Api$Reports$Encode$reportWithDateRange = F2(
	function (type_, dateRange) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'start_date',
					$elm$json$Json$Encode$string(
						$author$project$Helpers$Date$toRfc3339(dateRange.startDate))),
					_Utils_Tuple2(
					'end_date',
					$elm$json$Json$Encode$string(
						$author$project$Helpers$Date$toRfc3339(dateRange.endDate))),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(type_))
				]));
	});
var $author$project$Api$Reports$Encode$reportWithoutDateRange = function (type_) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(type_))
			]));
};
var $author$project$Api$Reports$Encode$report = function (report_) {
	switch (report_.$) {
		case 'CarrierInvoicingBillingDetailsReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Carrier Invoicing Billing Detail Report', dateRange);
		case 'FactorInvoicingBillingDetailsReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Factor Invoicing Billing Detail Report', dateRange);
		case 'CustomerInvoicesSentReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Customer Invoices Sent Report', dateRange);
		case 'DocumentRetrievalBillingDetailsReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Document Retrieval Billing Detail Report', dateRange);
		case 'ProcessorScorecardReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Processor Scorecard Report', dateRange);
		case 'IndexerScorecardReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Indexer Scorecard Report', dateRange);
		case 'IndexingActivityReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Indexing Activity Report', dateRange);
		case 'AuditorScorecardReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Auditor Scorecard Report', dateRange);
		case 'UserActivityReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'User Activity Report', dateRange);
		case 'VerificationsReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Verifications Report', dateRange);
		case 'VerificationsWorkflowReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Verifications Workflow Report', dateRange);
		case 'VerifierScorecardReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Verifier Scorecard Report', dateRange);
		case 'InvoiceExceptionReport':
			return $author$project$Api$Reports$Encode$reportWithoutDateRange('Invoice Exception Report');
		case 'AllPayablesExceptionsReport':
			return $author$project$Api$Reports$Encode$reportWithoutDateRange('All Payables Exceptions Report');
		case 'UnbilledInvoicesReport':
			return $author$project$Api$Reports$Encode$reportWithoutDateRange('Unbilled Invoices Report');
		case 'LoadsRequiringActionReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Loads Missing Documents Report', dateRange);
		case 'CustomerInvoiceDeliveryMethodReport':
			return $author$project$Api$Reports$Encode$reportWithoutDateRange('Customer Invoice Delivery Method Report');
		case 'NewQueueSnapshotReport':
			return $author$project$Api$Reports$Encode$reportWithoutDateRange('New Queue Snapshot Report');
		case 'RtaSnapshotReport':
			return $author$project$Api$Reports$Encode$reportWithoutDateRange('Ready To Audit Queue Snapshot Report');
		case 'EmailActivityReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Email Activity Report', dateRange);
		case 'AutoNidfBatchesReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Auto NIDF Batches Report', dateRange);
		case 'LtlLoadsReport':
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'LTL Loads Report', dateRange);
		case 'CustomerRulesReport':
			return $author$project$Api$Reports$Encode$reportWithoutDateRange('Customer Rules Report');
		case 'DocumentScraperStatusReport':
			return $author$project$Api$Reports$Encode$reportWithoutDateRange('Document Retrieval Status Report');
		default:
			var dateRange = report_.a;
			return A2($author$project$Api$Reports$Encode$reportWithDateRange, 'Carrier Scorecard Report', dateRange);
	}
};
var $author$project$Api$Reports$create = function (report) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/reports',
		$author$project$Api$Reports$Encode$report(report));
};
var $ianmackenzie$elm_units$Constants$second = 1;
var $ianmackenzie$elm_units$Constants$minute = 60 * $ianmackenzie$elm_units$Constants$second;
var $ianmackenzie$elm_units$Constants$hour = 60 * $ianmackenzie$elm_units$Constants$minute;
var $ianmackenzie$elm_units$Constants$day = 24 * $ianmackenzie$elm_units$Constants$hour;
var $ianmackenzie$elm_units$Duration$days = function (numDays) {
	return $ianmackenzie$elm_units$Duration$seconds($ianmackenzie$elm_units$Constants$day * numDays);
};
var $justinmimbs$date$Date$Days = {$: 'Days'};
var $justinmimbs$date$Date$Months = {$: 'Months'};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0.a;
		switch (unit.$) {
			case 'Years':
				return A3(
					$justinmimbs$date$Date$add,
					$justinmimbs$date$Date$Months,
					12 * n,
					$justinmimbs$date$Date$RD(rd));
			case 'Months':
				var date = $justinmimbs$date$Date$toCalendarDate(
					$justinmimbs$date$Date$RD(rd));
				var wholeMonths = ((12 * (date.year - 1)) + ($justinmimbs$date$Date$monthToNumber(date.month) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return $justinmimbs$date$Date$RD(
					($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
						$elm$core$Basics$min,
						date.day,
						A2($justinmimbs$date$Date$daysInMonth, y, m)));
			case 'Weeks':
				return $justinmimbs$date$Date$RD(rd + (7 * n));
			default:
				return $justinmimbs$date$Date$RD(rd + n);
		}
	});
var $ianmackenzie$elm_units$Duration$inDays = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) / $ianmackenzie$elm_units$Constants$day;
};
var $author$project$Components$SettingsPage$ReportsLayout$earlier = F2(
	function (duration, date) {
		return A3(
			$justinmimbs$date$Date$add,
			$justinmimbs$date$Date$Days,
			-$elm$core$Basics$floor(
				$ianmackenzie$elm_units$Duration$inDays(duration)),
			date);
	});
var $author$project$Components$SettingsPage$Reports$ReportView$init = F2(
	function (startDate, endDate) {
		return {
			endDate: $elm$core$Maybe$Just(endDate),
			startDate: $elm$core$Maybe$Just(startDate)
		};
	});
var $ianmackenzie$elm_units$Constants$week = 7 * $ianmackenzie$elm_units$Constants$day;
var $ianmackenzie$elm_units$Duration$weeks = function (numWeeks) {
	return $ianmackenzie$elm_units$Duration$seconds($ianmackenzie$elm_units$Constants$week * numWeeks);
};
var $author$project$Components$SettingsPage$ReportsLayout$initLoadedModel = function (currentDate) {
	var initReportView = function (defaultRange) {
		return A2(
			$author$project$Components$SettingsPage$Reports$ReportView$init,
			A2($author$project$Components$SettingsPage$ReportsLayout$earlier, defaultRange, currentDate),
			currentDate);
	};
	return {
		auditorScorecardReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		autoNidfBatchesReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(2)),
		carrierInvoicingBillingDetailsReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		carrierScorecardReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(1)),
		customerInvoicesSentReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(1)),
		documentRetrievalBillingDetailsReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(2)),
		emailActivityReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(2)),
		factorInvoicingBillingDetailsReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(2)),
		indexerScorecardReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		indexingActivityReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		loadsRequiringActionReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		ltlLoadsReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(2)),
		missingPodReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(2)),
		processorScorecardReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		userActivityReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		verificationsReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		verificationsWorkflowReport: initReportView(
			$ianmackenzie$elm_units$Duration$days(1)),
		verifierScorecardReport: initReportView(
			$ianmackenzie$elm_units$Duration$weeks(1))
	};
};
var $author$project$Helpers$Scroll$toTop = F2(
	function (toMsg, domId) {
		return A2(
			$elm$core$Task$attempt,
			toMsg,
			A3($elm$browser$Browser$Dom$setViewportOf, domId, 0, 0));
	});
var $author$project$Components$SettingsPage$Reports$ReportView$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateStartDate':
				var maybeDate = msg.a;
				return _Utils_update(
					model,
					{startDate: maybeDate});
			case 'UpdateEndDate':
				var maybeDate = msg.a;
				return _Utils_update(
					model,
					{endDate: maybeDate});
			default:
				return model;
		}
	});
var $author$project$Components$SettingsPage$ReportsLayout$updateLoadedModel = F2(
	function (loadedMsg, loaded) {
		switch (loadedMsg.$) {
			case 'UpdateUserActivityReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						userActivityReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.userActivityReport)
					});
			case 'UpdateProcessorScorecardReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						processorScorecardReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.processorScorecardReport)
					});
			case 'UpdateIndexerScorecardReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						indexerScorecardReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.indexerScorecardReport)
					});
			case 'UpdateIndexingActivityReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						indexingActivityReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.indexingActivityReport)
					});
			case 'UpdateVerificationsReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						verificationsReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.verificationsReport)
					});
			case 'UpdateVerificationsWorkflowReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						verificationsWorkflowReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.verificationsWorkflowReport)
					});
			case 'UpdateVerifierScorecardReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						verifierScorecardReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.verifierScorecardReport)
					});
			case 'UpdateMissingPodReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						missingPodReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.missingPodReport)
					});
			case 'UpdateDocumentRetrievalBillingDetailsReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						documentRetrievalBillingDetailsReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.documentRetrievalBillingDetailsReport)
					});
			case 'UpdateCarrierInvoicingBillingDetailsReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						carrierInvoicingBillingDetailsReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.carrierInvoicingBillingDetailsReport)
					});
			case 'UpdateFactorInvoicingBillingDetailsReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						factorInvoicingBillingDetailsReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.factorInvoicingBillingDetailsReport)
					});
			case 'UpdateCustomerInvoicesSentReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						customerInvoicesSentReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.customerInvoicesSentReport)
					});
			case 'UpdateLoadsRequiringActionReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						loadsRequiringActionReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.loadsRequiringActionReport)
					});
			case 'UpdateEmailActivityReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						emailActivityReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.emailActivityReport)
					});
			case 'UpdateAutoNidfBatchesReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						autoNidfBatchesReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.autoNidfBatchesReport)
					});
			case 'UpdateLtlLoadsReport':
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						ltlLoadsReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.ltlLoadsReport)
					});
			default:
				var reportViewMsg = loadedMsg.a;
				return _Utils_update(
					loaded,
					{
						carrierScorecardReport: A2($author$project$Components$SettingsPage$Reports$ReportView$update, reportViewMsg, loaded.carrierScorecardReport)
					});
		}
	});
var $author$project$Components$SettingsPage$ReportsLayout$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'UpdateCurrentDate':
				var currentDate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							currentDate: $elm$core$Maybe$Just(currentDate),
							loadedModel: $elm$core$Maybe$Just(
								$author$project$Components$SettingsPage$ReportsLayout$initLoadedModel(currentDate))
						}),
					$author$project$HubTran$Effect$none);
			case 'SendReport':
				var report = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$ReportsLayout$SendReportFinished,
						$author$project$Api$Reports$create(report)));
			case 'SendReportFinished':
				var result = msg.a;
				switch (result.$) {
					case 'Ok':
						var email = A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.currentUser;
									},
									function ($) {
										return $.receivesEmailsAt;
									}),
								$author$project$Forward$Remote$toMaybe(data)));
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$cmd(
										A2(
											$author$project$Helpers$Scroll$toTop,
											function (_v2) {
												return $author$project$Components$SettingsPage$ReportsLayout$FinishedScrolling;
											},
											'react-container')),
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Report will be emailed to: ' + email))
									])));
					case 'Err':
						var message = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$cmd(
										A2(
											$author$project$Helpers$Scroll$toTop,
											function (_v3) {
												return $author$project$Components$SettingsPage$ReportsLayout$FinishedScrolling;
											},
											'react-container')),
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$alert(message))
									])));
					default:
						return _Utils_Tuple2(
							model,
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$cmd(
										A2(
											$author$project$Helpers$Scroll$toTop,
											function (_v4) {
												return $author$project$Components$SettingsPage$ReportsLayout$FinishedScrolling;
											},
											'react-container')),
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$alert('An unexpected error occurred. Please try again.'))
									])));
				}
			case 'FinishedScrolling':
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			default:
				var loadedMsg = msg.a;
				return _Utils_Tuple2(
					function () {
						var _v5 = model.loadedModel;
						if (_v5.$ === 'Just') {
							var loadedModel = _v5.a;
							return _Utils_update(
								model,
								{
									loadedModel: $elm$core$Maybe$Just(
										A2($author$project$Components$SettingsPage$ReportsLayout$updateLoadedModel, loadedMsg, loadedModel))
								});
						} else {
							return model;
						}
					}(),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$init = F2(
	function (choices, policy) {
		return {choices: choices, isEditing: false, isSaving: false, origPolicy: policy, policy: policy};
	});
var $author$project$Api$Settings$podRequirementPolicy = function (policy) {
	var json = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pod_requirement_policy',
				$author$project$Domain$PodRequirementPolicy$encode(policy))
			]));
	return A2($author$project$Helpers$Api$postWithNoResponseBody, '/api/settings/pod_requirement_policy', json);
};
var $author$project$Api$Accounts$saveCustomExceptionMessages = function (items) {
	var encodedCustomExceptionMessages = $elm$core$List$isEmpty(items) ? $elm$json$Json$Encode$string('empty_array') : A2($elm$json$Json$Encode$list, $author$project$Domain$CustomExceptionMessage$encode, items);
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2('rules_broker_custom_exception_messages', encodedCustomExceptionMessages)
				])));
};
var $author$project$Api$Accounts$saveRequiredReferences = function (rules) {
	var encodedRequiredReferences = $elm$core$List$isEmpty(rules) ? $elm$json$Json$Encode$string('empty_array') : A2($elm$json$Json$Encode$list, $author$project$Domain$ReferenceRule$encode, rules);
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		'/api/accounts/settings',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from_elm',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2('rules_broker_required_references', encodedRequiredReferences)
				])));
};
var $author$project$Components$SettingsPage$ConditionalExceptions$update = F2(
	function (msg, model) {
		var index = msg.a;
		return _Utils_update(
			model,
			{
				expandedRules: A2($elm$core$Set$member, index, model.expandedRules) ? A2($elm$core$Set$remove, index, model.expandedRules) : A2($elm$core$Set$insert, index, model.expandedRules)
			});
	});
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$AfterSave = function (a) {
	return {$: 'AfterSave', a: a};
};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$update = F3(
	function (toSaveRequest, msg, model) {
		switch (msg.$) {
			case 'Change':
				var policy = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{policy: policy}),
					$author$project$HubTran$Effect$none);
			case 'Save':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithoutCaching,
						$author$project$Components$SettingsPage$Shared$PodRequirementPolicy$AfterSave,
						A2(
							$author$project$Forward$CacheableRequest$map,
							$author$project$Helpers$Api$Result$fromNestedResult,
							toSaveRequest(model.policy))));
			case 'AfterSave':
				switch (msg.a.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isEditing: false, isSaving: false, origPolicy: model.policy}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('POD Requirement Policy Saved!')));
					case 'Err':
						var message = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{isSaving: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('POD Requirement Policy Saved could not be saved')));
				}
			case 'StartEditing':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isEditing: true}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isEditing: false, policy: model.origPolicy}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Forward$FormWrapper$ChildMsg = function (a) {
	return {$: 'ChildMsg', a: a};
};
var $author$project$Forward$FormWrapper$update = F4(
	function (initChild, childUpdate, msg, _v0) {
		var model = _v0.a;
		if (msg.$ === 'Initialize') {
			if (msg.a.$ === 'Ok') {
				var initData = msg.a.a;
				var _v2 = initChild(initData);
				var childModel = _v2.a;
				var childEffect = _v2.b;
				return _Utils_Tuple2(
					$author$project$Forward$FormWrapper$Model(
						{
							child: $author$project$Forward$Remote$Loaded(childModel)
						}),
					A2($author$project$HubTran$Effect$map, $author$project$Forward$FormWrapper$ChildMsg, childEffect));
			} else {
				var error = msg.a.a;
				return _Utils_Tuple2(
					$author$project$Forward$FormWrapper$Model(
						{
							child: $author$project$Forward$Remote$Error(error)
						}),
					$author$project$HubTran$Effect$none);
			}
		} else {
			var childMsg = msg.a;
			var _v3 = model.child;
			switch (_v3.$) {
				case 'Loaded':
					var childModel = _v3.a;
					var _v4 = A2(childUpdate, childMsg, childModel);
					var newChildModel = _v4.a;
					var childEffect = _v4.b;
					return _Utils_Tuple2(
						$author$project$Forward$FormWrapper$Model(
							_Utils_update(
								model,
								{
									child: $author$project$Forward$Remote$Loaded(newChildModel)
								})),
						A2($author$project$HubTran$Effect$map, $author$project$Forward$FormWrapper$ChildMsg, childEffect));
				case 'Loading':
					return _Utils_Tuple2(
						$author$project$Forward$FormWrapper$Model(model),
						$author$project$HubTran$Effect$none);
				default:
					return _Utils_Tuple2(
						$author$project$Forward$FormWrapper$Model(model),
						$author$project$HubTran$Effect$none);
			}
		}
	});
var $author$project$Components$SettingsPage$RulesLayout$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'ReferencesMsg':
				var msg_ = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (references) {
						return _Utils_update(
							model,
							{references: references});
					},
					$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$RulesLayout$ReferencesMsg),
					A4(
						$author$project$Forward$FormWrapper$update,
						function (data) {
							return _Utils_Tuple2(
								A3(
									$author$project$Components$SettingsPage$Shared$ReferenceTable$init,
									data.rulesBrokerRequiredReferences,
									$elm$core$Set$toList(data.allReferenceFieldLabels),
									$elm$core$Maybe$Nothing),
								$author$project$HubTran$Effect$none);
						},
						$author$project$Components$SettingsPage$Shared$ReferenceTable$update($author$project$Api$Accounts$saveRequiredReferences),
						msg_,
						model.references));
			case 'CustomExceptionMessagesMsg':
				var msg_ = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (customExceptionMessages) {
						return _Utils_update(
							model,
							{customExceptionMessages: customExceptionMessages});
					},
					$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$RulesLayout$CustomExceptionMessagesMsg),
					A4(
						$author$project$Forward$FormWrapper$update,
						function (data) {
							return _Utils_Tuple2(
								A2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$init, $elm$core$Maybe$Nothing, data),
								$author$project$HubTran$Effect$none);
						},
						$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$update($author$project$Api$Accounts$saveCustomExceptionMessages),
						msg_,
						model.customExceptionMessages));
			case 'PodRequirementPolicyMsg':
				var msg_ = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (podRequirementPolicy) {
						return _Utils_update(
							model,
							{podRequirementPolicy: podRequirementPolicy});
					},
					$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$RulesLayout$PodRequirementPolicyMsg),
					A4(
						$author$project$Forward$FormWrapper$update,
						function (data) {
							return _Utils_Tuple2(
								A2(
									$author$project$Components$SettingsPage$Shared$PodRequirementPolicy$init,
									_List_fromArray(
										[$author$project$AuditPb$PODRequirementPolicyAlways, $author$project$AuditPb$PODRequirementPolicyDetermineFromLoad, $author$project$AuditPb$PODRequirementPolicyNever]),
									data),
								$author$project$HubTran$Effect$none);
						},
						$author$project$Components$SettingsPage$Shared$PodRequirementPolicy$update($author$project$Api$Settings$podRequirementPolicy),
						msg_,
						model.podRequirementPolicy));
			default:
				var msg_ = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (conditionalRules) {
						return _Utils_update(
							model,
							{conditionalRules: conditionalRules});
					},
					$author$project$HubTran$Effect$map($author$project$Components$SettingsPage$RulesLayout$ConditionalExceptionsMsg),
					A4(
						$author$project$Forward$FormWrapper$update,
						function (initModel) {
							return _Utils_Tuple2(initModel, $author$project$HubTran$Effect$none);
						},
						F2(
							function (childMsg, childModel) {
								return _Utils_Tuple2(
									A2($author$project$Components$SettingsPage$ConditionalExceptions$update, childMsg, childModel),
									$author$project$HubTran$Effect$none);
							}),
						msg_,
						model.conditionalRules));
		}
	});
var $author$project$Api$Users$baseUrl = '/api/accounts_payable/users';
var $author$project$Helpers$Api$postWithCustomErrors = F4(
	function (url, json, decoder, decodeErrors) {
		return A2(
			$author$project$Forward$CacheableRequest$cacheableRequestWithErrorData,
			{
				body: $elm$core$Maybe$Just(json),
				decoder: decoder,
				errorDecoder: function (_v0) {
					return decodeErrors;
				},
				headers: _List_Nil,
				method: 'POST',
				timeout: $elm$core$Maybe$Just($author$project$Helpers$Api$standardTimeout),
				url: url
			},
			$elm$core$Basics$identity);
	});
var $author$project$Api$Users$Encode$userForm = function (formData) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(formData.name)),
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(formData.emailAddress)),
							_Utils_Tuple2(
							'approver',
							$elm$json$Json$Encode$bool(formData.approver)),
							_Utils_Tuple2(
							'indexer',
							$elm$json$Json$Encode$bool(formData.indexer)),
							_Utils_Tuple2(
							'auditor',
							$elm$json$Json$Encode$bool(formData.auditor)),
							_Utils_Tuple2(
							'customer_representative',
							$elm$json$Json$Encode$bool(formData.customerRepresentative)),
							_Utils_Tuple2(
							'admin',
							$elm$json$Json$Encode$bool(formData.admin)),
							_Utils_Tuple2(
							'receivables',
							$elm$json$Json$Encode$bool(formData.receivables)),
							_Utils_Tuple2(
							'settings_role',
							$elm$json$Json$Encode$bool(formData.settingsRole)),
							_Utils_Tuple2(
							'exceptions_signature',
							$elm$json$Json$Encode$string(formData.emailSignature)),
							_Utils_Tuple2(
							'insights_dashboard_access',
							$elm$json$Json$Encode$bool(formData.insightsDashboardAccess)),
							_Utils_Tuple2(
							'read_only_factor_invoices',
							$elm$json$Json$Encode$bool(formData.readOnlyFactorInvoices)),
							_Utils_Tuple2(
							'can_unapprove_invoices',
							$elm$json$Json$Encode$bool(formData.canUnapproveInvoices))
						])))
			]));
};
var $author$project$Api$Users$create = function (formData) {
	return A4(
		$author$project$Helpers$Api$postWithCustomErrors,
		$author$project$Api$Users$baseUrl,
		$author$project$Api$Users$Encode$userForm(formData),
		$author$project$Api$Users$Decode$userForm,
		$author$project$Api$Users$Decode$errors);
};
var $author$project$Api$Users$userUrl = function (userId) {
	return $author$project$Api$Users$baseUrl + ('/' + $elm$core$String$fromInt(
		$author$project$Domain$UserId$toInt(userId)));
};
var $author$project$Api$Users$enableUrl = function (userId) {
	return $author$project$Api$Users$userUrl(userId) + '/enable';
};
var $author$project$Api$Users$enable = F2(
	function (userId, formData) {
		return A4(
			$author$project$Helpers$Api$postWithCustomErrors,
			$author$project$Api$Users$enableUrl(userId),
			$author$project$Api$Users$Encode$userForm(formData),
			$author$project$Api$Users$Decode$userForm,
			$author$project$Api$Users$Decode$errors);
	});
var $author$project$Components$SettingsPage$UserForm$formData = function (model) {
	return {
		admin: model.admin,
		approver: model.approver,
		auditor: model.auditor,
		canUnapproveInvoices: model.canUnapproveInvoices,
		customerRepresentative: model.customerRepresentative,
		emailAddress: $author$project$Experimental$FormField$value(model.emailAddress),
		emailSignature: $author$project$Experimental$FormField$value(model.emailSignature),
		groupUserId: model.groupUserId,
		indexer: model.indexer,
		insightsDashboardAccess: model.insightsDashboardAccess,
		name: $author$project$Experimental$FormField$value(model.name),
		readOnlyFactorInvoices: model.readOnlyFactorInvoices,
		receivables: model.receivables,
		settingsRole: model.settingsRole
	};
};
var $author$project$Components$SettingsPage$UserLayout$existingUserFormData = function (user) {
	return {admin: user.isAdmin, approver: user.isApprover, auditor: user.isAuditor, canUnapproveInvoices: user.canUnapproveInvoices, customerRepresentative: user.isCustomerRepresentative, emailAddress: user.emailAddress, emailSignature: user.emailSignature, groupUserId: user.groupUserId, indexer: user.isIndexer, insightsDashboardAccess: user.hasInsightsDashboardAccess, name: user.name, readOnlyFactorInvoices: user.readOnlyFactorInvoices, receivables: user.receivables, settingsRole: user.hasSettingsRole};
};
var $author$project$Components$SettingsPage$UserForm$init = function (formData_) {
	return {
		admin: formData_.admin,
		approver: formData_.approver,
		auditor: formData_.auditor,
		canUnapproveInvoices: formData_.canUnapproveInvoices,
		customerRepresentative: formData_.customerRepresentative,
		emailAddress: $author$project$Experimental$FormField$init(formData_.emailAddress),
		emailSignature: $author$project$Experimental$FormField$init(formData_.emailSignature),
		groupUserId: formData_.groupUserId,
		indexer: formData_.indexer,
		insightsDashboardAccess: formData_.insightsDashboardAccess,
		name: $author$project$Experimental$FormField$init(formData_.name),
		readOnlyFactorInvoices: formData_.readOnlyFactorInvoices,
		receivables: formData_.receivables,
		settingsRole: formData_.settingsRole
	};
};
var $author$project$Components$SettingsPage$UserLayout$newUserFormData = {admin: false, approver: false, auditor: true, canUnapproveInvoices: false, customerRepresentative: false, emailAddress: '', emailSignature: '', groupUserId: $elm$core$Maybe$Nothing, indexer: true, insightsDashboardAccess: false, name: '', readOnlyFactorInvoices: false, receivables: true, settingsRole: false};
var $author$project$Components$SettingsPage$UserLayout$mergeFormData = F2(
	function (data, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(data);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var data_ = _v0.a;
			var _default = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$SettingsPage$UserLayout$newUserFormData,
				A2($elm$core$Maybe$map, $author$project$Components$SettingsPage$UserLayout$existingUserFormData, data_.maybeUser));
			return $elm$core$Maybe$Just(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$SettingsPage$UserForm$init(_default),
					model.maybeUserForm));
		}
	});
var $author$project$Components$SettingsPage$UserLayout$SaveUserFinished = function (a) {
	return {$: 'SaveUserFinished', a: a};
};
var $author$project$Components$SettingsPage$UserLayout$saveUser = F2(
	function (model, apiRequest) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{isSaving: true}),
			A2($author$project$HubTran$Effect$sendCacheableRequestWithError, $author$project$Components$SettingsPage$UserLayout$SaveUserFinished, apiRequest));
	});
var $author$project$Path$settingsUsers = $author$project$Path$base(
	_List_fromArray(
		['app', 'settings', 'users']));
var $author$project$Experimental$FormField$updateFeedback = F2(
	function (_v0, feedback_) {
		var formField = _v0.a;
		return $author$project$Experimental$FormField$FormField(
			_Utils_update(
				formField,
				{
					feedback: $elm$core$Maybe$Just(feedback_)
				}));
	});
var $author$project$Components$SettingsPage$UserForm$updateFeedback = F2(
	function (feedbackData, model) {
		return _Utils_update(
			model,
			{
				emailAddress: A2($author$project$Experimental$FormField$updateFeedback, model.emailAddress, feedbackData.emailAddress),
				emailSignature: A2($author$project$Experimental$FormField$updateFeedback, model.emailSignature, feedbackData.emailSignature),
				name: A2($author$project$Experimental$FormField$updateFeedback, model.name, feedbackData.name)
			});
	});
var $author$project$Components$SettingsPage$UserLayout$saveUserFinished = F3(
	function (apiResult, data, savingModel) {
		var model = _Utils_update(
			savingModel,
			{isSaving: false});
		switch (apiResult.$) {
			case 'Ok':
				var user = apiResult.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$HubTran$Effect$invalidate(
								A2($author$project$Forward$Lookup$startFrom, user.id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$user)),
								$author$project$HubTran$Effect$load(
								$author$project$Path$toString($author$project$Path$settingsUsers))
							])));
			case 'Err':
				var feedbackData = apiResult.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							maybeUserForm: A2(
								$elm$core$Maybe$map,
								$author$project$Components$SettingsPage$UserForm$updateFeedback(feedbackData),
								A2($author$project$Components$SettingsPage$UserLayout$mergeFormData, data, model))
						}),
					$author$project$HubTran$Effect$none);
			default:
				var err = apiResult.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert(
							$author$project$Helpers$Http$errorToString(err))));
		}
	});
var $author$project$Api$Users$update = F2(
	function (userId, formData) {
		return A4(
			$author$project$Helpers$Api$putWithCustomErrors,
			$author$project$Api$Users$userUrl(userId),
			$author$project$Api$Users$Encode$userForm(formData),
			$author$project$Api$Users$Decode$userForm,
			$author$project$Api$Users$Decode$errors);
	});
var $author$project$Experimental$FormField$validate = F2(
	function (_v0, validate_) {
		var formField = _v0.a;
		return $author$project$Experimental$FormField$FormField(
			_Utils_update(
				formField,
				{
					feedback: $elm$core$Maybe$Just(
						validate_(formField.value))
				}));
	});
var $author$project$Experimental$Validate$presence = function (string) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(string)) ? $elm$core$Result$Err('Must be present.') : $elm$core$Result$Ok(_Utils_Tuple0);
};
var $author$project$Components$SettingsPage$UserForm$validations = {emailAddress: $author$project$Experimental$Validate$presence, emailSignature: $author$project$Experimental$FormField$alwaysValid, name: $author$project$Experimental$Validate$presence};
var $author$project$Components$SettingsPage$UserForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateName':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						name: A3($author$project$Experimental$FormField$update, model.name, string, $author$project$Components$SettingsPage$UserForm$validations.name)
					});
			case 'UpdateEmailAddress':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						emailAddress: A3($author$project$Experimental$FormField$update, model.emailAddress, string, $author$project$Components$SettingsPage$UserForm$validations.emailAddress)
					});
			case 'UpdateEmailSignature':
				var string = msg.a;
				return _Utils_update(
					model,
					{
						emailSignature: A3($author$project$Experimental$FormField$update, model.emailSignature, string, $author$project$Components$SettingsPage$UserForm$validations.emailSignature)
					});
			case 'UpdateApprover':
				var bool = msg.a;
				return _Utils_update(
					model,
					{approver: bool});
			case 'UpdateIndexer':
				var bool = msg.a;
				return _Utils_update(
					model,
					{indexer: bool});
			case 'UpdateAuditor':
				var bool = msg.a;
				return _Utils_update(
					model,
					{auditor: bool});
			case 'UpdateAdmin':
				var bool = msg.a;
				return _Utils_update(
					model,
					{admin: bool});
			case 'UpdateReceivables':
				var bool = msg.a;
				return _Utils_update(
					model,
					{receivables: bool});
			case 'UpdateSettingsRole':
				var bool = msg.a;
				return _Utils_update(
					model,
					{settingsRole: bool});
			case 'UpdateCustomerRepresentative':
				var bool = msg.a;
				return _Utils_update(
					model,
					{customerRepresentative: bool});
			case 'UpdateInsightsDashboardAccess':
				var bool = msg.a;
				return _Utils_update(
					model,
					{insightsDashboardAccess: bool});
			case 'UpdateReadOnlyFactorInvoices':
				var bool = msg.a;
				return _Utils_update(
					model,
					{readOnlyFactorInvoices: bool});
			case 'UpdateCanUnapproveInvoices':
				var bool = msg.a;
				return _Utils_update(
					model,
					{canUnapproveInvoices: bool});
			default:
				var formField = msg.a;
				switch (formField.$) {
					case 'Name':
						return _Utils_update(
							model,
							{
								name: A2($author$project$Experimental$FormField$validate, model.name, $author$project$Components$SettingsPage$UserForm$validations.name)
							});
					case 'EmailAddress':
						return _Utils_update(
							model,
							{
								emailAddress: A2($author$project$Experimental$FormField$validate, model.emailAddress, $author$project$Components$SettingsPage$UserForm$validations.emailAddress)
							});
					default:
						return model;
				}
		}
	});
var $author$project$Components$SettingsPage$UserLayout$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'UserFormMsg':
				var userFormMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							maybeUserForm: A2(
								$elm$core$Maybe$map,
								$author$project$Components$SettingsPage$UserForm$update(userFormMsg),
								A2($author$project$Components$SettingsPage$UserLayout$mergeFormData, data, model))
						}),
					$author$project$HubTran$Effect$none);
			case 'NavigateTo':
				var url = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						$author$project$HubTran$Navigation$pushUrl(url)));
			case 'SaveNewUser':
				var userFormModel = msg.a;
				return A2(
					$author$project$Components$SettingsPage$UserLayout$saveUser,
					model,
					$author$project$Api$Users$create(
						$author$project$Components$SettingsPage$UserForm$formData(userFormModel)));
			case 'SaveEditUser':
				var userId = msg.a;
				var userFormModel = msg.b;
				return A2(
					$author$project$Components$SettingsPage$UserLayout$saveUser,
					model,
					A2(
						$author$project$Api$Users$update,
						userId,
						$author$project$Components$SettingsPage$UserForm$formData(userFormModel)));
			case 'SaveEnableUser':
				var userId = msg.a;
				var userFormModel = msg.b;
				return A2(
					$author$project$Components$SettingsPage$UserLayout$saveUser,
					model,
					A2(
						$author$project$Api$Users$enable,
						userId,
						$author$project$Components$SettingsPage$UserForm$formData(userFormModel)));
			default:
				var result = msg.a;
				return A3($author$project$Components$SettingsPage$UserLayout$saveUserFinished, result, data, model);
		}
	});
var $author$project$Components$SettingsPage$UsersLayout$DisableUserFinished = function (a) {
	return {$: 'DisableUserFinished', a: a};
};
var $author$project$Api$Users$disableUrl = function (userId) {
	return $author$project$Api$Users$userUrl(userId) + '/disable';
};
var $author$project$Api$Users$Encode$emptyObject = $elm$json$Json$Encode$object(_List_Nil);
var $author$project$Api$Users$disable = function (userId) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		$author$project$Api$Users$disableUrl(userId),
		$author$project$Api$Users$Encode$emptyObject);
};
var $author$project$Components$SettingsPage$UsersLayout$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'NavigateTo':
				var url = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						$author$project$HubTran$Navigation$pushUrl(url)));
			case 'DisableUser':
				var userId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Components$SettingsPage$UsersLayout$DisableUserFinished,
						$author$project$Api$Users$disable(userId)));
			case 'DisableUserFinished':
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: false}),
					function () {
						if (result.$ === 'Ok') {
							return $author$project$HubTran$Effect$none;
						} else {
							return $author$project$HubTran$Effect$flash($author$project$HubTran$Flash$defaultServerErrorAlert);
						}
					}());
			case 'UpdateActivePage':
				var pageNum = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{activePageNum: pageNum}),
					$author$project$HubTran$Effect$none);
			case 'ChangeActivePerPage':
				var perPage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{activePerPage: perPage}),
					$author$project$HubTran$Effect$none);
			case 'UpdateDisabledPage':
				var pageNum = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{disabledPageNum: pageNum}),
					$author$project$HubTran$Effect$none);
			default:
				var perPage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{disabledPerPage: perPage}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Domain$NetworkBrokerId$toInt = function (_v0) {
	var _int = _v0.a;
	return _int;
};
var $author$project$Domain$NetworkBrokerId$toComparable = function (id) {
	return _Utils_Tuple2(
		'networkBrokerId',
		$author$project$Domain$NetworkBrokerId$toInt(id));
};
var $author$project$Components$SettingsPage$VerificationsLayout$formKey = function (debtorId) {
	return $author$project$Domain$NetworkBrokerId$toComparable(debtorId);
};
var $author$project$Components$SettingsPage$VerificationsLayout$hideEditLogin = F2(
	function (model, debtorId) {
		return _Utils_update(
			model,
			{
				loginForms: A2(
					$elm$core$Dict$remove,
					$author$project$Components$SettingsPage$VerificationsLayout$formKey(debtorId),
					model.loginForms)
			});
	});
var $author$project$Components$SettingsPage$VerificationsLayout$makeEditable = F2(
	function (debtorId, model) {
		var map = $elm$core$Maybe$map(
			function (form) {
				return _Utils_update(
					form,
					{saving: false});
			});
		return _Utils_update(
			model,
			{
				loginForms: A3(
					$elm$core$Dict$update,
					$author$project$Components$SettingsPage$VerificationsLayout$formKey(debtorId),
					map,
					model.loginForms)
			});
	});
var $author$project$Components$SettingsPage$VerificationsLayout$FinishSaveLogin = F2(
	function (a, b) {
		return {$: 'FinishSaveLogin', a: a, b: b};
	});
var $author$project$Api$Verifications$unlessEmpty = F2(
	function (f, str) {
		return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			f(str));
	});
var $author$project$Api$Verifications$login = function (_v0) {
	var password = _v0.password;
	var user = _v0.user;
	var debtorId = _v0.debtorId;
	var id = _v0.id;
	var body = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			_Utils_Tuple2(
				'user',
				$elm$json$Json$Encode$string(user))),
			$elm$core$Maybe$Just(
			_Utils_Tuple2(
				'network_broker_id',
				$elm$json$Json$Encode$int(
					$author$project$Domain$NetworkBrokerId$toInt(debtorId)))),
			A2(
			$author$project$Api$Verifications$unlessEmpty,
			function (value) {
				return _Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(value));
			},
			password)
		]);
	var payload = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'login',
				$elm$json$Json$Encode$object(
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, body)))
			]));
	var baseUrl = '/api/verifications/logins';
	var request = function () {
		if (id.$ === 'Nothing') {
			return $author$project$Helpers$Api$postWithNoResponseBody(baseUrl);
		} else {
			var id_ = id.a.a;
			return $author$project$Helpers$Api$putWithNoResponseBody(
				baseUrl + ('/' + $elm$core$String$fromInt(id_)));
		}
	}();
	return request(payload);
};
var $author$project$Components$SettingsPage$VerificationsLayout$saveEditLogin = F2(
	function (model, debtorId) {
		var key = $author$project$Components$SettingsPage$VerificationsLayout$formKey(debtorId);
		var _v0 = A2($elm$core$Dict$get, key, model.loginForms);
		if (_v0.$ === 'Just') {
			var form = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						loginForms: A3(
							$elm$core$Dict$insert,
							key,
							_Utils_update(
								form,
								{saving: true}),
							model.loginForms)
					}),
				A2(
					$author$project$HubTran$Effect$sendCacheableRequestWithError,
					$author$project$Components$SettingsPage$VerificationsLayout$FinishSaveLogin(debtorId),
					$author$project$Api$Verifications$login(form)));
		} else {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Components$SettingsPage$VerificationsLayout$storeEdits = F2(
	function (form, model) {
		return _Utils_update(
			model,
			{
				loginForms: A3(
					$elm$core$Dict$insert,
					$author$project$Components$SettingsPage$VerificationsLayout$formKey(form.debtorId),
					form,
					model.loginForms)
			});
	});
var $author$project$Components$SettingsPage$VerificationsLayout$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'EditLogin':
				var form = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$VerificationsLayout$storeEdits, form, model),
					$author$project$HubTran$Effect$none);
			case 'SaveLogin':
				var debtorId = msg.a;
				return A2($author$project$Components$SettingsPage$VerificationsLayout$saveEditLogin, model, debtorId);
			case 'CancelEditLogin':
				var debtorId = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Components$SettingsPage$VerificationsLayout$hideEditLogin, model, debtorId),
					$author$project$HubTran$Effect$none);
			default:
				switch (msg.b.$) {
					case 'Ok':
						var debtorId = msg.a;
						return _Utils_Tuple2(
							A2($author$project$Components$SettingsPage$VerificationsLayout$hideEditLogin, model, debtorId),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$success('Login saved successfully!')));
					case 'Err':
						var debtorId = msg.a;
						var message = msg.b.a;
						return _Utils_Tuple2(
							A2($author$project$Components$SettingsPage$VerificationsLayout$makeEditable, debtorId, model),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						var debtorId = msg.a;
						return _Utils_Tuple2(
							A2($author$project$Components$SettingsPage$VerificationsLayout$makeEditable, debtorId, model),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Login could not be saved!')));
				}
		}
	});
var $author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault = function (onDoneQuery) {
	return $elm$url$Url$percentEncode(
		A2($elm$core$Maybe$withDefault, '/app', onDoneQuery));
};
var $author$project$Factoring$Page$ClientSubmission$navigateToProcess = F4(
	function (emailId, id, dismissFundingNotes, onDoneQuery) {
		var query = A2($elm$core$Maybe$withDefault, false, dismissFundingNotes) ? 'true' : 'false';
		var path = A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2('dismissFundingNotes', query),
					_Utils_Tuple2(
					'onDone',
					$author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault(onDoneQuery))
				]),
			A2($author$project$Path$submissionInvoice, emailId, id));
		return $author$project$HubTran$Effect$replaceUrl(
			$author$project$Path$toString(path));
	});
var $author$project$Factoring$Page$ClientSubmission$navigateToReview = F2(
	function (emailId, onDoneQuery) {
		var path = A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'onDone',
					$author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault(onDoneQuery))
				]),
			$author$project$Path$submissionReview(emailId));
		return $author$project$HubTran$Effect$replaceUrl(
			$author$project$Path$toString(path));
	});
var $author$project$Factoring$Page$ClientSubmission$update = F2(
	function (msg, model) {
		if (msg.a.$ === 'Err') {
			var x = msg.a.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						loadingError: $elm$core$Maybe$Just(x)
					}),
				$author$project$HubTran$Effect$none);
		} else {
			switch (msg.a.a.$) {
				case 'Review':
					var _v1 = msg.a.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Factoring$Page$ClientSubmission$navigateToReview, model.emailId, model.onDone));
				case 'Processing':
					var factorInvoiceId = msg.a.a.a;
					return _Utils_Tuple2(
						model,
						A4($author$project$Factoring$Page$ClientSubmission$navigateToProcess, model.emailId, factorInvoiceId, model.dismissFundingNotes, model.onDone));
				default:
					var id = msg.a.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									A4($author$project$Factoring$Page$ClientSubmission$navigateToProcess, model.emailId, id, model.dismissFundingNotes, model.onDone),
									$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert('Review this invoice to proceed'))
								])));
			}
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$Browser = F2(
	function (selection, state) {
		return {selection: selection, state: state};
	});
var $author$project$Indexer$DocumentBrowser$FinishGroupUpdate = {$: 'FinishGroupUpdate'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$FinishSaving = function (a) {
	return {$: 'FinishSaving', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$ForwardSendThen = F2(
	function (a, b) {
		return {$: 'ForwardSendThen', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$HeaderMsg = function (a) {
	return {$: 'HeaderMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$IdentifyDocumentsMsg = F2(
	function (a, b) {
		return {$: 'IdentifyDocumentsMsg', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$SaveChanges = {$: 'SaveChanges'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$ShowMoveDocumentsModal = {$: 'ShowMoveDocumentsModal'};
var $author$project$Indexer$DocumentBrowser$UpdateGroup = {$: 'UpdateGroup'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$UpdateMismatchFinished = function (a) {
	return {$: 'UpdateMismatchFinished', a: a};
};
var $author$project$Js$setCarrierPresence = _Platform_outgoingPort('setCarrierPresence', $elm$json$Json$Encode$int);
var $author$project$Factoring$Page$ClientSubmissionInvoice$attemptCarrierPresence = function (tmsCarrierId) {
	return $author$project$HubTran$Effect$cmd(
		$author$project$Js$setCarrierPresence(
			$author$project$Domain$TmsCarrierId$toInt(tmsCarrierId)));
};
var $author$project$Api$DocumentBatches$autoGroup = function (documentBatchId) {
	var url = '/api/document_groups/' + (A2($elm$core$Basics$composeL, $elm$core$Debug$toString, $author$project$Domain$DocumentBatchId$toInt)(documentBatchId) + '?format=forward');
	return A2(
		$author$project$Helpers$Api$putWithNoResponseBody,
		url,
		$elm$json$Json$Encode$object(_List_Nil));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$DebounceMsg = function (a) {
	return {$: 'DebounceMsg', a: a};
};
var $jinjor$elm_debounce$Debounce$Manual = function (a) {
	return {$: 'Manual', a: a};
};
var $jinjor$elm_debounce$Debounce$manual = $jinjor$elm_debounce$Debounce$Manual(0);
var $author$project$Factoring$Page$ClientSubmissionInvoice$debounceConfig = {strategy: $jinjor$elm_debounce$Debounce$manual, transform: $author$project$Factoring$Page$ClientSubmissionInvoice$DebounceMsg};
var $author$project$Indexer$DocumentBrowser$documentLineContext = 'document-line';
var $author$project$Factoring$Page$ClientSubmission$Change$dropSaved = F2(
	function (saved, all) {
		return A2(
			$elm$core$List$take,
			$elm$core$List$length(all) - $elm$core$List$length(saved),
			all);
	});
var $author$project$Factoring$Page$ClientSubmission$Change$IsBasicChange = {$: 'IsBasicChange'};
var $author$project$Factoring$Page$ClientSubmission$Change$IsAssignSubmissionChange = {$: 'IsAssignSubmissionChange'};
var $author$project$Factoring$Page$ClientSubmission$Change$IsMoveGroupChange = {$: 'IsMoveGroupChange'};
var $author$project$Factoring$Page$ClientSubmission$Change$IsReviewChange = {$: 'IsReviewChange'};
var $author$project$Factoring$Page$ClientSubmission$Change$getChangeBatchTypeHelper = F2(
	function (change, oldChangeBatchType) {
		var _v0 = _Utils_Tuple2(change, oldChangeBatchType);
		switch (_v0.a.$) {
			case 'Review':
				var _v1 = _v0.a;
				return $author$project$Factoring$Page$ClientSubmission$Change$IsReviewChange;
			case 'MoveDocument':
				if (_v0.b.$ === 'IsReviewChange') {
					var _v2 = _v0.a;
					var _v3 = _v0.b;
					return $author$project$Factoring$Page$ClientSubmission$Change$IsReviewChange;
				} else {
					var _v4 = _v0.a;
					return $author$project$Factoring$Page$ClientSubmission$Change$IsMoveGroupChange;
				}
			case 'AssignSubmission':
				return $author$project$Factoring$Page$ClientSubmission$Change$IsAssignSubmissionChange;
			default:
				return oldChangeBatchType;
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Change$getChangeBatchType = function (changes) {
	return A3($elm$core$List$foldl, $author$project$Factoring$Page$ClientSubmission$Change$getChangeBatchTypeHelper, $author$project$Factoring$Page$ClientSubmission$Change$IsBasicChange, changes);
};
var $author$project$Path$submissionWithGroup = F2(
	function (emailId, group) {
		return A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'group',
					$elm$core$String$fromInt(group))
				]),
			$author$project$Path$submission(emailId));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$goToGroup = F4(
	function (emailMessageId, group, dismissFundingNotes, onDoneQuery) {
		var query = dismissFundingNotes ? 'true' : 'false';
		var path = A2(
			$author$project$Path$addQueries,
			_List_fromArray(
				[
					_Utils_Tuple2('dismissFundingNotes', query),
					_Utils_Tuple2(
					'onDone',
					$author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault(onDoneQuery))
				]),
			A2($author$project$Path$submissionWithGroup, emailMessageId, group));
		return $author$project$HubTran$Effect$pushUrl(
			$author$project$Path$toString(path));
	});
var $author$project$Indexer$DocumentBrowser$groupId = F2(
	function (idPrefix, index) {
		return idPrefix + ('document-browser-group-' + $elm$core$String$fromInt(index));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$isMovePreviousChange = function (change) {
	if ((change.$ === 'MoveDocument') && (change.b.$ === 'Previous')) {
		var _v1 = change.b;
		return true;
	} else {
		return false;
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$hasMovePreviousChange = function (changes) {
	return !$elm$core$List$isEmpty(
		A2(
			$elm$core$List$filter,
			function (c) {
				return $author$project$Factoring$Page$ClientSubmissionInvoice$isMovePreviousChange(c);
			},
			changes));
};
var $author$project$Indexer$Group$afterPage = F2(
	function (a, b) {
		return (_Utils_cmp(a.document, b.document) < 0) || (_Utils_eq(a.document, b.document) && (_Utils_cmp(a.page, b.page) < 0));
	});
var $author$project$Indexer$Group$getFirstAfterOrCycle = F2(
	function (selection, list) {
		if (!list.b) {
			return selection;
		} else {
			var all = list;
			var first = all.a;
			return A2(
				$elm$core$Maybe$withDefault,
				first,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						$author$project$Indexer$Group$afterPage(selection),
						all)));
		}
	});
var $author$project$Indexer$Group$indexedFindAll = F2(
	function (getter, mapper) {
		return A2(
			$elm$core$Basics$composeL,
			$elm$core$List$concat,
			$elm$core$List$indexedMap(
				function (index) {
					return A2(
						$elm$core$Basics$composeL,
						mapper(index),
						getter);
				}));
	});
var $author$project$Indexer$Group$selectDocumentWith = F4(
	function (documentType, group, document, candidate) {
		return _Utils_eq(
			$author$project$Domain$Document$documentTypeValueToUnresolved(candidate.documentTypeValue),
			documentType) ? _List_fromArray(
			[
				A4($author$project$Indexer$Group$Selection, group, document, 0, _List_Nil)
			]) : _List_Nil;
	});
var $author$project$Indexer$Group$nextDocOfType = F3(
	function (documentType, selection, browsables) {
		return A2(
			$author$project$Indexer$Group$getFirstAfterOrCycle,
			selection,
			A3(
				$author$project$Indexer$Group$indexedFindAll,
				function ($) {
					return $.document;
				},
				A2($author$project$Indexer$Group$selectDocumentWith, documentType, selection.group),
				A2($author$project$Indexer$Group$getList, selection.group, browsables)));
	});
var $author$project$Indexer$Group$MissingPrimary = {$: 'MissingPrimary'};
var $author$project$Indexer$Group$Primary = {$: 'Primary'};
var $author$project$Indexer$Group$withFirst = F2(
	function (target, _v0) {
		var x = _v0.a;
		return _Utils_eq(target, x);
	});
var $author$project$Indexer$Group$filterByContext = $elm$core$List$map(
	function (selection) {
		var lines = selection.lines;
		return A2(
			$elm$core$List$any,
			$author$project$Indexer$Group$withFirst($author$project$Indexer$Group$Primary),
			lines) ? _Utils_update(
			selection,
			{
				lines: A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						$author$project$Indexer$Group$withFirst($author$project$Indexer$Group$MissingPrimary)),
					lines)
			}) : selection;
	});
var $author$project$Indexer$Group$looksLikeAmount = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[0-9.,]+'));
var $author$project$Indexer$Group$normalizeAmount = A2($elm$core$Basics$composeR, $author$project$Money$castFromString, $author$project$Money$toStringWithoutPrefix);
var $author$project$Indexer$Group$hasNormalizedAmount = F2(
	function (value, line) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.match;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Indexer$Group$normalizeAmount,
					$elm$core$Basics$eq(value))),
			A2($elm$regex$Regex$find, $author$project$Indexer$Group$looksLikeAmount, line));
	});
var $author$project$Indexer$Group$hasAmount = F2(
	function (value, line) {
		return A2($elm$core$String$any, $elm$core$Char$isDigit, value) && A2(
			$author$project$Indexer$Group$hasNormalizedAmount,
			$author$project$Indexer$Group$normalizeAmount(value),
			line);
	});
var $author$project$Indexer$Group$adjacentWhitespace = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('( )( )+'));
var $author$project$Indexer$Group$ampersand = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('( )*&( )*'));
var $author$project$Indexer$Group$dot = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('( )*\u005C.( )*'));
var $author$project$Indexer$Group$normalizeText = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toLower,
	A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$regex$Regex$replace,
			$author$project$Indexer$Group$dot,
			function (_v0) {
				return ' ';
			}),
		A2(
			$elm$core$Basics$composeR,
			A2(
				$elm$regex$Regex$replace,
				$author$project$Indexer$Group$ampersand,
				function (_v1) {
					return '&';
				}),
			A2(
				$elm$core$Basics$composeR,
				A2(
					$elm$regex$Regex$replace,
					$author$project$Indexer$Group$adjacentWhitespace,
					function (_v2) {
						return ' ';
					}),
				$elm$core$String$trim))));
var $author$project$Indexer$Group$hasText = F2(
	function (value, line) {
		var _v0 = $author$project$Indexer$Group$normalizeText(value);
		if (_v0 === '') {
			return false;
		} else {
			var normalValue = _v0;
			return A2(
				$elm$core$String$contains,
				normalValue,
				$author$project$Indexer$Group$normalizeText(line));
		}
	});
var $author$project$Indexer$Group$looksLikeDba = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: true, multiline: false},
		' dba '));
var $elm$regex$Regex$splitAtMost = _Regex_splitAtMost;
var $author$project$Indexer$Group$hasBusinessName = F2(
	function (value, line) {
		return A2(
			$elm$core$List$any,
			function (value_) {
				return A2($author$project$Indexer$Group$hasText, value_, line);
			},
			A3($elm$regex$Regex$splitAtMost, 2, $author$project$Indexer$Group$looksLikeDba, value));
	});
var $author$project$Indexer$Group$looksLikeDate = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005Cd{1,2}/\u005Cd{1,2}/\u005Cd{4}|' + ('\u005Cd{1,2}/\u005Cd{1,2}/\u005Cd{2}|' + ('\u005Cd{1,2}-\u005Cd{1,2}-\u005Cd{4}|' + '\u005Cd{1,2}-\u005Cd{1,2}-\u005Cd{2})'))));
var $author$project$Indexer$Group$normalizeDate = function (dateString) {
	var mdyList = A2(
		$elm$core$List$map,
		function (val) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(val));
		},
		A2(
			$elm$core$String$split,
			'/',
			A3($elm$core$String$replace, '-', '/', dateString)));
	var listSize = $elm$core$List$length(mdyList);
	var date = F3(
		function (m, d, y) {
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				y,
				$justinmimbs$date$Date$numberToMonth(m),
				d);
		});
	if (listSize === 3) {
		var dateComponents = $elm$core$Array$fromList(mdyList);
		var dayInt = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, 1, dateComponents));
		var monthInt = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, 0, dateComponents));
		var yearInt = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, 2, dateComponents));
		return $justinmimbs$date$Date$toIsoString(
			A3(date, monthInt, dayInt, yearInt));
	} else {
		return '';
	}
};
var $author$project$Indexer$Group$hasNormalizedDate = F2(
	function (value, line) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.match;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Indexer$Group$normalizeDate,
					$elm$core$Basics$eq(value))),
			A2($elm$regex$Regex$find, $author$project$Indexer$Group$looksLikeDate, line));
	});
var $author$project$Indexer$Group$hasDate = F2(
	function (value, line) {
		return A2($elm$core$String$any, $elm$core$Char$isDigit, value) && A2(
			$author$project$Indexer$Group$hasNormalizedDate,
			$author$project$Indexer$Group$normalizeDate(value),
			line);
	});
var $author$project$Indexer$Group$padWithSpace = function (x) {
	return ' ' + x;
};
var $author$project$Indexer$Group$vary = F3(
	function (old, _new, whole) {
		var parts = A2(
			$elm$core$String$split,
			$author$project$Indexer$Group$padWithSpace(old),
			whole);
		return ($elm$core$List$length(parts) <= 1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$core$String$join,
				$author$project$Indexer$Group$padWithSpace(_new),
				parts));
	});
var $author$project$Indexer$Group$allowVariant = F2(
	function (shortForm, longForm) {
		return $elm$core$List$concatMap(
			function (variant) {
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(variant),
							A3($author$project$Indexer$Group$vary, shortForm, longForm, variant),
							A3($author$project$Indexer$Group$vary, longForm, shortForm, variant)
						]));
			});
	});
var $author$project$Indexer$Group$abbreviations = _List_fromArray(
	[
		A2($author$project$Indexer$Group$allowVariant, 'p o', 'po'),
		A2($author$project$Indexer$Group$allowVariant, 'ave', 'avenue'),
		A2($author$project$Indexer$Group$allowVariant, 'rd', 'road'),
		A2($author$project$Indexer$Group$allowVariant, 'st', 'street'),
		A2($author$project$Indexer$Group$allowVariant, 'dr', 'drive'),
		A2($author$project$Indexer$Group$allowVariant, 'ste', 'suite'),
		A2($author$project$Indexer$Group$allowVariant, 'ct', 'court'),
		A2($author$project$Indexer$Group$allowVariant, 'ln', 'lane'),
		A2($author$project$Indexer$Group$allowVariant, 'hwy', 'highway'),
		A2($author$project$Indexer$Group$allowVariant, 'cir', 'circle'),
		A2($author$project$Indexer$Group$allowVariant, 'pl', 'place'),
		A2($author$project$Indexer$Group$allowVariant, 'wy', 'way'),
		A2($author$project$Indexer$Group$allowVariant, 'n', 'north'),
		A2($author$project$Indexer$Group$allowVariant, 's', 'south'),
		A2($author$project$Indexer$Group$allowVariant, 'e', 'east'),
		A2($author$project$Indexer$Group$allowVariant, 'w', 'west')
	]);
var $author$project$Indexer$Group$hasStreetAddress = F2(
	function (value, line) {
		var initial = $author$project$Indexer$Group$padWithSpace(
			$author$project$Indexer$Group$normalizeText(value));
		return A2(
			$elm$core$List$any,
			function (x) {
				return A2($author$project$Indexer$Group$hasText, x, line);
			},
			A3(
				$elm$core$List$foldl,
				$elm$core$Basics$identity,
				_List_fromArray(
					[initial]),
				$author$project$Indexer$Group$abbreviations));
	});
var $author$project$Indexer$Group$useFinder = F3(
	function (finder, context, line) {
		useFinder:
		while (true) {
			var useIf = function (bool) {
				return bool ? $elm$core$Maybe$Just(
					_Utils_Tuple2(context, line)) : $elm$core$Maybe$Nothing;
			};
			switch (finder.$) {
				case 'None':
					return $elm$core$Maybe$Nothing;
				case 'Text':
					var value = finder.a;
					return useIf(
						A2($author$project$Indexer$Group$hasText, value, line.chars));
				case 'BusinessName':
					var value = finder.a;
					return useIf(
						A2($author$project$Indexer$Group$hasBusinessName, value, line.chars));
				case 'Amount':
					var value = finder.a;
					return useIf(
						A2($author$project$Indexer$Group$hasAmount, value, line.chars));
				case 'Date':
					var value = finder.a;
					return useIf(
						A2($author$project$Indexer$Group$hasDate, value, line.chars));
				case 'StreetAddress':
					var value = finder.a;
					return useIf(
						A2($author$project$Indexer$Group$hasStreetAddress, value, line.chars));
				case 'Any':
					var newFinders = finder.a;
					return $elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (x) {
								return A3($author$project$Indexer$Group$useFinder, x, context, line);
							},
							newFinders));
				default:
					var newContext = finder.a;
					var newFinder = finder.b;
					var $temp$finder = newFinder,
						$temp$context = newContext,
						$temp$line = line;
					finder = $temp$finder;
					context = $temp$context;
					line = $temp$line;
					continue useFinder;
			}
		}
	});
var $author$project$Indexer$Group$findSelections = F2(
	function (finder, group) {
		return A2(
			$author$project$Indexer$Group$indexedFindAll,
			function ($) {
				return $.pages;
			},
			function (document) {
				return A2(
					$author$project$Indexer$Group$indexedFindAll,
					function ($) {
						return $.lines;
					},
					F2(
						function (page, lines) {
							var _v0 = A2(
								$elm$core$List$filterMap,
								A2($author$project$Indexer$Group$useFinder, finder, $author$project$Indexer$Group$Primary),
								lines);
							if (!_v0.b) {
								return _List_Nil;
							} else {
								var xs = _v0;
								return _List_fromArray(
									[
										A4($author$project$Indexer$Group$Selection, group, document, page, xs)
									]);
							}
						}));
			});
	});
var $author$project$Indexer$Group$allLines = F3(
	function (finder, group, browsables) {
		return $author$project$Indexer$Group$filterByContext(
			A3(
				$author$project$Indexer$Group$findSelections,
				finder,
				group,
				A2($author$project$Indexer$Group$getList, group, browsables)));
	});
var $author$project$Indexer$Group$nextLine = F3(
	function (finder, selection, browsables) {
		return A2(
			$author$project$Indexer$Group$getFirstAfterOrCycle,
			selection,
			A3($author$project$Indexer$Group$allLines, finder, selection.group, browsables));
	});
var $author$project$Indexer$Group$samePage = F2(
	function (a, b) {
		return _Utils_eq(a.group, b.group) && (_Utils_eq(a.document, b.document) && _Utils_eq(a.page, b.page));
	});
var $author$project$Indexer$Group$nextLineOnPage = F3(
	function (finder, selection, browsables) {
		return A2(
			$elm$core$Maybe$withDefault,
			selection,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					$author$project$Indexer$Group$samePage(selection),
					A3($author$project$Indexer$Group$allLines, finder, selection.group, browsables))));
	});
var $author$project$Indexer$DocumentBrowser$highlightSelectedId = function (idPrefix) {
	return idPrefix + 'o-t--selected';
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$scrollToHighlight = function (idPrefix) {
	return $author$project$HubTran$Effect$cmd(
		$author$project$Js$scrollToId(
			$author$project$Indexer$DocumentBrowser$highlightSelectedId(idPrefix)));
};
var $author$project$Indexer$DocumentBrowser$thumbnailSelectedId = function (idPrefix) {
	return idPrefix + 'document-thumbnail__selected';
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$scrollToThumbnail = function (idPrefix) {
	return $author$project$HubTran$Effect$cmd(
		$author$project$Js$scrollToId(
			$author$project$Indexer$DocumentBrowser$thumbnailSelectedId(idPrefix)));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$highlight = F3(
	function (msg, selection, _v0) {
		var groupedDocuments = _v0.groupedDocuments;
		switch (msg.$) {
			case 'Remove':
				return _Utils_Tuple2(
					_Utils_update(
						selection,
						{lines: _List_Nil}),
					$author$project$HubTran$Effect$none);
			case 'Next':
				var finder = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Indexer$Group$nextLine, finder, selection, groupedDocuments),
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$Factoring$Page$ClientSubmissionInvoice$scrollToThumbnail($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix),
								$author$project$Factoring$Page$ClientSubmissionInvoice$scrollToHighlight($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix)
							])));
			case 'NextOf':
				var finder = msg.a;
				var documentType = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Indexer$Group$nextLineOnPage,
						finder,
						A3($author$project$Indexer$Group$nextDocOfType, documentType, selection, groupedDocuments),
						groupedDocuments),
					$author$project$HubTran$Effect$none);
			default:
				var finder = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Indexer$Group$nextLineOnPage, finder, selection, groupedDocuments),
					$author$project$Factoring$Page$ClientSubmissionInvoice$scrollToHighlight($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix));
		}
	});
var $author$project$Typeahead$isFocused = function (_v0) {
	var model = _v0.a;
	return model.focused;
};
var $author$project$Components$PaginatedDropdown$isOpen = function (paginatedDropdown) {
	return $author$project$Ui$V3$CustomSelect$isOpen(paginatedDropdown.dropdown);
};
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$isOpen = function (model) {
	return $author$project$Components$PaginatedDropdown$isOpen(model.dropdown);
};
var $author$project$Indexer$Group$nextGroup = F2(
	function (currentSelection, groups) {
		var nextIndex = _Utils_eq(
			currentSelection.group,
			$elm$core$List$length(groups) - 1) ? currentSelection.group : (currentSelection.group + 1);
		return {document: 0, group: nextIndex, lines: _List_Nil, page: 0};
	});
var $author$project$Indexer$Group$advanceFrom = F3(
	function (currentElement, advanceBy, list) {
		if ($elm$core$List$isEmpty(list)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var currentIndex = A2($elm_community$list_extra$List$Extra$elemIndex, currentElement, list);
			var nextIndex = A2(
				$elm$core$Basics$modBy,
				$elm$core$List$length(list),
				advanceBy + A2($elm$core$Maybe$withDefault, -advanceBy, currentIndex));
			return A2($elm_community$list_extra$List$Extra$getAt, nextIndex, list);
		}
	});
var $author$project$Indexer$Group$pageSelectionsForBrowsable = F3(
	function (groupIdx, docIdx, browsable) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (pageIdx, _v0) {
					return A4($author$project$Indexer$Group$Selection, groupIdx, docIdx, pageIdx, _List_Nil);
				}),
			browsable.pages);
	});
var $author$project$Indexer$Group$allPageSelectionsInGroup = F2(
	function (groups, selection) {
		var groupBrowsables = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm_community$list_extra$List$Extra$getAt, selection.group, groups));
		return $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				$author$project$Indexer$Group$pageSelectionsForBrowsable(selection.group),
				groupBrowsables));
	});
var $author$project$Indexer$Group$nextPage = F2(
	function (currentSelection, groups) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_update(
				currentSelection,
				{document: 0, page: 0}),
			A3(
				$author$project$Indexer$Group$advanceFrom,
				currentSelection,
				1,
				A2($author$project$Indexer$Group$allPageSelectionsInGroup, groups, currentSelection)));
	});
var $author$project$Helpers$List$filterOutMaybes = function (list) {
	return A2($elm$core$List$filterMap, $elm$core$Basics$identity, list);
};
var $author$project$Helpers$List$indexedFilterMap = F2(
	function (filterMapper, list) {
		return $author$project$Helpers$List$filterOutMaybes(
			A2($elm$core$List$indexedMap, filterMapper, list));
	});
var $author$project$Indexer$Group$pageSelectionsOfType = F3(
	function (documentType, selection, browsables) {
		return $elm$core$List$concat(
			A2(
				$author$project$Helpers$List$indexedFilterMap,
				F2(
					function (docIndex, browsable) {
						return _Utils_eq(
							$author$project$Domain$Document$documentTypeValueToUnresolved(browsable.document.documentTypeValue),
							documentType) ? $elm$core$Maybe$Just(
							A3($author$project$Indexer$Group$pageSelectionsForBrowsable, selection.group, docIndex, browsable)) : $elm$core$Maybe$Nothing;
					}),
				A2($author$project$Indexer$Group$getList, selection.group, browsables)));
	});
var $author$project$Indexer$Group$nextPageOfType = F3(
	function (documentType, selection, browsables) {
		return A2(
			$elm$core$Maybe$withDefault,
			selection,
			A3(
				$author$project$Indexer$Group$advanceFrom,
				selection,
				1,
				A3($author$project$Indexer$Group$pageSelectionsOfType, documentType, selection, browsables)));
	});
var $author$project$Indexer$Group$prevGroup = F2(
	function (currentSelection, _v0) {
		var prevIndex = (!currentSelection.group) ? 0 : (currentSelection.group - 1);
		return {document: 0, group: prevIndex, lines: _List_Nil, page: 0};
	});
var $author$project$Indexer$Group$prevPage = F2(
	function (currentSelection, groups) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_update(
				currentSelection,
				{document: 0, page: 0}),
			A3(
				$author$project$Indexer$Group$advanceFrom,
				currentSelection,
				-1,
				A2($author$project$Indexer$Group$allPageSelectionsInGroup, groups, currentSelection)));
	});
var $author$project$Indexer$Group$prevPageOfType = F3(
	function (documentType, selection, browsables) {
		return A2(
			$elm$core$Maybe$withDefault,
			selection,
			A3(
				$author$project$Indexer$Group$advanceFrom,
				selection,
				-1,
				A3($author$project$Indexer$Group$pageSelectionsOfType, documentType, selection, browsables)));
	});
var $author$project$Indexer$Group$get = F2(
	function (grouped, selection) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Indexer$Group$getAt(selection.document),
			A2($author$project$Indexer$Group$getAt, selection.group, grouped));
	});
var $author$project$Indexer$Group$getDocument = F2(
	function (grouped, selection) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.document;
			},
			A2($author$project$Indexer$Group$get, grouped, selection));
	});
var $author$project$Indexer$DocumentBrowser$mainImageId = function (idPrefix) {
	return idPrefix + 'main-image-selected';
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$selectSelection = F2(
	function (selection, model) {
		return _Utils_eq(selection.group, model.selection.group) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{selection: selection}),
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						$author$project$HubTran$Effect$cmd(
						$author$project$Js$scrollToId(
							$author$project$Indexer$DocumentBrowser$mainImageId($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix))),
						$author$project$HubTran$Effect$cmd(
						$author$project$Js$scrollToId(
							$author$project$Indexer$DocumentBrowser$thumbnailSelectedId($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix)))
					]))) : _Utils_Tuple2(
			model,
			$author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						A4($author$project$Factoring$Page$ClientSubmissionInvoice$goToGroup, model.emailMessageId, selection.group, model.dismissFundingNotes, model.onDoneQuery),
						$author$project$HubTran$Effect$cmd(
						$author$project$Js$scrollToId(
							$author$project$Indexer$DocumentBrowser$mainImageId($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix))),
						$author$project$HubTran$Effect$cmd(
						$author$project$Js$scrollToId(
							A2($author$project$Indexer$DocumentBrowser$groupId, $author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix, selection.group)))
					])));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$storeHotkeySelection = F3(
	function (docTypeKey, selection, model) {
		var newSelections = A3($elm$core$Dict$insert, docTypeKey, selection, model.mostRecentHotkeySelections);
		return _Utils_update(
			model,
			{mostRecentHotkeySelections: newSelections});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$returnToMostRecentOrSelect = F4(
	function (docType, model, groups, requestedSelection) {
		var docTypeKey = $author$project$AuditPb$documentTypeToString(docType);
		var recentSelection = A2($elm$core$Dict$get, docTypeKey, model.mostRecentHotkeySelections);
		var currentSelection = model.selection;
		var currentDocType = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Domain$Document$documentTypeValueToUnresolved,
				function ($) {
					return $.documentTypeValue;
				}),
			A2($author$project$Indexer$Group$getDocument, groups, currentSelection));
		var nextSelection = (!_Utils_eq(
			currentDocType,
			$elm$core$Maybe$Just(
				$author$project$Domain$UnresolvedDocumentType$Resolved(docType)))) ? A2($elm$core$Maybe$withDefault, requestedSelection, recentSelection) : requestedSelection;
		return A2(
			$elm$core$Tuple$mapFirst,
			A2($author$project$Factoring$Page$ClientSubmissionInvoice$storeHotkeySelection, docTypeKey, nextSelection),
			A2($author$project$Factoring$Page$ClientSubmissionInvoice$selectSelection, nextSelection, model));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$keyboardEventUpdate = F3(
	function (model, groups, ke) {
		var currentSelection = model.selection;
		var returnToMostRecentOrSelectNext = function (docType) {
			return A4(
				$author$project$Factoring$Page$ClientSubmissionInvoice$returnToMostRecentOrSelect,
				docType,
				model,
				groups,
				A3(
					$author$project$Indexer$Group$nextPageOfType,
					$author$project$Domain$UnresolvedDocumentType$Resolved(docType),
					currentSelection,
					groups));
		};
		var returnToMostRecentOrSelectPrev = function (docType) {
			return A4(
				$author$project$Factoring$Page$ClientSubmissionInvoice$returnToMostRecentOrSelect,
				docType,
				model,
				groups,
				A3(
					$author$project$Indexer$Group$prevPageOfType,
					$author$project$Domain$UnresolvedDocumentType$Resolved(docType),
					currentSelection,
					groups));
		};
		var select = function (getSelection_) {
			var selection = A2(getSelection_, currentSelection, groups);
			return (!_Utils_eq(selection, currentSelection)) ? A2($author$project$Factoring$Page$ClientSubmissionInvoice$selectSelection, selection, model) : _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		};
		if (ke.altKey) {
			var _v0 = ke.keyCode;
			switch (_v0.$) {
				case 'P':
					return ke.shiftKey ? select($author$project$Indexer$Group$prevPage) : select($author$project$Indexer$Group$nextPage);
				case 'G':
					return ke.shiftKey ? select($author$project$Indexer$Group$prevGroup) : select($author$project$Indexer$Group$nextGroup);
				case 'S':
					return select($author$project$Indexer$Group$nextPage);
				case 'A':
					return select($author$project$Indexer$Group$prevPage);
				case 'W':
					return select($author$project$Indexer$Group$nextGroup);
				case 'Q':
					return select($author$project$Indexer$Group$prevGroup);
				case 'One':
					return ke.shiftKey ? returnToMostRecentOrSelectPrev($author$project$AuditPb$DocumentTypeInvoice) : returnToMostRecentOrSelectNext($author$project$AuditPb$DocumentTypeInvoice);
				case 'Two':
					return ke.shiftKey ? returnToMostRecentOrSelectPrev($author$project$AuditPb$DocumentTypeRateConfirmation) : returnToMostRecentOrSelectNext($author$project$AuditPb$DocumentTypeRateConfirmation);
				case 'Three':
					return ke.shiftKey ? returnToMostRecentOrSelectPrev($author$project$AuditPb$DocumentTypeBillOfLading) : returnToMostRecentOrSelectNext($author$project$AuditPb$DocumentTypeBillOfLading);
				default:
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			}
		} else {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Change$Debtor = function (a) {
	return {$: 'Debtor', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange = function (a) {
	return {$: 'QueueChange', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$sendCmd = A2(
	$elm$core$Basics$composeR,
	$elm$core$Task$succeed,
	$elm$core$Task$perform($elm$core$Basics$identity));
var $author$project$Factoring$Page$ClientSubmissionInvoice$queueDebtorChange = function (debtorId) {
	var msg = $author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
		$author$project$Factoring$Page$ClientSubmission$Change$Debtor(debtorId));
	return $author$project$HubTran$Effect$cmd(
		$author$project$Factoring$Page$ClientSubmissionInvoice$sendCmd(msg));
};
var $author$project$Factoring$Page$ClientSubmission$Change$AssignSubmission = function (a) {
	return {$: 'AssignSubmission', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$queueSubmissionChange = F2(
	function (submissionId, groupId) {
		var msg = $author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
			$author$project$Factoring$Page$ClientSubmission$Change$AssignSubmission(
				_Utils_Tuple2(groupId, submissionId)));
		return $author$project$HubTran$Effect$cmd(
			$author$project$Factoring$Page$ClientSubmissionInvoice$sendCmd(msg));
	});
var $author$project$Api$DocumentBatches$resolveMismatch = function (documentBatchId) {
	var url = '/api/document_batches/' + (A2($elm$core$Basics$composeL, $elm$core$Debug$toString, $author$project$Domain$DocumentBatchId$toInt)(documentBatchId) + '/resolve_mismatch');
	return A2(
		$author$project$Helpers$Api$putWithNoResponseBody,
		url,
		$elm$json$Json$Encode$object(_List_Nil));
};
var $jinjor$elm_debounce$Debounce$unlock = function (config) {
	return A2(
		$elm$core$Platform$Cmd$map,
		config.transform,
		A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			$elm$core$Task$succeed(
				$jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Nothing))));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$restartDebounce = $author$project$HubTran$Effect$cmd(
	$jinjor$elm_debounce$Debounce$unlock($author$project$Factoring$Page$ClientSubmissionInvoice$debounceConfig));
var $author$project$Factoring$Page$ClientSubmissionInvoice$secondaryBrowserPrefix = 'secondary';
var $author$project$Components$DebtorWithAddressTypeahead$select = $author$project$Typeahead$selectItem;
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$select = F2(
	function (submissionDropdownData, model) {
		var item = $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$submissionToItem(submissionDropdownData);
		return _Utils_update(
			model,
			{
				dropdown: A2(
					$author$project$Components$PaginatedDropdown$select,
					_List_fromArray(
						[item]),
					model.dropdown)
			});
	});
var $author$project$Components$DebtorWithAddressTypeahead$selectedId = $author$project$Typeahead$selectedId;
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$selectedSubmissionDisplayText = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.text;
		},
		$elm$core$List$head(
			$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown)));
};
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$selectedSubmissionId = function (model) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Domain$FactorInvoiceSubmissionId$fromInt,
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$String$toInt,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.id;
				},
				$elm$core$List$head(
					$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown)))));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$showSaveError = $author$project$HubTran$Effect$flash(
	$author$project$HubTran$Flash$alert('Error saving your changes to this invoice'));
var $author$project$Factoring$Page$ClientSubmission$Change$prependTuple = F3(
	function (a, b, list) {
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(a, b),
			list);
	});
var $author$project$Factoring$Page$ClientSubmission$Change$skipDuplicates = F3(
	function (id, data, list) {
		return A3(
			$author$project$Factoring$Page$ClientSubmission$Change$prependTuple,
			id,
			data,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$neq(id)),
				list));
	});
var $author$project$Factoring$Page$ClientSubmission$Change$addInvoiceField = F3(
	function (name, value, requests) {
		return _Utils_update(
			requests,
			{
				invoice: A3($author$project$Factoring$Page$ClientSubmission$Change$skipDuplicates, name, value, requests.invoice)
			});
	});
var $author$project$Factoring$Page$ClientSubmission$Change$encodeDebtorId = function (id) {
	if (id.$ === 'Nothing') {
		return $elm$json$Json$Encode$null;
	} else {
		var x = id.a;
		return $elm$json$Json$Encode$int(
			$author$project$Domain$FactorBrokerId$toInt(x));
	}
};
var $author$project$Factoring$Page$ClientSubmission$Change$collectRequests = F3(
	function (invoice, change, requests) {
		switch (change.$) {
			case 'Text':
				var field = change.a;
				var value = change.b;
				var fieldName = function () {
					switch (field.$) {
						case 'LoadId':
							return 'load_id';
						case 'Number':
							return 'source_invoice_number';
						case 'Amount':
							return 'source_invoice_amount';
						default:
							return 'source_invoice_date';
					}
				}();
				return A3(
					$author$project$Factoring$Page$ClientSubmission$Change$addInvoiceField,
					fieldName,
					$elm$json$Json$Encode$string(value),
					requests);
			case 'Boolean':
				var check = change.a;
				var value = change.b;
				var fieldName = function () {
					switch (check.$) {
						case 'Tonu':
							return 'tonu';
						case 'ClientOrDebtorOnBol':
							return 'client_or_debtor_on_bol';
						case 'AmountMatchesRateCon':
							return 'amount_matches_rate_con';
						case 'ThirdPartyListedOnBol':
							return 'third_party_listed_on_bol';
						default:
							return 'pickup_dropoff_matches';
					}
				}();
				return A3(
					$author$project$Factoring$Page$ClientSubmission$Change$addInvoiceField,
					fieldName,
					$elm$json$Json$Encode$bool(value),
					requests);
			case 'AssignSubmission':
				var id = change.a;
				return _Utils_update(
					requests,
					{
						assignSubmission: $elm$core$Maybe$Just(id)
					});
			case 'Debtor':
				var id = change.a;
				return _Utils_eq(
					id,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.id;
						},
						invoice.debtor)) ? requests : A3(
					$author$project$Factoring$Page$ClientSubmission$Change$addInvoiceField,
					'factor_broker_id',
					$author$project$Factoring$Page$ClientSubmission$Change$encodeDebtorId(id),
					requests);
			case 'BadQuality':
				var pageIds = change.a;
				return _Utils_update(
					requests,
					{
						badQuality: $elm$core$Maybe$Just(pageIds)
					});
			case 'MissingPages':
				var types = change.a;
				return _Utils_update(
					requests,
					{
						missingPages: $elm$core$Maybe$Just(types)
					});
			case 'DocumentType':
				var id = change.a;
				var type_ = change.b;
				return _Utils_update(
					requests,
					{
						documentType: A3($author$project$Factoring$Page$ClientSubmission$Change$skipDuplicates, id, type_, requests.documentType)
					});
			case 'RotatePage':
				var id = change.a;
				var degrees = change.b;
				return _Utils_update(
					requests,
					{
						pageRotations: A3($author$project$Factoring$Page$ClientSubmission$Change$skipDuplicates, id, degrees, requests.pageRotations)
					});
			case 'MoveDocument':
				var id = change.a;
				var direction = change.b;
				return _Utils_update(
					requests,
					{
						documentGroupMovements: A3($author$project$Factoring$Page$ClientSubmission$Change$skipDuplicates, id, direction, requests.documentGroupMovements)
					});
			case 'Rule':
				var state = change.a;
				var rule = change.b;
				return _Utils_update(
					requests,
					{
						rule: A3($author$project$Factoring$Page$ClientSubmission$Change$skipDuplicates, rule, state, requests.rule)
					});
			case 'Review':
				return _Utils_update(
					requests,
					{review: true});
			case 'CreateCustomException':
				var message = change.a;
				return _Utils_update(
					requests,
					{
						newExceptionMessage: A2(
							$elm$core$List$append,
							requests.newExceptionMessage,
							_List_fromArray(
								[message]))
					});
			default:
				var resolutionMessage = change.a;
				var id = change.b;
				return _Utils_update(
					requests,
					{
						resolutionMessage: A2(
							$elm$core$List$append,
							requests.resolutionMessage,
							_List_fromArray(
								[
									_Utils_Tuple2(resolutionMessage, id)
								]))
					});
		}
	});
var $author$project$Api$Exceptions$createCustomException = F2(
	function (id, exceptionMessage) {
		var url = '/api/exceptions';
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'factor_invoice_id',
					$elm$json$Json$Encode$int(
						$author$project$Domain$FactorInvoiceId$toInt(id))),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string(exceptionMessage)),
					_Utils_Tuple2(
					'submission_workflow',
					$elm$json$Json$Encode$bool(true))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Api$FactorInvoice$memberUrl = F2(
	function (id, ending) {
		return '/api/factor_invoices/' + ($elm$core$String$fromInt(
			$author$project$Domain$FactorInvoiceId$toInt(id)) + ('/' + ending));
	});
var $author$project$Api$FactorInvoice$enableRule = F2(
	function (id, rule) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			A2($author$project$Api$FactorInvoice$memberUrl, id, 'rules/enable'),
			rule);
	});
var $author$project$Api$FactorInvoice$ignoreRule = F2(
	function (id, rule) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			A2($author$project$Api$FactorInvoice$memberUrl, id, 'rules/ignore'),
			rule);
	});
var $author$project$Api$DocumentGroups$manuallyAssignSubmission = F2(
	function (groupId, factorInvoiceSubmissionId) {
		var url = '/api/document_groups/' + ($elm$core$String$fromInt(
			$author$project$Domain$DocumentGroupId$toInt(groupId)) + ('/manually_assign_submission' + '?format=forward'));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'factor_client_invoice_submission_id',
					$elm$json$Json$Encode$int(
						$author$project$Domain$FactorInvoiceSubmissionId$toInt(factorInvoiceSubmissionId)))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Api$Documents$moveGroup = F2(
	function (id, direction) {
		var endpoint = function () {
			if (direction.$ === 'Next') {
				return 'move_next';
			} else {
				return 'move_previous';
			}
		}();
		var url = '/api/document_pages/' + ($elm$core$String$fromInt(
			$author$project$Domain$DocumentId$toInt(id)) + ('/' + (endpoint + '?format=forward')));
		var body = $elm$json$Json$Encode$object(_List_Nil);
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Factoring$Page$ClientSubmission$Change$noRequests = {assignSubmission: $elm$core$Maybe$Nothing, badQuality: $elm$core$Maybe$Nothing, documentGroupMovements: _List_Nil, documentType: _List_Nil, invoice: _List_Nil, invoiceDate: $elm$core$Maybe$Nothing, missingPages: $elm$core$Maybe$Nothing, newExceptionMessage: _List_Nil, pageRotations: _List_Nil, resolutionMessage: _List_Nil, review: false, rule: _List_Nil};
var $author$project$Factoring$Page$ClientSubmission$Change$oneRequestPer = F2(
	function (criteria, f) {
		return A2($elm$core$List$map, f, criteria);
	});
var $author$project$Factoring$Page$ClientSubmission$Change$requestIf = F2(
	function (criteria, x) {
		return criteria ? _List_fromArray(
			[x]) : _List_Nil;
	});
var $author$project$Factoring$Page$ClientSubmission$Change$requestMaybe = F2(
	function (criteria, f) {
		if (criteria.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var a = criteria.a;
			return _List_fromArray(
				[
					f(a)
				]);
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Change$requestNonEmpty = F2(
	function (criteria, f) {
		if (!criteria.b) {
			return _List_Nil;
		} else {
			var xs = criteria;
			return _List_fromArray(
				[
					f(xs)
				]);
		}
	});
var $author$project$Api$Exceptions$baseUrl = function (id) {
	return '/api/factor_invoices/' + ($elm$core$String$fromInt(
		$author$project$Domain$FactorInvoiceId$toInt(id)) + '/exceptions');
};
var $author$project$Domain$ExceptionEventId$encode = function (id) {
	return $elm$json$Json$Encode$int(
		$author$project$Domain$ExceptionEventId$toInt(id));
};
var $author$project$Api$Exceptions$resolveException = F2(
	function (id, _v0) {
		var resolutionMessage = _v0.a;
		var exceptionEventId = _v0.b;
		var url = $author$project$Api$Exceptions$baseUrl(id) + ('/' + ($elm$core$String$fromInt(
			$author$project$Domain$ExceptionEventId$toInt(exceptionEventId)) + '/resolve'));
		var nonEmptyResolution = function () {
			if (resolutionMessage === '') {
				return 'No resolution message given.';
			} else {
				return resolutionMessage;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$author$project$Domain$ExceptionEventId$encode(exceptionEventId)),
					_Utils_Tuple2(
					'resolution',
					$elm$json$Json$Encode$string(nonEmptyResolution)),
					_Utils_Tuple2(
					'submission_workflow',
					$elm$json$Json$Encode$bool(true))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Api$FactorInvoice$reviewSubmission = function (id) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		A2($author$project$Api$FactorInvoice$memberUrl, id, 'review_submission'),
		$elm$json$Json$Encode$object(_List_Nil));
};
var $author$project$Api$FactorInvoice$update = function (fields) {
	var json = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'factor_invoice',
				$elm$json$Json$Encode$object(fields))
			]));
	return A2($author$project$Helpers$Api$postWithNoResponseBody, '/api/factor_invoices/', json);
};
var $author$project$Api$Exceptions$updateBadQuality = F2(
	function (id, pageIds) {
		var url = $author$project$Api$Exceptions$baseUrl(id) + '/update_bad_quality';
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document_page_ids',
					A2(
						$elm$json$Json$Encode$list,
						A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Domain$DocumentPageId$toInt),
						pageIds))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Api$Exceptions$updateMissingPages = F2(
	function (id, types) {
		var url = $author$project$Api$Exceptions$baseUrl(id) + '/update_missing_pages';
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'types',
					A2($elm$json$Json$Encode$list, $author$project$Encode$DocumentTypeEncoder$encodeDocumentType, types))
				]));
		return A2($author$project$Helpers$Api$postWithNoResponseBody, url, body);
	});
var $author$project$Factoring$Page$ClientSubmission$Change$toHttpRequests = F2(
	function (invoice, changes) {
		var id = invoice.id;
		var changed = A3(
			$elm$core$List$foldr,
			$author$project$Factoring$Page$ClientSubmission$Change$collectRequests(invoice),
			$author$project$Factoring$Page$ClientSubmission$Change$noRequests,
			changes);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$requestNonEmpty,
					changed.invoice,
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$Factoring$Page$ClientSubmission$Change$prependTuple,
							'id',
							$elm$json$Json$Encode$int(
								$author$project$Domain$FactorInvoiceId$toInt(id))),
						$author$project$Api$FactorInvoice$update)),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$oneRequestPer,
					changed.rule,
					function (_v0) {
						var rule = _v0.a;
						var state = _v0.b;
						if (state.$ === 'Enabled') {
							return A2($author$project$Api$FactorInvoice$enableRule, id, rule);
						} else {
							return A2($author$project$Api$FactorInvoice$ignoreRule, id, rule);
						}
					}),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$oneRequestPer,
					changed.documentType,
					function (_v2) {
						var a = _v2.a;
						var b = _v2.b;
						return A2($author$project$Api$Documents$setDocumentType, a, b);
					}),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$oneRequestPer,
					changed.pageRotations,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return A2($author$project$Api$Documents$rotatePage, a, b);
					}),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$oneRequestPer,
					changed.documentGroupMovements,
					function (_v4) {
						var a = _v4.a;
						var b = _v4.b;
						return A2($author$project$Api$Documents$moveGroup, a, b);
					}),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$requestMaybe,
					changed.badQuality,
					$author$project$Api$Exceptions$updateBadQuality(id)),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$requestMaybe,
					changed.missingPages,
					$author$project$Api$Exceptions$updateMissingPages(id)),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$requestIf,
					changed.review,
					$author$project$Api$FactorInvoice$reviewSubmission(id)),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$oneRequestPer,
					changed.newExceptionMessage,
					$author$project$Api$Exceptions$createCustomException(id)),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$oneRequestPer,
					changed.resolutionMessage,
					$author$project$Api$Exceptions$resolveException(id)),
					A2(
					$author$project$Factoring$Page$ClientSubmission$Change$requestMaybe,
					changed.assignSubmission,
					function (_v5) {
						var groupId = _v5.a;
						var submissionId = _v5.b;
						return A2($author$project$Api$DocumentGroups$manuallyAssignSubmission, groupId, submissionId);
					})
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$topOfWorkArea = 'work-area--top';
var $author$project$Components$DebtorWithAddressTypeahead$maybe = F3(
	function (_default, f, m) {
		if (m.$ === 'Just') {
			var x = m.a;
			return f(x);
		} else {
			return _default;
		}
	});
var $author$project$Components$DebtorWithAddressTypeahead$maybeJoin = F3(
	function (separator, first, second) {
		var _v0 = _Utils_Tuple2(first, second);
		if (_v0.a.$ === 'Just') {
			if (_v0.b.$ === 'Just') {
				var x = _v0.a.a;
				var y = _v0.b.a;
				return $elm$core$Maybe$Just(
					_Utils_ap(
						x,
						_Utils_ap(separator, y)));
			} else {
				var _v1 = _v0.b;
				return first;
			}
		} else {
			if (_v0.b.$ === 'Just') {
				var _v2 = _v0.a;
				return second;
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$DebtorWithAddressTypeahead$viewDetail = function (prefix) {
	return A2(
		$author$project$Components$DebtorWithAddressTypeahead$maybe,
		'',
		function (content) {
			return _Utils_ap(prefix, content);
		});
};
var $author$project$Components$DebtorWithAddressTypeahead$viewDebtorAddress = function (address) {
	return A2($author$project$Components$DebtorWithAddressTypeahead$viewDetail, '', address.addressLine1) + (A2($author$project$Components$DebtorWithAddressTypeahead$viewDetail, '', address.addressLine2) + (' ' + A2(
		$author$project$Components$DebtorWithAddressTypeahead$viewDetail,
		'',
		A3(
			$author$project$Components$DebtorWithAddressTypeahead$maybeJoin,
			', ',
			address.city,
			A3($author$project$Components$DebtorWithAddressTypeahead$maybeJoin, ' ', address.state, address.postalCode)))));
};
var $author$project$Components$DebtorWithAddressTypeahead$display = function (debtorWithAddress) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(debtorWithAddress.factorBroker.name)
					])),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('secondary-typeahead-info')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3($author$project$Components$DebtorWithAddressTypeahead$maybe, '', $author$project$Components$DebtorWithAddressTypeahead$viewDebtorAddress, debtorWithAddress.address))
					]))
			]));
};
var $author$project$Components$DebtorWithAddressTypeahead$config = {
	additionalInputAttributes: _List_Nil,
	additionalMenuAttributes: _List_Nil,
	idToString: A2($elm$core$Basics$composeR, $author$project$Domain$FactorBrokerId$toInt, $elm$core$String$fromInt),
	inputClassOverride: $elm$core$Maybe$Nothing,
	itemDisplay: $author$project$Components$DebtorWithAddressTypeahead$display,
	itemName: A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.factorBroker;
		},
		function ($) {
			return $.name;
		}),
	liClassOverride: $elm$core$Maybe$Nothing,
	noItemDisplay: $elm$core$Maybe$Nothing,
	placeholder: 'Debtor Name',
	prependItems: _List_Nil,
	sort: $elm$core$List$sortBy(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.factorBroker;
			},
			function ($) {
				return $.name;
			})),
	toId: A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.factorBroker;
		},
		function ($) {
			return $.id;
		})
};
var $author$project$Components$DebtorWithAddressTypeahead$update = $author$project$Typeahead$update($author$project$Components$DebtorWithAddressTypeahead$config);
var $author$project$Factoring$Page$ClientSubmission$Header$handleIgnoreResponse = F2(
	function (result, httpErrMsg) {
		switch (result.$) {
			case 'Ok':
				return $author$project$HubTran$Effect$cmd(
					$author$project$HubTran$Navigation$load('/app'));
			case 'Err':
				var message = result.a;
				return $author$project$HubTran$Effect$flash(
					$author$project$HubTran$Flash$alert(message));
			default:
				return $author$project$HubTran$Effect$flash(
					$author$project$HubTran$Flash$alert(httpErrMsg));
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Header$FinishIgnoreAllGroups = function (a) {
	return {$: 'FinishIgnoreAllGroups', a: a};
};
var $author$project$Api$DocumentBatches$memberUrl = function (id) {
	return '/api/imports/document_batches/' + $elm$core$String$fromInt(
		$author$project$Domain$DocumentBatchId$toInt(id));
};
var $author$project$Api$DocumentBatches$ignoreAllGroups = function (documentBatchId) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		$author$project$Api$DocumentBatches$memberUrl(documentBatchId) + '/ignore',
		$elm$json$Json$Encode$null);
};
var $author$project$Factoring$Page$ClientSubmission$Header$ignoreAllGroups = function (documentBatchId) {
	return A2(
		$author$project$HubTran$Effect$sendCacheableRequestWithError,
		$author$project$Factoring$Page$ClientSubmission$Header$FinishIgnoreAllGroups,
		$author$project$Api$DocumentBatches$ignoreAllGroups(documentBatchId));
};
var $author$project$Factoring$Page$ClientSubmission$Header$FinishIgnoreEmail = function (a) {
	return {$: 'FinishIgnoreEmail', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Header$ignoreEmail = function (emailMessageId) {
	return A2(
		$author$project$HubTran$Effect$sendCacheableRequestWithError,
		$author$project$Factoring$Page$ClientSubmission$Header$FinishIgnoreEmail,
		$author$project$Api$EmailMessages$ignore(
			_List_fromArray(
				[emailMessageId])));
};
var $author$project$Factoring$Page$ClientSubmission$Header$update = function (msg) {
	switch (msg.$) {
		case 'GoTo':
			var url = msg.a;
			return $author$project$HubTran$Effect$cmd(
				$author$project$HubTran$Navigation$pushUrl(url));
		case 'IgnoreAllGroups':
			var documentBatchId = msg.a;
			return $author$project$Factoring$Page$ClientSubmission$Header$ignoreAllGroups(documentBatchId);
		case 'FinishIgnoreAllGroups':
			var result = msg.a;
			return A2($author$project$Factoring$Page$ClientSubmission$Header$handleIgnoreResponse, result, 'Could not ignore all groups.');
		case 'IgnoreEmail':
			var emailMessageId = msg.a;
			return $author$project$Factoring$Page$ClientSubmission$Header$ignoreEmail(emailMessageId);
		default:
			var result = msg.a;
			return A2($author$project$Factoring$Page$ClientSubmission$Header$handleIgnoreResponse, result, 'Could not ignore email.');
	}
};
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$maybeSubmissionToItem = function (maybeSubmission) {
	return A2(
		$elm$core$Maybe$withDefault,
		{
			id: '',
			label: $elm$html$Html$text(''),
			text: ''
		},
		A2($elm$core$Maybe$map, $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$submissionToItem, maybeSubmission));
};
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$update = F3(
	function (data, msg, model) {
		var _v0 = A4($author$project$Components$PaginatedDropdown$update, $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$maybeSubmissionToItem, data, msg, model.dropdown);
		var dropdown = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dropdown: dropdown}),
			cmd);
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateDocumentGroups = F2(
	function (a, b) {
		return {$: 'UpdateDocumentGroups', a: a, b: b};
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateFinished = function (a) {
	return {$: 'UpdateFinished', a: a};
};
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateGroupingFinished = function (a) {
	return {$: 'UpdateGroupingFinished', a: a};
};
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleError_ = F2(
	function (model, error) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					errorMessage: $elm$core$Maybe$Just('Server error: ' + error),
					isSaving: false
				}),
			$author$project$HubTran$Effect$none);
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleSuccess_ = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{errorMessage: $elm$core$Maybe$Nothing, isSaving: false}),
		$author$project$HubTran$Effect$none);
};
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleUpdate = F2(
	function (res, model) {
		switch (res.$) {
			case 'Ok':
				return $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleSuccess_(model);
			case 'Err':
				var message = res.a;
				return A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleError_, model, message);
			default:
				var error = res.a;
				return A2(
					$author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleError_,
					model,
					$elm$core$Debug$toString(error));
		}
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$updateType = F2(
	function (document, type_) {
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			'/api/documents/' + (A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Domain$DocumentId$toInt)(document.id) + '?format=forward'),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'document',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'type',
									$author$project$AuditPb$documentTypeEncoder(type_))
								])))
					])));
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateType':
				var document = msg.a;
				var type_ = msg.b;
				var updateDocTypeRequest = A2(
					$author$project$HubTran$Effect$sendCacheableRequestWithError,
					$author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateFinished,
					A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$updateType, document, type_));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					updateDocTypeRequest);
			case 'UpdateTypeAndGroup':
				var document = msg.a;
				var type_ = msg.b;
				var documentBatchId = msg.c;
				var updateDocTypeRequest = A2(
					$author$project$HubTran$Effect$sendCacheableRequestWithError,
					$author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateDocumentGroups(documentBatchId),
					A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$updateType, document, type_));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					updateDocTypeRequest);
			case 'UpdateDocumentGroups':
				var documentBatchId = msg.a;
				var res = msg.b;
				switch (res.$) {
					case 'Ok':
						var updateGroupRequest = A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateGroupingFinished,
							$author$project$Api$DocumentBatches$autoGroup(documentBatchId));
						return _Utils_Tuple2(model, updateGroupRequest);
					case 'Err':
						var message = res.a;
						return A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleError_, model, message);
					default:
						var error = res.a;
						return A2(
							$author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleError_,
							model,
							$elm$core$Debug$toString(error));
				}
			case 'UpdateGroupingFinished':
				var res = msg.a;
				return A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleUpdate, res, model);
			case 'UpdateFinished':
				var res = msg.a;
				return A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$handleUpdate, res, model);
			default:
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$DocumentBrowserMsg = function (a) {
	return {$: 'DocumentBrowserMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$getMaybeEmailMessage = function (data) {
	return $author$project$Forward$Remote$toMaybe(
		A2(
			$author$project$Forward$Remote$map,
			function ($) {
				return $.emailMessage;
			},
			A2(
				$author$project$Forward$Remote$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pageData;
					},
					function ($) {
						return $.coreData;
					}),
				data)));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$getMaybeSettings = function (data) {
	return $author$project$Forward$Remote$toMaybe(
		A2(
			$author$project$Forward$Remote$map,
			function ($) {
				return $.settings;
			},
			A2(
				$author$project$Forward$Remote$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pageData;
					},
					function ($) {
						return $.coreData;
					}),
				data)));
};
var $author$project$Indexer$DocumentBrowser$FinishPodUpdate = function (a) {
	return {$: 'FinishPodUpdate', a: a};
};
var $author$project$Js$autolink = _Platform_outgoingPort('autolink', $elm$json$Json$Encode$string);
var $author$project$Indexer$DocumentBrowser$availableLabels = F2(
	function (settings, email) {
		return A2(
			$elm$core$List$filter,
			function (l) {
				return !A2($elm$core$List$member, l, email.labels);
			},
			$author$project$Domain$AccountSettings$labelNames(settings.labels));
	});
var $author$project$Indexer$DocumentBrowser$emailViewerClass = 'email-viewer__body';
var $author$project$Indexer$DocumentBrowser$findAt = function (index) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$drop(index),
		$elm$core$List$head);
};
var $author$project$Helpers$Api$Result$toStringError = F3(
	function (genericMessage, toMessage, result) {
		switch (result.$) {
			case 'Ok':
				var a = result.a;
				return $elm$core$Result$Ok(a);
			case 'Err':
				var x = result.a;
				return $elm$core$Result$Err(
					genericMessage + (': ' + toMessage(x)));
			default:
				return $elm$core$Result$Err(genericMessage);
		}
	});
var $author$project$Indexer$DocumentBrowser$FinishLabelUpdate = F2(
	function (a, b) {
		return {$: 'FinishLabelUpdate', a: a, b: b};
	});
var $author$project$Indexer$DocumentBrowser$updateLabel = F3(
	function (name, request, model) {
		var labelEditor = model.labelEditor;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					labelEditor: _Utils_update(
						labelEditor,
						{
							saving: A2($elm$core$Set$insert, name, labelEditor.saving)
						})
				}),
			A2(
				$author$project$HubTran$Effect$sendCacheableRequestWithError,
				$author$project$Indexer$DocumentBrowser$FinishLabelUpdate(name),
				A2(request, model.emailMessageId, name)));
	});
var $author$project$Indexer$DocumentBrowser$withFlashOnError = F2(
	function (result, tuple) {
		var model = tuple.a;
		var cmds = tuple.b;
		if (result.$ === 'Ok') {
			return tuple;
		} else {
			var message = result.a;
			return _Utils_Tuple2(
				model,
				$author$project$HubTran$Effect$batch(
					_List_fromArray(
						[
							cmds,
							$author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$alert(message))
						])));
		}
	});
var $author$project$Indexer$DocumentBrowser$update = F4(
	function (settings, emailMessage, msg, model) {
		var labelEditor = model.labelEditor;
		switch (msg.$) {
			case 'MessageLoaded':
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						$author$project$Js$autolink('.' + $author$project$Indexer$DocumentBrowser$emailViewerClass)));
			case 'MainImageLoaded':
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$HubTran$Effect$cmd(
								$author$project$Js$setupDragHandlers($author$project$Indexer$DocumentBrowser$documentLineContext)),
								$author$project$HubTran$Effect$cmd(
								$author$project$Js$scrollToId(
									$author$project$Indexer$DocumentBrowser$thumbnailSelectedId(model.idPrefix)))
							])));
			case 'SetSize':
				var size = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{size: size}),
					$author$project$HubTran$Effect$none);
			case 'SetTab':
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{activeTab: tab}),
					$author$project$HubTran$Effect$none);
			case 'SelectLabel':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							labelEditor: _Utils_update(
								labelEditor,
								{selected: value})
						}),
					$author$project$HubTran$Effect$none);
			case 'AddLabel':
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$HubTran$Effect$none),
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return A3($author$project$Indexer$DocumentBrowser$updateLabel, x, $author$project$Api$EmailMessages$addLabel, model);
						},
						A2(
							$author$project$Indexer$DocumentBrowser$findAt,
							labelEditor.selected,
							A2($author$project$Indexer$DocumentBrowser$availableLabels, settings, emailMessage))));
			case 'DeleteLabel':
				var name = msg.a;
				return A3($author$project$Indexer$DocumentBrowser$updateLabel, name, $author$project$Api$EmailMessages$deleteLabel, model);
			case 'FinishLabelUpdate':
				var name = msg.a;
				var result = msg.b;
				return A2(
					$author$project$Indexer$DocumentBrowser$withFlashOnError,
					A3($author$project$Helpers$Api$Result$toStringError, 'Problem updating labels', $elm$core$Basics$identity, result),
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								labelEditor: _Utils_update(
									labelEditor,
									{
										saving: A2($elm$core$Set$remove, name, labelEditor.saving)
									})
							}),
						$author$project$HubTran$Effect$none));
			case 'FinishPodUpdate':
				var result = msg.a;
				return A2(
					$author$project$Indexer$DocumentBrowser$withFlashOnError,
					A3($author$project$Helpers$Api$Result$toStringError, 'Problem updating POD Status', $elm$core$Basics$identity, result),
					_Utils_Tuple2(model, $author$project$HubTran$Effect$none));
			case 'UpdatePod':
				var documentId = msg.a;
				var status = msg.b;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Indexer$DocumentBrowser$FinishPodUpdate,
						A2($author$project$Api$Documents$setPodStatus, documentId, status)));
			case 'UpdateGroup':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isUpdatingGroups: true}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isUpdatingGroups: false}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$updateDocumentBrowser = F3(
	function (data, msg_, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$getMaybeSettings(data),
			$author$project$Factoring$Page$ClientSubmissionInvoice$getMaybeEmailMessage(data));
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var settings = _v0.a.a;
			var emailMessage = _v0.b.a;
			var _v1 = A4($author$project$Indexer$DocumentBrowser$update, settings, emailMessage, msg_, model.documentBrowser);
			var documentBrowser = _v1.a;
			var documentBrowserCmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{documentBrowser: documentBrowser}),
				A2($author$project$HubTran$Effect$map, $author$project$Factoring$Page$ClientSubmissionInvoice$DocumentBrowserMsg, documentBrowserCmds));
		} else {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$updateMoveDocumentsModal = F2(
	function (fn, model) {
		return _Utils_update(
			model,
			{
				moveDocumentsModal: fn(model.moveDocumentsModal)
			});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$DocumentBrowserSecondaryMsg = function (a) {
	return {$: 'DocumentBrowserSecondaryMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$updateSecondaryDocumentBrowser = F3(
	function (data, msg_, model) {
		var _v0 = _Utils_Tuple3(
			$author$project$Factoring$Page$ClientSubmissionInvoice$getMaybeSettings(data),
			$author$project$Factoring$Page$ClientSubmissionInvoice$getMaybeEmailMessage(data),
			model.secondaryDocumentBrowser);
		if (((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) && (_v0.c.$ === 'Just')) {
			var settings = _v0.a.a;
			var emailMessage = _v0.b.a;
			var browser = _v0.c.a;
			var _v1 = A4($author$project$Indexer$DocumentBrowser$update, settings, emailMessage, msg_, browser.state);
			var documentBrowser = _v1.a;
			var documentBrowserCmds = _v1.b;
			var secondaryDocumentBrowser = A2($author$project$Factoring$Page$ClientSubmissionInvoice$Browser, browser.selection, documentBrowser);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						secondaryDocumentBrowser: $elm$core$Maybe$Just(secondaryDocumentBrowser)
					}),
				A2($author$project$HubTran$Effect$map, $author$project$Factoring$Page$ClientSubmissionInvoice$DocumentBrowserSecondaryMsg, documentBrowserCmds));
		} else {
			return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'UpdateDirtyAmount':
				var maybeChange = msg.a;
				var val = msg.b;
				if (maybeChange.$ === 'Just') {
					var change = maybeChange.a;
					var _v2 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Factoring$Page$ClientSubmissionInvoice$debounceConfig, _Utils_Tuple0, model.debounce);
					var newDebouncerState = _v2.a;
					var debounceCmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								changes: A2($elm$core$List$cons, change, model.changes),
								debounce: newDebouncerState,
								dirtyInvoiceAmount: val
							}),
						$author$project$HubTran$Effect$cmd(debounceCmd));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dirtyInvoiceAmount: val}),
						$author$project$HubTran$Effect$none);
				}
			case 'UpdateDirtyInvoiceDate':
				var maybeChange = msg.a;
				var val = msg.b;
				if (maybeChange.$ === 'Just') {
					var change = maybeChange.a;
					var _v4 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Factoring$Page$ClientSubmissionInvoice$debounceConfig, _Utils_Tuple0, model.debounce);
					var newDebouncerState = _v4.a;
					var debounceCmd = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								changes: A2($elm$core$List$cons, change, model.changes),
								debounce: newDebouncerState,
								dirtyInvoiceDate: val
							}),
						$author$project$HubTran$Effect$cmd(debounceCmd));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dirtyInvoiceDate: val}),
						$author$project$HubTran$Effect$none);
				}
			case 'CarrierIdentified':
				if (msg.a.$ === 'Ok') {
					if (msg.a.a.$ === 'Just') {
						var tmsCarrierId = msg.a.a.a;
						return _Utils_Tuple2(
							model,
							$author$project$Factoring$Page$ClientSubmissionInvoice$attemptCarrierPresence(tmsCarrierId));
					} else {
						var _v5 = msg.a.a;
						return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					}
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'DebtorIdentified':
				if ((msg.a.$ === 'Ok') && (msg.a.a.$ === 'Ok')) {
					var debtorId = msg.a.a.a;
					var newTypeahead = A2($author$project$Components$DebtorWithAddressTypeahead$select, debtorId, model.debtorWithAddressTypeahead);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{debtorWithAddressTypeahead: newTypeahead}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'DebtorWithAddressTypeaheadMsg':
				var typeaheadMsg = msg.a;
				var newTypeahead = A3(
					$author$project$Components$DebtorWithAddressTypeahead$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.debtorWithAddressTypeahead;
						},
						data),
					typeaheadMsg,
					model.debtorWithAddressTypeahead);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtorWithAddressTypeahead: newTypeahead}),
					$author$project$Typeahead$isFocused(newTypeahead) ? $author$project$HubTran$Effect$none : $author$project$Factoring$Page$ClientSubmissionInvoice$queueDebtorChange(
						$author$project$Components$DebtorWithAddressTypeahead$selectedId(newTypeahead)));
			case 'SubmissionDropdownMsg':
				var dropdownMsg = msg.a;
				var isClickInCaret = function (ddMsg) {
					if (ddMsg.$ === 'ClickIn') {
						var value = ddMsg.a;
						return value.isCaret;
					} else {
						return false;
					}
				};
				var _v6 = A3(
					$author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$update,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.submissionDropdown;
						},
						data),
					dropdownMsg,
					model.submissionDropdown);
				var newDropdown = _v6.a;
				var dropdownCmds = _v6.b;
				var showModal = A2(
					$elm$core$List$all,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							!_Utils_eq(dropdownMsg, $author$project$Ui$V3$CustomSelect$Close),
							!isClickInCaret(dropdownMsg),
							$author$project$Forward$Remote$isResolved(data),
							!$author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$isOpen(newDropdown),
							!_Utils_eq(
							$author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$selectedSubmissionId(newDropdown),
							$elm$core$Maybe$Nothing)
						]));
				var maybeShowModalEffect = showModal ? $author$project$HubTran$Effect$cmd(
					$author$project$Factoring$Page$ClientSubmissionInvoice$sendCmd($author$project$Factoring$Page$ClientSubmissionInvoice$ShowMoveDocumentsModal)) : $author$project$HubTran$Effect$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{submissionDropdown: newDropdown}),
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								A2(
								$author$project$HubTran$Effect$map,
								$author$project$Factoring$Page$ClientSubmissionInvoice$SubmissionDropdownMsg,
								$author$project$HubTran$Effect$cmd(dropdownCmds)),
								maybeShowModalEffect
							])));
			case 'PerformMoveDocuments':
				var maybeQueueSubmissionChange = function () {
					var _v8 = _Utils_Tuple3(
						data,
						$author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$isOpen(model.submissionDropdown),
						$author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$selectedSubmissionId(model.submissionDropdown));
					if (((_v8.a.$ === 'Loaded') && (!_v8.b)) && (_v8.c.$ === 'Just')) {
						var loadedData = _v8.a.a;
						var submissionId = _v8.c.a;
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$HubTran$Effect$none,
							A2(
								$elm$core$Maybe$map,
								$author$project$Factoring$Page$ClientSubmissionInvoice$queueSubmissionChange(submissionId),
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.documentGroupId;
									},
									$elm$core$List$head(loadedData.invoiceDocuments))));
					} else {
						return $author$project$HubTran$Effect$none;
					}
				}();
				return _Utils_Tuple2(model, maybeQueueSubmissionChange);
			case 'ShowMoveDocumentsModal':
				return model.moveDocumentsModal.isPerforming ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
					A2(
						$author$project$Factoring$Page$ClientSubmissionInvoice$updateMoveDocumentsModal,
						function (m) {
							return _Utils_update(
								m,
								{isShown: true});
						},
						A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$updateMoveDocumentsModal,
							$elm$core$Basics$always($author$project$Factoring$Page$ClientSubmissionInvoice$initMoveDocumentsModal),
							model)),
					$author$project$HubTran$Effect$none);
			case 'DismissMoveDocumentsModal':
				var resetDropdown = function () {
					var _v9 = model.originalSubmissionDropdown;
					if (_v9.$ === 'Just') {
						var originalSubmissionDropdown = _v9.a;
						return A2($author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$select, originalSubmissionDropdown, model.submissionDropdown);
					} else {
						return model.submissionDropdown;
					}
				}();
				return _Utils_Tuple2(
					A2(
						$author$project$Factoring$Page$ClientSubmissionInvoice$updateMoveDocumentsModal,
						function (m) {
							return _Utils_update(
								m,
								{isShown: false});
						},
						_Utils_update(
							model,
							{submissionDropdown: resetDropdown})),
					$author$project$HubTran$Effect$none);
			case 'OriginalSelectionLoaded':
				if ((msg.a.$ === 'Ok') && (msg.a.a.$ === 'Ok')) {
					var originalSelection = msg.a.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selection: originalSelection}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'OriginalSubmissionLoaded':
				if ((msg.a.$ === 'Ok') && (msg.a.a.$ === 'Just')) {
					var originalSubmission = msg.a.a.a;
					var newDropdown = A2($author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$select, originalSubmission, model.submissionDropdown);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								originalSubmissionDropdown: $elm$core$Maybe$Just(originalSubmission),
								submissionDropdown: newDropdown
							}),
						$author$project$HubTran$Effect$none);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'SelectDebtor':
				var debtor = msg.a;
				var debtorId = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.id;
					},
					debtor);
				var newTypeahead = A2($author$project$Components$DebtorWithAddressTypeahead$select, debtorId, model.debtorWithAddressTypeahead);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtorWithAddressTypeahead: newTypeahead}),
					$author$project$Factoring$Page$ClientSubmissionInvoice$queueDebtorChange(debtorId));
			case 'DocumentBrowserMsg':
				var msg_ = msg.a;
				return A3($author$project$Factoring$Page$ClientSubmissionInvoice$updateDocumentBrowser, data, msg_, model);
			case 'DocumentBrowserSecondaryMsg':
				var msg_ = msg.a;
				return A3($author$project$Factoring$Page$ClientSubmissionInvoice$updateSecondaryDocumentBrowser, data, msg_, model);
			case 'IdentifyDocumentsMsg':
				var selection = msg.a;
				var msg_ = msg.b;
				var _v10 = A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$update, msg_, model.identifyDocuments);
				var identifyDocuments = _v10.a;
				var identifyDocumentsCmds = _v10.b;
				if (msg_.$ === 'UpdateGroupingFinished') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{identifyDocuments: identifyDocuments, selection: selection}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$cmd(
									$author$project$Js$scrollToId(
										$author$project$Indexer$DocumentBrowser$thumbnailSelectedId($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix))),
									A2(
									$author$project$HubTran$Effect$map,
									$author$project$Factoring$Page$ClientSubmissionInvoice$IdentifyDocumentsMsg(selection),
									identifyDocumentsCmds),
									$author$project$HubTran$Effect$cmd(
									$author$project$HubTran$Navigation$load(
										$author$project$Path$toString(
											A2(
												$author$project$Path$addQueries,
												_List_fromArray(
													[
														_Utils_Tuple2(
														'onDone',
														$author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault(model.onDoneQuery))
													]),
												$author$project$Path$submission(model.emailMessageId))))),
									$author$project$HubTran$Effect$invalidate(
									A2($author$project$Forward$Lookup$startFrom, model.emailMessageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{identifyDocuments: identifyDocuments, selection: selection}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$cmd(
									$author$project$Js$scrollToId(
										$author$project$Indexer$DocumentBrowser$thumbnailSelectedId($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix))),
									A2(
									$author$project$HubTran$Effect$map,
									$author$project$Factoring$Page$ClientSubmissionInvoice$IdentifyDocumentsMsg(selection),
									identifyDocumentsCmds)
								])));
				}
			case 'HeaderMsg':
				var headerMsg = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$map,
						$author$project$Factoring$Page$ClientSubmissionInvoice$HeaderMsg,
						$author$project$Factoring$Page$ClientSubmission$Header$update(headerMsg)));
			case 'DebounceMsg':
				var debounceMsg = msg.a;
				var _v12 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Factoring$Page$ClientSubmissionInvoice$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast(
						function (_v13) {
							return $author$project$Factoring$Page$ClientSubmissionInvoice$sendCmd($author$project$Factoring$Page$ClientSubmissionInvoice$SaveChanges);
						}),
					debounceMsg,
					model.debounce);
				var newDebouncerState = _v12.a;
				var debouceCmd = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debounce: newDebouncerState}),
					$author$project$HubTran$Effect$cmd(debouceCmd));
			case 'SaveChanges':
				return _Utils_Tuple2(
					model,
					function () {
						var _v14 = $author$project$Forward$Remote$toMaybe(
							A2(
								$author$project$Forward$Remote$map,
								function ($) {
									return $.submission;
								},
								data));
						if (_v14.$ === 'Just') {
							if (_v14.a.$ === 'Ok') {
								var submission = _v14.a.a;
								return submission.invoice.readonly ? $author$project$HubTran$Effect$none : $author$project$HubTran$Effect$cmd(
									$author$project$Factoring$Page$ClientSubmissionInvoice$sendCmd(
										A3(
											$elm$core$List$foldl,
											$author$project$Factoring$Page$ClientSubmissionInvoice$ForwardSendThen,
											$author$project$Factoring$Page$ClientSubmissionInvoice$FinishSaving(
												$elm$core$Result$Ok(model.changes)),
											A2($author$project$Factoring$Page$ClientSubmission$Change$toHttpRequests, submission.invoice, model.changes))));
							} else {
								return $author$project$HubTran$Effect$none;
							}
						} else {
							return $author$project$HubTran$Effect$none;
						}
					}());
			case 'Select':
				var selection = msg.a;
				return A2($author$project$Factoring$Page$ClientSubmissionInvoice$selectSelection, selection, model);
			case 'SelectSecondary':
				var selection = msg.a;
				var secondaryDocumentBrowser = function () {
					var _v15 = model.secondaryDocumentBrowser;
					if (_v15.$ === 'Just') {
						var browser = _v15.a;
						return _Utils_update(
							browser,
							{selection: selection});
					} else {
						return A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$Browser,
							selection,
							A2($author$project$Indexer$DocumentBrowser$init, model.emailMessageId, $author$project$Factoring$Page$ClientSubmissionInvoice$secondaryBrowserPrefix));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							secondaryDocumentBrowser: $elm$core$Maybe$Just(secondaryDocumentBrowser)
						}),
					$author$project$HubTran$Effect$none);
			case 'CloseSecondary':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{secondaryDocumentBrowser: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'SetHover':
				var hoveredLineText = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hoveredLineText: hoveredLineText}),
					$author$project$HubTran$Effect$none);
			case 'AdjustHighlight':
				var subMsg = msg.a;
				var _v16 = $author$project$Forward$Remote$toMaybe(
					A2(
						$author$project$Forward$Remote$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pageData;
							},
							function ($) {
								return $.documentPagesData;
							}),
						data));
				if (_v16.$ === 'Just') {
					var pagesData = _v16.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{selection: x});
						},
						A3($author$project$Factoring$Page$ClientSubmissionInvoice$highlight, subMsg, model.selection, pagesData));
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'QueueChange':
				var change = msg.a;
				var _v17 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Factoring$Page$ClientSubmissionInvoice$debounceConfig, _Utils_Tuple0, model.debounce);
				var newDebouncerState = _v17.a;
				var debounceCmd = _v17.b;
				var updatedModel = _Utils_update(
					model,
					{
						changes: A2($elm$core$List$cons, change, model.changes),
						debounce: newDebouncerState
					});
				var _v18 = A3($author$project$Factoring$Page$ClientSubmissionInvoice$updateDocumentBrowser, data, $author$project$Indexer$DocumentBrowser$UpdateGroup, updatedModel);
				var modelToReturn = _v18.a;
				var updateDocumentBrowserEffect = _v18.b;
				if (change.$ === 'MoveDocument') {
					return _Utils_Tuple2(
						modelToReturn,
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$cmd(debounceCmd),
									updateDocumentBrowserEffect
								])));
				} else {
					return _Utils_Tuple2(
						updatedModel,
						$author$project$HubTran$Effect$cmd(debounceCmd));
				}
			case 'GetNewVerification':
				var id = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$refresh(
						A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationByFactorInvoiceId)));
			case 'AddNewFactorInvoice':
				var id = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$HubTran$Effect$refresh(
								A2($author$project$Forward$Lookup$startFrom, id, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
								$author$project$HubTran$Effect$refresh(
								A2($author$project$Forward$Lookup$startFrom, model.emailMessageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoicesByEmailMessageId))
							])));
			case 'GroupLoaded':
				var index = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$batch(
						_List_fromArray(
							[
								$author$project$HubTran$Effect$cmd(
								$author$project$Js$scrollToId($author$project$Factoring$Page$ClientSubmissionInvoice$topOfWorkArea)),
								$author$project$HubTran$Effect$cmd(
								$author$project$Js$scrollToId(
									A2($author$project$Indexer$DocumentBrowser$groupId, $author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix, index))),
								$author$project$HubTran$Effect$cmd(
								$author$project$Js$scrollToId(
									$author$project$Indexer$DocumentBrowser$mainImageId($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix))),
								$author$project$HubTran$Effect$cmd(
								$author$project$Js$setupDropHandlers($author$project$Indexer$DocumentBrowser$documentLineContext)),
								$author$project$HubTran$Effect$cmd(
								$author$project$Js$setupNewFactorInvoiceCreated(''))
							])));
			case 'DocumentKeyDown':
				var ke = msg.a;
				var _v20 = $author$project$Forward$Remote$toMaybe(
					A2(
						$author$project$Forward$Remote$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pageData;
							},
							function ($) {
								return $.documentPagesData;
							}),
						data));
				if (_v20.$ === 'Just') {
					var documentPagesData = _v20.a;
					return A3($author$project$Factoring$Page$ClientSubmissionInvoice$keyboardEventUpdate, model, documentPagesData.groupedDocuments, ke);
				} else {
					return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				}
			case 'SetShift':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{holdingShift: value}),
					$author$project$HubTran$Effect$none);
			case 'PresenceMsg':
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							presence: A2($author$project$Presence$update, subMsg, model.presence)
						}),
					$author$project$HubTran$Effect$none);
			case 'FinishSaving':
				if (msg.a.$ === 'Err') {
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[$author$project$Factoring$Page$ClientSubmissionInvoice$restartDebounce, $author$project$Factoring$Page$ClientSubmissionInvoice$showSaveError])));
				} else {
					var changes = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							changes: A2($author$project$Factoring$Page$ClientSubmission$Change$dropSaved, changes, model.changes),
							customExceptionText: $author$project$Factoring$Page$ClientSubmissionInvoice$Other(''),
							exceptionResolutionText: ''
						});
					var _v21 = $author$project$Factoring$Page$ClientSubmission$Change$getChangeBatchType(changes);
					switch (_v21.$) {
						case 'IsReviewChange':
							var nextGroup = 1 + model.selection.group;
							return _Utils_Tuple2(
								updatedModel,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$invalidate(
											A2($author$project$Forward$Lookup$startFrom, model.emailMessageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$firstUnreviewedSubmissionWorkflowFactorInvoice)),
											A4($author$project$Factoring$Page$ClientSubmissionInvoice$goToGroup, model.emailMessageId, nextGroup, model.dismissFundingNotes, model.onDoneQuery)
										])));
						case 'IsMoveGroupChange':
							var isMovePrevious = $author$project$Factoring$Page$ClientSubmissionInvoice$hasMovePreviousChange(changes);
							var _v22 = A3($author$project$Factoring$Page$ClientSubmissionInvoice$updateDocumentBrowser, data, $author$project$Indexer$DocumentBrowser$FinishGroupUpdate, updatedModel);
							var modelToReturn = _v22.a;
							var updateDocumentBrowserEffect = _v22.b;
							if (isMovePrevious) {
								var previousGroup = model.selection.group - 1;
								return _Utils_Tuple2(
									modelToReturn,
									$author$project$HubTran$Effect$batch(
										_List_fromArray(
											[
												updateDocumentBrowserEffect,
												A4($author$project$Factoring$Page$ClientSubmissionInvoice$goToGroup, model.emailMessageId, previousGroup, model.dismissFundingNotes, model.onDoneQuery),
												$author$project$HubTran$Effect$flash(
												$author$project$HubTran$Flash$alert(
													'Now reviewing group ' + $elm$core$String$fromInt(previousGroup + 1)))
											])));
							} else {
								return _Utils_Tuple2(modelToReturn, updateDocumentBrowserEffect);
							}
						case 'IsAssignSubmissionChange':
							var maybeFlash = function () {
								var _v24 = $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$selectedSubmissionDisplayText(model.submissionDropdown);
								if (_v24.$ === 'Just') {
									var label = _v24.a;
									return _List_fromArray(
										[
											$author$project$HubTran$Effect$invalidate(
											A2($author$project$Forward$Lookup$startFrom, model.emailMessageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$firstUnreviewedSubmissionWorkflowFactorInvoice)),
											$author$project$HubTran$Effect$invalidate(
											A2($author$project$Forward$Lookup$startFrom, model.emailMessageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoiceIdsByEmailMessageId)),
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$alert('Now reviewing load ' + label)),
											A4($author$project$Factoring$Page$ClientSubmissionInvoice$goToGroup, model.emailMessageId, model.selection.group, model.dismissFundingNotes, model.onDoneQuery)
										]);
								} else {
									return _List_Nil;
								}
							}();
							var _v23 = A3($author$project$Factoring$Page$ClientSubmissionInvoice$updateDocumentBrowser, data, $author$project$Indexer$DocumentBrowser$FinishGroupUpdate, updatedModel);
							var modelToReturn = _v23.a;
							var updateDocumentBrowserEffect = _v23.b;
							return _Utils_Tuple2(
								modelToReturn,
								$author$project$HubTran$Effect$batch(
									A2(
										$elm$core$List$append,
										maybeFlash,
										_List_fromArray(
											[updateDocumentBrowserEffect]))));
						default:
							return _Utils_Tuple2(updatedModel, $author$project$Factoring$Page$ClientSubmissionInvoice$restartDebounce);
					}
				}
			case 'ForwardSendThen':
				var request = msg.a;
				var next = msg.b;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$sendCacheableRequest,
						function (result) {
							if (result.$ === 'Ok') {
								return next;
							} else {
								var reason = result.a;
								return $author$project$Factoring$Page$ClientSubmissionInvoice$FinishSaving(
									$elm$core$Result$Err(reason));
							}
						},
						request));
			case 'AttemptToReGroup':
				var documentBatchId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{regroupInProgress: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateMismatchFinished,
						$author$project$Api$DocumentBatches$autoGroup(documentBatchId)));
			case 'UpdateMismatchFinished':
				var res = msg.a;
				switch (res.$) {
					case 'Ok':
						var showGroupingSuccess = $author$project$HubTran$Effect$flash(
							$author$project$HubTran$Flash$success('Successfully attempted to resolve grouping mismatch'));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{regroupInProgress: false}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$cmd(
										$author$project$Js$scrollToId(
											$author$project$Indexer$DocumentBrowser$thumbnailSelectedId($author$project$Factoring$Page$ClientSubmissionInvoice$primaryBrowserPrefix))),
										showGroupingSuccess,
										$author$project$HubTran$Effect$invalidate(
										A2($author$project$Forward$Lookup$startFrom, model.emailMessageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage)),
										$author$project$HubTran$Effect$cmd(
										$author$project$HubTran$Navigation$load(
											$author$project$Path$toString(
												A2(
													$author$project$Path$addQueries,
													_List_fromArray(
														[
															_Utils_Tuple2(
															'onDone',
															$author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault(model.onDoneQuery))
														]),
													$author$project$Path$submission(model.emailMessageId)))))
									])));
					case 'Err':
						var message = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{regroupInProgress: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{regroupInProgress: false}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Error resolving grouping mismatch')));
				}
			case 'ResolveGroupMismatch':
				var documentBatchId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{regroupInProgress: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateMismatchFinished,
						$author$project$Api$DocumentBatches$resolveMismatch(documentBatchId)));
			case 'ShowFundingNotes':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							userRequestsViewFundingNotes: $elm$core$Maybe$Just(true)
						}),
					$author$project$HubTran$Effect$none);
			case 'HideFundingNotes':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dismissFundingNotes: true,
							userRequestsViewFundingNotes: $elm$core$Maybe$Just(false)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetTimezone':
				var tz = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: tz}),
					$author$project$HubTran$Effect$none);
			case 'ShowCustomExceptionForm':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{viewCustomExceptionForm: true}),
					$author$project$HubTran$Effect$none);
			case 'HideCustomExceptionForm':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							customExceptionText: $author$project$Factoring$Page$ClientSubmissionInvoice$Other(''),
							viewCustomExceptionForm: false
						}),
					$author$project$HubTran$Effect$none);
			case 'SetCustomExceptionText':
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{customExceptionText: input}),
					$author$project$HubTran$Effect$none);
			case 'ShowExceptionResolutionForm':
				var maybeId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{exceptionResolutionText: '', resolvingException: maybeId}),
					$author$project$HubTran$Effect$none);
			case 'HideExceptionResolutionForm':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{exceptionResolutionText: '', resolvingException: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			default:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{exceptionResolutionText: input}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Factoring$Page$ClientSubmissionReview$Edited = function (a) {
	return {$: 'Edited', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$HeaderMsg = function (a) {
	return {$: 'HeaderMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$IdentifyDocumentsMsg = F2(
	function (a, b) {
		return {$: 'IdentifyDocumentsMsg', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionReview$NavigateWithLoad = function (a) {
	return {$: 'NavigateWithLoad', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$SendFailed = {$: 'SendFailed'};
var $author$project$Api$EmailMessages$encodeInvoiceId = function (id) {
	return $elm$json$Json$Encode$int(
		$author$project$Domain$FactorInvoiceId$toInt(id));
};
var $author$project$Api$EmailMessages$complete = function (params) {
	return A2(
		$author$project$Helpers$Api$postWithNoResponseBody,
		$author$project$Api$EmailMessages$baseUrl(params.emailMessageId) + '/complete_approved_rejected',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'recipients',
					$elm$json$Json$Encode$string(params.recipients)),
					_Utils_Tuple2(
					'rejection_message',
					$elm$json$Json$Encode$string(params.rejectionMessage)),
					_Utils_Tuple2(
					'approved_invoice_ids',
					A2($elm$json$Json$Encode$list, $author$project$Api$EmailMessages$encodeInvoiceId, params.approvedInvoiceIDs)),
					_Utils_Tuple2(
					'rejected_invoice_ids',
					A2($elm$json$Json$Encode$list, $author$project$Api$EmailMessages$encodeInvoiceId, params.rejectedInvoiceIDs))
				])));
};
var $author$project$Factoring$Page$ClientSubmissionReview$completeEmail = function (onDone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Api$EmailMessages$complete,
		$author$project$HubTran$Effect$sendCacheableRequest(
			function (result) {
				if (result.$ === 'Err') {
					return $author$project$Factoring$Page$ClientSubmissionReview$SendFailed;
				} else {
					return $author$project$Factoring$Page$ClientSubmissionReview$NavigateWithLoad(onDone);
				}
			}));
};
var $author$project$Factoring$Page$ClientSubmissionReview$formatExceptions = function (exception) {
	return $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$passing(exception) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('\u0009- ' + exception.formattedMessage);
};
var $author$project$Factoring$Page$ClientSubmissionReview$formatRejectedInvoice = function (_v0) {
	var invoice = _v0.invoice;
	var identifier = function () {
		var _v1 = _Utils_Tuple2(invoice.number, invoice.loadId);
		if (_v1.a === '') {
			if (_v1.b === '') {
				return 'No load id or invoice number provided';
			} else {
				return 'Load ID ' + invoice.loadId;
			}
		} else {
			if (_v1.b === '') {
				return 'Invoice ' + invoice.number;
			} else {
				return 'Invoice ' + (invoice.number + (', Load ID ' + invoice.loadId));
			}
		}
	}();
	return identifier + ('\u000A' + A2(
		$elm$core$String$join,
		'\u000A',
		A2($elm$core$List$filterMap, $author$project$Factoring$Page$ClientSubmissionReview$formatExceptions, invoice.exceptions)));
};
var $author$project$Factoring$Page$ClientSubmissionReview$draftToString = F2(
	function (draft, rejected) {
		if (draft.$ === 'Edited') {
			var raw = draft.a;
			return raw;
		} else {
			return A2(
				$elm$core$String$join,
				'\u000A\u000A',
				A2($elm$core$List$map, $author$project$Factoring$Page$ClientSubmissionReview$formatRejectedInvoice, rejected));
		}
	});
var $author$project$Factoring$Page$ClientSubmissionReview$completeParams = F2(
	function (data, model) {
		var sections = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Factoring$Page$ClientSubmissionReview$Sections, _List_Nil, _List_Nil),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.sections;
					},
					$elm$core$Result$toMaybe),
				$author$project$Forward$Remote$toMaybe(data)));
		return {
			approvedInvoiceIDs: A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.invoice;
					},
					function ($) {
						return $.id;
					}),
				sections.approved),
			emailMessageId: model.emailMessageId,
			recipients: model.extraRecipients,
			rejectedInvoiceIDs: A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.invoice;
					},
					function ($) {
						return $.id;
					}),
				sections.rejected),
			rejectionMessage: A2($author$project$Factoring$Page$ClientSubmissionReview$draftToString, model.messageDraft, sections.rejected)
		};
	});
var $author$project$Factoring$Page$ClientSubmissionReview$defaultAndPrependOnDone = function (onDoneQuery) {
	var defaultedOnDone = A2($elm$core$Maybe$withDefault, '/app', onDoneQuery);
	var prependedOnDone = (!A2($elm$core$String$startsWith, '/app', defaultedOnDone)) ? ('/app' + defaultedOnDone) : defaultedOnDone;
	return prependedOnDone;
};
var $author$project$Indexer$EmailMessageData$fromLoadedCore = F2(
	function (data, accessor) {
		return A2(
			$elm$core$Maybe$map,
			accessor,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.coreData;
					},
					$author$project$Forward$Remote$toMaybe),
				data));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$FinishResend = {$: 'FinishResend'};
var $author$project$Factoring$Page$ClientSubmissionReview$resendInvoices = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Transmissions$resend,
	$author$project$HubTran$Effect$sendCacheableRequest(
		function (result) {
			if (result.$ === 'Err') {
				return $author$project$Factoring$Page$ClientSubmissionReview$SendFailed;
			} else {
				return $author$project$Factoring$Page$ClientSubmissionReview$FinishResend;
			}
		}));
var $author$project$Factoring$Page$ClientSubmissionReview$DocumentBrowserMsg = function (a) {
	return {$: 'DocumentBrowserMsg', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$updateDocumentBrowser = F4(
	function (msg, model, settings, emailMessage) {
		var _v0 = A4($author$project$Indexer$DocumentBrowser$update, settings, emailMessage, msg, model.documentBrowser);
		var documentBrowser = _v0.a;
		var documentBrowserCmds = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{documentBrowser: documentBrowser}),
			A2($author$project$HubTran$Effect$map, $author$project$Factoring$Page$ClientSubmissionReview$DocumentBrowserMsg, documentBrowserCmds));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'DocumentBrowserMsg':
				var msg_ = msg.a;
				var maybePageData = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.pageData;
					},
					$author$project$Forward$Remote$toMaybe(data));
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$HubTran$Effect$none),
					A3(
						$elm$core$Maybe$map2,
						A2($author$project$Factoring$Page$ClientSubmissionReview$updateDocumentBrowser, msg_, model),
						A2(
							$author$project$Indexer$EmailMessageData$fromLoadedCore,
							maybePageData,
							function ($) {
								return $.settings;
							}),
						A2(
							$author$project$Indexer$EmailMessageData$fromLoadedCore,
							maybePageData,
							function ($) {
								return $.emailMessage;
							})));
			case 'HeaderMsg':
				var hMsg = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$HubTran$Effect$map,
						$author$project$Factoring$Page$ClientSubmissionReview$HeaderMsg,
						$author$project$Factoring$Page$ClientSubmission$Header$update(hMsg)));
			case 'Select':
				var selection = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selection: $elm$core$Maybe$Just(selection)
						}),
					$author$project$HubTran$Effect$cmd(
						$author$project$Js$scrollToId(
							$author$project$Indexer$DocumentBrowser$mainImageId($author$project$Factoring$Page$ClientSubmissionReview$primaryBrowserPrefix))));
			case 'EditRecipients':
				var recipients = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{extraRecipients: recipients}),
					$author$project$HubTran$Effect$none);
			case 'EditMessage':
				var message = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							messageDraft: $author$project$Factoring$Page$ClientSubmissionReview$Edited(message)
						}),
					$author$project$HubTran$Effect$none);
			case 'Send':
				return model.sending ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{sending: true}),
					A2(
						$author$project$Factoring$Page$ClientSubmissionReview$completeEmail,
						$author$project$Factoring$Page$ClientSubmissionReview$defaultAndPrependOnDone(model.onDoneQuery),
						A2($author$project$Factoring$Page$ClientSubmissionReview$completeParams, data, model)));
			case 'SendFailed':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sending: false}),
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert('Issue submitting these invoices')));
			case 'ResendInvoices':
				var id = msg.a;
				return model.sending ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{sending: true}),
					$author$project$Factoring$Page$ClientSubmissionReview$resendInvoices(id));
			case 'FinishResend':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{resent: true, sending: false}),
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$success('Invoices Resent!')));
			case 'NavigateWithLoad':
				var url = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						$author$project$HubTran$Navigation$load(url)));
			case 'PresenceMsg':
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							presence: A2($author$project$Presence$update, subMsg, model.presence)
						}),
					$author$project$HubTran$Effect$none);
			case 'IdentifyDocumentsMsg':
				var selection = msg.a;
				var msg_ = msg.b;
				var _v1 = A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$update, msg_, model.identifyDocuments);
				var identifyDocuments = _v1.a;
				var identifyDocumentsCmds = _v1.b;
				if (msg_.$ === 'UpdateGroupingFinished') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								identifyDocuments: identifyDocuments,
								selection: $elm$core$Maybe$Just(selection)
							}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$cmd(
									$author$project$Js$scrollToId(
										$author$project$Indexer$DocumentBrowser$thumbnailSelectedId($author$project$Factoring$Page$ClientSubmissionReview$primaryBrowserPrefix))),
									A2(
									$author$project$HubTran$Effect$map,
									$author$project$Factoring$Page$ClientSubmissionReview$IdentifyDocumentsMsg(selection),
									identifyDocumentsCmds),
									$author$project$HubTran$Effect$cmd(
									$author$project$HubTran$Navigation$load(
										$author$project$Path$toString(
											A2(
												$author$project$Path$addQueries,
												_List_fromArray(
													[
														_Utils_Tuple2(
														'onDone',
														$author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault(model.onDoneQuery))
													]),
												$author$project$Path$submission(model.emailMessageId))))),
									$author$project$HubTran$Effect$invalidate(
									A2($author$project$Forward$Lookup$startFrom, model.emailMessageId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$emailMessage))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								identifyDocuments: identifyDocuments,
								selection: $elm$core$Maybe$Just(selection)
							}),
						$author$project$HubTran$Effect$batch(
							_List_fromArray(
								[
									$author$project$HubTran$Effect$cmd(
									$author$project$Js$scrollToId(
										$author$project$Indexer$DocumentBrowser$thumbnailSelectedId($author$project$Factoring$Page$ClientSubmissionReview$primaryBrowserPrefix))),
									A2(
									$author$project$HubTran$Effect$map,
									$author$project$Factoring$Page$ClientSubmissionReview$IdentifyDocumentsMsg(selection),
									identifyDocumentsCmds)
								])));
				}
			default:
				var tz = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: tz}),
					$author$project$HubTran$Effect$none);
		}
	});
var $author$project$Factoring$Page$VerificationBatch$AddedRecipientCommitted = F3(
	function (a, b, c) {
		return {$: 'AddedRecipientCommitted', a: a, b: b, c: c};
	});
var $author$project$Factoring$Page$VerificationBatch$BatchStateChangedNowMaybeSkip = F3(
	function (a, b, c) {
		return {$: 'BatchStateChangedNowMaybeSkip', a: a, b: b, c: c};
	});
var $author$project$Factoring$Page$VerificationBatch$ContactInfoSaved = F2(
	function (a, b) {
		return {$: 'ContactInfoSaved', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmationDeliveredAt = function (a) {
	return {$: 'DebtorConfirmationDeliveredAt', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmationSent = function (a) {
	return {$: 'DebtorConfirmationSent', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmationsReset = function (a) {
	return {$: 'DebtorConfirmationsReset', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$ItemSaved = F2(
	function (a, b) {
		return {$: 'ItemSaved', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$ItemSavedNowFinish = F2(
	function (a, b) {
		return {$: 'ItemSavedNowFinish', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$RecipientEditUndone = F2(
	function (a, b) {
		return {$: 'RecipientEditUndone', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$RecipientExcluded = F2(
	function (a, b) {
		return {$: 'RecipientExcluded', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$SavedAndFinished = function (a) {
	return {$: 'SavedAndFinished', a: a};
};
var $author$project$Api$VerificationsDebtorBatches$memberUrl = function (id) {
	return '/api/verifications/debtor_batches/' + $elm$core$String$fromInt(
		$author$project$Domain$VerificationsDebtorBatchId$toInt(id));
};
var $author$project$Api$VerificationsDebtorBatches$recipientEditsUrl = function (id) {
	return $author$project$Api$VerificationsDebtorBatches$memberUrl(id) + '/confirmation_recipient_edits';
};
var $author$project$Api$VerificationsDebtorBatches$recipientEdit = F2(
	function (id, fields) {
		return A2(
			$author$project$Helpers$Api$postWithNoResponseBody,
			$author$project$Api$VerificationsDebtorBatches$recipientEditsUrl(id),
			$elm$json$Json$Encode$object(fields));
	});
var $author$project$Api$VerificationsDebtorBatches$addConfirmationRecipient = F2(
	function (id, recipient) {
		return A2(
			$author$project$Api$VerificationsDebtorBatches$recipientEdit,
			id,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('added')),
					_Utils_Tuple2(
					'address',
					$elm$json$Json$Encode$string(recipient.address)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(recipient.name))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$normalizeAddress = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toLower);
var $author$project$Factoring$Page$VerificationBatch$addedRecipientAddress = F2(
	function (key, rows) {
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.address;
				},
				$author$project$Factoring$Page$VerificationBatch$normalizeAddress),
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (row) {
					return _Utils_eq(row.key, key);
				},
				rows));
	});
var $author$project$Factoring$Page$VerificationBatch$addedRecipientName = F2(
	function (key, rows) {
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.name;
				},
				$elm$core$String$trim),
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (row) {
					return _Utils_eq(row.key, key);
				},
				rows));
	});
var $author$project$Factoring$Page$VerificationBatch$invalidateFactorInvoice = function (factorInvoiceId) {
	return $author$project$HubTran$Effect$batch(
		_List_fromArray(
			[
				$author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorInvoice)),
				$author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$activeVerificationsDebtorBatchIdByFactorInvoiceId)),
				$author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$autoVerificationByFactorInvoiceId)),
				$author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$canonicalVerificationIdByFactorInvoiceId)),
				$author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$clientSubmissionReviewDataByFactorInvoiceId)),
				$author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationByFactorInvoiceId)),
				$author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationPercentageByFactorInvoiceId)),
				$author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, factorInvoiceId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItemByFactorInvoiceId))
			]));
};
var $author$project$Factoring$Page$VerificationBatch$batchItemInvalidations = F2(
	function (batchItemId, itemFormState) {
		var _v0 = itemFormState.factorInvoiceId;
		if (_v0.$ === 'Nothing') {
			return $author$project$HubTran$Effect$invalidate(
				A2($author$project$Forward$Lookup$startFrom, batchItemId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItem));
		} else {
			var factorInvoiceId = _v0.a;
			return $author$project$HubTran$Effect$batch(
				_List_fromArray(
					[
						$author$project$Factoring$Page$VerificationBatch$invalidateFactorInvoice(factorInvoiceId),
						$author$project$HubTran$Effect$invalidate(
						A2($author$project$Forward$Lookup$startFrom, batchItemId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItem))
					]));
		}
	});
var $author$project$Factoring$Page$VerificationBatch$listFromData = F2(
	function (dataField, data) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				dataField,
				$author$project$Forward$Remote$toMaybe(data)));
	});
var $author$project$Factoring$Page$VerificationBatch$loadedListFromData = F2(
	function (dataField, data) {
		return A2(
			$elm$core$List$filterMap,
			$author$project$Forward$Remote$toMaybe,
			A2($author$project$Factoring$Page$VerificationBatch$listFromData, dataField, data));
	});
var $author$project$Factoring$Page$VerificationBatch$checkIfFinished = F2(
	function (currentBatchId, item) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(currentBatchId),
				item.previousVerificationsDebtorBatchId));
	});
var $author$project$Factoring$Page$VerificationBatch$itemDataToDefaultItemFormState = F2(
	function (debtorBatchId, _v0) {
		var invoice = _v0.invoice;
		var item = _v0.item;
		return {
			customState: item.effectiveCustomState,
			debtorContactId: item.cadenceDebtorContactId,
			factorInvoiceId: $elm$core$Maybe$Just(invoice.id),
			invoiceAmount: A2($elm$core$Maybe$withDefault, '', invoice.amount),
			isFinished: A2($author$project$Factoring$Page$VerificationBatch$checkIfFinished, debtorBatchId, item),
			manuallyUpdated: false,
			notes: item.note,
			updatesToSave: false,
			verificationMethodId: item.cadenceVerificationMethodId
		};
	});
var $author$project$Factoring$Page$VerificationBatch$toBatchSkipFormStateTuple = F2(
	function (batchId, itemData) {
		var plainState = A2($author$project$Factoring$Page$VerificationBatch$itemDataToDefaultItemFormState, batchId, itemData);
		return _Utils_Tuple2(
			itemData.item.id,
			_Utils_update(
				plainState,
				{customState: $author$project$Domain$VerificationsDebtorBatchItem$customStateSkipped}));
	});
var $author$project$Api$VerificationsDebtorBatches$encodeItemChanges = function (_v0) {
	var itemId = _v0.a;
	var invoiceAmount = _v0.b.invoiceAmount;
	var debtorContactId = _v0.b.debtorContactId;
	var verificationMethodId = _v0.b.verificationMethodId;
	var notes = _v0.b.notes;
	var customState = _v0.b.customState;
	var methodIdEncoder = A2($elm$core$Basics$composeR, $author$project$Domain$CadenceVerificationMethodId$toInt, $elm$json$Json$Encode$int);
	var maybeAppend = F3(
		function (field, encoder, toMaybeAppend) {
			if (toMaybeAppend.$ === 'Just') {
				var toAppend = toMaybeAppend.a;
				return $elm$core$List$append(
					_List_fromArray(
						[
							_Utils_Tuple2(
							field,
							encoder(toAppend))
						]));
			} else {
				return $elm$core$List$append(
					_List_fromArray(
						[
							_Utils_Tuple2(field, $elm$json$Json$Encode$null)
						]));
			}
		});
	var contactIdEncoder = A2($elm$core$Basics$composeR, $author$project$Domain$CadenceDebtorContactId$toInt, $elm$json$Json$Encode$int);
	return $elm$json$Json$Encode$object(
		A4(
			maybeAppend,
			'method_id',
			methodIdEncoder,
			verificationMethodId,
			A4(
				maybeAppend,
				'contact_id',
				contactIdEncoder,
				debtorContactId,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$VerificationsDebtorBatchItemId$toInt(itemId))),
						_Utils_Tuple2(
						'state',
						$elm$json$Json$Encode$string(customState.id)),
						_Utils_Tuple2(
						'note',
						$elm$json$Json$Encode$string(notes)),
						_Utils_Tuple2(
						'invoice_amount',
						$elm$json$Json$Encode$string(invoiceAmount))
					]))));
};
var $author$project$Api$VerificationsDebtorBatches$encodeItemParams = function (itemParams) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'items',
				A2($elm$json$Json$Encode$list, $author$project$Api$VerificationsDebtorBatches$encodeItemChanges, itemParams))
			]));
};
var $author$project$Api$VerificationsDebtorBatches$updateAndFinish = F2(
	function (id, itemParams) {
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			$author$project$Api$VerificationsDebtorBatches$memberUrl(id) + '/update_and_finish/',
			$author$project$Api$VerificationsDebtorBatches$encodeItemParams(itemParams));
	});
var $author$project$Factoring$Page$VerificationBatch$batchSkipAndFinish = F2(
	function (data, _v0) {
		var debtorBatchId = _v0.debtorBatchId;
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			$author$project$Factoring$Page$VerificationBatch$SavedAndFinished,
			A2(
				$author$project$Api$VerificationsDebtorBatches$updateAndFinish,
				debtorBatchId,
				A2(
					$elm$core$List$map,
					$author$project$Factoring$Page$VerificationBatch$toBatchSkipFormStateTuple(debtorBatchId),
					A2(
						$author$project$Factoring$Page$VerificationBatch$loadedListFromData,
						function ($) {
							return $.items;
						},
						data))));
	});
var $author$project$Js$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Domain$VerificationsDebtorBatchItem$customStateUnverified = {id: 'unverified', name: 'Unverified', selectable: true, state: $author$project$AuditPb$VerificationsDebtorBatchItemStateUnverified};
var $author$project$Factoring$Page$VerificationBatch$dashOrOnDone = function (maybeOnDone) {
	return A2($elm$core$Maybe$withDefault, '/app/dashboard/verify', maybeOnDone);
};
var $author$project$Api$VerificationsDebtorBatches$excludeConfirmationRecipient = F2(
	function (id, address) {
		return A2(
			$author$project$Api$VerificationsDebtorBatches$recipientEdit,
			id,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('excluded')),
					_Utils_Tuple2(
					'address',
					$elm$json$Json$Encode$string(address))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$ItemPartialFinishCompleted = F2(
	function (a, b) {
		return {$: 'ItemPartialFinishCompleted', a: a, b: b};
	});
var $author$project$Api$VerificationsDebtorBatches$moveItemsToFinishedBatch = F2(
	function (id, itemIds) {
		var encodeId = function (itemId) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(
							$author$project$Domain$VerificationsDebtorBatchItemId$toInt(itemId)))
					]));
		};
		var encodedItemIds = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'items',
					A2($elm$json$Json$Encode$list, encodeId, itemIds))
				]));
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			$author$project$Api$VerificationsDebtorBatches$memberUrl(id) + '/move_items_to_finished_batch',
			encodedItemIds);
	});
var $author$project$Factoring$Page$VerificationBatch$finishItem = F2(
	function (batchItemId, model) {
		return A2(
			$author$project$HubTran$Effect$sendCacheableRequestWithError,
			$author$project$Factoring$Page$VerificationBatch$ItemPartialFinishCompleted(batchItemId),
			A2(
				$author$project$Api$VerificationsDebtorBatches$moveItemsToFinishedBatch,
				model.debtorBatchId,
				$elm$core$List$singleton(batchItemId)));
	});
var $author$project$Factoring$Page$VerificationBatch$emptyItemFormState = {customState: $author$project$Domain$VerificationsDebtorBatchItem$customStateUnverified, debtorContactId: $elm$core$Maybe$Nothing, factorInvoiceId: $elm$core$Maybe$Nothing, invoiceAmount: '', isFinished: false, manuallyUpdated: false, notes: $author$project$Helpers$String$nbsp, updatesToSave: false, verificationMethodId: $elm$core$Maybe$Nothing};
var $author$project$Domain$VerificationsDebtorBatchItemId$toComparable = function (id) {
	return _Utils_Tuple2(
		'verificationsDebtorBatchItemId',
		$author$project$Domain$VerificationsDebtorBatchItemId$toInt(id));
};
var $author$project$Factoring$Page$VerificationBatch$getItemFormState = F2(
	function (id, dict) {
		return A2(
			$elm$core$Dict$get,
			$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(id),
			dict);
	});
var $author$project$Factoring$Page$VerificationBatch$getItemData = F4(
	function (data, _v0, id, formState) {
		var debtorBatchId = _v0.debtorBatchId;
		var items = A2(
			$author$project$Factoring$Page$VerificationBatch$listFromData,
			function ($) {
				return $.items;
			},
			data);
		var idsMatch = function (itemId) {
			return _Utils_eq(
				$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemId),
				$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(id));
		};
		var defaultItemData = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Factoring$Page$VerificationBatch$emptyItemFormState,
			$elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function (itemData) {
						return idsMatch(itemData.item.id) ? $elm$core$Maybe$Just(
							A2($author$project$Factoring$Page$VerificationBatch$itemDataToDefaultItemFormState, debtorBatchId, itemData)) : $elm$core$Maybe$Nothing;
					},
					A2($elm$core$List$filterMap, $author$project$Forward$Remote$toMaybe, items))));
		return A2(
			$elm$core$Maybe$withDefault,
			defaultItemData,
			A2($author$project$Factoring$Page$VerificationBatch$getItemFormState, id, formState));
	});
var $author$project$Factoring$Page$VerificationBatch$invalidateBatchItems = function (data) {
	return $author$project$HubTran$Effect$batch(
		A2(
			$elm$core$List$map,
			function (itemId) {
				return $author$project$HubTran$Effect$invalidate(
					A2($author$project$Forward$Lookup$startFrom, itemId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatchItem));
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.itemIds;
					},
					$author$project$Forward$Remote$toMaybe(data)))));
};
var $author$project$Factoring$Page$VerificationBatch$nextDebtorBatchState = function (state) {
	switch (state.$) {
		case 'VerificationsDebtorBatchStateAvailable':
			return $author$project$AuditPb$VerificationsDebtorBatchStateStarted;
		case 'VerificationsDebtorBatchStateStarted':
			return $author$project$AuditPb$VerificationsDebtorBatchStateWaiting;
		case 'VerificationsDebtorBatchStateWaiting':
			return $author$project$AuditPb$VerificationsDebtorBatchStateStarted;
		case 'VerificationsDebtorBatchStateReply':
			return $author$project$AuditPb$VerificationsDebtorBatchStateStarted;
		default:
			return $author$project$AuditPb$VerificationsDebtorBatchStateFinished;
	}
};
var $author$project$Api$VerificationsDebtorBatches$updateBatchState = F2(
	function (id, string) {
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			$author$project$Api$VerificationsDebtorBatches$memberUrl(id) + ('/' + string),
			$elm$json$Json$Encode$null);
	});
var $author$project$Api$VerificationsDebtorBatches$start = function (id) {
	return A2($author$project$Api$VerificationsDebtorBatches$updateBatchState, id, 'start');
};
var $author$project$Api$VerificationsDebtorBatches$waiting = function (id) {
	return A2($author$project$Api$VerificationsDebtorBatches$updateBatchState, id, 'waiting');
};
var $author$project$Api$VerificationsDebtorBatches$nextState = F2(
	function (id, state) {
		switch (state.$) {
			case 'VerificationsDebtorBatchStateAvailable':
				return $elm$core$Maybe$Just(
					$author$project$Api$VerificationsDebtorBatches$start(id));
			case 'VerificationsDebtorBatchStateStarted':
				return $elm$core$Maybe$Just(
					$author$project$Api$VerificationsDebtorBatches$waiting(id));
			case 'VerificationsDebtorBatchStateWaiting':
				return $elm$core$Maybe$Just(
					$author$project$Api$VerificationsDebtorBatches$start(id));
			case 'VerificationsDebtorBatchStateReply':
				return $elm$core$Maybe$Just(
					$author$project$Api$VerificationsDebtorBatches$start(id));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$HubTran$Flash$notice = function (msg) {
	return {indefinite: false, level: 'notice', message: msg, position: 'top', time: $elm$core$Maybe$Nothing, title: $elm$core$Maybe$Nothing};
};
var $author$project$HubTran$InspectableEffect$now = $author$project$HubTran$InspectableEffect$Now($elm$core$Basics$identity);
var $author$project$HubTran$Effect$now = $author$project$HubTran$Effect$InspectableEffect($author$project$HubTran$InspectableEffect$now);
var $author$project$Factoring$Page$VerificationBatch$refreshDebtorBatch = function (model) {
	return $author$project$HubTran$Effect$refresh(
		A2($author$project$Forward$Lookup$startFrom, model.debtorBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch));
};
var $author$project$Factoring$Page$VerificationBatch$recipientEditSaved = F3(
	function (_v0, result, model) {
		var whenUnexplained = _v0.whenUnexplained;
		var rollback = _v0.rollback;
		var address = _v0.address;
		var settled = function (m) {
			return _Utils_update(
				m,
				{
					recipientEditsInFlight: A2($elm$core$Set$remove, address, m.recipientEditsInFlight)
				});
		};
		switch (result.$) {
			case 'Ok':
				return _Utils_Tuple2(
					settled(model),
					$author$project$Factoring$Page$VerificationBatch$refreshDebtorBatch(model));
			case 'Err':
				var message = result.a;
				return _Utils_Tuple2(
					settled(
						rollback(model)),
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert(message)));
			default:
				return _Utils_Tuple2(
					settled(
						rollback(model)),
					$author$project$HubTran$Effect$flash(
						$author$project$HubTran$Flash$alert(whenUnexplained)));
		}
	});
var $author$project$Api$VerificationsDebtorBatches$resetDebtorConfirmations = function (id) {
	return $author$project$Helpers$Api$delete(
		$author$project$Api$VerificationsDebtorBatches$memberUrl(id) + '/debtor_confirmations');
};
var $author$project$Api$VerificationsDebtorBatches$sendDebtorConfirmation = function (id) {
	return A2(
		$author$project$Helpers$Api$putWithNoResponseBody,
		$author$project$Api$VerificationsDebtorBatches$memberUrl(id) + '/send_debtor_confirmation',
		$elm$json$Json$Encode$null);
};
var $author$project$Helpers$String$capitalize = function (string) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, string)),
		A2($elm$core$String$dropLeft, 1, string));
};
var $author$project$Domain$VerificationsDebtorBatch$stateToDisplayString = function (state) {
	switch (state.$) {
		case 'VerificationsDebtorBatchStateStarted':
			return 'In Progress';
		case 'VerificationsDebtorBatchStateReply':
			return 'Replied';
		default:
			return $author$project$Helpers$String$capitalize(
				$author$project$AuditPb$verificationsDebtorBatchStateToString(state));
	}
};
var $author$project$Api$VerificationsDebtorBatches$undoConfirmationRecipientEdit = F2(
	function (id, address) {
		return A2(
			$author$project$Helpers$Api$deleteWithParams,
			$author$project$Api$VerificationsDebtorBatches$recipientEditsUrl(id),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'address',
						$elm$json$Json$Encode$string(address))
					])));
	});
var $author$project$Factoring$Page$VerificationBatch$updateAddedRecipient = F2(
	function (key, change) {
		return $elm$core$List$map(
			function (row) {
				return _Utils_eq(row.key, key) ? change(row) : row;
			});
	});
var $author$project$Api$VerificationsDebtorBatches$updateItems = F2(
	function (id, itemParams) {
		return A2(
			$author$project$Helpers$Api$putWithNoResponseBody,
			$author$project$Api$VerificationsDebtorBatches$memberUrl(id) + '/',
			$author$project$Api$VerificationsDebtorBatches$encodeItemParams(itemParams));
	});
var $author$project$Factoring$Page$VerificationBatch$update = F3(
	function (data, msg, model) {
		switch (msg.$) {
			case 'ChangeBatchState':
				var currentState = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$HubTran$Effect$none),
					A2(
						$elm$core$Maybe$map,
						function (cmd) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{isSaving: true}),
								cmd);
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$HubTran$Effect$sendCacheableRequestWithError(
								A2($author$project$Factoring$Page$VerificationBatch$BatchStateChangedNowMaybeSkip, false, currentState)),
							A2($author$project$Api$VerificationsDebtorBatches$nextState, model.debtorBatchId, currentState))));
			case 'ChangeBatchStateThenSkipAndFinish':
				var currentState = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$HubTran$Effect$none),
					A2(
						$elm$core$Maybe$map,
						function (cmd) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{isSaving: true}),
								cmd);
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$HubTran$Effect$sendCacheableRequestWithError(
								A2($author$project$Factoring$Page$VerificationBatch$BatchStateChangedNowMaybeSkip, true, currentState)),
							A2($author$project$Api$VerificationsDebtorBatches$nextState, model.debtorBatchId, currentState))));
			case 'ChangeItemAmount':
				var itemId = msg.a;
				var invoiceAmount = msg.b;
				var oldEntry = A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, itemId, model.formState);
				var newEntry = _Utils_update(
					oldEntry,
					{invoiceAmount: invoiceAmount, updatesToSave: true});
				var key = $author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemId);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							formState: A3($elm$core$Dict$insert, key, newEntry, model.formState)
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangeItemState':
				var itemId = msg.a;
				var customStateId = msg.b;
				var oldEntry = A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, itemId, model.formState);
				var newState = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Domain$VerificationsDebtorBatchItem$customStateUnverified,
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (cs) {
							return _Utils_eq(cs.id, customStateId);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.accountSettings;
									},
									function ($) {
										return $.verificationsWorkflowDebtorBatchItemCustomStates;
									}),
								$author$project$Forward$Remote$toMaybe(data)))));
				var newEntry = _Utils_update(
					oldEntry,
					{customState: newState, updatesToSave: true});
				var key = $author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemId);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							formState: A3($elm$core$Dict$insert, key, newEntry, model.formState)
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangeItemNotes':
				var itemId = msg.a;
				var notes = msg.b;
				var oldEntry = A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, itemId, model.formState);
				var newEntry = _Utils_update(
					oldEntry,
					{manuallyUpdated: true, notes: notes, updatesToSave: true});
				var key = $author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemId);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							formState: A3($elm$core$Dict$insert, key, newEntry, model.formState)
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangeItemContact':
				var itemId = msg.a;
				var contactIdString = msg.b;
				var oldEntry = A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, itemId, model.formState);
				var key = $author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemId);
				var contactId = A2(
					$elm$core$Maybe$map,
					$author$project$Domain$CadenceDebtorContactId$fromInt,
					$elm$core$String$toInt(contactIdString));
				var newEntry = _Utils_update(
					oldEntry,
					{debtorContactId: contactId, manuallyUpdated: true, updatesToSave: true});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							formState: A3($elm$core$Dict$insert, key, newEntry, model.formState)
						}),
					$author$project$HubTran$Effect$none);
			case 'ChangeItemMethod':
				var itemId = msg.a;
				var methodIdString = msg.b;
				var oldEntry = A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, itemId, model.formState);
				var methodId = A2(
					$elm$core$Maybe$map,
					$author$project$Domain$CadenceVerificationMethodId$fromInt,
					$elm$core$String$toInt(methodIdString));
				var newEntry = _Utils_update(
					oldEntry,
					{manuallyUpdated: true, updatesToSave: true, verificationMethodId: methodId});
				var key = $author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemId);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							formState: A3($elm$core$Dict$insert, key, newEntry, model.formState)
						}),
					$author$project$HubTran$Effect$none);
			case 'SaveItemThenMaybeFinish':
				var batchItemId = msg.a;
				var toFinish = msg.b;
				var toSave = A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, batchItemId, model.formState);
				var isFinal = 1 === $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Forward$Remote$toMaybe,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map(
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.item;
										},
										A2(
											$elm$core$Basics$composeR,
											$author$project$Factoring$Page$VerificationBatch$checkIfFinished(model.debtorBatchId),
											$elm$core$Basics$not))),
								$elm$core$Maybe$withDefault(false))),
						A2(
							$author$project$Factoring$Page$VerificationBatch$listFromData,
							function ($) {
								return $.items;
							},
							data)));
				var _v1 = function () {
					var _v2 = _Utils_Tuple2(toFinish, isFinal);
					if (_v2.a) {
						if (_v2.b) {
							return _Utils_Tuple2($author$project$Api$VerificationsDebtorBatches$updateAndFinish, $author$project$Factoring$Page$VerificationBatch$SavedAndFinished);
						} else {
							return _Utils_Tuple2(
								$author$project$Api$VerificationsDebtorBatches$updateItems,
								$author$project$Factoring$Page$VerificationBatch$ItemSavedNowFinish(batchItemId));
						}
					} else {
						return _Utils_Tuple2(
							$author$project$Api$VerificationsDebtorBatches$updateItems,
							$author$project$Factoring$Page$VerificationBatch$ItemSaved(batchItemId));
					}
				}();
				var call = _v1.a;
				var callback = _v1.b;
				var commands = A2(
					$author$project$HubTran$Effect$sendCacheableRequestWithError,
					callback,
					A2(
						call,
						model.debtorBatchId,
						_List_fromArray(
							[
								_Utils_Tuple2(batchItemId, toSave)
							])));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					commands);
			case 'BatchSkipAndFinish':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2($author$project$Factoring$Page$VerificationBatch$batchSkipAndFinish, data, model));
			case 'SelectDocument':
				var selection = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedPage: selection}),
					$author$project$HubTran$Effect$none);
			case 'SelectLeftSideDocument':
				var selection = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							leftSideSelectedPage: $elm$core$Maybe$Just(selection)
						}),
					$author$project$HubTran$Effect$none);
			case 'ClearLeftSideDocument':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{leftSideSelectedPage: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'SelectInvoice':
				var invoiceId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedFactorInvoiceId: $elm$core$Maybe$Just(invoiceId),
							selectedPage: {documentIndex: 0, pageIndex: 0}
						}),
					$author$project$HubTran$Effect$none);
			case 'SelectTab':
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							tab: $elm$core$Maybe$Just(tab)
						}),
					$author$project$HubTran$Effect$none);
			case 'SetDocumentBrowserExpanded':
				var expanded = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{documentBrowserExpanded: expanded}),
					$author$project$HubTran$Effect$none);
			case 'SendDebtorConfirmation':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Factoring$Page$VerificationBatch$DebtorConfirmationSent,
						$author$project$Api$VerificationsDebtorBatches$sendDebtorConfirmation(model.debtorBatchId)));
			case 'ResetDebtorConfirmations':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: true}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Factoring$Page$VerificationBatch$DebtorConfirmationsReset,
						$author$project$Api$VerificationsDebtorBatches$resetDebtorConfirmations(model.debtorBatchId)));
			case 'ExcludeRecipient':
				var address = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							excludedRecipients: A2($elm$core$Set$insert, address, model.excludedRecipients),
							pendingEditUndos: A2($elm$core$Set$remove, address, model.pendingEditUndos),
							recipientEditsInFlight: A2($elm$core$Set$insert, address, model.recipientEditsInFlight)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Factoring$Page$VerificationBatch$RecipientExcluded(address),
						A2($author$project$Api$VerificationsDebtorBatches$excludeConfirmationRecipient, model.debtorBatchId, address)));
			case 'RecipientExcluded':
				var address = msg.a;
				var result = msg.b;
				return A3(
					$author$project$Factoring$Page$VerificationBatch$recipientEditSaved,
					{
						address: address,
						rollback: function (m) {
							return _Utils_update(
								m,
								{
									excludedRecipients: A2($elm$core$Set$remove, address, m.excludedRecipients)
								});
						},
						whenUnexplained: 'Could not take ' + (address + ' off the list.')
					},
					result,
					model);
			case 'UndoRecipientEdit':
				var address = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							excludedRecipients: A2($elm$core$Set$remove, address, model.excludedRecipients),
							pendingEditUndos: A2($elm$core$Set$insert, address, model.pendingEditUndos),
							recipientEditsInFlight: A2($elm$core$Set$insert, address, model.recipientEditsInFlight)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						$author$project$Factoring$Page$VerificationBatch$RecipientEditUndone(address),
						A2($author$project$Api$VerificationsDebtorBatches$undoConfirmationRecipientEdit, model.debtorBatchId, address)));
			case 'RecipientEditUndone':
				var address = msg.a;
				var result = msg.b;
				return A3(
					$author$project$Factoring$Page$VerificationBatch$recipientEditSaved,
					{
						address: address,
						rollback: function (m) {
							return _Utils_update(
								m,
								{
									pendingEditUndos: A2($elm$core$Set$remove, address, m.pendingEditUndos)
								});
						},
						whenUnexplained: 'Could not change the recipient list.'
					},
					result,
					model);
			case 'AddRecipientRow':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							addedRecipients: _Utils_ap(
								model.addedRecipients,
								_List_fromArray(
									[
										{address: '', key: model.nextAddedRecipientKey, name: '', saved: false, saving: false, showFormatWarning: false}
									])),
							nextAddedRecipientKey: model.nextAddedRecipientKey + 1
						}),
					$author$project$HubTran$Effect$none);
			case 'UpdateAddedRecipientName':
				var key = msg.a;
				var raw = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							addedRecipients: A3(
								$author$project$Factoring$Page$VerificationBatch$updateAddedRecipient,
								key,
								function (row) {
									return _Utils_update(
										row,
										{name: raw});
								},
								model.addedRecipients)
						}),
					$author$project$HubTran$Effect$none);
			case 'UpdateAddedRecipientAddress':
				var key = msg.a;
				var raw = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							addedRecipients: A3(
								$author$project$Factoring$Page$VerificationBatch$updateAddedRecipient,
								key,
								function (row) {
									return _Utils_update(
										row,
										{address: raw, showFormatWarning: false});
								},
								model.addedRecipients)
						}),
					$author$project$HubTran$Effect$none);
			case 'CommitAddedRecipient':
				var key = msg.a;
				var name = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($author$project$Factoring$Page$VerificationBatch$addedRecipientName, key, model.addedRecipients));
				var address = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($author$project$Factoring$Page$VerificationBatch$addedRecipientAddress, key, model.addedRecipients));
				return $elm$core$String$isEmpty(address) ? _Utils_Tuple2(model, $author$project$HubTran$Effect$none) : ((!$author$project$Domain$EmailAddress$isValid(address)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							addedRecipients: A3(
								$author$project$Factoring$Page$VerificationBatch$updateAddedRecipient,
								key,
								function (row) {
									return _Utils_update(
										row,
										{showFormatWarning: true});
								},
								model.addedRecipients)
						}),
					$author$project$HubTran$Effect$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							addedRecipients: A3(
								$author$project$Factoring$Page$VerificationBatch$updateAddedRecipient,
								key,
								function (row) {
									return _Utils_update(
										row,
										{saving: true});
								},
								model.addedRecipients),
							recipientEditsInFlight: A2($elm$core$Set$insert, address, model.recipientEditsInFlight)
						}),
					A2(
						$author$project$HubTran$Effect$sendCacheableRequestWithError,
						A2($author$project$Factoring$Page$VerificationBatch$AddedRecipientCommitted, key, address),
						A2(
							$author$project$Api$VerificationsDebtorBatches$addConfirmationRecipient,
							model.debtorBatchId,
							{address: address, name: name}))));
			case 'AddedRecipientCommitted':
				var key = msg.a;
				var address = msg.b;
				var result = msg.c;
				var settled = function (m) {
					return _Utils_update(
						m,
						{
							recipientEditsInFlight: A2($elm$core$Set$remove, address, m.recipientEditsInFlight)
						});
				};
				var stopSaving = function (m) {
					return settled(
						_Utils_update(
							m,
							{
								addedRecipients: A3(
									$author$project$Factoring$Page$VerificationBatch$updateAddedRecipient,
									key,
									function (row) {
										return _Utils_update(
											row,
											{saving: false});
									},
									m.addedRecipients)
							}));
				};
				switch (result.$) {
					case 'Ok':
						return _Utils_Tuple2(
							settled(
								_Utils_update(
									model,
									{
										addedRecipients: A3(
											$author$project$Factoring$Page$VerificationBatch$updateAddedRecipient,
											key,
											function (row) {
												return _Utils_update(
													row,
													{saved: true, saving: false});
											},
											model.addedRecipients),
										pendingEditUndos: A2($elm$core$Set$remove, address, model.pendingEditUndos)
									})),
							$author$project$Factoring$Page$VerificationBatch$refreshDebtorBatch(model));
					case 'Err':
						var message = result.a;
						return _Utils_Tuple2(
							stopSaving(model),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							stopSaving(model),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Could not save ' + (address + '.'))));
				}
			case 'DiscardAddedRecipient':
				var key = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							addedRecipients: A2(
								$elm$core$List$filter,
								function (row) {
									return !_Utils_eq(row.key, key);
								},
								model.addedRecipients)
						}),
					$author$project$HubTran$Effect$none);
			case 'DebtorConfirmationSent':
				var response = msg.a;
				var park = function (batch) {
					return _Utils_update(
						batch,
						{state: $author$project$AuditPb$VerificationsDebtorBatchStateWaiting});
				};
				var parkBatch = function (data_) {
					return _Utils_update(
						data_,
						{
							debtorBatch: park(data_.debtorBatch)
						});
				};
				var _v4 = function () {
					switch (response.$) {
						case 'Ok':
							return _Utils_Tuple2(
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$notice('Confirmation email queued for the debtor. Batch moved to Waiting.')),
											$author$project$Factoring$Page$VerificationBatch$invalidateBatchItems(data),
											$author$project$HubTran$Effect$invalidate(
											A2($author$project$Forward$Lookup$startFrom, model.debtorBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch))
										])),
								A2(
									$elm$core$Maybe$map,
									parkBatch,
									$author$project$Forward$Remote$toMaybe(data)));
						case 'Err':
							var message = response.a;
							return _Utils_Tuple2(
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(message)),
								$elm$core$Maybe$Nothing);
						default:
							return _Utils_Tuple2(
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert('Could not send the confirmation email.')),
								$elm$core$Maybe$Nothing);
					}
				}();
				var effect = _v4.a;
				var dataWhileInvalidating = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dataWhileInvalidating: dataWhileInvalidating, isSaving: false}),
					effect);
			case 'DebtorConfirmationDelivered':
				var batchId = msg.a;
				return _Utils_eq(
					batchId,
					$author$project$Domain$VerificationsDebtorBatchId$toInt(model.debtorBatchId)) ? _Utils_Tuple2(
					model,
					A2($author$project$HubTran$Effect$map, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmationDeliveredAt, $author$project$HubTran$Effect$now)) : _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
			case 'DebtorConfirmationDeliveredAt':
				var deliveredAt = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{requireItemsNewerThan: deliveredAt}),
					$author$project$HubTran$Effect$none);
			case 'DebtorConfirmationsReset':
				var response = msg.a;
				var settled = _Utils_update(
					model,
					{isSaving: false});
				switch (response.$) {
					case 'Ok':
						return _Utils_Tuple2(
							_Utils_update(
								settled,
								{addedRecipients: _List_Nil, excludedRecipients: $elm$core$Set$empty, pendingEditUndos: $elm$core$Set$empty}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$notice('Debtor confirmations cleared. This batch can be sent again.')),
										$author$project$Factoring$Page$VerificationBatch$invalidateBatchItems(data),
										$author$project$Factoring$Page$VerificationBatch$refreshDebtorBatch(model)
									])));
					case 'Err':
						var message = response.a;
						return _Utils_Tuple2(
							settled,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message)));
					default:
						return _Utils_Tuple2(
							settled,
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Could not reset the debtor confirmations.')));
				}
			case 'SaveContactInfo':
				var debtorId = msg.a;
				var _v7 = model.newContactInfo;
				if (_v7.$ === 'Nothing') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{editingContactInfo: false}),
						$author$project$HubTran$Effect$none);
				} else {
					var contactInfoString = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isSaving: true}),
						A2(
							$author$project$HubTran$Effect$sendCacheableRequestWithError,
							$author$project$Factoring$Page$VerificationBatch$ContactInfoSaved(debtorId),
							A2($author$project$Api$Debtors$contactInfo, debtorId, contactInfoString)));
				}
			case 'ToggleContactInfoChanges':
				var show = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editingContactInfo: show, newContactInfo: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'UpdateContactInfo':
				var updatedInfoString = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newContactInfo: $elm$core$Maybe$Just(updatedInfoString)
						}),
					$author$project$HubTran$Effect$none);
			case 'BatchStateChangedNowMaybeSkip':
				var toBatchSkip = msg.a;
				var state = msg.b;
				var response = msg.c;
				var setState = function (batch) {
					return _Utils_update(
						batch,
						{
							state: $author$project$Factoring$Page$VerificationBatch$nextDebtorBatchState(state)
						});
				};
				var setBatchState = function (data_) {
					return _Utils_update(
						data_,
						{
							debtorBatch: setState(data_.debtorBatch)
						});
				};
				var changeString = ' from ' + ($author$project$Domain$VerificationsDebtorBatch$stateToDisplayString(state) + (' to ' + $author$project$Domain$VerificationsDebtorBatch$stateToDisplayString(
					$author$project$Factoring$Page$VerificationBatch$nextDebtorBatchState(state))));
				var _v8 = function () {
					var _v9 = _Utils_Tuple2(response, toBatchSkip);
					if (_v9.a.$ === 'Ok') {
						if (!_v9.b) {
							return _Utils_Tuple2(
								$author$project$HubTran$Effect$invalidate(
									A2($author$project$Forward$Lookup$startFrom, model.debtorBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch)),
								A2(
									$elm$core$Maybe$map,
									setBatchState,
									$author$project$Forward$Remote$toMaybe(data)));
						} else {
							return _Utils_Tuple2(
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$invalidate(
											A2($author$project$Forward$Lookup$startFrom, model.debtorBatchId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$verificationsDebtorBatch)),
											A2($author$project$Factoring$Page$VerificationBatch$batchSkipAndFinish, data, model)
										])),
								A2(
									$elm$core$Maybe$map,
									setBatchState,
									$author$project$Forward$Remote$toMaybe(data)));
						}
					} else {
						return _Utils_Tuple2(
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Could not transition' + changeString)),
							$elm$core$Maybe$Nothing);
					}
				}();
				var effect = _v8.a;
				var dataWhileInvalidating = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dataWhileInvalidating: dataWhileInvalidating, isSaving: false}),
					effect);
			case 'ItemSaved':
				var batchItemId = msg.a;
				var response = msg.b;
				var invalidateBatchItem = A2(
					$author$project$Factoring$Page$VerificationBatch$batchItemInvalidations,
					batchItemId,
					A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, batchItemId, model.formState));
				var _v10 = function () {
					switch (response.$) {
						case 'Ok':
							return _Utils_Tuple2(
								function (key) {
									return A2($elm$core$Dict$remove, key, model.formState);
								}(
									$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(batchItemId)),
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$success('Changes Saved.')),
											invalidateBatchItem
										])));
						case 'Err':
							var message = response.a;
							return _Utils_Tuple2(
								model.formState,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$alert(message)),
											invalidateBatchItem
										])));
						default:
							return _Utils_Tuple2(
								model.formState,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$alert('Could Not Save Changes.')),
											invalidateBatchItem
										])));
					}
				}();
				var formState = _v10.a;
				var commands = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{formState: formState, isSaving: false}),
					commands);
			case 'ItemSavedNowFinish':
				var batchItemId = msg.a;
				var response = msg.b;
				var invalidateBatchItem = A2(
					$author$project$Factoring$Page$VerificationBatch$batchItemInvalidations,
					batchItemId,
					A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, batchItemId, model.formState));
				var _v12 = function () {
					switch (response.$) {
						case 'Ok':
							return _Utils_Tuple3(
								function (key) {
									return A2($elm$core$Dict$remove, key, model.formState);
								}(
									$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(batchItemId)),
								A2($author$project$Factoring$Page$VerificationBatch$finishItem, batchItemId, model),
								true);
						case 'Err':
							var message = response.a;
							return _Utils_Tuple3(
								model.formState,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$alert(message)),
											invalidateBatchItem
										])),
								false);
						default:
							return _Utils_Tuple3(
								model.formState,
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$alert('Could not Save and Complete Item.')),
											invalidateBatchItem
										])),
								false);
					}
				}();
				var formState = _v12.a;
				var commands = _v12.b;
				var isSaving = _v12.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{formState: formState, isSaving: isSaving}),
					commands);
			case 'SavedAndFinished':
				var response = msg.a;
				var commands = function () {
					switch (response.$) {
						case 'Ok':
							return $author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										$author$project$HubTran$Effect$flash(
										$author$project$HubTran$Flash$success('Saved And Finished.')),
										$author$project$HubTran$Effect$cmd(
										$author$project$HubTran$Navigation$load(
											$author$project$Factoring$Page$VerificationBatch$dashOrOnDone(model.maybeOnDone)))
									]));
						case 'Err':
							var message = response.a;
							return $author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert(message));
						default:
							return $author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('Could Not Save Changes.'));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isSaving: false}),
					commands);
			case 'ContactInfoSaved':
				var debtorId = msg.a;
				var response = msg.b;
				var setContactInfo = function (debtor) {
					return _Utils_update(
						debtor,
						{
							contactInfo: A2($elm$core$Maybe$withDefault, debtor.contactInfo, model.newContactInfo)
						});
				};
				var setDebtorContactInfo = function (data_) {
					return _Utils_update(
						data_,
						{
							debtor: setContactInfo(data_.debtor)
						});
				};
				var _v15 = function () {
					switch (response.$) {
						case 'Ok':
							return _Utils_Tuple2(
								$author$project$HubTran$Effect$invalidate(
									A2($author$project$Forward$Lookup$startFrom, debtorId, $author$project$Forward$AppSpecific$NeedsControllerEndpoints$factorBroker)),
								A2(
									$elm$core$Maybe$map,
									setDebtorContactInfo,
									$author$project$Forward$Remote$toMaybe(data)));
						case 'Err':
							var message = response.a;
							return _Utils_Tuple2(
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(message)),
								$elm$core$Maybe$Nothing);
						default:
							return _Utils_Tuple2(
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert('Could not update contact info.')),
								$elm$core$Maybe$Nothing);
					}
				}();
				var effect = _v15.a;
				var dataWhileInvalidating = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dataWhileInvalidating: dataWhileInvalidating, editingContactInfo: false, isSaving: false}),
					effect);
			case 'ItemPartialFinishCompleted':
				var batchItemId = msg.a;
				var response = msg.b;
				var invalidateBatchItem = A2(
					$author$project$Factoring$Page$VerificationBatch$batchItemInvalidations,
					batchItemId,
					A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, batchItemId, model.formState));
				var _v17 = function () {
					switch (response.$) {
						case 'Ok':
							return _Utils_Tuple2(
								$author$project$Forward$Remote$toMaybe(data),
								$author$project$HubTran$Effect$batch(
									_List_fromArray(
										[
											invalidateBatchItem,
											$author$project$HubTran$Effect$flash(
											$author$project$HubTran$Flash$success('Completed verification for invoice.'))
										])));
						case 'Err':
							var message = response.a;
							return _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert(message)));
						default:
							return _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								$author$project$HubTran$Effect$flash(
									$author$project$HubTran$Flash$alert('Could not complete verification for invoice.')));
					}
				}();
				var dataWhileInvalidating = _v17.a;
				var commands = _v17.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dataWhileInvalidating: dataWhileInvalidating, isSaving: false}),
					commands);
			case 'SetFormValuesForAllInvoices':
				var itemIds = msg.a;
				var item = msg.b;
				var items = A2(
					$elm$core$List$filter,
					function (itemId) {
						var unfinished = !A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, itemId, model.formState).isFinished;
						var unedited = !A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.manuallyUpdated;
								},
								A2(
									$elm$core$Dict$get,
									$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemId),
									model.formState)));
						return unfinished && unedited;
					},
					itemIds);
				var formDetails = A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, item.id, model.formState);
				var updatedModel = A3(
					$elm$core$List$foldl,
					F2(
						function (itemId, newModel) {
							var oldEntry = A4($author$project$Factoring$Page$VerificationBatch$getItemData, data, model, itemId, model.formState);
							var notes = function () {
								var _v19 = oldEntry.notes;
								if (_v19 === '') {
									return formDetails.notes;
								} else {
									return oldEntry.notes;
								}
							}();
							var method = formDetails.verificationMethodId;
							var key = $author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemId);
							var contact = formDetails.debtorContactId;
							var newEntry = _Utils_update(
								oldEntry,
								{debtorContactId: contact, notes: notes, updatesToSave: true, verificationMethodId: method});
							return _Utils_update(
								newModel,
								{
									formState: A3($elm$core$Dict$insert, key, newEntry, newModel.formState)
								});
						}),
					model,
					items);
				return _Utils_Tuple2(updatedModel, $author$project$HubTran$Effect$none);
			case 'SetTimezone':
				var tz = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: tz}),
					$author$project$HubTran$Effect$none);
			case 'SetDebtorContactInfoExpanded':
				var expanded = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{contactInfoExpanded: expanded}),
					$author$project$HubTran$Effect$none);
			case 'SetDebtorNotesExpanded':
				var expanded = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtorNotesExpanded: expanded}),
					$author$project$HubTran$Effect$none);
			case 'SetDebtorContactsExpanded':
				var expanded = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtorContactsExpanded: expanded}),
					$author$project$HubTran$Effect$none);
			case 'SetVerificationInstructionsState':
				var state = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{verificationInstructionsState: state}),
					$author$project$HubTran$Effect$none);
			case 'ToggleEmailModal':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{copiedToClipboard: false, viewEmailModal: !model.viewEmailModal}),
					$author$project$HubTran$Effect$none);
			case 'OpenDebtorConfirmation':
				var target = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							debtorConfirmationModal: $elm$core$Maybe$Just(target)
						}),
					$author$project$HubTran$Effect$none);
			case 'CloseDebtorConfirmation':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtorConfirmationModal: $elm$core$Maybe$Nothing}),
					$author$project$HubTran$Effect$none);
			case 'PresenceMsg':
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							presence: A2($author$project$Presence$update, subMsg, model.presence)
						}),
					$author$project$HubTran$Effect$none);
			case 'CopyToClipboard':
				var toCopy = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$HubTran$Effect$cmd(
						$author$project$Js$copyToClipboard(toCopy)));
			case 'CopiedToClipboard':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{copiedToClipboard: true}),
					$author$project$HubTran$Effect$none);
			case 'SetDebtorVerificationsExpandedState':
				var batchItemId = msg.a;
				var expanded = msg.b;
				var debtorVerificationsExpandedState = A3(
					$elm$core$Dict$insert,
					$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(batchItemId),
					expanded,
					model.debtorVerificationsExpandedState);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debtorVerificationsExpandedState: debtorVerificationsExpandedState}),
					$author$project$HubTran$Effect$none);
			case 'SetDebtorConfirmationExpandedState':
				var batchItemId = msg.a;
				var expanded = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							debtorConfirmationExpandedState: A3(
								$elm$core$Dict$insert,
								$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(batchItemId),
								expanded,
								model.debtorConfirmationExpandedState)
						}),
					$author$project$HubTran$Effect$none);
			default:
				return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
		}
	});
var $author$project$Main$updatePage = F4(
	function (mainModel, remoteData, msg, model) {
		var _v0 = _Utils_Tuple2(msg, remoteData);
		_v0$41:
		while (true) {
			if (_v0.b.$ === 'Loaded') {
				switch (_v0.a.$) {
					case 'ActivityPageMsg':
						if (_v0.b.a.$ === 'ActivityPageData') {
							var pageMsg = _v0.a.a;
							var _v1 = _v0.b.a;
							var page = _v1.a;
							var pageData = _v1.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$ActivityPage,
								$author$project$HubTran$Effect$map($author$project$Main$ActivityPageMsg),
								A3($author$project$Components$ActivityPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'BrokerBillingRequirementsPageMsg':
						if (_v0.b.a.$ === 'BrokerBillingRequirementsPageData') {
							var pageMsg = _v0.a.a;
							var _v2 = _v0.b.a;
							var page = _v2.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$BrokerBillingRequirementsPage,
								$author$project$HubTran$Effect$map($author$project$Main$BrokerBillingRequirementsPageMsg),
								A2($author$project$Broker$Page$BillingRequirements$update, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'ClientSubmissionInvoicePageMsg':
						if (_v0.b.a.$ === 'ClientSubmissionInvoicePageData') {
							var pageMsg = _v0.a.a;
							var _v3 = _v0.b.a;
							var page = _v3.a;
							var pageData = _v3.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$ClientSubmissionInvoicePage,
								$author$project$HubTran$Effect$map($author$project$Main$ClientSubmissionInvoicePageMsg),
								A3($author$project$Factoring$Page$ClientSubmissionInvoice$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'ClientSubmissionPageMsg':
						if (_v0.b.a.$ === 'ClientSubmissionPageData') {
							var pageMsg = _v0.a.a;
							var page = _v0.b.a.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$ClientSubmissionPage,
								$author$project$HubTran$Effect$map($author$project$Main$ClientSubmissionPageMsg),
								A2($author$project$Factoring$Page$ClientSubmission$update, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'ClientSubmissionReviewPageMsg':
						if (_v0.b.a.$ === 'ClientSubmissionReviewPageData') {
							var pageMsg = _v0.a.a;
							var _v4 = _v0.b.a;
							var page = _v4.a;
							var pageData = _v4.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$ClientSubmissionReviewPage,
								$author$project$HubTran$Effect$map($author$project$Main$ClientSubmissionReviewPageMsg),
								A3($author$project$Factoring$Page$ClientSubmissionReview$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'DashboardPageMsg':
						if (_v0.b.a.$ === 'DashboardPageData') {
							var pageMsg = _v0.a.a;
							var _v5 = _v0.b.a;
							var page = _v5.a;
							var pageData = _v5.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$DashboardPage,
								$author$project$HubTran$Effect$map($author$project$Main$DashboardPageMsg),
								A4($author$project$Components$DashboardPage$update, mainModel.headerFlags.reskinVals.queues, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'DocumentsViewerPopoutPageMsg':
						if (_v0.b.a.$ === 'DocumentsViewerPopoutPageData') {
							var pageMsg = _v0.a.a;
							var _v6 = _v0.b.a;
							var page = _v6.a;
							var pageData = _v6.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$DocumentsViewerPopoutPage,
								$author$project$HubTran$Effect$map($author$project$Main$DocumentsViewerPopoutPageMsg),
								A3($author$project$Broker$Page$DocumentsViewerPopout$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'EmailMessageSearchPageMsg':
						if (_v0.b.a.$ === 'EmailMessageSearchPageData') {
							var pageMsg = _v0.a.a;
							var _v7 = _v0.b.a;
							var page = _v7.a;
							var pageData = _v7.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$EmailMessageSearchPage,
								$author$project$HubTran$Effect$map($author$project$Main$EmailMessageSearchPageMsg),
								A4($author$project$Components$EmailMessageSearchPage$update, mainModel.headerFlags.reskinVals.topLevel, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'LtlReconcileInvoicePageMsg':
						if (_v0.b.a.$ === 'LtlReconcileInvoicePageData') {
							var pageMsg = _v0.a.a;
							var _v8 = _v0.b.a;
							var page = _v8.a;
							var pageData = _v8.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$LtlReconcileInvoicePage,
								$author$project$HubTran$Effect$map($author$project$Main$LtlReconcileInvoicePageMsg),
								A3($author$project$Components$LtlReconcileInvoicePage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'NonInvoiceConfirmPageMsg':
						if (_v0.b.a.$ === 'NonInvoiceConfirmPageData') {
							var pageMsg = _v0.a.a;
							var _v9 = _v0.b.a;
							var page = _v9.a;
							var pageData = _v9.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$NonInvoiceConfirmPage,
								$author$project$HubTran$Effect$map($author$project$Main$NonInvoiceConfirmPageMsg),
								A3($author$project$Components$NonInvoiceConfirmPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'OktaLoginPageMsg':
						if (_v0.b.a.$ === 'OktaLoginPageData') {
							var pageMsg = _v0.a.a;
							var _v10 = _v0.b.a;
							var page = _v10.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$OktaLoginPage,
								$author$project$HubTran$Effect$map($author$project$Main$OktaLoginPageMsg),
								A2($author$project$Components$OktaLoginPage$update, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsCarrierPageMsg':
						if (_v0.b.a.$ === 'SettingsCarrierPageData') {
							var pageMsg = _v0.a.a;
							var _v11 = _v0.b.a;
							var page = _v11.a;
							var pageData = _v11.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsCarrierPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsCarrierPageMsg),
								A3($author$project$Components$SettingsPage$CarrierLayout$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsCarriersPageMsg':
						if (_v0.b.a.$ === 'SettingsCarriersPageData') {
							var pageMsg = _v0.a.a;
							var _v12 = _v0.b.a;
							var page = _v12.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsCarriersPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsCarriersPageMsg),
								A2($author$project$Components$SettingsPage$CarriersLayout$update, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsCustomerPageMsg':
						if (_v0.b.a.$ === 'SettingsCustomerPageData') {
							var pageMsg = _v0.a.a;
							var _v13 = _v0.b.a;
							var page = _v13.a;
							var pageData = _v13.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsCustomerPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsCustomerPageMsg),
								A3($author$project$Components$SettingsPage$CustomerLayout$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsCustomersPageMsg':
						if (_v0.b.a.$ === 'SettingsCustomersPageData') {
							var pageMsg = _v0.a.a;
							var _v14 = _v0.b.a;
							var page = _v14.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsCustomersPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsCustomersPageMsg),
								A2($author$project$Components$SettingsPage$CustomersLayout$update, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsDebtorPageMsg':
						if (_v0.b.a.$ === 'SettingsDebtorPageData') {
							var pageMsg = _v0.a.a;
							var _v15 = _v0.b.a;
							var page = _v15.a;
							var pageData = _v15.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsDebtorPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsDebtorPageMsg),
								A3($author$project$Components$SettingsPage$DebtorLayout$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsPageMsg':
						if (_v0.b.a.$ === 'SettingsPageData') {
							var pageMsg = _v0.a.a;
							var _v16 = _v0.b.a;
							var page = _v16.a;
							var pageData = _v16.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsPageMsg),
								A4($author$project$Components$SettingsPage$update, mainModel.headerFlags.reskinVals.settings, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsReferenceFieldsPageMsg':
						if (_v0.b.a.$ === 'SettingsReferenceFieldsPageData') {
							var pageMsg = _v0.a.a;
							var _v17 = _v0.b.a;
							var page = _v17.a;
							var pageData = _v17.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsReferenceFieldsPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsReferenceFieldsPageMsg),
								A3($author$project$Components$SettingsPage$ReferenceFieldsLayout$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsReportsPageMsg':
						if (_v0.b.a.$ === 'SettingsReportsPageData') {
							var pageMsg = _v0.a.a;
							var _v18 = _v0.b.a;
							var page = _v18.a;
							var pageData = _v18.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsReportsPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsReportsPageMsg),
								A3($author$project$Components$SettingsPage$ReportsLayout$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsRulesPageMsg':
						if (_v0.b.a.$ === 'SettingsRulesPageData') {
							var pageMsg = _v0.a.a;
							var _v19 = _v0.b.a;
							var page = _v19.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsRulesPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsRulesPageMsg),
								A2($author$project$Components$SettingsPage$RulesLayout$update, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsUserPageMsg':
						if (_v0.b.a.$ === 'SettingsUserPageData') {
							var pageMsg = _v0.a.a;
							var _v20 = _v0.b.a;
							var page = _v20.a;
							var pageData = _v20.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsUserPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsUserPageMsg),
								A3($author$project$Components$SettingsPage$UserLayout$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsUsersPageMsg':
						if (_v0.b.a.$ === 'SettingsUsersPageData') {
							var pageMsg = _v0.a.a;
							var _v21 = _v0.b.a;
							var page = _v21.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsUsersPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsUsersPageMsg),
								A2($author$project$Components$SettingsPage$UsersLayout$update, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'SettingsVerificationsPageMsg':
						if (_v0.b.a.$ === 'SettingsVerificationsPageData') {
							var pageMsg = _v0.a.a;
							var _v22 = _v0.b.a;
							var page = _v22.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$SettingsVerificationsPage,
								$author$project$HubTran$Effect$map($author$project$Main$SettingsVerificationsPageMsg),
								A2($author$project$Components$SettingsPage$VerificationsLayout$update, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'TermsPageMsg':
						if (_v0.b.a.$ === 'TermsPageData') {
							var pageMsg = _v0.a.a;
							var page = _v0.b.a.a;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$TermsPage,
								$author$project$HubTran$Effect$map($author$project$Main$TermsPageMsg),
								A3(
									$author$project$Components$TermsPage$page.update,
									$author$project$Forward$Remote$Loaded(_Utils_Tuple0),
									pageMsg,
									page));
						} else {
							break _v0$41;
						}
					case 'VerificationBatchPageMsg':
						if (_v0.b.a.$ === 'VerificationBatchPageData') {
							var pageMsg = _v0.a.a;
							var _v23 = _v0.b.a;
							var page = _v23.a;
							var pageData = _v23.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$VerificationBatchPage,
								$author$project$HubTran$Effect$map($author$project$Main$VerificationBatchPageMsg),
								A3($author$project$Factoring$Page$VerificationBatch$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'LtlHeldSubmissionsPageMsg':
						if (_v0.b.a.$ === 'LtlHeldSubmissionsPageData') {
							var pageMsg = _v0.a.a;
							var _v24 = _v0.b.a;
							var page = _v24.a;
							var pageData = _v24.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$LtlHeldSubmissionsPage,
								$author$project$HubTran$Effect$map($author$project$Main$LtlHeldSubmissionsPageMsg),
								A3($author$project$Components$LtlHeldSubmissionsPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'MyClientsOverviewPageMsg':
						if (_v0.b.a.$ === 'MyClientsOverviewPageData') {
							var pageMsg = _v0.a.a;
							var _v25 = _v0.b.a;
							var page = _v25.a;
							var pageData = _v25.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$MyClientsOverviewPage,
								$author$project$HubTran$Effect$map($author$project$Main$MyClientsOverviewPageMsg),
								A3($author$project$Components$MyClients$OverviewPage$page.update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'NoaManagementToSendPageMsg':
						if (_v0.b.a.$ === 'NoaManagementToSendPageData') {
							var pageMsg = _v0.a.a;
							var _v26 = _v0.b.a;
							var page = _v26.a;
							var pageData = _v26.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$NoaManagementToSendPage,
								$author$project$HubTran$Effect$map($author$project$Main$NoaManagementToSendPageMsg),
								A3($author$project$Components$NoaManagement$ToSendPage$page.update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'DebtorChangesPageMsg':
						if (_v0.b.a.$ === 'DebtorChangesPageData') {
							var pageMsg = _v0.a.a;
							var _v27 = _v0.b.a;
							var page = _v27.a;
							var pageData = _v27.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$DebtorChangesPage,
								$author$project$HubTran$Effect$map($author$project$Main$DebtorChangesPageMsg),
								A3($author$project$Components$DebtorChanges$IndexPage$page.update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'DebtorChangesTemplatePageMsg':
						if (_v0.b.a.$ === 'DebtorChangesTemplatePageData') {
							var pageMsg = _v0.a.a;
							var _v28 = _v0.b.a;
							var page = _v28.a;
							var pageData = _v28.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$DebtorChangesTemplatePage,
								$author$project$HubTran$Effect$map($author$project$Main$DebtorChangesTemplatePageMsg),
								A3($author$project$Components$DebtorChanges$TemplatePage$page.update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'NoaManagementSentPageMsg':
						if (_v0.b.a.$ === 'NoaManagementSentPageData') {
							var pageMsg = _v0.a.a;
							var _v29 = _v0.b.a;
							var page = _v29.a;
							var pageData = _v29.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$NoaManagementSentPage,
								$author$project$HubTran$Effect$map($author$project$Main$NoaManagementSentPageMsg),
								A3($author$project$Components$NoaManagement$SentPage$page.update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'NoaManagementSkippedPageMsg':
						if (_v0.b.a.$ === 'NoaManagementSkippedPageData') {
							var pageMsg = _v0.a.a;
							var _v30 = _v0.b.a;
							var page = _v30.a;
							var pageData = _v30.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$NoaManagementSkippedPage,
								$author$project$HubTran$Effect$map($author$project$Main$NoaManagementSkippedPageMsg),
								A3($author$project$Components$NoaManagement$SkippedPage$page.update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'EmailMergePageMsg':
						if (_v0.b.a.$ === 'EmailMergePageData') {
							var pageMsg = _v0.a.a;
							var _v31 = _v0.b.a;
							var page = _v31.a;
							var pageData = _v31.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$EmailMergePage,
								$author$project$HubTran$Effect$map($author$project$Main$EmailMergePageMsg),
								A3($author$project$Components$EmailMergePage$page.update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'ReadonlyFactorInvoicePageMsg':
						if (_v0.b.a.$ === 'ReadonlyFactorInvoicePageData') {
							var pageMsg = _v0.a.a;
							var _v32 = _v0.b.a;
							var page = _v32.a;
							var pageData = _v32.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$ReadonlyFactorInvoicePage,
								$author$project$HubTran$Effect$map($author$project$Main$ReadonlyFactorInvoicePageMsg),
								A3($author$project$Components$ReadonlyFactorInvoicePage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'ToBeScrapedLoadsPageMsg':
						if (_v0.b.a.$ === 'ToBeScrapedLoadsPageData') {
							var pageMsg = _v0.a.a;
							var _v33 = _v0.b.a;
							var page = _v33.a;
							var pageData = _v33.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$ToBeScrapedLoadsPage,
								$author$project$HubTran$Effect$map($author$project$Main$ToBeScrapedLoadsPageMsg),
								A3($author$project$Components$ToBeScrapedLoadsPage$page.update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'CarrierInvoiceAuditPageMsg':
						if (_v0.b.a.$ === 'CarrierInvoiceAuditPageData') {
							var pageMsg = _v0.a.a;
							var _v34 = _v0.b.a;
							var page = _v34.a;
							var pageData = _v34.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$CarrierInvoiceAuditPage,
								$author$project$HubTran$Effect$map($author$project$Main$CarrierInvoiceAuditPageMsg),
								A3($author$project$Components$CarrierInvoiceAuditPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'FactorInvoiceAuditPageMsg':
						if (_v0.b.a.$ === 'FactorInvoiceAuditPageData') {
							var pageMsg = _v0.a.a;
							var _v35 = _v0.b.a;
							var page = _v35.a;
							var pageData = _v35.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$FactorInvoiceAuditPage,
								$author$project$HubTran$Effect$map($author$project$Main$FactorInvoiceAuditPageMsg),
								A3($author$project$Components$FactorInvoiceAuditPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'FactorInvoiceAuditBatchPageMsg':
						if (_v0.b.a.$ === 'FactorInvoiceAuditBatchPageData') {
							var pageMsg = _v0.a.a;
							var _v36 = _v0.b.a;
							var page = _v36.a;
							var pageData = _v36.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$FactorInvoiceAuditBatchPage,
								$author$project$HubTran$Effect$map($author$project$Main$FactorInvoiceAuditBatchPageMsg),
								A3($author$project$Components$FactorInvoiceAuditBatchPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'DocumentReviewPageMsg':
						if (_v0.b.a.$ === 'DocumentReviewPageData') {
							var pageMsg = _v0.a.a;
							var _v37 = _v0.b.a;
							var page = _v37.a;
							var pageData = _v37.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$DocumentReviewPage,
								$author$project$HubTran$Effect$map($author$project$Main$DocumentReviewPageMsg),
								A3($author$project$Components$DocumentReviewPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					case 'DocumentBatchReviewPageMsg':
						if (_v0.b.a.$ === 'DocumentBatchReviewPageData') {
							var pageMsg = _v0.a.a;
							var _v38 = _v0.b.a;
							var page = _v38.a;
							var pageData = _v38.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$DocumentBatchReviewPage,
								$author$project$HubTran$Effect$map($author$project$Main$DocumentBatchReviewPageMsg),
								A3($author$project$Components$DocumentBatchReviewPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
					default:
						if (_v0.b.a.$ === 'DocumentGroupReviewPageData') {
							var pageMsg = _v0.a.a;
							var _v39 = _v0.b.a;
							var page = _v39.a;
							var pageData = _v39.b;
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$DocumentGroupReviewPage,
								$author$project$HubTran$Effect$map($author$project$Main$DocumentGroupReviewPageMsg),
								A3($author$project$Components$DocumentGroupReviewPage$update, pageData, pageMsg, page));
						} else {
							break _v0$41;
						}
				}
			} else {
				break _v0$41;
			}
		}
		var _v40 = A2(
			$elm$core$Debug$log,
			'WARNING: dropped Msg because we are now on a different page',
			{
				msg: msg,
				page: A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$take,
						2,
						$elm$core$String$words(
							$elm$core$Debug$toString(remoteData))))
			});
		return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
	});
var $author$project$Main$ChangePage = F2(
	function (a, b) {
		return {$: 'ChangePage', a: a, b: b};
	});
var $author$project$Main$urlParser = function (location) {
	return A2(
		$author$project$Main$ChangePage,
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.path;
				},
				location)),
		$author$project$Main$parsePageRequest(location));
};
var $author$project$Main$update = F3(
	function (origData, msg, model) {
		update:
		while (true) {
			var remoteData = A2($author$project$Main$overrideRemoteDataForReskin, model, origData);
			switch (msg.$) {
				case 'SetTimezone':
					var tz = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{timezone: tz}),
						$author$project$HubTran$Effect$none);
				case 'OnUrlChange':
					var maybeUrl = msg.a;
					var $temp$origData = remoteData,
						$temp$msg = $author$project$Main$urlParser(maybeUrl),
						$temp$model = _Utils_update(
						model,
						{location: maybeUrl});
					origData = $temp$origData;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 'ChangePage':
					var pathname = msg.a;
					var pageRequest = msg.b;
					if (A2($author$project$Main$shouldRetainState, remoteData, pageRequest)) {
						return _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
					} else {
						var _v1 = A2($author$project$Main$initPage, model.headerFlags.reskinVals, pageRequest);
						var changedPage = _v1.a;
						var changedPageEffect = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{page: changedPage}),
							$author$project$HubTran$Effect$batch(
								_List_fromArray(
									[
										changedPageEffect,
										A3(
										$author$project$Main$setUserPresenceIfInterested,
										A2($author$project$Main$presencePath, pathname, pageRequest),
										model.page,
										changedPage)
									])));
					}
				case 'ActivityPageInitDataLoaded':
					var queryParams = msg.a;
					var initDataResult = msg.b;
					if (initDataResult.$ === 'Ok') {
						var initData = initDataResult.a;
						var _v3 = A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Main$ActivityPage,
							$author$project$HubTran$Effect$map($author$project$Main$ActivityPageMsg),
							A2($author$project$Components$ActivityPage$init, initData, queryParams));
						var newPage = _v3.a;
						var pageEffect = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{page: newPage}),
							A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
					} else {
						var error = initDataResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									page: $author$project$Main$LoadingFailedPage(error)
								}),
							$author$project$HubTran$Effect$none);
					}
				case 'DashboardPageInitDataLoaded':
					var flags = msg.a;
					var initDataResult = msg.b;
					if (initDataResult.$ === 'Ok') {
						var initData = initDataResult.a;
						var _v5 = A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Main$DashboardPage,
							$author$project$HubTran$Effect$map($author$project$Main$DashboardPageMsg),
							A2($author$project$Components$DashboardPage$init, flags, initData));
						var newPage = _v5.a;
						var pageEffect = _v5.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{page: newPage}),
							A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
					} else {
						var error = initDataResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									page: $author$project$Main$LoadingFailedPage(error)
								}),
							$author$project$HubTran$Effect$none);
					}
				case 'NoaManagementSentPageInitDataLoaded':
					var params = msg.a;
					var initDataResult = msg.b;
					if (initDataResult.$ === 'Ok') {
						var initData = initDataResult.a;
						var _v7 = A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Main$NoaManagementSentPage,
							$author$project$HubTran$Effect$map($author$project$Main$NoaManagementSentPageMsg),
							$author$project$Components$NoaManagement$SentPage$page.init(
								_Utils_Tuple2(params, initData)));
						var newPage = _v7.a;
						var pageEffect = _v7.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{page: newPage}),
							A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
					} else {
						var error = initDataResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									page: $author$project$Main$LoadingFailedPage(error)
								}),
							$author$project$HubTran$Effect$none);
					}
				case 'FactorInvoiceAuditPageInitDataLoaded':
					var initDataResult = msg.a;
					if (initDataResult.$ === 'Ok') {
						var initData = initDataResult.a;
						var _v9 = A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Main$FactorInvoiceAuditPage,
							$author$project$HubTran$Effect$map($author$project$Main$FactorInvoiceAuditPageMsg),
							$author$project$Components$FactorInvoiceAuditPage$init(initData));
						var newPage = _v9.a;
						var pageEffect = _v9.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{page: newPage}),
							A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
					} else {
						var error = initDataResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									page: $author$project$Main$LoadingFailedPage(error)
								}),
							$author$project$HubTran$Effect$none);
					}
				case 'FactorInvoiceAuditBatchPageInitDataLoaded':
					var documentBatchId = msg.a;
					var maybeOnDone = msg.b;
					var initDataResult = msg.c;
					if (initDataResult.$ === 'Ok') {
						if (initDataResult.a.$ === 'Just') {
							var initData = initDataResult.a.a;
							var _v11 = A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Main$FactorInvoiceAuditBatchPage,
								$author$project$HubTran$Effect$map($author$project$Main$FactorInvoiceAuditBatchPageMsg),
								$author$project$Components$FactorInvoiceAuditBatchPage$init(initData));
							var newPage = _v11.a;
							var pageEffect = _v11.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{page: newPage}),
								A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
						} else {
							var _v12 = initDataResult.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{page: $author$project$Main$BlankPage}),
								$author$project$HubTran$Effect$load(
									A2($author$project$Main$indexerFallbackUrl, documentBatchId, maybeOnDone)));
						}
					} else {
						var error = initDataResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									page: $author$project$Main$LoadingFailedPage(error)
								}),
							$author$project$HubTran$Effect$none);
					}
				case 'NonInvoiceConfirmPageInitDataLoaded':
					var initDataResult = msg.a;
					if (initDataResult.$ === 'Ok') {
						var initData = initDataResult.a;
						var _v14 = A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Main$NonInvoiceConfirmPage,
							$author$project$HubTran$Effect$map($author$project$Main$NonInvoiceConfirmPageMsg),
							$author$project$Components$NonInvoiceConfirmPage$init(initData));
						var newPage = _v14.a;
						var pageEffect = _v14.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{page: newPage}),
							A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
					} else {
						var error = initDataResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									page: $author$project$Main$LoadingFailedPage(error)
								}),
							$author$project$HubTran$Effect$none);
					}
				case 'LtlReconcileInvoicePageInitDataLoaded':
					var initDataResult = msg.a;
					if (initDataResult.$ === 'Ok') {
						var initData = initDataResult.a;
						var _v16 = A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Main$LtlReconcileInvoicePage,
							$author$project$HubTran$Effect$map($author$project$Main$LtlReconcileInvoicePageMsg),
							$author$project$Components$LtlReconcileInvoicePage$init(initData));
						var newPage = _v16.a;
						var pageEffect = _v16.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{page: newPage}),
							A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
					} else {
						var error = initDataResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									page: $author$project$Main$LoadingFailedPage(error)
								}),
							$author$project$HubTran$Effect$none);
					}
				case 'DocumentsViewerPopoutPageInitDataLoaded':
					var initDataResult = msg.a;
					if (initDataResult.$ === 'Ok') {
						var initData = initDataResult.a;
						var _v18 = A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Main$DocumentsViewerPopoutPage,
							$author$project$HubTran$Effect$map($author$project$Main$DocumentsViewerPopoutPageMsg),
							$author$project$Broker$Page$DocumentsViewerPopout$init(initData));
						var newPage = _v18.a;
						var pageEffect = _v18.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{page: newPage}),
							A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
					} else {
						var error = initDataResult.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									page: $author$project$Main$LoadingFailedPage(error)
								}),
							$author$project$HubTran$Effect$none);
					}
				case 'PageMsg':
					var pageMsg = msg.a;
					var _v19 = A4($author$project$Main$updatePage, model, remoteData, pageMsg, model.page);
					var newPage = _v19.a;
					var pageEffect = _v19.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{page: newPage}),
						A2($author$project$HubTran$Effect$map, $author$project$Main$PageMsg, pageEffect));
				case 'FlashComponentMsg':
					var childMsg = msg.a;
					var _v20 = A2($author$project$Components$Flash$update, childMsg, model.flash);
					var newFlashModel = _v20.a;
					var childEffect = _v20.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{flash: newFlashModel}),
						A2($author$project$HubTran$Effect$map, $author$project$Main$FlashComponentMsg, childEffect));
				case 'FlashFromJavascriptMaybeV3Reskin':
					var flashMessage = msg.a;
					var useV3ReskinError = A2(
						$elm$core$List$any,
						$elm$core$Basics$identity,
						_List_fromArray(
							[model.headerFlags.reskinVals.settings, model.headerFlags.reskinVals.queues]));
					var isVectorWorkflowPage = function () {
						var _v21 = model.page;
						switch (_v21.$) {
							case 'FactorInvoiceAuditPage':
								return true;
							case 'FactorInvoiceAuditBatchPage':
								return true;
							case 'FactorInvoiceAuditBatchGroupingPage':
								return true;
							case 'CarrierInvoiceAuditPage':
								return true;
							default:
								return false;
						}
					}();
					return _Utils_Tuple2(
						model,
						(useV3ReskinError || isVectorWorkflowPage) ? $author$project$HubTran$Effect$cmd(
							$author$project$Js$flashToJavascriptV3Reskin(flashMessage)) : $author$project$HubTran$Effect$cmd(
							$author$project$Js$flashToJavascriptLegacy(flashMessage)));
				case 'HeaderMsg':
					var headerMsg = msg.a;
					var _v22 = A2($author$project$Ui$V3$Header$update, headerMsg, model.header);
					var newHeader = _v22.a;
					var cmd = _v22.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{header: newHeader}),
						$author$project$HubTran$Effect$cmd(
							A2($elm$core$Platform$Cmd$map, $author$project$Main$HeaderMsg, cmd)));
				case 'OpenBeamer':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{beamerMessageCount: 0}),
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$openBeamer(_Utils_Tuple0)));
				case 'BeamerMessageCount':
					var messageCount = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{beamerMessageCount: messageCount}),
						$author$project$HubTran$Effect$none);
				case 'UpdateHeaderFlags':
					var headerFlags = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{headerFlags: headerFlags}),
						$author$project$HubTran$Effect$cmd($author$project$Main$getHeaderViewport));
				case 'ClickedHeaderNavLink':
					var path = msg.a;
					return _Utils_Tuple2(
						$author$project$Main$resetHeaderSearch(model),
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$navigateToReactPath(path)));
				case 'ChangeSearch':
					var newSearch = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{headerSearchRemote: $elm$core$Maybe$Nothing, headerSearchTerm: newSearch}),
						$author$project$HubTran$Effect$none);
				case 'Search':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								headerSearchRemote: $elm$core$Maybe$Just($author$project$Forward$Remote$Loading)
							}),
						$author$project$HubTran$Effect$cmd(
							$elm$http$Http$get(
								{
									expect: A2($elm$http$Http$expectJson, $author$project$Main$GotSearchItems, $author$project$Domain$LoadSearch$decode),
									url: $author$project$Main$searchEndpoint(model) + ('?reference=' + model.headerSearchTerm)
								})));
				case 'GotSearchItems':
					var result = msg.a;
					if (result.$ === 'Ok') {
						var loadSearch = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									headerSearchRemote: $elm$core$Maybe$Just(
										$author$project$Forward$Remote$Loaded(loadSearch))
								}),
							$author$project$HubTran$Effect$cmd($author$project$Main$getHeaderViewport));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{headerSearchRemote: $elm$core$Maybe$Nothing}),
							$author$project$HubTran$Effect$flash(
								$author$project$HubTran$Flash$alert('An unexpected error occurred. Please try again.')));
					}
				case 'ClickedSearchItem':
					var path = msg.a;
					var clickData = msg.b;
					return (!clickData.button) ? ((clickData.metaKey || clickData.ctrlKey) ? _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$openUrlInNewTab(path))) : _Utils_Tuple2(
						$author$project$Main$resetHeaderSearch(model),
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$navigateToReactPath(path)))) : _Utils_Tuple2(model, $author$project$HubTran$Effect$none);
				case 'GotHeaderElement':
					var elResult = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								headerElement: $elm$core$Result$toMaybe(elResult)
							}),
						$author$project$HubTran$Effect$none);
				case 'DismissSearchResults':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{headerSearchRemote: $elm$core$Maybe$Nothing}),
						$author$project$HubTran$Effect$none);
				case 'ViewportChanged':
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$cmd($author$project$Main$getHeaderViewport));
				case 'SwitchUser':
					var userId = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$switchGroupUserAccount(userId)));
				case 'ToggleReskinUser':
					var enabled = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$HubTran$Effect$cmd(
							$author$project$Js$toggleReskinUser(enabled)));
				case 'LtlHeldSubmissionsPageInitDataLoaded':
					var initDataResult = msg.a;
					return $author$project$Main$initDataLoaded(
						{initDataResult: initDataResult, model: model, page: $author$project$Main$LtlHeldSubmissionsPage, pageInit: $author$project$Components$LtlHeldSubmissionsPage$init, pageMsg: $author$project$Main$LtlHeldSubmissionsPageMsg});
				default:
					var initDataResult = msg.a;
					return $author$project$Main$initDataLoaded(
						{initDataResult: initDataResult, model: model, page: $author$project$Main$ReadonlyFactorInvoicePage, pageInit: $author$project$Components$ReadonlyFactorInvoicePage$init, pageMsg: $author$project$Main$ReadonlyFactorInvoicePageMsg});
			}
		}
	});
var $author$project$Ui$V3$Colors$BackgroundNeutralScrim = {$: 'BackgroundNeutralScrim'};
var $author$project$Main$ChangeSearch = function (a) {
	return {$: 'ChangeSearch', a: a};
};
var $author$project$Main$ClickedHeaderNavLink = function (a) {
	return {$: 'ClickedHeaderNavLink', a: a};
};
var $author$project$Main$DismissSearchResults = {$: 'DismissSearchResults'};
var $author$project$Components$Flash$MarkForRemoval = function (a) {
	return {$: 'MarkForRemoval', a: a};
};
var $author$project$Main$OpenBeamer = {$: 'OpenBeamer'};
var $author$project$Main$Search = {$: 'Search'};
var $author$project$Main$SwitchUser = function (a) {
	return {$: 'SwitchUser', a: a};
};
var $author$project$Main$ToggleReskinUser = function (a) {
	return {$: 'ToggleReskinUser', a: a};
};
var $author$project$Ui$V3$Header$Hidden = {$: 'Hidden'};
var $author$project$Ui$V3$Header$Selected = {$: 'Selected'};
var $author$project$Ui$V3$Header$Visible = {$: 'Visible'};
var $author$project$Ui$V3$Icon$auditQueue16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$d('M14.333 0H1.667A1.667 1.667 0 0 0 0 1.667v12.666A1.666 1.666 0 0 0 1.667 16h12.666A1.666 1.666 0 0 0 16 14.333V1.667A1.666 1.666 0 0 0 14.333 0Zm-2 6.333h-3a.667.667 0 1 1 0-1.333h3a.667.667 0 1 1 0 1.333ZM13 11.667a.667.667 0 0 1-.667.666h-3a.667.667 0 1 1 0-1.333h3a.666.666 0 0 1 .667.667ZM7.533 3.733l-2 2.667a.667.667 0 0 1-1.006.073l-1-1a.67.67 0 1 1 .946-.946l.454.46 1.54-2.054a.667.667 0 1 1 1.066.8Zm0 6.667-2 2.667a.667.667 0 0 1-1.006.073l-1-1a.67.67 0 1 1 .946-.947l.454.46L6.467 9.6a.667.667 0 1 1 1.066.8Z')
			]),
		_List_Nil));
var $author$project$Ui$V3$Icon$dataBar16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$d('M2.667 16h10.666a1.334 1.334 0 0 0 1.334-1.333V4.22a1.334 1.334 0 0 0-.394-.947l-2.88-2.88A1.334 1.334 0 0 0 10.447 0h-7.78a1.333 1.333 0 0 0-1.334 1.333v13.334A1.333 1.333 0 0 0 2.667 16Zm6.666-8a.333.333 0 0 1 .334-.333h.666a.333.333 0 0 1 .334.333v3.333a.333.333 0 0 1-.334.334h-.666a.333.333 0 0 1-.334-.334V8ZM7 6.667a.333.333 0 0 1 .333-.334H8a.333.333 0 0 1 .333.334v4.666a.333.333 0 0 1-.333.334h-.667A.333.333 0 0 1 7 11.333V6.667Zm-2.333 3A.333.333 0 0 1 5 9.333h.667A.333.333 0 0 1 6 9.667v1.666a.333.333 0 0 1-.333.334H5a.333.333 0 0 1-.333-.334V9.667Z')
			]),
		_List_Nil));
var $author$project$Ui$V3$Icon$document16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M13.666 4.2455C13.666 3.87455 13.5188 3.51876 13.2567 3.25626L10.4244 0.419866C10.1621 0.157198 9.80621 0.00944925 9.43501 0.00910459L1.73432 0.00195374C0.96061 0.00123596 0.333016 0.628247 0.333016 1.40195L0.333008 14.6007C0.333008 15.3739 0.959809 16.0007 1.73301 16.0007L12.266 16.0007C13.0392 16.0007 13.666 15.3739 13.666 14.6007L13.666 4.2455ZM10.6072 6.08229C10.6072 5.86138 10.4281 5.68229 10.2072 5.68229L3.79135 5.68229C3.57043 5.68229 3.39134 5.86138 3.39134 6.08229L3.39134 6.60944C3.39134 6.83035 3.57043 7.00944 3.79134 7.00944L10.2072 7.00944C10.4281 7.00944 10.6072 6.83035 10.6072 6.60944V6.08229ZM10.2072 8.02018C10.4281 8.02018 10.6072 8.19927 10.6072 8.42018V8.94733C10.6072 9.16824 10.4281 9.34733 10.2072 9.34733L3.79134 9.34733C3.57043 9.34733 3.39134 9.16824 3.39134 8.94733L3.39134 8.42018C3.39134 8.19927 3.57043 8.02018 3.79135 8.02018L10.2072 8.02018ZM6.19701 10.7581C6.19701 10.5372 6.01792 10.3581 5.79701 10.3581H3.79131C3.5704 10.3581 3.39131 10.5372 3.39131 10.7581L3.39131 11.2852C3.39131 11.5061 3.5704 11.6852 3.79131 11.6852H5.79701C6.01792 11.6852 6.19701 11.5061 6.19701 11.2852L6.19701 10.7581Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$moneyFill16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$d('M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm.973 12.393a.167.167 0 0 0-.14.16v.514a.833.833 0 0 1-1.666 0v-.474A.166.166 0 0 0 7 12.427h-.767a.833.833 0 1 1 0-1.667h2.394a.747.747 0 0 0 .28-1.427l-2.427-.98a2.4 2.4 0 0 1 .547-4.613.167.167 0 0 0 .14-.167v-.506a.833.833 0 1 1 1.666 0v.466A.167.167 0 0 0 9 3.7h.767a.833.833 0 0 1 0 1.667H7.373a.747.747 0 0 0-.28 1.44l2.427.973a2.4 2.4 0 0 1-.547 4.613Z')
			]),
		_List_Nil));
var $author$project$Ui$V3$Icon$user16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$d('M7.99 0a7.99 7.99 0 1 0 0 15.98A7.99 7.99 0 0 0 7.99 0Zm4.987 12.145a6.492 6.492 0 0 1-9.987 0 .153.153 0 0 1 0-.14.173.173 0 0 1 .08-.113 22.499 22.499 0 0 1 2.663-1.112l.453-.167c.14-.046.253-.226.313-.479a1.458 1.458 0 0 0-.16-1.165c-.56-.62-1.106-1.378-1.106-3.276a2.664 2.664 0 0 1 2.757-2.93 2.663 2.663 0 0 1 2.757 2.93c0 1.897-.546 2.663-1.106 3.276a1.431 1.431 0 0 0-.166 1.165.665.665 0 0 0 .32.48l.446.166c.91.312 1.8.683 2.663 1.112a.174.174 0 0 1 .08.113.153.153 0 0 1-.007.14Z')
			]),
		_List_Nil));
var $author$project$Ui$V3$Header$auditDropdownPages = function (visibleDropdownPages) {
	var maybePage = F4(
		function (visibility, icon, title, url) {
			switch (visibility.$) {
				case 'Hidden':
					return $elm$core$Maybe$Nothing;
				case 'Visible':
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							icon,
							{isCurrent: false, title: title, url: url}));
				default:
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							icon,
							{isCurrent: true, title: title, url: url}));
			}
		});
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A4(maybePage, visibleDropdownPages.payables, $author$project$Ui$V3$Icon$auditQueue16, 'Payables', '/app/dashboard'),
				A4(maybePage, visibleDropdownPages.receivables, $author$project$Ui$V3$Icon$moneyFill16, 'Receivables', '/customer_invoicing'),
				A4(maybePage, visibleDropdownPages.ltlDocRetrieval, $author$project$Ui$V3$Icon$document16, 'LTL doc retrieval', '/app/to_be_scraped_loads'),
				A4(maybePage, visibleDropdownPages.customerRep, $author$project$Ui$V3$Icon$user16, 'Customer rep', '/customer_representative'),
				A4(maybePage, visibleDropdownPages.insights, $author$project$Ui$V3$Icon$dataBar16, 'Insights', '/insights_dashboard')
			]));
};
var $author$project$Main$noaManagementUrl = '/app/noa_management';
var $author$project$Main$onNoaManagementPage = function (model) {
	var _v0 = model.location;
	if (_v0.$ === 'Just') {
		var url = _v0.a;
		return A2($elm$core$String$startsWith, $author$project$Main$noaManagementUrl, url.path);
	} else {
		return false;
	}
};
var $author$project$Ui$V3$Icon$sendMessage16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth('0.1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.6399 0.159818C15.5352 0.076009 15.409 0.0234221 15.2757 0.00809257C15.1425 -0.00723698 15.0076 0.015312 14.8866 0.0731518L0.846571 7.39982C0.644035 7.51 0.473532 7.67081 0.351708 7.86656C0.229884 8.06232 0.160903 8.28631 0.1515 8.51669C0.142097 8.74706 0.192594 8.97593 0.298059 9.18096C0.403525 9.38599 0.560355 9.56017 0.753237 9.68649L4.71324 12.1798V14.9265C4.71599 15.1222 4.77612 15.3128 4.88618 15.4747C4.99624 15.6366 5.15139 15.7626 5.33239 15.8371C5.51339 15.9116 5.71229 15.9314 5.90442 15.894C6.09655 15.8565 6.27347 15.7635 6.41324 15.6265L7.87324 14.1665L10.4599 15.7932C10.6375 15.9039 10.8387 15.9712 11.0472 15.9897C11.2556 16.0083 11.4655 15.9775 11.6599 15.8998C11.8535 15.8201 12.0257 15.6958 12.1623 15.5371C12.299 15.3784 12.3964 15.1898 12.4466 14.9865L15.8466 0.819818C15.8685 0.701295 15.8611 0.579214 15.8251 0.46419C15.7891 0.349165 15.7255 0.24468 15.6399 0.159818ZM11.5332 3.33315C11.5675 3.31439 11.6073 3.30878 11.6454 3.31738C11.6835 3.32597 11.7171 3.34818 11.7399 3.37982C11.7661 3.40915 11.7806 3.44713 11.7806 3.48649C11.7806 3.52584 11.7661 3.56382 11.7399 3.59315L5.33324 10.8398C5.3039 10.8661 5.26593 10.8806 5.22657 10.8806C5.18721 10.8806 5.14924 10.8661 5.1199 10.8398L1.72657 8.72649C1.70225 8.71093 1.6826 8.68908 1.66969 8.66326C1.65678 8.63744 1.65109 8.60861 1.65324 8.57982C1.65383 8.54998 1.66213 8.5208 1.67731 8.4951C1.69249 8.46941 1.71405 8.44807 1.7399 8.43315L11.5332 3.33315ZM6.04657 14.1065V13.0198L6.71324 13.4398L6.04657 14.1065ZM11.2266 14.4398C11.2195 14.465 11.2069 14.4883 11.1896 14.508C11.1723 14.5276 11.1507 14.543 11.1266 14.5532C11.1027 14.5649 11.0765 14.571 11.0499 14.571C11.0233 14.571 10.9971 14.5649 10.9732 14.5532L6.56657 11.7665C6.54442 11.7546 6.52553 11.7374 6.51158 11.7165C6.49763 11.6956 6.48904 11.6715 6.48657 11.6465C6.48323 11.6227 6.48508 11.5985 6.49198 11.5754C6.49889 11.5524 6.51069 11.5312 6.52657 11.5132L13.4866 3.61982C13.51 3.59092 13.5429 3.57112 13.5794 3.56382C13.6159 3.55652 13.6538 3.56218 13.6866 3.57982C13.7191 3.59759 13.745 3.6253 13.7606 3.6589C13.7762 3.69249 13.7806 3.73019 13.7732 3.76649L11.2266 14.4398Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('0.1')
					]),
				_List_Nil)
			])));
var $author$project$Main$headerDropdownPages = function (model) {
	var visiblePages = model.headerFlags.headerDropdownPages;
	var toVisibility = F2(
		function (check, maybeUrlForSelected) {
			if (check) {
				if (maybeUrlForSelected.$ === 'Just') {
					var url = maybeUrlForSelected.a;
					return A2($elm$core$String$contains, url, model.headerFlags.dashboardLinkLocation) ? $author$project$Ui$V3$Header$Selected : $author$project$Ui$V3$Header$Visible;
				} else {
					return $author$project$Ui$V3$Header$Visible;
				}
			} else {
				return $author$project$Ui$V3$Header$Hidden;
			}
		});
	var splitPoint = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			$elm$core$Basics$identity,
			_List_fromArray(
				[visiblePages.payables, visiblePages.receivables])));
	var onNoaPage = $author$project$Main$onNoaManagementPage(model);
	var urlForSelected = function (url) {
		return onNoaPage ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(url);
	};
	var noaManagementPages = visiblePages.noaManagement ? _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Ui$V3$Icon$sendMessage16,
			{
				isCurrent: $author$project$Main$onNoaManagementPage(model),
				title: 'NOA Management',
				url: $author$project$Main$noaManagementUrl
			})
		]) : _List_Nil;
	var auditPages = $author$project$Ui$V3$Header$auditDropdownPages(
		{
			customerRep: A2(toVisibility, visiblePages.customerRep, $elm$core$Maybe$Nothing),
			insights: A2(toVisibility, visiblePages.insights, $elm$core$Maybe$Nothing),
			ltlDocRetrieval: A2(
				toVisibility,
				visiblePages.ltlDocRetrieval,
				urlForSelected('to_be_scraped_loads')),
			payables: A2(
				toVisibility,
				visiblePages.payables,
				urlForSelected('dashboard')),
			receivables: A2(toVisibility, visiblePages.receivables, $elm$core$Maybe$Nothing)
		});
	return _Utils_ap(
		A2($elm$core$List$take, splitPoint, auditPages),
		_Utils_ap(
			noaManagementPages,
			A2($elm$core$List$drop, splitPoint, auditPages)));
};
var $author$project$Ui$V3$Icon$loader16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$d('M8 4.333a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1Zm-2.487-.26L4.1 2.667a1.02 1.02 0 0 0-1.433 0 .986.986 0 0 0 0 1.406L4.1 5.487a1 1 0 1 0 1.413-1.414ZM.333 8a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-2a1 1 0 0 0-1 1Zm4.334 2.347a.987.987 0 0 0-.734.32l-1.42 1.386a1.007 1.007 0 0 0 0 1.414 1.007 1.007 0 0 0 1.42 0l1.4-1.414a1 1 0 0 0-.666-1.706ZM7 14.667a1 1 0 1 0 2 0v-2a1 1 0 0 0-2 0v2Zm3.7-4a1 1 0 0 0 0 1.413l1.413 1.413c.188.187.442.292.707.294.267-.002.523-.107.713-.294.185-.188.288-.442.287-.706a.987.987 0 0 0-.293-.714l-1.414-1.406a1 1 0 0 0-1.413 0ZM15.667 8a1 1 0 0 0-1-1h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1Zm-3.001-5.727c-.25.012-.488.117-.666.294L10.573 4a1 1 0 0 0 .71 1.706c.266 0 .522-.105.71-.293L13.406 4a1 1 0 0 0-.74-1.727Z')
			]),
		_List_Nil));
var $author$project$Main$ClickedSearchItem = F2(
	function (a, b) {
		return {$: 'ClickedSearchItem', a: a, b: b};
	});
var $author$project$Decode$ClickData$ClickData = F3(
	function (button, metaKey, ctrlKey) {
		return {button: button, ctrlKey: ctrlKey, metaKey: metaKey};
	});
var $author$project$Decode$ClickData$clickDataDecoder = A2(
	$author$project$Helpers$Json$Decode$apply,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['ctrlKey']),
		$elm$json$Json$Decode$bool),
	A2(
		$author$project$Helpers$Json$Decode$apply,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['metaKey']),
			$elm$json$Json$Decode$bool),
		A2(
			$author$project$Helpers$Json$Decode$apply,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['button']),
				$elm$json$Json$Decode$int),
			$elm$json$Json$Decode$succeed($author$project$Decode$ClickData$ClickData))));
var $author$project$Domain$TmsLoadId$toString = function (_v0) {
	var _int = _v0.a;
	return $elm$core$String$fromInt(_int);
};
var $author$project$Main$clickedSearchItemPath = F2(
	function (loadState, model) {
		var onDoneKey = 'onDone';
		var onDone = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'/app/dashboard',
			function (location) {
				return A2(
					$elm$core$Maybe$withDefault,
					location.path,
					$elm_community$maybe_extra$Maybe$Extra$join(
						A2(
							$elm$url$Url$Parser$parse,
							$elm$url$Url$Parser$query(
								$elm$url$Url$Parser$Query$string(onDoneKey)),
							_Utils_update(
								location,
								{path: ''}))));
			},
			model.location);
		var maybeEmailId = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2(
				$elm$core$Maybe$map,
				$author$project$Domain$EmailMessageId$toInt,
				$elm$core$List$head(loadState.emailIds)));
		var factorInvoiceId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				A2(
					$elm$core$Maybe$map,
					$author$project$Domain$FactorInvoiceId$toInt,
					$elm$core$List$head(loadState.factorInvoiceIds))));
		var path = function () {
			var _v0 = _Utils_Tuple2(model.headerFlags.useSubmissionWorkflow, maybeEmailId);
			if (_v0.a && (_v0.b.$ === 'Just')) {
				var emailId = _v0.b.a;
				return 'client_submission/email/' + (emailId + ('/invoice/' + factorInvoiceId));
			} else {
				return model.headerFlags.isFactor ? ('factor_invoices/' + factorInvoiceId) : ('loads/' + $author$project$Domain$TmsLoadId$toString(loadState.id));
			}
		}();
		return A2(
			$elm$url$Url$Builder$absolute,
			_List_fromArray(
				['app', path]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, onDoneKey, onDone)
				]));
	});
var $author$project$Ui$V3$Table$FooterAttribute = function (a) {
	return {$: 'FooterAttribute', a: a};
};
var $author$project$Ui$V3$Table$footer = $author$project$Ui$V3$Table$FooterAttribute;
var $author$project$Ui$V3$Table$LinkableRowAttribute = function (a) {
	return {$: 'LinkableRowAttribute', a: a};
};
var $author$project$Ui$V3$Table$linkableRowAttrs = function (linkAttrs) {
	return $author$project$Ui$V3$Table$LinkableRowAttribute(linkAttrs);
};
var $author$project$Ui$V3$Table$MaxHeightAttribute = function (a) {
	return {$: 'MaxHeightAttribute', a: a};
};
var $author$project$Ui$V3$Table$maxHeight = function (value) {
	return $author$project$Ui$V3$Table$MaxHeightAttribute(value);
};
var $author$project$Ui$V3$Table$Dark = {$: 'Dark'};
var $author$project$Ui$V3$Table$StyleAttribute = function (a) {
	return {$: 'StyleAttribute', a: a};
};
var $author$project$Ui$V3$Table$styleDark = $author$project$Ui$V3$Table$StyleAttribute($author$project$Ui$V3$Table$Dark);
var $author$project$Main$searchResultsToTable = F2(
	function (model, loadSearch) {
		var toAddress = F4(
			function (city, state, postalCode, name) {
				return ((city === '') && (state === '')) ? name : A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							A2(
							$elm$core$String$join,
							', ',
							_List_fromArray(
								[city, state])),
							postalCode
						]));
			});
		var tmsShipmentExternalIdById = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (tmsShipment) {
					return _Utils_Tuple2(
						$author$project$Domain$TmsShipmentId$toInt(tmsShipment.id),
						tmsShipment.externalId);
				},
				loadSearch.tmsShipments));
		var maxHeightAttrs = function () {
			var _v0 = model.headerElement;
			if (_v0.$ === 'Just') {
				var el = _v0.a;
				return _List_fromArray(
					[
						$author$project$Ui$V3$Table$maxHeight(
						$elm$core$Basics$round((el.viewport.height - (el.element.y + el.element.height)) - (2 * 8)))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var heading = function (str) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(str)
					]));
		};
		var footerAttrs = $elm$core$List$isEmpty(loadSearch.loads) ? _List_fromArray(
			[
				$author$project$Ui$V3$Table$footer(
				_List_fromArray(
					[
						_Utils_Tuple2(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(6),
								A2($elm$html$Html$Attributes$style, 'text-align', 'center')
							]),
						$elm$html$Html$text('Your search – ' + (model.headerSearchTerm + ' – did not match any loads')))
					]))
			]) : _List_Nil;
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_Nil,
						content: function (load) {
							return $elm$html$Html$text(load.load.loadId);
						},
						heading: heading('Load')
					},
						{
						attrs: _List_Nil,
						content: function (load) {
							var tmsShipmentExternalIds = A2(
								$elm$core$List$filterMap,
								function (id) {
									return A2($elm$core$Dict$get, id, tmsShipmentExternalIdById);
								},
								A2($elm$core$List$map, $author$project$Domain$TmsShipmentId$toInt, load.load.tmsShipmentIds));
							var strLines = ($elm$core$List$length(tmsShipmentExternalIds) < 3) ? tmsShipmentExternalIds : $elm$core$List$concat(
								_List_fromArray(
									[
										A2($elm$core$List$take, 2, tmsShipmentExternalIds),
										_List_fromArray(
										[
											$elm$core$String$concat(
											_List_fromArray(
												[
													' plus ',
													$elm$core$String$fromInt(
													$elm$core$List$length(tmsShipmentExternalIds) - 2),
													' more'
												]))
										])
									]));
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (str) {
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(str)
												]));
									},
									strLines));
						},
						heading: heading('Shipment')
					},
						{
						attrs: _List_Nil,
						content: function (load) {
							return $elm$html$Html$text(load.invoiceNumber);
						},
						heading: heading('Invoice')
					},
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.load;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.carrier;
								},
								A2(
									$elm$core$Basics$composeR,
									A2(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										'',
										function ($) {
											return $.name;
										}),
									$elm$html$Html$text))),
						heading: heading('Carrier')
					},
						{
						attrs: _List_Nil,
						content: function (load) {
							return $elm$html$Html$text(
								A4(toAddress, load.load.originCity, load.load.originState, load.load.originPostalCode, load.load.originName));
						},
						heading: heading('Origin')
					},
						{
						attrs: _List_Nil,
						content: function (load) {
							return $elm$html$Html$text(
								A4(toAddress, load.load.destinationCity, load.load.destinationState, load.load.destinationPostalCode, load.load.destinationName));
						},
						heading: heading('Destination')
					}
					])
			},
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Ui$V3$Table$styleDark,
						$author$project$Ui$V3$Table$linkableRowAttrs(
						function (row) {
							return $elm$core$Maybe$Just(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$Events$preventDefaultOn,
										'click',
										A2(
											$elm$json$Json$Decode$map,
											function (msg) {
												return _Utils_Tuple2(msg, true);
											},
											A2(
												$elm$json$Json$Decode$map,
												function (cd) {
													return A2(
														$author$project$Main$ClickedSearchItem,
														A2($author$project$Main$clickedSearchItemPath, row, model),
														cd);
												},
												$author$project$Decode$ClickData$clickDataDecoder))),
										$elm$html$Html$Attributes$href(
										A2($author$project$Main$clickedSearchItemPath, row, model))
									]));
						})
					]),
				_Utils_ap(maxHeightAttrs, footerAttrs)),
			_List_Nil,
			loadSearch.loads);
	});
var $author$project$Ui$V3$Icon$Spin = {$: 'Spin'};
var $author$project$Ui$V3$Icon$spin = $author$project$Ui$V3$Icon$Spin;
var $author$project$Main$useV3ContainerStyles = F2(
	function (model, data) {
		var topLevelPageReskinned = model.headerFlags.reskinVals.topLevel;
		var settingsPageReskinned = model.headerFlags.reskinVals.settings;
		var queuesPageReskinned = model.headerFlags.reskinVals.queues;
		var auditPageReskinned = model.headerFlags.reskinVals.indexAudit;
		switch (data.$) {
			case 'SettingsCarrierPageData':
				return settingsPageReskinned;
			case 'SettingsCarriersPageData':
				return settingsPageReskinned;
			case 'SettingsCustomerPageData':
				return settingsPageReskinned;
			case 'SettingsCustomersPageData':
				return settingsPageReskinned;
			case 'SettingsDebtorPageData':
				return settingsPageReskinned;
			case 'SettingsPageData':
				return settingsPageReskinned;
			case 'SettingsReferenceFieldsPageData':
				return settingsPageReskinned;
			case 'SettingsReportsPageData':
				return settingsPageReskinned;
			case 'SettingsRulesPageData':
				return settingsPageReskinned;
			case 'SettingsUserPageData':
				return settingsPageReskinned;
			case 'SettingsUsersPageData':
				return settingsPageReskinned;
			case 'SettingsVerificationsPageData':
				return settingsPageReskinned;
			case 'ActivityPageData':
				return topLevelPageReskinned;
			case 'EmailMessageSearchPageData':
				return topLevelPageReskinned;
			case 'DashboardPageData':
				return queuesPageReskinned;
			case 'HelpPageData':
				return true;
			case 'LtlHeldSubmissionsPageData':
				return true;
			case 'CarrierInvoiceAuditPageData':
				return true;
			case 'FactorInvoiceAuditPageData':
				return true;
			case 'FactorInvoiceAuditBatchGroupingPageData':
				return true;
			case 'FactorInvoiceAuditBatchPageData':
				return true;
			case 'MyClientsOverviewPageData':
				return true;
			case 'NoaManagementToSendPageData':
				return true;
			case 'DebtorChangesPageData':
				return true;
			case 'DebtorChangesTemplatePageData':
				return true;
			case 'NoaManagementSentPageData':
				return true;
			case 'NoaManagementSkippedPageData':
				return true;
			case 'BrokerBillingRequirementsPageData':
				return auditPageReskinned;
			default:
				return false;
		}
	});
var $author$project$Ui$V3$Notification$ErrorLevel = {$: 'ErrorLevel'};
var $author$project$Ui$V3$Notification$error = $author$project$Ui$V3$Notification$AlertLevelAttribute($author$project$Ui$V3$Notification$ErrorLevel);
var $ianmackenzie$elm_units$Duration$from = F2(
	function (startTime, endTime) {
		var numMilliseconds = $elm$time$Time$posixToMillis(endTime) - $elm$time$Time$posixToMillis(startTime);
		return $ianmackenzie$elm_units$Duration$milliseconds(numMilliseconds);
	});
var $author$project$Ui$V3$Flash$getTimeSinceMessage = F2(
	function (message, modelCurrentTime) {
		var messageTime = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$millisToPosix(0),
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $elm$core$Basics$round, $elm$time$Time$millisToPosix),
				message.time));
		var currentTime = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$millisToPosix(0),
			modelCurrentTime);
		return A2($ianmackenzie$elm_units$Duration$from, messageTime, currentTime);
	});
var $author$project$Ui$V3$Flash$fadeOutTime = $ianmackenzie$elm_units$Duration$milliseconds(9700.0);
var $author$project$Ui$V3$Flash$shouldFadeIn = F2(
	function (timeSinceMessage, message) {
		var delta = $ianmackenzie$elm_units$Duration$inMilliseconds(timeSinceMessage);
		return ((delta > 0) && (_Utils_cmp(
			delta,
			$ianmackenzie$elm_units$Duration$inMilliseconds($author$project$Ui$V3$Flash$fadeOutTime)) < 0)) || ((delta > 0) && message.indefinite);
	});
var $author$project$Ui$V3$Notification$SuccessLevel = {$: 'SuccessLevel'};
var $author$project$Ui$V3$Notification$success = $author$project$Ui$V3$Notification$AlertLevelAttribute($author$project$Ui$V3$Notification$SuccessLevel);
var $author$project$Ui$V3$Notification$viewToast = F2(
	function (_v0, attributes) {
		var onClose = _v0.onClose;
		var message = _v0.message;
		var title = _v0.title;
		var computedAttributes = $author$project$Ui$V3$Notification$computeAttributes(attributes);
		return $author$project$Ui$V3$Notification$view(
			{
				actionButton: $elm$core$Maybe$Nothing,
				computedAttributes: computedAttributes,
				message: message,
				onClose: onClose,
				style: 'toast',
				title: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Ui$V3$Notification$WarningLevel = {$: 'WarningLevel'};
var $author$project$Ui$V3$Notification$warning = $author$project$Ui$V3$Notification$AlertLevelAttribute($author$project$Ui$V3$Notification$WarningLevel);
var $author$project$Ui$V3$Flash$viewMesssage = F3(
	function (model, markForRemoval, message) {
		var titleWithDefault = function (_default) {
			return A2($elm$core$Maybe$withDefault, _default, message.title);
		};
		var timeSinceMessage = A2($author$project$Ui$V3$Flash$getTimeSinceMessage, message, model.currentTime);
		var _v0 = function () {
			var _v1 = message.level;
			switch (_v1) {
				case 'warning':
					return _Utils_Tuple2(
						$author$project$Ui$V3$Notification$warning,
						titleWithDefault('Warning'));
				case 'alert':
					return _Utils_Tuple2(
						$author$project$Ui$V3$Notification$error,
						titleWithDefault('Error'));
				case 'success':
					return _Utils_Tuple2(
						$author$project$Ui$V3$Notification$success,
						titleWithDefault('Success'));
				default:
					return _Utils_Tuple2(
						$author$project$Ui$V3$Notification$info,
						titleWithDefault('Info'));
			}
		}();
		var style = _v0.a;
		var title = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__flash-message'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'v3__flash-message--active',
							A2($author$project$Ui$V3$Flash$shouldFadeIn, timeSinceMessage, message))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Notification$viewToast,
					{
						message: $elm$html$Html$text(message.message),
						onClose: $elm$core$Maybe$Just(markForRemoval),
						title: title
					},
					_List_fromArray(
						[style]))
				]));
	});
var $author$project$Ui$V3$Flash$view = F2(
	function (markForRemoval, model) {
		var viewMessages = function (messages) {
			return $elm$core$List$reverse(
				$elm$core$Array$toList(
					A2(
						$elm$core$Array$indexedMap,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Ui$V3$Flash$viewMesssage(model),
							markForRemoval),
						messages)));
		};
		var topMessages = A2(
			$elm$core$Array$filter,
			function (message) {
				return message.position === 'top';
			},
			model.messages);
		var bottomMessages = A2(
			$elm$core$Array$filter,
			function (message) {
				return message.position !== 'top';
			},
			model.messages);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__flash')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__flash--top')
						]),
					viewMessages(topMessages)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__flash--bottom')
						]),
					viewMessages(bottomMessages))
				]));
	});
var $author$project$Ui$V3$Colors$Gray0 = {$: 'Gray0'};
var $author$project$Ui$V3$Colors$Purple900 = {$: 'Purple900'};
var $author$project$Ui$V3$Stack$BackgroundAttribute = function (a) {
	return {$: 'BackgroundAttribute', a: a};
};
var $author$project$Ui$V3$Stack$BackgroundColor = function (a) {
	return {$: 'BackgroundColor', a: a};
};
var $author$project$Ui$V3$Stack$backgroundColor = function (color) {
	return $author$project$Ui$V3$Stack$BackgroundAttribute(
		$author$project$Ui$V3$Stack$BackgroundColor(color));
};
var $author$project$Ui$V3$Header$linkClickAttrs = function (maybeOnClick) {
	if (maybeOnClick.$ === 'Just') {
		var onClick = maybeOnClick.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$custom,
				'click',
				$elm$json$Json$Decode$succeed(
					function (msg) {
						return {message: msg, preventDefault: true, stopPropagation: true};
					}(onClick)))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$V3$Stack$MainAxisStart = {$: 'MainAxisStart'};
var $author$project$Ui$V3$Stack$mainAxisStart = $author$project$Ui$V3$Stack$MainAxisAttribute($author$project$Ui$V3$Stack$MainAxisStart);
var $author$project$Ui$V3$Stack$PaddingLeftRightTopBottom = F4(
	function (a, b, c, d) {
		return {$: 'PaddingLeftRightTopBottom', a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$V3$Stack$paddingLeftRightTopBottom = F4(
	function (l, r, t, b) {
		return $author$project$Ui$V3$Stack$PaddingAttribute(
			A4($author$project$Ui$V3$Stack$PaddingLeftRightTopBottom, l, r, t, b));
	});
var $author$project$Ui$V3$Header$Button = function (a) {
	return {$: 'Button', a: a};
};
var $author$project$Ui$V3$Header$ToggleAccounts = function (a) {
	return {$: 'ToggleAccounts', a: a};
};
var $author$project$Ui$V3$Colors$Blue600 = {$: 'Blue600'};
var $author$project$Ui$V3$Header$currentSidelineAttrs = function (isUnderlined) {
	var underlineColor = isUnderlined ? $author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Blue600) : 'transparent';
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'padding-left', '7px'),
			A2($elm$html$Html$Attributes$style, 'display', 'inline'),
			A2($elm$html$Html$Attributes$style, 'box-shadow', 'inset 2px 0 ' + underlineColor)
		]);
};
var $author$project$Ui$V3$Stack$HtmlAttribute = function (a) {
	return {$: 'HtmlAttribute', a: a};
};
var $author$project$Ui$V3$Stack$htmlAttribute = function (attr) {
	return $author$project$Ui$V3$Stack$HtmlAttribute(attr);
};
var $author$project$Ui$V3$Header$btnPadding = A2($author$project$Ui$V3$Stack$style, 'padding', '12px');
var $author$project$Ui$V3$Stack$classList = function (classes) {
	return $author$project$Ui$V3$Stack$ClassAttribute(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Ui$V3$Stack$OnEventAttribute = F2(
	function (a, b) {
		return {$: 'OnEventAttribute', a: a, b: b};
	});
var $author$project$Ui$V3$Stack$on = F2(
	function (eventName, eventDecoder) {
		return A2($author$project$Ui$V3$Stack$OnEventAttribute, eventName, eventDecoder);
	});
var $author$project$Ui$V3$Stack$onClickCustom = function (decoder) {
	return A2($author$project$Ui$V3$Stack$on, 'click', decoder);
};
var $author$project$Ui$V3$Stack$onClick = function (msg) {
	return $author$project$Ui$V3$Stack$onClickCustom(
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: false, stopPropagation: false}));
};
var $author$project$Ui$V3$Stack$viewHorzMaybes = F2(
	function (attributes, maybeChildren) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorz,
			attributes,
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeChildren));
	});
var $author$project$Ui$V3$Header$viewDropdown = F6(
	function (_v0, config, toggleMsg, isOpen, label, items) {
		var forAccount = _v0.forAccount;
		var alignRight = _v0.alignRight;
		var onClickAttrs = $elm$core$List$isEmpty(items) ? _List_Nil : _List_fromArray(
			[
				$author$project$Ui$V3$Stack$onClick(
				config.msgMapper(toggleMsg)),
				A2($author$project$Ui$V3$Stack$style, 'cursor', 'pointer'),
				A2($author$project$Ui$V3$Stack$style, 'user-select', 'none')
			]);
		var dropdown = isOpen ? $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Purple900),
						$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXXSmall),
						A2($author$project$Ui$V3$Stack$style, 'box-shadow', '0px 0px 12px 10px rgba(0, 34, 56, 0.16)'),
						A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px'),
						A2($author$project$Ui$V3$Stack$style, 'width', 'max-content'),
						A2($author$project$Ui$V3$Stack$style, 'position', 'absolute'),
						A2($author$project$Ui$V3$Stack$style, 'z-index', '99'),
						A2($author$project$Ui$V3$Stack$style, 'top', '62px'),
						A2($author$project$Ui$V3$Stack$style, 'max-height', 'calc(100vh - 120px)'),
						A2($author$project$Ui$V3$Stack$style, 'overflow-y', 'auto'),
						alignRight ? A2($author$project$Ui$V3$Stack$style, 'right', '0') : A2($author$project$Ui$V3$Stack$style, 'left', '0'),
						forAccount ? $author$project$Ui$V3$Stack$htmlAttribute(
						$elm$html$Html$Attributes$id($author$project$Ui$V3$Header$accountListDomId)) : $author$project$Ui$V3$Stack$class('')
					]),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var attrs = _v1.a;
						var itemLabel = _v1.b;
						var clickAction = _v1.c;
						var node = function () {
							if (clickAction.$ === 'Link') {
								var href = clickAction.a;
								return $elm$html$Html$a(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(href)
										]));
							} else {
								var clickMsg = clickAction.a;
								return $elm$html$Html$div(
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(clickMsg)
										]));
							}
						}();
						return node(
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Stack$viewHorzWithWidths,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Ui$V3$Stack$class(
												forAccount ? 'header__menu-btn header__menu-btn--account' : 'header__menu-btn'),
												A2($author$project$Ui$V3$Stack$style, 'border-radius', '6px'),
												A2($author$project$Ui$V3$Stack$style, 'cursor', 'pointer'),
												$author$project$Ui$V3$Header$btnPadding
											]),
										attrs),
									_List_fromArray(
										[
											_Utils_Tuple2($author$project$Ui$V3$Stack$fit, itemLabel)
										]))
								]));
					},
					items))) : $elm$core$Maybe$Nothing;
		var btn = $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Stack$viewHorz,
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('header__menu-btn', true),
									_Utils_Tuple2('header__menu-btn--open', isOpen)
								])),
							A2($author$project$Ui$V3$Stack$style, 'border-radius', '6px'),
							$author$project$Ui$V3$Header$btnPadding,
							A2(
							$author$project$Ui$V3$Stack$style,
							'z-index',
							isOpen ? '99' : '97')
						]),
					onClickAttrs),
				_List_fromArray(
					[label])));
		var backdrop = isOpen ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
						A2($elm$html$Html$Attributes$style, 'left', '0'),
						A2($elm$html$Html$Attributes$style, 'top', '0'),
						A2($elm$html$Html$Attributes$style, 'width', '100vw'),
						A2($elm$html$Html$Attributes$style, 'height', '100vh'),
						A2($elm$html$Html$Attributes$style, 'z-index', '98'),
						$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$BackgroundNeutralScrim),
						$elm$html$Html$Events$onClick(
						config.msgMapper(toggleMsg))
					]),
				_List_Nil)) : $elm$core$Maybe$Nothing;
		return A2(
			$author$project$Ui$V3$Stack$viewHorzMaybes,
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Stack$style, 'position', 'relative')
				]),
			alignRight ? _List_fromArray(
				[btn, dropdown, backdrop]) : _List_fromArray(
				[dropdown, btn, backdrop]));
	});
var $author$project$Ui$V3$Header$viewAccounts = F3(
	function (model, config, accounts) {
		return A2(
			$elm$core$Maybe$map,
			function (currentAccount) {
				var currentName = currentAccount.name;
				var currentNameDisplay = ($elm$core$String$length(currentName) > 16) ? (A2($elm$core$String$left, 8, currentName) + ('...' + A2($elm$core$String$right, 8, currentName))) : currentName;
				return A6(
					$author$project$Ui$V3$Header$viewDropdown,
					{alignRight: true, forAccount: true},
					config,
					$author$project$Ui$V3$Header$ToggleAccounts(
						{shouldOpen: !model.isAccountsOpen}),
					model.isAccountsOpen,
					A2(
						$author$project$Ui$V3$Stack$viewHorz,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
								$author$project$Ui$V3$Stack$crossAxisCenter,
								$author$project$Ui$V3$Stack$noWrap
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Typography$smallBody,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray0)
									]),
								currentNameDisplay),
								A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$chevronDown16)
							])),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var isCurrent = _v0.isCurrent;
							var onClick = _v0.onClick;
							var name = _v0.name;
							return _Utils_Tuple3(
								A2(
									$elm$core$List$cons,
									A2($author$project$Ui$V3$Stack$style, 'padding-left', '8px'),
									isCurrent ? _List_fromArray(
										[
											$author$project$Ui$V3$Stack$htmlAttribute(
											$elm$html$Html$Attributes$id($author$project$Ui$V3$Header$currentAccountDomId))
										]) : _List_Nil),
								A2(
									$author$project$Ui$V3$Typography$smallBodySemiBold,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray0),
												A2($elm$html$Html$Attributes$style, 'max-width', '250px')
											]),
										$author$project$Ui$V3$Header$currentSidelineAttrs(isCurrent)),
									name),
								$author$project$Ui$V3$Header$Button(onClick));
						},
						accounts));
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				function ($) {
					return $.isCurrent;
				},
				accounts));
	});
var $author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes = F2(
	function (attributes, maybesWithWidths) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			attributes,
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var width = _v0.a;
					var maybe = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(width),
						maybe);
				},
				maybesWithWidths));
	});
var $author$project$Ui$V3$Colors$Teal600 = {$: 'Teal600'};
var $author$project$Ui$V3$Header$underlineableLink = function (isUnderlined) {
	var underlineColor = isUnderlined ? $author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal600) : 'transparent';
	return $author$project$Ui$V3$Typography$smallBodySemiBold(
		_List_fromArray(
			[
				$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray0),
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				A2($elm$html$Html$Attributes$style, 'padding', '0'),
				A2($elm$html$Html$Attributes$style, 'display', 'inline'),
				A2($elm$html$Html$Attributes$style, 'box-shadow', 'inset 0 -2px ' + underlineColor)
			]));
};
var $author$project$Ui$V3$Header$viewLinks = function (config) {
	return A2(
		$author$project$Ui$V3$Stack$viewHorz,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var maybeOnClick = _v0.a;
				var page = _v0.b;
				return A2(
					$elm$html$Html$a,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$href(page.url),
						$author$project$Ui$V3$Header$linkClickAttrs(maybeOnClick)),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorz,
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Stack$style, 'padding', '10px 12px'),
									$author$project$Ui$V3$Stack$class('header__menu-btn'),
									A2($author$project$Ui$V3$Stack$style, 'border-radius', '6px')
								]),
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Header$underlineableLink, page.isCurrent, page.title)
								]))
						]));
			},
			config.rightPages));
};
var $author$project$Ui$V3$Colors$Gray300 = {$: 'Gray300'};
var $author$project$Ui$V3$Header$Link = function (a) {
	return {$: 'Link', a: a};
};
var $author$project$Ui$V3$Header$ToggleMenu = function (a) {
	return {$: 'ToggleMenu', a: a};
};
var $author$project$Ui$V3$Icon$closeSmall16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M9.14973 8.09004C9.13777 8.07881 9.12824 8.06525 9.12173 8.0502C9.11522 8.03514 9.11186 8.01891 9.11186 8.0025C9.11186 7.98609 9.11522 7.96986 9.12173 7.95481C9.12824 7.93975 9.13777 7.92619 9.14973 7.91496L13.7786 3.27787C13.8488 3.20855 13.9044 3.12598 13.9424 3.03496C13.9804 2.94394 14 2.84628 14 2.74763C14 2.64899 13.9804 2.55133 13.9424 2.46031C13.9044 2.36929 13.8488 2.28672 13.7786 2.21739C13.6374 2.07809 13.4471 2 13.2487 2C13.0504 2 12.8601 2.07809 12.7189 2.21739L8.08998 6.84948C8.07832 6.86158 8.06434 6.87121 8.04888 6.87779C8.03342 6.88436 8.0168 6.88775 8 6.88775C7.9832 6.88775 7.96658 6.88436 7.95112 6.87779C7.93566 6.87121 7.92168 6.86158 7.91002 6.84948L3.28113 2.21739C3.13989 2.07809 2.94956 2 2.75125 2C2.55295 2 2.36261 2.07809 2.22138 2.21739C2.15125 2.28672 2.09557 2.36929 2.05757 2.46031C2.01957 2.55133 2 2.64899 2 2.74763C2 2.84628 2.01957 2.94394 2.05757 3.03496C2.09557 3.12598 2.15125 3.20855 2.22138 3.27787L6.85027 7.91496C6.86223 7.92619 6.87176 7.93975 6.87827 7.95481C6.88478 7.96986 6.88814 7.98609 6.88814 8.0025C6.88814 8.01891 6.88478 8.03514 6.87827 8.0502C6.87176 8.06525 6.86223 8.07881 6.85027 8.09004L2.22138 12.7221C2.15125 12.7915 2.09557 12.874 2.05757 12.965C2.01957 13.0561 2 13.1537 2 13.2524C2 13.351 2.01957 13.4487 2.05757 13.5397C2.09557 13.6307 2.15125 13.7133 2.22138 13.7826C2.36261 13.9219 2.55295 14 2.75125 14C2.94956 14 3.13989 13.9219 3.28113 13.7826L7.91002 9.15052C7.92168 9.13842 7.93566 9.12879 7.95112 9.12221C7.96658 9.11564 7.9832 9.11225 8 9.11225C8.0168 9.11225 8.03342 9.11564 8.04888 9.12221C8.06434 9.12879 8.07832 9.13842 8.08998 9.15052L12.7189 13.7826C12.8601 13.9219 13.0504 14 13.2487 14C13.4471 14 13.6374 13.9219 13.7786 13.7826C13.8488 13.7133 13.9044 13.6307 13.9424 13.5397C13.9804 13.4487 14 13.351 14 13.2524C14 13.1537 13.9804 13.0561 13.9424 12.965C13.9044 12.874 13.8488 12.7915 13.7786 12.7221L9.14973 8.09004Z'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_Nil));
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Ui$V3$Icon$menu16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$d('M15 1.667H1a.667.667 0 0 0-.667.666V3c0 .368.299.667.667.667h14A.667.667 0 0 0 15.667 3v-.667A.667.667 0 0 0 15 1.666ZM15 7H1a.667.667 0 0 0-.667.667v.666C.333 8.702.632 9 1 9h14a.667.667 0 0 0 .667-.667v-.666A.667.667 0 0 0 15 7ZM1 12.334h14c.368 0 .667.298.667.666v.667a.667.667 0 0 1-.667.667H1a.667.667 0 0 1-.667-.667V13c0-.368.299-.666.667-.666Z'),
				$elm$svg$Svg$Attributes$clipRule('evenodd')
			]),
		_List_Nil));
var $author$project$Ui$V3$Header$viewMenu = F2(
	function (model, config) {
		var toDropdown = F2(
			function (label, dropdownPages) {
				return A6(
					$author$project$Ui$V3$Header$viewDropdown,
					{alignRight: false, forAccount: false},
					config,
					$author$project$Ui$V3$Header$ToggleMenu(
						{shouldOpen: !model.isMenuOpen}),
					model.isMenuOpen,
					label,
					dropdownPages);
			});
		var _v0 = config.dropdownPages;
		if (!_v0.b) {
			return $elm$html$Html$text('');
		} else {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				var page = _v1.b;
				var label = A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(page.url)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(page.title)
								]))
						]));
				return A2(toDropdown, label, _List_Nil);
			} else {
				var head = _v0.a;
				var tail = _v0.b;
				var pageEls = A2(
					$elm$core$List$map,
					function (_v2) {
						var icon = _v2.a;
						var page = _v2.b;
						var iconColor = page.isCurrent ? 'white' : $author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray300);
						return _Utils_Tuple3(
							_List_Nil,
							A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
										$author$project$Ui$V3$Stack$crossAxisCenter,
										A2($author$project$Ui$V3$Stack$style, 'color', iconColor),
										$author$project$Ui$V3$Stack$noWrap
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, icon)),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A2($author$project$Ui$V3$Header$underlineableLink, page.isCurrent, page.title))
									])),
							$author$project$Ui$V3$Header$Link(page.url));
					},
					config.dropdownPages);
				var currentPage = A2(
					$elm$core$Maybe$withDefault,
					head,
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							function ($) {
								return $.isCurrent;
							}),
						A2($elm$core$List$cons, head, tail))).b;
				var label = A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
							$author$project$Ui$V3$Stack$crossAxisCenter,
							$author$project$Ui$V3$Stack$noWrap
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(currentPage.title)
								])),
							model.isMenuOpen ? A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$closeSmall16) : A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$menu16)
						]));
				return A2(toDropdown, label, pageEls);
			}
		}
	});
var $author$project$Ui$V3$Header$CollapseSettings = {$: 'CollapseSettings'};
var $author$project$Ui$V3$Badge$MediumSize = {$: 'MediumSize'};
var $author$project$Ui$V3$Header$ToggleSettings = function (a) {
	return {$: 'ToggleSettings', a: a};
};
var $author$project$Ui$V3$Icon$announce = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$d('M16 5.998c-.001-.275-.086-.543-.245-.767s-.383-.394-.642-.486a.36.36 0 0 0-.307.04c-.043.032-.078.073-.102.12s-.037.1-.038.153v2.553c.001.053.014.106.038.153s.059.089.102.12.096.048.149.055.107.002.158-.015A1.33 1.33 0 0 0 16 6.664v-.667zm-2.333-4c0-.168-.043-.333-.125-.48a.99.99 0 0 0-.342-.36c-.553-.353-.98-.06-1.813.347a14.98 14.98 0 0 1-6.72 1.793c-.047 0-.093.009-.136.028s-.081.046-.113.081a.33.33 0 0 0-.07.12c-.015.045-.02.091-.015.138v5.727a5.55 5.55 0 0 0 .846 2.877c.541.863 1.309 1.561 2.22 2.016a.67.67 0 0 0 .897-.303.67.67 0 0 0-.303-.897 4.18 4.18 0 0 1-2.32-3.613c1.992.155 3.932.715 5.7 1.647.92.433 1.293.667 1.84.34a1 1 0 0 0 .453-.847V1.998zM3.333 3.665a.32.32 0 0 0-.025-.13.33.33 0 0 0-.075-.11c-.063-.06-.146-.094-.233-.093h-.667c-.307-.001-.61.059-.894.176s-.541.289-.758.506-.389.474-.506.758-.177.587-.176.894v1.333c.001.307.062.611.181.894a2.34 2.34 0 0 0 .51.756c.218.216.476.387.761.503s.589.175.895.173h.667c.085-.003.165-.039.225-.1a.33.33 0 0 0 .095-.227V3.665z')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$cog16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$d('M15 6.333h-1.24a6.336 6.336 0 0 0-.507-1.226l.874-.88a.973.973 0 0 0 .293-.707.98.98 0 0 0-.293-.707l-.94-.94a.994.994 0 0 0-1.414 0l-.88.88a6 6 0 0 0-1.226-.513V1a1 1 0 0 0-1-1H7.333a1 1 0 0 0-1 1v1.24a6 6 0 0 0-1.226.513l-.88-.88a.993.993 0 0 0-1.414 0l-.94.94a.98.98 0 0 0-.293.707.96.96 0 0 0 .293.707l.874.88a6.34 6.34 0 0 0-.507 1.226H1a1 1 0 0 0-1 1v1.334a1 1 0 0 0 1 1h1.24c.124.426.294.837.507 1.226l-.874.88a1 1 0 0 0 0 1.414l.94.94a1.02 1.02 0 0 0 1.414 0l.88-.874c.39.213.8.383 1.226.507V15a1 1 0 0 0 1 1h1.334a1 1 0 0 0 1-1v-1.24a6.17 6.17 0 0 0 1.226-.507l.88.874a.994.994 0 0 0 1.414 0l.94-.94a1 1 0 0 0 0-1.414l-.874-.88c.213-.39.383-.8.507-1.226H15a1 1 0 0 0 1-1V7.333a1 1 0 0 0-1-1Zm-7 5a3.334 3.334 0 1 1 0-6.667 3.334 3.334 0 0 1 0 6.667Z')
			]),
		_List_Nil));
var $author$project$Ui$V3$Icon$logout16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M9 11.6673C8.82319 11.6673 8.65362 11.7376 8.5286 11.8626C8.40357 11.9876 8.33333 12.1572 8.33333 12.334V14.0007C8.33333 14.0891 8.29821 14.1738 8.2357 14.2364C8.17319 14.2989 8.08841 14.334 8 14.334H1.66667C1.57826 14.334 1.49348 14.2989 1.43096 14.2364C1.36845 14.1738 1.33333 14.0891 1.33333 14.0007V2.00065C1.33333 1.91225 1.36845 1.82746 1.43096 1.76495C1.49348 1.70244 1.57826 1.66732 1.66667 1.66732H8C8.08841 1.66732 8.17319 1.70244 8.2357 1.76495C8.29821 1.82746 8.33333 1.91225 8.33333 2.00065V3.66732C8.33333 3.84413 8.40357 4.0137 8.5286 4.13872C8.65362 4.26375 8.82319 4.33398 9 4.33398C9.17681 4.33398 9.34638 4.26375 9.47141 4.13872C9.59643 4.0137 9.66667 3.84413 9.66667 3.66732V1.66732C9.66667 1.3137 9.52619 0.974557 9.27614 0.724509C9.02609 0.47446 8.68696 0.333984 8.33333 0.333984H1.33333C0.979711 0.333984 0.640573 0.47446 0.390524 0.724509C0.140476 0.974557 0 1.3137 0 1.66732L0 14.334C0 14.6876 0.140476 15.0267 0.390524 15.2768C0.640573 15.5268 0.979711 15.6673 1.33333 15.6673H8.33333C8.68696 15.6673 9.02609 15.5268 9.27614 15.2768C9.52619 15.0267 9.66667 14.6876 9.66667 14.334V12.334C9.66667 12.1572 9.59643 11.9876 9.47141 11.8626C9.34638 11.7376 9.17681 11.6673 9 11.6673Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.7003 7.78047L11.7003 5.1138C11.6001 5.04777 11.4838 5.01004 11.3639 5.00459C11.244 4.99915 11.1248 5.02619 11.0189 5.08286C10.9131 5.13954 10.8245 5.22374 10.7626 5.32658C10.7006 5.42942 10.6676 5.54708 10.667 5.66714V7.3338H4.66699C4.40178 7.3338 4.14742 7.43916 3.95989 7.6267C3.77235 7.81423 3.66699 8.06859 3.66699 8.3338C3.66699 8.59902 3.77235 8.85337 3.95989 9.04091C4.14742 9.22845 4.40178 9.3338 4.66699 9.3338H10.667V11.0005C10.667 11.1773 10.7372 11.3468 10.8623 11.4719C10.9873 11.5969 11.1568 11.6671 11.3337 11.6671C11.4643 11.6661 11.5919 11.6267 11.7003 11.5538L15.7003 8.88714C15.792 8.82674 15.8674 8.74463 15.9197 8.6481C15.9721 8.55157 15.9998 8.44361 16.0003 8.3338C15.9998 8.224 15.9721 8.11603 15.9197 8.0195C15.8674 7.92297 15.792 7.84086 15.7003 7.78047Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$question16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.06607 9.87327V9.72838C7.06891 9.23122 7.11295 8.83492 7.19818 8.53946C7.28624 8.24401 7.41408 8.00537 7.5817 7.82355C7.74931 7.64174 7.95102 7.47696 8.18681 7.32923C8.36295 7.2156 8.52062 7.0977 8.65982 6.97554C8.79903 6.85338 8.90982 6.71844 8.99221 6.57071C9.0746 6.42014 9.11579 6.25253 9.11579 6.06787C9.11579 5.87185 9.06891 5.69997 8.97516 5.55225C8.88141 5.40452 8.75499 5.29088 8.5959 5.21134C8.43965 5.13179 8.26636 5.09202 8.07602 5.09202C7.89136 5.09202 7.71664 5.13321 7.55187 5.2156C7.3871 5.29514 7.25215 5.41446 7.14704 5.57355C7.04193 5.7298 6.98511 5.92441 6.97658 6.15736H5.23795C5.25215 5.58918 5.38852 5.12043 5.64704 4.75111C5.90556 4.37895 6.24789 4.10196 6.67403 3.92014C7.10016 3.73548 7.57033 3.64315 8.08454 3.64315C8.64988 3.64315 9.14988 3.7369 9.58454 3.9244C10.0192 4.10906 10.3601 4.37753 10.6073 4.7298C10.8544 5.08208 10.978 5.50679 10.978 6.00395C10.978 6.33634 10.9226 6.63179 10.8118 6.89031C10.7039 7.146 10.5519 7.37327 10.3558 7.57213C10.1598 7.76816 9.92829 7.94571 9.66124 8.1048C9.43681 8.23833 9.25215 8.37753 9.10727 8.52242C8.96522 8.6673 8.85869 8.83492 8.78766 9.02526C8.71948 9.2156 8.68397 9.44997 8.68113 9.72838V9.87327H7.06607ZM7.90982 12.6005C7.62573 12.6005 7.38283 12.5011 7.18113 12.3022C6.98227 12.1005 6.88425 11.8591 6.8871 11.5778C6.88425 11.2994 6.98227 11.0608 7.18113 10.8619C7.38283 10.663 7.62573 10.5636 7.90982 10.5636C8.17971 10.5636 8.41693 10.663 8.62147 10.8619C8.82602 11.0608 8.92971 11.2994 8.93255 11.5778C8.92971 11.7653 8.87999 11.9372 8.7834 12.0934C8.68965 12.2468 8.56607 12.3704 8.41266 12.4642C8.25926 12.5551 8.09164 12.6005 7.90982 12.6005Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M8 1.76367C4.55307 1.76367 1.75879 4.55796 1.75879 8.00488C1.75879 11.4518 4.55307 14.2461 8 14.2461C11.4469 14.2461 14.2412 11.4518 14.2412 8.00488C14.2412 4.55796 11.4469 1.76367 8 1.76367ZM0.00878906 8.00488C0.00878906 3.59146 3.58658 0.0136719 8 0.0136719C12.4134 0.0136719 15.9912 3.59146 15.9912 8.00488C15.9912 12.4183 12.4134 15.9961 8 15.9961C3.58658 15.9961 0.00878906 12.4183 0.00878906 8.00488Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Chip$Style = F2(
	function (a, b) {
		return {$: 'Style', a: a, b: b};
	});
var $author$project$Ui$V3$Colors$Teal150 = {$: 'Teal150'};
var $author$project$Ui$V3$Colors$Teal200 = {$: 'Teal200'};
var $author$project$Ui$V3$Colors$Teal700 = {$: 'Teal700'};
var $author$project$Ui$V3$Chip$view = F2(
	function (attributes, text) {
		return A2(
			$author$project$Ui$V3$Chip$viewHtml,
			attributes,
			$elm$html$Html$text(text));
	});
var $author$project$Ui$V3$Header$toggleLinkContents = A2(
	$author$project$Ui$V3$Stack$viewVert,
	_List_fromArray(
		[
			$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$crossAxisCenter]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Typography$smallBodySemiBold,
						_List_fromArray(
							[
								$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray0),
								A2($elm$html$Html$Attributes$style, 'white-space', 'break-spaces')
							]),
						'Layout Preferences')),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Chip$view,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Chip$Style,
								'color',
								$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal700)),
								A2($author$project$Ui$V3$Chip$Style, 'font-weight', '500'),
								A2($author$project$Ui$V3$Chip$Style, 'line-height', '18px'),
								A2(
								$author$project$Ui$V3$Chip$Style,
								'border-color',
								$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal150))
							]),
						'New'))
				])),
			A2(
			$author$project$Ui$V3$Typography$xSmallBody,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray0),
					A2($elm$html$Html$Attributes$style, 'white-space', 'break-spaces')
				]),
			'Beginning 5/26/26 Triumph Audit will no longer support our previous experience and layout.'),
			A2(
			$author$project$Ui$V3$Typography$xSmallBody,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Teal200)
				]),
			'Switch Layout')
		]));
var $author$project$Ui$V3$Header$viewRightIcons = F2(
	function (model, config) {
		var viewItem = function (contents) {
			return A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
						$author$project$Ui$V3$Stack$crossAxisCenter,
						$author$project$Ui$V3$Stack$htmlAttribute(
						$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray300)),
						$author$project$Ui$V3$Stack$noWrap,
						A2($author$project$Ui$V3$Stack$style, 'white-space', 'nowrap'),
						A2($author$project$Ui$V3$Stack$style, 'max-width', '250px')
					]),
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
					contents));
		};
		var viewIcon = function (icon) {
			return A2(
				$author$project$Ui$V3$Stack$viewHorz,
				_List_fromArray(
					[
						$author$project$Ui$V3$Header$btnPadding,
						$author$project$Ui$V3$Stack$class('header__menu-btn'),
						A2($author$project$Ui$V3$Stack$style, 'border-radius', '6px'),
						A2($author$project$Ui$V3$Stack$style, 'cursor', 'pointer')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, _List_Nil, icon)
					]));
		};
		var updatesIcon = A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var onClick = _v1.onClick;
				var messageCount = _v1.messageCount;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'relative'),
							$elm$html$Html$Events$onClick(onClick)
						]),
					_List_fromArray(
						[
							viewIcon($author$project$Ui$V3$Icon$announce),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
									A2($elm$html$Html$Attributes$style, 'top', '-6px'),
									A2($elm$html$Html$Attributes$style, 'right', '3px'),
									A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
								]),
							(messageCount > 0) ? _List_fromArray(
								[
									A3(
									$author$project$Ui$V3$Badge$view,
									_List_fromArray(
										[
											$author$project$Ui$V3$Badge$badgeStyle($author$project$Ui$V3$Badge$AlertStyle),
											$author$project$Ui$V3$Badge$badgeSize($author$project$Ui$V3$Badge$MediumSize)
										]),
									messageCount,
									'')
								]) : _List_Nil)
						]));
			},
			config.beamer);
		var settingsIcon = A6(
			$author$project$Ui$V3$Header$viewDropdown,
			{alignRight: true, forAccount: false},
			config,
			$author$project$Ui$V3$Header$ToggleSettings(
				{shouldOpen: !model.isSettingsOpen}),
			model.isSettingsOpen,
			A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$cog16),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (_v0) {
							var enabled = _v0.enabled;
							var onToggle = _v0.onToggle;
							return _Utils_Tuple3(
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$onClick(
										config.msgMapper($author$project$Ui$V3$Header$CollapseSettings)),
										$author$project$Ui$V3$Stack$htmlAttribute(
										A2(
											$elm$html$Html$Attributes$attribute,
											'data-fullstory-reskin-toggle',
											enabled ? 'disable' : 'enable'))
									]),
								viewItem(
									_List_fromArray(
										[$author$project$Ui$V3$Header$toggleLinkContents])),
								$author$project$Ui$V3$Header$Button(
									onToggle(!enabled)));
						},
						config.reskinToggle),
						config.hasSettingsRole ? $elm$core$Maybe$Just(
						_Utils_Tuple3(
							_List_Nil,
							viewItem(
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$cog16),
										A2(
										$author$project$Ui$V3$Typography$smallBodySemiBold,
										_List_fromArray(
											[
												$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray0)
											]),
										'Account settings')
									])),
							$author$project$Ui$V3$Header$Link('/app/settings'))) : $elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(
						_Utils_Tuple3(
							_List_Nil,
							viewItem(
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$logout16),
										A2(
										$author$project$Ui$V3$Typography$smallBodySemiBold,
										_List_fromArray(
											[
												$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray0)
											]),
										'Log out')
									])),
							$author$project$Ui$V3$Header$Link('/app/logout')))
					])));
		var helpIcon = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('/app/help'),
					A2($elm$html$Html$Attributes$style, 'color', 'white')
				]),
			_List_fromArray(
				[
					viewIcon($author$project$Ui$V3$Icon$question16)
				]));
		return A2(
			$author$project$Ui$V3$Stack$viewHorzMaybes,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$crossAxisCenter]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(helpIcon),
					updatesIcon,
					$elm$core$Maybe$Just(settingsIcon)
				]));
	});
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $author$project$Ui$V3$Logo$viewTransparent32 = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('32'),
			$elm$svg$Svg$Attributes$height('32'),
			$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('32'),
					$elm$svg$Svg$Attributes$height('32'),
					$elm$svg$Svg$Attributes$rx('4'),
					$elm$svg$Svg$Attributes$fill('white'),
					$elm$svg$Svg$Attributes$fillOpacity('0.4')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M19.428 12.7316V6.42986L16.992 4V15.008H28L25.7215 12.7356L19.428 12.7316Z'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M16.992 28L19.2664 25.7215L19.2685 19.428H25.5701L28 16.9879H16.992V28Z'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12.7356 12.572H6.42782L4 15.008H15.0121V4L12.7356 6.27851V12.572Z'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6.27851 19.2644H12.572V25.5701L15.0121 28V16.9879H4L6.27851 19.2644Z'),
					$elm$svg$Svg$Attributes$fill('white')
				]),
			_List_Nil)
		]));
var $author$project$Ui$V3$Header$view = F2(
	function (model, config) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
			_List_fromArray(
				[
					A4($author$project$Ui$V3$Stack$paddingLeftRightTopBottom, $author$project$Ui$V3$Stack$spaceSmall, $author$project$Ui$V3$Stack$spaceXSmall, $author$project$Ui$V3$Stack$spaceXXSmall, $author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Purple900),
					$author$project$Ui$V3$Stack$mainAxisStart,
					$author$project$Ui$V3$Stack$crossAxisCenter,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
					$author$project$Ui$V3$Stack$class('v3__header'),
					A2(
					$author$project$Ui$V3$Stack$style,
					'color',
					$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray0))
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$href(config.logoUrl),
								$author$project$Ui$V3$Header$linkClickAttrs(config.logoAction)),
							_List_fromArray(
								[$author$project$Ui$V3$Logo$viewTransparent32])))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$core$Maybe$Just(
						A2($author$project$Ui$V3$Header$viewMenu, model, config))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$core$Maybe$Just(
						$author$project$Ui$V3$Header$viewLinks(config))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$elm$core$Maybe$Just(
						$elm$html$Html$text(''))),
					_Utils_Tuple2($author$project$Ui$V3$Stack$fit, config.middleContent),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$core$Maybe$Just(
						A2($author$project$Ui$V3$Header$viewRightIcons, model, config))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A3($author$project$Ui$V3$Header$viewAccounts, model, config, config.accounts))
				]));
	});
var $author$project$Forward$LoadingView$loadingViewReskinnable = function (v3ReskinEnabled) {
	return v3ReskinEnabled ? $author$project$Forward$LoadingView$v3LoadingView : $author$project$Forward$LoadingView$defaultLoadingView;
};
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Broker$Page$BillingRequirements$billingRules = function (customer) {
	var rulesBrokerCustomExceptionMessages = A2(
		$elm$core$List$map,
		function (rule) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(rule.message)
					]));
		},
		customer.rulesBrokerCustomExceptionMessages);
	return $elm$core$List$isEmpty(customer.rulesBrokerCustomExceptionMessages) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('load-detail__instructions-list load-detail__section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__section-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Customer Requirements')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('reminder')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Verify before proceeding')
							])),
					rulesBrokerCustomExceptionMessages))
			]));
};
var $author$project$Broker$Page$BillingRequirements$billToAddress = function (address) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (x) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(x)
								]));
					},
					address.addressLine1),
					A2(
					$elm$core$Maybe$map,
					function (x) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(x)
								]));
					},
					address.addressLine2),
					$elm$core$Maybe$Just(
					$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							', ',
							$elm_community$maybe_extra$Maybe$Extra$values(
								_List_fromArray(
									[address.city, address.state, address.postalCode]))))),
					A2(
					$elm$core$Maybe$map,
					function (x) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(x)
								]));
					},
					address.country)
				])));
};
var $elm$html$Html$dd = _VirtualDom_node('dd');
var $author$project$Broker$Page$BillingRequirements$referenceToString = function (reference) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				reference.name,
				': ',
				A2($elm$core$String$join, ', ', reference.values)
			]));
};
var $author$project$Broker$Page$BillingRequirements$displayReferences = function (customer) {
	return A2(
		$elm$core$List$map,
		function (x) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[x]));
		},
		A2(
			$elm$core$List$map,
			$elm$html$Html$text,
			A2($elm$core$List$map, $author$project$Broker$Page$BillingRequirements$referenceToString, customer.references)));
};
var $elm$html$Html$dl = _VirtualDom_node('dl');
var $elm$html$Html$dt = _VirtualDom_node('dt');
var $author$project$Broker$Page$BillingRequirements$requiredDocuments = F3(
	function (account, accountSettings, settings) {
		return A2(
			$elm$core$List$map,
			A2($author$project$Domain$Helpers$documentTypeToString, account, accountSettings),
			A2($elm$core$List$map, $author$project$Domain$UnresolvedDocumentType$fromPb, settings.requiredReceivablesTypes));
	});
var $author$project$Broker$Page$BillingRequirements$customerDetails = F3(
	function (account, accountSettings, customer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header flex')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Customer Details')
						])),
					A2(
					$elm$html$Html$dl,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$elm$html$Html$dt,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Customer name:')
										])),
									A2(
									$elm$html$Html$dd,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(customer.name)
										])),
									A2(
									$elm$html$Html$dt,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Customer ID:')
										])),
									A2(
									$elm$html$Html$dd,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, '', customer.accountNumber))
										]))
								]),
								function () {
								var _v0 = customer.billToAddress;
								if (_v0.$ === 'Nothing') {
									return _List_Nil;
								} else {
									var address = _v0.a;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$dt,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Bill to Address:')
												])),
											A2(
											$elm$html$Html$dd,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Broker$Page$BillingRequirements$billToAddress(address)
												]))
										]);
								}
							}(),
								account.receivablesAccount ? _List_fromArray(
								[
									A2(
									$elm$html$Html$dt,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Billing Interval')
										])),
									A2(
									$elm$html$Html$dd,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Domain$BillingInterval$display(customer.billingInterval))
										]))
								]) : _List_Nil,
								_List_fromArray(
								[
									A2(
									$elm$html$Html$dt,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Customer email address:')
										])),
									A2(
									$elm$html$Html$dd,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(customer.billingEmail)
										])),
									A2(
									$elm$html$Html$dt,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Required Documents')
										])),
									A2(
									$elm$html$Html$dd,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (x) {
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(x)
													]));
										},
										A3($author$project$Broker$Page$BillingRequirements$requiredDocuments, account, accountSettings, customer))),
									A2(
									$elm$html$Html$dt,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('POD Requirement')
										])),
									A2(
									$elm$html$Html$dd,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Domain$PodRequirementPolicy$display(customer.podRequirementPolicy))
										])),
									A2(
									$elm$html$Html$dt,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('References')
										])),
									A2(
									$elm$html$Html$dd,
									_List_Nil,
									$author$project$Broker$Page$BillingRequirements$displayReferences(customer))
								])
							])))
				]));
	});
var $author$project$Broker$Page$BillingRequirements$CurrentCustomerChanged = function (a) {
	return {$: 'CurrentCustomerChanged', a: a};
};
var $author$project$Broker$Page$BillingRequirements$customerChanged = function (newCustomerId) {
	return $author$project$Broker$Page$BillingRequirements$CurrentCustomerChanged(newCustomerId);
};
var $author$project$Broker$Page$BillingRequirements$optionHelper = F2(
	function (currentCustomer, customer) {
		var isSelected = _Utils_eq(currentCustomer.id, customer.id);
		var identifier = $elm$core$String$fromInt(
			$author$project$Domain$TmsCustomerId$toInt(customer.id));
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(identifier),
					$elm$html$Html$Attributes$selected(isSelected)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(customer.name)
				]));
	});
var $author$project$Broker$Page$BillingRequirements$customerSelector = F2(
	function (allCustomers, currentCustomer) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-input__select'),
					$elm$html$Html$Events$onInput($author$project$Broker$Page$BillingRequirements$customerChanged)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Broker$Page$BillingRequirements$optionHelper(currentCustomer),
				allCustomers));
	});
var $author$project$Broker$Page$BillingRequirements$instructionsList = function (customer) {
	var instructionsListElement = A2(
		$elm$core$List$map,
		function (instructions) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(instructions)
					]));
		},
		customer.instructionsList);
	return $elm$core$List$isEmpty(customer.instructionsList) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('load-detail__instructions-list load-detail__section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__section-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Customer Notes')
					])),
				A2($elm$html$Html$ul, _List_Nil, instructionsListElement)
			]));
};
var $author$project$Broker$Page$BillingRequirements$viewBillingRequirements = F4(
	function (account, accountSettings, allCustomers, customer) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__customer-selector')
					]),
				_List_fromArray(
					[
						A2($author$project$Broker$Page$BillingRequirements$customerSelector, allCustomers, customer)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('load-detail__row-item')
							]),
						_List_fromArray(
							[
								A3($author$project$Broker$Page$BillingRequirements$customerDetails, account, accountSettings, customer)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('load-detail__row-item')
							]),
						_List_fromArray(
							[
								$author$project$Broker$Page$BillingRequirements$instructionsList(customer),
								$author$project$Broker$Page$BillingRequirements$billingRules(customer)
							]))
					]))
			]);
	});
var $author$project$Broker$Page$BillingRequirements$viewHeader = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('billing-requirements__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Customer Details')
					]))
			]))
	]);
var $author$project$Broker$Page$BillingRequirements$loadedView = F3(
	function (_v0, model, data) {
		var emptyMessage = _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Please select or assign load to display billing requirements.')
					]))
			]);
		var allCustomerSettings = A2($elm$core$List$cons, data.loadCustomerSettings, data.shipmentCustomerSettings);
		var justCustomerSettings = $elm_community$list_extra$List$Extra$unique(
			$elm_community$maybe_extra$Maybe$Extra$values(allCustomerSettings));
		var defaultCustomer = function () {
			var _v1 = model.selectedCustomerId;
			if (_v1.$ === 'Nothing') {
				return $elm$core$List$head(justCustomerSettings);
			} else {
				var selectedCustomerId = _v1.a;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (x) {
							return _Utils_eq(
								$author$project$Domain$TmsCustomerId$toInt(x.id),
								selectedCustomerId);
						},
						justCustomerSettings));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('general-popup-container')
				]),
			A2(
				$elm$core$List$append,
				$author$project$Broker$Page$BillingRequirements$viewHeader,
				A2(
					$elm$core$Maybe$withDefault,
					emptyMessage,
					A2(
						$elm$core$Maybe$map,
						A3($author$project$Broker$Page$BillingRequirements$viewBillingRequirements, data.currentAccount, data.accountSettings, justCustomerSettings),
						defaultCustomer))));
	});
var $author$project$Broker$Page$BillingRequirements$customerSelect = F2(
	function (customers, selectedCustomer) {
		return ($elm$core$List$length(customers) > 1) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, 'Select customer'),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$SimpleSelect$view,
								{
									onInput: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.id;
										},
										A2(
											$elm$core$Basics$composeR,
											$author$project$Domain$TmsCustomerId$toInt,
											A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Broker$Page$BillingRequirements$CurrentCustomerChanged))),
									options: customers,
									toLabel: function ($) {
										return $.name;
									},
									value: $elm$core$Maybe$Just(selectedCustomer)
								},
								_List_fromArray(
									[$author$project$Ui$V3$SimpleSelect$autoWidth]))
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Ui$V3$Stack$divider = $author$project$Ui$V3$Stack$Basis('divider');
var $author$project$Broker$Page$BillingRequirements$billToAddressV3Reskin = function (customer) {
	var _v0 = customer.billToAddress;
	if (_v0.$ === 'Just') {
		var addr = _v0.a;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Maybe$map($elm$html$Html$text),
				_List_fromArray(
					[
						addr.addressLine1,
						addr.addressLine2,
						$elm$core$Maybe$Just(
						A2(
							$elm$core$String$join,
							', ',
							$elm_community$maybe_extra$Maybe$Extra$values(
								_List_fromArray(
									[addr.city, addr.state, addr.postalCode])))),
						addr.country
					])));
	} else {
		return $elm$html$Html$text('-');
	}
};
var $author$project$Broker$Page$BillingRequirements$withDashDefault = function (str) {
	return $elm$html$Html$text(
		$elm$core$String$isEmpty(str) ? '-' : str);
};
var $author$project$Broker$Page$BillingRequirements$maybeWithDashDefault = function (maybeStr) {
	return $author$project$Broker$Page$BillingRequirements$withDashDefault(
		A2($elm$core$Maybe$withDefault, '', maybeStr));
};
var $author$project$Broker$Page$BillingRequirements$references = function (customer) {
	return $elm$core$List$isEmpty(customer.references) ? $elm$html$Html$text('-') : A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
			]),
		A2(
			$elm$core$List$map,
			function (reference) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'word-break', 'break-word')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Broker$Page$BillingRequirements$referenceToString(reference))
						]));
			},
			customer.references));
};
var $author$project$Ui$V3$Stack$spaceLarge = $author$project$Ui$V3$Stack$SpatialUnit('l');
var $author$project$Ui$V3$Colors$Gray50 = {$: 'Gray50'};
var $author$project$Broker$Page$BillingRequirements$toTextBlocks = F3(
	function (title, maybeNotification, strs) {
		return $elm$core$List$isEmpty(strs) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Stack$viewVertMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_Utils_ap(
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									]))),
							maybeNotification
						]),
					A2(
						$elm$core$List$map,
						function (str) {
							return $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Gray50),
											$author$project$Ui$V3$Typography$smallBodyClass,
											A2($elm$html$Html$Attributes$style, 'padding', '8px'),
											A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
										]),
									$author$project$Ui$V3$Helpers$Html$textToDivs(str)));
						},
						strs))));
	});
var $author$project$Broker$Page$BillingRequirements$viewDetails = F3(
	function (account, accountSettings, customer) {
		var viewKeyVals = function (keyVals) {
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var key = _v0.a;
						var val = _v0.b;
						return A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
								]),
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, key)),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[$author$project$Ui$V3$Typography$smallBodyClass]),
										_List_fromArray(
											[val])))
								]));
					},
					keyVals));
		};
		var hasRequirements = !$elm$core$List$isEmpty(customer.rulesBrokerCustomExceptionMessages);
		var hasInstructions = !$elm$core$List$isEmpty(customer.instructionsList);
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceLarge)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						_List_fromArray(
							[
								(hasInstructions || hasRequirements) ? $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Customer details')
										]))) : $elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(
								viewKeyVals(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'Customer name',
											$author$project$Broker$Page$BillingRequirements$withDashDefault(customer.name)),
											_Utils_Tuple2(
											'Customer ID',
											$author$project$Broker$Page$BillingRequirements$maybeWithDashDefault(customer.accountNumber)),
											_Utils_Tuple2(
											'Bill to address',
											$author$project$Broker$Page$BillingRequirements$billToAddressV3Reskin(customer)),
											_Utils_Tuple2(
											'Customer email',
											$author$project$Broker$Page$BillingRequirements$withDashDefault(customer.billingEmail)),
											_Utils_Tuple2(
											'Required documents',
											A2(
												$author$project$Ui$V3$Stack$viewVert,
												_List_fromArray(
													[
														$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
													]),
												A2(
													$elm$core$List$map,
													$elm$html$Html$text,
													A3($author$project$Broker$Page$BillingRequirements$requiredDocuments, account, accountSettings, customer)))),
											_Utils_Tuple2(
											'POD requirement',
											$author$project$Broker$Page$BillingRequirements$withDashDefault(
												$author$project$Domain$PodRequirementPolicy$display(customer.podRequirementPolicy))),
											_Utils_Tuple2(
											'References',
											$author$project$Broker$Page$BillingRequirements$references(customer))
										])))
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
							]),
						_List_fromArray(
							[
								A3($author$project$Broker$Page$BillingRequirements$toTextBlocks, 'Customer notes', $elm$core$Maybe$Nothing, customer.instructionsList),
								A3(
								$author$project$Broker$Page$BillingRequirements$toTextBlocks,
								'Customer requirements',
								$elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V3$Notification$viewInline,
										{
											message: $elm$html$Html$text(''),
											onClose: $elm$core$Maybe$Nothing,
											title: $elm$core$Maybe$Just('Verify before proceeding')
										},
										_List_fromArray(
											[$author$project$Ui$V3$Notification$warning]))),
								A2(
									$elm$core$List$map,
									function ($) {
										return $.message;
									},
									customer.rulesBrokerCustomExceptionMessages))
							])))
				]));
	});
var $author$project$Broker$Page$BillingRequirements$loadedViewV3Reskin = F4(
	function (reactStyleOverrides, _v0, model, data) {
		var container = reactStyleOverrides ? $elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('mainViewContainer'),
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled')
				])) : $elm$html$Html$div(_List_Nil);
		var allCustomerSettings = $elm_community$list_extra$List$Extra$unique(
			$elm_community$maybe_extra$Maybe$Extra$values(
				A2($elm$core$List$cons, data.loadCustomerSettings, data.shipmentCustomerSettings)));
		var defaultCustomer = function () {
			var _v2 = model.selectedCustomerId;
			if (_v2.$ === 'Just') {
				var selectedCustomerId = _v2.a;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (x) {
							return _Utils_eq(
								$author$project$Domain$TmsCustomerId$toInt(x.id),
								selectedCustomerId);
						},
						allCustomerSettings));
			} else {
				return $elm$core$List$head(allCustomerSettings);
			}
		}();
		return $author$project$Helpers$Html$v3ReskinContainer(
			container(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Stack$viewVertWithHeights,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
								$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceSmall),
								$author$project$Ui$V3$Stack$class('billing-requirements__container')
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Customer details')
										]))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$divider,
								$elm$html$Html$text('')),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								function () {
									if (defaultCustomer.$ === 'Just') {
										var selectedCustomer = defaultCustomer.a;
										return A2(
											$author$project$Ui$V3$Stack$viewVertMaybes,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
												]),
											_List_fromArray(
												[
													A2($author$project$Broker$Page$BillingRequirements$customerSelect, allCustomerSettings, selectedCustomer),
													$elm$core$Maybe$Just(
													A3($author$project$Broker$Page$BillingRequirements$viewDetails, data.currentAccount, data.accountSettings, selectedCustomer))
												]));
									} else {
										return A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Please select or assign load to display billing requirements.')
												]));
									}
								}())
							]))
					])));
	});
var $author$project$Broker$Page$BillingRequirements$view = F4(
	function (v3ReskinAuditEnabled, tz, data, model) {
		var reactStyleOverrides = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.auditV3ReactStyleOverrides;
				},
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.accountSettings;
					},
					$author$project$Forward$Remote$toMaybe(data))));
		return (v3ReskinAuditEnabled || reactStyleOverrides) ? A2(
			$author$project$Forward$LoadingView$viewV3Reskin,
			A3($author$project$Broker$Page$BillingRequirements$loadedViewV3Reskin, reactStyleOverrides, tz, model),
			data) : A2(
			$author$project$Forward$LoadingView$view,
			A2($author$project$Broker$Page$BillingRequirements$loadedView, tz, model),
			data);
	});
var $author$project$Components$DocumentsBrowser$defaultOptions = {enableBolRateConCompare: false, enableCloseButton: false, enableLineDragging: false, enableThumbnailRightClick: false, expandButton: $elm$core$Maybe$Nothing, overlay: $elm$core$Maybe$Nothing, popoutButton: false};
var $author$project$Components$DocumentsBrowser$computeOptions = function (options) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'Overlay':
					var render = a.a;
					return _Utils_update(
						acc,
						{overlay: render});
				case 'EnableThumbnailRightClick':
					return _Utils_update(
						acc,
						{enableThumbnailRightClick: true});
				case 'EnableCloseButton':
					return _Utils_update(
						acc,
						{enableCloseButton: true});
				case 'EnableLineDragging':
					return _Utils_update(
						acc,
						{enableLineDragging: true});
				case 'EnableBolRateConCompare':
					return _Utils_update(
						acc,
						{enableBolRateConCompare: true});
				case 'ExpandButton':
					var state = a.a;
					return _Utils_update(
						acc,
						{
							expandButton: $elm$core$Maybe$Just(state)
						});
				default:
					return _Utils_update(
						acc,
						{popoutButton: true});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Components$DocumentsBrowser$defaultOptions, options);
};
var $author$project$Helpers$Html$optionalV3ReactStyleOverridesWrapperAttrs = function (enabled) {
	var outerAttrs = _List_fromArray(
		[
			$elm$html$Html$Attributes$id('mainViewContainer'),
			$elm$html$Html$Attributes$class('audit_v3_reskin__activate_container'),
			$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
			$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled--elm'),
			$elm$html$Html$Attributes$class('enable_shared-ui-v3')
		]);
	var innerAttrs = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('v3__theme')
		]);
	return enabled ? _Utils_Tuple2(outerAttrs, innerAttrs) : _Utils_Tuple2(_List_Nil, _List_Nil);
};
var $author$project$Components$DocumentsBrowser$Activity = {$: 'Activity'};
var $author$project$Components$DocumentsBrowser$CloseClicked = {$: 'CloseClicked'};
var $author$project$Components$DocumentsBrowser$Messages = {$: 'Messages'};
var $author$project$Components$DocumentsBrowser$SelectTab = function (a) {
	return {$: 'SelectTab', a: a};
};
var $author$project$Components$DocumentsBrowser$ToggleShowAllLoadDocs = function (a) {
	return {$: 'ToggleShowAllLoadDocs', a: a};
};
var $author$project$Components$DocumentsBrowser$tabToString = function (tab) {
	switch (tab.$) {
		case 'Documents':
			return 'Documents';
		case 'Activity':
			return 'Activity';
		default:
			return 'Messages';
	}
};
var $author$project$Components$DocumentsBrowser$undisplayedLoadDocsPresent = F2(
	function (currentProcessingSelection, documentData) {
		if (currentProcessingSelection.$ === 'CarrierInvoiceSelection') {
			return documentData.hasHiddenLoadDocuments;
		} else {
			return false;
		}
	});
var $author$project$Components$Shared$Tabs$button = F2(
	function (classes, options) {
		return options.useComponentSelectorStyle ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(options.onClick)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(options.label)
				])) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hub-button ' + classes),
					$elm$html$Html$Events$onClick(options.onClick)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(options.label)
				]));
	});
var $author$project$Components$Shared$Tabs$disabledButton = F2(
	function (classes, options) {
		return options.useComponentSelectorStyle ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('active'),
					$elm$html$Html$Attributes$disabled(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(options.label)
				])) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hub-button ' + classes),
					$elm$html$Html$Attributes$disabled(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(options.label)
				]));
	});
var $author$project$Components$Shared$Tabs$buttons = {
	_default: $author$project$Components$Shared$Tabs$button(''),
	disabled: {
		_default: $author$project$Components$Shared$Tabs$disabledButton(''),
		primary: $author$project$Components$Shared$Tabs$disabledButton('hub-button--primary'),
		success: $author$project$Components$Shared$Tabs$disabledButton('hub-button--success'),
		warning: $author$project$Components$Shared$Tabs$disabledButton('hub-button--warning')
	},
	primary: $author$project$Components$Shared$Tabs$button('hub-button--primary'),
	success: $author$project$Components$Shared$Tabs$button('hub-button--success'),
	warning: $author$project$Components$Shared$Tabs$button('hub-button--warning')
};
var $author$project$Components$Shared$Tabs$view = function (options) {
	var viewTab = function (value) {
		return _Utils_eq(options.selected, value) ? $author$project$Components$Shared$Tabs$buttons.disabled.primary(
			{
				label: options.toString(value),
				useComponentSelectorStyle: options.useComponentSelectorStyle
			}) : $author$project$Components$Shared$Tabs$buttons._default(
			{
				label: options.toString(value),
				onClick: options.onSelect(value),
				useComponentSelectorStyle: options.useComponentSelectorStyle
			});
	};
	var containerClass = options.useComponentSelectorStyle ? 'component-selector' : 'hub-button__tabs';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(containerClass)
			]),
		A2($elm$core$List$map, viewTab, options.choices));
};
var $author$project$Components$DocumentsBrowser$CompareBolAndRateConClicked = function (a) {
	return {$: 'CompareBolAndRateConClicked', a: a};
};
var $author$project$Components$DocumentBrowser$BolRateConPair$resolvedType = function (document) {
	var _v0 = document.documentTypeValue;
	if (_v0.$ === 'Document_DocumentTypeValue_DocumentType') {
		var documentType = _v0.a;
		return $elm$core$Maybe$Just(documentType);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$DocumentBrowser$BolRateConPair$firstOfTypes = F2(
	function (types, _v0) {
		var documentPages = _v0.documentPages;
		var documents = _v0.documents;
		return A2(
			$elm$core$Maybe$map,
			function (documentIndex) {
				return {documentIndex: documentIndex, pageIndex: 0};
			},
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (_v1) {
					var document = _v1.a;
					var pages = _v1.b;
					return (!$elm$core$List$isEmpty(pages)) && A2(
						$elm$core$List$member,
						$author$project$Components$DocumentBrowser$BolRateConPair$resolvedType(document),
						A2($elm$core$List$map, $elm$core$Maybe$Just, types));
				},
				A3($elm$core$List$map2, $elm$core$Tuple$pair, documents, documentPages)));
	});
var $author$project$Components$DocumentBrowser$BolRateConPair$find = function (documentData) {
	return {
		bol: A2(
			$author$project$Components$DocumentBrowser$BolRateConPair$firstOfTypes,
			_List_fromArray(
				[$author$project$AuditPb$DocumentTypeBillOfLading, $author$project$AuditPb$DocumentTypeHiddenBillOfLading]),
			documentData),
		rateCon: A2(
			$author$project$Components$DocumentBrowser$BolRateConPair$firstOfTypes,
			_List_fromArray(
				[$author$project$AuditPb$DocumentTypeRateConfirmation, $author$project$AuditPb$DocumentTypeCarrierRateConfirmation]),
			documentData)
	};
};
var $author$project$Components$DocumentsBrowser$sideBySideIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('14'),
			$elm$svg$Svg$Attributes$height('14'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$strokeWidth('2'),
			$elm$svg$Svg$Attributes$strokeLinecap('round'),
			$elm$svg$Svg$Attributes$strokeLinejoin('round'),
			A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('18'),
					$elm$svg$Svg$Attributes$height('18'),
					$elm$svg$Svg$Attributes$x('3'),
					$elm$svg$Svg$Attributes$y('3'),
					$elm$svg$Svg$Attributes$rx('2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 3v18')
				]),
			_List_Nil)
		]));
var $author$project$Components$DocumentsBrowser$viewBolRateConCompareButton = function (documentData) {
	var _v0 = $author$project$Components$DocumentBrowser$BolRateConPair$find(documentData);
	var rateCon = _v0.rateCon;
	var bol = _v0.bol;
	var _v1 = _Utils_Tuple2(bol, rateCon);
	if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
		var bolSelection = _v1.a.a;
		var rateConSelection = _v1.b.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__header-compare')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__header-compare-button'),
							$elm$html$Html$Events$onClick(
							$author$project$Components$DocumentsBrowser$CompareBolAndRateConClicked(
								{bol: bolSelection, rateCon: rateConSelection}))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Compare BOL & Rate Con'),
							$author$project$Components$DocumentsBrowser$sideBySideIcon
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$DocumentsBrowser$ToggleDocumentTypePicker = {$: 'ToggleDocumentTypePicker'};
var $author$project$Components$DocumentsBrowser$viewDocumentTypeDropdown = F2(
	function (maybeDocument, enabledDocumentTypes) {
		if (maybeDocument.$ === 'Just') {
			var document = maybeDocument.a;
			var currentType = $author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue);
			var currentTypeName = A2(
				$elm$core$Maybe$withDefault,
				'Unknown',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.name;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (dt) {
								return _Utils_eq(
									$author$project$Domain$UnresolvedDocumentType$Resolved(dt.documentType),
									currentType);
							},
							enabledDocumentTypes))));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__header-document-type'),
						$elm$html$Html$Events$onClick($author$project$Components$DocumentsBrowser$ToggleDocumentTypePicker)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('document-browser__header-document-type-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(currentTypeName)
							])),
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-pencil document-browser__header-document-type-icon')
							]),
						_List_Nil)
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$DocumentsBrowser$ExpandClicked = {$: 'ExpandClicked'};
var $author$project$Components$DocumentsBrowser$viewExpandButton = function (expanded) {
	var _v0 = expanded ? _Utils_Tuple2('fi-arrows-compress', 'Collapse Document Browser') : _Utils_Tuple2('fi-arrows-expand', 'Expand Document Browser');
	var iconClass = _v0.a;
	var title = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('document-browser__header-expand-link')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__header-expand_browser'),
						$elm$html$Html$Attributes$title(title),
						$elm$html$Html$Events$onClick($author$project$Components$DocumentsBrowser$ExpandClicked)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(iconClass)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Components$DocumentsBrowser$PopoutClicked = {$: 'PopoutClicked'};
var $author$project$Components$DocumentsBrowser$viewPopoutButton = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('document-browser__header-popout-link')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title('Open Document Browser in a New Window'),
					$elm$html$Html$Events$onClick($author$project$Components$DocumentsBrowser$PopoutClicked)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-arrows-out')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Components$DocumentsBrowser$viewDocBrowserTabs = F3(
	function (model, options, data) {
		var showAllLoadDocsLink = model.showAllLoadDocsToggled ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__toggle-docs-link'),
					$elm$html$Html$Events$onClick(
					$author$project$Components$DocumentsBrowser$ToggleShowAllLoadDocs(false))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Hide all load documents')
				])) : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__toggle-docs-link'),
					$elm$html$Html$Events$onClick(
					$author$project$Components$DocumentsBrowser$ToggleShowAllLoadDocs(true))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Show all load documents')
				]));
		var maybeShowAllLoadDocsLink = A2($author$project$Components$DocumentsBrowser$undisplayedLoadDocsPresent, model.currentProcessingSelection, data.documentData) ? showAllLoadDocsLink : $elm$html$Html$text('');
		var maybePopoutButton = options.popoutButton ? $author$project$Components$DocumentsBrowser$viewPopoutButton : $elm$html$Html$text('');
		var maybeExpandButton = function () {
			var _v0 = options.expandButton;
			if (_v0.$ === 'Just') {
				var expanded = _v0.a.expanded;
				return $author$project$Components$DocumentsBrowser$viewExpandButton(expanded);
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var maybeDocumentTypeDropdown = function () {
			if (A2($author$project$Components$DocumentsBrowser$isActionEnabled, $author$project$Components$DocumentsBrowser$UpdateDocumentTypeAction, model)) {
				var selection = A2($author$project$Components$DocumentsBrowser$selectedPage, data, model);
				var possiblyGroupedDocuments = A2($author$project$Components$DocumentsBrowser$getPossiblyGroupedDocuments, data, model);
				var maybeDocument = A2($author$project$Components$DocumentBrowser$Full$selectedDocument, possiblyGroupedDocuments, selection);
				return A2($author$project$Components$DocumentsBrowser$viewDocumentTypeDropdown, maybeDocument, model.enabledDocumentTypes);
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var maybeCloseButton = options.enableCloseButton ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__header-close-link'),
					$elm$html$Html$Events$onClick($author$project$Components$DocumentsBrowser$CloseClicked)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-x-circle')
								]),
							_List_Nil)
						]))
				])) : $elm$html$Html$text('');
		var maybeBolRateConCompareButton = (options.enableBolRateConCompare && _Utils_eq(model.selectedTab, $author$project$Components$DocumentsBrowser$Documents)) ? $author$project$Components$DocumentsBrowser$viewBolRateConCompareButton(
			A2($author$project$Components$DocumentsBrowser$getDocumentData, data, model)) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__header-component-selection')
						]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Tabs$view(
							{
								choices: _List_fromArray(
									[$author$project$Components$DocumentsBrowser$Documents, $author$project$Components$DocumentsBrowser$Messages, $author$project$Components$DocumentsBrowser$Activity]),
								onSelect: $author$project$Components$DocumentsBrowser$SelectTab,
								selected: model.selectedTab,
								toString: $author$project$Components$DocumentsBrowser$tabToString,
								useComponentSelectorStyle: true
							})
						])),
					maybeBolRateConCompareButton,
					maybeDocumentTypeDropdown,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__header-current')
						]),
					_List_fromArray(
						[maybeShowAllLoadDocsLink])),
					maybeCloseButton,
					maybeExpandButton,
					maybePopoutButton
				]));
	});
var $author$project$Components$DocumentsBrowser$ChangeActivityTabPage = function (a) {
	return {$: 'ChangeActivityTabPage', a: a};
};
var $author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$Idle = {$: 'Idle'};
var $author$project$Components$DocumentsBrowser$ResendToCadence = function (a) {
	return {$: 'ResendToCadence', a: a};
};
var $author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$Sending = {$: 'Sending'};
var $author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$Sent = {$: 'Sent'};
var $author$project$Components$DocumentsBrowser$UnapproveFromActivity = {$: 'UnapproveFromActivity'};
var $author$project$Helpers$Date$toString = F2(
	function (tz, date) {
		return A2($author$project$Helpers$Date$dateString, tz, date) + (' ' + A2($author$project$Helpers$Date$timeString, tz, date));
	});
var $author$project$Components$DocumentBrowser$ActivityView$time = F2(
	function (tz, activityItem) {
		return $elm$html$Html$text(
			A2($author$project$Helpers$Date$toString, tz, activityItem.createdAt));
	});
var $author$project$Domain$ActivityItem$userNameToString = function (activityItem) {
	return A2($elm$core$Maybe$withDefault, activityItem.automatedDisplayName, activityItem.userName);
};
var $author$project$Components$DocumentBrowser$ActivityView$detailBrowser = F5(
	function (tz, activityItem, isDetailed, label, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('activity-item__container', true),
							_Utils_Tuple2('activity-item__container--detailed', isDetailed)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-item__meta')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('activity-item__user')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Domain$ActivityItem$userNameToString(activityItem))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('activity-item__timestamp')
										]),
									_List_fromArray(
										[
											A2($author$project$Components$DocumentBrowser$ActivityView$time, tz, activityItem)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-item__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[value]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Details$DetailLine$detailLine = F2(
	function (label, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('activity-item__detail-line')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Details$DetailLine$detailLineWithNoLabel = function (value) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('activity-item__detail-line')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('activity-item__detail-line-value')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(value)
					]))
			]));
};
var $author$project$Components$DocumentBrowser$ActivityView$documentTypeDisplay = F2(
	function (accountSettings, documentType) {
		var maybeDocumentTypeDerivedName = function () {
			switch (documentType.$) {
				case 'Resolved':
					var documentType_ = documentType.a;
					return $elm$core$Maybe$Just(
						A3($author$project$Domain$DocumentType$toString, accountSettings.customDocumentTypeNames, $author$project$Domain$Environment$BrokerEnvironment, documentType_));
				case 'Partial':
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return A2($elm$core$Maybe$withDefault, 'A document', maybeDocumentTypeDerivedName);
	});
var $author$project$Components$DocumentBrowser$ActivityView$empty = A2($elm$html$Html$div, _List_Nil, _List_Nil);
var $author$project$Domain$ActivityItem$flaggedForManualReviewReasonToString = function (reason) {
	switch (reason.$) {
		case 'FlaggedForManualReviewReasonHitClientThreshold':
			return 'Randomly Selected for Review Based on Client Setting';
		case 'FlaggedForManualReviewReasonHitAccountThreshold':
			return 'Randomly Selected for Review Based on Account Setting';
		case 'FlaggedForManualReviewReasonHitClientCreditRatingThreshold':
			return 'Randomly Selected for Review Based on Client Credit Rating';
		case 'FlaggedForManualReviewReasonFailedAutoVerification':
			return 'Auto Verification Failed';
		case 'FlaggedForManualReviewReasonMarkedAsFuelAdvance':
			return 'Invoice is Marked as a Fuel Advance';
		case 'FlaggedForManualReviewReasonBrokerDomainMismatch':
			return 'Email on Rate Confirmation Does Not Match Known Broker Domains';
		default:
			return 'Debtor Excluded from Auto Processing';
	}
};
var $author$project$Components$DocumentBrowser$ActivityView$invoicesInBatchLine = function (invoiceCount) {
	if (invoiceCount.$ === 'Just') {
		var count = invoiceCount.a;
		return (count > 1) ? _List_fromArray(
			[
				A2(
				$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
				'Invoices in Batch',
				$elm$core$String$fromInt(count))
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm_community$string_extra$String$Extra$toSentenceBaseCase = function (list) {
	_v0$2:
	while (true) {
		if (list.b) {
			if (!list.b.b) {
				var x = list.a;
				return x;
			} else {
				if (!list.b.b.b) {
					var x = list.a;
					var _v1 = list.b;
					var y = _v1.a;
					return x + (' and ' + y);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return '';
};
var $elm_community$string_extra$String$Extra$toSentenceHelper = F3(
	function (lastPart, sentence, list) {
		toSentenceHelper:
		while (true) {
			if (!list.b) {
				return sentence;
			} else {
				if (!list.b.b) {
					var x = list.a;
					return _Utils_ap(
						sentence,
						_Utils_ap(lastPart, x));
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$lastPart = lastPart,
						$temp$sentence = sentence + (', ' + x),
						$temp$list = xs;
					lastPart = $temp$lastPart;
					sentence = $temp$sentence;
					list = $temp$list;
					continue toSentenceHelper;
				}
			}
		}
	});
var $elm_community$string_extra$String$Extra$toSentenceOxford = function (list) {
	if ((list.b && list.b.b) && list.b.b.b) {
		var x = list.a;
		var _v1 = list.b;
		var y = _v1.a;
		var _v2 = _v1.b;
		var z = _v2.a;
		var more = _v2.b;
		return A3(
			$elm_community$string_extra$String$Extra$toSentenceHelper,
			', and ',
			x + (', ' + y),
			A2($elm$core$List$cons, z, more));
	} else {
		return $elm_community$string_extra$String$Extra$toSentenceBaseCase(list);
	}
};
var $author$project$Domain$ActivityItem$ltlDisputeAddedDisputeItemMessages = function (disputeItems) {
	var dictEntryToStrings = F3(
		function (reconcileTypeString, items, strings) {
			return A2(
				$elm$core$List$cons,
				$elm_community$string_extra$String$Extra$toSentenceCase(reconcileTypeString) + (' disputed for ' + $elm_community$string_extra$String$Extra$toSentenceOxford(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.description;
						},
						items))),
				strings);
		});
	return A3(
		$elm$core$Dict$foldl,
		dictEntryToStrings,
		_List_Nil,
		A2(
			$elm_community$dict_extra$Dict$Extra$groupBy,
			A2(
				$elm$core$Basics$composeL,
				$author$project$AuditPb$ltlCarrierInvoiceReconcileTypeToString,
				function ($) {
					return $.reconcileType;
				}),
			disputeItems));
};
var $author$project$Components$DocumentBrowser$ActivityView$ruleDescriptionWithPrefix = F4(
	function (tz, activityItem, prefix, details_) {
		return A5(
			$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
			tz,
			activityItem,
			false,
			_Utils_ap(prefix, details_.rule.displayText),
			$author$project$Components$DocumentBrowser$ActivityView$empty);
	});
var $author$project$Domain$ActivityItem$thisInvoiceAndOthers = function (invoiceCount) {
	var _v0 = A2($elm$core$Maybe$withDefault, 1, invoiceCount) - 1;
	if (_v0 === 1) {
		return 'this invoice and 1 other';
	} else {
		var others = _v0;
		return (others > 1) ? ('this invoice and ' + ($elm$core$String$fromInt(others) + ' others')) : 'this invoice';
	}
};
var $author$project$Components$DocumentBrowser$ActivityView$unapproveView = F2(
	function (invoiceCount, config) {
		var _v0 = config.factorInvoiceState;
		if (_v0.$ === 'Just') {
			switch (_v0.a.$) {
				case 'Approved':
					var _v1 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-item__actions')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button--progress button--resend-to-cadence'),
											$elm$html$Html$Events$onClick(config.onUnapprove)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Unapprove ' + $author$project$Domain$ActivityItem$thisInvoiceAndOthers(invoiceCount))
										]))
								]))
						]);
				case 'Purchased':
					var _v2 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message--resent-to-cadence')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('This invoice has been marked as purchased. Contact support to un-approve.')
								]))
						]);
				default:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message--resent-to-cadence')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Un-approved ' + $author$project$Domain$ActivityItem$thisInvoiceAndOthers(invoiceCount))
								]))
						]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$ActivityBrowser$Details$AcceptAddedDetailsView$view = function (details) {
	var withLabel = F2(
		function (label, maybeValue) {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine(label),
				maybeValue);
		});
	var formatAcceptItem = function (item) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineWithNoLabel(item.description)),
					A2(
					withLabel,
					'Original Class',
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.original;
						},
						item.classChange)),
					A2(
					withLabel,
					'Updated Class',
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.updated;
						},
						item.classChange)),
					A2(
					withLabel,
					'Original Weight',
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.original;
						},
						item.weightChange)),
					A2(
					withLabel,
					'Updated Weight',
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.updated;
						},
						item.weightChange)),
					A2(
					withLabel,
					'Original Amount',
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.original;
						},
						item.amountChange)),
					A2(
					withLabel,
					'Updated Amount',
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.updated;
						},
						item.amountChange))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$concatMap, formatAcceptItem, details.acceptItems));
};
var $author$project$Components$ActivityBrowser$Details$AddDocumentToLoadSuccessDetailsView$view = F3(
	function (account, accountSettings, details) {
		var documentTypeToString = function (documentType) {
			return A3(
				$author$project$Domain$Helpers$documentTypeToString,
				account,
				accountSettings,
				$author$project$Domain$UnresolvedDocumentType$deserialize(
					$author$project$AuditPb$documentTypeToString(documentType)));
		};
		var sentence = A3(
			$author$project$Helpers$String$toSentence,
			'none',
			'and',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.documentType;
					},
					A2($elm_community$maybe_extra$Maybe$Extra$unwrap, 'Unknown', documentTypeToString)),
				details.documents));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineWithNoLabel(sentence + ' uploaded')
				]));
	});
var $author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$formatAmount = function (amount) {
	return $author$project$Money$toString(
		$author$project$Money$castFromString(amount));
};
var $author$project$Components$ActivityBrowser$Details$DetailLine$detailLineHtml = F2(
	function (label, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('activity-item__detail-line')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-label')
						]),
					label),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-value')
						]),
					value)
				]));
	});
var $author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$changedNote = F3(
	function (changedBy, formatSystemValue, systemValue) {
		return 'changed by ' + (changedBy + (', system had ' + A2(
			$elm$core$Maybe$withDefault,
			'nothing',
			A2($elm$core$Maybe$map, formatSystemValue, systemValue))));
	});
var $author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$sourceNote = F2(
	function (formatSystemValue, source) {
		var _v0 = source.kind;
		switch (_v0.$) {
			case 'FactorInvoiceFieldSourceKindPrefilledBySystem':
				return $elm$core$Maybe$Nothing;
			case 'FactorInvoiceFieldSourceKindChangedByUser':
				return $elm$core$Maybe$Just(
					A3(
						$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$changedNote,
						A2($elm$core$Maybe$withDefault, 'user', source.changedByName),
						formatSystemValue,
						source.systemValue));
			default:
				return $elm$core$Maybe$Just(
					A3($author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$changedNote, 'support', formatSystemValue, source.systemValue));
		}
	});
var $author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$sourcedDetailLine = F4(
	function (label, value, source, formatSystemValue) {
		return A2(
			$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineHtml,
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$text(value),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (note) {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('activity-item__detail-line-source')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('· ' + note)
										]))
								]);
						},
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$sourceNote(formatSystemValue),
							source)))));
	});
var $author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$view = F2(
	function (details, carrierName) {
		var sources = details.fieldSources;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A4(
							$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$sourcedDetailLine,
							'Invoice Number',
							A2($elm$core$Maybe$withDefault, '', details.invoiceNumber),
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.invoiceNumberSource;
								},
								sources),
							$elm$core$Basics$identity)),
						A2(
						$elm$core$Maybe$map,
						function (loadId) {
							return A4(
								$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$sourcedDetailLine,
								'Load ID',
								loadId,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.loadIdSource;
									},
									sources),
								$elm$core$Basics$identity);
						},
						details.loadId),
						$elm$core$Maybe$Just(
						A4(
							$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$sourcedDetailLine,
							'Amount',
							$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$formatAmount(
								A2($elm$core$Maybe$withDefault, '', details.amountToPay)),
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.amountSource;
								},
								sources),
							$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$formatAmount)),
						A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Helpers$Date$dateStringFromDate,
							$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine('Invoice Date')),
						details.invoiceDate),
						A2(
						$elm$core$Maybe$map,
						$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine(
							$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount)),
						carrierName),
						$elm$core$Maybe$Just(
						A4(
							$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$sourcedDetailLine,
							'Debtor',
							details.debtorName,
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.debtorSource;
								},
								sources),
							$elm$core$Basics$identity))
					])));
	});
var $author$project$Components$ActivityBrowser$Details$LoadShipmentApprovalDetailsView$view = function (details) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Shipment ID', details.shipmentId),
				A2(
				$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
				'Amount',
				$author$project$Money$toString(
					$author$project$Money$castFromString(
						A2($elm$core$Maybe$withDefault, '', details.amount)))),
				A2(
				$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
				'Customer ID',
				A2($elm$core$Maybe$withDefault, '', details.customerId)),
				A2(
				$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
				'Customer Name',
				A2($elm$core$Maybe$withDefault, '', details.customerName))
			]));
};
var $author$project$Components$ActivityBrowser$Details$LoadShipmentUnapprovalDetailsView$view = function (details) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Shipment ID', details.shipmentId),
				A2(
				$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
				'Amount',
				$author$project$Money$toString(
					$author$project$Money$castFromString(
						A2($elm$core$Maybe$withDefault, '', details.amount)))),
				A2(
				$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
				'Customer ID',
				A2($elm$core$Maybe$withDefault, '', details.customerId)),
				A2(
				$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
				'Customer Name',
				A2($elm$core$Maybe$withDefault, '', details.customerName))
			]));
};
var $author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$isResendableState = function (maybeState) {
	if (maybeState.$ === 'Just') {
		switch (maybeState.a.$) {
			case 'Approved':
				var _v1 = maybeState.a;
				return true;
			case 'Purchased':
				var _v2 = maybeState.a;
				return true;
			default:
				return false;
		}
	} else {
		return true;
	}
};
var $author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$view = function (config) {
	var _v0 = config.transmissionId;
	if (_v0.$ === 'Nothing') {
		return $elm$html$Html$text('');
	} else {
		var transmissionId = _v0.a;
		if (!config.currentUser.isAdmin) {
			return $elm$html$Html$text('');
		} else {
			if (!_Utils_eq(
				config.transmissionType,
				$elm$core$Maybe$Just('cadence'))) {
				return $elm$html$Html$text('');
			} else {
				if (!$author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$isResendableState(config.factorInvoiceState)) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message--resent-to-cadence')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Invoices have been un-approved and cannot be resent until re-approved')
							]));
				} else {
					var invoices = $author$project$Domain$ActivityItem$thisInvoiceAndOthers(config.invoiceCount) + ' to FactorSoft';
					var _v1 = config.resendState;
					switch (_v1.$) {
						case 'Sent':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message--resent-to-cadence')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Resent ' + invoices)
									]));
						case 'Sending':
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button--disabled button--resend-to-cadence'),
										$elm$html$Html$Attributes$disabled(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Resending ' + invoices)
									]));
						default:
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button--progress button--resend-to-cadence'),
										$elm$html$Html$Events$onClick(
										config.onResend(transmissionId))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Resend ' + invoices)
									]));
					}
				}
			}
		}
	}
};
var $author$project$Components$DocumentBrowser$ActivityView$details = F7(
	function (account, accountSettings, tz, onUnapprove, maybeResendConfig, carrierName, activityItem) {
		var _v0 = activityItem.details;
		switch (_v0.$) {
			case 'ClientOrDebtorOnBolChanged':
				var details_ = _v0.a;
				var message = $elm$core$String$concat(
					_List_fromArray(
						['Client or Debtor on BOL value changed to ', details_.to]));
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, message, $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'DebtorCorrected':
				var details_ = _v0.a;
				var message = function () {
					var _v1 = details_.previousDebtorName;
					if (_v1.$ === 'Just') {
						var previousDebtorName = _v1.a;
						return $elm$core$String$concat(
							_List_fromArray(
								['Debtor corrected from ', previousDebtorName, ' to ', details_.correctedDebtorName, '.']));
					} else {
						return $elm$core$String$concat(
							_List_fromArray(
								['Debtor corrected to ', details_.correctedDebtorName, '.']));
					}
				}();
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, message, $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'DocumentAdded':
				var details_ = _v0.a;
				var showLoadId = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (original) {
							return !$elm$core$String$isEmpty(original.load_id);
						},
						details_.original));
				var detailLines = showLoadId ? _List_fromArray(
					[
						A2(
						$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
						'Original Load',
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function (original) {
									return original.load_id;
								},
								details_.original)))
					]) : _List_Nil;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						showLoadId,
						A2($author$project$Components$DocumentBrowser$ActivityView$documentTypeDisplay, accountSettings, details_.documentType) + ' added to invoice',
						A2($elm$html$Html$div, _List_Nil, detailLines)));
			case 'DocumentAssigned':
				return $elm$core$Maybe$Nothing;
			case 'DocumentBatchIgnored':
				var ignoredDetails = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						false,
						'Documents marked as ignored',
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$DocumentBrowser$ActivityView$empty,
							A2(
								$elm$core$Maybe$map,
								function (r) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'font-size', '12px'),
												A2($elm$html$Html$Attributes$style, 'color', '#666')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reason: ' + r)
											]));
								},
								ignoredDetails.reason))));
			case 'ContactAdded':
				return $elm$core$Maybe$Nothing;
			case 'DocumentRemoved':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						false,
						A2($author$project$Components$DocumentBrowser$ActivityView$documentTypeDisplay, accountSettings, details_.documentType) + ' removed from invoice',
						$author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'DocumentSentToExternal':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Document Sent',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'Document Type',
									A2($author$project$Components$DocumentBrowser$ActivityView$documentTypeDisplay, accountSettings, details_.documentType)),
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Load ID', details_.loadId)
								]))));
			case 'ExceptionsClearedViaAPI':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Exceptions cleared via API', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'ExceptionDocumentsSent':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, true, 'Exception documents sent', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'ExceptionResolved':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						$elm$core$String$concat(
							_List_fromArray(
								[
									'Exception: ',
									A2(
									$elm$core$Maybe$withDefault,
									' ',
									A2($elm$core$Maybe$map, $author$project$Helpers$String$quote, details_.message)),
									' resolved'
								])),
						$author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'FactoringAssignment':
				return $elm$core$Maybe$Nothing;
			case 'ForwardedEmail':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Email was forwarded to ' + A2($elm$core$String$join, ', ', details_.recipients),
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'Note',
									A2($elm$core$Maybe$withDefault, '', details_.note))
								]))));
			case 'InvoiceDocumentsForwardedToTriumph':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'InvoiceDocumentsForwardedToTriumph', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'EmailMergeSource':
				return $elm$core$Maybe$Nothing;
			case 'EmailMergeTarget':
				return $elm$core$Maybe$Nothing;
			case 'EmailIgnored':
				return $elm$core$Maybe$Nothing;
			case 'EmailUnignored':
				return $elm$core$Maybe$Nothing;
			case 'EmailZeroPages':
				return $elm$core$Maybe$Nothing;
			case 'EmailCompleted':
				return $elm$core$Maybe$Nothing;
			case 'DuplicateEmailAutoCompleted':
				return $elm$core$Maybe$Nothing;
			case 'AutoCompletedWaitingExceptionsOnNewDocs':
				return $elm$core$Maybe$Nothing;
			case 'DuplicateDocumentBatchAutoCompleted':
				return $elm$core$Maybe$Nothing;
			case 'DuplicateDocumentAutoHidden':
				return $elm$core$Maybe$Nothing;
			case 'DuplicateDocumentAutoMerged':
				return $elm$core$Maybe$Nothing;
			case 'InvoiceAbandoned':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice Ignored',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'Reason',
									A2($elm$core$Maybe$withDefault, 'Not Provided', details_.reason))
								]))));
			case 'InvoiceApproved':
				var details_ = _v0.a;
				var body = _Utils_ap(
					$author$project$Components$DocumentBrowser$ActivityView$invoicesInBatchLine(details_.invoiceCount),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$DocumentBrowser$ActivityView$unapproveView(details_.invoiceCount),
							onUnapprove)));
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						!$elm$core$List$isEmpty(body),
						'Invoice Approved',
						A2($elm$html$Html$div, _List_Nil, body)));
			case 'CarrierPayableApproved':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, true, 'Carrier Payable Approved', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'InvoiceDocumentsResendRequested':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice Documents Resend Requested', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'InvoiceCreatedByExternal':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice Created From ' + $author$project$Helpers$String$capitalize(details_.sourceSystem),
						$author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'InvoiceMatched':
				return $elm$core$Maybe$Nothing;
			case 'InvoiceMarkedAsPurchased':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice Marked as Purchased', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'InvoiceProcessed':
				var processedDetails = _v0.a;
				if (processedDetails.$ === 'FactorInvoiceProcessedDetails_') {
					var details_ = processedDetails.a;
					return $elm$core$Maybe$Just(
						A5(
							$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
							tz,
							activityItem,
							true,
							'Invoice Processed',
							A2(
								$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$view,
								details_,
								carrierName(details_.tmsCarrierId))));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 'InvoiceAutoProcessed':
				var processedDetails = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice Processed',
						A2(
							$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$view,
							processedDetails,
							carrierName(processedDetails.tmsCarrierId))));
			case 'InvoiceRejected':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice Rejected', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'SentToVerifyQueue':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice sent to verify queue', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'BypassedVerifyQueue':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice bypassed verify queue', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'VerifierChangedInvoiceAmount':
				var amountDetails = _v0.a;
				var oldAmount = $author$project$Money$toString(
					$author$project$Money$castFromString(amountDetails.oldAmount));
				var newAmount = $author$project$Money$toString(
					$author$project$Money$castFromString(amountDetails.newAmount));
				var title = 'Changed invoice amount during verification from ' + (oldAmount + (' to ' + (newAmount + '.')));
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, title, $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'MarkedNotReadyForVerification':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Marked not ready for Verification', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'VerificationBatchStarted':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Verification batch started', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'VerifyCompleted':
				var verifyDetails = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice verification completed: ' + verifyDetails.status,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-item__detail-full-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Components$DocumentBrowser$ActivityView$empty,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine('Note'),
										verifyDetails.note))
								]))));
			case 'InvoiceRemovedFromGroup':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice Removed From Group', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'InvoiceUnapproved':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice Unapproved', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'InvoiceUnignored':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice Unignored', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'NoteAdded':
				var message = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Note Added',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-item__detail-full-body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]))));
			case 'NoteSentToPaymentsNetwork':
				var message = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Note Sent to Payee via Payments Network',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-item__detail-full-body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]))));
			case 'ReceivedInvoice':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Indexed documents sent to TMS', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'Paused':
				var pausedUntil = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						false,
						'Load paused until ' + A2($author$project$Helpers$Date$toString, tz, pausedUntil),
						$author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'PaymentAddressChanged':
				return $elm$core$Maybe$Nothing;
			case 'RuleDisabled':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A4($author$project$Components$DocumentBrowser$ActivityView$ruleDescriptionWithPrefix, tz, activityItem, 'Rule Disabled: ', details_));
			case 'RuleEnabled':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A4($author$project$Components$DocumentBrowser$ActivityView$ruleDescriptionWithPrefix, tz, activityItem, 'Rule Enabled: ', details_));
			case 'SavedAsIncomplete':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Saved as Incomplete', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'StateChanged':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Load moved to ' + (details_.newState + (' from ' + details_.originalState)),
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Reason', details_.reason)
								]))));
			case 'SentToExternal':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice Successfully Sent',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'Recipient',
									A2($elm$core$Maybe$withDefault, '', details_.url)),
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Response', details_.response),
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'File Name',
									A2($elm$core$Maybe$withDefault, '', details_.filename)),
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Data', details_.payload)
								]))));
			case 'SentToCadence':
				var sentToCadenceDetails = _v0.a;
				var resendView = function () {
					if (maybeResendConfig.$ === 'Just') {
						var resendConfig = maybeResendConfig.a;
						return _List_fromArray(
							[
								$author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$view(
								{
									currentUser: resendConfig.currentUser,
									factorInvoiceState: resendConfig.factorInvoiceState,
									invoiceCount: sentToCadenceDetails.invoiceCount,
									onResend: resendConfig.onResend,
									resendState: A2(
										$elm$core$Maybe$withDefault,
										$author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$Idle,
										A2($elm$core$Maybe$map, resendConfig.resendState, sentToCadenceDetails.transmissionId)),
									transmissionId: sentToCadenceDetails.transmissionId,
									transmissionType: sentToCadenceDetails.transmissionType
								})
							]);
					} else {
						return _List_Nil;
					}
				}();
				var batchLine = $author$project$Components$DocumentBrowser$ActivityView$invoicesInBatchLine(sentToCadenceDetails.invoiceCount);
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						(!_Utils_eq(maybeResendConfig, $elm$core$Maybe$Nothing)) || (!$elm$core$List$isEmpty(batchLine)),
						'Sent to FactorSoft',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_Utils_ap(batchLine, resendView))));
			case 'ReadyForFmsPickup':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Ready for FMS Pickup', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'AcknowledgedByFms':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Acknowledged by FMS', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'NonInvoiceLoadAssignment':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Non-Invoice Load Assignment', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'TransmissionReceived':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice transmission received', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'TransmissionFailed':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Transmission Failed',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-item__detail-full-body')
								]),
							$elm$core$List$singleton(
								$elm$html$Html$text(
									'Error Message: ' + A2($elm$core$Maybe$withDefault, 'Not provided', details_.failure_message))))));
			case 'TransmissionSucceeded':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice transmission succeeded', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'UpdatedFromExternal':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice Updated From FactorSoft',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Updated Attribute', details_.updatedAttribute),
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'Previous Value',
									A2($elm$core$Maybe$withDefault, '', details_.previousValue)),
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'New Value',
									A2($elm$core$Maybe$withDefault, '', details_.newValue))
								]))));
			case 'VerifiedByCadence':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice Successfully Received By FactorSoft', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'ShipmentApproved':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Shipment Approved',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'VIN', details_.vin)
								]))));
			case 'ShipmentRejected':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Shipment Rejected',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'VIN', details_.vin),
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'Reason',
									A2($elm$core$Maybe$withDefault, '', details_.reason))
								]))));
			case 'LoadDocumentsApproved':
				return $elm$core$Maybe$Nothing;
			case 'LoadDocumentsScraped':
				return $elm$core$Maybe$Nothing;
			case 'LoadDocumentsAssigned':
				return $elm$core$Maybe$Nothing;
			case 'LoadDocumentsSent':
				return $elm$core$Maybe$Nothing;
			case 'BuiltLoadSentToTMS':
				return $elm$core$Maybe$Nothing;
			case 'PodRequestSentToTextLocate':
				return $elm$core$Maybe$Nothing;
			case 'BuiltLoadConfirmed':
				return $elm$core$Maybe$Nothing;
			case 'LoadShipmentApproval':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Shipment Approved',
						$author$project$Components$ActivityBrowser$Details$LoadShipmentApprovalDetailsView$view(details_)));
			case 'LoadShipmentUnapproval':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Shipment Un-Approved',
						$author$project$Components$ActivityBrowser$Details$LoadShipmentUnapprovalDetailsView$view(details_)));
			case 'InvoiceExceptionEmailSent':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Email sent on exception', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'LtlDisputeAdded':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice reconciliation action taken',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineWithNoLabel,
								$author$project$Domain$ActivityItem$ltlDisputeAddedDisputeItemMessages(details_.disputeItems)))));
			case 'Hidden':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, true, details_.message, $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'LtlAcceptAdded':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Weight / Class / Amount changed and re-rate initiated',
						$author$project$Components$ActivityBrowser$Details$AcceptAddedDetailsView$view(details_)));
			case 'LtlUpdatedEdiReceived':
				return $elm$core$Maybe$Nothing;
			case 'LtlInvoiceMovedToTMSQueue':
				var data_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice moved to TMS',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Queue Name', data_.queueName),
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Reason', data_.reason)
								]))));
			case 'AddDocumentToLoadSuccess':
				var details_ = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Load documents uploaded',
						A3($author$project$Components$ActivityBrowser$Details$AddDocumentToLoadSuccessDetailsView$view, account, accountSettings, details_)));
			case 'AddDocumentToLoadFailure':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, true, 'Documents failed to upload', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'FlaggedForManualReview':
				var reason = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Invoice Flagged for Manual Review',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
									'Reason',
									$author$project$Domain$ActivityItem$flaggedForManualReviewReasonToString(reason))
								]))));
			case 'LtlRerateRequested':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Re-Rate Requested', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'CarrierInvoiceRuleChangedViaTms':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Invoice rule resolved by TMS update', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'LtlRerateCompleted':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Re-Rate Completed', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'LtlRerateFailed':
				var reason = _v0.a;
				return $elm$core$Maybe$Just(
					A5(
						$author$project$Components$DocumentBrowser$ActivityView$detailBrowser,
						tz,
						activityItem,
						true,
						'Re-Rate Failed',
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Error Message', reason.errorMessage)
								]))));
			case 'DocumentsMerged':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Documents Merged', $author$project$Components$DocumentBrowser$ActivityView$empty));
			case 'LineItemsAutoReplaced':
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Line Items Auto-Replaced', $author$project$Components$DocumentBrowser$ActivityView$empty));
			default:
				return $elm$core$Maybe$Just(
					A5($author$project$Components$DocumentBrowser$ActivityView$detailBrowser, tz, activityItem, false, 'Indexing Complete', $author$project$Components$DocumentBrowser$ActivityView$empty));
		}
	});
var $author$project$Helpers$Pagination$currentPage = function (page) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Page ' + $elm$core$String$fromInt(page + 1))
				]))
		]);
};
var $author$project$Helpers$Pagination$visibleIf = function (condition) {
	return condition ? _Utils_Tuple2('visibility', 'visible') : _Utils_Tuple2('visibility', 'hidden');
};
var $author$project$Helpers$Pagination$nextPageLink = F3(
	function (page, hasMore, msgOnClick) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('right'),
						msgOnClick(page + 1),
						function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return A2($elm$html$Html$Attributes$style, a, b);
					}(
						$author$project$Helpers$Pagination$visibleIf(hasMore))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Next Page')
					]))
			]);
	});
var $author$project$Helpers$Pagination$previousPageLink = F2(
	function (page, msgOnClick) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('left'),
						msgOnClick(page - 1),
						function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return A2($elm$html$Html$Attributes$style, a, b);
					}(
						$author$project$Helpers$Pagination$visibleIf(page > 0))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Previous Page')
					]))
			]);
	});
var $author$project$Helpers$Pagination$safeOnClick = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: true, stopPropagation: true}));
};
var $author$project$Helpers$Pagination$pagination_ = F4(
	function (safe, page, hasMore, msg) {
		var msgOnClick = function (_int) {
			return safe ? $author$project$Helpers$Pagination$safeOnClick(
				msg(_int)) : $elm$html$Html$Events$onClick(
				msg(_int));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column'),
					A2($elm$html$Html$Attributes$style, 'text-align', 'center')
				]),
			_Utils_ap(
				A2($author$project$Helpers$Pagination$previousPageLink, page, msgOnClick),
				_Utils_ap(
					$author$project$Helpers$Pagination$currentPage(page),
					A3($author$project$Helpers$Pagination$nextPageLink, page, hasMore, msgOnClick))));
	});
var $author$project$Helpers$Pagination$paginationWithSafeOnClick = $author$project$Helpers$Pagination$pagination_(true);
var $author$project$Components$DocumentBrowser$ActivityView$view = F9(
	function (account, accountSettings, fullHeight, tz, paginationParams, onUnapprove, maybeResendConfig, carrierName, items) {
		var paginationView = function () {
			if (paginationParams.$ === 'Just') {
				if ((!paginationParams.a.a) && (!paginationParams.a.c)) {
					var _v2 = paginationParams.a;
					return _List_Nil;
				} else {
					var _v3 = paginationParams.a;
					var page = _v3.a;
					var changePage = _v3.b;
					var moreItemsExist = _v3.c;
					return _List_fromArray(
						[
							A3($author$project$Helpers$Pagination$paginationWithSafeOnClick, page, moreItemsExist, changePage)
						]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var itemView = function () {
			if (!items.b) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert-box--highlight')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No activity is available.')
							]))
					]);
			} else {
				return A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						A6($author$project$Components$DocumentBrowser$ActivityView$details, account, accountSettings, tz, onUnapprove, maybeResendConfig, carrierName),
						$elm$core$Maybe$withDefault(
							$elm$html$Html$text(''))),
					items);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('document-browser__container', true),
							_Utils_Tuple2('row', !fullHeight),
							_Utils_Tuple2('document-browser__full-height', fullHeight)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__main-image-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-items')
								]),
							$elm$core$List$concat(
								_List_fromArray(
									[paginationView, itemView, paginationView])))
						]))
				]));
	});
var $author$project$Ui$V3$Skeleton$view = function (config) {
	return A2($author$project$Ui$V3$Skeleton$viewCustom, _List_Nil, config);
};
var $author$project$Components$DocumentsBrowser$viewActivityTab = F3(
	function (tz, data, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(data.activities);
		if (_v0.$ === 'Just') {
			var activities = _v0.a;
			var resendConfig = $elm$core$Maybe$Just(
				{
					currentUser: data.currentUser,
					factorInvoiceState: data.factorInvoiceState,
					onResend: $author$project$Components$DocumentsBrowser$ResendToCadence,
					resendState: function (transmissionId) {
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$Idle,
							A2(
								$elm$core$Maybe$map,
								function (s) {
									if (s.$ === 'ResendSending') {
										return $author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$Sending;
									} else {
										return $author$project$Components$ActivityBrowser$Details$SentToCadenceDetailsView$Sent;
									}
								},
								A2(
									$elm$core$Dict$get,
									$author$project$Domain$TransmissionId$toInt(transmissionId),
									model.resendingTransmissions)));
					}
				});
			var paginationParams = $elm$core$Maybe$Just(
				_Utils_Tuple3(
					model.activityTabPage,
					$author$project$Components$DocumentsBrowser$ChangeActivityTabPage,
					$author$project$Stream$hasMore(activities)));
			var onUnapprove = data.currentUser.isAdmin ? $elm$core$Maybe$Just(
				{factorInvoiceState: data.factorInvoiceState, onUnapprove: $author$project$Components$DocumentsBrowser$UnapproveFromActivity}) : $elm$core$Maybe$Nothing;
			var carrierName = function (carrierId) {
				return A2(
					$elm$core$Maybe$andThen,
					$elm$core$Dict$get(
						$author$project$Domain$TmsCarrierId$toComparable(carrierId)),
					$author$project$Forward$Remote$toMaybe(data.activityCarrierNames));
			};
			return A9(
				$author$project$Components$DocumentBrowser$ActivityView$view,
				data.currentAccount,
				data.accountSettings,
				true,
				tz,
				paginationParams,
				onUnapprove,
				resendConfig,
				carrierName,
				$author$project$Stream$value(activities));
		} else {
			return $author$project$Ui$V3$Skeleton$view(
				{height: $elm$core$Maybe$Nothing});
		}
	});
var $author$project$Components$DragDrop$DragId = function (a) {
	return {$: 'DragId', a: a};
};
var $author$project$Components$DocumentsBrowser$Duplicate = function (a) {
	return {$: 'Duplicate', a: a};
};
var $author$project$Components$DocumentsBrowser$LineDragStarted = function (a) {
	return {$: 'LineDragStarted', a: a};
};
var $author$project$Api$Documents$MergeDocumentsData = F2(
	function (currentDocumentId, intoDocumentId) {
		return {currentDocumentId: currentDocumentId, intoDocumentId: intoDocumentId};
	});
var $author$project$Components$DocumentsBrowser$MergeToPrevious = function (a) {
	return {$: 'MergeToPrevious', a: a};
};
var $author$project$Components$DocumentsBrowser$RightClickedThumbnail = function (a) {
	return {$: 'RightClickedThumbnail', a: a};
};
var $author$project$Components$DocumentsBrowser$SelectedGroupRendered = {$: 'SelectedGroupRendered'};
var $author$project$Components$DocumentsBrowser$SetLineSelection = function (a) {
	return {$: 'SetLineSelection', a: a};
};
var $author$project$Components$DocumentsBrowser$SplitFromDocument = F2(
	function (a, b) {
		return {$: 'SplitFromDocument', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$ToggleAnnotating = {$: 'ToggleAnnotating'};
var $author$project$Components$DocumentsBrowser$UpdateViewMode = function (a) {
	return {$: 'UpdateViewMode', a: a};
};
var $author$project$Components$DocumentsBrowser$ViewEmailBrowserClick = function (a) {
	return {$: 'ViewEmailBrowserClick', a: a};
};
var $author$project$Components$DocumentsBrowser$ViewEmailToolbarClick = function (a) {
	return {$: 'ViewEmailToolbarClick', a: a};
};
var $author$project$Components$DocumentsBrowser$addressAnswersToMark = F2(
	function (data, model) {
		return model.addressMarks ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			$author$project$Forward$Remote$toMaybe(data.addressAnswers)) : $elm$core$Dict$empty;
	});
var $author$project$Components$DragDrop$DragStart = function (a) {
	return {$: 'DragStart', a: a};
};
var $author$project$Components$DragDrop$DragCancelled = {$: 'DragCancelled'};
var $author$project$Components$DragDrop$dragEndCancellationDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (dropEffect) {
		if (dropEffect === 'none') {
			return $elm$json$Json$Decode$succeed(
				{message: $author$project$Components$DragDrop$DragCancelled, preventDefault: true, stopPropagation: true});
		} else {
			return $elm$json$Json$Decode$fail(dropEffect);
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['dataTransfer', 'dropEffect']),
		$elm$json$Json$Decode$string));
var $author$project$Components$DragDrop$dragAttributes = function (dragId) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'draggable', 'true'),
			A2(
			$elm$html$Html$Events$on,
			'dragstart',
			$elm$json$Json$Decode$succeed(
				$author$project$Components$DragDrop$DragStart(dragId))),
			A2($elm$html$Html$Events$custom, 'dragend', $author$project$Components$DragDrop$dragEndCancellationDecoder)
		]);
};
var $author$project$Components$DocumentsBrowser$DragScrollStart = F2(
	function (a, b) {
		return {$: 'DragScrollStart', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$dragScrollAttributes = function (model) {
	return (model.zoomLevel > 1) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$Events$preventDefaultOn,
			'mousedown',
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (button, x, y) {
						return (!button) ? _Utils_Tuple2(
							A2($author$project$Components$DocumentsBrowser$DragScrollStart, x, y),
							true) : _Utils_Tuple2($author$project$Components$DocumentsBrowser$NoOp, false);
					}),
				A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
				A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))),
			A2(
			$elm$html$Html$Attributes$style,
			'cursor',
			function () {
				var _v0 = model.dragScroll;
				if (_v0.$ === 'Just') {
					return 'grabbing';
				} else {
					return 'grab';
				}
			}())
		]) : _List_Nil;
};
var $author$project$Domain$FactorInvoice$displayStringForState = function (invoiceState) {
	switch (invoiceState.$) {
		case 'Draft':
			return 'Draft';
		case 'Exception':
			return 'Incomplete';
		case 'Abandoned':
			return 'Ignored';
		case 'Processed':
			return 'Processed';
		case 'Verifying':
			return 'Verifying';
		case 'VerifyCompleted':
			return 'Verify Completed';
		case 'Approved':
			return 'Approved';
		case 'Verified':
			return 'Verified';
		default:
			return 'Purchased';
	}
};
var $author$project$Ui$V3$StatusTag$ActiveStyle = {$: 'ActiveStyle'};
var $author$project$Ui$V3$StatusTag$activeStyle = $author$project$Ui$V3$StatusTag$Style($author$project$Ui$V3$StatusTag$ActiveStyle);
var $author$project$Ui$V3$StatusTag$neutralStyle = $author$project$Ui$V3$StatusTag$Style($author$project$Ui$V3$StatusTag$NeutralStyle);
var $author$project$Ui$V3$StatusTag$SuccessStyle = {$: 'SuccessStyle'};
var $author$project$Ui$V3$StatusTag$successStyle = $author$project$Ui$V3$StatusTag$Style($author$project$Ui$V3$StatusTag$SuccessStyle);
var $author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$style = function (state) {
	switch (state.$) {
		case 'Draft':
			return $author$project$Ui$V3$StatusTag$activeStyle;
		case 'Exception':
			return $author$project$Ui$V3$StatusTag$alertStyle;
		case 'Abandoned':
			return $author$project$Ui$V3$StatusTag$neutralStyle;
		case 'Processed':
			return $author$project$Ui$V3$StatusTag$successStyle;
		case 'Verifying':
			return $author$project$Ui$V3$StatusTag$successStyle;
		case 'VerifyCompleted':
			return $author$project$Ui$V3$StatusTag$successStyle;
		case 'Approved':
			return $author$project$Ui$V3$StatusTag$successStyle;
		case 'Verified':
			return $author$project$Ui$V3$StatusTag$successStyle;
		default:
			return $author$project$Ui$V3$StatusTag$successStyle;
	}
};
var $author$project$Ui$V3$StatusTag$Emphasis = function (a) {
	return {$: 'Emphasis', a: a};
};
var $author$project$Ui$V3$StatusTag$Subtle = {$: 'Subtle'};
var $author$project$Ui$V3$StatusTag$subtleEmphasis = $author$project$Ui$V3$StatusTag$Emphasis($author$project$Ui$V3$StatusTag$Subtle);
var $author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$view = function (state) {
	return A2(
		$author$project$Ui$V3$StatusTag$view,
		_List_fromArray(
			[
				$author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$style(state),
				$author$project$Ui$V3$StatusTag$smallSize,
				$author$project$Ui$V3$StatusTag$subtleEmphasis
			]),
		$author$project$Domain$FactorInvoice$displayStringForState(state));
};
var $author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$viewPending = A2(
	$author$project$Ui$V3$StatusTag$view,
	_List_fromArray(
		[$author$project$Ui$V3$StatusTag$neutralStyle, $author$project$Ui$V3$StatusTag$smallSize, $author$project$Ui$V3$StatusTag$subtleEmphasis]),
	'Pending');
var $author$project$Components$DocumentsBrowser$groupStatusTag = F2(
	function (invoiceStateByGroupId, key) {
		return A2(
			$elm$core$Maybe$andThen,
			function (statesByGroupId) {
				var _v0 = A2($elm$core$Dict$get, key, statesByGroupId);
				if (_v0.$ === 'Just') {
					var state = _v0.a;
					return $elm$core$Maybe$Just(
						$author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$view(state));
				} else {
					return $elm$core$Dict$isEmpty(statesByGroupId) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$DocumentBrowser$GroupFactorInvoiceStatusTag$viewPending);
				}
			},
			$author$project$Forward$Remote$toMaybe(invoiceStateByGroupId));
	});
var $author$project$Components$DocumentBrowser$MessagesView$hasEmailMessageForBatchId = F2(
	function (emailMessageDataList, maybeBatchId) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (batchId) {
					return A2(
						$elm$core$List$any,
						function (emailMessage) {
							return _Utils_eq(
								emailMessage.emailMessage.documentBatchId,
								$elm$core$Maybe$Just(batchId));
						},
						emailMessageDataList);
				},
				maybeBatchId));
	});
var $author$project$Components$DocumentBrowser$Full$mainImageContainerId = function (suffix) {
	return 'document-browser-main-image-' + suffix;
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$Editing = function (a) {
	return {$: 'Editing', a: a};
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$NoSession = {$: 'NoSession'};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$mapSession = F2(
	function (f, session) {
		if (session.$ === 'NoSession') {
			return $author$project$Components$DocumentBrowser$AnnotateToolbar$NoSession;
		} else {
			var actions = session.a;
			return $author$project$Components$DocumentBrowser$AnnotateToolbar$Editing(
				A2(
					$elm$core$List$map,
					function (action) {
						return {
							emphasis: action.emphasis,
							enabled: action.enabled,
							label: action.label,
							msg: f(action.msg)
						};
					},
					actions));
		}
	});
var $author$project$Components$DocumentBrowser$AnnotateToolbar$Tool = function (a) {
	return {$: 'Tool', a: a};
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$mapTool = F2(
	function (f, _v0) {
		var tool = _v0.a;
		return $author$project$Components$DocumentBrowser$AnnotateToolbar$Tool(
			{
				icon: tool.icon,
				label: tool.label,
				msg: f(tool.msg),
				order: tool.order
			});
	});
var $author$project$Components$DocumentsBrowser$maybeActionIfEnabled = F3(
	function (action, model, maybeMsg) {
		return A2($author$project$Components$DocumentsBrowser$isActionEnabled, action, model) ? maybeMsg : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$DocumentBrowser$PageImage$Annotated = {$: 'Annotated'};
var $author$project$Components$DocumentBrowser$PageImage$Raw = {$: 'Raw'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$visibleSession = F2(
	function (maybeSelectedDocPageId, model) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			function (session) {
				return _Utils_eq(
					$elm$core$Maybe$Just(session.docPageId),
					maybeSelectedDocPageId);
			},
			$author$project$Components$DocumentBrowser$AnnotationOverlay$sessionOf(model));
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$pageImage = F2(
	function (maybeSelectedDocPageId, model) {
		var _v0 = A2($author$project$Components$DocumentBrowser$AnnotationOverlay$visibleSession, maybeSelectedDocPageId, model);
		if (_v0.$ === 'Just') {
			return $author$project$Components$DocumentBrowser$PageImage$Raw;
		} else {
			return $author$project$Components$DocumentBrowser$PageImage$Annotated;
		}
	});
var $author$project$Components$DocumentsBrowser$selectedDocument = F2(
	function (data, model) {
		if (data.$ === 'Loaded') {
			var data_ = data.a;
			var selectedPage_ = A2($author$project$Components$DocumentsBrowser$selectedPageFromRemote, data, model);
			var possiblyGroupedDocuments = A2($author$project$Components$DocumentsBrowser$getPossiblyGroupedDocuments, data_, model);
			return A2($author$project$Components$DocumentBrowser$Full$selectedDocument, possiblyGroupedDocuments, selectedPage_);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$CancelClicked = {$: 'CancelClicked'};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$Secondary = {$: 'Secondary'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$cancel = {emphasis: $author$project$Components$DocumentBrowser$AnnotateToolbar$Secondary, enabled: true, label: 'Cancel', msg: $author$project$Components$DocumentBrowser$AnnotationOverlay$CancelClicked};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$Destructive = {$: 'Destructive'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$RemoveClicked = function (a) {
	return {$: 'RemoveClicked', a: a};
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$removeLabel = function (kind) {
	switch (kind.$) {
		case 'Stamp':
			return 'Remove Stamp';
		case 'Redaction':
			return 'Remove Redaction';
		case 'Text':
			return 'Remove Text';
		default:
			return 'Remove Crop';
	}
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$remove = function (session) {
	var _v0 = session.selection;
	if (_v0.$ === 'Selected') {
		var boxId = _v0.a;
		return _List_fromArray(
			[
				{
				emphasis: $author$project$Components$DocumentBrowser$AnnotateToolbar$Destructive,
				enabled: true,
				label: $author$project$Components$DocumentBrowser$AnnotationOverlay$removeLabel(session.kind),
				msg: $author$project$Components$DocumentBrowser$AnnotationOverlay$RemoveClicked(boxId)
			}
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$Primary = {$: 'Primary'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$SaveClicked = {$: 'SaveClicked'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$savable = function (session) {
	var _v0 = session.kind;
	switch (_v0.$) {
		case 'Stamp':
			return true;
		case 'Redaction':
			return true;
		case 'Crop':
			return true;
		default:
			return A2(
				$elm$core$List$all,
				function (editable) {
					return $elm$core$String$trim(editable.text) !== '';
				},
				session.boxes);
	}
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$saveLabel = function (kind) {
	switch (kind.$) {
		case 'Stamp':
			return 'Save Stamp';
		case 'Redaction':
			return 'Save Redactions';
		case 'Text':
			return 'Save Text';
		default:
			return 'Save Crop';
	}
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$save = function (session) {
	return {
		emphasis: $author$project$Components$DocumentBrowser$AnnotateToolbar$Primary,
		enabled: $author$project$Components$DocumentBrowser$AnnotationOverlay$savable(session),
		label: $author$project$Components$DocumentBrowser$AnnotationOverlay$saveLabel(session.kind),
		msg: $author$project$Components$DocumentBrowser$AnnotationOverlay$SaveClicked
	};
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$sessionActions = F2(
	function (maybeSelectedDocPageId, model) {
		var _v0 = A2($author$project$Components$DocumentBrowser$AnnotationOverlay$visibleSession, maybeSelectedDocPageId, model);
		if (_v0.$ === 'Just') {
			var session = _v0.a;
			return $author$project$Components$DocumentBrowser$AnnotateToolbar$Editing(
				_Utils_ap(
					A2(
						$elm$core$List$cons,
						$author$project$Components$DocumentBrowser$AnnotationOverlay$save(session),
						$author$project$Components$DocumentBrowser$AnnotationOverlay$remove(session)),
					_List_fromArray(
						[$author$project$Components$DocumentBrowser$AnnotationOverlay$cancel])));
		} else {
			return $author$project$Components$DocumentBrowser$AnnotateToolbar$NoSession;
		}
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Crop = {$: 'Crop'};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$Started = F3(
	function (a, b, c) {
		return {$: 'Started', a: a, b: b, c: c};
	});
var $author$project$Components$DocumentBrowser$AnnotateToolbar$crop = function (msg) {
	return $author$project$Components$DocumentBrowser$AnnotateToolbar$Tool(
		{icon: 'icon-crop', label: 'Crop', msg: msg, order: 3});
};
var $author$project$Components$DocumentBrowser$Annotation$defaultBox = {height: (6 * 612) / 792, left: 10, top: 10, width: 30};
var $author$project$Components$DocumentBrowser$Annotation$defaultCrop = {height: 100, left: 0, top: 0, width: 100};
var $author$project$Components$DocumentBrowser$Annotation$defaultStamp = F2(
	function (widthInPoints, heightInPoints) {
		var width = (widthInPoints * 100) / 612;
		var height = (heightInPoints * 100) / 792;
		return {height: height, left: 50 - (width / 2), top: 95 - height, width: width};
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$defaultStamp = function (settings) {
	return _Utils_eq(settings.annotationStampUrl, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : A3($elm$core$Maybe$map2, $author$project$Components$DocumentBrowser$Annotation$defaultStamp, settings.annotationStampWidth, settings.annotationStampHeight);
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$redact = function (msg) {
	return $author$project$Components$DocumentBrowser$AnnotateToolbar$Tool(
		{icon: 'icon-page-remove', label: 'Redact', msg: msg, order: 0});
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$stamp = function (msg) {
	return $author$project$Components$DocumentBrowser$AnnotateToolbar$Tool(
		{icon: 'icon-stamp', label: 'Add stamp', msg: msg, order: 1});
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$text = function (msg) {
	return $author$project$Components$DocumentBrowser$AnnotateToolbar$Tool(
		{icon: 'icon-text-color', label: 'Add Text', msg: msg, order: 2});
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$tools = F2(
	function (settings, maybeDocPageId) {
		if (maybeDocPageId.$ === 'Just') {
			var docPageId = maybeDocPageId.a;
			return A2(
				$elm$core$List$cons,
				$author$project$Components$DocumentBrowser$AnnotateToolbar$redact(
					A3($author$project$Components$DocumentBrowser$AnnotationOverlay$Started, $author$project$Components$DocumentBrowser$AnnotationOverlay$Redaction, docPageId, $author$project$Components$DocumentBrowser$Annotation$defaultBox)),
				A2(
					$elm$core$List$cons,
					$author$project$Components$DocumentBrowser$AnnotateToolbar$text(
						A3($author$project$Components$DocumentBrowser$AnnotationOverlay$Started, $author$project$Components$DocumentBrowser$AnnotationOverlay$Text, docPageId, $author$project$Components$DocumentBrowser$Annotation$defaultBox)),
					A2(
						$elm$core$List$cons,
						$author$project$Components$DocumentBrowser$AnnotateToolbar$crop(
							A3($author$project$Components$DocumentBrowser$AnnotationOverlay$Started, $author$project$Components$DocumentBrowser$AnnotationOverlay$Crop, docPageId, $author$project$Components$DocumentBrowser$Annotation$defaultCrop)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Components$DocumentBrowser$AnnotationOverlay$Started, $author$project$Components$DocumentBrowser$AnnotationOverlay$Stamp, docPageId),
									A2($elm$core$Basics$composeR, $author$project$Components$DocumentBrowser$AnnotateToolbar$stamp, $elm$core$List$singleton)),
								$author$project$Components$DocumentBrowser$AnnotationOverlay$defaultStamp(settings))))));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadFilesRequested = {$: 'AddDocumentToLoadFilesRequested'};
var $author$project$Components$DocumentBrowser$AddDocumentToLoad$view = F2(
	function (data, model) {
		var enabled = data.accountSettings.auditorDocumentUploadEnabled && ((!data.currentUser.readOnlyFactorInvoices) && ($elm_community$maybe_extra$Maybe$Extra$isJust(data.maybeTmsLoad) && $elm_community$maybe_extra$Maybe$Extra$isJust(model.pageContextData.carrierInvoiceId)));
		return enabled ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__add-document-wrapper document-browser__add-document-button-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('enable_shared-ui-v3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__theme'),
									A2($elm$html$Html$Attributes$style, 'padding-top', '16px'),
									A2($elm$html$Html$Attributes$style, 'padding-bottom', '16px')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick($author$project$Components$DocumentBrowser$AddDocumentToLoad$AddDocumentToLoadFilesRequested)
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
											$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
										]),
									'Add document')
								]))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Components$DocumentBrowser$Annotation$Drag$ByBody = {$: 'ByBody'};
var $author$project$Components$DocumentBrowser$Annotation$Drag$ByCorner = function (a) {
	return {$: 'ByCorner', a: a};
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$TextChanged = F3(
	function (a, b, c) {
		return {$: 'TextChanged', a: a, b: b, c: c};
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Components$DocumentBrowser$Annotation$stampImage = function (url) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('document-browser__annotation-image'),
				$elm$html$Html$Attributes$src(url),
				A2($elm$html$Html$Attributes$attribute, 'draggable', 'false')
			]),
		_List_Nil);
};
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $author$project$Components$DocumentBrowser$Annotation$TextBox$view = function (box) {
	return A2(
		$elm$html$Html$textarea,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('document-browser__annotation-text-input'),
				$elm$html$Html$Attributes$id(
				A2($author$project$Components$DocumentBrowser$Annotation$TextBox$inputId, box.containerId, box.boxId)),
				$elm$html$Html$Attributes$value(box.text),
				$elm$html$Html$Attributes$readonly(!box.editable),
				$elm$html$Html$Attributes$spellcheck(false),
				$elm$html$Html$Events$onInput(box.onInput)
			]),
		_List_Nil);
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$contents = F4(
	function (containerId, session, selected, editable) {
		var _v0 = session.kind;
		switch (_v0.$) {
			case 'Stamp':
				return _List_fromArray(
					[
						$author$project$Components$DocumentBrowser$Annotation$stampImage(session.stampUrl)
					]);
			case 'Redaction':
				return _List_Nil;
			case 'Crop':
				return _List_Nil;
			default:
				return _List_fromArray(
					[
						$author$project$Components$DocumentBrowser$Annotation$TextBox$view(
						{
							boxId: editable.id,
							containerId: containerId,
							editable: selected,
							onInput: A2($author$project$Components$DocumentBrowser$AnnotationOverlay$TextChanged, editable.id, containerId),
							text: editable.text
						})
					]);
		}
	});
var $author$project$Components$DocumentBrowser$Annotation$BottomLeft = {$: 'BottomLeft'};
var $author$project$Components$DocumentBrowser$Annotation$BottomRight = {$: 'BottomRight'};
var $author$project$Components$DocumentBrowser$Annotation$TopLeft = {$: 'TopLeft'};
var $author$project$Components$DocumentBrowser$Annotation$TopRight = {$: 'TopRight'};
var $author$project$Components$DocumentBrowser$Annotation$handles = function (attributes) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var corner = _v0.a;
			var modifier = _v0.b;
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('document-browser__annotation-handle'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('document-browser__annotation-handle--' + modifier),
						attributes(corner))),
				_List_Nil);
		},
		_List_fromArray(
			[
				_Utils_Tuple2($author$project$Components$DocumentBrowser$Annotation$TopLeft, 'top-left'),
				_Utils_Tuple2($author$project$Components$DocumentBrowser$Annotation$TopRight, 'top-right'),
				_Utils_Tuple2($author$project$Components$DocumentBrowser$Annotation$BottomRight, 'bottom-right'),
				_Utils_Tuple2($author$project$Components$DocumentBrowser$Annotation$BottomLeft, 'bottom-left')
			]));
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$DragStarted = F3(
	function (a, b, c) {
		return {$: 'DragStarted', a: a, b: b, c: c};
	});
var $author$project$Components$DocumentBrowser$Annotation$Drag$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'mousedown',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: true, stopPropagation: true}));
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$onMouseDown = F3(
	function (boxId, grip, containerId) {
		return $author$project$Components$DocumentBrowser$Annotation$Drag$onMouseDown(
			A3($author$project$Components$DocumentBrowser$AnnotationOverlay$DragStarted, boxId, grip, containerId));
	});
var $author$project$Components$DocumentBrowser$Annotation$percent = function (value) {
	return $elm$core$String$fromFloat(value) + '%';
};
var $author$project$Components$DocumentBrowser$Annotation$view = F4(
	function (kind, attributes, box, children) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__annotation'),
						$elm$html$Html$Attributes$class('document-browser__annotation--' + kind),
						A2(
						$elm$html$Html$Attributes$style,
						'top',
						$author$project$Components$DocumentBrowser$Annotation$percent(box.top)),
						A2(
						$elm$html$Html$Attributes$style,
						'left',
						$author$project$Components$DocumentBrowser$Annotation$percent(box.left)),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$author$project$Components$DocumentBrowser$Annotation$percent(box.width)),
						A2(
						$elm$html$Html$Attributes$style,
						'height',
						$author$project$Components$DocumentBrowser$Annotation$percent(box.height))
					]),
				attributes),
			children);
	});
var $author$project$Components$DocumentBrowser$Annotation$viewCrop = F3(
	function (attributes, box, children) {
		var band = F4(
			function (top, left, width, height) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__annotation-crop-band'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$author$project$Components$DocumentBrowser$Annotation$percent(top)),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$author$project$Components$DocumentBrowser$Annotation$percent(left)),
							A2(
							$elm$html$Html$Attributes$style,
							'width',
							$author$project$Components$DocumentBrowser$Annotation$percent(width)),
							A2(
							$elm$html$Html$Attributes$style,
							'height',
							$author$project$Components$DocumentBrowser$Annotation$percent(height))
						]),
					_List_Nil);
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__annotation-crop')
				]),
			_List_fromArray(
				[
					A4(band, 0, 0, 100, box.top),
					A4(band, box.top + box.height, 0, 100, (100 - box.top) - box.height),
					A4(band, box.top, 0, box.left, box.height),
					A4(band, box.top, box.left + box.width, (100 - box.left) - box.width, box.height),
					A4($author$project$Components$DocumentBrowser$Annotation$view, 'crop', attributes, box, children)
				]));
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$positioned = function (kind) {
	switch (kind.$) {
		case 'Stamp':
			return $author$project$Components$DocumentBrowser$Annotation$view('stamp');
		case 'Redaction':
			return $author$project$Components$DocumentBrowser$Annotation$view('redaction');
		case 'Text':
			return $author$project$Components$DocumentBrowser$Annotation$view('text');
		default:
			return $author$project$Components$DocumentBrowser$Annotation$viewCrop;
	}
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$viewEditable = F3(
	function (containerId, session, editable) {
		var selected = _Utils_eq(
			session.selection,
			$author$project$Components$DocumentBrowser$AnnotationOverlay$Selected(editable.id));
		var grips = selected ? $author$project$Components$DocumentBrowser$Annotation$handles(
			function (corner) {
				return _List_fromArray(
					[
						A3(
						$author$project$Components$DocumentBrowser$AnnotationOverlay$onMouseDown,
						editable.id,
						$author$project$Components$DocumentBrowser$Annotation$Drag$ByCorner(corner),
						containerId)
					]);
			}) : _List_Nil;
		return A4(
			$author$project$Components$DocumentBrowser$AnnotationOverlay$positioned,
			session.kind,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__annotation--editing'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('document-browser__annotation--selected', selected)
						])),
					A3($author$project$Components$DocumentBrowser$AnnotationOverlay$onMouseDown, editable.id, $author$project$Components$DocumentBrowser$Annotation$Drag$ByBody, containerId)
				]),
			editable.box,
			_Utils_ap(
				A4($author$project$Components$DocumentBrowser$AnnotationOverlay$contents, containerId, session, selected, editable),
				grips));
	});
var $author$project$Components$DocumentBrowser$Annotation$viewSaved = function (saved) {
	switch (saved.$) {
		case 'SavedStamp':
			var box = saved.a;
			var url = saved.b;
			return A4(
				$author$project$Components$DocumentBrowser$Annotation$view,
				'stamp',
				_List_Nil,
				box,
				_List_fromArray(
					[
						$author$project$Components$DocumentBrowser$Annotation$stampImage(url)
					]));
		case 'SavedRedaction':
			var box = saved.a;
			return A4($author$project$Components$DocumentBrowser$Annotation$view, 'redaction', _List_Nil, box, _List_Nil);
		case 'SavedText':
			var box = saved.a;
			var text = saved.b;
			return A4(
				$author$project$Components$DocumentBrowser$Annotation$view,
				'text',
				_List_Nil,
				box,
				_List_fromArray(
					[
						$elm$html$Html$text(text)
					]));
		default:
			var box = saved.a;
			return A3($author$project$Components$DocumentBrowser$Annotation$viewCrop, _List_Nil, box, _List_Nil);
	}
};
var $author$project$Components$DocumentBrowser$AnnotationOverlay$viewSession = F2(
	function (containerId, session) {
		return _Utils_ap(
			A2($elm$core$List$map, $author$project$Components$DocumentBrowser$Annotation$viewSaved, session.others),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$DocumentBrowser$AnnotationOverlay$viewEditable, containerId, session),
				session.boxes));
	});
var $author$project$Components$DocumentBrowser$AnnotationOverlay$view = F3(
	function (containerId, maybeSelectedDocPageId, model) {
		return A2(
			$elm$core$Maybe$map,
			function (session) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__annotation-layer')
						]),
					A2($author$project$Components$DocumentBrowser$AnnotationOverlay$viewSession, containerId, session));
			},
			A2($author$project$Components$DocumentBrowser$AnnotationOverlay$visibleSession, maybeSelectedDocPageId, model));
	});
var $elm_community$maybe_extra$Maybe$Extra$andMap = $elm$core$Maybe$map2($elm$core$Basics$apR);
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$disabledIconAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$disabled(true),
		$elm$html$Html$Attributes$class('icon--inactive'),
		A2($elm$html$Html$Attributes$style, 'cursor', 'auto')
	]);
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty = $elm$html$Html$text('');
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$downloadDoc = F2(
	function (user, maybeId) {
		var linkOrDisabled = function () {
			if (maybeId.$ === 'Just') {
				var docPageId = maybeId.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						'/api/documents/' + $author$project$Domain$DocumentId$toString(docPageId))
					]);
			} else {
				return $author$project$Components$DocumentBrowser$DocumentViewerToolbar$disabledIconAttrs;
			}
		}();
		return user.isManagedIndexer ? $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty : A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-toolbar__action-item'),
						$elm$html$Html$Attributes$title('Download Document')
					]),
				linkOrDisabled),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-download')
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$downloadDocs = F2(
	function (user, tokens) {
		if (user.isManagedIndexer) {
			return $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty;
		} else {
			var url = '//api.hubtran.com/downloads/documents/combined/' + A2($elm$core$String$join, ',', tokens);
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-toolbar__action-item'),
						$elm$html$Html$Attributes$title('Download All Documents'),
						$elm$html$Html$Attributes$href(url)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon-page-export-pdf')
							]),
						_List_Nil)
					]));
		}
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$duplicateDocument = function (maybeDuplicate) {
	if (maybeDuplicate.$ === 'Just') {
		var duplicate = maybeDuplicate.a;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-toolbar__action-item'),
					$elm$html$Html$Attributes$title('Duplicate Document'),
					$elm$html$Html$Events$onClick(duplicate)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-page-copy')
						]),
					_List_Nil)
				]));
	} else {
		return $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty;
	}
};
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$fitToHeight = function (updateViewMode) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page-toolbar__action-item'),
				$elm$html$Html$Attributes$title('Fit to Height'),
				$elm$html$Html$Events$onClick(
				updateViewMode($author$project$Components$DocumentBrowser$Full$Height))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('icon-fit-to-height')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$fitToWidth = function (updateViewMode) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page-toolbar__action-item'),
				$elm$html$Html$Attributes$title('Fit to Width'),
				$elm$html$Html$Events$onClick(
				updateViewMode($author$project$Components$DocumentBrowser$Full$Width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('icon-fit-to-width')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$maybeAnnotationIcon = F3(
	function (documentAnnotationEnabled, annotating, msgs) {
		return (!documentAnnotationEnabled) ? $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty : ($elm$core$List$isEmpty(msgs.tools) ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-toolbar__action-item'),
					$elm$html$Html$Attributes$title('To use annotations, return to the main screen and open the document viewer.')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('icon-annotate'),
						$author$project$Components$DocumentBrowser$DocumentViewerToolbar$disabledIconAttrs),
					_List_Nil)
				])) : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-toolbar__action-item'),
					$elm$html$Html$Attributes$title('Annotate Document'),
					$elm$html$Html$Events$onClick(msgs.toggleAnnotating)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-annotate'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('icon--highlight', annotating)
								]))
						]),
					_List_Nil)
				])));
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$maybeHideButton = function (maybeHideMsg) {
	if (maybeHideMsg.$ === 'Just') {
		var hide = maybeHideMsg.a;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-toolbar__action_button'),
					$elm$html$Html$Attributes$title('Hide - Alt+H'),
					$elm$html$Html$Events$onClick(hide)
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$width('14'),
							$elm$svg$Svg$Attributes$height('14'),
							$elm$svg$Svg$Attributes$viewBox('0 0 14 14'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$clipRule('evenodd'),
									$elm$svg$Svg$Attributes$d('M10.2783 1.19001L11.9467 2.94001C12.1416 3.13721 12.2507 3.40353 12.25 3.68084V10.29C12.25 10.5731 12.1375 10.8446 11.9373 11.0448C11.7371 11.245 11.4656 11.3575 11.1825 11.3575H10.2083V12.3317C10.2083 12.6148 10.0959 12.8863 9.89567 13.0865C9.69547 13.2867 9.42395 13.3992 9.14083 13.3992H2.8175C2.53438 13.3992 2.26286 13.2867 2.06266 13.0865C1.86247 12.8863 1.75 12.6148 1.75 12.3317V3.96667C1.75 3.68355 1.86247 3.41203 2.06266 3.21184C2.26286 3.01164 2.53438 2.89917 2.8175 2.89917H3.79167V1.92501C3.79624 1.64594 3.90992 1.37976 4.10837 1.1835C4.30681 0.987232 4.57423 0.876494 4.85333 0.875006H9.52C9.66098 0.874529 9.80065 0.902138 9.93085 0.956221C10.0611 1.0103 10.1792 1.08978 10.2783 1.19001ZM3.20833 12.2325H8.75C8.82735 12.2325 8.90154 12.2018 8.95624 12.1471C9.01094 12.0924 9.04167 12.0182 9.04167 11.9408V11.5033C9.04167 11.4647 9.0263 11.4276 8.99895 11.4002C8.9716 11.3729 8.93451 11.3575 8.89583 11.3575H4.85917C4.57605 11.3575 4.30453 11.245 4.10433 11.0448C3.90413 10.8446 3.79167 10.5731 3.79167 10.29V4.21167C3.79167 4.173 3.7763 4.1359 3.74895 4.10855C3.7216 4.0812 3.68451 4.06584 3.64583 4.06584H3.20833C3.13098 4.06584 3.05679 4.09657 3.00209 4.15127C2.9474 4.20596 2.91667 4.28015 2.91667 4.35751V11.9408C2.91667 12.0182 2.9474 12.0924 3.00209 12.1471C3.05679 12.2018 3.13098 12.2325 3.20833 12.2325ZM5.25 10.1908H10.7917C10.869 10.1908 10.9432 10.1601 10.9979 10.1054C11.0526 10.0507 11.0833 9.97653 11.0833 9.89917V3.82667C11.0834 3.78987 11.0763 3.75341 11.0622 3.71938C11.0482 3.68534 11.0276 3.65441 11.0017 3.62834L9.54917 2.11751C9.52121 2.08837 9.48772 2.0651 9.45066 2.04907C9.4136 2.03305 9.37371 2.02458 9.33333 2.02417H5.25C5.17265 2.02417 5.09846 2.0549 5.04376 2.1096C4.98906 2.1643 4.95833 2.23848 4.95833 2.31584V9.89917C4.95833 9.97653 4.98906 10.0507 5.04376 10.1054C5.09846 10.1601 5.17265 10.1908 5.25 10.1908ZM7.98544 6.93709L6.95425 7.96829C6.84485 8.07769 6.69648 8.13914 6.54177 8.13914C6.38706 8.13914 6.23868 8.07769 6.12929 7.96829C6.01989 7.85889 5.95843 7.71052 5.95843 7.55581C5.95843 7.4011 6.01989 7.25273 6.12929 7.14333L7.16049 6.11213L6.12929 5.08094C6.01989 4.97154 5.95843 4.82317 5.95843 4.66846C5.95843 4.51375 6.01989 4.36538 6.12929 4.25598C6.23868 4.14658 6.38706 4.08513 6.54177 4.08513C6.69648 4.08513 6.84485 4.14658 6.95425 4.25598L7.98544 5.28718L9.01664 4.25598C9.12604 4.14658 9.27441 4.08513 9.42912 4.08513C9.58383 4.08513 9.7322 4.14658 9.8416 4.25598C9.95099 4.36538 10.0125 4.51375 10.0125 4.66846C10.0125 4.82317 9.95099 4.97154 9.8416 5.08094L8.8104 6.11213L9.8416 7.14333C9.95099 7.25273 10.0125 7.4011 10.0125 7.55581C10.0125 7.71052 9.95099 7.85889 9.8416 7.96829C9.7322 8.07769 9.58383 8.13914 9.42912 8.13914C9.27441 8.13914 9.12604 8.07769 9.01664 7.96829L7.98544 6.93709Z'),
									$elm$svg$Svg$Attributes$fill('currentColor')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hide')
						]))
				]));
	} else {
		return $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty;
	}
};
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$visibilityIconAttrs = function (ariaLabel) {
	return _List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('v2__icon document-browser__visibility-off'),
			$elm$svg$Svg$Attributes$height('16px'),
			$elm$svg$Svg$Attributes$width('16px'),
			$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
			A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
			A2($elm$html$Html$Attributes$attribute, 'aria-label', ariaLabel)
		]);
};
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$visibilityOffIcon = A2(
	$elm$svg$Svg$svg,
	$author$project$Components$DocumentBrowser$DocumentViewerToolbar$visibilityIconAttrs('Visiblity Off'),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$strokeWidth('1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M10.9735,7.7629 C10.9735,9.4199 9.6305,10.7629 7.9735,10.7629 C6.3165,10.7629 4.9735,9.4199 4.9735,7.7629 C4.9735,6.1059 6.3165,4.7629 7.9735,4.7629 C9.6305,4.7629 10.9735,6.1059 10.9735,7.7629'),
							$elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('2'),
							$elm$svg$Svg$Attributes$x1('2.2001'),
							$elm$svg$Svg$Attributes$x2('14.3881'),
							$elm$svg$Svg$Attributes$y1('13.6999'),
							$elm$svg$Svg$Attributes$y2('1.9999')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M7.9989,12.2619 C10.5499,12.3079 13.1379,10.3869 14.7339,8.5039 C15.0889,8.0819 15.0889,7.4419 14.7339,7.0199 C14.4729,6.7119 14.1869,6.4059 13.8799,6.1079 C13.2699,5.5139 12.5789,4.9549 11.8409,4.4929'),
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M7.9989,3.2638 C5.4909,3.2188 2.8969,5.0968 1.2659,7.0198 C0.9119,7.4418 0.9119,8.0818 1.2659,8.5038 C2.1499,9.5468 3.3379,10.6018 4.6559,11.3278'),
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('2')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$visibilityOnIcon = A2(
	$elm$svg$Svg$svg,
	$author$project$Components$DocumentBrowser$DocumentViewerToolbar$visibilityIconAttrs('Visiblity On'),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$strokeWidth('1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M8,3.5 C5.49179157,3.45466472 2.89678208,5.33463561 1.2659177,7.25805135 C0.911360766,7.67980458 0.911360766,8.3203617 1.2659177,8.74211493 C2.86131498,10.6248623 5,12.5 8,12.5 C11,12.5 13.1374406,10.6248623 14.7340823,8.74211493 C15.0886392,8.3203617 15.0886392,7.67980458 14.7340823,7.25805135 C13.1013512,5.33463561 10.5082084,3.45466472 8,3.5 Z'),
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							$elm$svg$Svg$Attributes$strokeWidth('2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M10,8.00053337 C9.99970518,9.10503337 9.10414435,10.0001963 7.99964436,10 C6.89514437,9.99980363 5.99990185,9.10432235 6,7.9998223 C6.00009815,6.89532226 6.89549981,6 8,6 C8.53056859,5.99985847 9.03943951,6.2105999 9.41455828,6.58581872 C9.78967704,6.96103753 10.0002828,7.46996464 10,8.00053337 L10,8.00053337 Z'),
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							$elm$svg$Svg$Attributes$strokeWidth('2')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$maybeIllegibleButton = F2(
	function (maybeMarkIllegibleMsg, selectedPageIsIllegible) {
		if (maybeMarkIllegibleMsg.$ === 'Just') {
			var markIllegible = maybeMarkIllegibleMsg.a;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-toolbar__action_button'),
						$elm$html$Html$Attributes$title('Mark Illegible - Alt+T'),
						$elm$html$Html$Events$onClick(markIllegible)
					]),
				_List_fromArray(
					[
						selectedPageIsIllegible ? $author$project$Components$DocumentBrowser$DocumentViewerToolbar$visibilityOnIcon : $author$project$Components$DocumentBrowser$DocumentViewerToolbar$visibilityOffIcon,
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								selectedPageIsIllegible ? 'Legible' : 'Illegible')
							]))
					]));
		} else {
			return $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty;
		}
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$maybeViewEmailButton = F3(
	function (viewEmailMsg, accountSettings, hasEmailMessage) {
		var viewEmailTitle = accountSettings.indexAuditSplitEnabled ? 'Re-index' : 'View Email';
		return (accountSettings.documentsViewerDoctypeGroupingEnabled && hasEmailMessage) ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-toolbar__action_button page-toolbar__view_email'),
					$elm$html$Html$Attributes$title(viewEmailTitle),
					$elm$html$Html$Events$onClick(viewEmailMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(viewEmailTitle)
				])) : $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty;
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$mergeToPrevious = F2(
	function (maybeMergeToPreviousMsg, _v0) {
		var documentIndex = _v0.documentIndex;
		var _v1 = _Utils_Tuple2(documentIndex > 0, maybeMergeToPreviousMsg);
		if (_v1.a && (_v1.b.$ === 'Just')) {
			var mergeToPreviousMsg = _v1.b.a;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-toolbar__action-item'),
						$elm$html$Html$Attributes$title('Merge to Previous'),
						$elm$html$Html$Events$onClick(mergeToPreviousMsg)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon-merge-page')
							]),
						_List_Nil)
					]));
		} else {
			return $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty;
		}
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$rotateRightOnTrue = F2(
	function (right, maybeRotate) {
		var _v0 = right ? _Utils_Tuple2('right', 90) : _Utils_Tuple2('left', -90);
		var direction = _v0.a;
		var degrees = _v0.b;
		var onClickOrDisabled = function () {
			if (maybeRotate.$ === 'Just') {
				var rotate = maybeRotate.a;
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						rotate(degrees))
					]);
			} else {
				return $author$project$Components$DocumentBrowser$DocumentViewerToolbar$disabledIconAttrs;
			}
		}();
		var tooltipText = 'Rotate ' + $author$project$Helpers$String$capitalize(direction);
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-toolbar__action-item'),
						$elm$html$Html$Attributes$title(tooltipText)
					]),
				onClickOrDisabled),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-rotate-' + direction)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$rotateLeft = $author$project$Components$DocumentBrowser$DocumentViewerToolbar$rotateRightOnTrue(false);
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$rotateRight = $author$project$Components$DocumentBrowser$DocumentViewerToolbar$rotateRightOnTrue(true);
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$splitFromDocument = F2(
	function (maybeSplitFromDocumentMsg, _v0) {
		var pageIndex = _v0.pageIndex;
		var _v1 = _Utils_Tuple2(pageIndex > 0, maybeSplitFromDocumentMsg);
		if (_v1.a && (_v1.b.$ === 'Just')) {
			var splitFromDocumentMsg = _v1.b.a;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-toolbar__action-item'),
						$elm$html$Html$Attributes$title('Split From Document'),
						$elm$html$Html$Events$onClick(splitFromDocumentMsg)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon-split-page')
							]),
						_List_Nil)
					]));
		} else {
			return $author$project$Components$DocumentBrowser$DocumentViewerToolbar$empty;
		}
	});
var $author$project$Components$DocumentBrowser$AnnotateToolbar$order = function (_v0) {
	var tool = _v0.a;
	return tool.order;
};
var $author$project$Ui$V3$Button$ColorAlternative = {$: 'ColorAlternative'};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$emphasisAttributes = function (emphasis) {
	return A2(
		$elm$core$List$cons,
		$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorAlternative),
		function () {
			switch (emphasis.$) {
				case 'Primary':
					return _List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantPrimary)
						]);
				case 'Destructive':
					return _List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
						]);
				default:
					return _List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
						]);
			}
		}());
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$viewAction = function (action) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick(action.msg)
		},
		A2(
			$elm$core$List$cons,
			$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$V3$Button$disabled(!action.enabled),
				$author$project$Components$DocumentBrowser$AnnotateToolbar$emphasisAttributes(action.emphasis))),
		action.label);
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$viewSessionActions = function (session) {
	if (session.$ === 'NoSession') {
		return $elm$html$Html$text('');
	} else {
		var actions = session.a;
		return $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__annotate-actions')
					]),
				A2($elm$core$List$map, $author$project$Components$DocumentBrowser$AnnotateToolbar$viewAction, actions)));
	}
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$viewTool = function (_v0) {
	var tool = _v0.a;
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page-toolbar__action-item'),
				$elm$html$Html$Attributes$title(tool.label),
				$elm$html$Html$Events$onClick(tool.msg)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(tool.icon)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$DocumentBrowser$AnnotateToolbar$view = F2(
	function (tools, session) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__sub-nav')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__annotate-tools')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$DocumentBrowser$AnnotateToolbar$viewTool,
						A2($elm$core$List$sortBy, $author$project$Components$DocumentBrowser$AnnotateToolbar$order, tools))),
					$author$project$Components$DocumentBrowser$AnnotateToolbar$viewSessionActions(session)
				]));
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$viewDocumentType = F4(
	function (_v0, maybeDocument, maybeUpdateDocumentType, enabledDocumentTypes) {
		if (maybeUpdateDocumentType.$ === 'Nothing') {
			return $elm$html$Html$text('');
		} else {
			var updateDocumentType = maybeUpdateDocumentType.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__sub-nav')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('document-browser__sub-nav_description')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('document-browser__document-type')
									]),
								function () {
									if (maybeDocument.$ === 'Just') {
										var document = maybeDocument.a;
										var currentType = $author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue);
										var isUnknown = _Utils_eq(currentType, $author$project$Domain$UnresolvedDocumentType$Unknown);
										return isUnknown ? _List_fromArray(
											[
												A2(
												$elm$html$Html$em,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Unknown document type')
													]))
											]) : _List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('document-browser__document-type-label')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Type: ')
													])),
												A2(
												$elm$html$Html$select,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('document-browser__document-type-select'),
														$elm$html$Html$Events$onInput(
														function (val) {
															var _v3 = $author$project$AuditPb$documentTypeFromString(val);
															if (_v3.$ === 'Just') {
																var docType = _v3.a;
																return A2(updateDocumentType, document.id, docType);
															} else {
																return A2(updateDocumentType, document.id, $author$project$AuditPb$DocumentTypeInvoice);
															}
														})
													]),
												A2(
													$elm$core$List$map,
													function (dt) {
														return A2(
															$elm$html$Html$option,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$value(
																	$author$project$AuditPb$documentTypeToString(dt.documentType)),
																	$elm$html$Html$Attributes$selected(
																	_Utils_eq(
																		$author$project$Domain$UnresolvedDocumentType$Resolved(dt.documentType),
																		currentType))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(dt.name)
																]));
													},
													A2(
														$elm$core$List$sortBy,
														function ($) {
															return $.name;
														},
														enabledDocumentTypes)))
											]);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text('')
											]);
									}
								}())
							]))
					]));
		}
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$viewPod = F5(
	function (accountSettings, maybeDocument, maybeUpdatePod, documentIsPodUpdates, podRequirementSkipped) {
		var podDefinitionGuidanceView = _List_fromArray(
			[
				A2(
				$elm$html$Html$em,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Expand POD exception on the left to view and edit POD status.')
					]))
			]);
		var notAllowedAsPodView = _List_fromArray(
			[
				A2(
				$elm$html$Html$em,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('This document type may not be used as a proof of delivery.')
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__sub-nav')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__sub-nav_description')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-browser__pod-status')
								]),
							function () {
								if (maybeDocument.$ === 'Just') {
									var document = maybeDocument.a;
									var isPod = A3($author$project$Helpers$DocumentIsPodUpdates$getWithDefault, document.includesPOD, document.id, documentIsPodUpdates);
									var onClickOrDisabled = function () {
										if (maybeUpdatePod.$ === 'Just') {
											var updatePod = maybeUpdatePod.a;
											return $elm$html$Html$Events$onClick(
												A2(updatePod, document.id, !isPod));
										} else {
											return $elm$html$Html$Attributes$disabled(true);
										}
									}();
									return (!A2(
										$author$project$Helpers$DocumentType$allowedAsPod,
										accountSettings,
										$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue))) ? notAllowedAsPodView : ((accountSettings.podDefinitionModuleEnabled && (!podRequirementSkipped)) ? podDefinitionGuidanceView : _List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('document-browser__pod-status-checkbox'),
													$elm$html$Html$Attributes$type_('checkbox'),
													$elm$html$Html$Attributes$id('use-as-pod'),
													$elm$html$Html$Attributes$checked(isPod),
													onClickOrDisabled
												]),
											_List_Nil),
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('document-browser__pod-status-label'),
													$elm$html$Html$Attributes$for('use-as-pod')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Signed: Use as Proof of Delivery')
												]))
										]));
								} else {
									return notAllowedAsPodView;
								}
							}())
						]))
				]));
	});
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$viewZoomIn = function (maybeZoomIn) {
	if (maybeZoomIn.$ === 'Just') {
		var zoomIn = maybeZoomIn.a;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-toolbar__action-item'),
					$elm$html$Html$Attributes$title('Zoom In'),
					$elm$html$Html$Events$onClick(zoomIn)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-zoom-in')
						]),
					_List_Nil)
				]));
	} else {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title('Zoom In')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('icon-zoom-in'),
						$author$project$Components$DocumentBrowser$DocumentViewerToolbar$disabledIconAttrs),
					_List_Nil)
				]));
	}
};
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$viewZoomOut = function (maybeZoomOut) {
	if (maybeZoomOut.$ === 'Just') {
		var zoomOut = maybeZoomOut.a;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-toolbar__action-item'),
					$elm$html$Html$Attributes$title('Zoom Out'),
					$elm$html$Html$Events$onClick(zoomOut)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-zoom-out')
						]),
					_List_Nil)
				]));
	} else {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title('Zoom Out')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('icon-zoom-out'),
						$author$project$Components$DocumentBrowser$DocumentViewerToolbar$disabledIconAttrs),
					_List_Nil)
				]));
	}
};
var $author$project$Components$DocumentBrowser$DocumentViewerToolbar$view = F2(
	function (user, _v0) {
		var selectedPageIsIllegible = _v0.selectedPageIsIllegible;
		var enabledDocumentTypes = _v0.enabledDocumentTypes;
		var podRequirementSkipped = _v0.podRequirementSkipped;
		var hasEmailMessage = _v0.hasEmailMessage;
		var documentIsPodUpdates = _v0.documentIsPodUpdates;
		var accountSettings = _v0.accountSettings;
		var annotating = _v0.annotating;
		var documentAnnotationEnabled = _v0.documentAnnotationEnabled;
		var msgs = _v0.msgs;
		var documentTokens = _v0.documentTokens;
		var selectedPage = _v0.selectedPage;
		var maybeDocument = _v0.maybeDocument;
		var rowsBelow = annotating ? _List_fromArray(
			[
				A2($author$project$Components$DocumentBrowser$AnnotateToolbar$view, msgs.tools, msgs.annotateSession)
			]) : _List_fromArray(
			[
				A5($author$project$Components$DocumentBrowser$DocumentViewerToolbar$viewPod, accountSettings, maybeDocument, msgs.updatePod, documentIsPodUpdates, podRequirementSkipped),
				A4($author$project$Components$DocumentBrowser$DocumentViewerToolbar$viewDocumentType, accountSettings, maybeDocument, msgs.updateDocumentType, enabledDocumentTypes)
			]);
		var maybeDocumentId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.id;
			},
			maybeDocument);
		var duplicate = A2($elm_community$maybe_extra$Maybe$Extra$andMap, maybeDocumentId, msgs.duplicate);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__popout-page-toolbar'),
					$elm$html$Html$Attributes$class('document-browser')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-toolbar__bar')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('page-toolbar__action_icons')
								]),
							_List_fromArray(
								[
									$author$project$Components$DocumentBrowser$DocumentViewerToolbar$viewZoomIn(msgs.zoomIn),
									$author$project$Components$DocumentBrowser$DocumentViewerToolbar$viewZoomOut(msgs.zoomOut),
									A2($author$project$Components$DocumentBrowser$DocumentViewerToolbar$downloadDoc, user, maybeDocumentId),
									A2($author$project$Components$DocumentBrowser$DocumentViewerToolbar$downloadDocs, user, documentTokens),
									$author$project$Components$DocumentBrowser$DocumentViewerToolbar$duplicateDocument(duplicate),
									$author$project$Components$DocumentBrowser$DocumentViewerToolbar$rotateLeft(msgs.rotate),
									$author$project$Components$DocumentBrowser$DocumentViewerToolbar$rotateRight(msgs.rotate),
									A2($author$project$Components$DocumentBrowser$DocumentViewerToolbar$splitFromDocument, msgs.splitFromDocument, selectedPage),
									A2($author$project$Components$DocumentBrowser$DocumentViewerToolbar$mergeToPrevious, msgs.mergeToPrevious, selectedPage),
									$author$project$Components$DocumentBrowser$DocumentViewerToolbar$fitToHeight(msgs.updateViewMode),
									$author$project$Components$DocumentBrowser$DocumentViewerToolbar$fitToWidth(msgs.updateViewMode),
									A3($author$project$Components$DocumentBrowser$DocumentViewerToolbar$maybeAnnotationIcon, documentAnnotationEnabled, annotating, msgs)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('page-toolbar__action_buttons')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$DocumentBrowser$DocumentViewerToolbar$maybeIllegibleButton, msgs.markIllegible, selectedPageIsIllegible),
									$author$project$Components$DocumentBrowser$DocumentViewerToolbar$maybeHideButton(msgs.hide),
									A3($author$project$Components$DocumentBrowser$DocumentViewerToolbar$maybeViewEmailButton, msgs.viewEmail, accountSettings, hasEmailMessage)
								]))
						])),
				rowsBelow));
	});
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$DocumentBrowser$Full$docGroups = function (docData) {
	var _v0 = $elm$core$List$unzip(docData);
	var counts = _v0.a;
	var groupedDocs = _v0.b;
	var count = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$minimum(counts));
	return _Utils_Tuple2(
		count,
		{
			documentPages: A2($elm$core$List$map, $elm$core$Tuple$second, groupedDocs),
			documents: A2($elm$core$List$map, $elm$core$Tuple$first, groupedDocs)
		});
};
var $author$project$Components$DocumentBrowser$Full$maybeDisplayLabel = F4(
	function (showOnDocument, documentHasLabel, pageIndex, labelText) {
		return (showOnDocument && (documentHasLabel && (!pageIndex))) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('document-thumbnail__page-label', true),
										_Utils_Tuple2('v3__descriptor-tag', true),
										_Utils_Tuple2('v3__descriptor-tag--color-alert', true)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelText)
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$DocumentBrowser$Full$maybeDisplayCarrierRateLabel = F3(
	function (showCarrierRateOnDocument, document, pageIndex) {
		return A4($author$project$Components$DocumentBrowser$Full$maybeDisplayLabel, showCarrierRateOnDocument, document.hasCarrierRate, pageIndex, 'Carrier Rate');
	});
var $author$project$Components$DocumentBrowser$Full$maybeDisplayHiddenLabel = F2(
	function (document, pageIndex) {
		return (document.hidden && (!pageIndex)) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('document-thumbnail__page-label', true),
										_Utils_Tuple2('v3__descriptor-tag', true),
										_Utils_Tuple2('v3__descriptor-tag--color-alert', true)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Hidden')
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$DocumentBrowser$Full$maybeDisplayIllegibleLabel = function (page) {
	return page.illegible ? $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('document-thumbnail__page-label', true),
									_Utils_Tuple2('v3__descriptor-tag', true),
									_Utils_Tuple2('v3__descriptor-tag--color-alert', true)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Illegible')
						]))
				]))) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$DocumentBrowser$Full$documentIsPod = F2(
	function (document, documentIsPodUpdates) {
		return A3($author$project$Helpers$DocumentIsPodUpdates$getWithDefault, document.isPOD, document.id, documentIsPodUpdates);
	});
var $author$project$Components$DocumentBrowser$Full$maybeDisplayMissingPagesLabel = F3(
	function (document, pageIndex, documentIsPodUpdates) {
		var isPod = A2($author$project$Components$DocumentBrowser$Full$documentIsPod, document, documentIsPodUpdates);
		return ((!isPod) && (document.hasMissingPages && (!pageIndex))) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('document-thumbnail__page-label', true),
										_Utils_Tuple2('v3__descriptor-tag', true),
										_Utils_Tuple2('v3__descriptor-tag--color-alert', true)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Missing Pages')
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$DocumentBrowser$Full$maybeDisplayOsdLabel = F3(
	function (showDamagesOnDocument, document, pageIndex) {
		return A4($author$project$Components$DocumentBrowser$Full$maybeDisplayLabel, showDamagesOnDocument, document.hasDamage, pageIndex, 'OS&D');
	});
var $author$project$Components$DocumentBrowser$Full$maybeDisplayPodLabel = F3(
	function (document, pageIndex, documentIsPodUpdates) {
		var isPod = A2($author$project$Components$DocumentBrowser$Full$documentIsPod, document, documentIsPodUpdates);
		return (isPod && (!pageIndex)) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('document-thumbnail__page-label', true),
										_Utils_Tuple2('v3__descriptor-tag', true),
										_Utils_Tuple2('v3__descriptor-tag--color-success', true)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('POD')
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$DocumentBrowser$Full$maybeDisplayReferenceNumberLabel = F2(
	function (document, pageIndex) {
		return (document.hasReferenceNumber && (!pageIndex)) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('document-thumbnail__page-label', true),
										_Utils_Tuple2('v3__descriptor-tag', true),
										_Utils_Tuple2('v3__descriptor-tag--color-info', true)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Ref #')
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$DocumentBrowser$Full$maybeDisplaySignedLabel = F2(
	function (document, pageIndex) {
		return (document.isSigned && (!pageIndex)) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('document-thumbnail__page-label', true),
										_Utils_Tuple2('v3__descriptor-tag', true),
										_Utils_Tuple2('v3__descriptor-tag--color-info', true)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Signed')
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$DocumentBrowser$Full$thumbnailLabels = F6(
	function (document, documentPage, pageIndex, documentIsPodUpdates, showDamagesOnDocument, showCarrierRateOnDocument) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('document-thumbnail__page-label-container', true),
							_Utils_Tuple2('enable_shared-ui-v3 ', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A3($author$project$Components$DocumentBrowser$Full$maybeDisplayOsdLabel, showDamagesOnDocument, document, pageIndex),
								A3($author$project$Components$DocumentBrowser$Full$maybeDisplayCarrierRateLabel, showCarrierRateOnDocument, document, pageIndex),
								A3($author$project$Components$DocumentBrowser$Full$maybeDisplayPodLabel, document, pageIndex, documentIsPodUpdates),
								A2($author$project$Components$DocumentBrowser$Full$maybeDisplaySignedLabel, document, pageIndex),
								A2($author$project$Components$DocumentBrowser$Full$maybeDisplayReferenceNumberLabel, document, pageIndex),
								A2($author$project$Components$DocumentBrowser$Full$maybeDisplayHiddenLabel, document, pageIndex),
								A3($author$project$Components$DocumentBrowser$Full$maybeDisplayMissingPagesLabel, document, pageIndex, documentIsPodUpdates),
								$author$project$Components$DocumentBrowser$Full$maybeDisplayIllegibleLabel(documentPage)
							])))
				]));
	});
var $author$project$Components$DocumentBrowser$Full$documentPageThumbnailView = F9(
	function (_v0, selection, msgs, popout, documentIsPodUpdates, pageIndex, documentPage, showDamagesOnDocument, showCarrierRateOnDocument) {
		var documentIndex = _v0.a;
		var document = _v0.b;
		var appendOnRightClick = function () {
			var _v2 = msgs.onRightClick;
			if (_v2.$ === 'Just') {
				var rightClickMsg = _v2.a;
				return $elm$core$List$append(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$custom,
							'contextmenu',
							$elm$json$Json$Decode$succeed(
								{
									message: rightClickMsg(
										{documentIndex: documentIndex, pageIndex: pageIndex}),
									preventDefault: true,
									stopPropagation: true
								}))
						]));
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var _v1 = documentPage.thumbnailUrl;
		if (_v1.$ === 'Nothing') {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-thumbnail__blank-page')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No Preview Available')
					]));
		} else {
			var url = _v1.a;
			var isSelected = _Utils_eq(selection.documentIndex, documentIndex) && _Utils_eq(selection.pageIndex, pageIndex);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-thumbnail__page-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						appendOnRightClick(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('document-thumbnail__page', true),
											_Utils_Tuple2('document-thumbnail__page-popout', popout),
											_Utils_Tuple2('document-thumbnail__page--selected', isSelected)
										])),
									$elm$html$Html$Attributes$src(url),
									A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous'),
									A2($elm$html$Html$Attributes$attribute, 'loading', 'lazy'),
									$elm$html$Html$Events$onClick(
									msgs.onSelect(
										{documentIndex: documentIndex, pageIndex: pageIndex}))
								])),
						_List_Nil),
						A6($author$project$Components$DocumentBrowser$Full$thumbnailLabels, document, documentPage, pageIndex, documentIsPodUpdates, showDamagesOnDocument, showCarrierRateOnDocument)
					]));
		}
	});
var $author$project$Components$DocumentBrowser$Full$documentThumbnailView = F4(
	function (options, documentIndex, docCountAccumulator, _v0) {
		var documentIsPodUpdates = options.documentIsPodUpdates;
		var popout = options.popout;
		var selection = options.selection;
		var overlay = options.overlay;
		var accountSettings = options.accountSettings;
		var account = options.account;
		var document = _v0.a;
		var documentPages = _v0.b;
		var viewOverlay = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$always(
				$elm$html$Html$text('')),
			overlay);
		var thumbnailTitle = accountSettings.documentsViewerDoctypeGroupingEnabled ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-thumbnail__title')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-thumbnail__title'),
					$elm$html$Html$Events$onClick(
					options.onSelect(
						{documentIndex: documentIndex + docCountAccumulator, pageIndex: 0}))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3(
						$author$project$Domain$Helpers$documentTypeToString,
						account,
						accountSettings,
						$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue)))
				]));
		var msgs = {onRightClick: options.onRightClick, onSelect: options.onSelect};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-thumbnail')
				]),
			_List_fromArray(
				[
					thumbnailTitle,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-thumbnail__pages')
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (pageIndex, page) {
								return A9(
									$author$project$Components$DocumentBrowser$Full$documentPageThumbnailView,
									_Utils_Tuple2(documentIndex + docCountAccumulator, document),
									selection,
									msgs,
									popout,
									documentIsPodUpdates,
									pageIndex,
									page,
									accountSettings.runNoDocumentsHaveDamagesOrRatesRule,
									accountSettings.runNoDocumentsHaveCarrierRatesRule);
							}),
						documentPages)),
					viewOverlay(document.id)
				]));
	});
var $author$project$Components$DocumentBrowser$Full$emailHeading = F2(
	function (options, doc) {
		var isUploadedDoc = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (emailMessageList) {
					return !A2($author$project$Components$DocumentBrowser$MessagesView$hasEmailMessageForBatchId, emailMessageList, doc.documentBatchId);
				},
				options.emailMessageDataList));
		var maybeOnClick = function () {
			var _v1 = _Utils_Tuple3(doc.documentBatchId, options.onViewEmailClick, isUploadedDoc);
			if (((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) && (!_v1.c)) {
				var msg = _v1.b.a;
				return $elm$core$Maybe$Just(
					$elm$html$Html$Events$onClick(
						msg(doc)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var headerText = function () {
			if (isUploadedDoc) {
				return 'Uploaded Documents';
			} else {
				var _v0 = doc.documentBatchId;
				if (_v0.$ === 'Just') {
					return options.accountSettings.indexAuditSplitEnabled ? 'Re-index' : 'View Email';
				} else {
					return 'Missing Email';
				}
			}
		}();
		return A2(
			$elm$html$Html$h6,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						$elm$html$Html$Attributes$class('document-browser__group-heading')),
						maybeOnClick
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(headerText)
				]));
	});
var $author$project$Domain$DocumentBatchId$toComparable = function (id) {
	return _Utils_Tuple2(
		'documentBatchId',
		$author$project$Domain$DocumentBatchId$toInt(id));
};
var $author$project$Components$DocumentBrowser$Full$compareMaybeDocumentBatchId = F2(
	function (_v0, _v2) {
		var _v1 = _v0.b;
		var doc1 = _v1.a;
		var _v3 = _v2.b;
		var doc2 = _v3.a;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (a, b) {
						return _Utils_eq(
							$author$project$Domain$DocumentBatchId$toComparable(a),
							$author$project$Domain$DocumentBatchId$toComparable(b));
					}),
				doc1.documentBatchId,
				doc2.documentBatchId));
	});
var $author$project$Components$DocumentBrowser$Full$groupedByBatch = function (options) {
	var sortByNewestBatchFirstAssumingIdsAreIncremental = function (list) {
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				function (_v3) {
					var doc = _v3.a;
					return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $author$project$Domain$DocumentBatchId$toInt, doc.documentBatchId);
				},
				list));
	};
	var sortByDocumentNumber = function (list) {
		return A2(
			$elm$core$List$sortBy,
			function (_v1) {
				var _v2 = _v1.b;
				var d = _v2.a;
				return d.number;
			},
			list);
	};
	var documentData = $author$project$Components$DocumentBrowser$Full$getSelectedDocumentData(options.documents);
	return sortByNewestBatchFirstAssumingIdsAreIncremental(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var headMatch = _v0.a;
				var tailMatch = _v0.b;
				return _Utils_Tuple2(
					headMatch.b.a,
					sortByDocumentNumber(
						A2($elm$core$List$cons, headMatch, tailMatch)));
			},
			A2(
				$elm_community$list_extra$List$Extra$gatherWith,
				$author$project$Components$DocumentBrowser$Full$compareMaybeDocumentBatchId,
				A2(
					$elm$core$List$indexedMap,
					$elm$core$Tuple$pair,
					A3($elm$core$List$map2, $elm$core$Tuple$pair, documentData.documents, documentData.documentPages)))));
};
var $author$project$Components$DocumentBrowser$Full$viewGroupHeader = F3(
	function (attributes, index, extra) {
		return A2(
			$elm$html$Html$h6,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('document-browser__group-heading'),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Group' + ($author$project$Helpers$String$nbsp + $elm$core$String$fromInt(index + 1)))
						])),
					extra
				]));
	});
var $author$project$Components$DocumentBrowser$Full$collapsedGroupThumbnailView = F3(
	function (options, index, _v0) {
		var key = _v0.a;
		var group = _v0.b;
		var buildOnClick = function (onSelectGroup) {
			return $elm$core$List$singleton(
				$elm$html$Html$Events$onClick(
					onSelectGroup(
						$author$project$Domain$DocumentGroupId$fromComparable(key))));
		};
		var placeholderAttributes = A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('document-browser__collapsed-list'),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, buildOnClick, options.onSelectGroup)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__list-item'),
					$elm$html$Html$Attributes$class('document-browser__list-item--collapsed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					placeholderAttributes,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-browser__collapsed-list-content')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$DocumentBrowser$Full$viewGroupHeader,
									_List_Nil,
									index,
									A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('document-browser__collapsed-list-link')
											]),
										_List_Nil)),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('document-browser__collapsed-list-documents')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Helpers$String$pluralize,
												{many: 'documents', one: 'document'},
												$elm$core$List$length(group.documents)))
										]))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							options.groupStatusTag(key))
						]))
				]));
	});
var $author$project$Components$DocumentBrowser$Full$splitDocumentData = F2(
	function (index, _v0) {
		var documentPages = _v0.documentPages;
		var documents = _v0.documents;
		return _Utils_Tuple2(
			{
				documentPages: A2($elm$core$List$take, index, documentPages),
				documents: A2($elm$core$List$take, index, documents)
			},
			{
				documentPages: A2($elm$core$List$drop, index, documentPages),
				documents: A2($elm$core$List$drop, index, documents)
			});
	});
var $author$project$Components$DocumentBrowser$Full$doctypeThumbnailHeading = F3(
	function (options, startCount, _v0) {
		var docCountAccumulator = _v0.a;
		var documentData = _v0.b;
		var docType = _v0.c;
		var heading = A3(
			$author$project$Domain$Helpers$documentTypeToString,
			options.account,
			options.accountSettings,
			$author$project$Domain$UnresolvedDocumentType$deserialize(docType));
		var renderedBody = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__grouped-by-doctype')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-thumbnail__title document-thumbnail__doctype')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(heading)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A2($author$project$Components$DocumentBrowser$Full$documentThumbnailView, options, startCount + docCountAccumulator),
						documentData))
				]));
		return _Utils_Tuple2(docType, renderedBody);
	});
var $elm_community$list_extra$List$Extra$foldl1 = F2(
	function (func, list) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var x = list.a;
			var xs = list.b;
			return $elm$core$Maybe$Just(
				A3($elm$core$List$foldl, func, x, xs));
		}
	});
var $elm_community$list_extra$List$Extra$maximumWith = F2(
	function (comparator, list) {
		return A2(
			$elm_community$list_extra$List$Extra$foldl1,
			F2(
				function (x, y) {
					var _v0 = A2(comparator, x, y);
					if (_v0.$ === 'GT') {
						return x;
					} else {
						return y;
					}
				}),
			list);
	});
var $author$project$Components$DocumentBrowser$Full$previousAccumulator = function (list) {
	var prevAccumulator = A2(
		$elm_community$list_extra$List$Extra$maximumWith,
		F2(
			function (_v2, _v3) {
				var acc1 = _v2.a;
				var acc2 = _v3.a;
				return A2($elm$core$Basics$compare, acc1, acc2);
			}),
		list);
	if (prevAccumulator.$ === 'Just') {
		var _v1 = prevAccumulator.a;
		var acc = _v1.a;
		var docData = _v1.b;
		return acc + $elm$core$List$length(docData);
	} else {
		return 0;
	}
};
var $author$project$Components$DocumentBrowser$Full$groupedDocumentData = function (value) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v1, acc) {
				var doctype = _v1.a;
				var docData = _v1.b;
				return A2(
					$elm$core$List$append,
					acc,
					_List_fromArray(
						[
							_Utils_Tuple3(
							$author$project$Components$DocumentBrowser$Full$previousAccumulator(
								A2(
									$elm$core$List$map,
									function (_v2) {
										var x = _v2.a;
										var y = _v2.b;
										return _Utils_Tuple2(x, y);
									},
									acc)),
							docData,
							doctype)
						]));
			}),
		_List_Nil,
		$author$project$Components$DocumentBrowser$Full$sortedDoctypeGrouping(
			$elm$core$Dict$toList(
				A2(
					$elm_community$dict_extra$Dict$Extra$groupBy,
					function (_v0) {
						var doc = _v0.a;
						return $author$project$Domain$UnresolvedDocumentType$serialize(
							$author$project$Domain$Document$documentTypeValueToUnresolved(doc.documentTypeValue));
					},
					A3($elm$core$List$map2, $elm$core$Tuple$pair, value.documents, value.documentPages)))));
};
var $author$project$Components$DocumentBrowser$Full$doctypeThumbnailItems = F2(
	function (options, _v0) {
		var startCount = _v0.a;
		var value = _v0.b;
		var doctypeGrouping = A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$map,
				A2($author$project$Components$DocumentBrowser$Full$doctypeThumbnailHeading, options, startCount),
				$author$project$Components$DocumentBrowser$Full$groupedDocumentData(value)));
		return doctypeGrouping;
	});
var $author$project$Components$DocumentBrowser$Full$thumbnailItems = F2(
	function (options, _v0) {
		var count = _v0.a;
		var value = _v0.b;
		var documentData = A3($elm$core$List$map2, $elm$core$Tuple$pair, value.documents, value.documentPages);
		return A2(
			$elm$core$List$indexedMap,
			A2($author$project$Components$DocumentBrowser$Full$documentThumbnailView, options, count),
			documentData);
	});
var $author$project$Components$DocumentBrowser$Full$thumbnailViewItems = function (options) {
	return options.accountSettings.documentsViewerDoctypeGroupingEnabled ? $author$project$Components$DocumentBrowser$Full$doctypeThumbnailItems(options) : $author$project$Components$DocumentBrowser$Full$thumbnailItems(options);
};
var $author$project$Components$DocumentBrowser$Full$selectedGroupThumbnailLists = F2(
	function (options, value) {
		var wholeList = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-thumbnail-list')
					]),
				A2(
					$author$project$Components$DocumentBrowser$Full$thumbnailViewItems,
					options,
					_Utils_Tuple2(0, value)))
			]);
		var _v0 = options.relatedDocuments;
		if (_v0.$ === 'Nothing') {
			return wholeList;
		} else {
			var title = _v0.a.title;
			var startIndex = _v0.a.startIndex;
			var _v1 = A2($author$project$Components$DocumentBrowser$Full$splitDocumentData, startIndex, value);
			var own = _v1.a;
			var related = _v1.b;
			return $elm$core$List$isEmpty(related.documents) ? wholeList : _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-thumbnail-list document-browser__group-documents')
						]),
					A2(
						$author$project$Components$DocumentBrowser$Full$thumbnailViewItems,
						options,
						_Utils_Tuple2(0, own))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__related-documents')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-browser__related-documents-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-thumbnail-list')
								]),
							A2(
								$author$project$Components$DocumentBrowser$Full$thumbnailViewItems,
								options,
								_Utils_Tuple2(startIndex, related)))
						]))
				]);
		}
	});
var $author$project$Experimental$OnLoad$event = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'load',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Components$DocumentBrowser$Full$viewSelectedGroupRendered = function (options) {
	var _v0 = options.onSelectedGroupRendered;
	if (_v0.$ === 'Just') {
		var msg = _v0.a;
		return A3(
			$elm$html$Html$node,
			'style',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__selected-group-rendered'),
					$author$project$Experimental$OnLoad$event(msg)
				]),
			_List_Nil);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$DocumentBrowser$Full$thumbnailView = F4(
	function (options, selectedKey, index, _v0) {
		var key = _v0.a;
		var value = _v0.b;
		return _Utils_eq(key, selectedKey) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__list-item')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Components$DocumentBrowser$Full$viewSelectedGroupRendered(options),
				A2(
					$elm$core$List$cons,
					A3(
						$author$project$Components$DocumentBrowser$Full$viewGroupHeader,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(
								$author$project$Components$DocumentBrowser$Full$selectedGroupHeadingId(options.scrollContainerSuffix))
							]),
						index,
						$elm$html$Html$text('')),
					A2($author$project$Components$DocumentBrowser$Full$selectedGroupThumbnailLists, options, value)))) : A3(
			$author$project$Components$DocumentBrowser$Full$collapsedGroupThumbnailView,
			options,
			index,
			_Utils_Tuple2(key, value));
	});
var $author$project$Components$DocumentBrowser$Full$documentThumbnailListView = function (options) {
	var _v0 = options.documents;
	if (_v0.$ === 'UngroupedDocuments') {
		var documentPages = _v0.a.documentPages;
		var documents = _v0.a.documents;
		if (options.groupThumbnailsByDocumentBatch) {
			if (options.accountSettings.documentsViewerDoctypeGroupingEnabled) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-thumbnail-list')
						]),
					A2(
						$author$project$Components$DocumentBrowser$Full$thumbnailViewItems,
						options,
						_Utils_Tuple2(
							0,
							{documentPages: documentPages, documents: documents})));
			} else {
				var displayBatch = function (_v1) {
					var document = _v1.a;
					var indexedPairs = _v1.b;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Components$DocumentBrowser$Full$emailHeading, options, document),
						A2(
							$author$project$Components$DocumentBrowser$Full$thumbnailViewItems,
							options,
							$author$project$Components$DocumentBrowser$Full$docGroups(indexedPairs)));
				};
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__list-item--batched')
						]),
					A2(
						$elm$core$List$concatMap,
						displayBatch,
						$author$project$Components$DocumentBrowser$Full$groupedByBatch(options)));
			}
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-thumbnail-list')
					]),
				A2(
					$elm$core$List$indexedMap,
					A2($author$project$Components$DocumentBrowser$Full$documentThumbnailView, options, 0),
					A3($elm$core$List$map2, $elm$core$Tuple$pair, documents, documentPages)));
		}
	} else {
		var selectedKey = _v0.a;
		var dict = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-thumbnail-list')
				]),
			A2(
				$elm$core$List$indexedMap,
				A2($author$project$Components$DocumentBrowser$Full$thumbnailView, options, selectedKey),
				$elm$core$Dict$toList(dict)));
	}
};
var $author$project$Components$DocumentBrowser$Full$area = function (box) {
	return box.height * box.width;
};
var $author$project$Components$DocumentBrowser$Full$overlapArea = F2(
	function (one, other) {
		var overlap = F4(
			function (start, length, otherStart, otherLength) {
				return A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, start + length, otherStart + otherLength) - A2($elm$core$Basics$max, start, otherStart));
			});
		return A4(overlap, one.top, one.height, other.top, other.height) * A4(overlap, one.left, one.width, other.left, other.width);
	});
var $author$project$Components$DocumentBrowser$Full$alreadyBoxed = F2(
	function (highlightBoxes, mark) {
		return A2(
			$elm$core$List$any,
			function (box) {
				return _Utils_cmp(
					A2($author$project$Components$DocumentBrowser$Full$overlapArea, box, mark),
					0.5 * $author$project$Components$DocumentBrowser$Full$area(mark)) > -1;
			},
			highlightBoxes);
	});
var $author$project$Components$DocumentBrowser$AddressMarks$mark = F2(
	function (place, box) {
		return {height: box.height, left: box.left, place: place, top: box.top, width: box.width};
	});
var $author$project$Components$DocumentBrowser$AddressMarks$maxLineGapInHeights = 2.0;
var $author$project$Components$DocumentBrowser$AddressMarks$sameBlock = F2(
	function (one, other) {
		var verticalGap = A2($elm$core$Basics$max, one.box.top, other.box.top) - A2($elm$core$Basics$min, one.box.top + one.box.height, other.box.top + other.box.height);
		var horizontallyOverlapping = _Utils_cmp(
			A2($elm$core$Basics$min, one.box.left + one.box.width, other.box.left + other.box.width),
			A2($elm$core$Basics$max, one.box.left, other.box.left)) > 0;
		return horizontallyOverlapping && (_Utils_cmp(
			verticalGap,
			$author$project$Components$DocumentBrowser$AddressMarks$maxLineGapInHeights * A2($elm$core$Basics$max, one.box.height, other.box.height)) < 1);
	});
var $author$project$Components$DocumentBrowser$AddressMarks$blocks = function (candidates) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (candidate, gathered) {
				var _v0 = A2(
					$elm$core$List$partition,
					$elm$core$List$any(
						$author$project$Components$DocumentBrowser$AddressMarks$sameBlock(candidate)),
					gathered);
				var adjacent = _v0.a;
				var separate = _v0.b;
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$core$List$cons,
						candidate,
						$elm$core$List$concat(adjacent)),
					separate);
			}),
		_List_Nil,
		candidates);
};
var $author$project$Domain$DocumentPageLine$matching = F2(
	function (value, lines) {
		return A2(
			$elm$core$List$filter,
			$author$project$Domain$DocumentPageLine$matchOnChars(
				$elm$core$Maybe$Just(value)),
			lines);
	});
var $author$project$Components$DocumentBrowser$AddressMarks$shortestSearchableAnswer = 4;
var $author$project$Components$DocumentBrowser$AddressMarks$candidatesFor = F3(
	function (lines, index, answer) {
		var candidate = function (box) {
			return {answer: index, box: box, tier: answer.tier};
		};
		var _v0 = answer.location;
		if (_v0.$ === 'Just') {
			var location = _v0.a;
			return _List_fromArray(
				[
					candidate(
					{height: location.height, left: location.left, top: location.top, width: location.width})
				]);
		} else {
			return (_Utils_cmp(
				$elm$core$String$length(
					$elm$core$String$trim(answer.value)),
				$author$project$Components$DocumentBrowser$AddressMarks$shortestSearchableAnswer) < 0) ? _List_Nil : A2(
				$elm$core$List$map,
				function (line) {
					return candidate(
						{height: line.height, left: line.left, top: line.top, width: line.width});
				},
				A2($author$project$Domain$DocumentPageLine$matching, answer.value, lines));
		}
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$DocumentBrowser$AddressMarks$pair = F2(
	function (one, other) {
		var top = A2($elm$core$Basics$min, one.top, other.top);
		var left = A2($elm$core$Basics$min, one.left, other.left);
		return {
			height: A2($elm$core$Basics$max, one.top + one.height, other.top + other.height) - top,
			left: left,
			top: top,
			width: A2($elm$core$Basics$max, one.left + one.width, other.left + other.width) - left
		};
	});
var $author$project$Components$DocumentBrowser$AddressMarks$union = function (block) {
	var _v0 = A2(
		$elm$core$List$map,
		function ($) {
			return $.box;
		},
		block);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = _v0.a;
		var rest = _v0.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $author$project$Components$DocumentBrowser$AddressMarks$pair, first, rest));
	}
};
var $author$project$Components$DocumentBrowser$AddressMarks$rank = function (block) {
	return _Utils_Tuple3(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.tier;
					},
					block))),
		$elm$core$List$length(
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.answer;
					},
					block))),
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (box) {
					return -(box.height * box.width);
				},
				$author$project$Components$DocumentBrowser$AddressMarks$union(block))));
};
var $author$project$Components$DocumentBrowser$AddressMarks$chosenBlock = function (gathered) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$sortWith,
			F2(
				function (one, other) {
					return A2(
						$elm$core$Basics$compare,
						$author$project$Components$DocumentBrowser$AddressMarks$rank(other),
						$author$project$Components$DocumentBrowser$AddressMarks$rank(one));
				}),
			gathered));
};
var $author$project$Components$DocumentBrowser$AddressMarks$placeBox = F2(
	function (lines, answers) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$DocumentBrowser$AddressMarks$union,
			$author$project$Components$DocumentBrowser$AddressMarks$chosenBlock(
				$author$project$Components$DocumentBrowser$AddressMarks$blocks(
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							$author$project$Components$DocumentBrowser$AddressMarks$candidatesFor(lines),
							answers)))));
	});
var $author$project$Components$DocumentBrowser$AddressMarks$forPage = F2(
	function (lines, answers) {
		return A2(
			$elm$core$List$filterMap,
			function (place) {
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$DocumentBrowser$AddressMarks$mark(place),
					A2(
						$author$project$Components$DocumentBrowser$AddressMarks$placeBox,
						lines,
						A2(
							$elm$core$List$filter,
							function (answer) {
								return _Utils_eq(answer.place, place);
							},
							answers)));
			},
			_List_fromArray(
				[$author$project$AuditPb$AddressPlaceOrigin, $author$project$AuditPb$AddressPlaceDestination]));
	});
var $author$project$Components$DocumentBrowser$Full$markableAddressBoxes = F4(
	function (options, highlightBoxes, lines, documentPage) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				$author$project$Components$DocumentBrowser$Full$alreadyBoxed(highlightBoxes)),
			A2(
				$author$project$Components$DocumentBrowser$AddressMarks$forPage,
				lines,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Dict$get,
						$author$project$Domain$DocumentPageId$toComparable(documentPage.id),
						options.addressAnswers))));
	});
var $author$project$Components$DocumentBrowser$Full$resolveHighlightTarget = F3(
	function (target, currentPageId, lines) {
		if (target.$ === 'HighlightBox') {
			var box = target.a;
			return _Utils_eq(box.documentPageId, currentPageId) ? _List_fromArray(
				[box]) : _List_Nil;
		} else {
			var value = target.a;
			return A2(
				$elm$core$List$map,
				function (line) {
					return {documentPageId: currentPageId, height: line.height, left: line.left, top: line.top, width: line.width};
				},
				A2($author$project$Domain$DocumentPageLine$matching, value, lines));
		}
	});
var $author$project$Components$DocumentBrowser$Full$addressMarkClass = 'o-t--address';
var $author$project$Components$DocumentBrowser$Full$placeMarkClass = function (place) {
	if (place.$ === 'AddressPlaceOrigin') {
		return 'o-t--address-origin';
	} else {
		return 'o-t--address-destination';
	}
};
var $author$project$Components$DocumentBrowser$Full$placeName = function (place) {
	if (place.$ === 'AddressPlaceOrigin') {
		return 'Origin';
	} else {
		return 'Destination';
	}
};
var $author$project$Components$DocumentBrowser$Full$viewAddressLegendItem = function (place) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('document-browser__mark-legend-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__mark-legend-swatch'),
						$elm$html$Html$Attributes$class($author$project$Components$DocumentBrowser$Full$addressMarkClass),
						$elm$html$Html$Attributes$class(
						$author$project$Components$DocumentBrowser$Full$placeMarkClass(place))
					]),
				_List_Nil),
				$elm$html$Html$text(
				$author$project$Components$DocumentBrowser$Full$placeName(place))
			]));
};
var $author$project$Components$DocumentBrowser$Full$viewAddressLegend = function (addressAnswers) {
	return A2(
		$elm$core$List$all,
		$elm$core$List$isEmpty,
		$elm$core$Dict$values(addressAnswers)) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__mark-legend')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$DocumentBrowser$Full$viewAddressLegendItem,
				_List_fromArray(
					[$author$project$AuditPb$AddressPlaceOrigin, $author$project$AuditPb$AddressPlaceDestination])))
		]);
};
var $author$project$Components$DocumentPageMark$viewAs = F3(
	function (modifiers, maybeId, box) {
		var percent = function (size) {
			return $elm$core$String$fromFloat(size * 100) + '%';
		};
		var pad = 0.005;
		return A2(
			$elm$html$Html$span,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$cons, 'o-t', modifiers))),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2(
						$elm$html$Html$Attributes$style,
						'top',
						percent(box.top - pad)),
						A2(
						$elm$html$Html$Attributes$style,
						'left',
						percent(box.left - pad)),
						A2(
						$elm$html$Html$Attributes$style,
						'height',
						percent(box.height + (2 * pad))),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						percent(box.width + (2 * pad)))
					]),
				$elm_community$maybe_extra$Maybe$Extra$toList(
					A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, maybeId))),
			_List_Nil);
	});
var $author$project$Components$DocumentBrowser$Full$viewAddressMark = function (mark) {
	return A3(
		$author$project$Components$DocumentPageMark$viewAs,
		_List_fromArray(
			[
				$author$project$Components$DocumentBrowser$Full$addressMarkClass,
				$author$project$Components$DocumentBrowser$Full$placeMarkClass(mark.place)
			]),
		$elm$core$Maybe$Nothing,
		mark);
};
var $author$project$Components$DocumentPageMark$view = F2(
	function (maybeId, box) {
		return A3(
			$author$project$Components$DocumentPageMark$viewAs,
			_List_fromArray(
				['o-t--pinpoint']),
			maybeId,
			box);
	});
var $author$project$Components$DocumentBrowser$Full$viewHighlight = F2(
	function (scrollContainerSuffix, highlightBoxes) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, box) {
					return A2(
						$author$project$Components$DocumentPageMark$view,
						(!index) ? $elm$core$Maybe$Just(
							$author$project$Components$DocumentBrowser$Full$highlightBoxId(scrollContainerSuffix)) : $elm$core$Maybe$Nothing,
						box);
				}),
			highlightBoxes);
	});
var $elm$html$Html$Events$onDoubleClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'dblclick',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Components$DocumentBrowser$Full$viewLineHandle = F3(
	function (setValue, lineDragAttributes, line) {
		var percent = function (n) {
			return $elm$core$String$fromFloat(n * 100) + '%';
		};
		return A2(
			$elm$html$Html$span,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('o-t'),
						$elm$html$Html$Events$onDoubleClick(
						setValue(line.chars)),
						A2(
						$elm$html$Html$Attributes$style,
						'top',
						percent(line.top)),
						A2(
						$elm$html$Html$Attributes$style,
						'left',
						percent(line.left)),
						A2(
						$elm$html$Html$Attributes$style,
						'height',
						percent(line.height)),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						percent(line.width)),
						$elm$html$Html$Attributes$title(line.chars),
						A2($elm$html$Html$Attributes$attribute, 'data-chars', line.chars),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-top',
						$elm$core$String$fromFloat(line.top)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-left',
						$elm$core$String$fromFloat(line.left)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-height',
						$elm$core$String$fromFloat(line.height)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-width',
						$elm$core$String$fromFloat(line.width))
					]),
				lineDragAttributes(line)),
			_List_Nil);
	});
var $author$project$Components$DocumentBrowser$Full$mainImageView = F3(
	function (options, lines, documentPage) {
		var pageUrl = function () {
			var _v6 = options.pageImage;
			if (_v6.$ === 'Raw') {
				return documentPage.rawFullUrl;
			} else {
				return options.fullImage ? documentPage.fullUrl : documentPage.previewUrl;
			}
		}();
		var maybeSize = (options.zoomLevel > 1) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'transform',
				'Scale(' + ($elm$core$String$fromFloat(options.zoomLevel) + ')')),
				A2($elm$html$Html$Attributes$style, 'transform-origin', '0 0')
			]) : _List_Nil;
		var imgAttributes = function (url) {
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__main-image-selected'),
					A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous'),
					A2($elm$html$Html$Attributes$attribute, 'draggable', 'false'),
					$elm$html$Html$Attributes$src(url)
				]);
		};
		var highlightBoxes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (highlight) {
					return A3($author$project$Components$DocumentBrowser$Full$resolveHighlightTarget, highlight.target, documentPage.id, lines);
				},
				options.highlight));
		var addressMarks = A4($author$project$Components$DocumentBrowser$Full$markableAddressBoxes, options, highlightBoxes, lines, documentPage);
		var _v0 = function () {
			var _v1 = options.viewMode;
			if (_v1.$ === 'Just') {
				if (_v1.a.$ === 'Height') {
					var _v2 = _v1.a;
					return _Utils_Tuple3(
						'document-browser__popout-height-mode-zoomable-container',
						'document-browser__popout-main-image-scroll-anchor',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('document-browser__full-height')
							]));
				} else {
					var _v3 = _v1.a;
					return _Utils_Tuple3(
						'document-browser__zoomable-container',
						'document-browser__popout-main-image-scroll-anchor',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('document-browser__full-width')
							]));
				}
			} else {
				return _Utils_Tuple3('document-browser__zoomable-container', 'document-browser__main-image-scroll-anchor', _List_Nil);
			}
		}();
		var zoomableContainer = _v0.a;
		var mainImageContainerClass = _v0.b;
		var viewModeClass = _v0.c;
		var _v4 = (!documentPage.rotation) ? _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				A2($author$project$Components$DocumentBrowser$Full$viewLineHandle, options.setLineSelection, options.lineDragAttributes),
				lines),
			A2($author$project$Components$DocumentBrowser$Full$viewHighlight, options.scrollContainerSuffix, highlightBoxes)) : _Utils_Tuple2(_List_Nil, _List_Nil);
		var lineHandles = _v4.a;
		var highlightMarks = _v4.b;
		if (pageUrl.$ === 'Nothing') {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('No Preview Available')
					]));
		} else {
			var url = pageUrl.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-toolbar__wrapper')
					]),
				_Utils_ap(
					$author$project$Components$DocumentBrowser$Full$viewAddressLegend(options.addressAnswers),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(zoomableContainer),
									$elm$html$Html$Attributes$id(
									$author$project$Components$DocumentBrowser$Full$scrollContainerId(options.scrollContainerSuffix)),
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
									A2($elm$html$Html$Attributes$style, 'min-height', '0'),
									A2($elm$html$Html$Attributes$style, 'overflow', 'auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									A2(
										$elm$core$List$append,
										options.dragScrollAttributes,
										A2(
											$elm$core$List$append,
											viewModeClass,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('ocred-document__wrapper--enabled'),
													$elm$html$Html$Attributes$class('document-browser__main-image-wrapper')
												]))),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											A2(
												$elm$core$List$append,
												maybeSize,
												A2(
													$elm$core$List$append,
													viewModeClass,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(mainImageContainerClass),
															$elm$html$Html$Attributes$id(
															$author$project$Components$DocumentBrowser$Full$mainImageContainerId(options.scrollContainerSuffix))
														]))),
											A2(
												$elm$core$List$cons,
												A2(
													$elm$html$Html$img,
													A2(
														$elm$core$List$append,
														viewModeClass,
														imgAttributes(url)),
													_List_Nil),
												_Utils_ap(
													$elm_community$maybe_extra$Maybe$Extra$toList(options.annotationOverlay),
													_Utils_ap(
														lineHandles,
														_Utils_ap(
															A2($elm$core$List$map, $author$project$Components$DocumentBrowser$Full$viewAddressMark, addressMarks),
															highlightMarks)))))
										]))
								]))
						])));
		}
	});
var $author$project$Components$DocumentBrowser$Full$view = function (options) {
	var documentPageLines = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$andThen,
			function (compId) {
				return A2($elm$core$Dict$get, compId, options.lines);
			},
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.id;
					},
					$author$project$Domain$DocumentPageId$toComparable),
				A2($author$project$Components$DocumentBrowser$Full$selectedDocumentPage, options.documents, options.selection))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('document-browser__container', true),
						_Utils_Tuple2('document-browser__restricted-height', options.restrictHeight),
						_Utils_Tuple2('document-browser__full-height', !options.restrictHeight)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__main-image-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						options.secondary),
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activity-items')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('alert-box--highlight')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No Document Selected')
										]))
								])),
						A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$DocumentBrowser$Full$mainImageView, options, documentPageLines),
							A2($author$project$Components$DocumentBrowser$Full$selectedDocumentPage, options.documents, options.selection)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('document-browser__document-list', true),
								_Utils_Tuple2('document-browser__document-list-popout', options.popout)
							])),
						$elm$html$Html$Attributes$id(
						$author$project$Components$DocumentBrowser$Full$groupRailId(options.scrollContainerSuffix))
					]),
				_List_fromArray(
					[
						options.viewAddDocumentToLoadButton,
						$author$project$Components$DocumentBrowser$Full$documentThumbnailListView(options)
					]))
			]));
};
var $author$project$Components$DocumentsBrowser$viewDocumentsTab = F3(
	function (data, model, options) {
		var updatePod = A3(
			$author$project$Components$DocumentsBrowser$maybeActionIfEnabled,
			$author$project$Components$DocumentsBrowser$UpdatePodAction,
			model,
			$elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$UpdatePod));
		var updateDocumentType = $elm$core$Maybe$Nothing;
		var selection = A2($author$project$Components$DocumentsBrowser$selectedPage, data, model);
		var rotate = A3(
			$author$project$Components$DocumentsBrowser$maybeActionIfEnabled,
			$author$project$Components$DocumentsBrowser$RotateAction,
			model,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$DocumentsBrowser$Rotate,
				A2(
					$author$project$Components$DocumentsBrowser$selectedDocPage,
					$author$project$Forward$Remote$Loaded(data),
					model)));
		var possiblyGroupedDocuments = A2($author$project$Components$DocumentsBrowser$getPossiblyGroupedDocuments, data, model);
		var maybeSelectedDocument = A2($author$project$Components$DocumentBrowser$Full$selectedDocument, possiblyGroupedDocuments, selection);
		var selectedDocId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.id;
			},
			maybeSelectedDocument);
		var splitFromDocument = A3(
			$author$project$Components$DocumentsBrowser$maybeActionIfEnabled,
			$author$project$Components$DocumentsBrowser$SplitFromDocumentAction,
			model,
			A3(
				$elm$core$Maybe$map2,
				$author$project$Components$DocumentsBrowser$SplitFromDocument,
				selectedDocId,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.id;
					},
					A2(
						$author$project$Components$DocumentsBrowser$selectedDocPage,
						$author$project$Forward$Remote$Loaded(data),
						model))));
		var maybeSelectedDocPageId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.id;
			},
			A2(
				$author$project$Components$DocumentsBrowser$selectedDocPage,
				$author$project$Forward$Remote$Loaded(data),
				model));
		var tools = A2(
			$elm$core$List$map,
			$author$project$Components$DocumentBrowser$AnnotateToolbar$mapTool($author$project$Components$DocumentsBrowser$AnnotationMsg),
			A2($author$project$Components$DocumentBrowser$AnnotationOverlay$tools, data.accountSettings, maybeSelectedDocPageId));
		var maybeSelectGroup = function () {
			var _v1 = model.currentProcessingSelection;
			if (_v1.$ === 'GroupedDocumentBatchSelection') {
				var batchId = _v1.a;
				return $elm$core$Maybe$Just(
					$author$project$Components$DocumentsBrowser$SelectGroup(batchId));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var maybePreviousDocument = A2(
			$author$project$Components$DocumentBrowser$Full$selectedDocument,
			possiblyGroupedDocuments,
			_Utils_update(
				selection,
				{documentIndex: selection.documentIndex - 1}));
		var previousDocumentInSameBatch = A2(
			$elm$core$Maybe$withDefault,
			false,
			A3(
				$elm$core$Maybe$map2,
				$elm$core$Basics$eq,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.documentBatchId;
					},
					maybeSelectedDocument),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.documentBatchId;
					},
					maybePreviousDocument)));
		var shouldShowMergeButton = data.accountSettings.documentsViewerDoctypeGroupingEnabled ? previousDocumentInSameBatch : (selection.documentIndex > 0);
		var previousDocId = function () {
			var _v0 = _Utils_Tuple2(shouldShowMergeButton, maybePreviousDocument);
			if (_v0.a && (_v0.b.$ === 'Just')) {
				var previousDocument = _v0.b.a;
				return $elm$core$Maybe$Just(previousDocument.id);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var mergeToPrevious = A3(
			$author$project$Components$DocumentsBrowser$maybeActionIfEnabled,
			$author$project$Components$DocumentsBrowser$MergeToPreviousAction,
			model,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$DocumentsBrowser$MergeToPrevious,
				A3($elm$core$Maybe$map2, $author$project$Api$Documents$MergeDocumentsData, selectedDocId, previousDocId)));
		var keepMsgIf = F2(
			function (condition, msg) {
				return condition ? $elm$core$Maybe$Just(msg) : $elm$core$Maybe$Nothing;
			});
		var markIllegible = A3(
			$author$project$Components$DocumentsBrowser$maybeActionIfEnabled,
			$author$project$Components$DocumentsBrowser$MarkIllegibleAction,
			model,
			A2(
				keepMsgIf,
				A2($author$project$Components$DocumentsBrowser$illegibleEnabled, data, model),
				A3($author$project$Components$DocumentsBrowser$illegibleMsg, data, model, selection)));
		var zoomIn = A2(
			keepMsgIf,
			$author$project$Components$DocumentsBrowser$canZoomIn(model.zoomLevel),
			$author$project$Components$DocumentsBrowser$ZoomIn);
		var zoomOut = A2(
			keepMsgIf,
			$author$project$Components$DocumentsBrowser$canZoomOut(model.zoomLevel),
			$author$project$Components$DocumentsBrowser$ZoomOut);
		var hide = A2(
			keepMsgIf,
			A2($author$project$Components$DocumentsBrowser$hideEnabled, data, model),
			A3($author$project$Components$DocumentsBrowser$hideMsg, data, model, selection));
		var hasEmailMessage = A2(
			$author$project$Components$DocumentBrowser$MessagesView$hasEmailMessageForBatchId,
			data.emailMessageDataList,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.documentBatchId;
				},
				maybeSelectedDocument));
		var duplicate = A3(
			$author$project$Components$DocumentsBrowser$maybeActionIfEnabled,
			$author$project$Components$DocumentsBrowser$DuplicateAction,
			model,
			$elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$Duplicate));
		var toolbarMsgs = {
			annotateSession: A2(
				$author$project$Components$DocumentBrowser$AnnotateToolbar$mapSession,
				$author$project$Components$DocumentsBrowser$AnnotationMsg,
				A2($author$project$Components$DocumentBrowser$AnnotationOverlay$sessionActions, maybeSelectedDocPageId, model.annotations)),
			duplicate: duplicate,
			hide: hide,
			markIllegible: markIllegible,
			mergeToPrevious: mergeToPrevious,
			rotate: rotate,
			splitFromDocument: splitFromDocument,
			toggleAnnotating: $author$project$Components$DocumentsBrowser$ToggleAnnotating,
			tools: tools,
			updateDocumentType: updateDocumentType,
			updatePod: updatePod,
			updateViewMode: $author$project$Components$DocumentsBrowser$UpdateViewMode,
			viewEmail: $author$project$Components$DocumentsBrowser$ViewEmailToolbarClick(
				A2(
					$author$project$Components$DocumentsBrowser$selectedDocument,
					$author$project$Forward$Remote$Loaded(data),
					model)),
			zoomIn: zoomIn,
			zoomOut: zoomOut
		};
		var documentData = A2($author$project$Components$DocumentsBrowser$getDocumentData, data, model);
		var documentTokens = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.token;
			},
			documentData.documents);
		var documentAnnotationEnabled = A2($author$project$Components$DocumentsBrowser$isActionEnabled, $author$project$Components$DocumentsBrowser$AnnotateDocumentAction, model) && data.accountSettings.documentAnnotationEnabled;
		var toolbarConfig = {
			accountSettings: data.accountSettings,
			annotating: model.annotating,
			documentAnnotationEnabled: documentAnnotationEnabled,
			documentIsPodUpdates: model.documentIsPodUpdates,
			documentTokens: documentTokens,
			enabledDocumentTypes: model.enabledDocumentTypes,
			hasEmailMessage: hasEmailMessage,
			maybeDocument: maybeSelectedDocument,
			msgs: toolbarMsgs,
			podRequirementSkipped: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.podRequirementSkipped;
					},
					data.carrierInvoice)),
			selectedPage: selection,
			selectedPageIsIllegible: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.illegible;
					},
					A2(
						$author$project$Components$DocumentsBrowser$selectedDocPage,
						$author$project$Forward$Remote$Loaded(data),
						model)))
		};
		var annotationOverlay = A2(
			$elm$core$Maybe$map,
			$elm$html$Html$map($author$project$Components$DocumentsBrowser$AnnotationMsg),
			A3(
				$author$project$Components$DocumentBrowser$AnnotationOverlay$view,
				$author$project$Components$DocumentBrowser$Full$mainImageContainerId(model.scrollContainerSuffix),
				maybeSelectedDocPageId,
				model.annotations));
		return $author$project$Components$DocumentBrowser$Full$view(
			{
				account: data.currentAccount,
				accountSettings: data.accountSettings,
				addressAnswers: A2($author$project$Components$DocumentsBrowser$addressAnswersToMark, data, model),
				annotationOverlay: annotationOverlay,
				documentIsPodUpdates: model.documentIsPodUpdates,
				documents: possiblyGroupedDocuments,
				dragScrollAttributes: $author$project$Components$DocumentsBrowser$dragScrollAttributes(model),
				emailMessageDataList: $elm$core$Maybe$Just(data.emailMessageDataList),
				fullImage: true,
				groupStatusTag: $author$project$Components$DocumentsBrowser$groupStatusTag(data.invoiceStateByGroupId),
				groupThumbnailsByDocumentBatch: true,
				highlight: model.highlight,
				lineDragAttributes: (options.enableLineDragging && (model.zoomLevel <= 1)) ? function (line) {
					return A2(
						$elm$core$List$map,
						$elm$html$Html$Attributes$map($author$project$Components$DocumentsBrowser$LineDragStarted),
						$author$project$Components$DragDrop$dragAttributes(
							$author$project$Components$DragDrop$DragId(line)));
				} : $elm$core$Basics$always(_List_Nil),
				lines: A2($author$project$Components$DocumentsBrowser$getDocumentLines, data, model),
				onRightClick: options.enableThumbnailRightClick ? $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$RightClickedThumbnail) : $elm$core$Maybe$Nothing,
				onSelect: A2($author$project$Components$DocumentsBrowser$buildSelectDocumentMsg, data, model),
				onSelectGroup: maybeSelectGroup,
				onSelectedGroupRendered: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$SelectedGroupRendered),
				onViewEmailClick: $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$ViewEmailBrowserClick),
				overlay: options.overlay,
				pageImage: A2($author$project$Components$DocumentBrowser$AnnotationOverlay$pageImage, maybeSelectedDocPageId, model.annotations),
				popout: model.popout,
				relatedDocuments: A2(
					$elm$core$Maybe$map,
					function (startIndex) {
						return {startIndex: startIndex, title: 'Related Documents'};
					},
					data.groupedDocumentData.relatedDocumentsStartIndex),
				restrictHeight: false,
				scrollContainerSuffix: model.scrollContainerSuffix,
				secondary: $elm$core$Maybe$Just(
					A2($author$project$Components$DocumentBrowser$DocumentViewerToolbar$view, data.currentUser, toolbarConfig)),
				selection: selection,
				setLineSelection: $author$project$Components$DocumentsBrowser$SetLineSelection,
				viewAddDocumentToLoadButton: A2(
					$elm$html$Html$map,
					$author$project$Components$DocumentsBrowser$AddDocumentToLoadMsg,
					A2($author$project$Components$DocumentBrowser$AddDocumentToLoad$view, data.addDocumentToLoadData, model.addDocumentToLoad)),
				viewMode: model.viewMode,
				zoomLevel: model.zoomLevel
			});
	});
var $author$project$Components$DocumentsBrowser$AddLabelToMessage = F2(
	function (a, b) {
		return {$: 'AddLabelToMessage', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$CreateDocumentFromMessage = function (a) {
	return {$: 'CreateDocumentFromMessage', a: a};
};
var $author$project$Components$DocumentsBrowser$DeleteLabelFromMessage = F2(
	function (a, b) {
		return {$: 'DeleteLabelFromMessage', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$SaveMessageAsDocument = F2(
	function (a, b) {
		return {$: 'SaveMessageAsDocument', a: a, b: b};
	});
var $author$project$Components$DocumentsBrowser$SelectLabelForMessage = function (a) {
	return {$: 'SelectLabelForMessage', a: a};
};
var $author$project$Components$DocumentsBrowser$getDocumentGroupId = F2(
	function (data, model) {
		var _v0 = model.currentProcessingSelection;
		switch (_v0.$) {
			case 'GroupedDocumentBatchSelection':
				var documentGroupId = _v0.b;
				return $elm$core$Maybe$Just(documentGroupId);
			case 'CarrierInvoiceSelection':
				return A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.documentGroupId;
					},
					$elm$core$List$head(data.documentData.browserDocumentData.documents));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$DocumentsBrowser$isPortalSubmission = function (data) {
	return A2(
		$elm$core$List$any,
		function (emd) {
			return emd.emailMessage.hasFactorClientInvoiceSubmission;
		},
		data.emailMessageDataList);
};
var $author$project$Indexer$DocumentBrowser$checkSentOrReceived = F2(
	function (_v0, _v1) {
		var rejectMessage = _v0.rejectMessage;
		var emailMessage = _v0.emailMessage;
		var received = _v1.received;
		var sent = _v1.sent;
		var _v2 = _Utils_Tuple2(emailMessage.messageType, rejectMessage);
		if ((_v2.a.$ === 'Just') && (_v2.a.a.$ === 'EmailMessageTypeSent')) {
			var _v3 = _v2.a.a;
			return sent;
		} else {
			if (_v2.b.$ === 'Just') {
				return sent;
			} else {
				return received;
			}
		}
	});
var $author$project$Domain$EmailMessage$additionalRecipients = function (emailMessage) {
	return A2(
		$elm$core$List$filter,
		function (x) {
			return !_Utils_eq(
				$elm$core$Maybe$Just(x),
				emailMessage.recipientAddress);
		},
		A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.email;
			},
			emailMessage.rawTo));
};
var $author$project$Indexer$DocumentBrowser$viewEmailDetail = F2(
	function (name, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('activity-item__detail-line')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewEmailDetailFromRecipient = F2(
	function (name, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('activity-item__detail-line')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-label activity-item__detail-line-label__from')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewEmailDetailSubject = F2(
	function (name, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('activity-item__detail-line activity-item__primary-details')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewEmailHeader = F3(
	function (tz, email, labelEditor) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('email-viewer__header')
				]),
			_List_fromArray(
				[
					A2($author$project$Indexer$DocumentBrowser$viewEmailDetailSubject, 'Subject', email.subject),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__secondary-details')
						]),
					_List_fromArray(
						[
							A2($author$project$Indexer$DocumentBrowser$viewEmailDetailFromRecipient, 'From', email.senderAddress),
							A2(
							$author$project$Indexer$DocumentBrowser$viewEmailDetailFromRecipient,
							'Recipient',
							A2($elm$core$Maybe$withDefault, '', email.recipientAddress)),
							$elm$core$List$isEmpty(
							$author$project$Domain$EmailMessage$additionalRecipients(email)) ? $elm$html$Html$text('') : A2(
							$author$project$Indexer$DocumentBrowser$viewEmailDetail,
							'Additional Recipients',
							A2(
								$elm$core$String$join,
								', ',
								$author$project$Domain$EmailMessage$additionalRecipients(email))),
							$elm$core$List$isEmpty(email.rawCc) ? $elm$html$Html$text('') : A2(
							$author$project$Indexer$DocumentBrowser$viewEmailDetail,
							'CC',
							A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$filterMap,
									function ($) {
										return $.email;
									},
									email.rawCc))),
							A2(
							$author$project$Indexer$DocumentBrowser$viewEmailDetail,
							'Received',
							_Utils_ap(
								A2($author$project$Helpers$Date$dateStringFormat2, tz, email.createdAt),
								_Utils_ap(
									$author$project$Helpers$String$nbsp,
									A2($author$project$Helpers$Date$timeString, tz, email.createdAt))))
						])),
					labelEditor
				]));
	});
var $author$project$Components$DocumentBrowser$MessagesView$keyedDiv = $elm$html$Html$Keyed$node('div');
var $author$project$Components$DocumentBrowser$MessagesView$viewLabel = F4(
	function (model, maybeEditActions, email, name) {
		var viewDeleteIcon = function (editActions) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2(editActions.deleteLabelFromMessage, email.id, name))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-x-circle')
							]),
						_List_Nil)
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carrier-labels__label email-label-editor__label-display')
				]),
			_List_fromArray(
				[
					model.updating ? $elm$html$Html$text('saving...') : A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2($elm$core$Maybe$map, viewDeleteIcon, maybeEditActions),
								$elm$core$Maybe$Just(
								$elm$html$Html$text(name))
							])))
				]));
	});
var $author$project$Components$DocumentBrowser$MessagesView$viewNewLabelSelect = F3(
	function (model, editActions, unselected) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(model.selectedLabelIndex)),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$andThen,
						function (str) {
							var _v0 = $elm$core$String$toInt(str);
							if (_v0.$ === 'Nothing') {
								return $elm$json$Json$Decode$fail('could not convert string \u0027' + (str + '\u0027 to an Int'));
							} else {
								var index = _v0.a;
								return $elm$json$Json$Decode$succeed(
									editActions.selectLabelForMessage(index));
							}
						},
						$elm$html$Html$Events$targetValue))
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, name) {
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(i))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								]));
					}),
				unselected));
	});
var $author$project$Components$DocumentBrowser$MessagesView$viewNewLabel = F3(
	function (model, emailMessage, editActions) {
		var labels = A2($author$project$Indexer$DocumentBrowser$availableLabels, model.accountSettings, emailMessage);
		if (!labels.b) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('alert-box secondary')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('All available labels have been added.')
					]));
		} else {
			var unselected = labels;
			return A2(
				$author$project$Components$Shared$Grid$autoRow,
				5,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row collapse')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Grid$column,
								7,
								_List_fromArray(
									[
										A3($author$project$Components$DocumentBrowser$MessagesView$viewNewLabelSelect, model, editActions, unselected)
									])),
								function () {
								var attrs = function () {
									if (!model.updating) {
										var _v1 = A2($elm_community$list_extra$List$Extra$getAt, model.selectedLabelIndex, unselected);
										if (_v1.$ === 'Just') {
											var label = _v1.a;
											return _List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													A2(editActions.addLabelToMessage, emailMessage.id, label))
												]);
										} else {
											return _List_fromArray(
												[
													$elm$html$Html$Attributes$disabled(true),
													$elm$html$Html$Attributes$class('disabled')
												]);
										}
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$Attributes$disabled(true),
												$elm$html$Html$Attributes$class('disabled')
											]);
									}
								}();
								return A2(
									$author$project$Components$Shared$Grid$column,
									3,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$class('button postfix email-label-editor__new-label-postfix'),
												attrs),
											_List_fromArray(
												[
													$elm$html$Html$text('Add Label')
												]))
										]));
							}()
							]))
					]));
		}
	});
var $author$project$Components$DocumentBrowser$MessagesView$viewLabelEditor = F3(
	function (model, editActions, email) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$author$project$Components$DocumentBrowser$MessagesView$keyedDiv,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-label-editor__labels-list')
								]),
							A2(
								$elm$core$List$map,
								function (name) {
									return _Utils_Tuple2(
										name,
										A4($author$project$Components$DocumentBrowser$MessagesView$viewLabel, model, editActions, email, name));
								},
								email.labels))),
						A2(
						$elm$core$Maybe$map,
						A2($author$project$Components$DocumentBrowser$MessagesView$viewNewLabel, model, email),
						editActions)
					])));
	});
var $author$project$Components$DocumentBrowser$MessagesView$viewSaveAsDocument = F2(
	function (saveAsDocument, email) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-viewer__save-button button--confirmation'),
							$elm$html$Html$Events$onClick(
							saveAsDocument(email.id))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Save As Document')
						]))
				]));
	});
var $author$project$Components$DocumentBrowser$MessagesView$viewEmailMessage = F2(
	function (model, emailMessageData) {
		var sentMessageText = emailMessageData.emailMessage.automaticallySentAfterIndexing ? 'Sent Message (Automatic)' : 'Sent Message';
		var saveAsDocumentView = function () {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.maybeSaveMessageAsDocument;
				},
				model.editConfig);
			if (_v0.$ === 'Just') {
				var saveAsDocument = _v0.a;
				return A2(
					$author$project$Indexer$DocumentBrowser$checkSentOrReceived,
					emailMessageData,
					{
						received: A2($author$project$Components$DocumentBrowser$MessagesView$viewSaveAsDocument, saveAsDocument, emailMessageData.emailMessage),
						sent: $author$project$Helpers$Html$empty
					});
			} else {
				return $author$project$Helpers$Html$empty;
			}
		}();
		var labelEditorView = A2(
			$author$project$Indexer$DocumentBrowser$checkSentOrReceived,
			emailMessageData,
			{
				received: A3($author$project$Components$DocumentBrowser$MessagesView$viewLabelEditor, model, model.editConfig, emailMessageData.emailMessage),
				sent: $author$project$Helpers$Html$empty
			});
		var combinedView = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[saveAsDocumentView, labelEditorView]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-viewer__title')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Indexer$DocumentBrowser$checkSentOrReceived,
							emailMessageData,
							{
								received: $elm$html$Html$text('Received Message'),
								sent: $elm$html$Html$text(sentMessageText)
							})
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-viewer__email highlighted')
						]),
					_List_fromArray(
						[
							A3($author$project$Indexer$DocumentBrowser$viewEmailHeader, model.timeZone, emailMessageData.emailMessage, combinedView),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$Indexer$DocumentBrowser$emailViewerClass)
								]),
							$author$project$Domain$EmailBody$textToHtml(emailMessageData.emailMessage.textBody))
						]))
				]));
	});
var $author$project$Components$DocumentBrowser$MessagesView$viewEmailMessages = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$author$project$Components$DocumentBrowser$MessagesView$viewEmailMessage(model),
			model.emailMessages));
};
var $author$project$Components$DocumentBrowser$MessagesView$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('document-browser__container', true),
						_Utils_Tuple2('row', !model.fullHeight),
						_Utils_Tuple2('document-browser__full-height', model.fullHeight)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__main-image-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('activity-items document-browser__message-container')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Helpers$WaitingSpinner$waitingSpinnerWithText,
								'',
								model.savingAsDocument,
								_List_fromArray(
									[
										function () {
										var _v0 = model.emailMessages;
										if (!_v0.b) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('alert-box--highlight')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('No messages are available.')
													]));
										} else {
											return $author$project$Components$DocumentBrowser$MessagesView$viewEmailMessages(model);
										}
									}()
									]))
							]))
					]))
			]));
};
var $author$project$Components$DocumentsBrowser$viewMessagesTab = F3(
	function (tz, data, model) {
		var editConfig = (!A2($author$project$Components$DocumentsBrowser$isActionEnabled, $author$project$Components$DocumentsBrowser$EditMessageAction, model)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				addLabelToMessage: $author$project$Components$DocumentsBrowser$AddLabelToMessage,
				deleteLabelFromMessage: $author$project$Components$DocumentsBrowser$DeleteLabelFromMessage,
				maybeSaveMessageAsDocument: function () {
					if (model.savingMessageAsDocument || (model.savedMessageAsDocument || $author$project$Components$DocumentsBrowser$isPortalSubmission(data))) {
						return $elm$core$Maybe$Nothing;
					} else {
						var _v0 = model.currentProcessingSelection;
						if (_v0.$ === 'FactorInvoiceSelection') {
							return $elm$core$Maybe$Just($author$project$Components$DocumentsBrowser$CreateDocumentFromMessage);
						} else {
							return A2(
								$elm$core$Maybe$map,
								$author$project$Components$DocumentsBrowser$SaveMessageAsDocument,
								A2($author$project$Components$DocumentsBrowser$getDocumentGroupId, data, model));
						}
					}
				}(),
				selectLabelForMessage: $author$project$Components$DocumentsBrowser$SelectLabelForMessage
			});
		return $author$project$Components$DocumentBrowser$MessagesView$view(
			{accountSettings: data.accountSettings, editConfig: editConfig, emailMessages: data.emailMessageDataList, fullHeight: true, savingAsDocument: model.savingMessageAsDocument, selectedLabelIndex: model.selectedLabelIndex, timeZone: tz, updating: model.updating});
	});
var $author$project$Components$DocumentsBrowser$viewDocumentBrowser = F4(
	function (tz, data, model, options) {
		var _v0 = model.selectedTab;
		switch (_v0.$) {
			case 'Documents':
				return A3($author$project$Components$DocumentsBrowser$viewDocumentsTab, data, model, options);
			case 'Activity':
				return A3($author$project$Components$DocumentsBrowser$viewActivityTab, tz, data, model);
			default:
				return A3($author$project$Components$DocumentsBrowser$viewMessagesTab, tz, data, model);
		}
	});
var $author$project$Components$DocumentsBrowser$view = F4(
	function (tz, model, options, data) {
		var computedOptions = $author$project$Components$DocumentsBrowser$computeOptions(options);
		var _v0 = $author$project$Helpers$Html$optionalV3ReactStyleOverridesWrapperAttrs(data.accountSettings.auditV3ReactStyleOverrides);
		var outerAttrs = _v0.a;
		var innerAttrs = _v0.b;
		return model.updating ? (data.accountSettings.auditV3ReactStyleOverrides ? A2(
			$author$project$Ui$V3$Skeleton$viewCustom,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'border-radius', '0')
				]),
			{height: $elm$core$Maybe$Nothing}) : A2($author$project$Helpers$WaitingSpinner$waitingSpinner, true, _List_Nil)) : A2(
			$elm$html$Html$map,
			$author$project$Components$DocumentsBrowser$NonHotkeyMsg,
			A2(
				$elm$html$Html$div,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-indexer__main-body'),
							A2(
							$elm$html$Html$Attributes$style,
							'height',
							'calc(96vh + ' + ($elm$core$String$fromInt(model.viewPortHeightPxOffset) + 'px)'))
						]),
					outerAttrs),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('document-indexer__document-side'),
							innerAttrs),
						_List_fromArray(
							[
								A3($author$project$Components$DocumentsBrowser$viewDocBrowserTabs, model, computedOptions, data),
								A4($author$project$Components$DocumentsBrowser$viewDocumentBrowser, tz, data, model, computedOptions)
							]))
					])));
	});
var $author$project$Broker$Page$DocumentsViewerPopout$view = F3(
	function (tz, model, data) {
		return A2(
			$elm$html$Html$map,
			$author$project$Broker$Page$DocumentsViewerPopout$DocumentsBrowserMsg,
			A3(
				$author$project$Forward$LoadingView$viewV3Reskinnable,
				data.accountSettings.auditV3ReactStyleOverrides,
				A3($author$project$Components$DocumentsBrowser$view, tz, model.documentsViewer, _List_Nil),
				data.documentsBrowserData));
	});
var $author$project$Components$ActivityPage$ActivityItemListViewMsg = function (a) {
	return {$: 'ActivityItemListViewMsg', a: a};
};
var $author$project$Components$ActivityPage$ApplyFilters = {$: 'ApplyFilters'};
var $author$project$Components$ActivityPage$ChangePage = function (a) {
	return {$: 'ChangePage', a: a};
};
var $author$project$Components$ActivityPage$errorView = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-activity-stream__row activity-page')
			]),
		_List_fromArray(
			[
				$author$project$Forward$LoadingView$defaultErrorView(error)
			]));
};
var $author$project$Components$ActivityBrowser$ActivityItemListView$hasMoreItems = function (data_) {
	var _v0 = $author$project$Forward$Remote$toMaybe(data_);
	if (_v0.$ === 'Just') {
		var data = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Stream$hasMore(data.activityItems));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$ActivityPage$pageHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('small-10 column')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('View Activity')
				]))
		]));
var $author$project$Helpers$Pagination$pagination = $author$project$Helpers$Pagination$pagination_(false);
var $author$project$Components$ActivityBrowser$ActivityItemListView$bemClass = function (string) {
	return $elm$html$Html$Attributes$class('list-activity-stream__' + string);
};
var $author$project$Components$ActivityBrowser$ActivityItemListView$errorView = function (description) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('small-10 column')
			]),
		_List_fromArray(
			[
				$author$project$Forward$LoadingView$defaultErrorView(description)
			]));
};
var $author$project$Components$ActivityBrowser$ActivityItemListView$itemsHeader = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Components$ActivityBrowser$ActivityItemListView$bemClass('header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Components$ActivityBrowser$ActivityItemListView$bemClass('context')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Item')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Components$ActivityBrowser$ActivityItemListView$bemClass('title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Title')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Components$ActivityBrowser$ActivityItemListView$bemClass('user')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('User')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Components$ActivityBrowser$ActivityItemListView$bemClass('timestamp')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Time')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Components$ActivityBrowser$ActivityItemListView$bemClass('show-more')
					]),
				_List_Nil)
			]))
	]);
var $author$project$Components$ActivityBrowser$ActivityItemListView$loadingView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('small-10 column')
		]),
	_Utils_ap(
		$author$project$Components$ActivityBrowser$ActivityItemListView$itemsHeader,
		_List_fromArray(
			[
				$elm$html$Html$text('Loading ...')
			])));
var $author$project$Components$ActivityBrowser$ActivityItemListView$noActivityMessage = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Components$ActivityBrowser$ActivityItemListView$bemClass('context')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '20px'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No Activity Present')
					]))
			]))
	]);
var $author$project$Components$ActivityBrowser$ActivityItemListView$ActivityItemViewMsg = F2(
	function (a, b) {
		return {$: 'ActivityItemViewMsg', a: a, b: b};
	});
var $author$project$Components$ActivityBrowser$ActivityItemView$errorView = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-activity-stream__row')
			]),
		_List_fromArray(
			[
				$author$project$Forward$LoadingView$defaultErrorView(error)
			]));
};
var $author$project$Components$ActivityBrowser$ActivityItemView$loadingView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('list-activity-stream__row')
		]),
	_List_fromArray(
		[$author$project$Forward$LoadingView$defaultLoadingView]));
var $author$project$Components$ActivityBrowser$ActivityItemView$ToggleExpandedDetails = {$: 'ToggleExpandedDetails'};
var $author$project$Components$ActivityBrowser$DetailsView$ExpandedDetails = function (a) {
	return {$: 'ExpandedDetails', a: a};
};
var $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails = {$: 'NoExpandedDetails'};
var $author$project$Components$ActivityBrowser$DetailsView$RenderedByChildComponent = {$: 'RenderedByChildComponent'};
var $author$project$Components$ActivityBrowser$DetailsView$addressToString = function (address) {
	var beginning = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$apR(address),
			_List_fromArray(
				[
					function ($) {
					return $.addressLine1;
				},
					function ($) {
					return $.addressLine2;
				},
					function ($) {
					return $.city;
				}
				])));
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$cons,
			beginning,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$apR(address),
				_List_fromArray(
					[
						function ($) {
						return $.state;
					},
						function ($) {
						return $.postalCode;
					},
						function ($) {
						return $.country;
					}
					]))));
};
var $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic = function (html) {
	return $author$project$Components$ActivityBrowser$DetailsView$ExpandedDetails(
		function (_v0) {
			return html;
		});
};
var $author$project$Components$ActivityBrowser$DetailsView$expandedDetails = function (activityItem) {
	var _v0 = activityItem.details;
	switch (_v0.$) {
		case 'DocumentAdded':
			var details = _v0.a;
			var _v1 = details.original;
			if (_v1.$ === 'Just') {
				var original = _v1.a;
				return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
					A2(
						$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineHtml,
						_List_fromArray(
							[
								$elm$html$Html$text('Original Load')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Path$toString(
											$author$project$Path$load(original.load_state_id)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(original.load_id)
									]))
							])));
			} else {
				return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
			}
		case 'DocumentBatchIgnored':
			var details = _v0.a;
			var _v2 = details.reason;
			if (_v2.$ === 'Just') {
				var reason = _v2.a;
				return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('activity-item__detail-full-body'),
								A2($elm$html$Html$Attributes$style, 'font-size', '11px'),
								A2($elm$html$Html$Attributes$style, 'color', '#666')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reason: ' + reason)
							])));
			} else {
				return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
			}
		case 'DocumentAssigned':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'ContactAdded':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'DocumentRemoved':
			var details = _v0.a;
			var _v3 = details._new;
			if (_v3.$ === 'Just') {
				var original = _v3.a;
				return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
					A2(
						$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineHtml,
						_List_fromArray(
							[
								$elm$html$Html$text('New Load')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Path$toString(
											$author$project$Path$load(original.load_state_id)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(original.load_id)
									]))
							])));
			} else {
				return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
			}
		case 'DocumentSentToExternal':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$ExpandedDetails(
				function (_v4) {
					var accountSettings = _v4.accountSettings;
					var account = _v4.account;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
								'Document Type',
								A3($author$project$Domain$Helpers$documentTypeToString, account, accountSettings, details.documentType)),
								A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Load ID', details.loadId)
							]));
				});
		case 'ExceptionsClearedViaAPI':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'ExceptionDocumentsSent':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'ExceptionResolved':
			var details = _v0.a;
			var resolution = A2($elm$core$Maybe$withDefault, 'Not provided', details.resolution);
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-full-body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Resolution: ' + resolution)
						])));
		case 'FactoringAssignment':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Factoring Company', details.factoringCompanyName),
							A2(
							$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
							'Address',
							$author$project$Components$ActivityBrowser$DetailsView$addressToString(details.factoringCompanyAddress))
						])));
		case 'ForwardedEmail':
			var details = _v0.a;
			var _v5 = details.note;
			if (_v5.$ === 'Just') {
				var note = _v5.a;
				return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
					A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Note', note));
			} else {
				return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
			}
		case 'InvoiceDocumentsForwardedToTriumph':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'EmailMergeSource':
			var details = _v0.a;
			var linkUrl = function (currentUser) {
				return $author$project$Path$toString(
					A2($author$project$Path$emailMessage, details.targetEmailMessageId, currentUser.readOnlyFactorInvoices));
			};
			return $author$project$Components$ActivityBrowser$DetailsView$ExpandedDetails(
				function (_v6) {
					var currentUser = _v6.currentUser;
					return A2(
						$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineHtml,
						_List_fromArray(
							[
								$elm$html$Html$text('Merged into')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										linkUrl(currentUser))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Email')
									]))
							]));
				});
		case 'EmailMergeTarget':
			var details = _v0.a;
			var linkUrl = F2(
				function (currentUser, source) {
					return $author$project$Path$toString(
						A2($author$project$Path$emailMessage, source.emailMessageId, currentUser.readOnlyFactorInvoices));
				});
			var viewOriginalEmailLine = F2(
				function (currentUser, source) {
					return A2(
						$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineHtml,
						_List_fromArray(
							[
								$elm$html$Html$text('Original Email')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('\u0022'),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										A2(linkUrl, currentUser, source))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(source.subject)
									])),
								$elm$html$Html$text('\u0022 ' + source.sender)
							]));
				});
			return $author$project$Components$ActivityBrowser$DetailsView$ExpandedDetails(
				function (_v7) {
					var currentUser = _v7.currentUser;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (source) {
								return A2(viewOriginalEmailLine, currentUser, source);
							},
							details.sources));
				});
		case 'EmailIgnored':
			var details = _v0.a;
			var _v8 = details.reason;
			if (_v8.$ === 'Just') {
				var reason = _v8.a;
				return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('activity-item__detail-full-body'),
								A2($elm$html$Html$Attributes$style, 'font-size', '11px'),
								A2($elm$html$Html$Attributes$style, 'color', '#666')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reason: ' + reason)
							])));
			} else {
				return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
			}
		case 'EmailUnignored':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'EmailZeroPages':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'EmailCompleted':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'DuplicateEmailAutoCompleted':
			var details = _v0.a;
			var _v9 = details.duplicateEmailMessageId;
			if (_v9.$ === 'Just') {
				var id = _v9.a;
				return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('activity-item__detail-full-body')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Duplicate Email Message ID: ' + $elm$core$String$fromInt(id))
							])));
			} else {
				return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
			}
		case 'AutoCompletedWaitingExceptionsOnNewDocs':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'DuplicateDocumentBatchAutoCompleted':
			var details = _v0.a;
			var _v10 = details.duplicateDocumentBatchId;
			if (_v10.$ === 'Just') {
				var id = _v10.a;
				return $author$project$Components$ActivityBrowser$DetailsView$ExpandedDetails(
					function (_v11) {
						var currentUser = _v11.currentUser;
						var accountSettings = _v11.accountSettings;
						return A2(
							$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineHtml,
							_List_fromArray(
								[
									$elm$html$Html$text('Duplicate Document Batch ID')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Path$toString(
												A2(
													$author$project$Path$documentBatch,
													$author$project$Domain$DocumentBatchId$fromInt(id),
													{
														isReadonly: currentUser.readOnlyFactorInvoices,
														useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, accountSettings, currentUser)
													}))),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(id))
										]))
								]));
					});
			} else {
				return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
			}
		case 'DuplicateDocumentAutoHidden':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'DuplicateDocumentAutoMerged':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'InvoiceAbandoned':
			var details = _v0.a;
			var reason = A2($elm$core$Maybe$withDefault, 'Not Provided', details.reason);
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-full-body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Reason: ' + reason)
						])));
		case 'InvoiceApproved':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'CarrierPayableApproved':
			return $author$project$Components$ActivityBrowser$DetailsView$RenderedByChildComponent;
		case 'InvoiceDocumentsResendRequested':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'InvoiceCreatedByExternal':
			return $author$project$Components$ActivityBrowser$DetailsView$RenderedByChildComponent;
		case 'InvoiceMatched':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'InvoiceMarkedAsPurchased':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'InvoiceProcessed':
			return $author$project$Components$ActivityBrowser$DetailsView$RenderedByChildComponent;
		case 'InvoiceAutoProcessed':
			return $author$project$Components$ActivityBrowser$DetailsView$RenderedByChildComponent;
		case 'InvoiceRejected':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'InvoiceRemovedFromGroup':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'InvoiceUnapproved':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'InvoiceUnignored':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'SentToVerifyQueue':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'VerifyCompleted':
			var details = _v0.a;
			var _v12 = details.note;
			if (_v12.$ === 'Just') {
				var note = _v12.a;
				return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
					A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Note', note));
			} else {
				return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
			}
		case 'BypassedVerifyQueue':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'MarkedNotReadyForVerification':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'VerificationBatchStarted':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'VerifierChangedInvoiceAmount':
			var details = _v0.a;
			var oldAmount = $author$project$Money$toString(
				$author$project$Money$castFromString(details.oldAmount));
			var newAmount = $author$project$Money$toString(
				$author$project$Money$castFromString(details.newAmount));
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-full-body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Old amount: ' + oldAmount),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('New amount: ' + newAmount)
						])));
		case 'NoteAdded':
			var message = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-full-body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						])));
		case 'NoteSentToPaymentsNetwork':
			var message = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-full-body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						])));
		case 'Paused':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'PaymentAddressChanged':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'ReceivedInvoice':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'RuleDisabled':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'RuleEnabled':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'SavedAsIncomplete':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'StateChanged':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Reason:', details.reason));
		case 'SentToExternal':
			return $author$project$Components$ActivityBrowser$DetailsView$RenderedByChildComponent;
		case 'SentToCadence':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'TransmissionReceived':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'TransmissionFailed':
			var details = _v0.a;
			var failureMessage = A2($elm$core$Maybe$withDefault, 'Not provided', details.failure_message);
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-full-body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Error Message: ' + failureMessage)
						])));
		case 'TransmissionSucceeded':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'UpdatedFromExternal':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Updated Attribute', details.updatedAttribute),
							A2(
							$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
							'Previous Value',
							A2($elm$core$Maybe$withDefault, '', details.previousValue)),
							A2(
							$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
							'New Value',
							A2($elm$core$Maybe$withDefault, '', details.newValue))
						])));
		case 'VerifiedByCadence':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'ReadyForFmsPickup':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'AcknowledgedByFms':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'NonInvoiceLoadAssignment':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'ShipmentApproved':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'VIN', details.vin)
						])));
		case 'ShipmentRejected':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'VIN', details.vin),
							A2(
							$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
							'Reason',
							A2($elm$core$Maybe$withDefault, '', details.reason))
						])));
		case 'LoadDocumentsApproved':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'LoadDocumentsScraped':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'LoadDocumentsAssigned':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'LoadDocumentsSent':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'BuiltLoadSentToTMS':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'PodRequestSentToTextLocate':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'BuiltLoadConfirmed':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'LoadShipmentApproval':
			return $author$project$Components$ActivityBrowser$DetailsView$RenderedByChildComponent;
		case 'LoadShipmentUnapproval':
			return $author$project$Components$ActivityBrowser$DetailsView$RenderedByChildComponent;
		case 'ClientOrDebtorOnBolChanged':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'DebtorCorrected':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine('Previous debtor'),
								details.previousDebtorName),
								$elm$core$Maybe$Just(
								A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Corrected debtor', details.correctedDebtorName)),
								A2(
								$elm$core$Maybe$map,
								$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine('Note'),
								details.notes)
							]))));
		case 'InvoiceExceptionEmailSent':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'LtlDisputeAdded':
			var data = _v0.a;
			return $elm$core$List$isEmpty(data.disputeItems) ? $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails : $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$ActivityBrowser$Details$DetailLine$detailLineWithNoLabel,
						$author$project$Domain$ActivityItem$ltlDisputeAddedDisputeItemMessages(data.disputeItems))));
		case 'LtlInvoiceMovedToTMSQueue':
			var data = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Queue Name', data.queueName),
							A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Reason', data.reason)
						])));
		case 'LtlUpdatedEdiReceived':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'Hidden':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'LtlAcceptAdded':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				$author$project$Components$ActivityBrowser$Details$AcceptAddedDetailsView$view(details));
		case 'AddDocumentToLoadSuccess':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$ExpandedDetails(
				function (_v13) {
					var accountSettings = _v13.accountSettings;
					var account = _v13.account;
					return A3($author$project$Components$ActivityBrowser$Details$AddDocumentToLoadSuccessDetailsView$view, account, accountSettings, details);
				});
		case 'AddDocumentToLoadFailure':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'FlaggedForManualReview':
			var reason = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
							'Reason',
							$author$project$Domain$ActivityItem$flaggedForManualReviewReasonToString(reason))
						])));
		case 'LtlRerateRequested':
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Re-Rate Requested')
						])));
		case 'CarrierInvoiceRuleChangedViaTms':
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice rule resolved by TMS update')
						])));
		case 'LtlRerateCompleted':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'LtlRerateFailed':
			var details = _v0.a;
			return $author$project$Components$ActivityBrowser$DetailsView$renderExpandedStatic(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(details.errorMessage)
						])));
		case 'DocumentsMerged':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		case 'LineItemsAutoReplaced':
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
		default:
			return $author$project$Components$ActivityBrowser$DetailsView$NoExpandedDetails;
	}
};
var $author$project$Components$ActivityBrowser$DetailsView$hasExpandedDetails = function (activityItem) {
	var _v0 = $author$project$Components$ActivityBrowser$DetailsView$expandedDetails(activityItem);
	switch (_v0.$) {
		case 'ExpandedDetails':
			return true;
		case 'RenderedByChildComponent':
			return true;
		default:
			return false;
	}
};
var $author$project$Components$ActivityBrowser$ActivityItemView$expanderIcon = F4(
	function (_v0, _v1, activityItem, isExpanded) {
		var iconClass = isExpanded ? 'fi-minus' : 'fi-plus';
		var icon = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(iconClass),
					$elm$html$Html$Events$onClick($author$project$Components$ActivityBrowser$ActivityItemView$ToggleExpandedDetails)
				]),
			_List_Nil);
		return $author$project$Components$ActivityBrowser$DetailsView$hasExpandedDetails(activityItem) ? $elm$core$Maybe$Just(icon) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$ActivityBrowser$ActivityItemView$time = F2(
	function (tz, activityItem) {
		return $elm$html$Html$text(
			A2($author$project$Helpers$Date$toString, tz, activityItem.createdAt));
	});
var $author$project$Components$ActivityBrowser$ContextView$CarrierInvoiceContext = function (a) {
	return {$: 'CarrierInvoiceContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$DocumentBatchContext = function (a) {
	return {$: 'DocumentBatchContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$DocumentContext = function (a) {
	return {$: 'DocumentContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$DocumentGroupContext = function (a) {
	return {$: 'DocumentGroupContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$DocumentPageContext = function (a) {
	return {$: 'DocumentPageContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$EmailMessageContext = function (a) {
	return {$: 'EmailMessageContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$FactorInvoiceContext = function (a) {
	return {$: 'FactorInvoiceContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$LoadStateContext = function (a) {
	return {$: 'LoadStateContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$TmsCarrierContext = function (a) {
	return {$: 'TmsCarrierContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$TmsLoadShipmentContext = function (a) {
	return {$: 'TmsLoadShipmentContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$ToBeScrapedContext = function (a) {
	return {$: 'ToBeScrapedContext', a: a};
};
var $author$project$Components$ActivityBrowser$ContextView$childDisplayFromData = F2(
	function (activityItem, ownerData) {
		switch (ownerData.$) {
			case 'CarrierInvoiceData':
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$CarrierInvoiceContext(data);
			case 'DocumentBatchData':
				var data = ownerData.a;
				var _v1 = activityItem.details;
				if (_v1.$ === 'DocumentSentToExternal') {
					var details = _v1.a;
					return $author$project$Components$ActivityBrowser$ContextView$ToBeScrapedContext(details);
				} else {
					return $author$project$Components$ActivityBrowser$ContextView$DocumentBatchContext(data);
				}
			case 'DocumentData':
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$DocumentContext(data);
			case 'DocumentGroupData':
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$DocumentGroupContext(data);
			case 'EmailMessageData':
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$EmailMessageContext(data);
			case 'FactorInvoiceData':
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$FactorInvoiceContext(data);
			case 'TmsCarrierData':
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$TmsCarrierContext(data);
			case 'LoadStateData':
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$LoadStateContext(data);
			case 'DocumentPageData':
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$DocumentPageContext(data);
			default:
				var data = ownerData.a;
				return $author$project$Components$ActivityBrowser$ContextView$TmsLoadShipmentContext(data);
		}
	});
var $author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin = F2(
	function (top, bottom) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Ui$V3$Typography$smallBodySemiBoldClass]),
					top),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
						]),
					bottom)
				]));
	});
var $author$project$Components$ActivityBrowser$Context$CarrierInvoiceContextView$view = F2(
	function (v3Reskin, data) {
		var loadLink = $author$project$Path$toString(
			A2(
				$author$project$Path$addQueries,
				_List_fromArray(
					[
						_Utils_Tuple2('onDone', '/app/activity')
					]),
				$author$project$Path$load(data.contextData.loadStateId)));
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text('Load: '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(loadLink)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(data.contextData.loadId)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, 'Unknown Carrier', data.contextData.carrierName))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Load: '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(loadLink)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(data.contextData.loadId)
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__sub-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, 'Unknown Carrier', data.contextData.carrierName))
								]))
						]))
				]));
	});
var $author$project$Path$factorEmail = F3(
	function (accountSettings, email, pathContext) {
		if (accountSettings.useSubmissionWorkflow && email.hasFactorClientInvoiceSubmission) {
			return $author$project$Path$submission(email.id);
		} else {
			var _v0 = email.documentBatchId;
			if (_v0.$ === 'Just') {
				var id = _v0.a;
				return A2($author$project$Path$documentBatch, id, pathContext);
			} else {
				return A2($author$project$Path$emailMessage, email.id, pathContext.isReadonly);
			}
		}
	});
var $author$project$Helpers$EmailPath$emailPath = F5(
	function (account, settings, currentUser, email, doneTarget) {
		var isReadonly = function () {
			var _v0 = $author$project$Domain$Account$accountType(account);
			if (_v0.$ === 'BrokerAccount') {
				return false;
			} else {
				return currentUser.readOnlyFactorInvoices;
			}
		}();
		return $author$project$Path$toString(
			A2(
				$author$project$Path$addQueries,
				_List_fromArray(
					[
						_Utils_Tuple2('onDone', doneTarget)
					]),
				A3(
					$author$project$Path$factorEmail,
					settings,
					email,
					{
						isReadonly: isReadonly,
						useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, settings, currentUser)
					})));
	});
var $author$project$Components$ActivityBrowser$Context$DocumentBatchContextView$view = F3(
	function (v3Reskin, carrierTerm, data) {
		var suffix = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always('\u0022'),
				data.contextData.email));
		var subject = A2(
			$elm$core$Maybe$withDefault,
			'Documents',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.subject;
				},
				data.contextData.email));
		var readOnly = data.currentUser.readOnlyFactorInvoices;
		var prefix = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always('Email: \u0022'),
				data.contextData.email));
		var pathContext = {
			isReadonly: readOnly,
			useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, data.accountSettings, data.currentUser)
		};
		var hrefAttribute = function () {
			var _v0 = data.contextData.email;
			if (_v0.$ === 'Nothing') {
				return $elm$html$Html$Attributes$href(
					$author$project$Path$toString(
						A2($author$project$Path$documentBatch, data.contextData.documentBatchId, pathContext)));
			} else {
				var email = _v0.a;
				return $elm$html$Html$Attributes$href(
					A5($author$project$Helpers$EmailPath$emailPath, data.currentAccount, data.accountSettings, data.currentUser, email, '/app/activity'));
			}
		}();
		var carrier = A2($elm$core$Maybe$withDefault, 'Unknown ' + carrierTerm, data.contextData.carrierName);
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text(prefix),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[hrefAttribute]),
					_List_fromArray(
						[
							$elm$html$Html$text(subject)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(carrier)
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(prefix),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[hrefAttribute]),
									_List_fromArray(
										[
											$elm$html$Html$text(subject)
										])),
									$elm$html$Html$text(suffix)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__sub-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(carrier)
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Context$DocumentContextView$view = F2(
	function (v3Reskin, carrierTerm) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			A2($author$project$Components$ActivityBrowser$Context$DocumentBatchContextView$view, v3Reskin, carrierTerm));
	});
var $author$project$Components$ActivityBrowser$Context$DocumentGroupContextView$view = F3(
	function (v3Reskin, documentGroup, useFactorInvoiceWorkflowPage) {
		var documentGroupLink = $author$project$Path$toString(
			A3(
				$author$project$Path$documentGroup,
				documentGroup.documentBatchId,
				documentGroup.id,
				{isReadonly: false, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage}));
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text('Document Group: '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(documentGroupLink)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Domain$DocumentGroupId$toInt(documentGroup.id)))
						]))
				]),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Document Group: '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(documentGroupLink)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Domain$DocumentGroupId$toInt(documentGroup.id)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Context$DocumentPageContextView$loadedView = F6(
	function (v3Reskin, documentBatchId, documentGroupId, emailMessageSubject, currentUser, accountSettings) {
		var useFactorInvoiceWorkflowPage = A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, accountSettings, currentUser);
		var isReadonly = currentUser.readOnlyFactorInvoices;
		var pathContext = {isReadonly: isReadonly, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage};
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text('Email: \u0022'),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Path$toString(
								A3($author$project$Path$documentGroup, documentBatchId, documentGroupId, pathContext)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(emailMessageSubject)
						])),
					$elm$html$Html$text('\u0022')
				]),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Email: \u0022'),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Path$toString(
												A3($author$project$Path$documentGroup, documentBatchId, documentGroupId, pathContext)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(emailMessageSubject)
										])),
									$elm$html$Html$text('\u0022')
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Context$DocumentPageContextView$view = F2(
	function (v3Reskin, _v0) {
		var accountSettings = _v0.accountSettings;
		var currentUser = _v0.currentUser;
		var documentPage = _v0.documentPage;
		var _v1 = _Utils_Tuple3(documentPage.documentBatchId, documentPage.documentGroupId, documentPage.emailMessageSubject);
		if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
			if (_v1.c.$ === 'Just') {
				var documentBatchId = _v1.a.a;
				var documentGroupId = _v1.b.a;
				var emailMessageSubject = _v1.c.a;
				return A6($author$project$Components$ActivityBrowser$Context$DocumentPageContextView$loadedView, v3Reskin, documentBatchId, documentGroupId, emailMessageSubject, currentUser, accountSettings);
			} else {
				var documentBatchId = _v1.a.a;
				var documentGroupId = _v1.b.a;
				var _v2 = _v1.c;
				return A6($author$project$Components$ActivityBrowser$Context$DocumentPageContextView$loadedView, v3Reskin, documentBatchId, documentGroupId, 'No Email Subject Found', currentUser, accountSettings);
			}
		} else {
			return v3Reskin ? A2(
				$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$append,
							'Document Page Id: ',
							$elm$core$String$fromInt(
								$author$project$Domain$DocumentPageId$toInt(documentPage.id))))
					]),
				_List_Nil) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-activity-stream__main-context')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$String$append,
											'Document Page Id: ',
											$elm$core$String$fromInt(
												$author$project$Domain$DocumentPageId$toInt(documentPage.id))))
									]))
							]))
					]));
		}
	});
var $author$project$Components$ActivityBrowser$Context$EmailMessageContextView$view = F3(
	function (v3Reskin, carrierTerm, data) {
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text('Email: \u0022'),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							A5($author$project$Helpers$EmailPath$emailPath, data.currentAccount, data.accountSettings, data.currentUser, data.emailMessage, '/app/activity'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(data.emailMessage.subject)
						])),
					$elm$html$Html$text('\u0022')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'Unknown ' + carrierTerm,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							data.tmsCarrier)))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Email: \u0022'),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											A5($author$project$Helpers$EmailPath$emailPath, data.currentAccount, data.accountSettings, data.currentUser, data.emailMessage, '/app/activity'))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(data.emailMessage.subject)
										])),
									$elm$html$Html$text('\u0022')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__sub-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Unknown ' + carrierTerm,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.name;
											},
											data.tmsCarrier)))
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$invoicePath = function (data) {
	var referrer = _List_fromArray(
		[
			_Utils_Tuple2('onDone', '/app/activity')
		]);
	var path = function () {
		var context = {
			isReadonly: data.currentUser.readOnlyFactorInvoices,
			useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, data.accountSettings, data.currentUser)
		};
		if (data.accountSettings.useSubmissionWorkflow) {
			var _v0 = data.emailMessageId;
			if (_v0.$ === 'Nothing') {
				return A2($author$project$Path$factorInvoice, data.factorInvoiceDetails.factorInvoice.id, context);
			} else {
				var id = _v0.a;
				return A2($author$project$Path$submissionInvoice, id, data.factorInvoiceDetails.factorInvoice.id);
			}
		} else {
			return A2($author$project$Path$factorInvoice, data.factorInvoiceDetails.factorInvoice.id, context);
		}
	}();
	return $author$project$Path$toString(
		A2($author$project$Path$addQueries, referrer, path));
};
var $author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$view = F2(
	function (v3Reskin, data) {
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text('Invoice: '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$invoicePath(data))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Incomplete',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.name;
									},
									data.factorInvoiceDetails.factorBroker)) + (' ' + A2($elm$core$Maybe$withDefault, '', data.factorInvoiceDetails.factorInvoice.loadId)))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'Unknown ' + $author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							data.factorInvoiceDetails.tmsCarrier)))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice: '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$invoicePath(data))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Incomplete',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.name;
													},
													data.factorInvoiceDetails.factorBroker)) + (' ' + A2($elm$core$Maybe$withDefault, '', data.factorInvoiceDetails.factorInvoice.loadId)))
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__sub-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Unknown ' + $author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount),
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.name;
											},
											data.factorInvoiceDetails.tmsCarrier)))
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Context$LoadStateContextView$view = F2(
	function (v3Reskin, data) {
		var loadLink = $author$project$Path$toString(
			A2(
				$author$project$Path$addQueries,
				_List_fromArray(
					[
						_Utils_Tuple2('onDone', '/app/activity')
					]),
				$author$project$Path$load(data.loadStateId)));
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text('Load: '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(loadLink)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(data.loadId)
						]))
				]),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Load: '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(loadLink)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(data.loadId)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Context$TmsCarrierContextView$view = F3(
	function (v3Reskin, carrierTerm, data) {
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text(carrierTerm + (': ' + data.tmsCarrier.name))
				]),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(carrierTerm + (': ' + data.tmsCarrier.name))
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Context$TmsLoadShipmentContextView$view = F2(
	function (v3Reskin, data) {
		var loadLink = $author$project$Path$toString(
			A2(
				$author$project$Path$addQueries,
				_List_fromArray(
					[
						_Utils_Tuple2('onDone', '/app/activity')
					]),
				$author$project$Path$load(data.loadState.id)));
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text('Load: '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(loadLink)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(data.tmsLoad.loadId)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '', data.tmsLoadShipment.customerName))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Load: '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(loadLink)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(data.tmsLoad.loadId)
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__sub-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', data.tmsLoadShipment.customerName))
								]))
						]))
				]));
	});
var $author$project$Path$searchToBeScrapedLoads = function (string) {
	return A2(
		$author$project$Path$Path,
		_List_fromArray(
			['app', 'to_be_scraped_loads']),
		_List_fromArray(
			[
				_Utils_Tuple2('search_term', string)
			]));
};
var $author$project$Components$ActivityBrowser$Context$ToBeScrapedContextView$view = F2(
	function (v3Reskin, model) {
		return v3Reskin ? A2(
			$author$project$Components$ActivityBrowser$Context$ViewHelper$viewV3Reskin,
			_List_fromArray(
				[
					$elm$html$Html$text('Load: '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Path$toString(
								$author$project$Path$searchToBeScrapedLoads(model.loadId)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(model.loadId)
						]))
				]),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-activity-stream__main-context')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Load: '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Path$toString(
												$author$project$Path$searchToBeScrapedLoads(model.loadId)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.loadId)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$ContextView$view = F2(
	function (v3Reskin, data) {
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(data.account));
		var _v0 = A2($author$project$Components$ActivityBrowser$ContextView$childDisplayFromData, data.activityItem, data.ownerData);
		switch (_v0.$) {
			case 'CarrierInvoiceContext':
				var data_ = _v0.a;
				return A2($author$project$Components$ActivityBrowser$Context$CarrierInvoiceContextView$view, v3Reskin, data_);
			case 'DocumentBatchContext':
				var data_ = _v0.a;
				return A3($author$project$Components$ActivityBrowser$Context$DocumentBatchContextView$view, v3Reskin, carrierTerm, data_);
			case 'DocumentContext':
				var data_ = _v0.a;
				return A3($author$project$Components$ActivityBrowser$Context$DocumentContextView$view, v3Reskin, carrierTerm, data_);
			case 'DocumentGroupContext':
				var data_ = _v0.a;
				return A3(
					$author$project$Components$ActivityBrowser$Context$DocumentGroupContextView$view,
					v3Reskin,
					data_,
					A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, data.accountSettings, data.currentUser));
			case 'EmailMessageContext':
				var data_ = _v0.a;
				return A3($author$project$Components$ActivityBrowser$Context$EmailMessageContextView$view, v3Reskin, carrierTerm, data_);
			case 'FactorInvoiceContext':
				var data_ = _v0.a;
				return A2($author$project$Components$ActivityBrowser$Context$FactorInvoiceContextView$view, v3Reskin, data_);
			case 'TmsCarrierContext':
				var data_ = _v0.a;
				return A3($author$project$Components$ActivityBrowser$Context$TmsCarrierContextView$view, v3Reskin, carrierTerm, data_);
			case 'ToBeScrapedContext':
				var details = _v0.a;
				return A2(
					$author$project$Components$ActivityBrowser$Context$ToBeScrapedContextView$view,
					v3Reskin,
					{loadId: details.loadId});
			case 'LoadStateContext':
				var data_ = _v0.a;
				return A2($author$project$Components$ActivityBrowser$Context$LoadStateContextView$view, v3Reskin, data_);
			case 'DocumentPageContext':
				var data_ = _v0.a;
				return A2($author$project$Components$ActivityBrowser$Context$DocumentPageContextView$view, v3Reskin, data_);
			default:
				var data_ = _v0.a;
				return A2($author$project$Components$ActivityBrowser$Context$TmsLoadShipmentContextView$view, v3Reskin, data_);
		}
	});
var $author$project$Components$ActivityBrowser$TitleView$ruleDescriptionWithPrefix = F2(
	function (prefix, details) {
		return _Utils_ap(prefix, details.rule.displayText);
	});
var $author$project$Components$ActivityBrowser$TitleView$title = F4(
	function (tz, account, accountSettings, activityItem) {
		var _v0 = activityItem.details;
		switch (_v0.$) {
			case 'DocumentAdded':
				var details = _v0.a;
				var defaultName = A3($author$project$Domain$Helpers$documentTypeToString, account, accountSettings, details.documentType);
				return A2($elm$core$Maybe$withDefault, defaultName, details.documentTypeName) + ' added to invoice';
			case 'DocumentAssigned':
				return 'Document Assigned';
			case 'DocumentRemoved':
				var details = _v0.a;
				var defaultName = A3($author$project$Domain$Helpers$documentTypeToString, account, accountSettings, details.documentType);
				return A2($elm$core$Maybe$withDefault, defaultName, details.documentTypeName) + ' removed from invoice';
			case 'DocumentSentToExternal':
				return 'Document Sent';
			case 'ContactAdded':
				var details = _v0.a;
				var contactNameStr = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (contactName) {
							return contactName + ', ';
						},
						details.contactName));
				return 'New contact (' + (contactNameStr + (details.contactEmail + ') added'));
			case 'EmailMergeSource':
				return 'Completed due to Email Merge';
			case 'EmailMergeTarget':
				var details = _v0.a;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'Merged from',
							$elm$core$String$fromInt(
							$elm$core$List$length(details.sources)),
							'emails'
						]));
			case 'EmailIgnored':
				return 'Email Ignored';
			case 'EmailUnignored':
				return 'Email Unignored';
			case 'EmailZeroPages':
				return 'Auto-ignored due to no Documents';
			case 'EmailCompleted':
				return 'Email Completed';
			case 'DuplicateEmailAutoCompleted':
				return 'Duplicate Email Auto-Completed';
			case 'AutoCompletedWaitingExceptionsOnNewDocs':
				return 'Invoice moved from Waiting to Ready to Audit due to new documents';
			case 'DuplicateDocumentBatchAutoCompleted':
				return 'Duplicate Document Batch Auto-Completed';
			case 'DuplicateDocumentAutoHidden':
				return 'Duplicate Document Auto-Hidden';
			case 'DuplicateDocumentAutoMerged':
				return 'Duplicate Document Auto-Merged';
			case 'ExceptionResolved':
				var details = _v0.a;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'Exception:',
							A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Helpers$String$quote, details.message)),
							'resolved'
						]));
			case 'ExceptionsClearedViaAPI':
				return 'Exceptions Cleared Via API';
			case 'ExceptionDocumentsSent':
				return 'Exception Documents Sent';
			case 'FactoringAssignment':
				return 'Factoring Assignment';
			case 'ForwardedEmail':
				var details = _v0.a;
				return 'Email was forwarded to ' + A3($author$project$Helpers$String$toSentence, 'nobody', 'and', details.recipients);
			case 'InvoiceDocumentsForwardedToTriumph':
				return 'Invoice Documents Forwarded To Triumph';
			case 'InvoiceAbandoned':
				return 'Invoice Abandoned';
			case 'InvoiceApproved':
				return 'Invoice Approved';
			case 'CarrierPayableApproved':
				return 'Carrier Payable Approved';
			case 'InvoiceDocumentsResendRequested':
				return 'Invoice Documents Resend Requested';
			case 'InvoiceCreatedByExternal':
				var details = _v0.a;
				return 'Invoice Created From ' + $author$project$Helpers$String$capitalize(details.sourceSystem);
			case 'InvoiceProcessed':
				return 'Invoice Processed';
			case 'InvoiceAutoProcessed':
				return 'Invoice Auto Processed';
			case 'InvoiceRemovedFromGroup':
				return 'Invoice Removed From Group';
			case 'InvoiceUnapproved':
				return 'Invoice Un-Approved';
			case 'InvoiceUnignored':
				return 'Invoice Revived';
			case 'NoteAdded':
				return 'Note Added';
			case 'NoteSentToPaymentsNetwork':
				return 'Note Sent To Payments Network';
			case 'Paused':
				var date = _v0.a;
				return 'Load paused until ' + A2($author$project$Helpers$Date$dateString, tz, date);
			case 'ReceivedInvoice':
				return 'Indexed documents sent to TMS';
			case 'RuleDisabled':
				var details = _v0.a;
				return A2($author$project$Components$ActivityBrowser$TitleView$ruleDescriptionWithPrefix, 'Rule Disabled: ', details);
			case 'RuleEnabled':
				var details = _v0.a;
				return A2($author$project$Components$ActivityBrowser$TitleView$ruleDescriptionWithPrefix, 'Rule Enabled: ', details);
			case 'SentToExternal':
				return 'Invoice Successfully Sent';
			case 'StateChanged':
				var details = _v0.a;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						['Load moved to', details.newState, 'from', details.originalState]));
			case 'TransmissionReceived':
				return 'Invoice transmission received';
			case 'TransmissionFailed':
				return 'Invoice Rejected by TMS';
			case 'TransmissionSucceeded':
				return 'Invoice transmission succeeded';
			case 'PaymentAddressChanged':
				return 'Payment Address Changed';
			case 'DocumentBatchIgnored':
				return 'Documents marked as ignored';
			case 'SentToCadence':
				return 'Invoice Sent To FactorSoft';
			case 'ReadyForFmsPickup':
				return 'Invoice Ready for FMS Pickup';
			case 'AcknowledgedByFms':
				return 'Invoice Acknowledged by FMS';
			case 'NonInvoiceLoadAssignment':
				return 'Non-Invoice Load Assignment';
			case 'InvoiceMatched':
				return 'Documents matched to incomplete invoice';
			case 'InvoiceMarkedAsPurchased':
				return 'Invoice Marked as Purchased';
			case 'InvoiceRejected':
				return 'Processed Invoice Rejected';
			case 'SentToVerifyQueue':
				return 'Invoice Sent To Verify Queue';
			case 'VerifyCompleted':
				var details = _v0.a;
				return 'Invoice Verification Completed: ' + $author$project$Helpers$String$capitalize(details.status);
			case 'BypassedVerifyQueue':
				return 'Invoice Bypassed Verify Queue';
			case 'VerifierChangedInvoiceAmount':
				return 'Changed Invoice Amount During Verification';
			case 'MarkedNotReadyForVerification':
				return 'Marked not ready for Verification';
			case 'VerificationBatchStarted':
				return 'Verification Batch Started';
			case 'SavedAsIncomplete':
				var word = account.factorAccount ? 'Incomplete' : 'Exception';
				return 'Saved As ' + word;
			case 'UpdatedFromExternal':
				return 'Invoice Updated From TMS';
			case 'VerifiedByCadence':
				return 'Invoice Successfully Received By FactorSoft';
			case 'ShipmentApproved':
				return 'Shipment Approved';
			case 'ShipmentRejected':
				return 'Shipment Rejected';
			case 'LoadDocumentsApproved':
				return 'Load Documents Approved';
			case 'LoadDocumentsScraped':
				return 'Load Documents Retrieved';
			case 'LoadDocumentsAssigned':
				return 'Load Documents Assigned';
			case 'LoadDocumentsSent':
				return 'Load Documents Sent to TMS';
			case 'BuiltLoadSentToTMS':
				return 'Built Load Sent to TMS';
			case 'PodRequestSentToTextLocate':
				return 'POD Request Sent to Driver via TextLocate';
			case 'BuiltLoadConfirmed':
				return 'Built Load Confirmed by TMS';
			case 'LoadShipmentApproval':
				return 'Shipment Approved';
			case 'LoadShipmentUnapproval':
				return 'Shipment Un-Approved';
			case 'ClientOrDebtorOnBolChanged':
				var details = _v0.a;
				return $elm$core$String$concat(
					_List_fromArray(
						['Client or Debtor on BOL value changed to ', details.to]));
			case 'DebtorCorrected':
				var details = _v0.a;
				var _v1 = details.previousDebtorName;
				if (_v1.$ === 'Just') {
					var previousDebtorName = _v1.a;
					return $elm$core$String$concat(
						_List_fromArray(
							['Debtor corrected from ', previousDebtorName, ' to ', details.correctedDebtorName]));
				} else {
					return $elm$core$String$concat(
						_List_fromArray(
							['Debtor corrected to ', details.correctedDebtorName]));
				}
			case 'InvoiceExceptionEmailSent':
				return 'Email Sent on Exception';
			case 'LtlDisputeAdded':
				return 'Invoice reconciliation action taken';
			case 'LtlRerateRequested':
				return 'Re-Rate Requested';
			case 'Hidden':
				var details = _v0.a;
				return details.message;
			case 'LtlAcceptAdded':
				var acceptItems = _v0.a.acceptItems;
				var descriptions = $elm_community$string_extra$String$Extra$toSentenceOxford(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.description;
						},
						acceptItems));
				var suffix = ' changed for ' + (descriptions + ' and re-rate initiated');
				var changes = $elm_community$string_extra$String$Extra$toSentenceOxford(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$List$any,
								function (item) {
									return $elm_community$maybe_extra$Maybe$Extra$isJust(item.weightChange);
								},
								acceptItems) ? $elm$core$Maybe$Just('weight') : $elm$core$Maybe$Nothing,
								A2(
								$elm$core$List$any,
								function (item) {
									return $elm_community$maybe_extra$Maybe$Extra$isJust(item.classChange);
								},
								acceptItems) ? $elm$core$Maybe$Just('class') : $elm$core$Maybe$Nothing,
								A2(
								$elm$core$List$any,
								function (item) {
									return $elm_community$maybe_extra$Maybe$Extra$isJust(item.amountChange);
								},
								acceptItems) ? $elm$core$Maybe$Just('amount') : $elm$core$Maybe$Nothing
							])));
				return _Utils_ap(changes, suffix);
			case 'LtlInvoiceMovedToTMSQueue':
				return 'Invoice moved to TMS';
			case 'LtlUpdatedEdiReceived':
				return 'An updated EDI was received';
			case 'AddDocumentToLoadSuccess':
				return 'Load documents uploaded';
			case 'AddDocumentToLoadFailure':
				return 'Documents failed to upload';
			case 'FlaggedForManualReview':
				return 'Invoice Flagged for Manual Review';
			case 'CarrierInvoiceRuleChangedViaTms':
				return 'Invoice rule resolved by TMS update';
			case 'LtlRerateCompleted':
				return 'Re-Rate Completed';
			case 'LtlRerateFailed':
				return 'Re-Rate Failed';
			case 'DocumentsMerged':
				return 'Documents Merged';
			case 'LineItemsAutoReplaced':
				return 'Line Items Auto-Replaced';
			default:
				return 'Indexing Complete';
		}
	});
var $author$project$Components$ActivityBrowser$TitleView$view = F4(
	function (tz, account, accountSettings, activityItem) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A4($author$project$Components$ActivityBrowser$TitleView$title, tz, account, accountSettings, activityItem))
				]));
	});
var $author$project$Components$ActivityBrowser$ActivityItemView$DetailsViewMsg = function (a) {
	return {$: 'DetailsViewMsg', a: a};
};
var $author$project$Components$ActivityBrowser$DetailsView$TransmissionDetailsMsg = function (a) {
	return {$: 'TransmissionDetailsMsg', a: a};
};
var $author$project$Components$ActivityBrowser$Details$CarrierInvoiceProcessedDetailsView$carrierNameAndInfo = function (tmsCarrier) {
	return A2(
		$elm$core$String$join,
		' - ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$apR(tmsCarrier),
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.name;
					},
					$elm$core$Maybe$Just),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mcNumber;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('MC# '))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ein;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('EIN '))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.scac;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('SCAC ')))
				])));
};
var $author$project$Components$ActivityBrowser$Details$CarrierInvoiceProcessedDetailsView$remitTo = function (address) {
	var beginning = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$apR(address),
			_List_fromArray(
				[
					function ($) {
					return $.addressLine1;
				},
					function ($) {
					return $.addressLine2;
				},
					function ($) {
					return $.city;
				}
				])));
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$cons,
			beginning,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$apR(address),
				_List_fromArray(
					[
						function ($) {
						return $.state;
					},
						function ($) {
						return $.postalCode;
					},
						function ($) {
						return $.country;
					}
					]))));
};
var $author$project$Components$ActivityBrowser$Details$CarrierInvoiceProcessedDetailsView$view = F2(
	function (details, tmsCarrier) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Invoice Number', details.invoiceNumber),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Amount',
					$author$project$Money$toString(
						$author$project$Money$castFromString(details.amountToPay))),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Invoice Date',
					$author$project$Helpers$Date$dateStringFromDate(details.invoiceDate)),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Invoice Date',
					$author$project$Helpers$Date$dateStringFromDate(details.dateToPay)),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$BrokerAccount),
					$author$project$Components$ActivityBrowser$Details$CarrierInvoiceProcessedDetailsView$carrierNameAndInfo(tmsCarrier)),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Remit To',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Components$ActivityBrowser$Details$CarrierInvoiceProcessedDetailsView$remitTo, details.remitToAddress)))
				]));
	});
var $author$project$Components$ActivityBrowser$Details$CarrierPayableApprovedDetailsView$carrierNameAndInfo = function (tmsCarrier) {
	return A2(
		$elm$core$String$join,
		' - ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$apR(tmsCarrier),
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.name;
					},
					$elm$core$Maybe$Just),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mcNumber;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('MC# '))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ein;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('EIN '))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.scac;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('SCAC ')))
				])));
};
var $author$project$Components$ActivityBrowser$Details$CarrierPayableApprovedDetailsView$remitTo = function (address) {
	var beginning = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$apR(address),
			_List_fromArray(
				[
					function ($) {
					return $.addressLine1;
				},
					function ($) {
					return $.addressLine2;
				},
					function ($) {
					return $.city;
				}
				])));
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$cons,
			beginning,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$apR(address),
				_List_fromArray(
					[
						function ($) {
						return $.state;
					},
						function ($) {
						return $.postalCode;
					},
						function ($) {
						return $.country;
					}
					]))));
};
var $author$project$Components$ActivityBrowser$Details$CarrierPayableApprovedDetailsView$view = F2(
	function (details, tmsCarrier) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Invoice Number', details.invoiceNumber),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Amount',
					$author$project$Money$toString(
						$author$project$Money$castFromString(details.amountToPay))),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Invoice Date',
					$author$project$Helpers$Date$dateStringFromDate(details.invoiceDate)),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Date to Pay',
					$author$project$Helpers$Date$dateStringFromDate(details.dateToPay)),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$BrokerAccount),
					$author$project$Components$ActivityBrowser$Details$CarrierPayableApprovedDetailsView$carrierNameAndInfo(tmsCarrier)),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Remit To',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Components$ActivityBrowser$Details$CarrierPayableApprovedDetailsView$remitTo, details.remitToAddress)))
				]));
	});
var $author$project$Components$ActivityBrowser$Details$InvoiceCreatedByExternalDetailsView$carrierNameAndInfo = function (tmsCarrier) {
	return A2(
		$elm$core$String$join,
		' - ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$apR(tmsCarrier),
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.name;
					},
					$elm$core$Maybe$Just),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mcNumber;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('MC# '))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ein;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('EIN '))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.scac;
					},
					$elm$core$Maybe$map(
						$elm$core$String$append('SCAC ')))
				])));
};
var $author$project$Components$ActivityBrowser$Details$InvoiceCreatedByExternalDetailsView$view = F3(
	function (carrierTerm, details, tmsCarrier) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Invoice Number', details.invoiceNumber),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Amount',
					$author$project$Money$toString(
						$author$project$Money$castFromString(details.amountToPay))),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Invoice Date',
					$author$project$Helpers$Date$dateStringFromDate(details.invoiceDate)),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					'Invoice Date',
					$author$project$Helpers$Date$dateStringFromDate(details.dateToPay)),
					A2(
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine,
					carrierTerm,
					$author$project$Components$ActivityBrowser$Details$InvoiceCreatedByExternalDetailsView$carrierNameAndInfo(tmsCarrier))
				]));
	});
var $author$project$Components$ActivityBrowser$Details$TransmissionDetailsView$ToggleVisibility = {$: 'ToggleVisibility'};
var $elm$html$Html$code = _VirtualDom_node('code');
var $author$project$Components$ActivityBrowser$Details$DetailLine$detailLineCode = F3(
	function (label, value, msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('activity-item__detail-line')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activity-item__detail-line-code value')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$code,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(msg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(value)
								]))
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$Details$TransmissionDetailsView$view = F2(
	function (config, model) {
		var maybeRecipient = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$ActivityBrowser$Details$DetailLine$detailLine('Recipient'),
					$elm$core$List$singleton),
				config.recipient));
		var code = model.isDataVisible ? config.data : 'Click to show.';
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				maybeRecipient,
				_List_fromArray(
					[
						A2($author$project$Components$ActivityBrowser$Details$DetailLine$detailLine, 'Response', config.response),
						A3($author$project$Components$ActivityBrowser$Details$DetailLine$detailLineCode, 'Data', code, $author$project$Components$ActivityBrowser$Details$TransmissionDetailsView$ToggleVisibility)
					])));
	});
var $author$project$Components$ActivityBrowser$DetailsView$view = F3(
	function (_v0, data, model) {
		var _v1 = data.nestedDetails;
		switch (_v1.$) {
			case 'NoNestedDetails':
				var _v2 = $author$project$Components$ActivityBrowser$DetailsView$expandedDetails(data.activityItem);
				switch (_v2.$) {
					case 'ExpandedDetails':
						var render = _v2.a;
						return A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							render(
								{account: data.account, accountSettings: data.accountSettings, currentUser: data.currentUser}));
					case 'RenderedByChildComponent':
						return $elm$html$Html$text('');
					default:
						return $elm$html$Html$text('');
				}
			case 'FactorInvoiceProcessedData':
				var details = _v1.a;
				var tmsCarrier = _v1.b;
				return A2(
					$author$project$Components$ActivityBrowser$Details$FactorInvoiceProcessedDetailsView$view,
					details,
					$elm$core$Maybe$Just(tmsCarrier.name));
			case 'CarrierInvoiceProcessedData':
				var details = _v1.a;
				var tmsCarrier = _v1.b;
				return A2($author$project$Components$ActivityBrowser$Details$CarrierInvoiceProcessedDetailsView$view, details, tmsCarrier);
			case 'CarrierPayableApprovedData':
				var details = _v1.a;
				var tmsCarrier = _v1.b;
				return A2($author$project$Components$ActivityBrowser$Details$CarrierPayableApprovedDetailsView$view, details, tmsCarrier);
			case 'InvoiceCreatedByExternalData':
				var details = _v1.a;
				var tmsCarrier = _v1.b;
				var carrierTerm = $author$project$Domain$Account$carrierTerm(
					$author$project$Domain$Account$accountType(data.account));
				return A3($author$project$Components$ActivityBrowser$Details$InvoiceCreatedByExternalDetailsView$view, carrierTerm, details, tmsCarrier);
			case 'TransmissionDetailsData':
				var details = _v1.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$ActivityBrowser$DetailsView$TransmissionDetailsMsg,
					A2(
						$author$project$Components$ActivityBrowser$Details$TransmissionDetailsView$view,
						{data: details.payload, recipient: details.url, response: details.response},
						model.transmissionDetailsState));
			case 'LoadShipmentApprovalData':
				var details = _v1.a;
				return $author$project$Components$ActivityBrowser$Details$LoadShipmentApprovalDetailsView$view(details);
			default:
				var details = _v1.a;
				return $author$project$Components$ActivityBrowser$Details$LoadShipmentUnapprovalDetailsView$view(details);
		}
	});
var $author$project$Components$ActivityBrowser$ActivityItemView$viewDetails = F3(
	function (v3Reskin, data, model) {
		return model.isExpanded ? A2(
			$elm$html$Html$map,
			$author$project$Components$ActivityBrowser$ActivityItemView$DetailsViewMsg,
			A3($author$project$Components$ActivityBrowser$DetailsView$view, v3Reskin, data.detailsView, model.detailsView)) : $elm$html$Html$text('');
	});
var $author$project$Components$ActivityBrowser$ActivityItemView$view = F3(
	function (tz, data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-activity-stream__row activity-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-activity-stream__show-more')
						]),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A4($author$project$Components$ActivityBrowser$ActivityItemView$expanderIcon, data.currentAccount, data.accountSettings, data.activityItem, model.isExpanded))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-activity-stream__context')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$ActivityBrowser$ContextView$view, false, data.contextView)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-activity-stream__title')
						]),
					_List_fromArray(
						[
							A4($author$project$Components$ActivityBrowser$TitleView$view, tz, data.currentAccount, data.accountSettings, data.activityItem)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-activity-stream__user')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Domain$ActivityItem$userNameToString(data.activityItem))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-activity-stream__timestamp')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$ActivityBrowser$ActivityItemView$time, tz, data.activityItem)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$ActivityBrowser$ActivityItemView$viewDetails, false, data, model)
						]))
				]));
	});
var $author$project$Components$ActivityBrowser$ActivityItemListView$viewItem = F3(
	function (tz, model, childData) {
		switch (childData.$) {
			case 'Loaded':
				var data_ = childData.a;
				var activityItemId = data_.activityItem.id;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$ActivityBrowser$ActivityItemListView$ActivityItemViewMsg(activityItemId),
					A3(
						$author$project$Components$ActivityBrowser$ActivityItemView$view,
						tz,
						data_,
						A2($author$project$Components$ActivityBrowser$ActivityItemListView$activityItemViewModel, activityItemId, model)));
			case 'Loading':
				return $author$project$Components$ActivityBrowser$ActivityItemView$loadingView;
			default:
				var error = childData.a;
				return $author$project$Components$ActivityBrowser$ActivityItemView$errorView(error);
		}
	});
var $author$project$Components$ActivityBrowser$ActivityItemListView$view = F3(
	function (tz, data_, model) {
		switch (data_.$) {
			case 'Loaded':
				var data = data_.a;
				return ($elm$core$List$length(
					$author$project$Stream$value(data.activityItems)) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Components$ActivityBrowser$ActivityItemListView$bemClass('container')
						]),
					_Utils_ap(
						$author$project$Components$ActivityBrowser$ActivityItemListView$itemsHeader,
						A2(
							$elm$core$List$map,
							A2($author$project$Components$ActivityBrowser$ActivityItemListView$viewItem, tz, model),
							$author$project$Stream$value(data.activityItems)))) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_Utils_ap($author$project$Components$ActivityBrowser$ActivityItemListView$itemsHeader, $author$project$Components$ActivityBrowser$ActivityItemListView$noActivityMessage));
			case 'Loading':
				return $author$project$Components$ActivityBrowser$ActivityItemListView$loadingView;
			default:
				var error = data_.a;
				return $author$project$Components$ActivityBrowser$ActivityItemListView$errorView(error);
		}
	});
var $author$project$Components$ActivityBrowser$FiltersView$SelectActivityType = function (a) {
	return {$: 'SelectActivityType', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$SelectDate = function (a) {
	return {$: 'SelectDate', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$SelectEndDate = function (a) {
	return {$: 'SelectEndDate', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$SelectUserId = function (a) {
	return {$: 'SelectUserId', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$activityTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	function (x) {
		return $elm$core$String$isEmpty(x) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(x);
	},
	$elm$html$Html$Events$targetValue);
var $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly = {$: 'BrokerOnly'};
var $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly = {$: 'FactorOnly'};
var $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Hidden = {$: 'Hidden'};
var $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared = {$: 'Shared'};
var $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$activityTypeInfo = function (activityType) {
	switch (activityType.$) {
		case 'ActivityItemAccountsPayableActivityTypeInvoiceMatched':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Invoice Matched');
		case 'ActivityItemAccountsPayableActivityTypeRemovedFromGroup':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Invoice Removed From Group');
		case 'ActivityItemAccountsPayableActivityTypeInvoiceRejected':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Processed Invoice Rejected');
		case 'ActivityItemAccountsPayableActivityTypeSentToCadence':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Sent To CADENCE');
		case 'ActivityItemAccountsPayableActivityTypeVerifiedByCadence':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Successfully Received By CADENCE');
		case 'ActivityItemAccountsPayableActivityTypeReadyForFMSPickup':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Ready for FMS Pickup');
		case 'ActivityItemAccountsPayableActivityTypeAcknowledgedByFMS':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Acknowledged by FMS');
		case 'ActivityItemAccountsPayableActivityTypeSentToVerifyQueue':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Verifications: Invoice Sent to Verify Queue');
		case 'ActivityItemAccountsPayableActivityTypeBypassedVerifyQueue':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Verifications: Invoice Bypassed Verify Queue');
		case 'ActivityItemAccountsPayableActivityTypeVerifierChangedInvoiceAmount':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Verifications: Changed Invoice Amount');
		case 'ActivityItemAccountsPayableActivityTypeMarkedNotReadyForVerification':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Verifications: Marked not ready for Verification');
		case 'ActivityItemAccountsPayableActivityTypeVerificationBatchStarted':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Verifications: Batch Started');
		case 'ActivityItemAccountsPayableActivityTypeVerifyCompleted':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Verifications: Completed');
		case 'ActivityItemAccountsPayableActivityTypeMarkedPurchasedByUser':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Invoice Marked as Purchased');
		case 'ActivityItemAccountsPayableActivityTypeDocumentAdded':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Document Added');
		case 'ActivityItemAccountsPayableActivityTypeDocumentRemoved':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Document Removed');
		case 'ActivityItemAccountsPayableActivityTypeDocumentAssigned':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Document Assigned');
		case 'ActivityItemAccountsPayableActivityTypeDocumentsResendRequested':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Invoice Documents Resend Requested');
		case 'ActivityItemAccountsPayableActivityTypeDocSentToExternal':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Document Sent');
		case 'ActivityItemAccountsPayableActivityTypeDocumentsMerged':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Documents Merged');
		case 'ActivityItemAccountsPayableActivityTypeAddDocumentToLoadSuccess':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Successfully Added Document to Load');
		case 'ActivityItemAccountsPayableActivityTypeAddDocumentToLoadFailure':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Failed to Add Document to Load');
		case 'ActivityItemAccountsPayableActivityTypeEmailIgnored':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Email Ignored');
		case 'ActivityItemAccountsPayableActivityTypeEmailUnignored':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Email Unignored');
		case 'ActivityItemAccountsPayableActivityTypeEmailCompleted':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Email Processing Completed');
		case 'ActivityItemAccountsPayableActivityTypeDuplicateEmailAutoCompleted':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Duplicate Email Auto-Completed');
		case 'ActivityItemAccountsPayableActivityTypeAutoCompletedWaitingExceptionsOnNewDocs':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Invoice moved from Waiting to Ready to Audit due to new documents');
		case 'ActivityItemAccountsPayableActivityTypeEmailMergeTarget':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Merged From Emails');
		case 'ActivityItemAccountsPayableActivityTypeEmailMergeSource':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Completed Due to Email Merge');
		case 'ActivityItemAccountsPayableActivityTypeForwardedEmail':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Email Forwarded');
		case 'ActivityItemAccountsPayableActivityTypeEmailZeroPages':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Email with Zero Pages');
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsApproved':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Load Documents Approved');
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsScraped':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Load Documents Scraped');
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsAssigned':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Load Documents Assigned');
		case 'ActivityItemAccountsPayableActivityTypeLoadDocumentsSent':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Load Documents Sent to TMS');
		case 'ActivityItemAccountsPayableActivityTypeLoadShipmentApproval':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Shipment Approved');
		case 'ActivityItemAccountsPayableActivityTypeLoadShipmentUnapproval':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Shipment Un-Approved');
		case 'ActivityItemAccountsPayableActivityTypeBuiltLoadSentToTMS':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Built Load Sent to TMS');
		case 'ActivityItemAccountsPayableActivityTypeBuiltLoadConfirmed':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Built Load Confirmed');
		case 'ActivityItemAccountsPayableActivityTypePODRequestSentToTextLocate':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'POD Request Sent');
		case 'ActivityItemAccountsPayableActivityTypeLtlMovedToTMSQueue':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'LTL Invoice Moved to TMS');
		case 'ActivityItemAccountsPayableActivityTypeLtlDisputeAdded':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Invoice reconciliation action taken');
		case 'ActivityItemAccountsPayableActivityTypeLtlAcceptAdded':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'LTL Accept Added');
		case 'ActivityItemAccountsPayableActivityTypeLtlUpdatedEdiReceived':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'LTL Updated EDI Received');
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateRequested':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'LTL Re-Rate Requested');
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateFailed':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'LTL Re-Rate Failed');
		case 'ActivityItemAccountsPayableActivityTypeLtlRerateCompleted':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'LTL Re-Rate Completed');
		case 'ActivityItemAccountsPayableActivityTypeIgnore':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Documents Ignored');
		case 'ActivityItemAccountsPayableActivityTypeContactAdded':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Contact Information Added');
		case 'ActivityItemAccountsPayableActivityTypeExternalCreation':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Invoice Created from TMS');
		case 'ActivityItemAccountsPayableActivityTypeUpdatedFromExternal':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Invoice Updated From TMS');
		case 'ActivityItemAccountsPayableActivityTypeInvoiceDocumentsForwardedToTriumph':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Invoice Documents Forwarded To Triumph');
		case 'ActivityItemAccountsPayableActivityTypeAcertusShipmentApproved':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Acertus Shipment Approved');
		case 'ActivityItemAccountsPayableActivityTypeAcertusShipmentRejected':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Acertus Shipment Rejected');
		case 'ActivityItemAccountsPayableActivityTypeClientOrDebtorOnBolChanged':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Client/Debtor on BOL Changed');
		case 'ActivityItemAccountsPayableActivityTypeDebtorCorrected':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$FactorOnly, 'Debtor Corrected');
		case 'ActivityItemAccountsPayableActivityTypeCarrierInvoiceRuleChangedViaTMS':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Carrier Invoice Rule Changed via TMS');
		case 'ActivityItemAccountsPayableActivityTypeFactoringAssignment':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Factoring Assignment');
		case 'ActivityItemAccountsPayableActivityTypeIndexingComplete':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$BrokerOnly, 'Indexing Complete');
		case 'ActivityItemAccountsPayableActivityTypeSendNoteToPayeeViaPaymentsNetwork':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Hidden, 'Note Sent to Payee via Payments Network');
		case 'ActivityItemAccountsPayableActivityTypeHidden':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Hidden, 'Document Marked as Duplicate');
		case 'ActivityItemAccountsPayableActivityTypeNonInvoiceLoadAssignment':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Hidden, 'Non-Invoice Load Assignment');
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentBatchAutoCompleted':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Duplicate Document Batch Auto-Completed');
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoHidden':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Duplicate Document Auto-Hidden');
		case 'ActivityItemAccountsPayableActivityTypeDuplicateDocumentAutoMerged':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Duplicate Document Auto-Merged');
		case 'ActivityItemAccountsPayableActivityTypeLineItemsAutoReplaced':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Line Items Auto-Replaced');
		case 'ActivityItemAccountsPayableActivityTypeApproval':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Approved');
		case 'ActivityItemAccountsPayableActivityTypeCarrierPayableApproval':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Carrier Payable Approved');
		case 'ActivityItemAccountsPayableActivityTypeProcessed':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Processed');
		case 'ActivityItemAccountsPayableActivityTypeAutoProcessed':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Auto Processed');
		case 'ActivityItemAccountsPayableActivityTypeInvoiceAbandoned':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Ignored');
		case 'ActivityItemAccountsPayableActivityTypeInvoiceRevived':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Unignored');
		case 'ActivityItemAccountsPayableActivityTypeInvoiceUnapproved':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Un-Approved');
		case 'ActivityItemAccountsPayableActivityTypeReceivedInvoice':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Received');
		case 'ActivityItemAccountsPayableActivityTypeStateChange':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'State Changed');
		case 'ActivityItemAccountsPayableActivityTypeException':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Saved As Incomplete');
		case 'ActivityItemAccountsPayableActivityTypeExceptionResolved':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Exception Resolved');
		case 'ActivityItemAccountsPayableActivityTypeExceptionsClearedViaAPI':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Exceptions Cleared via API');
		case 'ActivityItemAccountsPayableActivityTypeDocsSentOnException':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Exception documents sent');
		case 'ActivityItemAccountsPayableActivityTypeInvoiceExceptionEmailSent':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Email Sent on Exception');
		case 'ActivityItemAccountsPayableActivityTypeFlaggedForManualReview':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Flagged for Manual Review');
		case 'ActivityItemAccountsPayableActivityTypeTransmissionReceived':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Transmission Received');
		case 'ActivityItemAccountsPayableActivityTypeTransmissionSucceeded':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Transmission Succeeded');
		case 'ActivityItemAccountsPayableActivityTypeTransmissionFailed':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Rejected by TMS');
		case 'ActivityItemAccountsPayableActivityTypeSentToExternal':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Invoice Sent to TMS');
		case 'ActivityItemAccountsPayableActivityTypeNote':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Note Added');
		case 'ActivityItemAccountsPayableActivityTypeRuleDisabled':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Exception Ignored');
		case 'ActivityItemAccountsPayableActivityTypeRuleEnabled':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Exception Unignored');
		case 'ActivityItemAccountsPayableActivityTypePaymentAddressChanged':
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Payment Address Changed');
		default:
			return _Utils_Tuple2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$Shared, 'Paused');
	}
};
var $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$shouldInclude = F4(
	function (category, account, accountSettings, activityType) {
		var isLoadDoc = A2(
			$elm$core$List$member,
			activityType,
			_List_fromArray(
				[$author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsApproved, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsAssigned, $author$project$AuditPb$ActivityItemAccountsPayableActivityTypeLoadDocumentsSent]));
		switch (category.$) {
			case 'Shared':
				return true;
			case 'FactorOnly':
				return account.factorAccount;
			case 'BrokerOnly':
				return !(account.factorAccount || (isLoadDoc && $elm$core$List$isEmpty(accountSettings.nonInvoiceLoadDocumentTypes)));
			default:
				return false;
		}
	});
var $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$filterActivityTypeAndDisplayName = F3(
	function (account, accountSettings, activityType) {
		var _v0 = $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$activityTypeInfo(activityType);
		var category = _v0.a;
		var displayName = _v0.b;
		return A4($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$shouldInclude, category, account, accountSettings, activityType) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(activityType, displayName)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$all = F2(
	function (account, accountSettings) {
		return A2(
			$elm$core$List$sortBy,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filterMap,
				A2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$filterActivityTypeAndDisplayName, account, accountSettings),
				$author$project$AuditPb$allActivityItemAccountsPayableActivityType));
	});
var $author$project$Typeahead$GetNewItems = function (a) {
	return {$: 'GetNewItems', a: a};
};
var $author$project$Typeahead$PossibleReset = {$: 'PossibleReset'};
var $author$project$Typeahead$SetFocus = function (a) {
	return {$: 'SetFocus', a: a};
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Typeahead$userInput = F3(
	function (data, _v0, config) {
		var model = _v0.a;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(
				model.selection,
				A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.selectedItem;
					},
					data));
			_v2$3:
			while (true) {
				if (_v2.a.$ === 'NoSelection') {
					var term = _v2.a.a;
					return _Utils_Tuple2(term, false);
				} else {
					switch (_v2.b.$) {
						case 'Loaded':
							if (_v2.b.a.$ === 'Just') {
								var selectedItem = _v2.b.a.a;
								return _Utils_Tuple2(
									config.itemName(selectedItem),
									false);
							} else {
								break _v2$3;
							}
						case 'Error':
							return _Utils_Tuple2('Unable to load', true);
						default:
							break _v2$3;
					}
				}
			}
			var itemId = _v2.a.a;
			var _v3 = A2(
				$elm_community$list_extra$List$Extra$find,
				function (prependItem) {
					return _Utils_eq(
						config.toId(prependItem),
						itemId);
				},
				config.prependItems);
			if (_v3.$ === 'Just') {
				var matchingPrependItem = _v3.a;
				return _Utils_Tuple2(
					config.itemName(matchingPrependItem),
					false);
			} else {
				return _Utils_Tuple2('Loading...', true);
			}
		}();
		var textValue = _v1.a;
		var isLoading = _v1.b;
		return A2(
			$elm$html$Html$input,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder(config.placeholder),
						$elm$html$Html$Attributes$value(textValue),
						$elm$html$Html$Attributes$disabled(isLoading),
						$elm$html$Html$Events$onFocus(
						$author$project$Typeahead$SetFocus(true)),
						$elm$html$Html$Events$onBlur($author$project$Typeahead$PossibleReset),
						$elm$html$Html$Events$onInput($author$project$Typeahead$GetNewItems),
						$elm$html$Html$Attributes$id('typeahead-input'),
						$elm$html$Html$Attributes$class(
						A2($elm$core$Maybe$withDefault, 'autocomplete-input', config.inputClassOverride)),
						$elm$html$Html$Attributes$autocomplete(false),
						$elm$html$Html$Attributes$type_('search')
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					config.additionalInputAttributes)),
			_List_Nil);
	});
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $author$project$TypeaheadMenu$MouseClick = function (a) {
	return {$: 'MouseClick', a: a};
};
var $author$project$TypeaheadMenu$MouseEnter = function (a) {
	return {$: 'MouseEnter', a: a};
};
var $author$project$TypeaheadMenu$MouseLeave = function (a) {
	return {$: 'MouseLeave', a: a};
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$TypeaheadMenu$viewItem = F3(
	function (config, state, item) {
		var id = config.toId(item);
		var isSelected = function (maybeId) {
			if (maybeId.$ === 'Just') {
				var someId = maybeId.a;
				return _Utils_eq(someId, id);
			} else {
				return false;
			}
		};
		var listItemData = A2(
			config.getLiData,
			{
				highlighted: isSelected(state.highlightedViaKeyboard) || isSelected(state.highlightedViaMouse)
			},
			item);
		var customAttributes = A2(
			$elm$core$List$map,
			$elm$html$Html$Attributes$map($elm$core$Basics$never),
			listItemData.attributes);
		var customLiAttr = A2(
			$elm$core$List$append,
			customAttributes,
			_List_fromArray(
				[
					$elm$html$Html$Events$onMouseEnter(
					$author$project$TypeaheadMenu$MouseEnter(id)),
					$elm$html$Html$Events$onMouseLeave(
					$author$project$TypeaheadMenu$MouseLeave(id)),
					$elm$html$Html$Events$onClick(
					$author$project$TypeaheadMenu$MouseClick(id))
				]));
		return A2(
			$elm$html$Html$li,
			customLiAttr,
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($elm$core$Basics$never),
				listItemData.children));
	});
var $author$project$TypeaheadMenu$viewList = F4(
	function (config, howManyToShow, state, selectedType) {
		var mapToAttributes = $elm$core$List$map(
			$elm$html$Html$Attributes$map($elm$core$Basics$never));
		var outerDivAttributes = mapToAttributes(config.outerDivAttributes);
		var getKeyedItems = function (item) {
			return _Utils_Tuple2(
				config.idToString(
					config.toId(item)),
				A3($author$project$TypeaheadMenu$viewItem, config, state, item));
		};
		var customUlAttr = mapToAttributes(config.ulAttributes);
		var _v0 = _Utils_Tuple2(selectedType, config.noItemDisplay);
		if (!_v0.a.b) {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.b;
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			} else {
				var noItemsMessage = _v0.b.a;
				return A2(
					$elm$html$Html$div,
					outerDivAttributes,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							customUlAttr,
							_List_fromArray(
								[
									A2($elm$html$Html$map, $elm$core$Basics$never, noItemsMessage)
								]))
						]));
			}
		} else {
			return A2(
				$elm$html$Html$div,
				outerDivAttributes,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Keyed$ul,
						customUlAttr,
						A2(
							$elm$core$List$map,
							getKeyedItems,
							A2($elm$core$List$take, howManyToShow, selectedType)))
					]));
		}
	});
var $author$project$TypeaheadMenu$view = F4(
	function (config, howManyToShow, state, selectedType) {
		return A4($author$project$TypeaheadMenu$viewList, config, howManyToShow, state, selectedType);
	});
var $author$project$Typeahead$viewConfig = function (config) {
	var defaultClassList = function (_v1) {
		var keyOrMouseSelected = _v1.keyOrMouseSelected;
		return _List_fromArray(
			[
				_Utils_Tuple2('typeahead-item', true),
				_Utils_Tuple2('key-selected', keyOrMouseSelected)
			]);
	};
	var liClassList = A2($elm$core$Maybe$withDefault, defaultClassList, config.liClassOverride);
	var customizedLi = F2(
		function (_v0, item) {
			var highlighted = _v0.highlighted;
			return {
				attributes: _List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						liClassList(
							{keyOrMouseSelected: highlighted})),
						$elm$html$Html$Attributes$id(
						config.itemName(item))
					]),
				children: _List_fromArray(
					[
						config.itemDisplay(item)
					])
			};
		});
	return {
		getLiData: customizedLi,
		idToString: config.idToString,
		noItemDisplay: config.noItemDisplay,
		outerDivAttributes: _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('typeahead-menu')
				]),
			config.additionalMenuAttributes),
		toId: config.toId,
		ulAttributes: _List_fromArray(
			[
				$elm$html$Html$Attributes$class('autocomplete-list')
			])
	};
};
var $author$project$Typeahead$viewMenu = F3(
	function (_v0, items, config) {
		var model = _v0.a;
		var _v1 = model.menu;
		if (_v1.$ === 'Just') {
			var menu = _v1.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Typeahead$TypeaheadMenuMsg,
				A4(
					$author$project$TypeaheadMenu$view,
					$author$project$Typeahead$viewConfig(config),
					model.numberToShow,
					menu,
					A3(
						$author$project$Typeahead$menuItems,
						config,
						$author$project$Typeahead$Model(model),
						items)));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Typeahead$viewKeyedList = F3(
	function (config, data_, _v0) {
		var model = _v0.a;
		if (_Utils_eq(
			model.selection,
			$author$project$Typeahead$NoSelection(''))) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$elm$core$String$fromInt(model.incrementToSetText),
					A3(
						$author$project$Typeahead$userInput,
						data_,
						$author$project$Typeahead$Model(model),
						config))
				]);
		} else {
			var _v1 = A2(
				$author$project$Forward$Remote$andThen,
				function ($) {
					return $.menuItems;
				},
				data_);
			switch (_v1.$) {
				case 'Loaded':
					var data = _v1.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$elm$core$String$fromInt(model.incrementToSetText),
							A3(
								$author$project$Typeahead$userInput,
								data_,
								$author$project$Typeahead$Model(model),
								config)),
							_Utils_Tuple2(
							'viewMenu',
							A3(
								$author$project$Typeahead$viewMenu,
								$author$project$Typeahead$Model(model),
								data,
								config))
						]);
				case 'Loading':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$elm$core$String$fromInt(model.incrementToSetText),
							A3(
								$author$project$Typeahead$userInput,
								data_,
								$author$project$Typeahead$Model(model),
								config)),
							_Utils_Tuple2(
							'typeahead-loading-spinner',
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('typeahead-loading')
									]),
								_List_fromArray(
									[$author$project$Helpers$WaitingSpinner$rawSpinner])))
						]);
				default:
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$elm$core$String$fromInt(model.incrementToSetText),
							A3(
								$author$project$Typeahead$userInput,
								data_,
								$author$project$Typeahead$Model(model),
								config))
						]);
			}
		}
	});
var $author$project$Typeahead$view = F3(
	function (config, data_, model) {
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('typeahead-container')
				]),
			A3($author$project$Typeahead$viewKeyedList, config, data_, model));
	});
var $author$project$Components$CarrierTypeahead$view = $author$project$Typeahead$view;
var $author$project$Components$ActivityBrowser$FiltersView$carrierTypeahead = F3(
	function (account, carrierTypeaheadData, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-2 column activity-filters-typeahead')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Domain$Account$carrierTerm(
								$author$project$Domain$Account$accountType(account)))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$ActivityBrowser$FiltersView$CarrierTypeaheadMsg,
					A3(
						$author$project$Components$CarrierTypeahead$view,
						$author$project$Components$ActivityBrowser$FiltersView$carrierTypeaheadConfig(account),
						carrierTypeaheadData,
						model.carrierTypeahead))
				]));
	});
var $author$project$Components$CustomerTypeahead$view = $author$project$Typeahead$view($author$project$Components$CustomerTypeahead$config);
var $author$project$Components$ActivityBrowser$FiltersView$customerTypeahead = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-2 column activity-filters-typeahead')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Customer')
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$ActivityBrowser$FiltersView$CustomerTypeaheadMsg,
					A2($author$project$Components$CustomerTypeahead$view, data, model.customerTypeahead))
				]));
	});
var $author$project$Components$DebtorTypeahead$viewCustom = function (config) {
	return $author$project$Typeahead$view(config);
};
var $author$project$Components$ActivityBrowser$FiltersView$debtorTypeahead = F2(
	function (debtorTypeaheadData, model) {
		var nameAndMcNumber = function (factorBroker) {
			return A2(
				$elm$core$String$join,
				' : ',
				$elm_community$maybe_extra$Maybe$Extra$values(
					_List_fromArray(
						[
							$elm$core$Maybe$Just(factorBroker.name),
							factorBroker.mcNumber
						])));
		};
		var withMcNumber = function (config) {
			return _Utils_update(
				config,
				{
					itemDisplay: A2($elm$core$Basics$composeR, nameAndMcNumber, $elm$html$Html$text),
					itemName: nameAndMcNumber,
					placeholder: 'Debtor Name or MC Number'
				});
		};
		var viewFn = $author$project$Components$DebtorTypeahead$viewCustom(
			withMcNumber($author$project$Components$DebtorTypeahead$defaultConfig));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-2 column activity-filters-typeahead')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Debtor')
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$ActivityBrowser$FiltersView$DebtorTypeaheadMsg,
					A2(viewFn, debtorTypeaheadData, model.debtorTypeahead))
				]));
	});
var $author$project$Components$ActivityBrowser$FiltersView$ChangeInvoiceNumOrLoadId = function (a) {
	return {$: 'ChangeInvoiceNumOrLoadId', a: a};
};
var $author$project$Components$ActivityBrowser$FiltersView$invoiceNumberOrLoadIdSearch = function (invoiceNumOrLoadIdString) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('small-2 column end')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Invoice / Load')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Events$onInput($author$project$Components$ActivityBrowser$FiltersView$ChangeInvoiceNumOrLoadId),
						$elm$html$Html$Attributes$placeholder('Invoice Number or Load Id'),
						$elm$html$Html$Attributes$value(invoiceNumOrLoadIdString)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$ActivityBrowser$FiltersView$factorFilterFields = F4(
	function (v3Reskin, account, debtorTypeaheadData, model) {
		var showDebtorTypeahead = !($elm_community$maybe_extra$Maybe$Extra$isNothing(
			A2($author$project$Components$ActivityBrowser$FiltersView$selectedTmsCarrierId, v3Reskin, model)) && $author$project$Components$ActivityBrowser$FiltersView$isSiloingDebtors(account));
		return _List_fromArray(
			[
				A2(
				$author$project$Helpers$Html$showIf,
				showDebtorTypeahead,
				A2($author$project$Components$ActivityBrowser$FiltersView$debtorTypeahead, debtorTypeaheadData, model)),
				$author$project$Components$ActivityBrowser$FiltersView$invoiceNumberOrLoadIdSearch(model.invoiceNumOrLoadIdString)
			]);
	});
var $author$project$Components$ActivityBrowser$FiltersView$filterOption = F2(
	function (selectedValue, _v0) {
		var optionValue = _v0.a;
		var optionLabel = _v0.b;
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(optionValue),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(selectedValue, optionValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(optionLabel)
				]));
	});
var $author$project$Components$ActivityBrowser$FiltersView$userToLabel = function (user) {
	return user.isDisabled ? ('Disabled - ' + user.name) : user.name;
};
var $author$project$Components$ActivityBrowser$FiltersView$userFilterOptions = function (users) {
	var toValue = function (user) {
		return _Utils_Tuple2(
			$elm$core$Debug$toString(user.id),
			$author$project$Components$ActivityBrowser$FiltersView$userToLabel(user));
	};
	var boolToInt = function (bool) {
		return (!bool) ? 0 : 1;
	};
	var compareUser = function (user) {
		return _Utils_Tuple2(
			boolToInt(user.isDisabled),
			user.name);
	};
	return A2(
		$elm$core$List$map,
		toValue,
		A2($elm$core$List$sortBy, compareUser, users));
};
var $author$project$Components$ActivityBrowser$FiltersView$userIdDecoder = function (users) {
	return A2(
		$elm$json$Json$Decode$map,
		function (selectedUserString) {
			if ($elm$core$String$isEmpty(selectedUserString)) {
				return $elm$core$Maybe$Nothing;
			} else {
				var selectedUser = A2(
					$elm$core$Dict$get,
					selectedUserString,
					$elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (u) {
								return _Utils_Tuple2(
									$elm$core$Debug$toString(u.id),
									u);
							},
							users)));
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.id;
					},
					selectedUser);
			}
		},
		$elm$html$Html$Events$targetValue);
};
var $author$project$Components$ActivityBrowser$FiltersView$view = F3(
	function (config, loadedData, model) {
		var users = config.users;
		var selectedUser = A2(
			$elm_community$list_extra$List$Extra$find,
			function (user) {
				return _Utils_eq(
					$elm$core$Maybe$Just(user.id),
					model.selectedUserId);
			},
			users);
		var accountSettings = config.accountSettings;
		var account = config.currentAccount;
		var accountTypeSpecificFields = function () {
			var _v0 = $author$project$Domain$Account$accountType(account);
			if (_v0.$ === 'FactorAccount') {
				return A4(
					$author$project$Components$ActivityBrowser$FiltersView$factorFilterFields,
					false,
					account,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.debtorTypeaheadData;
						},
						loadedData),
					model);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Components$ActivityBrowser$FiltersView$customerTypeahead,
						A2(
							$author$project$Forward$Remote$andThen,
							function ($) {
								return $.customerTypeaheadData;
							},
							loadedData),
						model)
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					config.onMsg,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-2 column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('User')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$Events$on,
												'change',
												A2(
													$elm$json$Json$Decode$map,
													$author$project$Components$ActivityBrowser$FiltersView$SelectUserId,
													$author$project$Components$ActivityBrowser$FiltersView$userIdDecoder(users)))
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$option,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$value('')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Any User')
													])),
											A2(
												$elm$core$List$map,
												$author$project$Components$ActivityBrowser$FiltersView$filterOption(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.id;
																},
																$elm$core$Debug$toString),
															selectedUser))),
												$author$project$Components$ActivityBrowser$FiltersView$userFilterOptions(users))))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-2 column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Activity Type')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$Events$on,
												'change',
												A2($elm$json$Json$Decode$map, $author$project$Components$ActivityBrowser$FiltersView$SelectActivityType, $author$project$Components$ActivityBrowser$FiltersView$activityTypeDecoder))
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$option,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$value('')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Any Type')
													])),
											A2(
												$elm$core$List$map,
												A2(
													$elm$core$Basics$composeL,
													$author$project$Components$ActivityBrowser$FiltersView$filterOption(
														A2($elm$core$Maybe$withDefault, '', model.selectedActivityType)),
													$elm$core$Tuple$mapFirst($author$project$AuditPb$activityItemAccountsPayableActivityTypeToString)),
												A2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$all, account, accountSettings))))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-2 column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Start Date')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('date'),
												A2(
												$elm$html$Html$Events$on,
												'change',
												A2($elm$json$Json$Decode$map, $author$project$Components$ActivityBrowser$FiltersView$SelectDate, $elm$html$Html$Events$targetValue)),
												$elm$html$Html$Attributes$value(model.startDateString)
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-2 column end')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('End Date')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('date'),
												A2(
												$elm$html$Html$Events$on,
												'change',
												A2($elm$json$Json$Decode$map, $author$project$Components$ActivityBrowser$FiltersView$SelectEndDate, $elm$html$Html$Events$targetValue)),
												$elm$html$Html$Attributes$value(model.endDateString)
											]),
										_List_Nil)
									])),
								A3(
								$author$project$Components$ActivityBrowser$FiltersView$carrierTypeahead,
								account,
								A2(
									$author$project$Forward$Remote$andThen,
									function ($) {
										return $.carrierTypeaheadData;
									},
									loadedData),
								model)
							]))),
					A2(
					$elm$html$Html$map,
					config.onMsg,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						accountTypeSpecificFields)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-2 column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button--progress'),
											$elm$html$Html$Events$onClick(config.onApplyFilters)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Update')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$ActivityPage$ClearFilters = {$: 'ClearFilters'};
var $author$project$Components$ActivityBrowser$FiltersView$hasChangedFiltersFromLast = F2(
	function (current, last) {
		var hasChanged = function (func) {
			return !_Utils_eq(
				func(last),
				func(current));
		};
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					hasChanged(
					function ($) {
						return $.selectedActivityType;
					}),
					hasChanged(
					function ($) {
						return $.selectedUserId;
					}),
					hasChanged(
					function ($) {
						return $.startDate;
					}),
					hasChanged(
					function ($) {
						return $.endDate;
					}),
					hasChanged(
					$author$project$Components$ActivityBrowser$FiltersView$selectedTmsCarrierId(true)),
					hasChanged(
					$author$project$Components$ActivityBrowser$FiltersView$selectedTmsCustomerId(true))
				]));
	});
var $author$project$Components$ActivityBrowser$FiltersView$hasAnyFiltersApplied = function (model) {
	return A2(
		$author$project$Components$ActivityBrowser$FiltersView$hasChangedFiltersFromLast,
		model,
		$author$project$Components$ActivityBrowser$FiltersView$clear(model));
};
var $author$project$Forward$Remote$defaultErrorView = function (error) {
	var _v0 = function () {
		if (error.$ === 'Unloadable') {
			var reason_ = error.a;
			return _Utils_Tuple2(reason_, $elm$core$Maybe$Nothing);
		} else {
			var err = error.a;
			return _Utils_Tuple2(
				'Could not parse data from server.\u000A\u000A' + err.decoderMessage,
				$elm$core$Maybe$Just(err.json));
		}
	}();
	var reason = _v0.a;
	var debug = _v0.b;
	return (reason === 'DoesNotExist') ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('forward-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('ERROR: The data you have requested could not be found on the server.')
			])) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('forward-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('ERROR: Please click the following link to '),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('https://support.triumphpay.com/support/tickets/new'),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('contact support')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'none')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(reason),
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', debug))
					]))
			]));
};
var $author$project$Ui$V3$Skeleton$viewRemote = F4(
	function (attrs, config, viewFunc, remote) {
		switch (remote.$) {
			case 'Loading':
				return A2($author$project$Ui$V3$Skeleton$viewCustom, attrs, config);
			case 'Loaded':
				var a = remote.a;
				return viewFunc(a);
			default:
				var error = remote.a;
				return $author$project$Forward$Remote$defaultErrorView(error);
		}
	});
var $author$project$Ui$V3$Icon$chevronUp16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M8.04772 4C8.39851 4 8.69919 4.15026 8.89964 4.40069L13.7606 9.91024C14.1114 10.2608 14.0613 10.8619 13.7105 11.2125C13.3597 11.5631 12.7584 11.513 12.4076 11.1624C12.4076 11.1624 12.4076 11.1624 12.3575 11.1123L8.09783 6.30399C8.04772 6.2539 7.99761 6.2539 7.89738 6.30399L3.63776 11.1123C3.28696 11.513 2.73572 11.5631 2.33481 11.2125C1.93391 10.8619 1.88379 10.3109 2.23459 9.91024C2.23459 9.91024 2.23459 9.91024 2.2847 9.86015L7.14568 4.35061C7.39625 4.15026 7.69693 4 8.04772 4Z'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_Nil));
var $author$project$Ui$V3$Table$defaultEmptyContent = function (_v0) {
	var body = _v0.body;
	var header = _v0.header;
	var attrs = _List_fromArray(
		[
			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
		]);
	return $author$project$Ui$V3$Table$EmptyContent(
		A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$h2,
						attrs,
						_List_fromArray(
							[
								$elm$html$Html$text(header)
							]))),
					A2(
					$elm$core$Maybe$map,
					$author$project$Ui$V3$Typography$body(attrs),
					body)
				])));
};
var $author$project$Ui$V3$Table$DrawerAttribute = function (a) {
	return {$: 'DrawerAttribute', a: a};
};
var $author$project$Ui$V3$Table$drawer = $author$project$Ui$V3$Table$DrawerAttribute;
var $author$project$Ui$V3$Table$FillHeightAttribute = {$: 'FillHeightAttribute'};
var $author$project$Ui$V3$Table$fillHeight = $author$project$Ui$V3$Table$FillHeightAttribute;
var $author$project$Ui$V3$Table$LoadMoreAttribute = function (a) {
	return {$: 'LoadMoreAttribute', a: a};
};
var $author$project$Ui$V3$Table$loadMore = $author$project$Ui$V3$Table$LoadMoreAttribute;
var $author$project$Ui$V3$Stack$MainAxisSpaceBetween = {$: 'MainAxisSpaceBetween'};
var $author$project$Ui$V3$Stack$mainAxisSpaceBetween = $author$project$Ui$V3$Stack$MainAxisAttribute($author$project$Ui$V3$Stack$MainAxisSpaceBetween);
var $author$project$Ui$V3$UtilityButton$SizeMedium = {$: 'SizeMedium'};
var $author$project$Ui$V3$UtilityButton$defaultAttributes = {badge: $elm$core$Maybe$Nothing, classes: '', iconColor: $elm$core$Maybe$Nothing, isDisabled: false, isHighlighted: false, showLabel: false, size: $author$project$Ui$V3$UtilityButton$SizeMedium};
var $author$project$Ui$V3$UtilityButton$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'Size':
					var val = a.a;
					return _Utils_update(
						acc,
						{size: val});
				case 'ShowLabel':
					var val = a.a;
					return _Utils_update(
						acc,
						{showLabel: val});
				case 'Badge':
					var val = a.a;
					return _Utils_update(
						acc,
						{
							badge: $elm$core$Maybe$Just(val)
						});
				case 'IsHighlighted':
					var val = a.a;
					return _Utils_update(
						acc,
						{isHighlighted: val});
				case 'IsDisabled':
					var val = a.a;
					return _Utils_update(
						acc,
						{isDisabled: val});
				case 'Class':
					var val = a.a;
					return _Utils_update(
						acc,
						{classes: acc.classes + (' ' + val)});
				default:
					var val = a.a;
					return _Utils_update(
						acc,
						{
							iconColor: $elm$core$Maybe$Just(val)
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$UtilityButton$defaultAttributes, attributes);
};
var $author$project$Ui$V3$UtilityButton$view = F2(
	function (config, attrs) {
		var computedAttributes = $author$project$Ui$V3$UtilityButton$computeAttributes(attrs);
		var sizeClass = function () {
			var _v1 = computedAttributes.size;
			if (_v1.$ === 'SizeSmall') {
				return 'v3__button--utility--size-small';
			} else {
				return 'v3__button--utility--size-medium';
			}
		}();
		var colorStyle = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$Attributes$class(''),
			A2($elm$core$Maybe$map, $author$project$Ui$V3$Colors$colorAttribute, computedAttributes.iconColor));
		var buttonText = computedAttributes.showLabel ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__button--utility-label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(config.label)
				])) : $elm$html$Html$text('');
		var badgeEl = function () {
			var _v0 = computedAttributes.badge;
			if (_v0.$ === 'Just') {
				var badgeConfig = _v0.a;
				return (badgeConfig.count > 0) ? A3(
					$author$project$Ui$V3$Badge$view,
					_List_fromArray(
						[
							$author$project$Ui$V3$Badge$badgeSize(badgeConfig.size),
							$author$project$Ui$V3$Badge$badgeStyle(badgeConfig.style)
						]),
					badgeConfig.count,
					badgeConfig.text) : $elm$html$Html$text('');
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__button'),
					$elm$html$Html$Attributes$class('v3__button--square'),
					$elm$html$Html$Attributes$class('v3__button--utility'),
					$elm$html$Html$Attributes$class(sizeClass),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('v3__button--utility--highlighted', computedAttributes.isHighlighted)
						])),
					$elm$html$Html$Attributes$class(computedAttributes.classes),
					$elm$html$Html$Attributes$disabled(computedAttributes.isDisabled),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', config.label),
					$elm$html$Html$Attributes$type_('button'),
					colorStyle,
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'click',
					$elm$json$Json$Decode$succeed(
						function (msg) {
							return _Utils_Tuple2(msg, true);
						}(config.onClick)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__button--label-wrapper')
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Icon$view16, _List_Nil, config.icon),
							badgeEl,
							buttonText
						]))
				]));
	});
var $author$project$Ui$V3$Table$NestedColumnAttribute = function (a) {
	return {$: 'NestedColumnAttribute', a: a};
};
var $author$project$Forward$Remote$all = function (remotes) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (remote, result) {
				return A3($author$project$Forward$Remote$map2, $elm$core$List$cons, remote, result);
			}),
		$author$project$Forward$Remote$Loaded(_List_Nil),
		remotes);
};
var $author$project$Ui$V3$Table$LoadingAttribute = function (a) {
	return {$: 'LoadingAttribute', a: a};
};
var $author$project$Ui$V3$Table$loading = $author$project$Ui$V3$Table$LoadingAttribute;
var $author$project$Ui$V3$Table$LoadingRow = function (a) {
	return {$: 'LoadingRow', a: a};
};
var $author$project$Ui$V3$Table$loadingRow = $author$project$Ui$V3$Table$LoadingRow;
var $author$project$Ui$V3$Table$viewRemotes = F3(
	function (_v0, attributes, remoteRows) {
		var rowHeight = _v0.rowHeight;
		var columns = _v0.columns;
		var loadingColumns = A2(
			$elm$core$List$map,
			function (column) {
				return {
					attrs: A2(
						$elm$core$List$map,
						function (attr) {
							switch (attr.$) {
								case 'CellAttributes':
									var f = attr.a;
									return $author$project$Ui$V3$Table$CellAttributes(
										function (loadingRow_) {
											if (loadingRow_.$ === 'Loaded') {
												var row = loadingRow_.a;
												return f(row);
											} else {
												return _List_Nil;
											}
										});
								case 'SortableAttribute':
									return $author$project$Ui$V3$Table$SortableAttribute;
								case 'RightAlignedAttribute':
									return $author$project$Ui$V3$Table$RightAlignedAttribute;
								case 'TopAlignedAttribute':
									return $author$project$Ui$V3$Table$TopAlignedAttribute;
								case 'BottomAlignedAttribute':
									return $author$project$Ui$V3$Table$BottomAlignedAttribute;
								default:
									var forSubgroup = attr.a.forSubgroup;
									var forTable = attr.a.forTable;
									return $author$project$Ui$V3$Table$NestedColumnAttribute(
										{
											forSubgroup: function (loadingRows) {
												return forSubgroup(
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														$author$project$Forward$Remote$toMaybe(
															$author$project$Forward$Remote$all(loadingRows))));
											},
											forTable: forTable
										});
							}
						},
						column.attrs),
					content: function (loadingRow_) {
						if (loadingRow_.$ === 'Loaded') {
							var row = loadingRow_.a;
							return column.content(row);
						} else {
							return $elm$html$Html$text('');
						}
					},
					heading: column.heading
				};
			},
			columns);
		var computedAttributes = $author$project$Ui$V3$Table$computeAttributes(
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Table$loadingRow(
						function (row) {
							if (row.$ === 'Loading') {
								return $elm$core$Maybe$Just(
									{height: rowHeight});
							} else {
								return $elm$core$Maybe$Nothing;
							}
						})
					])));
		switch (remoteRows.$) {
			case 'Loading':
				var showFullLoadingState = _Utils_eq(
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.rowsToShowWhileLoading;
						},
						computedAttributes.loadMore));
				return A2(
					$author$project$Ui$V3$Table$viewContainer,
					computedAttributes,
					A4(
						$author$project$Ui$V3$Table$viewTable,
						_List_Nil,
						loadingColumns,
						computedAttributes,
						$author$project$Ui$V3$Table$computeTableAttributes(
							_List_fromArray(
								[
									$author$project$Ui$V3$Table$loading(showFullLoadingState)
								]))));
			case 'Loaded':
				var rows = remoteRows.a;
				return A2(
					$author$project$Ui$V3$Table$viewContainer,
					computedAttributes,
					A4(
						$author$project$Ui$V3$Table$viewTable,
						rows,
						loadingColumns,
						computedAttributes,
						$author$project$Ui$V3$Table$computeTableAttributes(_List_Nil)));
			default:
				var err = remoteRows.a;
				return $author$project$Forward$Remote$defaultErrorView(err);
		}
	});
var $author$project$Components$ActivityBrowser$ActivityItemListView$viewV3Reskin = F9(
	function (tz, remoteData, maybeLastData, model, msgMapper, filtersView, loadMoreMsg, maybeClearMsg, hasAnyFiltersApplied) {
		var viewHeader = $author$project$Ui$V3$Typography$smallBodySemiBold(_List_Nil);
		var viewCell = function (el) {
			return A2(
				$elm$html$Html$map,
				msgMapper,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$author$project$Ui$V3$Typography$smallBodyClass]),
					_List_fromArray(
						[el])));
		};
		var filtersDrawer = {
			content: A2(
				$author$project$Ui$V3$Stack$viewVertWithHeights,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Stack$style, 'height', '100%')
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$mainAxisSpaceBetween,
									$author$project$Ui$V3$Stack$crossAxisCenter,
									A2($author$project$Ui$V3$Stack$style, 'border-bottom', '1px solid var(--color-gray-200)'),
									A2($author$project$Ui$V3$Stack$style, 'padding', '0 14px'),
									A2($author$project$Ui$V3$Stack$style, 'height', '51px')
								]),
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									$elm$core$Maybe$Just(
										viewHeader('Filters'))),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									A2(
										$elm$core$Maybe$map,
										function (clearMsg) {
											return A3(
												$author$project$Ui$V3$Button$view,
												{
													action: $author$project$Ui$V3$Button$onClick(clearMsg)
												},
												_List_fromArray(
													[
														$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
														$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall)
													]),
												'Clear all');
										},
										maybeClearMsg))
								]))),
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, filtersView)
					])),
			isOpen: true
		};
		var emptyContent = hasAnyFiltersApplied ? {
			body: $elm$core$Maybe$Just('There are no results that match these filters'),
			header: 'No results'
		} : {body: $elm$core$Maybe$Nothing, header: 'No activity present'};
		var columns = _List_fromArray(
			[
				{
				attrs: _List_Nil,
				content: function (item) {
					if ($author$project$Components$ActivityBrowser$DetailsView$hasExpandedDetails(item.activityItem)) {
						var activityItemId = item.activityItem.id;
						var itemModel = A2($author$project$Components$ActivityBrowser$ActivityItemListView$activityItemViewModel, activityItemId, model);
						var icon = itemModel.isExpanded ? $author$project$Ui$V3$Icon$chevronUp16 : $author$project$Ui$V3$Icon$chevronDown16;
						return viewCell(
							A2(
								$author$project$Ui$V3$UtilityButton$view,
								{
									icon: icon,
									label: 'Expand',
									onClick: A2($author$project$Components$ActivityBrowser$ActivityItemListView$ActivityItemViewMsg, activityItemId, $author$project$Components$ActivityBrowser$ActivityItemView$ToggleExpandedDetails)
								},
								_List_Nil));
					} else {
						return $elm$html$Html$text('');
					}
				},
				heading: $elm$html$Html$text('')
			},
				{
				attrs: _List_Nil,
				content: function (item) {
					return viewCell(
						A2($author$project$Components$ActivityBrowser$ContextView$view, true, item.contextView));
				},
				heading: viewHeader('Item')
			},
				{
				attrs: _List_Nil,
				content: function (item) {
					return viewCell(
						A4($author$project$Components$ActivityBrowser$TitleView$view, tz, item.currentAccount, item.accountSettings, item.activityItem));
				},
				heading: viewHeader('Title')
			},
				{
				attrs: _List_Nil,
				content: function (item) {
					return viewCell(
						$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, 'System', item.activityItem.userName)));
				},
				heading: viewHeader('User')
			},
				{
				attrs: _List_Nil,
				content: function (item) {
					return viewCell(
						$elm$html$Html$text(
							A2($author$project$Helpers$Date$toString, tz, item.activityItem.createdAt)));
				},
				heading: viewHeader('Time')
			}
			]);
		var subRow = function (item) {
			if (item.$ === 'Loaded') {
				var loadedItem = item.a;
				var activityItemId = loadedItem.activityItem.id;
				var itemModel = A2($author$project$Components$ActivityBrowser$ActivityItemListView$activityItemViewModel, activityItemId, model);
				return itemModel.isExpanded ? $elm$core$Maybe$Just(
					_List_fromArray(
						[
							A2($elm$html$Html$td, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$colspan(
									$elm$core$List$length(columns) - 1),
									A2($elm$html$Html$Attributes$style, 'padding', '0 15px 15px')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									msgMapper,
									A2(
										$elm$html$Html$map,
										$author$project$Components$ActivityBrowser$ActivityItemListView$ActivityItemViewMsg(activityItemId),
										A3($author$project$Components$ActivityBrowser$ActivityItemView$viewDetails, true, loadedItem, itemModel)))
								]))
						])) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A3(
			$author$project$Ui$V3$Table$viewRemotes,
			{columns: columns, rowHeight: 58},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$subRow(subRow),
					$author$project$Ui$V3$Table$drawer(filtersDrawer),
					$author$project$Ui$V3$Table$defaultEmptyContent(emptyContent),
					$author$project$Ui$V3$Table$fillHeight,
					$author$project$Ui$V3$Table$loadMore(
					{
						hasMore: !_Utils_eq(
							$author$project$Components$ActivityBrowser$ActivityItemListView$hasMoreItems(remoteData),
							$elm$core$Maybe$Just(false)),
						onLoadMore: loadMoreMsg,
						rowsToShowWhileLoading: $author$project$Forward$Remote$isResolved(remoteData) ? $elm$core$Maybe$Nothing : A2(
							$elm$core$Maybe$map,
							$author$project$Stream$value,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.activityItems;
								},
								maybeLastData))
					})
				]),
			A2(
				$author$project$Forward$Remote$map,
				$author$project$Stream$value,
				A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.activityItems;
					},
					remoteData)));
	});
var $author$project$Ui$V3$Button$CssStyle = F2(
	function (a, b) {
		return {$: 'CssStyle', a: a, b: b};
	});
var $author$project$Ui$V3$Button$cssStyle = $author$project$Ui$V3$Button$CssStyle;
var $author$project$Components$SettingsPage$CarrierDropdown$view = F3(
	function (label, data, model) {
		return A4(
			$author$project$Components$PaginatedDropdown$view,
			$author$project$Components$SettingsPage$CarrierDropdown$carrierToDropdownItem,
			data,
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$label(label)
				]),
			model.dropdown);
	});
var $author$project$Components$TmsCustomerDropdown$view = F4(
	function (attrs, accountSettings, data, model) {
		return A4(
			$author$project$Components$PaginatedDropdown$view,
			$author$project$Components$TmsCustomerDropdown$tmsCustomerToDropdownItem(accountSettings),
			data,
			attrs,
			model.dropdown);
	});
var $author$project$Components$ActivityBrowser$FiltersView$viewV3Reskin = F4(
	function (config, loadedData, lastModel, model) {
		var startDateFilter = A2(
			$author$project$Helpers$Html$labeledInput,
			'Start date',
			A4(
				$author$project$Ui$V3$Input$view,
				{onInput: $author$project$Components$ActivityBrowser$FiltersView$SelectDate},
				_List_fromArray(
					[$author$project$Ui$V3$Input$date]),
				_List_Nil,
				model.startDateString));
		var selectedUser = A2(
			$elm_community$list_extra$List$Extra$find,
			function (user) {
				return _Utils_eq(
					$elm$core$Maybe$Just(user.id),
					model.selectedUserId);
			},
			config.users);
		var userFilter = A2(
			$author$project$Helpers$Html$labeledInput,
			'User',
			A2(
				$author$project$Ui$V3$SimpleSelect$view,
				{
					onInput: function (user) {
						return $author$project$Components$ActivityBrowser$FiltersView$SelectUserId(
							A2(
								$elm$core$Maybe$map,
								function (u) {
									return u.id;
								},
								user));
					},
					options: A2(
						$elm$core$List$cons,
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$map, $elm$core$Maybe$Just, config.users)),
					toLabel: A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Components$ActivityBrowser$FiltersView$userToLabel),
						$elm$core$Maybe$withDefault('Any User')),
					value: $elm$core$Maybe$Just(selectedUser)
				},
				_List_Nil));
		var endDateFilter = A2(
			$author$project$Helpers$Html$labeledInput,
			'End date',
			A4(
				$author$project$Ui$V3$Input$view,
				{onInput: $author$project$Components$ActivityBrowser$FiltersView$SelectEndDate},
				_List_fromArray(
					[$author$project$Ui$V3$Input$date]),
				_List_Nil,
				model.endDateString));
		var customerFilter = A2(
			$elm$html$Html$map,
			$author$project$Components$ActivityBrowser$FiltersView$CustomerDropdownMsg,
			A4(
				$author$project$Components$TmsCustomerDropdown$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$CustomSelect$label('Customer')
					]),
				config.accountSettings,
				A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.customerDropdownData;
					},
					loadedData),
				model.customerDropdown));
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(config.currentAccount));
		var carrierFilter = A2(
			$elm$html$Html$map,
			$author$project$Components$ActivityBrowser$FiltersView$CarrierDropdownMsg,
			A3(
				$author$project$Components$SettingsPage$CarrierDropdown$view,
				carrierTerm,
				A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.carrierDropdownData;
					},
					loadedData),
				model.carrierDropdown));
		var activityTypeFilter = function () {
			var allOptions = A2($author$project$Components$ActivityBrowser$ActivityTypeFilterOptions$all, config.currentAccount, config.accountSettings);
			var current = A2(
				$elm_community$list_extra$List$Extra$find,
				function (_v1) {
					var activityType = _v1.a;
					return _Utils_eq(
						model.selectedActivityType,
						$elm$core$Maybe$Just(
							$author$project$AuditPb$activityItemAccountsPayableActivityTypeToString(activityType)));
				},
				allOptions);
			return A2(
				$author$project$Helpers$Html$labeledInput,
				'Activity type',
				A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$AuditPb$activityItemAccountsPayableActivityTypeToString)),
							$author$project$Components$ActivityBrowser$FiltersView$SelectActivityType),
						options: A2(
							$elm$core$List$cons,
							$elm$core$Maybe$Nothing,
							A2($elm$core$List$map, $elm$core$Maybe$Just, allOptions)),
						toLabel: A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map($elm$core$Tuple$second),
							$elm$core$Maybe$withDefault('Any Type')),
						value: $elm$core$Maybe$Just(current)
					},
					_List_Nil));
		}();
		var accountTypeSpecificFilters = function () {
			var _v0 = $author$project$Domain$Account$accountType(config.currentAccount);
			if (_v0.$ === 'FactorAccount') {
				return A4(
					$author$project$Components$ActivityBrowser$FiltersView$factorFilterFields,
					true,
					config.currentAccount,
					A2(
						$author$project$Forward$Remote$andThen,
						function ($) {
							return $.debtorTypeaheadData;
						},
						loadedData),
					model);
			} else {
				return _List_fromArray(
					[customerFilter]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'height', '100%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'relative'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
							A2($elm$html$Html$Attributes$style, 'padding', 'var(--space-xs) var(--space-xs) 0'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							config.onMsg,
							A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
										A2($author$project$Ui$V3$Stack$style, 'flex-grow', '1')
									]),
								_Utils_ap(
									_List_fromArray(
										[userFilter, activityTypeFilter, startDateFilter, endDateFilter, carrierFilter]),
									accountTypeSpecificFilters))),
							A2($author$project$Components$ActivityBrowser$FiltersView$hasChangedFiltersFromLast, lastModel, model) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
									A2($elm$html$Html$Attributes$style, 'bottom', '0'),
									A2($elm$html$Html$Attributes$style, 'background', 'white'),
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'padding', 'var(--space-xs) 0')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick(config.onApplyFilters)
									},
									_List_fromArray(
										[
											A2($author$project$Ui$V3$Button$cssStyle, 'width', '100%'),
											A2($author$project$Ui$V3$Button$cssStyle, 'justify-content', 'center')
										]),
									'Apply filters')
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Components$ActivityPage$viewV3Reskin = F4(
	function (containerHeight, tz, remoteData, model) {
		var hasAnyFiltersApplied = $author$project$Components$ActivityBrowser$FiltersView$hasAnyFiltersApplied(model.appliedFilters);
		var hasAnyFilters = $author$project$Components$ActivityBrowser$FiltersView$hasAnyFiltersApplied(model.filters);
		var filtersViewEl = A4(
			$author$project$Ui$V3$Skeleton$viewRemote,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'border-radius', '0')
				]),
			{height: $elm$core$Maybe$Nothing},
			function (data) {
				return A4(
					$author$project$Components$ActivityBrowser$FiltersView$viewV3Reskin,
					{accountSettings: data.accountSettings, currentAccount: data.currentAccount, onApplyFilters: $author$project$Components$ActivityPage$ApplyFilters, onMsg: $author$project$Components$ActivityPage$FiltersViewMsg, users: data.users},
					data.filtersView,
					model.appliedFilters,
					model.filters);
			},
			remoteData);
		return $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$author$project$Ui$V3$Stack$viewVertWithHeights,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceMedium),
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium),
						A2(
						$author$project$Ui$V3$Stack$style,
						'height',
						$author$project$Ui$V3$Helpers$Html$px(containerHeight)),
						$author$project$Ui$V3$Stack$class('activity--v3-reskin')
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('View activity')
								]))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A9(
							$author$project$Components$ActivityBrowser$ActivityItemListView$viewV3Reskin,
							tz,
							A2(
								$author$project$Forward$Remote$andThen,
								function ($) {
									return $.activityItemListView;
								},
								remoteData),
							model.maybeLastActivityItemListViewData,
							model.activityItemListView,
							$author$project$Components$ActivityPage$ActivityItemListViewMsg,
							filtersViewEl,
							$author$project$Components$ActivityPage$ChangePage(model.page + 1),
							hasAnyFilters ? $elm$core$Maybe$Just($author$project$Components$ActivityPage$ClearFilters) : $elm$core$Maybe$Nothing,
							hasAnyFiltersApplied))
					])));
	});
var $author$project$Components$ActivityPage$view = F5(
	function (containerHeight, v3ReskinEnabled, tz, data, model) {
		if (v3ReskinEnabled) {
			return A4($author$project$Components$ActivityPage$viewV3Reskin, containerHeight, tz, data, model);
		} else {
			switch (data.$) {
				case 'Loaded':
					var data_ = data.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row general-container')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$ActivityBrowser$FiltersView$view,
								{accountSettings: data_.accountSettings, currentAccount: data_.currentAccount, onApplyFilters: $author$project$Components$ActivityPage$ApplyFilters, onMsg: $author$project$Components$ActivityPage$FiltersViewMsg, users: data_.users},
								data_.filtersView,
								model.filters),
								$author$project$Components$ActivityPage$pageHeader,
								A3(
								$author$project$Helpers$Pagination$pagination,
								model.page,
								A2(
									$elm$core$Maybe$withDefault,
									true,
									$author$project$Components$ActivityBrowser$ActivityItemListView$hasMoreItems(data_.activityItemListView)),
								$author$project$Components$ActivityPage$ChangePage),
								A2(
								$elm$html$Html$map,
								$author$project$Components$ActivityPage$ActivityItemListViewMsg,
								A3($author$project$Components$ActivityBrowser$ActivityItemListView$view, tz, data_.activityItemListView, model.activityItemListView))
							]));
				case 'Loading':
					return $author$project$Forward$LoadingView$defaultLoadingView;
				default:
					var error = data.a;
					return $author$project$Components$ActivityPage$errorView(error);
			}
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$ReviewUnsavedEditClicked = {$: 'ReviewUnsavedEditClicked'};
var $author$project$Components$CarrierInvoiceAuditPage$SaveAndApproveClicked = {$: 'SaveAndApproveClicked'};
var $author$project$Components$CarrierInvoiceAuditPage$SaveAndSendEmailClicked = {$: 'SaveAndSendEmailClicked'};
var $author$project$Components$CarrierInvoiceAuditPage$SaveClicked = {$: 'SaveClicked'};
var $author$project$Components$CarrierInvoiceAuditPage$SaveWithErrorsClicked = {$: 'SaveWithErrorsClicked'};
var $author$project$Ui$V3$Button$TrackingAttribute = function (a) {
	return {$: 'TrackingAttribute', a: a};
};
var $author$project$Ui$V3$Button$trackingAttr = $author$project$Ui$V3$Button$TrackingAttribute;
var $author$project$Components$CarrierInvoiceAuditActionBar$view = function (config) {
	var button = F4(
		function (variant, label, testId, onClick) {
			return A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick(onClick)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$buttonVariant(variant),
						$author$project$Ui$V3$Button$disabled(config.isSubmitting),
						$author$project$Ui$V3$Button$trackingAttr(testId)
					]),
				label);
		});
	var finishButtons = function () {
		var _v0 = config.finishActions;
		switch (_v0.$) {
			case 'CarrierInvoiceFinishActionsNone':
				return _List_Nil;
			case 'CarrierInvoiceFinishActionsProcessOnly':
				return _List_fromArray(
					[
						A4(button, $author$project$Ui$V3$Button$VariantPrimary, 'Save', 'audit-save', config.onSave)
					]);
			case 'CarrierInvoiceFinishActionsProcessAndApprove':
				return _List_fromArray(
					[
						A4(button, $author$project$Ui$V3$Button$VariantPrimary, 'Save and Approve', 'audit-save-and-approve', config.onSave)
					]);
			default:
				return _List_fromArray(
					[
						A4(button, $author$project$Ui$V3$Button$VariantPrimary, 'Save', 'audit-save', config.onSave),
						A4(button, $author$project$Ui$V3$Button$VariantPrimary, 'Save and Approve', 'audit-save-and-approve', config.onSaveAndApprove)
					]);
		}
	}();
	var saveWithErrorsButtons = config.maySaveWithErrors ? _List_fromArray(
		[
			A4(button, $author$project$Ui$V3$Button$VariantSecondary, 'Save Exception and Send Now', 'audit-save-and-send-email', config.onSaveAndSendEmail),
			A4(button, $author$project$Ui$V3$Button$VariantSecondary, 'Resolve Later', 'audit-resolve-later', config.onSaveWithErrors)
		]) : _List_Nil;
	var buttons = (!config.isEditable) ? _List_Nil : (config.hasFailingChecks ? saveWithErrorsButtons : finishButtons);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__action-bar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__action-bar-buttons')
					]),
				buttons)
			]));
};
var $author$project$Components$CarrierInvoiceAuditPage$viewActionBar = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (checks, carrierInvoice) {
						return $author$project$Components$CarrierInvoiceAuditActionBar$view(
							{
								finishActions: carrierInvoice.finishActions,
								hasFailingChecks: !$elm$core$List$isEmpty(
									$author$project$Components$CarrierInvoiceAuditChecks$failing(checks)),
								isEditable: carrierInvoice.isEditable,
								isSubmitting: $author$project$PostRequestState$isInProgress(model.requestState),
								maySaveWithErrors: carrierInvoice.maySaveWithErrors,
								onSave: $author$project$Components$CarrierInvoiceAuditPage$SaveClicked,
								onSaveAndApprove: $author$project$Components$CarrierInvoiceAuditPage$SaveAndApproveClicked,
								onSaveAndSendEmail: $author$project$Components$CarrierInvoiceAuditPage$SaveAndSendEmailClicked,
								onSaveWithErrors: $author$project$Components$CarrierInvoiceAuditPage$SaveWithErrorsClicked
							});
					}),
				$author$project$Forward$Remote$toMaybe(data.auditChecks),
				$author$project$Forward$Remote$toMaybe(data.carrierInvoice)));
	});
var $author$project$Components$DocumentsBrowser$selectedDocumentType = F2(
	function (model, data) {
		var selection = A2($author$project$Components$DocumentsBrowser$selectedPage, data, model);
		var possiblyGroupedDocuments = A2($author$project$Components$DocumentsBrowser$getPossiblyGroupedDocuments, data, model);
		var maybeDocument = A2($author$project$Components$DocumentBrowser$Full$selectedDocument, possiblyGroupedDocuments, selection);
		return {
			currentType: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Domain$UnresolvedDocumentType$Unknown,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.documentTypeValue;
						},
						$author$project$Domain$Document$documentTypeValueToUnresolved),
					maybeDocument)),
			maybeDocumentId: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.id;
				},
				maybeDocument)
		};
	});
var $author$project$Components$DocumentTypePicker$Dismissed = {$: 'Dismissed'};
var $author$project$Ui$V3$Card$HeaderNote = function (a) {
	return {$: 'HeaderNote', a: a};
};
var $author$project$Ui$V3$Card$headerNote = function (note) {
	return $author$project$Ui$V3$Card$HeaderNote(note);
};
var $author$project$Ui$V3$Card$NoPadding = {$: 'NoPadding'};
var $author$project$Ui$V3$Card$noPadding = $author$project$Ui$V3$Card$NoPadding;
var $author$project$Ui$V3$Card$CanCollapse = function (a) {
	return {$: 'CanCollapse', a: a};
};
var $author$project$Ui$V3$Card$Dividers = {$: 'Dividers'};
var $author$project$Ui$V3$Card$FullWidthDividers = {$: 'FullWidthDividers'};
var $author$project$Ui$V3$Card$NoDivider = {$: 'NoDivider'};
var $author$project$Ui$V3$Card$NotCollapsible = {$: 'NotCollapsible'};
var $author$project$Ui$V3$Card$defaultAttributes = {classes: _List_Nil, collapsible: $author$project$Ui$V3$Card$NotCollapsible, dividers: $author$project$Ui$V3$Card$NoDivider, footerButtons: $elm$core$Maybe$Nothing, headerIconLeft: $elm$core$Maybe$Nothing, headerNote: $elm$core$Maybe$Nothing, headerStatusTag: $elm$core$Maybe$Nothing, noPadding: false, visibleOverflow: false};
var $author$project$Ui$V3$Card$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'ClassAttribute':
					var class_ = a.a;
					return _Utils_update(
						acc,
						{
							classes: A2($elm$core$List$cons, class_, acc.classes)
						});
				case 'DividersAttribute':
					var isFullWidth = a.a.isFullWidth;
					return _Utils_update(
						acc,
						{
							dividers: isFullWidth ? $author$project$Ui$V3$Card$FullWidthDividers : $author$project$Ui$V3$Card$Dividers
						});
				case 'NoPadding':
					return _Utils_update(
						acc,
						{noPadding: true});
				case 'HeaderIconLeft':
					var icon = a.a;
					return _Utils_update(
						acc,
						{
							headerIconLeft: $elm$core$Maybe$Just(icon)
						});
				case 'Collapsible':
					var collapseData = a.a;
					return _Utils_update(
						acc,
						{
							collapsible: $author$project$Ui$V3$Card$CanCollapse(collapseData)
						});
				case 'HeaderStatusTagAttribute':
					var statusTagStyle = a.a;
					var statusTagText = a.b;
					return _Utils_update(
						acc,
						{
							headerStatusTag: $elm$core$Maybe$Just(
								_Utils_Tuple2(statusTagStyle, statusTagText))
						});
				case 'HeaderNote':
					var note = a.a;
					return _Utils_update(
						acc,
						{
							headerNote: $elm$core$Maybe$Just(note)
						});
				case 'FooterButtonsAttribute':
					var html = a.a;
					return _Utils_update(
						acc,
						{
							footerButtons: $elm$core$Maybe$Just(html)
						});
				default:
					return _Utils_update(
						acc,
						{visibleOverflow: true});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Card$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Card$divider = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('v3__card-divider')
		]),
	_List_Nil);
var $author$project$Ui$V3$Card$empty = $elm$html$Html$text('');
var $author$project$Ui$V3$Card$viewWithHeader = F3(
	function (_v0, attributes, body) {
		var header = _v0.header;
		var computedAttributes = $author$project$Ui$V3$Card$computeAttributes(attributes);
		var hasDividers = !_Utils_eq(computedAttributes.dividers, $author$project$Ui$V3$Card$NoDivider);
		var isCollapsed = function () {
			var _v2 = computedAttributes.collapsible;
			if (_v2.$ === 'CanCollapse') {
				var collapseData = _v2.a;
				return collapseData.isCollapsed;
			} else {
				return false;
			}
		}();
		var children = A2(
			$elm$core$List$filter,
			function (a) {
				return !_Utils_eq(a, $author$project$Ui$V3$Card$empty);
			},
			_List_fromArray(
				[
					header,
					isCollapsed ? $author$project$Ui$V3$Card$empty : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('v3__card-body', true),
									_Utils_Tuple2('v3__card-body__no-padding', computedAttributes.noPadding),
									_Utils_Tuple2('v3__card-body__visible-overflow', computedAttributes.visibleOverflow)
								]))
						]),
					body),
					function () {
					var _v1 = computedAttributes.footerButtons;
					if (_v1.$ === 'Nothing') {
						return $author$project$Ui$V3$Card$empty;
					} else {
						var html = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__card-footer')
								]),
							_List_fromArray(
								[html]));
					}
				}()
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__card'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'v3__card--no-footer',
							_Utils_eq(computedAttributes.footerButtons, $elm$core$Maybe$Nothing)),
							_Utils_Tuple2(
							'v3__card--dividers',
							_Utils_eq(computedAttributes.dividers, $author$project$Ui$V3$Card$Dividers)),
							_Utils_Tuple2(
							'v3__card--dividers--full-width',
							_Utils_eq(computedAttributes.dividers, $author$project$Ui$V3$Card$FullWidthDividers))
						])),
					$elm$html$Html$Attributes$class(
					A2($elm$core$String$join, ' ', computedAttributes.classes))
				]),
			(hasDividers && (!isCollapsed)) ? A2($elm$core$List$intersperse, $author$project$Ui$V3$Card$divider, children) : children);
	});
var $author$project$Ui$V3$Card$view = F3(
	function (_v0, attributes, body) {
		var title = _v0.title;
		var viewStatusTag = F2(
			function (style, text) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__card-header--status-tag')
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$StatusTag$view, style, text)
						]));
			});
		var viewHeaderNote = function (note) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__card-header-note')
					]),
				_List_fromArray(
					[note]));
		};
		var spacer = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__card-header-space')
				]),
			_List_Nil);
		var computedAttributes = $author$project$Ui$V3$Card$computeAttributes(attributes);
		var headerHead = function () {
			var _v8 = computedAttributes.headerIconLeft;
			if (_v8.$ === 'Nothing') {
				return _List_fromArray(
					[
						$elm$html$Html$text(title)
					]);
			} else {
				var icon = _v8.a;
				return _List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, _List_Nil, icon),
						$elm$html$Html$text(title)
					]);
			}
		}();
		var collapsibleIndicator = function () {
			var _v6 = computedAttributes.collapsible;
			if (_v6.$ === 'NotCollapsible') {
				return $elm$core$Maybe$Nothing;
			} else {
				var isCollapsed = _v6.a.isCollapsed;
				var collapseHandlers = function () {
					var _v7 = computedAttributes.collapsible;
					if (_v7.$ === 'CanCollapse') {
						var collapseMsg = _v7.a.collapseMsg;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$Events$custom,
								'click',
								$elm$json$Json$Decode$succeed(
									{message: collapseMsg, preventDefault: true, stopPropagation: true})),
								A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
								A2($elm$html$Html$Attributes$attribute, 'role', 'button')
							]);
					} else {
						return _List_Nil;
					}
				}();
				return isCollapsed ? $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$span,
						collapseHandlers,
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$chevronUp16)
							]))) : $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$span,
						collapseHandlers,
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$chevronDown16)
							])));
			}
		}();
		var tailContent = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2($elm$core$Maybe$map, viewHeaderNote, computedAttributes.headerNote),
					collapsibleIndicator
				]));
		var headerTail = function () {
			var _v1 = _Utils_Tuple2(computedAttributes.headerStatusTag, tailContent);
			if (_v1.a.$ === 'Nothing') {
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return _List_Nil;
				} else {
					var _v4 = _v1.a;
					var tailElements = _v1.b;
					return A2($elm$core$List$cons, spacer, tailElements);
				}
			} else {
				if (!_v1.b.b) {
					var _v3 = _v1.a.a;
					var statusTagStyle = _v3.a;
					var statusTagText = _v3.b;
					return _List_fromArray(
						[
							A2(viewStatusTag, statusTagStyle, statusTagText)
						]);
				} else {
					var _v5 = _v1.a.a;
					var statusTagStyle = _v5.a;
					var statusTagText = _v5.b;
					var tailElements = _v1.b;
					return _Utils_ap(
						_List_fromArray(
							[
								A2(viewStatusTag, statusTagStyle, statusTagText),
								spacer
							]),
						tailElements);
				}
			}
		}();
		var cardHeader = A2(
			$elm$html$Html$h3,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__card-header')
				]),
			_Utils_ap(headerHead, headerTail));
		return A3(
			$author$project$Ui$V3$Card$viewWithHeader,
			{header: cardHeader},
			attributes,
			body);
	});
var $author$project$Components$DocumentTypePicker$Selected = F2(
	function (a, b) {
		return {$: 'Selected', a: a, b: b};
	});
var $author$project$Ui$V3$ActionCard$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $author$project$Ui$V3$ActionCard$customAction = function (el) {
	return $author$project$Ui$V3$ActionCard$Custom(el);
};
var $author$project$Ui$V3$ActionCard$Default = {$: 'Default'};
var $author$project$Ui$V3$ActionCard$default = $author$project$Ui$V3$ActionCard$Default;
var $author$project$Ui$V3$ActionCard$InList = {$: 'InList'};
var $author$project$Ui$V3$ActionCard$inList = $author$project$Ui$V3$ActionCard$InList;
var $author$project$Components$DocumentTypePicker$indexToKeyLabel = function (index) {
	return (index < 9) ? $elm$core$Maybe$Just(
		$elm$core$String$fromInt(index + 1)) : ((index === 9) ? $elm$core$Maybe$Just('0') : $elm$core$Maybe$Nothing);
};
var $author$project$Ui$V3$ActionCard$None = {$: 'None'};
var $author$project$Ui$V3$ActionCard$noAction = $author$project$Ui$V3$ActionCard$None;
var $author$project$Ui$V3$ActionCard$Selected = {$: 'Selected'};
var $author$project$Ui$V3$ActionCard$selected = $author$project$Ui$V3$ActionCard$Selected;
var $author$project$Ui$V3$ActionCard$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Ui$V3$ActionCard$state = function (state_) {
	return $author$project$Ui$V3$ActionCard$State(state_);
};
var $author$project$Ui$V3$ActionCard$Column = {$: 'Column'};
var $author$project$Ui$V3$ActionCard$Vertical = {$: 'Vertical'};
var $author$project$Ui$V3$ActionCard$Large = {$: 'Large'};
var $author$project$Ui$V3$ActionCard$Row = {$: 'Row'};
var $author$project$Ui$V3$ActionCard$defaultAttributes = {inList: false, orientation: $author$project$Ui$V3$ActionCard$Row, state: $author$project$Ui$V3$ActionCard$Default, textSize: $author$project$Ui$V3$ActionCard$Large};
var $author$project$Ui$V3$ActionCard$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'Orientation':
					var val = a.a;
					return _Utils_update(
						acc,
						{orientation: val});
				case 'State':
					var val = a.a;
					return _Utils_update(
						acc,
						{state: val});
				case 'TextSize':
					var val = a.a;
					return _Utils_update(
						acc,
						{textSize: val});
				default:
					return _Utils_update(
						acc,
						{inList: true});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$ActionCard$defaultAttributes, attributes);
};
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Ui$V3$ActionCard$stateToClass = function (state_) {
	switch (state_.$) {
		case 'Default':
			return 'default';
		case 'Selected':
			return 'selected';
		case 'Error':
			return 'error';
		default:
			return 'disabled';
	}
};
var $author$project$Ui$V3$ActionCard$textSizeToClass = function (textSize_) {
	switch (textSize_.$) {
		case 'Large':
			return 'large';
		case 'Mixed':
			return 'mixed';
		default:
			return 'small';
	}
};
var $author$project$Ui$V3$Colors$IconNeutralDefault = {$: 'IconNeutralDefault'};
var $author$project$Ui$V3$ActionCard$viewAction = function (action) {
	switch (action.$) {
		case 'Checkbox':
			var checked = action.a;
			return A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$checked(checked),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						$elm$html$Html$Attributes$tabindex(-1)
					]),
				_List_Nil);
		case 'Radio':
			var checked = action.a;
			return A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('radio'),
						$elm$html$Html$Attributes$checked(checked),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						$elm$html$Html$Attributes$tabindex(-1)
					]),
				_List_Nil);
		case 'Chevron':
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$IconNeutralDefault)
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$chevronRight16)
					]));
		case 'Custom':
			var el = action.a;
			return el;
		default:
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	}
};
var $author$project$Ui$V3$ActionCard$view = F2(
	function (attributes, _v0) {
		var onClick = _v0.onClick;
		var action = _v0.action;
		var description = _v0.description;
		var label = _v0.label;
		var icon = _v0.icon;
		var onClickAttrs = function () {
			if (onClick.$ === 'Just') {
				var msg = onClick.a;
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(msg)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var computedAttributes = $author$project$Ui$V3$ActionCard$computeAttributes(attributes);
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('v3__action-card', true),
							_Utils_Tuple2(
							'v3__action-card--' + $author$project$Ui$V3$ActionCard$stateToClass(computedAttributes.state),
							true),
							_Utils_Tuple2(
							'v3__action-card--text-' + $author$project$Ui$V3$ActionCard$textSizeToClass(computedAttributes.textSize),
							true),
							_Utils_Tuple2(
							'v3__action-card--vertical',
							_Utils_eq(computedAttributes.orientation, $author$project$Ui$V3$ActionCard$Vertical)),
							_Utils_Tuple2('v3__action-card--standalone', !computedAttributes.inList),
							_Utils_Tuple2('v3__action-card--in-list', computedAttributes.inList)
						])),
				onClickAttrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__action-card__icon-and-content')
						]),
					_List_fromArray(
						[
							function () {
							if (icon.$ === 'Just') {
								var i = icon.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3__action-card__icon')
										]),
									_List_fromArray(
										[i]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('v3__action-card__content', true),
											_Utils_Tuple2(
											'v3__action-card__content-column',
											_Utils_eq(computedAttributes.orientation, $author$project$Ui$V3$ActionCard$Column))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h5,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3__action-card__content--label')
										]),
									_List_fromArray(
										[label])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3__action-card__content--description')
										]),
									_List_fromArray(
										[description]))
								]))
						])),
					$author$project$Ui$V3$ActionCard$viewAction(action)
				]));
	});
var $author$project$Components$DocumentTypePicker$viewDocumentTypeRow = F3(
	function (config, index, docType) {
		var isSelected = _Utils_eq(
			$author$project$Domain$UnresolvedDocumentType$Resolved(docType.documentType),
			config.currentType);
		var stateAttr = isSelected ? $author$project$Ui$V3$ActionCard$state($author$project$Ui$V3$ActionCard$selected) : $author$project$Ui$V3$ActionCard$state($author$project$Ui$V3$ActionCard$default);
		var actionContent = function () {
			if (config.showHotkeys) {
				var _v1 = $author$project$Components$DocumentTypePicker$indexToKeyLabel(index);
				if (_v1.$ === 'Just') {
					var label = _v1.a;
					return $author$project$Ui$V3$ActionCard$customAction(
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit__document-type-picker__row-number')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])));
				} else {
					return $author$project$Ui$V3$ActionCard$noAction;
				}
			} else {
				return $author$project$Ui$V3$ActionCard$noAction;
			}
		}();
		return A2(
			$author$project$Ui$V3$ActionCard$view,
			_List_fromArray(
				[$author$project$Ui$V3$ActionCard$inList, stateAttr]),
			{
				action: actionContent,
				description: $elm$html$Html$text(''),
				icon: $elm$core$Maybe$Nothing,
				label: $elm$html$Html$text(docType.name),
				onClick: function () {
					var _v0 = config.maybeDocumentId;
					if (_v0.$ === 'Just') {
						var docId = _v0.a;
						return $elm$core$Maybe$Just(
							A2($author$project$Components$DocumentTypePicker$Selected, docId, docType.documentType));
					} else {
						return $elm$core$Maybe$Just($author$project$Components$DocumentTypePicker$Dismissed);
					}
				}()
			});
	});
var $author$project$Components$DocumentTypePicker$view = function (config) {
	var sorted = $author$project$Components$DocumentTypePicker$sortedTypes(config.enabledDocumentTypes);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__document-type-picker')
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$V3$Card$view,
				{title: 'Identify The Documents'},
				_List_fromArray(
					[
						$author$project$Ui$V3$Card$noPadding,
						$author$project$Ui$V3$Card$headerNote(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit__document-type-picker__continue-btn'),
									$elm$html$Html$Events$onClick($author$project$Components$DocumentTypePicker$Dismissed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Continue')
								])))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							$author$project$Components$DocumentTypePicker$viewDocumentTypeRow(config),
							sorted))
					]))
			]));
};
var $author$project$Components$CarrierInvoiceAuditPage$viewDocumentTypePicker = F2(
	function (data, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(data.documentsBrowserData);
		if (_v0.$ === 'Just') {
			var browserData = _v0.a;
			var browser = A2($author$project$Components$CarrierInvoiceAuditPage$browserWithDocumentTypes, data, model);
			var docInfo = A2($author$project$Components$DocumentsBrowser$selectedDocumentType, browser, browserData);
			return A2(
				$elm$html$Html$map,
				function (pickerMsg) {
					if (pickerMsg.$ === 'Selected') {
						var documentId = pickerMsg.a;
						var documentType = pickerMsg.b;
						return $author$project$Components$CarrierInvoiceAuditPage$DocumentsBrowserMsg(
							$author$project$Components$DocumentsBrowser$NonHotkeyMsg(
								A2($author$project$Components$DocumentsBrowser$UpdateDocumentType, documentId, documentType)));
					} else {
						return $author$project$Components$CarrierInvoiceAuditPage$DocumentsBrowserMsg(
							$author$project$Components$DocumentsBrowser$NonHotkeyMsg($author$project$Components$DocumentsBrowser$ToggleDocumentTypePicker));
					}
				},
				$author$project$Components$DocumentTypePicker$view(
					{currentType: docInfo.currentType, enabledDocumentTypes: browser.enabledDocumentTypes, maybeDocumentId: docInfo.maybeDocumentId, showHotkeys: true}));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Ui$V3$Button$SizeXSmall = {$: 'SizeXSmall'};
var $author$project$Components$AuditUnsavedEdits$viewStrip = F2(
	function (_v0, edits) {
		var onReview = _v0.onReview;
		if ($elm$core$List$isEmpty(edits)) {
			return $elm$html$Html$text('');
		} else {
			var describe = function (edit) {
				return $elm$html$Html$text(edit.label + (' (' + (edit.saved + (' → ' + (edit.edited + ')')))));
			};
			var count = $elm$core$List$length(edits);
			var countLabel = _Utils_ap(
				$elm$core$String$fromInt(count),
				(count === 1) ? ' unsaved change' : ' unsaved changes');
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__unsaved-strip'),
						A2($elm$html$Html$Attributes$attribute, 'role', 'status')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__unsaved-strip-icon')
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$alertTriangle16)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__unsaved-strip-text')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(countLabel)
									])),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$text(' — '),
								A2(
									$elm$core$List$intersperse,
									$elm$html$Html$text(', '),
									A2($elm$core$List$map, describe, edits))))),
						A3(
						$author$project$Ui$V3$Button$view,
						{
							action: $author$project$Ui$V3$Button$onClick(onReview)
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
								$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeXSmall)
							]),
						'Review')
					]));
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$AuditChecksMsg = function (a) {
	return {$: 'AuditChecksMsg', a: a};
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$Data = F3(
	function (tmsLoadDetails, carrier, information) {
		return {carrier: carrier, information: information, tmsLoadDetails: tmsLoadDetails};
	});
var $author$project$Components$CarrierInvoiceAuditPage$carrierOrNothing = function (remote) {
	if (remote.$ === 'Error') {
		return $author$project$Forward$Remote$Loaded($elm$core$Maybe$Nothing);
	} else {
		return remote;
	}
};
var $author$project$Components$CheckDocuments$checkDocument = F4(
	function (account, accountSettings, documentIsPodUpdates, _v0) {
		var document = _v0.a;
		var pages = _v0.b;
		return A2(
			$elm$core$Maybe$map,
			function (page) {
				return {
					documentId: document.id,
					hasDamage: document.hasDamage,
					labels: A6($author$project$Components$DocumentBrowser$Full$thumbnailLabels, document, page, 0, documentIsPodUpdates, accountSettings.runNoDocumentsHaveDamagesOrRatesRule, accountSettings.runNoDocumentsHaveCarrierRatesRule),
					pageId: page.id,
					thumbnailUrl: page.thumbnailUrl,
					title: A3(
						$author$project$Domain$Helpers$documentTypeToString,
						account,
						accountSettings,
						$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue))
				};
			},
			$elm$core$List$head(pages));
	});
var $author$project$Components$CheckDocuments$fromBrowserData = F4(
	function (account, accountSettings, documentIsPodUpdates, documentData) {
		return A2(
			$elm$core$List$filterMap,
			A3($author$project$Components$CheckDocuments$checkDocument, account, accountSettings, documentIsPodUpdates),
			A3($elm$core$List$map2, $elm$core$Tuple$pair, documentData.documents, documentData.documentPages));
	});
var $author$project$Components$CarrierInvoiceAuditPage$checkDocuments = F2(
	function (documentIsPodUpdates, remoteData) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (browserData) {
					return A4($author$project$Components$CheckDocuments$fromBrowserData, browserData.currentAccount, browserData.accountSettings, documentIsPodUpdates, browserData.documentData.browserDocumentData);
				},
				$author$project$Forward$Remote$toMaybe(remoteData)));
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$Components$UnidentifiedDocuments$isUnidentified = function (document) {
	return _Utils_eq(
		$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue),
		$author$project$Domain$UnresolvedDocumentType$Unknown);
};
var $author$project$Components$UnidentifiedDocuments$fromBrowserData = function (documentData) {
	return A2(
		$elm$core$List$map,
		function (page) {
			return {pageId: page.id, thumbnailUrl: page.thumbnailUrl};
		},
		A2(
			$elm$core$List$filterMap,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$head),
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Components$UnidentifiedDocuments$isUnidentified),
				A3($elm$core$List$map2, $elm$core$Tuple$pair, documentData.documents, documentData.documentPages))));
};
var $author$project$Components$CarrierInvoiceAuditPage$unidentifiedDocuments = function (remoteData) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.documentData;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.browserDocumentData;
					},
					$author$project$Components$UnidentifiedDocuments$fromBrowserData)),
			$author$project$Forward$Remote$toMaybe(remoteData)));
};
var $author$project$Components$CarrierInvoiceAuditPage$checksViewConfig = F2(
	function (data, model) {
		return A5(
			$elm$core$Maybe$map4,
			F4(
				function (checks, carrierInvoice, quickReview, accountSettings) {
					return {
						auditChecks: checks,
						customInvoiceExceptionMessages: accountSettings.customInvoiceExceptionMessages,
						documents: A2($author$project$Components$CarrierInvoiceAuditPage$checkDocuments, model.documentsBrowser.documentIsPodUpdates, data.documentsBrowserData),
						isEditable: carrierInvoice.isEditable,
						quickReview: quickReview,
						unidentifiedDocuments: $author$project$Components$CarrierInvoiceAuditPage$unidentifiedDocuments(data.documentsBrowserData)
					};
				}),
			$author$project$Forward$Remote$toMaybe(data.auditChecks),
			$author$project$Forward$Remote$toMaybe(data.carrierInvoice),
			$author$project$Components$CarrierInvoiceAuditPage$quickReviewValues(data),
			$author$project$Forward$Remote$toMaybe(data.accountSettings));
	});
var $author$project$Forward$Remote$map3 = F4(
	function (f, remoteA, remoteB, remoteC) {
		return A3(
			$author$project$Forward$Remote$map2,
			F2(
				function (_v0, c) {
					var a = _v0.a;
					var b = _v0.b;
					return A3(f, a, b, c);
				}),
			A3($author$project$Forward$Remote$map2, $elm$core$Tuple$pair, remoteA, remoteB),
			remoteC);
	});
var $author$project$Components$CarrierInvoiceAuditChecks$QuickReviewMsg = function (a) {
	return {$: 'QuickReviewMsg', a: a};
};
var $author$project$Components$AuditDrafts$shown = F3(
	function (key, stored, drafts) {
		var _v0 = A2($author$project$Components$AuditDrafts$draftOf, key, drafts);
		if (_v0.$ === 'FromInvoice') {
			return stored;
		} else {
			var typed = _v0.a.typed;
			return typed;
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$shownQuickReview = F3(
	function (field, stored, model) {
		return A3(
			$author$project$Components$AuditDrafts$shown,
			$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview(field),
			stored,
			model.drafts);
	});
var $author$project$Components$CarrierInvoiceAuditChecks$quickReviewConfig = F2(
	function (config, model) {
		var values = config.quickReview;
		return {
			invoiceAmountInput: A3($author$project$Components$CarrierInvoiceAuditChecks$shownQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount, values.invoiceAmount, model),
			invoiceDateInput: A3($author$project$Components$CarrierInvoiceAuditChecks$shownQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceDate, values.invoiceDate, model),
			invoiceNumberInput: A3($author$project$Components$CarrierInvoiceAuditChecks$shownQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceNumber, values.invoiceNumber, model),
			isCollapsed: model.quickReviewCollapsed,
			isEditable: config.isEditable,
			loadId: values.loadId
		};
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$CollapseClicked = {$: 'CollapseClicked'};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$Typed = {$: 'Typed'};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$displayedAmount = function (value) {
	var _v0 = $elm$core$String$toFloat(value);
	if (_v0.$ === 'Nothing') {
		return value;
	} else {
		var amount = _v0.a;
		var sign = (amount < 0) ? '-' : '';
		var cents = $elm$core$Basics$abs(
			$elm$core$Basics$round(amount * 100));
		return sign + ('$' + ($elm$core$String$fromInt((cents / 100) | 0) + ('.' + A3(
			$elm$core$String$padLeft,
			2,
			_Utils_chr('0'),
			$elm$core$String$fromInt(
				A2($elm$core$Basics$modBy, 100, cents))))));
	}
};
var $author$project$Ui$V3$Input$disabled = $author$project$Ui$V3$Input$DisabledAttribute;
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$formattedValue = F2(
	function (format, value) {
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(value)) ? '' : format(value);
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$inputTypeAttributes = function (entry) {
	if (entry.$ === 'Typed') {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[$author$project$Ui$V3$Input$date]);
	}
};
var $author$project$Ui$V3$Input$placeholder = $author$project$Ui$V3$Input$PlaceholderAttribute;
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputChanged = F2(
	function (a, b) {
		return {$: 'InputChanged', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputDisregarded = {$: 'InputDisregarded'};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$reportedValue = F2(
	function (config, value) {
		var _v0 = config.entry;
		if (_v0.$ === 'Typed') {
			return A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputChanged, config.field, value);
		} else {
			return $elm$core$String$isEmpty(value) ? $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputDisregarded : A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputChanged, config.field, value);
		}
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputSettled = F2(
	function (a, b) {
		return {$: 'InputSettled', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$settledDate = function (field) {
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (value, halfTyped) {
				return halfTyped ? $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputDisregarded : A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputSettled, field, value);
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'value']),
			$elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'validity', 'badInput']),
			$elm$json$Json$Decode$bool));
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$settleAttributes = F2(
	function (config, cleaned) {
		var _v0 = config.entry;
		if (_v0.$ === 'Typed') {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Events$on,
					'blur',
					$elm$json$Json$Decode$succeed(
						A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$InputSettled, config.field, cleaned)))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Events$on,
					'blur',
					$author$project$Components$CarrierInvoiceAuditQuickReviewFields$settledDate(config.field))
				]);
		}
	});
var $author$project$Components$AuditCheckCard$collapsedAttrs = function (isExpanded) {
	return isExpanded ? _List_Nil : _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'inert', ''),
			A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
		]);
};
var $author$project$Components$AuditQuickReviewCard$viewField = F3(
	function (_v0, title, body) {
		var isCollapsed = _v0.isCollapsed;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('invoice-audit-quick-review__field', true),
							_Utils_Tuple2('invoice-audit-quick-review__field--open', !isCollapsed)
						]))
				]),
			_List_fromArray(
				[
					title,
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('invoice-audit-quick-review__field-body-wrapper', true),
									_Utils_Tuple2('invoice-audit-quick-review__field-body-wrapper--expanded', !isCollapsed)
								])),
						$author$project$Components$AuditCheckCard$collapsedAttrs(!isCollapsed)),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit-quick-review__field-body-clip')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invoice-audit-quick-review__field-body')
										]),
									body)
								]))
						]))
				]));
	});
var $author$project$Components$AuditQuickReviewCard$viewFieldTitle = F3(
	function (attributes, label, content) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('invoice-audit-quick-review__field-title'),
				attributes),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit-quick-review__field-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
				content));
	});
var $author$project$Components$AuditQuickReviewCard$viewFieldValue = function (displayed) {
	return $elm$core$String$isEmpty(displayed) ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit-quick-review__field-value'),
				$elm$html$Html$Attributes$class('invoice-audit-quick-review__field-value--missing')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Missing')
			])) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit-quick-review__field-value'),
				$elm$html$Html$Attributes$title(displayed)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(displayed)
			]));
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewFieldTitle = F3(
	function (label, displayed, controls) {
		return A3(
			$author$project$Components$AuditQuickReviewCard$viewFieldTitle,
			_List_Nil,
			label,
			A2(
				$elm$core$List$cons,
				$author$project$Components$AuditQuickReviewCard$viewFieldValue(displayed),
				controls));
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$FindClicked = function (a) {
	return {$: 'FindClicked', a: a};
};
var $author$project$Components$AuditQuickReviewCard$viewFindButton = function (_v0) {
	var onFind = _v0.onFind;
	var lookup = _v0.lookup;
	var label = _v0.label;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn'),
				$elm$html$Html$Attributes$class('invoice-audit-quick-review__field-title-find'),
				$elm$html$Html$Attributes$title('Show ' + (label + ' on document')),
				$elm$html$Html$Attributes$disabled(
				$elm$core$String$isEmpty(
					$elm$core$String$trim(lookup))),
				$elm$html$Html$Events$onClick(
				onFind(lookup))
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
			]));
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewFindButton = F2(
	function (label, value) {
		return $author$project$Components$AuditQuickReviewCard$viewFindButton(
			{label: label, lookup: value, onFind: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$FindClicked});
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewEditableField = function (config) {
	var cleaned = config.clean(config.typed);
	return A3(
		$author$project$Components$AuditQuickReviewCard$viewField,
		{isCollapsed: config.isCollapsed},
		A3(
			$author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewFieldTitle,
			config.label,
			A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$formattedValue, config.formatValue, cleaned),
			_List_fromArray(
				[
					A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewFindButton, config.label, cleaned)
				])),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit-check__input-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit-check__input')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$reportedValue(config)
								},
								A2(
									$elm$core$List$cons,
									$author$project$Ui$V3$Input$placeholder(config.placeholder),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$V3$Input$disabled(!config.isEditable),
										$author$project$Components$CarrierInvoiceAuditQuickReviewFields$inputTypeAttributes(config.entry))),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-label', config.label),
									A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$settleAttributes, config, cleaned)),
								config.typed)
							]))
					]))
			]));
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewAmountField = function (config) {
	return $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewEditableField(
		{clean: $author$project$Domain$Amount$cleaned, entry: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$Typed, field: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount, formatValue: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$displayedAmount, isCollapsed: config.isCollapsed, isEditable: config.isEditable, label: 'Amount', placeholder: 'Enter invoice amount', typed: config.invoiceAmountInput});
};
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $author$project$Ui$V3$Icon$checkCircle16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth('1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$polyline,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$points('8.95710678 4.56801948 9.66421356 10.9319805 6.83578644 10.9319805'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$transform('translate(8.250000, 7.750000) rotate(-315.000000) translate(-8.250000, -7.750000) ')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('8'),
						$elm$svg$Svg$Attributes$cy('8'),
						$elm$svg$Svg$Attributes$r('7'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2')
					]),
				_List_Nil)
			])));
var $author$project$Components$AuditQuickReviewCard$viewHeader = F2(
	function (isCollapsed, onToggle) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('invoice-audit-quick-review__header'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-expanded',
					isCollapsed ? 'false' : 'true'),
					$elm$html$Html$Events$onClick(onToggle)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit-quick-review__icon')
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$checkCircle16)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit-quick-review__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Quick Review')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit-quick-review__chevron')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Icon$view16,
							_List_Nil,
							isCollapsed ? $author$project$Ui$V3$Icon$chevronRight16 : $author$project$Ui$V3$Icon$chevronDown16)
						]))
				]));
	});
var $author$project$Components$AuditQuickReviewCard$viewCard = F2(
	function (_v0, fields) {
		var onToggle = _v0.onToggle;
		var isCollapsed = _v0.isCollapsed;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('invoice-audit-quick-review', true),
							_Utils_Tuple2('invoice-audit-quick-review--collapsed', isCollapsed)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Components$AuditQuickReviewCard$viewHeader, isCollapsed, onToggle),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit-quick-review__fields')
						]),
					fields)
				]));
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$Picked = {$: 'Picked'};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$displayedDate = function (value) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(value);
	if (_v0.$ === 'Ok') {
		var date = _v0.a;
		return A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
	} else {
		return value;
	}
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewDateField = function (config) {
	return $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewEditableField(
		{clean: $elm$core$Basics$identity, entry: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$Picked, field: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceDate, formatValue: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$displayedDate, isCollapsed: config.isCollapsed, isEditable: config.isEditable, label: 'Date', placeholder: 'Enter invoice date', typed: config.invoiceDateInput});
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewTitleOnlyField = F3(
	function (label, displayed, controls) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit-quick-review__field'),
					$elm$html$Html$Attributes$class('ci-audit-quick-review__field--title-only')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewFieldTitle, label, displayed, controls)
				]));
	});
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewLoadIdField = function (config) {
	return A3(
		$author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewTitleOnlyField,
		'Load ID',
		A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$formattedValue, $elm$core$Basics$identity, config.loadId),
		_List_fromArray(
			[
				A2($author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewFindButton, 'Load ID', config.loadId)
			]));
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewNumberField = function (config) {
	return $author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewEditableField(
		{clean: $elm$core$Basics$identity, entry: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$Typed, field: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceNumber, formatValue: $elm$core$Basics$identity, isCollapsed: config.isCollapsed, isEditable: config.isEditable, label: 'Number', placeholder: 'Enter invoice number', typed: config.invoiceNumberInput});
};
var $author$project$Components$CarrierInvoiceAuditQuickReviewFields$view = function (config) {
	return A2(
		$author$project$Components$AuditQuickReviewCard$viewCard,
		{isCollapsed: config.isCollapsed, onToggle: $author$project$Components$CarrierInvoiceAuditQuickReviewFields$CollapseClicked},
		_List_fromArray(
			[
				$author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewLoadIdField(config),
				$author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewNumberField(config),
				$author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewAmountField(config),
				$author$project$Components$CarrierInvoiceAuditQuickReviewFields$viewDateField(config)
			]));
};
var $author$project$Components$AuditCheckCard$Failing = {$: 'Failing'};
var $author$project$Components$CarrierInvoiceAuditChecks$ToggleCheck = function (a) {
	return {$: 'ToggleCheck', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$eventTitle = function (event) {
	return A2($elm$core$Maybe$withDefault, '', event.message);
};
var $author$project$Components$CarrierInvoiceAuditChecks$namesDocuments = function (checkType) {
	var _v0 = checkType.check;
	if (_v0.$ === 'CarrierInvoiceAuditCheckType_Check_DocumentsRequiredCheck') {
		var requiredDocumentTypes = _v0.a.requiredDocumentTypes;
		return !$elm$core$List$isEmpty(requiredDocumentTypes);
	} else {
		return false;
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$failureMessages = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		return $author$project$Components$CarrierInvoiceAuditChecks$namesDocuments(ruleCheck.checkType) ? _List_Nil : A2(
			$elm$core$List$map,
			function ($) {
				return $.message;
			},
			ruleCheck.failures);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$title = function (checkType) {
	var _v0 = checkType.check;
	switch (_v0.$) {
		case 'CarrierInvoiceAuditCheckType_Check_OtherCheck':
			return 'Other Checks';
		case 'CarrierInvoiceAuditCheckType_Check_DocumentsRequiredCheck':
			var documentsRequired = _v0.a;
			return documentsRequired.title;
		case 'CarrierInvoiceAuditCheckType_Check_OsdCheck':
			return 'OS&D';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierRateCheck':
			return 'Carrier Rate';
		case 'CarrierInvoiceAuditCheckType_Check_DocumentReviewCheck':
			return 'Document Review';
		case 'CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck':
			return 'Extracted Reference Values';
		case 'CarrierInvoiceAuditCheckType_Check_LoadMatchCheck':
			return 'Load Match';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceAmountCheck':
			return 'Invoice Amount';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierMatchCheck':
			return 'Carrier Match';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceDuplicateInvoiceCheck':
			return 'Duplicate Invoice';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceDateCheck':
			return 'Invoice Date';
		case 'CarrierInvoiceAuditCheckType_Check_CustomExceptionMessageCheck':
			return 'Custom Exception Messages';
		case 'CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck':
			return 'Label Exceptions';
		case 'CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck':
			var reference = _v0.a.reference;
			return reference + ' reference';
		default:
			return 'Customer Instructions';
	}
};
var $author$project$Components$AuditCheckCard$titleWithLoneMessage = F2(
	function (baseTitle, failureMessages) {
		if (failureMessages.b && (!failureMessages.b.b)) {
			var only = failureMessages.a;
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(only)) ? baseTitle : (baseTitle + (' — ' + only));
		} else {
			return baseTitle;
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$headerTitle = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		var _v1 = _Utils_Tuple2(
			ruleCheck.checkType.check,
			$author$project$Components$CarrierInvoiceAuditChecks$failureMessages(check));
		_v1$6:
		while (true) {
			switch (_v1.a.$) {
				case 'CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck':
					if (_v1.b.b && (!_v1.b.b.b)) {
						var _v2 = _v1.b;
						var only = _v2.a;
						return only;
					} else {
						break _v1$6;
					}
				case 'CarrierInvoiceAuditCheckType_Check_CustomExceptionMessageCheck':
					var message = _v1.a.a.message;
					return $elm$core$String$isEmpty(message) ? $author$project$Components$CarrierInvoiceAuditChecks$title(ruleCheck.checkType) : message;
				case 'CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck':
					var labelRuleFailure = _v1.a.a;
					return $elm$core$String$isEmpty(labelRuleFailure.title) ? $author$project$Components$CarrierInvoiceAuditChecks$title(ruleCheck.checkType) : labelRuleFailure.title;
				case 'CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck':
					var message = _v1.a.a.message;
					return $elm$core$String$isEmpty(message) ? $author$project$Components$CarrierInvoiceAuditChecks$title(ruleCheck.checkType) : message;
				case 'CarrierInvoiceAuditCheckType_Check_CarrierRateCheck':
					var messages = _v1.b;
					return A2($author$project$Components$AuditCheckCard$titleWithLoneMessage, 'Carrier Rate Detected In Customer Documents', messages);
				case 'CarrierInvoiceAuditCheckType_Check_CustomerInstructionsCheck':
					return $author$project$Components$CarrierInvoiceAuditChecks$title(ruleCheck.checkType);
				default:
					break _v1$6;
			}
		}
		var messages = _v1.b;
		return ($author$project$Components$CarrierInvoiceAuditChecks$namesDocuments(ruleCheck.checkType) && (!$elm$core$List$isEmpty(ruleCheck.failures))) ? ('Missing ' + $author$project$Components$CarrierInvoiceAuditChecks$title(ruleCheck.checkType)) : A2(
			$author$project$Components$AuditCheckCard$titleWithLoneMessage,
			$author$project$Components$CarrierInvoiceAuditChecks$title(ruleCheck.checkType),
			messages);
	} else {
		var event = _v0.a;
		return $author$project$Components$CarrierInvoiceAuditChecks$eventTitle(event);
	}
};
var $author$project$Components$AuditCheckCard$cardStateClass = function (state) {
	if (state.$ === 'Just') {
		switch (state.a.$) {
			case 'Failing':
				var _v1 = state.a;
				return 'failing';
			case 'AllIgnored':
				var _v2 = state.a;
				return 'ignored';
			case 'AllConfirmed':
				var _v3 = state.a;
				return 'resolved';
			default:
				var _v4 = state.a;
				return 'resolved';
		}
	} else {
		return 'ignored';
	}
};
var $author$project$Components$AuditCheckCard$statusChip = function (state) {
	if (state.$ === 'Just') {
		switch (state.a.$) {
			case 'AtLeastOneResolved':
				var _v1 = state.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__chip invoice-audit__chip--resolved')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Resolved')
							]))
					]);
			case 'AllIgnored':
				var _v2 = state.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__chip invoice-audit__chip--ignored')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Resolved')
							]))
					]);
			case 'AllConfirmed':
				var _v3 = state.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__chip invoice-audit__chip--resolved')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirmed')
							]))
					]);
			default:
				var _v4 = state.a;
				return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$AuditCheckCard$unsavedChip = function (hasUnsavedEdit) {
	return hasUnsavedEdit ? _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__chip invoice-audit__chip--unsaved')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unsaved')
				]))
		]) : _List_Nil;
};
var $author$project$Components$AuditCheckCard$viewCard = F2(
	function (_v0, body) {
		var hasUnsavedEdit = _v0.hasUnsavedEdit;
		var state = _v0.state;
		var onToggle = _v0.onToggle;
		var isExpanded = _v0.isExpanded;
		var title = _v0.title;
		var chevron = isExpanded ? $author$project$Ui$V3$Icon$chevronDown16 : $author$project$Ui$V3$Icon$chevronRight16;
		var headerChildren = A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__failed-chevron')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, _List_Nil, chevron)
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$V3$Typography$smallBodySemiBold,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__failed-title')
						]),
					title),
				_Utils_ap(
					$author$project$Components$AuditCheckCard$statusChip(state),
					$author$project$Components$AuditCheckCard$unsavedChip(hasUnsavedEdit))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'invoice-audit__failed-card invoice-audit__failed-card--' + $author$project$Components$AuditCheckCard$cardStateClass(state),
							true),
							_Utils_Tuple2(
							'invoice-audit__failed-card--unsaved',
							hasUnsavedEdit && (!_Utils_eq(
								state,
								$elm$core$Maybe$Just($author$project$Components$AuditCheckCard$Failing))))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__failed-header'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'aria-expanded',
							isExpanded ? 'true' : 'false'),
							$elm$html$Html$Events$onClick(onToggle)
						]),
					headerChildren),
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('invoice-audit__failed-body-wrapper', true),
									_Utils_Tuple2('invoice-audit__failed-body-wrapper--expanded', isExpanded)
								])),
						$author$project$Components$AuditCheckCard$collapsedAttrs(isExpanded)),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit__failed-body-clip')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invoice-audit__failed-body')
										]),
									_List_fromArray(
										[body]))
								]))
						]))
				]));
	});
var $author$project$Components$AuditCheckCard$viewActiveFailureRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__resolved-row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__resolved-now'),
						$elm$html$Html$Attributes$title('Failing')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$error16)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__active-failure')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]));
};
var $author$project$Components$AuditCheckCard$viewActiveFailureMessages = function (messages) {
	return ($elm$core$List$length(messages) < 2) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, $author$project$Components$AuditCheckCard$viewActiveFailureRow, messages));
};
var $author$project$Components$CarrierInvoiceAuditChecks$IgnoreFailureClicked = function (a) {
	return {$: 'IgnoreFailureClicked', a: a};
};
var $author$project$Ui$V3$Button$SizeMedium = {$: 'SizeMedium'};
var $author$project$Components$AuditCheckActions$buttonSize = $author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium);
var $author$project$Ui$V3$Button$DisabledWhileLoadingAttribute = function (a) {
	return {$: 'DisabledWhileLoadingAttribute', a: a};
};
var $author$project$Ui$V3$Button$disabledWhileLoading = $author$project$Ui$V3$Button$DisabledWhileLoadingAttribute;
var $author$project$Components$CarrierInvoiceAuditCheckActions$viewIgnoreButton = F3(
	function (onIgnore, isInFlight, failures) {
		var _v0 = A2(
			$elm$core$List$filter,
			function ($) {
				return $.ignorable;
			},
			failures);
		if (!_v0.b) {
			return $elm$html$Html$text('');
		} else {
			var first = _v0.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__action-end')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$V3$Button$view,
						{
							action: $author$project$Ui$V3$Button$onClick(
								onIgnore(first.id))
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
								$author$project$Components$AuditCheckActions$buttonSize,
								$author$project$Ui$V3$Button$disabledWhileLoading(
								isInFlight(first.id))
							]),
						'Ignore')
					]));
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewCheckActions = F4(
	function (config, model, check, leadingActions) {
		var _v0 = _Utils_Tuple2(config.isEditable, check.details);
		if (_v0.a && (_v0.b.$ === 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck')) {
			var ruleCheck = _v0.b.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__check-actions')
						]),
					_Utils_ap(
						leadingActions,
						_List_fromArray(
							[
								A3(
								$author$project$Components$CarrierInvoiceAuditCheckActions$viewIgnoreButton,
								$author$project$Components$CarrierInvoiceAuditChecks$IgnoreFailureClicked,
								function (id) {
									return _Utils_eq(
										model.ignoreInFlight,
										$elm$core$Maybe$Just(
											$author$project$Components$CarrierInvoiceAuditChecks$Ignoring(id)));
								},
								ruleCheck.failures)
							])))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$DocumentThumbnailClicked = function (a) {
	return {$: 'DocumentThumbnailClicked', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$ExceptionEventMsg = F2(
	function (a, b) {
		return {$: 'ExceptionEventMsg', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditChecks$amountEditedFrom = F3(
	function (field, config, model) {
		var saved = A2($author$project$Components$CarrierInvoiceAuditChecks$storedValue, field, config.quickReview);
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Components$AuditUnsavedEdits$showAmount(saved)),
			A3(
				$author$project$Components$AuditDrafts$unsaved,
				$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview(field),
				saved,
				model.drafts));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$AmountFieldChanged = F2(
	function (a, b) {
		return {$: 'AmountFieldChanged', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditChecks$FindClicked = function (a) {
	return {$: 'FindClicked', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$RevertClicked = function (a) {
	return {$: 'RevertClicked', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$amountToPayField = F2(
	function (amount, editedFrom) {
		return {
			editedFrom: editedFrom,
			label: 'Amount to Pay',
			lookup: $author$project$Domain$Amount$cleaned(amount),
			onFind: $author$project$Components$CarrierInvoiceAuditChecks$FindClicked,
			onInput: $author$project$Components$CarrierInvoiceAuditChecks$AmountFieldChanged($author$project$Components$CarrierInvoiceAuditQuickReviewFields$AmountToPay),
			onRevert: $author$project$Components$CarrierInvoiceAuditChecks$RevertClicked(
				$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview($author$project$Components$CarrierInvoiceAuditQuickReviewFields$AmountToPay)),
			placeholder: 'Enter amount to pay',
			value: amount
		};
	});
var $author$project$Components$CarrierInvoiceAuditChecks$ExtractedFieldChanged = F2(
	function (a, b) {
		return {$: 'ExtractedFieldChanged', a: a, b: b};
	});
var $author$project$Components$CarrierInvoiceAuditChecks$InputDropMsg = function (a) {
	return {$: 'InputDropMsg', a: a};
};
var $author$project$Components$DragDrop$DragOver = function (a) {
	return {$: 'DragOver', a: a};
};
var $author$project$Components$DragDrop$Drop = function (a) {
	return {$: 'Drop', a: a};
};
var $author$project$Components$DragDrop$dropAttributes = function (dropId) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$Events$custom,
			'drop',
			$elm$json$Json$Decode$succeed(
				{
					message: $author$project$Components$DragDrop$Drop(dropId),
					preventDefault: true,
					stopPropagation: true
				})),
			A2(
			$elm$html$Html$Events$custom,
			'dragover',
			$elm$json$Json$Decode$succeed(
				{
					message: $author$project$Components$DragDrop$DragOver(dropId),
					preventDefault: true,
					stopPropagation: true
				}))
		]);
};
var $author$project$Components$CarrierInvoiceAuditChecks$shownExtracted = F2(
	function (model, field) {
		return A3(
			$author$project$Components$AuditDrafts$shown,
			$author$project$Components$CarrierInvoiceAuditDrafts$Extracted(field.name),
			field.value,
			model.drafts);
	});
var $author$project$Components$CarrierInvoiceAuditChecks$extractedFieldInput = F3(
	function (isEditable, model, field) {
		return {
			dropTarget: isEditable ? A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map($author$project$Components$CarrierInvoiceAuditChecks$InputDropMsg),
				$author$project$Components$DragDrop$dropAttributes(
					$author$project$Components$CarrierInvoiceAuditDrafts$Extracted(field.name))) : _List_Nil,
			editedFrom: isEditable ? A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(
					$author$project$Components$AuditUnsavedEdits$showText(field.value)),
				A2($author$project$Components$CarrierInvoiceAuditChecks$unsavedExtracted, model, field)) : $elm$core$Maybe$Nothing,
			label: field.label,
			onFind: $author$project$Components$CarrierInvoiceAuditChecks$FindClicked,
			onInput: $author$project$Components$CarrierInvoiceAuditChecks$ExtractedFieldChanged(field.name),
			onRevert: $author$project$Components$CarrierInvoiceAuditChecks$RevertClicked(
				$author$project$Components$CarrierInvoiceAuditDrafts$Extracted(field.name)),
			required: field.required,
			value: isEditable ? A2($author$project$Components$CarrierInvoiceAuditChecks$shownExtracted, model, field) : field.value
		};
	});
var $author$project$Components$CarrierInvoiceAuditChecks$settledExtractedField = F2(
	function (model, field) {
		return {
			name: field.name,
			stored: field.value,
			typed: A2($author$project$Components$CarrierInvoiceAuditChecks$shownExtracted, model, field)
		};
	});
var $author$project$Ui$V3$Input$ErrorAttribute = function (a) {
	return {$: 'ErrorAttribute', a: a};
};
var $author$project$Ui$V3$Input$error = $author$project$Ui$V3$Input$ErrorAttribute;
var $author$project$Ui$V3$Input$LabelAttribute = function (a) {
	return {$: 'LabelAttribute', a: a};
};
var $author$project$Ui$V3$Input$label = $author$project$Ui$V3$Input$LabelAttribute;
var $author$project$Components$AuditUnsavedValue$unsavedClass = function (editedFrom) {
	return $elm$html$Html$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'invoice-audit-check__input--unsaved',
				!_Utils_eq(editedFrom, $elm$core$Maybe$Nothing))
			]));
};
var $author$project$Components$AuditUnsavedValue$view = function (_v0) {
	var onRevert = _v0.onRevert;
	var editedFrom = _v0.editedFrom;
	if (editedFrom.$ === 'Just') {
		var saved = editedFrom.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit-check__unsaved-note')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Saved value: ' + saved)
						])),
					A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(onRevert)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
							$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeXSmall)
						]),
					'Revert')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$ExtractedFieldInputs$visibleLabel = function (field) {
	return field.required ? field.label : (field.label + ' (optional)');
};
var $author$project$Components$ExtractedFieldInputs$viewField = F2(
	function (isEditable, field) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ci-audit-check__field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('invoice-audit-check__input-row'),
						field.dropTarget),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit-check__input'),
									$author$project$Components$AuditUnsavedValue$unsavedClass(field.editedFrom)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$V3$Input$view,
									{onInput: field.onInput},
									_List_fromArray(
										[
											$author$project$Ui$V3$Input$label(
											$author$project$Components$ExtractedFieldInputs$visibleLabel(field)),
											$author$project$Ui$V3$Input$placeholder('Enter ' + field.label),
											$author$project$Ui$V3$Input$disabled(!isEditable),
											$author$project$Ui$V3$Input$error(
											isEditable && (field.required && $elm$core$String$isEmpty(
												$elm$core$String$trim(field.value))))
										]),
									_List_Nil,
									field.value),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn'),
											$elm$html$Html$Attributes$title('Show on document'),
											$elm$html$Html$Attributes$disabled(
											$elm$core$String$isEmpty(
												$elm$core$String$trim(field.value))),
											$elm$html$Html$Events$onClick(
											field.onFind(field.value))
										]),
									_List_fromArray(
										[
											A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
										]))
								]))
						])),
					$author$project$Components$AuditUnsavedValue$view(
					{editedFrom: field.editedFrom, onRevert: field.onRevert})
				]));
	});
var $author$project$Components$ExtractedFieldInputs$view = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ci-audit-check__field-remedy')
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$ExtractedFieldInputs$viewField(config.isEditable),
			config.fields));
};
var $author$project$Components$CarrierInvoiceAuditChecks$ExtractedFieldsSettled = function (a) {
	return {$: 'ExtractedFieldsSettled', a: a};
};
var $author$project$Components$AuditCheckActions$viewPrimaryButton = function (_v0) {
	var onClick = _v0.onClick;
	var label = _v0.label;
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick(onClick)
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantPrimary),
				$author$project$Components$AuditCheckActions$buttonSize
			]),
		label);
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewSaveFieldsButton = function (fields) {
	return $author$project$Components$AuditCheckActions$viewPrimaryButton(
		{
			label: 'Save Values',
			onClick: $author$project$Components$CarrierInvoiceAuditChecks$ExtractedFieldsSettled(fields)
		});
};
var $author$project$Components$CarrierInvoiceAuditChecks$extractedFieldsRemedy = F3(
	function (isEditable, model, fields) {
		return {
			actions: _List_fromArray(
				[
					$author$project$Components$CarrierInvoiceAuditChecks$viewSaveFieldsButton(
					A2(
						$elm$core$List$map,
						$author$project$Components$CarrierInvoiceAuditChecks$settledExtractedField(model),
						fields))
				]),
			body: _List_fromArray(
				[
					$author$project$Components$ExtractedFieldInputs$view(
					{
						fields: A2(
							$elm$core$List$map,
							A2($author$project$Components$CarrierInvoiceAuditChecks$extractedFieldInput, isEditable, model),
							fields),
						isEditable: isEditable
					})
				])
		};
	});
var $author$project$Components$CarrierInvoiceAuditChecks$invoiceAmountField = F2(
	function (amount, editedFrom) {
		return {
			editedFrom: editedFrom,
			label: 'Invoice Amount',
			lookup: $author$project$Domain$Amount$cleaned(amount),
			onFind: $author$project$Components$CarrierInvoiceAuditChecks$FindClicked,
			onInput: $author$project$Components$CarrierInvoiceAuditChecks$AmountFieldChanged($author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount),
			onRevert: $author$project$Components$CarrierInvoiceAuditChecks$RevertClicked(
				$author$project$Components$CarrierInvoiceAuditDrafts$QuickReview($author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount)),
			placeholder: 'Enter invoice amount',
			value: amount
		};
	});
var $author$project$Components$AmountFields$viewField = F2(
	function (isEditable, field) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ci-audit-check__field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit-check__input-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit-check__input'),
									$author$project$Components$AuditUnsavedValue$unsavedClass(field.editedFrom)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$V3$Input$view,
									{onInput: field.onInput},
									_List_fromArray(
										[
											$author$project$Ui$V3$Input$label(field.label),
											$author$project$Ui$V3$Input$placeholder(field.placeholder),
											$author$project$Ui$V3$Input$disabled(!isEditable)
										]),
									_List_Nil,
									field.value),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn'),
											$elm$html$Html$Attributes$title('Show on document'),
											$elm$html$Html$Attributes$disabled(
											$elm$core$String$isEmpty(
												$elm$core$String$trim(field.lookup))),
											$elm$html$Html$Events$onClick(
											field.onFind(field.lookup))
										]),
									_List_fromArray(
										[
											A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
										]))
								]))
						])),
					$author$project$Components$AuditUnsavedValue$view(
					{editedFrom: field.editedFrom, onRevert: field.onRevert})
				]));
	});
var $author$project$Components$AmountFields$view = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ci-audit-check__field-remedy')
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$AmountFields$viewField(config.isEditable),
			config.fields));
};
var $author$project$Components$DocumentThumbnail$viewWithLabels = F3(
	function (_v0, labels, attributes) {
		var selected = _v0.selected;
		var title = _v0.title;
		var thumbnailUrl = _v0.thumbnailUrl;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('document-thumbnail__page-container document-thumbnail-card'),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('document-thumbnail__page', true),
									_Utils_Tuple2('document-thumbnail__page--selected', selected)
								])),
							$elm$html$Html$Attributes$src(
							A2($elm$core$Maybe$withDefault, '', thumbnailUrl)),
							A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous')
						]),
					_List_Nil),
					labels,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-thumbnail__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]))
				]));
	});
var $author$project$Components$CheckDocuments$viewDocument = F2(
	function (onSelect, document) {
		return A3(
			$author$project$Components$DocumentThumbnail$viewWithLabels,
			{selected: false, thumbnailUrl: document.thumbnailUrl, title: document.title},
			A2($elm$html$Html$map, $elm$core$Basics$never, document.labels),
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					onSelect(document.pageId))
				]));
	});
var $author$project$Components$CheckDocuments$view = F2(
	function (onSelect, documents) {
		if (!documents.b) {
			return $elm$html$Html$text('');
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__document-grid')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Components$CheckDocuments$viewDocument(onSelect),
					documents));
		}
	});
var $author$project$Components$DocumentThumbnail$view = function (_v0) {
	var podTag = _v0.podTag;
	var selected = _v0.selected;
	var title = _v0.title;
	var thumbnailUrl = _v0.thumbnailUrl;
	return A2(
		$author$project$Components$DocumentThumbnail$viewWithLabels,
		{selected: selected, thumbnailUrl: thumbnailUrl, title: title},
		podTag ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-thumbnail__page-label-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$StatusTag$view,
					_List_fromArray(
						[$author$project$Ui$V3$StatusTag$successStyle, $author$project$Ui$V3$StatusTag$smallSize, $author$project$Ui$V3$StatusTag$subtleEmphasis]),
					'POD')
				])) : $elm$html$Html$text(''));
};
var $author$project$Components$UnidentifiedDocuments$viewDocument = F2(
	function (onSelect, document) {
		return A2(
			$author$project$Components$DocumentThumbnail$view,
			{podTag: false, selected: false, thumbnailUrl: document.thumbnailUrl, title: 'Unknown'},
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					onSelect(document.pageId))
				]));
	});
var $author$project$Components$UnidentifiedDocuments$view = F2(
	function (onSelect, documents) {
		if (!documents.b) {
			return $elm$html$Html$text('');
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__document-grid')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Components$UnidentifiedDocuments$viewDocument(onSelect),
					documents));
		}
	});
var $author$project$Components$AuditFailedCheckExceptionEvent$ResolutionInputChanged = function (a) {
	return {$: 'ResolutionInputChanged', a: a};
};
var $author$project$Components$AuditFailedCheckExceptionEvent$ResolveClicked = function (a) {
	return {$: 'ResolveClicked', a: a};
};
var $author$project$Ui$V3$Input$NodeAttribute = function (a) {
	return {$: 'NodeAttribute', a: a};
};
var $author$project$Ui$V3$Input$expandable = $author$project$Ui$V3$Input$NodeAttribute('textarea');
var $author$project$Components$AuditFailedCheckExceptionEvent$viewBody = F2(
	function (exceptionEvent, resolutionInput) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
					$author$project$Ui$V3$Stack$crossAxisLeft
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Ui$V3$Input$view,
					{onInput: $author$project$Components$AuditFailedCheckExceptionEvent$ResolutionInputChanged},
					_List_fromArray(
						[
							$author$project$Ui$V3$Input$label('Resolution'),
							$author$project$Ui$V3$Input$expandable,
							$author$project$Ui$V3$Input$placeholder('Enter resolution message')
						]),
					_List_Nil,
					resolutionInput),
					$author$project$Components$AuditCheckActions$viewPrimaryButton(
					{
						label: 'Resolve Exception',
						onClick: $author$project$Components$AuditFailedCheckExceptionEvent$ResolveClicked(exceptionEvent.id)
					})
				]));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewCustomerInstructionsGroup = function (_v0) {
	var instructions = _v0.instructions;
	var customerName = _v0.customerName;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__customer-instructions')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-field-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(customerName)
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__customer-instructions-list')
					]),
				A2(
					$elm$core$List$map,
					function (instruction) {
						return A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(instruction)
								]));
					},
					instructions))
			]));
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewCustomerInstructions = function (customers) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		A2($elm$core$List$map, $author$project$Components$CarrierInvoiceAuditChecks$viewCustomerInstructionsGroup, customers));
};
var $author$project$Components$CarrierInvoiceAuditChecks$describeLabelingRule = function (_v0) {
	var category = _v0.category;
	var kind = _v0.kind;
	switch (kind.$) {
		case 'LabelingRuleKindUnrecorded':
			return 'Not recorded';
		case 'LabelingRuleKindLoadReference':
			return 'Load reference';
		case 'LabelingRuleKindShipmentReference':
			return 'Shipment reference';
		case 'LabelingRuleKindCustomerReference':
			return 'Customer reference';
		case 'LabelingRuleKindReferenceCategory':
			return category + ' reference category';
		case 'LabelingRuleKindLoadCustomerList':
			return 'Load\u0027s customer on a customer label list';
		case 'LabelingRuleKindLoadPeople':
			return 'People on the load';
		case 'LabelingRuleKindLoadOffice':
			return 'Load office';
		case 'LabelingRuleKindLoadBusinessUnit':
			return 'Load business unit';
		case 'LabelingRuleKindLoadPriority':
			return 'Load priority';
		case 'LabelingRuleKindLoadMode':
			return 'Load mode';
		case 'LabelingRuleKindLoadDaysToPay':
			return 'Load days to pay';
		case 'LabelingRuleKindLoadQuickpay':
			return 'QuickPay load';
		case 'LabelingRuleKindLoadMultiDrop':
			return 'Multi-drop load';
		case 'LabelingRuleKindLoadMultiLeg':
			return 'Multi-leg load';
		case 'LabelingRuleKindLoadIdPrefix':
			return 'Load ID prefix';
		case 'LabelingRuleKindAuditBilling':
			return 'Unpaid or unbilled invoice';
		case 'LabelingRuleKindTonu':
			return 'TONU invoice';
		case 'LabelingRuleKindLtlPayables':
			return 'LTL re-rating';
		case 'LabelingRuleKindInvoiceException':
			return 'Invoice exceptions';
		case 'LabelingRuleKindEmail':
			return 'Invoice email';
		case 'LabelingRuleKindReplyParent':
			return 'Email this one replies to';
		case 'LabelingRuleKindDocumentTemplate':
			return 'Document template';
		case 'LabelingRuleKindLargeBatch':
			return 'Large batch';
		case 'LabelingRuleKindNoDocuments':
			return 'Email with no documents';
		case 'LabelingRuleKindSubmission':
			return 'Invoice submission';
		case 'LabelingRuleKindManual':
			return 'Added by hand';
		case 'LabelingRuleKindAdHoc':
			return 'Ad Hoc';
		default:
			return 'Carrier';
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$labelGroups = function (labelingRules) {
	return A2(
		$elm$core$List$map,
		function (_v1) {
			var _v2 = _v1.a;
			var label = _v2.a;
			var rules = _v2.b;
			var rest = _v1.b;
			return {
				labels: A2(
					$elm$core$List$cons,
					label,
					A2($elm$core$List$map, $elm$core$Tuple$first, rest)),
				rules: rules
			};
		},
		A2(
			$elm_community$list_extra$List$Extra$gatherEqualsBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				$elm$core$List$sortBy($author$project$Components$CarrierInvoiceAuditChecks$describeLabelingRule)),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var first = _v0.a;
					var rest = _v0.b;
					return _Utils_Tuple2(
						first.label,
						A2(
							$elm$core$List$map,
							function (rule) {
								return _Utils_update(
									rule,
									{label: ''});
							},
							A2($elm$core$List$cons, first, rest)));
				},
				A2(
					$elm_community$list_extra$List$Extra$gatherEqualsBy,
					function ($) {
						return $.label;
					},
					labelingRules))));
};
var $author$project$Ui$V3$Colors$Gray900 = {$: 'Gray900'};
var $author$project$Ui$V3$Colors$cssVariableWithOpacity = F2(
	function (opacity, color) {
		var opacityStr = $elm$core$String$fromFloat(100 * opacity) + '%';
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'color-mix(in srgb,',
					$author$project$Ui$V3$Colors$cssVariable(color),
					opacityStr,
					', transparent)'
				]));
	});
var $author$project$Components$Dashboard$RowHelper$carrierLabelButtonV3Reskin = function (label) {
	return A2(
		$author$project$Ui$V3$Chip$view,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Chip$Style,
				'background',
				A2($author$project$Ui$V3$Colors$cssVariableWithOpacity, 0.04, $author$project$Ui$V3$Colors$Gray900)),
				A2($author$project$Ui$V3$Chip$Style, 'border', 'inset 1px transparent'),
				A2($author$project$Ui$V3$Chip$Style, 'font-weight', '400'),
				A2($author$project$Ui$V3$Chip$Style, 'word-break', 'break-word')
			]),
		label);
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewCheckFieldWith = F2(
	function (label, value) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-field-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-field-value')
					]),
				_List_fromArray(
					[value]))
			]);
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewCheckField = function (_v0) {
	var label = _v0.a;
	var value = _v0.b;
	return A2(
		$author$project$Components$CarrierInvoiceAuditChecks$viewCheckFieldWith,
		label,
		$elm$html$Html$text(
			$elm$core$String$isEmpty(value) ? '—' : value));
};
var $author$project$Components$CarrierInvoiceAuditChecks$describeLabelingReferenceOwner = function (owner) {
	switch (owner.$) {
		case 'LabelingReferenceOwnerLoad':
			return 'Load';
		case 'LabelingReferenceOwnerShipment':
			return 'Shipment';
		default:
			return 'Customer';
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewLabelingReference = function (_v0) {
	var owner = _v0.owner;
	var value = _v0.value;
	var key = _v0.key;
	return A2(
		$elm$core$List$concatMap,
		$author$project$Components$CarrierInvoiceAuditChecks$viewCheckField,
		_List_fromArray(
			[
				_Utils_Tuple2('Reference', key),
				_Utils_Tuple2('Value', value),
				_Utils_Tuple2(
				'Owner',
				$author$project$Components$CarrierInvoiceAuditChecks$describeLabelingReferenceOwner(owner))
			]));
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewLabelingRecord = function (_v0) {
	var record = _v0.record;
	switch (record.$) {
		case 'LabelingRecord_Record_LabelingNoRecord':
			return _List_Nil;
		case 'LabelingRecord_Record_LabelingReferences':
			var references = record.a.references;
			return A2($elm$core$List$concatMap, $author$project$Components$CarrierInvoiceAuditChecks$viewLabelingReference, references);
		default:
			var carrier = record.a;
			return A2(
				$author$project$Components$CarrierInvoiceAuditChecks$viewCheckFieldWith,
				'Carrier',
				A2(
					$author$project$Ui$V3$Link$view,
					{
						text: carrier.name,
						url: $author$project$Path$toString(
							$author$project$Path$settingsEditCarrier(carrier.id))
					},
					_List_fromArray(
						[$author$project$Ui$V3$Link$targetBlank])));
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewLabelingRule = function (rule) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__label-group-rule invoice-audit__check-fields')
			]),
		_Utils_ap(
			$author$project$Components$CarrierInvoiceAuditChecks$viewCheckField(
				_Utils_Tuple2(
					'Rule',
					$author$project$Components$CarrierInvoiceAuditChecks$describeLabelingRule(rule))),
			$author$project$Components$CarrierInvoiceAuditChecks$viewLabelingRecord(rule.record)));
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewLabelGroup = function (_v0) {
	var rules = _v0.rules;
	var labels = _v0.labels;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__label-group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__label-group-labels')
					]),
				A2($elm$core$List$map, $author$project$Components$Dashboard$RowHelper$carrierLabelButtonV3Reskin, labels)),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__label-group-rules')
					]),
				A2($elm$core$List$map, $author$project$Components$CarrierInvoiceAuditChecks$viewLabelingRule, rules))
			]));
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewLabelingRules = function (labelingRules) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$CarrierInvoiceAuditChecks$viewLabelGroup,
			$author$project$Components$CarrierInvoiceAuditChecks$labelGroups(labelingRules)));
};
var $author$project$Domain$ReferenceRule$verb = function (rule) {
	switch (rule.$) {
		case 'IsPresent':
			return 'must be present';
		case 'IsEmpty':
			return 'must be empty';
		case 'HasValue':
			return 'must equal';
		case 'BeginsWith':
			return 'must begin with';
		default:
			return 'must not equal';
	}
};
var $author$project$Domain$ReferenceRule$describe = function (rule) {
	switch (rule.$) {
		case 'IsPresent':
			return $author$project$Domain$ReferenceRule$verb(rule);
		case 'IsEmpty':
			return $author$project$Domain$ReferenceRule$verb(rule);
		case 'HasValue':
			var value = rule.a;
			return $author$project$Domain$ReferenceRule$verb(rule) + (' ' + value);
		case 'BeginsWith':
			var value = rule.a;
			return $author$project$Domain$ReferenceRule$verb(rule) + (' ' + value);
		default:
			var value = rule.a;
			return $author$project$Domain$ReferenceRule$verb(rule) + (' ' + value);
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$describeRequirement = function (requirement) {
	return $author$project$Domain$ReferenceRule$describe(
		$author$project$Domain$ReferenceRule$fromPb(requirement).rule);
};
var $author$project$Components$CarrierInvoiceAuditChecks$describeSource = function (source) {
	if (source.$ === 'ReferenceRequirementsCheck_Source_AccountSource') {
		return 'Account';
	} else {
		var name = source.a.name;
		return 'Customer: ' + name;
	}
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewReferenceRequirements = function (_v0) {
	var source = _v0.source;
	var requirements = _v0.requirements;
	var loadValue = _v0.loadValue;
	var reference = _v0.reference;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-fields')
			]),
		A2(
			$elm$core$List$concatMap,
			$author$project$Components$CarrierInvoiceAuditChecks$viewCheckField,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('Reference', reference),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('On the load', loadValue),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (requirement) {
								return _Utils_Tuple2(
									'Requirement',
									$author$project$Components$CarrierInvoiceAuditChecks$describeRequirement(requirement));
							},
							requirements),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'Set by',
								$author$project$Components$CarrierInvoiceAuditChecks$describeSource(source))
							]))))));
};
var $author$project$Components$CarrierInvoiceAuditChecks$AmountFieldsSettled = function (a) {
	return {$: 'AmountFieldsSettled', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewSaveAmountsButton = F2(
	function (invoiceAmount, amountToPay) {
		return $author$project$Components$AuditCheckActions$viewPrimaryButton(
			{
				label: 'Save Amounts',
				onClick: $author$project$Components$CarrierInvoiceAuditChecks$AmountFieldsSettled(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount,
							$author$project$Domain$Amount$cleaned(invoiceAmount)),
							_Utils_Tuple2(
							$author$project$Components$CarrierInvoiceAuditQuickReviewFields$AmountToPay,
							$author$project$Domain$Amount$cleaned(amountToPay))
						]))
			});
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewRemedy = F3(
	function (config, model, check) {
		var _v0 = check.details;
		if (_v0.$ === 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck') {
			var ruleCheck = _v0.a;
			var _v1 = ruleCheck.checkType.check;
			switch (_v1.$) {
				case 'CarrierInvoiceAuditCheckType_Check_DocumentReviewCheck':
					return {
						actions: _List_Nil,
						body: _List_fromArray(
							[
								A2($author$project$Components$UnidentifiedDocuments$view, $author$project$Components$CarrierInvoiceAuditChecks$DocumentThumbnailClicked, config.unidentifiedDocuments)
							])
					};
				case 'CarrierInvoiceAuditCheckType_Check_OsdCheck':
					return {
						actions: _List_Nil,
						body: _List_fromArray(
							[
								A2(
								$author$project$Components$CheckDocuments$view,
								$author$project$Components$CarrierInvoiceAuditChecks$DocumentThumbnailClicked,
								A2(
									$elm$core$List$filter,
									function ($) {
										return $.hasDamage;
									},
									config.documents))
							])
					};
				case 'CarrierInvoiceAuditCheckType_Check_CarrierRateCheck':
					var documentIds = _v1.a.documentIds;
					return {
						actions: _List_Nil,
						body: _List_fromArray(
							[
								A2(
								$author$project$Components$CheckDocuments$view,
								$author$project$Components$CarrierInvoiceAuditChecks$DocumentThumbnailClicked,
								A2(
									$elm$core$List$filter,
									function (document) {
										return A2($elm$core$List$member, document.documentId, documentIds);
									},
									config.documents))
							])
					};
				case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceAmountCheck':
					var invoiceAmount = A3($author$project$Components$CarrierInvoiceAuditChecks$shownQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount, config.quickReview.invoiceAmount, model);
					var amountToPay = A3($author$project$Components$CarrierInvoiceAuditChecks$shownQuickReview, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$AmountToPay, config.quickReview.amountToPay, model);
					return {
						actions: _List_fromArray(
							[
								A2($author$project$Components$CarrierInvoiceAuditChecks$viewSaveAmountsButton, invoiceAmount, amountToPay)
							]),
						body: _List_fromArray(
							[
								$author$project$Components$AmountFields$view(
								{
									fields: _List_fromArray(
										[
											A2(
											$author$project$Components$CarrierInvoiceAuditChecks$invoiceAmountField,
											invoiceAmount,
											A3($author$project$Components$CarrierInvoiceAuditChecks$amountEditedFrom, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$InvoiceAmount, config, model)),
											A2(
											$author$project$Components$CarrierInvoiceAuditChecks$amountToPayField,
											amountToPay,
											A3($author$project$Components$CarrierInvoiceAuditChecks$amountEditedFrom, $author$project$Components$CarrierInvoiceAuditQuickReviewFields$AmountToPay, config, model))
										]),
									isEditable: config.isEditable
								})
							])
					};
				case 'CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck':
					var fields = _v1.a.fields;
					return A3($author$project$Components$CarrierInvoiceAuditChecks$extractedFieldsRemedy, config.isEditable, model, fields);
				case 'CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck':
					var referenceRequirements = _v1.a;
					return {
						actions: _List_Nil,
						body: _List_fromArray(
							[
								$author$project$Components$CarrierInvoiceAuditChecks$viewReferenceRequirements(referenceRequirements)
							])
					};
				case 'CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck':
					var labelingRules = _v1.a.labelingRules;
					return {
						actions: _List_Nil,
						body: $elm$core$List$isEmpty(labelingRules) ? _List_Nil : _List_fromArray(
							[
								$author$project$Components$CarrierInvoiceAuditChecks$viewLabelingRules(labelingRules)
							])
					};
				case 'CarrierInvoiceAuditCheckType_Check_CustomerInstructionsCheck':
					var customers = _v1.a.customers;
					return {
						actions: _List_Nil,
						body: _List_fromArray(
							[
								$author$project$Components$CarrierInvoiceAuditChecks$viewCustomerInstructions(customers)
							])
					};
				default:
					return {actions: _List_Nil, body: _List_Nil};
			}
		} else {
			var event = _v0.a;
			return config.isEditable ? {
				actions: _List_Nil,
				body: _List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$CarrierInvoiceAuditChecks$ExceptionEventMsg(event.id),
						A2(
							$author$project$Components$AuditFailedCheckExceptionEvent$viewBody,
							event,
							A2($author$project$Components$CarrierInvoiceAuditChecks$resolutionInput, event.id, model)))
					])
			} : {actions: _List_Nil, body: _List_Nil};
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewCheckBody = F3(
	function (config, model, check) {
		var remedy = A3($author$project$Components$CarrierInvoiceAuditChecks$viewRemedy, config, model, check);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__check-body')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Components$AuditCheckCard$viewActiveFailureMessages(
					$author$project$Components$CarrierInvoiceAuditChecks$failureMessages(check)),
				_Utils_ap(
					remedy.body,
					A4($author$project$Components$CarrierInvoiceAuditChecks$viewCheckActions, config, model, check, remedy.actions))));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewCheck = F5(
	function (config, model, unsavedCheckIds, topCheckKey, check) {
		var key = $author$project$Components$CarrierInvoiceAuditChecks$identifier(check);
		var isExpanded = A2(
			$elm$core$Set$member,
			key,
			A2($author$project$Components$CarrierInvoiceAuditChecks$expandedKeys, model.expansion, topCheckKey));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__sticky-row invoice-audit__sticky-row--failed'),
					$elm$html$Html$Attributes$id(
					$author$project$Components$CarrierInvoiceAuditChecks$checkElementId(key))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__sticky-icon invoice-audit__sticky-icon--open')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__sticky-content')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$AuditCheckCard$viewCard,
							{
								hasUnsavedEdit: A2($elm$core$List$member, key, unsavedCheckIds),
								isExpanded: isExpanded,
								onToggle: $author$project$Components$CarrierInvoiceAuditChecks$ToggleCheck(
									{key: key, topCheckKey: topCheckKey}),
								state: $elm$core$Maybe$Just($author$project$Components$AuditCheckCard$Failing),
								title: $author$project$Components$CarrierInvoiceAuditChecks$headerTitle(check)
							},
							A3($author$project$Components$CarrierInvoiceAuditChecks$viewCheckBody, config, model, check))
						]))
				]));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewChecks = F2(
	function (config, model) {
		var _v0 = $author$project$Components$CarrierInvoiceAuditChecks$failing(config.auditChecks);
		if (!_v0.b) {
			return A2($author$project$Ui$V3$Typography$body, _List_Nil, 'No failing checks.');
		} else {
			var failingChecks = _v0;
			var first = failingChecks.a;
			var unsavedCheckIds = A2(
				$elm$core$List$map,
				function ($) {
					return $.checkId;
				},
				A2(
					$author$project$Components$CarrierInvoiceAuditChecks$unsavedEdits,
					{
						auditChecks: config.auditChecks,
						quickReview: $elm$core$Maybe$Just(config.quickReview)
					},
					model));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__sticky-list')
					]),
				A2(
					$elm$core$List$map,
					A4(
						$author$project$Components$CarrierInvoiceAuditChecks$viewCheck,
						config,
						model,
						unsavedCheckIds,
						$author$project$Components$CarrierInvoiceAuditChecks$identifier(first)),
					failingChecks));
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$AddExceptionEventMsg = function (a) {
	return {$: 'AddExceptionEventMsg', a: a};
};
var $author$project$Components$AuditAddExceptionEvent$addCustomExceptionPlaceholder = 'Add custom exception...';
var $author$project$Components$AuditAddExceptionEvent$CustomMessageChanged = function (a) {
	return {$: 'CustomMessageChanged', a: a};
};
var $author$project$Components$AuditAddExceptionEvent$viewCustomMessage = F2(
	function (placeholder, model) {
		return A4(
			$author$project$Ui$V3$Input$view,
			{onInput: $author$project$Components$AuditAddExceptionEvent$CustomMessageChanged},
			_List_fromArray(
				[
					$author$project$Ui$V3$Input$placeholder(placeholder)
				]),
			_List_Nil,
			model.customMessage);
	});
var $author$project$Components$AuditAddExceptionEvent$MessageSelected = function (a) {
	return {$: 'MessageSelected', a: a};
};
var $author$project$Components$AuditAddExceptionEvent$messageOptions = function (messages) {
	return $elm_community$list_extra$List$Extra$unique(
		_Utils_ap(
			A2($elm$core$List$sortBy, $elm$core$String$toLower, messages),
			_List_fromArray(
				[$author$project$Components$AuditAddExceptionEvent$otherMessage])));
};
var $author$project$Ui$V3$SimpleSelect$PlaceholderAttribute = function (a) {
	return {$: 'PlaceholderAttribute', a: a};
};
var $author$project$Ui$V3$SimpleSelect$placeholder = $author$project$Ui$V3$SimpleSelect$PlaceholderAttribute;
var $author$project$Components$AuditAddExceptionEvent$viewMessageSelect = F2(
	function (messages, model) {
		return A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{
				onInput: $author$project$Components$AuditAddExceptionEvent$MessageSelected,
				options: $author$project$Components$AuditAddExceptionEvent$messageOptions(messages),
				toLabel: $elm$core$Basics$identity,
				value: $elm$core$String$isEmpty(model.selectedMessage) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.selectedMessage)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$SimpleSelect$placeholder(
					$elm$core$Maybe$Just($author$project$Components$AuditAddExceptionEvent$addCustomExceptionPlaceholder))
				]));
	});
var $author$project$Components$AuditAddExceptionEvent$viewPossibleCustomMessage = function (model) {
	return _Utils_eq(model.selectedMessage, $author$project$Components$AuditAddExceptionEvent$otherMessage) ? _List_fromArray(
		[
			A2($author$project$Components$AuditAddExceptionEvent$viewCustomMessage, 'Exception description', model)
		]) : _List_Nil;
};
var $author$project$Components$AuditAddExceptionEvent$AddClicked = {$: 'AddClicked'};
var $author$project$Components$AuditAddExceptionEvent$viewAddButton = function (isDisabled) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick($author$project$Components$AuditAddExceptionEvent$AddClicked)
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
				$author$project$Components$AuditCheckActions$buttonSize,
				$author$project$Ui$V3$Button$disabled(isDisabled)
			]),
		'+ Add Exception');
};
var $author$project$Components$AuditAddExceptionEvent$viewRow = F2(
	function (_v0, controls) {
		var addDisabled = _v0.addDisabled;
		var otherSelected = _v0.otherSelected;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__sticky-row invoice-audit__sticky-row--add-exception')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__sticky-icon invoice-audit__sticky-icon--blank')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__sticky-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('invoice-audit__add-exception', true),
											_Utils_Tuple2('invoice-audit__add-exception--other-selected', otherSelected)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invoice-audit__add-exception-controls')
										]),
									controls),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invoice-audit__add-exception-action')
										]),
									_List_fromArray(
										[
											$author$project$Components$AuditAddExceptionEvent$viewAddButton(addDisabled)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$AuditAddExceptionEvent$view = F2(
	function (config, model) {
		var _v0 = config.customInvoiceExceptionMessages;
		if (!_v0.b) {
			return A2(
				$author$project$Components$AuditAddExceptionEvent$viewRow,
				{addDisabled: false, otherSelected: false},
				_List_fromArray(
					[
						A2($author$project$Components$AuditAddExceptionEvent$viewCustomMessage, $author$project$Components$AuditAddExceptionEvent$addCustomExceptionPlaceholder, model)
					]));
		} else {
			var messages = _v0;
			return A2(
				$author$project$Components$AuditAddExceptionEvent$viewRow,
				{
					addDisabled: $elm$core$String$isEmpty(model.selectedMessage),
					otherSelected: _Utils_eq(model.selectedMessage, $author$project$Components$AuditAddExceptionEvent$otherMessage)
				},
				A2(
					$elm$core$List$cons,
					A2($author$project$Components$AuditAddExceptionEvent$viewMessageSelect, messages, model),
					$author$project$Components$AuditAddExceptionEvent$viewPossibleCustomMessage(model)));
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewPossibleAddException = F2(
	function (config, model) {
		return config.isEditable ? _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$CarrierInvoiceAuditChecks$AddExceptionEventMsg,
				A2(
					$author$project$Components$AuditAddExceptionEvent$view,
					{customInvoiceExceptionMessages: config.customInvoiceExceptionMessages},
					model.addExceptionEvent))
			]) : _List_Nil;
	});
var $author$project$Components$CarrierInvoiceAuditChecks$view = F2(
	function (config, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$cons,
					A2($author$project$Components$CarrierInvoiceAuditChecks$viewChecks, config, model),
					A2($author$project$Components$CarrierInvoiceAuditChecks$viewPossibleAddException, config, model)),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id($author$project$Components$CarrierInvoiceAuditChecks$quickReviewElementId)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$CarrierInvoiceAuditChecks$QuickReviewMsg,
								$author$project$Components$CarrierInvoiceAuditQuickReviewFields$view(
									A2($author$project$Components$CarrierInvoiceAuditChecks$quickReviewConfig, config, model)))
							]))
					])));
	});
var $author$project$Components$CarrierInvoiceAuditLoadDetails$isPresent = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$trim,
	A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not));
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewAddress = function (address) {
	var place = A2(
		$elm$core$List$filter,
		$author$project$Components$CarrierInvoiceAuditLoadDetails$isPresent,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					address.addressLine1,
					address.addressLine2,
					$author$project$Domain$Address$lastLine(address),
					A2(
					$elm_community$maybe_extra$Maybe$Extra$filter,
					function (country) {
						return !A2(
							$elm$core$List$member,
							country,
							_List_fromArray(
								['US', 'USA']));
					},
					address.country)
				])));
	return $elm$core$List$isEmpty(place) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('address')
				]),
			A2(
				$elm$core$List$map,
				function (line) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('address__line')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(line)
							]));
				},
				_Utils_ap(
					A2(
						$elm$core$List$filter,
						function (name) {
							return $author$project$Components$CarrierInvoiceAuditLoadDetails$isPresent(name) && (name !== 'Unknown Location');
						},
						_List_fromArray(
							[address.name])),
					place))));
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewRow = function (table) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-10 column')
					]),
				_List_fromArray(
					[table]))
			]));
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewValueTable = function (cells) {
	if ($elm$core$List$isEmpty(cells)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var width = $elm$core$String$fromFloat(
			100 / $elm$core$List$length(cells)) + '%';
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__info-table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('load-detail__info-table-header')
									]),
								A2(
									$elm$core$List$map,
									function (_v0) {
										var label = _v0.a;
										return A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'width', width)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(label)
												]));
									},
									cells))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('load-detail__info-table-data')
									]),
								A2(
									$elm$core$List$map,
									function (_v1) {
										var value = _v1.b;
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[value]));
									},
									cells))
							]))
					])));
	}
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewAddresses = function (load) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Components$CarrierInvoiceAuditLoadDetails$viewRow,
		$author$project$Components$CarrierInvoiceAuditLoadDetails$viewValueTable(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var label = _v0.a;
					var address = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(label),
						A2($elm$core$Maybe$andThen, $author$project$Components$CarrierInvoiceAuditLoadDetails$viewAddress, address));
				},
				_List_fromArray(
					[
						_Utils_Tuple2('Origin', load.origin),
						_Utils_Tuple2('Destination', load.destination)
					]))));
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$presentPairs = $elm$core$List$filterMap(
	function (_v0) {
		var label = _v0.a;
		var value = _v0.b;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(label),
			A2($elm_community$maybe_extra$Maybe$Extra$filter, $author$project$Components$CarrierInvoiceAuditLoadDetails$isPresent, value));
	});
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewPair = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('load-detail__info-reference-pair')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__info-reference-name')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name + ':')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__info-reference-value')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(value)
					]))
			]));
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewCarrier = function (carrier) {
	var pairs = $author$project$Components$CarrierInvoiceAuditLoadDetails$presentPairs(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'Name',
				$elm$core$Maybe$Just(carrier.name)),
				_Utils_Tuple2('MC', carrier.mcNumber),
				_Utils_Tuple2('DOT', carrier.dotNumber),
				_Utils_Tuple2('SCAC', carrier.scac)
			]));
	return $elm$core$List$isEmpty(pairs) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__info-table load-detail__info-table-with-references')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__info-table-header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('TMS Carrier')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('load-detail__info-with-references')
												]),
											A2($elm$core$List$map, $author$project$Components$CarrierInvoiceAuditLoadDetails$viewPair, pairs))
										]))
								]))
						]))
				])));
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewDatesAndCarrier = F3(
	function (tz, load, carrier) {
		var dates = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (shipped) {
						return _Utils_Tuple2(
							'Ship Date',
							A2($author$project$Helpers$Date$dateStringFormat2, tz, shipped));
					},
					load.actualShippedAt),
					A2(
					$elm$core$Maybe$map,
					function (delivered) {
						return _Utils_Tuple2(
							'Delivered Date',
							A2($author$project$Helpers$Date$dateStringFormat2, tz, delivered));
					},
					load.actualDeliveredAt)
				]));
		var lastIndex = $elm$core$List$length(dates) - 1;
		var viewDate = F2(
			function (index, _v0) {
				var label = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('small-3 column', true),
									_Utils_Tuple2('load-detail__row-table-container-start', !index),
									_Utils_Tuple2(
									'load-detail__row-table-container-end',
									_Utils_eq(index, lastIndex))
								]))
						]),
					$elm_community$maybe_extra$Maybe$Extra$toList(
						$author$project$Components$CarrierInvoiceAuditLoadDetails$viewValueTable(
							_List_fromArray(
								[
									_Utils_Tuple2(
									label,
									$elm$html$Html$text(value))
								]))));
			});
		var cells = _Utils_ap(
			A2($elm$core$List$indexedMap, viewDate, dates),
			$elm_community$maybe_extra$Maybe$Extra$toList(
				A2($elm$core$Maybe$andThen, $author$project$Components$CarrierInvoiceAuditLoadDetails$viewCarrier, carrier)));
		return $elm$core$List$isEmpty(cells) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row load-detail__load-info-area')
					]),
				cells));
	});
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewReferences = function (references) {
	var present = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.value;
			},
			$author$project$Components$CarrierInvoiceAuditLoadDetails$isPresent),
		references);
	return $elm$core$List$isEmpty(present) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Components$CarrierInvoiceAuditLoadDetails$viewRow(
			A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__info-table load-detail__info-table--vertical')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (reference) {
								return A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(reference.key)
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(reference.value)
												]))
										]));
							},
							present))
					]))));
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$labelStops = function (groups) {
	var labelStop = F2(
		function (stop, _v4) {
			var labelled = _v4.a;
			var drops = _v4.b;
			var _v3 = stop.kind;
			if (_v3.$ === 'TMSLoadInformation_KindPickup') {
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2('PICKUP', stop),
						labelled),
					drops);
			} else {
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'DROP ' + $elm$core$String$fromInt(drops + 1),
							stop),
						labelled),
					drops + 1);
			}
		});
	var labelGroup = F2(
		function (_v1, _v2) {
			var key = _v1.a;
			var stops = _v1.b;
			var labelled = _v2.a;
			var dropsSoFar = _v2.b;
			var _v0 = A3(
				$elm$core$List$foldl,
				labelStop,
				_Utils_Tuple2(_List_Nil, dropsSoFar),
				stops);
			var labelledStops = _v0.a;
			var dropsAfter = _v0.b;
			return _Utils_Tuple2(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						key,
						$elm$core$List$reverse(labelledStops)),
					labelled),
				dropsAfter);
		});
	return $elm$core$List$reverse(
		A3(
			$elm$core$List$foldl,
			labelGroup,
			_Utils_Tuple2(_List_Nil, 0),
			groups).a);
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$dateTime = F2(
	function (tz, time) {
		return A2($author$project$Helpers$Date$dateStringFormat2, tz, time) + (' ' + A2($author$project$Helpers$Date$timeStringNoPadding, tz, time));
	});
var $author$project$Components$CarrierInvoiceAuditLoadDetails$positive = $elm_community$maybe_extra$Maybe$Extra$filter(
	function (n) {
		return n > 0;
	});
var $author$project$Helpers$Format$weight = function (w) {
	if (w.$ === 'Just') {
		var n = w.a;
		return $author$project$Helpers$Format$int(n) + ' lbs';
	} else {
		return '';
	}
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$shipmentPairs = F2(
	function (tz, shipment) {
		return _Utils_ap(
			$author$project$Components$CarrierInvoiceAuditLoadDetails$presentPairs(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Shipment',
						$elm$core$Maybe$Just(shipment.shipmentId)),
						_Utils_Tuple2(
						'Pick-up Date',
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$CarrierInvoiceAuditLoadDetails$dateTime(tz),
							shipment.actualShippedAt)),
						_Utils_Tuple2(
						'Drop-off Date',
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$CarrierInvoiceAuditLoadDetails$dateTime(tz),
							shipment.actualDeliveredAt)),
						_Utils_Tuple2(
						'Weight',
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Helpers$Format$weight),
							$author$project$Components$CarrierInvoiceAuditLoadDetails$positive(shipment.weight))),
						_Utils_Tuple2('PO Number', shipment.po),
						_Utils_Tuple2('Pickup Reference', shipment.pickupReference),
						_Utils_Tuple2('Shipment Reference', shipment.shipRef),
						_Utils_Tuple2('Shipper Name', shipment.shipperName),
						_Utils_Tuple2('Customer', shipment.customerName)
					])),
			$author$project$Components$CarrierInvoiceAuditLoadDetails$presentPairs(
				A2(
					$elm$core$List$map,
					function (reference) {
						return _Utils_Tuple2(
							reference.key,
							$elm$core$Maybe$Just(reference.value));
					},
					shipment.references)));
	});
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewShipmentNotes = function (shipment) {
	var notes = A2($elm$core$List$filter, $author$project$Components$CarrierInvoiceAuditLoadDetails$isPresent, shipment.notes);
	return $elm$core$List$isEmpty(notes) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(2),
							$elm$html$Html$Attributes$class('load-detail__shipment_notes_row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__info-reference-pair')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__info-reference-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Shipment Notes:')
										])),
								A2(
									$elm$core$List$map,
									function (note) {
										return A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('load-detail__info-reference-value')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(note)
														]))
												]));
									},
									notes)))
						]))
				])));
};
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewStop = F3(
	function (tz, index, _v0) {
		var label = _v0.a;
		var stop = _v0.b;
		var details = _Utils_ap(
			$author$project$Components$CarrierInvoiceAuditLoadDetails$presentPairs(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Weight',
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Helpers$Format$weight),
							$author$project$Components$CarrierInvoiceAuditLoadDetails$positive(stop.weight))),
						_Utils_Tuple2(
						'Arrived',
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$CarrierInvoiceAuditLoadDetails$dateTime(tz),
							stop.actualArrivedAt)),
						_Utils_Tuple2(
						'Departed',
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$CarrierInvoiceAuditLoadDetails$dateTime(tz),
							stop.actualDepartedAt))
					])),
			$author$project$Components$CarrierInvoiceAuditLoadDetails$presentPairs(
				A2(
					$elm$core$List$map,
					function (reference) {
						return _Utils_Tuple2(
							reference.key,
							$elm$core$Maybe$Just(reference.value));
					},
					stop.references)));
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('load-detail__info-table-data', true),
							_Utils_Tuple2(
							'load-detail--even',
							!A2($elm$core$Basics$modBy, 2, index + 1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__align-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__align-top')
						]),
					_Utils_ap(
						$elm_community$maybe_extra$Maybe$Extra$toList(
							$author$project$Components$CarrierInvoiceAuditLoadDetails$viewAddress(stop.address)),
						A2(
							$elm$core$List$map,
							function (_v1) {
								var key = _v1.a;
								var value = _v1.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(key + (': ' + value))
										]));
							},
							details)))
				]));
	});
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewStopGroup = F3(
	function (tz, index, _v0) {
		var shipment = _v0.a;
		var stops = _v0.b;
		return A2(
			$elm$html$Html$tbody,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('load-detail', true),
							_Utils_Tuple2(
							'load-detail--even',
							!A2($elm$core$Basics$modBy, 2, index))
						]))
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$tr,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__info-table-data')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__info-with-references')
										]),
									A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										_List_Nil,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Components$CarrierInvoiceAuditLoadDetails$shipmentPairs(tz),
											$elm$core$List$map($author$project$Components$CarrierInvoiceAuditLoadDetails$viewPair)),
										shipment)),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__align-top')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$table,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('load-detail__full-width')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tbody,
													_List_Nil,
													A2(
														$elm$core$List$indexedMap,
														$author$project$Components$CarrierInvoiceAuditLoadDetails$viewStop(tz),
														stops))
												]))
										]))
								]))),
						A2($elm$core$Maybe$andThen, $author$project$Components$CarrierInvoiceAuditLoadDetails$viewShipmentNotes, shipment)
					])));
	});
var $author$project$Components$CarrierInvoiceAuditLoadDetails$viewStops = F2(
	function (tz, information) {
		var groups = _Utils_ap(
			A2(
				$elm$core$List$map,
				function (shipment) {
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(shipment),
						shipment.stops);
				},
				information.shipments),
			$elm$core$List$isEmpty(information.unshippedStops) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2($elm$core$Maybe$Nothing, information.unshippedStops)
				]));
		return $elm$core$List$isEmpty(groups) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$CarrierInvoiceAuditLoadDetails$viewRow(
				A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__info-table load-detail__info-table-with-references')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__info-table-header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Shipment')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Stops')
												]))
										]))
								])),
						A2(
							$elm$core$List$indexedMap,
							$author$project$Components$CarrierInvoiceAuditLoadDetails$viewStopGroup(tz),
							$author$project$Components$CarrierInvoiceAuditLoadDetails$labelStops(groups))))));
	});
var $author$project$Components$CarrierInvoiceAuditLoadDetails$view = F2(
	function (tz, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ci-audit__load-details')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header load-detail__section-header__load-info')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Load Information')
						])),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$author$project$Components$CarrierInvoiceAuditLoadDetails$viewAddresses(data.tmsLoadDetails.load),
							A2($author$project$Components$CarrierInvoiceAuditLoadDetails$viewStops, tz, data.information),
							$author$project$Components$CarrierInvoiceAuditLoadDetails$viewReferences(data.information.references),
							A3($author$project$Components$CarrierInvoiceAuditLoadDetails$viewDatesAndCarrier, tz, data.tmsLoadDetails.load, data.carrier)
						]))));
	});
var $author$project$Components$AuditCompletedChecks$NothingMoreToShow = {$: 'NothingMoreToShow'};
var $author$project$Components$AuditCompletedChecks$Positive = {$: 'Positive'};
var $author$project$Components$CarrierInvoiceAuditChecks$hasUnsavedExtractedEdit = F2(
	function (model, check) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$CarrierInvoiceAuditChecks$unsavedExtracted(model),
				$elm_community$maybe_extra$Maybe$Extra$isJust),
			A2(
				$elm$core$List$concatMap,
				$author$project$Components$CarrierInvoiceAuditChecks$checkExtractedFields,
				$author$project$Components$CarrierInvoiceAuditChecks$editable(
					_List_fromArray(
						[check]))));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$passedDescription = function (checkType) {
	var _v0 = checkType.check;
	switch (_v0.$) {
		case 'CarrierInvoiceAuditCheckType_Check_OtherCheck':
			return 'No other exceptions found.';
		case 'CarrierInvoiceAuditCheckType_Check_DocumentsRequiredCheck':
			var documentsRequired = _v0.a;
			return documentsRequired.passedDescription;
		case 'CarrierInvoiceAuditCheckType_Check_OsdCheck':
			return 'No overages, shortages or damages were detected.';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierRateCheck':
			return 'No document shows the carrier rate.';
		case 'CarrierInvoiceAuditCheckType_Check_DocumentReviewCheck':
			return 'Every document has a type.';
		case 'CarrierInvoiceAuditCheckType_Check_ExtractedFieldsCheck':
			var fields = _v0.a.fields;
			return A2(
				$elm$core$List$any,
				function ($) {
					return $.required;
				},
				fields) ? 'Every required value was read off the documents.' : 'All values are optional.';
		case 'CarrierInvoiceAuditCheckType_Check_LoadMatchCheck':
			return 'Invoice matches a delivered load.';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceAmountCheck':
			return 'Invoice amount matches the load.';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierMatchCheck':
			return 'Carrier and payment details match the load.';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceDuplicateInvoiceCheck':
			return 'No duplicate invoice found.';
		case 'CarrierInvoiceAuditCheckType_Check_CarrierInvoiceInvoiceDateCheck':
			return 'Invoice date is valid.';
		case 'CarrierInvoiceAuditCheckType_Check_CustomExceptionMessageCheck':
			return 'No custom exceptions were raised.';
		case 'CarrierInvoiceAuditCheckType_Check_LabelRuleFailureCheck':
			return 'No label on this invoice raises an exception.';
		case 'CarrierInvoiceAuditCheckType_Check_CustomerInstructionsCheck':
			return 'No customer on this load has instructions.';
		default:
			var requirements = _v0.a.requirements;
			return $elm_community$string_extra$String$Extra$toSentenceCase(
				A2(
					$elm$core$String$join,
					', ',
					A2($elm$core$List$map, $author$project$Components$CarrierInvoiceAuditChecks$describeRequirement, requirements)));
	}
};
var $author$project$Components$AuditCompletedChecks$Expandable = function (a) {
	return {$: 'Expandable', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$ToggleCompletedCheck = function (a) {
	return {$: 'ToggleCompletedCheck', a: a};
};
var $author$project$Components$CarrierInvoiceAuditChecks$expandable = F3(
	function (model, check, body) {
		var key = $author$project$Components$CarrierInvoiceAuditChecks$identifier(check);
		return $author$project$Components$AuditCompletedChecks$Expandable(
			{
				body: body,
				isExpanded: A2($elm$core$Set$member, key, model.expandedCompletedChecks),
				onToggle: $author$project$Components$CarrierInvoiceAuditChecks$ToggleCompletedCheck(key)
			});
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewCompletedExtractedFields = F3(
	function (isEditable, model, fields) {
		var remedy = A3($author$project$Components$CarrierInvoiceAuditChecks$extractedFieldsRemedy, isEditable, model, fields);
		var actions = isEditable ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				remedy.actions)
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__check-body')
				]),
			_Utils_ap(remedy.body, actions));
	});
var $author$project$Components$CarrierInvoiceAuditChecks$completedExtractedFields = F3(
	function (isEditable, model, checkType) {
		var fields = $author$project$Components$CarrierInvoiceAuditChecks$extractedFields(checkType);
		return (A2(
			$elm$core$List$any,
			function (field) {
				return $elm$core$String$trim(field.value) !== '';
			},
			fields) || (isEditable && (!$elm$core$List$isEmpty(fields)))) ? $elm$core$Maybe$Just(
			A3($author$project$Components$CarrierInvoiceAuditChecks$viewCompletedExtractedFields, isEditable, model, fields)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$CarrierInvoiceAuditChecks$extractedFieldsExpansion = F4(
	function (isEditable, model, check, checkType) {
		var _v0 = A3($author$project$Components$CarrierInvoiceAuditChecks$completedExtractedFields, isEditable, model, checkType);
		if (_v0.$ === 'Just') {
			var body = _v0.a;
			return A3($author$project$Components$CarrierInvoiceAuditChecks$expandable, model, check, body);
		} else {
			return $author$project$Components$AuditCompletedChecks$NothingMoreToShow;
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$passedExpansion = F4(
	function (isEditable, model, check, checkType) {
		var _v0 = checkType.check;
		if (_v0.$ === 'CarrierInvoiceAuditCheckType_Check_ReferenceRequirementsCheck') {
			var referenceRequirements = _v0.a;
			return A3(
				$author$project$Components$CarrierInvoiceAuditChecks$expandable,
				model,
				check,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__check-body')
						]),
					_List_fromArray(
						[
							$author$project$Components$CarrierInvoiceAuditChecks$viewReferenceRequirements(referenceRequirements)
						])));
		} else {
			return A4($author$project$Components$CarrierInvoiceAuditChecks$extractedFieldsExpansion, isEditable, model, check, checkType);
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$passedRow = F3(
	function (isEditable, model, check) {
		var _v0 = check.details;
		if (_v0.$ === 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck') {
			var ruleCheck = _v0.a;
			return {
				description: $author$project$Components$CarrierInvoiceAuditChecks$passedDescription(ruleCheck.checkType),
				domId: $elm$core$Maybe$Just(
					$author$project$Components$CarrierInvoiceAuditChecks$checkElementId(
						$author$project$Components$CarrierInvoiceAuditChecks$identifier(check))),
				expansion: A4($author$project$Components$CarrierInvoiceAuditChecks$passedExpansion, isEditable, model, check, ruleCheck.checkType),
				hasUnsavedEdit: A2($author$project$Components$CarrierInvoiceAuditChecks$hasUnsavedExtractedEdit, model, check),
				title: $author$project$Components$CarrierInvoiceAuditChecks$title(ruleCheck.checkType),
				tone: $author$project$Components$AuditCompletedChecks$Positive
			};
		} else {
			var event = _v0.a;
			return {
				description: '',
				domId: $elm$core$Maybe$Nothing,
				expansion: $author$project$Components$AuditCompletedChecks$NothingMoreToShow,
				hasUnsavedEdit: false,
				title: $author$project$Components$CarrierInvoiceAuditChecks$eventTitle(event),
				tone: $author$project$Components$AuditCompletedChecks$Positive
			};
		}
	});
var $author$project$Components$AuditCompletedChecks$Settled = {$: 'Settled'};
var $author$project$Components$AuditCompletedChecks$Warning = {$: 'Warning'};
var $author$project$Components$AuditCompletedChecks$toneIcon = function (tone) {
	switch (tone.$) {
		case 'Positive':
			return $author$project$Ui$V3$Icon$checkCircle16;
		case 'Warning':
			return $author$project$Ui$V3$Icon$alertTriangle16;
		default:
			return $author$project$Ui$V3$Icon$removeCircle16;
	}
};
var $author$project$Components$AuditCompletedChecks$unsavedChip = function (hasUnsavedEdit) {
	return hasUnsavedEdit ? _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__chip invoice-audit__chip--unsaved')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unsaved')
				]))
		]) : _List_Nil;
};
var $author$project$Components$AuditCompletedChecks$viewRow = function (_v0) {
	var expansion = _v0.expansion;
	var domId = _v0.domId;
	var hasUnsavedEdit = _v0.hasUnsavedEdit;
	var tone = _v0.tone;
	var description = _v0.description;
	var title = _v0.title;
	var headerAttrs = function () {
		if (expansion.$ === 'Expandable') {
			var onToggle = expansion.a.onToggle;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__passed-header'),
					$elm$html$Html$Events$onClick(onToggle)
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__passed-header invoice-audit__passed-header--no-chevron')
				]);
		}
	}();
	var chevron = function () {
		if (expansion.$ === 'Expandable') {
			var isExpanded = expansion.a.isExpanded;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__passed-chevron')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Icon$view16,
							_List_Nil,
							isExpanded ? $author$project$Ui$V3$Icon$chevronDown16 : $author$project$Ui$V3$Icon$chevronRight16)
						]))
				]);
		} else {
			return _List_Nil;
		}
	}();
	var body = function () {
		if (expansion.$ === 'Expandable') {
			var expanded = expansion.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('invoice-audit__passed-body-wrapper', true),
									_Utils_Tuple2('invoice-audit__passed-body-wrapper--expanded', expanded.isExpanded)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit__passed-body-clip')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invoice-audit__passed-body')
										]),
									_List_fromArray(
										[expanded.body]))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	}();
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('invoice-audit__passed-item'),
			A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$id,
				$elm_community$maybe_extra$Maybe$Extra$toList(domId))),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('invoice-audit__passed-icon', true),
								_Utils_Tuple2(
								'invoice-audit__passed-icon--warning',
								_Utils_eq(tone, $author$project$Components$AuditCompletedChecks$Warning)),
								_Utils_Tuple2(
								'invoice-audit__passed-icon--neutral',
								_Utils_eq(tone, $author$project$Components$AuditCompletedChecks$Settled))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Icon$view16,
						_List_Nil,
						$author$project$Components$AuditCompletedChecks$toneIcon(tone))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('invoice-audit__passed-content', true),
								_Utils_Tuple2('invoice-audit__passed-content--unsaved', hasUnsavedEdit)
							]))
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						headerAttrs,
						_Utils_ap(
							chevron,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invoice-audit__passed-header-text')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('invoice-audit__passed-title')
												]),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$text(title),
												$author$project$Components$AuditCompletedChecks$unsavedChip(hasUnsavedEdit))),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('invoice-audit__passed-desc')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(description)
												]))
										]))
								]))),
					body))
			]));
};
var $author$project$Components$AuditCompletedChecks$viewSectionHeader = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__section-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__section-header-label invoice-audit__section-header-label--strong')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__section-header-line')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$AuditCompletedChecks$viewSection = function (_v0) {
	var rows = _v0.rows;
	var label = _v0.label;
	return $elm$core$List$isEmpty(rows) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$AuditCompletedChecks$viewSectionHeader(label),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__passed-list')
						]),
					A2($elm$core$List$map, $author$project$Components$AuditCompletedChecks$viewRow, rows))
				]))
		]);
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewPassedGroup = F3(
	function (isEditable, model, checks) {
		return $author$project$Components$AuditCompletedChecks$viewSection(
			{
				label: 'Automatically Passed Checks',
				rows: A2(
					$elm$core$List$map,
					A2($author$project$Components$CarrierInvoiceAuditChecks$passedRow, isEditable, model),
					A2($author$project$Components$CarrierInvoiceAuditChecks$withResult, $author$project$AuditPb$CarrierInvoiceAuditCheckResultPassed, checks))
			});
	});
var $author$project$Components$CarrierInvoiceAuditChecks$resolvedBody = F2(
	function (model, checkType) {
		var _v0 = checkType.check;
		if (_v0.$ === 'CarrierInvoiceAuditCheckType_Check_CustomerInstructionsCheck') {
			var customers = _v0.a.customers;
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__check-body')
						]),
					_List_fromArray(
						[
							$author$project$Components$CarrierInvoiceAuditChecks$viewCustomerInstructions(customers)
						])));
		} else {
			return A3($author$project$Components$CarrierInvoiceAuditChecks$completedExtractedFields, false, model, checkType);
		}
	});
var $author$project$Components$AuditFailureHistory$view = function (_v0) {
	var leaf = _v0.leaf;
	var rows = _v0.rows;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__section-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__section-header-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Failure History')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__section-header-line')
							]),
						_List_Nil)
					])),
			_Utils_ap(
				rows,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__section-divider')
							]),
						_List_fromArray(
							[leaf]))
					]))));
};
var $author$project$Components$AuditFailureHistory$Ignored = {$: 'Ignored'};
var $author$project$Components$CarrierInvoiceAuditChecks$UnignoreFailureClicked = function (a) {
	return {$: 'UnignoreFailureClicked', a: a};
};
var $author$project$Components$AuditFailureHistory$viewRuleRow = function (_v0) {
	var isDisabled = _v0.isDisabled;
	var onUnignore = _v0.onUnignore;
	var text = _v0.text;
	var kind = _v0.kind;
	var undoButton = function (label) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__action-end')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$V3$Button$view,
						{
							action: $author$project$Ui$V3$Button$onClick(onUnignore)
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
								$author$project$Components$AuditCheckActions$buttonSize,
								$author$project$Ui$V3$Button$disabled(isDisabled)
							]),
						label)
					]))
			]);
	};
	var trailing = function () {
		switch (kind.$) {
			case 'Ignored':
				return undoButton('Unignore');
			case 'Confirmed':
				return undoButton('Unconfirm');
			default:
				return _List_Nil;
		}
	}();
	var _v1 = function () {
		switch (kind.$) {
			case 'Resolved':
				return _Utils_Tuple3(
					'passing',
					'Passing',
					_Utils_Tuple2('resolved', 'Resolved'));
			case 'Ignored':
				return _Utils_Tuple3(
					'ignored',
					'Ignored',
					_Utils_Tuple2('ignored', 'Ignored'));
			default:
				return _Utils_Tuple3(
					'passing',
					'Confirmed',
					_Utils_Tuple2('resolved', 'Confirmed'));
		}
	}();
	var modifier = _v1.a;
	var description = _v1.b;
	var _v2 = _v1.c;
	var chipModifier = _v2.a;
	var labelText = _v2.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__resolved-row')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__resolved-now fi-audit__resolved-now--' + modifier),
							$elm$html$Html$Attributes$title(description)
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$error16)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__resolved-was')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__rule-row-label invoice-audit__chip invoice-audit__chip--' + chipModifier)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						]))
				]),
			trailing));
};
var $author$project$Components$CarrierInvoiceAuditChecks$viewIgnoredFailure = F3(
	function (isEditable, model, failure) {
		return $author$project$Components$AuditFailureHistory$viewRuleRow(
			{
				isDisabled: (!isEditable) || _Utils_eq(
					model.ignoreInFlight,
					$elm$core$Maybe$Just(
						$author$project$Components$CarrierInvoiceAuditChecks$Unignoring(failure.id))),
				kind: $author$project$Components$AuditFailureHistory$Ignored,
				onUnignore: $author$project$Components$CarrierInvoiceAuditChecks$UnignoreFailureClicked(failure.id),
				text: failure.message
			});
	});
var $author$project$Components$CarrierInvoiceAuditChecks$resolvedRow = F3(
	function (isEditable, model, check) {
		var _v0 = check.details;
		if (_v0.$ === 'CarrierInvoiceAuditCheck_Details_CarrierInvoiceAuditRuleCheck') {
			var ruleCheck = _v0.a;
			return {
				description: 'Ignored',
				domId: $elm$core$Maybe$Just(
					$author$project$Components$CarrierInvoiceAuditChecks$checkElementId(
						$author$project$Components$CarrierInvoiceAuditChecks$identifier(check))),
				expansion: function () {
					var _v1 = ruleCheck.ignoredFailures;
					if (!_v1.b) {
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$AuditCompletedChecks$NothingMoreToShow,
							A2(
								$elm$core$Maybe$map,
								A2($author$project$Components$CarrierInvoiceAuditChecks$expandable, model, check),
								A2($author$project$Components$CarrierInvoiceAuditChecks$resolvedBody, model, ruleCheck.checkType)));
					} else {
						var ignoredFailures = _v1;
						return A3(
							$author$project$Components$CarrierInvoiceAuditChecks$expandable,
							model,
							check,
							$author$project$Components$AuditFailureHistory$view(
								{
									leaf: A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										A2($author$project$Components$CarrierInvoiceAuditChecks$resolvedBody, model, ruleCheck.checkType)),
									rows: A2(
										$elm$core$List$map,
										A2($author$project$Components$CarrierInvoiceAuditChecks$viewIgnoredFailure, isEditable, model),
										ignoredFailures)
								}));
					}
				}(),
				hasUnsavedEdit: A2($author$project$Components$CarrierInvoiceAuditChecks$hasUnsavedExtractedEdit, model, check),
				title: $author$project$Components$CarrierInvoiceAuditChecks$headerTitle(check),
				tone: $author$project$Components$AuditCompletedChecks$Settled
			};
		} else {
			var event = _v0.a;
			return {
				description: A2($elm$core$Maybe$withDefault, 'Resolved', event.resolution),
				domId: $elm$core$Maybe$Nothing,
				expansion: $author$project$Components$AuditCompletedChecks$NothingMoreToShow,
				hasUnsavedEdit: false,
				title: $author$project$Components$CarrierInvoiceAuditChecks$eventTitle(event),
				tone: $author$project$Components$AuditCompletedChecks$Settled
			};
		}
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewResolvedGroup = F3(
	function (isEditable, model, checks) {
		return $author$project$Components$AuditCompletedChecks$viewSection(
			{
				label: 'Resolved Checks',
				rows: A2(
					$elm$core$List$map,
					A2($author$project$Components$CarrierInvoiceAuditChecks$resolvedRow, isEditable, model),
					_Utils_ap(
						A2($author$project$Components$CarrierInvoiceAuditChecks$withResult, $author$project$AuditPb$CarrierInvoiceAuditCheckResultIgnored, checks),
						A2($author$project$Components$CarrierInvoiceAuditChecks$withResult, $author$project$AuditPb$CarrierInvoiceAuditCheckResultResolved, checks)))
			});
	});
var $author$project$Components$CarrierInvoiceAuditChecks$viewCompleted = F3(
	function (isEditable, model, checks) {
		var _v0 = _Utils_ap(
			A3($author$project$Components$CarrierInvoiceAuditChecks$viewPassedGroup, isEditable, model, checks),
			A3($author$project$Components$CarrierInvoiceAuditChecks$viewResolvedGroup, isEditable, model, checks));
		if (!_v0.b) {
			return A2($author$project$Ui$V3$Typography$body, _List_Nil, 'No completed checks.');
		} else {
			var groups = _v0;
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
					]),
				groups);
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$viewTabContent = F3(
	function (tz, data, model) {
		var _v0 = model.selectedTab;
		switch (_v0.$) {
			case 'Summary':
				var _v1 = A2($author$project$Components$CarrierInvoiceAuditPage$checksViewConfig, data, model);
				if (_v1.$ === 'Just') {
					var config = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$CarrierInvoiceAuditPage$AuditChecksMsg,
						A2($author$project$Components$CarrierInvoiceAuditChecks$view, config, model.auditChecks));
				} else {
					return $author$project$Ui$V3$Skeleton$view(
						{height: $elm$core$Maybe$Nothing});
				}
			case 'CompletedChecks':
				var _v2 = $author$project$Forward$Remote$toMaybe(data.auditChecks);
				if (_v2.$ === 'Just') {
					var checks = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$CarrierInvoiceAuditPage$AuditChecksMsg,
						A3(
							$author$project$Components$CarrierInvoiceAuditChecks$viewCompleted,
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.isEditable;
									},
									$author$project$Forward$Remote$toMaybe(data.carrierInvoice))),
							model.auditChecks,
							checks));
				} else {
					return $author$project$Ui$V3$Skeleton$view(
						{height: $elm$core$Maybe$Nothing});
				}
			default:
				var _v3 = $author$project$Forward$Remote$toMaybe(
					A4(
						$author$project$Forward$Remote$map3,
						$author$project$Components$CarrierInvoiceAuditLoadDetails$Data,
						data.tmsLoadDetails,
						$author$project$Components$CarrierInvoiceAuditPage$carrierOrNothing(data.tmsCarrier),
						data.tmsLoadInformation));
				if (_v3.$ === 'Just') {
					var loadDetails = _v3.a;
					return A2($author$project$Components$CarrierInvoiceAuditLoadDetails$view, tz, loadDetails);
				} else {
					return $author$project$Ui$V3$Skeleton$view(
						{height: $elm$core$Maybe$Nothing});
				}
		}
	});
var $author$project$Components$CarrierInvoiceAuditPage$LoadDetails = {$: 'LoadDetails'};
var $author$project$Components$CarrierInvoiceAuditChecks$hasUnsavedCompletedCheck = F2(
	function (checks, edits) {
		var completedIds = A2(
			$elm$core$List$map,
			$author$project$Components$CarrierInvoiceAuditChecks$identifier,
			$author$project$Components$CarrierInvoiceAuditChecks$completed(checks));
		return A2(
			$elm$core$List$any,
			function (edit) {
				return A2($elm$core$List$member, edit.checkId, completedIds);
			},
			edits);
	});
var $author$project$Components$CarrierInvoiceAuditPage$hasUnsavedCompletedCheck = F2(
	function (data, edits) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (checks) {
					return A2($author$project$Components$CarrierInvoiceAuditChecks$hasUnsavedCompletedCheck, checks, edits);
				},
				$author$project$Forward$Remote$toMaybe(data.auditChecks)));
	});
var $author$project$Path$legacyCarrierInvoice = F6(
	function (loadStateId, carrierInvoiceId, requiresLtlReconciliation, maybeEmailMessageId, maybeReplyEmailId, maybeOnDone) {
		var emailQuery = F2(
			function (name, maybeId) {
				if (maybeId.$ === 'Just') {
					var id = maybeId.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							name,
							$elm$core$String$fromInt(
								$author$project$Domain$EmailMessageId$toInt(id)))
						]);
				} else {
					return _List_Nil;
				}
			});
		return A2(
			$author$project$Path$addQueries,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('forceReact', 'true'),
				_Utils_ap(
					A2(emailQuery, 'emailMessageId', maybeEmailMessageId),
					_Utils_ap(
						A2(emailQuery, 'emailId', maybeReplyEmailId),
						$author$project$Path$onDoneQuery(maybeOnDone)))),
			A3($author$project$Path$carrierInvoiceWithLoad, loadStateId, carrierInvoiceId, requiresLtlReconciliation));
	});
var $author$project$Ui$V3$Button$Link = F2(
	function (a, b) {
		return {$: 'Link', a: a, b: b};
	});
var $author$project$Ui$V3$Button$asLink = F2(
	function (href, linkAttrs) {
		return A2($author$project$Ui$V3$Button$Link, href, linkAttrs);
	});
var $author$project$Components$JumpToLegacyInvoiceButton$view = function (_v0) {
	var legacyHref = _v0.legacyHref;
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: A2($author$project$Ui$V3$Button$asLink, legacyHref, _List_Nil)
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
			]),
		'View Legacy Page');
};
var $author$project$Components$CarrierInvoiceAuditPage$viewJumpToLegacy = F2(
	function (model, carrierInvoice) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ci-audit__tabs-action')
				]),
			_List_fromArray(
				[
					$author$project$Components$JumpToLegacyInvoiceButton$view(
					{
						legacyHref: $author$project$Path$toString(
							A6($author$project$Path$legacyCarrierInvoice, carrierInvoice.loadStateId, model.carrierInvoiceId, carrierInvoice.ltlData.requiresReconciliation, model.emailMessageId, model.replyEmailId, model.onDone))
					})
				]));
	});
var $author$project$Components$AuditUnsavedEdits$viewPip = function (isShown) {
	return isShown ? _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__tab-pip invoice-audit__tab-pip--unsaved'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Has unsaved changes')
				]),
			_List_Nil)
		]) : _List_Nil;
};
var $author$project$Components$CarrierInvoiceAuditPage$SelectTab = function (a) {
	return {$: 'SelectTab', a: a};
};
var $author$project$Components$CarrierInvoiceAuditPage$viewTab = F4(
	function (selectedTab, tab, label, extras) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('invoice-audit__tab', true),
							_Utils_Tuple2(
							'invoice-audit__tab--selected',
							_Utils_eq(selectedTab, tab))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Components$CarrierInvoiceAuditPage$SelectTab(tab))
				]),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$text(label),
				extras));
	});
var $author$project$Components$CarrierInvoiceAuditPage$viewTabs = F3(
	function (data, model, edits) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__tabs')
				]),
			_List_fromArray(
				[
					A4($author$project$Components$CarrierInvoiceAuditPage$viewTab, model.selectedTab, $author$project$Components$CarrierInvoiceAuditPage$Summary, 'Summary', _List_Nil),
					A4(
					$author$project$Components$CarrierInvoiceAuditPage$viewTab,
					model.selectedTab,
					$author$project$Components$CarrierInvoiceAuditPage$CompletedChecks,
					'Completed Checks',
					$author$project$Components$AuditUnsavedEdits$viewPip(
						(!_Utils_eq(model.selectedTab, $author$project$Components$CarrierInvoiceAuditPage$CompletedChecks)) && A2($author$project$Components$CarrierInvoiceAuditPage$hasUnsavedCompletedCheck, data, edits))),
					A4($author$project$Components$CarrierInvoiceAuditPage$viewTab, model.selectedTab, $author$project$Components$CarrierInvoiceAuditPage$LoadDetails, 'Load Details', _List_Nil),
					A2(
					$author$project$Helpers$Html$showMaybe,
					$author$project$Components$CarrierInvoiceAuditPage$viewJumpToLegacy(model),
					$author$project$Forward$Remote$toMaybe(data.carrierInvoice))
				]));
	});
var $author$project$Components$CarrierInvoiceAuditPage$viewChecks = F3(
	function (tz, data, model) {
		if (model.documentsBrowser.documentTypePickerOpen) {
			return A2($author$project$Components$CarrierInvoiceAuditPage$viewDocumentTypePicker, data, model);
		} else {
			var edits = A2($author$project$Components$CarrierInvoiceAuditPage$unsavedEdits, data, model);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__panel-wrapper')
					]),
				_List_fromArray(
					[
						A3($author$project$Components$CarrierInvoiceAuditPage$viewTabs, data, model, edits),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__panel')
							]),
						_List_fromArray(
							[
								A3($author$project$Components$CarrierInvoiceAuditPage$viewTabContent, tz, data, model)
							])),
						A2(
						$author$project$Components$AuditUnsavedEdits$viewStrip,
						{onReview: $author$project$Components$CarrierInvoiceAuditPage$ReviewUnsavedEditClicked},
						edits),
						A2($author$project$Components$CarrierInvoiceAuditPage$viewActionBar, data, model)
					]));
		}
	});
var $author$project$Components$DocumentsBrowser$EnableLineDragging = {$: 'EnableLineDragging'};
var $author$project$Components$DocumentsBrowser$enableLineDragging = $author$project$Components$DocumentsBrowser$EnableLineDragging;
var $author$project$Components$DocumentsBrowser$ExpandButton = function (a) {
	return {$: 'ExpandButton', a: a};
};
var $author$project$Components$DocumentsBrowser$expandButton = $author$project$Components$DocumentsBrowser$ExpandButton;
var $author$project$Components$AuditSplitPane$isExpanded = function (_v0) {
	var model = _v0.a;
	return model.expanded;
};
var $author$project$Components$DocumentsBrowser$PopoutButton = {$: 'PopoutButton'};
var $author$project$Components$DocumentsBrowser$popoutButton = $author$project$Components$DocumentsBrowser$PopoutButton;
var $author$project$Components$AuditDocumentsColumn$forceMarginForToolbarCss = '\u000A    .enable_shared-ui-v3 .document-browser__document-list {\u000A        margin-top: 37px;\u000A    }\u000A    ';
var $author$project$Components$AuditDocumentsColumn$view = F4(
	function (tz, browser, options, remoteData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__documents')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
					if (_v0.$ === 'Just') {
						var data = _v0.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit__documents-inner')
								]),
							_List_fromArray(
								[
									A3(
									$elm$html$Html$node,
									'style',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Components$AuditDocumentsColumn$forceMarginForToolbarCss)
										])),
									A4($author$project$Components$DocumentsBrowser$view, tz, browser, options, data)
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'height', '480px')
								]),
							_List_fromArray(
								[
									$author$project$Ui$V3$Skeleton$view(
									{height: $elm$core$Maybe$Nothing})
								]));
					}
				}()
				]));
	});
var $author$project$Components$CarrierInvoiceAuditPage$viewDocumentsBrowser = F3(
	function (tz, data, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$CarrierInvoiceAuditPage$DocumentsBrowserMsg,
			A4(
				$author$project$Components$AuditDocumentsColumn$view,
				tz,
				A2($author$project$Components$CarrierInvoiceAuditPage$browserWithDocumentTypes, data, model),
				_List_fromArray(
					[
						$author$project$Components$DocumentsBrowser$enableLineDragging,
						$author$project$Components$DocumentsBrowser$expandButton(
						{
							expanded: $author$project$Components$AuditSplitPane$isExpanded(model.splitPane)
						}),
						$author$project$Components$DocumentsBrowser$popoutButton
					]),
				data.documentsBrowserData));
	});
var $author$project$Components$CarrierInvoiceAuditPage$ExceptionSent = {$: 'ExceptionSent'};
var $author$project$Components$CarrierInvoiceAuditPage$SendToCarrierClosed = {$: 'SendToCarrierClosed'};
var $author$project$Ui$V3$Modal$Large = {$: 'Large'};
var $author$project$Ui$V3$Modal$large = $author$project$Ui$V3$Modal$Large;
var $author$project$Components$CarrierInvoiceAuditSendToCarrierModal$view = function (config) {
	return A2(
		$author$project$Ui$V3$Modal$view,
		_List_Nil,
		{
			body: A3(
				$elm$html$Html$node,
				'ht-exception-sender',
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Attributes$attribute,
							'carrier-invoice-id',
							$elm$core$String$fromInt(
								$author$project$Domain$CarrierInvoiceId$toInt(config.carrierInvoiceId))),
							A2(
							$elm$html$Html$Attributes$attribute,
							'load-state-id',
							$elm$core$String$fromInt(
								$author$project$Domain$LoadStateId$toInt(config.loadStateId))),
							A2(
							$elm$html$Html$Events$on,
							'exception-sent',
							$elm$json$Json$Decode$succeed(config.sentMsg)),
							A2(
							$elm$html$Html$Events$on,
							'exception-cancelled',
							$elm$json$Json$Decode$succeed(config.closedMsg))
						]),
					function () {
						var _v0 = config.emailMessageId;
						if (_v0.$ === 'Just') {
							var emailMessageId = _v0.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$attribute,
									'email-id',
									$elm$core$String$fromInt(
										$author$project$Domain$EmailMessageId$toInt(emailMessageId)))
								]);
						} else {
							return _List_Nil;
						}
					}()),
				_List_Nil),
			cancelButton: $elm$core$Maybe$Nothing,
			dismissMsg: config.closedMsg,
			footerButtons: _List_Nil,
			header: $author$project$Ui$V3$Modal$textHeader('Send to Carrier'),
			primaryButton: $elm$core$Maybe$Nothing,
			size: $author$project$Ui$V3$Modal$large
		});
};
var $author$project$Components$CarrierInvoiceAuditPage$viewSendToCarrierModal = F2(
	function (data, model) {
		var _v0 = _Utils_Tuple2(
			model.sendToCarrierOpen,
			$author$project$Forward$Remote$toMaybe(data.carrierInvoice));
		if (_v0.a && (_v0.b.$ === 'Just')) {
			var carrierInvoice = _v0.b.a;
			return $author$project$Components$CarrierInvoiceAuditSendToCarrierModal$view(
				{carrierInvoiceId: model.carrierInvoiceId, closedMsg: $author$project$Components$CarrierInvoiceAuditPage$SendToCarrierClosed, emailMessageId: model.emailMessageId, loadStateId: carrierInvoice.loadStateId, sentMsg: $author$project$Components$CarrierInvoiceAuditPage$ExceptionSent});
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$AuditSplitPane$documentsBasis = F2(
	function (width, savedWidthPx) {
		switch (width.$) {
			case 'Dragged':
				var widthPx = width.a;
				return $author$project$Ui$V3$Stack$fitPx(widthPx);
			case 'Even':
				return $author$project$Ui$V3$Stack$flex1;
			default:
				if (savedWidthPx.$ === 'Just') {
					var widthPx = savedWidthPx.a;
					return $author$project$Ui$V3$Stack$fitPx(widthPx);
				} else {
					return $author$project$Ui$V3$Stack$flex1;
				}
		}
	});
var $author$project$Components$AuditSplitPane$HandleDoubleClicked = {$: 'HandleDoubleClicked'};
var $author$project$Components$AuditSplitPane$HandlePressed = {$: 'HandlePressed'};
var $author$project$Components$AuditSplitPane$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'mousedown',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: true, stopPropagation: true}));
};
var $author$project$Components$AuditSplitPane$viewHandle = function (toMsg) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__split-handle'),
				A2($elm$html$Html$Attributes$attribute, 'role', 'separator'),
				A2($elm$html$Html$Attributes$attribute, 'aria-orientation', 'vertical'),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Resize the document viewer'),
				$elm$html$Html$Attributes$title('Drag to resize the document viewer, or double click for an even split'),
				$author$project$Components$AuditSplitPane$onMouseDown(
				toMsg($author$project$Components$AuditSplitPane$HandlePressed)),
				$elm$html$Html$Events$onDoubleClick(
				toMsg($author$project$Components$AuditSplitPane$HandleDoubleClicked))
			]),
		_List_Nil);
};
var $author$project$Components$AuditSplitPane$ShowDocumentsHereClicked = {$: 'ShowDocumentsHereClicked'};
var $author$project$Components$AuditSplitPane$viewPoppedOut = function (toMsg) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__popped-out')
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick(
						toMsg($author$project$Components$AuditSplitPane$ShowDocumentsHereClicked))
				},
				_List_Nil,
				'Show documents here')
			]));
};
var $author$project$Components$AuditSplitPane$viewSplit = F2(
	function (_v0, _v1) {
		var toMsg = _v0.toMsg;
		var savedWidthPx = _v0.savedWidthPx;
		var documents = _v0.documents;
		var left = _v0.left;
		var model = _v1.a;
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'align-items', 'stretch')),
					$author$project$Ui$V3$Stack$htmlAttribute(
					$elm$html$Html$Attributes$id($author$project$Components$AuditSplitPane$containerId))
				]),
			model.poppedOut ? _List_fromArray(
				[
					_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, left),
					_Utils_Tuple2(
					A2($author$project$Components$AuditSplitPane$documentsBasis, model.width, savedWidthPx),
					$author$project$Components$AuditSplitPane$viewPoppedOut(toMsg))
				]) : (model.expanded ? _List_fromArray(
				[
					_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, documents)
				]) : _List_fromArray(
				[
					_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, left),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fitPx($author$project$Components$AuditSplitPane$handleWidthPx),
					$author$project$Components$AuditSplitPane$viewHandle(toMsg)),
					_Utils_Tuple2(
					A2($author$project$Components$AuditSplitPane$documentsBasis, model.width, savedWidthPx),
					documents)
				])));
	});
var $author$project$Components$CarrierInvoiceAuditPage$view = F3(
	function (tz, data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Components$AuditSplitPane$viewSplit,
										{
											documents: A3($author$project$Components$CarrierInvoiceAuditPage$viewDocumentsBrowser, tz, data, model),
											left: A3($author$project$Components$CarrierInvoiceAuditPage$viewChecks, tz, data, model),
											savedWidthPx: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.auditDocumentsColumnWidth;
												},
												$author$project$Forward$Remote$toMaybe(data.currentUser)),
											toMsg: $author$project$Components$CarrierInvoiceAuditPage$SplitPaneMsg
										},
										model.splitPane)
									])),
								A2($author$project$Components$CarrierInvoiceAuditPage$viewSendToCarrierModal, data, model)
							])))
				]));
	});
var $author$project$Components$DashboardPage$SelectedQueue = function (a) {
	return {$: 'SelectedQueue', a: a};
};
var $author$project$Components$DashboardPage$DashboardSavedFilterOpenEditModal = {$: 'DashboardSavedFilterOpenEditModal'};
var $author$project$Components$DashboardPage$DashboardSavedFilterSaving = {$: 'DashboardSavedFilterSaving'};
var $author$project$Components$DashboardPage$DashboardSavedFilterSelected = function (a) {
	return {$: 'DashboardSavedFilterSelected', a: a};
};
var $author$project$Components$DashboardPage$UpdatePreferredFilters = {$: 'UpdatePreferredFilters'};
var $author$project$Components$Dashboard$FilterBar$CarrierFilter$view = F5(
	function (_v0, _v1, carrierDropdownMsg, carrierDropdownData, carrierDropdown) {
		return A2(
			$elm$html$Html$map,
			carrierDropdownMsg,
			A3($author$project$Components$CarrierDropdown$view, _List_Nil, carrierDropdownData, carrierDropdown));
	});
var $author$project$Components$Dashboard$FilterBar$viewCarrierFilter = F3(
	function (account, accountSettings, _v0) {
		var dropdownModel = _v0.dropdownModel;
		var dropdownData = _v0.dropdownData;
		var dropdownMsg = _v0.dropdownMsg;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__carrier-filter-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__carrier-filter-v3-container')
						]),
					_List_fromArray(
						[
							A5($author$project$Components$Dashboard$FilterBar$CarrierFilter$view, account.factorAccount, accountSettings.showCarrierExternalVendorId, dropdownMsg, dropdownData, dropdownModel)
						]))
				]));
	});
var $author$project$Components$DashboardPage$carrierFilterView = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__filters-customer-dropdown')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$Dashboard$FilterBar$viewCarrierFilter,
					data.account,
					data.accountSettings,
					{dropdownData: data.carrierDropdown, dropdownModel: model.carrierDropdown, dropdownMsg: $author$project$Components$DashboardPage$CarrierDropdownMsg})
				]));
	});
var $author$project$Components$DashboardPage$ClearAllFilters = {$: 'ClearAllFilters'};
var $author$project$Components$DashboardPage$clearButton = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('message__action-area')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme message__action-button-v3')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$V3$Button$view,
							{
								action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardPage$ClearAllFilters)
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium)
								]),
							'Clear All')
						]))
				]))
		]));
var $author$project$Components$CustomerDropdown$view = F2(
	function (data, model) {
		return A4(
			$author$project$Components$PaginatedDropdown$view,
			$author$project$Components$CustomerDropdown$tmsCustomerToDropdownItem,
			data,
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$label('Customer')
				]),
			model.dropdown);
	});
var $author$project$Components$Dashboard$FilterBar$viewCustomerFilter = function (_v0) {
	var dropdownModel = _v0.dropdownModel;
	var dropdownData = _v0.dropdownData;
	var dropdownMsg = _v0.dropdownMsg;
	return A2(
		$elm$html$Html$map,
		dropdownMsg,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__customer-filter')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__customer-filter-container')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$CustomerDropdown$view, dropdownData, dropdownModel)
						]))
				])));
};
var $author$project$Components$DashboardPage$customerFilterView = F2(
	function (data, model) {
		return A2($author$project$Components$DashboardPage$shouldShowCustomerDropdown, model.dashboardMode, data.account) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__filters-customer-dropdown')
				]),
			_List_fromArray(
				[
					$author$project$Components$Dashboard$FilterBar$viewCustomerFilter(
					{dropdownData: data.customerDropdown, dropdownModel: model.customerDropdown, dropdownMsg: $author$project$Components$DashboardPage$CustomerDropdownMsg})
				])) : $elm$html$Html$text('');
	});
var $author$project$Components$DashboardPage$SelectEndDate = F2(
	function (a, b) {
		return {$: 'SelectEndDate', a: a, b: b};
	});
var $author$project$Components$DashboardPage$SelectStartDate = F2(
	function (a, b) {
		return {$: 'SelectStartDate', a: a, b: b};
	});
var $author$project$Ui$V3$Input$ClassAttribute = function (a) {
	return {$: 'ClassAttribute', a: a};
};
var $author$project$Ui$V3$Input$class = function (value) {
	return $author$project$Ui$V3$Input$ClassAttribute(value);
};
var $author$project$Components$DashboardPage$dateInput = F4(
	function (inputAttr, labelStr, onInput, val) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('date-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__input-label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__input-label-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labelStr)
								]))
						])),
					A4(
					$author$project$Ui$V3$Input$view,
					{onInput: onInput},
					_List_fromArray(
						[
							inputAttr,
							$author$project$Ui$V3$Input$class('date-input-v3')
						]),
					_List_Nil,
					val)
				]));
	});
var $author$project$Components$DashboardPage$dateString = function (date) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, date));
};
var $author$project$Ui$V3$CustomSelect$isEmpty = function (_v0) {
	var model = _v0.a;
	return $elm$core$List$isEmpty(model.items);
};
var $author$project$Components$DashboardPage$maybeRangeTypeSelect = F2(
	function (data, model) {
		var dateRangeDropdown = A3($author$project$Components$DashboardPage$updatedDateRangeFilter, data, model, model.dateRangeDropdown);
		return $author$project$Ui$V3$CustomSelect$isEmpty(dateRangeDropdown) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme dashboard__date-range-dropdown')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$DashboardPage$DateRangeDropdownMsg,
							A2(
								$author$project$Ui$V3$CustomSelect$view,
								dateRangeDropdown,
								_List_fromArray(
									[
										$author$project$Ui$V3$CustomSelect$label('Date Range')
									])))
						]))
				]));
	});
var $author$project$Components$DashboardPage$dateRangeView = F3(
	function (tz, data, model) {
		var date = F3(
			function (labelStr, onInput, val) {
				return A4(
					$author$project$Components$DashboardPage$dateInput,
					$author$project$Ui$V3$Input$date,
					labelStr,
					onInput,
					$author$project$Components$DashboardPage$dateString(val));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('date-range date-range-v3 v3__theme')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$DashboardPage$maybeRangeTypeSelect, data, model),
							A3(
							date,
							'Start Date',
							$author$project$Components$DashboardPage$SelectStartDate(tz),
							model.startDate),
							A3(
							date,
							'End Date',
							$author$project$Components$DashboardPage$SelectEndDate(tz),
							model.endDate)
						]))
				]));
	});
var $author$project$Components$DashboardPage$dateTimeString = F2(
	function (internalDate, tz) {
		if (internalDate.$ === 'Nothing') {
			return '';
		} else {
			var date = internalDate.a;
			var year = A3(
				$elm$core$String$padLeft,
				4,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					A2($elm$time$Time$toYear, tz, date)));
			var second = A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, tz, date)));
			var month = A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					$justinmimbs$date$Date$monthToNumber(
						A2($elm$time$Time$toMonth, tz, date))));
			var minute = A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, tz, date)));
			var hour = A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					A2($elm$time$Time$toHour, tz, date)));
			var day = A3(
				$elm$core$String$padLeft,
				2,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					A2($elm$time$Time$toDay, tz, date)));
			return year + ('-' + (month + ('-' + (day + ('T' + (hour + (':' + (minute + (':' + second)))))))));
		}
	});
var $author$project$Components$DashboardPage$dateTimeRangeView = F3(
	function (tz, data, model) {
		var date = F3(
			function (labelStr, onInput, val) {
				return A4(
					$author$project$Components$DashboardPage$dateInput,
					$author$project$Ui$V3$Input$dateTime,
					labelStr,
					onInput,
					A2($author$project$Components$DashboardPage$dateTimeString, val, tz));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('date-range date-range-v3 date-range-datetime v3__theme')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$DashboardPage$maybeRangeTypeSelect, data, model),
							A3(
							date,
							'Start Date',
							$author$project$Components$DashboardPage$SelectStartDate(tz),
							model.startDateTime),
							A3(
							date,
							'End Date',
							$author$project$Components$DashboardPage$SelectEndDate(tz),
							model.endDateTime)
						]))
				]));
	});
var $author$project$Components$Dashboard$FilterBar$filterSelectView = F8(
	function (savedFilters, selectedSavedFilter, getName, onUpdateMsg, onSaveMsg, openEditModalMsg, isSaving, isEmpty) {
		var options = A2($elm$core$List$sortBy, getName, savedFilters);
		var editButton = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(openEditModalMsg)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Icon$view16,
					_List_fromArray(
						[
							$author$project$Ui$V3$Icon$label('Open Modal')
						]),
					$author$project$Ui$V3$Icon$cog16)
				]));
		var dropdown = A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{onInput: onUpdateMsg, options: options, toLabel: getName, value: selectedSavedFilter},
			_List_fromArray(
				[
					$author$project$Ui$V3$SimpleSelect$placeholder(
					$elm$core$Maybe$Just('--'))
				]));
		var buttonText = ((!_Utils_eq(selectedSavedFilter, $elm$core$Maybe$Nothing)) || isSaving) ? 'Saved' : 'Save';
		var buttonDisabled = (!_Utils_eq(selectedSavedFilter, $elm$core$Maybe$Nothing)) || (isSaving || isEmpty);
		var saveButton = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(onSaveMsg)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
					$author$project$Ui$V3$Button$disabled(buttonDisabled)
				]),
			buttonText);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter__preferred-filter-checkbox-area'),
					$elm$html$Html$Attributes$class('filter__dashboard-saved-filter-select-area'),
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					_List_fromArray(
						[saveButton, dropdown, editButton]))
				]));
	});
var $author$project$Components$DashboardPage$EnableFlowMode = {$: 'EnableFlowMode'};
var $author$project$Components$DashboardPage$flowModeButton = F4(
	function (accountSettings, user, dashboardRows, model) {
		var buttonVisible = A3($author$project$Components$Dashboard$AvailableQueues$supportsFlowMode, model.selectedQueue, model.dashboardMode, accountSettings);
		var batchesEmpty = $elm$core$List$isEmpty(
			$author$project$Components$DashboardPage$flowModeItems(dashboardRows));
		return (buttonVisible && (!user.readOnlyFactorInvoices)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__action-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('enable_shared-ui-v3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__theme message__action-button-v3')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardPage$EnableFlowMode)
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
											$author$project$Ui$V3$Button$disabled(batchesEmpty)
										]),
									'Enter Flow Mode')
								]))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Components$Dashboard$AvailableQueues$hasExceptionsColumn = function (queue) {
	switch (queue.$) {
		case 'NewQueue':
			return false;
		case 'FactorNeedsIndexingQueue':
			return false;
		case 'ReadyToAuditQueue':
			return true;
		case 'ExceptionQueue':
			return true;
		case 'RepliesQueue':
			return true;
		case 'WaitingQueue':
			return true;
		case 'VerifyQueue':
			return false;
		default:
			return false;
	}
};
var $author$project$Components$DashboardPage$ignoreButtonVisible = F3(
	function (_v0, accountSettings, dashboardRows) {
		var _v1 = _Utils_Tuple2(dashboardRows, accountSettings.ignoreMode);
		_v1$6:
		while (true) {
			if (_v1.b.$ === 'IgnoreModeBulkIgnore') {
				switch (_v1.a.$) {
					case 'NewEmailData':
						var _v2 = _v1.b;
						return true;
					case 'ReplyEmailData':
						var _v3 = _v1.b;
						return true;
					case 'UnsentExceptionedData':
						var _v4 = _v1.b;
						return true;
					case 'ProcessedBrokerData':
						var _v5 = _v1.b;
						return true;
					case 'ProcessedFactorData':
						var _v6 = _v1.b;
						return true;
					case 'ReadyToAuditCarrierInvoiceData':
						var _v7 = _v1.b;
						return true;
					default:
						break _v1$6;
				}
			} else {
				break _v1$6;
			}
		}
		return false;
	});
var $author$project$Components$DashboardPage$ShowIgnoreModal = {$: 'ShowIgnoreModal'};
var $author$project$Components$DashboardPage$showIgnoreButton = function (model) {
	var isDisabled = $timo_weike$generic_collections$ManualSet$isEmpty(model.selectedSelectables);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__action-area')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('enable_shared-ui-v3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v3__theme message__action-button-v3')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardPage$ShowIgnoreModal)
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
										$author$project$Ui$V3$Button$disabled(isDisabled)
									]),
								'Ignore')
							]))
					]))
			]));
};
var $author$project$Components$DashboardPage$ignoreButton = F4(
	function (model, accountSettings, currentUser, dashboardRows) {
		return ($author$project$Components$DashboardPage$canPerformQueueActions(currentUser) && A3($author$project$Components$DashboardPage$ignoreButtonVisible, model, accountSettings, dashboardRows)) ? $author$project$Components$DashboardPage$showIgnoreButton(model) : $elm$html$Html$text('');
	});
var $author$project$Domain$DashboardFilters$factorBrokersToString = function (factorBrokerIds) {
	return A2(
		$elm$core$String$join,
		',',
		A2(
			$elm$core$List$map,
			$elm$core$String$fromInt,
			A2($elm$core$List$map, $author$project$Domain$FactorBrokerId$toInt, factorBrokerIds)));
};
var $author$project$Domain$DashboardFilters$maybeCarrierToString = function (carrierIds) {
	return $elm$core$List$isEmpty(carrierIds) ? 'null' : A2(
		$elm$core$String$join,
		',',
		A2(
			$elm$core$List$map,
			$elm$core$String$fromInt,
			A2($elm$core$List$map, $author$project$Domain$TmsCarrierId$toInt, carrierIds)));
};
var $author$project$Domain$DashboardFilters$toComparable = function (dashboardFilters) {
	var labelFilters = $author$project$Domain$LabelFilter$listToComparable(dashboardFilters.labelFilters);
	var customerFilters = A2(
		$elm$core$String$join,
		' . ',
		A2($elm$core$List$map, $author$project$Domain$Customer$toStringKey, dashboardFilters.customers));
	return 'CarrierId: ' + ($author$project$Domain$DashboardFilters$maybeCarrierToString(dashboardFilters.tmsCarrierIds) + ('. FactorBrokerId: ' + ($author$project$Domain$DashboardFilters$factorBrokersToString(dashboardFilters.factorBrokerIds) + ('. Filters: ' + (labelFilters + ('. DashboardMode: ' + ($author$project$AuditPb$dashboardModeToString(dashboardFilters.dashboardMode) + ('. Customers: ' + (customerFilters + ('. Categories: ' + ($author$project$Domain$CategoryFilter$toString(dashboardFilters.categories) + ('. StartDate: ' + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, dashboardFilters.startDate)) + ('. StartDatetime: ' + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, dashboardFilters.startDateTime))) + ('. EndDate: ' + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, dashboardFilters.endDate)) + ('. EndDatetime: ' + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, dashboardFilters.endDateTime))) + ('. RangeType: ' + ($author$project$Domain$QueueDate$toString(dashboardFilters.rangeType) + ('. Exceptions: ' + A2($elm$core$String$join, ',', dashboardFilters.exceptions)))))))))))))))))))))));
};
var $author$project$Domain$DashboardFilters$isEmpty = F2(
	function (dashboardMode, dashboardFilters) {
		return _Utils_eq(
			$author$project$Domain$DashboardFilters$toComparable(
				_Utils_update(
					$author$project$Domain$DashboardFilters$empty,
					{dashboardMode: dashboardMode})),
			$author$project$Domain$DashboardFilters$toComparable(dashboardFilters));
	});
var $author$project$Domain$DashboardSavedFilter$isSelected = F2(
	function (_v0, savedFilter) {
		var currentMode = _v0.currentMode;
		var currentFilter = _v0.currentFilter;
		var savedFilterDashboardMode = $author$project$AuditPb$dashboardModeToString(savedFilter.dashboardMode);
		var modeString = $author$project$AuditPb$dashboardModeToString(currentMode);
		var comparableSavedFilter = $author$project$Domain$DashboardFilters$toComparable(
			A2($author$project$Domain$DashboardSavedFilter$applySavedFilter, currentFilter, savedFilter));
		var comparableFilter = $author$project$Domain$DashboardFilters$toComparable(currentFilter);
		return _Utils_eq(savedFilterDashboardMode, modeString) && _Utils_eq(comparableFilter, comparableSavedFilter);
	});
var $author$project$Components$DashboardPage$ShowBulkLabelModal = {$: 'ShowBulkLabelModal'};
var $author$project$Components$DashboardPage$labelButton = F2(
	function (model, currentUser) {
		if ($author$project$Components$DashboardPage$canPerformQueueActions(currentUser)) {
			var isDisabled = $timo_weike$generic_collections$ManualSet$isEmpty(model.selectedSelectables);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('enable_shared-ui-v3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3__theme message__action-button-v3')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$V3$Button$view,
										{
											action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardPage$ShowBulkLabelModal)
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
												$author$project$Ui$V3$Button$disabled(isDisabled)
											]),
										'Labels')
									]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$DashboardPage$mergeButtonVisible = F2(
	function (account, dashboardRows) {
		return account.factorAccount && function () {
			if (dashboardRows.$ === 'NewEmailData') {
				return true;
			} else {
				return false;
			}
		}();
	});
var $author$project$Components$DashboardPage$ShowMergeModal = {$: 'ShowMergeModal'};
var $author$project$Components$DashboardPage$customerTypeKey = function (customerType) {
	switch (customerType.$) {
		case 'Customers':
			var customers = customerType.a;
			return function (s) {
				return 'customers:' + s;
			}(
				A2(
					$elm$core$String$join,
					',',
					$elm$core$List$sort(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.id;
								},
								A2($elm$core$Basics$composeR, $author$project$Domain$TmsCustomerId$toInt, $elm$core$String$fromInt)),
							customers))));
		case 'Debtor':
			var broker = customerType.a;
			return 'debtor:' + $elm$core$String$fromInt(
				$author$project$Domain$FactorBrokerId$toInt(broker.id));
		default:
			return 'none';
	}
};
var $author$project$Components$DashboardPage$mergeButtonDisabledReason = F2(
	function (selectedSelectables, dashboardRows) {
		var selectedEmailIds = A3(
			$timo_weike$generic_collections$ManualSet$foldl,
			F2(
				function (selectable, acc) {
					if (selectable.$ === 'EmailMessage') {
						var id = selectable.a;
						return A2($elm$core$List$cons, id, acc);
					} else {
						return acc;
					}
				}),
			_List_Nil,
			selectedSelectables);
		var numSelected = $elm$core$List$length(selectedEmailIds);
		if (numSelected < 2) {
			return $elm$core$Maybe$Just('Select at least 2 emails to merge');
		} else {
			if (dashboardRows.$ === 'NewEmailData') {
				var page = dashboardRows.a;
				var selectedIdInts = A2($elm$core$List$map, $author$project$Domain$EmailMessageId$toInt, selectedEmailIds);
				var selectedRows = A2(
					$elm$core$List$filter,
					function (row) {
						return A2(
							$elm$core$List$member,
							$author$project$Domain$EmailMessageId$toInt(row.emailMessage.id),
							selectedIdInts);
					},
					A2(
						$elm$core$List$filterMap,
						$author$project$Forward$Remote$toMaybe,
						$author$project$Pagination$entries(page)));
				var hasUnknownCarrier = A2(
					$elm$core$List$any,
					function (row) {
						return _Utils_eq(row.maybeTmsCarrier, $elm$core$Maybe$Nothing);
					},
					selectedRows);
				var customerKeys = $elm_community$list_extra$List$Extra$unique(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.customers;
							},
							$author$project$Components$DashboardPage$customerTypeKey),
						selectedRows));
				var carrierIds = $elm_community$list_extra$List$Extra$unique(
					A2(
						$elm$core$List$filterMap,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.maybeTmsCarrier;
							},
							$elm$core$Maybe$map(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.id;
									},
									$author$project$Domain$TmsCarrierId$toInt))),
						selectedRows));
				return ($elm$core$List$length(carrierIds) > 1) ? $elm$core$Maybe$Just('Cannot merge emails from different carriers') : (hasUnknownCarrier ? $elm$core$Maybe$Just('Cannot merge emails with unknown carrier') : (($elm$core$List$length(customerKeys) > 1) ? $elm$core$Maybe$Just('Cannot merge emails from different customers') : (A2(
					$elm$core$List$any,
					function (row) {
						return _Utils_eq(row.emailMessage.importState, $author$project$AuditPb$EmailImportStateImportInProgress);
					},
					selectedRows) ? $elm$core$Maybe$Just('Cannot merge emails that are currently importing') : (A2(
					$elm$core$List$any,
					function (row) {
						return A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$eq(0),
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.pages;
									},
									row.maybeDocumentBatch)));
					},
					selectedRows) ? $elm$core$Maybe$Just('Cannot merge emails with 0 pages') : $elm$core$Maybe$Nothing))));
			} else {
				return $elm$core$Maybe$Just('Merge is only available on the New Emails queue');
			}
		}
	});
var $author$project$Ui$V3$Tooltip$TooltipStyle = F2(
	function (a, b) {
		return {$: 'TooltipStyle', a: a, b: b};
	});
var $author$project$Ui$V3$Tooltip$tooltipStyle = $author$project$Ui$V3$Tooltip$TooltipStyle;
var $author$project$Components$DashboardPage$showMergeButton = F2(
	function (model, dashboardRows) {
		var disabledReason = A2($author$project$Components$DashboardPage$mergeButtonDisabledReason, model.selectedSelectables, dashboardRows);
		var buttonElement = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardPage$ShowMergeModal)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
					$author$project$Ui$V3$Button$disabled(
					!_Utils_eq(disabledReason, $elm$core$Maybe$Nothing))
				]),
			'Merge');
		var wrappedButton = function () {
			if (disabledReason.$ === 'Just') {
				var reason = disabledReason.a;
				return A3(
					$author$project$Ui$V3$Tooltip$view,
					_List_fromArray(
						[
							$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$AboveDirection),
							$author$project$Ui$V3$Tooltip$tooltipLocation($author$project$Ui$V3$Tooltip$MiddleLocation),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'left', '50%'),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'transform', 'translateX(-50%) translateY(calc(-100% - 5px))'),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'max-width', '200px'),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'white-space', 'normal'),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'width', 'max-content')
						]),
					reason,
					buttonElement);
			} else {
				return buttonElement;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__action-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('enable_shared-ui-v3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__theme message__action-button-v3')
								]),
							_List_fromArray(
								[wrappedButton]))
						]))
				]));
	});
var $author$project$Components$DashboardPage$mergeButton = F4(
	function (model, account, currentUser, dashboardRows) {
		return ($author$project$Components$DashboardPage$canPerformQueueActions(currentUser) && A2($author$project$Components$DashboardPage$mergeButtonVisible, account, dashboardRows)) ? A2($author$project$Components$DashboardPage$showMergeButton, model, dashboardRows) : $elm$html$Html$text('');
	});
var $author$project$Domain$LabelFilter$isUnselected = $author$project$Domain$LabelFilter$isState($author$project$Domain$LabelFilter$Unselected);
var $author$project$Components$Dashboard$FilterBar$newPreferredFilterView = F3(
	function (currentUser, updatePreferredFilters, dashboardFilters) {
		var preferrencesMatchSelectedLabels = _Utils_eq(
			$author$project$Domain$LabelFilter$listToComparable(dashboardFilters.labelFilters),
			$author$project$Domain$LabelFilter$listToComparable(
				A2($elm$core$List$map, $author$project$Domain$LabelFilter$fromPb, currentUser.preferredFilters)));
		var preferrencesMatchSelectedCategories = _Utils_eq(
			$author$project$Domain$CategoryFilter$toString(dashboardFilters.categories),
			$author$project$Domain$CategoryFilter$toString(
				A2($elm$core$List$map, $author$project$Domain$CategoryFilter$fromPb, currentUser.preferredCategories)));
		var preferrencesMatchSelectedFilters = preferrencesMatchSelectedCategories && preferrencesMatchSelectedLabels;
		var noPreferenceSet = $elm$core$List$isEmpty(currentUser.preferredFilters);
		var labelsUnselected = A2($elm$core$List$all, $author$project$Domain$LabelFilter$isUnselected, dashboardFilters.labelFilters);
		var categoriesUnselected = $elm$core$List$isEmpty(
			$author$project$Domain$CategoryFilter$filterSelected(dashboardFilters.categories));
		return (labelsUnselected && (categoriesUnselected && noPreferenceSet)) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : (preferrencesMatchSelectedFilters ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter__preferred-filter-checkbox-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('active'),
							$elm$html$Html$Events$onClick(updatePreferredFilters)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-heart')
								]),
							_List_Nil),
							$elm$html$Html$text('Save filters')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter__preferred-filter-checkbox-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(updatePreferredFilters)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-heart')
								]),
							_List_Nil),
							$elm$html$Html$text('Save filters')
						]))
				])));
	});
var $author$project$Components$DashboardPage$LabelFiltersMsg = function (a) {
	return {$: 'LabelFiltersMsg', a: a};
};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$ToggleLabelFilter = function (a) {
	return {$: 'ToggleLabelFilter', a: a};
};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$ClickedAll = {$: 'ClickedAll'};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$allFilterState = function (labelFilters) {
	return A2($elm$core$List$all, $author$project$Domain$LabelFilter$isUnselected, labelFilters) ? $author$project$Domain$LabelFilter$Selected : $author$project$Domain$LabelFilter$Unselected;
};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$negationOf = function (filterLabel) {
	return A2($elm$core$String$startsWith, 'No ', filterLabel) ? ('Has' + A2($elm$core$String$dropLeft, 2, filterLabel)) : ('Not ' + filterLabel);
};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$labelFilterView = F2(
	function (msg, labelFilter) {
		var _v0 = function () {
			var _v1 = labelFilter.state;
			switch (_v1.$) {
				case 'Unselected':
					return _Utils_Tuple2(labelFilter.label, '');
				case 'Selected':
					return _Utils_Tuple2(labelFilter.label, 'active');
				default:
					return _Utils_Tuple2(
						$author$project$Components$Dashboard$FilterBar$LabelFilters$negationOf(labelFilter.label),
						'active negated');
			}
		}();
		var label = _v0.a;
		var cssClass = _v0.b;
		return A2(
			$elm$html$Html$dd,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(cssClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							msg(labelFilter))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Components$Dashboard$FilterBar$LabelFilters$allFilterView = function (labelFilters) {
	return A2(
		$author$project$Components$Dashboard$FilterBar$LabelFilters$labelFilterView,
		$elm$core$Basics$always($author$project$Components$Dashboard$FilterBar$LabelFilters$ClickedAll),
		{
			label: 'All',
			state: $author$project$Components$Dashboard$FilterBar$LabelFilters$allFilterState(labelFilters)
		});
};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$view = F2(
	function (queue, labelFilters) {
		var filtersMinusResolved = A2(
			$elm$core$List$filter,
			function (labelFilter) {
				return labelFilter.label !== 'Resolved Exceptions';
			},
			labelFilters);
		var filtersToView = function () {
			switch (queue.$) {
				case 'NewQueue':
					return filtersMinusResolved;
				case 'FinalQueue':
					return filtersMinusResolved;
				default:
					return labelFilters;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter__filter-container dashboard-filter')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$dt,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('FILTER:')
						])),
					A2(
					$elm$html$Html$dl,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sub-nav')
						]),
					A2(
						$elm$core$List$cons,
						$author$project$Components$Dashboard$FilterBar$LabelFilters$allFilterView(filtersToView),
						A2(
							$elm$core$List$map,
							$author$project$Components$Dashboard$FilterBar$LabelFilters$labelFilterView($author$project$Components$Dashboard$FilterBar$LabelFilters$ToggleLabelFilter),
							filtersToView)))
				]));
	});
var $author$project$Components$Dashboard$FilterBar$maybeView = F3(
	function (selectedQueue, labelFilters, labelFiltersMsg) {
		return A2(
			$elm$html$Html$map,
			labelFiltersMsg,
			A2($author$project$Components$Dashboard$FilterBar$LabelFilters$view, selectedQueue, labelFilters));
	});
var $author$project$Components$DashboardPage$possibleFiltersView = function (model) {
	return A3($author$project$Components$Dashboard$FilterBar$maybeView, model.selectedQueue, model.dashboardFilters.labelFilters, $author$project$Components$DashboardPage$LabelFiltersMsg);
};
var $author$project$Components$Dashboard$FilterBar$viewDebtorFilter = F2(
	function (_v0, _v1) {
		var dropdownModel = _v1.dropdownModel;
		var dropdownData = _v1.dropdownData;
		var dropdownMsg = _v1.dropdownMsg;
		return A2(
			$elm$html$Html$map,
			dropdownMsg,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__debtor-filter')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__debtor-filter-container')
							]),
						_List_fromArray(
							[
								A3($author$project$Components$DebtorDropdown$view, _List_Nil, dropdownData, dropdownModel)
							]))
					])));
	});
var $author$project$Components$Dashboard$FilterBar$viewExceptionsFilter = function (_v0) {
	var dropdownModel = _v0.dropdownModel;
	var dropdownMsg = _v0.dropdownMsg;
	return A2(
		$elm$html$Html$map,
		dropdownMsg,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__exceptions-filter-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__exceptions-filter-v3-container')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$CustomSelect$view,
							dropdownModel,
							_List_fromArray(
								[
									$author$project$Ui$V3$CustomSelect$label('Exceptions')
								]))
						]))
				])));
};
var $author$project$Components$DashboardPage$newDashboardControlView = F4(
	function (tz, data, model, dashboardRows) {
		var sortedCategoryDropdowns = A2(
			$elm$core$List$filterMap,
			function (categoryName) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(categoryName),
					A2($elm$core$Dict$get, categoryName, model.categoryDropdowns));
			},
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.category;
					},
					function ($) {
						return $.name;
					}),
				model.dashboardFilters.categories));
		var preferredFilterView = function () {
			var savedFilterIsSelected = function (dashboardSavedFilterData) {
				return A2(
					$author$project$Domain$DashboardSavedFilter$isSelected,
					{currentFilter: model.dashboardFilters, currentMode: model.dashboardMode},
					dashboardSavedFilterData.dashboardSavedFilter);
			};
			var selectedDashboardSavedFilterData = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					savedFilterIsSelected,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$Forward$Remote$toMaybe(data.dashboardSavedFilters))));
			var filterDataForMode = function (dashboardSavedFilterData) {
				return _Utils_eq(dashboardSavedFilterData.dashboardSavedFilter.dashboardMode, model.dashboardMode);
			};
			var filtersForMode = A2(
				$elm$core$List$filter,
				filterDataForMode,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Forward$Remote$toMaybe(data.dashboardSavedFilters)));
			var filterBar = data.accountSettings.savedFilterEnhancementsEnabled ? A8(
				$author$project$Components$Dashboard$FilterBar$filterSelectView,
				filtersForMode,
				selectedDashboardSavedFilterData,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dashboardSavedFilter;
					},
					function ($) {
						return $.name;
					}),
				$author$project$Components$DashboardPage$DashboardSavedFilterSelected,
				$author$project$Components$DashboardPage$DashboardSavedFilterSaving,
				$author$project$Components$DashboardPage$DashboardSavedFilterOpenEditModal,
				model.dashboardSavedFilterRefreshing,
				A2($author$project$Domain$DashboardFilters$isEmpty, model.dashboardMode, model.dashboardFilters)) : A3($author$project$Components$Dashboard$FilterBar$newPreferredFilterView, data.currentUser, $author$project$Components$DashboardPage$UpdatePreferredFilters, model.dashboardFilters);
			var _v1 = model.selectedQueue;
			if (_v1.$ === 'FinalQueue') {
				return (data.account.factorAccount && (!data.accountSettings.factorUseLabelsOnProcessed)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(filterBar);
			} else {
				return $elm$core$Maybe$Just(filterBar);
			}
		}();
		var maybeLabelButton = data.account.factorAccount ? A2($author$project$Components$DashboardPage$labelButton, model, data.currentUser) : $elm$html$Html$text('');
		var maybeExceptionsFilterView = (data.account.payablesAccount && ($author$project$Components$Dashboard$AvailableQueues$hasExceptionsColumn(model.selectedQueue) && (!_Utils_eq(model.dashboardMode, $author$project$AuditPb$DashboardModeIndex)))) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('enable_shared-ui-v3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v3__theme')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__filters-exceptions-dropdown')
									]),
								_List_fromArray(
									[
										$author$project$Components$Dashboard$FilterBar$viewExceptionsFilter(
										{
											dropdownModel: A3($author$project$Components$DashboardPage$updatedExceptionsDropdown, data, model, model.exceptionsDropdown),
											dropdownMsg: $author$project$Components$DashboardPage$ExceptionsDropdownMsg
										})
									]))
							]))
					]))) : $elm$core$Maybe$Nothing;
		var maybeDebtorFilterView = data.account.factorAccount ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__filters-debtor-dropdown')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Dashboard$FilterBar$viewDebtorFilter,
						model.selectedQueue,
						{dropdownData: data.debtorDropdown, dropdownModel: model.debtorDropdown, dropdownMsg: $author$project$Components$DashboardPage$DebtorDropdownMsg})
					]))) : $elm$core$Maybe$Nothing;
		var maybeCategoryView = $elm$core$List$isEmpty(sortedCategoryDropdowns) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__category-filters-container dashboard__controls-row')
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var categoryName = _v0.a;
						var dropdown = _v0.b;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__category-filter')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('enable_shared-ui-v3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$DashboardPage$CategoryDropdownMsg(categoryName),
											A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('v3__theme')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$V3$CustomSelect$view,
														dropdown,
														_List_fromArray(
															[
																$author$project$Ui$V3$CustomSelect$label(categoryName)
															]))
													])))
										]))
								]));
					},
					sortedCategoryDropdowns)));
		var dateView = data.accountSettings.showDateTimeFilters ? A3($author$project$Components$DashboardPage$dateTimeRangeView, tz, data, model) : A3($author$project$Components$DashboardPage$dateRangeView, tz, data, model);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__controls-container dashboard__controls-new-layout')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__controls-row dashboard__filters-filters-row')
								]),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										$author$project$Components$DashboardPage$possibleFiltersView(model)),
										preferredFilterView
									])))),
						maybeCategoryView,
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__controls-row dashboard__filters-action-row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dashboard__filters-action-row-left')
										]),
									_List_fromArray(
										[
											A4($author$project$Components$DashboardPage$flowModeButton, data.accountSettings, data.currentUser, dashboardRows, model),
											A4($author$project$Components$DashboardPage$ignoreButton, model, data.accountSettings, data.currentUser, dashboardRows),
											A4($author$project$Components$DashboardPage$mergeButton, model, data.account, data.currentUser, dashboardRows),
											maybeLabelButton
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dashboard__filters-action-row-right')
										]),
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												maybeExceptionsFilterView,
												maybeDebtorFilterView,
												$elm$core$Maybe$Just(
												A2($author$project$Components$DashboardPage$customerFilterView, data, model)),
												$elm$core$Maybe$Just(
												A2($author$project$Components$DashboardPage$carrierFilterView, data, model)),
												$elm$core$Maybe$Just(dateView),
												$elm$core$Maybe$Just($author$project$Components$DashboardPage$clearButton)
											])))
								])))
					])));
	});
var $author$project$Bem$block = function (string) {
	var prependBlock = $elm$core$Basics$append(string + '__');
	return {
		_class: A2($elm$core$Basics$composeL, $elm$html$Html$Attributes$class, prependBlock),
		classList: A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$classList,
			$elm$core$List$map(
				$elm$core$Tuple$mapFirst(prependBlock))),
		string: prependBlock
	};
};
var $author$project$Components$Dashboard$Menu$bem = $author$project$Bem$block('dashboard-menu');
var $author$project$Components$Dashboard$Menu$queueLabel = F3(
	function (accountType, dashboardMode, queue) {
		switch (queue.$) {
			case 'NewQueue':
				return 'New';
			case 'FactorNeedsIndexingQueue':
				return 'New';
			case 'ReadyToAuditQueue':
				return 'Ready to Audit';
			case 'ExceptionQueue':
				if (accountType.$ === 'BrokerAccount') {
					if (dashboardMode.$ === 'DashboardModeAudit') {
						return 'Held';
					} else {
						return 'Exception';
					}
				} else {
					return 'Incomplete';
				}
			case 'RepliesQueue':
				return 'Replies';
			case 'WaitingQueue':
				return 'Waiting';
			case 'VerifyQueue':
				return 'Verify';
			default:
				switch (queue.a.$) {
					case 'ProcessedQueue':
						return 'Processed';
					case 'ReviewQueue':
						var _v3 = queue.a;
						return 'Review';
					default:
						var _v4 = queue.a;
						return 'Unknown';
				}
		}
	});
var $author$project$Components$Dashboard$Menu$queueView = F5(
	function (accountType, selectedQueue, dashboardMode, msg, _v0) {
		var queue = _v0.a;
		var countData = _v0.b;
		var countToString = function (count_) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Helpers$String$nbsp,
				$author$project$Forward$Remote$toMaybe(
					A2($author$project$Forward$Remote$map, $elm$core$String$fromInt, count_)));
		};
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Components$Dashboard$Menu$bem.classList(
					_List_fromArray(
						[
							_Utils_Tuple2('item', true),
							_Utils_Tuple2(
							'item__active',
							_Utils_eq(queue, selectedQueue))
						])),
					$elm$html$Html$Events$onClick(
					msg(queue))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Components$Dashboard$Menu$bem._class('count')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							countToString(countData))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Components$Dashboard$Menu$bem._class('label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Components$Dashboard$Menu$queueLabel, accountType, dashboardMode, queue))
						]))
				]));
	});
var $author$project$Components$Dashboard$Menu$view = F4(
	function (selectedQueue, msg, dashboardMode, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Components$Dashboard$Menu$bem._class('container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Components$Dashboard$Menu$bem._class('row')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$Components$Dashboard$Menu$queueView, data.accountType, selectedQueue, dashboardMode, msg),
						data.queueCounts))
				]));
	});
var $author$project$Components$DashboardPage$DismissBulkLabelModal = {$: 'DismissBulkLabelModal'};
var $author$project$Components$DashboardPage$PerformBulkLabel = {$: 'PerformBulkLabel'};
var $author$project$Components$Shared$ModalDialog$dialogButtonsView = F2(
	function (dismissMsg, config) {
		var _v0 = config.confirm;
		if (_v0.$ === 'Just') {
			var confirm = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-10 column')
					]),
				_List_fromArray(
					[
						config.performing ? A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog__confirm-button--disabled')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, 'Performing...', config.performingText))
							])) : (config.success ? A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog__confirm-button--success')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, 'Success!', config.successText))
							])) : A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog__confirm-button'),
								$elm$html$Html$Events$onClick(confirm.msg)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(confirm.text)
							]))),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog__cancel-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('or')
									])),
								A2(
								$elm$html$Html$button,
								config.performing ? _List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-dialog__cancel-button')
									]) : _List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-dialog__cancel-button'),
										$elm$html$Html$Events$onClick(dismissMsg)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, 'Cancel', config.dismissText))
									]))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-10 column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog__dismiss--wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								config.performing ? _List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-dialog__dismiss-button')
									]) : _List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-dialog__dismiss-button'),
										$elm$html$Html$Events$onClick(dismissMsg)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, 'Dismiss', config.dismissText))
									]))
							]))
					]));
		}
	});
var $author$project$Components$Shared$ModalDialog$empty = $elm$html$Html$text('');
var $author$project$Components$Shared$ModalDialog$modalContainer = function (dialogBody) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cg-busy cg-busy-animation')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cg-busy-default-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cg-busy-default-container')
							]),
						_List_fromArray(
							[dialogBody]))
					]))
			]));
};
var $author$project$Components$Shared$ModalDialog$view = F2(
	function (dismissMsg, config) {
		var modalClass = A2($elm$core$Maybe$withDefault, 'modal__medium-container reply__mark-complete', config.modalClassOverride);
		return $author$project$Components$Shared$ModalDialog$modalContainer(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(modalClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-10 column')
									]),
								_List_fromArray(
									[
										A2($elm$core$Maybe$withDefault, $author$project$Components$Shared$ModalDialog$empty, config.header)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-10 column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[config.body]))
									])),
								A2($author$project$Components$Shared$ModalDialog$dialogButtonsView, dismissMsg, config)
							]))
					])));
	});
var $author$project$Components$DashboardPage$RemoveBulkLabel = function (a) {
	return {$: 'RemoveBulkLabel', a: a};
};
var $author$project$Components$Dashboard$Review$Model$selectableFactorInvoices = function (data) {
	return A2(
		$elm$core$List$filterMap,
		$author$project$Components$Dashboard$Review$Model$getMaybeLoadedInvoices,
		A2(
			$elm$core$List$concatMap,
			function (clientGroup) {
				return _Utils_ap(clientGroup.approvableInvoices, clientGroup.verifyingInvoices);
			},
			A2(
				$elm$core$List$filterMap,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$map(
						function ($) {
							return $.clientGroup;
						}),
					$author$project$Forward$Remote$toMaybe),
				$author$project$Pagination$entries(data))));
};
var $author$project$Components$Dashboard$Pager$Selectable$setMember = F2(
	function (ignorable, set) {
		return A3($timo_weike$generic_collections$ManualSet$member, $author$project$Components$Dashboard$Pager$Selectable$toComparable, ignorable, set);
	});
var $author$project$Components$DashboardPage$labelsForSelectables = F2(
	function (data, entryIdsToShow) {
		var getDuplicateItems = function (lists) {
			return $elm$core$Set$toList(
				A3(
					$elm$core$List$foldl,
					$elm$core$Set$intersect,
					$elm$core$Set$fromList(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							$elm$core$List$head(lists))),
					A2($elm$core$List$map, $elm$core$Set$fromList, lists)));
		};
		switch (data.$) {
			case 'NewEmailData':
				var a = data.a;
				return getDuplicateItems(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.labels;
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.emailMessage;
							},
							A2(
								$elm$core$List$filter,
								function (entry) {
									return A2(
										$author$project$Components$Dashboard$Pager$Selectable$setMember,
										$author$project$Components$Dashboard$Pager$Selectable$EmailMessage(entry.emailMessage.id),
										entryIdsToShow);
								},
								A2(
									$elm$core$List$filterMap,
									$author$project$Forward$Remote$toMaybe,
									$author$project$Pagination$entries(a))))));
			case 'FactorNeedsIndexingData':
				var a = data.a;
				return getDuplicateItems(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.labels;
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.emailMessage;
							},
							A2(
								$elm$core$List$filter,
								function (entry) {
									return A2(
										$author$project$Components$Dashboard$Pager$Selectable$setMember,
										$author$project$Components$Dashboard$Pager$Selectable$EmailMessage(entry.emailMessage.id),
										entryIdsToShow);
								},
								A2(
									$elm$core$List$filterMap,
									$author$project$Forward$Remote$toMaybe,
									$author$project$Pagination$entries(a))))));
			case 'ReadyToAuditCarrierInvoiceData':
				var a = data.a;
				return getDuplicateItems(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.labels;
						},
						A2(
							$elm$core$List$filter,
							function (entry) {
								return A2(
									$author$project$Components$Dashboard$Pager$Selectable$setMember,
									$author$project$Components$Dashboard$Pager$Selectable$CarrierInvoice(entry.carrierInvoiceId),
									entryIdsToShow);
							},
							A2(
								$elm$core$List$filterMap,
								$author$project$Forward$Remote$toMaybe,
								$author$project$Pagination$entries(a)))));
			case 'ReplyEmailData':
				var a = data.a;
				return getDuplicateItems(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.labels;
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.emailMessage;
							},
							A2(
								$elm$core$List$filter,
								function (entry) {
									return A2(
										$author$project$Components$Dashboard$Pager$Selectable$setMember,
										$author$project$Components$Dashboard$Pager$Selectable$EmailMessage(entry.emailMessage.id),
										entryIdsToShow);
								},
								A2(
									$elm$core$List$filterMap,
									$author$project$Forward$Remote$toMaybe,
									$author$project$Pagination$entries(a))))));
			case 'ReviewData':
				var a = data.a;
				return getDuplicateItems(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.labels;
						},
						A2(
							$elm$core$List$filter,
							function (factorInvoice) {
								return A2(
									$author$project$Components$Dashboard$Pager$Selectable$setMember,
									$author$project$Components$Dashboard$Pager$Selectable$FactorInvoice(factorInvoice.id),
									entryIdsToShow);
							},
							$author$project$Components$Dashboard$Review$Model$selectableFactorInvoices(a))));
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$DashboardPage$SelectBulkLabel = function (a) {
	return {$: 'SelectBulkLabel', a: a};
};
var $author$project$Components$DashboardPage$viewBulkLabelSelect = F2(
	function (data, _v0) {
		var labels = A2(
			$elm$core$List$map,
			function ($) {
				return $.name;
			},
			data.accountSettings.labels);
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$andThen,
						function (str) {
							var _v1 = $elm$core$String$toInt(str);
							if (_v1.$ === 'Nothing') {
								return $elm$json$Json$Decode$fail('could not convert string \u0027' + (str + '\u0027 to an Int'));
							} else {
								var x = _v1.a;
								return $elm$json$Json$Decode$succeed(
									$author$project$Components$DashboardPage$SelectBulkLabel(x));
							}
						},
						$elm$html$Html$Events$targetValue))
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, name) {
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(i))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								]));
					}),
				labels));
	});
var $author$project$Components$DashboardPage$viewBulkLabelBody = F2(
	function (data, model) {
		var existingLabels = function () {
			var _v0 = data.dashboardRows;
			if (_v0.$ === 'Loaded') {
				var dashboardRows = _v0.a;
				return A2($author$project$Components$DashboardPage$labelsForSelectables, dashboardRows, model.selectedSelectables);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			5,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Add')
								])),
							A2($author$project$Components$DashboardPage$viewBulkLabelSelect, data, model)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-label-editor__labels-list')
								]),
							A2(
								$elm$core$List$map,
								function (label) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('carrier-labels__label email-label-editor__bulk-display')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														$author$project$Components$DashboardPage$RemoveBulkLabel(label))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('icon')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$i,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('fi-x-circle')
																	]),
																_List_Nil)
															])),
														$elm$html$Html$text(label)
													]))
											]));
								},
								existingLabels))
						]))
				]));
	});
var $author$project$Components$DashboardPage$viewBulkLabelModal = F2(
	function (data, model) {
		var config = {
			body: A2($author$project$Components$DashboardPage$viewBulkLabelBody, data, model),
			confirm: $elm$core$Maybe$Just(
				{msg: $author$project$Components$DashboardPage$PerformBulkLabel, text: 'Apply'}),
			dismissText: $elm$core$Maybe$Just('Cancel'),
			header: $elm$core$Maybe$Nothing,
			modalClassOverride: $elm$core$Maybe$Nothing,
			performing: model.bulkLabelModal.isPerforming,
			performingText: $elm$core$Maybe$Just('Labeling... '),
			success: model.bulkLabelModal.succeeded,
			successText: $elm$core$Maybe$Nothing
		};
		return model.bulkLabelModal.isShown ? A2($author$project$Components$Shared$ModalDialog$view, $author$project$Components$DashboardPage$DismissBulkLabelModal, config) : $elm$html$Html$text('');
	});
var $author$project$Components$DashboardSavedFilterEditModal$Close = {$: 'Close'};
var $author$project$Ui$V3$Button$ColorDanger = {$: 'ColorDanger'};
var $author$project$Components$DashboardSavedFilterEditModal$DeleteClicked = function (a) {
	return {$: 'DeleteClicked', a: a};
};
var $author$project$Components$DashboardSavedFilterEditModal$Saving = {$: 'Saving'};
var $author$project$Components$DashboardSavedFilterEditModal$SetDefaultClicked = function (a) {
	return {$: 'SetDefaultClicked', a: a};
};
var $author$project$Components$DashboardSavedFilterEditModal$SetName = function (a) {
	return {$: 'SetName', a: a};
};
var $author$project$Components$DashboardSavedFilterEditModal$StartEditing = function (a) {
	return {$: 'StartEditing', a: a};
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Ui$V3$Input$ValidationAttribute = function (a) {
	return {$: 'ValidationAttribute', a: a};
};
var $author$project$Ui$V3$Input$validation = A2(
	$elm$core$Basics$composeR,
	$elm$core$Result$map(
		$elm$core$Basics$always(_Utils_Tuple0)),
	$author$project$Ui$V3$Input$ValidationAttribute);
var $author$project$Components$DashboardSavedFilterEditModal$filterRowView = F2(
	function (model, filter) {
		var startEditingButton = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					$author$project$Components$DashboardSavedFilterEditModal$StartEditing(filter))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
				]),
			'Edit');
		var saveButton = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardSavedFilterEditModal$Saving)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall)
				]),
			'Save');
		var filterIsBeingEdited = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (editingFilter) {
					return A2($author$project$Components$DashboardSavedFilterEditModal$idsMatch, filter, editingFilter);
				},
				model.editingFilter));
		var nameText = filterIsBeingEdited ? A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function ($) {
				return $.name;
			},
			model.editingFilter) : filter.name;
		var errorValidation = (filterIsBeingEdited && (!$elm$core$String$isEmpty(model.onSaveErrorMessage))) ? $elm$core$Result$Err(model.onSaveErrorMessage) : $elm$core$Result$Ok(_Utils_Tuple0);
		var editOrSaveView = filterIsBeingEdited ? saveButton : startEditingButton;
		var displayOrEditNameView = A4(
			$author$project$Ui$V3$Input$view,
			{onInput: $author$project$Components$DashboardSavedFilterEditModal$SetName},
			_List_fromArray(
				[
					$author$project$Ui$V3$Input$class('dashboard-saved-filter-name-input'),
					$author$project$Ui$V3$Input$validation(errorValidation),
					$author$project$Ui$V3$Input$disabled(!filterIsBeingEdited)
				]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$autofocus(true)
				]),
			nameText);
		var deleteButtonView = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					$author$project$Components$DashboardSavedFilterEditModal$DeleteClicked(filter))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
					$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorDanger)
				]),
			'Delete');
		var defaultButtonView = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					$author$project$Components$DashboardSavedFilterEditModal$SetDefaultClicked(filter))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
					filter.isDefault ? $author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantPrimary) : $author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
				]),
			'Default');
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[displayOrEditNameView])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[defaultButtonView])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[editOrSaveView])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[deleteButtonView]))
				]));
	});
var $author$project$Components$DashboardSavedFilterEditModal$filtersTableView = F2(
	function (model, filters) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-saved-filters-management-view__filters-table')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$DashboardSavedFilterEditModal$filterRowView(model),
				filters));
	});
var $author$project$Components$DashboardSavedFilterEditModal$groupedFiltersView = F3(
	function (model, dashboardMode, filters) {
		var headingText = (dashboardMode !== 'all') ? ($author$project$Helpers$String$capitalize(dashboardMode) + ' dashboard') : '';
		var heading = A2(
			$elm$html$Html$h6,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(headingText)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-saved-filters-management-view__group')
				]),
			_List_fromArray(
				[
					heading,
					A2($author$project$Components$DashboardSavedFilterEditModal$filtersTableView, model, filters)
				]));
	});
var $author$project$Components$DashboardSavedFilterEditModal$filtersByModeView = function (model) {
	var groupedFilters = A2(
		$elm$core$Dict$map,
		F2(
			function (_v0, v) {
				return A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Domain$DashboardSavedFilterId$toInt,
						function ($) {
							return $.id;
						}),
					v);
			}),
		A2(
			$elm_community$dict_extra$Dict$Extra$groupBy,
			A2(
				$elm$core$Basics$composeL,
				$author$project$AuditPb$dashboardModeToString,
				function ($) {
					return $.dashboardMode;
				}),
			model.dashboardSavedFilters));
	var groupedFiltersViews = $elm$core$Dict$values(
		A2(
			$elm$core$Dict$map,
			$author$project$Components$DashboardSavedFilterEditModal$groupedFiltersView(model),
			groupedFilters));
	var filtersView = $elm$core$List$isEmpty(model.dashboardSavedFilters) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$h6,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No saved filters')
				]))
		]) : groupedFiltersViews;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard-saved-filters-modal__filters')
			]),
		filtersView);
};
var $author$project$Components$DashboardSavedFilterEditModal$view = function (model) {
	var closeIconLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$Components$DashboardSavedFilterEditModal$Close)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Icon$view16,
				_List_fromArray(
					[
						$author$project$Ui$V3$Icon$label('Close Modal')
					]),
				$author$project$Ui$V3$Icon$close16)
			]));
	var body = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__medium-container'),
				$elm$html$Html$Attributes$class('reply__mark-complete'),
				$elm$html$Html$Attributes$class('v3__theme'),
				$elm$html$Html$Attributes$class('dashboard-saved-filters-modal')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-10 column')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard-saved-filter-modal__close')
									]),
								_List_fromArray(
									[closeIconLink])),
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Manage saved filters')
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard-saved-filters-modal__content')
									]),
								_List_fromArray(
									[
										$author$project$Components$DashboardSavedFilterEditModal$filtersByModeView(model)
									]))
							]))
					]))
			]));
	var bodyWrapper = A2(
		$author$project$Helpers$WaitingSpinner$waitingSpinner,
		model.isSaving,
		_List_fromArray(
			[body]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cg-busy cg-busy-animation')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cg-busy-default-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cg-busy-default-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('enable_shared-ui-v3')
									]),
								_List_fromArray(
									[bodyWrapper]))
							]))
					]))
			]));
};
var $author$project$Components$DashboardPage$viewDashboardSavedFilterEditModal = function (model) {
	return model.dashboardSavedFilterEditModal.isOpen ? A2(
		$elm$html$Html$map,
		$author$project$Components$DashboardPage$DashboardSavedFilterEditModalMsg,
		$author$project$Components$DashboardSavedFilterEditModal$view(model.dashboardSavedFilterEditModal)) : $elm$html$Html$text('');
};
var $author$project$Components$DashboardSavedFilterSaveModal$Close = {$: 'Close'};
var $author$project$Components$DashboardSavedFilterSaveModal$SaveStarted = {$: 'SaveStarted'};
var $author$project$Components$DashboardSavedFilterSaveModal$SetName = function (a) {
	return {$: 'SetName', a: a};
};
var $author$project$Components$DashboardSavedFilterSaveModal$viewModal = function (model) {
	var errorValidation = $elm$core$String$isEmpty(model.errorMessage) ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err(model.errorMessage);
	var nameForm = A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Events$onSubmit($author$project$Components$DashboardSavedFilterSaveModal$SaveStarted)
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Ui$V3$Input$view,
				{onInput: $author$project$Components$DashboardSavedFilterSaveModal$SetName},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$class('dashboard-saved-filter-name-input'),
						$author$project$Ui$V3$Input$validation(errorValidation)
					]),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$autofocus(true)
					]),
				model.name),
				A3(
				$author$project$Ui$V3$Button$view,
				{action: $author$project$Ui$V3$Button$submitForm},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
						$author$project$Ui$V3$Button$disabled(
						$elm$core$String$isEmpty(model.name))
					]),
				'Save'),
				A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardSavedFilterSaveModal$Close)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
						$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
					]),
				'Cancel')
			]));
	var closeIconLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$Components$DashboardSavedFilterSaveModal$Close)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Icon$view16,
				_List_fromArray(
					[
						$author$project$Ui$V3$Icon$label('Close Modal')
					]),
				$author$project$Ui$V3$Icon$close16)
			]));
	var dialogBody = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__medium-container'),
				$elm$html$Html$Attributes$class('reply__mark-complete'),
				$elm$html$Html$Attributes$class('v3__theme'),
				$elm$html$Html$Attributes$class('dashboard-saved-filters-modal')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-10 column')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard-saved-filter-modal__close')
									]),
								_List_fromArray(
									[closeIconLink])),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Save Filter')
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$h6,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Name your filter')
									])),
								nameForm
							]))
					]))
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cg-busy cg-busy-animation')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cg-busy-default-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cg-busy-default-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('enable_shared-ui-v3')
									]),
								_List_fromArray(
									[dialogBody]))
							]))
					]))
			]));
};
var $author$project$Components$DashboardSavedFilterSaveModal$view = function (model) {
	var _v0 = _Utils_Tuple2(model.isOpen, model.filter);
	if (_v0.a && (_v0.b.$ === 'Just')) {
		return $author$project$Components$DashboardSavedFilterSaveModal$viewModal(model);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$DashboardPage$viewDashboardSavedFilterSaveModal = function (model) {
	return model.dashboardSavedFilterSaveModal.isOpen ? A2(
		$elm$html$Html$map,
		$author$project$Components$DashboardPage$DashboardSavedFilterSaveModalMsg,
		$author$project$Components$DashboardSavedFilterSaveModal$view(model.dashboardSavedFilterSaveModal)) : $elm$html$Html$text('');
};
var $author$project$Components$DashboardPage$DismissIgnoreModal = {$: 'DismissIgnoreModal'};
var $author$project$Components$DashboardPage$PerformIgnore = {$: 'PerformIgnore'};
var $author$project$Components$DashboardPage$getItemTypeStrings = function (dashboardRows) {
	_v0$2:
	while (true) {
		if (dashboardRows.$ === 'Loaded') {
			switch (dashboardRows.a.$) {
				case 'ProcessedBrokerData':
					return _Utils_Tuple2('Invoices', 'invoices');
				case 'ProcessedFactorData':
					return _Utils_Tuple2('Invoices', 'invoices');
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return _Utils_Tuple2('Email Messages', 'email messages');
};
var $author$project$Components$DashboardPage$viewIgnoreModal = F2(
	function (data, model) {
		var dismissMsg = $author$project$Components$DashboardPage$DismissIgnoreModal;
		var _v0 = $author$project$Components$DashboardPage$getItemTypeStrings(data.dashboardRows);
		var upperCaseItemName = _v0.a;
		var lowerCaseItemName = _v0.b;
		var config = {
			body: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(model.ignoreModal.text)
					])),
			confirm: $elm$core$Maybe$Just(
				{msg: $author$project$Components$DashboardPage$PerformIgnore, text: 'Ignore'}),
			dismissText: $elm$core$Maybe$Just('Cancel'),
			header: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-submission__funding-notes--header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Ignore ' + upperCaseItemName)
								]))
						]))),
			modalClassOverride: $elm$core$Maybe$Nothing,
			performing: model.ignoreModal.isPerforming,
			performingText: $elm$core$Maybe$Just(
				'Ignoring ' + ($elm$core$String$fromInt(
					$timo_weike$generic_collections$ManualSet$size(model.selectedSelectables)) + (' ' + (lowerCaseItemName + '...')))),
			success: model.ignoreModal.succeeded,
			successText: $elm$core$Maybe$Nothing
		};
		return model.ignoreModal.isShown ? A2($author$project$Components$Shared$ModalDialog$view, dismissMsg, config) : $elm$html$Html$text('');
	});
var $author$project$Components$DashboardPage$DismissMergeModal = {$: 'DismissMergeModal'};
var $author$project$Components$DashboardPage$PerformMerge = {$: 'PerformMerge'};
var $author$project$Components$DashboardPage$viewMergeModal = F2(
	function (_v0, model) {
		var numSelected = $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables);
		var config = {
			body: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(model.mergeModal.text)
					])),
			confirm: $elm$core$Maybe$Just(
				{msg: $author$project$Components$DashboardPage$PerformMerge, text: 'Merge'}),
			dismissText: $elm$core$Maybe$Just('Cancel'),
			header: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-submission__funding-notes--header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Merge Emails')
								]))
						]))),
			modalClassOverride: $elm$core$Maybe$Nothing,
			performing: model.mergeModal.isPerforming,
			performingText: $elm$core$Maybe$Just(
				'Merging ' + ($elm$core$String$fromInt(numSelected) + ' emails...')),
			success: model.mergeModal.succeeded,
			successText: $elm$core$Maybe$Nothing
		};
		return model.mergeModal.isShown ? A2($author$project$Components$Shared$ModalDialog$view, $author$project$Components$DashboardPage$DismissMergeModal, config) : $elm$html$Html$text('');
	});
var $author$project$Components$DashboardPage$PagerTo = function (a) {
	return {$: 'PagerTo', a: a};
};
var $author$project$Components$DashboardPage$ProcessedBrokerActionAreaMsg = function (a) {
	return {$: 'ProcessedBrokerActionAreaMsg', a: a};
};
var $author$project$Components$DashboardPage$ProcessedBrokerRowMsg = function (a) {
	return {$: 'ProcessedBrokerRowMsg', a: a};
};
var $author$project$Components$DashboardPage$ProcessedFactorActionAreaMsg = function (a) {
	return {$: 'ProcessedFactorActionAreaMsg', a: a};
};
var $author$project$Components$DashboardPage$ProcessedFactorGroupMsg = function (a) {
	return {$: 'ProcessedFactorGroupMsg', a: a};
};
var $author$project$Components$DashboardPage$ProcessedFactorHeaderMsg = function (a) {
	return {$: 'ProcessedFactorHeaderMsg', a: a};
};
var $author$project$Components$DashboardPage$ReviewUiMsg = function (a) {
	return {$: 'ReviewUiMsg', a: a};
};
var $author$project$Components$DashboardPage$SelectSelectable = function (a) {
	return {$: 'SelectSelectable', a: a};
};
var $author$project$Components$DashboardPage$SetSortBy = function (a) {
	return {$: 'SetSortBy', a: a};
};
var $author$project$Components$DashboardPage$ToggleSelectAllVisible = {$: 'ToggleSelectAllVisible'};
var $author$project$Components$DashboardPage$ViewItem = function (a) {
	return {$: 'ViewItem', a: a};
};
var $author$project$Domain$DashboardFilters$DebtorFilterActive = {$: 'DebtorFilterActive'};
var $author$project$Domain$DashboardFilters$NoFiltersActive = {$: 'NoFiltersActive'};
var $author$project$Domain$DashboardFilters$NormalFiltersActive = {$: 'NormalFiltersActive'};
var $author$project$Domain$DashboardFilters$debtorFilterExists = function (dashboardFilters) {
	return !$elm$core$List$isEmpty(dashboardFilters.factorBrokerIds);
};
var $author$project$Domain$DashboardFilters$numFiltersApplied = function (dashboardFilters) {
	var labelNumDiffs = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Domain$LabelFilter$isUnselected),
			dashboardFilters.labelFilters));
	var categoryNumDiffs = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (cat) {
				return !($elm$core$Set$isEmpty(cat.selected) && $elm$core$Set$isEmpty(cat.excluded));
			},
			dashboardFilters.categories));
	var basicNumDiffs = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (checker) {
				return !_Utils_eq(
					checker(dashboardFilters),
					checker($author$project$Domain$DashboardFilters$empty));
			},
			_List_fromArray(
				[
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tmsCarrierIds;
					},
					$author$project$Domain$DashboardFilters$maybeCarrierToString),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.factorBrokerIds;
					},
					$author$project$Domain$DashboardFilters$factorBrokersToString),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.customers;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map($author$project$Domain$Customer$toStringKey),
						$elm$core$String$join(' . '))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.startDate;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($justinmimbs$date$Date$toIsoString),
						$elm$core$Maybe$withDefault(''))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.startDateTime;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($elm$time$Time$posixToMillis),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map($elm$core$String$fromInt),
							$elm$core$Maybe$withDefault('')))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.endDate;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($justinmimbs$date$Date$toIsoString),
						$elm$core$Maybe$withDefault(''))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.endDateTime;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($elm$time$Time$posixToMillis),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map($elm$core$String$fromInt),
							$elm$core$Maybe$withDefault('')))),
					A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.exceptions;
					},
					$elm$core$String$join(','))
				])));
	return $elm$core$List$sum(
		_List_fromArray(
			[basicNumDiffs, labelNumDiffs, categoryNumDiffs]));
};
var $author$project$Domain$DashboardFilters$filtersExist = function (dashboardFilters) {
	return $author$project$Domain$DashboardFilters$numFiltersApplied(dashboardFilters) > 0;
};
var $author$project$Domain$DashboardFilters$activeFilterType = function (dashboardFilters) {
	var _v0 = _Utils_Tuple2(
		$author$project$Domain$DashboardFilters$filtersExist(dashboardFilters),
		$author$project$Domain$DashboardFilters$debtorFilterExists(dashboardFilters));
	if (_v0.a) {
		if (_v0.b) {
			return $author$project$Domain$DashboardFilters$DebtorFilterActive;
		} else {
			return $author$project$Domain$DashboardFilters$NormalFiltersActive;
		}
	} else {
		return $author$project$Domain$DashboardFilters$NoFiltersActive;
	}
};
var $author$project$Id$Set$isEmpty = function (_v0) {
	var set = _v0.a;
	return $elm$core$Set$isEmpty(set);
};
var $author$project$Components$Dashboard$Review$Model$allAreSelected_ = F2(
	function (model, clientGroupDict) {
		var allSelectable = A2($author$project$Components$Dashboard$Review$Model$getAllSelectable, model.verifyMode, clientGroupDict);
		var selectableItemsExist = !$author$project$Id$Set$isEmpty(allSelectable);
		var unselected = A2(
			$author$project$Sanitized$sanitize,
			$author$project$Id$Set$diff(allSelectable),
			model.selectedFactorInvoiceIds);
		return _Utils_Tuple2(
			selectableItemsExist && $author$project$Id$Set$isEmpty(unselected),
			allSelectable);
	});
var $author$project$Components$Dashboard$Review$Model$allAreSelected = F2(
	function (model, data) {
		var clientGroups = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$map(
					function ($) {
						return $.clientGroup;
					}),
				$author$project$Forward$Remote$toMaybe),
			$author$project$Pagination$entries(data));
		var _v0 = $elm_community$maybe_extra$Maybe$Extra$combine(clientGroups);
		if (_v0.$ === 'Just') {
			var clientGroupsAllLoaded = _v0.a;
			return A2($author$project$Components$Dashboard$Review$Model$allAreSelected_, model, clientGroupsAllLoaded);
		} else {
			return _Utils_Tuple2(false, $author$project$Id$Set$empty);
		}
	});
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$BrokerApprove = {$: 'BrokerApprove'};
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$BrokerDeselectAll = {$: 'BrokerDeselectAll'};
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$BrokerSelectAll = function (a) {
	return {$: 'BrokerSelectAll', a: a};
};
var $author$project$Helpers$String$appendToEnd = F2(
	function (end, beginning) {
		return _Utils_ap(beginning, end);
	});
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$buttonTemplate = F3(
	function (isDisabled, onClickMsg, text) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('button', true),
							_Utils_Tuple2('button--progress', !isDisabled),
							_Utils_Tuple2('button--disabled', isDisabled)
						])),
					$elm$html$Html$Attributes$disabled(isDisabled),
					$elm$html$Html$Events$onClick(onClickMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text)
				]));
	});
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$brokerProcessedActionArea = F3(
	function (visibleIds, isProcessingApproval, selectedRowCount) {
		var isDisabled = isProcessingApproval || (!selectedRowCount);
		var buttonText = isProcessingApproval ? 'Approving...' : (isDisabled ? 'Select Invoices To Pay' : A2(
			$author$project$Helpers$String$appendToEnd,
			' To Pay',
			'Approve ' + A2(
				$author$project$Helpers$String$pluralize,
				{many: 'Invoices', one: 'Invoice'},
				selectedRowCount)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__action-area')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Dashboard$Processed$ProcessedActionArea$buttonTemplate, isDisabled, $author$project$Components$Dashboard$Processed$ProcessedActionArea$BrokerApprove, buttonText),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Components$Dashboard$Processed$ProcessedActionArea$BrokerSelectAll(visibleIds))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Check all')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' / ')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$Dashboard$Processed$ProcessedActionArea$BrokerDeselectAll)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Uncheck all')
								]))
						]))
				]));
	});
var $author$project$Components$Dashboard$Processed$BrokerModel$countSelected = function (brokerModel) {
	return $elm$core$List$length(
		$author$project$Components$Dashboard$Processed$BrokerModel$selectedBrokerInvoiceIds(brokerModel));
};
var $author$project$Components$Dashboard$DashboardRow$View$safeOnCheck = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: false, stopPropagation: true}));
};
var $author$project$Components$Dashboard$Header$View$maybeViewEmailSelectAll = function (maybeOnSelectAllVisible) {
	if (maybeOnSelectAllVisible.$ === 'Just') {
		var onSelectAllVisible = maybeOnSelectAllVisible.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__selected-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$author$project$Components$Dashboard$DashboardRow$View$safeOnCheck(onSelectAllVisible)
						]),
					_List_Nil)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Dashboard$Header$View$emailMessageHeader = F2(
	function (onSelectAllVisible, accountType) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-menu__row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__messages-header-row')
								]),
							_List_fromArray(
								[
									$author$project$Components$Dashboard$Header$View$maybeViewEmailSelectAll(onSelectAllVisible),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__small-subject-area')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Subject line')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__email-area')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Email')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__date-area')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Date/time')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__carrier-area')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Domain$Account$carrierTerm(accountType))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message_page-count-area')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Page count')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Dashboard$Header$View$textWithTooltip = F2(
	function (tooltip, body) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'true'),
					$elm$html$Html$Attributes$title(tooltip),
					A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(body)
				]));
	});
var $author$project$Components$Dashboard$Header$View$ageOrReceivedAt = function (displaySettings) {
	var _v0 = _Utils_Tuple2(displaySettings.showReceived, displaySettings.showReceivedAtOnly);
	if (_v0.a) {
		if (_v0.b) {
			return _List_fromArray(
				[
					A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Time that these messages were received.', 'Date received')
				]);
		} else {
			return _List_fromArray(
				[
					A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Time that these messages were received and the date when this item should be reviewed.', 'Date received / Review on')
				]);
		}
	} else {
		return _List_fromArray(
			[
				A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Time since these exceptions were saved. If provided, the date when this item should be reviewed.', 'Exception age / Review on')
			]);
	}
};
var $author$project$Domain$Account$customerTerm = function (accountType_) {
	if (accountType_.$ === 'FactorAccount') {
		return 'Debtor';
	} else {
		return 'Customer';
	}
};
var $author$project$Ui$V2$Icon$Label = function (a) {
	return {$: 'Label', a: a};
};
var $author$project$Ui$V2$Icon$label = $author$project$Ui$V2$Icon$Label;
var $author$project$Ui$V2$Icon$Icon16 = function (a) {
	return {$: 'Icon16', a: a};
};
var $author$project$Ui$V2$Icon$sortArrowDefault16 = $author$project$Ui$V2$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#7DA1C4'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27349 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#7DA1C4'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V2$Icon$sortArrowDown16 = $author$project$Ui$V2$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#7DA1C4'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27348 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#001929'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V2$Icon$sortArrowUp16 = $author$project$Ui$V2$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#001929'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27348 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#7DA1C4'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V2$Icon$view = F3(
	function (size, description, svg) {
		var ariaAttributes = function () {
			if (description.$ === 'Decorative') {
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
					]);
			} else {
				var text = description.a;
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', text)
					]);
			}
		}();
		return A2(
			$elm$svg$Svg$svg,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$class('v2__icon'),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$height(size + 'px'),
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$width(size + 'px'),
						A2(
							$elm$core$List$cons,
							$elm$svg$Svg$Attributes$viewBox('0 0 ' + (size + (' ' + size))),
							ariaAttributes)))),
			_List_fromArray(
				[
					A2($elm$svg$Svg$map, $elm$core$Basics$never, svg)
				]));
	});
var $author$project$Ui$V2$Icon$view16 = F2(
	function (attributes, _v0) {
		var svg = _v0.a;
		return A3($author$project$Ui$V2$Icon$view, '16', attributes.description, svg);
	});
var $author$project$Components$Dashboard$Header$View$sortableHeader = F5(
	function (className, columnSortName, currentSortBy, setSortByMsg, headerEl) {
		var _v0 = function () {
			if (_Utils_eq(
				currentSortBy.name,
				$author$project$Domain$QueueDate$toString(columnSortName))) {
				var _v1 = currentSortBy.order;
				if (_v1.$ === 'DashboardSortByOrderAsc') {
					return _Utils_Tuple2(
						$author$project$Ui$V2$Icon$sortArrowDown16,
						{
							name: $author$project$Domain$QueueDate$toString(columnSortName),
							order: $author$project$AuditPb$DashboardSortByOrderDesc
						});
				} else {
					return _Utils_Tuple2(
						$author$project$Ui$V2$Icon$sortArrowUp16,
						{
							name: $author$project$Domain$QueueDate$toString($author$project$AuditPb$QueueDateUnsorted),
							order: $author$project$AuditPb$DashboardSortByOrderAsc
						});
				}
			} else {
				return _Utils_Tuple2(
					$author$project$Ui$V2$Icon$sortArrowDefault16,
					{
						name: $author$project$Domain$QueueDate$toString(columnSortName),
						order: $author$project$AuditPb$DashboardSortByOrderAsc
					});
			}
		}();
		var icon = _v0.a;
		var newSort = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className + ' broker-sortable-header'),
					$elm$html$Html$Events$onClick(
					setSortByMsg(newSort))
				]),
			_List_fromArray(
				[
					headerEl,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('enable_shared-ui-v3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__theme')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V2$Icon$view16,
									{
										description: $author$project$Ui$V2$Icon$label('Sort')
									},
									icon)
								]))
						]))
				]));
	});
var $author$project$Components$Dashboard$Header$View$exceptionMessageHeader = F8(
	function (onSelectAllVisible, accountType, accountSettings, showReceivedAtOnly, dashboardMode, queue, currentSortBy, setSortByMsg) {
		var shouldShowDeliveredAt = A4($author$project$Components$Dashboard$DashboardRow$shouldShowDeliveredAt, accountType, accountSettings, dashboardMode, queue);
		var _v0 = shouldShowDeliveredAt ? _Utils_Tuple2('Load #', 'message__exceptioned-item-load-number') : _Utils_Tuple2('Load # / Subject Line', 'message__exceptioned-item-subject-line');
		var loadOrSubjectLineText = _v0.a;
		var loadOrSubjectLineClass = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__messages-header-row')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						$author$project$Components$Dashboard$Header$View$maybeViewEmailSelectAll(onSelectAllVisible)),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(loadOrSubjectLineClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(loadOrSubjectLineText)
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__exceptioned-item-carrier')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Domain$Account$carrierTerm(accountType))
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__exceptioned-item-customer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Domain$Account$customerTerm(accountType))
								]))),
						shouldShowDeliveredAt ? $elm$core$Maybe$Just(
						A5(
							$author$project$Components$Dashboard$Header$View$sortableHeader,
							'message__exceptioned-item-last-contact',
							$author$project$AuditPb$QueueDateLastContact,
							currentSortBy,
							setSortByMsg,
							A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Last message sent or received about this item', 'Last contact'))) : $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__exceptioned-item-last-contact')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Last message sent or received about this item', 'Last contact')
								]))),
						shouldShowDeliveredAt ? $elm$core$Maybe$Just(
						A5(
							$author$project$Components$Dashboard$Header$View$sortableHeader,
							'message__exceptioned-item-date-delivered',
							$author$project$AuditPb$QueueDateDelivered,
							currentSortBy,
							setSortByMsg,
							A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Actual or expected load delivery date', 'Date delivered'))) : $elm$core$Maybe$Nothing,
						shouldShowDeliveredAt ? $elm$core$Maybe$Just(
						A5(
							$author$project$Components$Dashboard$Header$View$sortableHeader,
							'message__exceptioned-item-age-review',
							$author$project$AuditPb$QueueDateReceived,
							currentSortBy,
							setSortByMsg,
							A2(
								$elm$html$Html$div,
								_List_Nil,
								$author$project$Components$Dashboard$Header$View$ageOrReceivedAt(
									{showReceived: accountSettings.showDateReceivedOnExceptionAndWaiting, showReceivedAtOnly: showReceivedAtOnly})))) : $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__exceptioned-item-age-review')
								]),
							$author$project$Components$Dashboard$Header$View$ageOrReceivedAt(
								{showReceived: accountSettings.showDateReceivedOnExceptionAndWaiting, showReceivedAtOnly: showReceivedAtOnly}))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__exceptioned-item-exception-and-notes')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Exceptions and notes')
								])))
					])));
	});
var $author$project$Components$Dashboard$Header$View$factorNeedsIndexingHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('dashboard-menu__row')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__messages-header-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__small-external-id-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('External ID #')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__date-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Date/time')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__date-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Last draft')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__page-count-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Page count')
								]))
						]))
				]))
		]));
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$FactorExpand = {$: 'FactorExpand'};
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$FactorReject = {$: 'FactorReject'};
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$FactorSend = {$: 'FactorSend'};
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$factorProcessedActionArea = F3(
	function (_v0, allGroupsSelected, selectedInvoiceCount) {
		var isRejecting = _v0.isRejecting;
		var isSendingToCadence = _v0.isSendingToCadence;
		var isDisabled = isSendingToCadence || (isRejecting || (!selectedInvoiceCount));
		var expansionButtonText = allGroupsSelected ? 'Collapse All' : 'Expand All';
		var buttonTexts = function () {
			var _v1 = _Utils_Tuple3(isSendingToCadence, isRejecting, isDisabled);
			if (_v1.a) {
				return {approve: 'Approving...', reject: 'Select Invoices To Reject'};
			} else {
				if (_v1.b) {
					return {approve: 'Select Invoices To Approve', reject: 'Rejecting...'};
				} else {
					if (_v1.c) {
						return {approve: 'Select Invoices To Approve', reject: 'Select Invoices To Reject'};
					} else {
						var invoices = A2(
							$author$project$Helpers$String$pluralize,
							{many: 'Invoices', one: 'Invoice'},
							selectedInvoiceCount);
						return {approve: 'Approve ' + invoices, reject: 'Reject ' + invoices};
					}
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__action-area')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Dashboard$Processed$ProcessedActionArea$buttonTemplate, isDisabled, $author$project$Components$Dashboard$Processed$ProcessedActionArea$FactorSend, buttonTexts.approve),
					$elm$html$Html$text($author$project$Helpers$String$nbsp),
					A3($author$project$Components$Dashboard$Processed$ProcessedActionArea$buttonTemplate, isDisabled, $author$project$Components$Dashboard$Processed$ProcessedActionArea$FactorReject, buttonTexts.reject),
					$elm$html$Html$text($author$project$Helpers$String$nbsp),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button'),
							$elm$html$Html$Events$onClick($author$project$Components$Dashboard$Processed$ProcessedActionArea$FactorExpand)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(expansionButtonText)
						]))
				]));
	});
var $author$project$Components$DashboardPage$SkipAsynchronousEmailReview = F3(
	function (a, b, c) {
		return {$: 'SkipAsynchronousEmailReview', a: a, b: b, c: c};
	});
var $author$project$Components$DashboardPage$maybeSkipAsynchronousEmailReview = function (user) {
	return user.isManagedIndexer ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$DashboardPage$SkipAsynchronousEmailReview);
};
var $author$project$Components$Dashboard$Header$View$processedBrokerHeader = F6(
	function (accountType, accountSettings, dashboardMode, queue, currentSortBy, setSortByMsg) {
		var shouldShowDeliveredAt = A4($author$project$Components$Dashboard$DashboardRow$shouldShowDeliveredAt, accountType, accountSettings, dashboardMode, queue);
		var remitHeader = accountSettings.useTriumphPayCarrierRemitTo ? 'Payee, from TriumphPay:' : 'Pay to:';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dashboard-menu__row', true),
							_Utils_Tuple2('dashboard-processed-broker', true),
							_Utils_Tuple2('show-delivery-date', shouldShowDeliveredAt)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__messages-header-row')
								]),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__processed-approve-area')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Approve')
												]))),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__processed-carrier-area')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$BrokerAccount))
												]))),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__processed-customer-area')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Domain$Account$customerTerm($author$project$Domain$Account$BrokerAccount))
												]))),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__processed-load-area')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Load')
												]))),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__processed-invoice-area')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Invoice #')
												]))),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__processed-amount-area')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Amount')
												]))),
										shouldShowDeliveredAt ? $elm$core$Maybe$Just(
										A5(
											$author$project$Components$Dashboard$Header$View$sortableHeader,
											'message__processed-date-delivered-area',
											$author$project$AuditPb$QueueDateDelivered,
											currentSortBy,
											setSortByMsg,
											A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Actual or expected load delivery date', 'Date delivered'))) : $elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__processed-payment-date-area')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Payment date')
												]))),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__processed-pay-to-area')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(remitHeader)
												])))
									])))
						]))
				]));
	});
var $author$project$Components$Dashboard$Header$ProcessedFactorToggleAll = {$: 'ProcessedFactorToggleAll'};
var $author$project$Components$Dashboard$Processed$FactorModel$SortByNewest = {$: 'SortByNewest'};
var $author$project$Components$Dashboard$Processed$FactorModel$SortByOldest = {$: 'SortByOldest'};
var $author$project$Components$Dashboard$Header$ProcessedFactorSortBy = function (a) {
	return {$: 'ProcessedFactorSortBy', a: a};
};
var $author$project$Components$Dashboard$Header$View$sortableTitle = F5(
	function (sort, titleClass, arrowClass, title, currentSort) {
		var showArrow = _Utils_eq(currentSort, sort);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('message__group-sortable-header', true),
							_Utils_Tuple2(titleClass, true),
							_Utils_Tuple2(arrowClass, showArrow)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Components$Dashboard$Header$ProcessedFactorSortBy(sort))
				]),
			_List_fromArray(
				[
					showArrow ? $elm$html$Html$text(
					_Utils_ap($author$project$Helpers$String$nbsp, title)) : $elm$html$Html$text(title)
				]));
	});
var $author$project$Components$Dashboard$Header$View$processedFactorHeader = function (_v0) {
	var currentOrder = _v0.currentOrder;
	var allSelected = _v0.allSelected;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard-menu__row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-10 column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__messages-header-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__group-approve-area')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('checkbox'),
												$elm$html$Html$Attributes$checked(allSelected),
												$elm$html$Html$Events$onClick($author$project$Components$Dashboard$Header$ProcessedFactorToggleAll)
											]),
										_List_Nil)
									])),
								A5(
								$author$project$Components$Dashboard$Header$View$sortableTitle,
								$author$project$Components$Dashboard$Processed$FactorModel$SortByAlpha,
								'message__group-carrier-name',
								'fi-arrow-down',
								$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount),
								currentOrder),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__group-invoice-count')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Invoices')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__group-invoice-total')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total')
									])),
								A5($author$project$Components$Dashboard$Header$View$sortableTitle, $author$project$Components$Dashboard$Processed$FactorModel$SortByOldest, 'message__group-invoice-oldest', 'fi-arrow-down', 'Oldest', currentOrder),
								A5($author$project$Components$Dashboard$Header$View$sortableTitle, $author$project$Components$Dashboard$Processed$FactorModel$SortByNewest, 'message__group-invoice-newest', 'fi-arrow-up', 'Newest', currentOrder)
							]))
					]))
			]));
};
var $author$project$Components$Dashboard$Header$View$readyToAuditHeader = F7(
	function (onSelectAllVisible, accountType, accountSettings, dashboardMode, queue, currentSortBy, setSortByMsg) {
		var shouldShowDeliveredAt = A4($author$project$Components$Dashboard$DashboardRow$shouldShowDeliveredAt, accountType, accountSettings, dashboardMode, queue);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-menu__row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__messages-header-row')
								]),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										$author$project$Components$Dashboard$Header$View$maybeViewEmailSelectAll(onSelectAllVisible)),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__ready-to-audit-load-number')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Load #')
												]))),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__ready-to-audit-carrier')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Domain$Account$carrierTerm(accountType))
												]))),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__ready-to-audit-customer')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Domain$Account$customerTerm(accountType))
												]))),
										shouldShowDeliveredAt ? $elm$core$Maybe$Just(
										A5(
											$author$project$Components$Dashboard$Header$View$sortableHeader,
											'message__ready-to-audit-date-received',
											$author$project$AuditPb$QueueDateReceived,
											currentSortBy,
											setSortByMsg,
											$elm$html$Html$text('Date received'))) : $elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__ready-to-audit-date-received')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Date received')
												]))),
										shouldShowDeliveredAt ? $elm$core$Maybe$Just(
										A5(
											$author$project$Components$Dashboard$Header$View$sortableHeader,
											'message__ready-to-audit-date-delivered',
											$author$project$AuditPb$QueueDateDelivered,
											currentSortBy,
											setSortByMsg,
											A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Actual or expected load delivery date', 'Date delivered'))) : $elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__ready-to-audit-exception-and-notes')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Exceptions and notes')
												])))
									])))
						]))
				]));
	});
var $author$project$Components$Dashboard$Header$View$replyHeader = F2(
	function (onSelectAllVisible, accountType) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard-menu__row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__messages-header-row')
								]),
							_List_fromArray(
								[
									$author$project$Components$Dashboard$Header$View$maybeViewEmailSelectAll(onSelectAllVisible),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__replies-subject')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Subject and sender')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__replies-carrier')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Domain$Account$carrierTerm(accountType))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__replies-customer')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Domain$Account$customerTerm(accountType))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__replies-date-received')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Received')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__replies-exceptions')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Exceptions and notes')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__replies-page-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Page count')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Dashboard$Review$Model$ToggleInvoiceSelection = F2(
	function (a, b) {
		return {$: 'ToggleInvoiceSelection', a: a, b: b};
	});
var $author$project$Components$Dashboard$Header$View$reviewHeader = function (config) {
	var clientsCount = A2(
		$elm$core$Maybe$map,
		function (count) {
			return '(' + ($elm$core$String$fromInt(count) + ')');
		},
		config.clientCount);
	var clientsWithCount = A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just('Clients'),
					clientsCount
				])));
	var _v0 = config.allSelected;
	var allSelected = _v0.a;
	var allSelectable = _v0.b;
	var maybeSelectAllCheckbox = config.readOnlyFactorUser ? $elm$html$Html$text($author$project$Helpers$String$nbsp) : A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				$elm$html$Html$Attributes$checked(allSelected),
				$elm$html$Html$Events$onClick(
				A2($author$project$Components$Dashboard$Review$Model$ToggleInvoiceSelection, allSelectable, !allSelected)),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Select all on page')
			]),
		_List_Nil);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard-menu__row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('small-10 column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__messages-header-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__review-approve-area')
									]),
								_List_fromArray(
									[maybeSelectAllCheckbox])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__review-group-client-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(clientsWithCount)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__review-group-verification-warning')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Helpers$String$nbsp)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__review-group-invoice-count')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Ready')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__group-invoice-total')
									]),
								_List_fromArray(
									[
										A2($author$project$Components$Dashboard$Header$View$textWithTooltip, 'Amount Ready to Approve', 'Total')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__review-group-invoice-oldest')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Oldest')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__review-group-invoice-newest')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Newest')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__review-group-credit-rating')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Credit Rating')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Dashboard$Review$Model$selectedCount = F2(
	function (model, data) {
		return $author$project$Id$Set$size(
			A2($author$project$Components$Dashboard$Review$Model$selectedFactorInvoiceIds, model, data));
	});
var $author$project$Components$DashboardPage$shouldHideIfOthersPresent = F3(
	function (accountSettings, currentUser, model) {
		return A3(
			$author$project$DashboardPresence$shouldHideIfOthersPresent,
			accountSettings,
			currentUser,
			A2($author$project$Components$DashboardPage$flowModeRequested, accountSettings, model));
	});
var $author$project$Components$Dashboard$Processed$FactorModel$sortBy = function (_v0) {
	var factorModel = _v0.a;
	return factorModel.sortBy;
};
var $author$project$Components$Dashboard$Header$View$verifyHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('dashboard-menu__row')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__messages-header-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__verify-large-box')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Debtor')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__verify-medium-box')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Oldest Received At ')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__verify-small-box')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Status')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__verify-small-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__verify-float-right')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Invoices')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__verify-small-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__verify-float-right')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Complete')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__verify-medium-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__verify-amount-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Amount')
										]))
								]))
						]))
				]))
		]));
var $author$project$Components$Dashboard$PaginationBar$pageCount = F2(
	function (count, perPage) {
		return $elm$core$Basics$ceiling(count / perPage);
	});
var $author$project$Components$Dashboard$PaginationBar$viewPaginatorLi = F3(
	function (liClass, liText, pageTo) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(liClass),
					$elm$html$Html$Events$onClick(pageTo)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(liText)
						]))
				]));
	});
var $author$project$Components$Dashboard$PaginationBar$viewPageNumber = F3(
	function (activePage, pageTo, page) {
		var pageClass = _Utils_eq(page, activePage) ? 'current' : '';
		return A3(
			$author$project$Components$Dashboard$PaginationBar$viewPaginatorLi,
			pageClass,
			$elm$core$String$fromInt(page),
			pageTo(page));
	});
var $author$project$Components$Dashboard$PaginationBar$view = F2(
	function (_v0, count) {
		var onPageTo = _v0.onPageTo;
		var activePage = _v0.activePage;
		var perPage = _v0.perPage;
		var unavailableIf = function (checkAgainst) {
			return _Utils_eq(activePage, checkAgainst) ? 'arrow unavailable' : 'arrow';
		};
		var pages = A2($author$project$Components$Dashboard$PaginationBar$pageCount, count, perPage);
		var rightArrow = _List_fromArray(
			[
				A3(
				$author$project$Components$Dashboard$PaginationBar$viewPaginatorLi,
				unavailableIf(pages),
				'»',
				onPageTo(activePage + 1))
			]);
		var pageNumberRange = (pages <= 15) ? A2($elm$core$List$range, 1, pages) : ((activePage < 9) ? A2($elm$core$List$range, 1, 15) : ((_Utils_cmp(activePage + 7, pages) < 0) ? A2($elm$core$List$range, activePage - 7, activePage + 7) : A2($elm$core$List$range, pages - 14, pages)));
		var pageNumbers = A2(
			$elm$core$List$map,
			A2($author$project$Components$Dashboard$PaginationBar$viewPageNumber, activePage, onPageTo),
			pageNumberRange);
		var leftArrow = _List_fromArray(
			[
				A3(
				$author$project$Components$Dashboard$PaginationBar$viewPaginatorLi,
				unavailableIf(1),
				'«',
				onPageTo(activePage - 1))
			]);
		return (pages > 1) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pagination')
								]),
							_Utils_ap(
								leftArrow,
								_Utils_ap(pageNumbers, rightArrow)))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Components$Dashboard$Pager$View$pagerContextEmptyMessage = function (config) {
	var _v0 = _Utils_Tuple2(config.activeFilterType, config.debtorSearchSupported);
	_v0$2:
	while (true) {
		switch (_v0.a.$) {
			case 'NoFiltersActive':
				var _v1 = _v0.a;
				return 'This queue is empty.';
			case 'DebtorFilterActive':
				if (!_v0.b) {
					var _v2 = _v0.a;
					return 'Debtor search is not available in this queue.';
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return 'There are no items matching these filters.';
};
var $author$project$Components$Dashboard$Pager$View$viewEmptyMessage = function (emptyMessage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__no-items-message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(emptyMessage)
			]));
};
var $author$project$Components$Dashboard$Pager$View$viewPagerIfIds = F2(
	function (config, viewPager_) {
		var loadedIdCount = config.rowCount;
		return (!loadedIdCount) ? $author$project$Components$Dashboard$Pager$View$viewEmptyMessage(
			$author$project$Components$Dashboard$Pager$View$pagerContextEmptyMessage(config)) : viewPager_(loadedIdCount);
	});
var $author$project$Components$Dashboard$Pager$View$view = function (config) {
	var viewPager_ = function (count) {
		var paginationBar = A2($author$project$Components$Dashboard$PaginationBar$view, config.paginationBar, count);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						config.actionArea,
						$elm$core$Maybe$Just(paginationBar),
						$elm$core$Maybe$Just(config.header),
						$elm$core$Maybe$Just(config.pager),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__lower-paginator')
								]),
							_List_fromArray(
								[paginationBar]))),
						config.actionArea
					])));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pager11')
			]),
		_List_fromArray(
			[
				A2($author$project$Components$Dashboard$Pager$View$viewPagerIfIds, config, viewPager_)
			]));
};
var $author$project$Components$Dashboard$Review$Model$ToggleVerifyMode = {$: 'ToggleVerifyMode'};
var $author$project$Helpers$List$appendToEnd = F2(
	function (first, second) {
		return _Utils_ap(second, first);
	});
var $author$project$Components$Dashboard$Review$Model$RejectInvoices = {$: 'RejectInvoices'};
var $author$project$Components$Dashboard$Review$Model$SendInvoices = {$: 'SendInvoices'};
var $author$project$Components$Dashboard$Review$ActionArea$buttonTemplate = F2(
	function (_v0, text) {
		var enabledClass = _v0.enabledClass;
		var onClickMsg = _v0.onClickMsg;
		var verifyMode = _v0.verifyMode;
		var isDisabled = _v0.isDisabled;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('button', true),
							_Utils_Tuple2('dashboard__review-buttons', !verifyMode),
							_Utils_Tuple2('dashboard__verify-mode-submit-button', verifyMode),
							_Utils_Tuple2(enabledClass, !isDisabled),
							_Utils_Tuple2('button--disabled', isDisabled)
						])),
					$elm$html$Html$Attributes$disabled(isDisabled),
					$elm$html$Html$Events$onClick(onClickMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text)
				]));
	});
var $author$project$Components$Dashboard$Review$ActionArea$viewApprovalModeButtons = function (_v0) {
	var accountSettings = _v0.accountSettings;
	var selectedRowCount = _v0.selectedRowCount;
	var sendingState = _v0.sendingState;
	var _v1 = accountSettings;
	var useSubmissionWorkflow = _v1.useSubmissionWorkflow;
	var _v2 = sendingState;
	var isVerifying = _v2.isVerifying;
	var isRejecting = _v2.isRejecting;
	var isSending = _v2.isSending;
	var isDisabled = isSending || (isRejecting || (isVerifying || (!selectedRowCount)));
	var buttonTexts = function () {
		var _v3 = _Utils_Tuple3(isSending, isRejecting, isDisabled);
		if (_v3.a) {
			return {approve: 'Approving...', reject: 'Select Invoices To Reject'};
		} else {
			if (_v3.b) {
				return {approve: 'Select Invoices To Approve', reject: 'Rejecting...'};
			} else {
				if (_v3.c) {
					return {approve: 'Select Invoices To Approve', reject: 'Select Invoices To Reject'};
				} else {
					var invoices = A2(
						$author$project$Helpers$String$pluralize,
						{many: 'Invoices', one: 'Invoice'},
						selectedRowCount);
					return {approve: 'Approve ' + invoices, reject: 'Reject ' + invoices};
				}
			}
		}
	}();
	var templateArgs = F2(
		function (msg, _class) {
			return {enabledClass: _class, isDisabled: isDisabled, onClickMsg: msg, verifyMode: false};
		});
	var maybeAppendReject = useSubmissionWorkflow ? $elm$core$Basics$identity : $author$project$Helpers$List$appendToEnd(
		_List_fromArray(
			[
				$elm$html$Html$text($author$project$Helpers$String$nbsp),
				A2(
				$author$project$Components$Dashboard$Review$ActionArea$buttonTemplate,
				A2(templateArgs, $author$project$Components$Dashboard$Review$Model$RejectInvoices, 'button--caution'),
				buttonTexts.reject)
			]));
	return maybeAppendReject(
		_List_fromArray(
			[
				A2(
				$author$project$Components$Dashboard$Review$ActionArea$buttonTemplate,
				A2(templateArgs, $author$project$Components$Dashboard$Review$Model$SendInvoices, 'button--progress'),
				buttonTexts.approve)
			]));
};
var $author$project$Components$Dashboard$Review$Model$BulkVerifyInvoices = {$: 'BulkVerifyInvoices'};
var $author$project$Components$Dashboard$Review$Model$SetCustomState = function (a) {
	return {$: 'SetCustomState', a: a};
};
var $author$project$Helpers$Html$onChange = function (message) {
	var toConfig = function (value) {
		return {
			message: message(value),
			preventDefault: true,
			stopPropagation: true
		};
	};
	return A2(
		$elm$html$Html$Events$custom,
		'change',
		A2($elm$json$Json$Decode$map, toConfig, $elm$html$Html$Events$targetValue));
};
var $author$project$Components$Dashboard$Review$ActionArea$viewStatusOption = F2(
	function (_v0, state) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(state.id),
					$elm$html$Html$Attributes$selected(false)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(state.name)
				]));
	});
var $author$project$Components$Dashboard$Review$ActionArea$viewVerifyModeButtons = function (_v0) {
	var accountSettings = _v0.accountSettings;
	var selectedRowCount = _v0.selectedRowCount;
	var selectedCustomState = _v0.selectedCustomState;
	var sendingState = _v0.sendingState;
	var stateIsAllowed = function (state) {
		return A2(
			$elm$core$List$member,
			state.id,
			_List_fromArray(
				['ppv_exception', 'rejected', 'skipped']));
	};
	var allowedCustomStates = A2($elm$core$List$filter, stateIsAllowed, accountSettings.verificationsWorkflowDebtorBatchItemCustomStates);
	var _v1 = sendingState;
	var isVerifying = _v1.isVerifying;
	var isRejecting = _v1.isRejecting;
	var isSending = _v1.isSending;
	var isDisabled = isSending || (isRejecting || (isVerifying || (!selectedRowCount)));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__verify-mode-set-state-msg')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Finish verification for selected invoices with status: ' + $author$project$Helpers$String$nbsp)
				])),
			A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__verification-state-dropdown'),
					$author$project$Helpers$Html$onChange($author$project$Components$Dashboard$Review$Model$SetCustomState)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Dashboard$Review$ActionArea$viewStatusOption(selectedCustomState),
				allowedCustomStates)),
			A2(
			$author$project$Components$Dashboard$Review$ActionArea$buttonTemplate,
			{enabledClass: 'button--progress', isDisabled: isDisabled, onClickMsg: $author$project$Components$Dashboard$Review$Model$BulkVerifyInvoices, verifyMode: true},
			'Submit')
		]);
};
var $author$project$Components$Dashboard$Review$ActionArea$view = function (config) {
	if (config.readOnlyFactorUser) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__action-area')
				]),
			_List_Nil);
	} else {
		var _v0 = config.accountSettings;
		var reviewTabVerifyModeEnabled = _v0.reviewTabVerifyModeEnabled;
		var buttons = (reviewTabVerifyModeEnabled && config.verifyModeOn) ? $author$project$Components$Dashboard$Review$ActionArea$viewVerifyModeButtons(config) : $author$project$Components$Dashboard$Review$ActionArea$viewApprovalModeButtons(config);
		var maybeAppendVerifyModeBox = reviewTabVerifyModeEnabled ? $author$project$Helpers$List$appendToEnd(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__verify-mode-checkbox-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$id('verify_mode'),
									$elm$html$Html$Events$onClick($author$project$Components$Dashboard$Review$Model$ToggleVerifyMode),
									$elm$html$Html$Attributes$checked(config.verifyModeOn)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('verify_mode')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Use in Verify Mode')
								]))
						]))
				])) : $elm$core$Basics$identity;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__action-area')
				]),
			maybeAppendVerifyModeBox(buttons));
	}
};
var $author$project$Helpers$List$fromMaybeList = function (maybeList) {
	if (maybeList.$ === 'Just') {
		var list = maybeList.a;
		return list;
	} else {
		return _List_Nil;
	}
};
var $author$project$DashboardPresence$getPathByData = F2(
	function (dashboardPresence, pathData) {
		var paths = function () {
			if (pathData.$ === 'EmailMessageIdPath') {
				var id = pathData.a;
				return A2(
					$author$project$Id$Dict$get,
					$author$project$Domain$EmailMessageId$fromInt(id),
					dashboardPresence.pathsByEmailMessageId);
			} else {
				var id = pathData.a;
				return A2(
					$author$project$Id$Dict$get,
					$author$project$Domain$DocumentBatchId$fromInt(id),
					dashboardPresence.pathsByDocumentBatchId);
			}
		}();
		return $author$project$Helpers$List$fromMaybeList(paths);
	});
var $author$project$DashboardPresence$stateAtPath = F3(
	function (dashboardPresence, path, pathData) {
		var paths = A2(
			$elm$core$List$cons,
			path,
			A2(
				$elm$core$List$concatMap,
				$author$project$DashboardPresence$getPathByData(dashboardPresence),
				pathData));
		var others = function (p) {
			return $author$project$Helpers$List$fromMaybeList(
				A2(
					$elm$core$Dict$get,
					$author$project$DashboardPresence$stringWithoutQuery(p),
					dashboardPresence.presenceByPath));
		};
		return {
			others: A2($elm$core$List$concatMap, others, paths),
			path: path
		};
	});
var $author$project$DashboardPresence$othersPresentOnPath = F2(
	function (dashboardPresence, path) {
		return !$elm$core$List$isEmpty(
			A3($author$project$DashboardPresence$stateAtPath, dashboardPresence, path, _List_Nil).others);
	});
var $author$project$Components$Dashboard$Pager$View$filteredRows = F3(
	function (rows, presence, pathGetter) {
		return A2(
			$elm$core$List$filter,
			function (row) {
				return !A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$DashboardPresence$othersPresentOnPath(presence),
						A2(
							$elm$core$Maybe$map,
							$author$project$Path$toString,
							pathGetter(
								$author$project$Forward$Remote$toMaybe(row)))));
			},
			rows);
	});
var $author$project$DashboardPresence$carrierPresent = F2(
	function (dashboardPresence, tmsCarrierId) {
		return A2($elm$core$List$member, tmsCarrierId, dashboardPresence.carriersPresent);
	});
var $author$project$Components$Dashboard$RowHelper$carrierPresentOnFactor = F3(
	function (accountType, maybeTmsCarrier, dashboardPresence) {
		var _v0 = _Utils_Tuple2(accountType, maybeTmsCarrier);
		if ((_v0.a.$ === 'FactorAccount') && (_v0.b.$ === 'Just')) {
			var _v1 = _v0.a;
			var carrier = _v0.b.a;
			return A2($author$project$DashboardPresence$carrierPresent, dashboardPresence, carrier.id);
		} else {
			return false;
		}
	});
var $author$project$Components$Dashboard$RowHelper$multipleCustomerTooltip = function (customers) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('popup__wrapper')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Multiple Customers')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('popup')
					]),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$html$Html$text,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$singleton,
							$elm$html$Html$li(_List_Nil))),
					customers))
			]));
};
var $author$project$Components$Dashboard$RowHelper$viewCustomers = F2(
	function (settings, customers) {
		var customerText = A2(
			$elm$core$List$map,
			$author$project$Domain$TmsCustomer$customerNameForDisplay(settings),
			customers);
		return ($elm$core$List$length(customers) < 4) ? A2(
			$elm$core$List$intersperse,
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			A2($elm$core$List$map, $elm$html$Html$text, customerText)) : _List_fromArray(
			[
				$author$project$Components$Dashboard$RowHelper$multipleCustomerTooltip(customerText)
			]);
	});
var $author$project$Components$Dashboard$RowHelper$customerInformationArea = F2(
	function (settings, customer) {
		var wrapDiv = $elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__customer-information')
				]));
		switch (customer.$) {
			case 'Customers':
				var customers = customer.a;
				return wrapDiv(
					A2($author$project$Components$Dashboard$RowHelper$viewCustomers, settings, customers));
			case 'Debtor':
				var factorBroker = customer.a;
				return wrapDiv(
					$elm$core$List$singleton(
						$elm$html$Html$text(factorBroker.name)));
			default:
				return $elm$html$Html$text($author$project$Helpers$String$nbsp);
		}
	});
var $author$project$Components$Dashboard$RowHelper$tmsCarrierName = F2(
	function (accountType, maybeCarrier) {
		return A2(
			$elm$core$Maybe$withDefault,
			'Unknown ' + $author$project$Domain$Account$carrierTerm(accountType),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.name;
				},
				maybeCarrier));
	});
var $author$project$Components$Dashboard$ExceptionedRowSummary$tooltipLi = function (exceptionMessage) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(exceptionMessage)
			]));
};
var $author$project$Components$Dashboard$ExceptionedRowSummary$exceptionsUl = F2(
	function (exceptionMessages, header) {
		if (!exceptionMessages.b) {
			return $elm$html$Html$text('');
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__exception-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(header)
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2($elm$core$List$map, $author$project$Components$Dashboard$ExceptionedRowSummary$tooltipLi, exceptionMessages))
					]));
		}
	});
var $author$project$Components$Dashboard$ExceptionedRowSummary$auditBillingTooltip = F2(
	function (exceptionSummary, onlyLinkTriggersPopup) {
		var numMessages = $elm$core$String$fromInt(
			$elm$core$List$length(exceptionSummary.paymentExceptions) + $elm$core$List$length(exceptionSummary.billingExceptions));
		var _v0 = onlyLinkTriggersPopup ? _Utils_Tuple2('popup-link__wrapper', 'popup-link') : _Utils_Tuple2('popup__wrapper', 'popup');
		var wrapperClassName = _v0.a;
		var className = _v0.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(wrapperClassName)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Preview ' + (numMessages + ' exceptions'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(className)
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Dashboard$ExceptionedRowSummary$exceptionsUl, exceptionSummary.billingExceptions, 'Billing exceptions'),
							A2($author$project$Components$Dashboard$ExceptionedRowSummary$exceptionsUl, exceptionSummary.paymentExceptions, 'Payment exceptions')
						]))
				]));
	});
var $author$project$Components$Dashboard$ExceptionedRowSummary$inlineException = F2(
	function (exception, header) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__exception-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(header)
						])),
					$elm$html$Html$text(exception)
				]));
	});
var $author$project$Components$Dashboard$ExceptionedRowSummary$auditBillingView = F2(
	function (exceptionSummary, onlyLinkTriggersPopup) {
		var _v0 = _Utils_Tuple2(exceptionSummary.paymentExceptions, exceptionSummary.billingExceptions);
		_v0$3:
		while (true) {
			if (_v0.a.b) {
				if ((!_v0.a.b.b) && (!_v0.b.b)) {
					var _v1 = _v0.a;
					var firstMessage = _v1.a;
					return A2($author$project$Components$Dashboard$ExceptionedRowSummary$inlineException, firstMessage, 'Payment exception');
				} else {
					break _v0$3;
				}
			} else {
				if (!_v0.b.b) {
					return $elm$html$Html$text('');
				} else {
					if (!_v0.b.b.b) {
						var _v2 = _v0.b;
						var firstMessage = _v2.a;
						return A2($author$project$Components$Dashboard$ExceptionedRowSummary$inlineException, firstMessage, 'Billing exception');
					} else {
						break _v0$3;
					}
				}
			}
		}
		return A2($author$project$Components$Dashboard$ExceptionedRowSummary$auditBillingTooltip, exceptionSummary, onlyLinkTriggersPopup);
	});
var $author$project$Components$Dashboard$ExceptionedRowSummary$tooltip = F2(
	function (exceptionMessages, onlyLinkTriggersPopup) {
		var numMessages = $elm$core$String$fromInt(
			$elm$core$List$length(exceptionMessages));
		var _v0 = onlyLinkTriggersPopup ? _Utils_Tuple2('popup-link__wrapper', 'popup-link') : _Utils_Tuple2('popup__wrapper', 'popup');
		var wrapperClassName = _v0.a;
		var className = _v0.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(wrapperClassName)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Preview ' + (numMessages + ' exceptions'))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(className)
						]),
					A2($elm$core$List$map, $author$project$Components$Dashboard$ExceptionedRowSummary$tooltipLi, exceptionMessages))
				]));
	});
var $author$project$Components$Dashboard$ExceptionedRowSummary$defaultView = F2(
	function (exceptionMessages, onlyLinkTriggersPopup) {
		if (!exceptionMessages.b) {
			return $elm$html$Html$text('');
		} else {
			if (!exceptionMessages.b.b) {
				var firstMessage = exceptionMessages.a;
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(firstMessage)
						]));
			} else {
				return A2($author$project$Components$Dashboard$ExceptionedRowSummary$tooltip, exceptionMessages, onlyLinkTriggersPopup);
			}
		}
	});
var $author$project$Components$Dashboard$ExceptionedRowSummary$view = F3(
	function (summary, onlyLinkTriggersPopup, auditBillingEnabled) {
		return (!auditBillingEnabled) ? A2($author$project$Components$Dashboard$ExceptionedRowSummary$defaultView, summary.paymentExceptions, onlyLinkTriggersPopup) : A2($author$project$Components$Dashboard$ExceptionedRowSummary$auditBillingView, summary, onlyLinkTriggersPopup);
	});
var $author$project$Components$Dashboard$DashboardRow$View$viewDateArea = F2(
	function (tz, maybeDate) {
		if (maybeDate.$ === 'Just') {
			var date = maybeDate.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__date')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Helpers$Date$dateStringTruncated, tz, date))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' ')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__time')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Helpers$Date$timeStringNoPadding, tz, date))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('')
				]);
		}
	});
var $author$project$Presence$unique = function (items) {
	return $elm$core$Set$toList(
		$elm$core$Set$fromList(items));
};
var $author$project$Presence$viewInLine = F2(
	function (carrierPresence, state) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('presence__container--inline message__presence-list', true),
								_Utils_Tuple2(
								'hide',
								$elm$core$List$isEmpty(state.others))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('presence__who')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Currently viewed by: ' + A2(
									$elm$core$String$join,
									', ',
									$author$project$Presence$unique(state.others)))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('presence__container--inline')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('presence__who presence__carrier', carrierPresence)
									]))
							]),
						_List_Nil)
					]))
			]);
	});
var $author$project$Components$Dashboard$RowHelper$carrierLabelButton = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carrier-labels__label')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Helpers$List$removeDuplicates = function (list) {
	return $elm$core$Set$toList(
		$elm$core$Set$fromList(list));
};
var $author$project$Components$Dashboard$DashboardRow$View$viewLabels = function (labels) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Dashboard$RowHelper$carrierLabelButton,
		$author$project$Helpers$List$removeDuplicates(labels));
};
var $author$project$Components$Dashboard$CarrierInvoiceRow$View$viewSelectedRowCheckbox = F2(
	function (config, invoiceRow) {
		var _v0 = _Utils_Tuple2(config.onSelectSelectable, config.accountSettings.ignoreMode);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'IgnoreModeBulkIgnore')) {
			var onSelectSelectable = _v0.a.a;
			var _v1 = _v0.b;
			var ignorable = $author$project$Components$Dashboard$Pager$Selectable$CarrierInvoice(invoiceRow.carrierInvoiceId);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__selected-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__selected')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(
										A2($author$project$Components$Dashboard$Pager$Selectable$setMember, ignorable, config.selectedSelectables)),
										$author$project$Components$Dashboard$DashboardRow$View$safeOnCheck(
										onSelectSelectable(ignorable))
									]),
								_List_Nil)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Dashboard$CarrierInvoiceRow$View$carrierInvoiceDashboardRowView = F2(
	function (config, carrierInvoiceRow) {
		var tmsCarrierString = A2($author$project$Components$Dashboard$RowHelper$tmsCarrierName, config.accountType, carrierInvoiceRow.tmsCarrier);
		var shouldShowDeliveredAt = A4($author$project$Components$Dashboard$DashboardRow$shouldShowDeliveredAt, config.accountType, config.accountSettings, config.dashboardMode, config.queue);
		var relativeDeliveredAt = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A3(
					$elm$core$Maybe$map2,
					$author$project$Components$Dashboard$RowHelper$getRelativeDeliveredAt(config.tz),
					config.currentDate,
					carrierInvoiceRow.deliveredAt)));
		var presence = A3(
			$author$project$DashboardPresence$stateAtPath,
			config.dashboardPresence,
			$author$project$Path$toString(carrierInvoiceRow.redirectTo),
			_List_Nil);
		var emailMessages = carrierInvoiceRow.emailAndReplyMessages;
		var oldestEmailCreatedAtDate = A2(
			$author$project$Helpers$List$foldl1,
			$author$project$Helpers$Date$min,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.createdAt;
				},
				emailMessages));
		var customers = A2($author$project$Components$Dashboard$DashboardRow$customersToCustomerType, carrierInvoiceRow.shipmentCustomers, carrierInvoiceRow.loadCustomer);
		var carrierExists = A3($author$project$Components$Dashboard$RowHelper$carrierPresentOnFactor, config.accountType, carrierInvoiceRow.tmsCarrier, config.dashboardPresence);
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($author$project$Components$Dashboard$CarrierInvoiceRow$View$viewSelectedRowCheckbox, config, carrierInvoiceRow)),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__ready-to-audit-load-number')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__subject')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(carrierInvoiceRow.loadId)
									]))
							]))),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__ready-to-audit-carrier')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__carrier message--truncate')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(tmsCarrierString)
									]))
							]))),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__ready-to-audit-customer')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Dashboard$RowHelper$customerInformationArea, config.accountSettings, customers)
							]))),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__ready-to-audit-date-received')
							]),
						A2($author$project$Components$Dashboard$DashboardRow$View$viewDateArea, config.tz, oldestEmailCreatedAtDate))),
					shouldShowDeliveredAt ? $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__ready-to-audit-date-delivered')
							]),
						A2(
							$elm$core$List$append,
							A2($author$project$Components$Dashboard$DashboardRow$View$viewDateArea, config.tz, carrierInvoiceRow.deliveredAt),
							_List_fromArray(
								[
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									relativeDeliveredAt
								])))) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__ready-to-audit-exception-and-notes')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__sender')
									]),
								_List_fromArray(
									[
										A3($author$project$Components$Dashboard$ExceptionedRowSummary$view, carrierInvoiceRow.exceptionSummary, true, config.accountSettings.auditBillingEnabled)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('carrier_labels message__carrier-labels')
									]),
								$author$project$Components$Dashboard$DashboardRow$View$viewLabels(carrierInvoiceRow.labels)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('presence_list')
									]),
								A2($author$project$Presence$viewInLine, carrierExists, presence))
							])))
				]));
	});
var $author$project$Components$Dashboard$RowHelper$messageSubject = function (string) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__subject-area')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__subject')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(string)
					]))
			]));
};
var $author$project$Components$Dashboard$DashboardRow$View$wrapper = F4(
	function (isOddRow, additionalRowClasses, maybeMsg, children) {
		var maybeAppendClasses = function (list) {
			if (additionalRowClasses.$ === 'Just') {
				var _class = additionalRowClasses.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(_class, true),
					list);
			} else {
				return list;
			}
		};
		var classes = $elm$html$Html$Attributes$classList(
			maybeAppendClasses(
				_List_fromArray(
					[
						_Utils_Tuple2('dashboard__messages-row', true),
						_Utils_Tuple2('odd', isOddRow)
					])));
		var attributes = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(classes),
					A2(
					$elm$core$Maybe$map,
					function (msg) {
						return A2(
							$elm$html$Html$Events$custom,
							'click',
							$elm$json$Json$Decode$succeed(
								{message: msg, preventDefault: true, stopPropagation: true}));
					},
					maybeMsg)
				]));
		return A2($elm$html$Html$div, attributes, children);
	});
var $author$project$Components$Dashboard$DashboardRow$View$customView = F2(
	function (config, data) {
		var additionalRowClasses = config.additionalRowClasses;
		var isOddRow = config.isOddRow;
		var _v0 = A2($author$project$Forward$Remote$andThen, config.view, data);
		switch (_v0.$) {
			case 'Loaded':
				var customRow = _v0.a;
				return A4($author$project$Components$Dashboard$DashboardRow$View$wrapper, isOddRow, additionalRowClasses, customRow.onRowClick, customRow.html);
			case 'Loading':
				return A4(
					$author$project$Components$Dashboard$DashboardRow$View$wrapper,
					isOddRow,
					additionalRowClasses,
					$elm$core$Maybe$Nothing,
					_List_fromArray(
						[
							$author$project$Components$Dashboard$RowHelper$messageSubject('Loading ...')
						]));
			default:
				var error = _v0.a;
				return A4(
					$author$project$Components$Dashboard$DashboardRow$View$wrapper,
					isOddRow,
					additionalRowClasses,
					$elm$core$Maybe$Nothing,
					_List_fromArray(
						[
							$author$project$Forward$LoadingView$defaultErrorView(error)
						]));
		}
	});
var $author$project$Components$Dashboard$DashboardRow$View$isOdd = function (i) {
	return A2($elm$core$Basics$modBy, 2, i) === 1;
};
var $author$project$Components$Dashboard$CarrierInvoiceRow$View$onClickHandler = F2(
	function (onRowClick, carrierInvoiceRow) {
		return $elm$core$Maybe$Just(
			onRowClick(carrierInvoiceRow.redirectTo));
	});
var $author$project$Components$Dashboard$CarrierInvoiceRow$View$view = F3(
	function (config, index, carrierInvoiceRow) {
		return A2(
			$author$project$Components$Dashboard$DashboardRow$View$customView,
			{
				additionalRowClasses: $elm$core$Maybe$Nothing,
				isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
				view: function (row) {
					return $author$project$Forward$Remote$Loaded(
						{
							html: A2($author$project$Components$Dashboard$CarrierInvoiceRow$View$carrierInvoiceDashboardRowView, config, row),
							onRowClick: A2($author$project$Components$Dashboard$CarrierInvoiceRow$View$onClickHandler, config.onRowClick, row)
						});
				}
			},
			carrierInvoiceRow);
	});
var $author$project$Components$Dashboard$Pager$View$viewCarrierInvoicePager = F2(
	function (config, carrierInvoiceRows) {
		var viewConfig = {accountSettings: config.accountSettings, accountType: config.accountType, currentDate: config.currentDate, dashboardMode: config.dashboardMode, dashboardPresence: config.dashboardPresence, onRowClick: config.onRowClick, onSelectSelectable: config.onSelectSelectable, queue: config.queue, selectedSelectables: config.selectedSelectables, tz: config.tz};
		var rows = config.hideIfOthersPresent ? A3(
			$author$project$Components$Dashboard$Pager$View$filteredRows,
			carrierInvoiceRows,
			config.dashboardPresence,
			$elm$core$Maybe$map(
				function ($) {
					return $.redirectTo;
				})) : carrierInvoiceRows;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$Dashboard$CarrierInvoiceRow$View$view(viewConfig),
				rows));
	});
var $author$project$DashboardPresence$EmailMessageIdPath = function (a) {
	return {$: 'EmailMessageIdPath', a: a};
};
var $author$project$DashboardPresence$DocumentBatchId = function (a) {
	return {$: 'DocumentBatchId', a: a};
};
var $author$project$Components$Dashboard$EmailRow$documentBatchToPathData = function (batch) {
	return $author$project$DashboardPresence$DocumentBatchId(
		$author$project$Domain$DocumentBatchId$toInt(batch.id));
};
var $author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName = F2(
	function (accountType, tmsCarrierData) {
		var _v0 = tmsCarrierData.singleCarrier;
		if (_v0.$ === 'Nothing') {
			return 'Unknown ' + $author$project$Domain$Account$carrierTerm(accountType);
		} else {
			if (!_v0.a) {
				return 'Multiple ' + ($author$project$Domain$Account$carrierTerm(accountType) + 's');
			} else {
				return A2($author$project$Components$Dashboard$RowHelper$tmsCarrierName, accountType, tmsCarrierData.tmsCarrier);
			}
		}
	});
var $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentBatchGroupingReview = {$: 'DocumentBatchGroupingReview'};
var $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReview = {$: 'DocumentContentReview'};
var $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReviewDocumentType = {$: 'DocumentContentReviewDocumentType'};
var $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReviewNoDependents = {$: 'DocumentContentReviewNoDependents'};
var $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentGroupLoadReview = {$: 'DocumentGroupLoadReview'};
var $author$project$Domain$EmailMessageAsynchronousReviewType$PodReview = {$: 'PodReview'};
var $author$project$Components$Dashboard$DashboardRow$View$importingButtonArea = _List_fromArray(
	[
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__action button disabled')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Importing...')
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__pages')
			]),
		_List_Nil)
	]);
var $author$project$Components$Dashboard$DashboardRow$View$importProgressLabelArea = function (importStatus) {
	var progressMessage = $elm$core$String$fromInt(importStatus.pageInStep) + ('/' + ($elm$core$String$fromInt(importStatus.pages) + ' importing'));
	var _v0 = importStatus.step;
	if (_v0.$ === 'ImportStepExtractData') {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-area-import-progress-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(progressMessage)
					]))
			]);
	} else {
		return $author$project$Components$Dashboard$DashboardRow$View$importingButtonArea;
	}
};
var $author$project$Components$Dashboard$DashboardRow$View$importingFailedButtonArea = _List_fromArray(
	[
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__action button disabled')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Import Failed')
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__pages')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Support has been notified.')
			]))
	]);
var $author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelArea = F4(
	function (maybeSkipAsynchronousEmailReview, emailMessageId, maybeDocumentBatchId, reviewType) {
		var _v0 = function () {
			switch (reviewType.$) {
				case 'PodReview':
					return _Utils_Tuple2('POD processing', 'Manually process >');
				case 'DocumentContentReview':
					return _Utils_Tuple2('Document Data Extraction', 'Skip data extraction >');
				case 'DocumentContentReviewDocumentType':
					return _Utils_Tuple2('Document Type Processing', 'Skip data extraction >');
				case 'DocumentContentReviewNoDependents':
					return _Utils_Tuple2('Document Data Extraction', 'Skip data extraction >');
				case 'DocumentBatchGroupingReview':
					return _Utils_Tuple2('Document Grouping Review', 'Skip grouping review >');
				default:
					return _Utils_Tuple2('Load Review', 'Skip load review >');
			}
		}();
		var processingText = _v0.a;
		var skipText = _v0.b;
		var processingLabel = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__action-area-import-progress-label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(processingText)
				]));
		var _v2 = _Utils_Tuple2(maybeDocumentBatchId, maybeSkipAsynchronousEmailReview);
		if ((_v2.a.$ === 'Just') && (_v2.b.$ === 'Just')) {
			var documentBatchId = _v2.a.a;
			var skipAsynchronousEmailReview = _v2.b.a;
			return _List_fromArray(
				[
					processingLabel,
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__manually-process'),
							$elm$html$Html$Events$onClick(
							A3(skipAsynchronousEmailReview, emailMessageId, documentBatchId, reviewType))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(skipText)
						]))
				]);
		} else {
			return _List_fromArray(
				[processingLabel]);
		}
	});
var $author$project$Domain$InvoiceAutoProcessingData$listAsString = function (invoiceAutoProcessingList) {
	var numOfInvoices = $elm$core$List$length(invoiceAutoProcessingList);
	var numOfAutoProcessedInvoices = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.wasAutoProcessed;
			},
			invoiceAutoProcessingList));
	return ((!numOfAutoProcessedInvoices) || _Utils_eq(numOfInvoices, numOfAutoProcessedInvoices)) ? '' : ($elm$core$String$fromInt(numOfAutoProcessedInvoices) + (' / ' + ($elm$core$String$fromInt(numOfInvoices) + ' auto processed')));
};
var $author$project$Components$Dashboard$DashboardRow$autoProcessingString = function (maybeDocumentBatch) {
	return $author$project$Domain$InvoiceAutoProcessingData$listAsString(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.autoProcessingData;
				},
				maybeDocumentBatch)));
};
var $author$project$Components$Dashboard$DashboardRow$pagesString = function (maybeDocumentBatch) {
	return A2(
		$author$project$Helpers$String$pluralize,
		{many: 'pages', one: 'page'},
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.pages;
				},
				maybeDocumentBatch)));
};
var $author$project$Components$Dashboard$DashboardRow$View$processedButtonArea = F2(
	function (maybeDocumentBatch, showProcessThisButton) {
		return showProcessThisButton ? _List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Process This')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__pages')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Dashboard$DashboardRow$pagesString(maybeDocumentBatch))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__auto-processing-data')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Dashboard$DashboardRow$autoProcessingString(maybeDocumentBatch))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__pages')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Dashboard$DashboardRow$pagesString(maybeDocumentBatch))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__auto-processing-data')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Dashboard$DashboardRow$autoProcessingString(maybeDocumentBatch))
					]))
			]);
	});
var $author$project$Components$Dashboard$DashboardRow$View$viewMessageActionArea = F7(
	function (onSkipAsynchronousEmailReview, emailImportState, maybeImportStatus, maybeDocumentBatch, showProcessThisButton, emailMessageId, documentBatchId) {
		var className = showProcessThisButton ? 'message__action-area' : 'message__page-count-area';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className)
				]),
			function () {
				var _v0 = _Utils_Tuple2(emailImportState, maybeImportStatus);
				switch (_v0.a.$) {
					case 'EmailImportStateImportInProgress':
						if (_v0.b.$ === 'Just') {
							var _v1 = _v0.a;
							var importStatus = _v0.b.a;
							return $author$project$Components$Dashboard$DashboardRow$View$importProgressLabelArea(importStatus);
						} else {
							var _v2 = _v0.a;
							var _v3 = _v0.b;
							return $author$project$Components$Dashboard$DashboardRow$View$importingButtonArea;
						}
					case 'EmailImportStateInDocumentContentReview':
						var _v4 = _v0.a;
						return A4($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelArea, onSkipAsynchronousEmailReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReview);
					case 'EmailImportStateInDocumentContentReviewDocumentType':
						var _v5 = _v0.a;
						return A4($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelArea, onSkipAsynchronousEmailReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReviewDocumentType);
					case 'EmailImportStateInDocumentContentReviewNoDependents':
						var _v6 = _v0.a;
						return A4($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelArea, onSkipAsynchronousEmailReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReviewNoDependents);
					case 'EmailImportStateInDocumentBatchGroupingReview':
						var _v7 = _v0.a;
						return A4($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelArea, onSkipAsynchronousEmailReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentBatchGroupingReview);
					case 'EmailImportStateInDocumentGroupLoadReview':
						var _v8 = _v0.a;
						return A4($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelArea, onSkipAsynchronousEmailReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentGroupLoadReview);
					case 'EmailImportStateInPODDetection':
						var _v9 = _v0.a;
						return A4($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelArea, onSkipAsynchronousEmailReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$PodReview);
					case 'EmailImportStateImportFailed':
						var _v10 = _v0.a;
						return $author$project$Components$Dashboard$DashboardRow$View$importingFailedButtonArea;
					default:
						var _v11 = _v0.a;
						return A2($author$project$Components$Dashboard$DashboardRow$View$processedButtonArea, maybeDocumentBatch, showProcessThisButton);
				}
			}());
	});
var $author$project$Components$Dashboard$EmailRow$View$viewSelectedRowCheckbox = F2(
	function (config, emailRow) {
		var _v0 = config.onSelectSelectable;
		if (_v0.$ === 'Just') {
			var onSelectSelectable = _v0.a;
			var ignorable = $author$project$Components$Dashboard$Pager$Selectable$EmailMessage(emailRow.emailMessage.id);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__selected-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__selected')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(
										A2($author$project$Components$Dashboard$Pager$Selectable$setMember, ignorable, config.selectedSelectables)),
										$author$project$Components$Dashboard$DashboardRow$View$safeOnCheck(
										onSelectSelectable(ignorable))
									]),
								_List_Nil)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Domain$ExceptionSummary$hasExceptions = function (exceptionSummary) {
	var paymentExceptions = !$elm$core$List$isEmpty(exceptionSummary.paymentExceptions);
	var billingExceptions = !$elm$core$List$isEmpty(exceptionSummary.billingExceptions);
	return paymentExceptions || billingExceptions;
};
var $author$project$Components$Dashboard$DashboardRow$View$viewSenderOrSummary = F3(
	function (accountSettings, sender, summary) {
		return $author$project$Domain$ExceptionSummary$hasExceptions(summary) ? A3($author$project$Components$Dashboard$ExceptionedRowSummary$view, summary, false, accountSettings.auditBillingEnabled) : $elm$html$Html$text(
			A2($elm$core$Maybe$withDefault, '', sender));
	});
var $author$project$Components$Dashboard$DashboardRow$View$viewSender = F2(
	function (accountSettings, sender) {
		return A3($author$project$Components$Dashboard$DashboardRow$View$viewSenderOrSummary, accountSettings, sender, $author$project$Domain$ExceptionSummary$empty);
	});
var $author$project$Components$Dashboard$EmailRow$View$emailDashboardRowView = F2(
	function (config, emailRow) {
		var emailMessage = emailRow.emailMessage;
		var tmsCarrierString = A2(
			$author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName,
			config.accountType,
			{singleCarrier: emailMessage.singleCarrier, tmsCarrier: emailRow.maybeTmsCarrier});
		var maybeDocumentBatchId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.id;
			},
			emailRow.maybeDocumentBatch);
		var carrierExists = A3($author$project$Components$Dashboard$RowHelper$carrierPresentOnFactor, config.accountType, emailRow.maybeTmsCarrier, config.dashboardPresence);
		var batchPathData = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2($elm$core$Maybe$map, $author$project$Components$Dashboard$EmailRow$documentBatchToPathData, emailRow.maybeDocumentBatch)));
		var presence = A3(
			$author$project$DashboardPresence$stateAtPath,
			config.dashboardPresence,
			$author$project$Path$toString(emailRow.redirectTo),
			A2(
				$elm$core$List$cons,
				$author$project$DashboardPresence$EmailMessageIdPath(
					$author$project$Domain$EmailMessageId$toInt(emailMessage.id)),
				batchPathData));
		return _List_fromArray(
			[
				A2($author$project$Components$Dashboard$EmailRow$View$viewSelectedRowCheckbox, config, emailRow),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__small-subject-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__subject message--truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(emailMessage.subject)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('carrier_labels message__carrier-labels')
							]),
						$author$project$Components$Dashboard$DashboardRow$View$viewLabels(emailMessage.labels)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('presence_list')
							]),
						A2($author$project$Presence$viewInLine, carrierExists, presence))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__email-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__sender message--truncate')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Dashboard$DashboardRow$View$viewSender,
								config.accountSettings,
								$elm$core$Maybe$Just(emailMessage.senderAddress))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__date-area')
					]),
				A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateArea,
					config.tz,
					$elm$core$Maybe$Just(emailMessage.createdAt))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__carrier-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__carrier message--truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(tmsCarrierString)
							]))
					])),
				A7($author$project$Components$Dashboard$DashboardRow$View$viewMessageActionArea, config.onSkipAsynchronousEmailReview, emailMessage.importState, emailRow.maybeImportStatus, emailRow.maybeDocumentBatch, false, emailMessage.id, maybeDocumentBatchId)
			]);
	});
var $author$project$Domain$EmailMessage$importCompleted = function (state) {
	switch (state.$) {
		case 'EmailImportStateImportCompleted':
			return true;
		case 'EmailImportStateImportInProgress':
			return false;
		case 'EmailImportStateInPODDetection':
			return false;
		case 'EmailImportStateInDocumentContentReview':
			return false;
		case 'EmailImportStateInDocumentContentReviewDocumentType':
			return false;
		case 'EmailImportStateInDocumentContentReviewNoDependents':
			return false;
		case 'EmailImportStateInDocumentBatchGroupingReview':
			return false;
		case 'EmailImportStateInDocumentGroupLoadReview':
			return false;
		default:
			return false;
	}
};
var $author$project$Components$Dashboard$EmailRow$View$onClickHandler = F2(
	function (onRowClick, emailRow) {
		var emailMessage = emailRow.emailMessage;
		return $author$project$Domain$EmailMessage$importCompleted(emailMessage.importState) ? $elm$core$Maybe$Just(
			onRowClick(emailRow.redirectTo)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Dashboard$DashboardRow$Email = {$: 'Email'};
var $author$project$Components$Dashboard$EmailRow$View$toDashboardRow = F3(
	function (accountType, dashboardPresence, emailRow) {
		var emailMessage = emailRow.emailMessage;
		return {
			age: $elm$core$Maybe$Nothing,
			carrierExists: A3($author$project$Components$Dashboard$RowHelper$carrierPresentOnFactor, accountType, emailRow.maybeTmsCarrier, dashboardPresence),
			createdAt: $elm$core$Maybe$Just(emailMessage.createdAt),
			customers: $author$project$Components$Dashboard$DashboardRow$NoCustomers,
			emailImportState: emailMessage.importState,
			ignorable: $elm$core$Maybe$Just(
				$author$project$Components$Dashboard$Pager$Selectable$EmailMessage(emailMessage.id)),
			isCompleted: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(true),
					emailMessage.completedAt)),
			labels: emailMessage.labels,
			lastSentAt: $elm$core$Maybe$Nothing,
			nextReviewOn: $elm$core$Maybe$Nothing,
			note: $elm$core$Maybe$Just(''),
			pages: $author$project$Components$Dashboard$DashboardRow$pagesString(emailRow.maybeDocumentBatch),
			presence: function () {
				var batchPathData = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A2($elm$core$Maybe$map, $author$project$Components$Dashboard$EmailRow$documentBatchToPathData, emailRow.maybeDocumentBatch)));
				return A3(
					$author$project$DashboardPresence$stateAtPath,
					dashboardPresence,
					$author$project$Path$toString(emailRow.redirectTo),
					A2(
						$elm$core$List$cons,
						$author$project$DashboardPresence$EmailMessageIdPath(
							$author$project$Domain$EmailMessageId$toInt(emailMessage.id)),
						batchPathData));
			}(),
			redirectTo: emailRow.redirectTo,
			rowType: $author$project$Components$Dashboard$DashboardRow$Email,
			sender: $elm$core$Maybe$Just(emailMessage.senderAddress),
			subject: emailMessage.subject,
			summary: $author$project$Domain$ExceptionSummary$empty,
			tmsCarrierString: A2(
				$author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName,
				accountType,
				{singleCarrier: emailMessage.singleCarrier, tmsCarrier: emailRow.maybeTmsCarrier})
		};
	});
var $author$project$Components$Dashboard$EmailRow$View$view = F3(
	function (config, index, emailRowData) {
		var isOddRow = $author$project$Components$Dashboard$DashboardRow$View$isOdd(index);
		var dashboardRowData = A2(
			$author$project$Forward$Remote$map,
			A2($author$project$Components$Dashboard$EmailRow$View$toDashboardRow, config.accountType, config.dashboardPresence),
			emailRowData);
		var additionalClasses = _Utils_eq(
			$elm$core$Maybe$Just($author$project$AuditPb$EmailImportStateImportCompleted),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.emailImportState;
				},
				$author$project$Forward$Remote$toMaybe(dashboardRowData))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('importing');
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.isCompleted;
				},
				$author$project$Forward$Remote$toMaybe(dashboardRowData))) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
			$author$project$Components$Dashboard$DashboardRow$View$customView,
			{
				additionalRowClasses: additionalClasses,
				isOddRow: isOddRow,
				view: function (row) {
					return $author$project$Forward$Remote$Loaded(
						{
							html: A2($author$project$Components$Dashboard$EmailRow$View$emailDashboardRowView, config, row),
							onRowClick: A2($author$project$Components$Dashboard$EmailRow$View$onClickHandler, config.onRowClick, row)
						});
				}
			},
			emailRowData);
	});
var $author$project$Components$Dashboard$Pager$View$viewEmailPager = F2(
	function (config, emailRows) {
		var viewEmailRow = $author$project$Components$Dashboard$EmailRow$View$view(
			{accountSettings: config.accountSettings, accountType: config.accountType, dashboardPresence: config.dashboardPresence, onRowClick: config.onRowClick, onSelectSelectable: config.onSelectSelectable, onSkipAsynchronousEmailReview: config.onSkipAsynchronousEmailReview, selectedSelectables: config.selectedSelectables, tz: config.tz});
		var dashboardPresence = config.dashboardPresence;
		var rows = config.hideIfOthersPresent ? A3(
			$author$project$Components$Dashboard$Pager$View$filteredRows,
			emailRows,
			dashboardPresence,
			$elm$core$Maybe$map(
				function ($) {
					return $.redirectTo;
				})) : emailRows;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$indexedMap, viewEmailRow, rows));
	});
var $author$project$Components$Dashboard$DashboardRow$View$nextReviewText = function (maybeNextReviewOn) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Helpers$Date$dateStringFromDate, maybeNextReviewOn));
};
var $author$project$Components$Dashboard$ExceptionedRowSummary$noteTooltip = function (maybeNote) {
	if (maybeNote.$ === 'Just') {
		var note = maybeNote.a;
		var shouldTruncate = $elm$core$String$length(note) > 50;
		var visibleNote = shouldTruncate ? (A3($elm$core$String$slice, 0, 50, note) + '...') : note;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('popup-link__wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(visibleNote)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('popup-link')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(note)
								]))
						]))
				]));
	} else {
		return A2($elm$html$Html$span, _List_Nil, _List_Nil);
	}
};
var $author$project$Components$Dashboard$ExceptionedRow$View$lastSentText = function (maybeLastSent) {
	return A2(
		$elm$core$String$join,
		' - ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[maybeLastSent])));
};
var $author$project$Components$Dashboard$ExceptionedRow$View$viewExceptionDateArea = function (lastSent) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Components$Dashboard$ExceptionedRow$View$lastSentText(lastSent))
				]))
		]);
};
var $author$project$Components$Dashboard$ExceptionedRow$View$viewMaybeMessageNote = function (maybeMessageNote) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__sender')
			]),
		_List_fromArray(
			[
				$author$project$Components$Dashboard$ExceptionedRowSummary$noteTooltip(maybeMessageNote)
			]));
};
var $author$project$Domain$ExceptionedItem$toSelectable = function (id) {
	return $author$project$Components$Dashboard$Pager$Selectable$ExceptionedItem(id);
};
var $author$project$Components$Dashboard$ExceptionedRow$View$viewSelectedRowCheckbox = F2(
	function (config, _v0) {
		var exceptionedRow = _v0.a;
		var _v1 = config.onSelectSelectable;
		if (_v1.$ === 'Just') {
			var onSelectSelectable = _v1.a;
			var ignorable = $author$project$Domain$ExceptionedItem$toSelectable(exceptionedRow.exceptionedItem.id);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__selected-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__selected')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(
										A2($author$project$Components$Dashboard$Pager$Selectable$setMember, ignorable, config.selectedSelectables)),
										$author$project$Components$Dashboard$DashboardRow$View$safeOnCheck(
										onSelectSelectable(ignorable))
									]),
								_List_Nil)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Dashboard$ExceptionedRow$View$exceptionedItemDashboardRowView = F2(
	function (config, _v0) {
		var exceptionedRow = _v0.a;
		var shouldShowDeliveredAt = A4($author$project$Components$Dashboard$DashboardRow$shouldShowDeliveredAt, config.accountType, config.accountSettings, config.dashboardMode, config.queue);
		var ownerData = exceptionedRow.ownerData;
		var presence = A3(
			$author$project$DashboardPresence$stateAtPath,
			config.dashboardPresence,
			$author$project$Path$toString(ownerData.redirectTo),
			_List_Nil);
		var relativeDeliveredAt = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A3(
					$elm$core$Maybe$map2,
					$author$project$Components$Dashboard$RowHelper$getRelativeDeliveredAt(config.tz),
					config.currentDate,
					ownerData.deliveredAt)));
		var showSubject = function () {
			var _v2 = ownerData.loadId;
			if (_v2.$ === 'Just') {
				return false;
			} else {
				return true;
			}
		}();
		var loadOrSubjectLineClass = shouldShowDeliveredAt ? 'message__exceptioned-item-load-number' : 'message__exceptioned-item-subject-line';
		var exceptionedItem = exceptionedRow.exceptionedItem;
		var displayIdText = function () {
			var _v1 = ownerData.loadDisplayId;
			if (_v1.$ === 'Just') {
				var displayId_ = _v1.a;
				return $elm$html$Html$text(displayId_.label + (': ' + displayId_.identifier));
			} else {
				return $elm$html$Html$text($author$project$Helpers$String$nbsp);
			}
		}();
		var secondaryLoadFieldText = showSubject ? $author$project$Components$Dashboard$ExceptionedRowSummary$noteTooltip(
			$elm$core$Maybe$Just(ownerData.subject)) : displayIdText;
		var carrierExists = A3($author$project$Components$Dashboard$RowHelper$carrierPresentOnFactor, config.accountType, ownerData.tmsCarrierData.tmsCarrier, config.dashboardPresence);
		var ageOrReceived = config.accountSettings.showDateReceivedOnExceptionAndWaiting ? A2($author$project$Components$Dashboard$DashboardRow$View$viewDateArea, config.tz, exceptionedItem.firstReceivedAt) : _List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A3(
						$elm$core$Maybe$map2,
						$author$project$Components$Dashboard$ExceptionedRow$View$getAge(config.tz),
						config.currentDate,
						exceptionedItem.createdAt)))
			]);
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$author$project$Components$Dashboard$ExceptionedRow$View$viewSelectedRowCheckbox,
						config,
						$author$project$Components$Dashboard$ExceptionedRow$ExceptionedRow(exceptionedRow))),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(loadOrSubjectLineClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, 'Unknown', ownerData.loadId)),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								secondaryLoadFieldText
							]))),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__exceptioned-item-carrier')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__carrier message--truncate')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName, config.accountType, ownerData.tmsCarrierData))
									]))
							]))),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__exceptioned-item-customer')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Dashboard$RowHelper$customerInformationArea, config.accountSettings, ownerData.customers)
							]))),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__exceptioned-item-last-contact')
							]),
						$author$project$Components$Dashboard$ExceptionedRow$View$viewExceptionDateArea(
							A2(
								$elm$core$Maybe$map,
								$author$project$Helpers$Date$dateStringTruncated(config.tz),
								exceptionedItem.lastSentAt)))),
					shouldShowDeliveredAt ? $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__exceptioned-item-date-delivered')
							]),
						A2(
							$elm$core$List$append,
							A2($author$project$Components$Dashboard$DashboardRow$View$viewDateArea, config.tz, ownerData.deliveredAt),
							_List_fromArray(
								[
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									relativeDeliveredAt
								])))) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__exceptioned-item-age-review')
							]),
						A2(
							$elm$core$List$append,
							ageOrReceived,
							_List_fromArray(
								[
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text(
									$author$project$Components$Dashboard$DashboardRow$View$nextReviewText(
										A2(
											$elm$core$Maybe$map,
											$justinmimbs$date$Date$fromPosix($elm$time$Time$utc),
											exceptionedItem.nextReviewOn)))
								])))),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__exceptioned-item-exception-and-notes')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__sender')
									]),
								_List_fromArray(
									[
										A3($author$project$Components$Dashboard$ExceptionedRowSummary$view, exceptionedRow.ownerData.exceptionSummary, true, config.accountSettings.auditBillingEnabled)
									])),
								$author$project$Components$Dashboard$ExceptionedRow$View$viewMaybeMessageNote(exceptionedItem.note),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('carrier_labels message__carrier-labels')
									]),
								$author$project$Components$Dashboard$DashboardRow$View$viewLabels(ownerData.labels)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('presence_list')
									]),
								A2($author$project$Presence$viewInLine, carrierExists, presence))
							])))
				]));
	});
var $author$project$Components$Dashboard$ExceptionedRow$View$onClickHandler = F2(
	function (onRowClick, exceptionedRow) {
		return $elm$core$Maybe$Just(
			onRowClick(
				$author$project$Components$Dashboard$ExceptionedRow$View$ownerDataRedirectTo(exceptionedRow)));
	});
var $author$project$Components$Dashboard$ExceptionedRow$View$view = F3(
	function (config, index, exceptionedRow) {
		return A2(
			$author$project$Components$Dashboard$DashboardRow$View$customView,
			{
				additionalRowClasses: $elm$core$Maybe$Nothing,
				isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
				view: function (row) {
					return $author$project$Forward$Remote$Loaded(
						{
							html: A2($author$project$Components$Dashboard$ExceptionedRow$View$exceptionedItemDashboardRowView, config, row),
							onRowClick: A2($author$project$Components$Dashboard$ExceptionedRow$View$onClickHandler, config.onRowClick, row)
						});
				}
			},
			exceptionedRow);
	});
var $author$project$Components$Dashboard$Pager$View$viewExceptionPager = F2(
	function (config, exceptionedRows) {
		var viewExceptionedRow = $author$project$Components$Dashboard$ExceptionedRow$View$view(
			{accountSettings: config.accountSettings, accountType: config.accountType, currentDate: config.currentDate, dashboardMode: config.dashboardMode, dashboardPresence: config.dashboardPresence, onRowClick: config.onRowClick, onSelectSelectable: config.onSelectSelectable, queue: config.queue, selectedSelectables: config.selectedSelectables, tz: config.tz});
		var rows = config.hideIfOthersPresent ? A3(
			$author$project$Components$Dashboard$Pager$View$filteredRows,
			exceptionedRows,
			config.dashboardPresence,
			$elm$core$Maybe$map($author$project$Components$Dashboard$ExceptionedRow$View$ownerDataRedirectTo)) : exceptionedRows;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$indexedMap, viewExceptionedRow, rows));
	});
var $author$project$Components$Dashboard$NeedsIndexingRow$documentBatchToPathData = function (batch) {
	return $author$project$DashboardPresence$DocumentBatchId(
		$author$project$Domain$DocumentBatchId$toInt(batch.id));
};
var $author$project$Components$Dashboard$NeedsIndexingRow$View$viewSelectedRowCheckbox = F2(
	function (config, needsIndexingRow) {
		var _v0 = config.onSelectSelectable;
		if (_v0.$ === 'Just') {
			var onSelectSelectable = _v0.a;
			var ignorable = $author$project$Components$Dashboard$Pager$Selectable$EmailMessage(needsIndexingRow.emailMessage.id);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__selected-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__selected')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(
										A2($author$project$Components$Dashboard$Pager$Selectable$setMember, ignorable, config.selectedSelectables)),
										$author$project$Components$Dashboard$DashboardRow$View$safeOnCheck(
										onSelectSelectable(ignorable))
									]),
								_List_Nil)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Dashboard$NeedsIndexingRow$View$needsIndexingRowView = F2(
	function (config, needsIndexingRow) {
		var emailMessage = needsIndexingRow.emailMessage;
		var documentBatchId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.id;
			},
			needsIndexingRow.maybeDocumentBatch);
		var carrierExists = A3($author$project$Components$Dashboard$RowHelper$carrierPresentOnFactor, config.accountType, needsIndexingRow.maybeTmsCarrier, config.dashboardPresence);
		var batchPathData = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2($elm$core$Maybe$map, $author$project$Components$Dashboard$NeedsIndexingRow$documentBatchToPathData, needsIndexingRow.maybeDocumentBatch)));
		var presence = A3(
			$author$project$DashboardPresence$stateAtPath,
			config.dashboardPresence,
			$author$project$Path$toString(needsIndexingRow.redirectTo),
			A2(
				$elm$core$List$cons,
				$author$project$DashboardPresence$EmailMessageIdPath(
					$author$project$Domain$EmailMessageId$toInt(emailMessage.id)),
				batchPathData));
		var batchExternalId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.externalId;
				},
				needsIndexingRow.submissionBatch));
		return _List_fromArray(
			[
				A2($author$project$Components$Dashboard$NeedsIndexingRow$View$viewSelectedRowCheckbox, config, needsIndexingRow),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__small-external-id-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__external_id message--truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(batchExternalId)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('carrier_labels message__carrier-labels')
							]),
						$author$project$Components$Dashboard$DashboardRow$View$viewLabels(emailMessage.labels)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('presence_list')
							]),
						A2($author$project$Presence$viewInLine, carrierExists, presence))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__date-area')
					]),
				A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateArea,
					config.tz,
					$elm$core$Maybe$Just(emailMessage.createdAt))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__date-area')
					]),
				A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateArea,
					config.tz,
					$elm$core$Maybe$Just(emailMessage.updatedAt))),
				A7($author$project$Components$Dashboard$DashboardRow$View$viewMessageActionArea, config.onSkipAsynchronousEmailReview, emailMessage.importState, needsIndexingRow.maybeImportStatus, needsIndexingRow.maybeDocumentBatch, false, emailMessage.id, documentBatchId)
			]);
	});
var $author$project$Components$Dashboard$NeedsIndexingRow$View$onClickHandler = F2(
	function (onRowClick, needsIndexingRow) {
		var emailMessage = needsIndexingRow.emailMessage;
		return $author$project$Domain$EmailMessage$importCompleted(emailMessage.importState) ? $elm$core$Maybe$Just(
			onRowClick(needsIndexingRow.redirectTo)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Dashboard$NeedsIndexingRow$View$toDashboardRow = F3(
	function (accountType, dashboardPresence, needsIndexingRow) {
		var emailMessage = needsIndexingRow.emailMessage;
		return {
			age: $elm$core$Maybe$Nothing,
			carrierExists: A3($author$project$Components$Dashboard$RowHelper$carrierPresentOnFactor, accountType, needsIndexingRow.maybeTmsCarrier, dashboardPresence),
			createdAt: $elm$core$Maybe$Just(emailMessage.createdAt),
			customers: $author$project$Components$Dashboard$DashboardRow$NoCustomers,
			emailImportState: emailMessage.importState,
			ignorable: $elm$core$Maybe$Just(
				$author$project$Components$Dashboard$Pager$Selectable$EmailMessage(emailMessage.id)),
			isCompleted: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(true),
					emailMessage.completedAt)),
			labels: emailMessage.labels,
			lastSentAt: $elm$core$Maybe$Nothing,
			nextReviewOn: $elm$core$Maybe$Nothing,
			note: $elm$core$Maybe$Just(''),
			pages: $author$project$Components$Dashboard$DashboardRow$pagesString(needsIndexingRow.maybeDocumentBatch),
			presence: function () {
				var batchPathData = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A2($elm$core$Maybe$map, $author$project$Components$Dashboard$NeedsIndexingRow$documentBatchToPathData, needsIndexingRow.maybeDocumentBatch)));
				return A3(
					$author$project$DashboardPresence$stateAtPath,
					dashboardPresence,
					$author$project$Path$toString(needsIndexingRow.redirectTo),
					A2(
						$elm$core$List$cons,
						$author$project$DashboardPresence$EmailMessageIdPath(
							$author$project$Domain$EmailMessageId$toInt(emailMessage.id)),
						batchPathData));
			}(),
			redirectTo: needsIndexingRow.redirectTo,
			rowType: $author$project$Components$Dashboard$DashboardRow$Email,
			sender: $elm$core$Maybe$Just(emailMessage.senderAddress),
			subject: emailMessage.subject,
			summary: $author$project$Domain$ExceptionSummary$empty,
			tmsCarrierString: A2(
				$author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName,
				accountType,
				{singleCarrier: emailMessage.singleCarrier, tmsCarrier: needsIndexingRow.maybeTmsCarrier})
		};
	});
var $author$project$Components$Dashboard$NeedsIndexingRow$View$view = F3(
	function (config, index, needsIndexingRowData) {
		var isOddRow = $author$project$Components$Dashboard$DashboardRow$View$isOdd(index);
		var dashboardRowData = A2(
			$author$project$Forward$Remote$map,
			A2($author$project$Components$Dashboard$NeedsIndexingRow$View$toDashboardRow, config.accountType, config.dashboardPresence),
			needsIndexingRowData);
		var additionalClasses = _Utils_eq(
			$elm$core$Maybe$Just($author$project$AuditPb$EmailImportStateImportCompleted),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.emailImportState;
				},
				$author$project$Forward$Remote$toMaybe(dashboardRowData))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('importing');
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.isCompleted;
				},
				$author$project$Forward$Remote$toMaybe(dashboardRowData))) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
			$author$project$Components$Dashboard$DashboardRow$View$customView,
			{
				additionalRowClasses: additionalClasses,
				isOddRow: isOddRow,
				view: function (row) {
					return $author$project$Forward$Remote$Loaded(
						{
							html: A2($author$project$Components$Dashboard$NeedsIndexingRow$View$needsIndexingRowView, config, row),
							onRowClick: A2($author$project$Components$Dashboard$NeedsIndexingRow$View$onClickHandler, config.onRowClick, row)
						});
				}
			},
			needsIndexingRowData);
	});
var $author$project$Components$Dashboard$Pager$View$viewNeedsIndexingPager = F2(
	function (config, needsIndexingRows) {
		var viewNeedsIndexingRow = $author$project$Components$Dashboard$NeedsIndexingRow$View$view(
			{accountSettings: config.accountSettings, accountType: config.accountType, dashboardPresence: config.dashboardPresence, onRowClick: config.onRowClick, onSelectSelectable: config.onSelectSelectable, onSkipAsynchronousEmailReview: config.onSkipAsynchronousEmailReview, selectedSelectables: config.selectedSelectables, tz: config.tz});
		var dashboardPresence = config.dashboardPresence;
		var rows = config.hideIfOthersPresent ? A3(
			$author$project$Components$Dashboard$Pager$View$filteredRows,
			needsIndexingRows,
			dashboardPresence,
			$elm$core$Maybe$map(
				function ($) {
					return $.redirectTo;
				})) : needsIndexingRows;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$indexedMap, viewNeedsIndexingRow, rows));
	});
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$ToggleSelection = function (a) {
	return {$: 'ToggleSelection', a: a};
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPiece = function (piece) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('address_piece')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(piece)
			]));
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPieces = function (address) {
	var whiteSpace = $elm$html$Html$text($author$project$Helpers$String$nbsp);
	var postalCode = A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2($elm$core$Maybe$map, $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPiece, address.postalCode));
	var dontDisplayAmerica = function (countryField) {
		if (countryField.$ === 'Just') {
			var aCountry = countryField.a;
			return ((aCountry === 'US') || (aCountry === 'USA')) ? $elm$core$Maybe$Nothing : countryField;
		} else {
			return countryField;
		}
	};
	var country = A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPiece,
			dontDisplayAmerica(address.country)));
	var cityState = function () {
		var _v0 = _Utils_Tuple2(address.city, address.state);
		if (_v0.a.$ === 'Just') {
			if (_v0.b.$ === 'Just') {
				var city = _v0.a.a;
				var state = _v0.b.a;
				return $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPiece(city + (', ' + state));
			} else {
				var city = _v0.a.a;
				var _v1 = _v0.b;
				return $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPiece(city);
			}
		} else {
			if (_v0.b.$ === 'Just') {
				var _v2 = _v0.a;
				var state = _v0.b.a;
				return $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPiece(state);
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return $elm$html$Html$text('');
			}
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('address__line')
			]),
		_List_fromArray(
			[cityState, whiteSpace, postalCode, whiteSpace, country]));
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$maybeAddressLine = function (maybeLine) {
	if (maybeLine.$ === 'Just') {
		var line = maybeLine.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('address__line')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(line)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$displayAddress = function (address) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('address')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('address__line')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(address.name)
					])),
				$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$maybeAddressLine(address.addressLine1),
				$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$maybeAddressLine(address.addressLine2),
				$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPieces(address)
			]));
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$displayDate = function (maybeDate) {
	return A2(
		$elm$core$Maybe$withDefault,
		'Invalid Date',
		A2($elm$core$Maybe$map, $author$project$Helpers$Date$dateStringFormat2FromDate, maybeDate));
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$noAddressFound = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('address')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('address__line')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No payment address found.')
				]))
		]));
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$payViaTriumphPay = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('address')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('address__line')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Pay via TriumphPay')
				]))
		]));
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$view = F2(
	function (config, row) {
		var rowRedirectTo = $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$redirectTo(row);
		var relativeDeliveredAt = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A3(
					$elm$core$Maybe$map2,
					$author$project$Components$Dashboard$RowHelper$getRelativeDeliveredAt(config.tz),
					config.currentDate,
					row.deliveredAt)));
		var isSelected = A2($author$project$Id$Set$member, row.carrierInvoiceId, config.selectedCarrierInvoiceds);
		return {
			html: A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-approve-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(isSelected),
											A2(
											$elm$html$Html$Events$custom,
											'click',
											$elm$json$Json$Decode$succeed(
												{
													message: config.onBrokerRowMsg(
														$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$ToggleSelection(row.carrierInvoiceId)),
													preventDefault: false,
													stopPropagation: true
												}))
										]),
									_List_Nil)
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-carrier-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__carrier')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Components$Dashboard$RowHelper$tmsCarrierName, $author$project$Domain$Account$BrokerAccount, row.tmsCarrier))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__carrier-labels')
										]),
									A2(
										$elm$core$List$map,
										$author$project$Components$Dashboard$RowHelper$carrierLabelButton,
										$author$project$Helpers$List$removeDuplicates(row.labels)))
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-customer-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__customer-information')
										]),
									_List_fromArray(
										[
											A2($author$project$Components$Dashboard$RowHelper$customerInformationArea, config.accountSettings, row.customers)
										]))
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-load-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Path$toString(rowRedirectTo)),
											A2(
											$elm$html$Html$Events$custom,
											'click',
											$elm$json$Json$Decode$succeed(
												{
													message: config.onViewItem(rowRedirectTo),
													preventDefault: true,
													stopPropagation: true
												}))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(row.loadId)
										]))
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-invoice-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, $author$project$Helpers$String$nbsp, row.invoiceNumber))
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-amount-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'No amount found',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Money$castFromString, $author$project$Money$toString),
											row.amountToPay)))
								]))),
						config.shouldShowDeliveredAt ? $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-date-delivered-area')
								]),
							A2(
								$elm$core$List$append,
								A2($author$project$Components$Dashboard$DashboardRow$View$viewDateArea, config.tz, row.deliveredAt),
								_List_fromArray(
									[
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										relativeDeliveredAt
									])))) : $elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-payment-date-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$displayDate(row.dateToPay))
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-pay-to-area')
								]),
							row.payViaTriumphPay ? _List_fromArray(
								[$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$payViaTriumphPay]) : _List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$noAddressFound,
									A2($elm$core$Maybe$map, $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$displayAddress, row.paymentAddress))
								])))
					])),
			onRowClick: $elm$core$Maybe$Just(
				config.onBrokerRowMsg(
					$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$ToggleSelection(row.carrierInvoiceId)))
		};
	});
var $author$project$Components$Dashboard$Processed$BrokerModel$viewRow = F3(
	function (config, _v0, rowData) {
		var model = _v0.a;
		return A2(
			$author$project$Forward$Remote$map,
			$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$view(
				{accountSettings: config.accountSettings, currentDate: config.currentDate, onBrokerRowMsg: config.onBrokerRowMsg, onViewItem: config.onViewItem, selectedCarrierInvoiceds: model.selected, shouldShowDeliveredAt: config.shouldShowDeliveredAt, tz: config.tz}),
			rowData);
	});
var $author$project$Components$Dashboard$Pager$View$viewProcessedBrokerPager = F7(
	function (msgs, accountSettings, tz, shouldShowDeliveredAt, currentDate, model, data) {
		var additionalRowClasses = shouldShowDeliveredAt ? 'dashboard-processed-broker show-delivery-date' : 'dashboard-processed-broker';
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				function (index) {
					return $author$project$Components$Dashboard$DashboardRow$View$customView(
						{
							additionalRowClasses: $elm$core$Maybe$Just(additionalRowClasses),
							isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
							view: A2(
								$author$project$Components$Dashboard$Processed$BrokerModel$viewRow,
								{accountSettings: accountSettings, currentDate: currentDate, onBrokerRowMsg: msgs.onBrokerRowMsg, onViewItem: msgs.onRowClick, shouldShowDeliveredAt: shouldShowDeliveredAt, tz: tz},
								model)
						});
				},
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeL, $author$project$Forward$Remote$Loaded, $elm$core$Tuple$second),
					$author$project$Pagination$entries(data))));
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toProcessedFactorInvoiceRow = F3(
	function (tmsCarrierData, useFactorInvoiceWorkflowPage, factorInvoiceData) {
		var factorInvoice = factorInvoiceData.factorInvoice;
		return {
			amount: A2($elm$core$Maybe$map, $author$project$Money$castFromString, factorInvoice.amount),
			debtorName: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Helpers$String$nbsp,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.name;
					},
					factorInvoiceData.maybeFactorBroker)),
			id: factorInvoice.id,
			invoiceId: A2($elm$core$Maybe$withDefault, 'Unknown', factorInvoice.invoiceNumber),
			loadId: A2($elm$core$Maybe$withDefault, 'No Load ID', factorInvoice.loadId),
			processedAt: factorInvoice.processedAt,
			receivedDate: factorInvoice.receivedAt,
			redirectTo: A2(
				$author$project$Path$factorInvoice,
				factorInvoice.id,
				{isReadonly: false, useFactorInvoiceWorkflowPage: useFactorInvoiceWorkflowPage}),
			tmsCarrierData: tmsCarrierData
		};
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toFactorRowInvoiceRows = F3(
	function (selectedFactorInvoices, tmsCarrierData, entry) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return _Utils_Tuple2(
					row,
					A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (row_) {
								return A2($author$project$Id$Set$member, row_.id, selectedFactorInvoices);
							},
							$author$project$Forward$Remote$toMaybe(row))));
			},
			A2(
				$elm$core$List$map,
				$author$project$Forward$Remote$map(
					A2($author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toProcessedFactorInvoiceRow, tmsCarrierData, entry.useFactorInvoiceWorkflowPage)),
				entry.factorInvoiceData));
	});
var $author$project$Money$sum2 = F2(
	function (_v0, _v1) {
		var rawCents1 = _v0.a;
		var rawCents2 = _v1.a;
		return $author$project$Money$Money(rawCents1 + rawCents2);
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toProcessedFactorGroupData = F2(
	function (selectedFactorInvoices, factorInvoices) {
		return {
			allSelected: A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Forward$Remote$toMaybe,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function (data) {
								return A2($author$project$Id$Set$member, data.factorInvoice.id, selectedFactorInvoices);
							}),
						$elm$core$Maybe$withDefault(false))),
				factorInvoices),
			anyAreLoading: A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Forward$Remote$toMaybe,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$Basics$always(false)),
						$elm$core$Maybe$withDefault(true))),
				factorInvoices),
			newest: $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$newestProcessedDate(factorInvoices),
			oldest: $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$oldestProcessedDate(factorInvoices),
			total: A2(
				$elm$core$Maybe$withDefault,
				'Loading ...',
				A2(
					$elm$core$Maybe$map,
					$author$project$Money$toString,
					A3(
						$elm$core$List$foldl,
						$elm$core$Maybe$map2($author$project$Money$sum2),
						$elm$core$Maybe$Just($author$project$Money$zero),
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Forward$Remote$toMaybe,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$andThen(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.factorInvoice;
											},
											function ($) {
												return $.amount;
											})),
									$elm$core$Maybe$map($author$project$Money$castFromString))),
							factorInvoices))))
		};
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toTmsCarrierData = function (maybeTmsCarrier) {
	return {
		singleCarrier: $elm$core$Maybe$Just(true),
		tmsCarrier: maybeTmsCarrier
	};
};
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toProcessedRow = F3(
	function (selectedFactorInvoices, expandedTmsCarriers, entry) {
		return A2(
			$author$project$Forward$Remote$map,
			function (maybeTmsCarrier) {
				return {
					data: A2($author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toProcessedFactorGroupData, selectedFactorInvoices, entry.factorInvoiceData),
					expanded: function () {
						if (maybeTmsCarrier.$ === 'Just') {
							var tmsCarrier = maybeTmsCarrier.a;
							return A2($author$project$Id$Set$member, tmsCarrier.id, expandedTmsCarriers);
						} else {
							return false;
						}
					}(),
					invoiceRows: A3(
						$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toFactorRowInvoiceRows,
						selectedFactorInvoices,
						$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toTmsCarrierData(maybeTmsCarrier),
						entry),
					tmsCarrierData: $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toTmsCarrierData(maybeTmsCarrier)
				};
			},
			entry.tmsCarrierData);
	});
var $author$project$Components$Dashboard$Processed$FactorModel$toProcessedRows = F2(
	function (data, model) {
		var m = model.a;
		var sanitizedSelectedFactorInvoiceIds = A2($author$project$Components$Dashboard$Processed$FactorModel$selectedFactorInvoiceIds, data, model);
		return A2(
			$elm$core$List$map,
			A2($author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toProcessedRow, sanitizedSelectedFactorInvoiceIds, m.expandedTmsCarrierIds),
			$author$project$Pagination$entries(data.currentPageData));
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$ToggleSelections = function (a) {
	return {$: 'ToggleSelections', a: a};
};
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$selectedIds = function (invoiceRows) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.id;
		},
		A2(
			$elm$core$List$filterMap,
			$author$project$Forward$Remote$toMaybe,
			A2($elm$core$List$map, $elm$core$Tuple$first, invoiceRows)));
};
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toggleGroupSelection = function (processedFactorGroup) {
	return $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$ToggleSelections(
		$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$selectedIds(processedFactorGroup.invoiceRows));
};
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toggleGroupSelectionIfCollapsed = function (processedFactorGroup) {
	return processedFactorGroup.expanded ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toggleGroupSelection(processedFactorGroup));
};
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$ToggleFactorExpansion = function (a) {
	return {$: 'ToggleFactorExpansion', a: a};
};
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$displayDate = F2(
	function (tz, maybeDate) {
		return A2(
			$elm$core$Maybe$withDefault,
			'Invalid Date',
			A2(
				$elm$core$Maybe$map,
				$author$project$Helpers$Date$toString(tz),
				maybeDate));
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$expandOrContract = F2(
	function (expanded, toggleExpansionMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__group-expanded-contract')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('fi-minus', expanded),
									_Utils_Tuple2('fi-plus', !expanded)
								])),
							A2(
							$elm$html$Html$Events$custom,
							'click',
							$elm$json$Json$Decode$succeed(
								{message: toggleExpansionMsg, preventDefault: true, stopPropagation: true}))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Helpers$String$nbsp)
						]))
				]));
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$expandedProcessedFactorHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('dashboard-menu__row')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__messages-header-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-approve-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Helpers$String$nbsp)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-client-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Client')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-debtor-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Debtor')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-received-date-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Received At')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-load-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Load')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-invoice-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice #')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__processed-amount-area')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Amount')
								]))
						]))
				]))
		]));
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$ToggleFactorInvoiceSelection = function (a) {
	return {$: 'ToggleFactorInvoiceSelection', a: a};
};
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$viewFactorExpansion = F3(
	function (config, selected, processedRow) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-approve-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(selected),
								A2(
								$elm$html$Html$Events$custom,
								'click',
								$elm$json$Json$Decode$succeed(
									{
										message: config.onFactorGroupMsg(
											$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$ToggleFactorInvoiceSelection(processedRow.id)),
										preventDefault: false,
										stopPropagation: true
									}))
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-client-area')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName, $author$project$Domain$Account$FactorAccount, processedRow.tmsCarrierData))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-debtor-area')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(processedRow.debtorName)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-received-date-area')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Helpers$Date$toString, config.timezone, processedRow.receivedDate))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-load-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								$author$project$Path$toString(processedRow.redirectTo)),
								A2(
								$elm$html$Html$Events$custom,
								'click',
								$elm$json$Json$Decode$succeed(
									{
										message: config.onViewItem(processedRow.redirectTo),
										preventDefault: true,
										stopPropagation: true
									}))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(processedRow.loadId)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-invoice-area')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(processedRow.invoiceId)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-amount-area')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Helpers$String$nbsp,
							A2($elm$core$Maybe$map, $author$project$Money$toString, processedRow.amount)))
					]))
			]);
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$viewFactorExpansionOnLoad = F3(
	function (config, index, _v0) {
		var processedRow = _v0.a;
		var selected = _v0.b;
		return A2(
			$author$project$Components$Dashboard$DashboardRow$View$customView,
			{
				additionalRowClasses: $elm$core$Maybe$Nothing,
				isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
				view: function (row) {
					return $author$project$Forward$Remote$Loaded(
						{
							html: A3($author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$viewFactorExpansion, config, selected, row),
							onRowClick: $elm$core$Maybe$Just(
								config.onFactorGroupMsg(
									$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$ToggleFactorInvoiceSelection(row.id)))
						});
				}
			},
			processedRow);
	});
var $author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$view = F2(
	function (config, processedGroup) {
		var _v0 = processedGroup.data;
		var anyAreLoading = _v0.anyAreLoading;
		var allSelected = _v0.allSelected;
		var newest = _v0.newest;
		var oldest = _v0.oldest;
		var total = _v0.total;
		var groupApproveArea = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__group-approve-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(allSelected),
							A2(
							$elm$html$Html$Events$custom,
							'click',
							$elm$json$Json$Decode$succeed(
								{
									message: config.onFactorGroupMsg(
										$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toggleGroupSelection(processedGroup)),
									preventDefault: false,
									stopPropagation: true
								}))
						]),
					_List_Nil),
					function () {
					var _v1 = processedGroup.tmsCarrierData.tmsCarrier;
					if (_v1.$ === 'Just') {
						var tmsCarrier = _v1.a;
						return A2(
							$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$expandOrContract,
							processedGroup.expanded,
							config.onFactorGroupMsg(
								$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$ToggleFactorExpansion(tmsCarrier.id)));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
		var dateMsg = function (date) {
			return anyAreLoading ? $author$project$Helpers$String$nbsp : A2($author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$displayDate, config.timezone, date);
		};
		var groupOrExpansion = processedGroup.expanded ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__group-expanded-area')
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$expandedProcessedFactorHeader,
					A3(
						$elm$core$List$map2,
						$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$viewFactorExpansionOnLoad(config),
						A2(
							$elm$core$List$range,
							0,
							$elm$core$List$length(processedGroup.invoiceRows)),
						processedGroup.invoiceRows)))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__group-carrier-name')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName, $author$project$Domain$Account$FactorAccount, processedGroup.tmsCarrierData))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__group-invoice-count')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$elm$core$List$length(processedGroup.invoiceRows)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__group-invoice-total')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(total)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__group-invoice-oldest')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						dateMsg(oldest))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__group-invoice-newest')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						dateMsg(newest))
					]))
			]);
		return A2($elm$core$List$cons, groupApproveArea, groupOrExpansion);
	});
var $author$project$Components$Dashboard$Pager$View$viewProcessedFactorPager = F4(
	function (tz, msgs, model, data) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				function (index) {
					return $author$project$Components$Dashboard$DashboardRow$View$customView(
						{
							additionalRowClasses: $elm$core$Maybe$Nothing,
							isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
							view: function (processedFactorGroup) {
								return $author$project$Forward$Remote$Loaded(
									{
										html: A2(
											$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$View$view,
											{onFactorGroupMsg: msgs.onFactorGroupMsg, onViewItem: msgs.onRowClick, timezone: tz},
											processedFactorGroup),
										onRowClick: A2(
											$elm$core$Maybe$map,
											msgs.onFactorGroupMsg,
											$author$project$Components$Dashboard$Processed$ProcessedFactorGroup$toggleGroupSelectionIfCollapsed(processedFactorGroup))
									});
							}
						});
				},
				A2($author$project$Components$Dashboard$Processed$FactorModel$toProcessedRows, data, model)));
	});
var $author$project$Components$Dashboard$ReplyRow$documentBatchToPathData = function (batch) {
	return $author$project$DashboardPresence$DocumentBatchId(
		$author$project$Domain$DocumentBatchId$toInt(batch.id));
};
var $author$project$Components$Dashboard$DashboardRow$View$viewMaybeMessageNote = function (maybeMessageNote) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__note')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($elm$core$Maybe$withDefault, $author$project$Helpers$String$nbsp, maybeMessageNote))
			]));
};
var $author$project$Components$Dashboard$ReplyRow$viewNotes = function (exceptionedItems) {
	if (!exceptionedItems.b) {
		return $author$project$Components$Dashboard$DashboardRow$View$viewMaybeMessageNote($elm$core$Maybe$Nothing);
	} else {
		var note = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				function (item) {
					return A2($elm$core$Maybe$withDefault, '', item.note);
				},
				exceptionedItems));
		return $author$project$Components$Dashboard$ExceptionedRowSummary$noteTooltip(
			$elm$core$Maybe$Just(note));
	}
};
var $author$project$Components$Dashboard$ReplyRow$viewSelectedRowCheckbox = F2(
	function (config, emailRow) {
		var _v0 = _Utils_Tuple2(config.onSelectSelectable, config.accountSettings.ignoreMode);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'IgnoreModeBulkIgnore')) {
			var onSelectSelectable = _v0.a.a;
			var _v1 = _v0.b;
			var ignorable = $author$project$Components$Dashboard$Pager$Selectable$EmailMessage(emailRow.emailMessage.id);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__selected-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__selected')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(
										A2($author$project$Components$Dashboard$Pager$Selectable$setMember, ignorable, config.selectedSelectables)),
										$author$project$Components$Dashboard$DashboardRow$View$safeOnCheck(
										onSelectSelectable(ignorable))
									]),
								_List_Nil)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Dashboard$ReplyRow$emailDashboardRowView = F2(
	function (config, emailRow) {
		var emailMessage = emailRow.emailMessage;
		var tmsCarrierString = A2(
			$author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName,
			config.accountType,
			{singleCarrier: emailMessage.singleCarrier, tmsCarrier: emailRow.maybeTmsCarrier});
		var documentBatchId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.id;
			},
			emailRow.maybeDocumentBatch);
		var carrierExists = A3($author$project$Components$Dashboard$RowHelper$carrierPresentOnFactor, config.accountType, emailRow.maybeTmsCarrier, config.dashboardPresence);
		var batchPathData = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2($elm$core$Maybe$map, $author$project$Components$Dashboard$ReplyRow$documentBatchToPathData, emailRow.maybeDocumentBatch)));
		var presence = A3(
			$author$project$DashboardPresence$stateAtPath,
			config.dashboardPresence,
			$author$project$Path$toString(emailRow.redirectTo),
			A2(
				$elm$core$List$cons,
				$author$project$DashboardPresence$EmailMessageIdPath(
					$author$project$Domain$EmailMessageId$toInt(emailMessage.id)),
				batchPathData));
		return _List_fromArray(
			[
				A2($author$project$Components$Dashboard$ReplyRow$viewSelectedRowCheckbox, config, emailRow),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__replies-subject')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__subject message--truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(emailMessage.subject)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__sender message--truncate')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Dashboard$DashboardRow$View$viewSender,
								config.accountSettings,
								$elm$core$Maybe$Just(emailMessage.senderAddress))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('carrier_labels message__carrier-labels')
							]),
						$author$project$Components$Dashboard$DashboardRow$View$viewLabels(emailMessage.labels)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('presence_list')
							]),
						A2($author$project$Presence$viewInLine, carrierExists, presence))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__replies-carrier')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__carrier message--truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(tmsCarrierString)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__replies-customer')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$Dashboard$RowHelper$customerInformationArea, config.accountSettings, emailRow.customers)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__replies-date-received')
					]),
				A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateArea,
					config.tz,
					$elm$core$Maybe$Just(emailMessage.createdAt))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__replies-exceptions')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('')
							]),
						_List_fromArray(
							[
								$author$project$Domain$ExceptionSummary$hasExceptions(emailRow.exceptionSummary) ? A3($author$project$Components$Dashboard$ExceptionedRowSummary$view, emailRow.exceptionSummary, true, config.accountSettings.auditBillingEnabled) : $elm$html$Html$text('None')
							])),
						$author$project$Components$Dashboard$ReplyRow$viewNotes(emailRow.exceptionedItems)
					])),
				A7($author$project$Components$Dashboard$DashboardRow$View$viewMessageActionArea, config.onSkipAsynchronousEmailReview, emailMessage.importState, $elm$core$Maybe$Nothing, emailRow.maybeDocumentBatch, false, emailMessage.id, documentBatchId)
			]);
	});
var $author$project$Components$Dashboard$ReplyRow$onClickHandler = F2(
	function (onRowClick, emailRow) {
		var emailMessage = emailRow.emailMessage;
		return $author$project$Domain$EmailMessage$importCompleted(emailMessage.importState) ? $elm$core$Maybe$Just(
			onRowClick(emailRow.redirectTo)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$Dashboard$ReplyRow$view = F3(
	function (config, index, emailRowData) {
		var isOddRow = $author$project$Components$Dashboard$DashboardRow$View$isOdd(index);
		var completedAtData = A2(
			$author$project$Forward$Remote$map,
			function (emailRow) {
				return emailRow.emailMessage.completedAt;
			},
			emailRowData);
		var maybeCompletedAt = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			$author$project$Forward$Remote$toMaybe(completedAtData));
		var isCompleted = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(true),
				maybeCompletedAt));
		return isCompleted ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
			$author$project$Components$Dashboard$DashboardRow$View$customView,
			{
				additionalRowClasses: $elm$core$Maybe$Nothing,
				isOddRow: isOddRow,
				view: function (row) {
					return $author$project$Forward$Remote$Loaded(
						{
							html: A2($author$project$Components$Dashboard$ReplyRow$emailDashboardRowView, config, row),
							onRowClick: A2($author$project$Components$Dashboard$ReplyRow$onClickHandler, config.onRowClick, row)
						});
				}
			},
			emailRowData);
	});
var $author$project$Components$Dashboard$Pager$View$viewReplyPager = F2(
	function (pagerContext, emailRows) {
		var viewReplyRow = $author$project$Components$Dashboard$ReplyRow$view(
			{accountSettings: pagerContext.accountSettings, accountType: pagerContext.accountType, dashboardPresence: pagerContext.dashboardPresence, onRowClick: pagerContext.onRowClick, onSelectSelectable: pagerContext.onSelectSelectable, onSkipAsynchronousEmailReview: pagerContext.onSkipAsynchronousEmailReview, selectedSelectables: pagerContext.selectedSelectables, tz: pagerContext.tz});
		var rows = pagerContext.hideIfOthersPresent ? A3(
			$author$project$Components$Dashboard$Pager$View$filteredRows,
			emailRows,
			pagerContext.dashboardPresence,
			$elm$core$Maybe$map(
				function ($) {
					return $.redirectTo;
				})) : emailRows;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$indexedMap, viewReplyRow, rows));
	});
var $author$project$Components$Dashboard$Review$Model$ToggleExpansion = function (a) {
	return {$: 'ToggleExpansion', a: a};
};
var $author$project$Components$Dashboard$ReviewRow$toggleExpansionWithCarrier = function (row) {
	return $elm$core$Maybe$Just(
		$author$project$Components$Dashboard$Review$Model$ToggleExpansion(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.id;
				},
				row.tmsCarrier)));
};
var $author$project$Components$Dashboard$ReviewRow$clientGroupVerifications = function (clientGroup) {
	var _v0 = clientGroup;
	var replyInvoices = _v0.replyInvoices;
	var waitingExceptionedInvoices = _v0.waitingExceptionedInvoices;
	var unsentExceptionedInvoices = _v0.unsentExceptionedInvoices;
	var verifyingInvoices = _v0.verifyingInvoices;
	var draftInvoices = _v0.draftInvoices;
	var approvableInvoices = _v0.approvableInvoices;
	var allInvoices = _Utils_ap(
		approvableInvoices,
		_Utils_ap(
			draftInvoices,
			_Utils_ap(
				verifyingInvoices,
				_Utils_ap(
					A2($elm$core$Maybe$withDefault, _List_Nil, unsentExceptionedInvoices),
					_Utils_ap(
						A2($elm$core$Maybe$withDefault, _List_Nil, waitingExceptionedInvoices),
						replyInvoices)))));
	return A2(
		$elm$core$List$map,
		function (invoiceInfo) {
			return A2($elm$core$Maybe$andThen, $author$project$Forward$Remote$toMaybe, invoiceInfo.expandedData);
		},
		allInvoices);
};
var $author$project$Components$Dashboard$ReviewRow$safeOnClick = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: true, stopPropagation: true}));
};
var $author$project$Components$Dashboard$ReviewRow$expandOrContract = F2(
	function (expanded, toggleExpansionMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__group-expanded-contract')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('fi-minus', expanded),
									_Utils_Tuple2('fi-plus', !expanded)
								])),
							$author$project$Components$Dashboard$ReviewRow$safeOnClick(toggleExpansionMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Helpers$String$nbsp)
						]))
				]));
	});
var $author$project$Components$Dashboard$Review$Model$compareDates = F4(
	function (dateComparison, exceptionInvoiceDates, emailMessages, factorInvoices) {
		var toDates = $elm$core$List$filterMap(
			A2(
				$elm$core$Basics$composeR,
				$author$project$Forward$Remote$toMaybe,
				$elm$core$Maybe$map(
					function ($) {
						return $.createdAt;
					})));
		return A2(
			$author$project$Helpers$List$foldl1,
			dateComparison,
			_Utils_ap(
				exceptionInvoiceDates,
				_Utils_ap(
					toDates(factorInvoices),
					toDates(emailMessages))));
	});
var $author$project$Components$Dashboard$Review$Model$newestCreatedDate = $author$project$Components$Dashboard$Review$Model$compareDates($author$project$Helpers$Date$max);
var $author$project$Components$Dashboard$Review$Model$oldestCreatedDate = $author$project$Components$Dashboard$Review$Model$compareDates($author$project$Helpers$Date$min);
var $author$project$Money$sum = function (moneys) {
	return A3($elm$core$List$foldl, $author$project$Money$sum2, $author$project$Money$zero, moneys);
};
var $author$project$Components$Dashboard$Review$Model$getGroupData = F2(
	function (model, clientGroup) {
		var anyAreLoading = function (list) {
			return !_Utils_eq(
				$elm$core$List$length(
					A2($elm$core$List$filterMap, $author$project$Components$Dashboard$Review$Model$getMaybeLoadedInvoices, list)),
				$elm$core$List$length(list));
		};
		var _v0 = clientGroup;
		var exceptionedCount = _v0.exceptionedCount;
		var exceptionInvoicesCreatedAt = _v0.exceptionInvoicesCreatedAt;
		var replyEmailMessages = _v0.replyEmailMessages;
		var newEmailMessages = _v0.newEmailMessages;
		var replyInvoices = _v0.replyInvoices;
		var verifyingInvoices = _v0.verifyingInvoices;
		var draftInvoices = _v0.draftInvoices;
		var approvableInvoices = _v0.approvableInvoices;
		var total = $author$project$Money$sum(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.amount;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Money$castFromString),
						$elm$core$Maybe$withDefault($author$project$Money$zero))),
				A2($elm$core$List$filterMap, $author$project$Components$Dashboard$Review$Model$getMaybeLoadedInvoices, approvableInvoices)));
		var emails = _Utils_ap(newEmailMessages, replyEmailMessages);
		var inProgress = _Utils_ap(
			draftInvoices,
			_Utils_ap(verifyingInvoices, replyInvoices));
		var invoices = _Utils_ap(approvableInvoices, inProgress);
		var count = $elm$core$List$length(invoices);
		var rowCount = (count + $elm$core$List$length(emails)) + exceptionedCount;
		var factorInvoices = A2(
			$elm$core$List$map,
			function ($) {
				return $.factorInvoice;
			},
			invoices);
		var totalString = anyAreLoading(invoices) ? 'Loading...' : ($elm$core$List$isEmpty(approvableInvoices) ? $author$project$Helpers$String$nbsp : $author$project$Money$toString(total));
		var selectableInvoices = function () {
			var _v1 = model.verifyMode;
			if (_v1.$ === 'Verify') {
				return verifyingInvoices;
			} else {
				return approvableInvoices;
			}
		}();
		var allSelected = A2(
			$author$project$Components$Dashboard$Review$Model$allAreSelected_,
			model,
			_List_fromArray(
				[clientGroup])).a && (!anyAreLoading(selectableInvoices));
		return {
			allSelected: allSelected,
			anyAreLoading: anyAreLoading(invoices),
			newest: A3($author$project$Components$Dashboard$Review$Model$newestCreatedDate, exceptionInvoicesCreatedAt, emails, factorInvoices),
			oldest: A3($author$project$Components$Dashboard$Review$Model$oldestCreatedDate, exceptionInvoicesCreatedAt, emails, factorInvoices),
			rowCount: rowCount,
			selectableInvoiceIds: $author$project$Id$Set$fromList(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.id;
					},
					A2($elm$core$List$filterMap, $author$project$Components$Dashboard$Review$Model$getMaybeLoadedInvoices, selectableInvoices))),
			total: totalString
		};
	});
var $author$project$Components$Dashboard$ReviewRow$safeOnCheck = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: false, stopPropagation: true}));
};
var $author$project$Components$Dashboard$ReviewRow$toRedDotData = function (maybeExpanded) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$map,
			function (exp) {
				return $elm$core$Maybe$Just(
					{autoVerification: exp.autoVerification, verificationsDebtorBatchItem: exp.verificationsDebtorBatchItem});
			},
			maybeExpanded));
};
var $author$project$Components$RedDot$viewDetailMessage = function (failure) {
	var _v0 = _Utils_Tuple2(failure.message, failure.brokerAmount);
	switch (_v0.a.$) {
		case 'VerificationFailureMessageLoadNotFoundFailure':
			var _v1 = _v0.a;
			return 'Load not found';
		case 'VerificationFailureMessageUndeliveredFailure':
			var _v2 = _v0.a;
			return 'Not delivered';
		case 'VerificationFailureMessageCarrierMismatchFailure':
			var _v3 = _v0.a;
			return 'Carrier does not match';
		case 'VerificationFailureMessageLoadIssueFailure':
			var _v4 = _v0.a;
			return 'There is an issue with the load';
		case 'VerificationFailureMessagePossibleFeesFailure':
			var _v5 = _v0.a;
			return 'There may be fees associated with this load';
		case 'VerificationFailureMessageRemitToFailure':
			var _v6 = _v0.a;
			return 'Remit-To address does not match';
		default:
			if (_v0.b.$ === 'Nothing') {
				var _v7 = _v0.a;
				var _v8 = _v0.b;
				return 'Amount Mismatch';
			} else {
				var _v9 = _v0.a;
				var brokerAmount_ = _v0.b.a;
				return 'Broker Amount: ' + $author$project$Money$toString(
					$author$project$Money$castFromString(brokerAmount_));
			}
	}
};
var $author$project$Components$RedDot$failureDetailStringsFromAutoVerifications = function (autoVerifications) {
	var singleAutoVerificationFailures = function (av) {
		var _v0 = av.state;
		if (_v0.$ === 'Verification_State_Fail') {
			var failures = _v0.a.failures;
			return A2($elm$core$List$map, $author$project$Components$RedDot$viewDetailMessage, failures);
		} else {
			return _List_Nil;
		}
	};
	return $elm_community$list_extra$List$Extra$unique(
		A2($elm$core$List$concatMap, singleAutoVerificationFailures, autoVerifications));
};
var $author$project$Domain$VerificationsDebtorBatchItem$levelToClass = function (verifyLevel) {
	switch (verifyLevel.$) {
		case 'VerifyLevelMedium':
			return 'medium';
		case 'VerifyLevelHigh':
			return 'high';
		default:
			return '';
	}
};
var $author$project$Components$RedDot$loading = function () {
	var tooltipAttrs = function (message) {
		return _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'true'),
				$elm$html$Html$Attributes$title(message),
				A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
			]);
	};
	return A2(
		$elm$html$Html$span,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('load-detail__verify-level loading'),
			tooltipAttrs('Loading...')),
		_List_fromArray(
			[
				$elm$html$Html$text($author$project$Helpers$String$nbsp)
			]));
}();
var $author$project$Domain$VerificationsDebtorBatchItem$verifyLevelToInt = function (verifyLevel) {
	switch (verifyLevel.$) {
		case 'VerifyLevelLow':
			return 1000;
		case 'VerifyLevelMedium':
			return 5000;
		case 'VerifyLevelHigh':
			return 10000;
		default:
			return 0;
	}
};
var $author$project$Components$RedDot$view = function (maybeRedDotDataList) {
	var redDotDataList = $elm_community$maybe_extra$Maybe$Extra$values(maybeRedDotDataList);
	if (_Utils_eq(
		$elm$core$List$length(redDotDataList),
		$elm$core$List$length(maybeRedDotDataList))) {
		var verifyLevelClass = $author$project$Domain$VerificationsDebtorBatchItem$levelToClass(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$AuditPb$VerifyLevelLow,
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							function (a) {
								return $author$project$Domain$VerificationsDebtorBatchItem$verifyLevelToInt(a);
							},
							A2(
								$elm$core$List$map,
								function ($) {
									return $.verifyLevel;
								},
								$elm_community$maybe_extra$Maybe$Extra$values(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.verificationsDebtorBatchItem;
										},
										redDotDataList))))))));
		var tooltipAttrs = function (message) {
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'true'),
					$elm$html$Html$Attributes$title(message),
					A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
				]);
		};
		var splitStringsOnSemiColon = function (warningStrings) {
			return A2(
				$elm$core$List$concatMap,
				$elm$core$String$split(';'),
				warningStrings);
		};
		var failedVerifyRulesWarning = A2(
			$elm$core$List$map,
			function ($) {
				return $.message;
			},
			A2(
				$elm$core$List$filter,
				function (a) {
					return _Utils_eq(a.level, $author$project$AuditPb$VerifyLevelHigh) || _Utils_eq(a.level, $author$project$AuditPb$VerifyLevelMedium);
				},
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.failedVerifyRules;
					},
					$elm_community$maybe_extra$Maybe$Extra$values(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.verificationsDebtorBatchItem;
							},
							redDotDataList)))));
		var checkAutoVerification = function (redDotData) {
			return $elm$core$List$isEmpty(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.failedVerifyRules;
						},
						redDotData.verificationsDebtorBatchItem)));
		};
		var verificationWarnings = $author$project$Components$RedDot$failureDetailStringsFromAutoVerifications(
			$elm_community$list_extra$List$Extra$unique(
				$elm_community$maybe_extra$Maybe$Extra$values(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.autoVerification;
						},
						A2($elm$core$List$filter, checkAutoVerification, redDotDataList)))));
		var allWarnings = _Utils_ap(failedVerifyRulesWarning, verificationWarnings);
		var failureSentence = 'Verification ' + ((($elm$core$List$length(allWarnings) > 1) ? 'warnings: \u000A' : 'warning: \u000A') + A2(
			$elm$core$String$join,
			'\u000A',
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$map,
					$elm$core$String$trim,
					splitStringsOnSemiColon(allWarnings)))));
		return $elm$core$List$isEmpty(allWarnings) ? $elm$html$Html$text($author$project$Helpers$String$nbsp) : A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('load-detail__verify-level ' + verifyLevelClass),
				tooltipAttrs(failureSentence)),
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$Helpers$String$nbsp)
				]));
	} else {
		return $author$project$Components$RedDot$loading;
	}
};
var $author$project$Components$Dashboard$ReviewRow$expansionMarkup = function (_v0) {
	var labels = _v0.labels;
	var verificationStatus = _v0.verificationStatus;
	var status = _v0.status;
	var amount = _v0.amount;
	var invoiceNum = _v0.invoiceNum;
	var load = _v0.load;
	var receivedAt = _v0.receivedAt;
	var verificationWarning = _v0.verificationWarning;
	var debtor = _v0.debtor;
	var approve = _v0.approve;
	var applyLabels = function (row) {
		return $elm$core$List$isEmpty(labels) ? row : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				row),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row message__review-funding-area')
					]),
				labels)
			]);
	};
	return applyLabels(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__review-approve-area')
					]),
				approve),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__review-debtor-area')
					]),
				debtor),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__review-verification-warning-area')
					]),
				verificationWarning),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__review-received-date-area')
					]),
				receivedAt),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-load-area')
					]),
				load),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-invoice-area')
					]),
				invoiceNum),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-amount-area')
					]),
				amount),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__review-status-area')
					]),
				status),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__review-verification-status-area')
					]),
				verificationStatus)
			]));
};
var $author$project$Components$Dashboard$ReviewRow$expandedReviewFactorHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('dashboard-menu__row')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__messages-header-row')
						]),
					$author$project$Components$Dashboard$ReviewRow$expansionMarkup(
						{
							amount: _List_fromArray(
								[
									$elm$html$Html$text('Amount')
								]),
							approve: _List_fromArray(
								[
									$elm$html$Html$text($author$project$Helpers$String$nbsp)
								]),
							debtor: _List_fromArray(
								[
									$elm$html$Html$text('Debtor')
								]),
							invoiceNum: _List_fromArray(
								[
									$elm$html$Html$text('Invoice #')
								]),
							labels: _List_Nil,
							load: _List_fromArray(
								[
									$elm$html$Html$text('Load')
								]),
							receivedAt: _List_fromArray(
								[
									$elm$html$Html$text('Received At')
								]),
							status: _List_fromArray(
								[
									$elm$html$Html$text('Status')
								]),
							verificationStatus: _List_fromArray(
								[
									$elm$html$Html$text('Verification Status')
								]),
							verificationWarning: _List_fromArray(
								[
									$elm$html$Html$text($author$project$Helpers$String$nbsp)
								])
						}))
				]))
		]));
var $author$project$Components$Dashboard$Review$Model$NoOp = {$: 'NoOp'};
var $author$project$Components$Dashboard$Review$Model$ToggleRejectionExpansion = function (a) {
	return {$: 'ToggleRejectionExpansion', a: a};
};
var $author$project$Components$Dashboard$ReviewRow$expandRejectedMarkup = F3(
	function (carrierId, exceptionsExpanded, clientGroup) {
		var action = exceptionsExpanded ? 'Hide ' : 'View ';
		var message = _Utils_ap(
			action,
			A2(
				$author$project$Helpers$String$pluralize,
				{many: 'Incomplete / Waiting Invoices', one: 'Incomplete / Waiting Invoice'},
				clientGroup.exceptionedCount));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__processed-approve-area')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Helpers$String$nbsp)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__review-rejected-expand-area')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Components$Dashboard$ReviewRow$safeOnClick(
								$author$project$Components$Dashboard$Review$Model$ToggleRejectionExpansion(carrierId))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]))
					]))
			]);
	});
var $author$project$Components$Dashboard$ReviewRow$expandOrCollapseRejection = F4(
	function (index, carrierId, exceptionsExpanded, clientGroup) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$Dashboard$DashboardRow$View$customView,
				{
					additionalRowClasses: $elm$core$Maybe$Just('review-expansion-row'),
					isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
					view: function (row) {
						return $author$project$Forward$Remote$Loaded(
							{
								html: A3($author$project$Components$Dashboard$ReviewRow$expandRejectedMarkup, carrierId, exceptionsExpanded, row),
								onRowClick: $elm$core$Maybe$Just($author$project$Components$Dashboard$Review$Model$NoOp)
							});
					}
				},
				$author$project$Forward$Remote$Loaded(clientGroup))
			]);
	});
var $author$project$Domain$FactorInvoice$isAtLeastProcessed = function (invoiceState) {
	switch (invoiceState.$) {
		case 'Draft':
			return false;
		case 'Exception':
			return false;
		case 'Abandoned':
			return false;
		case 'Verifying':
			return false;
		case 'Processed':
			return true;
		case 'VerifyCompleted':
			return true;
		case 'Approved':
			return true;
		case 'Verified':
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Dashboard$ReviewRow$toggleInvoiceSelectionIfApprovable = F3(
	function (isSelected, readOnlyFactorUser, factorInvoice) {
		return readOnlyFactorUser ? $author$project$Components$Dashboard$Review$Model$NoOp : ($author$project$Domain$FactorInvoice$isAtLeastProcessed(factorInvoice.state) ? A2(
			$author$project$Components$Dashboard$Review$Model$ToggleInvoiceSelection,
			$author$project$Id$Set$singleton(factorInvoice.id),
			!isSelected) : $author$project$Components$Dashboard$Review$Model$NoOp);
	});
var $author$project$Components$Dashboard$Review$Model$ViewItem = function (a) {
	return {$: 'ViewItem', a: a};
};
var $author$project$Domain$FactorInvoice$amountInMoney = function (invoice) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Money$fromCents,
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$String$toInt,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$String$replace, '.', ''),
				invoice.formattedAmount)));
};
var $author$project$Components$Dashboard$Review$Model$getInvoicePath = F3(
	function (factorInvoice, _v0, pathContext) {
		var activeBatchId = _v0.activeBatchId;
		var clientSubmissionReviewData = _v0.clientSubmissionReviewData;
		var _v1 = _Utils_Tuple2(factorInvoice.state, clientSubmissionReviewData);
		_v1$0:
		while (true) {
			if (_v1.b.$ === 'Nothing') {
				if (_v1.a.$ === 'Verifying') {
					break _v1$0;
				} else {
					var _v3 = _v1.b;
					return $elm$core$Maybe$Just(
						A2($author$project$Path$factorInvoice, factorInvoice.id, pathContext));
				}
			} else {
				if (_v1.a.$ === 'Verifying') {
					break _v1$0;
				} else {
					var batchEmailId = _v1.b.a.batchEmailId;
					return $elm$core$Maybe$Just(
						A2($author$project$Path$submissionInvoice, batchEmailId, factorInvoice.id));
				}
			}
		}
		var _v2 = _v1.a;
		return A2($elm$core$Maybe$map, $author$project$Path$verificationBatch, activeBatchId);
	});
var $author$project$Components$Dashboard$ReviewRow$maybeView = function (maybeString) {
	return $elm$html$Html$text(
		A2($elm$core$Maybe$withDefault, $author$project$Helpers$String$nbsp, maybeString));
};
var $author$project$Components$Dashboard$ReviewRow$verificationPercentageView = F2(
	function (verificationPercentage, carrierRatio) {
		if (verificationPercentage.$ === 'Just') {
			var percentage = verificationPercentage.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(percentage + ('%' + (' / ' + (carrierRatio + '%'))))
					]));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Components$Dashboard$ReviewRow$verificationStatusFromAutoVerification = function (autoVerification) {
	var _v0 = autoVerification.state;
	switch (_v0.$) {
		case 'Verification_State_Success':
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Auto-Verified')
						]))
				]);
		case 'Verification_State_UnconfirmedDelivery':
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Load Auto-Verified')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Delivery Unconfirmed')
						]))
				]);
		case 'Verification_State_Fail':
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Auto-Verification Failed')
						]))
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$text($author$project$Helpers$String$nbsp)
				]);
	}
};
var $author$project$Components$Dashboard$ReviewRow$viewVerificationStatus = function (maybeTuple) {
	if (maybeTuple.b.$ === 'Just') {
		var batchItem = maybeTuple.b.a;
		return $elm$core$List$singleton(
			$elm$html$Html$text(batchItem.effectiveCustomState.name));
	} else {
		if (maybeTuple.a.$ === 'Just') {
			var autoVerification = maybeTuple.a.a;
			var _v1 = maybeTuple.b;
			return $author$project$Components$Dashboard$ReviewRow$verificationStatusFromAutoVerification(autoVerification);
		} else {
			var _v2 = maybeTuple.a;
			var _v3 = maybeTuple.b;
			return _List_fromArray(
				[
					$elm$html$Html$text($author$project$Helpers$String$nbsp)
				]);
		}
	}
};
var $author$project$Components$Dashboard$ReviewRow$viewExpansionInvoice = function (tz) {
	return function (_v0) {
		return function (isSelected) {
			return function (status) {
				return function (showCheckbox) {
					return function (carrier) {
						return function (expandedData) {
							return function (dashboardPresence) {
								return function (pathContext) {
									return function (factorInvoice) {
										var showClientBatchRatios = _v0.showClientBatchRatios;
										var maybeExpandedData = A2($elm$core$Maybe$andThen, $author$project$Forward$Remote$toMaybe, expandedData);
										var redirectTo = A2(
											$elm$core$Maybe$andThen,
											function (data) {
												return A3($author$project$Components$Dashboard$Review$Model$getInvoicePath, factorInvoice, data, pathContext);
											},
											maybeExpandedData);
										var presencePill = function () {
											if (redirectTo.$ === 'Just') {
												var path = redirectTo.a;
												return A2(
													$author$project$Presence$viewInLine,
													false,
													A3(
														$author$project$DashboardPresence$stateAtPath,
														dashboardPresence,
														$author$project$Path$toString(path),
														_List_Nil));
											} else {
												return _List_Nil;
											}
										}();
										var verificationPercentageHtml = showClientBatchRatios ? A2(
											$author$project$Components$Dashboard$ReviewRow$verificationPercentageView,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.verificationPercentage;
												},
												maybeExpandedData),
											$elm$core$String$fromFloat(
												A2(
													$elm$core$Maybe$withDefault,
													$author$project$Domain$TmsCarrier$unknownCarrier.verificationPercentage,
													A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.verificationPercentage;
														},
														carrier)))) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
										var loadLinkComposer = function () {
											if (redirectTo.$ === 'Just') {
												var path = redirectTo.a;
												return A2(
													$elm$core$Basics$composeL,
													$elm$html$Html$a(
														_List_fromArray(
															[
																$elm$html$Html$Attributes$href(
																$author$project$Path$toString(path)),
																$author$project$Components$Dashboard$ReviewRow$safeOnClick(
																$author$project$Components$Dashboard$Review$Model$ViewItem(path))
															])),
													$elm$core$List$singleton);
											} else {
												return $elm$core$Basics$identity;
											}
										}();
										var loadLink = loadLinkComposer(
											$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, 'Unassigned Load', factorInvoice.loadId)));
										var debtorText = function () {
											if (expandedData.$ === 'Nothing') {
												return $elm$html$Html$text('Loading....');
											} else {
												switch (expandedData.a.$) {
													case 'Loading':
														var _v2 = expandedData.a;
														return $elm$html$Html$text('Loading....');
													case 'Loaded':
														var factorBroker = expandedData.a.a.factorBroker;
														return $elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'Unknown Debtor',
																A2(
																	$elm$core$Maybe$map,
																	function ($) {
																		return $.name;
																	},
																	factorBroker)));
													default:
														var error = expandedData.a.a;
														return $author$project$Forward$LoadingView$defaultErrorView(error);
												}
											}
										}();
										var checkBox = (showCheckbox && (!pathContext.isReadonly)) ? A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('checkbox'),
													$elm$html$Html$Attributes$checked(isSelected),
													$author$project$Components$Dashboard$ReviewRow$safeOnCheck(
													A2(
														$author$project$Components$Dashboard$Review$Model$ToggleInvoiceSelection,
														$author$project$Id$Set$singleton(factorInvoice.id),
														!isSelected))
												]),
											_List_Nil) : $elm$html$Html$text($author$project$Helpers$String$nbsp);
										var amount = A2(
											$elm$core$Maybe$map,
											$author$project$Money$toString,
											$author$project$Domain$FactorInvoice$amountInMoney(factorInvoice));
										return $author$project$Components$Dashboard$ReviewRow$expansionMarkup(
											{
												amount: _List_fromArray(
													[
														$author$project$Components$Dashboard$ReviewRow$maybeView(amount)
													]),
												approve: _List_fromArray(
													[checkBox]),
												debtor: _Utils_ap(
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_Nil,
															_List_fromArray(
																[debtorText])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('presence_list')
																]),
															presencePill)
														]),
													function () {
														var allLabels = _Utils_ap(
															A2(
																$elm$core$List$map,
																A2(
																	$elm$core$Basics$composeR,
																	$elm$html$Html$text,
																	A2(
																		$elm$core$Basics$composeR,
																		$elm$core$List$singleton,
																		$elm$html$Html$div(
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('message__review-funding-method-label')
																				])))),
																A2(
																	$elm$core$Maybe$withDefault,
																	_List_Nil,
																	A2(
																		$elm$core$Maybe$map,
																		function ($) {
																			return $.fundingMethods;
																		},
																		A2(
																			$elm$core$Maybe$andThen,
																			function ($) {
																				return $.clientSubmissionReviewData;
																			},
																			maybeExpandedData)))),
															A2(
																$elm$core$List$map,
																$author$project$Components$Dashboard$RowHelper$carrierLabelButton,
																$elm$core$List$sort(
																	$author$project$Helpers$List$removeDuplicates(factorInvoice.labels))));
														return $elm$core$List$isEmpty(allLabels) ? _List_Nil : _List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('message__review-group-labels')
																	]),
																allLabels)
															]);
													}()),
												invoiceNum: _List_fromArray(
													[
														$author$project$Components$Dashboard$ReviewRow$maybeView(factorInvoice.invoiceNumber)
													]),
												labels: _List_Nil,
												load: _List_fromArray(
													[loadLink]),
												receivedAt: A2(
													$author$project$Components$Dashboard$DashboardRow$View$viewDateArea,
													tz,
													$elm$core$Maybe$Just(factorInvoice.receivedAt)),
												status: _List_fromArray(
													[
														$elm$html$Html$text(status)
													]),
												verificationStatus: _List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														$author$project$Components$Dashboard$ReviewRow$viewVerificationStatus(
															A2(
																$elm$core$Maybe$withDefault,
																_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
																A2(
																	$elm$core$Maybe$map,
																	function (a) {
																		return _Utils_Tuple2(a.autoVerification, a.verificationsDebtorBatchItem);
																	},
																	maybeExpandedData)))),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[verificationPercentageHtml]))
													]),
												verificationWarning: $elm$core$List$singleton(
													$author$project$Components$RedDot$view(
														$elm$core$List$singleton(
															$author$project$Components$Dashboard$ReviewRow$toRedDotData(maybeExpandedData))))
											});
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Dashboard$ReviewRow$viewExpansionInvoiceOnLoad = function (tz) {
	return function (bools) {
		return function (selectedInvoiceIds) {
			return function (status) {
				return function (showCheckbox) {
					return function (carrier) {
						return function (dashboardPresence) {
							return function (pathContext) {
								return function (index) {
									return function (_v0) {
										var expandedData = _v0.expandedData;
										var factorInvoice = _v0.factorInvoice;
										var isSelected = function () {
											var _v1 = $author$project$Forward$Remote$toMaybe(factorInvoice);
											if (_v1.$ === 'Nothing') {
												return false;
											} else {
												var factorInvoice_ = _v1.a;
												return A2(
													$author$project$Sanitized$sanitize,
													$author$project$Id$Set$member(factorInvoice_.id),
													selectedInvoiceIds);
											}
										}();
										return A2(
											$author$project$Components$Dashboard$DashboardRow$View$customView,
											{
												additionalRowClasses: $elm$core$Maybe$Just('review-expansion-row'),
												isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
												view: function (row) {
													return $author$project$Forward$Remote$Loaded(
														{
															html: $author$project$Components$Dashboard$ReviewRow$viewExpansionInvoice(tz)(bools)(isSelected)(status)(showCheckbox)(carrier)(expandedData)(dashboardPresence)(pathContext)(row),
															onRowClick: $elm$core$Maybe$Just(
																A3($author$project$Components$Dashboard$ReviewRow$toggleInvoiceSelectionIfApprovable, isSelected, pathContext.isReadonly, row))
														});
												}
											},
											factorInvoice);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Dashboard$ReviewRow$maybeViewRejectedRows = F9(
	function (tz, bools, startingIndex, selectedFactorInvoiceIds, carrier, dashboardPresence, exceptionsExpanded, pathContext, clientGroup) {
		var viewRows = F4(
			function (start, end, status, exceptionedList) {
				return A3(
					$elm$core$List$map2,
					A8($author$project$Components$Dashboard$ReviewRow$viewExpansionInvoiceOnLoad, tz, bools, selectedFactorInvoiceIds, status, false, carrier, dashboardPresence, pathContext),
					A2($elm$core$List$range, start, end),
					exceptionedList);
			});
		var totalRows = startingIndex + clientGroup.exceptionedCount;
		var expansionRow = function (index) {
			return A4(
				$author$project$Components$Dashboard$ReviewRow$expandOrCollapseRejection,
				index,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.id;
					},
					carrier),
				exceptionsExpanded,
				clientGroup);
		};
		var countWithUnsent = startingIndex + $elm$core$List$length(
			A2($elm$core$Maybe$withDefault, _List_Nil, clientGroup.unsentExceptionedInvoices));
		var _v0 = _Utils_Tuple2(clientGroup.exceptionedCount > 0, exceptionsExpanded);
		if (!_v0.a) {
			return _List_Nil;
		} else {
			if (_v0.b) {
				return A2(
					$author$project$Helpers$List$appendToEnd,
					expansionRow(totalRows),
					A2(
						$author$project$Helpers$List$appendToEnd,
						A4(
							viewRows,
							countWithUnsent,
							totalRows,
							'Waiting',
							A2($elm$core$Maybe$withDefault, _List_Nil, clientGroup.waitingExceptionedInvoices)),
						A4(
							viewRows,
							startingIndex,
							countWithUnsent,
							'Incomplete',
							A2($elm$core$Maybe$withDefault, _List_Nil, clientGroup.unsentExceptionedInvoices))));
			} else {
				return expansionRow(startingIndex);
			}
		}
	});
var $author$project$Components$Dashboard$Review$Model$showInvoiceCheckbox = F2(
	function (verifyMode, state) {
		var _v0 = _Utils_Tuple2(verifyMode, state);
		_v0$3:
		while (true) {
			if (_v0.a.$ === 'Verify') {
				if (_v0.b.$ === 'Verifying') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return true;
				} else {
					break _v0$3;
				}
			} else {
				switch (_v0.b.$) {
					case 'Processed':
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return true;
					case 'VerifyCompleted':
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return true;
					default:
						break _v0$3;
				}
			}
		}
		return false;
	});
var $author$project$Components$Dashboard$ReviewRow$viewExpansionEmail = F4(
	function (tz, status, emailMessage, pathContext) {
		var redirectTo = A2($author$project$Path$emailMessage, emailMessage.id, pathContext.isReadonly);
		var loadLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					$author$project$Path$toString(redirectTo)),
					$author$project$Components$Dashboard$ReviewRow$safeOnClick(
					$author$project$Components$Dashboard$Review$Model$ViewItem(redirectTo))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unassigned Load(s)')
				]));
		var blank = _List_fromArray(
			[
				$elm$html$Html$text($author$project$Helpers$String$nbsp)
			]);
		return $author$project$Components$Dashboard$ReviewRow$expansionMarkup(
			{
				amount: blank,
				approve: blank,
				debtor: _List_fromArray(
					[
						$elm$html$Html$text('Unknown Debtor(s)')
					]),
				invoiceNum: blank,
				labels: _List_Nil,
				load: _List_fromArray(
					[loadLink]),
				receivedAt: A2(
					$author$project$Components$Dashboard$DashboardRow$View$viewDateArea,
					tz,
					$elm$core$Maybe$Just(emailMessage.createdAt)),
				status: _List_fromArray(
					[
						$elm$html$Html$text(status)
					]),
				verificationStatus: _List_fromArray(
					[
						$elm$html$Html$text($author$project$Helpers$String$nbsp)
					]),
				verificationWarning: _List_fromArray(
					[
						$elm$html$Html$text($author$project$Helpers$String$nbsp)
					])
			});
	});
var $author$project$Components$Dashboard$ReviewRow$viewExpansionEmailsOnLoad = F5(
	function (tz, status, pathContext, index, emailMessage) {
		return A2(
			$author$project$Components$Dashboard$DashboardRow$View$customView,
			{
				additionalRowClasses: $elm$core$Maybe$Just('review-expansion-row'),
				isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
				view: function (row) {
					return $author$project$Forward$Remote$Loaded(
						{
							html: A4($author$project$Components$Dashboard$ReviewRow$viewExpansionEmail, tz, status, row, pathContext),
							onRowClick: $elm$core$Maybe$Just($author$project$Components$Dashboard$Review$Model$NoOp)
						});
				}
			},
			emailMessage);
	});
var $author$project$Components$Dashboard$ReviewRow$viewExpansion = F8(
	function (tz, bools, selectedFactorInvoiceIds, carrier, dashboardPresence, exceptionsExpanded, pathContext, clientGroup) {
		var toInvoiceView = F4(
			function (label, showCheckbox, start, stop) {
				return A2(
					$elm$core$List$map2,
					A8($author$project$Components$Dashboard$ReviewRow$viewExpansionInvoiceOnLoad, tz, bools, selectedFactorInvoiceIds, label, showCheckbox, carrier, dashboardPresence, pathContext),
					A2($elm$core$List$range, start, stop));
			});
		var toEmailView = F3(
			function (label, start, stop) {
				return A2(
					$elm$core$List$map2,
					A3($author$project$Components$Dashboard$ReviewRow$viewExpansionEmailsOnLoad, tz, label, pathContext),
					A2($elm$core$List$range, start, stop));
			});
		var maybeShowCheckbox = function (state) {
			return A2($author$project$Components$Dashboard$Review$Model$showInvoiceCheckbox, bools.verifyMode, state);
		};
		var _v0 = clientGroup;
		var replyInvoices = _v0.replyInvoices;
		var replyEmailMessages = _v0.replyEmailMessages;
		var newEmailMessages = _v0.newEmailMessages;
		var verifyingInvoices = _v0.verifyingInvoices;
		var draftInvoices = _v0.draftInvoices;
		var approvableInvoices = _v0.approvableInvoices;
		var approvableCount = $elm$core$List$length(approvableInvoices);
		var countThruVerifying = approvableCount + $elm$core$List$length(verifyingInvoices);
		var countThruReplyInv = countThruVerifying + $elm$core$List$length(replyInvoices);
		var countThruAllReply = countThruReplyInv + $elm$core$List$length(replyEmailMessages);
		var countThruDrafts = countThruAllReply + $elm$core$List$length(draftInvoices);
		var rowCount = countThruDrafts + $elm$core$List$length(newEmailMessages);
		var maybeRejectedRows = A9($author$project$Components$Dashboard$ReviewRow$maybeViewRejectedRows, tz, bools, rowCount, selectedFactorInvoiceIds, carrier, dashboardPresence, exceptionsExpanded, pathContext, clientGroup);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__review-group-expanded-container')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[$author$project$Components$Dashboard$ReviewRow$expandedReviewFactorHeader]),
						A5(
						toInvoiceView,
						'Ready',
						maybeShowCheckbox($author$project$Domain$FactorInvoice$Processed),
						0,
						approvableCount,
						approvableInvoices),
						A5(
						toInvoiceView,
						'Verifying',
						maybeShowCheckbox($author$project$Domain$FactorInvoice$Verifying),
						approvableCount,
						countThruVerifying,
						verifyingInvoices),
						A5(toInvoiceView, 'Reply', false, countThruVerifying, countThruReplyInv, replyInvoices),
						A4(toEmailView, 'Reply', countThruReplyInv, countThruAllReply, replyEmailMessages),
						A5(toInvoiceView, 'New', false, countThruAllReply, countThruDrafts, draftInvoices),
						A4(toEmailView, 'New', countThruDrafts, rowCount, newEmailMessages),
						maybeRejectedRows
					])));
	});
var $author$project$Components$Dashboard$ReviewRow$viewGroupLabels = function (labels) {
	return $elm$core$List$isEmpty(labels) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__review-group-labels')
				]),
			A2($elm$core$List$map, $author$project$Components$Dashboard$RowHelper$carrierLabelButton, labels))
		]);
};
var $author$project$Components$Dashboard$ReviewRow$viewCarrierLoaded = F7(
	function (currentAccount, tz, showClientBatchRatios, reviewModel, dashboardPresence, pathContext, row) {
		var expandedTmsCarrierIds = reviewModel.expandedTmsCarrierIds;
		var verifyMode = reviewModel.verifyMode;
		var selectedFactorInvoiceIds = reviewModel.selectedFactorInvoiceIds;
		var clientGroup = row.clientGroup;
		var groupData = A2($author$project$Components$Dashboard$Review$Model$getGroupData, reviewModel, clientGroup);
		var dateMsg = function (date) {
			return groupData.anyAreLoading ? _List_fromArray(
				[
					$elm$html$Html$text($author$project$Helpers$String$nbsp)
				]) : A2($author$project$Components$Dashboard$DashboardRow$View$viewDateArea, tz, date);
		};
		var carrier = row.tmsCarrier;
		var carrierId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.id;
			},
			carrier);
		var expanded = A2($author$project$Id$MaybeSet$member, carrierId, expandedTmsCarrierIds);
		var carrierName = A2(
			$elm$core$Maybe$withDefault,
			'Unknown ' + currentAccount.carrierTerm,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.name;
				},
				carrier));
		var approvableCount = $elm$core$List$length(clientGroup.approvableInvoices);
		var approvableRatio = $elm$core$String$fromInt(approvableCount) + (' / ' + $elm$core$String$fromInt(groupData.rowCount));
		var selectableCount = function () {
			if (verifyMode.$ === 'Verify') {
				return $elm$core$List$length(clientGroup.verifyingInvoices);
			} else {
				return approvableCount;
			}
		}();
		var maybeShowCheckbox = ((!selectableCount) || pathContext.isReadonly) ? $elm$html$Html$text($author$project$Helpers$String$nbsp) : A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('checkbox'),
					$elm$html$Html$Attributes$checked(groupData.allSelected),
					$author$project$Components$Dashboard$ReviewRow$safeOnCheck(
					A2($author$project$Components$Dashboard$Review$Model$ToggleInvoiceSelection, groupData.selectableInvoiceIds, !groupData.allSelected)),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Select all for ' + carrierName)
				]),
			_List_Nil);
		var group = _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__review-approve-area')
						]),
					_List_fromArray(
						[
							maybeShowCheckbox,
							A2(
							$author$project$Components$Dashboard$ReviewRow$expandOrContract,
							expanded,
							$author$project$Components$Dashboard$Review$Model$ToggleExpansion(carrierId))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__review-group-client-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(carrierName)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__review-group-verification-warning')
						]),
					_List_fromArray(
						[
							$author$project$Components$RedDot$view(
							A2(
								$elm$core$List$map,
								$author$project$Components$Dashboard$ReviewRow$toRedDotData,
								$author$project$Components$Dashboard$ReviewRow$clientGroupVerifications(clientGroup)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__review-group-invoice-count')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(approvableRatio)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__review-group-invoice-total')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(groupData.total)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__review-group-invoice-oldest')
						]),
					dateMsg(groupData.oldest)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__review-group-invoice-newest')
						]),
					dateMsg(groupData.newest)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__review-group-credit-rating')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Helpers$String$nbsp,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.creditRating;
									},
									carrier)))
						]))
				]),
			$author$project$Components$Dashboard$ReviewRow$viewGroupLabels(row.labels));
		return expanded ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__review-group-container')
					]),
				group),
				A8(
				$author$project$Components$Dashboard$ReviewRow$viewExpansion,
				tz,
				{showClientBatchRatios: showClientBatchRatios, verifyMode: verifyMode},
				selectedFactorInvoiceIds,
				carrier,
				dashboardPresence,
				A2($author$project$Id$MaybeSet$member, carrierId, reviewModel.clientGroupExceptionsExpanded),
				pathContext,
				clientGroup)
			]) : group;
	});
var $author$project$Components$Dashboard$ReviewRow$view = F8(
	function (currentAccount, tz, showClientBatchRatios, reviewModel, dashboardPresence, index, pathContext, carrier) {
		return A2(
			$author$project$Components$Dashboard$DashboardRow$View$customView,
			{
				additionalRowClasses: $elm$core$Maybe$Just('review-group-row'),
				isOddRow: $author$project$Components$Dashboard$DashboardRow$View$isOdd(index),
				view: function (row) {
					return $author$project$Forward$Remote$Loaded(
						{
							html: A7($author$project$Components$Dashboard$ReviewRow$viewCarrierLoaded, currentAccount, tz, showClientBatchRatios, reviewModel, dashboardPresence, pathContext, row),
							onRowClick: $author$project$Components$Dashboard$ReviewRow$toggleExpansionWithCarrier(row)
						});
				}
			},
			carrier);
	});
var $author$project$Components$Dashboard$Pager$View$viewReviewPager = F7(
	function (currentAccount, accountSettings, tz, data, reviewModel, dashboardPresence, pathContext) {
		var viewReviewModel = function (index) {
			return A7($author$project$Components$Dashboard$ReviewRow$view, currentAccount, tz, accountSettings.showClientVerificationPercentagesOnReviewTab, reviewModel, dashboardPresence, index, pathContext);
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				viewReviewModel,
				$author$project$Pagination$entries(data)));
	});
var $author$project$Helpers$Maybe$filter = F2(
	function (predicate, maybeValue) {
		if (maybeValue.$ === 'Just') {
			var value = maybeValue.a;
			return predicate(value) ? $elm$core$Maybe$Just(value) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Domain$VerificationsDebtorBatchItem$isComplete = function (state) {
	switch (state.$) {
		case 'VerificationsDebtorBatchItemStateUnverified':
			return false;
		case 'VerificationsDebtorBatchItemStateHeld':
			return false;
		default:
			return true;
	}
};
var $author$project$Domain$VerificationsDebtorBatchItem$percentageComplete = function (items) {
	var totalItems = $elm$core$List$length(items);
	var itemsComplete = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.state;
				},
				$author$project$Domain$VerificationsDebtorBatchItem$isComplete),
			items));
	return (!totalItems) ? 0 : $elm$core$Basics$round((itemsComplete / totalItems) * 100);
};
var $author$project$Components$Dashboard$VerifyRow$View$viewLabelWithCount = function (labelWithCount) {
	var label = labelWithCount.a;
	var count = $elm$core$String$fromInt(labelWithCount.b);
	var labelText = label + (' (' + (count + ')'));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carrier-labels__label')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(labelText)
			]));
};
var $author$project$Components$Dashboard$VerifyRow$View$viewLabels = function (labels) {
	var labelsWithCount = $elm$core$Dict$toList(
		A3(
			$elm$core$List$foldr,
			F2(
				function (label, output) {
					return A3(
						$elm$core$Dict$update,
						label,
						function (existingCount) {
							if (existingCount.$ === 'Just') {
								var existingCount_ = existingCount.a;
								return $elm$core$Maybe$Just(existingCount_ + 1);
							} else {
								return $elm$core$Maybe$Just(1);
							}
						},
						output);
				}),
			$elm$core$Dict$empty,
			labels));
	return A2($elm$core$List$map, $author$project$Components$Dashboard$VerifyRow$View$viewLabelWithCount, labelsWithCount);
};
var $author$project$Components$Dashboard$VerifyRow$View$viewNoBuyLabels = function (debtor) {
	return debtor.noBuy ? _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carrier-labels__label__caution')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('NO BUY')
				]))
		]) : _List_Nil;
};
var $author$project$Components$Dashboard$VerifyRow$View$viewRow = F3(
	function (tz, presence, _v0) {
		var invoices = _v0.invoices;
		var items = _v0.items;
		var debtor = _v0.debtor;
		var debtorBatch = _v0.debtorBatch;
		var warningTooltip = function (warning) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-alert alert'),
						A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'true'),
						$elm$html$Html$Attributes$title(warning),
						A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
					]),
				_List_Nil);
		};
		var oldestReceivedAt = A2(
			$elm$core$Maybe$map,
			$elm$time$Time$millisToPosix,
			$elm$core$List$minimum(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.receivedAt;
						},
						$elm$time$Time$posixToMillis),
					invoices)));
		var maybeWarning = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Helpers$Html$empty,
			A2(
				$elm$core$Maybe$map,
				warningTooltip,
				A2(
					$author$project$Helpers$Maybe$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					debtor.warning)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__verify-large-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__subject')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(debtor.name),
								maybeWarning
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('carrier_labels message__carrier-labels')
							]),
						_Utils_ap(
							$author$project$Components$Dashboard$VerifyRow$View$viewLabels(debtorBatch.labels),
							$author$project$Components$Dashboard$VerifyRow$View$viewNoBuyLabels(debtor))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('presence_list')
							]),
						A2(
							$author$project$Presence$viewInLine,
							false,
							A3(
								$author$project$DashboardPresence$stateAtPath,
								presence,
								$author$project$Path$toString(
									$author$project$Path$verificationBatch(debtorBatch.id)),
								_List_Nil)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__verify-medium-box')
					]),
				A2($author$project$Components$Dashboard$DashboardRow$View$viewDateArea, tz, oldestReceivedAt)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__verify-small-box')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Domain$VerificationsDebtorBatch$stateToDisplayString(debtorBatch.state))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__verify-small-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__verify-float-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									$elm$core$List$length(items)))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__verify-small-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__verify-float-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Helpers$String$appendToEnd,
									'%',
									$elm$core$String$fromInt(
										$author$project$Domain$VerificationsDebtorBatchItem$percentageComplete(items))))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__verify-medium-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__verify-float-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Money$toString(
									$author$project$Money$sum(
										A2($elm$core$List$filterMap, $author$project$Domain$FactorInvoice$amountInMoney, invoices))))
							]))
					]))
			]);
	});
var $author$project$Components$Dashboard$VerifyRow$View$view = F3(
	function (config, index, row) {
		var dashboardPresence = config.dashboardPresence;
		var tz = config.tz;
		var onClickIfId = function (maybeId) {
			if (maybeId.$ === 'Just') {
				var debtorBatchId = maybeId.a;
				var path = $author$project$Path$verificationBatch(debtorBatchId);
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						config.onRowClick(path))
					]);
			} else {
				return _List_Nil;
			}
		};
		var wrapper = F2(
			function (maybeId, content) {
				return A2(
					$elm$html$Html$div,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('dashboard__messages-row', true),
											_Utils_Tuple2(
											'odd',
											$author$project$Components$Dashboard$DashboardRow$View$isOdd(index))
										]))
								]),
								onClickIfId(maybeId)
							])),
					content);
			});
		switch (row.$) {
			case 'Loaded':
				var loadedRow = row.a;
				return A2(
					wrapper,
					$elm$core$Maybe$Just(loadedRow.debtorBatch.id),
					A3($author$project$Components$Dashboard$VerifyRow$View$viewRow, tz, dashboardPresence, loadedRow));
			case 'Loading':
				return A2(
					wrapper,
					$elm$core$Maybe$Nothing,
					_List_fromArray(
						[
							$author$project$Components$Dashboard$RowHelper$messageSubject('Loading ...')
						]));
			default:
				var error = row.a;
				return A2(
					wrapper,
					$elm$core$Maybe$Nothing,
					_List_fromArray(
						[
							$author$project$Forward$LoadingView$defaultErrorView(error)
						]));
		}
	});
var $author$project$Components$Dashboard$Pager$View$viewVerifyPager = F2(
	function (pagerContext, verifyRows) {
		var config = {dashboardPresence: pagerContext.dashboardPresence, onRowClick: pagerContext.onRowClick, tz: pagerContext.tz};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$Dashboard$VerifyRow$View$view(config),
				verifyRows));
	});
var $author$project$Components$DashboardPage$viewPager = F4(
	function (tz, data, model, dashboardRows) {
		var onSelectSelectable = function () {
			if ($author$project$Components$DashboardPage$canPerformQueueActions(data.currentUser)) {
				var _v4 = _Utils_Tuple2(data.accountSettings.ignoreMode, data.account.factorAccount);
				if (_v4.b) {
					return $elm$core$Maybe$Just($author$project$Components$DashboardPage$SelectSelectable);
				} else {
					if (_v4.a.$ === 'IgnoreModeBulkIgnore') {
						var _v5 = _v4.a;
						return $elm$core$Maybe$Just($author$project$Components$DashboardPage$SelectSelectable);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var onSelectAllSelectable = function () {
			if ($author$project$Components$DashboardPage$canPerformQueueActions(data.currentUser)) {
				var _v2 = _Utils_Tuple2(data.accountSettings.ignoreMode, data.account.factorAccount);
				if (_v2.b) {
					return $elm$core$Maybe$Just($author$project$Components$DashboardPage$ToggleSelectAllVisible);
				} else {
					if (_v2.a.$ === 'IgnoreModeBulkIgnore') {
						var _v3 = _v2.a;
						return $elm$core$Maybe$Just($author$project$Components$DashboardPage$ToggleSelectAllVisible);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var hideIfOthersPresent = A3($author$project$Components$DashboardPage$shouldHideIfOthersPresent, data.accountSettings, data.currentUser, model);
		var activeFilterType = $author$project$Domain$DashboardFilters$activeFilterType(model.dashboardFilters);
		var pagerView = function (config) {
			return $author$project$Components$Dashboard$Pager$View$view(
				{
					actionArea: config.actionArea,
					activeFilterType: activeFilterType,
					debtorSearchSupported: config.debtorSearchSupported,
					header: config.header,
					pager: config.pager,
					paginationBar: {
						activePage: $author$project$Pagination$pageNumber(config.page),
						onPageTo: $author$project$Components$DashboardPage$PagerTo,
						perPage: data.accountSettings.perPageOnDashboard
					},
					rowCount: $author$project$Pagination$totalEntries(config.page)
				});
		};
		var accountType = $author$project$Domain$Account$accountType(data.account);
		switch (dashboardRows.$) {
			case 'NewEmailData':
				var page = dashboardRows.a;
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Nothing,
						debtorSearchSupported: false,
						header: A2($author$project$Components$Dashboard$Header$View$emailMessageHeader, onSelectAllSelectable, accountType),
						page: page,
						pager: A2(
							$author$project$Components$Dashboard$Pager$View$viewEmailPager,
							{
								accountSettings: data.accountSettings,
								accountType: accountType,
								dashboardPresence: model.dashboardPresence,
								hideIfOthersPresent: hideIfOthersPresent,
								onRowClick: $author$project$Components$DashboardPage$ViewItem,
								onSelectSelectable: onSelectSelectable,
								onSkipAsynchronousEmailReview: $author$project$Components$DashboardPage$maybeSkipAsynchronousEmailReview(data.currentUser),
								selectedSelectables: model.selectedSelectables,
								tz: tz
							},
							$author$project$Pagination$entries(page))
					});
			case 'FactorNeedsIndexingData':
				var page = dashboardRows.a;
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Nothing,
						debtorSearchSupported: false,
						header: $author$project$Components$Dashboard$Header$View$factorNeedsIndexingHeader,
						page: page,
						pager: A2(
							$author$project$Components$Dashboard$Pager$View$viewNeedsIndexingPager,
							{
								accountSettings: data.accountSettings,
								accountType: accountType,
								dashboardPresence: model.dashboardPresence,
								hideIfOthersPresent: hideIfOthersPresent,
								onRowClick: $author$project$Components$DashboardPage$ViewItem,
								onSelectSelectable: onSelectSelectable,
								onSkipAsynchronousEmailReview: $author$project$Components$DashboardPage$maybeSkipAsynchronousEmailReview(data.currentUser),
								selectedSelectables: model.selectedSelectables,
								tz: tz
							},
							$author$project$Pagination$entries(page))
					});
			case 'ReadyToAuditCarrierInvoiceData':
				var page = dashboardRows.a;
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Nothing,
						debtorSearchSupported: true,
						header: A7($author$project$Components$Dashboard$Header$View$readyToAuditHeader, onSelectAllSelectable, accountType, data.accountSettings, model.dashboardMode, model.selectedQueue, model.dashboardFilters.dashboardSortBy, $author$project$Components$DashboardPage$SetSortBy),
						page: page,
						pager: A2(
							$author$project$Components$Dashboard$Pager$View$viewCarrierInvoicePager,
							{accountSettings: data.accountSettings, accountType: accountType, currentDate: model.currentDate, dashboardMode: model.dashboardMode, dashboardPresence: model.dashboardPresence, hideIfOthersPresent: hideIfOthersPresent, onRowClick: $author$project$Components$DashboardPage$ViewItem, onSelectSelectable: onSelectSelectable, queue: model.selectedQueue, selectedSelectables: model.selectedSelectables, tz: tz},
							$author$project$Pagination$entries(page))
					});
			case 'UnsentExceptionedData':
				var page = dashboardRows.a;
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Nothing,
						debtorSearchSupported: true,
						header: A8($author$project$Components$Dashboard$Header$View$exceptionMessageHeader, onSelectAllSelectable, accountType, data.accountSettings, true, model.dashboardMode, model.selectedQueue, model.dashboardFilters.dashboardSortBy, $author$project$Components$DashboardPage$SetSortBy),
						page: page,
						pager: A2(
							$author$project$Components$Dashboard$Pager$View$viewExceptionPager,
							{accountSettings: data.accountSettings, accountType: accountType, currentDate: model.currentDate, dashboardMode: model.dashboardMode, dashboardPresence: model.dashboardPresence, hideIfOthersPresent: hideIfOthersPresent, onRowClick: $author$project$Components$DashboardPage$ViewItem, onSelectSelectable: onSelectSelectable, queue: model.selectedQueue, selectedSelectables: model.selectedSelectables, tz: tz},
							$author$project$Pagination$entries(page))
					});
			case 'ReplyEmailData':
				var page = dashboardRows.a;
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Nothing,
						debtorSearchSupported: false,
						header: A2($author$project$Components$Dashboard$Header$View$replyHeader, onSelectAllSelectable, accountType),
						page: page,
						pager: A2(
							$author$project$Components$Dashboard$Pager$View$viewReplyPager,
							{
								accountSettings: data.accountSettings,
								accountType: accountType,
								dashboardPresence: model.dashboardPresence,
								hideIfOthersPresent: hideIfOthersPresent,
								onRowClick: $author$project$Components$DashboardPage$ViewItem,
								onSelectSelectable: onSelectSelectable,
								onSkipAsynchronousEmailReview: $author$project$Components$DashboardPage$maybeSkipAsynchronousEmailReview(data.currentUser),
								selectedSelectables: model.selectedSelectables,
								tz: tz
							},
							$author$project$Pagination$entries(page))
					});
			case 'VerifyData':
				var page = dashboardRows.a;
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Nothing,
						debtorSearchSupported: true,
						header: $author$project$Components$Dashboard$Header$View$verifyHeader,
						page: page,
						pager: A2(
							$author$project$Components$Dashboard$Pager$View$viewVerifyPager,
							{dashboardPresence: model.dashboardPresence, onRowClick: $author$project$Components$DashboardPage$ViewItem, tz: tz},
							$author$project$Pagination$entries(page))
					});
			case 'ReviewData':
				var reviewData = dashboardRows.a;
				var reviewModel = model.reviewModel;
				var selectedRowCount = A2($author$project$Components$Dashboard$Review$Model$selectedCount, reviewModel, reviewData);
				var actionArea = A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ReviewUiMsg, $author$project$Components$DashboardPage$ReviewMsg),
					$author$project$Components$Dashboard$Review$ActionArea$view(
						{
							accountSettings: data.accountSettings,
							readOnlyFactorUser: data.currentUser.readOnlyFactorInvoices,
							selectedCustomState: reviewModel.selectedCustomState,
							selectedRowCount: selectedRowCount,
							sendingState: reviewModel.sendingState,
							verifyModeOn: _Utils_eq(reviewModel.verifyMode, $author$project$Components$Dashboard$Review$Model$Verify)
						}));
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Just(actionArea),
						debtorSearchSupported: true,
						header: A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ReviewUiMsg, $author$project$Components$DashboardPage$ReviewMsg),
							$author$project$Components$Dashboard$Header$View$reviewHeader(
								{
									allSelected: A2($author$project$Components$Dashboard$Review$Model$allAreSelected, reviewModel, reviewData),
									clientCount: $elm$core$Maybe$Just(
										$author$project$Pagination$totalEntries(reviewData)),
									readOnlyFactorUser: data.currentUser.readOnlyFactorInvoices
								})),
						page: reviewData,
						pager: A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ReviewUiMsg, $author$project$Components$DashboardPage$ReviewMsg),
							A7(
								$author$project$Components$Dashboard$Pager$View$viewReviewPager,
								data.account,
								data.accountSettings,
								tz,
								reviewData,
								reviewModel,
								model.dashboardPresence,
								{
									isReadonly: data.currentUser.readOnlyFactorInvoices,
									useFactorInvoiceWorkflowPage: A2($author$project$Domain$User$usesFactorInvoiceWorkflowPage, data.accountSettings, data.currentUser)
								}))
					});
			case 'ProcessedBrokerData':
				var brokerData = dashboardRows.a;
				var shouldShowDeliveredAt = A4(
					$author$project$Components$Dashboard$DashboardRow$shouldShowDeliveredAt,
					$author$project$Domain$Account$accountType(data.account),
					data.accountSettings,
					model.dashboardMode,
					model.selectedQueue);
				var currentDate = model.currentDate;
				var brokerModel = model.processedBrokerModel;
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ProcessedBrokerActionAreaMsg, $author$project$Components$DashboardPage$ProcessedBrokerMsg),
								A3(
									$author$project$Components$Dashboard$Processed$ProcessedActionArea$brokerProcessedActionArea,
									$author$project$Pagination$entries(
										A2($author$project$Pagination$map, $elm$core$Tuple$first, brokerData)),
									model.sendingState.isProcessingApproval,
									$author$project$Components$Dashboard$Processed$BrokerModel$countSelected(brokerModel)))),
						debtorSearchSupported: true,
						header: A6($author$project$Components$Dashboard$Header$View$processedBrokerHeader, accountType, data.accountSettings, model.dashboardMode, model.selectedQueue, model.dashboardFilters.dashboardSortBy, $author$project$Components$DashboardPage$SetSortBy),
						page: A2($author$project$Pagination$map, $elm$core$Tuple$second, brokerData),
						pager: A7(
							$author$project$Components$Dashboard$Pager$View$viewProcessedBrokerPager,
							{
								onBrokerRowMsg: A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ProcessedBrokerRowMsg, $author$project$Components$DashboardPage$ProcessedBrokerMsg),
								onRowClick: $author$project$Components$DashboardPage$ViewItem
							},
							data.accountSettings,
							tz,
							shouldShowDeliveredAt,
							currentDate,
							brokerModel,
							brokerData)
					});
			default:
				var factorData = dashboardRows.a;
				var factorModel = model.processedFactorModel;
				var expandedTmsCarrierIds = function () {
					var factorRecord = factorModel.a;
					return factorRecord.expandedTmsCarrierIds;
				}();
				return pagerView(
					{
						actionArea: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ProcessedFactorActionAreaMsg, $author$project$Components$DashboardPage$ProcessedFactorMsg),
								A3(
									$author$project$Components$Dashboard$Processed$ProcessedActionArea$factorProcessedActionArea,
									model.sendingState,
									_Utils_eq(
										A2($author$project$Components$Dashboard$Processed$FactorModel$expandAllCarrierIds, factorData, expandedTmsCarrierIds),
										$author$project$Id$Set$empty),
									A2($author$project$Components$Dashboard$Processed$FactorModel$countSelected, factorData, factorModel)))),
						debtorSearchSupported: true,
						header: A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ProcessedFactorHeaderMsg, $author$project$Components$DashboardPage$ProcessedFactorMsg),
							$author$project$Components$Dashboard$Header$View$processedFactorHeader(
								{
									allSelected: A2($author$project$Components$Dashboard$Processed$FactorModel$allSelected, factorData, factorModel),
									currentOrder: $author$project$Components$Dashboard$Processed$FactorModel$sortBy(factorModel)
								})),
						page: A2($author$project$Pagination$map, $author$project$Forward$Remote$Loaded, factorData.currentPageData),
						pager: A4(
							$author$project$Components$Dashboard$Pager$View$viewProcessedFactorPager,
							tz,
							{
								onFactorGroupMsg: A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ProcessedFactorGroupMsg, $author$project$Components$DashboardPage$ProcessedFactorMsg),
								onRowClick: $author$project$Components$DashboardPage$ViewItem
							},
							factorModel,
							factorData)
					});
		}
	});
var $author$project$Components$DashboardPage$view = F3(
	function (tz, data, model) {
		var dashboardContainerClassName = 'dashboard__messages-container--wider';
		var controlView = A3($author$project$Components$DashboardPage$newDashboardControlView, tz, data, model);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-box__stack hubtran-box__between-0 hubtran-box__horizontal-0 hubtran-box__vertical-0')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$DashboardPage$viewIgnoreModal, data, model),
					A2($author$project$Components$DashboardPage$viewMergeModal, data, model),
					A2($author$project$Components$DashboardPage$viewBulkLabelModal, data, model),
					$author$project$Components$DashboardPage$viewDashboardSavedFilterSaveModal(model),
					$author$project$Components$DashboardPage$viewDashboardSavedFilterEditModal(model),
					A3(
					$author$project$Forward$LoadingView$viewV3Reskinnable,
					data.accountSettings.auditV3ReskinEnabledTopLevel,
					A3(
						$author$project$Components$Dashboard$Menu$view,
						model.selectedQueue,
						A2($elm$core$Basics$composeL, $author$project$Components$DashboardPage$SelectedQueue, $author$project$Sanitized$raw),
						model.dashboardMode),
					data.menuData),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(dashboardContainerClassName)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__controls-container')
								]),
							_List_fromArray(
								[
									A3($author$project$Forward$LoadingView$viewV3Reskinnable, data.accountSettings.auditV3ReskinEnabledTopLevel, controlView, data.dashboardRows),
									A3(
									$author$project$Forward$LoadingView$viewV3Reskinnable,
									data.accountSettings.auditV3ReskinEnabledTopLevel,
									A3($author$project$Components$DashboardPage$viewPager, tz, data, model),
									data.dashboardRows)
								]))
						]))
				]));
	});
var $author$project$Ui$V3$Colors$Gray100 = {$: 'Gray100'};
var $author$project$Ui$V3$Stack$CrossAxisStretch = {$: 'CrossAxisStretch'};
var $author$project$Ui$V3$Stack$crossAxisStretch = $author$project$Ui$V3$Stack$CrossAxisAttribute($author$project$Ui$V3$Stack$CrossAxisStretch);
var $author$project$Ui$V3$Colors$Gray150 = {$: 'Gray150'};
var $author$project$Ui$V3$Stack$BorderAttribute = function (a) {
	return {$: 'BorderAttribute', a: a};
};
var $author$project$Ui$V3$Stack$BorderSolid = F2(
	function (a, b) {
		return {$: 'BorderSolid', a: a, b: b};
	});
var $author$project$Ui$V3$Stack$borderSolid = F2(
	function (width, color) {
		return $author$project$Ui$V3$Stack$BorderAttribute(
			A2($author$project$Ui$V3$Stack$BorderSolid, width, color));
	});
var $author$project$Components$DocumentBatchReviewPage$documentsBrowserPanel = F2(
	function (model, data) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
					A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Gray150)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$DocumentBatchReviewPage$DocumentsBrowserMsg,
					A2(
						$author$project$Forward$LoadingView$view,
						A3($author$project$Components$DocumentsBrowser$view, $elm$time$Time$utc, model.documentsBrowser, _List_Nil),
						data.documentsBrowserData))
				]));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$BackgroundClick = {$: 'BackgroundClick'};
var $author$project$Components$DocumentBatchGroupingReviewPage$GroupedDocuments = function (a) {
	return {$: 'GroupedDocuments', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$NewGroup = {$: 'NewGroup'};
var $author$project$Components$DocumentBatchGroupingReviewPage$SubmitGroups = {$: 'SubmitGroups'};
var $author$project$Components$DocumentBatchGroupingReviewPage$UngroupedDocuments = {$: 'UngroupedDocuments'};
var $author$project$Components$DragDrop$currentlyDragging = function (model) {
	var _v0 = model.dragState;
	if (_v0.$ === 'NotDragging') {
		return $elm$core$Maybe$Nothing;
	} else {
		var dragId = _v0.a.a;
		return $elm$core$Maybe$Just(dragId);
	}
};
var $author$project$Components$DocumentBatchGroupingReviewPage$StopPreviewingDocument = {$: 'StopPreviewingDocument'};
var $author$project$Ui$V3$Stack$MainAxisCenter = {$: 'MainAxisCenter'};
var $author$project$Ui$V3$Stack$mainAxisCenter = $author$project$Ui$V3$Stack$MainAxisAttribute($author$project$Ui$V3$Stack$MainAxisCenter);
var $author$project$Components$DocumentBatchGroupingReviewPage$documentsBrowserPanel = F2(
	function (data, documentsBrowser) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
					A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Gray150),
					$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							$elm$html$Html$text('Current Selection')),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Components$DocumentBatchGroupingReviewPage$StopPreviewingDocument),
										A2(
										$elm$html$Html$Attributes$style,
										'color',
										$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray900))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$V3$Stack$viewHorz,
										_List_fromArray(
											[
												A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Gray900),
												A2($author$project$Ui$V3$Stack$style, 'height', '32px'),
												A2($author$project$Ui$V3$Stack$style, 'width', '32px'),
												A2($author$project$Ui$V3$Stack$style, 'border-radius', '16px'),
												$author$project$Ui$V3$Stack$mainAxisCenter,
												$author$project$Ui$V3$Stack$crossAxisCenter
											]),
										_List_fromArray(
											[
												A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$close16)
											]))
									])))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$DocumentBatchGroupingReviewPage$DocumentsBrowserMsg,
					A2(
						$author$project$Forward$LoadingView$view,
						A3($author$project$Components$DocumentsBrowser$view, $elm$time$Time$utc, documentsBrowser, _List_Nil),
						data.documentsBrowserData))
				]));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$AddToGroup = function (a) {
	return {$: 'AddToGroup', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenuMsg = F2(
	function (a, b) {
		return {$: 'CardManagementMenuMsg', a: a, b: b};
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$DragDropMsg = function (a) {
	return {$: 'DragDropMsg', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$MergeSelectedDocuments = {$: 'MergeSelectedDocuments'};
var $author$project$Components$DocumentBatchGroupingReviewPage$ToggleGroupCollapse = F2(
	function (a, b) {
		return {$: 'ToggleGroupCollapse', a: a, b: b};
	});
var $author$project$Ui$V3$Colors$Gray200 = {$: 'Gray200'};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$addToGroupCard = A2(
	$author$project$Ui$V3$Stack$viewVertWithHeights,
	_List_fromArray(
		[
			A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Gray200),
			$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray100),
			A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px'),
			$author$project$Ui$V3$Stack$mainAxisCenter,
			$author$project$Ui$V3$Stack$crossAxisCenter
		]),
	_List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Ui$V3$Stack$fitPx(190),
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[$author$project$Ui$V3$Stack$mainAxisCenter, $author$project$Ui$V3$Stack$crossAxisCenter]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('+')
							]))
					])))
		]));
var $author$project$Components$DragDrop$currentlyDraggingOver = function (model) {
	var _v0 = model.dragState;
	if (_v0.$ === 'NotDragging') {
		return $elm$core$Maybe$Nothing;
	} else {
		var dropId = _v0.b;
		return dropId;
	}
};
var $author$project$Components$DocumentBatchGroupingReviewPage$addAtEndDropSiteIfApplicable = F2(
	function (model, localDocumentGroup) {
		var isRenderingNewGroup = $elm$core$List$isEmpty(localDocumentGroup.documents);
		var isMemberOfGroup = function (documentId) {
			return A2(
				$elm$core$List$member,
				documentId,
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.document;
						},
						function ($) {
							return $.id;
						}),
					localDocumentGroup.documents));
		};
		var isDraggingOverThisGroup = function () {
			var _v0 = $author$project$Components$DragDrop$currentlyDraggingOver(model.dragDrop);
			if (_v0.$ === 'Just') {
				if (_v0.a.$ === 'AddToGroup') {
					var index = _v0.a.a;
					return _Utils_eq(index, localDocumentGroup.groupIndex);
				} else {
					var documentId = _v0.a.a;
					return isMemberOfGroup(documentId);
				}
			} else {
				return false;
			}
		}();
		var isDraggedElementMemberOfThisGroup = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			false,
			isMemberOfGroup,
			$author$project$Components$DragDrop$currentlyDragging(model.dragDrop));
		return ((isDraggingOverThisGroup && (!isDraggedElementMemberOfThisGroup)) || isRenderingNewGroup) ? _Utils_Tuple2(
			$author$project$Ui$V3$Stack$fitPx(140),
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$addToGroupCard]))) : _Utils_Tuple2(
			$author$project$Ui$V3$Stack$fitPx(0),
			A2($elm$html$Html$div, _List_Nil, _List_Nil));
	});
var $author$project$Ui$V3$Card$Collapsible = function (a) {
	return {$: 'Collapsible', a: a};
};
var $author$project$Ui$V3$Card$collapsible = function (collapseConfig) {
	return $author$project$Ui$V3$Card$Collapsible(collapseConfig);
};
var $author$project$Ui$V3$Card$DividersAttribute = function (a) {
	return {$: 'DividersAttribute', a: a};
};
var $author$project$Ui$V3$Card$dividers = function (dividerConfig) {
	return $author$project$Ui$V3$Card$DividersAttribute(dividerConfig);
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCardMsg = F2(
	function (a, b) {
		return {$: 'DraggableDocumentCardMsg', a: a, b: b};
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$InsertBefore = function (a) {
	return {$: 'InsertBefore', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$PreviewDocument = function (a) {
	return {$: 'PreviewDocument', a: a};
};
var $author$project$Ui$V3$Colors$Blue100 = {$: 'Blue100'};
var $author$project$Ui$V3$Colors$Blue300 = {$: 'Blue300'};
var $author$project$Ui$V3$Colors$Blue50 = {$: 'Blue50'};
var $author$project$Ui$V3$Colors$Blue500 = {$: 'Blue500'};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardClick = function (a) {
	return {$: 'CardClick', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardHoverChange = function (a) {
	return {$: 'CardHoverChange', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardManagementMenuMsg = function (a) {
	return {$: 'CardManagementMenuMsg', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$OtherContent = {$: 'OtherContent'};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$OverDocumentPage = function (a) {
	return {$: 'OverDocumentPage', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isHovering = function (hoveringOver) {
	return !_Utils_eq(hoveringOver, $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NotHovering);
};
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$V3$Stack$PaddingTopBottom = F2(
	function (a, b) {
		return {$: 'PaddingTopBottom', a: a, b: b};
	});
var $author$project$Ui$V3$Stack$paddingTopBottom = F2(
	function (t, b) {
		return $author$project$Ui$V3$Stack$PaddingAttribute(
			A2($author$project$Ui$V3$Stack$PaddingTopBottom, t, b));
	});
var $author$project$Ui$V3$Stack$PaddingVert = function (a) {
	return {$: 'PaddingVert', a: a};
};
var $author$project$Ui$V3$Stack$paddingVert = function (v) {
	return $author$project$Ui$V3$Stack$PaddingAttribute(
		$author$project$Ui$V3$Stack$PaddingVert(v));
};
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$SplitPage = function (a) {
	return {$: 'SplitPage', a: a};
};
var $elm$html$Html$Attributes$draggable = _VirtualDom_attribute('draggable');
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$thumbnail = F3(
	function (_v0, index, _v1) {
		var numberOfCardsSelected = _v0.numberOfCardsSelected;
		var multiplePagesPresent = _v0.multiplePagesPresent;
		var isHovered = _v0.isHovered;
		var documentPageId = _v1.a;
		var maybeThumbnailUrl = _v1.b;
		var thumbnailImage = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-thumbnail__blank-page'),
						A2($elm$html$Html$Attributes$style, 'height', '170px'),
						$elm$html$Html$Attributes$draggable('false')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No Preview Available')
					])),
			function (url) {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(url),
							A2($elm$html$Html$Attributes$style, 'height', '170px'),
							$elm$html$Html$Attributes$draggable('false')
						]),
					_List_Nil);
			},
			maybeThumbnailUrl);
		var splitButton = (multiplePagesPresent && ((!(!index)) && isHovered)) ? A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Stack$style, 'position', 'absolute'),
					A2($author$project$Ui$V3$Stack$style, 'width', 'inherit'),
					A2(
					$author$project$Ui$V3$Stack$style,
					'top',
					(numberOfCardsSelected > 1) ? '0' : '30px'),
					A2($author$project$Ui$V3$Stack$style, 'z-index', '1'),
					$author$project$Ui$V3$Stack$mainAxisCenter,
					$author$project$Ui$V3$Stack$paddingVert($author$project$Ui$V3$Stack$spaceXXXSmall),
					A2($author$project$Ui$V3$Stack$style, 'padding-right', '8px')
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A3(
						$author$project$Ui$V3$Button$view,
						{
							action: $author$project$Ui$V3$Button$onClick(
								$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$SplitPage(documentPageId))
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeXSmall),
								$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
								A2($author$project$Ui$V3$Button$cssStyle, 'flex', '0')
							]),
						'Split'))
				])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseover',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardHoverChange(
								$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$OverDocumentPage(documentPageId)),
							true))),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center')
				]),
			_List_fromArray(
				[splitButton, thumbnailImage]));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$MenuClick = {$: 'MenuClick'};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$CloseMenu = {$: 'CloseMenu'};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$Grouped = function (a) {
	return {$: 'Grouped', a: a};
};
var $author$project$Ui$V3$Popup$LeftAlign = {$: 'LeftAlign'};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$MoveToGroup = function (a) {
	return {$: 'MoveToGroup', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$NewGroup = {$: 'NewGroup'};
var $author$project$Ui$V3$Popup$PopupAlignment = function (a) {
	return {$: 'PopupAlignment', a: a};
};
var $author$project$Ui$V3$Popup$StopPropagation = function (a) {
	return {$: 'StopPropagation', a: a};
};
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$Ungrouped = {$: 'Ungrouped'};
var $author$project$Ui$V3$Stack$BackgroundOnHoverAttribute = function (a) {
	return {$: 'BackgroundOnHoverAttribute', a: a};
};
var $author$project$Ui$V3$Stack$backgroundColorOnHover = function (color) {
	return $author$project$Ui$V3$Stack$BackgroundOnHoverAttribute(
		$author$project$Ui$V3$Stack$BackgroundColor(color));
};
var $author$project$Ui$V3$Stack$onClickStopPropagation = function (decoder) {
	return $author$project$Ui$V3$Stack$onClickCustom(
		A2(
			$elm$json$Json$Decode$map,
			function (_v0) {
				var msg = _v0.a;
				var stopPropagation = _v0.b;
				return {message: msg, preventDefault: false, stopPropagation: stopPropagation};
			},
			decoder));
};
var $author$project$Ui$V3$Colors$BackgroundNeutralContainer = {$: 'BackgroundNeutralContainer'};
var $author$project$Ui$V3$Stack$boxShadow = $author$project$Ui$V3$Stack$ClassAttribute('v3__stack--box-shadow');
var $author$project$Ui$V3$Popup$RightAlign = {$: 'RightAlign'};
var $author$project$Ui$V3$Popup$defaultAttributes = {popupAlignment: $author$project$Ui$V3$Popup$RightAlign, stopPropagation: false};
var $author$project$Ui$V3$Popup$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			if (a.$ === 'PopupAlignment') {
				var value = a.a;
				return _Utils_update(
					acc,
					{popupAlignment: value});
			} else {
				var value = a.a;
				return _Utils_update(
					acc,
					{stopPropagation: value});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Popup$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Popup$view = F3(
	function (config, attributes, content) {
		if (config.isOpen) {
			var computedAttributes = $author$project$Ui$V3$Popup$computeAttributes(attributes);
			var overlay = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__popup__overlay'),
						computedAttributes.stopPropagation ? A2(
						$elm$html$Html$Events$stopPropagationOn,
						'click',
						$elm$json$Json$Decode$succeed(
							_Utils_Tuple2(config.onClose, true))) : $elm$html$Html$Events$onClick(config.onClose)
					]),
				_List_Nil);
			var alignText = function () {
				var _v0 = computedAttributes.popupAlignment;
				if (_v0.$ === 'LeftAlign') {
					return 'left_align';
				} else {
					return 'right_align';
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__popup__container')
					]),
				_List_fromArray(
					[
						overlay,
						A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$class('v3__popup__content v3__popup__content__' + alignText),
								$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$BackgroundNeutralContainer),
								$author$project$Ui$V3$Stack$boxShadow,
								A2($author$project$Ui$V3$Stack$style, 'width', config.width)
							]),
						_List_fromArray(
							[content]))
					]));
		} else {
			return $author$project$Ui$V3$Helpers$Html$empty;
		}
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$menu = F2(
	function (_v0, _v1) {
		var groupIndex = _v0.groupIndex;
		var availableGroupIndices = _v0.availableGroupIndices;
		var isMenuOpen = _v1.isMenuOpen;
		var ungroupedOption = $elm_community$maybe_extra$Maybe$Extra$isJust(groupIndex) ? _List_fromArray(
			[
				_Utils_Tuple2($author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$Ungrouped, 'Ungrouped')
			]) : _List_Nil;
		var groupedOptions = A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapFirst($author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$Grouped),
			A2(
				$elm$core$List$filter,
				function (_v3) {
					var index = _v3.a;
					return !_Utils_eq(
						$elm$core$Maybe$Just(index),
						groupIndex);
				},
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (visibleIndex, index) {
							return _Utils_Tuple2(
								index,
								'Group ' + $elm$core$String$fromInt(visibleIndex + 1));
						}),
					$elm$core$List$sort(availableGroupIndices))));
		var allGroupOptions = _Utils_ap(
			ungroupedOption,
			_Utils_ap(
				groupedOptions,
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$NewGroup, 'New Group')
					])));
		var menuContent = A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
					$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXXSmall),
					A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Gray200)
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var groupOption = _v2.a;
					var label = _v2.b;
					return A2(
						$author$project$Ui$V3$Stack$viewHorz,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$backgroundColorOnHover($author$project$Ui$V3$Colors$Gray50),
								$author$project$Ui$V3$Stack$onClickStopPropagation(
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2(
										$author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$MoveToGroup(groupOption),
										true))),
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
								A2($author$project$Ui$V3$Stack$paddingVertHorz, $author$project$Ui$V3$Stack$spaceXXSmall, $author$project$Ui$V3$Stack$spaceXSmall),
								$author$project$Ui$V3$Stack$crossAxisCenter,
								A2($author$project$Ui$V3$Stack$style, 'font-weight', 'bold'),
								A2($author$project$Ui$V3$Stack$style, 'font-size', '11pt')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				},
				allGroupOptions));
		return A3(
			$author$project$Ui$V3$Popup$view,
			{isOpen: isMenuOpen, onClose: $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$CloseMenu, width: 'fit-content'},
			_List_fromArray(
				[
					$author$project$Ui$V3$Popup$PopupAlignment($author$project$Ui$V3$Popup$LeftAlign),
					$author$project$Ui$V3$Popup$StopPropagation(true)
				]),
			menuContent);
	});
var $author$project$Ui$V3$Button$Icon16Content = function (a) {
	return {$: 'Icon16Content', a: a};
};
var $author$project$Ui$V3$Button$RightIconWithHiddenLabelAttribute = function (a) {
	return {$: 'RightIconWithHiddenLabelAttribute', a: a};
};
var $author$project$Ui$V3$Button$rightIcon16WithHiddenLabel = A2($elm$core$Basics$composeL, $author$project$Ui$V3$Button$RightIconWithHiddenLabelAttribute, $author$project$Ui$V3$Button$Icon16Content);
var $author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$view = F2(
	function (data, model) {
		var visibleGroupIndex = data.visibleGroupIndex;
		var menuText = function () {
			if (visibleGroupIndex.$ === 'Nothing') {
				return 'Ungrouped';
			} else {
				var index = visibleGroupIndex.a;
				return 'Group ' + $elm$core$String$fromInt(index + 1);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[$author$project$Ui$V3$Stack$mainAxisCenter]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick($author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$MenuClick)
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeXSmall),
										$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
										$author$project$Ui$V3$Button$rightIcon16WithHiddenLabel($author$project$Ui$V3$Icon$chevronDown16)
									]),
								menuText))
						])),
					A2($author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$menu, data, model)
				]));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$view = F3(
	function (_v0, data, model) {
		var accountSettings = _v0.accountSettings;
		var account = _v0.account;
		var numberOfCardsSelected = data.numberOfCardsSelected;
		var thumbnailUrls = data.thumbnailUrls;
		var document = data.document;
		var hoveringOver = model.hoveringOver;
		var textContent = A3(
			$author$project$Domain$Helpers$documentTypeToString,
			account,
			accountSettings,
			$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue));
		var showMenu = ($author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isSelected(model) || $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isHovering(hoveringOver)) && ((data.numberOfCardsSelected < 2) && (_Utils_eq(data.currentlySelectedGroupIndex, $elm$core$Maybe$Nothing) || _Utils_eq(
			data.currentlySelectedGroupIndex,
			$elm$core$Maybe$Just(data.groupIndex))));
		var renderThumbnail = F2(
			function (index, _v2) {
				var documentPageId = _v2.a;
				var thumbnailUrl = _v2.b;
				return A3(
					$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$thumbnail,
					{
						isHovered: _Utils_eq(
							hoveringOver,
							$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$OverDocumentPage(documentPageId)),
						multiplePagesPresent: $elm$core$List$length(thumbnailUrls) > 1,
						numberOfCardsSelected: numberOfCardsSelected
					},
					index,
					_Utils_Tuple2(documentPageId, thumbnailUrl));
			});
		var mouseEvents = A2(
			$elm$core$List$map,
			$author$project$Ui$V3$Stack$htmlAttribute,
			_List_fromArray(
				[
					$elm$html$Html$Events$onMouseOver(
					$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardHoverChange($author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$OtherContent)),
					$elm$html$Html$Events$onMouseOut(
					$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardHoverChange($author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$NotHovering)),
					A2(
					$elm$html$Html$Events$custom,
					'click',
					A2(
						$elm$json$Json$Decode$map,
						function (isShift) {
							return {
								message: $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardClick(
									{isShift: isShift}),
								preventDefault: true,
								stopPropagation: true
							};
						},
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['shiftKey']),
							$elm$json$Json$Decode$bool)))
				]));
		var _v1 = $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isSelected(model) ? _Utils_Tuple2($author$project$Ui$V3$Colors$Blue500, $author$project$Ui$V3$Colors$Blue100) : ($author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isHovering(hoveringOver) ? _Utils_Tuple2($author$project$Ui$V3$Colors$Blue300, $author$project$Ui$V3$Colors$Blue50) : _Utils_Tuple2($author$project$Ui$V3$Colors$Gray200, $author$project$Ui$V3$Colors$Gray100));
		var borderColor = _v1.a;
		var backgroundColor = _v1.b;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Stack$borderSolid, 1, borderColor),
						$author$project$Ui$V3$Stack$backgroundColor(backgroundColor),
						$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXXXSmall),
						A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px'),
						A2($author$project$Ui$V3$Stack$style, 'position', 'relative')
					]),
				mouseEvents),
			_List_fromArray(
				[
					showMenu ? A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Stack$style, 'position', 'absolute'),
							A2($author$project$Ui$V3$Stack$style, 'top', '0'),
							A2($author$project$Ui$V3$Stack$style, 'z-index', '1'),
							$author$project$Ui$V3$Stack$mainAxisCenter,
							$author$project$Ui$V3$Stack$paddingVert($author$project$Ui$V3$Stack$spaceXXXSmall),
							A2($author$project$Ui$V3$Stack$style, 'padding-right', '8px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$CardManagementMenuMsg,
							A2(
								$author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$view,
								{availableGroupIndices: data.availableGroupIndices, groupIndex: data.groupIndex, visibleGroupIndex: data.visibleGroupIndex},
								model.cardManagementMenu))
						])) : $elm$html$Html$text(''),
					A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
							A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px'),
							A2($author$project$Ui$V3$Stack$style, 'overflow', 'hidden'),
							A2($author$project$Ui$V3$Stack$style, 'position', 'relative')
						]),
					A2($elm$core$List$indexedMap, renderThumbnail, thumbnailUrls)),
					A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Stack$paddingTopBottom, $author$project$Ui$V3$Stack$spaceXXSmall, $author$project$Ui$V3$Stack$spaceXXXSmall),
							$author$project$Ui$V3$Stack$mainAxisCenter
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
									A2($elm$html$Html$Attributes$style, 'font-size', '11pt')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(textContent)
								]))
						]))
				]));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$draggableDocumentElement = F5(
	function (data, model, groupIndex, visibleGroupIndex, localDocument) {
		var isIncludedInDragging = $elm_community$maybe_extra$Maybe$Extra$isJust(
			$author$project$Components$DragDrop$currentlyDragging(model.dragDrop)) && $author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$isSelected(localDocument.cardModel);
		var isCurrentlyBeingDragged = _Utils_eq(
			$author$project$Components$DragDrop$currentlyDragging(model.dragDrop),
			$elm$core$Maybe$Just(localDocument.document.id));
		var droppableAttributes = A2(
			$elm$core$List$map,
			$elm$html$Html$Attributes$map(
				A2($elm$core$Basics$composeL, $author$project$Components$DocumentBatchGroupingReviewPage$DragDropMsg, $author$project$Components$DragDrop$DropSideMsg)),
			$author$project$Components$DragDrop$dropAttributes(
				$author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$InsertBefore(localDocument.document.id)));
		var draggableAttributes = A2(
			$elm$core$List$map,
			$elm$html$Html$Attributes$map(
				A2($elm$core$Basics$composeL, $author$project$Components$DocumentBatchGroupingReviewPage$DragDropMsg, $author$project$Components$DragDrop$DragSideMsg)),
			$author$project$Components$DragDrop$dragAttributes(
				$author$project$Components$DragDrop$DragId(localDocument.document.id)));
		var documentId = localDocument.document.id;
		var previewDocumentHandler = (!isCurrentlyBeingDragged) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'contextmenu',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						$author$project$Components$DocumentBatchGroupingReviewPage$PreviewDocument(documentId),
						true)))
			]) : _List_Nil;
		var availableGroupIndices = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.groupIndex;
				},
				model.groupableDocumentIds));
		var cardData = {
			availableGroupIndices: availableGroupIndices,
			currentlySelectedGroupIndex: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.groupIndex;
				},
				$author$project$Components$DocumentBatchGroupingReviewPage$firstCurrentlySelectedCard(model)),
			document: localDocument.document,
			groupIndex: groupIndex,
			numberOfCardsSelected: $author$project$Components$DocumentBatchGroupingReviewPage$numberOfCardsSelected(model),
			thumbnailUrls: localDocument.thumbnailUrls,
			visibleGroupIndex: visibleGroupIndex
		};
		var cardElement = A2(
			$elm$html$Html$map,
			$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCardMsg(documentId),
			A3($author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$view, data, cardData, localDocument.cardModel));
		var _v0 = $author$project$Components$DragDrop$currentlyDraggingOver(model.dragDrop);
		if (_v0.$ === 'Just') {
			if (_v0.a.$ === 'InsertBefore') {
				var dropSiteDocumentId = _v0.a.a;
				return _Utils_eq(dropSiteDocumentId, localDocument.document.id) ? A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Gray150),
						droppableAttributes),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'visibility', 'hidden')
								]),
							_List_fromArray(
								[cardElement]))
						])) : A2(
					$elm$html$Html$div,
					_Utils_ap(
						droppableAttributes,
						(isCurrentlyBeingDragged || isIncludedInDragging) ? _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'opacity', '0.5')
							]) : _List_Nil),
					_List_fromArray(
						[cardElement]));
			} else {
				return A2(
					$elm$html$Html$div,
					isIncludedInDragging ? _List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'opacity', '0.5')
						]) : droppableAttributes,
					_List_fromArray(
						[cardElement]));
			}
		} else {
			return A3(
				$elm$html$Html$Keyed$node,
				'div',
				isIncludedInDragging ? _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'opacity', '0.5')
					]) : _Utils_ap(
					draggableAttributes,
					_Utils_ap(droppableAttributes, previewDocumentHandler)),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Domain$DocumentId$toString(documentId),
						cardElement)
					]));
		}
	});
var $author$project$Ui$V3$Icon$folder16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M4.36003 13.8337H3.97921C3.53029 13.8337 3.16316 13.8337 2.86478 13.8093C2.55594 13.7841 2.27701 13.7303 2.01652 13.5976C1.60883 13.3898 1.27737 13.0584 1.06965 12.6507C0.936921 12.3902 0.883097 12.1113 0.857864 11.8024C0.833486 11.504 0.833491 11.1369 0.833496 10.688V5.31276C0.833491 4.86385 0.833486 4.4967 0.857864 4.19833C0.883097 3.88949 0.936921 3.61056 1.06965 3.35006C1.27737 2.94238 1.60883 2.61092 2.01652 2.4032C2.27701 2.27047 2.55594 2.21664 2.86478 2.19141C3.16316 2.16703 3.5303 2.16704 3.97922 2.16704L5.04574 2.16702C5.24919 2.16683 5.42856 2.16666 5.60278 2.20849C5.75584 2.24523 5.90216 2.30584 6.03636 2.38808C6.18913 2.4817 6.31585 2.60865 6.45958 2.75265L6.88509 3.17819C7.07487 3.36797 7.11441 3.40297 7.15313 3.4267C7.19786 3.45411 7.24664 3.47431 7.29765 3.48656C7.34181 3.49716 7.39452 3.50038 7.6629 3.50038L9.35444 3.50038C9.80336 3.50037 10.1705 3.50037 10.4689 3.52474C10.7777 3.54998 11.0566 3.6038 11.3171 3.73653C11.7248 3.94425 12.0563 4.27571 12.264 4.6834C12.3967 4.94389 12.4506 5.22282 12.4758 5.53166C12.4909 5.71644 12.4966 5.92759 12.4988 6.16819C12.8506 6.17059 13.1517 6.17806 13.4046 6.20126C13.7799 6.23569 14.1328 6.30995 14.4205 6.52025C14.8419 6.82826 15.1121 7.30132 15.1632 7.8208C15.1981 8.17548 15.0828 8.51714 14.9217 8.85788C14.7617 9.19641 14.5189 9.60803 14.2188 10.1165L12.9073 12.3396C12.6618 12.7561 12.4828 13.0599 12.2275 13.2867C12.0025 13.4866 11.7385 13.6374 11.4521 13.7296C11.1269 13.8342 10.7744 13.834 10.2908 13.8337L4.51029 13.8337C4.45944 13.8337 4.40935 13.8337 4.36003 13.8337ZM5.00409 3.16704C5.27248 3.16704 5.32518 3.17026 5.36934 3.18086C5.42036 3.19311 5.46913 3.21331 5.51387 3.24072C5.55259 3.26445 5.59213 3.29945 5.78191 3.48923L6.20742 3.91477C6.35114 4.05876 6.47786 4.18572 6.63063 4.27934C6.76484 4.36158 6.91115 4.42219 7.06421 4.45893C7.23843 4.50076 7.4178 4.50059 7.62125 4.5004L9.3335 4.50038C9.80846 4.50038 10.1346 4.50077 10.3874 4.52142C10.6344 4.5416 10.7671 4.57861 10.8632 4.62754C11.0827 4.73939 11.2612 4.91786 11.373 5.13739C11.4219 5.23341 11.4589 5.3661 11.4791 5.6131C11.4916 5.76557 11.4967 5.9447 11.4987 6.16706L5.41838 6.16702C5.03978 6.16673 4.74226 6.1665 4.46666 6.25519C4.2243 6.33318 4.00085 6.46079 3.81053 6.62989C3.5941 6.82219 3.44312 7.07855 3.25098 7.40477L2.02529 9.48229C1.95871 9.59513 1.89471 9.7036 1.8335 9.80792V5.33371C1.8335 4.85875 1.83389 4.5326 1.85454 4.27976C1.87472 4.03276 1.91173 3.90008 1.96066 3.80405C2.07251 3.58453 2.25099 3.40605 2.47051 3.2942C2.56653 3.24527 2.69922 3.20827 2.94622 3.18809C3.19905 3.16743 3.5252 3.16704 4.00016 3.16704H5.00409ZM6.00411 12.8337C6.0028 12.8337 6.00148 12.8337 6.00016 12.8337H4.40263C3.77462 12.8335 3.32475 12.831 2.98305 12.7997C2.61469 12.7659 2.4557 12.7037 2.37002 12.6411C2.14015 12.4731 1.99279 12.215 1.9649 11.9317C1.95451 11.8261 1.98173 11.6575 2.1398 11.3231C2.29662 10.9913 2.54474 10.5698 2.89965 9.96824L4.07837 7.97042C4.32097 7.55924 4.39089 7.45194 4.47474 7.37744C4.56125 7.30057 4.66282 7.24257 4.77298 7.20712C4.87975 7.17276 5.0077 7.16706 5.48511 7.16706H11.9378C12.5598 7.16706 12.9915 7.16756 13.3132 7.19708C13.6378 7.22686 13.7667 7.28103 13.8304 7.3276C14.022 7.46761 14.1448 7.68263 14.168 7.91876C14.1758 7.9973 14.1569 8.13583 14.0176 8.43054C13.8796 8.7226 13.6606 9.09472 13.3446 9.63037L12.0834 11.768C11.7843 12.2748 11.6862 12.43 11.5633 12.5392C11.4421 12.6468 11.3 12.728 11.1457 12.7776C10.9892 12.828 10.8057 12.8337 10.2173 12.8337H6.00411Z'),
						$elm$svg$Svg$Attributes$fill('#1777DE')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Card$HeaderIconLeft = function (a) {
	return {$: 'HeaderIconLeft', a: a};
};
var $author$project$Ui$V3$Card$headerIconLeft = function (icon) {
	return $author$project$Ui$V3$Card$HeaderIconLeft(icon);
};
var $author$project$Ui$V3$Stack$PaddingBottom = function (a) {
	return {$: 'PaddingBottom', a: a};
};
var $author$project$Ui$V3$Stack$paddingBottom = A2($elm$core$Basics$composeL, $author$project$Ui$V3$Stack$PaddingAttribute, $author$project$Ui$V3$Stack$PaddingBottom);
var $author$project$Ui$V3$Card$VisibleOverflow = {$: 'VisibleOverflow'};
var $author$project$Ui$V3$Card$visibleOverflow = $author$project$Ui$V3$Card$VisibleOverflow;
var $author$project$Components$DocumentBatchGroupingReviewPage$groupCard = F4(
	function (data, model, groupType, localDocumentGroup) {
		var visibleGroupIndex = function () {
			switch (groupType.$) {
				case 'UngroupedDocuments':
					return $elm$core$Maybe$Nothing;
				case 'GroupedDocuments':
					var visibleIndex = groupType.a;
					return $elm$core$Maybe$Just(visibleIndex);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var title = function () {
			switch (groupType.$) {
				case 'UngroupedDocuments':
					return 'Ungrouped';
				case 'GroupedDocuments':
					var viewIndex = groupType.a;
					return 'Group ' + $elm$core$String$fromInt(viewIndex + 1);
				default:
					return 'New Group';
			}
		}();
		var selectedGroupDocumentId = $author$project$Components$DocumentBatchGroupingReviewPage$firstCurrentlySelectedCard(model);
		var mergeButtonIfApplicable = ($author$project$Components$DocumentBatchGroupingReviewPage$numberOfCardsSelected(model) === 2) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$DocumentBatchGroupingReviewPage$MergeSelectedDocuments)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeXSmall),
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
						]),
					'Merge'))
			]) : _List_Nil;
		var menuContent = F2(
			function (groupableDocumentId, groupIndex) {
				return A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$mainAxisCenter,
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
							$author$project$Ui$V3$Stack$paddingBottom($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Components$DocumentBatchGroupingReviewPage$numberOfCardsSelected(model)) + ' Selected')),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$elm$html$Html$map,
									$author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenuMsg(groupableDocumentId.documentId),
									A2(
										$author$project$Components$DocumentBatchGroupingReviewPage$CardManagementMenu$view,
										{
											availableGroupIndices: $elm_community$list_extra$List$Extra$unique(
												A2(
													$elm$core$List$filterMap,
													function ($) {
														return $.groupIndex;
													},
													model.groupableDocumentIds)),
											groupIndex: groupIndex,
											visibleGroupIndex: visibleGroupIndex
										},
										groupableDocumentId.cardModel.cardManagementMenu)))
							]),
						mergeButtonIfApplicable));
			});
		var menu = function (groupableDocumentId) {
			if ($author$project$Components$DocumentBatchGroupingReviewPage$numberOfCardsSelected(model) > 1) {
				switch (groupType.$) {
					case 'UngroupedDocuments':
						return _Utils_eq(groupableDocumentId.groupIndex, $elm$core$Maybe$Nothing) ? A2(menuContent, groupableDocumentId, $elm$core$Maybe$Nothing) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
					case 'GroupedDocuments':
						return _Utils_eq(groupableDocumentId.groupIndex, localDocumentGroup.groupIndex) ? A2(menuContent, groupableDocumentId, groupableDocumentId.groupIndex) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
					default:
						return A2($elm$html$Html$div, _List_Nil, _List_Nil);
				}
			} else {
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			}
		};
		var dropSiteAttributes = A2(
			$elm$core$List$map,
			$author$project$Ui$V3$Stack$htmlAttribute,
			A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map(
					A2($elm$core$Basics$composeL, $author$project$Components$DocumentBatchGroupingReviewPage$DragDropMsg, $author$project$Components$DragDrop$DropSideMsg)),
				$author$project$Components$DragDrop$dropAttributes(
					$author$project$Components$DocumentBatchGroupingReviewPage$DropHandler$AddToGroup(localDocumentGroup.groupIndex))));
		var collapsibleAttributes = function () {
			switch (groupType.$) {
				case 'UngroupedDocuments':
					return _List_fromArray(
						[
							$author$project$Ui$V3$Card$collapsible(
							{
								collapseMsg: A2($author$project$Components$DocumentBatchGroupingReviewPage$ToggleGroupCollapse, $elm$core$Maybe$Nothing, !localDocumentGroup.isCollapsed),
								isCollapsed: localDocumentGroup.isCollapsed
							})
						]);
				case 'GroupedDocuments':
					return _List_fromArray(
						[
							$author$project$Ui$V3$Card$collapsible(
							{
								collapseMsg: A2($author$project$Components$DocumentBatchGroupingReviewPage$ToggleGroupCollapse, localDocumentGroup.groupIndex, !localDocumentGroup.isCollapsed),
								isCollapsed: localDocumentGroup.isCollapsed
							})
						]);
				default:
					return _List_Nil;
			}
		}();
		return A3(
			$author$project$Ui$V3$Card$view,
			{title: title},
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Ui$V3$Card$dividers(
						{isFullWidth: true}),
						$author$project$Ui$V3$Card$headerIconLeft($author$project$Ui$V3$Icon$folder16),
						$author$project$Ui$V3$Card$visibleOverflow,
						$author$project$Ui$V3$Card$headerNote(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'border-radius', '6px'),
									A2($elm$html$Html$Attributes$style, 'border', '1px solid #D8D8DC'),
									A2($elm$html$Html$Attributes$style, 'padding', '2px 8px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$elm$core$List$length(localDocumentGroup.documents)))
								])))
					]),
				collapsibleAttributes),
			_List_fromArray(
				[
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					A2($elm$html$Html$div, _List_Nil, _List_Nil),
					menu,
					selectedGroupDocumentId),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
								$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXXSmall)
							]),
						dropSiteAttributes),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (documentWithThumbnails) {
								return _Utils_Tuple2(
									$author$project$Ui$V3$Stack$fitPx(
										$elm$core$List$length(documentWithThumbnails.thumbnailUrls) * 140),
									A5($author$project$Components$DocumentBatchGroupingReviewPage$draggableDocumentElement, data, model, localDocumentGroup.groupIndex, visibleGroupIndex, documentWithThumbnails));
							},
							localDocumentGroup.documents),
						_List_fromArray(
							[
								A2($author$project$Components$DocumentBatchGroupingReviewPage$addAtEndDropSiteIfApplicable, model, localDocumentGroup)
							])))
				]));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$localDocumentsByDocumentId = F2(
	function (_v0, groupableDocumentIds) {
		var documentPagesByDocument = _v0.documentPagesByDocument;
		var documents = _v0.documents;
		var documentPagesForDocumentId = function (documentId) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						A2(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							false,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.documentId;
								},
								$elm$core$Basics$eq(documentId)))),
					documentPagesByDocument));
		};
		var thumbnailUrls = function (documentId) {
			return A2(
				$elm$core$List$map,
				function (documentPage) {
					return _Utils_Tuple2(documentPage.id, documentPage.thumbnailUrl);
				},
				documentPagesForDocumentId(documentId));
		};
		var cardModel = function (documentId) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Components$DocumentBatchGroupingReviewPage$DraggableDocumentCard$init,
				function ($) {
					return $.cardModel;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.documentId;
						},
						$elm$core$Basics$eq(documentId)),
					groupableDocumentIds));
		};
		var dictElement = function (document) {
			return _Utils_Tuple2(
				$author$project$Domain$DocumentId$toComparable(document.id),
				{
					cardModel: cardModel(document.id),
					document: document,
					thumbnailUrls: thumbnailUrls(document.id)
				});
		};
		return $elm$core$Dict$fromList(
			A2($elm$core$List$map, dictElement, documents));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$transformGroupableDocumentIdsToGroups = F2(
	function (documentsWithThumbnailsById, groupableDocumentIds) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var groupableDocumentId = _v0.a;
				var remainders = _v0.b;
				return {
					documents: A2(
						$elm$core$List$filterMap,
						function (_v1) {
							var documentId = _v1.documentId;
							return A2(
								$elm$core$Dict$get,
								$author$project$Domain$DocumentId$toComparable(documentId),
								documentsWithThumbnailsById);
						},
						A2($elm$core$List$cons, groupableDocumentId, remainders)),
					groupIndex: groupableDocumentId.groupIndex,
					isCollapsed: A2(
						$elm$core$List$all,
						function ($) {
							return $.isGroupCollapsed;
						},
						A2($elm$core$List$cons, groupableDocumentId, remainders))
				};
			},
			A2(
				$elm_community$list_extra$List$Extra$gatherEqualsBy,
				function ($) {
					return $.groupIndex;
				},
				groupableDocumentIds));
	});
var $author$project$Components$DocumentBatchGroupingReviewPage$view = F2(
	function (data, model) {
		var groupableDocumentIds = A3($author$project$Components$DocumentBatchGroupingReviewPage$allGroupableDocumentIds, data.documents, data.documentPagesByDocument, model.groupableDocumentIds);
		var documentsWithThumbnailsById = A2($author$project$Components$DocumentBatchGroupingReviewPage$localDocumentsByDocumentId, data, groupableDocumentIds);
		var documentGroups = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.groupIndex;
				},
				$elm$core$Maybe$withDefault(-1)),
			A2($author$project$Components$DocumentBatchGroupingReviewPage$transformGroupableDocumentIdsToGroups, documentsWithThumbnailsById, groupableDocumentIds));
		var groupedDocuments = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.groupIndex;
				},
				$elm_community$maybe_extra$Maybe$Extra$isJust),
			documentGroups);
		var nextGroupIndex = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			0,
			$elm$core$Basics$add(1),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.groupIndex;
				},
				$elm_community$list_extra$List$Extra$last(documentGroups)));
		var nextGroupDragTarget = $elm_community$maybe_extra$Maybe$Extra$isJust(
			$author$project$Components$DragDrop$currentlyDragging(model.dragDrop)) ? A4(
			$author$project$Components$DocumentBatchGroupingReviewPage$groupCard,
			data,
			model,
			$author$project$Components$DocumentBatchGroupingReviewPage$NewGroup,
			{
				documents: _List_Nil,
				groupIndex: $elm$core$Maybe$Just(nextGroupIndex),
				isCollapsed: false
			}) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
		var ungroupedDocuments = A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.groupIndex;
				},
				$elm_community$maybe_extra$Maybe$Extra$isNothing),
			documentGroups);
		if (model.updating) {
			return A2(
				$author$project$Ui$V3$Skeleton$viewCustom,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border-radius', '0')
					]),
				{height: $elm$core$Maybe$Nothing});
		} else {
			var _v0 = model.documentPreview;
			if (_v0.$ === 'PreviewingDocument') {
				var documentsBrowser = _v0.b;
				return A2($author$project$Components$DocumentBatchGroupingReviewPage$documentsBrowserPanel, data, documentsBrowser);
			} else {
				return A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium),
							A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Gray150),
							$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceSmall),
							$author$project$Ui$V3$Stack$onClick($author$project$Components$DocumentBatchGroupingReviewPage$BackgroundClick)
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$V3$Stack$viewHorzWithWidths,
										_List_fromArray(
											[$author$project$Ui$V3$Stack$crossAxisBottom]),
										_List_fromArray(
											[
												_Utils_Tuple2(
												$author$project$Ui$V3$Stack$flex1,
												A2(
													$elm$html$Html$h3,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Group Documents')
														]))),
												_Utils_Tuple2(
												$author$project$Ui$V3$Stack$fit,
												A3(
													$author$project$Ui$V3$Button$view,
													{
														action: $author$project$Ui$V3$Button$onClick($author$project$Components$DocumentBatchGroupingReviewPage$SubmitGroups)
													},
													_List_fromArray(
														[
															$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
															$author$project$Ui$V3$Button$disabled(
															$elm_community$maybe_extra$Maybe$Extra$isJust(ungroupedDocuments))
														]),
													'Continue'))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray300)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Right click thumbnails to view full size document')
											]))
									])),
								A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								A2($elm$html$Html$div, _List_Nil, _List_Nil),
								A3($author$project$Components$DocumentBatchGroupingReviewPage$groupCard, data, model, $author$project$Components$DocumentBatchGroupingReviewPage$UngroupedDocuments),
								ungroupedDocuments)
							]),
						_Utils_ap(
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (viewIndex, group) {
										return A4(
											$author$project$Components$DocumentBatchGroupingReviewPage$groupCard,
											data,
											model,
											$author$project$Components$DocumentBatchGroupingReviewPage$GroupedDocuments(viewIndex),
											group);
									}),
								groupedDocuments),
							_List_fromArray(
								[nextGroupDragTarget]))));
			}
		}
	});
var $author$project$Components$DocumentBatchReviewPage$viewChildPanel = F2(
	function (data, model) {
		var _v0 = model.childModel;
		var childModel = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$DocumentBatchReviewPage$DocumentBatchGroupingReviewPageMsg,
			A2($author$project$Components$DocumentBatchGroupingReviewPage$view, data, childModel));
	});
var $author$project$Components$DocumentBatchReviewPage$scrollableChildPanel = F2(
	function (data, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorz,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
					$author$project$Ui$V3$Stack$crossAxisStretch,
					A2($author$project$Ui$V3$Stack$style, 'height', '97vh'),
					A2($author$project$Ui$V3$Stack$style, 'overflow-y', 'auto')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$DocumentBatchReviewPage$viewChildPanel, data, model)
				]));
	});
var $author$project$Components$DocumentBatchReviewPage$viewLoaded = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer'),
					$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Gray100)
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$mainAxisSpaceBetween,
								$author$project$Ui$V3$Stack$crossAxisStretch,
								A2($author$project$Ui$V3$Stack$paddingVertHorz, $author$project$Ui$V3$Stack$spaceMedium, $author$project$Ui$V3$Stack$spaceMedium),
								A2($author$project$Ui$V3$Stack$style, 'height', '97vh'),
								A2($author$project$Ui$V3$Stack$style, 'overflow-y', 'auto')
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2($author$project$Components$DocumentBatchReviewPage$scrollableChildPanel, data, model)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2($author$project$Components$DocumentBatchReviewPage$documentsBrowserPanel, model, data))
							])))
				]));
	});
var $author$project$Components$DocumentBatchReviewPage$view = F2(
	function (remoteData, model) {
		return A2(
			$author$project$Forward$LoadingView$viewV3Reskin,
			$author$project$Components$DocumentBatchReviewPage$viewLoaded(model),
			remoteData);
	});
var $author$project$Ui$V3$Stack$CrossAxisTop = {$: 'CrossAxisTop'};
var $author$project$Ui$V3$Stack$crossAxisTop = $author$project$Ui$V3$Stack$CrossAxisAttribute($author$project$Ui$V3$Stack$CrossAxisTop);
var $author$project$Components$DocumentGroupLoadReviewPage$documentsBrowserPanel = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$DocumentGroupLoadReviewPage$DocumentsBrowserMsg,
			A2(
				$author$project$Forward$LoadingView$view,
				A3($author$project$Components$DocumentsBrowser$view, $elm$time$Time$utc, model.documentsBrowser, _List_Nil),
				data.documentsBrowserData));
	});
var $author$project$Ui$V3$Stack$flex2 = $author$project$Ui$V3$Stack$Basis('flex-2');
var $author$project$Ui$V3$Stack$flex3 = $author$project$Ui$V3$Stack$Basis('flex-3');
var $author$project$Components$DocumentGroupLoadReviewPage$headerPanel = function (_v0) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_Nil);
};
var $author$project$Components$DocumentGroupLoadReviewPage$ExtractedCarrier = {$: 'ExtractedCarrier'};
var $author$project$Components$DocumentGroupLoadReviewPage$LoadCarrier = {$: 'LoadCarrier'};
var $author$project$Components$DocumentGroupLoadReviewPage$SetCarrierChoice = function (a) {
	return {$: 'SetCarrierChoice', a: a};
};
var $author$project$Components$DocumentGroupLoadReviewPage$UnknownCarrier = {$: 'UnknownCarrier'};
var $author$project$Ui$V3$Notification$Column = {$: 'Column'};
var $author$project$Ui$V3$Notification$column = $author$project$Ui$V3$Notification$Column;
var $author$project$Components$DocumentGroupLoadReviewPage$viewCarrierRadioOption = F5(
	function (_v0, onClickMsg, isChecked, labelText, detailView) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
					A2($elm$html$Html$Attributes$style, 'gap', '8px'),
					A2($elm$html$Html$Attributes$style, 'padding', '8px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					isChecked ? 'rgba(255,255,255,0.5)' : 'transparent')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$name('carrier-choice'),
							$elm$html$Html$Attributes$checked(isChecked),
							$elm$html$Html$Events$onClick(onClickMsg),
							A2($elm$html$Html$Attributes$style, 'margin-top', '3px'),
							A2($elm$html$Html$Attributes$style, 'flex-shrink', '0')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase'),
									A2($elm$html$Html$Attributes$style, 'letter-spacing', '0.05em'),
									A2($elm$html$Html$Attributes$style, 'opacity', '0.7'),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '2px')
								]),
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, labelText)
								])),
							detailView
						]))
				]));
	});
var $author$project$Components$DocumentGroupLoadReviewPage$PerformCarrierSearch = {$: 'PerformCarrierSearch'};
var $author$project$Components$DocumentGroupLoadReviewPage$UpdateCarrierSearchTerm = function (a) {
	return {$: 'UpdateCarrierSearchTerm', a: a};
};
var $author$project$Ui$V3$Input$ActiveAttribute = function (a) {
	return {$: 'ActiveAttribute', a: a};
};
var $author$project$Ui$V3$Input$active = $author$project$Ui$V3$Input$ActiveAttribute;
var $author$project$Components$DocumentGroupLoadReviewPage$SelectSearchedCarrier = function (a) {
	return {$: 'SelectSearchedCarrier', a: a};
};
var $author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSummary = function (carrier) {
	var identifiers = A2(
		$elm$core$String$join,
		'  ·  ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (mc) {
						return 'MC# ' + mc;
					},
					carrier.mcNumber),
					A2(
					$elm$core$Maybe$map,
					function (scac) {
						return 'SCAC ' + scac;
					},
					carrier.scac),
					A3(
					$elm$core$Maybe$map2,
					F2(
						function (city, state) {
							return city + (', ' + state);
						}),
					carrier.city,
					carrier.state)
				])));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, carrier.name)
					])),
				$elm$core$String$isEmpty(identifiers) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '2px')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$xSmallBody, _List_Nil, identifiers)
					]))
			]));
};
var $author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSearchResult = F3(
	function (maybeSelected, index, carrier) {
		var isSelected = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.id;
					},
					$elm$core$Basics$eq(carrier.id)),
				maybeSelected));
		var baseBackground = (!A2($elm$core$Basics$modBy, 2, index)) ? '#fff' : '#f7f7f7';
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Components$DocumentGroupLoadReviewPage$SelectSearchedCarrier(carrier)),
					A2($elm$html$Html$Attributes$style, 'padding', '6px 10px'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					A2($elm$html$Html$Attributes$style, 'color', '#333'),
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					isSelected ? '#cce5ff' : baseBackground)
				]),
			_List_fromArray(
				[
					$author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSummary(carrier)
				]));
	});
var $author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSearch = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-top', '8px'),
				A2($elm$html$Html$Attributes$style, 'margin-left', '20px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Events$preventDefaultOn,
						'submit',
						$elm$json$Json$Decode$succeed(
							_Utils_Tuple2($author$project$Components$DocumentGroupLoadReviewPage$PerformCarrierSearch, true)))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{onInput: $author$project$Components$DocumentGroupLoadReviewPage$UpdateCarrierSearchTerm},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$placeholder('Search by carrier name'),
										$author$project$Ui$V3$Input$active(true)
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', '100%')
									]),
								model.carrierSearchTerm),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'flex', '0 0 auto')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$V3$Button$view,
										{
											action: $author$project$Ui$V3$Button$onClick($author$project$Components$DocumentGroupLoadReviewPage$PerformCarrierSearch)
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
												A2($author$project$Ui$V3$Button$cssStyle, 'padding', '6px 12px')
											]),
										'Search')
									]))
							]))
					])),
				function () {
				var _v0 = model.carrierSearchResults;
				switch (_v0.$) {
					case 'NotAsked':
						return A2($elm$html$Html$div, _List_Nil, _List_Nil);
					case 'Loading':
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-top', '4px'),
									A2($elm$html$Html$Attributes$style, 'color', '#555')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Searching...')
								]));
					case 'Failure':
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-top', '4px'),
									A2($elm$html$Html$Attributes$style, 'color', '#721c24')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Error searching for carriers. Please try again.')
								]));
					default:
						var carriers = _v0.a;
						return $elm$core$List$isEmpty(carriers) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-top', '4px'),
									A2($elm$html$Html$Attributes$style, 'color', '#555')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No carriers found.')
								])) : A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'list-style', 'none'),
									A2($elm$html$Html$Attributes$style, 'margin', '4px 0 0 0'),
									A2($elm$html$Html$Attributes$style, 'padding', '0'),
									A2($elm$html$Html$Attributes$style, 'border', '1px solid #ccc'),
									A2($elm$html$Html$Attributes$style, 'border-radius', '3px'),
									A2($elm$html$Html$Attributes$style, 'background', '#fff'),
									A2($elm$html$Html$Attributes$style, 'max-height', '180px'),
									A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto')
								]),
							A2(
								$elm$core$List$indexedMap,
								$author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSearchResult(model.selectedSearchedCarrier),
								carriers));
				}
			}()
			]));
};
var $author$project$Components$DocumentGroupLoadReviewPage$carrierValidationPanel = function (model) {
	var _v0 = $author$project$Components$DocumentGroupLoadReviewPage$getSelectedLoadAndExtractedCarrier(model);
	if (_v0.$ === 'Nothing') {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		var extractedCarrier = _v0.a.extractedCarrier;
		var loadCarrier = _v0.a.loadCarrier;
		var mismatchPanel = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__notification v3__notification--inline v3__notification--error')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__notification-text v3__notification-text--column'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'stretch')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__notification-text-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Carrier mismatch: Which carrier is correct?')
								])),
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									function () {
									if (loadCarrier.$ === 'Nothing') {
										return $elm$core$Maybe$Nothing;
									} else {
										var lc = loadCarrier.a;
										return $elm$core$Maybe$Just(
											A5(
												$author$project$Components$DocumentGroupLoadReviewPage$viewCarrierRadioOption,
												model,
												$author$project$Components$DocumentGroupLoadReviewPage$SetCarrierChoice($author$project$Components$DocumentGroupLoadReviewPage$LoadCarrier),
												_Utils_eq(
													model.carrierChoice,
													$elm$core$Maybe$Just($author$project$Components$DocumentGroupLoadReviewPage$LoadCarrier)),
												'Load carrier',
												$author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSummary(lc)));
									}
								}(),
									function () {
									if (extractedCarrier.$ === 'Nothing') {
										return $elm$core$Maybe$Nothing;
									} else {
										var ec = extractedCarrier.a;
										return $elm$core$Maybe$Just(
											A5(
												$author$project$Components$DocumentGroupLoadReviewPage$viewCarrierRadioOption,
												model,
												$author$project$Components$DocumentGroupLoadReviewPage$SetCarrierChoice($author$project$Components$DocumentGroupLoadReviewPage$ExtractedCarrier),
												_Utils_eq(
													model.carrierChoice,
													$elm$core$Maybe$Just($author$project$Components$DocumentGroupLoadReviewPage$ExtractedCarrier)),
												'Extracted carrier',
												$author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSummary(ec)));
									}
								}(),
									$elm$core$Maybe$Just(
									A5(
										$author$project$Components$DocumentGroupLoadReviewPage$viewCarrierRadioOption,
										model,
										$author$project$Components$DocumentGroupLoadReviewPage$SetCarrierChoice($author$project$Components$DocumentGroupLoadReviewPage$UnknownCarrier),
										_Utils_eq(
											model.carrierChoice,
											$elm$core$Maybe$Just($author$project$Components$DocumentGroupLoadReviewPage$UnknownCarrier)),
										'Unknown / Multiple carriers',
										$elm$html$Html$text(''))),
									$elm$core$Maybe$Just(
									A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A5(
												$author$project$Components$DocumentGroupLoadReviewPage$viewCarrierRadioOption,
												model,
												$author$project$Components$DocumentGroupLoadReviewPage$SetCarrierChoice($author$project$Components$DocumentGroupLoadReviewPage$SearchedCarrier),
												_Utils_eq(
													model.carrierChoice,
													$elm$core$Maybe$Just($author$project$Components$DocumentGroupLoadReviewPage$SearchedCarrier)),
												'Search for a different carrier',
												$elm$html$Html$text('')),
												_Utils_eq(
												model.carrierChoice,
												$elm$core$Maybe$Just($author$project$Components$DocumentGroupLoadReviewPage$SearchedCarrier)) ? $author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSearch(model) : $elm$html$Html$text('')
											])))
								]))))
				]));
		if (extractedCarrier.$ === 'Nothing') {
			return mismatchPanel;
		} else {
			var ec = extractedCarrier.a;
			var carriersMatch = function () {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.id;
					},
					loadCarrier);
				if (_v2.$ === 'Just') {
					var loadCarrierId = _v2.a;
					return _Utils_eq(
						$elm$core$Maybe$Just(loadCarrierId),
						ec.id);
				} else {
					return false;
				}
			}();
			return $elm$core$String$isEmpty(ec.name) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : (carriersMatch ? A2(
				$author$project$Ui$V3$Notification$viewInline,
				{
					message: $author$project$Components$DocumentGroupLoadReviewPage$viewCarrierSummary(ec),
					onClose: $elm$core$Maybe$Nothing,
					title: $elm$core$Maybe$Just('Load carrier matches extracted carrier')
				},
				_List_fromArray(
					[$author$project$Ui$V3$Notification$success, $author$project$Ui$V3$Notification$column])) : mismatchPanel);
		}
	}
};
var $author$project$Components$LoadPicker$isShowingSearch = function (model) {
	var _v0 = model.state;
	if (_v0.$ === 'ShowingSearch') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$DocumentGroupLoadReviewPage$SubmitLoadAssignment = {$: 'SubmitLoadAssignment'};
var $author$project$Components$DocumentGroupLoadReviewPage$submitButton = function (model) {
	var hasSelection = !_Utils_eq(model.loadPicker.selectedLoadStateId, $elm$core$Maybe$Nothing);
	var hasCarrierMismatch = $author$project$Components$DocumentGroupLoadReviewPage$isMismatchPanelVisible(model);
	var needsCarrierChoice = hasCarrierMismatch && (_Utils_eq(model.carrierChoice, $elm$core$Maybe$Nothing) || (_Utils_eq(
		model.carrierChoice,
		$elm$core$Maybe$Just($author$project$Components$DocumentGroupLoadReviewPage$SearchedCarrier)) && _Utils_eq(model.selectedSearchedCarrier, $elm$core$Maybe$Nothing)));
	var isDisabled = needsCarrierChoice;
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick($author$project$Components$DocumentGroupLoadReviewPage$SubmitLoadAssignment)
		},
		A2(
			$elm$core$List$cons,
			$author$project$Ui$V3$Button$disabled(isDisabled),
			(!hasSelection) ? _List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorDanger),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
				]) : _List_Nil),
		hasSelection ? 'Submit Load Assignment' : 'Submit Without Load Assignment');
};
var $author$project$Components$DocumentGroupLoadReviewPage$submitButtonPanel = function (model) {
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[$author$project$Ui$V3$Stack$mainAxisEnd]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				$author$project$Components$DocumentGroupLoadReviewPage$submitButton(model))
			]));
};
var $author$project$Components$DocumentGroupLoadReviewPage$tipsNotification = A2(
	$author$project$Ui$V3$Notification$viewInline,
	{
		message: A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin', '0'),
					A2($elm$html$Html$Attributes$style, 'padding-left', '20px'),
					A2($elm$html$Html$Attributes$style, 'font-size', '12px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hover over a reference value to highlight matching text in the document.')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Click a reference value to jump to the next page with matching text.')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Double-click a page line in the document browser to autofill the Load and Carrier search fields.')
						]))
				])),
		onClose: $elm$core$Maybe$Nothing,
		title: $elm$core$Maybe$Just('Tips')
	},
	_List_fromArray(
		[$author$project$Ui$V3$Notification$info]));
var $author$project$Ui$V3$Colors$Blue150 = {$: 'Blue150'};
var $author$project$Components$LoadPicker$SelectLoad = function (a) {
	return {$: 'SelectLoad', a: a};
};
var $author$project$Components$LoadPicker$formatDestination = function (load) {
	var parts = A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		_List_fromArray(
			[load.destinationCity, load.destinationState]));
	return A2($elm$core$String$join, ', ', parts);
};
var $author$project$Components$LoadPicker$formatOrigin = function (load) {
	var parts = A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		_List_fromArray(
			[load.originCity, load.originState]));
	return A2($elm$core$String$join, ', ', parts);
};
var $author$project$Ui$V3$Table$RowAttributes = function (a) {
	return {$: 'RowAttributes', a: a};
};
var $author$project$Ui$V3$Table$rowAttributes = $author$project$Ui$V3$Table$RowAttributes;
var $author$project$Components$LoadPicker$buildAllReferences = function (load) {
	var customerRef = function () {
		var _v0 = load.customer;
		if (_v0.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var customer = _v0.a;
			var customerValue = (!$elm$core$String$isEmpty(customer.name)) ? customer.name : customer.externalId;
			return $elm$core$String$isEmpty(customerValue) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2('Customer', customerValue)
				]);
		}
	}();
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
		$elm$core$List$concat(
			_List_fromArray(
				[
					customerRef,
					_List_fromArray(
					[
						_Utils_Tuple2(
						'Office',
						A2($elm$core$Maybe$withDefault, '', load.office))
					]),
					load.visibleReferences,
					_List_fromArray(
					[
						_Utils_Tuple2(
						'Origin',
						$author$project$Components$LoadPicker$formatOrigin(load)),
						_Utils_Tuple2(
						'Destination',
						$author$project$Components$LoadPicker$formatDestination(load))
					])
				])));
};
var $author$project$Components$LoadPicker$ClickReferenceValue = function (a) {
	return {$: 'ClickReferenceValue', a: a};
};
var $author$project$Components$LoadPicker$HoverReferenceValue = function (a) {
	return {$: 'HoverReferenceValue', a: a};
};
var $author$project$Components$LoadPicker$hoverableValue = F2(
	function (value, hoveredValue) {
		return $elm$core$String$isEmpty(value) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$span,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding', '2px 4px'),
						A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
						$elm$html$Html$Events$onMouseEnter(
						$author$project$Components$LoadPicker$HoverReferenceValue(
							$elm$core$Maybe$Just(value))),
						$elm$html$Html$Events$onMouseLeave(
						$author$project$Components$LoadPicker$HoverReferenceValue($elm$core$Maybe$Nothing)),
						$elm$html$Html$Events$onClick(
						$author$project$Components$LoadPicker$ClickReferenceValue(value))
					]),
				_Utils_eq(
					hoveredValue,
					$elm$core$Maybe$Just(value)) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'background',
						A2($author$project$Ui$V3$Colors$cssVariableWithOpacity, 0.3, $author$project$Ui$V3$Colors$Teal600)),
						A2(
						$elm$html$Html$Attributes$style,
						'border',
						'1px solid ' + A2($author$project$Ui$V3$Colors$cssVariableWithOpacity, 0.3, $author$project$Ui$V3$Colors$Teal600))
					]) : _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border', '1px solid transparent')
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Components$LoadPicker$viewReferenceTableRow = F2(
	function (hoveredValue, _v0) {
		var refType = _v0.a;
		var refValue = _v0.b;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(refType)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$LoadPicker$hoverableValue, refValue, hoveredValue)
						]))
				]));
	});
var $author$project$Components$LoadPicker$viewReferenceSubRow = F3(
	function (selectedLoadStateId, hoveredValue, loadState) {
		if (!_Utils_eq(
			selectedLoadStateId,
			$elm$core$Maybe$Just(loadState.id))) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = $author$project$Components$LoadPicker$buildAllReferences(loadState.load);
			if (!_v0.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var allRefs = _v0;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$colspan(5)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('import-detail__reference-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('References')
										])),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__info-table load-detail__info-table--vertical')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Components$LoadPicker$viewReferenceTableRow(hoveredValue),
												allRefs))
										]))
								]))
						]));
			}
		}
	});
var $author$project$Components$LoadPicker$viewLoadTable = F4(
	function (firstLoad, rest, selectedLoadStateId, hoveredValue) {
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.load;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.loadId;
								},
								$elm$html$Html$text)),
						heading: $elm$html$Html$text('Load ID')
					},
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.load;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.carrier;
								},
								A2(
									$elm$core$Basics$composeR,
									A2(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										'',
										function ($) {
											return $.name;
										}),
									$elm$html$Html$text))),
						heading: $elm$html$Html$text('Carrier')
					},
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.load;
							},
							A2($elm$core$Basics$composeR, $author$project$Components$LoadPicker$formatOrigin, $elm$html$Html$text)),
						heading: $elm$html$Html$text('Origin')
					},
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.load;
							},
							A2($elm$core$Basics$composeR, $author$project$Components$LoadPicker$formatDestination, $elm$html$Html$text)),
						heading: $elm$html$Html$text('Destination')
					},
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.invoiceNumber;
							},
							$elm$html$Html$text),
						heading: $elm$html$Html$text('Invoice #')
					}
					])
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$clickable(
					{
						onClick: function (loadState) {
							return _Utils_eq(
								selectedLoadStateId,
								$elm$core$Maybe$Just(loadState.id)) ? $author$project$Components$LoadPicker$SelectLoad($elm$core$Maybe$Nothing) : $author$project$Components$LoadPicker$SelectLoad(
								$elm$core$Maybe$Just(loadState.id));
						}
					}),
					$author$project$Ui$V3$Table$rowAttributes(
					function (loadState) {
						return _Utils_eq(
							selectedLoadStateId,
							$elm$core$Maybe$Just(loadState.id)) ? _List_fromArray(
							[
								$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Blue150),
								A2(
								$elm$html$Html$Attributes$style,
								'border-left',
								'6px solid ' + $author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Blue500))
							]) : _List_Nil;
					}),
					$author$project$Ui$V3$Table$subRow(
					A2($author$project$Components$LoadPicker$viewReferenceSubRow, selectedLoadStateId, hoveredValue))
				]),
			_List_Nil,
			A2($elm$core$List$cons, firstLoad, rest));
	});
var $author$project$Components$LoadPicker$viewNoGuessedLoads = $elm$html$Html$text('');
var $author$project$Components$LoadPicker$CancelSearch = {$: 'CancelSearch'};
var $author$project$Components$LoadPicker$PerformSearch = {$: 'PerformSearch'};
var $author$project$Components$LoadPicker$UpdateSearchTerm = function (a) {
	return {$: 'UpdateSearchTerm', a: a};
};
var $author$project$Components$LoadPicker$onFormSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Components$LoadPicker$viewSearchForm = function (search) {
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$author$project$Components$LoadPicker$onFormSubmit($author$project$Components$LoadPicker$PerformSearch)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('large-12 columns')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{onInput: $author$project$Components$LoadPicker$UpdateSearchTerm},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$placeholder('Enter load ID, reference, or other identifying information'),
										$author$project$Ui$V3$Input$disabled(
										_Utils_eq(search.searchResults, $krisajenkins$remotedata$RemoteData$Loading)),
										$author$project$Ui$V3$Input$active(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('id-or-reference'),
										A2($elm$html$Html$Attributes$attribute, 'autoFocus', 'true')
									]),
								search.searchTerm)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '15px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('large-5 columns')
							]),
						_List_fromArray(
							[
								_Utils_eq(search.searchResults, $krisajenkins$remotedata$RemoteData$Loading) ? A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$disabled(true),
										$elm$html$Html$Attributes$class('small')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Searching...')
									])) : A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('submit'),
												$elm$html$Html$Attributes$class('button--confirmation')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Search')
											])),
										$elm$html$Html$text(' '),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('or ')
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$Components$LoadPicker$CancelSearch)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('cancel')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$LoadPicker$viewSearchResults = F3(
	function (search, selectedLoadStateId, hoveredValue) {
		var _v0 = search.searchResults;
		switch (_v0.$) {
			case 'NotAsked':
				return $elm$html$Html$text('');
			case 'Loading':
				return $elm$html$Html$text('Searching for loads...');
			case 'Success':
				var loads = _v0.a;
				if (!loads.b) {
					return $elm$html$Html$text('No loads found matching your search terms.');
				} else {
					var firstLoad = loads.a;
					var rest = loads.b;
					return A4($author$project$Components$LoadPicker$viewLoadTable, firstLoad, rest, selectedLoadStateId, hoveredValue);
				}
			default:
				var error = _v0.a;
				return $elm$html$Html$text('Error searching for loads: ' + error);
		}
	});
var $author$project$Components$LoadPicker$viewSearchArea = F3(
	function (search, selectedLoadStateId, hoveredValue) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					$author$project$Components$LoadPicker$viewSearchForm(search),
					A3($author$project$Components$LoadPicker$viewSearchResults, search, selectedLoadStateId, hoveredValue)
				]));
	});
var $author$project$Components$LoadPicker$viewContent = F2(
	function (_v0, model) {
		var _v1 = model.state;
		if (_v1.$ === 'ShowingGuessed') {
			var _v2 = model.guessedLoads;
			if (!_v2.b) {
				return $author$project$Components$LoadPicker$viewNoGuessedLoads;
			} else {
				var firstLoad = _v2.a;
				var rest = _v2.b;
				return A4($author$project$Components$LoadPicker$viewLoadTable, firstLoad, rest, model.selectedLoadStateId, model.hoveredValue);
			}
		} else {
			var search = _v1.a;
			return A3($author$project$Components$LoadPicker$viewSearchArea, search, model.selectedLoadStateId, model.hoveredValue);
		}
	});
var $author$project$Components$LoadPicker$ShowSearch = {$: 'ShowSearch'};
var $author$project$Components$LoadPicker$viewInstructions = function (model) {
	var _v0 = model.state;
	if (_v0.$ === 'ShowingGuessed') {
		return $elm$core$List$isEmpty(model.guessedLoads) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No Loads Found '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Components$LoadPicker$ShowSearch),
							A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
							A2($elm$html$Html$Attributes$style, 'color', 'blue'),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Search for another one')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Components$LoadPicker$ShowSearch),
							A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
							A2($elm$html$Html$Attributes$style, 'color', 'blue'),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Search for another load')
						]))
				]));
	} else {
		return A2($author$project$Ui$V3$Typography$body, _List_Nil, 'Search for loads to assign.');
	}
};
var $author$project$Components$DocumentGroupLoadReviewPage$loadPickerPanel = function (model) {
	var loadPickerConfig = {searchEndpoint: $author$project$Components$DocumentGroupLoadReviewPage$performLoadSearch};
	var loadPickerContent = A2(
		$elm$core$List$map,
		$elm$html$Html$map($author$project$Components$DocumentGroupLoadReviewPage$LoadPickerMsg),
		_List_fromArray(
			[
				$author$project$Components$LoadPicker$viewInstructions(model.loadPicker),
				A2($author$project$Components$LoadPicker$viewContent, loadPickerConfig, model.loadPicker)
			]));
	return A3(
		$author$project$Ui$V3$Card$view,
		{title: 'Load Assignment'},
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
					]),
				_Utils_ap(
					loadPickerContent,
					($author$project$Components$LoadPicker$isShowingSearch(model.loadPicker) && _Utils_eq(model.loadPicker.selectedLoadStateId, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[$author$project$Components$DocumentGroupLoadReviewPage$tipsNotification]) : _List_fromArray(
						[
							$author$project$Components$DocumentGroupLoadReviewPage$carrierValidationPanel(model),
							$author$project$Components$DocumentGroupLoadReviewPage$submitButtonPanel(model),
							$author$project$Components$DocumentGroupLoadReviewPage$tipsNotification
						])))
			]));
};
var $author$project$Components$DocumentGroupLoadReviewPage$viewChildPanel = F2(
	function (data, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertWithHeights,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$author$project$Components$DocumentGroupLoadReviewPage$headerPanel(data)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$author$project$Components$DocumentGroupLoadReviewPage$loadPickerPanel(model))
				]));
	});
var $author$project$Components$DocumentGroupLoadReviewPage$scrollableChildPanel = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'height', '96vh'),
					A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$DocumentGroupLoadReviewPage$viewChildPanel, data, model)
				]));
	});
var $author$project$Components$DocumentGroupLoadReviewPage$view = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[$author$project$Ui$V3$Stack$mainAxisSpaceBetween, $author$project$Ui$V3$Stack$crossAxisTop]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex2,
								A2($author$project$Components$DocumentGroupLoadReviewPage$scrollableChildPanel, data, model)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex3,
								A2($author$project$Components$DocumentGroupLoadReviewPage$documentsBrowserPanel, model, data))
							])))
				]));
	});
var $author$project$Components$DocumentGroupReviewPage$viewLoaded = F2(
	function (model, data) {
		var _v0 = model.childModel;
		var childModel = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$DocumentGroupReviewPage$DocumentGroupLoadReviewPageMsg,
			A2($author$project$Components$DocumentGroupLoadReviewPage$view, data, childModel));
	});
var $author$project$Components$DocumentGroupReviewPage$view = F2(
	function (remoteData, model) {
		return A2(
			$author$project$Forward$LoadingView$viewV3Reskin,
			$author$project$Components$DocumentGroupReviewPage$viewLoaded(model),
			remoteData);
	});
var $author$project$Components$DocumentReviewPage$documentsBrowserPanel = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$DocumentReviewPage$DocumentsBrowserMsg,
			A2(
				$author$project$Forward$LoadingView$view,
				A3($author$project$Components$DocumentsBrowser$view, $elm$time$Time$utc, model.documentsBrowser, _List_Nil),
				data.documentsBrowserData));
	});
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$ConfirmMatches = {$: 'ConfirmMatches'};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$ConfirmNoMatch = {$: 'ConfirmNoMatch'};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$buttonPanel = function (checkedValues) {
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$mainAxisEnd,
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$DocumentLoadReferenceMatchReviewPage$ConfirmNoMatch)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
							$author$project$Ui$V3$Button$disabled(
							!$elm$core$Set$isEmpty(checkedValues))
						]),
					'No matching references found')),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$DocumentLoadReferenceMatchReviewPage$ConfirmMatches)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$disabled(
							$elm$core$Set$isEmpty(checkedValues))
						]),
					'Submit'))
			]));
};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$instructionText = function (_v0) {
	return A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Check each reference that matches this load, or click \u0022No matching references found\u0022 if none match.')
			]));
};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$ToggleReferenceValue = F2(
	function (a, b) {
		return {$: 'ToggleReferenceValue', a: a, b: b};
	});
var $author$project$Ui$V3$Checkbox$ExtraPadding = function (a) {
	return {$: 'ExtraPadding', a: a};
};
var $author$project$Ui$V3$Checkbox$extraPadding = $author$project$Ui$V3$Checkbox$ExtraPadding;
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$ClickReferenceValue = function (a) {
	return {$: 'ClickReferenceValue', a: a};
};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$HoverReferenceValue = function (a) {
	return {$: 'HoverReferenceValue', a: a};
};
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$hoverableValue = F2(
	function (value, hoveredValue) {
		return $elm$core$String$isEmpty(value) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$span,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding', '2px 4px'),
						A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
						$elm$html$Html$Events$onMouseEnter(
						$author$project$Components$DocumentLoadReferenceMatchReviewPage$HoverReferenceValue(
							$elm$core$Maybe$Just(value))),
						$elm$html$Html$Events$onMouseLeave(
						$author$project$Components$DocumentLoadReferenceMatchReviewPage$HoverReferenceValue($elm$core$Maybe$Nothing)),
						$elm$html$Html$Events$onClick(
						$author$project$Components$DocumentLoadReferenceMatchReviewPage$ClickReferenceValue(value))
					]),
				_Utils_eq(
					hoveredValue,
					$elm$core$Maybe$Just(value)) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'background',
						A2($author$project$Ui$V3$Colors$cssVariableWithOpacity, 0.3, $author$project$Ui$V3$Colors$Teal600)),
						A2(
						$elm$html$Html$Attributes$style,
						'border',
						'1px solid ' + A2($author$project$Ui$V3$Colors$cssVariableWithOpacity, 0.3, $author$project$Ui$V3$Colors$Teal600))
					]) : _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border', '1px solid transparent')
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$loadReferencesTable = F3(
	function (tmsLoadDetails, checkedValues, hoveredValue) {
		var sortedReferences = A2(
			$elm$core$List$sortBy,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$map,
				function (ref) {
					return _Utils_Tuple2(ref.key, ref.value);
				},
				tmsLoadDetails.referenceFields));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Ui$V3$Table$view,
					{
						columns: _List_fromArray(
							[
								{
								attrs: _List_Nil,
								content: function (_v0) {
									var value = _v0.b;
									return A2(
										$author$project$Ui$V3$Checkbox$view,
										{
											checked: A2($elm$core$Set$member, value, checkedValues),
											label: $elm$html$Html$text(''),
											onCheck: $author$project$Components$DocumentLoadReferenceMatchReviewPage$ToggleReferenceValue(value)
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Checkbox$extraPadding(8)
											]));
								},
								heading: $elm$html$Html$text('Match?')
							},
								{
								attrs: _List_Nil,
								content: A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$html$Html$text),
								heading: $elm$html$Html$text('Reference')
							},
								{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$second,
									function (value) {
										return A2($author$project$Components$DocumentLoadReferenceMatchReviewPage$hoverableValue, value, hoveredValue);
									}),
								heading: $elm$html$Html$text('Value')
							}
							])
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Table$rowAttributes(
							function (_v1) {
								var value = _v1.b;
								return _List_fromArray(
									[
										$elm$html$Html$Events$onDoubleClick(
										A2(
											$author$project$Components$DocumentLoadReferenceMatchReviewPage$ToggleReferenceValue,
											value,
											!A2($elm$core$Set$member, value, checkedValues))),
										A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
									]);
							})
						]),
					_List_Nil,
					sortedReferences)
				]));
	});
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$referenceHintsNotification = A2(
	$author$project$Ui$V3$Notification$viewInline,
	{
		message: A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin', '0'),
					A2($elm$html$Html$Attributes$style, 'padding-left', '20px'),
					A2($elm$html$Html$Attributes$style, 'font-size', '12px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Double-click a row to toggle its checkbox.')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hover over a reference value to highlight matching text in the document.')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Click a reference value to jump to the next page with matching text.')
						]))
				])),
		onClose: $elm$core$Maybe$Nothing,
		title: $elm$core$Maybe$Just('Tips')
	},
	_List_fromArray(
		[$author$project$Ui$V3$Notification$info]));
var $author$project$Components$DocumentLoadReferenceMatchReviewPage$view = F2(
	function (data, model) {
		return A3(
			$author$project$Ui$V3$Card$view,
			{title: 'Load Reference Match Review'},
			_List_fromArray(
				[
					$author$project$Ui$V3$Card$dividers(
					{isFullWidth: false})
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVertWithHeights,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Components$DocumentLoadReferenceMatchReviewPage$instructionText(data)),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A3($author$project$Components$DocumentLoadReferenceMatchReviewPage$loadReferencesTable, data.tmsLoadDetails, model.checkedValues, model.hoveredValue)),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Components$DocumentLoadReferenceMatchReviewPage$buttonPanel(model.checkedValues)),
							_Utils_Tuple2($author$project$Ui$V3$Stack$fit, $author$project$Components$DocumentLoadReferenceMatchReviewPage$referenceHintsNotification)
						]))
				]));
	});
var $author$project$Components$DocumentTypeReviewPage$SelectDocumentType = function (a) {
	return {$: 'SelectDocumentType', a: a};
};
var $author$project$Components$DocumentTypeReviewPage$view = F2(
	function (data, _v0) {
		return A2(
			$elm$html$Html$map,
			function (pickerMsg) {
				if (pickerMsg.$ === 'Selected') {
					var docType = pickerMsg.b;
					return $author$project$Components$DocumentTypeReviewPage$SelectDocumentType(
						{documentType: docType, name: ''});
				} else {
					return $author$project$Components$DocumentTypeReviewPage$SelectDocumentType(
						{documentType: $author$project$AuditPb$DocumentTypeUnknown, name: ''});
				}
			},
			$author$project$Components$DocumentTypePicker$view(
				{
					currentType: $author$project$Domain$UnresolvedDocumentType$Unknown,
					enabledDocumentTypes: data.documentTypeSettings.enabledDocumentTypeNames,
					maybeDocumentId: $elm$core$Maybe$Just(data.documentTypeReview.documentId),
					showHotkeys: false
				}));
	});
var $author$project$Components$InvoiceAmountReviewPage$InvoiceAmountChanged = function (a) {
	return {$: 'InvoiceAmountChanged', a: a};
};
var $author$project$Components$InvoiceAmountReviewPage$Submit = {$: 'Submit'};
var $author$project$Components$InvoiceAmountReviewPage$SubmitNoInvoiceAmount = {$: 'SubmitNoInvoiceAmount'};
var $author$project$Helpers$Keypress$onEnter = function (action) {
	return A2(
		$elm$html$Html$Events$on,
		'keydown',
		A2(
			$elm$json$Json$Decode$andThen,
			function (code) {
				return (code === 'Enter') ? $elm$json$Json$Decode$succeed(action) : $elm$json$Json$Decode$fail('onEnter action ignored because code was not Enter');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
};
var $author$project$Components$InvoiceAmountReviewPage$invoiceAmountInputPanel = function (invoiceAmount) {
	var validValuePresent = $elm_community$maybe_extra$Maybe$Extra$isJust(invoiceAmount) && A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		false,
		A2($elm$core$Basics$composeL, $elm_community$maybe_extra$Maybe$Extra$isJust, $elm$core$String$toFloat),
		invoiceAmount);
	return $author$project$Helpers$Html$v3ReskinContainer(
		A3(
			$author$project$Ui$V3$Card$view,
			{title: 'Enter Invoice Amount'},
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Helpers$Html$labeledInput,
							'Invoice Amount',
							A4(
								$author$project$Ui$V3$Input$view,
								{onInput: $author$project$Components$InvoiceAmountReviewPage$InvoiceAmountChanged},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$placeholder('Double-click the invoice amount on the document to insert it here')
									]),
								_List_fromArray(
									[
										$author$project$Helpers$Keypress$onEnter($author$project$Components$InvoiceAmountReviewPage$Submit)
									]),
								A2($elm$core$Maybe$withDefault, '', invoiceAmount))),
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$mainAxisEnd,
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
								]),
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									A3(
										$author$project$Ui$V3$Button$view,
										{
											action: $author$project$Ui$V3$Button$onClick($author$project$Components$InvoiceAmountReviewPage$SubmitNoInvoiceAmount)
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
												$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorDanger)
											]),
										'No Invoice Amount Present')),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									A3(
										$author$project$Ui$V3$Button$view,
										{
											action: $author$project$Ui$V3$Button$onClick($author$project$Components$InvoiceAmountReviewPage$Submit)
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
												$author$project$Ui$V3$Button$disabled(!validValuePresent)
											]),
										'Submit'))
								]))
						]))
				])));
};
var $author$project$Components$InvoiceAmountReviewPage$view = function (model) {
	return $author$project$Components$InvoiceAmountReviewPage$invoiceAmountInputPanel(model.invoiceAmountInput);
};
var $author$project$Components$InvoiceNumberReviewPage$InvoiceNumberChanged = function (a) {
	return {$: 'InvoiceNumberChanged', a: a};
};
var $author$project$Components$InvoiceNumberReviewPage$Submit = {$: 'Submit'};
var $author$project$Ui$V3$Stack$CrossAxisRight = {$: 'CrossAxisRight'};
var $author$project$Ui$V3$Stack$crossAxisRight = $author$project$Ui$V3$Stack$CrossAxisAttribute($author$project$Ui$V3$Stack$CrossAxisRight);
var $author$project$Components$InvoiceNumberReviewPage$invoiceNumberInputPanel = function (invoiceNumber) {
	return $author$project$Helpers$Html$v3ReskinContainer(
		A3(
			$author$project$Ui$V3$Card$view,
			{title: 'Enter Invoice Number'},
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Helpers$Html$labeledInput,
							'Invoice Number',
							A4(
								$author$project$Ui$V3$Input$view,
								{onInput: $author$project$Components$InvoiceNumberReviewPage$InvoiceNumberChanged},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$placeholder('Double-click the invoice number on the document to insert it here')
									]),
								_List_fromArray(
									[
										$author$project$Helpers$Keypress$onEnter($author$project$Components$InvoiceNumberReviewPage$Submit)
									]),
								invoiceNumber)),
							A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[$author$project$Ui$V3$Stack$crossAxisRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick($author$project$Components$InvoiceNumberReviewPage$Submit)
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge)
										]),
									'Submit')
								]))
						]))
				])));
};
var $author$project$Components$InvoiceNumberReviewPage$view = function (model) {
	return $author$project$Components$InvoiceNumberReviewPage$invoiceNumberInputPanel(model.invoiceNumberInput);
};
var $author$project$Components$MultiPageBolReviewPage$buildFormState = F2(
	function (data, model) {
		var isSinglePageBol = $elm$core$List$length(data.documentPages) === 1;
		var existingMultiPageBolReview = data.multiPageBolReview;
		var questionOneAlreadyAnswered = !_Utils_eq(existingMultiPageBolReview.allPagesAreSameBol, $elm$core$Maybe$Nothing);
		return {
			allPagesAreSameBol: questionOneAlreadyAnswered ? existingMultiPageBolReview.allPagesAreSameBol : (isSinglePageBol ? $elm$core$Maybe$Just($author$project$AuditPb$MultiPageBolReviewAnswerYes) : model.allPagesAreSameBol),
			allPagesAreSameBolDisabled: isSinglePageBol,
			allPagesOfBolPresent: (!_Utils_eq(data.multiPageBolReview.allPagesOfBolPresent, $elm$core$Maybe$Nothing)) ? data.multiPageBolReview.allPagesOfBolPresent : model.allPagesOfBolPresent,
			reviewIsComplete: function () {
				var _v0 = _Utils_Tuple2(existingMultiPageBolReview.allPagesAreSameBol, existingMultiPageBolReview.allPagesOfBolPresent);
				if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
					return true;
				} else {
					return false;
				}
			}()
		};
	});
var $author$project$Components$MultiPageBolReviewPage$ConfirmAnswers = function (a) {
	return {$: 'ConfirmAnswers', a: a};
};
var $author$project$Components$MultiPageBolReviewPage$confirmButton = function (formState) {
	var notAnsweredYet = function () {
		var _v0 = _Utils_Tuple2(formState.allPagesAreSameBol, formState.allPagesOfBolPresent);
		_v0$0:
		while (true) {
			_v0$3:
			while (true) {
				if (_v0.a.$ === 'Just') {
					switch (_v0.a.a.$) {
						case 'MultiPageBolReviewAnswerNo':
							if (_v0.b.$ === 'Just') {
								break _v0$0;
							} else {
								var _v1 = _v0.a.a;
								return false;
							}
						case 'MultiPageBolReviewAnswerUnsure':
							if (_v0.b.$ === 'Just') {
								break _v0$0;
							} else {
								var _v2 = _v0.a.a;
								return false;
							}
						default:
							if (_v0.b.$ === 'Just') {
								break _v0$0;
							} else {
								break _v0$3;
							}
					}
				} else {
					break _v0$3;
				}
			}
			return true;
		}
		return false;
	}();
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick(
				$author$project$Components$MultiPageBolReviewPage$ConfirmAnswers(formState))
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$disabled(notAnsweredYet || formState.reviewIsComplete)
			]),
		'Confirm');
};
var $author$project$Components$MultiPageBolReviewPage$confirmButtonPanel = function (formState) {
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[$author$project$Ui$V3$Stack$mainAxisEnd]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				$author$project$Components$MultiPageBolReviewPage$confirmButton(formState))
			]));
};
var $author$project$Components$MultiPageBolReviewPage$documentIdPanel = function (document) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__radio-label-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				'Document ID: ' + $elm$core$String$fromInt(
					$author$project$Domain$DocumentId$toInt(document.id)))
			]));
};
var $author$project$Components$MultiPageBolReviewPage$AnswerAllPagesAreSameBol = function (a) {
	return {$: 'AnswerAllPagesAreSameBol', a: a};
};
var $author$project$Ui$V3$Radio$DisabledAttribute = function (a) {
	return {$: 'DisabledAttribute', a: a};
};
var $author$project$Ui$V3$Radio$disabled = $author$project$Ui$V3$Radio$DisabledAttribute;
var $author$project$Ui$V3$Radio$LayoutDirectionAttribute = function (a) {
	return {$: 'LayoutDirectionAttribute', a: a};
};
var $author$project$Ui$V3$Radio$layoutDirection = $author$project$Ui$V3$Radio$LayoutDirectionAttribute;
var $author$project$Components$MultiPageBolReviewPage$questionOnePanel = function (formState) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Do all pages belong to the same BOL?')
					])),
				A2(
				$author$project$Ui$V3$Radio$view,
				{
					label: function (option) {
						switch (option.$) {
							case 'MultiPageBolReviewAnswerYes':
								return 'Yes';
							case 'MultiPageBolReviewAnswerNo':
								return 'No';
							default:
								return 'Unsure';
						}
					},
					name: 'all_pages_are_same_bol',
					onSelect: function (answer) {
						return $author$project$Components$MultiPageBolReviewPage$AnswerAllPagesAreSameBol(answer);
					},
					options: _List_fromArray(
						[$author$project$AuditPb$MultiPageBolReviewAnswerYes, $author$project$AuditPb$MultiPageBolReviewAnswerNo, $author$project$AuditPb$MultiPageBolReviewAnswerUnsure]),
					selected: formState.allPagesAreSameBol
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionVertical),
						$author$project$Ui$V3$Radio$disabled(formState.allPagesAreSameBolDisabled || formState.reviewIsComplete)
					]))
			]));
};
var $author$project$Components$MultiPageBolReviewPage$AnswerAllPagesOfBolPresent = function (a) {
	return {$: 'AnswerAllPagesOfBolPresent', a: a};
};
var $author$project$Components$MultiPageBolReviewPage$questionTwoPanel = function (formState) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Are all BOL pages present?')
					])),
				A2(
				$author$project$Ui$V3$Radio$view,
				{
					label: function (option) {
						switch (option.$) {
							case 'MultiPageBolReviewAnswerYes':
								return 'Yes';
							case 'MultiPageBolReviewAnswerNo':
								return 'No';
							default:
								return 'Unsure';
						}
					},
					name: 'all_pages_of_bol_present',
					onSelect: function (answer) {
						return $author$project$Components$MultiPageBolReviewPage$AnswerAllPagesOfBolPresent(answer);
					},
					options: _List_fromArray(
						[$author$project$AuditPb$MultiPageBolReviewAnswerYes, $author$project$AuditPb$MultiPageBolReviewAnswerNo, $author$project$AuditPb$MultiPageBolReviewAnswerUnsure]),
					selected: formState.allPagesOfBolPresent
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionVertical),
						$author$project$Ui$V3$Radio$disabled(formState.reviewIsComplete)
					]))
			]));
};
var $author$project$Components$MultiPageBolReviewPage$questionsPanel = F2(
	function (data, formState) {
		var questionTwoSection = _Utils_eq(
			formState.allPagesAreSameBol,
			$elm$core$Maybe$Just($author$project$AuditPb$MultiPageBolReviewAnswerYes)) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				$author$project$Components$MultiPageBolReviewPage$questionTwoPanel(formState)),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$divider,
				$elm$html$Html$text(''))
			]) : _List_Nil;
		return A3(
			$author$project$Ui$V3$Card$view,
			{title: 'Multi-page BOL'},
			_List_fromArray(
				[
					$author$project$Ui$V3$Card$dividers(
					{isFullWidth: false})
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVertWithHeights,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								$author$project$Components$MultiPageBolReviewPage$questionOnePanel(formState)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$divider,
								$elm$html$Html$text(''))
							]),
						_Utils_ap(
							questionTwoSection,
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									$author$project$Components$MultiPageBolReviewPage$documentIdPanel(data.document)),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									$author$project$Components$MultiPageBolReviewPage$confirmButtonPanel(formState))
								]))))
				]));
	});
var $author$project$Components$MultiPageBolReviewPage$view = F2(
	function (data, model) {
		return A2(
			$author$project$Components$MultiPageBolReviewPage$questionsPanel,
			data,
			A2($author$project$Components$MultiPageBolReviewPage$buildFormState, data, model));
	});
var $author$project$Components$DocumentReviewPage$viewChildPanel = F2(
	function (data, model) {
		var _v0 = model.childModel;
		switch (_v0.$) {
			case 'InvoiceNumberReviewPage':
				var childModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$DocumentReviewPage$InvoiceNumberReviewPageMsg,
					$author$project$Components$InvoiceNumberReviewPage$view(childModel));
			case 'InvoiceAmountReviewPage':
				var childModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$DocumentReviewPage$InvoiceAmountReviewPageMsg,
					$author$project$Components$InvoiceAmountReviewPage$view(childModel));
			case 'MultiPageBolReviewPage':
				var childModel = _v0.a;
				var _v1 = data.multiPageBolReviewData;
				if (_v1.$ === 'Just') {
					var multiPageBolData = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$DocumentReviewPage$MultiPageBolReviewPageMsg,
						A2($author$project$Components$MultiPageBolReviewPage$view, multiPageBolData, childModel));
				} else {
					return $elm$html$Html$text('');
				}
			case 'DocumentTypeReviewPage':
				var childModel = _v0.a;
				var _v2 = data.documentTypeReviewData;
				if (_v2.$ === 'Just') {
					var documentTypeData = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$DocumentReviewPage$DocumentTypeReviewPageMsg,
						A2($author$project$Components$DocumentTypeReviewPage$view, documentTypeData, childModel));
				} else {
					return $elm$html$Html$text('');
				}
			default:
				var childModel = _v0.a;
				var _v3 = data.documentLoadReferenceMatchReviewData;
				if (_v3.$ === 'Just') {
					var documentLoadReferenceMatchReviewData = _v3.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$DocumentReviewPage$DocumentLoadReferenceMatchReviewPageMsg,
						A2($author$project$Components$DocumentLoadReferenceMatchReviewPage$view, documentLoadReferenceMatchReviewData, childModel));
				} else {
					return $elm$html$Html$text('');
				}
		}
	});
var $author$project$Components$DocumentReviewPage$scrollableChildPanel = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'height', '96vh'),
					A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$DocumentReviewPage$viewChildPanel, data, model)
				]));
	});
var $author$project$Components$DocumentReviewPage$viewLoaded = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[$author$project$Ui$V3$Stack$mainAxisSpaceBetween, $author$project$Ui$V3$Stack$crossAxisTop]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2($author$project$Components$DocumentReviewPage$scrollableChildPanel, data, model)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fitPx(850),
								A2($author$project$Components$DocumentReviewPage$documentsBrowserPanel, model, data))
							])))
				]));
	});
var $author$project$Components$DocumentReviewPage$view = F2(
	function (remoteData, model) {
		return A2(
			$author$project$Forward$LoadingView$viewV3Reskin,
			$author$project$Components$DocumentReviewPage$viewLoaded(model),
			remoteData);
	});
var $author$project$Components$EmailMessageSearchPage$ApplyFilters = {$: 'ApplyFilters'};
var $author$project$Components$EmailMessageSearchPage$ChangePage = function (a) {
	return {$: 'ChangePage', a: a};
};
var $author$project$Components$EmailMessageSearchPage$Clear = {$: 'Clear'};
var $author$project$Components$EmailMessageSearchPage$blankStateView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('small-10 column')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select search parameters to find emails.')
				]))
		]));
var $author$project$Components$EmailMessageSearchPage$emailMessageViewModel = F2(
	function (v3Reskin, model) {
		return {
			searchUrl: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$EmailMessageSearchPage$searchUrl(v3Reskin),
					model.filtersApplied))
		};
	});
var $author$project$Components$EmailMessageSearchPage$pageHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('small-10 column')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Results')
				]))
		]));
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$carrierTerm = function (account) {
	return $author$project$Domain$Account$carrierTerm(
		$author$project$Domain$Account$accountType(account));
};
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$itemsHeader = function (account) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__messages-header-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__subject-area')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Sender Information')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__date-area')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Date')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__carrier-area')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$EmailMessageSearchPage$EmailMessageListView$carrierTerm(account))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message__action-area')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Actions')
						]))
				]))
		]);
};
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$bemClass = function (string) {
	return $elm$html$Html$Attributes$class('list-activity-stream__' + string);
};
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$noEmailsMessage = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Components$EmailMessageSearchPage$EmailMessageListView$bemClass('context')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '20px'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No Emails Present')
					]))
			]))
	]);
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$messageRowClass = function (index) {
	return (A2($elm$core$Basics$modBy, 2, index) === 1) ? 'odd dashboard__messages-row' : 'dashboard__messages-row';
};
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$pages = F3(
	function (user, maybeDocumentBatch, emailMessage) {
		if (user.isManagedIndexer) {
			return $elm$html$Html$text('');
		} else {
			if (maybeDocumentBatch.$ === 'Just') {
				var batch = maybeDocumentBatch.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(emailMessage.attachmentDownloadUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Download ' + ($elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, 0, batch.pages)) + ' pages'))
						]));
			} else {
				return $elm$html$Html$text('0 pages');
			}
		}
	});
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$viewEmailButton = function (emailMessage) {
	var _v0 = emailMessage.importState;
	switch (_v0.$) {
		case 'EmailImportStateImportCompleted':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('View')
					]));
		case 'EmailImportStateInPODDetection':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button__disabled button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('POD processing')
					]));
		case 'EmailImportStateInDocumentContentReview':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button__disabled button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Document Reviews processing')
					]));
		case 'EmailImportStateInDocumentContentReviewDocumentType':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button__disabled button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Document Type processing')
					]));
		case 'EmailImportStateInDocumentContentReviewNoDependents':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button__disabled button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Document Reviews processing')
					]));
		case 'EmailImportStateInDocumentBatchGroupingReview':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button__disabled button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Document Grouping Reviews processing')
					]));
		case 'EmailImportStateInDocumentGroupLoadReview':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button__disabled button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Load Reviews processing')
					]));
		case 'EmailImportStateImportFailed':
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button__disabled button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Import failed')
					]));
		default:
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__action-button__disabled button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Importing...')
					]));
	}
};
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$viewTmsCarrier = F2(
	function (currentAccount, tmsCarrier) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'Unknown ' + $author$project$Domain$Account$carrierTerm(
							$author$project$Domain$Account$accountType(currentAccount)),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							tmsCarrier)))
				]));
	});
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$emailView = F7(
	function (tz, user, currentAccount, accountSettings, index, model, data) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('message__view-area-link'),
					$elm$html$Html$Attributes$href(
					A5(
						$author$project$Helpers$EmailPath$emailPath,
						currentAccount,
						accountSettings,
						data.currentUser,
						data.emailMessage,
						$elm$url$Url$percentEncode(model.searchUrl)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							$author$project$Components$EmailMessageSearchPage$EmailMessageView$messageRowClass(index))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__subject-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message__subject')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(data.emailMessage.subject)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message_sender')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(data.emailMessage.senderAddress)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__date-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Helpers$Date$toString, tz, data.emailMessage.createdAt))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__carrier-area')
								]),
							_List_fromArray(
								[
									A2($author$project$Components$EmailMessageSearchPage$EmailMessageView$viewTmsCarrier, currentAccount, data.tmsCarrier)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('message__action-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$EmailMessageSearchPage$EmailMessageView$viewEmailButton(data.emailMessage),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message__pages')
												]),
											_List_fromArray(
												[
													A3($author$project$Components$EmailMessageSearchPage$EmailMessageView$pages, user, data.documentBatch, data.emailMessage)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$errorView = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-activity-stream__row')
			]),
		_List_fromArray(
			[
				$author$project$Forward$LoadingView$defaultErrorView(error)
			]));
};
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$loadingView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('list-activity-stream__row')
		]),
	_List_fromArray(
		[$author$project$Forward$LoadingView$defaultLoadingView]));
var $author$project$Components$EmailMessageSearchPage$EmailMessageView$view = F7(
	function (tz, user, account, accountSettings, model, index, maybeData) {
		switch (maybeData.$) {
			case 'Loaded':
				var data = maybeData.a;
				return A7($author$project$Components$EmailMessageSearchPage$EmailMessageView$emailView, tz, user, account, accountSettings, index, model, data);
			case 'Loading':
				return $author$project$Components$EmailMessageSearchPage$EmailMessageView$loadingView;
			default:
				var error = maybeData.a;
				return $author$project$Components$EmailMessageSearchPage$EmailMessageView$errorView(error);
		}
	});
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$view = F3(
	function (tz, model, data) {
		var emailMessages = $author$project$Stream$value(data.emailMessagesStream);
		var messagesView = ($elm$core$List$length(emailMessages) > 0) ? A2(
			$elm$core$List$indexedMap,
			A5($author$project$Components$EmailMessageSearchPage$EmailMessageView$view, tz, data.currentUser, data.account, data.accountSettings, model),
			emailMessages) : $author$project$Components$EmailMessageSearchPage$EmailMessageListView$noEmailsMessage;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column')
				]),
			_Utils_ap(
				$author$project$Components$EmailMessageSearchPage$EmailMessageListView$itemsHeader(data.account),
				messagesView));
	});
var $author$project$Components$EmailMessageSearchPage$FiltersView$ChangeSentEmails = function (a) {
	return {$: 'ChangeSentEmails', a: a};
};
var $author$project$Components$EmailMessageSearchPage$FiltersView$SelectEndDate = function (a) {
	return {$: 'SelectEndDate', a: a};
};
var $author$project$Components$EmailMessageSearchPage$FiltersView$SelectSearchTerm = function (a) {
	return {$: 'SelectSearchTerm', a: a};
};
var $author$project$Components$EmailMessageSearchPage$FiltersView$SelectStartDate = function (a) {
	return {$: 'SelectStartDate', a: a};
};
var $author$project$Components$EmailMessageSearchPage$FiltersView$nbsp = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(160));
var $author$project$Components$EmailMessageSearchPage$FiltersView$carrierTerm = function (data) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$EmailMessageSearchPage$FiltersView$nbsp,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Domain$Account$accountType, $author$project$Domain$Account$carrierTerm),
			$author$project$Forward$Remote$toMaybe(data)));
};
var $author$project$Components$EmailMessageSearchPage$FiltersView$carrierTypeahead = F2(
	function (data, model) {
		var account = $author$project$Forward$Remote$Loaded(data.account);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-2 column activity-filters-typeahead')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$EmailMessageSearchPage$FiltersView$carrierTerm(account))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$EmailMessageSearchPage$FiltersView$CarrierTypeaheadMsg,
					A3(
						$author$project$Components$CarrierTypeahead$view,
						$author$project$Components$EmailMessageSearchPage$FiltersView$carrierTypeaheadConfig(account),
						data.carrierTypeaheadData,
						model.carrierTypeahead))
				]));
	});
var $author$project$Components$EmailMessageSearchPage$FiltersView$view = F3(
	function (config, data, model) {
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-10 column'),
					$elm$html$Html$Events$onSubmit(config.onApplyFilters)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							config.toMsg,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-2 column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Search Text')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Events$onInput($author$project$Components$EmailMessageSearchPage$FiltersView$SelectSearchTerm),
												$elm$html$Html$Attributes$value(
												A2($elm$core$Maybe$withDefault, '', model.selectedSearchTerm))
											]),
										_List_Nil)
									]))),
							A2(
							$elm$html$Html$map,
							config.toMsg,
							A2($author$project$Components$EmailMessageSearchPage$FiltersView$carrierTypeahead, data, model)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-2 column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Start Date')
										])),
									A2(
									$elm$html$Html$map,
									config.toMsg,
									A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('date'),
												A2(
												$elm$html$Html$Events$on,
												'change',
												A2($elm$json$Json$Decode$map, $author$project$Components$EmailMessageSearchPage$FiltersView$SelectStartDate, $elm$html$Html$Events$targetValue)),
												$elm$html$Html$Attributes$value(model.startDateString)
											]),
										_List_Nil))
								])),
							A2(
							$elm$html$Html$map,
							config.toMsg,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-2 column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('End Date')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('date'),
												A2(
												$elm$html$Html$Events$on,
												'change',
												A2($elm$json$Json$Decode$map, $author$project$Components$EmailMessageSearchPage$FiltersView$SelectEndDate, $elm$html$Html$Events$targetValue)),
												$elm$html$Html$Attributes$value(model.endDateString)
											]),
										_List_Nil)
									]))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-2 column')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$map,
					config.toMsg,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-2 column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$checked(model.includeSentEmails),
														$elm$html$Html$Events$onClick(
														$author$project$Components$EmailMessageSearchPage$FiltersView$ChangeSentEmails(!model.includeSentEmails))
													]),
												_List_Nil),
												$elm$html$Html$text($author$project$Components$EmailMessageSearchPage$FiltersView$nbsp),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Include Sent Emails')
													]))
											]))
									]))
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-2 column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button--progress')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Search')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$EmailMessageSearchPage$view = F3(
	function (tz, model, data) {
		var filtersView = A3(
			$author$project$Components$EmailMessageSearchPage$FiltersView$view,
			{
				hasFiltersApplied: !_Utils_eq(model.filtersApplied, $elm$core$Maybe$Nothing),
				onApplyFilters: $author$project$Components$EmailMessageSearchPage$ApplyFilters,
				onClear: $author$project$Components$EmailMessageSearchPage$Clear,
				toMsg: $author$project$Components$EmailMessageSearchPage$FiltersViewMsg
			},
			data.filtersUiState,
			model.filtersUiState);
		var _v0 = data.emailMessageListView;
		if (_v0.$ === 'Nothing') {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row dashboard__messages-container')
					]),
				_List_fromArray(
					[filtersView, $author$project$Components$EmailMessageSearchPage$blankStateView]));
		} else {
			var emailMessageListViewData = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row dashboard__messages-container')
					]),
				_List_fromArray(
					[
						filtersView,
						A3(
						$author$project$Helpers$Pagination$pagination,
						model.page,
						$author$project$Components$EmailMessageSearchPage$EmailMessageListView$hasMoreItems(emailMessageListViewData),
						$author$project$Components$EmailMessageSearchPage$ChangePage),
						$author$project$Components$EmailMessageSearchPage$pageHeader,
						A3(
						$author$project$Components$EmailMessageSearchPage$EmailMessageListView$view,
						tz,
						A2($author$project$Components$EmailMessageSearchPage$emailMessageViewModel, false, model),
						emailMessageListViewData)
					]));
		}
	});
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$GroupDocuments = {$: 'GroupDocuments'};
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$separator = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('indexing-nav__separator')
		]),
	_List_fromArray(
		[
			A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$chevronRight16)
		]));
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Completed = {$: 'Completed'};
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Current = {$: 'Current'};
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Upcoming = {$: 'Upcoming'};
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$steps = function (_v0) {
	var currentStep = _v0.currentStep;
	var onGroupDocumentsClicked = _v0.onGroupDocumentsClicked;
	var carrierTerm = _v0.carrierTerm;
	if (currentStep.$ === 'GroupDocuments') {
		return _List_fromArray(
			[
				{label: 'Assign ' + carrierTerm, onClick: $elm$core$Maybe$Nothing, state: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Completed},
				{label: 'Identify Documents', onClick: $elm$core$Maybe$Nothing, state: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Completed},
				{label: 'Group Documents', onClick: $elm$core$Maybe$Nothing, state: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Current},
				{label: 'Create and Submit Invoice', onClick: $elm$core$Maybe$Nothing, state: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Upcoming}
			]);
	} else {
		return _List_fromArray(
			[
				{label: 'Assign ' + carrierTerm, onClick: $elm$core$Maybe$Nothing, state: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Completed},
				{label: 'Identify Documents', onClick: $elm$core$Maybe$Nothing, state: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Completed},
				{label: 'Group Documents', onClick: onGroupDocumentsClicked, state: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Completed},
				{label: 'Create and Submit Invoice', onClick: $elm$core$Maybe$Nothing, state: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$Current}
			]);
	}
};
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$backStepUrl = F3(
	function (batchId, reactStep, maybeOnDone) {
		var onDoneQuery = function () {
			if (maybeOnDone.$ === 'Just') {
				var onDone = maybeOnDone.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'onDone',
						$elm$url$Url$percentEncode(onDone))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Path$addQueries,
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2('forceReact', 'true'),
						_Utils_Tuple2('step', reactStep)
					]),
				onDoneQuery),
			A2(
				$author$project$Path$documentBatch,
				batchId,
				{isReadonly: false, useFactorInvoiceWorkflowPage: false}));
	});
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$icon = function (state) {
	switch (state.$) {
		case 'Completed':
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('indexing-nav__icon')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$checkCircle16)
					]));
		case 'Current':
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('indexing-nav__current-marker')
					]),
				_List_Nil);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$reactStepName = function (index) {
	switch (index) {
		case 0:
			return $elm$core$Maybe$Just('assignCarrier');
		case 1:
			return $elm$core$Maybe$Just('assignTypes');
		case 2:
			return $elm$core$Maybe$Just('assignGroups');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$viewStep = F4(
	function (documentBatchId, maybeOnDone, index, step) {
		var modifier = function () {
			var _v3 = step.state;
			switch (_v3.$) {
				case 'Completed':
					return 'indexing-nav__step--completed';
				case 'Current':
					return 'indexing-nav__step--current';
				default:
					return 'indexing-nav__step--upcoming';
			}
		}();
		var children = _List_fromArray(
			[
				$author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$icon(step.state),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('indexing-nav__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(step.label)
					]))
			]);
		var _v0 = step.onClick;
		if (_v0.$ === 'Just') {
			var msg = _v0.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('indexing-nav__step ' + modifier),
						A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
						$elm$html$Html$Events$onClick(msg)
					]),
				children);
		} else {
			var _v1 = _Utils_Tuple3(
				step.state,
				documentBatchId,
				$author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$reactStepName(index));
			if (((_v1.a.$ === 'Completed') && (_v1.b.$ === 'Just')) && (_v1.c.$ === 'Just')) {
				var _v2 = _v1.a;
				var batchId = _v1.b.a;
				var reactStep = _v1.c.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indexing-nav__step ' + modifier),
							$elm$html$Html$Attributes$href(
							$author$project$Path$toString(
								A3($author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$backStepUrl, batchId, reactStep, maybeOnDone)))
						]),
					children);
			} else {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indexing-nav__step ' + modifier)
						]),
					children);
			}
		}
	});
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$view = function (_v0) {
	var currentStep = _v0.currentStep;
	var onGroupDocumentsClicked = _v0.onGroupDocumentsClicked;
	var maybeOnDone = _v0.maybeOnDone;
	var carrierTerm = _v0.carrierTerm;
	var documentBatchId = _v0.documentBatchId;
	var enabled = !_Utils_eq(documentBatchId, $elm$core$Maybe$Nothing);
	var rootClass = enabled ? 'indexing-nav' : 'indexing-nav indexing-nav--disabled';
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(rootClass),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Indexing progress')
			]),
		A2(
			$elm$core$List$intersperse,
			$author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$separator,
			A2(
				$elm$core$List$indexedMap,
				A2($author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$viewStep, documentBatchId, maybeOnDone),
				$author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$steps(
					{carrierTerm: carrierTerm, currentStep: currentStep, onGroupDocumentsClicked: onGroupDocumentsClicked}))));
};
var $author$project$Components$FactorInvoiceAuditBatchGroupingPage$view = F3(
	function (_v0, _v1, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fi-audit__nav-row')
											]),
										_List_fromArray(
											[
												$author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$view(
												{
													carrierTerm: $author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount),
													currentStep: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$GroupDocuments,
													documentBatchId: $elm$core$Maybe$Just(model.documentBatchId),
													maybeOnDone: model.onDone,
													onGroupDocumentsClicked: $elm$core$Maybe$Nothing
												})
											])),
										$elm$html$Html$text('Grouping view placeholder')
									]))
							])))
				]));
	});
var $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$CreateAndSubmitInvoice = {$: 'CreateAndSubmitInvoice'};
var $author$project$Components$FactorInvoiceAuditBatchPage$NavigateToGrouping = {$: 'NavigateToGrouping'};
var $author$project$Components$FactorInvoiceAuditBatchPage$OpenForwardEmailModal = {$: 'OpenForwardEmailModal'};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewForwardEmailButton = function (_v0) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditBatchPage$OpenForwardEmailModal)
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
			]),
		'Forward Email');
};
var $author$project$Components$FactorInvoiceAuditBatchPage$OpenIgnoreAllGroupsModal = {$: 'OpenIgnoreAllGroupsModal'};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewIgnoreAllGroupsButton = function (_v0) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditBatchPage$OpenIgnoreAllGroupsModal)
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
			]),
		'Ignore All Groups');
};
var $author$project$Components$FactorInvoiceAuditBatchPage$OpenMergeEmailModal = {$: 'OpenMergeEmailModal'};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewMergeEmailButton = function (model) {
	return (_Utils_eq(
		model.canMerge,
		$elm$core$Maybe$Just(true)) && (!_Utils_eq(model.emailMessageId, $elm$core$Maybe$Nothing))) ? $elm$core$Maybe$Just(
		A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditBatchPage$OpenMergeEmailModal)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
				]),
			'Merge Email')) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$FactorInvoiceAuditBatchPage$headerActions = function (model) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				$author$project$Components$FactorInvoiceAuditBatchPage$viewIgnoreAllGroupsButton(model)),
				$elm$core$Maybe$Just(
				$author$project$Components$FactorInvoiceAuditBatchPage$viewForwardEmailButton(model)),
				$author$project$Components$FactorInvoiceAuditBatchPage$viewMergeEmailButton(model)
			]));
};
var $author$project$Path$legacyFactorInvoiceInBatch = F3(
	function (documentBatchId, factorInvoiceId, maybeOnDone) {
		return A2(
			$author$project$Path$addQueries,
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'invoiceId',
						$elm$core$String$fromInt(
							$author$project$Domain$FactorInvoiceId$toInt(factorInvoiceId))),
						_Utils_Tuple2('forceReact', 'true')
					]),
				$author$project$Path$onDoneQuery(maybeOnDone)),
			A2(
				$author$project$Path$documentBatch,
				documentBatchId,
				{isReadonly: false, useFactorInvoiceWorkflowPage: false}));
	});
var $author$project$Components$FactorInvoiceAuditPacketComparison$CloseClicked = {$: 'CloseClicked'};
var $author$project$Components$FactorInvoiceAuditPacketComparison$DuplicateChosen = function (a) {
	return {$: 'DuplicateChosen', a: a};
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$FindValueRequested = function (a) {
	return {$: 'FindValueRequested', a: a};
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$JumpRequested = function (a) {
	return {$: 'JumpRequested', a: a};
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$PaneScrolled = function (a) {
	return {$: 'PaneScrolled', a: a};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$filedUnder = function (_v0) {
	var theirs = _v0.theirs;
	var mine = _v0.mine;
	return A2($elm_community$maybe_extra$Maybe$Extra$or, mine, theirs);
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$groupKey = A2(
	$elm$core$Basics$composeR,
	$author$project$Components$FactorInvoiceDuplicatePacketComparison$filedUnder,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			function ($) {
				return $.documentType;
			}),
		$elm$core$Maybe$withDefault('')));
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$groupTitle = A2(
	$elm$core$Basics$composeR,
	$author$project$Components$FactorInvoiceDuplicatePacketComparison$filedUnder,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			function ($) {
				return $.title;
			}),
		$elm$core$Maybe$withDefault('')));
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$groups = function (rows) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (indexed, acc) {
				var key = $author$project$Components$FactorInvoiceDuplicatePacketComparison$groupKey(indexed.row);
				var _v0 = A2(
					$elm_community$list_extra$List$Extra$findIndex,
					function (group) {
						return _Utils_eq(group.key, key);
					},
					acc);
				if (_v0.$ === 'Just') {
					var at = _v0.a;
					return A3(
						$elm_community$list_extra$List$Extra$updateAt,
						at,
						function (group) {
							return _Utils_update(
								group,
								{
									rows: _Utils_ap(
										group.rows,
										_List_fromArray(
											[indexed]))
								});
						},
						acc);
				} else {
					return _Utils_ap(
						acc,
						_List_fromArray(
							[
								{
								key: key,
								rows: _List_fromArray(
									[indexed]),
								title: $author$project$Components$FactorInvoiceDuplicatePacketComparison$groupTitle(indexed.row)
							}
							]));
				}
			}),
		_List_Nil,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, row) {
					return {index: index, row: row};
				}),
			rows));
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$groupPages = F2(
	function (sideIndex, group) {
		var side = (!sideIndex) ? function ($) {
			return $.mine;
		} : function ($) {
			return $.theirs;
		};
		return A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.pages;
			},
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var row = _v0.row;
					return side(row);
				},
				group.rows));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageBeingRead = F2(
	function (config, sideIndex) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Dict$get, sideIndex, config.atTop));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$scoringFor = F3(
	function (group, overlapFloor, subject) {
		var similarities = A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var row = _v0.row;
				return row.similarities;
			},
			group.rows);
		var joins = F2(
			function (page, similarity) {
				return _Utils_eq(similarity.documentPageId, subject.id) && _Utils_eq(similarity.otherDocumentPageId, page.id);
			});
		return {
			against: function (page) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					joins(page),
					similarities);
			},
			overlapFloor: overlapFloor
		};
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$subjectSide = 0;
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$scoringAgainst = F2(
	function (config, group) {
		return A2(
			$elm$core$List$all,
			function (_v0) {
				var row = _v0.row;
				return row.pagesScored;
			},
			group.rows) ? A3(
			$elm$core$Maybe$map2,
			$author$project$Components$FactorInvoiceDuplicatePacketComparison$scoringFor(group),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.overlapFloor;
				},
				$author$project$Forward$Remote$toMaybe(config.pairing)),
			A2(
				$elm_community$list_extra$List$Extra$getAt,
				A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$pageBeingRead, config, $author$project$Components$FactorInvoiceDuplicatePacketComparison$subjectSide),
				A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$groupPages, $author$project$Components$FactorInvoiceDuplicatePacketComparison$subjectSide, group))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$selectedGroupOf = F2(
	function (selected, all) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			$elm$core$List$head(all),
			A2(
				$elm$core$Maybe$andThen,
				function (key) {
					return A2(
						$elm_community$list_extra$List$Extra$find,
						function (group) {
							return _Utils_eq(group.key, key);
						},
						all);
				},
				selected));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$closeButton = function (closeMsg) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick(closeMsg)
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
			]),
		'Close');
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$openDuplicateLink = F2(
	function (config, label) {
		return A2(
			$author$project$Ui$V3$Link$view,
			{
				text: label,
				url: $author$project$Path$toString(
					A2($author$project$Path$factorInvoice, config.comparedInvoiceId, config.pathContext))
			},
			_List_fromArray(
				[$author$project$Ui$V3$Link$targetBlank]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewHeader = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__packet-compare-header')
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Compare invoices'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-actions')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$openDuplicateLink, config, 'Open existing invoice'),
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$closeButton(config.closeMsg)
					]))
			]));
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$MarkNothing = {$: 'MarkNothing'};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$fields = _List_fromArray(
	[
		{
		label: 'Invoice Number',
		value: function ($) {
			return $.invoiceNumber;
		}
	},
		{
		label: 'Invoice Amount',
		value: function ($) {
			return $.amount;
		}
	},
		{
		label: 'Debtor',
		value: function ($) {
			return $.debtorName;
		}
	},
		{
		label: 'Load ID',
		value: function ($) {
			return $.loadId;
		}
	}
	]);
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$differsFrom = F3(
	function (reference, details, field) {
		return !_Utils_eq(
			field.value(reference),
			field.value(details));
	});
var $author$project$Ui$V3$Icon$viewCustom = F4(
	function (xSize, ySize, attributes, _v0) {
		var svg = _v0.a;
		return A4(
			$author$project$Ui$V3$Icon$viewWithCustomDimensions,
			_Utils_Tuple2('16', '16'),
			_Utils_Tuple2(xSize, ySize),
			attributes,
			svg);
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageElementId = F3(
	function (rowIndex, sideIndex, pageIndex) {
		return A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[
					'fi-audit-packet-compare-page',
					$elm$core$String$fromInt(rowIndex),
					$elm$core$String$fromInt(sideIndex),
					$elm$core$String$fromInt(pageIndex)
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$groupAnchors = F2(
	function (keep, group) {
		var side = F2(
			function (sideIndex, get) {
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (pageIndex, _v1) {
								var elementId = _v1.a;
								var page = _v1.b;
								return keep(page) ? $elm$core$Maybe$Just(
									{elementId: elementId, group: group.key, pageIndex: pageIndex, sideIndex: sideIndex}) : $elm$core$Maybe$Nothing;
							}),
						A2(
							$elm$core$List$concatMap,
							function (_v0) {
								var row = _v0.row;
								var index = _v0.index;
								return A2(
									$elm$core$List$indexedMap,
									F2(
										function (documentPageIndex, page) {
											return _Utils_Tuple2(
												A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$pageElementId, index, sideIndex, documentPageIndex),
												page);
										}),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.pages;
											},
											get(row))));
							},
							group.rows)));
			});
		return _Utils_ap(
			A2(
				side,
				0,
				function ($) {
					return $.mine;
				}),
			A2(
				side,
				1,
				function ($) {
					return $.theirs;
				}));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$anchorsCarrying = F2(
	function (value, rows) {
		return A2(
			$elm$core$List$concatMap,
			$author$project$Components$FactorInvoiceDuplicatePacketComparison$groupAnchors(
				function (page) {
					return !_Utils_eq(
						A2($author$project$Domain$DocumentPageLine$matching, value, page.lines),
						_List_Nil);
				}),
			$author$project$Components$FactorInvoiceDuplicatePacketComparison$groups(rows));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$markedValue = function (search) {
	switch (search.$) {
		case 'Found':
			var value = search.a.value;
			return $elm$core$Maybe$Just(value);
		case 'NotFound':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewFindButton = F2(
	function (finder, value) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-find'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'fi-audit__packet-compare-find--marking',
							_Utils_eq(
								$author$project$Components$FactorInvoiceDuplicatePacketComparison$markedValue(finder.search),
								$elm$core$Maybe$Just(value)))
						])),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$title('Click to view value'),
					$elm$html$Html$Attributes$disabled(
					$elm$core$List$isEmpty(finder.rows)),
					A2(
					$elm$html$Html$Events$on,
					'click',
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return $elm$json$Json$Decode$succeed(
								finder.findMsg(
									{
										anchors: A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$anchorsCarrying, value, finder.rows),
										value: value
									}));
						}))
				]),
			_List_fromArray(
				[
					A4($author$project$Ui$V3$Icon$viewCustom, '12', '12', _List_Nil, $author$project$Ui$V3$Icon$search16)
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewField = F4(
	function (finder, marking, details, field) {
		var value = field.value(details);
		var differs = function () {
			if (marking.$ === 'MarkNothing') {
				return false;
			} else {
				var reference = marking.a;
				return A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$differsFrom, reference, details, field);
			}
		}();
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('fi-audit__packet-compare-field--differs', differs)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-field-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(field.label)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-field-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '—', value))
						])),
					differs ? A4(
					$author$project$Ui$V3$Icon$viewCustom,
					'12',
					'12',
					_List_fromArray(
						[
							$author$project$Ui$V3$Icon$label('Differs from this invoice')
						]),
					$author$project$Ui$V3$Icon$alertTriangle16) : $elm$html$Html$text(''),
					function () {
					if (value.$ === 'Just') {
						var present = value.a;
						return A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewFindButton, finder, present);
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewFields = F3(
	function (finder, marking, details) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-fields')
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewField, finder, marking, details),
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$fields));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMyHeading = F2(
	function (finder, details) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-cell'),
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-cell--heading'),
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-mine')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewFields, finder, $author$project$Components$FactorInvoiceDuplicatePacketComparison$MarkNothing, details)
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewSearchNote = function (search) {
	if (search.$ === 'NotFound') {
		var value = search.a.value;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-not-found')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Notification$viewToast,
					{
						message: $elm$html$Html$text('Not on any page of either invoice.'),
						onClose: $elm$core$Maybe$Nothing,
						title: value
					},
					_List_fromArray(
						[$author$project$Ui$V3$Notification$warning]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$MarkDifferencesFrom = function (a) {
	return {$: 'MarkDifferencesFrom', a: a};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$comparedChoice = function (config) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (choice) {
				return _Utils_eq(choice.id, config.comparedInvoiceId);
			},
			config.duplicates));
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$noDetails = {amount: $elm$core$Maybe$Nothing, debtorName: $elm$core$Maybe$Nothing, invoiceDate: $elm$core$Maybe$Nothing, invoiceNumber: $elm$core$Maybe$Nothing, loadId: $elm$core$Maybe$Nothing};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewTheirHeading = F2(
	function (finder, config) {
		var _v0 = function () {
			var _v1 = $author$project$Components$FactorInvoiceDuplicatePacketComparison$comparedChoice(config);
			if (_v1.$ === 'Just') {
				var choice = _v1.a;
				return _Utils_Tuple2(
					$author$project$Components$FactorInvoiceDuplicatePacketComparison$MarkDifferencesFrom(config.mine),
					choice.details);
			} else {
				return _Utils_Tuple2($author$project$Components$FactorInvoiceDuplicatePacketComparison$MarkNothing, $author$project$Components$FactorInvoiceDuplicatePacketComparison$noDetails);
			}
		}();
		var marking = _v0.a;
		var details = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-cell'),
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-cell--heading'),
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-theirs')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewFields, finder, marking, details)
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewHeadingRow = F2(
	function (config, rows) {
		var finder = {findMsg: config.findMsg, rows: rows, search: config.search};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-row fi-audit__packet-compare-row--heading')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMyHeading, finder, config.mine),
					A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewTheirHeading, finder, config),
					$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewSearchNote(config.search)
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$numberPagesThrough = function (documents) {
	return $elm$core$List$reverse(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, _v1) {
					var rowIndex = _v0.a;
					var document = _v0.b;
					var numbered = _v1.a;
					var pagesSoFar = _v1.b;
					return _Utils_Tuple2(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								pagesSoFar,
								_Utils_Tuple2(rowIndex, document)),
							numbered),
						pagesSoFar + $elm$core$List$length(document.pages));
				}),
			_Utils_Tuple2(_List_Nil, 0),
			documents).a);
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$elementsOf = F2(
	function (className, item) {
		var element = A2(
			$elm$json$Json$Decode$andThen,
			function (classes) {
				return A2(
					$elm$core$List$member,
					className,
					$elm$core$String$words(classes)) ? A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, item) : $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
			},
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'className', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed('')
					])));
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2(
				$elm$json$Json$Decode$andThen,
				function (length) {
					return A3(
						$elm$core$List$foldr,
						$elm$json$Json$Decode$map2($elm$core$List$cons),
						$elm$json$Json$Decode$succeed(_List_Nil),
						A2(
							$elm$core$List$map,
							function (index) {
								return A2(
									$elm$json$Json$Decode$field,
									$elm$core$String$fromInt(index),
									element);
							},
							A2($elm$core$List$range, 0, length - 1)));
				},
				A2($elm$json$Json$Decode$field, 'length', $elm$json$Json$Decode$int)));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$paneDecoder = A5(
	$elm$json$Json$Decode$map4,
	F4(
		function (scrollTop, scrollHeight, clientHeight, pageTops) {
			return {
				maxScroll: A2($elm$core$Basics$max, 0, scrollHeight - clientHeight),
				pageTops: pageTops,
				scrollTop: scrollTop
			};
		}),
	A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'scrollHeight', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientHeight', $elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$field,
		'children',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$concat,
			A2(
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$elementsOf,
				'fi-audit__packet-compare-doc',
				A2(
					$elm$json$Json$Decode$field,
					'children',
					A2(
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$elementsOf,
						'fi-audit__packet-compare-page-block',
						A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float)))))));
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$onPaneScroll = function (toMsg) {
	return A2(
		$elm$html$Html$Events$on,
		'scroll',
		A2(
			$elm$json$Json$Decode$map,
			toMsg,
			A2($elm$json$Json$Decode$field, 'target', $author$project$Components$FactorInvoiceDuplicatePacketComparison$paneDecoder)));
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageLabel = function (pages) {
	return (pages === 1) ? '1 page' : ($elm$core$String$fromInt(pages) + ' pages');
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMarks = F2(
	function (search, page) {
		var _v0 = $author$project$Components$FactorInvoiceDuplicatePacketComparison$markedValue(search);
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A2(
				$elm$core$List$map,
				$author$project$Components$DocumentPageMark$view($elm$core$Maybe$Nothing),
				A2($author$project$Domain$DocumentPageLine$matching, value, page.lines));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageBar = {
	below: function (overlapFloor) {
		return 'Below ' + ($elm$core$String$fromInt(
			$elm$core$Basics$round(overlapFloor * 100)) + '% match');
	},
	_class: 'fi-audit__packet-compare-page-score'
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$percentage = function (overlap) {
	return $elm$core$String$fromInt(
		A2(
			$elm$core$Basics$min,
			99,
			$elm$core$Basics$round(overlap * 100))) + '%';
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$scoredSide = 1;
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewScore = F4(
	function (style, scoring, sideIndex, page) {
		var score = F2(
			function (modifier, label) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(style._class),
							$elm$html$Html$Attributes$class(
							_Utils_ap(style._class, modifier))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			});
		if (scoring.$ === 'Just') {
			var overlapFloor = scoring.a.overlapFloor;
			var against = scoring.a.against;
			if (!_Utils_eq(sideIndex, $author$project$Components$FactorInvoiceDuplicatePacketComparison$scoredSide)) {
				return _List_Nil;
			} else {
				var _v1 = against(page);
				if (_v1.$ === 'Just') {
					var similarity = _v1.a;
					return similarity.identical ? _List_fromArray(
						[
							A2(score, '--same', '100% Match')
						]) : _List_fromArray(
						[
							A2(
							score,
							'--partial',
							$author$project$Components$FactorInvoiceDuplicatePacketComparison$percentage(similarity.wordOverlap) + ' Match')
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							score,
							'--none',
							style.below(overlapFloor))
						]);
				}
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPageHead = F3(
	function (pane, pageNumber, page) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-page-head')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$V3$Typography$smallBodySemiBold,
					_List_Nil,
					'Page ' + $elm$core$String$fromInt(pageNumber + 1)),
				A4($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewScore, $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageBar, pane.scoring, pane.sideIndex, page)));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPage = F4(
	function (pane, rowIndex, _v0, page) {
		var pageIndex = _v0.a;
		var pageNumber = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-page-block'),
					$elm$html$Html$Attributes$id(
					A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$pageElementId, rowIndex, pane.sideIndex, pageIndex))
				]),
			_List_fromArray(
				[
					A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPageHead, pane, pageNumber, page),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-page-frame')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__packet-compare-page'),
									$elm$html$Html$Attributes$src(page.url),
									A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous')
								]),
							_List_Nil),
						A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMarks, pane.search, page)))
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPaneDocument = F2(
	function (pane, _v0) {
		var firstPageNumber = _v0.a;
		var _v1 = _v0.b;
		var rowIndex = _v1.a;
		var document = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-doc')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-doc-title')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__packet-compare-doc-column')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(pane.columnLabel)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(document.title)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__packet-compare-doc-pages')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$FactorInvoiceDuplicatePacketComparison$pageLabel(
										$elm$core$List$length(document.pages)))
								]))
						])),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (pageIndex, page) {
							return A4(
								$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPage,
								pane,
								rowIndex,
								_Utils_Tuple2(pageIndex, firstPageNumber + pageIndex),
								page);
						}),
					document.pages)));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPane = F6(
	function (config, scoring, group, sideIndex, side, columnLabel) {
		var pane = {columnLabel: columnLabel, scoring: scoring, search: config.search, sideIndex: sideIndex};
		var documents = $author$project$Components$FactorInvoiceDuplicatePacketComparison$numberPagesThrough(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var row = _v0.row;
					var index = _v0.index;
					return A2(
						$elm$core$Maybe$map,
						function (document) {
							return _Utils_Tuple2(index, document);
						},
						side(row));
				},
				group.rows));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-pane'),
					$elm$html$Html$Attributes$id(
					$author$project$Components$FactorInvoiceDuplicatePacketComparison$paneId(sideIndex)),
					$author$project$Components$FactorInvoiceDuplicatePacketComparison$onPaneScroll(
					function (scrolled) {
						return config.scrolledMsg(
							{group: group.key, pane: scrolled, sideIndex: sideIndex});
					})
				]),
			$elm$core$List$isEmpty(documents) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-unmatched')
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'Nothing of this type on this invoice')
						]))
				]) : A2(
				$elm$core$List$map,
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPaneDocument(pane),
				documents));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPanes = F3(
	function (config, scoring, selected) {
		var _v0 = _Utils_Tuple2(
			$author$project$Forward$Remote$isResolved(config.pairing),
			selected);
		if (!_v0.a) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-panes')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$body, _List_Nil, 'Loading documents…')
					]));
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-panes')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[$author$project$Ui$V3$Typography$bodyClass]),
							_List_fromArray(
								[
									$elm$html$Html$text('These packets could not be paired up. '),
									A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$openDuplicateLink, config, 'Open the existing invoice'),
									$elm$html$Html$text(' to compare them.')
								]))
						]));
			} else {
				var group = _v0.b.a;
				var key = function (sideIndex) {
					return A2(
						$elm$core$String$join,
						'-',
						_List_fromArray(
							[
								$elm$core$String$fromInt(
								$author$project$Domain$FactorInvoiceId$toInt(config.comparedInvoiceId)),
								group.key,
								$elm$core$String$fromInt(sideIndex)
							]));
				};
				return A3(
					$elm$html$Html$Keyed$node,
					'div',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-panes')
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							key(0),
							A6(
								$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPane,
								config,
								scoring,
								group,
								0,
								function ($) {
									return $.mine;
								},
								'Current invoice')),
							_Utils_Tuple2(
							key(1),
							A6(
								$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPane,
								config,
								scoring,
								group,
								1,
								function ($) {
									return $.theirs;
								},
								'Existing invoice'))
						]));
			}
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$CloseText = {$: 'CloseText'};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$NoMatch = {$: 'NoMatch'};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$NotCompared = {$: 'NotCompared'};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$SameText = {$: 'SameText'};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageMatches = function (rows) {
	var similarities = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.similarities;
		},
		rows);
	var matchOf = F2(
		function (row, page) {
			if (!row.pagesScored) {
				return $author$project$Components$FactorInvoiceDuplicatePacketComparison$NotCompared;
			} else {
				var _v0 = A2(
					$elm$core$List$filter,
					function (similarity) {
						return _Utils_eq(similarity.otherDocumentPageId, page.id);
					},
					similarities);
				if (!_v0.b) {
					return $author$project$Components$FactorInvoiceDuplicatePacketComparison$NoMatch;
				} else {
					var found = _v0;
					return A2(
						$elm$core$List$any,
						function ($) {
							return $.identical;
						},
						found) ? $author$project$Components$FactorInvoiceDuplicatePacketComparison$SameText : $author$project$Components$FactorInvoiceDuplicatePacketComparison$CloseText;
				}
			}
		});
	return A2(
		$elm$core$List$concatMap,
		function (row) {
			return A2(
				$elm$core$List$map,
				matchOf(row),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.pages;
						},
						row.theirs)));
		},
		rows);
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageMatchesOf = F2(
	function (config, choice) {
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.rows;
				},
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$pageMatches),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Forward$Remote$toMaybe,
				A2(
					$elm$core$Dict$get,
					$author$project$Domain$FactorInvoiceId$toInt(choice.id),
					config.pairings)));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$countOf = F2(
	function (match, matches) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$eq(match),
				matches));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMatchCount = F3(
	function (modifier, description, count) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate-line'),
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate-line' + modifier)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Typography$xSmallBodySemiBold,
					_List_Nil,
					$elm$core$String$fromInt(count) + (' ' + description))
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewUncompared = function (count) {
	return (!count) ? _List_Nil : _List_fromArray(
		[
			A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMatchCount, '--uncompared', 'not compared', count)
		]);
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMatchCounts = function (measured) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate-counts')
			]),
		function () {
			if (measured.$ === 'Just') {
				var matches = measured.a;
				return A2(
					$elm$core$List$cons,
					A3(
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMatchCount,
						'--same',
						'same',
						A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$countOf, $author$project$Components$FactorInvoiceDuplicatePacketComparison$SameText, matches)),
					A2(
						$elm$core$List$cons,
						A3(
							$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMatchCount,
							'--close',
							'close',
							A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$countOf, $author$project$Components$FactorInvoiceDuplicatePacketComparison$CloseText, matches)),
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewUncompared(
							A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$countOf, $author$project$Components$FactorInvoiceDuplicatePacketComparison$NotCompared, matches))));
			} else {
				return _List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$xSmallBody, _List_Nil, 'Reading pages…')
					]);
			}
		}());
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewDiffers = F3(
	function (reference, details, field) {
		return A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$differsFrom, reference, details, field) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate-line'),
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate-line--differs')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, field.label + ' differs')
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewOnScreenDetails = F2(
	function (reference, details) {
		var about = A2(
			$elm$core$String$join,
			' · ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[details.debtorName, details.invoiceDate])));
		return A2(
			$elm$core$List$cons,
			A2($author$project$Ui$V3$Typography$xSmallBody, _List_Nil, about),
			A2(
				$elm$core$List$filterMap,
				A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewDiffers, reference, details),
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$fields));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewCandidate = F2(
	function (config, choice) {
		var onScreen = _Utils_eq(choice.id, config.comparedInvoiceId);
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$type_('button'),
					onScreen ? _List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate--selected'),
							A2($elm$html$Html$Attributes$attribute, 'aria-current', 'true')
						]) : _List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							config.compareMsg(choice.id))
						]))),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate-head')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Typography$xSmallBodySemiBold,
							_List_Nil,
							A2($elm$core$Maybe$withDefault, '—', choice.details.invoiceNumber)),
							A2(
							$author$project$Ui$V3$Typography$xSmallBody,
							_List_Nil,
							A2($elm$core$Maybe$withDefault, '', choice.details.amount))
						])),
				A2(
					$elm$core$List$cons,
					$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewMatchCounts(
						A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$pageMatchesOf, config, choice)),
					onScreen ? A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewOnScreenDetails, config.mine, choice.details) : _List_Nil)));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewCandidates = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidates')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidates-head')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Possible duplicates · ' + $elm$core$String$fromInt(
							$elm$core$List$length(config.duplicates)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-candidate-list')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewCandidate(config),
					config.duplicates))
			]));
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pairUp = F2(
	function (ours, theirs) {
		return A2(
			$elm$core$List$map,
			function (index) {
				return _Utils_Tuple2(
					A2($elm_community$list_extra$List$Extra$getAt, index, ours),
					A2($elm_community$list_extra$List$Extra$getAt, index, theirs));
			},
			A2(
				$elm$core$List$range,
				0,
				A2(
					$elm$core$Basics$max,
					$elm$core$List$length(ours),
					$elm$core$List$length(theirs)) - 1));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$paneAnchors = F2(
	function (sideIndex, group) {
		return A2(
			$elm$core$List$filter,
			function (anchor) {
				return _Utils_eq(anchor.sideIndex, sideIndex);
			},
			A2(
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$groupAnchors,
				$elm$core$Basics$always(true),
				group));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$pageCarriesSearch = F2(
	function (search, page) {
		var _v0 = $author$project$Components$FactorInvoiceDuplicatePacketComparison$markedValue(search);
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return !_Utils_eq(
				A2($author$project$Domain$DocumentPageLine$matching, value, page.lines),
				_List_Nil);
		} else {
			return false;
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$railChip = {
	below: $elm$core$Basics$always('—'),
	_class: 'fi-audit__packet-compare-rail-thumb-score'
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailPage = F4(
	function (config, scoring, pageIndex, entry) {
		if (entry.$ === 'Nothing') {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail-empty')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('—')
					]));
		} else {
			var _v1 = entry.a;
			var anchor = _v1.a;
			var page = _v1.b;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail-thumb'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'fi-audit__packet-compare-rail-thumb--selected',
								_Utils_eq(
									A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$pageBeingRead, config, anchor.sideIndex),
									pageIndex)),
								_Utils_Tuple2(
								'fi-audit__packet-compare-rail-thumb--carrying',
								A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$pageCarriesSearch, config.search, page))
							])),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$title(
						'Page ' + $elm$core$String$fromInt(pageIndex + 1)),
						$elm$html$Html$Events$onClick(
						config.jumpMsg(
							$author$project$Components$FactorInvoiceDuplicatePacketComparison$ToPage(anchor)))
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail-thumb-image'),
								$elm$html$Html$Attributes$src(page.url),
								A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous')
							]),
						_List_Nil),
					A4($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewScore, $author$project$Components$FactorInvoiceDuplicatePacketComparison$railChip, scoring, anchor.sideIndex, page)));
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailSide = F2(
	function (modifier, label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail-side'),
					$elm$html$Html$Attributes$class(modifier)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailPages = F3(
	function (config, scoring, group) {
		var pages = function (sideIndex) {
			return A3(
				$elm$core$List$map2,
				$elm$core$Tuple$pair,
				A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$paneAnchors, sideIndex, group),
				A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$groupPages, sideIndex, group));
		};
		var rows = A2(
			$author$project$Components$FactorInvoiceDuplicatePacketComparison$pairUp,
			pages(0),
			pages(1));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail-pages')
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailSide, 'fi-audit__packet-compare-rail-side--mine', 'New'),
				A2(
					$elm$core$List$cons,
					A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailSide, 'fi-audit__packet-compare-rail-side--theirs', 'Existing'),
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (pageIndex, _v0) {
									var ours = _v0.a;
									var theirs = _v0.b;
									return _List_fromArray(
										[
											A4($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailPage, config, scoring, pageIndex, ours),
											A4($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailPage, config, scoring, pageIndex, theirs)
										]);
								}),
							rows)))));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$ToGroup = function (a) {
	return {$: 'ToGroup', a: a};
};
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$carriesSearch = F2(
	function (search, group) {
		var _v0 = $author$project$Components$FactorInvoiceDuplicatePacketComparison$markedValue(search);
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return !_Utils_eq(
				A2(
					$author$project$Components$FactorInvoiceDuplicatePacketComparison$groupAnchors,
					function (page) {
						return !_Utils_eq(
							A2($author$project$Domain$DocumentPageLine$matching, value, page.lines),
							_List_Nil);
					},
					group),
				_List_Nil);
		} else {
			return false;
		}
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailType = F3(
	function (config, isSelected, group) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail-type'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('fi-audit__packet-compare-rail-type--selected', isSelected),
							_Utils_Tuple2(
							'fi-audit__packet-compare-rail-type--carrying',
							A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$carriesSearch, config.search, group))
						])),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick(
					config.jumpMsg(
						$author$project$Components$FactorInvoiceDuplicatePacketComparison$ToGroup(group.key)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(group.title)
						]))
				]));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailGroup = F4(
	function (config, scoring, selected, group) {
		var isSelected = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.key;
				},
				selected),
			$elm$core$Maybe$Just(group.key));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail-group')
				]),
			A2(
				$elm$core$List$cons,
				A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailType, config, isSelected, group),
				isSelected ? _List_fromArray(
					[
						A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailPages, config, scoring, group)
					]) : _List_Nil));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRail = F4(
	function (config, scoring, documentGroups, selected) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__packet-compare-rail')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewCandidates(config),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRailGroup, config, scoring, selected),
					documentGroups)));
	});
var $author$project$Components$FactorInvoiceDuplicatePacketComparison$view = function (config) {
	var rows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.rows;
			},
			$author$project$Forward$Remote$toMaybe(config.pairing)));
	var documentGroups = $author$project$Components$FactorInvoiceDuplicatePacketComparison$groups(rows);
	var selected = A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$selectedGroupOf, config.selectedGroup, documentGroups);
	var scoring = A2(
		$elm$core$Maybe$andThen,
		$author$project$Components$FactorInvoiceDuplicatePacketComparison$scoringAgainst(config),
		selected);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__packet-compare')
			]),
		_List_fromArray(
			[
				$author$project$Components$FactorInvoiceDuplicatePacketComparison$viewHeader(config),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__packet-compare-main')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__packet-compare-columns')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewHeadingRow, config, rows),
								A3($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewPanes, config, scoring, selected)
							])),
						A4($author$project$Components$FactorInvoiceDuplicatePacketComparison$viewRail, config, scoring, documentGroups, selected)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditPacketComparison$view = function (remoteData) {
	var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
	if (_v0.$ === 'Just') {
		var data = _v0.a;
		var _v1 = data.comparison;
		if (_v1.$ === 'Open') {
			var selection = _v1.a;
			var pairing = _v1.b;
			return $author$project$Components$FactorInvoiceDuplicatePacketComparison$view(
				{
					atTop: A2(
						$elm$core$Dict$map,
						F2(
							function (_v2, _v3) {
								var page = _v3.page;
								return page;
							}),
						selection.atTop),
					closeMsg: $author$project$Components$FactorInvoiceAuditPacketComparison$CloseClicked,
					compareMsg: $author$project$Components$FactorInvoiceAuditPacketComparison$DuplicateChosen,
					comparedInvoiceId: selection.otherInvoiceId,
					duplicates: data.duplicates,
					findMsg: $author$project$Components$FactorInvoiceAuditPacketComparison$FindValueRequested,
					jumpMsg: $author$project$Components$FactorInvoiceAuditPacketComparison$JumpRequested,
					mine: data.mine,
					pairing: pairing,
					pairings: data.pairings,
					pathContext: data.pathContext,
					scrolledMsg: $author$project$Components$FactorInvoiceAuditPacketComparison$PaneScrolled,
					search: selection.search,
					selectedGroup: selection.selectedGroup
				});
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoiceAuditBatchPage$CloseForwardEmailModal = {$: 'CloseForwardEmailModal'};
var $author$project$Components$FactorInvoiceAuditBatchPage$CloseIgnoreAllGroupsModal = {$: 'CloseIgnoreAllGroupsModal'};
var $author$project$Components$FactorInvoiceAuditBatchPage$CloseMergeEmailModal = {$: 'CloseMergeEmailModal'};
var $author$project$Components$FactorInvoiceAuditBatchPage$ForwardEmailDone = function (a) {
	return {$: 'ForwardEmailDone', a: a};
};
var $author$project$Components$FactorInvoiceAuditBatchPage$IgnoreAllGroupsComplete = {$: 'IgnoreAllGroupsComplete'};
var $author$project$Components$FactorInvoiceAuditBatchPage$MergeEmailComplete = {$: 'MergeEmailComplete'};
var $author$project$Ui$V3$Modal$Medium = {$: 'Medium'};
var $author$project$Ui$V3$Modal$medium = $author$project$Ui$V3$Modal$Medium;
var $author$project$Components$FactorInvoiceAuditForwardEmailModal$viewEmailForwarderElement = function (config) {
	return A3(
		$elm$html$Html$node,
		'ht-email-forwarder',
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'factor-invoice-id',
					$elm$core$String$fromInt(
						$author$project$Domain$FactorInvoiceId$toInt(config.factorInvoiceId))),
					A2(
					$elm$html$Html$Events$on,
					'forward-cancelled',
					$elm$json$Json$Decode$succeed(config.dismissMsg)),
					A2(
					$elm$html$Html$Events$on,
					'forward-done',
					A2(
						$elm$json$Json$Decode$map,
						config.doneMsg,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['detail']),
							$elm$json$Json$Decode$bool)))
				]),
			function () {
				var _v0 = config.emailId;
				if (_v0.$ === 'Just') {
					var eid = _v0.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$Attributes$attribute,
							'email-id',
							$elm$core$String$fromInt(
								$author$project$Domain$EmailMessageId$toInt(eid)))
						]);
				} else {
					return _List_Nil;
				}
			}()),
		_List_Nil);
};
var $author$project$Components$FactorInvoiceAuditForwardEmailModal$view = function (config) {
	return A2(
		$author$project$Ui$V3$Modal$view,
		_List_Nil,
		{
			body: $author$project$Components$FactorInvoiceAuditForwardEmailModal$viewEmailForwarderElement(config),
			cancelButton: $elm$core$Maybe$Nothing,
			dismissMsg: config.dismissMsg,
			footerButtons: _List_Nil,
			header: $author$project$Ui$V3$Modal$textHeader('Forward Email'),
			primaryButton: $elm$core$Maybe$Nothing,
			size: $author$project$Ui$V3$Modal$medium
		});
};
var $author$project$Ui$V3$Modal$NoHeader = {$: 'NoHeader'};
var $author$project$Ui$V3$Modal$noHeader = $author$project$Ui$V3$Modal$NoHeader;
var $author$project$Components$FactorInvoiceAuditIgnoreAllGroupsModal$viewIgnoreEntryElement = function (config) {
	return A3(
		$elm$html$Html$node,
		'ht-ignore-entry',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'document-batch-id',
				$elm$core$String$fromInt(
					$author$project$Domain$DocumentBatchId$toInt(config.documentBatchId))),
				A2(
				$elm$html$Html$Events$on,
				'ignore-complete',
				$elm$json$Json$Decode$succeed(config.ignoreCompleteMsg)),
				A2(
				$elm$html$Html$Events$on,
				'ignore-cancelled',
				$elm$json$Json$Decode$succeed(config.dismissMsg))
			]),
		_List_Nil);
};
var $author$project$Components$FactorInvoiceAuditIgnoreAllGroupsModal$view = function (config) {
	return A2(
		$author$project$Ui$V3$Modal$view,
		_List_Nil,
		{
			body: $author$project$Components$FactorInvoiceAuditIgnoreAllGroupsModal$viewIgnoreEntryElement(config),
			cancelButton: $elm$core$Maybe$Nothing,
			dismissMsg: config.dismissMsg,
			footerButtons: _List_Nil,
			header: $author$project$Ui$V3$Modal$noHeader,
			primaryButton: $elm$core$Maybe$Nothing,
			size: $author$project$Ui$V3$Modal$medium
		});
};
var $author$project$Components$FactorInvoiceAuditMergeEmailModal$viewEmailMergerElement = function (config) {
	var carrierId = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.id;
				},
				A2($elm$core$Basics$composeR, $author$project$Domain$TmsCarrierId$toInt, $elm$core$String$fromInt)),
			config.carrier));
	return A3(
		$elm$html$Html$node,
		'ht-email-merger',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'carrier-id', carrierId),
					A2(
					$elm$html$Html$Events$on,
					'merge-complete',
					$elm$json$Json$Decode$succeed(config.mergeCompleteMsg)),
					A2(
					$elm$html$Html$Events$on,
					'merge-cancelled',
					$elm$json$Json$Decode$succeed(config.dismissMsg))
				]),
			function () {
				var _v0 = config.emailId;
				if (_v0.$ === 'Just') {
					var eid = _v0.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$Attributes$attribute,
							'email-id',
							$elm$core$String$fromInt(
								$author$project$Domain$EmailMessageId$toInt(eid)))
						]);
				} else {
					return _List_Nil;
				}
			}()),
		_List_Nil);
};
var $author$project$Components$FactorInvoiceAuditMergeEmailModal$view = function (config) {
	return A2(
		$author$project$Ui$V3$Modal$view,
		_List_Nil,
		{
			body: $author$project$Components$FactorInvoiceAuditMergeEmailModal$viewEmailMergerElement(config),
			cancelButton: $elm$core$Maybe$Nothing,
			dismissMsg: config.dismissMsg,
			footerButtons: _List_Nil,
			header: $author$project$Ui$V3$Modal$noHeader,
			primaryButton: $elm$core$Maybe$Nothing,
			size: $author$project$Ui$V3$Modal$large
		});
};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewActiveModal = F2(
	function (carrier, model) {
		var _v0 = model.activeHeaderModal;
		if (_v0.$ === 'Just') {
			switch (_v0.a.$) {
				case 'MergeEmail':
					var _v1 = _v0.a;
					return $author$project$Components$FactorInvoiceAuditMergeEmailModal$view(
						{carrier: carrier, dismissMsg: $author$project$Components$FactorInvoiceAuditBatchPage$CloseMergeEmailModal, emailId: model.emailMessageId, mergeCompleteMsg: $author$project$Components$FactorInvoiceAuditBatchPage$MergeEmailComplete});
				case 'IgnoreAllGroups':
					var _v2 = _v0.a;
					return $author$project$Components$FactorInvoiceAuditIgnoreAllGroupsModal$view(
						{dismissMsg: $author$project$Components$FactorInvoiceAuditBatchPage$CloseIgnoreAllGroupsModal, documentBatchId: model.documentBatchId, ignoreCompleteMsg: $author$project$Components$FactorInvoiceAuditBatchPage$IgnoreAllGroupsComplete});
				default:
					var _v3 = _v0.a;
					return $author$project$Components$FactorInvoiceAuditForwardEmailModal$view(
						{dismissMsg: $author$project$Components$FactorInvoiceAuditBatchPage$CloseForwardEmailModal, doneMsg: $author$project$Components$FactorInvoiceAuditBatchPage$ForwardEmailDone, emailId: model.emailMessageId, factorInvoiceId: model.workingArea.factorInvoiceId});
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$forceMarginForToolbarCss = '\u000A    .enable_shared-ui-v3 .document-browser__document-list {\u000A        margin-top: 37px;\u000A    }\u000A    ';
var $author$project$Components$DocumentsBrowser$EnableBolRateConCompare = {$: 'EnableBolRateConCompare'};
var $author$project$Components$DocumentsBrowser$enableBolRateConCompare = $author$project$Components$DocumentsBrowser$EnableBolRateConCompare;
var $author$project$Components$DocumentsBrowser$EnableThumbnailRightClick = {$: 'EnableThumbnailRightClick'};
var $author$project$Components$DocumentsBrowser$enableThumbnailRightClick = $author$project$Components$DocumentsBrowser$EnableThumbnailRightClick;
var $author$project$Components$FactorInvoiceAuditBatchPage$mainViewerOptions = function (model) {
	return _Utils_ap(
		_List_fromArray(
			[
				$author$project$Components$DocumentsBrowser$enableThumbnailRightClick,
				$author$project$Components$DocumentsBrowser$enableLineDragging,
				$author$project$Components$DocumentsBrowser$expandButton(
				{
					expanded: $author$project$Components$AuditSplitPane$isExpanded(model.splitPane)
				}),
				$author$project$Components$DocumentsBrowser$popoutButton
			]),
		model.usesVectorWorkflow ? _List_fromArray(
			[$author$project$Components$DocumentsBrowser$enableBolRateConCompare]) : _List_Nil);
};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewDocumentsBrowser = F3(
	function (tz, model, remoteData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__documents')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
					if (_v0.$ === 'Just') {
						var data = _v0.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit__documents-inner')
								]),
							_List_fromArray(
								[
									A3(
									$elm$html$Html$node,
									'style',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Components$FactorInvoiceAuditBatchPage$forceMarginForToolbarCss)
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Components$FactorInvoiceAuditBatchPage$DocumentsBrowserMsg,
									A4(
										$author$project$Components$DocumentsBrowser$view,
										tz,
										model.documentsBrowser,
										$author$project$Components$FactorInvoiceAuditBatchPage$mainViewerOptions(model),
										data))
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'height', '480px')
								]),
							_List_fromArray(
								[
									$author$project$Ui$V3$Skeleton$view(
									{height: $elm$core$Maybe$Nothing})
								]));
					}
				}()
				]));
	});
var $author$project$Components$FactorInvoiceAuditHeader$viewMetaRow = F2(
	function (label, value) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__header-meta-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__header-meta-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Components$FactorInvoiceAuditHeader$view = F3(
	function (tz, fi, actions) {
		var orDash = $elm$core$Maybe$withDefault('—');
		var senderAddress = orDash(fi.documentBatchEmailDetails.senderAddress);
		var emailSubject = orDash(fi.documentBatchEmailDetails.subject);
		var emailClient = orDash(fi.documentBatchEmailDetails.carrierName);
		var dateTime = A2(
			$elm$core$Maybe$withDefault,
			'—',
			A2(
				$elm$core$Maybe$map,
				function (d) {
					return A2($author$project$Helpers$Date$dateString, tz, d) + (' ' + A2($author$project$Helpers$Date$timeString, tz, d));
				},
				fi.documentBatchEmailDetails.date));
		var accountExec = orDash(fi.documentBatchEmailDetails.carrierAccountExecutive);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__header-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__header-left')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-audit__header-subject')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(emailSubject)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-audit__header-sender')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(senderAddress)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__header-meta')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-audit__header-meta-date')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(dateTime)
										])),
									A2($author$project$Components$FactorInvoiceAuditHeader$viewMetaRow, 'Email Client:', emailClient),
									A2($author$project$Components$FactorInvoiceAuditHeader$viewMetaRow, 'Account Exec:', accountExec)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__header-actions')
								]),
							actions)
						]))
				]));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewHeader = F3(
	function (tz, remoteData, actions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'min-height', '96px')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
					if (_v0.$ === 'Just') {
						var data = _v0.a;
						return A3($author$project$Components$FactorInvoiceAuditHeader$view, tz, data.factorInvoice, actions);
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '1rem 1.5rem')
								]),
							_List_fromArray(
								[
									$author$project$Ui$V3$Skeleton$view(
									{
										height: $elm$core$Maybe$Just(112)
									})
								]));
					}
				}()
				]));
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$ClientNotesPanelMsg = function (a) {
	return {$: 'ClientNotesPanelMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$LastGroup = function (a) {
	return {$: 'LastGroup', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$MoreGroupsRemain = {$: 'MoreGroupsRemain'};
var $author$project$Components$FactorInvoiceAuditBatchPage$approvalScope = function (model) {
	var _v0 = _Utils_Tuple2(model.hasMoreGroups, model.processedCount);
	if (((_v0.a.$ === 'Just') && (!_v0.a.a)) && (_v0.b.$ === 'Just')) {
		var count = _v0.b.a;
		return $author$project$Components$FactorInvoiceAuditWorkingArea$LastGroup(count);
	} else {
		return $author$project$Components$FactorInvoiceAuditWorkingArea$MoreGroupsRemain;
	}
};
var $author$project$Domain$ClientNotesSidebarDisplay$isEnabled = function (display) {
	return !_Utils_eq(display, $author$project$AuditPb$ClientNotesSidebarDisplayDisabled);
};
var $author$project$Components$FactorInvoiceClientNotesPanel$parseNotes = function (maybeText) {
	if (maybeText.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var text = maybeText.a;
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2($elm$core$String$split, '\u000A', text)));
	}
};
var $author$project$Components$FactorInvoiceClientNotesPanel$textByType = F2(
	function (carrier, type_) {
		return A2(
			$elm$core$Maybe$andThen,
			function (c) {
				switch (type_) {
					case 'warning':
						return c.warning;
					case 'funding_notes':
						return c.fundingNotes;
					case 'notes':
						return c.notes;
					case 'verification_notes':
						return c.cadenceVerificationInstructions;
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			carrier);
	});
var $author$project$Components$FactorInvoiceClientNotesPanel$notesByType = F2(
	function (carrier, type_) {
		return $author$project$Components$FactorInvoiceClientNotesPanel$parseNotes(
			A2($author$project$Components$FactorInvoiceClientNotesPanel$textByType, carrier, type_));
	});
var $author$project$Components$FactorInvoiceClientNotesPanel$Toggle = {$: 'Toggle'};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Components$FactorInvoiceClientNotesPanel$sectionLabel = function (type_) {
	switch (type_) {
		case 'warning':
			return 'Warning';
		case 'funding_notes':
			return 'Funding';
		case 'notes':
			return 'Notes';
		case 'verification_notes':
			return 'Verification';
		default:
			var other = type_;
			return other;
	}
};
var $author$project$Components$FactorInvoiceClientNotesPanel$typeModifier = function (type_) {
	switch (type_) {
		case 'warning':
			return 'warning';
		case 'funding_notes':
			return 'funding';
		case 'verification_notes':
			return 'verification';
		default:
			return 'notes';
	}
};
var $author$project$Components$FactorInvoiceClientNotesPanel$viewPill = function (type_) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				'client-notes-card__pill client-notes-card__pill--' + $author$project$Components$FactorInvoiceClientNotesPanel$typeModifier(type_))
			]),
		_List_Nil);
};
var $author$project$Components$FactorInvoiceClientNotesPanel$viewCount = function (_v0) {
	var type_ = _v0.a;
	var notes = _v0.b;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('client-notes-card__count')
			]),
		_List_fromArray(
			[
				$author$project$Components$FactorInvoiceClientNotesPanel$viewPill(type_),
				$elm$html$Html$text(
				$author$project$Components$FactorInvoiceClientNotesPanel$sectionLabel(type_)),
				A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$elm$core$List$length(notes)))
					]))
			]));
};
var $author$project$Components$FactorInvoiceClientNotesPanel$viewHeader = F2(
	function (open, sections) {
		return $elm$core$List$isEmpty(sections) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('client-notes-card__header client-notes-card__header--static')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-notes-card__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Client Notes')
						]))
				])) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('client-notes-card__header'),
					$elm$html$Html$Attributes$type_('button'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-expanded',
					open ? 'true' : 'false'),
					$elm$html$Html$Events$onClick($author$project$Components$FactorInvoiceClientNotesPanel$Toggle)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-notes-card__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Client Notes')
						])),
					open ? $elm$html$Html$text('') : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-notes-card__counts')
						]),
					A2($elm$core$List$map, $author$project$Components$FactorInvoiceClientNotesPanel$viewCount, sections)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-notes-card__toggle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							open ? 'Hide ▴' : 'Show notes ▾')
						]))
				]));
	});
var $author$project$Components$FactorInvoiceClientNotesPanel$viewSection = function (_v0) {
	var type_ = _v0.a;
	var notes = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				'client-notes-card__section client-notes-card__section--' + $author$project$Components$FactorInvoiceClientNotesPanel$typeModifier(type_))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('client-notes-card__section-label')
					]),
				_List_fromArray(
					[
						$author$project$Components$FactorInvoiceClientNotesPanel$viewPill(type_),
						$elm$html$Html$text(
						$author$project$Components$FactorInvoiceClientNotesPanel$sectionLabel(type_))
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('client-notes-card__notes')
					]),
				A2(
					$elm$core$List$map,
					function (note) {
						return A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('client-notes-card__note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(note)
								]));
					},
					notes))
			]));
};
var $author$project$Components$FactorInvoiceClientNotesPanel$view = function (_v0) {
	var model = _v0.model;
	var accountSettings = _v0.accountSettings;
	var carrier = _v0.carrier;
	var warnings = A2(
		$elm$core$List$any,
		function (s) {
			return (s.noteType === 'warning') && (s.display !== 'hide');
		},
		accountSettings.clientNotesConfiguration) ? A2($author$project$Components$FactorInvoiceClientNotesPanel$notesByType, carrier, 'warning') : _List_Nil;
	var sections = A2(
		$elm$core$List$filterMap,
		function (s) {
			var _v1 = A2($author$project$Components$FactorInvoiceClientNotesPanel$notesByType, carrier, s.noteType);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var notes = _v1;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(s.noteType, notes));
			}
		},
		A2(
			$elm$core$List$filter,
			function (s) {
				return (s.noteType !== 'warning') && (s.display !== 'hide');
			},
			accountSettings.clientNotesConfiguration));
	return ((!$author$project$Domain$ClientNotesSidebarDisplay$isEnabled(accountSettings.clientNotesSidebarDisplay)) || ($elm$core$List$isEmpty(warnings) && $elm$core$List$isEmpty(sections))) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('client-notes-card v3_reskin_react__button-overrides-disabled')
			]),
		_List_fromArray(
			[
				A2($author$project$Components$FactorInvoiceClientNotesPanel$viewHeader, model.open, sections),
				$elm$core$List$isEmpty(warnings) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('client-notes-card__warning')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('client-notes-card__warning-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('⚠ WARNING')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('client-notes-card__warning-lines')
							]),
						A2(
							$elm$core$List$map,
							function (line) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('client-notes-card__warning-line')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(line)
										]));
							},
							warnings))
					])),
				$elm$core$List$isEmpty(sections) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('client-notes-card__body', true),
								_Utils_Tuple2('client-notes-card__body--expanded', model.open)
							])),
					$author$project$Components$AuditCheckCard$collapsedAttrs(model.open)),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('client-notes-card__body-track')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('client-notes-card__sections')
									]),
								A2($elm$core$List$map, $author$project$Components$FactorInvoiceClientNotesPanel$viewSection, sections))
							]))
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$ReviewUnsavedEditClicked = {$: 'ReviewUnsavedEditClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreClicked = {$: 'IgnoreClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$RejectClicked = {$: 'RejectClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$SaveAndApproveClicked = {$: 'SaveAndApproveClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$SaveAndSendClicked = {$: 'SaveAndSendClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$SaveAsIncompleteClicked = {$: 'SaveAsIncompleteClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$SaveClicked = {$: 'SaveClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$UnIgnoreClicked = {$: 'UnIgnoreClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$UnapproveClicked = {$: 'UnapproveClicked'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewActionBarButtons = F6(
	function (approvalScope, isApprover, isUnapprover, verificationsWorkflowEnabled, carrierTerm, data) {
		var showReject = _Utils_eq(data.factorInvoice.state, $author$project$Domain$FactorInvoice$Processed);
		var saveAndApproveLabel = function () {
			if (approvalScope.$ === 'LastGroup') {
				var processedCount = approvalScope.a;
				var count = processedCount + 1;
				var pluralized = (count === 1) ? 'Invoice' : 'Invoices';
				return 'Save and Approve ' + ($elm$core$String$fromInt(count) + (' ' + pluralized));
			} else {
				return 'Save and Approve 1 Invoice';
			}
		}();
		var isEditable = $author$project$Domain$FactorInvoice$editable(data.factorInvoice.state);
		var isApproved = _Utils_eq(data.factorInvoice.state, $author$project$Domain$FactorInvoice$Approved);
		var isAbandoned = _Utils_eq(data.factorInvoice.state, $author$project$Domain$FactorInvoice$Abandoned);
		var hasFailingChecks = A2(
			$elm$core$List$any,
			function (check) {
				return _Utils_eq(check.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultFailed) || _Utils_eq(check.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultPending);
			},
			data.auditChecks);
		var showSave = isEditable && (!hasFailingChecks);
		var showSaveAndSend = isEditable && hasFailingChecks;
		var showSaveAsIncomplete = isEditable && hasFailingChecks;
		var awaitingOtherGroups = _Utils_eq(approvalScope, $author$project$Components$FactorInvoiceAuditWorkingArea$MoreGroupsRemain);
		var showSaveAndApprove = isEditable && ((!hasFailingChecks) && (isApprover && ((!verificationsWorkflowEnabled) && (!awaitingOtherGroups))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__action-bar-buttons')
				]),
			_List_fromArray(
				[
					(isApproved && isUnapprover) ? A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditWorkingArea$UnapproveClicked)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
							$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorDanger)
						]),
					'Unapprove') : (showReject ? A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditWorkingArea$RejectClicked)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
							$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorDanger)
						]),
					'Reject') : $elm$html$Html$text('')),
					isAbandoned ? A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditWorkingArea$UnIgnoreClicked)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
						]),
					'Un-Ignore this Invoice') : (isEditable ? A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreClicked)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
							$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorDanger)
						]),
					'Ignore Invoice') : $elm$html$Html$text('')),
					showSaveAndSend ? A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditWorkingArea$SaveAndSendClicked)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
						]),
					'Save and Send to ' + carrierTerm) : $elm$html$Html$text(''),
					showSaveAsIncomplete ? A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditWorkingArea$SaveAsIncompleteClicked)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
						]),
					'Save as Incomplete') : $elm$html$Html$text(''),
					showSave ? A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditWorkingArea$SaveClicked)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantPrimary)
						]),
					'Save') : $elm$html$Html$text(''),
					showSaveAndApprove ? A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditWorkingArea$SaveAndApproveClicked)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantPrimary)
						]),
					saveAndApproveLabel) : $elm$html$Html$text('')
				]));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreCancelled = {$: 'IgnoreCancelled'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreConfirmed = {$: 'IgnoreConfirmed'};
var $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreReasonChanged = function (a) {
	return {$: 'IgnoreReasonChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewIgnoreModal = function (model) {
	return model.ignoreModalOpen ? A2(
		$author$project$Ui$V3$Modal$view,
		_List_Nil,
		{
			body: A4(
				$author$project$Ui$V3$Input$view,
				{onInput: $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreReasonChanged},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$label('Reason'),
						$author$project$Ui$V3$Input$expandable,
						$author$project$Ui$V3$Input$placeholder('Enter reason for ignoring this invoice...')
					]),
				_List_Nil,
				model.ignoreReason),
			cancelButton: $elm$core$Maybe$Just(
				_Utils_Tuple2('Cancel', $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreCancelled)),
			dismissMsg: $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreCancelled,
			footerButtons: _List_Nil,
			header: $author$project$Ui$V3$Modal$textHeader('Ignore Invoice'),
			primaryButton: $elm$core$Maybe$Just(
				_Utils_Tuple2('Ignore Invoice', $author$project$Components$FactorInvoiceAuditWorkingArea$IgnoreConfirmed)),
			size: $author$project$Ui$V3$Modal$small
		}) : $elm$html$Html$text('');
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewActionBar = F3(
	function (approvalScope, remoteData, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'contents')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$AuditUnsavedEdits$viewStrip,
					{onReview: $author$project$Components$FactorInvoiceAuditWorkingArea$ReviewUnsavedEditClicked},
					A2($author$project$Components$FactorInvoiceAuditWorkingArea$unsavedEdits, remoteData, model)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__action-bar')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
							if (_v0.$ === 'Just') {
								var data = _v0.a;
								return A6($author$project$Components$FactorInvoiceAuditWorkingArea$viewActionBarButtons, approvalScope, model.isApprover, model.isUnapprover, model.verificationsWorkflowEnabled, model.carrierTerm, data);
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					$author$project$Components$FactorInvoiceAuditWorkingArea$viewIgnoreModal(model)
				]));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$heldForReviewReasons = function (items) {
	return $elm_community$list_extra$List$Extra$unique(
		A2(
			$elm$core$List$filterMap,
			function (item) {
				var _v0 = item.details;
				if (_v0.$ === 'FlaggedForManualReview') {
					var reason = _v0.a;
					return $elm$core$Maybe$Just(reason);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			items));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$heldForReviewMessages = function (items) {
	return A2(
		$elm$core$List$map,
		function (reason) {
			return 'Held for manual review: ' + $author$project$Domain$ActivityItem$flaggedForManualReviewReasonToString(reason);
		},
		$author$project$Components$FactorInvoiceAuditWorkingArea$heldForReviewReasons(items));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$infoBanner = function (messages) {
	if (messages.b && (!messages.b.b)) {
		var single = messages.a;
		return A2(
			$author$project$Ui$V3$Notification$viewInline,
			{
				message: $elm$html$Html$text(single),
				onClose: $elm$core$Maybe$Nothing,
				title: $elm$core$Maybe$Nothing
			},
			_List_fromArray(
				[$author$project$Ui$V3$Notification$info]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__notification v3__notification--inline v3__notification--info fi-audit__banner')
				]),
			A2(
				$elm$core$List$map,
				function (message) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__banner-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3__notification-icon')
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$info16)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('v3__notification-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									]))
							]));
				},
				messages));
	}
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$stateMessages = F2(
	function (isUnapprover, state) {
		switch (state.$) {
			case 'Abandoned':
				return _List_fromArray(
					['This invoice has been ignored. Un-Ignore it to make changes.']);
			case 'Processed':
				return _List_fromArray(
					['This invoice has been processed. Reject it to make changes.']);
			case 'Approved':
				return isUnapprover ? _List_fromArray(
					['This invoice has been marked approved and cannot be changed. Unapprove it to make changes.']) : _List_fromArray(
					['This invoice has been marked approved and cannot be changed. Contact support if you need to make changes.']);
			case 'Purchased':
				return _List_fromArray(
					['This invoice has been purchased.']);
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewBanners = F2(
	function (remoteData, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Just') {
			var data = _v0.a;
			var _v1 = _Utils_ap(
				A2($author$project$Components$FactorInvoiceAuditWorkingArea$stateMessages, model.isUnapprover, data.factorInvoice.state),
				$author$project$Components$FactorInvoiceAuditWorkingArea$heldForReviewMessages(data.factorInvoice.activityItems));
			if (!_v1.b) {
				return _List_Nil;
			} else {
				var messages = _v1;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__status-banner')
							]),
						_List_fromArray(
							[
								$author$project$Components$FactorInvoiceAuditWorkingArea$infoBanner(messages)
							]))
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Presence$viewInCorner = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('presence__container', true),
						_Utils_Tuple2(
						'hide',
						$elm$core$List$isEmpty(state.others))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('presence__who')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Currently viewed by: ' + A2(
							$elm$core$String$join,
							', ',
							$author$project$Presence$unique(state.others)))
					]))
			]));
};
var $author$project$Components$DocumentsBrowser$EnableCloseButton = {$: 'EnableCloseButton'};
var $author$project$Components$DocumentsBrowser$enableCloseButton = $author$project$Components$DocumentsBrowser$EnableCloseButton;
var $author$project$Components$FactorInvoiceAuditBatchPage$viewSecondaryDocumentsBrowser = F3(
	function (tz, secondary, remoteData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__documents')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
					if (_v0.$ === 'Just') {
						var data = _v0.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit__documents-inner')
								]),
							_List_fromArray(
								[
									A3(
									$elm$html$Html$node,
									'style',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Components$FactorInvoiceAuditBatchPage$forceMarginForToolbarCss)
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Components$FactorInvoiceAuditBatchPage$SecondaryDocumentsBrowserMsg,
									A4(
										$author$project$Components$DocumentsBrowser$view,
										tz,
										secondary,
										_List_fromArray(
											[$author$project$Components$DocumentsBrowser$enableCloseButton]),
										data))
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'height', '480px')
								]),
							_List_fromArray(
								[
									$author$project$Ui$V3$Skeleton$view(
									{height: $elm$core$Maybe$Nothing})
								]));
					}
				}()
				]));
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$viewPendingInvoiceNotice = A2(
	$author$project$Ui$V3$Notification$viewInline,
	{
		message: $elm$html$Html$text('Only the first few invoices in a batch are created immediately; ' + ('the rest follow in the background. This group\u0027s details will ' + 'appear here as soon as its invoice is ready.')),
		onClose: $elm$core$Maybe$Nothing,
		title: $elm$core$Maybe$Just('This group\u0027s invoice is still being created')
	},
	_List_fromArray(
		[$author$project$Ui$V3$Notification$info]));
var $author$project$Domain$Verification$checklistDetails = _List_fromArray(
	[$author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure, $author$project$AuditPb$VerificationFailureMessageUndeliveredFailure, $author$project$AuditPb$VerificationFailureMessageCarrierMismatchFailure, $author$project$AuditPb$VerificationFailureMessageRemitToFailure, $author$project$AuditPb$VerificationFailureMessageAmountMismatchFailure]);
var $author$project$Domain$Verification$checksNeedingTheLoad = A2(
	$elm$core$List$filter,
	function (detail) {
		return !_Utils_eq(detail, $author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure);
	},
	$author$project$Domain$Verification$checklistDetails);
var $author$project$Domain$Verification$pendingChecksHeading = 'Pending load verifications';
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewInlineChecklist = $elm$html$Html$ul(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('fi-audit__verifications-details fi-audit__verifications-details--inline')
		]));
var $author$project$Domain$Verification$detailSubject = function (detail) {
	switch (detail.$) {
		case 'VerificationFailureMessageLoadNotFoundFailure':
			return 'Load';
		case 'VerificationFailureMessageUndeliveredFailure':
			return 'Load delivery';
		case 'VerificationFailureMessageCarrierMismatchFailure':
			return 'Carrier';
		case 'VerificationFailureMessageLoadIssueFailure':
			return 'Load issues';
		case 'VerificationFailureMessagePossibleFeesFailure':
			return 'Load fees';
		case 'VerificationFailureMessageRemitToFailure':
			return 'Remit-to address';
		default:
			return 'Amount';
	}
};
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewNotCheckedDetail = function (detail) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__verifications-item fi-audit__verifications-item--unchecked')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__verifications-icon fi-audit__verifications-icon--unchecked')
					]),
				_List_Nil),
				$elm$html$Html$text(
				$author$project$Domain$Verification$detailSubject(detail))
			]));
};
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewNotCheckedFooter = function (verification) {
	var _v0 = verification.state;
	if (_v0.$ === 'Verification_State_Fail') {
		var failures = _v0.a.failures;
		var mode = _v0.a.mode;
		return (A2(
			$elm$core$List$member,
			$author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.message;
				},
				failures)) && (!_Utils_eq(mode, $author$project$AuditPb$VerificationsModeRestricted))) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__verifications-card-footer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__verifications-unchecked-heading')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Domain$Verification$pendingChecksHeading)
							])),
						$author$project$Components$FactorInvoiceAuditVerificationTab$viewInlineChecklist(
						A2($elm$core$List$map, $author$project$Components$FactorInvoiceAuditVerificationTab$viewNotCheckedDetail, $author$project$Domain$Verification$checksNeedingTheLoad))
					]))
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Domain$Verification$skippedDeliveryMessage = 'Load delivery unconfirmed';
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewChecklist = $elm$html$Html$ul(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('fi-audit__verifications-details')
		]));
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewDetailItem = F2(
	function (iconClass, message) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__verifications-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__verifications-icon ' + iconClass)
						]),
					_List_Nil),
					$elm$html$Html$text(message)
				]));
	});
var $author$project$Components$FactorInvoiceAuditVerificationTab$displayedOnFailureDetails = function (failedDetails) {
	var possibleFeesDetail = A2(
		$elm$core$List$member,
		$author$project$AuditPb$VerificationFailureMessagePossibleFeesFailure,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.message;
			},
			failedDetails)) ? _List_fromArray(
		[$author$project$AuditPb$VerificationFailureMessagePossibleFeesFailure]) : _List_Nil;
	var loadIssueDetail = A2(
		$elm$core$List$member,
		$author$project$AuditPb$VerificationFailureMessageLoadIssueFailure,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.message;
			},
			failedDetails)) ? _List_fromArray(
		[$author$project$AuditPb$VerificationFailureMessageLoadIssueFailure]) : _List_Nil;
	return _Utils_ap(loadIssueDetail, possibleFeesDetail);
};
var $author$project$Domain$Verification$viewDetailMessage = function (failure) {
	var _v0 = _Utils_Tuple2(failure.message, failure.brokerAmount);
	switch (_v0.a.$) {
		case 'VerificationFailureMessageLoadNotFoundFailure':
			var _v1 = _v0.a;
			return 'Load not found';
		case 'VerificationFailureMessageUndeliveredFailure':
			var _v2 = _v0.a;
			return 'Load not delivered';
		case 'VerificationFailureMessageCarrierMismatchFailure':
			var _v3 = _v0.a;
			return 'Carrier does not match';
		case 'VerificationFailureMessageLoadIssueFailure':
			var _v4 = _v0.a;
			return 'Load has an issue';
		case 'VerificationFailureMessagePossibleFeesFailure':
			var _v5 = _v0.a;
			return 'Load may have fees';
		case 'VerificationFailureMessageRemitToFailure':
			var _v6 = _v0.a;
			return 'Remit-to address does not match';
		default:
			if (_v0.b.$ === 'Nothing') {
				var _v7 = _v0.a;
				var _v8 = _v0.b;
				return 'Amount does not match';
			} else {
				var _v9 = _v0.a;
				var brokerAmount_ = _v0.b.a;
				return 'Amount does not match the broker\u0027s ' + $author$project$Money$toString(
					$author$project$Money$castFromString(brokerAmount_));
			}
	}
};
var $author$project$Domain$Verification$viewPassedDetailMessage = F2(
	function (maybeLoadId, detail) {
		switch (detail.$) {
			case 'VerificationFailureMessageLoadNotFoundFailure':
				return A2(
					$elm$core$Maybe$withDefault,
					'Load found',
					A2(
						$elm$core$Maybe$map,
						function (loadId) {
							return 'Load #' + (loadId + ' found');
						},
						maybeLoadId));
			case 'VerificationFailureMessageUndeliveredFailure':
				return 'Load delivered';
			case 'VerificationFailureMessageCarrierMismatchFailure':
				return 'Carrier matches';
			case 'VerificationFailureMessageLoadIssueFailure':
				return 'Load has no issues';
			case 'VerificationFailureMessagePossibleFeesFailure':
				return 'Load has no fees';
			case 'VerificationFailureMessageRemitToFailure':
				return 'Remit-to address matches';
			default:
				return 'Amount matches';
		}
	});
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewMaybeFailedDetail = F4(
	function (mode, loadId, failedDetails, detailType) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(
				false,
				{brokerAmount: $elm$core$Maybe$Nothing, message: detailType}),
			A2(
				$elm$core$Maybe$map,
				function (d) {
					return _Utils_Tuple2(true, d);
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (d) {
						return _Utils_eq(d.message, detailType);
					},
					failedDetails)));
		var failed = _v0.a;
		var detail = _v0.b;
		return failed ? $elm$core$Maybe$Just(
			A2(
				$author$project$Components$FactorInvoiceAuditVerificationTab$viewDetailItem,
				'fi-audit__verifications-icon--fail',
				$author$project$Domain$Verification$viewDetailMessage(detail))) : ((!_Utils_eq(mode, $author$project$AuditPb$VerificationsModeRestricted)) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Components$FactorInvoiceAuditVerificationTab$viewDetailItem,
				'fi-audit__verifications-icon--pass',
				A2($author$project$Domain$Verification$viewPassedDetailMessage, loadId, detail.message))) : $elm$core$Maybe$Nothing);
	});
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewFailedVerificationDetails = F3(
	function (mode, loadId, failedDetails) {
		if (A2(
			$elm$core$List$member,
			$author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.message;
				},
				failedDetails))) {
			return $author$project$Components$FactorInvoiceAuditVerificationTab$viewChecklist(
				_List_fromArray(
					[
						A2(
						$author$project$Components$FactorInvoiceAuditVerificationTab$viewDetailItem,
						'fi-audit__verifications-icon--fail',
						$author$project$Domain$Verification$viewDetailMessage(
							{brokerAmount: $elm$core$Maybe$Nothing, message: $author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure}))
					]));
		} else {
			var allDetails = _Utils_ap(
				$author$project$Domain$Verification$checklistDetails,
				$author$project$Components$FactorInvoiceAuditVerificationTab$displayedOnFailureDetails(failedDetails));
			return $author$project$Components$FactorInvoiceAuditVerificationTab$viewChecklist(
				A2(
					$elm$core$List$filterMap,
					A3($author$project$Components$FactorInvoiceAuditVerificationTab$viewMaybeFailedDetail, mode, loadId, failedDetails),
					allDetails));
		}
	});
var $author$project$Domain$Verification$severityClass = function (severity) {
	switch (severity.$) {
		case 'Clear':
			return 'clear';
		case 'Alert':
			return 'alert';
		case 'Checking':
			return 'checking';
		default:
			return 'unverifiable';
	}
};
var $author$project$Domain$Verification$Alert = {$: 'Alert'};
var $author$project$Domain$Verification$Checking = {$: 'Checking'};
var $author$project$Domain$Verification$Clear = {$: 'Clear'};
var $author$project$Domain$Verification$Unverifiable = {$: 'Unverifiable'};
var $author$project$Domain$Verification$verdict = function (verification) {
	var _v0 = verification.state;
	switch (_v0.$) {
		case 'Verification_State_Success':
			return {explanation: $elm$core$Maybe$Nothing, glyph: 'fi-check', label: 'All Clear', severity: $author$project$Domain$Verification$Clear};
		case 'Verification_State_Fail':
			return {explanation: $elm$core$Maybe$Nothing, glyph: 'fi-alert', label: 'Alert', severity: $author$project$Domain$Verification$Alert};
		case 'Verification_State_Pending':
			return {
				explanation: $elm$core$Maybe$Just('Still checking this load'),
				glyph: 'fi-clock',
				label: 'Checking',
				severity: $author$project$Domain$Verification$Checking
			};
		case 'Verification_State_NonParticipatingCarrier':
			return {
				explanation: $elm$core$Maybe$Just('Nonparticipating or unmatched carrier. This may be due to a missing MC# in your FMS'),
				glyph: 'fi-prohibited',
				label: 'Carrier Not Participating',
				severity: $author$project$Domain$Verification$Unverifiable
			};
		case 'Verification_State_UnverifiableLoad':
			return {
				explanation: $elm$core$Maybe$Just('This load cannot be verified'),
				glyph: 'fi-prohibited',
				label: 'Load Not Verifiable',
				severity: $author$project$Domain$Verification$Unverifiable
			};
		default:
			return {explanation: $elm$core$Maybe$Nothing, glyph: 'fi-check', label: 'Verified, Delivery Unconfirmed', severity: $author$project$Domain$Verification$Clear};
	}
};
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewUnverifiedDetail = function (verification) {
	var _v0 = $author$project$Domain$Verification$verdict(verification);
	var explanation = _v0.explanation;
	var severity = _v0.severity;
	var label = _v0.label;
	return A2(
		$author$project$Components$FactorInvoiceAuditVerificationTab$viewDetailItem,
		'fi-audit__verifications-icon--' + $author$project$Domain$Verification$severityClass(severity),
		A2($elm$core$Maybe$withDefault, label, explanation));
};
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewVerificationDetails = F2(
	function (loadId, verification) {
		var _v0 = verification.state;
		switch (_v0.$) {
			case 'Verification_State_Success':
				return $author$project$Components$FactorInvoiceAuditVerificationTab$viewChecklist(
					A2(
						$elm$core$List$map,
						function (d) {
							return A2(
								$author$project$Components$FactorInvoiceAuditVerificationTab$viewDetailItem,
								'fi-audit__verifications-icon--pass',
								A2($author$project$Domain$Verification$viewPassedDetailMessage, loadId, d));
						},
						$author$project$Domain$Verification$checklistDetails));
			case 'Verification_State_Fail':
				var failures = _v0.a.failures;
				var mode = _v0.a.mode;
				return A3($author$project$Components$FactorInvoiceAuditVerificationTab$viewFailedVerificationDetails, mode, loadId, failures);
			case 'Verification_State_Pending':
				return $author$project$Components$FactorInvoiceAuditVerificationTab$viewChecklist(
					_List_fromArray(
						[
							$author$project$Components$FactorInvoiceAuditVerificationTab$viewUnverifiedDetail(verification)
						]));
			case 'Verification_State_NonParticipatingCarrier':
				return $author$project$Components$FactorInvoiceAuditVerificationTab$viewChecklist(
					_List_fromArray(
						[
							$author$project$Components$FactorInvoiceAuditVerificationTab$viewUnverifiedDetail(verification)
						]));
			case 'Verification_State_UnverifiableLoad':
				return $author$project$Components$FactorInvoiceAuditVerificationTab$viewChecklist(
					_List_fromArray(
						[
							$author$project$Components$FactorInvoiceAuditVerificationTab$viewUnverifiedDetail(verification)
						]));
			default:
				return $author$project$Components$FactorInvoiceAuditVerificationTab$viewChecklist(
					A2(
						$elm$core$List$map,
						function (d) {
							if (d.$ === 'VerificationFailureMessageUndeliveredFailure') {
								return A2($author$project$Components$FactorInvoiceAuditVerificationTab$viewDetailItem, 'fi-audit__verifications-icon--skipped', $author$project$Domain$Verification$skippedDeliveryMessage);
							} else {
								return A2(
									$author$project$Components$FactorInvoiceAuditVerificationTab$viewDetailItem,
									'fi-audit__verifications-icon--pass',
									A2($author$project$Domain$Verification$viewPassedDetailMessage, loadId, d));
							}
						},
						$author$project$Domain$Verification$checklistDetails));
		}
	});
var $author$project$Domain$FactorBroker$inNetworkVerifications = function (factorBroker) {
	var typeIsInNetwork = function (verificationType) {
		switch (verificationType.$) {
			case 'FactorBrokerVerificationTypeScraper':
				return false;
			case 'FactorBrokerVerificationTypeHubtranCustomer':
				return true;
			case 'FactorBrokerVerificationTypeOnDemandScraper':
				return false;
			case 'FactorBrokerVerificationTypeHubtranMultiAccountCustomer':
				return true;
			default:
				return false;
		}
	};
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, typeIsInNetwork, factorBroker.verificationsType));
};
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewVerificationSourceTooltip = function (maybeDebtor) {
	if (maybeDebtor.$ === 'Just') {
		var debtor = maybeDebtor.a;
		return $author$project$Domain$FactorBroker$inNetworkVerifications(debtor) ? A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-info fi-audit__verifications-info'),
					$elm$html$Html$Attributes$title('Data provided by the debtor\u0027s TMS.')
				]),
			_List_Nil) : $elm$html$Html$text('');
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoiceAuditVerificationTab$viewVerificationStatusLabel = function (verification) {
	var _v0 = $author$project$Domain$Verification$verdict(verification);
	var glyph = _v0.glyph;
	var severity = _v0.severity;
	var label = _v0.label;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				'fi-audit__verifications-label fi-audit__verifications-label--' + $author$project$Domain$Verification$severityClass(severity))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(glyph),
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
					]),
				_List_Nil),
				$elm$html$Html$text(label)
			]));
};
var $author$project$Components$FactorInvoiceAuditVerificationTab$view = function (remoteData) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'min-height', '200px')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
				if (_v0.$ === 'Just') {
					var data = _v0.a;
					var _v1 = data.verification;
					if (_v1.$ === 'Just') {
						var verification = _v1.a;
						var cardModifier = function () {
							var _v2 = verification.state;
							if (_v2.$ === 'Verification_State_Fail') {
								return 'fi-audit__verifications-card--fail';
							} else {
								return 'fi-audit__verifications-card--pass';
							}
						}();
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__verifications-card ' + cardModifier)
								]),
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fi-audit__verifications-card-header')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('fi-audit__verifications-card-title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Debtor Verification Results')
													])),
												$author$project$Components$FactorInvoiceAuditVerificationTab$viewVerificationStatusLabel(verification),
												$author$project$Components$FactorInvoiceAuditVerificationTab$viewVerificationSourceTooltip(data.assignedDebtor)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fi-audit__verifications-card-body')
											]),
										_List_fromArray(
											[
												A2($author$project$Components$FactorInvoiceAuditVerificationTab$viewVerificationDetails, data.loadId, verification)
											]))
									]),
								$author$project$Components$FactorInvoiceAuditVerificationTab$viewNotCheckedFooter(verification)));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__verifications-card')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-audit__verifications-card-header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fi-audit__verifications-card-title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Debtor Verification Results')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-audit__verifications-card-body')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('No verification data available for this invoice.')
												]))
										]))
								]));
					}
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Components$BrokeredCarrierDropdown$selectedName = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.text;
		},
		$elm$core$List$head(
			$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown)));
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$auditChecksConfig = F3(
	function (tz, data, model) {
		return {
			assignedCarrier: data.assignedCarrier,
			assignedDebtor: data.assignedDebtor,
			auditChecks: data.auditChecks,
			brokeredCarrierDropdown: model.brokeredCarrierDropdown,
			brokeredCarrierDropdownData: data.brokeredCarrierDropdownData,
			brokeredCarrierName: $author$project$Components$BrokeredCarrierDropdown$selectedName(model.brokeredCarrierDropdown),
			brokeredCarrierTermDropdown: model.brokeredCarrierTermDropdown,
			brokeredCarrierTermDropdownData: data.brokeredCarrierTermDropdownData,
			carrierAmount: data.factorInvoice.carrierAmount,
			carrierDropdown: model.carrierDropdown,
			carrierDropdownData: data.carrierDropdownData,
			carrierTerm: model.carrierTerm,
			customInvoiceExceptionMessages: model.customInvoiceExceptionMessages,
			debtorDropdown: model.debtorDropdown,
			debtorDropdownData: data.debtorDropdownData,
			duplicateInvoices: data.duplicateInvoices,
			enabledDocumentTypes: model.enabledDocumentTypes,
			factorInvoice: data.factorInvoice,
			formattedAmount: data.factorInvoice.formattedAmount,
			invoiceAmount: data.factorInvoice.amount,
			invoiceDate: data.factorInvoice.invoiceDate,
			invoiceNumber: data.factorInvoice.invoiceNumber,
			isFactor: model.isFactor,
			isReadOnly: $author$project$Domain$FactorInvoice$readOnly(data.factorInvoice.state),
			loadId: data.factorInvoice.loadId,
			pathContext: {
				isReadonly: $author$project$Domain$FactorInvoice$readOnly(data.factorInvoice.state),
				useFactorInvoiceWorkflowPage: model.useFactorInvoiceWorkflowPage
			},
			podDocuments: data.podDocuments,
			selectedCarrier: data.selectedCarrier,
			selectedDebtor: data.selectedDebtor,
			showVendorId: model.showVendorId,
			timeZone: tz,
			unidentifiedDocuments: data.unidentifiedDocuments
		};
	});
var $author$project$Components$FactorInvoiceAuditChecks$AddExceptionEventMsg = function (a) {
	return {$: 'AddExceptionEventMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$ToggleFailedCheck = function (a) {
	return {$: 'ToggleFailedCheck', a: a};
};
var $author$project$Components$AuditCheckCard$AllConfirmed = {$: 'AllConfirmed'};
var $author$project$Components$AuditCheckCard$AllIgnored = {$: 'AllIgnored'};
var $author$project$Components$AuditCheckCard$AtLeastOneResolved = {$: 'AtLeastOneResolved'};
var $author$project$Components$FactorInvoiceAuditFailedCheck$cardState = function (check) {
	var _v0 = check.result;
	switch (_v0.$) {
		case 'FactorInvoiceAuditCheckResultFailed':
			return $elm$core$Maybe$Just($author$project$Components$AuditCheckCard$Failing);
		case 'FactorInvoiceAuditCheckResultPending':
			return $elm$core$Maybe$Just($author$project$Components$AuditCheckCard$Failing);
		case 'FactorInvoiceAuditCheckResultResolved':
			return $elm$core$Maybe$Just($author$project$Components$AuditCheckCard$AtLeastOneResolved);
		case 'FactorInvoiceAuditCheckResultIgnored':
			var _v1 = check.details;
			if (_v1.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
				var ruleCheck = _v1.a;
				return A2(
					$elm$core$List$all,
					function ($) {
						return $.confirmable;
					},
					ruleCheck.ignoredRules) ? $elm$core$Maybe$Just($author$project$Components$AuditCheckCard$AllConfirmed) : $elm$core$Maybe$Just($author$project$Components$AuditCheckCard$AllIgnored);
			} else {
				return $elm$core$Maybe$Just($author$project$Components$AuditCheckCard$AllIgnored);
			}
		case 'FactorInvoiceAuditCheckResultPassed':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheck$failureMessages = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		return A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.message;
			},
			ruleCheck.failedRules);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$isDuplicateInvoiceCheck = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		var _v1 = ruleCheck.checkType.check;
		if (_v1.$ === 'FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck') {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$documentPresenceTitle = function (requirement) {
	switch (requirement.$) {
		case 'DocumentPresenceRequirementRateConfirmationRequired':
			return 'Rate Confirmation';
		case 'DocumentPresenceRequirementBillOfLadingRequired':
			return 'Bill of Lading';
		case 'DocumentPresenceRequirementPODRequired':
			return 'Delivery Receipt';
		case 'DocumentPresenceRequirementDebtorVisibleDocumentRequired':
			return 'Debtor-Visible Documents';
		case 'DocumentPresenceRequirementClientInvoiceRequired':
			return 'Client Invoice';
		case 'DocumentPresenceRequirementCarrierInvoiceRequired':
			return 'Brokered Carrier Invoice';
		case 'DocumentPresenceRequirementCarrierRateConfirmationRequired':
			return 'Brokered Carrier Rate Confirmation';
		case 'DocumentPresenceRequirementRequireDoctypes':
			return 'Unidentified Documents';
		case 'DocumentPresenceRequirementDocumentsRequired':
			return 'Documents Required';
		default:
			return 'Debtor-Required Documents';
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$titleFor = F2(
	function (config, check) {
		var _v0 = check.details;
		if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
			var ruleCheck = _v0.a;
			var _v1 = ruleCheck.checkType.check;
			switch (_v1.$) {
				case 'FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck':
					return 'Invoice Amount';
				case 'FactorInvoiceAuditCheckType_Check_InvoiceDateCheck':
					return 'Invoice Date';
				case 'FactorInvoiceAuditCheckType_Check_DocumentPresenceCheck':
					var doc = _v1.a;
					return $author$project$Components$FactorInvoiceAuditChecks$documentPresenceTitle(doc.requirement);
				case 'FactorInvoiceAuditCheckType_Check_PODRequiredCheck':
					return 'Proof of Delivery';
				case 'FactorInvoiceAuditCheckType_Check_CarrierRequiredCheck':
					return config.carrierTerm;
				case 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck':
					return 'Debtor';
				case 'FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck':
					return 'Load ID';
				case 'FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck':
					return 'Invoice Number';
				case 'FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck':
					return 'Duplicate Invoice';
				case 'FactorInvoiceAuditCheckType_Check_RateConBolConsistencyCheck':
					return 'Rate Confirmation and BOL Consistency';
				case 'FactorInvoiceAuditCheckType_Check_BrokerClientRequirementsCheck':
					return 'Brokered Carrier Amount';
				case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierCheck':
					return 'Brokered Carrier';
				case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierTermsCheck':
					return 'Brokered Carrier Terms';
				case 'FactorInvoiceAuditCheckType_Check_FactorLaneRateCheck':
					return 'Lane Rate';
				case 'FactorInvoiceAuditCheckType_Check_FundingInstructionsDetectedCheck':
					return 'Funding Instructions';
				case 'FactorInvoiceAuditCheckType_Check_ClientDebtorRelationshipCheck':
					return 'Client/Debtor Relationship';
				case 'FactorInvoiceAuditCheckType_Check_InvoiceDeliveryDateCheck':
					return 'Delivery Date';
				default:
					return 'Max Amount Review';
			}
		} else {
			var event = _v0.a;
			return A2($elm$core$Maybe$withDefault, '', event.message);
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$cardTitle = F2(
	function (config, check) {
		return $author$project$Components$FactorInvoiceAuditChecks$isDuplicateInvoiceCheck(check) ? A2($author$project$Components$FactorInvoiceAuditChecks$titleFor, config, check) : A2(
			$author$project$Components$AuditCheckCard$titleWithLoneMessage,
			A2($author$project$Components$FactorInvoiceAuditChecks$titleFor, config, check),
			$author$project$Components$FactorInvoiceAuditFailedCheck$failureMessages(check));
	});
var $author$project$Components$FactorInvoiceAuditChecks$hasUnsavedEditFor = F3(
	function (config, model, checkId) {
		return A2(
			$elm$core$List$any,
			function (edit) {
				return _Utils_eq(edit.checkId, checkId);
			},
			A2($author$project$Components$FactorInvoiceAuditChecks$unsavedEdits, config, model));
	});
var $author$project$Components$FactorInvoiceAuditChecks$settledIconClass = function (state) {
	_v0$3:
	while (true) {
		if (state.$ === 'Just') {
			switch (state.a.$) {
				case 'AtLeastOneResolved':
					var _v1 = state.a;
					return 'invoice-audit__sticky-icon fi-audit__sticky-icon--resolved-passed';
				case 'AllConfirmed':
					var _v2 = state.a;
					return 'invoice-audit__sticky-icon fi-audit__sticky-icon--resolved-passed';
				case 'AllIgnored':
					var _v3 = state.a;
					return 'invoice-audit__sticky-icon fi-audit__sticky-icon--resolved-ignored';
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 'invoice-audit__sticky-icon invoice-audit__sticky-icon--open';
};
var $author$project$Components$FactorInvoiceAuditChecks$ExceptionEventMsg = F2(
	function (a, b) {
		return {$: 'ExceptionEventMsg', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditChecks$UnignoreClicked = function (a) {
	return {$: 'UnignoreClicked', a: a};
};
var $author$project$Components$AuditFailureHistory$Resolved = {$: 'Resolved'};
var $author$project$Components$AuditFailureHistory$Confirmed = {$: 'Confirmed'};
var $author$project$Components$FactorInvoiceAuditFailedCheck$ignoredKindForRule = function (rule) {
	return rule.confirmable ? $author$project$Components$AuditFailureHistory$Confirmed : $author$project$Components$AuditFailureHistory$Ignored;
};
var $author$project$Components$FactorInvoiceAuditFailedCheck$resolutionDisplayText = function (resolution) {
	return A2(
		$elm$core$Maybe$withDefault,
		'[No resolution message provided]',
		A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			resolution));
};
var $author$project$Components$FactorInvoiceAuditFailedCheck$viewRuleRow = F3(
	function (config, kind, rule) {
		return $author$project$Components$AuditFailureHistory$viewRuleRow(
			{
				isDisabled: config.isReadOnly,
				kind: kind,
				onUnignore: config.onUnignore(rule.ruleEvaluationId),
				text: A2($elm$core$Maybe$withDefault, rule.ruleType, rule.message)
			});
	});
var $author$project$Components$FactorInvoiceAuditFailedCheck$viewResolvedOrIgnoredRules = F2(
	function (config, check) {
		var _v0 = check.details;
		if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
			var ruleCheck = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2($author$project$Components$FactorInvoiceAuditFailedCheck$viewRuleRow, config, $author$project$Components$AuditFailureHistory$Resolved),
						ruleCheck.resolvedRules),
					A2(
						$elm$core$List$map,
						function (rule) {
							return A3(
								$author$project$Components$FactorInvoiceAuditFailedCheck$viewRuleRow,
								config,
								$author$project$Components$FactorInvoiceAuditFailedCheck$ignoredKindForRule(rule),
								rule);
						},
						ruleCheck.ignoredRules)));
		} else {
			var exceptionEvent = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__resolved-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__resolved-now fi-audit__resolved-now--passing'),
								$elm$html$Html$Attributes$title('Resolved')
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$checkCircle16)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__resolved')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Components$FactorInvoiceAuditFailedCheck$resolutionDisplayText(exceptionEvent.resolution))
							]))
					]));
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$BrokerClientBrokeredCarrierMsg = function (a) {
	return {$: 'BrokerClientBrokeredCarrierMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$BrokerClientBrokeredCarrierTermsMsg = function (a) {
	return {$: 'BrokerClientBrokeredCarrierTermsMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$BrokerClientCarrierAmountMsg = function (a) {
	return {$: 'BrokerClientCarrierAmountMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$CarrierRequiredMsg = function (a) {
	return {$: 'CarrierRequiredMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg = function (a) {
	return {$: 'CommonActionMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$DebtorField = {$: 'DebtorField'};
var $author$project$Components$FactorInvoiceAuditChecks$DebtorRequiredMsg = function (a) {
	return {$: 'DebtorRequiredMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$DuplicateInvoiceMsg = function (a) {
	return {$: 'DuplicateInvoiceMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$InvoiceAmountField = {$: 'InvoiceAmountField'};
var $author$project$Components$FactorInvoiceAuditChecks$InvoiceAmountMsg = function (a) {
	return {$: 'InvoiceAmountMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$InvoiceDateField = {$: 'InvoiceDateField'};
var $author$project$Components$FactorInvoiceAuditChecks$InvoiceDateMsg = function (a) {
	return {$: 'InvoiceDateMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$InvoiceNumberField = {$: 'InvoiceNumberField'};
var $author$project$Components$FactorInvoiceAuditChecks$InvoiceNumberMsg = function (a) {
	return {$: 'InvoiceNumberMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$LoadIdField = {$: 'LoadIdField'};
var $author$project$Components$FactorInvoiceAuditChecks$LoadIdMsg = function (a) {
	return {$: 'LoadIdMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$editedFrom = F3(
	function (config, model, checkId) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.saved;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (edit) {
						return _Utils_eq(edit.checkId, checkId);
					},
					A2($author$project$Components$FactorInvoiceAuditChecks$unsavedEdits, config, model))));
	});
var $author$project$Components$FactorInvoiceAuditChecks$resolveLeafInput = F2(
	function (edited, extracted) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm_community$maybe_extra$Maybe$Extra$orElse, extracted, edited));
	});
var $author$project$Components$FactorInvoiceAuditChecks$shownDraft = F3(
	function (field, stored, model) {
		return A3(
			$author$project$Components$AuditDrafts$shown,
			field,
			A2($elm$core$Maybe$withDefault, '', stored),
			model.drafts);
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$update = function (msg) {
	var ruleResultId = msg.a;
	return $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId);
};
var $author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$update = function (msg) {
	var ruleResultId = msg.a;
	return $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId);
};
var $author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$update = function (msg) {
	var ruleResultId = msg.a;
	return $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId);
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$update = function (msg) {
	var ruleResultId = msg.a;
	return $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId);
};
var $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$update = function (msg) {
	var ruleResultId = msg.a;
	return $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId);
};
var $author$project$Components$FactorInvoiceAuditCheckActions$SetIsTonu = function (a) {
	return {$: 'SetIsTonu', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$update = function (msg) {
	switch (msg.$) {
		case 'IgnoreClicked':
			var ruleResultId = msg.a;
			return $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId);
		case 'ThumbnailClicked':
			var pageId = msg.a;
			return $author$project$Components$FactorInvoiceAuditCheckActions$SelectDocumentPage(pageId);
		default:
			var isTonu = msg.a;
			return $author$project$Components$FactorInvoiceAuditCheckActions$SetIsTonu(isTonu);
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$update = function (msg) {
	var ruleResultId = msg.a;
	return $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId);
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$DropdownMsg = function (a) {
	return {$: 'DropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$SaveClicked = {$: 'SaveClicked'};
var $author$project$Ui$V3$CustomSelect$DisabledAttribute = function (a) {
	return {$: 'DisabledAttribute', a: a};
};
var $author$project$Ui$V3$CustomSelect$disabled = $author$project$Ui$V3$CustomSelect$DisabledAttribute;
var $author$project$Components$BrokeredCarrierDropdown$view = F3(
	function (attrs, data, model) {
		return A4(
			$author$project$Components$PaginatedDropdown$view,
			$author$project$Components$BrokeredCarrierDropdown$brokeredCarrierToDropdownItem,
			data,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$V3$CustomSelect$label('Brokered Carrier'),
				attrs),
			model.dropdown);
	});
var $author$project$Components$FactorInvoiceAuditCheckActions$hasConfirmableRule = function (failedRules) {
	return A2(
		$elm$core$List$any,
		function (r) {
			return r.confirmable && (!r.unskippable);
		},
		failedRules);
};
var $author$project$Components$FactorInvoiceAuditCheckActions$ignoreButton = F2(
	function (onIgnore, ruleEvaluationId) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__action-end')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(
							onIgnore(ruleEvaluationId))
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
							$author$project$Components$AuditCheckActions$buttonSize
						]),
					'Ignore')
				]));
	});
var $author$project$Components$FactorInvoiceAuditCheckActions$skippableRule = function (failedRules) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (r) {
				return !r.unskippable;
			},
			failedRules));
};
var $author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton = F2(
	function (onIgnore, failedRules) {
		if ($author$project$Components$FactorInvoiceAuditCheckActions$hasConfirmableRule(failedRules)) {
			return $elm$html$Html$text('');
		} else {
			var _v0 = $author$project$Components$FactorInvoiceAuditCheckActions$skippableRule(failedRules);
			if (_v0.$ === 'Just') {
				var r = _v0.a;
				return A2($author$project$Components$FactorInvoiceAuditCheckActions$ignoreButton, onIgnore, r.ruleEvaluationId);
			} else {
				return $elm$html$Html$text('');
			}
		}
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$viewBody = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body'),
				A2($elm$html$Html$Attributes$attribute, 'data-testid', 'bcr-brokered-carrier-section')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$elm$html$Html$map,
							$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$DropdownMsg,
							A3(
								$author$project$Components$BrokeredCarrierDropdown$view,
								_List_fromArray(
									[
										$author$project$Ui$V3$CustomSelect$disabled(config.isReadOnly)
									]),
								config.dropdownData,
								config.dropdown))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$elm$html$Html$text(''))
					])),
				config.isReadOnly ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						$author$project$Components$AuditCheckActions$viewPrimaryButton(
						{label: 'Save Carrier', onClick: $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$SaveClicked}),
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$IgnoreClicked, config.failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$DropdownMsg = function (a) {
	return {$: 'DropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$SaveClicked = {$: 'SaveClicked'};
var $author$project$Components$BrokeredCarrierTermDropdown$view = F3(
	function (attrs, data, model) {
		return A4(
			$author$project$Components$PaginatedDropdown$view,
			$author$project$Components$BrokeredCarrierTermDropdown$brokeredCarrierTermToDropdownItem,
			data,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$V3$CustomSelect$label('Brokered Carrier Term'),
				attrs),
			model.dropdown);
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$viewBody = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body'),
				A2($elm$html$Html$Attributes$attribute, 'data-testid', 'bcr-brokered-carrier-term-section')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$elm$html$Html$map,
							$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$DropdownMsg,
							A3(
								$author$project$Components$BrokeredCarrierTermDropdown$view,
								_List_fromArray(
									[
										$author$project$Ui$V3$CustomSelect$disabled(config.isReadOnly)
									]),
								config.dropdownData,
								config.dropdown))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$elm$html$Html$text(''))
					])),
				config.isReadOnly ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						$author$project$Components$AuditCheckActions$viewPrimaryButton(
						{label: 'Save Terms', onClick: $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$SaveClicked}),
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$IgnoreClicked, config.failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$AmountInputChanged = function (a) {
	return {$: 'AmountInputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$FindValueClicked = function (a) {
	return {$: 'FindValueClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$RevertClicked = {$: 'RevertClicked'};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$SaveClicked = function (a) {
	return {$: 'SaveClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$viewBody = F2(
	function (config, model) {
		var currentValue = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm_community$maybe_extra$Maybe$Extra$orElse, config.carrierAmount, model.amountInput));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__check-body'),
					A2($elm$html$Html$Attributes$attribute, 'data-testid', 'bcr-carrier-amount-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit-check__input-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit-check__input'),
									$author$project$Components$AuditUnsavedValue$unsavedClass(config.editedFrom)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$V3$Input$view,
									{onInput: $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$AmountInputChanged},
									_List_fromArray(
										[
											$author$project$Ui$V3$Input$label('Brokered Carrier Amount'),
											$author$project$Ui$V3$Input$placeholder('Enter brokered carrier amount'),
											$author$project$Ui$V3$Input$disabled(config.isReadOnly)
										]),
									_List_Nil,
									currentValue),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn'),
											$elm$html$Html$Attributes$title('Show on document'),
											$elm$html$Html$Events$onClick(
											$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$FindValueClicked(currentValue))
										]),
									_List_fromArray(
										[
											A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
										]))
								]))
						])),
					$author$project$Components$AuditUnsavedValue$view(
					{editedFrom: config.editedFrom, onRevert: $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$RevertClicked}),
					config.isReadOnly ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__check-actions')
						]),
					_List_fromArray(
						[
							$author$project$Components$AuditCheckActions$viewPrimaryButton(
							{
								label: 'Save Amount',
								onClick: $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$SaveClicked(currentValue)
							}),
							A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$IgnoreClicked, config.failedRules)
						]))
				]));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$DropdownMsg = function (a) {
	return {$: 'DropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$SaveClicked = {$: 'SaveClicked'};
var $author$project$Components$CarrierDetails$hasLine1AndCity = function (_v0) {
	var city = _v0.city;
	var addressLine1 = _v0.addressLine1;
	var _v1 = _Utils_Tuple2(addressLine1, city);
	if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$CarrierDetails$preferredAddress = function (tmsCarrier) {
	return $author$project$Components$CarrierDetails$hasLine1AndCity(tmsCarrier.address) ? $elm$core$Maybe$Just(tmsCarrier.address) : A2(
		$elm$core$Maybe$andThen,
		function (addr) {
			return $author$project$Components$CarrierDetails$hasLine1AndCity(addr) ? $elm$core$Maybe$Just(addr) : $elm$core$Maybe$Nothing;
		},
		tmsCarrier.paymentAddress);
};
var $author$project$Components$CarrierDetails$body = function (str) {
	return A2($author$project$Ui$V3$Typography$body, _List_Nil, str);
};
var $author$project$Components$CarrierDetails$viewAddress = function (address) {
	var keepIfNonBlank = $elm$core$List$filterMap(
		$elm$core$Maybe$andThen($elm_community$string_extra$String$Extra$nonBlank));
	var joinedWith = F2(
		function (sep, parts) {
			return $elm_community$string_extra$String$Extra$nonBlank(
				A2(
					$elm$core$String$join,
					sep,
					keepIfNonBlank(parts)));
		});
	var joinedAddressLines = A2(
		joinedWith,
		' - ',
		_List_fromArray(
			[address.addressLine1, address.addressLine2]));
	var cityState = A2(
		joinedWith,
		' ',
		_List_fromArray(
			[address.city, address.state]));
	var cityStateZip = A2(
		joinedWith,
		', ',
		_List_fromArray(
			[cityState, address.postalCode]));
	return A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$elm$core$Maybe$map($author$project$Components$CarrierDetails$body),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(address.name),
					joinedAddressLines,
					cityStateZip,
					address.country
				])));
};
var $author$project$Components$CarrierDetails$heading = function (str) {
	return A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Components$CarrierDetails$identityLine = function (_v0) {
	var showVendorId = _v0.showVendorId;
	var isFactor = _v0.isFactor;
	var tmsCarrier = _v0.tmsCarrier;
	return A2(
		$elm$core$String$join,
		' - ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$append('MC# '),
					tmsCarrier.mcNumber),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$append('EIN '),
					tmsCarrier.ein),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$append('SCAC '),
					tmsCarrier.scac),
					(isFactor || showVendorId) ? tmsCarrier.externalVendorId : $elm$core$Maybe$Nothing
				])));
};
var $author$project$Components$CarrierDetails$viewIdentity = function (_v0) {
	var showVendorId = _v0.showVendorId;
	var isFactor = _v0.isFactor;
	var tmsCarrier = _v0.tmsCarrier;
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$CarrierDetails$heading(tmsCarrier.name),
				$author$project$Components$CarrierDetails$body(
				$author$project$Components$CarrierDetails$identityLine(
					{isFactor: isFactor, showVendorId: showVendorId, tmsCarrier: tmsCarrier}))
			]));
};
var $author$project$Components$CarrierDetails$view = function (_v0) {
	var showVendorId = _v0.showVendorId;
	var isFactor = _v0.isFactor;
	var tmsCarrier = _v0.tmsCarrier;
	return A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				$author$project$Components$CarrierDetails$viewIdentity(
					{isFactor: isFactor, showVendorId: showVendorId, tmsCarrier: tmsCarrier})),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$CarrierDetails$viewAddress,
				$author$project$Components$CarrierDetails$preferredAddress(tmsCarrier))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$viewBody = function (_v0) {
	var isReadOnly = _v0.isReadOnly;
	var carrierTerm = _v0.carrierTerm;
	var showVendorId = _v0.showVendorId;
	var isFactor = _v0.isFactor;
	var selectedCarrier = _v0.selectedCarrier;
	var dropdownData = _v0.dropdownData;
	var dropdown = _v0.dropdown;
	var detailsColumn = A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			function (carrier) {
				return $author$project$Components$CarrierDetails$view(
					{isFactor: isFactor, showVendorId: showVendorId, tmsCarrier: carrier});
			},
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				$author$project$Forward$Remote$toMaybe(selectedCarrier))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$elm$html$Html$map,
							$author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$DropdownMsg,
							A3(
								$author$project$Components$CarrierDropdown$view,
								_List_fromArray(
									[
										$author$project$Ui$V3$CustomSelect$disabled(isReadOnly)
									]),
								dropdownData,
								dropdown))),
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, detailsColumn)
					])),
				isReadOnly ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						$author$project$Components$AuditCheckActions$viewPrimaryButton(
						{label: 'Save ' + (carrierTerm + ' for Batch'), onClick: $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$SaveClicked})
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$viewBody = function (failedRules) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-actions')
			]),
		_List_fromArray(
			[
				A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$IgnoreClicked, failedRules)
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$DropdownMsg = function (a) {
	return {$: 'DropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SaveAndConfirmClicked = function (a) {
	return {$: 'SaveAndConfirmClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SaveClicked = {$: 'SaveClicked'};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SuggestionClicked = function (a) {
	return {$: 'SuggestionClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SuggestionFindClicked = function (a) {
	return {$: 'SuggestionFindClicked', a: a};
};
var $author$project$Components$DebtorDetails$body = function (str) {
	return A2($author$project$Ui$V3$Typography$body, _List_Nil, str);
};
var $author$project$Components$DebtorDetails$viewAddress = function (address) {
	var keepIfNonBlank = $elm$core$List$filterMap(
		$elm$core$Maybe$andThen($elm_community$string_extra$String$Extra$nonBlank));
	var joinedWith = F2(
		function (sep, parts) {
			return $elm_community$string_extra$String$Extra$nonBlank(
				A2(
					$elm$core$String$join,
					sep,
					keepIfNonBlank(parts)));
		});
	var joinedAddressLines = A2(
		joinedWith,
		' - ',
		_List_fromArray(
			[address.addressLine1, address.addressLine2]));
	var cityState = A2(
		joinedWith,
		' ',
		_List_fromArray(
			[address.city, address.state]));
	var cityStateZip = A2(
		joinedWith,
		', ',
		_List_fromArray(
			[cityState, address.postalCode]));
	return A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$elm$core$Maybe$map($author$project$Components$DebtorDetails$body),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(address.name),
					joinedAddressLines,
					cityStateZip,
					address.country
				])));
};
var $author$project$Domain$FactorBroker$debtorEmail = function (_v0) {
	var billingContact = _v0.billingContact;
	var cadenceDebtorDetails = _v0.cadenceDebtorDetails;
	return A2(
		$elm_community$maybe_extra$Maybe$Extra$or,
		cadenceDebtorDetails.email,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.email;
			},
			billingContact));
};
var $author$project$Components$DebtorDetails$labelled = F2(
	function (label, value) {
		return $author$project$Components$DebtorDetails$body(label + (': ' + value));
	});
var $author$project$Components$DebtorDetails$viewNotes = function (notes) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$DebtorDetails$body('Notes:'),
				A2(
				$elm$html$Html$code,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
						A2($elm$html$Html$Attributes$style, 'max-height', '100px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(notes)
					]))
			]));
};
var $author$project$Components$DebtorDetails$viewPhone = F2(
	function (label, value) {
		var dashed = A3($elm$core$String$replace, ' ', '-', value);
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('tel:' + dashed)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label + (': ' + dashed))
				]));
	});
var $author$project$Components$DebtorDetails$viewWarning = function (warning) {
	return A2(
		$author$project$Ui$V3$Notification$viewInline,
		{
			message: $elm$html$Html$text(warning),
			onClose: $elm$core$Maybe$Nothing,
			title: $elm$core$Maybe$Just('Debtor Warning')
		},
		_List_fromArray(
			[$author$project$Ui$V3$Notification$warning, $author$project$Ui$V3$Notification$column]));
};
var $author$project$Components$DebtorDetails$viewContact = function (factorBroker) {
	return A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$DebtorDetails$labelled('Email'),
				$author$project$Domain$FactorBroker$debtorEmail(factorBroker)),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$DebtorDetails$viewPhone('Primary'),
				factorBroker.cadenceDebtorDetails.phone1),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$DebtorDetails$viewPhone('Secondary'),
				factorBroker.cadenceDebtorDetails.phone2),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$DebtorDetails$viewNotes,
				$elm_community$string_extra$String$Extra$nonBlank(factorBroker.notes)),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$DebtorDetails$viewWarning,
				A2($elm$core$Maybe$andThen, $elm_community$string_extra$String$Extra$nonBlank, factorBroker.warning))
			]));
};
var $author$project$Components$DebtorDetails$heading = function (str) {
	return A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Components$DebtorDetails$viewName = function (factorBroker) {
	return factorBroker.noBuy ? A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
				$author$project$Ui$V3$Stack$crossAxisCenter
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				$author$project$Components$DebtorDetails$heading(factorBroker.name)),
				_Utils_Tuple2($author$project$Ui$V3$Stack$fit, $author$project$Components$DebtorDetails$noBuyTag)
			])) : $author$project$Components$DebtorDetails$heading(factorBroker.name);
};
var $author$project$Components$DebtorDetails$viewIdentity = function (factorBroker) {
	var mc = factorBroker.cadenceDebtorDetails.mcNumber;
	var dot = factorBroker.cadenceDebtorDetails.dotNumber;
	return A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_Nil,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				$author$project$Components$DebtorDetails$viewName(factorBroker)),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$DebtorDetails$labelled('DOT'),
				dot),
				A2(
				$elm$core$Maybe$map,
				$author$project$Components$DebtorDetails$labelled('MC'),
				mc)
			]));
};
var $author$project$Components$DebtorDetails$view = function (_v0) {
	var paymentAddress = _v0.paymentAddress;
	var factorBroker = _v0.factorBroker;
	return A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				$author$project$Components$DebtorDetails$viewIdentity(factorBroker)),
				A2($elm$core$Maybe$map, $author$project$Components$DebtorDetails$viewAddress, paymentAddress),
				$elm$core$Maybe$Just(
				$author$project$Components$DebtorDetails$viewContact(factorBroker))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$noaCopy = function (status) {
	switch (status.$) {
		case 'DebtorNoaStatusVerified':
			return _Utils_Tuple3($author$project$Ui$V3$Notification$success, 'NOA Verified', 'You are the factor of record.');
		case 'DebtorNoaStatusNotFactorOfRecord':
			return _Utils_Tuple3($author$project$Ui$V3$Notification$warning, 'Not the Factor of Record', 'You are not the factor of record, please submit an NOA, and LOR if available.');
		case 'DebtorNoaStatusCarrierNotFactored':
			return _Utils_Tuple3($author$project$Ui$V3$Notification$warning, 'Carrier Not Factored', 'Carrier currently not factored, please submit an NOA.');
		default:
			return _Utils_Tuple3($author$project$Ui$V3$Notification$warning, 'Carrier-Debtor Relationship Missing', 'This Debtor has not created a relationship for this carrier in TriumphPay.');
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$viewNoaAlert = function (noaStatus) {
	if (noaStatus.$ === 'Just') {
		var status = noaStatus.a;
		var _v1 = $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$noaCopy(status);
		var level = _v1.a;
		var title = _v1.b;
		var description = _v1.c;
		return A2(
			$author$project$Ui$V3$Notification$viewInline,
			{
				message: $elm$html$Html$text(description),
				onClose: $elm$core$Maybe$Nothing,
				title: $elm$core$Maybe$Just(title)
			},
			_List_fromArray(
				[level]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Ui$V3$Tooltip$FixedWidth = function (a) {
	return {$: 'FixedWidth', a: a};
};
var $author$project$Components$FactorInvoiceAuditCheckSuggestions$suggestionSourceLabel = function (source) {
	switch (source.$) {
		case 'SuggestionSourceClientSubmission':
			return 'Client Submission';
		case 'SuggestionSourceClientInvoice':
			return 'Invoice';
		case 'SuggestionSourceRateConfirmation':
			return 'Rate Confirmation';
		case 'SuggestionSourceBillOfLading':
			return 'Bill of Lading';
		default:
			return 'AI';
	}
};
var $author$project$Ui$V3$Tooltip$TooltipWidth = function (a) {
	return {$: 'TooltipWidth', a: a};
};
var $author$project$Ui$V3$Tooltip$tooltipWidth = $author$project$Ui$V3$Tooltip$TooltipWidth;
var $author$project$Ui$V3$Icon$aiSvg = function (size) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width(size),
				$elm$svg$Svg$Attributes$height(size),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M18.8179 2.08629C19.0253 1.45564 19.129 1.14031 19.2844 1.0552C19.4187 0.9816 19.5813 0.9816 19.7156 1.0552C19.871 1.14031 19.9747 1.45564 20.1821 2.08629L20.4973 3.04489C20.5389 3.17115 20.5596 3.23427 20.5953 3.28664C20.6269 3.33302 20.667 3.37305 20.7134 3.40467C20.7657 3.44037 20.8289 3.46113 20.9551 3.50265L21.9137 3.81792C22.5444 4.02533 22.8597 4.12903 22.9448 4.28437C23.0184 4.4187 23.0184 4.5813 22.9448 4.71563C22.8597 4.87097 22.5444 4.97467 21.9137 5.18208L20.9551 5.49735C20.8289 5.53887 20.7657 5.55963 20.7134 5.59533C20.667 5.62695 20.6269 5.66698 20.5953 5.71336C20.5596 5.76573 20.5389 5.82885 20.4973 5.95511L20.1821 6.91371C19.9747 7.54436 19.871 7.85969 19.7156 7.9448C19.5813 8.0184 19.4187 8.0184 19.2844 7.9448C19.129 7.85969 19.0253 7.54436 18.8179 6.91371L18.5027 5.95511C18.4611 5.82885 18.4404 5.76573 18.4047 5.71336C18.3731 5.66698 18.333 5.62695 18.2866 5.59533C18.2343 5.55963 18.1711 5.53887 18.0449 5.49735L17.0863 5.18208C16.4556 4.97467 16.1403 4.87097 16.0552 4.71563C15.9816 4.5813 15.9816 4.4187 16.0552 4.28437C16.1403 4.12903 16.4556 4.02533 17.0863 3.81792L18.0449 3.50265C18.1711 3.46113 18.2343 3.44037 18.2866 3.40467C18.333 3.37305 18.3731 3.33302 18.4047 3.28664C18.4404 3.23427 18.4611 3.17115 18.5027 3.04489L18.8179 2.08629Z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M10.7947 3.70345C10.2996 3.43218 9.70037 3.43218 9.20527 3.70345C8.83801 3.90466 8.61672 4.31887 8.43559 4.7466C8.24423 5.19851 8.03903 5.82243 7.77914 6.61266L6.96042 9.10208C6.84449 9.45456 6.81297 9.53571 6.7703 9.5983C6.72423 9.66588 6.66588 9.72423 6.5983 9.7703C6.53571 9.81297 6.45456 9.84449 6.10209 9.96042L3.61283 10.7791C2.82256 11.039 2.19852 11.2442 1.7466 11.4356C1.31887 11.6167 0.904663 11.838 0.703446 12.2053C0.432185 12.7004 0.432185 13.2996 0.703446 13.7947C0.904663 14.162 1.31887 14.3833 1.7466 14.5644C2.19853 14.7558 2.82249 14.961 3.61278 15.2209L6.10208 16.0396C6.45456 16.1555 6.53571 16.187 6.5983 16.2297C6.66588 16.2758 6.72423 16.3341 6.7703 16.4017C6.81297 16.4643 6.84449 16.5454 6.96042 16.8979L7.77908 19.3872C8.039 20.1775 8.24421 20.8015 8.43559 21.2534C8.61672 21.6811 8.83801 22.0953 9.20527 22.2966C9.70037 22.5678 10.2996 22.5678 10.7947 22.2966C11.162 22.0953 11.3833 21.6811 11.5644 21.2534C11.7558 20.8015 11.961 20.1776 12.2209 19.3873L13.0396 16.8979C13.1555 16.5454 13.187 16.4643 13.2297 16.4017C13.2758 16.3341 13.3341 16.2758 13.4017 16.2297C13.4643 16.187 13.5454 16.1555 13.8979 16.0396L16.3872 15.2209C17.1775 14.961 17.8015 14.7558 18.2534 14.5644C18.6811 14.3833 19.0953 14.162 19.2966 13.7947C19.5678 13.2996 19.5678 12.7004 19.2966 12.2053C19.0953 11.838 18.6811 11.6167 18.2534 11.4356C17.8015 11.2442 17.1776 11.039 16.3873 10.7791L13.8979 9.96042C13.5454 9.84449 13.4643 9.81297 13.4017 9.7703C13.3341 9.72423 13.2758 9.66588 13.2297 9.5983C13.187 9.53571 13.1555 9.45456 13.0396 9.10209L12.2209 6.61283C11.961 5.82255 11.7558 5.19853 11.5644 4.7466C11.3833 4.31887 11.162 3.90466 10.7947 3.70345Z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M19.346 18.0394C19.235 18.1002 19.1609 18.3255 19.0128 18.7759L18.7876 19.4606C18.7579 19.5508 18.7431 19.5959 18.7176 19.6333C18.695 19.6664 18.6664 19.695 18.6333 19.7176C18.5959 19.7431 18.5508 19.7579 18.4606 19.7876L17.7759 20.0128C17.3255 20.1609 17.1002 20.235 17.0394 20.346C16.9869 20.4419 16.9869 20.5581 17.0394 20.654C17.1002 20.765 17.3255 20.8391 17.7759 20.9872L18.4606 21.2124C18.5508 21.2421 18.5959 21.2569 18.6333 21.2824C18.6664 21.305 18.695 21.3336 18.7176 21.3667C18.7431 21.4041 18.7579 21.4492 18.7876 21.5394L19.0128 22.2241C19.1609 22.6745 19.235 22.8998 19.346 22.9606C19.4419 23.0131 19.5581 23.0131 19.654 22.9606C19.765 22.8998 19.8391 22.6745 19.9872 22.2241L20.2124 21.5394C20.2421 21.4492 20.2569 21.4041 20.2824 21.3667C20.305 21.3336 20.3336 21.305 20.3667 21.2824C20.4041 21.2569 20.4492 21.2421 20.5394 21.2124L21.2241 20.9872C21.6745 20.8391 21.8998 20.765 21.9606 20.654C22.0131 20.5581 22.0131 20.4419 21.9606 20.346C21.8998 20.235 21.6745 20.1609 21.2241 20.0128L20.5394 19.7876C20.4492 19.7579 20.4041 19.7431 20.3667 19.7176C20.3336 19.695 20.305 19.6664 20.2824 19.6333C20.2569 19.5959 20.2421 19.5508 20.2124 19.4606L19.9872 18.7759C19.8391 18.3255 19.765 18.1002 19.654 18.0394C19.5581 17.9869 19.4419 17.9869 19.346 18.0394Z')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Ui$V3$Icon$ai16 = $author$project$Ui$V3$Icon$Icon16(
	$author$project$Ui$V3$Icon$aiSvg('16'));
var $author$project$Components$FactorInvoiceAuditCheckSuggestions$viewRecommendedLine = function (suggestion) {
	return suggestion.recommended ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit-check__suggestion-card-recommendation'),
				A2($elm$html$Html$Attributes$attribute, 'data-testid', 'suggestion-recommended'),
				$author$project$Ui$V3$Typography$xSmallBodyClass
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Recommended'),
				A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$ai16)
			])) : $elm$html$Html$text('');
};
var $author$project$Ui$V3$Tooltip$TooltipHeader = function (a) {
	return {$: 'TooltipHeader', a: a};
};
var $author$project$Ui$V3$Tooltip$viewWithHeader = F3(
	function (attributes, header, tooltipStr) {
		var newAttrs = A2(
			$elm$core$List$cons,
			$author$project$Ui$V3$Tooltip$TooltipHeader(header),
			attributes);
		return A2(
			$author$project$Ui$V3$Tooltip$viewHtml,
			newAttrs,
			A2($author$project$Ui$V3$Tooltip$tooltipContent, newAttrs, tooltipStr));
	});
var $author$project$Components$FactorInvoiceAuditCheckSuggestions$viewSuggestionCard = F3(
	function (config, currentInput, suggestion) {
		var isSelected = _Utils_eq(
			currentInput,
			$elm$core$Maybe$Just(suggestion.value));
		var cardClass = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just('fi-audit-check__suggestion-card'),
						isSelected ? $elm$core$Maybe$Just('fi-audit-check__suggestion-card--selected') : $elm$core$Maybe$Nothing
					])));
		var card = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(cardClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('fi-audit-check__suggestion-card-content'),
							A2($elm$html$Html$Attributes$attribute, 'data-testid', 'suggestion-card-' + suggestion.value),
							$elm$html$Html$Attributes$disabled(config.isReadOnly),
							$elm$html$Html$Events$onClick(
							config.onClick(suggestion.value))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit-check__suggestion-card-label'),
									$author$project$Ui$V3$Typography$xSmallBodySemiBoldClass
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$FactorInvoiceAuditCheckSuggestions$suggestionSourceLabel(suggestion.source))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit-check__suggestion-card-value'),
									$author$project$Ui$V3$Typography$smallBodyClass
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									config.formatValue(suggestion.value))
								])),
							$author$project$Components$FactorInvoiceAuditCheckSuggestions$viewRecommendedLine(suggestion)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn fi-audit-check__find-value-btn--suggestion'),
							$elm$html$Html$Attributes$title('Show on document'),
							$elm$html$Html$Events$onClick(
							config.onFindClick(
								{location: suggestion.location, value: suggestion.value}))
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
						]))
				]));
		var _v0 = _Utils_Tuple2(suggestion.recommended, suggestion.reasoning);
		if (_v0.a && (_v0.b.$ === 'Just')) {
			var reasoning = _v0.b.a;
			return A4(
				$author$project$Ui$V3$Tooltip$viewWithHeader,
				_List_fromArray(
					[
						$author$project$Ui$V3$Tooltip$tooltipWidth(
						$author$project$Ui$V3$Tooltip$FixedWidth(260))
					]),
				'AI recommendation',
				reasoning,
				card);
		} else {
			return card;
		}
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$viewBody = function (_v0) {
	var isReadOnly = _v0.isReadOnly;
	var noaStatus = _v0.noaStatus;
	var suggestions = _v0.suggestions;
	var failedRules = _v0.failedRules;
	var selectedDebtor = _v0.selectedDebtor;
	var dropdownData = _v0.dropdownData;
	var dropdown = _v0.dropdown;
	var suggestionsRow = $elm$core$List$isEmpty(suggestions) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit-check__suggestions-row')
			]),
		A2(
			$elm$core$List$map,
			function (suggestion) {
				return A3(
					$author$project$Components$FactorInvoiceAuditCheckSuggestions$viewSuggestionCard,
					{
						formatValue: $elm$core$Basics$identity,
						isReadOnly: isReadOnly,
						onClick: function (value) {
							return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SuggestionClicked(
								{entityId: suggestion.entityId, value: value});
						},
						onFindClick: $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SuggestionFindClicked
					},
					$elm$core$Maybe$Nothing,
					suggestion);
			},
			suggestions));
	var dropdownView = A2(
		$elm$html$Html$map,
		$author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$DropdownMsg,
		A3(
			$author$project$Components$DebtorDropdown$view,
			_List_fromArray(
				[
					$author$project$Ui$V3$CustomSelect$disabled(isReadOnly)
				]),
			dropdownData,
			dropdown));
	var dropdownColumn = function () {
		if (noaStatus.$ === 'Just') {
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
					]),
				_List_fromArray(
					[
						dropdownView,
						$author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$viewNoaAlert(noaStatus)
					]));
		} else {
			return dropdownView;
		}
	}();
	var detailsColumn = A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			$author$project$Components$DebtorDetails$view,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				$author$project$Forward$Remote$toMaybe(selectedDebtor))));
	var confirmableRule = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (r) {
				return r.confirmable && (!r.unskippable);
			},
			failedRules));
	var saveButton = function () {
		if (confirmableRule.$ === 'Just') {
			var r = confirmableRule.a;
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save and Confirm Debtor',
					onClick: $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SaveAndConfirmClicked(r.ruleEvaluationId)
				});
		} else {
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{label: 'Save Debtor', onClick: $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$SaveClicked});
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				suggestionsRow,
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, dropdownColumn),
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, detailsColumn)
					])),
				isReadOnly ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						saveButton,
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$IgnoreClicked, failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$Reference = {$: 'Reference'};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$Duplicate = {$: 'Duplicate'};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$valuesMatch = F2(
	function (thisValue, duplicateValue) {
		var _v0 = _Utils_Tuple2(thisValue, duplicateValue);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var a = _v0.a.a;
			var b = _v0.b.a;
			return _Utils_eq(a, b);
		} else {
			return false;
		}
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$matchCell = F3(
	function (thisValue, duplicateValue, content) {
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__dup-tpose-col'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'fi-audit__dup-cell--match',
							A2($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$valuesMatch, thisValue, duplicateValue))
						]))
				]),
			_List_fromArray(
				[content]));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$duplicateCell = F3(
	function (config, field, row) {
		return A3(
			$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$matchCell,
			field.matchKey(config.thisInvoice),
			field.matchKey(row),
			A2(field.view, $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$Duplicate, row));
	});
var $elm$html$Html$Attributes$scope = $elm$html$Html$Attributes$stringProperty('scope');
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$labelCell = function (content) {
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__dup-tpose-label'),
				$elm$html$Html$Attributes$scope('row')
			]),
		content);
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$referenceClasses = 'fi-audit__dup-tpose-col fi-audit__dup-tpose-col--reference';
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$fieldRow = F3(
	function (config, duplicates, field) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$labelCell(
					_List_fromArray(
						[
							$elm$html$Html$text(field.label)
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$referenceClasses)
							]),
						_List_fromArray(
							[
								A2(field.view, $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$Reference, config.thisInvoice)
							])),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$duplicateCell, config, field),
						duplicates))));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$fuelAdvanceText = function (fuelAdvance) {
	return fuelAdvance ? 'Yes' : 'No';
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$invoiceNumberCell = F3(
	function (pathContext, column, row) {
		var label = A2($elm$core$Maybe$withDefault, '[No invoice number]', row.invoice.invoiceNumber);
		if (column.$ === 'Reference') {
			return $elm$html$Html$text(label);
		} else {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$author$project$Path$toString(
							A2($author$project$Path$factorInvoice, row.invoice.id, pathContext))),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		}
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$processDate = F2(
	function (tz, invoice) {
		return A2($author$project$Helpers$Date$dateString, tz, invoice.createdAt);
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$cellText = function (value) {
	return $elm$html$Html$text(
		A2($elm$core$Maybe$withDefault, '', value));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$textField = F2(
	function (label, matchKey) {
		return {
			label: label,
			matchKey: matchKey,
			view: F2(
				function (_v0, row) {
					return $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$cellText(
						matchKey(row));
				})
		};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$fields = function (config) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$textField,
			'Status',
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.invoice;
				},
				function ($) {
					return $.status;
				})),
			{
			label: 'Invoice #',
			matchKey: A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.invoice;
				},
				function ($) {
					return $.invoiceNumber;
				}),
			view: $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$invoiceNumberCell(config.pathContext)
		},
			A2(
			$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$textField,
			'Load ID',
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.invoice;
				},
				function ($) {
					return $.loadId;
				})),
			A2(
			$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$textField,
			'Fuel advance',
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.invoice;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fuelAdvance;
					},
					A2($elm$core$Basics$composeR, $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$fuelAdvanceText, $elm$core$Maybe$Just)))),
			A2(
			$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$textField,
			'Total',
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.invoice;
				},
				function ($) {
					return $.formattedAmount;
				})),
			A2(
			$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$textField,
			'Process date',
			function (row) {
				return $elm$core$Maybe$Just(
					A2($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$processDate, config.timeZone, row.invoice));
			}),
			A2(
			$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$textField,
			'Debtor',
			function ($) {
				return $.debtorName;
			}),
			A2(
			$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$textField,
			'Carrier',
			function ($) {
				return $.carrierName;
			})
		]);
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$CompareClicked = function (a) {
	return {$: 'CompareClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$compareButton = function (invoiceId) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick(
				$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$CompareClicked(invoiceId))
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
				$author$project$Ui$V3$Button$buttonColor($author$project$Ui$V3$Button$ColorAlternative),
				$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall)
			]),
		'Compare');
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$matchScore = F2(
	function (config, row) {
		var allFields = $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$fields(config);
		var matches = A2(
			$elm$core$List$filter,
			function (field) {
				return A2(
					$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$valuesMatch,
					field.matchKey(config.thisInvoice),
					field.matchKey(row));
			},
			allFields);
		return $elm$core$String$fromInt(
			$elm$core$List$length(matches)) + ('/' + ($elm$core$String$fromInt(
			$elm$core$List$length(allFields)) + ' fields match'));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$duplicateHeaderCell = F3(
	function (config, index, row) {
		return A2(
			$elm$html$Html$th,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__dup-tpose-col'),
					$elm$html$Html$Attributes$scope('col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__dup-tpose-col-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Duplicate ' + $elm$core$String$fromInt(index + 1)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__dup-tpose-col-score')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$matchScore, config, row))
								]))
						])),
					$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$compareButton(row.invoice.id)
				]));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$headerRow = F2(
	function (config, duplicates) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$labelCell(_List_Nil),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$referenceClasses),
								$elm$html$Html$Attributes$scope('col')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$DescriptorTag$view,
								_List_fromArray(
									[
										$author$project$Ui$V3$DescriptorTag$DescriptorTagStyle($author$project$Ui$V3$DescriptorTag$InfoStyle)
									]),
								'UNDER AUDIT')
							])),
					A2(
						$elm$core$List$indexedMap,
						$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$duplicateHeaderCell(config),
						duplicates))));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$maxVisibleDuplicates = 10;
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$note = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__dup-tpose-note')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(message)
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$statusNote = function (duplicateInvoices) {
	switch (duplicateInvoices.$) {
		case 'Loading':
			return $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$note('Loading duplicates…');
		case 'Loaded':
			var rows = duplicateInvoices.a;
			var total = $elm$core$List$length(rows);
			return (_Utils_cmp(total, $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$maxVisibleDuplicates) > 0) ? $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$note(
				'Showing ' + ($elm$core$String$fromInt($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$maxVisibleDuplicates) + (' of ' + ($elm$core$String$fromInt(total) + ' duplicates.')))) : $elm$html$Html$text('');
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$viewBody = function (config) {
	var duplicates = function () {
		var _v0 = config.duplicateInvoices;
		if (_v0.$ === 'Loaded') {
			var rows = _v0.a;
			return rows;
		} else {
			return _List_Nil;
		}
	}();
	var visibleDuplicates = A2($elm$core$List$take, $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$maxVisibleDuplicates, duplicates);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__dup-table-scroll')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__dup-tpose'),
								$elm$html$Html$Attributes$class('v3_reskin_react__button-overrides-disabled')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$headerRow, config, visibleDuplicates)
									])),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A2($author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$fieldRow, config, visibleDuplicates),
									$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$fields(config)))
							]))
					])),
				$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$statusNote(config.duplicateInvoices),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$IgnoreClicked, config.failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$viewBody = function (failedRules) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-actions')
			]),
		_List_fromArray(
			[
				A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$IgnoreClicked, failedRules)
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$viewBody = function (_v0) {
	var text = _v0.text;
	var failedRules = _v0.failedRules;
	var textBlock = $elm$core$String$isEmpty(text) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__funding-instructions-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				textBlock,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$IgnoreClicked, failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$AmountInputChanged = function (a) {
	return {$: 'AmountInputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$FindValueClicked = function (a) {
	return {$: 'FindValueClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$RevertClicked = {$: 'RevertClicked'};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SaveAndConfirmClicked = F2(
	function (a, b) {
		return {$: 'SaveAndConfirmClicked', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SaveClicked = function (a) {
	return {$: 'SaveClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SuggestionClicked = function (a) {
	return {$: 'SuggestionClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SuggestionFindClicked = function (a) {
	return {$: 'SuggestionFindClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$viewBody = function (config) {
	var currentValue = config.amountInput;
	var suggestionsRow = $elm$core$List$isEmpty(config.suggestions) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit-check__suggestions-row')
			]),
		A2(
			$elm$core$List$map,
			A2(
				$author$project$Components$FactorInvoiceAuditCheckSuggestions$viewSuggestionCard,
				{
					formatValue: function (v) {
						return '$' + v;
					},
					isReadOnly: config.isReadOnly,
					onClick: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SuggestionClicked,
					onFindClick: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SuggestionFindClicked
				},
				$elm$core$Maybe$Just(currentValue)),
			config.suggestions));
	var confirmableRule = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (r) {
				return r.confirmable && (!r.unskippable);
			},
			config.failedRules));
	var saveButton = function () {
		if (confirmableRule.$ === 'Just') {
			var r = confirmableRule.a;
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save and Confirm Amount',
					onClick: A2($author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SaveAndConfirmClicked, currentValue, r.ruleEvaluationId)
				});
		} else {
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save Amount',
					onClick: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$SaveClicked(currentValue)
				});
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				suggestionsRow,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit-check__input-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit-check__input'),
								$author$project$Components$AuditUnsavedValue$unsavedClass(config.editedFrom)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{onInput: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$AmountInputChanged},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Invoice Amount'),
										$author$project$Ui$V3$Input$placeholder('Enter invoice amount'),
										$author$project$Ui$V3$Input$disabled(config.isReadOnly)
									]),
								_List_Nil,
								currentValue),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn'),
										$elm$html$Html$Attributes$title('Show on document'),
										$elm$html$Html$Events$onClick(
										$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$FindValueClicked(currentValue))
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
									]))
							]))
					])),
				$author$project$Components$AuditUnsavedValue$view(
				{editedFrom: config.editedFrom, onRevert: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$RevertClicked}),
				config.isReadOnly ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						saveButton,
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$IgnoreClicked, config.failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$DateInputChanged = function (a) {
	return {$: 'DateInputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$RevertClicked = {$: 'RevertClicked'};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$SaveAndConfirmClicked = F2(
	function (a, b) {
		return {$: 'SaveAndConfirmClicked', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$SaveClicked = function (a) {
	return {$: 'SaveClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$viewBody = function (config) {
	var currentValue = config.dateInput;
	var confirmableRule = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (r) {
				return r.confirmable && (!r.unskippable);
			},
			config.failedRules));
	var saveButton = function () {
		if (confirmableRule.$ === 'Just') {
			var r = confirmableRule.a;
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save and Confirm Date',
					onClick: A2($author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$SaveAndConfirmClicked, currentValue, r.ruleEvaluationId)
				});
		} else {
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save Date',
					onClick: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$SaveClicked(currentValue)
				});
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Components$AuditUnsavedValue$unsavedClass(config.editedFrom)
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$V3$Input$view,
						{onInput: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$DateInputChanged},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$label('Invoice Date'),
								$author$project$Ui$V3$Input$date,
								$author$project$Ui$V3$Input$disabled(config.isReadOnly)
							]),
						_List_Nil,
						currentValue)
					])),
				$author$project$Components$AuditUnsavedValue$view(
				{editedFrom: config.editedFrom, onRevert: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$RevertClicked}),
				config.isReadOnly ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						saveButton,
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$IgnoreClicked, config.failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$formatDocumentTypeSource = function (raw) {
	return A3(
		$author$project$Domain$UnresolvedDocumentType$toString,
		$elm$core$Dict$empty,
		$author$project$Domain$Environment$FactorEnvironment,
		$author$project$Domain$UnresolvedDocumentType$deserialize(raw));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$viewReadOnlyInput = F2(
	function (inputLabel, value) {
		return A4(
			$author$project$Ui$V3$Input$view,
			{
				onInput: $elm$core$Basics$always(
					$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$IgnoreClicked(
						$author$project$Domain$RuleEvaluationId$fromInt(0)))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Input$label(inputLabel),
					$author$project$Ui$V3$Input$disabled(true)
				]),
			_List_Nil,
			value);
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$viewBody = function (_v0) {
	var deliveryDateSource = _v0.deliveryDateSource;
	var deliveryDate = _v0.deliveryDate;
	var failedRules = _v0.failedRules;
	var sourceValue = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$formatDocumentTypeSource, deliveryDateSource));
	var dateValue = A2($elm$core$Maybe$withDefault, '', deliveryDate);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				A2($author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$viewReadOnlyInput, 'Delivery Date', dateValue),
				A2($author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$viewReadOnlyInput, 'Source', sourceValue),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$IgnoreClicked, failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$FindValueClicked = function (a) {
	return {$: 'FindValueClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$InvoiceNumberInputChanged = function (a) {
	return {$: 'InvoiceNumberInputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$RevertClicked = {$: 'RevertClicked'};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SaveAndConfirmClicked = F2(
	function (a, b) {
		return {$: 'SaveAndConfirmClicked', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SaveClicked = function (a) {
	return {$: 'SaveClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SuggestionClicked = function (a) {
	return {$: 'SuggestionClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SuggestionFindClicked = function (a) {
	return {$: 'SuggestionFindClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$viewBody = function (config) {
	var currentValue = config.invoiceNumberInput;
	var suggestionsRow = $elm$core$List$isEmpty(config.suggestions) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit-check__suggestions-row')
			]),
		A2(
			$elm$core$List$map,
			A2(
				$author$project$Components$FactorInvoiceAuditCheckSuggestions$viewSuggestionCard,
				{formatValue: $elm$core$Basics$identity, isReadOnly: config.isReadOnly, onClick: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SuggestionClicked, onFindClick: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SuggestionFindClicked},
				$elm$core$Maybe$Just(currentValue)),
			config.suggestions));
	var confirmableRule = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (r) {
				return r.confirmable && (!r.unskippable);
			},
			config.failedRules));
	var saveButton = function () {
		if (confirmableRule.$ === 'Just') {
			var r = confirmableRule.a;
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save and Confirm Invoice Number',
					onClick: A2($author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SaveAndConfirmClicked, currentValue, r.ruleEvaluationId)
				});
		} else {
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save Invoice Number',
					onClick: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$SaveClicked(currentValue)
				});
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				suggestionsRow,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit-check__input-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit-check__input'),
								$author$project$Components$AuditUnsavedValue$unsavedClass(config.editedFrom)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{onInput: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$InvoiceNumberInputChanged},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Invoice Number'),
										$author$project$Ui$V3$Input$placeholder('Enter invoice number'),
										$author$project$Ui$V3$Input$disabled(config.isReadOnly)
									]),
								_List_Nil,
								currentValue),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn'),
										$elm$html$Html$Attributes$title('Show on document'),
										$elm$html$Html$Events$onClick(
										$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$FindValueClicked(currentValue))
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
									]))
							]))
					])),
				$author$project$Components$AuditUnsavedValue$view(
				{editedFrom: config.editedFrom, onRevert: $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$RevertClicked}),
				config.isReadOnly ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						saveButton,
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$IgnoreClicked, config.failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$FindValueClicked = function (a) {
	return {$: 'FindValueClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$LoadIdInputChanged = function (a) {
	return {$: 'LoadIdInputChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$RevertClicked = {$: 'RevertClicked'};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SaveAndConfirmClicked = F2(
	function (a, b) {
		return {$: 'SaveAndConfirmClicked', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SaveClicked = function (a) {
	return {$: 'SaveClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SuggestionClicked = function (a) {
	return {$: 'SuggestionClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SuggestionFindClicked = function (a) {
	return {$: 'SuggestionFindClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$DebtorAutofillToggled = function (a) {
	return {$: 'DebtorAutofillToggled', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$autofillAccuracyNote = function (offer) {
	return 'Kept ' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(offer.keptPercentage * 100)) + ('% of the last ' + ($elm$core$String$fromInt(offer.priorCount) + ' times (applies to all of your clients)')));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$viewDebtorAutofillOffer = function (config) {
	var _v0 = config.debtorAutofillOffer;
	if (_v0.$ === 'Nothing') {
		return $elm$html$Html$text('');
	} else {
		var offer = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit-check__autofill-offer')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Checkbox$view,
					{
						checked: config.debtorAutofillChecked,
						label: A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Accept the documents\u0027 load ID for '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(offer.debtorName)
										])),
									$elm$html$Html$text(' going forward without review')
								])),
						onCheck: $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$DebtorAutofillToggled
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Checkbox$disabled(config.isReadOnly)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit-check__autofill-offer-note')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Typography$smallBody,
							_List_Nil,
							$author$project$Components$FactorInvoiceAuditFailedCheckLoadId$autofillAccuracyNote(offer))
						]))
				]));
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$viewBody = function (config) {
	var currentValue = config.loadIdInput;
	var suggestionsRow = $elm$core$List$isEmpty(config.suggestions) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit-check__suggestions-row')
			]),
		A2(
			$elm$core$List$map,
			A2(
				$author$project$Components$FactorInvoiceAuditCheckSuggestions$viewSuggestionCard,
				{formatValue: $elm$core$Basics$identity, isReadOnly: config.isReadOnly, onClick: $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SuggestionClicked, onFindClick: $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SuggestionFindClicked},
				$elm$core$Maybe$Just(currentValue)),
			config.suggestions));
	var confirmableRule = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (r) {
				return r.confirmable && (!r.unskippable);
			},
			config.failedRules));
	var saveButton = function () {
		if (confirmableRule.$ === 'Just') {
			var r = confirmableRule.a;
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save and Confirm Load ID',
					onClick: A2($author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SaveAndConfirmClicked, currentValue, r.ruleEvaluationId)
				});
		} else {
			return $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Save Load ID',
					onClick: $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$SaveClicked(currentValue)
				});
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				suggestionsRow,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit-check__input-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit-check__input'),
								$author$project$Components$AuditUnsavedValue$unsavedClass(config.editedFrom)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{onInput: $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$LoadIdInputChanged},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Load ID'),
										$author$project$Ui$V3$Input$placeholder('Enter load ID'),
										$author$project$Ui$V3$Input$disabled(config.isReadOnly)
									]),
								_List_Nil,
								currentValue),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn'),
										$elm$html$Html$Attributes$title('Show on document'),
										$elm$html$Html$Events$onClick(
										$author$project$Components$FactorInvoiceAuditFailedCheckLoadId$FindValueClicked(currentValue))
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
									]))
							]))
					])),
				$author$project$Components$AuditUnsavedValue$view(
				{editedFrom: config.editedFrom, onRevert: $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$RevertClicked}),
				$author$project$Components$FactorInvoiceAuditFailedCheckLoadId$viewDebtorAutofillOffer(config),
				config.isReadOnly ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						saveButton,
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$IgnoreClicked, config.failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$ActionClicked = function (a) {
	return {$: 'ActionClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditCheckActions$viewConfirmOrIgnoreButton = F2(
	function (onAction, failedRules) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (r) {
					return !r.unskippable;
				},
				failedRules));
		if (_v0.$ === 'Nothing') {
			return $elm$html$Html$text('');
		} else {
			var r = _v0.a;
			return r.confirmable ? $author$project$Components$AuditCheckActions$viewPrimaryButton(
				{
					label: 'Confirm',
					onClick: onAction(r.ruleEvaluationId)
				}) : A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick(
						onAction(r.ruleEvaluationId))
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
						$author$project$Components$AuditCheckActions$buttonSize
					]),
				'Ignore');
		}
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$viewReadOnlyInput = F2(
	function (inputLabel, value) {
		return A4(
			$author$project$Ui$V3$Input$view,
			{
				onInput: $elm$core$Basics$always(
					$author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$ActionClicked(
						$author$project$Domain$RuleEvaluationId$fromInt(0)))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Input$label(inputLabel),
					$author$project$Ui$V3$Input$disabled(true)
				]),
			_List_Nil,
			value);
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$viewBody = function (_v0) {
	var maxAmount = _v0.maxAmount;
	var amount = _v0.amount;
	var failedRules = _v0.failedRules;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$viewReadOnlyInput,
				'Invoice Amount',
				A2($elm$core$Maybe$withDefault, '', amount)),
				A2(
				$author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$viewReadOnlyInput,
				'Maximum Amount',
				A2($elm$core$Maybe$withDefault, '', maxAmount)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewConfirmOrIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$ActionClicked, failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$displayedDocuments = function (podDocuments) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.podDefinition;
			},
			function ($) {
				return $.isDisplayed;
			}),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Forward$Remote$toMaybe(podDocuments)));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$SetIsTonuClicked = function (a) {
	return {$: 'SetIsTonuClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditCheckActions$tonuButton = F2(
	function (isCurrentlyTonu, onClick) {
		return isCurrentlyTonu ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__action-end')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(
							onClick(false))
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
							$author$project$Components$AuditCheckActions$buttonSize
						]),
					'Set as not TONU')
				])) : A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					onClick(true))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
					$author$project$Components$AuditCheckActions$buttonSize
				]),
			'Set as TONU');
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewCheckActions = F2(
	function (failedRules, isTonu) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__check-actions')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$FactorInvoiceAuditCheckActions$tonuButton, isTonu, $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$SetIsTonuClicked),
					A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$IgnoreClicked, failedRules)
				]));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$appliedInferenceChecks = function (definition) {
	return A2(
		$elm$core$List$filter,
		function ($) {
			return $.applied;
		},
		definition.podInferenceChecks);
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$ThumbnailClicked = function (a) {
	return {$: 'ThumbnailClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$thumbnailClickAttributes = function (firstPageId) {
	if (firstPageId.$ === 'Just') {
		var pageId = firstPageId.a;
		return _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$ThumbnailClicked(pageId)),
				$elm$html$Html$Attributes$class('document-thumbnail__page-container--clickable')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$podInferenceCheckTypeToLabel = function (checkType) {
	switch (checkType.$) {
		case 'DocumentPODInferenceCheckTypeCheckSignature':
			return 'Signature Review';
		case 'DocumentPODInferenceCheckTypeReferenceMatch':
			return 'Reference Match Review';
		case 'DocumentPODInferenceCheckTypeNoDamages':
			return 'OS&D Review';
		case 'DocumentPODInferenceCheckTypeNoCarrierRate':
			return 'Carrier Rate Review';
		case 'DocumentPODInferenceCheckTypeAllPagesPresent':
			return 'All Pages Present';
		case 'DocumentPODInferenceCheckTypeHasReceiverDate':
			return 'Has Receiver Date';
		default:
			return 'Manual Reference Match Review';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewInferenceCheck = function (check) {
	var _v0 = check.passed ? _Utils_Tuple3($author$project$Ui$V3$Icon$checkCircle16, 'fi-audit__pod-check-icon fi-audit__pod-check-icon--passing', 'Passing') : _Utils_Tuple3($author$project$Ui$V3$Icon$error16, 'fi-audit__pod-check-icon', 'Failing');
	var icon = _v0.a;
	var iconClass = _v0.b;
	var description = _v0.c;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__pod-check')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(iconClass),
						$elm$html$Html$Attributes$title(description),
						A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', description)
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, _List_Nil, icon)
					])),
				A2(
				$author$project$Ui$V3$Typography$xSmallBody,
				_List_Nil,
				$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$podInferenceCheckTypeToLabel(check.checkType))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewInferenceChecks = function (checks) {
	return $elm$core$List$isEmpty(checks) ? $elm$html$Html$text('') : A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Automation Results'),
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
						$author$project$Ui$V3$Stack$crossAxisCenter
					]),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewInferenceCheck,
						$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit)),
					checks))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewPodDocument = function (podDocument) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Components$DocumentThumbnail$view,
				{
					podTag: _Utils_eq(podDocument.podDefinition.disposition, $author$project$AuditPb$DocumentPODDispositionKnownPOD),
					selected: false,
					thumbnailUrl: podDocument.thumbnailUrl,
					title: podDocument.title
				},
				$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$thumbnailClickAttributes(podDocument.firstPageId)),
				$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewInferenceChecks(
				$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$appliedInferenceChecks(podDocument.podDefinition))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewBody = function (_v0) {
	var isReadOnly = _v0.isReadOnly;
	var podDocuments = _v0.podDocuments;
	var isTonu = _v0.isTonu;
	var failedRules = _v0.failedRules;
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
				$author$project$Ui$V3$Stack$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__document-grid')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewPodDocument,
					$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$displayedDocuments(podDocuments))),
				isReadOnly ? $elm$html$Html$text('') : A2($author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewCheckActions, failedRules, isTonu)
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$ActionClicked = function (a) {
	return {$: 'ActionClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$viewBody = function (_v0) {
	var failedRules = _v0.failedRules;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-actions')
			]),
		_List_fromArray(
			[
				A2($author$project$Components$FactorInvoiceAuditCheckActions$viewConfirmOrIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$ActionClicked, failedRules)
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$update = function (msg) {
	if (msg.$ === 'IgnoreClicked') {
		var ruleResultId = msg.a;
		return $author$project$Components$FactorInvoiceAuditCheckActions$IgnoreRule(ruleResultId);
	} else {
		var isTonu = msg.a;
		return $author$project$Components$FactorInvoiceAuditCheckActions$SetIsTonu(isTonu);
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$IgnoreClicked = function (a) {
	return {$: 'IgnoreClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$SetIsTonuClicked = function (a) {
	return {$: 'SetIsTonuClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$viewAcceptedTypes = function (typeNames) {
	if (!typeNames.b) {
		return $elm$html$Html$text('');
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__accepted-types')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$V3$Typography$xSmallBody,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__accepted-types-label')
						]),
					'Debtor-visible types:'),
				A2(
					$elm$core$List$map,
					$author$project$Ui$V3$Typography$xSmallBody(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__accepted-types-item')
							])),
					typeNames)));
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$viewBody = function (_v0) {
	var tonu = _v0.tonu;
	var requiredDocumentTypes = _v0.requiredDocumentTypes;
	var failedRules = _v0.failedRules;
	var tonuButton = function () {
		if (tonu.$ === 'Just') {
			var isTonu = tonu.a;
			return A2($author$project$Components$FactorInvoiceAuditCheckActions$tonuButton, isTonu, $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$SetIsTonuClicked);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var displayNames = A2(
		$elm$core$List$map,
		A2($author$project$Domain$DocumentType$toString, $elm$core$Dict$empty, $author$project$Domain$Environment$FactorEnvironment),
		A2($elm$core$List$filterMap, $author$project$AuditPb$documentTypeFromString, requiredDocumentTypes));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-body')
			]),
		_List_fromArray(
			[
				$author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$viewAcceptedTypes(displayNames),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__check-actions')
					]),
				_List_fromArray(
					[
						tonuButton,
						A2($author$project$Components$FactorInvoiceAuditCheckActions$viewIgnoreButton, $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$IgnoreClicked, failedRules)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditChecks$viewDocumentPresenceBody = F3(
	function (config, checkDetails, doc) {
		var typesForPills = _Utils_eq(doc.requirement, $author$project$AuditPb$DocumentPresenceRequirementDebtorVisibleDocumentRequired) ? doc.requiredDocumentTypes : _List_Nil;
		var tonu = _Utils_eq(doc.requirement, $author$project$AuditPb$DocumentPresenceRequirementBillOfLadingRequired) ? $elm$core$Maybe$Just(config.factorInvoice.tonu) : $elm$core$Maybe$Nothing;
		return A2(
			$elm$html$Html$map,
			function (leafMsg) {
				return $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg(
					$author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$update(leafMsg));
			},
			$author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$viewBody(
				{failedRules: checkDetails.failedRules, requiredDocumentTypes: typesForPills, tonu: tonu}));
	});
var $author$project$Components$FactorInvoiceAuditChecks$UnidentifiedDocumentsMsg = function (a) {
	return {$: 'UnidentifiedDocumentsMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$currentDocument = F2(
	function (cursor, documents) {
		var count = $elm$core$List$length(documents);
		var index = (!count) ? 0 : A2($elm$core$Basics$modBy, count, cursor);
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair(index + 1),
			$elm$core$List$head(
				A2($elm$core$List$drop, index, documents)));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$SkipClicked = {$: 'SkipClicked'};
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewActions = function (config) {
	return (config.isReadOnly || ($elm$core$List$length(config.documents) <= 1)) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__check-actions')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoice-audit__action-end')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$V3$Button$view,
						{
							action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$SkipClicked)
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
								$author$project$Components$AuditCheckActions$buttonSize
							]),
						'Next document')
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewDot = F2(
	function (position, index) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('invoice-audit__unidentified-cycler__dot', true),
							_Utils_Tuple2(
							'invoice-audit__unidentified-cycler__dot--current',
							_Utils_eq(index, position))
						]))
				]),
			_List_Nil);
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewCounter = F2(
	function (position, count) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__unidentified-cycler__counter')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Typography$smallBodySemiBold,
					_List_Nil,
					'Document ' + ($elm$core$String$fromInt(position) + (' of ' + $elm$core$String$fromInt(count)))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__unidentified-cycler__dots')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewDot(position),
						A2($elm$core$List$range, 1, count)))
				]));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$ThumbnailClicked = function (a) {
	return {$: 'ThumbnailClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewPreview = function (document) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('invoice-audit__unidentified-cycler__preview')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Components$DocumentThumbnail$view,
				{podTag: false, selected: false, thumbnailUrl: document.thumbnailUrl, title: 'Unknown'},
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$ThumbnailClicked(document.pageId)),
						$elm$html$Html$Attributes$class('document-thumbnail__page-container--clickable')
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$chunk = F2(
	function (size, items) {
		if (!items.b) {
			return _List_Nil;
		} else {
			return A2(
				$elm$core$List$cons,
				A2($elm$core$List$take, size, items),
				A2(
					$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$chunk,
					size,
					A2($elm$core$List$drop, size, items)));
		}
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$columnLength = 4;
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$offeredTypes = F2(
	function (guessedType, enabledDocumentTypes) {
		var sorted = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name;
			},
			enabledDocumentTypes);
		var _v0 = A2(
			$elm$core$List$partition,
			function (t) {
				return _Utils_eq(
					$elm$core$Maybe$Just(t.documentType),
					guessedType);
			},
			sorted);
		var guessed = _v0.a;
		var rest = _v0.b;
		return _Utils_ap(guessed, rest);
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$TypeClicked = F2(
	function (a, b) {
		return {$: 'TypeClicked', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewType = F3(
	function (isReadOnly, document, documentType) {
		var isGuessed = _Utils_eq(
			$elm$core$Maybe$Just(documentType.documentType),
			document.guessedType);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__unidentified-cycler__type')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$ActionCard$view,
					_List_fromArray(
						[
							$author$project$Ui$V3$ActionCard$inList,
							$author$project$Ui$V3$ActionCard$state($author$project$Ui$V3$ActionCard$default)
						]),
					{
						action: isGuessed ? $author$project$Ui$V3$ActionCard$customAction(
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('invoice-audit__unidentified-cycler__suggested')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Suggested')
									]))) : $author$project$Ui$V3$ActionCard$noAction,
						description: $elm$html$Html$text(''),
						icon: $elm$core$Maybe$Nothing,
						label: $elm$html$Html$text(documentType.name),
						onClick: isReadOnly ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$TypeClicked, document.documentId, documentType.documentType))
					})
				]));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewTypes = F2(
	function (config, document) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__unidentified-cycler__types')
				]),
			A2(
				$elm$core$List$map,
				function (column) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__unidentified-cycler__column')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewType, config.isReadOnly, document),
							column));
				},
				A2(
					$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$chunk,
					$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$columnLength,
					A2($author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$offeredTypes, document.guessedType, config.enabledDocumentTypes))));
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewBody = function (config) {
	var _v0 = A2($author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$currentDocument, config.cursor, config.documents);
	if (_v0.$ === 'Nothing') {
		return $elm$html$Html$text('');
	} else {
		var _v1 = _v0.a;
		var position = _v1.a;
		var document = _v1.b;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
					$author$project$Ui$V3$Stack$class('invoice-audit__check-body')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__unidentified-cycler')
						]),
					_List_fromArray(
						[
							$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewPreview(document),
							A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
									$author$project$Ui$V3$Stack$class('invoice-audit__unidentified-cycler__details')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewCounter,
									position,
									$elm$core$List$length(config.documents)),
									A2($author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewTypes, config, document),
									$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewActions(config)
								]))
						]))
				]));
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$viewUnidentifiedDocumentsBody = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$FactorInvoiceAuditChecks$UnidentifiedDocumentsMsg,
			$author$project$Components$FactorInvoiceAuditFailedCheckUnidentifiedDocuments$viewBody(
				{
					cursor: model.unidentifiedDocumentCursor,
					documents: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$Forward$Remote$toMaybe(config.unidentifiedDocuments)),
					enabledDocumentTypes: config.enabledDocumentTypes,
					isReadOnly: config.isReadOnly
				}));
	});
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$FailedCheckInput = function (a) {
	return {$: 'FailedCheckInput', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$InputDropMsg = function (a) {
	return {$: 'InputDropMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$toTestId = function (field) {
	switch (field.$) {
		case 'InvoiceAmountField':
			return 'drop-target-invoice-amount';
		case 'InvoiceDateField':
			return 'drop-target-invoice-date';
		case 'LoadIdField':
			return 'drop-target-load-id';
		case 'InvoiceNumberField':
			return 'drop-target-invoice-number';
		default:
			return 'drop-target-debtor';
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$wrapAsDropTarget = F2(
	function (field, leaf) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$attribute,
					'data-testid',
					$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$toTestId(field)),
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($author$project$Components$FactorInvoiceAuditChecks$InputDropMsg),
					$author$project$Components$DragDrop$dropAttributes(
						$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$FailedCheckInput(field)))),
			_List_fromArray(
				[leaf]));
	});
var $author$project$Components$FactorInvoiceAuditChecks$viewRuleCheckLeaf = F3(
	function (config, model, checkDetails) {
		var _v0 = checkDetails.checkType.check;
		switch (_v0.$) {
			case 'FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck':
				var invoiceAmountCheck = _v0.a;
				var amountInput = A3($author$project$Components$FactorInvoiceAuditChecks$shownDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount, config.formattedAmount, model);
				return A2(
					$author$project$Components$FactorInvoiceAuditChecks$wrapAsDropTarget,
					$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$InvoiceAmountField,
					A2(
						$elm$html$Html$map,
						$author$project$Components$FactorInvoiceAuditChecks$InvoiceAmountMsg,
						$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$viewBody(
							{
								amountInput: amountInput,
								editedFrom: A3($author$project$Components$FactorInvoiceAuditChecks$editedFrom, config, model, 'invoice_amount'),
								failedRules: checkDetails.failedRules,
								isReadOnly: config.isReadOnly,
								suggestions: invoiceAmountCheck.suggestions
							})));
			case 'FactorInvoiceAuditCheckType_Check_InvoiceDateCheck':
				var dateInput = A2(
					$author$project$Components$FactorInvoiceAuditChecks$resolveLeafInput,
					model.invoiceDateInput,
					A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, config.invoiceDate));
				return A2(
					$author$project$Components$FactorInvoiceAuditChecks$wrapAsDropTarget,
					$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$InvoiceDateField,
					A2(
						$elm$html$Html$map,
						$author$project$Components$FactorInvoiceAuditChecks$InvoiceDateMsg,
						$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$viewBody(
							{
								dateInput: dateInput,
								editedFrom: A3($author$project$Components$FactorInvoiceAuditChecks$editedFrom, config, model, 'invoice_date'),
								failedRules: checkDetails.failedRules,
								isReadOnly: config.isReadOnly
							})));
			case 'FactorInvoiceAuditCheckType_Check_DocumentPresenceCheck':
				var doc = _v0.a;
				return _Utils_eq(doc.requirement, $author$project$AuditPb$DocumentPresenceRequirementRequireDoctypes) ? A2($author$project$Components$FactorInvoiceAuditChecks$viewUnidentifiedDocumentsBody, config, model) : A3($author$project$Components$FactorInvoiceAuditChecks$viewDocumentPresenceBody, config, checkDetails, doc);
			case 'FactorInvoiceAuditCheckType_Check_PODRequiredCheck':
				return A2(
					$elm$html$Html$map,
					function (leafMsg) {
						return $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg(
							$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$update(leafMsg));
					},
					$author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$viewBody(
						{failedRules: checkDetails.failedRules, isReadOnly: config.isReadOnly, isTonu: config.factorInvoice.tonu, podDocuments: config.podDocuments}));
			case 'FactorInvoiceAuditCheckType_Check_CarrierRequiredCheck':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditChecks$CarrierRequiredMsg,
					$author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$viewBody(
						{carrierTerm: config.carrierTerm, dropdown: config.carrierDropdown, dropdownData: config.carrierDropdownData, isFactor: config.isFactor, isReadOnly: config.isReadOnly, selectedCarrier: config.selectedCarrier, showVendorId: config.showVendorId}));
			case 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck':
				var checkData = _v0.a;
				return A2(
					$author$project$Components$FactorInvoiceAuditChecks$wrapAsDropTarget,
					$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$DebtorField,
					A2(
						$elm$html$Html$map,
						$author$project$Components$FactorInvoiceAuditChecks$DebtorRequiredMsg,
						$author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$viewBody(
							{dropdown: config.debtorDropdown, dropdownData: config.debtorDropdownData, failedRules: checkDetails.failedRules, isReadOnly: config.isReadOnly, noaStatus: checkData.noaStatus, selectedDebtor: config.selectedDebtor, suggestions: checkData.suggestions})));
			case 'FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck':
				var checkData = _v0.a;
				var loadIdInput = A3($author$project$Components$FactorInvoiceAuditChecks$shownDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, config.loadId, model);
				return A2(
					$author$project$Components$FactorInvoiceAuditChecks$wrapAsDropTarget,
					$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$LoadIdField,
					A2(
						$elm$html$Html$map,
						$author$project$Components$FactorInvoiceAuditChecks$LoadIdMsg,
						$author$project$Components$FactorInvoiceAuditFailedCheckLoadId$viewBody(
							{
								debtorAutofillChecked: A2(
									$elm$core$Maybe$withDefault,
									A2(
										$elm$core$Maybe$withDefault,
										false,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.enabled;
											},
											checkData.debtorAutofillOffer)),
									model.debtorAutofillInput),
								debtorAutofillOffer: checkData.debtorAutofillOffer,
								editedFrom: A3($author$project$Components$FactorInvoiceAuditChecks$editedFrom, config, model, 'load_id_extraction_and_confirmation'),
								failedRules: checkDetails.failedRules,
								isReadOnly: config.isReadOnly,
								loadIdInput: loadIdInput,
								suggestions: checkData.suggestions
							})));
			case 'FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck':
				var checkData = _v0.a;
				var invoiceNumberInput = A3($author$project$Components$FactorInvoiceAuditChecks$shownDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, config.invoiceNumber, model);
				return A2(
					$author$project$Components$FactorInvoiceAuditChecks$wrapAsDropTarget,
					$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$InvoiceNumberField,
					A2(
						$elm$html$Html$map,
						$author$project$Components$FactorInvoiceAuditChecks$InvoiceNumberMsg,
						$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$viewBody(
							{
								editedFrom: A3($author$project$Components$FactorInvoiceAuditChecks$editedFrom, config, model, 'invoice_number'),
								failedRules: checkDetails.failedRules,
								invoiceNumberInput: invoiceNumberInput,
								isReadOnly: config.isReadOnly,
								suggestions: checkData.suggestions
							})));
			case 'FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditChecks$DuplicateInvoiceMsg,
					$author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$viewBody(
						{
							duplicateInvoices: config.duplicateInvoices,
							failedRules: checkDetails.failedRules,
							pathContext: config.pathContext,
							thisInvoice: {
								carrierName: A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.name;
									},
									config.assignedCarrier),
								debtorName: A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.name;
									},
									config.assignedDebtor),
								invoice: config.factorInvoice
							},
							timeZone: config.timeZone
						}));
			case 'FactorInvoiceAuditCheckType_Check_RateConBolConsistencyCheck':
				return A2(
					$elm$html$Html$map,
					function (leafMsg) {
						return $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg(
							$author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$update(leafMsg));
					},
					$author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$viewBody(
						{failedRules: checkDetails.failedRules}));
			case 'FactorInvoiceAuditCheckType_Check_BrokerClientRequirementsCheck':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditChecks$BrokerClientCarrierAmountMsg,
					A2(
						$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$viewBody,
						{
							carrierAmount: config.carrierAmount,
							editedFrom: A3($author$project$Components$FactorInvoiceAuditChecks$editedFrom, config, model, 'broker_client_carrier_amount'),
							failedRules: checkDetails.failedRules,
							isReadOnly: config.isReadOnly
						},
						{amountInput: model.brokerClientCarrierAmountInput}));
			case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierCheck':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditChecks$BrokerClientBrokeredCarrierMsg,
					$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$viewBody(
						{dropdown: config.brokeredCarrierDropdown, dropdownData: config.brokeredCarrierDropdownData, failedRules: checkDetails.failedRules, isReadOnly: config.isReadOnly}));
			case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierTermsCheck':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditChecks$BrokerClientBrokeredCarrierTermsMsg,
					$author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$viewBody(
						{dropdown: config.brokeredCarrierTermDropdown, dropdownData: config.brokeredCarrierTermDropdownData, failedRules: checkDetails.failedRules, isReadOnly: config.isReadOnly}));
			case 'FactorInvoiceAuditCheckType_Check_FactorLaneRateCheck':
				return A2(
					$elm$html$Html$map,
					function (leafMsg) {
						return $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg(
							$author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$update(leafMsg));
					},
					$author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$viewBody(checkDetails.failedRules));
			case 'FactorInvoiceAuditCheckType_Check_FundingInstructionsDetectedCheck':
				var checkData = _v0.a;
				return A2(
					$elm$html$Html$map,
					function (leafMsg) {
						return $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg(
							$author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$update(leafMsg));
					},
					$author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$viewBody(
						{failedRules: checkDetails.failedRules, text: checkData.text}));
			case 'FactorInvoiceAuditCheckType_Check_ClientDebtorRelationshipCheck':
				return A2(
					$elm$html$Html$map,
					function (leafMsg) {
						return $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg(
							$author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$update(leafMsg));
					},
					$author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$viewBody(checkDetails.failedRules));
			case 'FactorInvoiceAuditCheckType_Check_InvoiceDeliveryDateCheck':
				var checkData = _v0.a;
				return A2(
					$elm$html$Html$map,
					function (leafMsg) {
						return $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg(
							$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$update(leafMsg));
					},
					$author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$viewBody(
						{checkDays: checkData.checkDays, daysSince: checkData.daysSince, deliveryDate: checkData.deliveryDate, deliveryDateSource: checkData.deliveryDateSource, failedRules: checkDetails.failedRules}));
			default:
				var checkData = _v0.a;
				return A2(
					$elm$html$Html$map,
					function (leafMsg) {
						return $author$project$Components$FactorInvoiceAuditChecks$CommonActionMsg(
							$author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$update(leafMsg));
					},
					$author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$viewBody(
						{amount: checkData.amount, failedRules: checkDetails.failedRules, maxAmount: checkData.maxAmount}));
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$viewCheckBody = F3(
	function (config, model, check) {
		if (_Utils_eq(check.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultPassed)) {
			var _v0 = check.details;
			if (_v0.$ === 'FactorInvoiceAuditCheck_Details_ExceptionEvent') {
				return $elm$html$Html$text('');
			} else {
				var checkDetails = _v0.a;
				return A3($author$project$Components$FactorInvoiceAuditChecks$viewRuleCheckLeaf, config, model, checkDetails);
			}
		} else {
			if ((!_Utils_eq(check.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultFailed)) && (!_Utils_eq(check.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultPending))) {
				var _v1 = check.details;
				if (_v1.$ === 'FactorInvoiceAuditCheck_Details_ExceptionEvent') {
					return A2(
						$author$project$Components$FactorInvoiceAuditFailedCheck$viewResolvedOrIgnoredRules,
						{isReadOnly: config.isReadOnly, onUnignore: $author$project$Components$FactorInvoiceAuditChecks$UnignoreClicked},
						check);
				} else {
					var checkDetails = _v1.a;
					return $author$project$Components$AuditFailureHistory$view(
						{
							leaf: A3($author$project$Components$FactorInvoiceAuditChecks$viewRuleCheckLeaf, config, model, checkDetails),
							rows: _List_fromArray(
								[
									A2(
									$author$project$Components$FactorInvoiceAuditFailedCheck$viewResolvedOrIgnoredRules,
									{isReadOnly: config.isReadOnly, onUnignore: $author$project$Components$FactorInvoiceAuditChecks$UnignoreClicked},
									check)
								])
						});
				}
			} else {
				var _v2 = check.details;
				if (_v2.$ === 'FactorInvoiceAuditCheck_Details_ExceptionEvent') {
					var exceptionEvent = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$FactorInvoiceAuditChecks$ExceptionEventMsg(exceptionEvent.id),
						A2(
							$author$project$Components$AuditFailedCheckExceptionEvent$viewBody,
							exceptionEvent,
							A2($author$project$Components$FactorInvoiceAuditChecks$resolutionInputFor, exceptionEvent.id, model)));
				} else {
					var checkDetails = _v2.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$AuditCheckCard$viewActiveFailureMessages(
								$author$project$Components$FactorInvoiceAuditFailedCheck$failureMessages(check)),
								A3($author$project$Components$FactorInvoiceAuditChecks$viewRuleCheckLeaf, config, model, checkDetails)
							]));
				}
			}
		}
	});
var $elm$core$Basics$xor = _Basics_xor;
var $author$project$Components$FactorInvoiceAuditChecks$viewFailedRow = F4(
	function (config, model, firstActivelyFailingName, check) {
		var state = $author$project$Components$FactorInvoiceAuditFailedCheck$cardState(check);
		var checkId = $author$project$Components$FactorInvoiceAuditChecks$identifier(check);
		var defaultExpanded = _Utils_eq(
			firstActivelyFailingName,
			$elm$core$Maybe$Just(checkId));
		var hasUnsavedEdit = A3($author$project$Components$FactorInvoiceAuditChecks$hasUnsavedEditFor, config, model, checkId);
		var iconClass = function () {
			if ((state.$ === 'Just') && (state.a.$ === 'Failing')) {
				var _v1 = state.a;
				return 'invoice-audit__sticky-icon invoice-audit__sticky-icon--open';
			} else {
				return hasUnsavedEdit ? 'invoice-audit__sticky-icon fi-audit__sticky-icon--unsaved' : $author$project$Components$FactorInvoiceAuditChecks$settledIconClass(state);
			}
		}();
		var toggled = A2($elm$core$List$member, checkId, model.expandedFailedChecks);
		var isExpanded = defaultExpanded !== toggled;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__sticky-row invoice-audit__sticky-row--failed'),
					$elm$html$Html$Attributes$id(
					$author$project$Components$FactorInvoiceAuditChecks$checkElementId(checkId))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(iconClass)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__sticky-content')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$AuditCheckCard$viewCard,
							{
								hasUnsavedEdit: hasUnsavedEdit,
								isExpanded: isExpanded,
								onToggle: $author$project$Components$FactorInvoiceAuditChecks$ToggleFailedCheck(checkId),
								state: state,
								title: A2($author$project$Components$FactorInvoiceAuditChecks$cardTitle, config, check)
							},
							A3($author$project$Components$FactorInvoiceAuditChecks$viewCheckBody, config, model, check))
						]))
				]));
	});
var $author$project$Components$FactorInvoiceAuditChecks$viewCheckList = F3(
	function (config, model, failedChecks) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__sticky-list')
				]),
			A2(
				$elm$core$List$map,
				A3(
					$author$project$Components$FactorInvoiceAuditChecks$viewFailedRow,
					config,
					model,
					$author$project$Components$FactorInvoiceAuditChecks$firstActivelyFailing(failedChecks)),
				failedChecks));
	});
var $author$project$Components$FactorInvoiceAuditChecks$viewCheckListSection = F3(
	function (config, model, failedChecks) {
		return $elm$core$List$isEmpty(failedChecks) ? _List_Nil : _List_fromArray(
			[
				A3($author$project$Components$FactorInvoiceAuditChecks$viewCheckList, config, model, failedChecks)
			]);
	});
var $author$project$Components$FactorInvoiceAuditChecks$QuickReviewFieldsMsg = function (a) {
	return {$: 'QuickReviewFieldsMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$extractDebtorNoaStatus = function (checks) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (check) {
				var _v0 = check.details;
				if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
					var ruleCheck = _v0.a;
					var _v1 = ruleCheck.checkType.check;
					if (_v1.$ === 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck') {
						var data = _v1.a;
						return data.noaStatus;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			checks));
};
var $author$project$Components$FactorInvoiceAuditChecks$extractSiblingsSuggestions = function (checks) {
	var extract = function (check) {
		var _v0 = check.details;
		if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
			var ruleCheck = _v0.a;
			var _v1 = ruleCheck.checkType.check;
			switch (_v1.$) {
				case 'FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck':
					var data = _v1.a;
					return {debtor: _List_Nil, invoiceAmount: _List_Nil, invoiceNumber: _List_Nil, loadId: data.suggestions};
				case 'FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck':
					var data = _v1.a;
					return {debtor: _List_Nil, invoiceAmount: _List_Nil, invoiceNumber: data.suggestions, loadId: _List_Nil};
				case 'FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck':
					var data = _v1.a;
					return {debtor: _List_Nil, invoiceAmount: data.suggestions, invoiceNumber: _List_Nil, loadId: _List_Nil};
				case 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck':
					var data = _v1.a;
					return {debtor: data.suggestions, invoiceAmount: _List_Nil, invoiceNumber: _List_Nil, loadId: _List_Nil};
				default:
					return {debtor: _List_Nil, invoiceAmount: _List_Nil, invoiceNumber: _List_Nil, loadId: _List_Nil};
			}
		} else {
			return {debtor: _List_Nil, invoiceAmount: _List_Nil, invoiceNumber: _List_Nil, loadId: _List_Nil};
		}
	};
	return A3(
		$elm$core$List$foldl,
		F2(
			function (check, acc) {
				var s = extract(check);
				return {
					debtor: _Utils_ap(acc.debtor, s.debtor),
					invoiceAmount: _Utils_ap(acc.invoiceAmount, s.invoiceAmount),
					invoiceNumber: _Utils_ap(acc.invoiceNumber, s.invoiceNumber),
					loadId: _Utils_ap(acc.loadId, s.loadId)
				};
			}),
		{debtor: _List_Nil, invoiceAmount: _List_Nil, invoiceNumber: _List_Nil, loadId: _List_Nil},
		checks);
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$CollapseToggled = {$: 'CollapseToggled'};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorDropdownMsg = function (a) {
	return {$: 'DebtorDropdownMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$selectedDebtorName = function (config) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.factorBroker;
				},
				function ($) {
					return $.name;
				}),
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				$author$project$Forward$Remote$toMaybe(config.selectedDebtor))));
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewDebtorDetailsBody = function (config) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$elm$core$Basics$identity,
		$author$project$Forward$Remote$toMaybe(config.selectedDebtor));
	if (_v0.$ === 'Just') {
		var debtor = _v0.a;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('fi-audit-quick-review__details-body-wrapper', true),
							_Utils_Tuple2('fi-audit-quick-review__details-body-wrapper--expanded', config.debtorDetailsExpanded)
						])),
				$author$project$Components$AuditCheckCard$collapsedAttrs(config.debtorDetailsExpanded)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit-quick-review__details-body-clip')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit-quick-review__details-body')
								]),
							_List_fromArray(
								[
									$author$project$Components$DebtorDetails$view(debtor)
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorDetailsToggled = {$: 'DebtorDetailsToggled'};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewDebtorDetailsToggle = function (config) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$elm$core$Basics$identity,
		$author$project$Forward$Remote$toMaybe(config.selectedDebtor));
	if (_v0.$ === 'Just') {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit-quick-review__details')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('fi-audit-quick-review__details-toggle'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'aria-expanded',
							config.debtorDetailsExpanded ? 'true' : 'false'),
							$elm$html$Html$Events$onClick($author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorDetailsToggled)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Debtor Details'),
							A2(
							$author$project$Ui$V3$Icon$view16,
							_List_Nil,
							config.debtorDetailsExpanded ? $author$project$Ui$V3$Icon$chevronDown16 : $author$project$Ui$V3$Icon$chevronRight16)
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorSuggestionClicked = function (a) {
	return {$: 'DebtorSuggestionClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$FindClicked = function (a) {
	return {$: 'FindClicked', a: a};
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewSuggestionsSection = F2(
	function (suggestions, cards) {
		return $elm$core$List$isEmpty(suggestions) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit-quick-review__suggestions-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit-quick-review__suggestions-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Suggested Values')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit-quick-review__suggestions')
						]),
					cards)
				]));
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewDebtorSuggestions = function (config) {
	return A2(
		$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewSuggestionsSection,
		config.debtorSuggestions,
		A2(
			$elm$core$List$map,
			function (suggestion) {
				return A3(
					$author$project$Components$FactorInvoiceAuditCheckSuggestions$viewSuggestionCard,
					{
						formatValue: $elm$core$Basics$identity,
						isReadOnly: config.isReadOnly,
						onClick: function (value) {
							return $author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorSuggestionClicked(
								{entityId: suggestion.entityId, value: value});
						},
						onFindClick: $author$project$Components$FactorInvoiceAuditQuickReviewFields$FindClicked
					},
					$elm$core$Maybe$Nothing,
					suggestion);
			},
			config.debtorSuggestions));
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$InputDropMsg = function (a) {
	return {$: 'InputDropMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$QuickReviewInput = function (a) {
	return {$: 'QuickReviewInput', a: a};
};
var $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$toQuickReviewTestId = function (field) {
	return 'quick-review-' + $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$toTestId(field);
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$dropAttributes = F2(
	function (config, dropField) {
		return config.isReadOnly ? _List_Nil : A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$Attributes$attribute,
				'data-testid',
				$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$toQuickReviewTestId(dropField)),
			A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map($author$project$Components$FactorInvoiceAuditQuickReviewFields$InputDropMsg),
				$author$project$Components$DragDrop$dropAttributes(
					$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$QuickReviewInput(dropField))));
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewFieldTitleFind = F2(
	function (label, value) {
		return $author$project$Components$AuditQuickReviewCard$viewFindButton(
			{
				label: label,
				lookup: value,
				onFind: function (lookup) {
					return $author$project$Components$FactorInvoiceAuditQuickReviewFields$FindClicked(
						{location: $elm$core$Maybe$Nothing, value: lookup});
				}
			});
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewFieldTitle = F4(
	function (config, dropField, label, value) {
		return A3(
			$author$project$Components$AuditQuickReviewCard$viewFieldTitle,
			A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$dropAttributes, config, dropField),
			label,
			A2(
				$elm$core$List$cons,
				$author$project$Components$AuditQuickReviewCard$viewFieldValue(value.displayed),
				$elm$core$String$isEmpty(value.displayed) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$viewFieldTitleFind, label, value.lookup)
					])));
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewInputTitle = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('fi-audit-quick-review__input-title')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Selected Value')
		]));
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewNoaAlert = function (config) {
	var _v0 = config.debtorNoaStatus;
	if (_v0.$ === 'Just') {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit-quick-review__debtor-noa')
				]),
			_List_fromArray(
				[
					$author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$viewNoaAlert(config.debtorNoaStatus)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewDebtorField = function (config) {
	return A3(
		$author$project$Components$AuditQuickReviewCard$viewField,
		{isCollapsed: config.isCollapsed},
		A4(
			$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewFieldTitle,
			config,
			$author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$DebtorField,
			'Debtor',
			{
				displayed: $author$project$Components$FactorInvoiceAuditQuickReviewFields$selectedDebtorName(config),
				lookup: $author$project$Components$FactorInvoiceAuditQuickReviewFields$selectedDebtorName(config)
			}),
		_List_fromArray(
			[
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewDebtorSuggestions(config),
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewInputTitle,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit-quick-review__debtor-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit-quick-review__debtor-input')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$FactorInvoiceAuditQuickReviewFields$DebtorDropdownMsg,
								A3(
									$author$project$Components$DebtorDropdown$view,
									_List_fromArray(
										[
											$author$project$Ui$V3$CustomSelect$disabled(config.isReadOnly)
										]),
									config.debtorDropdownData,
									config.debtorDropdown))
							])),
						$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewDebtorDetailsToggle(config),
						$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewNoaAlert(config),
						$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewDebtorDetailsBody(config)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$Blurred = F2(
	function (a, b) {
		return {$: 'Blurred', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$InputChanged = F2(
	function (a, b) {
		return {$: 'InputChanged', a: a, b: b};
	});
var $author$project$Ui$V3$Input$LeadingTextAttribute = function (a) {
	return {$: 'LeadingTextAttribute', a: a};
};
var $author$project$Ui$V3$Input$leadingText = $author$project$Ui$V3$Input$LeadingTextAttribute;
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$currencyAttrs = function (fieldConfig) {
	var _v0 = _Utils_Tuple2(
		fieldConfig.currencyPrefix,
		$elm$core$String$isEmpty(
			$elm$core$String$trim(fieldConfig.value)));
	if ((_v0.a.$ === 'Just') && (!_v0.b)) {
		var prefix = _v0.a.a;
		return _List_fromArray(
			[
				$author$project$Ui$V3$Input$leadingText(prefix)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$toDropField = function (field) {
	switch (field.$) {
		case 'LoadId':
			return $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$LoadIdField;
		case 'InvoiceNumber':
			return $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$InvoiceNumberField;
		default:
			return $author$project$Components$FactorInvoiceAuditChecks$FactorInvoiceValueField$InvoiceAmountField;
	}
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewEditableFieldTitle = F2(
	function (config, fieldConfig) {
		return A3(
			$author$project$Components$AuditQuickReviewCard$viewFieldTitle,
			A2(
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$dropAttributes,
				config,
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$toDropField(fieldConfig.field)),
			fieldConfig.label,
			_List_fromArray(
				[
					A4(
					$author$project$Ui$V3$Input$view,
					{
						onInput: $author$project$Components$FactorInvoiceAuditQuickReviewFields$InputChanged(fieldConfig.field)
					},
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$placeholder(fieldConfig.placeholder),
								$author$project$Ui$V3$Input$disabled(config.isReadOnly),
								$author$project$Ui$V3$Input$class('fi-audit-quick-review__field-title-input'),
								$author$project$Ui$V3$Input$parentClass('fi-audit-quick-review__field-title-input-label')
							]),
						$author$project$Components$FactorInvoiceAuditQuickReviewFields$currencyAttrs(fieldConfig)),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$on,
							'blur',
							$elm$json$Json$Decode$succeed(
								A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$Blurred, fieldConfig.field, fieldConfig.value))),
							A2($elm$html$Html$Attributes$attribute, 'aria-label', fieldConfig.label)
						]),
					fieldConfig.value),
					$elm$core$String$isEmpty(
					$elm$core$String$trim(fieldConfig.value)) ? $elm$html$Html$text('') : A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$viewFieldTitleFind, fieldConfig.label, fieldConfig.value)
				]));
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewFindValueButton = function (fieldConfig) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('invoice-audit-check__find-value-btn'),
				$elm$html$Html$Attributes$title('Show on document'),
				$elm$html$Html$Events$onClick(
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$FindClicked(
					{location: $elm$core$Maybe$Nothing, value: fieldConfig.value}))
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$search16)
			]));
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$SuggestionClicked = F2(
	function (a, b) {
		return {$: 'SuggestionClicked', a: a, b: b};
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$formatValue = F2(
	function (fieldConfig, value) {
		var _v0 = fieldConfig.currencyPrefix;
		if (_v0.$ === 'Just') {
			var prefix = _v0.a;
			return _Utils_ap(prefix, value);
		} else {
			return value;
		}
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewSuggestions = F2(
	function (config, fieldConfig) {
		return A2(
			$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewSuggestionsSection,
			fieldConfig.suggestions,
			A2(
				$elm$core$List$map,
				A2(
					$author$project$Components$FactorInvoiceAuditCheckSuggestions$viewSuggestionCard,
					{
						formatValue: $author$project$Components$FactorInvoiceAuditQuickReviewFields$formatValue(fieldConfig),
						isReadOnly: config.isReadOnly,
						onClick: $author$project$Components$FactorInvoiceAuditQuickReviewFields$SuggestionClicked(fieldConfig.field),
						onFindClick: $author$project$Components$FactorInvoiceAuditQuickReviewFields$FindClicked
					},
					$elm$core$Maybe$Just(fieldConfig.value)),
				fieldConfig.suggestions));
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewTextField = F2(
	function (config, fieldConfig) {
		return A3(
			$author$project$Components$AuditQuickReviewCard$viewField,
			{isCollapsed: config.isCollapsed},
			A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$viewEditableFieldTitle, config, fieldConfig),
			_List_fromArray(
				[
					A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$viewSuggestions, config, fieldConfig),
					$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewInputTitle,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit-check__input-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invoice-audit-check__input')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$V3$Input$view,
									{
										onInput: $author$project$Components$FactorInvoiceAuditQuickReviewFields$InputChanged(fieldConfig.field)
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Input$placeholder(fieldConfig.placeholder),
											$author$project$Ui$V3$Input$disabled(config.isReadOnly)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$Events$on,
											'blur',
											$elm$json$Json$Decode$succeed(
												A2($author$project$Components$FactorInvoiceAuditQuickReviewFields$Blurred, fieldConfig.field, fieldConfig.value))),
											A2($elm$html$Html$Attributes$attribute, 'aria-label', fieldConfig.label)
										]),
									fieldConfig.value),
									$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewFindValueButton(fieldConfig)
								]))
						]))
				]));
	});
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewInvoiceAmountField = function (config) {
	return A2(
		$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewTextField,
		config,
		{
			currencyPrefix: $elm$core$Maybe$Just('$'),
			field: $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount,
			label: 'Invoice Amount',
			placeholder: 'Enter amount',
			suggestions: config.invoiceAmountSuggestions,
			value: config.invoiceAmountInput
		});
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewInvoiceNumberField = function (config) {
	return A2(
		$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewTextField,
		config,
		{currencyPrefix: $elm$core$Maybe$Nothing, field: $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, label: 'Invoice Number', placeholder: 'Enter invoice number', suggestions: config.invoiceNumberSuggestions, value: config.invoiceNumberInput});
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$viewLoadIdField = function (config) {
	return A2(
		$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewTextField,
		config,
		{currencyPrefix: $elm$core$Maybe$Nothing, field: $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, label: 'Load ID', placeholder: 'Enter load ID', suggestions: config.loadIdSuggestions, value: config.loadIdInput});
};
var $author$project$Components$FactorInvoiceAuditQuickReviewFields$view = function (config) {
	return A2(
		$author$project$Components$AuditQuickReviewCard$viewCard,
		{isCollapsed: config.isCollapsed, onToggle: $author$project$Components$FactorInvoiceAuditQuickReviewFields$CollapseToggled},
		_List_fromArray(
			[
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewLoadIdField(config),
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewInvoiceNumberField(config),
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewInvoiceAmountField(config),
				$author$project$Components$FactorInvoiceAuditQuickReviewFields$viewDebtorField(config)
			]));
};
var $author$project$Components$FactorInvoiceAuditChecks$viewQuickReviewCard = F2(
	function (config, model) {
		var siblingsSuggestions = $author$project$Components$FactorInvoiceAuditChecks$extractSiblingsSuggestions(config.auditChecks);
		return A2(
			$elm$html$Html$map,
			$author$project$Components$FactorInvoiceAuditChecks$QuickReviewFieldsMsg,
			$author$project$Components$FactorInvoiceAuditQuickReviewFields$view(
				{
					debtorDetailsExpanded: model.quickReviewDebtorDetailsExpanded,
					debtorDropdown: config.debtorDropdown,
					debtorDropdownData: config.debtorDropdownData,
					debtorNoaStatus: $author$project$Components$FactorInvoiceAuditChecks$extractDebtorNoaStatus(config.auditChecks),
					debtorSuggestions: siblingsSuggestions.debtor,
					invoiceAmountInput: A3($author$project$Components$FactorInvoiceAuditChecks$shownDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceAmount, config.formattedAmount, model),
					invoiceAmountSuggestions: siblingsSuggestions.invoiceAmount,
					invoiceNumberInput: A3($author$project$Components$FactorInvoiceAuditChecks$shownDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$InvoiceNumber, config.invoiceNumber, model),
					invoiceNumberSuggestions: siblingsSuggestions.invoiceNumber,
					isCollapsed: model.quickReviewCollapsed,
					isReadOnly: config.isReadOnly,
					loadIdInput: A3($author$project$Components$FactorInvoiceAuditChecks$shownDraft, $author$project$Components$FactorInvoiceAuditQuickReviewFields$LoadId, config.loadId, model),
					loadIdSuggestions: siblingsSuggestions.loadId,
					selectedDebtor: config.selectedDebtor
				}));
	});
var $author$project$Components$FactorInvoiceAuditChecks$view = F2(
	function (config, model) {
		var _v0 = $author$project$Components$FactorInvoiceAuditChecks$groupByResult(config.auditChecks);
		var failed = _v0.failed;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
				]),
			_Utils_ap(
				A3($author$project$Components$FactorInvoiceAuditChecks$viewCheckListSection, config, model, failed),
				_Utils_ap(
					config.isReadOnly ? _List_Nil : _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$FactorInvoiceAuditChecks$AddExceptionEventMsg,
							A2(
								$author$project$Components$AuditAddExceptionEvent$view,
								{customInvoiceExceptionMessages: config.customInvoiceExceptionMessages},
								model.addExceptionEvent))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id($author$project$Components$FactorInvoiceAuditChecks$quickReviewElementId)
								]),
							_List_fromArray(
								[
									A2($author$project$Components$FactorInvoiceAuditChecks$viewQuickReviewCard, config, model)
								]))
						]))));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$NotesChanged = function (a) {
	return {$: 'NotesChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$currentNotesValue = F2(
	function (data, model) {
		var _v0 = model.notesDraft;
		if (_v0.$ === 'Just') {
			var draft = _v0.a;
			return draft;
		} else {
			return A2($elm$core$Maybe$withDefault, '', data.factorInvoice.notes);
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$MustVerifyChanged = function (a) {
	return {$: 'MustVerifyChanged', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$currentMustVerifyValue = F2(
	function (data, model) {
		var _v0 = model.mustVerifyDraft;
		if (_v0.$ === 'Just') {
			var draft = _v0.a;
			return draft;
		} else {
			return data.factorInvoice.mustVerify;
		}
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewMustVerify = F2(
	function (data, model) {
		return model.verificationsWorkflowEnabled ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__must-verify')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Checkbox$view,
						{
							checked: A2($author$project$Components$FactorInvoiceAuditWorkingArea$currentMustVerifyValue, data, model),
							label: $elm$html$Html$text('Must be verified'),
							onCheck: $author$project$Components$FactorInvoiceAuditWorkingArea$MustVerifyChanged
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Checkbox$disabled(
								$author$project$Domain$FactorInvoice$readOnly(data.factorInvoice.state))
							]))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewNotes = F2(
	function (data, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__notes')
					]),
				A2(
					$elm$core$List$cons,
					A4(
						$author$project$Ui$V3$Input$view,
						{onInput: $author$project$Components$FactorInvoiceAuditWorkingArea$NotesChanged},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$label('Notes'),
								$author$project$Ui$V3$Input$expandable,
								$author$project$Ui$V3$Input$placeholder('Enter notes for this invoice...'),
								$author$project$Ui$V3$Input$disabled(
								$author$project$Domain$FactorInvoice$readOnly(data.factorInvoice.state))
							]),
						_List_Nil,
						A2($author$project$Components$FactorInvoiceAuditWorkingArea$currentNotesValue, data, model)),
					A2($author$project$Components$FactorInvoiceAuditWorkingArea$viewMustVerify, data, model)))
			]);
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$PossibleMatchesMsg = function (a) {
	return {$: 'PossibleMatchesMsg', a: a};
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$AssignDocumentsClicked = {$: 'AssignDocumentsClicked'};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$viewActions = F2(
	function (config, selectedMatch) {
		return config.isReadOnly ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__matches-actions')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$V3$Button$view,
						{
							action: $author$project$Ui$V3$Button$onClick($author$project$Components$FactorInvoiceAudit$PossibleMatches$AssignDocumentsClicked)
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
								$author$project$Ui$V3$Button$disabled(
								_Utils_eq(selectedMatch, $elm$core$Maybe$Nothing))
							]),
						'Assign Documents to This Invoice')
					]))
			]);
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$columnHeader = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__matches-column-header')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$viewColumnHeaders = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('fi-audit__matches-row fi-audit__matches-row--header')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__matches-select')
				]),
			_List_Nil),
			$author$project$Components$FactorInvoiceAudit$PossibleMatches$columnHeader('SENDER INFORMATION'),
			$author$project$Components$FactorInvoiceAudit$PossibleMatches$columnHeader('INVOICE INFORMATION'),
			$author$project$Components$FactorInvoiceAudit$PossibleMatches$columnHeader('DOCUMENTS')
		]));
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$field = F3(
	function (label, value, isMatched) {
		if (value.$ === 'Just') {
			var text = value.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__matches-field'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('fi-audit__matches-field--matched', isMatched)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							$elm$html$Html$text(' ' + text)
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$invoiceNumberLink = F3(
	function (pathContext, invoiceId, number) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__matches-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice:')
						])),
					$elm$html$Html$text(' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Path$toString(
								A2($author$project$Path$factorInvoice, invoiceId, pathContext))),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '[No invoice number]', number))
						]))
				]));
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$viewInvoiceInformation = F2(
	function (config, match) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					A3($author$project$Components$FactorInvoiceAudit$PossibleMatches$field, 'Origin:', match.origin, match.originMatches),
					A3($author$project$Components$FactorInvoiceAudit$PossibleMatches$field, 'Destination:', match.destination, match.destinationMatches),
					A3(
					$author$project$Components$FactorInvoiceAudit$PossibleMatches$field,
					'Amount:',
					A2(
						$elm$core$Maybe$map,
						function (amount) {
							return '$' + amount;
						},
						match.formattedAmount),
					false),
					A3($author$project$Components$FactorInvoiceAudit$PossibleMatches$field, 'Debtor:', match.debtorName, false),
					A2(
					$elm$core$List$concatMap,
					function (reference) {
						return A3(
							$author$project$Components$FactorInvoiceAudit$PossibleMatches$field,
							'Reference Match:',
							$elm$core$Maybe$Just(reference),
							true);
					},
					match.matchedReferences),
					A3($author$project$Components$FactorInvoiceAudit$PossibleMatches$field, 'Load ID:', match.loadId, false),
					_List_fromArray(
					[
						A3($author$project$Components$FactorInvoiceAudit$PossibleMatches$invoiceNumberLink, config.pathContext, match.id, match.invoiceNumber)
					])
				]));
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$MatchSelected = function (a) {
	return {$: 'MatchSelected', a: a};
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$viewRadio = F3(
	function (isReadOnly, selectedMatch, invoiceId) {
		return isReadOnly ? $elm$html$Html$text('') : A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('radio'),
					$elm$html$Html$Attributes$name('fi-audit__possible-match'),
					$elm$html$Html$Attributes$checked(
					_Utils_eq(
						selectedMatch,
						$elm$core$Maybe$Just(invoiceId))),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-label',
					'Select invoice ' + ($elm$core$String$fromInt(
						$author$project$Domain$FactorInvoiceId$toInt(invoiceId)) + ' to merge')),
					$elm$html$Html$Events$onCheck(
					function (_v0) {
						return $author$project$Components$FactorInvoiceAudit$PossibleMatches$MatchSelected(invoiceId);
					})
				]),
			_List_Nil);
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$emailDateText = F2(
	function (tz, emailDate) {
		if (emailDate.$ === 'Just') {
			var date = emailDate.a;
			return A2($author$project$Helpers$Date$dateStringTruncated, tz, date) + (' ' + A2($author$project$Helpers$Date$timeStringNoPadding, tz, date));
		} else {
			return '';
		}
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$viewSender = F2(
	function (config, match) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '[No subject]', match.emailSubject))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__matches-subtle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Components$FactorInvoiceAudit$PossibleMatches$emailDateText, config.timeZone, match.emailDate))
					]))
			]);
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$viewMatch = F3(
	function (config, selectedMatch, row) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__matches-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__matches-select')
						]),
					_List_fromArray(
						[
							A3($author$project$Components$FactorInvoiceAudit$PossibleMatches$viewRadio, config.isReadOnly, selectedMatch, row.match.id)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__matches-cell')
						]),
					A2($author$project$Components$FactorInvoiceAudit$PossibleMatches$viewSender, config, row.match)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__matches-cell')
						]),
					A2($author$project$Components$FactorInvoiceAudit$PossibleMatches$viewInvoiceInformation, config, row.match)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__matches-cell')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$String$join, ', ', row.documentTypeLabels))
						]))
				]));
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$viewBody = F2(
	function (config, _v0) {
		var model = _v0.a;
		if (model.isCollapsed) {
			return $elm$html$Html$text('');
		} else {
			var _v1 = config.matches;
			switch (_v1.$) {
				case 'Loading':
					return $author$project$Ui$V3$Skeleton$view(
						{height: $elm$core$Maybe$Nothing});
				case 'Error':
					var error = _v1.a;
					return $author$project$Forward$Remote$defaultErrorView(error);
				default:
					if (!_v1.a.b) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__matches-empty')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No possible matches')
								]));
					} else {
						var rows = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__matches-body')
								]),
							A2(
								$elm$core$List$cons,
								$author$project$Components$FactorInvoiceAudit$PossibleMatches$viewColumnHeaders,
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2($author$project$Components$FactorInvoiceAudit$PossibleMatches$viewMatch, config, model.selectedMatch),
										rows),
									A2($author$project$Components$FactorInvoiceAudit$PossibleMatches$viewActions, config, model.selectedMatch))));
					}
			}
		}
	});
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$CollapseToggled = {$: 'CollapseToggled'};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$viewHeader = function (isCollapsed) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('fi-audit__matches-header'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-expanded',
				isCollapsed ? 'false' : 'true'),
				$elm$html$Html$Events$onClick($author$project$Components$FactorInvoiceAudit$PossibleMatches$CollapseToggled)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__matches-title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Possible Matches')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__matches-chevron')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Icon$view16,
						_List_Nil,
						isCollapsed ? $author$project$Ui$V3$Icon$chevronRight16 : $author$project$Ui$V3$Icon$chevronDown16)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAudit$PossibleMatches$view = F2(
	function (config, _v0) {
		var model = _v0.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__matches')
					]),
				_List_fromArray(
					[
						$author$project$Components$FactorInvoiceAudit$PossibleMatches$viewHeader(model.isCollapsed),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__matches-body-wrapper'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('fi-audit__matches-body-wrapper--expanded', !model.isCollapsed)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fi-audit__matches-body-clip')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Components$FactorInvoiceAudit$PossibleMatches$viewBody,
										config,
										$author$project$Components$FactorInvoiceAudit$PossibleMatches$Model(model))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewPossibleMatches = F3(
	function (tz, data, model) {
		return A2(
			$elm$core$List$map,
			$elm$html$Html$map($author$project$Components$FactorInvoiceAuditWorkingArea$PossibleMatchesMsg),
			A2(
				$author$project$Components$FactorInvoiceAudit$PossibleMatches$view,
				{
					isReadOnly: $author$project$Domain$FactorInvoice$readOnly(data.factorInvoice.state),
					matches: data.possibleMatches,
					pathContext: {
						isReadonly: $author$project$Domain$FactorInvoice$readOnly(data.factorInvoice.state),
						useFactorInvoiceWorkflowPage: model.useFactorInvoiceWorkflowPage
					},
					timeZone: tz
				},
				model.possibleMatchesSection));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewChecks = F3(
	function (tz, remoteData, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Just') {
			var data = _v0.a;
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$map,
						$author$project$Components$FactorInvoiceAuditWorkingArea$AuditChecksMsg,
						A2(
							$author$project$Components$FactorInvoiceAuditChecks$view,
							A3($author$project$Components$FactorInvoiceAuditWorkingArea$auditChecksConfig, tz, data, model),
							model.auditChecks)),
					_Utils_ap(
						A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewPossibleMatches, tz, data, model),
						A2($author$project$Components$FactorInvoiceAuditWorkingArea$viewNotes, data, model))));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'min-height', '480px')
					]),
				_List_fromArray(
					[
						$author$project$Ui$V3$Skeleton$view(
						{height: $elm$core$Maybe$Nothing})
					]));
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$viewCompletedGroup = F3(
	function (config, model, completed) {
		return $elm$core$List$isEmpty(completed) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$AuditCompletedChecks$viewSectionHeader('Resolved Checks'),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invoice-audit__sticky-list')
							]),
						A2(
							$elm$core$List$map,
							A3($author$project$Components$FactorInvoiceAuditChecks$viewFailedRow, config, model, $elm$core$Maybe$Nothing),
							completed))
					]))
			]);
	});
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$hasEditableFields = false;
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$hasEditableFields = false;
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$hasEditableFields = false;
var $author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$hasEditableFields = false;
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$hasEditableFields = false;
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$hasEditableFields = false;
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$hasEditableFields = true;
var $author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$hasEditableFields = false;
var $author$project$Components$FactorInvoiceAuditChecks$checkHasEditableFields = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'FactorInvoiceAuditCheck_Details_ExceptionEvent') {
		return false;
	} else {
		var ruleCheck = _v0.a;
		var _v1 = ruleCheck.checkType.check;
		switch (_v1.$) {
			case 'FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_InvoiceDateCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_DocumentPresenceCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckDocumentPresence$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_PODRequiredCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_CarrierRequiredCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_RateConBolConsistencyCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_BrokerClientRequirementsCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierTermsCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_FactorLaneRateCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_FundingInstructionsDetectedCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_ClientDebtorRelationshipCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$hasEditableFields;
			case 'FactorInvoiceAuditCheckType_Check_InvoiceDeliveryDateCheck':
				return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$hasEditableFields;
			default:
				return $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$hasEditableFields;
		}
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$noaWarning = function (noaStatus) {
	if (noaStatus.$ === 'Just') {
		switch (noaStatus.a.$) {
			case 'DebtorNoaStatusNotFactorOfRecord':
				var _v1 = noaStatus.a;
				return $elm$core$Maybe$Just('Not the factor of record.');
			case 'DebtorNoaStatusCarrierNotFactored':
				var _v2 = noaStatus.a;
				return $elm$core$Maybe$Just('Carrier not factored.');
			case 'DebtorNoaStatusRelationshipMissing':
				var _v3 = noaStatus.a;
				return $elm$core$Maybe$Just('Carrier-debtor relationship missing.');
			default:
				var _v4 = noaStatus.a;
				return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$isNoaWarning = function (noaStatus) {
	return !_Utils_eq(
		$author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$noaWarning(noaStatus),
		$elm$core$Maybe$Nothing);
};
var $author$project$Components$FactorInvoiceAuditChecks$passedCheckHasWarning = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		var _v1 = ruleCheck.checkType.check;
		if (_v1.$ === 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck') {
			var checkData = _v1.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$isNoaWarning(checkData.noaStatus);
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$Components$FactorInvoiceAuditChecks$documentPresencePassedDescription = function (doc) {
	var _v0 = doc.requirement;
	switch (_v0.$) {
		case 'DocumentPresenceRequirementRateConfirmationRequired':
			return 'Rate Confirmation document found.';
		case 'DocumentPresenceRequirementBillOfLadingRequired':
			return 'Bill of Lading document found.';
		case 'DocumentPresenceRequirementPODRequired':
			return 'Delivery Receipt document found.';
		case 'DocumentPresenceRequirementDebtorVisibleDocumentRequired':
			return 'Debtor-visible document found.';
		case 'DocumentPresenceRequirementClientInvoiceRequired':
			return 'Client Invoice document found.';
		case 'DocumentPresenceRequirementCarrierInvoiceRequired':
			return 'Brokered Carrier Invoice document found.';
		case 'DocumentPresenceRequirementCarrierRateConfirmationRequired':
			return 'Brokered Carrier Rate Confirmation document found.';
		case 'DocumentPresenceRequirementRequireDoctypes':
			return 'All documents have assigned types.';
		case 'DocumentPresenceRequirementDocumentsRequired':
			return 'At least one document found.';
		default:
			if ($elm$core$List$isEmpty(doc.requiredDocumentTypes)) {
				return 'Debtor required documents found.';
			} else {
				var displayNames = A2(
					$elm$core$List$map,
					A2($author$project$Domain$DocumentType$toString, $elm$core$Dict$empty, $author$project$Domain$Environment$FactorEnvironment),
					A2($elm$core$List$filterMap, $author$project$AuditPb$documentTypeFromString, doc.requiredDocumentTypes));
				return 'All documents required by debtor are found: ' + (A2($elm$core$String$join, ', ', displayNames) + '.');
			}
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$passedDescription = function (_v0) {
	var brokeredCarrierName = _v0.brokeredCarrierName;
	if (brokeredCarrierName.$ === 'Just') {
		var name = brokeredCarrierName.a;
		return 'Brokered carrier confirmed — ' + (name + '.');
	} else {
		return 'Brokered carrier confirmed.';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$passedDescription = function (_v0) {
	var brokeredCarrierTermName = _v0.brokeredCarrierTermName;
	if (brokeredCarrierTermName.$ === 'Just') {
		var name = brokeredCarrierTermName.a;
		return 'Brokered carrier terms confirmed - ' + (name + '.');
	} else {
		return 'Brokered carrier terms confirmed.';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$passedDescription = function (_v0) {
	var carrierAmount = _v0.carrierAmount;
	if (carrierAmount.$ === 'Just') {
		var amount = carrierAmount.a;
		return 'Brokered carrier amount confirmed — $' + (amount + '.');
	} else {
		return 'Brokered carrier amount confirmed.';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$passedDescription = function (_v0) {
	var carrierTerm = _v0.carrierTerm;
	var assignedCarrier = _v0.assignedCarrier;
	if (assignedCarrier.$ === 'Just') {
		var carrier = assignedCarrier.a;
		return carrierTerm + (' confirmed — ' + (carrier.name + '.'));
	} else {
		return 'Passed';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$passedDescription = 'No client/debtor relationship block configured.';
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$debtorLabel = function (debtor) {
	return debtor.name + (' (' + ($elm$core$String$fromInt(
		$author$project$Domain$FactorBrokerId$toInt(debtor.id)) + ')'));
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$passedDescription = function (_v0) {
	var noaStatus = _v0.noaStatus;
	var assignedDebtor = _v0.assignedDebtor;
	var _v1 = _Utils_Tuple2(
		$author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$noaWarning(noaStatus),
		assignedDebtor);
	if (_v1.a.$ === 'Just') {
		if (_v1.b.$ === 'Just') {
			var warning = _v1.a.a;
			var debtor = _v1.b.a;
			return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$debtorLabel(debtor) + (' — ' + warning);
		} else {
			var warning = _v1.a.a;
			var _v2 = _v1.b;
			return warning;
		}
	} else {
		if (_v1.b.$ === 'Just') {
			var _v3 = _v1.a;
			var debtor = _v1.b.a;
			return 'Debtor identified — ' + ($author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$debtorLabel(debtor) + ' confirmed.');
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return 'Passed';
		}
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$passedDescription = 'No duplicate invoice found.';
var $author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$passedDescription = 'Invoice amount is within the predicted lane rate.';
var $author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$passedDescription = 'No funding instructions detected.';
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$passedDescription = function (_v0) {
	var formattedAmount = _v0.formattedAmount;
	if (formattedAmount.$ === 'Just') {
		var formatted = formattedAmount.a;
		return 'Amount confirmed — $' + (formatted + '.');
	} else {
		return 'Passed';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$passedDescription = function (_v0) {
	var invoiceDate = _v0.invoiceDate;
	if (invoiceDate.$ === 'Just') {
		var d = invoiceDate.a;
		return 'Invoice date confirmed — ' + (A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', d) + '.');
	} else {
		return 'Passed';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$passedDescription = function (_v0) {
	var invoiceDate = _v0.invoiceDate;
	var checkDays = _v0.checkDays;
	var deliveryDate = _v0.deliveryDate;
	var _v1 = _Utils_Tuple3(deliveryDate, checkDays, invoiceDate);
	if (((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) && (_v1.c.$ === 'Just')) {
		var dd = _v1.a.a;
		var days = _v1.b.a;
		var invDate = _v1.c.a;
		return 'Delivery date of ' + (dd + (' is within ' + ($elm$core$String$fromInt(days) + (' days of ' + (invDate + ' invoice date.')))));
	} else {
		return 'Delivery date within allowed range.';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$passedDescription = function (_v0) {
	var invoiceNumber = _v0.invoiceNumber;
	if (invoiceNumber.$ === 'Just') {
		var number = invoiceNumber.a;
		return 'Invoice number confirmed — ' + (number + '.');
	} else {
		return 'Passed';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$passedDescription = function (_v0) {
	var loadId = _v0.loadId;
	if (loadId.$ === 'Just') {
		var id = loadId.a;
		return 'Load ID confirmed — ' + (id + '.');
	} else {
		return 'Load ID was found and confirmed.';
	}
};
var $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$passedDescription = 'Invoice amount is within the maximum threshold.';
var $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$passedDescription = 'Valid Proof of Delivery found.';
var $author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$passedDescription = 'Rate Confirmation and BOL match.';
var $author$project$Components$BrokeredCarrierTermDropdown$selectedName = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.text;
		},
		$elm$core$List$head(
			$author$project$Components$PaginatedDropdown$selectedIds(model.dropdown)));
};
var $author$project$Components$FactorInvoiceAuditChecks$passedDescription = F2(
	function (config, check) {
		var _v0 = check.details;
		if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
			var ruleCheck = _v0.a;
			var _v1 = ruleCheck.checkType.check;
			switch (_v1.$) {
				case 'FactorInvoiceAuditCheckType_Check_InvoiceAmountCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceAmount$passedDescription(
						{formattedAmount: config.formattedAmount});
				case 'FactorInvoiceAuditCheckType_Check_InvoiceDateCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDate$passedDescription(
						{invoiceDate: config.invoiceDate});
				case 'FactorInvoiceAuditCheckType_Check_DocumentPresenceCheck':
					var doc = _v1.a;
					return $author$project$Components$FactorInvoiceAuditChecks$documentPresencePassedDescription(doc);
				case 'FactorInvoiceAuditCheckType_Check_PODRequiredCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckPodRequired$passedDescription;
				case 'FactorInvoiceAuditCheckType_Check_CarrierRequiredCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckCarrierRequired$passedDescription(
						{assignedCarrier: config.assignedCarrier, carrierTerm: config.carrierTerm});
				case 'FactorInvoiceAuditCheckType_Check_DebtorRequiredCheck':
					var checkData = _v1.a;
					return $author$project$Components$FactorInvoiceAuditFailedCheckDebtorRequired$passedDescription(
						{assignedDebtor: config.assignedDebtor, noaStatus: checkData.noaStatus});
				case 'FactorInvoiceAuditCheckType_Check_LoadIdExtractionAndConfirmationCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckLoadId$passedDescription(
						{loadId: config.loadId});
				case 'FactorInvoiceAuditCheckType_Check_InvoiceNumberCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceNumber$passedDescription(
						{invoiceNumber: config.invoiceNumber});
				case 'FactorInvoiceAuditCheckType_Check_DuplicateInvoiceCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckDuplicateInvoice$passedDescription;
				case 'FactorInvoiceAuditCheckType_Check_RateConBolConsistencyCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckRateConBolConsistency$passedDescription;
				case 'FactorInvoiceAuditCheckType_Check_BrokerClientRequirementsCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientCarrierAmount$passedDescription(
						{carrierAmount: config.carrierAmount});
				case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrier$passedDescription(
						{brokeredCarrierName: config.brokeredCarrierName});
				case 'FactorInvoiceAuditCheckType_Check_BrokerClientBrokeredCarrierTermsCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckBrokerClientBrokeredCarrierTerms$passedDescription(
						{
							brokeredCarrierTermName: $author$project$Components$BrokeredCarrierTermDropdown$selectedName(config.brokeredCarrierTermDropdown)
						});
				case 'FactorInvoiceAuditCheckType_Check_FactorLaneRateCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckFactorLaneRate$passedDescription;
				case 'FactorInvoiceAuditCheckType_Check_FundingInstructionsDetectedCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckFundingInstructions$passedDescription;
				case 'FactorInvoiceAuditCheckType_Check_ClientDebtorRelationshipCheck':
					return $author$project$Components$FactorInvoiceAuditFailedCheckClientDebtorRelationship$passedDescription;
				case 'FactorInvoiceAuditCheckType_Check_InvoiceDeliveryDateCheck':
					var checkData = _v1.a;
					return $author$project$Components$FactorInvoiceAuditFailedCheckInvoiceDeliveryDate$passedDescription(
						{checkDays: checkData.checkDays, deliveryDate: checkData.deliveryDate, invoiceDate: checkData.invoiceDate});
				default:
					return $author$project$Components$FactorInvoiceAuditFailedCheckMaxAmountReview$passedDescription;
			}
		} else {
			return '';
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$passedRow = F3(
	function (config, model, check) {
		var checkId = $author$project$Components$FactorInvoiceAuditChecks$identifier(check);
		return {
			description: A2($author$project$Components$FactorInvoiceAuditChecks$passedDescription, config, check),
			domId: $elm$core$Maybe$Just(
				$author$project$Components$FactorInvoiceAuditChecks$checkElementId(checkId)),
			expansion: $author$project$Components$FactorInvoiceAuditChecks$checkHasEditableFields(check) ? $author$project$Components$AuditCompletedChecks$Expandable(
				{
					body: A3($author$project$Components$FactorInvoiceAuditChecks$viewCheckBody, config, model, check),
					isExpanded: A2($elm$core$List$member, checkId, model.expandedFailedChecks),
					onToggle: $author$project$Components$FactorInvoiceAuditChecks$ToggleFailedCheck(checkId)
				}) : $author$project$Components$AuditCompletedChecks$NothingMoreToShow,
			hasUnsavedEdit: A3($author$project$Components$FactorInvoiceAuditChecks$hasUnsavedEditFor, config, model, checkId),
			title: A2($author$project$Components$FactorInvoiceAuditChecks$titleFor, config, check),
			tone: $author$project$Components$FactorInvoiceAuditChecks$passedCheckHasWarning(check) ? $author$project$Components$AuditCompletedChecks$Warning : $author$project$Components$AuditCompletedChecks$Positive
		};
	});
var $author$project$Components$FactorInvoiceAuditChecks$viewPassedGroup = F3(
	function (config, model, passed) {
		return $author$project$Components$AuditCompletedChecks$viewSection(
			{
				label: 'Automatically Passed Checks',
				rows: A2(
					$elm$core$List$map,
					A2($author$project$Components$FactorInvoiceAuditChecks$passedRow, config, model),
					passed)
			});
	});
var $author$project$Components$FactorInvoiceAuditChecks$viewCompleted = F2(
	function (config, model) {
		var _v0 = $author$project$Components$FactorInvoiceAuditChecks$groupByResult(config.auditChecks);
		var ignored = _v0.ignored;
		var resolved = _v0.resolved;
		var passed = _v0.passed;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
				]),
			_Utils_ap(
				A3($author$project$Components$FactorInvoiceAuditChecks$viewPassedGroup, config, model, passed),
				A3(
					$author$project$Components$FactorInvoiceAuditChecks$viewCompletedGroup,
					config,
					model,
					_Utils_ap(resolved, ignored))));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewCompleted = F3(
	function (tz, remoteData, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Just') {
			var data = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$FactorInvoiceAuditWorkingArea$AuditChecksMsg,
				A2(
					$author$project$Components$FactorInvoiceAuditChecks$viewCompleted,
					A3($author$project$Components$FactorInvoiceAuditWorkingArea$auditChecksConfig, tz, data, model),
					model.auditChecks));
		} else {
			return $author$project$Ui$V3$Skeleton$view(
				{height: $elm$core$Maybe$Nothing});
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$GroupCompleted = {$: 'GroupCompleted'};
var $author$project$Components$FactorInvoiceAuditBatchPage$boolToAttribute = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewFactorInvoiceElement = F2(
	function (hasMoreGroups, model) {
		return A3(
			$elm$html$Html$node,
			'ht-factor-invoice',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'factor-invoice-id',
					$elm$core$String$fromInt(
						$author$project$Domain$FactorInvoiceId$toInt(model.workingArea.factorInvoiceId))),
					A2(
					$elm$html$Html$Attributes$attribute,
					'has-more-groups',
					$author$project$Components$FactorInvoiceAuditBatchPage$boolToAttribute(hasMoreGroups)),
					A2($elm$html$Html$Attributes$attribute, 'advances-groups', 'true'),
					A2(
					$elm$html$Html$Events$on,
					'group-completed',
					$elm$json$Json$Decode$succeed($author$project$Components$FactorInvoiceAuditBatchPage$GroupCompleted))
				]),
			_List_Nil);
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$viewSelectedTabContent = F4(
	function (tz, workingAreaData, verificationTabData, model) {
		var _v0 = model.selectedTab;
		switch (_v0.$) {
			case 'Summary':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
					A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewChecks, tz, workingAreaData, model.workingArea));
			case 'CompletedChecks':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
					A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewCompleted, tz, workingAreaData, model.workingArea));
			case 'Details':
				var _v1 = model.hasMoreGroups;
				if (_v1.$ === 'Just') {
					var hasMoreGroups = _v1.a;
					return A2($author$project$Components$FactorInvoiceAuditBatchPage$viewFactorInvoiceElement, hasMoreGroups, model);
				} else {
					return $author$project$Ui$V3$Skeleton$view(
						{height: $elm$core$Maybe$Nothing});
				}
			default:
				return $author$project$Components$FactorInvoiceAuditVerificationTab$view(verificationTabData);
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$viewTabContent = F4(
	function (tz, workingAreaData, verificationTabData, model) {
		var _v0 = model.pendingInvoiceGroupId;
		if (_v0.$ === 'Just') {
			return $author$project$Components$FactorInvoiceAuditBatchPage$viewPendingInvoiceNotice;
		} else {
			return A4($author$project$Components$FactorInvoiceAuditBatchPage$viewSelectedTabContent, tz, workingAreaData, verificationTabData, model);
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$Details = {$: 'Details'};
var $author$project$Components$FactorInvoiceAuditBatchPage$Verification = {$: 'Verification'};
var $author$project$Components$FactorInvoiceAuditChecks$hasUnsavedCompletedCheck = F3(
	function (checks, savedValues, model) {
		var _v0 = $author$project$Components$FactorInvoiceAuditChecks$groupByResult(checks);
		var ignored = _v0.ignored;
		var resolved = _v0.resolved;
		var passed = _v0.passed;
		var completedIds = A2(
			$elm$core$List$map,
			$author$project$Components$FactorInvoiceAuditChecks$identifier,
			_Utils_ap(
				passed,
				_Utils_ap(resolved, ignored)));
		return A2(
			$elm$core$List$any,
			function (edit) {
				return A2($elm$core$List$member, edit.checkId, completedIds);
			},
			A2($author$project$Components$FactorInvoiceAuditChecks$unsavedEdits, savedValues, model));
	});
var $author$project$Components$FactorInvoiceAuditWorkingArea$hasUnsavedCompletedCheck = F2(
	function (remoteData, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Just') {
			var data = _v0.a;
			return A3($author$project$Components$FactorInvoiceAuditChecks$hasUnsavedCompletedCheck, data.auditChecks, data.factorInvoice, model.auditChecks);
		} else {
			return false;
		}
	});
var $author$project$Components$FactorInvoiceAuditChecks$viewProgressRow = function (_v0) {
	var total = _v0.total;
	var ignoredCount = _v0.ignoredCount;
	var resolvedCount = _v0.resolvedCount;
	var passedCount = _v0.passedCount;
	var segment = F2(
		function (result, count) {
			return (!count) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-audit__progress-segment fi-audit__progress-segment--' + result),
							A2(
							$elm$html$Html$Attributes$style,
							'flex-grow',
							$elm$core$String$fromInt(count))
						]),
					_List_Nil));
		});
	var segments = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(segment, 'passed', passedCount),
				A2(segment, 'resolved', resolvedCount),
				A2(segment, 'ignored', ignoredCount)
			]));
	var completedCount = (passedCount + resolvedCount) + ignoredCount;
	var countText = $elm$core$String$fromInt(completedCount) + (' of ' + $elm$core$String$fromInt(total));
	var pct = (!total) ? 0 : (completedCount / total);
	var fill = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__progress-fill'),
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromFloat(pct * 100) + '%')
			]),
		segments);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__progress-row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__progress-bar')
					]),
				_List_fromArray(
					[fill])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__progress-count')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(countText)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditChecks$viewProgress = function (config) {
	var _v0 = $author$project$Components$FactorInvoiceAuditChecks$groupByResult(config.auditChecks);
	var failed = _v0.failed;
	var ignored = _v0.ignored;
	var resolved = _v0.resolved;
	var passed = _v0.passed;
	return $author$project$Components$FactorInvoiceAuditChecks$viewProgressRow(
		{
			ignoredCount: $elm$core$List$length(ignored),
			passedCount: $elm$core$List$length(passed),
			resolvedCount: $elm$core$List$length(resolved),
			total: (($elm$core$List$length(passed) + $elm$core$List$length(resolved)) + $elm$core$List$length(ignored)) + $elm$core$List$length(failed)
		});
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$viewProgress = F3(
	function (tz, remoteData, model) {
		var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
		if (_v0.$ === 'Just') {
			var data = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$FactorInvoiceAuditWorkingArea$AuditChecksMsg,
				$author$project$Components$FactorInvoiceAuditChecks$viewProgress(
					A3($author$project$Components$FactorInvoiceAuditWorkingArea$auditChecksConfig, tz, data, model)));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$viewTab = F3(
	function (selectedTab, tab, content) {
		var selectedClass = _Utils_eq(selectedTab, tab) ? ' invoice-audit__tab--selected' : '';
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__tab' + selectedClass),
					$elm$html$Html$Events$onClick(
					$author$project$Components$FactorInvoiceAuditBatchPage$SelectTab(tab))
				]),
			content);
	});
var $author$project$Components$FactorInvoiceAuditVerificationTab$hasFailure = function (remoteData) {
	var _v0 = $author$project$Forward$Remote$toMaybe(remoteData);
	if (_v0.$ === 'Just') {
		var data = _v0.a;
		var _v1 = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.state;
			},
			data.verification);
		if ((_v1.$ === 'Just') && (_v1.a.$ === 'Verification_State_Fail')) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewVerificationTabLabel = function (verificationTabData) {
	return $author$project$Components$FactorInvoiceAuditVerificationTab$hasFailure(verificationTabData) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__tab-icon fi-audit__tab-icon--fail')
				]),
			_List_Nil),
			$elm$html$Html$text('Auto Verification')
		]) : _List_fromArray(
		[
			$elm$html$Html$text('Auto Verification')
		]);
};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewTabs = F4(
	function (tz, workingAreaData, verificationTabData, model) {
		var selectedTab = model.selectedTab;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__tabs')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A3(
						$author$project$Components$FactorInvoiceAuditBatchPage$viewTab,
						selectedTab,
						$author$project$Components$FactorInvoiceAuditBatchPage$Summary,
						_List_fromArray(
							[
								$elm$html$Html$text('Summary')
							])),
						A3(
						$author$project$Components$FactorInvoiceAuditBatchPage$viewTab,
						selectedTab,
						$author$project$Components$FactorInvoiceAuditBatchPage$Details,
						_List_fromArray(
							[
								$elm$html$Html$text('Details')
							]))
					]),
				_Utils_ap(
					model.accountSettings.verificationsEnabled ? _List_fromArray(
						[
							A3(
							$author$project$Components$FactorInvoiceAuditBatchPage$viewTab,
							selectedTab,
							$author$project$Components$FactorInvoiceAuditBatchPage$Verification,
							$author$project$Components$FactorInvoiceAuditBatchPage$viewVerificationTabLabel(verificationTabData))
						]) : _List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('invoice-audit__tab', true),
											_Utils_Tuple2('fi-audit__tab--progress', true),
											_Utils_Tuple2(
											'invoice-audit__tab--selected',
											_Utils_eq(selectedTab, $author$project$Components$FactorInvoiceAuditBatchPage$CompletedChecks))
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Components$FactorInvoiceAuditBatchPage$SelectTab($author$project$Components$FactorInvoiceAuditBatchPage$CompletedChecks))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$text('Completed Checks'),
										$author$project$Components$AuditUnsavedEdits$viewPip(
											(!_Utils_eq(selectedTab, $author$project$Components$FactorInvoiceAuditBatchPage$CompletedChecks)) && A2($author$project$Components$FactorInvoiceAuditWorkingArea$hasUnsavedCompletedCheck, workingAreaData, model.workingArea)))),
									A2(
									$elm$html$Html$map,
									$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
									A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewProgress, tz, workingAreaData, model.workingArea))
								]))
						]))));
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$viewLeftColumn = F6(
	function (tz, workingAreaData, verificationTabData, documentsBrowserData, panelArgs, model) {
		var _v0 = model.secondaryDocumentsBrowser;
		if (_v0.$ === 'Just') {
			var secondary = _v0.a;
			return A3($author$project$Components$FactorInvoiceAuditBatchPage$viewSecondaryDocumentsBrowser, tz, secondary, documentsBrowserData);
		} else {
			if (model.documentsBrowser.documentTypePickerOpen) {
				var _v1 = $author$project$Forward$Remote$toMaybe(documentsBrowserData);
				if (_v1.$ === 'Just') {
					var data = _v1.a;
					var docInfo = A2($author$project$Components$DocumentsBrowser$selectedDocumentType, model.documentsBrowser, data);
					return A2(
						$elm$html$Html$map,
						function (pickerMsg) {
							if (pickerMsg.$ === 'Selected') {
								var docId = pickerMsg.a;
								var docType = pickerMsg.b;
								return $author$project$Components$FactorInvoiceAuditBatchPage$DocumentsBrowserMsg(
									$author$project$Components$DocumentsBrowser$NonHotkeyMsg(
										A2($author$project$Components$DocumentsBrowser$UpdateDocumentType, docId, docType)));
							} else {
								return $author$project$Components$FactorInvoiceAuditBatchPage$DocumentsBrowserMsg(
									$author$project$Components$DocumentsBrowser$NonHotkeyMsg($author$project$Components$DocumentsBrowser$ToggleDocumentTypePicker));
							}
						},
						$author$project$Components$DocumentTypePicker$view(
							{currentType: docInfo.currentType, enabledDocumentTypes: model.documentsBrowser.enabledDocumentTypes, maybeDocumentId: docInfo.maybeDocumentId, showHotkeys: true}));
				} else {
					return $elm$html$Html$text('');
				}
			} else {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__panel-wrapper')
						]),
					_List_fromArray(
						[
							A4($author$project$Components$FactorInvoiceAuditBatchPage$viewTabs, tz, workingAreaData, verificationTabData, model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__panel-split')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invoice-audit__panel')
										]),
									A2(
										$elm$core$List$cons,
										$author$project$Presence$viewInCorner(model.presence),
										_Utils_ap(
											A2($author$project$Components$FactorInvoiceAuditWorkingArea$viewBanners, workingAreaData, model.workingArea),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$FactorInvoiceAuditBatchPage$ClientNotesPanelMsg,
													$author$project$Components$FactorInvoiceClientNotesPanel$view(panelArgs)),
													A4($author$project$Components$FactorInvoiceAuditBatchPage$viewTabContent, tz, workingAreaData, verificationTabData, model)
												]))))
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$FactorInvoiceAuditBatchPage$WorkingAreaMsg,
							A3(
								$author$project$Components$FactorInvoiceAuditWorkingArea$viewActionBar,
								$author$project$Components$FactorInvoiceAuditBatchPage$approvalScope(model),
								workingAreaData,
								model.workingArea))
						]));
			}
		}
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$CloseSendToCarrierModal = {$: 'CloseSendToCarrierModal'};
var $author$project$Components$FactorInvoiceAuditBatchPage$ExceptionSent = {$: 'ExceptionSent'};
var $author$project$Components$FactorInvoiceAuditSendToCarrierModal$checkMessages = function (check) {
	var _v0 = check.details;
	if (_v0.$ === 'FactorInvoiceAuditCheck_Details_FactorInvoiceAuditRuleCheck') {
		var ruleCheck = _v0.a;
		return A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.message;
			},
			ruleCheck.failedRules);
	} else {
		var event = _v0.a;
		var _v1 = event.message;
		if (_v1.$ === 'Just') {
			var msg = _v1.a;
			return _List_fromArray(
				[msg]);
		} else {
			return _List_Nil;
		}
	}
};
var $author$project$Components$FactorInvoiceAuditSendToCarrierModal$failingCheckMessages = function (allChecks) {
	return A2(
		$elm$core$List$concatMap,
		$author$project$Components$FactorInvoiceAuditSendToCarrierModal$checkMessages,
		A2(
			$elm$core$List$filter,
			function (c) {
				return _Utils_eq(c.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultFailed) || _Utils_eq(c.result, $author$project$AuditPb$FactorInvoiceAuditCheckResultPending);
			},
			allChecks));
};
var $author$project$Components$FactorInvoiceAuditSendToCarrierModal$viewEmailContext = function (maybeDetails) {
	var orDash = $elm$core$Maybe$withDefault('—');
	var emailClient = orDash(
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.carrierName;
			},
			maybeDetails));
	var accountExec = orDash(
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.carrierAccountExecutive;
			},
			maybeDetails));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fi-audit__send-modal-context')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__send-modal-context-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__send-modal-context-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Email Client:')
							])),
						$elm$html$Html$text(' ' + emailClient)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-audit__send-modal-context-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-audit__send-modal-context-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Account Exec:')
							])),
						$elm$html$Html$text(' ' + accountExec)
					]))
			]));
};
var $author$project$Components$FactorInvoiceAuditSendToCarrierModal$viewExceptionSenderElement = F2(
	function (queuedMessages, config) {
		return A3(
			$elm$html$Html$node,
			'ht-exception-sender',
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$attribute,
						'factor-invoice-id',
						$elm$core$String$fromInt(
							$author$project$Domain$FactorInvoiceId$toInt(config.workingArea.factorInvoiceId))),
						A2(
						$elm$html$Html$Attributes$property,
						'queuedMessages',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, queuedMessages)),
						A2(
						$elm$html$Html$Events$on,
						'exception-sent',
						$elm$json$Json$Decode$succeed(config.exceptionSentMsg)),
						A2(
						$elm$html$Html$Events$on,
						'exception-cancelled',
						$elm$json$Json$Decode$succeed(config.dismissMsg))
					]),
				function () {
					var _v0 = config.emailId;
					if (_v0.$ === 'Just') {
						var eid = _v0.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$attribute,
								'email-id',
								$elm$core$String$fromInt(
									$author$project$Domain$EmailMessageId$toInt(eid)))
							]);
					} else {
						return _List_Nil;
					}
				}()),
			_List_Nil);
	});
var $author$project$Components$FactorInvoiceAuditSendToCarrierModal$view = function (config) {
	if (config.isOpen) {
		var failingMessages = function () {
			var _v0 = $author$project$Forward$Remote$toMaybe(config.workingAreaData);
			if (_v0.$ === 'Just') {
				var data = _v0.a;
				return $author$project$Components$FactorInvoiceAuditSendToCarrierModal$failingCheckMessages(data.auditChecks);
			} else {
				return _List_Nil;
			}
		}();
		var emailDetails = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.factorInvoice;
				},
				function ($) {
					return $.documentBatchEmailDetails;
				}),
			$author$project$Forward$Remote$toMaybe(config.workingAreaData));
		return A2(
			$author$project$Ui$V3$Modal$view,
			_List_Nil,
			{
				body: A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$FactorInvoiceAuditSendToCarrierModal$viewEmailContext(emailDetails),
							A2($author$project$Components$FactorInvoiceAuditSendToCarrierModal$viewExceptionSenderElement, failingMessages, config)
						])),
				cancelButton: $elm$core$Maybe$Nothing,
				dismissMsg: config.dismissMsg,
				footerButtons: _List_Nil,
				header: $author$project$Ui$V3$Modal$textHeader('Send to ' + config.workingArea.carrierTerm),
				primaryButton: $elm$core$Maybe$Nothing,
				size: $author$project$Ui$V3$Modal$large
			});
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$FactorInvoiceAuditBatchPage$viewSendToCarrierModal = F2(
	function (workingAreaData, model) {
		return $author$project$Components$FactorInvoiceAuditSendToCarrierModal$view(
			{dismissMsg: $author$project$Components$FactorInvoiceAuditBatchPage$CloseSendToCarrierModal, emailId: model.emailMessageId, exceptionSentMsg: $author$project$Components$FactorInvoiceAuditBatchPage$ExceptionSent, isOpen: model.sendToCarrierModalOpen, workingArea: model.workingArea, workingAreaData: workingAreaData});
	});
var $author$project$Components$FactorInvoiceAuditBatchPage$view = F3(
	function (tz, remoteData, model) {
		var _v0 = function () {
			var _v1 = $author$project$Forward$Remote$toMaybe(remoteData);
			if (_v1.$ === 'Just') {
				var data = _v1.a;
				return _Utils_Tuple3(data.workingArea, data.documentsBrowserData, data.verificationTab);
			} else {
				return _Utils_Tuple3($author$project$Forward$Remote$Loading, $author$project$Forward$Remote$Loading, $author$project$Forward$Remote$Loading);
			}
		}();
		var loadedWorkingAreaData = _v0.a;
		var documentsBrowserData = _v0.b;
		var verificationTabData = _v0.c;
		var workingAreaData = function () {
			var _v2 = model.pendingInvoiceGroupId;
			if (_v2.$ === 'Just') {
				return $author$project$Forward$Remote$Loading;
			} else {
				return loadedWorkingAreaData;
			}
		}();
		var carrier = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.assignedCarrier;
			},
			$author$project$Forward$Remote$toMaybe(workingAreaData));
		var panelArgs = {accountSettings: model.accountSettings, carrier: carrier, model: model.clientNotesPanel};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Components$FactorInvoiceAuditWorkingArea$viewHeader,
										tz,
										workingAreaData,
										$author$project$Components$FactorInvoiceAuditBatchPage$headerActions(model)),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fi-audit__nav-row')
											]),
										_List_fromArray(
											[
												$author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$view(
												{
													carrierTerm: model.workingArea.carrierTerm,
													currentStep: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$CreateAndSubmitInvoice,
													documentBatchId: $elm$core$Maybe$Just(model.documentBatchId),
													maybeOnDone: model.workingArea.onDone,
													onGroupDocumentsClicked: model.accountSettings.useElmDocumentGrouping ? $elm$core$Maybe$Just($author$project$Components$FactorInvoiceAuditBatchPage$NavigateToGrouping) : $elm$core$Maybe$Nothing
												}),
												A2(
												$author$project$Helpers$Html$showIf,
												model.usesVectorWorkflow,
												$author$project$Components$JumpToLegacyInvoiceButton$view(
													{
														legacyHref: $author$project$Path$toString(
															A3($author$project$Path$legacyFactorInvoiceInBatch, model.documentBatchId, model.workingArea.factorInvoiceId, model.workingArea.onDone))
													}))
											])),
										A2(
										$author$project$Components$AuditSplitPane$viewSplit,
										{
											documents: A3($author$project$Components$FactorInvoiceAuditBatchPage$viewDocumentsBrowser, tz, model, documentsBrowserData),
											left: A6($author$project$Components$FactorInvoiceAuditBatchPage$viewLeftColumn, tz, workingAreaData, verificationTabData, documentsBrowserData, panelArgs, model),
											savedWidthPx: model.savedDocumentsColumnWidth,
											toMsg: $author$project$Components$FactorInvoiceAuditBatchPage$SplitPaneMsg
										},
										model.splitPane)
									])),
								A2($author$project$Components$FactorInvoiceAuditBatchPage$viewSendToCarrierModal, workingAreaData, model),
								A2($author$project$Components$FactorInvoiceAuditBatchPage$viewActiveModal, carrier, model),
								A2(
								$elm$html$Html$map,
								$author$project$Components$FactorInvoiceAuditBatchPage$PacketComparisonMsg,
								$author$project$Components$FactorInvoiceAuditPacketComparison$view(
									A2(
										$author$project$Forward$Remote$andThen,
										function ($) {
											return $.packetComparison;
										},
										remoteData)))
							])))
				]));
	});
var $author$project$Path$legacyFactorInvoice = F2(
	function (factorInvoiceId, maybeOnDone) {
		return A2(
			$author$project$Path$addQueries,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('forceReact', 'true'),
				$author$project$Path$onDoneQuery(maybeOnDone)),
			A2(
				$author$project$Path$factorInvoice,
				factorInvoiceId,
				{isReadonly: false, useFactorInvoiceWorkflowPage: false}));
	});
var $author$project$Components$FactorInvoiceAuditPage$mainViewerOptions = function (model) {
	return _Utils_ap(
		_List_fromArray(
			[
				$author$project$Components$DocumentsBrowser$enableThumbnailRightClick,
				$author$project$Components$DocumentsBrowser$enableLineDragging,
				$author$project$Components$DocumentsBrowser$expandButton(
				{
					expanded: $author$project$Components$AuditSplitPane$isExpanded(model.splitPane)
				}),
				$author$project$Components$DocumentsBrowser$popoutButton
			]),
		model.usesVectorWorkflow ? _List_fromArray(
			[$author$project$Components$DocumentsBrowser$enableBolRateConCompare]) : _List_Nil);
};
var $author$project$Components$FactorInvoiceAuditPage$viewDocumentsBrowser = F3(
	function (tz, model, remoteData) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg,
			A4(
				$author$project$Components$AuditDocumentsColumn$view,
				tz,
				model.documentsBrowser,
				$author$project$Components$FactorInvoiceAuditPage$mainViewerOptions(model),
				remoteData));
	});
var $author$project$Components$FactorInvoiceAuditPage$ClientNotesPanelMsg = function (a) {
	return {$: 'ClientNotesPanelMsg', a: a};
};
var $author$project$Components$FactorInvoiceAuditWorkingArea$SingleInvoice = {$: 'SingleInvoice'};
var $author$project$Components$FactorInvoiceAuditPage$viewSecondaryDocumentsBrowser = F3(
	function (tz, secondary, remoteData) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$FactorInvoiceAuditPage$SecondaryDocumentsBrowserMsg,
			A4(
				$author$project$Components$AuditDocumentsColumn$view,
				tz,
				secondary,
				_List_fromArray(
					[$author$project$Components$DocumentsBrowser$enableCloseButton]),
				remoteData));
	});
var $author$project$Components$FactorInvoiceAuditPage$viewFactorInvoiceElement = function (model) {
	return A3(
		$elm$html$Html$node,
		'ht-factor-invoice',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'factor-invoice-id',
				$elm$core$String$fromInt(
					$author$project$Domain$FactorInvoiceId$toInt(model.workingArea.factorInvoiceId))),
				A2($elm$html$Html$Attributes$attribute, 'has-more-groups', 'false'),
				A2($elm$html$Html$Attributes$attribute, 'advances-groups', 'false'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'done-url',
				A2($elm$core$Maybe$withDefault, '', model.workingArea.onDone))
			]),
		_List_Nil);
};
var $author$project$Components$FactorInvoiceAuditPage$viewTabContent = F4(
	function (tz, workingAreaData, verificationTabData, model) {
		var _v0 = model.selectedTab;
		switch (_v0.$) {
			case 'Summary':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg,
					A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewChecks, tz, workingAreaData, model.workingArea));
			case 'CompletedChecks':
				return A2(
					$elm$html$Html$map,
					$author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg,
					A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewCompleted, tz, workingAreaData, model.workingArea));
			case 'Details':
				return $author$project$Components$FactorInvoiceAuditPage$viewFactorInvoiceElement(model);
			default:
				return $author$project$Components$FactorInvoiceAuditVerificationTab$view(verificationTabData);
		}
	});
var $author$project$Components$FactorInvoiceAuditPage$Details = {$: 'Details'};
var $author$project$Components$FactorInvoiceAuditPage$Verification = {$: 'Verification'};
var $author$project$Components$FactorInvoiceAuditPage$viewTab = F3(
	function (selectedTab, tab, content) {
		var selectedClass = _Utils_eq(selectedTab, tab) ? ' invoice-audit__tab--selected' : '';
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__tab' + selectedClass),
					$elm$html$Html$Events$onClick(
					$author$project$Components$FactorInvoiceAuditPage$SelectTab(tab))
				]),
			content);
	});
var $author$project$Components$FactorInvoiceAuditPage$viewVerificationTabLabel = function (verificationTabData) {
	return $author$project$Components$FactorInvoiceAuditVerificationTab$hasFailure(verificationTabData) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-audit__tab-icon fi-audit__tab-icon--fail')
				]),
			_List_Nil),
			$elm$html$Html$text('Auto Verification')
		]) : _List_fromArray(
		[
			$elm$html$Html$text('Auto Verification')
		]);
};
var $author$project$Components$FactorInvoiceAuditPage$viewTabs = F4(
	function (tz, workingAreaData, verificationTabData, model) {
		var selectedTab = model.selectedTab;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-audit__tabs')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A3(
						$author$project$Components$FactorInvoiceAuditPage$viewTab,
						selectedTab,
						$author$project$Components$FactorInvoiceAuditPage$Summary,
						_List_fromArray(
							[
								$elm$html$Html$text('Summary')
							])),
						A3(
						$author$project$Components$FactorInvoiceAuditPage$viewTab,
						selectedTab,
						$author$project$Components$FactorInvoiceAuditPage$Details,
						_List_fromArray(
							[
								$elm$html$Html$text('Details')
							]))
					]),
				_Utils_ap(
					model.accountSettings.verificationsEnabled ? _List_fromArray(
						[
							A3(
							$author$project$Components$FactorInvoiceAuditPage$viewTab,
							selectedTab,
							$author$project$Components$FactorInvoiceAuditPage$Verification,
							$author$project$Components$FactorInvoiceAuditPage$viewVerificationTabLabel(verificationTabData))
						]) : _List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('invoice-audit__tab', true),
											_Utils_Tuple2('fi-audit__tab--progress', true),
											_Utils_Tuple2(
											'invoice-audit__tab--selected',
											_Utils_eq(selectedTab, $author$project$Components$FactorInvoiceAuditPage$CompletedChecks))
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Components$FactorInvoiceAuditPage$SelectTab($author$project$Components$FactorInvoiceAuditPage$CompletedChecks))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$text('Completed Checks'),
										$author$project$Components$AuditUnsavedEdits$viewPip(
											(!_Utils_eq(selectedTab, $author$project$Components$FactorInvoiceAuditPage$CompletedChecks)) && A2($author$project$Components$FactorInvoiceAuditWorkingArea$hasUnsavedCompletedCheck, workingAreaData, model.workingArea)))),
									A2(
									$elm$html$Html$map,
									$author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg,
									A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewProgress, tz, workingAreaData, model.workingArea))
								]))
						]))));
	});
var $author$project$Components$FactorInvoiceAuditPage$viewLeftColumn = F6(
	function (tz, workingAreaData, verificationTabData, documentsBrowserData, panelArgs, model) {
		var _v0 = model.secondaryDocumentsBrowser;
		if (_v0.$ === 'Just') {
			var secondary = _v0.a;
			return A3($author$project$Components$FactorInvoiceAuditPage$viewSecondaryDocumentsBrowser, tz, secondary, documentsBrowserData);
		} else {
			if (model.documentsBrowser.documentTypePickerOpen) {
				var _v1 = $author$project$Forward$Remote$toMaybe(documentsBrowserData);
				if (_v1.$ === 'Just') {
					var data = _v1.a;
					var docInfo = A2($author$project$Components$DocumentsBrowser$selectedDocumentType, model.documentsBrowser, data);
					return A2(
						$elm$html$Html$map,
						function (pickerMsg) {
							if (pickerMsg.$ === 'Selected') {
								var docId = pickerMsg.a;
								var docType = pickerMsg.b;
								return $author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg(
									$author$project$Components$DocumentsBrowser$NonHotkeyMsg(
										A2($author$project$Components$DocumentsBrowser$UpdateDocumentType, docId, docType)));
							} else {
								return $author$project$Components$FactorInvoiceAuditPage$DocumentsBrowserMsg(
									$author$project$Components$DocumentsBrowser$NonHotkeyMsg($author$project$Components$DocumentsBrowser$ToggleDocumentTypePicker));
							}
						},
						$author$project$Components$DocumentTypePicker$view(
							{currentType: docInfo.currentType, enabledDocumentTypes: model.documentsBrowser.enabledDocumentTypes, maybeDocumentId: docInfo.maybeDocumentId, showHotkeys: true}));
				} else {
					return $elm$html$Html$text('');
				}
			} else {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('invoice-audit__panel-wrapper')
						]),
					_List_fromArray(
						[
							A4($author$project$Components$FactorInvoiceAuditPage$viewTabs, tz, workingAreaData, verificationTabData, model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-audit__panel-split')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invoice-audit__panel')
										]),
									A2(
										$elm$core$List$cons,
										$author$project$Presence$viewInCorner(model.presence),
										_Utils_ap(
											A2($author$project$Components$FactorInvoiceAuditWorkingArea$viewBanners, workingAreaData, model.workingArea),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$FactorInvoiceAuditPage$ClientNotesPanelMsg,
													$author$project$Components$FactorInvoiceClientNotesPanel$view(panelArgs)),
													A4($author$project$Components$FactorInvoiceAuditPage$viewTabContent, tz, workingAreaData, verificationTabData, model)
												]))))
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$FactorInvoiceAuditPage$WorkingAreaMsg,
							A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewActionBar, $author$project$Components$FactorInvoiceAuditWorkingArea$SingleInvoice, workingAreaData, model.workingArea))
						]));
			}
		}
	});
var $author$project$Components$FactorInvoiceAuditPage$CloseSendToCarrierModal = {$: 'CloseSendToCarrierModal'};
var $author$project$Components$FactorInvoiceAuditPage$ExceptionSent = {$: 'ExceptionSent'};
var $author$project$Components$FactorInvoiceAuditPage$viewSendToCarrierModal = F2(
	function (workingAreaData, model) {
		return $author$project$Components$FactorInvoiceAuditSendToCarrierModal$view(
			{dismissMsg: $author$project$Components$FactorInvoiceAuditPage$CloseSendToCarrierModal, emailId: model.workingArea.emailId, exceptionSentMsg: $author$project$Components$FactorInvoiceAuditPage$ExceptionSent, isOpen: model.sendToCarrierModalOpen, workingArea: model.workingArea, workingAreaData: workingAreaData});
	});
var $author$project$Components$FactorInvoiceAuditPage$view = F3(
	function (tz, remoteData, model) {
		var _v0 = function () {
			var _v1 = $author$project$Forward$Remote$toMaybe(remoteData);
			if (_v1.$ === 'Just') {
				var data = _v1.a;
				return _Utils_Tuple3(data.workingArea, data.documentsBrowserData, data.verificationTab);
			} else {
				return _Utils_Tuple3($author$project$Forward$Remote$Loading, $author$project$Forward$Remote$Loading, $author$project$Forward$Remote$Loading);
			}
		}();
		var workingAreaData = _v0.a;
		var documentsBrowserData = _v0.b;
		var verificationTabData = _v0.c;
		var carrier = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.assignedCarrier;
			},
			$author$project$Forward$Remote$toMaybe(workingAreaData));
		var panelArgs = {accountSettings: model.accountSettings, carrier: carrier, model: model.clientNotesPanel};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled'),
					$elm$html$Html$Attributes$id('mainViewContainer')
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_Nil,
								_List_fromArray(
									[
										A3($author$project$Components$FactorInvoiceAuditWorkingArea$viewHeader, tz, workingAreaData, _List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fi-audit__nav-row')
											]),
										_List_fromArray(
											[
												$author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$view(
												{carrierTerm: model.workingArea.carrierTerm, currentStep: $author$project$Components$FactorInvoicesWorkflowIndexingNavigationBar$CreateAndSubmitInvoice, documentBatchId: $elm$core$Maybe$Nothing, maybeOnDone: model.workingArea.onDone, onGroupDocumentsClicked: $elm$core$Maybe$Nothing}),
												A2(
												$author$project$Helpers$Html$showIf,
												model.usesVectorWorkflow,
												$author$project$Components$JumpToLegacyInvoiceButton$view(
													{
														legacyHref: $author$project$Path$toString(
															A2($author$project$Path$legacyFactorInvoice, model.factorInvoiceId, model.workingArea.onDone))
													}))
											])),
										A2(
										$author$project$Components$AuditSplitPane$viewSplit,
										{
											documents: A3($author$project$Components$FactorInvoiceAuditPage$viewDocumentsBrowser, tz, model, documentsBrowserData),
											left: A6($author$project$Components$FactorInvoiceAuditPage$viewLeftColumn, tz, workingAreaData, verificationTabData, documentsBrowserData, panelArgs, model),
											savedWidthPx: model.savedDocumentsColumnWidth,
											toMsg: $author$project$Components$FactorInvoiceAuditPage$SplitPaneMsg
										},
										model.splitPane)
									])),
								A2($author$project$Components$FactorInvoiceAuditPage$viewSendToCarrierModal, workingAreaData, model),
								A2(
								$elm$html$Html$map,
								$author$project$Components$FactorInvoiceAuditPage$PacketComparisonMsg,
								$author$project$Components$FactorInvoiceAuditPacketComparison$view(
									A2(
										$author$project$Forward$Remote$andThen,
										function ($) {
											return $.packetComparison;
										},
										remoteData)))
							])))
				]));
	});
var $author$project$Ui$Ui = function (a) {
	return {$: 'Ui', a: a};
};
var $author$project$Ui$externalLink = F2(
	function (label, location) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-link__external'),
						$elm$html$Html$Attributes$href(location)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])));
	});
var $author$project$Ui$between3 = function (config) {
	return _Utils_update(
		config,
		{between: 3});
};
var $author$project$Ui$inset2 = function (config) {
	return _Utils_update(
		config,
		{horizontal: 2, vertical: 2});
};
var $author$project$Ui$defaultConfig = {between: 0, horizontal: 0, vertical: 0};
var $author$project$Ui$toHtml = function (_v0) {
	var html = _v0.a;
	return html;
};
var $author$project$Ui$stack = F2(
	function (attributes, children) {
		var config = A3($elm$core$List$foldl, $elm$core$Basics$identity, $author$project$Ui$defaultConfig, attributes);
		var classes = _List_fromArray(
			[
				'hubtran-box__stack',
				'hubtran-box__between-' + $elm$core$String$fromInt(config.between),
				'hubtran-box__horizontal-' + $elm$core$String$fromInt(config.horizontal),
				'hubtran-box__vertical-' + $elm$core$String$fromInt(config.vertical)
			]);
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($elm$core$String$join, ' ', classes))
					]),
				A2($elm$core$List$map, $author$project$Ui$toHtml, children)));
	});
var $author$project$Components$HelpPage$frame = $author$project$Ui$stack(
	_List_fromArray(
		[$author$project$Ui$between3, $author$project$Ui$inset2]));
var $author$project$Ui$heading = function (level) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Ui$Ui,
		A2(
			$elm$html$Html$node,
			'h' + level,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-heading__level-' + level)
				])));
};
var $author$project$Ui$heading2 = function (headingText) {
	return A2(
		$author$project$Ui$heading,
		'2',
		_List_fromArray(
			[
				$elm$html$Html$text(headingText)
			]));
};
var $author$project$Ui$mixedParagraph = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$author$project$Ui$Ui,
		$elm$html$Html$p(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-paragraph__mixed')
				]))),
	$elm$core$List$map($author$project$Ui$toHtml));
var $author$project$Ui$spacer = $author$project$Ui$Ui(
	A2($elm$html$Html$div, _List_Nil, _List_Nil));
var $author$project$Components$HelpPage$featureDoesntSupportAllHotkeys = function (_v0) {
	var settings = _v0.settings;
	return settings.featureEnableNonInvoiceFlow || (settings.useSubmissionWorkflow || settings.verificationsEnabled);
};
var $author$project$Ui$heading3 = function (headingText) {
	return A2(
		$author$project$Ui$heading,
		'3',
		_List_fromArray(
			[
				$elm$html$Html$text(headingText)
			]));
};
var $author$project$Components$HelpPage$manipulateDocumentsData = _List_fromArray(
	[
		_Utils_Tuple2('Alt+= or +(Numpad)', 'Zoom in'),
		_Utils_Tuple2('Alt+- or -(Numpad)', 'Zoom out'),
		_Utils_Tuple2('Right Arrow Key', 'Rotate page to right'),
		_Utils_Tuple2('Left Arrow Key', 'Rotate page to left')
	]);
var $author$project$Components$HelpPage$navigatePagesGroupsData = _List_fromArray(
	[
		_Utils_Tuple2('PgUp or Alt+P', 'Go to previous page'),
		_Utils_Tuple2('PgDn or Alt+Shift+P', 'Go to next page'),
		_Utils_Tuple2('Alt+G', 'Go to next Group'),
		_Utils_Tuple2('Alt+Shift+G', 'Go to previous Group')
	]);
var $author$project$Components$HelpPage$otherData = _List_fromArray(
	[
		_Utils_Tuple2('*(Numpad) or Alt+E', 'Edit a Doctype from any page')
	]);
var $author$project$Components$HelpPage$processDocumentsData = _List_fromArray(
	[
		_Utils_Tuple2('1-9 (Numpad)', 'Identify document types'),
		_Utils_Tuple2('0 (Numpad) or Alt+D', 'Verify that POD is signed'),
		_Utils_Tuple2('Alt+T', 'Mark page as illegible')
	]);
var $author$project$Ui$inset3 = function (config) {
	return _Utils_update(
		config,
		{horizontal: 3, vertical: 3});
};
var $author$project$Ui$cells = function (viewer) {
	return $elm$core$List$map(
		function (child) {
			return viewer(
				_List_fromArray(
					[
						$author$project$Ui$toHtml(
						A2(
							$author$project$Ui$stack,
							_List_fromArray(
								[$author$project$Ui$inset3]),
							_List_fromArray(
								[child])))
					]));
		});
};
var $author$project$Ui$headers = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$author$project$Ui$Ui,
		$elm$html$Html$thead(_List_Nil)),
	$author$project$Ui$cells(
		$elm$html$Html$th(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-table__header')
				]))));
var $author$project$Ui$row = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$author$project$Ui$Ui,
		$elm$html$Html$tr(_List_Nil)),
	$author$project$Ui$cells(
		$elm$html$Html$td(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-table__cell')
				]))));
var $author$project$Ui$table = F2(
	function (headers_, rows) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-table__table')
					]),
				_List_fromArray(
					[
						$author$project$Ui$toHtml(headers_),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2($elm$core$List$map, $author$project$Ui$toHtml, rows))
					])));
	});
var $author$project$Ui$text = function (content) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				])));
};
var $author$project$Components$HelpPage$toUiTable = function (rows) {
	return A2(
		$author$project$Ui$table,
		$author$project$Ui$headers(
			_List_fromArray(
				[
					$author$project$Ui$text('Shortcuts'),
					$author$project$Ui$text('Function')
				])),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var shortcut = _v0.a;
				var _function = _v0.b;
				return $author$project$Ui$row(
					_List_fromArray(
						[
							$author$project$Ui$text(shortcut),
							$author$project$Ui$text(_function)
						]));
			},
			rows));
};
var $author$project$Components$HelpPage$viewKeyboardShortcutSections = function (data) {
	return $author$project$Components$HelpPage$featureDoesntSupportAllHotkeys(data) ? _List_Nil : _List_fromArray(
		[
			$author$project$Ui$heading2('Keyboard Shortcuts'),
			$author$project$Ui$heading3('Process Documents'),
			$author$project$Components$HelpPage$toUiTable($author$project$Components$HelpPage$processDocumentsData),
			$author$project$Ui$heading3('Manipulate Documents'),
			$author$project$Components$HelpPage$toUiTable($author$project$Components$HelpPage$manipulateDocumentsData),
			$author$project$Ui$heading3('Navigate Pages and Groups'),
			$author$project$Components$HelpPage$toUiTable($author$project$Components$HelpPage$navigatePagesGroupsData),
			$author$project$Ui$heading3('Other'),
			$author$project$Components$HelpPage$toUiTable($author$project$Components$HelpPage$otherData)
		]);
};
var $author$project$Ui$unorderedList = function (children) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-unorderedlist__items')
				]),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$html$Html$li(_List_Nil),
					$elm$core$List$map($author$project$Ui$toHtml)),
				children)));
};
var $author$project$Components$HelpPage$viewSupportLink = function (data) {
	var _v0 = data.settings.processorSupportEmailAddress;
	if (_v0.$ === 'Nothing') {
		return _Utils_Tuple2('https://paymentshelp.triumph.io', 'https://paymentshelp.triumph.io');
	} else {
		var value = _v0.a;
		return _Utils_Tuple2(value, 'mailto:' + value);
	}
};
var $author$project$Components$HelpPage$viewSupportText = function (data) {
	var _v0 = data.settings.processorSupportEmailAddress;
	if (_v0.$ === 'Nothing') {
		return 'Find answers to FAQs and contact us at ';
	} else {
		return 'Email any questions to ';
	}
};
var $author$project$Components$HelpPage$viewTextSections = function (data) {
	return _List_fromArray(
		[
			$author$project$Ui$heading2('Contacting Support'),
			$author$project$Ui$mixedParagraph(
			_List_fromArray(
				[
					$author$project$Ui$text(
					$author$project$Components$HelpPage$viewSupportText(data)),
					function (_v0) {
					var label = _v0.a;
					var link = _v0.b;
					return A2($author$project$Ui$externalLink, label, link);
				}(
					$author$project$Components$HelpPage$viewSupportLink(data)),
					$author$project$Ui$text('. If you are sending in an error report, please include the following information:')
				])),
			$author$project$Ui$unorderedList(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$text('The URL of the page you are on. ')
					]),
					_List_fromArray(
					[
						$author$project$Ui$text('What you were trying to do and what you expected to happen. ')
					]),
					_List_fromArray(
					[
						$author$project$Ui$text('If you got an error message from the application, please include that.')
					])
				]))
		]);
};
var $author$project$Components$HelpPage$toV3Table = F2(
	function (title, rows) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A4(
					$author$project$Ui$V3$Table$view,
					{
						columns: _List_fromArray(
							[
								{
								attrs: _List_Nil,
								content: A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$html$Html$text),
								heading: $elm$html$Html$text('Shortcut')
							},
								{
								attrs: _List_Nil,
								content: A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$html$Html$text),
								heading: $elm$html$Html$text('Function')
							}
							])
					},
					_List_Nil,
					_List_Nil,
					rows)
				]));
	});
var $author$project$Components$HelpPage$viewV3Reskin = function (data) {
	return $author$project$Helpers$Html$v3ReskinContainer(
		A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXLarge)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
							]),
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Contacting Support')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Components$HelpPage$viewSupportText(data)),
													function (_v0) {
													var label = _v0.a;
													var link = _v0.b;
													return A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$href(link),
																A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(label)
															]));
												}(
													$author$project$Components$HelpPage$viewSupportLink(data)),
													$elm$html$Html$text('. If you are sending in an error report, please include the following information:')
												])),
											A2(
											$elm$html$Html$ul,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('The URL of the page you are on. ')
														])),
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('What you were trying to do and what you expected to happen. ')
														])),
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('If you got an error message from the application, please include that.')
														]))
												]))
										]))),
								$author$project$Components$HelpPage$featureDoesntSupportAllHotkeys(data) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$V3$Stack$viewVert,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Keyboard shortcuts')
														])),
													A2($author$project$Components$HelpPage$toV3Table, 'Process documents', $author$project$Components$HelpPage$processDocumentsData)
												])),
											A2($author$project$Components$HelpPage$toV3Table, 'Manipulate documents', $author$project$Components$HelpPage$manipulateDocumentsData),
											A2($author$project$Components$HelpPage$toV3Table, 'Navigate pages and groups', $author$project$Components$HelpPage$navigatePagesGroupsData),
											A2($author$project$Components$HelpPage$toV3Table, 'Other', $author$project$Components$HelpPage$otherData)
										]))),
								$elm$core$Maybe$Just(
								A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Privacy policy and standard terms of use')
												])),
											A2(
											$author$project$Ui$V3$Stack$viewVert,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href('https://triumph.io/privacy-policy/'),
															A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
															$author$project$Ui$V3$Typography$bodyClass
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Privacy policy')
														])),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href('https://triumph.io/terms-of-service/'),
															A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
															$author$project$Ui$V3$Typography$bodyClass
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Standard terms of use')
														]))
												]))
										])))
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$elm$html$Html$text(''))
				])));
};
var $author$project$Ui$empty = $author$project$Ui$Ui(
	$elm$html$Html$text(''));
var $author$project$Components$HelpPage$viewWhen = F2(
	function (condition, html) {
		return condition ? html : $author$project$Ui$empty;
	});
var $author$project$Components$HelpPage$view = F2(
	function (v3Reskin, data) {
		return v3Reskin ? $author$project$Components$HelpPage$viewV3Reskin(data) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('general-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('help-page')
						]),
					_List_fromArray(
						[
							$author$project$Ui$toHtml(
							A2(
								$author$project$Ui$stack,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$HelpPage$frame(
										$author$project$Components$HelpPage$viewTextSections(data)),
										$author$project$Components$HelpPage$frame(
										$author$project$Components$HelpPage$viewKeyboardShortcutSections(data)),
										A2(
										$author$project$Components$HelpPage$viewWhen,
										data.account.factorAccount,
										$author$project$Components$HelpPage$frame(
											_List_fromArray(
												[
													$author$project$Ui$heading2('Audit User Guide for Factors'),
													$author$project$Ui$mixedParagraph(
													_List_fromArray(
														[
															A2($author$project$Ui$externalLink, 'Audit User Guide for Factors', '/TPAY_0724_UserGuide_AuditforFactors.pdf')
														]))
												]))),
										$author$project$Components$HelpPage$frame(
										_List_fromArray(
											[
												$author$project$Ui$heading2('Privacy Policy and Standard Terms of Use'),
												$author$project$Ui$mixedParagraph(
												_List_fromArray(
													[
														A2($author$project$Ui$externalLink, 'Privacy Policy', 'https://triumph.io/privacy-policy/'),
														$author$project$Ui$spacer,
														A2($author$project$Ui$externalLink, 'Standard Terms of Use', 'https://triumph.io/terms-of-service/')
													]))
											]))
									])))
						]))
				]));
	});
var $author$project$Ui$V3$Pagination$Default = function (a) {
	return {$: 'Default', a: a};
};
var $author$project$Components$LtlHeldSubmissionsPage$SetEntriesPerPage = function (a) {
	return {$: 'SetEntriesPerPage', a: a};
};
var $author$project$Components$LtlHeldSubmissionsPage$SetPageNumber = function (a) {
	return {$: 'SetPageNumber', a: a};
};
var $author$project$Components$LtlHeldSubmissionsPage$SetSearchInput = function (a) {
	return {$: 'SetSearchInput', a: a};
};
var $author$project$Components$LtlHeldSubmissionsPage$SubmitSearchTerm = {$: 'SubmitSearchTerm'};
var $author$project$Components$LtlHeldSubmissionsPage$defaultString = '-';
var $author$project$Ui$V3$Icon$infoOutline16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipPath('url(#a)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$fill('#948D86'),
								$elm$svg$Svg$Attributes$d('M8.083 0a8 8 0 1 0 8 8 8.008 8.008 0 0 0-8-8Zm0 14.316A6.316 6.316 0 1 1 14.399 8a6.324 6.324 0 0 1-6.316 6.316Z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$fill('#948D86'),
								$elm$svg$Svg$Attributes$d('M9.944 11.158h-.632a.21.21 0 0 1-.21-.21v-3.16a1.684 1.684 0 0 0-1.684-1.684h-.843a.842.842 0 0 0 0 1.684h.666A.21.21 0 0 1 7.45 8v2.947a.21.21 0 0 1-.21.21h-.665a.842.842 0 1 0 0 1.685h3.368a.842.842 0 0 0 0-1.684ZM6.997 4.21a1.263 1.263 0 1 0 2.526 0 1.263 1.263 0 0 0-2.526 0Z')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$defs,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$clipPath,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('a')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill('#fff'),
										$elm$svg$Svg$Attributes$d('M0 0h16v16H0z')
									]),
								_List_Nil)
							]))
					]))
			])));
var $author$project$Components$LtlHeldSubmissionsPage$headerWithTooltip = F2(
	function (headerText, tooltipText) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorz,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(headerText),
					A3(
					$author$project$Ui$V3$Tooltip$view,
					_List_fromArray(
						[
							$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$AboveDirection),
							$author$project$Ui$V3$Tooltip$tooltipWidth(
							$author$project$Ui$V3$Tooltip$FixedWidth(200)),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'left', '-93px'),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'top', '-5px')
						]),
					tooltipText,
					A2(
						$author$project$Ui$V3$Icon$view16,
						_List_fromArray(
							[
								$author$project$Ui$V3$Icon$label('Matched load')
							]),
						$author$project$Ui$V3$Icon$infoOutline16))
				]));
	});
var $author$project$Ui$V3$Table$MinHeightAttribute = function (a) {
	return {$: 'MinHeightAttribute', a: a};
};
var $author$project$Ui$V3$Table$minHeight = function (value) {
	return $author$project$Ui$V3$Table$MinHeightAttribute(value);
};
var $author$project$Components$LtlHeldSubmissionsPage$prettyDocuments = F3(
	function (account, accountSettings, data) {
		var documentTypeToString = function (document) {
			return A3(
				$author$project$Domain$Helpers$documentTypeToString,
				account,
				accountSettings,
				$author$project$Domain$UnresolvedDocumentType$deserialize(
					$author$project$AuditPb$documentTypeToString(document.documentType)));
		};
		return $elm$html$Html$text(
			$elm$core$List$isEmpty(data.submission.documents) ? $author$project$Components$LtlHeldSubmissionsPage$defaultString : A2(
				$elm$core$String$join,
				', ',
				$elm_community$list_extra$List$Extra$unique(
					A2($elm$core$List$map, documentTypeToString, data.submission.documents))));
	});
var $author$project$Components$LtlHeldSubmissionsPage$prettyLoadLink = function (data) {
	var loadLink = F2(
		function (loadStateId, tmsLoad) {
			return A2(
				$author$project$Ui$V3$Link$view,
				{
					text: tmsLoad.loadId,
					url: $author$project$Path$toString(
						$author$project$Path$load(loadStateId))
				},
				_List_Nil);
		});
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text($author$project$Components$LtlHeldSubmissionsPage$defaultString),
		A3($elm$core$Maybe$map2, loadLink, data.submission.loadStateId, data.maybeTmsLoad));
};
var $author$project$Components$LtlHeldSubmissionsPage$prettyReceivedDate = F2(
	function (tz, data) {
		var date = data.submission.receivedDate;
		return $elm$html$Html$text(
			A2($author$project$Helpers$Date$dateString, tz, date) + (' ' + A2($author$project$Helpers$Date$timeStringNoPadding, tz, date)));
	});
var $author$project$Components$LtlHeldSubmissionsPage$SetSortOrder = function (a) {
	return {$: 'SetSortOrder', a: a};
};
var $author$project$AuditPb$SortOrderDesc = {$: 'SortOrderDesc'};
var $author$project$Components$LtlHeldSubmissionsPage$receivedDateHeader = function (sortOrder) {
	var _v0 = function () {
		if (sortOrder.$ === 'SortOrderAsc') {
			return _Utils_Tuple2($author$project$Ui$V3$Icon$sortArrowDown16, $author$project$AuditPb$SortOrderDesc);
		} else {
			return _Utils_Tuple2($author$project$Ui$V3$Icon$sortArrowUp16, $author$project$AuditPb$SortOrderAsc);
		}
	}();
	var icon = _v0.a;
	var newSort = _v0.b;
	return A2(
		$author$project$Ui$V3$Stack$viewHorz,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Received date'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Components$LtlHeldSubmissionsPage$SetSortOrder(newSort)),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Icon$view16,
						_List_fromArray(
							[
								$author$project$Ui$V3$Icon$label('Sort')
							]),
						icon)
					]))
			]));
};
var $author$project$Ui$V3$Table$toolbarSearch = function (_v0) {
	var onSubmit = _v0.onSubmit;
	var onInput = _v0.onInput;
	var placeholder = _v0.placeholder;
	var value = _v0.value;
	var container = function (el) {
		if (onSubmit.$ === 'Just') {
			var msg = onSubmit.a;
			return A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit(msg)
					]),
				_List_fromArray(
					[el]));
		} else {
			return el;
		}
	};
	return $author$project$Ui$V3$Table$ToolbarItem(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__table-toolbar-search')
				]),
			_List_fromArray(
				[
					container(
					A4(
						$author$project$Ui$V3$Input$view,
						{onInput: onInput},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$active(true),
								$author$project$Ui$V3$Input$placeholder(placeholder),
								A2(
								$author$project$Ui$V3$Input$leadingIcon,
								_List_fromArray(
									[
										$author$project$Ui$V3$Icon$label('Search')
									]),
								$author$project$Ui$V3$Icon$search16)
							]),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v3__table-search')
							]),
						value))
				])));
};
var $author$project$Components$LtlHeldSubmissionsPage$ImportToQueueButtonClick = function (a) {
	return {$: 'ImportToQueueButtonClick', a: a};
};
var $author$project$Components$LtlHeldSubmissionsPage$viewImportToQueueButton = F2(
	function (importsInProgress, submissionData) {
		return A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					$author$project$Components$LtlHeldSubmissionsPage$ImportToQueueButtonClick(submissionData.submission))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
					$author$project$Ui$V3$Button$disabled(
					A2(
						$elm$core$Set$member,
						$author$project$Domain$LtlPayablesCarrierInvoiceSubmissionId$toComparable(submissionData.submission.id),
						importsInProgress))
				]),
			'Import to queue');
	});
var $author$project$Components$LtlHeldSubmissionsPage$viewTable = F2(
	function (_v0, data) {
		var searchInput = _v0.searchInput;
		var sortOrder = _v0.sortOrder;
		var tz = _v0.tz;
		var importsInProgress = _v0.importsInProgress;
		var submissions = $author$project$Pagination$entries(data.ltlPayablesCarrierInvoiceSubmissions);
		var columns = _List_fromArray(
			[
				{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$Table$cellAttributes(
						function (_v2) {
							return _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding-left', '55px')
								]);
						})
					]),
				content: $author$project$Components$LtlHeldSubmissionsPage$prettyReceivedDate(tz),
				heading: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding-left', '40px')
						]),
					_List_fromArray(
						[
							$author$project$Components$LtlHeldSubmissionsPage$receivedDateHeader(sortOrder)
						]))
			},
				{
				attrs: _List_Nil,
				content: A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.submission;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.proNumber;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault($author$project$Components$LtlHeldSubmissionsPage$defaultString),
							$elm$html$Html$text))),
				heading: $elm$html$Html$text('Pro')
			},
				{
				attrs: _List_Nil,
				content: $author$project$Components$LtlHeldSubmissionsPage$prettyLoadLink,
				heading: A2($author$project$Components$LtlHeldSubmissionsPage$headerWithTooltip, 'Matched load', 'Load matched to EDI based on references found')
			},
				{
				attrs: _List_Nil,
				content: A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.submission;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.scac;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault($author$project$Components$LtlHeldSubmissionsPage$defaultString),
							$elm$html$Html$text))),
				heading: $elm$html$Html$text('SCAC')
			},
				{
				attrs: _List_Nil,
				content: A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.maybeTmsCarrier;
					},
					A2(
						$elm$core$Basics$composeR,
						A2(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Components$LtlHeldSubmissionsPage$defaultString,
							function ($) {
								return $.name;
							}),
						$elm$html$Html$text)),
				heading: A2($author$project$Components$LtlHeldSubmissionsPage$headerWithTooltip, 'Matched carrier', 'Carrier matched to EDI based on references found')
			},
				{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$Table$cellAttributes(
						function (_v3) {
							return _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'max-width', '200px')
								]);
						})
					]),
				content: A2($author$project$Components$LtlHeldSubmissionsPage$prettyDocuments, data.account, data.accountSettings),
				heading: $elm$html$Html$text('Documents')
			},
				{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$Table$cellAttributes(
						function (_v4) {
							return _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'max-width', '125px')
								]);
						})
					]),
				content: $author$project$Components$LtlHeldSubmissionsPage$viewImportToQueueButton(importsInProgress),
				heading: $elm$html$Html$text('Action')
			}
			]);
		return A4(
			$author$project$Ui$V3$Table$view,
			{columns: columns},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$defaultEmptyContent(
					{body: $elm$core$Maybe$Nothing, header: 'No Held Submissions'}),
					$author$project$Ui$V3$Table$toolbarItems(
					_List_fromArray(
						[
							_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Ui$V3$Table$toolbarEmpty),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$author$project$Ui$V3$Table$toolbarSearch(
								{
									onInput: $author$project$Components$LtlHeldSubmissionsPage$SetSearchInput,
									onSubmit: $elm$core$Maybe$Just($author$project$Components$LtlHeldSubmissionsPage$SubmitSearchTerm),
									placeholder: 'Pro number',
									value: searchInput
								}))
						])),
					$author$project$Ui$V3$Table$rowAttributes(
					function (_v1) {
						return _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'background', 'none')
							]);
					}),
					$author$project$Ui$V3$Table$pagination(
					{
						currentPage: data.ltlPayablesCarrierInvoiceSubmissions,
						dropdown: $author$project$Ui$V3$Pagination$Default(
							{onSelect: $author$project$Components$LtlHeldSubmissionsPage$SetEntriesPerPage}),
						updatePageMsg: $author$project$Components$LtlHeldSubmissionsPage$SetPageNumber
					}),
					$author$project$Ui$V3$Table$noOverflow,
					$author$project$Ui$V3$Table$fillHeight,
					$author$project$Ui$V3$Table$minHeight(500),
					$author$project$Ui$V3$Table$headCellAttrs(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'unset')
						]))
				]),
			_List_Nil,
			submissions);
	});
var $author$project$Components$LtlHeldSubmissionsPage$viewLoaded = F3(
	function (containerHeight, model, data) {
		return $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$author$project$Ui$V3$Stack$viewVertWithHeights,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium),
						$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceMedium),
						A2(
						$author$project$Ui$V3$Stack$style,
						'min-height',
						$author$project$Ui$V3$Helpers$Html$px(containerHeight))
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Held submissions')
								]))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2($author$project$Components$LtlHeldSubmissionsPage$viewTable, model, data))
					])));
	});
var $author$project$Components$LtlHeldSubmissionsPage$view = F3(
	function (containerHeight, data, model) {
		return A2(
			$author$project$Forward$LoadingView$viewV3Reskin,
			A2($author$project$Components$LtlHeldSubmissionsPage$viewLoaded, containerHeight, model),
			data);
	});
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$isEnabled = function (model) {
	return !$elm$core$List$isEmpty(model.ltlInvoiceAvailableTmsQueues);
};
var $author$project$Components$LtlReconcileInvoicePage$sectionTitle = function (title) {
	return A2(
		$elm$html$Html$h3,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-bottom', '16px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Components$LtlReconcileInvoicePage$sectionTopPadding = A2($elm$html$Html$Attributes$style, 'padding-top', '40px');
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Subtotal = {$: 'Subtotal'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Total = {$: 'Total'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Description = {$: 'Description'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Difference = {$: 'Difference'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Expected = {$: 'Expected'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Invoiced = {$: 'Invoiced'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$columnHeading = function (column) {
	return A2(
		$author$project$Ui$V3$Typography$smallBody,
		_List_Nil,
		function () {
			switch (column.$) {
				case 'Description':
					return 'Description';
				case 'Expected':
					return 'Expected';
				case 'Invoiced':
					return 'Invoiced';
				default:
					return 'Difference';
			}
		}());
};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$ShippedItem = {$: 'ShippedItem'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$tableCellAttributes = F2(
	function (columnType, row) {
		var maybeVerticalAlignRow = _Utils_eq(row.rowType, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$ShippedItem) ? (_Utils_eq(columnType, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Difference) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'vertical-align', 'bottom')
			]) : _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'vertical-align', 'top')
			])) : _List_Nil;
		var maybePadding = _Utils_eq(columnType, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Description) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-left', '16px')
			]) : (_Utils_eq(columnType, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Difference) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-right', '16px')
			]) : _List_Nil);
		var cellTopBottomPadding = function () {
			var _v0 = row.rowType;
			switch (_v0.$) {
				case 'Total':
					return '16px';
				case 'Subtotal':
					return '16px';
				case 'Subheader':
					return '8px';
				case 'LineItem':
					return '12px';
				default:
					return '24px';
			}
		}();
		return _Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding-top', cellTopBottomPadding),
					A2($elm$html$Html$Attributes$style, 'padding-bottom', cellTopBottomPadding)
				]),
			_Utils_ap(maybeVerticalAlignRow, maybePadding));
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$columns = _List_fromArray(
	[
		{
		attrs: _List_fromArray(
			[
				$author$project$Ui$V3$Table$cellAttributes(
				$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$tableCellAttributes($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Description))
			]),
		content: function ($) {
			return $.description;
		},
		heading: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$columnHeading($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Description)
	},
		{
		attrs: _List_fromArray(
			[
				$author$project$Ui$V3$Table$rightAligned,
				$author$project$Ui$V3$Table$cellAttributes(
				$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$tableCellAttributes($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Expected))
			]),
		content: function ($) {
			return $.lineItemExpected;
		},
		heading: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$columnHeading($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Expected)
	},
		{
		attrs: _List_fromArray(
			[
				$author$project$Ui$V3$Table$rightAligned,
				$author$project$Ui$V3$Table$cellAttributes(
				$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$tableCellAttributes($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Invoiced))
			]),
		content: function ($) {
			return $.carrierInvoiceExpected;
		},
		heading: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$columnHeading($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Invoiced)
	},
		{
		attrs: _List_fromArray(
			[
				$author$project$Ui$V3$Table$rightAligned,
				$author$project$Ui$V3$Table$cellAttributes(
				$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$tableCellAttributes($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Difference))
			]),
		content: function ($) {
			return $.difference;
		},
		heading: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$columnHeading($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Difference)
	}
	]);
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Subheader = {$: 'Subheader'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$headerRow = function (str) {
	return {
		carrierInvoiceExpected: $author$project$Helpers$Html$empty,
		description: A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, str),
		difference: $author$project$Helpers$Html$empty,
		lineItemExpected: $author$project$Helpers$Html$empty,
		rowType: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Subheader
	};
};
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$itemPairOrder = F2(
	function (itemPair1, itemPair2) {
		var _v0 = A2($elm$core$Basics$compare, itemPair2.metadata.sortScore, itemPair1.metadata.sortScore);
		if (_v0.$ === 'EQ') {
			return A2($elm$core$Basics$compare, itemPair1.metadata.description, itemPair2.metadata.description);
		} else {
			var other = _v0;
			return other;
		}
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$lineHaulTotals = function (equalityData) {
	var amountTuple = F2(
		function (maybeTotal, itemPair) {
			return _Utils_Tuple2(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Money$zero,
					A2(
						$elm$core$Maybe$andThen,
						maybeTotal,
						$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair))),
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Money$zero,
					A2(
						$elm$core$Maybe$andThen,
						maybeTotal,
						$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair))));
		});
	var lineItemAmounts = A2(
		$elm$core$List$map,
		amountTuple(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$Just,
				function ($) {
					return $.total;
				})),
		A2(
			$elm$core$List$filter,
			function (pair) {
				return _Utils_eq(pair.metadata.itemType, $author$project$AuditPb$LtlItemTypeLineHaul);
			},
			equalityData.lineItemPairs));
	var shippedItemAmounts = A2(
		$elm$core$List$map,
		amountTuple(
			function ($) {
				return $.maybeTotal;
			}),
		equalityData.shippedItemPairs);
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, _v1) {
				var loadAmount = _v0.a;
				var carrierAmount = _v0.b;
				var loadAmount_ = _v1.a;
				var carrierAmount_ = _v1.b;
				return _Utils_Tuple2(
					A2($author$project$Money$sum2, loadAmount, loadAmount_),
					A2($author$project$Money$sum2, carrierAmount, carrierAmount_));
			}),
		_Utils_Tuple2($author$project$Money$zero, $author$project$Money$zero),
		_Utils_ap(lineItemAmounts, shippedItemAmounts));
};
var $author$project$Ui$V3$Colors$Gray800 = {$: 'Gray800'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$rowAttributes = function (row) {
	var borderWidth = _Utils_eq(row.rowType, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Total) ? '1px' : '.5px';
	var baseRowAttrs = _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$style,
			'border-top-color',
			$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray200)),
			A2($elm$html$Html$Attributes$style, 'border-top-style', 'solid'),
			A2($elm$html$Html$Attributes$style, 'border-top-width', borderWidth),
			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray800)
		]);
	var backgroundColorAttr = _Utils_eq(row.rowType, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Subheader) ? $author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Gray50) : $author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Gray0);
	return A2($elm$core$List$cons, backgroundColorAttr, baseRowAttrs);
};
var $author$project$Ui$V3$Colors$Red700 = {$: 'Red700'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$default0 = $elm$core$Maybe$withDefault($author$project$Money$zero);
var $author$project$Money$difference = F2(
	function (_v0, _v1) {
		var cents1 = _v0.a;
		var cents2 = _v1.a;
		return $author$project$Money$fromCents(cents1 - cents2);
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$stringDefault = '-';
var $author$project$Money$toFloat = function (_v0) {
	var rawCents = _v0.a;
	return function (cents) {
		return cents / 100;
	}(rawCents);
};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$displayDifference = function (_v0) {
	var expectedAmount = _v0.expectedAmount;
	var invoicedAmount = _v0.invoicedAmount;
	var invoicedAmountOrZero = $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$default0(invoicedAmount);
	var expectedAmountOrZero = $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$default0(expectedAmount);
	var expectedMinusInvoiced = A2($author$project$Money$difference, expectedAmountOrZero, invoicedAmountOrZero);
	var expectedMinusInvoicedAsFloat = $author$project$Money$toFloat(expectedMinusInvoiced);
	var _v1 = _Utils_Tuple2(invoicedAmount, expectedAmount);
	if ((_v1.a.$ === 'Nothing') && (_v1.b.$ === 'Nothing')) {
		var _v2 = _v1.a;
		var _v3 = _v1.b;
		return $author$project$Helpers$Html$empty;
	} else {
		return _Utils_eq(expectedMinusInvoiced, $author$project$Money$zero) ? A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$stringDefault) : ((expectedMinusInvoicedAsFloat < 0) ? A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Red700)
				]),
			$author$project$Money$toString(expectedMinusInvoiced)) : A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_Nil,
			$author$project$Money$toString(expectedMinusInvoiced)));
	}
};
var $author$project$Domain$TmsShippedItem$prettyItemWeight = function (item) {
	var _v0 = _Utils_Tuple2(item.weight, item.weightUnit);
	if ((_v0.a.$ === 'Nothing') && (_v0.b.$ === 'Nothing')) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return '-';
	} else {
		return A2(
			$elm$core$String$join,
			' ',
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[item.weight, item.weightUnit])));
	}
};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$wrapValue = F2(
	function (isMismatch, value) {
		return isMismatch ? A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Red700)
				]),
			value) : A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, value);
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$shippedItemToRow = function (itemPair) {
	var loadItem = $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair);
	var itemAmount = function (item) {
		return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$stringDefault, $author$project$Money$toString, item.maybeTotal);
	};
	var itemToExpectedHtml = function (item) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Typography$smallBody,
					_List_Nil,
					'Class ' + A2($elm$core$Maybe$withDefault, '', item.className)),
					A2(
					$author$project$Ui$V3$Typography$smallBody,
					_List_Nil,
					$author$project$Domain$TmsShippedItem$prettyItemWeight(item)),
					A2(
					$author$project$Ui$V3$Typography$smallBody,
					_List_Nil,
					itemAmount(item))
				]));
	};
	var itemToInvoicedHtml = function (item) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$wrapValue,
					itemPair.metadata.classMismatch,
					'Class ' + A2($elm$core$Maybe$withDefault, '', item.className)),
					A2(
					$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$wrapValue,
					itemPair.metadata.weightMismatch,
					$author$project$Domain$TmsShippedItem$prettyItemWeight(item)),
					A2(
					$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$wrapValue,
					itemPair.metadata.amountMismatch,
					itemAmount(item))
				]));
	};
	var description = A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, itemPair.metadata.description);
	var carrierItem = $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair);
	return {
		carrierInvoiceExpected: A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$stringDefault),
			itemToInvoicedHtml,
			carrierItem),
		description: description,
		difference: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$displayDifference(
			{
				expectedAmount: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.maybeTotal;
					},
					loadItem),
				invoicedAmount: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.maybeTotal;
					},
					carrierItem)
			}),
		lineItemExpected: A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$stringDefault),
			itemToExpectedHtml,
			loadItem),
		rowType: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$ShippedItem
	};
};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$LineItem = {$: 'LineItem'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Amount = {$: 'Amount'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Percent = {$: 'Percent'};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$ToggleDiscountAmountPercentOption = F2(
	function (a, b) {
		return {$: 'ToggleDiscountAmountPercentOption', a: a, b: b};
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$getDiscountToggleOption = F2(
	function (itemPair, selectedDiscountToggleOptions) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Amount,
			A2($turboMaCk$any_dict$Dict$Any$get, itemPair, selectedDiscountToggleOptions));
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$discountPercentAmountToggle = F2(
	function (selectedDiscountToggleOptions, itemPair) {
		return A2(
			$author$project$Ui$V3$SecondaryToggle$view,
			_List_fromArray(
				[
					$author$project$Ui$V3$SecondaryToggle$topBottomPadding('0')
				]),
			{
				onToggle: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$ToggleDiscountAmountPercentOption(itemPair),
				segments: _List_fromArray(
					[$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Amount, $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Percent]),
				selected: A2($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$getDiscountToggleOption, itemPair, selectedDiscountToggleOptions),
				toLabel: function (option) {
					if (option.$ === 'Amount') {
						return $elm$html$Html$text('$');
					} else {
						return $elm$html$Html$text('%');
					}
				}
			});
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$viewDiscountPercentage = F2(
	function (total, amount) {
		var totalFloat = $author$project$Money$toFloat(total);
		var absoluteAmountFloat = $elm$core$Basics$abs(
			$author$project$Money$toFloat(amount));
		return (!(totalFloat + absoluteAmountFloat)) ? $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$stringDefault : function (v) {
			return v + '%';
		}(
			A2($myrho$elm_round$Round$round, 1, (absoluteAmountFloat / totalFloat) * 100));
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$lineItemToRow = F3(
	function (_v0, selectedDiscountToggleOptions, itemPair) {
		var expectedTotalAmount = _v0.a;
		var invoicedTotalAmount = _v0.b;
		var viewAmount = F2(
			function (total, amount) {
				var _v2 = itemPair.metadata.itemType;
				if (_v2.$ === 'LtlItemTypeDiscount') {
					var _v3 = A2($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$getDiscountToggleOption, itemPair, selectedDiscountToggleOptions);
					if (_v3.$ === 'Amount') {
						return $author$project$Money$toString(amount);
					} else {
						return A2($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$viewDiscountPercentage, total, amount);
					}
				} else {
					return $author$project$Money$toString(amount);
				}
			});
		var invoicedAmount = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.total;
			},
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair));
		var expectedAmount = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.total;
			},
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair));
		var lineItemExpected = A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_Nil,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$stringDefault,
				viewAmount(expectedTotalAmount),
				expectedAmount));
		var difference = $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$displayDifference(
			{expectedAmount: expectedAmount, invoicedAmount: invoicedAmount});
		var descriptionText = A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, itemPair.metadata.description);
		var description = function () {
			var _v1 = itemPair.metadata.itemType;
			if (_v1.$ === 'LtlItemTypeDiscount') {
				return A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$crossAxisCenter,
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2($author$project$Ui$V3$Stack$fit, descriptionText),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$discountPercentAmountToggle, selectedDiscountToggleOptions, itemPair))
						]));
			} else {
				return descriptionText;
			}
		}();
		var carrierInvoiceExpected = A2(
			$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$wrapValue,
			itemPair.metadata.amountMismatch,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$stringDefault,
				viewAmount(invoicedTotalAmount),
				invoicedAmount));
		return {carrierInvoiceExpected: carrierInvoiceExpected, description: description, difference: difference, lineItemExpected: lineItemExpected, rowType: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$LineItem};
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$toSortedLineItemRows = F3(
	function (expectedInvoicedTotalAmounts, selectedDiscountToggleOptions, itemPairs) {
		return A2(
			$elm$core$List$map,
			A2($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$lineItemToRow, expectedInvoicedTotalAmounts, selectedDiscountToggleOptions),
			A2($elm$core$List$sortWith, $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$itemPairOrder, itemPairs));
	});
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$totalForPairs = F4(
	function (pairGetter, itemGetter, maybeTotalGetter, data) {
		return $author$project$Money$sum(
			A2(
				$elm$core$List$filterMap,
				A2(
					$elm$core$Basics$composeR,
					itemGetter,
					$elm$core$Maybe$andThen(maybeTotalGetter)),
				pairGetter(data)));
	});
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$carrierTotal = function (data) {
	return A2(
		$author$project$Money$sum2,
		A4(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$totalForPairs,
			function ($) {
				return $.lineItemPairs;
			},
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.total;
				},
				$elm$core$Maybe$Just),
			data),
		A4(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$totalForPairs,
			function ($) {
				return $.shippedItemPairs;
			},
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem,
			function ($) {
				return $.maybeTotal;
			},
			data));
};
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$loadTotal = function (data) {
	return A2(
		$author$project$Money$sum2,
		A4(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$totalForPairs,
			function ($) {
				return $.lineItemPairs;
			},
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.total;
				},
				$elm$core$Maybe$Just),
			data),
		A4(
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$totalForPairs,
			function ($) {
				return $.shippedItemPairs;
			},
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem,
			function ($) {
				return $.maybeTotal;
			},
			data));
};
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$totalRowView = F4(
	function (title, rowType, lineItemPairs, shippedItemPairs) {
		var loadItemExpected = $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$loadTotal(
			{lineItemPairs: lineItemPairs, shippedItemPairs: shippedItemPairs});
		var carrierItemExpected = $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$carrierTotal(
			{lineItemPairs: lineItemPairs, shippedItemPairs: shippedItemPairs});
		return {
			carrierInvoiceExpected: A2(
				$author$project$Ui$V3$Typography$smallBodySemiBold,
				_List_Nil,
				$author$project$Money$toString(carrierItemExpected)),
			description: A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, title),
			difference: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$displayDifference(
				{
					expectedAmount: $elm$core$Maybe$Just(loadItemExpected),
					invoicedAmount: $elm$core$Maybe$Just(carrierItemExpected)
				}),
			lineItemExpected: A2(
				$author$project$Ui$V3$Typography$smallBodySemiBold,
				_List_Nil,
				$author$project$Money$toString(loadItemExpected)),
			rowType: rowType
		};
	});
var $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$view = F2(
	function (_v0, ltlPayablesCarrierAndLoadItemEqualityData) {
		var selectedDiscountToggleOptions = _v0.selectedDiscountToggleOptions;
		var totalRow = A4($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$totalRowView, 'Total', $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Total, ltlPayablesCarrierAndLoadItemEqualityData.lineItemPairs, ltlPayablesCarrierAndLoadItemEqualityData.shippedItemPairs);
		var lineItemLineHaulsDiscountsAndMinimums = A2(
			$elm$core$List$filter,
			function (pair) {
				return _Utils_eq(pair.metadata.itemType, $author$project$AuditPb$LtlItemTypeLineHaul) || (_Utils_eq(pair.metadata.itemType, $author$project$AuditPb$LtlItemTypeDiscount) || _Utils_eq(pair.metadata.itemType, $author$project$AuditPb$LtlItemTypeMinimum));
			},
			ltlPayablesCarrierAndLoadItemEqualityData.lineItemPairs);
		var subTotalRow = A4($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$totalRowView, 'Subtotal', $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$Subtotal, lineItemLineHaulsDiscountsAndMinimums, ltlPayablesCarrierAndLoadItemEqualityData.shippedItemPairs);
		var lineHaulItems = A2(
			$elm$core$List$map,
			$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$shippedItemToRow,
			A2($elm$core$List$sortWith, $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$itemPairOrder, ltlPayablesCarrierAndLoadItemEqualityData.shippedItemPairs));
		var expectedInvoicedTotalAmounts = $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$lineHaulTotals(ltlPayablesCarrierAndLoadItemEqualityData);
		var fuelSurcharges = A3(
			$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$toSortedLineItemRows,
			expectedInvoicedTotalAmounts,
			selectedDiscountToggleOptions,
			A2(
				$elm$core$List$filter,
				function (pair) {
					return _Utils_eq(pair.metadata.itemType, $author$project$AuditPb$LtlItemTypeFuelSurcharge);
				},
				ltlPayablesCarrierAndLoadItemEqualityData.lineItemPairs));
		var subtotaledLineItems = A3($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$toSortedLineItemRows, expectedInvoicedTotalAmounts, selectedDiscountToggleOptions, lineItemLineHaulsDiscountsAndMinimums);
		var freightHeader = ($elm$core$List$length(
			_Utils_ap(
				lineHaulItems,
				_Utils_ap(subtotaledLineItems, fuelSurcharges))) > 0) ? _List_fromArray(
			[
				$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$headerRow('Freight charges')
			]) : _List_Nil;
		var accessorialItems = A3(
			$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$toSortedLineItemRows,
			expectedInvoicedTotalAmounts,
			selectedDiscountToggleOptions,
			A2(
				$elm$core$List$filter,
				function (pair) {
					return _Utils_eq(pair.metadata.itemType, $author$project$AuditPb$LtlItemTypeAdditionalAccessorial);
				},
				ltlPayablesCarrierAndLoadItemEqualityData.lineItemPairs));
		var accessorialHeader = ($elm$core$List$length(accessorialItems) > 0) ? _List_fromArray(
			[
				$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$headerRow('Accessorials')
			]) : _List_Nil;
		return A4(
			$author$project$Ui$V3$Table$view,
			{columns: $author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$columns},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$rowAttributes($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$rowAttributes),
					$author$project$Ui$V3$Table$headCellAttrs(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding', '16px'),
							A2($elm$html$Html$Attributes$style, 'box-shadow', 'none'),
							A2(
							$elm$html$Html$Attributes$style,
							'border-bottom-color',
							$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray200)),
							A2($elm$html$Html$Attributes$style, 'border-bottom-style', 'solid'),
							A2($elm$html$Html$Attributes$style, 'border-bottom-width', '1px')
						]))
				]),
			_List_Nil,
			_Utils_ap(
				freightHeader,
				_Utils_ap(
					lineHaulItems,
					_Utils_ap(
						subtotaledLineItems,
						_Utils_ap(
							_List_fromArray(
								[subTotalRow]),
							_Utils_ap(
								fuelSurcharges,
								_Utils_ap(
									accessorialHeader,
									_Utils_ap(
										accessorialItems,
										_List_fromArray(
											[totalRow])))))))));
	});
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$CarrierItem = {$: 'CarrierItem'};
var $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$LoadItem = {$: 'LoadItem'};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$ApplyInvoicedValuesLineItem = F2(
	function (a, b) {
		return {$: 'ApplyInvoicedValuesLineItem', a: a, b: b};
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$isRerateEnabled = function (ltlData) {
	return (!_Utils_eq(ltlData.reRatingStatus, $author$project$AuditPb$CarrierInvoiceReRatingStatusInProgress)) && ltlData.customerRerateEnabled;
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$AcceptAccessorial = {$: 'AcceptAccessorial'};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$AcceptDisputeAccessorial = F2(
	function (a, b) {
		return {$: 'AcceptDisputeAccessorial', a: a, b: b};
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$DisputeAccessorial = {$: 'DisputeAccessorial'};
var $author$project$Ui$V3$Radio$LayoutDirectionHorizontal = {$: 'LayoutDirectionHorizontal'};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$isUpdatingAccessorial = function (accessorialUpdate) {
	if (accessorialUpdate.$ === 'UpdatingAccessorial') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$NoOp = {$: 'NoOp'};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$SetTmsUpdateValueLineItem = F2(
	function (a, b) {
		return {$: 'SetTmsUpdateValueLineItem', a: a, b: b};
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$getAccessorialUpdateAmount = function (accessorialUpdate) {
	if (accessorialUpdate.$ === 'UpdatingAccessorial') {
		var amount = accessorialUpdate.a.amount;
		return $elm$core$Maybe$Just(amount);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$result_extra$Result$Extra$isErr = function (x) {
	if (x.$ === 'Ok') {
		return false;
	} else {
		return true;
	}
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewInputAccessorial = F3(
	function (_v0, itemPair, tmsUpdateValues) {
		var ltlData = _v0.ltlData;
		var shouldShowIcon = function () {
			var _v1 = itemPair.state;
			switch (_v1.$) {
				case 'LoadItemAndCarrierItem':
					return true;
				case 'LoadItemOnly':
					return false;
				default:
					return true;
			}
		}();
		var expectedValue = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyMoneyAsString,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.total;
				},
				$author$project$Money$toString),
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair));
		var defaultValue = A2(
			$elm$core$Maybe$withDefault,
			expectedValue,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$LtlReconcileInvoicePage$MismatchTable$getAccessorialUpdateAmount,
				A2($turboMaCk$any_dict$Dict$Any$get, itemPair, tmsUpdateValues)));
		var inputAttrsBase = _List_fromArray(
			[
				$author$project$Ui$V3$Input$error(
				$elm_community$result_extra$Result$Extra$isErr(
					$author$project$Money$fromString(defaultValue))),
				$author$project$Ui$V3$Input$disabled(
				!$author$project$Components$LtlReconcileInvoicePage$MismatchTable$isRerateEnabled(ltlData))
			]);
		var carrierVal = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Components$LtlReconcileInvoicePage$MismatchTable$emptyMoneyAsString,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.total;
				},
				$author$project$Money$toString),
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair));
		var icon = _Utils_eq(defaultValue, carrierVal) ? $author$project$Ui$V3$Icon$success16 : $author$project$Ui$V3$Icon$alertTriangle16;
		var inputAttrs = shouldShowIcon ? A2(
			$elm$core$List$cons,
			A4(
				$author$project$Ui$V3$Input$trailingIconButtonCustom,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'cursor', 'text')
					]),
				_List_Nil,
				icon,
				$author$project$Components$LtlReconcileInvoicePage$MismatchTable$NoOp),
			inputAttrsBase) : inputAttrsBase;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, 'Amount')
					])),
				A4(
				$author$project$Ui$V3$Input$view,
				{
					onInput: $author$project$Components$LtlReconcileInvoicePage$MismatchTable$SetTmsUpdateValueLineItem(itemPair)
				},
				inputAttrs,
				_List_Nil,
				defaultValue)
			]);
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewCarrierItemOnlyItemPairActions = F3(
	function (carrierInvoice, itemPair, tmsUpdateValues) {
		var radioView = A2(
			$author$project$Ui$V3$Radio$view,
			{
				label: function (option) {
					if (option.$ === 'AcceptAccessorial') {
						return 'Accept';
					} else {
						return 'Dispute';
					}
				},
				name: 'accept-dispute',
				onSelect: $author$project$Components$LtlReconcileInvoicePage$MismatchTable$AcceptDisputeAccessorial(itemPair),
				options: _List_fromArray(
					[$author$project$Components$LtlReconcileInvoicePage$MismatchTable$AcceptAccessorial, $author$project$Components$LtlReconcileInvoicePage$MismatchTable$DisputeAccessorial]),
				selected: A2(
					$elm_community$maybe_extra$Maybe$Extra$orElse,
					$elm$core$Maybe$Just($author$project$Components$LtlReconcileInvoicePage$MismatchTable$DisputeAccessorial),
					A2(
						$elm$core$Maybe$map,
						function (updateValue) {
							if (updateValue.$ === 'UpdatingAccessorial') {
								return $author$project$Components$LtlReconcileInvoicePage$MismatchTable$AcceptAccessorial;
							} else {
								return $author$project$Components$LtlReconcileInvoicePage$MismatchTable$DisputeAccessorial;
							}
						},
						A2($turboMaCk$any_dict$Dict$Any$get, itemPair, tmsUpdateValues)))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionHorizontal)
				]));
		var isUpdating = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			false,
			$author$project$Components$LtlReconcileInvoicePage$MismatchTable$isUpdatingAccessorial,
			A2($turboMaCk$any_dict$Dict$Any$get, itemPair, tmsUpdateValues));
		var inputView = A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewInputAccessorial, carrierInvoice, itemPair, tmsUpdateValues);
		return isUpdating ? _Utils_ap(
			inputView,
			_List_fromArray(
				[radioView])) : _List_fromArray(
			[radioView]);
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewAccessorialItemPairActions = F3(
	function (tmsUpdateValuesAccessorial, carrierInvoice, itemPair) {
		var _v0 = itemPair.state;
		switch (_v0.$) {
			case 'LoadItemAndCarrierItem':
				return A2(
					$author$project$Ui$V3$Stack$viewVertWithHeights,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
										$author$project$Ui$V3$Stack$noWrap
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										A2(
											$author$project$Ui$V3$Stack$viewVert,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
												]),
											_Utils_ap(
												A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewInputAccessorial, carrierInvoice, itemPair, tmsUpdateValuesAccessorial),
												_List_fromArray(
													[
														function () {
														var _v1 = _Utils_Tuple2(
															$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair),
															$author$project$Components$LtlReconcileInvoicePage$MismatchTable$isRerateEnabled(carrierInvoice.ltlData));
														if ((_v1.a.$ === 'Just') && _v1.b) {
															var carrierItem = _v1.a.a;
															return A3(
																$author$project$Ui$V3$Button$view,
																{
																	action: $author$project$Ui$V3$Button$onClick(
																		A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$ApplyInvoicedValuesLineItem, itemPair, carrierItem))
																},
																_List_fromArray(
																	[
																		$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
																		$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
																		A2($author$project$Ui$V3$Button$cssStyle, 'border-radius', '0')
																	]),
																'Apply invoiced amount');
														} else {
															return $author$project$Helpers$Html$empty;
														}
													}()
													]))))
									])))
						]));
			case 'LoadItemOnly':
				return A2(
					$author$project$Ui$V3$Stack$viewVertWithHeights,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
										$author$project$Ui$V3$Stack$noWrap
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										A2(
											$author$project$Ui$V3$Stack$viewVert,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
												]),
											A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewInputAccessorial, carrierInvoice, itemPair, tmsUpdateValuesAccessorial)))
									])))
						]));
			default:
				return A2(
					$author$project$Ui$V3$Stack$viewVertWithHeights,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
										$author$project$Ui$V3$Stack$noWrap
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										A2(
											$author$project$Ui$V3$Stack$viewVert,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
												]),
											A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewCarrierItemOnlyItemPairActions, carrierInvoice, itemPair, tmsUpdateValuesAccessorial)))
									])))
						]));
		}
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$ApplyInvoicedValuesShippedItem = F2(
	function (a, b) {
		return {$: 'ApplyInvoicedValuesShippedItem', a: a, b: b};
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$SetTmsUpdateValueShippedItem = F3(
	function (a, b, c) {
		return {$: 'SetTmsUpdateValueShippedItem', a: a, b: b, c: c};
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$isInputMatch = F2(
	function (inputVal, carrierVal) {
		var _v0 = _Utils_Tuple2(
			$elm$core$String$toFloat(inputVal),
			$elm$core$String$toFloat(carrierVal));
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var inputValFloat = _v0.a.a;
			var carrierValFloat = _v0.b.a;
			return _Utils_eq(inputValFloat, carrierValFloat);
		} else {
			return _Utils_eq(inputVal, carrierVal);
		}
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewShippedItemInput = F5(
	function (reconcileType, _v0, itemPair, tmsUpdateValues, carrierValGetter) {
		var ltlData = _v0.ltlData;
		var maybeCurrentValue = A2($turboMaCk$any_dict$Dict$Any$get, itemPair, tmsUpdateValues);
		var defaultValue = function () {
			switch (reconcileType.$) {
				case 'LtlCarrierInvoiceReconcileTypeWeight':
					return A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$weightDefault, maybeCurrentValue, ltlData.ltlShippedItemReconcileItems, itemPair);
				case 'LtlCarrierInvoiceReconcileTypeClass':
					return A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$classDefault, maybeCurrentValue, ltlData.ltlShippedItemReconcileItems, itemPair);
				default:
					return '';
			}
		}();
		var icon = function (carrierVal) {
			return A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$isInputMatch, defaultValue, carrierVal) ? $author$project$Ui$V3$Icon$success16 : $author$project$Ui$V3$Icon$alertTriangle16;
		};
		var inputAttrsBase = _List_fromArray(
			[
				$author$project$Ui$V3$Input$error(
				$elm_community$maybe_extra$Maybe$Extra$isNothing(
					$elm$core$String$toFloat(defaultValue))),
				$author$project$Ui$V3$Input$disabled(
				!$author$project$Components$LtlReconcileInvoicePage$MismatchTable$isRerateEnabled(ltlData))
			]);
		var inputAttrs = function () {
			var _v1 = A2(
				$elm$core$Maybe$andThen,
				carrierValGetter,
				$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair));
			if (_v1.$ === 'Just') {
				var val = _v1.a;
				return A2(
					$elm$core$List$cons,
					A4(
						$author$project$Ui$V3$Input$trailingIconButtonCustom,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'cursor', 'text')
							]),
						_List_Nil,
						icon(val),
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$NoOp),
					inputAttrsBase);
			} else {
				return inputAttrsBase;
			}
		}();
		return A4(
			$author$project$Ui$V3$Input$view,
			{
				onInput: A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$SetTmsUpdateValueShippedItem, itemPair, reconcileType)
			},
			inputAttrs,
			_List_Nil,
			defaultValue);
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewShippedItemPairActions = F3(
	function (tmsUpdateValues, carrierInvoice, itemPair) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertWithHeights,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
								$author$project$Ui$V3$Stack$noWrap
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, 'Class')
												])),
											A5(
											$author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewShippedItemInput,
											$author$project$AuditPb$LtlCarrierInvoiceReconcileTypeClass,
											carrierInvoice,
											itemPair,
											tmsUpdateValues,
											function ($) {
												return $.className;
											})
										]))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, 'Weight')
												])),
											A5(
											$author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewShippedItemInput,
											$author$project$AuditPb$LtlCarrierInvoiceReconcileTypeWeight,
											carrierInvoice,
											itemPair,
											tmsUpdateValues,
											function ($) {
												return $.weight;
											})
										])))
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					function () {
						var _v0 = _Utils_Tuple2(
							$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem(itemPair),
							$author$project$Components$LtlReconcileInvoicePage$MismatchTable$isRerateEnabled(carrierInvoice.ltlData));
						if ((_v0.a.$ === 'Just') && _v0.b) {
							var carrierItem = _v0.a.a;
							return A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick(
										A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$ApplyInvoicedValuesShippedItem, itemPair, carrierItem))
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
										$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
										A2($author$project$Ui$V3$Button$cssStyle, 'border-radius', '0')
									]),
								'Apply invoiced values');
						} else {
							return $author$project$Helpers$Html$empty;
						}
					}())
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewMatchTableItemActions = F5(
	function (accountSettings, tmsUpdateValuesShippedItem, tmsUpdateValuesAccessorial, carrierInvoice, matchTableItem) {
		if (matchTableItem.$ === 'ShippedItem') {
			var itemPair = matchTableItem.a;
			return (!_Utils_eq(
				$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair),
				$elm$core$Maybe$Nothing)) ? A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewShippedItemPairActions, tmsUpdateValuesShippedItem, carrierInvoice, itemPair) : A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '-');
		} else {
			var itemPair = matchTableItem.a;
			return accountSettings.ltlAccessorialUpdateEnabled ? A3($author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewAccessorialItemPairActions, tmsUpdateValuesAccessorial, carrierInvoice, itemPair) : $author$project$Helpers$Html$empty;
		}
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewAccessorialItemDetails = function (accessorialItem) {
	return _List_fromArray(
		[
			A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, accessorialItem.description),
			A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_Nil,
			'Cost ' + $author$project$Money$toString(accessorialItem.total))
		]);
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewNoComparableAccessorial = _List_fromArray(
	[
		A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'No comparable item'),
		A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '-')
	]);
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewNoComparableShippedItem = _List_fromArray(
	[
		A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'No comparable item'),
		A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '-'),
		A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '-')
	]);
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewShippedItemDetails = function (shippedItem) {
	return _List_fromArray(
		[
			A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, shippedItem.description),
			A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_Nil,
			'Class ' + A2($elm$core$Maybe$withDefault, '-', shippedItem.className)),
			A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_Nil,
			'Weight ' + A2($elm$core$Maybe$withDefault, '-', shippedItem.weight))
		]);
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewMatchTableItemDetails = F2(
	function (itemPairPartToShow, matchItem) {
		var itemPairPartGetter = function () {
			if (itemPairPartToShow.$ === 'LoadItem') {
				return $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem;
			} else {
				return $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeCarrierItem;
			}
		}();
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			function () {
				if (matchItem.$ === 'ShippedItem') {
					var itemPair = matchItem.a;
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewNoComparableShippedItem,
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewShippedItemDetails,
						itemPairPartGetter(itemPair));
				} else {
					var itemPair = matchItem.a;
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewNoComparableAccessorial,
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewAccessorialItemDetails,
						itemPairPartGetter(itemPair));
				}
			}());
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$columns = F4(
	function (accountSettings, tmsUpdateValuesShippedItem, tmsUpdateValuesAccessorial, carrierInvoice) {
		return _List_fromArray(
			[
				{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$Table$topAligned,
						$author$project$Ui$V3$Table$cellAttributes(
						function (_v0) {
							return _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding-left', '24px')
								]);
						})
					]),
				content: $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewMatchTableItemDetails($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$LoadItem),
				heading: A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Expected')
			},
				{
				attrs: _List_fromArray(
					[$author$project$Ui$V3$Table$topAligned]),
				content: $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewMatchTableItemDetails($author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$CarrierItem),
				heading: A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Invoiced')
			},
				{
				attrs: _List_fromArray(
					[
						$author$project$Ui$V3$Table$topAligned,
						$author$project$Ui$V3$Table$cellAttributes(
						function (_v1) {
							return _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '210px'),
									A2($elm$html$Html$Attributes$style, 'padding-right', '24px')
								]);
						})
					]),
				content: A4($author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewMatchTableItemActions, accountSettings, tmsUpdateValuesShippedItem, tmsUpdateValuesAccessorial, carrierInvoice),
				heading: A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Update TMS')
			}
			]);
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$Accessorial = function (a) {
	return {$: 'Accessorial', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$ShippedItem = function (a) {
	return {$: 'ShippedItem', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$shouldShowLineItemType = function (itemType) {
	return A2(
		$elm$core$List$member,
		itemType,
		_List_fromArray(
			[$author$project$AuditPb$LtlItemTypeAdditionalAccessorial, $author$project$AuditPb$LtlItemTypeFuelSurcharge]));
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$itemPairsToShow = function (_v0) {
	var lineItemPairs = _v0.lineItemPairs;
	var shippedItemPairs = _v0.shippedItemPairs;
	var shippedItems = A2(
		$elm$core$List$map,
		$author$project$Components$LtlReconcileInvoicePage$MismatchTable$ShippedItem,
		A2($elm$core$List$sortWith, $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$itemPairOrder, shippedItemPairs));
	var accessorials = A2(
		$elm$core$List$map,
		$author$project$Components$LtlReconcileInvoicePage$MismatchTable$Accessorial,
		A2(
			$elm$core$List$sortWith,
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$itemPairOrder,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.metadata;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.itemType;
						},
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$shouldShowLineItemType)),
				lineItemPairs)));
	return _Utils_ap(shippedItems, accessorials);
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewTable = F2(
	function (_v0, _v1) {
		var carrierInvoice = _v0.carrierInvoice;
		var equalityData = _v0.equalityData;
		var accountSettings = _v0.accountSettings;
		var tmsUpdateValuesAccessorial = _v1.tmsUpdateValuesAccessorial;
		var tmsUpdateValuesShippedItem = _v1.tmsUpdateValuesShippedItem;
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: A4($author$project$Components$LtlReconcileInvoicePage$MismatchTable$columns, accountSettings, tmsUpdateValuesShippedItem, tmsUpdateValuesAccessorial, carrierInvoice)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$rowAttributes(
					function (_v2) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$style,
								'border-top-color',
								$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray200)),
								A2($elm$html$Html$Attributes$style, 'border-top-style', 'solid'),
								A2($elm$html$Html$Attributes$style, 'border-top-width', '1px'),
								$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Gray0)
							]);
					})
				]),
			_List_Nil,
			$author$project$Components$LtlReconcileInvoicePage$MismatchTable$itemPairsToShow(equalityData));
	});
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$view = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-test-id', 'mismatch-table')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$viewTable, data, model)
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$None = {$: 'None'};
var $author$project$Components$LtlReconcileInvoicePage$SkipReconcileInvoice = {$: 'SkipReconcileInvoice'};
var $author$project$Components$LtlReconcileInvoicePage$StartReconcileAllForInvoice = {$: 'StartReconcileAllForInvoice'};
var $author$project$Components$LtlReconcileInvoicePage$CustomerSettings = {$: 'CustomerSettings'};
var $author$project$Components$LtlReconcileInvoicePage$HazardousMaterial = {$: 'HazardousMaterial'};
var $author$project$Components$LtlReconcileInvoicePage$LoadStatus = {$: 'LoadStatus'};
var $author$project$Components$LtlReconcileInvoicePage$blockRerateDueToCustomerSettings = function (data) {
	return data.accountSettings.ltlRerateEnabled && (!data.carrierInvoice.ltlData.customerRerateEnabled);
};
var $author$project$Components$LtlReconcileInvoicePage$blockRerateDueToHazardousMaterial = function (data) {
	return data.accountSettings.ltlRerateEnabled && (data.accountSettings.ltlRerateBlockedForHazardousMaterial && ((!data.accountSettings.ltlReconcilePageMismatchTableEnabled) && A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				false,
				function ($) {
					return $.isHazardousMaterial;
				})),
		data.equalityData.shippedItemPairs)));
};
var $author$project$Components$LtlReconcileInvoicePage$blockRerateDueToLoadStatus = function (data) {
	return data.accountSettings.ltlRerateEnabled && (!(data.accountSettings.ltlReconcilePageMismatchTableEnabled || ($elm$core$List$isEmpty(data.accountSettings.requireLoadStatus) || A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$Just,
			$elm$core$Basics$eq(data.tmsLoadDetailsData.tmsLoadDetails.load.status)),
		data.accountSettings.requireLoadStatus))));
};
var $author$project$Components$LtlReconcileInvoicePage$blockRerateReason = function (data) {
	return $author$project$Components$LtlReconcileInvoicePage$blockRerateDueToCustomerSettings(data) ? $author$project$Components$LtlReconcileInvoicePage$CustomerSettings : ($author$project$Components$LtlReconcileInvoicePage$blockRerateDueToLoadStatus(data) ? $author$project$Components$LtlReconcileInvoicePage$LoadStatus : ($author$project$Components$LtlReconcileInvoicePage$blockRerateDueToHazardousMaterial(data) ? $author$project$Components$LtlReconcileInvoicePage$HazardousMaterial : $author$project$Components$LtlReconcileInvoicePage$None));
};
var $author$project$Components$LtlReconcileInvoicePage$StartResolveLater = {$: 'StartResolveLater'};
var $author$project$Components$LtlReconcileInvoicePage$viewResolveLaterButton = F2(
	function (model, isActionButtonsEnabled) {
		return A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$LtlReconcileInvoicePage$StartResolveLater)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
					$author$project$Ui$V3$Button$disabled(model.isFinishing || (model.isFinished || (!isActionButtonsEnabled))),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
				]),
			'Resolve later');
	});
var $author$project$Components$LtlReconcileInvoicePage$viewDefaultActionButtons = F3(
	function (model, data, isActionButtonsEnabled) {
		var rerateEnabled = data.accountSettings.ltlRerateEnabled && _Utils_eq(
			$author$project$Components$LtlReconcileInvoicePage$blockRerateReason(data),
			$author$project$Components$LtlReconcileInvoicePage$None);
		var isActionInProgress = model.isFinishing || model.isFinished;
		var rerateAndContinueButton = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$LtlReconcileInvoicePage$StartReconcileAllForInvoice)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
					$author$project$Ui$V3$Button$disabled(
					isActionInProgress || ((!isActionButtonsEnabled) || _Utils_eq(data.carrierInvoice.ltlData.reRatingStatus, $author$project$AuditPb$CarrierInvoiceReRatingStatusInProgress))),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
				]),
			'Re-rate and continue');
		var continueButton = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$LtlReconcileInvoicePage$SkipReconcileInvoice)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
					$author$project$Ui$V3$Button$disabled(isActionInProgress)
				]),
			'Continue');
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($author$project$Components$LtlReconcileInvoicePage$viewResolveLaterButton, model, isActionButtonsEnabled)),
					rerateEnabled ? $elm$core$Maybe$Just(rerateAndContinueButton) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(continueButton)
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$viewLoadDetails = F2(
	function (tz, tmsLoadDetailsData) {
		var viewKeyValuePair = F2(
			function (key, value) {
				return A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fitPx(150),
							A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, key)),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fitPx(200),
							A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, value))
						]));
			});
		var shipDate = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			$author$project$Helpers$Date$dateStringFormat2(tz),
			tmsLoadDetailsData.tmsLoadDetails.load.actualShippedAt);
		var proNumber = A2($elm$core$Maybe$withDefault, '', tmsLoadDetailsData.tmsLoadDetails.load.proNumber);
		var loadId = tmsLoadDetailsData.tmsLoadDetails.load.loadId;
		var formatAddress = function (address) {
			return A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							address.addressLine1,
							address.addressLine2,
							$author$project$Domain$Address$lastLine(address)
						])));
		};
		var origin = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', formatAddress, tmsLoadDetailsData.tmsLoadDetails.load.origin);
		var distance = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (dist) {
				return dist + ' miles';
			},
			tmsLoadDetailsData.tmsLoadDetails.load.distance);
		var destination = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', formatAddress, tmsLoadDetailsData.tmsLoadDetails.load.destination);
		var deliveryDate = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			$author$project$Helpers$Date$dateStringFormat2(tz),
			tmsLoadDetailsData.tmsLoadDetails.load.actualDeliveredAt);
		var carrier = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function ($) {
				return $.name;
			},
			tmsLoadDetailsData.carrier);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Components$LtlReconcileInvoicePage$sectionTopPadding]),
			_List_fromArray(
				[
					$author$project$Components$LtlReconcileInvoicePage$sectionTitle('Load details'),
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_Nil,
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(viewKeyValuePair, 'Load ID', loadId)),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(viewKeyValuePair, 'Pro Number', proNumber))
								])),
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_Nil,
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(viewKeyValuePair, 'Carrier', carrier)),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(viewKeyValuePair, 'Distance', distance))
								])),
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_Nil,
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(viewKeyValuePair, 'Ship Date', shipDate)),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(viewKeyValuePair, 'Delivery Date', deliveryDate))
								])),
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_Nil,
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(viewKeyValuePair, 'Origin', origin)),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(viewKeyValuePair, 'Destination', destination))
								]))
						]))
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$StartReconcileMismatchTableSelectionsForInvoice = {$: 'StartReconcileMismatchTableSelectionsForInvoice'};
var $turboMaCk$any_dict$Dict$Any$toList = function (_v0) {
	var dict = _v0.a.dict;
	return $elm$core$Dict$values(dict);
};
var $turboMaCk$any_dict$Dict$Any$values = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$map($elm$core$Tuple$second),
	$turboMaCk$any_dict$Dict$Any$toList);
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$isInputValid = function (_v0) {
	var tmsUpdateValuesShippedItem = _v0.tmsUpdateValuesShippedItem;
	return A2(
		$elm$core$List$all,
		function (shippedItemUpdate) {
			return $elm_community$maybe_extra$Maybe$Extra$isJust(
				$elm$core$String$toFloat(shippedItemUpdate.weight)) && $elm_community$maybe_extra$Maybe$Extra$isJust(
				$elm$core$String$toFloat(shippedItemUpdate._class));
		},
		$turboMaCk$any_dict$Dict$Any$values(tmsUpdateValuesShippedItem));
};
var $author$project$Components$LtlReconcileInvoicePage$MismatchTable$willTriggerRerate = F2(
	function (_v0, _v1) {
		var equalityData = _v0.equalityData;
		var tmsUpdateValuesAccessorial = _v1.tmsUpdateValuesAccessorial;
		var tmsUpdateValuesShippedItem = _v1.tmsUpdateValuesShippedItem;
		var isUpdatedShippedItem = function (itemPair) {
			var _v4 = _Utils_Tuple2(
				A2($turboMaCk$any_dict$Dict$Any$get, itemPair, tmsUpdateValuesShippedItem),
				$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair));
			if ((_v4.a.$ === 'Just') && (_v4.b.$ === 'Just')) {
				var currentValue = _v4.a.a;
				var loadItem = _v4.b.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$isInputMatch(currentValue.weight),
						$elm$core$Basics$not),
					loadItem.weight) || A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$LtlReconcileInvoicePage$MismatchTable$isInputMatch(currentValue._class),
						$elm$core$Basics$not),
					loadItem.className);
			} else {
				return false;
			}
		};
		var isUpdatedLineItem = function (itemPair) {
			var _v2 = _Utils_Tuple2(
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$LtlReconcileInvoicePage$MismatchTable$getAccessorialUpdateAmount,
					A2($turboMaCk$any_dict$Dict$Any$get, itemPair, tmsUpdateValuesAccessorial)),
				$author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$maybeLoadItem(itemPair));
			if (_v2.a.$ === 'Just') {
				if (_v2.b.$ === 'Just') {
					var currentAmount = _v2.a.a;
					var loadItem = _v2.b.a;
					return !_Utils_eq(
						currentAmount,
						$author$project$Money$toString(loadItem.total));
				} else {
					var _v3 = _v2.b;
					return true;
				}
			} else {
				return false;
			}
		};
		return A2($elm$core$List$any, isUpdatedShippedItem, equalityData.shippedItemPairs) || A2($elm$core$List$any, isUpdatedLineItem, equalityData.lineItemPairs);
	});
var $author$project$Components$LtlReconcileInvoicePage$viewMismatchTableActionButtons = F3(
	function (model, data, isActionButtonsEnabled) {
		var rerateBlockedReason = $author$project$Components$LtlReconcileInvoicePage$blockRerateReason(data);
		var willTriggerRerate = (!_Utils_eq(data.carrierInvoice.ltlData.reRatingStatus, $author$project$AuditPb$CarrierInvoiceReRatingStatusInProgress)) && (_Utils_eq(rerateBlockedReason, $author$project$Components$LtlReconcileInvoicePage$None) && A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$willTriggerRerate, data.mismatchTableData, model.mismatchTable));
		var isInputValid = $author$project$Components$LtlReconcileInvoicePage$MismatchTable$isInputValid(model.mismatchTable);
		var disabled = (!isActionButtonsEnabled) || ((!isInputValid) || (model.isFinishing || model.isFinished));
		var buttonText = willTriggerRerate ? 'Re-rate and continue' : 'Continue';
		var continueButton = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$LtlReconcileInvoicePage$StartReconcileMismatchTableSelectionsForInvoice)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
					$author$project$Ui$V3$Button$disabled(disabled)
				]),
			buttonText);
		return _List_fromArray(
			[
				A2($author$project$Components$LtlReconcileInvoicePage$viewResolveLaterButton, model, isActionButtonsEnabled),
				continueButton
			]);
	});
var $author$project$Ui$V3$Notification$Icon = F2(
	function (a, b) {
		return {$: 'Icon', a: a, b: b};
	});
var $author$project$Ui$V3$Notification$iconWithAttributes = $author$project$Ui$V3$Notification$Icon;
var $author$project$Components$LtlReconcileInvoicePage$viewReRatingStatus = function (invoice) {
	var _v0 = invoice.ltlData.reRatingStatus;
	switch (_v0.$) {
		case 'CarrierInvoiceReRatingStatusInProgress':
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Notification$viewInline,
						{
							message: $elm$html$Html$text('No changes can be made until re-rate has been completed.'),
							onClose: $elm$core$Maybe$Nothing,
							title: $elm$core$Maybe$Just('Re-rate in progress')
						},
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Notification$iconWithAttributes,
								_List_fromArray(
									[$author$project$Ui$V3$Icon$spin]),
								$author$project$Ui$V3$Icon$loader16),
								$author$project$Ui$V3$Notification$column
							])),
						$author$project$Helpers$Html$empty
					]));
		case 'CarrierInvoiceReRatingStatusFailed':
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Notification$viewInline,
						{
							message: $elm$html$Html$text('View activity panel for further details.'),
							onClose: $elm$core$Maybe$Nothing,
							title: $elm$core$Maybe$Just('Re-rate failed')
						},
						_List_fromArray(
							[$author$project$Ui$V3$Notification$error])),
						$author$project$Helpers$Html$empty
					]));
		default:
			return $author$project$Helpers$Html$empty;
	}
};
var $elm_community$string_extra$String$Extra$humanize = function (string) {
	return $elm_community$string_extra$String$Extra$toSentenceCase(
		$elm$core$String$toLower(
			$elm$core$String$trim(
				A3(
					$elm$regex$Regex$replace,
					$elm_community$string_extra$String$Extra$regexFromString('_id$|[-_\u005Cs]+'),
					$elm$core$Basics$always(' '),
					A3(
						$elm$regex$Regex$replace,
						$elm_community$string_extra$String$Extra$regexFromString('[A-Z]+'),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.match;
							},
							$elm$core$String$append('-')),
						string)))));
};
var $elm_community$string_extra$String$Extra$surround = F2(
	function (wrapper, string) {
		return _Utils_ap(
			wrapper,
			_Utils_ap(string, wrapper));
	});
var $elm_community$string_extra$String$Extra$quote = function (string) {
	return A2($elm_community$string_extra$String$Extra$surround, '\u0022', string);
};
var $author$project$Components$LtlReconcileInvoicePage$loadStatusWarningText = function (data) {
	var statuses = A3(
		$elm$core$String$replace,
		'and',
		'or',
		$elm_community$string_extra$String$Extra$toSentenceOxford(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$humanize, $elm_community$string_extra$String$Extra$quote),
				data.accountSettings.requireLoadStatus)));
	return 'Load must be in ' + (statuses + ' in order to re-rate');
};
var $author$project$Components$LtlReconcileInvoicePage$rerateDisabledWarningText = F2(
	function (reason, data) {
		switch (reason.$) {
			case 'None':
				return '';
			case 'CustomerSettings':
				return 'This load can\u0027t be re-rated because rerating is disabled for the customer';
			case 'HazardousMaterial':
				return 'This load can\u0027t be re-rated as a hazmat is present. To resolve, make updates in your TMS.';
			default:
				return $author$project$Components$LtlReconcileInvoicePage$loadStatusWarningText(data);
		}
	});
var $author$project$Components$LtlReconcileInvoicePage$viewRerateUnavailableWarning = function (data) {
	var reason = $author$project$Components$LtlReconcileInvoicePage$blockRerateReason(data);
	if (reason.$ === 'None') {
		return $author$project$Helpers$Html$empty;
	} else {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Notification$viewInline,
					{
						message: $elm$html$Html$text(
							A2($author$project$Components$LtlReconcileInvoicePage$rerateDisabledWarningText, reason, data)),
						onClose: $elm$core$Maybe$Nothing,
						title: $elm$core$Maybe$Just('Re-rate unavailable')
					},
					_List_Nil),
					$author$project$Helpers$Html$empty
				]));
	}
};
var $author$project$Components$LtlReconcileInvoicePage$Percent = {$: 'Percent'};
var $author$project$Components$LtlReconcileInvoicePage$SelectTotalsHeaderToggle = function (a) {
	return {$: 'SelectTotalsHeaderToggle', a: a};
};
var $author$project$Money$absoluteDifference = F2(
	function (_v0, _v1) {
		var cents1 = _v0.a;
		var cents2 = _v1.a;
		return $author$project$Money$fromCents(
			$elm$core$Basics$abs(cents1 - cents2));
	});
var $author$project$Ui$V3$Icon$arrow2Down16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M15.5267 6.82667C15.4342 6.74337 15.3259 6.67943 15.2083 6.63862C15.0907 6.59781 14.9661 6.58094 14.8418 6.58902C14.7176 6.59709 14.5962 6.62995 14.4848 6.68565C14.3735 6.74134 14.2744 6.81876 14.1934 6.91333L9.22675 12.5533C9.20428 12.5795 9.17426 12.598 9.14083 12.6063C9.1074 12.6147 9.0722 12.6125 9.04008 12.6C9.00952 12.5873 8.98323 12.5661 8.96433 12.5389C8.94543 12.5118 8.9347 12.4797 8.93342 12.4467V0.94C8.93342 0.690696 8.83438 0.451604 8.6581 0.27532C8.48181 0.0990354 8.24272 0 7.99342 0C7.74411 0 7.50502 0.0990354 7.32874 0.27532C7.15245 0.451604 7.05342 0.690696 7.05342 0.94V12.4467C7.05213 12.4797 7.04141 12.5118 7.0225 12.5389C7.0036 12.5661 6.97731 12.5873 6.94675 12.6C6.91463 12.6125 6.87943 12.6147 6.846 12.6063C6.81257 12.598 6.78256 12.5795 6.76008 12.5533L1.80008 6.91333C1.71866 6.82053 1.61976 6.74468 1.50903 6.6901C1.39829 6.63552 1.27789 6.60329 1.1547 6.59524C0.905901 6.57899 0.660836 6.66223 0.473417 6.82667C0.285997 6.9911 0.171575 7.22325 0.155322 7.47205C0.139068 7.72085 0.222316 7.96591 0.38675 8.15333L6.82008 15.4867C6.96773 15.6541 7.14931 15.7882 7.35275 15.88C7.5562 15.9718 7.77687 16.0193 8.00008 16.0193C8.2233 16.0193 8.44396 15.9718 8.64741 15.88C8.85086 15.7882 9.03244 15.6541 9.18008 15.4867L15.6134 8.15333C15.6948 8.06054 15.7572 7.95261 15.7969 7.83571C15.8366 7.71882 15.8529 7.59524 15.8449 7.47205C15.8368 7.34885 15.8046 7.22845 15.75 7.11771C15.6954 7.00698 15.6196 6.90808 15.5267 6.82667Z'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_Nil));
var $author$project$Ui$V3$Icon$arrow2Up16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M15.6132 7.84L9.17991 0.533333C8.86749 0.213714 8.44625 0.0233259 7.99991 0C7.55357 0.0233259 7.13233 0.213714 6.81991 0.533333L0.386576 7.86667C0.288671 7.95629 0.210857 8.06564 0.158257 8.18751C0.105657 8.30938 0.0794627 8.441 0.0813988 8.57372C0.083335 8.70644 0.113357 8.83725 0.16949 8.95753C0.225623 9.07781 0.306593 9.18484 0.407071 9.27158C0.507549 9.35831 0.625257 9.42278 0.752447 9.46074C0.879637 9.49871 1.01342 9.5093 1.14501 9.49184C1.27659 9.47437 1.40297 9.42923 1.51585 9.3594C1.62873 9.28956 1.72554 9.19661 1.79991 9.08667L6.76658 3.44667C6.78905 3.42055 6.81907 3.40203 6.85249 3.39368C6.88592 3.38532 6.92112 3.38753 6.95324 3.4C6.9843 3.41198 7.01106 3.43299 7.03007 3.46032C7.04909 3.48765 7.05948 3.52005 7.05991 3.55333V15.06C7.05991 15.1834 7.08422 15.3057 7.13146 15.4197C7.1787 15.5338 7.24794 15.6374 7.33523 15.7247C7.42252 15.812 7.52614 15.8812 7.64019 15.9284C7.75423 15.9757 7.87647 16 7.99991 16C8.12335 16 8.24559 15.9757 8.35963 15.9284C8.47368 15.8812 8.5773 15.812 8.66459 15.7247C8.75188 15.6374 8.82112 15.5338 8.86836 15.4197C8.9156 15.3057 8.93991 15.1834 8.93991 15.06V3.55333C8.94034 3.52005 8.95073 3.48765 8.96974 3.46032C8.98876 3.43299 9.01552 3.41198 9.04658 3.4C9.0787 3.38753 9.1139 3.38532 9.14732 3.39368C9.18075 3.40203 9.21077 3.42055 9.23324 3.44667L14.1999 9.08667C14.2818 9.17947 14.3811 9.25524 14.4922 9.30965C14.6034 9.36406 14.7241 9.39605 14.8477 9.40379C14.9712 9.41152 15.095 9.39486 15.212 9.35475C15.3291 9.31464 15.4371 9.25186 15.5299 9.17C15.6227 9.08814 15.6985 8.98881 15.7529 8.87767C15.8073 8.76653 15.8393 8.64576 15.847 8.52226C15.8548 8.39876 15.8381 8.27494 15.798 8.15788C15.7579 8.04082 15.6951 7.9328 15.6132 7.84Z'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_Nil));
var $author$project$Components$LtlReconcileInvoicePage$stringDefault = '-';
var $author$project$Ui$V3$Stack$StyleAsCard = {$: 'StyleAsCard'};
var $author$project$Ui$V3$Stack$styleAsCard = $author$project$Ui$V3$Stack$StyleAsAttribute($author$project$Ui$V3$Stack$StyleAsCard);
var $author$project$Components$LtlReconcileInvoicePage$viewTotalsHeader = F2(
	function (selected, equalityData) {
		var toggle = A2(
			$author$project$Ui$V3$SecondaryToggle$view,
			_List_fromArray(
				[
					$author$project$Ui$V3$SecondaryToggle$topBottomPadding('2px')
				]),
			{
				onToggle: $author$project$Components$LtlReconcileInvoicePage$SelectTotalsHeaderToggle,
				segments: _List_fromArray(
					[$author$project$Components$LtlReconcileInvoicePage$Amount, $author$project$Components$LtlReconcileInvoicePage$Percent]),
				selected: selected,
				toLabel: function (option) {
					if (option.$ === 'Amount') {
						return $elm$html$Html$text('$');
					} else {
						return $elm$html$Html$text('%');
					}
				}
			});
		var invoicedAmount = $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$carrierTotal(equalityData);
		var expectedAmount = $author$project$Domain$LtlPayablesCarrierAndLoadItemEqualityData$loadTotal(equalityData);
		var differenceText = function () {
			if (selected.$ === 'Amount') {
				return $author$project$Money$toString(
					A2($author$project$Money$absoluteDifference, invoicedAmount, expectedAmount));
			} else {
				return (!$author$project$Money$toFloat(expectedAmount)) ? $author$project$Components$LtlReconcileInvoicePage$stringDefault : function (v) {
					return v + '%';
				}(
					A2(
						$myrho$elm_round$Round$round,
						1,
						$elm$core$Basics$abs(
							100 * (($author$project$Money$toFloat(invoicedAmount) - $author$project$Money$toFloat(expectedAmount)) / $author$project$Money$toFloat(expectedAmount)))));
			}
		}();
		var dangerAttr = $author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Red700);
		var amountDifference = A2($author$project$Money$difference, invoicedAmount, expectedAmount);
		var invoicedAmountHtml = ($author$project$Money$toFloat(amountDifference) > 0) ? A2(
			$author$project$Ui$V3$Typography$smallBodySemiBold,
			_List_fromArray(
				[dangerAttr]),
			$author$project$Money$toString(invoicedAmount)) : A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_Nil,
			$author$project$Money$toString(invoicedAmount));
		var viewAmountDifference = ($author$project$Money$toFloat(amountDifference) > 0) ? A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Stack$viewHorz,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$htmlAttribute(dangerAttr)
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$arrow2Up16)
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Typography$smallBodySemiBold,
						_List_fromArray(
							[dangerAttr]),
						differenceText))
				])) : (($author$project$Money$toFloat(amountDifference) < 0) ? A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Stack$viewHorz,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$arrow2Down16)
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, differenceText))
				])) : A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$crossAxisCenter]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$html$Html$text($author$project$Components$LtlReconcileInvoicePage$stringDefault))
				])));
		return A2(
			$author$project$Ui$V3$Stack$viewHorz,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					A4($author$project$Ui$V3$Stack$paddingLeftRightTopBottom, $author$project$Ui$V3$Stack$spaceXSmall, $author$project$Ui$V3$Stack$spaceXSmall, $author$project$Ui$V3$Stack$spaceXXSmall, $author$project$Ui$V3$Stack$spaceXXSmall),
					A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Gray150),
					A2($author$project$Ui$V3$Stack$style, 'margin-bottom', '24px'),
					$author$project$Ui$V3$Stack$crossAxisCenter,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Expected')),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBody,
								_List_Nil,
								$author$project$Money$toString(expectedAmount)))
						])),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Invoiced')),
							_Utils_Tuple2($author$project$Ui$V3$Stack$fit, invoicedAmountHtml)
						])),
					A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$crossAxisCenter,
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
								]),
							_List_fromArray(
								[
									_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Helpers$Html$empty),
									_Utils_Tuple2($author$project$Ui$V3$Stack$fit, viewAmountDifference),
									_Utils_Tuple2($author$project$Ui$V3$Stack$fit, toggle)
								]))
						]))
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$viewContentLeft = F2(
	function (model, data) {
		var isActionButtonsEnabled = data.currentUser.isAdmin || data.currentUser.isAuditor;
		var invoiceDetailsTable = A2(
			$elm$html$Html$map,
			$author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTableMsg,
			A2($author$project$Components$LtlReconcileInvoicePage$InvoiceDetailsTable$view, model.invoiceDetailsTable, data.equalityData));
		var mainContent = data.accountSettings.ltlReconcilePageMismatchTableEnabled ? _List_fromArray(
			[
				$author$project$Components$LtlReconcileInvoicePage$sectionTitle('Reconcile invoice'),
				A2($author$project$Components$LtlReconcileInvoicePage$viewTotalsHeader, model.totalsHeaderSelectedToggleOption, data.equalityData),
				A2(
				$elm$html$Html$map,
				$author$project$Components$LtlReconcileInvoicePage$MismatchTableMsg,
				A2($author$project$Components$LtlReconcileInvoicePage$MismatchTable$view, data.mismatchTableData, model.mismatchTable)),
				A2($author$project$Components$LtlReconcileInvoicePage$viewLoadDetails, model.timezone, data.tmsLoadDetailsData),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Components$LtlReconcileInvoicePage$sectionTopPadding]),
				_List_fromArray(
					[
						$author$project$Components$LtlReconcileInvoicePage$sectionTitle('Invoice details'),
						invoiceDetailsTable
					]))
			]) : _List_fromArray(
			[
				$author$project$Components$LtlReconcileInvoicePage$sectionTitle('Invoice comparison'),
				A2($author$project$Components$LtlReconcileInvoicePage$viewTotalsHeader, model.totalsHeaderSelectedToggleOption, data.equalityData),
				invoiceDetailsTable,
				A2($author$project$Components$LtlReconcileInvoicePage$viewLoadDetails, model.timezone, data.tmsLoadDetailsData)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '24px')
								]),
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Components$LtlReconcileInvoicePage$viewReRatingStatus(data.carrierInvoice),
										$author$project$Components$LtlReconcileInvoicePage$viewRerateUnavailableWarning(data)
									]),
								mainContent)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '16px 24px'),
									A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
									A2($elm$html$Html$Attributes$style, 'bottom', '0'),
									A2(
									$elm$html$Html$Attributes$style,
									'border-top-color',
									$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray200)),
									A2($elm$html$Html$Attributes$style, 'border-top-style', 'solid'),
									A2($elm$html$Html$Attributes$style, 'border-top-width', '1px'),
									$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Gray0)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$V3$Stack$viewHorzWithWidths,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
													$author$project$Ui$V3$Stack$mainAxisEnd
												]),
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
												data.accountSettings.ltlReconcilePageMismatchTableEnabled ? A3($author$project$Components$LtlReconcileInvoicePage$viewMismatchTableActionButtons, model, data, isActionButtonsEnabled) : A3($author$project$Components$LtlReconcileInvoicePage$viewDefaultActionButtons, model, data, isActionButtonsEnabled)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$viewContent = F2(
	function (model, data) {
		var documentsBrowser = A3($author$project$Components$DocumentsBrowser$view, model.timezone, model.documentsBrowser, _List_Nil);
		var documentsBrowserWithLoader = data.accountSettings.auditV3ReactStyleOverrides ? A4(
			$author$project$Ui$V3$Skeleton$viewRemote,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'border-radius', '0')
				]),
			{height: $elm$core$Maybe$Nothing},
			documentsBrowser,
			data.documentsBrowserData) : A2($author$project$Forward$LoadingView$view, documentsBrowser, data.documentsBrowserData);
		var contentRight = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'flex', '1')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$map, $author$project$Components$LtlReconcileInvoicePage$DocumentsBrowserMsg, documentsBrowserWithLoader)
				]));
		var contentLeft = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'flex', '1'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'scroll')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$LtlReconcileInvoicePage$viewContentLeft, model, data)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden')
				]),
			_List_fromArray(
				[contentLeft, contentRight]));
	});
var $author$project$Ui$V3$Tooltip$BelowDirection = {$: 'BelowDirection'};
var $author$project$Components$LtlReconcileInvoicePage$ImDoneButtonClicked = {$: 'ImDoneButtonClicked'};
var $author$project$Components$LtlReconcileInvoicePage$OpenIgnoreModal = {$: 'OpenIgnoreModal'};
var $author$project$Components$LtlReconcileInvoicePage$OpenMoveToTmsModal = {$: 'OpenMoveToTmsModal'};
var $author$project$Ui$V3$Icon$box16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10.6666 5.51292C10.6974 5.49531 10.7217 5.46837 10.7361 5.436C10.7505 5.40364 10.7542 5.36753 10.7466 5.33292C10.7431 5.3082 10.7341 5.28459 10.7203 5.26382C10.7064 5.24305 10.6881 5.22565 10.6666 5.21292L4.14664 2.24625C4.10337 2.2281 4.05691 2.21875 4.00998 2.21875C3.96305 2.21875 3.91659 2.2281 3.87331 2.24625L1.33331 3.33292C1.30347 3.34772 1.27832 3.37052 1.26067 3.39877C1.24301 3.42701 1.23354 3.45961 1.23331 3.49292C1.22849 3.52709 1.23588 3.56187 1.25417 3.59113C1.27246 3.6204 1.30048 3.64228 1.33331 3.65292L8.19331 6.51292C8.23546 6.53089 8.28082 6.54015 8.32664 6.54015C8.37247 6.54015 8.41782 6.53089 8.45998 6.51292L10.6666 5.51292Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M14.7066 3.6664C14.7364 3.65339 14.7618 3.63194 14.7796 3.60469C14.7973 3.57744 14.8067 3.54559 14.8066 3.51307C14.8063 3.48148 14.7966 3.45069 14.7788 3.42459C14.761 3.39849 14.7359 3.37824 14.7066 3.3664L8.26663 0.566399C8.18252 0.52969 8.09174 0.510742 7.99997 0.510742C7.9082 0.510742 7.81741 0.52969 7.7333 0.566399L5.58663 1.49973C5.55784 1.51227 5.53318 1.5327 5.51548 1.55864C5.49779 1.58459 5.48779 1.61501 5.48663 1.6464C5.48652 1.67893 5.49593 1.71078 5.5137 1.73802C5.53147 1.76527 5.55682 1.78672 5.58663 1.79973L12.0533 4.75307C12.0962 4.77281 12.1428 4.78303 12.19 4.78303C12.2372 4.78303 12.2838 4.77281 12.3266 4.75307L14.7066 3.6664Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M0.566646 4.41967C0.541522 4.40825 0.514244 4.40234 0.486646 4.40234C0.459049 4.40234 0.431771 4.40825 0.406646 4.41967C0.384201 4.43552 0.365845 4.45649 0.353095 4.48083C0.340344 4.50517 0.333564 4.53219 0.333313 4.55967V11.9997C0.33397 12.1313 0.373572 12.2598 0.447127 12.3689C0.520683 12.4781 0.6249 12.563 0.746646 12.613L7.59998 15.4797C7.62469 15.4925 7.65213 15.4992 7.67998 15.4992C7.70783 15.4992 7.73527 15.4925 7.75998 15.4797C7.78275 15.4658 7.80149 15.4461 7.81435 15.4227C7.82722 15.3994 7.83375 15.373 7.83331 15.3463V7.55967C7.83343 7.52714 7.82402 7.49529 7.80625 7.46805C7.78848 7.4408 7.76313 7.41935 7.73331 7.40634L0.566646 4.41967Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.83331 15.293C8.83322 15.3208 8.84004 15.3481 8.85316 15.3725C8.86628 15.3969 8.88528 15.4177 8.90845 15.4329C8.93162 15.4481 8.95822 15.4573 8.98584 15.4597C9.01347 15.462 9.04124 15.4575 9.06665 15.4464L15.2733 12.6264C15.3934 12.5724 15.4949 12.4841 15.5649 12.3726C15.6349 12.2611 15.6703 12.1313 15.6666 11.9997V4.59303C15.6667 4.56531 15.6599 4.538 15.6468 4.51357C15.6337 4.48915 15.6147 4.46839 15.5915 4.45316C15.5683 4.43794 15.5417 4.42873 15.5141 4.42638C15.4865 4.42403 15.4587 4.42861 15.4333 4.4397L8.93331 7.39303C8.9035 7.40604 8.87815 7.42749 8.86038 7.45474C8.84261 7.48198 8.8332 7.51383 8.83331 7.54636V15.293Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Stack$CrossAxisBaseline = {$: 'CrossAxisBaseline'};
var $author$project$Ui$V3$Stack$crossAxisBaseline = $author$project$Ui$V3$Stack$CrossAxisAttribute($author$project$Ui$V3$Stack$CrossAxisBaseline);
var $author$project$Domain$CarrierInvoice$isAbandoned = function (carrierInvoice) {
	return carrierInvoice.status === 'Ignored';
};
var $author$project$Domain$CarrierInvoice$isApproved = function (carrierInvoice) {
	return carrierInvoice.status === 'Approved';
};
var $author$project$Ui$V3$Icon$truck16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$d('M15.992 11.177a1.172 1.172 0 0 0-.873-1.133l-2.304-.599a.433.433 0 0 1-.32-.42 3.495 3.495 0 0 0-1.651-2.976l-1.512-.946a.793.793 0 0 0-.173-.073.14.14 0 0 1-.107-.087 2.817 2.817 0 0 0-2.537-1.605H5.003a.333.333 0 0 0-.333.333v9.157a.166.166 0 0 1-.166.167h-.666a.166.166 0 0 1-.167-.167V2.672A2.298 2.298 0 0 0 1.966.362L.415.007A.333.333 0 0 0 .008.34v12.5a.16.16 0 0 0 .087.147.16.16 0 0 0 .173 0c.318-.211.69-.325 1.072-.326a1.998 1.998 0 0 1 1.998 1.998c0 .155-.02.31-.06.46a.153.153 0 0 0 0 .139.16.16 0 0 0 .127.067h6.8a.207.207 0 0 0 .126-.074.16.16 0 0 0 0-.133 1.725 1.725 0 0 1 0-.46 1.998 1.998 0 0 1 3.996 0c0 .045.016.088.046.12a.193.193 0 0 0 .12.047H15.5a.506.506 0 0 0 .493-.5v-3.15ZM7.334 7a.333.333 0 0 1 .333.333v1.998a.333.333 0 0 1-.333.333h-.666a.333.333 0 0 1-.333-.333V7.334A.333.333 0 0 1 6.668 7h.666Zm3.823 1.998a.146.146 0 0 1-.047.12.153.153 0 0 1-.12.053H9.812a.166.166 0 0 1-.167-.166V7.154a.16.16 0 0 1 .087-.14.153.153 0 0 1 .166 0 2.292 2.292 0 0 1 1.259 1.978V9Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$d('M12.329 15.992a1.332 1.332 0 1 0 0-2.664 1.332 1.332 0 0 0 0 2.664Zm-10.989 0a1.332 1.332 0 1 0 0-2.664 1.332 1.332 0 0 0 0 2.664Z')
					]),
				_List_Nil)
			])));
var $author$project$Components$LtlReconcileInvoicePage$viewMarginHeader = function (_v0) {
	var customerMarginData = _v0.customerMarginData;
	var percentDifference = customerMarginData.percentDifference;
	var dollarDifference = $author$project$Money$castFromString(
		$elm$core$String$fromFloat(customerMarginData.dollarDifference));
	var dangerAttributes = ($author$project$Money$toFloat(dollarDifference) < 0) ? _List_fromArray(
		[
			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Red700)
		]) : _List_Nil;
	var _v1 = (!percentDifference) ? _Utils_Tuple2($author$project$Helpers$Html$empty, '') : ((percentDifference < 0) ? _Utils_Tuple2(
		A4($author$project$Ui$V3$Icon$viewCustom, '8', '8', _List_Nil, $author$project$Ui$V3$Icon$arrow2Down16),
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(percentDifference)) + '%') : _Utils_Tuple2(
		A4($author$project$Ui$V3$Icon$viewCustom, '8', '8', _List_Nil, $author$project$Ui$V3$Icon$arrow2Up16),
		$elm$core$String$fromFloat(percentDifference) + '%'));
	var icon = _v1.a;
	var percentString = _v1.b;
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Typography$smallBody,
					dangerAttributes,
					$author$project$Money$toString(dollarDifference))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$elm$html$Html$span,
					dangerAttributes,
					_List_fromArray(
						[icon]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2($author$project$Ui$V3$Typography$smallBody, dangerAttributes, percentString))
			]));
};
var $author$project$Components$LtlReconcileInvoicePage$viewHeader = F2(
	function (_v0, displayMoveToTmsButton) {
		var accountSettings = _v0.accountSettings;
		var tmsLoadDetailsData = _v0.tmsLoadDetailsData;
		var carrierInvoice = _v0.carrierInvoice;
		var moveToTmsButton = displayMoveToTmsButton ? A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$LtlReconcileInvoicePage$OpenMoveToTmsModal)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
				]),
			'Move to TMS') : $author$project$Helpers$Html$empty;
		var maybeReferenceValue = ($elm$core$String$length(accountSettings.loadDisplayReferenceKey) > 0) ? $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (ref) {
					return _Utils_eq(ref.key, accountSettings.loadDisplayReferenceKey) ? $elm$core$Maybe$Just(ref.value) : $elm$core$Maybe$Nothing;
				},
				tmsLoadDetailsData.tmsLoadDetails.referenceFields)) : $elm$core$Maybe$Nothing;
		var shouldDisplayReference = accountSettings.displayReferenceInHeader && (($elm$core$String$length(accountSettings.loadDisplayReferenceLabel) > 0) && $elm_community$maybe_extra$Maybe$Extra$isJust(maybeReferenceValue));
		var headerLeftItemsBase = _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-icon')
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$box16)
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBodySemiBold,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
									]),
								'Customer')),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBody,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
									]),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function ($) {
										return $.name;
									},
									tmsLoadDetailsData.customer)))
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-icon')
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$truck16)
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBodySemiBold,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
									]),
								'Carrier')),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBody,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
									]),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function ($) {
										return $.name;
									},
									tmsLoadDetailsData.carrier)))
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBodySemiBold,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
									]),
								'Load ID')),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBody,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
									]),
								tmsLoadDetailsData.tmsLoadDetails.load.loadId))
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBodySemiBold,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
									]),
								'Pro number')),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Typography$smallBody,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
									]),
								A2($elm$core$Maybe$withDefault, '', tmsLoadDetailsData.tmsLoadDetails.load.proNumber)))
						])))
			]);
		var headerLeftItemsMaybeReference = _Utils_ap(
			headerLeftItemsBase,
			shouldDisplayReference ? _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$author$project$Ui$V3$Typography$smallBodySemiBold,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
										]),
									accountSettings.loadDisplayReferenceLabel)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$author$project$Ui$V3$Typography$smallBody,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
										]),
									A2($elm$core$Maybe$withDefault, '', maybeReferenceValue)))
							])))
				]) : _List_Nil);
		var headerLeftItems = _Utils_ap(
			headerLeftItemsMaybeReference,
			accountSettings.displayCustomerMarginInHeader ? _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-icon')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$V3$Tooltip$view,
											_List_fromArray(
												[
													$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$BelowDirection),
													$author$project$Ui$V3$Tooltip$tooltipWidth(
													$author$project$Ui$V3$Tooltip$FixedWidth(200)),
													A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'left', '-93px'),
													A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'top', '-10px')
												]),
											$elm$core$String$concat(
												_List_fromArray(
													[
														'Calculated as invoiced payable (',
														A2(
														$elm$core$Basics$composeR,
														$elm$core$String$fromFloat,
														A2($elm$core$Basics$composeR, $author$project$Money$castFromString, $author$project$Money$toString))(carrierInvoice.customerMarginData.carrierCharge),
														') deducted from the receivable (',
														A2(
														$elm$core$Basics$composeR,
														$elm$core$String$fromFloat,
														A2($elm$core$Basics$composeR, $author$project$Money$castFromString, $author$project$Money$toString))(carrierInvoice.customerMarginData.customerCharge),
														').'
													])),
											A2(
												$author$project$Ui$V3$Icon$view16,
												_List_fromArray(
													[
														$author$project$Ui$V3$Icon$label('Customer margin')
													]),
												$author$project$Ui$V3$Icon$infoOutline16))
										]))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$author$project$Ui$V3$Typography$smallBodySemiBold,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-ltl-header__info-area-text')
										]),
									'Customer margin')),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								$author$project$Components$LtlReconcileInvoicePage$viewMarginHeader(carrierInvoice))
							])))
				]) : _List_Nil);
		var actionButton = $author$project$Domain$CarrierInvoice$isAbandoned(carrierInvoice) ? A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$LtlReconcileInvoicePage$ImDoneButtonClicked)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
				]),
			'I\u0027m Done') : A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$LtlReconcileInvoicePage$OpenIgnoreModal)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeLarge),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
					$author$project$Ui$V3$Button$disabled(
					$author$project$Domain$CarrierInvoice$isApproved(carrierInvoice))
				]),
			'Ignore Invoice');
		var headerRight = A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
					$author$project$Ui$V3$Stack$crossAxisBaseline
				]),
			_List_fromArray(
				[
					_Utils_Tuple2($author$project$Ui$V3$Stack$fit, moveToTmsButton),
					_Utils_Tuple2($author$project$Ui$V3$Stack$fit, actionButton)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding', '24px'),
							$elm$html$Html$Attributes$class('document-indexer__header--ltl'),
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Stack$style, 'line-height', '24px'),
									$author$project$Ui$V3$Stack$crossAxisCenter
								]),
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									A2(
										$author$project$Ui$V3$Stack$viewHorzWithWidths,
										_List_fromArray(
											[
												$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
												$author$project$Ui$V3$Stack$crossAxisStretch
											]),
										headerLeftItems)),
									_Utils_Tuple2($author$project$Ui$V3$Stack$fit, headerRight)
								]))
						]))
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$CloseIgnoreModal = {$: 'CloseIgnoreModal'};
var $author$project$Components$LtlReconcileInvoicePage$PerformIgnore = {$: 'PerformIgnore'};
var $author$project$Components$LtlReconcileInvoicePage$SetIgnoreReason = function (a) {
	return {$: 'SetIgnoreReason', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$viewIgnoreModal = function (ignoreModal) {
	var body = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('enable_shared-ui-v3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__theme')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$V3$Input$view,
						{onInput: $author$project$Components$LtlReconcileInvoicePage$SetIgnoreReason},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$expandable,
								$author$project$Ui$V3$Input$label('Reason')
							]),
						_List_Nil,
						ignoreModal.text)
					]))
			]));
	return ignoreModal.isShown ? A2(
		$author$project$Components$Shared$ModalDialog$view,
		$author$project$Components$LtlReconcileInvoicePage$CloseIgnoreModal,
		{
			body: body,
			confirm: $elm$core$Maybe$Just(
				{msg: $author$project$Components$LtlReconcileInvoicePage$PerformIgnore, text: 'Ignore Invoice'}),
			dismissText: $elm$core$Maybe$Just('Cancel'),
			header: $elm$core$Maybe$Just($author$project$Helpers$Html$empty),
			modalClassOverride: $elm$core$Maybe$Just('modal__medium-container invoice__mark-complete cg-busy-backdrop-elm'),
			performing: ignoreModal.isPerforming,
			performingText: $elm$core$Maybe$Just('Ignoring Invoice...'),
			success: false,
			successText: $elm$core$Maybe$Nothing
		}) : $author$project$Helpers$Html$empty;
};
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$Cancel = {$: 'Cancel'};
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$StartSubmitForm = {$: 'StartSubmitForm'};
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$SetReason = function (a) {
	return {$: 'SetReason', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$viewReasonInput = function () {
	var reasonInput = A4(
		$author$project$Ui$V3$Input$view,
		{onInput: $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$SetReason},
		_List_fromArray(
			[
				$author$project$Ui$V3$Input$expandable,
				$author$project$Ui$V3$Input$placeholder('Provide a reason'),
				$author$project$Ui$V3$Input$parentClass('v3__input--resize-vertical')
			]),
		_List_Nil,
		'');
	var inputLabel = A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[$author$project$Ui$V3$Stack$mainAxisSpaceBetween]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$elm$html$Html$h6,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Reason')
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Typography$xSmallBody,
					_List_fromArray(
						[
							$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
						]),
					'Optional'))
			]));
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
			]),
		_List_fromArray(
			[inputLabel, reasonInput]));
}();
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$UpdateSelectedTmsQueue = function (a) {
	return {$: 'UpdateSelectedTmsQueue', a: a};
};
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$viewTmsQueueSelect = F2(
	function (tmsQueues, selectedTmsQueue) {
		var selectInput = A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{
				onInput: $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$UpdateSelectedTmsQueue,
				options: tmsQueues,
				toLabel: $elm$core$Basics$identity,
				value: $elm$core$Maybe$Just(selectedTmsQueue)
			},
			_List_Nil);
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Assign to Internal Queue')
						])),
					selectInput
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$viewBody = F2(
	function (tmsQueues, selectedTmsQueue) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$author$project$Ui$V3$Typography$smallBodyClass]),
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice will be moved to the TMS and is ignored in Audit')
						])),
					$author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$viewReasonInput,
					A2($author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$viewTmsQueueSelect, tmsQueues, selectedTmsQueue)
				]));
	});
var $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$view = function (_v0) {
	var selectedTmsQueue = _v0.selectedTmsQueue;
	var ltlInvoiceAvailableTmsQueues = _v0.ltlInvoiceAvailableTmsQueues;
	var isSubmitting = _v0.isSubmitting;
	var isOpen = _v0.isOpen;
	return isOpen ? A2(
		$author$project$Ui$V3$Modal$view,
		_List_fromArray(
			[
				$author$project$Ui$V3$Modal$disablePrimaryButton(isSubmitting)
			]),
		{
			body: A2($author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$viewBody, ltlInvoiceAvailableTmsQueues, selectedTmsQueue),
			cancelButton: $elm$core$Maybe$Just(
				_Utils_Tuple2('Cancel', $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$Cancel)),
			dismissMsg: $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$Cancel,
			footerButtons: _List_Nil,
			header: $author$project$Ui$V3$Modal$textHeader('Move to TMS'),
			primaryButton: $elm$core$Maybe$Just(
				_Utils_Tuple2('Confirm', $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$StartSubmitForm)),
			size: $author$project$Ui$V3$Modal$medium
		}) : $elm$html$Html$text('');
};
var $author$project$Components$LtlReconcileInvoicePage$viewMoveToTmsModal = function (moveToTmsModal) {
	var modal = A2(
		$elm$html$Html$map,
		$author$project$Components$LtlReconcileInvoicePage$MoveToTmsModalMsg,
		$author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$view(moveToTmsModal));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('enable_shared-ui-v3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('v3__theme')
					]),
				_List_fromArray(
					[modal]))
			]));
};
var $author$project$Components$LtlReconcileInvoicePage$viewSubHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('document-indexer__progress')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indexer-progress__container-ltl-reconcile')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indexer-progress__list')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indexer-progress__item'),
									$elm$html$Html$Attributes$class('indexer-progress__item--clickable'),
									$elm$html$Html$Attributes$class('indexer-progress__item__active')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-progress__indicator')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('indexer-progress__indicator-inner')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Reconcile Invoice')
										])),
									A2(
									$elm$html$Html$hr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-progress__trailer')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indexer-progress__item'),
									$elm$html$Html$Attributes$class('indexer-progress__item__completed')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-progress__indicator')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('indexer-progress__indicator-inner')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Review and Submit')
										]))
								]))
						]))
				]))
		]));
var $author$project$Components$LtlReconcileInvoicePage$view = F2(
	function (model, data) {
		var moveToTmsModalEnabled = $author$project$Components$LtlReconcileInvoicePage$MoveToTmsModal$isEnabled(model.moveToTmsModal);
		var maybeAuditV3ReactStyleOverrideAttrs = data.accountSettings.auditV3ReactStyleOverrides ? _List_fromArray(
			[
				$elm$html$Html$Attributes$id('mainViewContainer'),
				$elm$html$Html$Attributes$class('v3__theme'),
				$elm$html$Html$Attributes$class('audit_v3_reskin__activate_container'),
				$elm$html$Html$Attributes$class('v3_reskin__react-style-overrides-enabled--ltl-reconcile')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				maybeAuditV3ReactStyleOverrideAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-container'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'white')
					])),
			_List_fromArray(
				[
					$author$project$Components$LtlReconcileInvoicePage$viewIgnoreModal(model.ignoreModal),
					$author$project$Components$LtlReconcileInvoicePage$viewMoveToTmsModal(model.moveToTmsModal),
					A2($author$project$Components$LtlReconcileInvoicePage$viewHeader, data, moveToTmsModalEnabled),
					$author$project$Components$LtlReconcileInvoicePage$viewSubHeader,
					A2($author$project$Components$LtlReconcileInvoicePage$viewContent, model, data)
				]));
	});
var $author$project$Components$NonInvoiceConfirmPage$ClickedApprove = {$: 'ClickedApprove'};
var $author$project$Components$NonInvoiceConfirmPage$ClickedContinue = {$: 'ClickedContinue'};
var $author$project$Components$NonInvoiceConfirmPage$Disabled = {$: 'Disabled'};
var $author$project$Components$NonInvoiceConfirmPage$Enabled = function (a) {
	return {$: 'Enabled', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$Exception = F2(
	function (message, document) {
		return {document: document, message: message};
	});
var $author$project$Id$Dict$values = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$values(dict);
};
var $author$project$Components$NonInvoiceConfirmPage$assignedDocumentIds = function (dict) {
	return A2(
		$elm$core$List$concatMap,
		$author$project$Id$Set$toList,
		$author$project$Id$Dict$values(dict));
};
var $author$project$Components$NonInvoiceConfirmPage$continueLabel = function (nextUp) {
	if (nextUp.$ === 'Dashboard') {
		return 'Continue to dashboard';
	} else {
		return 'Continue to next group';
	}
};
var $author$project$Components$NonInvoiceConfirmPage$needsShipmentAssignment = F3(
	function (documentIdsRequiringShipments, assignedDocIds, doc) {
		return (!A2($elm$core$List$member, doc.id, assignedDocIds)) && A2($author$project$Id$Set$member, doc.id, documentIdsRequiringShipments);
	});
var $author$project$Components$DocumentsBrowser$Overlay = function (a) {
	return {$: 'Overlay', a: a};
};
var $author$project$Components$DocumentsBrowser$overlay = function (render) {
	return $author$project$Components$DocumentsBrowser$Overlay(
		$elm$core$Maybe$Just(render));
};
var $author$project$Components$NonInvoiceConfirmPage$viewNothing = $elm$html$Html$text('');
var $author$project$Components$NonInvoiceConfirmPage$statusMessage = function (formState) {
	switch (formState.$) {
		case 'Ready':
			return $author$project$Components$NonInvoiceConfirmPage$viewNothing;
		case 'Loading':
			return $elm$html$Html$text('Loading...');
		case 'Success':
			var message = formState.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('success')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]));
		default:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('problem')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Could not approve documents.')
					]));
	}
};
var $author$project$Components$NonInvoiceConfirmPage$viewDocumentThumbnailOverlay = F2(
	function (model, id) {
		var requiresShipment = A2($author$project$Id$Set$member, id, model.documentIdsRequiringShipments);
		var isSentToTms = false;
		var isAttachedToShipment = A2(
			$elm$core$List$member,
			id,
			$author$project$Components$NonInvoiceConfirmPage$assignedDocumentIds(model.shipmentDocuments));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('doc-overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('doc-overlay__icons')
						]),
					_List_fromArray(
						[
							isAttachedToShipment ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-paperclip doc-overlay__icon doc-overlay__icon--blue')
								]),
							_List_Nil) : (requiresShipment ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-alert doc-overlay__icon doc-overlay__icon--orange')
								]),
							_List_Nil) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-paperclip doc-overlay__icon doc-overlay__icon--gray')
								]),
							_List_Nil)),
							isSentToTms ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-check doc-overlay__icon doc-overlay__icon--green')
								]),
							_List_Nil) : $author$project$Components$NonInvoiceConfirmPage$viewNothing
						]))
				]));
	});
var $author$project$Components$NonInvoiceConfirmPage$viewEmailHeader = F2(
	function (tz, options) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-indexer__header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indexer-header__container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indexer-header__subject-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-header__subject')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(options.subject)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-header__sender-address')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(options.sender)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indexer-header__action-area')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-header__date-area')
										]),
									_List_fromArray(
										[
											function () {
											var _v0 = options.date;
											if (_v0.$ === 'Just') {
												var date = _v0.a;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('indexer-header__date-time')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('indexer-header__date')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($author$project$Helpers$Date$dateString, tz, date))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('indexer-header__time')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($author$project$Helpers$Date$timeString, tz, date))
																]))
														]));
											} else {
												return $author$project$Components$NonInvoiceConfirmPage$viewNothing;
											}
										}(),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('indexer-header__carrier-area')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Email Carrier: ')
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(options.carrier)
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-header__center-action-area')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-header__right-action-area')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $elm$html$Html$aside = _VirtualDom_node('aside');
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Components$NonInvoiceConfirmPage$viewLayout = function (options) {
	var _v0 = $author$project$Helpers$Html$optionalV3ReactStyleOverridesWrapperAttrs(options.settings.auditV3ReactStyleOverrides);
	var outerAttrs = _v0.a;
	var innerAttrs = _v0.b;
	return A2(
		$elm$html$Html$div,
		outerAttrs,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('non-invoice-confirm-page__wrapper dual-layout'),
					innerAttrs),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$header,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dual-layout__header')
							]),
						_List_fromArray(
							[options.header])),
						A2(
						$elm$html$Html$nav,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dual-layout__nav')
							]),
						_List_fromArray(
							[options.secondaryNav])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dual-layout__content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$main_,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dual-layout__pane dual-layout__pane--left')
									]),
								_List_fromArray(
									[options.left])),
								A2(
								$elm$html$Html$aside,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dual-layout__pane dual-layout__pane--right')
									]),
								_List_fromArray(
									[options.right]))
							]))
					]))
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$NoOp = {$: 'NoOp'};
var $author$project$Components$NonInvoiceConfirmPage$SelectDocument = function (a) {
	return {$: 'SelectDocument', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$ifNonEmpty = F2(
	function (items, viewItems) {
		return $elm$core$List$isEmpty(items) ? $author$project$Components$NonInvoiceConfirmPage$viewNothing : viewItems;
	});
var $author$project$Components$NonInvoiceConfirmPage$onButtonEvent = F2(
	function (event, action) {
		if (action.$ === 'Enabled') {
			var msg = action.a;
			return event(msg);
		} else {
			return $elm$html$Html$Attributes$disabled(true);
		}
	});
var $author$project$Components$NonInvoiceConfirmPage$onButtonClick = $author$project$Components$NonInvoiceConfirmPage$onButtonEvent($elm$html$Html$Events$onClick);
var $author$project$Domain$Address$toLines = function (address) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(address.name),
				address.addressLine1,
				address.addressLine2,
				$author$project$Domain$Address$lastLine(address)
			]));
};
var $author$project$Components$Shared$Table$defaultAttributes = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'font-family', 'sans-serif'),
		A2($elm$html$Html$Attributes$style, 'width', '100%')
	]);
var $author$project$Components$Shared$Table$viewHeader = function (header) {
	return A2(
		$elm$html$Html$th,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(header)
			]));
};
var $author$project$Components$Shared$Table$viewColumnHeader = function (_v0) {
	var header = _v0.header;
	return $author$project$Components$Shared$Table$viewHeader(header);
};
var $author$project$Components$Shared$Table$viewColumnHeaders = function (headers) {
	return A2(
		$elm$html$Html$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Components$Shared$Table$viewColumnHeader, headers))
			]));
};
var $author$project$Components$Shared$Table$viewRow = F2(
	function (data, column) {
		return A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					column.view(data)
				]));
	});
var $author$project$Components$Shared$Table$viewRows = F2(
	function (columns, data) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Components$Shared$Table$viewRow(data),
				columns));
	});
var $author$project$Components$Shared$Table$view = function (options) {
	return A2(
		$elm$html$Html$table,
		$author$project$Components$Shared$Table$defaultAttributes,
		_List_fromArray(
			[
				$author$project$Components$Shared$Table$viewColumnHeaders(options.columns),
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Components$Shared$Table$viewRows(options.columns),
					options.data))
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$viewAddressLines = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$text,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				$elm$html$Html$div(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address_line')
						]))))),
	$elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('address')
			])));
var $author$project$Components$NonInvoiceConfirmPage$viewAddressTable = function (items) {
	return $author$project$Components$Shared$Table$view(
		{
			columns: _List_fromArray(
				[
					{
					header: 'Origin',
					view: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.origin;
						},
						$author$project$Components$NonInvoiceConfirmPage$viewAddressLines)
				},
					{
					header: 'Destination',
					view: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.destination;
						},
						$author$project$Components$NonInvoiceConfirmPage$viewAddressLines)
				}
				]),
			data: items
		});
};
var $author$project$Components$NonInvoiceConfirmPage$viewBabyTable = function (_v0) {
	var label = _v0.a;
	var value = _v0.b;
	return A2(
		$elm$html$Html$table,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]))
							]))
					])),
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(value)
									]))
							]))
					]))
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$viewBoldList = function (pairs) {
	var viewPair = function (_v0) {
		var label = _v0.a;
		var value = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__info-reference-pair')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__info-reference-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label + ':')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__info-reference-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, viewPair, pairs));
};
var $author$project$Components$NonInvoiceConfirmPage$viewCarrierTable = function (items) {
	return $author$project$Components$Shared$Table$view(
		{
			columns: _List_fromArray(
				[
					{
					header: 'TMS Carrier',
					view: function (_v0) {
						return $author$project$Components$NonInvoiceConfirmPage$viewBoldList(items);
					}
				}
				]),
			data: _List_fromArray(
				[_Utils_Tuple0])
		});
};
var $author$project$Components$NonInvoiceConfirmPage$viewLineItems = F2(
	function (tms, items) {
		return $author$project$Components$Shared$Table$view(
			{
				columns: function () {
					if (tms.$ === 'TMSOptionMercuryGate') {
						return _List_fromArray(
							[
								{
								header: 'Description',
								view: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.description;
									},
									$elm$html$Html$text)
							},
								{
								header: 'Rate Qualifier',
								view: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.rateQualifier;
									},
									$elm$html$Html$text)
							},
								{
								header: 'Quantity',
								view: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.quantity;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Maybe$withDefault(''),
										$elm$html$Html$text))
							},
								{
								header: 'Rate',
								view: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.rate;
									},
									A2(
										$elm$core$Basics$composeR,
										$author$project$Money$castFromString,
										A2($elm$core$Basics$composeR, $author$project$Money$toString, $elm$html$Html$text)))
							},
								{
								header: 'Carrier Charge',
								view: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.total;
									},
									A2(
										$elm$core$Basics$composeR,
										$author$project$Money$castFromString,
										A2($elm$core$Basics$composeR, $author$project$Money$toString, $elm$html$Html$text)))
							}
							]);
					} else {
						return _List_fromArray(
							[
								{
								header: 'Description',
								view: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.description;
									},
									$elm$html$Html$text)
							},
								{
								header: 'Carrier Charge',
								view: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.total;
									},
									A2(
										$elm$core$Basics$composeR,
										$author$project$Money$castFromString,
										A2($elm$core$Basics$composeR, $author$project$Money$toString, $elm$html$Html$text)))
							}
							]);
					}
				}(),
				data: items
			});
	});
var $author$project$Components$NonInvoiceConfirmPage$viewRow = function (items) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dual-layout__row')
			]),
		items);
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Components$NonInvoiceConfirmPage$viewSection = function (options) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section'),
				$elm$html$Html$Attributes$class('section__' + options.className)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(options.title)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section__body')
					]),
				options.body)
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$AddedShipmentDocFor = F2(
	function (a, b) {
		return {$: 'AddedShipmentDocFor', a: a, b: b};
	});
var $author$project$Components$NonInvoiceConfirmPage$ExpandReferencesFor = function (a) {
	return {$: 'ExpandReferencesFor', a: a};
};
var $author$project$Components$NonInvoiceConfirmPage$RemovedShipmentDocFor = F2(
	function (a, b) {
		return {$: 'RemovedShipmentDocFor', a: a, b: b};
	});
var $author$project$Components$NonInvoiceConfirmPage$toShipment = F2(
	function (visibleReferenceLabels, shipment) {
		var _v0 = A2(
			$elm$core$List$partition,
			function (_v1) {
				var name = _v1.a;
				return A2($elm$core$List$member, name, visibleReferenceLabels);
			},
			$elm$core$Dict$toList(shipment.references));
		var visibleReferences = _v0.a;
		var additionalReferences = _v0.b;
		var references = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						_Utils_Tuple2('Shipment', shipment.shipmentId)
					]),
					A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (weight) {
								return _Utils_Tuple2(
									'Weight',
									(weight === 1) ? '1 lb' : ($elm$core$String$fromInt(weight) + ' lbs'));
							},
							shipment.weight),
							A2(
							$elm$core$Maybe$map,
							function (name) {
								return _Utils_Tuple2('Shipper Name', name);
							},
							shipment.shipperName)
						])),
					visibleReferences
				]));
		return {additionalReferences: additionalReferences, notes: shipment.shipmentNotes, references: references, stops: shipment.stops};
	});
var $author$project$Domain$TmsStop$address = function (stop) {
	var _v0 = stop.tmsStop;
	if (_v0.$ === 'TMSShipment_TMSStopWrapper_TMSStop_Pickup') {
		var pickup = _v0.a;
		return pickup.address;
	} else {
		var drop = _v0.a;
		return drop.address;
	}
};
var $author$project$Domain$TmsStop$name = function (stop) {
	var _v0 = stop.tmsStop;
	if (_v0.$ === 'TMSShipment_TMSStopWrapper_TMSStop_Pickup') {
		return 'Pickup';
	} else {
		return 'Drop';
	}
};
var $author$project$Components$Shared$Table$viewHeaders = function (headers) {
	return A2(
		$elm$html$Html$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Components$Shared$Table$viewHeader, headers))
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$viewShipmentNotes = F2(
	function (shipment, options) {
		var viewNote = function (note) {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('load-detail__info-reference-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(note)
							]))
					]));
		};
		var isVisible = !$elm$core$List$isEmpty(shipment.notes);
		return (isVisible && options.isExpanded) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__shipment_notes_row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(2)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('load-detail__info-reference-pair')
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('load-detail__info-reference-name')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Shipment Notes:')
											])),
									A2($elm$core$List$map, viewNote, shipment.notes)))
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$NonInvoiceConfirmPage$viewVerticalTable = function (items) {
	var viewRow_ = function (_v0) {
		var label = _v0.a;
		var value = _v0.b;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[value]))
				]));
	};
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('load-detail__info-table load-detail__info-table--vertical')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				A2($elm$core$List$map, viewRow_, items))
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$whenNonEmpty = F2(
	function (viewFn, items) {
		return $elm$core$List$isEmpty(items) ? $author$project$Components$NonInvoiceConfirmPage$viewNothing : viewFn(items);
	});
var $author$project$Components$NonInvoiceConfirmPage$viewShipmentDetails = F2(
	function (options, shipment) {
		var viewAddress = A2($elm$core$Basics$composeR, $author$project$Domain$Address$toLines, $author$project$Components$NonInvoiceConfirmPage$viewAddressLines);
		var hasAddressInformation = !$elm$core$List$isEmpty(
			A2(
				$elm$core$List$concatMap,
				A2($elm$core$Basics$composeR, $author$project$Domain$TmsStop$address, $author$project$Domain$Address$toLines),
				shipment.stops));
		return A2(
			$elm$html$Html$table,
			$author$project$Components$Shared$Table$defaultAttributes,
			_List_fromArray(
				[
					$author$project$Components$Shared$Table$viewHeaders(
					_List_fromArray(
						['Details', 'Stops'])),
					A2(
					$elm$html$Html$tbody,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__info-reference-pair')
						]),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('hub__column hub__spacing--medium')
														]),
													_List_fromArray(
														[
															$author$project$Components$NonInvoiceConfirmPage$viewBoldList(shipment.references),
															options.isExpanded ? $author$project$Components$NonInvoiceConfirmPage$viewBoldList(shipment.additionalReferences) : A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('button--link'),
																	$elm$html$Html$Events$onClick(options.expandReferences)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('View all shipment details')
																]))
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													hasAddressInformation ? A2(
													$author$project$Components$NonInvoiceConfirmPage$whenNonEmpty,
													$author$project$Components$NonInvoiceConfirmPage$viewVerticalTable,
													A2(
														$elm$core$List$map,
														function (stop) {
															return _Utils_Tuple2(
																$author$project$Domain$TmsStop$name(stop),
																viewAddress(
																	$author$project$Domain$TmsStop$address(stop)));
														},
														shipment.stops)) : $author$project$Components$NonInvoiceConfirmPage$viewNothing
												]))
										]))),
								A2(
								$author$project$Components$NonInvoiceConfirmPage$viewShipmentNotes,
								shipment,
								{isExpanded: options.isExpanded})
							])))
				]));
	});
var $author$project$Components$NonInvoiceConfirmPage$previewUrlFor = function (pages) {
	return A2(
		$elm$core$Maybe$andThen,
		function (page) {
			return page.previewUrl;
		},
		$elm$core$List$head(pages));
};
var $author$project$Components$NonInvoiceConfirmPage$viewShipmentDocumentPicker = function (options) {
	var viewShipmentDocument = function (documentId) {
		var _v1 = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$mapSecond($author$project$Components$NonInvoiceConfirmPage$previewUrlFor),
			A2($author$project$Components$NonInvoiceConfirmPage$getDocumentWith, options.documents, documentId));
		if ((_v1.$ === 'Just') && (_v1.a.b.$ === 'Just')) {
			var _v2 = _v1.a;
			var doc = _v2.a;
			var url = _v2.b.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hub__relative hub__border--light shipment-document')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('document-thumbnail'),
								$elm$html$Html$Events$onClick(
								options.onView(documentId))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('document-thumbnail__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3(
											$author$project$Domain$UnresolvedDocumentType$toString,
											options.accountSettings.customDocumentTypeNames,
											$author$project$Domain$Environment$BrokerEnvironment,
											$author$project$Domain$Document$documentTypeValueToUnresolved(doc.documentTypeValue)))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('document-thumbnail__pages')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('document-thumbnail__page'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'document-thumbnail__page--selected',
														_Utils_eq(
															options.selected,
															$elm$core$Maybe$Just(doc.id)))
													])),
												$elm$html$Html$Attributes$src(url),
												A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								options.onRemove(documentId)),
								$elm$html$Html$Attributes$class('hub__absolute hub__align-right hub__align-top hub__padding--tiny')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('icon icon-close')
									]),
								_List_Nil)
							]))
					]));
		} else {
			return $author$project$Components$NonInvoiceConfirmPage$viewNothing;
		}
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hub__column hub__spacing--small')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section__title section__title--assigned-documents section__title--smaller')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Assigned Documents')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hub hub__row hub__wrap hub__spacing--small')
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							viewShipmentDocument,
							$author$project$Id$Set$toList(options.associatedDocumentIds)),
							function () {
							var _v0 = options.selected;
							if (_v0.$ === 'Nothing') {
								return _List_Nil;
							} else {
								var documentId = _v0.a;
								return A2($author$project$Id$Set$member, documentId, options.associatedDocumentIds) ? _List_Nil : (A2($author$project$Id$Set$member, documentId, options.documentIdsRequiringShipments) ? _List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('shipment__add-button'),
												$elm$html$Html$Events$onClick(
												options.onAdd(documentId))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('+')
													]))
											]))
									]) : _List_Nil);
							}
						}()
						])))
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$viewShipments = function (options) {
	var viewShipment = function (shipment) {
		return $author$project$Components$NonInvoiceConfirmPage$viewSection(
			{
				body: _List_fromArray(
					[
						A2(
						$author$project$Components$NonInvoiceConfirmPage$viewShipmentDetails,
						{
							expandReferences: $author$project$Components$NonInvoiceConfirmPage$ExpandReferencesFor(shipment.id),
							isExpanded: A2($author$project$Id$Set$member, shipment.id, options.expandedShipmentReferences)
						},
						A2($author$project$Components$NonInvoiceConfirmPage$toShipment, options.visibleReferenceLabels, shipment)),
						$author$project$Components$NonInvoiceConfirmPage$viewShipmentDocumentPicker(
						{
							accountSettings: options.accountSettings,
							associatedDocumentIds: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Id$Set$empty,
								A2($author$project$Id$Dict$get, shipment.id, options.shipmentDocuments)),
							documentIdsRequiringShipments: options.documentIdsRequiringShipments,
							documents: options.documents,
							onAdd: $author$project$Components$NonInvoiceConfirmPage$AddedShipmentDocFor(shipment.id),
							onRemove: $author$project$Components$NonInvoiceConfirmPage$RemovedShipmentDocFor(shipment.id),
							onView: $author$project$Components$NonInvoiceConfirmPage$SelectDocument,
							selected: options.selectedDocumentId
						})
					]),
				className: 'shipment',
				title: 'Shipment ' + shipment.shipmentId
			});
	};
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, viewShipment, options.shipments));
};
var $author$project$Components$NonInvoiceConfirmPage$viewSubsection = function (options) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section__title section__title--smaller')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(options.title)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section__body')
					]),
				options.body)
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$viewLeftSide = function (options) {
	var handler = function (doc) {
		if (doc.$ === 'Just') {
			var document = doc.a;
			return $author$project$Components$NonInvoiceConfirmPage$SelectDocument(document.id);
		} else {
			return $author$project$Components$NonInvoiceConfirmPage$NoOp;
		}
	};
	var customerInstructions = A2(
		$elm$core$List$map,
		function (instructions) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(instructions)
					]));
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.instructionsList;
				},
				options.customer)));
	var classes = function (handler_) {
		if (handler_.$ === 'SelectDocument') {
			return _List_fromArray(
				['rules__error', 'rules__clickable']);
		} else {
			return _List_fromArray(
				['rules__error']);
		}
	};
	var callToAction = function (handler_) {
		if (handler_.$ === 'SelectDocument') {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rules__error__cta')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('View')
					]));
		} else {
			return $elm$html$Html$text('');
		}
	};
	var listException = function (exception) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2(
						$elm$core$String$join,
						' ',
						classes(
							handler(exception.document)))),
					$elm$html$Html$Events$onClick(
					handler(exception.document))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(exception.message),
					callToAction(
					handler(exception.document))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('docflow')
			]),
		_List_fromArray(
			[
				$author$project$Presence$viewInCorner(options.presence),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('docflow__form')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('docflow__h1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Load ' + options.loadId)
							])),
						$author$project$Components$NonInvoiceConfirmPage$viewSection(
						{
							body: _List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('rules__list')
										]),
									$elm$core$List$isEmpty(options.exceptions) ? _List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('rules__all-pass')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('No Exceptions')
												]))
										]) : A2($elm$core$List$map, listException, options.exceptions))
								]),
							className: 'exceptions',
							title: 'Exceptions'
						}),
						$elm$core$List$isEmpty(customerInstructions) ? $elm$html$Html$text('') : $author$project$Components$NonInvoiceConfirmPage$viewSection(
						{body: customerInstructions, className: 'customer-instructions', title: 'Customer Instructions'}),
						A2(
						$author$project$Components$NonInvoiceConfirmPage$ifNonEmpty,
						options.shipments,
						$author$project$Components$NonInvoiceConfirmPage$viewShipments(options)),
						$author$project$Components$NonInvoiceConfirmPage$viewSection(
						{
							body: _List_fromArray(
								[
									$author$project$Components$NonInvoiceConfirmPage$viewAddressTable(
									_List_fromArray(
										[
											{
											destination: A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2($elm$core$Maybe$map, $author$project$Domain$Address$toLines, options.addresses.destination)),
											origin: A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2($elm$core$Maybe$map, $author$project$Domain$Address$toLines, options.addresses.origin))
										}
										])),
									function () {
									if ($elm$core$List$isEmpty(options.references) && _Utils_eq(options.customer, $elm$core$Maybe$Nothing)) {
										return $author$project$Components$NonInvoiceConfirmPage$viewNothing;
									} else {
										var prependCustomer = function (refs) {
											return A2(
												$elm$core$Maybe$withDefault,
												refs,
												A2(
													$elm$core$Maybe$map,
													function (_v0) {
														var name = _v0.name;
														return A2(
															$elm$core$List$cons,
															_Utils_Tuple2('Customer', name),
															refs);
													},
													options.customer));
										};
										return $author$project$Components$NonInvoiceConfirmPage$viewSubsection(
											{
												body: _List_fromArray(
													[
														$author$project$Components$NonInvoiceConfirmPage$viewVerticalTable(
														A2(
															$elm$core$List$map,
															$elm$core$Tuple$mapSecond($elm$html$Html$text),
															prependCustomer(options.references)))
													]),
												title: 'References'
											});
									}
								}(),
									A2(
									$author$project$Components$NonInvoiceConfirmPage$whenNonEmpty,
									$author$project$Components$NonInvoiceConfirmPage$viewRow,
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$map,
												$author$project$Components$NonInvoiceConfirmPage$viewBabyTable,
												A2(
													$elm$core$Maybe$map,
													function (date) {
														return _Utils_Tuple2(
															'Ship Date',
															A2($author$project$Helpers$Date$dateStringFormat2, options.timezone, date));
													},
													options.dates.shippedAt)),
												A2(
												$elm$core$Maybe$map,
												$author$project$Components$NonInvoiceConfirmPage$viewBabyTable,
												A2(
													$elm$core$Maybe$map,
													function (date) {
														return _Utils_Tuple2(
															'Delivered Date',
															A2($author$project$Helpers$Date$dateStringFormat2, options.timezone, date));
													},
													options.dates.deliveredAt)),
												A2(
												$elm$core$Maybe$map,
												$author$project$Components$NonInvoiceConfirmPage$viewBabyTable,
												A2(
													$elm$core$Maybe$map,
													function (charge) {
														return _Utils_Tuple2(
															'Customer Charge',
															$author$project$Money$toString(charge));
													},
													options.customerCharge))
											]))),
									function () {
									var _v1 = options.carrier;
									if (_v1.$ === 'Just') {
										var carrier = _v1.a;
										return $author$project$Components$NonInvoiceConfirmPage$viewCarrierTable(
											_List_fromArray(
												[
													_Utils_Tuple2('Name', carrier.name)
												]));
									} else {
										return $author$project$Components$NonInvoiceConfirmPage$viewNothing;
									}
								}(),
									A2(
									$author$project$Components$NonInvoiceConfirmPage$ifNonEmpty,
									options.lineItems,
									$author$project$Components$NonInvoiceConfirmPage$viewSubsection(
										{
											body: _List_fromArray(
												[
													A2($author$project$Components$NonInvoiceConfirmPage$viewLineItems, options.tms, options.lineItems)
												]),
											title: 'Line Items'
										}))
								]),
							className: 'load-information',
							title: 'Additional Load Information'
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('docflow__controls')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('docflow__button button button--progress'),
								$author$project$Components$NonInvoiceConfirmPage$onButtonClick(options.actions.primary.event)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(options.actions.primary.label)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('docflow__button button button--link'),
								$author$project$Components$NonInvoiceConfirmPage$onButtonClick(options.actions.secondary.event)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(options.actions.secondary.label)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('docflow__status')
							]),
						_List_fromArray(
							[options.status]))
					]))
			]));
};
var $author$project$Components$NonInvoiceConfirmPage$viewProgressBar = function (options) {
	var viewLink = F2(
		function (class_, _v1) {
			var url = _v1.url;
			var label = _v1.label;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(class_)
					]),
				_List_fromArray(
					[
						function () {
						if (url.$ === 'Just') {
							var url_ = url.a;
							return A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(url_),
										$elm$html$Html$Attributes$class('button--link'),
										A2($elm$html$Html$Attributes$style, 'color', 'inherit')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]));
						} else {
							return $elm$html$Html$text(label);
						}
					}()
					]));
		});
	var viewNextLink = viewLink('crumb crumb--next');
	var viewCurrentLink = viewLink('crumb crumb--current');
	var viewCompletedLink = viewLink('crumb crumb--completed');
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('crumb__list')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2($elm$core$List$map, viewCompletedLink, options.links.complete),
					_List_fromArray(
					[
						viewCurrentLink(options.links.current)
					]),
					A2($elm$core$List$map, viewNextLink, options.links.next)
				])));
};
var $author$project$Components$NonInvoiceConfirmPage$viewRightSide = function (options) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dual-layout__right-side')
			]),
		_List_fromArray(
			[options.viewContent]));
};
var $author$project$Components$NonInvoiceConfirmPage$view = F2(
	function (model, data) {
		var whenEnabled = function (msg) {
			var _v1 = model.formState;
			switch (_v1.$) {
				case 'Ready':
					return $author$project$Components$NonInvoiceConfirmPage$Enabled(msg);
				case 'Loading':
					return $author$project$Components$NonInvoiceConfirmPage$Disabled;
				case 'Success':
					return $author$project$Components$NonInvoiceConfirmPage$Disabled;
				default:
					return $author$project$Components$NonInvoiceConfirmPage$Enabled(msg);
			}
		};
		var references = A2(
			$elm$core$List$map,
			function (ref) {
				return _Utils_Tuple2(ref.key, ref.value);
			},
			data.tmsLoadDetails.tmsLoadDetails.referenceFields);
		var load = data.tmsLoadDetails.tmsLoadDetails.load;
		var lineItems = data.tmsLoadDetails.tmsLoadDetails.lineItems;
		var exceptions = function () {
			var unassignedShipmentDocuments = $elm$core$List$isEmpty(data.tmsLoadDetails.shipments) ? _List_Nil : A2(
				$elm$core$List$filter,
				A2(
					$author$project$Components$NonInvoiceConfirmPage$needsShipmentAssignment,
					model.documentIdsRequiringShipments,
					$author$project$Components$NonInvoiceConfirmPage$assignedDocumentIds(model.shipmentDocuments)),
				A2($elm$core$List$map, $elm$core$Tuple$first, data.tmsLoadDetails.documents));
			return (!$elm$core$List$isEmpty(unassignedShipmentDocuments)) ? _List_fromArray(
				[
					A2(
					$author$project$Components$NonInvoiceConfirmPage$Exception,
					'Some shipment documents aren\u0027t assigned to a shipment.',
					$elm$core$List$head(unassignedShipmentDocuments))
				]) : _List_Nil;
		}();
		var whenPrimaryEnabled = function (msg) {
			return $elm$core$List$isEmpty(exceptions) ? whenEnabled(msg) : $author$project$Components$NonInvoiceConfirmPage$Disabled;
		};
		var documentsBrowser = A3(
			$author$project$Components$DocumentsBrowser$view,
			model.timezone,
			model.documentsBrowser,
			_List_fromArray(
				[
					$author$project$Components$DocumentsBrowser$overlay(
					$author$project$Components$NonInvoiceConfirmPage$viewDocumentThumbnailOverlay(model))
				]));
		var documentsBrowserWithLoader = data.settings.auditV3ReactStyleOverrides ? A4(
			$author$project$Ui$V3$Skeleton$viewRemote,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'border-radius', '0')
				]),
			{height: $elm$core$Maybe$Nothing},
			documentsBrowser,
			data.documentsBrowserData) : A2($author$project$Forward$LoadingView$view, documentsBrowser, data.documentsBrowserData);
		return $author$project$Components$NonInvoiceConfirmPage$viewLayout(
			{
				header: A2(
					$author$project$Components$NonInvoiceConfirmPage$viewEmailHeader,
					model.timezone,
					function () {
						var _v0 = data.documentBatch.message;
						if (_v0.$ === 'Just') {
							var message = _v0.a;
							return {
								carrier: A2(
									$elm$core$Maybe$withDefault,
									'Unknown',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.name;
										},
										data.tmsLoadDetails.carrier)),
								date: message.importCompletedAt,
								sender: message.senderAddress,
								subject: message.subject
							};
						} else {
							return {
								carrier: A2(
									$elm$core$Maybe$withDefault,
									'Unknown',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.name;
										},
										data.tmsLoadDetails.carrier)),
								date: $elm$core$Maybe$Nothing,
								sender: '',
								subject: ''
							};
						}
					}()),
				left: $author$project$Components$NonInvoiceConfirmPage$viewLeftSide(
					{
						accountSettings: data.settings,
						actions: {
							primary: {
								event: whenPrimaryEnabled($author$project$Components$NonInvoiceConfirmPage$ClickedApprove),
								label: 'Approve Documents'
							},
							secondary: {
								event: whenEnabled($author$project$Components$NonInvoiceConfirmPage$ClickedContinue),
								label: $author$project$Components$NonInvoiceConfirmPage$continueLabel(model.nextUp)
							}
						},
						addresses: {destination: load.destination, origin: load.origin},
						carrier: data.tmsLoadDetails.carrier,
						customer: data.tmsLoadDetails.customer,
						customerCharge: A2($elm$core$Maybe$map, $author$project$Money$castFromString, load.customerCharge),
						dates: {deliveredAt: load.actualDeliveredAt, shippedAt: load.actualShippedAt},
						documentIds: data.tmsLoadDetails.tmsLoadDetails.documentIds,
						documentIdsRequiringShipments: model.documentIdsRequiringShipments,
						documents: data.tmsLoadDetails.documents,
						exceptions: exceptions,
						expandedShipmentReferences: model.expandedShipmentReferences,
						lineItems: lineItems,
						loadId: load.loadId,
						presence: model.presence,
						references: references,
						selectedDocumentId: model.selectedDocumentId,
						shipmentDocuments: model.shipmentDocuments,
						shipments: data.tmsLoadDetails.shipments,
						status: $author$project$Components$NonInvoiceConfirmPage$statusMessage(model.formState),
						timezone: model.timezone,
						tms: data.account.tms,
						visibleReferenceLabels: data.settings.visibleTMSReferenceFieldLabels
					}),
				right: $author$project$Components$NonInvoiceConfirmPage$viewRightSide(
					{
						viewContent: A2($elm$html$Html$map, $author$project$Components$NonInvoiceConfirmPage$DocumentsBrowserMsg, documentsBrowserWithLoader)
					}),
				secondaryNav: $author$project$Components$NonInvoiceConfirmPage$viewProgressBar(
					{
						links: {
							complete: _List_fromArray(
								[
									{label: 'Assign Carrier', url: $elm$core$Maybe$Nothing},
									{label: 'Identify Documents', url: $elm$core$Maybe$Nothing},
									{label: 'Group Documents', url: $elm$core$Maybe$Nothing},
									{
									label: 'Assign Load',
									url: $elm$core$Maybe$Just(
										A4(
											$author$project$Components$NonInvoiceConfirmPage$assignLoadUrl,
											model.documentBatchId,
											data.documentBatch.documentBatch.emailMessageId,
											model.onDoneParam,
											$author$project$Components$NonInvoiceConfirmPage$getPathContext(data)))
								}
								]),
							current: {label: 'Confirm & Submit', url: $elm$core$Maybe$Nothing},
							next: _List_Nil
						}
					}),
				settings: data.settings
			});
	});
var $author$project$Ui$V3$Stack$flex5 = $author$project$Ui$V3$Stack$Basis('flex-5');
var $author$project$Ui$V3$Stack$flex7 = $author$project$Ui$V3$Stack$Basis('flex-7');
var $author$project$Components$OktaLoginPage$ClickedBackToSignIn = {$: 'ClickedBackToSignIn'};
var $author$project$Components$OktaLoginPage$viewOktaErrorMessageWrapper = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('my-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('okta-form-infobox-error infobox infobox-error'),
						A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon error-16')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]))
					]))
			]));
};
var $author$project$Components$OktaLoginPage$viewLoginError = function (failedReason) {
	var msg = A2(
		$elm$core$String$contains,
		'unauthorized',
		$elm$core$String$toLower(failedReason)) ? 'Account not found.' : 'An error occurred during sign in.  Please try again.';
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$OktaLoginPage$viewOktaErrorMessageWrapper(msg),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('o-form-button-bar')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary mt-2'),
								$elm$html$Html$Events$onClick($author$project$Components$OktaLoginPage$ClickedBackToSignIn)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Back to sign in')
							]))
					]))
			]));
};
var $author$project$Components$OktaLoginPage$viewOktaWidgetFakeWrapper = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('okta-sign-in'),
				$elm$html$Html$Attributes$class('auth-container error-container'),
				$elm$html$Html$Attributes$class('mt-0')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Components$OktaLoginPage$viewForm = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background-color', 'white'),
				A2($elm$html$Html$Attributes$style, 'padding', '4rem')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin', '0 auto'),
						A2($elm$html$Html$Attributes$style, 'max-width', '400px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/assets/TriumphLogoColorNew.svg'),
										A2($elm$html$Html$Attributes$style, 'width', '260px')
									]),
								_List_Nil)
							])),
						function () {
						var _v0 = model.failReason;
						if (_v0.$ === 'Just') {
							var reason = _v0.a;
							return $author$project$Components$OktaLoginPage$viewOktaWidgetFakeWrapper(
								$author$project$Components$OktaLoginPage$viewLoginError(reason));
						} else {
							return A3(
								$elm$html$Html$Keyed$node,
								'div',
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id($author$project$Components$OktaLoginPage$signInWidgetId)
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Components$OktaLoginPage$signInWidgetId,
										$elm$html$Html$text(''))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Ui$V3$Button$LinkTarget = function (a) {
	return {$: 'LinkTarget', a: a};
};
var $author$project$Ui$V3$Button$linkTarget = function (target) {
	return $author$project$Ui$V3$Button$LinkTarget(target);
};
var $author$project$Ui$V3$Stack$PaddingTop = function (a) {
	return {$: 'PaddingTop', a: a};
};
var $author$project$Ui$V3$Stack$paddingTop = A2($elm$core$Basics$composeL, $author$project$Ui$V3$Stack$PaddingAttribute, $author$project$Ui$V3$Stack$PaddingTop);
var $author$project$Components$OktaLoginPage$viewSecurityIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('48'),
			$elm$svg$Svg$Attributes$height('48'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#a)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#F5FAFF'),
							$elm$svg$Svg$Attributes$d('M.833 24c0 17.834 19.306 28.98 34.75 20.063A23.167 23.167 0 0 0 47.168 24c0-17.834-19.306-28.98-34.75-20.063A23.167 23.167 0 0 0 .833 24Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#FCFEFF'),
							$elm$svg$Svg$Attributes$d('m24 4.76 13.066 4.557a2.011 2.011 0 0 1 1.35 1.9v13.992C38.415 34.93 24 40.294 24 40.294S9.585 34.93 9.585 25.21V11.216a2.01 2.01 0 0 1 1.349-1.899L24 4.76Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stroke('#020064'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('.6'),
							$elm$svg$Svg$Attributes$d('m24 4.76 13.066 4.557a2.011 2.011 0 0 1 1.35 1.9v13.992C38.415 34.93 24 40.294 24 40.294S9.585 34.93 9.585 25.21V11.216a2.01 2.01 0 0 1 1.349-1.899L24 4.76Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#CCE8FF'),
							$elm$svg$Svg$Attributes$d('M14.278 21.856c0 7.484 8.102 12.162 14.583 8.42a9.722 9.722 0 0 0 4.861-8.42c0-7.484-8.102-12.161-14.583-8.42a9.722 9.722 0 0 0-4.861 8.42Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stroke('#020064'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('.6'),
							$elm$svg$Svg$Attributes$d('M14.278 21.856c0 7.484 8.102 12.162 14.583 8.42a9.722 9.722 0 0 0 4.861-8.42c0-7.484-8.102-12.161-14.583-8.42a9.722 9.722 0 0 0-4.861 8.42Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#FCFEFF'),
							$elm$svg$Svg$Attributes$d('M19.642 20.18h8.716v8.046h-8.716V20.18Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#FCFEFF'),
							$elm$svg$Svg$Attributes$stroke('#020064'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('.6'),
							$elm$svg$Svg$Attributes$d('M27.688 18.504c.003-2.839-3.068-4.616-5.528-3.2a3.688 3.688 0 0 0-1.848 3.2v1.676h2.012v-1.676a1.676 1.676 0 1 1 3.352 0v1.676h2.012v-1.676Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stroke('#020064'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('.6'),
							$elm$svg$Svg$Attributes$d('M19.642 20.18h8.716v8.046h-8.716V20.18Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#CCE8FF'),
							$elm$svg$Svg$Attributes$stroke('#020064'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round'),
							$elm$svg$Svg$Attributes$strokeWidth('.6'),
							$elm$svg$Svg$Attributes$d('M25.006 23.868a1.006 1.006 0 1 0-1.68.744v.932a.67.67 0 0 0 1.342 0v-.932a.997.997 0 0 0 .338-.744Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#CCE8FF'),
							$elm$svg$Svg$Attributes$d('M15.955 43.915c-.005.774 6.696 1.258 12.062.872 2.495-.18 4.03-.512 4.028-.872.005-.774-6.696-1.258-12.062-.872-2.495.18-4.03.512-4.028.872Z')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('a')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fill('#fff'),
									$elm$svg$Svg$Attributes$d('M0 0h48v48H0z')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Components$OktaLoginPage$viewMarketingContent = function () {
	var learnMoreUrl = 'https://paymentshelp.triumph.io/support/solutions/articles/44002622497-how-to-set-up-multi-factor-authentication-mfa-';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('okta-sign-in-page__marketing-panel')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$styleAsCard,
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
								$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceSmall),
								A2($author$project$Ui$V3$Stack$style, 'width', '30rem')
							]),
						_List_fromArray(
							[
								$author$project$Components$OktaLoginPage$viewSecurityIcon,
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We are enhancing our security')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We are progressively rolling out multi-factor authentication. After deployment, '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('multi-factor authentication')
											])),
										$elm$html$Html$text(' and password complexity guidelines will be required to log in to TriumphPay Audit.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We will be implementing these steps to maintain elevated cyber security best practices and safeguard your payment information.')
									])),
								A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[$author$project$Ui$V3$Stack$mainAxisEnd]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A3(
											$author$project$Ui$V3$Button$view,
											{
												action: A2(
													$author$project$Ui$V3$Button$asLink,
													learnMoreUrl,
													_List_fromArray(
														[
															$author$project$Ui$V3$Button$linkTarget('_blank')
														]))
											},
											_List_fromArray(
												[
													$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
													$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
												]),
											'Learn more'))
									]))
							]))
					]))
			]));
}();
var $author$project$Components$OktaLoginPage$view = F2(
	function (model, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$crossAxisStretch,
									$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray50),
									A2($author$project$Ui$V3$Stack$style, 'min-height', '100vh')
								]),
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex5,
									$author$project$Components$OktaLoginPage$viewForm(model)),
									_Utils_Tuple2($author$project$Ui$V3$Stack$flex7, $author$project$Components$OktaLoginPage$viewMarketingContent)
								]))
						]))
				]));
	});
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$emailDetails = function (documentSource) {
	switch (documentSource.$) {
		case 'FromFactorInvoice':
			var factorInvoice = documentSource.a.factorInvoice;
			var jsonDetails = factorInvoice.documentBatchEmailDetails;
			return {accountExecutive: jsonDetails.carrierAccountExecutive, clientName: jsonDetails.carrierName, date: jsonDetails.date, senderAddress: jsonDetails.senderAddress, subject: jsonDetails.subject};
		case 'FromDocumentBatch':
			var maybeCarrier = documentSource.a.maybeCarrier;
			var maybeEmail = documentSource.a.maybeEmail;
			return {
				accountExecutive: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.acctExec;
					},
					maybeCarrier),
				clientName: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.name;
					},
					maybeCarrier),
				date: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.createdAt;
					},
					maybeEmail),
				senderAddress: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.senderAddress;
					},
					maybeEmail),
				subject: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.subject;
					},
					maybeEmail)
			};
		default:
			var maybeCarrier = documentSource.a.maybeCarrier;
			var email = documentSource.a.email;
			return {
				accountExecutive: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.acctExec;
					},
					maybeCarrier),
				clientName: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.name;
					},
					maybeCarrier),
				date: $elm$core$Maybe$Just(email.createdAt),
				senderAddress: $elm$core$Maybe$Just(email.senderAddress),
				subject: $elm$core$Maybe$Just(email.subject)
			};
	}
};
var $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$factorInvoiceDetails = function (documentSource) {
	switch (documentSource.$) {
		case 'FromFactorInvoice':
			var source = documentSource.a;
			return $elm$core$Maybe$Just(source);
		case 'FromDocumentBatch':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$V3$Stack$PaddingLeft = function (a) {
	return {$: 'PaddingLeft', a: a};
};
var $author$project$Ui$V3$Stack$paddingLeft = function (l) {
	return $author$project$Ui$V3$Stack$PaddingAttribute(
		$author$project$Ui$V3$Stack$PaddingLeft(l));
};
var $author$project$Components$ReadonlyFactorInvoicePage$EmailDetails$view = F2(
	function (tz, details) {
		var viewAccountExec = function (accountExec) {
			return A2($author$project$Ui$V3$Typography$body, _List_Nil, 'Account Exec: ' + accountExec);
		};
		var maybeAccountExec = $elm_community$maybe_extra$Maybe$Extra$isJust(details.clientName) ? $elm$core$Maybe$Just(
			A2($elm$core$Maybe$withDefault, 'Not set for client', details.accountExecutive)) : $elm$core$Maybe$Nothing;
		var formattedTime = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Helpers$Date$timeString(tz),
				details.date));
		var formattedDate = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Helpers$Date$dateString(tz),
				details.date));
		var viewDateAndTime = A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2($author$project$Ui$V3$Typography$body, _List_Nil, formattedDate)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Typography$body,
						_List_fromArray(
							[
								$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray400)
							]),
						formattedTime))
				]));
		var clientName = A2($elm$core$Maybe$withDefault, 'Unknown', details.clientName);
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceSmall),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex2,
					A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								$author$project$Ui$V3$Typography$bodySemiBold(_List_Nil),
								details.subject),
								A2(
								$elm$core$Maybe$map,
								$author$project$Ui$V3$Typography$body(_List_Nil),
								details.senderAddress)
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex3,
					A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_Nil,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(viewDateAndTime),
								$elm$core$Maybe$Just(
								A2($author$project$Ui$V3$Typography$body, _List_Nil, 'Email Client: ' + clientName)),
								A2($elm$core$Maybe$map, viewAccountExec, maybeAccountExec)
							])))
				]));
	});
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$body = function (str) {
	return A2($author$project$Ui$V3$Typography$body, _List_Nil, str);
};
var $author$project$Ui$V3$Checkbox$viewDisabled = F2(
	function (_v0, attributes) {
		var label = _v0.label;
		var checked = _v0.checked;
		return A2(
			$author$project$Ui$V3$Checkbox$viewInternal,
			{checked: checked, label: label, onCheck: $elm$core$Maybe$Nothing},
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Checkbox$disabled(true)
					])));
	});
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$checkbox = F2(
	function (label, checked) {
		return A2(
			$author$project$Ui$V3$Checkbox$viewDisabled,
			{
				checked: checked,
				label: $elm$html$Html$text(label)
			},
			_List_Nil);
	});
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$heading = function (str) {
	return A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$notesCodeBlock = function (notes) {
	return A2(
		$elm$html$Html$code,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
				A2($elm$html$Html$Attributes$style, 'max-height', '100px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(notes)
			]));
};
var $author$project$Ui$V3$Chip$Filled = function (a) {
	return {$: 'Filled', a: a};
};
var $author$project$Ui$V3$Colors$Red600 = {$: 'Red600'};
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$disabledIgnoreButton = function (label) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rules__ignore-button'),
				$elm$html$Html$Attributes$class('rules__ignore-button--disabled'),
				$elm$html$Html$Attributes$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Ui$V3$Helpers$Html$showIf = F2(
	function (flag, view_) {
		return flag ? view_ : $author$project$Ui$V3$Helpers$Html$empty;
	});
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$viewExceptionDetailRow = F3(
	function (factorInvoice, exception, el) {
		var resolutionMessage = function () {
			var _v0 = exception.possibleResolutionMessage;
			if (_v0.$ === 'Nothing') {
				return $author$project$Ui$V3$Helpers$Html$empty;
			} else {
				var message = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Helpers$String$nbsp + ('Resolution Message: ' + message))
						]));
			}
		}();
		var invoiceEditable = $author$project$Domain$FactorInvoice$editable(factorInvoice.state);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rules__item'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rules__item-text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text', true),
											_Utils_Tuple2('rules__ignored', el.ignored)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(exception.formattedMessage)
								])),
							resolutionMessage
						])),
					A2(
					$author$project$Ui$V3$Helpers$Html$showIf,
					invoiceEditable,
					$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$disabledIgnoreButton(el.text))
				]));
	});
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$viewException = F2(
	function (factorInvoice, exception) {
		return A3(
			$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$viewExceptionDetailRow,
			factorInvoice,
			exception,
			function () {
				var _v0 = exception.data;
				switch (_v0.$) {
					case 'Required':
						return {ignored: false, text: 'Required'};
					case 'Resolvable':
						if (_v0.a.a.$ === 'Enabled') {
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							return {ignored: false, text: 'Resolve'};
						} else {
							var _v3 = _v0.a;
							var _v4 = _v3.a;
							return {ignored: true, text: 'Resolved'};
						}
					default:
						if (_v0.a.a.$ === 'Enabled') {
							var _v5 = _v0.a;
							var _v6 = _v5.a;
							return {ignored: false, text: 'Ignore'};
						} else {
							var _v7 = _v0.a;
							var _v8 = _v7.a;
							return {ignored: true, text: 'Enable'};
						}
				}
			}());
	});
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$viewExceptionsRow = F2(
	function (factorInvoice, exceptions) {
		var exceptionCountChip = function (count) {
			return A2(
				$author$project$Ui$V3$Chip$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$Chip$Filled(true),
						A2(
						$author$project$Ui$V3$Chip$Style,
						'background',
						$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Red600)),
						A2($author$project$Ui$V3$Chip$Style, 'border', 'none')
					]),
				$elm$core$String$fromInt(count));
		};
		var exceptionsHeading = A2(
			$author$project$Ui$V3$Stack$viewVertWithHeights,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$paddingBottom($author$project$Ui$V3$Stack$spaceXSmall),
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$heading('Exceptions')),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								exceptionCountChip(
									$elm$core$List$length(exceptions)))
							]))),
					_Utils_Tuple2($author$project$Ui$V3$Stack$divider, $author$project$Ui$V3$Helpers$Html$empty)
				]));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				exceptionsHeading,
				A2(
					$elm$core$List$map,
					$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$viewException(factorInvoice),
					exceptions)));
	});
var $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$view = F2(
	function (accountSettings, _v0) {
		var exceptions = _v0.exceptions;
		var debtorPaymentAddress = _v0.debtorPaymentAddress;
		var debtor = _v0.debtor;
		var factorInvoice = _v0.factorInvoice;
		var twoColumnRow = F2(
			function (leftChildren, rightChildren) {
				return A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Stack$viewVertMaybes, _List_Nil, leftChildren),
							A2($author$project$Ui$V3$Stack$viewVertMaybes, _List_Nil, rightChildren)
						]));
			});
		var singleItemRow = F2(
			function (label, value) {
				return A2(
					twoColumnRow,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$heading(label))
						]),
					_List_fromArray(
						[
							A2($elm$core$Maybe$map, $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$body, value)
						]));
			});
		var mustVerifyCheckbox = accountSettings.verificationsWorkflowEnabled ? $elm$core$Maybe$Just(
			A2($author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$checkbox, 'Must be verified', factorInvoice.mustVerify)) : $elm$core$Maybe$Nothing;
		var maybeExceptionsRow = $elm$core$List$isEmpty(exceptions) ? $author$project$Ui$V3$Helpers$Html$empty : A2($author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$viewExceptionsRow, factorInvoice, exceptions);
		var invoiceNotes = A2($elm$core$Maybe$andThen, $elm_community$string_extra$String$Extra$nonBlank, factorInvoice.notes);
		var invoiceNotesRow = A2(
			twoColumnRow,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$heading('Notes'))
				]),
			_List_fromArray(
				[
					A2($elm$core$Maybe$map, $author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$notesCodeBlock, invoiceNotes)
				]));
		var flagsRow = A2(
			twoColumnRow,
			_List_Nil,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$checkbox, 'Fuel Advance', factorInvoice.fuelAdvance)),
					$elm$core$Maybe$Just(
					A2($author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$checkbox, 'TONU', factorInvoice.tonu)),
					mustVerifyCheckbox
				]));
		var debtorDetailsRow = A2(
			twoColumnRow,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$heading('Debtor')),
					A2($elm$core$Maybe$map, $author$project$Components$DebtorDetails$viewIdentity, debtor)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$body('Debtor Details')),
					A2($elm$core$Maybe$map, $author$project$Components$DebtorDetails$viewAddress, debtorPaymentAddress),
					A2($elm$core$Maybe$map, $author$project$Components$DebtorDetails$viewContact, debtor)
				]));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceSmall),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					maybeExceptionsRow,
					debtorDetailsRow,
					A2(singleItemRow, 'Load ID', factorInvoice.loadId),
					A2(singleItemRow, 'Invoice Number', factorInvoice.invoiceNumber),
					A2(
					singleItemRow,
					'Amount',
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return '$' + a;
						},
						factorInvoice.formattedAmount)),
					flagsRow,
					A2(singleItemRow, 'Origin', factorInvoice.origin),
					A2(singleItemRow, 'Destination', factorInvoice.destination),
					invoiceNotesRow
				]));
	});
var $author$project$Components$ReadonlyFactorInvoicePage$view = F3(
	function (tz, remoteData, model) {
		var viewWhiteBackgroundInset = function (_v1) {
			var rightPane = _v1.rightPane;
			var leftPane = _v1.leftPane;
			return A2(
				$author$project$Ui$V3$Stack$viewVertWithHeights,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
						A2($author$project$Ui$V3$Stack$borderSolid, 2, $author$project$Ui$V3$Colors$Gray400)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$author$project$Components$ReadonlyFactorInvoicePage$EmailDetails$view,
							tz,
							$author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$emailDetails(model.documentSource))),
						_Utils_Tuple2($author$project$Ui$V3$Stack$divider, $author$project$Ui$V3$Helpers$Html$empty),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$author$project$Ui$V3$Stack$viewHorz,
							_List_Nil,
							_List_fromArray(
								[leftPane, rightPane])))
					]));
		};
		var getSelectedLazyFactorInvoice = function (data) {
			return A2(
				$elm$core$Maybe$andThen,
				function (k) {
					return A2($elm$core$Dict$get, k, data.factorInvoicesByGroupId);
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Domain$DocumentGroupId$toInt,
					$author$project$Components$DocumentsBrowser$selectedDocumentGroupId(model.documentsBrowser)));
		};
		var selectedLazyFactorInvoice = function () {
			var handleMissingInvoiceForGroupId = function (mrm) {
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Forward$Remote$Loaded($elm$core$Maybe$Nothing),
					mrm);
			};
			return A2(
				$author$project$Forward$Remote$andThen,
				handleMissingInvoiceForGroupId,
				A2($author$project$Forward$Remote$map, getSelectedLazyFactorInvoice, remoteData));
		}();
		var viewExtractedValues = function () {
			var viewDetails = function (details) {
				return A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					A2($author$project$Components$ReadonlyFactorInvoicePage$FactorInvoiceDetails$view, model.accountSettings, details));
			};
			var _v0 = $author$project$Components$ReadonlyFactorInvoicePage$DocumentSource$factorInvoiceDetails(model.documentSource);
			if (_v0.$ === 'Just') {
				var directFactorInvoiceDetails = _v0.a;
				return viewDetails(directFactorInvoiceDetails);
			} else {
				return A2(
					$author$project$Forward$LoadingView$viewV3Reskin,
					A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Ui$V3$Helpers$Html$empty, viewDetails),
					selectedLazyFactorInvoice);
			}
		}();
		var forceMarginForToolbarCss = '\u000A            .enable_shared-ui-v3 .document-browser__document-list {\u000A                margin-top: 37px;\u000A            }\u000A            ';
		var viewDocumentsBrowser = function (documentsBrowserData) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$html$Html$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(forceMarginForToolbarCss)
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Components$ReadonlyFactorInvoicePage$DocumentsBrowserMsg,
						A4($author$project$Components$DocumentsBrowser$view, tz, model.documentsBrowser, _List_Nil, documentsBrowserData))
					]));
		};
		var viewDocumentsBrowserLoading = A2(
			$author$project$Forward$LoadingView$viewV3Reskin,
			viewDocumentsBrowser,
			A2(
				$author$project$Forward$Remote$map,
				function ($) {
					return $.documentsBrowserData;
				},
				remoteData));
		var backgroundMargin = A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$paddingLeft($author$project$Ui$V3$Stack$spaceXXLarge)
				]),
			_List_Nil);
		return $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$Ui$V3$Stack$fit, backgroundMargin),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						viewWhiteBackgroundInset(
							{leftPane: viewExtractedValues, rightPane: viewDocumentsBrowserLoading})),
						_Utils_Tuple2($author$project$Ui$V3$Stack$fit, backgroundMargin)
					])));
	});
var $author$project$Components$SettingsPage$Shared$Section$Carriers = {$: 'Carriers'};
var $author$project$Components$SettingsPage$Shared$Section$Customers = {$: 'Customers'};
var $author$project$Components$SettingsPage$Shared$Section$ReferenceFields = {$: 'ReferenceFields'};
var $author$project$Components$SettingsPage$Shared$Section$Reports = {$: 'Reports'};
var $author$project$Components$SettingsPage$Shared$Section$Rules = {$: 'Rules'};
var $author$project$Components$SettingsPage$Shared$Section$Users = {$: 'Users'};
var $author$project$Components$SettingsPage$Shared$Section$Verifications = {$: 'Verifications'};
var $author$project$Components$SettingsPage$Shared$Section$SectionDetails = F2(
	function (label, path) {
		return {label: label, path: path};
	});
var $author$project$Components$SettingsPage$Shared$Section$sectionDetails = F3(
	function (v3ReskinEnabled, _v0, section) {
		var staticSectionDetails = F2(
			function (label, path) {
				return A2(
					$author$project$Components$SettingsPage$Shared$Section$SectionDetails,
					$elm$core$Basics$always(label),
					path);
			});
		switch (section.$) {
			case 'Account':
				return A2(staticSectionDetails, 'Account', 'account');
			case 'Carriers':
				return A2(
					$author$project$Components$SettingsPage$Shared$Section$SectionDetails,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Domain$Account$carrierTerm,
						$author$project$Helpers$String$appendToEnd('s')),
					'carriers');
			case 'CarrierDocuments':
				return A2(staticSectionDetails, 'Do Not Display', '');
			case 'Customers':
				return A2(staticSectionDetails, 'Customers', 'customers');
			case 'Contacts':
				return A2(staticSectionDetails, 'Contacts', 'contacts');
			case 'Debtors':
				return A2(staticSectionDetails, 'Debtors', 'debtors');
			case 'FactorClientPortal':
				return A2(
					staticSectionDetails,
					v3ReskinEnabled ? 'Client portal' : 'Client Portal',
					'client_portal');
			case 'DocumentTypes':
				return A2(
					staticSectionDetails,
					v3ReskinEnabled ? 'Document types' : 'Document Types',
					'document_types');
			case 'Integrations':
				return A2(staticSectionDetails, 'Integrations', 'integrations');
			case 'Rules':
				return A2(staticSectionDetails, 'Rules', 'rules');
			case 'Reports':
				return A2(staticSectionDetails, 'Reports', 'reports');
			case 'Users':
				return A2(staticSectionDetails, 'Users', 'users');
			case 'Verifications':
				return A2(staticSectionDetails, 'Verifications', 'verifications');
			case 'Exceptions':
				return A2(staticSectionDetails, 'Exceptions', 'exceptions');
			case 'NextGenAudit':
				return A2(staticSectionDetails, 'NextGen Audit', 'next_gen_audit');
			case 'ReferenceFields':
				return A2(staticSectionDetails, 'Reference fields', 'reference_fields');
			case 'ScraperStatus':
				return A2(staticSectionDetails, 'Scraper Status', 'scraper_status');
			default:
				return A2(staticSectionDetails, 'POD definition', 'pod_definition');
		}
	});
var $author$project$Components$SettingsPage$Shared$Section$tabView = F5(
	function (v3ReskinEnabled, accountType, accountSettings, currentSection, section) {
		var classes = $elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'active',
					_Utils_eq(currentSection, section))
				]));
		var _v0 = A3($author$project$Components$SettingsPage$Shared$Section$sectionDetails, v3ReskinEnabled, accountSettings, section);
		var path = _v0.path;
		var label = _v0.label;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[classes]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/app/settings/' + path)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							label(accountType))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$Section$tabViewReskin = F5(
	function (v3ReskinEnabled, accountType, accountSettings, currentSection, section) {
		var active = _Utils_eq(currentSection, section);
		var activeNotch = active ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'top', '8px'),
					A2($elm$html$Html$Attributes$style, 'left', '8px'),
					A2($elm$html$Html$Attributes$style, 'width', '3px'),
					A2($elm$html$Html$Attributes$style, 'height', '26px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '3px'),
					$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Teal600)
				]),
			_List_Nil) : $author$project$Helpers$Html$empty;
		var _v0 = A3($author$project$Components$SettingsPage$Shared$Section$sectionDetails, v3ReskinEnabled, accountSettings, section);
		var path = _v0.path;
		var label = _v0.label;
		return A2(
			$author$project$Ui$V3$Stack$viewHorz,
			active ? _List_fromArray(
				[
					$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
					A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px')
				]) : _List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$backgroundColorOnHover($author$project$Ui$V3$Colors$Gray0),
							A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px'),
							$author$project$Ui$V3$Stack$class('v3__type__h5')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3_sidebar__link'),
									A2($elm$html$Html$Attributes$style, 'padding', '12px 16px'),
									A2($elm$html$Html$Attributes$style, 'position', 'relative'),
									$elm$html$Html$Attributes$href('/app/settings/' + path),
									$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
								]),
							_List_fromArray(
								[
									activeNotch,
									$elm$html$Html$text(
									label(accountType))
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$Section$sidebar = F5(
	function (v3ReskinEnabled, currentSection, currentAccount, accountSettings, currentUser) {
		var scraperStatusEnabled = currentAccount.scraperAccount && (currentUser.isAdmin && accountSettings.scraperStatusEnabled);
		var podDefinitionEnabled = accountSettings.podDefinitionModuleEnabled && ((!currentAccount.factorAccount) && v3ReskinEnabled);
		var factorNextGenAuditEnabled = currentAccount.factorAccount && (accountSettings.factorNextGenAuditEnabled && currentUser.isAdmin);
		var accountType = $author$project$Domain$Account$accountType(currentAccount);
		var sortByLabel = function (section) {
			return A3($author$project$Components$SettingsPage$Shared$Section$sectionDetails, v3ReskinEnabled, accountSettings, section.a).label(accountType);
		};
		var sections = A2(
			$elm$core$List$sortBy,
			sortByLabel,
			_List_fromArray(
				[
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Account, true),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Exceptions, true),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Carriers, true),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Contacts, true),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$NextGenAudit, factorNextGenAuditEnabled),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Customers, !currentAccount.factorAccount),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Debtors, currentAccount.factorAccount),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$DocumentTypes, currentUser.isAdmin),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Integrations, currentAccount.factorAccount),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Reports, true),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Rules, (!currentAccount.factorAccount) && currentUser.isAdmin),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$FactorClientPortal, currentAccount.factorAccount && currentUser.isAdmin),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Users, currentUser.isAdmin),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$Verifications, currentAccount.factorAccount),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$ReferenceFields, currentAccount.payablesAccount && (v3ReskinEnabled && (!accountSettings.disableReorderTMSReferenceFields))),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$ScraperStatus, scraperStatusEnabled),
					_Utils_Tuple2($author$project$Components$SettingsPage$Shared$Section$PodDefinition, podDefinitionEnabled)
				]));
		return v3ReskinEnabled ? _List_fromArray(
			[
				$author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorz,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$paddingLeft($author$project$Ui$V3$Stack$spaceXSmall)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Settings')
										]))
								])),
							A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A4($author$project$Components$SettingsPage$Shared$Section$tabViewReskin, v3ReskinEnabled, accountType, accountSettings, currentSection),
								A2(
									$elm$core$List$map,
									$elm$core$Tuple$first,
									A2($elm$core$List$filter, $elm$core$Tuple$second, sections))))
						])))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Settings')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav settings__nav')
					]),
				A2(
					$elm$core$List$map,
					A4($author$project$Components$SettingsPage$Shared$Section$tabView, v3ReskinEnabled, accountType, accountSettings, currentSection),
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						A2($elm$core$List$filter, $elm$core$Tuple$second, sections))))
			]);
	});
var $author$project$Components$SettingsPage$Shared$Section$frameView = F6(
	function (v3ReskinEnabled, currentSection, currentAccount, accountSettings, currentUser, inner) {
		var v3ReskinSidebarAttrs = v3ReskinEnabled ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
				A2($elm$html$Html$Attributes$style, 'top', '24px'),
				A2($elm$html$Html$Attributes$style, 'padding', '0 16px')
			]) : _List_Nil;
		var v3ReskinAttrs = v3ReskinEnabled ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background', 'transparent'),
				A2($elm$html$Html$Attributes$style, 'border', '0'),
				A2($elm$html$Html$Attributes$style, 'padding-top', '48px'),
				A2($elm$html$Html$Attributes$style, 'padding-bottom', '80px')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('general-container row'),
				v3ReskinAttrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row settings')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('small-2 column'),
										v3ReskinSidebarAttrs),
									A5($author$project$Components$SettingsPage$Shared$Section$sidebar, v3ReskinEnabled, currentSection, currentAccount, accountSettings, currentUser)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-8 column')
										]),
									_List_fromArray(
										[inner]))
								]))
						]))
				]));
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$errorView = function (error) {
	var description = function () {
		if (error.$ === 'Unloadable') {
			var reason = error.a;
			return {debug: $elm$core$Maybe$Nothing, reason: reason};
		} else {
			var err = error.a;
			return {
				debug: $elm$core$Maybe$Just(err.json),
				reason: 'Could not parse data from server.\u000A\u000A' + err.decoderMessage
			};
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('small-10 column')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Error: ' + description.reason),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'none')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', description.debug))
					]))
			]));
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$DocumentBrowserMsg = function (a) {
	return {$: 'DocumentBrowserMsg', a: a};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$FiltersViewMsg = function (a) {
	return {$: 'FiltersViewMsg', a: a};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$ClearErrorMessage = {$: 'ClearErrorMessage'};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$errorMessage = function (model) {
	var _v0 = model.errorMessage;
	if (_v0.$ === 'Nothing') {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		var message = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert-box alert')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(message),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('close'),
							$elm$html$Html$Events$onClick($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$ClearErrorMessage)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('✕')
						]))
				]));
	}
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$SelectDocumentType = function (a) {
	return {$: 'SelectDocumentType', a: a};
};
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$uploadTypeOption = F4(
	function (model, account, accountSettings, documentType) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Encode$DocumentTypeEncoder$documentTypeString(documentType)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						$author$project$Encode$DocumentTypeEncoder$documentTypeString(documentType),
						model.selectedDocumentType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Domain$Helpers$documentTypeToString, account, accountSettings, documentType))
				]));
	});
var $author$project$Helpers$With$with3 = F4(
	function (a, b, c, f) {
		return A3(f, a, b, c);
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$documentTypeForm = F3(
	function (documentTypes, model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-5 column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$on,
							'change',
							A2($elm$json$Json$Decode$map, $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$SelectDocumentType, $elm$html$Html$Events$targetValue))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(''),
									$elm$html$Html$Attributes$disabled(
									$elm$core$String$length(model.selectedDocumentType) > 0)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Select Document Type To Upload')
								])),
						A2(
							$elm$core$List$map,
							A4($author$project$Helpers$With$with3, model, data.currentAccount, data.accountSettings, $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$uploadTypeOption),
							documentTypes)))
				]));
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$uploadArea = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row carrier-documents__upload-area')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$documentTypeForm, data.carrierDocumentTypes, model, data),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-2')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('hubtran-file-drop')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('hubtran-upload-progress-bar')
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$uploadMessage = function (model) {
	return model.fileUploaded ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('alert-box--progress')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('File uploaded!')
			])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$HideDeleteConfirmation = {$: 'HideDeleteConfirmation'};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$DeleteDocument = function (a) {
	return {$: 'DeleteDocument', a: a};
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$confirmDeleteModalConfig = F2(
	function (documentId, deletingDocument) {
		return {
			body: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Are you sure you want to delete this document?')
					])),
			confirm: $elm$core$Maybe$Just(
				{
					msg: $author$project$Components$CarrierDocumentsView$DocumentsListView$DeleteDocument(documentId),
					text: 'Delete'
				}),
			dismissText: $elm$core$Maybe$Just('Cancel'),
			header: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Confirm Delete')
								]))
						]))),
			modalClassOverride: $elm$core$Maybe$Nothing,
			performing: deletingDocument,
			performingText: $elm$core$Maybe$Just('Deleting...'),
			success: false,
			successText: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$confirmDeleteModalOrEmpty = F2(
	function (maybeDocumentId, deletingDocument) {
		if (maybeDocumentId.$ === 'Just') {
			var documentId = maybeDocumentId.a;
			return A2(
				$author$project$Components$Shared$ModalDialog$view,
				$author$project$Components$CarrierDocumentsView$DocumentsListView$HideDeleteConfirmation,
				A2($author$project$Components$CarrierDocumentsView$DocumentsListView$confirmDeleteModalConfig, documentId, deletingDocument));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$ShowDeleteConfirmation = function (a) {
	return {$: 'ShowDeleteConfirmation', a: a};
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$documentDeleteLink = function (document) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carrier-documents__action')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-trash'),
						$elm$html$Html$Events$onClick(
						$author$project$Components$CarrierDocumentsView$DocumentsListView$ShowDeleteConfirmation(document.id)),
						$elm$html$Html$Attributes$title('Delete')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$documentDownloadLink = function (document) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(document.inlineDownloadUrl),
				$elm$html$Html$Attributes$target('blank'),
				$elm$html$Html$Attributes$class('carrier-documents__action')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-download'),
						$elm$html$Html$Attributes$title('Download')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$PreviewDocumentSelected = function (a) {
	return {$: 'PreviewDocumentSelected', a: a};
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$possibleDocumentPreviewLink = function (document) {
	return document.previewable ? A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carrier-documents__action')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-eye'),
						$elm$html$Html$Events$onClick(
						$author$project$Components$CarrierDocumentsView$DocumentsListView$PreviewDocumentSelected(document.id)),
						$elm$html$Html$Attributes$title('Preview')
					]),
				_List_Nil)
			])) : $elm$html$Html$text('');
};
var $author$project$Components$CarrierDocumentsView$DocumentsListView$rowView = F3(
	function (tz, data, document) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3(
								$author$project$Domain$Helpers$documentTypeToString,
								data.currentAccount,
								data.accountSettings,
								$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Helpers$Date$toString, tz, document.createdAt))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$CarrierDocumentsView$DocumentsListView$documentDownloadLink(document),
							$author$project$Components$CarrierDocumentsView$DocumentsListView$possibleDocumentPreviewLink(document),
							$author$project$Components$CarrierDocumentsView$DocumentsListView$documentDeleteLink(document)
						]))
				]));
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$tableBody = F3(
	function (tz, data, documents) {
		return $elm$core$List$isEmpty(documents) ? A2(
			$elm$html$Html$tbody,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No Documents Available')
				])) : A2(
			$elm$html$Html$tbody,
			_List_Nil,
			A2(
				$elm$core$List$map,
				A2($author$project$Components$CarrierDocumentsView$DocumentsListView$rowView, tz, data),
				documents));
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$documentTable = F3(
	function (tz, data, documents) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carrier-documents__uploads-table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Document Type')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Upload Date/Time')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Actions')
										]))
								]))
						])),
					A3($author$project$Components$CarrierDocumentsView$DocumentsListView$tableBody, tz, data, documents)
				]));
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$filteredDocuments = F2(
	function (filterDocumentType, documents) {
		if (filterDocumentType.$ === 'Nothing') {
			return documents;
		} else {
			var documentType = filterDocumentType.a;
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(documentType),
						$author$project$Domain$Document$documentTypeValueToUnresolved),
					function ($) {
						return $.documentTypeValue;
					}),
				documents);
		}
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$loadedView = F4(
	function (tz, filterDocumentType, model, data) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Components$CarrierDocumentsView$DocumentsListView$documentTable,
					tz,
					data,
					A2($author$project$Components$CarrierDocumentsView$DocumentsListView$filteredDocuments, filterDocumentType, data.documents)),
					A2($author$project$Components$CarrierDocumentsView$DocumentsListView$confirmDeleteModalOrEmpty, model.confirmDeleteDocumentId, model.deletingDocument)
				]));
	});
var $author$project$Components$CarrierDocumentsView$DocumentsListView$view = F4(
	function (tz, filterDocumentType, data, model) {
		return A2(
			$author$project$Forward$LoadingView$view,
			A3($author$project$Components$CarrierDocumentsView$DocumentsListView$loadedView, tz, filterDocumentType, model),
			data);
	});
var $author$project$Components$CarrierDocumentsView$FiltersView$DocumentTypeSelected = function (a) {
	return {$: 'DocumentTypeSelected', a: a};
};
var $author$project$Components$CarrierDocumentsView$FiltersView$filterOption = F3(
	function (account, accountSettings, documentType) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Encode$DocumentTypeEncoder$documentTypeString(documentType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Domain$Helpers$documentTypeToString, account, accountSettings, documentType))
				]));
	});
var $author$project$Components$CarrierDocumentsView$FiltersView$nbsp = '\u00A0';
var $author$project$Components$CarrierDocumentsView$FiltersView$view = F2(
	function (config, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carrier-documents__document-type-filter')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('carrier-documents__document-type-filter__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Document' + ($author$project$Components$CarrierDocumentsView$FiltersView$nbsp + 'Type:'))
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('carrier-documents__document-type-filter__select'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							A2($elm$json$Json$Decode$map, $author$project$Components$CarrierDocumentsView$FiltersView$DocumentTypeSelected, $elm$html$Html$Events$targetValue))
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No Filter Selected')
								])),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$CarrierDocumentsView$FiltersView$filterOption, config.currentAccount, config.accountSettings),
							config.carrierDocumentTypes)))
				]));
	});
var $author$project$Components$DocumentBrowser$NoOp = {$: 'NoOp'};
var $author$project$Components$DocumentBrowser$SelectDocumentPage = function (a) {
	return {$: 'SelectDocumentPage', a: a};
};
var $author$project$Components$DocumentBrowser$loadedView = F2(
	function (model, data) {
		return $author$project$Components$DocumentBrowser$Full$view(
			{
				account: data.currentAccount,
				accountSettings: data.accountSettings,
				addressAnswers: $elm$core$Dict$empty,
				annotationOverlay: $elm$core$Maybe$Nothing,
				documentIsPodUpdates: $author$project$Helpers$DocumentIsPodUpdates$empty,
				documents: $author$project$Components$DocumentBrowser$Full$UngroupedDocuments(
					A2(
						$author$project$Components$DocumentBrowser$Full$DocumentData,
						A2($elm$core$List$map, $elm$core$Tuple$first, data.documents),
						A2($elm$core$List$map, $elm$core$Tuple$second, data.documents))),
				dragScrollAttributes: _List_Nil,
				emailMessageDataList: $elm$core$Maybe$Nothing,
				fullImage: false,
				groupStatusTag: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				groupThumbnailsByDocumentBatch: false,
				highlight: $elm$core$Maybe$Nothing,
				lineDragAttributes: $elm$core$Basics$always(_List_Nil),
				lines: $elm$core$Dict$empty,
				onRightClick: $elm$core$Maybe$Nothing,
				onSelect: $author$project$Components$DocumentBrowser$SelectDocumentPage,
				onSelectGroup: $elm$core$Maybe$Nothing,
				onSelectedGroupRendered: $elm$core$Maybe$Nothing,
				onViewEmailClick: $elm$core$Maybe$Nothing,
				overlay: $elm$core$Maybe$Nothing,
				pageImage: $author$project$Components$DocumentBrowser$PageImage$Annotated,
				popout: false,
				relatedDocuments: $elm$core$Maybe$Nothing,
				restrictHeight: true,
				scrollContainerSuffix: 'standalone',
				secondary: $elm$core$Maybe$Nothing,
				selection: model.selection,
				setLineSelection: $elm$core$Basics$always($author$project$Components$DocumentBrowser$NoOp),
				viewAddDocumentToLoadButton: $elm$html$Html$text(''),
				viewMode: $elm$core$Maybe$Nothing,
				zoomLevel: 1.0
			});
	});
var $author$project$Components$DocumentBrowser$view = F2(
	function (data, model) {
		return A2(
			$author$project$Forward$LoadingView$view,
			$author$project$Components$DocumentBrowser$loadedView(model),
			data);
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$authorizedView = F3(
	function (tz, model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-5 column')
						]),
					_List_fromArray(
						[
							$author$project$Components$CarrierDocumentsView$CarrierDocumentsView$errorMessage(model),
							$author$project$Components$CarrierDocumentsView$CarrierDocumentsView$uploadMessage(model),
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Document Uploads')
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$CarrierDocumentsView$CarrierDocumentsView$FiltersViewMsg,
							A2(
								$author$project$Components$CarrierDocumentsView$FiltersView$view,
								{accountSettings: data.accountSettings, carrierDocumentTypes: data.carrierDocumentTypes, currentAccount: data.currentAccount},
								model.filtersView)),
							A2(
							$elm$html$Html$map,
							$author$project$Components$CarrierDocumentsView$CarrierDocumentsView$DocumentsListViewMsg,
							A4($author$project$Components$CarrierDocumentsView$DocumentsListView$view, tz, model.filtersView.selectedDocumentType, data.documentsListView, model.documentsListView)),
							A2($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$uploadArea, model, data)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-5 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Preview')
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$CarrierDocumentsView$CarrierDocumentsView$DocumentBrowserMsg,
							A2($author$project$Components$DocumentBrowser$view, data.documentBrowser, model.documentBrowser))
						]))
				]));
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$loadedView = F3(
	function (tz, model, data) {
		return data.currentUser.hasSettingsRole ? A3($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$authorizedView, tz, model, data) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$loadingView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('small-10 column')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Loading ...')
		]));
var $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$view = F3(
	function (tz, data, model) {
		switch (data.$) {
			case 'Loaded':
				var data_ = data.a;
				return A2(
					$author$project$Helpers$WaitingSpinner$waitingSpinner,
					model.saving,
					_List_fromArray(
						[
							A3($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$loadedView, tz, model, data_)
						]));
			case 'Loading':
				return $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$loadingView;
			default:
				var error = data.a;
				return $author$project$Components$CarrierDocumentsView$CarrierDocumentsView$errorView(error);
		}
	});
var $author$project$Components$SettingsPage$AccountSettingsView$CarrierPaymentsMsg = function (a) {
	return {$: 'CarrierPaymentsMsg', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ClientNotesConfigurationMsg = function (a) {
	return {$: 'ClientNotesConfigurationMsg', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ExceptionOldInvoicesAfterChange = function (a) {
	return {$: 'ExceptionOldInvoicesAfterChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$FailedCadenceTransmissionChange = function (a) {
	return {$: 'FailedCadenceTransmissionChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$InvoiceSettingsMsg = function (a) {
	return {$: 'InvoiceSettingsMsg', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$InvoiceToleranceSettingsMsg = function (a) {
	return {$: 'InvoiceToleranceSettingsMsg', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ReorderTmsReferenceFieldLabel = F2(
	function (a, b) {
		return {$: 'ReorderTmsReferenceFieldLabel', a: a, b: b};
	});
var $author$project$Components$SettingsPage$AccountSettingsView$SelectTmsReferenceFieldLabel = function (a) {
	return {$: 'SelectTmsReferenceFieldLabel', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$UnselectTmsReferenceFieldLabel = function (a) {
	return {$: 'UnselectTmsReferenceFieldLabel', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$afterLoad = F2(
	function (f, x) {
		return $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg(
			f(x));
	});
var $author$project$Ui$between1 = function (config) {
	return _Utils_update(
		config,
		{between: 1});
};
var $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE = $author$project$Ui$Ui;
var $author$project$Ui$heading1 = function (headingText) {
	return A2(
		$author$project$Ui$heading,
		'1',
		_List_fromArray(
			[
				$elm$html$Html$text(headingText)
			]));
};
var $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateCarrierDaysToPay = function (a) {
	return {$: 'UpdateCarrierDaysToPay', a: a};
};
var $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateQuickpayDiscount = function (a) {
	return {$: 'UpdateQuickpayDiscount', a: a};
};
var $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateQuickpayDiscountDisabled = function (a) {
	return {$: 'UpdateQuickpayDiscountDisabled', a: a};
};
var $author$project$Components$Shared$Grid$autoRowEnd = F2(
	function (columnLength, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Shared$Grid$endColumn(columnLength),
					$elm$core$List$singleton),
				children));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$Components$SettingsPage$Account$CarrierPayments$paymentTermsView = F2(
	function (carrierDaysToPay, onChange) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Payment Terms')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row collapse')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-2 column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$required(true),
											$elm$html$Html$Attributes$type_('number'),
											$elm$html$Html$Attributes$class('validatingFormField'),
											$elm$html$Html$Attributes$min('0'),
											$elm$html$Html$Attributes$value(carrierDaysToPay),
											$elm$html$Html$Events$onInput(onChange)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-1 column end')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('postfix')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('days')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Account$CarrierPayments$quickpayDiscountDisabledView = F2(
	function (quickpayDiscountDisabled, onChange) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Disable Quickpay Discount')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$required(false),
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Events$onCheck(onChange),
							$elm$html$Html$Attributes$checked(quickpayDiscountDisabled)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$Account$CarrierPayments$quickpayDiscountView = F3(
	function (disabled_, quickpayDiscount, onChange) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Quickpay Discount')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row collapse')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-2 column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$required(false),
											$elm$html$Html$Attributes$type_('number'),
											$elm$html$Html$Attributes$min('0'),
											$elm$html$Html$Attributes$max('100'),
											$elm$html$Html$Attributes$class('validatingFormField'),
											$elm$html$Html$Attributes$value(
											disabled_ ? '' : quickpayDiscount),
											$elm$html$Html$Events$onInput(onChange),
											$elm$html$Html$Attributes$disabled(disabled_)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-1 column end')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('postfix')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('%')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Account$CarrierPayments$view = F2(
	function (mapMsg, model) {
		return $author$project$Ui$toHtml(
			A2(
				$author$project$Ui$stack,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
						A2(
							$author$project$Components$Shared$Grid$autoRowEnd,
							5,
							_List_fromArray(
								[
									A2(
									$author$project$Components$SettingsPage$Account$CarrierPayments$paymentTermsView,
									$author$project$Experimental$FormField$value(model.carrierDaysToPay),
									A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateCarrierDaysToPay, mapMsg))
								]))),
						$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
						A2(
							$author$project$Components$Shared$Grid$autoRowEnd,
							5,
							_List_fromArray(
								[
									A3(
									$author$project$Components$SettingsPage$Account$CarrierPayments$quickpayDiscountView,
									$author$project$Experimental$FormField$value(model.quickpayDiscountDisabled),
									$author$project$Experimental$FormField$value(model.quickpayDiscount),
									A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateQuickpayDiscount, mapMsg))
								]))),
						$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
						A2(
							$author$project$Components$Shared$Grid$autoRowEnd,
							5,
							_List_fromArray(
								[
									A2(
									$author$project$Components$SettingsPage$Account$CarrierPayments$quickpayDiscountDisabledView,
									$author$project$Experimental$FormField$value(model.quickpayDiscountDisabled),
									A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateQuickpayDiscountDisabled, mapMsg))
								])))
					])));
	});
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$SetDisplay = F2(
	function (a, b) {
		return {$: 'SetDisplay', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$displayOptions = _List_fromArray(
	[
		_Utils_Tuple2('expanded', 'Show Expanded'),
		_Utils_Tuple2('closed', 'Show Closed'),
		_Utils_Tuple2('hide', 'Hide')
	]);
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$DragEnd = {$: 'DragEnd'};
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$DragOver = function (a) {
	return {$: 'DragOver', a: a};
};
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$DragStart = function (a) {
	return {$: 'DragStart', a: a};
};
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$Drop = function (a) {
	return {$: 'Drop', a: a};
};
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$dragAttrs = F4(
	function (mapMsg, index, draggingIndex, _v0) {
		return _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'draggable', 'true'),
				A2(
				$elm$html$Html$Events$on,
				'dragstart',
				$elm$json$Json$Decode$succeed(
					mapMsg(
						$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$DragStart(index)))),
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'dragover',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						mapMsg(
							$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$DragOver(index)),
						true))),
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'drop',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						mapMsg(
							$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$Drop(index)),
						true))),
				A2(
				$elm$html$Html$Events$on,
				'dragend',
				$elm$json$Json$Decode$succeed(
					mapMsg($author$project$Components$SettingsPage$Account$ClientNotesConfiguration$DragEnd))),
				A2($elm$html$Html$Attributes$style, 'cursor', 'grab'),
				A2(
				$elm$html$Html$Attributes$style,
				'opacity',
				_Utils_eq(
					draggingIndex,
					$elm$core$Maybe$Just(index)) ? '0.4' : '1')
			]);
	});
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$noteLabel = function (noteType) {
	switch (noteType) {
		case 'warning':
			return 'Warning';
		case 'verification_notes':
			return 'Verification Notes';
		case 'funding_notes':
			return 'Funding Notes';
		case 'notes':
			return 'Notes';
		default:
			return noteType;
	}
};
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$view = F2(
	function (mapMsg, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2($elm$html$Html$th, _List_Nil, _List_Nil),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Section')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Display')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, setting) {
										var color = (_Utils_eq(
											model.dragOverIndex,
											$elm$core$Maybe$Just(index)) && (!_Utils_eq(
											model.draggingIndex,
											$elm$core$Maybe$Just(index)))) ? '2px solid #1a9bbb' : '2px solid transparent';
										var borderVert = _List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'border-top', color),
												A2($elm$html$Html$Attributes$style, 'border-bottom', color)
											]);
										return A2(
											$elm$html$Html$tr,
											A4($author$project$Components$SettingsPage$Account$ClientNotesConfiguration$dragAttrs, mapMsg, index, model.draggingIndex, model.dragOverIndex),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													A2(
														$elm$core$List$cons,
														A2($elm$html$Html$Attributes$style, 'border-left', color),
														_Utils_ap(
															borderVert,
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
																	A2($elm$html$Html$Attributes$style, 'color', '#aaa'),
																	A2($elm$html$Html$Attributes$style, 'user-select', 'none')
																]))),
													_List_fromArray(
														[
															$elm$html$Html$text('⠿')
														])),
													A2(
													$elm$html$Html$td,
													borderVert,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$noteLabel(setting.noteType))
														])),
													A2(
													$elm$html$Html$td,
													A2(
														$elm$core$List$cons,
														A2($elm$html$Html$Attributes$style, 'border-right', color),
														borderVert),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$select,
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$style, 'width', '200px'),
																	A2($elm$html$Html$Attributes$style, 'margin-bottom', '0'),
																	A2(
																	$elm$html$Html$Events$on,
																	'change',
																	A2(
																		$elm$json$Json$Decode$map,
																		function (str) {
																			return mapMsg(
																				A2($author$project$Components$SettingsPage$Account$ClientNotesConfiguration$SetDisplay, index, str));
																		},
																		$elm$html$Html$Events$targetValue))
																]),
															A2(
																$elm$core$List$map,
																function (_v0) {
																	var optValue = _v0.a;
																	var optLabel = _v0.b;
																	return A2(
																		$elm$html$Html$option,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$value(optValue),
																				$elm$html$Html$Attributes$selected(
																				_Utils_eq(optValue, setting.display))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(optLabel)
																			]));
																},
																$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$displayOptions))
														]))
												]));
									}),
								model.settings))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Account$InvoiceSettings$UpdateDateStrategy = function (a) {
	return {$: 'UpdateDateStrategy', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceSettings$UpdateAutoApprove = function (a) {
	return {$: 'UpdateAutoApprove', a: a};
};
var $author$project$Ui$between2 = function (config) {
	return _Utils_update(
		config,
		{between: 2});
};
var $author$project$Ui$feedbackView = function (maybeFeedback) {
	if (maybeFeedback.$ === 'Nothing') {
		return $author$project$Ui$empty;
	} else {
		if (maybeFeedback.a.$ === 'Ok') {
			return $author$project$Ui$empty;
		} else {
			var message = maybeFeedback.a.a;
			return $author$project$Ui$Ui(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hubtran-feedback__feedback')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						])));
		}
	}
};
var $author$project$Ui$hasError = function (maybeFeedback) {
	if (maybeFeedback.$ === 'Nothing') {
		return false;
	} else {
		if (maybeFeedback.a.$ === 'Ok') {
			return false;
		} else {
			return true;
		}
	}
};
var $author$project$Ui$inline = F2(
	function (attributes, children) {
		var config = A3($elm$core$List$foldl, $elm$core$Basics$identity, $author$project$Ui$defaultConfig, attributes);
		var classes = _List_fromArray(
			[
				'hubtran-box__inline',
				'hubtran-box__between-' + $elm$core$String$fromInt(config.between),
				'hubtran-box__horizontal-' + $elm$core$String$fromInt(config.horizontal),
				'hubtran-box__vertical-' + $elm$core$String$fromInt(config.vertical)
			]);
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($elm$core$String$join, ' ', classes))
					]),
				A2($elm$core$List$map, $author$project$Ui$toHtml, children)));
	});
var $author$project$Ui$checkbox = function (config) {
	var inputClass = $author$project$Ui$hasError(config.feedback) ? 'hubtran-checkbox__checkbox--error' : 'hubtran-checkbox__checkbox';
	return A2(
		$author$project$Ui$stack,
		_List_fromArray(
			[$author$project$Ui$between1]),
		_List_fromArray(
			[
				$author$project$Ui$feedbackView(config.feedback),
				$author$project$Ui$Ui(
				A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hubtran-checkbox__label')
						]),
					_List_fromArray(
						[
							$author$project$Ui$toHtml(
							A2(
								$author$project$Ui$inline,
								_List_fromArray(
									[$author$project$Ui$between2]),
								_List_fromArray(
									[
										$author$project$Ui$Ui(
										A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(inputClass),
													$elm$html$Html$Attributes$type_('checkbox'),
													$elm$html$Html$Attributes$checked(config.value),
													$elm$html$Html$Events$onCheck(config.onChange)
												]),
											_List_Nil)),
										A2(
										$author$project$Ui$inline,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Ui(
												$elm$html$Html$text(config.label))
											]))
									])))
						])))
			]));
};
var $author$project$Components$SettingsPage$Account$InvoiceSettings$autoApproveViewIfEnabled = F2(
	function (model, mapMsg) {
		return model.autoApproveEditEnabled ? _List_fromArray(
			[
				$author$project$Ui$checkbox(
				{
					feedback: $elm$core$Maybe$Nothing,
					label: 'Auto Approve Invoices (Hide Processed Queue)',
					onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceSettings$UpdateAutoApprove, mapMsg),
					value: $author$project$Experimental$FormField$value(model.autoApprove)
				})
			]) : _List_Nil;
	});
var $author$project$Ui$concatStack = F2(
	function (attributes, lists) {
		return A2(
			$author$project$Ui$stack,
			attributes,
			$elm$core$List$concat(lists));
	});
var $author$project$Ui$equalWidths = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$author$project$Ui$Ui,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-columns__equal-widths')
				]))),
	$elm$core$List$map($author$project$Ui$toHtml));
var $author$project$Components$SettingsPage$Account$InvoiceSettings$invoiceDateOptions = _List_fromArray(
	[
		_Utils_Tuple2('receipt_date', 'The business day the document was received.'),
		_Utils_Tuple2('actual_receipt_date', 'The day the document was received.'),
		_Utils_Tuple2('invoice_date', 'The invoice date on the document.')
	]);
var $author$project$Ui$keyedStack = F2(
	function (attributes, children) {
		var config = A3($elm$core$List$foldl, $elm$core$Basics$identity, $author$project$Ui$defaultConfig, attributes);
		var classes = _List_fromArray(
			[
				'hubtran-box__stack',
				'hubtran-box__between-' + $elm$core$String$fromInt(config.between),
				'hubtran-box__horizontal-' + $elm$core$String$fromInt(config.horizontal),
				'hubtran-box__vertical-' + $elm$core$String$fromInt(config.vertical)
			]);
		return $author$project$Ui$Ui(
			A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($elm$core$String$join, ' ', classes))
					]),
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond($author$project$Ui$toHtml),
					children)));
	});
var $author$project$Ui$optionHelper = F2(
	function (selectedValue, optionDetails) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(optionDetails.a),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(optionDetails.a, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(optionDetails.b)
				]));
	});
var $author$project$Ui$select = function (config) {
	return A2(
		$author$project$Ui$keyedStack,
		_List_fromArray(
			[$author$project$Ui$between1]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$author$project$Ui$Ui(
					A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-input__label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.label)
							])))),
				_Utils_Tuple2(
				'input',
				$author$project$Ui$Ui(
					A2(
						$elm$html$Html$select,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-input__select'),
								$elm$html$Html$Events$onInput(config.onChange)
							]),
						A2(
							$elm$core$List$map,
							$author$project$Ui$optionHelper(config.value),
							config.options))))
			]));
};
var $author$project$Components$SettingsPage$Account$InvoiceSettings$view = F4(
	function (mapMsg, model, _v0, _v1) {
		return $author$project$Ui$equalWidths(
			_List_fromArray(
				[
					A2(
					$author$project$Ui$concatStack,
					_List_fromArray(
						[$author$project$Ui$between3]),
					_List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$Ui$select(
								{
									label: 'Take Invoice Date From',
									onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceSettings$UpdateDateStrategy, mapMsg),
									options: $author$project$Components$SettingsPage$Account$InvoiceSettings$invoiceDateOptions,
									value: $author$project$Experimental$FormField$value(model.invoiceDateStrategy)
								})
							]),
							A2($author$project$Components$SettingsPage$Account$InvoiceSettings$autoApproveViewIfEnabled, model, mapMsg)
						])),
					$author$project$Ui$spacer
				]));
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$NoOp = {$: 'NoOp'};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceEnabled = function (a) {
	return {$: 'UpdateLtlMarginToleranceEnabled', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceMaximum = function (a) {
	return {$: 'UpdateLtlMarginToleranceMaximum', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceMinimum = function (a) {
	return {$: 'UpdateLtlMarginToleranceMinimum', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceUnit = function (a) {
	return {$: 'UpdateLtlMarginToleranceUnit', a: a};
};
var $author$project$Ui$amountInput = function (config) {
	var inputClass = $author$project$Ui$hasError(config.feedback) ? 'hubtran-input__text--error' : 'hubtran-input__text';
	return A2(
		$author$project$Ui$keyedStack,
		_List_fromArray(
			[$author$project$Ui$between1]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$author$project$Ui$Ui(
					A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-input__label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.label)
							])))),
				_Utils_Tuple2(
				'feedback',
				$author$project$Ui$feedbackView(config.feedback)),
				_Utils_Tuple2(
				'input',
				A2(
					$author$project$Ui$inline,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Ui(
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('hubtran-input__prefix')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', config.labelPrefix))
									]))),
							$author$project$Ui$Ui(
							A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('number'),
										$elm$html$Html$Attributes$class(inputClass),
										$elm$html$Html$Attributes$placeholder(config.placeholder),
										$elm$html$Html$Attributes$value(config.value),
										$elm$html$Html$Events$onInput(config.onChange),
										$elm$html$Html$Events$onBlur(config.onBlur)
									]),
								_List_Nil))
						])))
			]));
};
var $author$project$Ui$heading6 = function (headingText) {
	return A2(
		$author$project$Ui$heading,
		'6',
		_List_fromArray(
			[
				$elm$html$Html$text(headingText)
			]));
};
var $author$project$Domain$Tolerance$toleranceUnitDisplay = function (unit) {
	if (unit.$ === 'ToleranceUnitDollars') {
		return 'Dollars';
	} else {
		return 'Percentage';
	}
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceUnitOptions = A2(
	$elm$core$List$map,
	function (unit) {
		return _Utils_Tuple2(
			unit,
			$author$project$Domain$Tolerance$toleranceUnitDisplay(unit));
	},
	$author$project$AuditPb$allToleranceUnit);
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$validNumberFeedback = F3(
	function (value, minimumValue, minimumString) {
		return $elm$core$String$isEmpty(
			$author$project$Experimental$FormField$value(value)) ? $elm$core$Result$Err('Must be a number') : ((_Utils_cmp(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toFloat(
					$author$project$Experimental$FormField$value(value))),
			minimumValue) < 0) ? $elm$core$Result$Err('Must be greater than or equal to ' + minimumString) : $elm$core$Result$Ok(_Utils_Tuple0));
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$validNumberPresence = function (value) {
	return $elm$core$String$isEmpty(
		$author$project$Experimental$FormField$value(value)) ? $elm$core$Result$Err('Must be a number') : $elm$core$Result$Ok(_Utils_Tuple0);
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$marginToleranceFieldsIfEnabled = F4(
	function (mapMsg, model, accountType, accountSettings) {
		var labelPrefix = function () {
			var _v0 = $author$project$Experimental$FormField$value(model.ltlMarginToleranceUnit);
			if (_v0.$ === 'ToleranceUnitPercentage') {
				return '%';
			} else {
				return '$';
			}
		}();
		var header = $author$project$Ui$heading6('Less-Than-Truckload Customer Margin Tolerance');
		var enabled = A2(
			$author$project$Ui$inline,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					$author$project$Ui$checkbox(
					{
						feedback: $elm$core$Maybe$Nothing,
						label: 'Enabled',
						onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceEnabled, mapMsg),
						value: $author$project$Experimental$FormField$value(model.ltlMarginToleranceEnabled)
					})
				]));
		return (_Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) && accountSettings.ltlCustomerMarginToleranceEnabled) ? ($author$project$Experimental$FormField$value(model.ltlMarginToleranceEnabled) ? _List_fromArray(
			[
				header,
				enabled,
				A2(
				$author$project$Ui$inline,
				_List_fromArray(
					[$author$project$Ui$between2]),
				_List_fromArray(
					[
						$author$project$Ui$select(
						{
							label: 'Unit',
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceUnit, mapMsg),
							options: A2(
								$elm$core$List$map,
								$elm$core$Tuple$mapFirst($author$project$AuditPb$toleranceUnitToString),
								$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceUnitOptions),
							value: $author$project$AuditPb$toleranceUnitToString(
								$author$project$Experimental$FormField$value(model.ltlMarginToleranceUnit))
						}),
						$author$project$Ui$amountInput(
						{
							feedback: $elm$core$Maybe$Just(
								$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$validNumberPresence(model.ltlMarginToleranceMinimum)),
							label: 'Minimum',
							labelPrefix: $elm$core$Maybe$Just(labelPrefix),
							onBlur: mapMsg($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$NoOp),
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceMinimum, mapMsg),
							placeholder: '',
							value: $author$project$Experimental$FormField$value(model.ltlMarginToleranceMinimum)
						}),
						$author$project$Ui$amountInput(
						{
							feedback: $elm$core$Maybe$Just(
								A3(
									$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$validNumberFeedback,
									model.ltlMarginToleranceMaximum,
									function (minVal) {
										return A2($elm$core$Basics$max, 0, minVal);
									}(
										A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toFloat(
												$author$project$Experimental$FormField$value(model.ltlMarginToleranceMinimum)))),
									'minimum and not negative')),
							label: 'Maximum',
							labelPrefix: $elm$core$Maybe$Just(labelPrefix),
							onBlur: mapMsg($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$NoOp),
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceMaximum, mapMsg),
							placeholder: '',
							value: $author$project$Experimental$FormField$value(model.ltlMarginToleranceMaximum)
						})
					]))
			]) : _List_fromArray(
			[header, enabled])) : _List_Nil;
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceOver = function (a) {
	return {$: 'UpdateAmountToleranceOver', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceUnder = function (a) {
	return {$: 'UpdateAmountToleranceUnder', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceUnit = function (a) {
	return {$: 'UpdateAmountToleranceUnit', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceFieldsIfEnabled = F4(
	function (mapMsg, model, accountType, accountSettings) {
		var toleranceLabel = accountSettings.ltlTolerancesEnabled ? 'Truckload Invoice Amount Tolerance' : 'Invoice Amount Tolerance';
		var labelPrefix = function () {
			var _v0 = $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceUnit);
			if (_v0.$ === 'ToleranceUnitDollars') {
				return '$';
			} else {
				return '%';
			}
		}();
		return _Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) ? _List_fromArray(
			[
				$author$project$Ui$heading6(toleranceLabel),
				A2(
				$author$project$Ui$inline,
				_List_fromArray(
					[$author$project$Ui$between2]),
				_List_fromArray(
					[
						$author$project$Ui$select(
						{
							label: 'Unit',
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceUnit, mapMsg),
							options: A2(
								$elm$core$List$map,
								$elm$core$Tuple$mapFirst($author$project$AuditPb$toleranceUnitToString),
								$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceUnitOptions),
							value: $author$project$AuditPb$toleranceUnitToString(
								$author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceUnit))
						}),
						$author$project$Ui$amountInput(
						{
							feedback: $elm$core$Maybe$Just(
								A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$validNumberFeedback, model.carrierInvoiceAmountToleranceOver, 0, '0')),
							label: 'Above',
							labelPrefix: $elm$core$Maybe$Just(labelPrefix),
							onBlur: mapMsg($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$NoOp),
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceOver, mapMsg),
							placeholder: '',
							value: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceOver)
						}),
						$author$project$Ui$amountInput(
						{
							feedback: $elm$core$Maybe$Just(
								A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$validNumberFeedback, model.carrierInvoiceAmountToleranceUnder, 0, '0')),
							label: 'Below',
							labelPrefix: $elm$core$Maybe$Just(labelPrefix),
							onBlur: mapMsg($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$NoOp),
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceUnder, mapMsg),
							placeholder: '',
							value: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceUnder)
						})
					]))
			]) : _List_Nil;
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceOver = function (a) {
	return {$: 'UpdateLtlAmountToleranceOver', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceUnder = function (a) {
	return {$: 'UpdateLtlAmountToleranceUnder', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceUnit = function (a) {
	return {$: 'UpdateLtlAmountToleranceUnit', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceFieldsIfLtlBroker = F4(
	function (mapMsg, model, accountType, accountSettings) {
		var labelPrefix = function () {
			var _v0 = $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceUnit);
			if (_v0.$ === 'ToleranceUnitPercentage') {
				return '%';
			} else {
				return '$';
			}
		}();
		return (_Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) && accountSettings.ltlTolerancesEnabled) ? _List_fromArray(
			[
				$author$project$Ui$heading6('Less-Than-Truckload Invoice Amount Tolerance'),
				A2(
				$author$project$Ui$inline,
				_List_fromArray(
					[$author$project$Ui$between2]),
				_List_fromArray(
					[
						$author$project$Ui$select(
						{
							label: 'Unit',
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceUnit, mapMsg),
							options: A2(
								$elm$core$List$map,
								$elm$core$Tuple$mapFirst($author$project$AuditPb$toleranceUnitToString),
								$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceUnitOptions),
							value: $author$project$AuditPb$toleranceUnitToString(
								$author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceUnit))
						}),
						$author$project$Ui$amountInput(
						{
							feedback: $elm$core$Maybe$Just(
								A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$validNumberFeedback, model.ltlCarrierInvoiceAmountToleranceOver, 0, '0')),
							label: 'Above',
							labelPrefix: $elm$core$Maybe$Just(labelPrefix),
							onBlur: mapMsg($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$NoOp),
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceOver, mapMsg),
							placeholder: '',
							value: $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceOver)
						}),
						$author$project$Ui$amountInput(
						{
							feedback: $elm$core$Maybe$Just(
								A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$validNumberFeedback, model.ltlCarrierInvoiceAmountToleranceUnder, 0, '0')),
							label: 'Below',
							labelPrefix: $elm$core$Maybe$Just(labelPrefix),
							onBlur: mapMsg($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$NoOp),
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceUnder, mapMsg),
							placeholder: '',
							value: $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceUnder)
						})
					]))
			]) : _List_Nil;
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$view = F4(
	function (mapMsg, model, accountType, accountSettings) {
		return $author$project$Ui$equalWidths(
			_List_fromArray(
				[
					A2(
					$author$project$Ui$concatStack,
					_List_fromArray(
						[$author$project$Ui$between3]),
					_List_fromArray(
						[
							A4($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceFieldsIfEnabled, mapMsg, model, accountType, accountSettings),
							A4($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceFieldsIfLtlBroker, mapMsg, model, accountType, accountSettings),
							A4($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$marginToleranceFieldsIfEnabled, mapMsg, model, accountType, accountSettings)
						])),
					$author$project$Ui$spacer
				]));
	});
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$DragStart = function (a) {
	return {$: 'DragStart', a: a};
};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$DragStop = {$: 'DragStop'};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$LoadedSelectedFields = {$: 'LoadedSelectedFields'};
var $author$project$Experimental$OnLoad$keyedNode = F3(
	function (key, msg, children) {
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_Nil,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'1-' + key,
					A3(
						$elm$html$Html$node,
						'style',
						_List_fromArray(
							[
								$author$project$Experimental$OnLoad$event(msg)
							]),
						_List_Nil)),
					_Utils_Tuple2(
					'2-' + key,
					A2($elm$html$Html$div, _List_Nil, children))
				]));
	});
var $author$project$Ui$neutralAlert = function (child) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-alert--neutral')
				]),
			_List_fromArray(
				[
					$author$project$Ui$toHtml(child)
				])));
};
var $author$project$Drag$on = function () {
	var attr = F2(
		function (suffix, msg) {
			return A2(
				$elm$html$Html$Events$on,
				'drag' + suffix,
				$elm$json$Json$Decode$succeed(msg));
		});
	return {
		end: attr('end'),
		enter: attr('enter'),
		leave: attr('leave'),
		start: attr('start')
	};
}();
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$draggable = F5(
	function (events, index, field, state, child) {
		var dragSpecificAttribute = function () {
			var _v0 = state.subject;
			if (_v0.$ === 'Nothing') {
				return $elm$html$Html$Attributes$class('');
			} else {
				var subject = _v0.a;
				return _Utils_eq(subject, field) ? $elm$html$Html$Attributes$class('reference-fields__ui--subject') : A2(
					function ($) {
						return $.enter;
					},
					$author$project$Drag$on,
					A2(events.reorder, index, subject));
			}
		}();
		return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
			A3(
				$author$project$Experimental$OnLoad$keyedNode,
				'',
				events.internal($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$LoadedSelectedFields),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$title(field),
								A2($elm$html$Html$Attributes$attribute, 'data-drag', $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$dragContext),
								$elm$html$Html$Attributes$class('reference-fields__ui--reorderable'),
								A2(
								function ($) {
									return $.start;
								},
								$author$project$Drag$on,
								events.internal(
									$author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$DragStart(field))),
								A2(
								function ($) {
									return $.end;
								},
								$author$project$Drag$on,
								events.internal($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$DragStop)),
								dragSpecificAttribute
							]),
						_List_fromArray(
							[
								$author$project$Ui$toHtml(
								$author$project$Ui$neutralAlert(child))
							]))
					])));
	});
var $author$project$Ui$icon = function (name) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-' + name)
				]),
			_List_Nil));
};
var $author$project$Ui$internalLinkMixed = F2(
	function (label, msg) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-link__internal'),
						$elm$html$Html$Events$onClick(msg)
					]),
				A2($elm$core$List$map, $author$project$Ui$toHtml, label)));
	});
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$fieldView = F3(
	function (toMessage, icon, field) {
		return A2(
			$author$project$Ui$inline,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					$author$project$Ui$text(field),
					A2(
					$author$project$Ui$internalLinkMixed,
					_List_fromArray(
						[
							$author$project$Ui$icon(icon)
						]),
					toMessage(field))
				]));
	});
var $author$project$Ui$paragraph = function (content) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-paragraph__text')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				])));
};
var $author$project$Ui$divider = $author$project$Ui$Ui(
	A2(
		$elm$html$Html$hr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hubtran-divider__line')
			]),
		_List_Nil));
var $author$project$Ui$heading5 = function (headingText) {
	return A2(
		$author$project$Ui$heading,
		'5',
		_List_fromArray(
			[
				$elm$html$Html$text(headingText)
			]));
};
var $author$project$Components$SettingsPage$Shared$Section$viewUi = F2(
	function (name, children) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$stack,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$heading5(name),
							$author$project$Ui$divider
						])),
				children));
	});
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$view = F4(
	function (events, selectedFields, allFieldsSet, state) {
		if ($elm$core$Set$isEmpty(allFieldsSet) || events.reorderDisabled) {
			return $author$project$Ui$text('');
		} else {
			var availableFields = A2(
				$elm$core$List$sortBy,
				$elm$core$String$toLower,
				$elm$core$Set$toList(
					A2(
						$elm$core$Set$diff,
						allFieldsSet,
						$elm$core$Set$fromList(selectedFields))));
			return A2(
				$author$project$Components$SettingsPage$Shared$Section$viewUi,
				'Reference Fields',
				_List_fromArray(
					[
						$author$project$Ui$equalWidths(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$stack,
								_List_Nil,
								$elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												$author$project$Ui$heading6('Available Fields'),
												A2(
												$author$project$Ui$stack,
												_List_Nil,
												A2(
													$elm$core$List$map,
													A2($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$fieldView, events.select, 'plus'),
													availableFields))
											]),
											$elm$core$List$isEmpty(selectedFields) ? _List_fromArray(
											[
												$author$project$Ui$paragraph('All fields will be shown.')
											]) : _List_fromArray(
											[
												$author$project$Ui$heading6('Selected Fields (drag to reorder)'),
												A2(
												$author$project$Ui$stack,
												_List_Nil,
												A2(
													$elm$core$List$indexedMap,
													F2(
														function (index, field) {
															return A5(
																$author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$draggable,
																events,
																index,
																field,
																state,
																A3($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$fieldView, events.unselect, 'minus', field));
														}),
													selectedFields))
											])
										]))),
								$author$project$Ui$spacer
							]))
					]));
		}
	});
var $author$project$Components$SettingsPage$AccountSettingsView$CreateAutoReplyFilter = {$: 'CreateAutoReplyFilter'};
var $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterBodyChange = function (a) {
	return {$: 'NewAutoReplyFilterBodyChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterEmailAddressChange = function (a) {
	return {$: 'NewAutoReplyFilterEmailAddressChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterSubjectChange = function (a) {
	return {$: 'NewAutoReplyFilterSubjectChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$NoOp = {$: 'NoOp'};
var $author$project$Ui$disabled = function (label) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-button__neutral'),
					$elm$html$Html$Attributes$disabled(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])));
};
var $author$project$Ui$primary = F2(
	function (label, onClickMsg) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-button__primary'),
						$elm$html$Html$Events$onClick(onClickMsg)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])));
	});
var $author$project$Ui$disableablePrimary = F2(
	function (labelResult, onClickMsg) {
		if (labelResult.$ === 'Ok') {
			var label = labelResult.a;
			return A2($author$project$Ui$primary, label, onClickMsg);
		} else {
			var label = labelResult.a;
			return $author$project$Ui$disabled(label);
		}
	});
var $author$project$Components$SettingsPage$AccountSettingsView$disableIf = F2(
	function (check, label) {
		return $author$project$Ui$disableablePrimary(
			check ? $elm$core$Result$Err(label) : $elm$core$Result$Ok(label));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$possibleTable = F3(
	function (columns, row, entries) {
		return $elm$core$List$isEmpty(entries) ? $author$project$Ui$empty : A2(
			$author$project$Ui$table,
			$author$project$Ui$headers(
				A2($elm$core$List$map, $author$project$Ui$text, columns)),
			A2($elm$core$List$map, row, entries));
	});
var $author$project$Ui$textInputWithAttributes = F2(
	function (config, attributes) {
		var inputClass = $author$project$Ui$hasError(config.feedback) ? 'hubtran-input__text--error' : 'hubtran-input__text';
		return A2(
			$author$project$Ui$keyedStack,
			_List_fromArray(
				[$author$project$Ui$between1]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'label',
					$author$project$Ui$Ui(
						A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hubtran-input__label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(config.label)
								])))),
					_Utils_Tuple2(
					'feedback',
					$author$project$Ui$feedbackView(config.feedback)),
					_Utils_Tuple2(
					'input',
					$author$project$Ui$Ui(
						A2(
							$elm$html$Html$input,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$class(inputClass),
										$elm$html$Html$Attributes$placeholder(config.placeholder),
										$elm$html$Html$Attributes$value(config.value),
										$elm$html$Html$Events$onInput(config.onChange),
										$elm$html$Html$Events$onBlur(config.onBlur)
									]),
								attributes),
							_List_Nil)))
				]));
	});
var $author$project$Ui$textInput = function (config) {
	return A2($author$project$Ui$textInputWithAttributes, config, _List_Nil);
};
var $author$project$Components$SettingsPage$AccountSettingsView$DeleteAutoReplyFilter = function (a) {
	return {$: 'DeleteAutoReplyFilter', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewAutoReplyFilterRow = function (filter) {
	return $author$project$Ui$row(
		_List_fromArray(
			[
				$author$project$Ui$text(filter.email),
				$author$project$Ui$text(filter.subject),
				$author$project$Ui$text(filter.body),
				A2(
				$author$project$Ui$inline,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$primary,
						'Delete',
						$author$project$Components$SettingsPage$AccountSettingsView$DeleteAutoReplyFilter(filter))
					]))
			]));
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewAutoReplyFilters = F4(
	function (newEmailAddress, newSubject, newBody, filters) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between3]),
			_List_fromArray(
				[
					$author$project$Ui$paragraph('To automatically filter out auto-reply emails,\u000A        set the sender address and subject or body of emails\u000A        you do not wish to see.'),
					$author$project$Ui$equalWidths(
					_List_fromArray(
						[
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: '', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$AccountSettingsView$NoOp, onChange: $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterEmailAddressChange, placeholder: 'Email Address', value: newEmailAddress}),
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: '', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$AccountSettingsView$NoOp, onChange: $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterSubjectChange, placeholder: 'Subject', value: newSubject}),
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: '', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$AccountSettingsView$NoOp, onChange: $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterBodyChange, placeholder: 'Body', value: newBody})
						])),
					A2(
					$author$project$Ui$inline,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Components$SettingsPage$AccountSettingsView$disableIf,
							$elm$core$String$isEmpty(newEmailAddress),
							'Create New Filter',
							$author$project$Components$SettingsPage$AccountSettingsView$CreateAutoReplyFilter)
						])),
					A3(
					$author$project$Components$SettingsPage$AccountSettingsView$possibleTable,
					_List_fromArray(
						['Email Address', 'Subject', 'Body', 'Delete Filter']),
					$author$project$Components$SettingsPage$AccountSettingsView$viewAutoReplyFilterRow,
					filters)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewCadenceSettings = F2(
	function (onChange, raw) {
		var instructions = 'Comma-separated list of emails';
		var feedback = raw.valid ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err(instructions);
		return A2(
			$author$project$Ui$inline,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$textInput(
					{
						feedback: $elm$core$Maybe$Just(feedback),
						label: '\u000A            Notify When CADENCE Rejects Invoice Batch.\u000A            If this is blank, all admins will be emailed.',
						labelPrefix: $elm$core$Maybe$Nothing,
						onBlur: $author$project$Components$SettingsPage$AccountSettingsView$NoOp,
						onChange: onChange,
						placeholder: instructions,
						value: raw.content
					})
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$CreateCustomInvoiceExceptionMessage = {$: 'CreateCustomInvoiceExceptionMessage'};
var $author$project$Components$SettingsPage$AccountSettingsView$NewCustomInvoiceExceptionMessageChange = function (a) {
	return {$: 'NewCustomInvoiceExceptionMessageChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$customInvoiceExceptionMessagesWarning = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('alert-box info')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Note: Custom invoice exception messages are used for manually adding an exception. They are used by auditors to document why an invoice is held.')
		]));
var $author$project$Components$SettingsPage$AccountSettingsView$DeleteCustomInvoiceExceptionMessage = function (a) {
	return {$: 'DeleteCustomInvoiceExceptionMessage', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewCustomMessageRow = function (message) {
	return $author$project$Ui$row(
		_List_fromArray(
			[
				$author$project$Ui$text(message),
				A2(
				$author$project$Ui$inline,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$primary,
						'Delete',
						$author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg(
							$author$project$Components$SettingsPage$AccountSettingsView$DeleteCustomInvoiceExceptionMessage(message)))
					]))
			]));
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewCustomInvoiceExceptionMessages = F2(
	function (newValue, messages) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between3]),
			_List_fromArray(
				[
					$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE($author$project$Components$SettingsPage$AccountSettingsView$customInvoiceExceptionMessagesWarning),
					A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between2]),
					_List_fromArray(
						[
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: '', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$AccountSettingsView$NoOp, onChange: $author$project$Components$SettingsPage$AccountSettingsView$NewCustomInvoiceExceptionMessageChange, placeholder: 'New message', value: newValue}),
							A3(
							$author$project$Components$SettingsPage$AccountSettingsView$disableIf,
							$elm$core$String$isEmpty(newValue),
							'Create Message',
							$author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$CreateCustomInvoiceExceptionMessage))
						])),
					A3(
					$author$project$Components$SettingsPage$AccountSettingsView$possibleTable,
					_List_fromArray(
						['Message', 'Delete']),
					$author$project$Components$SettingsPage$AccountSettingsView$viewCustomMessageRow,
					messages)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$after = function (days) {
	return _Utils_Tuple2(
		$elm$core$String$fromInt(days),
		'After ' + ($elm$core$String$fromInt(days) + ' Days'));
};
var $author$project$Components$SettingsPage$AccountSettingsView$neverOld = _Utils_Tuple2('', 'Never');
var $author$project$Components$SettingsPage$AccountSettingsView$viewExceptionSettings = F2(
	function (onChange, value) {
		return A2(
			$author$project$Ui$inline,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$select(
					{
						label: 'When should we create exceptions for old invoices?',
						onChange: onChange,
						options: _List_fromArray(
							[
								$author$project$Components$SettingsPage$AccountSettingsView$neverOld,
								$author$project$Components$SettingsPage$AccountSettingsView$after(120),
								$author$project$Components$SettingsPage$AccountSettingsView$after(90),
								$author$project$Components$SettingsPage$AccountSettingsView$after(60),
								$author$project$Components$SettingsPage$AccountSettingsView$after(30)
							]),
						value: value
					})
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewIf = F2(
	function (check, ui) {
		return check ? ui : $author$project$Ui$empty;
	});
var $author$project$Components$SettingsPage$AccountSettingsView$LoadCustomerLabelNameChange = function (a) {
	return {$: 'LoadCustomerLabelNameChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$LoadCustomerLabelSourceChange = function (a) {
	return {$: 'LoadCustomerLabelSourceChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$SaveLoadCustomerLabel = {$: 'SaveLoadCustomerLabel'};
var $author$project$Components$SettingsPage$AccountSettingsView$ifCategoriesEnabled = F2(
	function (data, content) {
		return data.accountSettings.showCategorizedLabels ? content : $author$project$Ui$empty;
	});
var $author$project$Api$LoadCustomerLabels$loadCustomerLabelSources = _List_fromArray(
	[
		_Utils_Tuple2('customer_category_labeler', 'Customer'),
		_Utils_Tuple2('people_category_labeler', 'People'),
		_Utils_Tuple2('division_category_labeler', 'Division'),
		_Utils_Tuple2($author$project$Api$LoadCustomerLabels$ungroupedSource, 'None')
	]);
var $author$project$Components$SettingsPage$AccountSettingsView$ifCategoriesEnabledElse = F3(
	function (data, enabledContent, disabledContent) {
		return data.accountSettings.showCategorizedLabels ? enabledContent : disabledContent;
	});
var $author$project$Ui$headerWithCustomClass = function (_v0) {
	var className = _v0.a;
	var content = _v0.b;
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hubtran-table__header'),
				$elm$html$Html$Attributes$class(className)
			]),
		_List_fromArray(
			[
				$author$project$Ui$toHtml(
				A2(
					$author$project$Ui$stack,
					_List_fromArray(
						[$author$project$Ui$inset3]),
					_List_fromArray(
						[content])))
			]));
};
var $author$project$Ui$headersWithCustomClasses = function (items) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$thead,
			_List_Nil,
			A2($elm$core$List$map, $author$project$Ui$headerWithCustomClass, items)));
};
var $author$project$Ui$styledSpan = F2(
	function (styles, content) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$span,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return A2($elm$html$Html$Attributes$style, a, b);
					},
					styles),
				A2($elm$core$List$map, $author$project$Ui$toHtml, content)));
	});
var $author$project$Ui$basicTooltip = F2(
	function (additionalStyles, tooltipText) {
		return A2(
			$author$project$Ui$inline,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$styledSpan,
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('background-color', '#008CBA'),
								_Utils_Tuple2('border-radius', '5px'),
								_Utils_Tuple2('box-shadow', '#444444 2px 2px'),
								_Utils_Tuple2('color', 'white'),
								_Utils_Tuple2('z-index', '10'),
								_Utils_Tuple2('padding', '5px 10px')
							]),
						additionalStyles),
					_List_fromArray(
						[
							$author$project$Ui$text(tooltipText)
						]))
				]));
	});
var $author$project$Ui$longTooltip = $author$project$Ui$basicTooltip(
	_List_fromArray(
		[
			_Utils_Tuple2('width', '180px')
		]));
var $author$project$Ui$tooltipAbove = F2(
	function (tooltip, content) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-tooltip__wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-tooltip__above')
							]),
						_List_fromArray(
							[
								$author$project$Ui$toHtml(tooltip)
							])),
						$author$project$Ui$toHtml(content)
					])));
	});
var $author$project$Ui$textWithInfoTooltip = F2(
	function (content, toolTip) {
		return A2(
			$author$project$Ui$inline,
			_List_fromArray(
				[$author$project$Ui$between1]),
			_List_fromArray(
				[
					$author$project$Ui$text(content),
					A2(
					$author$project$Ui$tooltipAbove,
					toolTip,
					$author$project$Ui$icon('info'))
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$loadCustomerLabelHeadersWithCategories = function (_v0) {
	return $author$project$Ui$headersWithCustomClasses(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'small-2',
				$author$project$Ui$text('Label Name')),
				_Utils_Tuple2(
				'small-2',
				$author$project$Ui$text('Category')),
				_Utils_Tuple2(
				'small-2',
				A2(
					$author$project$Ui$textWithInfoTooltip,
					'Editing',
					$author$project$Ui$longTooltip('To edit, click the pencil to activate the Label Editor above.'))),
				_Utils_Tuple2(
				'small-4',
				A2(
					$author$project$Ui$textWithInfoTooltip,
					'Add customer',
					$author$project$Ui$longTooltip('When a customer is linked to a label, that customer\u0027s invoices will be automatically labeled.'))),
				_Utils_Tuple2(
				'small-2',
				$author$project$Ui$text('Delete'))
			]));
};
var $author$project$Components$SettingsPage$AccountSettingsView$loadCustomerLabelHeadersWithoutCategories = function (_v0) {
	return $author$project$Ui$headersWithCustomClasses(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'small-3',
				$author$project$Ui$text('Label Name')),
				_Utils_Tuple2(
				'small-3',
				A2(
					$author$project$Ui$textWithInfoTooltip,
					'Editing',
					$author$project$Ui$longTooltip('To edit, click the pencil to activate the Label Editor above.'))),
				_Utils_Tuple2(
				'small-3',
				A2(
					$author$project$Ui$textWithInfoTooltip,
					'Add customer',
					$author$project$Ui$longTooltip('When a customer is linked to a label, that customer\u0027s invoices will be automatically labeled.'))),
				_Utils_Tuple2(
				'small-3',
				$author$project$Ui$text('Delete'))
			]));
};
var $author$project$Components$SettingsPage$AccountSettingsView$loadCustomerLabelHeaders = function (data) {
	return A3(
		$author$project$Components$SettingsPage$AccountSettingsView$ifCategoriesEnabledElse,
		data,
		$author$project$Components$SettingsPage$AccountSettingsView$loadCustomerLabelHeadersWithCategories(data),
		$author$project$Components$SettingsPage$AccountSettingsView$loadCustomerLabelHeadersWithoutCategories(data));
};
var $author$project$Components$SettingsPage$AccountSettingsView$AddCustomerToLoadCustomerLabel = F2(
	function (a, b) {
		return {$: 'AddCustomerToLoadCustomerLabel', a: a, b: b};
	});
var $author$project$Components$SettingsPage$AccountSettingsView$CollapseLoadCustomerLabel = {$: 'CollapseLoadCustomerLabel'};
var $author$project$Components$SettingsPage$AccountSettingsView$ExpandLoadCustomerLabel = function (a) {
	return {$: 'ExpandLoadCustomerLabel', a: a};
};
var $author$project$Ui$horizontal3 = function (config) {
	return _Utils_update(
		config,
		{horizontal: 3});
};
var $author$project$Components$SettingsPage$AccountSettingsView$DeleteLoadCustomerLabelCustomer = F2(
	function (a, b) {
		return {$: 'DeleteLoadCustomerLabelCustomer', a: a, b: b};
	});
var $author$project$Ui$horizontal2 = function (config) {
	return _Utils_update(
		config,
		{horizontal: 2});
};
var $author$project$Ui$shortTooltip = $author$project$Ui$basicTooltip(
	_List_fromArray(
		[
			_Utils_Tuple2('white-space', 'nowrap')
		]));
var $author$project$Ui$tooltipLeft = F2(
	function (tooltip, content) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-tooltip__wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-tooltip__left')
							]),
						_List_fromArray(
							[
								$author$project$Ui$toHtml(tooltip)
							])),
						$author$project$Ui$toHtml(content)
					])));
	});
var $author$project$Ui$vertical1 = function (config) {
	return _Utils_update(
		config,
		{vertical: 1});
};
var $author$project$Components$SettingsPage$AccountSettingsView$deleteOnLeft = F2(
	function (_delete, content) {
		return A2(
			$author$project$Ui$tooltipLeft,
			A2(
				$author$project$Ui$internalLinkMixed,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$inline,
						_List_fromArray(
							[$author$project$Ui$vertical1, $author$project$Ui$horizontal2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$tooltipAbove,
								$author$project$Ui$shortTooltip('Delete'),
								$author$project$Ui$icon('trash'))
							]))
					]),
				_delete),
			content);
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelCustomer = F2(
	function (label, customer) {
		return A2(
			$author$project$Components$SettingsPage$AccountSettingsView$deleteOnLeft,
			A2($author$project$Components$SettingsPage$AccountSettingsView$DeleteLoadCustomerLabelCustomer, label, customer),
			$author$project$Ui$text(customer.name));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$DeleteLoadCustomerLabel = function (a) {
	return {$: 'DeleteLoadCustomerLabel', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$EditLoadCustomerLabel = function (a) {
	return {$: 'EditLoadCustomerLabel', a: a};
};
var $author$project$Api$LoadCustomerLabels$loadCustomerLabelNameForSource = function (source) {
	return function (item) {
		if (item.$ === 'Just') {
			var _v1 = item.a;
			var name = _v1.b;
			return name;
		} else {
			return 'name';
		}
	}(
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (x) {
					return _Utils_eq(x.a, source);
				},
				$author$project$Api$LoadCustomerLabels$loadCustomerLabelSources)));
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelTableRow = F5(
	function (data, label, icon, toggle, details) {
		return $author$project$Ui$row(
			A2(
				$elm$core$List$filter,
				function (ui) {
					return !_Utils_eq(ui, $author$project$Ui$empty);
				},
				_List_fromArray(
					[
						$author$project$Ui$text(label.name),
						A2(
						$author$project$Components$SettingsPage$AccountSettingsView$ifCategoriesEnabled,
						data,
						$author$project$Ui$text(
							$author$project$Api$LoadCustomerLabels$loadCustomerLabelNameForSource(label.source))),
						A2(
						$author$project$Ui$internalLinkMixed,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$tooltipAbove,
								$author$project$Ui$shortTooltip('Edit'),
								$author$project$Ui$icon('pencil'))
							]),
						$author$project$Components$SettingsPage$AccountSettingsView$EditLoadCustomerLabel(label)),
						A2(
						$author$project$Ui$stack,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$internalLinkMixed,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$tooltipAbove,
										$author$project$Ui$shortTooltip('Customers'),
										$author$project$Ui$icon(icon))
									]),
								toggle),
								details
							])),
						A2(
						$author$project$Ui$inline,
						_List_fromArray(
							[$author$project$Ui$vertical1, $author$project$Ui$horizontal2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$internalLinkMixed,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$inline,
										_List_fromArray(
											[$author$project$Ui$vertical1, $author$project$Ui$horizontal2]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$tooltipAbove,
												$author$project$Ui$shortTooltip('Delete'),
												$author$project$Ui$icon('trash'))
											]))
									]),
								$author$project$Components$SettingsPage$AccountSettingsView$DeleteLoadCustomerLabel(label))
							]))
					])));
	});
var $author$project$Components$CustomerTypeahead$viewUi = F3(
	function (toParentMsg, data, model) {
		return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('activity-filters-typeahead ui-typeahead--positioned')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toParentMsg,
						A2($author$project$Components$CustomerTypeahead$view, data, model))
					])));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabel = F3(
	function (data, model, _v0) {
		var label = _v0.a;
		var customers = _v0.b;
		var editing = function () {
			var _v2 = model.newLoadCustomerLabel;
			if (_v2.$ === 'New') {
				return false;
			} else {
				var old = _v2.a.old;
				return _Utils_eq(old, label.name);
			}
		}();
		return editing ? $author$project$Ui$spacer : ((!_Utils_eq(
			model.showLoadCustomerLabel,
			$elm$core$Maybe$Just(label))) ? A5(
			$author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelTableRow,
			data,
			label,
			'plus',
			$author$project$Components$SettingsPage$AccountSettingsView$ExpandLoadCustomerLabel(label),
			$author$project$Ui$empty) : A5(
			$author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelTableRow,
			data,
			label,
			'minus',
			$author$project$Components$SettingsPage$AccountSettingsView$CollapseLoadCustomerLabel,
			A2(
				$author$project$Ui$stack,
				_List_fromArray(
					[$author$project$Ui$horizontal3]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelCustomer(label),
						customers),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$inline,
							_List_fromArray(
								[$author$project$Ui$between2]),
							_List_fromArray(
								[
									A3($author$project$Components$CustomerTypeahead$viewUi, $author$project$Components$SettingsPage$AccountSettingsView$CustomerTypeaheadMsg, data.customerTypeahead, model.loadCustomerTypeahead),
									function () {
									var _v1 = $author$project$Typeahead$selectedId(model.loadCustomerTypeahead);
									if (_v1.$ === 'Nothing') {
										return $author$project$Ui$disabled('Save');
									} else {
										var customerId = _v1.a;
										return A2(
											$author$project$Ui$primary,
											'Save',
											A2($author$project$Components$SettingsPage$AccountSettingsView$AddCustomerToLoadCustomerLabel, label, customerId));
									}
								}()
								]))
						])))));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$loadCustomerLabelTable = F2(
	function (data, model) {
		return $elm$core$List$isEmpty(data.labeledCustomers) ? $author$project$Ui$text('No labels yet') : A2(
			$author$project$Ui$table,
			$author$project$Components$SettingsPage$AccountSettingsView$loadCustomerLabelHeaders(data),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabel, data, model),
				data.labeledCustomers));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabels = F2(
	function (data, model) {
		var _v0 = function () {
			var _v1 = model.newLoadCustomerLabel;
			if (_v1.$ === 'New') {
				var x = _v1.a;
				return _Utils_Tuple2('Add', x);
			} else {
				var newSource = _v1.a.newSource;
				var _new = _v1.a._new;
				return _Utils_Tuple2(
					'Update',
					{name: _new, source: newSource});
			}
		}();
		var action = _v0.a;
		var label = _v0.b;
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between3]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between2]),
					_List_fromArray(
						[
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: '', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$AccountSettingsView$NoOp, onChange: $author$project$Components$SettingsPage$AccountSettingsView$LoadCustomerLabelNameChange, placeholder: 'Add New Label', value: label.name}),
							A2(
							$author$project$Components$SettingsPage$AccountSettingsView$ifCategoriesEnabled,
							data,
							$author$project$Ui$select(
								{label: '', onChange: $author$project$Components$SettingsPage$AccountSettingsView$LoadCustomerLabelSourceChange, options: $author$project$Api$LoadCustomerLabels$loadCustomerLabelSources, value: label.source})),
							A3(
							$author$project$Components$SettingsPage$AccountSettingsView$disableIf,
							$elm$core$String$isEmpty(label.name),
							action,
							$author$project$Components$SettingsPage$AccountSettingsView$SaveLoadCustomerLabel)
						])),
					A2($author$project$Components$SettingsPage$AccountSettingsView$loadCustomerLabelTable, data, model)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm = {$: 'SaveMainForm'};
var $author$project$Components$SettingsPage$Account$CarrierPayments$fieldIsPresent = A2(
	$elm$core$Basics$composeR,
	$author$project$Experimental$FormField$value,
	A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not));
var $author$project$Components$SettingsPage$Account$CarrierPayments$validatePaymentTerms = function (carrierDaysToPay) {
	return $author$project$Components$SettingsPage$Account$CarrierPayments$fieldIsPresent(carrierDaysToPay) ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err('cannot be blank');
};
var $author$project$Components$SettingsPage$Account$CarrierPayments$validateQuickpayDiscount = function (model) {
	var discountIsDisabled = $author$project$Experimental$FormField$value(model.quickpayDiscountDisabled);
	return (discountIsDisabled || $author$project$Components$SettingsPage$Account$CarrierPayments$fieldIsPresent(model.quickpayDiscount)) ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err('cannot be blank');
};
var $author$project$Components$SettingsPage$Account$CarrierPayments$isValid = function (model) {
	return A2(
		$elm$core$List$all,
		$author$project$Helpers$Result$isOk,
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$Account$CarrierPayments$validatePaymentTerms(model.carrierDaysToPay),
				$author$project$Components$SettingsPage$Account$CarrierPayments$validateQuickpayDiscount(model)
			]));
};
var $author$project$Components$SettingsPage$Account$InvoiceSettings$isValid = function (_v0) {
	return true;
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$allRequiredFields = function (model) {
	var marginToleranceInputs = $author$project$Experimental$FormField$value(model.ltlMarginToleranceEnabled) ? _List_fromArray(
		[model.ltlMarginToleranceMinimum, model.ltlMarginToleranceMaximum]) : _List_Nil;
	var invoiceToleranceInputs = _List_fromArray(
		[model.carrierInvoiceAmountToleranceOver, model.carrierInvoiceAmountToleranceUnder, model.ltlCarrierInvoiceAmountToleranceOver, model.ltlCarrierInvoiceAmountToleranceUnder]);
	return A2(
		$elm$core$List$all,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			$author$project$Experimental$FormField$value),
		_Utils_ap(invoiceToleranceInputs, marginToleranceInputs));
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$lineItemTypeRequiredAndPresent = F2(
	function (accountSettings, model) {
		var lineItemsEnabled = accountSettings.lineItemVisibility !== 'hidden';
		var hasLineItemType = !_Utils_eq(
			$author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceLineItemTypeId),
			$elm$core$Maybe$Nothing);
		return (!lineItemsEnabled) || hasLineItemType;
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$minimumMaximumValid = function (model) {
	var minVal = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toFloat(
			$author$project$Experimental$FormField$value(model.ltlMarginToleranceMinimum)));
	var minBound = A2($elm$core$Basics$max, 0, minVal);
	var maxVal = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toFloat(
			$author$project$Experimental$FormField$value(model.ltlMarginToleranceMaximum)));
	return _Utils_cmp(maxVal, minBound) > -1;
};
var $author$project$Domain$Tolerance$validateToleranceValue = function (value) {
	if ($elm$core$String$isEmpty(value)) {
		return $elm$core$Result$Ok(_Utils_Tuple0);
	} else {
		var _v0 = $elm$core$String$toFloat(value);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Result$Ok(_Utils_Tuple0);
		} else {
			var n = _v0.a;
			return (n >= 0) ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err('Must be greater than or equal to 0');
		}
	}
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceValuesNotNegative = function (model) {
	return A2(
		$elm$core$List$all,
		function (field) {
			return _Utils_eq(
				$author$project$Domain$Tolerance$validateToleranceValue(
					$author$project$Experimental$FormField$value(field)),
				$elm$core$Result$Ok(_Utils_Tuple0));
		},
		_List_fromArray(
			[model.carrierInvoiceAmountToleranceOver, model.carrierInvoiceAmountToleranceUnder, model.ltlCarrierInvoiceAmountToleranceOver, model.ltlCarrierInvoiceAmountToleranceUnder]));
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$isValid = F2(
	function (accountSettings, model) {
		return $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$allRequiredFields(model) && (A2($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$lineItemTypeRequiredAndPresent, accountSettings, model) && ($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$minimumMaximumValid(model) && $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceValuesNotNegative(model)));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewMainSaveButton = F2(
	function (data, model) {
		var message = ($author$project$Components$SettingsPage$EditableSection$current(model.failedCadenceTransmissionRecipientsEditableSection).valid && ($author$project$Components$SettingsPage$Account$CarrierPayments$isValid(
			$author$project$Components$SettingsPage$EditableSection$current(model.carrierPaymentsEditableSection)) && ($author$project$Components$SettingsPage$Account$InvoiceSettings$isValid(
			$author$project$Components$SettingsPage$EditableSection$current(model.invoiceSettingsEditableSection)) && A2(
			$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$isValid,
			data.accountSettings,
			$author$project$Components$SettingsPage$EditableSection$current(model.invoiceToleranceSettingsEditableSection))))) ? $elm$core$Result$Ok('Save') : $elm$core$Result$Err('Fix errors to save');
		return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('settings__account-multi-save--sticky')
					]),
				_List_fromArray(
					[
						$author$project$Ui$toHtml(
						A2(
							$author$project$Ui$inline,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$disableablePrimary,
									message,
									$author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm))
								])))
					])));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailDelay = function (a) {
	return {$: 'ChangeMissingDocumentsEmailDelay', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailInterval = function (a) {
	return {$: 'ChangeMissingDocumentsEmailInterval', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailTotalCount = function (a) {
	return {$: 'ChangeMissingDocumentsEmailTotalCount', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ToggleMissingDocumentsEmails = function (a) {
	return {$: 'ToggleMissingDocumentsEmails', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$delayOptions = _List_fromArray(
	[
		_Utils_Tuple2('24', '1'),
		_Utils_Tuple2('48', '2'),
		_Utils_Tuple2('72', '3'),
		_Utils_Tuple2('96', '4'),
		_Utils_Tuple2('120', '5'),
		_Utils_Tuple2('144', '6'),
		_Utils_Tuple2('168', '7')
	]);
var $author$project$Components$SettingsPage$AccountSettingsView$maxEmailsPerLoad = 10;
var $author$project$Components$SettingsPage$AccountSettingsView$emailsPerLoadOptions = A2(
	$elm$core$List$map,
	function (count) {
		return _Utils_Tuple2(
			$elm$core$String$fromInt(count),
			$elm$core$String$fromInt(count));
	},
	A2($elm$core$List$range, 1, $author$project$Components$SettingsPage$AccountSettingsView$maxEmailsPerLoad));
var $author$project$Components$SettingsPage$AccountSettingsView$intervalOptions = A2(
	$elm$core$List$map,
	function (days) {
		return _Utils_Tuple2(
			$elm$core$String$fromInt(days),
			$elm$core$String$fromInt(days));
	},
	_List_fromArray(
		[1, 2, 3, 5, 7, 10, 14]));
var $author$project$Components$SettingsPage$AccountSettingsView$missingDocumentsSchedule = function (settings) {
	var total = A3($elm$core$Basics$clamp, 1, $author$project$Components$SettingsPage$AccountSettingsView$maxEmailsPerLoad, settings.emailsPerLoad);
	var interval = A2($elm$core$Basics$max, 1, settings.intervalInDays);
	var firstDay = A2($elm$core$Basics$max, 1, (settings.delayInHours / 24) | 0);
	return A2(
		$elm$core$List$map,
		function (position) {
			return {
				daysAfterDelivery: firstDay + ((position - 1) * interval),
				kind: (position === 1) ? 'Document request' : (_Utils_eq(position, total) ? 'FINAL NOTICE' : 'Reminder'),
				position: position
			};
		},
		A2($elm$core$List$range, 1, total));
};
var $author$project$Components$SettingsPage$AccountSettingsView$scheduleRowText = function (email) {
	return 'Email ' + ($elm$core$String$fromInt(email.position) + (' — ' + ($elm$core$String$fromInt(email.daysAfterDelivery) + (((email.daysAfterDelivery === 1) ? ' day after delivery — ' : ' days after delivery — ') + email.kind))));
};
var $author$project$Components$SettingsPage$AccountSettingsView$schedulePreviewLines = function (settings) {
	return A2(
		$elm$core$List$cons,
		'What the carrier receives',
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Components$SettingsPage$AccountSettingsView$scheduleRowText,
				$author$project$Components$SettingsPage$AccountSettingsView$missingDocumentsSchedule(settings)),
			_List_fromArray(
				['Reminders stop as soon as the documents arrive or the invoice is processed.'])));
};
var $author$project$Components$SettingsPage$AccountSettingsView$scheduleSettings = function (loadedModel) {
	return {delayInHours: loadedModel.sendMissingDocumentsEmailDelayInHours, emailsPerLoad: loadedModel.sendMissingDocumentsEmailTotalCount, intervalInDays: loadedModel.sendMissingDocumentsEmailIntervalInDays};
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewMissingDocumentsSettingsLegacy = F2(
	function (cadenceEnabled, loadedModel) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
					A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(loadedModel.sendMissingDocumentsEmailsEnabled),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleMissingDocumentsEmails)),
										A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
									]),
								_List_Nil),
								$elm$html$Html$text('Autosend Request Emails')
							]))),
					(loadedModel.sendMissingDocumentsEmailsEnabled && (!cadenceEnabled)) ? A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between1]),
					_List_fromArray(
						[
							$author$project$Ui$text('Wait'),
							$author$project$Ui$select(
							{
								label: '',
								onChange: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailDelay),
								options: $author$project$Components$SettingsPage$AccountSettingsView$delayOptions,
								value: $elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailDelayInHours)
							}),
							$author$project$Ui$text('days after delivery')
						])) : (loadedModel.sendMissingDocumentsEmailsEnabled ? A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between1]),
					_List_fromArray(
						[
							$author$project$Ui$text('Wait'),
							$author$project$Ui$select(
							{
								label: '',
								onChange: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailDelay),
								options: $author$project$Components$SettingsPage$AccountSettingsView$delayOptions,
								value: $elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailDelayInHours)
							}),
							$author$project$Ui$text('days after delivery, then send up to'),
							$author$project$Ui$select(
							{
								label: '',
								onChange: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailTotalCount),
								options: $author$project$Components$SettingsPage$AccountSettingsView$emailsPerLoadOptions,
								value: $elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailTotalCount)
							}),
							$author$project$Ui$text('emails every'),
							$author$project$Ui$select(
							{
								label: '',
								onChange: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailInterval),
								options: $author$project$Components$SettingsPage$AccountSettingsView$intervalOptions,
								value: $elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailIntervalInDays)
							}),
							$author$project$Ui$text('days until the documents arrive')
						])) : $author$project$Ui$empty),
					(loadedModel.sendMissingDocumentsEmailsEnabled && cadenceEnabled) ? A2(
					$author$project$Ui$stack,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Ui$text,
						$author$project$Components$SettingsPage$AccountSettingsView$schedulePreviewLines(
							$author$project$Components$SettingsPage$AccountSettingsView$scheduleSettings(loadedModel)))) : $author$project$Ui$empty,
					A2(
					$author$project$Ui$inline,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$primary,
							'Save',
							$author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm))
						]))
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$CreateOfficePeopleMapping = {$: 'CreateOfficePeopleMapping'};
var $author$project$Components$SettingsPage$AccountSettingsView$NewOfficeMappingChange = function (a) {
	return {$: 'NewOfficeMappingChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$NewPeopleMappingChange = function (a) {
	return {$: 'NewPeopleMappingChange', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$DeleteOfficePeopleMapping = function (a) {
	return {$: 'DeleteOfficePeopleMapping', a: a};
};
var $author$project$Ui$internalLink = F2(
	function (label, msg) {
		return A2(
			$author$project$Ui$internalLinkMixed,
			_List_fromArray(
				[
					$author$project$Ui$text(label)
				]),
			msg);
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewOfficePeopleMappingRow = function (mapping) {
	return $author$project$Ui$row(
		_List_fromArray(
			[
				$author$project$Ui$text(mapping.office),
				$author$project$Ui$text(mapping.person),
				A2(
				$author$project$Ui$inline,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$internalLink,
						'Delete',
						$author$project$Components$SettingsPage$AccountSettingsView$DeleteOfficePeopleMapping(mapping))
					]))
			]));
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewOfficePeopleMappings = F3(
	function (newOffice, newPerson, mappings) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between3]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$SettingsPage$AccountSettingsView$possibleTable,
					_List_fromArray(
						['Office', 'Person', 'Actions']),
					$author$project$Components$SettingsPage$AccountSettingsView$viewOfficePeopleMappingRow,
					mappings),
					A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between2]),
					_List_fromArray(
						[
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: '', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$AccountSettingsView$NoOp, onChange: $author$project$Components$SettingsPage$AccountSettingsView$NewOfficeMappingChange, placeholder: 'Office', value: newOffice}),
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: '', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$AccountSettingsView$NoOp, onChange: $author$project$Components$SettingsPage$AccountSettingsView$NewPeopleMappingChange, placeholder: 'Person', value: newPerson}),
							A3(
							$author$project$Components$SettingsPage$AccountSettingsView$disableIf,
							A2(
								$elm$core$List$member,
								'',
								_List_fromArray(
									[newOffice, newPerson])),
							'Add',
							$author$project$Components$SettingsPage$AccountSettingsView$CreateOfficePeopleMapping)
						]))
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$legacyView = F2(
	function (data, model) {
		var loadedModel = A2($author$project$Components$SettingsPage$AccountSettingsView$loadedModelFromData, data, model);
		var canCheckInvoiceDate = _Utils_eq(
			$author$project$Domain$Account$accountType(data.account),
			$author$project$Domain$Account$BrokerAccount) || data.accountSettings.factorUseSourceInvoiceDate;
		return $author$project$Ui$toHtml(
			A2(
				$author$project$Ui$stack,
				_List_fromArray(
					[$author$project$Ui$between1]),
				_List_fromArray(
					[
						$author$project$Ui$heading1('Account Settings'),
						A2(
						$author$project$Ui$stack,
						_List_fromArray(
							[$author$project$Ui$between3]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$SettingsPage$Shared$Section$viewUi,
								'Invoice Settings',
								_List_fromArray(
									[
										A4(
										$author$project$Components$SettingsPage$Account$InvoiceSettings$view,
										$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$InvoiceSettingsMsg),
										$author$project$Components$SettingsPage$EditableSection$current(loadedModel.invoiceSettingsEditableSection),
										$author$project$Domain$Account$accountType(data.account),
										data.accountSettings)
									])),
								A2(
								$author$project$Components$SettingsPage$Shared$Section$viewUi,
								'Invoice Tolerance',
								_List_fromArray(
									[
										A4(
										$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$view,
										$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$InvoiceToleranceSettingsMsg),
										$author$project$Components$SettingsPage$EditableSection$current(loadedModel.invoiceToleranceSettingsEditableSection),
										$author$project$Domain$Account$accountType(data.account),
										data.accountSettings)
									])),
								A2(
								$author$project$Components$SettingsPage$Shared$Section$viewUi,
								$author$project$Domain$Account$carrierTerm(
									$author$project$Domain$Account$accountType(data.account)) + ' Payments',
								_List_fromArray(
									[
										$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
										A2(
											$author$project$Components$SettingsPage$Account$CarrierPayments$view,
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$CarrierPaymentsMsg),
											$author$project$Components$SettingsPage$EditableSection$current(loadedModel.carrierPaymentsEditableSection)))
									])),
								A2(
								$author$project$Components$SettingsPage$AccountSettingsView$viewIf,
								data.user.isAdmin && canCheckInvoiceDate,
								A2(
									$author$project$Components$SettingsPage$Shared$Section$viewUi,
									'Exception Settings',
									_List_fromArray(
										[
											A2(
											$author$project$Components$SettingsPage$AccountSettingsView$viewExceptionSettings,
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$ExceptionOldInvoicesAfterChange),
											$author$project$Components$SettingsPage$EditableSection$current(loadedModel.validSourceDateRangeEditableSection))
										]))),
								A2(
								$author$project$Components$SettingsPage$AccountSettingsView$viewIf,
								data.user.isAdmin && _Utils_eq(data.account.tms, $author$project$AuditPb$TMSOptionCadence),
								A2(
									$author$project$Components$SettingsPage$Shared$Section$viewUi,
									'CADENCE Settings',
									_List_fromArray(
										[
											A2(
											$author$project$Components$SettingsPage$AccountSettingsView$viewCadenceSettings,
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$FailedCadenceTransmissionChange),
											$author$project$Components$SettingsPage$EditableSection$current(loadedModel.failedCadenceTransmissionRecipientsEditableSection))
										]))),
								A2($author$project$Components$SettingsPage$AccountSettingsView$viewMainSaveButton, data, loadedModel),
								A2(
								$author$project$Components$SettingsPage$AccountSettingsView$viewIf,
								$author$project$Domain$ClientNotesSidebarDisplay$isEnabled(data.accountSettings.clientNotesSidebarDisplay),
								A2(
									$author$project$Components$SettingsPage$Shared$Section$viewUi,
									'Client Notes Configuration',
									_List_fromArray(
										[
											$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
											A2(
												$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$view,
												$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$ClientNotesConfigurationMsg),
												loadedModel.clientNotesConfigurationModel))
										]))),
								A4(
								$author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$view,
								{
									internal: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$TmsReferenceFieldsMsg),
									reorder: F2(
										function (to, field) {
											return $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg(
												A2($author$project$Components$SettingsPage$AccountSettingsView$ReorderTmsReferenceFieldLabel, to, field));
										}),
									reorderDisabled: data.accountSettings.disableReorderTMSReferenceFields,
									select: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$SelectTmsReferenceFieldLabel),
									unselect: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$UnselectTmsReferenceFieldLabel)
								},
								loadedModel.visibleTmsReferenceFieldLabels,
								data.allReferenceFieldLabels,
								loadedModel.tmsReferenceFieldsState),
								A2(
								$author$project$Components$SettingsPage$Shared$Section$viewUi,
								'Custom Invoice Exception Messages',
								_List_fromArray(
									[
										A2($author$project$Components$SettingsPage$AccountSettingsView$viewCustomInvoiceExceptionMessages, model.newCustomInvoiceExceptionMessage, loadedModel.customInvoiceExceptionMessages)
									])),
								A2(
								$author$project$Components$SettingsPage$AccountSettingsView$viewIf,
								data.accountSettings.usesOfficePeopleMap,
								A2(
									$author$project$Components$SettingsPage$Shared$Section$viewUi,
									'Office-People Mappings',
									_List_fromArray(
										[
											A3($author$project$Components$SettingsPage$AccountSettingsView$viewOfficePeopleMappings, model.newOfficeMapping, model.newPeopleMapping, loadedModel.officePeopleMappings)
										]))),
								A2(
								$author$project$Components$SettingsPage$AccountSettingsView$viewIf,
								data.accountSettings.useLoadCustomerLabels,
								A2(
									$author$project$Components$SettingsPage$Shared$Section$viewUi,
									'Load Filter Labels',
									_List_fromArray(
										[
											A2($author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabels, data, model)
										]))),
								A2(
								$author$project$Components$SettingsPage$AccountSettingsView$viewIf,
								data.account.payablesAccount,
								A2(
									$author$project$Components$SettingsPage$Shared$Section$viewUi,
									'Autosend Paperwork Request Emails',
									_List_fromArray(
										[
											A2($author$project$Components$SettingsPage$AccountSettingsView$viewMissingDocumentsSettingsLegacy, data.accountSettings.sendMissingDocumentsEmailCadenceUiEnabled, loadedModel)
										]))),
								A2(
								$author$project$Components$SettingsPage$Shared$Section$viewUi,
								'Auto Reply Filters',
								_List_fromArray(
									[
										A4($author$project$Components$SettingsPage$AccountSettingsView$viewAutoReplyFilters, model.newAutoReplyFilterEmailAddress, model.newAutoReplyFilterSubject, model.newAutoReplyFilterBody, loadedModel.autoReplyFilters)
									])),
								$author$project$Ui$spacer
							]))
					])));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$SaveImplicitCarrierInvoice = {$: 'SaveImplicitCarrierInvoice'};
var $author$project$Components$SettingsPage$AccountSettingsView$ToggleCadenceSettings = function (a) {
	return {$: 'ToggleCadenceSettings', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ToggleCarrierPayments = function (a) {
	return {$: 'ToggleCarrierPayments', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ToggleExceptionSettings = function (a) {
	return {$: 'ToggleExceptionSettings', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ToggleImplicitCarrierInvoiceSection = function (a) {
	return {$: 'ToggleImplicitCarrierInvoiceSection', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ToggleImplicitCarrierInvoiceValue = function (a) {
	return {$: 'ToggleImplicitCarrierInvoiceValue', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ToggleInvoiceSettings = function (a) {
	return {$: 'ToggleInvoiceSettings', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$ToggleInvoiceToleranceSettings = function (a) {
	return {$: 'ToggleInvoiceToleranceSettings', a: a};
};
var $author$project$Helpers$Html$editButtons = function (_v0) {
	var primaryDisabled = _v0.primaryDisabled;
	var primaryLabel = _v0.primaryLabel;
	var primaryMsg = _v0.primaryMsg;
	var cancelMsg = _v0.cancelMsg;
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
				$author$project$Ui$V3$Stack$mainAxisEnd
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(cancelMsg)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
						]),
					'Cancel')),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(primaryMsg)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$disabled(primaryDisabled)
						]),
					primaryLabel))
			]));
};
var $author$project$Ui$V3$Icon$editOutline16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('m8.641 3.319 -6.596 6.596c-0.105 0.105 -0.197 0.197 -0.273 0.307q-0.102 0.145 -0.167 0.31c-0.049 0.124 -0.075 0.253 -0.104 0.401l-0.596 2.96c-0.023 0.117 -0.047 0.235 -0.058 0.335 -0.011 0.107 -0.018 0.263 0.049 0.425 0.085 0.205 0.247 0.367 0.452 0.452 0.163 0.067 0.319 0.06 0.425 0.049 0.101 -0.011 0.219 -0.035 0.335 -0.058l2.96 -0.596c0.147 -0.029 0.277 -0.055 0.401 -0.104q0.165 -0.065 0.31 -0.167c0.109 -0.076 0.203 -0.169 0.309 -0.275L14.079 5.96c0.252 -0.251 0.462 -0.461 0.62 -0.647 0.165 -0.193 0.301 -0.393 0.379 -0.633a1.833 1.833 0 0 0 0 -1.133c-0.078 -0.24 -0.215 -0.44 -0.379 -0.633 -0.158 -0.186 -0.368 -0.396 -0.62 -0.648l-0.345 -0.345c-0.252 -0.252 -0.462 -0.462 -0.648 -0.62 -0.193 -0.164 -0.393 -0.301 -0.633 -0.379a1.833 1.833 0 0 0 -1.133 0c-0.24 0.078 -0.44 0.215 -0.633 0.379 -0.185 0.158 -0.395 0.368 -0.647 0.62l-1.388 1.387 -0.005 0.006zm2.989 -1.445a0.833 0.833 0 0 1 0.515 0c0.064 0.02 0.149 0.065 0.295 0.19 0.151 0.128 0.333 0.309 0.603 0.579l0.316 0.317c0.27 0.269 0.451 0.451 0.579 0.602 0.125 0.147 0.169 0.231 0.191 0.295a0.833 0.833 0 0 1 0 0.515c-0.021 0.065 -0.067 0.149 -0.191 0.295 -0.128 0.151 -0.309 0.333 -0.579 0.602L12.333 6.293 9.707 3.667 10.733 2.641c0.269 -0.269 0.451 -0.45 0.601 -0.578 0.147 -0.125 0.231 -0.169 0.295 -0.19M9 4.373l2.627 2.627 -6.225 6.225c-0.139 0.139 -0.167 0.165 -0.195 0.185a0.533 0.533 0 0 1 -0.103 0.055c-0.031 0.013 -0.069 0.022 -0.262 0.06l-2.962 0.597 0.596 -2.962c0.039 -0.193 0.049 -0.231 0.061 -0.262a0.533 0.533 0 0 1 0.055 -0.103c0.02 -0.028 0.045 -0.056 0.183 -0.193z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$UtilityButton$Size = function (a) {
	return {$: 'Size', a: a};
};
var $author$project$Ui$V3$UtilityButton$SizeSmall = {$: 'SizeSmall'};
var $author$project$Ui$V3$UtilityButton$sizeSmall = $author$project$Ui$V3$UtilityButton$Size($author$project$Ui$V3$UtilityButton$SizeSmall);
var $author$project$Components$SettingsPage$EditableSection$view = F2(
	function (_v0, _v1) {
		var onSave = _v0.onSave;
		var onToggle = _v0.onToggle;
		var isValid = _v0.isValid;
		var viewEditing = _v0.viewEditing;
		var viewOriginal = _v0.viewOriginal;
		var title = _v0.title;
		var section = _v1.a;
		var viewEditButton = A2(
			$author$project$Ui$V3$UtilityButton$view,
			{
				icon: $author$project$Ui$V3$Icon$editOutline16,
				label: 'Edit',
				onClick: onToggle(true)
			},
			_List_fromArray(
				[$author$project$Ui$V3$UtilityButton$sizeSmall]));
		var viewCancelSaveButtons = A2(
			$elm$core$Maybe$map,
			function (editing) {
				return $author$project$Helpers$Html$editButtons(
					{
						cancelMsg: onToggle(false),
						primaryDisabled: !isValid(editing),
						primaryLabel: 'Save',
						primaryMsg: onSave
					});
			},
			section.editing);
		var isEditing = !_Utils_eq(section.editing, $elm$core$Maybe$Nothing);
		var viewContent = A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			isEditing ? _List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]) : _List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							]))),
					$elm$core$Maybe$Just(
					function () {
						var _v2 = section.editing;
						if (_v2.$ === 'Just') {
							var editing = _v2.a;
							return viewEditing(editing);
						} else {
							return viewOriginal(section.original);
						}
					}()),
					viewCancelSaveButtons
				]));
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
					$author$project$Ui$V3$Stack$styleAsCard
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$elm$core$Maybe$Just(viewContent)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					_Utils_eq(section.editing, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(viewEditButton) : $elm$core$Maybe$Nothing)
				]));
	});
var $author$project$Ui$V3$Icon$removeOutline16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M6.803 0.833c-0.26 0 -0.488 0 -0.703 0.065a1.533 1.533 0 0 0 -0.517 0.277c-0.173 0.143 -0.3 0.333 -0.444 0.549l-0.413 0.62c-0.191 0.287 -0.233 0.34 -0.277 0.376a0.533 0.533 0 0 1 -0.172 0.093c-0.053 0.016 -0.121 0.021 -0.457 0.021H2a0.5 0.5 0 0 0 0 1h12a0.5 0.5 0 0 0 0 -1h-1.82c-0.336 0 -0.403 -0.005 -0.457 -0.021a0.533 0.533 0 0 1 -0.172 -0.093c-0.044 -0.036 -0.086 -0.089 -0.277 -0.376l-0.413 -0.62c-0.144 -0.216 -0.271 -0.407 -0.444 -0.549a1.533 1.533 0 0 0 -0.517 -0.277c-0.215 -0.065 -0.443 -0.065 -0.703 -0.065zm3.597 2 -0.34 -0.51c-0.191 -0.287 -0.233 -0.34 -0.277 -0.376a0.533 0.533 0 0 0 -0.172 -0.093c-0.054 -0.016 -0.122 -0.021 -0.467 -0.021h-2.287c-0.345 0 -0.413 0.005 -0.467 0.021a0.533 0.533 0 0 0 -0.172 0.093c-0.044 0.036 -0.086 0.089 -0.277 0.376l-0.34 0.51z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2.631 5.38a0.5 0.5 0 0 1 0.995 -0.093l0.6 6.431c0.049 0.52 0.083 0.882 0.131 1.163 0.048 0.275 0.103 0.433 0.175 0.553 0.152 0.256 0.377 0.46 0.646 0.589 0.127 0.06 0.289 0.1 0.567 0.122 0.284 0.023 0.647 0.023 1.17 0.023h2.169c0.523 0 0.885 0 1.17 -0.023 0.278 -0.022 0.44 -0.063 0.567 -0.123a1.5 1.5 0 0 0 0.646 -0.588c0.071 -0.12 0.127 -0.279 0.175 -0.553 0.048 -0.281 0.083 -0.642 0.131 -1.163l0.6 -6.431a0.5 0.5 0 0 1 0.995 0.093l-0.602 6.451c-0.047 0.495 -0.083 0.896 -0.14 1.22 -0.057 0.335 -0.141 0.627 -0.3 0.893a2.5 2.5 0 0 1 -1.077 0.981c-0.281 0.133 -0.579 0.19 -0.917 0.216 -0.328 0.026 -0.73 0.026 -1.227 0.026h-2.21c-0.498 0 -0.9 0 -1.228 -0.026 -0.339 -0.027 -0.637 -0.082 -0.917 -0.215a2.5 2.5 0 0 1 -1.077 -0.981c-0.159 -0.267 -0.243 -0.559 -0.3 -0.893 -0.057 -0.324 -0.093 -0.725 -0.14 -1.22z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.833 11.667v-4.667a0.5 0.5 0 0 1 1 0v4.667a0.5 0.5 0 0 1 -1 0'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6.167 7v4.667a0.5 0.5 0 0 0 1 0v-4.667a0.5 0.5 0 0 0 -1 0'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Components$SettingsPage$AccountSettingsView$viewIconButton = F3(
	function (icon, label, onClick) {
		return A2(
			$author$project$Ui$V3$UtilityButton$view,
			{icon: icon, label: label, onClick: onClick},
			_List_fromArray(
				[$author$project$Ui$V3$UtilityButton$sizeSmall]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$deleteBtn = function (onClick) {
	return A3($author$project$Components$SettingsPage$AccountSettingsView$viewIconButton, $author$project$Ui$V3$Icon$removeOutline16, 'Delete', onClick);
};
var $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading = function (heading) {
	return A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, heading);
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewTableUnlessEmpty = F4(
	function (columns, attributes, tableAttributes, rows) {
		return $elm$core$List$isEmpty(rows) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A4($author$project$Ui$V3$Table$view, columns, attributes, tableAttributes, rows));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewAutoReplyFiltersReskin = F4(
	function (newEmailAddress, newSubject, newBody, filters) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To automatically filter out auto-reply emails, set the sender address and subject or body of emails you do not wish to see.')
							]))),
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$crossAxisBottom,
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2(
									$author$project$Helpers$Html$labeledInput,
									'Email address',
									A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterEmailAddressChange},
										_List_Nil,
										_List_Nil,
										newEmailAddress))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2(
									$author$project$Helpers$Html$labeledInput,
									'Subject',
									A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterSubjectChange},
										_List_Nil,
										_List_Nil,
										newSubject))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2(
									$author$project$Helpers$Html$labeledInput,
									'Body',
									A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$SettingsPage$AccountSettingsView$NewAutoReplyFilterBodyChange},
										_List_Nil,
										_List_Nil,
										newBody))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$AccountSettingsView$CreateAutoReplyFilter)
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Button$disabled(
											$elm$core$String$isEmpty(newEmailAddress))
										]),
									'Create new filter'))
							]))),
					A4(
					$author$project$Components$SettingsPage$AccountSettingsView$viewTableUnlessEmpty,
					{
						columns: _List_fromArray(
							[
								{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.email;
									},
									$elm$html$Html$text),
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Email Address')
							},
								{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.subject;
									},
									$elm$html$Html$text),
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Subject')
							},
								{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.body;
									},
									$elm$html$Html$text),
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Body')
							},
								{
								attrs: _List_Nil,
								content: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$AccountSettingsView$DeleteAutoReplyFilter, $author$project$Components$SettingsPage$AccountSettingsView$deleteBtn),
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Delete filter')
							}
							])
					},
					_List_Nil,
					_List_Nil,
					filters)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewCadenceSettingsV3Reskin = function (raw) {
	return $elm$core$String$isEmpty(raw.content) ? $elm$html$Html$text('Notify all admins') : A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Notify the following:')
					])),
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$elm$html$Html$text,
					A2(
						$elm$core$List$map,
						$elm$core$String$trim,
						A2($elm$core$String$split, ',', raw.content))))
			]));
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewCadenceSettingsV3ReskinEdit = F2(
	function (onChange, raw) {
		var instructions = 'Comma-separated list of emails';
		var feedback = raw.valid ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err(instructions);
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Notify when Cadence rejects invoice batch. If this is blank, all admins will be emailed.')
						])),
					A4(
					$author$project$Ui$V3$Input$view,
					{onInput: onChange},
					_List_fromArray(
						[
							$author$project$Ui$V3$Input$placeholder(instructions),
							$author$project$Ui$V3$Input$validation(feedback)
						]),
					_List_Nil,
					raw.content)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewCustomInvoiceExceptionMessagesV3Reskin = F2(
	function (newValue, messages) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just($author$project$Components$SettingsPage$AccountSettingsView$customInvoiceExceptionMessagesWarning),
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
								$author$project$Ui$V3$Stack$crossAxisBottom
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2(
									$author$project$Helpers$Html$labeledInput,
									'New message',
									A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$SettingsPage$AccountSettingsView$NewCustomInvoiceExceptionMessageChange},
										_List_Nil,
										_List_Nil,
										newValue))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick(
											$author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$CreateCustomInvoiceExceptionMessage))
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Button$disabled(
											$elm$core$String$isEmpty(newValue))
										]),
									'Create message'))
							]))),
					A4(
					$author$project$Components$SettingsPage$AccountSettingsView$viewTableUnlessEmpty,
					{
						columns: _List_fromArray(
							[
								{
								attrs: _List_Nil,
								content: $elm$html$Html$text,
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Message')
							},
								{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									$author$project$Components$SettingsPage$AccountSettingsView$DeleteCustomInvoiceExceptionMessage,
									A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$deleteBtn)),
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Delete')
							}
							])
					},
					_List_Nil,
					_List_Nil,
					messages)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewExceptionSettingsV3Reskin = F2(
	function (_v0, value) {
		return $elm$core$String$isEmpty(value) ? $elm$html$Html$text('Never create exceptions for old invoices') : $elm$html$Html$text('Create exceptions for old invoices after ' + (value + ' days'));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewExceptionSettingsV3ReskinEdit = F2(
	function (onChange, value) {
		var options = _List_fromArray(
			[
				$author$project$Components$SettingsPage$AccountSettingsView$neverOld,
				$author$project$Components$SettingsPage$AccountSettingsView$after(120),
				$author$project$Components$SettingsPage$AccountSettingsView$after(90),
				$author$project$Components$SettingsPage$AccountSettingsView$after(60),
				$author$project$Components$SettingsPage$AccountSettingsView$after(30)
			]);
		return A2(
			$author$project$Helpers$Html$labeledInput,
			'When should we create exceptions for old invoices?',
			A2(
				$author$project$Ui$V3$SimpleSelect$view,
				{
					onInput: A2($elm$core$Basics$composeR, $elm$core$Tuple$first, onChange),
					options: options,
					toLabel: $elm$core$Tuple$second,
					value: A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(value),
						A2(
							$elm$core$Dict$get,
							value,
							$elm$core$Dict$fromList(options)))
				},
				_List_Nil));
	});
var $author$project$Ui$V3$Icon$add16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$d('M8 2a1 1 0 0 0-1 1v4H3a1 1 0 0 0 0 2h4v4a1 1 0 1 0 2 0V9h4a1 1 0 1 0 0-2H9V3a1 1 0 0 0-1-1Z')
			]),
		_List_Nil));
var $author$project$Ui$V3$Icon$minus16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$d('M 13 7 L 3 7 C 2.23 7 1.749 7.833 2.134 8.5 C 2.313 8.809 2.643 9 3 9 L 13 9 C 13.77 9 14.251 8.167 13.866 7.5 C 13.687 7.191 13.357 7 13 7 Z')
			]),
		_List_Nil));
var $author$project$Ui$V3$Tooltip$FromLeft = function (a) {
	return {$: 'FromLeft', a: a};
};
var $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeadingWithToolip = F2(
	function (heading, tooltip) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorz,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$class('v3__type__extra-small-body-semi-bold'),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter,
					A2($author$project$Ui$V3$Stack$style, 'line-height', '0'),
					$author$project$Ui$V3$Stack$noWrap
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(heading),
					A3(
					$author$project$Ui$V3$Tooltip$view,
					_List_fromArray(
						[
							$author$project$Ui$V3$Tooltip$tooltipWidth(
							$author$project$Ui$V3$Tooltip$FixedWidth(205)),
							$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$BelowDirection),
							$author$project$Ui$V3$Tooltip$tooltipLocation(
							$author$project$Ui$V3$Tooltip$FromLeft('5px')),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'left', '-6px'),
							A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'top', '-12px')
						]),
					tooltip,
					A4($author$project$Ui$V3$Icon$viewCustom, '12', '12', _List_Nil, $author$project$Ui$V3$Icon$infoOutline16))
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelsTableV3Reskin = F2(
	function (data, model) {
		var rows = function () {
			var _v6 = model.newLoadCustomerLabel;
			if (_v6.$ === 'New') {
				return data.labeledCustomers;
			} else {
				var old = _v6.a.old;
				return A2(
					$elm$core$List$filter,
					function (_v7) {
						var label = _v7.a;
						return !_Utils_eq(label.name, old);
					},
					data.labeledCustomers);
			}
		}();
		var columns = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: function (_v0) {
							var loadCustomerLabel = _v0.a;
							return $elm$html$Html$text(loadCustomerLabel.name);
						},
						heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Label name')
					}),
					data.accountSettings.showCategorizedLabels ? $elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: function (_v1) {
							var loadCustomerLabel = _v1.a;
							return $elm$html$Html$text(
								$author$project$Api$LoadCustomerLabels$loadCustomerLabelNameForSource(loadCustomerLabel.source));
						},
						heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Category')
					}) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: function (_v2) {
							var loadCustomerLabel = _v2.a;
							return A3(
								$author$project$Components$SettingsPage$AccountSettingsView$viewIconButton,
								$author$project$Ui$V3$Icon$editOutline16,
								'Edit',
								$author$project$Components$SettingsPage$AccountSettingsView$EditLoadCustomerLabel(loadCustomerLabel));
						},
						heading: A2($author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeadingWithToolip, 'Editing', 'To edit, click the pencil to activate the Label Editor above.')
					}),
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: function (_v3) {
							var loadCustomerLabel = _v3.a;
							var customers = _v3.b;
							if (!_Utils_eq(
								model.showLoadCustomerLabel,
								$elm$core$Maybe$Just(loadCustomerLabel))) {
								return A3(
									$author$project$Components$SettingsPage$AccountSettingsView$viewIconButton,
									$author$project$Ui$V3$Icon$add16,
									'Open',
									$author$project$Components$SettingsPage$AccountSettingsView$ExpandLoadCustomerLabel(loadCustomerLabel));
							} else {
								var maybeCustomerId = $elm$core$List$head(
									$author$project$Components$TmsCustomerDropdown$selectedIds(model.loadCustomerTypeaheadReskin));
								return A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
										]),
									_List_fromArray(
										[
											A3($author$project$Components$SettingsPage$AccountSettingsView$viewIconButton, $author$project$Ui$V3$Icon$minus16, 'Close', $author$project$Components$SettingsPage$AccountSettingsView$CollapseLoadCustomerLabel),
											A2(
											$author$project$Ui$V3$Stack$viewVert,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (customer) {
													return A2(
														$author$project$Ui$V3$Stack$viewHorzWithWidths,
														_List_fromArray(
															[
																$author$project$Ui$V3$Stack$class('parent_for_hidden'),
																$author$project$Ui$V3$Stack$crossAxisCenter
															]),
														_List_fromArray(
															[
																_Utils_Tuple2(
																$author$project$Ui$V3$Stack$fit,
																A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('hidden_unless_parent_hovered')
																		]),
																	_List_fromArray(
																		[
																			$author$project$Components$SettingsPage$AccountSettingsView$deleteBtn(
																			A2($author$project$Components$SettingsPage$AccountSettingsView$DeleteLoadCustomerLabelCustomer, loadCustomerLabel, customer))
																		]))),
																_Utils_Tuple2(
																$author$project$Ui$V3$Stack$flex1,
																A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, customer.name))
															]));
												},
												customers)),
											A2(
											$author$project$Ui$V3$Stack$viewHorzWithWidths,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
													$author$project$Ui$V3$Stack$crossAxisBottom
												]),
											_List_fromArray(
												[
													_Utils_Tuple2(
													$author$project$Ui$V3$Stack$flex1,
													A2(
														$elm$html$Html$map,
														$author$project$Components$SettingsPage$AccountSettingsView$CustomerTypeaheadReskinMsg,
														A4(
															$author$project$Components$TmsCustomerDropdown$view,
															_List_fromArray(
																[
																	$author$project$Ui$V3$CustomSelect$label('Customer name')
																]),
															data.accountSettings,
															data.customerTypeaheadReskin,
															model.loadCustomerTypeaheadReskin))),
													_Utils_Tuple2(
													$author$project$Ui$V3$Stack$fit,
													A3(
														$author$project$Ui$V3$Button$view,
														{
															action: $author$project$Ui$V3$Button$onClick(
																function () {
																	if (maybeCustomerId.$ === 'Just') {
																		var customerId = maybeCustomerId.a;
																		return A2($author$project$Components$SettingsPage$AccountSettingsView$AddCustomerToLoadCustomerLabel, loadCustomerLabel, customerId);
																	} else {
																		return $author$project$Components$SettingsPage$AccountSettingsView$NoOp;
																	}
																}())
														},
														_List_fromArray(
															[
																$author$project$Ui$V3$Button$disabled(
																_Utils_eq(
																	$author$project$Components$TmsCustomerDropdown$selectedIds(model.loadCustomerTypeaheadReskin),
																	_List_Nil))
															]),
														'Add'))
												]))
										]));
							}
						},
						heading: A2($author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeadingWithToolip, 'Customers', 'When a customer is linked to a label, that customer\u0027s invoices will be automatically labeled.')
					}),
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: function (_v5) {
							var loadCustomerLabel = _v5.a;
							return $author$project$Components$SettingsPage$AccountSettingsView$deleteBtn(
								$author$project$Components$SettingsPage$AccountSettingsView$DeleteLoadCustomerLabel(loadCustomerLabel));
						},
						heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Delete')
					})
				]));
		return A4(
			$author$project$Ui$V3$Table$view,
			{columns: columns},
			_List_fromArray(
				[$author$project$Ui$V3$Table$noOverflow]),
			_List_Nil,
			rows);
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelsV3Reskin = F2(
	function (data, model) {
		var _v0 = function () {
			var _v1 = model.newLoadCustomerLabel;
			if (_v1.$ === 'New') {
				var x = _v1.a;
				return _Utils_Tuple2('Add', x);
			} else {
				var newSource = _v1.a.newSource;
				var _new = _v1.a._new;
				return _Utils_Tuple2(
					'Update',
					{name: _new, source: newSource});
			}
		}();
		var action = _v0.a;
		var label = _v0.b;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
									$author$project$Ui$V3$Stack$crossAxisBottom
								]),
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									$elm$core$Maybe$Just(
										A2(
											$author$project$Helpers$Html$labeledInput,
											'Add new label',
											A4(
												$author$project$Ui$V3$Input$view,
												{onInput: $author$project$Components$SettingsPage$AccountSettingsView$LoadCustomerLabelNameChange},
												_List_Nil,
												_List_Nil,
												label.name)))),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									data.accountSettings.showCategorizedLabels ? $elm$core$Maybe$Just(
										A2(
											$author$project$Ui$V3$SimpleSelect$view,
											{
												onInput: A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Components$SettingsPage$AccountSettingsView$LoadCustomerLabelSourceChange),
												options: $author$project$Api$LoadCustomerLabels$loadCustomerLabelSources,
												toLabel: $elm$core$Tuple$second,
												value: function () {
													var value = label.source;
													return A2(
														$elm$core$Maybe$map,
														$elm$core$Tuple$pair(value),
														A2(
															$elm$core$Dict$get,
															value,
															$elm$core$Dict$fromList($author$project$Api$LoadCustomerLabels$loadCustomerLabelSources)));
												}()
											},
											_List_Nil)) : $elm$core$Maybe$Nothing),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									$elm$core$Maybe$Just(
										A3(
											$author$project$Ui$V3$Button$view,
											{
												action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$AccountSettingsView$SaveLoadCustomerLabel)
											},
											_List_fromArray(
												[
													$author$project$Ui$V3$Button$disabled(
													$elm$core$String$isEmpty(label.name))
												]),
											action)))
								])),
							$elm$html$Html$text('')
						])),
					$elm$core$List$isEmpty(data.labeledCustomers) ? $elm$html$Html$text('No labels yet') : A2($author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelsTableV3Reskin, data, model)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewCadenceSelectsV3Reskin = function (loadedModel) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Ui$V3$Stack$fit,
			$elm$html$Html$text('days after delivery, then send up to')),
			_Utils_Tuple2(
			$author$project$Ui$V3$Stack$fit,
			A2(
				$author$project$Ui$V3$SimpleSelect$view,
				{
					onInput: A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailTotalCount, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg)),
					options: $author$project$Components$SettingsPage$AccountSettingsView$emailsPerLoadOptions,
					toLabel: $elm$core$Tuple$second,
					value: $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v0) {
								var count = _v0.a;
								return _Utils_eq(
									count,
									$elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailTotalCount));
							},
							$author$project$Components$SettingsPage$AccountSettingsView$emailsPerLoadOptions))
				},
				_List_Nil)),
			_Utils_Tuple2(
			$author$project$Ui$V3$Stack$fit,
			$elm$html$Html$text('emails every')),
			_Utils_Tuple2(
			$author$project$Ui$V3$Stack$fit,
			A2(
				$author$project$Ui$V3$SimpleSelect$view,
				{
					onInput: A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailInterval, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg)),
					options: $author$project$Components$SettingsPage$AccountSettingsView$intervalOptions,
					toLabel: $elm$core$Tuple$second,
					value: $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v1) {
								var days = _v1.a;
								return _Utils_eq(
									days,
									$elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailIntervalInDays));
							},
							$author$project$Components$SettingsPage$AccountSettingsView$intervalOptions))
				},
				_List_Nil)),
			_Utils_Tuple2(
			$author$project$Ui$V3$Stack$fit,
			$elm$html$Html$text('days until the documents arrive'))
		]);
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewSchedulePreview = function (loadedModel) {
	return A2(
		$elm$core$List$map,
		function (line) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(line)
					]));
		},
		$author$project$Components$SettingsPage$AccountSettingsView$schedulePreviewLines(
			$author$project$Components$SettingsPage$AccountSettingsView$scheduleSettings(loadedModel)));
};
var $author$project$Components$SettingsPage$AccountSettingsView$viewMissingDocumentsSettingsV3Reskin = F2(
	function (cadenceEnabled, loadedModel) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('checkbox'),
												$elm$html$Html$Attributes$checked(loadedModel.sendMissingDocumentsEmailsEnabled),
												$elm$html$Html$Events$onCheck(
												A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleMissingDocumentsEmails)),
												A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
											]),
										_List_Nil),
										$elm$html$Html$text('Autosend Request Emails')
									]))
							]))),
					loadedModel.sendMissingDocumentsEmailsEnabled ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
								$author$project$Ui$V3$Stack$crossAxisCenter
							]),
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									$elm$html$Html$text('Wait')),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									A2(
										$author$project$Ui$V3$SimpleSelect$view,
										{
											onInput: A2(
												$elm$core$Basics$composeR,
												$elm$core$Tuple$first,
												A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$AccountSettingsView$ChangeMissingDocumentsEmailDelay, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg)),
											options: $author$project$Components$SettingsPage$AccountSettingsView$delayOptions,
											toLabel: $elm$core$Tuple$second,
											value: $elm$core$List$head(
												A2(
													$elm$core$List$filter,
													function (_v0) {
														var hours = _v0.a;
														return _Utils_eq(
															hours,
															$elm$core$String$fromInt(loadedModel.sendMissingDocumentsEmailDelayInHours));
													},
													$author$project$Components$SettingsPage$AccountSettingsView$delayOptions))
										},
										_List_Nil))
								]),
							cadenceEnabled ? $author$project$Components$SettingsPage$AccountSettingsView$viewCadenceSelectsV3Reskin(loadedModel) : _List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									$elm$html$Html$text('days after delivery'))
								])))) : $elm$core$Maybe$Nothing,
					(loadedModel.sendMissingDocumentsEmailsEnabled && cadenceEnabled) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
							]),
						$author$project$Components$SettingsPage$AccountSettingsView$viewSchedulePreview(loadedModel))) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_Nil,
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick(
											$author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm))
									},
									_List_Nil,
									'Save'))
							])))
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$viewOfficePeopleMappingsV3Reskin = F3(
	function (newOffice, newPerson, mappings) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorz,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
										$author$project$Ui$V3$Stack$crossAxisBottom
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										A2(
											$author$project$Helpers$Html$labeledInput,
											'Office',
											A4(
												$author$project$Ui$V3$Input$view,
												{onInput: $author$project$Components$SettingsPage$AccountSettingsView$NewOfficeMappingChange},
												_List_Nil,
												_List_Nil,
												newOffice))),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										A2(
											$author$project$Helpers$Html$labeledInput,
											'Person',
											A4(
												$author$project$Ui$V3$Input$view,
												{onInput: $author$project$Components$SettingsPage$AccountSettingsView$NewPeopleMappingChange},
												_List_Nil,
												_List_Nil,
												newPerson))),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A3(
											$author$project$Ui$V3$Button$view,
											{
												action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$AccountSettingsView$CreateOfficePeopleMapping)
											},
											_List_fromArray(
												[
													$author$project$Ui$V3$Button$disabled(
													A2(
														$elm$core$List$member,
														'',
														_List_fromArray(
															[newOffice, newPerson])))
												]),
											'Add'))
									])),
								$elm$html$Html$text('')
							]))),
					A4(
					$author$project$Components$SettingsPage$AccountSettingsView$viewTableUnlessEmpty,
					{
						columns: _List_fromArray(
							[
								{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.office;
									},
									$elm$html$Html$text),
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Office')
							},
								{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.person;
									},
									$elm$html$Html$text),
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Person')
							},
								{
								attrs: _List_Nil,
								content: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$AccountSettingsView$DeleteOfficePeopleMapping, $author$project$Components$SettingsPage$AccountSettingsView$deleteBtn),
								heading: $author$project$Components$SettingsPage$AccountSettingsView$tableColumnHeading('Delete')
							}
							])
					},
					_List_Nil,
					_List_Nil,
					mappings)
				]));
	});
var $author$project$Components$SettingsPage$Account$CarrierPayments$viewV3Reskin = F2(
	function (_v0, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Payment terms: ' + ($author$project$Experimental$FormField$value(model.carrierDaysToPay) + ' days')),
					$author$project$Experimental$FormField$value(model.quickpayDiscountDisabled) ? $elm$html$Html$text('Quickpay discount: disabled') : $elm$html$Html$text(
					'Quickpay discount: ' + ($author$project$Experimental$FormField$value(model.quickpayDiscount) + '%'))
				]));
	});
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$viewDisplaySelect = F3(
	function (index, currentDisplay, onChange) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$map,
						onChange(index),
						$elm$html$Html$Events$targetValue))
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var optValue = _v0.a;
					var label = _v0.b;
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(optValue),
								$elm$html$Html$Attributes$selected(
								_Utils_eq(optValue, currentDisplay))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				},
				$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$displayOptions));
	});
var $author$project$Components$SettingsPage$Account$ClientNotesConfiguration$viewV3Reskin = F2(
	function (mapMsg, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, setting) {
						return A2(
							$elm$html$Html$div,
							A4($author$project$Components$SettingsPage$Account$ClientNotesConfiguration$dragAttrs, mapMsg, index, model.draggingIndex, model.dragOverIndex),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Stack$viewHorz,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall),
											$author$project$Ui$V3$Stack$crossAxisCenter
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'color', '#aaa'),
													A2($elm$html$Html$Attributes$style, 'user-select', 'none')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('⠿')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'min-width', '120px')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$noteLabel(setting.noteType))
												])),
											A3(
											$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$viewDisplaySelect,
											index,
											setting.display,
											F2(
												function (idx, str) {
													return mapMsg(
														A2($author$project$Components$SettingsPage$Account$ClientNotesConfiguration$SetDisplay, idx, str));
												}))
										]))
								]));
					}),
				model.settings));
	});
var $author$project$Components$SettingsPage$Account$InvoiceSettings$invoiceDateOptionsV3Reskin = _List_fromArray(
	[
		_Utils_Tuple2('receipt_date', 'The business day the document was received'),
		_Utils_Tuple2('actual_receipt_date', 'The day the document was received'),
		_Utils_Tuple2('invoice_date', 'The invoice date on the document')
	]);
var $author$project$Components$SettingsPage$Account$InvoiceSettings$invoiceDateOptionValueToSentence = function (model) {
	return 'Take invoice date from ' + function (val) {
		return $elm$core$String$toLower(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Dict$get,
					val,
					$elm$core$Dict$fromList($author$project$Components$SettingsPage$Account$InvoiceSettings$invoiceDateOptionsV3Reskin))));
	}(
		$author$project$Experimental$FormField$value(model.invoiceDateStrategy));
};
var $author$project$Components$SettingsPage$Account$InvoiceSettings$viewV3Reskin = F4(
	function (_v0, _v1, _v2, model) {
		var autoApproveView = model.autoApproveEditEnabled ? _List_fromArray(
			[
				$author$project$Experimental$FormField$value(model.autoApprove) ? $elm$html$Html$text('Auto Approve: enabled') : $elm$html$Html$text('Auto Approve: disabled')
			]) : _List_Nil;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$text(
					$author$project$Components$SettingsPage$Account$InvoiceSettings$invoiceDateOptionValueToSentence(model)),
				autoApproveView));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$displayToleranceFieldsV3Reskin = function (config) {
	var _v0 = function () {
		var _v1 = config.unitValue;
		if (_v1.$ === 'ToleranceUnitDollars') {
			return _Utils_Tuple2(
				$author$project$Domain$Tolerance$toleranceUnitToSymbol($author$project$AuditPb$ToleranceUnitDollars),
				'');
		} else {
			return _Utils_Tuple2(
				'',
				$author$project$Domain$Tolerance$toleranceUnitToSymbol($author$project$AuditPb$ToleranceUnitPercentage));
		}
	}();
	var prefix = _v0.a;
	var suffix = _v0.b;
	var lowerToleranceValue = _Utils_ap(
		prefix,
		_Utils_ap(config.lowerValue, suffix));
	var lowerToleranceColumn = A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, config.lowerLabel),
				A2($author$project$Ui$V3$Typography$body, _List_Nil, lowerToleranceValue)
			]));
	var upperToleranceValue = _Utils_ap(
		prefix,
		_Utils_ap(config.upperValue, suffix));
	var upperToleranceColumn = A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, config.upperLabel),
				A2($author$project$Ui$V3$Typography$body, _List_Nil, upperToleranceValue)
			]));
	var toleranceRow = A2(
		$author$project$Ui$V3$Stack$viewHorz,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_fromArray(
			[lowerToleranceColumn, upperToleranceColumn]));
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, config.header),
				A2($elm$core$List$cons, toleranceRow, config.additionalContent)))
		]);
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$ltlToleranceFieldsIfEnabledV3Reskin = F3(
	function (_v0, model, accountSettings) {
		return accountSettings.ltlTolerancesEnabled ? $author$project$Components$SettingsPage$Shared$Tolerance$displayToleranceFieldsV3Reskin(
			{
				additionalContent: _List_Nil,
				header: 'Less-than-truckload',
				lowerLabel: 'Lower Tolerance Limit',
				lowerValue: $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceUnder),
				unitValue: $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceUnit),
				upperLabel: 'Upper Tolerance Limit',
				upperValue: $author$project$Experimental$FormField$value(model.ltlCarrierInvoiceAmountToleranceOver)
			}) : _List_Nil;
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$sectionDisplayDisabledV3Reskin = function (header) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, header),
					A2($author$project$Ui$V3$Typography$body, _List_Nil, 'Disabled')
				]))
		]);
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$marginToleranceFieldsIfEnabledV3Reskin = F3(
	function (_v0, model, accountSettings) {
		if (accountSettings.ltlCustomerMarginToleranceEnabled) {
			var minimum = $author$project$Experimental$FormField$value(model.ltlMarginToleranceMinimum);
			var maximum = $author$project$Experimental$FormField$value(model.ltlMarginToleranceMaximum);
			var header = 'Less-than-truckload margin tolerance';
			return ($elm$core$String$isEmpty(maximum) || $elm$core$String$isEmpty(minimum)) ? $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$sectionDisplayDisabledV3Reskin(header) : $author$project$Components$SettingsPage$Shared$Tolerance$displayToleranceFieldsV3Reskin(
				{
					additionalContent: _List_Nil,
					header: header,
					lowerLabel: 'Minimum',
					lowerValue: $author$project$Money$toStringWithoutPrefixOrCommas(
						$author$project$Money$castFromString(minimum)),
					unitValue: $author$project$Experimental$FormField$value(model.ltlMarginToleranceUnit),
					upperLabel: 'Maximum',
					upperValue: $author$project$Money$toStringWithoutPrefixOrCommas(
						$author$project$Money$castFromString(maximum))
				});
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceFieldsIfEnabledV3Reskin = F3(
	function (_v0, model, accountSettings) {
		var lineItemTypeName = A2(
			$elm$core$Maybe$withDefault,
			'None',
			A2(
				$elm$core$Maybe$andThen,
				function (selectedId) {
					return A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.description;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (lineItemType) {
									return _Utils_eq(lineItemType.id, selectedId);
								},
								accountSettings.tmsLineItemTypes)));
				},
				$author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceLineItemTypeId)));
		var lineItemTypeValue = (lineItemTypeName === 'None') ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'color', 'var(--color-gray-400)')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(lineItemTypeName)
				])) : A2($author$project$Ui$V3$Typography$body, _List_Nil, lineItemTypeName);
		var lineItemTypeDisplay = (accountSettings.lineItemVisibility !== 'hidden') ? _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
						A2($author$project$Ui$V3$Stack$style, 'max-width', '75%')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Line Item Type'),
						lineItemTypeValue,
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', 'var(--color-gray-400)'),
								A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
								A2($elm$html$Html$Attributes$style, 'line-height', '1.4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Discrepancies between expected and approved invoice amount will return to the TMS under this line item type.')
							]))
					]))
			]) : _List_Nil;
		return $author$project$Components$SettingsPage$Shared$Tolerance$displayToleranceFieldsV3Reskin(
			{
				additionalContent: lineItemTypeDisplay,
				header: 'Default',
				lowerLabel: 'Lower Tolerance Limit',
				lowerValue: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceUnder),
				unitValue: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceUnit),
				upperLabel: 'Upper Tolerance Limit',
				upperValue: $author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceOver)
			});
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$viewV3Reskin = F3(
	function (mapMsg, accountSettings, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$author$project$Ui$V3$Typography$smallBodyClass]),
					_List_fromArray(
						[
							$elm$html$Html$text('Create exception if invoice amount outside indicated tolerance')
						])),
				_Utils_ap(
					A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceFieldsIfEnabledV3Reskin, mapMsg, model, accountSettings),
					_Utils_ap(
						A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$ltlToleranceFieldsIfEnabledV3Reskin, mapMsg, model, accountSettings),
						A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$marginToleranceFieldsIfEnabledV3Reskin, mapMsg, model, accountSettings)))));
	});
var $author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$viewV3Reskin = F2(
	function (typeDisplay, enabled) {
		var settingDisplay = enabled ? 'Enable' : 'Disable';
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$implicitInvoiceHelpText(typeDisplay),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Current Setting: '),
							A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, settingDisplay)
						]))
				]));
	});
var $author$project$Ui$V3$Input$MinAttribute = function (a) {
	return {$: 'MinAttribute', a: a};
};
var $author$project$Ui$V3$Input$min = $author$project$Ui$V3$Input$MinAttribute;
var $author$project$Ui$V3$Input$numberInput = $author$project$Ui$V3$Input$TypeAttribute('number');
var $author$project$Ui$V3$Input$TrailingTextInBoxAttribute = function (a) {
	return {$: 'TrailingTextInBoxAttribute', a: a};
};
var $author$project$Ui$V3$Input$trailingTextInBox = $author$project$Ui$V3$Input$TrailingTextInBoxAttribute;
var $author$project$Components$SettingsPage$Account$CarrierPayments$paymentTermsViewV3Reskin = F2(
	function (carrierDaysToPay, onChange) {
		return A2(
			$author$project$Helpers$Html$labeledInput,
			'Payment terms',
			A4(
				$author$project$Ui$V3$Input$view,
				{onInput: onChange},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$numberInput,
						$author$project$Ui$V3$Input$min('0'),
						$author$project$Ui$V3$Input$trailingTextInBox(
						{text: 'days', width: 60}),
						$author$project$Ui$V3$Input$validation(
						$author$project$Components$SettingsPage$Account$CarrierPayments$validatePaymentTerms(carrierDaysToPay))
					]),
				_List_Nil,
				$author$project$Experimental$FormField$value(carrierDaysToPay)));
	});
var $author$project$Components$SettingsPage$Account$CarrierPayments$quickpayDiscountDisabledViewV3Reskin = F2(
	function (quickpayDiscountDisabled, onChange) {
		return A2(
			$author$project$Ui$V3$Checkbox$view,
			{
				checked: quickpayDiscountDisabled,
				label: $elm$html$Html$text('Disable quickpay discount'),
				onCheck: onChange
			},
			_List_Nil);
	});
var $author$project$Ui$V3$Input$MaxAttribute = function (a) {
	return {$: 'MaxAttribute', a: a};
};
var $author$project$Ui$V3$Input$max = $author$project$Ui$V3$Input$MaxAttribute;
var $author$project$Components$SettingsPage$Account$CarrierPayments$quickpayDiscountViewV3Reskin = F2(
	function (model, onChange) {
		return A2(
			$author$project$Helpers$Html$labeledInput,
			'Quickpay discount',
			A4(
				$author$project$Ui$V3$Input$view,
				{onInput: onChange},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$numberInput,
						$author$project$Ui$V3$Input$min('0'),
						$author$project$Ui$V3$Input$max('100'),
						$author$project$Ui$V3$Input$trailingTextInBox(
						{text: '%', width: 40}),
						$author$project$Ui$V3$Input$disabled(
						$author$project$Experimental$FormField$value(model.quickpayDiscountDisabled)),
						$author$project$Ui$V3$Input$validation(
						$author$project$Components$SettingsPage$Account$CarrierPayments$validateQuickpayDiscount(model))
					]),
				_List_Nil,
				$author$project$Experimental$FormField$value(model.quickpayDiscountDisabled) ? '' : $author$project$Experimental$FormField$value(model.quickpayDiscount)));
	});
var $author$project$Components$SettingsPage$Account$CarrierPayments$viewV3ReskinEdit = F2(
	function (mapMsg, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fitPx(160),
							A2(
								$author$project$Components$SettingsPage$Account$CarrierPayments$paymentTermsViewV3Reskin,
								model.carrierDaysToPay,
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateCarrierDaysToPay, mapMsg)))
						])),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fitPx(160),
							A2(
								$author$project$Components$SettingsPage$Account$CarrierPayments$quickpayDiscountViewV3Reskin,
								model,
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateQuickpayDiscount, mapMsg)))
						])),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Components$SettingsPage$Account$CarrierPayments$quickpayDiscountDisabledViewV3Reskin,
								$author$project$Experimental$FormField$value(model.quickpayDiscountDisabled),
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$CarrierPayments$UpdateQuickpayDiscountDisabled, mapMsg)))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Account$InvoiceSettings$viewV3ReskinEdit = F4(
	function (mapMsg, _v0, _v1, model) {
		var autoApproveEditView = model.autoApproveEditEnabled ? _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Checkbox$view,
				{
					checked: $author$project$Experimental$FormField$value(model.autoApprove),
					label: $elm$html$Html$text('Auto Approve Invoices (Hide Processed Queue)'),
					onCheck: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceSettings$UpdateAutoApprove, mapMsg)
				},
				_List_Nil)
			]) : _List_Nil;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Helpers$Html$labeledInput,
					'Take invoice date from',
					A2(
						$author$project$Ui$V3$SimpleSelect$view,
						{
							onInput: A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceSettings$UpdateDateStrategy, mapMsg)),
							options: $author$project$Components$SettingsPage$Account$InvoiceSettings$invoiceDateOptionsV3Reskin,
							toLabel: $elm$core$Tuple$second,
							value: function (val) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$pair(val),
									A2(
										$elm$core$Dict$get,
										val,
										$elm$core$Dict$fromList($author$project$Components$SettingsPage$Account$InvoiceSettings$invoiceDateOptionsV3Reskin)));
							}(
								$author$project$Experimental$FormField$value(model.invoiceDateStrategy))
						},
						_List_Nil)),
				autoApproveEditView));
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceUnitV3Reskin = function (a) {
	return {$: 'UpdateLtlAmountToleranceUnitV3Reskin', a: a};
};
var $author$project$Ui$V3$Input$LeadingTextInBoxAttribute = function (a) {
	return {$: 'LeadingTextInBoxAttribute', a: a};
};
var $author$project$Ui$V3$Input$leadingTextInBox = $author$project$Ui$V3$Input$LeadingTextInBoxAttribute;
var $author$project$Components$SettingsPage$Shared$Tolerance$maybeEditToleranceFieldsV3Reskin = function (config) {
	var labelPrefix = $author$project$Domain$Tolerance$toleranceUnitToSymbol(config.unitValue);
	var inputDisabled = function () {
		var _v0 = config.maybeEnabledValue;
		if (_v0.$ === 'Just') {
			var enabled = _v0.a;
			return !enabled;
		} else {
			return false;
		}
	}();
	return inputDisabled ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Helpers$Html$labeledInput,
						'Type',
						A2(
							$author$project$Ui$V3$SimpleSelect$view,
							{
								onInput: config.onUnitChange,
								options: $author$project$AuditPb$allToleranceUnit,
								toLabel: $author$project$Components$SettingsPage$Shared$Tolerance$toleranceUnitDisplay,
								value: $elm$core$Maybe$Just(config.unitValue)
							},
							_List_Nil))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Helpers$Html$labeledInput,
						config.lowerValueLabel,
						A4(
							$author$project$Ui$V3$Input$view,
							{onInput: config.onLowerChange},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$leadingTextInBox(labelPrefix),
									$author$project$Ui$V3$Input$placeholder('0.00'),
									$author$project$Ui$V3$Input$validation(config.lowerValidation)
								]),
							_List_Nil,
							config.lowerValue))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Helpers$Html$labeledInput,
						config.upperValueLabel,
						A4(
							$author$project$Ui$V3$Input$view,
							{onInput: config.onUpperChange},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$leadingTextInBox(labelPrefix),
									$author$project$Ui$V3$Input$placeholder('0.00'),
									$author$project$Ui$V3$Input$validation(config.upperValidation)
								]),
							_List_Nil,
							config.upperValue)))
				])));
};
var $author$project$Components$SettingsPage$Shared$Tolerance$maybeEnableToleranceEditV3Reskin = F2(
	function (maybeOnEnabledChange, maybeEnabled) {
		var _v0 = _Utils_Tuple2(maybeOnEnabledChange, maybeEnabled);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var onEnabledChange = _v0.a.a;
			var enabled = _v0.b.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Checkbox$view,
							{
								checked: enabled,
								label: $elm$html$Html$text('Enabled'),
								onCheck: onEnabledChange
							},
							_List_Nil)
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$editFieldsDisplayV3Reskin = function (config) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, config.header)),
					A2($author$project$Components$SettingsPage$Shared$Tolerance$maybeEnableToleranceEditV3Reskin, config.maybeOnEnabledChange, config.maybeEnabledValue),
					$author$project$Components$SettingsPage$Shared$Tolerance$maybeEditToleranceFieldsV3Reskin(config)
				]))
		]);
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$editToleranceFields = F2(
	function (mapMsg, config) {
		return _Utils_ap(
			$author$project$Components$SettingsPage$Shared$Tolerance$editFieldsDisplayV3Reskin(
				{
					header: config.header,
					lowerValidation: $author$project$Domain$Tolerance$validateToleranceValue(
						$author$project$Experimental$FormField$value(config.lowerValue)),
					lowerValue: $author$project$Experimental$FormField$value(config.lowerValue),
					lowerValueLabel: config.lowerValueLabel,
					maybeEnabledValue: config.maybeEnabledValue,
					maybeOnEnabledChange: A2(
						$elm$core$Maybe$map,
						function (onChange) {
							return A2($elm$core$Basics$composeR, onChange, mapMsg);
						},
						config.maybeOnEnabledChange),
					onLowerChange: A2($elm$core$Basics$composeR, config.onLowerChange, mapMsg),
					onUnitChange: A2($elm$core$Basics$composeR, config.onUnitChange, mapMsg),
					onUpperChange: A2($elm$core$Basics$composeR, config.onUpperChange, mapMsg),
					unitValue: $author$project$Experimental$FormField$value(config.unitValue),
					upperValidation: $author$project$Domain$Tolerance$validateToleranceValue(
						$author$project$Experimental$FormField$value(config.upperValue)),
					upperValue: $author$project$Experimental$FormField$value(config.upperValue),
					upperValueLabel: config.upperValueLabel
				}),
			config.additionalContent);
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$ltlToleranceFieldsIfEnabledV3ReskinEdit = F3(
	function (mapMsg, model, accountSettings) {
		return accountSettings.ltlTolerancesEnabled ? A2(
			$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$editToleranceFields,
			mapMsg,
			{additionalContent: _List_Nil, header: 'Less-than-truckload', lowerValue: model.ltlCarrierInvoiceAmountToleranceUnder, lowerValueLabel: 'Lower tolerance', maybeEnabledValue: $elm$core$Maybe$Nothing, maybeOnEnabledChange: $elm$core$Maybe$Nothing, onLowerChange: $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceUnder, onUnitChange: $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceUnitV3Reskin, onUpperChange: $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlAmountToleranceOver, unitValue: model.ltlCarrierInvoiceAmountToleranceUnit, upperValue: model.ltlCarrierInvoiceAmountToleranceOver, upperValueLabel: 'Upper tolerance'}) : _List_Nil;
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceUnitV3Reskin = function (a) {
	return {$: 'UpdateLtlMarginToleranceUnitV3Reskin', a: a};
};
var $author$project$Domain$Tolerance$validateMarginValue = F3(
	function (value, isEnabled, minimumValue) {
		if (!isEnabled) {
			return $elm$core$Result$Ok(_Utils_Tuple0);
		} else {
			if ($elm$core$String$isEmpty(value)) {
				return $elm$core$Result$Err('Cannot be blank');
			} else {
				var _v0 = $elm$core$String$toFloat(value);
				if (_v0.$ === 'Nothing') {
					return $elm$core$Result$Err('Must be a number');
				} else {
					var n = _v0.a;
					return (_Utils_cmp(n, minimumValue) > -1) ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err(
						'Must be greater than or equal to ' + $elm$core$String$fromFloat(minimumValue));
				}
			}
		}
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$editMarginToleranceFields = F2(
	function (mapMsg, model) {
		return $author$project$Components$SettingsPage$Shared$Tolerance$editFieldsDisplayV3Reskin(
			{
				header: 'Less-than-truckload margin tolerance',
				lowerValidation: A3(
					$author$project$Domain$Tolerance$validateMarginValue,
					$author$project$Experimental$FormField$value(model.ltlMarginToleranceMinimum),
					$author$project$Experimental$FormField$value(model.ltlMarginToleranceEnabled),
					0),
				lowerValue: $author$project$Experimental$FormField$value(model.ltlMarginToleranceMinimum),
				lowerValueLabel: 'Minimum',
				maybeEnabledValue: $elm$core$Maybe$Just(
					$author$project$Experimental$FormField$value(model.ltlMarginToleranceEnabled)),
				maybeOnEnabledChange: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceEnabled, mapMsg)),
				onLowerChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceMinimum, mapMsg),
				onUnitChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceUnitV3Reskin, mapMsg),
				onUpperChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateLtlMarginToleranceMaximum, mapMsg),
				unitValue: $author$project$Experimental$FormField$value(model.ltlMarginToleranceUnit),
				upperValidation: A3(
					$author$project$Domain$Tolerance$validateMarginValue,
					$author$project$Experimental$FormField$value(model.ltlMarginToleranceMaximum),
					$author$project$Experimental$FormField$value(model.ltlMarginToleranceEnabled),
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toFloat(
							$author$project$Experimental$FormField$value(model.ltlMarginToleranceMinimum)))),
				upperValue: $author$project$Experimental$FormField$value(model.ltlMarginToleranceMaximum),
				upperValueLabel: 'Maximum'
			});
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$marginToleranceFieldsIfEnabledV3ReskinEdit = F3(
	function (mapMsg, model, accountSettings) {
		return accountSettings.ltlCustomerMarginToleranceEnabled ? A2($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$editMarginToleranceFields, mapMsg, model) : _List_Nil;
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceUnitV3Reskin = function (a) {
	return {$: 'UpdateAmountToleranceUnitV3Reskin', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceLineItemType = function (a) {
	return {$: 'UpdateAmountToleranceLineItemType', a: a};
};
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$lineItemTypeDropdownIfNeeded = F3(
	function (mapMsg, model, accountSettings) {
		return (accountSettings.lineItemVisibility !== 'hidden') ? _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
						A2($author$project$Ui$V3$Stack$style, 'max-width', '75%')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'TMS Line Item Type for Amount Differences'),
						A2(
						$author$project$Ui$V3$SimpleSelect$view,
						{
							onInput: function (lineItemType) {
								return mapMsg(
									$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceLineItemType(
										$elm$core$Maybe$Just(lineItemType.id)));
							},
							options: accountSettings.tmsLineItemTypes,
							toLabel: function ($) {
								return $.description;
							},
							value: A2(
								$elm$core$Maybe$andThen,
								function (selectedId) {
									return $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (lineItemType) {
												return _Utils_eq(lineItemType.id, selectedId);
											},
											accountSettings.tmsLineItemTypes));
								},
								$author$project$Experimental$FormField$value(model.carrierInvoiceAmountToleranceLineItemTypeId))
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$SimpleSelect$placeholder(
								$elm$core$Maybe$Just('None'))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', 'var(--color-gray-400)'),
								$elm$html$Html$Attributes$class('v3__typography__x-small-body')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Discrepancies between expected and approved invoice amount will return to the TMS under this line item type.')
							]))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceFieldsIfEnabledV3ReskinEdit = F3(
	function (mapMsg, model, accountSettings) {
		return A2(
			$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$editToleranceFields,
			mapMsg,
			{
				additionalContent: A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$lineItemTypeDropdownIfNeeded, mapMsg, model, accountSettings),
				header: 'Default',
				lowerValue: model.carrierInvoiceAmountToleranceUnder,
				lowerValueLabel: 'Lower tolerance',
				maybeEnabledValue: $elm$core$Maybe$Nothing,
				maybeOnEnabledChange: $elm$core$Maybe$Nothing,
				onLowerChange: $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceUnder,
				onUnitChange: $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceUnitV3Reskin,
				onUpperChange: $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$UpdateAmountToleranceOver,
				unitValue: model.carrierInvoiceAmountToleranceUnit,
				upperValue: model.carrierInvoiceAmountToleranceOver,
				upperValueLabel: 'Upper tolerance'
			});
	});
var $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$viewV3ReskinEdit = F3(
	function (mapMsg, accountSettings, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_Utils_ap(
				A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$toleranceFieldsIfEnabledV3ReskinEdit, mapMsg, model, accountSettings),
				_Utils_ap(
					A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$ltlToleranceFieldsIfEnabledV3ReskinEdit, mapMsg, model, accountSettings),
					A3($author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$marginToleranceFieldsIfEnabledV3ReskinEdit, mapMsg, model, accountSettings))));
	});
var $author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$viewV3ReskinEdit = F3(
	function (typeDisplay, onCheck, enabled) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$implicitInvoiceHelpText(typeDisplay),
					A2(
					$author$project$Ui$V3$Checkbox$view,
					{
						checked: enabled,
						label: $elm$html$Html$text('Enable'),
						onCheck: onCheck
					},
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$v3ReskinView = F2(
	function (data, model) {
		var loadedModel = A2($author$project$Components$SettingsPage$AccountSettingsView$loadedModelFromData, data, model);
		var halfWidthContainer = function (contents) {
			return A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, contents),
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Helpers$Html$empty)
					]));
		};
		var cardSection = F2(
			function (title, contents) {
				return A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$styleAsCard,
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
							$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceSmall)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
								]),
							contents)
						]));
			});
		var accountType = $author$project$Domain$Account$accountType(data.account);
		var canCheckInvoiceDate = _Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) || data.accountSettings.factorUseSourceInvoiceDate;
		var showImplicitInvoice = _Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) && data.accountSettings.tempAllowCarrierLevelImplicitInvoice;
		var showTolerances = _Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount);
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Account settings')
						])),
					A2(
					$author$project$Ui$V3$Stack$viewVertMaybes,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
						]),
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							halfWidthContainer(
								A2(
									$author$project$Components$SettingsPage$EditableSection$view,
									{
										isValid: $author$project$Components$SettingsPage$Account$InvoiceSettings$isValid,
										onSave: $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm),
										onToggle: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleInvoiceSettings),
										title: 'Invoice settings',
										viewEditing: A3(
											$author$project$Components$SettingsPage$Account$InvoiceSettings$viewV3ReskinEdit,
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$InvoiceSettingsMsg),
											accountType,
											data.accountSettings),
										viewOriginal: A3(
											$author$project$Components$SettingsPage$Account$InvoiceSettings$viewV3Reskin,
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$InvoiceSettingsMsg),
											accountType,
											data.accountSettings)
									},
									loadedModel.invoiceSettingsEditableSection))),
							showTolerances ? $elm$core$Maybe$Just(
							halfWidthContainer(
								A2(
									$author$project$Components$SettingsPage$EditableSection$view,
									{
										isValid: $author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$isValid(data.accountSettings),
										onSave: $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm),
										onToggle: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleInvoiceToleranceSettings),
										title: 'Invoice tolerance',
										viewEditing: A2(
											$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$viewV3ReskinEdit,
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$InvoiceToleranceSettingsMsg),
											data.accountSettings),
										viewOriginal: A2(
											$author$project$Components$SettingsPage$Account$InvoiceToleranceSettings$viewV3Reskin,
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$InvoiceToleranceSettingsMsg),
											data.accountSettings)
									},
									loadedModel.invoiceToleranceSettingsEditableSection))) : $elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(
							halfWidthContainer(
								A2(
									$author$project$Components$SettingsPage$EditableSection$view,
									{
										isValid: $author$project$Components$SettingsPage$Account$CarrierPayments$isValid,
										onSave: $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm),
										onToggle: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleCarrierPayments),
										title: $author$project$Domain$Account$carrierTerm(
											$author$project$Domain$Account$accountType(data.account)) + ' payments',
										viewEditing: $author$project$Components$SettingsPage$Account$CarrierPayments$viewV3ReskinEdit(
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$CarrierPaymentsMsg)),
										viewOriginal: $author$project$Components$SettingsPage$Account$CarrierPayments$viewV3Reskin(
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$CarrierPaymentsMsg))
									},
									loadedModel.carrierPaymentsEditableSection))),
							$author$project$Domain$ClientNotesSidebarDisplay$isEnabled(data.accountSettings.clientNotesSidebarDisplay) ? $elm$core$Maybe$Just(
							halfWidthContainer(
								A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$styleAsCard,
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
											$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceSmall)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Client Notes Configuration')
												])),
											A2(
											$author$project$Components$SettingsPage$Account$ClientNotesConfiguration$viewV3Reskin,
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$ClientNotesConfigurationMsg),
											loadedModel.clientNotesConfigurationModel)
										])))) : $elm$core$Maybe$Nothing,
							(data.user.isAdmin && canCheckInvoiceDate) ? $elm$core$Maybe$Just(
							halfWidthContainer(
								A2(
									$author$project$Components$SettingsPage$EditableSection$view,
									{
										isValid: $elm$core$Basics$always(true),
										onSave: $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm),
										onToggle: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleExceptionSettings),
										title: 'Exception settings',
										viewEditing: $author$project$Components$SettingsPage$AccountSettingsView$viewExceptionSettingsV3ReskinEdit(
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$ExceptionOldInvoicesAfterChange)),
										viewOriginal: $author$project$Components$SettingsPage$AccountSettingsView$viewExceptionSettingsV3Reskin(
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$ExceptionOldInvoicesAfterChange))
									},
									loadedModel.validSourceDateRangeEditableSection))) : $elm$core$Maybe$Nothing,
							(data.user.isAdmin && _Utils_eq(data.account.tms, $author$project$AuditPb$TMSOptionCadence)) ? $elm$core$Maybe$Just(
							halfWidthContainer(
								A2(
									$author$project$Components$SettingsPage$EditableSection$view,
									{
										isValid: $elm$core$Basics$always(true),
										onSave: $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveMainForm),
										onToggle: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleCadenceSettings),
										title: 'Cadence settings',
										viewEditing: $author$project$Components$SettingsPage$AccountSettingsView$viewCadenceSettingsV3ReskinEdit(
											$author$project$Components$SettingsPage$AccountSettingsView$afterLoad($author$project$Components$SettingsPage$AccountSettingsView$FailedCadenceTransmissionChange)),
										viewOriginal: $author$project$Components$SettingsPage$AccountSettingsView$viewCadenceSettingsV3Reskin
									},
									loadedModel.failedCadenceTransmissionRecipientsEditableSection))) : $elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(
							halfWidthContainer(
								A2(
									cardSection,
									'Custom invoice exception messages',
									_List_fromArray(
										[
											A2($author$project$Components$SettingsPage$AccountSettingsView$viewCustomInvoiceExceptionMessagesV3Reskin, model.newCustomInvoiceExceptionMessage, loadedModel.customInvoiceExceptionMessages)
										])))),
							showImplicitInvoice ? $elm$core$Maybe$Just(
							halfWidthContainer(
								A2(
									$author$project$Components$SettingsPage$EditableSection$view,
									{
										isValid: $elm$core$Basics$always(true),
										onSave: $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg($author$project$Components$SettingsPage$AccountSettingsView$SaveImplicitCarrierInvoice),
										onToggle: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleImplicitCarrierInvoiceSection),
										title: 'Implicit invoice',
										viewEditing: A2(
											$author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$viewV3ReskinEdit,
											'account',
											A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$AccountSettingsView$LoadedMsg, $author$project$Components$SettingsPage$AccountSettingsView$ToggleImplicitCarrierInvoiceValue)),
										viewOriginal: $author$project$Components$SettingsPage$Shared$ImplicitInvoiceSettings$viewV3Reskin('account')
									},
									loadedModel.allowImplicitCarrierInvoiceEditableSection))) : $elm$core$Maybe$Nothing,
							data.accountSettings.usesOfficePeopleMap ? $elm$core$Maybe$Just(
							A2(
								cardSection,
								'Office-people mappings',
								_List_fromArray(
									[
										A3($author$project$Components$SettingsPage$AccountSettingsView$viewOfficePeopleMappingsV3Reskin, model.newOfficeMapping, model.newPeopleMapping, loadedModel.officePeopleMappings)
									]))) : $elm$core$Maybe$Nothing,
							data.accountSettings.useLoadCustomerLabels ? $elm$core$Maybe$Just(
							A2(
								cardSection,
								'Load filter labels',
								_List_fromArray(
									[
										A2($author$project$Components$SettingsPage$AccountSettingsView$viewLoadCustomerLabelsV3Reskin, data, model)
									]))) : $elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(
							A2(
								cardSection,
								'Auto reply filters',
								_List_fromArray(
									[
										A4($author$project$Components$SettingsPage$AccountSettingsView$viewAutoReplyFiltersReskin, model.newAutoReplyFilterEmailAddress, model.newAutoReplyFilterSubject, model.newAutoReplyFilterBody, loadedModel.autoReplyFilters)
									]))),
							data.account.payablesAccount ? $elm$core$Maybe$Just(
							A2(
								cardSection,
								'Autosend Paperwork Request Emails',
								_List_fromArray(
									[
										A2($author$project$Components$SettingsPage$AccountSettingsView$viewMissingDocumentsSettingsV3Reskin, data.accountSettings.sendMissingDocumentsEmailCadenceUiEnabled, loadedModel)
									]))) : $elm$core$Maybe$Nothing
						]))
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$authorizedView = F3(
	function (v3ReskinEnabled, data, model) {
		return A2(
			$author$project$Helpers$WaitingSpinner$waitingSpinner,
			model.isSaving,
			v3ReskinEnabled ? _List_fromArray(
				[
					A2($author$project$Components$SettingsPage$AccountSettingsView$v3ReskinView, data, model)
				]) : _List_fromArray(
				[
					A2($author$project$Components$SettingsPage$AccountSettingsView$legacyView, data, model)
				]));
	});
var $author$project$Components$SettingsPage$AccountSettingsView$view = F3(
	function (v3ReskinEnabled, data, model) {
		return data.user.hasSettingsRole ? A3($author$project$Components$SettingsPage$AccountSettingsView$authorizedView, v3ReskinEnabled, data, model) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$ViewCreateContact = {$: 'ViewCreateContact'};
var $author$project$Components$SettingsPage$ContactsSettingsView$ViewList = {$: 'ViewList'};
var $author$project$Components$SettingsPage$ContactsSettingsView$DeleteContact = function (a) {
	return {$: 'DeleteContact', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettingsView$deleteButtonView = function (contactId) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button--caution'),
				$elm$html$Html$Events$onClick(
				$author$project$Components$SettingsPage$ContactsSettingsView$DeleteContact(contactId))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-trash')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' Delete')
					]))
			]));
};
var $author$project$Components$SettingsPage$ContactsSettingsView$ViewEditContact = F3(
	function (a, b, c) {
		return {$: 'ViewEditContact', a: a, b: b, c: c};
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$editButtonView = F3(
	function (contactId, form, maybeTmsCarrier) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button--confirmation'),
					$elm$html$Html$Events$onClick(
					A3($author$project$Components$SettingsPage$ContactsSettingsView$ViewEditContact, contactId, form, maybeTmsCarrier))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-pencil')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' Edit')
						]))
				]));
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$linkToCarrierBaseUrl = '/app/settings/carriers/';
var $author$project$Components$SettingsPage$ContactsSettingsView$tmsCarrierIdToString = function (tmsCarrierId) {
	return $elm$core$String$fromInt(
		$author$project$Domain$TmsCarrierId$toInt(tmsCarrierId));
};
var $author$project$Domain$ContactIdsQuery$typeAsString = function (contactType) {
	return $author$project$AuditPb$contactTypeToString(contactType);
};
var $author$project$Components$SettingsPage$ContactsSettingsView$viewCarrierContactName = function (contact) {
	var _v0 = contact.name;
	if (_v0.$ === 'Just') {
		var name = _v0.a;
		return A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	} else {
		return A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				]));
	}
};
var $author$project$Components$SettingsPage$ContactsSettingsView$viewMultiCarrierContactName = function (contact) {
	var _v0 = contact.name;
	if (_v0.$ === 'Just') {
		var name = _v0.a;
		return A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	} else {
		return A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				]));
	}
};
var $author$project$Components$SettingsPage$ContactsSettingsView$contactView = F2(
	function (account, contact) {
		var typeAsString = function (type_) {
			return $author$project$Domain$ContactIdsQuery$typeAsString(type_);
		};
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(account));
		var _v0 = contact.contact.contactType;
		if (_v0.$ === 'Contact_ContactType_MultiCarrierContact') {
			var contact_ = _v0.a;
			var updateContactForm = {
				carrier_id: $elm$core$Maybe$Nothing,
				contact_type: typeAsString($author$project$AuditPb$ContactTypeGeneral),
				email: contact_.email,
				name: A2($elm$core$Maybe$withDefault, '', contact_.name)
			};
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('contacts__table-large')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(contact_.email)
							])),
						$author$project$Components$SettingsPage$ContactsSettingsView$viewMultiCarrierContactName(contact_),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('contacts__table-large')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('General - No ' + carrierTerm)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('contacts__table-small')
							]),
						_List_fromArray(
							[
								A3($author$project$Components$SettingsPage$ContactsSettingsView$editButtonView, contact_.id, updateContactForm, contact.carrier)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('contacts__table-small')
							]),
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$ContactsSettingsView$deleteButtonView(contact_.id)
							]))
					]));
		} else {
			var contact_ = _v0.a;
			var updateContactForm = {
				carrier_id: $elm$core$Maybe$Nothing,
				contact_type: typeAsString($author$project$AuditPb$ContactTypeCarrier),
				email: contact_.email,
				name: A2($elm$core$Maybe$withDefault, '', contact_.name)
			};
			var tmsCarrierName = A2(
				$elm$core$Maybe$withDefault,
				'Unknown',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.name;
					},
					contact.carrier));
			var tmsCarrierId = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Components$SettingsPage$ContactsSettingsView$tmsCarrierIdToString, contact_.tmsCarrierId);
			var tmsCarrierLink = _Utils_ap($author$project$Components$SettingsPage$ContactsSettingsView$linkToCarrierBaseUrl, tmsCarrierId);
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(contact_.email)
							])),
						$author$project$Components$SettingsPage$ContactsSettingsView$viewCarrierContactName(contact_),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(tmsCarrierLink)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(tmsCarrierName)
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A3($author$project$Components$SettingsPage$ContactsSettingsView$editButtonView, contact_.id, updateContactForm, contact.carrier)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$ContactsSettingsView$deleteButtonView(contact_.id)
							]))
					]));
		}
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$contactsView = F2(
	function (account, contacts) {
		return A2(
			$elm$core$List$map,
			$author$project$Components$SettingsPage$ContactsSettingsView$contactView(account),
			contacts);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$contactTableView = F2(
	function (data, loadedContactData) {
		var listContacts = A2(
			$author$project$Components$SettingsPage$ContactsSettingsView$contactsView,
			data.currentAccount,
			$author$project$Pagination$entries(loadedContactData));
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(data.currentAccount));
		return $elm$core$List$isEmpty(listContacts) ? $elm$html$Html$text('No contacts found.') : A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Email')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Name')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(carrierTerm)
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										]))
								]))
						]),
						listContacts
					])));
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$UpdatePage = function (a) {
	return {$: 'UpdatePage', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettingsView$paginationDetails = F2(
	function (loadedContactData, currentPage) {
		var loadedPage = $author$project$Forward$Remote$toMaybe(loadedContactData);
		return _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Pagination$pageNumber, loadedPage),
			$elm$core$Maybe$Just(currentPage)) ? loadedPage : $elm$core$Maybe$Nothing;
	});
var $author$project$Pagination$View$findBottomRange = F2(
	function (currentPageNumber, totalNumberOfPages) {
		return (totalNumberOfPages < 15) ? 1 : (((currentPageNumber - 7) <= 0) ? 1 : ((_Utils_cmp(currentPageNumber + 7, totalNumberOfPages) > 0) ? (totalNumberOfPages - 15) : (currentPageNumber - 7)));
	});
var $author$project$Pagination$View$findTopRange = F2(
	function (currentPageNumber, totalNumberOfPages) {
		return (totalNumberOfPages < 15) ? totalNumberOfPages : (((currentPageNumber - 7) < 0) ? 15 : ((_Utils_cmp(currentPageNumber + 7, totalNumberOfPages) > 0) ? totalNumberOfPages : (currentPageNumber + 7)));
	});
var $author$project$Pagination$View$createPageList = function (currentPage) {
	var numberOfPages = $author$project$Pagination$totalPages(currentPage);
	var currentPageNumber = $author$project$Pagination$pageNumber(currentPage);
	var topRange = A2($author$project$Pagination$View$findTopRange, currentPageNumber, numberOfPages);
	var bottomRange = A2($author$project$Pagination$View$findBottomRange, currentPageNumber, numberOfPages);
	return A2($elm$core$List$range, bottomRange, topRange);
};
var $author$project$Pagination$View$paginationListItem = F3(
	function (message, currentPageNumber, pageNumber) {
		return _Utils_eq(pageNumber, currentPageNumber) ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('current')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							message(pageNumber))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(pageNumber))
						]))
				])) : A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							message(pageNumber))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(pageNumber))
						]))
				]));
	});
var $author$project$Pagination$View$createPaginationPages = F2(
	function (message, currentPage) {
		var listOfPages = $author$project$Pagination$View$createPageList(currentPage);
		return A2(
			$elm$core$List$map,
			A2(
				$author$project$Pagination$View$paginationListItem,
				message,
				$author$project$Pagination$pageNumber(currentPage)),
			listOfPages);
	});
var $author$project$Pagination$View$paginationPagesWithArrows = F2(
	function (message, currentPage) {
		var totalNumberOfPages = $author$project$Pagination$totalPages(currentPage);
		var currentPageNumber = $author$project$Pagination$pageNumber(currentPage);
		var pageMinusOne = _List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('arrow')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								message(currentPageNumber - 1))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('«')
							]))
					]))
			]);
		var pagePlusOne = _List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('arrow')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								message(currentPageNumber + 1))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('»')
							]))
					]))
			]);
		return (!totalNumberOfPages) ? _List_Nil : (((currentPageNumber === 1) && (totalNumberOfPages < 2)) ? A2($author$project$Pagination$View$createPaginationPages, message, currentPage) : ((currentPageNumber === 1) ? $elm$core$List$concat(
			_List_fromArray(
				[
					A2($author$project$Pagination$View$createPaginationPages, message, currentPage),
					pagePlusOne
				])) : (_Utils_eq(currentPageNumber, totalNumberOfPages) ? $elm$core$List$concat(
			_List_fromArray(
				[
					pageMinusOne,
					A2($author$project$Pagination$View$createPaginationPages, message, currentPage)
				])) : $elm$core$List$concat(
			_List_fromArray(
				[
					pageMinusOne,
					A2($author$project$Pagination$View$createPaginationPages, message, currentPage),
					pagePlusOne
				])))));
	});
var $author$project$Pagination$View$view = F2(
	function (message, page) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-pagination__container pagination')
				]),
			A2($author$project$Pagination$View$paginationPagesWithArrows, message, page));
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$paginationView = F2(
	function (data, model) {
		var maybePage = A2($author$project$Components$SettingsPage$ContactsSettingsView$paginationDetails, data.contactData, model.page);
		if (maybePage.$ === 'Just') {
			var page = maybePage.a;
			return A2($author$project$Pagination$View$view, $author$project$Components$SettingsPage$ContactsSettingsView$UpdatePage, page);
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$CreateContact = {$: 'CreateContact'};
var $author$project$Components$SettingsPage$ContactForm$SetEmailInput = function (a) {
	return {$: 'SetEmailInput', a: a};
};
var $author$project$Components$SettingsPage$ContactForm$inputEmail = function (model) {
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('text'),
				$elm$html$Html$Attributes$placeholder('Email'),
				$elm$html$Html$Attributes$value(model.emailInput),
				$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$ContactForm$SetEmailInput)
			]),
		_List_Nil);
};
var $author$project$Components$SettingsPage$ContactForm$SetNameInput = function (a) {
	return {$: 'SetNameInput', a: a};
};
var $author$project$Components$SettingsPage$ContactForm$inputName = function (model) {
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('text'),
				$elm$html$Html$Attributes$placeholder('Name'),
				$elm$html$Html$Attributes$value(model.nameInput),
				$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$ContactForm$SetNameInput)
			]),
		_List_Nil);
};
var $author$project$Components$SettingsPage$ContactForm$carrierTerm = function (data) {
	return $author$project$Domain$Account$carrierTerm(
		$author$project$Domain$Account$accountType(data.account));
};
var $author$project$Components$SettingsPage$ContactForm$viewCarrierTypeahead = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-2 column activity-filters-typeahead left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Select ' + $author$project$Components$SettingsPage$ContactForm$carrierTerm(data))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$ContactForm$CarrierTypeaheadMsg,
					A3(
						$author$project$Components$CarrierTypeahead$view,
						$author$project$Components$SettingsPage$ContactForm$carrierTypeaheadConfig(
							$author$project$Forward$Remote$Loaded(data)),
						data.carrierTypeaheadData,
						model.carrierTypeahead))
				]));
	});
var $author$project$Components$SettingsPage$ContactForm$SelectContactType = function (a) {
	return {$: 'SelectContactType', a: a};
};
var $author$project$Components$SettingsPage$ContactForm$viewContactTypeDropdown = function (model) {
	var viewContactOption = function (contactType) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$Components$SettingsPage$ContactForm$typeToString(contactType)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(contactType, model.selectedContactType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Components$SettingsPage$ContactForm$typeToString(contactType))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('small-2 columns')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Select Contact Type')
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$ContactForm$SelectContactType)
					]),
				_List_fromArray(
					[
						viewContactOption($author$project$Components$SettingsPage$ContactForm$General),
						viewContactOption($author$project$Components$SettingsPage$ContactForm$Carrier)
					]))
			]));
};
var $author$project$Components$SettingsPage$ContactForm$viewLoaded = F3(
	function (model, config, data) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(config.title)
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$elm$html$Html$map,
					config.msgMap,
					$author$project$Components$SettingsPage$ContactForm$inputName(model)),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Email')
						])),
					A2(
					$elm$html$Html$map,
					config.msgMap,
					$author$project$Components$SettingsPage$ContactForm$inputEmail(model)),
					function () {
					var _v0 = model.selectedContactType;
					if (_v0.$ === 'General') {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									config.msgMap,
									$author$project$Components$SettingsPage$ContactForm$viewContactTypeDropdown(model))
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									config.msgMap,
									$author$project$Components$SettingsPage$ContactForm$viewContactTypeDropdown(model)),
									A2(
									$elm$html$Html$map,
									config.msgMap,
									A2($author$project$Components$SettingsPage$ContactForm$viewCarrierTypeahead, model, data)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small-6 columns')
										]),
									_List_Nil)
								]));
					}
				}(),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button--confirmation'),
							$elm$html$Html$Events$onClick(config.buttonMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(config.buttonText)
						]))
				]));
	});
var $author$project$Components$SettingsPage$ContactForm$view = F3(
	function (config, data, model) {
		return A2(
			$author$project$Forward$LoadingView$view,
			A2($author$project$Components$SettingsPage$ContactForm$viewLoaded, model, config),
			data);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$viewCreateContact = F2(
	function (model, data) {
		return A3(
			$author$project$Components$SettingsPage$ContactForm$view,
			{buttonMsg: $author$project$Components$SettingsPage$ContactsSettingsView$CreateContact, buttonText: 'Create', msgMap: $author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg, title: 'Create New Contact'},
			$author$project$Forward$Remote$Loaded(data.contactFormData),
			model.contactFormModel);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$UpdateContact = function (a) {
	return {$: 'UpdateContact', a: a};
};
var $author$project$Components$SettingsPage$ContactsSettingsView$viewEditContact = F3(
	function (contactId, model, data) {
		return A3(
			$author$project$Components$SettingsPage$ContactForm$view,
			{
				buttonMsg: $author$project$Components$SettingsPage$ContactsSettingsView$UpdateContact(contactId),
				buttonText: 'Save',
				msgMap: $author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg,
				title: 'Edit Contact'
			},
			$author$project$Forward$Remote$Loaded(data.contactFormData),
			model.contactFormModel);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$authorizedView = F2(
	function (model, data) {
		var _v0 = model.viewState;
		switch (_v0.$) {
			case 'ShowList':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-12 columns')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'margin-bottom', '1.5em')
										]),
									_List_fromArray(
										[
											A2($author$project$Components$SettingsPage$ContactsSettingsView$paginationView, data, model)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-12 columns')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Forward$LoadingView$view,
									$author$project$Components$SettingsPage$ContactsSettingsView$contactTableView(data),
									data.contactData)
								]))
						]));
			case 'ShowEditContact':
				var contactId = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Components$SettingsPage$ContactsSettingsView$viewEditContact, contactId, model, data),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small-12 columns right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$ContactsSettingsView$ViewList)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('go back')
										]))
								]))
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$SettingsPage$ContactsSettingsView$viewCreateContact, model, data),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$ContactsSettingsView$ViewList)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('go back')
								]))
						]));
		}
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$loadedView = F2(
	function (model, data) {
		return data.user.hasSettingsRole ? A2($author$project$Components$SettingsPage$ContactsSettingsView$authorizedView, model, data) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Domain$Contact$contactId = function (contact) {
	var _v0 = contact.contactType;
	if (_v0.$ === 'Contact_ContactType_CarrierContact') {
		var multiCarrierContact = _v0.a;
		return multiCarrierContact.id;
	} else {
		var carrierContact = _v0.a;
		return carrierContact.id;
	}
};
var $author$project$Domain$Contact$email = function (contact) {
	var _v0 = contact.contactType;
	if (_v0.$ === 'Contact_ContactType_CarrierContact') {
		var carrierContact = _v0.a;
		return carrierContact.email;
	} else {
		var multiCarrierContact = _v0.a;
		return multiCarrierContact.email;
	}
};
var $author$project$Domain$Contact$name = function (contact) {
	var _v0 = contact.contactType;
	if (_v0.$ === 'Contact_ContactType_MultiCarrierContact') {
		var multiCarrierContact = _v0.a;
		return multiCarrierContact.name;
	} else {
		var carrierContact = _v0.a;
		return carrierContact.name;
	}
};
var $author$project$Components$SettingsPage$ContactsSettingsView$contactTableViewV3Reskin = F3(
	function (_v0, data, loadedContactData) {
		var typeAsString = function (type_) {
			return $author$project$Domain$ContactIdsQuery$typeAsString(type_);
		};
		var contacts = $author$project$Pagination$entries(loadedContactData);
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(data.currentAccount));
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.contact;
							},
							A2($elm$core$Basics$composeR, $author$project$Domain$Contact$email, $elm$html$Html$text)),
						heading: $elm$html$Html$text('Email')
					},
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.contact;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Domain$Contact$name,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault(''),
									$elm$html$Html$text))),
						heading: $elm$html$Html$text('Name')
					},
						{
						attrs: _List_Nil,
						content: function (_v1) {
							var carrier = _v1.carrier;
							var contact = _v1.contact;
							var _v2 = contact.contactType;
							if (_v2.$ === 'Contact_ContactType_MultiCarrierContact') {
								return $elm$html$Html$text('General - No ' + carrierTerm);
							} else {
								var contact_ = _v2.a;
								var tmsCarrierName = A2(
									$elm$core$Maybe$withDefault,
									'Unknown',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.name;
										},
										carrier));
								var tmsCarrierId = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Components$SettingsPage$ContactsSettingsView$tmsCarrierIdToString, contact_.tmsCarrierId);
								var tmsCarrierLink = _Utils_ap($author$project$Components$SettingsPage$ContactsSettingsView$linkToCarrierBaseUrl, tmsCarrierId);
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(tmsCarrierLink)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$V3$Typography$xSmallBody,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
													A2($elm$html$Html$Attributes$style, 'color', 'var(--color-blue-600)')
												]),
											tmsCarrierName)
										]));
							}
						},
						heading: $elm$html$Html$text('Carrier')
					},
						{
						attrs: _List_Nil,
						content: function (_v3) {
							var carrier = _v3.carrier;
							var contact = _v3.contact;
							var updateContactForm = {
								carrier_id: $elm$core$Maybe$Nothing,
								contact_type: typeAsString(
									function () {
										var _v4 = contact.contactType;
										if (_v4.$ === 'Contact_ContactType_MultiCarrierContact') {
											return $author$project$AuditPb$ContactTypeGeneral;
										} else {
											return $author$project$AuditPb$ContactTypeCarrier;
										}
									}()),
								email: $author$project$Domain$Contact$email(contact),
								name: A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Domain$Contact$name(contact))
							};
							return A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										$elm$html$Html$text('')),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A2(
											$author$project$Ui$V3$UtilityButton$view,
											{
												icon: $author$project$Ui$V3$Icon$editOutline16,
												label: 'Edit',
												onClick: A3(
													$author$project$Components$SettingsPage$ContactsSettingsView$ViewEditContact,
													$author$project$Domain$Contact$contactId(contact),
													updateContactForm,
													carrier)
											},
											_List_fromArray(
												[$author$project$Ui$V3$UtilityButton$sizeSmall]))),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A2(
											$author$project$Ui$V3$UtilityButton$view,
											{
												icon: $author$project$Ui$V3$Icon$removeOutline16,
												label: 'Delete',
												onClick: $author$project$Components$SettingsPage$ContactsSettingsView$DeleteContact(
													$author$project$Domain$Contact$contactId(contact))
											},
											_List_fromArray(
												[$author$project$Ui$V3$UtilityButton$sizeSmall])))
									]));
						},
						heading: $elm$html$Html$text('')
					}
					])
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$pagination(
					{currentPage: loadedContactData, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$SettingsPage$ContactsSettingsView$UpdatePage})
				]),
			_List_Nil,
			contacts);
	});
var $author$project$Ui$V3$Button$LeftIconWithHiddenLabelAttribute = function (a) {
	return {$: 'LeftIconWithHiddenLabelAttribute', a: a};
};
var $author$project$Ui$V3$Button$leftIcon16WithHiddenLabel = A2($elm$core$Basics$composeL, $author$project$Ui$V3$Button$LeftIconWithHiddenLabelAttribute, $author$project$Ui$V3$Button$Icon16Content);
var $author$project$Components$SettingsPage$ContactsFilter$ClearTerm = {$: 'ClearTerm'};
var $author$project$Components$SettingsPage$ContactsFilter$SelectContactType = function (a) {
	return {$: 'SelectContactType', a: a};
};
var $author$project$Components$SettingsPage$ContactsFilter$UpdateTerm = function (a) {
	return {$: 'UpdateTerm', a: a};
};
var $author$project$AuditPb$allContactType = _List_fromArray(
	[$author$project$AuditPb$ContactTypeAll, $author$project$AuditPb$ContactTypeCarrier, $author$project$AuditPb$ContactTypeGeneral]);
var $author$project$Domain$ContactIdsQuery$typeAsDisplayString = F2(
	function (accountType, contactType) {
		if (contactType.$ === 'ContactTypeCarrier') {
			return $elm$core$String$toLower(
				$author$project$Domain$Account$carrierTerm(accountType));
		} else {
			return $author$project$Domain$ContactIdsQuery$typeAsString(contactType);
		}
	});
var $author$project$Components$SettingsPage$ContactsFilter$typeAsString = F2(
	function (data, contactType) {
		var typeString = function (accountType) {
			return A2($author$project$Domain$ContactIdsQuery$typeAsDisplayString, accountType, contactType);
		};
		return typeString(
			$author$project$Domain$Account$accountType(data.account));
	});
var $author$project$Components$SettingsPage$ContactsFilter$viewV3Reskin = F2(
	function (data, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Ui$V3$SearchInput$view,
					{onClear: $author$project$Components$SettingsPage$ContactsFilter$ClearTerm, onInput: $author$project$Components$SettingsPage$ContactsFilter$UpdateTerm},
					_List_fromArray(
						[
							$author$project$Ui$V3$SearchInput$placeholder('Search contacts by email')
						]),
					_List_Nil,
					model.emailSearchTerm),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$elm$core$Maybe$Just(
								A2(
									$author$project$Helpers$Html$labeledInput,
									'Filter by contact type',
									A2(
										$author$project$Ui$V3$SimpleSelect$view,
										{
											onInput: A2(
												$elm$core$Basics$composeR,
												$author$project$Components$SettingsPage$ContactsFilter$typeAsString(data),
												$author$project$Components$SettingsPage$ContactsFilter$SelectContactType),
											options: $author$project$AuditPb$allContactType,
											toLabel: $author$project$Components$SettingsPage$ContactsFilter$typeAsString(data),
											value: $elm$core$Maybe$Just(model.selectedContactType)
										},
										_List_Nil)))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							function () {
								var _v0 = model.selectedContactType;
								if (_v0.$ === 'ContactTypeCarrier') {
									return $elm$core$Maybe$Just(
										A2(
											$elm$html$Html$map,
											$author$project$Components$SettingsPage$ContactsFilter$CarrierDropdownMsg,
											A3(
												$author$project$Components$SettingsPage$CarrierDropdown$view,
												'Find contact by ' + ($elm$core$String$toLower(
													$author$project$Domain$Account$carrierTerm(
														$author$project$Domain$Account$accountType(data.account))) + ' name'),
												data.carrierDropdownData,
												model.carrierDropdown)));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}())
						]))
				]));
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$viewContactsFilterV3Reskin = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$SettingsPage$ContactsSettingsView$ContactFilterMsg,
			A2($author$project$Components$SettingsPage$ContactsFilter$viewV3Reskin, data.contactFilterData, model.contactFilterModel));
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$viewContactsListV3Reskin = F2(
	function (model, data) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Contacts')
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$ContactsSettingsView$ViewCreateContact)
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Button$leftIcon16WithHiddenLabel($author$project$Ui$V3$Icon$add16)
									]),
								'Add new contact'))
						])),
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							A2($author$project$Components$SettingsPage$ContactsSettingsView$viewContactsFilterV3Reskin, model, data)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'relative')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Forward$LoadingView$viewV3Reskin,
							A2($author$project$Components$SettingsPage$ContactsSettingsView$contactTableViewV3Reskin, model, data),
							data.contactData)
						]))
				]));
	});
var $author$project$Components$SettingsPage$ContactForm$viewLoadedV3Reskin = F4(
	function (model, config, data, cancelOnClick) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge),
					$author$project$Ui$V3$Stack$styleAsCard
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(config.title)
						])),
					A2(
					$elm$html$Html$map,
					config.msgMap,
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewHorz,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$SettingsPage$ContactForm$SetNameInput},
										_List_fromArray(
											[
												$author$project$Ui$V3$Input$label('Name')
											]),
										_List_Nil,
										model.nameInput),
										A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$SettingsPage$ContactForm$SetEmailInput},
										_List_fromArray(
											[
												$author$project$Ui$V3$Input$label('Email')
											]),
										_List_Nil,
										model.emailInput)
									])),
								A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										A2(
											$author$project$Helpers$Html$labeledInput,
											'Filter by contact type',
											A2(
												$author$project$Ui$V3$SimpleSelect$view,
												{
													onInput: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$ContactForm$typeToString, $author$project$Components$SettingsPage$ContactForm$SelectContactType),
													options: _List_fromArray(
														[$author$project$Components$SettingsPage$ContactForm$General, $author$project$Components$SettingsPage$ContactForm$Carrier]),
													toLabel: $author$project$Components$SettingsPage$ContactForm$typeToString,
													value: $elm$core$Maybe$Just(model.selectedContactType)
												},
												_List_Nil))),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										function () {
											var _v0 = model.selectedContactType;
											if (_v0.$ === 'General') {
												return $elm$html$Html$text('');
											} else {
												return A2(
													$elm$html$Html$map,
													$author$project$Components$SettingsPage$ContactForm$CarrierDropdownMsg,
													A3(
														$author$project$Components$SettingsPage$CarrierDropdown$view,
														'Select ' + $elm$core$String$toLower(
															$author$project$Domain$Account$carrierTerm(
																$author$project$Domain$Account$accountType(data.account))),
														data.carrierDropdownData,
														model.carrierDropdown));
											}
										}())
									]))
							]))),
					$author$project$Helpers$Html$editButtons(
					{cancelMsg: cancelOnClick, primaryDisabled: false, primaryLabel: config.buttonText, primaryMsg: config.buttonMsg})
				]));
	});
var $author$project$Components$SettingsPage$ContactForm$viewV3Reskin = F4(
	function (config, data, model, cancelOnClick) {
		return A4($author$project$Components$SettingsPage$ContactForm$viewLoadedV3Reskin, model, config, data, cancelOnClick);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$viewCreateContactV3Reskin = F2(
	function (model, data) {
		return A4(
			$author$project$Components$SettingsPage$ContactForm$viewV3Reskin,
			{buttonMsg: $author$project$Components$SettingsPage$ContactsSettingsView$CreateContact, buttonText: 'Create', msgMap: $author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg, title: 'Create New Contact'},
			data.contactFormData,
			model.contactFormModel,
			$author$project$Components$SettingsPage$ContactsSettingsView$ViewList);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$viewEditContactV3Reskin = F3(
	function (contactId, model, data) {
		return A4(
			$author$project$Components$SettingsPage$ContactForm$viewV3Reskin,
			{
				buttonMsg: $author$project$Components$SettingsPage$ContactsSettingsView$UpdateContact(contactId),
				buttonText: 'Save',
				msgMap: $author$project$Components$SettingsPage$ContactsSettingsView$ContactFormMsg,
				title: 'Edit Contact'
			},
			data.contactFormData,
			model.contactFormModel,
			$author$project$Components$SettingsPage$ContactsSettingsView$ViewList);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$authorizedViewV3Reskin = F2(
	function (model, data) {
		var _v0 = model.viewState;
		switch (_v0.$) {
			case 'ShowList':
				return A2($author$project$Components$SettingsPage$ContactsSettingsView$viewContactsListV3Reskin, model, data);
			case 'ShowEditContact':
				var contactId = _v0.a;
				return A3($author$project$Components$SettingsPage$ContactsSettingsView$viewEditContactV3Reskin, contactId, model, data);
			default:
				return A2($author$project$Components$SettingsPage$ContactsSettingsView$viewCreateContactV3Reskin, model, data);
		}
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$loadedViewV3Reskin = F2(
	function (model, data) {
		return data.user.hasSettingsRole ? A2($author$project$Components$SettingsPage$ContactsSettingsView$authorizedViewV3Reskin, model, data) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$SettingsPage$ContactsFilter$viewContactOption = F3(
	function (contactType, model, data) {
		return _Utils_eq(contactType, model.selectedContactType) ? A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					A2($author$project$Components$SettingsPage$ContactsFilter$typeAsString, data, contactType)),
					$elm$html$Html$Attributes$selected(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Components$SettingsPage$ContactsFilter$typeAsString, data, contactType))
				])) : A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					A2($author$project$Components$SettingsPage$ContactsFilter$typeAsString, data, contactType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Components$SettingsPage$ContactsFilter$typeAsString, data, contactType))
				]));
	});
var $author$project$Components$SettingsPage$ContactsFilter$viewContactTypeDropdown = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-2 columns')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Filter By Contact Type')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$ContactsFilter$SelectContactType)
						]),
					_List_fromArray(
						[
							A3($author$project$Components$SettingsPage$ContactsFilter$viewContactOption, $author$project$AuditPb$ContactTypeAll, model, data),
							A3($author$project$Components$SettingsPage$ContactsFilter$viewContactOption, $author$project$AuditPb$ContactTypeCarrier, model, data),
							A3($author$project$Components$SettingsPage$ContactsFilter$viewContactOption, $author$project$AuditPb$ContactTypeGeneral, model, data)
						]))
				]));
	});
var $author$project$Components$SettingsPage$ContactsFilter$CarrierTypeaheadMsg = function (a) {
	return {$: 'CarrierTypeaheadMsg', a: a};
};
var $author$project$Components$SettingsPage$ContactsFilter$carrierTerm = function (data) {
	return $author$project$Domain$Account$carrierTerm(
		$author$project$Domain$Account$accountType(data.account));
};
var $author$project$Components$SettingsPage$ContactsFilter$carrierTypeaheadConfig = function (data) {
	var updatedItemDisplay = function (tmsCarrier) {
		var _v0 = _Utils_Tuple2(
			tmsCarrier.inactiveAt,
			$author$project$Domain$Account$accountType(data.account));
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'FactorAccount')) {
			var _v1 = _v0.b;
			return tmsCarrier.name + ' (inactive)';
		} else {
			return tmsCarrier.name;
		}
	};
	var config = $author$project$Components$CarrierTypeahead$config(
		$elm$core$Maybe$Just(
			$author$project$Domain$Account$accountType(data.account)));
	return _Utils_update(
		config,
		{
			itemDisplay: A2($elm$core$Basics$composeR, updatedItemDisplay, $elm$html$Html$text)
		});
};
var $author$project$Components$CarrierTypeahead$viewCustom = F2(
	function (config_, fn) {
		return $author$project$Typeahead$view(
			fn(config_));
	});
var $author$project$Components$SettingsPage$ContactsFilter$viewSearchCarrierName = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('small-2 columns left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Find Contact by ' + ($author$project$Components$SettingsPage$ContactsFilter$carrierTerm(data) + ' Name'))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$ContactsFilter$CarrierTypeaheadMsg,
					A4(
						$author$project$Components$CarrierTypeahead$viewCustom,
						$author$project$Components$SettingsPage$ContactsFilter$carrierTypeaheadConfig(data),
						function (typeahead) {
							return _Utils_update(
								typeahead,
								{
									inputClassOverride: $elm$core$Maybe$Just('contacts__carrier-typeahead')
								});
						},
						data.carrierTypeaheadData,
						model.carrierTypeahead))
				]));
	});
var $author$project$Components$SettingsPage$ContactsFilter$viewAdvancedSearch = F2(
	function (model, data) {
		var _v0 = model.selectedContactType;
		if (_v0.$ === 'ContactTypeCarrier') {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Components$SettingsPage$ContactsFilter$viewContactTypeDropdown, model, data),
						A2($author$project$Components$SettingsPage$ContactsFilter$viewSearchCarrierName, model, data),
						A2($elm$html$Html$p, _List_Nil, _List_Nil)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Components$SettingsPage$ContactsFilter$viewContactTypeDropdown, model, data)
					]));
		}
	});
var $author$project$Components$SettingsPage$ContactsFilter$viewSearchTermInput = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('small-12 columns')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$placeholder('Search Contacts By Email'),
						$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$ContactsFilter$UpdateTerm),
						$elm$html$Html$Attributes$value(model.emailSearchTerm),
						$elm$html$Html$Attributes$autofocus(true)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$SettingsPage$ContactsFilter$viewLoaded = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							$author$project$Components$SettingsPage$ContactsFilter$viewSearchTermInput(model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2($author$project$Components$SettingsPage$ContactsFilter$viewAdvancedSearch, model, data)
						]))
				]));
	});
var $author$project$Components$SettingsPage$ContactsFilter$view = F2(
	function (data, model) {
		return A2(
			$author$project$Forward$LoadingView$view,
			$author$project$Components$SettingsPage$ContactsFilter$viewLoaded(model),
			data);
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$viewContactsFilter = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$SettingsPage$ContactsSettingsView$ContactFilterMsg,
			A2(
				$author$project$Components$SettingsPage$ContactsFilter$view,
				$author$project$Forward$Remote$Loaded(data.contactFilterData),
				model.contactFilterModel));
	});
var $author$project$Components$SettingsPage$ContactsSettingsView$viewSearchTerms = function (model) {
	var queryTerm = model.contactFilterModel.emailSearchTerm;
	return $elm$core$String$isEmpty(queryTerm) ? A2(
		$elm$html$Html$h3,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('All Contacts')
			])) : A2(
		$elm$html$Html$h3,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Contacts matching: ' + queryTerm)
			]));
};
var $author$project$Components$SettingsPage$ContactsSettingsView$view = F3(
	function (v3ReskinEnabled, data, model) {
		if (v3ReskinEnabled) {
			return A2(
				$author$project$Forward$LoadingView$viewV3Reskin,
				$author$project$Components$SettingsPage$ContactsSettingsView$loadedViewV3Reskin(model),
				data);
		} else {
			var _v0 = model.viewState;
			switch (_v0.$) {
				case 'ShowList':
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-5 columns')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Contacts')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('small-12 column')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('row')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('small-5 columns')
													]),
												_List_fromArray(
													[
														$author$project$Components$SettingsPage$ContactsSettingsView$viewSearchTerms(model)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('small-6 large-2 large-offset-3 columns')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button success expand right'),
																$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$ContactsSettingsView$ViewCreateContact)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('  + Add New Contact  ')
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Forward$LoadingView$view,
												$author$project$Components$SettingsPage$ContactsSettingsView$viewContactsFilter(model),
												data)
											])),
										A2(
										$author$project$Forward$LoadingView$view,
										$author$project$Components$SettingsPage$ContactsSettingsView$loadedView(model),
										data)
									]))
							]));
				case 'ShowEditContact':
					return A2(
						$author$project$Forward$LoadingView$view,
						$author$project$Components$SettingsPage$ContactsSettingsView$loadedView(model),
						data);
				default:
					return A2(
						$author$project$Forward$LoadingView$view,
						$author$project$Components$SettingsPage$ContactsSettingsView$loadedView(model),
						data);
			}
		}
	});
var $author$project$Components$SettingsPage$DebtorsSettingsView$UpdateTerm = function (a) {
	return {$: 'UpdateTerm', a: a};
};
var $author$project$Components$SettingsPage$DebtorsSettingsView$pageTitle = function (searchTerm) {
	if (searchTerm === '') {
		return 'All Debtors';
	} else {
		var filter = searchTerm;
		return 'Debtors matching: \u0022' + (filter + '\u0022');
	}
};
var $author$project$Components$SettingsPage$DebtorsSettingsView$UpdatePage = function (a) {
	return {$: 'UpdatePage', a: a};
};
var $author$project$Components$SettingsPage$DebtorsSettingsView$GoToUrl = function (a) {
	return {$: 'GoToUrl', a: a};
};
var $author$project$Helpers$GenericLink$genericLink = F4(
	function (msg, attrs, url, content) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						$author$project$Event$Extra$onClickPreventDefaultForLinkWithHref(msg),
						$elm$html$Html$Attributes$href(url)
					])),
			content);
	});
var $author$project$Components$SettingsPage$DebtorsSettingsView$linkToDebtorPage = function (destination) {
	return A4(
		$author$project$Helpers$GenericLink$genericLink,
		$author$project$Components$SettingsPage$DebtorsSettingsView$GoToUrl(destination),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button--confirmation small')
			]),
		destination,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('View')
					]))
			]));
};
var $author$project$Components$SettingsPage$DebtorsSettingsView$debtorView = function (_v0) {
	var paymentAddress = _v0.paymentAddress;
	var broker = _v0.broker;
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(broker.name)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', broker.mcNumber))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2($elm$core$Maybe$map, $author$project$Components$SettingsPage$Carriers$AddressView$view, paymentAddress))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$DebtorsSettingsView$linkToDebtorPage(
						'/app/settings/debtors/' + $elm$core$String$fromInt(
							$author$project$Domain$FactorBrokerId$toInt(broker.id)))
					]))
			]));
};
var $author$project$Components$SettingsPage$DebtorsSettingsView$row = function (inner) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[inner]));
};
var $author$project$Components$SettingsPage$DebtorsSettingsView$resultTable = function (currentPage) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$DebtorsSettingsView$row(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-12 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '1.5em')
								]),
							_List_fromArray(
								[
									A2($author$project$Pagination$View$view, $author$project$Components$SettingsPage$DebtorsSettingsView$UpdatePage, currentPage)
								]))
						]))),
				$author$project$Components$SettingsPage$DebtorsSettingsView$row(
				function () {
					var debtors = $author$project$Pagination$entries(currentPage);
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-12 columns')
							]),
						_List_fromArray(
							[
								$elm$core$List$isEmpty(debtors) ? $elm$html$Html$text('No debtors found.') : A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', '100%')
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Name')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('MC #')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Address')
															])),
														A2($elm$html$Html$th, _List_Nil, _List_Nil)
													]))
											])),
									A2($elm$core$List$map, $author$project$Components$SettingsPage$DebtorsSettingsView$debtorView, debtors)))
							]));
				}())
			]));
};
var $author$project$Components$SettingsPage$DebtorsSettingsView$authorizedView = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('customer-browser')
				]),
			_List_fromArray(
				[
					$author$project$Components$SettingsPage$DebtorsSettingsView$row(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-5 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Components$SettingsPage$DebtorsSettingsView$pageTitle(model.searchTerm))
									]))
							]))),
					$author$project$Components$SettingsPage$DebtorsSettingsView$row(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-12 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$placeholder('Search Debtors'),
										$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$DebtorsSettingsView$UpdateTerm),
										$elm$html$Html$Attributes$value(model.searchTerm),
										$elm$html$Html$Attributes$autofocus(true)
									]),
								_List_Nil),
								A2($author$project$Forward$LoadingView$view, $author$project$Components$SettingsPage$DebtorsSettingsView$resultTable, data.currentPage)
							])))
				]));
	});
var $author$project$Components$SettingsPage$DebtorsSettingsView$view = F2(
	function (data, model) {
		return data.currentUser.hasSettingsRole ? A2($author$project$Components$SettingsPage$DebtorsSettingsView$authorizedView, data, model) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$EditHotkeyList = {$: 'EditHotkeyList'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveHotkeyList = {$: 'SaveHotkeyList'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$isDuplicateInList = F2(
	function (list, item) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (a) {
					return _Utils_eq(a, item);
				},
				list)) > 1;
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$hasDuplicate = function (list) {
	return A2(
		$elm$core$List$any,
		$author$project$Components$SettingsPage$DocumentTypesSettingsView$isDuplicateInList(list),
		list);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$sameHotkeyList = F2(
	function (data, model) {
		var indexedOriginalList = A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, data.documentTypeSettings.documentTypeHotkeysOrdering);
		var indexedCurrentList = A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, model.localHotkeyList);
		var inOriginalList = function (a) {
			return A2($elm$core$List$member, a, indexedOriginalList);
		};
		return A2($elm$core$List$all, inOriginalList, indexedCurrentList);
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListButton = F2(
	function (data, model) {
		return model.isSaving ? A2($author$project$Components$Shared$Button$disabled, 'Saving...', _List_Nil) : (model.editingHotkeyList ? (A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$sameHotkeyList, data, model) ? A2($author$project$Components$Shared$Button$disabled, 'Save', _List_Nil) : ($author$project$Components$SettingsPage$DocumentTypesSettingsView$hasDuplicate(model.localHotkeyList) ? A2($author$project$Components$Shared$Button$disabled, 'Save', _List_Nil) : A3($author$project$Components$Shared$Button$confirm, 'Save', $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveHotkeyList, _List_Nil))) : A3($author$project$Components$Shared$Button$confirm, 'Edit Hotkeys', $author$project$Components$SettingsPage$DocumentTypesSettingsView$EditHotkeyList, _List_Nil));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListErrorMessage = function (model) {
	return $author$project$Components$SettingsPage$DocumentTypesSettingsView$hasDuplicate(model.localHotkeyList) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'max-width', '60%'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
				A2($elm$html$Html$Attributes$style, 'padding', '0.5rem'),
				A2($elm$html$Html$Attributes$style, 'background-color', '#FDDED5'),
				A2($elm$html$Html$Attributes$style, 'border', 'solid 1px #FAAD97')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Cannot have multiple hotkeys for a single document type.')
			])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$UpdateHotkeySelection = F2(
	function (a, b) {
		return {$: 'UpdateHotkeySelection', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeToString = function (data) {
	var env = data.currentAccount.factorAccount ? $author$project$Domain$Environment$FactorEnvironment : $author$project$Domain$Environment$BrokerEnvironment;
	return A2($author$project$Domain$DocumentType$toString, data.accountSettings.customDocumentTypeNames, env);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$editHotkeyListRow = F4(
	function (data, isDuplicate, index, documentType) {
		var updateHotkeySelection = function (doc) {
			return A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$UpdateHotkeySelection, index, doc);
		};
		var cellClass = isDuplicate(documentType) ? $elm$html$Html$Attributes$class('settings__document-type-hotkeys--duplicate-cell-error') : $elm$html$Html$Attributes$class('settings__document-type-hotkeys--duplicate-cell');
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(index + 1))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[cellClass]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Select$view(
							{
								choices: A2(
									$elm$core$List$map,
									function ($) {
										return $.documentType;
									},
									data.documentTypeSettings.enabledDocumentTypeNames),
								disabledChoices: _List_fromArray(
									[documentType]),
								onChange: updateHotkeySelection,
								placeholder: 'Select a Document Type',
								sortAlphabetically: true,
								toString: $author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeToString(data),
								value: $elm$core$Maybe$Just(documentType)
							})
						]))
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListRow = F3(
	function (data, index, documentType) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(index + 1))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeToString, data, documentType))
						]))
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListTable = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-hotkey-document-type-map__table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hubtran-hotkey-document-type-map__hotkey')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Hotkey')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hubtran-hotkey-document-type-map__document-type')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Document Type')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					model.editingHotkeyList ? A2(
						$elm$core$List$indexedMap,
						A2(
							$author$project$Components$SettingsPage$DocumentTypesSettingsView$editHotkeyListRow,
							data,
							$author$project$Components$SettingsPage$DocumentTypesSettingsView$isDuplicateInList(model.localHotkeyList)),
						A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$getHotkeyList, data, model)) : A2(
						$elm$core$List$indexedMap,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListRow(data),
						A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$getHotkeyList, data, model)))
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeHotkeysSection = F2(
	function (data, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Hotkeys for Document Type')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-subheader')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Numberpad hotkeys are available for the first 9 document types.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('To configure the order of the first 9 document types, change the doctype for that hotkey below.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-body')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListTable, data, model),
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListErrorMessage(model),
						A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListButton, data, model)
					]))
			]);
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypesSectionHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('shared__section-header')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h4,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select visible and required documents.')
				]))
		]));
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$header = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Document Types')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select visible and required documents.')
				]))
		]));
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveTmsMap = {$: 'SaveTmsMap'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsMapButton = function (model) {
	return $elm$core$Dict$isEmpty(model.tmsMapEdits) ? A2($author$project$Components$Shared$Button$disabled, 'Save', _List_Nil) : (model.isSaving ? A2($author$project$Components$Shared$Button$disabled, 'Saving...', _List_Nil) : A3($author$project$Components$Shared$Button$confirm, 'Save', $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveTmsMap, _List_Nil));
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$InputTmsMap = F2(
	function (a, b) {
		return {$: 'InputTmsMap', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsMapRow = F3(
	function (data, model, documentTypeWithName) {
		var key = $author$project$AuditPb$documentTypeToString(documentTypeWithName.documentType);
		return _Utils_Tuple2(
			key,
			A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(documentTypeWithName.name)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										$author$project$Components$SettingsPage$DocumentTypesSettingsView$InputTmsMap(key)),
										$elm$html$Html$Attributes$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Dict$get,
												key,
												A2(
													$author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsMap,
													$author$project$Forward$Remote$Loaded(data),
													model))))
									]),
								_List_Nil)
							]))
					])));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsMapTable = F3(
	function (data, model, settings) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-tms-document-type-map__table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hubtran-tms-document-type-map__hubtran-type')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('TriumphPay Audit Type')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hubtran-tms-document-type-map__tms-type')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('TMS Type')
										]))
								]))
						])),
					A3(
					$elm$html$Html$Keyed$node,
					'tbody',
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsMapRow, data, model),
						settings.enabledDocumentTypeNames))
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveTmsPodMap = {$: 'SaveTmsPodMap'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsPodMapButton = function (model) {
	return _Utils_eq(model.tmsPodMapEdit, $elm$core$Maybe$Nothing) ? A2($author$project$Components$Shared$Button$disabled, 'Save', _List_Nil) : (model.isSaving ? A2($author$project$Components$Shared$Button$disabled, 'Saving...', _List_Nil) : A3($author$project$Components$Shared$Button$confirm, 'Save', $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveTmsPodMap, _List_Nil));
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$InputTmsPodMap = function (a) {
	return {$: 'InputTmsPodMap', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsPodMapTable = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-tms-document-type-map__table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Document set as POD (any document type)')
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$DocumentTypesSettingsView$InputTmsPodMap),
													$elm$html$Html$Attributes$value(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsPodMap,
															$author$project$Forward$Remote$Loaded(data),
															model)))
												]),
											_List_Nil)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$hubtranTmsMapSection = F3(
	function (data, model, settings) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('TriumphPay Audit ↔ TMS Document Type Mappings')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-body')
					]),
				_List_fromArray(
					[
						A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsMapTable, data, model, settings),
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsMapButton(model)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('TriumphPay Audit POD Flag ↔ TMS Document Type Mapping')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-body')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsPodMapTable, data, model),
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsPodMapButton(model)
					]))
			]);
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$pageHeader = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Document Types')
				]))
		]));
var $author$project$Domain$AccountSettings$useDocumentTypeHotkeys = function (accountSettings) {
	return !accountSettings.useSubmissionWorkflow;
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldUseDocumentTypeHotkeys = function (data) {
	return $author$project$Domain$AccountSettings$useDocumentTypeHotkeys(data.accountSettings) && data.currentUser.isAdmin;
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldViewTmsMapSection = function (data) {
	return A2(
		$elm$core$List$member,
		data.currentAccount.tms,
		_List_fromArray(
			[$author$project$AuditPb$TMSOptionMercuryGate, $author$project$AuditPb$TMSOptionAljex, $author$project$AuditPb$TMSOptionKeypoint, $author$project$AuditPb$TMSOptionThreegTMS, $author$project$AuditPb$TMSOptionMasterMind, $author$project$AuditPb$TMSOptionMCLeod, $author$project$AuditPb$TMSOptionRevenova])) && data.currentUser.isAdmin;
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeForTruckPhotos = function (a) {
	return {$: 'SaveDocumentTypeForTruckPhotos', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldShowDocumentTypeForPhotosSection = function (data) {
	return data.currentUser.isAdmin;
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewDocumentTypeForTruckPhotosSection = function (data) {
	var value = A2(
		$elm_community$list_extra$List$Extra$find,
		function (d) {
			return _Utils_eq(d.documentType, data.accountSettings.documentTypeForTruckPhotos);
		},
		data.documentTypeSettings.enabledDocumentTypeNames);
	var labelText = 'Document Type to set on photos auto-identified by system as \u0027Photos of trucks / trailers / cargo\u0027';
	var choices = data.documentTypeSettings.enabledDocumentTypeNames;
	return $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldShowDocumentTypeForPhotosSection(data) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
									A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
								]),
							_List_fromArray(
								[
									$author$project$Components$Shared$Select$view(
									{
										choices: choices,
										disabledChoices: _List_Nil,
										onChange: $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeForTruckPhotos,
										placeholder: 'Select a Document Type',
										sortAlphabetically: true,
										toString: function ($) {
											return $.name;
										},
										value: value
									})
								]))
						]))
				]))
		]) : _List_fromArray(
		[
			A2($elm$html$Html$div, _List_Nil, _List_Nil)
		]);
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$Dirty = {$: 'Dirty'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowCheck = F2(
	function (a, b) {
		return {$: 'OnRowCheck', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowRemove = F2(
	function (a, b) {
		return {$: 'OnRowRemove', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowUncheck = F2(
	function (a, b) {
		return {$: 'OnRowUncheck', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnSave = {$: 'OnSave'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnSelectAddClick = F2(
	function (a, b) {
		return {$: 'OnSelectAddClick', a: a, b: b};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnSelectChange = function (a) {
	return {$: 'OnSelectChange', a: a};
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$Saving = {$: 'Saving'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$SetCadenceImageType = F3(
	function (a, b, c) {
		return {$: 'SetCadenceImageType', a: a, b: b, c: c};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$SetPayablesValue = F3(
	function (a, b, c) {
		return {$: 'SetPayablesValue', a: a, b: b, c: c};
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$Unmodified = {$: 'Unmodified'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$fromRow = function (row) {
	var _v0 = row.documentType;
	if (_v0.$ === 'Resolved') {
		var documentType = _v0.a;
		return $elm$core$Maybe$Just(
			{documentType: documentType, name: row.name});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$SettingsPage$Shared$Table$bolded = function (label) {
	return A2(
		$elm$html$Html$strong,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'font-family', 'sans-serif')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Components$SettingsPage$Shared$Table$viewHeader = function (label) {
	return A2(
		$elm$html$Html$td,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$Shared$Table$bolded(label)
			]));
};
var $author$project$Components$SettingsPage$Shared$Table$view = function (_v0) {
	var viewRow = _v0.viewRow;
	var data = _v0.data;
	var headers = _v0.headers;
	return A2(
		$elm$html$Html$table,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						A2($elm$core$List$map, $author$project$Components$SettingsPage$Shared$Table$viewHeader, headers))
					])),
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				A2($elm$core$List$map, viewRow, data))
			]));
};
var $author$project$Components$SettingsPage$Shared$DocumentTypeTable$view = function (options) {
	return $author$project$Components$SettingsPage$Shared$Table$view(
		{
			data: A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.name;
				},
				options.rows),
			headers: options.headers,
			viewRow: options.isEditable ? options.viewRow(options.messages) : options.viewReadOnlyRow
		});
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewControls = function (options) {
	var _v0 = function () {
		var _v1 = options.status;
		switch (_v1.$) {
			case 'Dirty':
				return {
					attrs: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('button--confirmation'),
							$elm$html$Html$Events$onClick(options.onSave)
						]),
					label: options.labels.ready
				};
			case 'Saving':
				return {
					attrs: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('button--disabled'),
							$elm$html$Html$Attributes$disabled(true)
						]),
					label: options.labels.saving
				};
			default:
				return {
					attrs: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('button--disabled'),
							$elm$html$Html$Attributes$disabled(true)
						]),
					label: options.labels.noChanges
				};
		}
	}();
	var attrs = _v0.attrs;
	var label = _v0.label;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-left', '8px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				attrs,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]));
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewReadOnlyRow = F3(
	function (shouldShowReceivablesColumn, shouldShowPayablesColumn, row) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'min-width', '200px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(row.name)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$Shared$Checkbox$viewDisabled(row.isVisibleToCustomer)
								]))
						]),
						shouldShowReceivablesColumn ? _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$Shared$Checkbox$viewDisabled(row.isRequiredForCustomer)
								]))
						]) : _List_Nil,
						shouldShowPayablesColumn ? _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Shared$Select$viewDisabled(
									{
										choices: _List_fromArray(
											[$author$project$Components$SettingsPage$Shared$PayablesValue$required, $author$project$Components$SettingsPage$Shared$PayablesValue$useHubtranDefaults]),
										placeholder: 'Select an option',
										toString: $author$project$Components$SettingsPage$Shared$PayablesValue$toString,
										value: $elm$core$Maybe$Just(row.isRequiredForPayables)
									})
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2($elm$html$Html$td, _List_Nil, _List_Nil)
						])
					])));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$RequiredForCustomer = {$: 'RequiredForCustomer'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$VisibleToCustomer = {$: 'VisibleToCustomer'};
var $author$project$Components$SettingsPage$Shared$DocumentTypeTable$isOptionalRow = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.rowType;
	},
	$elm$core$Basics$eq($author$project$Components$SettingsPage$Shared$DocumentTypeTable$OptionalRow));
var $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$toString = function (imageType) {
	if (imageType.$ === 'TypeValue') {
		var type_ = imageType.a;
		return type_.description;
	} else {
		return 'None';
	}
};
var $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$toValues = function (imageTypes) {
	return A2(
		$elm$core$List$cons,
		$author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$NoValue,
		A2(
			$elm$core$List$map,
			function (type_) {
				return $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$TypeValue(type_);
			},
			imageTypes));
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewRow = F6(
	function (shouldShowReceivablesColumn, shouldShowPayablesColumn, shouldShowCadenceImageTypes, imageTypes, messages, row) {
		var removeButton = $author$project$Components$SettingsPage$Shared$DocumentTypeTable$isOptionalRow(row) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button--link danger'),
					$elm$html$Html$Events$onClick(
					messages.remove(row.documentType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Remove')
				])) : $elm$html$Html$text('');
		var receivablesColumn = shouldShowReceivablesColumn ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$Shared$Checkbox$view(
						{
							id: _Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$DocumentTypesSettingsView$RequiredForCustomer),
							messages: messages.checkbox,
							value: row.isRequiredForCustomer
						})
					]))
			]) : _List_Nil;
		var optionalColumns = shouldShowPayablesColumn ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'min-width', '250px')
					]),
				_List_fromArray(
					[
						$author$project$Components$Shared$Select$view(
						{
							choices: _List_fromArray(
								[$author$project$Components$SettingsPage$Shared$PayablesValue$required, $author$project$Components$SettingsPage$Shared$PayablesValue$useHubtranDefaults]),
							disabledChoices: _List_Nil,
							onChange: messages.setPayablesValue(row.documentType),
							placeholder: 'Select an option',
							sortAlphabetically: false,
							toString: $author$project$Components$SettingsPage$Shared$PayablesValue$toString,
							value: $elm$core$Maybe$Just(row.isRequiredForPayables)
						})
					]))
			]) : (shouldShowCadenceImageTypes ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$Shared$Select$view(
						{
							choices: $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$toValues(imageTypes),
							disabledChoices: _List_Nil,
							onChange: messages.setCadenceImageType(row.documentType),
							placeholder: 'Select an option',
							sortAlphabetically: false,
							toString: $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$toString,
							value: $elm$core$Maybe$Just(row.maybeCadenceImageType)
						})
					]))
			]) : _List_Nil);
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'min-width', '200px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(row.name)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$Shared$Checkbox$view(
									{
										id: _Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$DocumentTypesSettingsView$VisibleToCustomer),
										messages: messages.checkbox,
										value: row.isVisibleToCustomer
									})
								]))
						]),
						receivablesColumn,
						optionalColumns,
						_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[removeButton]))
						])
					])));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewSelect = function (options) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(options.label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
					]),
				_List_fromArray(
					[
						$author$project$Components$Shared$Select$view(options.select),
						function () {
						var _v0 = options.select.value;
						if (_v0.$ === 'Just') {
							var value = _v0.a;
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin-left', '8px'),
										$elm$html$Html$Attributes$class('button--confirmation'),
										$elm$html$Html$Events$onClick(
										options.onAddClick(value))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add')
									]));
						} else {
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin-left', '8px'),
										$elm$html$Html$Attributes$class('button--disabled')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add')
									]));
						}
					}()
					]))
			]));
};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewDocumentTypesSection = F2(
	function (data, model) {
		var shouldShowReceivablesColumn = data.currentAccount.receivablesAccount || data.accountSettings.auditBillingEnabled;
		var shouldShowPayablesColumn = !data.currentAccount.factorAccount;
		var shouldShowCadenceImageTypes = data.accountSettings.useCadenceImageTypes;
		var optionalHeaders = shouldShowPayablesColumn ? _List_fromArray(
			['Required for Payables']) : (shouldShowCadenceImageTypes ? _List_fromArray(
			['Cadence Image Type']) : _List_Nil);
		var noun = data.currentAccount.factorAccount ? 'Debtor' : 'Customer';
		var receivablesHeader = shouldShowReceivablesColumn ? _List_fromArray(
			['Required for ' + (noun + ' Billing')]) : _List_Nil;
		var imageTypes = data.documentTypeSettings.cadenceImageTypes;
		var options = {
			account: data.currentAccount,
			headers: $elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						['Document Type', 'Visible to ' + noun]),
						receivablesHeader,
						optionalHeaders,
						_List_fromArray(
						[''])
					])),
			isEditable: data.currentUser.isAdmin,
			messages: {
				checkbox: {
					onCheck: $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowCheck(
						{v3ReskinEnabled: false}),
					onUncheck: $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowUncheck(
						{v3ReskinEnabled: false})
				},
				remove: $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowRemove(
					{v3ReskinEnabled: false}),
				setCadenceImageType: $author$project$Components$SettingsPage$DocumentTypesSettingsView$SetCadenceImageType(
					{v3ReskinEnabled: false}),
				setPayablesValue: $author$project$Components$SettingsPage$DocumentTypesSettingsView$SetPayablesValue(
					{v3ReskinEnabled: false})
			},
			rows: model.rows,
			viewReadOnlyRow: A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewReadOnlyRow, shouldShowReceivablesColumn, shouldShowPayablesColumn),
			viewRow: A4($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewRow, shouldShowReceivablesColumn, shouldShowPayablesColumn, shouldShowCadenceImageTypes, imageTypes)
		};
		return data.currentUser.isAdmin ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewSelect(
					{
						label: 'Add Document Types',
						onAddClick: $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnSelectAddClick(
							{v3ReskinEnabled: false}),
						select: {
							choices: data.documentTypeSettings.allDocumentTypeNames,
							disabledChoices: A2($elm$core$List$filterMap, $author$project$Components$SettingsPage$DocumentTypesSettingsView$fromRow, model.rows),
							onChange: $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnSelectChange,
							placeholder: 'Select a Document Type',
							sortAlphabetically: true,
							toString: function ($) {
								return $.name;
							},
							value: model.selectedOption
						}
					}),
					$author$project$Components$SettingsPage$Shared$DocumentTypeTable$view(options),
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewControls(
					{
						labels: {noChanges: 'Save', ready: 'Save', saving: 'Saving...'},
						onSave: $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnSave,
						status: function () {
							var _v0 = model.rowsSinceLastSave;
							if (_v0.$ === 'Just') {
								var rows = _v0.a;
								return _Utils_eq(rows, model.rows) ? $author$project$Components$SettingsPage$DocumentTypesSettingsView$Unmodified : $author$project$Components$SettingsPage$DocumentTypesSettingsView$Dirty;
							} else {
								return $author$project$Components$SettingsPage$DocumentTypesSettingsView$Saving;
							}
						}()
					})
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$SettingsPage$Shared$DocumentTypeTable$view(options)
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$authorizedView = F2(
	function (model, data) {
		var tmsMapSection = $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldViewTmsMapSection(data) ? A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$hubtranTmsMapSection, data, model, data.documentTypeSettings) : _List_Nil;
		var documentTypeHotkeysEnabledSection = $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldUseDocumentTypeHotkeys(data) ? $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[$author$project$Components$SettingsPage$DocumentTypesSettingsView$pageHeader]),
					A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeHotkeysSection, data, model),
					_List_fromArray(
					[$author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypesSectionHeader])
				])) : _List_fromArray(
			[$author$project$Components$SettingsPage$DocumentTypesSettingsView$header]);
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			10,
			$elm$core$List$concat(
				_List_fromArray(
					[
						documentTypeHotkeysEnabledSection,
						_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$SettingsPage$DocumentTypesSettingsView$DocumentTypes,
							A2(
								$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewDocumentTypesSection,
								data,
								A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$initDocumentTypesSection, model, data)))
						]),
						tmsMapSection,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewDocumentTypeForTruckPhotosSection(data)
					])));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelEditHotkeyList = {$: 'CancelEditHotkeyList'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewEditSection = function (options) {
	return options.isEditing ? A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[$author$project$Ui$V3$Stack$styleAsCard]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(options.title)
							])),
						A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceXSmall),
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						_List_fromArray(
							[
								options.headerBody,
								options.body,
								A2(
								$elm$core$Maybe$map,
								function (error) {
									return A2(
										$author$project$Ui$V3$Notification$viewInline,
										{
											message: $elm$html$Html$text(error),
											onClose: $elm$core$Maybe$Nothing,
											title: $elm$core$Maybe$Nothing
										},
										_List_fromArray(
											[$author$project$Ui$V3$Notification$error]));
								},
								options.error),
								$elm$core$Maybe$Just(
								$author$project$Helpers$Html$editButtons(
									{cancelMsg: options.cancelMsg, primaryDisabled: options.primaryDisabled, primaryLabel: 'Save', primaryMsg: options.primaryMsg}))
							]))
					]))
			])) : A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$styleAsCard,
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Ui$V3$Stack$viewVertMaybes,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
									]),
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
													$elm$html$Html$Events$onClick(options.editMsg)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(options.title)
												]))),
										options.headerBody
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$UtilityButton$view,
								{icon: $author$project$Ui$V3$Icon$editOutline16, label: 'Edit', onClick: options.editMsg},
								_List_Nil))
						]))),
				options.body
			]));
};
var $author$project$Ui$V3$SimpleSelect$ErrorAttribute = function (a) {
	return {$: 'ErrorAttribute', a: a};
};
var $author$project$Ui$V3$SimpleSelect$error = $author$project$Ui$V3$SimpleSelect$ErrorAttribute;
var $author$project$Ui$V3$SimpleSelect$SortByLabelAttribute = function (a) {
	return {$: 'SortByLabelAttribute', a: a};
};
var $author$project$Ui$V3$SimpleSelect$sortByLabel = $author$project$Ui$V3$SimpleSelect$SortByLabelAttribute;
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListTableV3Reskin = F2(
	function (data, model) {
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Basics$add(1),
								A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$html$Html$text))),
						heading: $elm$html$Html$text('Hotkey')
					},
						{
						attrs: _List_Nil,
						content: model.editingHotkeyList ? function (_v0) {
							var index = _v0.a;
							var docType = _v0.b;
							var error = A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$isDuplicateInList, model.localHotkeyList, docType);
							return A2(
								$author$project$Ui$V3$SimpleSelect$view,
								{
									onInput: $author$project$Components$SettingsPage$DocumentTypesSettingsView$UpdateHotkeySelection(index),
									options: A2(
										$elm$core$List$map,
										function ($) {
											return $.documentType;
										},
										data.documentTypeSettings.enabledDocumentTypeNames),
									toLabel: $author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeToString(data),
									value: $elm$core$Maybe$Just(docType)
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$SimpleSelect$placeholder(
										$elm$core$Maybe$Just('Select a Document Type')),
										$author$project$Ui$V3$SimpleSelect$error(error),
										$author$project$Ui$V3$SimpleSelect$sortByLabel(true)
									]));
						} : A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeToString(data),
								$elm$html$Html$text)),
						heading: $elm$html$Html$text('Document type')
					}
					])
			},
			_List_Nil,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				$elm$core$Tuple$pair,
				A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$getHotkeyList, data, model)));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeHotkeysSectionV3Reskin = F2(
	function (data, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewEditSection(
						{
							body: $elm$core$Maybe$Just(
								A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewHotkeyListTableV3Reskin, data, model)),
							cancelMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelEditHotkeyList,
							editMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$EditHotkeyList,
							error: $author$project$Components$SettingsPage$DocumentTypesSettingsView$hasDuplicate(model.localHotkeyList) ? $elm$core$Maybe$Just('Cannot have multiple hotkeys for a single document type') : $elm$core$Maybe$Nothing,
							headerBody: $elm$core$Maybe$Just(
								A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Numberpad hotkeys are available for the first 9 document types.'),
											$elm$html$Html$text('To configure the order of the first 9 document types, change the doctype for that hotkey below.')
										]))),
							isEditing: model.editingHotkeyList,
							primaryDisabled: model.isSaving,
							primaryMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveHotkeyList,
							title: 'Hotkeys for document types'
						})),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$elm$html$Html$text(''))
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelEditTmsMap = {$: 'CancelEditTmsMap'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelEditTmsPodMap = {$: 'CancelEditTmsPodMap'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$EditTmsMap = {$: 'EditTmsMap'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$EditTmsPodMap = {$: 'EditTmsPodMap'};
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsMapTableV3Reskin = F3(
	function (data, model, settings) {
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_Nil,
						content: function (documentTypeWithName) {
							return $elm$html$Html$text(documentTypeWithName.name);
						},
						heading: $elm$html$Html$text('TriumphPay Audit Type')
					},
						{
						attrs: _List_Nil,
						content: function (documentTypeWithName) {
							var key = $author$project$AuditPb$documentTypeToString(documentTypeWithName.documentType);
							var val = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Dict$get,
									key,
									A2(
										$author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsMap,
										$author$project$Forward$Remote$Loaded(data),
										model)));
							return A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: $author$project$Components$SettingsPage$DocumentTypesSettingsView$InputTmsMap(key)
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$disabled(!model.editingTmsMap)
									]),
								_List_Nil,
								val);
						},
						heading: $elm$html$Html$text('TMS type')
					}
					])
			},
			_List_Nil,
			_List_Nil,
			settings.enabledDocumentTypeNames);
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsPodMapTableV3Reskin = F2(
	function (data, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorz,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$styleAsCard]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Document set as POD (any document type)'),
					A4(
					$author$project$Ui$V3$Input$view,
					{onInput: $author$project$Components$SettingsPage$DocumentTypesSettingsView$InputTmsPodMap},
					_List_fromArray(
						[
							$author$project$Ui$V3$Input$disabled(!model.editingTmsPodMap)
						]),
					_List_Nil,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$author$project$Components$SettingsPage$DocumentTypesSettingsView$currentTmsPodMap,
							$author$project$Forward$Remote$Loaded(data),
							model)))
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$hubtranTmsMapSectionV3Reskin = F3(
	function (data, model, settings) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewEditSection(
							{
								body: $elm$core$Maybe$Just(
									A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsMapTableV3Reskin, data, model, settings)),
								cancelMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelEditTmsMap,
								editMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$EditTmsMap,
								error: $elm$core$Maybe$Nothing,
								headerBody: $elm$core$Maybe$Nothing,
								isEditing: model.editingTmsMap,
								primaryDisabled: model.isSaving,
								primaryMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveTmsMap,
								title: 'TriumphPay Audit ↔ TMS document type mappings'
							})),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$elm$html$Html$text(''))
					])),
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewEditSection(
							{
								body: $elm$core$Maybe$Just(
									A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$viewTmsPodMapTableV3Reskin, data, model)),
								cancelMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelEditTmsPodMap,
								editMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$EditTmsPodMap,
								error: $elm$core$Maybe$Nothing,
								headerBody: $elm$core$Maybe$Nothing,
								isEditing: model.editingTmsPodMap,
								primaryDisabled: model.isSaving,
								primaryMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveTmsPodMap,
								title: 'TriumphPay Audit POD flag ↔ TMS document type mapping'
							})),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$elm$html$Html$text(''))
					]))
			]);
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelOnRowRemove = {$: 'CancelOnRowRemove'};
var $author$project$Domain$UnresolvedDocumentType$mapResolved = F2(
	function (f, unresolvedDocumentType) {
		if (unresolvedDocumentType.$ === 'Resolved') {
			var docType = unresolvedDocumentType.a;
			return f(docType);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$maybeViewRemovalWarningModal = F3(
	function (v3ReskinEnabled, model, data) {
		var findName = function (docType) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.name;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.documentType;
						},
						$elm$core$Basics$eq(docType)),
					data.documentTypeSettings.allDocumentTypeNames));
		};
		var viewModal = function (documentType) {
			return A2(
				$author$project$Ui$V3$Modal$view,
				_List_Nil,
				{
					body: $elm$html$Html$text(
						'Removing ' + (A2(
							$elm$core$Maybe$withDefault,
							'Unknown',
							A2($author$project$Domain$UnresolvedDocumentType$mapResolved, findName, documentType)) + (' as a document type will likely cause major interruptions in document processing. ' + 'Please discuss with your Customer Success Manager before proceeding.'))),
					cancelButton: $elm$core$Maybe$Just(
						_Utils_Tuple2('Cancel', $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelOnRowRemove)),
					dismissMsg: $author$project$Components$SettingsPage$DocumentTypesSettingsView$CancelOnRowRemove,
					footerButtons: _List_Nil,
					header: $author$project$Ui$V3$Modal$textHeader('Warning'),
					primaryButton: $elm$core$Maybe$Just(
						_Utils_Tuple2(
							'Continue',
							A2(
								$author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowRemove,
								{v3ReskinEnabled: v3ReskinEnabled},
								documentType))),
					size: $author$project$Ui$V3$Modal$small
				});
		};
		return A2(
			$elm$html$Html$map,
			$author$project$Components$SettingsPage$DocumentTypesSettingsView$DocumentTypes,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$html$Html$text(''),
				viewModal,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.documentTypeRemovalWarning;
					},
					model.changes)));
	});
var $author$project$Ui$V3$SimpleSelect$DisabledOptionsAttribute = function (a) {
	return {$: 'DisabledOptionsAttribute', a: a};
};
var $author$project$Ui$V3$SimpleSelect$disabledOptions = $author$project$Ui$V3$SimpleSelect$DisabledOptionsAttribute;
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewDocumentTypeForTruckPhotosSectionV3Reskin = function (data) {
	var value = A2(
		$elm_community$list_extra$List$Extra$find,
		function (d) {
			return _Utils_eq(d.documentType, data.accountSettings.documentTypeForTruckPhotos);
		},
		data.documentTypeSettings.enabledDocumentTypeNames);
	var labelText = 'Document Type to set on photos auto-identified by system as \u0027Photos of trucks / trailers / cargo\u0027';
	var label = 'When Triumph Audit detects a photo of a truck or trailer, what document type should it set that photo as?';
	var choices = data.documentTypeSettings.enabledDocumentTypeNames;
	return $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldShowDocumentTypeForPhotosSection(data) ? _List_fromArray(
		[
			A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
							$author$project$Ui$V3$Stack$crossAxisBottom
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Helpers$Html$labeledInput,
								label,
								A2(
									$author$project$Ui$V3$SimpleSelect$view,
									{
										onInput: $author$project$Components$SettingsPage$DocumentTypesSettingsView$SaveDocumentTypeForTruckPhotos,
										options: choices,
										toLabel: function ($) {
											return $.name;
										},
										value: value
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$SimpleSelect$placeholder(
											$elm$core$Maybe$Just('Select a document type')),
											$author$project$Ui$V3$SimpleSelect$disabledOptions(_List_Nil),
											$author$project$Ui$V3$SimpleSelect$sortByLabel(true)
										]))))
						]))
				]))
		]) : _List_Nil;
};
var $author$project$Ui$V3$SimpleSelect$DisabledAttribute = function (a) {
	return {$: 'DisabledAttribute', a: a};
};
var $author$project$Ui$V3$SimpleSelect$disabled = $author$project$Ui$V3$SimpleSelect$DisabledAttribute;
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$viewDocumentTypesSectionV3Reskin = F2(
	function (data, model) {
		var shouldShowReceivablesColumn = data.currentAccount.receivablesAccount || data.accountSettings.auditBillingEnabled;
		var shouldShowPayablesColumn = !data.currentAccount.factorAccount;
		var shouldShowCadenceImageTypes = data.accountSettings.useCadenceImageTypes;
		var noun = data.currentAccount.factorAccount ? 'Debtor' : 'Customer';
		var isDisabled = !data.currentUser.isAdmin;
		var imageTypes = data.documentTypeSettings.cadenceImageTypes;
		var docTypeTable = A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.name;
									},
									$author$project$Ui$V3$Typography$smallBodySemiBold(_List_Nil)),
								heading: $elm$html$Html$text('Document Type')
							}),
							$elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: function (row) {
									return A2(
										$author$project$Ui$V3$Checkbox$view,
										{
											checked: $author$project$Components$SettingsPage$Shared$Checkbox$isChecked(row.isVisibleToCustomer),
											label: $elm$html$Html$text(''),
											onCheck: function (checked) {
												return checked ? A2(
													$author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowCheck,
													{v3ReskinEnabled: true},
													_Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$DocumentTypesSettingsView$VisibleToCustomer)) : A2(
													$author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowUncheck,
													{v3ReskinEnabled: true},
													_Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$DocumentTypesSettingsView$VisibleToCustomer));
											}
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Checkbox$disabled(isDisabled)
											]));
								},
								heading: $elm$html$Html$text('Visible to ' + noun)
							}),
							shouldShowReceivablesColumn ? $elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: function (row) {
									return A2(
										$author$project$Ui$V3$Checkbox$view,
										{
											checked: $author$project$Components$SettingsPage$Shared$Checkbox$isChecked(row.isRequiredForCustomer),
											label: $elm$html$Html$text(''),
											onCheck: function (checked) {
												return checked ? A2(
													$author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowCheck,
													{v3ReskinEnabled: true},
													_Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$DocumentTypesSettingsView$RequiredForCustomer)) : A2(
													$author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowUncheck,
													{v3ReskinEnabled: true},
													_Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$DocumentTypesSettingsView$RequiredForCustomer));
											}
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Checkbox$disabled(isDisabled)
											]));
								},
								heading: $elm$html$Html$text('Required for ' + (noun + ' Billing'))
							}) : $elm$core$Maybe$Nothing,
							shouldShowPayablesColumn ? $elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: function (row) {
									return A2(
										$author$project$Ui$V3$SimpleSelect$view,
										{
											onInput: A2(
												$author$project$Components$SettingsPage$DocumentTypesSettingsView$SetPayablesValue,
												{v3ReskinEnabled: true},
												row.documentType),
											options: _List_fromArray(
												[$author$project$Components$SettingsPage$Shared$PayablesValue$required, $author$project$Components$SettingsPage$Shared$PayablesValue$useHubtranDefaults]),
											toLabel: $author$project$Components$SettingsPage$Shared$PayablesValue$toString,
											value: $elm$core$Maybe$Just(row.isRequiredForPayables)
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$SimpleSelect$disabled(isDisabled)
											]));
								},
								heading: $elm$html$Html$text('Required for Payables')
							}) : (shouldShowCadenceImageTypes ? $elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: function (row) {
									return A2(
										$author$project$Ui$V3$SimpleSelect$view,
										{
											onInput: A2(
												$author$project$Components$SettingsPage$DocumentTypesSettingsView$SetCadenceImageType,
												{v3ReskinEnabled: true},
												row.documentType),
											options: $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$toValues(imageTypes),
											toLabel: $author$project$Components$SettingsPage$Shared$CadenceImageTypeValue$toString,
											value: $elm$core$Maybe$Just(row.maybeCadenceImageType)
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$SimpleSelect$disabled(isDisabled)
											]));
								},
								heading: $elm$html$Html$text('Cadence Image Type')
							}) : $elm$core$Maybe$Nothing),
							isDisabled ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: function (row) {
									return A2(
										$author$project$Ui$V3$UtilityButton$view,
										{
											icon: $author$project$Ui$V3$Icon$removeOutline16,
											label: 'Remove',
											onClick: A2(
												$author$project$Components$SettingsPage$DocumentTypesSettingsView$OnRowRemove,
												{v3ReskinEnabled: true},
												row.documentType)
										},
										_List_Nil);
								},
								heading: $elm$html$Html$text('')
							})
						]))
			},
			_List_Nil,
			_List_Nil,
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.name;
				},
				model.rows));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Select visible and required documents')
						])),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
							$author$project$Ui$V3$Stack$crossAxisBottom
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Helpers$Html$labeledInput,
								'Add document types',
								A2(
									$author$project$Ui$V3$SimpleSelect$view,
									{
										onInput: $author$project$Components$SettingsPage$DocumentTypesSettingsView$OnSelectChange,
										options: data.documentTypeSettings.allDocumentTypeNames,
										toLabel: function ($) {
											return $.name;
										},
										value: model.selectedOption
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$SimpleSelect$placeholder(
											$elm$core$Maybe$Just('Select a Document Type')),
											$author$project$Ui$V3$SimpleSelect$disabledOptions(
											A2($elm$core$List$filterMap, $author$project$Components$SettingsPage$DocumentTypesSettingsView$fromRow, model.rows)),
											$author$project$Ui$V3$SimpleSelect$sortByLabel(true)
										])))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							function () {
								var _v0 = model.selectedOption;
								if (_v0.$ === 'Just') {
									var value = _v0.a;
									return A3(
										$author$project$Ui$V3$Button$view,
										{
											action: $author$project$Ui$V3$Button$onClick(
												A2(
													$author$project$Components$SettingsPage$DocumentTypesSettingsView$OnSelectAddClick,
													{v3ReskinEnabled: true},
													value))
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Button$rightIcon16WithHiddenLabel($author$project$Ui$V3$Icon$add16)
											]),
										'Add');
								} else {
									return A3(
										$author$project$Ui$V3$Button$view,
										{action: $author$project$Ui$V3$Button$submitForm},
										_List_fromArray(
											[
												$author$project$Ui$V3$Button$rightIcon16WithHiddenLabel($author$project$Ui$V3$Icon$add16),
												$author$project$Ui$V3$Button$disabled(true)
											]),
										'Add');
								}
							}())
						])),
					docTypeTable
				]));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$authorizedViewV3Reskin = F2(
	function (model, data) {
		var tmsMapSection = $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldViewTmsMapSection(data) ? A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$hubtranTmsMapSectionV3Reskin, data, model, data.documentTypeSettings) : _List_Nil;
		var documentTypeHotkeysEnabledSection = $author$project$Components$SettingsPage$DocumentTypesSettingsView$shouldUseDocumentTypeHotkeys(data) ? _List_fromArray(
			[
				A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$documentTypeHotkeysSectionV3Reskin, data, model)
			]) : _List_Nil;
		return $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
					]),
				_List_fromArray(
					[
						A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$maybeViewRemovalWarningModal, true, model, data),
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Document types')
							])),
						A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									documentTypeHotkeysEnabledSection,
									_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$SettingsPage$DocumentTypesSettingsView$DocumentTypes,
										A2(
											$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewDocumentTypesSectionV3Reskin,
											data,
											A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$initDocumentTypesSection, model, data)))
									]),
									tmsMapSection,
									$author$project$Components$SettingsPage$DocumentTypesSettingsView$viewDocumentTypeForTruckPhotosSectionV3Reskin(data)
								])))
					])));
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$loadedView = F3(
	function (v3ReskinEnabled, model, data) {
		return data.currentUser.hasSettingsRole ? (v3ReskinEnabled ? A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$authorizedViewV3Reskin, model, data) : A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$authorizedView, model, data)) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$SettingsPage$DocumentTypesSettingsView$view = F3(
	function (v3ReskinEnabled, data, model) {
		return A3(
			$author$project$Forward$LoadingView$viewV3Reskinnable,
			v3ReskinEnabled,
			A2($author$project$Components$SettingsPage$DocumentTypesSettingsView$loadedView, v3ReskinEnabled, model),
			data);
	});
var $author$project$Components$SettingsPage$Shared$EditSection$CancelEditing = {$: 'CancelEditing'};
var $author$project$Components$SettingsPage$Shared$EditSection$ChangeValue = function (a) {
	return {$: 'ChangeValue', a: a};
};
var $author$project$Components$SettingsPage$Shared$EditSection$Save = {$: 'Save'};
var $author$project$Components$SettingsPage$Shared$EditSection$StartEditing = {$: 'StartEditing'};
var $author$project$Components$SettingsPage$Shared$EditSection$space = A2(
	$elm$html$Html$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text($author$project$Helpers$String$nbsp)
		]));
var $author$project$Components$SettingsPage$Shared$EditSection$cancel = F2(
	function (description, msg) {
		return _List_fromArray(
			[
				$elm$html$Html$text(description),
				$author$project$Components$SettingsPage$Shared$EditSection$space,
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('cancel')
					]))
			]);
	});
var $author$project$Components$SettingsPage$Shared$EditSection$pencil = F2(
	function (description, msg) {
		return _List_fromArray(
			[
				$elm$html$Html$text(description),
				$author$project$Components$SettingsPage$Shared$EditSection$space,
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-pencil')
							]),
						_List_Nil)
					]))
			]);
	});
var $author$project$Components$SettingsPage$Shared$EditSection$sharedView = F3(
	function (error, header, body) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-header')
						]),
					header),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-body')
						]),
					_List_fromArray(
						[
							function () {
							if (error.$ === 'Nothing') {
								return $elm$html$Html$text('');
							} else {
								var message = error.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('alert-box alert')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]));
							}
						}(),
							body
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$EditSection$view = F2(
	function (_v0, _v1) {
		var formView = _v0.formView;
		var summaryView = _v0.summaryView;
		var toMsg = _v0.toMsg;
		var title = _v0.title;
		var section = _v1.a;
		return A2(
			$elm$html$Html$map,
			toMsg,
			section.editing ? A3(
				$author$project$Components$SettingsPage$Shared$EditSection$sharedView,
				section.errors,
				A2($author$project$Components$SettingsPage$Shared$EditSection$cancel, title, $author$project$Components$SettingsPage$Shared$EditSection$CancelEditing),
				A4(formView, $author$project$Components$SettingsPage$Shared$EditSection$ChangeValue, $author$project$Components$SettingsPage$Shared$EditSection$Save, section.saving, section.current)) : A3(
				$author$project$Components$SettingsPage$Shared$EditSection$sharedView,
				$elm$core$Maybe$Nothing,
				A2($author$project$Components$SettingsPage$Shared$EditSection$pencil, title, $author$project$Components$SettingsPage$Shared$EditSection$StartEditing),
				A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					summaryView(section.initial))));
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$authorizedView = F2(
	function (data, model) {
		return A2(
			$author$project$Components$Shared$Grid$autoRow,
			10,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Exceptions')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Grid$column,
							10,
							_List_fromArray(
								[
									A2(
									$author$project$Components$SettingsPage$Shared$EditSection$view,
									A2($author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectConfig, data.currentAccount, data.accountSettings),
									A2($author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectTemplate, data, model))
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$TemplateVariables$listViewV3Reskin = F4(
	function (example, templateVariables, loadReferenceVariables, shipmentReferenceVariables) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Available variables'),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-left', '28px')
								]),
							A2(
								$elm$core$List$map,
								function (s) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(s)
											]));
								},
								_Utils_ap(
									templateVariables,
									_Utils_ap(loadReferenceVariables, shipmentReferenceVariables))))
						])),
					example
				]));
	});
var $author$project$Components$SettingsPage$Shared$TemplateVariables$referenceInstructionsV3Reskin = F2(
	function (supportLoadReferences, supportShipmentReferences) {
		var shipmentInstructions = supportShipmentReferences ? _List_fromArray(
			[
				$elm$html$Html$text('Shipment Reference example (if your shipments have a reference named `Shipping Order`): Invoice for Order [Shipping Order]'),
				$elm$html$Html$text('Resulting Subject: Invoice for Order 456')
			]) : _List_Nil;
		var loadInstructions = supportLoadReferences ? _List_fromArray(
			[
				$elm$html$Html$text('Load Reference example (if your loads have a reference named \u0027Customer Load ID\u0027): Invoice for Load <Customer Load ID>'),
				$elm$html$Html$text('Resulting Subject: Invoice for Load 123')
			]) : _List_Nil;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Available references'),
							$elm$html$Html$text('You can use load and shipment references as variables as well. Use angle brackets <> for load references, and square brackets [] for shipment references. Make sure you match the case and spacing exactly as found in your TMS, otherwise it won\u0027t match.')
						])),
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Examples')
								]),
								loadInstructions,
								shipmentInstructions
							])))
				]));
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$templateVariablesExampleV3Reskin = function (currentAccount) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Example'),
						$elm$html$Html$text(
						'Custom Subject: ' + $author$project$Components$SettingsPage$ExceptionSettingsView$defaultTemplate(currentAccount)),
						$elm$html$Html$text(
						'Resulting Subject: ' + $author$project$Components$SettingsPage$ExceptionSettingsView$defaultTemplateRendered(currentAccount))
					])),
				A2($author$project$Components$SettingsPage$Shared$TemplateVariables$referenceInstructionsV3Reskin, true, false)
			]));
};
var $author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectFormViewV3Reskin = F4(
	function (currentAccount, accountSettings, set, result) {
		return _Utils_Tuple3(
			A4(
				$author$project$Ui$V3$Input$view,
				{
					onInput: A2(
						$elm$core$Basics$composeL,
						set,
						$author$project$Components$SettingsPage$ExceptionSettingsView$ensureValidTemplate(accountSettings))
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$label('Custom Exception Email Subject (optional)'),
						$author$project$Ui$V3$Input$error(
						$author$project$Helpers$Result$isError(result))
					]),
				_List_Nil,
				A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result)),
			A4(
				$author$project$Components$SettingsPage$Shared$TemplateVariables$listViewV3Reskin,
				$author$project$Components$SettingsPage$ExceptionSettingsView$templateVariablesExampleV3Reskin(currentAccount),
				accountSettings.payablesTemplateVariables,
				accountSettings.loadReferenceVariables,
				_List_Nil),
			$author$project$Helpers$Result$isOk(result));
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectConfigV3Reskin = F2(
	function (currentAccount, accountSettings) {
		return {
			apiRequest: $author$project$Components$SettingsPage$ExceptionSettingsView$validatingSend($author$project$Api$Accounts$customExceptionSubjectTemplate),
			formView: A2($author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectFormViewV3Reskin, currentAccount, accountSettings),
			summaryView: $author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectSummaryView,
			title: 'Custom exception subject',
			toMsg: $author$project$Components$SettingsPage$ExceptionSettingsView$CustomSubjectUpdate
		};
	});
var $author$project$Components$SettingsPage$Shared$EditSection$sharedViewV3Reskin = F3(
	function (error, header, body) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$styleAsCard]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__type__h3')
								]),
							header),
							A2(
							$author$project$Ui$V3$Stack$viewVertMaybes,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									function (e) {
										return A2(
											$author$project$Ui$V3$Notification$viewInline,
											{
												message: $elm$html$Html$text(e),
												onClose: $elm$core$Maybe$Nothing,
												title: $elm$core$Maybe$Nothing
											},
											_List_fromArray(
												[$author$project$Ui$V3$Notification$error]));
									},
									error),
									$elm$core$Maybe$Just(body)
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$EditSection$viewV3ReskinCustom = function (_v0) {
	var onSave = _v0.onSave;
	var onCancel = _v0.onCancel;
	var onStartEdit = _v0.onStartEdit;
	var initial = _v0.initial;
	var current = _v0.current;
	var maybeError = _v0.maybeError;
	var saving = _v0.saving;
	var editing = _v0.editing;
	var formView = _v0.formView;
	var summaryView = _v0.summaryView;
	var title = _v0.title;
	if (editing) {
		var _v1 = formView(current);
		var formViewHtmlTop = _v1.a;
		var maybeFormViewHtmlBottom = _v1.b;
		var isValid = _v1.c;
		var isDisabled = saving || (!isValid);
		return A3(
			$author$project$Components$SettingsPage$Shared$EditSection$sharedViewV3Reskin,
			maybeError,
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]),
			A2(
				$author$project$Ui$V3$Stack$viewVertMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceXSmall),
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						$elm$core$Maybe$Just(formViewHtmlTop),
						$elm$core$Maybe$Just(
						$author$project$Helpers$Html$editButtons(
							{cancelMsg: onCancel, primaryDisabled: isDisabled, primaryLabel: 'Save', primaryMsg: onSave})),
						maybeFormViewHtmlBottom
					])));
	} else {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
										$elm$html$Html$Events$onClick(onStartEdit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])),
								A2(
								$author$project$Ui$V3$Stack$viewVertMaybes,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
									]),
								_List_fromArray(
									[
										A2(
										$elm$core$Maybe$map,
										function (e) {
											return A2(
												$author$project$Ui$V3$Notification$viewInline,
												{
													message: $elm$html$Html$text(e),
													onClose: $elm$core$Maybe$Nothing,
													title: $elm$core$Maybe$Nothing
												},
												_List_fromArray(
													[$author$project$Ui$V3$Notification$error]));
										},
										maybeError),
										$elm$core$Maybe$Just(
										A2(
											$elm$html$Html$map,
											$elm$core$Basics$never,
											summaryView(initial)))
									]))
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$UtilityButton$view,
						{icon: $author$project$Ui$V3$Icon$editOutline16, label: 'Edit', onClick: onStartEdit},
						_List_fromArray(
							[$author$project$Ui$V3$UtilityButton$sizeSmall])))
				]));
	}
};
var $author$project$Components$SettingsPage$Shared$EditSection$viewV3ReskinHelper = F2(
	function (_v0, _v1) {
		var formView = _v0.formView;
		var summaryView = _v0.summaryView;
		var toMsg = _v0.toMsg;
		var title = _v0.title;
		var section = _v1.a;
		return A2(
			$elm$html$Html$map,
			toMsg,
			$author$project$Components$SettingsPage$Shared$EditSection$viewV3ReskinCustom(
				{
					current: section.current,
					editing: section.editing,
					formView: formView($author$project$Components$SettingsPage$Shared$EditSection$ChangeValue),
					initial: section.initial,
					maybeError: section.errors,
					onCancel: $author$project$Components$SettingsPage$Shared$EditSection$CancelEditing,
					onSave: $author$project$Components$SettingsPage$Shared$EditSection$Save,
					onStartEdit: $author$project$Components$SettingsPage$Shared$EditSection$StartEditing,
					saving: section.saving,
					summaryView: summaryView,
					title: title
				}));
	});
var $author$project$Components$SettingsPage$Shared$EditSection$viewInlineBtnsV3Reskin = function (_v0) {
	var formView = _v0.formView;
	var summaryView = _v0.summaryView;
	var toMsg = _v0.toMsg;
	var title = _v0.title;
	return $author$project$Components$SettingsPage$Shared$EditSection$viewV3ReskinHelper(
		{
			formView: F2(
				function (set, result) {
					return function (_v1) {
						var preHtml = _v1.a;
						var postHtml = _v1.b;
						var isValid = _v1.c;
						return _Utils_Tuple3(
							preHtml,
							$elm$core$Maybe$Just(postHtml),
							isValid);
					}(
						A2(formView, set, result));
				}),
			summaryView: summaryView,
			title: title,
			toMsg: toMsg
		});
};
var $author$project$Components$SettingsPage$ExceptionSettingsView$authorizedViewV3Reskin = F2(
	function (data, model) {
		return $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Exceptions')
							])),
						A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewInlineBtnsV3Reskin,
						A2($author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectConfigV3Reskin, data.currentAccount, data.accountSettings),
						A2($author$project$Components$SettingsPage$ExceptionSettingsView$customSubjectTemplate, data, model))
					])));
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CancelDelete = {$: 'CancelDelete'};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$DeleteTemplate = function (a) {
	return {$: 'DeleteTemplate', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$deleteModalV2View = function (model) {
	var _v0 = model.deletingState;
	if (_v0.$ === 'NotDeleting') {
		return $author$project$Ui$spacer;
	} else {
		var templateToDelete = _v0.a;
		return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('enable_shared-ui-v3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('v3__theme')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Modal$view,
								_List_Nil,
								{
									body: $elm$html$Html$text('Are you sure you want to delete this message?'),
									cancelButton: $elm$core$Maybe$Just(
										_Utils_Tuple2('Cancel', $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CancelDelete)),
									dismissMsg: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CancelDelete,
									footerButtons: _List_Nil,
									header: $author$project$Ui$V3$Modal$textHeader('Delete message'),
									primaryButton: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											'Confirm',
											$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$DeleteTemplate(templateToDelete))),
									size: $author$project$Ui$V3$Modal$medium
								})
							]))
					])));
	}
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartCreatingTemplate = {$: 'StartCreatingTemplate'};
var $author$project$Ui$between4 = function (config) {
	return _Utils_update(
		config,
		{between: 4});
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetAsDefault = function (a) {
	return {$: 'SetAsDefault', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartDeleting = function (a) {
	return {$: 'StartDeleting', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartEditing = function (a) {
	return {$: 'StartEditing', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$pencil = function (msg) {
	return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
		A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-pencil')
						]),
					_List_Nil)
				])));
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$trash = function (msg) {
	return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
		A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-trash')
						]),
					_List_Nil)
				])));
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$showTemplateV2 = F2(
	function (_v0, template) {
		var isDefault = template.isDefault;
		return $author$project$Ui$row(
			_List_fromArray(
				[
					A2(
					$author$project$Ui$stack,
					_List_fromArray(
						[$author$project$Ui$between2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$inline,
							_List_fromArray(
								[$author$project$Ui$between3]),
							_List_fromArray(
								[
									$author$project$Ui$heading5(template.name),
									$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$pencil(
									$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartEditing(template)),
									isDefault ? A2(
									$author$project$Ui$inline,
									_List_fromArray(
										[$author$project$Ui$between2]),
									_List_fromArray(
										[
											$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
											A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('disabled')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('fi-trash')
															]),
														_List_Nil)
													]))),
											$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
											A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('disabled')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('default')
													])))
										])) : A2(
									$author$project$Ui$inline,
									_List_fromArray(
										[$author$project$Ui$between2]),
									_List_fromArray(
										[
											$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$trash(
											$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartDeleting(template)),
											$author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
											A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetAsDefault(template))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Set as default')
													])))
										]))
								])),
							$author$project$Ui$text('Subject: ' + template.subject),
							A2(
							$author$project$Ui$stack,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Ui$text,
								$elm$core$String$lines(template.body)))
						]))
				]));
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CancelEdit = {$: 'CancelEdit'};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CreateButtonClick = {$: 'CreateButtonClick'};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NoOp = {$: 'NoOp'};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SaveButtonClick = function (a) {
	return {$: 'SaveButtonClick', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetBody = function (a) {
	return {$: 'SetBody', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetName = function (a) {
	return {$: 'SetName', a: a};
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetSubject = function (a) {
	return {$: 'SetSubject', a: a};
};
var $author$project$Ui$textarea = function (config) {
	var inputClass = $author$project$Ui$hasError(config.feedback) ? 'hubtran-input__text--error' : 'hubtran-input__text';
	return A2(
		$author$project$Ui$keyedStack,
		_List_fromArray(
			[$author$project$Ui$between1]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$author$project$Ui$Ui(
					A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-input__label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.label)
							])))),
				_Utils_Tuple2(
				'feedback',
				$author$project$Ui$feedbackView(config.feedback)),
				_Utils_Tuple2(
				'input',
				$author$project$Ui$Ui(
					A2(
						$elm$html$Html$textarea,
						$author$project$Helpers$Attributes$blockGrammarly(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$rows(4),
									$elm$html$Html$Attributes$class(inputClass),
									$elm$html$Html$Attributes$placeholder(config.placeholder),
									$elm$html$Html$Events$onInput(config.onChange),
									$elm$html$Html$Events$onBlur(config.onBlur)
								])),
						_List_fromArray(
							[
								$elm$html$Html$text(config.value)
							]))))
			]));
};
var $author$project$Ui$bold = function (content) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-text__bold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				])));
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewHelpTextV2 = function (account) {
	return A2(
		$author$project$Ui$stack,
		_List_fromArray(
			[$author$project$Ui$between2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$stack,
				_List_fromArray(
					[$author$project$Ui$between1]),
				_List_fromArray(
					[
						$author$project$Ui$bold('Common variables'),
						A2(
						$author$project$Ui$stack,
						_List_fromArray(
							[$author$project$Ui$between1]),
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Ui$text('{invoice_number}'),
									$author$project$Ui$text('{carrier_name}'),
									$author$project$Ui$text('{load_id}'),
									$author$project$Ui$text('{exception_summary}'),
									$author$project$Ui$text('{account_name}'),
									$author$project$Ui$text('{signature}')
								]),
							account.payablesAccount ? _List_fromArray(
								[
									$author$project$Ui$text('{ship_date}'),
									$author$project$Ui$text('{invoiced_amount}'),
									$author$project$Ui$text('{expected_amount}'),
									$author$project$Ui$text('{load_status}'),
									$author$project$Ui$text('{variance_amount}'),
									$author$project$Ui$text('{customer_charge}'),
									$author$project$Ui$text('{weight}'),
									$author$project$Ui$text('{freight_class}'),
									$author$project$Ui$text('{account_number}')
								]) : _List_Nil)),
						A2(
						$author$project$Ui$stack,
						_List_fromArray(
							[$author$project$Ui$between1]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$inline,
								_List_fromArray(
									[$author$project$Ui$between1]),
								_List_fromArray(
									[
										$author$project$Ui$bold('Input: '),
										$author$project$Ui$text('Invoice number {invoice_number} has exceptions')
									])),
								A2(
								$author$project$Ui$inline,
								_List_fromArray(
									[$author$project$Ui$between1]),
								_List_fromArray(
									[
										$author$project$Ui$bold('Result: '),
										$author$project$Ui$text('Invoice number 11223344 has exceptions')
									]))
							]))
					])),
				A2(
				$author$project$Ui$stack,
				_List_fromArray(
					[$author$project$Ui$between1]),
				_List_fromArray(
					[
						$author$project$Ui$bold('Available variables'),
						$author$project$Ui$text('You can use load and shipment references as variables as well.\u000AUse angle brackets <> for load references, and square brackets [] for shipment references.\u000AMake sure you match the case and spacing exactly as found in your TMS, otherwise it won\u0027t match.'),
						A2(
						$author$project$Ui$stack,
						_List_fromArray(
							[$author$project$Ui$between1]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$inline,
								_List_fromArray(
									[$author$project$Ui$between1]),
								_List_fromArray(
									[
										$author$project$Ui$bold('Input: '),
										$author$project$Ui$text('Confirmation required since margin has decreased by <Margin>')
									])),
								A2(
								$author$project$Ui$inline,
								_List_fromArray(
									[$author$project$Ui$between1]),
								_List_fromArray(
									[
										$author$project$Ui$bold('Result: '),
										$author$project$Ui$text('Confirmation required since margin has decreased by 12%')
									]))
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateFormV2 = F3(
	function (account, form, maybeTemplate) {
		var saveMsg = function () {
			if (maybeTemplate.$ === 'Just') {
				var template = maybeTemplate.a;
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SaveButtonClick(template);
			} else {
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CreateButtonClick;
			}
		}();
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$stack,
					_List_fromArray(
						[$author$project$Ui$between1]),
					_List_fromArray(
						[
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: 'Template name', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NoOp, onChange: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetName, placeholder: '', value: form.name}),
							$author$project$Ui$textInput(
							{feedback: $elm$core$Maybe$Nothing, label: 'Subject line', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NoOp, onChange: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetSubject, placeholder: '', value: form.subject}),
							$author$project$Ui$textarea(
							{feedback: $elm$core$Maybe$Nothing, label: 'Message', labelPrefix: $elm$core$Maybe$Nothing, onBlur: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$NoOp, onChange: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetBody, placeholder: '', value: form.body})
						])),
					$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewHelpTextV2(account),
					A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between1]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$disableablePrimary,
							$elm$core$Result$Ok('Cancel'),
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CancelEdit),
							A2(
							$author$project$Ui$disableablePrimary,
							$elm$core$Result$Ok('Save'),
							saveMsg)
						]))
				]));
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateV2 = F3(
	function (account, model, template) {
		var _v0 = model.editingState;
		switch (_v0.$) {
			case 'NotEditing':
				return A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$showTemplateV2, model, template);
			case 'Editing':
				var form = _v0.a;
				var templateBeingEdited = _v0.b;
				return _Utils_eq(templateBeingEdited, template) ? A3(
					$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateFormV2,
					account,
					form,
					$elm$core$Maybe$Just(templateBeingEdited)) : A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$showTemplateV2, model, template);
			default:
				return A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$showTemplateV2, model, template);
		}
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewIndexV2 = F3(
	function (account, model, data) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between4]),
					_List_fromArray(
						[
							$author$project$Ui$heading1('Exception messages'),
							A2($author$project$Ui$primary, 'Add', $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartCreatingTemplate)
						])),
					$author$project$Ui$text('Create templated messages for exceptions.'),
					$author$project$Ui$text('Changes to templates require logging out and back into your account to see.'),
					A2(
					$author$project$Ui$stack,
					_List_fromArray(
						[$author$project$Ui$between4]),
					A2(
						$elm$core$List$intersperse,
						$author$project$Ui$divider,
						A2(
							$elm$core$List$map,
							A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateV2, account, model),
							data.customExceptionEmailTemplates)))
				]));
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewNewV2 = F2(
	function (account, form) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between1]),
					_List_fromArray(
						[
							$author$project$Ui$heading1('Create a template')
						])),
					A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateFormV2, account, form, $elm$core$Maybe$Nothing)
				]));
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewV2 = F3(
	function (account, model, data) {
		return $author$project$Ui$toHtml(
			A2(
				$author$project$Ui$stack,
				_List_fromArray(
					[$author$project$Ui$between3]),
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$deleteModalV2View(model),
						function () {
						var _v0 = model.editingState;
						switch (_v0.$) {
							case 'NotEditing':
								return A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewIndexV2, account, model, data);
							case 'Editing':
								return A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewIndexV2, account, model, data);
							default:
								var form = _v0.a;
								return A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewNewV2, account, form);
						}
					}()
					])));
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$deleteModalViewV3Reskin = function (model) {
	var _v0 = model.deletingState;
	if (_v0.$ === 'NotDeleting') {
		return $elm$html$Html$text('');
	} else {
		var templateToDelete = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Modal$view,
							_List_Nil,
							{
								body: $elm$html$Html$text('Are you sure you want to delete this message?'),
								cancelButton: $elm$core$Maybe$Just(
									_Utils_Tuple2('Cancel', $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CancelDelete)),
								dismissMsg: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CancelDelete,
								footerButtons: _List_Nil,
								header: $author$project$Ui$V3$Modal$textHeader('Delete message'),
								primaryButton: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										'Confirm',
										$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$DeleteTemplate(templateToDelete))),
								size: $author$project$Ui$V3$Modal$medium
							})
						]))
				]));
	}
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$showTemplateV3Reskin = F3(
	function (_v0, canDelete_, template) {
		var canDelete = canDelete_ && (!template.isDefault);
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, template.name),
							A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'Subject: ' + template.subject),
							A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Ui$V3$Typography$smallBody(_List_Nil),
								$elm$core$String$lines(template.body)))
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Stack$viewHorzMaybes,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
							$author$project$Ui$V3$Stack$crossAxisCenter
						]),
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2(
								$author$project$Ui$V3$UtilityButton$view,
								{
									icon: $author$project$Ui$V3$Icon$editOutline16,
									label: 'Edit',
									onClick: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartEditing(template)
								},
								_List_fromArray(
									[$author$project$Ui$V3$UtilityButton$sizeSmall]))),
							canDelete ? $elm$core$Maybe$Just(
							A2(
								$author$project$Ui$V3$UtilityButton$view,
								{
									icon: $author$project$Ui$V3$Icon$removeOutline16,
									label: 'Delete',
									onClick: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartDeleting(template)
								},
								_List_fromArray(
									[$author$project$Ui$V3$UtilityButton$sizeSmall]))) : $elm$core$Maybe$Nothing,
							template.isDefault ? $elm$core$Maybe$Just(
							A2(
								$author$project$Ui$V3$Typography$xSmallBodySemiBold,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin-top', '4px'),
										A2($elm$html$Html$Attributes$style, 'font-weight', '500')
									]),
								'Default')) : $elm$core$Maybe$Just(
							A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick(
										$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetAsDefault(template))
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
										$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary)
									]),
								'Set as Default'))
						])))
			]);
	});
var $author$project$Ui$V3$Input$Height = function (a) {
	return {$: 'Height', a: a};
};
var $author$project$Ui$V3$Input$height = $author$project$Ui$V3$Input$Height;
var $author$project$Ui$V3$Input$textInput = $author$project$Ui$V3$Input$TypeAttribute('text');
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewHelpTextV3Reskin = function (account) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Common variables')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{invoice_number}')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{carrier_name}')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{load_id}')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{exception_summary}')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{account_name}')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{signature}')
									]))
							]),
							account.payablesAccount ? _List_fromArray(
							[
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{ship_date}'),
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{invoiced_amount}'),
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{expected_amount}'),
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{load_status}'),
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{variance_amount}'),
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{customer_charge}'),
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{weight}'),
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{freight_class}'),
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '{account_number}')
							]) : _List_Nil,
							_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Input: '),
												A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'Invoice number {invoice_number} has exceptions')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Result: '),
												A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'Invoice number 11223344 has exceptions')
											]))
									]))
							])
						]))),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Available variables')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, '\u000A                    You can use load and shipment references as variables as well.\u000A                    Use angle brackets <> for load references, and square brackets [] for shipment references.\u000A                    Make sure you match the case and spacing exactly as found in your TMS, otherwise it won\u0027t match.\u000A                    ')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Input: '),
										A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'Confirmation required since margin has decreased by <Margin>')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Result: '),
										A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'Confirmation required since margin has decreased by 12%')
									]))
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateFormV3Reskin = F3(
	function (account, form, maybeTemplate) {
		var saveMsg = function () {
			if (maybeTemplate.$ === 'Just') {
				var template = maybeTemplate.a;
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SaveButtonClick(template);
			} else {
				return $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CreateButtonClick;
			}
		}();
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorz,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
										]),
									_List_fromArray(
										[
											A4(
											$author$project$Ui$V3$Input$view,
											{onInput: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetName},
											_List_fromArray(
												[
													$author$project$Ui$V3$Input$label('Template name'),
													$author$project$Ui$V3$Input$disabled(form.isSaving)
												]),
											_List_Nil,
											form.name),
											A4(
											$author$project$Ui$V3$Input$view,
											{onInput: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetSubject},
											_List_fromArray(
												[
													$author$project$Ui$V3$Input$label('Subject line'),
													$author$project$Ui$V3$Input$disabled(form.isSaving)
												]),
											_List_Nil,
											form.subject),
											A4(
											$author$project$Ui$V3$Input$view,
											{onInput: $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$SetBody},
											_List_fromArray(
												[
													$author$project$Ui$V3$Input$label('Message'),
													$author$project$Ui$V3$Input$textInput,
													$author$project$Ui$V3$Input$expandable,
													$author$project$Ui$V3$Input$height('240px'),
													$author$project$Ui$V3$Input$disabled(form.isSaving)
												]),
											_List_Nil,
											form.body)
										])),
									$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewHelpTextV3Reskin(account)
								])),
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_fromArray(
								[$author$project$Ui$V3$Stack$mainAxisEnd]),
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									A2(
										$author$project$Ui$V3$Stack$viewHorz,
										_List_fromArray(
											[
												$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$V3$Button$view,
												{
													action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$CancelEdit)
												},
												_List_fromArray(
													[
														$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
													]),
												'Cancel'),
												A3(
												$author$project$Ui$V3$Button$view,
												{
													action: $author$project$Ui$V3$Button$onClick(saveMsg)
												},
												_List_Nil,
												'Save')
											])))
								]))
						])))
			]);
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateV3Reskin = F4(
	function (account, model, canDelete, template) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$mainAxisSpaceBetween,
					A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px'),
					A2($author$project$Ui$V3$Stack$style, 'border', '1px solid var(--border-default, #CFD9E4)'),
					A2($author$project$Ui$V3$Stack$style, 'background', '#FFF'),
					A2($author$project$Ui$V3$Stack$style, 'padding', '16px')
				]),
			function () {
				var _v0 = model.editingState;
				switch (_v0.$) {
					case 'NotEditing':
						return A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$showTemplateV3Reskin, model, canDelete, template);
					case 'Editing':
						var form = _v0.a;
						var templateBeingEdited = _v0.b;
						return _Utils_eq(templateBeingEdited, template) ? A3(
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateFormV3Reskin,
							account,
							form,
							$elm$core$Maybe$Just(templateBeingEdited)) : A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$showTemplateV3Reskin, model, canDelete, template);
					default:
						return A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$showTemplateV3Reskin, model, canDelete, template);
				}
			}());
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewIndexV3Reskin = F3(
	function (account, model, data) {
		var canDelete = $elm$core$List$length(data.customExceptionEmailTemplates) > 1;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[$author$project$Ui$V3$Stack$mainAxisSpaceBetween]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Exception messages')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Create templated messages for exceptions.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Changes to templates require logging out and back into your account to see.')
										]))
								]))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A3(
							$author$project$Ui$V3$Button$view,
							{
								action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$StartCreatingTemplate)
							},
							_List_Nil,
							'Add'))
					])),
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateV3Reskin, account, model, canDelete),
					data.customExceptionEmailTemplates))
			]);
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewNewV3Reskin = F2(
	function (account, form) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[$author$project$Ui$V3$Stack$mainAxisSpaceBetween]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Create a template')
										]))
								])))
					])),
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_Nil,
				A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewTemplateFormV3Reskin, account, form, $elm$core$Maybe$Nothing))
			]);
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewV3Reskin = F3(
	function (account, model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					_List_fromArray(
						[
							$author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$deleteModalViewV3Reskin(model),
							A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceLarge),
									A2($author$project$Ui$V3$Stack$style, 'margin-bottom', '24px')
								]),
							function () {
								var _v0 = model.editingState;
								switch (_v0.$) {
									case 'NotEditing':
										return A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewIndexV3Reskin, account, model, data);
									case 'Editing':
										return A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewIndexV3Reskin, account, model, data);
									default:
										var form = _v0.a;
										return A2($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewNewV3Reskin, account, form);
								}
							}())
						]))
				]));
	});
var $author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$view = F4(
	function (v3ReskinEnabled, account, model, data) {
		return v3ReskinEnabled ? A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewV3Reskin, account, model, data) : A3($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$viewV2, account, model, data);
	});
var $author$project$Components$SettingsPage$ExceptionSettingsView$view = F3(
	function (v3ReskinEnabled, data, model) {
		return data.currentUser.hasSettingsRole ? (data.accountSettings.multipleCustomExceptionTemplates ? A2(
			$elm$html$Html$map,
			$author$project$Components$SettingsPage$ExceptionSettingsView$MultipleCustomExceptionTemplatesMsg,
			A4($author$project$Components$SettingsPage$MultipleCustomExceptionTemplatesView$view, v3ReskinEnabled, data.currentAccount, model.multipleCustomExceptionTemplates, data.multipleCustomExceptionTemplatesData)) : (v3ReskinEnabled ? A2($author$project$Components$SettingsPage$ExceptionSettingsView$authorizedViewV3Reskin, data, model) : A2($author$project$Components$SettingsPage$ExceptionSettingsView$authorizedView, data, model))) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$SaveSettings = {$: 'SaveSettings'};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$formData_ = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$SettingsPage$FactorClientPortalSettingsView$initForm(data).a,
			model.form);
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleInvoiceNumber = {$: 'ToggleInvoiceNumber'};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleLoadNumber = {$: 'ToggleLoadNumber'};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewCheckboxToggle = F4(
	function (model, column, msg, columns) {
		var isCurrentHeader = A2($elm$core$List$member, column, columns);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('factor-client-portal-settings__column', isCurrentHeader),
								_Utils_Tuple2('factor-client-portal-settings__column-disabled', !isCurrentHeader)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(isCurrentHeader),
								$elm$html$Html$Events$onClick(msg),
								$elm$html$Html$Attributes$disabled(model.isSaving)
							]),
						_List_Nil)
					]))
			]);
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewCheckboxColumns = F2(
	function (model, form) {
		return A2(
			$elm$core$List$concatMap,
			function (column) {
				switch (column.$) {
					case 'PortalDisplaySettingsColumnInvoiceNumber':
						return A4(
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewCheckboxToggle,
							model,
							column,
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm($author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleInvoiceNumber),
							form.currentHeaders);
					case 'PortalDisplaySettingsColumnLoadNumber':
						return A4(
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewCheckboxToggle,
							model,
							column,
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm($author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleLoadNumber),
							form.currentHeaders);
					default:
						return _List_fromArray(
							[
								A2($elm$html$Html$td, _List_Nil, _List_Nil)
							]);
				}
			},
			$author$project$AuditPb$allPortalDisplaySettingsColumn);
	});
var $author$project$Domain$PortalDisplaySettings$columnToString = function (column) {
	switch (column.$) {
		case 'PortalDisplaySettingsColumnReceivedAt':
			return 'Received';
		case 'PortalDisplaySettingsColumnInvoiceNumber':
			return 'Invoice Number';
		case 'PortalDisplaySettingsColumnLoadNumber':
			return 'Load Number';
		case 'PortalDisplaySettingsColumnIsFuelAdvance':
			return 'Fuel Advance?';
		case 'PortalDisplaySettingsColumnAmount':
			return 'Amount';
		default:
			return 'Status';
	}
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewColumns = function (model) {
	return A2(
		$elm$core$List$map,
		function (column) {
			return A2($elm$core$List$member, column, model.currentHeaders) ? A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('factor-client-portal-settings__column')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Domain$PortalDisplaySettings$columnToString(column))
					])) : A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('factor-client-portal-settings__column-disabled')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Domain$PortalDisplaySettings$columnToString(column) + ' (disabled)')
					]));
		},
		$author$project$AuditPb$allPortalDisplaySettingsColumn);
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$CustomMessageChanged = function (a) {
	return {$: 'CustomMessageChanged', a: a};
};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewCustomMessageForm = function (form) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('factor-client-portal-settings__form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('large-12 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Custom HTML Message')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Enter custom HTML message here...'),
										$elm$html$Html$Attributes$rows(2),
										$elm$html$Html$Attributes$cols(40),
										$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$FactorClientPortalSettingsView$CustomMessageChanged),
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', form.customMessage)),
										A2($elm$html$Html$Attributes$style, 'width', '100%')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewFeatures = function (model) {
	var hasOverrideableFeatures = A2(
		$elm$core$List$any,
		function (_v1) {
			var feature = _v1.feature;
			return feature.canOverrideForClient;
		},
		model.features);
	return $elm$core$List$isEmpty(model.features) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Features')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-body')
					]),
				_List_fromArray(
					[
						hasOverrideableFeatures ? A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Features for individual clients can be overridden in Client\u0027s settings page.')
							])) : $elm$html$Html$text(''),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('factor-client-portal-settings__features enable_shared-ui-v3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('factor-client-portal-settings__table v3__theme')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											function (_v0) {
												var dropdown = _v0.dropdown;
												var feature = _v0.feature;
												return A2(
													$elm$html$Html$tr,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('factor-client-portal-settings__feature-row')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$td,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('large-1 columns')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$map,
																	$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FeatureDropdownMsg(feature.label),
																	A2($author$project$Ui$V3$CustomSelect$view, dropdown, _List_Nil))
																])),
															A2(
															$elm$html$Html$td,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('large-9 columns factor-client-portal-settings__rush-fee-label')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(feature.label)
																]))
														]));
											},
											model.features))
									]))
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$FundingDisclosureChanged = function (a) {
	return {$: 'FundingDisclosureChanged', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewFundingDisclosureForm = function (form) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('factor-client-portal-settings__form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('large-12 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('HTML message at bottom of funding form (supports links, bold, italics, underline)'),
										$elm$html$Html$Attributes$rows(4),
										$elm$html$Html$Attributes$cols(40),
										$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$FactorClientPortalSettingsView$FundingDisclosureChanged),
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', form.fundingDisclosure)),
										A2($elm$html$Html$Attributes$style, 'width', '100%')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$AddNewFundingMethod = {$: 'AddNewFundingMethod'};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$CancelEditing = function (a) {
	return {$: 'CancelEditing', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$FundingMethodChanged = F2(
	function (a, b) {
		return {$: 'FundingMethodChanged', a: a, b: b};
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$PayablesLabelValue = function (a) {
	return {$: 'PayablesLabelValue', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$PortalFieldNameValue = function (a) {
	return {$: 'PortalFieldNameValue', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$RemoveFundingMethod = function (a) {
	return {$: 'RemoveFundingMethod', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$SpanishTranslationValue = function (a) {
	return {$: 'SpanishTranslationValue', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleEditingState = function (a) {
	return {$: 'ToggleEditingState', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewFundingInput = F2(
	function (index, fundingMethodFormValue) {
		var isEditing = function () {
			if (fundingMethodFormValue.$ === 'Editing') {
				return true;
			} else {
				return false;
			}
		}();
		var inputs = isEditing ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-3 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Portal Field Name (In English)')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FundingMethodChanged(index),
											$author$project$Components$SettingsPage$FactorClientPortalSettingsView$PortalFieldNameValue)),
										$elm$html$Html$Attributes$value(
										$author$project$Components$SettingsPage$FactorClientPortalSettingsView$portalFieldNameLabel(fundingMethodFormValue))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-3 columns')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Optional Field Name (In Spanish)')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FundingMethodChanged(index),
											$author$project$Components$SettingsPage$FactorClientPortalSettingsView$SpanishTranslationValue)),
										$elm$html$Html$Attributes$value(
										$author$project$Components$SettingsPage$FactorClientPortalSettingsView$fundingMethodSpanishTranslation(fundingMethodFormValue))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-3 columns end')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Optional Payables Label')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FundingMethodChanged(index),
											$author$project$Components$SettingsPage$FactorClientPortalSettingsView$PayablesLabelValue)),
										$elm$html$Html$Attributes$value(
										$author$project$Components$SettingsPage$FactorClientPortalSettingsView$fundingMethodPayablesLabel(fundingMethodFormValue))
									]),
								_List_Nil)
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$SettingsPage$FactorClientPortalSettingsView$portalFieldNameLabel(fundingMethodFormValue))
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Events$onInput(
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$FundingMethodChanged(index),
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$PortalFieldNameValue)),
						$elm$html$Html$Attributes$value(
						$author$project$Components$SettingsPage$FactorClientPortalSettingsView$portalFieldNameLabel(fundingMethodFormValue)),
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_Nil)
			]);
		var action = function () {
			if (fundingMethodFormValue.$ === 'Editing') {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleEditingState(index))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-check factor-client-portal-settings__action')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$CancelEditing(index))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-x factor-client-portal-settings__action')
										]),
									_List_Nil)
								]))
						]));
			} else {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleEditingState(index))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-pencil factor-client-portal-settings__action')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$RemoveFundingMethod(index))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-trash factor-client-portal-settings__action')
										]),
									_List_Nil)
								]))
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-1 columns factor-client-portal-settings__checkbox2')
						]),
					_List_fromArray(
						[action])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-9 columns')
						]),
					inputs)
				]));
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$RushFeeLabelChanged = function (a) {
	return {$: 'RushFeeLabelChanged', a: a};
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleRushFee = {$: 'ToggleRushFee'};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewRushFeeSettings = function (form) {
	var defaultLabelValue = A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$Attributes$placeholder('Rush fee/QuickPay 2% fee'),
		A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, form.rushFeeLabelOverride));
	var checkbox = A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				$elm$html$Html$Attributes$checked(form.showRushFee),
				$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleRushFee)
			]),
		_List_Nil);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-1 columns factor-client-portal-settings__checkbox2')
						]),
					_List_fromArray(
						[checkbox])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-9 columns factor-client-portal-settings__rush-fee-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Pay rush fee')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('row', true),
							_Utils_Tuple2('factor-client-portal-settings__input-disabled', !form.showRushFee)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-1 columns factor-client-portal-settings__checkbox2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Helpers$String$nbsp)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-9 columns factor-client-portal-settings__rush-fee-label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Rush Fee Label')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$FactorClientPortalSettingsView$RushFeeLabelChanged),
									defaultLabelValue
								]),
							_List_Nil)
						]))
				]))
		]);
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewFundingForm = function (model) {
	var rushFeeSettings = $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewRushFeeSettings(model);
	var fundingMethodsHeader = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-1 columns')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-9 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h5,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Funding Methods')
								]))
						]))
				]))
		]);
	var fundingInputs = A2($elm$core$List$indexedMap, $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewFundingInput, model.fundingMethods);
	var addFundingButton = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-1 columns')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-9 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$FactorClientPortalSettingsView$AddNewFundingMethod)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('factor-client-portal-settings__action fi-plus')
										]),
									_List_Nil),
									$elm$html$Html$text('Add a new funding method')
								]))
						]))
				]))
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('factor-client-portal-settings__form')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[rushFeeSettings, fundingMethodsHeader, fundingInputs, addFundingButton])));
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleInvoiceInput = {$: 'ToggleInvoiceInput'};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleRequiredField = function (a) {
	return {$: 'ToggleRequiredField', a: a};
};
var $author$project$Domain$PortalDisplaySettings$fieldToString = function (field) {
	switch (field.$) {
		case 'PortalDisplaySettingsInputFieldDebtor':
			return 'Debtor';
		case 'PortalDisplaySettingsInputFieldInvoiceNumberField':
			return 'Invoice Number';
		case 'PortalDisplaySettingsInputFieldLoadId':
			return 'Load ID';
		case 'PortalDisplaySettingsInputFieldAmountField':
			return 'Amount';
		default:
			return 'Comments';
	}
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$maybeRequiredText = function (isRequired) {
	return isRequired ? ' (Required)' : '';
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewUploadFormRow = F2(
	function (model, inputField) {
		var isRequired = A2($elm$core$List$member, inputField, model.currentRequiredFields);
		var isDisabled = (!model.showInvoiceField) && _Utils_eq(inputField, $author$project$AuditPb$PortalDisplaySettingsInputFieldInvoiceNumberField);
		var requiredCheckbox = A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('checkbox'),
					$elm$html$Html$Attributes$checked(isRequired),
					$elm$html$Html$Events$onClick(
					$author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleRequiredField(inputField)),
					$elm$html$Html$Attributes$disabled(isDisabled)
				]),
			_List_Nil);
		var inputName = $author$project$Domain$PortalDisplaySettings$fieldToString(inputField);
		var displayCheckbox = _Utils_eq(inputField, $author$project$AuditPb$PortalDisplaySettingsInputFieldInvoiceNumberField) ? A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('checkbox'),
					$elm$html$Html$Attributes$checked(model.showInvoiceField),
					$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$FactorClientPortalSettingsView$ToggleInvoiceInput)
				]),
			_List_Nil) : A2($elm$html$Html$p, _List_Nil, _List_Nil);
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-2 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('factor-client-portal-settings__checkbox')
								]),
							_List_fromArray(
								[requiredCheckbox]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-2 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('factor-client-portal-settings__checkbox')
								]),
							_List_fromArray(
								[displayCheckbox]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('large-6 columns', true),
									_Utils_Tuple2('factor-client-portal-settings__input-disabled', isDisabled)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('document-upload-page__label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											_Utils_ap(
												inputName,
												$author$project$Components$SettingsPage$FactorClientPortalSettingsView$maybeRequiredText(isRequired)))
										])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$placeholder(inputName),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$class('factor-client-portal-settings__input')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewUploadForm = function (model) {
	var uploadFormRows = A2(
		$elm$core$List$map,
		$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewUploadFormRow(model),
		$author$project$AuditPb$allPortalDisplaySettingsInputField);
	var headers = _List_fromArray(
		[
			A2(
			$elm$html$Html$th,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('large-2 columns'),
					A2($elm$html$Html$Attributes$style, 'text-align', 'center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Require Field')
				])),
			A2(
			$elm$html$Html$th,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('large-2 columns'),
					A2($elm$html$Html$Attributes$style, 'text-align', 'center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Display Field')
				])),
			A2(
			$elm$html$Html$th,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('large-6 columns'),
					A2($elm$html$Html$Attributes$style, 'text-align', 'center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Input Field')
				]))
		]);
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('factor-client-portal-settings__upload-form-table')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2($elm$html$Html$tr, _List_Nil, headers)
					])),
				A2($elm$html$Html$tbody, _List_Nil, uploadFormRows)
			]));
};
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$authorizedView = F2(
	function (model, data) {
		var form = A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$formData_, data, model);
		var uploadFormSettings = (_Utils_eq(data.currentAccount.tms, $author$project$AuditPb$TMSOptionBusinessManager) || (data.currentAccount.name === 'eCapital')) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('shared__section-body')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('What information do you want from your clients in their portal uploads?')
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm,
					$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewUploadForm(form))
				]));
		return data.portalDisplaySettings.factorClientPortalEnabled ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Portal Display Settings')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select what you want your clients to see in their portals')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You must click the \u0027Save\u0027 button to keep changes')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 columns')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = data.portalDisplaySettings.publicDebtorCreditCheckPathSegment;
							if (_v0.$ === 'Just') {
								var segment = _v0.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('shared__section-header')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Public Debtor Credit Check')
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('shared__section-body')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Here is the link to the public facing credit check to send to clients')
														])),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href('https://audit.triumphpay.com/factor_client_portal/' + (segment + '/debtor_credit_check/'))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Public Debtor Credit Check')
														]))
												]))
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-header ')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Main Page')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h5,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Columns')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('What information would you like displayed on the main table?')
										])),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('factor-client-portal-settings__table')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_Nil,
													A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewCheckboxColumns, model, form))
												])),
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_Nil,
													$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewColumns(form))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Custom Messaging')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Add custom HTML to display to clients in their portal dashboard as a banner notification. Supports links, bold, italics, and underline.')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm,
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewCustomMessageForm(form))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Document Upload Form')
										]))
								])),
							uploadFormSettings,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Funding Form')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('What kind of funding info would you like them to see?')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm,
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewFundingForm(form))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-header shared__section-header--subsection')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h5,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Funding Disclosure')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shared__section-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm,
									$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewFundingDisclosureForm(form))
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$EditForm,
							$author$project$Components$SettingsPage$FactorClientPortalSettingsView$viewFeatures(form)),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button--confirmation'),
									$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$FactorClientPortalSettingsView$SaveSettings)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save Changes')
								]))
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('small-10 columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Portal Display Settings')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You don\u0027t currently have the client portal enabled.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If you would like to enable the portal for your clients please contact support.')
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$loadedView = F2(
	function (model, data) {
		return data.currentUser.hasSettingsRole ? A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$authorizedView, model, data) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$SettingsPage$FactorClientPortalSettingsView$view = F2(
	function (data, model) {
		return A2(
			$author$project$Forward$LoadingView$view,
			$author$project$Components$SettingsPage$FactorClientPortalSettingsView$loadedView(model),
			data);
	});
var $author$project$Ui$between5 = function (config) {
	return _Utils_update(
		config,
		{between: 5});
};
var $author$project$Components$SettingsPage$IntegrationsSettingsView$fileStatusHeaders = $author$project$Ui$headers(
	_List_fromArray(
		[
			$author$project$Ui$text('File'),
			$author$project$Ui$text('Status'),
			$author$project$Ui$text('Updated At')
		]));
var $author$project$Helpers$Date$compactDateTimeString = F2(
	function (tz, date) {
		var time = A2(
			$elm$core$String$startsWith,
			'0',
			A2($author$project$Helpers$Date$timeString, tz, date)) ? A2(
			$elm$core$String$dropLeft,
			1,
			A2($author$project$Helpers$Date$timeString, tz, date)) : A2($author$project$Helpers$Date$timeString, tz, date);
		var month = $author$project$Helpers$Date$shortMonthString(
			A2($elm$time$Time$toMonth, tz, date));
		var day = $elm$core$String$fromInt(
			A2($elm$time$Time$toDay, tz, date));
		return month + (' ' + (day + (' ' + time)));
	});
var $author$project$Helpers$Date$maybeCompactDateTimeString = F2(
	function (tz, maybeDate) {
		if (maybeDate.$ === 'Just') {
			var date = maybeDate.a;
			return A2($author$project$Helpers$Date$compactDateTimeString, tz, date);
		} else {
			return 'Unknown Date';
		}
	});
var $author$project$Domain$Integration$statusToString = function (maybeStatus) {
	if (maybeStatus.$ === 'Just') {
		var status = maybeStatus.a;
		switch (status.$) {
			case 'FileStatusImporting':
				return 'Importing';
			case 'FileStatusImported':
				return 'Imported';
			case 'FileStatusImportFailed':
				return 'Import Failed';
			default:
				return 'Skipped';
		}
	} else {
		return 'Unknown Status';
	}
};
var $author$project$Components$SettingsPage$IntegrationsSettingsView$fileStatusRow = F3(
	function (tz, filename, fileDetails) {
		return $author$project$Ui$row(
			_List_fromArray(
				[
					$author$project$Ui$text(filename),
					$author$project$Ui$text(
					$author$project$Domain$Integration$statusToString(fileDetails.status)),
					$author$project$Ui$text(
					A2($author$project$Helpers$Date$maybeCompactDateTimeString, tz, fileDetails.time))
				]));
	});
var $author$project$Components$SettingsPage$IntegrationsSettingsView$fileStatusRows = F2(
	function (tz, statusData) {
		var filenames = _List_fromArray(
			['Invoices', 'Debtors', 'Clients', 'Agings']);
		var fileDetails = _List_fromArray(
			[statusData.fileStatusData.invoices, statusData.fileStatusData.debtors, statusData.fileStatusData.carriers, statusData.fileStatusData.agings]);
		return A3(
			$elm$core$List$map2,
			$author$project$Components$SettingsPage$IntegrationsSettingsView$fileStatusRow(tz),
			filenames,
			fileDetails);
	});
var $author$project$Ui$heading4 = function (headingText) {
	return A2(
		$author$project$Ui$heading,
		'4',
		_List_fromArray(
			[
				$elm$html$Html$text(headingText)
			]));
};
var $author$project$Components$SettingsPage$IntegrationsSettingsView$transmissionStatusHeaders = $author$project$Ui$headers(
	_List_fromArray(
		[
			$author$project$Ui$text('Transmission Details'),
			$author$project$Ui$text('Sent At')
		]));
var $author$project$Domain$Integration$compactTransmissionDetails = function (transmissionDetails) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (item, tuple) {
				if (tuple.a) {
					return _Utils_Tuple2(true, tuple.b + (' ' + item));
				} else {
					var numOfInvoices = $elm$core$String$toInt(item);
					if (numOfInvoices.$ === 'Just') {
						return _Utils_Tuple2(true, item);
					} else {
						return _Utils_Tuple2(false, '');
					}
				}
			}),
		_Utils_Tuple2(false, ''),
		$elm$core$String$words(transmissionDetails)).b;
};
var $author$project$Components$SettingsPage$IntegrationsSettingsView$transmissionStatusRow = F2(
	function (tz, transmissionData) {
		return $author$project$Ui$row(
			_List_fromArray(
				[
					$author$project$Ui$text(
					$author$project$Domain$Integration$compactTransmissionDetails(transmissionData.transmissionDetails)),
					$author$project$Ui$text(
					A2($author$project$Helpers$Date$compactDateTimeString, tz, transmissionData.time))
				]));
	});
var $author$project$Components$SettingsPage$IntegrationsSettingsView$cadenceDetailsView = F3(
	function (tz, id, details) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between5]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$stack,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$heading4('FactorSoft File Import Status'),
							$author$project$Ui$divider
						])),
					A2(
					$author$project$Ui$stack,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$inline,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$table,
									$author$project$Components$SettingsPage$IntegrationsSettingsView$fileStatusHeaders,
									A2($author$project$Components$SettingsPage$IntegrationsSettingsView$fileStatusRows, tz, details))
								]))
						])),
					A2(
					$author$project$Ui$stack,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$heading4('FactorSoft Transmission Status'),
							$author$project$Ui$divider
						])),
					A2(
					$author$project$Ui$stack,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$inline,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$table,
									$author$project$Components$SettingsPage$IntegrationsSettingsView$transmissionStatusHeaders,
									A2(
										$elm$core$List$map,
										$author$project$Components$SettingsPage$IntegrationsSettingsView$transmissionStatusRow(tz),
										details.transmissionData))
								]))
						])),
					A2(
					$author$project$Ui$stack,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$heading4('FactorSoft Client Installation'),
							$author$project$Ui$divider
						])),
					A2(
					$author$project$Ui$stack,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$paragraph('\u000A            TriumphPay Audit uses a Windows client application to enable data transfer between your FactorSoft installation and\u000A            our servers.  To setup the Windows client application download the following files and follow the installation\u000A            instructions.\u000A            '),
							$author$project$Ui$unorderedList(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2($author$project$Ui$externalLink, 'Download Complete Installation Instructions', 'https://hubtran-deploy.s3.us-west-2.amazonaws.com/TriumphPay+Audit+-+FactorSoft+Installation+Instructions+-+2025.pdf')
									]),
									_List_fromArray(
									[
										A2($author$project$Ui$externalLink, 'Download TriumphPay Audit Windows Client', 'https://hubtran-deploy.s3.us-west-2.amazonaws.com/c0db6705-f2ce-4d43-8e01-9522dd204acb/TriumphPayAuditInstaller-0.8.11.exe')
									]),
									_List_fromArray(
									[
										A2(
										$author$project$Ui$externalLink,
										'Download Your Configuration File',
										'/api/downloads/integrations/' + ($elm$core$String$fromInt(id) + '/configuration?fms=cadence'))
									])
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$IntegrationsSettingsView$factorSqlDetailsView = function (id) {
	return A2(
		$author$project$Ui$stack,
		_List_fromArray(
			[$author$project$Ui$between5]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$stack,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$paragraph('\u000A            TriumphPay Audit uses a Windows client application to enable data transfer between your FactorSQL installation and\u000A            our servers.  To setup the Windows client application download the following files.\u000A            '),
						$author$project$Ui$unorderedList(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2($author$project$Ui$externalLink, 'Download TriumphPay Audit Windows Client', 'https://hubtran-deploy.s3.us-west-2.amazonaws.com/c0db6705-f2ce-4d43-8e01-9522dd204acb/TriumphPayAuditInstallerFactorSQL-0.5.10.exe')
								]),
								_List_fromArray(
								[
									A2(
									$author$project$Ui$externalLink,
									'Download Your Configuration File',
									'/api/downloads/integrations/' + ($elm$core$String$fromInt(id) + '/configuration?fms=factorsql'))
								])
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$IntegrationsSettingsView$mercuryGateDetailsView = function (details) {
	return A2(
		$author$project$Ui$stack,
		_List_fromArray(
			[$author$project$Ui$between2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$stack,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$heading4('Mercury Gate Easy Click'),
						$author$project$Ui$divider
					])),
				A2(
				$author$project$Ui$stack,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$bold('Remit to address types'),
						$author$project$Ui$text(
						A2($elm$core$String$join, ', ', details.remitToAddressTypes))
					]))
			]));
};
var $author$project$Components$SettingsPage$IntegrationsSettingsView$integrationDetailsView = F2(
	function (tz, integration) {
		var integrationDetails = integration.integrationDetails;
		var id = $author$project$Domain$IntegrationId$toInt(integration.id);
		switch (integrationDetails.$) {
			case 'Integration_IntegrationDetails_MercuryGateDetails':
				var details = integrationDetails.a;
				return $author$project$Components$SettingsPage$IntegrationsSettingsView$mercuryGateDetailsView(details);
			case 'Integration_IntegrationDetails_CadenceDetails':
				var details = integrationDetails.a;
				return A3($author$project$Components$SettingsPage$IntegrationsSettingsView$cadenceDetailsView, tz, id, details);
			case 'Integration_IntegrationDetails_FactorSqlDetails':
				return $author$project$Components$SettingsPage$IntegrationsSettingsView$factorSqlDetailsView(id);
			default:
				return $author$project$Ui$empty;
		}
	});
var $author$project$Components$SettingsPage$IntegrationsSettingsView$integrationsView = F2(
	function (tz, integrations) {
		return $elm$core$List$isEmpty(integrations) ? $author$project$Ui$paragraph('You do not have any integrations yet.') : A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between4]),
			A2(
				$elm$core$List$map,
				$author$project$Components$SettingsPage$IntegrationsSettingsView$integrationDetailsView(tz),
				integrations));
	});
var $author$project$Components$SettingsPage$IntegrationsSettingsView$authorizedView = F2(
	function (tz, data) {
		return $author$project$Ui$toHtml(
			A2(
				$author$project$Ui$stack,
				_List_fromArray(
					[$author$project$Ui$between4]),
				_List_fromArray(
					[
						$author$project$Ui$heading2('Integrations'),
						$author$project$Ui$paragraph('Please contact support if you need to change any of these settings.'),
						A2($author$project$Components$SettingsPage$IntegrationsSettingsView$integrationsView, tz, data.integrations)
					])));
	});
var $author$project$Components$SettingsPage$IntegrationsSettingsView$view = F2(
	function (tz, data) {
		return data.currentUser.hasSettingsRole ? A2($author$project$Components$SettingsPage$IntegrationsSettingsView$authorizedView, tz, data) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$authorizedViewV2 = F2(
	function (data, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('NextGen Audit Settings')
						])),
					A2(
					$author$project$Components$SettingsPage$Shared$EditSection$view,
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOverConfigV2,
					A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOver, data, model)),
					A2(
					$author$project$Components$SettingsPage$Shared$EditSection$view,
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageConfigV2,
					A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentage, data, model)),
					A2(
					$author$project$Components$SettingsPage$Shared$EditSection$view,
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsConfigV2,
					A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsState, data, model))
				]));
	});
var $elm_community$result_extra$Result$Extra$isOk = function (x) {
	if (x.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Ui$V3$Input$Width = function (a) {
	return {$: 'Width', a: a};
};
var $author$project$Ui$V3$Input$width = $author$project$Ui$V3$Input$Width;
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageFormViewV3 = F2(
	function (set, result) {
		var isValid = $elm_community$result_extra$Result$Extra$isOk(result);
		var displayValue = A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$String$fromInt, result);
		var html = A4(
			$author$project$Ui$V3$Input$view,
			{
				onInput: A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$NextGenAuditSettingsView$parseNumeric)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Input$label('Require verification for invoice amounts over this value. Please leave blank to be disabled.'),
					$author$project$Ui$V3$Input$numberInput,
					$author$project$Ui$V3$Input$width('160px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$min('0'),
					$elm$html$Html$Attributes$max('100')
				]),
			displayValue);
		return _Utils_Tuple2(html, isValid);
	});
var $author$project$Components$SettingsPage$Shared$EditSection$withV3FormView = F2(
	function (formView, sharedConfig) {
		return {apiRequest: sharedConfig.apiRequest, formView: formView, summaryView: sharedConfig.summaryView, title: sharedConfig.title, toMsg: sharedConfig.toMsg};
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageConfigV3 = A2($author$project$Components$SettingsPage$Shared$EditSection$withV3FormView, $author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageFormViewV3, $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedManualReviewConfig);
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsFormV3 = F2(
	function (set, enabledTypes) {
		var enabledSet = $elm$core$Set$fromList(enabledTypes);
		var checkboxRow = function (_v1) {
			var key = _v1.a;
			var label = _v1.b;
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px'),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(
								A2($elm$core$Set$member, key, enabledSet)),
								$elm$html$Html$Events$onCheck(
								function (_v0) {
									return set(
										A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$toggleType, key, enabledTypes));
								}),
								A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
							]),
						_List_Nil),
						$elm$html$Html$text(label)
					]));
		};
		var allChecked = _Utils_eq(
			$elm$core$List$length(enabledTypes),
			$elm$core$List$length($author$project$Components$SettingsPage$NextGenAuditSettingsView$allTypeKeys));
		var selectAllRow = A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(allChecked),
							$elm$html$Html$Events$onCheck(
							function (v) {
								return set(
									v ? $author$project$Components$SettingsPage$NextGenAuditSettingsView$allTypeKeys : _List_Nil);
							}),
							A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
						]),
					_List_Nil),
					$elm$html$Html$text('Select All')
				]));
		var html = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Stop autoprocessing if a verification fails for:')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '16px')
						]),
					_Utils_ap(
						A2($elm$core$List$map, checkboxRow, $author$project$Components$SettingsPage$NextGenAuditSettingsView$allVerificationExceptionOptions),
						_List_fromArray(
							[
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								selectAllRow
							])))
				]));
		return _Utils_Tuple2(html, true);
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsConfigV3 = A2($author$project$Components$SettingsPage$Shared$EditSection$withV3FormView, $author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsFormV3, $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedVerificationExceptionsConfig);
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$AddRule = {$: 'AddRule'};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$CancelEditing = {$: 'CancelEditing'};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditDefaultReviewPercentage = function (a) {
	return {$: 'EditDefaultReviewPercentage', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditRuleReviewPercentage = F2(
	function (a, b) {
		return {$: 'EditRuleReviewPercentage', a: a, b: b};
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$RemoveRule = function (a) {
	return {$: 'RemoveRule', a: a};
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SaveEdits = {$: 'SaveEdits'};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$cardTitle = 'Manual Review Percentage';
var $author$project$Ui$V3$CustomSelect$DisabledItemIds = function (a) {
	return {$: 'DisabledItemIds', a: a};
};
var $author$project$Ui$V3$CustomSelect$disabledItemIds = function (ids) {
	return $author$project$Ui$V3$CustomSelect$DisabledItemIds(ids);
};
var $author$project$Ui$V3$CustomSelect$ErrorAttribute = function (a) {
	return {$: 'ErrorAttribute', a: a};
};
var $author$project$Ui$V3$CustomSelect$error = $author$project$Ui$V3$CustomSelect$ErrorAttribute;
var $elm$core$Set$filter = F2(
	function (isGood, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (key, _v1) {
						return isGood(key);
					}),
				dict));
	});
var $author$project$Ui$V3$Card$FooterButtonsAttribute = function (a) {
	return {$: 'FooterButtonsAttribute', a: a};
};
var $author$project$Ui$V3$Grid$Width = function (a) {
	return {$: 'Width', a: a};
};
var $author$project$Ui$V3$Grid$fit = $author$project$Ui$V3$Grid$Width('fit');
var $author$project$Ui$V3$Grid$GapAttribute = function (a) {
	return {$: 'GapAttribute', a: a};
};
var $author$project$Ui$V3$Grid$gap = $author$project$Ui$V3$Grid$GapAttribute;
var $author$project$Ui$V3$Grid$SpatialUnit = function (a) {
	return {$: 'SpatialUnit', a: a};
};
var $author$project$Ui$V3$Grid$spaceXSmall = $author$project$Ui$V3$Grid$SpatialUnit('xs');
var $author$project$Ui$V3$Grid$defaultAttributes = {classes: _List_Nil, gap: $elm$core$Maybe$Nothing, padding: $elm$core$Maybe$Nothing};
var $author$project$Ui$V3$Grid$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			switch (a.$) {
				case 'GapAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							gap: $elm$core$Maybe$Just(value)
						});
				case 'PaddingAttribute':
					var value = a.a;
					return _Utils_update(
						acc,
						{
							padding: $elm$core$Maybe$Just(value)
						});
				default:
					var value = a.a;
					return _Utils_update(
						acc,
						{
							classes: A2($elm$core$List$cons, value, acc.classes)
						});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Grid$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Grid$maybeSpace = F2(
	function (prefix, maybeUnit) {
		if (maybeUnit.$ === 'Nothing') {
			return $elm$html$Html$Attributes$class('');
		} else {
			var name = maybeUnit.a.a;
			return $elm$html$Html$Attributes$class(
				_Utils_ap(prefix, name));
		}
	});
var $author$project$Ui$V3$Grid$viewColumn = function (_v0) {
	var width = _v0.a.a;
	var child = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('v3__grid-column'),
				$elm$html$Html$Attributes$class('v3__grid-column--width-' + width)
			]),
		_List_fromArray(
			[child]));
};
var $author$project$Ui$V3$Grid$viewWithWidths = F2(
	function (attributes, childrenWithWidths) {
		var computed = $author$project$Ui$V3$Grid$computeAttributes(attributes);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__grid'),
					$elm$html$Html$Attributes$class(
					A2($elm$core$String$join, ' ', computed.classes)),
					A2($author$project$Ui$V3$Grid$maybeSpace, 'v3__grid--gap-', computed.gap),
					A2($author$project$Ui$V3$Grid$maybeSpace, 'v3__grid--padding-', computed.padding)
				]),
			A2($elm$core$List$map, $author$project$Ui$V3$Grid$viewColumn, childrenWithWidths));
	});
var $author$project$Ui$V3$Card$footerButtons = function (buttonList) {
	return $author$project$Ui$V3$Card$FooterButtonsAttribute(
		A2(
			$author$project$Ui$V3$Grid$viewWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Grid$gap($author$project$Ui$V3$Grid$spaceXSmall)
				]),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$pair($author$project$Ui$V3$Grid$fit),
				buttonList)));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$editingView = function (editing) {
	var allSelectedRatingIds = editing.allSelectedRatingIds;
	var creditRatingRules = editing.creditRatingRules;
	var accountDefault = editing.accountDefault;
	var saveDisabled = $elm_community$maybe_extra$Maybe$Extra$isNothing(
		$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validate(editing));
	var ruleHeader = A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_Nil,
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				A2(
					$elm$html$Html$h5,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Credit Rating')
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				A2(
					$elm$html$Html$h5,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Value')
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fitPx(32),
				$elm$html$Html$text(''))
			]));
	var rowStack = function (content) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceSmall),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			content);
	};
	var removeButton = function (editId) {
		return A2(
			$author$project$Ui$V3$UtilityButton$view,
			{
				icon: $author$project$Ui$V3$Icon$closeSmall16,
				label: 'Remove',
				onClick: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg(
					$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$RemoveRule(editId))
			},
			_List_fromArray(
				[$author$project$Ui$V3$UtilityButton$sizeSmall]));
	};
	var percentInput = F2(
		function (onInput, value) {
			var error = $elm_community$maybe_extra$Maybe$Extra$isNothing(
				$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validatePercentage(value));
			return A4(
				$author$project$Ui$V3$Input$view,
				{
					onInput: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg, onInput)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$numberInput,
						$author$project$Ui$V3$Input$min('0'),
						$author$project$Ui$V3$Input$max('100'),
						$author$project$Ui$V3$Input$error(error)
					]),
				_List_Nil,
				value);
		});
	var viewRule = function (_v0) {
		var editId = _v0.editId;
		var percentage = _v0.percentage;
		var select = _v0.select;
		var selectedByThisRule = function (ratingId) {
			return A2(
				$elm$core$List$member,
				ratingId,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.id;
					},
					$author$project$Ui$V3$CustomSelect$selectedItems(select)));
		};
		var error = $elm_community$maybe_extra$Maybe$Extra$isNothing(
			$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$validateRuleSelect(select));
		var disabledItemIds = $elm$core$Set$toList(
			A2(
				$elm$core$Set$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, selectedByThisRule),
				allSelectedRatingIds));
		return rowStack(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg,
							$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$CustomSelectMsg(editId)),
						A2(
							$author$project$Ui$V3$CustomSelect$view,
							select,
							_List_fromArray(
								[
									$author$project$Ui$V3$CustomSelect$error(error),
									$author$project$Ui$V3$CustomSelect$disabledItemIds(disabledItemIds)
								])))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						percentInput,
						$author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditRuleReviewPercentage(editId),
						percentage)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					removeButton(editId))
				]));
	};
	var footerButtons = _List_fromArray(
		[
			$author$project$Helpers$Html$editButtons(
			{
				cancelMsg: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$CancelEditing),
				primaryDisabled: saveDisabled,
				primaryLabel: 'Save',
				primaryMsg: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SaveEdits)
			})
		]);
	var customSelectRows = A2($elm$core$List$map, viewRule, creditRatingRules);
	var cancelButton = A2(
		$author$project$Ui$V3$UtilityButton$view,
		{
			icon: $author$project$Ui$V3$Icon$close16,
			label: 'Cancel',
			onClick: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$CancelEditing)
		},
		_List_fromArray(
			[$author$project$Ui$V3$UtilityButton$sizeSmall]));
	var addButton = A2(
		$author$project$Ui$V3$UtilityButton$view,
		{
			icon: $author$project$Ui$V3$Icon$add16,
			label: 'Add',
			onClick: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditMsg($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$AddRule)
		},
		_List_fromArray(
			[$author$project$Ui$V3$UtilityButton$sizeSmall]));
	var viewAccountDefaultRow = rowStack(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Account Default')
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				A2(percentInput, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$EditDefaultReviewPercentage, accountDefault)),
				_Utils_Tuple2($author$project$Ui$V3$Stack$fit, addButton)
			]));
	return A3(
		$author$project$Ui$V3$Card$view,
		{title: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$cardTitle},
		_List_fromArray(
			[
				$author$project$Ui$V3$Card$headerNote(cancelButton),
				$author$project$Ui$V3$Card$visibleOverflow,
				$author$project$Ui$V3$Card$footerButtons(footerButtons)
			]),
		A2(
			$elm$core$List$cons,
			ruleHeader,
			_Utils_ap(
				customSelectRows,
				_List_fromArray(
					[viewAccountDefaultRow]))));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$StartEditing = {$: 'StartEditing'};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SummaryMsg = function (a) {
	return {$: 'SummaryMsg', a: a};
};
var $author$project$Ui$V3$UtilityButton$IsDisabled = function (a) {
	return {$: 'IsDisabled', a: a};
};
var $author$project$Ui$V3$UtilityButton$isDisabled = $author$project$Ui$V3$UtilityButton$IsDisabled;
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$savingView = function (_v0) {
	var disabledEditButton = A2(
		$author$project$Ui$V3$UtilityButton$view,
		{
			icon: $author$project$Ui$V3$Icon$editOutline16,
			label: 'Edit',
			onClick: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SummaryMsg($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$StartEditing)
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$UtilityButton$sizeSmall,
				$author$project$Ui$V3$UtilityButton$isDisabled(true)
			]));
	return A3(
		$author$project$Ui$V3$Card$view,
		{title: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$cardTitle},
		_List_fromArray(
			[
				$author$project$Ui$V3$Card$headerNote(disabledEditButton)
			]),
		_List_fromArray(
			[
				$author$project$Ui$V3$Skeleton$view(
				{
					height: $elm$core$Maybe$Just(200)
				})
			]));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$editButton = A2(
	$author$project$Ui$V3$UtilityButton$view,
	{
		icon: $author$project$Ui$V3$Icon$editOutline16,
		label: 'Edit',
		onClick: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$SummaryMsg($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$StartEditing)
	},
	_List_fromArray(
		[$author$project$Ui$V3$UtilityButton$sizeSmall]));
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$summaryView = function (original) {
	var viewSelectedItems = function (ratingNames) {
		var joined = A2($elm$core$String$join, ', ', ratingNames);
		return ($elm$core$String$length(joined) > 20) ? A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_Nil,
			A2($elm$core$List$map, $elm$html$Html$text, ratingNames)) : $elm$html$Html$text(joined);
	};
	var ruleHeader = A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				A2(
					$elm$html$Html$h5,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Credit Rating')
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				A2(
					$elm$html$Html$h5,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Value')
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fitPx(32),
				$elm$html$Html$text(''))
			]));
	var rowStack = function (content) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceSmall),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			content);
	};
	var cardDivider = function (padding) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[padding]),
			_List_fromArray(
				[$author$project$Ui$V3$Card$divider]));
	};
	var asTextPercent = function (_int) {
		return $elm$html$Html$text(
			$elm$core$String$fromInt(_int) + '%');
	};
	var viewAccountDefault = rowStack(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Account Default')
						]))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$flex1,
				asTextPercent(original.accountDefault)),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fitPx(32),
				$elm$html$Html$text(''))
			]));
	var viewRule = function (_v0) {
		var reviewPercentage = _v0.reviewPercentage;
		var creditRatings = _v0.creditRatings;
		return rowStack(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					viewSelectedItems(creditRatings)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					asTextPercent(reviewPercentage)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fitPx(32),
					$elm$html$Html$text(''))
				]));
	};
	var customSelectRows = A2($elm$core$List$map, viewRule, original.rulesResponse.reviewPercentageRules);
	var ruleRows = A2(
		$elm$core$List$intersperse,
		cardDivider(
			$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceXSmall)),
		_Utils_ap(
			customSelectRows,
			_List_fromArray(
				[viewAccountDefault])));
	return A3(
		$author$project$Ui$V3$Card$view,
		{title: $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$cardTitle},
		_List_fromArray(
			[
				$author$project$Ui$V3$Card$headerNote($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$editButton)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_Nil,
				A2($elm$core$List$cons, ruleHeader, ruleRows))
			]));
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$view = F2(
	function (data, table) {
		switch (table.$) {
			case 'Editing':
				var editModel = table.a;
				return $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$editingView(editModel);
			case 'Summary':
				return $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$summaryView(data);
			default:
				return $author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$savingView(data);
		}
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$viewReviewPercentageTable = F3(
	function (data, rulesResponse, reviewPercentageTable) {
		var tableData = {accountDefault: data.accountSettings.manualReviewPercentage, rulesResponse: rulesResponse};
		return A2(
			$elm$html$Html$map,
			$author$project$Components$SettingsPage$NextGenAuditSettingsView$UpdateReviewPercentageRules,
			A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$ReviewPercentage$view, tableData, reviewPercentageTable));
	});
var $author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin = function (_v0) {
	var formView = _v0.formView;
	var summaryView = _v0.summaryView;
	var toMsg = _v0.toMsg;
	var title = _v0.title;
	return $author$project$Components$SettingsPage$Shared$EditSection$viewV3ReskinHelper(
		{
			formView: F2(
				function (set, result) {
					return function (_v1) {
						var preHtml = _v1.a;
						var isValid = _v1.b;
						return _Utils_Tuple3(preHtml, $elm$core$Maybe$Nothing, isValid);
					}(
						A2(formView, set, result));
				}),
			summaryView: summaryView,
			title: title,
			toMsg: toMsg
		});
};
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnOverFormViewV3 = F2(
	function (set, result) {
		var isValid = $elm_community$result_extra$Result$Extra$isOk(result);
		var displayValue = A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result);
		var html = A4(
			$author$project$Ui$V3$Input$view,
			{
				onInput: A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$NextGenAuditSettingsView$ensureNumeric)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Input$label('Require verification for invoice amounts over this value. Please leave blank to be disabled.'),
					$author$project$Ui$V3$Input$numberInput,
					$author$project$Ui$V3$Input$width('160px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$min('0')
				]),
			displayValue);
		return _Utils_Tuple2(html, isValid);
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOverConfigV3 = A2($author$project$Components$SettingsPage$Shared$EditSection$withV3FormView, $author$project$Components$SettingsPage$NextGenAuditSettingsView$warnOverFormViewV3, $author$project$Components$SettingsPage$NextGenAuditSettingsView$sharedWarnIfAmountOverConfig);
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$authorizedViewV3 = F2(
	function (data, model) {
		var viewWarnIfAmountOver = A2(
			$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
			$author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOverConfigV3,
			A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$warnIfAmountOver, data, model));
		var viewVerificationExceptions = A2(
			$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
			$author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsConfigV3,
			A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$verificationExceptionsState, data, model));
		var viewManualReviewPercentage = A2(
			$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
			$author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentageConfigV3,
			A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$manualReviewPercentage, data, model));
		var threeQuartersWidthContainer = function (contents) {
			return A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex3, contents),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$elm$html$Html$text(''))
					]));
		};
		var halfWidthContainer = function (contents) {
			return A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, contents),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$elm$html$Html$text(''))
					]));
		};
		var _v0 = function () {
			var _v1 = data.accountSettings.ngaRules;
			if (_v1.$ === 'Just') {
				var rulesResponse = _v1.a;
				return {
					nonRulesReviewPercentageView: $elm$core$Maybe$Nothing,
					rulesHeading: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Rules')
								]))),
					rulesTable: $elm$core$Maybe$Just(
						A3($author$project$Components$SettingsPage$NextGenAuditSettingsView$viewReviewPercentageTable, data, rulesResponse, model.reviewPercentageTable))
				};
			} else {
				return {
					nonRulesReviewPercentageView: $elm$core$Maybe$Just(viewManualReviewPercentage),
					rulesHeading: $elm$core$Maybe$Nothing,
					rulesTable: $elm$core$Maybe$Nothing
				};
			}
		}();
		var nonRulesReviewPercentageView = _v0.nonRulesReviewPercentageView;
		var rulesTable = _v0.rulesTable;
		var rulesHeading = _v0.rulesHeading;
		return $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$author$project$Ui$V3$Stack$viewVertMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceLarge)
					]),
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('NextGen Audit Settings')
								]))),
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Account Level')
								]))),
						$elm$core$Maybe$Just(
						A2(
							$author$project$Ui$V3$Stack$viewVertMaybes,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
								]),
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									halfWidthContainer(viewWarnIfAmountOver)),
									A2($elm$core$Maybe$map, halfWidthContainer, nonRulesReviewPercentageView)
								]))),
						rulesHeading,
						A2($elm$core$Maybe$map, threeQuartersWidthContainer, rulesTable),
						$elm$core$Maybe$Just(
						halfWidthContainer(viewVerificationExceptions))
					])));
	});
var $author$project$Components$SettingsPage$NextGenAuditSettingsView$view = F3(
	function (v3ReskinEnabled, data, model) {
		return (!data.currentUser.isAdmin) ? $elm$html$Html$text('ERROR: You must be an admin in order to access this page.') : (v3ReskinEnabled ? A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$authorizedViewV3, data, model) : A2($author$project$Components$SettingsPage$NextGenAuditSettingsView$authorizedViewV2, data, model));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CardMsg = function (a) {
	return {$: 'CardMsg', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$SaveCard = {$: 'SaveCard'};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$SetCardEditing = function (a) {
	return {$: 'SetCardEditing', a: a};
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkExposureTypeLabel = function (exposureType) {
	switch (exposureType.$) {
		case 'PodDetectionOnly':
			return 'POD detection only';
		case 'ExceptionOnly':
			return 'Exception only';
		case 'PodDetectionAndException':
			return 'Both POD detection and exception';
		default:
			return 'Disabled';
	}
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewCarrierRateOnlyV3Reskin = function (model) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Set how Carrier Rate exceptions are surfaced.'),
				A2(
				$author$project$Ui$V3$Typography$body,
				_List_Nil,
				$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkExposureTypeLabel(model.carrierRateType))
			]));
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel = function (checkType) {
	switch (checkType.$) {
		case 'DocumentPODInferenceCheckTypeCheckSignature':
			return 'Signature Review';
		case 'DocumentPODInferenceCheckTypeReferenceMatch':
			return 'Reference Match Review';
		case 'DocumentPODInferenceCheckTypeManualReferenceMatch':
			return 'Manual Reference Match Review';
		case 'DocumentPODInferenceCheckTypeNoDamages':
			return 'OS&D Review';
		case 'DocumentPODInferenceCheckTypeNoCarrierRate':
			return 'Carrier Rate Review';
		case 'DocumentPODInferenceCheckTypeAllPagesPresent':
			return 'All Pages Present';
		default:
			return 'Has Receiver Date';
	}
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$disabledCheckboxWithHint = F3(
	function (label, checked, hint) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Checkbox$viewDisabled,
					{
						checked: checked,
						label: $elm$html$Html$text(label)
					},
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding-left', '22px'),
							A2($elm$html$Html$Attributes$style, 'line-height', '18px')
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Typography$xSmallBody, _List_Nil, hint)
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$carrierRateReviewSetting = function (model) {
	var isChecked = A2($elm$core$List$member, $author$project$AuditPb$DocumentPODInferenceCheckTypeNoCarrierRate, model.checks);
	return $elm$core$Maybe$Just(
		A3(
			$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$disabledCheckboxWithHint,
			$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeNoCarrierRate),
			isChecked,
			'To set OS&D Review and Carrier Rate Review update the OS&D and Carrier Rate exception settings'));
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$referenceMatchReviewSetting = function (model) {
	return model.podRequiresBolValidation ? $elm$core$Maybe$Just(
		A3(
			$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$disabledCheckboxWithHint,
			$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch),
			true,
			'Reference Match Review is determined by your BOL validation configuration and cannot be changed here')) : (model.referenceMatchEnabled ? $elm$core$Maybe$Just(
		A2(
			$author$project$Ui$V3$Checkbox$viewDisabled,
			{
				checked: A2($elm$core$List$member, $author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch, model.checks),
				label: $elm$html$Html$text(
					$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch))
			},
			_List_Nil)) : $elm$core$Maybe$Nothing);
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewChecksOnlyV3Reskin = function (model) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Typography$body, _List_Nil, 'Set the general required POD checks for your brokerage.')
					])),
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('For a document to be considered a POD for this account it must contain:')
							])),
						A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2(
									$author$project$Ui$V3$Checkbox$viewDisabled,
									{
										checked: A2($elm$core$List$member, $author$project$AuditPb$DocumentPODInferenceCheckTypeCheckSignature, model.checks),
										label: $elm$html$Html$text(
											$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeCheckSignature))
									},
									_List_Nil)),
								$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$referenceMatchReviewSetting(model),
								$elm$core$Maybe$Just(
								A2(
									$author$project$Ui$V3$Checkbox$viewDisabled,
									{
										checked: A2($elm$core$List$member, $author$project$AuditPb$DocumentPODInferenceCheckTypeNoDamages, model.checks),
										label: $elm$html$Html$text(
											$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeNoDamages))
									},
									_List_Nil)),
								$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$carrierRateReviewSetting(model)
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewDamagesOnlyV3Reskin = function (model) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Set how OS&D exceptions are surfaced.'),
				A2(
				$author$project$Ui$V3$Typography$body,
				_List_Nil,
				$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkExposureTypeLabel(model.damagesType))
			]));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$viewChecks = function (checks) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewChecksOnlyV3Reskin(checks),
				$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewDamagesOnlyV3Reskin(checks),
				$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewCarrierRateOnlyV3Reskin(checks)
			]));
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$SetCarrierRateType = function (a) {
	return {$: 'SetCarrierRateType', a: a};
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$allCheckExposureTypes = _List_fromArray(
	[$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$PodDetectionOnly, $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$ExceptionOnly, $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$PodDetectionAndException, $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$Disabled]);
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewCarrierRateOnlyV3ReskinEdit = F2(
	function (mapMsg, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Set how Carrier Rate exceptions are surfaced.'),
					A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$SetCarrierRateType, mapMsg),
						options: $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$allCheckExposureTypes,
						toLabel: $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkExposureTypeLabel,
						value: $elm$core$Maybe$Just(model.carrierRateType)
					},
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$ToggleCheck = F2(
	function (a, b) {
		return {$: 'ToggleCheck', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$referenceMatchReviewEdit = F2(
	function (mapMsg, model) {
		return model.referenceMatchEnabled ? $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Checkbox$view,
				{
					checked: A2($elm$core$List$member, $author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch, model.checks),
					label: $elm$html$Html$text(
						$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch)),
					onCheck: A2(
						$elm$core$Basics$composeR,
						$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$ToggleCheck($author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch),
						mapMsg)
				},
				_List_Nil)) : (model.podRequiresBolValidation ? $elm$core$Maybe$Just(
			A3(
				$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$disabledCheckboxWithHint,
				$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeReferenceMatch),
				true,
				'Reference Match Review is determined by your BOL validation configuration and cannot be changed here')) : $elm$core$Maybe$Nothing);
	});
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewChecksOnlyV3ReskinEdit = F2(
	function (mapMsg, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Typography$body, _List_Nil, 'Set the general required POD checks for your brokerage.')
						])),
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('For a document to be considered a POD for this account it must contain:')
								])),
							A2(
							$author$project$Ui$V3$Stack$viewVertMaybes,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
								]),
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V3$Checkbox$view,
										{
											checked: A2($elm$core$List$member, $author$project$AuditPb$DocumentPODInferenceCheckTypeCheckSignature, model.checks),
											label: $elm$html$Html$text(
												$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeCheckSignature)),
											onCheck: A2(
												$elm$core$Basics$composeR,
												$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$ToggleCheck($author$project$AuditPb$DocumentPODInferenceCheckTypeCheckSignature),
												mapMsg)
										},
										_List_Nil)),
									A2($author$project$Components$SettingsPage$Shared$PodDefinitionChecks$referenceMatchReviewEdit, mapMsg, model),
									$elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V3$Checkbox$viewDisabled,
										{
											checked: A2($elm$core$List$member, $author$project$AuditPb$DocumentPODInferenceCheckTypeNoDamages, model.checks),
											label: $elm$html$Html$text(
												$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel($author$project$AuditPb$DocumentPODInferenceCheckTypeNoDamages))
										},
										_List_Nil)),
									$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$carrierRateReviewSetting(model)
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$SetDamagesType = function (a) {
	return {$: 'SetDamagesType', a: a};
};
var $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewDamagesOnlyV3ReskinEdit = F2(
	function (mapMsg, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Typography$bodySemiBold, _List_Nil, 'Set how OS&D exceptions are surfaced.'),
					A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$SetDamagesType, mapMsg),
						options: $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$allCheckExposureTypes,
						toLabel: $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkExposureTypeLabel,
						value: $elm$core$Maybe$Just(model.damagesType)
					},
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$viewChecksEdit = F2(
	function (mapMsg, checks) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewChecksOnlyV3ReskinEdit, mapMsg, checks),
					A2($author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewDamagesOnlyV3ReskinEdit, mapMsg, checks),
					A2($author$project$Components$SettingsPage$Shared$PodDefinitionChecks$viewCarrierRateOnlyV3ReskinEdit, mapMsg, checks)
				]));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$viewAccountChecks = F2(
	function (data, model) {
		return A2(
			$author$project$Components$SettingsPage$EditableSection$view,
			{
				isValid: $elm$core$Basics$always(true),
				onSave: $author$project$Components$SettingsPage$PodDefinitionSettingsView$AccountLevel($author$project$Components$SettingsPage$PodDefinitionSettingsView$SaveCard),
				onToggle: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$PodDefinitionSettingsView$AccountLevel, $author$project$Components$SettingsPage$PodDefinitionSettingsView$SetCardEditing),
				title: 'POD definition settings',
				viewEditing: $author$project$Components$SettingsPage$PodDefinitionSettingsView$viewChecksEdit(
					A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$PodDefinitionSettingsView$AccountLevel, $author$project$Components$SettingsPage$PodDefinitionSettingsView$CardMsg)),
				viewOriginal: $author$project$Components$SettingsPage$PodDefinitionSettingsView$viewChecks
			},
			$author$project$Components$SettingsPage$EditableSection$fromParts(
				{
					editing: model.accountChecksDraft,
					original: $author$project$Components$SettingsPage$Shared$PodDefinitionChecks$init(data.accountSettings)
				}));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$viewAccountLevel = F2(
	function (data, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Account level')
						])),
					A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$viewAccountChecks, data, model)
				]));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$NewGroup = {$: 'NewGroup'};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$StartEditing = function (a) {
	return {$: 'StartEditing', a: a};
};
var $author$project$Ui$V3$Colors$Teal400 = {$: 'Teal400'};
var $author$project$Ui$V3$UtilityButton$IconColor = function (a) {
	return {$: 'IconColor', a: a};
};
var $author$project$Ui$V3$UtilityButton$iconColor = $author$project$Ui$V3$UtilityButton$IconColor;
var $author$project$Ui$V3$UtilityButton$ShowLabel = function (a) {
	return {$: 'ShowLabel', a: a};
};
var $author$project$Ui$V3$UtilityButton$showLabel = $author$project$Ui$V3$UtilityButton$ShowLabel;
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewAddDefinitionLink = function (editEnabled) {
	return A2(
		$author$project$Helpers$Html$showIf,
		editEnabled,
		A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$mainAxisEnd]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$UtilityButton$view,
						{
							icon: $author$project$Ui$V3$Icon$add16,
							label: 'Add custom definition',
							onClick: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$StartEditing($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$NewGroup)
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$UtilityButton$sizeSmall,
								$author$project$Ui$V3$UtilityButton$showLabel(true),
								$author$project$Ui$V3$UtilityButton$iconColor($author$project$Ui$V3$Colors$Teal400)
							])))
				])));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CancelDeleting = {$: 'CancelDeleting'};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$ConfirmDeleting = function (a) {
	return {$: 'ConfirmDeleting', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewDeleteConfirmation = function (model) {
	return A2(
		$author$project$Helpers$Html$showMaybe,
		function (group) {
			return $author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Modal$view,
					_List_fromArray(
						[
							$author$project$Ui$V3$Modal$disablePrimaryButton(
							$author$project$PostRequestState$isInProgress(model.requestState))
						]),
					{
						body: $elm$html$Html$text('Are you sure? These customers will use the account level POD definition settings.'),
						cancelButton: $elm$core$Maybe$Just(
							_Utils_Tuple2('Cancel', $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CancelDeleting)),
						dismissMsg: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CancelDeleting,
						footerButtons: _List_Nil,
						header: $author$project$Ui$V3$Modal$textHeader('Delete custom definition'),
						primaryButton: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								'Confirm',
								$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$ConfirmDeleting(group))),
						size: $author$project$Ui$V3$Modal$small
					}));
		},
		model.deleting);
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Edited = function (a) {
	return {$: 'Edited', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Saved = function (a) {
	return {$: 'Saved', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$isEditedGroup = F2(
	function (editing, group) {
		var sortedCustomerIds = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($author$project$Domain$TmsCustomerId$toInt),
			$elm$core$List$sort);
		var _v0 = editing.target;
		if (_v0.$ === 'ExistingGroup') {
			var edited = _v0.a;
			return _Utils_eq(
				sortedCustomerIds(edited.tmsCustomerIds),
				sortedCustomerIds(group.tmsCustomerIds));
		} else {
			return false;
		}
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Passed = {$: 'Passed'};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$validateCustomers = F2(
	function (data, editing) {
		var overlapping = $elm$core$List$sort(
			A2(
				$elm$core$List$map,
				$author$project$Domain$TmsCustomer$customerNameForDisplay(data.accountSettings),
				A2(
					$elm$core$List$filterMap,
					function (id) {
						return A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.id;
								},
								$elm$core$Basics$eq(id)),
							data.customers);
					},
					A2(
						$elm$core$List$filter,
						function (id) {
							return A2($elm$core$List$member, id, editing.draft.tmsCustomerIds);
						},
						A2(
							$elm$core$List$concatMap,
							function ($) {
								return $.tmsCustomerIds;
							},
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Basics$not,
									$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$isEditedGroup(editing)),
								data.definitions.groups))))));
		return $elm$core$List$isEmpty(editing.draft.tmsCustomerIds) ? $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Error('Select at least one customer') : ((!$elm$core$List$isEmpty(overlapping)) ? $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Error(
			'Already used by another definition: ' + A2($elm$core$String$join, ', ', overlapping)) : $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Passed);
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CancelEditing = {$: 'CancelEditing'};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$SaveEditing = {$: 'SaveEditing'};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCancelSaveButtons = F2(
	function (validation, saving) {
		return $author$project$Helpers$Html$editButtons(
			{
				cancelMsg: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CancelEditing,
				primaryDisabled: saving || (!_Utils_eq(validation, $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Passed)),
				primaryLabel: 'Save',
				primaryMsg: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$SaveEditing
			});
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$StartDeleting = function (a) {
	return {$: 'StartDeleting', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewDeleteButton = function (group) {
	return A2(
		$author$project$Ui$V3$UtilityButton$view,
		{
			icon: $author$project$Ui$V3$Icon$removeOutline16,
			label: 'Delete',
			onClick: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$StartDeleting(group)
		},
		_List_fromArray(
			[$author$project$Ui$V3$UtilityButton$sizeSmall]));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$ExistingGroup = function (a) {
	return {$: 'ExistingGroup', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewEditButton = function (group) {
	return A2(
		$author$project$Ui$V3$UtilityButton$view,
		{
			icon: $author$project$Ui$V3$Icon$editOutline16,
			label: 'Edit',
			onClick: $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$StartEditing(
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$ExistingGroup(group))
		},
		_List_fromArray(
			[$author$project$Ui$V3$UtilityButton$sizeSmall]));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCardActions = function (group) {
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewEditButton(group)),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewDeleteButton(group))
			]));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$UpdateDraft = function (a) {
	return {$: 'UpdateDraft', a: a};
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$noOverrideLabel = A2($author$project$Ui$V3$Typography$smallBody, _List_Nil, 'Does not override the account level setting');
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroupCheck = F3(
	function (draft, group, checkType) {
		var label = $elm$html$Html$text(
			$author$project$Components$SettingsPage$Shared$PodDefinitionChecks$checkTypeLabel(checkType));
		var checked = A2(
			$elm$core$List$member,
			checkType,
			A2($elm$core$Maybe$withDefault, group, draft).podDefinitionChecksEnabled);
		if (draft.$ === 'Just') {
			var editedGroup = draft.a;
			return A2(
				$author$project$Ui$V3$Checkbox$view,
				{
					checked: checked,
					label: label,
					onCheck: function (enabled) {
						return $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$UpdateDraft(
							_Utils_update(
								editedGroup,
								{
									podDefinitionChecksEnabled: A3($author$project$Components$SettingsPage$Shared$PodDefinitionChecks$setCheckEnabled, checkType, enabled, editedGroup.podDefinitionChecksEnabled)
								}));
					}
				},
				_List_Nil);
		} else {
			return A2(
				$author$project$Ui$V3$Checkbox$viewDisabled,
				{checked: checked, label: label},
				_List_Nil);
		}
	});
var $author$project$Ui$V3$Toggle$Size = function (a) {
	return {$: 'Size', a: a};
};
var $author$project$Ui$V3$Toggle$Small = {$: 'Small'};
var $author$project$Ui$V3$Toggle$small = $author$project$Ui$V3$Toggle$Size($author$project$Ui$V3$Toggle$Small);
var $author$project$Ui$V3$Toggle$Large = {$: 'Large'};
var $author$project$Ui$V3$Toggle$defaultAttributes = {size: $author$project$Ui$V3$Toggle$Large};
var $author$project$Ui$V3$Toggle$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			var value = a.a;
			return _Utils_update(
				acc,
				{size: value});
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$Toggle$defaultAttributes, attributes);
};
var $author$project$Ui$V3$Toggle$sizeToStr = function (size) {
	if (size.$ === 'Small') {
		return 'small';
	} else {
		return 'large';
	}
};
var $author$project$Ui$V3$Toggle$view = F3(
	function (attrs, toggleMsg, isOn) {
		var toggledStr = isOn ? 'on' : 'off';
		var computedAttributes = $author$project$Ui$V3$Toggle$computeAttributes(attrs);
		var sizeStr = $author$project$Ui$V3$Toggle$sizeToStr(computedAttributes.size);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__toggle__label'),
					$elm$html$Html$Attributes$class('v3__toggle__label--' + sizeStr),
					$elm$html$Html$Attributes$class('v3__toggle__label--' + toggledStr)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__toggle__input'),
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(isOn),
							$elm$html$Html$Events$onCheck(toggleMsg)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__toggle__slider'),
							$elm$html$Html$Attributes$class('v3__toggle__slider--' + sizeStr),
							$elm$html$Html$Attributes$class('v3__toggle__slider--' + toggledStr)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewOverrideToggle = F2(
	function (inherits, onToggle) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A3(
						$author$project$Ui$V3$Toggle$view,
						_List_fromArray(
							[$author$project$Ui$V3$Toggle$small]),
						onToggle,
						!inherits)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Typography$xSmallBody,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', 'var(--color-text-secondary)')
							]),
						'Override the account level setting'))
				]));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroupChecks = F3(
	function (availableChecks, maybeEditing, group) {
		var draft = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.draft;
			},
			maybeEditing);
		var inheritsPODDefinitionChecksEnabled = A2($elm$core$Maybe$withDefault, group, draft).inheritsPODDefinitionChecksEnabled;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
							$author$project$Ui$V3$Stack$crossAxisCenter
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							$elm$core$Maybe$Just(
								A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Required POD checks:'))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$elm$core$Maybe$map,
								function (draftGroup) {
									return A2(
										$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewOverrideToggle,
										draftGroup.inheritsPODDefinitionChecksEnabled,
										function (isOn) {
											return $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$UpdateDraft(
												_Utils_update(
													draftGroup,
													{inheritsPODDefinitionChecksEnabled: !isOn}));
										});
								},
								draft))
						])),
				inheritsPODDefinitionChecksEnabled ? _List_fromArray(
					[$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$noOverrideLabel]) : A2(
					$elm$core$List$map,
					A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroupCheck, draft, group),
					availableChecks)));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewChip = F2(
	function (maybeEditing, onRemove) {
		return $author$project$Ui$V3$Chip$view(
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Chip$Style, 'border-radius', 'var(--corner-radius-sm)'),
						A2($author$project$Ui$V3$Chip$Style, 'padding', '12px 16px'),
						A2($author$project$Ui$V3$Chip$Style, 'font-weight', 'var(--font-weight-regular)')
					]),
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (_v0) {
						var draft = _v0.draft;
						return _List_fromArray(
							[
								$author$project$Ui$V3$Chip$removable(
								{
									onRemove: onRemove(draft)
								})
							]);
					},
					maybeEditing)));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCustomerChip = F2(
	function (maybeEditing, _v0) {
		var id = _v0.a;
		var name = _v0.b;
		return A3(
			$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewChip,
			maybeEditing,
			function (draft) {
				return $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$UpdateDraft(
					_Utils_update(
						draft,
						{
							tmsCustomerIds: A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(id),
								draft.tmsCustomerIds)
						}));
			},
			name);
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewValidationError = function (validation) {
	if (validation.$ === 'Passed') {
		return $elm$html$Html$text('');
	} else {
		var message = validation.a;
		return A2(
			$author$project$Ui$V3$Typography$xSmallBody,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'color', 'var(--color-text-feedback-error)')
				]),
			message);
	}
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroupCustomers = F4(
	function (data, validation, maybeEditing, group) {
		var shown = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			group,
			function ($) {
				return $.draft;
			},
			maybeEditing);
		var names = A2(
			$elm$core$List$sortBy,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$map,
				function (customer) {
					return _Utils_Tuple2(
						customer.id,
						A2($author$project$Domain$TmsCustomer$customerNameForDisplay, data.accountSettings, customer));
				},
				A2(
					$elm$core$List$filter,
					function (customer) {
						return A2($elm$core$List$member, customer.id, shown.tmsCustomerIds);
					},
					data.customers)));
		var viewCustomerChips = A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
					$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCustomerChip(maybeEditing)),
				names));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Customers:'),
				function () {
					if (maybeEditing.$ === 'Just') {
						var editing = maybeEditing.a;
						return _List_fromArray(
							[
								viewCustomerChips,
								A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_Nil,
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fitPx(280),
										A2(
											$elm$html$Html$map,
											$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$CustomerSelectMsg,
											A4($author$project$Components$TmsCustomerDropdown$view, _List_Nil, data.accountSettings, data.customerSelectData, editing.customerSelect)))
									])),
								$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewValidationError(validation)
							]);
					} else {
						return _List_fromArray(
							[viewCustomerChips]);
					}
				}()));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewDocumentTypeChip = F3(
	function (data, maybeEditing, documentType) {
		return A3(
			$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewChip,
			maybeEditing,
			function (draft) {
				return $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$UpdateDraft(
					_Utils_update(
						draft,
						{
							allowedAsPODOverrideDocumentTypes: A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(documentType),
								draft.allowedAsPODOverrideDocumentTypes)
						}));
			},
			A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeLabel, data, documentType));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewDocumentTypesHeadline = function (draft) {
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
				$author$project$Ui$V3$Stack$crossAxisCenter
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				$elm$core$Maybe$Just(
					A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, 'Document types:'))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$elm$core$Maybe$map,
					function (draftGroup) {
						return A2(
							$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewOverrideToggle,
							draftGroup.inheritsAllowedAsPODOverrideDocumentTypes,
							function (isOn) {
								return $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$UpdateDraft(
									_Utils_update(
										draftGroup,
										{inheritsAllowedAsPODOverrideDocumentTypes: !isOn}));
							});
					},
					draft))
			]));
};
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroupOverrideDocumentTypes = F3(
	function (data, maybeEditing, group) {
		var draft = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.draft;
			},
			maybeEditing);
		var shown = A2($elm$core$Maybe$withDefault, group, draft);
		var viewDocumentTypeChips = A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
					A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewDocumentTypeChip, data, maybeEditing)),
				A2(
					$elm$core$List$sortBy,
					$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$documentTypeLabel(data),
					shown.allowedAsPODOverrideDocumentTypes)));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewDocumentTypesHeadline(draft),
				function () {
					if (shown.inheritsAllowedAsPODOverrideDocumentTypes) {
						return _List_fromArray(
							[$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$noOverrideLabel]);
					} else {
						if (maybeEditing.$ === 'Just') {
							var editing = maybeEditing.a;
							return _List_fromArray(
								[
									viewDocumentTypeChips,
									A2(
									$author$project$Ui$V3$Stack$viewHorzWithWidths,
									_List_Nil,
									_List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$Ui$V3$Stack$fitPx(280),
											A2(
												$elm$html$Html$map,
												$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$DocumentTypeSelectMsg,
												A2($author$project$Ui$V3$CustomSelect$view, editing.documentTypeSelect, _List_Nil)))
										]))
								]);
						} else {
							return _List_fromArray(
								[viewDocumentTypeChips]);
						}
					}
				}()));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCard = F4(
	function (data, model, editEnabled, card) {
		var _v0 = function () {
			if (card.$ === 'Saved') {
				var saved = card.a;
				return _Utils_Tuple2(saved, $elm$core$Maybe$Nothing);
			} else {
				var edited = card.a;
				return _Utils_Tuple2(
					edited.draft,
					$elm$core$Maybe$Just(edited));
			}
		}();
		var group = _v0.a;
		var editing = _v0.b;
		var validation = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Passed,
			$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$validateCustomers(data),
			editing);
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$styleAsCard]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
							]),
						_List_fromArray(
							[
								A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroupOverrideDocumentTypes, data, editing, group),
								A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroupChecks, data.definitions.availableChecks, editing, group),
								A4($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroupCustomers, data, validation, editing, group),
								A2(
								$author$project$Helpers$Html$showIf,
								!_Utils_eq(editing, $elm$core$Maybe$Nothing),
								A2(
									$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCancelSaveButtons,
									validation,
									$author$project$PostRequestState$isInProgress(model.requestState)))
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Helpers$Html$showIf,
						editEnabled && _Utils_eq(editing, $elm$core$Maybe$Nothing),
						$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCardActions(group)))
				]));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroup = F4(
	function (data, model, editEnabled, group) {
		return A4(
			$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCard,
			data,
			model,
			editEnabled,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Saved(group),
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Edited,
				A2(
					$elm_community$maybe_extra$Maybe$Extra$filter,
					function (editing) {
						return A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$isEditedGroup, editing, group);
					},
					model.editing)));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewNewGroup = F3(
	function (data, model, editEnabled) {
		return A2(
			$author$project$Helpers$Html$showMaybe,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$Edited,
				A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewCard, data, model, editEnabled)),
			A2(
				$elm_community$maybe_extra$Maybe$Extra$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.target;
					},
					$elm$core$Basics$eq($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$NewGroup)),
				model.editing));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$view = F2(
	function (model, data) {
		var editEnabled = data.accountSettings.podDefinitionCustomerEditEnabled;
		return ($elm$core$List$isEmpty(data.definitions.groups) && (!editEnabled)) ? $elm$html$Html$text('') : A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Customer level')
						])),
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewGroup, data, model, editEnabled),
							data.definitions.groups),
						_List_fromArray(
							[
								A3($author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewNewGroup, data, model, editEnabled)
							]))),
					$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewAddDefinitionLink(editEnabled),
					$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$viewDeleteConfirmation(model)
				]));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$viewCustomerLevel = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevelMsg,
			A4(
				$author$project$Ui$V3$Skeleton$viewRemote,
				_List_Nil,
				{
					height: $elm$core$Maybe$Just(200)
				},
				$author$project$Components$SettingsPage$PodDefinitionSettingsView$CustomerLevel$view(model.customerLevel),
				data.customerLevel));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$authorizedView = F2(
	function (data, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceLarge)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('POD definition')
						])),
					A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$viewAccountLevel, data, model),
					A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$viewCustomerLevel, data, model)
				]));
	});
var $author$project$Components$SettingsPage$PodDefinitionSettingsView$view = F2(
	function (data, model) {
		return data.user.hasSettingsRole ? A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$authorizedView, data, model) : $elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.');
	});
var $author$project$Components$SettingsPage$ScraperStatusView$view = F2(
	function (_v0, _v1) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('here')
				]));
	});
var $author$project$Components$SettingsPage$mainContent = F4(
	function (v3ReskinEnabled, _v0, tz, data) {
		var _v1 = data.sectionData;
		switch (_v1.$) {
			case 'AccountSettingsData':
				var childModel = _v1.a;
				var childData = _v1.b;
				return A3(
					$author$project$Helpers$Bool$doIf,
					v3ReskinEnabled,
					$author$project$Helpers$Html$v3ReskinContainer,
					A2(
						$elm$html$Html$map,
						$author$project$Components$SettingsPage$AccountSettingsViewMsg,
						A3($author$project$Components$SettingsPage$AccountSettingsView$view, v3ReskinEnabled, childData, childModel)));
			case 'IntegrationsSettingsData':
				var childData = _v1.a;
				return A2($author$project$Components$SettingsPage$IntegrationsSettingsView$view, tz, childData);
			case 'NextGenAuditSettingsData':
				var childModel = _v1.a;
				var childData = _v1.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$NextGenAuditSettingsViewMsg,
					A3($author$project$Components$SettingsPage$NextGenAuditSettingsView$view, v3ReskinEnabled, childData, childModel));
			case 'DocumentTypesSettingsData':
				var childModel = _v1.a;
				var childData = _v1.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$DocumentTypesSettingsViewMsg,
					A3($author$project$Components$SettingsPage$DocumentTypesSettingsView$view, v3ReskinEnabled, childData, childModel));
			case 'CarrierDocumentsSettingsData':
				var childModel = _v1.a;
				var childData = _v1.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$CarrierDocumentsSettingsViewMsg,
					A3($author$project$Components$CarrierDocumentsView$CarrierDocumentsView$view, tz, childData, childModel));
			case 'ContactsSettingsData':
				var childModel = _v1.a;
				var childData = _v1.b;
				return A3(
					$author$project$Helpers$Bool$doIf,
					v3ReskinEnabled,
					$author$project$Helpers$Html$v3ReskinContainer,
					A2(
						$elm$html$Html$map,
						$author$project$Components$SettingsPage$ContactsSettingsViewMsg,
						A3($author$project$Components$SettingsPage$ContactsSettingsView$view, v3ReskinEnabled, childData, childModel)));
			case 'DebtorsSettingsData':
				var childModel = _v1.a;
				var childData = _v1.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$DebtorsSettingsViewMsg,
					A2($author$project$Components$SettingsPage$DebtorsSettingsView$view, childData, childModel));
			case 'FactorClientPortalSettingsData':
				var childModel = _v1.a;
				var childData = _v1.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$FactorClientPortalSettingsViewMsg,
					A2($author$project$Components$SettingsPage$FactorClientPortalSettingsView$view, childData, childModel));
			case 'ExceptionSettingsData':
				var childModel = _v1.a;
				var childData = _v1.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$ExceptionSettingsViewMsg,
					A3($author$project$Components$SettingsPage$ExceptionSettingsView$view, v3ReskinEnabled, childData, childModel));
			case 'ScraperStatusSettingsData':
				var childData = _v1.a;
				return A2($author$project$Components$SettingsPage$ScraperStatusView$view, tz, childData);
			default:
				var childModel = _v1.a;
				var childData = _v1.b;
				return A3(
					$author$project$Helpers$Bool$doIf,
					v3ReskinEnabled,
					$author$project$Helpers$Html$v3ReskinContainer,
					A2(
						$elm$html$Html$map,
						$author$project$Components$SettingsPage$PodDefinitionSettingsViewMsg,
						A2($author$project$Components$SettingsPage$PodDefinitionSettingsView$view, childData, childModel)));
		}
	});
var $author$project$Components$SettingsPage$toSection = function (activeSection) {
	switch (activeSection.$) {
		case 'AccountSettings':
			return $author$project$Components$SettingsPage$Shared$Section$Account;
		case 'IntegrationsSettings':
			return $author$project$Components$SettingsPage$Shared$Section$Integrations;
		case 'NextGenAuditSettings':
			return $author$project$Components$SettingsPage$Shared$Section$NextGenAudit;
		case 'DocumentTypesSettings':
			return $author$project$Components$SettingsPage$Shared$Section$DocumentTypes;
		case 'CarrierDocumentsSettings':
			return $author$project$Components$SettingsPage$Shared$Section$Carriers;
		case 'ContactsSettings':
			return $author$project$Components$SettingsPage$Shared$Section$Contacts;
		case 'DebtorsSettings':
			return $author$project$Components$SettingsPage$Shared$Section$Debtors;
		case 'FactorClientPortalSettings':
			return $author$project$Components$SettingsPage$Shared$Section$FactorClientPortal;
		case 'ExceptionSettings':
			return $author$project$Components$SettingsPage$Shared$Section$Exceptions;
		case 'ScraperStatusSettings':
			return $author$project$Components$SettingsPage$Shared$Section$ScraperStatus;
		default:
			return $author$project$Components$SettingsPage$Shared$Section$PodDefinition;
	}
};
var $author$project$Components$SettingsPage$view = F4(
	function (v3ReskinEnabled, tz, model, data) {
		return A6(
			$author$project$Components$SettingsPage$Shared$Section$frameView,
			v3ReskinEnabled,
			$author$project$Components$SettingsPage$toSection(model.activeSection),
			data.currentAccount,
			data.accountSettings,
			data.currentUser,
			A4($author$project$Components$SettingsPage$mainContent, v3ReskinEnabled, model, tz, data));
	});
var $author$project$Components$SettingsPage$CarrierLayout$ClosePortalWarning = {$: 'ClosePortalWarning'};
var $author$project$Components$SettingsPage$CarrierLayout$GoBack = {$: 'GoBack'};
var $author$project$Ui$V3$Icon$arrowLeft16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.0324 7.0406H3.62511C3.59136 7.04027 3.55851 7.02975 3.53085 7.01042C3.50319 6.99109 3.48202 6.96384 3.47013 6.93226C3.45823 6.90068 3.45616 6.86624 3.46419 6.83347C3.47222 6.80069 3.48996 6.77111 3.51511 6.7486L9.27311 1.68193C9.45413 1.51126 9.56182 1.27698 9.57349 1.02846C9.58515 0.77994 9.49988 0.536599 9.33565 0.349718C9.17142 0.162837 8.94104 0.0470142 8.69309 0.0266583C8.44513 0.00630245 8.19895 0.0830039 8.00644 0.240598L0.552442 6.79993C0.382191 6.95008 0.245838 7.13473 0.152442 7.34163C0.0590449 7.54853 0.0107422 7.77293 0.0107422 7.99993C0.0107422 8.22693 0.0590449 8.45133 0.152442 8.65823C0.245838 8.86513 0.382191 9.04978 0.552442 9.19993L8.00511 15.7579C8.19777 15.9135 8.44313 15.9887 8.68989 15.9676C8.93666 15.9466 9.16575 15.831 9.32928 15.645C9.49281 15.459 9.57814 15.217 9.56742 14.9696C9.5567 14.7221 9.45078 14.4884 9.27177 14.3173L3.51377 9.2506C3.48863 9.22809 3.47088 9.19851 3.46285 9.16573C3.45483 9.13295 3.4569 9.09851 3.46879 9.06693C3.48069 9.03535 3.50186 9.00811 3.52951 8.98878C3.55717 8.96944 3.59003 8.95892 3.62377 8.9586H15.0324C15.2826 8.952 15.5203 8.848 15.6949 8.66875C15.8694 8.4895 15.9671 8.24916 15.9671 7.99893C15.9671 7.7487 15.8694 7.50837 15.6949 7.32911C15.5203 7.14986 15.2826 7.04586 15.0324 7.03926V7.0406Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Components$SettingsPage$CarrierLayout$container = function (html) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$styleAsCard,
				$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_fromArray(
			[html]));
};
var $author$project$Components$SettingsPage$CarrierLayout$TogglePortalAccess = function (a) {
	return {$: 'TogglePortalAccess', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$enableActionString = function (isEnabled) {
	return isEnabled ? 'Disable' : 'Enable';
};
var $author$project$Components$SettingsPage$CarrierLayout$portalWarningModalConfig = F2(
	function (isEnabled, carrierName) {
		return {
			body: isEnabled ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('settings__warning-modal--text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(carrierName + ' will no longer be able to upload through the Client Portal.')
					])) : A2($elm$html$Html$div, _List_Nil, _List_Nil),
			confirm: $elm$core$Maybe$Just(
				{
					msg: $author$project$Components$SettingsPage$CarrierLayout$TogglePortalAccess(!isEnabled),
					text: 'Yes'
				}),
			dismissText: $elm$core$Maybe$Just('No'),
			header: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('settings__warning-modal--header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$SettingsPage$CarrierLayout$enableActionString(isEnabled) + (' the Client Portal for ' + (carrierName + '?')))
								]))
						]))),
			modalClassOverride: $elm$core$Maybe$Nothing,
			performing: false,
			performingText: $elm$core$Maybe$Just('Updating Client Portal Access...'),
			success: false,
			successText: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$portalWarningModalConfigV3Reskin = F2(
	function (isEnabled, carrierName) {
		return {
			body: isEnabled ? $elm$html$Html$text(carrierName + ' will no longer be able to upload through the Client Portal.') : $elm$html$Html$text(''),
			cancelButton: $elm$core$Maybe$Just(
				_Utils_Tuple2('No', $author$project$Components$SettingsPage$CarrierLayout$ClosePortalWarning)),
			dismissMsg: $author$project$Components$SettingsPage$CarrierLayout$ClosePortalWarning,
			footerButtons: _List_Nil,
			header: $author$project$Ui$V3$Modal$textHeader(
				$author$project$Components$SettingsPage$CarrierLayout$enableActionString(isEnabled) + (' the Client Portal for ' + (carrierName + '?'))),
			primaryButton: $elm$core$Maybe$Just(
				_Utils_Tuple2(
					'Yes',
					$author$project$Components$SettingsPage$CarrierLayout$TogglePortalAccess(!isEnabled))),
			size: $author$project$Ui$V3$Modal$medium
		};
	});
var $author$project$Components$ClientDebtorConfigurationManager$HasCustomDefaults = function (a) {
	return {$: 'HasCustomDefaults', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$UsingAccountDefaults = {$: 'UsingAccountDefaults'};
var $author$project$Components$ClientDebtorConfigurationManager$clientLevelConfigState = function (configs) {
	var _v0 = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.isClientLevel;
			},
			configs));
	if (_v0.$ === 'Just') {
		var config = _v0.a;
		return $author$project$Components$ClientDebtorConfigurationManager$HasCustomDefaults(config);
	} else {
		return $author$project$Components$ClientDebtorConfigurationManager$UsingAccountDefaults;
	}
};
var $author$project$Components$ClientDebtorConfigurationManager$StartCreatingClientLevelConfig = {$: 'StartCreatingClientLevelConfig'};
var $author$project$Components$ClientDebtorConfigurationManager$EditConfiguration = function (a) {
	return {$: 'EditConfiguration', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$ShowDeleteConfirmation = function (a) {
	return {$: 'ShowDeleteConfirmation', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$amountSourceLabel = function (source) {
	switch (source) {
		case 'invoice':
			return 'Use invoice amount';
		case 'rate_con':
			return 'Use rate con amount';
		default:
			return 'Unknown amount source';
	}
};
var $author$project$Ui$V2$Badge$ErrorStyle = {$: 'ErrorStyle'};
var $author$project$Ui$V2$Badge$error = $author$project$Ui$V2$Badge$StyleAttribute($author$project$Ui$V2$Badge$ErrorStyle);
var $author$project$Ui$V2$Badge$InfoStyle = {$: 'InfoStyle'};
var $author$project$Ui$V2$Badge$info = $author$project$Ui$V2$Badge$StyleAttribute($author$project$Ui$V2$Badge$InfoStyle);
var $author$project$Ui$V2$Badge$SuccessStyle = {$: 'SuccessStyle'};
var $author$project$Ui$V2$Badge$success = $author$project$Ui$V2$Badge$StyleAttribute($author$project$Ui$V2$Badge$SuccessStyle);
var $author$project$Components$ClientDebtorConfigurationManager$viewConfiguration = function (config) {
	var hasAnyExplicitSettings = (!_Utils_eq(config.rateConRequired, $author$project$Domain$RequirementSetting$Inherit)) || ((!_Utils_eq(config.bolRequired, $author$project$Domain$RequirementSetting$Inherit)) || ((!_Utils_eq(config.podRequired, $author$project$Domain$RequirementSetting$Inherit)) || ((!_Utils_eq(config.amountMatchRequirement, $author$project$Domain$AmountMatchRequirement$Inherit)) || (config.alwaysBlock || ((!_Utils_eq(config.laneRateExceptionsMode, $author$project$Domain$LaneRateCheckSetting$Inherit)) || ((!_Utils_eq(config.factorDeliveryDateCheckDays, $author$project$Domain$DeliveryDateCheckSetting$Inherit)) || ((!_Utils_eq(config.invoiceAmountHistoryRuleMode, $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit)) || ((!_Utils_eq(config.trustClientSubmittedInvoiceNumber, $author$project$Domain$TrustClientSubmittedSetting$Inherit)) || ((!_Utils_eq(config.trustClientSubmittedLoadId, $author$project$Domain$TrustClientSubmittedSetting$Inherit)) || ((!_Utils_eq(config.trustClientSubmittedDebtor, $author$project$Domain$TrustClientSubmittedSetting$Inherit)) || (!_Utils_eq(config.trustClientSubmittedAmount, $author$project$Domain$TrustClientSubmittedSetting$Inherit))))))))))));
	var exceptionBadges = function () {
		if (config.alwaysBlock) {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$V2$Badge$view,
					_List_fromArray(
						[$author$project$Ui$V2$Badge$error]),
					'Manual review required')
				]);
		} else {
			if (hasAnyExplicitSettings) {
				var trustSubmittedBadges = _List_fromArray(
					[
						function () {
						var _v6 = config.trustClientSubmittedInvoiceNumber;
						switch (_v6.$) {
							case 'Enabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Trust submitted invoice #'));
							case 'Disabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$error]),
										'Don\u0027t trust submitted invoice #'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}(),
						function () {
						var _v7 = config.trustClientSubmittedLoadId;
						switch (_v7.$) {
							case 'Enabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Trust submitted load ID'));
							case 'Disabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$error]),
										'Don\u0027t trust submitted load ID'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}(),
						function () {
						var _v8 = config.trustClientSubmittedDebtor;
						switch (_v8.$) {
							case 'Enabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Trust submitted debtor'));
							case 'Disabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$error]),
										'Don\u0027t trust submitted debtor'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}(),
						function () {
						var _v9 = config.trustClientSubmittedAmount;
						switch (_v9.$) {
							case 'Enabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Trust submitted amount'));
							case 'Disabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$error]),
										'Don\u0027t trust submitted amount'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}()
					]);
				var laneRateBadges = _List_fromArray(
					[
						function () {
						var _v5 = config.laneRateExceptionsMode;
						switch (_v5.$) {
							case 'Enabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Lane rate check'));
							case 'Disabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$error]),
										'No lane rate check'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}()
					]);
				var invoiceAmountHistoryBadges = _List_fromArray(
					[
						function () {
						var _v4 = config.invoiceAmountHistoryRuleMode;
						switch (_v4.$) {
							case 'Enabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Amount history check'));
							case 'Disabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$error]),
										'No amount history check'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}()
					]);
				var documentBadges = _List_fromArray(
					[
						function () {
						var _v1 = config.rateConRequired;
						switch (_v1.$) {
							case 'Required':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Rate con required'));
							case 'NotRequired':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$alert]),
										'No rate con required'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}(),
						function () {
						var _v2 = config.bolRequired;
						switch (_v2.$) {
							case 'Required':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'BOL required'));
							case 'NotRequired':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$info]),
										'No BOL required'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}(),
						function () {
						var _v3 = config.podRequired;
						switch (_v3.$) {
							case 'Required':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'POD required'));
							case 'NotRequired':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$info]),
										'No POD required'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}()
					]);
				var deliveryDateBadges = _List_fromArray(
					[
						function () {
						var _v0 = config.factorDeliveryDateCheckDays;
						switch (_v0.$) {
							case 'Disabled':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$error]),
										'No delivery date check'));
							case 'ThirtyDays':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Delivery date: 30d'));
							case 'SixtyDays':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Delivery date: 60d'));
							case 'NinetyDays':
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$V2$Badge$view,
										_List_fromArray(
											[$author$project$Ui$V2$Badge$success]),
										'Delivery date: 90d'));
							default:
								return $elm$core$Maybe$Nothing;
						}
					}()
					]);
				var amountBadges = _Utils_eq(config.amountMatchRequirement, $author$project$Domain$AmountMatchRequirement$MayDiffer) ? _List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$author$project$Ui$V2$Badge$view,
							_List_fromArray(
								[$author$project$Ui$V2$Badge$error]),
							'Amounts may differ')),
						$elm$core$Maybe$Just(
						A2(
							$author$project$Ui$V2$Badge$view,
							_List_fromArray(
								[$author$project$Ui$V2$Badge$success]),
							$author$project$Components$ClientDebtorConfigurationManager$amountSourceLabel(config.amountSource)))
					]) : _List_Nil;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_Utils_ap(
						documentBadges,
						_Utils_ap(
							amountBadges,
							_Utils_ap(
								laneRateBadges,
								_Utils_ap(
									deliveryDateBadges,
									_Utils_ap(invoiceAmountHistoryBadges, trustSubmittedBadges))))));
			} else {
				return _List_fromArray(
					[
						A2($author$project$Ui$V2$Badge$view, _List_Nil, 'Standard rules')
					]);
			}
		}
	}();
	var displayName = config.isClientLevel ? 'Client Defaults for All Debtors' : ($elm$core$String$isEmpty(config.debtorName) ? '(Debtor no longer exists)' : config.debtorName);
	var badges = exceptionBadges;
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('configuration-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('configuration-item__content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('configuration-item__header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('configuration-item__name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(displayName)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('configuration-item__badges')
									]),
								badges)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('configuration-item__notes')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '(No notes)', config.notes))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('configuration-item__actions')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Components$ClientDebtorConfigurationManager$EditConfiguration(config)),
								$elm$html$Html$Attributes$class('configuration-item__button configuration-item__button--edit')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							])),
					config.isClientLevel ? _List_Nil : _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Components$ClientDebtorConfigurationManager$ShowDeleteConfirmation(config.id)),
									$elm$html$Html$Attributes$class('configuration-item__button configuration-item__button--delete')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						])))
			]));
};
var $author$project$Components$ClientDebtorConfigurationManager$CancelEdit = {$: 'CancelEdit'};
var $author$project$Components$ClientDebtorConfigurationManager$NotesChanged = function (a) {
	return {$: 'NotesChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$SaveConfiguration = {$: 'SaveConfiguration'};
var $author$project$Components$ClientDebtorConfigurationManager$UpdateConfiguration = {$: 'UpdateConfiguration'};
var $author$project$Components$ClientDebtorConfigurationManager$configModeFromFormState = function (formState) {
	switch (formState.$) {
		case 'CreatingClientLevelConfig':
			return $author$project$Components$ClientDebtorConfigurationManager$ClientLevel;
		case 'EditingClientLevelConfig':
			return $author$project$Components$ClientDebtorConfigurationManager$ClientLevel;
		default:
			return $author$project$Components$ClientDebtorConfigurationManager$DebtorSpecific;
	}
};
var $author$project$Components$ClientDebtorConfigurationManager$maxNotesLength = 1000;
var $author$project$Components$ClientDebtorConfigurationManager$minNotesLength = 3;
var $author$project$Components$ClientDebtorConfigurationManager$AlwaysBlockChanged = function (a) {
	return {$: 'AlwaysBlockChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$AmountMatchRequirementChanged = function (a) {
	return {$: 'AmountMatchRequirementChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$AmountSourceChanged = function (a) {
	return {$: 'AmountSourceChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$BolRequiredChanged = function (a) {
	return {$: 'BolRequiredChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$DeliveryDateCheckSettingChanged = function (a) {
	return {$: 'DeliveryDateCheckSettingChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$InvoiceAmountHistoryCheckSettingChanged = function (a) {
	return {$: 'InvoiceAmountHistoryCheckSettingChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$LaneRateCheckSettingChanged = function (a) {
	return {$: 'LaneRateCheckSettingChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$PodRequiredChanged = function (a) {
	return {$: 'PodRequiredChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$RateConRequiredChanged = function (a) {
	return {$: 'RateConRequiredChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$TrustClientSubmittedAmountChanged = function (a) {
	return {$: 'TrustClientSubmittedAmountChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$TrustClientSubmittedDebtorChanged = function (a) {
	return {$: 'TrustClientSubmittedDebtorChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$TrustClientSubmittedInvoiceNumberChanged = function (a) {
	return {$: 'TrustClientSubmittedInvoiceNumberChanged', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$TrustClientSubmittedLoadIdChanged = function (a) {
	return {$: 'TrustClientSubmittedLoadIdChanged', a: a};
};
var $author$project$Domain$AmountMatchRequirement$ClientLevel = {$: 'ClientLevel'};
var $author$project$Domain$AmountMatchRequirement$DebtorSpecific = {$: 'DebtorSpecific'};
var $author$project$Components$ClientDebtorConfigurationManager$configModeToAmountMatchInheritContext = function (mode) {
	if (mode.$ === 'ClientLevel') {
		return $author$project$Domain$AmountMatchRequirement$ClientLevel;
	} else {
		return $author$project$Domain$AmountMatchRequirement$DebtorSpecific;
	}
};
var $author$project$Domain$AmountMatchRequirement$displayWithContext = F2(
	function (context, setting) {
		switch (setting.$) {
			case 'Inherit':
				if (context.$ === 'ClientLevel') {
					return 'Use Account Default';
				} else {
					return 'Use Client Default';
				}
			case 'MustMatch':
				return 'Must Match';
			default:
				return 'May Differ';
		}
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewAmountMatchRequirementRadioGroupV2 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToAmountMatchInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-options')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('configuration-form__requirement-option')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('radio'),
												$elm$html$Html$Attributes$name(groupName),
												$elm$html$Html$Attributes$checked(
												_Utils_eq(currentValue, option)),
												$elm$html$Html$Events$onInput(
												function (_v0) {
													return onChange(option);
												}),
												$elm$html$Html$Attributes$disabled(isDisabled)
											]),
										_List_Nil),
										$elm$html$Html$text(
										A2($author$project$Domain$AmountMatchRequirement$displayWithContext, context, option))
									]));
						},
						_List_fromArray(
							[$author$project$Domain$AmountMatchRequirement$MustMatch, $author$project$Domain$AmountMatchRequirement$MayDiffer, $author$project$Domain$AmountMatchRequirement$Inherit])))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewAmountMatchRequirementRadioGroupV3 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToAmountMatchInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$author$project$Ui$V3$Radio$view,
					{
						label: $author$project$Domain$AmountMatchRequirement$displayWithContext(context),
						name: groupName,
						onSelect: onChange,
						options: _List_fromArray(
							[$author$project$Domain$AmountMatchRequirement$MustMatch, $author$project$Domain$AmountMatchRequirement$MayDiffer, $author$project$Domain$AmountMatchRequirement$Inherit]),
						selected: $elm$core$Maybe$Just(currentValue)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Radio$disabled(isDisabled),
							$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionHorizontal)
						]))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewCheckbox = F4(
	function (labelText, isChecked, onCheckMsg, helpText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__checkbox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(isChecked),
									$elm$html$Html$Events$onCheck(onCheckMsg)
								]),
							_List_Nil),
							$elm$html$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__help-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(helpText)
						]))
				]));
	});
var $author$project$Domain$DeliveryDateCheckSetting$ClientLevel = {$: 'ClientLevel'};
var $author$project$Domain$DeliveryDateCheckSetting$DebtorSpecific = {$: 'DebtorSpecific'};
var $author$project$Components$ClientDebtorConfigurationManager$configModeToDeliveryDateCheckInheritContext = function (mode) {
	if (mode.$ === 'ClientLevel') {
		return $author$project$Domain$DeliveryDateCheckSetting$ClientLevel;
	} else {
		return $author$project$Domain$DeliveryDateCheckSetting$DebtorSpecific;
	}
};
var $author$project$Domain$DeliveryDateCheckSetting$displayWithContext = F2(
	function (context, setting) {
		switch (setting.$) {
			case 'Inherit':
				if (context.$ === 'ClientLevel') {
					return 'Use Account Default';
				} else {
					return 'Use Client Default';
				}
			case 'Disabled':
				return 'Disabled';
			case 'ThirtyDays':
				return '30 Days';
			case 'SixtyDays':
				return '60 Days';
			default:
				return '90 Days';
		}
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewDeliveryDateCheckRadioGroupV2 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToDeliveryDateCheckInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-options')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('configuration-form__requirement-option')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('radio'),
												$elm$html$Html$Attributes$name(groupName),
												$elm$html$Html$Attributes$checked(
												_Utils_eq(currentValue, option)),
												$elm$html$Html$Events$onInput(
												function (_v0) {
													return onChange(option);
												}),
												$elm$html$Html$Attributes$disabled(isDisabled)
											]),
										_List_Nil),
										$elm$html$Html$text(
										A2($author$project$Domain$DeliveryDateCheckSetting$displayWithContext, context, option))
									]));
						},
						_List_fromArray(
							[$author$project$Domain$DeliveryDateCheckSetting$Disabled, $author$project$Domain$DeliveryDateCheckSetting$ThirtyDays, $author$project$Domain$DeliveryDateCheckSetting$SixtyDays, $author$project$Domain$DeliveryDateCheckSetting$NinetyDays, $author$project$Domain$DeliveryDateCheckSetting$Inherit])))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewDeliveryDateCheckRadioGroupV3 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToDeliveryDateCheckInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$author$project$Ui$V3$Radio$view,
					{
						label: $author$project$Domain$DeliveryDateCheckSetting$displayWithContext(context),
						name: groupName,
						onSelect: onChange,
						options: _List_fromArray(
							[$author$project$Domain$DeliveryDateCheckSetting$Disabled, $author$project$Domain$DeliveryDateCheckSetting$ThirtyDays, $author$project$Domain$DeliveryDateCheckSetting$SixtyDays, $author$project$Domain$DeliveryDateCheckSetting$NinetyDays, $author$project$Domain$DeliveryDateCheckSetting$Inherit]),
						selected: $elm$core$Maybe$Just(currentValue)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Radio$disabled(isDisabled),
							$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionHorizontal)
						]))
				]));
	});
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$ClientLevel = {$: 'ClientLevel'};
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$DebtorSpecific = {$: 'DebtorSpecific'};
var $author$project$Components$ClientDebtorConfigurationManager$configModeToInvoiceAmountHistoryInheritContext = function (mode) {
	if (mode.$ === 'ClientLevel') {
		return $author$project$Domain$InvoiceAmountHistoryCheckSetting$ClientLevel;
	} else {
		return $author$project$Domain$InvoiceAmountHistoryCheckSetting$DebtorSpecific;
	}
};
var $author$project$Domain$InvoiceAmountHistoryCheckSetting$displayWithContext = F2(
	function (context, setting) {
		switch (setting.$) {
			case 'Inherit':
				if (context.$ === 'ClientLevel') {
					return 'Use Account Default';
				} else {
					return 'Use Client Default';
				}
			case 'Enabled':
				return 'Enabled';
			default:
				return 'Disabled';
		}
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewInvoiceAmountHistoryCheckRadioGroupV2 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToInvoiceAmountHistoryInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-options')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('configuration-form__requirement-option')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('radio'),
												$elm$html$Html$Attributes$name(groupName),
												$elm$html$Html$Attributes$checked(
												_Utils_eq(currentValue, option)),
												$elm$html$Html$Events$onInput(
												function (_v0) {
													return onChange(option);
												}),
												$elm$html$Html$Attributes$disabled(isDisabled)
											]),
										_List_Nil),
										$elm$html$Html$text(
										A2($author$project$Domain$InvoiceAmountHistoryCheckSetting$displayWithContext, context, option))
									]));
						},
						_List_fromArray(
							[$author$project$Domain$InvoiceAmountHistoryCheckSetting$Enabled, $author$project$Domain$InvoiceAmountHistoryCheckSetting$Disabled, $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit])))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewInvoiceAmountHistoryCheckRadioGroupV3 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToInvoiceAmountHistoryInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$author$project$Ui$V3$Radio$view,
					{
						label: $author$project$Domain$InvoiceAmountHistoryCheckSetting$displayWithContext(context),
						name: groupName,
						onSelect: onChange,
						options: _List_fromArray(
							[$author$project$Domain$InvoiceAmountHistoryCheckSetting$Enabled, $author$project$Domain$InvoiceAmountHistoryCheckSetting$Disabled, $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit]),
						selected: $elm$core$Maybe$Just(currentValue)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Radio$disabled(isDisabled),
							$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionHorizontal)
						]))
				]));
	});
var $author$project$Domain$LaneRateCheckSetting$ClientLevel = {$: 'ClientLevel'};
var $author$project$Domain$LaneRateCheckSetting$DebtorSpecific = {$: 'DebtorSpecific'};
var $author$project$Components$ClientDebtorConfigurationManager$configModeToLaneRateInheritContext = function (mode) {
	if (mode.$ === 'ClientLevel') {
		return $author$project$Domain$LaneRateCheckSetting$ClientLevel;
	} else {
		return $author$project$Domain$LaneRateCheckSetting$DebtorSpecific;
	}
};
var $author$project$Domain$LaneRateCheckSetting$displayWithContext = F2(
	function (context, setting) {
		switch (setting.$) {
			case 'Inherit':
				if (context.$ === 'ClientLevel') {
					return 'Use Account Default';
				} else {
					return 'Use Client Default';
				}
			case 'Enabled':
				return 'Enabled';
			default:
				return 'Disabled';
		}
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewLaneRateCheckRadioGroupV2 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToLaneRateInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-options')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('configuration-form__requirement-option')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('radio'),
												$elm$html$Html$Attributes$name(groupName),
												$elm$html$Html$Attributes$checked(
												_Utils_eq(currentValue, option)),
												$elm$html$Html$Events$onInput(
												function (_v0) {
													return onChange(option);
												}),
												$elm$html$Html$Attributes$disabled(isDisabled)
											]),
										_List_Nil),
										$elm$html$Html$text(
										A2($author$project$Domain$LaneRateCheckSetting$displayWithContext, context, option))
									]));
						},
						_List_fromArray(
							[$author$project$Domain$LaneRateCheckSetting$Enabled, $author$project$Domain$LaneRateCheckSetting$Disabled, $author$project$Domain$LaneRateCheckSetting$Inherit])))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewLaneRateCheckRadioGroupV3 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToLaneRateInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$author$project$Ui$V3$Radio$view,
					{
						label: $author$project$Domain$LaneRateCheckSetting$displayWithContext(context),
						name: groupName,
						onSelect: onChange,
						options: _List_fromArray(
							[$author$project$Domain$LaneRateCheckSetting$Enabled, $author$project$Domain$LaneRateCheckSetting$Disabled, $author$project$Domain$LaneRateCheckSetting$Inherit]),
						selected: $elm$core$Maybe$Just(currentValue)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Radio$disabled(isDisabled),
							$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionHorizontal)
						]))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewRadioSuperseded = F6(
	function (isSuperseded, groupName, labelText, val, currentValue, onChangeMsg) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					isSuperseded ? 'configuration-form__radio configuration-form__radio--superseded' : 'configuration-form__radio')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$name(groupName),
							$elm$html$Html$Attributes$value(val),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(currentValue, val)),
							$elm$html$Html$Events$onInput(onChangeMsg),
							$elm$html$Html$Attributes$disabled(isSuperseded)
						]),
					_List_Nil),
					$elm$html$Html$text(labelText)
				]));
	});
var $author$project$Domain$RequirementSetting$ClientLevel = {$: 'ClientLevel'};
var $author$project$Domain$RequirementSetting$DebtorSpecific = {$: 'DebtorSpecific'};
var $author$project$Components$ClientDebtorConfigurationManager$configModeToInheritContext = function (mode) {
	if (mode.$ === 'ClientLevel') {
		return $author$project$Domain$RequirementSetting$ClientLevel;
	} else {
		return $author$project$Domain$RequirementSetting$DebtorSpecific;
	}
};
var $author$project$Domain$RequirementSetting$displayWithContext = F2(
	function (context, setting) {
		switch (setting.$) {
			case 'Inherit':
				if (context.$ === 'ClientLevel') {
					return 'Use Account Default';
				} else {
					return 'Use Client Default';
				}
			case 'Required':
				return 'Yes';
			default:
				return 'No';
		}
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewRequirementRadioGroupV2 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-options')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('configuration-form__requirement-option')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('radio'),
												$elm$html$Html$Attributes$name(groupName),
												$elm$html$Html$Attributes$checked(
												_Utils_eq(currentValue, option)),
												$elm$html$Html$Events$onInput(
												function (_v0) {
													return onChange(option);
												}),
												$elm$html$Html$Attributes$disabled(isDisabled)
											]),
										_List_Nil),
										$elm$html$Html$text(
										A2($author$project$Domain$RequirementSetting$displayWithContext, context, option))
									]));
						},
						_List_fromArray(
							[$author$project$Domain$RequirementSetting$Required, $author$project$Domain$RequirementSetting$NotRequired, $author$project$Domain$RequirementSetting$Inherit])))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewRequirementRadioGroupV3 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$author$project$Ui$V3$Radio$view,
					{
						label: $author$project$Domain$RequirementSetting$displayWithContext(context),
						name: groupName,
						onSelect: onChange,
						options: _List_fromArray(
							[$author$project$Domain$RequirementSetting$Required, $author$project$Domain$RequirementSetting$NotRequired, $author$project$Domain$RequirementSetting$Inherit]),
						selected: $elm$core$Maybe$Just(currentValue)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Radio$disabled(isDisabled),
							$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionHorizontal)
						]))
				]));
	});
var $author$project$Domain$TrustClientSubmittedSetting$ClientLevel = {$: 'ClientLevel'};
var $author$project$Domain$TrustClientSubmittedSetting$DebtorSpecific = {$: 'DebtorSpecific'};
var $author$project$Components$ClientDebtorConfigurationManager$configModeToTrustClientSubmittedInheritContext = function (mode) {
	if (mode.$ === 'ClientLevel') {
		return $author$project$Domain$TrustClientSubmittedSetting$ClientLevel;
	} else {
		return $author$project$Domain$TrustClientSubmittedSetting$DebtorSpecific;
	}
};
var $author$project$Domain$TrustClientSubmittedSetting$displayWithContext = F2(
	function (context, setting) {
		switch (setting.$) {
			case 'Inherit':
				if (context.$ === 'ClientLevel') {
					return 'Use Account Default';
				} else {
					return 'Use Client Default';
				}
			case 'Enabled':
				return 'Trust submitted';
			default:
				return 'Don\u0027t trust submitted';
		}
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewTrustClientSubmittedRadioGroupV2 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToTrustClientSubmittedInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-options')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('configuration-form__requirement-option')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('radio'),
												$elm$html$Html$Attributes$name(groupName),
												$elm$html$Html$Attributes$checked(
												_Utils_eq(currentValue, option)),
												$elm$html$Html$Events$onInput(
												function (_v0) {
													return onChange(option);
												}),
												$elm$html$Html$Attributes$disabled(isDisabled)
											]),
										_List_Nil),
										$elm$html$Html$text(
										A2($author$project$Domain$TrustClientSubmittedSetting$displayWithContext, context, option))
									]));
						},
						_List_fromArray(
							[$author$project$Domain$TrustClientSubmittedSetting$Enabled, $author$project$Domain$TrustClientSubmittedSetting$Disabled, $author$project$Domain$TrustClientSubmittedSetting$Inherit])))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewTrustClientSubmittedRadioGroupV3 = F6(
	function (configMode, labelText, groupName, currentValue, onChange, isDisabled) {
		var context = $author$project$Components$ClientDebtorConfigurationManager$configModeToTrustClientSubmittedInheritContext(configMode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-form__requirement-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form__requirement-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$author$project$Ui$V3$Radio$view,
					{
						label: $author$project$Domain$TrustClientSubmittedSetting$displayWithContext(context),
						name: groupName,
						onSelect: onChange,
						options: _List_fromArray(
							[$author$project$Domain$TrustClientSubmittedSetting$Enabled, $author$project$Domain$TrustClientSubmittedSetting$Disabled, $author$project$Domain$TrustClientSubmittedSetting$Inherit]),
						selected: $elm$core$Maybe$Just(currentValue)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Radio$disabled(isDisabled),
							$author$project$Ui$V3$Radio$layoutDirection($author$project$Ui$V3$Radio$LayoutDirectionHorizontal)
						]))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewExceptionFields = function (hideLaneRateExceptionCheck) {
	return function (hideInvoiceAmountHistoryCheck) {
		return function (isV3Reskin) {
			return function (configMode) {
				return function (alwaysBlock) {
					return function (rateConRequired) {
						return function (bolRequired) {
							return function (podRequired) {
								return function (amountMatchRequirement) {
									return function (amountSource) {
										return function (laneRateExceptionsMode) {
											return function (factorDeliveryDateCheckDays) {
												return function (invoiceAmountHistoryRuleMode) {
													return function (trustClientSubmittedInvoiceNumber) {
														return function (trustClientSubmittedLoadId) {
															return function (trustClientSubmittedDebtor) {
																return function (trustClientSubmittedAmount) {
																	var viewRadioGroup = isV3Reskin ? $author$project$Components$ClientDebtorConfigurationManager$viewRequirementRadioGroupV3 : $author$project$Components$ClientDebtorConfigurationManager$viewRequirementRadioGroupV2;
																	var trustClientSubmittedRadioGroup = isV3Reskin ? $author$project$Components$ClientDebtorConfigurationManager$viewTrustClientSubmittedRadioGroupV3 : $author$project$Components$ClientDebtorConfigurationManager$viewTrustClientSubmittedRadioGroupV2;
																	var requiredDocumentsFields = function () {
																		if (configMode.$ === 'ClientLevel') {
																			return _List_fromArray(
																				[
																					A6(viewRadioGroup, configMode, 'Bill of Lading Required?', 'bol-required', bolRequired, $author$project$Components$ClientDebtorConfigurationManager$BolRequiredChanged, alwaysBlock)
																				]);
																		} else {
																			return _List_fromArray(
																				[
																					A6(viewRadioGroup, configMode, 'Rate Confirmation Required?', 'rate-con-required', rateConRequired, $author$project$Components$ClientDebtorConfigurationManager$RateConRequiredChanged, alwaysBlock),
																					A6(viewRadioGroup, configMode, 'Bill of Lading Required?', 'bol-required', bolRequired, $author$project$Components$ClientDebtorConfigurationManager$BolRequiredChanged, alwaysBlock),
																					A6(viewRadioGroup, configMode, 'Proof of Delivery Required?', 'pod-required', podRequired, $author$project$Components$ClientDebtorConfigurationManager$PodRequiredChanged, alwaysBlock)
																				]);
																		}
																	}();
																	var laneRateRadioGroup = isV3Reskin ? $author$project$Components$ClientDebtorConfigurationManager$viewLaneRateCheckRadioGroupV3 : $author$project$Components$ClientDebtorConfigurationManager$viewLaneRateCheckRadioGroupV2;
																	var invoiceAmountHistoryRadioGroup = isV3Reskin ? $author$project$Components$ClientDebtorConfigurationManager$viewInvoiceAmountHistoryCheckRadioGroupV3 : $author$project$Components$ClientDebtorConfigurationManager$viewInvoiceAmountHistoryCheckRadioGroupV2;
																	var deliveryDateRadioGroup = isV3Reskin ? $author$project$Components$ClientDebtorConfigurationManager$viewDeliveryDateCheckRadioGroupV3 : $author$project$Components$ClientDebtorConfigurationManager$viewDeliveryDateCheckRadioGroupV2;
																	var amountMatchRadioGroup = isV3Reskin ? $author$project$Components$ClientDebtorConfigurationManager$viewAmountMatchRequirementRadioGroupV3 : $author$project$Components$ClientDebtorConfigurationManager$viewAmountMatchRequirementRadioGroupV2;
																	return A2(
																		$elm$html$Html$div,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$h4,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('client-debtor-config__subsection-header')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('Exceptions for this relationship')
																					])),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class(
																						alwaysBlock ? 'configuration-form__section configuration-form__section--always-block configuration-form__section--always-block-active' : 'configuration-form__section configuration-form__section--always-block')
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$p,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('configuration-form__section-header configuration-form__section-header--block')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('ALWAYS REQUIRE MANUAL REVIEW')
																							])),
																						A4($author$project$Components$ClientDebtorConfigurationManager$viewCheckbox, 'Always require manual review for invoices from this debtor', alwaysBlock, $author$project$Components$ClientDebtorConfigurationManager$AlwaysBlockChanged, 'All invoices between this carrier and debtor will be sent to manual review — no autoprocessing.')
																					])),
																				$elm$core$List$isEmpty(requiredDocumentsFields) ? $elm$html$Html$text('') : A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('configuration-form__section')
																					]),
																				A2(
																					$elm$core$List$cons,
																					A2(
																						$elm$html$Html$p,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('configuration-form__section-header')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('REQUIRED DOCUMENTS')
																							])),
																					requiredDocumentsFields)),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('configuration-form__section')
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$p,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('configuration-form__section-header')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('AUDIT CHECKS')
																							])),
																						A6(amountMatchRadioGroup, configMode, 'Rate Confirmation/Client Invoice Amount Matching', 'amount-matching', amountMatchRequirement, $author$project$Components$ClientDebtorConfigurationManager$AmountMatchRequirementChanged, alwaysBlock),
																						_Utils_eq(amountMatchRequirement, $author$project$Domain$AmountMatchRequirement$MayDiffer) ? A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('configuration-form__amount-source')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$p,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('when extracting the invoice amount, use:')
																									])),
																								A6($author$project$Components$ClientDebtorConfigurationManager$viewRadioSuperseded, alwaysBlock, 'amount-source', 'Invoice amount', 'invoice', amountSource, $author$project$Components$ClientDebtorConfigurationManager$AmountSourceChanged),
																								A6($author$project$Components$ClientDebtorConfigurationManager$viewRadioSuperseded, alwaysBlock, 'amount-source', 'Rate confirmation amount', 'rate_con', amountSource, $author$project$Components$ClientDebtorConfigurationManager$AmountSourceChanged)
																							])) : $elm$html$Html$text(''),
																						hideLaneRateExceptionCheck ? $elm$html$Html$text('') : A6(laneRateRadioGroup, configMode, 'Lane Rate Exception Check', 'lane-rate-check', laneRateExceptionsMode, $author$project$Components$ClientDebtorConfigurationManager$LaneRateCheckSettingChanged, alwaysBlock),
																						A6(deliveryDateRadioGroup, configMode, 'Delivery Date Check', 'delivery-date-check', factorDeliveryDateCheckDays, $author$project$Components$ClientDebtorConfigurationManager$DeliveryDateCheckSettingChanged, alwaysBlock),
																						hideInvoiceAmountHistoryCheck ? $elm$html$Html$text('') : A6(invoiceAmountHistoryRadioGroup, configMode, 'Invoice Amount History Check', 'invoice-amount-history-check', invoiceAmountHistoryRuleMode, $author$project$Components$ClientDebtorConfigurationManager$InvoiceAmountHistoryCheckSettingChanged, alwaysBlock),
																						A6(trustClientSubmittedRadioGroup, configMode, 'Trust client submitted invoice number', 'trust-client-submitted-invoice-number', trustClientSubmittedInvoiceNumber, $author$project$Components$ClientDebtorConfigurationManager$TrustClientSubmittedInvoiceNumberChanged, alwaysBlock),
																						A6(trustClientSubmittedRadioGroup, configMode, 'Trust client submitted load ID', 'trust-client-submitted-load-id', trustClientSubmittedLoadId, $author$project$Components$ClientDebtorConfigurationManager$TrustClientSubmittedLoadIdChanged, alwaysBlock),
																						A6(trustClientSubmittedRadioGroup, configMode, 'Trust client submitted debtor', 'trust-client-submitted-debtor', trustClientSubmittedDebtor, $author$project$Components$ClientDebtorConfigurationManager$TrustClientSubmittedDebtorChanged, alwaysBlock),
																						A6(trustClientSubmittedRadioGroup, configMode, 'Trust client submitted amount', 'trust-client-submitted-amount', trustClientSubmittedAmount, $author$project$Components$ClientDebtorConfigurationManager$TrustClientSubmittedAmountChanged, alwaysBlock)
																					]))
																			]));
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$ClientDebtorConfigurationManager$viewFormContent = F3(
	function (isV3Reskin, data, model) {
		var notesLength = function () {
			var _v7 = model.notes;
			if (_v7.$ === 'Just') {
				var str = _v7.a;
				return $elm$core$String$length(str);
			} else {
				return 0;
			}
		}();
		var isNotesTooShort = function () {
			var _v6 = model.notes;
			if (_v6.$ === 'Just') {
				var str = _v6.a;
				return ($elm$core$String$length(str) > 0) && (_Utils_cmp(
					$elm$core$String$length(str),
					$author$project$Components$ClientDebtorConfigurationManager$minNotesLength) < 0);
			} else {
				return false;
			}
		}();
		var isNotesTooLong = function () {
			var _v5 = model.notes;
			if (_v5.$ === 'Just') {
				var str = _v5.a;
				return _Utils_cmp(
					$elm$core$String$length(str),
					$author$project$Components$ClientDebtorConfigurationManager$maxNotesLength) > 0;
			} else {
				return false;
			}
		}();
		var hasValidNotes = function () {
			var _v4 = model.notes;
			if (_v4.$ === 'Nothing') {
				return true;
			} else {
				var str = _v4.a;
				return (_Utils_cmp(
					$elm$core$String$length(str),
					$author$project$Components$ClientDebtorConfigurationManager$minNotesLength) > -1) && (_Utils_cmp(
					$elm$core$String$length(str),
					$author$project$Components$ClientDebtorConfigurationManager$maxNotesLength) < 1);
			}
		}();
		var hasDebtorSelected = !_Utils_eq(
			$author$project$Typeahead$selectedId(model.debtorTypeahead),
			$elm$core$Maybe$Nothing);
		var configMode = $author$project$Components$ClientDebtorConfigurationManager$configModeFromFormState(model.formState);
		var canSave = function () {
			var _v3 = model.configMode;
			if (_v3.$ === 'ClientLevel') {
				return hasValidNotes && (!model.savingConfiguration);
			} else {
				return hasDebtorSelected && (hasValidNotes && (!model.savingConfiguration));
			}
		}();
		var _v0 = model.formState;
		switch (_v0.$) {
			case 'CreatingClientLevelConfig':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('configuration-form__client-level-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('This configuration will apply to all debtors for this carrier.')
								])),
							$author$project$Components$ClientDebtorConfigurationManager$viewExceptionFields(data.hideLaneRateExceptionCheck)(data.hideInvoiceAmountHistoryCheck)(isV3Reskin)(configMode)(model.alwaysBlock)(model.rateConRequired)(model.bolRequired)(model.podRequired)(model.amountMatchRequirement)(model.amountSource)(model.laneRateExceptionsMode)(model.factorDeliveryDateCheckDays)(model.invoiceAmountHistoryRuleMode)(model.trustClientSubmittedInvoiceNumber)(model.trustClientSubmittedLoadId)(model.trustClientSubmittedDebtor)(model.trustClientSubmittedAmount),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('client-debtor-config__subsection-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Notes')
								])),
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$placeholder(
									'Notes (optional, minimum ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$minNotesLength) + ' characters if provided)')),
									$elm$html$Html$Attributes$value(
									A2($elm$core$Maybe$withDefault, '', model.notes)),
									$elm$html$Html$Events$onInput($author$project$Components$ClientDebtorConfigurationManager$NotesChanged)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									(isNotesTooShort || isNotesTooLong) ? 'character-count error' : 'character-count')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(notesLength) + (' / ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$maxNotesLength) + (' characters' + (isNotesTooShort ? (' (minimum ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$minNotesLength) + ' required if notes are provided)')) : '')))))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$SaveConfiguration),
									$elm$html$Html$Attributes$disabled(!canSave),
									$elm$html$Html$Attributes$class('configuration-form__button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.savingConfiguration ? 'Saving...' : 'Save Configuration')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$CancelEdit),
									$elm$html$Html$Attributes$class('configuration-form__button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]));
			case 'CreatingDebtorConfig':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$ClientDebtorConfigurationManager$DebtorTypeaheadMsg,
							A3($author$project$Components$DebtorTypeahead$viewCustom, $author$project$Components$DebtorTypeahead$defaultConfig, data.debtorTypeaheadData, model.debtorTypeahead)),
							$author$project$Components$ClientDebtorConfigurationManager$viewExceptionFields(data.hideLaneRateExceptionCheck)(data.hideInvoiceAmountHistoryCheck)(isV3Reskin)(configMode)(model.alwaysBlock)(model.rateConRequired)(model.bolRequired)(model.podRequired)(model.amountMatchRequirement)(model.amountSource)(model.laneRateExceptionsMode)(model.factorDeliveryDateCheckDays)(model.invoiceAmountHistoryRuleMode)(model.trustClientSubmittedInvoiceNumber)(model.trustClientSubmittedLoadId)(model.trustClientSubmittedDebtor)(model.trustClientSubmittedAmount),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('client-debtor-config__subsection-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Notes')
								])),
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$placeholder(
									'Notes (optional, minimum ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$minNotesLength) + ' characters if provided)')),
									$elm$html$Html$Attributes$value(
									A2($elm$core$Maybe$withDefault, '', model.notes)),
									$elm$html$Html$Events$onInput($author$project$Components$ClientDebtorConfigurationManager$NotesChanged)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									(isNotesTooShort || isNotesTooLong) ? 'character-count error' : 'character-count')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(notesLength) + (' / ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$maxNotesLength) + (' characters' + (isNotesTooShort ? (' (minimum ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$minNotesLength) + ' required if notes are provided)')) : '')))))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$SaveConfiguration),
									$elm$html$Html$Attributes$disabled(!canSave),
									$elm$html$Html$Attributes$class('configuration-form__button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.savingConfiguration ? 'Saving...' : 'Save Configuration')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$CancelEdit),
									$elm$html$Html$Attributes$class('configuration-form__button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]));
			case 'EditingClientLevelConfig':
				var editingId = _v0.a;
				var editingConfig = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(c.id, editingId);
						},
						model.configurations));
				var debtorName = 'All debtors (carrier default)';
				var canUpdate = function () {
					if (editingConfig.$ === 'Just') {
						var config = editingConfig.a;
						var notesChanged = !_Utils_eq(model.notes, config.notes);
						var noteValidationFailure = notesChanged && (!hasValidNotes);
						var hasChanges = notesChanged || ((!_Utils_eq(model.rateConRequired, config.rateConRequired)) || ((!_Utils_eq(model.bolRequired, config.bolRequired)) || ((!_Utils_eq(model.podRequired, config.podRequired)) || ((!_Utils_eq(model.amountMatchRequirement, config.amountMatchRequirement)) || ((!_Utils_eq(model.amountSource, config.amountSource)) || ((!_Utils_eq(model.alwaysBlock, config.alwaysBlock)) || ((!_Utils_eq(model.laneRateExceptionsMode, config.laneRateExceptionsMode)) || ((!_Utils_eq(model.factorDeliveryDateCheckDays, config.factorDeliveryDateCheckDays)) || ((!_Utils_eq(model.invoiceAmountHistoryRuleMode, config.invoiceAmountHistoryRuleMode)) || ((!_Utils_eq(model.trustClientSubmittedInvoiceNumber, config.trustClientSubmittedInvoiceNumber)) || ((!_Utils_eq(model.trustClientSubmittedLoadId, config.trustClientSubmittedLoadId)) || ((!_Utils_eq(model.trustClientSubmittedDebtor, config.trustClientSubmittedDebtor)) || (!_Utils_eq(model.trustClientSubmittedAmount, config.trustClientSubmittedAmount))))))))))))));
						return hasChanges && ((!noteValidationFailure) && (!model.updatingConfiguration));
					} else {
						return false;
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('editing-debtor-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Editing: ' + debtorName)
								])),
							$author$project$Components$ClientDebtorConfigurationManager$viewExceptionFields(data.hideLaneRateExceptionCheck)(data.hideInvoiceAmountHistoryCheck)(isV3Reskin)(configMode)(model.alwaysBlock)(model.rateConRequired)(model.bolRequired)(model.podRequired)(model.amountMatchRequirement)(model.amountSource)(model.laneRateExceptionsMode)(model.factorDeliveryDateCheckDays)(model.invoiceAmountHistoryRuleMode)(model.trustClientSubmittedInvoiceNumber)(model.trustClientSubmittedLoadId)(model.trustClientSubmittedDebtor)(model.trustClientSubmittedAmount),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('client-debtor-config__subsection-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Notes')
								])),
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$placeholder(
									'Notes (optional, minimum ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$minNotesLength) + ' characters if provided)')),
									$elm$html$Html$Attributes$value(
									A2($elm$core$Maybe$withDefault, '', model.notes)),
									$elm$html$Html$Events$onInput($author$project$Components$ClientDebtorConfigurationManager$NotesChanged)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									(isNotesTooShort || isNotesTooLong) ? 'character-count error' : 'character-count')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(notesLength) + (' / ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$maxNotesLength) + (' characters' + (isNotesTooShort ? (' (minimum ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$minNotesLength) + ' required if notes are provided)')) : '')))))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$UpdateConfiguration),
									$elm$html$Html$Attributes$disabled(!canUpdate),
									$elm$html$Html$Attributes$class('configuration-form__button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.updatingConfiguration ? 'Updating...' : 'Update Configuration')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$CancelEdit),
									$elm$html$Html$Attributes$class('configuration-form__button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]));
			case 'EditingDebtorConfig':
				var editingId = _v0.a;
				var editingConfig = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(c.id, editingId);
						},
						model.configurations));
				var debtorName = A2(
					$elm$core$Maybe$withDefault,
					'(Unknown)',
					A2(
						$elm$core$Maybe$map,
						function (c) {
							return $elm$core$String$isEmpty(c.debtorName) ? '(Debtor no longer exists)' : c.debtorName;
						},
						editingConfig));
				var canUpdate = function () {
					if (editingConfig.$ === 'Just') {
						var config = editingConfig.a;
						var notesChanged = !_Utils_eq(model.notes, config.notes);
						var noteValidationFailure = notesChanged && (!hasValidNotes);
						var hasChanges = notesChanged || ((!_Utils_eq(model.rateConRequired, config.rateConRequired)) || ((!_Utils_eq(model.bolRequired, config.bolRequired)) || ((!_Utils_eq(model.podRequired, config.podRequired)) || ((!_Utils_eq(model.amountMatchRequirement, config.amountMatchRequirement)) || ((!_Utils_eq(model.amountSource, config.amountSource)) || ((!_Utils_eq(model.alwaysBlock, config.alwaysBlock)) || ((!_Utils_eq(model.laneRateExceptionsMode, config.laneRateExceptionsMode)) || ((!_Utils_eq(model.factorDeliveryDateCheckDays, config.factorDeliveryDateCheckDays)) || ((!_Utils_eq(model.invoiceAmountHistoryRuleMode, config.invoiceAmountHistoryRuleMode)) || ((!_Utils_eq(model.trustClientSubmittedInvoiceNumber, config.trustClientSubmittedInvoiceNumber)) || ((!_Utils_eq(model.trustClientSubmittedLoadId, config.trustClientSubmittedLoadId)) || ((!_Utils_eq(model.trustClientSubmittedDebtor, config.trustClientSubmittedDebtor)) || (!_Utils_eq(model.trustClientSubmittedAmount, config.trustClientSubmittedAmount))))))))))))));
						return hasChanges && ((!noteValidationFailure) && (!model.updatingConfiguration));
					} else {
						return false;
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-form')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('editing-debtor-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Editing: ' + debtorName)
								])),
							$author$project$Components$ClientDebtorConfigurationManager$viewExceptionFields(data.hideLaneRateExceptionCheck)(data.hideInvoiceAmountHistoryCheck)(isV3Reskin)(configMode)(model.alwaysBlock)(model.rateConRequired)(model.bolRequired)(model.podRequired)(model.amountMatchRequirement)(model.amountSource)(model.laneRateExceptionsMode)(model.factorDeliveryDateCheckDays)(model.invoiceAmountHistoryRuleMode)(model.trustClientSubmittedInvoiceNumber)(model.trustClientSubmittedLoadId)(model.trustClientSubmittedDebtor)(model.trustClientSubmittedAmount),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('client-debtor-config__subsection-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Notes')
								])),
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$placeholder(
									'Notes (optional, minimum ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$minNotesLength) + ' characters if provided)')),
									$elm$html$Html$Attributes$value(
									A2($elm$core$Maybe$withDefault, '', model.notes)),
									$elm$html$Html$Events$onInput($author$project$Components$ClientDebtorConfigurationManager$NotesChanged)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									(isNotesTooShort || isNotesTooLong) ? 'character-count error' : 'character-count')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(notesLength) + (' / ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$maxNotesLength) + (' characters' + (isNotesTooShort ? (' (minimum ' + ($elm$core$String$fromInt($author$project$Components$ClientDebtorConfigurationManager$minNotesLength) + ' required if notes are provided)')) : '')))))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$UpdateConfiguration),
									$elm$html$Html$Attributes$disabled(!canUpdate),
									$elm$html$Html$Attributes$class('configuration-form__button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.updatingConfiguration ? 'Updating...' : 'Update Configuration')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$CancelEdit),
									$elm$html$Html$Attributes$class('configuration-form__button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewAllDebtorsRow = F4(
	function (isV3Reskin, data, model, state) {
		var inheritedRow = A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-item configuration-item--inherited')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-item__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('configuration-item__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('configuration-item__name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('All debtors (using account defaults)')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('configuration-item__notes')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('This carrier is using your account\u0027s default validation rules. Click Customize to override for this carrier.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-item__actions')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$StartCreatingClientLevelConfig),
									$elm$html$Html$Attributes$class('configuration-item__button configuration-item__button--customize')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Customize')
								]))
						]))
				]));
		var createForm = function () {
			var _v3 = model.formState;
			if (_v3.$ === 'CreatingClientLevelConfig') {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('configuration-list__inline-form')
							]),
						_List_fromArray(
							[
								A3($author$project$Components$ClientDebtorConfigurationManager$viewFormContent, isV3Reskin, data, model)
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-list')
				]),
			function () {
				if (state.$ === 'UsingAccountDefaults') {
					return A2($elm$core$List$cons, inheritedRow, createForm);
				} else {
					var config = state.a;
					var _v1 = _Utils_Tuple2(model.formState, config.id);
					switch (_v1.a.$) {
						case 'EditingClientLevelConfig':
							var editingId = _v1.a.a;
							var configId = _v1.b;
							return _Utils_eq(editingId, configId) ? _List_fromArray(
								[
									$author$project$Components$ClientDebtorConfigurationManager$viewConfiguration(config),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('configuration-list__inline-form')
										]),
									_List_fromArray(
										[
											A3($author$project$Components$ClientDebtorConfigurationManager$viewFormContent, isV3Reskin, data, model)
										]))
								]) : _List_fromArray(
								[
									$author$project$Components$ClientDebtorConfigurationManager$viewConfiguration(config)
								]);
						case 'CreatingClientLevelConfig':
							var _v2 = _v1.a;
							return _List_fromArray(
								[
									$author$project$Components$ClientDebtorConfigurationManager$viewConfiguration(config),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('configuration-list__inline-form')
										]),
									_List_fromArray(
										[
											A3($author$project$Components$ClientDebtorConfigurationManager$viewFormContent, isV3Reskin, data, model)
										]))
								]);
						default:
							return _List_fromArray(
								[
									$author$project$Components$ClientDebtorConfigurationManager$viewConfiguration(config)
								]);
					}
				}
			}());
	});
var $author$project$Components$ClientDebtorConfigurationManager$StartCreatingDebtorConfig = {$: 'StartCreatingDebtorConfig'};
var $author$project$Components$ClientDebtorConfigurationManager$viewConfigurationWithForm = F4(
	function (isV3Reskin, data, model, config) {
		var isBeingEdited = function () {
			var _v0 = model.formState;
			switch (_v0.$) {
				case 'EditingClientLevelConfig':
					var editingId = _v0.a;
					return _Utils_eq(editingId, config.id);
				case 'EditingDebtorConfig':
					var editingId = _v0.a;
					return _Utils_eq(editingId, config.id);
				default:
					return false;
			}
		}();
		return _List_fromArray(
			[
				$author$project$Components$ClientDebtorConfigurationManager$viewConfiguration(config),
				isBeingEdited ? A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('configuration-list__inline-form')
					]),
				_List_fromArray(
					[
						A3($author$project$Components$ClientDebtorConfigurationManager$viewFormContent, isV3Reskin, data, model)
					])) : $elm$html$Html$text('')
			]);
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewDebtorSpecificSection = F4(
	function (isV3Reskin, data, model, debtorSpecificConfigs) {
		return ($elm$core$List$isEmpty(debtorSpecificConfigs) && (!_Utils_eq(model.formState, $author$project$Components$ClientDebtorConfigurationManager$CreatingDebtorConfig))) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configuration-list__empty-state')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('No per-debtor exceptions configured.')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$StartCreatingDebtorConfig),
							$elm$html$Html$Attributes$class('configuration-list__add-button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('+ Add Debtor Exception')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-list__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('PER-DEBTOR EXCEPTIONS')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configuration-list')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$concatMap,
							A3($author$project$Components$ClientDebtorConfigurationManager$viewConfigurationWithForm, isV3Reskin, data, model),
							debtorSpecificConfigs),
						function () {
							var _v0 = model.formState;
							if (_v0.$ === 'CreatingDebtorConfig') {
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('configuration-list__inline-form')
											]),
										_List_fromArray(
											[
												A3($author$project$Components$ClientDebtorConfigurationManager$viewFormContent, isV3Reskin, data, model)
											]))
									]);
							} else {
								return _List_Nil;
							}
						}())),
					function () {
					var _v1 = model.formState;
					if (_v1.$ === 'Hidden') {
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Components$ClientDebtorConfigurationManager$StartCreatingDebtorConfig),
									$elm$html$Html$Attributes$class('configuration-list__add-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('+ Add Debtor Exception')
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewConfigurationList = F4(
	function (isV3Reskin, data, model, configurations) {
		var debtorSpecificConfigs = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				function ($) {
					return $.isClientLevel;
				}),
			configurations);
		var allDebtorsState = $author$project$Components$ClientDebtorConfigurationManager$clientLevelConfigState(configurations);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('configuration-list--client-level')
								]),
							_List_fromArray(
								[
									A4($author$project$Components$ClientDebtorConfigurationManager$viewAllDebtorsRow, isV3Reskin, data, model, allDebtorsState)
								]))
						])),
					A4($author$project$Components$ClientDebtorConfigurationManager$viewDebtorSpecificSection, isV3Reskin, data, model, debtorSpecificConfigs)
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$DeleteConfiguration = function (a) {
	return {$: 'DeleteConfiguration', a: a};
};
var $author$project$Components$ClientDebtorConfigurationManager$buildActiveRulesList = function (config) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				config.alwaysBlock ? $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Always require manual review')
						]))) : $elm$core$Maybe$Nothing,
				function () {
				var _v0 = config.rateConRequired;
				switch (_v0.$) {
					case 'Required':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Rate confirmation required')
									])));
					case 'NotRequired':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No rate confirmation required')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				function () {
				var _v1 = config.bolRequired;
				switch (_v1.$) {
					case 'Required':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Bill of Lading required')
									])));
					case 'NotRequired':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No Bill of Lading required')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				function () {
				var _v2 = config.podRequired;
				switch (_v2.$) {
					case 'Required':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Proof of Delivery required')
									])));
					case 'NotRequired':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No Proof of Delivery required')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				_Utils_eq(config.amountMatchRequirement, $author$project$Domain$AmountMatchRequirement$MayDiffer) ? $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Amounts may differ - use '),
							function () {
							var _v3 = config.amountSource;
							switch (_v3) {
								case 'invoice':
									return $elm$html$Html$text('invoice amount');
								case 'rate_con':
									return $elm$html$Html$text('rate confirmation amount');
								default:
									return $elm$html$Html$text('unknown source');
							}
						}()
						]))) : $elm$core$Maybe$Nothing,
				function () {
				var _v4 = config.laneRateExceptionsMode;
				switch (_v4.$) {
					case 'Enabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Lane rate check enabled')
									])));
					case 'Disabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Lane rate check disabled')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				function () {
				var _v5 = config.factorDeliveryDateCheckDays;
				switch (_v5.$) {
					case 'Disabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Delivery date check disabled')
									])));
					case 'ThirtyDays':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Delivery date check: 30 days')
									])));
					case 'SixtyDays':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Delivery date check: 60 days')
									])));
					case 'NinetyDays':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Delivery date check: 90 days')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				function () {
				var _v6 = config.invoiceAmountHistoryRuleMode;
				switch (_v6.$) {
					case 'Enabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Amount history check enabled')
									])));
					case 'Disabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Amount history check disabled')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				function () {
				var _v7 = config.trustClientSubmittedInvoiceNumber;
				switch (_v7.$) {
					case 'Enabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Trust submitted invoice number')
									])));
					case 'Disabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Don\u0027t trust submitted invoice number')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				function () {
				var _v8 = config.trustClientSubmittedLoadId;
				switch (_v8.$) {
					case 'Enabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Trust submitted load ID')
									])));
					case 'Disabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Don\u0027t trust submitted load ID')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				function () {
				var _v9 = config.trustClientSubmittedDebtor;
				switch (_v9.$) {
					case 'Enabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Trust submitted debtor')
									])));
					case 'Disabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Don\u0027t trust submitted debtor')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}(),
				function () {
				var _v10 = config.trustClientSubmittedAmount;
				switch (_v10.$) {
					case 'Enabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Trust submitted amount')
									])));
					case 'Disabled':
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Don\u0027t trust submitted amount')
									])));
					default:
						return $elm$core$Maybe$Nothing;
				}
			}()
			]));
};
var $author$project$Components$ClientDebtorConfigurationManager$configHasActiveRules = function (config) {
	return config.alwaysBlock || ((!_Utils_eq(config.rateConRequired, $author$project$Domain$RequirementSetting$Inherit)) || ((!_Utils_eq(config.bolRequired, $author$project$Domain$RequirementSetting$Inherit)) || ((!_Utils_eq(config.podRequired, $author$project$Domain$RequirementSetting$Inherit)) || ((!_Utils_eq(config.amountMatchRequirement, $author$project$Domain$AmountMatchRequirement$Inherit)) || ((!_Utils_eq(config.laneRateExceptionsMode, $author$project$Domain$LaneRateCheckSetting$Inherit)) || ((!_Utils_eq(config.factorDeliveryDateCheckDays, $author$project$Domain$DeliveryDateCheckSetting$Inherit)) || ((!_Utils_eq(config.invoiceAmountHistoryRuleMode, $author$project$Domain$InvoiceAmountHistoryCheckSetting$Inherit)) || ((!_Utils_eq(config.trustClientSubmittedInvoiceNumber, $author$project$Domain$TrustClientSubmittedSetting$Inherit)) || ((!_Utils_eq(config.trustClientSubmittedLoadId, $author$project$Domain$TrustClientSubmittedSetting$Inherit)) || ((!_Utils_eq(config.trustClientSubmittedDebtor, $author$project$Domain$TrustClientSubmittedSetting$Inherit)) || (!_Utils_eq(config.trustClientSubmittedAmount, $author$project$Domain$TrustClientSubmittedSetting$Inherit))))))))))));
};
var $author$project$Components$ClientDebtorConfigurationManager$viewActiveRules = function (config) {
	return $author$project$Components$ClientDebtorConfigurationManager$configHasActiveRules(config) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('client-debtor-config-manager__delete-modal__info-box')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('RULES THAT WILL BE REMOVED:')
							]))
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				$author$project$Components$ClientDebtorConfigurationManager$buildActiveRulesList(config))
			])) : $elm$html$Html$text('');
};
var $author$project$Components$ClientDebtorConfigurationManager$viewDeleteConfirmationModal = function (model) {
	var _v0 = model.confirmDeleteConfigId;
	if (_v0.$ === 'Just') {
		var configId = _v0.a;
		var _v1 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.id, configId);
				},
				model.configurations));
		if (_v1.$ === 'Just') {
			var config = _v1.a;
			return A2(
				$author$project$Components$Shared$ModalDialog$view,
				$author$project$Components$ClientDebtorConfigurationManager$HideDeleteConfirmation,
				{
					body: A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You are about to delete the configuration for '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(config.debtorName)
											])),
										$elm$html$Html$text('.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This action cannot be undone.')
									])),
								$author$project$Components$ClientDebtorConfigurationManager$viewActiveRules(config)
							])),
					confirm: $elm$core$Maybe$Just(
						{
							msg: $author$project$Components$ClientDebtorConfigurationManager$DeleteConfiguration(configId),
							text: 'Delete'
						}),
					dismissText: $elm$core$Maybe$Just('Cancel'),
					header: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Delete configuration?')
								]))),
					modalClassOverride: $elm$core$Maybe$Just('modal__medium-container client-debtor-config-manager__delete-modal'),
					performing: model.deletingConfiguration,
					performingText: $elm$core$Maybe$Just('Deleting...'),
					success: false,
					successText: $elm$core$Maybe$Nothing
				});
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$ClientDebtorConfigurationManager$view = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v2__theme')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-debtor-configurations')
						]),
					_List_fromArray(
						[
							function () {
							if (model.isLoading) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('loading')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Loading configurations...')
										]));
							} else {
								var _v0 = model.loadError;
								if (_v0.$ === 'Just') {
									var errorMsg = _v0.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('error')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(errorMsg)
											]));
								} else {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A4($author$project$Components$ClientDebtorConfigurationManager$viewConfigurationList, false, data, model, model.configurations)
											]));
								}
							}
						}()
						])),
					$author$project$Components$ClientDebtorConfigurationManager$viewDeleteConfirmationModal(model)
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$UpdateAttemptToAutoProcess = function (a) {
	return {$: 'UpdateAttemptToAutoProcess', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateFactorSendCustomerInvoiceToCadence = function (a) {
	return {$: 'UpdateFactorSendCustomerInvoiceToCadence', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateRateConfirmationRequired = function (a) {
	return {$: 'UpdateRateConfirmationRequired', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateReceivablesInvoiceCustomer = function (a) {
	return {$: 'UpdateReceivablesInvoiceCustomer', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateSkipAutoStamp = function (a) {
	return {$: 'UpdateSkipAutoStamp', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdatepodRequired = function (a) {
	return {$: 'UpdatepodRequired', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$alwaysUseTmsPaymentAddress = function (settings) {
	return !settings.allowEditingCarrierPaymentStrategy;
};
var $author$project$Components$SettingsPage$CarrierLayout$isTriumphPay = function (carrier) {
	return carrier.paymentStrategy === 'triumphpay';
};
var $author$project$Components$SettingsPage$CarrierLayout$alwaysUseTmsPaymentTerms = function (settings) {
	return settings.carrierDaysToPayIntegration;
};
var $author$project$Components$SettingsPage$CarrierLayout$shouldShowPaymentTermsView = function (data) {
	return !$author$project$Components$SettingsPage$CarrierLayout$isTriumphPay(data.carrierData.carrier);
};
var $author$project$Components$SettingsPage$CarrierLayout$showIf = F2(
	function (check, html) {
		return check ? html : $elm$html$Html$text('');
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewSection = F2(
	function (headerText, body) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(headerText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-body')
						]),
					body)
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$paymentTermsView = F3(
	function (model, data, form) {
		return A2(
			$author$project$Components$SettingsPage$CarrierLayout$showIf,
			$author$project$Components$SettingsPage$CarrierLayout$shouldShowPaymentTermsView(data),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('payment-terms')
					]),
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$CarrierLayout$alwaysUseTmsPaymentTerms(data.accountSettings) ? A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Payment Terms',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Edit payment terms in your TMS')
									])),
								$elm$html$Html$text(
								'Net ' + $elm$core$String$fromInt(data.carrierData.carrier.effectiveDaysToPay))
							])) : A2(
						$author$project$Components$SettingsPage$Shared$EditSection$view,
						$author$project$Components$SettingsPage$CarrierLayout$paymentTermsConfig(model.carrierId),
						form.paymentTerms)
					])));
	});
var $author$project$Components$Shared$Radio$viewOne = F3(
	function (toMsg, current, _v0) {
		var name = _v0.a;
		var value = _v0.b;
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(value, current)),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed(
								toMsg(value)))
						]),
					_List_Nil),
					$elm$html$Html$text($author$project$Helpers$String$nbsp),
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Components$Shared$Radio$view = F3(
	function (toMsg, current, options) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Shared$Radio$viewOne, toMsg, current),
				options));
	});
var $author$project$Components$SettingsPage$CarrierLayout$maybeText = A2($elm$core$Basics$composeL, $elm$html$Html$text, $author$project$Components$SettingsPage$CarrierLayout$maybeString);
var $author$project$Components$SettingsPage$CarrierLayout$viewDetailTable = F2(
	function (carrier, showVendorId) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carrier-viewer__table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('MC#')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('SCAC')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('EIN')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('DOT#')
										])),
									showVendorId ? A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Vendor ID')
										])) : $elm$html$Html$text('')
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$SettingsPage$CarrierLayout$maybeText(carrier.mcNumber)
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$SettingsPage$CarrierLayout$maybeText(carrier.scac)
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$SettingsPage$CarrierLayout$maybeText(carrier.ein)
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$SettingsPage$CarrierLayout$maybeText(carrier.dotNumber)
										])),
									showVendorId ? A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$SettingsPage$CarrierLayout$maybeText(carrier.externalVendorId)
										])) : $elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewFeaturesForm = function (featureOverrides) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carrier-viewer__table enable_shared-ui-v3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Feature')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Default')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Override')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__theme')
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var dropdown = _v0.dropdown;
							var feature = _v0.feature;
							return A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(feature.label)
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												feature.enabledForAccount ? $elm$html$Html$text('On') : $elm$html$Html$text('Off')
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												A2(
													$elm$core$Basics$composeL,
													$author$project$Components$SettingsPage$CarrierLayout$FormMsg,
													$author$project$Components$SettingsPage$CarrierLayout$UpdateFeature(feature.id)),
												A2($author$project$Ui$V3$CustomSelect$view, dropdown, _List_Nil))
											]))
									]));
						},
						featureOverrides))
				]))
		]);
};
var $author$project$Components$SettingsPage$CarrierLayout$viewLeft = F3(
	function (model, data, form) {
		var paymentAddressSourceMsg = data.accountSettings.useTriumphPayCarrierRemitTo ? 'Payment address is managed by TriumphPay' : 'Edit payment address in your TMS';
		var carrier = data.carrierData.carrier;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$viewSection,
					'Details',
					_List_fromArray(
						[
							A2($author$project$Components$SettingsPage$CarrierLayout$viewDetailTable, carrier, data.accountSettings.showCarrierExternalVendorId)
						])),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$viewSection,
					'Main Address',
					_List_fromArray(
						[
							$author$project$Components$SettingsPage$CarrierLayout$viewAddress(carrier.address)
						])),
					$author$project$Components$SettingsPage$CarrierLayout$isTriumphPay(carrier) ? A2(
					$author$project$Components$SettingsPage$CarrierLayout$viewSection,
					'Payment',
					_List_fromArray(
						[
							$elm$html$Html$text('Pay via TriumphPay')
						])) : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Components$SettingsPage$CarrierLayout$paymentTermsView, model, data, form),
							A2(
							$author$project$Components$SettingsPage$CarrierLayout$showIf,
							$elm$core$List$length(data.accountSettings.carrierToleranceEnabledModes) > 0,
							A2(
								$author$project$Components$SettingsPage$Shared$EditSection$view,
								$author$project$Components$SettingsPage$CarrierLayout$invoiceToleranceConfig(model.carrierId),
								form.invoiceTolerance)),
							A2(
							$author$project$Components$SettingsPage$CarrierLayout$showIf,
							!data.accountSettings.quickpayDiscountDisabled,
							A2(
								$author$project$Components$SettingsPage$Shared$EditSection$view,
								$author$project$Components$SettingsPage$CarrierLayout$quickpayDiscountConfig(model.carrierId),
								form.quickpayDiscount)),
							$author$project$Components$SettingsPage$CarrierLayout$alwaysUseTmsPaymentAddress(data.accountSettings) ? A2(
							$author$project$Components$SettingsPage$CarrierLayout$viewSection,
							'Payment Address',
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(paymentAddressSourceMsg)
										])),
									$author$project$Components$SettingsPage$CarrierLayout$viewAddress(
									A2($elm$core$Maybe$withDefault, $author$project$Components$SettingsPage$CarrierLayout$blankAddress, carrier.paymentAddress))
								])) : A2(
							$author$project$Components$SettingsPage$Shared$EditSection$view,
							$author$project$Components$SettingsPage$CarrierLayout$paymentAddressConfig(model.carrierId),
							form.paymentAddress)
						])),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.accountSettings.attemptToAutoProcessDocumentBatches,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Auto-processing',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Attempt to auto-process document batches',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateAttemptToAutoProcess, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.attemptToAutoProcessDocumentBatches)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.factorAccount,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Rules',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Rate confirmation required',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateRateConfirmationRequired, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.rateConfirmationRequired),
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Proof of delivery required',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdatepodRequired, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.podRequired)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.receivablesAccount && data.account.factorAccount,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Invoicing',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Bill outside of TriumphPay Audit',
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$not,
									A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateReceivablesInvoiceCustomer, $author$project$Components$SettingsPage$CarrierLayout$FormMsg)),
								!carrier.receivablesInvoiceCustomer)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					!_Utils_eq(data.accountSettings.annotationAutoStampDocumentType, $elm$core$Maybe$Nothing),
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Auto-stamping',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Don\u0027t Auto Stamp documents for this client',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateSkipAutoStamp, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.skipAutoStamp)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.factorAccount && data.accountSettings.ableToGenerateCustomerInvoices,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Send Debtor Invoice to TMS',
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Radio$view,
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateFactorSendCustomerInvoiceToCadence, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.factorSendCustomerInvoiceToCadence,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'Yes',
										$elm$core$Maybe$Just(true)),
										_Utils_Tuple2(
										'No',
										$elm$core$Maybe$Just(false)),
										_Utils_Tuple2('Account Default', $elm$core$Maybe$Nothing)
									]))
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					!$elm$core$List$isEmpty(form.featureOverrides),
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Feature Overrides',
						$author$project$Components$SettingsPage$CarrierLayout$viewFeaturesForm(form.featureOverrides))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.currentUser.isAdmin,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$showIf,
						data.account.factorAccount,
						A2(
							$author$project$Components$SettingsPage$CarrierLayout$showIf,
							data.accountSettings.factorNextGenAuditEnabled,
							A2(
								$author$project$Components$SettingsPage$Shared$EditSection$view,
								$author$project$Components$SettingsPage$CarrierLayout$warnIfAmountOverConfig(model.carrierId),
								form.warnIfAmountOver))))
				]));
	});
var $author$project$Components$SettingsPage$Shared$Tolerance$toleranceValuesNotNegative = function (model) {
	return A2(
		$elm$core$List$all,
		function (value) {
			return _Utils_eq(
				$author$project$Domain$Tolerance$validateToleranceValue(value),
				$elm$core$Result$Ok(_Utils_Tuple0));
		},
		_List_fromArray(
			[model.amountAbove, model.amountBelow]));
};
var $author$project$Components$SettingsPage$Shared$Tolerance$formViewV3 = F2(
	function (set, model) {
		var modeInfoTextV3 = ($elm$core$List$length(model.enabledModeList) > 0) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Ui$V3$Typography$smallBodyClass]),
						_List_fromArray(
							[
								$elm$html$Html$text('Carrier specific tolerances apply to the following modes: '),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								A2($elm$core$String$join, ', ', model.enabledModeList)),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('')
							]))
					]))) : $elm$core$Maybe$Nothing;
		var labelPrefix = $author$project$Domain$Tolerance$toleranceUnitToSymbol(model.unit);
		var overrideContentV3 = model.overrideEnabled ? $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$author$project$Helpers$Html$labeledInput,
							'Type',
							A2(
								$author$project$Ui$V3$SimpleSelect$view,
								{
									onInput: function (unit) {
										return set(
											_Utils_update(
												model,
												{unit: unit}));
									},
									options: $author$project$AuditPb$allToleranceUnit,
									toLabel: $author$project$Components$SettingsPage$Shared$Tolerance$toleranceUnitDisplay,
									value: $elm$core$Maybe$Just(model.unit)
								},
								_List_Nil))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$author$project$Helpers$Html$labeledInput,
							'Lower tolerance',
							A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (amountBelow) {
										return set(
											_Utils_update(
												model,
												{amountBelow: amountBelow}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$leadingTextInBox(labelPrefix),
										$author$project$Ui$V3$Input$placeholder('0.00'),
										$author$project$Ui$V3$Input$validation(
										$author$project$Domain$Tolerance$validateToleranceValue(model.amountBelow))
									]),
								_List_Nil,
								model.amountBelow))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$author$project$Helpers$Html$labeledInput,
							'Upper tolerance',
							A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (amountAbove) {
										return set(
											_Utils_update(
												model,
												{amountAbove: amountAbove}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$leadingTextInBox(labelPrefix),
										$author$project$Ui$V3$Input$placeholder('0.00'),
										$author$project$Ui$V3$Input$validation(
										$author$project$Domain$Tolerance$validateToleranceValue(model.amountAbove))
									]),
								_List_Nil,
								model.amountAbove)))
					]))) : $elm$core$Maybe$Nothing;
		var isValid = (!($elm$core$String$isEmpty(model.amountAbove) || $elm$core$String$isEmpty(model.amountBelow))) && $author$project$Components$SettingsPage$Shared$Tolerance$toleranceValuesNotNegative(model);
		var enableOverrideV3 = $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$id('accountdefault'),
								$elm$html$Html$Attributes$checked(!model.overrideEnabled),
								$elm$html$Html$Events$onClick(
								set(
									_Utils_update(
										model,
										{overrideEnabled: false})))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('accountdefault')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Account default')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$id('overrideenabled'),
								$elm$html$Html$Attributes$checked(model.overrideEnabled),
								$elm$html$Html$Events$onClick(
								set(
									_Utils_update(
										model,
										{overrideEnabled: true})))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('overrideenabled')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.overrideTypeLabel)
							]))
					])));
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$Stack$viewVertMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
					]),
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$p,
							_List_fromArray(
								[$author$project$Ui$V3$Typography$smallBodyClass]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create exception if invoice amount outside indicated tolerance')
								]))),
						modeInfoTextV3,
						enableOverrideV3,
						overrideContentV3
					])),
			isValid);
	});
var $author$project$Components$SettingsPage$CarrierLayout$invoiceToleranceConfigV3Reskin = function (carrierId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Carriers$invoiceTolerance(carrierId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$Tolerance$formViewV3,
		summaryView: $author$project$Components$SettingsPage$Shared$Tolerance$summaryView,
		title: 'Invoice Tolerance',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateToleranceOverride)
	};
};
var $author$project$Components$SettingsPage$CarrierLayout$viewAddressInputV3Reskin = F4(
	function (labelText, onInput_, content, required) {
		var valid = function () {
			if (required) {
				if (content.$ === 'Just') {
					var c = content.a;
					return !$elm$core$String$isEmpty(c);
				} else {
					return false;
				}
			} else {
				return true;
			}
		}();
		var validation = valid ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err('Cannot be blank');
		return A4(
			$author$project$Ui$V3$Input$view,
			{onInput: onInput_},
			_List_fromArray(
				[
					$author$project$Ui$V3$Input$label(labelText),
					$author$project$Ui$V3$Input$validation(validation)
				]),
			_List_Nil,
			A2($elm$core$Maybe$withDefault, '', content));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewPaymentAddressFormV3Reskin = F2(
	function (edit, address) {
		var name = $elm$core$Maybe$Just(address.name);
		var valid = A2(
			$elm$core$List$all,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$SettingsPage$CarrierLayout$isBlank),
			_List_fromArray(
				[name, address.addressLine1, address.city, address.state, address.postalCode]));
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Components$SettingsPage$CarrierLayout$viewAddressInputV3Reskin,
						'Name',
						function (x) {
							return edit(
								_Utils_update(
									address,
									{name: x}));
						},
						name,
						true),
						A2(
						$author$project$Ui$V3$Stack$viewHorz,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Components$SettingsPage$CarrierLayout$viewAddressInputV3Reskin,
								'Line 1',
								function (x) {
									return edit(
										_Utils_update(
											address,
											{
												addressLine1: $elm$core$Maybe$Just(x)
											}));
								},
								address.addressLine1,
								true),
								A4(
								$author$project$Components$SettingsPage$CarrierLayout$viewAddressInputV3Reskin,
								'Line 2 (optional)',
								function (x) {
									return edit(
										_Utils_update(
											address,
											{
												addressLine2: $elm$core$Maybe$Just(x)
											}));
								},
								address.addressLine2,
								false)
							])),
						A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex5,
								A4(
									$author$project$Components$SettingsPage$CarrierLayout$viewAddressInputV3Reskin,
									'City',
									function (x) {
										return edit(
											_Utils_update(
												address,
												{
													city: $elm$core$Maybe$Just(x)
												}));
									},
									address.city,
									true)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex2,
								A4(
									$author$project$Components$SettingsPage$CarrierLayout$viewAddressInputV3Reskin,
									'State',
									function (x) {
										return edit(
											_Utils_update(
												address,
												{
													state: $elm$core$Maybe$Just(x)
												}));
									},
									address.state,
									true)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex3,
								A4(
									$author$project$Components$SettingsPage$CarrierLayout$viewAddressInputV3Reskin,
									'Postal Code',
									function (x) {
										return edit(
											_Utils_update(
												address,
												{
													postalCode: $elm$core$Maybe$Just(x)
												}));
									},
									address.postalCode,
									true))
							])),
						A4(
						$author$project$Components$SettingsPage$CarrierLayout$viewAddressInputV3Reskin,
						'Country (optional)',
						function (x) {
							return edit(
								_Utils_update(
									address,
									{
										country: $elm$core$Maybe$Just(x)
									}));
						},
						address.country,
						false)
					])),
			valid);
	});
var $author$project$Components$SettingsPage$CarrierLayout$paymentAddressConfigV3Reskin = function (carrierId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeL,
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
			$author$project$Api$Carriers$paymentAddress(carrierId)),
		formView: $author$project$Components$SettingsPage$CarrierLayout$viewPaymentAddressFormV3Reskin,
		summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewAddress,
		title: 'Payment address',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdatePaymentAddress)
	};
};
var $author$project$Components$SettingsPage$Shared$PaymentTerms$formViewV3Reskin = F2(
	function (set, model) {
		var isValid = $elm_community$result_extra$Result$Extra$isOk(model);
		return _Utils_Tuple2(
			A4(
				$author$project$Ui$V3$Input$view,
				{
					onInput: A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$Shared$PaymentTerms$ensurePositiveInteger)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$label('Payment terms'),
						$author$project$Ui$V3$Input$validation(
						A2(
							$elm$core$Result$mapError,
							$elm$core$Basics$always('Cannot be blank'),
							model)),
						$author$project$Ui$V3$Input$numberInput,
						$author$project$Ui$V3$Input$trailingTextInBox(
						{text: 'days', width: 64}),
						$author$project$Ui$V3$Input$width('160px')
					]),
				_List_Nil,
				$author$project$Components$SettingsPage$Shared$PaymentTerms$getString(model)),
			isValid);
	});
var $author$project$Components$SettingsPage$CarrierLayout$paymentTermsConfigV3Reskin = function (carrierId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
			$author$project$Api$Carriers$daysToPay(carrierId)),
		formView: $author$project$Components$SettingsPage$Shared$PaymentTerms$formViewV3Reskin,
		summaryView: $author$project$Components$SettingsPage$Shared$PaymentTerms$summaryView,
		title: 'Payment terms',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdatePaymentTerms)
	};
};
var $author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin = F2(
	function (headerText, body) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__type__h2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(headerText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__type__body')
						]),
					body)
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$paymentTermsViewV3Reskin = F3(
	function (model, data, form) {
		return $author$project$Components$SettingsPage$CarrierLayout$alwaysUseTmsPaymentTerms(data.accountSettings) ? A2(
			$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
			'Payment terms',
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Edit payment terms in your TMS')
								])),
							$elm$html$Html$text(
							'Net ' + $elm$core$String$fromInt(data.carrierData.carrier.effectiveDaysToPay))
						]))
				])) : A2(
			$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
			$author$project$Components$SettingsPage$CarrierLayout$paymentTermsConfigV3Reskin(model.carrierId),
			form.paymentTerms);
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewQuickpayDiscountFormV3Reskin = F2(
	function (edit, quickpayDiscount) {
		var validate = function (string) {
			return A2(
				$elm$core$Result$fromMaybe,
				'Cannot be blank',
				$elm$core$String$toFloat(string));
		};
		return _Utils_Tuple2(
			A4(
				$author$project$Ui$V3$Input$view,
				{
					onInput: A2($elm$core$Basics$composeL, edit, validate)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$label('QuickPay discount'),
						$author$project$Ui$V3$Input$validation(quickpayDiscount),
						$author$project$Ui$V3$Input$numberInput,
						$author$project$Ui$V3$Input$trailingTextInBox(
						{text: '%', width: 42}),
						$author$project$Ui$V3$Input$width('160px')
					]),
				_List_Nil,
				$elm_community$result_extra$Result$Extra$merge(
					A2($elm$core$Result$map, $elm$core$String$fromFloat, quickpayDiscount))),
			$elm_community$result_extra$Result$Extra$isOk(quickpayDiscount));
	});
var $author$project$Components$SettingsPage$CarrierLayout$quickpayDiscountConfigV3Reskin = function (carrierId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
			$author$project$Api$Carriers$quickpayDiscount(carrierId)),
		formView: $author$project$Components$SettingsPage$CarrierLayout$viewQuickpayDiscountFormV3Reskin,
		summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewQuickpayDiscountSummary,
		title: 'QuickPay discount',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateQuickpayDiscount)
	};
};
var $author$project$Components$SettingsPage$CarrierLayout$tableColumnHeading = $author$project$Ui$V3$Typography$xSmallBodySemiBold(_List_Nil);
var $author$project$Components$SettingsPage$CarrierLayout$viewDetailTableV3 = F2(
	function (carrier, showVendorId) {
		return A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.mcNumber;
									},
									$author$project$Components$SettingsPage$CarrierLayout$maybeText),
								heading: $author$project$Components$SettingsPage$CarrierLayout$tableColumnHeading('MC#')
							}),
							$elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.scac;
									},
									$author$project$Components$SettingsPage$CarrierLayout$maybeText),
								heading: $author$project$Components$SettingsPage$CarrierLayout$tableColumnHeading('SCAC')
							}),
							$elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ein;
									},
									$author$project$Components$SettingsPage$CarrierLayout$maybeText),
								heading: $author$project$Components$SettingsPage$CarrierLayout$tableColumnHeading('EIN')
							}),
							$elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dotNumber;
									},
									$author$project$Components$SettingsPage$CarrierLayout$maybeText),
								heading: $author$project$Components$SettingsPage$CarrierLayout$tableColumnHeading('DOT#')
							}),
							showVendorId ? $elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.externalVendorId;
									},
									$author$project$Components$SettingsPage$CarrierLayout$maybeText),
								heading: $author$project$Components$SettingsPage$CarrierLayout$tableColumnHeading('Vendor ID')
							}) : $elm$core$Maybe$Nothing
						]))
			},
			_List_Nil,
			_List_Nil,
			_List_fromArray(
				[carrier]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewLeftV3Reskin = F3(
	function (model, data, form) {
		var paymentAddressSourceMsg = data.accountSettings.useTriumphPayCarrierRemitTo ? 'Payment address is managed by TriumphPay' : 'Edit payment address in your TMS';
		var carrier = data.carrierData.carrier;
		var accountType = $author$project$Domain$Account$accountType(data.account);
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Details',
						_List_fromArray(
							[
								A2($author$project$Components$SettingsPage$CarrierLayout$viewDetailTableV3, carrier, data.accountSettings.showCarrierExternalVendorId)
							]))),
					$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Main address',
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$CarrierLayout$viewAddress(carrier.address)
							]))),
					$author$project$Components$SettingsPage$CarrierLayout$isTriumphPay(carrier) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Payment',
						_List_fromArray(
							[
								$elm$html$Html$text('Pay via TriumphPay')
							]))) : $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
							]),
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$CarrierLayout$shouldShowPaymentTermsView(data) ? $elm$core$Maybe$Just(
								A3($author$project$Components$SettingsPage$CarrierLayout$paymentTermsViewV3Reskin, model, data, form)) : $elm$core$Maybe$Nothing,
								($elm$core$List$length(data.accountSettings.carrierToleranceEnabledModes) > 0) ? $elm$core$Maybe$Just(
								A2(
									$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
									$author$project$Components$SettingsPage$CarrierLayout$invoiceToleranceConfigV3Reskin(model.carrierId),
									form.invoiceTolerance)) : $elm$core$Maybe$Nothing,
								(!data.accountSettings.quickpayDiscountDisabled) ? $elm$core$Maybe$Just(
								A2(
									$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
									$author$project$Components$SettingsPage$CarrierLayout$quickpayDiscountConfigV3Reskin(model.carrierId),
									form.quickpayDiscount)) : $elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(
								$author$project$Components$SettingsPage$CarrierLayout$alwaysUseTmsPaymentAddress(data.accountSettings) ? A2(
									$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
									'Payment address',
									_List_fromArray(
										[
											A2(
											$author$project$Ui$V3$Stack$viewVert,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(paymentAddressSourceMsg)
														])),
													$author$project$Components$SettingsPage$CarrierLayout$viewAddress(
													A2($elm$core$Maybe$withDefault, $author$project$Components$SettingsPage$CarrierLayout$blankAddress, carrier.paymentAddress))
												]))
										])) : A2(
									$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
									$author$project$Components$SettingsPage$CarrierLayout$paymentAddressConfigV3Reskin(model.carrierId),
									form.paymentAddress))
							]))),
					data.accountSettings.attemptToAutoProcessDocumentBatches ? $elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Auto-processing',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Attempt to auto-process document batches',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateAttemptToAutoProcess, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.attemptToAutoProcessDocumentBatches)
							]))) : $elm$core$Maybe$Nothing,
					data.account.factorAccount ? $elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Rules',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Rate confirmation required',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateRateConfirmationRequired, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.rateConfirmationRequired),
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Proof of delivery required',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdatepodRequired, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.podRequired)
							]))) : $elm$core$Maybe$Nothing,
					(data.account.receivablesAccount && data.account.factorAccount) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Invoicing',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Bill outside of TriumphPay Audit',
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$not,
									A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateReceivablesInvoiceCustomer, $author$project$Components$SettingsPage$CarrierLayout$FormMsg)),
								!carrier.receivablesInvoiceCustomer)
							]))) : $elm$core$Maybe$Nothing,
					(!_Utils_eq(data.accountSettings.annotationAutoStampDocumentType, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Auto-stamping',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Don\u0027t Auto Stamp documents for this client',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateSkipAutoStamp, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.skipAutoStamp)
							]))) : $elm$core$Maybe$Nothing,
					(data.account.factorAccount && data.accountSettings.ableToGenerateCustomerInvoices) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Send debtor invoice to TMS',
						_List_fromArray(
							[
								A3(
								$author$project$Components$Shared$Radio$view,
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateFactorSendCustomerInvoiceToCadence, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.factorSendCustomerInvoiceToCadence,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'Yes',
										$elm$core$Maybe$Just(true)),
										_Utils_Tuple2(
										'No',
										$elm$core$Maybe$Just(false)),
										_Utils_Tuple2('Account Default', $elm$core$Maybe$Nothing)
									]))
							]))) : $elm$core$Maybe$Nothing,
					(_Utils_eq(accountType, $author$project$Domain$Account$BrokerAccount) && data.accountSettings.tempAllowCarrierLevelImplicitInvoice) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
						$author$project$Components$SettingsPage$CarrierLayout$allowImplicitCarrierInvoiceConfigV3Reskin(model.carrierId),
						form.implicitInvoiceOverride)) : $elm$core$Maybe$Nothing,
					(!$elm$core$List$isEmpty(form.featureOverrides)) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Feature overrides',
						$author$project$Components$SettingsPage$CarrierLayout$viewFeaturesForm(form.featureOverrides))) : $elm$core$Maybe$Nothing
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$DeleteContact = function (a) {
	return {$: 'DeleteContact', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$GoTo = function (a) {
	return {$: 'GoTo', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$InviteContact = function (a) {
	return {$: 'InviteContact', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$SaveContactForm = {$: 'SaveContactForm'};
var $author$project$Components$SettingsPage$CarrierLayout$SetContactForm = function (a) {
	return {$: 'SetContactForm', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateTransportationClient = function (a) {
	return {$: 'UpdateTransportationClient', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$labelTypeDescription = function (account) {
	return account.factorAccount ? ('These labels are automatically assigned to ' + ($elm$core$String$toLower(
		$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount)) + 's either by external factoring software or by client type e.g. broker, and cannot be updated in TriumphPay Audit')) : 'These labels are set externally and cannot be updated in TriumphPay Audit';
};
var $author$project$Components$SettingsPage$CarrierLayout$labelTypeHeader = function (account) {
	return account.factorAccount ? 'Automatic Labels' : 'TMS Labels';
};
var $author$project$Components$SettingsPage$CarrierLayout$CustomerTypeaheadMsg = function (a) {
	return {$: 'CustomerTypeaheadMsg', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$DeleteExternalLogin = function (a) {
	return {$: 'DeleteExternalLogin', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$SaveExternalLoginForm = {$: 'SaveExternalLoginForm'};
var $author$project$Components$SettingsPage$CarrierLayout$SetExternalLoginForm = function (a) {
	return {$: 'SetExternalLoginForm', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$TestExternalLoginCredentials = {$: 'TestExternalLoginCredentials'};
var $author$project$Components$SettingsPage$CarrierLayout$UpdateScrapingEnabled = function (a) {
	return {$: 'UpdateScrapingEnabled', a: a};
};
var $author$project$Components$SettingsPage$CarrierLayout$viewCustomerTypeahead = F3(
	function (toMsg, typeaheadData, typeahead) {
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Customer'),
					A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('activity-filters-typeahead')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$CustomerTypeahead$view, typeaheadData, typeahead)
							])))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$scrapingViewParams = F3(
	function (model, data, _v0) {
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(data.account));
		var carrier = data.carrierData.carrier;
		return {
			account: data.account,
			accountSettings: data.accountSettings,
			carrier: carrier,
			carrierTerm: carrierTerm,
			customerTypeahead: A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v1, typeaheadData) {
							var typeahead = _v1.typeahead;
							return A3($author$project$Components$SettingsPage$CarrierLayout$viewCustomerTypeahead, $author$project$Components$SettingsPage$CarrierLayout$CustomerTypeaheadMsg, typeaheadData, typeahead);
						}),
					model.externalLoginForm,
					data.typeaheadData)),
			customerTypeaheadV3Reskin: A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, typeaheadData) {
							var typeaheadV3Reskin = _v2.typeaheadV3Reskin;
							return A2(
								$elm$html$Html$map,
								$author$project$Components$SettingsPage$CarrierLayout$CustomerTypeaheadMsgV3Reskin,
								A4(
									$author$project$Components$TmsCustomerDropdown$view,
									_List_fromArray(
										[
											$author$project$Ui$V3$CustomSelect$label('Customer name')
										]),
									data.accountSettings,
									typeaheadData,
									typeaheadV3Reskin));
						}),
					model.externalLoginForm,
					data.typeaheadDataV3Reskin)),
			customers: data.carrierData.externalLoginCustomers,
			externalLogins: data.externalLogins,
			form: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.form;
				},
				model.externalLoginForm),
			onDelete: $author$project$Components$SettingsPage$CarrierLayout$DeleteExternalLogin,
			onEdit: $author$project$Components$SettingsPage$CarrierLayout$SetExternalLoginForm,
			onSave: $author$project$Components$SettingsPage$CarrierLayout$SaveExternalLoginForm,
			onScrapingEnabled: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateScrapingEnabled),
			onTestCredentials: $author$project$Components$SettingsPage$CarrierLayout$TestExternalLoginCredentials,
			processingExternalLogin: model.processingExternalLogin,
			testCredentialsResult: model.testCredentialsResult,
			testingCredentials: model.testingCredentials
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$shouldShowVerifyPercentile = function (_v0) {
	var currentUser = _v0.currentUser;
	var carrierData = _v0.carrierData;
	var accountSettings = _v0.accountSettings;
	var account = _v0.account;
	return account.factorAccount && (accountSettings.verificationsWorkflowEnabled && (currentUser.isAdmin && ((!carrierData.carrier.excludeFromVerificationsWorkflow) && accountSettings.verificationsWorkflowEnableCarrierPercentileCheck)));
};
var $author$project$Helpers$String$appendIndefiniteArticle = function (string) {
	var isVowel = function (_char) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(_char),
			'aeiou');
	};
	return isVowel(
		A2($elm$core$String$left, 1, string)) ? A2($elm$core$String$append, 'an ', string) : A2($elm$core$String$append, 'a ', string);
};
var $author$project$Components$SettingsPage$Carriers$Contacts$viewMessage = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('alert-box--highlight')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('When you add a contact for '),
				$elm$html$Html$text(
				$author$project$Helpers$String$appendIndefiniteArticle(
					$elm$core$String$toLower(config.carrierTerm))),
				$elm$html$Html$text(', messages sent from that address will be'),
				$elm$html$Html$text(' automatically associated with the '),
				$elm$html$Html$text(
				$elm$core$String$toLower(config.carrierTerm)),
				$elm$html$Html$text('. You will also be able to easily send exceptions to contacts.')
			]));
};
var $author$project$Components$SettingsPage$Carriers$Contacts$blank = {admin: false, email: '', factorClientPortalEnabled: false, id: $author$project$Components$SettingsPage$Carriers$Contacts$newId, name: '', portalSubmissionStrategy: $author$project$Domain$TmsCarrier$PortalOnly, urlHash: ''};
var $author$project$Components$SettingsPage$Carriers$Contacts$empty = $elm$html$Html$text('');
var $author$project$Components$SettingsPage$Carriers$Contacts$edit = function (config) {
	return A2($elm$core$Basics$composeL, config.onEdit, $elm$core$Maybe$Just);
};
var $author$project$Components$SettingsPage$Carriers$Contacts$field = F3(
	function (type__, labelText, attrs) {
		var order = (type__ === 'checkbox') ? $elm$core$List$reverse : $elm$core$Basics$identity;
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			order(
				_List_fromArray(
					[
						$elm$html$Html$text(labelText),
						$elm$html$Html$text($author$project$Helpers$String$nbsp),
						A2(
						$elm$html$Html$input,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$type_(type__),
							attrs),
						_List_Nil)
					])));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$showIf = F2(
	function (check, html) {
		return check ? html : $author$project$Components$SettingsPage$Carriers$Contacts$empty;
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewForm = F2(
	function (config, contact) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-list__row__editing')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$SettingsPage$Carriers$Contacts$field,
					'text',
					'Name',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(contact.name),
							$elm$html$Html$Events$onInput(
							function (x) {
								return A2(
									$author$project$Components$SettingsPage$Carriers$Contacts$edit,
									config,
									_Utils_update(
										contact,
										{name: x}));
							})
						])),
					A3(
					$author$project$Components$SettingsPage$Carriers$Contacts$field,
					'email',
					'Email',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(contact.email),
							$elm$html$Html$Events$onInput(
							function (x) {
								return A2(
									$author$project$Components$SettingsPage$Carriers$Contacts$edit,
									config,
									_Utils_update(
										contact,
										{email: x}));
							})
						])),
					A2(
					$author$project$Components$SettingsPage$Carriers$Contacts$showIf,
					config.factorClientPortalEnabled,
					A3(
						$author$project$Components$SettingsPage$Carriers$Contacts$field,
						'checkbox',
						'Factor Client Portal Enabled',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$checked(contact.factorClientPortalEnabled),
								$elm$html$Html$Events$onCheck(
								function (x) {
									return A2(
										$author$project$Components$SettingsPage$Carriers$Contacts$edit,
										config,
										_Utils_update(
											contact,
											{factorClientPortalEnabled: x}));
								})
							]))),
					A2(
					$author$project$Components$SettingsPage$Carriers$Contacts$showIf,
					config.factorClientPortalEnabled && contact.factorClientPortalEnabled,
					A3(
						$author$project$Components$SettingsPage$Carriers$Contacts$field,
						'checkbox',
						'Portal Admin',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$checked(contact.admin),
								$elm$html$Html$Events$onCheck(
								function (x) {
									return A2(
										$author$project$Components$SettingsPage$Carriers$Contacts$edit,
										config,
										_Utils_update(
											contact,
											{admin: x}));
								})
							]))),
					$elm$core$String$isEmpty(contact.email) ? A2($author$project$Components$Shared$Button$disabled, 'Save', _List_Nil) : A3($author$project$Components$Shared$Button$confirm, 'Save', config.onSave, _List_Nil),
					$elm$html$Html$text(' - or - '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							config.onEdit($elm$core$Maybe$Nothing))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('cancel')
						]))
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewNewContact = function (config) {
	var _v0 = config.form;
	if (_v0.$ === 'Just') {
		var contact = _v0.a;
		return _Utils_eq(contact.id, $author$project$Components$SettingsPage$Carriers$Contacts$newId) ? A2($author$project$Components$SettingsPage$Carriers$Contacts$viewForm, config, contact) : $author$project$Components$SettingsPage$Carriers$Contacts$empty;
	} else {
		return A3(
			$author$project$Components$Shared$Button$confirm,
			'New Contact',
			config.onEdit(
				$elm$core$Maybe$Just($author$project$Components$SettingsPage$Carriers$Contacts$blank)),
			_List_Nil);
	}
};
var $author$project$Components$SettingsPage$Carriers$Contacts$viewAction = F3(
	function (title_, iconName, msg) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-list__action'),
					$elm$html$Html$Attributes$title(title_),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-' + iconName)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewContactSummary = function (contact) {
	return $elm$core$String$isEmpty(contact.name) ? contact.email : (contact.name + (' <' + (contact.email + '>')));
};
var $author$project$Components$SettingsPage$Carriers$Contacts$setting = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('contact-list__setting')
		]));
var $author$project$Components$SettingsPage$Carriers$Contacts$viewAdminBadge = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('alert-box info contact-list__admin')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Admin')
		]));
var $author$project$Components$SettingsPage$Carriers$Contacts$invitationButton = F2(
	function (config, contact) {
		var buttonText = 'Re-Send Portal Invite Email';
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-list__invite-button'),
					$elm$html$Html$Events$onClick(
					config.onInvite(contact))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewInvitationButtons = F2(
	function (config, contact) {
		return $author$project$Components$SettingsPage$Carriers$Contacts$setting(
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Carriers$Contacts$invitationButton, config, contact)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewPortalLink = function (hash) {
	var path = '/factor_client_portal/invoice_status/' + hash;
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(path)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Client portal')
			]));
};
var $author$project$Components$SettingsPage$Carriers$Contacts$viewPortalSettingsSummary = F2(
	function (config, contact) {
		return (!config.factorClientPortalEnabled) ? $author$project$Components$SettingsPage$Carriers$Contacts$empty : (contact.factorClientPortalEnabled ? $author$project$Components$SettingsPage$Carriers$Contacts$setting(
			_List_fromArray(
				[
					$author$project$Components$SettingsPage$Carriers$Contacts$viewPortalLink(contact.urlHash),
					A2($author$project$Components$SettingsPage$Carriers$Contacts$showIf, contact.admin, $author$project$Components$SettingsPage$Carriers$Contacts$viewAdminBadge),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$SettingsPage$Carriers$Contacts$viewInvitationButtons, config, contact)
						]))
				])) : $author$project$Components$SettingsPage$Carriers$Contacts$setting(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$em,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Client portal not enabled')
						]))
				])));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewSummary = F3(
	function (config, contact, actions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-list__card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('contact-list__row')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$SettingsPage$Carriers$Contacts$viewContactSummary(contact)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('contact-list__actions')
								]),
							actions)
						])),
					A2($author$project$Components$SettingsPage$Carriers$Contacts$viewPortalSettingsSummary, config, contact)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewRow = F2(
	function (config, contact) {
		var _v0 = config.form;
		if (_v0.$ === 'Nothing') {
			return A3(
				$author$project$Components$SettingsPage$Carriers$Contacts$viewSummary,
				config,
				contact,
				_List_fromArray(
					[
						A3(
						$author$project$Components$SettingsPage$Carriers$Contacts$viewAction,
						'Edit',
						'pencil',
						config.onEdit(
							$elm$core$Maybe$Just(contact))),
						A3(
						$author$project$Components$SettingsPage$Carriers$Contacts$viewAction,
						'Delete',
						'trash',
						config.onDelete(contact.id))
					]));
		} else {
			var editing = _v0.a;
			return (!_Utils_eq(editing.id, contact.id)) ? A3($author$project$Components$SettingsPage$Carriers$Contacts$viewSummary, config, contact, _List_Nil) : A2($author$project$Components$SettingsPage$Carriers$Contacts$viewForm, config, editing);
		}
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$view = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Contacts')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-body')
					]),
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$Carriers$Contacts$viewMessage(config),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('contact-list__list')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$SettingsPage$Carriers$Contacts$viewRow(config),
							config.carrier.contacts)),
						$author$project$Components$SettingsPage$Carriers$Contacts$viewNewContact(config)
					]))
			]));
};
var $author$project$Components$SettingsPage$Carriers$Scraping$alertBox = function (message) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('alert-box--highlight')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(message)
			]));
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewCheckbox = F3(
	function (labelText, onCheck_, checked_) {
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(checked_),
							$elm$html$Html$Events$onCheck(onCheck_)
						]),
					_List_Nil),
					$elm$html$Html$text($author$project$Helpers$String$nbsp),
					$elm$html$Html$text(labelText)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$HideCustomer = {$: 'HideCustomer'};
var $author$project$Components$SettingsPage$Carriers$Scraping$ShowCustomer = {$: 'ShowCustomer'};
var $author$project$Components$SettingsPage$Carriers$Scraping$credentialsRequired = function (carrier) {
	return (!_Utils_eq(carrier.scrapingDocumentsAuthRequirement, $author$project$AuditPb$ScraperAuthRequirementNone)) || (!_Utils_eq(carrier.scrapingInvoiceAuthRequirement, $author$project$AuditPb$ScraperAuthRequirementNone));
};
var $author$project$Components$SettingsPage$Carriers$Scraping$Form = F2(
	function (login, useCustomer) {
		return {login: login, useCustomer: useCustomer};
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$empty = $elm$html$Html$text('');
var $author$project$Components$SettingsPage$Carriers$Scraping$hasMaybe = function (x) {
	if (x.$ === 'Nothing') {
		return false;
	} else {
		if (x.a === '') {
			return false;
		} else {
			return true;
		}
	}
};
var $author$project$Components$SettingsPage$Carriers$Scraping$maybeString = $elm$core$Maybe$withDefault('');
var $author$project$Components$SettingsPage$Carriers$Scraping$loginScrapesService = F2(
	function (scrapingServices, service) {
		return A2($elm$core$List$member, service, scrapingServices);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$authTypeRequiresLoginForService = F4(
	function (scrapingServices, carrier, authRequirement, service) {
		var requirement = _Utils_eq(service, $author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs) ? carrier.scrapingDocumentsAuthRequirement : carrier.scrapingInvoiceAuthRequirement;
		var serviceRequiresAuth = A2(
			$elm$core$List$member,
			requirement,
			_List_fromArray(
				[authRequirement, $author$project$AuditPb$ScraperAuthRequirementUsernamePasswordAndToken]));
		return A2($author$project$Components$SettingsPage$Carriers$Scraping$loginScrapesService, scrapingServices, service) && serviceRequiresAuth;
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$authTypeRequiresLogin = F3(
	function (scrapingServices, carrier, authRequirement) {
		return A4($author$project$Components$SettingsPage$Carriers$Scraping$authTypeRequiresLoginForService, scrapingServices, carrier, authRequirement, $author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs) || A4($author$project$Components$SettingsPage$Carriers$Scraping$authTypeRequiresLoginForService, scrapingServices, carrier, authRequirement, $author$project$AuditPb$ScrapingServiceScrAPINgServiceInvoices);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$requiresToken = F2(
	function (scrapingServices, carrier) {
		return A3($author$project$Components$SettingsPage$Carriers$Scraping$authTypeRequiresLogin, scrapingServices, carrier, $author$project$AuditPb$ScraperAuthRequirementToken);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$authenticatedServicesForScraper = F3(
	function (scrapingServices, carrier, authType) {
		return A2(
			$elm$core$List$filter,
			function (service) {
				return A4($author$project$Components$SettingsPage$Carriers$Scraping$authTypeRequiresLoginForService, scrapingServices, carrier, authType, service);
			},
			scrapingServices);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$nameForService = function (service) {
	if (service.$ === 'ScrapingServiceScrAPINgServiceDocs') {
		return 'Scraping Documents';
	} else {
		return 'Scraping Invoice';
	}
};
var $author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLogin = F3(
	function (scrapingServices, carrier, authType) {
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Components$SettingsPage$Carriers$Scraping$nameForService,
				A3($author$project$Components$SettingsPage$Carriers$Scraping$authenticatedServicesForScraper, scrapingServices, carrier, authType)));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewInput = F4(
	function (type__, labelText, value_, onInput_) {
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(labelText),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_(type__),
							$elm$html$Html$Attributes$value(value_),
							$elm$html$Html$Events$onInput(onInput_)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewTokenInput = F3(
	function (config, useCustomer, login) {
		return A2($author$project$Components$SettingsPage$Carriers$Scraping$requiresToken, login.scrapingServices, config.carrier) ? _Utils_Tuple2(
			$author$project$Components$SettingsPage$Carriers$Scraping$hasMaybe(login.token),
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3($author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLogin, login.scrapingServices, config.carrier, $author$project$AuditPb$ScraperAuthRequirementToken)),
						A4(
						$author$project$Components$SettingsPage$Carriers$Scraping$viewInput,
						'text',
						'Token',
						$author$project$Components$SettingsPage$Carriers$Scraping$maybeString(login.token),
						function (x) {
							return config.onEdit(
								$elm$core$Maybe$Just(
									A2(
										$author$project$Components$SettingsPage$Carriers$Scraping$Form,
										_Utils_update(
											login,
											{
												markLoginFailed: false,
												token: $elm$core$Maybe$Just(x)
											}),
										useCustomer)));
						})
					]))) : _Utils_Tuple2(true, $author$project$Components$SettingsPage$Carriers$Scraping$empty);
	});
var $author$project$Api$Carriers$ExternalLogins$Dirty = function (a) {
	return {$: 'Dirty', a: a};
};
var $author$project$Components$SettingsPage$Carriers$Scraping$hasPassword = function (password) {
	switch (password.$) {
		case 'Absent':
			return false;
		case 'Present':
			return true;
		default:
			if (password.a === '') {
				return false;
			} else {
				return true;
			}
	}
};
var $author$project$Components$SettingsPage$Carriers$Scraping$passwordValue = function (password) {
	switch (password.$) {
		case 'Present':
			return 'password';
		case 'Absent':
			return '';
		default:
			var x = password.a;
			return x;
	}
};
var $author$project$Components$SettingsPage$Carriers$Scraping$requiresUsernamePassword = F2(
	function (scrapingServices, carrier) {
		return A3($author$project$Components$SettingsPage$Carriers$Scraping$authTypeRequiresLogin, scrapingServices, carrier, $author$project$AuditPb$ScraperAuthRequirementUsernamePassword);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewUsernamePasswordInput = F3(
	function (config, useCustomer, login) {
		return A2($author$project$Components$SettingsPage$Carriers$Scraping$requiresUsernamePassword, login.scrapingServices, config.carrier) ? _Utils_Tuple2(
			$author$project$Components$SettingsPage$Carriers$Scraping$hasMaybe(login.user) && $author$project$Components$SettingsPage$Carriers$Scraping$hasPassword(login.password),
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3($author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLogin, login.scrapingServices, config.carrier, $author$project$AuditPb$ScraperAuthRequirementUsernamePassword)),
						A4(
						$author$project$Components$SettingsPage$Carriers$Scraping$viewInput,
						'text',
						'User',
						$author$project$Components$SettingsPage$Carriers$Scraping$maybeString(login.user),
						function (x) {
							return config.onEdit(
								$elm$core$Maybe$Just(
									A2(
										$author$project$Components$SettingsPage$Carriers$Scraping$Form,
										_Utils_update(
											login,
											{
												markLoginFailed: false,
												user: $elm$core$Maybe$Just(x)
											}),
										useCustomer)));
						}),
						A4(
						$author$project$Components$SettingsPage$Carriers$Scraping$viewInput,
						'password',
						'Password',
						$author$project$Components$SettingsPage$Carriers$Scraping$passwordValue(login.password),
						function (x) {
							return config.onEdit(
								$elm$core$Maybe$Just(
									A2(
										$author$project$Components$SettingsPage$Carriers$Scraping$Form,
										_Utils_update(
											login,
											{
												markLoginFailed: false,
												password: $author$project$Api$Carriers$ExternalLogins$Dirty(x)
											}),
										useCustomer)));
						})
					]))) : _Utils_Tuple2(true, $author$project$Components$SettingsPage$Carriers$Scraping$empty);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$credentialInputs = F3(
	function (config, useCustomer, login) {
		var _v0 = A3($author$project$Components$SettingsPage$Carriers$Scraping$viewUsernamePasswordInput, config, useCustomer, login);
		var usernamePasswordValid = _v0.a;
		var usernamePasswordInput = _v0.b;
		var _v1 = A3($author$project$Components$SettingsPage$Carriers$Scraping$viewTokenInput, config, useCustomer, login);
		var tokenValid = _v1.a;
		var tokenInput = _v1.b;
		return _Utils_Tuple2(
			usernamePasswordValid && tokenValid,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[usernamePasswordInput, tokenInput])));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewCustomerTypeahead = F3(
	function (config, useCustomer, login) {
		if (useCustomer.$ === 'HideCustomer') {
			return _Utils_Tuple2(true, $author$project$Components$SettingsPage$Carriers$Scraping$empty);
		} else {
			return _Utils_Tuple2(
				!_Utils_eq(login.customerId, $elm$core$Maybe$Nothing),
				config.customerTypeahead);
		}
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewServicesInput = F5(
	function (config, useCustomer, login, serviceConstant, serviceLabel) {
		var onCheck = function (checked_) {
			return checked_ ? config.onEdit(
				$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$Carriers$Scraping$Form,
						_Utils_update(
							login,
							{
								scrapingServices: A2($elm$core$List$cons, serviceConstant, login.scrapingServices)
							}),
						useCustomer))) : config.onEdit(
				$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$Carriers$Scraping$Form,
						_Utils_update(
							login,
							{
								scrapingServices: A2(
									$elm$core$List$filter,
									function (x) {
										return !_Utils_eq(x, serviceConstant);
									},
									login.scrapingServices)
							}),
						useCustomer)));
		};
		return A3(
			$author$project$Components$SettingsPage$Carriers$Scraping$viewCheckbox,
			serviceLabel,
			onCheck,
			A2($author$project$Components$SettingsPage$Carriers$Scraping$loginScrapesService, login.scrapingServices, serviceConstant));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewTestCredentialsResult = function (config) {
	var _v0 = config.testCredentialsResult;
	switch (_v0.$) {
		case 'NotTested':
			return $author$project$Components$SettingsPage$Carriers$Scraping$empty;
		case 'TestSuccess':
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'green'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('✓ Credentials are valid')
					]));
		default:
			var message = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'red'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('✗ ' + message)
					]));
	}
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewForm = F3(
	function (config, useCustomer, login) {
		var servicesValid = !$elm$core$List$isEmpty(login.scrapingServices);
		var servicesInputInvoice = config.carrier.supportsScrapingInvoice ? A5($author$project$Components$SettingsPage$Carriers$Scraping$viewServicesInput, config, useCustomer, login, $author$project$AuditPb$ScrapingServiceScrAPINgServiceInvoices, 'Use for scraping invoice amounts') : $author$project$Components$SettingsPage$Carriers$Scraping$empty;
		var servicesInputDocs = _Utils_eq(config.carrier.scrapingDocumentsAuthRequirement, $author$project$AuditPb$ScraperAuthRequirementNone) ? $author$project$Components$SettingsPage$Carriers$Scraping$empty : A5($author$project$Components$SettingsPage$Carriers$Scraping$viewServicesInput, config, useCustomer, login, $author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs, 'Use for scraping documents');
		var _v0 = A3($author$project$Components$SettingsPage$Carriers$Scraping$viewCustomerTypeahead, config, useCustomer, login);
		var customerValid = _v0.a;
		var customerInput = _v0.b;
		var _v1 = A3($author$project$Components$SettingsPage$Carriers$Scraping$credentialInputs, config, useCustomer, login);
		var credentialInputsValid = _v1.a;
		var credentialInput = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('login-list__credentials-edit')
				]),
			_List_fromArray(
				[
					function () {
					var _v2 = config.carrier.setupHelpText;
					if (_v2.$ === 'Nothing') {
						return $author$project$Components$SettingsPage$Carriers$Scraping$empty;
					} else {
						var x = _v2.a;
						return $author$project$Components$SettingsPage$Carriers$Scraping$alertBox(x);
					}
				}(),
					servicesInputDocs,
					servicesInputInvoice,
					credentialInput,
					customerInput,
					$author$project$Components$SettingsPage$Carriers$Scraping$viewTestCredentialsResult(config),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center')
						]),
					_List_fromArray(
						[
							config.carrier.supportsCredentialTesting ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
									A2($elm$html$Html$Attributes$style, 'gap', '8px')
								]),
							_List_fromArray(
								[
									config.testingCredentials ? A2($author$project$Components$Shared$Button$disabled, 'Testing...', _List_Nil) : ((credentialInputsValid && (customerValid && servicesValid)) ? A3(
									$author$project$Components$Shared$Button$enabled,
									'Test Credentials',
									config.onTestCredentials,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button--secondary')
										])) : A2($author$project$Components$Shared$Button$disabled, 'Test Credentials', _List_Nil)),
									(!config.testingCredentials) ? A3(
									$author$project$Ui$V3$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$AboveDirection)
										]),
									'Test if credentials are valid',
									A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$infoOutline16)) : $author$project$Components$SettingsPage$Carriers$Scraping$empty
								])) : $author$project$Components$SettingsPage$Carriers$Scraping$empty,
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									(credentialInputsValid && (customerValid && servicesValid)) ? A3($author$project$Components$Shared$Button$enabled, 'Save', config.onSave, _List_Nil) : A2($author$project$Components$Shared$Button$disabled, 'Save', _List_Nil),
									$elm$html$Html$text($author$project$Helpers$String$nbsp),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											config.onEdit($elm$core$Maybe$Nothing))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('cancel')
										]))
								]))
						]))
				]));
	});
var $author$project$Api$Carriers$ExternalLogins$Absent = {$: 'Absent'};
var $author$project$Api$Carriers$ExternalLogins$Present = {$: 'Present'};
var $author$project$Components$SettingsPage$Carriers$Scraping$presentOrAbsent = function (check) {
	return check ? $author$project$Api$Carriers$ExternalLogins$Present : $author$project$Api$Carriers$ExternalLogins$Absent;
};
var $author$project$Components$SettingsPage$Carriers$Scraping$externalLoginFormFromProto = function (login) {
	return {
		customerId: login.tmsCustomerId,
		id: login.id,
		markLoginFailed: false,
		password: $author$project$Components$SettingsPage$Carriers$Scraping$presentOrAbsent(login.passwordPresent),
		scrapingServices: login.scrapingServices,
		token: login.token,
		user: login.user
	};
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewAction = F2(
	function (icon, msg) {
		var clickConfig = $elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: false, stopPropagation: true});
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('login-list__action'),
					A2($elm$html$Html$Events$custom, 'click', clickConfig)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-' + icon)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewWithCustomerName = F3(
	function (id, value, customers) {
		var credential = A2($elm$core$Maybe$withDefault, 'Please add credentials', value);
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($elm$core$Dict$get, x, customers);
			},
			A2($elm$core$Maybe$map, $author$project$Domain$TmsCustomerId$toInt, id));
		if (_v0.$ === 'Nothing') {
			return A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(credential)
					]));
		} else {
			var name = _v0.a.name;
			return A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name + (' <' + (credential + '>')))
					]));
		}
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewToken = F3(
	function (carrier, customers, login) {
		return (!A2($author$project$Components$SettingsPage$Carriers$Scraping$requiresToken, login.scrapingServices, carrier)) ? $author$project$Components$SettingsPage$Carriers$Scraping$empty : A3($author$project$Components$SettingsPage$Carriers$Scraping$viewWithCustomerName, login.customerId, login.token, customers);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewUsername = F3(
	function (carrier, customers, login) {
		return (!A2($author$project$Components$SettingsPage$Carriers$Scraping$requiresUsernamePassword, login.scrapingServices, carrier)) ? $author$project$Components$SettingsPage$Carriers$Scraping$empty : A3($author$project$Components$SettingsPage$Carriers$Scraping$viewWithCustomerName, login.customerId, login.user, customers);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewLoginSummary = F3(
	function (config, useCustomer, login) {
		var externalLoginForm = $author$project$Components$SettingsPage$Carriers$Scraping$externalLoginFormFromProto(login);
		var editLogin = config.onEdit(
			$elm$core$Maybe$Just(
				A2($author$project$Components$SettingsPage$Carriers$Scraping$Form, externalLoginForm, useCustomer)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('login-list__row'),
					$elm$html$Html$Events$onClick(editLogin)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLogin, login.scrapingServices, config.carrier, $author$project$AuditPb$ScraperAuthRequirementUsernamePassword))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLogin, login.scrapingServices, config.carrier, $author$project$AuditPb$ScraperAuthRequirementToken))
						])),
					A3($author$project$Components$SettingsPage$Carriers$Scraping$viewToken, config.carrier, config.customers, externalLoginForm),
					A3($author$project$Components$SettingsPage$Carriers$Scraping$viewUsername, config.carrier, config.customers, externalLoginForm),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('login-list__actions')
						]),
					_List_fromArray(
						[
							(!_Utils_eq(login.loginFailureDetectedAt, $elm$core$Maybe$Nothing)) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
									A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
								]),
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$error16),
									A2(
									$author$project$Ui$V3$Typography$xSmallBody,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'margin-left', '4px'),
											A2(
											$elm$html$Html$Attributes$style,
											'color',
											$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Red700))
										]),
									'Login Failed')
								])) : $author$project$Components$SettingsPage$Carriers$Scraping$empty,
							A2($author$project$Components$SettingsPage$Carriers$Scraping$viewAction, 'pencil', editLogin),
							A2(
							$author$project$Components$SettingsPage$Carriers$Scraping$viewAction,
							'trash',
							config.onDelete(login.id))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewLoginList = F3(
	function (config, useCustomer, logins) {
		var row = function (x) {
			var _v0 = config.form;
			if (_v0.$ === 'Just') {
				var form = _v0.a;
				return _Utils_eq(x.id, form.login.id) ? A3($author$project$Components$SettingsPage$Carriers$Scraping$viewForm, config, useCustomer, form.login) : A3($author$project$Components$SettingsPage$Carriers$Scraping$viewLoginSummary, config, useCustomer, x);
			} else {
				return A3($author$project$Components$SettingsPage$Carriers$Scraping$viewLoginSummary, config, useCustomer, x);
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('login-list__list')
				]),
			A2($elm$core$List$map, row, logins));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$blankLogin = function (supportsInvoice) {
	var services = supportsInvoice ? _List_fromArray(
		[$author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs, $author$project$AuditPb$ScrapingServiceScrAPINgServiceInvoices]) : _List_fromArray(
		[$author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs]);
	return {customerId: $elm$core$Maybe$Nothing, id: $author$project$Domain$ExternalLoginId$dummyId, markLoginFailed: false, password: $author$project$Api$Carriers$ExternalLogins$Absent, scrapingServices: services, token: $elm$core$Maybe$Nothing, user: $elm$core$Maybe$Nothing};
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewNewLogin = F3(
	function (config, modifier, useCustomer) {
		var _v0 = config.form;
		if (_v0.$ === 'Just') {
			var form = _v0.a;
			return (_Utils_eq(form.login.id, $author$project$Domain$ExternalLoginId$dummyId) && _Utils_eq(form.useCustomer, useCustomer)) ? A3($author$project$Components$SettingsPage$Carriers$Scraping$viewForm, config, useCustomer, form.login) : $author$project$Components$SettingsPage$Carriers$Scraping$empty;
		} else {
			return A3(
				$author$project$Components$Shared$Button$confirm,
				'New ' + (modifier + ' Login'),
				config.onEdit(
					$elm$core$Maybe$Just(
						A2(
							$author$project$Components$SettingsPage$Carriers$Scraping$Form,
							$author$project$Components$SettingsPage$Carriers$Scraping$blankLogin(config.carrier.supportsScrapingInvoice),
							useCustomer))),
				_List_Nil);
		}
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewSection = F4(
	function (config, modifier, useCustomer, filter) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(modifier + ' Credentials')
						])),
					A3(
					$author$project$Components$SettingsPage$Carriers$Scraping$viewLoginList,
					config,
					useCustomer,
					A2($elm$core$List$filter, filter, config.externalLogins)),
					A3($author$project$Components$SettingsPage$Carriers$Scraping$viewNewLogin, config, modifier, useCustomer)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewCredentials = function (config) {
	return (!$author$project$Components$SettingsPage$Carriers$Scraping$credentialsRequired(config.carrier)) ? _List_fromArray(
		[
			$author$project$Components$SettingsPage$Carriers$Scraping$alertBox(
			'Credentials are not required to automatically retrieve documents for this ' + ($elm$core$String$toLower(config.carrierTerm) + '.'))
		]) : _List_fromArray(
		[
			A4(
			$author$project$Components$SettingsPage$Carriers$Scraping$viewSection,
			config,
			'',
			$author$project$Components$SettingsPage$Carriers$Scraping$HideCustomer,
			function (x) {
				return _Utils_eq(x.tmsCustomerId, $elm$core$Maybe$Nothing);
			}),
			A4(
			$author$project$Components$SettingsPage$Carriers$Scraping$viewSection,
			config,
			'Customer-Specific',
			$author$project$Components$SettingsPage$Carriers$Scraping$ShowCustomer,
			function (x) {
				return !_Utils_eq(x.tmsCustomerId, $elm$core$Maybe$Nothing);
			})
		]);
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewDocumentTypeList = function (config) {
	var item = function (type_) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Domain$Helpers$documentTypeToString, config.account, config.accountSettings, type_))
				]));
	};
	return A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2($elm$core$List$map, item, config.carrier.documentTypesRetrieved));
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewSupportsScrapingInvoice = function (config) {
	var supportedString = config.carrier.supportsScrapingInvoice ? 'Yes' : 'No';
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h6,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Supports Scraping Invoice Amounts?')
					])),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(supportedString)
					]))
			]));
};
var $author$project$Components$SettingsPage$Carriers$Scraping$view = function (config) {
	return (!config.carrier.scraperAvailable) ? $author$project$Components$SettingsPage$Carriers$Scraping$alertBox(
		'Automatic retrieval is not available for this ' + ($elm$core$String$toLower(config.carrierTerm) + '.')) : A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			A3(
				$author$project$Components$SettingsPage$Carriers$Scraping$viewCheckbox,
				'Enabled for this ' + $elm$core$String$toLower(config.carrierTerm),
				config.onScrapingEnabled,
				config.carrier.scrapingEnabled),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h6,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Document Types Available')
						])),
				A2(
					$elm$core$List$cons,
					$author$project$Components$SettingsPage$Carriers$Scraping$viewDocumentTypeList(config),
					A2(
						$elm$core$List$cons,
						$author$project$Components$SettingsPage$Carriers$Scraping$viewSupportsScrapingInvoice(config),
						$author$project$Components$SettingsPage$Carriers$Scraping$viewCredentials(config))))));
};
var $author$project$Components$SettingsPage$CarrierLayout$viewDocumentsLinkV3Reskin = F3(
	function (carrierTerm, toMsg, url) {
		return A4(
			$author$project$Helpers$GenericLink$genericLink,
			toMsg(url),
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')
				]),
			url,
			_List_fromArray(
				[
					$elm$html$Html$text('View ' + (carrierTerm + ' Documents'))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$ShowPortalWarning = {$: 'ShowPortalWarning'};
var $author$project$Components$SettingsPage$CarrierLayout$viewFactorClientPortalEnabler = function (isEnabled) {
	return A3(
		$author$project$Components$Shared$Button$confirm,
		$author$project$Components$SettingsPage$CarrierLayout$enableActionString(isEnabled),
		$author$project$Components$SettingsPage$CarrierLayout$ShowPortalWarning,
		_List_Nil);
};
var $author$project$Components$SettingsPage$CarrierLayout$viewRight = F3(
	function (model, data, form) {
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(data.account));
		var carrier = data.carrierData.carrier;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$SettingsPage$Carriers$Contacts$view(
					{carrier: carrier, carrierTerm: carrierTerm, factorClientPortalEnabled: data.account.factorAccount && (data.accountSettings.factorClientPortalEnabled && carrier.factorClientPortalEnabled), form: model.contactForm, onDelete: $author$project$Components$SettingsPage$CarrierLayout$DeleteContact, onEdit: $author$project$Components$SettingsPage$CarrierLayout$SetContactForm, onInvite: $author$project$Components$SettingsPage$CarrierLayout$InviteContact, onSave: $author$project$Components$SettingsPage$CarrierLayout$SaveContactForm}),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.factorAccount && data.accountSettings.noaManagementEnabled,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'NOAs',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Attributes$href(
										$author$project$Path$toString(
											A2(
												$author$project$Path$noaManagementSent,
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(model.carrierId))))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('View sent NOAs')
									]))
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.scraperAccount,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Automatic Document Retrieval',
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$Carriers$Scraping$view(
								A3($author$project$Components$SettingsPage$CarrierLayout$scrapingViewParams, model, data, form))
							]))),
					A2(
					$author$project$Components$SettingsPage$Shared$EditSection$view,
					A2($author$project$Components$SettingsPage$CarrierLayout$labelsConfig, model.carrierId, data.accountSettings),
					form.labels),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					!$elm$core$Set$isEmpty(carrier.externalLabels),
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						$author$project$Components$SettingsPage$CarrierLayout$labelTypeHeader(data.account),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
										A2($elm$html$Html$Attributes$style, 'font-style', 'italic')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Components$SettingsPage$CarrierLayout$labelTypeDescription(data.account))
									])),
								$author$project$Components$SettingsPage$CarrierLayout$viewLabelsSummary(carrier.externalLabels)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.factorAccount,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Client Type',
						_List_fromArray(
							[
								A3(
								$author$project$Components$SettingsPage$CarrierLayout$viewCheckbox,
								'Transportation Client',
								A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateTransportationClient, $author$project$Components$SettingsPage$CarrierLayout$FormMsg),
								carrier.transportationClient)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.accountSettings.carrierDocumentsAccount,
					A3(
						$author$project$Components$SettingsPage$CarrierLayout$viewDocumentsLinkV3Reskin,
						carrierTerm,
						$author$project$Components$SettingsPage$CarrierLayout$GoTo,
						$author$project$Path$toString(
							$author$project$Path$settingsEditCarrierDocuments(model.carrierId)))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.factorAccount && data.currentUser.isAdmin,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSection,
						'Client Portal',
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$CarrierLayout$viewFactorClientPortalEnabler(carrier.factorClientPortalEnabled)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					$author$project$Components$SettingsPage$CarrierLayout$shouldShowVerifyPercentile(data),
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$view,
						$author$project$Components$SettingsPage$CarrierLayout$verifyPercentileConfig(model.carrierId),
						form.verifyPercentile)),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.factorAccount && data.currentUser.hasSettingsRole,
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$view,
						A2($author$project$Components$SettingsPage$CarrierLayout$invoiceNumberStrategyConfig, data.accountSettings, model.carrierId),
						form.invoiceNumberStrategy)),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.account.factorAccount && data.currentUser.hasSettingsRole,
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$view,
						A2($author$project$Components$SettingsPage$CarrierLayout$autoGenerateInvoiceNumbersConfig, data.accountSettings, model.carrierId),
						form.autoGenerateInvoiceNumbers)),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$showIf,
					data.currentUser.isAdmin,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$showIf,
						data.account.factorAccount,
						A2(
							$author$project$Components$SettingsPage$CarrierLayout$showIf,
							data.accountSettings.factorNextGenAuditEnabled,
							A2(
								$author$project$Components$SettingsPage$Shared$EditSection$view,
								A2($author$project$Components$SettingsPage$CarrierLayout$manualReviewPercentageConfig, data.accountSettings, model.carrierId),
								form.manualReviewPercentage))))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewAutoGenerateInvoiceNumbersFormV3Reskin = F2(
	function (edit, maybeValue) {
		var options = _List_fromArray(
			[
				{label: 'Use Account Default', value: 'account_level_setting'},
				{label: 'Always', value: 'always'},
				{label: 'Never', value: 'never'},
				{label: 'When Not Extracted', value: 'when not extracted'}
			]);
		var currentValue = A2($elm$core$Maybe$withDefault, 'account_level_setting', maybeValue);
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Auto-Generate Invoice Numbers')
							])),
						A2(
						$elm$html$Html$select,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, edit, $elm$core$Maybe$Just))
							]),
						A2(
							$elm$core$List$map,
							function (opt) {
								return A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(opt.value),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(opt.value, currentValue))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(opt.label)
										]));
							},
							options))
					])),
			true);
	});
var $author$project$Components$SettingsPage$CarrierLayout$autoGenerateInvoiceNumbersConfigV3Reskin = F2(
	function (accountSettings, carrierId) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeL,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
				$author$project$Api$Carriers$autoGenerateFactorInvoiceNumbers(carrierId)),
			formView: $author$project$Components$SettingsPage$CarrierLayout$viewAutoGenerateInvoiceNumbersFormV3Reskin,
			summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewAutoGenerateInvoiceNumbersSummary(accountSettings),
			title: 'Auto-Generate Invoice Numbers',
			toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateAutoGenerateInvoiceNumbers)
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewInvoiceNumberStrategyFormV3Reskin = F2(
	function (edit, maybeStrategy) {
		var options = _List_fromArray(
			[
				{label: 'Use Account Default', value: ''},
				{label: 'Leave Blank', value: 'leave_blank'},
				{label: 'Load ID', value: 'load_id'},
				{label: 'Single Sequence', value: 'single_sequence'},
				{label: 'Sequence Per Client', value: 'sequence_per_client'},
				{label: 'Sequence Per Client with ID', value: 'sequence_per_client_with_id'}
			]);
		var currentValue = function () {
			if (maybeStrategy.$ === 'Just') {
				if (maybeStrategy.a === 'account_level_strategy') {
					return '';
				} else {
					var val = maybeStrategy.a;
					return val;
				}
			} else {
				return '';
			}
		}();
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Invoice Number Strategy')
							])),
						A2(
						$elm$html$Html$select,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (val) {
									return (val === '') ? edit($elm$core$Maybe$Nothing) : edit(
										$elm$core$Maybe$Just(val));
								})
							]),
						A2(
							$elm$core$List$map,
							function (opt) {
								return A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(opt.value),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(opt.value, currentValue))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(opt.label)
										]));
							},
							options))
					])),
			true);
	});
var $author$project$Components$SettingsPage$CarrierLayout$invoiceNumberStrategyConfigV3Reskin = F2(
	function (accountSettings, carrierId) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeL,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
				$author$project$Api$Carriers$factorInvoiceNumberStrategy(carrierId)),
			formView: $author$project$Components$SettingsPage$CarrierLayout$viewInvoiceNumberStrategyFormV3Reskin,
			summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewInvoiceNumberStrategySummary(accountSettings),
			title: 'Invoice Number Strategy',
			toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateInvoiceNumberStrategy)
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewLabelToggleV3Reskin = F3(
	function (edit, labels, candidate) {
		return A2(
			$author$project$Ui$V3$Checkbox$view,
			{
				checked: A2($elm$core$Set$member, candidate, labels),
				label: $elm$html$Html$text(candidate),
				onCheck: function (checked) {
					return checked ? edit(
						A2($elm$core$Set$insert, candidate, labels)) : edit(
						A2($elm$core$Set$remove, candidate, labels));
				}
			},
			_List_Nil);
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewLabelsFormV3Reskin = F3(
	function (settings, edit, labels) {
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$Components$SettingsPage$CarrierLayout$viewLabelToggleV3Reskin, edit, labels),
					$author$project$Domain$AccountSettings$labelNames(settings.possibleCarrierLabels))),
			true);
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewLabelsSummaryV3Reskin = function (labels) {
	return $elm$core$Set$isEmpty(labels) ? $elm$html$Html$text('None selected') : A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
			]),
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
			A2(
				$elm$core$List$map,
				$author$project$Ui$V3$Chip$view(_List_Nil),
				$elm$core$Set$toList(labels))));
};
var $author$project$Components$SettingsPage$CarrierLayout$labelsConfigV3Reskin = F2(
	function (carrierId, settings) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeL,
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity),
				$author$project$Api$Carriers$labels(carrierId)),
			formView: $author$project$Components$SettingsPage$CarrierLayout$viewLabelsFormV3Reskin(settings),
			summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewLabelsSummaryV3Reskin,
			title: 'TriumphPay Audit labels',
			toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateLabels)
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewManualReviewPercentageFormV3Reskin = F2(
	function (edit, manualReviewPercentage) {
		var stringValue = function () {
			if (manualReviewPercentage.$ === 'Ok') {
				if (manualReviewPercentage.a.$ === 'Just') {
					var manualReviewPercentageInt = manualReviewPercentage.a.a;
					return $elm$core$String$fromInt(manualReviewPercentageInt);
				} else {
					var _v1 = manualReviewPercentage.a;
					return '';
				}
			} else {
				var msg = manualReviewPercentage.a;
				return msg;
			}
		}();
		return _Utils_Tuple2(
			A4(
				$author$project$Ui$V3$Input$view,
				{
					onInput: A2(
						$elm$core$Basics$composeL,
						edit,
						$author$project$Components$SettingsPage$CarrierLayout$ensureNumeric(-1))
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$label('Manual Review Percentage'),
						$author$project$Ui$V3$Input$validation(manualReviewPercentage),
						$author$project$Ui$V3$Input$numberInput,
						$author$project$Ui$V3$Input$trailingTextInBox(
						{text: '%', width: 42}),
						$author$project$Ui$V3$Input$width('160px')
					]),
				_List_Nil,
				stringValue),
			$elm_community$result_extra$Result$Extra$isOk(manualReviewPercentage));
	});
var $author$project$Components$SettingsPage$CarrierLayout$manualReviewPercentageConfigV3Reskin = F2(
	function (accountSettings, carrierId) {
		return {
			apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
				$author$project$Api$Carriers$manualReviewPercentage(carrierId)),
			formView: $author$project$Components$SettingsPage$CarrierLayout$viewManualReviewPercentageFormV3Reskin,
			summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewManualReviewPercentageSummary(accountSettings),
			title: 'Manual Review Percentage',
			toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateManualReviewPercentage)
		};
	});
var $author$project$Components$SettingsPage$CarrierLayout$maybeShowIf = F2(
	function (check, html) {
		return check ? $elm$core$Maybe$Just(html) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$SettingsPage$CarrierLayout$viewVerifyPercentileFormV3Reskin = F2(
	function (edit, verifyPercentile) {
		var validate = function (string) {
			return A2(
				$elm$core$Result$fromMaybe,
				'Could not convert to integer',
				$elm$core$String$toInt(string));
		};
		return _Utils_Tuple2(
			A4(
				$author$project$Ui$V3$Input$view,
				{
					onInput: A2($elm$core$Basics$composeL, edit, validate)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$label('Verifications percentile'),
						$author$project$Ui$V3$Input$validation(verifyPercentile),
						$author$project$Ui$V3$Input$numberInput,
						$author$project$Ui$V3$Input$trailingTextInBox(
						{text: '%', width: 42}),
						$author$project$Ui$V3$Input$width('160px')
					]),
				_List_Nil,
				$elm_community$result_extra$Result$Extra$merge(
					A2($elm$core$Result$map, $elm$core$String$fromInt, verifyPercentile))),
			$elm_community$result_extra$Result$Extra$isOk(verifyPercentile));
	});
var $author$project$Components$SettingsPage$CarrierLayout$verifyPercentileConfigV3Reskin = function (carrierId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CarrierLayout$validatingSend(
			$author$project$Api$Carriers$verifyPercentile(carrierId)),
		formView: $author$project$Components$SettingsPage$CarrierLayout$viewVerifyPercentileFormV3Reskin,
		summaryView: $author$project$Components$SettingsPage$CarrierLayout$viewVerifyPercentileSummary,
		title: 'Verifications percentile',
		toMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CarrierLayout$FormMsg, $author$project$Components$SettingsPage$CarrierLayout$UpdateVerifyPercentile)
	};
};
var $author$project$Components$SettingsPage$CarrierLayout$viewFactorClientPortalEnablerV3Reskin = function (isEnabled) {
	return A3(
		$author$project$Ui$V3$Button$view,
		{
			action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$CarrierLayout$ShowPortalWarning)
		},
		_List_Nil,
		$author$project$Components$SettingsPage$CarrierLayout$enableActionString(isEnabled));
};
var $author$project$Components$SettingsPage$Carriers$Contacts$viewMessageV3Reskin = function (config) {
	return A2(
		$author$project$Ui$V3$Notification$viewInline,
		{
			message: A2(
				$elm$html$Html$span,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$elm$html$Html$text,
					_List_fromArray(
						[
							'When you add a contact for ',
							$author$project$Helpers$String$appendIndefiniteArticle(
							$elm$core$String$toLower(config.carrierTerm)),
							', messages sent from that address will be automatically associated with the ',
							$elm$core$String$toLower(config.carrierTerm),
							'. You will also be able to easily send exceptions to contacts.'
						]))),
			onClose: $elm$core$Maybe$Nothing,
			title: $elm$core$Maybe$Nothing
		},
		_List_Nil);
};
var $author$project$Components$SettingsPage$Carriers$Contacts$viewFormV3Reskin = F2(
	function (config, contact) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorz,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (x) {
										return A2(
											$author$project$Components$SettingsPage$Carriers$Contacts$edit,
											config,
											_Utils_update(
												contact,
												{name: x}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Name')
									]),
								_List_Nil,
								contact.name),
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (x) {
										return A2(
											$author$project$Components$SettingsPage$Carriers$Contacts$edit,
											config,
											_Utils_update(
												contact,
												{email: x}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Email')
									]),
								_List_Nil,
								contact.email)
							]))),
					config.factorClientPortalEnabled ? $elm$core$Maybe$Just(
					A3(
						$author$project$Components$SettingsPage$Carriers$Contacts$field,
						'checkbox',
						'Factor Client Portal Enabled',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$checked(contact.factorClientPortalEnabled),
								$elm$html$Html$Events$onCheck(
								function (x) {
									return A2(
										$author$project$Components$SettingsPage$Carriers$Contacts$edit,
										config,
										_Utils_update(
											contact,
											{factorClientPortalEnabled: x}));
								})
							]))) : $elm$core$Maybe$Nothing,
					(config.factorClientPortalEnabled && contact.factorClientPortalEnabled) ? $elm$core$Maybe$Just(
					A3(
						$author$project$Components$SettingsPage$Carriers$Contacts$field,
						'checkbox',
						'Portal Admin',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$checked(contact.admin),
								$elm$html$Html$Events$onCheck(
								function (x) {
									return A2(
										$author$project$Components$SettingsPage$Carriers$Contacts$edit,
										config,
										_Utils_update(
											contact,
											{admin: x}));
								})
							]))) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					$author$project$Helpers$Html$editButtons(
						{
							cancelMsg: config.onEdit($elm$core$Maybe$Nothing),
							primaryDisabled: $elm$core$String$isEmpty(contact.email),
							primaryLabel: 'Save',
							primaryMsg: config.onSave
						}))
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewNewContactV3Reskin = function (config) {
	var _v0 = config.form;
	if (_v0.$ === 'Just') {
		var contact = _v0.a;
		return _Utils_eq(contact.id, $author$project$Components$SettingsPage$Carriers$Contacts$newId) ? $elm$core$Maybe$Just(
			A2($author$project$Components$SettingsPage$Carriers$Contacts$viewFormV3Reskin, config, contact)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$V3$Button$view,
						{
							action: $author$project$Ui$V3$Button$onClick(
								config.onEdit(
									$elm$core$Maybe$Just($author$project$Components$SettingsPage$Carriers$Contacts$blank)))
						},
						_List_Nil,
						'New contact')
					])));
	}
};
var $author$project$Components$SettingsPage$Carriers$Contacts$viewActionV3Reskin = F3(
	function (title_, icon, msg) {
		return A2(
			$author$project$Ui$V3$UtilityButton$view,
			{icon: icon, label: title_, onClick: msg},
			_List_fromArray(
				[$author$project$Ui$V3$UtilityButton$sizeSmall]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$justIf = F2(
	function (check, html) {
		return check ? $elm$core$Maybe$Just(html) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewAdminBadgeV3Reskin = A2($author$project$Ui$V3$Chip$view, _List_Nil, 'Admin');
var $author$project$Components$SettingsPage$Carriers$Contacts$invitationButtonV3Reskin = F2(
	function (config, contact) {
		var buttonText = 'Re-Send Portal Invite Email';
		return A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick(
					config.onInvite(contact))
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall)
				]),
			buttonText);
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewInvitationButtonsV3Reskin = F2(
	function (config, contact) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Carriers$Contacts$invitationButtonV3Reskin, config, contact)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewPortalSettingsSummaryV3Reskin = F2(
	function (config, contact) {
		return (!config.factorClientPortalEnabled) ? $elm$core$Maybe$Nothing : (contact.factorClientPortalEnabled ? $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$crossAxisCenter,
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						$elm$core$Maybe$Just(
							$author$project$Components$SettingsPage$Carriers$Contacts$viewPortalLink(contact.urlHash))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2($author$project$Components$SettingsPage$Carriers$Contacts$justIf, contact.admin, $author$project$Components$SettingsPage$Carriers$Contacts$viewAdminBadgeV3Reskin)),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Components$SettingsPage$Carriers$Contacts$viewInvitationButtonsV3Reskin, config, contact)
									]))))
					]))) : $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$V3$Stack$viewHorz,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$em,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Client portal not enabled')
							]))
					]))));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewSummaryV3Reskin = F3(
	function (config, contact, actions) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
								$author$project$Ui$V3$Stack$crossAxisCenter
							]),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2(
									$author$project$Ui$V3$Typography$smallBodySemiBold,
									_List_Nil,
									$author$project$Components$SettingsPage$Carriers$Contacts$viewContactSummary(contact))),
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
								actions)))),
					A2($author$project$Components$SettingsPage$Carriers$Contacts$viewPortalSettingsSummaryV3Reskin, config, contact)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewRowV3Reskin = F2(
	function (config, contact) {
		var _v0 = config.form;
		if (_v0.$ === 'Nothing') {
			return A3(
				$author$project$Components$SettingsPage$Carriers$Contacts$viewSummaryV3Reskin,
				config,
				contact,
				_List_fromArray(
					[
						A3(
						$author$project$Components$SettingsPage$Carriers$Contacts$viewActionV3Reskin,
						'Edit',
						$author$project$Ui$V3$Icon$editOutline16,
						config.onEdit(
							$elm$core$Maybe$Just(contact))),
						A3(
						$author$project$Components$SettingsPage$Carriers$Contacts$viewActionV3Reskin,
						'Delete',
						$author$project$Ui$V3$Icon$removeOutline16,
						config.onDelete(contact.id))
					]));
		} else {
			var editing = _v0.a;
			return (!_Utils_eq(editing.id, contact.id)) ? A3($author$project$Components$SettingsPage$Carriers$Contacts$viewSummaryV3Reskin, config, contact, _List_Nil) : A2($author$project$Components$SettingsPage$Carriers$Contacts$viewFormV3Reskin, config, editing);
		}
	});
var $author$project$Components$SettingsPage$Carriers$Contacts$viewV3Reskin = function (config) {
	return A2(
		$author$project$Ui$V3$Stack$viewVertMaybes,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__type__h2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Contacts')
						]))),
				$elm$core$Maybe$Just(
				$author$project$Components$SettingsPage$Carriers$Contacts$viewMessageV3Reskin(config)),
				$elm$core$List$isEmpty(config.carrier.contacts) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					A2(
						$elm$core$List$intersperse,
						A2(
							$elm$html$Html$hr,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin', '0'),
									A2($elm$html$Html$Attributes$style, 'border-color', 'var(--color-border-neutral-default)')
								]),
							_List_Nil),
						A2(
							$elm$core$List$map,
							$author$project$Components$SettingsPage$Carriers$Contacts$viewRowV3Reskin(config),
							config.carrier.contacts)))),
				$author$project$Components$SettingsPage$Carriers$Contacts$viewNewContactV3Reskin(config)
			]));
};
var $author$project$Components$SettingsPage$Carriers$Scraping$alertBoxV3Reskin = function (message) {
	return A2(
		$author$project$Ui$V3$Notification$viewInline,
		{
			message: $elm$html$Html$text(message),
			onClose: $elm$core$Maybe$Nothing,
			title: $elm$core$Maybe$Nothing
		},
		_List_Nil);
};
var $author$project$Components$SettingsPage$Carriers$Scraping$hr = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'margin', '0')
		]),
	_List_Nil);
var $author$project$Components$SettingsPage$Carriers$Scraping$labeledSection = F2(
	function (label, content) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					content
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewCheckboxV3Reskin = F3(
	function (labelText, onCheck_, checked_) {
		return A2(
			$author$project$Ui$V3$Checkbox$view,
			{
				checked: checked_,
				label: A2(
					$elm$html$Html$p,
					_List_fromArray(
						[$author$project$Ui$V3$Typography$xSmallBodyClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
				onCheck: onCheck_
			},
			_List_Nil);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$nameForServiceV3Reskin = function (service) {
	if (service.$ === 'ScrapingServiceScrAPINgServiceDocs') {
		return 'Scraping documents';
	} else {
		return 'Scraping invoice';
	}
};
var $author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLoginV3Reskin = F3(
	function (scrapingServices, carrier, authType) {
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Components$SettingsPage$Carriers$Scraping$nameForServiceV3Reskin,
				A3($author$project$Components$SettingsPage$Carriers$Scraping$authenticatedServicesForScraper, scrapingServices, carrier, authType)));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewTokenInputV3Reskin = F3(
	function (config, useCustomer, login) {
		return A2($author$project$Components$SettingsPage$Carriers$Scraping$requiresToken, login.scrapingServices, config.carrier) ? _Utils_Tuple2(
			$author$project$Components$SettingsPage$Carriers$Scraping$hasMaybe(login.token),
			$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLoginV3Reskin, login.scrapingServices, config.carrier, $author$project$AuditPb$ScraperAuthRequirementToken)),
							A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: function (x) {
									return config.onEdit(
										$elm$core$Maybe$Just(
											A2(
												$author$project$Components$SettingsPage$Carriers$Scraping$Form,
												_Utils_update(
													login,
													{
														markLoginFailed: false,
														token: $elm$core$Maybe$Just(x)
													}),
												useCustomer)));
								}
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$label('Token')
								]),
							_List_Nil,
							$author$project$Components$SettingsPage$Carriers$Scraping$maybeString(login.token))
						])))) : _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
	});
var $author$project$Ui$V3$Input$password = $author$project$Ui$V3$Input$TypeAttribute('password');
var $author$project$Components$SettingsPage$Carriers$Scraping$viewUsernamePasswordInputV3Reskin = F3(
	function (config, useCustomer, login) {
		return A2($author$project$Components$SettingsPage$Carriers$Scraping$requiresUsernamePassword, login.scrapingServices, config.carrier) ? _Utils_Tuple2(
			$author$project$Components$SettingsPage$Carriers$Scraping$hasMaybe(login.user) && $author$project$Components$SettingsPage$Carriers$Scraping$hasPassword(login.password),
			$elm$core$Maybe$Just(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: function (x) {
									return config.onEdit(
										$elm$core$Maybe$Just(
											A2(
												$author$project$Components$SettingsPage$Carriers$Scraping$Form,
												_Utils_update(
													login,
													{
														markLoginFailed: false,
														user: $elm$core$Maybe$Just(x)
													}),
												useCustomer)));
								}
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$label('User')
								]),
							_List_Nil,
							$author$project$Components$SettingsPage$Carriers$Scraping$maybeString(login.user)),
							A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: function (x) {
									return config.onEdit(
										$elm$core$Maybe$Just(
											A2(
												$author$project$Components$SettingsPage$Carriers$Scraping$Form,
												_Utils_update(
													login,
													{
														markLoginFailed: false,
														password: $author$project$Api$Carriers$ExternalLogins$Dirty(x)
													}),
												useCustomer)));
								}
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$label('Password'),
									$author$project$Ui$V3$Input$password
								]),
							_List_Nil,
							$author$project$Components$SettingsPage$Carriers$Scraping$passwordValue(login.password))
						])))) : _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$credentialInputsV3Reskin = F3(
	function (config, useCustomer, login) {
		var _v0 = A3($author$project$Components$SettingsPage$Carriers$Scraping$viewUsernamePasswordInputV3Reskin, config, useCustomer, login);
		var usernamePasswordValid = _v0.a;
		var usernamePasswordInput = _v0.b;
		var _v1 = A3($author$project$Components$SettingsPage$Carriers$Scraping$viewTokenInputV3Reskin, config, useCustomer, login);
		var tokenValid = _v1.a;
		var tokenInput = _v1.b;
		return _Utils_Tuple2(
			usernamePasswordValid && tokenValid,
			A2(
				$author$project$Ui$V3$Stack$viewVertMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				_List_fromArray(
					[usernamePasswordInput, tokenInput])));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewCustomerTypeaheadV3Reskin = F3(
	function (config, useCustomer, login) {
		if (useCustomer.$ === 'HideCustomer') {
			return _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
		} else {
			return _Utils_Tuple2(
				!_Utils_eq(login.customerId, $elm$core$Maybe$Nothing),
				$elm$core$Maybe$Just(config.customerTypeaheadV3Reskin));
		}
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewServicesInputV3Reskin = F5(
	function (config, useCustomer, login, serviceConstant, serviceLabel) {
		var onCheck = function (checked_) {
			return checked_ ? config.onEdit(
				$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$Carriers$Scraping$Form,
						_Utils_update(
							login,
							{
								scrapingServices: A2($elm$core$List$cons, serviceConstant, login.scrapingServices)
							}),
						useCustomer))) : config.onEdit(
				$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$Carriers$Scraping$Form,
						_Utils_update(
							login,
							{
								scrapingServices: A2(
									$elm$core$List$filter,
									function (x) {
										return !_Utils_eq(x, serviceConstant);
									},
									login.scrapingServices)
							}),
						useCustomer)));
		};
		return A3(
			$author$project$Components$SettingsPage$Carriers$Scraping$viewCheckboxV3Reskin,
			serviceLabel,
			onCheck,
			A2($author$project$Components$SettingsPage$Carriers$Scraping$loginScrapesService, login.scrapingServices, serviceConstant));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewTestCredentialsResultV3Reskin = function (config) {
	var _v0 = config.testCredentialsResult;
	switch (_v0.$) {
		case 'NotTested':
			return $author$project$Components$SettingsPage$Carriers$Scraping$empty;
		case 'TestSuccess':
			return A2(
				$author$project$Ui$V3$Notification$viewInline,
				{
					message: $elm$html$Html$text('✓ Credentials are valid'),
					onClose: $elm$core$Maybe$Nothing,
					title: $elm$core$Maybe$Nothing
				},
				_List_fromArray(
					[$author$project$Ui$V3$Notification$success]));
		default:
			var message = _v0.a;
			return A2(
				$author$project$Ui$V3$Notification$viewInline,
				{
					message: $elm$html$Html$text('✗ ' + message),
					onClose: $elm$core$Maybe$Nothing,
					title: $elm$core$Maybe$Nothing
				},
				_List_fromArray(
					[$author$project$Ui$V3$Notification$error]));
	}
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewFormV3Reskin = F3(
	function (config, useCustomer, login) {
		var servicesValid = !$elm$core$List$isEmpty(login.scrapingServices);
		var servicesInputInvoice = config.carrier.supportsScrapingInvoice ? $elm$core$Maybe$Just(
			A5($author$project$Components$SettingsPage$Carriers$Scraping$viewServicesInputV3Reskin, config, useCustomer, login, $author$project$AuditPb$ScrapingServiceScrAPINgServiceInvoices, 'Use for scraping invoice amounts')) : $elm$core$Maybe$Nothing;
		var servicesInputDocs = _Utils_eq(config.carrier.scrapingDocumentsAuthRequirement, $author$project$AuditPb$ScraperAuthRequirementNone) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A5($author$project$Components$SettingsPage$Carriers$Scraping$viewServicesInputV3Reskin, config, useCustomer, login, $author$project$AuditPb$ScrapingServiceScrAPINgServiceDocs, 'Use for scraping documents'));
		var _v0 = A3($author$project$Components$SettingsPage$Carriers$Scraping$viewCustomerTypeaheadV3Reskin, config, useCustomer, login);
		var customerValid = _v0.a;
		var customerInput = _v0.b;
		var _v1 = A3($author$project$Components$SettingsPage$Carriers$Scraping$credentialInputsV3Reskin, config, useCustomer, login);
		var credentialInputsValid = _v1.a;
		var credentialInput = _v1.b;
		var isDisabled = (!_Utils_eq(config.processingExternalLogin, $elm$core$Maybe$Nothing)) || (!(credentialInputsValid && (customerValid && servicesValid)));
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray50),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2($elm$core$Maybe$map, $author$project$Components$SettingsPage$Carriers$Scraping$alertBoxV3Reskin, config.carrier.setupHelpText),
					servicesInputDocs,
					servicesInputInvoice,
					$elm$core$Maybe$Just(credentialInput),
					customerInput,
					$elm$core$Maybe$Just(
					$author$project$Components$SettingsPage$Carriers$Scraping$viewTestCredentialsResultV3Reskin(config)),
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[$author$project$Ui$V3$Stack$mainAxisSpaceBetween, $author$project$Ui$V3$Stack$crossAxisCenter]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								config.carrier.supportsCredentialTesting ? (config.testingCredentials ? A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick(config.onTestCredentials)
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
											$author$project$Ui$V3$Button$disabled(true)
										]),
									'Testing...') : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'display', 'flex'),
											A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
											A2($elm$html$Html$Attributes$style, 'gap', '8px')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$V3$Button$view,
											{
												action: $author$project$Ui$V3$Button$onClick(config.onTestCredentials)
											},
											_List_fromArray(
												[
													$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
													$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
													$author$project$Ui$V3$Button$disabled(isDisabled)
												]),
											'Test Credentials'),
											A3(
											$author$project$Ui$V3$Tooltip$view,
											_List_fromArray(
												[
													$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$AboveDirection)
												]),
											'Test if credentials are valid',
											A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$infoOutline16))
										]))) : $author$project$Components$SettingsPage$Carriers$Scraping$empty),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								$author$project$Helpers$Html$editButtons(
									{
										cancelMsg: config.onEdit($elm$core$Maybe$Nothing),
										primaryDisabled: isDisabled,
										primaryLabel: 'Save',
										primaryMsg: config.onSave
									}))
							])))
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewActionV3Reskin = F4(
	function (title_, icon, msg, disabled) {
		return A2(
			$author$project$Ui$V3$UtilityButton$view,
			{icon: icon, label: title_, onClick: msg},
			_List_fromArray(
				[
					$author$project$Ui$V3$UtilityButton$sizeSmall,
					$author$project$Ui$V3$UtilityButton$isDisabled(disabled)
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewTokenV3Reskin = F3(
	function (carrier, customers, login) {
		return (!A2($author$project$Components$SettingsPage$Carriers$Scraping$requiresToken, login.scrapingServices, carrier)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A3($author$project$Components$SettingsPage$Carriers$Scraping$viewWithCustomerName, login.customerId, login.token, customers));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewUsernameV3Reskin = F3(
	function (carrier, customers, login) {
		return (!A2($author$project$Components$SettingsPage$Carriers$Scraping$requiresUsernamePassword, login.scrapingServices, carrier)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A3($author$project$Components$SettingsPage$Carriers$Scraping$viewWithCustomerName, login.customerId, login.user, customers));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewLoginSummaryV3Reskin = F3(
	function (config, useCustomer, login) {
		var textUnlessEmpty = function (str) {
			return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, str));
		};
		var isDisabled = _Utils_eq(
			config.processingExternalLogin,
			$elm$core$Maybe$Just(login.id));
		var failureText = (!_Utils_eq(login.loginFailureDetectedAt, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center')
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$error16),
						A2(
						$author$project$Ui$V3$Typography$xSmallBody,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-left', '4px'),
								A2(
								$elm$html$Html$Attributes$style,
								'color',
								$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Red700))
							]),
						'Login Failed')
					]))) : $elm$core$Maybe$Nothing;
		var externalLoginForm = $author$project$Components$SettingsPage$Carriers$Scraping$externalLoginFormFromProto(login);
		var editLogin = config.onEdit(
			$elm$core$Maybe$Just(
				A2($author$project$Components$SettingsPage$Carriers$Scraping$Form, externalLoginForm, useCustomer)));
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$onClick(editLogin)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewVertMaybes,
						_List_Nil,
						_List_fromArray(
							[
								textUnlessEmpty(
								A3($author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLoginV3Reskin, login.scrapingServices, config.carrier, $author$project$AuditPb$ScraperAuthRequirementUsernamePassword)),
								textUnlessEmpty(
								A3($author$project$Components$SettingsPage$Carriers$Scraping$servicesUsedForLoginV3Reskin, login.scrapingServices, config.carrier, $author$project$AuditPb$ScraperAuthRequirementToken)),
								A3($author$project$Components$SettingsPage$Carriers$Scraping$viewTokenV3Reskin, config.carrier, config.customers, externalLoginForm),
								A3($author$project$Components$SettingsPage$Carriers$Scraping$viewUsernameV3Reskin, config.carrier, config.customers, externalLoginForm),
								failureText
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A4($author$project$Components$SettingsPage$Carriers$Scraping$viewActionV3Reskin, 'Edit', $author$project$Ui$V3$Icon$editOutline16, editLogin, isDisabled)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A4(
						$author$project$Components$SettingsPage$Carriers$Scraping$viewActionV3Reskin,
						'Delete',
						$author$project$Ui$V3$Icon$removeOutline16,
						config.onDelete(login.id),
						isDisabled))
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewLoginListV3Reskin = F3(
	function (config, useCustomer, logins) {
		if ($elm$core$List$isEmpty(logins)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var row = function (x) {
				var _v0 = config.form;
				if (_v0.$ === 'Just') {
					var form = _v0.a;
					return _Utils_eq(x.id, form.login.id) ? A3($author$project$Components$SettingsPage$Carriers$Scraping$viewFormV3Reskin, config, useCustomer, form.login) : A3($author$project$Components$SettingsPage$Carriers$Scraping$viewLoginSummaryV3Reskin, config, useCustomer, x);
				} else {
					return A3($author$project$Components$SettingsPage$Carriers$Scraping$viewLoginSummaryV3Reskin, config, useCustomer, x);
				}
			};
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					A2($elm$core$List$map, row, logins)));
		}
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewNewLoginV3Reskin = F2(
	function (config, useCustomer) {
		var _v0 = config.form;
		if (_v0.$ === 'Just') {
			var form = _v0.a;
			return (_Utils_eq(form.login.id, $author$project$Domain$ExternalLoginId$dummyId) && _Utils_eq(form.useCustomer, useCustomer)) ? $elm$core$Maybe$Just(
				A3($author$project$Components$SettingsPage$Carriers$Scraping$viewFormV3Reskin, config, useCustomer, form.login)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewSectionV3Reskin = F4(
	function (config, header, useCustomer, filter) {
		var bodyContents = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Carriers$Scraping$viewNewLoginV3Reskin, config, useCustomer),
					A3(
					$author$project$Components$SettingsPage$Carriers$Scraping$viewLoginListV3Reskin,
					config,
					useCustomer,
					A2($elm$core$List$filter, filter, config.externalLogins))
				]));
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
						_List_fromArray(
							[$author$project$Ui$V3$Stack$mainAxisSpaceBetween, $author$project$Ui$V3$Stack$crossAxisCenter]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								$elm$core$Maybe$Just(
									A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(header)
											])))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								_Utils_eq(config.form, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
									A3(
										$author$project$Ui$V3$Button$view,
										{
											action: $author$project$Ui$V3$Button$onClick(
												config.onEdit(
													$elm$core$Maybe$Just(
														A2(
															$author$project$Components$SettingsPage$Carriers$Scraping$Form,
															$author$project$Components$SettingsPage$Carriers$Scraping$blankLogin(config.carrier.supportsScrapingInvoice),
															useCustomer))))
										},
										_List_fromArray(
											[
												$author$project$Ui$V3$Button$leftIcon16WithHiddenLabel($author$project$Ui$V3$Icon$add16),
												$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium)
											]),
										'Add')) : $elm$core$Maybe$Nothing)
							]))),
					$elm$core$List$isEmpty(bodyContents) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						bodyContents))
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Scraping$viewCredentialsV3Reskin = function (config) {
	return (!$author$project$Components$SettingsPage$Carriers$Scraping$credentialsRequired(config.carrier)) ? _List_fromArray(
		[
			$author$project$Components$SettingsPage$Carriers$Scraping$alertBoxV3Reskin(
			'Credentials are not required to automatically retrieve documents for this ' + ($elm$core$String$toLower(config.carrierTerm) + '.'))
		]) : _List_fromArray(
		[
			A4(
			$author$project$Components$SettingsPage$Carriers$Scraping$viewSectionV3Reskin,
			config,
			'Credentials',
			$author$project$Components$SettingsPage$Carriers$Scraping$HideCustomer,
			function (x) {
				return _Utils_eq(x.tmsCustomerId, $elm$core$Maybe$Nothing);
			}),
			$author$project$Components$SettingsPage$Carriers$Scraping$hr,
			A4(
			$author$project$Components$SettingsPage$Carriers$Scraping$viewSectionV3Reskin,
			config,
			'Customer-specific credentials',
			$author$project$Components$SettingsPage$Carriers$Scraping$ShowCustomer,
			function (x) {
				return !_Utils_eq(x.tmsCustomerId, $elm$core$Maybe$Nothing);
			})
		]);
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewSupportsScrapingInvoiceV3Reskin = function (config) {
	var supportedString = config.carrier.supportsScrapingInvoice ? 'Yes' : 'No';
	return A2(
		$author$project$Components$SettingsPage$Carriers$Scraping$labeledSection,
		'Supports Scraping Invoice Amounts?',
		$elm$html$Html$text(supportedString));
};
var $author$project$Components$SettingsPage$Carriers$Scraping$viewV3Reskin = function (config) {
	return (!config.carrier.scraperAvailable) ? $author$project$Components$SettingsPage$Carriers$Scraping$alertBoxV3Reskin(
		'Automatic retrieval is not available for this ' + ($elm$core$String$toLower(config.carrierTerm) + '.')) : A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A3(
					$author$project$Components$SettingsPage$Carriers$Scraping$viewCheckboxV3Reskin,
					'Enabled for this ' + $elm$core$String$toLower(config.carrierTerm),
					config.onScrapingEnabled,
					config.carrier.scrapingEnabled),
					A2(
					$author$project$Components$SettingsPage$Carriers$Scraping$labeledSection,
					'Document types available',
					$author$project$Components$SettingsPage$Carriers$Scraping$viewDocumentTypeList(config)),
					$author$project$Components$SettingsPage$Carriers$Scraping$hr,
					$author$project$Components$SettingsPage$Carriers$Scraping$viewSupportsScrapingInvoiceV3Reskin(config),
					$author$project$Components$SettingsPage$Carriers$Scraping$hr
				]),
			$author$project$Components$SettingsPage$Carriers$Scraping$viewCredentialsV3Reskin(config)));
};
var $author$project$Components$SettingsPage$CarrierLayout$viewRightV3Reskin = F3(
	function (model, data, form) {
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(data.account));
		var carrier = data.carrierData.carrier;
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$author$project$Components$SettingsPage$CarrierLayout$container(
						$author$project$Components$SettingsPage$Carriers$Contacts$viewV3Reskin(
							{carrier: carrier, carrierTerm: carrierTerm, factorClientPortalEnabled: data.account.factorAccount && (data.accountSettings.factorClientPortalEnabled && carrier.factorClientPortalEnabled), form: model.contactForm, onDelete: $author$project$Components$SettingsPage$CarrierLayout$DeleteContact, onEdit: $author$project$Components$SettingsPage$CarrierLayout$SetContactForm, onInvite: $author$project$Components$SettingsPage$CarrierLayout$InviteContact, onSave: $author$project$Components$SettingsPage$CarrierLayout$SaveContactForm}))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					data.account.factorAccount && data.accountSettings.noaManagementEnabled,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'NOAs',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Attributes$href(
										$author$project$Path$toString(
											A2(
												$author$project$Path$noaManagementSent,
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(model.carrierId))))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('View sent NOAs')
									]))
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					data.account.scraperAccount,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Automatic document retrieval',
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$Carriers$Scraping$viewV3Reskin(
								A3($author$project$Components$SettingsPage$CarrierLayout$scrapingViewParams, model, data, form))
							]))),
					$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
						A2($author$project$Components$SettingsPage$CarrierLayout$labelsConfigV3Reskin, model.carrierId, data.accountSettings),
						form.labels)),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					!$elm$core$Set$isEmpty(carrier.externalLabels),
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						$author$project$Components$SettingsPage$CarrierLayout$labelTypeHeader(data.account),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'font-style', 'italic')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Components$SettingsPage$CarrierLayout$labelTypeDescription(data.account))
											])),
										$author$project$Components$SettingsPage$CarrierLayout$viewLabelsSummaryV3Reskin(carrier.externalLabels)
									]))
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					data.account.factorAccount,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Client Type',
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Checkbox$view,
								{
									checked: carrier.transportationClient,
									label: $elm$html$Html$text('Transportation Client'),
									onCheck: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$CarrierLayout$UpdateTransportationClient, $author$project$Components$SettingsPage$CarrierLayout$FormMsg)
								},
								_List_Nil)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					data.accountSettings.carrierDocumentsAccount,
					$author$project$Components$SettingsPage$CarrierLayout$container(
						A3(
							$author$project$Components$SettingsPage$CarrierLayout$viewDocumentsLinkV3Reskin,
							carrierTerm,
							$author$project$Components$SettingsPage$CarrierLayout$GoTo,
							$author$project$Path$toString(
								$author$project$Path$settingsEditCarrierDocuments(model.carrierId))))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					data.account.factorAccount && data.currentUser.isAdmin,
					A2(
						$author$project$Components$SettingsPage$CarrierLayout$viewSectionV3Reskin,
						'Client Portal',
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$CarrierLayout$viewFactorClientPortalEnablerV3Reskin(carrier.factorClientPortalEnabled)
							]))),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					$author$project$Components$SettingsPage$CarrierLayout$shouldShowVerifyPercentile(data),
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
						$author$project$Components$SettingsPage$CarrierLayout$verifyPercentileConfigV3Reskin(model.carrierId),
						form.verifyPercentile)),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					data.account.factorAccount && data.currentUser.hasSettingsRole,
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
						A2($author$project$Components$SettingsPage$CarrierLayout$invoiceNumberStrategyConfigV3Reskin, data.accountSettings, model.carrierId),
						form.invoiceNumberStrategy)),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					data.account.factorAccount && data.currentUser.hasSettingsRole,
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
						A2($author$project$Components$SettingsPage$CarrierLayout$autoGenerateInvoiceNumbersConfigV3Reskin, data.accountSettings, model.carrierId),
						form.autoGenerateInvoiceNumbers)),
					A2(
					$author$project$Components$SettingsPage$CarrierLayout$maybeShowIf,
					data.account.factorAccount && (data.accountSettings.factorNextGenAuditEnabled && data.currentUser.isAdmin),
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
						A2($author$project$Components$SettingsPage$CarrierLayout$manualReviewPercentageConfigV3Reskin, data.accountSettings, model.carrierId),
						form.manualReviewPercentage))
				]));
	});
var $author$project$Components$ClientDebtorConfigurationManager$viewDeleteConfirmationModalV3 = function (model) {
	var _v0 = model.confirmDeleteConfigId;
	if (_v0.$ === 'Just') {
		var configId = _v0.a;
		var _v1 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.id, configId);
				},
				model.configurations));
		if (_v1.$ === 'Just') {
			var config = _v1.a;
			return A2(
				$author$project$Ui$V3$Modal$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$Modal$disablePrimaryButton(model.deletingConfiguration)
					]),
				{
					body: A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You are about to delete the configuration for '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(config.debtorName)
											])),
										$elm$html$Html$text('.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This action cannot be undone.')
									])),
								$author$project$Components$ClientDebtorConfigurationManager$viewActiveRules(config)
							])),
					cancelButton: $elm$core$Maybe$Just(
						_Utils_Tuple2('Cancel', $author$project$Components$ClientDebtorConfigurationManager$HideDeleteConfirmation)),
					dismissMsg: $author$project$Components$ClientDebtorConfigurationManager$HideDeleteConfirmation,
					footerButtons: _List_Nil,
					header: $author$project$Ui$V3$Modal$textHeader('Delete configuration?'),
					primaryButton: $elm$core$Maybe$Just(
						_Utils_Tuple2(
							'Delete',
							$author$project$Components$ClientDebtorConfigurationManager$DeleteConfiguration(configId))),
					size: $author$project$Ui$V3$Modal$medium
				});
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$ClientDebtorConfigurationManager$viewV3Reskin = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__theme')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-debtor-configurations')
						]),
					_List_fromArray(
						[
							function () {
							if (model.isLoading) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('loading')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Loading configurations...')
										]));
							} else {
								var _v0 = model.loadError;
								if (_v0.$ === 'Just') {
									var errorMsg = _v0.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('error')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(errorMsg)
											]));
								} else {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A4($author$project$Components$ClientDebtorConfigurationManager$viewConfigurationList, true, data, model, model.configurations)
											]));
								}
							}
						}()
						])),
					$author$project$Components$ClientDebtorConfigurationManager$viewDeleteConfirmationModalV3(model)
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$authorizedView = F3(
	function (v3ReskinEnabled, model, data) {
		var form = A2($author$project$Components$SettingsPage$CarrierLayout$mergeFormData, data, model.form).a;
		var carrier = data.carrierData.carrier;
		var portalWarningModal = model.showPortalWarning ? (v3ReskinEnabled ? A2(
			$author$project$Ui$V3$Modal$view,
			_List_Nil,
			A2($author$project$Components$SettingsPage$CarrierLayout$portalWarningModalConfigV3Reskin, carrier.factorClientPortalEnabled, carrier.name)) : A2(
			$author$project$Components$Shared$ModalDialog$view,
			$author$project$Components$SettingsPage$CarrierLayout$ClosePortalWarning,
			A2($author$project$Components$SettingsPage$CarrierLayout$portalWarningModalConfig, carrier.factorClientPortalEnabled, carrier.name))) : $elm$html$Html$text('');
		return v3ReskinEnabled ? $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
					]),
				_List_fromArray(
					[
						portalWarningModal,
						A6(
						$author$project$Components$SettingsPage$Shared$Section$frameView,
						v3ReskinEnabled,
						$author$project$Components$SettingsPage$Shared$Section$Carriers,
						data.account,
						data.accountSettings,
						data.currentUser,
						A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Ui$V3$Typography$smallBodySemiBoldClass,
											$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$CarrierLayout$GoBack)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$V3$Stack$viewHorzWithWidths,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
													$author$project$Ui$V3$Stack$crossAxisCenter
												]),
											_List_fromArray(
												[
													_Utils_Tuple2(
													$author$project$Ui$V3$Stack$fit,
													A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$arrowLeft16)),
													_Utils_Tuple2(
													$author$project$Ui$V3$Stack$fit,
													$elm$html$Html$text('All carriers'))
												]))
										])),
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('v3__type__h1')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(carrier.name)
										])),
									A2(
									$author$project$Ui$V3$Stack$viewHorz,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
										]),
									_List_fromArray(
										[
											A3($author$project$Components$SettingsPage$CarrierLayout$viewLeftV3Reskin, model, data, form),
											A3($author$project$Components$SettingsPage$CarrierLayout$viewRightV3Reskin, model, data, form)
										])),
									(data.account.factorAccount && data.accountSettings.enablePerRelationshipAutoprocessingOverrides) ? $author$project$Components$SettingsPage$CarrierLayout$container(
									A2(
										$author$project$Ui$V3$Stack$viewVert,
										_List_fromArray(
											[
												$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h2,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('v3__type__h2')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Client Debtor Configurations')
													])),
												A2(
												$elm$html$Html$map,
												$author$project$Components$SettingsPage$CarrierLayout$ClientDebtorConfigManagerMsg,
												A2($author$project$Components$ClientDebtorConfigurationManager$viewV3Reskin, data.clientDebtorConfigManagerData, model.clientDebtorConfigManager))
											]))) : $elm$html$Html$text('')
								])))
					]))) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					portalWarningModal,
					A6(
					$author$project$Components$SettingsPage$Shared$Section$frameView,
					v3ReskinEnabled,
					$author$project$Components$SettingsPage$Shared$Section$Carriers,
					data.account,
					data.accountSettings,
					data.currentUser,
					A2(
						$author$project$Components$Shared$Grid$column,
						12,
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Grid$autoRow,
								10,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												A4(
												$author$project$Helpers$GenericLink$genericLink,
												$author$project$Components$SettingsPage$CarrierLayout$GoBack,
												_List_Nil,
												'#',
												_List_fromArray(
													[
														$elm$html$Html$text('« ')
													])),
												$elm$html$Html$text(carrier.name)
											]))
									])),
								A2(
								$author$project$Components$Shared$Grid$autoRow,
								5,
								_List_fromArray(
									[
										A3($author$project$Components$SettingsPage$CarrierLayout$viewLeft, model, data, form),
										A3($author$project$Components$SettingsPage$CarrierLayout$viewRight, model, data, form)
									])),
								(data.account.factorAccount && data.accountSettings.enablePerRelationshipAutoprocessingOverrides) ? A2(
								$author$project$Components$Shared$Grid$autoRow,
								12,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('shared__section-header')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Client Debtor Configurations')
													])),
												A2(
												$elm$html$Html$map,
												$author$project$Components$SettingsPage$CarrierLayout$ClientDebtorConfigManagerMsg,
												A2($author$project$Components$ClientDebtorConfigurationManager$view, data.clientDebtorConfigManagerData, model.clientDebtorConfigManager))
											]))
									])) : $elm$html$Html$text('')
							])))
				]));
	});
var $author$project$Components$SettingsPage$CarrierLayout$view = F3(
	function (v3ReskinEnabled, model, data) {
		return data.currentUser.hasSettingsRole ? A3($author$project$Components$SettingsPage$CarrierLayout$authorizedView, v3ReskinEnabled, model, data) : A6(
			$author$project$Components$SettingsPage$Shared$Section$frameView,
			v3ReskinEnabled,
			$author$project$Components$SettingsPage$Shared$Section$Carriers,
			data.account,
			data.accountSettings,
			data.currentUser,
			$elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.'));
	});
var $author$project$Components$SettingsPage$CarriersLayout$FiltersMsg = function (a) {
	return {$: 'FiltersMsg', a: a};
};
var $author$project$Components$SettingsPage$CarriersLayout$NavigateTo = function (a) {
	return {$: 'NavigateTo', a: a};
};
var $author$project$Ui$V3$Tooltip$RightDirection = {$: 'RightDirection'};
var $author$project$Components$SettingsPage$CarriersLayout$UpdatePage = function (a) {
	return {$: 'UpdatePage', a: a};
};
var $author$project$Components$SettingsPage$CarriersLayout$tableColumnHeading = $author$project$Ui$V3$Typography$xSmallBodySemiBold(_List_Nil);
var $author$project$Ui$V3$Table$viewRemote = F3(
	function (_v0, attributes, remoteRows) {
		var columns = _v0.columns;
		var computedAttributes = $author$project$Ui$V3$Table$computeAttributes(attributes);
		switch (remoteRows.$) {
			case 'Loading':
				return A2(
					$author$project$Ui$V3$Table$viewContainer,
					computedAttributes,
					A4(
						$author$project$Ui$V3$Table$viewTable,
						_List_Nil,
						columns,
						computedAttributes,
						$author$project$Ui$V3$Table$computeTableAttributes(
							_List_fromArray(
								[
									$author$project$Ui$V3$Table$loading(true)
								]))));
			case 'Loaded':
				var rows = remoteRows.a;
				return A2(
					$author$project$Ui$V3$Table$viewContainer,
					computedAttributes,
					A4(
						$author$project$Ui$V3$Table$viewTable,
						rows,
						columns,
						computedAttributes,
						$author$project$Ui$V3$Table$computeTableAttributes(_List_Nil)));
			default:
				var err = remoteRows.a;
				return $author$project$Forward$Remote$defaultErrorView(err);
		}
	});
var $author$project$Components$SettingsPage$CarriersLayout$carriersTableV3Reskin = F6(
	function (tz, carrierTerm, carrierData, showVendorId, useTriumphPayCarrierRemitTo, showLabels) {
		var remoteTmsCarriers = A2($author$project$Forward$Remote$map, $author$project$Pagination$entries, carrierData);
		var remitHeader = useTriumphPayCarrierRemitTo ? 'Remittance, from TriumphPay' : 'Remit Address';
		var paginationAttributes = function () {
			if (carrierData.$ === 'Loaded') {
				var carriers = carrierData.a;
				return _List_fromArray(
					[
						$author$project$Ui$V3$Table$pagination(
						{currentPage: carriers, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$SettingsPage$CarriersLayout$UpdatePage})
					]);
			} else {
				return _List_Nil;
			}
		}();
		var carrierNameAndStatus = function (carrier) {
			return A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
						$author$project$Ui$V3$Stack$crossAxisCenter
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						$elm$core$Maybe$Just(
							A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, carrier.name))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$elm$core$Maybe$map,
							function (posix) {
								return A3(
									$author$project$Ui$V3$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$V3$Tooltip$tooltipWidth(
											$author$project$Ui$V3$Tooltip$FixedWidth(110)),
											$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$RightDirection),
											$author$project$Ui$V3$Tooltip$tooltipLocation($author$project$Ui$V3$Tooltip$MiddleLocation)
										]),
									'inactive ' + A2($author$project$Helpers$Date$dateStringTruncated, tz, posix),
									A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$alertTriangle16));
							},
							carrier.inactiveAt))
					]));
		};
		var columns = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: carrierNameAndStatus,
						heading: $author$project$Components$SettingsPage$CarriersLayout$tableColumnHeading('Name')
					}),
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.scac;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$elm$html$Html$text)),
						heading: $author$project$Components$SettingsPage$CarriersLayout$tableColumnHeading('SCAC')
					}),
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.mcNumber;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$elm$html$Html$text)),
						heading: $author$project$Components$SettingsPage$CarriersLayout$tableColumnHeading('MC#')
					}),
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dotNumber;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$elm$html$Html$text)),
						heading: $author$project$Components$SettingsPage$CarriersLayout$tableColumnHeading('DOT#')
					}),
					showVendorId ? $elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.externalVendorId;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$elm$html$Html$text)),
						heading: $author$project$Components$SettingsPage$CarriersLayout$tableColumnHeading('Vendor ID')
					}) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.paymentAddress;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($author$project$Components$SettingsPage$Carriers$AddressView$view),
								$elm$core$Maybe$withDefault(
									$elm$html$Html$text('')))),
						heading: $author$project$Components$SettingsPage$CarriersLayout$tableColumnHeading(remitHeader)
					}),
					showLabels ? $elm$core$Maybe$Just(
					{
						attrs: _List_Nil,
						content: function (carrier) {
							return $elm$html$Html$text(
								A2(
									$elm$core$String$join,
									', ',
									$elm$core$Set$toList(
										A2($elm$core$Set$union, carrier.labels, carrier.externalLabels))));
						},
						heading: $author$project$Components$SettingsPage$CarriersLayout$tableColumnHeading('Labels')
					}) : $elm$core$Maybe$Nothing
				]));
		return A3(
			$author$project$Ui$V3$Table$viewRemote,
			{columns: columns},
			$elm$core$List$concat(
				_List_fromArray(
					[
						paginationAttributes,
						_List_fromArray(
						[
							$author$project$Ui$V3$Table$clickable(
							{
								onClick: function (carrier) {
									return $author$project$Components$SettingsPage$CarriersLayout$NavigateTo(
										$author$project$Path$toString(
											$author$project$Path$settingsEditCarrier(carrier.id)));
								}
							}),
							$author$project$Ui$V3$Table$defaultEmptyContent(
							{
								body: $elm$core$Maybe$Nothing,
								header: 'No ' + ($elm$core$String$toLower(carrierTerm) + 's found.')
							})
						])
					])),
			remoteTmsCarriers);
	});
var $author$project$Components$SettingsPage$CarriersLayout$tableHeaders = F3(
	function (showVendorId, useTriumphPayCarrierRemitTo, showLabels) {
		var remitHeader = useTriumphPayCarrierRemitTo ? 'Remittance, from TriumphPay' : 'Remit Address';
		return $author$project$Ui$headers(
			A2(
				$elm$core$List$filter,
				function (ui) {
					return !_Utils_eq(ui, $author$project$Ui$empty);
				},
				_List_fromArray(
					[
						$author$project$Ui$text('Name'),
						$author$project$Ui$text('SCAC'),
						$author$project$Ui$text('MC#'),
						$author$project$Ui$text('DOT#'),
						showVendorId ? $author$project$Ui$text('Vendor ID') : $author$project$Ui$empty,
						$author$project$Ui$text(remitHeader),
						showLabels ? $author$project$Ui$text('Labels') : $author$project$Ui$empty,
						$author$project$Ui$text('')
					])));
	});
var $author$project$Ui$tooltipRight = F2(
	function (tooltip, content) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-tooltip__wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-tooltip__right')
							]),
						_List_fromArray(
							[
								$author$project$Ui$toHtml(tooltip)
							])),
						$author$project$Ui$toHtml(content)
					])));
	});
var $author$project$Components$SettingsPage$CarriersLayout$tableRow = F4(
	function (tz, showVendorId, showLabels, tmsCarrier) {
		var paymentAddress = tmsCarrier.paymentAddress;
		var carrierNameAndStatus = function () {
			var _v1 = tmsCarrier.inactiveAt;
			if (_v1.$ === 'Just') {
				var posix = _v1.a;
				return A2(
					$author$project$Ui$inline,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$text(tmsCarrier.name),
							A2(
							$author$project$Ui$tooltipRight,
							A2(
								$author$project$Ui$inline,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$styledSpan,
										_List_fromArray(
											[
												_Utils_Tuple2('background-color', 'white'),
												_Utils_Tuple2('z-index', '10')
											]),
										_List_fromArray(
											[
												$author$project$Ui$text(
												'inactive ' + A2($author$project$Helpers$Date$dateStringTruncated, tz, posix))
											]))
									])),
							A2(
								$author$project$Ui$styledSpan,
								_List_fromArray(
									[
										_Utils_Tuple2('color', 'orange')
									]),
								_List_fromArray(
									[
										$author$project$Ui$icon('alert')
									])))
						]));
			} else {
				return $author$project$Ui$text(tmsCarrier.name);
			}
		}();
		return $author$project$Ui$row(
			A2(
				$elm$core$List$filter,
				function (ui) {
					return !_Utils_eq(ui, $author$project$Ui$empty);
				},
				_List_fromArray(
					[
						carrierNameAndStatus,
						$author$project$Ui$text(
						A2($elm$core$Maybe$withDefault, '', tmsCarrier.scac)),
						$author$project$Ui$text(
						A2($elm$core$Maybe$withDefault, '', tmsCarrier.mcNumber)),
						$author$project$Ui$text(
						A2($elm$core$Maybe$withDefault, '', tmsCarrier.dotNumber)),
						showVendorId ? $author$project$Ui$text(
						A2($elm$core$Maybe$withDefault, '', tmsCarrier.externalVendorId)) : $author$project$Ui$empty,
						function () {
						if (paymentAddress.$ === 'Nothing') {
							return $author$project$Ui$text('');
						} else {
							var x = paymentAddress.a;
							return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
								$author$project$Components$SettingsPage$Carriers$AddressView$view(x));
						}
					}(),
						showLabels ? $author$project$Ui$text(
						A2(
							$elm$core$String$join,
							', ',
							$elm$core$Set$toList(
								A2($elm$core$Set$union, tmsCarrier.labels, tmsCarrier.externalLabels)))) : $author$project$Ui$empty,
						A2(
						$author$project$Ui$inline,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$primary,
								'View',
								$author$project$Components$SettingsPage$CarriersLayout$NavigateTo(
									$author$project$Path$toString(
										$author$project$Path$settingsEditCarrier(tmsCarrier.id))))
							]))
					])));
	});
var $author$project$Components$SettingsPage$CarriersLayout$carriersTable = F6(
	function (tz, carrierTerm, tmsCarriers, showVendorId, useTriumphPayCarrierRemitTo, showLabels) {
		return $elm$core$List$isEmpty(tmsCarriers) ? $author$project$Ui$text(
			'No ' + ($elm$core$String$toLower(carrierTerm) + 's found.')) : A2(
			$author$project$Ui$table,
			A3($author$project$Components$SettingsPage$CarriersLayout$tableHeaders, showVendorId, useTriumphPayCarrierRemitTo, showLabels),
			A2(
				$elm$core$List$map,
				A3($author$project$Components$SettingsPage$CarriersLayout$tableRow, tz, showVendorId, showLabels),
				tmsCarriers));
	});
var $author$project$Helpers$WaitingSpinner$fence = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('waiting-spinner__fence')
			]),
		children);
};
var $author$project$Components$SettingsPage$CarriersLayout$carriersView = F6(
	function (tz, carrierTerm, carrierData, showVendorId, useTriumphPayCarrierRemitTo, showLabels) {
		return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
			$author$project$Helpers$WaitingSpinner$fence(
				_List_fromArray(
					[
						A2(
						$author$project$Forward$LoadingView$view,
						function (data) {
							return $author$project$Ui$toHtml(
								A2(
									$author$project$Ui$stack,
									_List_fromArray(
										[$author$project$Ui$between3]),
									_List_fromArray(
										[
											A6($author$project$Components$SettingsPage$CarriersLayout$carriersTable, tz, carrierTerm, data, showVendorId, useTriumphPayCarrierRemitTo, showLabels),
											$author$project$Ui$paragraph('')
										])));
						},
						carrierData)
					])));
	});
var $author$project$Components$SettingsPage$CarriersLayout$frameView = F2(
	function (v3ReskinEnabled, _v0) {
		var user = _v0.user;
		var accountSettings = _v0.accountSettings;
		var account = _v0.account;
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Carriers, account, accountSettings, user);
	});
var $author$project$Components$SettingsPage$CarriersLayout$heading = function (_v0) {
	var searchTerm = _v0.searchTerm;
	var carrierTerm = _v0.carrierTerm;
	return $elm$core$String$isEmpty(searchTerm) ? ('All ' + (carrierTerm + 's')) : (carrierTerm + ('s Matching \u0022' + (searchTerm + '\u0022')));
};
var $author$project$Components$SettingsPage$CarriersLayout$headingV3Reskin = function (_v0) {
	var searchTerm = _v0.searchTerm;
	var carrierTerm = _v0.carrierTerm;
	return $elm$core$String$isEmpty(searchTerm) ? ('All ' + ($elm$core$String$toLower(carrierTerm) + 's')) : (carrierTerm + ('s matching \u0022' + (searchTerm + '\u0022')));
};
var $author$project$Components$SettingsPage$CarriersLayout$maybePaginationView = function (maybePaginationPage) {
	if (maybePaginationPage.$ === 'Just') {
		var paginationPage = maybePaginationPage.a;
		return $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
			A2($author$project$Pagination$View$view, $author$project$Components$SettingsPage$CarriersLayout$UpdatePage, paginationPage));
	} else {
		return $author$project$Ui$empty;
	}
};
var $author$project$Components$SettingsPage$CarriersLayout$paginationDetails = F2(
	function (carrierData, filtersModel) {
		var loadedPage = $author$project$Forward$Remote$toMaybe(carrierData);
		return _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Pagination$pageNumber, loadedPage),
			$elm$core$Maybe$Just(filtersModel.page)) ? loadedPage : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$SettingsPage$Carriers$Filters$NoOp = {$: 'NoOp'};
var $author$project$Components$SettingsPage$Carriers$Filters$UpdateEligibleForAutoprocessing = function (a) {
	return {$: 'UpdateEligibleForAutoprocessing', a: a};
};
var $author$project$Components$SettingsPage$Carriers$Filters$UpdateScraperOnly = function (a) {
	return {$: 'UpdateScraperOnly', a: a};
};
var $author$project$Components$SettingsPage$Carriers$Filters$UpdateTerm = function (a) {
	return {$: 'UpdateTerm', a: a};
};
var $author$project$Components$SettingsPage$Carriers$Filters$UpdateWithLoginFailures = function (a) {
	return {$: 'UpdateWithLoginFailures', a: a};
};
var $author$project$Components$SettingsPage$Carriers$Filters$ToggleLabel = function (a) {
	return {$: 'ToggleLabel', a: a};
};
var $author$project$Components$SettingsPage$Carriers$Filters$labelFilterViewLegacy = F3(
	function (toMsg, selectedLabels, label) {
		var isSelected = A2($elm$core$Set$member, label.name, selectedLabels);
		var cssClass = isSelected ? 'active' : '';
		return A2(
			$elm$html$Html$dd,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(cssClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							toMsg(
								$author$project$Components$SettingsPage$Carriers$Filters$ToggleLabel(label.name)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label.name)
						]))
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Filters$uniqueLabelsByName = function (labels) {
	var addIfUnique = F2(
		function (label, _v0) {
			var seen = _v0.a;
			var acc = _v0.b;
			return A2($elm$core$Set$member, label.name, seen) ? _Utils_Tuple2(seen, acc) : _Utils_Tuple2(
				A2($elm$core$Set$insert, label.name, seen),
				_Utils_ap(
					acc,
					_List_fromArray(
						[label])));
		});
	return A3(
		$elm$core$List$foldl,
		addIfUnique,
		_Utils_Tuple2($elm$core$Set$empty, _List_Nil),
		labels).b;
};
var $author$project$Components$SettingsPage$Carriers$Filters$view = F4(
	function (account, accountSettings, toMsg, model) {
		var uniqueLabels = $author$project$Components$SettingsPage$Carriers$Filters$uniqueLabelsByName(accountSettings.possibleCarrierLabels);
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between3]),
			_List_fromArray(
				[
					$author$project$Ui$textInput(
					{
						feedback: $elm$core$Maybe$Nothing,
						label: 'Search ' + ($author$project$Domain$Account$carrierTerm(
							$author$project$Domain$Account$accountType(account)) + 's'),
						labelPrefix: $elm$core$Maybe$Nothing,
						onBlur: toMsg($author$project$Components$SettingsPage$Carriers$Filters$NoOp),
						onChange: A2($elm$core$Basics$composeL, toMsg, $author$project$Components$SettingsPage$Carriers$Filters$UpdateTerm),
						placeholder: '',
						value: model.term
					}),
					(account.factorAccount && (!$elm$core$List$isEmpty(uniqueLabels))) ? $author$project$Ui$fromHtml___TEMPORARY_BACKDOOR___DONT_USE(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('filter__filter-container dashboard-filter')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$dt,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('FILTER:')
									])),
								A2(
								$elm$html$Html$dl,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sub-nav')
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Components$SettingsPage$Carriers$Filters$labelFilterViewLegacy, toMsg, model.selectedLabels),
									uniqueLabels))
							]))) : $author$project$Ui$empty,
					(account.factorAccount && accountSettings.factorNextGenAuditEnabled) ? $author$project$Ui$checkbox(
					{
						feedback: $elm$core$Maybe$Nothing,
						label: 'Eligible for Autoprocessing',
						onChange: A2($elm$core$Basics$composeL, toMsg, $author$project$Components$SettingsPage$Carriers$Filters$UpdateEligibleForAutoprocessing),
						value: model.eligibleForAutoprocessing
					}) : $author$project$Ui$empty,
					account.scraperAccount ? A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between4]),
					_List_fromArray(
						[
							$author$project$Ui$checkbox(
							{
								feedback: $elm$core$Maybe$Nothing,
								label: 'With Automatic Document Retrieval Available',
								onChange: A2($elm$core$Basics$composeL, toMsg, $author$project$Components$SettingsPage$Carriers$Filters$UpdateScraperOnly),
								value: model.scraperOnly
							}),
							$author$project$Ui$checkbox(
							{
								feedback: $elm$core$Maybe$Nothing,
								label: 'With Sign-In Failures',
								onChange: A2($elm$core$Basics$composeL, toMsg, $author$project$Components$SettingsPage$Carriers$Filters$UpdateWithLoginFailures),
								value: model.withLoginFailures
							})
						])) : $author$project$Ui$empty
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Filters$ClearTerm = {$: 'ClearTerm'};
var $author$project$Components$SettingsPage$Carriers$Filters$labelChipView = F3(
	function (toMsg, selectedLabels, label) {
		var isSelected = A2($elm$core$Set$member, label.name, selectedLabels);
		var _v0 = isSelected ? _Utils_Tuple3(
			_List_fromArray(
				[
					$author$project$Ui$V3$Chip$Filled(true),
					A2(
					$author$project$Ui$V3$Chip$Style,
					'background',
					$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal600)),
					A2(
					$author$project$Ui$V3$Chip$Style,
					'border-color',
					$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal600))
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$V3$Stack$style, 'color', 'white'),
					A2($author$project$Ui$V3$Stack$style, 'filter', 'brightness(100)')
				]),
			$elm$core$Maybe$Just(
				A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$success16))) : _Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing);
		var chipAttrs = _v0.a;
		var contentAttrs = _v0.b;
		var prefixIcon = _v0.c;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					toMsg(
						$author$project$Components$SettingsPage$Carriers$Filters$ToggleLabel(label.name))),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Chip$viewHtml,
					chipAttrs,
					A2(
						$author$project$Ui$V3$Stack$viewHorzMaybes,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
									$author$project$Ui$V3$Stack$mainAxisCenter,
									$author$project$Ui$V3$Stack$noWrap
								]),
							contentAttrs),
						_List_fromArray(
							[
								prefixIcon,
								$elm$core$Maybe$Just(
								A2(
									$author$project$Ui$V3$Typography$xSmallBody,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
											A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
											$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
										]),
									label.name))
							])))
				]));
	});
var $author$project$Components$SettingsPage$Carriers$Filters$viewV3Reskin = F4(
	function (account, accountSettings, toMsg, model) {
		var uniqueLabels = $author$project$Components$SettingsPage$Carriers$Filters$uniqueLabelsByName(accountSettings.possibleCarrierLabels);
		var searchInput = A4(
			$author$project$Ui$V3$SearchInput$view,
			{
				onClear: toMsg($author$project$Components$SettingsPage$Carriers$Filters$ClearTerm),
				onInput: A2($elm$core$Basics$composeL, toMsg, $author$project$Components$SettingsPage$Carriers$Filters$UpdateTerm)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$SearchInput$placeholder(
					'Search ' + ($author$project$Domain$Account$carrierTerm(
						$author$project$Domain$Account$accountType(account)) + 's'))
				]),
			_List_Nil,
			model.term);
		var labelChips = $elm$core$List$isEmpty(uniqueLabels) ? $elm$html$Html$text('') : A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			A2(
				$elm$core$List$map,
				function (label) {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A3($author$project$Components$SettingsPage$Carriers$Filters$labelChipView, toMsg, model.selectedLabels, label));
				},
				uniqueLabels));
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(searchInput),
					(account.factorAccount && (!$elm$core$List$isEmpty(uniqueLabels))) ? $elm$core$Maybe$Just(labelChips) : $elm$core$Maybe$Nothing,
					(account.factorAccount && accountSettings.factorNextGenAuditEnabled) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Checkbox$view,
						{
							checked: model.eligibleForAutoprocessing,
							label: $elm$html$Html$text('Eligible for Autoprocessing'),
							onCheck: A2($elm$core$Basics$composeL, toMsg, $author$project$Components$SettingsPage$Carriers$Filters$UpdateEligibleForAutoprocessing)
						},
						_List_Nil)) : $elm$core$Maybe$Nothing,
					account.scraperAccount ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$author$project$Ui$V3$Checkbox$view,
									{
										checked: model.scraperOnly,
										label: $elm$html$Html$text('With automatic document retrieval available'),
										onCheck: A2($elm$core$Basics$composeL, toMsg, $author$project$Components$SettingsPage$Carriers$Filters$UpdateScraperOnly)
									},
									_List_Nil)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$author$project$Ui$V3$Checkbox$view,
									{
										checked: model.withLoginFailures,
										label: $elm$html$Html$text('With sign-in failures'),
										onCheck: A2($elm$core$Basics$composeL, toMsg, $author$project$Components$SettingsPage$Carriers$Filters$UpdateWithLoginFailures)
									},
									_List_Nil))
							]))) : $elm$core$Maybe$Nothing
				]));
	});
var $author$project$Components$SettingsPage$CarriersLayout$authorizedView = F4(
	function (v3ReskinEnabled, tz, model, data) {
		var filtersModel = model.filtersModel;
		var carrierTerm = $author$project$Domain$Account$carrierTerm(
			$author$project$Domain$Account$accountType(data.account));
		return v3ReskinEnabled ? A3(
			$author$project$Components$SettingsPage$CarriersLayout$frameView,
			v3ReskinEnabled,
			data,
			$author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$testId('carriers-container'),
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('v3__type__h1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$SettingsPage$CarriersLayout$headingV3Reskin(
										{carrierTerm: carrierTerm, searchTerm: filtersModel.term}))
								])),
							A4($author$project$Components$SettingsPage$Carriers$Filters$viewV3Reskin, data.account, data.accountSettings, $author$project$Components$SettingsPage$CarriersLayout$FiltersMsg, filtersModel),
							A6($author$project$Components$SettingsPage$CarriersLayout$carriersTableV3Reskin, tz, carrierTerm, data.carrierData, data.accountSettings.showCarrierExternalVendorId, data.accountSettings.useTriumphPayCarrierRemitTo, data.account.factorAccount)
						])))) : A3(
			$author$project$Components$SettingsPage$CarriersLayout$frameView,
			v3ReskinEnabled,
			data,
			$author$project$Ui$toHtml(
				A2(
					$author$project$Ui$stack,
					_List_fromArray(
						[$author$project$Ui$between3]),
					_List_fromArray(
						[
							$author$project$Ui$heading2(
							$author$project$Components$SettingsPage$CarriersLayout$heading(
								{carrierTerm: carrierTerm, searchTerm: filtersModel.term})),
							A4($author$project$Components$SettingsPage$Carriers$Filters$view, data.account, data.accountSettings, $author$project$Components$SettingsPage$CarriersLayout$FiltersMsg, filtersModel),
							A2(
							$author$project$Ui$stack,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$CarriersLayout$maybePaginationView(
									A2($author$project$Components$SettingsPage$CarriersLayout$paginationDetails, data.carrierData, filtersModel))
								])),
							A6(
							$author$project$Components$SettingsPage$CarriersLayout$carriersView,
							tz,
							carrierTerm,
							A2($author$project$Forward$Remote$map, $author$project$Pagination$entries, data.carrierData),
							data.accountSettings.showCarrierExternalVendorId,
							data.accountSettings.useTriumphPayCarrierRemitTo,
							data.account.factorAccount)
						]))));
	});
var $author$project$Components$SettingsPage$CarriersLayout$view = F4(
	function (v3ReskinEnabled, tz, model, data) {
		return data.user.hasSettingsRole ? A4($author$project$Components$SettingsPage$CarriersLayout$authorizedView, v3ReskinEnabled, tz, model, data) : A3(
			$author$project$Components$SettingsPage$CarriersLayout$frameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.'));
	});
var $author$project$Components$SettingsPage$CustomerLayout$ContactForm = F5(
	function (id, name, email, saving, error) {
		return {email: email, error: error, id: id, name: name, saving: saving};
	});
var $author$project$Components$SettingsPage$CustomerLayout$blankEmail = $author$project$Domain$EmailAddress$fromString('');
var $author$project$Components$SettingsPage$CustomerLayout$Contact_Save = {$: 'Contact_Save'};
var $author$project$Components$SettingsPage$CustomerLayout$Contact_Set = function (a) {
	return {$: 'Contact_Set', a: a};
};
var $author$project$Components$SettingsPage$CustomerLayout$contactFormButtons = function (contact) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('contact-list__save'),
						$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$CustomerLayout$Contact_Save),
						$elm$html$Html$Attributes$disabled(contact.saving)
					]),
				_List_fromArray(
					[
						contact.saving ? $elm$html$Html$text('Saving...') : $elm$html$Html$text('Save')
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' - or -')
					])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('contact-list__cancel'),
						$elm$html$Html$Events$onClick(
						$author$project$Components$SettingsPage$CustomerLayout$Contact_Set($elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('cancel')
					]))
			]));
};
var $author$project$Components$SettingsPage$CustomerLayout$contactFormField = F2(
	function (error, data) {
		var fieldId = 'contact_' + data.field;
		var classes = _List_fromArray(
			[
				_Utils_Tuple2('inline', true),
				_Utils_Tuple2('right', true),
				_Utils_Tuple2(
				'error',
				A3(
					$author$project$Components$SettingsPage$CustomerLayout$maybe,
					false,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fields;
						},
						$elm$core$List$member(data.field)),
					error))
			]);
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(classes),
						$elm$html$Html$Attributes$for(fieldId)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(data.title)
					])),
			A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(fieldId),
						$elm$html$Html$Attributes$placeholder(data.title),
						$elm$html$Html$Attributes$type_(data.type_),
						$elm$html$Html$Attributes$value(data.defaultValue),
						$elm$html$Html$Events$onInput(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CustomerLayout$Contact_Set, $elm$core$Maybe$Just),
							data.setter))
					]),
				_List_Nil));
	});
var $author$project$Components$SettingsPage$CustomerLayout$empty = $elm$html$Html$text('');
var $author$project$Components$SettingsPage$CustomerLayout$contactFormGrid = F2(
	function (error, fields) {
		var formRows = A2(
			$elm$core$List$map,
			function (_v0) {
				var left = _v0.a;
				var right = _v0.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Grid$column,
							2,
							_List_fromArray(
								[left])),
							A2(
							$author$project$Components$Shared$Grid$column,
							8,
							_List_fromArray(
								[right]))
						]));
			},
			fields);
		var errorRow = A3(
			$author$project$Components$SettingsPage$CustomerLayout$maybe,
			$author$project$Components$SettingsPage$CustomerLayout$empty,
			function (e) {
				return A2(
					$author$project$Components$Shared$Grid$autoRow,
					12,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('alert-box alert')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(e.message)
								]))
						]));
			},
			error);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-list__row__editing')
				]),
			A2($elm$core$List$cons, errorRow, formRows));
	});
var $author$project$Components$SettingsPage$CustomerLayout$contactListEditor = function (contact) {
	return A2(
		$author$project$Components$SettingsPage$CustomerLayout$contactFormGrid,
		contact.error,
		_List_fromArray(
			[
				A2(
				$author$project$Components$SettingsPage$CustomerLayout$contactFormField,
				contact.error,
				{
					defaultValue: contact.name,
					field: 'name',
					setter: function (x) {
						return _Utils_update(
							contact,
							{name: x});
					},
					title: 'Name',
					type_: 'text'
				}),
				A2(
				$author$project$Components$SettingsPage$CustomerLayout$contactFormField,
				contact.error,
				{
					defaultValue: $author$project$Domain$EmailAddress$toString(contact.email),
					field: 'email',
					setter: function (x) {
						return _Utils_update(
							contact,
							{
								email: $author$project$Domain$EmailAddress$fromString(x)
							});
					},
					title: 'Email',
					type_: 'email'
				}),
				_Utils_Tuple2(
				$author$project$Components$SettingsPage$CustomerLayout$empty,
				$author$project$Components$SettingsPage$CustomerLayout$contactFormButtons(contact))
			]));
};
var $author$project$Components$SettingsPage$CustomerLayout$Contact_Delete = function (a) {
	return {$: 'Contact_Delete', a: a};
};
var $author$project$Components$SettingsPage$CustomerLayout$contactListAction = F2(
	function (attrs, inner) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('contact-list__action'),
				attrs),
			_List_fromArray(
				[inner]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$editContact = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $elm$html$Html$Events$onClick, $author$project$Components$SettingsPage$CustomerLayout$Contact_Set),
	$elm$core$Maybe$Just);
var $author$project$Components$SettingsPage$CustomerLayout$if_ = F3(
	function (condition, func, value) {
		return condition ? func(value) : value;
	});
var $author$project$Components$SettingsPage$CustomerLayout$when = F3(
	function (condition, func, value) {
		return condition ? func(value) : $author$project$Components$SettingsPage$CustomerLayout$empty;
	});
var $author$project$Components$SettingsPage$CustomerLayout$contactListRow = F2(
	function (accountSettings, contact) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-list__row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Components$SettingsPage$CustomerLayout$if_,
							contact.deleted,
							function (x) {
								return A3(
									$elm$html$Html$node,
									'strike',
									_List_fromArray(
										[
											$elm$html$Html$Attributes$title('Deleted')
										]),
									_List_fromArray(
										[x]));
							},
							$elm$html$Html$text(
								A3(
									$author$project$Components$SettingsPage$CustomerLayout$if_,
									contact.name !== '',
									function (x) {
										return contact.name + (' <' + (x + '>'));
									},
									A3(
										$author$project$Components$SettingsPage$CustomerLayout$if_,
										$elm$core$String$isEmpty(contact.email),
										function (_v0) {
											return 'Not Provided';
										},
										contact.email))))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('contact-list__actions')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Components$SettingsPage$CustomerLayout$when,
							(!contact.deleted) && accountSettings.brokerCustomerPortalEnabled,
							$author$project$Components$SettingsPage$CustomerLayout$contactListAction(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/customer_portal/shipment_status/' + contact.urlHash),
										$elm$html$Html$Attributes$target('_blank')
									])),
							$elm$html$Html$text('Customer portal')),
							A2(
							$author$project$Components$SettingsPage$CustomerLayout$contactListAction,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$CustomerLayout$editContact(
									A5(
										$author$project$Components$SettingsPage$CustomerLayout$ContactForm,
										$elm$core$Maybe$Just(contact.id),
										contact.name,
										$author$project$Domain$EmailAddress$fromString(contact.email),
										false,
										$elm$core$Maybe$Nothing))
								]),
							A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fi-pencil'),
										$elm$html$Html$Attributes$title('Edit')
									]),
								_List_Nil)),
							A3(
							$author$project$Components$SettingsPage$CustomerLayout$when,
							!contact.deleted,
							$author$project$Components$SettingsPage$CustomerLayout$contactListAction(
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Components$SettingsPage$CustomerLayout$Contact_Delete(contact))
									])),
							A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fi-trash'),
										$elm$html$Html$Attributes$title('Delete')
									]),
								_List_Nil))
						]))
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$contactListView = F3(
	function (accountSettings, all, contactForm) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Contacts')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('contact-list')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Components$SettingsPage$CustomerLayout$maybe,
						A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('contact-list__list')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$SettingsPage$CustomerLayout$contactListRow(accountSettings),
								all)),
						$author$project$Components$SettingsPage$CustomerLayout$contactListEditor,
						contactForm),
						A3(
						$author$project$Components$SettingsPage$CustomerLayout$when,
						_Utils_eq(contactForm, $elm$core$Maybe$Nothing),
						$elm$html$Html$a(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button primary'),
									$author$project$Components$SettingsPage$CustomerLayout$editContact(
									A5($author$project$Components$SettingsPage$CustomerLayout$ContactForm, $elm$core$Maybe$Nothing, '', $author$project$Components$SettingsPage$CustomerLayout$blankEmail, false, $elm$core$Maybe$Nothing))
								])),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fi-plus')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' New Contact')
									]))
							]))
					]))
			]);
	});
var $author$project$Components$SettingsPage$CustomerLayout$row1 = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			])),
	$elm$core$List$singleton);
var $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This setting is being pulled directly from the TMS. To make changes, modify in your TMS.')
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$CustomerLayout$billingEmailsSection = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.emailDeliveryRecipientAddress ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$billingIntervalSection = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.customerBillingInterval ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$sectionView = F2(
	function (innerHeader, innerBody) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-header')
						]),
					innerHeader),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-body')
						]),
					innerBody)
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$customExceptionMessagesWarning = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('alert-box alert')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Warning: Adding a custom exception message will trigger an exception on every invoice that matches the rule criteria and prevent processing until the rule is manually ignored.')
		]));
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ClickedSave = {$: 'ClickedSave'};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ClickedUndo = {$: 'ClickedUndo'};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewControls = function (model) {
	var buttons = $author$project$Helpers$Savable$hasChanged(model.items) ? {
		revert: A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button--link'),
					$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ClickedUndo)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Undo changes')
				])),
		save: A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button--confirmation'),
					$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ClickedSave)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Save')
				]))
	} : {
		revert: $elm$html$Html$text(''),
		save: A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Save')
				]))
	};
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button__row')
			]),
		_List_fromArray(
			[buttons.save, buttons.revert]));
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$Add = function (a) {
	return {$: 'Add', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$DoNothing = {$: 'DoNothing'};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$UpdateInput = function (a) {
	return {$: 'UpdateInput', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewNewRuleForm = function (_v0) {
	var newRuleInput = _v0.newRuleInput;
	var _v1 = $elm$core$String$isEmpty(newRuleInput) ? _Utils_Tuple2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$DoNothing, 'button') : _Utils_Tuple2(
		$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$Add(
			{message: newRuleInput, typesSelection: $author$project$Domain$CustomExceptionMessage$Payment}),
		'button--confirmation');
	var submitMsg = _v1.a;
	var buttonClass = _v1.b;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				$elm$html$Html$Events$onSubmit(submitMsg)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'flex', '1'),
						A2($elm$html$Html$Attributes$style, 'margin-right', '8px'),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$value(newRuleInput),
						$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$UpdateInput)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(buttonClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add rule')
					]))
			]));
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$displayedRules = function (accountSettings) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.typesSelection;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$Domain$CustomExceptionMessage$displayed(accountSettings.auditBillingEnabled),
				$elm$core$Basics$neq($elm$core$Maybe$Nothing))));
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$Remove = function (a) {
	return {$: 'Remove', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewRemoveLink = function (item) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'margin-left', 'auto'),
				A2($elm$html$Html$Attributes$style, 'text-align', 'right'),
				$elm$html$Html$Attributes$class('button--link danger'),
				$elm$html$Html$Events$onClick(
				$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$Remove(item))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Remove')
			]));
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$allTypesSelections = function (accountSettings) {
	return accountSettings.auditBillingEnabled ? _List_fromArray(
		[$author$project$Domain$CustomExceptionMessage$Both, $author$project$Domain$CustomExceptionMessage$Billing, $author$project$Domain$CustomExceptionMessage$Payment]) : _List_fromArray(
		[$author$project$Domain$CustomExceptionMessage$Payment]);
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ChangeTypes = F2(
	function (a, b) {
		return {$: 'ChangeTypes', a: a, b: b};
	});
var $author$project$Domain$CustomExceptionMessage$bothType = 'both';
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$onTypesChange = F2(
	function (customExceptionMessage, selection) {
		return _Utils_eq(selection, $author$project$Domain$CustomExceptionMessage$bothType) ? A2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ChangeTypes, customExceptionMessage, $author$project$Domain$CustomExceptionMessage$Both) : (_Utils_eq(selection, $author$project$Domain$CustomExceptionMessage$paymentType) ? A2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ChangeTypes, customExceptionMessage, $author$project$Domain$CustomExceptionMessage$Payment) : (_Utils_eq(selection, $author$project$Domain$CustomExceptionMessage$billingType) ? A2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ChangeTypes, customExceptionMessage, $author$project$Domain$CustomExceptionMessage$Billing) : $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$DoNothing));
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$typesSelectionToStr = function (typesSelection) {
	switch (typesSelection.$) {
		case 'Both':
			return 'Bill and Pay';
		case 'Billing':
			return 'Bill';
		case 'Payment':
			return 'Payment';
		default:
			return 'Unknown';
	}
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$typesSelectionToValue = function (typesSelection) {
	switch (typesSelection.$) {
		case 'Both':
			return $author$project$Domain$CustomExceptionMessage$bothType;
		case 'Billing':
			return $author$project$Domain$CustomExceptionMessage$billingType;
		case 'Payment':
			return $author$project$Domain$CustomExceptionMessage$paymentType;
		default:
			return '';
	}
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewTypes = F2(
	function (accountSettings, customExceptionMessage) {
		return accountSettings.auditBillingEnabled ? A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput(
					$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$onTypesChange(customExceptionMessage))
				]),
			A2(
				$elm$core$List$map,
				function (typesSelection) {
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$typesSelectionToValue(typesSelection)),
								$elm$html$Html$Attributes$selected(
								_Utils_eq(typesSelection, customExceptionMessage.typesSelection))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$typesSelectionToStr(typesSelection))
							]));
				},
				$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$allTypesSelections(accountSettings))) : $elm$html$Html$text(
			$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$typesSelectionToStr(
				A2(
					$elm$core$Maybe$withDefault,
					customExceptionMessage.typesSelection,
					A2($author$project$Domain$CustomExceptionMessage$displayed, false, customExceptionMessage.typesSelection))));
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewRules = F2(
	function (accountSettings, allItems) {
		var items = A2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$displayedRules, accountSettings, allItems);
		return $elm$core$List$isEmpty(items) ? $elm$html$Html$text('') : $author$project$Components$Shared$Table$view(
			{
				columns: _List_fromArray(
					[
						{
						header: 'Message',
						view: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.message;
							},
							$elm$html$Html$text)
					},
						{
						header: 'Related to',
						view: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewTypes(accountSettings)
					},
						{header: '', view: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewRemoveLink}
					]),
				data: A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.message;
					},
					items)
			});
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
				A2($elm$html$Html$Attributes$style, 'max-width', '540px')
			]),
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$customExceptionMessagesWarning,
				A2(
				$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewRules,
				model.accountSettings,
				$author$project$Helpers$Savable$value(model.items)),
				$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewNewRuleForm(model),
				$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewControls(model)
			]));
};
var $author$project$Components$SettingsPage$CustomerLayout$customExceptionMessagesSection = F2(
	function (customExceptionMessages, accountSettings) {
		return accountSettings.controlledByTMS.customExceptionMessages ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection('Custom Exception Messages') : A2(
			$author$project$Components$SettingsPage$CustomerLayout$sectionView,
			_List_fromArray(
				[
					$elm$html$Html$text('Custom Exception Messages')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('These rules will only apply to this customer, when processing carrier invoices. In addition to the '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/app/settings/rules')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('account\u0027s custom exception messages')
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$CustomerLayout$CustomExceptionMessagesUpdate,
					$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$view(customExceptionMessages))
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$customerInstructionsSection = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.customerInstructions ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$deliveryMethodSection = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.deliveryMethod ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentSection = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerInvoiceTemplates ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateSection = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerInvoiceTemplates ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateSection = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerLtlRerate ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginSection = F2(
	function (config, state) {
		return A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlToleranceSection = F2(
	function (config, state) {
		return A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$masterInvoiceTemplateSection = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerInvoiceTemplates ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$podRequirementSection = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.customerRequiredDocs ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$statementInvoiceTemplateSection = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerInvoiceTemplates ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSection(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$view, config, state);
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnRowCheck = function (a) {
	return {$: 'OnRowCheck', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnRowUncheck = function (a) {
	return {$: 'OnRowUncheck', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$SetPayablesValue = F2(
	function (a, b) {
		return {$: 'SetPayablesValue', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnRevertClick = {$: 'OnRevertClick'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnSaveClick = {$: 'OnSaveClick'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$spacer = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'width', '1rem'),
			A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
		]),
	_List_Nil);
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Button = {$: 'Button'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewNode = F2(
	function (node, _v0) {
		var labels = _v0.labels;
		var loadingStatus = _v0.loadingStatus;
		var status = _v0.status;
		var onClick = _v0.onClick;
		var fn = function () {
			if (node.$ === 'Button') {
				return $elm$html$Html$button;
			} else {
				return $elm$html$Html$a;
			}
		}();
		return A2(
			fn,
			_Utils_ap(
				(!_Utils_eq(status, loadingStatus)) ? _List_fromArray(
					[
						$elm$html$Html$Events$onClick(onClick)
					]) : _List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'button--confirmation',
								_Utils_eq(node, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Button) && (!_Utils_eq(status, loadingStatus)))
							]))
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(
					_Utils_eq(status, loadingStatus) ? labels.loading : labels.ready)
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewButton = $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewNode($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Button);
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Link = {$: 'Link'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewLink = $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewNode($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Link);
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewControls = function (status) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('buttons')
			]),
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewButton(
				{
					labels: {loading: 'Saving...', ready: 'Save'},
					loadingStatus: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Saving,
					onClick: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnSaveClick,
					status: status
				}),
				$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$spacer,
				$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewLink(
				{
					labels: {loading: 'Reverting...', ready: 'Use account settings'},
					loadingStatus: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Reverting,
					onClick: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnRevertClick,
					status: status
				}),
				$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$spacer,
				function () {
				if (status.$ === 'Success') {
					var message = status.a;
					return A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$isSameAsGlobal = function (model) {
	return _Utils_eq(model.rowsSinceLastSave, model.globalRows);
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewHeader = F2(
	function (descriptions, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Document Types')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							A2(
								$elm$html$Html$p,
								_List_Nil,
								$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$isSameAsGlobal(model) ? descriptions.sameAsGlobal : descriptions.hasDifferences))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewReadOnlyRow = F2(
	function (columns, row) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (fn) {
					return fn(row);
				},
				columns));
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewRow = F3(
	function (columns, messages, row) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (column) {
					return column.isDisabled ? column.viewDisabled(row) : A2(column.view, messages, row);
				},
				columns));
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnMakeChangesClick = {$: 'OnMakeChangesClick'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewSameAsGlobalControls = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button--confirmation'),
					$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnMakeChangesClick)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Edit Document Types '),
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-pencil')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$view = F3(
	function (config, account, model) {
		var options = {
			account: account,
			headers: A2(
				$elm$core$List$map,
				function ($) {
					return $.header;
				},
				config.columns),
			isEditable: config.isAdmin && (!model.keepGlobalSettings),
			messages: {onCheck: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnRowCheck, onUncheck: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnRowUncheck, setPayablesValue: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$SetPayablesValue},
			rows: model.rows,
			viewReadOnlyRow: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewReadOnlyRow(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.viewDisabled;
					},
					config.columns)),
			viewRow: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewRow(config.columns)
		};
		return config.isAdmin ? (model.keepGlobalSettings ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewHeader, config.descriptions, model),
					$author$project$Components$SettingsPage$Shared$DocumentTypeTable$view(options),
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewSameAsGlobalControls
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewHeader, config.descriptions, model),
					$author$project$Components$SettingsPage$Shared$DocumentTypeTable$view(options),
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewControls(model.status)
				]))) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewHeader, config.descriptions, model),
					$author$project$Components$SettingsPage$Shared$DocumentTypeTable$view(options)
				]));
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$hasItems = function (model) {
	return !$elm$core$List$isEmpty(
		$author$project$Helpers$Savable$value(model.items));
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$RevertChanges = {$: 'RevertChanges'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$ClickedSave = function (a) {
	return {$: 'ClickedSave', a: a};
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewSaveButton = function (model) {
	return $author$project$Helpers$Savable$hasChanged(model.items) ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button button--confirmation'),
				A2($elm$html$Html$Attributes$style, 'margin', '0'),
				$elm$html$Html$Events$onClick(
				$author$project$Components$SettingsPage$Shared$ReferenceTable$ClickedSave(
					{v3ReskinEnabled: false}))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Save changes')
			])) : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button'),
				A2($elm$html$Html$Attributes$style, 'margin', '0')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Save changes')
			]));
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewControls = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center')
			]),
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$Shared$ReferenceTable$viewSaveButton(model),
				$author$project$Helpers$Savable$hasChanged(model.items) ? A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-left', '1rem'),
						$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$Shared$ReferenceTable$RevertChanges)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Undo changes')
					])) : $elm$html$Html$text(''),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-left', '1rem')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(model.message)
					]))
			]));
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$AddReference = function (a) {
	return {$: 'AddReference', a: a};
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$SelectReference = function (a) {
	return {$: 'SelectReference', a: a};
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewReferenceDropdown = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'min-width', '250px')
			]),
		_List_fromArray(
			[
				$author$project$Components$Shared$Select$view(
				{choices: model.references, disabledChoices: _List_Nil, onChange: $author$project$Components$SettingsPage$Shared$ReferenceTable$SelectReference, placeholder: 'Add a new rule', sortAlphabetically: false, toString: $elm$core$Basics$identity, value: model.selectedReference}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
					]),
				_List_Nil),
				A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add')
						])),
				A2(
					$elm$core$Maybe$map,
					function (ref) {
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button--confirmation'),
									$elm$html$Html$Events$onClick(
									$author$project$Components$SettingsPage$Shared$ReferenceTable$AddReference(ref))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add')
								]));
					},
					model.selectedReference))
			]));
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$Remove = {$: 'Remove'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$UpdateItem = F2(
	function (a, b) {
		return {$: 'UpdateItem', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewRemove = function (item) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2($author$project$Components$SettingsPage$Shared$ReferenceTable$UpdateItem, item, $author$project$Components$SettingsPage$Shared$ReferenceTable$Remove))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Remove')
			]));
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$SetOption = function (a) {
	return {$: 'SetOption', a: a};
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$SetValue = function (a) {
	return {$: 'SetValue', a: a};
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$optionNeedsInput = function (option) {
	switch (option.$) {
		case 'IsPresentOption':
			return false;
		case 'HasValueOption':
			return true;
		case 'NotValueOption':
			return true;
		case 'BeginsWithOption':
			return true;
		default:
			return false;
	}
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$optionToString = function (option) {
	return $author$project$Domain$ReferenceRule$verb(
		A2($author$project$Components$SettingsPage$Shared$ReferenceTable$ruleFor, option, ''));
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewRule = function (item) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex')
			]),
		_List_fromArray(
			[
				$author$project$Components$Shared$Select$view(
				{
					choices: _List_fromArray(
						[$author$project$Components$SettingsPage$Shared$ReferenceTable$IsPresentOption, $author$project$Components$SettingsPage$Shared$ReferenceTable$IsEmptyOption, $author$project$Components$SettingsPage$Shared$ReferenceTable$HasValueOption, $author$project$Components$SettingsPage$Shared$ReferenceTable$NotValueOption, $author$project$Components$SettingsPage$Shared$ReferenceTable$BeginsWithOption]),
					disabledChoices: _List_Nil,
					onChange: A2(
						$elm$core$Basics$composeL,
						$author$project$Components$SettingsPage$Shared$ReferenceTable$UpdateItem(item),
						$author$project$Components$SettingsPage$Shared$ReferenceTable$SetOption),
					placeholder: 'Select a rule',
					sortAlphabetically: false,
					toString: $author$project$Components$SettingsPage$Shared$ReferenceTable$optionToString,
					value: $elm$core$Maybe$Just(item.option)
				}),
				$author$project$Components$SettingsPage$Shared$ReferenceTable$optionNeedsInput(item.option) ? A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$value(item.value),
						$elm$html$Html$Events$onInput(
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$SettingsPage$Shared$ReferenceTable$UpdateItem(item),
							$author$project$Components$SettingsPage$Shared$ReferenceTable$SetValue)),
						A2($elm$html$Html$Attributes$style, 'margin', '0'),
						A2($elm$html$Html$Attributes$style, 'margin-left', '8px')
					]),
				_List_Nil) : $elm$html$Html$text('')
			]));
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
				A2($elm$html$Html$Attributes$style, 'max-width', '540px')
			]),
		_List_fromArray(
			[
				$author$project$Components$SettingsPage$Shared$ReferenceTable$viewReferenceDropdown(model),
				$author$project$Components$SettingsPage$Shared$ReferenceTable$hasItems(model) ? $author$project$Components$Shared$Table$view(
				{
					columns: _List_fromArray(
						[
							{
							header: 'Reference',
							view: A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.label;
								},
								$elm$html$Html$text)
						},
							{header: 'Rule', view: $author$project$Components$SettingsPage$Shared$ReferenceTable$viewRule},
							{header: '', view: $author$project$Components$SettingsPage$Shared$ReferenceTable$viewRemove}
						]),
					data: $author$project$Helpers$Savable$value(model.items)
				}) : A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'opacity', '0.5')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No reference rules.')
					])),
				$author$project$Components$SettingsPage$Shared$ReferenceTable$viewControls(model)
			]));
};
var $author$project$Components$SettingsPage$CustomerLayout$sections = F3(
	function (customerId, data, formState) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$SettingsPage$Shared$EditSection$view,
				$author$project$Components$SettingsPage$CustomerLayout$paymentTermsConfig(customerId),
				formState.paymentTerms),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$billingIntervalSection,
				$author$project$Components$SettingsPage$CustomerLayout$billingIntervalConfig(customerId),
				formState.billingInterval,
				data.accountSettings),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.currentAccount.receivablesAccount,
				A2(
					$author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateSection,
					A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfig, $author$project$Components$SettingsPage$CustomerLayout$InvoiceTemplate, customerId, data.invoiceTemplates),
					data.accountSettings),
				formState.invoiceTemplate),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.accountSettings.ltlTolerancesEnabled,
				$author$project$Components$SettingsPage$CustomerLayout$ltlToleranceSection(
					$author$project$Components$SettingsPage$CustomerLayout$ltlToleranceConfig(customerId)),
				formState.ltlTolerance),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.accountSettings.ltlCustomerMarginToleranceEnabled,
				$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginSection(
					$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginToleranceConfig(customerId)),
				formState.ltlCustomerMarginTolerance),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.accountSettings.ltlRerateEnabled,
				A2(
					$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateSection,
					$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateConfig(customerId),
					data.accountSettings),
				formState.ltlCustomerAutoRate),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.accountSettings.ltlReweighChargeExceptionsEnabled,
				$author$project$Components$SettingsPage$Shared$EditSection$view(
					$author$project$Components$SettingsPage$CustomerLayout$ltlReweighChargeExceptionsConfig(customerId)),
				formState.ltlReweighChargeExceptions),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.accountSettings.ltlReweighChargeExceptionsEnabled && data.customerSettings.ltlReweighChargeExceptionsEnabled,
				$author$project$Components$SettingsPage$Shared$EditSection$view(
					$author$project$Components$SettingsPage$CustomerLayout$ltlRequireManualReweighReviewConfig(customerId)),
				formState.ltlRequireManualReweighReview),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.currentAccount.receivablesAccount && data.currentAccount.payablesAccount,
				A2(
					$author$project$Components$SettingsPage$CustomerLayout$statementInvoiceTemplateSection,
					A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfig, $author$project$Components$SettingsPage$CustomerLayout$StatementInvoiceTemplate, customerId, data.invoiceTemplates),
					data.accountSettings),
				formState.statementInvoiceTemplate),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.currentAccount.receivablesAccount && data.currentAccount.payablesAccount,
				A2(
					$author$project$Components$SettingsPage$CustomerLayout$masterInvoiceTemplateSection,
					A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfig, $author$project$Components$SettingsPage$CustomerLayout$MasterInvoiceTemplate, customerId, data.invoiceTemplates),
					data.accountSettings),
				formState.masterInvoiceTemplate),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.currentAccount.receivablesAccount && ($elm$core$List$length(data.remitToAddresses) > 1),
				$author$project$Components$SettingsPage$Shared$EditSection$view(
					A2($author$project$Components$SettingsPage$CustomerLayout$remitToAddressConfig, customerId, data.remitToAddresses)),
				formState.remitToAddress),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$customerInstructionsSection,
				$author$project$Components$SettingsPage$CustomerLayout$instructionsConfig(customerId),
				formState.instructions,
				data.accountSettings),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$deliveryMethodSection,
				A2($author$project$Components$SettingsPage$CustomerLayout$deliveryMethodConfig, customerId, data),
				formState.deliveryMethod,
				data.accountSettings),
				A2(
				$author$project$Components$SettingsPage$Shared$EditSection$view,
				A3($author$project$Components$SettingsPage$CustomerLayout$customSubjectConfig, customerId, data.customerSettings, data.accountSettings),
				formState.customSubject),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$billingEmailsSection,
				$author$project$Components$SettingsPage$CustomerLayout$billingEmailConfig(customerId),
				formState.billingEmail,
				data.accountSettings),
				A2(
				$elm$html$Html$map,
				$author$project$Components$SettingsPage$CustomerLayout$DocumentTypesUpdate,
				A3(
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$view,
					A2($author$project$Components$SettingsPage$CustomerLayout$documentTypesSettingsFromData, customerId, data),
					data.currentAccount,
					formState.documentTypes)),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$podRequirementSection,
				$author$project$Components$SettingsPage$CustomerLayout$podRequirementPolicyConfig(customerId),
				formState.podRequirementPolicy,
				data.accountSettings),
				A3(
				$author$project$Components$SettingsPage$CustomerLayout$when,
				data.currentAccount.receivablesAccount,
				A2(
					$author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentSection,
					$author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentConfig(customerId),
					data.accountSettings),
				formState.ignoreInvoiceDocument),
				A2(
				$author$project$Components$SettingsPage$CustomerLayout$sectionView,
				_List_fromArray(
					[
						$elm$html$Html$text('Required References')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('These rules will only apply to this customer, in addition to the '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/app/settings/rules')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('account\u0027s reference rules')
									])),
								$elm$html$Html$text('.')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Components$SettingsPage$CustomerLayout$ReferencesUpdate,
						$author$project$Components$SettingsPage$Shared$ReferenceTable$view(formState.requiredReferences))
					])),
				A2($author$project$Components$SettingsPage$CustomerLayout$customExceptionMessagesSection, formState.customExceptionMessages, data.accountSettings)
			]);
	});
var $author$project$Components$SettingsPage$CustomerLayout$settingsFrameView = F2(
	function (v3ReskinEnabled, data) {
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Customers, data.currentAccount, data.accountSettings, data.currentUser);
	});
var $author$project$Components$SettingsPage$CustomerLayout$GoBack = {$: 'GoBack'};
var $author$project$Components$SettingsPage$CustomerLayout$titleView = F2(
	function (name, accountNumber) {
		return $author$project$Components$SettingsPage$CustomerLayout$row1(
			A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$author$project$Helpers$GenericLink$genericLink,
						$author$project$Components$SettingsPage$CustomerLayout$GoBack,
						_List_Nil,
						'#',
						_List_fromArray(
							[
								$elm$html$Html$text('« ')
							])),
						$elm$html$Html$text(
						_Utils_ap(
							name,
							A3(
								$author$project$Components$SettingsPage$CustomerLayout$maybe,
								'',
								function (x) {
									return ' (' + (x + ')');
								},
								accountNumber)))
					])));
	});
var $author$project$Components$SettingsPage$CustomerLayout$authorizedView = F2(
	function (model, data) {
		var formState = A2($author$project$Components$SettingsPage$CustomerLayout$currentFormState, data, model);
		return A3(
			$author$project$Components$SettingsPage$CustomerLayout$settingsFrameView,
			false,
			data,
			A2(
				$author$project$Components$Shared$Grid$column,
				12,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Grid$autoRow,
						10,
						_List_fromArray(
							[
								A2($author$project$Components$SettingsPage$CustomerLayout$titleView, data.customerSettings.name, data.customerSettings.accountNumber)
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Components$SettingsPage$CustomerLayout$LoadedMsg,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Shared$Grid$column,
									5,
									A2(
										$elm$core$List$map,
										$author$project$Components$SettingsPage$CustomerLayout$row1,
										A3($author$project$Components$SettingsPage$CustomerLayout$sections, model.customerId, data, formState))),
									A2(
									$author$project$Components$Shared$Grid$column,
									5,
									A3($author$project$Components$SettingsPage$CustomerLayout$contactListView, data.accountSettings, data.customerSettings.contacts, formState.contactForm))
								])))
					])));
	});
var $author$project$Ui$V3$Input$email = $author$project$Ui$V3$Input$TypeAttribute('email');
var $author$project$Components$SettingsPage$CustomerLayout$contactListEditorV3Reskin = function (contact) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorz,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$V3$Input$view,
						{
							onInput: A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CustomerLayout$Contact_Set, $elm$core$Maybe$Just),
								function (x) {
									return _Utils_update(
										contact,
										{name: x});
								})
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$label('Name')
							]),
						_List_Nil,
						contact.name),
						A4(
						$author$project$Ui$V3$Input$view,
						{
							onInput: A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$CustomerLayout$Contact_Set, $elm$core$Maybe$Just),
								function (x) {
									return _Utils_update(
										contact,
										{
											email: $author$project$Domain$EmailAddress$fromString(x)
										});
								})
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$label('Email'),
								$author$project$Ui$V3$Input$email
							]),
						_List_Nil,
						$author$project$Domain$EmailAddress$toString(contact.email))
					])),
				$author$project$Helpers$Html$editButtons(
				{
					cancelMsg: $author$project$Components$SettingsPage$CustomerLayout$Contact_Set($elm$core$Maybe$Nothing),
					primaryDisabled: contact.saving,
					primaryLabel: 'Save',
					primaryMsg: $author$project$Components$SettingsPage$CustomerLayout$Contact_Save
				})
			]));
};
var $author$project$Components$SettingsPage$CustomerLayout$contactListRowV3Reskin = F2(
	function (accountSettings, contact) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[$author$project$Ui$V3$Typography$smallBodySemiBoldClass]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$SettingsPage$CustomerLayout$if_,
									contact.deleted,
									function (x) {
										return A3(
											$elm$html$Html$node,
											'strike',
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title('Deleted')
												]),
											_List_fromArray(
												[x]));
									},
									$elm$html$Html$text(
										A3(
											$author$project$Components$SettingsPage$CustomerLayout$if_,
											contact.name !== '',
											$elm$core$Basics$always(contact.name),
											A3(
												$author$project$Components$SettingsPage$CustomerLayout$if_,
												$elm$core$String$isEmpty(contact.email),
												function (_v0) {
													return 'Not Provided';
												},
												contact.email))))
								])))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					((!contact.deleted) && accountSettings.brokerCustomerPortalEnabled) ? $elm$core$Maybe$Just(
						A2(
							$author$project$Components$SettingsPage$CustomerLayout$contactListAction,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/customer_portal/shipment_status/' + contact.urlHash),
									$elm$html$Html$Attributes$target('_blank')
								]),
							$elm$html$Html$text('Customer portal'))) : $elm$core$Maybe$Nothing),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$core$Maybe$Just(
						A2(
							$author$project$Ui$V3$UtilityButton$view,
							{
								icon: $author$project$Ui$V3$Icon$editOutline16,
								label: 'Edit',
								onClick: $author$project$Components$SettingsPage$CustomerLayout$Contact_Set(
									$elm$core$Maybe$Just(
										A5(
											$author$project$Components$SettingsPage$CustomerLayout$ContactForm,
											$elm$core$Maybe$Just(contact.id),
											contact.name,
											$author$project$Domain$EmailAddress$fromString(contact.email),
											false,
											$elm$core$Maybe$Nothing)))
							},
							_List_fromArray(
								[$author$project$Ui$V3$UtilityButton$sizeSmall])))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					(!contact.deleted) ? $elm$core$Maybe$Just(
						A2(
							$author$project$Ui$V3$UtilityButton$view,
							{
								icon: $author$project$Ui$V3$Icon$removeOutline16,
								label: 'Delete',
								onClick: $author$project$Components$SettingsPage$CustomerLayout$Contact_Delete(contact)
							},
							_List_fromArray(
								[$author$project$Ui$V3$UtilityButton$sizeSmall]))) : $elm$core$Maybe$Nothing)
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$contactListViewV3Reskin = F3(
	function (accountSettings, all, contactForm) {
		var header = function () {
			if (contactForm.$ === 'Just') {
				var form = contactForm.a;
				var _v2 = form.id;
				if (_v2.$ === 'Just') {
					return 'Edit contact';
				} else {
					return 'New contact';
				}
			} else {
				return 'Contacts';
			}
		}();
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(header)
								]))
						]),
						function () {
						if (contactForm.$ === 'Just') {
							var form = contactForm.a;
							return _List_fromArray(
								[
									$author$project$Components$SettingsPage$CustomerLayout$contactListEditorV3Reskin(form)
								]);
						} else {
							var newContact = A5($author$project$Components$SettingsPage$CustomerLayout$ContactForm, $elm$core$Maybe$Nothing, '', $author$project$Components$SettingsPage$CustomerLayout$blankEmail, false, $elm$core$Maybe$Nothing);
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
										]),
									A2(
										$elm$core$List$intersperse,
										A2(
											$elm$html$Html$hr,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'margin', '0')
												]),
											_List_Nil),
										A2(
											$elm$core$List$map,
											$author$project$Components$SettingsPage$CustomerLayout$contactListRowV3Reskin(accountSettings),
											all))),
									A2(
									$author$project$Ui$V3$Stack$viewHorzWithWidths,
									_List_fromArray(
										[$author$project$Ui$V3$Stack$mainAxisEnd]),
									_List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$Ui$V3$Stack$fit,
											A3(
												$author$project$Ui$V3$Button$view,
												{
													action: $author$project$Ui$V3$Button$onClick(
														$author$project$Components$SettingsPage$CustomerLayout$Contact_Set(
															$elm$core$Maybe$Just(newContact)))
												},
												_List_fromArray(
													[
														$author$project$Ui$V3$Button$leftIcon16WithHiddenLabel($author$project$Ui$V3$Icon$add16)
													]),
												'New Contact'))
										]))
								]);
						}
					}()
					])));
	});
var $author$project$Components$SettingsPage$Shared$BillingEmail$formViewV3Reskin = F3(
	function (tmsControlled, set, result) {
		if (result.$ === 'Ok') {
			var emailAddress = result.a;
			return _Utils_Tuple2(
				A4(
					$author$project$Ui$V3$Input$view,
					{
						onInput: A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$Shared$BillingEmail$ensureValid)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Input$label(
							tmsControlled ? 'Billing email address(es) controlled from TMS' : 'Billing email address(es), separated by comma'),
							$author$project$Ui$V3$Input$disabled(tmsControlled)
						]),
					_List_Nil,
					$author$project$Domain$EmailAddress$toString(emailAddress)),
				true);
		} else {
			var invalid = result.a;
			return _Utils_Tuple2(
				A4(
					$author$project$Ui$V3$Input$view,
					{
						onInput: A2($elm$core$Basics$composeL, set, $author$project$Components$SettingsPage$Shared$BillingEmail$ensureValid)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Input$label('Billing email address(es), separated by comma'),
							$author$project$Ui$V3$Input$validation(
							$elm$core$Result$Err('Doesn\u0027t look like a list of valid email addresses'))
						]),
					_List_Nil,
					invalid),
				false);
		}
	});
var $author$project$Components$SettingsPage$CustomerLayout$billingEmailConfigV3Reskin = function (customerId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CustomerLayout$validatingSend(
			$author$project$Api$Customers$billingEmail(customerId)),
		formView: $author$project$Components$SettingsPage$Shared$BillingEmail$formViewV3Reskin(false),
		summaryView: $elm$core$Basics$always(
			$elm$html$Html$text('')),
		title: 'Billing email',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$BillingEmailUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin = function (title) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$styleAsCard,
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('This setting is being pulled directly from the TMS. To make changes, modify in your TMS.')
					]))
			]));
};
var $author$project$Components$SettingsPage$CustomerLayout$billingEmailsSectionV3Reskin = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.emailDeliveryRecipientAddress ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$Shared$BillingInterval$formViewV3Reskin = F2(
	function (set, interval) {
		return _Utils_Tuple2(
			A2(
				$author$project$Helpers$Html$labeledInput,
				'Billing Interval',
				A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: set,
						options: _List_fromArray(
							[$author$project$AuditPb$BillingIntervalDaily, $author$project$AuditPb$BillingIntervalWeekly, $author$project$AuditPb$BillingIntervalMonthly, $author$project$AuditPb$BillingIntervalNever]),
						toLabel: $author$project$Domain$BillingInterval$encoded,
						value: $elm$core$Maybe$Just(interval)
					},
					_List_Nil)),
			true);
	});
var $author$project$Components$SettingsPage$CustomerLayout$billingIntervalConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$billingInterval(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$BillingInterval$formViewV3Reskin,
		summaryView: $author$project$Components$SettingsPage$Shared$BillingInterval$summaryView,
		title: 'Billing interval',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$BillingIntervalUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$billingIntervalSectionV3Reskin = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.customerBillingInterval ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$sectionViewV3Reskin = F2(
	function (header, innerBody) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(header)
						])),
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					innerBody)
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$AddV3Reskin = function (a) {
	return {$: 'AddV3Reskin', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ChangeNewTypes = function (a) {
	return {$: 'ChangeNewTypes', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewNewTypesV3Reskin = F3(
	function (isSaving, accountSettings, typesSelection) {
		return A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{
				onInput: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ChangeNewTypes,
				options: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$allTypesSelections(accountSettings),
				toLabel: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$typesSelectionToStr,
				value: typesSelection
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$SimpleSelect$placeholder(
					accountSettings.auditBillingEnabled ? $elm$core$Maybe$Just('') : $elm$core$Maybe$Nothing),
					$author$project$Ui$V3$SimpleSelect$disabled(isSaving)
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewNewRuleFormV3Reskin = function (_v0) {
	var accountSettings = _v0.accountSettings;
	var isSaving = _v0.isSaving;
	var newTypesSelection = _v0.newTypesSelection;
	var newRuleInput = _v0.newRuleInput;
	var _v1 = function () {
		var _v2 = _Utils_Tuple3(
			isSaving,
			$elm$core$String$isEmpty(newRuleInput),
			newTypesSelection);
		if (((!_v2.a) && (!_v2.b)) && (_v2.c.$ === 'Just')) {
			var typesSelection = _v2.c.a;
			return _Utils_Tuple2(
				$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$AddV3Reskin(
					{message: newRuleInput, typesSelection: typesSelection}),
				false);
		} else {
			return _Utils_Tuple2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$DoNothing, true);
		}
	}();
	var submitMsg = _v1.a;
	var isDisabled = _v1.b;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Events$onSubmit(submitMsg)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
						$author$project$Ui$V3$Stack$crossAxisBottom
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A4(
							$author$project$Ui$V3$Input$view,
							{onInput: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$UpdateInput},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$label('Message'),
									$author$project$Ui$V3$Input$disabled(isSaving)
								]),
							_List_Nil,
							newRuleInput)),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$author$project$Helpers$Html$labeledInput,
							'Related to',
							A3($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewNewTypesV3Reskin, isSaving, accountSettings, newTypesSelection))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A3(
							$author$project$Ui$V3$Button$view,
							{action: $author$project$Ui$V3$Button$submitForm},
							_List_fromArray(
								[
									$author$project$Ui$V3$Button$disabled(isDisabled)
								]),
							'Add rule'))
					]))
			]));
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$RemoveV3Reskin = function (a) {
	return {$: 'RemoveV3Reskin', a: a};
};
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewRemoveLinkV3Reskin = F2(
	function (isSaving, item) {
		return A2(
			$author$project$Ui$V3$UtilityButton$view,
			{
				icon: $author$project$Ui$V3$Icon$removeOutline16,
				label: 'Remove',
				onClick: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$RemoveV3Reskin(item)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$UtilityButton$isDisabled(isSaving)
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ChangeTypesV3Reskin = F2(
	function (a, b) {
		return {$: 'ChangeTypesV3Reskin', a: a, b: b};
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewTypesV3Reskin = F3(
	function (isSaving, accountSettings, customExceptionMessage) {
		return accountSettings.auditBillingEnabled ? A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{
				onInput: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$ChangeTypesV3Reskin(customExceptionMessage),
				options: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$allTypesSelections(accountSettings),
				toLabel: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$typesSelectionToStr,
				value: $elm$core$Maybe$Just(customExceptionMessage.typesSelection)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$SimpleSelect$disabled(isSaving)
				])) : A2(
			$author$project$Ui$V3$Typography$smallBody,
			_List_Nil,
			$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$typesSelectionToStr(
				A2(
					$elm$core$Maybe$withDefault,
					customExceptionMessage.typesSelection,
					A2($author$project$Domain$CustomExceptionMessage$displayed, false, customExceptionMessage.typesSelection))));
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewRulesV3Reskin = F3(
	function (isSaving, accountSettings, allItems) {
		var items = A2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$displayedRules, accountSettings, allItems);
		return $elm$core$List$isEmpty(items) ? A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_Nil,
						content: $elm$core$Basics$always(
							A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No custom exception messages')
									]))),
						heading: $elm$html$Html$text('Message')
					},
						{
						attrs: _List_Nil,
						content: $elm$core$Basics$always(
							$elm$html$Html$text('')),
						heading: $elm$html$Html$text('Related to')
					}
					])
			},
			_List_Nil,
			_List_Nil,
			_List_fromArray(
				[_Utils_Tuple0])) : A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_Nil,
						content: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.message;
							},
							$author$project$Ui$V3$Typography$smallBodySemiBold(_List_Nil)),
						heading: $elm$html$Html$text('Message')
					},
						{
						attrs: _List_Nil,
						content: A2($author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewTypesV3Reskin, isSaving, accountSettings),
						heading: $elm$html$Html$text('Related to')
					},
						{
						attrs: _List_Nil,
						content: $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewRemoveLinkV3Reskin(isSaving),
						heading: $elm$html$Html$text('')
					}
					])
			},
			_List_Nil,
			_List_Nil,
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.message;
				},
				items));
	});
var $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewV3Reskin = F2(
	function (description, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					description,
					$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$customExceptionMessagesWarning,
					$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewNewRuleFormV3Reskin(model),
					A3(
					$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewRulesV3Reskin,
					model.isSaving,
					model.accountSettings,
					$author$project$Helpers$Savable$value(model.items))
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$customExceptionMessagesSectionV3Reskin = F2(
	function (customExceptionMessages, accountSettings) {
		return accountSettings.controlledByTMS.customExceptionMessages ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin('Custom Exception Messages') : A2(
			$author$project$Components$SettingsPage$CustomerLayout$sectionViewV3Reskin,
			'Custom exception messages',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$SettingsPage$CustomerLayout$CustomExceptionMessagesUpdate,
					A2(
						$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewV3Reskin,
						A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('These rules will only apply to this customer, when processing carrier invoices. In addition to the '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/app/settings/rules')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('account\u0027s custom exception messages')
										])),
									$elm$html$Html$text('.')
								])),
						customExceptionMessages))
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$customSubjectFormViewV3Reskin = F4(
	function (customerSettings, accountSettings, set, result) {
		var val = A3($author$project$Helpers$Result$either, $elm$core$Basics$identity, $elm$core$Basics$identity, result);
		var isValid = $author$project$Helpers$Result$isOk(result);
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$V3$Input$view,
						{
							onInput: A2(
								$elm$core$Basics$composeL,
								set,
								A2($author$project$Components$SettingsPage$CustomerLayout$ensureValidTemplate, customerSettings, accountSettings))
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$label('Custom subject template (optional)'),
								$author$project$Ui$V3$Input$validation(
								A2(
									$elm$core$Result$mapError,
									$elm$core$Basics$always('Invalid variable'),
									result))
							]),
						_List_Nil,
						val),
						A4($author$project$Components$SettingsPage$Shared$TemplateVariables$listView, $author$project$Components$SettingsPage$CustomerLayout$templateVariablesExample, customerSettings.templateVariables, _List_Nil, _List_Nil)
					])),
			isValid);
	});
var $author$project$Components$SettingsPage$CustomerLayout$customSubjectConfigV3Config = F3(
	function (customerId, customerSettings, accountSettings) {
		return {
			apiRequest: $author$project$Components$SettingsPage$CustomerLayout$validatingSend(
				$author$project$Api$Customers$customSubject(customerId)),
			formView: A2($author$project$Components$SettingsPage$CustomerLayout$customSubjectFormViewV3Reskin, customerSettings, accountSettings),
			summaryView: $author$project$Components$SettingsPage$CustomerLayout$customSubjectSummaryView,
			title: 'Custom invoice subject',
			toMsg: $author$project$Components$SettingsPage$CustomerLayout$CustomSubjectUpdate
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$customerInstructionsSectionV3Reskin = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.customerInstructions ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$autoSendBadgeV3Reskin = F3(
	function (isFactor, accountSettings, value) {
		var shouldShow = isFactor && accountSettings.factorAutoSendInvoices;
		var _v0 = A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$canAutoSend, accountSettings, value) ? _Utils_Tuple2(_List_Nil, 'enabled') : _Utils_Tuple2(
			_List_fromArray(
				[$author$project$Ui$V3$Notification$warning]),
			'disabled');
		var attrs = _v0.a;
		var verb = _v0.b;
		var content = 'Auto-sending ' + (verb + ' based off current delivery method');
		return A2(
			$author$project$Helpers$Html$showIf,
			shouldShow,
			A2(
				$author$project$Ui$V3$Notification$viewInline,
				{
					message: $elm$html$Html$text(content),
					onClose: $elm$core$Maybe$Nothing,
					title: $elm$core$Maybe$Nothing
				},
				attrs));
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$isFormValid = F2(
	function (config, currentValue) {
		switch (currentValue.$) {
			case 'Email':
				var preferences = currentValue.a;
				return A4($author$project$Components$SettingsPage$Shared$TemplateVariables$isValid, config.templateVariables, config.accountSettings.loadReferenceVariables, config.accountSettings.shipmentReferenceVariables, preferences.customInvoiceAttachmentFilename);
			case 'Ftp':
				var template = currentValue.a.a;
				return A4($author$project$Components$SettingsPage$Shared$TemplateVariables$isValid, config.templateVariables, config.accountSettings.loadReferenceVariables, config.accountSettings.shipmentReferenceVariables, template);
			default:
				return true;
		}
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin = F2(
	function (config, model) {
		var existingMultiple = function () {
			var _v6 = config.currentDeliveryMethod;
			if (_v6.$ === 'Multiple') {
				var details = _v6.a;
				return $author$project$Domain$DeliveryMethod$Multiple(details);
			} else {
				return $author$project$Components$SettingsPage$Shared$DeliveryMethod$newMultiple;
			}
		}();
		var options = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					{
						label: 'Email',
						selected: function () {
							if (model.$ === 'Email') {
								return true;
							} else {
								return false;
							}
						}(),
						val: $author$project$Components$SettingsPage$Shared$DeliveryMethod$newEmail
					}),
					$elm$core$Maybe$Just(
					{
						label: 'Print',
						selected: _Utils_eq(model, $author$project$Domain$DeliveryMethod$Print),
						val: $author$project$Domain$DeliveryMethod$Print
					}),
					config.isFactor ? $elm$core$Maybe$Just(
					function () {
						var _v1 = config.currentDeliveryMethod;
						if (_v1.$ === 'PaymentsNetworkMultiple') {
							var details = _v1.a;
							return {
								label: 'Payments Network (Multiple)',
								selected: function () {
									if (model.$ === 'PaymentsNetworkMultiple') {
										return true;
									} else {
										return false;
									}
								}(),
								val: $author$project$Domain$DeliveryMethod$PaymentsNetworkMultiple(details)
							};
						} else {
							return {
								label: 'Payments Network',
								selected: _Utils_eq(model, $author$project$Domain$DeliveryMethod$PaymentsNetwork),
								val: $author$project$Domain$DeliveryMethod$PaymentsNetwork
							};
						}
					}()) : $elm$core$Maybe$Nothing,
					config.isFactor ? $elm$core$Maybe$Just(
					{
						label: 'Multiple',
						selected: function () {
							if (model.$ === 'Multiple') {
								return true;
							} else {
								return false;
							}
						}(),
						val: existingMultiple
					}) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					{
						label: 'FTP/SFTP',
						selected: function () {
							if (model.$ === 'Ftp') {
								return true;
							} else {
								return false;
							}
						}(),
						val: $author$project$Components$SettingsPage$Shared$DeliveryMethod$newFtp
					}),
					$elm$core$Maybe$Just(
					{
						label: 'FPA Upload (Cass)',
						selected: function () {
							if (model.$ === 'UploadCass') {
								return true;
							} else {
								return false;
							}
						}(),
						val: $author$project$Components$SettingsPage$Shared$DeliveryMethod$newUploadCass
					})
				]));
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Radio$view,
				{
					label: function ($) {
						return $.label;
					},
					name: 'delivery_method',
					onSelect: function ($) {
						return $.val;
					},
					options: options,
					selected: A2(
						$elm_community$list_extra$List$Extra$find,
						function ($) {
							return $.selected;
						},
						options)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Radio$disabled(!config.enableChangingType)
					]))
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$displayMultipleDetailsV3Reskin = F2(
	function (settings, deliveryOptionDetails) {
		return $elm$core$List$isEmpty(deliveryOptionDetails.choices) ? _List_Nil : _List_fromArray(
			[
				A4(
				$author$project$Ui$V3$Table$view,
				{
					columns: _List_fromArray(
						[
							{
							attrs: _List_Nil,
							content: A2(
								$elm$core$Basics$composeL,
								$elm$html$Html$text,
								function ($) {
									return $.regexPattern;
								}),
							heading: $elm$html$Html$text('Matching pattern')
						},
							{
							attrs: _List_Nil,
							content: function (choice) {
								return $elm$html$Html$text(
									function () {
										var _v0 = choice.deliveryMethod;
										if (_v0.$ === 'PaymentsNetwork') {
											return 'Payments Network';
										} else {
											return 'Email';
										}
									}());
							},
							heading: $elm$html$Html$text('Delivery type')
						},
							{
							attrs: _List_Nil,
							content: function (choice) {
								return $elm$html$Html$text(
									function () {
										var _v1 = choice.deliveryMethod;
										if (_v1.$ === 'Email') {
											var preferences = _v1.a;
											var _v2 = preferences.emailPerInvoice;
											if (_v2.$ === 'Default') {
												return 'account default (' + ($author$project$Components$SettingsPage$Shared$DeliveryMethod$accountDefaultGrouping(settings) + ')');
											} else {
												if (_v2.a) {
													return 'one invoice per email';
												} else {
													return 'single email for all sent invoices';
												}
											}
										} else {
											return '';
										}
									}());
							},
							heading: $elm$html$Html$text('Invoice grouping')
						},
							{
							attrs: _List_Nil,
							content: function (choice) {
								return $elm$html$Html$text(
									function () {
										var _v3 = choice.deliveryMethod;
										if (_v3.$ === 'Email') {
											var preferences = _v3.a;
											return preferences.attachInvoices ? 'Attachment' : 'Download Link';
										} else {
											return '';
										}
									}());
							},
							heading: $elm$html$Html$text('Link or attachment')
						},
							{
							attrs: _List_Nil,
							content: function (choice) {
								return $elm$html$Html$text(
									function () {
										var _v4 = choice.deliveryMethod;
										if (_v4.$ === 'Email') {
											var preferences = _v4.a;
											return preferences.billingEmailOverride;
										} else {
											return '';
										}
									}());
							},
							heading: $elm$html$Html$text('Billing override email address')
						}
						])
				},
				_List_Nil,
				_List_Nil,
				deliveryOptionDetails.choices)
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$emailAttachInvoicesRowV3Reskin = function (preferences) {
	var options = _List_fromArray(
		[
			{
			label: 'Download Link',
			selected: !preferences.attachInvoices,
			val: $author$project$Domain$DeliveryMethod$Email(
				_Utils_update(
					preferences,
					{attachInvoices: false}))
		},
			{
			label: 'Attachment',
			selected: preferences.attachInvoices,
			val: $author$project$Domain$DeliveryMethod$Email(
				_Utils_update(
					preferences,
					{attachInvoices: true}))
		}
		]);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$V3$Radio$view,
			{
				label: function ($) {
					return $.label;
				},
				name: 'email_media',
				onSelect: function ($) {
					return $.val;
				},
				options: options,
				selected: A2(
					$elm_community$list_extra$List$Extra$find,
					function ($) {
						return $.selected;
					},
					options)
			},
			_List_Nil)
		]);
};
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$emailFilenameRowV3Reskin = F4(
	function (isValid, isFactor, config, preferences) {
		if ((!preferences.attachInvoices) || isFactor) {
			return _List_Nil;
		} else {
			var val = preferences.customInvoiceAttachmentFilename;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: function (s) {
									return $author$project$Domain$DeliveryMethod$Email(
										_Utils_update(
											preferences,
											{customInvoiceAttachmentFilename: s}));
								}
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$error(!isValid),
									$author$project$Ui$V3$Input$trailingTextInBox(
									{text: '.pdf', width: 100})
								]),
							_List_Nil,
							val),
							$author$project$Components$SettingsPage$Shared$DeliveryMethod$rowCollapse(
							_List_fromArray(
								[
									A4(
									$author$project$Components$SettingsPage$Shared$TemplateVariables$listView,
									$author$project$Components$SettingsPage$Shared$DeliveryMethod$templateVariablesExample(config.isFactor),
									config.templateVariables,
									_List_Nil,
									_List_Nil)
								]))
						]))
				]);
		}
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$emailPerInvoiceRowV3Reskin = F2(
	function (accountSettings, preferences) {
		var options = _List_fromArray(
			[
				{
				label: 'One invoice per email',
				selected: _Utils_eq(
					preferences.emailPerInvoice,
					$author$project$Domain$DeliveryMethod$Overridden(true)),
				val: $author$project$Domain$DeliveryMethod$Email(
					_Utils_update(
						preferences,
						{
							emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(true)
						}))
			},
				{
				label: 'All invoices in single email',
				selected: _Utils_eq(
					preferences.emailPerInvoice,
					$author$project$Domain$DeliveryMethod$Overridden(false)),
				val: $author$project$Domain$DeliveryMethod$Email(
					_Utils_update(
						preferences,
						{
							emailPerInvoice: $author$project$Domain$DeliveryMethod$Overridden(false)
						}))
			},
				{
				label: 'Use Account Default (' + ($author$project$Components$SettingsPage$Shared$DeliveryMethod$accountDefaultGrouping(accountSettings) + ')'),
				selected: _Utils_eq(preferences.emailPerInvoice, $author$project$Domain$DeliveryMethod$Default),
				val: $author$project$Domain$DeliveryMethod$Email(
					_Utils_update(
						preferences,
						{emailPerInvoice: $author$project$Domain$DeliveryMethod$Default}))
			}
			]);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Radio$view,
				{
					label: function ($) {
						return $.label;
					},
					name: 'email_amount',
					onSelect: function ($) {
						return $.val;
					},
					options: options,
					selected: A2(
						$elm_community$list_extra$List$Extra$find,
						function ($) {
							return $.selected;
						},
						options)
				},
				_List_Nil)
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$ftpProtocolTypeViewV3Reskin = F2(
	function (value, setter) {
		return A2(
			$author$project$Ui$V3$Radio$view,
			{
				label: function (t) {
					if (t.$ === 'BasicFtp') {
						return 'FTP';
					} else {
						return 'SFTP';
					}
				},
				name: 'ftp_protocol',
				onSelect: setter,
				options: _List_fromArray(
					[$author$project$Domain$DeliveryMethod$BasicFtp, $author$project$Domain$DeliveryMethod$SecureSftp]),
				selected: $elm$core$Maybe$Just(value)
			},
			_List_Nil);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$setMultipleTypeV3Reskin = F2(
	function (deliveryOptionDetails, currentDeliveryMethod) {
		var disableCustom = function () {
			if (currentDeliveryMethod.$ === 'Multiple') {
				var details = currentDeliveryMethod.a;
				return $author$project$Domain$DeliveryMethod$isSchneider(details);
			} else {
				return true;
			}
		}();
		var currentDetails = function () {
			if (currentDeliveryMethod.$ === 'Multiple') {
				var details = currentDeliveryMethod.a;
				return details;
			} else {
				return {choices: _List_Nil};
			}
		}();
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$SimpleSelect$view,
				{
					onInput: $author$project$Components$SettingsPage$Shared$DeliveryMethod$setMultiple(currentDetails),
					options: _List_fromArray(
						[$author$project$Domain$DeliveryMethod$Schneider, $author$project$Domain$DeliveryMethod$Custom]),
					toLabel: $author$project$Domain$DeliveryMethod$multipleTypeToString,
					value: $elm$core$Maybe$Just(
						$author$project$Domain$DeliveryMethod$isSchneider(deliveryOptionDetails) ? $author$project$Domain$DeliveryMethod$Schneider : $author$project$Domain$DeliveryMethod$Custom)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$SimpleSelect$disabledOptions(
						disableCustom ? _List_fromArray(
							[$author$project$Domain$DeliveryMethod$Custom]) : _List_Nil)
					]))
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$templateFilenameInputRowV3Reskin = F2(
	function (isValid, config) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$V3$Input$view,
						{onInput: config.onInput},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$label(config.name),
								$author$project$Ui$V3$Input$error(!isValid),
								$author$project$Ui$V3$Input$trailingTextInBox(
								{text: '.pdf', width: 100})
							]),
						_List_Nil,
						config.value),
						A4(
						$author$project$Components$SettingsPage$Shared$TemplateVariables$listView,
						$author$project$Components$SettingsPage$Shared$DeliveryMethod$templateVariablesExample(config.isFactor),
						config.variables,
						_List_Nil,
						_List_Nil)
					]))
			]);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$radioOptionsViewV3Reskin = F3(
	function (isValid, config, currentValue) {
		var manageInTmsLabel = function (message) {
			return (!config.enableChangingType) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]) : _List_Nil;
		};
		var contents = function () {
			switch (currentValue.$) {
				case 'Email':
					var preferences = currentValue.a;
					return _List_fromArray(
						[
							manageInTmsLabel('All settings except link vs attachment are managed directly in the TMS.'),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue),
							$author$project$Components$SettingsPage$Shared$DeliveryMethod$emailAttachInvoicesRowV3Reskin(preferences),
							A4($author$project$Components$SettingsPage$Shared$DeliveryMethod$emailFilenameRowV3Reskin, isValid, config.isFactor, config, preferences),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$emailPerInvoiceRowV3Reskin, config.accountSettings, preferences)
						]);
				case 'Print':
					return _List_fromArray(
						[
							manageInTmsLabel('Settings are managed directly in the TMS.'),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue)
						]);
				case 'BackupOnly':
					return _List_fromArray(
						[
							manageInTmsLabel('Settings are managed directly in the TMS.'),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue)
						]);
				case 'TpayApi':
					return _List_fromArray(
						[
							manageInTmsLabel('Settings are managed directly in the TMS.'),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue)
						]);
				case 'PaymentsNetwork':
					return _List_fromArray(
						[
							manageInTmsLabel('Settings are managed directly in the TMS.'),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue)
						]);
				case 'Multiple':
					var multipleDetails = currentValue.a;
					return _List_fromArray(
						[
							manageInTmsLabel('Settings are managed directly in the TMS.'),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$setMultipleTypeV3Reskin, multipleDetails, config.currentDeliveryMethod),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$displayMultipleDetailsV3Reskin, config.accountSettings, multipleDetails)
						]);
				case 'PaymentsNetworkMultiple':
					var multipleDetails = currentValue.a;
					return _List_fromArray(
						[
							manageInTmsLabel('Settings are managed directly in the TMS.'),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue),
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$displayMultipleDetailsV3Reskin, config.accountSettings, multipleDetails)
						]);
				case 'Ftp':
					var filename = currentValue.a;
					var template = filename.a;
					var credentials = currentValue.b;
					var protocolType = currentValue.c;
					return _List_fromArray(
						[
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue),
							_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{username: s}),
											protocolType);
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Username (case-sensitive)')
									]),
								_List_Nil,
								credentials.username),
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{password: s}),
											protocolType);
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Password (case-sensitive)'),
										$author$project$Ui$V3$Input$password
									]),
								_List_Nil,
								credentials.password),
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{host: s}),
											protocolType);
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Host (case-sensitive)')
									]),
								_List_Nil,
								credentials.host),
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{ftpPort: s}),
											protocolType);
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Port (optional)')
									]),
								_List_Nil,
								credentials.ftpPort),
								A2(
								$author$project$Components$SettingsPage$Shared$DeliveryMethod$ftpProtocolTypeViewV3Reskin,
								protocolType,
								function (s) {
									return A3($author$project$Domain$DeliveryMethod$Ftp, filename, credentials, s);
								}),
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											filename,
											_Utils_update(
												credentials,
												{rootDirectory: s}),
											protocolType);
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Root directory (optional) (case-sensitive)')
									]),
								_List_Nil,
								credentials.rootDirectory)
							]),
							A2(
							$elm$core$List$cons,
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							A2(
								$author$project$Components$SettingsPage$Shared$DeliveryMethod$templateFilenameInputRowV3Reskin,
								isValid,
								{
									id: 'ftpcustomname',
									isFactor: config.isFactor,
									name: 'Custom filename (optional)',
									onInput: function (s) {
										return A3(
											$author$project$Domain$DeliveryMethod$Ftp,
											$author$project$Domain$DeliveryMethod$FtpFilename(s),
											credentials,
											protocolType);
									},
									settings: config.accountSettings,
									value: template,
									variables: config.templateVariables
								}))
						]);
				case 'UploadCass':
					var credentials = currentValue.a;
					return _List_fromArray(
						[
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue),
							_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return $author$project$Domain$DeliveryMethod$UploadCass(
											_Utils_update(
												credentials,
												{username: s}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Username (case-sensitive)')
									]),
								_List_Nil,
								credentials.username),
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return $author$project$Domain$DeliveryMethod$UploadCass(
											_Utils_update(
												credentials,
												{password: s}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Password (case-sensitive)'),
										$author$project$Ui$V3$Input$password
									]),
								_List_Nil,
								credentials.password),
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return $author$project$Domain$DeliveryMethod$UploadCass(
											_Utils_update(
												credentials,
												{account: s}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('Account name (case-sensitive)')
									]),
								_List_Nil,
								credentials.account)
							])
						]);
				default:
					var otherSettings = currentValue.a;
					return _List_fromArray(
						[
							A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$deliveryMethodsViewV3Reskin, config, currentValue),
							_List_fromArray(
							[
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return $author$project$Domain$DeliveryMethod$Other(
											_Utils_update(
												otherSettings,
												{externalDeliveryMethod: s}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('External Delivery Method')
									]),
								_List_Nil,
								otherSettings.externalDeliveryMethod),
								A4(
								$author$project$Ui$V3$Input$view,
								{
									onInput: function (s) {
										return $author$project$Domain$DeliveryMethod$Other(
											_Utils_update(
												otherSettings,
												{externalEmailRecipients: s}));
									}
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Input$label('External Email Recipients')
									]),
								_List_Nil,
								otherSettings.externalEmailRecipients)
							])
						]);
			}
		}();
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			$elm$core$List$concat(contents));
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$formViewV3Reskin = F3(
	function (config, set, value) {
		var isValid = A2($author$project$Components$SettingsPage$Shared$DeliveryMethod$isFormValid, config, value);
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						A3($author$project$Components$SettingsPage$Shared$DeliveryMethod$autoSendBadgeV3Reskin, config.isFactor, config.accountSettings, value),
						A2(
						$elm$html$Html$map,
						set,
						A3($author$project$Components$SettingsPage$Shared$DeliveryMethod$radioOptionsViewV3Reskin, isValid, config, value))
					])),
			isValid);
	});
var $author$project$Components$SettingsPage$Shared$DeliveryMethod$summaryViewV3Reskin = F3(
	function (_v0, accountSettings, value) {
		var isFactor = _v0.isFactor;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$paddingTop($author$project$Ui$V3$Stack$spaceXXSmall),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A3($author$project$Components$SettingsPage$Shared$DeliveryMethod$autoSendBadgeV3Reskin, isFactor, accountSettings, value),
					$elm$html$Html$text(
					function () {
						switch (value.$) {
							case 'Email':
								var preferences = value.a;
								var grouping = function () {
									var _v2 = preferences.emailPerInvoice;
									if (_v2.$ === 'Default') {
										return 'account default (' + ($author$project$Components$SettingsPage$Shared$DeliveryMethod$accountDefaultGrouping(accountSettings) + ')');
									} else {
										if (_v2.a) {
											return 'one invoice per email';
										} else {
											return 'single email for all sent invoices';
										}
									}
								}();
								var format = preferences.attachInvoices ? 'Attachment' : 'Download Link';
								return 'Email + ' + (format + (', ' + grouping));
							case 'Print':
								return 'Print';
							case 'PaymentsNetwork':
								return 'Payments Network';
							case 'Multiple':
								return 'Multiple';
							case 'PaymentsNetworkMultiple':
								return 'Payments Network (Multiple)';
							case 'Ftp':
								var protocolType = value.c;
								return $elm$core$String$toUpper(
									$author$project$Domain$DeliveryMethod$ftpProtocolTypeToString(protocolType));
							case 'UploadCass':
								return 'FPA Upload (Cass)';
							case 'BackupOnly':
								return 'Backup Only';
							case 'TpayApi':
								return 'TriumphPay API';
							default:
								return 'Other';
						}
					}())
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$deliveryMethodConfigV3Reskin = F2(
	function (customerId, data) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Customers$deliveryMethod(customerId),
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
			formView: $author$project$Components$SettingsPage$Shared$DeliveryMethod$formViewV3Reskin(
				{
					accountSettings: data.accountSettings,
					currentDeliveryMethod: $author$project$Domain$DeliveryMethodFromPb$fromPb(data.customerSettings.deliveryMethod.method),
					enableChangingType: !data.accountSettings.controlledByTMS.deliveryMethod,
					isFactor: false,
					templateVariables: data.customerSettings.templateVariables
				}),
			summaryView: A2(
				$author$project$Components$SettingsPage$Shared$DeliveryMethod$summaryViewV3Reskin,
				{isFactor: false},
				data.accountSettings),
			title: 'Send invoices via',
			toMsg: $author$project$Components$SettingsPage$CustomerLayout$DeliveryMethodUpdate
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$deliveryMethodSectionV3Reskin = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.deliveryMethod ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$Shared$PayablesValue$toStringV3Reskin = function (value) {
	if (value.$ === 'Required') {
		return 'Required';
	} else {
		return 'Default';
	}
};
var $author$project$Components$SettingsPage$Shared$Checkbox$v3ReskinHelper = F2(
	function (isDisabled, options) {
		return A2(
			$author$project$Ui$V3$Checkbox$view,
			{
				checked: $author$project$Components$SettingsPage$Shared$Checkbox$isChecked(options.value),
				label: $elm$html$Html$text(''),
				onCheck: function (checked_) {
					return checked_ ? options.messages.onCheck(options.id) : options.messages.onUncheck(options.id);
				}
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Checkbox$disabled(isDisabled)
				]));
	});
var $author$project$Components$SettingsPage$Shared$Checkbox$viewDisabledV3Reskin = $author$project$Components$SettingsPage$Shared$Checkbox$v3ReskinHelper(true);
var $author$project$Components$SettingsPage$Shared$Checkbox$viewV3Reskin = $author$project$Components$SettingsPage$Shared$Checkbox$v3ReskinHelper(false);
var $author$project$Components$SettingsPage$CustomerLayout$documentTypesSettingsFromDataV3Reskin = F2(
	function (id, data) {
		return {
			columns: _List_fromArray(
				[
					{
					header: 'Document Type',
					isDisabled: false,
					view: F3(
						function (_v0, _v1, row) {
							return $elm$html$Html$text(row.name);
						})
				},
					{
					header: 'Visible to Customer',
					isDisabled: data.accountSettings.controlledByTMS.customerVisibleDocs,
					view: F3(
						function (_v2, messages, row) {
							var isDisabled = _v2.isDisabled;
							return isDisabled ? $author$project$Components$SettingsPage$Shared$Checkbox$viewDisabledV3Reskin(
								{
									id: _Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$visibleToCustomer),
									messages: {onCheck: messages.onCheck, onUncheck: messages.onUncheck},
									value: row.isVisibleToCustomer
								}) : $author$project$Components$SettingsPage$Shared$Checkbox$viewV3Reskin(
								{
									id: _Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$visibleToCustomer),
									messages: {onCheck: messages.onCheck, onUncheck: messages.onUncheck},
									value: row.isVisibleToCustomer
								});
						})
				},
					{
					header: 'Required for Customer Billing',
					isDisabled: data.accountSettings.controlledByTMS.customerRequiredDocs,
					view: F3(
						function (_v3, messages, row) {
							var isDisabled = _v3.isDisabled;
							return isDisabled ? $author$project$Components$SettingsPage$Shared$Checkbox$viewDisabledV3Reskin(
								{
									id: _Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$requiredForCustomer),
									messages: {onCheck: messages.onCheck, onUncheck: messages.onUncheck},
									value: row.isRequiredForCustomer
								}) : $author$project$Components$SettingsPage$Shared$Checkbox$viewV3Reskin(
								{
									id: _Utils_Tuple2(row.documentType, $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$requiredForCustomer),
									messages: {onCheck: messages.onCheck, onUncheck: messages.onUncheck},
									value: row.isRequiredForCustomer
								});
						})
				},
					{
					header: 'Required for Payables',
					isDisabled: false,
					view: F3(
						function (_v4, messages, row) {
							var isDisabled = _v4.isDisabled;
							return A2(
								$author$project$Ui$V3$SimpleSelect$view,
								{
									onInput: messages.setPayablesValue(row.documentType),
									options: _List_fromArray(
										[$author$project$Components$SettingsPage$Shared$PayablesValue$required, $author$project$Components$SettingsPage$Shared$PayablesValue$useHubtranDefaults]),
									toLabel: $author$project$Components$SettingsPage$Shared$PayablesValue$toStringV3Reskin,
									value: $elm$core$Maybe$Just(row.isRequiredForPayables)
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$SimpleSelect$disabled(isDisabled)
									]));
						})
				}
				]),
			descriptions: {
				hasDifferences: _List_fromArray(
					[
						$elm$html$Html$text('This customer is using custom settings instead of account settings. '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/app/settings/document_types')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('You can update account settings here.')
							]))
					]),
				sameAsGlobal: _List_fromArray(
					[
						$elm$html$Html$text('This customer is using the account settings. '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/app/settings/document_types')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('You can update account settings here.')
							]))
					])
			},
			id: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$customerId(id),
			isAdmin: data.currentUser.isAdmin,
			settings: {
				global: data.documentTypeSettings,
				local: $author$project$Components$SettingsPage$CustomerLayout$documentTypes(data.customerSettings)
			}
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentFormViewV3Reskin = F2(
	function (set, value) {
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$Checkbox$view,
				{
					checked: value,
					label: $elm$html$Html$text('Ignore TriumphPay Audit\u0027s invoice document'),
					onCheck: set
				},
				_List_Nil),
			true);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ignoreInvoiceDocument(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentFormViewV3Reskin,
		summaryView: $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentSummaryView,
		title: 'Ignore TriumphPay Audit\u0027s customer invoice in receivables',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$IgnoreInvoiceDocumentUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentSectionV3Reskin = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerInvoiceTemplates ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$instructionsFormViewV3Reskin = F2(
	function (set, instructions) {
		return _Utils_Tuple2(
			A4(
				$author$project$Ui$V3$Input$view,
				{onInput: set},
				_List_fromArray(
					[
						$author$project$Ui$V3$Input$label('Special instructions'),
						$author$project$Ui$V3$Input$expandable
					]),
				$author$project$Helpers$Attributes$blockGrammarly(_List_Nil),
				instructions),
			true);
	});
var $author$project$Components$SettingsPage$CustomerLayout$instructionsConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$instructions(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$CustomerLayout$instructionsFormViewV3Reskin,
		summaryView: $author$project$Components$SettingsPage$CustomerLayout$instructionsSummaryView,
		title: 'Instructions',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$InstructionsUpdate
	};
};
var $author$project$Components$SettingsPage$Shared$InvoiceTemplate$formViewV3Reskin = F3(
	function (allOptions, set, maybeId) {
		var toOption = function (template) {
			return _Utils_Tuple2(
				template.name,
				$elm$core$Maybe$Just(template.id));
		};
		var selectedOption = A2(
			$elm$core$Maybe$map,
			toOption,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (template) {
					return _Utils_eq(
						$elm$core$Maybe$Just(template.id),
						maybeId);
				},
				allOptions));
		var defaultOption = _Utils_Tuple2($author$project$Components$SettingsPage$Shared$InvoiceTemplate$defaultName, $elm$core$Maybe$Nothing);
		var options = A2(
			$elm$core$List$cons,
			defaultOption,
			A2($elm$core$List$map, toOption, allOptions));
		return _Utils_Tuple2(
			A2(
				$author$project$Helpers$Html$labeledInput,
				'Invoice Template',
				A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: A2($elm$core$Basics$composeR, $elm$core$Tuple$second, set),
						options: options,
						toLabel: $elm$core$Tuple$first,
						value: selectedOption
					},
					_List_Nil)),
			true);
	});
var $author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfigV3Reskin = F3(
	function (section, customerId, templates) {
		var _v0 = function () {
			switch (section.$) {
				case 'InvoiceTemplate':
					return {templateIdField: 'customer_invoice_template_id', title: 'Invoice template'};
				case 'StatementInvoiceTemplate':
					return {templateIdField: 'statement_customer_invoice_template_id', title: 'Statement invoice template'};
				default:
					return {templateIdField: 'master_customer_invoice_template_id', title: 'Master invoice template (used for master/child invoices)'};
			}
		}();
		var templateIdField = _v0.templateIdField;
		var title = _v0.title;
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				A2($author$project$Api$Customers$invoiceTemplate, templateIdField, customerId),
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
			formView: $author$project$Components$SettingsPage$Shared$InvoiceTemplate$formViewV3Reskin(templates),
			summaryView: $author$project$Components$SettingsPage$Shared$InvoiceTemplate$summaryView(templates),
			title: title,
			toMsg: $author$project$Components$SettingsPage$CustomerLayout$InvoiceTemplateUpdate(section)
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateSectionV3Reskin = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerInvoiceTemplates ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$justWhen = F3(
	function (condition, func, value) {
		return condition ? $elm$core$Maybe$Just(
			func(value)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlAutoRerateEnabled(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: F2(
			function (set, value) {
				return _Utils_Tuple2(
					A2(
						$author$project$Ui$V3$Checkbox$view,
						{
							checked: value,
							label: $elm$html$Html$text('Enable auto re-rating'),
							onCheck: set
						},
						_List_Nil),
					true);
			}),
		summaryView: function (value) {
			return value ? $elm$html$Html$text('Enabled') : $elm$html$Html$text('Not enabled');
		},
		title: 'Auto re-rate less-than-truckload invoices',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlCustomerAutoRateUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateSectionV3Reskin = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerLtlRerate ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginSectionV3Reskin = F2(
	function (config, state) {
		return A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginToleranceFormViewV3ReskinWrapper = F2(
	function (set, model) {
		var labelPrefix = $author$project$Domain$Tolerance$toleranceUnitToSymbol(model.unit);
		var isValid = $author$project$Helpers$Result$isOk(
			A3(
				$author$project$Domain$Tolerance$validateMarginValue,
				model.minimumTolerance,
				_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled),
				0)) && $author$project$Helpers$Result$isOk(
			A3(
				$author$project$Domain$Tolerance$validateMarginValue,
				model.maximumTolerance,
				_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled),
				A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toFloat(model.minimumTolerance))));
		var enableOverride = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id('accountdefault-margin'),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(model.marginType, $author$project$Domain$Override$AccountDefault)),
							$elm$html$Html$Events$onClick(
							set(
								_Utils_update(
									model,
									{marginType: $author$project$Domain$Override$AccountDefault})))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('accountdefault-margin')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Account default')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id('customerspecific-margin'),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(model.marginType, $author$project$Domain$Override$Enabled)),
							$elm$html$Html$Events$onClick(
							set(
								_Utils_update(
									model,
									{marginType: $author$project$Domain$Override$Enabled})))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('customerspecific-margin')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Customer specific')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id('disabled-margin'),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(model.marginType, $author$project$Domain$Override$Disabled)),
							$elm$html$Html$Events$onClick(
							set(
								_Utils_update(
									model,
									{marginType: $author$project$Domain$Override$Disabled})))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('disabled-margin')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Disabled')
						]))
				]));
		var customerSpecificContent = _Utils_eq(model.marginType, $author$project$Domain$Override$Enabled) ? A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Helpers$Html$labeledInput,
						'Type',
						A2(
							$author$project$Ui$V3$SimpleSelect$view,
							{
								onInput: function (unit) {
									return set(
										_Utils_update(
											model,
											{unit: unit}));
								},
								options: $author$project$AuditPb$allToleranceUnit,
								toLabel: $author$project$Domain$Tolerance$toleranceUnitDisplay,
								value: $elm$core$Maybe$Just(model.unit)
							},
							_List_Nil))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Helpers$Html$labeledInput,
						'Minimum tolerance',
						A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: function (minimum) {
									return set(
										_Utils_update(
											model,
											{minimumTolerance: minimum}));
								}
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$leadingTextInBox(labelPrefix),
									$author$project$Ui$V3$Input$placeholder('0.00'),
									$author$project$Ui$V3$Input$validation(
									A3($author$project$Domain$Tolerance$validateMarginValue, model.minimumTolerance, true, 0))
								]),
							_List_Nil,
							model.minimumTolerance))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Helpers$Html$labeledInput,
						'Maximum tolerance',
						A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: function (maximum) {
									return set(
										_Utils_update(
											model,
											{maximumTolerance: maximum}));
								}
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$leadingTextInBox(labelPrefix),
									$author$project$Ui$V3$Input$placeholder('0.00'),
									$author$project$Ui$V3$Input$validation(
									A3(
										$author$project$Domain$Tolerance$validateMarginValue,
										model.maximumTolerance,
										true,
										A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toFloat(model.minimumTolerance))))
								]),
							_List_Nil,
							model.maximumTolerance)))
				])) : $elm$html$Html$text('');
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				_List_fromArray(
					[enableOverride, customerSpecificContent])),
			isValid);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginToleranceConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlCustomerMarginTolerance(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginToleranceFormViewV3ReskinWrapper,
		summaryView: $author$project$Components$SettingsPage$Shared$CustomerMarginTolerance$summaryView,
		title: 'Less-than-truckload customer margin tolerance',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlCustomerMarginToleranceUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$ltlRequireManualReweighReviewConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlRequireManualReweighReview(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: F2(
			function (set, value) {
				return _Utils_Tuple2(
					A2(
						$author$project$Ui$V3$Checkbox$view,
						{
							checked: value,
							label: $elm$html$Html$text('Always require manual review for reweigh charges, even when W&I certificate is present'),
							onCheck: set
						},
						_List_Nil),
					true);
			}),
		summaryView: function (value) {
			return value ? $elm$html$Html$text('Manual review required for all reweigh charges') : $elm$html$Html$text('Auto-resolve when W&I certificate is present');
		},
		title: 'Manual review requirements for reweigh charges',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlRequireManualReweighReviewUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$ltlReweighChargeExceptionsConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlReweighChargeExceptionsEnabled(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: F2(
			function (set, value) {
				return _Utils_Tuple2(
					A2(
						$author$project$Ui$V3$Checkbox$view,
						{
							checked: value,
							label: $elm$html$Html$text('Re-weigh charge exception checking'),
							onCheck: set
						},
						_List_Nil),
					true);
			}),
		summaryView: function (value) {
			return value ? $elm$html$Html$text('Enabled') : $elm$html$Html$text('Disabled');
		},
		title: 'Re-weigh charge exceptions for less-than-truckload invoices',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlReweighChargeExceptionsUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$ltlReweighChargeExceptionsSectionV3Reskin = F2(
	function (config, state) {
		return A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$ltlToleranceConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$ltlTolerance(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$Tolerance$formViewV3,
		summaryView: $author$project$Components$SettingsPage$Shared$Tolerance$summaryView,
		title: 'Less-than-truckload invoice tolerance',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$LtlToleranceUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$ltlToleranceSectionV3Reskin = F2(
	function (config, state) {
		return A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$masterInvoiceTemplateSectionV3Reskin = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerInvoiceTemplates ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$paymentTermsConfigV3Reskin = function (customerId) {
	return {
		apiRequest: $author$project$Components$SettingsPage$CustomerLayout$validatingSend(
			$author$project$Api$Customers$daysToPay(customerId)),
		formView: $author$project$Components$SettingsPage$Shared$PaymentTerms$formViewV3Reskin,
		summaryView: $author$project$Components$SettingsPage$Shared$PaymentTerms$summaryView,
		title: 'Payment terms',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$PaymentTermsUpdate
	};
};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$formViewV3Reskin = F2(
	function (set, policy) {
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$V3$SimpleSelect$view,
				{
					onInput: set,
					options: _List_fromArray(
						[$author$project$AuditPb$PODRequirementPolicyUseAccountSetting, $author$project$AuditPb$PODRequirementPolicyAlways, $author$project$AuditPb$PODRequirementPolicyDetermineFromLoad, $author$project$AuditPb$PODRequirementPolicyNever]),
					toLabel: $author$project$Domain$PodRequirementPolicy$display,
					value: $elm$core$Maybe$Just(policy)
				},
				_List_Nil),
			true);
	});
var $author$project$Components$SettingsPage$CustomerLayout$podRequirementPolicyConfigV3Reskin = function (customerId) {
	return {
		apiRequest: A2(
			$elm$core$Basics$composeR,
			$author$project$Api$Customers$podRequirementPolicy(customerId),
			$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
		formView: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$formViewV3Reskin,
		summaryView: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$summaryView,
		title: 'POD requirement policy',
		toMsg: $author$project$Components$SettingsPage$CustomerLayout$PodRequirementPolicyUpdate
	};
};
var $author$project$Components$SettingsPage$CustomerLayout$podRequirementSectionV3Reskin = F3(
	function (config, state, accountSettings) {
		return accountSettings.controlledByTMS.customerRequiredDocs ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$Shared$RemitToAddress$defaultNameV3Reskin = 'Account default';
var $author$project$Components$SettingsPage$Shared$RemitToAddress$formViewV3Reskin = F3(
	function (allOptions, set, maybeId) {
		var toOption = function (address) {
			return _Utils_Tuple2(address.name, address.id);
		};
		var selectedOption = A2(
			$elm$core$Maybe$map,
			toOption,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (address) {
					return _Utils_eq(address.id, maybeId);
				},
				allOptions));
		var defaultOption = _Utils_Tuple2($author$project$Components$SettingsPage$Shared$RemitToAddress$defaultNameV3Reskin, $elm$core$Maybe$Nothing);
		var options = A2(
			$elm$core$List$cons,
			defaultOption,
			A2($elm$core$List$map, toOption, allOptions));
		return _Utils_Tuple2(
			A2(
				$author$project$Helpers$Html$labeledInput,
				'Account remit to address',
				A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: A2($elm$core$Basics$composeR, $elm$core$Tuple$second, set),
						options: options,
						toLabel: $elm$core$Tuple$first,
						value: selectedOption
					},
					_List_Nil)),
			true);
	});
var $author$project$Components$SettingsPage$Shared$RemitToAddress$summaryViewV3Reskin = F2(
	function (allOptions, maybeId) {
		var _v0 = A2(
			$elm$core$List$filter,
			$author$project$Components$SettingsPage$Shared$RemitToAddress$isSelected(maybeId),
			allOptions);
		if (_v0.b && (!_v0.b.b)) {
			var name = _v0.a.name;
			return $elm$html$Html$text(name);
		} else {
			return $elm$html$Html$text($author$project$Components$SettingsPage$Shared$RemitToAddress$defaultNameV3Reskin);
		}
	});
var $author$project$Components$SettingsPage$CustomerLayout$remitToAddressConfigV3Reskin = F2(
	function (customerId, addresses) {
		return {
			apiRequest: A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Customers$remitToAddress(customerId),
				$author$project$HubTran$Effect$sendCacheableRequestWithError($elm$core$Basics$identity)),
			formView: $author$project$Components$SettingsPage$Shared$RemitToAddress$formViewV3Reskin(addresses),
			summaryView: $author$project$Components$SettingsPage$Shared$RemitToAddress$summaryViewV3Reskin(addresses),
			title: 'Remit to address (to show as account\u0027s \u0027remit-to\u0027 on invoices)',
			toMsg: $author$project$Components$SettingsPage$CustomerLayout$RemitToAddressUpdate
		};
	});
var $author$project$Components$SettingsPage$CustomerLayout$statementInvoiceTemplateSectionV3Reskin = F3(
	function (config, accountSettings, state) {
		return accountSettings.controlledByTMS.customerInvoiceTemplates ? $author$project$Components$SettingsPage$CustomerLayout$tmsLockSectionV3Reskin(config.title) : A2($author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin, config, state);
	});
var $author$project$Components$SettingsPage$CustomerLayout$viewSkipReviewSection = function (settings) {
	return A2(
		$elm$core$Maybe$map,
		function (skipReviewValue) {
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$styleAsCard,
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Skip billing paperwork review')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Determines whether billing paperwork review is required after audit. This setting is pulled directly from the TMS and cannot be edited here. To make changes, update the setting in your TMS.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Skip Review: ' + skipReviewValue)
							]))
					]));
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.values;
				},
				A2(
					$elm$core$List$filter,
					function (reference) {
						return reference.name === 'SkipReview';
					},
					settings.references))));
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$ClickedCustom = {$: 'ClickedCustom'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$ClickedUseAccountSettings = {$: 'ClickedUseAccountSettings'};
var $author$project$Ui$V3$SegmentedButtonGroup$defaultAttributes = {disabled: false, isInlineFlex: false};
var $author$project$Ui$V3$SegmentedButtonGroup$computeAttributes = function (attributes) {
	var step = F2(
		function (a, acc) {
			if (a.$ === 'DisabledAttribute') {
				var b = a.a;
				return _Utils_update(
					acc,
					{disabled: b});
			} else {
				var b = a.a;
				return _Utils_update(
					acc,
					{isInlineFlex: b});
			}
		});
	return A3($elm$core$List$foldl, step, $author$project$Ui$V3$SegmentedButtonGroup$defaultAttributes, attributes);
};
var $author$project$Ui$V3$SegmentedButtonGroup$viewButton = F4(
	function (onClick, label, isSelected, isDisabled) {
		var selectedClass = isSelected ? 'v3__segmented-button-group__button--selected' : 'v3__segmented-button-group__button--unselected';
		var clickAttrs = isDisabled ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$stopPropagationOn,
				'click',
				$elm$json$Json$Decode$succeed(
					function (msg) {
						return _Utils_Tuple2(msg, true);
					}(onClick)))
			]);
		var attrs = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('v3__segmented-button-group__button'),
					$elm$html$Html$Attributes$class(selectedClass),
					$elm$html$Html$Attributes$type_('button')
				]),
			clickAttrs);
		return A2(
			$elm$html$Html$button,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Ui$V3$SegmentedButtonGroup$view = F2(
	function (config, attributes) {
		var selected = function (segment) {
			var _v0 = config.selected;
			if (_v0.$ === 'Just') {
				var selectedSegment = _v0.a;
				return _Utils_eq(selectedSegment, segment);
			} else {
				return false;
			}
		};
		var computedAttributes = $author$project$Ui$V3$SegmentedButtonGroup$computeAttributes(attributes);
		var segmentToButton = function (segment) {
			return A4(
				$author$project$Ui$V3$SegmentedButtonGroup$viewButton,
				config.onClick(segment),
				config.toLabel(segment),
				selected(segment),
				computedAttributes.disabled);
		};
		var wrapperClass = computedAttributes.isInlineFlex ? 'v3__segmented-button-group--inline' : 'v3__segmented-button-group';
		var abilityClass = computedAttributes.disabled ? 'v3__segmented-button-group--disabled' : 'v3__segmented-button-group--enabled';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(wrapperClass),
					$elm$html$Html$Attributes$class(abilityClass)
				]),
			A2($elm$core$List$map, segmentToButton, config.segments));
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Cancel = {$: 'Cancel'};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewControlsV3Reskin = function (status) {
	var disabled = function () {
		switch (status.$) {
			case 'Saving':
				return true;
			case 'Reverting':
				return true;
			default:
				return false;
		}
	}();
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
				$author$project$Ui$V3$Stack$mainAxisEnd
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$Cancel)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
							$author$project$Ui$V3$Button$disabled(disabled)
						]),
					'Cancel')),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnSaveClick)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$disabled(disabled)
						]),
					'Save'))
			]));
};
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewHeaderV3Reskin = F2(
	function (config, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$elm$core$Maybe$Just(
						A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Document types')
										])),
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									A2(
										$elm$html$Html$p,
										_List_Nil,
										$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$isSameAsGlobal(model) ? config.descriptions.sameAsGlobal : config.descriptions.hasDifferences))
								])))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					model.isEditing ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							$author$project$Ui$V3$UtilityButton$view,
							{icon: $author$project$Ui$V3$Icon$editOutline16, label: 'Edit', onClick: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnMakeChangesClick},
							_List_Nil)))
				]));
	});
var $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewV3Reskin = F3(
	function (config, _v0, model) {
		var useAccountSettingsToggle = _Utils_Tuple2('Use account settings', $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$ClickedUseAccountSettings);
		var messages = {onCheck: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnRowCheck, onUncheck: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$OnRowUncheck, setPayablesValue: $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$SetPayablesValue};
		var table = A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: A2(
					$elm$core$List$map,
					function (column) {
						return {
							attrs: _List_Nil,
							content: A2(
								column.view,
								{isDisabled: !model.isEditing},
								messages),
							heading: $elm$html$Html$text(column.header)
						};
					},
					config.columns)
			},
			_List_Nil,
			_List_Nil,
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.name;
				},
				model.rows));
		var customToggle = _Utils_Tuple2('Custom', $author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$ClickedCustom);
		var container = function (els) {
			return A2(
				$author$project$Ui$V3$Stack$viewVertMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$styleAsCard,
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				els);
		};
		return container(
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewHeaderV3Reskin, config, model)),
					model.isEditing ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$SegmentedButtonGroup$view,
						{
							onClick: $elm$core$Tuple$second,
							segments: _List_fromArray(
								[useAccountSettingsToggle, customToggle]),
							selected: $elm$core$Maybe$Just(
								model.useAccountSettings ? useAccountSettingsToggle : customToggle),
							toLabel: $elm$core$Tuple$first
						},
						_List_Nil)) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(table),
					model.isEditing ? $elm$core$Maybe$Just(
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewControlsV3Reskin(model.status)) : $elm$core$Maybe$Nothing
				]));
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$CancelEditing = {$: 'CancelEditing'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$StartEditing = {$: 'StartEditing'};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewReferenceDropdownV3Reskin = function (model) {
	return A2(
		$author$project$Ui$V3$Stack$viewHorzWithWidths,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
				$author$project$Ui$V3$Stack$crossAxisBottom
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$author$project$Helpers$Html$labeledInput,
					'Rule',
					A2(
						$author$project$Ui$V3$SimpleSelect$view,
						{onInput: $author$project$Components$SettingsPage$Shared$ReferenceTable$SelectReference, options: model.references, toLabel: $elm$core$Basics$identity, value: model.selectedReference},
						_List_fromArray(
							[
								$author$project$Ui$V3$SimpleSelect$placeholder(
								$elm$core$Maybe$Just(''))
							])))),
				_Utils_Tuple2(
				$author$project$Ui$V3$Stack$fit,
				A2(
					$elm$core$Maybe$withDefault,
					A3(
						$author$project$Ui$V3$Button$view,
						{action: $author$project$Ui$V3$Button$submitForm},
						_List_fromArray(
							[
								$author$project$Ui$V3$Button$disabled(true)
							]),
						'Add'),
					A2(
						$elm$core$Maybe$map,
						function (ref) {
							return A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick(
										$author$project$Components$SettingsPage$Shared$ReferenceTable$AddReference(ref))
								},
								_List_Nil,
								'Add');
						},
						model.selectedReference)))
			]));
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewRemoveV3Reskin = function (item) {
	return A2(
		$author$project$Ui$V3$UtilityButton$view,
		{
			icon: $author$project$Ui$V3$Icon$removeOutline16,
			label: 'Remove',
			onClick: A2($author$project$Components$SettingsPage$Shared$ReferenceTable$UpdateItem, item, $author$project$Components$SettingsPage$Shared$ReferenceTable$Remove)
		},
		_List_Nil);
};
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewRuleV3Reskin = F2(
	function (isEditing, item) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$V3$SimpleSelect$view,
						{
							onInput: A2(
								$elm$core$Basics$composeL,
								$author$project$Components$SettingsPage$Shared$ReferenceTable$UpdateItem(item),
								$author$project$Components$SettingsPage$Shared$ReferenceTable$SetOption),
							options: _List_fromArray(
								[$author$project$Components$SettingsPage$Shared$ReferenceTable$IsPresentOption, $author$project$Components$SettingsPage$Shared$ReferenceTable$IsEmptyOption, $author$project$Components$SettingsPage$Shared$ReferenceTable$HasValueOption, $author$project$Components$SettingsPage$Shared$ReferenceTable$NotValueOption, $author$project$Components$SettingsPage$Shared$ReferenceTable$BeginsWithOption]),
							toLabel: $author$project$Components$SettingsPage$Shared$ReferenceTable$optionToString,
							value: $elm$core$Maybe$Just(item.option)
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$SimpleSelect$disabled(!isEditing)
							]))),
					$author$project$Components$SettingsPage$Shared$ReferenceTable$optionNeedsInput(item.option) ? $elm$core$Maybe$Just(
					A4(
						$author$project$Ui$V3$Input$view,
						{
							onInput: A2(
								$elm$core$Basics$composeL,
								$author$project$Components$SettingsPage$Shared$ReferenceTable$UpdateItem(item),
								$author$project$Components$SettingsPage$Shared$ReferenceTable$SetValue)
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Input$disabled(!isEditing)
							]),
						_List_Nil,
						item.value)) : $elm$core$Maybe$Nothing
				]));
	});
var $author$project$Components$SettingsPage$Shared$ReferenceTable$viewV3Reskin = F2(
	function (description, model) {
		var table = $author$project$Components$SettingsPage$Shared$ReferenceTable$hasItems(model) ? A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.label;
									},
									$author$project$Ui$V3$Typography$smallBodySemiBold(_List_Nil)),
								heading: $elm$html$Html$text('Reference')
							}),
							$elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: $author$project$Components$SettingsPage$Shared$ReferenceTable$viewRuleV3Reskin(model.isEditing),
								heading: $elm$html$Html$text('Rule')
							}),
							model.isEditing ? $elm$core$Maybe$Just(
							{
								attrs: _List_Nil,
								content: $author$project$Components$SettingsPage$Shared$ReferenceTable$viewRemoveV3Reskin,
								heading: $elm$html$Html$text('')
							}) : $elm$core$Maybe$Nothing
						]))
			},
			_List_Nil,
			_List_Nil,
			$author$project$Helpers$Savable$value(model.items)) : A4(
			$author$project$Ui$V3$Table$view,
			{
				columns: _List_fromArray(
					[
						{
						attrs: _List_Nil,
						content: $elm$core$Basics$always(
							A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No reference rules')
									]))),
						heading: $elm$html$Html$text('Reference')
					},
						{
						attrs: _List_Nil,
						content: $elm$core$Basics$always(
							$elm$html$Html$text('')),
						heading: $elm$html$Html$text('Rule')
					}
					])
			},
			_List_Nil,
			_List_Nil,
			_List_fromArray(
				[_Utils_Tuple0]));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h3,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Required references')
											])),
										description
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							model.isEditing ? $elm$html$Html$text('') : A2(
								$author$project$Ui$V3$UtilityButton$view,
								{icon: $author$project$Ui$V3$Icon$editOutline16, label: 'Edit', onClick: $author$project$Components$SettingsPage$Shared$ReferenceTable$StartEditing},
								_List_fromArray(
									[$author$project$Ui$V3$UtilityButton$sizeSmall])))
						])),
					model.isEditing ? A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
						]),
					_List_fromArray(
						[
							$author$project$Components$SettingsPage$Shared$ReferenceTable$viewReferenceDropdownV3Reskin(model),
							table,
							$author$project$Helpers$Html$editButtons(
							{
								cancelMsg: $author$project$Components$SettingsPage$Shared$ReferenceTable$CancelEditing,
								primaryDisabled: model.isSaving,
								primaryLabel: 'Save',
								primaryMsg: $author$project$Components$SettingsPage$Shared$ReferenceTable$ClickedSave(
									{v3ReskinEnabled: true})
							})
						])) : table
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$sectionsV3Reskin = F3(
	function (customerId, data, formState) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
						$author$project$Components$SettingsPage$CustomerLayout$paymentTermsConfigV3Reskin(customerId),
						formState.paymentTerms)),
					$elm$core$Maybe$Just(
					A3(
						$author$project$Components$SettingsPage$CustomerLayout$billingIntervalSectionV3Reskin,
						$author$project$Components$SettingsPage$CustomerLayout$billingIntervalConfigV3Reskin(customerId),
						formState.billingInterval,
						data.accountSettings)),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.accountSettings.ltlTolerancesEnabled,
					$author$project$Components$SettingsPage$CustomerLayout$ltlToleranceSectionV3Reskin(
						$author$project$Components$SettingsPage$CustomerLayout$ltlToleranceConfigV3Reskin(customerId)),
					formState.ltlTolerance),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.accountSettings.ltlCustomerMarginToleranceEnabled,
					$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginSectionV3Reskin(
						$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerMarginToleranceConfigV3Reskin(customerId)),
					formState.ltlCustomerMarginTolerance),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.accountSettings.ltlRerateEnabled,
					A2(
						$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateSectionV3Reskin,
						$author$project$Components$SettingsPage$CustomerLayout$ltlCustomerAutoRateConfigV3Reskin(customerId),
						data.accountSettings),
					formState.ltlCustomerAutoRate),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.accountSettings.ltlReweighChargeExceptionsEnabled,
					$author$project$Components$SettingsPage$CustomerLayout$ltlReweighChargeExceptionsSectionV3Reskin(
						$author$project$Components$SettingsPage$CustomerLayout$ltlReweighChargeExceptionsConfigV3Reskin(customerId)),
					formState.ltlReweighChargeExceptions),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.accountSettings.ltlReweighChargeExceptionsEnabled && data.customerSettings.ltlReweighChargeExceptionsEnabled,
					$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin(
						$author$project$Components$SettingsPage$CustomerLayout$ltlRequireManualReweighReviewConfigV3Reskin(customerId)),
					formState.ltlRequireManualReweighReview),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.currentAccount.receivablesAccount,
					A2(
						$author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateSectionV3Reskin,
						A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfigV3Reskin, $author$project$Components$SettingsPage$CustomerLayout$InvoiceTemplate, customerId, data.invoiceTemplates),
						data.accountSettings),
					formState.invoiceTemplate),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.currentAccount.receivablesAccount && data.currentAccount.payablesAccount,
					A2(
						$author$project$Components$SettingsPage$CustomerLayout$statementInvoiceTemplateSectionV3Reskin,
						A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfigV3Reskin, $author$project$Components$SettingsPage$CustomerLayout$StatementInvoiceTemplate, customerId, data.invoiceTemplates),
						data.accountSettings),
					formState.statementInvoiceTemplate),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.currentAccount.receivablesAccount && data.currentAccount.payablesAccount,
					A2(
						$author$project$Components$SettingsPage$CustomerLayout$masterInvoiceTemplateSectionV3Reskin,
						A3($author$project$Components$SettingsPage$CustomerLayout$invoiceTemplateConfigV3Reskin, $author$project$Components$SettingsPage$CustomerLayout$MasterInvoiceTemplate, customerId, data.invoiceTemplates),
						data.accountSettings),
					formState.masterInvoiceTemplate),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.currentAccount.receivablesAccount && ($elm$core$List$length(data.remitToAddresses) > 1),
					$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin(
						A2($author$project$Components$SettingsPage$CustomerLayout$remitToAddressConfigV3Reskin, customerId, data.remitToAddresses)),
					formState.remitToAddress),
					$elm$core$Maybe$Just(
					A3(
						$author$project$Components$SettingsPage$CustomerLayout$customerInstructionsSectionV3Reskin,
						$author$project$Components$SettingsPage$CustomerLayout$instructionsConfigV3Reskin(customerId),
						formState.instructions,
						data.accountSettings)),
					$elm$core$Maybe$Just(
					A3(
						$author$project$Components$SettingsPage$CustomerLayout$deliveryMethodSectionV3Reskin,
						A2($author$project$Components$SettingsPage$CustomerLayout$deliveryMethodConfigV3Reskin, customerId, data),
						formState.deliveryMethod,
						data.accountSettings)),
					$elm$core$Maybe$Just(
					A2(
						$author$project$Components$SettingsPage$Shared$EditSection$viewV3Reskin,
						A3($author$project$Components$SettingsPage$CustomerLayout$customSubjectConfigV3Config, customerId, data.customerSettings, data.accountSettings),
						formState.customSubject)),
					$elm$core$Maybe$Just(
					A3(
						$author$project$Components$SettingsPage$CustomerLayout$billingEmailsSectionV3Reskin,
						$author$project$Components$SettingsPage$CustomerLayout$billingEmailConfigV3Reskin(customerId),
						formState.billingEmail,
						data.accountSettings)),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$map,
						$author$project$Components$SettingsPage$CustomerLayout$DocumentTypesUpdate,
						A3(
							$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$viewV3Reskin,
							A2($author$project$Components$SettingsPage$CustomerLayout$documentTypesSettingsFromDataV3Reskin, customerId, data),
							data.currentAccount,
							formState.documentTypes))),
					$elm$core$Maybe$Just(
					A3(
						$author$project$Components$SettingsPage$CustomerLayout$podRequirementSectionV3Reskin,
						$author$project$Components$SettingsPage$CustomerLayout$podRequirementPolicyConfigV3Reskin(customerId),
						formState.podRequirementPolicy,
						data.accountSettings)),
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$justWhen,
					data.currentAccount.receivablesAccount,
					A2(
						$author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentSectionV3Reskin,
						$author$project$Components$SettingsPage$CustomerLayout$ignoreInvoiceDocumentConfigV3Reskin(customerId),
						data.accountSettings),
					formState.ignoreInvoiceDocument),
					$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$map,
						$author$project$Components$SettingsPage$CustomerLayout$ReferencesUpdate,
						A2(
							$author$project$Components$SettingsPage$Shared$ReferenceTable$viewV3Reskin,
							A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These rules will only apply to this customer, in addition to the '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/app/settings/rules')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('account\u0027s reference rules')
											])),
										$elm$html$Html$text('.')
									])),
							formState.requiredReferences))),
					$elm$core$Maybe$Just(
					A2($author$project$Components$SettingsPage$CustomerLayout$customExceptionMessagesSectionV3Reskin, formState.customExceptionMessages, data.accountSettings)),
					$author$project$Components$SettingsPage$CustomerLayout$viewSkipReviewSection(data.customerSettings)
				]));
	});
var $author$project$Components$SettingsPage$CustomerLayout$authorizedViewV3Reskin = F2(
	function (model, data) {
		var header = $elm$core$String$concat(
			_List_fromArray(
				[
					data.customerSettings.name,
					A3(
					$author$project$Components$SettingsPage$CustomerLayout$maybe,
					'',
					function (x) {
						return ' (' + (x + ')');
					},
					data.customerSettings.accountNumber)
				]));
		var formState = A2($author$project$Components$SettingsPage$CustomerLayout$currentFormState, data, model);
		return A3(
			$author$project$Components$SettingsPage$CustomerLayout$settingsFrameView,
			true,
			data,
			$author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Ui$V3$Typography$smallBodySemiBoldClass,
											$elm$html$Html$Events$onClick($author$project$Components$SettingsPage$CustomerLayout$GoBack)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$V3$Stack$viewHorzWithWidths,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
													$author$project$Ui$V3$Stack$crossAxisCenter
												]),
											_List_fromArray(
												[
													_Utils_Tuple2(
													$author$project$Ui$V3$Stack$fit,
													A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$arrowLeft16)),
													_Utils_Tuple2(
													$author$project$Ui$V3$Stack$fit,
													$elm$html$Html$text('All customers'))
												]))
										])),
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(header)
										]))
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$SettingsPage$CustomerLayout$LoadedMsg,
							A2(
								$author$project$Ui$V3$Stack$viewHorz,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$V3$Stack$viewVert,
										_List_fromArray(
											[
												$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
											]),
										A3($author$project$Components$SettingsPage$CustomerLayout$sectionsV3Reskin, model.customerId, data, formState)),
										A3($author$project$Components$SettingsPage$CustomerLayout$contactListViewV3Reskin, data.accountSettings, data.customerSettings.contacts, formState.contactForm)
									])))
						]))));
	});
var $author$project$Components$SettingsPage$CustomerLayout$view = F3(
	function (v3ReskinEnabled, model, data) {
		return data.currentUser.hasSettingsRole ? (v3ReskinEnabled ? A2($author$project$Components$SettingsPage$CustomerLayout$authorizedViewV3Reskin, model, data) : A2($author$project$Components$SettingsPage$CustomerLayout$authorizedView, model, data)) : A3(
			$author$project$Components$SettingsPage$CustomerLayout$settingsFrameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.'));
	});
var $author$project$Components$SettingsPage$CustomersLayout$ChangeSearchTerm = function (a) {
	return {$: 'ChangeSearchTerm', a: a};
};
var $author$project$Components$SettingsPage$CustomersLayout$pageTitle = F2(
	function (v3ReskinEnabled, searchTerm) {
		if (searchTerm === '') {
			return v3ReskinEnabled ? 'All customers' : 'All Customers';
		} else {
			var filter = searchTerm;
			return 'Customers matching: \u0022' + (filter + '\u0022');
		}
	});
var $author$project$Components$SettingsPage$CustomersLayout$settingsFrameView = F2(
	function (v3ReskinEnabled, data) {
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Customers, data.currentAccount, data.accountSettings, data.currentUser);
	});
var $author$project$Components$SettingsPage$CustomersLayout$ChangePage = function (a) {
	return {$: 'ChangePage', a: a};
};
var $author$project$Components$SettingsPage$CustomersLayout$GoToUrl = function (a) {
	return {$: 'GoToUrl', a: a};
};
var $author$project$Components$SettingsPage$CustomersLayout$linkToCustomerPage = function (back) {
	return A4(
		$author$project$Helpers$GenericLink$genericLink,
		$author$project$Components$SettingsPage$CustomersLayout$GoToUrl(back),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button--confirmation small')
			]),
		back,
		_List_fromArray(
			[
				$elm$html$Html$text('View')
			]));
};
var $author$project$Components$SettingsPage$CustomersLayout$customerView = function (_v0) {
	var id = _v0.id;
	var accountNumber = _v0.accountNumber;
	var name = _v0.name;
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', accountNumber))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$CustomersLayout$linkToCustomerPage(
						'/app/settings/customers/' + $elm$core$String$fromInt(
							$author$project$Domain$TmsCustomerId$toInt(id)))
					]))
			]));
};
var $author$project$Pagination$isEmpty = function (page) {
	return $elm$core$List$isEmpty(
		$author$project$Pagination$entries(page));
};
var $author$project$Components$SettingsPage$CustomersLayout$tableView = function (customers) {
	return $author$project$Pagination$isEmpty(customers) ? $elm$html$Html$text('No customers found.') : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Components$Shared$Grid$autoRow,
				12,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '1.5em')
							]),
						_List_fromArray(
							[
								A2($author$project$Pagination$View$view, $author$project$Components$SettingsPage$CustomersLayout$ChangePage, customers)
							]))
					])),
				A2(
				$author$project$Components$Shared$Grid$autoRow,
				12,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', '100%')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Name')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Account Number')
													])),
												A2($elm$html$Html$th, _List_Nil, _List_Nil)
											]))
									])),
							A2(
								$elm$core$List$map,
								$author$project$Components$SettingsPage$CustomersLayout$customerView,
								$author$project$Pagination$entries(customers))))
					]))
			]));
};
var $author$project$Components$SettingsPage$CustomersLayout$authorizedView = F2(
	function (model, data) {
		return A3(
			$author$project$Components$SettingsPage$CustomersLayout$settingsFrameView,
			false,
			data,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('customer-browser')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Shared$Grid$autoRow,
						5,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Components$SettingsPage$CustomersLayout$pageTitle, false, model.term))
									]))
							])),
						A2(
						$author$project$Components$Shared$Grid$autoRow,
						12,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$placeholder('Search Customers'),
										$elm$html$Html$Events$onInput($author$project$Components$SettingsPage$CustomersLayout$ChangeSearchTerm),
										$elm$html$Html$Attributes$value(model.term),
										$elm$html$Html$Attributes$autofocus(true)
									]),
								_List_Nil),
								A2($author$project$Forward$LoadingView$view, $author$project$Components$SettingsPage$CustomersLayout$tableView, data.customers)
							]))
					])));
	});
var $author$project$Components$SettingsPage$CustomersLayout$tableColumnHeading = $author$project$Ui$V3$Typography$xSmallBodySemiBold(_List_Nil);
var $author$project$Components$SettingsPage$CustomersLayout$tableViewV3Reskin = function (customers) {
	return $author$project$Pagination$isEmpty(customers) ? $elm$html$Html$text('No customers found.') : A4(
		$author$project$Ui$V3$Table$view,
		{
			columns: _List_fromArray(
				[
					{
					attrs: _List_Nil,
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.name;
						},
						$author$project$Ui$V3$Typography$xSmallBodySemiBold(_List_Nil)),
					heading: $author$project$Components$SettingsPage$CustomersLayout$tableColumnHeading('Name')
				},
					{
					attrs: _List_Nil,
					content: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.accountNumber;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(''),
							$elm$html$Html$text)),
					heading: $author$project$Components$SettingsPage$CustomersLayout$tableColumnHeading('Account number')
				}
				])
		},
		_List_fromArray(
			[
				$author$project$Ui$V3$Table$pagination(
				{currentPage: customers, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: $author$project$Components$SettingsPage$CustomersLayout$ChangePage}),
				$author$project$Ui$V3$Table$clickable(
				{
					onClick: function (_v0) {
						var id = _v0.id;
						return $author$project$Components$SettingsPage$CustomersLayout$GoToUrl(
							'/app/settings/customers/' + $elm$core$String$fromInt(
								$author$project$Domain$TmsCustomerId$toInt(id)));
					}
				})
			]),
		_List_Nil,
		$author$project$Pagination$entries(customers));
};
var $author$project$Components$SettingsPage$CustomersLayout$authorizedViewV3Reskin = F2(
	function (model, data) {
		return A3(
			$author$project$Components$SettingsPage$CustomersLayout$settingsFrameView,
			true,
			data,
			$author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$testId('carriers-container'),
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Components$SettingsPage$CustomersLayout$pageTitle, true, model.term))
								])),
							A4(
							$author$project$Ui$V3$SearchInput$view,
							{
								onClear: $author$project$Components$SettingsPage$CustomersLayout$ChangeSearchTerm(''),
								onInput: $author$project$Components$SettingsPage$CustomersLayout$ChangeSearchTerm
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$SearchInput$placeholder('Search customers')
								]),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$autofocus(true)
								]),
							model.term),
							A2($author$project$Forward$LoadingView$viewV3Reskin, $author$project$Components$SettingsPage$CustomersLayout$tableViewV3Reskin, data.customers)
						]))));
	});
var $author$project$Components$SettingsPage$CustomersLayout$view = F3(
	function (v3ReskinEnabled, model, data) {
		return data.currentUser.hasSettingsRole ? (v3ReskinEnabled ? A2($author$project$Components$SettingsPage$CustomersLayout$authorizedViewV3Reskin, model, data) : A2($author$project$Components$SettingsPage$CustomersLayout$authorizedView, model, data)) : A3(
			$author$project$Components$SettingsPage$CustomersLayout$settingsFrameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.'));
	});
var $author$project$Components$SettingsPage$DebtorLayout$AllowAutoprocessing_Set = function (a) {
	return {$: 'AllowAutoprocessing_Set', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$sectionView = F2(
	function (innerHeader, innerBody) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-header')
						]),
					innerHeader),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-body')
						]),
					innerBody)
				]));
	});
var $author$project$Components$SettingsPage$DebtorLayout$allowAutoprocessingView = function (_v0) {
	var value = _v0.value;
	var saving = _v0.saving;
	return A2(
		$author$project$Components$SettingsPage$DebtorLayout$sectionView,
		_List_fromArray(
			[
				$elm$html$Html$text('Autoprocessing')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('When enabled, invoices for this debtor will be processed according to client rules.'),
						$elm$html$Html$text('When disabled, invoices to this debtor will never be autoprocessed.')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$id('allowautoprocessing'),
						$elm$html$Html$Attributes$disabled(saving),
						$elm$html$Html$Attributes$checked(value),
						$elm$html$Html$Events$onCheck($author$project$Components$SettingsPage$DebtorLayout$AllowAutoprocessing_Set)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('allowautoprocessing')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Enable Autoprocessing')
					]))
			]));
};
var $author$project$Components$SettingsPage$DebtorLayout$LoadIdAutoRelease_Set = function (a) {
	return {$: 'LoadIdAutoRelease_Set', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$loadIdAutoReleaseAccuracy = F2(
	function (tz, autoRelease) {
		var _v0 = _Utils_Tuple2(autoRelease.keptPercentage, autoRelease.priorCount);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var percentage = _v0.a.a;
			var count = _v0.b.a;
			return 'Auditors kept the documents\u0027 load ID ' + ($elm$core$String$fromInt(
				$elm$core$Basics$round(percentage * 100)) + ('% of the last ' + ($elm$core$String$fromInt(count) + (' times this debtor disagreed' + function () {
				var _v1 = autoRelease.statsUpdatedAt;
				if (_v1.$ === 'Just') {
					var at = _v1.a;
					return ', measured ' + (A2($author$project$Helpers$Date$dateString, tz, at) + '.');
				} else {
					return '.';
				}
			}()))));
		} else {
			return 'No recent accuracy has been measured for this debtor.';
		}
	});
var $author$project$Components$SettingsPage$DebtorLayout$loadIdAutoReleaseTrail = F2(
	function (tz, autoRelease) {
		var supersededByOn = function (at) {
			var _v0 = autoRelease.enabledAt;
			if (_v0.$ === 'Just') {
				var enabledAt = _v0.a;
				return _Utils_cmp(
					$elm$time$Time$posixToMillis(enabledAt),
					$elm$time$Time$posixToMillis(at)) > 0;
			} else {
				return false;
			}
		};
		var line = F3(
			function (verb, name, at) {
				return verb + (' by ' + (A2($elm$core$Maybe$withDefault, 'an auditor', name) + (' on ' + A2($author$project$Helpers$Date$toString, tz, at))));
			});
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2(line, 'Turned on', autoRelease.enabledByName),
					autoRelease.enabledAt),
					A2(
					$elm$core$Maybe$andThen,
					function (at) {
						return supersededByOn(at) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A3(line, 'Turned off', autoRelease.disabledByName, at));
					},
					autoRelease.disabledAt)
				]));
	});
var $author$project$Components$SettingsPage$DebtorLayout$loadIdAutoReleaseView = F3(
	function (tz, autoRelease, _v0) {
		var value = _v0.value;
		var saving = _v0.saving;
		return A2(
			$author$project$Components$SettingsPage$DebtorLayout$sectionView,
			_List_fromArray(
				[
					$elm$html$Html$text('Load ID Auto-Release')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('When on, invoices for this debtor are released without review when the load ID on the documents disagrees with the one the client submitted. It applies to every client billing this debtor.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Components$SettingsPage$DebtorLayout$loadIdAutoReleaseAccuracy, tz, autoRelease))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (line) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(line)
									]));
						},
						A2($author$project$Components$SettingsPage$DebtorLayout$loadIdAutoReleaseTrail, tz, autoRelease))),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$id('loadidautorelease'),
							$elm$html$Html$Attributes$disabled(saving || (!(value || autoRelease.eligible))),
							$elm$html$Html$Attributes$checked(value),
							$elm$html$Html$Events$onCheck($author$project$Components$SettingsPage$DebtorLayout$LoadIdAutoRelease_Set)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('loadidautorelease')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							(value || autoRelease.eligible) ? 'Release load ID disagreements for this debtor' : 'Not enough load ID history yet to turn this on for this debtor')
						]))
				]));
	});
var $author$project$Components$SettingsPage$DebtorLayout$SetFactorBrokerLoadIdRegressionRuleMode = function (a) {
	return {$: 'SetFactorBrokerLoadIdRegressionRuleMode', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$loadIdRegressionRulesView = function (form) {
	var handleChange = function (raw) {
		return $author$project$Components$SettingsPage$DebtorLayout$SetFactorBrokerLoadIdRegressionRuleMode(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$AuditPb$rulesModeDefault,
				$author$project$AuditPb$rulesModeFromString(raw)));
	};
	return A2(
		$author$project$Components$SettingsPage$DebtorLayout$sectionView,
		_List_fromArray(
			[
				$elm$html$Html$text('Load ID Regression Rules')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-id-regression-override-options')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$id('load-id-regression-inherit'),
										$elm$html$Html$Attributes$name('load-id-regression-override'),
										$elm$html$Html$Attributes$value('unset'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(form.value, $author$project$AuditPb$RulesModeUnset)),
										$elm$html$Html$Attributes$disabled(form.saving),
										$elm$html$Html$Events$onInput(handleChange)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('load-id-regression-inherit')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Use Default Load ID Regression Rules')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$id('load-id-regression-disabled'),
										$elm$html$Html$Attributes$name('load-id-regression-override'),
										$elm$html$Html$Attributes$value('off'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(form.value, $author$project$AuditPb$RulesModeOff)),
										$elm$html$Html$Attributes$disabled(form.saving),
										$elm$html$Html$Events$onInput(handleChange)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('load-id-regression-disabled')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Load ID Regression Not Required')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$id('load-id-regression-enabled'),
										$elm$html$Html$Attributes$name('load-id-regression-override'),
										$elm$html$Html$Attributes$value('on'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(form.value, $author$project$AuditPb$RulesModeOn)),
										$elm$html$Html$Attributes$disabled(form.saving),
										$elm$html$Html$Events$onInput(handleChange)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('load-id-regression-enabled')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Always Require Load ID Regression')
									]))
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$DebtorLayout$LoadIdStrategies_Toggle = F2(
	function (a, b) {
		return {$: 'LoadIdStrategies_Toggle', a: a, b: b};
	});
var $author$project$Domain$LoadIdStrategy$label = function (strategy) {
	switch (strategy.$) {
		case 'LoadIdStrategyStripDashedSuffix':
			return 'Ignore the last hyphen and everything after it';
		case 'LoadIdStrategyStripLeadingZeros':
			return 'Ignore leading zeros';
		case 'LoadIdStrategyStripWhitespace':
			return 'Ignore spaces';
		case 'LoadIdStrategyStripColons':
			return 'Ignore colons';
		case 'LoadIdStrategyStripPipe':
			return 'Ignore pipe characters';
		case 'LoadIdStrategyUpcase':
			return 'Ignore capitalization';
		case 'LoadIdStrategyNumbersOnly':
			return 'Ignore everything except digits';
		default:
			return 'Ignore everything except letters and digits';
	}
};
var $author$project$Components$SettingsPage$DebtorLayout$loadIdStrategyRow = F4(
	function (accountStrategies, saving, selected, strategy) {
		var elementId = 'loadidstrategy-' + $author$project$AuditPb$loadIdStrategyToString(strategy);
		var accountWide = A2($elm$core$List$member, strategy, accountStrategies);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$id(elementId),
							$elm$html$Html$Attributes$disabled(saving || accountWide),
							$elm$html$Html$Attributes$checked(
							accountWide || A2($elm$core$List$member, strategy, selected)),
							$elm$html$Html$Events$onCheck(
							$author$project$Components$SettingsPage$DebtorLayout$LoadIdStrategies_Toggle(strategy))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(elementId)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Domain$LoadIdStrategy$label(strategy)),
							A3(
							$author$project$Components$SettingsPage$DebtorLayout$when,
							accountWide,
							function (_v0) {
								return $elm$html$Html$text(' (on for every debtor on this account)');
							},
							_Utils_Tuple0)
						]))
				]));
	});
var $author$project$Components$SettingsPage$DebtorLayout$loadIdStrategiesView = F2(
	function (accountStrategies, _v0) {
		var value = _v0.value;
		var saving = _v0.saving;
		return A2(
			$author$project$Components$SettingsPage$DebtorLayout$sectionView,
			_List_fromArray(
				[
					$elm$html$Html$text('Load ID Matching')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Rules for matching this debtor\u0027s load IDs against the ones your clients bill under. Only matching is affected — the load ID on the invoice and on the documents is left alone.'),
							$elm$html$Html$text(' With the hyphen rule on, for instance, \u00221005082-2\u0022 is matched as \u00221005082\u0022.')
						])),
				A2(
					$elm$core$List$map,
					A3($author$project$Components$SettingsPage$DebtorLayout$loadIdStrategyRow, accountStrategies, saving, value),
					$author$project$AuditPb$allLoadIdStrategy)));
	});
var $author$project$Components$SettingsPage$DebtorLayout$RateConfirmationRequired_Set = function (a) {
	return {$: 'RateConfirmationRequired_Set', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$rateConfirmationView = function (_v0) {
	var rateConfirmationRequiredForm = _v0.rateConfirmationRequiredForm;
	var accountSettings = _v0.accountSettings;
	var rateConfDisabled = rateConfirmationRequiredForm.saving || accountSettings.apiRateConfirmationRequired;
	return A2(
		$author$project$Components$SettingsPage$DebtorLayout$sectionView,
		_List_fromArray(
			[
				$elm$html$Html$text('Rate Confirmation')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$id('rateconfirmationrequired'),
						$elm$html$Html$Attributes$disabled(rateConfDisabled),
						$elm$html$Html$Attributes$checked(rateConfirmationRequiredForm.value),
						$elm$html$Html$Events$onCheck($author$project$Components$SettingsPage$DebtorLayout$RateConfirmationRequired_Set)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('rateconfirmationrequired')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						accountSettings.apiRateConfirmationRequired ? 'Rate confirmation required (controlled by FMS)' : 'Rate confirmation required')
					]))
			]));
};
var $author$project$Components$SettingsPage$DebtorLayout$SkipAutoStamp_Set = function (a) {
	return {$: 'SkipAutoStamp_Set', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$skipAutoStampView = function (_v0) {
	var value = _v0.value;
	var saving = _v0.saving;
	return A2(
		$author$project$Components$SettingsPage$DebtorLayout$sectionView,
		_List_fromArray(
			[
				$elm$html$Html$text('Auto Stamping')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$id('skipautostamp'),
						$elm$html$Html$Attributes$disabled(saving),
						$elm$html$Html$Attributes$checked(value),
						$elm$html$Html$Events$onCheck($author$project$Components$SettingsPage$DebtorLayout$SkipAutoStamp_Set)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('skipautostamp')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Don\u0027t Auto Stamp documents for this debtor')
					]))
			]));
};
var $author$project$Components$SettingsPage$DebtorLayout$Default = {$: 'Default'};
var $author$project$Components$SettingsPage$DebtorLayout$NotRequired = {$: 'NotRequired'};
var $author$project$Components$SettingsPage$DebtorLayout$Required = {$: 'Required'};
var $author$project$Components$SettingsPage$DebtorLayout$SetVerificationWorkflow = function (a) {
	return {$: 'SetVerificationWorkflow', a: a};
};
var $author$project$Components$SettingsPage$DebtorLayout$verificationRulesView = function (_v0) {
	var requireVerificationsWorkflowForm = _v0.requireVerificationsWorkflowForm;
	var excludeFromVerificationsWorkflowForm = _v0.excludeFromVerificationsWorkflowForm;
	var verificationValue = requireVerificationsWorkflowForm.value ? $author$project$Components$SettingsPage$DebtorLayout$Required : (excludeFromVerificationsWorkflowForm.value ? $author$project$Components$SettingsPage$DebtorLayout$NotRequired : $author$project$Components$SettingsPage$DebtorLayout$Default);
	var verificationSaving = excludeFromVerificationsWorkflowForm.saving || requireVerificationsWorkflowForm.saving;
	var handleVerificationChange = function (value) {
		switch (value) {
			case 'required':
				return $author$project$Components$SettingsPage$DebtorLayout$SetVerificationWorkflow($author$project$Components$SettingsPage$DebtorLayout$Required);
			case 'not_required':
				return $author$project$Components$SettingsPage$DebtorLayout$SetVerificationWorkflow($author$project$Components$SettingsPage$DebtorLayout$NotRequired);
			default:
				return $author$project$Components$SettingsPage$DebtorLayout$SetVerificationWorkflow($author$project$Components$SettingsPage$DebtorLayout$Default);
		}
	};
	return A2(
		$author$project$Components$SettingsPage$DebtorLayout$sectionView,
		_List_fromArray(
			[
				$elm$html$Html$text('Verification Rules')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification-options')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$id('verification-default'),
										$elm$html$Html$Attributes$name('verification-workflow'),
										$elm$html$Html$Attributes$value('default'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(verificationValue, $author$project$Components$SettingsPage$DebtorLayout$Default)),
										$elm$html$Html$Attributes$disabled(verificationSaving),
										$elm$html$Html$Events$onInput(handleVerificationChange)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('verification-default')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Use Default Verification Rules')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$id('verification-not-required'),
										$elm$html$Html$Attributes$name('verification-workflow'),
										$elm$html$Html$Attributes$value('not_required'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(verificationValue, $author$project$Components$SettingsPage$DebtorLayout$NotRequired)),
										$elm$html$Html$Attributes$disabled(verificationSaving),
										$elm$html$Html$Events$onInput(handleVerificationChange)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('verification-not-required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Verification Not Required')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Attributes$id('verification-required'),
										$elm$html$Html$Attributes$name('verification-workflow'),
										$elm$html$Html$Attributes$value('required'),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(verificationValue, $author$project$Components$SettingsPage$DebtorLayout$Required)),
										$elm$html$Html$Attributes$disabled(verificationSaving),
										$elm$html$Html$Events$onInput(handleVerificationChange)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('verification-required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Always Require Verification')
									]))
							]))
					]))
			]));
};
var $author$project$Components$SettingsPage$DebtorLayout$sections = F4(
	function (tz, debtorId, data, formState) {
		return _List_fromArray(
			[
				A2(
				$author$project$Components$SettingsPage$Shared$EditSection$view,
				A2($author$project$Components$SettingsPage$DebtorLayout$deliveryMethodConfig, debtorId, data),
				formState.deliveryMethod),
				A2(
				$author$project$Components$SettingsPage$Shared$EditSection$view,
				A2($author$project$Components$SettingsPage$DebtorLayout$billingEmailConfig, data.accountSettings.controlledByTMS.debtorBillingEmail, debtorId),
				formState.billingEmail),
				A3(
				$author$project$Components$SettingsPage$DebtorLayout$when,
				data.accountSettings.verificationsWorkflowEnabled,
				$author$project$Components$SettingsPage$Shared$EditSection$view(
					$author$project$Components$SettingsPage$DebtorLayout$contactInfoConfig(debtorId)),
				formState.contactInfo),
				A2(
				$elm$html$Html$map,
				$author$project$Components$SettingsPage$DebtorLayout$DocumentTypesUpdate,
				A3(
					$author$project$Components$SettingsPage$Shared$CustomerDocumentTypes$view,
					A2($author$project$Components$SettingsPage$DebtorLayout$documentTypesSettingsFromData, debtorId, data),
					data.currentAccount,
					formState.documentTypes)),
				A3(
				$author$project$Components$SettingsPage$DebtorLayout$when,
				data.currentAccount.receivablesAccount,
				$author$project$Components$SettingsPage$Shared$EditSection$view(
					$author$project$Components$SettingsPage$DebtorLayout$billingIntervalConfig(debtorId)),
				formState.billingInterval),
				A3(
				$author$project$Components$SettingsPage$DebtorLayout$when,
				data.currentAccount.receivablesAccount,
				$author$project$Components$SettingsPage$Shared$EditSection$view(
					A2($author$project$Components$SettingsPage$DebtorLayout$invoiceTemplateConfig, debtorId, data.invoiceTemplates)),
				formState.invoiceTemplate),
				$author$project$Components$SettingsPage$DebtorLayout$rateConfirmationView(
				{accountSettings: data.accountSettings, rateConfirmationRequiredForm: formState.rateConfirmationRequired}),
				A3(
				$author$project$Components$SettingsPage$DebtorLayout$when,
				data.accountSettings.verificationsWorkflowEnabled,
				$author$project$Components$SettingsPage$DebtorLayout$verificationRulesView,
				{excludeFromVerificationsWorkflowForm: formState.excludeFromVerificationsWorkflow, requireVerificationsWorkflowForm: formState.requireVerificationsWorkflow}),
				A3($author$project$Components$SettingsPage$DebtorLayout$when, data.accountSettings.factorBrokerLoadIdRegressionRuleMode === 'on', $author$project$Components$SettingsPage$DebtorLayout$loadIdRegressionRulesView, formState.factorBrokerLoadIdRegressionRuleMode),
				$author$project$Components$SettingsPage$Shared$EditSection$view(
				$author$project$Components$SettingsPage$DebtorLayout$warnIfAmountOverConfig(debtorId))(formState.warnIfAmountOver),
				A3(
				$author$project$Components$SettingsPage$DebtorLayout$when,
				!_Utils_eq(data.accountSettings.annotationAutoStampDocumentType, $elm$core$Maybe$Nothing),
				$author$project$Components$SettingsPage$DebtorLayout$skipAutoStampView,
				formState.skipAutoStamp),
				A3($author$project$Components$SettingsPage$DebtorLayout$when, data.accountSettings.factorNextGenAuditEnabled, $author$project$Components$SettingsPage$DebtorLayout$allowAutoprocessingView, formState.allowAutoprocessing),
				A3(
				$author$project$Components$SettingsPage$DebtorLayout$when,
				data.accountSettings.factorNextGenAuditEnabled,
				A2($author$project$Components$SettingsPage$DebtorLayout$loadIdAutoReleaseView, tz, data.debtorSettings.loadIdAutoRelease),
				formState.loadIdAutoRelease),
				A2($author$project$Components$SettingsPage$DebtorLayout$loadIdStrategiesView, data.accountSettings.loadIdStrategies, formState.loadIdStrategies)
			]);
	});
var $author$project$Components$SettingsPage$DebtorLayout$settingsFrameView = F2(
	function (v3ReskinEnabled, data) {
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Debtors, data.currentAccount, data.accountSettings, data.currentUser);
	});
var $author$project$Components$SettingsPage$DebtorLayout$GoBack = {$: 'GoBack'};
var $author$project$Components$SettingsPage$DebtorLayout$titleView = function (name) {
	return A2(
		$elm$html$Html$h1,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$Helpers$GenericLink$genericLink,
				$author$project$Components$SettingsPage$DebtorLayout$GoBack,
				_List_Nil,
				'#',
				_List_fromArray(
					[
						$elm$html$Html$text('« ')
					])),
				$elm$html$Html$text(name)
			]));
};
var $author$project$Components$SettingsPage$DebtorLayout$authorizedView = F4(
	function (v3ReskinEnabled, tz, model, data) {
		var formState = A2($author$project$Components$SettingsPage$DebtorLayout$mergeFormData, data, model);
		return A3(
			$author$project$Components$SettingsPage$DebtorLayout$settingsFrameView,
			v3ReskinEnabled,
			data,
			$author$project$Components$SettingsPage$DebtorLayout$row1(
				A2(
					$author$project$Components$Shared$Grid$column,
					12,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Shared$Grid$column,
							10,
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$DebtorLayout$row1(
									$author$project$Components$SettingsPage$DebtorLayout$titleView(data.debtorSettings.name)),
									A2(
									$author$project$Components$Shared$Grid$column,
									6,
									A2(
										$elm$core$List$map,
										$author$project$Components$SettingsPage$DebtorLayout$row1,
										A4($author$project$Components$SettingsPage$DebtorLayout$sections, tz, model.debtorId, data, formState)))
								]))
						]))));
	});
var $author$project$Components$SettingsPage$DebtorLayout$view = F4(
	function (v3ReskinEnabled, tz, model, data) {
		return data.currentUser.hasSettingsRole ? A4($author$project$Components$SettingsPage$DebtorLayout$authorizedView, v3ReskinEnabled, tz, model, data) : A3(
			$author$project$Components$SettingsPage$DebtorLayout$settingsFrameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.'));
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$Cancel = {$: 'Cancel'};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$ReorderTmsReferenceFieldLabel = F2(
	function (a, b) {
		return {$: 'ReorderTmsReferenceFieldLabel', a: a, b: b};
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$Save = {$: 'Save'};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$SelectTmsReferenceFieldLabel = function (a) {
	return {$: 'SelectTmsReferenceFieldLabel', a: a};
};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$UnselectTmsReferenceFieldLabel = function (a) {
	return {$: 'UnselectTmsReferenceFieldLabel', a: a};
};
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$frameView = function (_v0) {
	var currentUser = _v0.currentUser;
	var accountSettings = _v0.accountSettings;
	var account = _v0.account;
	return A5($author$project$Components$SettingsPage$Shared$Section$frameView, true, $author$project$Components$SettingsPage$Shared$Section$ReferenceFields, account, accountSettings, currentUser);
};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$LoadedAvailableFields = {$: 'LoadedAvailableFields'};
var $author$project$Ui$V3$Stack$PaddingHorz = function (a) {
	return {$: 'PaddingHorz', a: a};
};
var $author$project$Ui$V3$Stack$paddingHorz = function (h) {
	return $author$project$Ui$V3$Stack$PaddingAttribute(
		$author$project$Ui$V3$Stack$PaddingHorz(h));
};
var $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$viewV3Reskin = F4(
	function (events, selectedFields, allFieldsSet, state) {
		if ($elm$core$Set$isEmpty(allFieldsSet) || events.reorderDisabled) {
			return $elm$core$Maybe$Nothing;
		} else {
			var editButtonsContainerHeightPx = 72;
			var fieldsContainerHeightPx = function () {
				var _v1 = state.fieldsContainer;
				if (_v1.$ === 'Just') {
					var element = _v1.a.element;
					var viewport = _v1.a.viewport;
					return $elm$core$Basics$round((viewport.height - element.y) - editButtonsContainerHeightPx);
				} else {
					return -1;
				}
			}();
			var selectedFieldsView = $elm$core$List$isEmpty(selectedFields) ? A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('All fields will be shown.')
					])) : A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Selected fields (drag to reorder)')
							])),
						A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
								A2(
								$author$project$Ui$V3$Stack$style,
								'height',
								$author$project$Ui$V3$Helpers$Html$px(fieldsContainerHeightPx)),
								A2($author$project$Ui$V3$Stack$style, 'overflow-y', 'auto'),
								$author$project$Ui$V3$Stack$paddingBottom($author$project$Ui$V3$Stack$spaceXSmall)
							]),
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, field) {
									var dragSpecificAttribute = function () {
										var _v0 = state.subject;
										if (_v0.$ === 'Nothing') {
											return $elm$html$Html$Attributes$class('');
										} else {
											var subject = _v0.a;
											return _Utils_eq(subject, field) ? $elm$html$Html$Attributes$class('reference-fields__ui--subject') : A2(
												function ($) {
													return $.enter;
												},
												$author$project$Drag$on,
												A2(events.reorder, index, subject));
										}
									}();
									return A3(
										$author$project$Experimental$OnLoad$keyedNode,
										field,
										events.internal($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$LoadedSelectedFields),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$title(field),
														A2($elm$html$Html$Attributes$attribute, 'data-drag', $author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$dragContext),
														$elm$html$Html$Attributes$class('reference-fields__ui--reorderable'),
														A2(
														function ($) {
															return $.start;
														},
														$author$project$Drag$on,
														events.internal(
															$author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$DragStart(field))),
														A2(
														function ($) {
															return $.end;
														},
														$author$project$Drag$on,
														events.internal($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$DragStop)),
														dragSpecificAttribute
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$V3$Stack$viewHorzWithWidths,
														_List_fromArray(
															[
																$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
																$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
																$author$project$Ui$V3$Stack$paddingHorz($author$project$Ui$V3$Stack$spaceXXSmall),
																$author$project$Ui$V3$Stack$crossAxisCenter,
																A2(
																$author$project$Ui$V3$Stack$style,
																'color',
																$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray200)),
																A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px'),
																A2($author$project$Ui$V3$Stack$style, 'height', '40px'),
																A2($author$project$Ui$V3$Stack$style, 'cursor', 'grab')
															]),
														_List_fromArray(
															[
																_Utils_Tuple2(
																$author$project$Ui$V3$Stack$fit,
																A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$menu16)),
																_Utils_Tuple2(
																$author$project$Ui$V3$Stack$flex1,
																A2(
																	$elm$html$Html$h5,
																	_List_fromArray(
																		[
																			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Teal600)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(field)
																		]))),
																_Utils_Tuple2(
																$author$project$Ui$V3$Stack$fit,
																A2(
																	$author$project$Ui$V3$UtilityButton$view,
																	{
																		icon: $author$project$Ui$V3$Icon$removeCircle16,
																		label: 'Remove',
																		onClick: events.unselect(field)
																	},
																	_List_fromArray(
																		[$author$project$Ui$V3$UtilityButton$sizeSmall])))
															]))
													]))
											]));
								}),
							selectedFields))
					]));
			var availableFields = A2(
				$elm$core$List$sortBy,
				$elm$core$String$toLower,
				$elm$core$Set$toList(
					A2(
						$elm$core$Set$diff,
						allFieldsSet,
						$elm$core$Set$fromList(selectedFields))));
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$V3$Stack$viewHorz,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Stack$viewVert,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Available fields')
												])),
											A2(
											$author$project$Ui$V3$Stack$viewVert,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
													$author$project$Ui$V3$Stack$htmlAttribute(
													$elm$html$Html$Attributes$id($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$fieldsContainerId)),
													A2(
													$author$project$Ui$V3$Stack$style,
													'height',
													$author$project$Ui$V3$Helpers$Html$px(fieldsContainerHeightPx)),
													A2($author$project$Ui$V3$Stack$style, 'overflow-y', 'auto'),
													$author$project$Ui$V3$Stack$paddingBottom($author$project$Ui$V3$Stack$spaceXSmall)
												]),
											A2(
												$elm$core$List$map,
												function (field) {
													return A2(
														$author$project$Ui$V3$Stack$viewHorzWithWidths,
														_List_fromArray(
															[
																$author$project$Ui$V3$Stack$backgroundColorOnHover($author$project$Ui$V3$Colors$Gray0),
																$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
																$author$project$Ui$V3$Stack$crossAxisCenter,
																$author$project$Ui$V3$Stack$paddingHorz($author$project$Ui$V3$Stack$spaceXXSmall),
																A2($author$project$Ui$V3$Stack$style, 'border-radius', '8px'),
																A2($author$project$Ui$V3$Stack$style, 'height', '32px'),
																A2(
																$author$project$Ui$V3$Stack$style,
																'color',
																$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal600)),
																A2($author$project$Ui$V3$Stack$style, 'cursor', 'pointer'),
																$author$project$Ui$V3$Stack$onClick(
																events.select(field))
															]),
														_List_fromArray(
															[
																_Utils_Tuple2(
																$author$project$Ui$V3$Stack$fit,
																A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$add16)),
																_Utils_Tuple2(
																$author$project$Ui$V3$Stack$flex1,
																A2(
																	$elm$html$Html$h5,
																	_List_fromArray(
																		[
																			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Teal600)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(field)
																		])))
															]));
												},
												availableFields))
										])),
									selectedFieldsView
								])),
							A2(
							$author$project$Ui$V3$Stack$viewHorz,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Stack$style,
									'height',
									$author$project$Ui$V3$Helpers$Html$px(editButtonsContainerHeightPx)),
									A2($author$project$Ui$V3$Stack$style, 'border-top', '1px solid var(--color-gray-200)'),
									A2($author$project$Ui$V3$Stack$style, 'position', 'fixed'),
									A2($author$project$Ui$V3$Stack$style, 'bottom', '0'),
									A2($author$project$Ui$V3$Stack$style, 'width', '100%')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Stack$viewHorz,
									_List_fromArray(
										[
											$author$project$Ui$V3$Stack$paddingHorz($author$project$Ui$V3$Stack$spaceXXLarge),
											$author$project$Ui$V3$Stack$crossAxisCenter,
											A2(
											$author$project$Ui$V3$Stack$style,
											'height',
											$author$project$Ui$V3$Helpers$Html$px(editButtonsContainerHeightPx)),
											A2($author$project$Ui$V3$Stack$style, 'position', 'fixed'),
											A2($author$project$Ui$V3$Stack$style, 'bottom', '0'),
											A2($author$project$Ui$V3$Stack$style, 'right', '0')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$V3$Stack$viewHorzWithWidths,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
													$author$project$Ui$V3$Stack$mainAxisEnd
												]),
											_List_fromArray(
												[
													_Utils_Tuple2(
													$author$project$Ui$V3$Stack$fit,
													A3(
														$author$project$Ui$V3$Button$view,
														{
															action: $author$project$Ui$V3$Button$onClick(events.cancel)
														},
														_List_fromArray(
															[
																$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
																$author$project$Ui$V3$Button$disabled(events.editButtonsDisabled)
															]),
														'Cancel')),
													_Utils_Tuple2(
													$author$project$Ui$V3$Stack$fit,
													A3(
														$author$project$Ui$V3$Button$view,
														{
															action: $author$project$Ui$V3$Button$onClick(events.save)
														},
														_List_fromArray(
															[
																$author$project$Ui$V3$Button$disabled(events.editButtonsDisabled)
															]),
														'Save'))
												]))
										]))
								])),
							A3(
							$author$project$Experimental$OnLoad$keyedNode,
							'availableFields',
							events.internal($author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$LoadedAvailableFields),
							_List_Nil)
						])));
		}
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$authorizedView = F2(
	function (model, data) {
		var loadedModel = A2($author$project$Components$SettingsPage$ReferenceFieldsLayout$loadedModelFromData, data, model);
		return A2(
			$author$project$Components$SettingsPage$ReferenceFieldsLayout$frameView,
			data,
			$author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Stack$viewVertMaybes,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
						]),
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Reference fields')
									]))),
							A4(
							$author$project$Components$SettingsPage$Account$TmsReferenceFieldsView$viewV3Reskin,
							{
								cancel: $author$project$Components$SettingsPage$ReferenceFieldsLayout$Cancel,
								editButtonsDisabled: _Utils_eq(loadedModel.visibleTmsReferenceFieldLabels, loadedModel.origVisibleTmsReferenceFieldLabels) || loadedModel.isSaving,
								internal: $author$project$Components$SettingsPage$ReferenceFieldsLayout$TmsReferenceFieldsMsg,
								reorder: $author$project$Components$SettingsPage$ReferenceFieldsLayout$ReorderTmsReferenceFieldLabel,
								reorderDisabled: data.accountSettings.disableReorderTMSReferenceFields,
								save: $author$project$Components$SettingsPage$ReferenceFieldsLayout$Save,
								select: $author$project$Components$SettingsPage$ReferenceFieldsLayout$SelectTmsReferenceFieldLabel,
								unselect: $author$project$Components$SettingsPage$ReferenceFieldsLayout$UnselectTmsReferenceFieldLabel
							},
							loadedModel.visibleTmsReferenceFieldLabels,
							data.allReferenceFieldLabels,
							loadedModel.tmsReferenceFieldsState)
						]))));
	});
var $author$project$Components$SettingsPage$ReferenceFieldsLayout$view = F2(
	function (model, data) {
		return data.currentUser.hasSettingsRole ? A2($author$project$Components$SettingsPage$ReferenceFieldsLayout$authorizedView, model, data) : A2(
			$author$project$Components$SettingsPage$ReferenceFieldsLayout$frameView,
			data,
			$elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.'));
	});
var $author$project$Components$SettingsPage$ReportsLayout$frameView = F2(
	function (v3ReskinEnabled, _v0) {
		var currentUser = _v0.currentUser;
		var accountSettings = _v0.accountSettings;
		var account = _v0.account;
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Reports, account, accountSettings, currentUser);
	});
var $author$project$Components$SettingsPage$Reports$ReportView$DownloadFile = function (a) {
	return {$: 'DownloadFile', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg = function (a) {
	return {$: 'LoadedMsg', a: a};
};
var $author$project$Domain$Duration$OneMonth = {$: 'OneMonth'};
var $author$project$Domain$Duration$OneWeek = {$: 'OneWeek'};
var $author$project$Components$SettingsPage$ReportsLayout$SendReport = function (a) {
	return {$: 'SendReport', a: a};
};
var $author$project$Domain$Duration$ThreeMonths = {$: 'ThreeMonths'};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateAutoNidfBatchesReport = function (a) {
	return {$: 'UpdateAutoNidfBatchesReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateCarrierInvoicingBillingDetailsReport = function (a) {
	return {$: 'UpdateCarrierInvoicingBillingDetailsReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateCarrierScorecardReport = function (a) {
	return {$: 'UpdateCarrierScorecardReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateCustomerInvoicesSentReport = function (a) {
	return {$: 'UpdateCustomerInvoicesSentReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateDocumentRetrievalBillingDetailsReport = function (a) {
	return {$: 'UpdateDocumentRetrievalBillingDetailsReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateEmailActivityReport = function (a) {
	return {$: 'UpdateEmailActivityReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateFactorInvoicingBillingDetailsReport = function (a) {
	return {$: 'UpdateFactorInvoicingBillingDetailsReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateIndexerScorecardReport = function (a) {
	return {$: 'UpdateIndexerScorecardReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateIndexingActivityReport = function (a) {
	return {$: 'UpdateIndexingActivityReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateLoadsRequiringActionReport = function (a) {
	return {$: 'UpdateLoadsRequiringActionReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateLtlLoadsReport = function (a) {
	return {$: 'UpdateLtlLoadsReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateMissingPodReport = function (a) {
	return {$: 'UpdateMissingPodReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateProcessorScorecardReport = function (a) {
	return {$: 'UpdateProcessorScorecardReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateUserActivityReport = function (a) {
	return {$: 'UpdateUserActivityReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateVerificationsReport = function (a) {
	return {$: 'UpdateVerificationsReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateVerificationsWorkflowReport = function (a) {
	return {$: 'UpdateVerificationsWorkflowReport', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$UpdateVerifierScorecardReport = function (a) {
	return {$: 'UpdateVerifierScorecardReport', a: a};
};
var $author$project$Api$Reports$Report$AllPayablesExceptionsReport = {$: 'AllPayablesExceptionsReport'};
var $author$project$Api$Reports$allPayablesExceptionsReport = $author$project$Api$Reports$Report$AllPayablesExceptionsReport;
var $author$project$Api$Reports$Report$AuditorScorecardReport = function (a) {
	return {$: 'AuditorScorecardReport', a: a};
};
var $author$project$Api$Reports$auditorScorecardReport = $author$project$Api$Reports$Report$AuditorScorecardReport;
var $author$project$Api$Reports$Report$AutoNidfBatchesReport = function (a) {
	return {$: 'AutoNidfBatchesReport', a: a};
};
var $author$project$Api$Reports$autoNidfBatchesReport = $author$project$Api$Reports$Report$AutoNidfBatchesReport;
var $author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports = F2(
	function (accountSettings, user) {
		return user.isAdmin || (!accountSettings.limitReportsToAdmin);
	});
var $author$project$Api$Reports$Report$CarrierInvoicingBillingDetailsReport = function (a) {
	return {$: 'CarrierInvoicingBillingDetailsReport', a: a};
};
var $author$project$Api$Reports$carrierInvoicingBillingDetailsReport = $author$project$Api$Reports$Report$CarrierInvoicingBillingDetailsReport;
var $author$project$Api$Reports$Report$CarrierScorecardReport = function (a) {
	return {$: 'CarrierScorecardReport', a: a};
};
var $author$project$Api$Reports$carrierScorecardReport = $author$project$Api$Reports$Report$CarrierScorecardReport;
var $author$project$Api$Reports$Report$CustomerInvoiceDeliveryMethodReport = {$: 'CustomerInvoiceDeliveryMethodReport'};
var $author$project$Api$Reports$customerInvoiceDeliveryMethodReport = $author$project$Api$Reports$Report$CustomerInvoiceDeliveryMethodReport;
var $author$project$Api$Reports$Report$CustomerInvoicesSentReport = function (a) {
	return {$: 'CustomerInvoicesSentReport', a: a};
};
var $author$project$Api$Reports$customerInvoicesSentReport = $author$project$Api$Reports$Report$CustomerInvoicesSentReport;
var $author$project$Api$Reports$Report$CustomerRulesReport = {$: 'CustomerRulesReport'};
var $author$project$Api$Reports$customerRulesReport = $author$project$Api$Reports$Report$CustomerRulesReport;
var $author$project$Api$Reports$Report$DocumentRetrievalBillingDetailsReport = function (a) {
	return {$: 'DocumentRetrievalBillingDetailsReport', a: a};
};
var $author$project$Api$Reports$documentRetrievalBillingDetailsReport = $author$project$Api$Reports$Report$DocumentRetrievalBillingDetailsReport;
var $author$project$Api$Reports$Report$DocumentScraperStatusReport = {$: 'DocumentScraperStatusReport'};
var $author$project$Api$Reports$documentScraperStatusReport = $author$project$Api$Reports$Report$DocumentScraperStatusReport;
var $author$project$Api$Reports$Report$EmailActivityReport = function (a) {
	return {$: 'EmailActivityReport', a: a};
};
var $author$project$Api$Reports$emailActivityReport = $author$project$Api$Reports$Report$EmailActivityReport;
var $author$project$Components$SettingsPage$Reports$ReportView$EmailFile = function (a) {
	return {$: 'EmailFile', a: a};
};
var $author$project$Components$SettingsPage$ReportsLayout$emailDelivery = function (apiCall) {
	return $author$project$Components$SettingsPage$Reports$ReportView$EmailFile(
		A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$SendReport, apiCall));
};
var $author$project$Api$Reports$Report$FactorInvoicingBillingDetailsReport = function (a) {
	return {$: 'FactorInvoicingBillingDetailsReport', a: a};
};
var $author$project$Api$Reports$factorInvoicingBillingDetailsReport = $author$project$Api$Reports$Report$FactorInvoicingBillingDetailsReport;
var $author$project$Api$Reports$Report$IndexerScorecardReport = function (a) {
	return {$: 'IndexerScorecardReport', a: a};
};
var $author$project$Api$Reports$indexerScorecardReport = $author$project$Api$Reports$Report$IndexerScorecardReport;
var $author$project$Api$Reports$Report$IndexingActivityReport = function (a) {
	return {$: 'IndexingActivityReport', a: a};
};
var $author$project$Api$Reports$indexingActivityReport = $author$project$Api$Reports$Report$IndexingActivityReport;
var $author$project$Api$Reports$Report$InvoiceExceptionReport = {$: 'InvoiceExceptionReport'};
var $author$project$Api$Reports$invoiceExceptionReport = $author$project$Api$Reports$Report$InvoiceExceptionReport;
var $author$project$Api$Reports$Report$LoadsRequiringActionReport = function (a) {
	return {$: 'LoadsRequiringActionReport', a: a};
};
var $author$project$Api$Reports$loadsRequiringActionReport = $author$project$Api$Reports$Report$LoadsRequiringActionReport;
var $author$project$Api$Reports$Report$LtlLoadsReport = function (a) {
	return {$: 'LtlLoadsReport', a: a};
};
var $author$project$Api$Reports$ltlLoadsReport = $author$project$Api$Reports$Report$LtlLoadsReport;
var $author$project$Components$SettingsPage$ReportsLayout$ltlLoadsReportIsViewable = function (accountSettings) {
	return accountSettings.ltlReconcileEnabled || accountSettings.ltlLoadsReportEnabled;
};
var $author$project$Api$Reports$Report$NewQueueSnapshotReport = {$: 'NewQueueSnapshotReport'};
var $author$project$Api$Reports$newQueueSnapshotReport = $author$project$Api$Reports$Report$NewQueueSnapshotReport;
var $author$project$Api$Reports$Report$ProcessorScorecardReport = function (a) {
	return {$: 'ProcessorScorecardReport', a: a};
};
var $author$project$Api$Reports$processorScorecardReport = $author$project$Api$Reports$Report$ProcessorScorecardReport;
var $author$project$Api$Reports$Report$RtaSnapshotReport = {$: 'RtaSnapshotReport'};
var $author$project$Api$Reports$rtaSnapshotReport = $author$project$Api$Reports$Report$RtaSnapshotReport;
var $author$project$Ui$FormData = F2(
	function (name, value) {
		return {name: name, value: value};
	});
var $author$project$Components$SettingsPage$Reports$ReportView$downloadFileLabel = 'Download File';
var $author$project$Ui$hiddenInput = function (formData) {
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('hidden'),
				$elm$html$Html$Attributes$name(formData.name),
				$elm$html$Html$Attributes$value(formData.value)
			]),
		_List_Nil);
};
var $author$project$Ui$post = F3(
	function (path, formData, child) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$action(path),
						$elm$html$Html$Attributes$method('post')
					]),
				_Utils_ap(
					A2($elm$core$List$map, $author$project$Ui$hiddenInput, formData),
					_List_fromArray(
						[
							$author$project$Ui$toHtml(child)
						]))));
	});
var $author$project$Ui$primarySubmit = function (label) {
	return $author$project$Ui$Ui(
		A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hubtran-button__primary')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])));
};
var $author$project$Components$SettingsPage$ReportsLayout$simpleDownloadReportView = F2(
	function (title, reportType) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between3]),
			_List_fromArray(
				[
					$author$project$Ui$heading3(title),
					A2(
					$author$project$Ui$inline,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$post,
							'/reports',
							_List_fromArray(
								[
									A2($author$project$Ui$FormData, 'type', reportType)
								]),
							$author$project$Ui$primarySubmit($author$project$Components$SettingsPage$Reports$ReportView$downloadFileLabel))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Reports$ReportView$emailFileLabel = 'Email File';
var $author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView = F2(
	function (title, onClick) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between3]),
			_List_fromArray(
				[
					$author$project$Ui$heading3(title),
					A2(
					$author$project$Ui$inline,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$primary, $author$project$Components$SettingsPage$Reports$ReportView$emailFileLabel, onClick)
						]))
				]));
	});
var $author$project$Api$Reports$Report$UnbilledInvoicesReport = {$: 'UnbilledInvoicesReport'};
var $author$project$Api$Reports$unbilledInvoicesReport = $author$project$Api$Reports$Report$UnbilledInvoicesReport;
var $author$project$Api$Reports$Report$UserActivityReport = function (a) {
	return {$: 'UserActivityReport', a: a};
};
var $author$project$Api$Reports$userActivityReport = $author$project$Api$Reports$Report$UserActivityReport;
var $author$project$Api$Reports$Report$VerificationsReport = function (a) {
	return {$: 'VerificationsReport', a: a};
};
var $author$project$Api$Reports$verificationsReport = $author$project$Api$Reports$Report$VerificationsReport;
var $author$project$Api$Reports$Report$VerificationsWorkflowReport = function (a) {
	return {$: 'VerificationsWorkflowReport', a: a};
};
var $author$project$Api$Reports$verificationsWorkflowReport = $author$project$Api$Reports$Report$VerificationsWorkflowReport;
var $author$project$Api$Reports$Report$VerifierScorecardReport = function (a) {
	return {$: 'VerifierScorecardReport', a: a};
};
var $author$project$Api$Reports$verifierScorecardReport = $author$project$Api$Reports$Report$VerifierScorecardReport;
var $author$project$Components$SettingsPage$Reports$ReportView$NoOp = {$: 'NoOp'};
var $author$project$Components$SettingsPage$Reports$ReportView$UpdateEndDate = function (a) {
	return {$: 'UpdateEndDate', a: a};
};
var $author$project$Components$SettingsPage$Reports$ReportView$UpdateStartDate = function (a) {
	return {$: 'UpdateStartDate', a: a};
};
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Helpers$Date$ascendingOrder = F2(
	function (date1, date2) {
		return !_Utils_eq(
			A2($justinmimbs$date$Date$compare, date1, date2),
			$elm$core$Basics$GT);
	});
var $author$project$Components$SettingsPage$Reports$ReportView$ascendingOrderOnlyDate = F2(
	function (date1, date2) {
		return A2($author$project$Helpers$Date$ascendingOrder, date1, date2);
	});
var $author$project$Components$SettingsPage$Reports$ReportView$dateCheck = F2(
	function (f, model) {
		return A3(
			$elm$core$Result$map2,
			f,
			A2($elm$core$Result$fromMaybe, 'Start Date Is Required', model.startDate),
			A2($elm$core$Result$fromMaybe, 'End Date Is Required', model.endDate));
	});
var $author$project$Helpers$Bool$ternary = F3(
	function (trueValue, falseValue, bool) {
		return bool ? trueValue : falseValue;
	});
var $author$project$Domain$Duration$toString = function (duration) {
	switch (duration.$) {
		case 'OneWeek':
			return 'One Week';
		case 'OneMonth':
			return 'One Month';
		default:
			return 'Three Months';
	}
};
var $author$project$Helpers$Date$inGivenRange = F3(
	function (start, date, duration) {
		var end = A3(
			$justinmimbs$date$Date$add,
			$justinmimbs$date$Date$Days,
			$elm$core$Basics$floor(
				$ianmackenzie$elm_units$Duration$inDays(duration)),
			start);
		return !_Utils_eq(
			A2($justinmimbs$date$Date$compare, date, end),
			$elm$core$Basics$GT);
	});
var $author$project$Domain$Duration$toGenericDuration = function (duration) {
	switch (duration.$) {
		case 'OneWeek':
			return $ianmackenzie$elm_units$Duration$days(7);
		case 'OneMonth':
			return $ianmackenzie$elm_units$Duration$days(30);
		default:
			return $ianmackenzie$elm_units$Duration$days(92);
	}
};
var $author$project$Components$SettingsPage$Reports$ReportView$withinTimeLimit = F3(
	function (duration, date1, date2) {
		return A3(
			$author$project$Helpers$Date$inGivenRange,
			date1,
			date2,
			$author$project$Domain$Duration$toGenericDuration(duration));
	});
var $author$project$Components$SettingsPage$Reports$ReportView$buttonLabel = F3(
	function (duration, okLabel, model) {
		var ascendingCheck = A2(
			$elm$core$Result$andThen,
			A2(
				$author$project$Helpers$Bool$ternary,
				$elm$core$Result$Ok(okLabel),
				$elm$core$Result$Err('Start Date Must Be Before End Date')),
			A2($author$project$Components$SettingsPage$Reports$ReportView$dateCheck, $author$project$Components$SettingsPage$Reports$ReportView$ascendingOrderOnlyDate, model));
		if (ascendingCheck.$ === 'Ok') {
			var okLabel_ = ascendingCheck.a;
			return A2(
				$elm$core$Result$andThen,
				A2(
					$author$project$Helpers$Bool$ternary,
					$elm$core$Result$Ok(okLabel_),
					$elm$core$Result$Err(
						'Date Range Must Be Within ' + $author$project$Domain$Duration$toString(duration))),
				A2(
					$author$project$Components$SettingsPage$Reports$ReportView$dateCheck,
					$author$project$Components$SettingsPage$Reports$ReportView$withinTimeLimit(duration),
					model));
		} else {
			var err = ascendingCheck.a;
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Ui$disableablePrimarySubmit = function (labelResult) {
	if (labelResult.$ === 'Ok') {
		var label = labelResult.a;
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-button__primary')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])));
	} else {
		var label = labelResult.a;
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-button__neutral'),
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])));
	}
};
var $author$project$Components$SettingsPage$Reports$ReportView$downloadButton = F3(
	function (duration, reportType, model) {
		return A3(
			$author$project$Ui$post,
			'/reports',
			_List_fromArray(
				[
					A2($author$project$Ui$FormData, 'type', reportType),
					A2(
					$author$project$Ui$FormData,
					'start_date',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, model.startDate))),
					A2(
					$author$project$Ui$FormData,
					'end_date',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, model.endDate)))
				]),
			$author$project$Ui$disableablePrimarySubmit(
				A3($author$project$Components$SettingsPage$Reports$ReportView$buttonLabel, duration, $author$project$Components$SettingsPage$Reports$ReportView$downloadFileLabel, model)));
	});
var $author$project$Api$Reports$dateRange = F2(
	function (startDate, endDate) {
		return {endDate: endDate, startDate: startDate};
	});
var $author$project$Components$SettingsPage$Reports$ReportView$buttonMsg = F3(
	function (onClick, config, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			config.mapMsg($author$project$Components$SettingsPage$Reports$ReportView$NoOp),
			A2(
				$elm$core$Maybe$map,
				onClick,
				A3($elm$core$Maybe$map2, $author$project$Api$Reports$dateRange, model.startDate, model.endDate)));
	});
var $author$project$Components$SettingsPage$Reports$ReportView$emailButton = F3(
	function (onClick, config, model) {
		return A2(
			$author$project$Ui$disableablePrimary,
			A3($author$project$Components$SettingsPage$Reports$ReportView$buttonLabel, config.duration, $author$project$Components$SettingsPage$Reports$ReportView$emailFileLabel, model),
			A3($author$project$Components$SettingsPage$Reports$ReportView$buttonMsg, onClick, config, model));
	});
var $author$project$Components$SettingsPage$Reports$ReportView$button = F2(
	function (config, model) {
		var _v0 = config.deliveryMethod;
		if (_v0.$ === 'EmailFile') {
			var onClick = _v0.a;
			return A3($author$project$Components$SettingsPage$Reports$ReportView$emailButton, onClick, config, model);
		} else {
			var reportType = _v0.a;
			return A3($author$project$Components$SettingsPage$Reports$ReportView$downloadButton, config.duration, reportType, model);
		}
	});
var $author$project$Ui$dateInput = function (config) {
	var inputClass = $author$project$Ui$hasError(config.feedback) ? 'hubtran-input__date--error' : 'hubtran-input__date';
	var attributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$class(inputClass),
			$elm$html$Html$Attributes$type_('date'),
			$elm$html$Html$Attributes$value(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, config.value))),
			$elm$html$Html$Events$onInput(
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, config.onChange, $elm$core$Result$toMaybe),
				$justinmimbs$date$Date$fromIsoString)),
			$elm$html$Html$Events$onBlur(config.onBlur)
		]);
	return A2(
		$author$project$Ui$keyedStack,
		_List_fromArray(
			[$author$project$Ui$between1]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$author$project$Ui$Ui(
					A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-input__label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.label)
							])))),
				_Utils_Tuple2(
				'feedback',
				$author$project$Ui$feedbackView(config.feedback)),
				_Utils_Tuple2(
				'input',
				$author$project$Ui$Ui(
					A2($elm$html$Html$input, attributes, _List_Nil)))
			]));
};
var $justinmimbs$date$Date$fromOrdinalDate = F2(
	function (y, od) {
		var daysInY = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return $justinmimbs$date$Date$RD(
			$justinmimbs$date$Date$daysBeforeYear(y) + A3($elm$core$Basics$clamp, 1, daysInY, od));
	});
var $author$project$Ui$V3$Helpers$Html$percySpecific = function (_v0) {
	var _default = _v0._default;
	var percy = _v0.percy;
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('percy-exclusive')
					]),
				_List_fromArray(
					[percy])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('percy-hidden')
					]),
				_List_fromArray(
					[_default]))
			]));
};
var $author$project$Ui$V3$Helpers$Html$percyFriendlyDate = F2(
	function (date, toHtml) {
		return $author$project$Ui$V3$Helpers$Html$percySpecific(
			{
				_default: toHtml(date),
				percy: toHtml(
					A2($justinmimbs$date$Date$fromOrdinalDate, 2024, 1))
			});
	});
var $author$project$Ui$percyFriendlyDateInput = function (config) {
	var _v0 = config.value;
	if (_v0.$ === 'Just') {
		var value = _v0.a;
		return $author$project$Ui$Ui(
			A2(
				$author$project$Ui$V3$Helpers$Html$percyFriendlyDate,
				value,
				function (date) {
					return $author$project$Ui$toHtml(
						$author$project$Ui$dateInput(
							_Utils_update(
								config,
								{
									value: $elm$core$Maybe$Just(date)
								})));
				}));
	} else {
		return $author$project$Ui$dateInput(config);
	}
};
var $author$project$Components$SettingsPage$Reports$ReportView$view = F2(
	function (config, model) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					$author$project$Ui$heading3(config.title),
					A2(
					$author$project$Ui$stack,
					_List_fromArray(
						[$author$project$Ui$between3]),
					_List_fromArray(
						[
							$author$project$Ui$equalWidths(
							_List_fromArray(
								[
									A2(
									$author$project$Ui$stack,
									_List_fromArray(
										[$author$project$Ui$between3]),
									_List_fromArray(
										[
											$author$project$Ui$percyFriendlyDateInput(
											{
												feedback: $elm$core$Maybe$Nothing,
												label: 'Start Date',
												onBlur: config.mapMsg($author$project$Components$SettingsPage$Reports$ReportView$NoOp),
												onChange: A2($elm$core$Basics$composeL, config.mapMsg, $author$project$Components$SettingsPage$Reports$ReportView$UpdateStartDate),
												value: model.startDate
											}),
											$author$project$Ui$percyFriendlyDateInput(
											{
												feedback: $elm$core$Maybe$Nothing,
												label: 'End Date',
												onBlur: config.mapMsg($author$project$Components$SettingsPage$Reports$ReportView$NoOp),
												onChange: A2($elm$core$Basics$composeL, config.mapMsg, $author$project$Components$SettingsPage$Reports$ReportView$UpdateEndDate),
												value: model.endDate
											})
										])),
									$author$project$Ui$spacer,
									$author$project$Ui$spacer,
									$author$project$Ui$spacer,
									$author$project$Ui$spacer
								])),
							A2(
							$author$project$Ui$inline,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$SettingsPage$Reports$ReportView$button, config, model)
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$ReportsLayout$visibleReports = F2(
	function (loadedModel, data) {
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$first,
				_List_fromArray(
					[
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$userActivityReport),
								duration: $author$project$Domain$Duration$OneMonth,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateUserActivityReport),
								title: 'User Activity Report'
							},
							loadedModel.userActivityReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && ((data.account.payablesAccount || data.account.factorAccount) && (!data.accountSettings.indexAuditSplitEnabled)),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$processorScorecardReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateProcessorScorecardReport),
								title: 'Processor Scorecard Report'
							},
							loadedModel.processorScorecardReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && (data.account.payablesAccount && data.accountSettings.indexAuditSplitEnabled),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$indexerScorecardReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateIndexerScorecardReport),
								title: 'Indexer Scorecard Report'
							},
							loadedModel.indexerScorecardReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && (data.account.payablesAccount && data.accountSettings.indexAuditSplitEnabled),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$indexingActivityReport),
								duration: $author$project$Domain$Duration$OneWeek,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateIndexingActivityReport),
								title: 'Indexing Activity Report'
							},
							loadedModel.indexingActivityReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && (data.account.payablesAccount && data.accountSettings.indexAuditSplitEnabled),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$auditorScorecardReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateIndexerScorecardReport),
								title: 'Auditor Scorecard Report'
							},
							loadedModel.indexerScorecardReport)),
						_Utils_Tuple2(
						data.accountSettings.verificationsEnabled,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$verificationsReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateVerificationsReport),
								title: 'Verifications Report'
							},
							loadedModel.verificationsReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && data.accountSettings.verificationsWorkflowEnabled,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$verificationsWorkflowReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateVerificationsWorkflowReport),
								title: 'Verifications Workflow Report'
							},
							loadedModel.verificationsWorkflowReport)),
						_Utils_Tuple2(
						data.accountSettings.verificationsEnabled,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$verifierScorecardReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateVerifierScorecardReport),
								title: 'Verifier Scorecard Report'
							},
							loadedModel.verifierScorecardReport)),
						_Utils_Tuple2(
						data.account.scraperAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$Reports$ReportView$DownloadFile('Missing POD Report'),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateMissingPodReport),
								title: 'Missing POD Report'
							},
							loadedModel.missingPodReport)),
						_Utils_Tuple2(
						data.account.scraperAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$documentRetrievalBillingDetailsReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateDocumentRetrievalBillingDetailsReport),
								title: 'Document Retrieval Billing Details Report'
							},
							loadedModel.documentRetrievalBillingDetailsReport)),
						_Utils_Tuple2(
						data.account.scraperAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView,
							'Document Retrieval Status Report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$documentScraperStatusReport))),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$carrierInvoicingBillingDetailsReport),
								duration: $author$project$Domain$Duration$OneMonth,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateCarrierInvoicingBillingDetailsReport),
								title: 'Carrier Invoicing Billing Detail Report'
							},
							loadedModel.carrierInvoicingBillingDetailsReport)),
						_Utils_Tuple2(
						data.account.factorAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$factorInvoicingBillingDetailsReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateFactorInvoicingBillingDetailsReport),
								title: 'Factor Invoicing Billing Detail Report'
							},
							loadedModel.factorInvoicingBillingDetailsReport)),
						_Utils_Tuple2(
						data.account.factorAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$carrierScorecardReport),
								duration: $author$project$Domain$Duration$OneWeek,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateCarrierScorecardReport),
								title: 'Carrier Scorecard Report'
							},
							loadedModel.carrierScorecardReport)),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$loadsRequiringActionReport),
								duration: $author$project$Domain$Duration$OneMonth,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateLoadsRequiringActionReport),
								title: 'Loads Missing Documents Report'
							},
							loadedModel.loadsRequiringActionReport)),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView,
							'Invoice Exception Report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$invoiceExceptionReport))),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView,
							'All Payables Exceptions Report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$allPayablesExceptionsReport))),
						_Utils_Tuple2(
						data.account.payablesAccount && data.accountSettings.auditBillingEnabled,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView,
							'Unbilled Invoices Report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$unbilledInvoicesReport))),
						_Utils_Tuple2(
						data.account.receivablesAccount,
						A2($author$project$Components$SettingsPage$ReportsLayout$simpleDownloadReportView, 'Customer Invoices Missing Documents Report', 'Customer Invoices Missing Documents Report')),
						_Utils_Tuple2(
						data.account.receivablesAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$customerInvoicesSentReport),
								duration: $author$project$Domain$Duration$OneMonth,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateCustomerInvoicesSentReport),
								title: 'Customer Invoices Sent Report'
							},
							loadedModel.customerInvoicesSentReport)),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView,
							'Customer Rules Report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$customerRulesReport))),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && data.account.receivablesAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView,
							'Customer Invoice Delivery Method Report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$customerInvoiceDeliveryMethodReport))),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser),
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView,
							'New Queue Snapshot Report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$newQueueSnapshotReport))),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && data.accountSettings.indexAuditSplitEnabled,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportView,
							'Ready To Audit Queue Snapshot Report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$rtaSnapshotReport))),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$emailActivityReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateEmailActivityReport),
								title: 'Email Activity Report'
							},
							loadedModel.emailActivityReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && data.accountSettings.autoIndexNidfDocumentsToLoad,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$autoNidfBatchesReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateAutoNidfBatchesReport),
								title: 'Auto-NIDF Batches Report'
							},
							loadedModel.autoNidfBatchesReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && $author$project$Components$SettingsPage$ReportsLayout$ltlLoadsReportIsViewable(data.accountSettings),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$view,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$ltlLoadsReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateLtlLoadsReport),
								title: 'LTL Loads Report'
							},
							loadedModel.ltlLoadsReport))
					])));
	});
var $author$project$Components$SettingsPage$ReportsLayout$simpleDownloadReportViewV3Reskin = F2(
	function (title, reportType) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$styleAsCard]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$action('/reports'),
							$elm$html$Html$Attributes$method('POST')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('hidden'),
									$elm$html$Html$Attributes$name('type'),
									$elm$html$Html$Attributes$value(reportType)
								]),
							_List_Nil),
							A2(
							$author$project$Ui$V3$Stack$viewHorzWithWidths,
							_List_Nil,
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$flex1,
									$elm$html$Html$text('')),
									_Utils_Tuple2(
									$author$project$Ui$V3$Stack$fit,
									A3(
										$author$project$Ui$V3$Button$view,
										{action: $author$project$Ui$V3$Button$submitForm},
										_List_fromArray(
											[
												$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
											]),
										$author$project$Components$SettingsPage$Reports$ReportView$downloadFileLabel))
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin = F2(
	function (title, onClick) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$styleAsCard]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							$elm$html$Html$text('')),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick(onClick)
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
									]),
								$author$project$Components$SettingsPage$Reports$ReportView$emailFileLabel))
						]))
				]));
	});
var $author$project$Components$SettingsPage$Reports$ReportView$buttonV3Reskin = F3(
	function (config, model, maybeErr) {
		var toBtn = F2(
			function (btnConfig, label) {
				return A2(
					$author$project$Ui$V3$Stack$viewVertMaybes,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (err) {
								return A2(
									$author$project$Ui$V3$Notification$viewInline,
									{
										message: $elm$html$Html$text(err),
										onClose: $elm$core$Maybe$Nothing,
										title: $elm$core$Maybe$Nothing
									},
									_List_fromArray(
										[$author$project$Ui$V3$Notification$error]));
							},
							maybeErr),
							$elm$core$Maybe$Just(
							A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_Nil,
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$flex1,
										$elm$html$Html$text('')),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A3(
											$author$project$Ui$V3$Button$view,
											btnConfig,
											_List_fromArray(
												[
													$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
													$author$project$Ui$V3$Button$disabled(
													!_Utils_eq(maybeErr, $elm$core$Maybe$Nothing))
												]),
											label))
									])))
						]));
			});
		var _v0 = config.deliveryMethod;
		if (_v0.$ === 'EmailFile') {
			var onClick = _v0.a;
			return A2(
				toBtn,
				{
					action: $author$project$Ui$V3$Button$onClick(
						A2(
							$elm$core$Maybe$withDefault,
							config.mapMsg($author$project$Components$SettingsPage$Reports$ReportView$NoOp),
							A2(
								$elm$core$Maybe$map,
								onClick,
								A3($elm$core$Maybe$map2, $author$project$Api$Reports$dateRange, model.startDate, model.endDate))))
				},
				$author$project$Components$SettingsPage$Reports$ReportView$emailFileLabel);
		} else {
			var reportType = _v0.a;
			return A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$action('/reports'),
						$elm$html$Html$Attributes$method('POST')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('hidden'),
								$elm$html$Html$Attributes$name('type'),
								$elm$html$Html$Attributes$value(reportType)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('hidden'),
								$elm$html$Html$Attributes$name('start_date'),
								$elm$html$Html$Attributes$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, model.startDate)))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('hidden'),
								$elm$html$Html$Attributes$name('end_date'),
								$elm$html$Html$Attributes$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Helpers$Date$toRfc3339, model.endDate)))
							]),
						_List_Nil),
						A2(
						toBtn,
						{action: $author$project$Ui$V3$Button$submitForm},
						$author$project$Components$SettingsPage$Reports$ReportView$downloadFileLabel)
					]));
		}
	});
var $author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin = F2(
	function (config, model) {
		var maybeErr = function () {
			var _v1 = A3($author$project$Components$SettingsPage$Reports$ReportView$buttonLabel, config.duration, '', model);
			if (_v1.$ === 'Ok') {
				return $elm$core$Maybe$Nothing;
			} else {
				var err = _v1.a;
				return $elm$core$Maybe$Just(
					$author$project$Helpers$String$capitalize(
						$author$project$Helpers$String$toLowerKeepMixedCaps(err)));
			}
		}();
		var viewDate = F3(
			function (label, onInput, dateStr) {
				return A4(
					$author$project$Ui$V3$Input$view,
					{
						onInput: A2(
							$elm$core$Basics$composeR,
							$justinmimbs$date$Date$fromIsoString,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Result$toMaybe,
								A2($elm$core$Basics$composeR, onInput, config.mapMsg)))
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Input$date,
							$author$project$Ui$V3$Input$label(label),
							$author$project$Ui$V3$Input$error(
							!_Utils_eq(maybeErr, $elm$core$Maybe$Nothing))
						]),
					_List_Nil,
					dateStr);
			});
		var date = F3(
			function (label, onInput, maybeVal) {
				if (maybeVal.$ === 'Just') {
					var val = maybeVal.a;
					return A2(
						$author$project$Ui$V3$Helpers$Html$percyFriendlyDate,
						val,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Helpers$Date$toRfc3339,
							A2(viewDate, label, onInput)));
				} else {
					return A3(viewDate, label, onInput, '');
				}
			});
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$styleAsCard,
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(config.title)
						])),
					A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							A3(date, 'Start date', $author$project$Components$SettingsPage$Reports$ReportView$UpdateStartDate, model.startDate),
							A3(date, 'End date', $author$project$Components$SettingsPage$Reports$ReportView$UpdateEndDate, model.endDate)
						])),
					A3($author$project$Components$SettingsPage$Reports$ReportView$buttonV3Reskin, config, model, maybeErr)
				]));
	});
var $author$project$Components$SettingsPage$ReportsLayout$visibleReportsV3Reskin = F2(
	function (loadedModel, data) {
		var reports = A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$first,
				_List_fromArray(
					[
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$userActivityReport),
								duration: $author$project$Domain$Duration$OneMonth,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateUserActivityReport),
								title: 'User activity report'
							},
							loadedModel.userActivityReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && ((data.account.payablesAccount || data.account.factorAccount) && (!data.accountSettings.indexAuditSplitEnabled)),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$processorScorecardReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateProcessorScorecardReport),
								title: 'Processor scorecard report'
							},
							loadedModel.processorScorecardReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && (data.account.payablesAccount && data.accountSettings.indexAuditSplitEnabled),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$indexerScorecardReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateIndexerScorecardReport),
								title: 'Indexer scorecard report'
							},
							loadedModel.indexerScorecardReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && (data.account.payablesAccount && data.accountSettings.indexAuditSplitEnabled),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$indexingActivityReport),
								duration: $author$project$Domain$Duration$OneWeek,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateIndexingActivityReport),
								title: 'Indexing activity report'
							},
							loadedModel.indexingActivityReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && (data.account.payablesAccount && data.accountSettings.indexAuditSplitEnabled),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$auditorScorecardReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateIndexerScorecardReport),
								title: 'Auditor scorecard report'
							},
							loadedModel.indexerScorecardReport)),
						_Utils_Tuple2(
						data.accountSettings.verificationsEnabled,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$verificationsReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateVerificationsReport),
								title: 'Verifications report'
							},
							loadedModel.verificationsReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && data.accountSettings.verificationsWorkflowEnabled,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$verificationsWorkflowReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateVerificationsWorkflowReport),
								title: 'Verifications workflow report'
							},
							loadedModel.verificationsWorkflowReport)),
						_Utils_Tuple2(
						data.accountSettings.verificationsEnabled,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$verifierScorecardReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateVerifierScorecardReport),
								title: 'Verifier scorecard report'
							},
							loadedModel.verifierScorecardReport)),
						_Utils_Tuple2(
						data.account.scraperAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$Reports$ReportView$DownloadFile('Missing POD Report'),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateMissingPodReport),
								title: 'Missing POD report'
							},
							loadedModel.missingPodReport)),
						_Utils_Tuple2(
						data.account.scraperAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$documentRetrievalBillingDetailsReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateDocumentRetrievalBillingDetailsReport),
								title: 'Document retrieval billing details report'
							},
							loadedModel.documentRetrievalBillingDetailsReport)),
						_Utils_Tuple2(
						data.account.scraperAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin,
							'Document retrieval status report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$documentScraperStatusReport))),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$carrierInvoicingBillingDetailsReport),
								duration: $author$project$Domain$Duration$OneMonth,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateCarrierInvoicingBillingDetailsReport),
								title: 'Carrier invoicing billing detail report'
							},
							loadedModel.carrierInvoicingBillingDetailsReport)),
						_Utils_Tuple2(
						data.account.factorAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$factorInvoicingBillingDetailsReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateFactorInvoicingBillingDetailsReport),
								title: 'Factor invoicing billing detail report'
							},
							loadedModel.factorInvoicingBillingDetailsReport)),
						_Utils_Tuple2(
						data.account.factorAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$carrierScorecardReport),
								duration: $author$project$Domain$Duration$OneWeek,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateCarrierScorecardReport),
								title: 'Carrier scorecard report'
							},
							loadedModel.carrierScorecardReport)),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$loadsRequiringActionReport),
								duration: $author$project$Domain$Duration$OneMonth,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateLoadsRequiringActionReport),
								title: 'Loads missing documents report'
							},
							loadedModel.loadsRequiringActionReport)),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin,
							'Invoice exception report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$invoiceExceptionReport))),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin,
							'All payables exceptions report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$allPayablesExceptionsReport))),
						_Utils_Tuple2(
						data.account.payablesAccount && data.accountSettings.auditBillingEnabled,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin,
							'Unbilled invoices report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$unbilledInvoicesReport))),
						_Utils_Tuple2(
						data.account.receivablesAccount,
						A2($author$project$Components$SettingsPage$ReportsLayout$simpleDownloadReportViewV3Reskin, 'Customer invoices missing documents report', 'Customer invoices missing documents report')),
						_Utils_Tuple2(
						data.account.receivablesAccount,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$customerInvoicesSentReport),
								duration: $author$project$Domain$Duration$OneMonth,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateCustomerInvoicesSentReport),
								title: 'Customer invoices sent report'
							},
							loadedModel.customerInvoicesSentReport)),
						_Utils_Tuple2(
						data.account.payablesAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin,
							'Customer rules report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$customerRulesReport))),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && data.account.receivablesAccount,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin,
							'Customer invoice delivery method report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$customerInvoiceDeliveryMethodReport))),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser),
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin,
							'New queue snapshot report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$newQueueSnapshotReport))),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && data.accountSettings.indexAuditSplitEnabled,
						A2(
							$author$project$Components$SettingsPage$ReportsLayout$simpleEmailReportViewV3Reskin,
							'Ready to audit queue snapshot report',
							$author$project$Components$SettingsPage$ReportsLayout$SendReport($author$project$Api$Reports$rtaSnapshotReport))),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$emailActivityReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateEmailActivityReport),
								title: 'Email activity report'
							},
							loadedModel.emailActivityReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && data.accountSettings.autoIndexNidfDocumentsToLoad,
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$autoNidfBatchesReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateAutoNidfBatchesReport),
								title: 'Auto-NIDF batches report'
							},
							loadedModel.autoNidfBatchesReport)),
						_Utils_Tuple2(
						A2($author$project$Components$SettingsPage$ReportsLayout$canViewAdminReports, data.accountSettings, data.currentUser) && $author$project$Components$SettingsPage$ReportsLayout$ltlLoadsReportIsViewable(data.accountSettings),
						A2(
							$author$project$Components$SettingsPage$Reports$ReportView$viewV3Reskin,
							{
								deliveryMethod: $author$project$Components$SettingsPage$ReportsLayout$emailDelivery($author$project$Api$Reports$ltlLoadsReport),
								duration: $author$project$Domain$Duration$ThreeMonths,
								mapMsg: A2($elm$core$Basics$composeL, $author$project$Components$SettingsPage$ReportsLayout$LoadedMsg, $author$project$Components$SettingsPage$ReportsLayout$UpdateLtlLoadsReport),
								title: 'LTL loads report'
							},
							loadedModel.ltlLoadsReport))
					])));
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
							]),
						reports)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$flex1,
					$elm$html$Html$text(''))
				]));
	});
var $author$project$Components$SettingsPage$ReportsLayout$authorizedView = F3(
	function (v3ReskinEnabled, model, data) {
		var _v0 = model.loadedModel;
		if (_v0.$ === 'Just') {
			var loadedModel = _v0.a;
			return A3(
				$author$project$Components$SettingsPage$ReportsLayout$frameView,
				v3ReskinEnabled,
				data,
				v3ReskinEnabled ? $author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewVert,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Reports')
									])),
								A2($author$project$Components$SettingsPage$ReportsLayout$visibleReportsV3Reskin, loadedModel, data)
							]))) : $author$project$Ui$toHtml(
					A2(
						$author$project$Ui$stack,
						_List_fromArray(
							[$author$project$Ui$between4]),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$heading2('Reports'),
							_Utils_ap(
								A2($author$project$Components$SettingsPage$ReportsLayout$visibleReports, loadedModel, data),
								_List_fromArray(
									[
										A2($author$project$Ui$stack, _List_Nil, _List_Nil)
									]))))));
		} else {
			return A3(
				$author$project$Components$SettingsPage$ReportsLayout$frameView,
				v3ReskinEnabled,
				data,
				$elm$html$Html$text('Loading ...'));
		}
	});
var $author$project$Components$SettingsPage$ReportsLayout$view = F3(
	function (v3ReskinEnabled, model, data) {
		return data.currentUser.hasSettingsRole ? A3($author$project$Components$SettingsPage$ReportsLayout$authorizedView, v3ReskinEnabled, model, data) : A3(
			$author$project$Components$SettingsPage$ReportsLayout$frameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.'));
	});
var $author$project$Components$SettingsPage$RulesLayout$frameView = F2(
	function (v3ReskinEnabled, _v0) {
		var user = _v0.user;
		var settings = _v0.settings;
		var account = _v0.account;
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Rules, account, settings, user);
	});
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$Change = function (a) {
	return {$: 'Change', a: a};
};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$Save = {$: 'Save'};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$view = function (model) {
	return $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$advancedView(
		{choices: model.choices, onChange: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$Change, onSave: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$Save, policy: model.policy});
};
var $author$project$Forward$FormWrapper$viewCustom = F3(
	function (views, childView, _v0) {
		var model = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Forward$FormWrapper$ChildMsg,
			function () {
				var _v1 = model.child;
				switch (_v1.$) {
					case 'Loading':
						return views.loading;
					case 'Loaded':
						var childModel = _v1.a;
						return childView(childModel);
					default:
						var error = _v1.a;
						return views.error(error);
				}
			}());
	});
var $author$project$Forward$FormWrapper$view = F2(
	function (childView, model) {
		return A3(
			$author$project$Forward$FormWrapper$viewCustom,
			{error: $author$project$Forward$LoadingView$defaultErrorView, loading: $author$project$Forward$LoadingView$defaultLoadingView},
			childView,
			model);
	});
var $author$project$Components$SettingsPage$ConditionalExceptions$ToggleRuleExpanded = function (a) {
	return {$: 'ToggleRuleExpanded', a: a};
};
var $author$project$Components$SettingsPage$ConditionalExceptions$countConditions = function (group) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (node, acc) {
				var _v0 = node.node;
				if (_v0.$ === 'ConditionalExceptionRule_RuleNode_Node_Condition') {
					return acc + 1;
				} else {
					var nested = _v0.a;
					return acc + $author$project$Components$SettingsPage$ConditionalExceptions$countConditions(nested);
				}
			}),
		0,
		group.children);
};
var $author$project$Ui$V3$Colors$Blue200 = {$: 'Blue200'};
var $author$project$Ui$V3$Colors$Teal100 = {$: 'Teal100'};
var $author$project$Components$SettingsPage$ConditionalExceptions$conditionSummary = function (condition) {
	var predicateLabel = function () {
		var _v2 = condition.predicate;
		switch (_v2) {
			case 'is_not':
				return 'is not';
			case 'is_present':
				return 'is present';
			case 'is_not_present':
				return 'is not present';
			case 'less_than':
				return 'less than';
			case 'less_than_or_equal_to':
				return 'less than or equal to';
			case 'greater_than':
				return 'greater than';
			case 'greater_than_or_equal_to':
				return 'greater than or equal to';
			default:
				return 'is';
		}
	}();
	var needsValue = (condition.predicate !== 'is_present') && (condition.predicate !== 'is_not_present');
	var valueSummary = function () {
		if (needsValue) {
			var _v1 = condition.value;
			if (_v1.$ === 'Just') {
				var v = _v1.a;
				return ' \u0022' + (v + '\u0022');
			} else {
				return ' (none)';
			}
		} else {
			return '';
		}
	}();
	var fieldLabel = function () {
		var _v0 = condition.fieldCategory;
		_v0$4:
		while (true) {
			if (_v0.$ === 'Just') {
				switch (_v0.a) {
					case 'customer':
						return 'Customer';
					case 'carrier':
						return 'Carrier';
					case 'load_reference':
						return 'Load Ref: ' + A2($elm$core$Maybe$withDefault, '', condition.fieldId);
					case 'invoice':
						return 'Load: ' + A2($elm$core$Maybe$withDefault, '', condition.fieldId);
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return '(no field)';
	}();
	return fieldLabel + (' ' + (predicateLabel + valueSummary));
};
var $author$project$Components$SettingsPage$ConditionalExceptions$viewConditionsReadOnly = function (group) {
	var operatorText = $elm$core$String$toUpper(group.operator);
	var childrenWithConnectors = A2(
		$elm$core$List$intersperse,
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('conditional-rules__readonly-connector')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(operatorText)
				])),
		A2($elm$core$List$map, $author$project$Components$SettingsPage$ConditionalExceptions$viewNodeReadOnly, group.children));
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
			]),
		childrenWithConnectors);
};
var $author$project$Components$SettingsPage$ConditionalExceptions$viewNodeReadOnly = function (node) {
	var _v0 = node.node;
	if (_v0.$ === 'ConditionalExceptionRule_RuleNode_Node_Condition') {
		var condition = _v0.a;
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Blue150),
					$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXXSmall)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Components$SettingsPage$ConditionalExceptions$conditionSummary(condition))
				]));
	} else {
		var group = _v0.a;
		return $author$project$Components$SettingsPage$ConditionalExceptions$viewConditionsReadOnly(group);
	}
};
var $author$project$Components$SettingsPage$ConditionalExceptions$viewRuleDetail = function (rule) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$class('conditional-rules__rule-detail'),
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[$author$project$Ui$V3$Stack$crossAxisCenter]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fitPx(48),
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conditional-rules__detail-keyword')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('IF')
								]))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Blue100),
									A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Blue200),
									$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXSmall),
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
								]),
							_List_fromArray(
								[
									$author$project$Components$SettingsPage$ConditionalExceptions$viewConditionsReadOnly(rule.conditions)
								])))
					])),
				A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[$author$project$Ui$V3$Stack$crossAxisCenter]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fitPx(48),
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('conditional-rules__detail-keyword')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('THEN')
								]))),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$flex1,
						A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Teal100),
									A2($author$project$Ui$V3$Stack$borderSolid, 1, $author$project$Ui$V3$Colors$Teal200),
									$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXSmall)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Raise exception: \u0022' + (rule.exceptionMessage + '\u0022'))
								])))
					]))
			]));
};
var $author$project$Components$SettingsPage$ConditionalExceptions$viewSavedRuleReadOnly = F3(
	function (expandedRules, index, rule) {
		var isCollapsed = !A2($elm$core$Set$member, index, expandedRules);
		var conditionCount = $author$project$Components$SettingsPage$ConditionalExceptions$countConditions(rule.conditions);
		var countText = $elm$core$String$fromInt(conditionCount) + (' condition' + ((conditionCount !== 1) ? 's' : ''));
		var titleText = 'Exception \u0022' + (rule.exceptionMessage + ('\u0022 — ' + countText));
		return A3(
			$author$project$Ui$V3$Card$view,
			{title: titleText},
			_List_fromArray(
				[
					$author$project$Ui$V3$Card$collapsible(
					{
						collapseMsg: $author$project$Components$SettingsPage$ConditionalExceptions$ToggleRuleExpanded(index),
						isCollapsed: isCollapsed
					})
				]),
			_List_fromArray(
				[
					$author$project$Components$SettingsPage$ConditionalExceptions$viewRuleDetail(rule)
				]));
	});
var $author$project$Components$SettingsPage$ConditionalExceptions$viewReadOnly = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('conditional-rules')
			]),
		_List_fromArray(
			[
				$elm$core$List$isEmpty(model.rules) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conditional-rules__empty-state')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('conditional-rules__empty-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No conditional exceptions configured.')
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('conditional-rules__list')
					]),
				A2(
					$elm$core$List$indexedMap,
					$author$project$Components$SettingsPage$ConditionalExceptions$viewSavedRuleReadOnly(model.expandedRules),
					model.rules))
			]));
};
var $author$project$Components$SettingsPage$RulesLayout$viewSection = function (config) {
	var description = config.description;
	var title = config.title;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('shared__section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shared__section-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
				A2($elm$html$Html$map, $elm$core$Basics$never, description),
				config.view
			]));
};
var $author$project$Components$SettingsPage$RulesLayout$authorizedView = F2(
	function (model, data) {
		return A3(
			$author$project$Components$SettingsPage$RulesLayout$frameView,
			false,
			data,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Rules')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Components$SettingsPage$RulesLayout$viewSection,
							_List_fromArray(
								[
									{
									description: $elm$html$Html$text(''),
									title: 'POD Requirement Policy',
									view: A2(
										$elm$html$Html$map,
										$author$project$Components$SettingsPage$RulesLayout$PodRequirementPolicyMsg,
										A2($author$project$Forward$FormWrapper$view, $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$view, model.podRequirementPolicy))
								},
									{
									description: A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('These are the required references for this account.')
											])),
									title: 'Required References',
									view: A2(
										$elm$html$Html$map,
										$author$project$Components$SettingsPage$RulesLayout$ReferencesMsg,
										A2($author$project$Forward$FormWrapper$view, $author$project$Components$SettingsPage$Shared$ReferenceTable$view, model.references))
								},
									{
									description: A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Set custom exception messages for this account.')
											])),
									title: 'Custom Exception Messages',
									view: A2(
										$elm$html$Html$map,
										$author$project$Components$SettingsPage$RulesLayout$CustomExceptionMessagesMsg,
										A2($author$project$Forward$FormWrapper$view, $author$project$Components$SettingsPage$Shared$CustomExceptionMessages$view, model.customExceptionMessages))
								},
									{
									description: A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Conditional exceptions that trigger during auto-approval.')
											])),
									title: 'Conditional Exceptions',
									view: A2(
										$elm$html$Html$map,
										$author$project$Components$SettingsPage$RulesLayout$ConditionalExceptionsMsg,
										A2($author$project$Forward$FormWrapper$view, $author$project$Components$SettingsPage$ConditionalExceptions$viewReadOnly, model.conditionalRules))
								}
								])))
					])));
	});
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$Cancel = {$: 'Cancel'};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$StartEditing = {$: 'StartEditing'};
var $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$formViewV3ReskinForRules = function (model) {
	var section = {
		current: model.policy,
		editing: model.isEditing,
		formView: function (policy) {
			return _Utils_Tuple3(
				A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
						]),
					_List_fromArray(
						[
							$author$project$Components$SettingsPage$Shared$PodRequirementPolicy$description,
							A2(
							$author$project$Ui$V3$SimpleSelect$view,
							{
								onInput: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$Change,
								options: model.choices,
								toLabel: $author$project$Domain$PodRequirementPolicy$display,
								value: $elm$core$Maybe$Just(policy)
							},
							_List_Nil)
						])),
				$elm$core$Maybe$Nothing,
				true);
		},
		initial: model.origPolicy,
		maybeError: $elm$core$Maybe$Nothing,
		onCancel: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$Cancel,
		onSave: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$Save,
		onStartEdit: $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$StartEditing,
		saving: model.isSaving,
		summaryView: function (policy) {
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
					]),
				_List_fromArray(
					[
						$author$project$Components$SettingsPage$Shared$PodRequirementPolicy$description,
						A2(
						$elm$html$Html$em,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$Shared$PodRequirementPolicy$summaryView(policy)
							]))
					]));
		},
		title: 'POD requirement policy'
	};
	return $author$project$Components$SettingsPage$Shared$EditSection$viewV3ReskinCustom(section);
};
var $author$project$Components$SettingsPage$RulesLayout$authorizedViewV3Reskin = F2(
	function (model, data) {
		return A3(
			$author$project$Components$SettingsPage$RulesLayout$frameView,
			true,
			data,
			$author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Rules')
											])),
										A2(
										$elm$html$Html$map,
										$author$project$Components$SettingsPage$RulesLayout$PodRequirementPolicyMsg,
										A2($author$project$Forward$FormWrapper$view, $author$project$Components$SettingsPage$Shared$PodRequirementPolicy$formViewV3ReskinForRules, model.podRequirementPolicy)),
										A2(
										$elm$html$Html$map,
										$author$project$Components$SettingsPage$RulesLayout$ReferencesMsg,
										A2(
											$author$project$Forward$FormWrapper$view,
											$author$project$Components$SettingsPage$Shared$ReferenceTable$viewV3Reskin(
												A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('These are the required references for this account.')
														]))),
											model.references)),
										A2(
										$author$project$Ui$V3$Stack$viewVert,
										_List_fromArray(
											[$author$project$Ui$V3$Stack$styleAsCard]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Custom exception messages')
													])),
												A2(
												$elm$html$Html$map,
												$author$project$Components$SettingsPage$RulesLayout$CustomExceptionMessagesMsg,
												A2(
													$author$project$Forward$FormWrapper$view,
													$author$project$Components$SettingsPage$Shared$CustomExceptionMessages$viewV3Reskin(
														A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Set custom exception messages for this account.')
																]))),
													model.customExceptionMessages))
											])),
										A2(
										$author$project$Ui$V3$Stack$viewVert,
										_List_fromArray(
											[$author$project$Ui$V3$Stack$styleAsCard]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Conditional Exceptions')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Conditional exceptions that trigger during auto-approval.')
													])),
												A2(
												$elm$html$Html$map,
												$author$project$Components$SettingsPage$RulesLayout$ConditionalExceptionsMsg,
												A2($author$project$Forward$FormWrapper$view, $author$project$Components$SettingsPage$ConditionalExceptions$viewReadOnly, model.conditionalRules))
											]))
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							$elm$html$Html$text(''))
						]))));
	});
var $author$project$Components$SettingsPage$RulesLayout$readOnlyView = F2(
	function (model, data) {
		return A3(
			$author$project$Components$SettingsPage$RulesLayout$frameView,
			false,
			data,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Rules')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$SettingsPage$RulesLayout$viewSection(
								{
									description: A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Conditional exceptions that trigger during auto-approval.')
											])),
									title: 'Conditional Exceptions',
									view: A2(
										$elm$html$Html$map,
										$author$project$Components$SettingsPage$RulesLayout$ConditionalExceptionsMsg,
										A2($author$project$Forward$FormWrapper$view, $author$project$Components$SettingsPage$ConditionalExceptions$viewReadOnly, model.conditionalRules))
								})
							]))
					])));
	});
var $author$project$Components$SettingsPage$RulesLayout$readOnlyViewV3Reskin = F2(
	function (model, data) {
		return A3(
			$author$project$Components$SettingsPage$RulesLayout$frameView,
			true,
			data,
			$author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Ui$V3$Stack$viewVert,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Rules')
											])),
										A2(
										$author$project$Ui$V3$Stack$viewVert,
										_List_fromArray(
											[$author$project$Ui$V3$Stack$styleAsCard]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Conditional Exceptions')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Conditional exceptions that trigger during auto-approval.')
													])),
												A2(
												$elm$html$Html$map,
												$author$project$Components$SettingsPage$RulesLayout$ConditionalExceptionsMsg,
												A2($author$project$Forward$FormWrapper$view, $author$project$Components$SettingsPage$ConditionalExceptions$viewReadOnly, model.conditionalRules))
											]))
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							$elm$html$Html$text(''))
						]))));
	});
var $author$project$Components$SettingsPage$RulesLayout$view = F3(
	function (v3ReskinEnabled, model, data) {
		return data.user.hasSettingsRole ? (v3ReskinEnabled ? A2($author$project$Components$SettingsPage$RulesLayout$authorizedViewV3Reskin, model, data) : A2($author$project$Components$SettingsPage$RulesLayout$authorizedView, model, data)) : (v3ReskinEnabled ? A2($author$project$Components$SettingsPage$RulesLayout$readOnlyViewV3Reskin, model, data) : A2($author$project$Components$SettingsPage$RulesLayout$readOnlyView, model, data));
	});
var $author$project$Components$SettingsPage$UserLayout$frameView = F2(
	function (v3ReskinEnabled, _v0) {
		var currentUser = _v0.currentUser;
		var accountSettings = _v0.accountSettings;
		var account = _v0.account;
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Users, account, accountSettings, currentUser);
	});
var $author$project$Components$SettingsPage$UserLayout$NavigateTo = function (a) {
	return {$: 'NavigateTo', a: a};
};
var $author$project$Components$SettingsPage$UserLayout$SaveEditUser = F2(
	function (a, b) {
		return {$: 'SaveEditUser', a: a, b: b};
	});
var $author$project$Components$SettingsPage$UserLayout$SaveEnableUser = F2(
	function (a, b) {
		return {$: 'SaveEnableUser', a: a, b: b};
	});
var $author$project$Components$SettingsPage$UserLayout$SaveNewUser = function (a) {
	return {$: 'SaveNewUser', a: a};
};
var $author$project$Components$SettingsPage$UserLayout$UserFormMsg = function (a) {
	return {$: 'UserFormMsg', a: a};
};
var $author$project$Components$SettingsPage$UserLayout$userFormConfig = function (model) {
	var _v0 = model.mode;
	switch (_v0.$) {
		case 'NewMode':
			return {
				heading: 'New User',
				isSaving: model.isSaving,
				mapMsg: $author$project$Components$SettingsPage$UserLayout$UserFormMsg,
				onCancel: $author$project$Components$SettingsPage$UserLayout$NavigateTo(
					$author$project$Path$toString($author$project$Path$settingsUsers)),
				onSave: $author$project$Components$SettingsPage$UserLayout$SaveNewUser
			};
		case 'EditMode':
			var userId = _v0.a;
			return {
				heading: 'Edit User',
				isSaving: model.isSaving,
				mapMsg: $author$project$Components$SettingsPage$UserLayout$UserFormMsg,
				onCancel: $author$project$Components$SettingsPage$UserLayout$NavigateTo(
					$author$project$Path$toString($author$project$Path$settingsUsers)),
				onSave: $author$project$Components$SettingsPage$UserLayout$SaveEditUser(userId)
			};
		default:
			var userId = _v0.a;
			return {
				heading: 'Enable User',
				isSaving: model.isSaving,
				mapMsg: $author$project$Components$SettingsPage$UserLayout$UserFormMsg,
				onCancel: $author$project$Components$SettingsPage$UserLayout$NavigateTo(
					$author$project$Path$toString($author$project$Path$settingsUsers)),
				onSave: $author$project$Components$SettingsPage$UserLayout$SaveEnableUser(userId)
			};
	}
};
var $author$project$Components$SettingsPage$UserForm$EmailAddress = {$: 'EmailAddress'};
var $author$project$Components$SettingsPage$UserForm$EmailSignature = {$: 'EmailSignature'};
var $author$project$Components$SettingsPage$UserForm$Name = {$: 'Name'};
var $author$project$Components$SettingsPage$UserForm$UpdateEmailAddress = function (a) {
	return {$: 'UpdateEmailAddress', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateEmailSignature = function (a) {
	return {$: 'UpdateEmailSignature', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateName = function (a) {
	return {$: 'UpdateName', a: a};
};
var $author$project$Components$SettingsPage$UserForm$Validate = function (a) {
	return {$: 'Validate', a: a};
};
var $author$project$Experimental$FormField$feedback = function (_v0) {
	var formField = _v0.a;
	return formField.feedback;
};
var $author$project$Ui$checkboxGroup = F2(
	function (label, children) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Ui(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hubtran-checkbox__group-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))),
				A2($elm$core$List$map, $author$project$Ui$checkbox, children)));
	});
var $author$project$Components$SettingsPage$UserForm$UpdateAdmin = function (a) {
	return {$: 'UpdateAdmin', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateApprover = function (a) {
	return {$: 'UpdateApprover', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateAuditor = function (a) {
	return {$: 'UpdateAuditor', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateCanUnapproveInvoices = function (a) {
	return {$: 'UpdateCanUnapproveInvoices', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateCustomerRepresentative = function (a) {
	return {$: 'UpdateCustomerRepresentative', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateIndexer = function (a) {
	return {$: 'UpdateIndexer', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateInsightsDashboardAccess = function (a) {
	return {$: 'UpdateInsightsDashboardAccess', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateReadOnlyFactorInvoices = function (a) {
	return {$: 'UpdateReadOnlyFactorInvoices', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateReceivables = function (a) {
	return {$: 'UpdateReceivables', a: a};
};
var $author$project$Components$SettingsPage$UserForm$UpdateSettingsRole = function (a) {
	return {$: 'UpdateSettingsRole', a: a};
};
var $author$project$Helpers$List$conditionallyAppend = F3(
	function (conditional, item, list) {
		return conditional ? _Utils_ap(list, item) : list;
	});
var $author$project$Components$SettingsPage$UserForm$permissions = F4(
	function (config, accountSettings, account, model) {
		return A3(
			$author$project$Helpers$List$conditionallyAppend,
			_Utils_eq(
				$author$project$Domain$Account$accountType(account),
				$author$project$Domain$Account$BrokerAccount) && accountSettings.canUnapproveInvoices,
			_List_fromArray(
				[
					{
					feedback: $elm$core$Maybe$Nothing,
					label: 'Invoice Unapproval',
					onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateCanUnapproveInvoices, config.mapMsg),
					value: model.canUnapproveInvoices
				}
				]),
			A3(
				$author$project$Helpers$List$conditionallyAppend,
				accountSettings.allowReadonlyFactorUserSelection,
				_List_fromArray(
					[
						{
						feedback: $elm$core$Maybe$Nothing,
						label: 'Read Only Factor Invoices',
						onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateReadOnlyFactorInvoices, config.mapMsg),
						value: model.readOnlyFactorInvoices
					}
					]),
				A2(
					$elm$core$List$append,
					_List_fromArray(
						[
							{
							feedback: $elm$core$Maybe$Nothing,
							label: 'Insights Dashboard Access',
							onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateInsightsDashboardAccess, config.mapMsg),
							value: model.insightsDashboardAccess
						}
						]),
					A3(
						$author$project$Helpers$List$conditionallyAppend,
						accountSettings.customerRepresentativeViewEnabled,
						_List_fromArray(
							[
								{
								feedback: $elm$core$Maybe$Nothing,
								label: 'Customer Representative',
								onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateCustomerRepresentative, config.mapMsg),
								value: model.customerRepresentative
							}
							]),
						A3(
							$author$project$Helpers$List$conditionallyAppend,
							accountSettings.indexAuditSplitEnabled,
							_List_fromArray(
								[
									{
									feedback: $elm$core$Maybe$Nothing,
									label: 'Indexer',
									onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateIndexer, config.mapMsg),
									value: model.indexer
								}
								]),
							A3(
								$author$project$Helpers$List$conditionallyAppend,
								accountSettings.indexAuditSplitEnabled,
								_List_fromArray(
									[
										{
										feedback: $elm$core$Maybe$Nothing,
										label: 'Auditor',
										onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateAuditor, config.mapMsg),
										value: model.auditor
									}
									]),
								A3(
									$author$project$Helpers$List$conditionallyAppend,
									account.receivablesAccount,
									_List_fromArray(
										[
											{
											feedback: $elm$core$Maybe$Nothing,
											label: 'Receivables',
											onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateReceivables, config.mapMsg),
											value: model.receivables
										}
										]),
									_List_fromArray(
										[
											{
											feedback: $elm$core$Maybe$Nothing,
											label: 'Approver',
											onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateApprover, config.mapMsg),
											value: model.approver
										},
											{
											feedback: $elm$core$Maybe$Nothing,
											label: 'Admin',
											onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateAdmin, config.mapMsg),
											value: model.admin
										},
											{
											feedback: $elm$core$Maybe$Nothing,
											label: 'Settings',
											onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateSettingsRole, config.mapMsg),
											value: model.settingsRole
										}
										]))))))));
	});
var $author$project$Components$SettingsPage$UserForm$permissionGroup = F4(
	function (config, accountSettings, account, model) {
		return A2(
			$author$project$Ui$checkboxGroup,
			'Permissions',
			A4($author$project$Components$SettingsPage$UserForm$permissions, config, accountSettings, account, model));
	});
var $author$project$Ui$vertical2 = function (config) {
	return _Utils_update(
		config,
		{vertical: 2});
};
var $author$project$Components$SettingsPage$UserForm$view = F4(
	function (config, accountSettings, account, model) {
		return config.isSaving ? $elm$html$Html$text('Saving ...') : $author$project$Ui$toHtml(
			A2(
				$author$project$Ui$stack,
				_List_fromArray(
					[$author$project$Ui$between2]),
				_List_fromArray(
					[
						$author$project$Ui$heading2(config.heading),
						A2(
						$author$project$Ui$stack,
						_List_fromArray(
							[$author$project$Ui$between3]),
						_List_fromArray(
							[
								$author$project$Ui$textInput(
								{
									feedback: $author$project$Experimental$FormField$feedback(model.name),
									label: 'Name',
									labelPrefix: $elm$core$Maybe$Nothing,
									onBlur: config.mapMsg(
										$author$project$Components$SettingsPage$UserForm$Validate($author$project$Components$SettingsPage$UserForm$Name)),
									onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateName, config.mapMsg),
									placeholder: '',
									value: $author$project$Experimental$FormField$value(model.name)
								}),
								A2(
								$author$project$Ui$textInputWithAttributes,
								{
									feedback: $author$project$Experimental$FormField$feedback(model.emailAddress),
									label: 'Email',
									labelPrefix: $elm$core$Maybe$Nothing,
									onBlur: config.mapMsg(
										$author$project$Components$SettingsPage$UserForm$Validate($author$project$Components$SettingsPage$UserForm$EmailAddress)),
									onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateEmailAddress, config.mapMsg),
									placeholder: '',
									value: $author$project$Experimental$FormField$value(model.emailAddress)
								},
								_List_fromArray(
									[
										$elm$html$Html$Attributes$disabled(
										A2(
											$elm$core$Maybe$withDefault,
											false,
											A2(
												$elm$core$Maybe$map,
												$elm$core$Basics$always(true),
												model.groupUserId)))
									])),
								A4($author$project$Components$SettingsPage$UserForm$permissionGroup, config, accountSettings, account, model),
								$author$project$Ui$textarea(
								{
									feedback: $author$project$Experimental$FormField$feedback(model.emailSignature),
									label: 'Email Signature',
									labelPrefix: $elm$core$Maybe$Nothing,
									onBlur: config.mapMsg(
										$author$project$Components$SettingsPage$UserForm$Validate($author$project$Components$SettingsPage$UserForm$EmailSignature)),
									onChange: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateEmailSignature, config.mapMsg),
									placeholder: '',
									value: $author$project$Experimental$FormField$value(model.emailSignature)
								}),
								A2(
								$author$project$Ui$inline,
								_List_fromArray(
									[$author$project$Ui$between1]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$primary,
										'Save',
										config.onSave(model)),
										A2(
										$author$project$Ui$stack,
										_List_fromArray(
											[$author$project$Ui$vertical2]),
										_List_fromArray(
											[
												$author$project$Ui$text('or')
											])),
										A2(
										$author$project$Ui$stack,
										_List_fromArray(
											[$author$project$Ui$vertical2]),
										_List_fromArray(
											[
												A2($author$project$Ui$internalLink, 'Cancel', config.onCancel)
											]))
									]))
							]))
					])));
	});
var $author$project$Components$SettingsPage$UserLayout$userFormView = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				A3(
					$author$project$Components$SettingsPage$UserForm$view,
					$author$project$Components$SettingsPage$UserLayout$userFormConfig(model),
					data.accountSettings,
					data.account),
				A2(
					$author$project$Components$SettingsPage$UserLayout$mergeFormData,
					$author$project$Forward$Remote$Loaded(data),
					model)));
	});
var $author$project$Components$SettingsPage$UserForm$isValid = function (model) {
	return A2(
		$elm$core$List$all,
		function (feedback) {
			if (feedback.$ === 'Nothing') {
				return true;
			} else {
				if (feedback.a.$ === 'Ok') {
					return true;
				} else {
					return false;
				}
			}
		},
		_List_fromArray(
			[
				$author$project$Experimental$FormField$feedback(model.name),
				$author$project$Experimental$FormField$feedback(model.emailAddress),
				$author$project$Experimental$FormField$feedback(model.emailSignature)
			]));
};
var $author$project$Components$SettingsPage$UserForm$permissionGroupV3Reskin = F4(
	function (config, accountSettings, account, model) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('v3__type__extra-small-body-semi-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Permissions')
						])),
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var onChange = _v0.onChange;
							var value = _v0.value;
							var label = _v0.label;
							return A2(
								$author$project$Ui$V3$Checkbox$view,
								{
									checked: value,
									label: $elm$html$Html$text(
										$elm_community$string_extra$String$Extra$toSentenceCase(
											$elm$core$String$toLower(label))),
									onCheck: onChange
								},
								_List_Nil);
						},
						A4($author$project$Components$SettingsPage$UserForm$permissions, config, accountSettings, account, model)))
				]));
	});
var $author$project$Components$SettingsPage$UserForm$viewV3Reskin = F4(
	function (config, accountSettings, account, model) {
		var validation = function (formField) {
			return $author$project$Ui$V3$Input$validation(
				function () {
					var _v0 = $author$project$Experimental$FormField$feedback(formField);
					if (_v0.$ === 'Just') {
						var feedback = _v0.a;
						return feedback;
					} else {
						return $elm$core$Result$Ok(_Utils_Tuple0);
					}
				}());
		};
		var sentenceCaseHeading = $author$project$Helpers$String$capitalize(
			$author$project$Helpers$String$toLowerKeepMixedCaps(config.heading));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sentenceCaseHeading)
						])),
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
							$author$project$Ui$V3$Stack$styleAsCard
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateName, config.mapMsg)
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$label('Name'),
									validation(model.name)
								]),
							_List_fromArray(
								[
									$elm$html$Html$Events$onBlur(
									config.mapMsg(
										$author$project$Components$SettingsPage$UserForm$Validate($author$project$Components$SettingsPage$UserForm$Name)))
								]),
							$author$project$Experimental$FormField$value(model.name)),
							A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateEmailAddress, config.mapMsg)
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$label('Email'),
									validation(model.emailAddress)
								]),
							_List_fromArray(
								[
									$elm$html$Html$Events$onBlur(
									config.mapMsg(
										$author$project$Components$SettingsPage$UserForm$Validate($author$project$Components$SettingsPage$UserForm$EmailAddress)))
								]),
							$author$project$Experimental$FormField$value(model.emailAddress)),
							A4($author$project$Components$SettingsPage$UserForm$permissionGroupV3Reskin, config, accountSettings, account, model),
							A4(
							$author$project$Ui$V3$Input$view,
							{
								onInput: A2($elm$core$Basics$composeR, $author$project$Components$SettingsPage$UserForm$UpdateEmailSignature, config.mapMsg)
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$Input$label('Email Signature'),
									validation(model.emailSignature),
									$author$project$Ui$V3$Input$expandable
								]),
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'height', '64px'),
									$elm$html$Html$Events$onBlur(
									config.mapMsg(
										$author$project$Components$SettingsPage$UserForm$Validate($author$project$Components$SettingsPage$UserForm$EmailSignature)))
								]),
							$author$project$Experimental$FormField$value(model.emailSignature)),
							$author$project$Helpers$Html$editButtons(
							{
								cancelMsg: config.onCancel,
								primaryDisabled: config.isSaving || (!$author$project$Components$SettingsPage$UserForm$isValid(model)),
								primaryLabel: 'Save',
								primaryMsg: config.onSave(model)
							})
						]))
				]));
	});
var $author$project$Components$SettingsPage$UserLayout$userFormViewV3Reskin = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				A3(
					$author$project$Components$SettingsPage$UserForm$viewV3Reskin,
					$author$project$Components$SettingsPage$UserLayout$userFormConfig(model),
					data.accountSettings,
					data.account),
				A2(
					$author$project$Components$SettingsPage$UserLayout$mergeFormData,
					$author$project$Forward$Remote$Loaded(data),
					model)));
	});
var $author$project$Components$SettingsPage$UserLayout$view = F3(
	function (v3ReskinEnabled, model, data) {
		return (!data.currentUser.isAdmin) ? A3(
			$author$project$Components$SettingsPage$UserLayout$frameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('ERROR: You must be an admin to use this page.')) : A3(
			$author$project$Components$SettingsPage$UserLayout$frameView,
			v3ReskinEnabled,
			data,
			v3ReskinEnabled ? $author$project$Helpers$Html$v3ReskinContainer(
				A2($author$project$Components$SettingsPage$UserLayout$userFormViewV3Reskin, data, model)) : A2($author$project$Components$SettingsPage$UserLayout$userFormView, data, model));
	});
var $author$project$Components$SettingsPage$UsersLayout$NavigateTo = function (a) {
	return {$: 'NavigateTo', a: a};
};
var $author$project$Components$SettingsPage$UsersLayout$DisableUser = function (a) {
	return {$: 'DisableUser', a: a};
};
var $author$project$Ui$neutral = F2(
	function (label, onClickMsg) {
		return $author$project$Ui$Ui(
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hubtran-button__neutral'),
						$elm$html$Html$Events$onClick(onClickMsg)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])));
	});
var $author$project$Components$SettingsPage$UsersLayout$roleStrings = F3(
	function (_v0, accountSettings, account) {
		var readOnlyFactorInvoices = _v0.readOnlyFactorInvoices;
		var canUnapproveInvoices = _v0.canUnapproveInvoices;
		var hasInsightsDashboardAccess = _v0.hasInsightsDashboardAccess;
		var isCustomerRepresentative = _v0.isCustomerRepresentative;
		var hasSettingsRole = _v0.hasSettingsRole;
		var receivables = _v0.receivables;
		var isIndexer = _v0.isIndexer;
		var isAuditor = _v0.isAuditor;
		var isApprover = _v0.isApprover;
		var isAdmin = _v0.isAdmin;
		return A3(
			$author$project$Helpers$List$conditionallyAppend,
			_Utils_eq(
				$author$project$Domain$Account$accountType(account),
				$author$project$Domain$Account$BrokerAccount) && canUnapproveInvoices,
			_List_fromArray(
				['Invoice Unapproval']),
			A3(
				$author$project$Helpers$List$conditionallyAppend,
				accountSettings.allowReadonlyFactorUserSelection && readOnlyFactorInvoices,
				_List_fromArray(
					['Read Only']),
				A3(
					$author$project$Helpers$List$conditionallyAppend,
					hasInsightsDashboardAccess,
					_List_fromArray(
						['Insights Dashboard']),
					A3(
						$author$project$Helpers$List$conditionallyAppend,
						accountSettings.customerRepresentativeViewEnabled && isCustomerRepresentative,
						_List_fromArray(
							['Customer Representative']),
						A3(
							$author$project$Helpers$List$conditionallyAppend,
							hasSettingsRole,
							_List_fromArray(
								['Settings']),
							A3(
								$author$project$Helpers$List$conditionallyAppend,
								accountSettings.indexAuditSplitEnabled && isIndexer,
								_List_fromArray(
									['Indexer']),
								A3(
									$author$project$Helpers$List$conditionallyAppend,
									accountSettings.indexAuditSplitEnabled && isAuditor,
									_List_fromArray(
										['Auditor']),
									A3(
										$author$project$Helpers$List$conditionallyAppend,
										(!isAdmin) && ((!isApprover) && (!accountSettings.indexAuditSplitEnabled)),
										_List_fromArray(
											['Basic']),
										A3(
											$author$project$Helpers$List$conditionallyAppend,
											account.receivablesAccount && receivables,
											_List_fromArray(
												['Receivables']),
											A3(
												$author$project$Helpers$List$conditionallyAppend,
												isApprover,
												_List_fromArray(
													['Approver']),
												A3(
													$author$project$Helpers$List$conditionallyAppend,
													isAdmin,
													_List_fromArray(
														['Admin']),
													_List_Nil)))))))))));
	});
var $author$project$Components$SettingsPage$UsersLayout$roles = F3(
	function (user, accountSettings, account) {
		return A2(
			$elm$core$String$join,
			', ',
			A3($author$project$Components$SettingsPage$UsersLayout$roleStrings, user, accountSettings, account));
	});
var $author$project$Path$settingsEditUser = function (userId) {
	return A2(
		$author$project$Path$appendToBase,
		_List_fromArray(
			[
				$elm$core$String$fromInt(
				$author$project$Domain$UserId$toInt(userId))
			]),
		$author$project$Path$settingsUsers);
};
var $author$project$Components$SettingsPage$UsersLayout$activeUserRow = F3(
	function (accountSettings, account, user) {
		return $author$project$Ui$row(
			_List_fromArray(
				[
					$author$project$Ui$text(user.name),
					$author$project$Ui$text(user.receivesEmailsAt),
					$author$project$Ui$text(
					A3($author$project$Components$SettingsPage$UsersLayout$roles, user, accountSettings, account)),
					A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$neutral,
							'Edit',
							$author$project$Components$SettingsPage$UsersLayout$NavigateTo(
								$author$project$Path$toString(
									$author$project$Path$settingsEditUser(user.id)))),
							A2(
							$author$project$Ui$neutral,
							'Disable',
							$author$project$Components$SettingsPage$UsersLayout$DisableUser(user.id))
						]))
				]));
	});
var $author$project$Path$settingsNewUser = A2(
	$author$project$Path$appendToBase,
	_List_fromArray(
		['new']),
	$author$project$Path$settingsUsers);
var $author$project$Components$SettingsPage$UsersLayout$tableHeaders = $author$project$Ui$headers(
	_List_fromArray(
		[
			$author$project$Ui$text('Name'),
			$author$project$Ui$text('Email'),
			$author$project$Ui$text('Role'),
			$author$project$Ui$text('Actions')
		]));
var $author$project$Components$SettingsPage$UsersLayout$activeUsersView = F3(
	function (users, accountSettings, account) {
		return A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					$author$project$Ui$heading2('Active Users'),
					A2(
					$author$project$Ui$stack,
					_List_fromArray(
						[$author$project$Ui$between3]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$inline,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$table,
									$author$project$Components$SettingsPage$UsersLayout$tableHeaders,
									A2(
										$elm$core$List$map,
										A2($author$project$Components$SettingsPage$UsersLayout$activeUserRow, accountSettings, account),
										users))
								])),
							A2(
							$author$project$Ui$inline,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$neutral,
									'New User',
									$author$project$Components$SettingsPage$UsersLayout$NavigateTo(
										$author$project$Path$toString($author$project$Path$settingsNewUser)))
								]))
						]))
				]));
	});
var $author$project$Components$SettingsPage$UsersLayout$ChangeActivePerPage = function (a) {
	return {$: 'ChangeActivePerPage', a: a};
};
var $author$project$Components$SettingsPage$UsersLayout$UpdateActivePage = function (a) {
	return {$: 'UpdateActivePage', a: a};
};
var $author$project$Components$SettingsPage$UsersLayout$roleChips = F3(
	function (user, accountSettings, account) {
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			A2(
				$elm$core$List$map,
				function (roleStr) {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2($author$project$Ui$V3$Chip$view, _List_Nil, roleStr));
				},
				A3($author$project$Components$SettingsPage$UsersLayout$roleStrings, user, accountSettings, account)));
	});
var $author$project$Components$SettingsPage$UsersLayout$usersViewV3Reskin = function (_v0) {
	var account = _v0.account;
	var accountSettings = _v0.accountSettings;
	var users = _v0.users;
	var updatePerPageMsg = _v0.updatePerPageMsg;
	var updatePageMsg = _v0.updatePageMsg;
	var perPage = _v0.perPage;
	var pageNum = _v0.pageNum;
	var lastColumn = _v0.lastColumn;
	var header = _v0.header;
	return $elm$core$List$isEmpty(users) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		function () {
			var page = A3($author$project$Pagination$fromList, pageNum, perPage, users);
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
					]),
				_List_fromArray(
					[
						header,
						A4(
						$author$project$Ui$V3$Table$view,
						{
							columns: _List_fromArray(
								[
									{
									attrs: _List_Nil,
									content: function (user) {
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('v3__type__small-body-semi-bold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(user.name)
												]));
									},
									heading: $elm$html$Html$text('Name')
								},
									{
									attrs: _List_Nil,
									content: function (user) {
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('v3__type__small-body')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(user.receivesEmailsAt)
												]));
									},
									heading: $elm$html$Html$text('Email')
								},
									{
									attrs: _List_Nil,
									content: function (user) {
										return A3($author$project$Components$SettingsPage$UsersLayout$roleChips, user, accountSettings, account);
									},
									heading: $elm$html$Html$text('Role')
								},
									{
									attrs: _List_Nil,
									content: lastColumn,
									heading: $elm$html$Html$text('')
								}
								])
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Table$pagination(
								{
									currentPage: page,
									dropdown: $author$project$Ui$V3$Pagination$Default(
										{onSelect: updatePerPageMsg}),
									updatePageMsg: updatePageMsg
								})
							]),
						_List_Nil,
						$author$project$Pagination$entries(page))
					]));
		}());
};
var $author$project$Components$SettingsPage$UsersLayout$activeUsersViewV3Reskin = F4(
	function (users, model, accountSettings, account) {
		return $author$project$Components$SettingsPage$UsersLayout$usersViewV3Reskin(
			{
				account: account,
				accountSettings: accountSettings,
				header: A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Active users')
									]))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A3(
								$author$project$Ui$V3$Button$view,
								{
									action: $author$project$Ui$V3$Button$onClick(
										$author$project$Components$SettingsPage$UsersLayout$NavigateTo(
											$author$project$Path$toString($author$project$Path$settingsNewUser)))
								},
								_List_fromArray(
									[
										$author$project$Ui$V3$Button$leftIcon16WithHiddenLabel($author$project$Ui$V3$Icon$add16)
									]),
								'Add User'))
						])),
				lastColumn: function (user) {
					return A2(
						$author$project$Ui$V3$Stack$viewHorzWithWidths,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
								$author$project$Ui$V3$Stack$noWrap,
								$author$project$Ui$V3$Stack$crossAxisCenter
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A2(
									$author$project$Ui$V3$UtilityButton$view,
									{
										icon: $author$project$Ui$V3$Icon$editOutline16,
										label: 'Edit',
										onClick: $author$project$Components$SettingsPage$UsersLayout$NavigateTo(
											$author$project$Path$toString(
												$author$project$Path$settingsEditUser(user.id)))
									},
									_List_fromArray(
										[$author$project$Ui$V3$UtilityButton$sizeSmall]))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								A3(
									$author$project$Ui$V3$Button$view,
									{
										action: $author$project$Ui$V3$Button$onClick(
											$author$project$Components$SettingsPage$UsersLayout$DisableUser(user.id))
									},
									_List_fromArray(
										[
											$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
											A2($author$project$Ui$V3$Button$cssStyle, 'padding', '0')
										]),
									'Disable'))
							]));
				},
				pageNum: model.activePageNum,
				perPage: model.activePerPage,
				updatePageMsg: $author$project$Components$SettingsPage$UsersLayout$UpdateActivePage,
				updatePerPageMsg: $author$project$Components$SettingsPage$UsersLayout$ChangeActivePerPage,
				users: users
			});
	});
var $author$project$Path$settingsEnableUser = function (userId) {
	return A2(
		$author$project$Path$appendToBase,
		_List_fromArray(
			[
				$elm$core$String$fromInt(
				$author$project$Domain$UserId$toInt(userId)),
				'enable'
			]),
		$author$project$Path$settingsUsers);
};
var $author$project$Components$SettingsPage$UsersLayout$disabledUserRow = F3(
	function (accountSettings, account, user) {
		return $author$project$Ui$row(
			_List_fromArray(
				[
					$author$project$Ui$text(user.name),
					$author$project$Ui$text(user.emailAddress),
					$author$project$Ui$text(
					A3($author$project$Components$SettingsPage$UsersLayout$roles, user, accountSettings, account)),
					A2(
					$author$project$Ui$inline,
					_List_fromArray(
						[$author$project$Ui$between2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$neutral,
							'Enable',
							$author$project$Components$SettingsPage$UsersLayout$NavigateTo(
								$author$project$Path$toString(
									$author$project$Path$settingsEnableUser(user.id))))
						]))
				]));
	});
var $author$project$Components$SettingsPage$UsersLayout$disabledUsersView = F3(
	function (users, accountSettings, account) {
		return $elm$core$List$isEmpty(users) ? $author$project$Ui$empty : A2(
			$author$project$Ui$stack,
			_List_fromArray(
				[$author$project$Ui$between2]),
			_List_fromArray(
				[
					$author$project$Ui$heading2('Disabled Users'),
					A2(
					$author$project$Ui$inline,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$table,
							$author$project$Components$SettingsPage$UsersLayout$tableHeaders,
							A2(
								$elm$core$List$map,
								A2($author$project$Components$SettingsPage$UsersLayout$disabledUserRow, accountSettings, account),
								users))
						]))
				]));
	});
var $author$project$Components$SettingsPage$UsersLayout$ChangeDisabledPerPage = function (a) {
	return {$: 'ChangeDisabledPerPage', a: a};
};
var $author$project$Components$SettingsPage$UsersLayout$UpdateDisabledPage = function (a) {
	return {$: 'UpdateDisabledPage', a: a};
};
var $author$project$Components$SettingsPage$UsersLayout$disabledUsersViewV3Reskin = F4(
	function (users, model, accountSettings, account) {
		return $author$project$Components$SettingsPage$UsersLayout$usersViewV3Reskin(
			{
				account: account,
				accountSettings: accountSettings,
				header: A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Disabled users')
						])),
				lastColumn: function (user) {
					return A3(
						$author$project$Ui$V3$Button$view,
						{
							action: $author$project$Ui$V3$Button$onClick(
								$author$project$Components$SettingsPage$UsersLayout$NavigateTo(
									$author$project$Path$toString(
										$author$project$Path$settingsEnableUser(user.id))))
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
								A2($author$project$Ui$V3$Button$cssStyle, 'padding', '0')
							]),
						'Enable');
				},
				pageNum: model.disabledPageNum,
				perPage: model.disabledPerPage,
				updatePageMsg: $author$project$Components$SettingsPage$UsersLayout$UpdateDisabledPage,
				updatePerPageMsg: $author$project$Components$SettingsPage$UsersLayout$ChangeDisabledPerPage,
				users: users
			});
	});
var $author$project$Components$SettingsPage$UsersLayout$frameView = F2(
	function (v3ReskinEnabled, _v0) {
		var user = _v0.user;
		var accountSettings = _v0.accountSettings;
		var account = _v0.account;
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Users, account, accountSettings, user);
	});
var $author$project$Components$SettingsPage$UsersLayout$view = F3(
	function (v3ReskinEnabled, model, data) {
		var disabledUsers = data.user.isAdmin ? A2(
			$elm$core$List$filter,
			function ($) {
				return $.isDisabled;
			},
			data.users) : _List_Nil;
		var activeUsers = data.user.isAdmin ? A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				function ($) {
					return $.isDisabled;
				}),
			data.users) : _List_Nil;
		return (!data.user.isAdmin) ? A3(
			$author$project$Components$SettingsPage$UsersLayout$frameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('ERROR: You must be an admin to use this page.')) : (model.isSaving ? A3(
			$author$project$Components$SettingsPage$UsersLayout$frameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('Saving ...')) : A3(
			$author$project$Components$SettingsPage$UsersLayout$frameView,
			v3ReskinEnabled,
			data,
			v3ReskinEnabled ? $author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$Stack$viewVertMaybes,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXLarge)
						]),
					_List_fromArray(
						[
							A4($author$project$Components$SettingsPage$UsersLayout$activeUsersViewV3Reskin, activeUsers, model, data.accountSettings, data.account),
							A4($author$project$Components$SettingsPage$UsersLayout$disabledUsersViewV3Reskin, disabledUsers, model, data.accountSettings, data.account)
						]))) : $author$project$Ui$toHtml(
				A2(
					$author$project$Ui$stack,
					_List_fromArray(
						[$author$project$Ui$between5]),
					_List_fromArray(
						[
							A3($author$project$Components$SettingsPage$UsersLayout$activeUsersView, activeUsers, data.accountSettings, data.account),
							A3($author$project$Components$SettingsPage$UsersLayout$disabledUsersView, disabledUsers, data.accountSettings, data.account),
							A2($author$project$Ui$stack, _List_Nil, _List_Nil)
						])))));
	});
var $author$project$Components$SettingsPage$VerificationsLayout$frameView = F2(
	function (v3ReskinEnabled, _v0) {
		var user = _v0.user;
		var accountSettings = _v0.accountSettings;
		var account = _v0.account;
		return A5($author$project$Components$SettingsPage$Shared$Section$frameView, v3ReskinEnabled, $author$project$Components$SettingsPage$Shared$Section$Verifications, account, accountSettings, user);
	});
var $author$project$Components$SettingsPage$VerificationsLayout$fullWidth = A2($elm$html$Html$Attributes$style, 'width', '100%');
var $author$project$Components$SettingsPage$VerificationsLayout$inNetworkDebtorBody = function (networkBroker) {
	var modeToString = function (mode) {
		switch (mode.$) {
			case 'VerificationsModeFull':
				return 'FULL';
			case 'VerificationsModeRestricted':
				return 'FAILURES ONLY';
			default:
				return 'TEST';
		}
	};
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(networkBroker.name)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', networkBroker.mcNumber))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						modeToString(networkBroker.verificationsMode))
					]))
			]));
};
var $author$project$Components$SettingsPage$VerificationsLayout$inNetworkDebtorHeader = A2(
	$elm$html$Html$thead,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('settings-verifications__debtors')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Debtor')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('settings-verifications__debtors')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('MC Number')
						])),
					A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('settings-verifications__debtors')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Mode')
						]))
				]))
		]));
var $author$project$Components$SettingsPage$VerificationsLayout$loginHeader = A2(
	$elm$html$Html$thead,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Debtor')
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Login')
						]))
				]))
		]));
var $author$project$Components$SettingsPage$VerificationsLayout$EditLogin = function (a) {
	return {$: 'EditLogin', a: a};
};
var $author$project$Components$SettingsPage$VerificationsLayout$LoginForm = F5(
	function (id, debtorId, user, password, saving) {
		return {debtorId: debtorId, id: id, password: password, saving: saving, user: user};
	});
var $author$project$Components$SettingsPage$VerificationsLayout$loginLabelView = F3(
	function (id, user, startEditing) {
		if (id.$ === 'Nothing') {
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('error'),
						A2($elm$html$Html$Attributes$style, 'display', 'inline'),
						$elm$html$Html$Events$onClick(startEditing)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('NONE')
							]))
					]));
		} else {
			return $elm$html$Html$text(user);
		}
	});
var $author$project$Components$SettingsPage$VerificationsLayout$loginDescriptionView = function (login) {
	var loginUser = A2($elm$core$Maybe$withDefault, '', login.loginUser);
	var startEditing = $author$project$Components$SettingsPage$VerificationsLayout$EditLogin(
		A5($author$project$Components$SettingsPage$VerificationsLayout$LoginForm, login.loginId, login.debtorId, loginUser, '', false));
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[$author$project$Components$SettingsPage$VerificationsLayout$fullWidth]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$title('Edit'),
						$elm$html$Html$Events$onClick(startEditing)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-pencil')
							]),
						_List_Nil)
					])),
				$elm$html$Html$text(
				A2($elm$core$String$repeat, 3, $author$project$Helpers$String$nbsp)),
				A3($author$project$Components$SettingsPage$VerificationsLayout$loginLabelView, login.loginId, loginUser, startEditing)
			]));
};
var $author$project$Components$SettingsPage$VerificationsLayout$CancelEditLogin = function (a) {
	return {$: 'CancelEditLogin', a: a};
};
var $author$project$Components$SettingsPage$VerificationsLayout$SaveLogin = function (a) {
	return {$: 'SaveLogin', a: a};
};
var $author$project$Components$Shared$Button$cancel = F3(
	function (buttonText, message, attrs) {
		return A3(
			$author$project$Components$Shared$Button$enabled,
			buttonText,
			message,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('button--cancel'),
				attrs));
	});
var $author$project$Components$SettingsPage$VerificationsLayout$loginFormView = function (form) {
	var inputs = _List_fromArray(
		[
			A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text'),
					$elm$html$Html$Attributes$placeholder('User'),
					$elm$html$Html$Attributes$value(form.user),
					$elm$html$Html$Attributes$disabled(form.saving),
					$elm$html$Html$Events$onInput(
					function (string) {
						return $author$project$Components$SettingsPage$VerificationsLayout$EditLogin(
							_Utils_update(
								form,
								{user: string}));
					})
				]),
			_List_Nil),
			A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('password'),
					$elm$html$Html$Attributes$placeholder('New password'),
					$elm$html$Html$Attributes$disabled(form.saving),
					$elm$html$Html$Events$onInput(
					function (string) {
						return $author$project$Components$SettingsPage$VerificationsLayout$EditLogin(
							_Utils_update(
								form,
								{password: string}));
					})
				]),
			_List_Nil)
		]);
	var buttons = form.saving ? _List_fromArray(
		[
			A2($author$project$Components$Shared$Button$disabled, 'Saving ...', _List_Nil)
		]) : _List_fromArray(
		[
			A3(
			$author$project$Components$Shared$Button$confirm,
			'Save',
			$author$project$Components$SettingsPage$VerificationsLayout$SaveLogin(form.debtorId),
			_List_Nil),
			A3(
			$author$project$Components$Shared$Button$cancel,
			'cancel',
			$author$project$Components$SettingsPage$VerificationsLayout$CancelEditLogin(form.debtorId),
			_List_Nil)
		]);
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[$author$project$Components$SettingsPage$VerificationsLayout$fullWidth]),
		_Utils_ap(inputs, buttons));
};
var $author$project$Components$SettingsPage$VerificationsLayout$loginView = F2(
	function (forms, login) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(login.debtorName)
						])),
					function () {
					var _v0 = A2(
						$elm$core$Dict$get,
						$author$project$Components$SettingsPage$VerificationsLayout$formKey(login.debtorId),
						forms);
					if (_v0.$ === 'Just') {
						var form = _v0.a;
						return $author$project$Components$SettingsPage$VerificationsLayout$loginFormView(form);
					} else {
						return $author$project$Components$SettingsPage$VerificationsLayout$loginDescriptionView(login);
					}
				}()
				]));
	});
var $author$project$Components$SettingsPage$VerificationsLayout$matchedInNetworkDebtorTitle = function (debtors) {
	return 'Matched In-Network Debtors (' + ($elm$core$String$fromInt(
		$elm$core$List$length(debtors)) + ')');
};
var $author$project$Components$SettingsPage$VerificationsLayout$sharedSection = F2(
	function (title, body) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shared__section-body')
						]),
					_List_fromArray(
						[body]))
				]));
	});
var $author$project$Components$SettingsPage$VerificationsLayout$unMatchedInNetworkDebtorTitle = function (debtors) {
	return 'Unmatched In-Network Debtors (' + ($elm$core$String$fromInt(
		$elm$core$List$length(debtors)) + ')');
};
var $author$project$Components$SettingsPage$VerificationsLayout$authorizedView = F3(
	function (v3ReskinEnabled, model, data) {
		return A3(
			$author$project$Components$SettingsPage$VerificationsLayout$frameView,
			v3ReskinEnabled,
			data,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Verifications')
							])),
						A2(
						$author$project$Components$SettingsPage$VerificationsLayout$sharedSection,
						'Portal Logins',
						A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Components$SettingsPage$VerificationsLayout$fullWidth]),
							A2(
								$elm$core$List$cons,
								$author$project$Components$SettingsPage$VerificationsLayout$loginHeader,
								A2(
									$elm$core$List$map,
									$author$project$Components$SettingsPage$VerificationsLayout$loginView(model.loginForms),
									data.logins)))),
						A2(
						$author$project$Components$SettingsPage$VerificationsLayout$sharedSection,
						$author$project$Components$SettingsPage$VerificationsLayout$unMatchedInNetworkDebtorTitle(data.unMatchedDebtors),
						A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('settings-verifications__unmatched-debtors-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('To match these debtors, add the MC numbers in your factoring application.')
								]))),
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[$author$project$Components$SettingsPage$VerificationsLayout$fullWidth]),
						A2(
							$elm$core$List$cons,
							$author$project$Components$SettingsPage$VerificationsLayout$inNetworkDebtorHeader,
							A2($elm$core$List$map, $author$project$Components$SettingsPage$VerificationsLayout$inNetworkDebtorBody, data.unMatchedDebtors))),
						A2(
						$author$project$Components$SettingsPage$VerificationsLayout$sharedSection,
						$author$project$Components$SettingsPage$VerificationsLayout$matchedInNetworkDebtorTitle(data.matchedDebtors),
						A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Components$SettingsPage$VerificationsLayout$fullWidth]),
							A2(
								$elm$core$List$cons,
								$author$project$Components$SettingsPage$VerificationsLayout$inNetworkDebtorHeader,
								A2($elm$core$List$map, $author$project$Components$SettingsPage$VerificationsLayout$inNetworkDebtorBody, data.matchedDebtors))))
					])));
	});
var $author$project$Components$SettingsPage$VerificationsLayout$view = F3(
	function (v3ReskinEnabled, model, data) {
		return data.user.hasSettingsRole ? A3($author$project$Components$SettingsPage$VerificationsLayout$authorizedView, v3ReskinEnabled, model, data) : A3(
			$author$project$Components$SettingsPage$VerificationsLayout$frameView,
			v3ReskinEnabled,
			data,
			$elm$html$Html$text('ERROR: You must have settings access to view this page. Please contact your supervisor if you need access.'));
	});
var $author$project$Factoring$Page$ClientSubmission$view = function (model) {
	var _v0 = model.loadingError;
	if (_v0.$ === 'Nothing') {
		return $author$project$Forward$LoadingView$defaultLoadingView;
	} else {
		var error = _v0.a;
		return $author$project$Forward$LoadingView$defaultErrorView(error);
	}
};
var $author$project$Factoring$Page$ClientSubmission$Header$Active = function (a) {
	return {$: 'Active', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Header$Disabled = function (a) {
	return {$: 'Disabled', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$HideFundingNotes = {$: 'HideFundingNotes'};
var $author$project$Factoring$Page$ClientSubmission$Header$Link = F2(
	function (a, b) {
		return {$: 'Link', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmission$Header$Model = F4(
	function (accountSettings, batchData, presence, allGroupsUnreviewed) {
		return {accountSettings: accountSettings, allGroupsUnreviewed: allGroupsUnreviewed, batchData: batchData, presence: presence};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$empty = $elm$html$Html$text('');
var $author$project$Factoring$Page$ClientSubmissionInvoice$fundingNotesModalConfig = F2(
	function (carrierName, notesText) {
		return {
			body: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('client-submission__funding-notes--text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(notesText)
					])),
			confirm: $elm$core$Maybe$Nothing,
			dismissText: $elm$core$Maybe$Just('Continue'),
			header: $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-submission__funding-notes--header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Funding Notes')
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('client-submission__funding-notes--header__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(carrierName)
								]))
						]))),
			modalClassOverride: $elm$core$Maybe$Nothing,
			performing: false,
			performingText: $elm$core$Maybe$Nothing,
			success: false,
			successText: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$getFullyReviewed = function (data) {
	var _v0 = $author$project$Forward$Remote$toMaybe(data.hasUnreviewedGroups);
	if (_v0.$ === 'Just') {
		var unreviewedGroups = _v0.a;
		return !unreviewedGroups;
	} else {
		return false;
	}
};
var $author$project$Factoring$Page$ClientSubmission$CacheData$loadingErrorToString = function (loadingError) {
	if (loadingError.$ === 'MissingInvoice') {
		return 'Missing invoice';
	} else {
		var clientTerm = loadingError.a.clientTerm;
		return 'Missing ' + clientTerm;
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$shouldDisplayFundingNotesFromSettings = function (settings) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.displayCadenceFundingNotes;
			},
			settings));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$shouldDisplayFundingNotes = F2(
	function (data, model) {
		var showIfNotAlreadyDismissed = A2($elm$core$Maybe$withDefault, false, model.userRequestsViewFundingNotes) || (!model.dismissFundingNotes);
		var showIfAllowed = function () {
			var _v0 = model.userRequestsViewFundingNotes;
			if (_v0.$ === 'Nothing') {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					$author$project$Forward$Remote$toMaybe(data.hasUnreviewedGroups));
			} else {
				var userRequest = _v0.a;
				return userRequest;
			}
		}();
		var allowedByAccount = $author$project$Factoring$Page$ClientSubmissionInvoice$shouldDisplayFundingNotesFromSettings(
			$author$project$Forward$Remote$toMaybe(data.accountSettings));
		return showIfNotAlreadyDismissed && (allowedByAccount && showIfAllowed);
	});
var $author$project$Factoring$Page$ClientSubmission$Header$IgnoreAllGroups = function (a) {
	return {$: 'IgnoreAllGroups', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Header$IgnoreEmail = function (a) {
	return {$: 'IgnoreEmail', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Header$viewIgnoreButton = F2(
	function (accountSettings, emailMessage) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			$author$project$AuditPb$IgnoreModeSubmissionsWorkflowNoIgnore,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ignoreMode;
				},
				accountSettings));
		if (_v0.$ === 'IgnoreModeSubmissionsWorkflowNoIgnore') {
			return $elm$html$Html$text('');
		} else {
			var _v1 = _Utils_Tuple2(emailMessage.documentBatchId, emailMessage.id);
			if (_v1.a.$ === 'Just') {
				var documentBatchId = _v1.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indexer-header__right-action-area')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indexer-header__ignore-link button--cancel'),
									$elm$html$Html$Events$onClick(
									$author$project$Factoring$Page$ClientSubmission$Header$IgnoreAllGroups(documentBatchId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Ignore All Groups')
								]))
						]));
			} else {
				var _v2 = _v1.a;
				var emailMessageId = _v1.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indexer-header__right-action-area')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indexer-header__ignore-link button--cancel'),
									$elm$html$Html$Events$onClick(
									$author$project$Factoring$Page$ClientSubmission$Header$IgnoreEmail(emailMessageId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Ignore This Email')
								]))
						]));
			}
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Header$viewOrgName = function (carrier) {
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('indexer-header__carrier-label'),
										$elm$html$Html$Attributes$title('The Organization associated with this email address')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount) + ': ')
									]))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'Unknown',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.name;
										},
										carrier)))
							]))
					]))
			]));
};
var $author$project$Factoring$Page$ClientSubmission$Header$isLast = F2(
	function (list, index) {
		return _Utils_eq(
			index,
			$elm$core$List$length(list) - 1);
	});
var $author$project$Factoring$Page$ClientSubmission$Header$GoTo = function (a) {
	return {$: 'GoTo', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Header$viewStepHelp = F4(
	function (last, activeClass, node, label) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indexer-progress__item ' + activeClass)
				]),
			_List_fromArray(
				[
					node(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indexer-progress__indicator')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indexer-progress__indicator-inner')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							last ? $elm$html$Html$text('') : A2(
							$elm$html$Html$hr,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indexer-progress__trailer')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmission$Header$viewStep = F2(
	function (last, step) {
		switch (step.$) {
			case 'Disabled':
				var label = step.a;
				return A4(
					$author$project$Factoring$Page$ClientSubmission$Header$viewStepHelp,
					last,
					'',
					$elm$html$Html$div(_List_Nil),
					label);
			case 'Active':
				var label = step.a;
				return A4(
					$author$project$Factoring$Page$ClientSubmission$Header$viewStepHelp,
					last,
					'indexer-progress__item__active',
					$elm$html$Html$div(_List_Nil),
					label);
			default:
				var label = step.a;
				var url = step.b;
				return A4(
					$author$project$Factoring$Page$ClientSubmission$Header$viewStepHelp,
					last,
					'',
					A3(
						$author$project$Helpers$GenericLink$genericLink,
						$author$project$Factoring$Page$ClientSubmission$Header$GoTo(url),
						_List_Nil,
						url),
					label);
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Header$viewProgress = function (steps) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('document-indexer__progress')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('indexer-progress__container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('indexer-progress__list')
							]),
						A2(
							$elm$core$List$indexedMap,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Factoring$Page$ClientSubmission$Header$viewStep,
								$author$project$Factoring$Page$ClientSubmission$Header$isLast(steps)),
							steps))
					]))
			]));
};
var $author$project$Factoring$Page$ClientSubmission$Header$view = F4(
	function (toMsg, tz, model, steps) {
		var presenceIndicators = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Presence$viewInLine(false),
				model.presence));
		var maybeTmsCarrier = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.tmsCarrier;
			},
			model.batchData);
		var maybeEmailMessage = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.emailMessage;
			},
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.loadedCore;
				},
				model.batchData));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					toMsg,
					function () {
						if (maybeEmailMessage.$ === 'Just') {
							var emailMessage = maybeEmailMessage.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('document-indexer__header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('indexer-header__subject-area')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('indexer-header__subject')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(emailMessage.subject)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('indexer-header__sender-address')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(emailMessage.senderAddress)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('indexer-header__action-area')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('indexer-header__date-area')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('indexer-header__date-time')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('indexer-header__date')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($author$project$Helpers$Date$dateString, tz, emailMessage.createdAt))
																	])),
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('indexer-header__time')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		' ' + A2($author$project$Helpers$Date$timeString, tz, emailMessage.createdAt))
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('indexer-header__carrier-area')
															]),
														_List_fromArray(
															[
																$author$project$Factoring$Page$ClientSubmission$Header$viewOrgName(maybeTmsCarrier)
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('indexer-header__center-action-area')
													]),
												_List_fromArray(
													[
														function () {
														var _v1 = model.accountSettings;
														if (_v1.$ === 'Just') {
															var settings = _v1.a;
															return (!settings.disableOutgoingEmailsInSubmissionWorkflow) ? A2(
																$elm$html$Html$button,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('indexer-header__view-email')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Forward Email')
																	])) : $elm$html$Html$text('');
														} else {
															return $elm$html$Html$text('');
														}
													}()
													])),
												model.allGroupsUnreviewed ? A2($author$project$Factoring$Page$ClientSubmission$Header$viewIgnoreButton, model.accountSettings, emailMessage) : $elm$html$Html$text('')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('indexer-header__presence-area')
											]),
										presenceIndicators)
									]));
						} else {
							return $author$project$Helpers$Html$empty;
						}
					}()),
					A2(
					$elm$html$Html$map,
					toMsg,
					$author$project$Factoring$Page$ClientSubmission$Header$viewProgress(steps))
				]));
	});
var $author$project$Indexer$DocumentBrowser$All = {$: 'All'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$Select = function (a) {
	return {$: 'Select', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$SelectSecondary = function (a) {
	return {$: 'SelectSecondary', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$SetHover = function (a) {
	return {$: 'SetHover', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Change$MoveDocument = F2(
	function (a, b) {
		return {$: 'MoveDocument', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$getDocument = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($author$project$Indexer$Group$getDocument, x.groupedDocuments, model.selection);
			},
			$author$project$Forward$Remote$toMaybe(data.pageData.documentPagesData));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$moveDocumentToGroup = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$map,
			F2(
				function (document, direction) {
					return $author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
						A2($author$project$Factoring$Page$ClientSubmission$Change$MoveDocument, document.id, direction));
				}),
			A2($author$project$Factoring$Page$ClientSubmissionInvoice$getDocument, data, model));
	});
var $author$project$Factoring$Page$ClientSubmission$Change$RotatePage = F2(
	function (a, b) {
		return {$: 'RotatePage', a: a, b: b};
	});
var $author$project$Indexer$Group$getDocumentPage = F2(
	function (grouped, selection) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.page;
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pages;
					},
					$author$project$Indexer$Group$getAt(selection.page)),
				A2($author$project$Indexer$Group$get, grouped, selection)));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$getDocumentPage = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($author$project$Indexer$Group$getDocumentPage, x.groupedDocuments, model.selection);
			},
			$author$project$Forward$Remote$toMaybe(data.pageData.documentPagesData));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$rotatePage = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$map,
			F2(
				function (page, amount) {
					return $author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
						A2(
							$author$project$Factoring$Page$ClientSubmission$Change$RotatePage,
							page.id,
							A2($elm$core$Basics$modBy, 360, page.rotation + amount)));
				}),
			A2($author$project$Factoring$Page$ClientSubmissionInvoice$getDocumentPage, data, model));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$documentName = function (accountSettings) {
	return A2($author$project$Domain$UnresolvedDocumentType$toString, accountSettings.customDocumentTypeNames, $author$project$Domain$Environment$FactorEnvironment);
};
var $author$project$Factoring$Page$ClientSubmission$Change$hasDocumentType = $elm$core$List$any(
	function (change) {
		if (change.$ === 'DocumentType') {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$bem = function (elementModifier) {
	return $elm$html$Html$Attributes$class('client-submission__' + elementModifier);
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$inlineWaitingSpinner = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$author$project$Factoring$Page$ClientSubmissionInvoice$bem('document-type-spinner')
		]),
	_List_fromArray(
		[$author$project$Helpers$WaitingSpinner$rawSpinner]));
var $author$project$Factoring$Page$ClientSubmissionInvoice$maybe = F3(
	function (_default, f, m) {
		if (m.$ === 'Just') {
			var x = m.a;
			return f(x);
		} else {
			return _default;
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Change$DocumentType = F2(
	function (a, b) {
		return {$: 'DocumentType', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewEditDocumentTypeDropdown = F2(
	function (document, selection) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$author$project$Factoring$Page$ClientSubmissionInvoice$bem('document-type-dropdown'),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange,
							$author$project$Factoring$Page$ClientSubmission$Change$DocumentType(document.id)),
						A2(
							$author$project$Helpers$Json$Decode$enum,
							$elm$html$Html$Events$targetValue,
							A2(
								$elm$core$List$map,
								function (_v0) {
									var tag = _v0.a;
									var documentType = _v0.b;
									return _Utils_Tuple2(
										tag,
										$author$project$Domain$UnresolvedDocumentType$Resolved(documentType));
								},
								selection))))
				]),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var x = _v1.a;
					var docType = _v1.b;
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('client-submission__document-type-option'),
								$elm$html$Html$Attributes$value(x),
								$elm$html$Html$Attributes$selected(
								_Utils_eq(
									$author$project$Domain$UnresolvedDocumentType$Resolved(docType),
									$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(x)
							]));
				},
				A2($elm$core$List$sortBy, $elm$core$Tuple$first, selection)));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewEditDocumentType = F3(
	function (data, model, document) {
		var _v0 = $author$project$Forward$Remote$toMaybe(data.accountSettings);
		if (_v0.$ === 'Just') {
			var accountSettings = _v0.a;
			var readonly = A3(
				$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
				true,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.invoice;
					},
					function ($) {
						return $.readonly;
					}),
				$elm$core$Result$toMaybe(data.submission));
			var isUnknown = _Utils_eq(
				$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue),
				$author$project$Domain$UnresolvedDocumentType$Unknown);
			return (readonly || isUnknown) ? $elm$html$Html$text(
				A2(
					$author$project$Factoring$Page$ClientSubmissionInvoice$documentName,
					accountSettings,
					$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue))) : ($author$project$Factoring$Page$ClientSubmission$Change$hasDocumentType(model.changes) ? $author$project$Factoring$Page$ClientSubmissionInvoice$inlineWaitingSpinner : A2(
				$author$project$Factoring$Page$ClientSubmissionInvoice$viewEditDocumentTypeDropdown,
				document,
				A3(
					$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
					_List_Nil,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.enabledDocumentTypeNames;
						},
						$elm$core$List$map(
							function (x) {
								return _Utils_Tuple2(
									A2(
										$author$project$Factoring$Page$ClientSubmissionInvoice$documentName,
										accountSettings,
										$author$project$Domain$UnresolvedDocumentType$Resolved(x.documentType)),
									x.documentType);
							})),
					$author$project$Forward$Remote$toMaybe(data.documentTypeSettings))));
		} else {
			return $author$project$Factoring$Page$ClientSubmissionInvoice$inlineWaitingSpinner;
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$documentBrowserEvents = F2(
	function (data, model) {
		return {
			close: $elm$core$Maybe$Nothing,
			editType: $elm$core$Maybe$Just(
				A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewEditDocumentType, data, model)),
			filter: $author$project$Indexer$DocumentBrowser$All,
			internal: $author$project$Factoring$Page$ClientSubmissionInvoice$DocumentBrowserMsg,
			moveDocument: A2($author$project$Factoring$Page$ClientSubmissionInvoice$moveDocumentToGroup, data, model),
			rotatePage: A2($author$project$Factoring$Page$ClientSubmissionInvoice$rotatePage, data, model),
			selectPrimary: $author$project$Factoring$Page$ClientSubmissionInvoice$Select,
			selectSecondary: $author$project$Factoring$Page$ClientSubmissionInvoice$SelectSecondary,
			setHover: $author$project$Factoring$Page$ClientSubmissionInvoice$SetHover
		};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$CloseSecondary = {$: 'CloseSecondary'};
var $author$project$Indexer$DocumentBrowser$InGroup = function (a) {
	return {$: 'InGroup', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$documentBrowserSecondaryEvents = F3(
	function (data, model, group) {
		return {
			close: $elm$core$Maybe$Just($author$project$Factoring$Page$ClientSubmissionInvoice$CloseSecondary),
			editType: $elm$core$Maybe$Just(
				A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewEditDocumentType, data, model)),
			filter: $author$project$Indexer$DocumentBrowser$InGroup(group),
			internal: $author$project$Factoring$Page$ClientSubmissionInvoice$DocumentBrowserSecondaryMsg,
			moveDocument: A2($author$project$Factoring$Page$ClientSubmissionInvoice$moveDocumentToGroup, data, model),
			rotatePage: A2($author$project$Factoring$Page$ClientSubmissionInvoice$rotatePage, data, model),
			selectPrimary: $author$project$Factoring$Page$ClientSubmissionInvoice$SelectSecondary,
			selectSecondary: $author$project$Factoring$Page$ClientSubmissionInvoice$SelectSecondary,
			setHover: $author$project$Factoring$Page$ClientSubmissionInvoice$SetHover
		};
	});
var $author$project$Indexer$DocumentBrowser$empty = $elm$html$Html$text('');
var $author$project$Indexer$DocumentBrowser$findAt2 = F2(
	function (first, second) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Indexer$DocumentBrowser$findAt(first),
			$elm$core$Maybe$andThen(
				$author$project$Indexer$DocumentBrowser$findAt(second)));
	});
var $author$project$Indexer$DocumentBrowser$viewDocumentHeader = F5(
	function (events, selected, account, accountSettings, groupedDocuments) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				var _v0 = A3($author$project$Indexer$DocumentBrowser$findAt2, selected.group, selected.document, groupedDocuments);
				if (_v0.$ === 'Nothing') {
					return _List_Nil;
				} else {
					var document = _v0.a.document;
					return _List_fromArray(
						[
							function () {
							var _v1 = events.editType;
							if (_v1.$ === 'Nothing') {
								return $elm$html$Html$text(
									A3(
										$author$project$Domain$Helpers$documentTypeToString,
										account,
										accountSettings,
										$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue)));
							} else {
								var edit = _v1.a;
								return edit(document);
							}
						}()
						]);
				}
			}());
	});
var $author$project$Indexer$DocumentBrowser$onlyOneDocumentInGroup = F2(
	function (selected, groupedDocuments) {
		var thisDocumentGroup = A2($author$project$Indexer$Group$getDocumentsInGroup, groupedDocuments, selected);
		return $elm$core$List$length(thisDocumentGroup) === 1;
	});
var $author$project$Indexer$DocumentBrowser$shouldShowGroupMovementButtons = F3(
	function (accountSettings, selected, groupedDocuments) {
		return accountSettings.showGroupMovementButtonsInSubmissionWorkflow && (!A2($author$project$Indexer$DocumentBrowser$onlyOneDocumentInGroup, selected, groupedDocuments));
	});
var $author$project$Indexer$DocumentBrowser$showIf = F2(
	function (flag, view_) {
		return flag ? view_ : $author$project$Indexer$DocumentBrowser$empty;
	});
var $author$project$Indexer$DocumentBrowser$indexedMap2 = function (f) {
	var recurse = F4(
		function (i, acc, a, b) {
			recurse:
			while (true) {
				var _v0 = _Utils_Tuple2(a, b);
				if (_v0.a.b && _v0.b.b) {
					var _v1 = _v0.a;
					var firstA = _v1.a;
					var restA = _v1.b;
					var _v2 = _v0.b;
					var firstB = _v2.a;
					var restB = _v2.b;
					var $temp$i = i + 1,
						$temp$acc = A2(
						$elm$core$List$cons,
						A3(f, i, firstA, firstB),
						acc),
						$temp$a = restA,
						$temp$b = restB;
					i = $temp$i;
					acc = $temp$acc;
					a = $temp$a;
					b = $temp$b;
					continue recurse;
				} else {
					return $elm$core$List$reverse(acc);
				}
			}
		});
	return A2(recurse, 0, _List_Nil);
};
var $author$project$Indexer$DocumentBrowser$groupContext = 'group-document';
var $author$project$Indexer$DocumentBrowser$hideDocument = F3(
	function (group, _v0, filter) {
		if (filter.$ === 'All') {
			return false;
		} else {
			var i = filter.a;
			return !_Utils_eq(group, i);
		}
	});
var $author$project$Indexer$DocumentBrowser$noAttr = $elm$html$Html$Attributes$class('');
var $author$project$Indexer$DocumentBrowser$keyedDiv = $elm$html$Html$Keyed$node('div');
var $author$project$Indexer$DocumentBrowser$viewThumbnail = F2(
	function (idPrefix, config) {
		var _v0 = config.ocr.page.thumbnailUrl;
		if (_v0.$ === 'Nothing') {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-thumbnail__blank-page')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No Preview Available')
					]));
		} else {
			var url = _v0.a;
			var isSelected = A2($author$project$Indexer$Group$samePage, config._this, config.selected);
			return A2(
				$author$project$Indexer$DocumentBrowser$keyedDiv,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('scroll-anchor-container')
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'anchor',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('scroll-anchor'),
									isSelected ? $elm$html$Html$Attributes$id(
									$author$project$Indexer$DocumentBrowser$thumbnailSelectedId(idPrefix)) : $author$project$Indexer$DocumentBrowser$noAttr
								]),
							_List_Nil)),
						_Utils_Tuple2(
						url,
						A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(url),
									$elm$html$Html$Attributes$draggable('false'),
									A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('document-thumbnail__page', true),
											_Utils_Tuple2('document-thumbnail__page--selected', isSelected)
										])),
									$elm$html$Html$Events$onClick(config.onClick),
									A2(
									$elm$html$Html$Events$preventDefaultOn,
									'contextmenu',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(config.onRightClick, true)))
								]),
							_List_Nil))
					]));
		}
	});
var $author$project$Indexer$DocumentBrowser$viewDocumentPageThumbnail = F7(
	function (idPrefix, events, selected, group, document, page, ocr) {
		var _this = _Utils_update(
			$author$project$Indexer$Group$firstSelection,
			{document: document, group: group, page: page});
		return A2(
			$author$project$Indexer$DocumentBrowser$viewThumbnail,
			idPrefix,
			{
				ocr: ocr,
				onClick: events.selectPrimary(_this),
				onRightClick: events.selectSecondary(_this),
				selected: selected,
				_this: _this
			});
	});
var $author$project$Indexer$DocumentBrowser$viewDocumentThumbnail = F8(
	function (idPrefix, events, account, accountSettings, selected, group, index, _v0) {
		var pages = _v0.pages;
		var document = _v0.document;
		return A3($author$project$Indexer$DocumentBrowser$hideDocument, group, document.id, events.filter) ? $author$project$Indexer$DocumentBrowser$empty : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-thumbnail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-drag', $author$project$Indexer$DocumentBrowser$groupContext),
							$elm$html$Html$Attributes$title(
							$elm$core$String$fromInt(
								$author$project$Domain$DocumentId$toInt(document.id))),
							function () {
							var _v1 = events.filter;
							if (_v1.$ === 'All') {
								return $author$project$Indexer$DocumentBrowser$noAttr;
							} else {
								return $author$project$Indexer$DocumentBrowser$noAttr;
							}
						}()
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-thumbnail__title'),
									$elm$html$Html$Events$onClick(
									events.selectPrimary(
										_Utils_update(
											$author$project$Indexer$Group$firstSelection,
											{document: index, group: group})))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$author$project$Domain$Helpers$documentTypeToString,
										account,
										accountSettings,
										$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-thumbnail__pages')
								]),
							A2(
								$elm$core$List$indexedMap,
								A5($author$project$Indexer$DocumentBrowser$viewDocumentPageThumbnail, idPrefix, events, selected, group, index),
								pages))
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewDisplayStatus = function (status) {
	var wrapper = F2(
		function (modifier, label) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__collapsed-list-load_ids-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('document-browser__collapsed-list-load_ids'),
								$elm$html$Html$Attributes$class('document-browser__collapsed-list-load_ids-' + modifier)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					]));
		});
	if (status.$ === 'Nothing') {
		return $elm$html$Html$text('');
	} else {
		if (status.a.$ === 'DocumentGroup_DisplayStatusApproved') {
			var _v1 = status.a;
			return A2(wrapper, 'approved', 'Approved');
		} else {
			var _v2 = status.a;
			return A2(wrapper, 'exception', 'Rejected');
		}
	}
};
var $author$project$Indexer$DocumentBrowser$viewGroupHeader = F2(
	function (index, extra) {
		return A2(
			$elm$html$Html$h6,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__group-heading')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Group'),
							$elm$html$Html$text($author$project$Helpers$String$nbsp),
							$elm$html$Html$text(
							$elm$core$String$fromInt(index + 1))
						])),
					extra
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewCollapsedList = F4(
	function (events, index, group, browsables) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__collapsed-list'),
							$elm$html$Html$Events$onClick(
							events.selectPrimary(
								_Utils_update(
									$author$project$Indexer$Group$firstSelection,
									{group: index})))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Indexer$DocumentBrowser$viewGroupHeader,
							index,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('document-browser__collapsed-list-link')
									]),
								_List_Nil)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-browser__collapsed-list-documents')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Helpers$String$pluralize,
										{many: 'documents', one: 'document'},
										$elm$core$List$length(browsables)))
								]))
						])),
					$author$project$Indexer$DocumentBrowser$viewDisplayStatus(group.displayStatus)
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewGroupedDocumentThumbnails = F8(
	function (idPrefix, events, selected, account, accountSettings, index, group, browsables) {
		var thumbnails = A2(
			$elm$core$List$indexedMap,
			A6($author$project$Indexer$DocumentBrowser$viewDocumentThumbnail, idPrefix, events, account, accountSettings, selected, index),
			browsables);
		var attrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('document-browser__list-item'),
				$elm$html$Html$Attributes$id(
				A2($author$project$Indexer$DocumentBrowser$groupId, idPrefix, index))
			]);
		var filteredAttrs = A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('document-browser__list-item--filtered'),
			attrs);
		var _v0 = events.filter;
		if (_v0.$ === 'InGroup') {
			return A2($elm$html$Html$div, filteredAttrs, thumbnails);
		} else {
			return A2(
				$elm$html$Html$div,
				attrs,
				(!_Utils_eq(selected.group, index)) ? _List_fromArray(
					[
						A4($author$project$Indexer$DocumentBrowser$viewCollapsedList, events, index, group, browsables)
					]) : A2(
					$elm$core$List$cons,
					A2($author$project$Indexer$DocumentBrowser$viewGroupHeader, index, $author$project$Indexer$DocumentBrowser$empty),
					thumbnails));
		}
	});
var $author$project$Indexer$DocumentBrowser$viewDocumentGroups = F6(
	function (idPrefix, events, selected, account, accountSettings, info) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-thumbnail-list')
				]),
			function () {
				var _v0 = info.groupedDocuments;
				if (_v0.b && (!_v0.b.b)) {
					var onlyOne = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						A6($author$project$Indexer$DocumentBrowser$viewDocumentThumbnail, idPrefix, events, account, accountSettings, selected, 0),
						onlyOne);
				} else {
					return A3(
						$author$project$Indexer$DocumentBrowser$indexedMap2,
						A5($author$project$Indexer$DocumentBrowser$viewGroupedDocumentThumbnails, idPrefix, events, selected, account, accountSettings),
						info.documentGroups,
						info.groupedDocuments);
				}
			}());
	});
var $author$project$Indexer$DocumentBrowser$MainImageLoaded = {$: 'MainImageLoaded'};
var $author$project$Indexer$DocumentBrowser$percent = function (n) {
	return $elm$core$String$fromFloat(n * 100) + '%';
};
var $author$project$Indexer$DocumentBrowser$viewLineHandle = F5(
	function (idPrefix, hoveredValue, _v0, selected, line) {
		var setHover = _v0.setHover;
		var boxClassPrefix = A2($author$project$Domain$DocumentPageLine$matchOnChars, hoveredValue, line) ? 'o-t o-h ' : 'o-t ';
		var boxClass = function () {
			var _v1 = A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							$elm$core$Basics$eq(line)),
						selected.lines)));
			if (_v1.$ === 'Nothing') {
				return '';
			} else {
				switch (_v1.a.$) {
					case 'Primary':
						var _v2 = _v1.a;
						return $author$project$Indexer$DocumentBrowser$highlightSelectedId(idPrefix);
					case 'Secondary':
						var _v3 = _v1.a;
						return 'o-t--selected-caution';
					default:
						var _v4 = _v1.a;
						return 'o-t--selected-caution';
				}
			}
		}();
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					_Utils_ap(boxClassPrefix, boxClass)),
					A2($elm$html$Html$Attributes$attribute, 'data-drag', $author$project$Indexer$DocumentBrowser$documentLineContext),
					A2(
					$elm$html$Html$Attributes$style,
					'top',
					$author$project$Indexer$DocumentBrowser$percent(line.top)),
					A2(
					$elm$html$Html$Attributes$style,
					'left',
					$author$project$Indexer$DocumentBrowser$percent(line.left)),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$author$project$Indexer$DocumentBrowser$percent(line.height)),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$author$project$Indexer$DocumentBrowser$percent(line.width)),
					$elm$html$Html$Attributes$title(line.chars),
					$elm$html$Html$Events$onMouseEnter(
					setHover(
						$elm$core$Maybe$Just(line.chars))),
					$elm$html$Html$Events$onMouseLeave(
					setHover($elm$core$Maybe$Nothing))
				]),
			_List_Nil);
	});
var $author$project$Indexer$DocumentBrowser$UpdatePod = F2(
	function (a, b) {
		return {$: 'UpdatePod', a: a, b: b};
	});
var $author$project$Indexer$DocumentBrowser$viewPodElement = F3(
	function (accountSettings, document, events) {
		return A2(
			$author$project$Helpers$DocumentType$allowedAsPod,
			accountSettings,
			$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue)) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__pod-status-checkbox'),
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$id('use-as-pod'),
						$elm$html$Html$Attributes$checked(document.includesPOD),
						$elm$html$Html$Events$onClick(
						events.internal(
							A2($author$project$Indexer$DocumentBrowser$UpdatePod, document.id, !document.includesPOD)))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__pod-status-label'),
						$elm$html$Html$Attributes$for('use-as-pod')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Signed: Use as Proof of Delivery')
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$em,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('This document type may not be used as a proof of delivery.')
					]))
			]);
	});
var $author$project$Indexer$DocumentBrowser$viewPodStatus = F3(
	function (accountSettings, document, events) {
		return accountSettings.enablePODInSubmissionWorkflow ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__pod-status')
				]),
			A3($author$project$Indexer$DocumentBrowser$viewPodElement, accountSettings, document, events)) : $elm$html$Html$text('');
	});
var $author$project$Indexer$DocumentBrowser$viewSelectedPage = F7(
	function (accountSettings, idPrefix, hoveredValue, events, selected, size, maybeBrowsable) {
		var maybePage = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Indexer$DocumentBrowser$findAt(selected.page),
				function ($) {
					return $.pages;
				}),
			maybeBrowsable);
		var maybeDocument = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.document;
			},
			maybeBrowsable);
		var podStatus = function () {
			if (maybeDocument.$ === 'Nothing') {
				return $elm$html$Html$text('');
			} else {
				var document = maybeDocument.a;
				return A3($author$project$Indexer$DocumentBrowser$viewPodStatus, accountSettings, document, events);
			}
		}();
		if (maybePage.$ === 'Nothing') {
			return $elm$html$Html$text('No Document Selected');
		} else {
			var lines = maybePage.a.lines;
			var page = maybePage.a.page;
			var fullOrPreviewUrl = function () {
				if (size.$ === 'Expanded') {
					return page.fullUrl;
				} else {
					return page.previewUrl;
				}
			}();
			if (fullOrPreviewUrl.$ === 'Nothing') {
				return $elm$html$Html$text('No Preview Available');
			} else {
				var url = fullOrPreviewUrl.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__page-toolbar')
						]),
					_List_fromArray(
						[
							podStatus,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ocred-document__wrapper--enabled'),
									$elm$html$Html$Attributes$class('document-browser__main-image-wrapper'),
									$elm$html$Html$Attributes$class('document-browser__main-image-wrapper--scrollable')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('document-browser__main-image-scroll-anchor')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(url),
													$elm$html$Html$Attributes$draggable('false'),
													A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous'),
													$elm$html$Html$Attributes$id(
													$author$project$Indexer$DocumentBrowser$mainImageId(idPrefix)),
													$elm$html$Html$Attributes$class('document-browser__main-image-selected'),
													$author$project$Experimental$OnLoad$event(
													events.internal($author$project$Indexer$DocumentBrowser$MainImageLoaded))
												]),
											_List_Nil),
										A2(
											$elm$core$List$map,
											A4($author$project$Indexer$DocumentBrowser$viewLineHandle, idPrefix, hoveredValue, events, selected),
											lines)))
								]))
						]));
			}
		}
	});
var $author$project$Api$Documents$Next = {$: 'Next'};
var $author$project$Api$Documents$Previous = {$: 'Previous'};
var $author$project$Indexer$Group$isFirstGroup = function (currentSelection) {
	return !currentSelection.group;
};
var $author$project$Indexer$Group$isLastGroup = F2(
	function (currentSelection, groups) {
		return _Utils_eq(
			currentSelection.group,
			$elm$core$List$length(groups) - 1);
	});
var $author$project$Indexer$DocumentBrowser$viewMoveGroupButtons = F4(
	function (selection, groups, isUpdatingGroups, moveGroupEvent) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__move_group_buttons')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Indexer$DocumentBrowser$showIf,
					!$author$project$Indexer$Group$isFirstGroup(selection),
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button document-browser__move-group-button'),
								$elm$html$Html$Attributes$disabled(isUpdatingGroups),
								$elm$html$Html$Events$onClick(
								moveGroupEvent($author$project$Api$Documents$Previous))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Move to Previous Group')
							]))),
					A2(
					$author$project$Indexer$DocumentBrowser$showIf,
					!A2($author$project$Indexer$Group$isLastGroup, selection, groups),
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button document-browser__move-group-button'),
								$elm$html$Html$Attributes$disabled(isUpdatingGroups),
								$elm$html$Html$Events$onClick(
								moveGroupEvent($author$project$Api$Documents$Next))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Move to Next Group')
							])))
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewSubNav = F4(
	function (selection, groups, events, isUpdatingGroups) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__sub-nav')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$div, _List_Nil, _List_Nil),
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Indexer$DocumentBrowser$empty,
					A2(
						$elm$core$Maybe$map,
						A3($author$project$Indexer$DocumentBrowser$viewMoveGroupButtons, selection, groups, isUpdatingGroups),
						events.moveDocument))
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewDocumentTab = F9(
	function (idPrefix, hoveredValue, events, selected, account, accountSettings, info, size, isUpdatingGroups) {
		var shouldShowMovementButtons = A3($author$project$Indexer$DocumentBrowser$shouldShowGroupMovementButtons, accountSettings, selected, info.groupedDocuments);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__main-image-container')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Indexer$DocumentBrowser$showIf,
							shouldShowMovementButtons,
							A4($author$project$Indexer$DocumentBrowser$viewSubNav, selected, info.groupedDocuments, events, isUpdatingGroups)),
							A7(
							$author$project$Indexer$DocumentBrowser$viewSelectedPage,
							accountSettings,
							idPrefix,
							hoveredValue,
							events,
							selected,
							size,
							A3($author$project$Indexer$DocumentBrowser$findAt2, selected.group, selected.document, info.groupedDocuments))
						])),
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('document-browser__document-list'),
						function () {
							var _v0 = events.filter;
							if (_v0.$ === 'All') {
								return _List_Nil;
							} else {
								return _List_Nil;
							}
						}()),
					_List_fromArray(
						[
							A6($author$project$Indexer$DocumentBrowser$viewDocumentGroups, idPrefix, events, selected, account, accountSettings, info)
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$Activity = {$: 'Activity'};
var $author$project$Indexer$DocumentBrowser$Expanded = {$: 'Expanded'};
var $author$project$Indexer$DocumentBrowser$Message = {$: 'Message'};
var $author$project$Indexer$DocumentBrowser$SetSize = function (a) {
	return {$: 'SetSize', a: a};
};
var $author$project$Indexer$DocumentBrowser$viewArrows = F4(
	function (events, icon, name, size) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__header-expand_browser'),
					$elm$html$Html$Attributes$title(name + ($author$project$Helpers$String$nbsp + 'Document Browser')),
					$elm$html$Html$Events$onClick(
					events.internal(
						$author$project$Indexer$DocumentBrowser$SetSize(size)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-arrows-' + icon)
						]),
					_List_Nil)
				]));
	});
var $author$project$Indexer$DocumentBrowser$focusable = F2(
	function (attrs, children) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$tabindex(-1),
				attrs),
			children);
	});
var $author$project$Indexer$DocumentBrowser$viewImageMenu = function (turn) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('document-browser__header-image-menu')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Indexer$DocumentBrowser$focusable,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-list')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('document-browser__header-image-menu-content')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Indexer$DocumentBrowser$focusable,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								turn(-90)),
								$elm$html$Html$Attributes$class('document-browser__header-image-menu-action')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/assets/icons/rotate-left.png')
									]),
								_List_Nil),
								$elm$html$Html$text('Rotate Left')
							])),
						A2(
						$author$project$Indexer$DocumentBrowser$focusable,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								turn(90)),
								$elm$html$Html$Attributes$class('document-browser__header-image-menu-action')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/assets/icons/rotate-right.png')
									]),
								_List_Nil),
								$elm$html$Html$text('Rotate Right')
							]))
					]))
			]));
};
var $author$project$Indexer$DocumentBrowser$SetTab = function (a) {
	return {$: 'SetTab', a: a};
};
var $author$project$Indexer$DocumentBrowser$viewTab = F4(
	function (events, active, name, _this) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					events.internal(
						$author$project$Indexer$DocumentBrowser$SetTab(_this))),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(_this, active))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewFrame = F6(
	function (events, showActivity, size, activeTab, headerView, tabView) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-indexer__document-side')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-indexer__document-browser-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-browser__header')
								]),
							function () {
								var _v0 = events.close;
								if (_v0.$ === 'Just') {
									var msg = _v0.a;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('document-browser__header-current')
												]),
											_List_fromArray(
												[headerView])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('document-browser__header-close-link')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Events$onClick(msg)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$i,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('fi-x-circle')
																]),
															_List_Nil)
														]))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('document-browser__header-component-selection')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('component-selector')
														]),
													_List_fromArray(
														[
															A4($author$project$Indexer$DocumentBrowser$viewTab, events, activeTab, 'Documents', $author$project$Indexer$DocumentBrowser$Document),
															A4($author$project$Indexer$DocumentBrowser$viewTab, events, activeTab, 'Messages', $author$project$Indexer$DocumentBrowser$Message),
															A2(
															$author$project$Indexer$DocumentBrowser$showIf,
															showActivity,
															A4($author$project$Indexer$DocumentBrowser$viewTab, events, activeTab, 'Activity', $author$project$Indexer$DocumentBrowser$Activity))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('document-browser__header-current')
												]),
											_List_fromArray(
												[headerView])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('document-browser__header-expand-link')
												]),
											_List_fromArray(
												[
													function () {
													if (size.$ === 'Collapsed') {
														return A4($author$project$Indexer$DocumentBrowser$viewArrows, events, 'expand', 'Expand', $author$project$Indexer$DocumentBrowser$Expanded);
													} else {
														return A4($author$project$Indexer$DocumentBrowser$viewArrows, events, 'compress', 'Collapse', $author$project$Indexer$DocumentBrowser$Collapsed);
													}
												}()
												])),
											A2(
											$elm$core$Maybe$withDefault,
											$author$project$Indexer$DocumentBrowser$empty,
											A2($elm$core$Maybe$map, $author$project$Indexer$DocumentBrowser$viewImageMenu, events.rotatePage))
										]);
								}
							}()),
							tabView
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$MessageLoaded = {$: 'MessageLoaded'};
var $author$project$Indexer$DocumentBrowser$viewEmailBody = F3(
	function (events, emailId, textBody) {
		var key = $elm$core$String$fromInt(
			$author$project$Domain$EmailMessageId$toInt(emailId));
		return A3(
			$author$project$Experimental$OnLoad$keyedNode,
			key,
			events.internal($author$project$Indexer$DocumentBrowser$MessageLoaded),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$Indexer$DocumentBrowser$emailViewerClass)
						]),
					$author$project$Domain$EmailBody$textToHtml(textBody))
				]));
	});
var $author$project$Indexer$DocumentBrowser$DeleteLabel = function (a) {
	return {$: 'DeleteLabel', a: a};
};
var $author$project$Indexer$DocumentBrowser$viewLabel = F3(
	function (events, labelEditor, name) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carrier-labels__label email-label-editor__label-display')
				]),
			_List_fromArray(
				[
					A2($elm$core$Set$member, name, labelEditor.saving) ? $elm$html$Html$text('saving...') : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									events.internal(
										$author$project$Indexer$DocumentBrowser$DeleteLabel(name)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fi-x-circle')
										]),
									_List_Nil)
								])),
							$elm$html$Html$text(name)
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$AddLabel = {$: 'AddLabel'};
var $author$project$Indexer$DocumentBrowser$SelectLabel = function (a) {
	return {$: 'SelectLabel', a: a};
};
var $author$project$Indexer$DocumentBrowser$viewNewLabelSelect = F3(
	function (events, labelEditor, unselected) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(labelEditor.selected)),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$andThen,
						function (str) {
							var _v0 = $elm$core$String$toInt(str);
							if (_v0.$ === 'Nothing') {
								return $elm$json$Json$Decode$fail('could not convert string \u0027' + (str + '\u0027 to an Int'));
							} else {
								var x = _v0.a;
								return $elm$json$Json$Decode$succeed(
									events.internal(
										$author$project$Indexer$DocumentBrowser$SelectLabel(x)));
							}
						},
						$elm$html$Html$Events$targetValue))
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, name) {
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(i))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								]));
					}),
				unselected));
	});
var $author$project$Indexer$DocumentBrowser$viewNewLabel = F4(
	function (events, labelEditor, settings, email) {
		var _v0 = A2($author$project$Indexer$DocumentBrowser$availableLabels, settings, email);
		if (!_v0.b) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('alert-box secondary')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('All available labels have been added.')
					]));
		} else {
			var unselected = _v0;
			return A2(
				$author$project$Components$Shared$Grid$autoRow,
				5,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row collapse')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Shared$Grid$column,
								7,
								_List_fromArray(
									[
										A3($author$project$Indexer$DocumentBrowser$viewNewLabelSelect, events, labelEditor, unselected)
									])),
								function () {
								var attrs = $elm$core$Set$isEmpty(labelEditor.saving) ? _List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										events.internal($author$project$Indexer$DocumentBrowser$AddLabel))
									]) : _List_fromArray(
									[
										$elm$html$Html$Attributes$disabled(true),
										$elm$html$Html$Attributes$class('disabled')
									]);
								return A2(
									$author$project$Components$Shared$Grid$column,
									3,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$class('button postfix email-label-editor__new-label-postfix'),
												attrs),
											_List_fromArray(
												[
													$elm$html$Html$text('Add Label')
												]))
										]));
							}()
							]))
					]));
		}
	});
var $author$project$Indexer$DocumentBrowser$viewLabelEditor = F4(
	function (events, labelEditor, settings, email) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Indexer$DocumentBrowser$keyedDiv,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-label-editor__labels-list')
						]),
					A2(
						$elm$core$List$map,
						function (name) {
							return _Utils_Tuple2(
								name,
								A3($author$project$Indexer$DocumentBrowser$viewLabel, events, labelEditor, name));
						},
						email.labels)),
					A4($author$project$Indexer$DocumentBrowser$viewNewLabel, events, labelEditor, settings, email)
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewRejectMessage = F4(
	function (tz, events, sentMessage, email) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-viewer__email highlighted')
						]),
					_List_fromArray(
						[
							A3($author$project$Indexer$DocumentBrowser$viewEmailHeader, tz, sentMessage, $author$project$Indexer$DocumentBrowser$empty),
							A3($author$project$Indexer$DocumentBrowser$viewEmailBody, events, sentMessage.id, sentMessage.textBody)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-viewer__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Received Message')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-viewer__email highlighted')
						]),
					_List_fromArray(
						[
							A3($author$project$Indexer$DocumentBrowser$viewEmailHeader, tz, email, $author$project$Indexer$DocumentBrowser$empty),
							A3($author$project$Indexer$DocumentBrowser$viewEmailBody, events, email.id, email.textBody)
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$viewEmailMessage = F4(
	function (tz, events, labelEditor, coreInfo) {
		var rejectMessage = coreInfo.rejectMessage;
		var emailMessage = coreInfo.emailMessage;
		var settings = coreInfo.settings;
		if (rejectMessage.$ === 'Just') {
			var sentMessage = rejectMessage.a;
			return A4($author$project$Indexer$DocumentBrowser$viewRejectMessage, tz, events, sentMessage, emailMessage);
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('email-viewer__email highlighted')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Indexer$DocumentBrowser$viewEmailHeader,
						tz,
						emailMessage,
						A2(
							$author$project$Indexer$DocumentBrowser$checkSentOrReceived,
							coreInfo,
							{
								received: A4($author$project$Indexer$DocumentBrowser$viewLabelEditor, events, labelEditor, settings, emailMessage),
								sent: $author$project$Indexer$DocumentBrowser$empty
							})),
						A3($author$project$Indexer$DocumentBrowser$viewEmailBody, events, emailMessage.id, emailMessage.textBody)
					]));
		}
	});
var $author$project$Indexer$DocumentBrowser$viewMessageTab = F4(
	function (tz, events, labelEditor, coreInfo) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__main-image-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-viewer__thread-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('email-viewer__thread-item')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('email-viewer__container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('email-viewer__title')
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Indexer$DocumentBrowser$checkSentOrReceived,
															coreInfo,
															{
																received: $elm$html$Html$text('Received Message'),
																sent: $elm$html$Html$text('Sent Message')
															})
														])),
													A4($author$project$Indexer$DocumentBrowser$viewEmailMessage, tz, events, labelEditor, coreInfo)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Indexer$DocumentBrowser$view = F2(
	function (config, model) {
		var hoveredValue = config.hoveredValue;
		var showActivity = config.showActivity;
		var activities = config.activities;
		var selected = config.selected;
		var info = config.info;
		var events = config.events;
		var coreInfo = info.loadedDocumentBatch.loadedCore;
		var settings = coreInfo.settings;
		var account = coreInfo.account;
		return function (_v0) {
			var a = _v0.a;
			var b = _v0.b;
			return A6($author$project$Indexer$DocumentBrowser$viewFrame, events, showActivity, model.size, model.activeTab, a, b);
		}(
			function () {
				var _v1 = model.activeTab;
				switch (_v1.$) {
					case 'Message':
						return _Utils_Tuple2(
							$author$project$Indexer$DocumentBrowser$empty,
							A4($author$project$Indexer$DocumentBrowser$viewMessageTab, config.timezone, events, model.labelEditor, coreInfo));
					case 'Document':
						return _Utils_Tuple2(
							A5($author$project$Indexer$DocumentBrowser$viewDocumentHeader, events, selected, account, settings, info.groupedDocuments),
							A9($author$project$Indexer$DocumentBrowser$viewDocumentTab, model.idPrefix, hoveredValue, events, selected, account, settings, info, model.size, model.isUpdatingGroups));
					default:
						return _Utils_Tuple2(
							$author$project$Indexer$DocumentBrowser$empty,
							A9(
								$author$project$Components$DocumentBrowser$ActivityView$view,
								account,
								settings,
								false,
								config.timezone,
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Nothing,
								config.resendConfig,
								$elm$core$Basics$always($elm$core$Maybe$Nothing),
								activities));
				}
			}());
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewLoadedBrowser = F6(
	function (browser, isSecondary, data, model, submission, pages) {
		var events = isSecondary ? A3($author$project$Factoring$Page$ClientSubmissionInvoice$documentBrowserSecondaryEvents, data, model, browser.selection.group) : A2($author$project$Factoring$Page$ClientSubmissionInvoice$documentBrowserEvents, data, model);
		var config = {activities: submission.invoice.activityItems, events: events, hoveredValue: model.hoveredLineText, info: pages, resendConfig: $elm$core$Maybe$Nothing, selected: browser.selection, showActivity: true, timezone: model.timezone};
		return A2($author$project$Indexer$DocumentBrowser$view, config, browser.state);
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewBrowser = F4(
	function (data, model, browser, isSecondary) {
		var _v0 = _Utils_Tuple2(data.submission, data.pageData.documentPagesData);
		if ((_v0.a.$ === 'Ok') && (_v0.b.$ === 'Loaded')) {
			var submission = _v0.a.a;
			var documentPagesData = _v0.b.a;
			return A6($author$project$Factoring$Page$ClientSubmissionInvoice$viewLoadedBrowser, browser, isSecondary, data, model, submission, documentPagesData);
		} else {
			return $author$project$Forward$LoadingView$defaultLoadingView;
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$AttemptToReGroup = function (a) {
	return {$: 'AttemptToReGroup', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$ResolveGroupMismatch = function (a) {
	return {$: 'ResolveGroupMismatch', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewGroupMismatch = function (documentBatch) {
	var regroupRequired = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.regroupRequired;
			},
			documentBatch));
	var documentBatchId = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.id;
		},
		documentBatch);
	var regroupButton = function () {
		if (documentBatchId.$ === 'Just') {
			var batchId = documentBatchId.a;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button--progress'),
						$elm$html$Html$Events$onClick(
						$author$project$Factoring$Page$ClientSubmissionInvoice$AttemptToReGroup(batchId))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Regroup')
					]));
		} else {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button--progress'),
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Regroup')
					]));
		}
	}();
	var continueButton = function () {
		var _v0 = _Utils_Tuple2(documentBatchId, regroupRequired);
		if (_v0.a.$ === 'Just') {
			if (!_v0.b) {
				var batchId = _v0.a.a;
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button--progress'),
							$elm$html$Html$Events$onClick(
							$author$project$Factoring$Page$ClientSubmissionInvoice$ResolveGroupMismatch(batchId))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Continue Without Regrouping')
						]));
			} else {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button--disabled'),
							$elm$html$Html$Attributes$disabled(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Continue Without Regrouping')
						]));
			}
		} else {
			var _v1 = _v0.a;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button--disabled'),
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Continue Without Regrouping')
					]));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('client-submission__no-select')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__section-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Error: We were unable to successfully group the documents')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__document-information')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert-box--highlight')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('This often happens because an invoice document was assigned the incorrect type. Please follow the instructions below to regroup. If all document types look correct and do not need to be changed please click \u0027Continue Without Regrouping\u0027')
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Click through the documents in the browser on the right hand side. Look for any invoices that may have been assigned the wrong document type.')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('When any incorrectly assigned documents are found, update their document type using the dropdown on the browser.')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('When all document types are corrected, click the \u0027Regroup\u0027 button below.')
									]))
							])),
						regroupButton,
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Helpers$String$nbsp)
							])),
						continueButton
					]))
			]));
};
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$NoOp = {$: 'NoOp'};
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateType = F2(
	function (a, b) {
		return {$: 'UpdateType', a: a, b: b};
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateTypeAndGroup = F3(
	function (a, b, c) {
		return {$: 'UpdateTypeAndGroup', a: a, b: b, c: c};
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$viewDocumentType = F4(
	function (selected, type_, updateGroup, maybeDocumentBatch) {
		var msg = updateGroup ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Factoring$Page$EmailMessage$IdentifyDocuments$NoOp,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateTypeAndGroup, selected, type_.documentType),
					function ($) {
						return $.id;
					}),
				maybeDocumentBatch)) : A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$UpdateType, selected, type_.documentType);
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(
								$author$project$Domain$Document$documentTypeValueToUnresolved(selected.documentTypeValue),
								$author$project$Domain$UnresolvedDocumentType$Resolved(type_.documentType))),
							_Utils_Tuple2(
							'guessed',
							_Utils_eq(
								$author$project$Domain$UnresolvedDocumentType$Resolved(type_.documentType),
								$author$project$Domain$Document$guessedDocumentTypeValueToUnresolved(selected.guessedDocumentTypeValue))),
							_Utils_Tuple2('document-indexer__type', true)
						])),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(type_.name)
				]));
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$viewDocumentTypes = F5(
	function (selected, types, updateGroup, maybeDocumentBatch, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (t) {
					return A4($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$viewDocumentType, selected, t, updateGroup, maybeDocumentBatch);
				},
				types));
	});
var $author$project$Factoring$Page$EmailMessage$Support$viewMaybe = F2(
	function (val, view) {
		if (val.$ === 'Just') {
			var v = val.a;
			return view(v);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$viewIdentifyUnknowns = F5(
	function (config, selection, enabledTypes, updateGroups, model) {
		var maybeDocumentBatch = config.loadedDocumentBatch.documentBatch;
		return A2(
			$author$project$Helpers$WaitingSpinner$waitingSpinner,
			model.isSaving,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-types__main-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Identify Unknown Documents')
								])),
							A2(
							$author$project$Factoring$Page$EmailMessage$Support$viewMaybe,
							A2($author$project$Indexer$Group$getDocument, config.groupedDocuments, selection),
							function (selected) {
								return A5($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$viewDocumentTypes, selected, enabledTypes, updateGroups, maybeDocumentBatch, model);
							})
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewIdentifyDocuments = F4(
	function (data, model, documentPagesInfo, selections) {
		var isLastSelection = $elm$core$List$length(selections) <= 1;
		var isBatchLevelUpload = function () {
			var _v4 = documentPagesInfo.loadedDocumentBatch.documentBatch;
			if (_v4.$ === 'Just') {
				var batch = _v4.a;
				return batch.batchLevelUploads;
			} else {
				return false;
			}
		}();
		var enabledDocumentTypeNames = A3(
			$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
			_List_Nil,
			function ($) {
				return $.enabledDocumentTypeNames;
			},
			$author$project$Forward$Remote$toMaybe(data.documentTypeSettings));
		var currentSelection = model.selection;
		var firstSelectionInGroup = _Utils_update(
			$author$project$Indexer$Group$firstSelection,
			{group: currentSelection.group});
		var nextPrecedingUnknownSelection = A2(
			$elm_community$list_extra$List$Extra$find,
			function (s) {
				return _Utils_cmp(s.document, currentSelection.document) < 0;
			},
			selections);
		var nextSucceedingUnknownSelection = A2(
			$elm_community$list_extra$List$Extra$find,
			function (s) {
				return _Utils_cmp(s.document, currentSelection.document) > 0;
			},
			selections);
		var nextSelection = function () {
			var _v0 = _Utils_Tuple2(nextSucceedingUnknownSelection, nextPrecedingUnknownSelection);
			if (_v0.a.$ === 'Just') {
				var succeedingSelection = _v0.a.a;
				return succeedingSelection;
			} else {
				if (_v0.b.$ === 'Just') {
					var _v1 = _v0.a;
					var precedingSelection = _v0.b.a;
					return precedingSelection;
				} else {
					var _v2 = _v0.a;
					var _v3 = _v0.b;
					return firstSelectionInGroup;
				}
			}
		}();
		return A2(
			$elm$html$Html$map,
			$author$project$Factoring$Page$ClientSubmissionInvoice$IdentifyDocumentsMsg(nextSelection),
			A5($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$viewIdentifyUnknowns, documentPagesInfo, currentSelection, enabledDocumentTypeNames, isLastSelection && isBatchLevelUpload, model.identifyDocuments));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$GroupLoaded = function (a) {
	return {$: 'GroupLoaded', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewOnLoadTrigger = function (_v0) {
	var group = _v0.group;
	return A3(
		$author$project$Experimental$OnLoad$keyedNode,
		$elm$core$String$fromInt(group),
		$author$project$Factoring$Page$ClientSubmissionInvoice$GroupLoaded(group),
		_List_Nil);
};
var $author$project$Factoring$Page$ClientSubmission$Change$Amount = {$: 'Amount'};
var $author$project$Indexer$Group$Amount = function (a) {
	return {$: 'Amount', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Change$AmountMatchesRateCon = {$: 'AmountMatchesRateCon'};
var $author$project$Indexer$Group$Any = function (a) {
	return {$: 'Any', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Change$ClientOrDebtorOnBol = {$: 'ClientOrDebtorOnBol'};
var $author$project$Indexer$Group$Date = function (a) {
	return {$: 'Date', a: a};
};
var $author$project$Indexer$Group$InContext = F2(
	function (a, b) {
		return {$: 'InContext', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmission$Change$InvoiceDate = {$: 'InvoiceDate'};
var $author$project$Factoring$Page$ClientSubmission$Change$LoadId = {$: 'LoadId'};
var $author$project$Indexer$Group$None = {$: 'None'};
var $author$project$Factoring$Page$ClientSubmission$Change$Number = {$: 'Number'};
var $author$project$Factoring$Page$ClientSubmission$Change$PickupDropoffMatches = {$: 'PickupDropoffMatches'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$ShowFundingNotes = {$: 'ShowFundingNotes'};
var $author$project$Indexer$Group$Text = function (a) {
	return {$: 'Text', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Change$ThirdPartyListedOnBol = {$: 'ThirdPartyListedOnBol'};
var $author$project$Factoring$Page$ClientSubmission$Change$Tonu = {$: 'Tonu'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$alertWithTooltip = F2(
	function (tooltip, showRedAlert) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'true'),
					$elm$html$Html$Attributes$title(tooltip),
					A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
					$elm$html$Html$Attributes$class('client-submission__alert-tooltip')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('fi-alert', true),
									_Utils_Tuple2('alert', showRedAlert)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Helpers$String$nbsp)
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$alternateRateConAndBolDoctype = F2(
	function (model, maybeGroups) {
		var currentDocType = function () {
			if (maybeGroups.$ === 'Just') {
				var groups = maybeGroups.a;
				return A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Domain$Document$documentTypeValueToUnresolved,
						function ($) {
							return $.documentTypeValue;
						}),
					A2($author$project$Indexer$Group$getDocument, groups, model.selection));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		_v0$2:
		while (true) {
			if ((currentDocType.$ === 'Just') && (currentDocType.a.$ === 'Resolved')) {
				switch (currentDocType.a.a.$) {
					case 'DocumentTypeBillOfLading':
						var _v1 = currentDocType.a.a;
						return $author$project$AuditPb$DocumentTypeRateConfirmation;
					case 'DocumentTypeRateConfirmation':
						var _v2 = currentDocType.a.a;
						return $author$project$AuditPb$DocumentTypeBillOfLading;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$AuditPb$DocumentTypeBillOfLading;
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$AdjustHighlight = function (a) {
	return {$: 'AdjustHighlight', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$Next = function (a) {
	return {$: 'Next', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$OnPage = function (a) {
	return {$: 'OnPage', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$Remove = {$: 'Remove'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewHighlightableInput = function (inputFinder) {
	var highlightableAttrs = _List_fromArray(
		[
			$elm$html$Html$Events$onClick(
			$author$project$Factoring$Page$ClientSubmissionInvoice$AdjustHighlight(
				$author$project$Factoring$Page$ClientSubmissionInvoice$Next(inputFinder))),
			$elm$html$Html$Events$onMouseEnter(
			$author$project$Factoring$Page$ClientSubmissionInvoice$AdjustHighlight(
				$author$project$Factoring$Page$ClientSubmissionInvoice$OnPage(inputFinder))),
			$elm$html$Html$Events$onMouseLeave(
			$author$project$Factoring$Page$ClientSubmissionInvoice$AdjustHighlight($author$project$Factoring$Page$ClientSubmissionInvoice$Remove))
		]);
	return A2(
		$elm$html$Html$div,
		highlightableAttrs,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-magnifying-glass')
					]),
				_List_Nil)
			]));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewInputSearchColumn = function (inputFinder) {
	if (inputFinder.$ === 'None') {
		return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('client-submission__input-search')
				]),
			_List_fromArray(
				[
					$author$project$Factoring$Page$ClientSubmissionInvoice$viewHighlightableInput(inputFinder)
				]));
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$onShiftClick = F2(
	function (whenTrue, whenFalse) {
		return A2(
			$elm$html$Html$Events$stopPropagationOn,
			'click',
			A2(
				$elm$json$Json$Decode$map,
				function (shift) {
					return _Utils_Tuple2(
						shift ? whenTrue : whenFalse,
						true);
				},
				A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool)));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewHighlightable = F2(
	function (attrs, row) {
		var highlightableAttrs = _Utils_eq(row.finder, $author$project$Indexer$Group$None) ? attrs : A2(
			$elm$core$List$cons,
			A4(
				$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
				$elm$html$Html$Events$onClick,
				$author$project$Factoring$Page$ClientSubmissionInvoice$onShiftClick,
				row.autofill,
				$author$project$Factoring$Page$ClientSubmissionInvoice$AdjustHighlight(
					$author$project$Factoring$Page$ClientSubmissionInvoice$Next(row.finder))),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Events$onMouseEnter(
					$author$project$Factoring$Page$ClientSubmissionInvoice$AdjustHighlight(
						$author$project$Factoring$Page$ClientSubmissionInvoice$OnPage(row.finder))),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onMouseLeave(
						$author$project$Factoring$Page$ClientSubmissionInvoice$AdjustHighlight($author$project$Factoring$Page$ClientSubmissionInvoice$Remove)),
					attrs)));
		return A2(
			$elm$html$Html$div,
			highlightableAttrs,
			_List_fromArray(
				[row.formatted]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewSubmissionColumn = F2(
	function (width, row) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'column large-' + $elm$core$String$fromInt(width))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Factoring$Page$ClientSubmissionInvoice$viewHighlightable,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-submission__submission-value')
						]),
					row)
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewRow = F2(
	function (name, row) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('large-3 column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Factoring$Page$ClientSubmissionInvoice$bem('detail-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]))
								]))
						]),
						_Utils_eq(row.lastColumn, $author$project$Factoring$Page$ClientSubmissionInvoice$empty) ? _List_fromArray(
						[
							A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewSubmissionColumn, 7, row)
						]) : _List_fromArray(
						[
							A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewSubmissionColumn, 3, row),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('large-3 column')
								]),
							_List_fromArray(
								[row.lastColumn])),
							$author$project$Factoring$Page$ClientSubmissionInvoice$viewInputSearchColumn(row.inputFinder)
						]),
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('large-1 column')
								]),
							_List_fromArray(
								[$author$project$Factoring$Page$ClientSubmissionInvoice$empty]))
						])
					])));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$carrierNameRow = F2(
	function (carrierName, fundingNotes) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
			'Client',
			{
				autofill: $elm$core$Maybe$Nothing,
				finder: $author$project$Indexer$Group$Text(carrierName),
				formatted: $elm$html$Html$text(carrierName),
				inputFinder: $author$project$Indexer$Group$None,
				lastColumn: fundingNotes
			});
	});
var $author$project$Factoring$Page$ClientSubmission$Change$Boolean = F2(
	function (a, b) {
		return {$: 'Boolean', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$NextOf = F2(
	function (a, b) {
		return {$: 'NextOf', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$checkboxRow = F3(
	function (labelText, check, row) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
			'',
			{
				autofill: $elm$core$Maybe$Nothing,
				finder: row.finder,
				formatted: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button-group'),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$onShiftClick,
							$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
								A2($author$project$Factoring$Page$ClientSubmission$Change$Boolean, check, !row.checked)),
							$author$project$Factoring$Page$ClientSubmissionInvoice$AdjustHighlight(
								A2(
									$author$project$Factoring$Page$ClientSubmissionInvoice$NextOf,
									row.finder,
									$author$project$Domain$UnresolvedDocumentType$Resolved(row.jumpTo))))
						]),
					_List_fromArray(
						[row.formatted])),
				inputFinder: $author$project$Indexer$Group$None,
				lastColumn: A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$author$project$Factoring$Page$ClientSubmissionInvoice$bem('value-label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(row.checked),
									$elm$html$Html$Attributes$disabled(row.disabled),
									$elm$html$Html$Events$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange,
										$author$project$Factoring$Page$ClientSubmission$Change$Boolean(check)))
								]),
							_List_Nil),
							$elm$html$Html$text(' ' + labelText)
						]))
			});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$cleanAmount = function () {
	var replace = function (by) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(by),
			$elm$core$String$concat);
	};
	return A2(
		$elm$core$Basics$composeR,
		replace('$'),
		replace(','));
}();
var $author$project$Factoring$Page$ClientSubmissionInvoice$clientDebtorNoaStatusRow = function (invoice) {
	var maybeNoaRelationship = invoice.clientDebtorNoaRelationship;
	if (maybeNoaRelationship.$ === 'Just') {
		var noaRelationship = maybeNoaRelationship.a;
		var maybeTitle = noaRelationship.title;
		var maybeStatus = noaRelationship.status;
		var maybeDescription = noaRelationship.description;
		var _v1 = _Utils_Tuple3(maybeStatus, maybeTitle, maybeDescription);
		if (((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) && (_v1.c.$ === 'Just')) {
			var status = _v1.a.a;
			var title = _v1.b.a;
			var description = _v1.c.a;
			var notifcationStatus = function () {
				switch (status.$) {
					case 'Success':
						return $author$project$Ui$V3$Notification$success;
					case 'Warning':
						return $author$project$Ui$V3$Notification$warning;
					case 'Info':
						return $author$project$Ui$V3$Notification$info;
					default:
						return $author$project$Ui$V3$Notification$error;
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('large-3 column')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('large-7 column')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('enable_shared-ui-v3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('v3__theme')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$V3$Notification$viewInline,
												{
													message: $elm$html$Html$text(description),
													onClose: $elm$core$Maybe$Nothing,
													title: $elm$core$Maybe$Just(title)
												},
												_List_fromArray(
													[notifcationStatus]))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
		}
	} else {
		return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$SelectDebtor = function (a) {
	return {$: 'SelectDebtor', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$allAre = function (x) {
	return $elm$core$List$all(
		$elm$core$Basics$eq(x));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$debtorDetailFrame = F2(
	function (children, showMismatch_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('client-submission__compact-details', true),
							_Utils_Tuple2('client-submission__row__mismatch', showMismatch_)
						]))
				]),
			children);
	});
var $author$project$Indexer$Group$Secondary = {$: 'Secondary'};
var $author$project$Indexer$Group$StreetAddress = function (a) {
	return {$: 'StreetAddress', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$debtorSecondaryFinder = F2(
	function (debtor, address) {
		return A2(
			$author$project$Indexer$Group$InContext,
			$author$project$Indexer$Group$Secondary,
			$author$project$Indexer$Group$Any(
				_List_fromArray(
					[
						A3(
						$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
						$author$project$Indexer$Group$None,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Indexer$Group$Text,
							function ($) {
								return $.name;
							}),
						debtor),
						A3(
						$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
						$author$project$Indexer$Group$None,
						$author$project$Indexer$Group$StreetAddress,
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.addressLine1;
							},
							address)),
						A3(
						$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
						$author$project$Indexer$Group$None,
						$author$project$Indexer$Group$StreetAddress,
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.addressLine2;
							},
							address)),
						A3(
						$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
						$author$project$Indexer$Group$None,
						$author$project$Indexer$Group$Text,
						A2($elm$core$Maybe$andThen, $author$project$Domain$Address$lastLine, address)),
						A3(
						$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
						$author$project$Indexer$Group$None,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.commonAliases;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map($author$project$Indexer$Group$Text),
								$author$project$Indexer$Group$Any)),
						debtor)
					])));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$debtorsDontMatch = F2(
	function (submissionDebtor, invoiceDebtor) {
		var _v0 = _Utils_Tuple2(submissionDebtor, invoiceDebtor);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
			var subDebtor = _v0.a.a;
			var invDebtor = _v0.b.a;
			return !_Utils_eq(subDebtor, invDebtor);
		} else {
			return false;
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$debtorDetailRow = function (params) {
	var autofill = params.invoice.readonly ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Factoring$Page$ClientSubmissionInvoice$SelectDebtor(params.submission.debtor));
	var createViewerParams = F2(
		function (debtor, debtorAddress) {
			return {
				autofill: autofill,
				data: params.data,
				debtor: debtor,
				debtorAddress: debtorAddress,
				finder: A2($author$project$Factoring$Page$ClientSubmissionInvoice$debtorSecondaryFinder, debtor, debtorAddress),
				isPaymentsNetworkInvoice: params.isPaymentsNetworkInvoice
			};
		});
	var left = params.viewer(
		A2(createViewerParams, params.submission.debtor, params.submission.debtorAddress));
	var right = params.viewer(
		A2(createViewerParams, params.invoice.debtor, params.invoice.debtorAddress));
	return (A2($author$project$Factoring$Page$ClientSubmissionInvoice$allAre, $author$project$Factoring$Page$ClientSubmissionInvoice$empty, left) && A2($author$project$Factoring$Page$ClientSubmissionInvoice$allAre, $author$project$Factoring$Page$ClientSubmissionInvoice$empty, right)) ? $author$project$Factoring$Page$ClientSubmissionInvoice$empty : A2(
		$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
		'',
		{
			autofill: $elm$core$Maybe$Nothing,
			finder: $author$project$Indexer$Group$None,
			formatted: A2($author$project$Factoring$Page$ClientSubmissionInvoice$debtorDetailFrame, left, false),
			inputFinder: $author$project$Indexer$Group$None,
			lastColumn: A2(
				$author$project$Factoring$Page$ClientSubmissionInvoice$debtorDetailFrame,
				right,
				A2($author$project$Factoring$Page$ClientSubmissionInvoice$debtorsDontMatch, params.submission.debtor, params.invoice.debtor))
		});
};
var $author$project$Indexer$Group$BusinessName = function (a) {
	return {$: 'BusinessName', a: a};
};
var $author$project$Components$DebtorWithAddressTypeahead$view = $author$project$Typeahead$view($author$project$Components$DebtorWithAddressTypeahead$config);
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewManualDebtorName = function (name) {
	if (name === '') {
		return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('client-submission__manual-debtor-name')
				]),
			_List_fromArray(
				[
					A2($author$project$Factoring$Page$ClientSubmissionInvoice$alertWithTooltip, 'Debtor name entered manually. Could not match with debtor in system.', false),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-submission__manual-debtor-name__text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$debtorTypeaheadRow = F5(
	function (name, typeaheadData, typeahead, submission, invoice) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
			name,
			{
				autofill: invoice.readonly ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Factoring$Page$ClientSubmissionInvoice$SelectDebtor(submission.debtor)),
				finder: $author$project$Indexer$Group$Any(
					_List_fromArray(
						[
							A3(
							$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
							$author$project$Indexer$Group$None,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.name;
								},
								$author$project$Indexer$Group$BusinessName),
							submission.debtor),
							A2($author$project$Factoring$Page$ClientSubmissionInvoice$debtorSecondaryFinder, submission.debtor, submission.debtorAddress)
						])),
				formatted: A3(
					$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
					$author$project$Factoring$Page$ClientSubmissionInvoice$viewManualDebtorName(submission.manualDebtorName),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.name;
						},
						$elm$html$Html$text),
					submission.debtor),
				inputFinder: $author$project$Indexer$Group$Any(
					_List_fromArray(
						[
							A3(
							$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
							$author$project$Indexer$Group$None,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.name;
								},
								$author$project$Indexer$Group$BusinessName),
							invoice.debtor),
							A2($author$project$Factoring$Page$ClientSubmissionInvoice$debtorSecondaryFinder, invoice.debtor, invoice.debtorAddress)
						])),
				lastColumn: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('activity-filters-typeahead', true),
									_Utils_Tuple2(
									'client-submission__row__mismatch',
									A2($author$project$Factoring$Page$ClientSubmissionInvoice$debtorsDontMatch, submission.debtor, invoice.debtor))
								]))
						]),
					_List_fromArray(
						[
							invoice.readonly ? A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$disabled(true),
									$elm$html$Html$Attributes$value(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.name;
											},
											invoice.debtor)))
								]),
							_List_Nil) : A2(
							$elm$html$Html$map,
							$author$project$Factoring$Page$ClientSubmissionInvoice$DebtorWithAddressTypeaheadMsg,
							A2($author$project$Components$DebtorWithAddressTypeahead$view, typeaheadData, typeahead))
						]))
			});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$formatAmount = A2($elm$core$Basics$composeR, $author$project$Money$castFromString, $author$project$Money$toString);
var $author$project$Factoring$Page$ClientSubmission$Change$Text = F2(
	function (a, b) {
		return {$: 'Text', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyAmount = F2(
	function (a, b) {
		return {$: 'UpdateDirtyAmount', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$getAmountInputHandlers = {
	onAutofillMsg: function (val) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyAmount,
			$elm$core$Maybe$Just(
				A2($author$project$Factoring$Page$ClientSubmission$Change$Text, $author$project$Factoring$Page$ClientSubmission$Change$Amount, val)),
			$elm$core$Maybe$Nothing);
	},
	onChangeMsg: function (val) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyAmount,
			$elm$core$Maybe$Just(
				A2($author$project$Factoring$Page$ClientSubmission$Change$Text, $author$project$Factoring$Page$ClientSubmission$Change$Amount, val)),
			$elm$core$Maybe$Nothing);
	},
	onDropMsg: function (val) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyAmount,
			$elm$core$Maybe$Just(
				A2($author$project$Factoring$Page$ClientSubmission$Change$Text, $author$project$Factoring$Page$ClientSubmission$Change$Amount, val)),
			$elm$core$Maybe$Nothing);
	},
	onInputMsg: function (val) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyAmount,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(val));
	}
};
var $author$project$Factoring$Page$ClientSubmission$Change$get = F3(
	function (_default, check, changes) {
		get:
		while (true) {
			if (!changes.b) {
				return _default;
			} else {
				var first = changes.a;
				var rest = changes.b;
				var _v1 = check(first);
				if (_v1.$ === 'Just') {
					var value = _v1.a;
					return value;
				} else {
					var $temp$default = _default,
						$temp$check = check,
						$temp$changes = rest;
					_default = $temp$default;
					check = $temp$check;
					changes = $temp$changes;
					continue get;
				}
			}
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Change$justIfEq = F3(
	function (left, right, value) {
		return _Utils_eq(left, right) ? $elm$core$Maybe$Just(value) : $elm$core$Maybe$Nothing;
	});
var $author$project$Factoring$Page$ClientSubmission$Change$getBoolean = F2(
	function (field, _default) {
		return A2(
			$author$project$Factoring$Page$ClientSubmission$Change$get,
			_default,
			function (change) {
				if (change.$ === 'Boolean') {
					var x = change.a;
					var value = change.b;
					return A3($author$project$Factoring$Page$ClientSubmission$Change$justIfEq, x, field, value);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyInvoiceDate = F2(
	function (a, b) {
		return {$: 'UpdateDirtyInvoiceDate', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$getDateInputHandlers = {
	onAutofillMsg: function (val) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyInvoiceDate,
			$elm$core$Maybe$Just(
				A2($author$project$Factoring$Page$ClientSubmission$Change$Text, $author$project$Factoring$Page$ClientSubmission$Change$InvoiceDate, val)),
			$elm$core$Maybe$Nothing);
	},
	onChangeMsg: function (val) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyInvoiceDate,
			$elm$core$Maybe$Just(
				A2($author$project$Factoring$Page$ClientSubmission$Change$Text, $author$project$Factoring$Page$ClientSubmission$Change$InvoiceDate, val)),
			$elm$core$Maybe$Nothing);
	},
	onDropMsg: function (val) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyInvoiceDate,
			$elm$core$Maybe$Just(
				A2($author$project$Factoring$Page$ClientSubmission$Change$Text, $author$project$Factoring$Page$ClientSubmission$Change$InvoiceDate, val)),
			$elm$core$Maybe$Nothing);
	},
	onInputMsg: function (val) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$UpdateDirtyInvoiceDate,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(val));
	}
};
var $author$project$Factoring$Page$ClientSubmission$Change$getText = F2(
	function (field, _default) {
		return A2(
			$author$project$Factoring$Page$ClientSubmission$Change$get,
			_default,
			function (change) {
				if (change.$ === 'Text') {
					var x = change.a;
					var value = change.b;
					return A3($author$project$Factoring$Page$ClientSubmission$Change$justIfEq, x, field, value);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$inputRowDefaultEventHandlers = function (field) {
	var queueChange = function (value) {
		return $author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
			A2($author$project$Factoring$Page$ClientSubmission$Change$Text, field, value));
	};
	return {
		onAutofillMsg: queueChange,
		onChangeMsg: $elm$core$Basics$always($author$project$Factoring$Page$ClientSubmissionInvoice$NoOp),
		onDropMsg: queueChange,
		onInputMsg: queueChange
	};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'change',
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Factoring$Page$ClientSubmissionInvoice$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$showMismatch = function (_v0) {
	var trim = _v0.trim;
	var extractedData = _v0.extractedData;
	var submissionValue = _v0.submissionValue;
	var finder = _v0.finder;
	var valueMatches = _Utils_eq(
		finder,
		$author$project$Indexer$Group$Amount(submissionValue)) ? A2($author$project$Indexer$Group$hasAmount, submissionValue, extractedData) : (trim ? _Utils_eq(
		$elm$core$String$trim(
			$elm$core$String$toLower(submissionValue)),
		$elm$core$String$trim(
			$elm$core$String$toLower(extractedData))) : _Utils_eq(
		$elm$core$String$toLower(submissionValue),
		$elm$core$String$toLower(extractedData)));
	return valueMatches ? $elm$html$Html$Attributes$class('') : ($elm$core$String$isEmpty(
		$elm$core$String$trim(extractedData)) ? $author$project$Factoring$Page$ClientSubmissionInvoice$bem('input-row__extracted-empty') : $author$project$Factoring$Page$ClientSubmissionInvoice$bem('row__mismatch'));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$inputRow_ = F4(
	function (detailName, _v0, _v1, row) {
		var onAutofillMsg = _v1.onAutofillMsg;
		var onDropMsg = _v1.onDropMsg;
		var onChangeMsg = _v1.onChangeMsg;
		var onInputMsg = _v1.onInputMsg;
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
			detailName,
			{
				autofill: row.disabled ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					onAutofillMsg(row.raw)),
				finder: row.finder,
				formatted: row.formatted,
				inputFinder: row.inputFinder,
				lastColumn: A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$value(row.inputValue),
							$author$project$Factoring$Page$ClientSubmissionInvoice$showMismatch(
							{extractedData: row.inputValue, finder: row.finder, submissionValue: row.raw, trim: row.trim}),
							$elm$html$Html$Attributes$placeholder(detailName),
							$elm$html$Html$Attributes$disabled(row.disabled),
							A2($elm$html$Html$Attributes$attribute, 'data-drop', $author$project$Indexer$DocumentBrowser$documentLineContext),
							$elm$html$Html$Events$onInput(onInputMsg),
							$author$project$Factoring$Page$ClientSubmissionInvoice$onChange(onChangeMsg),
							A2(
							$elm$html$Html$Events$on,
							'x-drop',
							A2(
								$elm$json$Json$Decode$map,
								A2($elm$core$Basics$composeR, row.clean, onDropMsg),
								A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string)))
						]),
					_List_Nil)
			});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$inputRow = F3(
	function (detailName, field, row) {
		return A4(
			$author$project$Factoring$Page$ClientSubmissionInvoice$inputRow_,
			detailName,
			field,
			$author$project$Factoring$Page$ClientSubmissionInvoice$inputRowDefaultEventHandlers(field),
			row);
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$maybeDateToFormattedString = function (date) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Helpers$Date$dateStringFromDate, date));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$paymentsNetworkInvoice = F2(
	function (account, invoice) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return account.paymentsNetworkEnabled;
				},
				invoice.paymentsNetworkExternalLoadId));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$showIf = F2(
	function (flag, view_) {
		return flag ? view_ : $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$staticRow = F2(
	function (detailName, value) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
			detailName,
			{
				autofill: $elm$core$Maybe$Nothing,
				finder: $author$project$Indexer$Group$Text(value),
				formatted: $elm$html$Html$text(value),
				inputFinder: $author$project$Indexer$Group$None,
				lastColumn: $author$project$Factoring$Page$ClientSubmissionInvoice$empty
			});
	});
var $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$view = F2(
	function (data, model) {
		return A4($author$project$Components$PaginatedDropdown$view, $author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$maybeSubmissionToItem, data, _List_Nil, model.dropdown);
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$formatDisplayStatus = function (invoice) {
	var _v0 = invoice.state;
	switch (_v0) {
		case 'abandoned':
			return 'rejected';
		case 'approved':
			return 'approved';
		case 'verified':
			return 'approved';
		case 'purchased':
			return 'approved';
		case 'processed':
			return 'processed';
		default:
			return 'placed in ' + (invoice.state + ' state');
	}
};
var $author$project$Factoring$Page$ClientSubmission$Change$Review = {$: 'Review'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewContinueButton = F3(
	function (label, className, changes) {
		var loading = !$elm$core$List$isEmpty(changes);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-3 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' ')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-3 column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Factoring$Page$ClientSubmissionInvoice$bem('button'),
									$elm$html$Html$Attributes$class(className),
									$elm$html$Html$Events$onClick(
									$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange($author$project$Factoring$Page$ClientSubmission$Change$Review)),
									$elm$html$Html$Attributes$disabled(loading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-4 column')
						]),
					_List_fromArray(
						[$author$project$Factoring$Page$ClientSubmissionInvoice$empty]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewApproveReject = F2(
	function (invoice, changes) {
		return invoice.readonly ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('client-submission__readonly-notice')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Invoice was ' + $author$project$Factoring$Page$ClientSubmissionInvoice$formatDisplayStatus(invoice))
				])) : (A2($elm$core$List$all, $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$passing, invoice.exceptions) ? A3($author$project$Factoring$Page$ClientSubmissionInvoice$viewContinueButton, 'Approve', 'button--progress', changes) : A3($author$project$Factoring$Page$ClientSubmissionInvoice$viewContinueButton, 'Reject', 'button--caution', changes));
	});
var $author$project$Factoring$Page$ClientSubmission$Change$BadQuality = function (a) {
	return {$: 'BadQuality', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Change$hasBadQuality = $elm$core$List$any(
	function (change) {
		if (change.$ === 'BadQuality') {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewToggleRow = F4(
	function (labelText, buttonText, lastColumn, attrs) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
			labelText,
			{
				autofill: $elm$core$Maybe$Nothing,
				finder: $author$project$Indexer$Group$None,
				formatted: A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$cons,
						$author$project$Factoring$Page$ClientSubmissionInvoice$bem('compact-button'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('button tiny'),
							attrs)),
					_List_fromArray(
						[
							$elm$html$Html$text(buttonText)
						])),
				inputFinder: $author$project$Indexer$Group$None,
				lastColumn: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Factoring$Page$ClientSubmissionInvoice$bem('compact-details'),
							$author$project$Factoring$Page$ClientSubmissionInvoice$bem('value-label')
						]),
					_List_fromArray(
						[lastColumn]))
			});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewBadQualityToggle = F3(
	function (_v0, changes, page) {
		var badQualityPages = _v0.badQualityPages;
		var row = F3(
			function (buttonText, pageIds, lastColumn) {
				return A4(
					$author$project$Factoring$Page$ClientSubmissionInvoice$viewToggleRow,
					'Unreadable Document',
					buttonText,
					lastColumn,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(
							$author$project$Factoring$Page$ClientSubmission$Change$hasBadQuality(changes)),
							$elm$html$Html$Events$onClick(
							$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
								$author$project$Factoring$Page$ClientSubmission$Change$BadQuality(pageIds)))
						]));
			});
		return A2($elm$core$List$member, page.id, badQualityPages) ? A3(
			row,
			'Remove Page',
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(page.id),
				badQualityPages),
			function () {
				var _v1 = $elm$core$List$length(badQualityPages) - 1;
				switch (_v1) {
					case 0:
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Factoring$Page$ClientSubmissionInvoice$bem('row__mismatch')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('This page')
								]));
					case 1:
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Factoring$Page$ClientSubmissionInvoice$bem('row__mismatch')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('This page + 1 other')
								]));
					default:
						var n = _v1;
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Factoring$Page$ClientSubmissionInvoice$bem('row__mismatch')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'This page + ' + ($elm$core$String$fromInt(n) + ' others'))
								]));
				}
			}()) : A3(
			row,
			'Add Page',
			A2($elm$core$List$cons, page.id, badQualityPages),
			function () {
				var _v2 = $elm$core$List$length(badQualityPages);
				switch (_v2) {
					case 0:
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('No pages')
								]));
					case 1:
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Factoring$Page$ClientSubmissionInvoice$bem('row__mismatch')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('1 other page')
								]));
					default:
						var n = _v2;
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Factoring$Page$ClientSubmissionInvoice$bem('row__mismatch')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(n) + ' other pages')
								]));
				}
			}());
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewDetail = F3(
	function (secondaryFinder, autofill, prefix) {
		return A2(
			$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
			$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
			function (content) {
				var finder = $author$project$Indexer$Group$Any(
					_List_fromArray(
						[
							$author$project$Indexer$Group$Text(content),
							secondaryFinder
						]));
				return A2(
					$author$project$Factoring$Page$ClientSubmissionInvoice$viewHighlightable,
					_List_Nil,
					{
						autofill: autofill,
						finder: finder,
						formatted: A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									prefix,
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(content)
										]))
								])),
						inputFinder: finder
					});
			});
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewDebtorAddress = function (_v0) {
	var autofill = _v0.autofill;
	var finder = _v0.finder;
	var debtorAddress = _v0.debtorAddress;
	if (debtorAddress.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var address = debtorAddress.a;
		return _List_fromArray(
			[
				A4($author$project$Factoring$Page$ClientSubmissionInvoice$viewDetail, finder, autofill, $author$project$Factoring$Page$ClientSubmissionInvoice$empty, address.addressLine1),
				A4($author$project$Factoring$Page$ClientSubmissionInvoice$viewDetail, finder, autofill, $author$project$Factoring$Page$ClientSubmissionInvoice$empty, address.addressLine2),
				A4(
				$author$project$Factoring$Page$ClientSubmissionInvoice$viewDetail,
				finder,
				autofill,
				$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
				$author$project$Domain$Address$lastLine(address))
			]);
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewDebtorDetail = F3(
	function (name, getter, _v0) {
		var autofill = _v0.autofill;
		var finder = _v0.finder;
		var debtor = _v0.debtor;
		var detail = A2($elm$core$Maybe$andThen, getter, debtor);
		if ((detail.$ === 'Just') && (detail.a === '')) {
			return _List_fromArray(
				[$author$project$Factoring$Page$ClientSubmissionInvoice$empty]);
		} else {
			return _List_fromArray(
				[
					A4($author$project$Factoring$Page$ClientSubmissionInvoice$viewDetail, finder, autofill, name, detail)
				]);
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$factorBrokerEmail = function (maybeDebtor) {
	return A2(
		$elm$core$Maybe$andThen,
		function (debtor) {
			var _v0 = debtor.cadenceDebtorDetails.email;
			if (_v0.$ === 'Just') {
				var email = _v0.a;
				return $elm$core$Maybe$Just(email);
			} else {
				return A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.email;
					},
					debtor.billingContact);
			}
		},
		maybeDebtor);
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewDebtorEmail = function (_v0) {
	var autofill = _v0.autofill;
	var finder = _v0.finder;
	var debtor = _v0.debtor;
	var email = $author$project$Factoring$Page$ClientSubmissionInvoice$factorBrokerEmail(debtor);
	if ((email.$ === 'Just') && (email.a === '')) {
		return _List_fromArray(
			[$author$project$Factoring$Page$ClientSubmissionInvoice$empty]);
	} else {
		return _List_fromArray(
			[
				A4(
				$author$project$Factoring$Page$ClientSubmissionInvoice$viewDetail,
				finder,
				autofill,
				A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Email: ')
						])),
				email)
			]);
	}
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$HideCustomExceptionForm = {$: 'HideCustomExceptionForm'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$ShowCustomExceptionForm = {$: 'ShowCustomExceptionForm'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewAddCustomExceptionButton = F2(
	function (invoice, model) {
		var _v0 = _Utils_Tuple2(invoice.readonly, model.viewCustomExceptionForm);
		if (_v0.a) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fi-plus rules__add-exception-icon disabled'),
								$elm$html$Html$Attributes$title('This invoice has been processed and cannot be altered.')
							]),
						_List_Nil)
					]));
		} else {
			if (_v0.b) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Factoring$Page$ClientSubmissionInvoice$HideCustomExceptionForm)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-minus rules__add-exception-icon')
								]),
							_List_Nil)
						]));
			} else {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Factoring$Page$ClientSubmissionInvoice$ShowCustomExceptionForm)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-plus rules__add-exception-icon')
								]),
							_List_Nil)
						]));
			}
		}
	});
var $author$project$Factoring$Page$ClientSubmission$Change$CreateCustomException = function (a) {
	return {$: 'CreateCustomException', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$Predefined = function (a) {
	return {$: 'Predefined', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$SetCustomExceptionText = function (a) {
	return {$: 'SetCustomExceptionText', a: a};
};
var $elm_community$dict_extra$Dict$Extra$invert = function (dict) {
	return A3(
		$elm$core$Dict$foldl,
		F3(
			function (k, v, acc) {
				return A3($elm$core$Dict$insert, v, k, acc);
			}),
		$elm$core$Dict$empty,
		dict);
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$maybeViewFreeFormCustomException = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.customExceptionText;
			if (_v0.$ === 'Other') {
				var val = _v0.a;
				return A2(
					$elm$html$Html$textarea,
					$author$project$Helpers$Attributes$blockGrammarly(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$placeholder('Custom Exception Text'),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Factoring$Page$ClientSubmissionInvoice$SetCustomExceptionText, $author$project$Factoring$Page$ClientSubmissionInvoice$Other)),
								$elm$html$Html$Attributes$value(val)
							])),
					_List_Nil);
			} else {
				return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
			}
		}()
		]);
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewCustomExceptionForm = F2(
	function (data, model) {
		var effectiveValue = function () {
			var _v2 = model.customExceptionText;
			if (_v2.$ === 'Other') {
				var val = _v2.a;
				return val;
			} else {
				var val = _v2.a;
				return val;
			}
		}();
		var customInvoiceExceptionMessages = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.customInvoiceExceptionMessages;
				},
				$author$project$Forward$Remote$toMaybe(data.accountSettings)));
		var indexStringsToExceptionMessages = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (idx, messageStr) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(idx),
							messageStr);
					}),
				A2($elm$core$List$cons, 'Other', customInvoiceExceptionMessages)));
		var onSelectInput = function (val) {
			var otherIsSelected = val === '0';
			var maybeSelectedMessage = A2($elm$core$Dict$get, val, indexStringsToExceptionMessages);
			return otherIsSelected ? $author$project$Factoring$Page$ClientSubmissionInvoice$SetCustomExceptionText(
				$author$project$Factoring$Page$ClientSubmissionInvoice$Other('')) : A2(
				$elm$core$Maybe$withDefault,
				$author$project$Factoring$Page$ClientSubmissionInvoice$NoOp,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Factoring$Page$ClientSubmissionInvoice$SetCustomExceptionText, $author$project$Factoring$Page$ClientSubmissionInvoice$Predefined),
					maybeSelectedMessage));
		};
		var selectValue = function () {
			var _v1 = model.customExceptionText;
			if (_v1.$ === 'Other') {
				return '0';
			} else {
				var val = _v1.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'-1',
					A2(
						$elm$core$Dict$get,
						val,
						$elm_community$dict_extra$Dict$Extra$invert(indexStringsToExceptionMessages)));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rules__add-custom-exception-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rules__custom-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Custom Exception')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rules__custom-input')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hubtran-input__select'),
									$elm$html$Html$Events$onInput(onSelectInput),
									$elm$html$Html$Attributes$value(selectValue)
								]),
							A2(
								$elm$core$List$map,
								function (_v0) {
									var idxStr = _v0.a;
									var message = _v0.b;
									return A2(
										$elm$html$Html$option,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$value(idxStr)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(message)
											]));
								},
								$elm$core$Dict$toList(indexStringsToExceptionMessages))),
						$author$project$Factoring$Page$ClientSubmissionInvoice$maybeViewFreeFormCustomException(model))),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rules__add-exception-button-right'),
									$elm$html$Html$Events$onClick(
									$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
										$author$project$Factoring$Page$ClientSubmission$Change$CreateCustomException(effectiveValue)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Factoring$Page$ClientSubmissionInvoice$HideCustomExceptionForm),
									$elm$html$Html$Attributes$class('rules__cancel-custom-exception')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Helpers$String$nbsp)
								]))
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmission$Change$Rule = F2(
	function (a, b) {
		return {$: 'Rule', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$ShowExceptionResolutionForm = function (a) {
	return {$: 'ShowExceptionResolutionForm', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptionDetailRow = F3(
	function (invoice, exception, el) {
		var resolutionMessage = function () {
			var _v0 = exception.possibleResolutionMessage;
			if (_v0.$ === 'Nothing') {
				return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
			} else {
				var message = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Helpers$String$nbsp + ('Resolution Message: ' + message))
						]));
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rules__item'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rules__item-text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('text'),
								el.item),
							_List_fromArray(
								[
									$elm$html$Html$text(exception.formattedMessage)
								])),
							resolutionMessage
						])),
					A2(
					$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
					!invoice.readonly,
					A2(
						$elm$html$Html$button,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('rules__ignore-button'),
							el.button),
						_List_fromArray(
							[
								$elm$html$Html$text(el.text)
							])))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$HideExceptionResolutionForm = {$: 'HideExceptionResolutionForm'};
var $author$project$Factoring$Page$ClientSubmission$Change$ResolveException = F2(
	function (a, b) {
		return {$: 'ResolveException', a: a, b: b};
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$SetResolutionText = function (a) {
	return {$: 'SetResolutionText', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewResolveForm = F2(
	function (model, id) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rules__resolve-exception-form-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rules__custom-input')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$textarea,
							$author$project$Helpers$Attributes$blockGrammarly(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Resolution message'),
										$elm$html$Html$Events$onInput($author$project$Factoring$Page$ClientSubmissionInvoice$SetResolutionText),
										$elm$html$Html$Attributes$value(model.exceptionResolutionText)
									])),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rules__add-exception-button-right'),
									$elm$html$Html$Events$onClick(
									$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
										A2($author$project$Factoring$Page$ClientSubmission$Change$ResolveException, model.exceptionResolutionText, id)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Resolve Exception')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Factoring$Page$ClientSubmissionInvoice$HideExceptionResolutionForm),
									$elm$html$Html$Attributes$class('rules__cancel-custom-exception')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Helpers$String$nbsp)
								]))
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptionDetailItem = F4(
	function (model, invoice, exception, el) {
		var _v0 = model.resolvingException;
		if (_v0.$ === 'Nothing') {
			return A3($author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptionDetailRow, invoice, exception, el);
		} else {
			var id = _v0.a;
			return _Utils_eq(
				exception.possibleId,
				$elm$core$Maybe$Just(id)) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rules__resolution-exception-container')
					]),
				_List_fromArray(
					[
						A3($author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptionDetailRow, invoice, exception, el),
						A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewResolveForm, model, id)
					])) : A3($author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptionDetailRow, invoice, exception, el);
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptionDetail = F3(
	function (model, invoice, exception) {
		return A4(
			$author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptionDetailItem,
			model,
			invoice,
			exception,
			function () {
				var _v0 = exception.data;
				switch (_v0.$) {
					case 'Required':
						return {
							button: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('rules__ignore-button--disabled'),
									$elm$html$Html$Attributes$disabled(true)
								]),
							item: _List_Nil,
							text: 'Required'
						};
					case 'Resolvable':
						if (_v0.a.a.$ === 'Enabled') {
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							var disableButton = _Utils_eq(exception.possibleId, model.resolvingException);
							return {
								button: _List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Factoring$Page$ClientSubmissionInvoice$ShowExceptionResolutionForm(exception.possibleId)),
										$elm$html$Html$Attributes$disabled(disableButton),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('rules__ignore-button--disabled', disableButton)
											]))
									]),
								item: _List_Nil,
								text: 'Resolve'
							};
						} else {
							var _v3 = _v0.a;
							var _v4 = _v3.a;
							return {
								button: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('rules__ignore-button--disabled'),
										$elm$html$Html$Attributes$disabled(true)
									]),
								item: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('rules__ignored')
									]),
								text: 'Resolved'
							};
						}
					default:
						if (_v0.a.a.$ === 'Enabled') {
							var _v5 = _v0.a;
							var _v6 = _v5.a;
							var raw = _v5.b;
							return {
								button: _List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
											A2($author$project$Factoring$Page$ClientSubmission$Change$Rule, $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Ignored, raw)))
									]),
								item: _List_Nil,
								text: 'Ignore'
							};
						} else {
							var _v7 = _v0.a;
							var _v8 = _v7.a;
							var raw = _v7.b;
							return {
								button: _List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
											A2($author$project$Factoring$Page$ClientSubmission$Change$Rule, $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$Enabled, raw)))
									]),
								item: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('rules__ignored')
									]),
								text: 'Enable'
							};
						}
				}
			}());
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewRuleAlert = function (count) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('round alert label rules__header__alert')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(count))
			]));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptions = F4(
	function (data, model, invoice, showCustomExceptions) {
		var _v0 = _Utils_Tuple2(showCustomExceptions, invoice.exceptions);
		if ((!_v0.a) && (!_v0.b.b)) {
			return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
		} else {
			var messages = _v0.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__rules')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rules__header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Exceptions' + $author$project$Helpers$String$nbsp),
								function () {
								var _v1 = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Factoring$Page$ClientSubmission$CacheData$Exception$passing),
									invoice.exceptions);
								if (!_v1.b) {
									return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
								} else {
									var xs = _v1;
									return $author$project$Factoring$Page$ClientSubmissionInvoice$viewRuleAlert(
										$elm$core$List$length(xs));
								}
							}(),
								A2(
								$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
								showCustomExceptions,
								A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewAddCustomExceptionButton, invoice, model)),
								A2(
								$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
								model.viewCustomExceptionForm,
								A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewCustomExceptionForm, data, model))
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rules__list')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptionDetail, model, invoice),
							messages))
					]));
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewLoadIdMismatchMessage = function () {
	var alert = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('alert client-submission__load-id-mismatch-alert')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fi-x-circle')
					]),
				_List_Nil),
				$elm$html$Html$text(' Load ID does not match debtor load pattern')
			]));
	return A2(
		$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
		'',
		{autofill: $elm$core$Maybe$Nothing, finder: $author$project$Indexer$Group$None, formatted: $author$project$Factoring$Page$ClientSubmissionInvoice$empty, inputFinder: $author$project$Indexer$Group$None, lastColumn: alert});
}();
var $author$project$Factoring$Page$ClientSubmission$Change$MissingPages = function (a) {
	return {$: 'MissingPages', a: a};
};
var $author$project$Factoring$Page$ClientSubmission$Change$hasMissingPages = $elm$core$List$any(
	function (change) {
		if (change.$ === 'MissingPages') {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewMissingPagesToggle = F4(
	function (accountSettings, _v0, changes, _v1) {
		var missingPages = _v0.missingPages;
		var documentTypeValue = _v1.documentTypeValue;
		var documentType = $author$project$Domain$Document$documentTypeValueToUnresolved(documentTypeValue);
		var row = F2(
			function (verb, types) {
				return A4(
					$author$project$Factoring$Page$ClientSubmissionInvoice$viewToggleRow,
					'Missing Pages',
					verb + (' ' + A2($author$project$Factoring$Page$ClientSubmissionInvoice$documentName, accountSettings, documentType)),
					$elm$core$List$isEmpty(missingPages) ? A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('No pages')
							])) : A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Factoring$Page$ClientSubmissionInvoice$bem('row__mismatch')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$String$join,
									', ',
									A2(
										$elm$core$List$map,
										$author$project$Factoring$Page$ClientSubmissionInvoice$documentName(accountSettings),
										missingPages)))
							])),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(
							$author$project$Factoring$Page$ClientSubmission$Change$hasMissingPages(changes)),
							$elm$html$Html$Events$onClick(
							$author$project$Factoring$Page$ClientSubmissionInvoice$QueueChange(
								$author$project$Factoring$Page$ClientSubmission$Change$MissingPages(types)))
						]));
			});
		return A2($elm$core$List$member, documentType, missingPages) ? A2(
			row,
			'Remove',
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(documentType),
				missingPages)) : A2(
			row,
			'Add ',
			A2($elm$core$List$cons, documentType, missingPages));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewPaymentsNetworkLoad = A2(
	$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
	$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
	function (id) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('TPay Network Load Id: ' + id)
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$emailInValidDomains = F2(
	function (validDomains, emailMaybe) {
		if (emailMaybe.$ === 'Nothing') {
			return true;
		} else {
			var email = emailMaybe.a;
			if ($elm$core$List$isEmpty(validDomains)) {
				return true;
			} else {
				var extractedDomain = function () {
					var _v1 = A2($elm$core$String$split, '@', email);
					if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
						var _v2 = _v1.b;
						var domain = _v2.a;
						return $elm$core$String$toLower(domain);
					} else {
						return '';
					}
				}();
				return (extractedDomain === '') ? true : A2(
					$elm$core$List$member,
					extractedDomain,
					A2($elm$core$List$map, $elm$core$String$toLower, validDomains));
			}
		}
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$rateConEmail = function (data) {
	return A2(
		$elm$core$Maybe$andThen,
		function (doc) {
			return $elm$core$List$head(doc.brokerEmailAddresses);
		},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (doc) {
					return !$elm$core$List$isEmpty(doc.brokerEmailAddresses);
				},
				A2(
					$elm$core$List$filter,
					function (doc) {
						return _Utils_eq(
							$author$project$Domain$Document$documentTypeValueToUnresolved(doc.documentTypeValue),
							$author$project$Domain$UnresolvedDocumentType$Resolved($author$project$AuditPb$DocumentTypeRateConfirmation));
					},
					data.invoiceDocuments))));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewRateConEmailValidation = function (_v0) {
	var isPaymentsNetworkInvoice = _v0.isPaymentsNetworkInvoice;
	var data = _v0.data;
	var debtor = _v0.debtor;
	var validEmailDomains = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.emailDomainsToValidate;
			},
			debtor));
	var rateConfirmationEmail = $author$project$Factoring$Page$ClientSubmissionInvoice$rateConEmail(data);
	var emailMatchesValidDomains = A2($author$project$Factoring$Page$ClientSubmissionInvoice$emailInValidDomains, validEmailDomains, rateConfirmationEmail);
	var brokerEmail = $author$project$Factoring$Page$ClientSubmissionInvoice$factorBrokerEmail(debtor);
	var emailMatchesBrokerEmail = _Utils_eq(brokerEmail, rateConfirmationEmail);
	var isEmailValid = emailMatchesValidDomains || emailMatchesBrokerEmail;
	return (isEmailValid || isPaymentsNetworkInvoice) ? _List_fromArray(
		[$author$project$Factoring$Page$ClientSubmissionInvoice$empty]) : _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert client-submission__rate-con-email-matcher')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-x-circle')
						]),
					_List_Nil),
					$elm$html$Html$text(' Email on rate con does not match')
				]))
		]);
};
var $author$project$Domain$Verification$isAmountFailure = function (failure) {
	return _Utils_eq(failure.message, $author$project$AuditPb$VerificationFailureMessageAmountMismatchFailure);
};
var $author$project$Domain$Verification$hasLoadAndAmountFailures = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filter(
		function (x) {
			return _Utils_eq($author$project$AuditPb$VerificationFailureMessageLoadIssueFailure, x.message) || $author$project$Domain$Verification$isAmountFailure(x);
		}),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$length,
		$elm$core$Basics$eq(2)));
var $author$project$Domain$Verification$viewDetails = function (failures) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('column')
			]),
		A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Domain$Verification$viewDetailMessage(x))
						]));
			},
			$author$project$Domain$Verification$hasLoadAndAmountFailures(failures) ? A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Domain$Verification$isAmountFailure),
				failures) : failures));
};
var $author$project$Domain$Verification$viewDisclosure = function (verification) {
	var _v0 = verification.state;
	switch (_v0.$) {
		case 'Verification_State_Success':
			return $elm$html$Html$text('');
		case 'Verification_State_Pending':
			return $elm$html$Html$text('');
		case 'Verification_State_NonParticipatingCarrier':
			return $elm$html$Html$text('');
		case 'Verification_State_UnverifiableLoad':
			return $elm$html$Html$text('');
		case 'Verification_State_UnconfirmedDelivery':
			return $elm$html$Html$text('');
		default:
			var failures = _v0.a.failures;
			return $author$project$Domain$Verification$viewDetails(failures);
	}
};
var $author$project$Domain$Verification$viewHeader = function (verification) {
	var _v0 = $author$project$Domain$Verification$verdict(verification);
	var severity = _v0.severity;
	var label = _v0.label;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						'verification__verdict-indicator verification__verdict-indicator--' + $author$project$Domain$Verification$severityClass(severity))
					]),
				_List_Nil),
				$elm$html$Html$text('Broker Verification: ' + label)
			]));
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewVerification = A2(
	$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
	$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
	function (verification) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row collapse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$author$project$Domain$Verification$viewHeader(verification)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__document-information')
						]),
					_List_fromArray(
						[
							$author$project$Domain$Verification$viewDisclosure(verification)
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewSubmission = F5(
	function (data, model, submission, account, documentTypes) {
		var invoice = submission.invoice;
		var submissionInvoiceDateString = $author$project$Factoring$Page$ClientSubmissionInvoice$maybeDateToFormattedString(submission.invoiceDate);
		var showClientInvoiceDocumentAuditInputs = submission.auditClientInvoiceDocument;
		var showInvoiceDateField = showClientInvoiceDocumentAuditInputs && account.showInvoiceDateInputInSubmissionWorkflow;
		var rateConPresent = A2(
			$elm$core$List$member,
			$author$project$Domain$UnresolvedDocumentType$Resolved($author$project$AuditPb$DocumentTypeRateConfirmation),
			documentTypes);
		var isPaymentsNetworkInvoice = A2($author$project$Factoring$Page$ClientSubmissionInvoice$paymentsNetworkInvoice, account, invoice);
		var invoiceDateString = $author$project$Factoring$Page$ClientSubmissionInvoice$maybeDateToFormattedString(invoice.invoiceDate);
		var groups = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.groupedDocuments;
			},
			$author$project$Forward$Remote$toMaybe(data.pageData.documentPagesData));
		var displayFundingNotesAllowed = $author$project$Factoring$Page$ClientSubmissionInvoice$shouldDisplayFundingNotesFromSettings(
			$author$project$Forward$Remote$toMaybe(data.accountSettings));
		var clientTermLower = $elm$core$String$toLower(
			$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$FactorAccount));
		var callDebtorDetailRow = function (viewerFunction) {
			return $author$project$Factoring$Page$ClientSubmissionInvoice$debtorDetailRow(
				{data: data, invoice: invoice, isPaymentsNetworkInvoice: isPaymentsNetworkInvoice, submission: submission, viewer: viewerFunction});
		};
		var cadenceFundingNotes = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.fundingNotes;
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.tmsCarrier;
				},
				$author$project$Forward$Remote$toMaybe(data.pageData.documentBatchData)));
		var cadenceFundingNotesView = displayFundingNotesAllowed ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('client-submission__submission-value')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Factoring$Page$ClientSubmissionInvoice$ShowFundingNotes)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('View Funding Notes ')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fi-clipboard-notes')
											]),
										_List_Nil)
									]))
							]));
				},
				cadenceFundingNotes)) : $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
		var bolPresent = A2(
			$elm$core$List$member,
			$author$project$Domain$UnresolvedDocumentType$Resolved($author$project$AuditPb$DocumentTypeBillOfLading),
			documentTypes);
		var showManuallyCheckThirdPartyListedOnBol = account.manuallyCheckThirdPartyListedOnBol && bolPresent;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('client-submission__no-select', model.holdingShift)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Details')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__document-information')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$staticRow,
							'Account Executive',
							A2($elm$core$Maybe$withDefault, 'None', submission.carrier.acctExec)),
							A2($author$project$Factoring$Page$ClientSubmissionInvoice$carrierNameRow, submission.carrier.name, cadenceFundingNotesView),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							account.allowManualSubmissionReassignmentInSubmissionWorkflow,
							A2(
								$author$project$Factoring$Page$ClientSubmissionInvoice$viewRow,
								'Client Load',
								{
									autofill: $elm$core$Maybe$Nothing,
									finder: $author$project$Indexer$Group$None,
									formatted: A2(
										$elm$html$Html$map,
										$author$project$Factoring$Page$ClientSubmissionInvoice$SubmissionDropdownMsg,
										A2($author$project$Factoring$Page$ClientSubmission$SubmissionDropdown$view, data.submissionDropdown, model.submissionDropdown)),
									inputFinder: $author$project$Indexer$Group$None,
									lastColumn: $elm$html$Html$text('')
								})),
							A5($author$project$Factoring$Page$ClientSubmissionInvoice$debtorTypeaheadRow, 'Debtor', data.debtorWithAddressTypeahead, model.debtorWithAddressTypeahead, submission, invoice),
							callDebtorDetailRow($author$project$Factoring$Page$ClientSubmissionInvoice$viewDebtorEmail),
							callDebtorDetailRow($author$project$Factoring$Page$ClientSubmissionInvoice$viewRateConEmailValidation),
							callDebtorDetailRow($author$project$Factoring$Page$ClientSubmissionInvoice$viewDebtorAddress),
							callDebtorDetailRow(
							A2(
								$author$project$Factoring$Page$ClientSubmissionInvoice$viewDebtorDetail,
								A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('MC: ')
										])),
								function ($) {
									return $.mcNumber;
								})),
							callDebtorDetailRow(
							A2(
								$author$project$Factoring$Page$ClientSubmissionInvoice$viewDebtorDetail,
								A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('DOT: ')
										])),
								function ($) {
									return $.dotNumber;
								})),
							$author$project$Factoring$Page$ClientSubmissionInvoice$clientDebtorNoaStatusRow(invoice),
							callDebtorDetailRow(
							A2(
								$author$project$Factoring$Page$ClientSubmissionInvoice$viewDebtorDetail,
								A2($author$project$Factoring$Page$ClientSubmissionInvoice$alertWithTooltip, 'Warning', true),
								function ($) {
									return $.warning;
								})),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							account.checkClientOrDebtorOnBol && bolPresent,
							A3(
								$author$project$Factoring$Page$ClientSubmissionInvoice$checkboxRow,
								'Client or Debtor on BOL',
								$author$project$Factoring$Page$ClientSubmission$Change$ClientOrDebtorOnBol,
								{
									checked: A3($author$project$Factoring$Page$ClientSubmission$Change$getBoolean, $author$project$Factoring$Page$ClientSubmission$Change$ClientOrDebtorOnBol, invoice.clientOrDebtorOnBol, model.changes),
									disabled: invoice.readonly,
									finder: $author$project$Indexer$Group$Any(
										_List_fromArray(
											[
												$author$project$Indexer$Group$Text(submission.carrier.name),
												A3(
												$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
												$author$project$Indexer$Group$None,
												A2(
													$elm$core$Basics$composeL,
													$author$project$Indexer$Group$Text,
													function ($) {
														return $.name;
													}),
												invoice.debtor),
												A2(
												$author$project$Indexer$Group$InContext,
												$author$project$Indexer$Group$MissingPrimary,
												$author$project$Indexer$Group$Text(clientTermLower))
											])),
									formatted: showManuallyCheckThirdPartyListedOnBol ? $elm$html$Html$text('') : A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button tiny')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View BOL')
											])),
									inputFinder: $author$project$Indexer$Group$None,
									jumpTo: $author$project$AuditPb$DocumentTypeBillOfLading
								})),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							showManuallyCheckThirdPartyListedOnBol,
							A3(
								$author$project$Factoring$Page$ClientSubmissionInvoice$checkboxRow,
								'Third party listed on BOL',
								$author$project$Factoring$Page$ClientSubmission$Change$ThirdPartyListedOnBol,
								{
									checked: A3($author$project$Factoring$Page$ClientSubmission$Change$getBoolean, $author$project$Factoring$Page$ClientSubmission$Change$ThirdPartyListedOnBol, invoice.thirdPartyListedOnBol, model.changes),
									disabled: invoice.readonly,
									finder: $author$project$Indexer$Group$None,
									formatted: A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button tiny')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View BOL')
											])),
									inputFinder: $author$project$Indexer$Group$None,
									jumpTo: $author$project$AuditPb$DocumentTypeBillOfLading
								})),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							!bolPresent,
							A3(
								$author$project$Factoring$Page$ClientSubmissionInvoice$checkboxRow,
								'TONU',
								$author$project$Factoring$Page$ClientSubmission$Change$Tonu,
								{
									checked: A3($author$project$Factoring$Page$ClientSubmission$Change$getBoolean, $author$project$Factoring$Page$ClientSubmission$Change$Tonu, invoice.tonu, model.changes),
									disabled: invoice.readonly,
									finder: $author$project$Indexer$Group$None,
									formatted: A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Factoring$Page$ClientSubmissionInvoice$bem('compact-details'),
												$author$project$Factoring$Page$ClientSubmissionInvoice$bem('value-label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('No BOL present')
											])),
									inputFinder: $author$project$Indexer$Group$None,
									jumpTo: $author$project$AuditPb$DocumentTypeBillOfLading
								})),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							showClientInvoiceDocumentAuditInputs,
							A3(
								$author$project$Factoring$Page$ClientSubmissionInvoice$inputRow,
								'Invoice #',
								$author$project$Factoring$Page$ClientSubmission$Change$Number,
								{
									clean: $elm$core$Basics$identity,
									disabled: invoice.readonly,
									finder: $author$project$Indexer$Group$Text(submission.number),
									formatted: $elm$html$Html$text(submission.number),
									inputFinder: $author$project$Indexer$Group$Text(invoice.number),
									inputValue: A3($author$project$Factoring$Page$ClientSubmission$Change$getText, $author$project$Factoring$Page$ClientSubmission$Change$Number, invoice.number, model.changes),
									raw: submission.number,
									trim: false
								})),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							showInvoiceDateField,
							A4(
								$author$project$Factoring$Page$ClientSubmissionInvoice$inputRow_,
								'Invoice Date',
								$author$project$Factoring$Page$ClientSubmission$Change$InvoiceDate,
								$author$project$Factoring$Page$ClientSubmissionInvoice$getDateInputHandlers,
								{
									clean: $elm$core$Basics$identity,
									disabled: invoice.readonly,
									finder: $author$project$Indexer$Group$Date(submissionInvoiceDateString),
									formatted: $elm$html$Html$text(submissionInvoiceDateString),
									inputFinder: $author$project$Indexer$Group$Date(invoiceDateString),
									inputValue: A2(
										$elm$core$Maybe$withDefault,
										A3($author$project$Factoring$Page$ClientSubmission$Change$getText, $author$project$Factoring$Page$ClientSubmission$Change$InvoiceDate, invoiceDateString, model.changes),
										model.dirtyInvoiceDate),
									raw: submissionInvoiceDateString,
									trim: false
								})),
							A3(
							$author$project$Factoring$Page$ClientSubmissionInvoice$inputRow,
							'Load ID',
							$author$project$Factoring$Page$ClientSubmission$Change$LoadId,
							{
								clean: $elm$core$Basics$identity,
								disabled: invoice.readonly,
								finder: $author$project$Indexer$Group$Text(submission.loadId),
								formatted: $elm$html$Html$text(submission.loadId),
								inputFinder: $author$project$Indexer$Group$Text(invoice.loadId),
								inputValue: A3($author$project$Factoring$Page$ClientSubmission$Change$getText, $author$project$Factoring$Page$ClientSubmission$Change$LoadId, invoice.loadId, model.changes),
								raw: submission.loadId,
								trim: true
							}),
							A2($author$project$Factoring$Page$ClientSubmissionInvoice$showIf, invoice.loadIdPatternMismatch, $author$project$Factoring$Page$ClientSubmissionInvoice$viewLoadIdMismatchMessage),
							A4(
							$author$project$Factoring$Page$ClientSubmissionInvoice$inputRow_,
							'Amount',
							$author$project$Factoring$Page$ClientSubmission$Change$Amount,
							$author$project$Factoring$Page$ClientSubmissionInvoice$getAmountInputHandlers,
							{
								clean: $author$project$Factoring$Page$ClientSubmissionInvoice$cleanAmount,
								disabled: invoice.readonly,
								finder: $author$project$Indexer$Group$Amount(submission.amount),
								formatted: $elm$html$Html$text(
									$author$project$Factoring$Page$ClientSubmissionInvoice$formatAmount(submission.amount)),
								inputFinder: $author$project$Indexer$Group$Amount(invoice.amount),
								inputValue: A2(
									$elm$core$Maybe$withDefault,
									A3($author$project$Factoring$Page$ClientSubmission$Change$getText, $author$project$Factoring$Page$ClientSubmission$Change$Amount, invoice.amount, model.changes),
									model.dirtyInvoiceAmount),
								raw: submission.amount,
								trim: false
							}),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							account.manuallyCheckAmountMatchesRateCon && rateConPresent,
							A3(
								$author$project$Factoring$Page$ClientSubmissionInvoice$checkboxRow,
								'Amount matches rate con',
								$author$project$Factoring$Page$ClientSubmission$Change$AmountMatchesRateCon,
								{
									checked: A3($author$project$Factoring$Page$ClientSubmission$Change$getBoolean, $author$project$Factoring$Page$ClientSubmission$Change$AmountMatchesRateCon, invoice.amountMatchesRateCon, model.changes),
									disabled: invoice.readonly,
									finder: $author$project$Indexer$Group$Amount(submission.amount),
									formatted: A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button tiny')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View Rate Con')
											])),
									inputFinder: $author$project$Indexer$Group$None,
									jumpTo: $author$project$AuditPb$DocumentTypeRateConfirmation
								})),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							account.manuallyCheckPickupDropoffMatches && (rateConPresent && bolPresent),
							A3(
								$author$project$Factoring$Page$ClientSubmissionInvoice$checkboxRow,
								'Pick up/drop off matches',
								$author$project$Factoring$Page$ClientSubmission$Change$PickupDropoffMatches,
								{
									checked: A3($author$project$Factoring$Page$ClientSubmission$Change$getBoolean, $author$project$Factoring$Page$ClientSubmission$Change$PickupDropoffMatches, invoice.pickupDropoffMatches, model.changes),
									disabled: invoice.readonly,
									finder: $author$project$Indexer$Group$Amount(submission.amount),
									formatted: A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button tiny')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View Docs')
											])),
									inputFinder: $author$project$Indexer$Group$None,
									jumpTo: A2($author$project$Factoring$Page$ClientSubmissionInvoice$alternateRateConAndBolDoctype, model, groups)
								})),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							!invoice.readonly,
							A3(
								$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
								$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
								A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewBadQualityToggle, invoice, model.changes),
								A2($author$project$Factoring$Page$ClientSubmissionInvoice$getDocumentPage, data, model))),
							A2(
							$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
							!invoice.readonly,
							A3(
								$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
								$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
								A3($author$project$Factoring$Page$ClientSubmissionInvoice$viewMissingPagesToggle, account, invoice, model.changes),
								A2($author$project$Factoring$Page$ClientSubmissionInvoice$getDocument, data, model)))
						])),
					A2(
					$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
					account.displayAutomatedVerificationsOnSubmissionWorkflow,
					$author$project$Factoring$Page$ClientSubmissionInvoice$viewVerification(invoice.verification)),
					A2(
					$author$project$Factoring$Page$ClientSubmissionInvoice$showIf,
					A2($author$project$Factoring$Page$ClientSubmissionInvoice$paymentsNetworkInvoice, account, invoice),
					$author$project$Factoring$Page$ClientSubmissionInvoice$viewPaymentsNetworkLoad(invoice.paymentsNetworkExternalLoadId)),
					A4($author$project$Factoring$Page$ClientSubmissionInvoice$viewExceptions, data, model, invoice, account.allowCustomExceptions),
					A2($author$project$Factoring$Page$ClientSubmissionInvoice$viewApproveReject, invoice, model.changes)
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewLeftSide = F4(
	function (data, model, submission, accountSettings) {
		var selection = model.selection;
		var groupMismatch = function () {
			var _v2 = data.documentBatch;
			if (_v2.$ === 'Just') {
				var batch = _v2.a;
				return batch.groupMismatch;
			} else {
				return false;
			}
		}();
		var groupDocumentTypes = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Domain$Document$documentTypeValueToUnresolved,
				function ($) {
					return $.documentTypeValue;
				}),
			data.invoiceDocuments);
		var unknown = A2($author$project$Factoring$Page$ClientSubmissionInvoice$unknownSelections, selection.group, groupDocumentTypes);
		var showIdentifier = function () {
			if (!unknown.b) {
				return model.identifyDocuments.isSaving;
			} else {
				return true;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('xlarge-2 document-indexer__work-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id($author$project$Factoring$Page$ClientSubmissionInvoice$topOfWorkArea)
								]),
							_List_Nil),
							A3(
							$author$project$Factoring$Page$ClientSubmissionInvoice$maybe,
							$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
							$author$project$Factoring$Page$ClientSubmissionInvoice$viewOnLoadTrigger,
							$elm$core$Result$toMaybe(data.originalSelection)),
							function () {
							var _v0 = _Utils_Tuple2(showIdentifier, groupMismatch);
							if (!_v0.a) {
								if (!_v0.b) {
									return A5($author$project$Factoring$Page$ClientSubmissionInvoice$viewSubmission, data, model, submission, accountSettings, groupDocumentTypes);
								} else {
									return A3(
										$author$project$Helpers$WaitingSpinner$waitingSpinnerWithText,
										'Saving',
										$author$project$Factoring$Page$ClientSubmission$Change$hasDocumentType(model.changes),
										_List_fromArray(
											[
												A2(
												$author$project$Forward$LoadingView$view,
												function (resolvedDocumentPagesData) {
													return $author$project$Factoring$Page$ClientSubmissionInvoice$viewGroupMismatch(resolvedDocumentPagesData.loadedDocumentBatch.documentBatch);
												},
												data.pageData.documentPagesData)
											]));
								}
							} else {
								return A2(
									$author$project$Forward$LoadingView$view,
									function (resolvedDocumentPagesInfo) {
										return A4($author$project$Factoring$Page$ClientSubmissionInvoice$viewIdentifyDocuments, data, model, resolvedDocumentPagesInfo, unknown);
									},
									data.pageData.documentPagesData);
							}
						}()
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$DismissMoveDocumentsModal = {$: 'DismissMoveDocumentsModal'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$PerformMoveDocuments = {$: 'PerformMoveDocuments'};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewMoveDocumentsModal = function (model) {
	var dismissMsg = $author$project$Factoring$Page$ClientSubmissionInvoice$DismissMoveDocumentsModal;
	var config = {
		body: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(model.moveDocumentsModal.text)
				])),
		confirm: $elm$core$Maybe$Just(
			{msg: $author$project$Factoring$Page$ClientSubmissionInvoice$PerformMoveDocuments, text: 'Move Documents'}),
		dismissText: $elm$core$Maybe$Just('Cancel'),
		header: $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('client-submission__funding-notes--header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Move Documents')
							]))
					]))),
		modalClassOverride: $elm$core$Maybe$Nothing,
		performing: model.moveDocumentsModal.isPerforming,
		performingText: $elm$core$Maybe$Just('Moving documents...'),
		success: model.moveDocumentsModal.succeeded,
		successText: $elm$core$Maybe$Nothing
	};
	return model.moveDocumentsModal.isShown ? A2($author$project$Components$Shared$ModalDialog$view, dismissMsg, config) : $elm$html$Html$text('');
};
var $author$project$Factoring$Page$ClientSubmissionInvoice$viewLoaded = F2(
	function (model, data) {
		var reviewHeader = $author$project$Factoring$Page$ClientSubmissionInvoice$getFullyReviewed(data) ? A2(
			$author$project$Factoring$Page$ClientSubmission$Header$Link,
			'Review',
			$author$project$Path$toString(
				A2(
					$author$project$Path$addQueries,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'onDone',
							$author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault(model.onDoneQuery))
						]),
					$author$project$Path$submissionReview(model.emailMessageId)))) : $author$project$Factoring$Page$ClientSubmission$Header$Disabled('Review');
		var steps = _List_fromArray(
			[
				$author$project$Factoring$Page$ClientSubmission$Header$Active('Process'),
				reviewHeader
			]);
		var primaryBrowser = A2($author$project$Factoring$Page$ClientSubmissionInvoice$Browser, model.selection, model.documentBrowser);
		var moveDocumentsModal = $author$project$Factoring$Page$ClientSubmissionInvoice$viewMoveDocumentsModal(model);
		var fundingNotesText = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.fundingNotes;
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.tmsCarrier;
				},
				$author$project$Forward$Remote$toMaybe(data.pageData.documentBatchData)));
		var fundingNotesCarrier = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.name;
			},
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.tmsCarrier;
				},
				$author$project$Forward$Remote$toMaybe(data.pageData.documentBatchData)));
		var fundingNotesModal = A2($author$project$Factoring$Page$ClientSubmissionInvoice$shouldDisplayFundingNotes, data, model) ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Factoring$Page$ClientSubmissionInvoice$empty,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Shared$ModalDialog$view($author$project$Factoring$Page$ClientSubmissionInvoice$HideFundingNotes),
				A3($elm$core$Maybe$map2, $author$project$Factoring$Page$ClientSubmissionInvoice$fundingNotesModalConfig, fundingNotesCarrier, fundingNotesText))) : $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
		var allGroupsUnreviewed = $author$project$Forward$Remote$toMaybe(data.allGroupsUnreviewed);
		var headerModel = A4(
			$author$project$Factoring$Page$ClientSubmission$Header$Model,
			$author$project$Forward$Remote$toMaybe(data.accountSettings),
			$author$project$Forward$Remote$toMaybe(data.pageData.documentBatchData),
			$elm$core$Maybe$Just(model.presence),
			A2($elm$core$Maybe$withDefault, false, allGroupsUnreviewed));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-container')
				]),
			_List_fromArray(
				[
					A4($author$project$Factoring$Page$ClientSubmission$Header$view, $author$project$Factoring$Page$ClientSubmissionInvoice$HeaderMsg, model.timezone, headerModel, steps),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-indexer__main-body')
						]),
					_List_fromArray(
						[
							fundingNotesModal,
							moveDocumentsModal,
							function () {
							var _v0 = model.documentBrowser.size;
							if (_v0.$ === 'Expanded') {
								return $author$project$Factoring$Page$ClientSubmissionInvoice$empty;
							} else {
								var _v1 = model.secondaryDocumentBrowser;
								if (_v1.$ === 'Just') {
									var secondaryBrowser = _v1.a;
									return A4($author$project$Factoring$Page$ClientSubmissionInvoice$viewBrowser, data, model, secondaryBrowser, true);
								} else {
									var _v2 = data.submission;
									if (_v2.$ === 'Ok') {
										var submission = _v2.a;
										return A2(
											$author$project$Forward$LoadingView$view,
											A3($author$project$Factoring$Page$ClientSubmissionInvoice$viewLeftSide, data, model, submission),
											data.accountSettings);
									} else {
										var loadingError = _v2.a;
										return $author$project$Forward$LoadingView$defaultErrorView(
											$author$project$Forward$Remote$Unloadable(
												$author$project$Factoring$Page$ClientSubmission$CacheData$loadingErrorToString(loadingError)));
									}
								}
							}
						}(),
							(!model.regroupInProgress) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A3(
							$author$project$Helpers$WaitingSpinner$waitingSpinnerWithText,
							'Regrouping',
							true,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('row general-container')
										]),
									_List_Nil)
								])),
							A4($author$project$Factoring$Page$ClientSubmissionInvoice$viewBrowser, data, model, primaryBrowser, false)
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionInvoice$view = F2(
	function (data, model) {
		return A2(
			$author$project$Forward$LoadingView$view,
			$author$project$Factoring$Page$ClientSubmissionInvoice$viewLoaded(model),
			data);
	});
var $author$project$Factoring$Page$ClientSubmissionReview$LeftSideData = F4(
	function (user, sections, coreInfo, pageData) {
		return {coreInfo: coreInfo, pageData: pageData, sections: sections, user: user};
	});
var $author$project$Factoring$Page$ClientSubmission$CacheData$cacheDataResultToRemote = function (result) {
	if (result.$ === 'Ok') {
		var sections = result.a;
		return $author$project$Forward$Remote$Loaded(sections);
	} else {
		var loadingError = result.a;
		return $author$project$Forward$Remote$Error(
			$author$project$Forward$Remote$Unloadable(
				$author$project$Factoring$Page$ClientSubmission$CacheData$loadingErrorToString(loadingError)));
	}
};
var $author$project$Forward$Remote$map4 = F5(
	function (f, remoteA, remoteB, remoteC, remoteD) {
		return A3(
			$author$project$Forward$Remote$map2,
			F2(
				function (_v0, _v1) {
					var a = _v0.a;
					var b = _v0.b;
					var c = _v1.a;
					var d = _v1.b;
					return A4(f, a, b, c, d);
				}),
			A3($author$project$Forward$Remote$map2, $elm$core$Tuple$pair, remoteA, remoteB),
			A3($author$project$Forward$Remote$map2, $elm$core$Tuple$pair, remoteC, remoteD));
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$getDocumentsInGroup = F2(
	function (selection, groupedDocuments) {
		return A2($author$project$Indexer$Group$getDocumentsInGroup, groupedDocuments, selection);
	});
var $author$project$Factoring$Page$EmailMessage$IdentifyDocuments$unknownDocuments = F2(
	function (selection, groupedDocuments) {
		var documents = A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$getDocumentsInGroup, selection, groupedDocuments);
		return A3(
			$elm$core$List$foldl,
			F2(
				function (document, _v0) {
					var currentIndex = _v0.a;
					var unknownSelections = _v0.b;
					return _Utils_eq(
						$author$project$Domain$Document$documentTypeValueToUnresolved(document.documentTypeValue),
						$author$project$Domain$UnresolvedDocumentType$Unknown) ? _Utils_Tuple2(
						currentIndex + 1,
						A2(
							$elm$core$List$append,
							unknownSelections,
							_List_fromArray(
								[
									A4($author$project$Indexer$Group$Selection, selection.group, currentIndex, 0, _List_Nil)
								]))) : _Utils_Tuple2(currentIndex + 1, unknownSelections);
				}),
			_Utils_Tuple2(0, _List_Nil),
			documents).b;
	});
var $author$project$Factoring$Page$ClientSubmissionReview$getInitialSelection = function (pageData) {
	var maybeData = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.groupedDocuments;
			},
			$author$project$Forward$Remote$toMaybe(
				A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.documentPagesData;
					},
					pageData))));
	var unknowns = A2($author$project$Factoring$Page$EmailMessage$IdentifyDocuments$unknownDocuments, $author$project$Indexer$Group$firstSelection, maybeData);
	if (!unknowns.b) {
		return $author$project$Indexer$Group$firstSelection;
	} else {
		var unknownList = unknowns;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Indexer$Group$firstSelection,
			$elm$core$List$head(unknownList));
	}
};
var $author$project$Factoring$Page$ClientSubmissionReview$currentSelection = F2(
	function (data, model) {
		var _v0 = model.selection;
		if (_v0.$ === 'Just') {
			var sel = _v0.a;
			return sel;
		} else {
			return $author$project$Factoring$Page$ClientSubmissionReview$getInitialSelection(
				A2(
					$author$project$Forward$Remote$map,
					function ($) {
						return $.pageData;
					},
					data));
		}
	});
var $author$project$Factoring$Page$ClientSubmissionReview$NoOp = {$: 'NoOp'};
var $author$project$Factoring$Page$ClientSubmissionReview$Select = function (a) {
	return {$: 'Select', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$documentBrowserEvents = {
	close: $elm$core$Maybe$Nothing,
	editType: $elm$core$Maybe$Nothing,
	filter: $author$project$Indexer$DocumentBrowser$All,
	internal: $author$project$Factoring$Page$ClientSubmissionReview$DocumentBrowserMsg,
	moveDocument: $elm$core$Maybe$Nothing,
	rotatePage: $elm$core$Maybe$Nothing,
	selectPrimary: $author$project$Factoring$Page$ClientSubmissionReview$Select,
	selectSecondary: $elm$core$Basics$always($author$project$Factoring$Page$ClientSubmissionReview$NoOp),
	setHover: $elm$core$Basics$always($author$project$Factoring$Page$ClientSubmissionReview$NoOp)
};
var $author$project$Factoring$Page$ClientSubmissionReview$viewDocumentBrowser = F3(
	function (data, model, pages) {
		var config = {
			activities: _List_Nil,
			events: $author$project$Factoring$Page$ClientSubmissionReview$documentBrowserEvents,
			hoveredValue: $elm$core$Maybe$Nothing,
			info: pages,
			resendConfig: $elm$core$Maybe$Nothing,
			selected: A2($author$project$Factoring$Page$ClientSubmissionReview$currentSelection, data, model),
			showActivity: false,
			timezone: model.timezone
		};
		return A2($author$project$Indexer$DocumentBrowser$view, config, model.documentBrowser);
	});
var $author$project$Factoring$Page$ClientSubmissionReview$showIdentifier = F2(
	function (model, unknowns) {
		if (!unknowns.b) {
			return model.identifyDocuments.isSaving;
		} else {
			return true;
		}
	});
var $author$project$Factoring$Page$ClientSubmissionReview$viewHeader = function (name) {
	return A2(
		$elm$html$Html$h3,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('load-detail__section-header')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(name)
			]));
};
var $author$project$Factoring$Page$ClientSubmissionReview$maybe = F3(
	function (_default, f, m) {
		if (m.$ === 'Just') {
			var x = m.a;
			return f(x);
		} else {
			return _default;
		}
	});
var $author$project$Factoring$Page$ClientSubmissionReview$viewIdentifyDocuments = F4(
	function (data, model, pageData, selections) {
		var isLastSelection = $elm$core$List$length(selections) <= 1;
		var initialSelection = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Indexer$Group$firstSelection,
			$elm$core$List$head(selections));
		var nextSelection = A2(
			$elm$core$Maybe$withDefault,
			initialSelection,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				$elm$core$List$tail(selections)));
		var enabledDocumentTypeNames = A3(
			$author$project$Factoring$Page$ClientSubmissionReview$maybe,
			_List_Nil,
			function ($) {
				return $.enabledDocumentTypeNames;
			},
			$author$project$Forward$Remote$toMaybe(
				A2(
					$author$project$Forward$Remote$andThen,
					function ($) {
						return $.documentTypeSettings;
					},
					data)));
		return A2(
			$elm$html$Html$map,
			$author$project$Factoring$Page$ClientSubmissionReview$IdentifyDocumentsMsg(nextSelection),
			A5(
				$author$project$Factoring$Page$EmailMessage$IdentifyDocuments$viewIdentifyUnknowns,
				pageData,
				A2($author$project$Factoring$Page$ClientSubmissionReview$currentSelection, data, model),
				enabledDocumentTypeNames,
				isLastSelection,
				model.identifyDocuments));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$viewIfNonEmpty = F2(
	function (viewer, list) {
		if (!list.b) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('label secondary')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('None')
					]));
		} else {
			var first = list.a;
			var rest = list.b;
			return A2(viewer, first, rest);
		}
	});
var $author$project$Factoring$Page$ClientSubmissionReview$empty = A2($elm$html$Html$div, _List_Nil, _List_Nil);
var $author$project$Factoring$Page$ClientSubmissionReview$viewApprovedDetails = function (_v0) {
	var invoice = _v0.invoice;
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(invoice.number)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.name;
								},
								invoice.debtor)))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(invoice.loadId)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('$' + invoice.amount)
					]))
			]));
};
var $author$project$Factoring$Page$ClientSubmissionReview$viewApprovedHeaders = A2(
	$elm$html$Html$thead,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__info-table-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice No.')
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Debtor')
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Load Id')
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Amount')
						]))
				]))
		]));
var $author$project$Factoring$Page$ClientSubmissionReview$ResendInvoices = function (a) {
	return {$: 'ResendInvoices', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$resendInvoicesText = function (model) {
	return model.sending ? 'Resending...' : (model.resent ? 'Invoices have been resent' : 'Resend invoice(s) to Cadence');
};
var $author$project$Factoring$Page$ClientSubmissionReview$viewApprovedState = F4(
	function (invoice, state, user, model) {
		var resendToCadenceButton = function () {
			var _v1 = _Utils_Tuple2(user.isAdmin, invoice.transmissionId);
			if (_v1.a) {
				if (_v1.b.$ === 'Just') {
					var id = _v1.b.a;
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button--progress right'),
								$elm$html$Html$Attributes$disabled(model.sending || model.resent),
								$elm$html$Html$Events$onClick(
								$author$project$Factoring$Page$ClientSubmissionReview$ResendInvoices(id))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Factoring$Page$ClientSubmissionReview$resendInvoicesText(model))
							]));
				} else {
					return $author$project$Factoring$Page$ClientSubmissionReview$empty;
				}
			} else {
				return $author$project$Factoring$Page$ClientSubmissionReview$empty;
			}
		}();
		var _v0 = (state === 'rejected') ? _Utils_Tuple2('Rejected by Cadence', resendToCadenceButton) : ((state === 'verified') ? _Utils_Tuple2('Succesfully received by Cadence', $author$project$Factoring$Page$ClientSubmissionReview$empty) : (((state === 'generated') || (state === 'pending')) ? _Utils_Tuple2('Sending to Cadence...', $author$project$Factoring$Page$ClientSubmissionReview$empty) : (((state === 'send_failed') || (state === 'generated_failed')) ? _Utils_Tuple2('Invoice failed to send. Support has been notified.', $author$project$Factoring$Page$ClientSubmissionReview$empty) : _Utils_Tuple2('Sent. Waiting to be picked up by Cadence.', $author$project$Factoring$Page$ClientSubmissionReview$empty))));
		var stateString = _v0.a;
		var action = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__load-info-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column large-4 client-submission__approved-status')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status: ' + stateString)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column large-6 client-submission__resend-button')
								]),
							_List_fromArray(
								[action]))
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$viewInvoiceTable = F4(
	function (model, user, first, rest) {
		var maybeViewApprovedState = function () {
			var _v0 = first.invoice.transmissionState;
			if (_v0.$ === 'Just') {
				var state = _v0.a;
				return A4($author$project$Factoring$Page$ClientSubmissionReview$viewApprovedState, first.invoice, state, user, model);
			} else {
				return $author$project$Factoring$Page$ClientSubmissionReview$empty;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					maybeViewApprovedState,
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__info-table')
						]),
					_List_fromArray(
						[
							$author$project$Factoring$Page$ClientSubmissionReview$viewApprovedHeaders,
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Factoring$Page$ClientSubmissionReview$viewApprovedDetails,
								A2($elm$core$List$cons, first, rest)))
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$EditMessage = function (a) {
	return {$: 'EditMessage', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$EditRecipients = function (a) {
	return {$: 'EditRecipients', a: a};
};
var $author$project$Factoring$Page$ClientSubmissionReview$viewRejectedEmailTemplate = F3(
	function (_v0, first, rest) {
		var messageDraft = _v0.messageDraft;
		var extraRecipients = _v0.extraRecipients;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('client-submission__recipients')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('client-submission__recipients-half')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$b,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('To:')
										])),
									$elm$html$Html$text($author$project$Helpers$String$nbsp),
									A2(
									$elm$html$Html$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$author$project$Helpers$String$toSentence,
												'(no recipients)',
												'',
												A2(
													$elm$core$List$map,
													function ($) {
														return $.email;
													},
													first.correspondents)))
										]))
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('client-submission__recipients-half', true),
											_Utils_Tuple2(
											'client-submission__input-row__mismatch',
											!$author$project$Domain$EmailAddress$isValidList(extraRecipients))
										])),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$placeholder('More email addresses'),
									$elm$html$Html$Attributes$value(extraRecipients),
									$elm$html$Html$Events$onInput($author$project$Factoring$Page$ClientSubmissionReview$EditRecipients)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$textarea,
					$author$project$Helpers$Attributes$blockGrammarly(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('load-detail__rejected-invoices'),
								$elm$html$Html$Events$onInput($author$project$Factoring$Page$ClientSubmissionReview$EditMessage),
								$elm$html$Html$Attributes$value(
								A2(
									$author$project$Factoring$Page$ClientSubmissionReview$draftToString,
									messageDraft,
									A2($elm$core$List$cons, first, rest)))
							])),
					_List_Nil)
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$Send = {$: 'Send'};
var $author$project$Factoring$Page$ClientSubmissionReview$viewSendButton = F2(
	function (model, emailMessage) {
		var _v0 = model.sending ? _Utils_Tuple2(
			$elm$html$Html$Attributes$disabled(true),
			'Sending...') : ($author$project$Domain$EmailAddress$isValidList(model.extraRecipients) ? _Utils_Tuple2(
			$elm$html$Html$Events$onClick($author$project$Factoring$Page$ClientSubmissionReview$Send),
			'Send') : _Utils_Tuple2(
			$elm$html$Html$Attributes$disabled(true),
			'Send'));
		var attr = _v0.a;
		var instruction = _v0.b;
		return (!_Utils_eq(emailMessage.completedAt, $elm$core$Maybe$Nothing)) ? $author$project$Factoring$Page$ClientSubmissionReview$empty : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					$author$project$Factoring$Page$ClientSubmissionReview$viewHeader(''),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							attr,
							$elm$html$Html$Attributes$class('button--progress right client-submission__send-button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(instruction)
						]))
				]));
	});
var $author$project$Factoring$Page$ClientSubmissionReview$viewLeftSide = F3(
	function (data, model, _v0) {
		var pageData = _v0.pageData;
		var coreInfo = _v0.coreInfo;
		var sections = _v0.sections;
		var user = _v0.user;
		var unknowns = A2(
			$author$project$Factoring$Page$EmailMessage$IdentifyDocuments$unknownDocuments,
			A2($author$project$Factoring$Page$ClientSubmissionReview$currentSelection, data, model),
			pageData.groupedDocuments);
		var rejectedSection = coreInfo.settings.disableOutgoingEmailsInSubmissionWorkflow ? A2(
			$author$project$Factoring$Page$ClientSubmissionReview$viewIfNonEmpty,
			A2($author$project$Factoring$Page$ClientSubmissionReview$viewInvoiceTable, model, user),
			sections.rejected) : A2(
			$author$project$Factoring$Page$ClientSubmissionReview$viewIfNonEmpty,
			$author$project$Factoring$Page$ClientSubmissionReview$viewRejectedEmailTemplate(model),
			sections.rejected);
		var viewBody = A2($author$project$Factoring$Page$ClientSubmissionReview$showIdentifier, model, unknowns) ? _List_fromArray(
			[
				A4($author$project$Factoring$Page$ClientSubmissionReview$viewIdentifyDocuments, data, model, pageData, unknowns)
			]) : _List_fromArray(
			[
				$author$project$Factoring$Page$ClientSubmissionReview$viewHeader('Rejected'),
				rejectedSection,
				$author$project$Factoring$Page$ClientSubmissionReview$viewHeader('Approved'),
				A2(
				$author$project$Factoring$Page$ClientSubmissionReview$viewIfNonEmpty,
				A2($author$project$Factoring$Page$ClientSubmissionReview$viewInvoiceTable, model, user),
				sections.approved),
				A2($author$project$Factoring$Page$ClientSubmissionReview$viewSendButton, model, coreInfo.emailMessage)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('xlarge-2 column document-indexer__work-area')
				]),
			viewBody);
	});
var $author$project$Factoring$Page$ClientSubmissionReview$view = F2(
	function (data, model) {
		var headerModel = A4(
			$author$project$Factoring$Page$ClientSubmission$Header$Model,
			$elm$core$Maybe$Nothing,
			$author$project$Forward$Remote$toMaybe(
				A2(
					$author$project$Forward$Remote$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pageData;
						},
						function ($) {
							return $.documentBatchData;
						}),
					data)),
			$elm$core$Maybe$Just(model.presence),
			false);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-container')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Factoring$Page$ClientSubmission$Header$view,
					$author$project$Factoring$Page$ClientSubmissionReview$HeaderMsg,
					model.timezone,
					headerModel,
					_List_fromArray(
						[
							A2(
							$author$project$Factoring$Page$ClientSubmission$Header$Link,
							'Process',
							$author$project$Path$toString(
								A2(
									$author$project$Path$addQueries,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'onDone',
											$author$project$Factoring$Page$ClientSubmission$OnDone$encodeWithDefault(model.onDoneQuery))
										]),
									A2($author$project$Path$submissionWithGroup, model.emailMessageId, 0)))),
							$author$project$Factoring$Page$ClientSubmission$Header$Active('Review')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-indexer__main-body')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.documentBrowser.size;
							if (_v0.$ === 'Expanded') {
								return $elm$html$Html$text('');
							} else {
								return A2(
									$author$project$Forward$LoadingView$view,
									A2($author$project$Factoring$Page$ClientSubmissionReview$viewLeftSide, data, model),
									A5(
										$author$project$Forward$Remote$map4,
										$author$project$Factoring$Page$ClientSubmissionReview$LeftSideData,
										A2(
											$author$project$Forward$Remote$andThen,
											function ($) {
												return $.user;
											},
											data),
										A2(
											$author$project$Forward$Remote$andThen,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.sections;
												},
												$author$project$Factoring$Page$ClientSubmission$CacheData$cacheDataResultToRemote),
											data),
										A2(
											$author$project$Forward$Remote$andThen,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.pageData;
												},
												function ($) {
													return $.coreData;
												}),
											data),
										A2(
											$author$project$Forward$Remote$andThen,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.pageData;
												},
												function ($) {
													return $.documentPagesData;
												}),
											data)));
							}
						}(),
							A2(
							$author$project$Forward$LoadingView$view,
							A2($author$project$Factoring$Page$ClientSubmissionReview$viewDocumentBrowser, data, model),
							A2(
								$author$project$Forward$Remote$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.pageData;
									},
									function ($) {
										return $.documentPagesData;
									}),
								data))
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$CopyToClipboard = function (a) {
	return {$: 'CopyToClipboard', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$ToggleEmailModal = {$: 'ToggleEmailModal'};
var $author$project$Factoring$Page$VerificationBatch$Documents = {$: 'Documents'};
var $author$project$Factoring$Page$VerificationBatch$Email = {$: 'Email'};
var $author$project$Factoring$Page$VerificationBatch$confirmationMessageData = function (data) {
	return A2(
		$elm$core$List$map,
		function (emailMessage) {
			return A2($author$project$Components$DocumentBrowser$MessagesView$EmailMessageData, emailMessage, $elm$core$Maybe$Nothing);
		},
		$elm$core$List$reverse(
			A2($elm$core$List$filterMap, $author$project$Forward$Remote$toMaybe, data.confirmationMessages)));
};
var $author$project$Factoring$Page$VerificationBatch$confirmationEmailTabOffered = function (data) {
	return data.accountSettings.verificationsDebtorConfirmationEnabled && (!$elm$core$List$isEmpty(
		$author$project$Factoring$Page$VerificationBatch$confirmationMessageData(data)));
};
var $author$project$Factoring$Page$VerificationBatch$isSentMessage = function (messageData) {
	return _Utils_eq(
		messageData.emailMessage.messageType,
		$elm$core$Maybe$Just($author$project$AuditPb$EmailMessageTypeSent));
};
var $author$project$Factoring$Page$VerificationBatch$confirmationReplyReceived = function (data) {
	return $author$project$Factoring$Page$VerificationBatch$confirmationEmailTabOffered(data) && A2(
		$elm$core$List$any,
		function (messageData) {
			return !$author$project$Factoring$Page$VerificationBatch$isSentMessage(messageData);
		},
		$author$project$Factoring$Page$VerificationBatch$confirmationMessageData(data));
};
var $author$project$Factoring$Page$VerificationBatch$selectedTab = F2(
	function (data, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Factoring$Page$VerificationBatch$confirmationReplyReceived(data) ? $author$project$Factoring$Page$VerificationBatch$Email : $author$project$Factoring$Page$VerificationBatch$Documents,
			model.tab);
	});
var $author$project$Factoring$Page$VerificationBatch$BatchMail$greeting = function (maybeDisplayName) {
	var newLine = '\u000A\u000A\u000A';
	var colon = ':';
	var baseGreeting = 'I am looking to verify the rate and delivery for the following loads';
	if (maybeDisplayName.$ === 'Just') {
		var displayName = maybeDisplayName.a;
		return baseGreeting + (' submitted to ' + (displayName + (colon + newLine)));
	} else {
		return _Utils_ap(
			baseGreeting,
			_Utils_ap(colon, newLine));
	}
};
var $author$project$Factoring$Page$VerificationBatch$BatchMail$groupByCarrier = function (itemDataList) {
	var checkForCarrier = F2(
		function (carrier, itemData) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$eq(
						$author$project$Domain$TmsCarrierId$toComparable(carrier.id)),
					A2($elm$core$Maybe$map, $author$project$Domain$TmsCarrierId$toComparable, itemData.invoice.tmsCarrierId)));
		});
	var pairWithInvoices = function (carrier) {
		return function (invList) {
			return _Utils_Tuple2(carrier, invList);
		}(
			A2(
				$elm$core$List$filter,
				checkForCarrier(carrier),
				itemDataList));
	};
	var carriers = A2(
		$elm$core$List$map,
		function ($) {
			return $.tmsCarrier;
		},
		itemDataList);
	return A2(
		$elm$core$List$map,
		pairWithInvoices,
		A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.id;
				},
				$author$project$Domain$TmsCarrierId$toComparable),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, carriers)));
};
var $author$project$Factoring$Page$VerificationBatch$BatchMail$spaceOut = function (strings) {
	return A2($elm$core$List$intersperse, '\u000A\u000A', strings);
};
var $author$project$Factoring$Page$VerificationBatch$BatchMail$pleaseListAnyThatApply = function (maybeDisplayName) {
	var header = '\u000A\u0009 Please list any of the following that apply to this load:';
	var baseItems = _List_fromArray(
		['Advances:', 'Fees/Deductions:', 'Claims:']);
	var allItems = _Utils_ap(
		baseItems,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					function (name) {
						return 'Payable to ' + (name + ':');
					},
					maybeDisplayName))));
	return _Utils_ap(
		header,
		A3(
			$elm$core$List$foldr,
			F2(
				function (item, string) {
					return '\u000A\u0009 ' + (item + string);
				}),
			'\u000A\u0009 ',
			allItems));
};
var $author$project$Factoring$Page$VerificationBatch$BatchMail$toLoadLine = F2(
	function (maybeDisplayName, _v0) {
		var debtorVisibleDocumentUrl = _v0.debtorVisibleDocumentUrl;
		var invoice = _v0.invoice;
		return '       +  LOAD #: ' + (A2($elm$core$Maybe$withDefault, '', invoice.loadId) + ('    AMOUNT: ' + (A2($elm$core$Maybe$withDefault, '', invoice.formattedAmount) + ('\u000A' + ($author$project$Factoring$Page$VerificationBatch$BatchMail$pleaseListAnyThatApply(maybeDisplayName) + ('\u000A' + ('\u0009 Download documents for load ' + (A2($elm$core$Maybe$withDefault, '', invoice.loadId) + (' at: ' + (debtorVisibleDocumentUrl + '\u000A\u000A'))))))))));
	});
var $author$project$Factoring$Page$VerificationBatch$BatchMail$toCarrierGroup = F2(
	function (maybeDisplayName, _v0) {
		var carrier = _v0.a;
		var itemDataList = _v0.b;
		return A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					'CARRIER: ' + (carrier.name + ('     MC #: ' + A2($elm$core$Maybe$withDefault, '', carrier.mcNumber)))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Factoring$Page$VerificationBatch$BatchMail$toLoadLine(maybeDisplayName),
				itemDataList));
	});
var $author$project$Factoring$Page$VerificationBatch$BatchMail$body = F2(
	function (maybeDisplayName, itemDataList) {
		return _Utils_ap(
			$author$project$Factoring$Page$VerificationBatch$BatchMail$greeting(maybeDisplayName),
			A3(
				$elm$core$List$foldr,
				$elm$core$Basics$append,
				'',
				$author$project$Factoring$Page$VerificationBatch$BatchMail$spaceOut(
					A2(
						$elm$core$List$concatMap,
						$author$project$Factoring$Page$VerificationBatch$BatchMail$toCarrierGroup(maybeDisplayName),
						$author$project$Factoring$Page$VerificationBatch$BatchMail$groupByCarrier(itemDataList)))));
	});
var $author$project$Factoring$Page$VerificationBatch$BatchMail$subjectLine = 'Rate Verification Request';
var $author$project$Factoring$Page$VerificationBatch$BatchMail$viewAsModal = F5(
	function (accountSettings, copied, recipient, _v0, itemDataList) {
		var hide = _v0.hide;
		var copy = _v0.copy;
		var maybeAppend = F2(
			function (prefix, str) {
				if (str.$ === 'Just') {
					var string = str.a;
					return $author$project$Helpers$List$appendToEnd(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('verification__modal-to-line')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										_Utils_ap(prefix, string))
									]))
							]));
				} else {
					return $elm$core$Basics$identity;
				}
			});
		var emailDraft = A2($author$project$Factoring$Page$VerificationBatch$BatchMail$body, accountSettings.verificationsWorkflowDisplayName, itemDataList);
		return A2(
			$author$project$Components$Shared$ModalDialog$view,
			hide,
			{
				body: A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$textarea,
							$author$project$Helpers$Attributes$blockGrammarly(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('verification__modal-text-area')
									])),
							_List_fromArray(
								[
									$elm$html$Html$text(emailDraft)
								]))
						])),
				confirm: $elm$core$Maybe$Just(
					{
						msg: copy(emailDraft),
						text: 'Copy'
					}),
				dismissText: $elm$core$Maybe$Just('Close'),
				header: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__modal-header')
							]),
						A3(
							maybeAppend,
							'cc: ',
							accountSettings.verificationsWorkflowEmailCcRecipients,
							A3(
								maybeAppend,
								'to: ',
								recipient,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text($author$project$Factoring$Page$VerificationBatch$BatchMail$subjectLine)
											]))
									]))))),
				modalClassOverride: $elm$core$Maybe$Just('modal__large-container'),
				performing: false,
				performingText: $elm$core$Maybe$Nothing,
				success: copied,
				successText: $elm$core$Maybe$Just('Copied')
			});
	});
var $author$project$Factoring$Page$VerificationBatch$CloseDebtorConfirmation = {$: 'CloseDebtorConfirmation'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$CarrierDisputed = {$: 'CarrierDisputed'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Confirmed = {$: 'Confirmed'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Corrected = {$: 'Corrected'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Drifted = {$: 'Drifted'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$RepliedInProse = {$: 'RepliedInProse'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Waiting = {$: 'Waiting'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$carrierDisputed = function (confirmation) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.carrierDisputed;
			},
			confirmation.answers));
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$loadState = function (confirmation) {
	var drifted = !$elm$core$List$isEmpty(confirmation.driftedFields);
	var _v0 = _Utils_Tuple2(confirmation.state, confirmation.verdict);
	switch (_v0.a.$) {
		case 'VerificationsDebtorConfirmationStateNotAsked':
			var _v1 = _v0.a;
			return $elm$core$Maybe$Nothing;
		case 'VerificationsDebtorConfirmationStateSendFailed':
			var _v2 = _v0.a;
			return $elm$core$Maybe$Nothing;
		default:
			var verdict = _v0.b;
			if ($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$carrierDisputed(confirmation)) {
				return $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$CarrierDisputed);
			} else {
				if (drifted && (!_Utils_eq(verdict, $elm$core$Maybe$Nothing))) {
					return $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Drifted);
				} else {
					if (verdict.$ === 'Just') {
						switch (verdict.a.$) {
							case 'VerificationsDebtorConfirmationVerdictConfirmed':
								var _v4 = verdict.a;
								return $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Confirmed);
							case 'VerificationsDebtorConfirmationVerdictCorrection':
								var _v5 = verdict.a;
								return $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Corrected);
							default:
								return $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$RepliedInProse);
						}
					} else {
						return _Utils_eq(confirmation.requestReply, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Waiting) : $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$RepliedInProse);
					}
				}
			}
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$v3Scoped = $author$project$Helpers$Html$v3ReskinContainer;
var $author$project$Ui$V3$Icon$clock16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$strokeWidth('1.25'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('8'),
						$elm$svg$Svg$Attributes$cy('8'),
						$elm$svg$Svg$Attributes$r('6.5')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8 4.5V8L10.25 9.75')
					]),
				_List_Nil)
			])));
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateIcon = function (state) {
	switch (state.$) {
		case 'Waiting':
			return $author$project$Ui$V3$Icon$clock16;
		case 'RepliedInProse':
			return $author$project$Ui$V3$Icon$sendMessage16;
		case 'Confirmed':
			return $author$project$Ui$V3$Icon$checkCircle16;
		case 'Corrected':
			return $author$project$Ui$V3$Icon$alertTriangle16;
		case 'CarrierDisputed':
			return $author$project$Ui$V3$Icon$error16;
		default:
			return $author$project$Ui$V3$Icon$alertTriangle16;
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$respondedSuffix = F2(
	function (tz, maybeAt) {
		if (maybeAt.$ === 'Just') {
			var at = maybeAt.a;
			return ' — ' + A2($author$project$Helpers$Date$compactDateTimeString, tz, at);
		} else {
			return '';
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$verdictText = function (maybeVerdict) {
	if (maybeVerdict.$ === 'Just') {
		switch (maybeVerdict.a.$) {
			case 'VerificationsDebtorConfirmationVerdictConfirmed':
				var _v1 = maybeVerdict.a;
				return 'The debtor confirmed this load';
			case 'VerificationsDebtorConfirmationVerdictCorrection':
				var _v2 = maybeVerdict.a;
				return 'The debtor confirmed this load with corrections';
			default:
				var _v3 = maybeVerdict.a;
				return 'The debtor replied, but not in a form we could read';
		}
	} else {
		return 'The debtor replied';
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateSentence = F4(
	function (tz, debtor, confirmation, state) {
		switch (state.$) {
			case 'Waiting':
				var _v1 = confirmation.askedAt;
				if (_v1.$ === 'Just') {
					var askedAt = _v1.a;
					return 'Asked ' + (debtor.name + (' on ' + (A2($author$project$Helpers$Date$compactDateTimeString, tz, askedAt) + ' — no reply yet.')));
				} else {
					return 'Asked ' + (debtor.name + ' — no reply yet.');
				}
			case 'CarrierDisputed':
				return 'A debtor disputes the carrier on this load' + A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$respondedSuffix, tz, confirmation.respondedAt);
			default:
				return _Utils_ap(
					$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$verdictText(confirmation.verdict),
					A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$respondedSuffix, tz, confirmation.respondedAt));
		}
	});
var $author$project$Helpers$String$isBlank = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty);
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank = function (str) {
	return $author$project$Helpers$String$isBlank(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$recipientLabel = function (recipient) {
	var _v0 = $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank(recipient.name);
	if (_v0.$ === 'Just') {
		var name = _v0.a;
		return name + (' (' + (recipient.emailAddress + ')'));
	} else {
		return recipient.emailAddress;
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewAnsweredBy = F2(
	function (tz, confirmation) {
		var _v0 = confirmation.answeredBy;
		if (_v0.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var recipient = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-answered-by')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Answered by ' + ($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$recipientLabel(recipient) + A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$respondedSuffix, tz, confirmation.answeredAt)))
						]))
				]);
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$driftFieldLabel = function (field) {
	switch (field) {
		case 'load_id':
			return 'load number';
		case 'carrier':
			return 'carrier';
		case 'amount':
			return 'amount';
		case 'invoice_date':
			return 'invoice date';
		default:
			var other = field;
			return other;
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText = function (amount) {
	return A2(
		$elm$core$Result$withDefault,
		amount,
		A2(
			$elm$core$Result$map,
			$author$project$Money$toString,
			$author$project$Money$fromString(amount)));
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewDrift = F2(
	function (itemData, confirmation) {
		if ($elm$core$List$isEmpty(confirmation.driftedFields)) {
			return _List_Nil;
		} else {
			var otherFields = A2(
				$elm$core$List$filter,
				function (field) {
					return field !== 'amount';
				},
				confirmation.driftedFields);
			var amountHeadline = function (askedAmount) {
				return function () {
					var _v1 = confirmation.verdict;
					if ((_v1.$ === 'Just') && (_v1.a.$ === 'VerificationsDebtorConfirmationVerdictConfirmed')) {
						var _v2 = _v1.a;
						return 'Confirmed for ';
					} else {
						return 'The debtor was asked about ';
					}
				}() + ($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText(askedAmount) + (' — this invoice now reads ' + A2(
					$elm$core$Maybe$withDefault,
					'a different amount',
					A2($elm$core$Maybe$map, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText, itemData.invoice.amount))));
			};
			var headline = function () {
				var _v0 = _Utils_Tuple2(
					A2($elm$core$List$member, 'amount', confirmation.driftedFields),
					confirmation.askedAmount);
				if (_v0.a && (_v0.b.$ === 'Just')) {
					var askedAmount = _v0.b.a;
					return $elm$core$List$isEmpty(otherFields) ? amountHeadline(askedAmount) : (amountHeadline(askedAmount) + ('. Also changed: ' + A2(
						$elm$core$String$join,
						', ',
						A2($elm$core$List$map, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$driftFieldLabel, otherFields))));
				} else {
					return 'This invoice changed after the debtor was asked: ' + A2(
						$elm$core$String$join,
						', ',
						A2($elm$core$List$map, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$driftFieldLabel, confirmation.driftedFields));
				}
			}();
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-panel-drift')
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$alertTriangle16),
							$elm$html$Html$text($author$project$Helpers$String$nbsp),
							$elm$html$Html$text(headline)
						]))
				]);
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFact = F3(
	function (label, valueAttrs, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-fact')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-fact-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$span,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('verification__debtor-confirmation-fact-value'),
						valueAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFacts = function (confirmation) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('verification__debtor-confirmation-facts')
			]),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFact, 'Load #', _List_Nil),
					A2($elm$core$Maybe$andThen, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank, confirmation.askedLoadId)),
					A2(
					$elm$core$Maybe$map,
					A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFact, 'Invoice date', _List_Nil),
					A2($elm$core$Maybe$andThen, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank, confirmation.askedInvoiceDate)),
					A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFact,
						'Amount',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-fact-value--amount')
							])),
					A2($elm$core$Maybe$map, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText, confirmation.askedAmount))
				])));
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewAssertion = function (confirmation) {
	var carrier = A2(
		$elm$core$Maybe$withDefault,
		'their carrier',
		A2($elm$core$Maybe$andThen, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank, confirmation.askedCarrierName));
	var amount = A2(
		$elm$core$Maybe$withDefault,
		'the amount we gave is what you\u0027ll pay',
		A2(
			$elm$core$Maybe$map,
			function (asked) {
				return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText(asked) + ' is what you\u0027ll pay';
			},
			confirmation.askedAmount));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-assertion')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-assertion-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Confirming means all of this is true')
						])),
					$elm$html$Html$text('The load was delivered · ' + (carrier + (' hauled it · ' + (amount + ' · no advances, deductions, damage claims, or accessorials outstanding.'))))
				]))
		]);
};
var $elm$html$Html$details = _VirtualDom_node('details');
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$maxProseCharacters = 600;
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$maxProseLines = 6;
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewProse = F2(
	function (proseClass, prose) {
		var lines = $elm$core$String$lines(prose);
		var wholeProse = A2($elm$core$String$join, '\u000A', lines);
		var head = A2(
			$elm$core$String$left,
			$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$maxProseCharacters,
			A2(
				$elm$core$String$join,
				'\u000A',
				A2($elm$core$List$take, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$maxProseLines, lines)));
		var remainder = A2(
			$elm$core$String$dropLeft,
			$elm$core$String$length(head),
			wholeProse);
		var tail = A2($elm$core$String$startsWith, '\u000A', remainder) ? A2($elm$core$String$dropLeft, 1, remainder) : remainder;
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(tail)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(proseClass)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(prose)
				])) : A2(
			$elm$html$Html$details,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-prose-disclosure')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$summary,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-prose-summary')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(proseClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(head)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('verification__debtor-confirmation-prose-caption verification__debtor-confirmation-prose-caption--collapsed')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Show the rest of the email')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('verification__debtor-confirmation-prose-caption verification__debtor-confirmation-prose-caption--expanded')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hide the rest of the email')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(proseClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(tail)
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFreeText = function (freeText) {
	return $author$project$Helpers$String$isBlank(freeText) ? _List_Nil : _List_fromArray(
		[
			A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewProse, 'verification__debtor-confirmation-answer', freeText)
		]);
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewQuestion = function (answer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('verification__debtor-confirmation-question', true),
						_Utils_Tuple2(
						'verification__debtor-confirmation-question--blank',
						_Utils_eq(answer.answer, $elm$core$Maybe$Nothing))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification__debtor-confirmation-question-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(answer.question)
					])),
				A2(
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewProse,
				'verification__debtor-confirmation-answer',
				A2(
					$elm$core$Maybe$withDefault,
					'left blank',
					A2($elm$core$Maybe$andThen, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank, answer.answer)))
			]));
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewSubmission = F2(
	function (confirmation, state) {
		var _v0 = _Utils_Tuple3(state, confirmation.channel, confirmation.answeredQuestions);
		if (_v0.a.$ === 'Waiting') {
			var _v1 = _v0.a;
			return _List_Nil;
		} else {
			if ((_v0.b.$ === 'Just') && (_v0.b.a.$ === 'VerificationsDebtorConfirmationChannelOneClick')) {
				var _v2 = _v0.b.a;
				return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewAssertion(confirmation);
			} else {
				if (!_v0.c.b) {
					return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFreeText(confirmation.freeText);
				} else {
					var questions = _v0.c;
					return A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('verification__debtor-confirmation-hint')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('They were asked to fill in only what\u0027s different. A blank is not an answer.')
								])),
						A2($elm$core$List$map, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewQuestion, questions));
				}
			}
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewLoadSection = F3(
	function (tz, debtor, _v0) {
		var itemData = _v0.a;
		var confirmation = _v0.b;
		var state = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-modal-load')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFacts(confirmation),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-modal-state')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$V3$Icon$view16,
								_List_Nil,
								$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateIcon(state)),
								$elm$html$Html$text($author$project$Helpers$String$nbsp),
								$elm$html$Html$text(
								A4($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateSentence, tz, debtor, confirmation, state))
							])),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewAnsweredBy, tz, confirmation),
								A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewDrift, itemData, confirmation),
								A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewSubmission, confirmation, state)
							])))));
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewRequestReply = function (reply) {
	return $author$project$Helpers$String$isBlank(reply.freeText) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-reply')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-reply-headline')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Replied by email:')
						])),
					A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewProse, 'verification__debtor-confirmation-reply-prose', reply.freeText)
				])));
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewAsModal = F4(
	function (tz, debtor, _v0, itemDataList) {
		var dismiss = _v0.dismiss;
		var asked = A2(
			$elm$core$List$filterMap,
			function (itemData) {
				return A2(
					$elm$core$Maybe$andThen,
					function (confirmation) {
						return A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_Tuple3(itemData, confirmation, state);
							},
							$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$loadState(confirmation));
					},
					itemData.item.debtorConfirmation);
			},
			itemDataList);
		var replies = A2(
			$elm$core$List$filterMap,
			$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewRequestReply,
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$filterMap,
					function (_v2) {
						var confirmation = _v2.b;
						return confirmation.requestReply;
					},
					asked)));
		var sections = A2(
			$elm$core$List$map,
			A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewLoadSection, tz, debtor),
			asked);
		var body = function () {
			if (!sections.b) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-modal-empty')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No loads on this batch have been sent to the debtor to confirm.')
							]))
					]);
			} else {
				return _Utils_ap(replies, sections);
			}
		}();
		return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$v3Scoped(
			A2(
				$author$project$Ui$V3$Modal$view,
				_List_Nil,
				{
					body: A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-modal-body')
							]),
						body),
					cancelButton: $elm$core$Maybe$Just(
						_Utils_Tuple2('Close', dismiss)),
					dismissMsg: dismiss,
					footerButtons: _List_Nil,
					header: $author$project$Ui$V3$Modal$textHeader('What ' + (debtor.name + ' was asked to confirm')),
					primaryButton: $elm$core$Maybe$Nothing,
					size: $author$project$Ui$V3$Modal$large
				}));
	});
var $author$project$Factoring$Page$VerificationBatch$viewDebtorConfirmationModal = F3(
	function (model, debtor, itemDataList) {
		return A4(
			$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewAsModal,
			model.timezone,
			debtor,
			{dismiss: $author$project$Factoring$Page$VerificationBatch$CloseDebtorConfirmation},
			itemDataList);
	});
var $author$project$Factoring$Page$VerificationBatch$Activity = {$: 'Activity'};
var $author$project$Factoring$Page$VerificationBatch$SelectTab = function (a) {
	return {$: 'SelectTab', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$tabToString = function (tab) {
	switch (tab.$) {
		case 'Documents':
			return 'Documents';
		case 'Email':
			return 'Email';
		default:
			return 'Activity';
	}
};
var $author$project$Factoring$Page$VerificationBatch$SetDocumentBrowserExpanded = function (a) {
	return {$: 'SetDocumentBrowserExpanded', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$viewArrows = F3(
	function (icon, name, newExpanded) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__header-expand_browser'),
					$elm$html$Html$Attributes$title(name + ($author$project$Helpers$String$nbsp + 'Document Browser')),
					$elm$html$Html$Events$onClick(
					$author$project$Factoring$Page$VerificationBatch$SetDocumentBrowserExpanded(newExpanded))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-arrows-' + icon)
						]),
					_List_Nil)
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewDocBrowserTabs = F3(
	function (data, currentTab, expanded) {
		var choices = $author$project$Factoring$Page$VerificationBatch$confirmationEmailTabOffered(data) ? _List_fromArray(
			[$author$project$Factoring$Page$VerificationBatch$Documents, $author$project$Factoring$Page$VerificationBatch$Email, $author$project$Factoring$Page$VerificationBatch$Activity]) : _List_fromArray(
			[$author$project$Factoring$Page$VerificationBatch$Documents, $author$project$Factoring$Page$VerificationBatch$Activity]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__header-component-selection')
						]),
					_List_fromArray(
						[
							$author$project$Components$Shared$Tabs$view(
							{choices: choices, onSelect: $author$project$Factoring$Page$VerificationBatch$SelectTab, selected: currentTab, toString: $author$project$Factoring$Page$VerificationBatch$tabToString, useComponentSelectorStyle: true})
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__header-current')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-browser__header-expand-link')
						]),
					_List_fromArray(
						[
							expanded ? A3($author$project$Factoring$Page$VerificationBatch$viewArrows, 'compress', 'Collapse', false) : A3($author$project$Factoring$Page$VerificationBatch$viewArrows, 'expand', 'Expand', true)
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$selectedFactorInvoiceId = F2(
	function (data, model) {
		var _v0 = model.selectedFactorInvoiceId;
		if (_v0.$ === 'Nothing') {
			return A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.invoice;
					},
					function ($) {
						return $.id;
					}),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Forward$Remote$toMaybe,
					$elm$core$List$head(data.items)));
		} else {
			return model.selectedFactorInvoiceId;
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewActivityTab = F2(
	function (data, model) {
		var getActivityItemsIfSelected = function (loadedItem) {
			return A2(
				$elm$core$Maybe$andThen,
				function (id) {
					return _Utils_eq(id, loadedItem.invoice.id) ? $elm$core$Maybe$Just(loadedItem.invoice.activityItems) : $elm$core$Maybe$Nothing;
				},
				A2($author$project$Factoring$Page$VerificationBatch$selectedFactorInvoiceId, data, model));
		};
		return A9(
			$author$project$Components$DocumentBrowser$ActivityView$view,
			data.account,
			data.accountSettings,
			true,
			model.timezone,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$always($elm$core$Maybe$Nothing),
			$elm$core$List$concat(
				A2(
					$elm$core$List$filterMap,
					getActivityItemsIfSelected,
					A2(
						$author$project$Factoring$Page$VerificationBatch$loadedListFromData,
						function ($) {
							return $.items;
						},
						$author$project$Forward$Remote$Loaded(data)))));
	});
var $author$project$Factoring$Page$VerificationBatch$viewConfirmationEmailTab = F2(
	function (data, model) {
		return $author$project$Components$DocumentBrowser$MessagesView$view(
			{
				accountSettings: data.accountSettings,
				editConfig: $elm$core$Maybe$Nothing,
				emailMessages: $author$project$Factoring$Page$VerificationBatch$confirmationMessageData(data),
				fullHeight: true,
				savingAsDocument: false,
				selectedLabelIndex: 0,
				timeZone: model.timezone,
				updating: false
			});
	});
var $author$project$Factoring$Page$VerificationBatch$NoOp = {$: 'NoOp'};
var $author$project$Factoring$Page$VerificationBatch$SelectDocument = function (a) {
	return {$: 'SelectDocument', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$SelectLeftSideDocument = function (a) {
	return {$: 'SelectLeftSideDocument', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$viewDocumentsTab = F3(
	function (data, leftSideSelectedPage, model) {
		var documentData = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Components$DocumentBrowser$Full$DocumentData, _List_Nil, _List_Nil),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Forward$Remote$toMaybe,
				A2(
					$elm$core$Maybe$andThen,
					function (invoiceId) {
						return A2(
							$elm$core$Dict$get,
							$author$project$Domain$FactorInvoiceId$toComparable(invoiceId),
							data.documentsData);
					},
					A2($author$project$Factoring$Page$VerificationBatch$selectedFactorInvoiceId, data, model))));
		var _v0 = function () {
			if (leftSideSelectedPage.$ === 'Just') {
				var leftSide = leftSideSelectedPage.a;
				return _Utils_Tuple2(leftSide, $author$project$Factoring$Page$VerificationBatch$SelectLeftSideDocument);
			} else {
				return _Utils_Tuple2(model.selectedPage, $author$project$Factoring$Page$VerificationBatch$SelectDocument);
			}
		}();
		var selectedPage = _v0.a;
		var onSelect = _v0.b;
		return $author$project$Components$DocumentBrowser$Full$view(
			{
				account: data.account,
				accountSettings: data.accountSettings,
				addressAnswers: $elm$core$Dict$empty,
				annotationOverlay: $elm$core$Maybe$Nothing,
				documentIsPodUpdates: $author$project$Helpers$DocumentIsPodUpdates$empty,
				documents: $author$project$Components$DocumentBrowser$Full$UngroupedDocuments(documentData),
				dragScrollAttributes: _List_Nil,
				emailMessageDataList: $elm$core$Maybe$Nothing,
				fullImage: model.documentBrowserExpanded,
				groupStatusTag: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				groupThumbnailsByDocumentBatch: false,
				highlight: $elm$core$Maybe$Nothing,
				lineDragAttributes: $elm$core$Basics$always(_List_Nil),
				lines: $elm$core$Dict$empty,
				onRightClick: $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$SelectLeftSideDocument),
				onSelect: onSelect,
				onSelectGroup: $elm$core$Maybe$Nothing,
				onSelectedGroupRendered: $elm$core$Maybe$Nothing,
				onViewEmailClick: $elm$core$Maybe$Nothing,
				overlay: $elm$core$Maybe$Nothing,
				pageImage: $author$project$Components$DocumentBrowser$PageImage$Annotated,
				popout: false,
				relatedDocuments: $elm$core$Maybe$Nothing,
				restrictHeight: false,
				scrollContainerSuffix: 'verification',
				secondary: $elm$core$Maybe$Nothing,
				selection: selectedPage,
				setLineSelection: $elm$core$Basics$always($author$project$Factoring$Page$VerificationBatch$NoOp),
				viewAddDocumentToLoadButton: $elm$html$Html$text(''),
				viewMode: $elm$core$Maybe$Nothing,
				zoomLevel: 1.0
			});
	});
var $author$project$Factoring$Page$VerificationBatch$viewDocumentBrowser = F3(
	function (data, leftSideSelectedPage, model) {
		var _v0 = A2($author$project$Factoring$Page$VerificationBatch$selectedTab, data, model);
		switch (_v0.$) {
			case 'Documents':
				return A3($author$project$Factoring$Page$VerificationBatch$viewDocumentsTab, data, leftSideSelectedPage, model);
			case 'Email':
				return $author$project$Factoring$Page$VerificationBatch$confirmationEmailTabOffered(data) ? A2($author$project$Factoring$Page$VerificationBatch$viewConfirmationEmailTab, data, model) : A3($author$project$Factoring$Page$VerificationBatch$viewDocumentsTab, data, leftSideSelectedPage, model);
			default:
				return A2($author$project$Factoring$Page$VerificationBatch$viewActivityTab, data, model);
		}
	});
var $author$project$Factoring$Page$VerificationBatch$selectedItem = F2(
	function (data, model) {
		var unpackListHead = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Maybe$andThen($author$project$Forward$Remote$toMaybe));
		var compareIds = F2(
			function (first, second) {
				return _Utils_eq(
					$author$project$Domain$FactorInvoiceId$toComparable(first),
					$author$project$Domain$FactorInvoiceId$toComparable(second));
			});
		var allItems = data.items;
		var _v0 = model.selectedFactorInvoiceId;
		if (_v0.$ === 'Nothing') {
			return unpackListHead(allItems);
		} else {
			var selectedInvoiceId = _v0.a;
			return unpackListHead(
				A2(
					$elm$core$List$filter,
					function (item) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								compareIds(selectedInvoiceId),
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.invoice;
										},
										function ($) {
											return $.id;
										}),
									$author$project$Forward$Remote$toMaybe(item))));
					},
					allItems));
		}
	});
var $author$project$Factoring$Page$VerificationBatch$toCols = function (htmlMsg) {
	return A2(
		$elm$core$List$map,
		function (interior) {
			return A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[interior]));
		},
		htmlMsg);
};
var $author$project$Factoring$Page$VerificationBatch$batchItemRowHeaders = function (useContactsAndNotes) {
	var notesHeader = useContactsAndNotes ? 'Contact And Notes' : 'Notes';
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('load-detail__info-table-header')
			]),
		$author$project$Factoring$Page$VerificationBatch$toCols(
			A2(
				$elm$core$List$map,
				$elm$html$Html$text,
				_List_fromArray(
					['', 'Invoice', 'Client', 'Amount/Status', notesHeader]))));
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Factoring$Page$VerificationBatch$OpenDebtorConfirmation = function (a) {
	return {$: 'OpenDebtorConfirmation', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$SelectInvoice = function (a) {
	return {$: 'SelectInvoice', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$SingleLoad = function (a) {
	return {$: 'SingleLoad', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$checkLoadedItemCompletion = F4(
	function (accountSettings, batchId, formState, itemData) {
		var notNothing = function (maybeSomething) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(true),
					maybeSomething));
		};
		var _v0 = itemData;
		var item = _v0.item;
		var currentData = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Factoring$Page$VerificationBatch$itemDataToDefaultItemFormState, batchId, itemData),
			A2($author$project$Factoring$Page$VerificationBatch$getItemFormState, item.id, formState));
		var checkMethodContactCompletion = notNothing(currentData.verificationMethodId) && notNothing(currentData.debtorContactId);
		var _v1 = currentData.customState.state;
		switch (_v1.$) {
			case 'VerificationsDebtorBatchItemStateNotReady':
				return true;
			case 'VerificationsDebtorBatchItemStateUnverified':
				return false;
			case 'VerificationsDebtorBatchItemStateHeld':
				return false;
			case 'VerificationsDebtorBatchItemStateVerified':
				return checkMethodContactCompletion || (!accountSettings.verificationsWorkflowUseCadenceNotes);
			case 'VerificationsDebtorBatchItemStateSkipped':
				return true;
			case 'VerificationsDebtorBatchItemStateRejected':
				return checkMethodContactCompletion || ((!accountSettings.verificationsWorkflowUseCadenceNotes) || (!accountSettings.verificationsWorkflowSendRejectedInvoicesToTMS));
			case 'VerificationsDebtorBatchItemStateAutoSkipped':
				return true;
			default:
				return false;
		}
	});
var $author$project$Factoring$Page$VerificationBatch$checkItemCompletion = F4(
	function (accountSettings, batchId, formState, itemData) {
		return A4($author$project$Factoring$Page$VerificationBatch$checkLoadedItemCompletion, accountSettings, batchId, formState, itemData);
	});
var $author$project$Factoring$Page$VerificationBatch$SetDebtorConfirmationExpandedState = F2(
	function (a, b) {
		return {$: 'SetDebtorConfirmationExpandedState', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$getDebtorConfirmationExpandedStateByItem = F3(
	function (_v0, _v1, inline) {
		var debtorConfirmationExpandedState = _v0.debtorConfirmationExpandedState;
		var item = _v1.item;
		return A2(
			$elm$core$Maybe$withDefault,
			inline.answered,
			A2(
				$elm$core$Dict$get,
				$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(item.id),
				debtorConfirmationExpandedState));
	});
var $author$project$Factoring$Page$VerificationBatch$showOrHideDetails = function (expanded) {
	return expanded ? _List_fromArray(
		[
			$elm$html$Html$text('Hide details'),
			$elm$html$Html$text($author$project$Helpers$String$nbsp),
			A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-minus')
				]),
			_List_Nil)
		]) : _List_fromArray(
		[
			$elm$html$Html$text('Show details'),
			$elm$html$Html$text($author$project$Helpers$String$nbsp),
			A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi-plus')
				]),
			_List_Nil)
		]);
};
var $author$project$Factoring$Page$VerificationBatch$viewSeverityPill = function (_v0) {
	var glyph = _v0.glyph;
	var severity = _v0.severity;
	var label = _v0.label;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				'load-detail__debtor-verification-detail-labels load-detail__debtor-verification-detail-labels--' + $author$project$Domain$Verification$severityClass(severity))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(glyph),
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
					]),
				_List_Nil),
				$elm$html$Html$text(label)
			]));
};
var $author$project$Factoring$Page$VerificationBatch$debtorConfirmationSection = F4(
	function (baseRowClasses, model, itemData, inline) {
		var headerRowClasses = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					_Utils_Tuple2('verification__contact-info-section', true)
				]),
			baseRowClasses);
		var expanded = A3($author$project$Factoring$Page$VerificationBatch$getDebtorConfirmationExpandedStateByItem, model, itemData, inline);
		return A3(
			$author$project$Helpers$List$conditionallyAppend,
			expanded,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(baseRowClasses)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$colspan(5)
								]),
							_List_fromArray(
								[inline.body]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(headerRowClasses)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$colspan(5)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__section-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Debtor confirmation'),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text($author$project$Helpers$String$nbsp)
												])),
											$author$project$Factoring$Page$VerificationBatch$viewSeverityPill(inline),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text($author$project$Helpers$String$nbsp)
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													A2($author$project$Factoring$Page$VerificationBatch$SetDebtorConfirmationExpandedState, itemData.item.id, !expanded)),
													$elm$html$Html$Attributes$class('right factor-invoice__header-action show-debtor-confirmation-toggle')
												]),
											$author$project$Factoring$Page$VerificationBatch$showOrHideDetails(expanded))
										]))
								]))
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$SetDebtorVerificationsExpandedState = F2(
	function (a, b) {
		return {$: 'SetDebtorVerificationsExpandedState', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$getDebtorVerificationsExpandedStateByItem = F2(
	function (_v0, _v1) {
		var debtorVerificationsExpandedState = _v0.debtorVerificationsExpandedState;
		var maybeAutoVerification = _v1.maybeAutoVerification;
		var item = _v1.item;
		var defaultState = function () {
			var _v2 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.state;
				},
				maybeAutoVerification);
			if ((_v2.$ === 'Just') && (_v2.a.$ === 'Verification_State_Success')) {
				return false;
			} else {
				return true;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			defaultState,
			A2(
				$elm$core$Dict$get,
				$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(item.id),
				debtorVerificationsExpandedState));
	});
var $author$project$Factoring$Page$VerificationBatch$maybeSourceTooltip = function (debtor) {
	return $author$project$Domain$FactorBroker$inNetworkVerifications(debtor) ? A2(
		$elm$html$Html$a,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'true'),
						$elm$html$Html$Attributes$title('Data provided by the debtor\u0027s TMS.'),
						A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
						$elm$html$Html$Attributes$class('fi-info')
					]),
				_List_Nil)
			])) : $elm$html$Html$text('');
};
var $author$project$Factoring$Page$VerificationBatch$debtorVerificationDetail = F4(
	function (_v0, loadId, failedDetails, detailType) {
		var _v1 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(
				false,
				{brokerAmount: $elm$core$Maybe$Nothing, message: detailType}),
			A2(
				$elm$core$Maybe$map,
				function (failedDetail) {
					return _Utils_Tuple2(true, failedDetail);
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (failedDetail) {
						return _Utils_eq(failedDetail.message, detailType);
					},
					failedDetails)));
		var failed = _v1.a;
		var detail = _v1.b;
		var iconClass = failed ? 'fi-x load-detail__debtor-verification-detail-icon fail' : 'fi-check load-detail__debtor-verification-detail-icon success';
		var message = failed ? $author$project$Domain$Verification$viewDetailMessage(detail) : A2($author$project$Domain$Verification$viewPassedDetailMessage, loadId, detail.message);
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(iconClass),
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil),
					$elm$html$Html$text(message)
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$showNotCheckedDetail = function (detail) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__debtor-verification-detail-icon unchecked'),
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
					]),
				_List_Nil),
				$elm$html$Html$text(
				$author$project$Domain$Verification$detailSubject(detail))
			]));
};
var $author$project$Factoring$Page$VerificationBatch$showNotCheckedGroup = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('load-detail__debtor-verification-not-checked')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__debtor-verification-not-checked-label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$Domain$Verification$pendingChecksHeading)
				])),
			A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__debtor-verification-detail-display' + ' load-detail__debtor-verification-detail-display--inline')
				]),
			A2($elm$core$List$map, $author$project$Factoring$Page$VerificationBatch$showNotCheckedDetail, $author$project$Domain$Verification$checksNeedingTheLoad))
		]));
var $author$project$Factoring$Page$VerificationBatch$showFailures = F4(
	function (baseRowClasses, loadId, mode, failedDetails) {
		var showDebtorVerificationDetail = A2($author$project$Factoring$Page$VerificationBatch$debtorVerificationDetail, baseRowClasses, loadId);
		return A2(
			$elm$core$List$member,
			$author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.message;
				},
				failedDetails)) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__debtor-verification-detail-display')
						]),
					_List_fromArray(
						[
							A2(showDebtorVerificationDetail, failedDetails, $author$project$AuditPb$VerificationFailureMessageLoadNotFoundFailure)
						])),
				_Utils_eq(mode, $author$project$AuditPb$VerificationsModeRestricted) ? _List_Nil : _List_fromArray(
					[$author$project$Factoring$Page$VerificationBatch$showNotCheckedGroup]))) : A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__debtor-verification-detail-display')
				]),
			A2(
				$elm$core$List$map,
				showDebtorVerificationDetail(failedDetails),
				$author$project$Domain$Verification$checklistDetails));
	});
var $author$project$Factoring$Page$VerificationBatch$showDebtorVerificationDetailSection = F3(
	function (baseRowClasses, loadId, autoVerification) {
		var wrapToRow = function (content) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(baseRowClasses)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(5)
							]),
						_List_fromArray(
							[content]))
					]));
		};
		var showUnverifiedMessage = function (verification) {
			var _v2 = $author$project$Domain$Verification$verdict(verification);
			var explanation = _v2.explanation;
			var glyph = _v2.glyph;
			var severity = _v2.severity;
			var label = _v2.label;
			return wrapToRow(
				A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__debtor-verification-detail-display')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											glyph + (' load-detail__debtor-verification-detail-unverified-icon' + (' load-detail__debtor-verification-detail-unverified-icon--' + $author$project$Domain$Verification$severityClass(severity)))),
											A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
										]),
									_List_Nil),
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, label, explanation))
								]))
						])));
		};
		var showDebtorVerificationDetail = F2(
			function (failedDetails, detailType) {
				return A4($author$project$Factoring$Page$VerificationBatch$debtorVerificationDetail, baseRowClasses, loadId, failedDetails, detailType);
			});
		var _v0 = autoVerification.state;
		switch (_v0.$) {
			case 'Verification_State_Success':
				return wrapToRow(
					A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('load-detail__debtor-verification-detail-display')
							]),
						A2(
							$elm$core$List$map,
							showDebtorVerificationDetail(_List_Nil),
							$author$project$Domain$Verification$checklistDetails)));
			case 'Verification_State_Pending':
				return showUnverifiedMessage(autoVerification);
			case 'Verification_State_NonParticipatingCarrier':
				return showUnverifiedMessage(autoVerification);
			case 'Verification_State_UnverifiableLoad':
				return showUnverifiedMessage(autoVerification);
			case 'Verification_State_UnconfirmedDelivery':
				return wrapToRow(
					A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('load-detail__debtor-verification-detail-display')
							]),
						A2(
							$elm$core$List$map,
							function (d) {
								if (d.$ === 'VerificationFailureMessageUndeliveredFailure') {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('fi-minus load-detail__debtor-verification-detail-icon skipped'),
														A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
													]),
												_List_Nil),
												$elm$html$Html$text($author$project$Domain$Verification$skippedDeliveryMessage)
											]));
								} else {
									return A2(showDebtorVerificationDetail, _List_Nil, d);
								}
							},
							$author$project$Domain$Verification$checklistDetails)));
			default:
				var failures = _v0.a.failures;
				var mode = _v0.a.mode;
				return wrapToRow(
					A4($author$project$Factoring$Page$VerificationBatch$showFailures, baseRowClasses, loadId, mode, failures));
		}
	});
var $author$project$Factoring$Page$VerificationBatch$debtorVerifications = F5(
	function (baseRowClasses, model, debtor, itemData, autoVerification) {
		var verificationDetailSection = $elm$core$List$singleton(
			A3($author$project$Factoring$Page$VerificationBatch$showDebtorVerificationDetailSection, baseRowClasses, itemData.invoice.loadId, autoVerification));
		var headerRowClasses = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					_Utils_Tuple2('verification__contact-info-section', true)
				]),
			baseRowClasses);
		var expanded = A2($author$project$Factoring$Page$VerificationBatch$getDebtorVerificationsExpandedStateByItem, model, itemData);
		var toggleExpandedMsg = A2($author$project$Factoring$Page$VerificationBatch$SetDebtorVerificationsExpandedState, itemData.item.id, !expanded);
		return A3(
			$author$project$Helpers$List$conditionallyAppend,
			expanded,
			verificationDetailSection,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(headerRowClasses)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$colspan(5)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__section-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Debtor verifications'),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text($author$project$Helpers$String$nbsp)
												])),
											$author$project$Factoring$Page$VerificationBatch$maybeSourceTooltip(debtor),
											$author$project$Factoring$Page$VerificationBatch$viewSeverityPill(
											$author$project$Domain$Verification$verdict(autoVerification)),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text($author$project$Helpers$String$nbsp)
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(toggleExpandedMsg),
													$elm$html$Html$Attributes$class('right factor-invoice__header-action show-verifications-toggle')
												]),
											$author$project$Factoring$Page$VerificationBatch$showOrHideDetails(expanded))
										]))
								]))
						]))
				]));
	});
var $author$project$Domain$VerificationsDebtorBatch$inProgress = function (state) {
	switch (state.$) {
		case 'VerificationsDebtorBatchStateStarted':
			return true;
		case 'VerificationsDebtorBatchStateWaiting':
			return true;
		case 'VerificationsDebtorBatchStateReply':
			return true;
		default:
			return false;
	}
};
var $author$project$Factoring$Page$VerificationBatch$blockForCadenceData = function (cadenceDataMissing) {
	return cadenceDataMissing.methodsEmpty || cadenceDataMissing.contactsEmpty;
};
var $author$project$Factoring$Page$VerificationBatch$getCadenceDataMissing = function (_v0) {
	var verificationMethodIds = _v0.verificationMethodIds;
	var debtorContactIds = _v0.debtorContactIds;
	var accountSettings = _v0.accountSettings;
	var _v1 = _Utils_Tuple3(accountSettings.verificationsWorkflowUseCadenceNotes, verificationMethodIds, debtorContactIds);
	_v1$3:
	while (true) {
		if (_v1.a) {
			if (!_v1.b.b) {
				if (!_v1.c.b) {
					return {contactsEmpty: true, methodsEmpty: true};
				} else {
					return {contactsEmpty: false, methodsEmpty: true};
				}
			} else {
				if (!_v1.c.b) {
					return {contactsEmpty: true, methodsEmpty: false};
				} else {
					break _v1$3;
				}
			}
		} else {
			break _v1$3;
		}
	}
	return {contactsEmpty: false, methodsEmpty: false};
};
var $author$project$Factoring$Page$VerificationBatch$SetFormValuesForAllInvoices = F2(
	function (a, b) {
		return {$: 'SetFormValuesForAllInvoices', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$maybeSetAllButton = F3(
	function (manuallyUpdated, itemIds, item) {
		var singleInvoice = $elm$core$List$length(itemIds) === 1;
		var showButton = manuallyUpdated && (!singleInvoice);
		return showButton ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__verification-notes-set-all-button'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Factoring$Page$VerificationBatch$SetFormValuesForAllInvoices, itemIds, item))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Set for All Invoices')
				])) : $author$project$Helpers$Html$empty;
	});
var $author$project$Factoring$Page$VerificationBatch$SaveItemThenMaybeFinish = F2(
	function (a, b) {
		return {$: 'SaveItemThenMaybeFinish', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$viewButton = F3(
	function (buttonClass, disable, _v0) {
		var label = _v0.a;
		var msg = _v0.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					buttonClass,
					$elm$html$Html$Attributes$disabled(disable),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewSaveButton = F5(
	function (accountSettings, debtorBatch, formState, _v0, itemData) {
		var cadenceDataMissing = _v0.cadenceDataMissing;
		var updatesToSave = _v0.updatesToSave;
		var isSaving = _v0.isSaving;
		var isComplete = A4($author$project$Factoring$Page$VerificationBatch$checkLoadedItemCompletion, accountSettings, debtorBatch.id, formState, itemData);
		var hideButton = $elm$html$Html$text($author$project$Helpers$String$nbsp);
		var classes = function (showGreen) {
			return $elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('load-detail__verifications-save-button', true),
						_Utils_Tuple2('button--progress', showGreen)
					]));
		};
		var blockFinishForCadenceData = cadenceDataMissing && accountSettings.verificationsWorkflowUseCadenceNotes;
		var blockRejectedFinishForCadenceData = blockFinishForCadenceData && accountSettings.verificationsWorkflowSendRejectedInvoicesToTMS;
		var _v1 = itemData;
		var item = _v1.item;
		var currentData = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Factoring$Page$VerificationBatch$itemDataToDefaultItemFormState, debtorBatch.id, itemData),
			A2($author$project$Factoring$Page$VerificationBatch$getItemFormState, item.id, formState));
		var isFinished = A2($author$project$Factoring$Page$VerificationBatch$checkIfFinished, debtorBatch.id, item);
		var blockEditing = (!$author$project$Domain$VerificationsDebtorBatch$inProgress(debtorBatch.state)) || (isSaving || isFinished);
		var justSaveButton = updatesToSave ? A3(
			$author$project$Factoring$Page$VerificationBatch$viewButton,
			classes(true),
			false,
			_Utils_Tuple2(
				'Save Invoice',
				A2($author$project$Factoring$Page$VerificationBatch$SaveItemThenMaybeFinish, item.id, false))) : hideButton;
		var saveAndFinishButton = function (label) {
			return A3(
				$author$project$Factoring$Page$VerificationBatch$viewButton,
				classes(isComplete),
				!isComplete,
				_Utils_Tuple2(
					label,
					A2($author$project$Factoring$Page$VerificationBatch$SaveItemThenMaybeFinish, item.id, true)));
		};
		var _v2 = _Utils_Tuple2(blockEditing, currentData.customState.state);
		if (!_v2.a) {
			switch (_v2.b.$) {
				case 'VerificationsDebtorBatchItemStateNotReady':
					var _v3 = _v2.b;
					return saveAndFinishButton('Send Invoice Back To Processors');
				case 'VerificationsDebtorBatchItemStateUnverified':
					var _v4 = _v2.b;
					return justSaveButton;
				case 'VerificationsDebtorBatchItemStateHeld':
					var _v5 = _v2.b;
					return justSaveButton;
				case 'VerificationsDebtorBatchItemStateVerified':
					var _v6 = _v2.b;
					return blockFinishForCadenceData ? justSaveButton : saveAndFinishButton('Save And Verify Invoice');
				case 'VerificationsDebtorBatchItemStateSkipped':
					var _v7 = _v2.b;
					return saveAndFinishButton('Skip Invoice Verification');
				case 'VerificationsDebtorBatchItemStateRejected':
					var _v8 = _v2.b;
					return blockRejectedFinishForCadenceData ? justSaveButton : saveAndFinishButton('Save And Reject Invoice');
				case 'VerificationsDebtorBatchItemStateAutoSkipped':
					var _v9 = _v2.b;
					return hideButton;
				default:
					var _v10 = _v2.b;
					return hideButton;
			}
		} else {
			return hideButton;
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewActionArea = F6(
	function (model, data, accountSettings, batch, itemIds, itemData) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(false, false),
			A2(
				$elm$core$Maybe$map,
				function (itemFormState) {
					return _Utils_Tuple2(itemFormState.manuallyUpdated, itemFormState.updatesToSave);
				},
				A2(
					$elm$core$Dict$get,
					$author$project$Domain$VerificationsDebtorBatchItemId$toComparable(itemData.item.id),
					model.formState)));
		var manuallyUpdated = _v0.a;
		var updatesToSave = _v0.b;
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$colspan(5),
					$elm$html$Html$Attributes$class('load-detail__verifications-action-area')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Factoring$Page$VerificationBatch$viewSaveButton,
					accountSettings,
					batch,
					model.formState,
					{
						cadenceDataMissing: $author$project$Factoring$Page$VerificationBatch$blockForCadenceData(
							$author$project$Factoring$Page$VerificationBatch$getCadenceDataMissing(data)),
						isSaving: model.isSaving,
						updatesToSave: updatesToSave
					},
					itemData),
					A3($author$project$Factoring$Page$VerificationBatch$maybeSetAllButton, manuallyUpdated, itemIds, itemData.item)
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$emptyToNothing = function (str) {
	return (str === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Factoring$Page$VerificationBatch$viewLabeledDetail = F2(
	function (label, detail) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('labeled-detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('detail-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(detail)
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewCarrier = function (tmsCarrier) {
	var maybeMcNumberText = A2(
		$elm$core$Maybe$andThen,
		$author$project$Factoring$Page$VerificationBatch$emptyToNothing,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.mcNumber;
			},
			tmsCarrier));
	var maybeCreditRatingText = A2(
		$elm$core$Maybe$andThen,
		$author$project$Factoring$Page$VerificationBatch$emptyToNothing,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.creditRating;
			},
			tmsCarrier));
	return _List_fromArray(
		[
			A2(
			$author$project$Factoring$Page$VerificationBatch$viewLabeledDetail,
			'Name:',
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Helpers$String$nbsp,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.name;
					},
					tmsCarrier))),
			A2(
			$author$project$Factoring$Page$VerificationBatch$viewLabeledDetail,
			'MC:',
			A2($elm$core$Maybe$withDefault, 'Unknown', maybeMcNumberText)),
			A2(
			$author$project$Factoring$Page$VerificationBatch$viewLabeledDetail,
			'Credit Rating:',
			A2($elm$core$Maybe$withDefault, 'Unknown', maybeCreditRatingText))
		]);
};
var $author$project$Factoring$Page$VerificationBatch$ChangeItemAmount = F2(
	function (a, b) {
		return {$: 'ChangeItemAmount', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$viewEditableAmount = F3(
	function (_v0, id, amount) {
		var blockItem = _v0.blockItem;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('number'),
					$elm$html$Html$Attributes$value(amount),
					$elm$html$Html$Events$onInput(
					$author$project$Factoring$Page$VerificationBatch$ChangeItemAmount(id)),
					$elm$html$Html$Attributes$disabled(blockItem),
					$elm$html$Html$Attributes$class('load-detail__verification-invoice-amount')
				]),
			_List_Nil);
	});
var $author$project$Factoring$Page$VerificationBatch$ChangeItemNotes = F2(
	function (a, b) {
		return {$: 'ChangeItemNotes', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$ChangeItemContact = F2(
	function (a, b) {
		return {$: 'ChangeItemContact', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$ChangeItemMethod = F2(
	function (a, b) {
		return {$: 'ChangeItemMethod', a: a, b: b};
	});
var $author$project$Domain$CadenceDebtorContact$name = function (contact) {
	return contact.firstName + (' ' + contact.lastName);
};
var $author$project$Factoring$Page$VerificationBatch$viewGenericOption = F2(
	function (_v0, display) {
		var toDisplayString = _v0.toDisplayString;
		var idString = _v0.idString;
		var toId = _v0.toId;
		var selection = _v0.selection;
		var isSelected = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(
					toId(display)),
				selection));
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					idString(
						toId(display))),
					$elm$html$Html$Attributes$selected(isSelected)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					toDisplayString(display))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewContactsAndMethodsDropdowns = F4(
	function (blockItem, formState, item, _v0) {
		var contacts = _v0.contacts;
		var methods = _v0.methods;
		var selectedMethodId = A2(
			$elm$core$Maybe$withDefault,
			item.cadenceVerificationMethodId,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.verificationMethodId;
				},
				A2($author$project$Factoring$Page$VerificationBatch$getItemFormState, item.id, formState)));
		var selectedContactId = A2(
			$elm$core$Maybe$withDefault,
			item.cadenceDebtorContactId,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.debtorContactId;
				},
				A2($author$project$Factoring$Page$VerificationBatch$getItemFormState, item.id, formState)));
		var appendEmptyMessage = F2(
			function (maybeSelection, message) {
				return $elm$core$List$append(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('empty'),
									$elm$html$Html$Attributes$selected(
									_Utils_eq(maybeSelection, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]))
						]));
			});
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__verification-dropdown'),
						$author$project$Helpers$Html$onChange(
						$author$project$Factoring$Page$VerificationBatch$ChangeItemContact(item.id)),
						$elm$html$Html$Attributes$disabled(blockItem)
					]),
				A3(
					appendEmptyMessage,
					selectedContactId,
					'Contact',
					A2(
						$elm$core$List$map,
						$author$project$Factoring$Page$VerificationBatch$viewGenericOption(
							{
								idString: A2($elm$core$Basics$composeR, $author$project$Domain$CadenceDebtorContactId$toInt, $elm$core$String$fromInt),
								selection: selectedContactId,
								toDisplayString: $author$project$Domain$CadenceDebtorContact$name,
								toId: function ($) {
									return $.id;
								}
							}),
						contacts))),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__verification-dropdown methods'),
						$author$project$Helpers$Html$onChange(
						$author$project$Factoring$Page$VerificationBatch$ChangeItemMethod(item.id)),
						$elm$html$Html$Attributes$disabled(blockItem)
					]),
				A3(
					appendEmptyMessage,
					selectedMethodId,
					'Contact method',
					A2(
						$elm$core$List$map,
						$author$project$Factoring$Page$VerificationBatch$viewGenericOption(
							{
								idString: A2($elm$core$Basics$composeR, $author$project$Domain$CadenceVerificationMethodId$toInt, $elm$core$String$fromInt),
								selection: selectedMethodId,
								toDisplayString: function ($) {
									return $.description;
								},
								toId: function ($) {
									return $.id;
								}
							}),
						methods)))
			]);
	});
var $author$project$Factoring$Page$VerificationBatch$viewEditableNotesContact = F4(
	function (_v0, formState, contactsAndMethods, item) {
		var blockItem = _v0.blockItem;
		var useCadenceNotes = _v0.useCadenceNotes;
		var maybeWithContactsAndMethods = function (textArea) {
			return useCadenceNotes ? A2(
				$author$project$Helpers$List$appendToEnd,
				textArea,
				A4($author$project$Factoring$Page$VerificationBatch$viewContactsAndMethodsDropdowns, blockItem, formState, item, contactsAndMethods)) : textArea;
		};
		var id = item.id;
		var notes = A2(
			$elm$core$Maybe$withDefault,
			item.note,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.notes;
				},
				A2($author$project$Factoring$Page$VerificationBatch$getItemFormState, id, formState)));
		var autoTextarea = function (_v1) {
			var placeholder = _v1.placeholder;
			var onInput = _v1.onInput;
			var text = _v1.text;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__verification-notes-textarea-autoexpand')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						$author$project$Helpers$Attributes$blockGrammarly(
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(onInput),
									$elm$html$Html$Attributes$placeholder(placeholder)
								])),
						_List_fromArray(
							[
								$elm$html$Html$text(text)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(text + '_')
							]))
					]));
		};
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__editable-notes')
				]),
			maybeWithContactsAndMethods(
				$elm$core$List$singleton(
					autoTextarea(
						{
							onInput: $author$project$Factoring$Page$VerificationBatch$ChangeItemNotes(id),
							placeholder: 'No additional notes.',
							text: notes
						}))));
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$driftedVerdictLabel = function (verdict) {
	_v0$2:
	while (true) {
		if (verdict.$ === 'Just') {
			switch (verdict.a.$) {
				case 'VerificationsDebtorConfirmationVerdictConfirmed':
					var _v1 = verdict.a;
					return 'Debtor: confirmed';
				case 'VerificationsDebtorConfirmationVerdictCorrection':
					var _v2 = verdict.a;
					return 'Debtor: sent back with changes';
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 'Debtor: replied by email';
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$indicatorLabel = F2(
	function (confirmation, state) {
		switch (state.$) {
			case 'Waiting':
				return 'Debtor: waiting';
			case 'RepliedInProse':
				return 'Debtor: replied by email';
			case 'Confirmed':
				return 'Debtor: confirmed';
			case 'Corrected':
				return 'Debtor: sent back with changes';
			case 'CarrierDisputed':
				return 'Debtor: disputes carrier';
			default:
				return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$driftedVerdictLabel(confirmation.verdict);
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateModifier = function (state) {
	switch (state.$) {
		case 'Waiting':
			return 'waiting';
		case 'RepliedInProse':
			return 'replied';
		case 'Confirmed':
			return 'confirmed';
		case 'Corrected':
			return 'corrected';
		case 'CarrierDisputed':
			return 'carrier-disputed';
		default:
			return 'drifted';
	}
};
var $author$project$Ui$V3$StatusTag$WarningStyle = {$: 'WarningStyle'};
var $author$project$Ui$V3$StatusTag$warningStyle = $author$project$Ui$V3$StatusTag$Style($author$project$Ui$V3$StatusTag$WarningStyle);
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateTagStyle = function (state) {
	switch (state.$) {
		case 'Waiting':
			return $author$project$Ui$V3$StatusTag$neutralStyle;
		case 'RepliedInProse':
			return $author$project$Ui$V3$StatusTag$activeStyle;
		case 'Confirmed':
			return $author$project$Ui$V3$StatusTag$successStyle;
		case 'Corrected':
			return $author$project$Ui$V3$StatusTag$warningStyle;
		case 'CarrierDisputed':
			return $author$project$Ui$V3$StatusTag$alertStyle;
		default:
			return $author$project$Ui$V3$StatusTag$warningStyle;
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$driftedSubject = function (driftedFields) {
	return A2($elm$core$List$member, 'amount', driftedFields) ? 'Amount changed since we asked' : 'Details changed since we asked';
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewDriftNote = F2(
	function (state, confirmation) {
		if (state.$ === 'Drifted') {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-indicator-drift')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$driftedSubject(confirmation.driftedFields))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewIndicator = F2(
	function (_v0, confirmation) {
		var open = _v0.open;
		var _v1 = $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$loadState(confirmation);
		if (_v1.$ === 'Nothing') {
			return $author$project$Helpers$Html$empty;
		} else {
			var state = _v1.a;
			return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$v3Scoped(
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('verification__debtor-confirmation-indicator', true),
									_Utils_Tuple2(
									'verification__debtor-confirmation-indicator--' + $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateModifier(state),
									true)
								])),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick(open)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('verification__debtor-confirmation-indicator-badge')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$V3$Icon$view16,
									_List_Nil,
									$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateIcon(state)),
									A2(
									$author$project$Ui$V3$StatusTag$view,
									_List_fromArray(
										[
											$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateTagStyle(state),
											$author$project$Ui$V3$StatusTag$smallSize,
											$author$project$Ui$V3$StatusTag$subtleEmphasis
										]),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$indicatorLabel, confirmation, state))
								])),
						A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewDriftNote, state, confirmation))));
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$inlineGlyph = function (state) {
	switch (state.$) {
		case 'Waiting':
			return 'fi-clock';
		case 'RepliedInProse':
			return 'fi-mail';
		case 'Confirmed':
			return 'fi-check';
		case 'Corrected':
			return 'fi-alert';
		case 'CarrierDisputed':
			return 'fi-prohibited';
		default:
			return 'fi-alert';
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$inlineLabel = function (state) {
	switch (state.$) {
		case 'Waiting':
			return 'Awaiting debtor';
		case 'RepliedInProse':
			return 'Replied by email';
		case 'Confirmed':
			return 'Confirmed';
		case 'Corrected':
			return 'Sent back with changes';
		case 'CarrierDisputed':
			return 'Disputes carrier';
		default:
			return 'Changed since we asked';
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$inlineSeverity = function (state) {
	switch (state.$) {
		case 'Waiting':
			return $author$project$Domain$Verification$Checking;
		case 'RepliedInProse':
			return $author$project$Domain$Verification$Checking;
		case 'Confirmed':
			return $author$project$Domain$Verification$Clear;
		case 'Corrected':
			return $author$project$Domain$Verification$Alert;
		case 'CarrierDisputed':
			return $author$project$Domain$Verification$Alert;
		default:
			return $author$project$Domain$Verification$Alert;
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$accessorialsLabel = 'Accessorials';
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$advancesLabel = 'Advances';
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Agrees = {$: 'Agrees'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed = F2(
	function (label, value) {
		return {agreement: $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Agrees, comparison: $elm$core$Maybe$Nothing, label: label, value: value};
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$amountToPayLabel = 'Amount to pay';
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Disagrees = {$: 'Disagrees'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$disagreed = F3(
	function (label, value, comparison) {
		return {agreement: $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Disagrees, comparison: comparison, label: label, value: value};
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Unanswered = {$: 'Unanswered'};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$leftBlank = function (label) {
	return {agreement: $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Unanswered, comparison: $elm$core$Maybe$Nothing, label: label, value: 'left blank'};
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$amountCheck = F2(
	function (itemData, maybeAnswer) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank, maybeAnswer);
		if (_v0.$ === 'Nothing') {
			return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$leftBlank($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$amountToPayLabel);
		} else {
			var answer = _v0.a;
			var invoiceAmount = A2($elm$core$Maybe$andThen, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank, itemData.invoice.amount);
			var asMoney = function (amount) {
				return $elm$core$Result$toMaybe(
					$author$project$Money$fromString(amount));
			};
			return ((!_Utils_eq(
				asMoney(answer),
				$elm$core$Maybe$Nothing)) && _Utils_eq(
				asMoney(answer),
				A2($elm$core$Maybe$andThen, asMoney, invoiceAmount))) ? A2(
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed,
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$amountToPayLabel,
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText(answer)) : A3(
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$disagreed,
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$amountToPayLabel,
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText(answer),
				A2(
					$elm$core$Maybe$map,
					function (amount) {
						return 'invoice: ' + $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText(amount);
					},
					invoiceAmount));
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$rightCarrierLabel = 'Right carrier';
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$carrierCheck = F2(
	function (itemData, answers) {
		var _v0 = answers.carrierDisputed;
		if (_v0.$ === 'Nothing') {
			return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$leftBlank($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$rightCarrierLabel);
		} else {
			if (!_v0.a) {
				return A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$rightCarrierLabel, 'Yes');
			} else {
				return A3(
					$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$disagreed,
					$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$rightCarrierLabel,
					A2(
						$elm$core$Maybe$withDefault,
						'someone they didn\u0027t name',
						A2($elm$core$Maybe$andThen, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank, answers.actualCarrier)),
					A2(
						$elm$core$Maybe$map,
						function (carrier) {
							return 'invoice: ' + carrier.name;
						},
						itemData.tmsCarrier));
			}
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deductionsLabel = 'Deductions';
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveredLabel = 'Delivered';
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveryCheck = function (maybeDelivery) {
	if (maybeDelivery.$ === 'Nothing') {
		return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$leftBlank($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveredLabel);
	} else {
		switch (maybeDelivery.a.$) {
			case 'VerificationsDebtorConfirmationDeliveryUnknown':
				var _v1 = maybeDelivery.a;
				return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$leftBlank($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveredLabel);
			case 'VerificationsDebtorConfirmationDeliveryDelivered':
				var _v2 = maybeDelivery.a;
				return A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveredLabel, 'Yes');
			case 'VerificationsDebtorConfirmationDeliveryNotYet':
				var _v3 = maybeDelivery.a;
				return A3($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$disagreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveredLabel, 'Not yet', $elm$core$Maybe$Nothing);
			default:
				var _v4 = maybeDelivery.a;
				return A3($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$disagreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveredLabel, 'Never will be', $elm$core$Maybe$Nothing);
		}
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$outstandingCheck = F2(
	function (label, maybeAmount) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$nonBlank, maybeAmount);
		if (_v0.$ === 'Nothing') {
			return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$leftBlank(label);
		} else {
			var amount = _v0.a;
			return _Utils_eq(
				$author$project$Money$fromString(amount),
				$elm$core$Result$Ok($author$project$Money$zero)) ? A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed, label, 'None') : A3(
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$disagreed,
				label,
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$moneyText(amount),
				$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$inlineChecklist = F2(
	function (itemData, confirmation) {
		var _v0 = _Utils_Tuple2(confirmation.channel, confirmation.answers);
		_v0$1:
		while (true) {
			if (_v0.a.$ === 'Nothing') {
				var _v1 = _v0.a;
				return $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.$ === 'Just') {
					if (_v0.a.a.$ === 'VerificationsDebtorConfirmationChannelEmailReply') {
						break _v0$1;
					} else {
						var answers = _v0.b.a;
						return $elm$core$Maybe$Just(
							_List_fromArray(
								[
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$amountCheck, itemData, answers.amountToPay),
									$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveryCheck(answers.delivery),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$carrierCheck, itemData, answers),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$outstandingCheck, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$advancesLabel, answers.advances),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$outstandingCheck, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deductionsLabel, answers.deductions),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$outstandingCheck, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$accessorialsLabel, answers.accessorials)
								]));
					}
				} else {
					if (_v0.a.a.$ === 'VerificationsDebtorConfirmationChannelEmailReply') {
						break _v0$1;
					} else {
						var _v3 = _v0.b;
						return $elm$core$Maybe$Just(
							_List_fromArray(
								[
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$amountCheck, itemData, confirmation.askedAmount),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deliveredLabel, 'Yes'),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$rightCarrierLabel, 'Yes'),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$advancesLabel, 'None'),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$deductionsLabel, 'None'),
									A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreed, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$accessorialsLabel, 'None')
								]));
					}
				}
			}
		}
		var _v2 = _v0.a.a;
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreementIconClass = function (agreement) {
	switch (agreement.$) {
		case 'Agrees':
			return 'fi-check load-detail__debtor-verification-detail-icon success';
		case 'Disagrees':
			return 'fi-alert load-detail__debtor-verification-detail-icon fail';
		default:
			return 'fi-minus load-detail__debtor-verification-detail-icon skipped';
	}
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewCheck = function (check) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('verification__debtor-confirmation-check')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$agreementIconClass(check.agreement)),
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
					]),
				_List_Nil),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-check-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(check.label)
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-check-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(check.value)
							])),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (comparison) {
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('verification__debtor-confirmation-check-comparison')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('(' + (comparison + ')'))
											]))
									]);
							},
							check.comparison))))));
};
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewInlineAnswers = F5(
	function (tz, debtor, itemData, confirmation, state) {
		if (state.$ === 'Waiting') {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-modal-state')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A4($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$stateSentence, tz, debtor, confirmation, state))
						]))
				]);
		} else {
			var _v1 = A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$inlineChecklist, itemData, confirmation);
			if (_v1.$ === 'Nothing') {
				return $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFreeText(confirmation.freeText);
			} else {
				var checks = _v1.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('load-detail__debtor-verification-detail-display')
							]),
						A2($elm$core$List$map, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewCheck, checks)),
					$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFreeText(confirmation.freeText));
			}
		}
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewInlineBody = F5(
	function (tz, debtor, itemData, confirmation, state) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-panel')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFacts(confirmation),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewAnsweredBy, tz, confirmation),
							A2($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewDrift, itemData, confirmation),
							A5($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewInlineAnswers, tz, debtor, itemData, confirmation, state)
						]))));
	});
var $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewInline = F4(
	function (tz, debtor, itemData, confirmation) {
		return A2(
			$elm$core$Maybe$map,
			function (state) {
				return {
					answered: !_Utils_eq(state, $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$Waiting),
					body: A5($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewInlineBody, tz, debtor, itemData, confirmation, state),
					glyph: $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$inlineGlyph(state),
					label: $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$inlineLabel(state),
					severity: $author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$inlineSeverity(state)
				};
			},
			$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$loadState(confirmation));
	});
var $author$project$Factoring$Page$VerificationBatch$viewLabel = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carrier-labels__label')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Factoring$Page$VerificationBatch$viewLabels = function (invoice) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carrier_labels message__carrier-labels')
			]),
		A2($elm$core$List$map, $author$project$Factoring$Page$VerificationBatch$viewLabel, invoice.labels));
};
var $author$project$Factoring$Page$VerificationBatch$viewNoaPaymentLabel = function (_v0) {
	var paymentCount = _v0.paymentCount;
	var aging = _v0.aging;
	var exists = function (maybeSomething) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(true),
				maybeSomething));
	};
	var baseLabel = F3(
		function (divclass, iclass, msg) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('noa-labels message__noa-labels')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('noa-labels__label ' + divclass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(iclass)
									]),
								_List_Nil),
								$elm$html$Html$text(msg)
							]))
					]));
		});
	var failure = function (msg) {
		return A3(baseLabel, 'error', 'fi-x', msg);
	};
	var fullSuccess = function (msg) {
		return A3(baseLabel, 'full_success', 'fi-check', msg);
	};
	var partialSuccess = function (msg) {
		return A3(baseLabel, 'partial_success', 'fi-check', msg);
	};
	return (paymentCount > 0) ? fullSuccess('NOA: Payments Made') : (exists(aging.noaReceivedAt) ? partialSuccess('NOA: Received') : (exists(aging.noaSentAt) ? partialSuccess('NOA: Sent') : failure('NOA: Not Sent')));
};
var $author$project$Factoring$Page$VerificationBatch$viewInvoiceData = F2(
	function (_v0, tz) {
		var maybeAgingAndPaymentData = _v0.maybeAgingAndPaymentData;
		var invoice = _v0.invoice;
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__verification-load-and-date')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Factoring$Page$VerificationBatch$viewLabeledDetail,
					'Load ID:',
					A2($elm$core$Maybe$withDefault, '', invoice.loadId)),
					A2(
					$author$project$Factoring$Page$VerificationBatch$viewLabeledDetail,
					'Received At:',
					A2($author$project$Helpers$Date$compactDateTimeString, tz, invoice.receivedAt)),
					$author$project$Factoring$Page$VerificationBatch$viewLabels(invoice),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text($author$project$Helpers$String$nbsp),
					A2($elm$core$Maybe$map, $author$project$Factoring$Page$VerificationBatch$viewNoaPaymentLabel, maybeAgingAndPaymentData))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewStaticNotesContact = F2(
	function (useCadenceNotes, _v0) {
		var debtorContact = _v0.debtorContact;
		var verificationMethod = _v0.verificationMethod;
		var item = _v0.item;
		var maybeView = F3(
			function (label, maybeObject, toText) {
				var _v1 = _Utils_Tuple2(maybeObject, useCadenceNotes);
				if ((_v1.a.$ === 'Just') && _v1.b) {
					var object = _v1.a.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Factoring$Page$VerificationBatch$viewLabeledDetail,
							label,
							toText(object))
						]);
				} else {
					return _List_Nil;
				}
			});
		var maybeItem = (item.note === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(item);
		return A2(
			$elm$core$List$append,
			A3(maybeView, 'Contact:', debtorContact, $author$project$Domain$CadenceDebtorContact$name),
			A2(
				$elm$core$List$append,
				A3(
					maybeView,
					'Method:',
					verificationMethod,
					function ($) {
						return $.description;
					}),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A3(
							maybeView,
							'Notes:',
							maybeItem,
							function ($) {
								return $.note;
							}))
					])));
	});
var $author$project$Factoring$Page$VerificationBatch$ChangeItemState = F2(
	function (a, b) {
		return {$: 'ChangeItemState', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$viewStatusOption = F2(
	function (selected, customState) {
		var isSelected = _Utils_eq(customState.id, selected.id);
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(customState.id),
					$elm$html$Html$Attributes$selected(isSelected)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(customState.name)
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewStatusDropdown = F5(
	function (customStates, _v0, id, formState, defaultSelection) {
		var blockItem = _v0.blockItem;
		var useCadenceNotes = _v0.useCadenceNotes;
		var selected = A2(
			$elm$core$Maybe$withDefault,
			defaultSelection,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.customState;
				},
				A2($author$project$Factoring$Page$VerificationBatch$getItemFormState, id, formState)));
		var selectableCustomStates = A2(
			$elm$core$List$filter,
			function ($) {
				return $.selectable;
			},
			customStates);
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('load-detail__verification-state-dropdown', true),
							_Utils_Tuple2('load-detail__old-ver-dropdown', !useCadenceNotes)
						])),
					$author$project$Helpers$Html$onChange(
					$author$project$Factoring$Page$VerificationBatch$ChangeItemState(id)),
					$elm$html$Html$Attributes$disabled(blockItem)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Factoring$Page$VerificationBatch$viewStatusOption(selected),
				selectableCustomStates));
	});
var $author$project$Factoring$Page$VerificationBatch$viewBatchItem = F4(
	function (model, data, index, itemData) {
		var loadedMethods = A2($elm$core$List$filterMap, $author$project$Forward$Remote$toMaybe, data.verificationMethods);
		var loadedContacts = A2($elm$core$List$filterMap, $author$project$Forward$Remote$toMaybe, data.debtorContacts);
		var contactsAndMethods = {contacts: loadedContacts, methods: loadedMethods};
		var amount = A2(
			$elm$core$Maybe$withDefault,
			A2($elm$core$Maybe$withDefault, '', itemData.invoice.amount),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.invoiceAmount;
				},
				A2($author$project$Factoring$Page$VerificationBatch$getItemFormState, itemData.item.id, model.formState)));
		var amountString = A2(
			$elm$core$Result$withDefault,
			'',
			A2(
				$elm$core$Result$map,
				$author$project$Money$toString,
				$author$project$Money$fromString(amount)));
		var _v0 = itemData;
		var invoice = _v0.invoice;
		var item = _v0.item;
		var isCurrentInvoice = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(invoice.id),
				A2($author$project$Factoring$Page$VerificationBatch$selectedFactorInvoiceId, data, model)));
		var rowClasses = _List_fromArray(
			[
				_Utils_Tuple2('load-detail__verification-batch-row', true),
				_Utils_Tuple2('load-detail__invoice-table-current-invoice', isCurrentInvoice),
				_Utils_Tuple2(
				'odd',
				1 === A2($elm$core$Basics$modBy, 2, index)),
				_Utils_Tuple2(
				'even',
				!A2($elm$core$Basics$modBy, 2, index))
			]);
		var rowAttributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$classList(rowClasses),
				$elm$html$Html$Events$onClick(
				$author$project$Factoring$Page$VerificationBatch$SelectInvoice(invoice.id))
			]);
		var blockItem = A2($author$project$Factoring$Page$VerificationBatch$checkIfFinished, model.debtorBatchId, item) || model.isSaving;
		var _v1 = data;
		var itemIds = _v1.itemIds;
		var debtorBatch = _v1.debtorBatch;
		var debtor = _v1.debtor;
		var accountSettings = _v1.accountSettings;
		var maybeConfirmation = accountSettings.verificationsDebtorConfirmationEnabled ? itemData.item.debtorConfirmation : $elm$core$Maybe$Nothing;
		var viewDebtorConfirmationIndicator = function () {
			if (maybeConfirmation.$ === 'Just') {
				var confirmation = maybeConfirmation.a;
				return A2(
					$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewIndicator,
					{
						open: $author$project$Factoring$Page$VerificationBatch$OpenDebtorConfirmation(
							$author$project$Factoring$Page$VerificationBatch$SingleLoad(item.id))
					},
					confirmation);
			} else {
				return $author$project$Helpers$Html$empty;
			}
		}();
		var useCadenceNotes = accountSettings.verificationsWorkflowUseCadenceNotes;
		var maybeAppendDebtorConfirmation = function () {
			var _v4 = A2(
				$elm$core$Maybe$andThen,
				A3($author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewInline, model.timezone, debtor, itemData),
				maybeConfirmation);
			if (_v4.$ === 'Just') {
				var inline = _v4.a;
				return $author$project$Helpers$List$appendToEnd(
					A4($author$project$Factoring$Page$VerificationBatch$debtorConfirmationSection, rowClasses, model, itemData, inline));
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var maybeAppendDebtorVerifications = function () {
			var _v3 = _Utils_Tuple2(itemData.maybeAutoVerification, accountSettings.paymentsNetworkEnabled);
			if ((_v3.a.$ === 'Just') && _v3.b) {
				var autoVerification = _v3.a.a;
				return $author$project$Helpers$List$appendToEnd(
					A5($author$project$Factoring$Page$VerificationBatch$debtorVerifications, rowClasses, model, debtor, itemData, autoVerification));
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var isEditable = $author$project$Domain$VerificationsDebtorBatch$inProgress(debtorBatch.state);
		var itemMarkupBools = {
			blockItem: blockItem,
			isComplete: A4($author$project$Factoring$Page$VerificationBatch$checkItemCompletion, accountSettings, model.debtorBatchId, model.formState, itemData),
			isEditable: isEditable,
			useCadenceNotes: useCadenceNotes
		};
		var plainCol = $elm$html$Html$td(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('load-detail__verification-plain-col', isEditable && useCadenceNotes)
						]))
				]));
		var _v2 = isEditable ? _Utils_Tuple3(
			A5($author$project$Factoring$Page$VerificationBatch$viewStatusDropdown, accountSettings.verificationsWorkflowDebtorBatchItemCustomStates, itemMarkupBools, item.id, model.formState, item.effectiveCustomState),
			A4($author$project$Factoring$Page$VerificationBatch$viewEditableNotesContact, itemMarkupBools, model.formState, contactsAndMethods, item),
			A3($author$project$Factoring$Page$VerificationBatch$viewEditableAmount, itemMarkupBools, item.id, amount)) : _Utils_Tuple3(
			A2($author$project$Factoring$Page$VerificationBatch$viewLabeledDetail, 'Status:', item.effectiveCustomState.name),
			plainCol(
				A2($author$project$Factoring$Page$VerificationBatch$viewStaticNotesContact, useCadenceNotes, itemData)),
			A2($author$project$Factoring$Page$VerificationBatch$viewLabeledDetail, 'Amount:', amountString));
		var viewStatus = _v2.a;
		var viewNotesContactsAndMethods = _v2.b;
		var viewAmount = _v2.c;
		return maybeAppendDebtorConfirmation(
			maybeAppendDebtorVerifications(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						rowAttributes,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-col')
									]),
								_List_fromArray(
									[
										$author$project$Components$RedDot$view(
										_List_fromArray(
											[
												$elm$core$Maybe$Just(
												{
													autoVerification: itemData.maybeAutoVerification,
													verificationsDebtorBatchItem: $elm$core$Maybe$Just(itemData.item)
												})
											]))
									])),
								A2($author$project$Factoring$Page$VerificationBatch$viewInvoiceData, itemData, model.timezone),
								plainCol(
								$author$project$Factoring$Page$VerificationBatch$viewCarrier(itemData.tmsCarrier)),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('load-detail__status-box-col')
									]),
								_List_fromArray(
									[viewAmount, viewStatus, viewDebtorConfirmationIndicator])),
								viewNotesContactsAndMethods
							])),
						A2(
						$elm$html$Html$tr,
						rowAttributes,
						_List_fromArray(
							[
								A6($author$project$Factoring$Page$VerificationBatch$viewActionArea, model, data, accountSettings, debtorBatch, itemIds, itemData)
							]))
					])));
	});
var $author$project$Factoring$Page$VerificationBatch$viewBatchItemOnLoad = F4(
	function (model, data, index, itemData) {
		var unloadedDataRow = function (message) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('load-detail__verification-batch-row', true),
									_Utils_Tuple2(
									'odd',
									1 === A2($elm$core$Basics$modBy, 2, index)),
									_Utils_Tuple2(
									'even',
									!A2($elm$core$Basics$modBy, 2, index))
								]))
						]),
					$author$project$Factoring$Page$VerificationBatch$toCols(
						A2(
							$elm$core$List$cons,
							message,
							A2(
								$elm$core$List$repeat,
								5,
								$elm$html$Html$text($author$project$Helpers$String$nbsp)))))
				]);
		};
		switch (itemData.$) {
			case 'Loaded':
				var loadedItemData = itemData.a;
				return A4($author$project$Factoring$Page$VerificationBatch$viewBatchItem, model, data, index, loadedItemData);
			case 'Loading':
				return unloadedDataRow(
					$elm$html$Html$text('Loading...'));
			default:
				var err = itemData.a;
				return unloadedDataRow(
					$author$project$Forward$LoadingView$defaultErrorView(err));
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewBatchItems = F2(
	function (data, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__invoices-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Invoices')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__info-table verification__invoice-table')
						]),
					A2(
						$elm$core$List$cons,
						$author$project$Factoring$Page$VerificationBatch$batchItemRowHeaders(data.accountSettings.verificationsWorkflowUseCadenceNotes),
						$elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								A2($author$project$Factoring$Page$VerificationBatch$viewBatchItemOnLoad, model, data),
								data.items))))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$SetDebtorContactInfoExpanded = function (a) {
	return {$: 'SetDebtorContactInfoExpanded', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$viewLink = function (_v0) {
	var content = _v0.content;
	var protocol = _v0.protocol;
	var label = _v0.label;
	var classSuffix = _v0.classSuffix;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('verification__cadence-details-' + classSuffix)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(protocol + (':' + content))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(content)
					]))
			]));
};
var $author$project$Factoring$Page$VerificationBatch$maybeViewCadenceDebtorDetails = F2(
	function (debtor, expanded) {
		var buildArgs = F2(
			function (args, content) {
				return {classSuffix: args.classSuffix, content: content, label: args.label, protocol: args.protocol};
			});
		var contactDetailsDisplay = A2(
			$elm$core$List$filterMap,
			$elm$core$Maybe$map($author$project$Factoring$Page$VerificationBatch$viewLink),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					buildArgs(
						{classSuffix: 'email', label: 'Email: ', protocol: 'mailto'}),
					debtor.cadenceDebtorDetails.email),
					A2(
					$elm$core$Maybe$map,
					buildArgs(
						{classSuffix: 'phone1', label: 'Phone 1: ', protocol: 'tel'}),
					debtor.cadenceDebtorDetails.phone1),
					A2(
					$elm$core$Maybe$map,
					buildArgs(
						{classSuffix: 'phone2', label: 'Phone 2: ', protocol: 'tel'}),
					debtor.cadenceDebtorDetails.phone2)
				]));
		var displayHtml = ($elm$core$List$isEmpty(contactDetailsDisplay) && expanded) ? _List_fromArray(
			[
				$elm$html$Html$text('Please set debtor contact details in your factoring application in order to view them in TriumphPay Audit.')
			]) : (expanded ? contactDetailsDisplay : _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__contact-info-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Contact Details'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__expand-button')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('fi-minus', expanded),
													_Utils_Tuple2('fi-plus', !expanded)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Factoring$Page$VerificationBatch$SetDebtorContactInfoExpanded(!expanded))
										]),
									_List_fromArray(
										[$author$project$Helpers$Html$empty]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__cadence-details')
						]),
					displayHtml)
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$SaveContactInfo = function (a) {
	return {$: 'SaveContactInfo', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$ToggleContactInfoChanges = function (a) {
	return {$: 'ToggleContactInfoChanges', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$UpdateContactInfo = function (a) {
	return {$: 'UpdateContactInfo', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$viewEditableContactInfo = F2(
	function (model, debtor) {
		var editLinkHtml = (!model.editingContactInfo) ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title('Edit'),
					$elm$html$Html$Events$onClick(
					$author$project$Factoring$Page$VerificationBatch$ToggleContactInfoChanges(true))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fi-pencil')
						]),
					_List_Nil)
				])) : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Factoring$Page$VerificationBatch$ToggleContactInfoChanges(false))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('cancel')
				]));
		var contactString = function () {
			var _v1 = model.newContactInfo;
			if (_v1.$ === 'Nothing') {
				return debtor.contactInfo;
			} else {
				var newContactInfo = _v1.a;
				return newContactInfo;
			}
		}();
		var button = (!model.isSaving) ? A3(
			$author$project$Components$Shared$Button$confirm,
			'Save Contact Info',
			$author$project$Factoring$Page$VerificationBatch$SaveContactInfo(debtor.id),
			_List_Nil) : A2($author$project$Components$Shared$Button$disabled, 'Save Contact Info', _List_Nil);
		var displayHtml = function () {
			if (!model.editingContactInfo) {
				var _v0 = debtor.contactInfo;
				if (_v0 === '') {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__contact-info-blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Click the pencil icon above to add contact details.')
							]));
				} else {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						$author$project$Domain$EmailBody$textToHtml(debtor.contactInfo));
				}
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$textarea,
							$author$project$Helpers$Attributes$blockGrammarly(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('verification__contact-info-textarea'),
										$elm$html$Html$Attributes$disabled(model.isSaving),
										$elm$html$Html$Events$onInput($author$project$Factoring$Page$VerificationBatch$UpdateContactInfo),
										$elm$html$Html$Attributes$value(contactString)
									])),
							_List_Nil),
							button
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__contact-info-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Contact Info'),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Helpers$String$nbsp)
								])),
							editLinkHtml
						])),
					displayHtml
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewContactInfo = F3(
	function (accountSettings, model, debtor) {
		return accountSettings.showCadenceDebtorInfo ? A2($author$project$Factoring$Page$VerificationBatch$maybeViewCadenceDebtorDetails, debtor, model.contactInfoExpanded) : A2($author$project$Factoring$Page$VerificationBatch$viewEditableContactInfo, model, debtor);
	});
var $author$project$Factoring$Page$VerificationBatch$Asked = {$: 'Asked'};
var $author$project$Factoring$Page$VerificationBatch$BlockedNow = function (a) {
	return {$: 'BlockedNow', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$FromContact = {$: 'FromContact'};
var $author$project$Factoring$Page$VerificationBatch$NotEmailed = function (a) {
	return {$: 'NotEmailed', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$TakenOffTheList = {$: 'TakenOffTheList'};
var $author$project$Factoring$Page$VerificationBatch$askedAddressees = function (loadedItems) {
	return A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		function ($) {
			return $.address;
		},
		A2(
			$elm$core$List$filter,
			function (recipient) {
				return !$elm$core$String$isEmpty(recipient.address);
			},
			A2(
				$elm$core$List$map,
				function (recipient) {
					return {
						acceptedAt: recipient.acceptedAt,
						address: $author$project$Factoring$Page$VerificationBatch$normalizeAddress(recipient.emailAddress),
						bounceReason: recipient.bounceReason,
						bouncedAt: recipient.bouncedAt,
						deliveredAt: recipient.deliveredAt,
						deliveryError: recipient.deliveryError,
						name: $elm$core$String$trim(recipient.name),
						openedAt: recipient.openedAt
					};
				},
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.recipients;
					},
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.askedAt;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$map($elm$time$Time$posixToMillis),
									$elm$core$Maybe$withDefault(0))),
							A2(
								$elm$core$List$filterMap,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.item;
									},
									function ($) {
										return $.debtorConfirmation;
									}),
								loadedItems)))))));
};
var $author$project$Factoring$Page$VerificationBatch$Accepted = function (a) {
	return {$: 'Accepted', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$Bounced = function (a) {
	return {$: 'Bounced', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$Delivered = function (a) {
	return {$: 'Delivered', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$DeliveryFailed = function (a) {
	return {$: 'DeliveryFailed', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$Opened = function (a) {
	return {$: 'Opened', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$Sending = {$: 'Sending'};
var $author$project$Factoring$Page$VerificationBatch$Bouncing = {$: 'Bouncing'};
var $author$project$Factoring$Page$VerificationBatch$InvalidAddress = {$: 'InvalidAddress'};
var $author$project$Factoring$Page$VerificationBatch$OptedOut = function (a) {
	return {$: 'OptedOut', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$optOutsFor = function (debtorBatch) {
	return A2(
		$elm$core$List$map,
		function (optOut) {
			return _Utils_Tuple2(
				$author$project$Factoring$Page$VerificationBatch$normalizeAddress(optOut.emailAddress),
				optOut);
		},
		debtorBatch.optOuts);
};
var $author$project$Factoring$Page$VerificationBatch$blockedReason = F2(
	function (debtorBatch, address) {
		if (!$author$project$Domain$EmailAddress$isValid(address)) {
			return $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$InvalidAddress);
		} else {
			var _v0 = A2(
				$elm_community$list_extra$List$Extra$find,
				function (_v1) {
					var optOutAddress = _v1.a;
					return _Utils_eq(optOutAddress, address);
				},
				$author$project$Factoring$Page$VerificationBatch$optOutsFor(debtorBatch));
			if (_v0.$ === 'Just') {
				var _v2 = _v0.a;
				var optOut = _v2.b;
				return $elm$core$Maybe$Just(
					$author$project$Factoring$Page$VerificationBatch$OptedOut(optOut));
			} else {
				return A2(
					$elm$core$Set$member,
					address,
					$elm$core$Set$fromList(
						A2($elm$core$List$map, $author$project$Factoring$Page$VerificationBatch$normalizeAddress, debtorBatch.bouncingAddresses))) ? $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$Bouncing) : $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Factoring$Page$VerificationBatch$BlockedBouncing = {$: 'BlockedBouncing'};
var $author$project$Factoring$Page$VerificationBatch$BlockedInvalidAddress = {$: 'BlockedInvalidAddress'};
var $author$project$Factoring$Page$VerificationBatch$BlockedOptedOut = function (a) {
	return {$: 'BlockedOptedOut', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$blockedStateFor = function (reason) {
	switch (reason.$) {
		case 'Bouncing':
			return $author$project$Factoring$Page$VerificationBatch$BlockedBouncing;
		case 'OptedOut':
			var optOut = reason.a;
			return $author$project$Factoring$Page$VerificationBatch$BlockedOptedOut(optOut);
		default:
			return $author$project$Factoring$Page$VerificationBatch$BlockedInvalidAddress;
	}
};
var $author$project$Factoring$Page$VerificationBatch$askedRecipientState = F2(
	function (debtorBatch, recipient) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Factoring$Page$VerificationBatch$Sending,
			$elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2($elm$core$Maybe$map, $author$project$Factoring$Page$VerificationBatch$DeliveryFailed, recipient.deliveryError),
							A2(
							$elm$core$Maybe$map,
							function (at) {
								return $author$project$Factoring$Page$VerificationBatch$Bounced(
									{at: at, reason: recipient.bounceReason});
							},
							recipient.bouncedAt),
							A2($elm$core$Maybe$map, $author$project$Factoring$Page$VerificationBatch$Opened, recipient.openedAt),
							A2($elm$core$Maybe$map, $author$project$Factoring$Page$VerificationBatch$Delivered, recipient.deliveredAt),
							A2(
							$elm$core$Maybe$map,
							$author$project$Factoring$Page$VerificationBatch$blockedStateFor,
							A2($author$project$Factoring$Page$VerificationBatch$blockedReason, debtorBatch, recipient.address)),
							A2($elm$core$Maybe$map, $author$project$Factoring$Page$VerificationBatch$Accepted, recipient.acceptedAt)
						]))));
	});
var $author$project$Factoring$Page$VerificationBatch$excludedByVerifier = function (debtorBatch) {
	return $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.emailAddress;
				},
				$author$project$Factoring$Page$VerificationBatch$normalizeAddress),
			A2(
				$elm$core$List$filter,
				function (edit) {
					return _Utils_eq(edit.kind, $author$project$AuditPb$VerificationsDebtorConfirmationRecipientEditKindExcluded);
				},
				debtorBatch.recipientEdits)));
};
var $author$project$Factoring$Page$VerificationBatch$askedRecipientRows = F3(
	function (debtorBatch, contacts, loadedItems) {
		var excluded = $author$project$Factoring$Page$VerificationBatch$excludedByVerifier(debtorBatch);
		var notEmailedReason = function (address) {
			return A2($elm$core$Set$member, address, excluded) ? $elm$core$Maybe$Just($author$project$Factoring$Page$VerificationBatch$TakenOffTheList) : A2(
				$elm$core$Maybe$map,
				$author$project$Factoring$Page$VerificationBatch$BlockedNow,
				A2($author$project$Factoring$Page$VerificationBatch$blockedReason, debtorBatch, address));
		};
		var asked = $author$project$Factoring$Page$VerificationBatch$askedAddressees(loadedItems);
		var askedAddresses = $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.address;
				},
				asked));
		var notEmailed = A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.address;
			},
			A2(
				$elm$core$List$filter,
				function (row) {
					return (!$elm$core$String$isEmpty(row.address)) && (!A2($elm$core$Set$member, row.address, askedAddresses));
				},
				A2(
					$elm$core$List$map,
					function (contact) {
						var address = $author$project$Factoring$Page$VerificationBatch$normalizeAddress(contact.email);
						return {
							address: address,
							name: $author$project$Domain$CadenceDebtorContact$name(contact),
							origin: $author$project$Factoring$Page$VerificationBatch$FromContact,
							state: $author$project$Factoring$Page$VerificationBatch$NotEmailed(
								notEmailedReason(address))
						};
					},
					contacts)));
		var askedRows = A2(
			$elm$core$List$map,
			function (recipient) {
				return {
					address: recipient.address,
					name: recipient.name,
					origin: $author$project$Factoring$Page$VerificationBatch$Asked,
					state: A2($author$project$Factoring$Page$VerificationBatch$askedRecipientState, debtorBatch, recipient)
				};
			},
			asked);
		return _Utils_ap(askedRows, notEmailed);
	});
var $author$project$Factoring$Page$VerificationBatch$AwaitingDebtor = {$: 'AwaitingDebtor'};
var $author$project$Factoring$Page$VerificationBatch$DebtorResponded = {$: 'DebtorResponded'};
var $author$project$Factoring$Page$VerificationBatch$NotAskedYet = {$: 'NotAskedYet'};
var $author$project$Factoring$Page$VerificationBatch$SendFailed = function (a) {
	return {$: 'SendFailed', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$debtorConfirmationStatus = function (loadedItems) {
	var confirmations = A2(
		$elm$core$List$filterMap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.item;
			},
			function ($) {
				return $.debtorConfirmation;
			}),
		loadedItems);
	var stateIs = function (state) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.state;
				},
				$elm$core$Basics$eq(state)),
			confirmations);
	};
	return stateIs($author$project$AuditPb$VerificationsDebtorConfirmationStateAnswered) ? $author$project$Factoring$Page$VerificationBatch$DebtorResponded : (stateIs($author$project$AuditPb$VerificationsDebtorConfirmationStateAsked) ? $author$project$Factoring$Page$VerificationBatch$AwaitingDebtor : A2(
		$elm$core$Maybe$withDefault,
		$author$project$Factoring$Page$VerificationBatch$NotAskedYet,
		A2(
			$elm$core$Maybe$map,
			$author$project$Factoring$Page$VerificationBatch$SendFailed,
			A2(
				$elm_community$list_extra$List$Extra$maximumBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.askedAt;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($elm$time$Time$posixToMillis),
						$elm$core$Maybe$withDefault(0))),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.state;
						},
						$elm$core$Basics$eq($author$project$AuditPb$VerificationsDebtorConfirmationStateSendFailed)),
					confirmations)))));
};
var $author$project$Factoring$Page$VerificationBatch$Added = function (a) {
	return {$: 'Added', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$Excluded = {$: 'Excluded'};
var $author$project$Factoring$Page$VerificationBatch$Saved = {$: 'Saved'};
var $author$project$Factoring$Page$VerificationBatch$SavingRecipient = {$: 'SavingRecipient'};
var $author$project$Factoring$Page$VerificationBatch$typedRecipientState = F2(
	function (debtorBatch, row) {
		if (row.saving) {
			return $author$project$Factoring$Page$VerificationBatch$SavingRecipient;
		} else {
			var _v0 = A2(
				$author$project$Factoring$Page$VerificationBatch$blockedReason,
				debtorBatch,
				$author$project$Factoring$Page$VerificationBatch$normalizeAddress(row.address));
			if (_v0.$ === 'Just') {
				if (_v0.a.$ === 'InvalidAddress') {
					var _v1 = _v0.a;
					return $author$project$Factoring$Page$VerificationBatch$Sending;
				} else {
					var reason = _v0.a;
					return $author$project$Factoring$Page$VerificationBatch$blockedStateFor(reason);
				}
			} else {
				return $author$project$Factoring$Page$VerificationBatch$Sending;
			}
		}
	});
var $author$project$Factoring$Page$VerificationBatch$recipientRows = F3(
	function (model, debtorBatch, contacts) {
		var excludedAddresses = A2(
			$elm$core$Set$diff,
			A2(
				$elm$core$Set$union,
				model.excludedRecipients,
				$author$project$Factoring$Page$VerificationBatch$excludedByVerifier(debtorBatch)),
			model.pendingEditUndos);
		var editsOfKind = function (kind) {
			return A2(
				$elm$core$List$map,
				function (edit) {
					return {
						address: $author$project$Factoring$Page$VerificationBatch$normalizeAddress(edit.emailAddress),
						name: $elm$core$String$trim(edit.name)
					};
				},
				A2(
					$elm$core$List$filter,
					function (edit) {
						return _Utils_eq(edit.kind, kind);
					},
					debtorBatch.recipientEdits));
		};
		var savedAdded = A2(
			$elm$core$List$map,
			function (row) {
				return {
					address: row.address,
					name: row.name,
					origin: $author$project$Factoring$Page$VerificationBatch$Saved,
					state: A2(
						$elm$core$Maybe$withDefault,
						$author$project$Factoring$Page$VerificationBatch$Sending,
						A2(
							$elm$core$Maybe$map,
							$author$project$Factoring$Page$VerificationBatch$blockedStateFor,
							A2($author$project$Factoring$Page$VerificationBatch$blockedReason, debtorBatch, row.address)))
				};
			},
			A2(
				$elm$core$List$filter,
				function (row) {
					return (!$elm$core$String$isEmpty(row.address)) && (!A2($elm$core$Set$member, row.address, model.pendingEditUndos));
				},
				_Utils_ap(
					editsOfKind($author$project$AuditPb$VerificationsDebtorConfirmationRecipientEditKindAdded),
					A2(
						$elm$core$List$map,
						function (row) {
							return {
								address: $author$project$Factoring$Page$VerificationBatch$normalizeAddress(row.address),
								name: $elm$core$String$trim(row.name)
							};
						},
						A2(
							$elm$core$List$filter,
							function ($) {
								return $.saved;
							},
							model.addedRecipients)))));
		var contactState = function (address) {
			var _v2 = A2($author$project$Factoring$Page$VerificationBatch$blockedReason, debtorBatch, address);
			if (_v2.$ === 'Just') {
				var reason = _v2.a;
				return $author$project$Factoring$Page$VerificationBatch$blockedStateFor(reason);
			} else {
				return A2($elm$core$Set$member, address, excludedAddresses) ? $author$project$Factoring$Page$VerificationBatch$Excluded : $author$project$Factoring$Page$VerificationBatch$Sending;
			}
		};
		var fromContacts = A2(
			$elm$core$List$filter,
			function (row) {
				return !$elm$core$String$isEmpty(row.address);
			},
			A2(
				$elm$core$List$map,
				function (contact) {
					var address = $author$project$Factoring$Page$VerificationBatch$normalizeAddress(contact.email);
					return {
						address: address,
						name: $author$project$Domain$CadenceDebtorContact$name(contact),
						origin: $author$project$Factoring$Page$VerificationBatch$FromContact,
						state: contactState(address)
					};
				},
				contacts));
		var contactAddresses = $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.address;
				},
				fromContacts));
		var strandedOptOuts = A2(
			$elm$core$List$map,
			function (_v1) {
				var address = _v1.a;
				var optOut = _v1.b;
				return {
					address: address,
					name: '',
					origin: $author$project$Factoring$Page$VerificationBatch$FromContact,
					state: $author$project$Factoring$Page$VerificationBatch$BlockedOptedOut(optOut)
				};
			},
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var address = _v0.a;
						return !A2($elm$core$Set$member, address, contactAddresses);
					},
					$author$project$Factoring$Page$VerificationBatch$optOutsFor(debtorBatch))));
		var beingTyped = A2(
			$elm$core$List$map,
			function (row) {
				return {
					address: row.address,
					name: row.name,
					origin: $author$project$Factoring$Page$VerificationBatch$Added(
						{key: row.key, saving: row.saving, showFormatWarning: row.showFormatWarning}),
					state: A2($author$project$Factoring$Page$VerificationBatch$typedRecipientState, debtorBatch, row)
				};
			},
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.saved;
					},
					$elm$core$Basics$not),
				model.addedRecipients));
		return _Utils_ap(
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				function ($) {
					return $.address;
				},
				_Utils_ap(
					fromContacts,
					_Utils_ap(strandedOptOuts, savedAdded))),
			beingTyped);
	});
var $author$project$Factoring$Page$VerificationBatch$sendStillOffered = function (status) {
	switch (status.$) {
		case 'NotAskedYet':
			return true;
		case 'SendFailed':
			return true;
		case 'AwaitingDebtor':
			return false;
		default:
			return false;
	}
};
var $author$project$Factoring$Page$VerificationBatch$isSending = function (state) {
	switch (state.$) {
		case 'Sending':
			return true;
		case 'SavingRecipient':
			return true;
		case 'Excluded':
			return false;
		case 'BlockedOptedOut':
			return false;
		case 'BlockedBouncing':
			return false;
		case 'BlockedInvalidAddress':
			return false;
		case 'NotEmailed':
			return false;
		case 'DeliveryFailed':
			return false;
		case 'Accepted':
			return false;
		case 'Delivered':
			return false;
		case 'Opened':
			return false;
		default:
			return false;
	}
};
var $author$project$Factoring$Page$VerificationBatch$sendableAddresses = function (rows) {
	return $elm_community$list_extra$List$Extra$unique(
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2(
				$elm$core$List$map,
				function (row) {
					return $author$project$Factoring$Page$VerificationBatch$normalizeAddress(row.address);
				},
				A2(
					$elm$core$List$filter,
					function (row) {
						return $author$project$Factoring$Page$VerificationBatch$isSending(row.state);
					},
					rows))));
};
var $author$project$Factoring$Page$VerificationBatch$AddRecipientRow = {$: 'AddRecipientRow'};
var $author$project$Factoring$Page$VerificationBatch$isDraftRow = function (row) {
	var _v0 = row.origin;
	switch (_v0.$) {
		case 'Added':
			return $elm$core$String$isEmpty(
				$author$project$Factoring$Page$VerificationBatch$normalizeAddress(row.address));
		case 'Saved':
			return false;
		case 'FromContact':
			return false;
		default:
			return false;
	}
};
var $author$project$Factoring$Page$VerificationBatch$isUncommittedRow = function (row) {
	var _v0 = row.origin;
	switch (_v0.$) {
		case 'Added':
			return !$elm$core$String$isEmpty(
				$author$project$Factoring$Page$VerificationBatch$normalizeAddress(row.address));
		case 'Saved':
			return false;
		case 'FromContact':
			return false;
		default:
			return false;
	}
};
var $author$project$Factoring$Page$VerificationBatch$addRecipientBlockedReason = function (rows) {
	return A2($elm$core$List$any, $author$project$Factoring$Page$VerificationBatch$isDraftRow, rows) ? $elm$core$Maybe$Just('Fill in the empty row first.') : (A2($elm$core$List$any, $author$project$Factoring$Page$VerificationBatch$isUncommittedRow, rows) ? $elm$core$Maybe$Just('Save or discard the new recipient first.') : $elm$core$Maybe$Nothing);
};
var $author$project$Factoring$Page$VerificationBatch$viewAddRecipient = function (rows) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-add')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Factoring$Page$VerificationBatch$addRecipientBlockedReason(rows);
				if (_v0.$ === 'Just') {
					var reason = _v0.a;
					return A2(
						$author$project$Components$Shared$Button$disabled,
						'Add New Recipient',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-add-button'),
								$elm$html$Html$Attributes$title(reason)
							]));
				} else {
					return A3(
						$author$project$Components$Shared$Button$enabled,
						'Add New Recipient',
						$author$project$Factoring$Page$VerificationBatch$AddRecipientRow,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-add-button')
							]));
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-add-note')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Addresses you add are saved to this debtor and used on future confirmation emails.')
					]))
			]));
};
var $author$project$Factoring$Page$VerificationBatch$UpdateAddedRecipientName = F2(
	function (a, b) {
		return {$: 'UpdateAddedRecipientName', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$viewAddedAddressWarning = function (_v0) {
	var showWarning = _v0.showWarning;
	var raw = _v0.raw;
	var address = $author$project$Factoring$Page$VerificationBatch$normalizeAddress(raw);
	return ((!showWarning) || ($elm$core$String$isEmpty(address) || $author$project$Domain$EmailAddress$isValid(address))) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-invalid')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('That doesn\u0027t look like an email address.')
				]))
		]);
};
var $author$project$Factoring$Page$VerificationBatch$UpdateAddedRecipientAddress = F2(
	function (a, b) {
		return {$: 'UpdateAddedRecipientAddress', a: a, b: b};
	});
var $author$project$Factoring$Page$VerificationBatch$viewAddedRecipientAddress = function (_v0) {
	var saving = _v0.saving;
	var raw = _v0.raw;
	var key = _v0.key;
	return A2(
		$elm$html$Html$input,
		$author$project$Helpers$Attributes$blockGrammarly(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('email'),
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-email-input'),
					$elm$html$Html$Attributes$placeholder('Email address'),
					$elm$html$Html$Attributes$value(raw),
					$elm$html$Html$Attributes$disabled(saving),
					$elm$html$Html$Events$onInput(
					$author$project$Factoring$Page$VerificationBatch$UpdateAddedRecipientAddress(key))
				])),
		_List_Nil);
};
var $author$project$Factoring$Page$VerificationBatch$ExcludeRecipient = function (a) {
	return {$: 'ExcludeRecipient', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$UndoRecipientEdit = function (a) {
	return {$: 'UndoRecipientEdit', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$noRecipientAction = A2(
	$elm$html$Html$td,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-remove-cell')
		]),
	_List_Nil);
var $author$project$Ui$V3$Icon$plusCircle16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.99984 11.1666C7.7237 11.1666 7.49984 10.9428 7.49984 10.6666V8.49996H5.33317C5.05703 8.49996 4.83317 8.2761 4.83317 7.99996C4.83317 7.72382 5.05703 7.49996 5.33317 7.49996H7.49984V5.33329C7.49984 5.05715 7.7237 4.83329 7.99984 4.83329C8.27598 4.83329 8.49984 5.05715 8.49984 5.33329V7.49996H10.6665C10.9426 7.49996 11.1665 7.72382 11.1665 7.99996C11.1665 8.2761 10.9426 8.49996 10.6665 8.49996H8.49984V10.6666C8.49984 10.9428 8.27598 11.1666 7.99984 11.1666Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M0.166504 7.99996C0.166504 3.67373 3.67361 0.166626 7.99984 0.166626C12.3261 0.166626 15.8332 3.67373 15.8332 7.99996C15.8332 12.3262 12.3261 15.8333 7.99984 15.8333C3.67361 15.8333 0.166504 12.3262 0.166504 7.99996ZM7.99984 1.16663C4.22589 1.16663 1.1665 4.22601 1.1665 7.99996C1.1665 11.7739 4.22589 14.8333 7.99984 14.8333C11.7738 14.8333 14.8332 11.7739 14.8332 7.99996C14.8332 4.22601 11.7738 1.16663 7.99984 1.16663Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Factoring$Page$VerificationBatch$CommitAddedRecipient = function (a) {
	return {$: 'CommitAddedRecipient', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$DiscardAddedRecipient = function (a) {
	return {$: 'DiscardAddedRecipient', a: a};
};
var $author$project$Ui$V3$Icon$check16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.58 0.193543C15.4738 0.116312 15.3534 0.0608838 15.2257 0.0304623C15.098 4.0926e-05 14.9656 -0.00477028 14.836 0.0163068C14.7065 0.0373839 14.5824 0.0839313 14.4709 0.153258C14.3594 0.222586 14.2628 0.313318 14.1866 0.42021L4.83329 13.4669L1.70662 10.3402C1.51706 10.1636 1.26633 10.0674 1.00726 10.072C0.748193 10.0765 0.501013 10.1815 0.317796 10.3647C0.134578 10.5479 0.0296291 10.7951 0.0250581 11.0542C0.0204872 11.3132 0.116651 11.564 0.293291 11.7535L4.24662 15.7135C4.35094 15.813 4.47514 15.8892 4.61104 15.9371C4.74695 15.9851 4.89147 16.0037 5.03508 15.9917C5.1787 15.9797 5.31814 15.9375 5.44424 15.8677C5.57033 15.7979 5.6802 15.7022 5.76662 15.5869L15.8133 1.58688C15.8902 1.48033 15.9452 1.35959 15.9751 1.23164C16.005 1.1037 16.0092 0.971087 15.9875 0.841497C15.9658 0.711906 15.9186 0.587909 15.8487 0.476686C15.7787 0.365462 15.6874 0.269224 15.58 0.193543Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1')
					]),
				_List_Nil)
			])));
var $author$project$Factoring$Page$VerificationBatch$viewAddedRecipientActions = function (_v0) {
	var commitBlocked = _v0.commitBlocked;
	var blank = _v0.blank;
	var saving = _v0.saving;
	var key = _v0.key;
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-remove-cell')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-actions')
					]),
				_List_fromArray(
					[
						$author$project$Helpers$Html$v3ReskinContainer(
						A2(
							$author$project$Ui$V3$UtilityButton$view,
							{
								icon: $author$project$Ui$V3$Icon$check16,
								label: 'Save this recipient',
								onClick: $author$project$Factoring$Page$VerificationBatch$CommitAddedRecipient(key)
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$UtilityButton$sizeSmall,
									$author$project$Ui$V3$UtilityButton$isDisabled(saving || (blank || commitBlocked))
								]))),
						$author$project$Helpers$Html$v3ReskinContainer(
						A2(
							$author$project$Ui$V3$UtilityButton$view,
							{
								icon: $author$project$Ui$V3$Icon$close16,
								label: 'Discard this row',
								onClick: $author$project$Factoring$Page$VerificationBatch$DiscardAddedRecipient(key)
							},
							_List_fromArray(
								[
									$author$project$Ui$V3$UtilityButton$sizeSmall,
									$author$project$Ui$V3$UtilityButton$isDisabled(saving)
								])))
					]))
			]));
};
var $author$project$Factoring$Page$VerificationBatch$viewRecipientRemove = function (_v0) {
	var disabled = _v0.disabled;
	var msg = _v0.msg;
	var icon = _v0.icon;
	var label = _v0.label;
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-remove-cell'),
				$elm$html$Html$Attributes$title(label)
			]),
		_List_fromArray(
			[
				$author$project$Helpers$Html$v3ReskinContainer(
				A2(
					$author$project$Ui$V3$UtilityButton$view,
					{icon: icon, label: label, onClick: msg},
					_List_fromArray(
						[
							$author$project$Ui$V3$UtilityButton$sizeSmall,
							$author$project$Ui$V3$UtilityButton$isDisabled(disabled)
						])))
			]));
};
var $author$project$Factoring$Page$VerificationBatch$viewRecipientAction = F2(
	function (editsInFlight, row) {
		var inFlight = A2(
			$elm$core$Set$member,
			$author$project$Factoring$Page$VerificationBatch$normalizeAddress(row.address),
			editsInFlight);
		var _v0 = row.origin;
		switch (_v0.$) {
			case 'Added':
				var saving = _v0.a.saving;
				var key = _v0.a.key;
				return $author$project$Factoring$Page$VerificationBatch$viewAddedRecipientActions(
					{
						blank: $elm$core$String$isEmpty(
							$author$project$Factoring$Page$VerificationBatch$normalizeAddress(row.address)),
						commitBlocked: inFlight,
						key: key,
						saving: saving
					});
			case 'Saved':
				return $author$project$Factoring$Page$VerificationBatch$viewRecipientRemove(
					{
						disabled: inFlight,
						icon: $author$project$Ui$V3$Icon$removeCircle16,
						label: 'Take ' + (row.address + ' off the list'),
						msg: $author$project$Factoring$Page$VerificationBatch$UndoRecipientEdit(row.address)
					});
			case 'Asked':
				return $author$project$Factoring$Page$VerificationBatch$noRecipientAction;
			default:
				var _v1 = row.state;
				switch (_v1.$) {
					case 'NotEmailed':
						return $author$project$Factoring$Page$VerificationBatch$noRecipientAction;
					case 'Excluded':
						return $author$project$Factoring$Page$VerificationBatch$viewRecipientRemove(
							{
								disabled: inFlight,
								icon: $author$project$Ui$V3$Icon$plusCircle16,
								label: 'Email ' + (row.address + ' after all'),
								msg: $author$project$Factoring$Page$VerificationBatch$UndoRecipientEdit(row.address)
							});
					case 'BlockedBouncing':
						return $author$project$Factoring$Page$VerificationBatch$noRecipientAction;
					case 'BlockedOptedOut':
						return $author$project$Factoring$Page$VerificationBatch$noRecipientAction;
					case 'BlockedInvalidAddress':
						return $author$project$Factoring$Page$VerificationBatch$noRecipientAction;
					default:
						return $author$project$Factoring$Page$VerificationBatch$viewRecipientRemove(
							{
								disabled: inFlight,
								icon: $author$project$Ui$V3$Icon$removeCircle16,
								label: 'Don\u0027t email ' + row.address,
								msg: $author$project$Factoring$Page$VerificationBatch$ExcludeRecipient(row.address)
							});
				}
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewRecipientStatus = F2(
	function (tz, row) {
		var suffix = function () {
			var _v3 = row.origin;
			switch (_v3.$) {
				case 'FromContact':
					return '';
				case 'Asked':
					return '';
				case 'Added':
					return ' — remove this row to send';
				default:
					return ' — remove this row to send';
			}
		}();
		var status = function (children) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-status')
						]),
					children)
				]);
		};
		var blocked = function (children) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-status--blocked')
						]),
					children)
				]);
		};
		var _v0 = row.state;
		switch (_v0.$) {
			case 'Sending':
				return _List_Nil;
			case 'Accepted':
				var at = _v0.a;
				return status(
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Sent ' + A2($author$project$Helpers$Date$compactDateTimeString, tz, at))
						]));
			case 'Delivered':
				var at = _v0.a;
				return status(
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Delivered ' + A2($author$project$Helpers$Date$compactDateTimeString, tz, at))
						]));
			case 'Opened':
				var at = _v0.a;
				return status(
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Last opened ' + A2($author$project$Helpers$Date$compactDateTimeString, tz, at))
						]));
			case 'Bounced':
				var reason = _v0.a.reason;
				var at = _v0.a.at;
				return blocked(
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Bounced ' + (A2($author$project$Helpers$Date$compactDateTimeString, tz, at) + A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (text_) {
										return ' — ' + text_;
									},
									reason))))
						]));
			case 'SavingRecipient':
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-status')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Saving…')
							]))
					]);
			case 'Excluded':
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-status')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Not being emailed')
							]))
					]);
			case 'DeliveryFailed':
				var error = _v0.a;
				return blocked(
					_List_fromArray(
						[
							$elm$html$Html$text('Couldn\u0027t be emailed — ' + error)
						]));
			case 'NotEmailed':
				var maybeReason = _v0.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-status')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Not emailed')
							])),
					function () {
						if (maybeReason.$ === 'Just') {
							if (maybeReason.a.$ === 'TakenOffTheList') {
								var _v2 = maybeReason.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-status')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You took this contact off the list')
											]))
									]);
							} else {
								var reason = maybeReason.a.a;
								return A2(
									$author$project$Factoring$Page$VerificationBatch$viewRecipientStatus,
									tz,
									_Utils_update(
										row,
										{
											state: $author$project$Factoring$Page$VerificationBatch$blockedStateFor(reason)
										}));
							}
						} else {
							return _List_Nil;
						}
					}());
			case 'BlockedBouncing':
				return blocked(
					_List_fromArray(
						[
							$elm$html$Html$text('Bouncing' + suffix)
						]));
			case 'BlockedInvalidAddress':
				return blocked(
					_List_fromArray(
						[
							$elm$html$Html$text('Not a valid email address')
						]));
			default:
				var optOut = _v0.a;
				return blocked(
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Asked not to be emailed — ' + (A2($author$project$Helpers$Date$compactDateTimeString, tz, optOut.optedOutAt) + suffix))
								])),
						$author$project$Factoring$Page$VerificationBatch$DebtorConfirmation$viewFreeText(optOut.freeText)));
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewContactName = F2(
	function (origin, name) {
		var named = !$elm$core$String$isEmpty(
			$elm$core$String$trim(name));
		var nameOnly = named ? _List_fromArray(
			[
				$elm$html$Html$text(name)
			]) : _List_Nil;
		switch (origin.$) {
			case 'Asked':
				return nameOnly;
			case 'Saved':
				return nameOnly;
			default:
				return named ? _List_fromArray(
					[
						$elm$html$Html$text(name),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-origin')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cadence contact')
							]))
					]) : _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-origin')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No contact on file')
							]))
					]);
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewStaticRecipientRow = F3(
	function (tz, editsInFlight, row) {
		var struck = function () {
			var _v0 = row.state;
			switch (_v0.$) {
				case 'Sending':
					return '';
				case 'SavingRecipient':
					return '';
				case 'Accepted':
					return '';
				case 'Delivered':
					return '';
				case 'Opened':
					return '';
				default:
					return ' verification__debtor-confirmation-recipient-row--excluded';
			}
		}();
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__debtor-contact-row' + struck)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					A2($author$project$Factoring$Page$VerificationBatch$viewContactName, row.origin, row.name)),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(row.address)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					A2($author$project$Factoring$Page$VerificationBatch$viewRecipientStatus, tz, row)),
					A2($author$project$Factoring$Page$VerificationBatch$viewRecipientAction, editsInFlight, row)
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewRecipientRow = F3(
	function (tz, editsInFlight, row) {
		var _v0 = row.origin;
		switch (_v0.$) {
			case 'FromContact':
				return A3($author$project$Factoring$Page$VerificationBatch$viewStaticRecipientRow, tz, editsInFlight, row);
			case 'Saved':
				return A3($author$project$Factoring$Page$VerificationBatch$viewStaticRecipientRow, tz, editsInFlight, row);
			case 'Asked':
				return A3($author$project$Factoring$Page$VerificationBatch$viewStaticRecipientRow, tz, editsInFlight, row);
			default:
				var showFormatWarning = _v0.a.showFormatWarning;
				var saving = _v0.a.saving;
				var key = _v0.a.key;
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__debtor-contact-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									$author$project$Helpers$Attributes$blockGrammarly(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipient-name-input'),
												$elm$html$Html$Attributes$placeholder('Name (optional)'),
												$elm$html$Html$Attributes$value(row.name),
												$elm$html$Html$Attributes$disabled(saving),
												$elm$html$Html$Events$onInput(
												$author$project$Factoring$Page$VerificationBatch$UpdateAddedRecipientName(key))
											])),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Factoring$Page$VerificationBatch$viewAddedRecipientAddress(
									{key: key, raw: row.address, saving: saving})
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_Utils_ap(
								A2($author$project$Factoring$Page$VerificationBatch$viewRecipientStatus, tz, row),
								$author$project$Factoring$Page$VerificationBatch$viewAddedAddressWarning(
									{raw: row.address, showWarning: showFormatWarning}))),
							A2($author$project$Factoring$Page$VerificationBatch$viewRecipientAction, editsInFlight, row)
						]));
		}
	});
var $author$project$Factoring$Page$VerificationBatch$SendDebtorConfirmation = {$: 'SendDebtorConfirmation'};
var $author$project$Factoring$Page$VerificationBatch$addedByVerifier = function (row) {
	var _v0 = row.origin;
	switch (_v0.$) {
		case 'Added':
			return true;
		case 'Saved':
			return true;
		case 'FromContact':
			return false;
		default:
			return false;
	}
};
var $author$project$Factoring$Page$VerificationBatch$blockedAddedRows = function (rows) {
	return A2(
		$elm$core$List$filter,
		function (row) {
			var _v0 = row.state;
			switch (_v0.$) {
				case 'BlockedOptedOut':
					return true;
				case 'BlockedBouncing':
					return true;
				default:
					return false;
			}
		},
		A2($elm$core$List$filter, $author$project$Factoring$Page$VerificationBatch$addedByVerifier, rows));
};
var $author$project$Factoring$Page$VerificationBatch$invalidRecipientAddresses = function (rows) {
	return A2(
		$elm$core$List$filter,
		function (address) {
			return (!$elm$core$String$isEmpty(address)) && (!$author$project$Domain$EmailAddress$isValid(address));
		},
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.address;
				},
				$author$project$Factoring$Page$VerificationBatch$normalizeAddress),
			A2($elm$core$List$filter, $author$project$Factoring$Page$VerificationBatch$addedByVerifier, rows)));
};
var $author$project$Factoring$Page$VerificationBatch$AllLoads = {$: 'AllLoads'};
var $author$project$Factoring$Page$VerificationBatch$viewDebtorConfirmationBlock = F2(
	function (sendRow, context) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__debtor-confirmation-send')
						]),
					sendRow),
				context));
	});
var $author$project$Factoring$Page$VerificationBatch$viewAskedDebtorConfirmation = F3(
	function (statusText, trailingButtons, context) {
		return A2(
			$author$project$Factoring$Page$VerificationBatch$viewDebtorConfirmationBlock,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-status'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$title('See the debtor\u0027s form, and when this happened'),
								$elm$html$Html$Events$onClick(
								$author$project$Factoring$Page$VerificationBatch$OpenDebtorConfirmation($author$project$Factoring$Page$VerificationBatch$AllLoads))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(statusText)
							])),
						A2($author$project$Components$Shared$Button$disabled, 'Send', _List_Nil)
					]),
				trailingButtons),
			context);
	});
var $author$project$Factoring$Page$VerificationBatch$ResetDebtorConfirmations = {$: 'ResetDebtorConfirmations'};
var $author$project$Factoring$Page$VerificationBatch$viewResetDebtorConfirmations = function (isSaving) {
	var label = 'Reset (demo)';
	var explanation = 'Demo only: deletes this batch\u0027s confirmation requests, the debtor\u0027s answers and opt-outs, and any ' + 'recipients added or excluded here, so the email can be sent again.';
	return isSaving ? A2(
		$author$project$Components$Shared$Button$disabled,
		label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title(explanation)
			])) : A3(
		$author$project$Components$Shared$Button$cancel,
		label,
		$author$project$Factoring$Page$VerificationBatch$ResetDebtorConfirmations,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title(explanation)
			]));
};
var $author$project$Factoring$Page$VerificationBatch$viewSendDebtorConfirmation = F4(
	function (model, debtorBatch, status, rows) {
		var resetButton = function () {
			var _v1 = _Utils_Tuple2(debtorBatch.confirmationResetAvailable, status);
			if (!_v1.a) {
				return _List_Nil;
			} else {
				switch (_v1.b.$) {
					case 'NotAskedYet':
						var _v2 = _v1.b;
						return _List_Nil;
					case 'SendFailed':
						return _List_Nil;
					default:
						return _List_fromArray(
							[
								$author$project$Factoring$Page$VerificationBatch$viewResetDebtorConfirmations(model.isSaving)
							]);
				}
			}
		}();
		if (model.isSaving) {
			return A2(
				$author$project$Factoring$Page$VerificationBatch$viewDebtorConfirmationBlock,
				A2(
					$elm$core$List$cons,
					A2($author$project$Components$Shared$Button$disabled, 'Send', _List_Nil),
					resetButton),
				_List_Nil);
		} else {
			var liveSendRow = A2(
				$author$project$Factoring$Page$VerificationBatch$viewDebtorConfirmationBlock,
				_List_fromArray(
					[
						A2($elm$core$List$any, $author$project$Factoring$Page$VerificationBatch$isUncommittedRow, rows) ? A2(
						$author$project$Components$Shared$Button$disabled,
						'Send',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$title('Save or discard the new recipient first.')
							])) : (($elm$core$List$isEmpty(
						$author$project$Factoring$Page$VerificationBatch$sendableAddresses(rows)) || ((!$elm$core$List$isEmpty(
						$author$project$Factoring$Page$VerificationBatch$invalidRecipientAddresses(rows))) || (!$elm$core$List$isEmpty(
						$author$project$Factoring$Page$VerificationBatch$blockedAddedRows(rows))))) ? A2($author$project$Components$Shared$Button$disabled, 'Send', _List_Nil) : A3($author$project$Components$Shared$Button$confirm, 'Send', $author$project$Factoring$Page$VerificationBatch$SendDebtorConfirmation, _List_Nil))
					]),
				_List_Nil);
			switch (status.$) {
				case 'NotAskedYet':
					return liveSendRow;
				case 'SendFailed':
					return liveSendRow;
				case 'AwaitingDebtor':
					return A3($author$project$Factoring$Page$VerificationBatch$viewAskedDebtorConfirmation, 'Sent, waiting on debtor response', resetButton, _List_Nil);
				default:
					return A3($author$project$Factoring$Page$VerificationBatch$viewAskedDebtorConfirmation, 'Debtor responded', resetButton, _List_Nil);
			}
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewFailedRecipient = function (recipient) {
	return A2(
		$elm$core$Maybe$map,
		function (error) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification__debtor-confirmation-send-failure-address')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(recipient.emailAddress + (' — ' + error))
					]));
		},
		recipient.deliveryError);
};
var $author$project$Factoring$Page$VerificationBatch$viewSendFailure = F2(
	function (tz, status) {
		switch (status.$) {
			case 'SendFailed':
				var confirmation = status.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verification__debtor-confirmation-send-failure')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('verification__debtor-confirmation-send-failure-headline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'This debtor wasn\u0027t emailed' + (A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function (at) {
													return ', tried ' + A2($author$project$Helpers$Date$compactDateTimeString, tz, at);
												},
												confirmation.askedAt)) + '. You can send again.'))
									])),
							A2($elm$core$List$filterMap, $author$project$Factoring$Page$VerificationBatch$viewFailedRecipient, confirmation.recipients)))
					]);
			case 'NotAskedYet':
				return _List_Nil;
			case 'AwaitingDebtor':
				return _List_Nil;
			default:
				return _List_Nil;
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewConfirmationRecipients = F4(
	function (model, debtorBatch, contacts, loadedItems) {
		var status = $author$project$Factoring$Page$VerificationBatch$debtorConfirmationStatus(loadedItems);
		var rows = $author$project$Factoring$Page$VerificationBatch$sendStillOffered(status) ? A3($author$project$Factoring$Page$VerificationBatch$recipientRows, model, debtorBatch, contacts) : A3($author$project$Factoring$Page$VerificationBatch$askedRecipientRows, debtorBatch, contacts, loadedItems);
		var nobody = $elm$core$List$isEmpty(
			$author$project$Factoring$Page$VerificationBatch$sendableAddresses(rows)) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipients-empty')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Nobody will be emailed until you add an address.')
					]))
			]) : _List_Nil;
		var listing = $elm$core$List$isEmpty(rows) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('load-detail__info-table verification__invoice-table')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$tr,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('load-detail__info-table-header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Name')
									])),
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Email')
									])),
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Delivery')
									])),
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[$author$project$Helpers$Html$empty]))
							])),
					A2(
						$elm$core$List$map,
						A2($author$project$Factoring$Page$VerificationBatch$viewRecipientRow, model.timezone, model.recipientEditsInFlight),
						rows)))
			]);
		var beforeSending = $author$project$Factoring$Page$VerificationBatch$sendStillOffered(status) ? _Utils_ap(
			A2(
				$elm$core$List$cons,
				$author$project$Factoring$Page$VerificationBatch$viewAddRecipient(rows),
				nobody),
			A2($author$project$Factoring$Page$VerificationBatch$viewSendFailure, model.timezone, status)) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-confirmation-recipients')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Debtor Confirmation Email')
						])),
				_Utils_ap(
					listing,
					_Utils_ap(
						beforeSending,
						_List_fromArray(
							[
								A4($author$project$Factoring$Page$VerificationBatch$viewSendDebtorConfirmation, model, debtorBatch, status, rows)
							])))));
	});
var $author$project$Factoring$Page$VerificationBatch$SetDebtorContactsExpanded = function (a) {
	return {$: 'SetDebtorContactsExpanded', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$BatchMail$mailToLink = F3(
	function (accountSettings, recipient, itemDataList) {
		var maybeAppendBody = function () {
			if (!itemDataList.b) {
				return $elm$core$Basics$identity;
			} else {
				return $elm$core$List$cons(
					A2(
						$elm$url$Url$Builder$string,
						'body',
						A2($author$project$Factoring$Page$VerificationBatch$BatchMail$body, accountSettings.verificationsWorkflowDisplayName, itemDataList)));
			}
		}();
		var maybeAppend = F2(
			function (field, arg) {
				if (arg.$ === 'Just') {
					var string = arg.a;
					return $elm$core$List$cons(
						A2($elm$url$Url$Builder$string, field, string));
				} else {
					return $elm$core$Basics$identity;
				}
			});
		return 'mailto:' + $elm$url$Url$Builder$toQuery(
			A3(
				maybeAppend,
				'cc',
				accountSettings.verificationsWorkflowEmailCcRecipients,
				A3(
					maybeAppend,
					'to',
					recipient,
					maybeAppendBody(
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'subject', $author$project$Factoring$Page$VerificationBatch$BatchMail$subjectLine)
							])))));
	});
var $author$project$Factoring$Page$VerificationBatch$BatchMail$batchMailTo = F3(
	function (accountSettings, recipient, itemDataList) {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$href(
				A3($author$project$Factoring$Page$VerificationBatch$BatchMail$mailToLink, accountSettings, recipient, itemDataList)),
				$elm$html$Html$Attributes$target('_blank')
			]);
	});
var $author$project$Factoring$Page$VerificationBatch$BatchMail$verificationEmailLink = F4(
	function (accountSettings, recipientData, loadedItems, toggleEmailModal) {
		var _v0 = recipientData.useRecipientAsLinkText ? _Utils_Tuple2(recipientData.recipient, recipientData.recipient) : _Utils_Tuple2(recipientData.recipient, $elm$core$Maybe$Nothing);
		var recipient = _v0.a;
		var linkText = _v0.b;
		var sendLink = A2(
			$elm$html$Html$a,
			A3($author$project$Factoring$Page$VerificationBatch$BatchMail$batchMailTo, accountSettings, recipient, loadedItems),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, 'Send Verification Email to Debtor', linkText))
				]));
		var viewLink = A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Events$onClick(toggleEmailModal),
				A3($author$project$Factoring$Page$VerificationBatch$BatchMail$batchMailTo, accountSettings, recipient, _List_Nil)),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, 'View Email Draft in Browser', linkText))
				]));
		return $elm$core$List$isEmpty(loadedItems) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[sendLink])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							recipientData.useRecipientAsLinkText ? $elm$html$Html$text('') : viewLink
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewDebtorContact = F3(
	function (accountSettings, loadedItems, contact) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__debtor-contact-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Domain$CadenceDebtorContact$name(contact))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Factoring$Page$VerificationBatch$BatchMail$verificationEmailLink,
							accountSettings,
							{
								recipient: $elm$core$Maybe$Just(contact.email),
								useRecipientAsLinkText: true
							},
							loadedItems,
							$author$project$Factoring$Page$VerificationBatch$ToggleEmailModal)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('tel:' + contact.phone)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(contact.phone)
								]))
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewLoadedDebtorContacts = F4(
	function (accountSettings, loadedItems, debtorContacts, expanded) {
		var displayHtml = expanded ? A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__info-table verification__invoice-table')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__info-table-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Email')
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Phone')
								]))
						])),
				A2(
					$elm$core$List$map,
					A2($author$project$Factoring$Page$VerificationBatch$viewDebtorContact, accountSettings, loadedItems),
					debtorContacts))) : $author$project$Helpers$Html$empty;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__debtor-contacts-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Debtor Contacts'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__expand-button')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('fi-minus', expanded),
													_Utils_Tuple2('fi-plus', !expanded)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Factoring$Page$VerificationBatch$SetDebtorContactsExpanded(!expanded))
										]),
									_List_fromArray(
										[$author$project$Helpers$Html$empty]))
								]))
						])),
					displayHtml
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewDebtorContacts = F2(
	function (model, data) {
		var onlyLoaded = function (field) {
			return A2(
				$elm$core$List$filterMap,
				$author$project$Forward$Remote$toMaybe,
				field(data));
		};
		return data.accountSettings.verificationsDebtorConfirmationEnabled ? A4(
			$author$project$Factoring$Page$VerificationBatch$viewConfirmationRecipients,
			model,
			data.debtorBatch,
			onlyLoaded(
				function ($) {
					return $.debtorContacts;
				}),
			onlyLoaded(
				function ($) {
					return $.items;
				})) : ($elm$core$List$isEmpty(data.debtorContacts) ? $author$project$Helpers$Html$empty : A4(
			$author$project$Factoring$Page$VerificationBatch$viewLoadedDebtorContacts,
			data.accountSettings,
			onlyLoaded(
				function ($) {
					return $.items;
				}),
			onlyLoaded(
				function ($) {
					return $.debtorContacts;
				}),
			model.debtorContactsExpanded));
	});
var $author$project$Factoring$Page$VerificationBatch$SetDebtorNotesExpanded = function (a) {
	return {$: 'SetDebtorNotesExpanded', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$viewDebtorNotes = F2(
	function (debtor, expanded) {
		var notes = expanded ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__debtor-notes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(debtor.notes)
						]))
				])) : $author$project$Helpers$Html$empty;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__contact-info-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Debtor Notes'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__expand-button')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('fi-minus', expanded),
													_Utils_Tuple2('fi-plus', !expanded)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Factoring$Page$VerificationBatch$SetDebtorNotesExpanded(!expanded))
										]),
									_List_fromArray(
										[$author$project$Helpers$Html$empty]))
								]))
						])),
					notes
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$ChangeBatchState = function (a) {
	return {$: 'ChangeBatchState', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$viewStatusBar = F3(
	function (exitUrl, batchState, isSaving) {
		var showButton = A2(
			$author$project$Factoring$Page$VerificationBatch$viewButton,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('verification__right-hand-button', true),
						_Utils_Tuple2('verification__status-button', !isSaving)
					])),
			isSaving);
		var withButton = function (label) {
			return _Utils_Tuple2(
				$author$project$Domain$VerificationsDebtorBatch$stateToDisplayString(batchState),
				showButton(
					_Utils_Tuple2(
						label,
						$author$project$Factoring$Page$VerificationBatch$ChangeBatchState(batchState))));
		};
		var _v0 = function () {
			switch (batchState.$) {
				case 'VerificationsDebtorBatchStateAvailable':
					return withButton('Begin');
				case 'VerificationsDebtorBatchStateStarted':
					return withButton('Mark as Waiting');
				case 'VerificationsDebtorBatchStateWaiting':
					return withButton('Resume');
				case 'VerificationsDebtorBatchStateReply':
					return withButton('Resume');
				default:
					return _Utils_Tuple2(
						'Complete',
						$elm$html$Html$text($author$project$Helpers$String$nbsp));
			}
		}();
		var status = _v0.a;
		var button = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__status-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__status-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Batch: ' + status)
						])),
					button,
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__exit-link'),
							$elm$html$Html$Attributes$href(exitUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Back to Verify Queue')
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$noBuyText = function (debtor) {
	return debtor.noBuy ? $elm$core$Maybe$Just('No Buy') : $elm$core$Maybe$Nothing;
};
var $author$project$Factoring$Page$VerificationBatch$viewBatchProgress = F2(
	function (maybePercentComplete, label) {
		var labelId = 'verification-progress-label';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__progress')
				]),
			_List_fromArray(
				[
					function () {
					if (maybePercentComplete.$ === 'Just') {
						var percentComplete = maybePercentComplete.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('verification__progress-track'),
									A2($elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
									A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', labelId),
									A2($elm$html$Html$Attributes$attribute, 'aria-valuemin', '0'),
									A2($elm$html$Html$Attributes$attribute, 'aria-valuemax', '100'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-valuenow',
									$elm$core$String$fromInt(percentComplete))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('verification__progress-meter'),
											A2(
											$elm$html$Html$Attributes$style,
											'width',
											$elm$core$String$fromInt(percentComplete) + '%')
										]),
									_List_Nil)
								]));
					} else {
						return $author$project$Helpers$Html$empty;
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verification__progress-label'),
							$elm$html$Html$Attributes$id(labelId)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewDebtorWarning = function (maybeWarning) {
	if (maybeWarning.$ === 'Just') {
		if (maybeWarning.a === '') {
			return $author$project$Helpers$Html$empty;
		} else {
			var warning = maybeWarning.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('debtor-warning')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'true'),
								$elm$html$Html$Attributes$title('Warning'),
								A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fi-alert alert')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Helpers$String$nbsp)
									]))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(warning)
							]))
					]));
		}
	} else {
		return $author$project$Helpers$Html$empty;
	}
};
var $author$project$Factoring$Page$VerificationBatch$viewTopBar = function (data) {
	var loadedItems = A2($elm$core$List$filterMap, $author$project$Forward$Remote$toMaybe, data.items);
	var percComplete = $author$project$Domain$VerificationsDebtorBatchItem$percentageComplete(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.item;
			},
			loadedItems));
	var items = data.items;
	var invoiceString = A2(
		$author$project$Helpers$String$pluralize,
		{many: 'invoices', one: 'invoice'},
		$elm$core$List$length(items));
	var allAreLoaded = _Utils_eq(
		$elm$core$List$length(loadedItems),
		$elm$core$List$length(items));
	var _v0 = data;
	var debtorBatch = _v0.debtorBatch;
	var debtor = _v0.debtor;
	var started = function () {
		var _v1 = debtorBatch.state;
		if (_v1.$ === 'VerificationsDebtorBatchStateAvailable') {
			return false;
		} else {
			return true;
		}
	}();
	var maybePercentComplete = (allAreLoaded && started) ? $elm$core$Maybe$Just(percComplete) : $elm$core$Maybe$Nothing;
	var showCompleteIfLoaded = (allAreLoaded && started) ? A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				invoiceString + ',',
				$elm$core$String$fromInt(
				$elm$core$List$length(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.item;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.effectiveCustomState;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.state;
									},
									$author$project$Domain$VerificationsDebtorBatchItem$isComplete))),
						loadedItems))),
				'complete,',
				$elm$core$String$fromInt(percComplete) + '%'
			])) : invoiceString;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('verification__top-bar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(debtor.name)
					])),
				$author$project$Factoring$Page$VerificationBatch$viewDebtorWarning(debtor.warning),
				$author$project$Factoring$Page$VerificationBatch$viewDebtorWarning(
				$author$project$Factoring$Page$VerificationBatch$noBuyText(debtor)),
				A2($author$project$Factoring$Page$VerificationBatch$viewBatchProgress, maybePercentComplete, showCompleteIfLoaded),
				data.accountSettings.verificationsDebtorConfirmationEnabled ? $author$project$Helpers$Html$empty : A4(
				$author$project$Factoring$Page$VerificationBatch$BatchMail$verificationEmailLink,
				data.accountSettings,
				{recipient: data.debtor.cadenceDebtorDetails.email, useRecipientAsLinkText: false},
				loadedItems,
				$author$project$Factoring$Page$VerificationBatch$ToggleEmailModal)
			]));
};
var $author$project$Factoring$Page$VerificationBatch$viewHeader = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__header')
				]),
			_List_fromArray(
				[
					$author$project$Factoring$Page$VerificationBatch$viewTopBar(data),
					A3(
					$author$project$Factoring$Page$VerificationBatch$viewStatusBar,
					$author$project$Factoring$Page$VerificationBatch$dashOrOnDone(model.maybeOnDone),
					data.debtorBatch.state,
					model.isSaving)
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$SetVerificationInstructionsState = function (a) {
	return {$: 'SetVerificationInstructionsState', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$viewClientInstructions = function (maybeValue) {
	if (maybeValue.$ === 'Just') {
		var value = maybeValue.a;
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__verification-batch-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$pre,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__verification-instructions__verification-instructions filled')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(value)
								]))
						]))
				]));
	} else {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__verification-batch-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__verification-instructions__verification-instructions empty')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('None')
										]))
								]))
						]))
				]));
	}
};
var $author$project$Factoring$Page$VerificationBatch$viewInstructionsSection = F4(
	function (headerText, toggleState, expanded, value) {
		var iconClass = expanded ? 'fi-minus' : 'fi-plus';
		var header = A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(headerText),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__expand-button')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(iconClass),
											$elm$html$Html$Events$onClick(
											$author$project$Factoring$Page$VerificationBatch$SetVerificationInstructionsState(toggleState))
										]),
									_List_fromArray(
										[$author$project$Helpers$Html$empty]))
								])),
							$elm$html$Html$text($author$project$Helpers$String$nbsp)
						]))
				]));
		return expanded ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__verification-instructions-section')
				]),
			_List_fromArray(
				[
					header,
					A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Factoring$Page$VerificationBatch$viewClientInstructions(value)
						]))
				])) : header;
	});
var $author$project$Factoring$Page$VerificationBatch$viewExpandedInstructions = F2(
	function (carrier, state) {
		var verificationInstructions = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.cadenceVerificationInstructions;
			},
			carrier);
		var fundingNotes = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.fundingNotes;
			},
			carrier);
		var carrierName = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Helpers$String$nbsp,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.name;
				},
				carrier));
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('load-detail__info-table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-detail__info-table-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(carrierName)
										]))
								]))
						])),
					A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Factoring$Page$VerificationBatch$viewInstructionsSection,
							'Verification Notes',
							_Utils_update(
								state,
								{verificationNotes: !state.verificationNotes}),
							state.verificationNotes,
							verificationInstructions)
						])),
					A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Factoring$Page$VerificationBatch$viewInstructionsSection,
							'Funding Notes',
							_Utils_update(
								state,
								{fundingNotes: !state.fundingNotes}),
							state.fundingNotes,
							fundingNotes)
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$viewVerificationInstructions = F3(
	function (accountSettings, state, selectedBatchItem) {
		var carrier = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.tmsCarrier;
			},
			selectedBatchItem);
		var _v0 = _Utils_Tuple2(
			state.section,
			_Utils_update(
				state,
				{section: !state.section}));
		var expanded = _v0.a;
		var toggleExpansion = _v0.b;
		var instructions = expanded ? A2($author$project$Factoring$Page$VerificationBatch$viewExpandedInstructions, carrier, state) : $author$project$Helpers$Html$empty;
		return accountSettings.showCadenceVerificationInstructions ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verification__verification-instructions-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('load-detail__section-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Client Instructions'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('load-detail__expand-button')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('fi-minus', expanded),
													_Utils_Tuple2('fi-plus', !expanded)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Factoring$Page$VerificationBatch$SetVerificationInstructionsState(toggleExpansion))
										]),
									_List_fromArray(
										[$author$project$Helpers$Html$empty]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[instructions]))
				])) : $author$project$Helpers$Html$empty;
	});
var $author$project$Factoring$Page$VerificationBatch$viewLeftSide = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('xlarge-4 small-5 column document-indexer__work-area')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Factoring$Page$VerificationBatch$viewHeader, model, data),
							A3($author$project$Factoring$Page$VerificationBatch$viewContactInfo, data.accountSettings, model, data.debtor),
							A2($author$project$Factoring$Page$VerificationBatch$viewDebtorContacts, model, data),
							A2($author$project$Factoring$Page$VerificationBatch$viewDebtorNotes, data.debtor, model.debtorNotesExpanded),
							A3(
							$author$project$Factoring$Page$VerificationBatch$viewVerificationInstructions,
							data.accountSettings,
							model.verificationInstructionsState,
							A2($author$project$Factoring$Page$VerificationBatch$selectedItem, data, model)),
							A2($author$project$Factoring$Page$VerificationBatch$viewBatchItems, data, model)
						]))
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$ClearLeftSideDocument = {$: 'ClearLeftSideDocument'};
var $author$project$Factoring$Page$VerificationBatch$viewLeftSideDocBrowserHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('document-browser__header')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__header-current')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$Helpers$String$nbsp)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-browser__header-close-link'),
					$elm$html$Html$Events$onClick($author$project$Factoring$Page$VerificationBatch$ClearLeftSideDocument)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fi-x-circle')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Factoring$Page$VerificationBatch$BatchSkipAndFinish = {$: 'BatchSkipAndFinish'};
var $author$project$Factoring$Page$VerificationBatch$ChangeBatchStateThenSkipAndFinish = function (a) {
	return {$: 'ChangeBatchStateThenSkipAndFinish', a: a};
};
var $author$project$Factoring$Page$VerificationBatch$updateCadenceMessage = F2(
	function (debtorName, _v0) {
		var methodsEmpty = _v0.methodsEmpty;
		var contactsEmpty = _v0.contactsEmpty;
		var _v1 = _Utils_Tuple2(contactsEmpty, methodsEmpty);
		if (_v1.a) {
			if (_v1.b) {
				return 'We have received no contacts for ' + (debtorName + ' or verification methods from Cadence. Please add these to Cadence to complete verification.');
			} else {
				return 'We have received no contacts for ' + (debtorName + ' from Cadence. Please add debtor contacts to Cadence to complete verification.');
			}
		} else {
			if (_v1.b) {
				return 'We have received no verification methods from Cadence. Please add verification methods to Cadence to complete verification.';
			} else {
				return $author$project$Helpers$String$nbsp;
			}
		}
	});
var $author$project$Factoring$Page$VerificationBatch$viewSupportLink = function (data) {
	var _v0 = data.accountSettings.processorSupportEmailAddress;
	if (_v0.$ === 'Nothing') {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('https://paymentshelp.triumph.io'),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Contact support')
				]));
	} else {
		var value = _v0.a;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('mailto:' + value)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Contact support')
				]));
	}
};
var $author$project$Factoring$Page$VerificationBatch$viewUpdateCadencePrompt = function (data) {
	var skipAndFinishMarkup = function (msg) {
		return _List_fromArray(
			[
				$elm$html$Html$text(', or '),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('skip verification')
					])),
				$elm$html$Html$text(' for these invoices.')
			]);
	};
	var cadenceDataMissing = $author$project$Factoring$Page$VerificationBatch$getCadenceDataMissing(data);
	var _v0 = data;
	var debtorBatch = _v0.debtorBatch;
	var debtor = _v0.debtor;
	var skipAndFinishMessage = function () {
		var _v1 = debtorBatch.state;
		switch (_v1.$) {
			case 'VerificationsDebtorBatchStateStarted':
				return skipAndFinishMarkup($author$project$Factoring$Page$VerificationBatch$BatchSkipAndFinish);
			case 'VerificationsDebtorBatchStateFinished':
				return _List_fromArray(
					[
						$elm$html$Html$text('.')
					]);
			default:
				return skipAndFinishMarkup(
					$author$project$Factoring$Page$VerificationBatch$ChangeBatchStateThenSkipAndFinish(debtorBatch.state));
		}
	}();
	return $author$project$Factoring$Page$VerificationBatch$blockForCadenceData(cadenceDataMissing) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('document-container__verification-batch-update-cadence-alert')
			]),
		A2(
			$author$project$Helpers$List$appendToEnd,
			skipAndFinishMessage,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Factoring$Page$VerificationBatch$updateCadenceMessage, debtor.name, cadenceDataMissing)),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$author$project$Factoring$Page$VerificationBatch$viewSupportLink(data),
					$elm$html$Html$text(' if you are seeing this message in error')
				]))) : $author$project$Helpers$Html$empty;
};
var $author$project$Factoring$Page$VerificationBatch$loadedView = F2(
	function (model, data) {
		var loadedItems = A2($elm$core$List$filterMap, $author$project$Forward$Remote$toMaybe, data.items);
		var maybeDebtorConfirmationModal = function () {
			var _v2 = model.debtorConfirmationModal;
			if (_v2.$ === 'Nothing') {
				return $author$project$Helpers$Html$empty;
			} else {
				if (_v2.a.$ === 'AllLoads') {
					var _v3 = _v2.a;
					return A3($author$project$Factoring$Page$VerificationBatch$viewDebtorConfirmationModal, model, data.debtor, loadedItems);
				} else {
					var batchItemId = _v2.a.a;
					return A3(
						$author$project$Factoring$Page$VerificationBatch$viewDebtorConfirmationModal,
						model,
						data.debtor,
						A2(
							$elm$core$List$filter,
							function (itemData) {
								return _Utils_eq(itemData.item.id, batchItemId);
							},
							loadedItems));
				}
			}
		}();
		var maybeModal = model.viewEmailModal ? A5(
			$author$project$Factoring$Page$VerificationBatch$BatchMail$viewAsModal,
			data.accountSettings,
			model.copiedToClipboard,
			data.debtor.cadenceDebtorDetails.email,
			{copy: $author$project$Factoring$Page$VerificationBatch$CopyToClipboard, hide: $author$project$Factoring$Page$VerificationBatch$ToggleEmailModal},
			loadedItems) : $author$project$Helpers$Html$empty;
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('document-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('document-indexer__main-body')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(model.documentBrowserExpanded, model.leftSideSelectedPage);
							if (_v0.a) {
								return $author$project$Helpers$Html$empty;
							} else {
								if (_v0.b.$ === 'Just') {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('document-indexer__document-side')
											]),
										_List_fromArray(
											[
												$author$project$Factoring$Page$VerificationBatch$viewLeftSideDocBrowserHeader,
												A3($author$project$Factoring$Page$VerificationBatch$viewDocumentsTab, data, model.leftSideSelectedPage, model)
											]));
								} else {
									var _v1 = _v0.b;
									return A2($author$project$Factoring$Page$VerificationBatch$viewLeftSide, model, data);
								}
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('document-indexer__document-side')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Factoring$Page$VerificationBatch$viewDocBrowserTabs,
									data,
									A2($author$project$Factoring$Page$VerificationBatch$selectedTab, data, model),
									model.documentBrowserExpanded),
									A3($author$project$Factoring$Page$VerificationBatch$viewDocumentBrowser, data, $elm$core$Maybe$Nothing, model)
								]))
						])),
					$author$project$Factoring$Page$VerificationBatch$viewUpdateCadencePrompt(data),
					maybeModal,
					maybeDebtorConfirmationModal
				]));
	});
var $author$project$Factoring$Page$VerificationBatch$view = F2(
	function (data, model) {
		var body = function () {
			var _v0 = _Utils_Tuple2(data, model.dataWhileInvalidating);
			if ((_v0.a.$ === 'Loading') && (_v0.b.$ === 'Just')) {
				var _v1 = _v0.a;
				var dataWhileInvalidating = _v0.b.a;
				return A2($author$project$Factoring$Page$VerificationBatch$loadedView, model, dataWhileInvalidating);
			} else {
				return A2(
					$author$project$Forward$LoadingView$view,
					$author$project$Factoring$Page$VerificationBatch$loadedView(model),
					data);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					body,
					$author$project$Presence$viewInCorner(model.presence)
				]));
	});
var $author$project$Ui$V3$Stack$spaceResponsiveSmall = $author$project$Ui$V3$Stack$SpatialUnit('responsive-s');
var $elm_community$dict_extra$Dict$Extra$filterGroupBy = F2(
	function (keyfn, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					var _v0 = keyfn(x);
					if (_v0.$ === 'Just') {
						var key = _v0.a;
						return A3(
							$elm$core$Dict$update,
							key,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map(
									$elm$core$List$cons(x)),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault(
										_List_fromArray(
											[x])),
									$elm$core$Maybe$Just)),
							acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			list);
	});
var $author$project$Components$DashboardSavedFilterEditModal$CancelEditing = {$: 'CancelEditing'};
var $author$project$Ui$V3$UtilityButton$IsHighlighted = function (a) {
	return {$: 'IsHighlighted', a: a};
};
var $author$project$Ui$V3$UtilityButton$isHighlighted = $author$project$Ui$V3$UtilityButton$IsHighlighted;
var $author$project$Components$DashboardSavedFilterEditModal$filterRowViewV3Reskin = F2(
	function (model, filter) {
		var filterIsBeingEdited = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (editingFilter) {
					return A2($author$project$Components$DashboardSavedFilterEditModal$idsMatch, filter, editingFilter);
				},
				model.editingFilter));
		var nameText = filterIsBeingEdited ? A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function ($) {
				return $.name;
			},
			model.editingFilter) : filter.name;
		var errorValidation = (filterIsBeingEdited && (!$elm$core$String$isEmpty(model.onSaveErrorMessage))) ? $elm$core$Result$Err(model.onSaveErrorMessage) : $elm$core$Result$Ok(_Utils_Tuple0);
		var displayOrEditNameView = A4(
			$author$project$Ui$V3$Input$view,
			{onInput: $author$project$Components$DashboardSavedFilterEditModal$SetName},
			_List_fromArray(
				[
					$author$project$Ui$V3$Input$validation(errorValidation),
					$author$project$Ui$V3$Input$disabled(!filterIsBeingEdited)
				]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$autofocus(true)
				]),
			nameText);
		var buttons = filterIsBeingEdited ? _List_fromArray(
			[
				A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardSavedFilterEditModal$CancelEditing)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
					]),
				'Cancel'),
				A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardSavedFilterEditModal$Saving)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$disabled(model.isSaving)
					]),
				'Save')
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$UtilityButton$view,
				{
					icon: filter.isDefault ? $author$project$Ui$V3$Icon$radioChecked16 : $author$project$Ui$V3$Icon$radio16,
					label: filter.isDefault ? 'Default' : 'Set as default',
					onClick: $author$project$Components$DashboardSavedFilterEditModal$SetDefaultClicked(filter)
				},
				filter.isDefault ? _List_fromArray(
					[
						$author$project$Ui$V3$UtilityButton$isHighlighted(true)
					]) : _List_Nil),
				A2(
				$author$project$Ui$V3$UtilityButton$view,
				{
					icon: $author$project$Ui$V3$Icon$editOutline16,
					label: 'Edit',
					onClick: $author$project$Components$DashboardSavedFilterEditModal$StartEditing(filter)
				},
				_List_Nil),
				A2(
				$author$project$Ui$V3$UtilityButton$view,
				{
					icon: $author$project$Ui$V3$Icon$removeOutline16,
					label: 'Delete',
					onClick: $author$project$Components$DashboardSavedFilterEditModal$DeleteClicked(filter)
				},
				_List_Nil)
			]);
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, displayOrEditNameView),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Stack$viewHorz,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
							]),
						buttons))
				]));
	});
var $author$project$Components$DashboardSavedFilterEditModal$groupedFiltersViewV3Reskin = F3(
	function (model, dashboardMode, filters) {
		var heading = (dashboardMode !== 'all') ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$h6,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Helpers$String$capitalize(dashboardMode) + ' dashboard')
					]))) : $elm$core$Maybe$Nothing;
		var filterEls = A2(
			$elm$core$List$map,
			$elm$core$Maybe$Just,
			A2(
				$elm$core$List$map,
				$author$project$Components$DashboardSavedFilterEditModal$filterRowViewV3Reskin(model),
				filters));
		return A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			A2($elm$core$List$cons, heading, filterEls));
	});
var $author$project$Components$DashboardSavedFilterEditModal$filtersByModeViewV3Reskin = F2(
	function (visibleDashboardModes, model) {
		var groupedFilters = A2(
			$elm_community$dict_extra$Dict$Extra$filterGroupBy,
			function (filter) {
				return A2($elm$core$List$member, filter.dashboardMode, visibleDashboardModes) ? $elm$core$Maybe$Just(
					$author$project$AuditPb$dashboardModeToString(filter.dashboardMode)) : $elm$core$Maybe$Nothing;
			},
			model.dashboardSavedFilters);
		return $elm$core$Dict$isEmpty(groupedFilters) ? A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding-top', 'var(--space-s)')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No saved filters')
				])) : A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
				]),
			$elm$core$Dict$values(
				A2(
					$elm$core$Dict$map,
					$author$project$Components$DashboardSavedFilterEditModal$groupedFiltersViewV3Reskin(model),
					A2(
						$elm$core$Dict$map,
						F2(
							function (_v0, v) {
								return A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Domain$DashboardSavedFilterId$toInt,
										function ($) {
											return $.id;
										}),
									v);
							}),
						groupedFilters))));
	});
var $author$project$Components$DashboardSavedFilterEditModal$viewV3Reskin = F2(
	function (visibleDashboardModes, model) {
		return A2(
			$author$project$Ui$V3$Modal$view,
			_List_Nil,
			{
				body: A2($author$project$Components$DashboardSavedFilterEditModal$filtersByModeViewV3Reskin, visibleDashboardModes, model),
				cancelButton: $elm$core$Maybe$Nothing,
				dismissMsg: $author$project$Components$DashboardSavedFilterEditModal$Close,
				footerButtons: _List_Nil,
				header: $author$project$Ui$V3$Modal$textHeader('Manage saved filters'),
				primaryButton: $elm$core$Maybe$Nothing,
				size: $author$project$Ui$V3$Modal$medium
			});
	});
var $author$project$Domain$DashboardMode$visibleModes = F2(
	function (accountSettings, user) {
		return A2(
			$elm$core$List$filter,
			function (mode) {
				return _Utils_eq(
					mode,
					A3(
						$author$project$Domain$DashboardMode$dashboardModeOverride,
						accountSettings,
						user,
						$author$project$Sanitized$raw(mode)));
			},
			$author$project$AuditPb$allDashboardMode);
	});
var $author$project$Components$DashboardPage$viewDashboardSavedFilterEditModalV3Reskin = F2(
	function (data, model) {
		return model.dashboardSavedFilterEditModal.isOpen ? A2(
			$elm$html$Html$map,
			$author$project$Components$DashboardPage$DashboardSavedFilterEditModalMsg,
			A2(
				$author$project$Components$DashboardSavedFilterEditModal$viewV3Reskin,
				A2($author$project$Domain$DashboardMode$visibleModes, data.accountSettings, data.currentUser),
				model.dashboardSavedFilterEditModal)) : $elm$html$Html$text('');
	});
var $author$project$Components$DashboardSavedFilterSaveModal$viewV3Reskin = function (model) {
	var errorValidation = $elm$core$String$isEmpty(model.errorMessage) ? $elm$core$Result$Ok(_Utils_Tuple0) : $elm$core$Result$Err(model.errorMessage);
	var body = A4(
		$author$project$Ui$V3$Input$view,
		{onInput: $author$project$Components$DashboardSavedFilterSaveModal$SetName},
		_List_fromArray(
			[
				$author$project$Ui$V3$Input$validation(errorValidation),
				$author$project$Ui$V3$Input$label('Name your filter')
			]),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$autofocus(true)
			]),
		model.name);
	return A2(
		$author$project$Ui$V3$Modal$view,
		_List_fromArray(
			[
				$author$project$Ui$V3$Modal$disablePrimaryButton(model.isSaving)
			]),
		{
			body: body,
			cancelButton: $elm$core$Maybe$Just(
				_Utils_Tuple2('Cancel', $author$project$Components$DashboardSavedFilterSaveModal$Close)),
			dismissMsg: $author$project$Components$DashboardSavedFilterSaveModal$Close,
			footerButtons: _List_Nil,
			header: $author$project$Ui$V3$Modal$textHeader('Save filter'),
			primaryButton: $elm$core$Maybe$Just(
				_Utils_Tuple2('Save', $author$project$Components$DashboardSavedFilterSaveModal$SaveStarted)),
			size: $author$project$Ui$V3$Modal$small
		});
};
var $author$project$Components$DashboardPage$viewDashboardSavedFilterSaveModalV3Reskin = function (model) {
	return model.dashboardSavedFilterSaveModal.isOpen ? A2(
		$elm$html$Html$map,
		$author$project$Components$DashboardPage$DashboardSavedFilterSaveModalMsg,
		$author$project$Components$DashboardSavedFilterSaveModal$viewV3Reskin(model.dashboardSavedFilterSaveModal)) : $elm$html$Html$text('');
};
var $author$project$Components$DashboardPage$viewIgnoreModalV3Reskin = F2(
	function (data, model) {
		if (model.ignoreModal.isShown) {
			var lowerCaseItemName = $author$project$Components$DashboardPage$getItemTypeStrings(data.dashboardRows).b;
			var config = {
				body: A2($author$project$Ui$V3$Typography$xSmallBody, _List_Nil, model.ignoreModal.text),
				cancelButton: $elm$core$Maybe$Just(
					_Utils_Tuple2('Cancel', $author$project$Components$DashboardPage$DismissIgnoreModal)),
				dismissMsg: $author$project$Components$DashboardPage$DismissIgnoreModal,
				footerButtons: _List_Nil,
				header: $author$project$Ui$V3$Modal$textHeader('Ignore ' + (lowerCaseItemName + '?')),
				primaryButton: $elm$core$Maybe$Just(
					_Utils_Tuple2('Ignore', $author$project$Components$DashboardPage$PerformIgnore)),
				size: $author$project$Ui$V3$Modal$small
			};
			return A2(
				$author$project$Ui$V3$Modal$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$Modal$disablePrimaryButton(model.ignoreModal.isPerforming)
					]),
				config);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Dashboard$FilterBar$LabelFilters$ToggleCollapse = {$: 'ToggleCollapse'};
var $author$project$Components$Dashboard$FilterBar$LabelFilters$labelFilterViewV3Reskin = F2(
	function (msg, labelFilter) {
		var _v0 = function () {
			var _v1 = labelFilter.state;
			switch (_v1.$) {
				case 'Unselected':
					return _Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing);
				case 'Selected':
					return _Utils_Tuple3(
						_List_fromArray(
							[
								$author$project$Ui$V3$Chip$Filled(true),
								A2(
								$author$project$Ui$V3$Chip$Style,
								'background',
								$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal600)),
								A2(
								$author$project$Ui$V3$Chip$Style,
								'border-color',
								$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal600))
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Stack$style, 'color', 'white'),
								A2($author$project$Ui$V3$Stack$style, 'filter', 'brightness(100)')
							]),
						$elm$core$Maybe$Just(
							A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$success16)));
				default:
					return _Utils_Tuple3(
						_List_fromArray(
							[
								$author$project$Ui$V3$Chip$Excluded(true),
								A2(
								$author$project$Ui$V3$Chip$Style,
								'background',
								$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray200)),
								A2(
								$author$project$Ui$V3$Chip$Style,
								'border-color',
								$author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray200))
							]),
						_List_Nil,
						$elm$core$Maybe$Nothing);
			}
		}();
		var chipAttrs = _v0.a;
		var contentAttrs = _v0.b;
		var prefixIcon = _v0.c;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					msg(labelFilter)),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Chip$viewHtml,
					chipAttrs,
					A2(
						$author$project$Ui$V3$Stack$viewHorzMaybes,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
									$author$project$Ui$V3$Stack$mainAxisCenter,
									$author$project$Ui$V3$Stack$noWrap
								]),
							contentAttrs),
						_List_fromArray(
							[
								prefixIcon,
								$elm$core$Maybe$Just(
								A2(
									$author$project$Ui$V3$Typography$xSmallBody,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
											A2($elm$html$Html$Attributes$style, 'font-weight', '500'),
											$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
										]),
									labelFilter.label))
							])))
				]));
	});
var $author$project$Components$Dashboard$FilterBar$LabelFilters$viewV3Reskin = F3(
	function (isCollapsed, queue, labelFilters) {
		var filtersMinusResolved = A2(
			$elm$core$List$filter,
			function (labelFilter) {
				return labelFilter.label !== 'Resolved Exceptions';
			},
			labelFilters);
		var filtersToView = function () {
			switch (queue.$) {
				case 'NewQueue':
					return filtersMinusResolved;
				case 'FinalQueue':
					return filtersMinusResolved;
				default:
					return labelFilters;
			}
		}();
		var collapseBtnText = isCollapsed ? 'Show all labels' : 'Hide labels';
		var collapseToggleBtn = A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$Dashboard$FilterBar$LabelFilters$ToggleCollapse)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
					$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
					A2($author$project$Ui$V3$Button$cssStyle, 'top', '-1px')
				]),
			collapseBtnText);
		var activeFilters = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Domain$LabelFilter$isUnselected),
			filtersToView);
		var addFilter = A2(
			$author$project$Components$Dashboard$FilterBar$LabelFilters$labelFilterViewV3Reskin,
			$elm$core$Basics$always($author$project$Components$Dashboard$FilterBar$LabelFilters$ClickedAll),
			{
				label: 'All',
				state: $elm$core$List$isEmpty(activeFilters) ? $author$project$Domain$LabelFilter$Selected : $author$project$Domain$LabelFilter$Unselected
			});
		var filtersEls = isCollapsed ? A2(
			$elm$core$List$cons,
			addFilter,
			A2(
				$elm$core$List$map,
				$author$project$Components$Dashboard$FilterBar$LabelFilters$labelFilterViewV3Reskin($author$project$Components$Dashboard$FilterBar$LabelFilters$ToggleLabelFilter),
				activeFilters)) : A2(
			$elm$core$List$cons,
			addFilter,
			A2(
				$elm$core$List$map,
				$author$project$Components$Dashboard$FilterBar$LabelFilters$labelFilterViewV3Reskin($author$project$Components$Dashboard$FilterBar$LabelFilters$ToggleLabelFilter),
				filtersToView));
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
					$author$project$Ui$V3$Stack$crossAxisCenter
				]),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
				A2($elm$core$List$cons, collapseToggleBtn, filtersEls)));
	});
var $author$project$Components$DashboardPage$viewLabelFilters = F3(
	function (isCollapsed, selectedQueue, labelFilters) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$DashboardPage$LabelFiltersMsg,
			A3($author$project$Components$Dashboard$FilterBar$LabelFilters$viewV3Reskin, isCollapsed, selectedQueue, labelFilters));
	});
var $author$project$Components$DashboardPage$viewMergeModalV3Reskin = F2(
	function (_v0, model) {
		if (model.mergeModal.isShown) {
			var config = {
				body: A2($author$project$Ui$V3$Typography$xSmallBody, _List_Nil, model.mergeModal.text),
				cancelButton: $elm$core$Maybe$Just(
					_Utils_Tuple2('Cancel', $author$project$Components$DashboardPage$DismissMergeModal)),
				dismissMsg: $author$project$Components$DashboardPage$DismissMergeModal,
				footerButtons: _List_Nil,
				header: $author$project$Ui$V3$Modal$textHeader('Merge emails?'),
				primaryButton: $elm$core$Maybe$Just(
					_Utils_Tuple2('Merge', $author$project$Components$DashboardPage$PerformMerge)),
				size: $author$project$Ui$V3$Modal$small
			};
			return A2(
				$author$project$Ui$V3$Modal$view,
				_List_fromArray(
					[
						$author$project$Ui$V3$Modal$disablePrimaryButton(model.mergeModal.isPerforming)
					]),
				config);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$DashboardPage$GoToReview = function (a) {
	return {$: 'GoToReview', a: a};
};
var $author$project$Components$DashboardPage$ToggleFilters = {$: 'ToggleFilters'};
var $author$project$Components$DashboardPage$ViewItemNewTab = function (a) {
	return {$: 'ViewItemNewTab', a: a};
};
var $author$project$Components$Dashboard$Pager$View$WithDecoder = function (a) {
	return {$: 'WithDecoder', a: a};
};
var $author$project$Components$Dashboard$Processed$ProcessedActionArea$approvePayBtn = F3(
	function (_v0, isProcessingApproval, selectedRowCount) {
		var isDisabled = isProcessingApproval || (!selectedRowCount);
		var buttonText = isProcessingApproval ? 'Approving...' : (isDisabled ? 'Select invoices to pay' : A2(
			$author$project$Helpers$String$appendToEnd,
			' to pay',
			'Approve ' + A2(
				$author$project$Helpers$String$pluralize,
				{many: 'invoices', one: 'invoice'},
				selectedRowCount)));
		return A3(
			$author$project$Ui$V3$Button$view,
			{
				action: $author$project$Ui$V3$Button$onClick($author$project$Components$Dashboard$Processed$ProcessedActionArea$BrokerApprove)
			},
			_List_fromArray(
				[
					$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
					$author$project$Ui$V3$Button$disabled(isDisabled)
				]),
			buttonText);
	});
var $author$project$Components$DashboardPage$ignoreButtonVisibleV3Reskin = F2(
	function (queue, accountSettings) {
		var _v0 = _Utils_Tuple2(queue, accountSettings.ignoreMode);
		_v0$6:
		while (true) {
			if (_v0.b.$ === 'IgnoreModeBulkIgnore') {
				switch (_v0.a.$) {
					case 'NewQueue':
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					case 'RepliesQueue':
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return true;
					case 'ExceptionQueue':
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						return true;
					case 'WaitingQueue':
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return true;
					case 'FinalQueue':
						if (_v0.a.a.$ === 'ProcessedQueue') {
							var _v9 = _v0.b;
							return true;
						} else {
							break _v0$6;
						}
					case 'ReadyToAuditQueue':
						var _v10 = _v0.a;
						var _v11 = _v0.b;
						return true;
					default:
						break _v0$6;
				}
			} else {
				break _v0$6;
			}
		}
		return false;
	});
var $author$project$Components$DashboardPage$mergeButtonVisibleV3Reskin = F2(
	function (queue, account) {
		return account.factorAccount && _Utils_eq(queue, $author$project$Components$Dashboard$AvailableQueues$NewQueue);
	});
var $author$project$Components$Dashboard$Processed$BrokerModel$selectedBrokerInvoiceIdSet = function (_v0) {
	var model = _v0.a;
	return model.selected;
};
var $author$project$Components$DashboardPage$SelectedEventDateRange = function (a) {
	return {$: 'SelectedEventDateRange', a: a};
};
var $author$project$Components$Dashboard$QueueDateInfoHelper$availableForQueue = F3(
	function (dashboardMode, queue, accountSettings) {
		return A2(
			$elm$core$List$map,
			function (f) {
				return f(accountSettings);
			},
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2($author$project$Components$Dashboard$QueueDateInfoHelper$availableForQueueLazy, dashboardMode, queue)));
	});
var $author$project$Components$Dashboard$FilterBar$filterSelectViewV3Reskin = F8(
	function (savedFilters, selectedSavedFilter, getName, onUpdateMsg, _v0, openEditModalMsg, _v1, _v2) {
		var options = A2($elm$core$List$sortBy, getName, savedFilters);
		var editButton = A2(
			$author$project$Ui$V3$UtilityButton$view,
			{icon: $author$project$Ui$V3$Icon$cog16, label: 'Open Saved Filters Modal', onClick: openEditModalMsg},
			_List_fromArray(
				[$author$project$Ui$V3$UtilityButton$sizeSmall]));
		var dropdown = A2(
			$author$project$Ui$V3$SimpleSelect$view,
			{onInput: onUpdateMsg, options: options, toLabel: getName, value: selectedSavedFilter},
			_List_fromArray(
				[
					$author$project$Ui$V3$SimpleSelect$placeholder(
					$elm$core$Maybe$Just('')),
					$author$project$Ui$V3$SimpleSelect$sizeSmall
				]));
		return A2(
			$author$project$Helpers$Html$labeledInput,
			'Your saved filters',
			A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
						$author$project$Ui$V3$Stack$crossAxisCenter,
						$author$project$Ui$V3$Stack$paddingBottom($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, dropdown),
						_Utils_Tuple2($author$project$Ui$V3$Stack$fit, editButton)
					])));
	});
var $author$project$Domain$QueueDate$toLabel = function (name) {
	switch (name.$) {
		case 'QueueDateUnsorted':
			return '';
		case 'QueueDateDelivered':
			return 'Date delivered';
		case 'QueueDateReceived':
			return 'Date received';
		case 'QueueDateLastContact':
			return 'Last contact';
		case 'QueueDateEstimatedDue':
			return 'Estimated due date';
		case 'QueueDateReviewOn':
			return 'Review on';
		case 'QueueDateProcessed':
			return 'Date processed';
		default:
			return 'Payment date';
	}
};
var $author$project$Components$Dashboard$QueueDateInfo$toEventDateRangeLabel = function (_v0) {
	var name = _v0.name;
	var queueDate = _v0.queueDate;
	var queueDateLabel = $author$project$Domain$QueueDate$toLabel(queueDate);
	return _Utils_eq(queueDateLabel, name) ? name : (queueDateLabel + (' (' + (name + ')')));
};
var $author$project$Components$DashboardPage$viewDate = F8(
	function (tz, accountSettings, showLabels, label, onInput, date, dateTime, attrs) {
		var wrapper = showLabels ? $author$project$Helpers$Html$labeledInput(label) : $elm$core$Basics$identity;
		var styles = function () {
			var _v1 = _Utils_Tuple2(date, dateTime);
			if ((_v1.a.$ === 'Nothing') && (_v1.b.$ === 'Nothing')) {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				return _List_fromArray(
					[
						$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray400)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var _v0 = accountSettings.showDateTimeFilters ? _Utils_Tuple2(
			$author$project$Ui$V3$Input$dateTime,
			A2($author$project$Components$DashboardPage$dateTimeString, dateTime, tz)) : _Utils_Tuple2(
			$author$project$Ui$V3$Input$date,
			$author$project$Components$DashboardPage$dateString(date));
		var inputType = _v0.a;
		var val = _v0.b;
		return wrapper(
			A4(
				$author$project$Ui$V3$Input$view,
				{
					onInput: onInput(tz)
				},
				_List_fromArray(
					[inputType]),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase'),
					_Utils_ap(styles, attrs)),
				val));
	});
var $author$project$Components$DashboardPage$viewFilters = F3(
	function (tz, data, model) {
		var savedFilters = function () {
			if (data.accountSettings.savedFilterEnhancementsEnabled) {
				var savedFilterIsSelected = function (dashboardSavedFilterData) {
					return A2(
						$author$project$Domain$DashboardSavedFilter$isSelected,
						{currentFilter: model.dashboardFilters, currentMode: model.dashboardMode},
						dashboardSavedFilterData.dashboardSavedFilter);
				};
				var selectedDashboardSavedFilterData = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						savedFilterIsSelected,
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							$author$project$Forward$Remote$toMaybe(data.dashboardSavedFilters))));
				var filterDataForMode = function (dashboardSavedFilterData) {
					return _Utils_eq(dashboardSavedFilterData.dashboardSavedFilter.dashboardMode, model.dashboardMode);
				};
				var filtersForMode = A2(
					$elm$core$List$filter,
					filterDataForMode,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$Forward$Remote$toMaybe(data.dashboardSavedFilters)));
				return $elm$core$Maybe$Just(
					A8(
						$author$project$Components$Dashboard$FilterBar$filterSelectViewV3Reskin,
						filtersForMode,
						selectedDashboardSavedFilterData,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dashboardSavedFilter;
							},
							function ($) {
								return $.name;
							}),
						$author$project$Components$DashboardPage$DashboardSavedFilterSelected,
						$author$project$Components$DashboardPage$DashboardSavedFilterSaving,
						$author$project$Components$DashboardPage$DashboardSavedFilterOpenEditModal,
						model.dashboardSavedFilterRefreshing,
						A2($author$project$Domain$DashboardFilters$isEmpty, model.dashboardMode, model.dashboardFilters)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var queueDateInfos = A3($author$project$Components$Dashboard$QueueDateInfoHelper$availableForQueue, model.dashboardMode, model.selectedQueue, data.accountSettings);
		var exceptionsFilter = (data.account.payablesAccount && ($author$project$Components$Dashboard$AvailableQueues$hasExceptionsColumn(model.selectedQueue) && (!_Utils_eq(model.dashboardMode, $author$project$AuditPb$DashboardModeIndex)))) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$map,
				$author$project$Components$DashboardPage$ExceptionsDropdownMsg,
				A2(
					$author$project$Ui$V3$CustomSelect$view,
					model.exceptionsDropdown,
					_List_fromArray(
						[
							$author$project$Ui$V3$CustomSelect$label('Exceptions')
						])))) : $elm$core$Maybe$Nothing;
		var eventDateRangeFilter = ($elm$core$List$length(queueDateInfos) > 1) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Helpers$Html$labeledInput,
				'Event date range',
				A2(
					$author$project$Ui$V3$SimpleSelect$view,
					{
						onInput: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.queueDate;
							},
							$author$project$Components$DashboardPage$SelectedEventDateRange),
						options: queueDateInfos,
						toLabel: $author$project$Components$Dashboard$QueueDateInfo$toEventDateRangeLabel,
						value: $elm_community$maybe_extra$Maybe$Extra$orList(
							_List_fromArray(
								[
									A2(
									$elm_community$list_extra$List$Extra$find,
									function (queueDateInfo) {
										return _Utils_eq(queueDateInfo.queueDate, model.dashboardFilters.rangeType);
									},
									queueDateInfos),
									A2(
									$elm_community$list_extra$List$Extra$find,
									function ($) {
										return $._default;
									},
									queueDateInfos)
								]))
					},
					_List_Nil))) : $elm$core$Maybe$Nothing;
		var startDateFilter = A8(
			$author$project$Components$DashboardPage$viewDate,
			tz,
			data.accountSettings,
			_Utils_eq(eventDateRangeFilter, $elm$core$Maybe$Nothing),
			'Start Date',
			$author$project$Components$DashboardPage$SelectStartDate,
			model.startDate,
			model.startDateTime,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'border-right-width', '1px'),
					A2($elm$html$Html$Attributes$style, 'border-top-right-radius', '0'),
					A2($elm$html$Html$Attributes$style, 'border-bottom-right-radius', '0')
				]));
		var endDateFilter = A8(
			$author$project$Components$DashboardPage$viewDate,
			tz,
			data.accountSettings,
			_Utils_eq(eventDateRangeFilter, $elm$core$Maybe$Nothing),
			'End Date',
			$author$project$Components$DashboardPage$SelectEndDate,
			model.endDate,
			model.endDateTime,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'border-left-width', '1px'),
					A2($elm$html$Html$Attributes$style, 'border-top-left-radius', '0'),
					A2($elm$html$Html$Attributes$style, 'border-bottom-left-radius', '0')
				]));
		var dateFilters = A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$noWrap]),
			_List_fromArray(
				[
					_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, startDateFilter),
					_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, endDateFilter)
				]));
		var customerFilter = A2($author$project$Components$DashboardPage$shouldShowCustomerDropdown, model.dashboardMode, data.account) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$map,
				$author$project$Components$DashboardPage$CustomerDropdownMsg,
				A2($author$project$Components$CustomerDropdown$view, data.customerDropdown, model.customerDropdown))) : $elm$core$Maybe$Nothing;
		var categoryFilters = A2(
			$elm$core$List$map,
			function (_v0) {
				var categoryName = _v0.a;
				var dropdown = _v0.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$DashboardPage$CategoryDropdownMsg(categoryName),
					A2(
						$author$project$Ui$V3$CustomSelect$view,
						dropdown,
						_List_fromArray(
							[
								$author$project$Ui$V3$CustomSelect$label(categoryName)
							])));
			},
			A2(
				$elm$core$List$filterMap,
				function (categoryName) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(categoryName),
						A2($elm$core$Dict$get, categoryName, model.categoryDropdowns));
				},
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.category;
						},
						function ($) {
							return $.name;
						}),
					model.dashboardFilters.categories)));
		var carrierFilter = A2(
			$elm$html$Html$map,
			$author$project$Components$DashboardPage$CarrierDropdownMsg,
			A3($author$project$Components$CarrierDropdown$view, _List_Nil, data.carrierDropdown, model.carrierDropdown));
		return _Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						savedFilters,
						eventDateRangeFilter,
						$elm$core$Maybe$Just(dateFilters),
						customerFilter,
						$elm$core$Maybe$Just(carrierFilter),
						exceptionsFilter
					])),
			categoryFilters);
	});
var $author$project$Components$DashboardPage$viewPreferredFilter = F3(
	function (accountSettings, currentUser, dashboardFilters) {
		var preferrencesMatchSelectedLabels = _Utils_eq(
			$author$project$Domain$LabelFilter$listToComparable(dashboardFilters.labelFilters),
			$author$project$Domain$LabelFilter$listToComparable(
				A2($elm$core$List$map, $author$project$Domain$LabelFilter$fromPb, currentUser.preferredFilters)));
		var preferrencesMatchSelectedCategories = _Utils_eq(
			$author$project$Domain$CategoryFilter$toString(dashboardFilters.categories),
			$author$project$Domain$CategoryFilter$toString(
				A2($elm$core$List$map, $author$project$Domain$CategoryFilter$fromPb, currentUser.preferredCategories)));
		var preferrencesMatchSelectedFilters = preferrencesMatchSelectedCategories && preferrencesMatchSelectedLabels;
		var noPreferenceSet = $elm$core$List$isEmpty(currentUser.preferredFilters);
		var labelsUnselected = A2($elm$core$List$all, $author$project$Domain$LabelFilter$isUnselected, dashboardFilters.labelFilters);
		var categoriesUnselected = $elm$core$List$isEmpty(
			$author$project$Domain$CategoryFilter$filterSelected(dashboardFilters.categories));
		return (accountSettings.savedFilterEnhancementsEnabled || (labelsUnselected && (categoriesUnselected && noPreferenceSet))) ? $elm$core$Maybe$Nothing : (preferrencesMatchSelectedFilters ? $elm$core$Maybe$Just(
			A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardPage$UpdatePreferredFilters)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
						$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
						A2($author$project$Ui$V3$Button$cssStyle, 'padding', '0'),
						$author$project$Ui$V3$Button$disabled(true)
					]),
				'Saved labels')) : $elm$core$Maybe$Just(
			A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick($author$project$Components$DashboardPage$UpdatePreferredFilters)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
						$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
						A2($author$project$Ui$V3$Button$cssStyle, 'padding', '0')
					]),
				'Set as default labels')));
	});
var $author$project$Components$Dashboard$RowHelper$multipleCustomerTooltipV3Reskin = function (customers) {
	return A3(
		$author$project$Ui$V3$Tooltip$viewHtml,
		_List_fromArray(
			[
				$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$BelowDirection)
			]),
		A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_Nil,
			A2($elm$core$List$map, $elm$html$Html$text, customers)),
		$elm$html$Html$text('Multiple Customers'));
};
var $author$project$Components$Dashboard$RowHelper$viewCustomersV3Reskin = F2(
	function (settings, customers) {
		var customerText = A2(
			$elm$core$List$map,
			$author$project$Domain$TmsCustomer$customerNameForDisplay(settings),
			customers);
		return ($elm$core$List$length(customers) < 4) ? A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_Nil,
			A2($elm$core$List$map, $elm$html$Html$text, customerText)) : $author$project$Components$Dashboard$RowHelper$multipleCustomerTooltipV3Reskin(customerText);
	});
var $author$project$Components$Dashboard$RowHelper$customerInformationAreaV3Reskin = F2(
	function (settings, customer) {
		switch (customer.$) {
			case 'Customers':
				var customers = customer.a;
				return A2($author$project$Components$Dashboard$RowHelper$viewCustomersV3Reskin, settings, customers);
			case 'Debtor':
				var factorBroker = customer.a;
				return $elm$html$Html$text(factorBroker.name);
			default:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Unknown customer')
						]));
		}
	});
var $author$project$Ui$V3$Icon$sortArrowDefaultLight16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#CFD9E4'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27349 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#CFD9E4'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$sortArrowDownLight16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#CFD9E4'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27348 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#001929'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Ui$V3$Icon$sortArrowUpLight16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5.73846L8.57309 1.67891C8.27346 1.32396 7.72652 1.32396 7.42688 1.67891L4 5.73846'),
						$elm$svg$Svg$Attributes$stroke('#001929'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.00002 10.2615L7.42691 14.3211C7.72654 14.676 8.27348 14.676 8.57312 14.3211L12 10.2615'),
						$elm$svg$Svg$Attributes$stroke('#CFD9E4'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round')
					]),
				_List_Nil)
			])));
var $author$project$Components$Dashboard$QueueDateInfo$viewHeader = F3(
	function (onSortBy, currentSortBy, _v0) {
		var name = _v0.name;
		var tooltip = _v0.tooltip;
		var queueDate = _v0.queueDate;
		var tooltipAttrs = function () {
			if (tooltip.$ === 'Just') {
				var tooltipStr = tooltip.a;
				return _List_fromArray(
					[
						$author$project$Ui$V3$Stack$htmlAttribute(
						A2($elm$html$Html$Attributes$attribute, 'data-tooltip', 'true')),
						$author$project$Ui$V3$Stack$htmlAttribute(
						$elm$html$Html$Attributes$title(tooltipStr)),
						$author$project$Ui$V3$Stack$htmlAttribute(
						A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var queueDateName = $author$project$Domain$QueueDate$toString(queueDate);
		var _v1 = function () {
			if (_Utils_eq(currentSortBy.name, queueDateName)) {
				var _v2 = currentSortBy.order;
				if (_v2.$ === 'DashboardSortByOrderAsc') {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Icon$sortArrowDownLight16,
						{name: queueDateName, order: $author$project$AuditPb$DashboardSortByOrderDesc});
				} else {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Icon$sortArrowUpLight16,
						{name: queueDateName, order: $author$project$AuditPb$DashboardSortByOrderAsc});
				}
			} else {
				return _Utils_Tuple2(
					$author$project$Ui$V3$Icon$sortArrowDefaultLight16,
					{name: queueDateName, order: $author$project$AuditPb$DashboardSortByOrderAsc});
			}
		}();
		var icon = _v1.a;
		var newSort = _v1.b;
		return A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$crossAxisCenter,
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
						$author$project$Ui$V3$Stack$noWrap,
						$author$project$Ui$V3$Stack$onClick(
						onSortBy(newSort))
					]),
				tooltipAttrs),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$html$Html$text(name)),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2($author$project$Ui$V3$Icon$view16, _List_Nil, icon))
				]));
	});
var $author$project$Components$Dashboard$QueueDateInfo$tableColumns = F2(
	function (config, queueDateInfosAndColumnViewers) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var queueDateInfo = _v0.a;
				var columnViewer = _v0.b;
				return {
					attrs: _List_Nil,
					content: columnViewer(config),
					heading: A3($author$project$Components$Dashboard$QueueDateInfo$viewHeader, config.onSortBy, config.currentSortBy, queueDateInfo)
				};
			},
			queueDateInfosAndColumnViewers);
	});
var $author$project$Components$Dashboard$RowHelper$tmsCarrierNameV3Reskin = F2(
	function (accountType, maybeCarrier) {
		if (maybeCarrier.$ === 'Just') {
			var carrier = maybeCarrier.a;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(carrier.name)
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Unknown ' + $author$project$Domain$Account$carrierTerm(accountType))
					]));
		}
	});
var $author$project$Ui$V3$Checkbox$StopPropagationAttribute = {$: 'StopPropagationAttribute'};
var $author$project$Ui$V3$Checkbox$stopPropagation = $author$project$Ui$V3$Checkbox$StopPropagationAttribute;
var $author$project$Ui$V3$Colors$Yellow50 = {$: 'Yellow50'};
var $author$project$Ui$V3$Colors$Yellow700 = {$: 'Yellow700'};
var $author$project$Ui$V3$Icon$eye16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.6289 7.28093C13.8689 5.34093 10.9623 3.28093 8.00895 3.33427C5.05561 3.3876 2.14895 5.34093 0.388945 7.28093C0.138777 7.55388 0 7.91068 0 8.28093C0 8.65118 0.138777 9.00799 0.388945 9.28093C1.56228 10.5476 4.50228 13.2009 8.00895 13.2009C11.5156 13.2009 14.4489 10.5343 15.6289 9.2476C15.8698 8.97667 16.0028 8.62677 16.0028 8.26427C16.0028 7.90176 15.8698 7.55186 15.6289 7.28093ZM4.94228 8.2676C4.94228 7.66107 5.12214 7.06816 5.45911 6.56385C5.79607 6.05954 6.27502 5.66648 6.83538 5.43437C7.39574 5.20226 8.01235 5.14153 8.60722 5.25986C9.2021 5.37819 9.74853 5.67026 10.1774 6.09914C10.6063 6.52802 10.8984 7.07445 11.0167 7.66932C11.135 8.2642 11.0743 8.8808 10.8422 9.44116C10.6101 10.0015 10.217 10.4805 9.71269 10.8174C9.20838 11.1544 8.61547 11.3343 8.00895 11.3343C7.19562 11.3343 6.4156 11.0112 5.84048 10.4361C5.26537 9.86095 4.94228 9.08093 4.94228 8.2676Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.00887 9.60099C8.74525 9.60099 9.3422 9.00404 9.3422 8.26766C9.3422 7.53128 8.74525 6.93433 8.00887 6.93433C7.27249 6.93433 6.67554 7.53128 6.67554 8.26766C6.67554 9.00404 7.27249 9.60099 8.00887 9.60099Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Presence$viewInLineV3Reskin = function (state) {
	if ($elm$core$List$isEmpty(state.others)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var str = $elm_community$string_extra$String$Extra$toSentenceOxford(
			$author$project$Presence$unique(state.others)) + ' currently viewing';
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$Yellow50),
						A2($elm$html$Html$Attributes$style, 'padding', '3px 8px'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '4px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Yellow700),
								A2($elm$html$Html$Attributes$style, 'position', 'relative'),
								A2($elm$html$Html$Attributes$style, 'margin-right', '8px'),
								A2($elm$html$Html$Attributes$style, 'top', '2px')
							]),
						_List_fromArray(
							[
								A4($author$project$Ui$V3$Icon$viewCustom, '12', '12', _List_Nil, $author$project$Ui$V3$Icon$eye16)
							])),
						$elm$html$Html$text(str)
					])));
	}
};
var $author$project$Components$Dashboard$DashboardRow$View$viewLabelsV3Reskin = function (labels) {
	return $elm$core$List$isEmpty(labels) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
				A2(
					$elm$core$List$map,
					$author$project$Components$Dashboard$RowHelper$carrierLabelButtonV3Reskin,
					$author$project$Helpers$List$removeDuplicates(labels)))));
};
var $author$project$Components$Dashboard$DashboardRow$View$viewLoadOrSubjectColumn = function (config) {
	var viewSelectedRowCheckboxV3Reskin = function (row) {
		var _v0 = _Utils_Tuple2(config.onSelectSelectable, config.accountSettings.ignoreMode);
		if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'IgnoreModeBulkIgnore')) {
			var onSelectSelectable = _v0.a.a;
			var _v1 = _v0.b;
			return A2(
				$author$project$Ui$V3$Checkbox$view,
				{
					checked: A2($author$project$Components$Dashboard$Pager$Selectable$setMember, row.ignorable, config.selectedSelectables),
					label: $elm$html$Html$text(''),
					onCheck: $elm$core$Basics$always(
						onSelectSelectable(row.ignorable))
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Checkbox$stopPropagation,
						$author$project$Ui$V3$Checkbox$extraPadding(8)
					]));
		} else {
			return $elm$html$Html$text('');
		}
	};
	return {
		attrs: _List_Nil,
		content: A2(
			$elm$core$Basics$composeR,
			config.toColumnData,
			function (row) {
				return A2(
					$author$project$Ui$V3$Stack$viewVertMaybes,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall),
							$author$project$Ui$V3$Stack$crossAxisLeft
						]),
					_List_fromArray(
						[
							$author$project$Presence$viewInLineV3Reskin(
							A3(
								$author$project$DashboardPresence$stateAtPath,
								config.dashboardPresence,
								$author$project$Path$toString(row.redirectTo),
								row.pathData)),
							$elm$core$Maybe$Just(
							A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[$author$project$Ui$V3$Stack$crossAxisLeft, $author$project$Ui$V3$Stack$noWrap]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'padding-top', '3px')
												]),
											_List_fromArray(
												[
													viewSelectedRowCheckboxV3Reskin(row)
												]))),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										A2(
											$author$project$Ui$V3$Stack$viewVertMaybes,
											_List_fromArray(
												[
													$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
												]),
											_List_fromArray(
												[
													$elm$core$Maybe$Just(
													A2(
														$author$project$Ui$V3$Stack$viewVertMaybes,
														_List_Nil,
														_List_fromArray(
															[
																$elm$core$Maybe$Just(
																A2(
																	$author$project$Ui$V3$Typography$smallBodySemiBold,
																	_List_fromArray(
																		[
																			A2($elm$html$Html$Attributes$style, 'display', '-webkit-box'),
																			A2($elm$html$Html$Attributes$style, '-webkit-box-orient', 'vertical'),
																			A2($elm$html$Html$Attributes$style, '-webkit-line-clamp', '2'),
																			A2($elm$html$Html$Attributes$style, 'overflow', 'hidden')
																		]),
																	row.header)),
																A2(
																$elm$core$Maybe$map,
																$author$project$Ui$V3$Typography$xSmallBody(
																	_List_fromArray(
																		[
																			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
																		])),
																row.subheader)
															]))),
													A2($elm$core$Maybe$map, $elm$html$Html$text, row.body),
													$author$project$Components$Dashboard$DashboardRow$View$viewLabelsV3Reskin(row.labels)
												])))
									])))
						]));
			}),
		heading: A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[$author$project$Ui$V3$Stack$noWrap, $author$project$Ui$V3$Stack$crossAxisCenter]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					A2(
						$author$project$Ui$V3$Checkbox$view,
						{
							checked: config.areAllSelected,
							label: $elm$html$Html$text(''),
							onCheck: $elm$core$Basics$always(config.onSelectAll)
						},
						_List_fromArray(
							[
								$author$project$Ui$V3$Checkbox$extraPadding(8)
							]))),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$html$Html$text(config.columnHeading))
				]))
	};
};
var $author$project$Components$Dashboard$ExceptionedRowSummary$maxNumVisible = 2;
var $author$project$Components$Dashboard$ExceptionedRowSummary$tooltipV3Reskin = F2(
	function (numExceptions, tooltipContents) {
		var lastStr = $elm$core$String$concat(
			_List_fromArray(
				[
					'View all ',
					$elm$core$String$fromInt(numExceptions),
					' exceptions'
				]));
		return A3(
			$author$project$Ui$V3$Tooltip$viewHtml,
			_List_fromArray(
				[
					$author$project$Ui$V3$Tooltip$tooltipLocation($author$project$Ui$V3$Tooltip$BeginningLocation),
					$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$BelowDirection)
				]),
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				tooltipContents),
			A2(
				$author$project$Ui$V3$Stack$viewHorzWithWidths,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						$elm$html$Html$text(lastStr)),
						_Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$TextBrandDefault)
								]),
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$info16)
								])))
					])));
	});
var $author$project$Domain$ExceptionSummary$totalCount = function (_v0) {
	var paymentExceptions = _v0.paymentExceptions;
	var billingExceptions = _v0.billingExceptions;
	return $elm$core$List$length(
		_Utils_ap(billingExceptions, paymentExceptions));
};
var $author$project$Components$Dashboard$ExceptionedRowSummary$auditBillingViewV3Reskin = function (exceptionSummary) {
	var paymentExceptions = exceptionSummary.paymentExceptions;
	var billingExceptions = exceptionSummary.billingExceptions;
	var tooltipLabeledList = F2(
		function (header, els) {
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$V3$Typography$smallBodySemiBold,
						_List_fromArray(
							[
								$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray0)
							]),
						header),
					A2(
						$elm$core$List$map,
						function (el) {
							return A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidths,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										$elm$html$Html$text('•')),
										_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, el)
									]));
						},
						els)));
		});
	var origCount = $author$project$Domain$ExceptionSummary$totalCount(exceptionSummary);
	var labeledList = F2(
		function (header, els) {
			return A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
					]),
				A2(
					$elm$core$List$cons,
					A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, header),
					els));
		});
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(billingExceptions, paymentExceptions);
		if (!_v1.a.b) {
			if (!_v1.b.b) {
				return _Utils_Tuple2('', _List_Nil);
			} else {
				if (!_v1.b.b.b) {
					var _v3 = _v1.b;
					var one = _v3.a;
					return _Utils_Tuple2(
						'Payment exception',
						_List_fromArray(
							[one]));
				} else {
					var many = _v1.b;
					return _Utils_Tuple2(
						'Payment exceptions',
						A2($elm$core$List$take, 2, many));
				}
			}
		} else {
			if (!_v1.a.b.b) {
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					var one = _v2.a;
					return _Utils_Tuple2(
						'Billing exception',
						_List_fromArray(
							[one]));
				} else {
					var _v4 = _v1.a;
					var one = _v4.a;
					var rest = _v1.b;
					return _Utils_Tuple2(
						'Billing/Payment exceptions',
						A2(
							$elm$core$List$cons,
							one,
							A2($elm$core$List$take, 1, rest)));
				}
			} else {
				if (!_v1.b.b) {
					var many = _v1.a;
					return _Utils_Tuple2(
						'Billing exceptions',
						A2($elm$core$List$take, 2, many));
				} else {
					var many = _v1.a;
					return _Utils_Tuple2(
						'Billing/Payment exceptions',
						A2($elm$core$List$take, 2, many));
				}
			}
		}
	}();
	var visibleHeader = _v0.a;
	var visibleExceptions = _v0.b;
	if ($elm$core$List$isEmpty(visibleExceptions)) {
		return $elm$html$Html$text('');
	} else {
		if (_Utils_cmp(origCount, $author$project$Components$Dashboard$ExceptionedRowSummary$maxNumVisible) < 1) {
			return A2(
				labeledList,
				visibleHeader,
				A2($elm$core$List$map, $elm$html$Html$text, visibleExceptions));
		} else {
			var tooltipEl = A2(
				$author$project$Components$Dashboard$ExceptionedRowSummary$tooltipV3Reskin,
				origCount,
				A2(
					$elm$core$List$filterMap,
					function (_v5) {
						var header = _v5.a;
						var exceptions = _v5.b;
						return $elm$core$List$isEmpty(exceptions) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2(
								tooltipLabeledList,
								header,
								A2($elm$core$List$map, $elm$html$Html$text, exceptions)));
					},
					_List_fromArray(
						[
							_Utils_Tuple2('Billing exceptions', exceptionSummary.billingExceptions),
							_Utils_Tuple2('Payment exceptions', exceptionSummary.paymentExceptions)
						])));
			return A2(
				labeledList,
				visibleHeader,
				_Utils_ap(
					A2($elm$core$List$map, $elm$html$Html$text, visibleExceptions),
					_List_fromArray(
						[tooltipEl])));
		}
	}
};
var $author$project$Components$Dashboard$ExceptionedRowSummary$defaultViewV3Reskin = function (exceptionMessages) {
	var numMessages = $elm$core$List$length(exceptionMessages);
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_fromArray(
			[
				$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXSmall)
			]),
		function () {
			if (_Utils_cmp(numMessages, $author$project$Components$Dashboard$ExceptionedRowSummary$maxNumVisible) < 1) {
				return A2($elm$core$List$map, $elm$html$Html$text, exceptionMessages);
			} else {
				var visibleMessages = A2(
					$elm$core$List$map,
					$elm$html$Html$text,
					A2($elm$core$List$take, $author$project$Components$Dashboard$ExceptionedRowSummary$maxNumVisible, exceptionMessages));
				var lastEl = A2(
					$author$project$Components$Dashboard$ExceptionedRowSummary$tooltipV3Reskin,
					numMessages,
					A2($elm$core$List$map, $elm$html$Html$text, exceptionMessages));
				return _Utils_ap(
					visibleMessages,
					_List_fromArray(
						[lastEl]));
			}
		}());
};
var $author$project$Components$Dashboard$ExceptionedRowSummary$noteTooltipV3Reskin = function (note) {
	if ($elm$core$String$length(note) > 50) {
		var visibleNote = A3($elm$core$String$slice, 0, 50, note) + '... ';
		return A3(
			$author$project$Ui$V3$Tooltip$viewHtml,
			_List_fromArray(
				[
					$author$project$Ui$V3$Tooltip$tooltipLocation($author$project$Ui$V3$Tooltip$BeginningLocation),
					$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$BelowDirection),
					A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'top', 'calc(100% - 20px)')
				]),
			$elm$html$Html$text(note),
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(visibleNote),
								A2($author$project$Ui$V3$Icon$view16, _List_Nil, $author$project$Ui$V3$Icon$infoOutline16)
							]))
					])));
	} else {
		return $elm$html$Html$text(note);
	}
};
var $author$project$Components$Dashboard$ExceptionedRowSummary$viewV3Reskin = F3(
	function (summary, auditBillingEnabled, maybeNote) {
		return ((!$author$project$Domain$ExceptionSummary$hasExceptions(summary)) && _Utils_eq(maybeNote, $elm$core$Maybe$Nothing)) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('None')
				])) : A2(
			$author$project$Ui$V3$Stack$viewVertMaybes,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$htmlAttribute($author$project$Ui$V3$Typography$xSmallBodyClass),
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
				]),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					auditBillingEnabled ? $author$project$Components$Dashboard$ExceptionedRowSummary$auditBillingViewV3Reskin(summary) : $author$project$Components$Dashboard$ExceptionedRowSummary$defaultViewV3Reskin(summary.paymentExceptions)),
					A2($elm$core$Maybe$map, $author$project$Components$Dashboard$ExceptionedRowSummary$noteTooltipV3Reskin, maybeNote)
				]));
	});
var $author$project$Components$Dashboard$CarrierInvoiceRow$View$viewV3Reskin = function (config) {
	var loadId = $author$project$Components$Dashboard$DashboardRow$View$viewLoadOrSubjectColumn(
		{
			accountSettings: config.accountSettings,
			areAllSelected: config.areAllSelected,
			columnHeading: 'Load',
			dashboardPresence: config.dashboardPresence,
			onSelectAll: config.onSelectAll,
			onSelectSelectable: config.onSelectSelectable,
			selectedSelectables: config.selectedSelectables,
			toColumnData: function (row) {
				return {
					body: $elm$core$Maybe$Nothing,
					header: row.loadId,
					ignorable: $author$project$Components$Dashboard$Pager$Selectable$CarrierInvoice(row.carrierInvoiceId),
					labels: row.labels,
					pathData: _List_Nil,
					redirectTo: row.redirectTo,
					subheader: $elm$core$Maybe$Nothing
				};
			}
		});
	var exceptions = {
		attrs: _List_Nil,
		content: function (row) {
			return A3($author$project$Components$Dashboard$ExceptionedRowSummary$viewV3Reskin, row.exceptionSummary, config.accountSettings.auditBillingEnabled, $elm$core$Maybe$Nothing);
		},
		heading: $elm$html$Html$text('Exceptions and notes')
	};
	var dateColumns = A2($author$project$Components$Dashboard$QueueDateInfo$tableColumns, config, $author$project$Components$Dashboard$CarrierInvoiceRow$View$getQueueDateInfosAndColumns);
	var customer = {
		attrs: _List_Nil,
		content: function (row) {
			return A2(
				$author$project$Components$Dashboard$RowHelper$customerInformationAreaV3Reskin,
				config.accountSettings,
				A2($author$project$Components$Dashboard$DashboardRow$customersToCustomerType, row.shipmentCustomers, row.loadCustomer));
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$customerTerm(config.accountType))
	};
	var carrier = {
		attrs: _List_Nil,
		content: function (row) {
			return A2($author$project$Components$Dashboard$RowHelper$tmsCarrierNameV3Reskin, config.accountType, row.tmsCarrier);
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$carrierTerm(config.accountType))
	};
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[loadId, carrier, customer]),
				dateColumns,
				_List_fromArray(
				[exceptions])
			]));
};
var $author$project$Components$Dashboard$RowHelper$maybeTmsCarrierNameV3Reskin = F2(
	function (accountType, tmsCarrierData) {
		var _v0 = tmsCarrierData.singleCarrier;
		if (_v0.$ === 'Nothing') {
			return A2($author$project$Components$Dashboard$RowHelper$tmsCarrierNameV3Reskin, accountType, $elm$core$Maybe$Nothing);
		} else {
			if (!_v0.a) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Multiple ' + ($author$project$Domain$Account$carrierTerm(accountType) + 's'))
						]));
			} else {
				return A2($author$project$Components$Dashboard$RowHelper$tmsCarrierNameV3Reskin, accountType, tmsCarrierData.tmsCarrier);
			}
		}
	});
var $author$project$Components$Dashboard$DashboardRow$View$importingButtonAreaV3Reskin = _List_fromArray(
	[
		A2(
		$author$project$Ui$V3$StatusTag$view,
		_List_fromArray(
			[$author$project$Ui$V3$StatusTag$activeStyle]),
		'Importing...')
	]);
var $author$project$Components$Dashboard$DashboardRow$View$importProgressLabelAreaV3Reskin = function (importStatus) {
	var progressMessage = $elm$core$String$fromInt(importStatus.pageInStep) + ('/' + ($elm$core$String$fromInt(importStatus.pages) + ' importing'));
	var _v0 = importStatus.step;
	if (_v0.$ === 'ImportStepExtractData') {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$StatusTag$view,
				_List_fromArray(
					[$author$project$Ui$V3$StatusTag$activeStyle]),
				progressMessage)
			]);
	} else {
		return $author$project$Components$Dashboard$DashboardRow$View$importingButtonAreaV3Reskin;
	}
};
var $author$project$Components$Dashboard$DashboardRow$View$importingFailedButtonAreaV3Reskin = _List_fromArray(
	[
		A2(
		$author$project$Ui$V3$StatusTag$view,
		_List_fromArray(
			[$author$project$Ui$V3$StatusTag$alertStyle]),
		'Import Failed'),
		$elm$html$Html$text('Support has been notified')
	]);
var $author$project$Ui$V3$Icon$arrowRightSmall16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(0, 1)')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.4935 6.49995C12.493 6.3297 12.4565 6.16147 12.3864 6.00635C12.3162 5.85122 12.214 5.71272 12.0865 5.59995L6.49698 0.680448C6.3526 0.562253 6.16796 0.504727 5.982 0.519994C5.79603 0.535261 5.62325 0.622128 5.50007 0.762289C5.3769 0.902449 5.31295 1.08496 5.3217 1.27134C5.33045 1.45773 5.41122 1.63344 5.54698 1.76145L9.86548 5.56145C9.88442 5.57825 9.89781 5.60041 9.90388 5.62499C9.90995 5.64957 9.90841 5.67542 9.89946 5.6991C9.89052 5.72279 9.87459 5.7432 9.85379 5.75764C9.83299 5.77208 9.8083 5.77986 9.78298 5.77995H1.22598C1.03503 5.77995 0.851891 5.85581 0.716865 5.99083C0.581838 6.12586 0.505981 6.30899 0.505981 6.49995C0.505981 6.6909 0.581838 6.87404 0.716865 7.00907C0.851891 7.14409 1.03503 7.21995 1.22598 7.21995H9.78148C9.80679 7.22019 9.83143 7.22808 9.85218 7.24258C9.87292 7.25708 9.88879 7.27752 9.89772 7.3012C9.90664 7.32488 9.90819 7.35071 9.90217 7.3753C9.89615 7.39988 9.88284 7.42207 9.86398 7.43895L5.54548 11.2389C5.46996 11.3 5.40755 11.3756 5.36201 11.4613C5.31647 11.5471 5.28874 11.6411 5.28049 11.7379C5.27224 11.8346 5.28364 11.932 5.314 12.0242C5.34437 12.1164 5.39306 12.2016 5.45717 12.2745C5.52127 12.3474 5.59946 12.4066 5.68703 12.4485C5.7746 12.4904 5.86974 12.5142 5.96673 12.5184C6.06373 12.5226 6.16057 12.5071 6.25143 12.4729C6.3423 12.4388 6.42531 12.3865 6.49548 12.3194L12.086 7.39995C12.2137 7.28727 12.316 7.14879 12.3863 6.99365C12.4565 6.83851 12.493 6.67025 12.4935 6.49995Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			])));
var $author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelAreaV3Reskin = F5(
	function (maybeSkipAsynchronousEmailReview, onGoToReview, emailMessageId, maybeDocumentBatchId, reviewType) {
		var _v0 = function () {
			switch (reviewType.$) {
				case 'PodReview':
					return _Utils_Tuple2('POD processing', 'Manually process');
				case 'DocumentContentReview':
					return _Utils_Tuple2('Document Data Extraction', 'Skip data extraction >');
				case 'DocumentContentReviewDocumentType':
					return _Utils_Tuple2('Document Type Processing', 'Skip data extraction >');
				case 'DocumentContentReviewNoDependents':
					return _Utils_Tuple2('Document Data Extraction', 'Skip data extraction >');
				case 'DocumentBatchGroupingReview':
					return _Utils_Tuple2('Document Grouping Review', 'Skip grouping review >');
				default:
					return _Utils_Tuple2('Load Review', 'Skip load review >');
			}
		}();
		var processingText = _v0.a;
		var skipText = _v0.b;
		var processingLabel = A2(
			$author$project$Ui$V3$StatusTag$view,
			_List_fromArray(
				[$author$project$Ui$V3$StatusTag$activeStyle]),
			processingText);
		var actionableProcessingLabel = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			processingLabel,
			function (msg) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$stopPropagationOn,
							'click',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2(
									msg(emailMessageId),
									true)))
						]),
					_List_fromArray(
						[processingLabel]));
			},
			onGoToReview);
		var _v2 = _Utils_Tuple2(maybeDocumentBatchId, maybeSkipAsynchronousEmailReview);
		if ((_v2.a.$ === 'Just') && (_v2.b.$ === 'Just')) {
			var documentBatchId = _v2.a.a;
			var skipAsynchronousEmailReview = _v2.b.a;
			return _List_fromArray(
				[
					actionableProcessingLabel,
					A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(
							A3(skipAsynchronousEmailReview, emailMessageId, documentBatchId, reviewType))
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
							$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeSmall),
							$author$project$Ui$V3$Button$rightIcon16WithHiddenLabel($author$project$Ui$V3$Icon$arrowRightSmall16)
						]),
					skipText)
				]);
		} else {
			return _List_fromArray(
				[actionableProcessingLabel]);
		}
	});
var $author$project$Components$Dashboard$DashboardRow$View$noWrap = function (str) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $author$project$Components$Dashboard$DashboardRow$View$processedButtonAreaV3Reskin = F2(
	function (maybeDocumentBatch, showProcessThisButton) {
		return showProcessThisButton ? _List_fromArray(
			[
				A2(
				$author$project$Ui$V3$StatusTag$view,
				_List_fromArray(
					[$author$project$Ui$V3$StatusTag$activeStyle]),
				'Process this'),
				$author$project$Components$Dashboard$DashboardRow$View$noWrap(
				$author$project$Components$Dashboard$DashboardRow$pagesString(maybeDocumentBatch)),
				$author$project$Components$Dashboard$DashboardRow$View$noWrap(
				$author$project$Components$Dashboard$DashboardRow$autoProcessingString(maybeDocumentBatch))
			]) : _List_fromArray(
			[
				$author$project$Components$Dashboard$DashboardRow$View$noWrap(
				$author$project$Components$Dashboard$DashboardRow$pagesString(maybeDocumentBatch)),
				$author$project$Components$Dashboard$DashboardRow$View$noWrap(
				$author$project$Components$Dashboard$DashboardRow$autoProcessingString(maybeDocumentBatch))
			]);
	});
var $author$project$Components$Dashboard$DashboardRow$View$viewMessageActionAreaV3Reskin = F8(
	function (onSkipAsynchronousEmailReview, onGoToReview, emailImportState, maybeImportStatus, maybeDocumentBatch, showProcessThisButton, emailMessageId, documentBatchId) {
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
					$author$project$Ui$V3$Stack$crossAxisLeft
				]),
			function () {
				var _v0 = _Utils_Tuple2(emailImportState, maybeImportStatus);
				switch (_v0.a.$) {
					case 'EmailImportStateImportInProgress':
						if (_v0.b.$ === 'Just') {
							var _v1 = _v0.a;
							var importStatus = _v0.b.a;
							return $author$project$Components$Dashboard$DashboardRow$View$importProgressLabelAreaV3Reskin(importStatus);
						} else {
							var _v2 = _v0.a;
							var _v3 = _v0.b;
							return $author$project$Components$Dashboard$DashboardRow$View$importingButtonAreaV3Reskin;
						}
					case 'EmailImportStateInDocumentContentReview':
						var _v4 = _v0.a;
						return A5($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelAreaV3Reskin, onSkipAsynchronousEmailReview, onGoToReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReview);
					case 'EmailImportStateInDocumentContentReviewDocumentType':
						var _v5 = _v0.a;
						return A5($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelAreaV3Reskin, onSkipAsynchronousEmailReview, onGoToReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReviewDocumentType);
					case 'EmailImportStateInDocumentContentReviewNoDependents':
						var _v6 = _v0.a;
						return A5($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelAreaV3Reskin, onSkipAsynchronousEmailReview, onGoToReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentContentReviewNoDependents);
					case 'EmailImportStateInDocumentBatchGroupingReview':
						var _v7 = _v0.a;
						return A5($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelAreaV3Reskin, onSkipAsynchronousEmailReview, onGoToReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentBatchGroupingReview);
					case 'EmailImportStateInDocumentGroupLoadReview':
						var _v8 = _v0.a;
						return A5($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelAreaV3Reskin, onSkipAsynchronousEmailReview, onGoToReview, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$DocumentGroupLoadReview);
					case 'EmailImportStateInPODDetection':
						var _v9 = _v0.a;
						return A5($author$project$Components$Dashboard$DashboardRow$View$inAsynchronousEmailReviewLabelAreaV3Reskin, onSkipAsynchronousEmailReview, $elm$core$Maybe$Nothing, emailMessageId, documentBatchId, $author$project$Domain$EmailMessageAsynchronousReviewType$PodReview);
					case 'EmailImportStateImportFailed':
						var _v10 = _v0.a;
						return $author$project$Components$Dashboard$DashboardRow$View$importingFailedButtonAreaV3Reskin;
					default:
						var _v11 = _v0.a;
						return A2($author$project$Components$Dashboard$DashboardRow$View$processedButtonAreaV3Reskin, maybeDocumentBatch, showProcessThisButton);
				}
			}());
	});
var $author$project$Components$Dashboard$EmailRow$View$viewV3Reskin = function (config) {
	var pageCount = {
		attrs: _List_Nil,
		content: function (row) {
			return A8(
				$author$project$Components$Dashboard$DashboardRow$View$viewMessageActionAreaV3Reskin,
				config.onSkipAsynchronousEmailReview,
				config.onGoToReview,
				row.emailMessage.importState,
				row.maybeImportStatus,
				row.maybeDocumentBatch,
				false,
				row.emailMessage.id,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.id;
					},
					row.maybeDocumentBatch));
		},
		heading: $elm$html$Html$text('Page count')
	};
	var email = {
		attrs: _List_Nil,
		content: function (row) {
			return A2(
				$author$project$Components$Dashboard$DashboardRow$View$viewSender,
				config.accountSettings,
				$elm$core$Maybe$Just(row.emailMessage.senderAddress));
		},
		heading: $elm$html$Html$text('Email')
	};
	var dateColumns = A2($author$project$Components$Dashboard$QueueDateInfo$tableColumns, config, $author$project$Components$Dashboard$EmailRow$View$getQueueDateInfosAndColumns);
	var carrier = {
		attrs: _List_Nil,
		content: function (row) {
			return A2(
				$author$project$Components$Dashboard$RowHelper$maybeTmsCarrierNameV3Reskin,
				config.accountType,
				{singleCarrier: row.emailMessage.singleCarrier, tmsCarrier: row.maybeTmsCarrier});
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$carrierTerm(config.accountType))
	};
	var batchPathData = function (row) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2($elm$core$Maybe$map, $author$project$Components$Dashboard$EmailRow$documentBatchToPathData, row.maybeDocumentBatch)));
	};
	var pathData = function (row) {
		return A2(
			$elm$core$List$cons,
			$author$project$DashboardPresence$EmailMessageIdPath(
				$author$project$Domain$EmailMessageId$toInt(row.emailMessage.id)),
			batchPathData(row));
	};
	var subjectLine = $author$project$Components$Dashboard$DashboardRow$View$viewLoadOrSubjectColumn(
		{
			accountSettings: config.accountSettings,
			areAllSelected: config.areAllSelected,
			columnHeading: 'Subject line',
			dashboardPresence: config.dashboardPresence,
			onSelectAll: config.onSelectAll,
			onSelectSelectable: config.onSelectSelectable,
			selectedSelectables: config.selectedSelectables,
			toColumnData: function (row) {
				return {
					body: $elm$core$Maybe$Nothing,
					header: row.emailMessage.subject,
					ignorable: $author$project$Components$Dashboard$Pager$Selectable$EmailMessage(row.emailMessage.id),
					labels: row.emailMessage.labels,
					pathData: pathData(row),
					redirectTo: row.redirectTo,
					subheader: $elm$core$Maybe$Nothing
				};
			}
		});
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[subjectLine, email]),
				dateColumns,
				_List_fromArray(
				[carrier, pageCount])
			]));
};
var $author$project$Components$Dashboard$ExceptionedRow$View$viewV3Reskin = function (config) {
	var showSubject = function (row) {
		var _v5 = row.ownerData.loadId;
		if (_v5.$ === 'Just') {
			return false;
		} else {
			return !$elm$core$String$isEmpty(row.ownerData.subject);
		}
	};
	var exceptionsAndNotes = {
		attrs: _List_Nil,
		content: function (_v4) {
			var row = _v4.a;
			return A3($author$project$Components$Dashboard$ExceptionedRowSummary$viewV3Reskin, row.ownerData.exceptionSummary, config.accountSettings.auditBillingEnabled, row.exceptionedItem.note);
		},
		heading: $elm$html$Html$text('Exceptions and notes')
	};
	var displayIdText = function (row) {
		var _v3 = row.ownerData.loadDisplayId;
		if (_v3.$ === 'Just') {
			var displayId_ = _v3.a;
			return $elm$core$Maybe$Just(displayId_.label + (': ' + displayId_.identifier));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var secondaryLoadFieldText = function (row) {
		return showSubject(row) ? $elm$core$Maybe$Just(row.ownerData.subject) : displayIdText(row);
	};
	var loadSubjectLine = $author$project$Components$Dashboard$DashboardRow$View$viewLoadOrSubjectColumn(
		{
			accountSettings: config.accountSettings,
			areAllSelected: config.areAllSelected,
			columnHeading: _Utils_eq(config.dashboardMode, $author$project$AuditPb$DashboardModeAudit) ? 'Load' : 'Load / Subject line',
			dashboardPresence: config.dashboardPresence,
			onSelectAll: config.onSelectAll,
			onSelectSelectable: config.onSelectSelectable,
			selectedSelectables: config.selectedSelectables,
			toColumnData: function (_v2) {
				var row = _v2.a;
				return {
					body: secondaryLoadFieldText(row),
					header: A2($elm$core$Maybe$withDefault, 'Unknown', row.ownerData.loadId),
					ignorable: $author$project$Domain$ExceptionedItem$toSelectable(row.exceptionedItem.id),
					labels: row.ownerData.labels,
					pathData: _List_Nil,
					redirectTo: row.ownerData.redirectTo,
					subheader: $elm$core$Maybe$Nothing
				};
			}
		});
	var dateColumns = A2(
		$author$project$Components$Dashboard$QueueDateInfo$tableColumns,
		config,
		A2(
			$elm$core$List$map,
			function (f) {
				return f(config.accountSettings);
			},
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2($author$project$Components$Dashboard$ExceptionedRow$View$getLazyQueueDateInfosAndColumns, config.dashboardMode, config.queue))));
	var customer = {
		attrs: _List_Nil,
		content: function (_v1) {
			var row = _v1.a;
			return A2($author$project$Components$Dashboard$RowHelper$customerInformationAreaV3Reskin, config.accountSettings, row.ownerData.customers);
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$customerTerm(config.accountType))
	};
	var carrier = {
		attrs: _List_Nil,
		content: function (_v0) {
			var row = _v0.a;
			return A2($author$project$Components$Dashboard$RowHelper$maybeTmsCarrierNameV3Reskin, config.accountType, row.ownerData.tmsCarrierData);
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$carrierTerm(config.accountType))
	};
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[loadSubjectLine, carrier, customer]),
				dateColumns,
				_List_fromArray(
				[exceptionsAndNotes])
			]));
};
var $author$project$Ui$V3$UtilityButton$Badge = function (a) {
	return {$: 'Badge', a: a};
};
var $author$project$Ui$V3$UtilityButton$badge = $author$project$Ui$V3$UtilityButton$Badge;
var $author$project$Ui$V3$Table$WithDecoder = function (a) {
	return {$: 'WithDecoder', a: a};
};
var $author$project$Ui$V3$Table$clickableWithDecoder = function (_v0) {
	var onClick = _v0.onClick;
	return $author$project$Ui$V3$Table$OnClickAttribute(
		$author$project$Ui$V3$Table$WithDecoder(onClick));
};
var $author$project$Ui$V3$Icon$filter16 = $author$project$Ui$V3$Icon$Icon16(
	A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth('0.1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.2201 2.3867C15.3844 2.16245 15.4832 1.89695 15.5054 1.61981C15.5276 1.34268 15.4724 1.06482 15.3458 0.817268C15.2193 0.569713 15.0264 0.362198 14.7888 0.217889C14.5512 0.0735796 14.2781 -0.00184513 14.0001 3.42844e-05H2.00007C1.72334 0.00208673 1.45252 0.0803156 1.21732 0.226139C0.982122 0.371963 0.791628 0.579748 0.666737 0.826701C0.541669 1.07036 0.486667 1.34395 0.507853 1.61702C0.529039 1.89008 0.625582 2.15191 0.786737 2.37337L5.52007 9.15337V14.4867C5.51848 14.6956 5.56037 14.9026 5.64306 15.0945C5.72576 15.2864 5.84746 15.4589 6.00044 15.6013C6.15342 15.7436 6.33432 15.8525 6.53166 15.9212C6.729 15.9898 6.93846 16.0167 7.14674 16C7.51444 16.0096 7.87735 15.9149 8.1934 15.7267L9.84007 14.7C10.0256 14.5596 10.1763 14.3783 10.2803 14.1702C10.3844 13.962 10.439 13.7327 10.4401 13.5V9.16003L15.2201 2.3867ZM8.92674 8.3867C8.82651 8.52664 8.77287 8.69457 8.7734 8.8667V13.1867C8.77374 13.2442 8.75918 13.3009 8.73114 13.3511C8.7031 13.4013 8.66254 13.4435 8.6134 13.4734L7.6734 14.0267C7.62273 14.056 7.56525 14.0714 7.50674 14.0714C7.44822 14.0714 7.39074 14.056 7.34007 14.0267C7.28969 13.9976 7.2478 13.9559 7.21856 13.9056C7.18932 13.8553 7.17375 13.7982 7.1734 13.74V8.89337C7.17407 8.7243 7.12288 8.5591 7.02674 8.42003L2.66674 2.19337C2.63564 2.1409 2.61924 2.08103 2.61924 2.02003C2.61924 1.95904 2.63564 1.89917 2.66674 1.8467C2.69515 1.79184 2.73825 1.74596 2.79122 1.71418C2.8442 1.68239 2.90496 1.66596 2.96674 1.6667H13.0401C13.1018 1.66596 13.1626 1.68239 13.2156 1.71418C13.2686 1.74596 13.3117 1.79184 13.3401 1.8467C13.3712 1.89917 13.3876 1.95904 13.3876 2.02003C13.3876 2.08103 13.3712 2.1409 13.3401 2.19337L8.92674 8.3867Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('0.1')
					]),
				_List_Nil)
			])));
var $author$project$Components$Dashboard$Pager$View$pagerContextEmptyMessageV3Reskin = function (config) {
	var _v0 = _Utils_Tuple2(config.activeFilterType, config.debtorSearchSupported);
	_v0$2:
	while (true) {
		switch (_v0.a.$) {
			case 'NoFiltersActive':
				var _v1 = _v0.a;
				return $author$project$Ui$V3$Table$defaultEmptyContent(
					{body: $elm$core$Maybe$Nothing, header: 'This queue is empty'});
			case 'DebtorFilterActive':
				if (!_v0.b) {
					var _v2 = _v0.a;
					return $author$project$Ui$V3$Table$defaultEmptyContent(
						{body: $elm$core$Maybe$Nothing, header: 'Debtor search is not available in this queue'});
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $author$project$Ui$V3$Table$defaultEmptyContent(
		{
			body: $elm$core$Maybe$Just('There are no results that match these filters'),
			header: 'No results'
		});
};
var $author$project$Ui$V3$Table$toolbarPagination = function (_v0) {
	var currentPage = _v0.currentPage;
	var dropdown = _v0.dropdown;
	var updatePageMsg = _v0.updatePageMsg;
	return $author$project$Ui$V3$Table$ToolbarItem(
		A3($author$project$Ui$V3$Pagination$view, updatePageMsg, dropdown, currentPage));
};
var $author$project$Components$Dashboard$Pager$View$viewV3Reskin = function (config) {
	var numFiltersBadge = (config.numFiltersApplied > 0) ? _List_fromArray(
		[
			$author$project$Ui$V3$UtilityButton$badge(
			{count: config.numFiltersApplied, size: $author$project$Ui$V3$Badge$DefaultSize, style: $author$project$Ui$V3$Badge$AlertStyle, text: ''})
		]) : _List_Nil;
	var toggleFiltersBtn = _Utils_Tuple2(
		$author$project$Ui$V3$Stack$fit,
		$author$project$Ui$V3$Table$toolbarCustomHtml(
			A2(
				$author$project$Ui$V3$UtilityButton$view,
				{
					icon: $author$project$Ui$V3$Icon$filter16,
					label: config.showFilters ? 'Hide filters' : 'Show filters',
					onClick: config.toggleFiltersMsg
				},
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Ui$V3$UtilityButton$showLabel(true),
							$author$project$Ui$V3$UtilityButton$sizeSmall
						]),
					numFiltersBadge))));
	var mergeBtnText = (!config.numSelected) ? 'Merge' : ('Merge ' + A2(
		$author$project$Helpers$String$pluralize,
		{many: 'emails', one: 'email'},
		config.numSelected));
	var maybePreferredFiltersBtn = A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
		A2($elm$core$Maybe$map, $author$project$Ui$V3$Table$toolbarCustomHtml, config.maybePreferredFiltersBtn));
	var maybeMergeBtn = function () {
		if (config.mergeBtnVisible) {
			var buttonElement = A3(
				$author$project$Ui$V3$Button$view,
				{
					action: $author$project$Ui$V3$Button$onClick(config.mergeMsg)
				},
				_List_fromArray(
					[
						$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
						$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
						$author$project$Ui$V3$Button$disabled(
						!_Utils_eq(config.mergeDisabledReason, $elm$core$Maybe$Nothing))
					]),
				mergeBtnText);
			var wrappedButton = function () {
				var _v5 = config.mergeDisabledReason;
				if (_v5.$ === 'Just') {
					var reason = _v5.a;
					return A3(
						$author$project$Ui$V3$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$V3$Tooltip$tooltipDirection($author$project$Ui$V3$Tooltip$AboveDirection),
								$author$project$Ui$V3$Tooltip$tooltipLocation($author$project$Ui$V3$Tooltip$MiddleLocation),
								A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'left', '50%'),
								A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'transform', 'translateX(-50%) translateY(calc(-100% - 5px))'),
								A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'max-width', '200px'),
								A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'white-space', 'normal'),
								A2($author$project$Ui$V3$Tooltip$tooltipStyle, 'width', 'max-content')
							]),
						reason,
						buttonElement);
				} else {
					return buttonElement;
				}
			}();
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$author$project$Ui$V3$Table$toolbarCustomHtml(wrappedButton)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var maybeFlowModeBtn = config.flowModeBtnVisible ? $elm$core$Maybe$Just(
		_Utils_Tuple2(
			$author$project$Ui$V3$Stack$fit,
			$author$project$Ui$V3$Table$toolbarCustomHtml(
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(config.flowModeMsg)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
							$author$project$Ui$V3$Button$disabled(config.flowModeBtnDisabled)
						]),
					'Flow mode')))) : $elm$core$Maybe$Nothing;
	var maybeApprovePayBtn = A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$pair($author$project$Ui$V3$Stack$fit),
		A2($elm$core$Maybe$map, $author$project$Ui$V3$Table$toolbarCustomHtml, config.maybeApprovePayBtn));
	var ignoreBtnText = (!config.numSelected) ? 'Ignore' : ('Ignore ' + A2(
		$author$project$Helpers$String$pluralize,
		{many: 'items', one: 'item'},
		config.numSelected));
	var maybeIgnoreBtn = config.ignoreBtnVisible ? $elm$core$Maybe$Just(
		_Utils_Tuple2(
			$author$project$Ui$V3$Stack$fit,
			$author$project$Ui$V3$Table$toolbarCustomHtml(
				A3(
					$author$project$Ui$V3$Button$view,
					{
						action: $author$project$Ui$V3$Button$onClick(config.ignoreMsg)
					},
					_List_fromArray(
						[
							$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
							$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
							$author$project$Ui$V3$Button$disabled(!config.numSelected)
						]),
					ignoreBtnText)))) : $elm$core$Maybe$Nothing;
	var headerHeight = 50;
	var filteredRemotePage = function () {
		var _v4 = config.hider;
		if (_v4.$ === 'Just') {
			var pathGetter = _v4.a.pathGetter;
			var dashboardPresence = _v4.a.dashboardPresence;
			return A2(
				$author$project$Forward$Remote$map,
				$author$project$Pagination$mapEntries(
					function (rows) {
						return A3(
							$author$project$Components$Dashboard$Pager$View$filteredRows,
							rows,
							dashboardPresence,
							$elm$core$Maybe$map(pathGetter));
					}),
				config.remotePage);
		} else {
			return config.remotePage;
		}
	}();
	var _v0 = function () {
		if (filteredRemotePage.$ === 'Loaded') {
			var page = filteredRemotePage.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					{currentPage: page, dropdown: $author$project$Ui$V3$Pagination$None, updatePageMsg: config.updatePage}),
				54);
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
		}
	}();
	var maybePagination = _v0.a;
	var paginationHeight = _v0.b;
	var toolbarItems = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				maybeFlowModeBtn,
				maybeApprovePayBtn,
				maybeIgnoreBtn,
				maybeMergeBtn,
				$elm$core$Maybe$Just(
				_Utils_Tuple2($author$project$Ui$V3$Stack$flex1, $author$project$Ui$V3$Table$toolbarEmpty)),
				A2(
				$elm$core$Maybe$map,
				function (pagination) {
					return _Utils_Tuple2(
						$author$project$Ui$V3$Stack$fit,
						$author$project$Ui$V3$Table$toolbarPagination(pagination));
				},
				maybePagination),
				maybePreferredFiltersBtn,
				$elm$core$Maybe$Just(toggleFiltersBtn)
			]));
	var tableMinHeight = function () {
		var _v3 = config.tableElement;
		if (_v3.$ === 'Just') {
			var element = _v3.a.element;
			var viewport = _v3.a.viewport;
			return $elm$core$Basics$round((((viewport.height - element.y) - 32) - headerHeight) - paginationHeight);
		} else {
			return 400;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id($author$project$Components$Dashboard$Pager$View$tableId)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$V3$Table$viewRemotes,
				{columns: config.columns, rowHeight: 83},
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Ui$V3$Table$toolbarItems(toolbarItems),
							$author$project$Ui$V3$Table$headCellAttrs(
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '0 15px'),
									A2(
									$elm$html$Html$Attributes$style,
									'height',
									$author$project$Ui$V3$Helpers$Html$px(headerHeight)),
									A2($elm$html$Html$Attributes$style, 'line-height', '12px')
								])),
							$author$project$Ui$V3$Table$minHeight(tableMinHeight),
							$author$project$Ui$V3$Table$fillHeight,
							$author$project$Components$Dashboard$Pager$View$pagerContextEmptyMessageV3Reskin(config),
							function () {
							var _v2 = config.onRowClick;
							var onClick = _v2.a;
							return $author$project$Ui$V3$Table$clickableWithDecoder(
								{onClick: onClick});
						}(),
							$author$project$Ui$V3$Table$drawer(
							{
								content: A2(
									$author$project$Ui$V3$Stack$viewVertWithHeights,
									_List_fromArray(
										[
											A2($author$project$Ui$V3$Stack$style, 'height', '100%')
										]),
									_List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$Ui$V3$Stack$fit,
											A2(
												$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
												_List_fromArray(
													[
														$author$project$Ui$V3$Stack$mainAxisSpaceBetween,
														$author$project$Ui$V3$Stack$crossAxisCenter,
														$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
														A2($author$project$Ui$V3$Stack$style, 'border-bottom', '1px solid var(--color-gray-200)'),
														A2($author$project$Ui$V3$Stack$style, 'padding', '0 14px'),
														A2(
														$author$project$Ui$V3$Stack$style,
														'height',
														$author$project$Ui$V3$Helpers$Html$px(headerHeight))
													]),
												_List_fromArray(
													[
														_Utils_Tuple2(
														$author$project$Ui$V3$Stack$flex1,
														$elm$core$Maybe$Just(
															A2($author$project$Ui$V3$Typography$xSmallBodySemiBold, _List_Nil, 'Filters'))),
														_Utils_Tuple2(
														$author$project$Ui$V3$Stack$fit,
														A2(
															$elm$core$Maybe$map,
															function (saveFiltersMsg) {
																return A3(
																	$author$project$Ui$V3$Button$view,
																	{
																		action: $author$project$Ui$V3$Button$onClick(saveFiltersMsg)
																	},
																	_List_fromArray(
																		[
																			$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantTertiary),
																			$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium),
																			A2($author$project$Ui$V3$Button$cssStyle, 'padding', '0')
																		]),
																	'Save');
															},
															config.saveFiltersMsg)),
														_Utils_Tuple2(
														$author$project$Ui$V3$Stack$fit,
														A2(
															$elm$core$Maybe$map,
															function (clearFiltersMsg) {
																return A3(
																	$author$project$Ui$V3$Button$view,
																	{
																		action: $author$project$Ui$V3$Button$onClick(clearFiltersMsg)
																	},
																	_List_fromArray(
																		[
																			$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary),
																			$author$project$Ui$V3$Button$buttonSize($author$project$Ui$V3$Button$SizeMedium)
																		]),
																	'Clear');
															},
															config.clearFiltersMsg))
													]))),
											_Utils_Tuple2(
											$author$project$Ui$V3$Stack$flex1,
											A2(
												$author$project$Ui$V3$Stack$viewVert,
												_List_fromArray(
													[
														$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceXSmall),
														$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall)
													]),
												config.filters))
										])),
								isOpen: config.showFilters
							})
						]),
					$elm_community$maybe_extra$Maybe$Extra$toList(
						A2($elm$core$Maybe$map, $author$project$Ui$V3$Table$pagination, maybePagination))),
				A2($author$project$Forward$Remote$map, $author$project$Pagination$entries, filteredRemotePage))
			]));
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPiecesV3Reskin = function (address) {
	var postalCode = A2($elm$core$Maybe$withDefault, '', address.postalCode);
	var dontDisplayAmerica = function (countryField) {
		_v0$2:
		while (true) {
			if (countryField.$ === 'Just') {
				switch (countryField.a) {
					case 'US':
						return $elm$core$Maybe$Nothing;
					case 'USA':
						return $elm$core$Maybe$Nothing;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return countryField;
	};
	var country = A2(
		$elm$core$Maybe$withDefault,
		'',
		dontDisplayAmerica(address.country));
	var cityState = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[address.city, address.state])));
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[cityState, postalCode, country])));
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$displayAddressV3Reskin = function (address) {
	return A2(
		$author$project$Ui$V3$Stack$viewVert,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$elm$html$Html$text,
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				A2(
					$elm$core$List$map,
					$elm$core$String$trim,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(address.name),
								address.addressLine1,
								address.addressLine2,
								$elm$core$Maybe$Just(
								$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$addressPiecesV3Reskin(address))
							]))))));
};
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$noAddressFoundV3Reskin = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('No payment address found.')
		]));
var $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$viewV3Reskin = function (config) {
	var payTo = {
		attrs: _List_Nil,
		content: function (row) {
			return row.payViaTriumphPay ? $elm$html$Html$text('Pay via TriumphPay') : A2(
				$elm$core$Maybe$withDefault,
				$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$noAddressFoundV3Reskin,
				A2($elm$core$Maybe$map, $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$displayAddressV3Reskin, row.paymentAddress));
		},
		heading: $elm$html$Html$text('Pay to')
	};
	var loadId = {
		attrs: _List_Nil,
		content: function (row) {
			var rowRedirectTo = $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$redirectTo(row);
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$author$project$Path$toString(rowRedirectTo)),
						A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline'),
						A2(
						$elm$html$Html$Events$custom,
						'click',
						$elm$json$Json$Decode$succeed(
							{
								message: config.onLoadClick(rowRedirectTo),
								preventDefault: true,
								stopPropagation: true
							}))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(row.loadId)
					]));
		},
		heading: $elm$html$Html$text('Load')
	};
	var invoiceNum = {
		attrs: _List_Nil,
		content: function (row) {
			return $elm$html$Html$text(
				A2($elm$core$Maybe$withDefault, '', row.invoiceNumber));
		},
		heading: $elm$html$Html$text('Invoice')
	};
	var dateColumns = A2($author$project$Components$Dashboard$QueueDateInfo$tableColumns, config, $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$getQueueDateInfosAndColumns);
	var customer = {
		attrs: _List_Nil,
		content: function (row) {
			return A2($author$project$Components$Dashboard$RowHelper$customerInformationAreaV3Reskin, config.accountSettings, row.customers);
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$customerTerm($author$project$Domain$Account$BrokerAccount))
	};
	var checkbox = {
		attrs: _List_Nil,
		content: function (row) {
			return A2(
				$author$project$Ui$V3$Checkbox$view,
				{
					checked: A2($author$project$Id$Set$member, row.carrierInvoiceId, config.selectedCarrierInvoiceIds),
					label: $elm$html$Html$text(''),
					onCheck: $elm$core$Basics$always(
						config.onBrokerRowMsg(
							$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$ToggleSelection(row.carrierInvoiceId)))
				},
				_List_fromArray(
					[$author$project$Ui$V3$Checkbox$stopPropagation]));
		},
		heading: A2(
			$author$project$Ui$V3$Checkbox$view,
			{
				checked: config.areAllSelected,
				label: $elm$html$Html$text(''),
				onCheck: $elm$core$Basics$always(config.onSelectAll)
			},
			_List_Nil)
	};
	var carrier = {
		attrs: _List_Nil,
		content: function (row) {
			return A2(
				$author$project$Ui$V3$Stack$viewVertMaybes,
				_List_fromArray(
					[
						$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
					]),
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2($author$project$Components$Dashboard$RowHelper$tmsCarrierNameV3Reskin, $author$project$Domain$Account$BrokerAccount, row.tmsCarrier)),
						$author$project$Components$Dashboard$DashboardRow$View$viewLabelsV3Reskin(row.labels)
					]));
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$carrierTerm($author$project$Domain$Account$BrokerAccount))
	};
	var amount = {
		attrs: _List_Nil,
		content: function (row) {
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'No amount found',
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Money$castFromString, $author$project$Money$toString),
						row.amountToPay)));
		},
		heading: $elm$html$Html$text('Amount')
	};
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[checkbox, carrier, customer, loadId, invoiceNum, amount]),
				dateColumns,
				_List_fromArray(
				[payTo])
			]));
};
var $author$project$Components$Dashboard$ReplyRow$viewV3Reskin = function (config) {
	var pageCount = {
		attrs: _List_Nil,
		content: function (row) {
			return A8(
				$author$project$Components$Dashboard$DashboardRow$View$viewMessageActionAreaV3Reskin,
				config.onSkipAsynchronousEmailReview,
				config.onGoToReview,
				row.emailMessage.importState,
				$elm$core$Maybe$Nothing,
				row.maybeDocumentBatch,
				false,
				row.emailMessage.id,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.id;
					},
					row.maybeDocumentBatch));
		},
		heading: A2(
			$author$project$Ui$V3$Stack$viewHorzWithWidths,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$html$Html$text('Page')),
					_Utils_Tuple2(
					$author$project$Ui$V3$Stack$fit,
					$elm$html$Html$text('count'))
				]))
	};
	var loadSubjectLine = $author$project$Components$Dashboard$DashboardRow$View$viewLoadOrSubjectColumn(
		{
			accountSettings: config.accountSettings,
			areAllSelected: config.areAllSelected,
			columnHeading: 'Subject and sender',
			dashboardPresence: config.dashboardPresence,
			onSelectAll: config.onSelectAll,
			onSelectSelectable: config.onSelectSelectable,
			selectedSelectables: config.selectedSelectables,
			toColumnData: function (row) {
				return {
					body: $elm$core$Maybe$Nothing,
					header: row.emailMessage.subject,
					ignorable: $author$project$Components$Dashboard$Pager$Selectable$EmailMessage(row.emailMessage.id),
					labels: row.emailMessage.labels,
					pathData: _List_Nil,
					redirectTo: row.redirectTo,
					subheader: $elm$core$Maybe$Just(row.emailMessage.senderAddress)
				};
			}
		});
	var getNotes = function (row) {
		var _v0 = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.note;
			},
			row.exceptionedItems);
		if (!_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var notes = _v0;
			return $elm$core$Maybe$Just(
				A2($elm$core$String$join, ' ', notes));
		}
	};
	var exceptionsAndNotes = {
		attrs: _List_Nil,
		content: function (row) {
			return A3(
				$author$project$Components$Dashboard$ExceptionedRowSummary$viewV3Reskin,
				row.exceptionSummary,
				config.accountSettings.auditBillingEnabled,
				getNotes(row));
		},
		heading: $elm$html$Html$text('Exceptions and notes')
	};
	var dateColumns = A2($author$project$Components$Dashboard$QueueDateInfo$tableColumns, config, $author$project$Components$Dashboard$ReplyRow$getQueueDateInfosAndColumns);
	var customer = {
		attrs: _List_Nil,
		content: function (row) {
			return A2($author$project$Components$Dashboard$RowHelper$customerInformationArea, config.accountSettings, row.customers);
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$customerTerm(config.accountType))
	};
	var carrier = {
		attrs: _List_Nil,
		content: function (row) {
			return $elm$html$Html$text(
				A2(
					$author$project$Components$Dashboard$RowHelper$maybeTmsCarrierName,
					config.accountType,
					{singleCarrier: row.emailMessage.singleCarrier, tmsCarrier: row.maybeTmsCarrier}));
		},
		heading: $elm$html$Html$text(
			$author$project$Domain$Account$carrierTerm(config.accountType))
	};
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[loadSubjectLine, carrier, customer]),
				dateColumns,
				_List_fromArray(
				[pageCount, exceptionsAndNotes])
			]));
};
var $author$project$Components$DashboardPage$viewPagerV3Reskin = F4(
	function (tz, data, model, remoteDashboardRows) {
		var viewItemTypeByButtonClick = F2(
			function (path, clickData) {
				return (!clickData.button) ? ((clickData.metaKey || clickData.ctrlKey) ? $author$project$Components$DashboardPage$ViewItemNewTab(path) : $author$project$Components$DashboardPage$ViewItem(path)) : $author$project$Components$DashboardPage$NoOp;
			});
		var savedFilterIsSelected = function (dashboardSavedFilterData) {
			return A2(
				$author$project$Domain$DashboardSavedFilter$isSelected,
				{currentFilter: model.dashboardFilters, currentMode: model.dashboardMode},
				dashboardSavedFilterData.dashboardSavedFilter);
		};
		var selectedDashboardSavedFilterData = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				savedFilterIsSelected,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Forward$Remote$toMaybe(data.dashboardSavedFilters))));
		var onClickHandler = function (config) {
			return function (remoteRow) {
				var _v17 = _Utils_Tuple3(remoteRow, config.onRowClickOverride, config.pathGetter);
				_v17$2:
				while (true) {
					if (_v17.a.$ === 'Loaded') {
						if (_v17.b.$ === 'Just') {
							var row = _v17.a.a;
							var override = _v17.b.a;
							return $elm$json$Json$Decode$succeed(
								override(row));
						} else {
							if (_v17.c.$ === 'Just') {
								var row = _v17.a.a;
								var _v18 = _v17.b;
								var pathGetter = _v17.c.a;
								return A2(
									$elm$json$Json$Decode$map,
									viewItemTypeByButtonClick(
										pathGetter(row)),
									$author$project$Decode$ClickData$clickDataDecoder);
							} else {
								break _v17$2;
							}
						}
					} else {
						break _v17$2;
					}
				}
				return $elm$json$Json$Decode$succeed($author$project$Components$DashboardPage$NoOp);
			};
		};
		var hideSaveFiltersBtn = A2(
			$elm$core$List$any,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					!_Utils_eq(selectedDashboardSavedFilterData, $elm$core$Maybe$Nothing),
					model.dashboardSavedFilterRefreshing,
					A2($author$project$Domain$DashboardFilters$isEmpty, model.dashboardMode, model.dashboardFilters),
					!data.accountSettings.savedFilterEnhancementsEnabled
				]));
		var hideIfOthersPresent = A3($author$project$Components$DashboardPage$shouldHideIfOthersPresent, data.accountSettings, data.currentUser, model);
		var currentSortByName = A3($author$project$Components$Dashboard$QueueDateInfoHelper$applyFallbackQueueDatesForDashboardFilters, model.dashboardMode, model.selectedQueue, model.dashboardFilters).dashboardSortBy.name;
		var currentSortBy = function (sortBy) {
			return _Utils_update(
				sortBy,
				{name: currentSortByName});
		}(model.dashboardFilters.dashboardSortBy);
		var badState = $author$project$Forward$Remote$Error(
			$author$project$Forward$Remote$Unloadable('bad state'));
		var activeFilterType = $author$project$Domain$DashboardFilters$activeFilterType(model.dashboardFilters);
		var pagerView = function (config) {
			return $author$project$Components$Dashboard$Pager$View$viewV3Reskin(
				{
					activeFilterType: activeFilterType,
					clearFiltersMsg: ($author$project$Domain$DashboardFilters$numFiltersApplied(model.dashboardFilters) > 0) ? $elm$core$Maybe$Just($author$project$Components$DashboardPage$ClearAllFilters) : $elm$core$Maybe$Nothing,
					columns: config.columns,
					debtorSearchSupported: config.debtorSearchSupported,
					filters: A3($author$project$Components$DashboardPage$viewFilters, tz, data, model),
					flowModeBtnDisabled: A2(
						$elm$core$Maybe$withDefault,
						true,
						$author$project$Forward$Remote$toMaybe(
							A2(
								$author$project$Forward$Remote$map,
								A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$flowModeItems, $elm$core$List$isEmpty),
								remoteDashboardRows))),
					flowModeBtnVisible: A3($author$project$Components$Dashboard$AvailableQueues$supportsFlowMode, model.selectedQueue, model.dashboardMode, data.accountSettings),
					flowModeMsg: $author$project$Components$DashboardPage$EnableFlowMode,
					hider: function () {
						var _v16 = _Utils_Tuple2(hideIfOthersPresent, config.pathGetter);
						if (_v16.a && (_v16.b.$ === 'Just')) {
							var pathGetter = _v16.b.a;
							return $elm$core$Maybe$Just(
								{dashboardPresence: model.dashboardPresence, pathGetter: pathGetter});
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}(),
					ignoreBtnVisible: A2($author$project$Components$DashboardPage$ignoreButtonVisibleV3Reskin, model.selectedQueue, data.accountSettings),
					ignoreMsg: $author$project$Components$DashboardPage$ShowIgnoreModal,
					maybeApprovePayBtn: config.maybeApprovePayBtn,
					maybePreferredFiltersBtn: A3($author$project$Components$DashboardPage$viewPreferredFilter, data.accountSettings, data.currentUser, model.dashboardFilters),
					mergeBtnVisible: A2($author$project$Components$DashboardPage$mergeButtonVisibleV3Reskin, model.selectedQueue, data.account),
					mergeDisabledReason: A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$DashboardPage$mergeButtonDisabledReason(model.selectedSelectables),
						$author$project$Forward$Remote$toMaybe(remoteDashboardRows)),
					mergeMsg: $author$project$Components$DashboardPage$ShowMergeModal,
					numFiltersApplied: $author$project$Domain$DashboardFilters$numFiltersApplied(model.dashboardFilters),
					numSelected: config.numSelected,
					onRowClick: $author$project$Components$Dashboard$Pager$View$WithDecoder(
						onClickHandler(config)),
					remotePage: config.remotePage,
					saveFiltersMsg: hideSaveFiltersBtn ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$DashboardPage$DashboardSavedFilterSaving),
					showFilters: model.showFilters,
					tableElement: model.tableElement,
					toggleFiltersMsg: $author$project$Components$DashboardPage$ToggleFilters,
					updatePage: $author$project$Components$DashboardPage$PagerTo
				});
		};
		var accountType = $author$project$Domain$Account$accountType(data.account);
		var _v0 = model.selectedQueue;
		switch (_v0.$) {
			case 'NewQueue':
				return pagerView(
					{
						columns: $author$project$Components$Dashboard$EmailRow$View$viewV3Reskin(
							{
								accountSettings: data.accountSettings,
								accountType: accountType,
								areAllSelected: model.selectAllVisible,
								currentSortBy: currentSortBy,
								dashboardPresence: model.dashboardPresence,
								onGoToReview: data.currentUser.isManagedIndexer ? $elm$core$Maybe$Just($author$project$Components$DashboardPage$GoToReview) : $elm$core$Maybe$Nothing,
								onSelectAll: $author$project$Components$DashboardPage$ToggleSelectAllVisible,
								onSelectSelectable: $elm$core$Maybe$Just($author$project$Components$DashboardPage$SelectSelectable),
								onSkipAsynchronousEmailReview: $author$project$Components$DashboardPage$maybeSkipAsynchronousEmailReview(data.currentUser),
								onSortBy: $author$project$Components$DashboardPage$SetSortBy,
								selectedSelectables: model.selectedSelectables,
								tz: tz
							}),
						debtorSearchSupported: false,
						maybeApprovePayBtn: $elm$core$Maybe$Nothing,
						numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
						onRowClickOverride: $elm$core$Maybe$Just(
							function (row) {
								return $author$project$Domain$EmailMessage$importCompleted(row.emailMessage.importState) ? $author$project$Components$DashboardPage$ViewItem(row.redirectTo) : $author$project$Components$DashboardPage$NoOp;
							}),
						pathGetter: $elm$core$Maybe$Just(
							function ($) {
								return $.redirectTo;
							}),
						remotePage: A2(
							$author$project$Forward$Remote$andThen,
							function (dashboardRows) {
								if (dashboardRows.$ === 'NewEmailData') {
									var page = dashboardRows.a;
									return $author$project$Forward$Remote$Loaded(page);
								} else {
									return badState;
								}
							},
							remoteDashboardRows)
					});
			case 'FactorNeedsIndexingQueue':
				return pagerView(
					{
						columns: _List_Nil,
						debtorSearchSupported: false,
						maybeApprovePayBtn: $elm$core$Maybe$Nothing,
						numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
						onRowClickOverride: $elm$core$Maybe$Nothing,
						pathGetter: $elm$core$Maybe$Just(
							function ($) {
								return $.redirectTo;
							}),
						remotePage: A2(
							$author$project$Forward$Remote$andThen,
							function (dashboardRows) {
								if (dashboardRows.$ === 'FactorNeedsIndexingData') {
									var page = dashboardRows.a;
									return $author$project$Forward$Remote$Loaded(page);
								} else {
									return badState;
								}
							},
							remoteDashboardRows)
					});
			case 'ReadyToAuditQueue':
				return pagerView(
					{
						columns: $author$project$Components$Dashboard$CarrierInvoiceRow$View$viewV3Reskin(
							{
								accountSettings: data.accountSettings,
								accountType: accountType,
								areAllSelected: model.selectAllVisible,
								currentDate: model.currentDate,
								currentSortBy: currentSortBy,
								dashboardMode: model.dashboardMode,
								dashboardPresence: model.dashboardPresence,
								onSelectAll: $author$project$Components$DashboardPage$ToggleSelectAllVisible,
								onSelectSelectable: $elm$core$Maybe$Just($author$project$Components$DashboardPage$SelectSelectable),
								onSortBy: $author$project$Components$DashboardPage$SetSortBy,
								queue: model.selectedQueue,
								selectedSelectables: model.selectedSelectables,
								tz: tz
							}),
						debtorSearchSupported: true,
						maybeApprovePayBtn: $elm$core$Maybe$Nothing,
						numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
						onRowClickOverride: $elm$core$Maybe$Nothing,
						pathGetter: $elm$core$Maybe$Just(
							function ($) {
								return $.redirectTo;
							}),
						remotePage: A2(
							$author$project$Forward$Remote$andThen,
							function (dashboardRows) {
								if (dashboardRows.$ === 'ReadyToAuditCarrierInvoiceData') {
									var page = dashboardRows.a;
									return $author$project$Forward$Remote$Loaded(page);
								} else {
									return badState;
								}
							},
							remoteDashboardRows)
					});
			case 'ExceptionQueue':
				return pagerView(
					{
						columns: $author$project$Components$Dashboard$ExceptionedRow$View$viewV3Reskin(
							{
								accountSettings: data.accountSettings,
								accountType: accountType,
								areAllSelected: model.selectAllVisible,
								currentDate: model.currentDate,
								currentSortBy: currentSortBy,
								dashboardMode: model.dashboardMode,
								dashboardPresence: model.dashboardPresence,
								onSelectAll: $author$project$Components$DashboardPage$ToggleSelectAllVisible,
								onSelectSelectable: $elm$core$Maybe$Just($author$project$Components$DashboardPage$SelectSelectable),
								onSortBy: $author$project$Components$DashboardPage$SetSortBy,
								queue: model.selectedQueue,
								selectedSelectables: model.selectedSelectables,
								tz: tz
							}),
						debtorSearchSupported: true,
						maybeApprovePayBtn: $elm$core$Maybe$Nothing,
						numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
						onRowClickOverride: $elm$core$Maybe$Nothing,
						pathGetter: $elm$core$Maybe$Just($author$project$Components$Dashboard$ExceptionedRow$View$ownerDataRedirectTo),
						remotePage: A2(
							$author$project$Forward$Remote$andThen,
							function (dashboardRows) {
								if (dashboardRows.$ === 'UnsentExceptionedData') {
									var page = dashboardRows.a;
									return $author$project$Forward$Remote$Loaded(page);
								} else {
									return badState;
								}
							},
							remoteDashboardRows)
					});
			case 'WaitingQueue':
				return pagerView(
					{
						columns: $author$project$Components$Dashboard$ExceptionedRow$View$viewV3Reskin(
							{
								accountSettings: data.accountSettings,
								accountType: accountType,
								areAllSelected: model.selectAllVisible,
								currentDate: model.currentDate,
								currentSortBy: currentSortBy,
								dashboardMode: model.dashboardMode,
								dashboardPresence: model.dashboardPresence,
								onSelectAll: $author$project$Components$DashboardPage$ToggleSelectAllVisible,
								onSelectSelectable: $elm$core$Maybe$Just($author$project$Components$DashboardPage$SelectSelectable),
								onSortBy: $author$project$Components$DashboardPage$SetSortBy,
								queue: model.selectedQueue,
								selectedSelectables: model.selectedSelectables,
								tz: tz
							}),
						debtorSearchSupported: true,
						maybeApprovePayBtn: $elm$core$Maybe$Nothing,
						numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
						onRowClickOverride: $elm$core$Maybe$Nothing,
						pathGetter: $elm$core$Maybe$Just($author$project$Components$Dashboard$ExceptionedRow$View$ownerDataRedirectTo),
						remotePage: A2(
							$author$project$Forward$Remote$andThen,
							function (dashboardRows) {
								if (dashboardRows.$ === 'UnsentExceptionedData') {
									var page = dashboardRows.a;
									return $author$project$Forward$Remote$Loaded(page);
								} else {
									return badState;
								}
							},
							remoteDashboardRows)
					});
			case 'RepliesQueue':
				return pagerView(
					{
						columns: $author$project$Components$Dashboard$ReplyRow$viewV3Reskin(
							{
								accountSettings: data.accountSettings,
								accountType: accountType,
								areAllSelected: model.selectAllVisible,
								currentSortBy: currentSortBy,
								dashboardPresence: model.dashboardPresence,
								onGoToReview: data.currentUser.isManagedIndexer ? $elm$core$Maybe$Just($author$project$Components$DashboardPage$GoToReview) : $elm$core$Maybe$Nothing,
								onSelectAll: $author$project$Components$DashboardPage$ToggleSelectAllVisible,
								onSelectSelectable: $elm$core$Maybe$Just($author$project$Components$DashboardPage$SelectSelectable),
								onSkipAsynchronousEmailReview: $author$project$Components$DashboardPage$maybeSkipAsynchronousEmailReview(data.currentUser),
								onSortBy: $author$project$Components$DashboardPage$SetSortBy,
								selectedSelectables: model.selectedSelectables,
								tz: tz
							}),
						debtorSearchSupported: false,
						maybeApprovePayBtn: $elm$core$Maybe$Nothing,
						numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
						onRowClickOverride: $elm$core$Maybe$Nothing,
						pathGetter: $elm$core$Maybe$Just(
							function ($) {
								return $.redirectTo;
							}),
						remotePage: A2(
							$author$project$Forward$Remote$andThen,
							function (dashboardRows) {
								if (dashboardRows.$ === 'ReplyEmailData') {
									var page = dashboardRows.a;
									return $author$project$Forward$Remote$Loaded(page);
								} else {
									return badState;
								}
							},
							remoteDashboardRows)
					});
			case 'VerifyQueue':
				return pagerView(
					{
						columns: _List_Nil,
						debtorSearchSupported: true,
						maybeApprovePayBtn: $elm$core$Maybe$Nothing,
						numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
						onRowClickOverride: $elm$core$Maybe$Nothing,
						pathGetter: $elm$core$Maybe$Nothing,
						remotePage: A2(
							$author$project$Forward$Remote$andThen,
							function (dashboardRows) {
								if (dashboardRows.$ === 'VerifyData') {
									var page = dashboardRows.a;
									return $author$project$Forward$Remote$Loaded(page);
								} else {
									return badState;
								}
							},
							remoteDashboardRows)
					});
			default:
				switch (_v0.a.$) {
					case 'ReviewQueue':
						var _v8 = _v0.a;
						return pagerView(
							{
								columns: _List_Nil,
								debtorSearchSupported: true,
								maybeApprovePayBtn: $elm$core$Maybe$Nothing,
								numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
								onRowClickOverride: $elm$core$Maybe$Nothing,
								pathGetter: $elm$core$Maybe$Nothing,
								remotePage: A2(
									$author$project$Forward$Remote$andThen,
									function (dashboardRows) {
										if (dashboardRows.$ === 'ReviewData') {
											var page = dashboardRows.a;
											return $author$project$Forward$Remote$Loaded(page);
										} else {
											return badState;
										}
									},
									remoteDashboardRows)
							});
					case 'ProcessedQueue':
						if (_v0.a.a.$ === 'BrokerAccount') {
							var _v10 = _v0.a.a;
							return pagerView(
								{
									columns: $author$project$Components$Dashboard$Processed$ProcessedBrokerRow$viewV3Reskin(
										{
											accountSettings: data.accountSettings,
											areAllSelected: model.selectAllVisible,
											currentDate: model.currentDate,
											currentSortBy: currentSortBy,
											onBrokerRowMsg: A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ProcessedBrokerRowMsg, $author$project$Components$DashboardPage$ProcessedBrokerMsg),
											onLoadClick: $author$project$Components$DashboardPage$ViewItem,
											onSelectAll: $author$project$Components$DashboardPage$ToggleSelectAllVisible,
											onSortBy: $author$project$Components$DashboardPage$SetSortBy,
											selectedCarrierInvoiceIds: $author$project$Components$Dashboard$Processed$BrokerModel$selectedBrokerInvoiceIdSet(model.processedBrokerModel),
											tz: tz
										}),
									debtorSearchSupported: true,
									maybeApprovePayBtn: A2(
										$elm$core$Maybe$andThen,
										function (dashboardRows) {
											if (dashboardRows.$ === 'ProcessedBrokerData') {
												var brokerData = dashboardRows.a;
												return $elm$core$Maybe$Just(
													A2(
														$elm$html$Html$map,
														A2($elm$core$Basics$composeR, $author$project$Components$DashboardPage$ProcessedBrokerActionAreaMsg, $author$project$Components$DashboardPage$ProcessedBrokerMsg),
														A3(
															$author$project$Components$Dashboard$Processed$ProcessedActionArea$approvePayBtn,
															$author$project$Pagination$entries(
																A2($author$project$Pagination$map, $elm$core$Tuple$first, brokerData)),
															model.sendingState.isProcessingApproval,
															$author$project$Components$Dashboard$Processed$BrokerModel$countSelected(model.processedBrokerModel))));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										},
										$author$project$Forward$Remote$toMaybe(remoteDashboardRows)),
									numSelected: $author$project$Components$Dashboard$Processed$BrokerModel$countSelected(model.processedBrokerModel),
									onRowClickOverride: $elm$core$Maybe$Just(
										function (row) {
											return $author$project$Components$DashboardPage$ProcessedBrokerMsg(
												$author$project$Components$DashboardPage$ProcessedBrokerRowMsg(
													$author$project$Components$Dashboard$Processed$ProcessedBrokerRow$ToggleSelection(row.carrierInvoiceId)));
										}),
									pathGetter: $elm$core$Maybe$Nothing,
									remotePage: A2(
										$author$project$Forward$Remote$andThen,
										function (dashboardRows) {
											if (dashboardRows.$ === 'ProcessedBrokerData') {
												var brokerData = dashboardRows.a;
												return $author$project$Forward$Remote$Loaded(
													A2($author$project$Pagination$map, $elm$core$Tuple$second, brokerData));
											} else {
												return badState;
											}
										},
										remoteDashboardRows)
								});
						} else {
							var _v13 = _v0.a.a;
							return pagerView(
								{
									columns: _List_Nil,
									debtorSearchSupported: true,
									maybeApprovePayBtn: $elm$core$Maybe$Nothing,
									numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
									onRowClickOverride: $elm$core$Maybe$Nothing,
									pathGetter: $elm$core$Maybe$Nothing,
									remotePage: A2(
										$author$project$Forward$Remote$andThen,
										function (dashboardRows) {
											if (dashboardRows.$ === 'ProcessedFactorData') {
												var factorData = dashboardRows.a;
												return $author$project$Forward$Remote$Loaded(
													A2($author$project$Pagination$map, $author$project$Forward$Remote$Loaded, factorData.currentPageData));
											} else {
												return badState;
											}
										},
										remoteDashboardRows)
								});
						}
					default:
						var _v15 = _v0.a;
						return pagerView(
							{
								columns: _List_Nil,
								debtorSearchSupported: true,
								maybeApprovePayBtn: $elm$core$Maybe$Nothing,
								numSelected: $timo_weike$generic_collections$ManualSet$size(model.selectedSelectables),
								onRowClickOverride: $elm$core$Maybe$Nothing,
								pathGetter: $elm$core$Maybe$Nothing,
								remotePage: badState
							});
				}
		}
	});
var $author$project$Components$Dashboard$Menu$queueViewV3Reskin = F7(
	function (accountType, selectedQueue, dashboardMode, msg, numQueues, queueIndex, _v0) {
		var queue = _v0.a;
		var remoteCount = _v0.b;
		var isActive = _Utils_eq(queue, selectedQueue);
		var activeStyles = isActive ? _List_fromArray(
			[
				$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
				A2(
				$author$project$Ui$V3$Stack$style,
				'box-shadow',
				'inset 0 -4px 0 ' + $author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Teal600))
			]) : _List_fromArray(
			[
				$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray50)
			]);
		var _v1 = isActive ? _Utils_Tuple2($author$project$Ui$V3$Colors$Gray900, $author$project$Ui$V3$Colors$Gray600) : _Utils_Tuple2($author$project$Ui$V3$Colors$Gray400, $author$project$Ui$V3$Colors$Gray400);
		var countColor = _v1.a;
		var labelColor = _v1.b;
		var countEl = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'height', '26px')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Ui$V3$Skeleton$viewRemote,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'max-width', '50px')
						]),
					{height: $elm$core$Maybe$Nothing},
					function (count) {
						return A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$author$project$Ui$V3$Colors$colorAttribute(countColor),
									A2($elm$html$Html$Attributes$style, 'line-height', '32px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(count))
								]));
					},
					remoteCount)
				]));
		var label = A2(
			$author$project$Ui$V3$Typography$body,
			_List_fromArray(
				[
					$author$project$Ui$V3$Colors$colorAttribute(labelColor),
					A2($elm$html$Html$Attributes$style, 'line-height', '18px'),
					A2($elm$html$Html$Attributes$style, 'height', '18px')
				]),
			$elm_community$string_extra$String$Extra$toSentenceCase(
				$elm$core$String$toLower(
					A3($author$project$Components$Dashboard$Menu$queueLabel, accountType, dashboardMode, queue))));
		return A2(
			$author$project$Ui$V3$Stack$viewVert,
			_List_fromArray(
				[
					$author$project$Ui$V3$Stack$backgroundColorOnHover($author$project$Ui$V3$Colors$Gray0)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewVert,
					_Utils_ap(
						_List_fromArray(
							[
								A2($author$project$Ui$V3$Stack$paddingVertHorz, $author$project$Ui$V3$Stack$spaceXSmall, $author$project$Ui$V3$Stack$spaceSmall),
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXXXSmall),
								$author$project$Ui$V3$Stack$mainAxisEnd,
								A2(
								$author$project$Ui$V3$Stack$style,
								'border-right',
								_Utils_eq(queueIndex, numQueues - 1) ? '0' : ('1px solid ' + $author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray150))),
								A2($author$project$Ui$V3$Stack$style, 'height', '96px'),
								$author$project$Ui$V3$Stack$onClick(
								msg(queue))
							]),
						activeStyles),
					_List_fromArray(
						[countEl, label]))
				]));
	});
var $author$project$Components$Dashboard$Menu$viewV3Reskin = F4(
	function (selectedQueue, msg, dashboardMode, remoteData) {
		return A2(
			$author$project$Forward$LoadingView$viewV3Reskin,
			function (data) {
				return A2(
					$author$project$Ui$V3$Stack$viewHorz,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$noWrap,
							$author$project$Ui$V3$Stack$backgroundColor($author$project$Ui$V3$Colors$Gray0),
							A2(
							$author$project$Ui$V3$Stack$style,
							'border-bottom',
							'1px solid ' + $author$project$Ui$V3$Colors$cssVariable($author$project$Ui$V3$Colors$Gray150))
						]),
					A2(
						$elm$core$List$indexedMap,
						A5(
							$author$project$Components$Dashboard$Menu$queueViewV3Reskin,
							data.accountType,
							selectedQueue,
							dashboardMode,
							msg,
							$elm$core$List$length(data.queueCounts)),
						data.queueCounts));
			},
			remoteData);
	});
var $author$project$Components$DashboardPage$viewV3Reskin = F3(
	function (tz, remoteData, model) {
		return $author$project$Helpers$Html$v3ReskinContainer(
			A2(
				$author$project$Ui$V3$Stack$viewVert,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$author$project$Components$Dashboard$Menu$viewV3Reskin,
						model.selectedQueue,
						A2($elm$core$Basics$composeL, $author$project$Components$DashboardPage$SelectedQueue, $author$project$Sanitized$raw),
						model.dashboardMode,
						A2(
							$author$project$Forward$Remote$andThen,
							function ($) {
								return $.menuData;
							},
							remoteData)),
						A2(
						$author$project$Forward$LoadingView$viewV3Reskin,
						function (data) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Components$DashboardPage$viewIgnoreModalV3Reskin, data, model),
										A2($author$project$Components$DashboardPage$viewMergeModalV3Reskin, data, model),
										A2($author$project$Components$DashboardPage$viewBulkLabelModal, data, model),
										$author$project$Components$DashboardPage$viewDashboardSavedFilterSaveModalV3Reskin(model),
										A2($author$project$Components$DashboardPage$viewDashboardSavedFilterEditModalV3Reskin, data, model),
										A2(
										$author$project$Ui$V3$Stack$viewVert,
										_List_fromArray(
											[
												A2($author$project$Ui$V3$Stack$paddingVertHorz, $author$project$Ui$V3$Stack$spaceMedium, $author$project$Ui$V3$Stack$spaceResponsiveSmall),
												$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceSmall)
											]),
										_List_fromArray(
											[
												A3($author$project$Components$DashboardPage$viewLabelFilters, model.labelsCollapsed, model.selectedQueue, model.dashboardFilters.labelFilters),
												A4($author$project$Components$DashboardPage$viewPagerV3Reskin, tz, data, model, data.dashboardRows)
											]))
									]));
						},
						remoteData)
					])));
	});
var $author$project$Components$EmailMessageSearchPage$LoadMore = {$: 'LoadMore'};
var $author$project$Components$EmailMessageSearchPage$EmailMessageListView$viewV3Reskin = F5(
	function (tz, model, loadMoreMsg, isLoading, data) {
		var items = $author$project$Stream$value(data.emailMessagesStream);
		var downloadColumn = data.currentUser.isManagedIndexer ? _List_Nil : _List_fromArray(
			[
				{
				attrs: _List_Nil,
				content: function (row) {
					var _v1 = row.emailMessage.importState;
					switch (_v1.$) {
						case 'EmailImportStateImportCompleted':
							var _v2 = row.documentBatch;
							if (_v2.$ === 'Just') {
								var batch = _v2.a;
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(row.emailMessage.attachmentDownloadUrl),
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Download ' + ($elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, 0, batch.pages)) + ' pages'))
										]));
							} else {
								return $elm$html$Html$text('');
							}
						case 'EmailImportStateInPODDetection':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('POD processing')
									]));
						case 'EmailImportStateInDocumentContentReview':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Document Data Extraction processing')
									]));
						case 'EmailImportStateInDocumentContentReviewDocumentType':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Document Type processing')
									]));
						case 'EmailImportStateInDocumentContentReviewNoDependents':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Document Data Extraction processing')
									]));
						case 'EmailImportStateInDocumentBatchGroupingReview':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Document Batch Grouping processing')
									]));
						case 'EmailImportStateInDocumentGroupLoadReview':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Load Reviews processing')
									]));
						case 'EmailImportStateImportFailed':
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Import Failed')
									]));
						default:
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Importing...')
									]));
					}
				},
				heading: $elm$html$Html$text('')
			}
			]);
		var columns = _Utils_ap(
			_List_fromArray(
				[
					{
					attrs: _List_Nil,
					content: function (row) {
						return A2(
							$author$project$Ui$V3$Stack$viewVert,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$V3$Typography$smallBodySemiBold, _List_Nil, row.emailMessage.subject),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray600)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(row.emailMessage.senderAddress)
										]))
								]));
					},
					heading: $elm$html$Html$text('Sender information')
				},
					{
					attrs: _List_Nil,
					content: function (row) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Helpers$Date$toString, tz, row.emailMessage.createdAt))
								]));
					},
					heading: $elm$html$Html$text('Date')
				},
					{
					attrs: _List_Nil,
					content: function (row) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Ui$V3$Colors$colorAttribute($author$project$Ui$V3$Colors$Gray900)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										'Unknown ' + $author$project$Domain$Account$carrierTerm(
											$author$project$Domain$Account$accountType(data.account)),
										function ($) {
											return $.name;
										},
										row.tmsCarrier))
								]));
					},
					heading: $elm$html$Html$text('Carrier')
				}
				]),
			downloadColumn);
		return A3(
			$author$project$Ui$V3$Table$viewRemotes,
			{columns: columns, rowHeight: 67},
			_List_fromArray(
				[
					$author$project$Ui$V3$Table$fillHeight,
					$author$project$Ui$V3$Table$linkableRowAttrs(
					function (row) {
						if (row.$ === 'Loaded') {
							var loadedRow = row.a;
							return $author$project$Domain$EmailMessage$importCompleted(loadedRow.emailMessage.importState) ? $elm$core$Maybe$Just(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										A5(
											$author$project$Helpers$EmailPath$emailPath,
											data.account,
											data.accountSettings,
											data.currentUser,
											loadedRow.emailMessage,
											$elm$url$Url$percentEncode(model.searchUrl)))
									])) : $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}),
					$author$project$Ui$V3$Table$defaultEmptyContent(
					{body: $elm$core$Maybe$Nothing, header: 'No emails found'}),
					$author$project$Ui$V3$Table$loadMore(
					{
						hasMore: $author$project$Stream$hasMore(data.emailMessagesStream),
						onLoadMore: loadMoreMsg,
						rowsToShowWhileLoading: isLoading ? $elm$core$Maybe$Just(items) : $elm$core$Maybe$Nothing
					})
				]),
			$author$project$Forward$Remote$Loaded(items));
	});
var $author$project$Components$EmailMessageSearchPage$FiltersView$viewV3Reskin = F3(
	function (config, data, model) {
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Events$onSubmit(config.onApplyFilters)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$V3$Stack$viewHorzWithWidths,
					_List_fromArray(
						[
							$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
							$author$project$Ui$V3$Stack$crossAxisBottom,
							$author$project$Ui$V3$Stack$class('email-message-search-page__filters--v3-reskin')
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$author$project$Helpers$Html$labeledInput,
								'Search text',
								A2(
									$elm$html$Html$map,
									config.toMsg,
									A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$EmailMessageSearchPage$FiltersView$SelectSearchTerm},
										_List_Nil,
										_List_Nil,
										A2($elm$core$Maybe$withDefault, '', model.selectedSearchTerm))))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$flex1,
							A2(
								$elm$html$Html$map,
								config.toMsg,
								A2(
									$elm$html$Html$map,
									$author$project$Components$EmailMessageSearchPage$FiltersView$CarrierDropdownMsg,
									A3(
										$author$project$Components$SettingsPage$CarrierDropdown$view,
										$author$project$Components$EmailMessageSearchPage$FiltersView$carrierTerm(
											$author$project$Forward$Remote$Loaded(data.account)),
										data.carrierDropdownData,
										model.carrierDropdown)))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fitPx(144),
							A2(
								$author$project$Helpers$Html$labeledInput,
								'Start date',
								A2(
									$elm$html$Html$map,
									config.toMsg,
									A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$EmailMessageSearchPage$FiltersView$SelectStartDate},
										_List_fromArray(
											[$author$project$Ui$V3$Input$date]),
										_List_Nil,
										model.startDateString)))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fitPx(144),
							A2(
								$author$project$Helpers$Html$labeledInput,
								'End date',
								A2(
									$elm$html$Html$map,
									config.toMsg,
									A4(
										$author$project$Ui$V3$Input$view,
										{onInput: $author$project$Components$EmailMessageSearchPage$FiltersView$SelectEndDate},
										_List_fromArray(
											[$author$project$Ui$V3$Input$date]),
										_List_Nil,
										model.endDateString)))),
							_Utils_Tuple2(
							$author$project$Ui$V3$Stack$fit,
							A2(
								$author$project$Ui$V3$Stack$viewHorzWithWidthsMaybes,
								_List_fromArray(
									[
										$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceXSmall),
										$author$project$Ui$V3$Stack$crossAxisCenter
									]),
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										$elm$core$Maybe$Just(
											A2(
												$elm$html$Html$map,
												config.toMsg,
												A2(
													$author$project$Ui$V3$Checkbox$view,
													{
														checked: model.includeSentEmails,
														label: $elm$html$Html$text('Include sent emails'),
														onCheck: $author$project$Components$EmailMessageSearchPage$FiltersView$ChangeSentEmails
													},
													_List_Nil)))),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										$elm$core$Maybe$Just(
											A2(
												$elm$html$Html$map,
												config.toMsg,
												A3(
													$author$project$Ui$V3$Button$view,
													{action: $author$project$Ui$V3$Button$submitForm},
													_List_Nil,
													'Search')))),
										_Utils_Tuple2(
										$author$project$Ui$V3$Stack$fit,
										config.hasFiltersApplied ? $elm$core$Maybe$Just(
											A3(
												$author$project$Ui$V3$Button$view,
												{
													action: $author$project$Ui$V3$Button$onClick(config.onClear)
												},
												_List_fromArray(
													[
														$author$project$Ui$V3$Button$buttonVariant($author$project$Ui$V3$Button$VariantSecondary)
													]),
												'Clear')) : $elm$core$Maybe$Nothing)
									])))
						]))
				]));
	});
var $author$project$Ui$V3$Stack$viewVertWithHeightsMaybes = F2(
	function (attributes, maybesWithHeights) {
		return A2(
			$author$project$Ui$V3$Stack$viewVertWithHeights,
			attributes,
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var height = _v0.a;
					var maybe = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(height),
						maybe);
				},
				maybesWithHeights));
	});
var $author$project$Components$EmailMessageSearchPage$viewV3Reskin = F4(
	function (containerHeight, tz, model, remoteData) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(remoteData, model.maybeLastData);
			_v1$0:
			while (true) {
				if (_v1.b.$ === 'Just') {
					if (_v1.a.$ === 'Loaded') {
						break _v1$0;
					} else {
						var lastData = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Forward$Remote$Loaded(lastData),
							true);
					}
				} else {
					if (_v1.a.$ === 'Loaded') {
						break _v1$0;
					} else {
						var _v2 = _v1.b;
						return _Utils_Tuple2($author$project$Forward$Remote$Loading, true);
					}
				}
			}
			return _Utils_Tuple2(remoteData, false);
		}();
		var viewData = _v0.a;
		var isLoading = _v0.b;
		return A2(
			$author$project$Forward$LoadingView$viewV3Reskin,
			function (data) {
				var filtersView = A3(
					$author$project$Components$EmailMessageSearchPage$FiltersView$viewV3Reskin,
					{
						hasFiltersApplied: !_Utils_eq(model.filtersApplied, $elm$core$Maybe$Nothing),
						onApplyFilters: $author$project$Components$EmailMessageSearchPage$ApplyFilters,
						onClear: $author$project$Components$EmailMessageSearchPage$Clear,
						toMsg: $author$project$Components$EmailMessageSearchPage$FiltersViewMsg
					},
					data.filtersUiState,
					model.filtersUiState);
				return $author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Stack$viewVertWithHeightsMaybes,
						_List_fromArray(
							[
								$author$project$Ui$V3$Stack$padding($author$project$Ui$V3$Stack$spaceMedium),
								$author$project$Ui$V3$Stack$gap($author$project$Ui$V3$Stack$spaceMedium),
								A2(
								$author$project$Ui$V3$Stack$style,
								'height',
								$author$project$Ui$V3$Helpers$Html$px(containerHeight))
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								$elm$core$Maybe$Just(
									A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Email search')
											])))),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$fit,
								$elm$core$Maybe$Just(filtersView)),
								_Utils_Tuple2(
								$author$project$Ui$V3$Stack$flex1,
								A2(
									$elm$core$Maybe$map,
									A4(
										$author$project$Components$EmailMessageSearchPage$EmailMessageListView$viewV3Reskin,
										tz,
										A2($author$project$Components$EmailMessageSearchPage$emailMessageViewModel, true, model),
										$author$project$Components$EmailMessageSearchPage$LoadMore,
										isLoading),
									data.emailMessageListView))
							])));
			},
			viewData);
	});
var $author$project$Main$viewPage = F3(
	function (_v0, model, pd) {
		var indexAudit = _v0.indexAudit;
		var queues = _v0.queues;
		var settings = _v0.settings;
		var topLevel = _v0.topLevel;
		var tz = model.timezone;
		var loadingView = $author$project$Forward$LoadingView$viewV3Reskinnable(topLevel);
		var containerHeight = function () {
			var _v2 = model.headerElement;
			if (_v2.$ === 'Just') {
				var el = _v2.a;
				return $elm$core$Basics$floor(el.viewport.height - (el.element.y + el.element.height));
			} else {
				return -1;
			}
		}();
		switch (pd.$) {
			case 'BlankPageData':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('no-route-matched')
						]),
					_List_Nil);
			case 'LoadingPageData':
				return $author$project$Forward$LoadingView$loadingViewReskinnable(topLevel);
			case 'LoadingFailedPageData':
				var error = pd.a;
				return $author$project$Forward$LoadingView$defaultErrorView(error);
			case 'ActivityPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$ActivityPageMsg,
					A5($author$project$Components$ActivityPage$view, containerHeight, topLevel, tz, pageData, page));
			case 'BrokerBillingRequirementsPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$BrokerBillingRequirementsPageMsg,
					A4($author$project$Broker$Page$BillingRequirements$view, indexAudit, tz, pageData, page));
			case 'ClientSubmissionInvoicePageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$ClientSubmissionInvoicePageMsg,
					A2($author$project$Factoring$Page$ClientSubmissionInvoice$view, pageData, page));
			case 'ClientSubmissionPageData':
				var page = pd.a;
				return $author$project$Factoring$Page$ClientSubmission$view(page);
			case 'ClientSubmissionReviewPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$ClientSubmissionReviewPageMsg,
					A2($author$project$Factoring$Page$ClientSubmissionReview$view, pageData, page));
			case 'DashboardPageData':
				var page = pd.a;
				var pageData = pd.b;
				return queues ? A2(
					$elm$html$Html$map,
					$author$project$Main$DashboardPageMsg,
					A3($author$project$Components$DashboardPage$viewV3Reskin, tz, pageData, page)) : A2(
					$elm$html$Html$map,
					$author$project$Main$DashboardPageMsg,
					A2(
						loadingView,
						function (data) {
							return A3($author$project$Components$DashboardPage$view, tz, data, page);
						},
						pageData));
			case 'DocumentsViewerPopoutPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$DocumentsViewerPopoutPageMsg,
					A2(
						loadingView,
						A2($author$project$Broker$Page$DocumentsViewerPopout$view, tz, page),
						pageData));
			case 'EmailMessageSearchPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$EmailMessageSearchPageMsg,
					topLevel ? A4($author$project$Components$EmailMessageSearchPage$viewV3Reskin, containerHeight, tz, page, pageData) : A2(
						loadingView,
						A2($author$project$Components$EmailMessageSearchPage$view, tz, page),
						pageData));
			case 'HelpPageData':
				var pageData = pd.a;
				return A2(
					loadingView,
					$author$project$Components$HelpPage$view(topLevel),
					pageData);
			case 'NonInvoiceConfirmPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$NonInvoiceConfirmPageMsg,
					A2(
						loadingView,
						$author$project$Components$NonInvoiceConfirmPage$view(page),
						pageData));
			case 'OktaLoginPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$OktaLoginPageMsg,
					A2(
						loadingView,
						$author$project$Components$OktaLoginPage$view(page),
						pageData));
			case 'SettingsCarrierPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsCarrierPageMsg,
					A2(
						loadingView,
						A2($author$project$Components$SettingsPage$CarrierLayout$view, settings, page),
						pageData));
			case 'SettingsCarriersPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsCarriersPageMsg,
					A2(
						loadingView,
						A3($author$project$Components$SettingsPage$CarriersLayout$view, settings, tz, page),
						pageData));
			case 'SettingsCustomerPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsCustomerPageMsg,
					A2(
						loadingView,
						A2($author$project$Components$SettingsPage$CustomerLayout$view, settings, page),
						pageData));
			case 'SettingsCustomersPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsCustomersPageMsg,
					A2(
						loadingView,
						A2($author$project$Components$SettingsPage$CustomersLayout$view, settings, page),
						pageData));
			case 'SettingsDebtorPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsDebtorPageMsg,
					A2(
						loadingView,
						A3($author$project$Components$SettingsPage$DebtorLayout$view, settings, tz, page),
						pageData));
			case 'SettingsPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsPageMsg,
					A2(
						loadingView,
						A3($author$project$Components$SettingsPage$view, settings, tz, page),
						pageData));
			case 'SettingsReferenceFieldsPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsReferenceFieldsPageMsg,
					A2(
						loadingView,
						$author$project$Components$SettingsPage$ReferenceFieldsLayout$view(page),
						pageData));
			case 'SettingsReportsPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsReportsPageMsg,
					A2(
						loadingView,
						A2($author$project$Components$SettingsPage$ReportsLayout$view, settings, page),
						pageData));
			case 'SettingsRulesPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsRulesPageMsg,
					A2(
						loadingView,
						A2($author$project$Components$SettingsPage$RulesLayout$view, settings, page),
						pageData));
			case 'SettingsUserPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsUserPageMsg,
					A2(
						loadingView,
						A2($author$project$Components$SettingsPage$UserLayout$view, settings, page),
						pageData));
			case 'SettingsUsersPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsUsersPageMsg,
					A2(
						loadingView,
						A2($author$project$Components$SettingsPage$UsersLayout$view, settings, page),
						pageData));
			case 'SettingsVerificationsPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SettingsVerificationsPageMsg,
					A2(
						loadingView,
						A2($author$project$Components$SettingsPage$VerificationsLayout$view, settings, page),
						pageData));
			case 'TermsPageData':
				var page = pd.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$TermsPageMsg,
					A2(
						$author$project$Components$TermsPage$page.view,
						$author$project$Forward$Remote$Loaded(_Utils_Tuple0),
						page));
			case 'VerificationBatchPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$VerificationBatchPageMsg,
					A2($author$project$Factoring$Page$VerificationBatch$view, pageData, page));
			case 'LtlReconcileInvoicePageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$LtlReconcileInvoicePageMsg,
					A2(
						loadingView,
						$author$project$Components$LtlReconcileInvoicePage$view(page),
						pageData));
			case 'CarrierInvoiceAuditPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$CarrierInvoiceAuditPageMsg,
					A3($author$project$Components$CarrierInvoiceAuditPage$view, tz, pageData, page));
			case 'FactorInvoiceAuditPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$FactorInvoiceAuditPageMsg,
					A3($author$project$Components$FactorInvoiceAuditPage$view, tz, pageData, page));
			case 'FactorInvoiceAuditBatchGroupingPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					A3($author$project$Components$FactorInvoiceAuditBatchGroupingPage$view, tz, pageData, page));
			case 'FactorInvoiceAuditBatchPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$FactorInvoiceAuditBatchPageMsg,
					A3($author$project$Components$FactorInvoiceAuditBatchPage$view, tz, pageData, page));
			case 'ForwardingHasMovedPageData':
				return A2(
					$author$project$Components$ForwardingHasMovedPage$page.view,
					$author$project$Forward$Remote$Loaded(_Utils_Tuple0),
					_Utils_Tuple0);
			case 'MyClientsOverviewPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$MyClientsOverviewPageMsg,
					A2($author$project$Components$MyClients$OverviewPage$page.view, pageData, page));
			case 'NoaManagementToSendPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$NoaManagementToSendPageMsg,
					A2($author$project$Components$NoaManagement$ToSendPage$page.view, pageData, page));
			case 'DebtorChangesPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$DebtorChangesPageMsg,
					A2($author$project$Components$DebtorChanges$IndexPage$page.view, pageData, page));
			case 'DebtorChangesTemplatePageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$DebtorChangesTemplatePageMsg,
					A2($author$project$Components$DebtorChanges$TemplatePage$page.view, pageData, page));
			case 'NoaManagementSentPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$NoaManagementSentPageMsg,
					A2($author$project$Components$NoaManagement$SentPage$page.view, pageData, page));
			case 'NoaManagementSkippedPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$NoaManagementSkippedPageMsg,
					A2($author$project$Components$NoaManagement$SkippedPage$page.view, pageData, page));
			case 'DocumentReviewPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$DocumentReviewPageMsg,
					A2($author$project$Components$DocumentReviewPage$view, pageData, page));
			case 'DocumentBatchReviewPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$DocumentBatchReviewPageMsg,
					A2($author$project$Components$DocumentBatchReviewPage$view, pageData, page));
			case 'DocumentGroupReviewPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$DocumentGroupReviewPageMsg,
					A2($author$project$Components$DocumentGroupReviewPage$view, pageData, page));
			case 'LtlHeldSubmissionsPageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$LtlHeldSubmissionsPageMsg,
					A3($author$project$Components$LtlHeldSubmissionsPage$view, containerHeight, pageData, page));
			case 'EmailMergePageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$EmailMergePageMsg,
					A2($author$project$Components$EmailMergePage$page.view, pageData, page));
			case 'ReadonlyFactorInvoicePageData':
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$ReadonlyFactorInvoicePageMsg,
					A3($author$project$Components$ReadonlyFactorInvoicePage$view, tz, pageData, page));
			default:
				var page = pd.a;
				var pageData = pd.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$ToBeScrapedLoadsPageMsg,
					A2($author$project$Components$ToBeScrapedLoadsPage$page.view, pageData, page));
		}
	});
var $author$project$Main$view = F2(
	function (origData, model) {
		var loadingIcon = function () {
			var _v4 = model.headerSearchRemote;
			if ((_v4.$ === 'Just') && (_v4.a.$ === 'Loading')) {
				var _v5 = _v4.a;
				return A2(
					$author$project$Ui$V3$Icon$view16,
					_List_fromArray(
						[$author$project$Ui$V3$Icon$spin]),
					$author$project$Ui$V3$Icon$loader16);
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var headerSearchResults = function () {
			var _v2 = model.headerSearchRemote;
			if ((_v2.$ === 'Just') && (_v2.a.$ === 'Loaded')) {
				var results = _v2.a.a;
				var backdropMinHeight = function () {
					var _v3 = model.headerElement;
					if (_v3.$ === 'Just') {
						var el = _v3.a;
						return $author$project$Ui$V3$Helpers$Html$px(
							$elm$core$Basics$floor(el.viewport.height - el.element.y));
					} else {
						return '100%';
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'relative'),
							A2($elm$html$Html$Attributes$style, 'z-index', '60')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'height', '100%'),
									A2($elm$html$Html$Attributes$style, 'min-height', backdropMinHeight),
									A2($elm$html$Html$Attributes$style, 'top', '0'),
									A2($elm$html$Html$Attributes$style, 'left', '0'),
									A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
									$author$project$Ui$V3$Colors$backgroundColorAttribute($author$project$Ui$V3$Colors$BackgroundNeutralScrim),
									$elm$html$Html$Events$onClick($author$project$Main$DismissSearchResults)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
									A2($elm$html$Html$Attributes$style, 'margin-top', '8px'),
									A2($elm$html$Html$Attributes$style, 'right', '8px'),
									A2($elm$html$Html$Attributes$style, 'width', '842px')
								]),
							_List_fromArray(
								[
									A2($author$project$Main$searchResultsToTable, model, results)
								]))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var headerSearch = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header_search__container'),
							$elm$html$Html$Events$onSubmit($author$project$Main$Search),
							$elm$html$Html$Events$onClick($author$project$Main$DismissSearchResults)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header_search__input'),
									$elm$html$Html$Attributes$placeholder('Load, reference, invoice, or shipment'),
									$elm$html$Html$Attributes$value(model.headerSearchTerm),
									$elm$html$Html$Events$onInput($author$project$Main$ChangeSearch),
									$elm$html$Html$Events$onFocus($author$project$Main$DismissSearchResults)
								]),
							_List_Nil),
							loadingIcon,
							A3(
							$author$project$Ui$V3$Button$view,
							{action: $author$project$Ui$V3$Button$submitForm},
							_List_Nil,
							'Search')
						]))
				]));
		var header = A2(
			$author$project$Ui$V3$Header$view,
			model.header,
			{
				accounts: A2(
					$elm$core$List$map,
					function (account) {
						return {
							isCurrent: account.isCurrent,
							name: account.name,
							onClick: $author$project$Main$SwitchUser(account.id)
						};
					},
					model.headerFlags.accounts),
				beamer: $elm$core$Maybe$Just(
					{messageCount: model.beamerMessageCount, onClick: $author$project$Main$OpenBeamer}),
				dropdownPages: $author$project$Main$headerDropdownPages(model),
				hasSettingsRole: model.headerFlags.hasSettingsRole,
				logoAction: $elm$core$Maybe$Just(
					$author$project$Main$ClickedHeaderNavLink(model.headerFlags.dashboardLinkLocation)),
				logoUrl: model.headerFlags.dashboardLinkLocation,
				middleContent: $elm$core$Maybe$Just(headerSearch),
				msgMapper: $author$project$Main$HeaderMsg,
				reskinToggle: A2(
					$elm$core$Maybe$map,
					function (isEnabled) {
						return {enabled: isEnabled, onToggle: $author$project$Main$ToggleReskinUser};
					},
					model.headerFlags.reskinUserToggle),
				rightPages: A2(
					$elm$core$List$map,
					function (page) {
						var currentPath = function () {
							var _v1 = model.location;
							if (_v1.$ === 'Just') {
								var url = _v1.a;
								return A2(
									$elm$core$String$join,
									'?',
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												$elm$core$Maybe$Just(url.path),
												url.query
											])));
							} else {
								return '';
							}
						}();
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(
								$author$project$Main$ClickedHeaderNavLink(page.url)),
							{
								isCurrent: A2(
									$elm$core$List$any,
									function (regexStr) {
										var regex = A2(
											$elm$core$Maybe$withDefault,
											$elm$regex$Regex$never,
											$elm$regex$Regex$fromString(regexStr));
										return A2($elm$regex$Regex$contains, regex, currentPath);
									},
									page.possibleLocationRegexes),
								title: page.title,
								url: page.url
							});
					},
					model.headerFlags.headerRightPages)
			});
		var data = A2($author$project$Main$overrideRemoteDataForReskin, model, origData);
		var auditV3ReskinActivator = function () {
			if (data.$ === 'Loaded') {
				var pd = data.a;
				return A2($author$project$Main$useV3ContainerStyles, model, pd) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('audit_v3_reskin__activate_container')
						]),
					_List_Nil) : $elm$html$Html$text('');
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Helpers$Html$v3ReskinContainer(
					(model.headerFlags.showNavBar && model.headerFlags.reskinVals.topLevel) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id($author$project$Main$headerId)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'position', 'relative'),
										A2($elm$html$Html$Attributes$style, 'z-index', '1000')
									]),
								_List_fromArray(
									[header])),
								headerSearchResults
							])) : $elm$html$Html$text('')),
					$author$project$Helpers$Html$v3ReskinContainer(
					A2(
						$author$project$Ui$V3$Flash$view,
						A2($elm$core$Basics$composeR, $author$project$Components$Flash$MarkForRemoval, $author$project$Main$FlashComponentMsg),
						model.flash)),
					A2(
					$elm$html$Html$map,
					$author$project$Main$PageMsg,
					A3(
						$author$project$Forward$LoadingView$viewV3Reskinnable,
						model.headerFlags.reskinVals.topLevel,
						A2($author$project$Main$viewPage, model.headerFlags.reskinVals, model),
						data)),
					auditV3ReskinActivator
				]));
	});
var $author$project$Main$main = $author$project$Forward$Component$programWithFlags(
	{dataEffects: $author$project$Main$dataEffects, init: $author$project$Main$init, loadData: $author$project$Main$loadData, needsUrl: '/api/accounts_payable/needs/', onUrlChange: $author$project$Main$OnUrlChange, subscriptions: $author$project$Main$subscriptions, update: $author$project$Main$update, view: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (mainFlags) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (initialLocation) {
					return $elm$json$Json$Decode$succeed(
						{initialLocation: initialLocation, mainFlags: mainFlags});
				},
				A2($elm$json$Json$Decode$field, 'initialLocation', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'mainFlags',
			A2(
				$elm$json$Json$Decode$andThen,
				function (useSubmissionWorkflow) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (showNavBar) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (reskinVals) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (reskinUserToggle) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (isFactor) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (headerRightPages) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (headerDropdownPages) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (hasSettingsRole) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (dashboardLinkLocation) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (accounts) {
																							return $elm$json$Json$Decode$succeed(
																								{accounts: accounts, dashboardLinkLocation: dashboardLinkLocation, hasSettingsRole: hasSettingsRole, headerDropdownPages: headerDropdownPages, headerRightPages: headerRightPages, isFactor: isFactor, reskinUserToggle: reskinUserToggle, reskinVals: reskinVals, showNavBar: showNavBar, useSubmissionWorkflow: useSubmissionWorkflow});
																						},
																						A2(
																							$elm$json$Json$Decode$field,
																							'accounts',
																							$elm$json$Json$Decode$list(
																								A2(
																									$elm$json$Json$Decode$andThen,
																									function (name) {
																										return A2(
																											$elm$json$Json$Decode$andThen,
																											function (isCurrent) {
																												return A2(
																													$elm$json$Json$Decode$andThen,
																													function (id) {
																														return $elm$json$Json$Decode$succeed(
																															{id: id, isCurrent: isCurrent, name: name});
																													},
																													A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int));
																											},
																											A2($elm$json$Json$Decode$field, 'isCurrent', $elm$json$Json$Decode$bool));
																									},
																									A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)))));
																				},
																				A2($elm$json$Json$Decode$field, 'dashboardLinkLocation', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'hasSettingsRole', $elm$json$Json$Decode$bool));
																},
																A2(
																	$elm$json$Json$Decode$field,
																	'headerDropdownPages',
																	A2(
																		$elm$json$Json$Decode$andThen,
																		function (receivables) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (payables) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (noaManagement) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (ltlDocRetrieval) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (insights) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (customerRep) {
																													return $elm$json$Json$Decode$succeed(
																														{customerRep: customerRep, insights: insights, ltlDocRetrieval: ltlDocRetrieval, noaManagement: noaManagement, payables: payables, receivables: receivables});
																												},
																												A2($elm$json$Json$Decode$field, 'customerRep', $elm$json$Json$Decode$bool));
																										},
																										A2($elm$json$Json$Decode$field, 'insights', $elm$json$Json$Decode$bool));
																								},
																								A2($elm$json$Json$Decode$field, 'ltlDocRetrieval', $elm$json$Json$Decode$bool));
																						},
																						A2($elm$json$Json$Decode$field, 'noaManagement', $elm$json$Json$Decode$bool));
																				},
																				A2($elm$json$Json$Decode$field, 'payables', $elm$json$Json$Decode$bool));
																		},
																		A2($elm$json$Json$Decode$field, 'receivables', $elm$json$Json$Decode$bool))));
														},
														A2(
															$elm$json$Json$Decode$field,
															'headerRightPages',
															$elm$json$Json$Decode$list(
																A2(
																	$elm$json$Json$Decode$andThen,
																	function (url) {
																		return A2(
																			$elm$json$Json$Decode$andThen,
																			function (title) {
																				return A2(
																					$elm$json$Json$Decode$andThen,
																					function (possibleLocationRegexes) {
																						return $elm$json$Json$Decode$succeed(
																							{possibleLocationRegexes: possibleLocationRegexes, title: title, url: url});
																					},
																					A2(
																						$elm$json$Json$Decode$field,
																						'possibleLocationRegexes',
																						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
																			},
																			A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string));
																	},
																	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string)))));
												},
												A2($elm$json$Json$Decode$field, 'isFactor', $elm$json$Json$Decode$bool));
										},
										A2(
											$elm$json$Json$Decode$field,
											'reskinUserToggle',
											$elm$json$Json$Decode$oneOf(
												_List_fromArray(
													[
														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)
													]))));
								},
								A2(
									$elm$json$Json$Decode$field,
									'reskinVals',
									A2(
										$elm$json$Json$Decode$andThen,
										function (topLevel) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (settings) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (queues) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (indexAudit) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (everything) {
																			return $elm$json$Json$Decode$succeed(
																				{everything: everything, indexAudit: indexAudit, queues: queues, settings: settings, topLevel: topLevel});
																		},
																		A2($elm$json$Json$Decode$field, 'everything', $elm$json$Json$Decode$bool));
																},
																A2($elm$json$Json$Decode$field, 'indexAudit', $elm$json$Json$Decode$bool));
														},
														A2($elm$json$Json$Decode$field, 'queues', $elm$json$Json$Decode$bool));
												},
												A2($elm$json$Json$Decode$field, 'settings', $elm$json$Json$Decode$bool));
										},
										A2($elm$json$Json$Decode$field, 'topLevel', $elm$json$Json$Decode$bool))));
						},
						A2($elm$json$Json$Decode$field, 'showNavBar', $elm$json$Json$Decode$bool));
				},
				A2($elm$json$Json$Decode$field, 'useSubmissionWorkflow', $elm$json$Json$Decode$bool)))))(0)}});}(this));